var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var mapboxGl = { exports: {} };
(function(module, exports) {
  (function(global2, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    var shared, worker, mapboxgl2;
    function define(_, chunk) {
      if (!shared) {
        shared = chunk;
      } else if (!worker) {
        worker = chunk;
      } else {
        var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";
        var sharedChunk = {};
        shared(sharedChunk);
        mapboxgl2 = chunk(sharedChunk);
        if (typeof window !== "undefined" && window && window.URL && window.URL.createObjectURL) {
          mapboxgl2.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], { type: "text/javascript" }));
        }
      }
    }
    define(["exports"], function(t3) {
      function e2(t4) {
        return t4 && t4.__esModule && Object.prototype.hasOwnProperty.call(t4, "default") ? t4.default : t4;
      }
      var r2, n2 = {}, i2 = {};
      function a3() {
        if (r2) return i2;
        r2 = 1, Object.defineProperty(i2, "__esModule", { value: true }), i2.setMatrixArrayType = function(t5) {
          i2.ARRAY_TYPE = e3 = t5;
        }, i2.toRadian = function(t5) {
          return t5 * a4;
        }, i2.equals = function(e4, r3) {
          return Math.abs(e4 - r3) <= t4 * Math.max(1, Math.abs(e4), Math.abs(r3));
        }, i2.RANDOM = i2.ARRAY_TYPE = i2.EPSILON = void 0;
        var t4 = 1e-6;
        i2.EPSILON = t4;
        var e3 = "undefined" != typeof Float32Array ? Float32Array : Array;
        i2.ARRAY_TYPE = e3;
        var n3 = Math.random;
        i2.RANDOM = n3;
        var a4 = Math.PI / 180;
        return Math.hypot || (Math.hypot = function() {
          for (var t5 = 0, e4 = arguments.length; e4--; ) t5 += arguments[e4] * arguments[e4];
          return Math.sqrt(t5);
        }), i2;
      }
      var s2, o2 = {};
      function l2() {
        if (s2) return o2;
        function t4(e4) {
          return t4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t5) {
            return typeof t5;
          } : function(t5) {
            return t5 && "function" == typeof Symbol && t5.constructor === Symbol && t5 !== Symbol.prototype ? "symbol" : typeof t5;
          }, t4(e4);
        }
        s2 = 1, Object.defineProperty(o2, "__esModule", { value: true }), o2.create = function() {
          var t5 = new e3.ARRAY_TYPE(4);
          return e3.ARRAY_TYPE != Float32Array && (t5[1] = 0, t5[2] = 0), t5[0] = 1, t5[3] = 1, t5;
        }, o2.clone = function(t5) {
          var r4 = new e3.ARRAY_TYPE(4);
          return r4[0] = t5[0], r4[1] = t5[1], r4[2] = t5[2], r4[3] = t5[3], r4;
        }, o2.copy = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = e4[1], t5[2] = e4[2], t5[3] = e4[3], t5;
        }, o2.identity = function(t5) {
          return t5[0] = 1, t5[1] = 0, t5[2] = 0, t5[3] = 1, t5;
        }, o2.fromValues = function(t5, r4, n4, i4) {
          var a4 = new e3.ARRAY_TYPE(4);
          return a4[0] = t5, a4[1] = r4, a4[2] = n4, a4[3] = i4, a4;
        }, o2.set = function(t5, e4, r4, n4, i4) {
          return t5[0] = e4, t5[1] = r4, t5[2] = n4, t5[3] = i4, t5;
        }, o2.transpose = function(t5, e4) {
          if (t5 === e4) {
            var r4 = e4[1];
            t5[1] = e4[2], t5[2] = r4;
          } else t5[0] = e4[0], t5[1] = e4[2], t5[2] = e4[1], t5[3] = e4[3];
          return t5;
        }, o2.invert = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = e4[3], s3 = r4 * a4 - i4 * n4;
          return s3 ? (t5[0] = a4 * (s3 = 1 / s3), t5[1] = -n4 * s3, t5[2] = -i4 * s3, t5[3] = r4 * s3, t5) : null;
        }, o2.adjoint = function(t5, e4) {
          var r4 = e4[0];
          return t5[0] = e4[3], t5[1] = -e4[1], t5[2] = -e4[2], t5[3] = r4, t5;
        }, o2.determinant = function(t5) {
          return t5[0] * t5[3] - t5[2] * t5[1];
        }, o2.multiply = n3, o2.rotate = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s3 = e4[3], o3 = Math.sin(r4), l3 = Math.cos(r4);
          return t5[0] = n4 * l3 + a4 * o3, t5[1] = i4 * l3 + s3 * o3, t5[2] = n4 * -o3 + a4 * l3, t5[3] = i4 * -o3 + s3 * l3, t5;
        }, o2.scale = function(t5, e4, r4) {
          var n4 = e4[1], i4 = e4[2], a4 = e4[3], s3 = r4[0], o3 = r4[1];
          return t5[0] = e4[0] * s3, t5[1] = n4 * s3, t5[2] = i4 * o3, t5[3] = a4 * o3, t5;
        }, o2.fromRotation = function(t5, e4) {
          var r4 = Math.sin(e4), n4 = Math.cos(e4);
          return t5[0] = n4, t5[1] = r4, t5[2] = -r4, t5[3] = n4, t5;
        }, o2.fromScaling = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = 0, t5[2] = 0, t5[3] = e4[1], t5;
        }, o2.str = function(t5) {
          return "mat2(" + t5[0] + ", " + t5[1] + ", " + t5[2] + ", " + t5[3] + ")";
        }, o2.frob = function(t5) {
          return Math.hypot(t5[0], t5[1], t5[2], t5[3]);
        }, o2.LDU = function(t5, e4, r4, n4) {
          return t5[2] = n4[2] / n4[0], r4[0] = n4[0], r4[1] = n4[1], r4[3] = n4[3] - t5[2] * r4[1], [t5, e4, r4];
        }, o2.add = function(t5, e4, r4) {
          return t5[0] = e4[0] + r4[0], t5[1] = e4[1] + r4[1], t5[2] = e4[2] + r4[2], t5[3] = e4[3] + r4[3], t5;
        }, o2.subtract = i3, o2.exactEquals = function(t5, e4) {
          return t5[0] === e4[0] && t5[1] === e4[1] && t5[2] === e4[2] && t5[3] === e4[3];
        }, o2.equals = function(t5, r4) {
          var n4 = t5[0], i4 = t5[1], a4 = t5[2], s3 = t5[3], o3 = r4[0], l3 = r4[1], u4 = r4[2], c3 = r4[3];
          return Math.abs(n4 - o3) <= e3.EPSILON * Math.max(1, Math.abs(n4), Math.abs(o3)) && Math.abs(i4 - l3) <= e3.EPSILON * Math.max(1, Math.abs(i4), Math.abs(l3)) && Math.abs(a4 - u4) <= e3.EPSILON * Math.max(1, Math.abs(a4), Math.abs(u4)) && Math.abs(s3 - c3) <= e3.EPSILON * Math.max(1, Math.abs(s3), Math.abs(c3));
        }, o2.multiplyScalar = function(t5, e4, r4) {
          return t5[0] = e4[0] * r4, t5[1] = e4[1] * r4, t5[2] = e4[2] * r4, t5[3] = e4[3] * r4, t5;
        }, o2.multiplyScalarAndAdd = function(t5, e4, r4, n4) {
          return t5[0] = e4[0] + r4[0] * n4, t5[1] = e4[1] + r4[1] * n4, t5[2] = e4[2] + r4[2] * n4, t5[3] = e4[3] + r4[3] * n4, t5;
        }, o2.sub = o2.mul = void 0;
        var e3 = function(e4, n4) {
          if (e4 && e4.__esModule) return e4;
          if (null === e4 || "object" !== t4(e4) && "function" != typeof e4) return { default: e4 };
          var i4 = r3(void 0);
          if (i4 && i4.has(e4)) return i4.get(e4);
          var a4 = {}, s3 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var o3 in e4) if ("default" !== o3 && Object.prototype.hasOwnProperty.call(e4, o3)) {
            var l3 = s3 ? Object.getOwnPropertyDescriptor(e4, o3) : null;
            l3 && (l3.get || l3.set) ? Object.defineProperty(a4, o3, l3) : a4[o3] = e4[o3];
          }
          return a4.default = e4, i4 && i4.set(e4, a4), a4;
        }(a3());
        function r3(t5) {
          if ("function" != typeof WeakMap) return null;
          var e4 = /* @__PURE__ */ new WeakMap(), n4 = /* @__PURE__ */ new WeakMap();
          return (r3 = function(t6) {
            return t6 ? n4 : e4;
          })(t5);
        }
        function n3(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s3 = e4[3], o3 = r4[0], l3 = r4[1], u4 = r4[2], c3 = r4[3];
          return t5[0] = n4 * o3 + a4 * l3, t5[1] = i4 * o3 + s3 * l3, t5[2] = n4 * u4 + a4 * c3, t5[3] = i4 * u4 + s3 * c3, t5;
        }
        function i3(t5, e4, r4) {
          return t5[0] = e4[0] - r4[0], t5[1] = e4[1] - r4[1], t5[2] = e4[2] - r4[2], t5[3] = e4[3] - r4[3], t5;
        }
        return o2.mul = n3, o2.sub = i3, o2;
      }
      var u3, c2 = {};
      function h2() {
        if (u3) return c2;
        function t4(e4) {
          return t4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t5) {
            return typeof t5;
          } : function(t5) {
            return t5 && "function" == typeof Symbol && t5.constructor === Symbol && t5 !== Symbol.prototype ? "symbol" : typeof t5;
          }, t4(e4);
        }
        u3 = 1, Object.defineProperty(c2, "__esModule", { value: true }), c2.create = function() {
          var t5 = new e3.ARRAY_TYPE(6);
          return e3.ARRAY_TYPE != Float32Array && (t5[1] = 0, t5[2] = 0, t5[4] = 0, t5[5] = 0), t5[0] = 1, t5[3] = 1, t5;
        }, c2.clone = function(t5) {
          var r4 = new e3.ARRAY_TYPE(6);
          return r4[0] = t5[0], r4[1] = t5[1], r4[2] = t5[2], r4[3] = t5[3], r4[4] = t5[4], r4[5] = t5[5], r4;
        }, c2.copy = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = e4[1], t5[2] = e4[2], t5[3] = e4[3], t5[4] = e4[4], t5[5] = e4[5], t5;
        }, c2.identity = function(t5) {
          return t5[0] = 1, t5[1] = 0, t5[2] = 0, t5[3] = 1, t5[4] = 0, t5[5] = 0, t5;
        }, c2.fromValues = function(t5, r4, n4, i4, a4, s3) {
          var o3 = new e3.ARRAY_TYPE(6);
          return o3[0] = t5, o3[1] = r4, o3[2] = n4, o3[3] = i4, o3[4] = a4, o3[5] = s3, o3;
        }, c2.set = function(t5, e4, r4, n4, i4, a4, s3) {
          return t5[0] = e4, t5[1] = r4, t5[2] = n4, t5[3] = i4, t5[4] = a4, t5[5] = s3, t5;
        }, c2.invert = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = e4[3], s3 = e4[4], o3 = e4[5], l3 = r4 * a4 - n4 * i4;
          return l3 ? (t5[0] = a4 * (l3 = 1 / l3), t5[1] = -n4 * l3, t5[2] = -i4 * l3, t5[3] = r4 * l3, t5[4] = (i4 * o3 - a4 * s3) * l3, t5[5] = (n4 * s3 - r4 * o3) * l3, t5) : null;
        }, c2.determinant = function(t5) {
          return t5[0] * t5[3] - t5[1] * t5[2];
        }, c2.multiply = n3, c2.rotate = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s3 = e4[3], o3 = e4[4], l3 = e4[5], u4 = Math.sin(r4), c3 = Math.cos(r4);
          return t5[0] = n4 * c3 + a4 * u4, t5[1] = i4 * c3 + s3 * u4, t5[2] = n4 * -u4 + a4 * c3, t5[3] = i4 * -u4 + s3 * c3, t5[4] = o3, t5[5] = l3, t5;
        }, c2.scale = function(t5, e4, r4) {
          var n4 = e4[1], i4 = e4[2], a4 = e4[3], s3 = e4[4], o3 = e4[5], l3 = r4[0], u4 = r4[1];
          return t5[0] = e4[0] * l3, t5[1] = n4 * l3, t5[2] = i4 * u4, t5[3] = a4 * u4, t5[4] = s3, t5[5] = o3, t5;
        }, c2.translate = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s3 = e4[3], o3 = e4[4], l3 = e4[5], u4 = r4[0], c3 = r4[1];
          return t5[0] = n4, t5[1] = i4, t5[2] = a4, t5[3] = s3, t5[4] = n4 * u4 + a4 * c3 + o3, t5[5] = i4 * u4 + s3 * c3 + l3, t5;
        }, c2.fromRotation = function(t5, e4) {
          var r4 = Math.sin(e4), n4 = Math.cos(e4);
          return t5[0] = n4, t5[1] = r4, t5[2] = -r4, t5[3] = n4, t5[4] = 0, t5[5] = 0, t5;
        }, c2.fromScaling = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = 0, t5[2] = 0, t5[3] = e4[1], t5[4] = 0, t5[5] = 0, t5;
        }, c2.fromTranslation = function(t5, e4) {
          return t5[0] = 1, t5[1] = 0, t5[2] = 0, t5[3] = 1, t5[4] = e4[0], t5[5] = e4[1], t5;
        }, c2.str = function(t5) {
          return "mat2d(" + t5[0] + ", " + t5[1] + ", " + t5[2] + ", " + t5[3] + ", " + t5[4] + ", " + t5[5] + ")";
        }, c2.frob = function(t5) {
          return Math.hypot(t5[0], t5[1], t5[2], t5[3], t5[4], t5[5], 1);
        }, c2.add = function(t5, e4, r4) {
          return t5[0] = e4[0] + r4[0], t5[1] = e4[1] + r4[1], t5[2] = e4[2] + r4[2], t5[3] = e4[3] + r4[3], t5[4] = e4[4] + r4[4], t5[5] = e4[5] + r4[5], t5;
        }, c2.subtract = i3, c2.multiplyScalar = function(t5, e4, r4) {
          return t5[0] = e4[0] * r4, t5[1] = e4[1] * r4, t5[2] = e4[2] * r4, t5[3] = e4[3] * r4, t5[4] = e4[4] * r4, t5[5] = e4[5] * r4, t5;
        }, c2.multiplyScalarAndAdd = function(t5, e4, r4, n4) {
          return t5[0] = e4[0] + r4[0] * n4, t5[1] = e4[1] + r4[1] * n4, t5[2] = e4[2] + r4[2] * n4, t5[3] = e4[3] + r4[3] * n4, t5[4] = e4[4] + r4[4] * n4, t5[5] = e4[5] + r4[5] * n4, t5;
        }, c2.exactEquals = function(t5, e4) {
          return t5[0] === e4[0] && t5[1] === e4[1] && t5[2] === e4[2] && t5[3] === e4[3] && t5[4] === e4[4] && t5[5] === e4[5];
        }, c2.equals = function(t5, r4) {
          var n4 = t5[0], i4 = t5[1], a4 = t5[2], s3 = t5[3], o3 = t5[4], l3 = t5[5], u4 = r4[0], c3 = r4[1], h3 = r4[2], p3 = r4[3], f3 = r4[4], d3 = r4[5];
          return Math.abs(n4 - u4) <= e3.EPSILON * Math.max(1, Math.abs(n4), Math.abs(u4)) && Math.abs(i4 - c3) <= e3.EPSILON * Math.max(1, Math.abs(i4), Math.abs(c3)) && Math.abs(a4 - h3) <= e3.EPSILON * Math.max(1, Math.abs(a4), Math.abs(h3)) && Math.abs(s3 - p3) <= e3.EPSILON * Math.max(1, Math.abs(s3), Math.abs(p3)) && Math.abs(o3 - f3) <= e3.EPSILON * Math.max(1, Math.abs(o3), Math.abs(f3)) && Math.abs(l3 - d3) <= e3.EPSILON * Math.max(1, Math.abs(l3), Math.abs(d3));
        }, c2.sub = c2.mul = void 0;
        var e3 = function(e4, n4) {
          if (e4 && e4.__esModule) return e4;
          if (null === e4 || "object" !== t4(e4) && "function" != typeof e4) return { default: e4 };
          var i4 = r3(void 0);
          if (i4 && i4.has(e4)) return i4.get(e4);
          var a4 = {}, s3 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var o3 in e4) if ("default" !== o3 && Object.prototype.hasOwnProperty.call(e4, o3)) {
            var l3 = s3 ? Object.getOwnPropertyDescriptor(e4, o3) : null;
            l3 && (l3.get || l3.set) ? Object.defineProperty(a4, o3, l3) : a4[o3] = e4[o3];
          }
          return a4.default = e4, i4 && i4.set(e4, a4), a4;
        }(a3());
        function r3(t5) {
          if ("function" != typeof WeakMap) return null;
          var e4 = /* @__PURE__ */ new WeakMap(), n4 = /* @__PURE__ */ new WeakMap();
          return (r3 = function(t6) {
            return t6 ? n4 : e4;
          })(t5);
        }
        function n3(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s3 = e4[3], o3 = e4[4], l3 = e4[5], u4 = r4[0], c3 = r4[1], h3 = r4[2], p3 = r4[3], f3 = r4[4], d3 = r4[5];
          return t5[0] = n4 * u4 + a4 * c3, t5[1] = i4 * u4 + s3 * c3, t5[2] = n4 * h3 + a4 * p3, t5[3] = i4 * h3 + s3 * p3, t5[4] = n4 * f3 + a4 * d3 + o3, t5[5] = i4 * f3 + s3 * d3 + l3, t5;
        }
        function i3(t5, e4, r4) {
          return t5[0] = e4[0] - r4[0], t5[1] = e4[1] - r4[1], t5[2] = e4[2] - r4[2], t5[3] = e4[3] - r4[3], t5[4] = e4[4] - r4[4], t5[5] = e4[5] - r4[5], t5;
        }
        return c2.mul = n3, c2.sub = i3, c2;
      }
      var p2, f2 = {};
      function d2() {
        if (p2) return f2;
        function t4(e4) {
          return t4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t5) {
            return typeof t5;
          } : function(t5) {
            return t5 && "function" == typeof Symbol && t5.constructor === Symbol && t5 !== Symbol.prototype ? "symbol" : typeof t5;
          }, t4(e4);
        }
        p2 = 1, Object.defineProperty(f2, "__esModule", { value: true }), f2.create = function() {
          var t5 = new e3.ARRAY_TYPE(9);
          return e3.ARRAY_TYPE != Float32Array && (t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[5] = 0, t5[6] = 0, t5[7] = 0), t5[0] = 1, t5[4] = 1, t5[8] = 1, t5;
        }, f2.fromMat4 = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = e4[1], t5[2] = e4[2], t5[3] = e4[4], t5[4] = e4[5], t5[5] = e4[6], t5[6] = e4[8], t5[7] = e4[9], t5[8] = e4[10], t5;
        }, f2.clone = function(t5) {
          var r4 = new e3.ARRAY_TYPE(9);
          return r4[0] = t5[0], r4[1] = t5[1], r4[2] = t5[2], r4[3] = t5[3], r4[4] = t5[4], r4[5] = t5[5], r4[6] = t5[6], r4[7] = t5[7], r4[8] = t5[8], r4;
        }, f2.copy = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = e4[1], t5[2] = e4[2], t5[3] = e4[3], t5[4] = e4[4], t5[5] = e4[5], t5[6] = e4[6], t5[7] = e4[7], t5[8] = e4[8], t5;
        }, f2.fromValues = function(t5, r4, n4, i4, a4, s3, o3, l3, u4) {
          var c3 = new e3.ARRAY_TYPE(9);
          return c3[0] = t5, c3[1] = r4, c3[2] = n4, c3[3] = i4, c3[4] = a4, c3[5] = s3, c3[6] = o3, c3[7] = l3, c3[8] = u4, c3;
        }, f2.set = function(t5, e4, r4, n4, i4, a4, s3, o3, l3, u4) {
          return t5[0] = e4, t5[1] = r4, t5[2] = n4, t5[3] = i4, t5[4] = a4, t5[5] = s3, t5[6] = o3, t5[7] = l3, t5[8] = u4, t5;
        }, f2.identity = function(t5) {
          return t5[0] = 1, t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = 1, t5[5] = 0, t5[6] = 0, t5[7] = 0, t5[8] = 1, t5;
        }, f2.transpose = function(t5, e4) {
          if (t5 === e4) {
            var r4 = e4[1], n4 = e4[2], i4 = e4[5];
            t5[1] = e4[3], t5[2] = e4[6], t5[3] = r4, t5[5] = e4[7], t5[6] = n4, t5[7] = i4;
          } else t5[0] = e4[0], t5[1] = e4[3], t5[2] = e4[6], t5[3] = e4[1], t5[4] = e4[4], t5[5] = e4[7], t5[6] = e4[2], t5[7] = e4[5], t5[8] = e4[8];
          return t5;
        }, f2.invert = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = e4[3], s3 = e4[4], o3 = e4[5], l3 = e4[6], u4 = e4[7], c3 = e4[8], h3 = c3 * s3 - o3 * u4, p3 = -c3 * a4 + o3 * l3, f3 = u4 * a4 - s3 * l3, d3 = r4 * h3 + n4 * p3 + i4 * f3;
          return d3 ? (t5[0] = h3 * (d3 = 1 / d3), t5[1] = (-c3 * n4 + i4 * u4) * d3, t5[2] = (o3 * n4 - i4 * s3) * d3, t5[3] = p3 * d3, t5[4] = (c3 * r4 - i4 * l3) * d3, t5[5] = (-o3 * r4 + i4 * a4) * d3, t5[6] = f3 * d3, t5[7] = (-u4 * r4 + n4 * l3) * d3, t5[8] = (s3 * r4 - n4 * a4) * d3, t5) : null;
        }, f2.adjoint = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = e4[3], s3 = e4[4], o3 = e4[5], l3 = e4[6], u4 = e4[7], c3 = e4[8];
          return t5[0] = s3 * c3 - o3 * u4, t5[1] = i4 * u4 - n4 * c3, t5[2] = n4 * o3 - i4 * s3, t5[3] = o3 * l3 - a4 * c3, t5[4] = r4 * c3 - i4 * l3, t5[5] = i4 * a4 - r4 * o3, t5[6] = a4 * u4 - s3 * l3, t5[7] = n4 * l3 - r4 * u4, t5[8] = r4 * s3 - n4 * a4, t5;
        }, f2.determinant = function(t5) {
          var e4 = t5[3], r4 = t5[4], n4 = t5[5], i4 = t5[6], a4 = t5[7], s3 = t5[8];
          return t5[0] * (s3 * r4 - n4 * a4) + t5[1] * (-s3 * e4 + n4 * i4) + t5[2] * (a4 * e4 - r4 * i4);
        }, f2.multiply = n3, f2.translate = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s3 = e4[3], o3 = e4[4], l3 = e4[5], u4 = e4[6], c3 = e4[7], h3 = e4[8], p3 = r4[0], f3 = r4[1];
          return t5[0] = n4, t5[1] = i4, t5[2] = a4, t5[3] = s3, t5[4] = o3, t5[5] = l3, t5[6] = p3 * n4 + f3 * s3 + u4, t5[7] = p3 * i4 + f3 * o3 + c3, t5[8] = p3 * a4 + f3 * l3 + h3, t5;
        }, f2.rotate = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s3 = e4[3], o3 = e4[4], l3 = e4[5], u4 = e4[6], c3 = e4[7], h3 = e4[8], p3 = Math.sin(r4), f3 = Math.cos(r4);
          return t5[0] = f3 * n4 + p3 * s3, t5[1] = f3 * i4 + p3 * o3, t5[2] = f3 * a4 + p3 * l3, t5[3] = f3 * s3 - p3 * n4, t5[4] = f3 * o3 - p3 * i4, t5[5] = f3 * l3 - p3 * a4, t5[6] = u4, t5[7] = c3, t5[8] = h3, t5;
        }, f2.scale = function(t5, e4, r4) {
          var n4 = r4[0], i4 = r4[1];
          return t5[0] = n4 * e4[0], t5[1] = n4 * e4[1], t5[2] = n4 * e4[2], t5[3] = i4 * e4[3], t5[4] = i4 * e4[4], t5[5] = i4 * e4[5], t5[6] = e4[6], t5[7] = e4[7], t5[8] = e4[8], t5;
        }, f2.fromTranslation = function(t5, e4) {
          return t5[0] = 1, t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = 1, t5[5] = 0, t5[6] = e4[0], t5[7] = e4[1], t5[8] = 1, t5;
        }, f2.fromRotation = function(t5, e4) {
          var r4 = Math.sin(e4), n4 = Math.cos(e4);
          return t5[0] = n4, t5[1] = r4, t5[2] = 0, t5[3] = -r4, t5[4] = n4, t5[5] = 0, t5[6] = 0, t5[7] = 0, t5[8] = 1, t5;
        }, f2.fromScaling = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = e4[1], t5[5] = 0, t5[6] = 0, t5[7] = 0, t5[8] = 1, t5;
        }, f2.fromMat2d = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = e4[1], t5[2] = 0, t5[3] = e4[2], t5[4] = e4[3], t5[5] = 0, t5[6] = e4[4], t5[7] = e4[5], t5[8] = 1, t5;
        }, f2.fromQuat = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = e4[3], s3 = r4 + r4, o3 = n4 + n4, l3 = i4 + i4, u4 = r4 * s3, c3 = n4 * s3, h3 = n4 * o3, p3 = i4 * s3, f3 = i4 * o3, d3 = i4 * l3, m2 = a4 * s3, y2 = a4 * o3, g4 = a4 * l3;
          return t5[0] = 1 - h3 - d3, t5[3] = c3 - g4, t5[6] = p3 + y2, t5[1] = c3 + g4, t5[4] = 1 - u4 - d3, t5[7] = f3 - m2, t5[2] = p3 - y2, t5[5] = f3 + m2, t5[8] = 1 - u4 - h3, t5;
        }, f2.normalFromMat4 = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = e4[3], s3 = e4[4], o3 = e4[5], l3 = e4[6], u4 = e4[7], c3 = e4[8], h3 = e4[9], p3 = e4[10], f3 = e4[11], d3 = e4[12], m2 = e4[13], y2 = e4[14], g4 = e4[15], x2 = r4 * o3 - n4 * s3, v2 = r4 * l3 - i4 * s3, b2 = r4 * u4 - a4 * s3, w2 = n4 * l3 - i4 * o3, _2 = n4 * u4 - a4 * o3, M2 = i4 * u4 - a4 * l3, A3 = c3 * m2 - h3 * d3, S2 = c3 * y2 - p3 * d3, I3 = c3 * g4 - f3 * d3, z3 = h3 * y2 - p3 * m2, P2 = h3 * g4 - f3 * m2, k2 = p3 * g4 - f3 * y2, T3 = x2 * k2 - v2 * P2 + b2 * z3 + w2 * I3 - _2 * S2 + M2 * A3;
          return T3 ? (t5[0] = (o3 * k2 - l3 * P2 + u4 * z3) * (T3 = 1 / T3), t5[1] = (l3 * I3 - s3 * k2 - u4 * S2) * T3, t5[2] = (s3 * P2 - o3 * I3 + u4 * A3) * T3, t5[3] = (i4 * P2 - n4 * k2 - a4 * z3) * T3, t5[4] = (r4 * k2 - i4 * I3 + a4 * S2) * T3, t5[5] = (n4 * I3 - r4 * P2 - a4 * A3) * T3, t5[6] = (m2 * M2 - y2 * _2 + g4 * w2) * T3, t5[7] = (y2 * b2 - d3 * M2 - g4 * v2) * T3, t5[8] = (d3 * _2 - m2 * b2 + g4 * x2) * T3, t5) : null;
        }, f2.projection = function(t5, e4, r4) {
          return t5[0] = 2 / e4, t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = -2 / r4, t5[5] = 0, t5[6] = -1, t5[7] = 1, t5[8] = 1, t5;
        }, f2.str = function(t5) {
          return "mat3(" + t5[0] + ", " + t5[1] + ", " + t5[2] + ", " + t5[3] + ", " + t5[4] + ", " + t5[5] + ", " + t5[6] + ", " + t5[7] + ", " + t5[8] + ")";
        }, f2.frob = function(t5) {
          return Math.hypot(t5[0], t5[1], t5[2], t5[3], t5[4], t5[5], t5[6], t5[7], t5[8]);
        }, f2.add = function(t5, e4, r4) {
          return t5[0] = e4[0] + r4[0], t5[1] = e4[1] + r4[1], t5[2] = e4[2] + r4[2], t5[3] = e4[3] + r4[3], t5[4] = e4[4] + r4[4], t5[5] = e4[5] + r4[5], t5[6] = e4[6] + r4[6], t5[7] = e4[7] + r4[7], t5[8] = e4[8] + r4[8], t5;
        }, f2.subtract = i3, f2.multiplyScalar = function(t5, e4, r4) {
          return t5[0] = e4[0] * r4, t5[1] = e4[1] * r4, t5[2] = e4[2] * r4, t5[3] = e4[3] * r4, t5[4] = e4[4] * r4, t5[5] = e4[5] * r4, t5[6] = e4[6] * r4, t5[7] = e4[7] * r4, t5[8] = e4[8] * r4, t5;
        }, f2.multiplyScalarAndAdd = function(t5, e4, r4, n4) {
          return t5[0] = e4[0] + r4[0] * n4, t5[1] = e4[1] + r4[1] * n4, t5[2] = e4[2] + r4[2] * n4, t5[3] = e4[3] + r4[3] * n4, t5[4] = e4[4] + r4[4] * n4, t5[5] = e4[5] + r4[5] * n4, t5[6] = e4[6] + r4[6] * n4, t5[7] = e4[7] + r4[7] * n4, t5[8] = e4[8] + r4[8] * n4, t5;
        }, f2.exactEquals = function(t5, e4) {
          return t5[0] === e4[0] && t5[1] === e4[1] && t5[2] === e4[2] && t5[3] === e4[3] && t5[4] === e4[4] && t5[5] === e4[5] && t5[6] === e4[6] && t5[7] === e4[7] && t5[8] === e4[8];
        }, f2.equals = function(t5, r4) {
          var n4 = t5[0], i4 = t5[1], a4 = t5[2], s3 = t5[3], o3 = t5[4], l3 = t5[5], u4 = t5[6], c3 = t5[7], h3 = t5[8], p3 = r4[0], f3 = r4[1], d3 = r4[2], m2 = r4[3], y2 = r4[4], g4 = r4[5], x2 = r4[6], v2 = r4[7], b2 = r4[8];
          return Math.abs(n4 - p3) <= e3.EPSILON * Math.max(1, Math.abs(n4), Math.abs(p3)) && Math.abs(i4 - f3) <= e3.EPSILON * Math.max(1, Math.abs(i4), Math.abs(f3)) && Math.abs(a4 - d3) <= e3.EPSILON * Math.max(1, Math.abs(a4), Math.abs(d3)) && Math.abs(s3 - m2) <= e3.EPSILON * Math.max(1, Math.abs(s3), Math.abs(m2)) && Math.abs(o3 - y2) <= e3.EPSILON * Math.max(1, Math.abs(o3), Math.abs(y2)) && Math.abs(l3 - g4) <= e3.EPSILON * Math.max(1, Math.abs(l3), Math.abs(g4)) && Math.abs(u4 - x2) <= e3.EPSILON * Math.max(1, Math.abs(u4), Math.abs(x2)) && Math.abs(c3 - v2) <= e3.EPSILON * Math.max(1, Math.abs(c3), Math.abs(v2)) && Math.abs(h3 - b2) <= e3.EPSILON * Math.max(1, Math.abs(h3), Math.abs(b2));
        }, f2.sub = f2.mul = void 0;
        var e3 = function(e4, n4) {
          if (e4 && e4.__esModule) return e4;
          if (null === e4 || "object" !== t4(e4) && "function" != typeof e4) return { default: e4 };
          var i4 = r3(void 0);
          if (i4 && i4.has(e4)) return i4.get(e4);
          var a4 = {}, s3 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var o3 in e4) if ("default" !== o3 && Object.prototype.hasOwnProperty.call(e4, o3)) {
            var l3 = s3 ? Object.getOwnPropertyDescriptor(e4, o3) : null;
            l3 && (l3.get || l3.set) ? Object.defineProperty(a4, o3, l3) : a4[o3] = e4[o3];
          }
          return a4.default = e4, i4 && i4.set(e4, a4), a4;
        }(a3());
        function r3(t5) {
          if ("function" != typeof WeakMap) return null;
          var e4 = /* @__PURE__ */ new WeakMap(), n4 = /* @__PURE__ */ new WeakMap();
          return (r3 = function(t6) {
            return t6 ? n4 : e4;
          })(t5);
        }
        function n3(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s3 = e4[3], o3 = e4[4], l3 = e4[5], u4 = e4[6], c3 = e4[7], h3 = e4[8], p3 = r4[0], f3 = r4[1], d3 = r4[2], m2 = r4[3], y2 = r4[4], g4 = r4[5], x2 = r4[6], v2 = r4[7], b2 = r4[8];
          return t5[0] = p3 * n4 + f3 * s3 + d3 * u4, t5[1] = p3 * i4 + f3 * o3 + d3 * c3, t5[2] = p3 * a4 + f3 * l3 + d3 * h3, t5[3] = m2 * n4 + y2 * s3 + g4 * u4, t5[4] = m2 * i4 + y2 * o3 + g4 * c3, t5[5] = m2 * a4 + y2 * l3 + g4 * h3, t5[6] = x2 * n4 + v2 * s3 + b2 * u4, t5[7] = x2 * i4 + v2 * o3 + b2 * c3, t5[8] = x2 * a4 + v2 * l3 + b2 * h3, t5;
        }
        function i3(t5, e4, r4) {
          return t5[0] = e4[0] - r4[0], t5[1] = e4[1] - r4[1], t5[2] = e4[2] - r4[2], t5[3] = e4[3] - r4[3], t5[4] = e4[4] - r4[4], t5[5] = e4[5] - r4[5], t5[6] = e4[6] - r4[6], t5[7] = e4[7] - r4[7], t5[8] = e4[8] - r4[8], t5;
        }
        return f2.mul = n3, f2.sub = i3, f2;
      }
      var m, y = {};
      function g3() {
        if (m) return y;
        function t4(e4) {
          return t4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t5) {
            return typeof t5;
          } : function(t5) {
            return t5 && "function" == typeof Symbol && t5.constructor === Symbol && t5 !== Symbol.prototype ? "symbol" : typeof t5;
          }, t4(e4);
        }
        m = 1, Object.defineProperty(y, "__esModule", { value: true }), y.create = function() {
          var t5 = new e3.ARRAY_TYPE(16);
          return e3.ARRAY_TYPE != Float32Array && (t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = 0, t5[6] = 0, t5[7] = 0, t5[8] = 0, t5[9] = 0, t5[11] = 0, t5[12] = 0, t5[13] = 0, t5[14] = 0), t5[0] = 1, t5[5] = 1, t5[10] = 1, t5[15] = 1, t5;
        }, y.clone = function(t5) {
          var r4 = new e3.ARRAY_TYPE(16);
          return r4[0] = t5[0], r4[1] = t5[1], r4[2] = t5[2], r4[3] = t5[3], r4[4] = t5[4], r4[5] = t5[5], r4[6] = t5[6], r4[7] = t5[7], r4[8] = t5[8], r4[9] = t5[9], r4[10] = t5[10], r4[11] = t5[11], r4[12] = t5[12], r4[13] = t5[13], r4[14] = t5[14], r4[15] = t5[15], r4;
        }, y.copy = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = e4[1], t5[2] = e4[2], t5[3] = e4[3], t5[4] = e4[4], t5[5] = e4[5], t5[6] = e4[6], t5[7] = e4[7], t5[8] = e4[8], t5[9] = e4[9], t5[10] = e4[10], t5[11] = e4[11], t5[12] = e4[12], t5[13] = e4[13], t5[14] = e4[14], t5[15] = e4[15], t5;
        }, y.fromValues = function(t5, r4, n4, i4, a4, s4, o4, l4, u5, c4, h3, p3, f3, d3, m2, y2) {
          var g4 = new e3.ARRAY_TYPE(16);
          return g4[0] = t5, g4[1] = r4, g4[2] = n4, g4[3] = i4, g4[4] = a4, g4[5] = s4, g4[6] = o4, g4[7] = l4, g4[8] = u5, g4[9] = c4, g4[10] = h3, g4[11] = p3, g4[12] = f3, g4[13] = d3, g4[14] = m2, g4[15] = y2, g4;
        }, y.set = function(t5, e4, r4, n4, i4, a4, s4, o4, l4, u5, c4, h3, p3, f3, d3, m2, y2) {
          return t5[0] = e4, t5[1] = r4, t5[2] = n4, t5[3] = i4, t5[4] = a4, t5[5] = s4, t5[6] = o4, t5[7] = l4, t5[8] = u5, t5[9] = c4, t5[10] = h3, t5[11] = p3, t5[12] = f3, t5[13] = d3, t5[14] = m2, t5[15] = y2, t5;
        }, y.identity = n3, y.transpose = function(t5, e4) {
          if (t5 === e4) {
            var r4 = e4[1], n4 = e4[2], i4 = e4[3], a4 = e4[6], s4 = e4[7], o4 = e4[11];
            t5[1] = e4[4], t5[2] = e4[8], t5[3] = e4[12], t5[4] = r4, t5[6] = e4[9], t5[7] = e4[13], t5[8] = n4, t5[9] = a4, t5[11] = e4[14], t5[12] = i4, t5[13] = s4, t5[14] = o4;
          } else t5[0] = e4[0], t5[1] = e4[4], t5[2] = e4[8], t5[3] = e4[12], t5[4] = e4[1], t5[5] = e4[5], t5[6] = e4[9], t5[7] = e4[13], t5[8] = e4[2], t5[9] = e4[6], t5[10] = e4[10], t5[11] = e4[14], t5[12] = e4[3], t5[13] = e4[7], t5[14] = e4[11], t5[15] = e4[15];
          return t5;
        }, y.invert = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = e4[3], s4 = e4[4], o4 = e4[5], l4 = e4[6], u5 = e4[7], c4 = e4[8], h3 = e4[9], p3 = e4[10], f3 = e4[11], d3 = e4[12], m2 = e4[13], y2 = e4[14], g4 = e4[15], x2 = r4 * o4 - n4 * s4, v2 = r4 * l4 - i4 * s4, b2 = r4 * u5 - a4 * s4, w2 = n4 * l4 - i4 * o4, _2 = n4 * u5 - a4 * o4, M2 = i4 * u5 - a4 * l4, A3 = c4 * m2 - h3 * d3, S2 = c4 * y2 - p3 * d3, I3 = c4 * g4 - f3 * d3, z3 = h3 * y2 - p3 * m2, P2 = h3 * g4 - f3 * m2, k2 = p3 * g4 - f3 * y2, T3 = x2 * k2 - v2 * P2 + b2 * z3 + w2 * I3 - _2 * S2 + M2 * A3;
          return T3 ? (t5[0] = (o4 * k2 - l4 * P2 + u5 * z3) * (T3 = 1 / T3), t5[1] = (i4 * P2 - n4 * k2 - a4 * z3) * T3, t5[2] = (m2 * M2 - y2 * _2 + g4 * w2) * T3, t5[3] = (p3 * _2 - h3 * M2 - f3 * w2) * T3, t5[4] = (l4 * I3 - s4 * k2 - u5 * S2) * T3, t5[5] = (r4 * k2 - i4 * I3 + a4 * S2) * T3, t5[6] = (y2 * b2 - d3 * M2 - g4 * v2) * T3, t5[7] = (c4 * M2 - p3 * b2 + f3 * v2) * T3, t5[8] = (s4 * P2 - o4 * I3 + u5 * A3) * T3, t5[9] = (n4 * I3 - r4 * P2 - a4 * A3) * T3, t5[10] = (d3 * _2 - m2 * b2 + g4 * x2) * T3, t5[11] = (h3 * b2 - c4 * _2 - f3 * x2) * T3, t5[12] = (o4 * S2 - s4 * z3 - l4 * A3) * T3, t5[13] = (r4 * z3 - n4 * S2 + i4 * A3) * T3, t5[14] = (m2 * v2 - d3 * w2 - y2 * x2) * T3, t5[15] = (c4 * w2 - h3 * v2 + p3 * x2) * T3, t5) : null;
        }, y.adjoint = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = e4[3], s4 = e4[4], o4 = e4[5], l4 = e4[6], u5 = e4[7], c4 = e4[8], h3 = e4[9], p3 = e4[10], f3 = e4[11], d3 = e4[12], m2 = e4[13], y2 = e4[14], g4 = e4[15];
          return t5[0] = o4 * (p3 * g4 - f3 * y2) - h3 * (l4 * g4 - u5 * y2) + m2 * (l4 * f3 - u5 * p3), t5[1] = -(n4 * (p3 * g4 - f3 * y2) - h3 * (i4 * g4 - a4 * y2) + m2 * (i4 * f3 - a4 * p3)), t5[2] = n4 * (l4 * g4 - u5 * y2) - o4 * (i4 * g4 - a4 * y2) + m2 * (i4 * u5 - a4 * l4), t5[3] = -(n4 * (l4 * f3 - u5 * p3) - o4 * (i4 * f3 - a4 * p3) + h3 * (i4 * u5 - a4 * l4)), t5[4] = -(s4 * (p3 * g4 - f3 * y2) - c4 * (l4 * g4 - u5 * y2) + d3 * (l4 * f3 - u5 * p3)), t5[5] = r4 * (p3 * g4 - f3 * y2) - c4 * (i4 * g4 - a4 * y2) + d3 * (i4 * f3 - a4 * p3), t5[6] = -(r4 * (l4 * g4 - u5 * y2) - s4 * (i4 * g4 - a4 * y2) + d3 * (i4 * u5 - a4 * l4)), t5[7] = r4 * (l4 * f3 - u5 * p3) - s4 * (i4 * f3 - a4 * p3) + c4 * (i4 * u5 - a4 * l4), t5[8] = s4 * (h3 * g4 - f3 * m2) - c4 * (o4 * g4 - u5 * m2) + d3 * (o4 * f3 - u5 * h3), t5[9] = -(r4 * (h3 * g4 - f3 * m2) - c4 * (n4 * g4 - a4 * m2) + d3 * (n4 * f3 - a4 * h3)), t5[10] = r4 * (o4 * g4 - u5 * m2) - s4 * (n4 * g4 - a4 * m2) + d3 * (n4 * u5 - a4 * o4), t5[11] = -(r4 * (o4 * f3 - u5 * h3) - s4 * (n4 * f3 - a4 * h3) + c4 * (n4 * u5 - a4 * o4)), t5[12] = -(s4 * (h3 * y2 - p3 * m2) - c4 * (o4 * y2 - l4 * m2) + d3 * (o4 * p3 - l4 * h3)), t5[13] = r4 * (h3 * y2 - p3 * m2) - c4 * (n4 * y2 - i4 * m2) + d3 * (n4 * p3 - i4 * h3), t5[14] = -(r4 * (o4 * y2 - l4 * m2) - s4 * (n4 * y2 - i4 * m2) + d3 * (n4 * l4 - i4 * o4)), t5[15] = r4 * (o4 * p3 - l4 * h3) - s4 * (n4 * p3 - i4 * h3) + c4 * (n4 * l4 - i4 * o4), t5;
        }, y.determinant = function(t5) {
          var e4 = t5[0], r4 = t5[1], n4 = t5[2], i4 = t5[3], a4 = t5[4], s4 = t5[5], o4 = t5[6], l4 = t5[7], u5 = t5[8], c4 = t5[9], h3 = t5[10], p3 = t5[11], f3 = t5[12], d3 = t5[13], m2 = t5[14], y2 = t5[15];
          return (e4 * s4 - r4 * a4) * (h3 * y2 - p3 * m2) - (e4 * o4 - n4 * a4) * (c4 * y2 - p3 * d3) + (e4 * l4 - i4 * a4) * (c4 * m2 - h3 * d3) + (r4 * o4 - n4 * s4) * (u5 * y2 - p3 * f3) - (r4 * l4 - i4 * s4) * (u5 * m2 - h3 * f3) + (n4 * l4 - i4 * o4) * (u5 * d3 - c4 * f3);
        }, y.multiply = i3, y.translate = function(t5, e4, r4) {
          var n4, i4, a4, s4, o4, l4, u5, c4, h3, p3, f3, d3, m2 = r4[0], y2 = r4[1], g4 = r4[2];
          return e4 === t5 ? (t5[12] = e4[0] * m2 + e4[4] * y2 + e4[8] * g4 + e4[12], t5[13] = e4[1] * m2 + e4[5] * y2 + e4[9] * g4 + e4[13], t5[14] = e4[2] * m2 + e4[6] * y2 + e4[10] * g4 + e4[14], t5[15] = e4[3] * m2 + e4[7] * y2 + e4[11] * g4 + e4[15]) : (i4 = e4[1], a4 = e4[2], s4 = e4[3], o4 = e4[4], l4 = e4[5], u5 = e4[6], c4 = e4[7], h3 = e4[8], p3 = e4[9], f3 = e4[10], d3 = e4[11], t5[0] = n4 = e4[0], t5[1] = i4, t5[2] = a4, t5[3] = s4, t5[4] = o4, t5[5] = l4, t5[6] = u5, t5[7] = c4, t5[8] = h3, t5[9] = p3, t5[10] = f3, t5[11] = d3, t5[12] = n4 * m2 + o4 * y2 + h3 * g4 + e4[12], t5[13] = i4 * m2 + l4 * y2 + p3 * g4 + e4[13], t5[14] = a4 * m2 + u5 * y2 + f3 * g4 + e4[14], t5[15] = s4 * m2 + c4 * y2 + d3 * g4 + e4[15]), t5;
        }, y.scale = function(t5, e4, r4) {
          var n4 = r4[0], i4 = r4[1], a4 = r4[2];
          return t5[0] = e4[0] * n4, t5[1] = e4[1] * n4, t5[2] = e4[2] * n4, t5[3] = e4[3] * n4, t5[4] = e4[4] * i4, t5[5] = e4[5] * i4, t5[6] = e4[6] * i4, t5[7] = e4[7] * i4, t5[8] = e4[8] * a4, t5[9] = e4[9] * a4, t5[10] = e4[10] * a4, t5[11] = e4[11] * a4, t5[12] = e4[12], t5[13] = e4[13], t5[14] = e4[14], t5[15] = e4[15], t5;
        }, y.rotate = function(t5, r4, n4, i4) {
          var a4, s4, o4, l4, u5, c4, h3, p3, f3, d3, m2, y2, g4, x2, v2, b2, w2, _2, M2, A3, S2, I3, z3, P2, k2 = i4[0], T3 = i4[1], E3 = i4[2], B4 = Math.hypot(k2, T3, E3);
          return B4 < e3.EPSILON ? null : (k2 *= B4 = 1 / B4, T3 *= B4, E3 *= B4, a4 = Math.sin(n4), s4 = Math.cos(n4), u5 = r4[1], c4 = r4[2], h3 = r4[3], f3 = r4[5], d3 = r4[6], m2 = r4[7], g4 = r4[9], x2 = r4[10], v2 = r4[11], b2 = k2 * k2 * (o4 = 1 - s4) + s4, M2 = k2 * T3 * o4 - E3 * a4, A3 = T3 * T3 * o4 + s4, S2 = E3 * T3 * o4 + k2 * a4, I3 = k2 * E3 * o4 + T3 * a4, z3 = T3 * E3 * o4 - k2 * a4, P2 = E3 * E3 * o4 + s4, t5[0] = (l4 = r4[0]) * b2 + (p3 = r4[4]) * (w2 = T3 * k2 * o4 + E3 * a4) + (y2 = r4[8]) * (_2 = E3 * k2 * o4 - T3 * a4), t5[1] = u5 * b2 + f3 * w2 + g4 * _2, t5[2] = c4 * b2 + d3 * w2 + x2 * _2, t5[3] = h3 * b2 + m2 * w2 + v2 * _2, t5[4] = l4 * M2 + p3 * A3 + y2 * S2, t5[5] = u5 * M2 + f3 * A3 + g4 * S2, t5[6] = c4 * M2 + d3 * A3 + x2 * S2, t5[7] = h3 * M2 + m2 * A3 + v2 * S2, t5[8] = l4 * I3 + p3 * z3 + y2 * P2, t5[9] = u5 * I3 + f3 * z3 + g4 * P2, t5[10] = c4 * I3 + d3 * z3 + x2 * P2, t5[11] = h3 * I3 + m2 * z3 + v2 * P2, r4 !== t5 && (t5[12] = r4[12], t5[13] = r4[13], t5[14] = r4[14], t5[15] = r4[15]), t5);
        }, y.rotateX = function(t5, e4, r4) {
          var n4 = Math.sin(r4), i4 = Math.cos(r4), a4 = e4[4], s4 = e4[5], o4 = e4[6], l4 = e4[7], u5 = e4[8], c4 = e4[9], h3 = e4[10], p3 = e4[11];
          return e4 !== t5 && (t5[0] = e4[0], t5[1] = e4[1], t5[2] = e4[2], t5[3] = e4[3], t5[12] = e4[12], t5[13] = e4[13], t5[14] = e4[14], t5[15] = e4[15]), t5[4] = a4 * i4 + u5 * n4, t5[5] = s4 * i4 + c4 * n4, t5[6] = o4 * i4 + h3 * n4, t5[7] = l4 * i4 + p3 * n4, t5[8] = u5 * i4 - a4 * n4, t5[9] = c4 * i4 - s4 * n4, t5[10] = h3 * i4 - o4 * n4, t5[11] = p3 * i4 - l4 * n4, t5;
        }, y.rotateY = function(t5, e4, r4) {
          var n4 = Math.sin(r4), i4 = Math.cos(r4), a4 = e4[0], s4 = e4[1], o4 = e4[2], l4 = e4[3], u5 = e4[8], c4 = e4[9], h3 = e4[10], p3 = e4[11];
          return e4 !== t5 && (t5[4] = e4[4], t5[5] = e4[5], t5[6] = e4[6], t5[7] = e4[7], t5[12] = e4[12], t5[13] = e4[13], t5[14] = e4[14], t5[15] = e4[15]), t5[0] = a4 * i4 - u5 * n4, t5[1] = s4 * i4 - c4 * n4, t5[2] = o4 * i4 - h3 * n4, t5[3] = l4 * i4 - p3 * n4, t5[8] = a4 * n4 + u5 * i4, t5[9] = s4 * n4 + c4 * i4, t5[10] = o4 * n4 + h3 * i4, t5[11] = l4 * n4 + p3 * i4, t5;
        }, y.rotateZ = function(t5, e4, r4) {
          var n4 = Math.sin(r4), i4 = Math.cos(r4), a4 = e4[0], s4 = e4[1], o4 = e4[2], l4 = e4[3], u5 = e4[4], c4 = e4[5], h3 = e4[6], p3 = e4[7];
          return e4 !== t5 && (t5[8] = e4[8], t5[9] = e4[9], t5[10] = e4[10], t5[11] = e4[11], t5[12] = e4[12], t5[13] = e4[13], t5[14] = e4[14], t5[15] = e4[15]), t5[0] = a4 * i4 + u5 * n4, t5[1] = s4 * i4 + c4 * n4, t5[2] = o4 * i4 + h3 * n4, t5[3] = l4 * i4 + p3 * n4, t5[4] = u5 * i4 - a4 * n4, t5[5] = c4 * i4 - s4 * n4, t5[6] = h3 * i4 - o4 * n4, t5[7] = p3 * i4 - l4 * n4, t5;
        }, y.fromTranslation = function(t5, e4) {
          return t5[0] = 1, t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = 0, t5[5] = 1, t5[6] = 0, t5[7] = 0, t5[8] = 0, t5[9] = 0, t5[10] = 1, t5[11] = 0, t5[12] = e4[0], t5[13] = e4[1], t5[14] = e4[2], t5[15] = 1, t5;
        }, y.fromScaling = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = 0, t5[5] = e4[1], t5[6] = 0, t5[7] = 0, t5[8] = 0, t5[9] = 0, t5[10] = e4[2], t5[11] = 0, t5[12] = 0, t5[13] = 0, t5[14] = 0, t5[15] = 1, t5;
        }, y.fromRotation = function(t5, r4, n4) {
          var i4, a4, s4, o4 = n4[0], l4 = n4[1], u5 = n4[2], c4 = Math.hypot(o4, l4, u5);
          return c4 < e3.EPSILON ? null : (o4 *= c4 = 1 / c4, l4 *= c4, u5 *= c4, i4 = Math.sin(r4), a4 = Math.cos(r4), t5[0] = o4 * o4 * (s4 = 1 - a4) + a4, t5[1] = l4 * o4 * s4 + u5 * i4, t5[2] = u5 * o4 * s4 - l4 * i4, t5[3] = 0, t5[4] = o4 * l4 * s4 - u5 * i4, t5[5] = l4 * l4 * s4 + a4, t5[6] = u5 * l4 * s4 + o4 * i4, t5[7] = 0, t5[8] = o4 * u5 * s4 + l4 * i4, t5[9] = l4 * u5 * s4 - o4 * i4, t5[10] = u5 * u5 * s4 + a4, t5[11] = 0, t5[12] = 0, t5[13] = 0, t5[14] = 0, t5[15] = 1, t5);
        }, y.fromXRotation = function(t5, e4) {
          var r4 = Math.sin(e4), n4 = Math.cos(e4);
          return t5[0] = 1, t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = 0, t5[5] = n4, t5[6] = r4, t5[7] = 0, t5[8] = 0, t5[9] = -r4, t5[10] = n4, t5[11] = 0, t5[12] = 0, t5[13] = 0, t5[14] = 0, t5[15] = 1, t5;
        }, y.fromYRotation = function(t5, e4) {
          var r4 = Math.sin(e4), n4 = Math.cos(e4);
          return t5[0] = n4, t5[1] = 0, t5[2] = -r4, t5[3] = 0, t5[4] = 0, t5[5] = 1, t5[6] = 0, t5[7] = 0, t5[8] = r4, t5[9] = 0, t5[10] = n4, t5[11] = 0, t5[12] = 0, t5[13] = 0, t5[14] = 0, t5[15] = 1, t5;
        }, y.fromZRotation = function(t5, e4) {
          var r4 = Math.sin(e4), n4 = Math.cos(e4);
          return t5[0] = n4, t5[1] = r4, t5[2] = 0, t5[3] = 0, t5[4] = -r4, t5[5] = n4, t5[6] = 0, t5[7] = 0, t5[8] = 0, t5[9] = 0, t5[10] = 1, t5[11] = 0, t5[12] = 0, t5[13] = 0, t5[14] = 0, t5[15] = 1, t5;
        }, y.fromRotationTranslation = s3, y.fromQuat2 = function(t5, r4) {
          var n4 = new e3.ARRAY_TYPE(3), i4 = -r4[0], a4 = -r4[1], o4 = -r4[2], l4 = r4[3], u5 = r4[4], c4 = r4[5], h3 = r4[6], p3 = r4[7], f3 = i4 * i4 + a4 * a4 + o4 * o4 + l4 * l4;
          return f3 > 0 ? (n4[0] = 2 * (u5 * l4 + p3 * i4 + c4 * o4 - h3 * a4) / f3, n4[1] = 2 * (c4 * l4 + p3 * a4 + h3 * i4 - u5 * o4) / f3, n4[2] = 2 * (h3 * l4 + p3 * o4 + u5 * a4 - c4 * i4) / f3) : (n4[0] = 2 * (u5 * l4 + p3 * i4 + c4 * o4 - h3 * a4), n4[1] = 2 * (c4 * l4 + p3 * a4 + h3 * i4 - u5 * o4), n4[2] = 2 * (h3 * l4 + p3 * o4 + u5 * a4 - c4 * i4)), s3(t5, r4, n4), t5;
        }, y.getTranslation = function(t5, e4) {
          return t5[0] = e4[12], t5[1] = e4[13], t5[2] = e4[14], t5;
        }, y.getScaling = o3, y.getRotation = function(t5, r4) {
          var n4 = new e3.ARRAY_TYPE(3);
          o3(n4, r4);
          var i4 = 1 / n4[0], a4 = 1 / n4[1], s4 = 1 / n4[2], l4 = r4[0] * i4, u5 = r4[1] * a4, c4 = r4[2] * s4, h3 = r4[4] * i4, p3 = r4[5] * a4, f3 = r4[6] * s4, d3 = r4[8] * i4, m2 = r4[9] * a4, y2 = r4[10] * s4, g4 = l4 + p3 + y2, x2 = 0;
          return g4 > 0 ? (x2 = 2 * Math.sqrt(g4 + 1), t5[3] = 0.25 * x2, t5[0] = (f3 - m2) / x2, t5[1] = (d3 - c4) / x2, t5[2] = (u5 - h3) / x2) : l4 > p3 && l4 > y2 ? (x2 = 2 * Math.sqrt(1 + l4 - p3 - y2), t5[3] = (f3 - m2) / x2, t5[0] = 0.25 * x2, t5[1] = (u5 + h3) / x2, t5[2] = (d3 + c4) / x2) : p3 > y2 ? (x2 = 2 * Math.sqrt(1 + p3 - l4 - y2), t5[3] = (d3 - c4) / x2, t5[0] = (u5 + h3) / x2, t5[1] = 0.25 * x2, t5[2] = (f3 + m2) / x2) : (x2 = 2 * Math.sqrt(1 + y2 - l4 - p3), t5[3] = (u5 - h3) / x2, t5[0] = (d3 + c4) / x2, t5[1] = (f3 + m2) / x2, t5[2] = 0.25 * x2), t5;
        }, y.fromRotationTranslationScale = function(t5, e4, r4, n4) {
          var i4 = e4[0], a4 = e4[1], s4 = e4[2], o4 = e4[3], l4 = i4 + i4, u5 = a4 + a4, c4 = s4 + s4, h3 = i4 * l4, p3 = i4 * u5, f3 = i4 * c4, d3 = a4 * u5, m2 = a4 * c4, y2 = s4 * c4, g4 = o4 * l4, x2 = o4 * u5, v2 = o4 * c4, b2 = n4[0], w2 = n4[1], _2 = n4[2];
          return t5[0] = (1 - (d3 + y2)) * b2, t5[1] = (p3 + v2) * b2, t5[2] = (f3 - x2) * b2, t5[3] = 0, t5[4] = (p3 - v2) * w2, t5[5] = (1 - (h3 + y2)) * w2, t5[6] = (m2 + g4) * w2, t5[7] = 0, t5[8] = (f3 + x2) * _2, t5[9] = (m2 - g4) * _2, t5[10] = (1 - (h3 + d3)) * _2, t5[11] = 0, t5[12] = r4[0], t5[13] = r4[1], t5[14] = r4[2], t5[15] = 1, t5;
        }, y.fromRotationTranslationScaleOrigin = function(t5, e4, r4, n4, i4) {
          var a4 = e4[0], s4 = e4[1], o4 = e4[2], l4 = e4[3], u5 = a4 + a4, c4 = s4 + s4, h3 = o4 + o4, p3 = a4 * u5, f3 = a4 * c4, d3 = a4 * h3, m2 = s4 * c4, y2 = s4 * h3, g4 = o4 * h3, x2 = l4 * u5, v2 = l4 * c4, b2 = l4 * h3, w2 = n4[0], _2 = n4[1], M2 = n4[2], A3 = i4[0], S2 = i4[1], I3 = i4[2], z3 = (1 - (m2 + g4)) * w2, P2 = (f3 + b2) * w2, k2 = (d3 - v2) * w2, T3 = (f3 - b2) * _2, E3 = (1 - (p3 + g4)) * _2, B4 = (y2 + x2) * _2, V3 = (d3 + v2) * M2, C3 = (y2 - x2) * M2, R3 = (1 - (p3 + m2)) * M2;
          return t5[0] = z3, t5[1] = P2, t5[2] = k2, t5[3] = 0, t5[4] = T3, t5[5] = E3, t5[6] = B4, t5[7] = 0, t5[8] = V3, t5[9] = C3, t5[10] = R3, t5[11] = 0, t5[12] = r4[0] + A3 - (z3 * A3 + T3 * S2 + V3 * I3), t5[13] = r4[1] + S2 - (P2 * A3 + E3 * S2 + C3 * I3), t5[14] = r4[2] + I3 - (k2 * A3 + B4 * S2 + R3 * I3), t5[15] = 1, t5;
        }, y.fromQuat = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = e4[3], s4 = r4 + r4, o4 = n4 + n4, l4 = i4 + i4, u5 = r4 * s4, c4 = n4 * s4, h3 = n4 * o4, p3 = i4 * s4, f3 = i4 * o4, d3 = i4 * l4, m2 = a4 * s4, y2 = a4 * o4, g4 = a4 * l4;
          return t5[0] = 1 - h3 - d3, t5[1] = c4 + g4, t5[2] = p3 - y2, t5[3] = 0, t5[4] = c4 - g4, t5[5] = 1 - u5 - d3, t5[6] = f3 + m2, t5[7] = 0, t5[8] = p3 + y2, t5[9] = f3 - m2, t5[10] = 1 - u5 - h3, t5[11] = 0, t5[12] = 0, t5[13] = 0, t5[14] = 0, t5[15] = 1, t5;
        }, y.frustum = function(t5, e4, r4, n4, i4, a4, s4) {
          var o4 = 1 / (r4 - e4), l4 = 1 / (i4 - n4), u5 = 1 / (a4 - s4);
          return t5[0] = 2 * a4 * o4, t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = 0, t5[5] = 2 * a4 * l4, t5[6] = 0, t5[7] = 0, t5[8] = (r4 + e4) * o4, t5[9] = (i4 + n4) * l4, t5[10] = (s4 + a4) * u5, t5[11] = -1, t5[12] = 0, t5[13] = 0, t5[14] = s4 * a4 * 2 * u5, t5[15] = 0, t5;
        }, y.perspectiveNO = l3, y.perspectiveZO = function(t5, e4, r4, n4, i4) {
          var a4, s4 = 1 / Math.tan(e4 / 2);
          return t5[0] = s4 / r4, t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = 0, t5[5] = s4, t5[6] = 0, t5[7] = 0, t5[8] = 0, t5[9] = 0, t5[11] = -1, t5[12] = 0, t5[13] = 0, t5[15] = 0, null != i4 && i4 !== 1 / 0 ? (t5[10] = i4 * (a4 = 1 / (n4 - i4)), t5[14] = i4 * n4 * a4) : (t5[10] = -1, t5[14] = -n4), t5;
        }, y.perspectiveFromFieldOfView = function(t5, e4, r4, n4) {
          var i4 = Math.tan(e4.upDegrees * Math.PI / 180), a4 = Math.tan(e4.downDegrees * Math.PI / 180), s4 = Math.tan(e4.leftDegrees * Math.PI / 180), o4 = Math.tan(e4.rightDegrees * Math.PI / 180), l4 = 2 / (s4 + o4), u5 = 2 / (i4 + a4);
          return t5[0] = l4, t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = 0, t5[5] = u5, t5[6] = 0, t5[7] = 0, t5[8] = -(s4 - o4) * l4 * 0.5, t5[9] = (i4 - a4) * u5 * 0.5, t5[10] = n4 / (r4 - n4), t5[11] = -1, t5[12] = 0, t5[13] = 0, t5[14] = n4 * r4 / (r4 - n4), t5[15] = 0, t5;
        }, y.orthoNO = u4, y.orthoZO = function(t5, e4, r4, n4, i4, a4, s4) {
          var o4 = 1 / (e4 - r4), l4 = 1 / (n4 - i4), u5 = 1 / (a4 - s4);
          return t5[0] = -2 * o4, t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = 0, t5[5] = -2 * l4, t5[6] = 0, t5[7] = 0, t5[8] = 0, t5[9] = 0, t5[10] = u5, t5[11] = 0, t5[12] = (e4 + r4) * o4, t5[13] = (i4 + n4) * l4, t5[14] = a4 * u5, t5[15] = 1, t5;
        }, y.lookAt = function(t5, r4, i4, a4) {
          var s4, o4, l4, u5, c4, h3, p3, f3, d3, m2, y2 = r4[0], g4 = r4[1], x2 = r4[2], v2 = a4[0], b2 = a4[1], w2 = a4[2], _2 = i4[0], M2 = i4[1], A3 = i4[2];
          return Math.abs(y2 - _2) < e3.EPSILON && Math.abs(g4 - M2) < e3.EPSILON && Math.abs(x2 - A3) < e3.EPSILON ? n3(t5) : (p3 = y2 - _2, f3 = g4 - M2, d3 = x2 - A3, s4 = b2 * (d3 *= m2 = 1 / Math.hypot(p3, f3, d3)) - w2 * (f3 *= m2), o4 = w2 * (p3 *= m2) - v2 * d3, l4 = v2 * f3 - b2 * p3, (m2 = Math.hypot(s4, o4, l4)) ? (s4 *= m2 = 1 / m2, o4 *= m2, l4 *= m2) : (s4 = 0, o4 = 0, l4 = 0), u5 = f3 * l4 - d3 * o4, c4 = d3 * s4 - p3 * l4, h3 = p3 * o4 - f3 * s4, (m2 = Math.hypot(u5, c4, h3)) ? (u5 *= m2 = 1 / m2, c4 *= m2, h3 *= m2) : (u5 = 0, c4 = 0, h3 = 0), t5[0] = s4, t5[1] = u5, t5[2] = p3, t5[3] = 0, t5[4] = o4, t5[5] = c4, t5[6] = f3, t5[7] = 0, t5[8] = l4, t5[9] = h3, t5[10] = d3, t5[11] = 0, t5[12] = -(s4 * y2 + o4 * g4 + l4 * x2), t5[13] = -(u5 * y2 + c4 * g4 + h3 * x2), t5[14] = -(p3 * y2 + f3 * g4 + d3 * x2), t5[15] = 1, t5);
        }, y.targetTo = function(t5, e4, r4, n4) {
          var i4 = e4[0], a4 = e4[1], s4 = e4[2], o4 = n4[0], l4 = n4[1], u5 = n4[2], c4 = i4 - r4[0], h3 = a4 - r4[1], p3 = s4 - r4[2], f3 = c4 * c4 + h3 * h3 + p3 * p3;
          f3 > 0 && (c4 *= f3 = 1 / Math.sqrt(f3), h3 *= f3, p3 *= f3);
          var d3 = l4 * p3 - u5 * h3, m2 = u5 * c4 - o4 * p3, y2 = o4 * h3 - l4 * c4;
          return (f3 = d3 * d3 + m2 * m2 + y2 * y2) > 0 && (d3 *= f3 = 1 / Math.sqrt(f3), m2 *= f3, y2 *= f3), t5[0] = d3, t5[1] = m2, t5[2] = y2, t5[3] = 0, t5[4] = h3 * y2 - p3 * m2, t5[5] = p3 * d3 - c4 * y2, t5[6] = c4 * m2 - h3 * d3, t5[7] = 0, t5[8] = c4, t5[9] = h3, t5[10] = p3, t5[11] = 0, t5[12] = i4, t5[13] = a4, t5[14] = s4, t5[15] = 1, t5;
        }, y.str = function(t5) {
          return "mat4(" + t5[0] + ", " + t5[1] + ", " + t5[2] + ", " + t5[3] + ", " + t5[4] + ", " + t5[5] + ", " + t5[6] + ", " + t5[7] + ", " + t5[8] + ", " + t5[9] + ", " + t5[10] + ", " + t5[11] + ", " + t5[12] + ", " + t5[13] + ", " + t5[14] + ", " + t5[15] + ")";
        }, y.frob = function(t5) {
          return Math.hypot(t5[0], t5[1], t5[2], t5[3], t5[4], t5[5], t5[6], t5[7], t5[8], t5[9], t5[10], t5[11], t5[12], t5[13], t5[14], t5[15]);
        }, y.add = function(t5, e4, r4) {
          return t5[0] = e4[0] + r4[0], t5[1] = e4[1] + r4[1], t5[2] = e4[2] + r4[2], t5[3] = e4[3] + r4[3], t5[4] = e4[4] + r4[4], t5[5] = e4[5] + r4[5], t5[6] = e4[6] + r4[6], t5[7] = e4[7] + r4[7], t5[8] = e4[8] + r4[8], t5[9] = e4[9] + r4[9], t5[10] = e4[10] + r4[10], t5[11] = e4[11] + r4[11], t5[12] = e4[12] + r4[12], t5[13] = e4[13] + r4[13], t5[14] = e4[14] + r4[14], t5[15] = e4[15] + r4[15], t5;
        }, y.subtract = c3, y.multiplyScalar = function(t5, e4, r4) {
          return t5[0] = e4[0] * r4, t5[1] = e4[1] * r4, t5[2] = e4[2] * r4, t5[3] = e4[3] * r4, t5[4] = e4[4] * r4, t5[5] = e4[5] * r4, t5[6] = e4[6] * r4, t5[7] = e4[7] * r4, t5[8] = e4[8] * r4, t5[9] = e4[9] * r4, t5[10] = e4[10] * r4, t5[11] = e4[11] * r4, t5[12] = e4[12] * r4, t5[13] = e4[13] * r4, t5[14] = e4[14] * r4, t5[15] = e4[15] * r4, t5;
        }, y.multiplyScalarAndAdd = function(t5, e4, r4, n4) {
          return t5[0] = e4[0] + r4[0] * n4, t5[1] = e4[1] + r4[1] * n4, t5[2] = e4[2] + r4[2] * n4, t5[3] = e4[3] + r4[3] * n4, t5[4] = e4[4] + r4[4] * n4, t5[5] = e4[5] + r4[5] * n4, t5[6] = e4[6] + r4[6] * n4, t5[7] = e4[7] + r4[7] * n4, t5[8] = e4[8] + r4[8] * n4, t5[9] = e4[9] + r4[9] * n4, t5[10] = e4[10] + r4[10] * n4, t5[11] = e4[11] + r4[11] * n4, t5[12] = e4[12] + r4[12] * n4, t5[13] = e4[13] + r4[13] * n4, t5[14] = e4[14] + r4[14] * n4, t5[15] = e4[15] + r4[15] * n4, t5;
        }, y.exactEquals = function(t5, e4) {
          return t5[0] === e4[0] && t5[1] === e4[1] && t5[2] === e4[2] && t5[3] === e4[3] && t5[4] === e4[4] && t5[5] === e4[5] && t5[6] === e4[6] && t5[7] === e4[7] && t5[8] === e4[8] && t5[9] === e4[9] && t5[10] === e4[10] && t5[11] === e4[11] && t5[12] === e4[12] && t5[13] === e4[13] && t5[14] === e4[14] && t5[15] === e4[15];
        }, y.equals = function(t5, r4) {
          var n4 = t5[0], i4 = t5[1], a4 = t5[2], s4 = t5[3], o4 = t5[4], l4 = t5[5], u5 = t5[6], c4 = t5[7], h3 = t5[8], p3 = t5[9], f3 = t5[10], d3 = t5[11], m2 = t5[12], y2 = t5[13], g4 = t5[14], x2 = t5[15], v2 = r4[0], b2 = r4[1], w2 = r4[2], _2 = r4[3], M2 = r4[4], A3 = r4[5], S2 = r4[6], I3 = r4[7], z3 = r4[8], P2 = r4[9], k2 = r4[10], T3 = r4[11], E3 = r4[12], B4 = r4[13], V3 = r4[14], C3 = r4[15];
          return Math.abs(n4 - v2) <= e3.EPSILON * Math.max(1, Math.abs(n4), Math.abs(v2)) && Math.abs(i4 - b2) <= e3.EPSILON * Math.max(1, Math.abs(i4), Math.abs(b2)) && Math.abs(a4 - w2) <= e3.EPSILON * Math.max(1, Math.abs(a4), Math.abs(w2)) && Math.abs(s4 - _2) <= e3.EPSILON * Math.max(1, Math.abs(s4), Math.abs(_2)) && Math.abs(o4 - M2) <= e3.EPSILON * Math.max(1, Math.abs(o4), Math.abs(M2)) && Math.abs(l4 - A3) <= e3.EPSILON * Math.max(1, Math.abs(l4), Math.abs(A3)) && Math.abs(u5 - S2) <= e3.EPSILON * Math.max(1, Math.abs(u5), Math.abs(S2)) && Math.abs(c4 - I3) <= e3.EPSILON * Math.max(1, Math.abs(c4), Math.abs(I3)) && Math.abs(h3 - z3) <= e3.EPSILON * Math.max(1, Math.abs(h3), Math.abs(z3)) && Math.abs(p3 - P2) <= e3.EPSILON * Math.max(1, Math.abs(p3), Math.abs(P2)) && Math.abs(f3 - k2) <= e3.EPSILON * Math.max(1, Math.abs(f3), Math.abs(k2)) && Math.abs(d3 - T3) <= e3.EPSILON * Math.max(1, Math.abs(d3), Math.abs(T3)) && Math.abs(m2 - E3) <= e3.EPSILON * Math.max(1, Math.abs(m2), Math.abs(E3)) && Math.abs(y2 - B4) <= e3.EPSILON * Math.max(1, Math.abs(y2), Math.abs(B4)) && Math.abs(g4 - V3) <= e3.EPSILON * Math.max(1, Math.abs(g4), Math.abs(V3)) && Math.abs(x2 - C3) <= e3.EPSILON * Math.max(1, Math.abs(x2), Math.abs(C3));
        }, y.sub = y.mul = y.ortho = y.perspective = void 0;
        var e3 = function(e4, n4) {
          if (e4 && e4.__esModule) return e4;
          if (null === e4 || "object" !== t4(e4) && "function" != typeof e4) return { default: e4 };
          var i4 = r3(void 0);
          if (i4 && i4.has(e4)) return i4.get(e4);
          var a4 = {}, s4 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var o4 in e4) if ("default" !== o4 && Object.prototype.hasOwnProperty.call(e4, o4)) {
            var l4 = s4 ? Object.getOwnPropertyDescriptor(e4, o4) : null;
            l4 && (l4.get || l4.set) ? Object.defineProperty(a4, o4, l4) : a4[o4] = e4[o4];
          }
          return a4.default = e4, i4 && i4.set(e4, a4), a4;
        }(a3());
        function r3(t5) {
          if ("function" != typeof WeakMap) return null;
          var e4 = /* @__PURE__ */ new WeakMap(), n4 = /* @__PURE__ */ new WeakMap();
          return (r3 = function(t6) {
            return t6 ? n4 : e4;
          })(t5);
        }
        function n3(t5) {
          return t5[0] = 1, t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = 0, t5[5] = 1, t5[6] = 0, t5[7] = 0, t5[8] = 0, t5[9] = 0, t5[10] = 1, t5[11] = 0, t5[12] = 0, t5[13] = 0, t5[14] = 0, t5[15] = 1, t5;
        }
        function i3(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s4 = e4[3], o4 = e4[4], l4 = e4[5], u5 = e4[6], c4 = e4[7], h3 = e4[8], p3 = e4[9], f3 = e4[10], d3 = e4[11], m2 = e4[12], y2 = e4[13], g4 = e4[14], x2 = e4[15], v2 = r4[0], b2 = r4[1], w2 = r4[2], _2 = r4[3];
          return t5[0] = v2 * n4 + b2 * o4 + w2 * h3 + _2 * m2, t5[1] = v2 * i4 + b2 * l4 + w2 * p3 + _2 * y2, t5[2] = v2 * a4 + b2 * u5 + w2 * f3 + _2 * g4, t5[3] = v2 * s4 + b2 * c4 + w2 * d3 + _2 * x2, t5[4] = (v2 = r4[4]) * n4 + (b2 = r4[5]) * o4 + (w2 = r4[6]) * h3 + (_2 = r4[7]) * m2, t5[5] = v2 * i4 + b2 * l4 + w2 * p3 + _2 * y2, t5[6] = v2 * a4 + b2 * u5 + w2 * f3 + _2 * g4, t5[7] = v2 * s4 + b2 * c4 + w2 * d3 + _2 * x2, t5[8] = (v2 = r4[8]) * n4 + (b2 = r4[9]) * o4 + (w2 = r4[10]) * h3 + (_2 = r4[11]) * m2, t5[9] = v2 * i4 + b2 * l4 + w2 * p3 + _2 * y2, t5[10] = v2 * a4 + b2 * u5 + w2 * f3 + _2 * g4, t5[11] = v2 * s4 + b2 * c4 + w2 * d3 + _2 * x2, t5[12] = (v2 = r4[12]) * n4 + (b2 = r4[13]) * o4 + (w2 = r4[14]) * h3 + (_2 = r4[15]) * m2, t5[13] = v2 * i4 + b2 * l4 + w2 * p3 + _2 * y2, t5[14] = v2 * a4 + b2 * u5 + w2 * f3 + _2 * g4, t5[15] = v2 * s4 + b2 * c4 + w2 * d3 + _2 * x2, t5;
        }
        function s3(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s4 = e4[3], o4 = n4 + n4, l4 = i4 + i4, u5 = a4 + a4, c4 = n4 * o4, h3 = n4 * l4, p3 = n4 * u5, f3 = i4 * l4, d3 = i4 * u5, m2 = a4 * u5, y2 = s4 * o4, g4 = s4 * l4, x2 = s4 * u5;
          return t5[0] = 1 - (f3 + m2), t5[1] = h3 + x2, t5[2] = p3 - g4, t5[3] = 0, t5[4] = h3 - x2, t5[5] = 1 - (c4 + m2), t5[6] = d3 + y2, t5[7] = 0, t5[8] = p3 + g4, t5[9] = d3 - y2, t5[10] = 1 - (c4 + f3), t5[11] = 0, t5[12] = r4[0], t5[13] = r4[1], t5[14] = r4[2], t5[15] = 1, t5;
        }
        function o3(t5, e4) {
          var r4 = e4[4], n4 = e4[5], i4 = e4[6], a4 = e4[8], s4 = e4[9], o4 = e4[10];
          return t5[0] = Math.hypot(e4[0], e4[1], e4[2]), t5[1] = Math.hypot(r4, n4, i4), t5[2] = Math.hypot(a4, s4, o4), t5;
        }
        function l3(t5, e4, r4, n4, i4) {
          var a4, s4 = 1 / Math.tan(e4 / 2);
          return t5[0] = s4 / r4, t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = 0, t5[5] = s4, t5[6] = 0, t5[7] = 0, t5[8] = 0, t5[9] = 0, t5[11] = -1, t5[12] = 0, t5[13] = 0, t5[15] = 0, null != i4 && i4 !== 1 / 0 ? (t5[10] = (i4 + n4) * (a4 = 1 / (n4 - i4)), t5[14] = 2 * i4 * n4 * a4) : (t5[10] = -1, t5[14] = -2 * n4), t5;
        }
        function u4(t5, e4, r4, n4, i4, a4, s4) {
          var o4 = 1 / (e4 - r4), l4 = 1 / (n4 - i4), u5 = 1 / (a4 - s4);
          return t5[0] = -2 * o4, t5[1] = 0, t5[2] = 0, t5[3] = 0, t5[4] = 0, t5[5] = -2 * l4, t5[6] = 0, t5[7] = 0, t5[8] = 0, t5[9] = 0, t5[10] = 2 * u5, t5[11] = 0, t5[12] = (e4 + r4) * o4, t5[13] = (i4 + n4) * l4, t5[14] = (s4 + a4) * u5, t5[15] = 1, t5;
        }
        function c3(t5, e4, r4) {
          return t5[0] = e4[0] - r4[0], t5[1] = e4[1] - r4[1], t5[2] = e4[2] - r4[2], t5[3] = e4[3] - r4[3], t5[4] = e4[4] - r4[4], t5[5] = e4[5] - r4[5], t5[6] = e4[6] - r4[6], t5[7] = e4[7] - r4[7], t5[8] = e4[8] - r4[8], t5[9] = e4[9] - r4[9], t5[10] = e4[10] - r4[10], t5[11] = e4[11] - r4[11], t5[12] = e4[12] - r4[12], t5[13] = e4[13] - r4[13], t5[14] = e4[14] - r4[14], t5[15] = e4[15] - r4[15], t5;
        }
        return y.perspective = l3, y.ortho = u4, y.mul = i3, y.sub = c3, y;
      }
      var x, v = {}, b = {};
      function w() {
        if (x) return b;
        function t4(e4) {
          return t4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t5) {
            return typeof t5;
          } : function(t5) {
            return t5 && "function" == typeof Symbol && t5.constructor === Symbol && t5 !== Symbol.prototype ? "symbol" : typeof t5;
          }, t4(e4);
        }
        x = 1, Object.defineProperty(b, "__esModule", { value: true }), b.create = n3, b.clone = function(t5) {
          var r4 = new e3.ARRAY_TYPE(3);
          return r4[0] = t5[0], r4[1] = t5[1], r4[2] = t5[2], r4;
        }, b.length = i3, b.fromValues = function(t5, r4, n4) {
          var i4 = new e3.ARRAY_TYPE(3);
          return i4[0] = t5, i4[1] = r4, i4[2] = n4, i4;
        }, b.copy = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = e4[1], t5[2] = e4[2], t5;
        }, b.set = function(t5, e4, r4, n4) {
          return t5[0] = e4, t5[1] = r4, t5[2] = n4, t5;
        }, b.add = function(t5, e4, r4) {
          return t5[0] = e4[0] + r4[0], t5[1] = e4[1] + r4[1], t5[2] = e4[2] + r4[2], t5;
        }, b.subtract = s3, b.multiply = o3, b.divide = l3, b.ceil = function(t5, e4) {
          return t5[0] = Math.ceil(e4[0]), t5[1] = Math.ceil(e4[1]), t5[2] = Math.ceil(e4[2]), t5;
        }, b.floor = function(t5, e4) {
          return t5[0] = Math.floor(e4[0]), t5[1] = Math.floor(e4[1]), t5[2] = Math.floor(e4[2]), t5;
        }, b.min = function(t5, e4, r4) {
          return t5[0] = Math.min(e4[0], r4[0]), t5[1] = Math.min(e4[1], r4[1]), t5[2] = Math.min(e4[2], r4[2]), t5;
        }, b.max = function(t5, e4, r4) {
          return t5[0] = Math.max(e4[0], r4[0]), t5[1] = Math.max(e4[1], r4[1]), t5[2] = Math.max(e4[2], r4[2]), t5;
        }, b.round = function(t5, e4) {
          return t5[0] = Math.round(e4[0]), t5[1] = Math.round(e4[1]), t5[2] = Math.round(e4[2]), t5;
        }, b.scale = function(t5, e4, r4) {
          return t5[0] = e4[0] * r4, t5[1] = e4[1] * r4, t5[2] = e4[2] * r4, t5;
        }, b.scaleAndAdd = function(t5, e4, r4, n4) {
          return t5[0] = e4[0] + r4[0] * n4, t5[1] = e4[1] + r4[1] * n4, t5[2] = e4[2] + r4[2] * n4, t5;
        }, b.distance = u4, b.squaredDistance = c3, b.squaredLength = h3, b.negate = function(t5, e4) {
          return t5[0] = -e4[0], t5[1] = -e4[1], t5[2] = -e4[2], t5;
        }, b.inverse = function(t5, e4) {
          return t5[0] = 1 / e4[0], t5[1] = 1 / e4[1], t5[2] = 1 / e4[2], t5;
        }, b.normalize = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = r4 * r4 + n4 * n4 + i4 * i4;
          return a4 > 0 && (a4 = 1 / Math.sqrt(a4)), t5[0] = e4[0] * a4, t5[1] = e4[1] * a4, t5[2] = e4[2] * a4, t5;
        }, b.dot = p3, b.cross = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s4 = r4[0], o4 = r4[1], l4 = r4[2];
          return t5[0] = i4 * l4 - a4 * o4, t5[1] = a4 * s4 - n4 * l4, t5[2] = n4 * o4 - i4 * s4, t5;
        }, b.lerp = function(t5, e4, r4, n4) {
          var i4 = e4[0], a4 = e4[1], s4 = e4[2];
          return t5[0] = i4 + n4 * (r4[0] - i4), t5[1] = a4 + n4 * (r4[1] - a4), t5[2] = s4 + n4 * (r4[2] - s4), t5;
        }, b.hermite = function(t5, e4, r4, n4, i4, a4) {
          var s4 = a4 * a4, o4 = s4 * (2 * a4 - 3) + 1, l4 = s4 * (a4 - 2) + a4, u5 = s4 * (a4 - 1), c4 = s4 * (3 - 2 * a4);
          return t5[0] = e4[0] * o4 + r4[0] * l4 + n4[0] * u5 + i4[0] * c4, t5[1] = e4[1] * o4 + r4[1] * l4 + n4[1] * u5 + i4[1] * c4, t5[2] = e4[2] * o4 + r4[2] * l4 + n4[2] * u5 + i4[2] * c4, t5;
        }, b.bezier = function(t5, e4, r4, n4, i4, a4) {
          var s4 = 1 - a4, o4 = s4 * s4, l4 = a4 * a4, u5 = o4 * s4, c4 = 3 * a4 * o4, h4 = 3 * l4 * s4, p4 = l4 * a4;
          return t5[0] = e4[0] * u5 + r4[0] * c4 + n4[0] * h4 + i4[0] * p4, t5[1] = e4[1] * u5 + r4[1] * c4 + n4[1] * h4 + i4[1] * p4, t5[2] = e4[2] * u5 + r4[2] * c4 + n4[2] * h4 + i4[2] * p4, t5;
        }, b.random = function(t5, r4) {
          r4 = r4 || 1;
          var n4 = 2 * e3.RANDOM() * Math.PI, i4 = 2 * e3.RANDOM() - 1, a4 = Math.sqrt(1 - i4 * i4) * r4;
          return t5[0] = Math.cos(n4) * a4, t5[1] = Math.sin(n4) * a4, t5[2] = i4 * r4, t5;
        }, b.transformMat4 = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s4 = r4[3] * n4 + r4[7] * i4 + r4[11] * a4 + r4[15];
          return t5[0] = (r4[0] * n4 + r4[4] * i4 + r4[8] * a4 + r4[12]) / (s4 = s4 || 1), t5[1] = (r4[1] * n4 + r4[5] * i4 + r4[9] * a4 + r4[13]) / s4, t5[2] = (r4[2] * n4 + r4[6] * i4 + r4[10] * a4 + r4[14]) / s4, t5;
        }, b.transformMat3 = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2];
          return t5[0] = n4 * r4[0] + i4 * r4[3] + a4 * r4[6], t5[1] = n4 * r4[1] + i4 * r4[4] + a4 * r4[7], t5[2] = n4 * r4[2] + i4 * r4[5] + a4 * r4[8], t5;
        }, b.transformQuat = function(t5, e4, r4) {
          var n4 = r4[0], i4 = r4[1], a4 = r4[2], s4 = e4[0], o4 = e4[1], l4 = e4[2], u5 = i4 * l4 - a4 * o4, c4 = a4 * s4 - n4 * l4, h4 = n4 * o4 - i4 * s4, p4 = i4 * h4 - a4 * c4, f4 = a4 * u5 - n4 * h4, d4 = n4 * c4 - i4 * u5, m2 = 2 * r4[3];
          return c4 *= m2, h4 *= m2, f4 *= 2, d4 *= 2, t5[0] = s4 + (u5 *= m2) + (p4 *= 2), t5[1] = o4 + c4 + f4, t5[2] = l4 + h4 + d4, t5;
        }, b.rotateX = function(t5, e4, r4, n4) {
          var i4 = [], a4 = [];
          return i4[0] = e4[0] - r4[0], i4[1] = e4[1] - r4[1], i4[2] = e4[2] - r4[2], a4[0] = i4[0], a4[1] = i4[1] * Math.cos(n4) - i4[2] * Math.sin(n4), a4[2] = i4[1] * Math.sin(n4) + i4[2] * Math.cos(n4), t5[0] = a4[0] + r4[0], t5[1] = a4[1] + r4[1], t5[2] = a4[2] + r4[2], t5;
        }, b.rotateY = function(t5, e4, r4, n4) {
          var i4 = [], a4 = [];
          return i4[0] = e4[0] - r4[0], i4[1] = e4[1] - r4[1], i4[2] = e4[2] - r4[2], a4[0] = i4[2] * Math.sin(n4) + i4[0] * Math.cos(n4), a4[1] = i4[1], a4[2] = i4[2] * Math.cos(n4) - i4[0] * Math.sin(n4), t5[0] = a4[0] + r4[0], t5[1] = a4[1] + r4[1], t5[2] = a4[2] + r4[2], t5;
        }, b.rotateZ = function(t5, e4, r4, n4) {
          var i4 = [], a4 = [];
          return i4[0] = e4[0] - r4[0], i4[1] = e4[1] - r4[1], i4[2] = e4[2] - r4[2], a4[0] = i4[0] * Math.cos(n4) - i4[1] * Math.sin(n4), a4[1] = i4[0] * Math.sin(n4) + i4[1] * Math.cos(n4), a4[2] = i4[2], t5[0] = a4[0] + r4[0], t5[1] = a4[1] + r4[1], t5[2] = a4[2] + r4[2], t5;
        }, b.angle = function(t5, e4) {
          var r4 = t5[0], n4 = t5[1], i4 = t5[2], a4 = e4[0], s4 = e4[1], o4 = e4[2], l4 = Math.sqrt(r4 * r4 + n4 * n4 + i4 * i4) * Math.sqrt(a4 * a4 + s4 * s4 + o4 * o4), u5 = l4 && p3(t5, e4) / l4;
          return Math.acos(Math.min(Math.max(u5, -1), 1));
        }, b.zero = function(t5) {
          return t5[0] = 0, t5[1] = 0, t5[2] = 0, t5;
        }, b.str = function(t5) {
          return "vec3(" + t5[0] + ", " + t5[1] + ", " + t5[2] + ")";
        }, b.exactEquals = function(t5, e4) {
          return t5[0] === e4[0] && t5[1] === e4[1] && t5[2] === e4[2];
        }, b.equals = function(t5, r4) {
          var n4 = t5[0], i4 = t5[1], a4 = t5[2], s4 = r4[0], o4 = r4[1], l4 = r4[2];
          return Math.abs(n4 - s4) <= e3.EPSILON * Math.max(1, Math.abs(n4), Math.abs(s4)) && Math.abs(i4 - o4) <= e3.EPSILON * Math.max(1, Math.abs(i4), Math.abs(o4)) && Math.abs(a4 - l4) <= e3.EPSILON * Math.max(1, Math.abs(a4), Math.abs(l4));
        }, b.forEach = b.sqrLen = b.len = b.sqrDist = b.dist = b.div = b.mul = b.sub = void 0;
        var e3 = function(e4, n4) {
          if (e4 && e4.__esModule) return e4;
          if (null === e4 || "object" !== t4(e4) && "function" != typeof e4) return { default: e4 };
          var i4 = r3(void 0);
          if (i4 && i4.has(e4)) return i4.get(e4);
          var a4 = {}, s4 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var o4 in e4) if ("default" !== o4 && Object.prototype.hasOwnProperty.call(e4, o4)) {
            var l4 = s4 ? Object.getOwnPropertyDescriptor(e4, o4) : null;
            l4 && (l4.get || l4.set) ? Object.defineProperty(a4, o4, l4) : a4[o4] = e4[o4];
          }
          return a4.default = e4, i4 && i4.set(e4, a4), a4;
        }(a3());
        function r3(t5) {
          if ("function" != typeof WeakMap) return null;
          var e4 = /* @__PURE__ */ new WeakMap(), n4 = /* @__PURE__ */ new WeakMap();
          return (r3 = function(t6) {
            return t6 ? n4 : e4;
          })(t5);
        }
        function n3() {
          var t5 = new e3.ARRAY_TYPE(3);
          return e3.ARRAY_TYPE != Float32Array && (t5[0] = 0, t5[1] = 0, t5[2] = 0), t5;
        }
        function i3(t5) {
          return Math.hypot(t5[0], t5[1], t5[2]);
        }
        function s3(t5, e4, r4) {
          return t5[0] = e4[0] - r4[0], t5[1] = e4[1] - r4[1], t5[2] = e4[2] - r4[2], t5;
        }
        function o3(t5, e4, r4) {
          return t5[0] = e4[0] * r4[0], t5[1] = e4[1] * r4[1], t5[2] = e4[2] * r4[2], t5;
        }
        function l3(t5, e4, r4) {
          return t5[0] = e4[0] / r4[0], t5[1] = e4[1] / r4[1], t5[2] = e4[2] / r4[2], t5;
        }
        function u4(t5, e4) {
          return Math.hypot(e4[0] - t5[0], e4[1] - t5[1], e4[2] - t5[2]);
        }
        function c3(t5, e4) {
          var r4 = e4[0] - t5[0], n4 = e4[1] - t5[1], i4 = e4[2] - t5[2];
          return r4 * r4 + n4 * n4 + i4 * i4;
        }
        function h3(t5) {
          var e4 = t5[0], r4 = t5[1], n4 = t5[2];
          return e4 * e4 + r4 * r4 + n4 * n4;
        }
        function p3(t5, e4) {
          return t5[0] * e4[0] + t5[1] * e4[1] + t5[2] * e4[2];
        }
        b.sub = s3, b.mul = o3, b.div = l3, b.dist = u4, b.sqrDist = c3, b.len = i3, b.sqrLen = h3;
        var f3, d3 = (f3 = n3(), function(t5, e4, r4, n4, i4, a4) {
          var s4, o4;
          for (e4 || (e4 = 3), r4 || (r4 = 0), o4 = n4 ? Math.min(n4 * e4 + r4, t5.length) : t5.length, s4 = r4; s4 < o4; s4 += e4) f3[0] = t5[s4], f3[1] = t5[s4 + 1], f3[2] = t5[s4 + 2], i4(f3, f3, a4), t5[s4] = f3[0], t5[s4 + 1] = f3[1], t5[s4 + 2] = f3[2];
          return t5;
        });
        return b.forEach = d3, b;
      }
      var _, M, A2 = {};
      function S() {
        if (_) return A2;
        function t4(e4) {
          return t4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t5) {
            return typeof t5;
          } : function(t5) {
            return t5 && "function" == typeof Symbol && t5.constructor === Symbol && t5 !== Symbol.prototype ? "symbol" : typeof t5;
          }, t4(e4);
        }
        _ = 1, Object.defineProperty(A2, "__esModule", { value: true }), A2.create = n3, A2.clone = function(t5) {
          var r4 = new e3.ARRAY_TYPE(4);
          return r4[0] = t5[0], r4[1] = t5[1], r4[2] = t5[2], r4[3] = t5[3], r4;
        }, A2.fromValues = function(t5, r4, n4, i4) {
          var a4 = new e3.ARRAY_TYPE(4);
          return a4[0] = t5, a4[1] = r4, a4[2] = n4, a4[3] = i4, a4;
        }, A2.copy = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = e4[1], t5[2] = e4[2], t5[3] = e4[3], t5;
        }, A2.set = function(t5, e4, r4, n4, i4) {
          return t5[0] = e4, t5[1] = r4, t5[2] = n4, t5[3] = i4, t5;
        }, A2.add = function(t5, e4, r4) {
          return t5[0] = e4[0] + r4[0], t5[1] = e4[1] + r4[1], t5[2] = e4[2] + r4[2], t5[3] = e4[3] + r4[3], t5;
        }, A2.subtract = i3, A2.multiply = s3, A2.divide = o3, A2.ceil = function(t5, e4) {
          return t5[0] = Math.ceil(e4[0]), t5[1] = Math.ceil(e4[1]), t5[2] = Math.ceil(e4[2]), t5[3] = Math.ceil(e4[3]), t5;
        }, A2.floor = function(t5, e4) {
          return t5[0] = Math.floor(e4[0]), t5[1] = Math.floor(e4[1]), t5[2] = Math.floor(e4[2]), t5[3] = Math.floor(e4[3]), t5;
        }, A2.min = function(t5, e4, r4) {
          return t5[0] = Math.min(e4[0], r4[0]), t5[1] = Math.min(e4[1], r4[1]), t5[2] = Math.min(e4[2], r4[2]), t5[3] = Math.min(e4[3], r4[3]), t5;
        }, A2.max = function(t5, e4, r4) {
          return t5[0] = Math.max(e4[0], r4[0]), t5[1] = Math.max(e4[1], r4[1]), t5[2] = Math.max(e4[2], r4[2]), t5[3] = Math.max(e4[3], r4[3]), t5;
        }, A2.round = function(t5, e4) {
          return t5[0] = Math.round(e4[0]), t5[1] = Math.round(e4[1]), t5[2] = Math.round(e4[2]), t5[3] = Math.round(e4[3]), t5;
        }, A2.scale = function(t5, e4, r4) {
          return t5[0] = e4[0] * r4, t5[1] = e4[1] * r4, t5[2] = e4[2] * r4, t5[3] = e4[3] * r4, t5;
        }, A2.scaleAndAdd = function(t5, e4, r4, n4) {
          return t5[0] = e4[0] + r4[0] * n4, t5[1] = e4[1] + r4[1] * n4, t5[2] = e4[2] + r4[2] * n4, t5[3] = e4[3] + r4[3] * n4, t5;
        }, A2.distance = l3, A2.squaredDistance = u4, A2.length = c3, A2.squaredLength = h3, A2.negate = function(t5, e4) {
          return t5[0] = -e4[0], t5[1] = -e4[1], t5[2] = -e4[2], t5[3] = -e4[3], t5;
        }, A2.inverse = function(t5, e4) {
          return t5[0] = 1 / e4[0], t5[1] = 1 / e4[1], t5[2] = 1 / e4[2], t5[3] = 1 / e4[3], t5;
        }, A2.normalize = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = e4[3], s4 = r4 * r4 + n4 * n4 + i4 * i4 + a4 * a4;
          return s4 > 0 && (s4 = 1 / Math.sqrt(s4)), t5[0] = r4 * s4, t5[1] = n4 * s4, t5[2] = i4 * s4, t5[3] = a4 * s4, t5;
        }, A2.dot = function(t5, e4) {
          return t5[0] * e4[0] + t5[1] * e4[1] + t5[2] * e4[2] + t5[3] * e4[3];
        }, A2.cross = function(t5, e4, r4, n4) {
          var i4 = r4[0] * n4[1] - r4[1] * n4[0], a4 = r4[0] * n4[2] - r4[2] * n4[0], s4 = r4[0] * n4[3] - r4[3] * n4[0], o4 = r4[1] * n4[2] - r4[2] * n4[1], l4 = r4[1] * n4[3] - r4[3] * n4[1], u5 = r4[2] * n4[3] - r4[3] * n4[2], c4 = e4[0], h4 = e4[1], p4 = e4[2], f4 = e4[3];
          return t5[0] = h4 * u5 - p4 * l4 + f4 * o4, t5[1] = -c4 * u5 + p4 * s4 - f4 * a4, t5[2] = c4 * l4 - h4 * s4 + f4 * i4, t5[3] = -c4 * o4 + h4 * a4 - p4 * i4, t5;
        }, A2.lerp = function(t5, e4, r4, n4) {
          var i4 = e4[0], a4 = e4[1], s4 = e4[2], o4 = e4[3];
          return t5[0] = i4 + n4 * (r4[0] - i4), t5[1] = a4 + n4 * (r4[1] - a4), t5[2] = s4 + n4 * (r4[2] - s4), t5[3] = o4 + n4 * (r4[3] - o4), t5;
        }, A2.random = function(t5, r4) {
          var n4, i4, a4, s4, o4, l4;
          r4 = r4 || 1;
          do {
            o4 = (n4 = 2 * e3.RANDOM() - 1) * n4 + (i4 = 2 * e3.RANDOM() - 1) * i4;
          } while (o4 >= 1);
          do {
            l4 = (a4 = 2 * e3.RANDOM() - 1) * a4 + (s4 = 2 * e3.RANDOM() - 1) * s4;
          } while (l4 >= 1);
          var u5 = Math.sqrt((1 - o4) / l4);
          return t5[0] = r4 * n4, t5[1] = r4 * i4, t5[2] = r4 * a4 * u5, t5[3] = r4 * s4 * u5, t5;
        }, A2.transformMat4 = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s4 = e4[3];
          return t5[0] = r4[0] * n4 + r4[4] * i4 + r4[8] * a4 + r4[12] * s4, t5[1] = r4[1] * n4 + r4[5] * i4 + r4[9] * a4 + r4[13] * s4, t5[2] = r4[2] * n4 + r4[6] * i4 + r4[10] * a4 + r4[14] * s4, t5[3] = r4[3] * n4 + r4[7] * i4 + r4[11] * a4 + r4[15] * s4, t5;
        }, A2.transformQuat = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s4 = r4[0], o4 = r4[1], l4 = r4[2], u5 = r4[3], c4 = u5 * n4 + o4 * a4 - l4 * i4, h4 = u5 * i4 + l4 * n4 - s4 * a4, p4 = u5 * a4 + s4 * i4 - o4 * n4, f4 = -s4 * n4 - o4 * i4 - l4 * a4;
          return t5[0] = c4 * u5 + f4 * -s4 + h4 * -l4 - p4 * -o4, t5[1] = h4 * u5 + f4 * -o4 + p4 * -s4 - c4 * -l4, t5[2] = p4 * u5 + f4 * -l4 + c4 * -o4 - h4 * -s4, t5[3] = e4[3], t5;
        }, A2.zero = function(t5) {
          return t5[0] = 0, t5[1] = 0, t5[2] = 0, t5[3] = 0, t5;
        }, A2.str = function(t5) {
          return "vec4(" + t5[0] + ", " + t5[1] + ", " + t5[2] + ", " + t5[3] + ")";
        }, A2.exactEquals = function(t5, e4) {
          return t5[0] === e4[0] && t5[1] === e4[1] && t5[2] === e4[2] && t5[3] === e4[3];
        }, A2.equals = function(t5, r4) {
          var n4 = t5[0], i4 = t5[1], a4 = t5[2], s4 = t5[3], o4 = r4[0], l4 = r4[1], u5 = r4[2], c4 = r4[3];
          return Math.abs(n4 - o4) <= e3.EPSILON * Math.max(1, Math.abs(n4), Math.abs(o4)) && Math.abs(i4 - l4) <= e3.EPSILON * Math.max(1, Math.abs(i4), Math.abs(l4)) && Math.abs(a4 - u5) <= e3.EPSILON * Math.max(1, Math.abs(a4), Math.abs(u5)) && Math.abs(s4 - c4) <= e3.EPSILON * Math.max(1, Math.abs(s4), Math.abs(c4));
        }, A2.forEach = A2.sqrLen = A2.len = A2.sqrDist = A2.dist = A2.div = A2.mul = A2.sub = void 0;
        var e3 = function(e4, n4) {
          if (e4 && e4.__esModule) return e4;
          if (null === e4 || "object" !== t4(e4) && "function" != typeof e4) return { default: e4 };
          var i4 = r3(void 0);
          if (i4 && i4.has(e4)) return i4.get(e4);
          var a4 = {}, s4 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var o4 in e4) if ("default" !== o4 && Object.prototype.hasOwnProperty.call(e4, o4)) {
            var l4 = s4 ? Object.getOwnPropertyDescriptor(e4, o4) : null;
            l4 && (l4.get || l4.set) ? Object.defineProperty(a4, o4, l4) : a4[o4] = e4[o4];
          }
          return a4.default = e4, i4 && i4.set(e4, a4), a4;
        }(a3());
        function r3(t5) {
          if ("function" != typeof WeakMap) return null;
          var e4 = /* @__PURE__ */ new WeakMap(), n4 = /* @__PURE__ */ new WeakMap();
          return (r3 = function(t6) {
            return t6 ? n4 : e4;
          })(t5);
        }
        function n3() {
          var t5 = new e3.ARRAY_TYPE(4);
          return e3.ARRAY_TYPE != Float32Array && (t5[0] = 0, t5[1] = 0, t5[2] = 0, t5[3] = 0), t5;
        }
        function i3(t5, e4, r4) {
          return t5[0] = e4[0] - r4[0], t5[1] = e4[1] - r4[1], t5[2] = e4[2] - r4[2], t5[3] = e4[3] - r4[3], t5;
        }
        function s3(t5, e4, r4) {
          return t5[0] = e4[0] * r4[0], t5[1] = e4[1] * r4[1], t5[2] = e4[2] * r4[2], t5[3] = e4[3] * r4[3], t5;
        }
        function o3(t5, e4, r4) {
          return t5[0] = e4[0] / r4[0], t5[1] = e4[1] / r4[1], t5[2] = e4[2] / r4[2], t5[3] = e4[3] / r4[3], t5;
        }
        function l3(t5, e4) {
          return Math.hypot(e4[0] - t5[0], e4[1] - t5[1], e4[2] - t5[2], e4[3] - t5[3]);
        }
        function u4(t5, e4) {
          var r4 = e4[0] - t5[0], n4 = e4[1] - t5[1], i4 = e4[2] - t5[2], a4 = e4[3] - t5[3];
          return r4 * r4 + n4 * n4 + i4 * i4 + a4 * a4;
        }
        function c3(t5) {
          return Math.hypot(t5[0], t5[1], t5[2], t5[3]);
        }
        function h3(t5) {
          var e4 = t5[0], r4 = t5[1], n4 = t5[2], i4 = t5[3];
          return e4 * e4 + r4 * r4 + n4 * n4 + i4 * i4;
        }
        A2.sub = i3, A2.mul = s3, A2.div = o3, A2.dist = l3, A2.sqrDist = u4, A2.len = c3, A2.sqrLen = h3;
        var p3, f3 = (p3 = n3(), function(t5, e4, r4, n4, i4, a4) {
          var s4, o4;
          for (e4 || (e4 = 4), r4 || (r4 = 0), o4 = n4 ? Math.min(n4 * e4 + r4, t5.length) : t5.length, s4 = r4; s4 < o4; s4 += e4) p3[0] = t5[s4], p3[1] = t5[s4 + 1], p3[2] = t5[s4 + 2], p3[3] = t5[s4 + 3], i4(p3, p3, a4), t5[s4] = p3[0], t5[s4 + 1] = p3[1], t5[s4 + 2] = p3[2], t5[s4 + 3] = p3[3];
          return t5;
        });
        return A2.forEach = f3, A2;
      }
      function I2() {
        if (M) return v;
        function t4(e4) {
          return t4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t5) {
            return typeof t5;
          } : function(t5) {
            return t5 && "function" == typeof Symbol && t5.constructor === Symbol && t5 !== Symbol.prototype ? "symbol" : typeof t5;
          }, t4(e4);
        }
        M = 1, Object.defineProperty(v, "__esModule", { value: true }), v.create = l3, v.identity = function(t5) {
          return t5[0] = 0, t5[1] = 0, t5[2] = 0, t5[3] = 1, t5;
        }, v.setAxisAngle = u4, v.getAxisAngle = function(t5, r4) {
          var n4 = 2 * Math.acos(r4[3]), i4 = Math.sin(n4 / 2);
          return i4 > e3.EPSILON ? (t5[0] = r4[0] / i4, t5[1] = r4[1] / i4, t5[2] = r4[2] / i4) : (t5[0] = 1, t5[1] = 0, t5[2] = 0), n4;
        }, v.getAngle = function(t5, e4) {
          var r4 = g4(t5, e4);
          return Math.acos(2 * r4 * r4 - 1);
        }, v.multiply = c3, v.rotateX = function(t5, e4, r4) {
          r4 *= 0.5;
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s4 = e4[3], o4 = Math.sin(r4), l4 = Math.cos(r4);
          return t5[0] = n4 * l4 + s4 * o4, t5[1] = i4 * l4 + a4 * o4, t5[2] = a4 * l4 - i4 * o4, t5[3] = s4 * l4 - n4 * o4, t5;
        }, v.rotateY = function(t5, e4, r4) {
          r4 *= 0.5;
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s4 = e4[3], o4 = Math.sin(r4), l4 = Math.cos(r4);
          return t5[0] = n4 * l4 - a4 * o4, t5[1] = i4 * l4 + s4 * o4, t5[2] = a4 * l4 + n4 * o4, t5[3] = s4 * l4 - i4 * o4, t5;
        }, v.rotateZ = function(t5, e4, r4) {
          r4 *= 0.5;
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s4 = e4[3], o4 = Math.sin(r4), l4 = Math.cos(r4);
          return t5[0] = n4 * l4 + i4 * o4, t5[1] = i4 * l4 - n4 * o4, t5[2] = a4 * l4 + s4 * o4, t5[3] = s4 * l4 - a4 * o4, t5;
        }, v.calculateW = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2];
          return t5[0] = r4, t5[1] = n4, t5[2] = i4, t5[3] = Math.sqrt(Math.abs(1 - r4 * r4 - n4 * n4 - i4 * i4)), t5;
        }, v.exp = h3, v.ln = p3, v.pow = function(t5, e4, r4) {
          return p3(t5, e4), y2(t5, t5, r4), h3(t5, t5), t5;
        }, v.slerp = f3, v.random = function(t5) {
          var r4 = e3.RANDOM(), n4 = e3.RANDOM(), i4 = e3.RANDOM(), a4 = Math.sqrt(1 - r4), s4 = Math.sqrt(r4);
          return t5[0] = a4 * Math.sin(2 * Math.PI * n4), t5[1] = a4 * Math.cos(2 * Math.PI * n4), t5[2] = s4 * Math.sin(2 * Math.PI * i4), t5[3] = s4 * Math.cos(2 * Math.PI * i4), t5;
        }, v.invert = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = e4[3], s4 = r4 * r4 + n4 * n4 + i4 * i4 + a4 * a4, o4 = s4 ? 1 / s4 : 0;
          return t5[0] = -r4 * o4, t5[1] = -n4 * o4, t5[2] = -i4 * o4, t5[3] = a4 * o4, t5;
        }, v.conjugate = function(t5, e4) {
          return t5[0] = -e4[0], t5[1] = -e4[1], t5[2] = -e4[2], t5[3] = e4[3], t5;
        }, v.fromMat3 = m2, v.fromEuler = function(t5, e4, r4, n4) {
          var i4 = 0.5 * Math.PI / 180;
          e4 *= i4, r4 *= i4, n4 *= i4;
          var a4 = Math.sin(e4), s4 = Math.cos(e4), o4 = Math.sin(r4), l4 = Math.cos(r4), u5 = Math.sin(n4), c4 = Math.cos(n4);
          return t5[0] = a4 * l4 * c4 - s4 * o4 * u5, t5[1] = s4 * o4 * c4 + a4 * l4 * u5, t5[2] = s4 * l4 * u5 - a4 * o4 * c4, t5[3] = s4 * l4 * c4 + a4 * o4 * u5, t5;
        }, v.str = function(t5) {
          return "quat(" + t5[0] + ", " + t5[1] + ", " + t5[2] + ", " + t5[3] + ")";
        }, v.setAxes = v.sqlerp = v.rotationTo = v.equals = v.exactEquals = v.normalize = v.sqrLen = v.squaredLength = v.len = v.length = v.lerp = v.dot = v.scale = v.mul = v.add = v.set = v.copy = v.fromValues = v.clone = void 0;
        var e3 = o3(a3()), r3 = o3(d2()), n3 = o3(w()), i3 = o3(S());
        function s3(t5) {
          if ("function" != typeof WeakMap) return null;
          var e4 = /* @__PURE__ */ new WeakMap(), r4 = /* @__PURE__ */ new WeakMap();
          return (s3 = function(t6) {
            return t6 ? r4 : e4;
          })(t5);
        }
        function o3(e4, r4) {
          if (e4 && e4.__esModule) return e4;
          if (null === e4 || "object" !== t4(e4) && "function" != typeof e4) return { default: e4 };
          var n4 = s3(r4);
          if (n4 && n4.has(e4)) return n4.get(e4);
          var i4 = {}, a4 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var o4 in e4) if ("default" !== o4 && Object.prototype.hasOwnProperty.call(e4, o4)) {
            var l4 = a4 ? Object.getOwnPropertyDescriptor(e4, o4) : null;
            l4 && (l4.get || l4.set) ? Object.defineProperty(i4, o4, l4) : i4[o4] = e4[o4];
          }
          return i4.default = e4, n4 && n4.set(e4, i4), i4;
        }
        function l3() {
          var t5 = new e3.ARRAY_TYPE(4);
          return e3.ARRAY_TYPE != Float32Array && (t5[0] = 0, t5[1] = 0, t5[2] = 0), t5[3] = 1, t5;
        }
        function u4(t5, e4, r4) {
          r4 *= 0.5;
          var n4 = Math.sin(r4);
          return t5[0] = n4 * e4[0], t5[1] = n4 * e4[1], t5[2] = n4 * e4[2], t5[3] = Math.cos(r4), t5;
        }
        function c3(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s4 = e4[3], o4 = r4[0], l4 = r4[1], u5 = r4[2], c4 = r4[3];
          return t5[0] = n4 * c4 + s4 * o4 + i4 * u5 - a4 * l4, t5[1] = i4 * c4 + s4 * l4 + a4 * o4 - n4 * u5, t5[2] = a4 * c4 + s4 * u5 + n4 * l4 - i4 * o4, t5[3] = s4 * c4 - n4 * o4 - i4 * l4 - a4 * u5, t5;
        }
        function h3(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = e4[3], s4 = Math.sqrt(r4 * r4 + n4 * n4 + i4 * i4), o4 = Math.exp(a4), l4 = s4 > 0 ? o4 * Math.sin(s4) / s4 : 0;
          return t5[0] = r4 * l4, t5[1] = n4 * l4, t5[2] = i4 * l4, t5[3] = o4 * Math.cos(s4), t5;
        }
        function p3(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = e4[2], a4 = e4[3], s4 = Math.sqrt(r4 * r4 + n4 * n4 + i4 * i4), o4 = s4 > 0 ? Math.atan2(s4, a4) / s4 : 0;
          return t5[0] = r4 * o4, t5[1] = n4 * o4, t5[2] = i4 * o4, t5[3] = 0.5 * Math.log(r4 * r4 + n4 * n4 + i4 * i4 + a4 * a4), t5;
        }
        function f3(t5, r4, n4, i4) {
          var a4, s4, o4, l4, u5, c4 = r4[0], h4 = r4[1], p4 = r4[2], f4 = r4[3], d3 = n4[0], m3 = n4[1], y3 = n4[2], g5 = n4[3];
          return (s4 = c4 * d3 + h4 * m3 + p4 * y3 + f4 * g5) < 0 && (s4 = -s4, d3 = -d3, m3 = -m3, y3 = -y3, g5 = -g5), 1 - s4 > e3.EPSILON ? (a4 = Math.acos(s4), o4 = Math.sin(a4), l4 = Math.sin((1 - i4) * a4) / o4, u5 = Math.sin(i4 * a4) / o4) : (l4 = 1 - i4, u5 = i4), t5[0] = l4 * c4 + u5 * d3, t5[1] = l4 * h4 + u5 * m3, t5[2] = l4 * p4 + u5 * y3, t5[3] = l4 * f4 + u5 * g5, t5;
        }
        function m2(t5, e4) {
          var r4, n4 = e4[0] + e4[4] + e4[8];
          if (n4 > 0) r4 = Math.sqrt(n4 + 1), t5[3] = 0.5 * r4, t5[0] = (e4[5] - e4[7]) * (r4 = 0.5 / r4), t5[1] = (e4[6] - e4[2]) * r4, t5[2] = (e4[1] - e4[3]) * r4;
          else {
            var i4 = 0;
            e4[4] > e4[0] && (i4 = 1), e4[8] > e4[3 * i4 + i4] && (i4 = 2);
            var a4 = (i4 + 1) % 3, s4 = (i4 + 2) % 3;
            r4 = Math.sqrt(e4[3 * i4 + i4] - e4[3 * a4 + a4] - e4[3 * s4 + s4] + 1), t5[i4] = 0.5 * r4, t5[3] = (e4[3 * a4 + s4] - e4[3 * s4 + a4]) * (r4 = 0.5 / r4), t5[a4] = (e4[3 * a4 + i4] + e4[3 * i4 + a4]) * r4, t5[s4] = (e4[3 * s4 + i4] + e4[3 * i4 + s4]) * r4;
          }
          return t5;
        }
        v.clone = i3.clone, v.fromValues = i3.fromValues, v.copy = i3.copy, v.set = i3.set, v.add = i3.add, v.mul = c3;
        var y2 = i3.scale;
        v.scale = y2;
        var g4 = i3.dot;
        v.dot = g4, v.lerp = i3.lerp;
        var x2 = i3.length;
        v.length = x2, v.len = x2;
        var b2 = i3.squaredLength;
        v.squaredLength = b2, v.sqrLen = b2;
        var _2 = i3.normalize;
        v.normalize = _2, v.exactEquals = i3.exactEquals, v.equals = i3.equals;
        var A3, I3, z3, P2 = (A3 = n3.create(), I3 = n3.fromValues(1, 0, 0), z3 = n3.fromValues(0, 1, 0), function(t5, e4, r4) {
          var i4 = n3.dot(e4, r4);
          return i4 < -0.999999 ? (n3.cross(A3, I3, e4), n3.len(A3) < 1e-6 && n3.cross(A3, z3, e4), n3.normalize(A3, A3), u4(t5, A3, Math.PI), t5) : i4 > 0.999999 ? (t5[0] = 0, t5[1] = 0, t5[2] = 0, t5[3] = 1, t5) : (n3.cross(A3, e4, r4), t5[0] = A3[0], t5[1] = A3[1], t5[2] = A3[2], t5[3] = 1 + i4, _2(t5, t5));
        });
        v.rotationTo = P2;
        var k2, T3, E3 = (k2 = l3(), T3 = l3(), function(t5, e4, r4, n4, i4, a4) {
          return f3(k2, e4, i4, a4), f3(T3, r4, n4, a4), f3(t5, k2, T3, 2 * a4 * (1 - a4)), t5;
        });
        v.sqlerp = E3;
        var B4, V3 = (B4 = r3.create(), function(t5, e4, r4, n4) {
          return B4[0] = r4[0], B4[3] = r4[1], B4[6] = r4[2], B4[1] = n4[0], B4[4] = n4[1], B4[7] = n4[2], B4[2] = -e4[0], B4[5] = -e4[1], B4[8] = -e4[2], _2(t5, m2(t5, B4));
        });
        return v.setAxes = V3, v;
      }
      var z2, P = {};
      function k() {
        if (z2) return P;
        function t4(e4) {
          return t4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t5) {
            return typeof t5;
          } : function(t5) {
            return t5 && "function" == typeof Symbol && t5.constructor === Symbol && t5 !== Symbol.prototype ? "symbol" : typeof t5;
          }, t4(e4);
        }
        z2 = 1, Object.defineProperty(P, "__esModule", { value: true }), P.create = function() {
          var t5 = new e3.ARRAY_TYPE(8);
          return e3.ARRAY_TYPE != Float32Array && (t5[0] = 0, t5[1] = 0, t5[2] = 0, t5[4] = 0, t5[5] = 0, t5[6] = 0, t5[7] = 0), t5[3] = 1, t5;
        }, P.clone = function(t5) {
          var r4 = new e3.ARRAY_TYPE(8);
          return r4[0] = t5[0], r4[1] = t5[1], r4[2] = t5[2], r4[3] = t5[3], r4[4] = t5[4], r4[5] = t5[5], r4[6] = t5[6], r4[7] = t5[7], r4;
        }, P.fromValues = function(t5, r4, n4, i4, a4, s4, o4, l4) {
          var u5 = new e3.ARRAY_TYPE(8);
          return u5[0] = t5, u5[1] = r4, u5[2] = n4, u5[3] = i4, u5[4] = a4, u5[5] = s4, u5[6] = o4, u5[7] = l4, u5;
        }, P.fromRotationTranslationValues = function(t5, r4, n4, i4, a4, s4, o4) {
          var l4 = new e3.ARRAY_TYPE(8);
          l4[0] = t5, l4[1] = r4, l4[2] = n4, l4[3] = i4;
          var u5 = 0.5 * a4, c4 = 0.5 * s4, h4 = 0.5 * o4;
          return l4[4] = u5 * i4 + c4 * n4 - h4 * r4, l4[5] = c4 * i4 + h4 * t5 - u5 * n4, l4[6] = h4 * i4 + u5 * r4 - c4 * t5, l4[7] = -u5 * t5 - c4 * r4 - h4 * n4, l4;
        }, P.fromRotationTranslation = o3, P.fromTranslation = function(t5, e4) {
          return t5[0] = 0, t5[1] = 0, t5[2] = 0, t5[3] = 1, t5[4] = 0.5 * e4[0], t5[5] = 0.5 * e4[1], t5[6] = 0.5 * e4[2], t5[7] = 0, t5;
        }, P.fromRotation = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = e4[1], t5[2] = e4[2], t5[3] = e4[3], t5[4] = 0, t5[5] = 0, t5[6] = 0, t5[7] = 0, t5;
        }, P.fromMat4 = function(t5, i4) {
          var a4 = r3.create();
          n3.getRotation(a4, i4);
          var s4 = new e3.ARRAY_TYPE(3);
          return n3.getTranslation(s4, i4), o3(t5, a4, s4), t5;
        }, P.copy = l3, P.identity = function(t5) {
          return t5[0] = 0, t5[1] = 0, t5[2] = 0, t5[3] = 1, t5[4] = 0, t5[5] = 0, t5[6] = 0, t5[7] = 0, t5;
        }, P.set = function(t5, e4, r4, n4, i4, a4, s4, o4, l4) {
          return t5[0] = e4, t5[1] = r4, t5[2] = n4, t5[3] = i4, t5[4] = a4, t5[5] = s4, t5[6] = o4, t5[7] = l4, t5;
        }, P.getDual = function(t5, e4) {
          return t5[0] = e4[4], t5[1] = e4[5], t5[2] = e4[6], t5[3] = e4[7], t5;
        }, P.setDual = function(t5, e4) {
          return t5[4] = e4[0], t5[5] = e4[1], t5[6] = e4[2], t5[7] = e4[3], t5;
        }, P.getTranslation = function(t5, e4) {
          var r4 = e4[4], n4 = e4[5], i4 = e4[6], a4 = e4[7], s4 = -e4[0], o4 = -e4[1], l4 = -e4[2], u5 = e4[3];
          return t5[0] = 2 * (r4 * u5 + a4 * s4 + n4 * l4 - i4 * o4), t5[1] = 2 * (n4 * u5 + a4 * o4 + i4 * s4 - r4 * l4), t5[2] = 2 * (i4 * u5 + a4 * l4 + r4 * o4 - n4 * s4), t5;
        }, P.translate = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s4 = e4[3], o4 = 0.5 * r4[0], l4 = 0.5 * r4[1], u5 = 0.5 * r4[2], c4 = e4[4], h4 = e4[5], p4 = e4[6], f3 = e4[7];
          return t5[0] = n4, t5[1] = i4, t5[2] = a4, t5[3] = s4, t5[4] = s4 * o4 + i4 * u5 - a4 * l4 + c4, t5[5] = s4 * l4 + a4 * o4 - n4 * u5 + h4, t5[6] = s4 * u5 + n4 * l4 - i4 * o4 + p4, t5[7] = -n4 * o4 - i4 * l4 - a4 * u5 + f3, t5;
        }, P.rotateX = function(t5, e4, n4) {
          var i4 = -e4[0], a4 = -e4[1], s4 = -e4[2], o4 = e4[3], l4 = e4[4], u5 = e4[5], c4 = e4[6], h4 = e4[7], p4 = l4 * o4 + h4 * i4 + u5 * s4 - c4 * a4, f3 = u5 * o4 + h4 * a4 + c4 * i4 - l4 * s4, d3 = c4 * o4 + h4 * s4 + l4 * a4 - u5 * i4, m2 = h4 * o4 - l4 * i4 - u5 * a4 - c4 * s4;
          return r3.rotateX(t5, e4, n4), t5[4] = p4 * (o4 = t5[3]) + m2 * (i4 = t5[0]) + f3 * (s4 = t5[2]) - d3 * (a4 = t5[1]), t5[5] = f3 * o4 + m2 * a4 + d3 * i4 - p4 * s4, t5[6] = d3 * o4 + m2 * s4 + p4 * a4 - f3 * i4, t5[7] = m2 * o4 - p4 * i4 - f3 * a4 - d3 * s4, t5;
        }, P.rotateY = function(t5, e4, n4) {
          var i4 = -e4[0], a4 = -e4[1], s4 = -e4[2], o4 = e4[3], l4 = e4[4], u5 = e4[5], c4 = e4[6], h4 = e4[7], p4 = l4 * o4 + h4 * i4 + u5 * s4 - c4 * a4, f3 = u5 * o4 + h4 * a4 + c4 * i4 - l4 * s4, d3 = c4 * o4 + h4 * s4 + l4 * a4 - u5 * i4, m2 = h4 * o4 - l4 * i4 - u5 * a4 - c4 * s4;
          return r3.rotateY(t5, e4, n4), t5[4] = p4 * (o4 = t5[3]) + m2 * (i4 = t5[0]) + f3 * (s4 = t5[2]) - d3 * (a4 = t5[1]), t5[5] = f3 * o4 + m2 * a4 + d3 * i4 - p4 * s4, t5[6] = d3 * o4 + m2 * s4 + p4 * a4 - f3 * i4, t5[7] = m2 * o4 - p4 * i4 - f3 * a4 - d3 * s4, t5;
        }, P.rotateZ = function(t5, e4, n4) {
          var i4 = -e4[0], a4 = -e4[1], s4 = -e4[2], o4 = e4[3], l4 = e4[4], u5 = e4[5], c4 = e4[6], h4 = e4[7], p4 = l4 * o4 + h4 * i4 + u5 * s4 - c4 * a4, f3 = u5 * o4 + h4 * a4 + c4 * i4 - l4 * s4, d3 = c4 * o4 + h4 * s4 + l4 * a4 - u5 * i4, m2 = h4 * o4 - l4 * i4 - u5 * a4 - c4 * s4;
          return r3.rotateZ(t5, e4, n4), t5[4] = p4 * (o4 = t5[3]) + m2 * (i4 = t5[0]) + f3 * (s4 = t5[2]) - d3 * (a4 = t5[1]), t5[5] = f3 * o4 + m2 * a4 + d3 * i4 - p4 * s4, t5[6] = d3 * o4 + m2 * s4 + p4 * a4 - f3 * i4, t5[7] = m2 * o4 - p4 * i4 - f3 * a4 - d3 * s4, t5;
        }, P.rotateByQuatAppend = function(t5, e4, r4) {
          var n4 = r4[0], i4 = r4[1], a4 = r4[2], s4 = r4[3], o4 = e4[0], l4 = e4[1], u5 = e4[2], c4 = e4[3];
          return t5[0] = o4 * s4 + c4 * n4 + l4 * a4 - u5 * i4, t5[1] = l4 * s4 + c4 * i4 + u5 * n4 - o4 * a4, t5[2] = u5 * s4 + c4 * a4 + o4 * i4 - l4 * n4, t5[3] = c4 * s4 - o4 * n4 - l4 * i4 - u5 * a4, t5[4] = (o4 = e4[4]) * s4 + (c4 = e4[7]) * n4 + (l4 = e4[5]) * a4 - (u5 = e4[6]) * i4, t5[5] = l4 * s4 + c4 * i4 + u5 * n4 - o4 * a4, t5[6] = u5 * s4 + c4 * a4 + o4 * i4 - l4 * n4, t5[7] = c4 * s4 - o4 * n4 - l4 * i4 - u5 * a4, t5;
        }, P.rotateByQuatPrepend = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s4 = e4[3], o4 = r4[0], l4 = r4[1], u5 = r4[2], c4 = r4[3];
          return t5[0] = n4 * c4 + s4 * o4 + i4 * u5 - a4 * l4, t5[1] = i4 * c4 + s4 * l4 + a4 * o4 - n4 * u5, t5[2] = a4 * c4 + s4 * u5 + n4 * l4 - i4 * o4, t5[3] = s4 * c4 - n4 * o4 - i4 * l4 - a4 * u5, t5[4] = n4 * (c4 = r4[7]) + s4 * (o4 = r4[4]) + i4 * (u5 = r4[6]) - a4 * (l4 = r4[5]), t5[5] = i4 * c4 + s4 * l4 + a4 * o4 - n4 * u5, t5[6] = a4 * c4 + s4 * u5 + n4 * l4 - i4 * o4, t5[7] = s4 * c4 - n4 * o4 - i4 * l4 - a4 * u5, t5;
        }, P.rotateAroundAxis = function(t5, r4, n4, i4) {
          if (Math.abs(i4) < e3.EPSILON) return l3(t5, r4);
          var a4 = Math.hypot(n4[0], n4[1], n4[2]);
          i4 *= 0.5;
          var s4 = Math.sin(i4), o4 = s4 * n4[0] / a4, u5 = s4 * n4[1] / a4, c4 = s4 * n4[2] / a4, h4 = Math.cos(i4), p4 = r4[0], f3 = r4[1], d3 = r4[2], m2 = r4[3];
          t5[0] = p4 * h4 + m2 * o4 + f3 * c4 - d3 * u5, t5[1] = f3 * h4 + m2 * u5 + d3 * o4 - p4 * c4, t5[2] = d3 * h4 + m2 * c4 + p4 * u5 - f3 * o4, t5[3] = m2 * h4 - p4 * o4 - f3 * u5 - d3 * c4;
          var y2 = r4[4], g4 = r4[5], x2 = r4[6], v2 = r4[7];
          return t5[4] = y2 * h4 + v2 * o4 + g4 * c4 - x2 * u5, t5[5] = g4 * h4 + v2 * u5 + x2 * o4 - y2 * c4, t5[6] = x2 * h4 + v2 * c4 + y2 * u5 - g4 * o4, t5[7] = v2 * h4 - y2 * o4 - g4 * u5 - x2 * c4, t5;
        }, P.add = function(t5, e4, r4) {
          return t5[0] = e4[0] + r4[0], t5[1] = e4[1] + r4[1], t5[2] = e4[2] + r4[2], t5[3] = e4[3] + r4[3], t5[4] = e4[4] + r4[4], t5[5] = e4[5] + r4[5], t5[6] = e4[6] + r4[6], t5[7] = e4[7] + r4[7], t5;
        }, P.multiply = u4, P.scale = function(t5, e4, r4) {
          return t5[0] = e4[0] * r4, t5[1] = e4[1] * r4, t5[2] = e4[2] * r4, t5[3] = e4[3] * r4, t5[4] = e4[4] * r4, t5[5] = e4[5] * r4, t5[6] = e4[6] * r4, t5[7] = e4[7] * r4, t5;
        }, P.lerp = function(t5, e4, r4, n4) {
          var i4 = 1 - n4;
          return c3(e4, r4) < 0 && (n4 = -n4), t5[0] = e4[0] * i4 + r4[0] * n4, t5[1] = e4[1] * i4 + r4[1] * n4, t5[2] = e4[2] * i4 + r4[2] * n4, t5[3] = e4[3] * i4 + r4[3] * n4, t5[4] = e4[4] * i4 + r4[4] * n4, t5[5] = e4[5] * i4 + r4[5] * n4, t5[6] = e4[6] * i4 + r4[6] * n4, t5[7] = e4[7] * i4 + r4[7] * n4, t5;
        }, P.invert = function(t5, e4) {
          var r4 = p3(e4);
          return t5[0] = -e4[0] / r4, t5[1] = -e4[1] / r4, t5[2] = -e4[2] / r4, t5[3] = e4[3] / r4, t5[4] = -e4[4] / r4, t5[5] = -e4[5] / r4, t5[6] = -e4[6] / r4, t5[7] = e4[7] / r4, t5;
        }, P.conjugate = function(t5, e4) {
          return t5[0] = -e4[0], t5[1] = -e4[1], t5[2] = -e4[2], t5[3] = e4[3], t5[4] = -e4[4], t5[5] = -e4[5], t5[6] = -e4[6], t5[7] = e4[7], t5;
        }, P.normalize = function(t5, e4) {
          var r4 = p3(e4);
          if (r4 > 0) {
            r4 = Math.sqrt(r4);
            var n4 = e4[0] / r4, i4 = e4[1] / r4, a4 = e4[2] / r4, s4 = e4[3] / r4, o4 = e4[4], l4 = e4[5], u5 = e4[6], c4 = e4[7], h4 = n4 * o4 + i4 * l4 + a4 * u5 + s4 * c4;
            t5[0] = n4, t5[1] = i4, t5[2] = a4, t5[3] = s4, t5[4] = (o4 - n4 * h4) / r4, t5[5] = (l4 - i4 * h4) / r4, t5[6] = (u5 - a4 * h4) / r4, t5[7] = (c4 - s4 * h4) / r4;
          }
          return t5;
        }, P.str = function(t5) {
          return "quat2(" + t5[0] + ", " + t5[1] + ", " + t5[2] + ", " + t5[3] + ", " + t5[4] + ", " + t5[5] + ", " + t5[6] + ", " + t5[7] + ")";
        }, P.exactEquals = function(t5, e4) {
          return t5[0] === e4[0] && t5[1] === e4[1] && t5[2] === e4[2] && t5[3] === e4[3] && t5[4] === e4[4] && t5[5] === e4[5] && t5[6] === e4[6] && t5[7] === e4[7];
        }, P.equals = function(t5, r4) {
          var n4 = t5[0], i4 = t5[1], a4 = t5[2], s4 = t5[3], o4 = t5[4], l4 = t5[5], u5 = t5[6], c4 = t5[7], h4 = r4[0], p4 = r4[1], f3 = r4[2], d3 = r4[3], m2 = r4[4], y2 = r4[5], g4 = r4[6], x2 = r4[7];
          return Math.abs(n4 - h4) <= e3.EPSILON * Math.max(1, Math.abs(n4), Math.abs(h4)) && Math.abs(i4 - p4) <= e3.EPSILON * Math.max(1, Math.abs(i4), Math.abs(p4)) && Math.abs(a4 - f3) <= e3.EPSILON * Math.max(1, Math.abs(a4), Math.abs(f3)) && Math.abs(s4 - d3) <= e3.EPSILON * Math.max(1, Math.abs(s4), Math.abs(d3)) && Math.abs(o4 - m2) <= e3.EPSILON * Math.max(1, Math.abs(o4), Math.abs(m2)) && Math.abs(l4 - y2) <= e3.EPSILON * Math.max(1, Math.abs(l4), Math.abs(y2)) && Math.abs(u5 - g4) <= e3.EPSILON * Math.max(1, Math.abs(u5), Math.abs(g4)) && Math.abs(c4 - x2) <= e3.EPSILON * Math.max(1, Math.abs(c4), Math.abs(x2));
        }, P.sqrLen = P.squaredLength = P.len = P.length = P.dot = P.mul = P.setReal = P.getReal = void 0;
        var e3 = s3(a3()), r3 = s3(I2()), n3 = s3(g3());
        function i3(t5) {
          if ("function" != typeof WeakMap) return null;
          var e4 = /* @__PURE__ */ new WeakMap(), r4 = /* @__PURE__ */ new WeakMap();
          return (i3 = function(t6) {
            return t6 ? r4 : e4;
          })(t5);
        }
        function s3(e4, r4) {
          if (e4 && e4.__esModule) return e4;
          if (null === e4 || "object" !== t4(e4) && "function" != typeof e4) return { default: e4 };
          var n4 = i3(r4);
          if (n4 && n4.has(e4)) return n4.get(e4);
          var a4 = {}, s4 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var o4 in e4) if ("default" !== o4 && Object.prototype.hasOwnProperty.call(e4, o4)) {
            var l4 = s4 ? Object.getOwnPropertyDescriptor(e4, o4) : null;
            l4 && (l4.get || l4.set) ? Object.defineProperty(a4, o4, l4) : a4[o4] = e4[o4];
          }
          return a4.default = e4, n4 && n4.set(e4, a4), a4;
        }
        function o3(t5, e4, r4) {
          var n4 = 0.5 * r4[0], i4 = 0.5 * r4[1], a4 = 0.5 * r4[2], s4 = e4[0], o4 = e4[1], l4 = e4[2], u5 = e4[3];
          return t5[0] = s4, t5[1] = o4, t5[2] = l4, t5[3] = u5, t5[4] = n4 * u5 + i4 * l4 - a4 * o4, t5[5] = i4 * u5 + a4 * s4 - n4 * l4, t5[6] = a4 * u5 + n4 * o4 - i4 * s4, t5[7] = -n4 * s4 - i4 * o4 - a4 * l4, t5;
        }
        function l3(t5, e4) {
          return t5[0] = e4[0], t5[1] = e4[1], t5[2] = e4[2], t5[3] = e4[3], t5[4] = e4[4], t5[5] = e4[5], t5[6] = e4[6], t5[7] = e4[7], t5;
        }
        function u4(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1], a4 = e4[2], s4 = e4[3], o4 = r4[4], l4 = r4[5], u5 = r4[6], c4 = r4[7], h4 = e4[4], p4 = e4[5], f3 = e4[6], d3 = e4[7], m2 = r4[0], y2 = r4[1], g4 = r4[2], x2 = r4[3];
          return t5[0] = n4 * x2 + s4 * m2 + i4 * g4 - a4 * y2, t5[1] = i4 * x2 + s4 * y2 + a4 * m2 - n4 * g4, t5[2] = a4 * x2 + s4 * g4 + n4 * y2 - i4 * m2, t5[3] = s4 * x2 - n4 * m2 - i4 * y2 - a4 * g4, t5[4] = n4 * c4 + s4 * o4 + i4 * u5 - a4 * l4 + h4 * x2 + d3 * m2 + p4 * g4 - f3 * y2, t5[5] = i4 * c4 + s4 * l4 + a4 * o4 - n4 * u5 + p4 * x2 + d3 * y2 + f3 * m2 - h4 * g4, t5[6] = a4 * c4 + s4 * u5 + n4 * l4 - i4 * o4 + f3 * x2 + d3 * g4 + h4 * y2 - p4 * m2, t5[7] = s4 * c4 - n4 * o4 - i4 * l4 - a4 * u5 + d3 * x2 - h4 * m2 - p4 * y2 - f3 * g4, t5;
        }
        P.getReal = r3.copy, P.setReal = r3.copy, P.mul = u4;
        var c3 = r3.dot;
        P.dot = c3;
        var h3 = r3.length;
        P.length = h3, P.len = h3;
        var p3 = r3.squaredLength;
        return P.squaredLength = p3, P.sqrLen = p3, P;
      }
      var T2, E2, B3 = {};
      function V2() {
        if (T2) return B3;
        function t4(e4) {
          return t4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t5) {
            return typeof t5;
          } : function(t5) {
            return t5 && "function" == typeof Symbol && t5.constructor === Symbol && t5 !== Symbol.prototype ? "symbol" : typeof t5;
          }, t4(e4);
        }
        T2 = 1, Object.defineProperty(B3, "__esModule", { value: true }), B3.create = n3, B3.clone = function(t5) {
          var r4 = new e3.ARRAY_TYPE(2);
          return r4[0] = t5[0], r4[1] = t5[1], r4;
        }, B3.fromValues = function(t5, r4) {
          var n4 = new e3.ARRAY_TYPE(2);
          return n4[0] = t5, n4[1] = r4, n4;
        }, B3.copy = function(t5, e4) {
          return t5[0] = e4[0], t5[1] = e4[1], t5;
        }, B3.set = function(t5, e4, r4) {
          return t5[0] = e4, t5[1] = r4, t5;
        }, B3.add = function(t5, e4, r4) {
          return t5[0] = e4[0] + r4[0], t5[1] = e4[1] + r4[1], t5;
        }, B3.subtract = i3, B3.multiply = s3, B3.divide = o3, B3.ceil = function(t5, e4) {
          return t5[0] = Math.ceil(e4[0]), t5[1] = Math.ceil(e4[1]), t5;
        }, B3.floor = function(t5, e4) {
          return t5[0] = Math.floor(e4[0]), t5[1] = Math.floor(e4[1]), t5;
        }, B3.min = function(t5, e4, r4) {
          return t5[0] = Math.min(e4[0], r4[0]), t5[1] = Math.min(e4[1], r4[1]), t5;
        }, B3.max = function(t5, e4, r4) {
          return t5[0] = Math.max(e4[0], r4[0]), t5[1] = Math.max(e4[1], r4[1]), t5;
        }, B3.round = function(t5, e4) {
          return t5[0] = Math.round(e4[0]), t5[1] = Math.round(e4[1]), t5;
        }, B3.scale = function(t5, e4, r4) {
          return t5[0] = e4[0] * r4, t5[1] = e4[1] * r4, t5;
        }, B3.scaleAndAdd = function(t5, e4, r4, n4) {
          return t5[0] = e4[0] + r4[0] * n4, t5[1] = e4[1] + r4[1] * n4, t5;
        }, B3.distance = l3, B3.squaredDistance = u4, B3.length = c3, B3.squaredLength = h3, B3.negate = function(t5, e4) {
          return t5[0] = -e4[0], t5[1] = -e4[1], t5;
        }, B3.inverse = function(t5, e4) {
          return t5[0] = 1 / e4[0], t5[1] = 1 / e4[1], t5;
        }, B3.normalize = function(t5, e4) {
          var r4 = e4[0], n4 = e4[1], i4 = r4 * r4 + n4 * n4;
          return i4 > 0 && (i4 = 1 / Math.sqrt(i4)), t5[0] = e4[0] * i4, t5[1] = e4[1] * i4, t5;
        }, B3.dot = function(t5, e4) {
          return t5[0] * e4[0] + t5[1] * e4[1];
        }, B3.cross = function(t5, e4, r4) {
          var n4 = e4[0] * r4[1] - e4[1] * r4[0];
          return t5[0] = t5[1] = 0, t5[2] = n4, t5;
        }, B3.lerp = function(t5, e4, r4, n4) {
          var i4 = e4[0], a4 = e4[1];
          return t5[0] = i4 + n4 * (r4[0] - i4), t5[1] = a4 + n4 * (r4[1] - a4), t5;
        }, B3.random = function(t5, r4) {
          r4 = r4 || 1;
          var n4 = 2 * e3.RANDOM() * Math.PI;
          return t5[0] = Math.cos(n4) * r4, t5[1] = Math.sin(n4) * r4, t5;
        }, B3.transformMat2 = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1];
          return t5[0] = r4[0] * n4 + r4[2] * i4, t5[1] = r4[1] * n4 + r4[3] * i4, t5;
        }, B3.transformMat2d = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1];
          return t5[0] = r4[0] * n4 + r4[2] * i4 + r4[4], t5[1] = r4[1] * n4 + r4[3] * i4 + r4[5], t5;
        }, B3.transformMat3 = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1];
          return t5[0] = r4[0] * n4 + r4[3] * i4 + r4[6], t5[1] = r4[1] * n4 + r4[4] * i4 + r4[7], t5;
        }, B3.transformMat4 = function(t5, e4, r4) {
          var n4 = e4[0], i4 = e4[1];
          return t5[0] = r4[0] * n4 + r4[4] * i4 + r4[12], t5[1] = r4[1] * n4 + r4[5] * i4 + r4[13], t5;
        }, B3.rotate = function(t5, e4, r4, n4) {
          var i4 = e4[0] - r4[0], a4 = e4[1] - r4[1], s4 = Math.sin(n4), o4 = Math.cos(n4);
          return t5[0] = i4 * o4 - a4 * s4 + r4[0], t5[1] = i4 * s4 + a4 * o4 + r4[1], t5;
        }, B3.angle = function(t5, e4) {
          var r4 = t5[0], n4 = t5[1], i4 = e4[0], a4 = e4[1], s4 = Math.sqrt(r4 * r4 + n4 * n4) * Math.sqrt(i4 * i4 + a4 * a4);
          return Math.acos(Math.min(Math.max(s4 && (r4 * i4 + n4 * a4) / s4, -1), 1));
        }, B3.zero = function(t5) {
          return t5[0] = 0, t5[1] = 0, t5;
        }, B3.str = function(t5) {
          return "vec2(" + t5[0] + ", " + t5[1] + ")";
        }, B3.exactEquals = function(t5, e4) {
          return t5[0] === e4[0] && t5[1] === e4[1];
        }, B3.equals = function(t5, r4) {
          var n4 = t5[0], i4 = t5[1], a4 = r4[0], s4 = r4[1];
          return Math.abs(n4 - a4) <= e3.EPSILON * Math.max(1, Math.abs(n4), Math.abs(a4)) && Math.abs(i4 - s4) <= e3.EPSILON * Math.max(1, Math.abs(i4), Math.abs(s4));
        }, B3.forEach = B3.sqrLen = B3.sqrDist = B3.dist = B3.div = B3.mul = B3.sub = B3.len = void 0;
        var e3 = function(e4, n4) {
          if (e4 && e4.__esModule) return e4;
          if (null === e4 || "object" !== t4(e4) && "function" != typeof e4) return { default: e4 };
          var i4 = r3(void 0);
          if (i4 && i4.has(e4)) return i4.get(e4);
          var a4 = {}, s4 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var o4 in e4) if ("default" !== o4 && Object.prototype.hasOwnProperty.call(e4, o4)) {
            var l4 = s4 ? Object.getOwnPropertyDescriptor(e4, o4) : null;
            l4 && (l4.get || l4.set) ? Object.defineProperty(a4, o4, l4) : a4[o4] = e4[o4];
          }
          return a4.default = e4, i4 && i4.set(e4, a4), a4;
        }(a3());
        function r3(t5) {
          if ("function" != typeof WeakMap) return null;
          var e4 = /* @__PURE__ */ new WeakMap(), n4 = /* @__PURE__ */ new WeakMap();
          return (r3 = function(t6) {
            return t6 ? n4 : e4;
          })(t5);
        }
        function n3() {
          var t5 = new e3.ARRAY_TYPE(2);
          return e3.ARRAY_TYPE != Float32Array && (t5[0] = 0, t5[1] = 0), t5;
        }
        function i3(t5, e4, r4) {
          return t5[0] = e4[0] - r4[0], t5[1] = e4[1] - r4[1], t5;
        }
        function s3(t5, e4, r4) {
          return t5[0] = e4[0] * r4[0], t5[1] = e4[1] * r4[1], t5;
        }
        function o3(t5, e4, r4) {
          return t5[0] = e4[0] / r4[0], t5[1] = e4[1] / r4[1], t5;
        }
        function l3(t5, e4) {
          return Math.hypot(e4[0] - t5[0], e4[1] - t5[1]);
        }
        function u4(t5, e4) {
          var r4 = e4[0] - t5[0], n4 = e4[1] - t5[1];
          return r4 * r4 + n4 * n4;
        }
        function c3(t5) {
          return Math.hypot(t5[0], t5[1]);
        }
        function h3(t5) {
          var e4 = t5[0], r4 = t5[1];
          return e4 * e4 + r4 * r4;
        }
        B3.len = c3, B3.sub = i3, B3.mul = s3, B3.div = o3, B3.dist = l3, B3.sqrDist = u4, B3.sqrLen = h3;
        var p3, f3 = (p3 = n3(), function(t5, e4, r4, n4, i4, a4) {
          var s4, o4;
          for (e4 || (e4 = 2), r4 || (r4 = 0), o4 = n4 ? Math.min(n4 * e4 + r4, t5.length) : t5.length, s4 = r4; s4 < o4; s4 += e4) p3[0] = t5[s4], p3[1] = t5[s4 + 1], i4(p3, p3, a4), t5[s4] = p3[0], t5[s4 + 1] = p3[1];
          return t5;
        });
        return B3.forEach = f3, B3;
      }
      function C2() {
        if (E2) return n2;
        function t4(e4) {
          return t4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t5) {
            return typeof t5;
          } : function(t5) {
            return t5 && "function" == typeof Symbol && t5.constructor === Symbol && t5 !== Symbol.prototype ? "symbol" : typeof t5;
          }, t4(e4);
        }
        E2 = 1, Object.defineProperty(n2, "__esModule", { value: true }), n2.vec4 = n2.vec3 = n2.vec2 = n2.quat2 = n2.quat = n2.mat4 = n2.mat3 = n2.mat2d = n2.mat2 = n2.glMatrix = void 0;
        var e3 = x2(a3());
        n2.glMatrix = e3;
        var r3 = x2(l2());
        n2.mat2 = r3;
        var i3 = x2(h2());
        n2.mat2d = i3;
        var s3 = x2(d2());
        n2.mat3 = s3;
        var o3 = x2(g3());
        n2.mat4 = o3;
        var u4 = x2(I2());
        n2.quat = u4;
        var c3 = x2(k());
        n2.quat2 = c3;
        var p3 = x2(V2());
        n2.vec2 = p3;
        var f3 = x2(w());
        n2.vec3 = f3;
        var m2 = x2(S());
        function y2(t5) {
          if ("function" != typeof WeakMap) return null;
          var e4 = /* @__PURE__ */ new WeakMap(), r4 = /* @__PURE__ */ new WeakMap();
          return (y2 = function(t6) {
            return t6 ? r4 : e4;
          })(t5);
        }
        function x2(e4, r4) {
          if (e4 && e4.__esModule) return e4;
          if (null === e4 || "object" !== t4(e4) && "function" != typeof e4) return { default: e4 };
          var n3 = y2(r4);
          if (n3 && n3.has(e4)) return n3.get(e4);
          var i4 = {}, a4 = Object.defineProperty && Object.getOwnPropertyDescriptor;
          for (var s4 in e4) if ("default" !== s4 && Object.prototype.hasOwnProperty.call(e4, s4)) {
            var o4 = a4 ? Object.getOwnPropertyDescriptor(e4, s4) : null;
            o4 && (o4.get || o4.set) ? Object.defineProperty(i4, s4, o4) : i4[s4] = e4[s4];
          }
          return i4.default = e4, n3 && n3.set(e4, i4), i4;
        }
        return n2.vec4 = m2, n2;
      }
      var R2, D, L2, F2, O = C2(), U2 = function() {
        if (D) return R2;
        function t4(t5, e3, r3, n3) {
          this.cx = 3 * t5, this.bx = 3 * (r3 - t5) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e3, this.by = 3 * (n3 - e3) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t5, this.p1y = e3, this.p2x = r3, this.p2y = n3;
        }
        return D = 1, R2 = t4, t4.prototype = { sampleCurveX: function(t5) {
          return ((this.ax * t5 + this.bx) * t5 + this.cx) * t5;
        }, sampleCurveY: function(t5) {
          return ((this.ay * t5 + this.by) * t5 + this.cy) * t5;
        }, sampleCurveDerivativeX: function(t5) {
          return (3 * this.ax * t5 + 2 * this.bx) * t5 + this.cx;
        }, solveCurveX: function(t5, e3) {
          if (void 0 === e3 && (e3 = 1e-6), t5 < 0) return 0;
          if (t5 > 1) return 1;
          for (var r3 = t5, n3 = 0; n3 < 8; n3++) {
            var i3 = this.sampleCurveX(r3) - t5;
            if (Math.abs(i3) < e3) return r3;
            var a4 = this.sampleCurveDerivativeX(r3);
            if (Math.abs(a4) < 1e-6) break;
            r3 -= i3 / a4;
          }
          var s3 = 0, o3 = 1;
          for (r3 = t5, n3 = 0; n3 < 20 && (i3 = this.sampleCurveX(r3), !(Math.abs(i3 - t5) < e3)); n3++) t5 > i3 ? s3 = r3 : o3 = r3, r3 = 0.5 * (o3 - s3) + s3;
          return r3;
        }, solve: function(t5, e3) {
          return this.sampleCurveY(this.solveCurveX(t5, e3));
        } }, R2;
      }(), j = e2(U2);
      function N() {
        if (F2) return L2;
        function t4(t5, e3) {
          this.x = t5, this.y = e3;
        }
        return F2 = 1, L2 = t4, t4.prototype = { clone: function() {
          return new t4(this.x, this.y);
        }, add: function(t5) {
          return this.clone()._add(t5);
        }, sub: function(t5) {
          return this.clone()._sub(t5);
        }, multByPoint: function(t5) {
          return this.clone()._multByPoint(t5);
        }, divByPoint: function(t5) {
          return this.clone()._divByPoint(t5);
        }, mult: function(t5) {
          return this.clone()._mult(t5);
        }, div: function(t5) {
          return this.clone()._div(t5);
        }, rotate: function(t5) {
          return this.clone()._rotate(t5);
        }, rotateAround: function(t5, e3) {
          return this.clone()._rotateAround(t5, e3);
        }, matMult: function(t5) {
          return this.clone()._matMult(t5);
        }, unit: function() {
          return this.clone()._unit();
        }, perp: function() {
          return this.clone()._perp();
        }, round: function() {
          return this.clone()._round();
        }, mag: function() {
          return Math.sqrt(this.x * this.x + this.y * this.y);
        }, equals: function(t5) {
          return this.x === t5.x && this.y === t5.y;
        }, dist: function(t5) {
          return Math.sqrt(this.distSqr(t5));
        }, distSqr: function(t5) {
          var e3 = t5.x - this.x, r3 = t5.y - this.y;
          return e3 * e3 + r3 * r3;
        }, angle: function() {
          return Math.atan2(this.y, this.x);
        }, angleTo: function(t5) {
          return Math.atan2(this.y - t5.y, this.x - t5.x);
        }, angleWith: function(t5) {
          return this.angleWithSep(t5.x, t5.y);
        }, angleWithSep: function(t5, e3) {
          return Math.atan2(this.x * e3 - this.y * t5, this.x * t5 + this.y * e3);
        }, _matMult: function(t5) {
          var e3 = t5[2] * this.x + t5[3] * this.y;
          return this.x = t5[0] * this.x + t5[1] * this.y, this.y = e3, this;
        }, _add: function(t5) {
          return this.x += t5.x, this.y += t5.y, this;
        }, _sub: function(t5) {
          return this.x -= t5.x, this.y -= t5.y, this;
        }, _mult: function(t5) {
          return this.x *= t5, this.y *= t5, this;
        }, _div: function(t5) {
          return this.x /= t5, this.y /= t5, this;
        }, _multByPoint: function(t5) {
          return this.x *= t5.x, this.y *= t5.y, this;
        }, _divByPoint: function(t5) {
          return this.x /= t5.x, this.y /= t5.y, this;
        }, _unit: function() {
          return this._div(this.mag()), this;
        }, _perp: function() {
          var t5 = this.y;
          return this.y = this.x, this.x = -t5, this;
        }, _rotate: function(t5) {
          var e3 = Math.cos(t5), r3 = Math.sin(t5), n3 = r3 * this.x + e3 * this.y;
          return this.x = e3 * this.x - r3 * this.y, this.y = n3, this;
        }, _rotateAround: function(t5, e3) {
          var r3 = Math.cos(t5), n3 = Math.sin(t5), i3 = e3.y + n3 * (this.x - e3.x) + r3 * (this.y - e3.y);
          return this.x = e3.x + r3 * (this.x - e3.x) - n3 * (this.y - e3.y), this.y = i3, this;
        }, _round: function() {
          return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
        } }, t4.convert = function(e3) {
          return e3 instanceof t4 ? e3 : Array.isArray(e3) ? new t4(e3[0], e3[1]) : e3;
        }, L2;
      }
      var q = e2(N());
      function $2(t4, e3) {
        if (Array.isArray(t4)) {
          if (!Array.isArray(e3) || t4.length !== e3.length) return false;
          for (let r3 = 0; r3 < t4.length; r3++) if (!$2(t4[r3], e3[r3])) return false;
          return true;
        }
        if ("object" == typeof t4 && null !== t4 && null !== e3) {
          if ("object" != typeof e3) return false;
          if (Object.keys(t4).length !== Object.keys(e3).length) return false;
          for (const r3 in t4) if (!$2(t4[r3], e3[r3])) return false;
          return true;
        }
        return t4 === e3;
      }
      const G = Math.PI / 180, X = 180 / Math.PI;
      function Y(t4) {
        return t4 * G;
      }
      function Z2(t4) {
        return t4 * X;
      }
      const W = [[0, 0], [1, 0], [1, 1], [0, 1]];
      function H(t4) {
        if (t4 <= 0) return 0;
        if (t4 >= 1) return 1;
        const e3 = t4 * t4, r3 = e3 * t4;
        return 4 * (t4 < 0.5 ? r3 : 3 * (t4 - e3) + r3 - 0.75);
      }
      function K(t4, e3, r3, n3) {
        const i3 = new j(t4, e3, r3, n3);
        return function(t5) {
          return i3.solve(t5);
        };
      }
      const J = K(0.25, 0.1, 0.25, 1);
      function Q2(t4, e3, r3) {
        return Math.min(r3, Math.max(e3, t4));
      }
      function tt(t4, e3, r3) {
        return (r3 = Q2((r3 - t4) / (e3 - t4), 0, 1)) * r3 * (3 - 2 * r3);
      }
      function et2(t4, e3, r3) {
        const n3 = r3 - e3, i3 = ((t4 - e3) % n3 + n3) % n3 + e3;
        return i3 === e3 ? r3 : i3;
      }
      function rt(t4, e3, r3) {
        if (!t4.length) return r3(null, []);
        let n3 = t4.length;
        const i3 = new Array(t4.length);
        let a4 = null;
        t4.forEach((t5, s3) => {
          e3(t5, (t6, e4) => {
            t6 && (a4 = t6), i3[s3] = e4, 0 == --n3 && r3(a4, i3);
          });
        });
      }
      function nt(t4, ...e3) {
        for (const r3 of e3) for (const e4 in r3) t4[e4] = r3[e4];
        return t4;
      }
      let it2 = 1;
      function at() {
        return it2++;
      }
      function st(t4) {
        return t4 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t4) / Math.LN2));
      }
      function ot(t4, e3) {
        t4.forEach((t5) => {
          e3[t5] && (e3[t5] = e3[t5].bind(e3));
        });
      }
      function lt2(t4, e3) {
        return -1 !== t4.indexOf(e3, t4.length - e3.length);
      }
      function ut(t4, e3, r3) {
        const n3 = {};
        for (const r4 in t4) n3[r4] = e3.call(this, t4[r4], r4, t4);
        return n3;
      }
      function ct2(t4, e3, r3) {
        const n3 = {};
        for (const r4 in t4) e3.call(this, t4[r4], r4, t4) && (n3[r4] = t4[r4]);
        return n3;
      }
      function ht(t4) {
        return Array.isArray(t4) ? t4.map(ht) : "object" == typeof t4 && t4 ? ut(t4, ht) : t4;
      }
      const pt2 = {};
      function ft(t4) {
        pt2[t4] || ("undefined" != typeof console && console.warn(t4), pt2[t4] = true);
      }
      function dt(t4, e3, r3) {
        return (r3.y - t4.y) * (e3.x - t4.x) > (e3.y - t4.y) * (r3.x - t4.x);
      }
      function mt(t4) {
        let e3 = 0;
        for (let r3, n3, i3 = 0, a4 = t4.length, s3 = a4 - 1; i3 < a4; s3 = i3++) r3 = t4[i3], n3 = t4[s3], e3 += (n3.x - r3.x) * (r3.y + n3.y);
        return e3;
      }
      function yt2([t4, e3, r3]) {
        const n3 = Y(e3 + 90), i3 = Y(r3);
        return { x: t4 * Math.cos(n3) * Math.sin(i3), y: t4 * Math.sin(n3) * Math.sin(i3), z: t4 * Math.cos(i3), azimuthal: e3, polar: r3 };
      }
      function gt() {
        return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
      }
      function xt2(t4) {
        const e3 = {};
        if (t4.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t5, r3, n3, i3) => {
          const a4 = n3 || i3;
          return e3[r3] = !a4 || a4.toLowerCase(), "";
        }), e3["max-age"]) {
          const t5 = parseInt(e3["max-age"], 10);
          isNaN(t5) ? delete e3["max-age"] : e3["max-age"] = t5;
        }
        return e3;
      }
      let vt = null;
      function bt(t4, e3) {
        return [t4[4 * e3], t4[4 * e3 + 1], t4[4 * e3 + 2], t4[4 * e3 + 3]];
      }
      function wt2(t4, e3, r3, n3) {
        for (; e3 < r3; ) {
          const i3 = e3 + r3 >> 1;
          t4[i3] < n3 ? e3 = i3 + 1 : r3 = i3;
        }
        return e3;
      }
      function _t(t4, e3, r3, n3) {
        for (; e3 < r3; ) {
          const i3 = e3 + r3 >> 1;
          t4[i3] <= n3 ? e3 = i3 + 1 : r3 = i3;
        }
        return e3;
      }
      function Mt(t4) {
        return t4 > 0 ? 1 / (1.001 - t4) : 1 + t4;
      }
      function At(t4) {
        return t4 > 0 ? 1 - 1 / (1.001 - t4) : -t4;
      }
      const St = { API_URL: "https://api.mapbox.com", get API_URL_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
      }, get API_TILEJSON_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i;
      }, get API_SPRITE_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i;
      }, get API_FONTS_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i;
      }, get API_STYLE_REGEX() {
        return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i;
      }, get API_CDN_URL_REGEX() {
        return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i;
      }, get EVENTS_URL() {
        if (!St.API_URL) return null;
        try {
          const t4 = new URL(St.API_URL);
          return "api.mapbox.cn" === t4.hostname ? "https://events.mapbox.cn/events/v2" : "api.mapbox.com" === t4.hostname ? "https://events.mapbox.com/events/v2" : null;
        } catch (t4) {
          return null;
        }
      }, SESSION_PATH: "/map-sessions/v1", FEEDBACK_URL: "https://apps.mapbox.com/feedback", TILE_URL_VERSION: "v4", RASTER_URL_PREFIX: "raster/v1", RASTERARRAYS_URL_PREFIX: "rasterarrays/v1", REQUIRE_ACCESS_TOKEN: true, ACCESS_TOKEN: null, DEFAULT_STYLE: "mapbox://styles/mapbox/standard", MAX_PARALLEL_IMAGE_REQUESTS: 16, DRACO_URL: "https://api.mapbox.com/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm", MESHOPT_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_base_v0.20.wasm", MESHOPT_SIMD_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_simd_v0.20.wasm", GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf", TILES3D_URL_PREFIX: "3dtiles/v1" };
      function It(t4) {
        return St.API_URL_REGEX.test(t4);
      }
      function zt(t4) {
        return St.API_SPRITE_REGEX.test(t4);
      }
      let Pt, kt, Tt, Et, Bt, Vt;
      function Ct2() {
        return null == Pt && (Pt = self.OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof self.createImageBitmap), Pt;
      }
      const Rt = { now: () => void 0 !== Et ? Et : performance.now(), setNow(t4) {
        Et = t4;
      }, restoreNow() {
        Et = void 0;
      }, frame(t4) {
        const e3 = requestAnimationFrame(t4);
        return { cancel: () => cancelAnimationFrame(e3) };
      }, getImageData(t4, e3 = 0) {
        const { width: r3, height: n3 } = t4;
        Bt || (Bt = document.createElement("canvas"));
        const i3 = Bt.getContext("2d", { willReadFrequently: true });
        if (!i3) throw new Error("failed to create canvas 2d context");
        return (r3 > Bt.width || n3 > Bt.height) && (Bt.width = r3, Bt.height = n3), i3.clearRect(-e3, -e3, r3 + 2 * e3, n3 + 2 * e3), i3.drawImage(t4, 0, 0, r3, n3), i3.getImageData(-e3, -e3, r3 + 2 * e3, n3 + 2 * e3);
      }, resolveURL: (t4) => (kt || (kt = document.createElement("a")), kt.href = t4, kt.href), get devicePixelRatio() {
        return window.devicePixelRatio;
      }, get prefersReducedMotion() {
        return !!window.matchMedia && (null == Tt && (Tt = window.matchMedia("(prefers-reduced-motion: reduce)")), Tt.matches);
      }, hasCanvasFingerprintNoise() {
        if (void 0 !== Vt) return Vt;
        if (!Ct2()) return Vt = false, false;
        const t4 = new OffscreenCanvas(85, 1), e3 = t4.getContext("2d", { willReadFrequently: true });
        let r3 = 0;
        for (let n4 = 0; n4 < t4.width; ++n4) e3.fillStyle = `rgba(${r3++},${r3++},${r3++}, 255)`, e3.fillRect(n4, 0, 1, 1);
        const n3 = e3.getImageData(0, 0, t4.width, t4.height);
        r3 = 0;
        for (let t5 = 0; t5 < n3.data.length; ++t5) if (t5 % 4 != 3 && r3++ !== n3.data[t5]) return Vt = true, true;
        return Vt = false, false;
      } };
      function Dt(t4, e3) {
        const r3 = t4.indexOf("?");
        if (r3 < 0) return `${t4}?${new URLSearchParams(e3).toString()}`;
        const n3 = new URLSearchParams(t4.slice(r3));
        for (const t5 in e3) n3.set(t5, e3[t5]);
        return `${t4.slice(0, r3)}?${n3.toString()}`;
      }
      function Lt(t4, e3 = { persistentParams: [] }) {
        const r3 = t4.indexOf("?");
        if (r3 < 0) return t4;
        const n3 = new URLSearchParams(), i3 = new URLSearchParams(t4.slice(r3));
        for (const t5 of e3.persistentParams) {
          const e4 = i3.get(t5);
          e4 && n3.set(t5, e4);
        }
        const a4 = n3.toString();
        return `${t4.slice(0, r3)}${a4.length > 0 ? `?${a4}` : ""}`;
      }
      const Ft2 = "mapbox-tiles";
      let Ot = 500, Ut = 50;
      const jt = ["language", "worldview", "jobid"];
      let Nt, qt;
      function $t() {
        try {
          return caches;
        } catch (t4) {
        }
      }
      function Gt() {
        const t4 = $t();
        t4 && null == Nt && (Nt = t4.open(Ft2));
      }
      let Xt = 1 / 0;
      const Yt = { supported: false, testSupport: function(t4) {
        !Ht && Wt && (Kt ? Qt(t4) : Zt = t4);
      } };
      let Zt, Wt, Ht = false, Kt = false;
      const Jt = "undefined" != typeof self ? self : {};
      function Qt(t4) {
        const e3 = t4.createTexture();
        t4.bindTexture(t4.TEXTURE_2D, e3);
        try {
          if (t4.texImage2D(t4.TEXTURE_2D, 0, t4.RGBA, t4.RGBA, t4.UNSIGNED_BYTE, Wt), t4.isContextLost()) return;
          Yt.supported = true;
        } catch (t5) {
        }
        t4.deleteTexture(e3), Ht = true;
      }
      Jt.document && (Wt = Jt.document.createElement("img"), Wt.onload = function() {
        Zt && Qt(Zt), Zt = null, Kt = true;
      }, Wt.onerror = function() {
        Ht = true, Zt = null;
      }, Wt.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
      const te2 = { Unknown: "Unknown", Style: "Style", Source: "Source", Tile: "Tile", Glyphs: "Glyphs", SpriteImage: "SpriteImage", SpriteJSON: "SpriteJSON", Image: "Image", Model: "Model" };
      "function" == typeof Object.freeze && Object.freeze(te2);
      class ee extends Error {
        constructor(t4, e3, r3) {
          401 === e3 && It(r3) && (t4 += ": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"), super(t4), this.status = e3, this.url = r3;
        }
        toString() {
          return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
        }
      }
      const re = gt() ? () => self.worker && self.worker.referrer : () => ("blob:" === location.protocol ? parent : self).location.href;
      const ne = function(t4, e3) {
        if (!(/^file:/.test(r3 = t4.url) || /^file:/.test(re()) && !/^\w+:/.test(r3))) {
          if (self.fetch && self.Request && self.AbortController && Request.prototype.hasOwnProperty("signal")) return function(t5, e4) {
            const r4 = new AbortController(), n3 = new Request(t5.url, { method: t5.method || "GET", body: t5.body, credentials: t5.credentials, headers: t5.headers, referrer: re(), referrerPolicy: t5.referrerPolicy, signal: r4.signal });
            let i3 = false, a4 = false;
            const s3 = (o3 = n3.url).indexOf("sku=") > 0 && It(o3);
            var o3;
            "json" === t5.type && n3.headers.set("Accept", "application/json");
            const l3 = (r5, i4, o4) => {
              if (a4) return;
              if (r5 && "SecurityError" !== r5.message && ft(r5.toString()), i4 && o4) return u4(i4);
              const l4 = Date.now();
              fetch(n3).then((r6) => {
                if (r6.ok) {
                  const t6 = s3 ? r6.clone() : null;
                  return u4(r6, t6, l4);
                }
                return e4(new ee(r6.statusText, r6.status, t5.url));
              }).catch((r6) => {
                "AbortError" !== r6.name && e4(new Error(`${r6.message} ${t5.url}`));
              });
            }, u4 = (r5, s4, o4) => {
              ("arrayBuffer" === t5.type ? r5.arrayBuffer() : "json" === t5.type ? r5.json() : r5.text()).then((t6) => {
                a4 || (s4 && o4 && function(t7, e5, r6) {
                  if (Gt(), null == Nt) return;
                  const n4 = xt2(e5.headers.get("Cache-Control") || "");
                  if (n4["no-store"]) return;
                  const i4 = { status: e5.status, statusText: e5.statusText, headers: new Headers() };
                  e5.headers.forEach((t8, e6) => i4.headers.set(e6, t8)), n4["max-age"] && i4.headers.set("Expires", new Date(r6 + 1e3 * n4["max-age"]).toUTCString());
                  const a5 = i4.headers.get("Expires");
                  if (!a5) return;
                  if (new Date(a5).getTime() - r6 < 42e4) return;
                  let s5 = Lt(t7.url, { persistentParams: jt });
                  if (206 === e5.status) {
                    const e6 = t7.headers.get("Range");
                    if (!e6) return;
                    i4.status = 200, s5 = Dt(s5, { range: e6 });
                  }
                  !function(t8, e6) {
                    if (void 0 === qt) try {
                      new Response(new ReadableStream()), qt = true;
                    } catch (t9) {
                      qt = false;
                    }
                    qt ? e6(t8.body) : t8.blob().then(e6);
                  }(e5, (t8) => {
                    const r7 = new Response(200 !== (n5 = e5.status) && 404 !== n5 && [101, 103, 204, 205, 304].includes(n5) ? null : t8, i4);
                    var n5;
                    Gt(), null != Nt && Nt.then((t9) => t9.put(s5, r7)).catch((t9) => ft(t9.message));
                  });
                }(n3, s4, o4), i3 = true, e4(null, t6, r5.headers.get("Cache-Control"), r5.headers.get("Expires")));
              }).catch((t6) => {
                a4 || e4(new Error(t6.message));
              });
            };
            return s3 ? function(t6, e5) {
              if (Gt(), null == Nt) return e5(null);
              Nt.then((r5) => {
                let n4 = Lt(t6.url, { persistentParams: jt });
                const i4 = t6.headers.get("Range");
                i4 && (n4 = Dt(n4, { range: i4 })), r5.match(n4).then((t7) => {
                  const i5 = function(t8) {
                    if (!t8) return false;
                    const e6 = new Date(t8.headers.get("Expires") || 0), r6 = xt2(t8.headers.get("Cache-Control") || "");
                    return e6 > Date.now() && !r6["no-cache"];
                  }(t7);
                  r5.delete(n4), i5 && r5.put(n4, t7.clone()), e5(null, t7, i5);
                }).catch(e5);
              }).catch(e5);
            }(n3, l3) : l3(null, null), { cancel: () => {
              a4 = true, i3 || r4.abort();
            } };
          }(t4, e3);
          if (gt() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", t4, e3, void 0, true);
        }
        var r3;
        return function(t5, e4) {
          const r4 = new XMLHttpRequest();
          r4.open(t5.method || "GET", t5.url, true), "arrayBuffer" === t5.type && (r4.responseType = "arraybuffer");
          for (const e5 in t5.headers) r4.setRequestHeader(e5, t5.headers[e5]);
          return "json" === t5.type && (r4.responseType = "text", r4.setRequestHeader("Accept", "application/json")), r4.withCredentials = "include" === t5.credentials, r4.onerror = () => {
            e4(new Error(r4.statusText));
          }, r4.onload = () => {
            if ((r4.status >= 200 && r4.status < 300 || 0 === r4.status) && null !== r4.response) {
              let n3 = r4.response;
              if ("json" === t5.type) try {
                n3 = JSON.parse(r4.response);
              } catch (t6) {
                return e4(t6);
              }
              e4(null, n3, r4.getResponseHeader("Cache-Control"), r4.getResponseHeader("Expires"));
            } else e4(new ee(r4.statusText, r4.status, t5.url));
          }, r4.send(t5.body), { cancel: () => r4.abort() };
        }(t4, e3);
      }, ie = function(t4, e3) {
        return ne(nt(t4, { type: "arrayBuffer" }), e3);
      };
      function ae2(t4) {
        const e3 = document.createElement("a");
        return e3.href = t4, e3.protocol === location.protocol && e3.host === location.host;
      }
      const se = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
      let oe, le;
      oe = [], le = 0;
      const ue2 = function(t4, e3) {
        if (Yt.supported && (t4.headers || (t4.headers = {}), t4.headers.accept = "image/webp,*/*"), le >= St.MAX_PARALLEL_IMAGE_REQUESTS) {
          const r4 = { requestParameters: t4, callback: e3, cancelled: false, cancel() {
            this.cancelled = true;
          } };
          return oe.push(r4), r4;
        }
        le++;
        let r3 = false;
        const n3 = () => {
          if (!r3) for (r3 = true, le--; oe.length && le < St.MAX_PARALLEL_IMAGE_REQUESTS; ) {
            const t5 = oe.shift(), { requestParameters: e4, callback: r4, cancelled: n4 } = t5;
            n4 || (t5.cancel = ue2(e4, r4).cancel);
          }
        }, i3 = ie(t4, (t5, r4, i4, a4) => {
          n3(), t5 ? e3(t5) : r4 && (self.createImageBitmap ? function(t6, e4) {
            const r5 = new Blob([new Uint8Array(t6)], { type: "image/png" });
            createImageBitmap(r5).then((t7) => {
              e4(null, t7);
            }).catch((t7) => {
              e4(new Error(`Could not load image because of ${t7.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
            });
          }(r4, (t6, r5) => e3(t6, r5, i4, a4)) : function(t6, e4) {
            const r5 = new Image();
            r5.onload = () => {
              e4(null, r5), URL.revokeObjectURL(r5.src), r5.onload = null, requestAnimationFrame(() => {
                r5.src = se;
              });
            }, r5.onerror = () => e4(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
            const n4 = new Blob([new Uint8Array(t6)], { type: "image/png" });
            r5.src = t6.byteLength ? URL.createObjectURL(n4) : se;
          }(r4, (t6, r5) => e3(t6, r5, i4, a4)));
        });
        return { cancel: () => {
          i3.cancel(), n3();
        } };
      };
      var ce, he, pe, fe = { exports: {} }, de = { exports: {} }, me = { exports: {} }, ye = function() {
        if (pe) return fe.exports;
        pe = 1;
        var t4 = (ce || (ce = 1, de.exports = function(t5, e4) {
          var r3, n3, i3, a4, s3, o3, l3, u4;
          for (n3 = t5.length - (r3 = 3 & t5.length), i3 = e4, s3 = 3432918353, o3 = 461845907, u4 = 0; u4 < n3; ) l3 = 255 & t5.charCodeAt(u4) | (255 & t5.charCodeAt(++u4)) << 8 | (255 & t5.charCodeAt(++u4)) << 16 | (255 & t5.charCodeAt(++u4)) << 24, ++u4, i3 = 27492 + (65535 & (a4 = 5 * (65535 & (i3 = (i3 ^= l3 = (65535 & (l3 = (l3 = (65535 & l3) * s3 + (((l3 >>> 16) * s3 & 65535) << 16) & 4294967295) << 15 | l3 >>> 17)) * o3 + (((l3 >>> 16) * o3 & 65535) << 16) & 4294967295) << 13 | i3 >>> 19)) + ((5 * (i3 >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (a4 >>> 16) & 65535) << 16);
          switch (l3 = 0, r3) {
            case 3:
              l3 ^= (255 & t5.charCodeAt(u4 + 2)) << 16;
            case 2:
              l3 ^= (255 & t5.charCodeAt(u4 + 1)) << 8;
            case 1:
              i3 ^= l3 = (65535 & (l3 = (l3 = (65535 & (l3 ^= 255 & t5.charCodeAt(u4))) * s3 + (((l3 >>> 16) * s3 & 65535) << 16) & 4294967295) << 15 | l3 >>> 17)) * o3 + (((l3 >>> 16) * o3 & 65535) << 16) & 4294967295;
          }
          return i3 ^= t5.length, i3 = 2246822507 * (65535 & (i3 ^= i3 >>> 16)) + ((2246822507 * (i3 >>> 16) & 65535) << 16) & 4294967295, i3 = 3266489909 * (65535 & (i3 ^= i3 >>> 13)) + ((3266489909 * (i3 >>> 16) & 65535) << 16) & 4294967295, (i3 ^= i3 >>> 16) >>> 0;
        }), de.exports), e3 = (he || (he = 1, me.exports = function(t5, e4) {
          for (var r3, n3 = t5.length, i3 = e4 ^ n3, a4 = 0; n3 >= 4; ) r3 = 1540483477 * (65535 & (r3 = 255 & t5.charCodeAt(a4) | (255 & t5.charCodeAt(++a4)) << 8 | (255 & t5.charCodeAt(++a4)) << 16 | (255 & t5.charCodeAt(++a4)) << 24)) + ((1540483477 * (r3 >>> 16) & 65535) << 16), i3 = 1540483477 * (65535 & i3) + ((1540483477 * (i3 >>> 16) & 65535) << 16) ^ (r3 = 1540483477 * (65535 & (r3 ^= r3 >>> 24)) + ((1540483477 * (r3 >>> 16) & 65535) << 16)), n3 -= 4, ++a4;
          switch (n3) {
            case 3:
              i3 ^= (255 & t5.charCodeAt(a4 + 2)) << 16;
            case 2:
              i3 ^= (255 & t5.charCodeAt(a4 + 1)) << 8;
            case 1:
              i3 = 1540483477 * (65535 & (i3 ^= 255 & t5.charCodeAt(a4))) + ((1540483477 * (i3 >>> 16) & 65535) << 16);
          }
          return i3 = 1540483477 * (65535 & (i3 ^= i3 >>> 13)) + ((1540483477 * (i3 >>> 16) & 65535) << 16), (i3 ^= i3 >>> 15) >>> 0;
        }), me.exports);
        return fe.exports = t4, fe.exports.murmur3 = t4, fe.exports.murmur2 = e3, fe.exports;
      }(), ge2 = e2(ye);
      class xe {
        constructor(t4, ...e3) {
          nt(this, e3[0] || {}), this.type = t4;
        }
      }
      class ve extends xe {
        constructor(t4, e3 = {}) {
          super("error", nt({ error: t4 }, e3));
        }
      }
      function be(t4, e3, r3) {
        r3[t4] && -1 !== r3[t4].indexOf(e3) || (r3[t4] = r3[t4] || [], r3[t4].push(e3));
      }
      function we2(t4, e3, r3) {
        if (r3 && r3[t4]) {
          const n3 = r3[t4].indexOf(e3);
          -1 !== n3 && r3[t4].splice(n3, 1);
        }
      }
      class _e {
        on(t4, e3) {
          return this._listeners = this._listeners || {}, be(t4, e3, this._listeners), this;
        }
        off(t4, e3) {
          return we2(t4, e3, this._listeners), we2(t4, e3, this._oneTimeListeners), this;
        }
        once(t4, e3) {
          return e3 ? (this._oneTimeListeners = this._oneTimeListeners || {}, be(t4, e3, this._oneTimeListeners), this) : new Promise((e4) => this.once(t4, e4));
        }
        fire(t4, e3) {
          const r3 = "string" == typeof t4 ? new xe(t4, e3) : t4, n3 = r3.type;
          if (this.listens(n3)) {
            r3.target = this;
            const t5 = this._listeners && this._listeners[n3] ? this._listeners[n3].slice() : [];
            for (const e5 of t5) e5.call(this, r3);
            const e4 = this._oneTimeListeners && this._oneTimeListeners[n3] ? this._oneTimeListeners[n3].slice() : [];
            for (const t6 of e4) we2(n3, t6, this._oneTimeListeners), t6.call(this, r3);
            const i3 = this._eventedParent;
            i3 && (nt(r3, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i3.fire(r3));
          } else r3 instanceof ve && console.error(r3.error);
          return this;
        }
        listens(t4) {
          return !!(this._listeners && this._listeners[t4] && this._listeners[t4].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t4] && this._oneTimeListeners[t4].length > 0 || this._eventedParent && this._eventedParent.listens(t4));
        }
        setEventedParent(t4, e3) {
          return this._eventedParent = t4, this._eventedParentData = e3, this;
        }
      }
      var Me, Ae2 = {}, Se = function() {
        if (Me) return Ae2;
        Me = 1;
        var t4 = { transparent: [0, 0, 0, 0], aliceblue: [240, 248, 255, 1], antiquewhite: [250, 235, 215, 1], aqua: [0, 255, 255, 1], aquamarine: [127, 255, 212, 1], azure: [240, 255, 255, 1], beige: [245, 245, 220, 1], bisque: [255, 228, 196, 1], black: [0, 0, 0, 1], blanchedalmond: [255, 235, 205, 1], blue: [0, 0, 255, 1], blueviolet: [138, 43, 226, 1], brown: [165, 42, 42, 1], burlywood: [222, 184, 135, 1], cadetblue: [95, 158, 160, 1], chartreuse: [127, 255, 0, 1], chocolate: [210, 105, 30, 1], coral: [255, 127, 80, 1], cornflowerblue: [100, 149, 237, 1], cornsilk: [255, 248, 220, 1], crimson: [220, 20, 60, 1], cyan: [0, 255, 255, 1], darkblue: [0, 0, 139, 1], darkcyan: [0, 139, 139, 1], darkgoldenrod: [184, 134, 11, 1], darkgray: [169, 169, 169, 1], darkgreen: [0, 100, 0, 1], darkgrey: [169, 169, 169, 1], darkkhaki: [189, 183, 107, 1], darkmagenta: [139, 0, 139, 1], darkolivegreen: [85, 107, 47, 1], darkorange: [255, 140, 0, 1], darkorchid: [153, 50, 204, 1], darkred: [139, 0, 0, 1], darksalmon: [233, 150, 122, 1], darkseagreen: [143, 188, 143, 1], darkslateblue: [72, 61, 139, 1], darkslategray: [47, 79, 79, 1], darkslategrey: [47, 79, 79, 1], darkturquoise: [0, 206, 209, 1], darkviolet: [148, 0, 211, 1], deeppink: [255, 20, 147, 1], deepskyblue: [0, 191, 255, 1], dimgray: [105, 105, 105, 1], dimgrey: [105, 105, 105, 1], dodgerblue: [30, 144, 255, 1], firebrick: [178, 34, 34, 1], floralwhite: [255, 250, 240, 1], forestgreen: [34, 139, 34, 1], fuchsia: [255, 0, 255, 1], gainsboro: [220, 220, 220, 1], ghostwhite: [248, 248, 255, 1], gold: [255, 215, 0, 1], goldenrod: [218, 165, 32, 1], gray: [128, 128, 128, 1], green: [0, 128, 0, 1], greenyellow: [173, 255, 47, 1], grey: [128, 128, 128, 1], honeydew: [240, 255, 240, 1], hotpink: [255, 105, 180, 1], indianred: [205, 92, 92, 1], indigo: [75, 0, 130, 1], ivory: [255, 255, 240, 1], khaki: [240, 230, 140, 1], lavender: [230, 230, 250, 1], lavenderblush: [255, 240, 245, 1], lawngreen: [124, 252, 0, 1], lemonchiffon: [255, 250, 205, 1], lightblue: [173, 216, 230, 1], lightcoral: [240, 128, 128, 1], lightcyan: [224, 255, 255, 1], lightgoldenrodyellow: [250, 250, 210, 1], lightgray: [211, 211, 211, 1], lightgreen: [144, 238, 144, 1], lightgrey: [211, 211, 211, 1], lightpink: [255, 182, 193, 1], lightsalmon: [255, 160, 122, 1], lightseagreen: [32, 178, 170, 1], lightskyblue: [135, 206, 250, 1], lightslategray: [119, 136, 153, 1], lightslategrey: [119, 136, 153, 1], lightsteelblue: [176, 196, 222, 1], lightyellow: [255, 255, 224, 1], lime: [0, 255, 0, 1], limegreen: [50, 205, 50, 1], linen: [250, 240, 230, 1], magenta: [255, 0, 255, 1], maroon: [128, 0, 0, 1], mediumaquamarine: [102, 205, 170, 1], mediumblue: [0, 0, 205, 1], mediumorchid: [186, 85, 211, 1], mediumpurple: [147, 112, 219, 1], mediumseagreen: [60, 179, 113, 1], mediumslateblue: [123, 104, 238, 1], mediumspringgreen: [0, 250, 154, 1], mediumturquoise: [72, 209, 204, 1], mediumvioletred: [199, 21, 133, 1], midnightblue: [25, 25, 112, 1], mintcream: [245, 255, 250, 1], mistyrose: [255, 228, 225, 1], moccasin: [255, 228, 181, 1], navajowhite: [255, 222, 173, 1], navy: [0, 0, 128, 1], oldlace: [253, 245, 230, 1], olive: [128, 128, 0, 1], olivedrab: [107, 142, 35, 1], orange: [255, 165, 0, 1], orangered: [255, 69, 0, 1], orchid: [218, 112, 214, 1], palegoldenrod: [238, 232, 170, 1], palegreen: [152, 251, 152, 1], paleturquoise: [175, 238, 238, 1], palevioletred: [219, 112, 147, 1], papayawhip: [255, 239, 213, 1], peachpuff: [255, 218, 185, 1], peru: [205, 133, 63, 1], pink: [255, 192, 203, 1], plum: [221, 160, 221, 1], powderblue: [176, 224, 230, 1], purple: [128, 0, 128, 1], rebeccapurple: [102, 51, 153, 1], red: [255, 0, 0, 1], rosybrown: [188, 143, 143, 1], royalblue: [65, 105, 225, 1], saddlebrown: [139, 69, 19, 1], salmon: [250, 128, 114, 1], sandybrown: [244, 164, 96, 1], seagreen: [46, 139, 87, 1], seashell: [255, 245, 238, 1], sienna: [160, 82, 45, 1], silver: [192, 192, 192, 1], skyblue: [135, 206, 235, 1], slateblue: [106, 90, 205, 1], slategray: [112, 128, 144, 1], slategrey: [112, 128, 144, 1], snow: [255, 250, 250, 1], springgreen: [0, 255, 127, 1], steelblue: [70, 130, 180, 1], tan: [210, 180, 140, 1], teal: [0, 128, 128, 1], thistle: [216, 191, 216, 1], tomato: [255, 99, 71, 1], turquoise: [64, 224, 208, 1], violet: [238, 130, 238, 1], wheat: [245, 222, 179, 1], white: [255, 255, 255, 1], whitesmoke: [245, 245, 245, 1], yellow: [255, 255, 0, 1], yellowgreen: [154, 205, 50, 1] };
        function e3(t5) {
          return (t5 = Math.round(t5)) < 0 ? 0 : t5 > 255 ? 255 : t5;
        }
        function r3(t5) {
          return e3("%" === t5[t5.length - 1] ? parseFloat(t5) / 100 * 255 : parseInt(t5));
        }
        function n3(t5) {
          return (e4 = "%" === t5[t5.length - 1] ? parseFloat(t5) / 100 : parseFloat(t5)) < 0 ? 0 : e4 > 1 ? 1 : e4;
          var e4;
        }
        function i3(t5, e4, r4) {
          return r4 < 0 ? r4 += 1 : r4 > 1 && (r4 -= 1), 6 * r4 < 1 ? t5 + (e4 - t5) * r4 * 6 : 2 * r4 < 1 ? e4 : 3 * r4 < 2 ? t5 + (e4 - t5) * (2 / 3 - r4) * 6 : t5;
        }
        try {
          Ae2.parseCSSColor = function(a4) {
            var s3, o3 = a4.replace(/ /g, "").toLowerCase();
            if (o3 in t4) return t4[o3].slice();
            if ("#" === o3[0]) return 4 === o3.length ? (s3 = parseInt(o3.substr(1), 16)) >= 0 && s3 <= 4095 ? [(3840 & s3) >> 4 | (3840 & s3) >> 8, 240 & s3 | (240 & s3) >> 4, 15 & s3 | (15 & s3) << 4, 1] : null : 7 === o3.length && (s3 = parseInt(o3.substr(1), 16)) >= 0 && s3 <= 16777215 ? [(16711680 & s3) >> 16, (65280 & s3) >> 8, 255 & s3, 1] : null;
            var l3 = o3.indexOf("("), u4 = o3.indexOf(")");
            if (-1 !== l3 && u4 + 1 === o3.length) {
              var c3 = o3.substr(0, l3), h3 = o3.substr(l3 + 1, u4 - (l3 + 1)).split(","), p3 = 1;
              switch (c3) {
                case "rgba":
                  if (4 !== h3.length) return null;
                  p3 = n3(h3.pop());
                case "rgb":
                  return 3 !== h3.length ? null : [r3(h3[0]), r3(h3[1]), r3(h3[2]), p3];
                case "hsla":
                  if (4 !== h3.length) return null;
                  p3 = n3(h3.pop());
                case "hsl":
                  if (3 !== h3.length) return null;
                  var f3 = (parseFloat(h3[0]) % 360 + 360) % 360 / 360, d3 = n3(h3[1]), m2 = n3(h3[2]), y2 = m2 <= 0.5 ? m2 * (d3 + 1) : m2 + d3 - m2 * d3, g4 = 2 * m2 - y2;
                  return [e3(255 * i3(g4, y2, f3 + 1 / 3)), e3(255 * i3(g4, y2, f3)), e3(255 * i3(g4, y2, f3 - 1 / 3)), p3];
                default:
                  return null;
              }
            }
            return null;
          };
        } catch (t5) {
        }
        return Ae2;
      }();
      class Ie {
        constructor(t4, e3, r3, n3 = 1) {
          this.r = t4, this.g = e3, this.b = r3, this.a = n3;
        }
        static parse(t4) {
          if (!t4) return;
          if (t4 instanceof Ie) return t4;
          if ("string" != typeof t4) return;
          const e3 = Se.parseCSSColor(t4);
          return e3 ? new Ie(e3[0] / 255 * e3[3], e3[1] / 255 * e3[3], e3[2] / 255 * e3[3], e3[3]) : void 0;
        }
        toString() {
          const [t4, e3, r3, n3] = 0 === this.a ? [0, 0, 0, 0] : [255 * this.r / this.a, 255 * this.g / this.a, 255 * this.b / this.a, this.a];
          return `rgba(${Math.round(t4)},${Math.round(e3)},${Math.round(r3)},${n3})`;
        }
        toRenderColor(t4) {
          const { r: e3, g: r3, b: n3, a: i3 } = this;
          return new ze(t4, e3, r3, n3, i3);
        }
      }
      class ze {
        constructor(t4, e3, r3, n3, i3) {
          if (t4) {
            const a4 = t4.image.height, s3 = a4 * a4;
            e3 = 0 === i3 ? 0 : e3 / i3 * (a4 - 1), r3 = 0 === i3 ? 0 : r3 / i3 * (a4 - 1), n3 = 0 === i3 ? 0 : n3 / i3 * (a4 - 1);
            const o3 = Math.floor(e3), l3 = Math.floor(r3), u4 = Math.floor(n3), c3 = Math.ceil(e3), h3 = Math.ceil(r3), p3 = Math.ceil(n3), f3 = e3 - o3, d3 = r3 - l3, m2 = n3 - u4, y2 = t4.image.data, g4 = 4 * (o3 + l3 * s3 + u4 * a4), x2 = 4 * (o3 + l3 * s3 + p3 * a4), v2 = 4 * (o3 + h3 * s3 + u4 * a4), b2 = 4 * (o3 + h3 * s3 + p3 * a4), w2 = 4 * (c3 + l3 * s3 + u4 * a4), _2 = 4 * (c3 + l3 * s3 + p3 * a4), M2 = 4 * (c3 + h3 * s3 + u4 * a4), A3 = 4 * (c3 + h3 * s3 + p3 * a4);
            if (g4 < 0 || A3 >= y2.length) throw new Error("out of range");
            this.r = Pe(Pe(Pe(y2[g4], y2[x2], m2), Pe(y2[v2], y2[b2], m2), d3), Pe(Pe(y2[w2], y2[_2], m2), Pe(y2[M2], y2[A3], m2), d3), f3) / 255 * i3, this.g = Pe(Pe(Pe(y2[g4 + 1], y2[x2 + 1], m2), Pe(y2[v2 + 1], y2[b2 + 1], m2), d3), Pe(Pe(y2[w2 + 1], y2[_2 + 1], m2), Pe(y2[M2 + 1], y2[A3 + 1], m2), d3), f3) / 255 * i3, this.b = Pe(Pe(Pe(y2[g4 + 2], y2[x2 + 2], m2), Pe(y2[v2 + 2], y2[b2 + 2], m2), d3), Pe(Pe(y2[w2 + 2], y2[_2 + 2], m2), Pe(y2[M2 + 2], y2[A3 + 2], m2), d3), f3) / 255 * i3, this.a = i3;
          } else this.r = e3, this.g = r3, this.b = n3, this.a = i3;
        }
        toArray() {
          const { r: t4, g: e3, b: r3, a: n3 } = this;
          return 0 === n3 ? [0, 0, 0, 0] : [255 * t4 / n3, 255 * e3 / n3, 255 * r3 / n3, n3];
        }
        toArray01() {
          const { r: t4, g: e3, b: r3, a: n3 } = this;
          return 0 === n3 ? [0, 0, 0, 0] : [t4 / n3, e3 / n3, r3 / n3, n3];
        }
        toArray01Scaled(t4) {
          const { r: e3, g: r3, b: n3, a: i3 } = this;
          return 0 === i3 ? [0, 0, 0] : [e3 / i3 * t4, r3 / i3 * t4, n3 / i3 * t4];
        }
        toArray01PremultipliedAlpha() {
          const { r: t4, g: e3, b: r3, a: n3 } = this;
          return [t4, e3, r3, n3];
        }
        toArray01Linear() {
          const { r: t4, g: e3, b: r3, a: n3 } = this;
          return 0 === n3 ? [0, 0, 0, 0] : [Math.pow(t4 / n3, 2.2), Math.pow(e3 / n3, 2.2), Math.pow(r3 / n3, 2.2), n3];
        }
      }
      function Pe(t4, e3, r3) {
        return t4 * (1 - r3) + e3 * r3;
      }
      function ke(t4, e3, r3) {
        return t4.map((t5, n3) => Pe(t5, e3[n3], r3));
      }
      Ie.black = new Ie(0, 0, 0, 1), Ie.white = new Ie(1, 1, 1, 1), Ie.transparent = new Ie(0, 0, 0, 0), Ie.red = new Ie(1, 0, 0, 1), Ie.blue = new Ie(0, 0, 1, 1);
      var Te = Object.freeze({ __proto__: null, array: ke, color: function(t4, e3, r3) {
        return new Ie(Pe(t4.r, e3.r, r3), Pe(t4.g, e3.g, r3), Pe(t4.b, e3.b, r3), Pe(t4.a, e3.a, r3));
      }, number: Pe });
      function Ee(t4, ...e3) {
        for (const r3 of e3) for (const e4 in r3) t4[e4] = r3[e4];
        return t4;
      }
      class Be extends Error {
        constructor(t4, e3) {
          super(e3), this.message = e3, this.key = t4;
        }
      }
      class Ve {
        constructor(t4, e3 = []) {
          this.parent = t4, this.bindings = {};
          for (const [t5, r3] of e3) this.bindings[t5] = r3;
        }
        concat(t4) {
          return new Ve(this, t4);
        }
        get(t4) {
          if (this.bindings[t4]) return this.bindings[t4];
          if (this.parent) return this.parent.get(t4);
          throw new Error(`${t4} not found in scope.`);
        }
        has(t4) {
          return !!this.bindings[t4] || !!this.parent && this.parent.has(t4);
        }
      }
      const Ce = { kind: "null" }, Re = { kind: "number" }, De = { kind: "string" }, Le = { kind: "boolean" }, Fe = { kind: "color" }, Oe = { kind: "object" }, Ue = { kind: "value" }, je = { kind: "collator" }, Ne = { kind: "formatted" }, qe = { kind: "resolvedImage" };
      function $e(t4, e3) {
        return { kind: "array", itemType: t4, N: e3 };
      }
      function Ge(t4) {
        if ("array" === t4.kind) {
          const e3 = Ge(t4.itemType);
          return "number" == typeof t4.N ? `array<${e3}, ${t4.N}>` : "value" === t4.itemType.kind ? "array" : `array<${e3}>`;
        }
        return t4.kind;
      }
      const Xe = [Ce, Re, De, Le, Fe, Ne, Oe, $e(Ue), qe];
      function Ye(t4, e3) {
        if ("error" === e3.kind) return null;
        if ("array" === t4.kind) {
          if ("array" === e3.kind && (0 === e3.N && "value" === e3.itemType.kind || !Ye(t4.itemType, e3.itemType)) && ("number" != typeof t4.N || t4.N === e3.N)) return null;
        } else {
          if (t4.kind === e3.kind) return null;
          if ("value" === t4.kind) {
            for (const t5 of Xe) if (!Ye(t5, e3)) return null;
          }
        }
        return `Expected ${Ge(t4)} but found ${Ge(e3)} instead.`;
      }
      function Ze(t4, e3) {
        return e3.some((e4) => e4.kind === t4.kind);
      }
      function We(t4, e3) {
        return e3.some((e4) => "null" === e4 ? null === t4 : "array" === e4 ? Array.isArray(t4) : "object" === e4 ? t4 && !Array.isArray(t4) && "object" == typeof t4 : e4 === typeof t4);
      }
      class He {
        constructor(t4, e3, r3) {
          this.sensitivity = t4 ? e3 ? "variant" : "case" : e3 ? "accent" : "base", this.locale = r3, this.collator = new Intl.Collator(this.locale ? this.locale : [], { sensitivity: this.sensitivity, usage: "search" });
        }
        compare(t4, e3) {
          return this.collator.compare(t4, e3);
        }
        resolvedLocale() {
          return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
        }
      }
      class Ke {
        constructor(t4, e3, r3, n3, i3) {
          this.text = t4.normalize ? t4.normalize() : t4, this.image = e3, this.scale = r3, this.fontStack = n3, this.textColor = i3;
        }
      }
      class Je {
        constructor(t4) {
          this.sections = t4;
        }
        static fromString(t4) {
          return new Je([new Ke(t4, null, null, null, null)]);
        }
        isEmpty() {
          return 0 === this.sections.length || !this.sections.some((t4) => 0 !== t4.text.length || t4.image && 0 !== t4.image.namePrimary.length);
        }
        static factory(t4) {
          return t4 instanceof Je ? t4 : Je.fromString(t4);
        }
        toString() {
          return 0 === this.sections.length ? "" : this.sections.map((t4) => t4.text).join("");
        }
        serialize() {
          const t4 = ["format"];
          for (const e3 of this.sections) {
            if (e3.image) {
              t4.push(["image", e3.image.namePrimary]);
              continue;
            }
            t4.push(e3.text);
            const r3 = {};
            e3.fontStack && (r3["text-font"] = ["literal", e3.fontStack.split(",")]), e3.scale && (r3["font-scale"] = e3.scale), e3.textColor && (r3["text-color"] = ["rgba"].concat(e3.textColor.toRenderColor(null).toArray())), t4.push(r3);
          }
          return t4;
        }
      }
      class Qe {
        constructor(t4) {
          this.namePrimary = t4.namePrimary, t4.nameSecondary && (this.nameSecondary = t4.nameSecondary), this.available = t4.available;
        }
        toString() {
          return this.nameSecondary ? `[${this.namePrimary},${this.nameSecondary}]` : this.namePrimary;
        }
        static fromString(t4, e3) {
          return t4 ? new Qe({ namePrimary: t4, nameSecondary: e3, available: false }) : null;
        }
        serialize() {
          return this.nameSecondary ? ["image", this.namePrimary, this.nameSecondary] : ["image", this.namePrimary];
        }
      }
      function tr(t4, e3, r3, n3) {
        return "number" == typeof t4 && t4 >= 0 && t4 <= 255 && "number" == typeof e3 && e3 >= 0 && e3 <= 255 && "number" == typeof r3 && r3 >= 0 && r3 <= 255 ? void 0 === n3 || "number" == typeof n3 && n3 >= 0 && n3 <= 1 ? null : `Invalid rgba value [${[t4, e3, r3, n3].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n3 ? [t4, e3, r3, n3] : [t4, e3, r3]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
      }
      function er(t4) {
        if (null === t4) return true;
        if ("string" == typeof t4) return true;
        if ("boolean" == typeof t4) return true;
        if ("number" == typeof t4) return true;
        if (t4 instanceof Ie) return true;
        if (t4 instanceof He) return true;
        if (t4 instanceof Je) return true;
        if (t4 instanceof Qe) return true;
        if (Array.isArray(t4)) {
          for (const e3 of t4) if (!er(e3)) return false;
          return true;
        }
        if ("object" == typeof t4) {
          for (const e3 in t4) if (!er(t4[e3])) return false;
          return true;
        }
        return false;
      }
      function rr(t4) {
        if (null === t4) return Ce;
        if ("string" == typeof t4) return De;
        if ("boolean" == typeof t4) return Le;
        if ("number" == typeof t4) return Re;
        if (t4 instanceof Ie) return Fe;
        if (t4 instanceof He) return je;
        if (t4 instanceof Je) return Ne;
        if (t4 instanceof Qe) return qe;
        if (Array.isArray(t4)) {
          const e3 = t4.length;
          let r3;
          for (const e4 of t4) {
            const t5 = rr(e4);
            if (r3) {
              if (r3 === t5) continue;
              r3 = Ue;
              break;
            }
            r3 = t5;
          }
          return $e(r3 || Ue, e3);
        }
        return Oe;
      }
      function nr(t4) {
        const e3 = typeof t4;
        return null === t4 ? "" : "string" === e3 || "number" === e3 || "boolean" === e3 ? String(t4) : t4 instanceof Ie || t4 instanceof Je || t4 instanceof Qe ? t4.toString() : JSON.stringify(t4);
      }
      class ir {
        constructor(t4, e3) {
          this.type = t4, this.value = e3;
        }
        static parse(t4, e3) {
          if (2 !== t4.length) return e3.error(`'literal' expression requires exactly one argument, but found ${t4.length - 1} instead.`);
          if (!er(t4[1])) return e3.error("invalid value");
          const r3 = t4[1];
          let n3 = rr(r3);
          const i3 = e3.expectedType;
          return "array" !== n3.kind || 0 !== n3.N || !i3 || "array" !== i3.kind || "number" == typeof i3.N && 0 !== i3.N || (n3 = i3), new ir(n3, r3);
        }
        evaluate() {
          return this.value;
        }
        eachChild() {
        }
        outputDefined() {
          return true;
        }
        serialize() {
          return "array" === this.type.kind || "object" === this.type.kind ? ["literal", this.value] : this.value instanceof Ie ? ["rgba"].concat(this.value.toRenderColor(null).toArray()) : this.value instanceof Je ? this.value.serialize() : this.value;
        }
      }
      class ar {
        constructor(t4) {
          this.name = "ExpressionEvaluationError", this.message = t4;
        }
        toJSON() {
          return this.message;
        }
      }
      const sr = { string: De, number: Re, boolean: Le, object: Oe };
      class or {
        constructor(t4, e3) {
          this.type = t4, this.args = e3;
        }
        static parse(t4, e3) {
          if (t4.length < 2) return e3.error("Expected at least one argument.");
          let r3, n3 = 1;
          const i3 = t4[0];
          if ("array" === i3) {
            let i4, a5;
            if (t4.length > 2) {
              const r4 = t4[1];
              if ("string" != typeof r4 || !(r4 in sr) || "object" === r4) return e3.error('The item type argument of "array" must be one of string, number, boolean', 1);
              i4 = sr[r4], n3++;
            } else i4 = Ue;
            if (t4.length > 3) {
              if (null !== t4[2] && ("number" != typeof t4[2] || t4[2] < 0 || t4[2] !== Math.floor(t4[2]))) return e3.error('The length argument to "array" must be a positive integer literal', 2);
              a5 = t4[2], n3++;
            }
            r3 = $e(i4, a5);
          } else r3 = sr[i3];
          const a4 = [];
          for (; n3 < t4.length; n3++) {
            const r4 = e3.parse(t4[n3], n3, Ue);
            if (!r4) return null;
            a4.push(r4);
          }
          return new or(r3, a4);
        }
        evaluate(t4) {
          for (let e3 = 0; e3 < this.args.length; e3++) {
            const r3 = this.args[e3].evaluate(t4);
            if (!Ye(this.type, rr(r3))) return r3;
            if (e3 === this.args.length - 1) throw new ar(`The expression ${JSON.stringify(this.args[e3].serialize())} evaluated to ${Ge(rr(r3))} but was expected to be of type ${Ge(this.type)}.`);
          }
          return null;
        }
        eachChild(t4) {
          this.args.forEach(t4);
        }
        outputDefined() {
          return this.args.every((t4) => t4.outputDefined());
        }
        serialize() {
          const t4 = this.type, e3 = [t4.kind];
          if ("array" === t4.kind) {
            const r3 = t4.itemType;
            if ("string" === r3.kind || "number" === r3.kind || "boolean" === r3.kind) {
              e3.push(r3.kind);
              const n3 = t4.N;
              ("number" == typeof n3 || this.args.length > 1) && e3.push(n3);
            }
          }
          return e3.concat(this.args.map((t5) => t5.serialize()));
        }
      }
      class lr {
        constructor(t4) {
          this.type = Ne, this.sections = t4;
        }
        static parse(t4, e3) {
          if (t4.length < 2) return e3.error("Expected at least one argument.");
          const r3 = t4[1];
          if (!Array.isArray(r3) && "object" == typeof r3) return e3.error("First argument must be an image or text section.");
          const n3 = [];
          let i3 = false;
          for (let r4 = 1; r4 <= t4.length - 1; ++r4) {
            const a4 = t4[r4];
            if (i3 && "object" == typeof a4 && !Array.isArray(a4)) {
              i3 = false;
              let t5 = null;
              if (a4["font-scale"] && (t5 = e3.parseObjectValue(a4["font-scale"], r4, "font-scale", Re), !t5)) return null;
              let s3 = null;
              if (a4["text-font"] && (s3 = e3.parseObjectValue(a4["text-font"], r4, "text-font", $e(De)), !s3)) return null;
              let o3 = null;
              if (a4["text-color"] && (o3 = e3.parseObjectValue(a4["text-color"], r4, "text-color", Fe), !o3)) return null;
              const l3 = n3[n3.length - 1];
              l3.scale = t5, l3.font = s3, l3.textColor = o3;
            } else {
              const a5 = e3.parse(t4[r4], r4, Ue);
              if (!a5) return null;
              const s3 = a5.type.kind;
              if ("string" !== s3 && "value" !== s3 && "null" !== s3 && "resolvedImage" !== s3) return e3.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
              i3 = true, n3.push({ content: a5, scale: null, font: null, textColor: null });
            }
          }
          return new lr(n3);
        }
        evaluate(t4) {
          return new Je(this.sections.map((e3) => {
            const r3 = e3.content.evaluate(t4);
            return rr(r3) === qe ? new Ke("", r3, null, null, null) : new Ke(nr(r3), null, e3.scale ? e3.scale.evaluate(t4) : null, e3.font ? e3.font.evaluate(t4).join(",") : null, e3.textColor ? e3.textColor.evaluate(t4) : null);
          }));
        }
        eachChild(t4) {
          for (const e3 of this.sections) t4(e3.content), e3.scale && t4(e3.scale), e3.font && t4(e3.font), e3.textColor && t4(e3.textColor);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          const t4 = ["format"];
          for (const e3 of this.sections) {
            t4.push(e3.content.serialize());
            const r3 = {};
            e3.scale && (r3["font-scale"] = e3.scale.serialize()), e3.font && (r3["text-font"] = e3.font.serialize()), e3.textColor && (r3["text-color"] = e3.textColor.serialize()), t4.push(r3);
          }
          return t4;
        }
      }
      class ur {
        constructor(t4, e3) {
          this.type = qe, this.inputPrimary = t4, this.inputSecondary = e3;
        }
        static parse(t4, e3) {
          if (t4.length < 2) return e3.error("Expected two or more arguments.");
          const r3 = e3.parse(t4[1], 1, De);
          if (!r3) return e3.error("No image name provided.");
          if (2 === t4.length) return new ur(r3);
          const n3 = e3.parse(t4[2], 1, De);
          return n3 ? new ur(r3, n3) : e3.error("Secondary image variant is not a string.");
        }
        evaluate(t4) {
          const e3 = Qe.fromString(this.inputPrimary.evaluate(t4), this.inputSecondary ? this.inputSecondary.evaluate(t4) : void 0);
          return e3 && t4.availableImages && (e3.available = t4.availableImages.indexOf(e3.namePrimary) > -1, e3.nameSecondary && e3.available && t4.availableImages && (e3.available = t4.availableImages.indexOf(e3.nameSecondary) > -1)), e3;
        }
        eachChild(t4) {
          t4(this.inputPrimary), this.inputSecondary && t4(this.inputSecondary);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          return this.inputSecondary ? ["image", this.inputPrimary.serialize(), this.inputSecondary.serialize()] : ["image", this.inputPrimary.serialize()];
        }
      }
      function cr(t4) {
        return t4 instanceof Number ? "number" : t4 instanceof String ? "string" : t4 instanceof Boolean ? "boolean" : Array.isArray(t4) ? "array" : null === t4 ? "null" : typeof t4;
      }
      const hr = { "to-boolean": Le, "to-color": Fe, "to-number": Re, "to-string": De };
      class pr {
        constructor(t4, e3) {
          this.type = t4, this.args = e3;
        }
        static parse(t4, e3) {
          if (t4.length < 2) return e3.error("Expected at least one argument.");
          const r3 = t4[0], n3 = [];
          let i3 = Ce;
          if ("to-array" === r3) {
            if (!Array.isArray(t4[1])) return null;
            const r4 = t4[1].length;
            if (e3.expectedType) {
              if ("array" !== e3.expectedType.kind) return e3.error(`Expected ${e3.expectedType.kind} but found array.`);
              i3 = $e(e3.expectedType.itemType, r4);
            } else {
              if (!(r4 > 0 && er(t4[1][0]))) return null;
              i3 = $e(rr(t4[1][0]), r4);
            }
            for (let a4 = 0; a4 < r4; a4++) {
              const r5 = t4[1][a4];
              let s3;
              if ("array" === cr(r5)) s3 = e3.parse(r5, void 0, i3.itemType);
              else {
                const t5 = cr(r5);
                if (t5 !== i3.itemType.kind) return e3.error(`Expected ${i3.itemType.kind} but found ${t5}.`);
                s3 = e3.registry.literal.parse(["literal", void 0 === r5 ? null : r5], e3);
              }
              if (!s3) return null;
              n3.push(s3);
            }
          } else {
            if (("to-boolean" === r3 || "to-string" === r3) && 2 !== t4.length) return e3.error("Expected one argument.");
            i3 = hr[r3];
            for (let r4 = 1; r4 < t4.length; r4++) {
              const i4 = e3.parse(t4[r4], r4, Ue);
              if (!i4) return null;
              n3.push(i4);
            }
          }
          return new pr(i3, n3);
        }
        evaluate(t4) {
          if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t4));
          if ("color" === this.type.kind) {
            let e3, r3;
            for (const n3 of this.args) {
              if (e3 = n3.evaluate(t4), r3 = null, e3 instanceof Ie) return e3;
              if ("string" == typeof e3) {
                const r4 = t4.parseColor(e3);
                if (r4) return r4;
              } else if (Array.isArray(e3) && (r3 = e3.length < 3 || e3.length > 4 ? `Invalid rbga value ${JSON.stringify(e3)}: expected an array containing either three or four numeric values.` : tr(e3[0], e3[1], e3[2], e3[3]), !r3)) return new Ie(e3[0] / 255, e3[1] / 255, e3[2] / 255, e3[3]);
            }
            throw new ar(r3 || `Could not parse color from value '${"string" == typeof e3 ? e3 : String(JSON.stringify(e3))}'`);
          }
          if ("number" === this.type.kind) {
            let e3 = null;
            for (const r3 of this.args) {
              if (e3 = r3.evaluate(t4), null === e3) return 0;
              const n3 = Number(e3);
              if (!isNaN(n3)) return n3;
            }
            throw new ar(`Could not convert ${JSON.stringify(e3)} to number.`);
          }
          return "formatted" === this.type.kind ? Je.fromString(nr(this.args[0].evaluate(t4))) : "resolvedImage" === this.type.kind ? Qe.fromString(nr(this.args[0].evaluate(t4))) : "array" === this.type.kind ? this.args.map((e3) => e3.evaluate(t4)) : nr(this.args[0].evaluate(t4));
        }
        eachChild(t4) {
          this.args.forEach(t4);
        }
        outputDefined() {
          return this.args.every((t4) => t4.outputDefined());
        }
        serialize() {
          if ("formatted" === this.type.kind) return new lr([{ content: this.args[0], scale: null, font: null, textColor: null }]).serialize();
          if ("resolvedImage" === this.type.kind) return new ur(this.args[0]).serialize();
          const t4 = "array" === this.type.kind ? [] : [`to-${this.type.kind}`];
          return this.eachChild((e3) => {
            t4.push(e3.serialize());
          }), t4;
        }
      }
      const fr = ["Unknown", "Point", "LineString", "Polygon"];
      class dr {
        constructor(t4, e3) {
          this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.scope = t4, this.options = e3;
        }
        id() {
          return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
        }
        geometryType() {
          return this.feature ? "number" == typeof this.feature.type ? fr[this.feature.type] : this.feature.type : null;
        }
        geometry() {
          return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
        }
        canonicalID() {
          return this.canonical;
        }
        properties() {
          return this.feature && this.feature.properties || {};
        }
        measureLight(t4) {
          return this.globals.brightness || 0;
        }
        distanceFromCenter() {
          if (this.featureTileCoord && this.featureDistanceData) {
            const t4 = this.featureDistanceData.center, e3 = this.featureDistanceData.scale, { x: r3, y: n3 } = this.featureTileCoord;
            return this.featureDistanceData.bearing[0] * (r3 * e3 - t4[0]) + this.featureDistanceData.bearing[1] * (n3 * e3 - t4[1]);
          }
          return 0;
        }
        parseColor(t4) {
          let e3 = this._parseColorCache[t4];
          return e3 || (e3 = this._parseColorCache[t4] = Ie.parse(t4)), e3;
        }
        getConfig(t4) {
          return this.options ? this.options.get(t4) : null;
        }
      }
      class mr {
        constructor(t4, e3, r3, n3, i3) {
          this.name = t4, this.type = e3, this._evaluate = r3, this.args = n3, this._overloadIndex = i3;
        }
        evaluate(t4) {
          if (!this._evaluate) {
            const t5 = mr.definitions[this.name];
            this._evaluate = Array.isArray(t5) ? t5[2] : t5.overloads[this._overloadIndex][1];
          }
          return this._evaluate(t4, this.args);
        }
        eachChild(t4) {
          this.args.forEach(t4);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          return [this.name].concat(this.args.map((t4) => t4.serialize()));
        }
        static parse(t4, e3) {
          const r3 = t4[0], n3 = mr.definitions[r3];
          if (!n3) return e3.error(`Unknown expression "${r3}". If you wanted a literal array, use ["literal", [...]].`, 0);
          const i3 = Array.isArray(n3) ? n3[0] : n3.type, a4 = Array.isArray(n3) ? [[n3[1], n3[2]]] : n3.overloads, s3 = [];
          let o3 = null, l3 = -1;
          for (const [n4, u4] of a4) {
            if (Array.isArray(n4) && n4.length !== t4.length - 1) continue;
            s3.push(n4), l3++, o3 = new Rn(e3.registry, e3.path, null, e3.scope, void 0, e3._scope, e3.options);
            const a5 = [];
            let c3 = false;
            for (let e4 = 1; e4 < t4.length; e4++) {
              const r4 = t4[e4], i4 = Array.isArray(n4) ? n4[e4 - 1] : n4.type, s4 = o3.parse(r4, 1 + a5.length, i4);
              if (!s4) {
                c3 = true;
                break;
              }
              a5.push(s4);
            }
            if (!c3) if (Array.isArray(n4) && n4.length !== a5.length) o3.error(`Expected ${n4.length} arguments, but found ${a5.length} instead.`);
            else {
              for (let t5 = 0; t5 < a5.length; t5++) {
                const e4 = Array.isArray(n4) ? n4[t5] : n4.type, r4 = a5[t5];
                o3.concat(t5 + 1).checkSubtype(e4, r4.type);
              }
              if (0 === o3.errors.length) return new mr(r3, i3, u4, a5, l3);
            }
          }
          if (1 === s3.length) e3.errors.push(...o3.errors);
          else {
            const r4 = (s3.length ? s3 : a4.map(([t5]) => t5)).map(yr).join(" | "), n4 = [];
            for (let r5 = 1; r5 < t4.length; r5++) {
              const i4 = e3.parse(t4[r5], 1 + n4.length);
              if (!i4) return null;
              n4.push(Ge(i4.type));
            }
            e3.error(`Expected arguments of type ${r4}, but found (${n4.join(", ")}) instead.`);
          }
          return null;
        }
        static register(t4, e3) {
          mr.definitions = e3;
          for (const r3 in e3) t4[r3] = mr;
        }
      }
      function yr(t4) {
        return Array.isArray(t4) ? `(${t4.map(Ge).join(", ")})` : `(${Ge(t4.type)}...)`;
      }
      class gr {
        constructor(t4, e3, r3) {
          this.type = je, this.locale = r3, this.caseSensitive = t4, this.diacriticSensitive = e3;
        }
        static parse(t4, e3) {
          if (2 !== t4.length) return e3.error("Expected one argument.");
          const r3 = t4[1];
          if ("object" != typeof r3 || Array.isArray(r3)) return e3.error("Collator options argument must be an object.");
          const n3 = void 0 === r3["case-sensitive"] ? e3.parse(false, 1, Le) : e3.parseObjectValue(r3["case-sensitive"], 1, "case-sensitive", Le);
          if (!n3) return null;
          const i3 = void 0 === r3["diacritic-sensitive"] ? e3.parse(false, 1, Le) : e3.parseObjectValue(r3["diacritic-sensitive"], 1, "diacritic-sensitive", Le);
          if (!i3) return null;
          let a4 = null;
          return r3.locale && (a4 = e3.parseObjectValue(r3.locale, 1, "locale", De), !a4) ? null : new gr(n3, i3, a4);
        }
        evaluate(t4) {
          return new He(this.caseSensitive.evaluate(t4), this.diacriticSensitive.evaluate(t4), this.locale ? this.locale.evaluate(t4) : null);
        }
        eachChild(t4) {
          t4(this.caseSensitive), t4(this.diacriticSensitive), this.locale && t4(this.locale);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          const t4 = {};
          return t4["case-sensitive"] = this.caseSensitive.serialize(), t4["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t4.locale = this.locale.serialize()), ["collator", t4];
        }
      }
      function xr(t4, e3, r3 = 0, n3 = t4.length - 1, i3 = br) {
        for (; n3 > r3; ) {
          if (n3 - r3 > 600) {
            const a5 = n3 - r3 + 1, s4 = e3 - r3 + 1, o4 = Math.log(a5), l3 = 0.5 * Math.exp(2 * o4 / 3), u4 = 0.5 * Math.sqrt(o4 * l3 * (a5 - l3) / a5) * (s4 - a5 / 2 < 0 ? -1 : 1);
            xr(t4, e3, Math.max(r3, Math.floor(e3 - s4 * l3 / a5 + u4)), Math.min(n3, Math.floor(e3 + (a5 - s4) * l3 / a5 + u4)), i3);
          }
          const a4 = t4[e3];
          let s3 = r3, o3 = n3;
          for (vr(t4, r3, e3), i3(t4[n3], a4) > 0 && vr(t4, r3, n3); s3 < o3; ) {
            for (vr(t4, s3, o3), s3++, o3--; i3(t4[s3], a4) < 0; ) s3++;
            for (; i3(t4[o3], a4) > 0; ) o3--;
          }
          0 === i3(t4[r3], a4) ? vr(t4, r3, o3) : (o3++, vr(t4, o3, n3)), o3 <= e3 && (r3 = o3 + 1), e3 <= o3 && (n3 = o3 - 1);
        }
      }
      function vr(t4, e3, r3) {
        const n3 = t4[e3];
        t4[e3] = t4[r3], t4[r3] = n3;
      }
      function br(t4, e3) {
        return t4 < e3 ? -1 : t4 > e3 ? 1 : 0;
      }
      function wr(t4) {
        let e3 = 0;
        for (let r3, n3, i3 = 0, a4 = t4.length, s3 = a4 - 1; i3 < a4; s3 = i3++) r3 = t4[i3], n3 = t4[s3], e3 += (n3.x - r3.x) * (r3.y + n3.y);
        return e3;
      }
      function _r(t4, e3) {
        t4[0] = Math.min(t4[0], e3[0]), t4[1] = Math.min(t4[1], e3[1]), t4[2] = Math.max(t4[2], e3[0]), t4[3] = Math.max(t4[3], e3[1]);
      }
      function Mr2(t4, e3) {
        return !(t4[0] <= e3[0] || t4[2] >= e3[2] || t4[1] <= e3[1] || t4[3] >= e3[3]);
      }
      function Ar2(t4, e3, r3) {
        const n3 = t4[0] - e3[0], i3 = t4[1] - e3[1], a4 = t4[0] - r3[0], s3 = t4[1] - r3[1];
        return n3 * s3 - a4 * i3 == 0 && n3 * a4 <= 0 && i3 * s3 <= 0;
      }
      function Sr(t4, e3, r3 = false) {
        let n3 = false;
        for (let o3 = 0, l3 = e3.length; o3 < l3; o3++) {
          const l4 = e3[o3];
          for (let e4 = 0, o4 = l4.length, u4 = o4 - 1; e4 < o4; u4 = e4++) {
            const o5 = l4[u4], c3 = l4[e4];
            if (Ar2(t4, o5, c3)) return r3;
            (a4 = o5)[1] > (i3 = t4)[1] != (s3 = c3)[1] > i3[1] && i3[0] < (s3[0] - a4[0]) * (i3[1] - a4[1]) / (s3[1] - a4[1]) + a4[0] && (n3 = !n3);
          }
        }
        var i3, a4, s3;
        return n3;
      }
      function Ir(t4, e3, r3, n3) {
        const i3 = n3[0] - r3[0], a4 = n3[1] - r3[1], s3 = (t4[0] - r3[0]) * a4 - i3 * (t4[1] - r3[1]), o3 = (e3[0] - r3[0]) * a4 - i3 * (e3[1] - r3[1]);
        return s3 > 0 && o3 < 0 || s3 < 0 && o3 > 0;
      }
      function zr(t4, e3, r3, n3) {
        return 0 != (i3 = [n3[0] - r3[0], n3[1] - r3[1]])[0] * (a4 = [e3[0] - t4[0], e3[1] - t4[1]])[1] - i3[1] * a4[0] && !(!Ir(t4, e3, r3, n3) || !Ir(r3, n3, t4, e3));
        var i3, a4;
      }
      const Pr = 8192;
      function kr(t4, e3) {
        const r3 = (180 + t4[0]) / 360, n3 = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t4[1] * Math.PI / 360))) / 360, i3 = Math.pow(2, e3.z);
        return [Math.round(r3 * i3 * Pr), Math.round(n3 * i3 * Pr)];
      }
      function Tr(t4, e3) {
        for (let r3 = 0; r3 < e3.length; r3++) if (Sr(t4, e3[r3])) return true;
        return false;
      }
      function Er(t4, e3, r3) {
        for (const n3 of r3) for (let r4 = 0, i3 = n3.length, a4 = i3 - 1; r4 < i3; a4 = r4++) if (zr(t4, e3, n3[a4], n3[r4])) return true;
        return false;
      }
      function Br(t4, e3) {
        for (let r3 = 0; r3 < t4.length; ++r3) if (!Sr(t4[r3], e3)) return false;
        for (let r3 = 0; r3 < t4.length - 1; ++r3) if (Er(t4[r3], t4[r3 + 1], e3)) return false;
        return true;
      }
      function Vr(t4, e3) {
        for (let r3 = 0; r3 < e3.length; r3++) if (Br(t4, e3[r3])) return true;
        return false;
      }
      function Cr(t4, e3, r3) {
        const n3 = [];
        for (let i3 = 0; i3 < t4.length; i3++) {
          const a4 = [];
          for (let n4 = 0; n4 < t4[i3].length; n4++) {
            const s3 = kr(t4[i3][n4], r3);
            _r(e3, s3), a4.push(s3);
          }
          n3.push(a4);
        }
        return n3;
      }
      function Rr(t4, e3, r3) {
        const n3 = [];
        for (let i3 = 0; i3 < t4.length; i3++) {
          const a4 = Cr(t4[i3], e3, r3);
          n3.push(a4);
        }
        return n3;
      }
      function Dr(t4, e3, r3, n3) {
        if (t4[0] < r3[0] || t4[0] > r3[2]) {
          const e4 = 0.5 * n3;
          let i3 = t4[0] - r3[0] > e4 ? -n3 : r3[0] - t4[0] > e4 ? n3 : 0;
          0 === i3 && (i3 = t4[0] - r3[2] > e4 ? -n3 : r3[2] - t4[0] > e4 ? n3 : 0), t4[0] += i3;
        }
        _r(e3, t4);
      }
      function Lr(t4, e3, r3, n3) {
        const i3 = Math.pow(2, n3.z) * Pr, a4 = [n3.x * Pr, n3.y * Pr], s3 = [];
        if (!t4) return s3;
        for (const n4 of t4) for (const t5 of n4) {
          const n5 = [t5.x + a4[0], t5.y + a4[1]];
          Dr(n5, e3, r3, i3), s3.push(n5);
        }
        return s3;
      }
      function Fr(t4, e3, r3, n3) {
        const i3 = Math.pow(2, n3.z) * Pr, a4 = [n3.x * Pr, n3.y * Pr], s3 = [];
        if (!t4) return s3;
        for (const r4 of t4) {
          const t5 = [];
          for (const n4 of r4) {
            const r5 = [n4.x + a4[0], n4.y + a4[1]];
            _r(e3, r5), t5.push(r5);
          }
          s3.push(t5);
        }
        if (e3[2] - e3[0] <= i3 / 2) {
          (o3 = e3)[0] = o3[1] = 1 / 0, o3[2] = o3[3] = -1 / 0;
          for (const t5 of s3) for (const n4 of t5) Dr(n4, e3, r3, i3);
        }
        var o3;
        return s3;
      }
      class Or {
        constructor(t4, e3) {
          this.type = Le, this.geojson = t4, this.geometries = e3;
        }
        static parse(t4, e3) {
          if (2 !== t4.length) return e3.error(`'within' expression requires exactly one argument, but found ${t4.length - 1} instead.`);
          if (er(t4[1])) {
            const e4 = t4[1];
            if ("FeatureCollection" === e4.type) for (let t5 = 0; t5 < e4.features.length; ++t5) {
              const r3 = e4.features[t5].geometry.type;
              if ("Polygon" === r3 || "MultiPolygon" === r3) return new Or(e4, e4.features[t5].geometry);
            }
            else if ("Feature" === e4.type) {
              const t5 = e4.geometry.type;
              if ("Polygon" === t5 || "MultiPolygon" === t5) return new Or(e4, e4.geometry);
            } else if ("Polygon" === e4.type || "MultiPolygon" === e4.type) return new Or(e4, e4);
          }
          return e3.error("'within' expression requires valid geojson object that contains polygon geometry type.");
        }
        evaluate(t4) {
          if (null != t4.geometry() && null != t4.canonicalID()) {
            if ("Point" === t4.geometryType()) return function(t5, e3) {
              const r3 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], n3 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], i3 = t5.canonicalID();
              if (!i3) return false;
              if ("Polygon" === e3.type) {
                const a4 = Cr(e3.coordinates, n3, i3), s3 = Lr(t5.geometry(), r3, n3, i3);
                if (!Mr2(r3, n3)) return false;
                for (const t6 of s3) if (!Sr(t6, a4)) return false;
              }
              if ("MultiPolygon" === e3.type) {
                const a4 = Rr(e3.coordinates, n3, i3), s3 = Lr(t5.geometry(), r3, n3, i3);
                if (!Mr2(r3, n3)) return false;
                for (const t6 of s3) if (!Tr(t6, a4)) return false;
              }
              return true;
            }(t4, this.geometries);
            if ("LineString" === t4.geometryType()) return function(t5, e3) {
              const r3 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], n3 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], i3 = t5.canonicalID();
              if (!i3) return false;
              if ("Polygon" === e3.type) {
                const a4 = Cr(e3.coordinates, n3, i3), s3 = Fr(t5.geometry(), r3, n3, i3);
                if (!Mr2(r3, n3)) return false;
                for (const t6 of s3) if (!Br(t6, a4)) return false;
              }
              if ("MultiPolygon" === e3.type) {
                const a4 = Rr(e3.coordinates, n3, i3), s3 = Fr(t5.geometry(), r3, n3, i3);
                if (!Mr2(r3, n3)) return false;
                for (const t6 of s3) if (!Vr(t6, a4)) return false;
              }
              return true;
            }(t4, this.geometries);
          }
          return false;
        }
        eachChild() {
        }
        outputDefined() {
          return true;
        }
        serialize() {
          return ["within", this.geojson];
        }
      }
      const Ur = { kilometers: 1, miles: 1e3 / 1609.344, nauticalmiles: 1e3 / 1852, meters: 1e3, metres: 1e3, yards: 1e3 / 0.9144, feet: 1e3 / 0.3048, inches: 1e3 / 0.0254 }, jr = 1 / 298.257223563, Nr = jr * (2 - jr), qr = Math.PI / 180;
      class $r {
        static fromTile(t4, e3, r3) {
          const n3 = Math.PI * (1 - 2 * (t4 + 0.5) / Math.pow(2, e3)), i3 = Math.atan(0.5 * (Math.exp(n3) - Math.exp(-n3))) / qr;
          return new $r(i3, r3);
        }
        static get units() {
          return Ur;
        }
        constructor(t4, e3) {
          if (void 0 === t4) throw new Error("No latitude given.");
          if (e3 && !Ur[e3]) throw new Error(`Unknown unit ${e3}. Use one of: ${Object.keys(Ur).join(", ")}`);
          const r3 = 6378.137 * qr * (e3 ? Ur[e3] : 1), n3 = Math.cos(t4 * qr), i3 = 1 / (1 - Nr * (1 - n3 * n3)), a4 = Math.sqrt(i3);
          this.kx = r3 * a4 * n3, this.ky = r3 * a4 * i3 * (1 - Nr);
        }
        distance(t4, e3) {
          const r3 = Yr(t4[0] - e3[0]) * this.kx, n3 = (t4[1] - e3[1]) * this.ky;
          return Math.sqrt(r3 * r3 + n3 * n3);
        }
        bearing(t4, e3) {
          const r3 = Yr(e3[0] - t4[0]) * this.kx;
          return Math.atan2(r3, (e3[1] - t4[1]) * this.ky) / qr;
        }
        destination(t4, e3, r3) {
          const n3 = r3 * qr;
          return this.offset(t4, Math.sin(n3) * e3, Math.cos(n3) * e3);
        }
        offset(t4, e3, r3) {
          return [t4[0] + e3 / this.kx, t4[1] + r3 / this.ky];
        }
        lineDistance(t4) {
          let e3 = 0;
          for (let r3 = 0; r3 < t4.length - 1; r3++) e3 += this.distance(t4[r3], t4[r3 + 1]);
          return e3;
        }
        area(t4) {
          let e3 = 0;
          for (let r3 = 0; r3 < t4.length; r3++) {
            const n3 = t4[r3];
            for (let t5 = 0, i3 = n3.length, a4 = i3 - 1; t5 < i3; a4 = t5++) e3 += Yr(n3[t5][0] - n3[a4][0]) * (n3[t5][1] + n3[a4][1]) * (r3 ? -1 : 1);
          }
          return Math.abs(e3) / 2 * this.kx * this.ky;
        }
        along(t4, e3) {
          let r3 = 0;
          if (e3 <= 0) return t4[0];
          for (let n3 = 0; n3 < t4.length - 1; n3++) {
            const i3 = t4[n3], a4 = t4[n3 + 1], s3 = this.distance(i3, a4);
            if (r3 += s3, r3 > e3) return Xr(i3, a4, (e3 - (r3 - s3)) / s3);
          }
          return t4[t4.length - 1];
        }
        pointToSegmentDistance(t4, e3, r3) {
          let [n3, i3] = e3, a4 = Yr(r3[0] - n3) * this.kx, s3 = (r3[1] - i3) * this.ky;
          if (0 !== a4 || 0 !== s3) {
            const e4 = (Yr(t4[0] - n3) * this.kx * a4 + (t4[1] - i3) * this.ky * s3) / (a4 * a4 + s3 * s3);
            e4 > 1 ? (n3 = r3[0], i3 = r3[1]) : e4 > 0 && (n3 += a4 / this.kx * e4, i3 += s3 / this.ky * e4);
          }
          return a4 = Yr(t4[0] - n3) * this.kx, s3 = (t4[1] - i3) * this.ky, Math.sqrt(a4 * a4 + s3 * s3);
        }
        pointOnLine(t4, e3) {
          let r3 = 1 / 0, n3 = t4[0][0], i3 = t4[0][1], a4 = 0, s3 = 0;
          for (let o3 = 0; o3 < t4.length - 1; o3++) {
            let l3 = t4[o3][0], u4 = t4[o3][1], c3 = Yr(t4[o3 + 1][0] - l3) * this.kx, h3 = (t4[o3 + 1][1] - u4) * this.ky, p3 = 0;
            0 === c3 && 0 === h3 || (p3 = (Yr(e3[0] - l3) * this.kx * c3 + (e3[1] - u4) * this.ky * h3) / (c3 * c3 + h3 * h3), p3 > 1 ? (l3 = t4[o3 + 1][0], u4 = t4[o3 + 1][1]) : p3 > 0 && (l3 += c3 / this.kx * p3, u4 += h3 / this.ky * p3)), c3 = Yr(e3[0] - l3) * this.kx, h3 = (e3[1] - u4) * this.ky;
            const f3 = c3 * c3 + h3 * h3;
            f3 < r3 && (r3 = f3, n3 = l3, i3 = u4, a4 = o3, s3 = p3);
          }
          return { point: [n3, i3], index: a4, t: Math.max(0, Math.min(1, s3)) };
        }
        lineSlice(t4, e3, r3) {
          let n3 = this.pointOnLine(r3, t4), i3 = this.pointOnLine(r3, e3);
          if (n3.index > i3.index || n3.index === i3.index && n3.t > i3.t) {
            const t5 = n3;
            n3 = i3, i3 = t5;
          }
          const a4 = [n3.point], s3 = n3.index + 1, o3 = i3.index;
          !Gr(r3[s3], a4[0]) && s3 <= o3 && a4.push(r3[s3]);
          for (let t5 = s3 + 1; t5 <= o3; t5++) a4.push(r3[t5]);
          return Gr(r3[o3], i3.point) || a4.push(i3.point), a4;
        }
        lineSliceAlong(t4, e3, r3) {
          let n3 = 0;
          const i3 = [];
          for (let a4 = 0; a4 < r3.length - 1; a4++) {
            const s3 = r3[a4], o3 = r3[a4 + 1], l3 = this.distance(s3, o3);
            if (n3 += l3, n3 > t4 && 0 === i3.length && i3.push(Xr(s3, o3, (t4 - (n3 - l3)) / l3)), n3 >= e3) return i3.push(Xr(s3, o3, (e3 - (n3 - l3)) / l3)), i3;
            n3 > t4 && i3.push(o3);
          }
          return i3;
        }
        bufferPoint(t4, e3) {
          const r3 = e3 / this.ky, n3 = e3 / this.kx;
          return [t4[0] - n3, t4[1] - r3, t4[0] + n3, t4[1] + r3];
        }
        bufferBBox(t4, e3) {
          const r3 = e3 / this.ky, n3 = e3 / this.kx;
          return [t4[0] - n3, t4[1] - r3, t4[2] + n3, t4[3] + r3];
        }
        insideBBox(t4, e3) {
          return Yr(t4[0] - e3[0]) >= 0 && Yr(t4[0] - e3[2]) <= 0 && t4[1] >= e3[1] && t4[1] <= e3[3];
        }
      }
      function Gr(t4, e3) {
        return t4[0] === e3[0] && t4[1] === e3[1];
      }
      function Xr(t4, e3, r3) {
        const n3 = Yr(e3[0] - t4[0]);
        return [t4[0] + n3 * r3, t4[1] + (e3[1] - t4[1]) * r3];
      }
      function Yr(t4) {
        for (; t4 < -180; ) t4 += 360;
        for (; t4 > 180; ) t4 -= 360;
        return t4;
      }
      class Zr {
        constructor(t4 = [], e3 = (t5, e4) => t5 < e4 ? -1 : t5 > e4 ? 1 : 0) {
          if (this.data = t4, this.length = this.data.length, this.compare = e3, this.length > 0) for (let t5 = (this.length >> 1) - 1; t5 >= 0; t5--) this._down(t5);
        }
        push(t4) {
          this.data.push(t4), this._up(this.length++);
        }
        pop() {
          if (0 === this.length) return;
          const t4 = this.data[0], e3 = this.data.pop();
          return --this.length > 0 && (this.data[0] = e3, this._down(0)), t4;
        }
        peek() {
          return this.data[0];
        }
        _up(t4) {
          const { data: e3, compare: r3 } = this, n3 = e3[t4];
          for (; t4 > 0; ) {
            const i3 = t4 - 1 >> 1, a4 = e3[i3];
            if (r3(n3, a4) >= 0) break;
            e3[t4] = a4, t4 = i3;
          }
          e3[t4] = n3;
        }
        _down(t4) {
          const { data: e3, compare: r3 } = this, n3 = this.length >> 1, i3 = e3[t4];
          for (; t4 < n3; ) {
            let n4 = 1 + (t4 << 1);
            const a4 = n4 + 1;
            if (a4 < this.length && r3(e3[a4], e3[n4]) < 0 && (n4 = a4), r3(e3[n4], i3) >= 0) break;
            e3[t4] = e3[n4], t4 = n4;
          }
          e3[t4] = i3;
        }
      }
      var Wr = 8192;
      function Hr(t4, e3) {
        return e3.dist - t4.dist;
      }
      const Kr = 100, Jr = 50;
      function Qr(t4) {
        const e3 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
        if (e3.length !== t4.length) return false;
        for (let r3 = 0; r3 < e3.length; r3++) if (e3[r3] !== t4[r3]) return false;
        return true;
      }
      function tn(t4) {
        return t4[1] - t4[0] + 1;
      }
      function en(t4, e3) {
        const r3 = t4[1] >= t4[0] && t4[1] < e3;
        return r3 || console.warn("Distance Expression: Index is out of range"), r3;
      }
      function rn(t4, e3) {
        if (t4[0] > t4[1]) return [null, null];
        const r3 = tn(t4);
        if (e3) {
          if (2 === r3) return [t4, null];
          const e4 = Math.floor(r3 / 2);
          return [[t4[0], t4[0] + e4], [t4[0] + e4, t4[1]]];
        }
        {
          if (1 === r3) return [t4, null];
          const e4 = Math.floor(r3 / 2) - 1;
          return [[t4[0], t4[0] + e4], [t4[0] + e4 + 1, t4[1]]];
        }
      }
      function nn(t4, e3) {
        const r3 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
        if (!en(e3, t4.length)) return r3;
        for (let n3 = e3[0]; n3 <= e3[1]; ++n3) _r(r3, t4[n3]);
        return r3;
      }
      function an(t4) {
        const e3 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
        for (let r3 = 0; r3 < t4.length; ++r3) for (let n3 = 0; n3 < t4[r3].length; ++n3) _r(e3, t4[r3][n3]);
        return e3;
      }
      function sn(t4, e3, r3) {
        if (Qr(t4) || Qr(e3)) return NaN;
        let n3 = 0, i3 = 0;
        return t4[2] < e3[0] && (n3 = e3[0] - t4[2]), t4[0] > e3[2] && (n3 = t4[0] - e3[2]), t4[1] > e3[3] && (i3 = t4[1] - e3[3]), t4[3] < e3[1] && (i3 = e3[1] - t4[3]), r3.distance([0, 0], [n3, i3]);
      }
      function on(t4) {
        return 360 * t4 - 180;
      }
      function ln(t4) {
        return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t4) * Math.PI / 180)) - 90;
      }
      function un(t4, e3) {
        const r3 = Math.pow(2, e3.z), n3 = (t4.y / Wr + e3.y) / r3;
        return [on((t4.x / Wr + e3.x) / r3), ln(n3)];
      }
      function cn(t4, e3) {
        const r3 = [];
        for (let n3 = 0; n3 < t4.length; ++n3) r3.push(un(t4[n3], e3));
        return r3;
      }
      function hn(t4, e3, r3) {
        const n3 = r3.pointOnLine(e3, t4).point;
        return r3.distance(t4, n3);
      }
      function pn(t4, e3, r3, n3, i3) {
        const a4 = r3.slice(n3[0], n3[1] + 1);
        let s3 = 1 / 0;
        for (let r4 = e3[0]; r4 <= e3[1]; ++r4) if (0 === (s3 = Math.min(s3, hn(t4[r4], a4, i3)))) return 0;
        return s3;
      }
      function fn(t4, e3, r3, n3, i3) {
        const a4 = Math.min(i3.pointToSegmentDistance(t4, r3, n3), i3.pointToSegmentDistance(e3, r3, n3)), s3 = Math.min(i3.pointToSegmentDistance(r3, t4, e3), i3.pointToSegmentDistance(n3, t4, e3));
        return Math.min(a4, s3);
      }
      function dn(t4, e3, r3, n3, i3) {
        if (!en(e3, t4.length) || !en(n3, r3.length)) return NaN;
        let a4 = 1 / 0;
        for (let s3 = e3[0]; s3 < e3[1]; ++s3) for (let e4 = n3[0]; e4 < n3[1]; ++e4) {
          if (zr(t4[s3], t4[s3 + 1], r3[e4], r3[e4 + 1])) return 0;
          a4 = Math.min(a4, fn(t4[s3], t4[s3 + 1], r3[e4], r3[e4 + 1], i3));
        }
        return a4;
      }
      function mn(t4, e3, r3, n3, i3) {
        if (!en(e3, t4.length) || !en(n3, r3.length)) return NaN;
        let a4 = 1 / 0;
        for (let s3 = e3[0]; s3 <= e3[1]; ++s3) for (let e4 = n3[0]; e4 <= n3[1]; ++e4) if (0 === (a4 = Math.min(a4, i3.distance(t4[s3], r3[e4])))) return a4;
        return a4;
      }
      function yn(t4, e3, r3) {
        if (Sr(t4, e3, true)) return 0;
        let n3 = 1 / 0;
        for (const i3 of e3) {
          const e4 = i3.length;
          if (e4 < 2) return console.warn("Distance Expression: Invalid polygon!"), NaN;
          if (i3[0] !== i3[e4 - 1] && 0 === (n3 = Math.min(n3, r3.pointToSegmentDistance(t4, i3[e4 - 1], i3[0])))) return n3;
          if (0 === (n3 = Math.min(n3, hn(t4, i3, r3)))) return n3;
        }
        return n3;
      }
      function gn(t4, e3, r3, n3) {
        if (!en(e3, t4.length)) return NaN;
        for (let n4 = e3[0]; n4 <= e3[1]; ++n4) if (Sr(t4[n4], r3, true)) return 0;
        let i3 = 1 / 0;
        for (let a4 = e3[0]; a4 < e3[1]; ++a4) for (const e4 of r3) for (let r4 = 0, s3 = e4.length, o3 = s3 - 1; r4 < s3; o3 = r4++) {
          if (zr(t4[a4], t4[a4 + 1], e4[o3], e4[r4])) return 0;
          i3 = Math.min(i3, fn(t4[a4], t4[a4 + 1], e4[o3], e4[r4], n3));
        }
        return i3;
      }
      function xn(t4, e3) {
        for (const r3 of t4) for (let t5 = 0; t5 <= r3.length - 1; ++t5) if (Sr(r3[t5], e3, true)) return true;
        return false;
      }
      function vn(t4, e3, r3, n3 = 1 / 0) {
        const i3 = an(t4), a4 = an(e3);
        if (n3 !== 1 / 0 && sn(i3, a4, r3) >= n3) return n3;
        if (Mr2(i3, a4)) {
          if (xn(t4, e3)) return 0;
        } else if (xn(e3, t4)) return 0;
        let s3 = n3;
        for (const n4 of t4) for (let t5 = 0, i4 = n4.length, a5 = i4 - 1; t5 < i4; a5 = t5++) for (const i5 of e3) for (let e4 = 0, o3 = i5.length, l3 = o3 - 1; e4 < o3; l3 = e4++) {
          if (zr(n4[a5], n4[t5], i5[l3], i5[e4])) return 0;
          s3 = Math.min(s3, fn(n4[a5], n4[t5], i5[l3], i5[e4], r3));
        }
        return s3;
      }
      function bn(t4, e3, r3, n3, i3, a4, s3) {
        if (null === a4 || null === s3) return;
        const o3 = sn(nn(n3, a4), nn(i3, s3), r3);
        o3 < e3 && t4.push({ dist: o3, range1: a4, range2: s3 });
      }
      function wn(t4, e3, r3, n3, i3 = 1 / 0) {
        let a4 = Math.min(n3.distance(t4[0], r3[0][0]), i3);
        if (0 === a4) return a4;
        const s3 = new Zr([{ dist: 0, range1: [0, t4.length - 1], range2: [0, 0] }], Hr), o3 = e3 ? Jr : Kr, l3 = an(r3);
        for (; s3.length; ) {
          const i4 = s3.pop();
          if (i4.dist >= a4) continue;
          const u4 = i4.range1;
          if (tn(u4) <= o3) {
            if (!en(u4, t4.length)) return NaN;
            if (e3) {
              const e4 = gn(t4, u4, r3, n3);
              if (0 === (a4 = Math.min(a4, e4))) return a4;
            } else for (let e4 = u4[0]; e4 <= u4[1]; ++e4) {
              const i5 = yn(t4[e4], r3, n3);
              if (0 === (a4 = Math.min(a4, i5))) return a4;
            }
          } else {
            const r4 = rn(u4, e3);
            if (null !== r4[0]) {
              const e4 = sn(nn(t4, r4[0]), l3, n3);
              e4 < a4 && s3.push({ dist: e4, range1: r4[0], range2: [0, 0] });
            }
            if (null !== r4[1]) {
              const e4 = sn(nn(t4, r4[1]), l3, n3);
              e4 < a4 && s3.push({ dist: e4, range1: r4[1], range2: [0, 0] });
            }
          }
        }
        return a4;
      }
      function _n(t4, e3, r3, n3, i3, a4 = 1 / 0) {
        let s3 = Math.min(a4, i3.distance(t4[0], r3[0]));
        if (0 === s3) return s3;
        const o3 = new Zr([{ dist: 0, range1: [0, t4.length - 1], range2: [0, r3.length - 1] }], Hr), l3 = e3 ? Jr : Kr, u4 = n3 ? Jr : Kr;
        for (; o3.length; ) {
          const a5 = o3.pop();
          if (a5.dist >= s3) continue;
          const c3 = a5.range1, h3 = a5.range2;
          if (tn(c3) <= l3 && tn(h3) <= u4) {
            if (!en(c3, t4.length) || !en(h3, r3.length)) return NaN;
            if (e3 && n3 ? s3 = Math.min(s3, dn(t4, c3, r3, h3, i3)) : e3 || n3 ? e3 && !n3 ? s3 = Math.min(s3, pn(r3, h3, t4, c3, i3)) : !e3 && n3 && (s3 = Math.min(s3, pn(t4, c3, r3, h3, i3))) : s3 = Math.min(s3, mn(t4, c3, r3, h3, i3)), 0 === s3) return s3;
          } else {
            const a6 = rn(c3, e3), l4 = rn(h3, n3);
            bn(o3, s3, i3, t4, r3, a6[0], l4[0]), bn(o3, s3, i3, t4, r3, a6[0], l4[1]), bn(o3, s3, i3, t4, r3, a6[1], l4[0]), bn(o3, s3, i3, t4, r3, a6[1], l4[1]);
          }
        }
        return s3;
      }
      function Mn(t4, e3, r3, n3, i3 = 1 / 0) {
        let a4 = i3;
        const s3 = nn(t4, [0, t4.length - 1]);
        for (const i4 of r3) if (!(a4 !== 1 / 0 && sn(s3, nn(i4, [0, i4.length - 1]), n3) >= a4) && (a4 = Math.min(a4, _n(t4, e3, i4, true, n3, a4)), 0 === a4)) return a4;
        return a4;
      }
      function An(t4, e3, r3, n3, i3 = 1 / 0) {
        let a4 = i3;
        const s3 = nn(t4, [0, t4.length - 1]);
        for (const i4 of r3) {
          if (a4 !== 1 / 0 && sn(s3, an(i4), n3) >= a4) continue;
          const r4 = wn(t4, e3, i4, n3, a4);
          if (isNaN(r4)) return r4;
          if (0 === (a4 = Math.min(a4, r4))) return a4;
        }
        return a4;
      }
      function Sn2(t4) {
        return "Point" === t4 || "MultiPoint" === t4 || "LineString" === t4 || "MultiLineString" === t4 || "Polygon" === t4 || "MultiPolygon" === t4;
      }
      class In2 {
        constructor(t4, e3) {
          this.type = Re, this.geojson = t4, this.geometries = e3;
        }
        static parse(t4, e3) {
          if (2 !== t4.length) return e3.error(`'distance' expression requires either one argument, but found ' ${t4.length - 1} instead.`);
          if (er(t4[1])) {
            const e4 = t4[1];
            if ("FeatureCollection" === e4.type) {
              for (let t5 = 0; t5 < e4.features.length; ++t5) if (Sn2(e4.features[t5].geometry.type)) return new In2(e4, e4.features[t5].geometry);
            } else if ("Feature" === e4.type) {
              if (Sn2(e4.geometry.type)) return new In2(e4, e4.geometry);
            } else if (Sn2(e4.type)) return new In2(e4, e4);
          }
          return e3.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].");
        }
        evaluate(t4) {
          const e3 = t4.geometry(), r3 = t4.canonicalID();
          if (null != e3 && null != r3) {
            if ("Point" === t4.geometryType()) return function(t5, e4, r4) {
              const n3 = [];
              for (const r5 of t5) for (const t6 of r5) n3.push(un(t6, e4));
              const i3 = new $r(n3[0][1], "meters");
              return "Point" === r4.type || "MultiPoint" === r4.type || "LineString" === r4.type ? _n(n3, false, "Point" === r4.type ? [r4.coordinates] : r4.coordinates, "LineString" === r4.type, i3) : "MultiLineString" === r4.type ? Mn(n3, false, r4.coordinates, i3) : "Polygon" === r4.type || "MultiPolygon" === r4.type ? An(n3, false, "Polygon" === r4.type ? [r4.coordinates] : r4.coordinates, i3) : null;
            }(e3, r3, this.geometries);
            if ("LineString" === t4.geometryType()) return function(t5, e4, r4) {
              const n3 = [];
              for (const r5 of t5) {
                const t6 = [];
                for (const n4 of r5) t6.push(un(n4, e4));
                n3.push(t6);
              }
              const i3 = new $r(n3[0][0][1], "meters");
              if ("Point" === r4.type || "MultiPoint" === r4.type || "LineString" === r4.type) return Mn("Point" === r4.type ? [r4.coordinates] : r4.coordinates, "LineString" === r4.type, n3, i3);
              if ("MultiLineString" === r4.type) {
                let t6 = 1 / 0;
                for (let e5 = 0; e5 < r4.coordinates.length; e5++) {
                  const a4 = Mn(r4.coordinates[e5], true, n3, i3, t6);
                  if (isNaN(a4)) return a4;
                  if (0 === (t6 = Math.min(t6, a4))) return t6;
                }
                return t6;
              }
              if ("Polygon" === r4.type || "MultiPolygon" === r4.type) {
                let t6 = 1 / 0;
                for (let e5 = 0; e5 < n3.length; e5++) {
                  const a4 = An(n3[e5], true, "Polygon" === r4.type ? [r4.coordinates] : r4.coordinates, i3, t6);
                  if (isNaN(a4)) return a4;
                  if (0 === (t6 = Math.min(t6, a4))) return t6;
                }
                return t6;
              }
              return null;
            }(e3, r3, this.geometries);
            if ("Polygon" === t4.geometryType()) return function(t5, e4, r4) {
              const n3 = [];
              for (const r5 of function(t6, e5) {
                const r6 = t6.length;
                if (r6 <= 1) return [t6];
                const n4 = [];
                let i4, a4;
                for (let e6 = 0; e6 < r6; e6++) {
                  const r7 = wr(t6[e6]);
                  0 !== r7 && (t6[e6].area = Math.abs(r7), void 0 === a4 && (a4 = r7 < 0), a4 === r7 < 0 ? (i4 && n4.push(i4), i4 = [t6[e6]]) : i4.push(t6[e6]));
                }
                return i4 && n4.push(i4), n4;
              }(t5)) {
                const t6 = [];
                for (let n4 = 0; n4 < r5.length; ++n4) t6.push(cn(r5[n4], e4));
                n3.push(t6);
              }
              const i3 = new $r(n3[0][0][0][1], "meters");
              if ("Point" === r4.type || "MultiPoint" === r4.type || "LineString" === r4.type) return An("Point" === r4.type ? [r4.coordinates] : r4.coordinates, "LineString" === r4.type, n3, i3);
              if ("MultiLineString" === r4.type) {
                let t6 = 1 / 0;
                for (let e5 = 0; e5 < r4.coordinates.length; e5++) {
                  const a4 = An(r4.coordinates[e5], true, n3, i3, t6);
                  if (isNaN(a4)) return a4;
                  if (0 === (t6 = Math.min(t6, a4))) return t6;
                }
                return t6;
              }
              return "Polygon" === r4.type || "MultiPolygon" === r4.type ? function(t6, e5, r5) {
                let n4 = 1 / 0;
                for (const i4 of t6) for (const t7 of e5) {
                  const e6 = vn(i4, t7, r5, n4);
                  if (isNaN(e6)) return e6;
                  if (0 === (n4 = Math.min(n4, e6))) return n4;
                }
                return n4;
              }("Polygon" === r4.type ? [r4.coordinates] : r4.coordinates, n3, i3) : null;
            }(e3, r3, this.geometries);
            console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries.");
          } else console.warn("Distance Expression: requirs valid feature and canonical information.");
          return null;
        }
        eachChild() {
        }
        outputDefined() {
          return true;
        }
        serialize() {
          return ["distance", this.geojson];
        }
      }
      function zn(t4, e3) {
        switch (t4) {
          case "string":
            return nr(e3);
          case "number":
            return +e3;
          case "boolean":
            return !!e3;
          case "color":
            return Ie.parse(e3);
          case "formatted":
            return Je.fromString(nr(e3));
          case "resolvedImage":
            return Qe.fromString(nr(e3));
        }
        return e3;
      }
      function Pn(t4, e3, r3, n3) {
        return void 0 !== n3 && (t4 = n3 * Math.round(t4 / n3)), void 0 !== e3 && t4 < e3 && (t4 = e3), void 0 !== r3 && t4 > r3 && (t4 = r3), t4;
      }
      class kn {
        constructor(t4, e3, r3) {
          this.type = t4, this.key = e3, this.scope = r3;
        }
        static parse(t4, e3) {
          let r3 = e3.expectedType;
          if (null == r3 && (r3 = Ue), t4.length < 2 || t4.length > 3) return e3.error("Invalid number of arguments for 'config' expression.");
          const n3 = e3.parse(t4[1], 1);
          if (!(n3 instanceof ir)) return e3.error("Key name of 'config' expression must be a string literal.");
          if (t4.length >= 3) {
            const i3 = e3.parse(t4[2], 2);
            return i3 instanceof ir ? new kn(r3, nr(n3.value), nr(i3.value)) : e3.error("Scope of 'config' expression must be a string literal.");
          }
          return new kn(r3, nr(n3.value));
        }
        evaluate(t4) {
          const e3 = [this.key, this.scope, t4.scope].filter(Boolean).join(""), r3 = t4.getConfig(e3);
          if (!r3) return null;
          const { type: n3, value: i3, values: a4, minValue: s3, maxValue: o3, stepValue: l3 } = r3, u4 = r3.default.evaluate(t4);
          let c3 = u4;
          if (i3) {
            const e4 = t4.scope;
            t4.scope = (e4 || "").split("").slice(1).join(""), c3 = i3.evaluate(t4), t4.scope = e4;
          }
          return n3 && (c3 = zn(n3, c3)), void 0 === c3 || void 0 === s3 && void 0 === o3 && void 0 === l3 || ("number" == typeof c3 ? c3 = Pn(c3, s3, o3, l3) : Array.isArray(c3) && (c3 = c3.map((t5) => "number" == typeof t5 ? Pn(t5, s3, o3, l3) : t5))), void 0 !== i3 && void 0 !== c3 && a4 && !a4.includes(c3) && (c3 = u4, n3 && (c3 = zn(n3, c3))), (n3 && n3 !== this.type || void 0 !== c3 && rr(c3) !== this.type) && (c3 = zn(this.type.kind, c3)), c3;
        }
        eachChild() {
        }
        outputDefined() {
          return false;
        }
        serialize() {
          const t4 = ["config", this.key];
          return this.scope && t4.concat(this.key), t4;
        }
      }
      function Tn(t4) {
        if (t4 instanceof mr) {
          if ("get" === t4.name && 1 === t4.args.length) return false;
          if ("feature-state" === t4.name) return false;
          if ("has" === t4.name && 1 === t4.args.length) return false;
          if ("properties" === t4.name || "geometry-type" === t4.name || "id" === t4.name) return false;
          if (/^filter-/.test(t4.name)) return false;
        }
        if (t4 instanceof Or) return false;
        if (t4 instanceof In2) return false;
        let e3 = true;
        return t4.eachChild((t5) => {
          e3 && !Tn(t5) && (e3 = false);
        }), e3;
      }
      function En(t4) {
        if (t4 instanceof mr && "feature-state" === t4.name) return false;
        let e3 = true;
        return t4.eachChild((t5) => {
          e3 && !En(t5) && (e3 = false);
        }), e3;
      }
      function Bn(t4) {
        if (t4 instanceof kn) return /* @__PURE__ */ new Set([t4.key]);
        let e3 = /* @__PURE__ */ new Set();
        return t4.eachChild((t5) => {
          e3 = /* @__PURE__ */ new Set([...e3, ...Bn(t5)]);
        }), e3;
      }
      function Vn(t4, e3) {
        if (t4 instanceof mr && e3.indexOf(t4.name) >= 0) return false;
        let r3 = true;
        return t4.eachChild((t5) => {
          r3 && !Vn(t5, e3) && (r3 = false);
        }), r3;
      }
      class Cn {
        constructor(t4, e3) {
          this.type = e3.type, this.name = t4, this.boundExpression = e3;
        }
        static parse(t4, e3) {
          if (2 !== t4.length || "string" != typeof t4[1]) return e3.error("'var' expression requires exactly one string literal argument.");
          const r3 = t4[1];
          return e3.scope.has(r3) ? new Cn(r3, e3.scope.get(r3)) : e3.error(`Unknown variable "${r3}". Make sure "${r3}" has been bound in an enclosing "let" expression before using it.`, 1);
        }
        evaluate(t4) {
          return this.boundExpression.evaluate(t4);
        }
        eachChild() {
        }
        outputDefined() {
          return false;
        }
        serialize() {
          return ["var", this.name];
        }
      }
      class Rn {
        constructor(t4, e3 = [], r3, n3 = new Ve(), i3 = [], a4, s3) {
          this.registry = t4, this.path = e3, this.key = e3.map((t5) => "string" == typeof t5 ? `['${t5}']` : `[${t5}]`).join(""), this.scope = n3, this.errors = i3, this.expectedType = r3, this._scope = a4, this.options = s3;
        }
        parse(t4, e3, r3, n3, i3 = {}) {
          return e3 || r3 ? this.concat(e3, null, r3, n3)._parse(t4, i3) : this._parse(t4, i3);
        }
        parseObjectValue(t4, e3, r3, n3, i3, a4 = {}) {
          return this.concat(e3, r3, n3, i3)._parse(t4, a4);
        }
        _parse(t4, e3) {
          function r3(t5, e4, r4) {
            return "assert" === r4 ? new or(e4, [t5]) : "coerce" === r4 ? new pr(e4, [t5]) : t5;
          }
          if (null !== t4 && "string" != typeof t4 && "boolean" != typeof t4 && "number" != typeof t4 || (t4 = ["literal", t4]), Array.isArray(t4)) {
            if (0 === t4.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
            const n3 = "string" == typeof t4[0] ? this.registry[t4[0]] : void 0;
            if (n3) {
              let i3 = n3.parse(t4, this);
              if (!i3) return null;
              if (this.expectedType) {
                const t5 = this.expectedType, n4 = i3.type;
                if ("string" !== t5.kind && "number" !== t5.kind && "boolean" !== t5.kind && "object" !== t5.kind && "array" !== t5.kind || "value" !== n4.kind) if ("color" !== t5.kind && "formatted" !== t5.kind && "resolvedImage" !== t5.kind || "value" !== n4.kind && "string" !== n4.kind) {
                  if (this.checkSubtype(t5, n4)) return null;
                } else i3 = r3(i3, t5, e3.typeAnnotation || "coerce");
                else i3 = r3(i3, t5, e3.typeAnnotation || "assert");
              }
              if (!(i3 instanceof ir) && "resolvedImage" !== i3.type.kind && Dn(i3)) {
                const t5 = new dr(this._scope, this.options);
                try {
                  i3 = new ir(i3.type, i3.evaluate(t5));
                } catch (t6) {
                  return this.error(t6.message), null;
                }
              }
              return i3;
            }
            return pr.parse(["to-array", t4], this);
          }
          return this.error(void 0 === t4 ? "'undefined' value invalid. Use null instead." : "object" == typeof t4 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t4} instead.`);
        }
        concat(t4, e3, r3, n3) {
          let i3 = "number" == typeof t4 ? this.path.concat(t4) : this.path;
          i3 = "string" == typeof e3 ? i3.concat(e3) : i3;
          const a4 = n3 ? this.scope.concat(n3) : this.scope;
          return new Rn(this.registry, i3, r3 || null, a4, this.errors, this._scope, this.options);
        }
        error(t4, ...e3) {
          const r3 = `${this.key}${e3.map((t5) => `[${t5}]`).join("")}`;
          this.errors.push(new Be(r3, t4));
        }
        checkSubtype(t4, e3) {
          const r3 = Ye(t4, e3);
          return r3 && this.error(r3), r3;
        }
      }
      function Dn(t4) {
        if (t4 instanceof Cn) return Dn(t4.boundExpression);
        if (t4 instanceof mr && "error" === t4.name) return false;
        if (t4 instanceof gr) return false;
        if (t4 instanceof Or) return false;
        if (t4 instanceof In2) return false;
        if (t4 instanceof kn) return false;
        const e3 = t4 instanceof pr || t4 instanceof or;
        let r3 = true;
        return t4.eachChild((t5) => {
          r3 = e3 ? r3 && Dn(t5) : r3 && t5 instanceof ir;
        }), !!r3 && Tn(t4) && Vn(t4, ["zoom", "heatmap-density", "line-progress", "raster-value", "sky-radial-progress", "accumulated", "is-supported-script", "pitch", "distance-from-center", "measure-light", "raster-particle-speed"]);
      }
      function Ln(t4, e3) {
        const r3 = t4.length - 1;
        let n3, i3, a4 = 0, s3 = r3, o3 = 0;
        for (; a4 <= s3; ) if (o3 = Math.floor((a4 + s3) / 2), n3 = t4[o3], i3 = t4[o3 + 1], n3 <= e3) {
          if (o3 === r3 || e3 < i3) return o3;
          a4 = o3 + 1;
        } else {
          if (!(n3 > e3)) throw new ar("Input is not a number.");
          s3 = o3 - 1;
        }
        return 0;
      }
      class Fn {
        constructor(t4, e3, r3) {
          this.type = t4, this.input = e3, this.labels = [], this.outputs = [];
          for (const [t5, e4] of r3) this.labels.push(t5), this.outputs.push(e4);
        }
        static parse(t4, e3) {
          if (t4.length - 1 < 4) return e3.error(`Expected at least 4 arguments, but found only ${t4.length - 1}.`);
          if ((t4.length - 1) % 2 != 0) return e3.error("Expected an even number of arguments.");
          const r3 = e3.parse(t4[1], 1, Re);
          if (!r3) return null;
          const n3 = [];
          let i3 = null;
          e3.expectedType && "value" !== e3.expectedType.kind && (i3 = e3.expectedType);
          for (let r4 = 1; r4 < t4.length; r4 += 2) {
            const a4 = 1 === r4 ? -1 / 0 : t4[r4], s3 = t4[r4 + 1], o3 = r4, l3 = r4 + 1;
            if ("number" != typeof a4) return e3.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o3);
            if (n3.length && n3[n3.length - 1][0] >= a4) return e3.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o3);
            const u4 = e3.parse(s3, l3, i3);
            if (!u4) return null;
            i3 = i3 || u4.type, n3.push([a4, u4]);
          }
          return new Fn(i3, r3, n3);
        }
        evaluate(t4) {
          const e3 = this.labels, r3 = this.outputs;
          if (1 === e3.length) return r3[0].evaluate(t4);
          const n3 = this.input.evaluate(t4);
          if (n3 <= e3[0]) return r3[0].evaluate(t4);
          const i3 = e3.length;
          return n3 >= e3[i3 - 1] ? r3[i3 - 1].evaluate(t4) : r3[Ln(e3, n3)].evaluate(t4);
        }
        eachChild(t4) {
          t4(this.input);
          for (const e3 of this.outputs) t4(e3);
        }
        outputDefined() {
          return this.outputs.every((t4) => t4.outputDefined());
        }
        serialize() {
          const t4 = ["step", this.input.serialize()];
          for (let e3 = 0; e3 < this.labels.length; e3++) e3 > 0 && t4.push(this.labels[e3]), t4.push(this.outputs[e3].serialize());
          return t4;
        }
      }
      const On = 0.95047, Un2 = 1.08883, jn = 4 / 29, Nn = 6 / 29, qn2 = 3 * Nn * Nn, $n = Nn * Nn * Nn, Gn2 = Math.PI / 180, Xn = 180 / Math.PI;
      function Yn(t4) {
        return t4 > $n ? Math.pow(t4, 1 / 3) : t4 / qn2 + jn;
      }
      function Zn(t4) {
        return t4 > Nn ? t4 * t4 * t4 : qn2 * (t4 - jn);
      }
      function Wn(t4) {
        return 255 * (t4 <= 31308e-7 ? 12.92 * t4 : 1.055 * Math.pow(t4, 1 / 2.4) - 0.055);
      }
      function Hn(t4) {
        return (t4 /= 255) <= 0.04045 ? t4 / 12.92 : Math.pow((t4 + 0.055) / 1.055, 2.4);
      }
      function Kn(t4) {
        const e3 = Hn(t4.r), r3 = Hn(t4.g), n3 = Hn(t4.b), i3 = Yn((0.4124564 * e3 + 0.3575761 * r3 + 0.1804375 * n3) / On), a4 = Yn((0.2126729 * e3 + 0.7151522 * r3 + 0.072175 * n3) / 1);
        return { l: 116 * a4 - 16, a: 500 * (i3 - a4), b: 200 * (a4 - Yn((0.0193339 * e3 + 0.119192 * r3 + 0.9503041 * n3) / Un2)), alpha: t4.a };
      }
      function Jn(t4) {
        let e3 = (t4.l + 16) / 116, r3 = isNaN(t4.a) ? e3 : e3 + t4.a / 500, n3 = isNaN(t4.b) ? e3 : e3 - t4.b / 200;
        return e3 = 1 * Zn(e3), r3 = On * Zn(r3), n3 = Un2 * Zn(n3), new Ie(Wn(3.2404542 * r3 - 1.5371385 * e3 - 0.4985314 * n3), Wn(-0.969266 * r3 + 1.8760108 * e3 + 0.041556 * n3), Wn(0.0556434 * r3 - 0.2040259 * e3 + 1.0572252 * n3), t4.alpha);
      }
      function Qn(t4, e3, r3) {
        const n3 = e3 - t4;
        return t4 + r3 * (n3 > 180 || n3 < -180 ? n3 - 360 * Math.round(n3 / 360) : n3);
      }
      const ti2 = { forward: Kn, reverse: Jn, interpolate: function(t4, e3, r3) {
        return { l: Pe(t4.l, e3.l, r3), a: Pe(t4.a, e3.a, r3), b: Pe(t4.b, e3.b, r3), alpha: Pe(t4.alpha, e3.alpha, r3) };
      } }, ei = { forward: function(t4) {
        const { l: e3, a: r3, b: n3 } = Kn(t4), i3 = Math.atan2(n3, r3) * Xn;
        return { h: i3 < 0 ? i3 + 360 : i3, c: Math.sqrt(r3 * r3 + n3 * n3), l: e3, alpha: t4.a };
      }, reverse: function(t4) {
        const e3 = t4.h * Gn2, r3 = t4.c;
        return Jn({ l: t4.l, a: Math.cos(e3) * r3, b: Math.sin(e3) * r3, alpha: t4.alpha });
      }, interpolate: function(t4, e3, r3) {
        return { h: Qn(t4.h, e3.h, r3), c: Pe(t4.c, e3.c, r3), l: Pe(t4.l, e3.l, r3), alpha: Pe(t4.alpha, e3.alpha, r3) };
      } };
      var ri = Object.freeze({ __proto__: null, hcl: ei, lab: ti2 });
      class ni {
        constructor(t4, e3, r3, n3, i3) {
          this.type = t4, this.operator = e3, this.interpolation = r3, this.input = n3, this.labels = [], this.outputs = [];
          for (const [t5, e4] of i3) this.labels.push(t5), this.outputs.push(e4);
        }
        static interpolationFactor(t4, e3, r3, n3) {
          let i3 = 0;
          if ("exponential" === t4.name) i3 = ii(e3, t4.base, r3, n3);
          else if ("linear" === t4.name) i3 = ii(e3, 1, r3, n3);
          else if ("cubic-bezier" === t4.name) {
            const a4 = t4.controlPoints;
            i3 = new j(a4[0], a4[1], a4[2], a4[3]).solve(ii(e3, 1, r3, n3));
          }
          return i3;
        }
        static parse(t4, e3) {
          let [r3, n3, i3, ...a4] = t4;
          if (!Array.isArray(n3) || 0 === n3.length) return e3.error("Expected an interpolation type expression.", 1);
          if ("linear" === n3[0]) n3 = { name: "linear" };
          else if ("exponential" === n3[0]) {
            const t5 = n3[1];
            if ("number" != typeof t5) return e3.error("Exponential interpolation requires a numeric base.", 1, 1);
            n3 = { name: "exponential", base: t5 };
          } else {
            if ("cubic-bezier" !== n3[0]) return e3.error(`Unknown interpolation type ${String(n3[0])}`, 1, 0);
            {
              const t5 = n3.slice(1);
              if (4 !== t5.length || t5.some((t6) => "number" != typeof t6 || t6 < 0 || t6 > 1)) return e3.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
              n3 = { name: "cubic-bezier", controlPoints: t5 };
            }
          }
          if (t4.length - 1 < 4) return e3.error(`Expected at least 4 arguments, but found only ${t4.length - 1}.`);
          if ((t4.length - 1) % 2 != 0) return e3.error("Expected an even number of arguments.");
          if (i3 = e3.parse(i3, 2, Re), !i3) return null;
          const s3 = [];
          let o3 = null;
          "interpolate-hcl" === r3 || "interpolate-lab" === r3 ? o3 = Fe : e3.expectedType && "value" !== e3.expectedType.kind && (o3 = e3.expectedType);
          for (let t5 = 0; t5 < a4.length; t5 += 2) {
            const r4 = a4[t5], n4 = a4[t5 + 1], i4 = t5 + 3, l3 = t5 + 4;
            if ("number" != typeof r4) return e3.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i4);
            if (s3.length && s3[s3.length - 1][0] >= r4) return e3.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i4);
            const u4 = e3.parse(n4, l3, o3);
            if (!u4) return null;
            o3 = o3 || u4.type, s3.push([r4, u4]);
          }
          return "number" === o3.kind || "color" === o3.kind || "array" === o3.kind && "number" === o3.itemType.kind && "number" == typeof o3.N ? new ni(o3, r3, n3, i3, s3) : e3.error(`Type ${Ge(o3)} is not interpolatable.`);
        }
        evaluate(t4) {
          const e3 = this.labels, r3 = this.outputs;
          if (1 === e3.length) return r3[0].evaluate(t4);
          const n3 = this.input.evaluate(t4);
          if (n3 <= e3[0]) return r3[0].evaluate(t4);
          const i3 = e3.length;
          if (n3 >= e3[i3 - 1]) return r3[i3 - 1].evaluate(t4);
          const a4 = Ln(e3, n3), s3 = ni.interpolationFactor(this.interpolation, n3, e3[a4], e3[a4 + 1]), o3 = r3[a4].evaluate(t4), l3 = r3[a4 + 1].evaluate(t4);
          return "interpolate" === this.operator ? Te[this.type.kind.toLowerCase()](o3, l3, s3) : "interpolate-hcl" === this.operator ? ei.reverse(ei.interpolate(ei.forward(o3), ei.forward(l3), s3)) : ti2.reverse(ti2.interpolate(ti2.forward(o3), ti2.forward(l3), s3));
        }
        eachChild(t4) {
          t4(this.input);
          for (const e3 of this.outputs) t4(e3);
        }
        outputDefined() {
          return this.outputs.every((t4) => t4.outputDefined());
        }
        serialize() {
          let t4;
          t4 = "linear" === this.interpolation.name ? ["linear"] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? ["linear"] : ["exponential", this.interpolation.base] : ["cubic-bezier"].concat(this.interpolation.controlPoints);
          const e3 = [this.operator, t4, this.input.serialize()];
          for (let t5 = 0; t5 < this.labels.length; t5++) e3.push(this.labels[t5], this.outputs[t5].serialize());
          return e3;
        }
      }
      function ii(t4, e3, r3, n3) {
        const i3 = n3 - r3, a4 = t4 - r3;
        return 0 === i3 ? 0 : 1 === e3 ? a4 / i3 : (Math.pow(e3, a4) - 1) / (Math.pow(e3, i3) - 1);
      }
      class ai {
        constructor(t4, e3) {
          this.type = t4, this.args = e3;
        }
        static parse(t4, e3) {
          if (t4.length < 2) return e3.error("Expectected at least one argument.");
          let r3 = null;
          const n3 = e3.expectedType;
          n3 && "value" !== n3.kind && (r3 = n3);
          const i3 = [];
          for (const n4 of t4.slice(1)) {
            const t5 = e3.parse(n4, 1 + i3.length, r3, void 0, { typeAnnotation: "omit" });
            if (!t5) return null;
            r3 = r3 || t5.type, i3.push(t5);
          }
          const a4 = n3 && i3.some((t5) => Ye(n3, t5.type));
          return new ai(a4 ? Ue : r3, i3);
        }
        evaluate(t4) {
          let e3, r3 = null, n3 = 0;
          for (const i3 of this.args) {
            if (n3++, r3 = i3.evaluate(t4), r3 && r3 instanceof Qe && !r3.available && (e3 || (e3 = r3), r3 = null, n3 === this.args.length)) return e3;
            if (null !== r3) break;
          }
          return r3;
        }
        eachChild(t4) {
          this.args.forEach(t4);
        }
        outputDefined() {
          return this.args.every((t4) => t4.outputDefined());
        }
        serialize() {
          const t4 = ["coalesce"];
          return this.eachChild((e3) => {
            t4.push(e3.serialize());
          }), t4;
        }
      }
      class si {
        constructor(t4, e3) {
          this.type = e3.type, this.bindings = [].concat(t4), this.result = e3;
        }
        evaluate(t4) {
          return this.result.evaluate(t4);
        }
        eachChild(t4) {
          for (const e3 of this.bindings) t4(e3[1]);
          t4(this.result);
        }
        static parse(t4, e3) {
          if (t4.length < 4) return e3.error(`Expected at least 3 arguments, but found ${t4.length - 1} instead.`);
          const r3 = [];
          for (let n4 = 1; n4 < t4.length - 1; n4 += 2) {
            const i3 = t4[n4];
            if ("string" != typeof i3) return e3.error(`Expected string, but found ${typeof i3} instead.`, n4);
            if (/[^a-zA-Z0-9_]/.test(i3)) return e3.error("Variable names must contain only alphanumeric characters or '_'.", n4);
            const a4 = e3.parse(t4[n4 + 1], n4 + 1);
            if (!a4) return null;
            r3.push([i3, a4]);
          }
          const n3 = e3.parse(t4[t4.length - 1], t4.length - 1, e3.expectedType, r3);
          return n3 ? new si(r3, n3) : null;
        }
        outputDefined() {
          return this.result.outputDefined();
        }
        serialize() {
          const t4 = ["let"];
          for (const [e3, r3] of this.bindings) t4.push(e3, r3.serialize());
          return t4.push(this.result.serialize()), t4;
        }
      }
      class oi {
        constructor(t4, e3, r3) {
          this.type = t4, this.index = e3, this.input = r3;
        }
        static parse(t4, e3) {
          if (3 !== t4.length) return e3.error(`Expected 2 arguments, but found ${t4.length - 1} instead.`);
          const r3 = e3.parse(t4[1], 1, Re), n3 = e3.parse(t4[2], 2, $e(e3.expectedType || Ue));
          return r3 && n3 ? new oi(n3.type.itemType, r3, n3) : null;
        }
        evaluate(t4) {
          const e3 = this.index.evaluate(t4), r3 = this.input.evaluate(t4);
          if (e3 < 0) throw new ar(`Array index out of bounds: ${e3} < 0.`);
          if (e3 > r3.length - 1) throw new ar(`Array index out of bounds: ${e3} > ${r3.length - 1}.`);
          if (e3 === Math.floor(e3)) return r3[e3];
          const n3 = Math.floor(e3), i3 = Math.ceil(e3), a4 = r3[n3], s3 = r3[i3];
          if ("number" != typeof a4 || "number" != typeof s3) throw new ar(`Cannot interpolate between non-number values at index ${e3}.`);
          const o3 = e3 - n3;
          return a4 * (1 - o3) + s3 * o3;
        }
        eachChild(t4) {
          t4(this.index), t4(this.input);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          return ["at", this.index.serialize(), this.input.serialize()];
        }
      }
      class li {
        constructor(t4, e3) {
          this.type = Le, this.needle = t4, this.haystack = e3;
        }
        static parse(t4, e3) {
          if (3 !== t4.length) return e3.error(`Expected 2 arguments, but found ${t4.length - 1} instead.`);
          const r3 = e3.parse(t4[1], 1, Ue), n3 = e3.parse(t4[2], 2, Ue);
          return r3 && n3 ? Ze(r3.type, [Le, De, Re, Ce, Ue]) ? new li(r3, n3) : e3.error(`Expected first argument to be of type boolean, string, number or null, but found ${Ge(r3.type)} instead`) : null;
        }
        evaluate(t4) {
          const e3 = this.needle.evaluate(t4), r3 = this.haystack.evaluate(t4);
          if (null == r3) return false;
          if (!We(e3, ["boolean", "string", "number", "null"])) throw new ar(`Expected first argument to be of type boolean, string, number or null, but found ${Ge(rr(e3))} instead.`);
          if (!We(r3, ["string", "array"])) throw new ar(`Expected second argument to be of type array or string, but found ${Ge(rr(r3))} instead.`);
          return r3.indexOf(e3) >= 0;
        }
        eachChild(t4) {
          t4(this.needle), t4(this.haystack);
        }
        outputDefined() {
          return true;
        }
        serialize() {
          return ["in", this.needle.serialize(), this.haystack.serialize()];
        }
      }
      class ui {
        constructor(t4, e3, r3) {
          this.type = Re, this.needle = t4, this.haystack = e3, this.fromIndex = r3;
        }
        static parse(t4, e3) {
          if (t4.length <= 2 || t4.length >= 5) return e3.error(`Expected 3 or 4 arguments, but found ${t4.length - 1} instead.`);
          const r3 = e3.parse(t4[1], 1, Ue), n3 = e3.parse(t4[2], 2, Ue);
          if (!r3 || !n3) return null;
          if (!Ze(r3.type, [Le, De, Re, Ce, Ue])) return e3.error(`Expected first argument to be of type boolean, string, number or null, but found ${Ge(r3.type)} instead`);
          if (4 === t4.length) {
            const i3 = e3.parse(t4[3], 3, Re);
            return i3 ? new ui(r3, n3, i3) : null;
          }
          return new ui(r3, n3);
        }
        evaluate(t4) {
          const e3 = this.needle.evaluate(t4), r3 = this.haystack.evaluate(t4);
          if (!We(e3, ["boolean", "string", "number", "null"])) throw new ar(`Expected first argument to be of type boolean, string, number or null, but found ${Ge(rr(e3))} instead.`);
          if (!We(r3, ["string", "array"])) throw new ar(`Expected second argument to be of type array or string, but found ${Ge(rr(r3))} instead.`);
          if (this.fromIndex) {
            const n3 = this.fromIndex.evaluate(t4);
            return r3.indexOf(e3, n3);
          }
          return r3.indexOf(e3);
        }
        eachChild(t4) {
          t4(this.needle), t4(this.haystack), this.fromIndex && t4(this.fromIndex);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          if (null != this.fromIndex && void 0 !== this.fromIndex) {
            const t4 = this.fromIndex.serialize();
            return ["index-of", this.needle.serialize(), this.haystack.serialize(), t4];
          }
          return ["index-of", this.needle.serialize(), this.haystack.serialize()];
        }
      }
      class ci {
        constructor(t4, e3, r3, n3, i3, a4) {
          this.inputType = t4, this.type = e3, this.input = r3, this.cases = n3, this.outputs = i3, this.otherwise = a4;
        }
        static parse(t4, e3) {
          if (t4.length < 5) return e3.error(`Expected at least 4 arguments, but found only ${t4.length - 1}.`);
          if (t4.length % 2 != 1) return e3.error("Expected an even number of arguments.");
          let r3, n3;
          e3.expectedType && "value" !== e3.expectedType.kind && (n3 = e3.expectedType);
          const i3 = {}, a4 = [];
          for (let s4 = 2; s4 < t4.length - 1; s4 += 2) {
            let o4 = t4[s4];
            const l3 = t4[s4 + 1];
            Array.isArray(o4) || (o4 = [o4]);
            const u4 = e3.concat(s4);
            if (0 === o4.length) return u4.error("Expected at least one branch label.");
            for (const t5 of o4) {
              if ("number" != typeof t5 && "string" != typeof t5) return u4.error("Branch labels must be numbers or strings.");
              if ("number" == typeof t5 && Math.abs(t5) > Number.MAX_SAFE_INTEGER) return u4.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
              if ("number" == typeof t5 && Math.floor(t5) !== t5) return u4.error("Numeric branch labels must be integer values.");
              if (r3) {
                if (u4.checkSubtype(r3, rr(t5))) return null;
              } else r3 = rr(t5);
              if (void 0 !== i3[String(t5)]) return u4.error("Branch labels must be unique.");
              i3[String(t5)] = a4.length;
            }
            const c3 = e3.parse(l3, s4, n3);
            if (!c3) return null;
            n3 = n3 || c3.type, a4.push(c3);
          }
          const s3 = e3.parse(t4[1], 1, Ue);
          if (!s3) return null;
          const o3 = e3.parse(t4[t4.length - 1], t4.length - 1, n3);
          return o3 ? "value" !== s3.type.kind && e3.concat(1).checkSubtype(r3, s3.type) ? null : new ci(r3, n3, s3, i3, a4, o3) : null;
        }
        evaluate(t4) {
          const e3 = this.input.evaluate(t4);
          return (rr(e3) === this.inputType && this.outputs[this.cases[e3]] || this.otherwise).evaluate(t4);
        }
        eachChild(t4) {
          t4(this.input), this.outputs.forEach(t4), t4(this.otherwise);
        }
        outputDefined() {
          return this.outputs.every((t4) => t4.outputDefined()) && this.otherwise.outputDefined();
        }
        serialize() {
          const t4 = ["match", this.input.serialize()], e3 = Object.keys(this.cases).sort(), r3 = [], n3 = {};
          for (const t5 of e3) {
            const e4 = n3[this.cases[t5]];
            void 0 === e4 ? (n3[this.cases[t5]] = r3.length, r3.push([this.cases[t5], [t5]])) : r3[e4][1].push(t5);
          }
          const i3 = (t5) => "number" === this.inputType.kind ? Number(t5) : t5;
          for (const [e4, n4] of r3) t4.push(1 === n4.length ? i3(n4[0]) : n4.map(i3)), t4.push(this.outputs[e4].serialize());
          return t4.push(this.otherwise.serialize()), t4;
        }
      }
      class hi {
        constructor(t4, e3, r3) {
          this.type = t4, this.branches = e3, this.otherwise = r3;
        }
        static parse(t4, e3) {
          if (t4.length < 4) return e3.error(`Expected at least 3 arguments, but found only ${t4.length - 1}.`);
          if (t4.length % 2 != 0) return e3.error("Expected an odd number of arguments.");
          let r3;
          e3.expectedType && "value" !== e3.expectedType.kind && (r3 = e3.expectedType);
          const n3 = [];
          for (let i4 = 1; i4 < t4.length - 1; i4 += 2) {
            const a4 = e3.parse(t4[i4], i4, Le);
            if (!a4) return null;
            const s3 = e3.parse(t4[i4 + 1], i4 + 1, r3);
            if (!s3) return null;
            n3.push([a4, s3]), r3 = r3 || s3.type;
          }
          const i3 = e3.parse(t4[t4.length - 1], t4.length - 1, r3);
          return i3 ? new hi(r3, n3, i3) : null;
        }
        evaluate(t4) {
          for (const [e3, r3] of this.branches) if (e3.evaluate(t4)) return r3.evaluate(t4);
          return this.otherwise.evaluate(t4);
        }
        eachChild(t4) {
          for (const [e3, r3] of this.branches) t4(e3), t4(r3);
          t4(this.otherwise);
        }
        outputDefined() {
          return this.branches.every(([t4, e3]) => e3.outputDefined()) && this.otherwise.outputDefined();
        }
        serialize() {
          const t4 = ["case"];
          return this.eachChild((e3) => {
            t4.push(e3.serialize());
          }), t4;
        }
      }
      class pi2 {
        constructor(t4, e3, r3, n3) {
          this.type = t4, this.input = e3, this.beginIndex = r3, this.endIndex = n3;
        }
        static parse(t4, e3) {
          if (t4.length <= 2 || t4.length >= 5) return e3.error(`Expected 3 or 4 arguments, but found ${t4.length - 1} instead.`);
          const r3 = e3.parse(t4[1], 1, Ue), n3 = e3.parse(t4[2], 2, Re);
          if (!r3 || !n3) return null;
          if (!Ze(r3.type, [$e(Ue), De, Ue])) return e3.error(`Expected first argument to be of type array or string, but found ${Ge(r3.type)} instead`);
          if (4 === t4.length) {
            const i3 = e3.parse(t4[3], 3, Re);
            return i3 ? new pi2(r3.type, r3, n3, i3) : null;
          }
          return new pi2(r3.type, r3, n3);
        }
        evaluate(t4) {
          const e3 = this.input.evaluate(t4), r3 = this.beginIndex.evaluate(t4);
          if (!We(e3, ["string", "array"])) throw new ar(`Expected first argument to be of type array or string, but found ${Ge(rr(e3))} instead.`);
          if (this.endIndex) {
            const n3 = this.endIndex.evaluate(t4);
            return e3.slice(r3, n3);
          }
          return e3.slice(r3);
        }
        eachChild(t4) {
          t4(this.input), t4(this.beginIndex), this.endIndex && t4(this.endIndex);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          if (null != this.endIndex && void 0 !== this.endIndex) {
            const t4 = this.endIndex.serialize();
            return ["slice", this.input.serialize(), this.beginIndex.serialize(), t4];
          }
          return ["slice", this.input.serialize(), this.beginIndex.serialize()];
        }
      }
      function fi(t4, e3) {
        return "==" === t4 || "!=" === t4 ? "boolean" === e3.kind || "string" === e3.kind || "number" === e3.kind || "null" === e3.kind || "value" === e3.kind : "string" === e3.kind || "number" === e3.kind || "value" === e3.kind;
      }
      function di(t4, e3, r3, n3) {
        return 0 === n3.compare(e3, r3);
      }
      function mi(t4, e3, r3) {
        const n3 = "==" !== t4 && "!=" !== t4;
        return class i3 {
          constructor(t5, e4, r4) {
            this.type = Le, this.lhs = t5, this.rhs = e4, this.collator = r4, this.hasUntypedArgument = "value" === t5.type.kind || "value" === e4.type.kind;
          }
          static parse(t5, e4) {
            if (3 !== t5.length && 4 !== t5.length) return e4.error("Expected two or three arguments.");
            const r4 = t5[0];
            let a4 = e4.parse(t5[1], 1, Ue);
            if (!a4) return null;
            if (!fi(r4, a4.type)) return e4.concat(1).error(`"${r4}" comparisons are not supported for type '${Ge(a4.type)}'.`);
            let s3 = e4.parse(t5[2], 2, Ue);
            if (!s3) return null;
            if (!fi(r4, s3.type)) return e4.concat(2).error(`"${r4}" comparisons are not supported for type '${Ge(s3.type)}'.`);
            if (a4.type.kind !== s3.type.kind && "value" !== a4.type.kind && "value" !== s3.type.kind) return e4.error(`Cannot compare types '${Ge(a4.type)}' and '${Ge(s3.type)}'.`);
            n3 && ("value" === a4.type.kind && "value" !== s3.type.kind ? a4 = new or(s3.type, [a4]) : "value" !== a4.type.kind && "value" === s3.type.kind && (s3 = new or(a4.type, [s3])));
            let o3 = null;
            if (4 === t5.length) {
              if ("string" !== a4.type.kind && "string" !== s3.type.kind && "value" !== a4.type.kind && "value" !== s3.type.kind) return e4.error("Cannot use collator to compare non-string types.");
              if (o3 = e4.parse(t5[3], 3, je), !o3) return null;
            }
            return new i3(a4, s3, o3);
          }
          evaluate(i4) {
            const a4 = this.lhs.evaluate(i4), s3 = this.rhs.evaluate(i4);
            if (n3 && this.hasUntypedArgument) {
              const e4 = rr(a4), r4 = rr(s3);
              if (e4.kind !== r4.kind || "string" !== e4.kind && "number" !== e4.kind) throw new ar(`Expected arguments for "${t4}" to be (string, string) or (number, number), but found (${e4.kind}, ${r4.kind}) instead.`);
            }
            if (this.collator && !n3 && this.hasUntypedArgument) {
              const t5 = rr(a4), r4 = rr(s3);
              if ("string" !== t5.kind || "string" !== r4.kind) return e3(i4, a4, s3);
            }
            return this.collator ? r3(i4, a4, s3, this.collator.evaluate(i4)) : e3(i4, a4, s3);
          }
          eachChild(t5) {
            t5(this.lhs), t5(this.rhs), this.collator && t5(this.collator);
          }
          outputDefined() {
            return true;
          }
          serialize() {
            const e4 = [t4];
            return this.eachChild((t5) => {
              e4.push(t5.serialize());
            }), e4;
          }
        };
      }
      const yi = mi("==", function(t4, e3, r3) {
        return e3 === r3;
      }, di), gi = mi("!=", function(t4, e3, r3) {
        return e3 !== r3;
      }, function(t4, e3, r3, n3) {
        return !di(0, e3, r3, n3);
      }), xi = mi("<", function(t4, e3, r3) {
        return e3 < r3;
      }, function(t4, e3, r3, n3) {
        return n3.compare(e3, r3) < 0;
      }), vi = mi(">", function(t4, e3, r3) {
        return e3 > r3;
      }, function(t4, e3, r3, n3) {
        return n3.compare(e3, r3) > 0;
      }), bi = mi("<=", function(t4, e3, r3) {
        return e3 <= r3;
      }, function(t4, e3, r3, n3) {
        return n3.compare(e3, r3) <= 0;
      }), wi = mi(">=", function(t4, e3, r3) {
        return e3 >= r3;
      }, function(t4, e3, r3, n3) {
        return n3.compare(e3, r3) >= 0;
      });
      class _i {
        constructor(t4, e3, r3, n3, i3, a4) {
          this.type = De, this.number = t4, this.locale = e3, this.currency = r3, this.unit = n3, this.minFractionDigits = i3, this.maxFractionDigits = a4;
        }
        static parse(t4, e3) {
          if (3 !== t4.length) return e3.error("Expected two arguments.");
          const r3 = e3.parse(t4[1], 1, Re);
          if (!r3) return null;
          const n3 = t4[2];
          if ("object" != typeof n3 || Array.isArray(n3)) return e3.error("NumberFormat options argument must be an object.");
          let i3 = null;
          if (n3.locale && (i3 = e3.parseObjectValue(n3.locale, 2, "locale", De), !i3)) return null;
          let a4 = null;
          if (n3.currency && (a4 = e3.parseObjectValue(n3.currency, 2, "currency", De), !a4)) return null;
          let s3 = null;
          if (n3.unit && (s3 = e3.parseObjectValue(n3.unit, 2, "unit", De), !s3)) return null;
          let o3 = null;
          if (n3["min-fraction-digits"] && (o3 = e3.parseObjectValue(n3["min-fraction-digits"], 2, "min-fraction-digits", Re), !o3)) return null;
          let l3 = null;
          return n3["max-fraction-digits"] && (l3 = e3.parseObjectValue(n3["max-fraction-digits"], 2, "max-fraction-digits", Re), !l3) ? null : new _i(r3, i3, a4, s3, o3, l3);
        }
        evaluate(t4) {
          return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t4) : [], { style: (this.currency ? "currency" : this.unit && "unit") || "decimal", currency: this.currency ? this.currency.evaluate(t4) : void 0, unit: this.unit ? this.unit.evaluate(t4) : void 0, minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t4) : void 0, maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t4) : void 0 }).format(this.number.evaluate(t4));
        }
        eachChild(t4) {
          t4(this.number), this.locale && t4(this.locale), this.currency && t4(this.currency), this.unit && t4(this.unit), this.minFractionDigits && t4(this.minFractionDigits), this.maxFractionDigits && t4(this.maxFractionDigits);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          const t4 = {};
          return this.locale && (t4.locale = this.locale.serialize()), this.currency && (t4.currency = this.currency.serialize()), this.unit && (t4.unit = this.unit.serialize()), this.minFractionDigits && (t4["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t4["max-fraction-digits"] = this.maxFractionDigits.serialize()), ["number-format", this.number.serialize(), t4];
        }
      }
      class Mi {
        constructor(t4) {
          this.type = Re, this.input = t4;
        }
        static parse(t4, e3) {
          if (2 !== t4.length) return e3.error(`Expected 1 argument, but found ${t4.length - 1} instead.`);
          const r3 = e3.parse(t4[1], 1);
          return r3 ? "array" !== r3.type.kind && "string" !== r3.type.kind && "value" !== r3.type.kind ? e3.error(`Expected argument of type string or array, but found ${Ge(r3.type)} instead.`) : new Mi(r3) : null;
        }
        evaluate(t4) {
          const e3 = this.input.evaluate(t4);
          if ("string" == typeof e3) return e3.length;
          if (Array.isArray(e3)) return e3.length;
          throw new ar(`Expected value to be of type string or array, but found ${Ge(rr(e3))} instead.`);
        }
        eachChild(t4) {
          t4(this.input);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          const t4 = ["length"];
          return this.eachChild((e3) => {
            t4.push(e3.serialize());
          }), t4;
        }
      }
      function Ai(t4) {
        return function() {
          t4 = 1831565813 + (t4 |= 0) | 0;
          let e3 = Math.imul(t4 ^ t4 >>> 15, 1 | t4);
          return e3 = e3 + Math.imul(e3 ^ e3 >>> 7, 61 | e3) ^ e3, ((e3 ^ e3 >>> 14) >>> 0) / 4294967296;
        };
      }
      const Si2 = { "==": yi, "!=": gi, ">": vi, "<": xi, ">=": wi, "<=": bi, array: or, at: oi, boolean: or, case: hi, coalesce: ai, collator: gr, format: lr, image: ur, in: li, "index-of": ui, interpolate: ni, "interpolate-hcl": ni, "interpolate-lab": ni, length: Mi, let: si, literal: ir, match: ci, number: or, "number-format": _i, object: or, slice: pi2, step: Fn, string: or, "to-boolean": pr, "to-color": pr, "to-number": pr, "to-string": pr, var: Cn, within: Or, distance: In2, config: kn };
      function Ii2(t4, [e3, r3, n3, i3]) {
        e3 = e3.evaluate(t4), r3 = r3.evaluate(t4), n3 = n3.evaluate(t4);
        const a4 = i3 ? i3.evaluate(t4) : 1, s3 = tr(e3, r3, n3, a4);
        if (s3) throw new ar(s3);
        return new Ie(e3 / 255 * a4, r3 / 255 * a4, n3 / 255 * a4, a4);
      }
      function zi(t4, [e3, r3, n3, i3]) {
        e3 = e3.evaluate(t4), r3 = r3.evaluate(t4), n3 = n3.evaluate(t4);
        const a4 = i3 ? i3.evaluate(t4) : 1, s3 = function(t5, e4, r4, n4) {
          return "number" == typeof t5 && t5 >= 0 && t5 <= 360 ? "number" == typeof e4 && e4 >= 0 && e4 <= 100 && "number" == typeof r4 && r4 >= 0 && r4 <= 100 ? void 0 === n4 || "number" == typeof n4 && n4 >= 0 && n4 <= 1 ? null : `Invalid hsla value [${[t5, e4, r4, n4].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid hsla value [${("number" == typeof n4 ? [t5, e4, r4, n4] : [t5, e4, r4]).join(", ")}]: 's', and 'l' must be between 0 and 100.` : `Invalid hsla value [${("number" == typeof n4 ? [t5, e4, r4, n4] : [t5, e4, r4]).join(", ")}]: 'h' must be between 0 and 360.`;
        }(e3, r3, n3, a4);
        if (s3) throw new ar(s3);
        const o3 = `hsla(${e3}, ${r3}%, ${n3}%, ${a4})`, l3 = Ie.parse(o3);
        if (!l3) throw new ar(`Failed to parse HSLA color: ${o3}`);
        return l3;
      }
      function Pi2(t4, e3) {
        return t4 in e3;
      }
      function ki(t4, e3) {
        const r3 = e3[t4];
        return void 0 === r3 ? null : r3;
      }
      function Ti2(t4) {
        return { type: t4 };
      }
      function Ei(t4) {
        return { result: "success", value: t4 };
      }
      function Bi(t4) {
        return { result: "error", value: t4 };
      }
      function Vi(t4, e3) {
        return !!t4 && !!t4.parameters && t4.parameters.indexOf(e3) > -1;
      }
      function Ci(t4) {
        return "data-driven" === t4["property-type"];
      }
      function Ri(t4) {
        return Vi(t4.expression, "measure-light");
      }
      function Di(t4) {
        return Vi(t4.expression, "zoom");
      }
      function Li(t4) {
        return !!t4.expression && t4.expression.interpolated;
      }
      function Fi(t4) {
        return "object" == typeof t4 && null !== t4 && !Array.isArray(t4);
      }
      function Oi2(t4) {
        return t4;
      }
      function Ui(t4, e3) {
        const r3 = "color" === e3.type, n3 = t4.stops && "object" == typeof t4.stops[0][0], i3 = n3 || !(n3 || void 0 !== t4.property), a4 = t4.type || (Li(e3) ? "exponential" : "interval");
        if (r3 && ((t4 = Ee({}, t4)).stops && (t4.stops = t4.stops.map((t5) => [t5[0], Ie.parse(t5[1])])), t4.default = Ie.parse(t4.default ? t4.default : e3.default)), t4.colorSpace && "rgb" !== t4.colorSpace && !ri[t4.colorSpace]) throw new Error(`Unknown color space: ${t4.colorSpace}`);
        let s3, o3, l3;
        if ("exponential" === a4) s3 = $i;
        else if ("interval" === a4) s3 = qi;
        else if ("categorical" === a4) {
          s3 = Ni, o3 = /* @__PURE__ */ Object.create(null);
          for (const e4 of t4.stops) o3[e4[0]] = e4[1];
          l3 = typeof t4.stops[0][0];
        } else {
          if ("identity" !== a4) throw new Error(`Unknown function type "${a4}"`);
          s3 = Gi;
        }
        if (n3) {
          const r4 = {}, n4 = [];
          for (let e4 = 0; e4 < t4.stops.length; e4++) {
            const i5 = t4.stops[e4], a6 = i5[0].zoom;
            void 0 === r4[a6] && (r4[a6] = { zoom: a6, type: t4.type, property: t4.property, default: t4.default, stops: [] }, n4.push(a6)), r4[a6].stops.push([i5[0].value, i5[1]]);
          }
          const i4 = [];
          for (const t5 of n4) i4.push([r4[t5].zoom, Ui(r4[t5], e3)]);
          const a5 = { name: "linear" };
          return { kind: "composite", interpolationType: a5, interpolationFactor: ni.interpolationFactor.bind(void 0, a5), zoomStops: i4.map((t5) => t5[0]), evaluate: ({ zoom: r5 }, n5) => $i({ stops: i4, base: t4.base }, e3, r5).evaluate(r5, n5) };
        }
        if (i3) {
          const r4 = "exponential" === a4 ? { name: "exponential", base: void 0 !== t4.base ? t4.base : 1 } : null;
          return { kind: "camera", interpolationType: r4, interpolationFactor: ni.interpolationFactor.bind(void 0, r4), zoomStops: t4.stops.map((t5) => t5[0]), evaluate: ({ zoom: r5 }) => s3(t4, e3, r5, o3, l3) };
        }
        return { kind: "source", evaluate(r4, n4) {
          const i4 = n4 && n4.properties ? n4.properties[t4.property] : void 0;
          return void 0 === i4 ? ji(t4.default, e3.default) : s3(t4, e3, i4, o3, l3);
        } };
      }
      function ji(t4, e3, r3) {
        return void 0 !== t4 ? t4 : void 0 !== e3 ? e3 : void 0 !== r3 ? r3 : void 0;
      }
      function Ni(t4, e3, r3, n3, i3) {
        return ji(typeof r3 === i3 ? n3[r3] : void 0, t4.default, e3.default);
      }
      function qi(t4, e3, r3) {
        if ("number" !== cr(r3)) return ji(t4.default, e3.default);
        const n3 = t4.stops.length;
        if (1 === n3) return t4.stops[0][1];
        if (r3 <= t4.stops[0][0]) return t4.stops[0][1];
        if (r3 >= t4.stops[n3 - 1][0]) return t4.stops[n3 - 1][1];
        const i3 = Ln(t4.stops.map((t5) => t5[0]), r3);
        return t4.stops[i3][1];
      }
      function $i(t4, e3, r3) {
        const n3 = void 0 !== t4.base ? t4.base : 1;
        if ("number" !== cr(r3)) return ji(t4.default, e3.default);
        const i3 = t4.stops.length;
        if (1 === i3) return t4.stops[0][1];
        if (r3 <= t4.stops[0][0]) return t4.stops[0][1];
        if (r3 >= t4.stops[i3 - 1][0]) return t4.stops[i3 - 1][1];
        const a4 = Ln(t4.stops.map((t5) => t5[0]), r3), s3 = function(t5, e4, r4, n4) {
          const i4 = n4 - r4, a5 = t5 - r4;
          return 0 === i4 ? 0 : 1 === e4 ? a5 / i4 : (Math.pow(e4, a5) - 1) / (Math.pow(e4, i4) - 1);
        }(r3, n3, t4.stops[a4][0], t4.stops[a4 + 1][0]), o3 = t4.stops[a4][1], l3 = t4.stops[a4 + 1][1];
        let u4 = Te[e3.type] || Oi2;
        if (t4.colorSpace && "rgb" !== t4.colorSpace) {
          const e4 = ri[t4.colorSpace];
          u4 = (t5, r4) => e4.reverse(e4.interpolate(e4.forward(t5), e4.forward(r4), s3));
        }
        return "function" == typeof o3.evaluate ? { evaluate(...t5) {
          const e4 = o3.evaluate.apply(void 0, t5), r4 = l3.evaluate.apply(void 0, t5);
          if (void 0 !== e4 && void 0 !== r4) return u4(e4, r4, s3);
        } } : u4(o3, l3, s3);
      }
      function Gi(t4, e3, r3) {
        return "color" === e3.type ? r3 = Ie.parse(r3) : "formatted" === e3.type ? r3 = Je.fromString(r3.toString()) : "resolvedImage" === e3.type ? r3 = Qe.fromString(r3.toString()) : cr(r3) === e3.type || "enum" === e3.type && e3.values[r3] || (r3 = void 0), ji(r3, t4.default, e3.default);
      }
      mr.register(Si2, { error: [{ kind: "error" }, [De], (t4, [e3]) => {
        throw new ar(e3.evaluate(t4));
      }], typeof: [De, [Ue], (t4, [e3]) => Ge(rr(e3.evaluate(t4)))], "to-rgba": [$e(Re, 4), [Fe], (t4, [e3]) => e3.evaluate(t4).toRenderColor(null).toArray()], rgb: [Fe, [Re, Re, Re], Ii2], rgba: [Fe, [Re, Re, Re, Re], Ii2], hsl: [Fe, [Re, Re, Re], zi], hsla: [Fe, [Re, Re, Re, Re], zi], has: { type: Le, overloads: [[[De], (t4, [e3]) => Pi2(e3.evaluate(t4), t4.properties())], [[De, Oe], (t4, [e3, r3]) => Pi2(e3.evaluate(t4), r3.evaluate(t4))]] }, get: { type: Ue, overloads: [[[De], (t4, [e3]) => ki(e3.evaluate(t4), t4.properties())], [[De, Oe], (t4, [e3, r3]) => ki(e3.evaluate(t4), r3.evaluate(t4))]] }, "feature-state": [Ue, [De], (t4, [e3]) => ki(e3.evaluate(t4), t4.featureState || {})], properties: [Oe, [], (t4) => t4.properties()], "geometry-type": [De, [], (t4) => t4.geometryType()], id: [Ue, [], (t4) => t4.id()], zoom: [Re, [], (t4) => t4.globals.zoom], pitch: [Re, [], (t4) => t4.globals.pitch || 0], "distance-from-center": [Re, [], (t4) => t4.distanceFromCenter()], "measure-light": [Re, [De], (t4, [e3]) => t4.measureLight(e3.evaluate(t4))], "heatmap-density": [Re, [], (t4) => t4.globals.heatmapDensity || 0], "line-progress": [Re, [], (t4) => t4.globals.lineProgress || 0], "raster-value": [Re, [], (t4) => t4.globals.rasterValue || 0], "raster-particle-speed": [Re, [], (t4) => t4.globals.rasterParticleSpeed || 0], "sky-radial-progress": [Re, [], (t4) => t4.globals.skyRadialProgress || 0], accumulated: [Ue, [], (t4) => void 0 === t4.globals.accumulated ? null : t4.globals.accumulated], "+": [Re, Ti2(Re), (t4, e3) => {
        let r3 = 0;
        for (const n3 of e3) r3 += n3.evaluate(t4);
        return r3;
      }], "*": [Re, Ti2(Re), (t4, e3) => {
        let r3 = 1;
        for (const n3 of e3) r3 *= n3.evaluate(t4);
        return r3;
      }], "-": { type: Re, overloads: [[[Re, Re], (t4, [e3, r3]) => e3.evaluate(t4) - r3.evaluate(t4)], [[Re], (t4, [e3]) => -e3.evaluate(t4)]] }, "/": [Re, [Re, Re], (t4, [e3, r3]) => e3.evaluate(t4) / r3.evaluate(t4)], "%": [Re, [Re, Re], (t4, [e3, r3]) => e3.evaluate(t4) % r3.evaluate(t4)], ln2: [Re, [], () => Math.LN2], pi: [Re, [], () => Math.PI], e: [Re, [], () => Math.E], "^": [Re, [Re, Re], (t4, [e3, r3]) => Math.pow(e3.evaluate(t4), r3.evaluate(t4))], sqrt: [Re, [Re], (t4, [e3]) => Math.sqrt(e3.evaluate(t4))], log10: [Re, [Re], (t4, [e3]) => Math.log(e3.evaluate(t4)) / Math.LN10], ln: [Re, [Re], (t4, [e3]) => Math.log(e3.evaluate(t4))], log2: [Re, [Re], (t4, [e3]) => Math.log(e3.evaluate(t4)) / Math.LN2], sin: [Re, [Re], (t4, [e3]) => Math.sin(e3.evaluate(t4))], cos: [Re, [Re], (t4, [e3]) => Math.cos(e3.evaluate(t4))], tan: [Re, [Re], (t4, [e3]) => Math.tan(e3.evaluate(t4))], asin: [Re, [Re], (t4, [e3]) => Math.asin(e3.evaluate(t4))], acos: [Re, [Re], (t4, [e3]) => Math.acos(e3.evaluate(t4))], atan: [Re, [Re], (t4, [e3]) => Math.atan(e3.evaluate(t4))], min: [Re, Ti2(Re), (t4, e3) => Math.min(...e3.map((e4) => e4.evaluate(t4)))], max: [Re, Ti2(Re), (t4, e3) => Math.max(...e3.map((e4) => e4.evaluate(t4)))], abs: [Re, [Re], (t4, [e3]) => Math.abs(e3.evaluate(t4))], round: [Re, [Re], (t4, [e3]) => {
        const r3 = e3.evaluate(t4);
        return r3 < 0 ? -Math.round(-r3) : Math.round(r3);
      }], floor: [Re, [Re], (t4, [e3]) => Math.floor(e3.evaluate(t4))], ceil: [Re, [Re], (t4, [e3]) => Math.ceil(e3.evaluate(t4))], "filter-==": [Le, [De, Ue], (t4, [e3, r3]) => t4.properties()[e3.value] === r3.value], "filter-id-==": [Le, [Ue], (t4, [e3]) => t4.id() === e3.value], "filter-type-==": [Le, [De], (t4, [e3]) => t4.geometryType() === e3.value], "filter-<": [Le, [De, Ue], (t4, [e3, r3]) => {
        const n3 = t4.properties()[e3.value], i3 = r3.value;
        return typeof n3 == typeof i3 && n3 < i3;
      }], "filter-id-<": [Le, [Ue], (t4, [e3]) => {
        const r3 = t4.id(), n3 = e3.value;
        return typeof r3 == typeof n3 && r3 < n3;
      }], "filter->": [Le, [De, Ue], (t4, [e3, r3]) => {
        const n3 = t4.properties()[e3.value], i3 = r3.value;
        return typeof n3 == typeof i3 && n3 > i3;
      }], "filter-id->": [Le, [Ue], (t4, [e3]) => {
        const r3 = t4.id(), n3 = e3.value;
        return typeof r3 == typeof n3 && r3 > n3;
      }], "filter-<=": [Le, [De, Ue], (t4, [e3, r3]) => {
        const n3 = t4.properties()[e3.value], i3 = r3.value;
        return typeof n3 == typeof i3 && n3 <= i3;
      }], "filter-id-<=": [Le, [Ue], (t4, [e3]) => {
        const r3 = t4.id(), n3 = e3.value;
        return typeof r3 == typeof n3 && r3 <= n3;
      }], "filter->=": [Le, [De, Ue], (t4, [e3, r3]) => {
        const n3 = t4.properties()[e3.value], i3 = r3.value;
        return typeof n3 == typeof i3 && n3 >= i3;
      }], "filter-id->=": [Le, [Ue], (t4, [e3]) => {
        const r3 = t4.id(), n3 = e3.value;
        return typeof r3 == typeof n3 && r3 >= n3;
      }], "filter-has": [Le, [Ue], (t4, [e3]) => e3.value in t4.properties()], "filter-has-id": [Le, [], (t4) => null !== t4.id() && void 0 !== t4.id()], "filter-type-in": [Le, [$e(De)], (t4, [e3]) => e3.value.indexOf(t4.geometryType()) >= 0], "filter-id-in": [Le, [$e(Ue)], (t4, [e3]) => e3.value.indexOf(t4.id()) >= 0], "filter-in-small": [Le, [De, $e(Ue)], (t4, [e3, r3]) => r3.value.indexOf(t4.properties()[e3.value]) >= 0], "filter-in-large": [Le, [De, $e(Ue)], (t4, [e3, r3]) => function(t5, e4, r4, n3) {
        for (; r4 <= n3; ) {
          const i3 = r4 + n3 >> 1;
          if (e4[i3] === t5) return true;
          e4[i3] > t5 ? n3 = i3 - 1 : r4 = i3 + 1;
        }
        return false;
      }(t4.properties()[e3.value], r3.value, 0, r3.value.length - 1)], all: { type: Le, overloads: [[[Le, Le], (t4, [e3, r3]) => e3.evaluate(t4) && r3.evaluate(t4)], [Ti2(Le), (t4, e3) => {
        for (const r3 of e3) if (!r3.evaluate(t4)) return false;
        return true;
      }]] }, any: { type: Le, overloads: [[[Le, Le], (t4, [e3, r3]) => e3.evaluate(t4) || r3.evaluate(t4)], [Ti2(Le), (t4, e3) => {
        for (const r3 of e3) if (r3.evaluate(t4)) return true;
        return false;
      }]] }, "!": [Le, [Le], (t4, [e3]) => !e3.evaluate(t4)], "is-supported-script": [Le, [De], (t4, [e3]) => {
        const r3 = t4.globals && t4.globals.isSupportedScript;
        return !r3 || r3(e3.evaluate(t4));
      }], upcase: [De, [De], (t4, [e3]) => e3.evaluate(t4).toUpperCase()], downcase: [De, [De], (t4, [e3]) => e3.evaluate(t4).toLowerCase()], concat: [De, Ti2(Ue), (t4, e3) => e3.map((e4) => nr(e4.evaluate(t4))).join("")], "resolved-locale": [De, [je], (t4, [e3]) => e3.evaluate(t4).resolvedLocale()], random: [Re, [Re, Re, Ue], (t4, e3) => {
        const [r3, n3, i3] = e3.map((e4) => e4.evaluate(t4));
        if (r3 > n3) return r3;
        if (r3 === n3) return r3;
        let a4;
        if ("string" == typeof i3) a4 = function(t5) {
          let e4 = 0;
          if (0 === t5.length) return e4;
          for (let r4 = 0; r4 < t5.length; r4++) e4 = (e4 << 5) - e4 + t5.charCodeAt(r4), e4 |= 0;
          return e4;
        }(i3);
        else {
          if ("number" != typeof i3) throw new ar(`Invalid seed input: ${i3}`);
          a4 = i3;
        }
        return r3 + Ai(a4)() * (n3 - r3);
      }] });
      class Xi {
        constructor(t4, e3, r3, n3) {
          this.expression = t4, this._warningHistory = {}, this._evaluator = new dr(r3, n3), this._defaultValue = e3 ? function(t5) {
            return "color" === t5.type && (Fi(t5.default) || Array.isArray(t5.default)) ? new Ie(0, 0, 0, 0) : "color" === t5.type ? Ie.parse(t5.default) || null : void 0 === t5.default ? null : t5.default;
          }(e3) : null, this._enumValues = e3 && "enum" === e3.type ? e3.values : null, this.configDependencies = Bn(t4);
        }
        evaluateWithoutErrorHandling(t4, e3, r3, n3, i3, a4, s3, o3) {
          return this._evaluator.globals = t4, this._evaluator.feature = e3, this._evaluator.featureState = r3, this._evaluator.canonical = n3 || null, this._evaluator.availableImages = i3 || null, this._evaluator.formattedSection = a4, this._evaluator.featureTileCoord = s3 || null, this._evaluator.featureDistanceData = o3 || null, this.expression.evaluate(this._evaluator);
        }
        evaluate(t4, e3, r3, n3, i3, a4, s3, o3) {
          this._evaluator.globals = t4, this._evaluator.feature = e3 || null, this._evaluator.featureState = r3 || null, this._evaluator.canonical = n3 || null, this._evaluator.availableImages = i3 || null, this._evaluator.formattedSection = a4 || null, this._evaluator.featureTileCoord = s3 || null, this._evaluator.featureDistanceData = o3 || null;
          try {
            const t5 = this.expression.evaluate(this._evaluator);
            if (null == t5 || "number" == typeof t5 && t5 != t5) return this._defaultValue;
            if (this._enumValues && !(t5 in this._enumValues)) throw new ar(`Expected value to be one of ${Object.keys(this._enumValues).map((t6) => JSON.stringify(t6)).join(", ")}, but found ${JSON.stringify(t5)} instead.`);
            return t5;
          } catch (t5) {
            return this._warningHistory[t5.message] || (this._warningHistory[t5.message] = true, "undefined" != typeof console && console.warn(`Failed to evaluate expression "${JSON.stringify(this.expression.serialize())}". ${t5.message}`)), this._defaultValue;
          }
        }
      }
      function Yi(t4) {
        return Array.isArray(t4) && t4.length > 0 && "string" == typeof t4[0] && t4[0] in Si2;
      }
      function Zi2(t4, e3, r3, n3) {
        const i3 = new Rn(Si2, [], e3 ? function(t5) {
          const e4 = { color: Fe, string: De, number: Re, enum: De, boolean: Le, formatted: Ne, resolvedImage: qe };
          return "array" === t5.type ? $e(e4[t5.value] || Ue, t5.length) : e4[t5.type];
        }(e3) : void 0, void 0, void 0, r3, n3), a4 = i3.parse(t4, void 0, void 0, void 0, e3 && "string" === e3.type ? { typeAnnotation: "coerce" } : void 0);
        return a4 ? Ei(new Xi(a4, e3, r3, n3)) : Bi(i3.errors);
      }
      class Wi {
        constructor(t4, e3, r3) {
          this.kind = t4, this._styleExpression = e3, this.isLightConstant = r3, this.isStateDependent = "constant" !== t4 && !En(e3.expression), this.configDependencies = Bn(e3.expression);
        }
        evaluateWithoutErrorHandling(t4, e3, r3, n3, i3, a4) {
          return this._styleExpression.evaluateWithoutErrorHandling(t4, e3, r3, n3, i3, a4);
        }
        evaluate(t4, e3, r3, n3, i3, a4) {
          return this._styleExpression.evaluate(t4, e3, r3, n3, i3, a4);
        }
      }
      class Hi {
        constructor(t4, e3, r3, n3, i3) {
          this.kind = t4, this.zoomStops = r3, this._styleExpression = e3, this.isStateDependent = "camera" !== t4 && !En(e3.expression), this.isLightConstant = i3, this.configDependencies = Bn(e3.expression), this.interpolationType = n3;
        }
        evaluateWithoutErrorHandling(t4, e3, r3, n3, i3, a4) {
          return this._styleExpression.evaluateWithoutErrorHandling(t4, e3, r3, n3, i3, a4);
        }
        evaluate(t4, e3, r3, n3, i3, a4) {
          return this._styleExpression.evaluate(t4, e3, r3, n3, i3, a4);
        }
        interpolationFactor(t4, e3, r3) {
          return this.interpolationType ? ni.interpolationFactor(this.interpolationType, t4, e3, r3) : 0;
        }
      }
      function Ki(t4, e3, r3, n3) {
        if ("error" === (t4 = Zi2(t4, e3, r3, n3)).result) return t4;
        const i3 = t4.value.expression, a4 = Tn(i3);
        if (!a4 && !Ci(e3)) return Bi([new Be("", "data expressions not supported")]);
        const s3 = Vn(i3, ["zoom", "pitch", "distance-from-center"]);
        if (!s3 && !Di(e3)) return Bi([new Be("", "zoom expressions not supported")]);
        const o3 = Vn(i3, ["measure-light"]);
        if (!o3 && !Ri(e3)) return Bi([new Be("", "measure-light expression not supported")]);
        const l3 = Vn(i3, ["line-progress"]);
        if (!l3 && !function(t5) {
          return Vi(t5.expression, "line-progress");
        }(e3)) return Bi([new Be("", "line-progress expression not supported")]);
        const u4 = e3.expression && e3.expression.relaxZoomRestriction, c3 = Qi(i3);
        return c3 || s3 || u4 ? c3 instanceof Be ? Bi([c3]) : c3 instanceof ni && !Li(e3) ? Bi([new Be("", '"interpolate" expressions cannot be used with this property')]) : Ei(c3 ? new Hi(a4 && l3 ? "camera" : "composite", t4.value, c3.labels, c3 instanceof ni ? c3.interpolation : void 0, o3) : new Wi(a4 && l3 ? "constant" : "source", t4.value, o3)) : Bi([new Be("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')]);
      }
      class Ji {
        constructor(t4, e3) {
          this._parameters = t4, this._specification = e3, Ee(this, Ui(this._parameters, this._specification));
        }
        static deserialize(t4) {
          return new Ji(t4._parameters, t4._specification);
        }
        static serialize(t4) {
          return { _parameters: t4._parameters, _specification: t4._specification };
        }
      }
      function Qi(t4) {
        let e3 = null;
        if (t4 instanceof si) e3 = Qi(t4.result);
        else if (t4 instanceof ai) {
          for (const r3 of t4.args) if (e3 = Qi(r3), e3) break;
        } else (t4 instanceof Fn || t4 instanceof ni) && t4.input instanceof mr && "zoom" === t4.input.name && (e3 = t4);
        return e3 instanceof Be || t4.eachChild((t5) => {
          const r3 = Qi(t5);
          r3 instanceof Be ? e3 = r3 : e3 && r3 && e3 !== r3 && (e3 = new Be("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
        }), e3;
      }
      var ta, ea, ra = function() {
        if (ea) return ta;
        ea = 1, ta = e3;
        var t4 = 3;
        function e3(e4, r3, n3) {
          var i3 = this.cells = [];
          if (e4 instanceof ArrayBuffer) {
            this.arrayBuffer = e4;
            var a4 = new Int32Array(this.arrayBuffer);
            e4 = a4[0], this.d = (r3 = a4[1]) + 2 * (n3 = a4[2]);
            for (var s3 = 0; s3 < this.d * this.d; s3++) {
              var o3 = a4[t4 + s3], l3 = a4[t4 + s3 + 1];
              i3.push(o3 === l3 ? null : a4.subarray(o3, l3));
            }
            var u4 = a4[t4 + i3.length + 1];
            this.keys = a4.subarray(a4[t4 + i3.length], u4), this.bboxes = a4.subarray(u4), this.insert = this._insertReadonly;
          } else {
            this.d = r3 + 2 * n3;
            for (var c3 = 0; c3 < this.d * this.d; c3++) i3.push([]);
            this.keys = [], this.bboxes = [];
          }
          this.n = r3, this.extent = e4, this.padding = n3, this.scale = r3 / e4, this.uid = 0;
          var h3 = n3 / r3 * e4;
          this.min = -h3, this.max = e4 + h3;
        }
        return e3.prototype.insert = function(t5, e4, r3, n3, i3) {
          this._forEachCell(e4, r3, n3, i3, this._insertCell, this.uid++), this.keys.push(t5), this.bboxes.push(e4), this.bboxes.push(r3), this.bboxes.push(n3), this.bboxes.push(i3);
        }, e3.prototype._insertReadonly = function() {
          throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
        }, e3.prototype._insertCell = function(t5, e4, r3, n3, i3, a4) {
          this.cells[i3].push(a4);
        }, e3.prototype.query = function(t5, e4, r3, n3, i3) {
          var a4 = this.min, s3 = this.max;
          if (t5 <= a4 && e4 <= a4 && s3 <= r3 && s3 <= n3 && !i3) return Array.prototype.slice.call(this.keys);
          var o3 = [];
          return this._forEachCell(t5, e4, r3, n3, this._queryCell, o3, {}, i3), o3;
        }, e3.prototype._queryCell = function(t5, e4, r3, n3, i3, a4, s3, o3) {
          var l3 = this.cells[i3];
          if (null !== l3) for (var u4 = this.keys, c3 = this.bboxes, h3 = 0; h3 < l3.length; h3++) {
            var p3 = l3[h3];
            if (void 0 === s3[p3]) {
              var f3 = 4 * p3;
              (o3 ? o3(c3[f3 + 0], c3[f3 + 1], c3[f3 + 2], c3[f3 + 3]) : t5 <= c3[f3 + 2] && e4 <= c3[f3 + 3] && r3 >= c3[f3 + 0] && n3 >= c3[f3 + 1]) ? (s3[p3] = true, a4.push(u4[p3])) : s3[p3] = false;
            }
          }
        }, e3.prototype._forEachCell = function(t5, e4, r3, n3, i3, a4, s3, o3) {
          for (var l3 = this._convertToCellCoord(t5), u4 = this._convertToCellCoord(e4), c3 = this._convertToCellCoord(r3), h3 = this._convertToCellCoord(n3), p3 = l3; p3 <= c3; p3++) for (var f3 = u4; f3 <= h3; f3++) {
            var d3 = this.d * f3 + p3;
            if ((!o3 || o3(this._convertFromCellCoord(p3), this._convertFromCellCoord(f3), this._convertFromCellCoord(p3 + 1), this._convertFromCellCoord(f3 + 1))) && i3.call(this, t5, e4, r3, n3, d3, a4, s3, o3)) return;
          }
        }, e3.prototype._convertFromCellCoord = function(t5) {
          return (t5 - this.padding) / this.scale;
        }, e3.prototype._convertToCellCoord = function(t5) {
          return Math.max(0, Math.min(this.d - 1, Math.floor(t5 * this.scale) + this.padding));
        }, e3.prototype.toArrayBuffer = function() {
          if (this.arrayBuffer) return this.arrayBuffer;
          for (var e4 = this.cells, r3 = t4 + this.cells.length + 1 + 1, n3 = 0, i3 = 0; i3 < this.cells.length; i3++) n3 += this.cells[i3].length;
          var a4 = new Int32Array(r3 + n3 + this.keys.length + this.bboxes.length);
          a4[0] = this.extent, a4[1] = this.n, a4[2] = this.padding;
          for (var s3 = r3, o3 = 0; o3 < e4.length; o3++) {
            var l3 = e4[o3];
            a4[t4 + o3] = s3, a4.set(l3, s3), s3 += l3.length;
          }
          return a4[t4 + e4.length] = s3, a4.set(this.keys, s3), a4[t4 + e4.length + 1] = s3 += this.keys.length, a4.set(this.bboxes, s3), s3 += this.bboxes.length, a4.buffer;
        }, ta;
      }(), na = e2(ra);
      const ia = {};
      function aa(t4, e3, r3 = {}) {
        Object.defineProperty(t4, "_classRegistryKey", { value: e3, writable: false }), ia[e3] = { klass: t4, omit: r3.omit || [] };
      }
      aa(Object, "Object"), na.serialize = function(t4, e3) {
        const r3 = t4.toArrayBuffer();
        return e3 && e3.add(r3), { buffer: r3 };
      }, na.deserialize = function(t4) {
        return new na(t4.buffer);
      }, Object.defineProperty(na, "name", { value: "Grid" }), aa(na, "Grid"), aa(Ie, "Color"), aa(Error, "Error"), aa(Je, "Formatted"), aa(Ke, "FormattedSection"), aa(ee, "AJAXError"), aa(Qe, "ResolvedImage"), aa(Ji, "StylePropertyFunction"), aa(Xi, "StyleExpression", { omit: ["_evaluator"] }), aa(Hi, "ZoomDependentExpression"), aa(Wi, "ZoomConstantExpression"), aa(mr, "CompoundExpression", { omit: ["_evaluate"] });
      for (const t4 in Si2) ia[Si2[t4]._classRegistryKey] || aa(Si2[t4], `Expression${t4}`);
      function sa(t4) {
        return t4 && "undefined" != typeof ArrayBuffer && (t4 instanceof ArrayBuffer || t4.constructor && "ArrayBuffer" === t4.constructor.name);
      }
      function oa(t4) {
        return self.ImageBitmap && t4 instanceof ImageBitmap;
      }
      function la(t4, e3) {
        if (null == t4 || "boolean" == typeof t4 || "number" == typeof t4 || "string" == typeof t4 || t4 instanceof Boolean || t4 instanceof Number || t4 instanceof String || t4 instanceof Date || t4 instanceof RegExp) return t4;
        if (sa(t4) || oa(t4)) return e3 && e3.add(t4), t4;
        if (ArrayBuffer.isView(t4)) {
          const r3 = t4;
          return e3 && e3.add(r3.buffer), r3;
        }
        if (t4 instanceof ImageData) return e3 && e3.add(t4.data.buffer), t4;
        if (Array.isArray(t4)) {
          const r3 = [];
          for (const n3 of t4) r3.push(la(n3, e3));
          return r3;
        }
        if (t4 instanceof Map) {
          const e4 = { $name: "Map" };
          for (const [r3, n3] of t4.entries()) e4[r3] = la(n3);
          return e4;
        }
        if (t4 instanceof Set) {
          const e4 = { $name: "Set" };
          let r3 = 0;
          for (const n3 of t4.values()) e4[++r3] = la(n3);
          return e4;
        }
        if ("object" == typeof t4) {
          const r3 = t4.constructor, n3 = r3._classRegistryKey;
          if (!n3) throw new Error(`can't serialize object of unregistered class ${n3}`);
          const i3 = r3.serialize ? r3.serialize(t4, e3) : {};
          if (!r3.serialize) {
            for (const r4 in t4) t4.hasOwnProperty(r4) && (ia[n3].omit.indexOf(r4) >= 0 || (i3[r4] = la(t4[r4], e3)));
            t4 instanceof Error && (i3.message = t4.message);
          }
          if (i3.$name) throw new Error("$name property is reserved for worker serialization logic.");
          return "Object" !== n3 && (i3.$name = n3), i3;
        }
        throw new Error("can't serialize object of type " + typeof t4);
      }
      function ua(t4) {
        if (null == t4 || "boolean" == typeof t4 || "number" == typeof t4 || "string" == typeof t4 || t4 instanceof Boolean || t4 instanceof Number || t4 instanceof String || t4 instanceof Date || t4 instanceof RegExp || sa(t4) || oa(t4) || ArrayBuffer.isView(t4) || t4 instanceof ImageData) return t4;
        if (Array.isArray(t4)) return t4.map(ua);
        if ("object" == typeof t4) {
          const e3 = t4.$name || "Object";
          if ("Map" === e3) {
            const e4 = /* @__PURE__ */ new Map();
            for (const r4 of Object.keys(t4)) "$name" !== r4 && e4.set(r4, ua(t4[r4]));
            return e4;
          }
          if ("Set" === e3) {
            const e4 = /* @__PURE__ */ new Set();
            for (const r4 of Object.keys(t4)) "$name" !== r4 && e4.add(ua(t4[r4]));
            return e4;
          }
          const { klass: r3 } = ia[e3];
          if (!r3) throw new Error(`can't deserialize unregistered class ${e3}`);
          if (r3.deserialize) return r3.deserialize(t4);
          const n3 = Object.create(r3.prototype);
          for (const e4 of Object.keys(t4)) "$name" !== e4 && (n3[e4] = ua(t4[e4]));
          return n3;
        }
        throw new Error("can't deserialize object of type " + typeof t4);
      }
      const ca = { "Latin-1 Supplement": (t4) => t4 >= 128 && t4 <= 255, Arabic: (t4) => t4 >= 1536 && t4 <= 1791, "Arabic Supplement": (t4) => t4 >= 1872 && t4 <= 1919, "Arabic Extended-A": (t4) => t4 >= 2208 && t4 <= 2303, "Hangul Jamo": (t4) => t4 >= 4352 && t4 <= 4607, "Unified Canadian Aboriginal Syllabics": (t4) => t4 >= 5120 && t4 <= 5759, Khmer: (t4) => t4 >= 6016 && t4 <= 6143, "Unified Canadian Aboriginal Syllabics Extended": (t4) => t4 >= 6320 && t4 <= 6399, "General Punctuation": (t4) => t4 >= 8192 && t4 <= 8303, "Letterlike Symbols": (t4) => t4 >= 8448 && t4 <= 8527, "Number Forms": (t4) => t4 >= 8528 && t4 <= 8591, "Miscellaneous Technical": (t4) => t4 >= 8960 && t4 <= 9215, "Control Pictures": (t4) => t4 >= 9216 && t4 <= 9279, "Optical Character Recognition": (t4) => t4 >= 9280 && t4 <= 9311, "Enclosed Alphanumerics": (t4) => t4 >= 9312 && t4 <= 9471, "Geometric Shapes": (t4) => t4 >= 9632 && t4 <= 9727, "Miscellaneous Symbols": (t4) => t4 >= 9728 && t4 <= 9983, "Miscellaneous Symbols and Arrows": (t4) => t4 >= 11008 && t4 <= 11263, "CJK Radicals Supplement": (t4) => t4 >= 11904 && t4 <= 12031, "Kangxi Radicals": (t4) => t4 >= 12032 && t4 <= 12255, "Ideographic Description Characters": (t4) => t4 >= 12272 && t4 <= 12287, "CJK Symbols and Punctuation": (t4) => t4 >= 12288 && t4 <= 12351, Hiragana: (t4) => t4 >= 12352 && t4 <= 12447, Katakana: (t4) => t4 >= 12448 && t4 <= 12543, Bopomofo: (t4) => t4 >= 12544 && t4 <= 12591, "Hangul Compatibility Jamo": (t4) => t4 >= 12592 && t4 <= 12687, Kanbun: (t4) => t4 >= 12688 && t4 <= 12703, "Bopomofo Extended": (t4) => t4 >= 12704 && t4 <= 12735, "CJK Strokes": (t4) => t4 >= 12736 && t4 <= 12783, "Katakana Phonetic Extensions": (t4) => t4 >= 12784 && t4 <= 12799, "Enclosed CJK Letters and Months": (t4) => t4 >= 12800 && t4 <= 13055, "CJK Compatibility": (t4) => t4 >= 13056 && t4 <= 13311, "CJK Unified Ideographs Extension A": (t4) => t4 >= 13312 && t4 <= 19903, "Yijing Hexagram Symbols": (t4) => t4 >= 19904 && t4 <= 19967, "CJK Unified Ideographs": (t4) => t4 >= 19968 && t4 <= 40959, "Yi Syllables": (t4) => t4 >= 40960 && t4 <= 42127, "Yi Radicals": (t4) => t4 >= 42128 && t4 <= 42191, "Hangul Jamo Extended-A": (t4) => t4 >= 43360 && t4 <= 43391, "Hangul Syllables": (t4) => t4 >= 44032 && t4 <= 55215, "Hangul Jamo Extended-B": (t4) => t4 >= 55216 && t4 <= 55295, "Private Use Area": (t4) => t4 >= 57344 && t4 <= 63743, "CJK Compatibility Ideographs": (t4) => t4 >= 63744 && t4 <= 64255, "Arabic Presentation Forms-A": (t4) => t4 >= 64336 && t4 <= 65023, "Vertical Forms": (t4) => t4 >= 65040 && t4 <= 65055, "CJK Compatibility Forms": (t4) => t4 >= 65072 && t4 <= 65103, "Small Form Variants": (t4) => t4 >= 65104 && t4 <= 65135, "Arabic Presentation Forms-B": (t4) => t4 >= 65136 && t4 <= 65279, "Halfwidth and Fullwidth Forms": (t4) => t4 >= 65280 && t4 <= 65519, Osage: (t4) => t4 >= 66736 && t4 <= 66815, "CJK Unified Ideographs Extension B": (t4) => t4 >= 131072 && t4 <= 173791 };
      function ha(t4) {
        for (const e3 of t4) if (da(e3.charCodeAt(0))) return true;
        return false;
      }
      function pa(t4) {
        for (const e3 of t4) if (!fa(e3.charCodeAt(0))) return false;
        return true;
      }
      function fa(t4) {
        return !(ca.Arabic(t4) || ca["Arabic Supplement"](t4) || ca["Arabic Extended-A"](t4) || ca["Arabic Presentation Forms-A"](t4) || ca["Arabic Presentation Forms-B"](t4));
      }
      function da(t4) {
        return !(746 !== t4 && 747 !== t4 && (t4 < 4352 || !(ca["Bopomofo Extended"](t4) || ca.Bopomofo(t4) || ca["CJK Compatibility Forms"](t4) && !(t4 >= 65097 && t4 <= 65103) || ca["CJK Compatibility Ideographs"](t4) || ca["CJK Compatibility"](t4) || ca["CJK Radicals Supplement"](t4) || ca["CJK Strokes"](t4) || !(!ca["CJK Symbols and Punctuation"](t4) || t4 >= 12296 && t4 <= 12305 || t4 >= 12308 && t4 <= 12319 || 12336 === t4) || ca["CJK Unified Ideographs Extension A"](t4) || ca["CJK Unified Ideographs"](t4) || ca["Enclosed CJK Letters and Months"](t4) || ca["Hangul Compatibility Jamo"](t4) || ca["Hangul Jamo Extended-A"](t4) || ca["Hangul Jamo Extended-B"](t4) || ca["Hangul Jamo"](t4) || ca["Hangul Syllables"](t4) || ca.Hiragana(t4) || ca["Ideographic Description Characters"](t4) || ca.Kanbun(t4) || ca["Kangxi Radicals"](t4) || ca["Katakana Phonetic Extensions"](t4) || ca.Katakana(t4) && 12540 !== t4 || !(!ca["Halfwidth and Fullwidth Forms"](t4) || 65288 === t4 || 65289 === t4 || 65293 === t4 || t4 >= 65306 && t4 <= 65310 || 65339 === t4 || 65341 === t4 || 65343 === t4 || t4 >= 65371 && t4 <= 65503 || 65507 === t4 || t4 >= 65512 && t4 <= 65519) || !(!ca["Small Form Variants"](t4) || t4 >= 65112 && t4 <= 65118 || t4 >= 65123 && t4 <= 65126) || ca["Unified Canadian Aboriginal Syllabics"](t4) || ca["Unified Canadian Aboriginal Syllabics Extended"](t4) || ca["Vertical Forms"](t4) || ca["Yijing Hexagram Symbols"](t4) || ca["Yi Syllables"](t4) || ca["Yi Radicals"](t4))));
      }
      function ma(t4) {
        return !(da(t4) || function(t5) {
          return !!(ca["Latin-1 Supplement"](t5) && (167 === t5 || 169 === t5 || 174 === t5 || 177 === t5 || 188 === t5 || 189 === t5 || 190 === t5 || 215 === t5 || 247 === t5) || ca["General Punctuation"](t5) && (8214 === t5 || 8224 === t5 || 8225 === t5 || 8240 === t5 || 8241 === t5 || 8251 === t5 || 8252 === t5 || 8258 === t5 || 8263 === t5 || 8264 === t5 || 8265 === t5 || 8273 === t5) || ca["Letterlike Symbols"](t5) || ca["Number Forms"](t5) || ca["Miscellaneous Technical"](t5) && (t5 >= 8960 && t5 <= 8967 || t5 >= 8972 && t5 <= 8991 || t5 >= 8996 && t5 <= 9e3 || 9003 === t5 || t5 >= 9085 && t5 <= 9114 || t5 >= 9150 && t5 <= 9165 || 9167 === t5 || t5 >= 9169 && t5 <= 9179 || t5 >= 9186 && t5 <= 9215) || ca["Control Pictures"](t5) && 9251 !== t5 || ca["Optical Character Recognition"](t5) || ca["Enclosed Alphanumerics"](t5) || ca["Geometric Shapes"](t5) || ca["Miscellaneous Symbols"](t5) && !(t5 >= 9754 && t5 <= 9759) || ca["Miscellaneous Symbols and Arrows"](t5) && (t5 >= 11026 && t5 <= 11055 || t5 >= 11088 && t5 <= 11097 || t5 >= 11192 && t5 <= 11243) || ca["CJK Symbols and Punctuation"](t5) || ca.Katakana(t5) || ca["Private Use Area"](t5) || ca["CJK Compatibility Forms"](t5) || ca["Small Form Variants"](t5) || ca["Halfwidth and Fullwidth Forms"](t5) || 8734 === t5 || 8756 === t5 || 8757 === t5 || t5 >= 9984 && t5 <= 10087 || t5 >= 10102 && t5 <= 10131 || 65532 === t5 || 65533 === t5);
        }(t4));
      }
      function ya(t4) {
        return t4 >= 1424 && t4 <= 2303 || ca["Arabic Presentation Forms-A"](t4) || ca["Arabic Presentation Forms-B"](t4);
      }
      function ga(t4, e3) {
        return !(!e3 && ya(t4) || t4 >= 2304 && t4 <= 3583 || t4 >= 3840 && t4 <= 4255 || ca.Khmer(t4));
      }
      function xa(t4) {
        for (const e3 of t4) if (ya(e3.charCodeAt(0))) return true;
        return false;
      }
      const va = "deferred", ba = "loading", wa = "loaded";
      let _a2 = null, Ma = "unavailable", Aa = null;
      const Sa = function(t4) {
        t4 && "string" == typeof t4 && t4.indexOf("NetworkError") > -1 && (Ma = "error"), _a2 && _a2(t4);
      };
      function Ia() {
        za.fire(new xe("pluginStateChange", { pluginStatus: Ma, pluginURL: Aa }));
      }
      const za = new _e(), Pa = function() {
        return Ma;
      }, ka = function() {
        if (Ma !== va || !Aa) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
        Ma = ba, Ia(), Aa && ie({ url: Aa }, (t4) => {
          t4 ? Sa(t4) : (Ma = wa, Ia());
        });
      }, Ta = { applyArabicShaping: null, processBidirectionalText: null, processStyledBidirectionalText: null, isLoaded: () => Ma === wa || null != Ta.applyArabicShaping, isLoading: () => Ma === ba, setState(t4) {
        Ma = t4.pluginStatus, Aa = t4.pluginURL;
      }, isParsed: () => null != Ta.applyArabicShaping && null != Ta.processBidirectionalText && null != Ta.processStyledBidirectionalText, getPluginURL: () => Aa };
      class Ea {
        constructor(t4, e3) {
          this.zoom = t4, e3 ? (this.now = e3.now, this.fadeDuration = e3.fadeDuration, this.transition = e3.transition, this.pitch = e3.pitch, this.brightness = e3.brightness) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
        }
        isSupportedScript(t4) {
          return function(t5, e3) {
            for (const r3 of t5) if (!ga(r3.charCodeAt(0), e3)) return false;
            return true;
          }(t4, Ta.isLoaded());
        }
      }
      class Ba {
        constructor(t4, e3, r3, n3) {
          this.property = t4, this.value = e3, this.expression = function(t5, e4, r4, n4) {
            if (Fi(t5)) return new Ji(t5, e4);
            if (Yi(t5) || Array.isArray(t5) && t5.length > 0) {
              const i3 = Ki(t5, e4, r4, n4);
              if ("error" === i3.result) throw new Error(i3.value.map((t6) => `${t6.key}: ${t6.message}`).join(", "));
              return i3.value;
            }
            {
              let r5 = t5;
              return "string" == typeof t5 && "color" === e4.type && (r5 = Ie.parse(t5)), { kind: "constant", configDependencies: /* @__PURE__ */ new Set(), evaluate: () => r5 };
            }
          }(void 0 === e3 ? t4.specification.default : e3, t4.specification, r3, n3);
        }
        isDataDriven() {
          return "source" === this.expression.kind || "composite" === this.expression.kind;
        }
        possiblyEvaluate(t4, e3, r3) {
          return this.property.possiblyEvaluate(this, t4, e3, r3);
        }
      }
      class Va {
        constructor(t4, e3, r3) {
          this.property = t4, this.value = new Ba(t4, void 0, e3, r3);
        }
        transitioned(t4, e3) {
          return new Ra(this.property, this.value, e3, nt({}, t4.transition, this.transition), t4.now);
        }
        untransitioned() {
          return new Ra(this.property, this.value, null, {}, 0);
        }
      }
      class Ca {
        constructor(t4, e3, r3) {
          this._properties = t4, this._values = Object.create(t4.defaultTransitionablePropertyValues), this._scope = e3, this._options = r3, this.configDependencies = /* @__PURE__ */ new Set();
        }
        getValue(t4) {
          return ht(this._values[t4].value.value);
        }
        setValue(t4, e3) {
          this._values.hasOwnProperty(t4) || (this._values[t4] = new Va(this._values[t4].property, this._scope, this._options)), this._values[t4].value = new Ba(this._values[t4].property, null === e3 ? void 0 : ht(e3), this._scope, this._options), this._values[t4].value.expression.configDependencies && (this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._values[t4].value.expression.configDependencies]));
        }
        setTransitionOrValue(t4, e3) {
          e3 && (this._options = e3);
          const r3 = this._properties.properties;
          if (t4) for (const e4 in t4) {
            const n3 = t4[e4];
            if (lt2(e4, "-transition")) {
              const t5 = e4.slice(0, -11);
              r3[t5] && this.setTransition(t5, n3);
            } else r3.hasOwnProperty(e4) && this.setValue(e4, n3);
          }
        }
        getTransition(t4) {
          return ht(this._values[t4].transition);
        }
        setTransition(t4, e3) {
          this._values.hasOwnProperty(t4) || (this._values[t4] = new Va(this._values[t4].property)), this._values[t4].transition = ht(e3) || void 0;
        }
        serialize() {
          const t4 = {};
          for (const e3 of Object.keys(this._values)) {
            const r3 = this.getValue(e3);
            void 0 !== r3 && (t4[e3] = r3);
            const n3 = this.getTransition(e3);
            void 0 !== n3 && (t4[`${e3}-transition`] = n3);
          }
          return t4;
        }
        transitioned(t4, e3) {
          const r3 = new Da(this._properties);
          for (const n3 of Object.keys(this._values)) r3._values[n3] = this._values[n3].transitioned(t4, e3._values[n3]);
          return r3;
        }
        untransitioned() {
          const t4 = new Da(this._properties);
          for (const e3 of Object.keys(this._values)) t4._values[e3] = this._values[e3].untransitioned();
          return t4;
        }
      }
      class Ra {
        constructor(t4, e3, r3, n3, i3) {
          const a4 = n3.delay || 0, s3 = n3.duration || 0;
          i3 = i3 || 0, this.property = t4, this.value = e3, this.begin = i3 + a4, this.end = this.begin + s3, t4.specification.transition && (n3.delay || n3.duration) && (this.prior = r3);
        }
        possiblyEvaluate(t4, e3, r3) {
          const n3 = t4.now || 0, i3 = this.value.possiblyEvaluate(t4, e3, r3), a4 = this.prior;
          if (a4) {
            if (n3 > this.end) return this.prior = null, i3;
            if (this.value.isDataDriven()) return this.prior = null, i3;
            if (n3 < this.begin) return a4.possiblyEvaluate(t4, e3, r3);
            {
              const s3 = (n3 - this.begin) / (this.end - this.begin);
              return this.property.interpolate(a4.possiblyEvaluate(t4, e3, r3), i3, H(s3));
            }
          }
          return i3;
        }
      }
      class Da {
        constructor(t4) {
          this._properties = t4, this._values = Object.create(t4.defaultTransitioningPropertyValues);
        }
        possiblyEvaluate(t4, e3, r3) {
          const n3 = new Oa(this._properties);
          for (const i3 of Object.keys(this._values)) n3._values[i3] = this._values[i3].possiblyEvaluate(t4, e3, r3);
          return n3;
        }
        hasTransition() {
          for (const t4 of Object.keys(this._values)) if (this._values[t4].prior) return true;
          return false;
        }
      }
      class La {
        constructor(t4, e3, r3) {
          this._properties = t4, this._values = Object.create(t4.defaultPropertyValues), this._scope = e3, this._options = r3, this.configDependencies = /* @__PURE__ */ new Set();
        }
        getValue(t4) {
          return ht(this._values[t4].value);
        }
        setValue(t4, e3) {
          this._values[t4] = new Ba(this._values[t4].property, null === e3 ? void 0 : ht(e3), this._scope, this._options), this._values[t4].expression.configDependencies && (this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._values[t4].expression.configDependencies]));
        }
        serialize() {
          const t4 = {};
          for (const e3 of Object.keys(this._values)) {
            const r3 = this.getValue(e3);
            void 0 !== r3 && (t4[e3] = r3);
          }
          return t4;
        }
        possiblyEvaluate(t4, e3, r3) {
          const n3 = new Oa(this._properties);
          for (const i3 of Object.keys(this._values)) n3._values[i3] = this._values[i3].possiblyEvaluate(t4, e3, r3);
          return n3;
        }
      }
      class Fa {
        constructor(t4, e3, r3) {
          this.property = t4, this.value = e3, this.parameters = r3;
        }
        isConstant() {
          return "constant" === this.value.kind;
        }
        constantOr(t4) {
          return "constant" === this.value.kind ? this.value.value : t4;
        }
        evaluate(t4, e3, r3, n3) {
          return this.property.evaluate(this.value, this.parameters, t4, e3, r3, n3);
        }
      }
      class Oa {
        constructor(t4) {
          this._properties = t4, this._values = Object.create(t4.defaultPossiblyEvaluatedValues);
        }
        get(t4) {
          return this._values[t4];
        }
      }
      class Ua {
        constructor(t4) {
          this.specification = t4;
        }
        possiblyEvaluate(t4, e3) {
          return t4.expression.evaluate(e3);
        }
        interpolate(t4, e3, r3) {
          const n3 = Te[this.specification.type];
          return n3 ? n3(t4, e3, r3) : t4;
        }
      }
      class ja {
        constructor(t4, e3) {
          this.specification = t4, this.overrides = e3;
        }
        possiblyEvaluate(t4, e3, r3, n3) {
          return new Fa(this, "constant" === t4.expression.kind || "camera" === t4.expression.kind ? { kind: "constant", value: t4.expression.evaluate(e3, null, {}, r3, n3) } : t4.expression, e3);
        }
        interpolate(t4, e3, r3) {
          if ("constant" !== t4.value.kind || "constant" !== e3.value.kind) return t4;
          if (void 0 === t4.value.value || void 0 === e3.value.value) return new Fa(this, { kind: "constant", value: void 0 }, t4.parameters);
          const n3 = Te[this.specification.type];
          return n3 ? new Fa(this, { kind: "constant", value: n3(t4.value.value, e3.value.value, r3) }, t4.parameters) : t4;
        }
        evaluate(t4, e3, r3, n3, i3, a4) {
          return "constant" === t4.kind ? t4.value : t4.evaluate(e3, r3, n3, i3, a4);
        }
      }
      class Na {
        constructor(t4) {
          this.specification = t4;
        }
        possiblyEvaluate(t4, e3, r3, n3) {
          return !!t4.expression.evaluate(e3, null, {}, r3, n3);
        }
        interpolate() {
          return false;
        }
      }
      class qa {
        constructor(t4) {
          this.properties = t4, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
          const e3 = new Ea(0, {});
          for (const r3 in t4) {
            const n3 = t4[r3];
            n3.specification.overridable && this.overridableProperties.push(r3);
            const i3 = this.defaultPropertyValues[r3] = new Ba(n3, void 0), a4 = this.defaultTransitionablePropertyValues[r3] = new Va(n3);
            this.defaultTransitioningPropertyValues[r3] = a4.untransitioned(), this.defaultPossiblyEvaluatedValues[r3] = i3.possiblyEvaluate(e3);
          }
        }
      }
      aa(ja, "DataDrivenProperty"), aa(Ua, "DataConstantProperty"), aa(Na, "ColorRampProperty");
      var $a = JSON.parse('{"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"required":false,"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"camera":{"type":"camera"},"color-theme":{"type":"colorTheme"},"imports":{"type":"array","value":"import"},"schema":{"type":"schema"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"required":true,"type":"array","value":"layer"},"models":{"type":"models"},"featuresets":{"experimental":true,"type":"featuresets"}},"featuresets":{"experimental":true,"*":{"type":"featureset"}},"featureset":{"experimental":true,"metadata":{"type":"*"},"selectors":{"type":"array","value":"selector"}},"selector":{"experimental":true,"layer":{"type":"string","required":true},"properties":{"type":"selectorProperty","required":false},"featureNamespace":{"type":"string","required":false}},"selectorProperty":{"experimental":true,"*":{"type":"*"}},"model":{"type":"string","required":true},"import":{"id":{"type":"string","required":true},"url":{"type":"string","required":true},"config":{"type":"config"},"data":{"type":"$root"}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"default":{"type":"*","property-type":"data-constant","expression":{},"required":true},"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1}},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"values":{"type":"array","value":"*"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"id":{"type":"string","required":true},"properties":{"type":"properties"},"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"cast-shadows":{"type":"boolean","default":false,"property-type":"data-constant"},"shadow-intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_ambient":{"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":1,"mapbox":1},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"experimental":true,"type":{"required":true,"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"},"dynamic":{"type":"boolean","default":false}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":1}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":1}},"url":{"required":false,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_model":{"type":{"required":true,"type":"enum","values":{"model":1,"batched-model":1}},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"raster-particle":{"experimental":true},"hillshade":{},"model":{"experimental":true},"background":{},"sky":{},"slot":{},"clip":{}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_clip","layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_raster-particle","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_model":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"model-id":{"type":"string","default":"","property-type":"data-driven","expression":{"parameters":["zoom","feature"]}}},"layout_clip":{"clip-layer-types":{"type":"array","value":"enum","values":{"model":1,"symbol":1},"default":[],"expression":{},"property-type":"data-constant","experimental":true},"clip-layer-scope":{"type":"array","value":"string","default":[],"expression":{},"property-type":"data-constant","experimental":true}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"fill-elevation-reference":{"type":"enum","values":{"none":1,"hd-road-base":1,"hd-road-markup":1},"default":"none","experimental":true,"private":true,"expression":{},"property-type":"data-constant"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"fill-extrusion-edge-radius":{"type":"number","experimental":true,"default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"constant"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":1,"round":1,"square":1},"default":"butt","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":1,"round":1,"miter":1,"none":1},"default":"miter","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-z-offset":{"type":"number","experimental":true,"default":0,"expression":{"parameters":["zoom","feature","line-progress"]},"property-type":"data-driven"},"line-elevation-reference":{"type":"enum","values":{"none":1,"sea":1,"ground":1,"hd-road-markup":1},"default":"none","experimental":true,"expression":{},"property-type":"data-constant"},"line-cross-slope":{"type":"number","experimental":true,"expression":{},"property-type":"constant"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":1,"line":1,"line-center":1},"default":"point","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":1,"viewport-y":1,"source":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-elevation-reference":{"type":"enum","values":{"sea":1,"ground":1,"hd-road-markup":1},"default":"ground","experimental":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-size":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":0.1,"maximum":10,"experimental":true,"private":true,"expression":{},"property-type":"data-constant"},"icon-text-fit":{"type":"enum","values":{"none":1,"width":1,"height":1,"both":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":0.1,"maximum":10,"experimental":true,"private":true,"expression":{},"property-type":"data-constant"},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":1,"left":1,"center":1,"right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-transform":{"type":"enum","values":{"none":1,"uppercase":1,"lowercase":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster-particle":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_hillshade":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster-particle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_clip":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_model":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":1,"exponential":1,"interval":1,"categorical":1},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":1,"lab":1,"hcl":1},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"high-color":{"type":"color","property-type":"data-constant","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"space-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"horizon-blend":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"star-intensity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"snow":{"density":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"opacity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","property-type":"data-constant","default":0,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"centerThinning":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,90],"minimum":0,"maximum":360,"length":2,"value":"number","property-type":"data-constant","transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"rain":{"density":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"opacity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","property-type":"data-constant","default":0,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"centerThinning":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,80],"minimum":0,"maximum":360,"length":2,"value":"number","property-type":"data-constant","transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"camera":{"camera-projection":{"type":"enum","values":{"perspective":1,"orthographic":1},"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"default":"perspective","property-type":"data-constant"}},"colorTheme":{"data":{"type":"string","property-type":"data-constant","expression":{}}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1},"default":"mercator","required":true},"center":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-180,-90],"maximum":[180,90]},"parallels":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-90,-90],"maximum":[90,90]}},"terrain":{"source":{"type":"string","required":true},"exaggeration":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_raster-particle","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"fill-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-height-alignment":{"type":"enum","experimental":true,"values":{"terrain":1,"flat":1},"default":"flat","property-type":"data-constant"},"fill-extrusion-base-alignment":{"type":"enum","experimental":true,"values":{"terrain":1,"flat":1},"default":"terrain","property-type":"data-constant"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-ambient-occlusion-intensity":{"property-type":"data-constant","type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"property-type":"data-constant","type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-wall-radius":{"property-type":"data-constant","type":"number","experimental":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-radius":{"property-type":"data-constant","type":"number","experimental":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-attenuation":{"property-type":"data-constant","type":"number","experimental":true,"default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-flood-light-color":{"property-type":"data-constant","type":"color","experimental":true,"default":"#ffffff","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-intensity":{"property-type":"data-constant","type":"number","experimental":true,"default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-wall-radius":{"property-type":"data-driven","type":"number","experimental":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-radius":{"property-type":"data-driven","type":"number","experimental":true,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-attenuation":{"property-type":"data-constant","type":"number","experimental":true,"default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-vertical-scale":{"property-type":"data-constant","type":"number","experimental":true,"default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-rounded-roof":{"property-type":"data-constant","type":"boolean","default":true,"experimental":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"fill-extrusion-line-width":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-cast-shadows":{"type":"boolean","default":true,"property-type":"data-constant"}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-gradient":{"type":"color","expression":{"interpolated":true,"parameters":["line-progress"]},"property-type":"color-ramp"},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"property-type":"constant"},"line-trim-fade-range":{"type":"array","value":"number","experimental":true,"length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-trim-color":{"type":"color","experimental":true,"default":"transparent","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-border-width":{"type":"number","private":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-border-color":{"type":"color","private":true,"default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true,"property-type":"data-constant"}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"expression":{"interpolated":true,"parameters":["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-image-cross-fade":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"transition":true},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","transition":true,"overridable":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-color-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"icon-color-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"symbol-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-value"]},"property-type":"color-ramp"},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color-range":{"type":"array","length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-resampling":{"type":"enum","values":{"linear":1,"nearest":1},"default":"linear","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"raster-array-band":{"type":"string","required":false,"experimental":true,"property-type":"data-constant"},"raster-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"experimental":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_raster-particle":{"raster-particle-array-band":{"type":"string","required":false,"property-type":"data-constant"},"raster-particle-count":{"type":"number","default":512,"minimum":1,"property-type":"data-constant"},"raster-particle-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-particle-speed"]},"property-type":"color-ramp"},"raster-particle-max-speed":{"type":"number","default":1,"minimum":1,"property-type":"data-constant"},"raster-particle-speed-factor":{"type":"number","default":0.2,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-particle-fade-opacity-factor":{"type":"number","default":0.98,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-particle-reset-rate-factor":{"type":"number","default":0.8,"minimum":0,"maximum":1,"property-type":"data-constant"},"raster-particle-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-accent-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_background":{"background-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":[]},"property-type":"data-constant"},"background-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":1,"atmosphere":1},"default":"atmosphere","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100,"property-type":"data-constant"},"sky-gradient-center":{"type":"array","value":"number","default":[0,0],"length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"expression":{"interpolated":true,"parameters":["sky-radial-progress"]},"property-type":"color-ramp"},"sky-atmosphere-halo-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-atmosphere-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"model-rotation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-scale":{"type":"array","value":"number","length":3,"default":[1,1,1],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-translation":{"type":"array","value":"number","length":3,"default":[0,0,0],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-color":{"type":"color","default":"#ffffff","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":true},"model-color-mix-intensity":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-type":{"type":"enum","values":{"common-3d":1,"location-indicator":1},"default":"common-3d","property-type":"data-constant"},"model-cast-shadows":{"type":"boolean","default":true,"property-type":"data-constant"},"model-receive-shadows":{"type":"boolean","default":true,"property-type":"data-constant"},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant","transition":true},"model-emissive-strength":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state"]},"transition":true},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"model-front-cutoff":{"type":"array","private":true,"value":"number","property-type":"data-constant","expression":{"interpolated":true,"parameters":["zoom"]},"length":3,"default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1]}},"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"property-type":{"data-driven":{"type":"property-type"},"color-ramp":{"type":"property-type"},"data-constant":{"type":"property-type"},"constant":{"type":"property-type"}},"promoteId":{"*":{"type":"string"}}}');
      function Ga(t4) {
        return t4 instanceof Number || t4 instanceof String || t4 instanceof Boolean ? t4.valueOf() : t4;
      }
      function Xa(t4) {
        if (Array.isArray(t4)) return t4.map(Xa);
        if (t4 instanceof Object && !(t4 instanceof Number || t4 instanceof String || t4 instanceof Boolean)) {
          const e3 = {};
          for (const r3 in t4) e3[r3] = Xa(t4[r3]);
          return e3;
        }
        return Ga(t4);
      }
      function Ya(t4) {
        if (true === t4 || false === t4) return true;
        if (!Array.isArray(t4) || 0 === t4.length) return false;
        switch (t4[0]) {
          case "has":
            return t4.length >= 2 && "$id" !== t4[1] && "$type" !== t4[1];
          case "in":
            return t4.length >= 3 && ("string" != typeof t4[1] || Array.isArray(t4[2]));
          case "!in":
          case "!has":
          case "none":
            return false;
          case "==":
          case "!=":
          case ">":
          case ">=":
          case "<":
          case "<=":
            return 3 !== t4.length || Array.isArray(t4[1]) || Array.isArray(t4[2]);
          case "any":
          case "all":
            for (const e3 of t4.slice(1)) if (!Ya(e3) && "boolean" != typeof e3) return false;
            return true;
          default:
            return true;
        }
      }
      function Za(t4, e3 = "", r3 = null, n3 = "fill") {
        if (null == t4) return { filter: () => true, needGeometry: false, needFeature: false };
        Ya(t4) || (t4 = es(t4));
        const i3 = t4;
        let a4 = true;
        try {
          a4 = function(t5) {
            if (!Ka(t5)) return t5;
            let e4 = Xa(t5);
            return Ha(e4), e4 = Wa(e4), e4;
          }(i3);
        } catch (t5) {
          console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.
This is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md
and paste the contents of this message in the report.
Thank you!
Filter Expression:
${JSON.stringify(i3, null, 2)}
        `);
        }
        let s3 = null, o3 = null;
        if ("background" !== n3 && "sky" !== n3 && "slot" !== n3) {
          o3 = $a[`filter_${n3}`];
          const t5 = Zi2(a4, o3, e3, r3);
          if ("error" === t5.result) throw new Error(t5.value.map((t6) => `${t6.key}: ${t6.message}`).join(", "));
          s3 = (e4, r4, n4) => t5.value.evaluate(e4, r4, {}, n4);
        }
        let l3 = null, u4 = null;
        if (a4 !== i3) {
          const t5 = Zi2(i3, o3, e3, r3);
          if ("error" === t5.result) throw new Error(t5.value.map((t6) => `${t6.key}: ${t6.message}`).join(", "));
          l3 = (e4, r4, n4, i4, a5) => t5.value.evaluate(e4, r4, {}, n4, void 0, void 0, i4, a5), u4 = !Tn(t5.value.expression);
        }
        return { filter: s3, dynamicFilter: l3 || void 0, needGeometry: ts(a4), needFeature: !!u4 };
      }
      function Wa(t4) {
        if (!Array.isArray(t4)) return t4;
        const e3 = function(t5) {
          if (Ja.has(t5[0])) {
            for (let e4 = 1; e4 < t5.length; e4++) if (Ka(t5[e4])) return true;
          }
          return t5;
        }(t4);
        return true === e3 ? e3 : e3.map((t5) => Wa(t5));
      }
      function Ha(t4) {
        let e3 = false;
        const r3 = [];
        if ("case" === t4[0]) {
          for (let n3 = 1; n3 < t4.length - 1; n3 += 2) e3 = e3 || Ka(t4[n3]), r3.push(t4[n3 + 1]);
          r3.push(t4[t4.length - 1]);
        } else if ("match" === t4[0]) {
          e3 = e3 || Ka(t4[1]);
          for (let e4 = 2; e4 < t4.length - 1; e4 += 2) r3.push(t4[e4 + 1]);
          r3.push(t4[t4.length - 1]);
        } else if ("step" === t4[0]) {
          e3 = e3 || Ka(t4[1]);
          for (let e4 = 1; e4 < t4.length - 1; e4 += 2) r3.push(t4[e4 + 1]);
        }
        e3 && (t4.length = 0, t4.push("any", ...r3));
        for (let e4 = 1; e4 < t4.length; e4++) Ha(t4[e4]);
      }
      function Ka(t4) {
        if (!Array.isArray(t4)) return false;
        if ("pitch" === (e3 = t4[0]) || "distance-from-center" === e3) return true;
        var e3;
        for (let e4 = 1; e4 < t4.length; e4++) if (Ka(t4[e4])) return true;
        return false;
      }
      const Ja = /* @__PURE__ */ new Set(["in", "==", "!=", ">", ">=", "<", "<=", "to-boolean"]);
      function Qa(t4, e3) {
        return t4 < e3 ? -1 : t4 > e3 ? 1 : 0;
      }
      function ts(t4) {
        if (!Array.isArray(t4)) return false;
        if ("within" === t4[0] || "distance" === t4[0]) return true;
        for (let e3 = 1; e3 < t4.length; e3++) if (ts(t4[e3])) return true;
        return false;
      }
      function es(t4) {
        if (!t4) return true;
        const e3 = t4[0];
        return t4.length <= 1 ? "any" !== e3 : "==" === e3 ? rs(t4[1], t4[2], "==") : "!=" === e3 ? as(rs(t4[1], t4[2], "==")) : "<" === e3 || ">" === e3 || "<=" === e3 || ">=" === e3 ? rs(t4[1], t4[2], e3) : "any" === e3 ? (r3 = t4.slice(1), ["any"].concat(r3.map(es))) : "all" === e3 ? ["all"].concat(t4.slice(1).map(es)) : "none" === e3 ? ["all"].concat(t4.slice(1).map(es).map(as)) : "in" === e3 ? ns(t4[1], t4.slice(2)) : "!in" === e3 ? as(ns(t4[1], t4.slice(2))) : "has" === e3 ? is(t4[1]) : "!has" !== e3 || as(is(t4[1]));
        var r3;
      }
      function rs(t4, e3, r3) {
        switch (t4) {
          case "$type":
            return [`filter-type-${r3}`, e3];
          case "$id":
            return [`filter-id-${r3}`, e3];
          default:
            return [`filter-${r3}`, t4, e3];
        }
      }
      function ns(t4, e3) {
        if (0 === e3.length) return false;
        switch (t4) {
          case "$type":
            return ["filter-type-in", ["literal", e3]];
          case "$id":
            return ["filter-id-in", ["literal", e3]];
          default:
            return e3.length > 200 && !e3.some((t5) => typeof t5 != typeof e3[0]) ? ["filter-in-large", t4, ["literal", e3.sort(Qa)]] : ["filter-in-small", t4, ["literal", e3]];
        }
      }
      function is(t4) {
        switch (t4) {
          case "$type":
            return true;
          case "$id":
            return ["filter-has-id"];
          default:
            return ["filter-has", t4];
        }
      }
      function as(t4) {
        return ["!", t4];
      }
      const ss = "";
      function os(t4, e3) {
        return e3 ? `${t4}${ss}${e3}` : t4;
      }
      const ls = "-transition", us = /* @__PURE__ */ new Set(["fill", "line", "background", "hillshade", "raster"]);
      class cs extends _e {
        constructor(t4, e3, r3, n3, i3) {
          if (super(), this.id = t4.id, this.fqid = os(this.id, r3), this.type = t4.type, this.scope = r3, this.lut = n3, this.options = i3, this._featureFilter = { filter: () => true, needGeometry: false, needFeature: false }, this._filterCompiled = false, this.configDependencies = /* @__PURE__ */ new Set(), "custom" !== t4.type) {
            if (this.metadata = t4.metadata, this.minzoom = t4.minzoom, this.maxzoom = t4.maxzoom, t4.type && "background" !== t4.type && "sky" !== t4.type && "slot" !== t4.type) {
              this.source = t4.source, this.sourceLayer = t4["source-layer"], this.filter = t4.filter;
              const e4 = Zi2(this.filter, $a[`filter_${t4.type}`]);
              "error" !== e4.result && (this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...e4.value.configDependencies]));
            }
            if (t4.slot && (this.slot = t4.slot), e3.layout && (this._unevaluatedLayout = new La(e3.layout, this.scope, i3), this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._unevaluatedLayout.configDependencies])), e3.paint) {
              this._transitionablePaint = new Ca(e3.paint, this.scope, i3);
              for (const e4 in t4.paint) this.setPaintProperty(e4, t4.paint[e4]);
              for (const e4 in t4.layout) this.setLayoutProperty(e4, t4.layout[e4]);
              this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._transitionablePaint.configDependencies]), this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Oa(e3.paint);
            }
          }
        }
        onAdd(t4) {
        }
        onRemove(t4) {
        }
        isDraped(t4) {
          return !this.is3D() && us.has(this.type);
        }
        getLayoutProperty(t4) {
          return "visibility" === t4 ? this.visibility : this._unevaluatedLayout.getValue(t4);
        }
        setLayoutProperty(t4, e3) {
          if ("custom" === this.type && "visibility" === t4) return void (this.visibility = e3);
          const r3 = this._unevaluatedLayout;
          r3._properties.properties[t4] && (r3.setValue(t4, e3), this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...r3.configDependencies]), "visibility" === t4 && this.possiblyEvaluateVisibility());
        }
        possiblyEvaluateVisibility() {
          this._unevaluatedLayout._values.visibility && (this.visibility = this._unevaluatedLayout._values.visibility.possiblyEvaluate({ zoom: 0 }));
        }
        getPaintProperty(t4) {
          return lt2(t4, ls) ? this._transitionablePaint.getTransition(t4.slice(0, -11)) : this._transitionablePaint.getValue(t4);
        }
        setPaintProperty(t4, e3) {
          const r3 = this._transitionablePaint, n3 = r3._properties.properties;
          if (lt2(t4, ls)) {
            const i4 = t4.slice(0, -11);
            return n3[i4] && r3.setTransition(i4, e3 || void 0), false;
          }
          if (!n3[t4]) return false;
          const i3 = r3._values[t4], a4 = i3.value.isDataDriven(), s3 = i3.value;
          r3.setValue(t4, e3), this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...r3.configDependencies]), this._handleSpecialPaintPropertyUpdate(t4);
          const o3 = r3._values[t4].value, l3 = o3.isDataDriven(), u4 = lt2(t4, "pattern") || "line-dasharray" === t4;
          return l3 || a4 || u4 || this._handleOverridablePaintPropertyUpdate(t4, s3, o3);
        }
        _handleSpecialPaintPropertyUpdate(t4) {
        }
        getProgramIds() {
          return null;
        }
        getDefaultProgramParams(t4, e3, r3) {
          return null;
        }
        _handleOverridablePaintPropertyUpdate(t4, e3, r3) {
          return false;
        }
        isHidden(t4) {
          return !!(this.minzoom && t4 < this.minzoom) || !!(this.maxzoom && t4 >= this.maxzoom) || "none" === this.visibility;
        }
        updateTransitions(t4) {
          this._transitioningPaint = this._transitionablePaint.transitioned(t4, this._transitioningPaint);
        }
        hasTransition() {
          return this._transitioningPaint.hasTransition();
        }
        recalculate(t4, e3) {
          this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t4, void 0, e3)), this.paint = this._transitioningPaint.possiblyEvaluate(t4, void 0, e3);
        }
        serialize() {
          return ct2({ id: this.id, type: this.type, slot: this.slot, source: this.source, "source-layer": this.sourceLayer, metadata: this.metadata, minzoom: this.minzoom, maxzoom: this.maxzoom, filter: this.filter, layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(), paint: this._transitionablePaint && this._transitionablePaint.serialize() }, (t4, e3) => !(void 0 === t4 || "layout" === e3 && !Object.keys(t4).length || "paint" === e3 && !Object.keys(t4).length));
        }
        is3D() {
          return false;
        }
        isSky() {
          return false;
        }
        isTileClipped() {
          return false;
        }
        hasOffscreenPass() {
          return false;
        }
        hasShadowPass() {
          return false;
        }
        canCastShadows() {
          return false;
        }
        hasLightBeamPass() {
          return false;
        }
        cutoffRange() {
          return 0;
        }
        tileCoverLift() {
          return 0;
        }
        resize() {
        }
        isStateDependent() {
          for (const t4 in this.paint._values) {
            const e3 = this.paint.get(t4);
            if (e3 instanceof Fa && Ci(e3.property.specification) && ("source" === e3.value.kind || "composite" === e3.value.kind) && e3.value.isStateDependent) return true;
          }
          return false;
        }
        compileFilter(t4) {
          this._filterCompiled || (this._featureFilter = Za(this.filter, this.scope, t4), this._filterCompiled = true);
        }
        invalidateCompiledFilter() {
          this._filterCompiled = false;
        }
        dynamicFilter() {
          return this._featureFilter.dynamicFilter;
        }
        dynamicFilterNeedsFeature() {
          return this._featureFilter.needFeature;
        }
        getLayerRenderingStats() {
          return this._stats;
        }
        resetLayerRenderingStats(t4) {
          this._stats && ("shadow" === t4.renderPass ? this._stats.numRenderedVerticesInShadowPass = 0 : this._stats.numRenderedVerticesInTransparentPass = 0);
        }
        queryRadius(t4) {
        }
        queryIntersectsFeature(t4, e3, r3, n3, i3, a4, s3, o3, l3) {
        }
        queryIntersectsMatchingFeature(t4, e3, r3, n3) {
        }
      }
      const hs = { Int8: Int8Array, Uint8: Uint8Array, Int16: Int16Array, Uint16: Uint16Array, Int32: Int32Array, Uint32: Uint32Array, Float32: Float32Array };
      class ps {
        constructor(t4, e3) {
          this._structArray = t4, this._pos1 = e3 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
        }
      }
      class fs {
        constructor() {
          this.isTransferred = false, this.capacity = -1, this.resize(0);
        }
        static serialize(t4, e3) {
          return t4._trim(), e3 && (t4.isTransferred = true, e3.add(t4.arrayBuffer)), { length: t4.length, arrayBuffer: t4.arrayBuffer };
        }
        static deserialize(t4) {
          const e3 = Object.create(this.prototype);
          return e3.arrayBuffer = t4.arrayBuffer, e3.length = t4.length, e3.capacity = t4.arrayBuffer.byteLength / e3.bytesPerElement, e3._refreshViews(), e3;
        }
        _trim() {
          this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
        }
        clear() {
          this.length = 0;
        }
        resize(t4) {
          this.reserve(t4), this.length = t4;
        }
        reserve(t4) {
          if (t4 > this.capacity) {
            this.capacity = Math.max(t4, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
            const e3 = this.uint8;
            this._refreshViews(), e3 && this.uint8.set(e3);
          }
        }
        _refreshViews() {
          throw new Error("StructArray#_refreshViews() must be implemented by each concrete StructArray layout");
        }
        emplace(...t4) {
          throw new Error("StructArray#emplace() must be implemented by each concrete StructArray layout");
        }
        emplaceBack(...t4) {
          throw new Error("StructArray#emplaceBack() must be implemented by each concrete StructArray layout");
        }
        destroy() {
          this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
        }
      }
      function ds(t4, e3 = 1) {
        let r3 = 0, n3 = 0;
        return { members: t4.map((t5) => {
          const i3 = hs[t5.type].BYTES_PER_ELEMENT, a4 = r3 = ms(r3, Math.max(e3, i3)), s3 = t5.components || 1;
          return n3 = Math.max(n3, i3), r3 += i3 * s3, { name: t5.name, type: t5.type, components: s3, offset: a4 };
        }), size: ms(r3, Math.max(n3, e3)), alignment: e3 };
      }
      function ms(t4, e3) {
        return Math.ceil(t4 / e3) * e3;
      }
      class ys extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3) {
          const r3 = this.length;
          return this.resize(r3 + 1), this.emplace(r3, t4, e3);
        }
        emplace(t4, e3, r3) {
          const n3 = 2 * t4;
          return this.int16[n3 + 0] = e3, this.int16[n3 + 1] = r3, t4;
        }
      }
      ys.prototype.bytesPerElement = 4, aa(ys, "StructArrayLayout2i4");
      class gs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3) {
          const n3 = this.length;
          return this.resize(n3 + 1), this.emplace(n3, t4, e3, r3);
        }
        emplace(t4, e3, r3, n3) {
          const i3 = 3 * t4;
          return this.int16[i3 + 0] = e3, this.int16[i3 + 1] = r3, this.int16[i3 + 2] = n3, t4;
        }
      }
      gs.prototype.bytesPerElement = 6, aa(gs, "StructArrayLayout3i6");
      class xs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3) {
          const i3 = this.length;
          return this.resize(i3 + 1), this.emplace(i3, t4, e3, r3, n3);
        }
        emplace(t4, e3, r3, n3, i3) {
          const a4 = 4 * t4;
          return this.int16[a4 + 0] = e3, this.int16[a4 + 1] = r3, this.int16[a4 + 2] = n3, this.int16[a4 + 3] = i3, t4;
        }
      }
      xs.prototype.bytesPerElement = 8, aa(xs, "StructArrayLayout4i8");
      class vs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3) {
          const a4 = this.length;
          return this.resize(a4 + 1), this.emplace(a4, t4, e3, r3, n3, i3);
        }
        emplace(t4, e3, r3, n3, i3, a4) {
          const s3 = 5 * t4;
          return this.int16[s3 + 0] = e3, this.int16[s3 + 1] = r3, this.int16[s3 + 2] = n3, this.int16[s3 + 3] = i3, this.int16[s3 + 4] = a4, t4;
        }
      }
      vs.prototype.bytesPerElement = 10, aa(vs, "StructArrayLayout5i10");
      class bs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = this.length;
          return this.resize(o3 + 1), this.emplace(o3, t4, e3, r3, n3, i3, a4, s3);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3, o3) {
          const l3 = 6 * t4, u4 = 12 * t4, c3 = 3 * t4;
          return this.int16[l3 + 0] = e3, this.int16[l3 + 1] = r3, this.uint8[u4 + 4] = n3, this.uint8[u4 + 5] = i3, this.uint8[u4 + 6] = a4, this.uint8[u4 + 7] = s3, this.float32[c3 + 2] = o3, t4;
        }
      }
      bs.prototype.bytesPerElement = 12, aa(bs, "StructArrayLayout2i4ub1f12");
      class ws extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3) {
          const i3 = this.length;
          return this.resize(i3 + 1), this.emplace(i3, t4, e3, r3, n3);
        }
        emplace(t4, e3, r3, n3, i3) {
          const a4 = 4 * t4;
          return this.float32[a4 + 0] = e3, this.float32[a4 + 1] = r3, this.float32[a4 + 2] = n3, this.float32[a4 + 3] = i3, t4;
        }
      }
      ws.prototype.bytesPerElement = 16, aa(ws, "StructArrayLayout4f16");
      class _s extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3) {
          const n3 = this.length;
          return this.resize(n3 + 1), this.emplace(n3, t4, e3, r3);
        }
        emplace(t4, e3, r3, n3) {
          const i3 = 3 * t4;
          return this.float32[i3 + 0] = e3, this.float32[i3 + 1] = r3, this.float32[i3 + 2] = n3, t4;
        }
      }
      _s.prototype.bytesPerElement = 12, aa(_s, "StructArrayLayout3f12");
      class Ms extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3) {
          const a4 = this.length;
          return this.resize(a4 + 1), this.emplace(a4, t4, e3, r3, n3, i3);
        }
        emplace(t4, e3, r3, n3, i3, a4) {
          const s3 = 6 * t4, o3 = 3 * t4;
          return this.uint16[s3 + 0] = e3, this.uint16[s3 + 1] = r3, this.uint16[s3 + 2] = n3, this.uint16[s3 + 3] = i3, this.float32[o3 + 2] = a4, t4;
        }
      }
      Ms.prototype.bytesPerElement = 12, aa(Ms, "StructArrayLayout4ui1f12");
      class As extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3) {
          const i3 = this.length;
          return this.resize(i3 + 1), this.emplace(i3, t4, e3, r3, n3);
        }
        emplace(t4, e3, r3, n3, i3) {
          const a4 = 4 * t4;
          return this.uint16[a4 + 0] = e3, this.uint16[a4 + 1] = r3, this.uint16[a4 + 2] = n3, this.uint16[a4 + 3] = i3, t4;
        }
      }
      As.prototype.bytesPerElement = 8, aa(As, "StructArrayLayout4ui8");
      class Ss extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4) {
          const s3 = this.length;
          return this.resize(s3 + 1), this.emplace(s3, t4, e3, r3, n3, i3, a4);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = 6 * t4;
          return this.int16[o3 + 0] = e3, this.int16[o3 + 1] = r3, this.int16[o3 + 2] = n3, this.int16[o3 + 3] = i3, this.int16[o3 + 4] = a4, this.int16[o3 + 5] = s3, t4;
        }
      }
      Ss.prototype.bytesPerElement = 12, aa(Ss, "StructArrayLayout6i12");
      class Is extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3) {
          const p3 = this.length;
          return this.resize(p3 + 1), this.emplace(p3, t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3) {
          const f3 = 12 * t4;
          return this.int16[f3 + 0] = e3, this.int16[f3 + 1] = r3, this.int16[f3 + 2] = n3, this.int16[f3 + 3] = i3, this.uint16[f3 + 4] = a4, this.uint16[f3 + 5] = s3, this.uint16[f3 + 6] = o3, this.uint16[f3 + 7] = l3, this.int16[f3 + 8] = u4, this.int16[f3 + 9] = c3, this.int16[f3 + 10] = h3, this.int16[f3 + 11] = p3, t4;
        }
      }
      Is.prototype.bytesPerElement = 24, aa(Is, "StructArrayLayout4i4ui4i24");
      class zs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4) {
          const s3 = this.length;
          return this.resize(s3 + 1), this.emplace(s3, t4, e3, r3, n3, i3, a4);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = 10 * t4, l3 = 5 * t4;
          return this.int16[o3 + 0] = e3, this.int16[o3 + 1] = r3, this.int16[o3 + 2] = n3, this.float32[l3 + 2] = i3, this.float32[l3 + 3] = a4, this.float32[l3 + 4] = s3, t4;
        }
      }
      zs.prototype.bytesPerElement = 20, aa(zs, "StructArrayLayout3i3f20");
      class Ps extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
        }
        emplaceBack(t4) {
          const e3 = this.length;
          return this.resize(e3 + 1), this.emplace(e3, t4);
        }
        emplace(t4, e3) {
          return this.uint32[1 * t4 + 0] = e3, t4;
        }
      }
      Ps.prototype.bytesPerElement = 4, aa(Ps, "StructArrayLayout1ul4");
      class ks extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3) {
          const r3 = this.length;
          return this.resize(r3 + 1), this.emplace(r3, t4, e3);
        }
        emplace(t4, e3, r3) {
          const n3 = 2 * t4;
          return this.uint16[n3 + 0] = e3, this.uint16[n3 + 1] = r3, t4;
        }
      }
      ks.prototype.bytesPerElement = 4, aa(ks, "StructArrayLayout2ui4");
      class Ts extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3) {
          const f3 = this.length;
          return this.resize(f3 + 1), this.emplace(f3, t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3) {
          const d3 = 20 * t4, m2 = 10 * t4;
          return this.int16[d3 + 0] = e3, this.int16[d3 + 1] = r3, this.int16[d3 + 2] = n3, this.int16[d3 + 3] = i3, this.int16[d3 + 4] = a4, this.float32[m2 + 3] = s3, this.float32[m2 + 4] = o3, this.float32[m2 + 5] = l3, this.float32[m2 + 6] = u4, this.int16[d3 + 14] = c3, this.uint32[m2 + 8] = h3, this.uint16[d3 + 18] = p3, this.uint16[d3 + 19] = f3, t4;
        }
      }
      Ts.prototype.bytesPerElement = 40, aa(Ts, "StructArrayLayout5i4f1i1ul2ui40");
      class Es extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = this.length;
          return this.resize(o3 + 1), this.emplace(o3, t4, e3, r3, n3, i3, a4, s3);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3, o3) {
          const l3 = 8 * t4;
          return this.int16[l3 + 0] = e3, this.int16[l3 + 1] = r3, this.int16[l3 + 2] = n3, this.int16[l3 + 4] = i3, this.int16[l3 + 5] = a4, this.int16[l3 + 6] = s3, this.int16[l3 + 7] = o3, t4;
        }
      }
      Es.prototype.bytesPerElement = 16, aa(Es, "StructArrayLayout3i2i2i16");
      class Bs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3) {
          const a4 = this.length;
          return this.resize(a4 + 1), this.emplace(a4, t4, e3, r3, n3, i3);
        }
        emplace(t4, e3, r3, n3, i3, a4) {
          const s3 = 4 * t4, o3 = 8 * t4;
          return this.float32[s3 + 0] = e3, this.float32[s3 + 1] = r3, this.float32[s3 + 2] = n3, this.int16[o3 + 6] = i3, this.int16[o3 + 7] = a4, t4;
        }
      }
      Bs.prototype.bytesPerElement = 16, aa(Bs, "StructArrayLayout2f1f2i16");
      class Vs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4) {
          const s3 = this.length;
          return this.resize(s3 + 1), this.emplace(s3, t4, e3, r3, n3, i3, a4);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = 20 * t4, l3 = 5 * t4;
          return this.uint8[o3 + 0] = e3, this.uint8[o3 + 1] = r3, this.float32[l3 + 1] = n3, this.float32[l3 + 2] = i3, this.float32[l3 + 3] = a4, this.float32[l3 + 4] = s3, t4;
        }
      }
      Vs.prototype.bytesPerElement = 20, aa(Vs, "StructArrayLayout2ub4f20");
      class Cs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3) {
          const n3 = this.length;
          return this.resize(n3 + 1), this.emplace(n3, t4, e3, r3);
        }
        emplace(t4, e3, r3, n3) {
          const i3 = 3 * t4;
          return this.uint16[i3 + 0] = e3, this.uint16[i3 + 1] = r3, this.uint16[i3 + 2] = n3, t4;
        }
      }
      Cs.prototype.bytesPerElement = 6, aa(Cs, "StructArrayLayout3ui6");
      class Rs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3, d3, m2, y2, g4, x2, v2, b2) {
          const w2 = this.length;
          return this.resize(w2 + 1), this.emplace(w2, t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3, d3, m2, y2, g4, x2, v2, b2);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3, d3, m2, y2, g4, x2, v2, b2, w2) {
          const _2 = 30 * t4, M2 = 15 * t4, A3 = 60 * t4;
          return this.int16[_2 + 0] = e3, this.int16[_2 + 1] = r3, this.int16[_2 + 2] = n3, this.float32[M2 + 2] = i3, this.float32[M2 + 3] = a4, this.uint16[_2 + 8] = s3, this.uint16[_2 + 9] = o3, this.uint32[M2 + 5] = l3, this.uint32[M2 + 6] = u4, this.uint32[M2 + 7] = c3, this.uint16[_2 + 16] = h3, this.uint16[_2 + 17] = p3, this.uint16[_2 + 18] = f3, this.float32[M2 + 10] = d3, this.float32[M2 + 11] = m2, this.uint8[A3 + 48] = y2, this.uint8[A3 + 49] = g4, this.uint8[A3 + 50] = x2, this.uint32[M2 + 13] = v2, this.int16[_2 + 28] = b2, this.uint8[A3 + 58] = w2, t4;
        }
      }
      Rs.prototype.bytesPerElement = 60, aa(Rs, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
      class Ds extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3, d3, m2, y2, g4, x2, v2, b2, w2, _2, M2, A3, S2, I3, z3, P2, k2, T3, E3) {
          const B4 = this.length;
          return this.resize(B4 + 1), this.emplace(B4, t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3, d3, m2, y2, g4, x2, v2, b2, w2, _2, M2, A3, S2, I3, z3, P2, k2, T3, E3);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3, d3, m2, y2, g4, x2, v2, b2, w2, _2, M2, A3, S2, I3, z3, P2, k2, T3, E3, B4) {
          const V3 = 20 * t4, C3 = 40 * t4, R3 = 80 * t4;
          return this.float32[V3 + 0] = e3, this.float32[V3 + 1] = r3, this.int16[C3 + 4] = n3, this.int16[C3 + 5] = i3, this.int16[C3 + 6] = a4, this.int16[C3 + 7] = s3, this.int16[C3 + 8] = o3, this.int16[C3 + 9] = l3, this.int16[C3 + 10] = u4, this.int16[C3 + 11] = c3, this.int16[C3 + 12] = h3, this.uint16[C3 + 13] = p3, this.uint16[C3 + 14] = f3, this.uint16[C3 + 15] = d3, this.uint16[C3 + 16] = m2, this.uint16[C3 + 17] = y2, this.uint16[C3 + 18] = g4, this.uint16[C3 + 19] = x2, this.uint16[C3 + 20] = v2, this.uint16[C3 + 21] = b2, this.uint16[C3 + 22] = w2, this.uint16[C3 + 23] = _2, this.uint16[C3 + 24] = M2, this.uint16[C3 + 25] = A3, this.uint16[C3 + 26] = S2, this.uint16[C3 + 27] = I3, this.uint32[V3 + 14] = z3, this.float32[V3 + 15] = P2, this.float32[V3 + 16] = k2, this.float32[V3 + 17] = T3, this.float32[V3 + 18] = E3, this.uint8[R3 + 76] = B4, t4;
        }
      }
      Ds.prototype.bytesPerElement = 80, aa(Ds, "StructArrayLayout2f9i15ui1ul4f1ub80");
      class Ls extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4) {
          const e3 = this.length;
          return this.resize(e3 + 1), this.emplace(e3, t4);
        }
        emplace(t4, e3) {
          return this.float32[1 * t4 + 0] = e3, t4;
        }
      }
      Ls.prototype.bytesPerElement = 4, aa(Ls, "StructArrayLayout1f4");
      class Fs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3) {
          const a4 = this.length;
          return this.resize(a4 + 1), this.emplace(a4, t4, e3, r3, n3, i3);
        }
        emplace(t4, e3, r3, n3, i3, a4) {
          const s3 = 5 * t4;
          return this.float32[s3 + 0] = e3, this.float32[s3 + 1] = r3, this.float32[s3 + 2] = n3, this.float32[s3 + 3] = i3, this.float32[s3 + 4] = a4, t4;
        }
      }
      Fs.prototype.bytesPerElement = 20, aa(Fs, "StructArrayLayout5f20");
      class Os extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = this.length;
          return this.resize(o3 + 1), this.emplace(o3, t4, e3, r3, n3, i3, a4, s3);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3, o3) {
          const l3 = 7 * t4;
          return this.float32[l3 + 0] = e3, this.float32[l3 + 1] = r3, this.float32[l3 + 2] = n3, this.float32[l3 + 3] = i3, this.float32[l3 + 4] = a4, this.float32[l3 + 5] = s3, this.float32[l3 + 6] = o3, t4;
        }
      }
      Os.prototype.bytesPerElement = 28, aa(Os, "StructArrayLayout7f28");
      class Us extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3) {
          const h3 = this.length;
          return this.resize(h3 + 1), this.emplace(h3, t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3) {
          const p3 = 11 * t4;
          return this.float32[p3 + 0] = e3, this.float32[p3 + 1] = r3, this.float32[p3 + 2] = n3, this.float32[p3 + 3] = i3, this.float32[p3 + 4] = a4, this.float32[p3 + 5] = s3, this.float32[p3 + 6] = o3, this.float32[p3 + 7] = l3, this.float32[p3 + 8] = u4, this.float32[p3 + 9] = c3, this.float32[p3 + 10] = h3, t4;
        }
      }
      Us.prototype.bytesPerElement = 44, aa(Us, "StructArrayLayout11f44");
      class js extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4, s3, o3, l3) {
          const u4 = this.length;
          return this.resize(u4 + 1), this.emplace(u4, t4, e3, r3, n3, i3, a4, s3, o3, l3);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4) {
          const c3 = 9 * t4;
          return this.float32[c3 + 0] = e3, this.float32[c3 + 1] = r3, this.float32[c3 + 2] = n3, this.float32[c3 + 3] = i3, this.float32[c3 + 4] = a4, this.float32[c3 + 5] = s3, this.float32[c3 + 6] = o3, this.float32[c3 + 7] = l3, this.float32[c3 + 8] = u4, t4;
        }
      }
      js.prototype.bytesPerElement = 36, aa(js, "StructArrayLayout9f36");
      class Ns extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3) {
          const i3 = this.length;
          return this.resize(i3 + 1), this.emplace(i3, t4, e3, r3, n3);
        }
        emplace(t4, e3, r3, n3, i3) {
          const a4 = 6 * t4;
          return this.uint32[3 * t4 + 0] = e3, this.uint16[a4 + 2] = r3, this.uint16[a4 + 3] = n3, this.uint16[a4 + 4] = i3, t4;
        }
      }
      Ns.prototype.bytesPerElement = 12, aa(Ns, "StructArrayLayout1ul3ui12");
      class qs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(t4) {
          const e3 = this.length;
          return this.resize(e3 + 1), this.emplace(e3, t4);
        }
        emplace(t4, e3) {
          return this.uint16[1 * t4 + 0] = e3, t4;
        }
      }
      qs.prototype.bytesPerElement = 2, aa(qs, "StructArrayLayout1ui2");
      class $s extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3) {
          const r3 = this.length;
          return this.resize(r3 + 1), this.emplace(r3, t4, e3);
        }
        emplace(t4, e3, r3) {
          const n3 = 2 * t4;
          return this.float32[n3 + 0] = e3, this.float32[n3 + 1] = r3, t4;
        }
      }
      $s.prototype.bytesPerElement = 8, aa($s, "StructArrayLayout2f8");
      class Gs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3, d3, m2) {
          const y2 = this.length;
          return this.resize(y2 + 1), this.emplace(y2, t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3, d3, m2);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3, d3, m2, y2) {
          const g4 = 16 * t4;
          return this.float32[g4 + 0] = e3, this.float32[g4 + 1] = r3, this.float32[g4 + 2] = n3, this.float32[g4 + 3] = i3, this.float32[g4 + 4] = a4, this.float32[g4 + 5] = s3, this.float32[g4 + 6] = o3, this.float32[g4 + 7] = l3, this.float32[g4 + 8] = u4, this.float32[g4 + 9] = c3, this.float32[g4 + 10] = h3, this.float32[g4 + 11] = p3, this.float32[g4 + 12] = f3, this.float32[g4 + 13] = d3, this.float32[g4 + 14] = m2, this.float32[g4 + 15] = y2, t4;
        }
      }
      Gs.prototype.bytesPerElement = 64, aa(Gs, "StructArrayLayout16f64");
      class Xs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = this.length;
          return this.resize(o3 + 1), this.emplace(o3, t4, e3, r3, n3, i3, a4, s3);
        }
        emplace(t4, e3, r3, n3, i3, a4, s3, o3) {
          const l3 = 10 * t4, u4 = 5 * t4;
          return this.uint16[l3 + 0] = e3, this.uint16[l3 + 1] = r3, this.uint16[l3 + 2] = n3, this.uint16[l3 + 3] = i3, this.float32[u4 + 2] = a4, this.float32[u4 + 3] = s3, this.float32[u4 + 4] = o3, t4;
        }
      }
      Xs.prototype.bytesPerElement = 20, aa(Xs, "StructArrayLayout4ui3f20");
      class Ys extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(t4) {
          const e3 = this.length;
          return this.resize(e3 + 1), this.emplace(e3, t4);
        }
        emplace(t4, e3) {
          return this.int16[1 * t4 + 0] = e3, t4;
        }
      }
      Ys.prototype.bytesPerElement = 2, aa(Ys, "StructArrayLayout1i2");
      class Zs extends fs {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer);
        }
        emplaceBack(t4) {
          const e3 = this.length;
          return this.resize(e3 + 1), this.emplace(e3, t4);
        }
        emplace(t4, e3) {
          return this.uint8[1 * t4 + 0] = e3, t4;
        }
      }
      Zs.prototype.bytesPerElement = 1, aa(Zs, "StructArrayLayout1ub1");
      class Ws extends ps {
        get projectedAnchorX() {
          return this._structArray.int16[this._pos2 + 0];
        }
        get projectedAnchorY() {
          return this._structArray.int16[this._pos2 + 1];
        }
        get projectedAnchorZ() {
          return this._structArray.int16[this._pos2 + 2];
        }
        get tileAnchorX() {
          return this._structArray.int16[this._pos2 + 3];
        }
        get tileAnchorY() {
          return this._structArray.int16[this._pos2 + 4];
        }
        get x1() {
          return this._structArray.float32[this._pos4 + 3];
        }
        get y1() {
          return this._structArray.float32[this._pos4 + 4];
        }
        get x2() {
          return this._structArray.float32[this._pos4 + 5];
        }
        get y2() {
          return this._structArray.float32[this._pos4 + 6];
        }
        get padding() {
          return this._structArray.int16[this._pos2 + 14];
        }
        get featureIndex() {
          return this._structArray.uint32[this._pos4 + 8];
        }
        get sourceLayerIndex() {
          return this._structArray.uint16[this._pos2 + 18];
        }
        get bucketIndex() {
          return this._structArray.uint16[this._pos2 + 19];
        }
      }
      Ws.prototype.size = 40;
      class Hs extends Ts {
        get(t4) {
          return new Ws(this, t4);
        }
      }
      aa(Hs, "CollisionBoxArray");
      class Ks extends ps {
        get projectedAnchorX() {
          return this._structArray.int16[this._pos2 + 0];
        }
        get projectedAnchorY() {
          return this._structArray.int16[this._pos2 + 1];
        }
        get projectedAnchorZ() {
          return this._structArray.int16[this._pos2 + 2];
        }
        get tileAnchorX() {
          return this._structArray.float32[this._pos4 + 2];
        }
        get tileAnchorY() {
          return this._structArray.float32[this._pos4 + 3];
        }
        get glyphStartIndex() {
          return this._structArray.uint16[this._pos2 + 8];
        }
        get numGlyphs() {
          return this._structArray.uint16[this._pos2 + 9];
        }
        get vertexStartIndex() {
          return this._structArray.uint32[this._pos4 + 5];
        }
        get lineStartIndex() {
          return this._structArray.uint32[this._pos4 + 6];
        }
        get lineLength() {
          return this._structArray.uint32[this._pos4 + 7];
        }
        get segment() {
          return this._structArray.uint16[this._pos2 + 16];
        }
        get lowerSize() {
          return this._structArray.uint16[this._pos2 + 17];
        }
        get upperSize() {
          return this._structArray.uint16[this._pos2 + 18];
        }
        get lineOffsetX() {
          return this._structArray.float32[this._pos4 + 10];
        }
        get lineOffsetY() {
          return this._structArray.float32[this._pos4 + 11];
        }
        get writingMode() {
          return this._structArray.uint8[this._pos1 + 48];
        }
        get placedOrientation() {
          return this._structArray.uint8[this._pos1 + 49];
        }
        set placedOrientation(t4) {
          this._structArray.uint8[this._pos1 + 49] = t4;
        }
        get hidden() {
          return this._structArray.uint8[this._pos1 + 50];
        }
        set hidden(t4) {
          this._structArray.uint8[this._pos1 + 50] = t4;
        }
        get crossTileID() {
          return this._structArray.uint32[this._pos4 + 13];
        }
        set crossTileID(t4) {
          this._structArray.uint32[this._pos4 + 13] = t4;
        }
        get associatedIconIndex() {
          return this._structArray.int16[this._pos2 + 28];
        }
        get flipState() {
          return this._structArray.uint8[this._pos1 + 58];
        }
        set flipState(t4) {
          this._structArray.uint8[this._pos1 + 58] = t4;
        }
      }
      Ks.prototype.size = 60;
      class Js extends Rs {
        get(t4) {
          return new Ks(this, t4);
        }
      }
      aa(Js, "PlacedSymbolArray");
      class Qs extends ps {
        get tileAnchorX() {
          return this._structArray.float32[this._pos4 + 0];
        }
        get tileAnchorY() {
          return this._structArray.float32[this._pos4 + 1];
        }
        get projectedAnchorX() {
          return this._structArray.int16[this._pos2 + 4];
        }
        get projectedAnchorY() {
          return this._structArray.int16[this._pos2 + 5];
        }
        get projectedAnchorZ() {
          return this._structArray.int16[this._pos2 + 6];
        }
        get rightJustifiedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 7];
        }
        get centerJustifiedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 8];
        }
        get leftJustifiedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 9];
        }
        get verticalPlacedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 10];
        }
        get placedIconSymbolIndex() {
          return this._structArray.int16[this._pos2 + 11];
        }
        get verticalPlacedIconSymbolIndex() {
          return this._structArray.int16[this._pos2 + 12];
        }
        get key() {
          return this._structArray.uint16[this._pos2 + 13];
        }
        get textBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 14];
        }
        get textBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 15];
        }
        get verticalTextBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 16];
        }
        get verticalTextBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 17];
        }
        get iconBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 18];
        }
        get iconBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 19];
        }
        get verticalIconBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 20];
        }
        get verticalIconBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 21];
        }
        get featureIndex() {
          return this._structArray.uint16[this._pos2 + 22];
        }
        get numHorizontalGlyphVertices() {
          return this._structArray.uint16[this._pos2 + 23];
        }
        get numVerticalGlyphVertices() {
          return this._structArray.uint16[this._pos2 + 24];
        }
        get numIconVertices() {
          return this._structArray.uint16[this._pos2 + 25];
        }
        get numVerticalIconVertices() {
          return this._structArray.uint16[this._pos2 + 26];
        }
        get useRuntimeCollisionCircles() {
          return this._structArray.uint16[this._pos2 + 27];
        }
        get crossTileID() {
          return this._structArray.uint32[this._pos4 + 14];
        }
        set crossTileID(t4) {
          this._structArray.uint32[this._pos4 + 14] = t4;
        }
        get textOffset0() {
          return this._structArray.float32[this._pos4 + 15];
        }
        get textOffset1() {
          return this._structArray.float32[this._pos4 + 16];
        }
        get collisionCircleDiameter() {
          return this._structArray.float32[this._pos4 + 17];
        }
        get zOffset() {
          return this._structArray.float32[this._pos4 + 18];
        }
        set zOffset(t4) {
          this._structArray.float32[this._pos4 + 18] = t4;
        }
        get hasIconTextFit() {
          return this._structArray.uint8[this._pos1 + 76];
        }
      }
      Qs.prototype.size = 80;
      class to extends Ds {
        get(t4) {
          return new Qs(this, t4);
        }
      }
      aa(to, "SymbolInstanceArray");
      class eo extends Ls {
        getoffsetX(t4) {
          return this.float32[1 * t4 + 0];
        }
      }
      aa(eo, "GlyphOffsetArray");
      class ro extends ys {
        getx(t4) {
          return this.int16[2 * t4 + 0];
        }
        gety(t4) {
          return this.int16[2 * t4 + 1];
        }
      }
      aa(ro, "SymbolLineVertexArray");
      class no extends ps {
        get featureIndex() {
          return this._structArray.uint32[this._pos4 + 0];
        }
        get sourceLayerIndex() {
          return this._structArray.uint16[this._pos2 + 2];
        }
        get bucketIndex() {
          return this._structArray.uint16[this._pos2 + 3];
        }
        get layoutVertexArrayOffset() {
          return this._structArray.uint16[this._pos2 + 4];
        }
      }
      no.prototype.size = 12;
      class io extends Ns {
        get(t4) {
          return new no(this, t4);
        }
      }
      aa(io, "FeatureIndexArray");
      class ao extends ks {
        geta_centroid_pos0(t4) {
          return this.uint16[2 * t4 + 0];
        }
        geta_centroid_pos1(t4) {
          return this.uint16[2 * t4 + 1];
        }
      }
      aa(ao, "FillExtrusionCentroidArray");
      class so extends ps {
        get a_join_normal_inside0() {
          return this._structArray.int16[this._pos2 + 0];
        }
        get a_join_normal_inside1() {
          return this._structArray.int16[this._pos2 + 1];
        }
        get a_join_normal_inside2() {
          return this._structArray.int16[this._pos2 + 2];
        }
      }
      so.prototype.size = 6;
      class oo extends gs {
        get(t4) {
          return new so(this, t4);
        }
      }
      aa(oo, "FillExtrusionWallArray");
      const lo = ds([{ name: "a_pos", components: 2, type: "Int16" }], 4), uo = ds([{ name: "a_pos_3", components: 3, type: "Int16" }, { name: "a_pos_normal_3", components: 3, type: "Int16" }]);
      class co {
        constructor(t4 = []) {
          this.segments = t4;
        }
        _prepareSegment(t4, e3, r3, n3) {
          let i3 = this.segments[this.segments.length - 1];
          return t4 > co.MAX_VERTEX_ARRAY_LENGTH && ft(`Max vertices per segment is ${co.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t4}`), (!i3 || i3.vertexLength + t4 > co.MAX_VERTEX_ARRAY_LENGTH || i3.sortKey !== n3) && (i3 = { vertexOffset: e3, primitiveOffset: r3, vertexLength: 0, primitiveLength: 0 }, void 0 !== n3 && (i3.sortKey = n3), this.segments.push(i3)), i3;
        }
        prepareSegment(t4, e3, r3, n3) {
          return this._prepareSegment(t4, e3.length, r3.length, n3);
        }
        get() {
          return this.segments;
        }
        destroy() {
          for (const t4 of this.segments) for (const e3 in t4.vaos) t4.vaos[e3].destroy();
        }
        static simpleSegment(t4, e3, r3, n3) {
          return new co([{ vertexOffset: t4, primitiveOffset: e3, vertexLength: r3, primitiveLength: n3, vaos: {}, sortKey: 0 }]);
        }
      }
      function ho(t4, e3) {
        return 256 * (t4 = Q2(Math.floor(t4), 0, 255)) + Q2(Math.floor(e3), 0, 255);
      }
      co.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, aa(co, "SegmentVector");
      const po = ds([{ name: "a_pattern", components: 4, type: "Uint16" }, { name: "a_pixel_ratio", components: 1, type: "Float32" }]), fo = ds([{ name: "a_dash", components: 4, type: "Uint16" }]);
      class mo {
        constructor() {
          this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = false;
        }
        add(t4, e3, r3, n3) {
          this.ids.push(yo(t4)), this.positions.push(e3, r3, n3);
        }
        eachPosition(t4, e3) {
          const r3 = yo(t4);
          let n3 = 0, i3 = this.ids.length - 1;
          for (; n3 < i3; ) {
            const t5 = n3 + i3 >> 1;
            this.ids[t5] >= r3 ? i3 = t5 : n3 = t5 + 1;
          }
          for (; this.ids[n3] === r3; ) e3(this.positions[3 * n3], this.positions[3 * n3 + 1], this.positions[3 * n3 + 2]), n3++;
        }
        static serialize(t4, e3) {
          const r3 = new Float64Array(t4.ids), n3 = new Uint32Array(t4.positions);
          return go(r3, n3, 0, r3.length - 1), e3 && (e3.add(r3.buffer), e3.add(n3.buffer)), { ids: r3, positions: n3 };
        }
        static deserialize(t4) {
          const e3 = new mo();
          let r3;
          e3.ids = t4.ids, e3.positions = t4.positions;
          for (const t5 of e3.ids) t5 !== r3 && e3.uniqueIds.push(t5), r3 = t5;
          return e3.indexed = true, e3;
        }
      }
      function yo(t4) {
        const e3 = +t4;
        return !isNaN(e3) && Number.MIN_SAFE_INTEGER <= e3 && e3 <= Number.MAX_SAFE_INTEGER ? e3 : ge2(String(t4));
      }
      function go(t4, e3, r3, n3) {
        for (; r3 < n3; ) {
          const i3 = t4[r3 + n3 >> 1];
          let a4 = r3 - 1, s3 = n3 + 1;
          for (; ; ) {
            do {
              a4++;
            } while (t4[a4] < i3);
            do {
              s3--;
            } while (t4[s3] > i3);
            if (a4 >= s3) break;
            xo(t4, a4, s3), xo(e3, 3 * a4, 3 * s3), xo(e3, 3 * a4 + 1, 3 * s3 + 1), xo(e3, 3 * a4 + 2, 3 * s3 + 2);
          }
          s3 - r3 < n3 - s3 ? (go(t4, e3, r3, s3), r3 = s3 + 1) : (go(t4, e3, s3 + 1, n3), n3 = s3);
        }
      }
      function xo(t4, e3, r3) {
        const n3 = t4[e3];
        t4[e3] = t4[r3], t4[r3] = n3;
      }
      aa(mo, "FeaturePositionMap");
      class vo {
        constructor(t4) {
          this.gl = t4.gl, this.initialized = false;
        }
        fetchUniformLocation(t4, e3) {
          return this.location || this.initialized || (this.location = this.gl.getUniformLocation(t4, e3), this.initialized = true), !!this.location;
        }
        set(t4, e3, r3) {
          throw new Error("Uniform#set() must be implemented by each concrete Uniform");
        }
      }
      class bo extends vo {
        constructor(t4) {
          super(t4), this.current = 0;
        }
        set(t4, e3, r3) {
          this.fetchUniformLocation(t4, e3) && this.current !== r3 && (this.current = r3, this.gl.uniform1i(this.location, r3));
        }
      }
      class wo extends vo {
        constructor(t4) {
          super(t4), this.current = 0;
        }
        set(t4, e3, r3) {
          this.fetchUniformLocation(t4, e3) && this.current !== r3 && (this.current = r3, this.gl.uniform1f(this.location, r3));
        }
      }
      class _o extends vo {
        constructor(t4) {
          super(t4), this.current = [0, 0];
        }
        set(t4, e3, r3) {
          this.fetchUniformLocation(t4, e3) && (r3[0] === this.current[0] && r3[1] === this.current[1] || (this.current = r3, this.gl.uniform2f(this.location, r3[0], r3[1])));
        }
      }
      class Mo extends vo {
        constructor(t4) {
          super(t4), this.current = [0, 0, 0];
        }
        set(t4, e3, r3) {
          this.fetchUniformLocation(t4, e3) && (r3[0] === this.current[0] && r3[1] === this.current[1] && r3[2] === this.current[2] || (this.current = r3, this.gl.uniform3f(this.location, r3[0], r3[1], r3[2])));
        }
      }
      class Ao extends vo {
        constructor(t4) {
          super(t4), this.current = [0, 0, 0, 0];
        }
        set(t4, e3, r3) {
          this.fetchUniformLocation(t4, e3) && (r3[0] === this.current[0] && r3[1] === this.current[1] && r3[2] === this.current[2] && r3[3] === this.current[3] || (this.current = r3, this.gl.uniform4f(this.location, r3[0], r3[1], r3[2], r3[3])));
        }
      }
      class So extends vo {
        constructor(t4) {
          super(t4), this.current = Ie.transparent.toRenderColor(null);
        }
        set(t4, e3, r3) {
          this.fetchUniformLocation(t4, e3) && (r3.r === this.current.r && r3.g === this.current.g && r3.b === this.current.b && r3.a === this.current.a || (this.current = r3, this.gl.uniform4f(this.location, r3.r, r3.g, r3.b, r3.a)));
        }
      }
      const Io = new Float32Array(16);
      class zo extends vo {
        constructor(t4) {
          super(t4), this.current = Io;
        }
        set(t4, e3, r3) {
          if (this.fetchUniformLocation(t4, e3)) {
            if (r3[12] !== this.current[12] || r3[0] !== this.current[0]) return this.current = r3, void this.gl.uniformMatrix4fv(this.location, false, r3);
            for (let t5 = 1; t5 < 16; t5++) if (r3[t5] !== this.current[t5]) {
              this.current = r3, this.gl.uniformMatrix4fv(this.location, false, r3);
              break;
            }
          }
        }
      }
      const Po = new Float32Array(9), ko = new Float32Array(4);
      class To extends vo {
        constructor(t4) {
          super(t4), this.current = ko;
        }
        set(t4, e3, r3) {
          if (this.fetchUniformLocation(t4, e3)) {
            for (let t5 = 0; t5 < 4; t5++) if (r3[t5] !== this.current[t5]) {
              this.current = r3, this.gl.uniformMatrix2fv(this.location, false, r3);
              break;
            }
          }
        }
      }
      function Eo(t4) {
        return [ho(255 * t4.r, 255 * t4.g), ho(255 * t4.b, 255 * t4.a)];
      }
      class Bo {
        constructor(t4, e3, r3, n3) {
          this.value = t4, this.uniformNames = e3.map((t5) => `u_${t5}`), this.type = r3, this.context = n3;
        }
        setUniform(t4, e3, r3, n3, i3) {
          const a4 = n3.constantOr(this.value);
          e3.set(t4, i3, a4 instanceof Ie ? a4.toRenderColor(this.context.lut) : a4);
        }
        getBinding(t4, e3) {
          return "color" === this.type ? new So(t4) : new wo(t4);
        }
      }
      class Vo {
        constructor(t4, e3) {
          this.uniformNames = e3.map((t5) => `u_${t5}`), this.pattern = null, this.pixelRatio = 1;
        }
        setConstantPatternPositions(t4) {
          this.pixelRatio = t4.pixelRatio || 1, this.pattern = t4.tl.concat(t4.br);
        }
        setUniform(t4, e3, r3, n3, i3) {
          const a4 = "u_pattern" === i3 || "u_dash" === i3 ? this.pattern : "u_pixel_ratio" === i3 ? this.pixelRatio : null;
          a4 && e3.set(t4, i3, a4);
        }
        getBinding(t4, e3) {
          return "u_pattern" === e3 || "u_dash" === e3 ? new Ao(t4) : new wo(t4);
        }
      }
      class Co {
        constructor(t4, e3, r3, n3) {
          this.expression = t4, this.type = r3, this.maxValue = 0, this.paintVertexAttributes = e3.map((t5) => ({ name: `a_${t5}`, type: "Float32", components: "color" === r3 ? 2 : 1, offset: 0 })), this.paintVertexArray = new n3();
        }
        populatePaintArray(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = this.paintVertexArray.length, l3 = this.expression.evaluate(new Ea(0, { brightness: a4 }), e3, {}, i3, n3, s3);
          this.paintVertexArray.resize(t4), this._setPaintValue(o3, t4, l3, this.context);
        }
        updatePaintArray(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = this.expression.evaluate({ zoom: 0, brightness: s3 }, r3, n3, void 0, i3);
          this._setPaintValue(t4, e3, o3, this.context);
        }
        _setPaintValue(t4, e3, r3, n3) {
          if ("color" === this.type) {
            const i3 = Eo(r3.toRenderColor(n3.lut));
            for (let r4 = t4; r4 < e3; r4++) this.paintVertexArray.emplace(r4, i3[0], i3[1]);
          } else {
            for (let n4 = t4; n4 < e3; n4++) this.paintVertexArray.emplace(n4, r3);
            this.maxValue = Math.max(this.maxValue, Math.abs(r3));
          }
        }
        upload(t4) {
          this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t4.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
        }
        destroy() {
          this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }
      }
      class Ro {
        constructor(t4, e3, r3, n3, i3, a4) {
          this.expression = t4, this.uniformNames = e3.map((t5) => `u_${t5}_t`), this.type = r3, this.useIntegerZoom = n3, this.context = i3, this.maxValue = 0, this.paintVertexAttributes = e3.map((t5) => ({ name: `a_${t5}`, type: "Float32", components: "color" === r3 ? 4 : 2, offset: 0 })), this.paintVertexArray = new a4();
        }
        populatePaintArray(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = this.expression.evaluate(new Ea(this.context.zoom, { brightness: a4 }), e3, {}, i3, n3, s3), l3 = this.expression.evaluate(new Ea(this.context.zoom + 1, { brightness: a4 }), e3, {}, i3, n3, s3), u4 = this.paintVertexArray.length;
          this.paintVertexArray.resize(t4), this._setPaintValue(u4, t4, o3, l3, this.context);
        }
        updatePaintArray(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = this.expression.evaluate({ zoom: this.context.zoom, brightness: s3 }, r3, n3, void 0, i3), l3 = this.expression.evaluate({ zoom: this.context.zoom + 1, brightness: s3 }, r3, n3, void 0, i3);
          this._setPaintValue(t4, e3, o3, l3, this.context);
        }
        _setPaintValue(t4, e3, r3, n3, i3) {
          if ("color" === this.type) {
            const n4 = Eo(r3.toRenderColor(i3.lut)), a4 = Eo(r3.toRenderColor(i3.lut));
            for (let r4 = t4; r4 < e3; r4++) this.paintVertexArray.emplace(r4, n4[0], n4[1], a4[0], a4[1]);
          } else {
            for (let i4 = t4; i4 < e3; i4++) this.paintVertexArray.emplace(i4, r3, n3);
            this.maxValue = Math.max(this.maxValue, Math.abs(r3), Math.abs(n3));
          }
        }
        upload(t4) {
          this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t4.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
        }
        destroy() {
          this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }
        setUniform(t4, e3, r3, n3, i3) {
          const a4 = this.useIntegerZoom ? Math.floor(r3.zoom) : r3.zoom, s3 = Q2(this.expression.interpolationFactor(a4, this.context.zoom, this.context.zoom + 1), 0, 1);
          e3.set(t4, i3, s3);
        }
        getBinding(t4, e3) {
          return new wo(t4);
        }
      }
      class Do {
        constructor(t4, e3, r3, n3, i3) {
          this.expression = t4, this.layerId = i3, this.paintVertexAttributes = ("array" === r3 ? fo : po).members;
          for (let t5 = 0; t5 < e3.length; ++t5) ;
          this.paintVertexArray = new n3();
        }
        populatePaintArray(t4, e3, r3, n3) {
          const i3 = this.paintVertexArray.length;
          this.paintVertexArray.resize(t4), this._setPaintValues(i3, t4, e3.patterns && e3.patterns[this.layerId], r3);
        }
        updatePaintArray(t4, e3, r3, n3, i3, a4, s3) {
          this._setPaintValues(t4, e3, r3.patterns && r3.patterns[this.layerId], a4);
        }
        _setPaintValues(t4, e3, r3, n3) {
          if (!n3 || !r3) return;
          const i3 = n3[r3];
          if (!i3) return;
          const { tl: a4, br: s3, pixelRatio: o3 } = i3;
          for (let r4 = t4; r4 < e3; r4++) this.paintVertexArray.emplace(r4, a4[0], a4[1], s3[0], s3[1], o3);
        }
        upload(t4) {
          this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = t4.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
        }
        destroy() {
          this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }
      }
      class Lo {
        constructor(t4, e3, r3 = () => true) {
          this.binders = {}, this._buffers = [], this.context = e3;
          const n3 = [];
          for (const i3 in t4.paint._values) {
            const a4 = t4.paint.get(i3);
            if (!r3(i3)) continue;
            if (!(a4 instanceof Fa && Ci(a4.property.specification))) continue;
            const s3 = Uo(i3, t4.type), o3 = a4.value, l3 = a4.property.specification.type, u4 = !!a4.property.useIntegerZoom, c3 = "line-dasharray" === i3 || i3.endsWith("pattern"), h3 = "line-dasharray" === i3 && "constant" !== t4.layout.get("line-cap").value.kind;
            if ("constant" !== o3.kind || h3) if ("source" === o3.kind || h3 || c3) {
              const e4 = qo(i3, l3, "source");
              this.binders[i3] = c3 ? new Do(o3, s3, l3, e4, t4.id) : new Co(o3, s3, l3, e4), n3.push(`/a_${i3}`);
            } else {
              const t5 = qo(i3, l3, "composite");
              this.binders[i3] = new Ro(o3, s3, l3, u4, e3, t5), n3.push(`/z_${i3}`);
            }
            else this.binders[i3] = c3 ? new Vo(o3.value, s3) : new Bo(o3.value, s3, l3, e3), n3.push(`/u_${i3}`);
          }
          this.cacheKey = n3.sort().join("");
        }
        getMaxValue(t4) {
          const e3 = this.binders[t4];
          return e3 instanceof Co || e3 instanceof Ro ? e3.maxValue : 0;
        }
        populatePaintArrays(t4, e3, r3, n3, i3, a4, s3) {
          for (const o3 in this.binders) {
            const l3 = this.binders[o3];
            l3.context = this.context, (l3 instanceof Co || l3 instanceof Ro || l3 instanceof Do) && l3.populatePaintArray(t4, e3, r3, n3, i3, a4, s3);
          }
        }
        setConstantPatternPositions(t4) {
          for (const e3 in this.binders) {
            const r3 = this.binders[e3];
            r3 instanceof Vo && r3.setConstantPatternPositions(t4);
          }
        }
        updatePaintArrays(t4, e3, r3, n3, i3, a4, s3, o3) {
          let l3 = false;
          const u4 = Object.keys(t4), c3 = 0 !== u4.length, h3 = c3 ? u4 : e3.uniqueIds;
          this.context.lut = i3.lut;
          for (const u5 in this.binders) {
            const p3 = this.binders[u5];
            if (p3.context = this.context, (p3 instanceof Co || p3 instanceof Ro || p3 instanceof Do) && (true === p3.expression.isStateDependent || false === p3.expression.isLightConstant)) {
              const f3 = i3.paint.get(u5);
              p3.expression = f3.value;
              for (const r4 of h3) {
                const i4 = t4[r4.toString()];
                e3.eachPosition(r4, (t5, e4, r5) => {
                  const l4 = n3.feature(t5);
                  p3.updatePaintArray(e4, r5, l4, i4, a4, s3, o3);
                });
              }
              if (!c3) for (const e4 of r3.uniqueIds) {
                const i4 = t4[e4.toString()];
                r3.eachPosition(e4, (t5, e5, r4) => {
                  const l4 = n3.feature(t5);
                  p3.updatePaintArray(e5, r4, l4, i4, a4, s3, o3);
                });
              }
              l3 = true;
            }
          }
          return l3;
        }
        defines() {
          const t4 = [];
          for (const e3 in this.binders) {
            const r3 = this.binders[e3];
            (r3 instanceof Bo || r3 instanceof Vo) && t4.push(...r3.uniformNames.map((t5) => `#define HAS_UNIFORM_${t5}`));
          }
          return t4;
        }
        getBinderAttributes() {
          const t4 = [];
          for (const e3 in this.binders) {
            const r3 = this.binders[e3];
            if (r3 instanceof Co || r3 instanceof Ro || r3 instanceof Do) for (let e4 = 0; e4 < r3.paintVertexAttributes.length; e4++) t4.push(r3.paintVertexAttributes[e4].name);
          }
          return t4;
        }
        getBinderUniforms() {
          const t4 = [];
          for (const e3 in this.binders) {
            const r3 = this.binders[e3];
            if (r3 instanceof Bo || r3 instanceof Vo || r3 instanceof Ro) for (const e4 of r3.uniformNames) t4.push(e4);
          }
          return t4;
        }
        getPaintVertexBuffers() {
          return this._buffers;
        }
        getUniforms(t4) {
          const e3 = [];
          for (const r3 in this.binders) {
            const n3 = this.binders[r3];
            if (n3 instanceof Bo || n3 instanceof Vo || n3 instanceof Ro) for (const i3 of n3.uniformNames) e3.push({ name: i3, property: r3, binding: n3.getBinding(t4, i3) });
          }
          return e3;
        }
        setUniforms(t4, e3, r3, n3, i3) {
          for (const { name: e4, property: a4, binding: s3 } of r3) this.binders[a4].setUniform(t4, s3, i3, n3.get(a4), e4);
        }
        updatePaintBuffers() {
          this._buffers = [];
          for (const t4 in this.binders) {
            const e3 = this.binders[t4];
            (e3 instanceof Co || e3 instanceof Ro || e3 instanceof Do) && e3.paintVertexBuffer && this._buffers.push(e3.paintVertexBuffer);
          }
        }
        upload(t4) {
          for (const e3 in this.binders) {
            const r3 = this.binders[e3];
            (r3 instanceof Co || r3 instanceof Ro || r3 instanceof Do) && r3.upload(t4);
          }
          this.updatePaintBuffers();
        }
        destroy() {
          for (const t4 in this.binders) {
            const e3 = this.binders[t4];
            (e3 instanceof Co || e3 instanceof Ro || e3 instanceof Do) && e3.destroy();
          }
        }
      }
      class Fo {
        constructor(t4, e3, r3 = () => true) {
          this.programConfigurations = {};
          for (const n3 of t4) this.programConfigurations[n3.id] = new Lo(n3, e3, r3);
          this.needsUpload = false, this._featureMap = new mo(), this._featureMapWithoutIds = new mo(), this._bufferOffset = 0, this._idlessCounter = 0;
        }
        populatePaintArrays(t4, e3, r3, n3, i3, a4, s3, o3) {
          for (const r4 in this.programConfigurations) this.programConfigurations[r4].populatePaintArrays(t4, e3, n3, i3, a4, s3, o3);
          void 0 !== e3.id ? this._featureMap.add(e3.id, r3, this._bufferOffset, t4) : (this._featureMapWithoutIds.add(this._idlessCounter, r3, this._bufferOffset, t4), this._idlessCounter += 1), this._bufferOffset = t4, this.needsUpload = true;
        }
        updatePaintArrays(t4, e3, r3, n3, i3, a4) {
          for (const s3 of r3) this.needsUpload = this.programConfigurations[s3.id].updatePaintArrays(t4, this._featureMap, this._featureMapWithoutIds, e3, s3, n3, i3, a4 || 0) || this.needsUpload;
        }
        get(t4) {
          return this.programConfigurations[t4];
        }
        upload(t4) {
          if (this.needsUpload) {
            for (const e3 in this.programConfigurations) this.programConfigurations[e3].upload(t4);
            this.needsUpload = false;
          }
        }
        destroy() {
          for (const t4 in this.programConfigurations) this.programConfigurations[t4].destroy();
        }
      }
      const Oo = { "text-opacity": ["opacity"], "icon-opacity": ["opacity"], "text-occlusion-opacity": ["occlusion_opacity"], "icon-occlusion-opacity": ["occlusion_opacity"], "text-color": ["fill_color"], "icon-color": ["fill_color"], "text-emissive-strength": ["emissive_strength"], "icon-emissive-strength": ["emissive_strength"], "text-halo-color": ["halo_color"], "icon-halo-color": ["halo_color"], "text-halo-blur": ["halo_blur"], "icon-halo-blur": ["halo_blur"], "text-halo-width": ["halo_width"], "icon-halo-width": ["halo_width"], "symbol-z-offset": ["z_offset"], "line-gap-width": ["gapwidth"], "line-pattern": ["pattern", "pixel_ratio"], "fill-pattern": ["pattern", "pixel_ratio"], "fill-extrusion-pattern": ["pattern", "pixel_ratio"], "line-dasharray": ["dash"] };
      function Uo(t4, e3) {
        return Oo[t4] || [t4.replace(`${e3}-`, "").replace(/-/g, "_")];
      }
      const jo = { "line-pattern": { source: Ms, composite: Ms }, "fill-pattern": { source: Ms, composite: Ms }, "fill-extrusion-pattern": { source: Ms, composite: Ms }, "line-dasharray": { source: As, composite: As } }, No = { color: { source: $s, composite: ws }, number: { source: Ls, composite: $s } };
      function qo(t4, e3, r3) {
        const n3 = jo[t4];
        return n3 && n3[r3] || No[e3][r3];
      }
      aa(Bo, "ConstantBinder"), aa(Vo, "PatternConstantBinder"), aa(Co, "SourceExpressionBinder"), aa(Do, "PatternCompositeBinder"), aa(Ro, "CompositeExpressionBinder"), aa(Lo, "ProgramConfiguration", { omit: ["_buffers"] }), aa(Fo, "ProgramConfigurationSet");
      const $o = Wr / Math.PI / 2, Go = 5, Xo = 6, Yo = 16383, Zo = 64, Wo = [Zo, 32, 16], Ho = -$o, Ko = $o;
      function Jo(t4, e3, r3, n3 = $o) {
        return r3 = Y(r3), [t4 * Math.sin(r3) * n3, -e3 * n3, t4 * Math.cos(r3) * n3];
      }
      function Qo(t4, e3, r3) {
        return Jo(Math.cos(Y(t4)), Math.sin(Y(t4)), e3, r3);
      }
      const tl = 63710088e-1, el = 2 * Math.PI * tl;
      class rl {
        constructor(t4, e3) {
          if (isNaN(t4) || isNaN(e3)) throw new Error(`Invalid LngLat object: (${t4}, ${e3})`);
          if (this.lng = +t4, this.lat = +e3, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
        }
        wrap() {
          return new rl(et2(this.lng, -180, 180), this.lat);
        }
        toArray() {
          return [this.lng, this.lat];
        }
        toString() {
          return `LngLat(${this.lng}, ${this.lat})`;
        }
        distanceTo(t4) {
          const e3 = Math.PI / 180, r3 = this.lat * e3, n3 = t4.lat * e3, i3 = Math.sin(r3) * Math.sin(n3) + Math.cos(r3) * Math.cos(n3) * Math.cos((t4.lng - this.lng) * e3);
          return tl * Math.acos(Math.min(i3, 1));
        }
        toBounds(t4 = 0) {
          const e3 = 360 * t4 / 40075017, r3 = e3 / Math.cos(Math.PI / 180 * this.lat);
          return new nl({ lng: this.lng - r3, lat: this.lat - e3 }, { lng: this.lng + r3, lat: this.lat + e3 });
        }
        toEcef(t4) {
          return Qo(this.lat, this.lng, $o + t4 * $o / tl);
        }
        static convert(t4) {
          if (t4 instanceof rl) return t4;
          if (Array.isArray(t4) && (2 === t4.length || 3 === t4.length)) return new rl(Number(t4[0]), Number(t4[1]));
          if (!Array.isArray(t4) && "object" == typeof t4 && null !== t4) return new rl(Number("lng" in t4 ? t4.lng : t4.lon), Number(t4.lat));
          throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
        }
      }
      class nl {
        constructor(t4, e3) {
          if (t4) if (e3) this.setSouthWest(t4).setNorthEast(e3);
          else if (4 === t4.length) {
            const e4 = t4;
            this.setSouthWest([e4[0], e4[1]]).setNorthEast([e4[2], e4[3]]);
          } else {
            const e4 = t4;
            this.setSouthWest(e4[0]).setNorthEast(e4[1]);
          }
        }
        setNorthEast(t4) {
          return this._ne = t4 instanceof rl ? new rl(t4.lng, t4.lat) : rl.convert(t4), this;
        }
        setSouthWest(t4) {
          return this._sw = t4 instanceof rl ? new rl(t4.lng, t4.lat) : rl.convert(t4), this;
        }
        extend(t4) {
          const e3 = this._sw, r3 = this._ne;
          let n3, i3;
          if (t4 instanceof rl) n3 = t4, i3 = t4;
          else {
            if (!(t4 instanceof nl)) return Array.isArray(t4) ? 4 === t4.length || t4.every(Array.isArray) ? this.extend(nl.convert(t4)) : this.extend(rl.convert(t4)) : "object" == typeof t4 && null !== t4 && t4.hasOwnProperty("lat") && (t4.hasOwnProperty("lon") || t4.hasOwnProperty("lng")) ? this.extend(rl.convert(t4)) : this;
            if (n3 = t4._sw, i3 = t4._ne, !n3 || !i3) return this;
          }
          return e3 || r3 ? (e3.lng = Math.min(n3.lng, e3.lng), e3.lat = Math.min(n3.lat, e3.lat), r3.lng = Math.max(i3.lng, r3.lng), r3.lat = Math.max(i3.lat, r3.lat)) : (this._sw = new rl(n3.lng, n3.lat), this._ne = new rl(i3.lng, i3.lat)), this;
        }
        getCenter() {
          return new rl((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
        }
        getSouthWest() {
          return this._sw;
        }
        getNorthEast() {
          return this._ne;
        }
        getNorthWest() {
          return new rl(this.getWest(), this.getNorth());
        }
        getSouthEast() {
          return new rl(this.getEast(), this.getSouth());
        }
        getWest() {
          return this._sw.lng;
        }
        getSouth() {
          return this._sw.lat;
        }
        getEast() {
          return this._ne.lng;
        }
        getNorth() {
          return this._ne.lat;
        }
        toArray() {
          return [this._sw.toArray(), this._ne.toArray()];
        }
        toString() {
          return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
        }
        isEmpty() {
          return !(this._sw && this._ne);
        }
        contains(t4) {
          const { lng: e3, lat: r3 } = rl.convert(t4);
          let n3 = this._sw.lng <= e3 && e3 <= this._ne.lng;
          return this._sw.lng > this._ne.lng && (n3 = this._sw.lng >= e3 && e3 >= this._ne.lng), this._sw.lat <= r3 && r3 <= this._ne.lat && n3;
        }
        static convert(t4) {
          if (t4) return t4 instanceof nl ? t4 : new nl(t4);
        }
      }
      const il = 0, al = 25.5;
      function sl(t4) {
        return el * Math.cos(t4 * Math.PI / 180);
      }
      function ol(t4) {
        return (180 + t4) / 360;
      }
      function ll(t4) {
        return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t4 * Math.PI / 360))) / 360;
      }
      function ul(t4, e3) {
        return t4 / sl(e3);
      }
      function cl(t4) {
        return 360 * t4 - 180;
      }
      function hl(t4) {
        return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t4) * Math.PI / 180)) - 90;
      }
      function pl(t4, e3) {
        return t4 * sl(hl(e3));
      }
      const fl2 = 85.051129;
      function dl(t4) {
        return Math.cos(Y(Q2(t4, -fl2, fl2)));
      }
      function ml(t4, e3) {
        const r3 = Q2(e3, il, al), n3 = Math.pow(2, r3);
        return dl(t4) * el / (512 * n3);
      }
      function yl(t4) {
        return 1 / Math.cos(t4 * Math.PI / 180);
      }
      function gl(t4, e3 = 0) {
        const r3 = Math.exp(Math.PI * (1 - (t4.y + e3 / Wr) / (1 << t4.z) * 2));
        return 80150034 * r3 / (r3 * r3 + 1) / Wr / (1 << t4.z);
      }
      class xl {
        constructor(t4, e3, r3 = 0) {
          this.x = +t4, this.y = +e3, this.z = +r3;
        }
        static fromLngLat(t4, e3 = 0) {
          const r3 = rl.convert(t4);
          return new xl(ol(r3.lng), ll(r3.lat), ul(e3, r3.lat));
        }
        toLngLat() {
          return new rl(cl(this.x), hl(this.y));
        }
        toAltitude() {
          return pl(this.z, this.y);
        }
        meterInMercatorCoordinateUnits() {
          return 1 / el * yl(hl(this.y));
        }
      }
      function vl(t4, e3, r3, n3, i3, a4, s3, o3, l3) {
        const u4 = (e3 + n3) / 2, c3 = (r3 + i3) / 2, h3 = new q(u4, c3);
        o3(h3), function(t5, e4, r4, n4, i4, a5) {
          const s4 = r4 - i4, o4 = n4 - a5;
          return Math.abs((n4 - e4) * s4 - (r4 - t5) * o4) / Math.hypot(s4, o4);
        }(h3.x, h3.y, a4.x, a4.y, s3.x, s3.y) >= l3 ? (vl(t4, e3, r3, u4, c3, a4, h3, o3, l3), vl(t4, u4, c3, n3, i3, h3, s3, o3, l3)) : t4.push(s3);
      }
      function bl(t4, e3, r3) {
        let n3 = t4[0], i3 = n3.x, a4 = n3.y;
        e3(n3);
        const s3 = [n3];
        for (let o3 = 1; o3 < t4.length; o3++) {
          const l3 = t4[o3], { x: u4, y: c3 } = l3;
          e3(l3), vl(s3, i3, a4, u4, c3, n3, l3, e3, r3), i3 = u4, a4 = c3, n3 = l3;
        }
        return s3;
      }
      function wl(t4, e3, r3, n3) {
        if (n3(e3, r3)) {
          const i3 = e3.add(r3)._mult(0.5);
          wl(t4, e3, i3, n3), wl(t4, i3, r3, n3);
        } else t4.push(r3);
      }
      function _l(t4, e3) {
        let r3 = t4[0];
        const n3 = [r3];
        for (let i3 = 1; i3 < t4.length; i3++) {
          const a4 = t4[i3];
          wl(n3, r3, a4, e3), r3 = a4;
        }
        return n3;
      }
      const Ml = Math.pow(2, 14) - 1, Al = -Ml - 1;
      function Sl(t4, e3) {
        const r3 = Math.round(t4.x * e3), n3 = Math.round(t4.y * e3);
        return t4.x = Q2(r3, Al, Ml), t4.y = Q2(n3, Al, Ml), (r3 < t4.x || r3 > t4.x + 1 || n3 < t4.y || n3 > t4.y + 1) && ft("Geometry exceeds allowed extent, reduce your vector tile buffer size"), t4;
      }
      function Il(t4, e3, r3) {
        const n3 = t4.loadGeometry(), i3 = t4.extent, a4 = Wr / i3;
        if (e3 && r3 && r3.projection.isReprojectedInTileSpace) {
          const a5 = 1 << e3.z, { scale: s3, x: o3, y: l3, projection: u4 } = r3, c3 = (t5) => {
            const r4 = cl((e3.x + t5.x / i3) / a5), n4 = hl((e3.y + t5.y / i3) / a5), c4 = u4.project(r4, n4);
            t5.x = (c4.x * s3 - o3) * i3, t5.y = (c4.y * s3 - l3) * i3;
          };
          for (let e4 = 0; e4 < n3.length; e4++) if (1 !== t4.type) n3[e4] = bl(n3[e4], c3, 1);
          else {
            const t5 = [];
            for (const r4 of n3[e4]) r4.x < 0 || r4.x >= i3 || r4.y < 0 || r4.y >= i3 || (c3(r4), t5.push(r4));
            n3[e4] = t5;
          }
        }
        for (const t5 of n3) for (const e4 of t5) Sl(e4, a4);
        return n3;
      }
      function zl(t4, e3) {
        return { type: t4.type, id: t4.id, properties: t4.properties, geometry: e3 ? Il(t4) : [] };
      }
      function Pl(t4, e3, r3, n3, i3) {
        t4.emplaceBack(2 * e3 + (n3 + 1) / 2, 2 * r3 + (i3 + 1) / 2);
      }
      function kl(t4, e3, r3) {
        const n3 = 16384;
        t4.emplaceBack(e3.x, e3.y, e3.z, r3[0] * n3, r3[1] * n3, r3[2] * n3);
      }
      class Tl {
        constructor(t4) {
          this.zoom = t4.zoom, this.overscaling = t4.overscaling, this.layers = t4.layers, this.layerIds = this.layers.map((t5) => t5.fqid), this.index = t4.index, this.hasPattern = false, this.projection = t4.projection, this.layoutVertexArray = new ys(), this.indexArray = new Cs(), this.segments = new co(), this.programConfigurations = new Fo(t4.layers, { zoom: t4.zoom, lut: t4.lut }), this.stateDependentLayerIds = this.layers.filter((t5) => t5.isStateDependent()).map((t5) => t5.id);
        }
        updateFootprints(t4, e3) {
        }
        populate(t4, e3, r3, n3) {
          const i3 = this.layers[0], a4 = [];
          let s3 = null;
          "circle" === i3.type && (s3 = i3.layout.get("circle-sort-key"));
          for (const { feature: e4, id: i4, index: o4, sourceLayerIndex: l3 } of t4) {
            const t5 = this.layers[0]._featureFilter.needGeometry, u4 = zl(e4, t5);
            if (!this.layers[0]._featureFilter.filter(new Ea(this.zoom), u4, r3)) continue;
            const c3 = s3 ? s3.evaluate(u4, {}, r3) : void 0, h3 = { id: i4, properties: e4.properties, type: e4.type, sourceLayerIndex: l3, index: o4, geometry: t5 ? u4.geometry : Il(e4, r3, n3), patterns: {}, sortKey: c3 };
            a4.push(h3);
          }
          s3 && a4.sort((t5, e4) => t5.sortKey - e4.sortKey);
          let o3 = null;
          "globe" === n3.projection.name && (this.globeExtVertexArray = new Ss(), o3 = n3.projection);
          for (const n4 of a4) {
            const { geometry: i4, index: a5, sourceLayerIndex: s4 } = n4, l3 = t4[a5].feature;
            this.addFeature(n4, i4, a5, e3.availableImages, r3, o3, e3.brightness), e3.featureIndex.insert(l3, i4, a5, s4, this.index);
          }
        }
        update(t4, e3, r3, n3, i3) {
          const a4 = 0 !== Object.keys(t4).length;
          a4 && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(t4, e3, a4 ? this.stateDependentLayers : this.layers, r3, n3, i3);
        }
        isEmpty() {
          return 0 === this.layoutVertexArray.length;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(t4) {
          this.uploaded || (this.layoutVertexBuffer = t4.createVertexBuffer(this.layoutVertexArray, lo.members), this.indexBuffer = t4.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = t4.createVertexBuffer(this.globeExtVertexArray, uo.members))), this.programConfigurations.upload(t4), this.uploaded = true;
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy());
        }
        addFeature(t4, e3, r3, n3, i3, a4, s3) {
          for (const r4 of e3) for (const e4 of r4) {
            const r5 = e4.x, n4 = e4.y;
            if (r5 < 0 || r5 >= Wr || n4 < 0 || n4 >= Wr) continue;
            if (a4) {
              const t5 = a4.projectTilePoint(r5, n4, i3), e5 = a4.upVector(i3, r5, n4), s5 = this.globeExtVertexArray;
              kl(s5, t5, e5), kl(s5, t5, e5), kl(s5, t5, e5), kl(s5, t5, e5);
            }
            const s4 = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t4.sortKey), o3 = s4.vertexLength;
            Pl(this.layoutVertexArray, r5, n4, -1, -1), Pl(this.layoutVertexArray, r5, n4, 1, -1), Pl(this.layoutVertexArray, r5, n4, 1, 1), Pl(this.layoutVertexArray, r5, n4, -1, 1), this.indexArray.emplaceBack(o3, o3 + 1, o3 + 2), this.indexArray.emplaceBack(o3, o3 + 2, o3 + 3), s4.vertexLength += 4, s4.primitiveLength += 2;
          }
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t4, r3, {}, n3, i3, s3);
        }
      }
      function El(t4, e3) {
        for (let r3 = 0; r3 < t4.length; r3++) if (Ul(e3, t4[r3])) return true;
        for (let r3 = 0; r3 < e3.length; r3++) if (Ul(t4, e3[r3])) return true;
        return !!Rl(t4, e3);
      }
      function Bl(t4, e3, r3) {
        return !!Ul(t4, e3) || !!Ll(e3, t4, r3);
      }
      function Vl(t4, e3) {
        if (1 === t4.length) return Ol(e3, t4[0]);
        for (let r3 = 0; r3 < e3.length; r3++) {
          const n3 = e3[r3];
          for (let e4 = 0; e4 < n3.length; e4++) if (Ul(t4, n3[e4])) return true;
        }
        for (let r3 = 0; r3 < t4.length; r3++) if (Ol(e3, t4[r3])) return true;
        for (let r3 = 0; r3 < e3.length; r3++) if (Rl(t4, e3[r3])) return true;
        return false;
      }
      function Cl(t4, e3, r3) {
        if (t4.length > 1) {
          if (Rl(t4, e3)) return true;
          for (let n3 = 0; n3 < e3.length; n3++) if (Ll(e3[n3], t4, r3)) return true;
        }
        for (let n3 = 0; n3 < t4.length; n3++) if (Ll(t4[n3], e3, r3)) return true;
        return false;
      }
      function Rl(t4, e3) {
        if (0 === t4.length || 0 === e3.length) return false;
        for (let r3 = 0; r3 < t4.length - 1; r3++) {
          const n3 = t4[r3], i3 = t4[r3 + 1];
          for (let t5 = 0; t5 < e3.length - 1; t5++) if (Dl(n3, i3, e3[t5], e3[t5 + 1])) return true;
        }
        return false;
      }
      function Dl(t4, e3, r3, n3) {
        return dt(t4, r3, n3) !== dt(e3, r3, n3) && dt(t4, e3, r3) !== dt(t4, e3, n3);
      }
      function Ll(t4, e3, r3) {
        const n3 = r3 * r3;
        if (1 === e3.length) return t4.distSqr(e3[0]) < n3;
        for (let r4 = 1; r4 < e3.length; r4++) if (Fl(t4, e3[r4 - 1], e3[r4]) < n3) return true;
        return false;
      }
      function Fl(t4, e3, r3) {
        const n3 = e3.distSqr(r3);
        if (0 === n3) return t4.distSqr(e3);
        const i3 = ((t4.x - e3.x) * (r3.x - e3.x) + (t4.y - e3.y) * (r3.y - e3.y)) / n3;
        return t4.distSqr(i3 < 0 ? e3 : i3 > 1 ? r3 : r3.sub(e3)._mult(i3)._add(e3));
      }
      function Ol(t4, e3) {
        let r3, n3, i3, a4 = false;
        for (let s3 = 0; s3 < t4.length; s3++) {
          r3 = t4[s3];
          for (let t5 = 0, s4 = r3.length - 1; t5 < r3.length; s4 = t5++) n3 = r3[t5], i3 = r3[s4], n3.y > e3.y != i3.y > e3.y && e3.x < (i3.x - n3.x) * (e3.y - n3.y) / (i3.y - n3.y) + n3.x && (a4 = !a4);
        }
        return a4;
      }
      function Ul(t4, e3) {
        let r3 = false;
        for (let n3 = 0, i3 = t4.length - 1; n3 < t4.length; i3 = n3++) {
          const a4 = t4[n3], s3 = t4[i3];
          a4.y > e3.y != s3.y > e3.y && e3.x < (s3.x - a4.x) * (e3.y - a4.y) / (s3.y - a4.y) + a4.x && (r3 = !r3);
        }
        return r3;
      }
      function jl(t4, e3, r3, n3, i3) {
        for (const a5 of t4) if (e3 <= a5.x && r3 <= a5.y && n3 >= a5.x && i3 >= a5.y) return true;
        const a4 = [new q(e3, r3), new q(e3, i3), new q(n3, i3), new q(n3, r3)];
        if (t4.length > 2) {
          for (const e4 of a4) if (Ul(t4, e4)) return true;
        }
        for (let e4 = 0; e4 < t4.length - 1; e4++) if (Nl(t4[e4], t4[e4 + 1], a4)) return true;
        return false;
      }
      function Nl(t4, e3, r3) {
        const n3 = r3[0], i3 = r3[2];
        if (t4.x < n3.x && e3.x < n3.x || t4.x > i3.x && e3.x > i3.x || t4.y < n3.y && e3.y < n3.y || t4.y > i3.y && e3.y > i3.y) return false;
        const a4 = dt(t4, e3, r3[0]);
        return a4 !== dt(t4, e3, r3[1]) || a4 !== dt(t4, e3, r3[2]) || a4 !== dt(t4, e3, r3[3]);
      }
      function ql(t4, e3, r3, n3, i3, a4) {
        let s3 = e3.y - t4.y, o3 = t4.x - e3.x;
        if (a4 = a4 || 0) {
          const t5 = s3 * s3 + o3 * o3;
          if (0 === t5) return true;
          const e4 = Math.sqrt(t5);
          s3 /= e4, o3 /= e4;
        }
        return !((r3.x - t4.x) * s3 + (r3.y - t4.y) * o3 - a4 < 0 || (n3.x - t4.x) * s3 + (n3.y - t4.y) * o3 - a4 < 0 || (i3.x - t4.x) * s3 + (i3.y - t4.y) * o3 - a4 < 0);
      }
      function $l(t4, e3, r3, n3, i3, a4, s3) {
        return !(ql(t4, e3, n3, i3, a4, s3) || ql(e3, r3, n3, i3, a4, s3) || ql(r3, t4, n3, i3, a4, s3) || ql(n3, i3, t4, e3, r3, s3) || ql(i3, a4, t4, e3, r3, s3) || ql(a4, n3, t4, e3, r3, s3));
      }
      function Gl(t4, e3, r3) {
        const n3 = e3.paint.get(t4).value;
        return "constant" === n3.kind ? n3.value : r3.programConfigurations.get(e3.id).getMaxValue(t4);
      }
      function Xl(t4) {
        return Math.sqrt(t4[0] * t4[0] + t4[1] * t4[1]);
      }
      function Yl(t4, e3, r3, n3, i3) {
        if (!e3[0] && !e3[1]) return t4;
        const a4 = q.convert(e3)._mult(i3);
        "viewport" === r3 && a4._rotate(-n3);
        const s3 = [];
        for (let e4 = 0; e4 < t4.length; e4++) s3.push(t4[e4].sub(a4));
        return s3;
      }
      function Zl(t4, e3, r3, n3) {
        const i3 = q.convert(t4)._mult(n3);
        return "viewport" === e3 && i3._rotate(-r3), i3;
      }
      let Wl, Hl;
      aa(Tl, "CircleBucket", { omit: ["layers"] });
      var Kl, Jl = { exports: {} }, Ql = (Kl || (Kl = 1, function(t4, e3) {
        !function(t5) {
          function e4(t6, e5, n3) {
            var i3 = r3(256 * t6, 256 * (e5 = Math.pow(2, n3) - e5 - 1), n3), a4 = r3(256 * (t6 + 1), 256 * (e5 + 1), n3);
            return i3[0] + "," + i3[1] + "," + a4[0] + "," + a4[1];
          }
          function r3(t6, e5, r4) {
            var n3 = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r4);
            return [t6 * n3 - 2 * Math.PI * 6378137 / 2, e5 * n3 - 2 * Math.PI * 6378137 / 2];
          }
          t5.getURL = function(t6, r4, n3, i3, a4, s3) {
            return s3 = s3 || {}, t6 + "?" + ["bbox=" + e4(n3, i3, a4), "format=" + (s3.format || "image/png"), "service=" + (s3.service || "WMS"), "version=" + (s3.version || "1.1.1"), "request=" + (s3.request || "GetMap"), "srs=" + (s3.srs || "EPSG:3857"), "width=" + (s3.width || 256), "height=" + (s3.height || 256), "layers=" + r4].join("&");
          }, t5.getTileBBox = e4, t5.getMercCoords = r3, Object.defineProperty(t5, "__esModule", { value: true });
        }(e3);
      }(0, Jl.exports)), Jl.exports);
      class tu {
        constructor(t4, e3, r3) {
          this.z = t4, this.x = e3, this.y = r3, this.key = nu(0, t4, t4, e3, r3);
        }
        equals(t4) {
          return this.z === t4.z && this.x === t4.x && this.y === t4.y;
        }
        url(t4, e3) {
          const r3 = Ql.getTileBBox(this.x, this.y, this.z), n3 = function(t5, e4, r4) {
            let n4, i3 = "";
            for (let a4 = t5; a4 > 0; a4--) n4 = 1 << a4 - 1, i3 += (e4 & n4 ? 1 : 0) + (r4 & n4 ? 2 : 0);
            return i3;
          }(this.z, this.x, this.y);
          return t4[(this.x + this.y) % t4.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === e3 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n3).replace("{bbox-epsg-3857}", r3);
        }
        toString() {
          return `${this.z}/${this.x}/${this.y}`;
        }
      }
      class eu {
        constructor(t4, e3) {
          this.wrap = t4, this.canonical = e3, this.key = nu(t4, e3.z, e3.z, e3.x, e3.y);
        }
      }
      class ru {
        constructor(t4, e3, r3, n3, i3) {
          this.overscaledZ = t4, this.wrap = e3, this.canonical = new tu(r3, +n3, +i3), this.key = 0 === e3 && t4 === r3 ? this.canonical.key : nu(e3, t4, r3, n3, i3);
        }
        equals(t4) {
          return this.overscaledZ === t4.overscaledZ && this.wrap === t4.wrap && this.canonical.equals(t4.canonical);
        }
        scaledTo(t4) {
          const e3 = this.canonical.z - t4;
          return t4 > this.canonical.z ? new ru(t4, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new ru(t4, this.wrap, t4, this.canonical.x >> e3, this.canonical.y >> e3);
        }
        calculateScaledKey(t4, e3 = true) {
          if (this.overscaledZ === t4 && e3) return this.key;
          if (t4 > this.canonical.z) return nu(this.wrap * +e3, t4, this.canonical.z, this.canonical.x, this.canonical.y);
          {
            const r3 = this.canonical.z - t4;
            return nu(this.wrap * +e3, t4, t4, this.canonical.x >> r3, this.canonical.y >> r3);
          }
        }
        isChildOf(t4) {
          if (t4.wrap !== this.wrap) return false;
          const e3 = this.canonical.z - t4.canonical.z;
          return 0 === t4.overscaledZ || t4.overscaledZ < this.overscaledZ && t4.canonical.z < this.canonical.z && t4.canonical.x === this.canonical.x >> e3 && t4.canonical.y === this.canonical.y >> e3;
        }
        children(t4) {
          if (this.overscaledZ >= t4) return [new ru(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)];
          const e3 = this.canonical.z + 1, r3 = 2 * this.canonical.x, n3 = 2 * this.canonical.y;
          return [new ru(e3, this.wrap, e3, r3, n3), new ru(e3, this.wrap, e3, r3 + 1, n3), new ru(e3, this.wrap, e3, r3, n3 + 1), new ru(e3, this.wrap, e3, r3 + 1, n3 + 1)];
        }
        isLessThan(t4) {
          return this.wrap < t4.wrap || !(this.wrap > t4.wrap) && (this.overscaledZ < t4.overscaledZ || !(this.overscaledZ > t4.overscaledZ) && (this.canonical.x < t4.canonical.x || !(this.canonical.x > t4.canonical.x) && this.canonical.y < t4.canonical.y));
        }
        wrapped() {
          return new ru(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
        }
        unwrapTo(t4) {
          return new ru(this.overscaledZ, t4, this.canonical.z, this.canonical.x, this.canonical.y);
        }
        overscaleFactor() {
          return Math.pow(2, this.overscaledZ - this.canonical.z);
        }
        toUnwrapped() {
          return new eu(this.wrap, this.canonical);
        }
        toString() {
          return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
        }
      }
      function nu(t4, e3, r3, n3, i3) {
        const a4 = 1 << Math.min(r3, 22);
        let s3 = a4 * (i3 % a4) + n3 % a4;
        return t4 && r3 < 22 && (s3 += a4 * a4 * ((t4 < 0 ? -2 * t4 - 1 : 2 * t4) % (1 << 2 * (22 - r3)))), 16 * (32 * s3 + r3) + (e3 - r3);
      }
      const iu = [(t4) => {
        let e3 = t4.canonical.x - 1, r3 = t4.wrap;
        return e3 < 0 && (e3 = (1 << t4.canonical.z) - 1, r3--), new ru(t4.overscaledZ, r3, t4.canonical.z, e3, t4.canonical.y);
      }, (t4) => {
        let e3 = t4.canonical.x + 1, r3 = t4.wrap;
        return e3 === 1 << t4.canonical.z && (e3 = 0, r3++), new ru(t4.overscaledZ, r3, t4.canonical.z, e3, t4.canonical.y);
      }, (t4) => new ru(t4.overscaledZ, t4.wrap, t4.canonical.z, t4.canonical.x, (0 === t4.canonical.y ? 1 << t4.canonical.z : t4.canonical.y) - 1), (t4) => new ru(t4.overscaledZ, t4.wrap, t4.canonical.z, t4.canonical.x, t4.canonical.y === (1 << t4.canonical.z) - 1 ? 0 : t4.canonical.y + 1)];
      aa(tu, "CanonicalTileID"), aa(ru, "OverscaledTileID", { omit: ["projMatrix", "expandedProjMatrix"] });
      const au = ds([{ type: "Float32", name: "a_globe_pos", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }]), { members: su } = au, ou = ds([{ name: "a_pos_3", components: 3, type: "Int16" }]);
      var lu = ds([{ name: "a_pos", type: "Int16", components: 2 }]);
      class uu {
        constructor(t4, e3) {
          this.pos = t4, this.dir = e3;
        }
        intersectsPlane(t4, e3, r3) {
          const n3 = O.vec3.dot(e3, this.dir);
          if (Math.abs(n3) < 1e-6) return false;
          const i3 = ((t4[0] - this.pos[0]) * e3[0] + (t4[1] - this.pos[1]) * e3[1] + (t4[2] - this.pos[2]) * e3[2]) / n3;
          return r3[0] = this.pos[0] + this.dir[0] * i3, r3[1] = this.pos[1] + this.dir[1] * i3, r3[2] = this.pos[2] + this.dir[2] * i3, true;
        }
        closestPointOnSphere(t4, e3, r3) {
          if (O.vec3.equals(this.pos, t4) || 0 === e3) return r3[0] = r3[1] = r3[2] = 0, false;
          const [n3, i3, a4] = this.dir, s3 = this.pos[0] - t4[0], o3 = this.pos[1] - t4[1], l3 = this.pos[2] - t4[2], u4 = n3 * n3 + i3 * i3 + a4 * a4, c3 = 2 * (s3 * n3 + o3 * i3 + l3 * a4), h3 = c3 * c3 - 4 * u4 * (s3 * s3 + o3 * o3 + l3 * l3 - e3 * e3);
          if (h3 < 0) {
            const t5 = Math.max(-c3 / 2, 0), u5 = s3 + n3 * t5, h4 = o3 + i3 * t5, p3 = l3 + a4 * t5, f3 = Math.hypot(u5, h4, p3);
            return r3[0] = u5 * e3 / f3, r3[1] = h4 * e3 / f3, r3[2] = p3 * e3 / f3, false;
          }
          {
            const t5 = (-c3 - Math.sqrt(h3)) / (2 * u4);
            if (t5 < 0) {
              const t6 = Math.hypot(s3, o3, l3);
              return r3[0] = s3 * e3 / t6, r3[1] = o3 * e3 / t6, r3[2] = l3 * e3 / t6, false;
            }
            return r3[0] = s3 + n3 * t5, r3[1] = o3 + i3 * t5, r3[2] = l3 + a4 * t5, true;
          }
        }
      }
      class cu {
        constructor(t4, e3, r3, n3, i3) {
          this.TL = t4, this.TR = e3, this.BR = r3, this.BL = n3, this.horizon = i3;
        }
        static fromInvProjectionMatrix(t4, e3, r3) {
          const n3 = [-1, 1, 1], i3 = [1, 1, 1], a4 = [1, -1, 1], s3 = [-1, -1, 1], o3 = O.vec3.transformMat4(n3, n3, t4), l3 = O.vec3.transformMat4(i3, i3, t4), u4 = O.vec3.transformMat4(a4, a4, t4), c3 = O.vec3.transformMat4(s3, s3, t4);
          return new cu(o3, l3, u4, c3, e3 / r3);
        }
      }
      function hu(t4, e3, r3) {
        let n3 = 1 / 0, i3 = -1 / 0;
        const a4 = [];
        for (const s3 of t4) {
          O.vec3.sub(a4, s3, e3);
          const t5 = O.vec3.dot(a4, r3);
          n3 = Math.min(n3, t5), i3 = Math.max(i3, t5);
        }
        return [n3, i3];
      }
      function pu(t4, e3) {
        let r3 = true;
        for (let n3 = 0; n3 < t4.planes.length; n3++) {
          const i3 = t4.planes[n3];
          let a4 = 0;
          for (let t5 = 0; t5 < e3.length; t5++) a4 += O.vec3.dot(i3, e3[t5]) + i3[3] >= 0;
          if (0 === a4) return 0;
          a4 !== e3.length && (r3 = false);
        }
        return r3 ? 2 : 1;
      }
      function fu(t4, e3) {
        for (const r3 of t4.projections) {
          const n3 = hu(e3, t4.points[0], r3.axis);
          if (r3.projection[1] < n3[0] || r3.projection[0] > n3[1]) return 0;
        }
        return 1;
      }
      function du(t4, e3) {
        let r3 = 0;
        const n3 = [0, 0, 0, 0];
        for (let i3 = 0; i3 < t4.length; i3++) n3[0] = t4[i3][0], n3[1] = t4[i3][1], n3[2] = t4[i3][2], n3[3] = 1, O.vec4.dot(n3, e3) >= 0 && r3++;
        return r3;
      }
      class mu {
        constructor(t4, e3) {
          this.points = t4 || new Array(8).fill([0, 0, 0]), this.planes = e3 || new Array(6).fill([0, 0, 0, 0]), this.bounds = yu.fromPoints(this.points), this.projections = [], this.frustumEdges = [O.vec3.sub([], this.points[2], this.points[3]), O.vec3.sub([], this.points[0], this.points[3]), O.vec3.sub([], this.points[4], this.points[0]), O.vec3.sub([], this.points[5], this.points[1]), O.vec3.sub([], this.points[6], this.points[2]), O.vec3.sub([], this.points[7], this.points[3])];
          for (const t5 of this.frustumEdges) {
            const e4 = [0, -t5[2], t5[1]], r3 = [t5[2], 0, -t5[0]];
            this.projections.push({ axis: e4, projection: hu(this.points, this.points[0], e4) }), this.projections.push({ axis: r3, projection: hu(this.points, this.points[0], r3) });
          }
        }
        static fromInvProjectionMatrix(t4, e3, r3, n3) {
          const i3 = Math.pow(2, r3), a4 = [[-1, 1, -1, 1], [1, 1, -1, 1], [1, -1, -1, 1], [-1, -1, -1, 1], [-1, 1, 1, 1], [1, 1, 1, 1], [1, -1, 1, 1], [-1, -1, 1, 1]].map((r4) => {
            const a5 = O.vec4.transformMat4([], r4, t4), s4 = 1 / a5[3] / e3 * i3;
            return O.vec4.mul(a5, a5, [s4, s4, n3 ? 1 / a5[3] : s4, s4]);
          }), s3 = [[0, 1, 2], [6, 5, 4], [0, 3, 7], [2, 1, 5], [3, 2, 6], [0, 4, 5]].map((t5) => {
            const e4 = O.vec3.sub([], a4[t5[0]], a4[t5[1]]), r4 = O.vec3.sub([], a4[t5[2]], a4[t5[1]]), n4 = O.vec3.normalize([], O.vec3.cross([], e4, r4)), i4 = -O.vec3.dot(n4, a4[t5[1]]);
            return n4.concat(i4);
          }), o3 = [];
          for (let t5 = 0; t5 < a4.length; t5++) o3.push([a4[t5][0], a4[t5][1], a4[t5][2]]);
          return new mu(o3, s3);
        }
        intersectsPrecise(t4, e3, r3) {
          for (let r4 = 0; r4 < e3.length; r4++) if (!du(t4, e3[r4])) return 0;
          for (let e4 = 0; e4 < this.planes.length; e4++) if (!du(t4, this.planes[e4])) return 0;
          for (const e4 of r3) for (const r4 of this.frustumEdges) {
            const n3 = O.vec3.cross([], e4, r4), i3 = O.vec3.length(n3);
            if (0 === i3) continue;
            O.vec3.scale(n3, n3, 1 / i3);
            const a4 = hu(this.points, this.points[0], n3), s3 = hu(t4, this.points[0], n3);
            if (a4[0] > s3[1] || s3[0] > a4[1]) return 0;
          }
          return 1;
        }
        containsPoint(t4) {
          for (const e3 of this.planes) {
            const r3 = e3[3];
            if (O.vec3.dot([e3[0], e3[1], e3[2]], t4) + r3 < 0) return false;
          }
          return true;
        }
      }
      class yu {
        static fromPoints(t4) {
          const e3 = [1 / 0, 1 / 0, 1 / 0], r3 = [-1 / 0, -1 / 0, -1 / 0];
          for (const n3 of t4) O.vec3.min(e3, e3, n3), O.vec3.max(r3, r3, n3);
          return new yu(e3, r3);
        }
        static fromTileIdAndHeight(t4, e3, r3) {
          const n3 = 1 << t4.canonical.z, i3 = t4.canonical.x, a4 = t4.canonical.y;
          return new yu([i3 / n3, a4 / n3, e3], [(i3 + 1) / n3, (a4 + 1) / n3, r3]);
        }
        static applyTransform(t4, e3) {
          const r3 = t4.getCorners();
          for (let t5 = 0; t5 < r3.length; ++t5) O.vec3.transformMat4(r3[t5], r3[t5], e3);
          return yu.fromPoints(r3);
        }
        static applyTransformFast(t4, e3) {
          const r3 = [e3[12], e3[13], e3[14]], n3 = [...r3];
          for (let i3 = 0; i3 < 3; i3++) for (let a4 = 0; a4 < 3; a4++) {
            const s3 = e3[4 * a4 + i3], o3 = s3 * t4.min[a4], l3 = s3 * t4.max[a4];
            r3[i3] += Math.min(o3, l3), n3[i3] += Math.max(o3, l3);
          }
          return new yu(r3, n3);
        }
        static projectAabbCorners(t4, e3) {
          const r3 = t4.getCorners();
          for (let t5 = 0; t5 < r3.length; ++t5) O.vec3.transformMat4(r3[t5], r3[t5], e3);
          return r3;
        }
        constructor(t4, e3) {
          this.min = t4, this.max = e3, this.center = O.vec3.scale([], O.vec3.add([], this.min, this.max), 0.5);
        }
        quadrant(t4) {
          const e3 = [t4 % 2 == 0, t4 < 2], r3 = O.vec3.clone(this.min), n3 = O.vec3.clone(this.max);
          for (let t5 = 0; t5 < e3.length; t5++) r3[t5] = e3[t5] ? this.min[t5] : this.center[t5], n3[t5] = e3[t5] ? this.center[t5] : this.max[t5];
          return n3[2] = this.max[2], new yu(r3, n3);
        }
        distanceX(t4) {
          return Math.max(Math.min(this.max[0], t4[0]), this.min[0]) - t4[0];
        }
        distanceY(t4) {
          return Math.max(Math.min(this.max[1], t4[1]), this.min[1]) - t4[1];
        }
        distanceZ(t4) {
          return Math.max(Math.min(this.max[2], t4[2]), this.min[2]) - t4[2];
        }
        getCorners() {
          const t4 = this.min, e3 = this.max;
          return [[t4[0], t4[1], t4[2]], [e3[0], t4[1], t4[2]], [e3[0], e3[1], t4[2]], [t4[0], e3[1], t4[2]], [t4[0], t4[1], e3[2]], [e3[0], t4[1], e3[2]], [e3[0], e3[1], e3[2]], [t4[0], e3[1], e3[2]]];
        }
        intersects(t4) {
          return this.intersectsAabb(t4.bounds) ? pu(t4, this.getCorners()) : 0;
        }
        intersectsFlat(t4) {
          return this.intersectsAabb(t4.bounds) ? pu(t4, [[this.min[0], this.min[1], 0], [this.max[0], this.min[1], 0], [this.max[0], this.max[1], 0], [this.min[0], this.max[1], 0]]) : 0;
        }
        intersectsPrecise(t4, e3) {
          return e3 || this.intersects(t4) ? fu(t4, this.getCorners()) : 0;
        }
        intersectsPreciseFlat(t4, e3) {
          return e3 || this.intersectsFlat(t4) ? fu(t4, [[this.min[0], this.min[1], 0], [this.max[0], this.min[1], 0], [this.max[0], this.max[1], 0], [this.min[0], this.max[1], 0]]) : 0;
        }
        intersectsAabb(t4) {
          for (let e3 = 0; e3 < 3; ++e3) if (this.min[e3] > t4.max[e3] || t4.min[e3] > this.max[e3]) return false;
          return true;
        }
        intersectsAabbXY(t4) {
          return !(this.min[0] > t4.max[0] || t4.min[0] > this.max[0] || this.min[1] > t4.max[1] || t4.min[1] > this.max[1]);
        }
        encapsulate(t4) {
          for (let e3 = 0; e3 < 3; e3++) this.min[e3] = Math.min(this.min[e3], t4.min[e3]), this.max[e3] = Math.max(this.max[e3], t4.max[e3]);
        }
        encapsulatePoint(t4) {
          for (let e3 = 0; e3 < 3; e3++) this.min[e3] = Math.min(this.min[e3], t4[e3]), this.max[e3] = Math.max(this.max[e3], t4[e3]);
        }
        closestPoint(t4) {
          return [Math.max(Math.min(this.max[0], t4[0]), this.min[0]), Math.max(Math.min(this.max[1], t4[1]), this.min[1]), Math.max(Math.min(this.max[2], t4[2]), this.min[2])];
        }
      }
      function gu(t4) {
        return t4 * $o / tl;
      }
      aa(yu, "Aabb");
      const xu = [new yu([Ho, Ho, Ho], [Ko, Ko, Ko]), new yu([Ho, Ho, Ho], [0, 0, Ko]), new yu([0, Ho, Ho], [Ko, 0, Ko]), new yu([Ho, 0, Ho], [0, Ko, Ko]), new yu([0, 0, Ho], [Ko, Ko, Ko])];
      function vu(t4, e3, r3, n3 = true) {
        const i3 = O.vec3.scale([], t4._camera.position, t4.worldSize), a4 = [e3, r3, 1, 1];
        O.vec4.transformMat4(a4, a4, t4.pixelMatrixInverse), O.vec4.scale(a4, a4, 1 / a4[3]);
        const s3 = O.vec3.sub([], a4, i3), o3 = O.vec3.normalize([], s3), l3 = t4.globeMatrix, u4 = [l3[12], l3[13], l3[14]], c3 = O.vec3.sub([], u4, i3), h3 = O.vec3.length(c3), p3 = O.vec3.normalize([], c3), f3 = t4.worldSize / (2 * Math.PI), d3 = O.vec3.dot(p3, o3), m2 = Math.asin(f3 / h3);
        if (m2 < Math.acos(d3)) {
          if (!n3) return null;
          const t5 = [], e4 = [];
          O.vec3.scale(t5, o3, h3 / d3), O.vec3.normalize(e4, O.vec3.sub(e4, t5, c3)), O.vec3.normalize(o3, O.vec3.add(o3, c3, O.vec3.scale(o3, e4, Math.tan(m2) * h3)));
        }
        const y2 = [];
        new uu(i3, o3).closestPointOnSphere(u4, f3, y2);
        const g4 = O.vec3.normalize([], bt(l3, 0)), x2 = O.vec3.normalize([], bt(l3, 1)), v2 = O.vec3.normalize([], bt(l3, 2)), b2 = O.vec3.dot(g4, y2), w2 = O.vec3.dot(x2, y2), _2 = O.vec3.dot(v2, y2), M2 = Z2(Math.asin(-w2 / f3));
        let A3 = Z2(Math.atan2(b2, _2));
        A3 = t4.center.lng + function(t5, e4) {
          const r4 = (e4 - t5 + 180) % 360 - 180;
          return r4 < -180 ? r4 + 360 : r4;
        }(t4.center.lng, A3);
        const S2 = ol(A3), I3 = Q2(ll(M2), 0, 1);
        return new xl(S2, I3);
      }
      class bu {
        constructor(t4, e3, r3) {
          this.a = O.vec3.sub([], t4, r3), this.b = O.vec3.sub([], e3, r3), this.center = r3;
          const n3 = O.vec3.normalize([], this.a), i3 = O.vec3.normalize([], this.b);
          this.angle = Math.acos(O.vec3.dot(n3, i3));
        }
      }
      function wu(t4, e3) {
        if (0 === t4.angle) return null;
        let r3;
        return r3 = 0 === t4.a[e3] ? 1 / t4.angle * 0.5 * Math.PI : 1 / t4.angle * Math.atan(t4.b[e3] / t4.a[e3] / Math.sin(t4.angle) - 1 / Math.tan(t4.angle)), r3 < 0 || r3 > 1 ? null : function(t5, e4, r4, n3) {
          const i3 = Math.sin(r4);
          return t5 * (Math.sin((1 - n3) * r4) / i3) + e4 * (Math.sin(n3 * r4) / i3);
        }(t4.a[e3], t4.b[e3], t4.angle, Q2(r3, 0, 1)) + t4.center[e3];
      }
      function _u(t4) {
        if (t4.z <= 1) return xu[t4.z + 2 * t4.y + t4.x];
        const e3 = zu(Iu(t4));
        return yu.fromPoints(e3);
      }
      function Mu(t4, e3, r3) {
        return O.vec3.scale(t4, t4, 1 - r3), O.vec3.scaleAndAdd(t4, t4, e3, r3);
      }
      function Au(t4, e3, r3) {
        for (const n3 of t4) O.vec3.transformMat4(n3, n3, e3), O.vec3.scale(n3, n3, r3);
      }
      function Su(t4, e3, r3, n3) {
        const i3 = e3 / t4.worldSize, a4 = t4.globeMatrix;
        if (r3.z <= 1) {
          const t5 = _u(r3).getCorners();
          return Au(t5, a4, i3), yu.fromPoints(t5);
        }
        const s3 = Iu(r3, n3), o3 = zu(s3, $o + gu(t4._tileCoverLift));
        Au(o3, a4, i3);
        const l3 = Number.MAX_VALUE, u4 = [-l3, -l3, -l3], c3 = [l3, l3, l3];
        if (s3.contains(t4.center)) {
          for (const t5 of o3) O.vec3.min(c3, c3, t5), O.vec3.max(u4, u4, t5);
          u4[2] = 0;
          const e4 = t4.point, r4 = [e4.x * i3, e4.y * i3, 0];
          return O.vec3.min(c3, c3, r4), O.vec3.max(u4, u4, r4), new yu(c3, u4);
        }
        if (t4._tileCoverLift > 0) {
          for (const t5 of o3) O.vec3.min(c3, c3, t5), O.vec3.max(u4, u4, t5);
          return new yu(c3, u4);
        }
        const h3 = [a4[12] * i3, a4[13] * i3, a4[14] * i3], p3 = s3.getCenter(), f3 = Q2(t4.center.lat, -fl2, fl2), d3 = Q2(p3.lat, -fl2, fl2), m2 = ol(t4.center.lng), y2 = ll(f3);
        let g4 = m2 - ol(p3.lng);
        const x2 = y2 - ll(d3);
        g4 > 0.5 ? g4 -= 1 : g4 < -0.5 && (g4 += 1);
        let v2 = 0;
        if (Math.abs(g4) > Math.abs(x2)) v2 = g4 >= 0 ? 1 : 3;
        else {
          v2 = x2 >= 0 ? 0 : 2;
          const t5 = [a4[4] * i3, a4[5] * i3, a4[6] * i3], e4 = -Math.sin(Y(x2 >= 0 ? s3.getSouth() : s3.getNorth())) * $o;
          O.vec3.scaleAndAdd(h3, h3, t5, e4);
        }
        const b2 = o3[v2], w2 = o3[(v2 + 1) % 4], _2 = new bu(b2, w2, h3), M2 = [wu(_2, 0) || b2[0], wu(_2, 1) || b2[1], wu(_2, 2) || b2[2]], A3 = Du(t4.zoom);
        if (A3 > 0) {
          const n4 = function({ x: t5, y: e4, z: r4 }, n5, i5, a5, s4) {
            const o4 = 1 / (1 << r4);
            let l4 = t5 * o4, u5 = l4 + o4, c4 = e4 * o4, h4 = c4 + o4, p4 = 0;
            const f4 = (l4 + u5) / 2 - a5;
            return f4 > 0.5 ? p4 = -1 : f4 < -0.5 && (p4 = 1), l4 = ((l4 + p4) * n5 - (a5 *= n5)) * i5 + a5, u5 = ((u5 + p4) * n5 - a5) * i5 + a5, c4 = (c4 * n5 - (s4 *= n5)) * i5 + s4, h4 = (h4 * n5 - s4) * i5 + s4, [[l4, h4, 0], [u5, h4, 0], [u5, c4, 0], [l4, c4, 0]];
          }(r3, e3, t4._pixelsPerMercatorPixel, m2, y2);
          for (let t5 = 0; t5 < o3.length; t5++) Mu(o3[t5], n4[t5], A3);
          const i4 = O.vec3.add([], n4[v2], n4[(v2 + 1) % 4]);
          O.vec3.scale(i4, i4, 0.5), Mu(M2, i4, A3);
        }
        for (const t5 of o3) O.vec3.min(c3, c3, t5), O.vec3.max(u4, u4, t5);
        return c3[2] = Math.min(b2[2], w2[2]), O.vec3.min(c3, c3, M2), O.vec3.max(u4, u4, M2), new yu(c3, u4);
      }
      function Iu({ x: t4, y: e3, z: r3 }, n3 = false) {
        const i3 = 1 / (1 << r3), a4 = new rl(cl(t4 * i3), e3 === (1 << r3) - 1 && n3 ? -90 : hl((e3 + 1) * i3)), s3 = new rl(cl((t4 + 1) * i3), 0 === e3 && n3 ? 90 : hl(e3 * i3));
        return new nl(a4, s3);
      }
      function zu(t4, e3 = $o) {
        const r3 = Y(t4.getNorth()), n3 = Y(t4.getSouth()), i3 = Math.cos(r3), a4 = Math.cos(n3), s3 = Math.sin(r3), o3 = Math.sin(n3), l3 = t4.getWest(), u4 = t4.getEast();
        return [Jo(a4, o3, l3, e3), Jo(a4, o3, u4, e3), Jo(i3, s3, u4, e3), Jo(i3, s3, l3, e3)];
      }
      function Pu(t4, e3, r3, n3) {
        const i3 = 1 << r3.z, a4 = (t4 / Wr + r3.x) / i3;
        return Qo(hl((e3 / Wr + r3.y) / i3), cl(a4), n3);
      }
      function ku({ min: t4, max: e3 }) {
        return Yo / Math.max(e3[0] - t4[0], e3[1] - t4[1], e3[2] - t4[2]);
      }
      const Tu = new Float64Array(16);
      function Eu(t4) {
        const e3 = ku(t4), r3 = O.mat4.fromScaling(Tu, [e3, e3, e3]);
        return O.mat4.translate(r3, r3, O.vec3.negate([], t4.min));
      }
      function Bu(t4) {
        const e3 = O.mat4.fromTranslation(Tu, t4.min), r3 = 1 / ku(t4);
        return O.mat4.scale(e3, e3, [r3, r3, r3]);
      }
      function Vu(t4) {
        const e3 = Wr / (2 * Math.PI);
        return t4 / (2 * Math.PI) / e3;
      }
      function Cu(t4, e3) {
        return Wr / (512 * Math.pow(2, t4)) * ku(_u(e3));
      }
      function Ru(t4, e3, r3, n3, i3) {
        const a4 = Vu(r3), s3 = [t4, e3, -r3 / (2 * Math.PI)], o3 = O.mat4.identity(new Float64Array(16));
        return O.mat4.translate(o3, o3, s3), O.mat4.scale(o3, o3, [a4, a4, a4]), O.mat4.rotateX(o3, o3, Y(-i3)), O.mat4.rotateY(o3, o3, Y(-n3)), o3;
      }
      function Du(t4) {
        return tt(Go, Xo, t4);
      }
      function Lu(t4, e3) {
        const r3 = Qo(e3.lat, e3.lng), n3 = function(t5) {
          const e4 = Qo(t5._center.lat, t5._center.lng), r4 = O.vec3.fromValues(0, 1, 0);
          let n4 = O.vec3.cross([], r4, e4);
          const i4 = O.mat4.fromRotation([], -t5.angle, e4);
          n4 = O.vec3.transformMat4(n4, n4, i4), O.mat4.fromRotation(i4, -t5._pitch, n4);
          const a4 = O.vec3.normalize([], e4);
          return O.vec3.scale(a4, a4, gu(t5.cameraToCenterDistance / t5.pixelsPerMeter)), O.vec3.transformMat4(a4, a4, i4), O.vec3.add([], e4, a4);
        }(t4), i3 = O.vec3.subtract([], n3, r3);
        return O.vec3.angle(i3, r3);
      }
      function Fu(t4, e3) {
        return Lu(t4, e3) > Math.PI / 2 * 1.01;
      }
      const Ou = Y(85), Uu = Math.cos(Ou), ju = Math.sin(Ou), Nu = O.mat4.create(), qu = (t4) => {
        const e3 = [];
        return "map" === t4.paint.get("circle-pitch-alignment") && e3.push("PITCH_WITH_MAP"), "map" === t4.paint.get("circle-pitch-scale") && e3.push("SCALE_WITH_MAP"), e3;
      };
      function $u(t4, e3, r3, n3, i3, a4, s3, o3, l3) {
        if (a4 && t4.queryGeometry.isAboveHorizon) return false;
        a4 && (l3 *= t4.pixelToTileUnitsFactor);
        const u4 = t4.tileID.canonical, c3 = r3.projection.upVectorScale(u4, r3.center.lat, r3.worldSize).metersToTile;
        for (const h3 of e3) for (const e4 of h3) {
          const h4 = e4.add(o3), p3 = i3 && r3.elevation ? r3.elevation.exaggeration() * i3.getElevationAt(h4.x, h4.y, true) : 0, f3 = r3.projection.projectTilePoint(h4.x, h4.y, u4);
          if (p3 > 0) {
            const t5 = r3.projection.upVector(u4, h4.x, h4.y);
            f3.x += t5[0] * c3 * p3, f3.y += t5[1] * c3 * p3, f3.z += t5[2] * c3 * p3;
          }
          const d3 = a4 ? h4 : Gu(f3.x, f3.y, f3.z, n3), m2 = a4 ? t4.tilespaceRays.map((t5) => Zu(t5, p3)) : t4.queryGeometry.screenGeometry, y2 = O.vec4.transformMat4([], [f3.x, f3.y, f3.z, 1], n3);
          if (!s3 && a4 ? l3 *= y2[3] / r3.cameraToCenterDistance : s3 && !a4 && (l3 *= r3.cameraToCenterDistance / y2[3]), a4) {
            const t5 = hl((e4.y / Wr + u4.y) / (1 << u4.z));
            l3 /= r3.projection.pixelsPerMeter(t5, 1) / ul(1, t5);
          }
          if (Bl(m2, d3, l3)) return true;
        }
        return false;
      }
      function Gu(t4, e3, r3, n3) {
        const i3 = O.vec4.transformMat4([], [t4, e3, r3, 1], n3);
        return new q(i3[0] / i3[3], i3[1] / i3[3]);
      }
      const Xu = O.vec3.fromValues(0, 0, 0), Yu = O.vec3.fromValues(0, 0, 1);
      function Zu(t4, e3) {
        const r3 = O.vec3.create();
        return Xu[2] = e3, t4.intersectsPlane(Xu, Yu, r3), new q(r3[0], r3[1]);
      }
      class Wu extends Tl {
      }
      let Hu, Ku, Ju, Qu;
      function tc(t4, { width: e3, height: r3 }, n3, i3) {
        if (i3) {
          if (i3 instanceof Uint8ClampedArray) i3 = new Uint8Array(i3.buffer);
          else if (i3.length !== e3 * r3 * n3) throw new RangeError("mismatched image size");
        } else i3 = new Uint8Array(e3 * r3 * n3);
        return t4.width = e3, t4.height = r3, t4.data = i3, t4;
      }
      function ec2(t4, e3, r3) {
        const { width: n3, height: i3 } = e3;
        n3 === t4.width && i3 === t4.height || (rc(t4, e3, { x: 0, y: 0 }, { x: 0, y: 0 }, { width: Math.min(t4.width, n3), height: Math.min(t4.height, i3) }, r3, null), t4.width = n3, t4.height = i3, t4.data = e3.data);
      }
      function rc(t4, e3, r3, n3, i3, a4, s3, o3) {
        if (0 === i3.width || 0 === i3.height) return e3;
        if (i3.width > t4.width || i3.height > t4.height || r3.x > t4.width - i3.width || r3.y > t4.height - i3.height) throw new RangeError("out of range source coordinates for image copy");
        if (i3.width > e3.width || i3.height > e3.height || n3.x > e3.width - i3.width || n3.y > e3.height - i3.height) throw new RangeError("out of range destination coordinates for image copy");
        const l3 = t4.data, u4 = e3.data, c3 = 4 === a4 && o3;
        for (let o4 = 0; o4 < i3.height; o4++) {
          const h3 = ((r3.y + o4) * t4.width + r3.x) * a4, p3 = ((n3.y + o4) * e3.width + n3.x) * a4;
          if (c3) for (let t5 = 0; t5 < i3.width; t5++) {
            const e4 = h3 + t5 * a4 + 3, r4 = p3 + t5 * a4;
            u4[r4 + 0] = 255, u4[r4 + 1] = 255, u4[r4 + 2] = 255, u4[r4 + 3] = l3[e4];
          }
          else if (s3) for (let t5 = 0; t5 < i3.width; t5++) {
            const e4 = h3 + t5 * a4, r4 = p3 + t5 * a4, n4 = l3[e4 + 3], i4 = new Ie(l3[e4 + 0] / 255 * n4, l3[e4 + 1] / 255 * n4, l3[e4 + 2] / 255 * n4, n4).toRenderColor(s3).toArray();
            u4[r4 + 0] = i4[0], u4[r4 + 1] = i4[1], u4[r4 + 2] = i4[2], u4[r4 + 3] = i4[3];
          }
          else for (let t5 = 0; t5 < i3.width * a4; t5++) u4[p3 + t5] = l3[h3 + t5];
        }
        return e3;
      }
      aa(Wu, "HeatmapBucket", { omit: ["layers"] });
      class nc {
        constructor(t4, e3) {
          tc(this, t4, 1, e3);
        }
        resize(t4) {
          ec2(this, new nc(t4), 1);
        }
        clone() {
          return new nc({ width: this.width, height: this.height }, new Uint8Array(this.data));
        }
        static copy(t4, e3, r3, n3, i3) {
          rc(t4, e3, r3, n3, i3, 1, null);
        }
      }
      class ic {
        constructor(t4, e3) {
          tc(this, t4, 4, e3);
        }
        resize(t4) {
          ec2(this, new ic(t4), 4);
        }
        replace(t4, e3) {
          e3 ? this.data.set(t4) : this.data = t4 instanceof Uint8ClampedArray ? new Uint8Array(t4.buffer) : t4;
        }
        clone() {
          return new ic({ width: this.width, height: this.height }, new Uint8Array(this.data));
        }
        static copy(t4, e3, r3, n3, i3, a4, s3) {
          rc(t4, e3, r3, n3, i3, 4, a4, s3);
        }
      }
      class ac {
        constructor(t4, e3) {
          this.width = t4.width, this.height = t4.height, this.data = e3 instanceof Uint8Array ? new Float32Array(e3.buffer) : e3;
        }
      }
      function sc(t4) {
        const e3 = {}, r3 = t4.resolution || 256, n3 = t4.clips ? t4.clips.length : 1, i3 = t4.image || new ic({ width: r3, height: n3 }), a4 = (r4, n4, a5) => {
          e3[t4.evaluationKey] = a5;
          const s3 = t4.expression.evaluate(e3);
          s3 && (i3.data[r4 + n4 + 0] = Math.floor(255 * s3.r / s3.a), i3.data[r4 + n4 + 1] = Math.floor(255 * s3.g / s3.a), i3.data[r4 + n4 + 2] = Math.floor(255 * s3.b / s3.a), i3.data[r4 + n4 + 3] = Math.floor(255 * s3.a));
        };
        if (t4.clips) for (let e4 = 0, i4 = 0; e4 < n3; ++e4, i4 += 4 * r3) for (let n4 = 0, s3 = 0; n4 < r3; n4++, s3 += 4) {
          const o3 = n4 / (r3 - 1), { start: l3, end: u4 } = t4.clips[e4];
          a4(i4, s3, l3 * (1 - o3) + u4 * o3);
        }
        else for (let t5 = 0, e4 = 0; t5 < r3; t5++, e4 += 4) a4(0, e4, t5 / (r3 - 1));
        return i3;
      }
      aa(nc, "AlphaImage"), aa(ic, "RGBAImage");
      const oc = ds([{ name: "a_pos", components: 2, type: "Int16" }], 4), { members: lc } = oc;
      function uc(t4, e3, r3 = 2) {
        const n3 = e3 && e3.length, i3 = n3 ? e3[0] * r3 : t4.length;
        let a4 = cc(t4, 0, i3, r3, true);
        const s3 = [];
        if (!a4 || a4.next === a4.prev) return s3;
        let o3, l3, u4;
        if (n3 && (a4 = function(t5, e4, r4, n4) {
          const i4 = [];
          for (let r5 = 0, a5 = e4.length; r5 < a5; r5++) {
            const s4 = cc(t5, e4[r5] * n4, r5 < a5 - 1 ? e4[r5 + 1] * n4 : t5.length, n4, false);
            s4 === s4.next && (s4.steiner = true), i4.push(wc(s4));
          }
          i4.sort(gc);
          for (let t6 = 0; t6 < i4.length; t6++) r4 = xc(i4[t6], r4);
          return r4;
        }(t4, e3, a4, r3)), t4.length > 80 * r3) {
          o3 = 1 / 0, l3 = 1 / 0;
          let e4 = -1 / 0, n4 = -1 / 0;
          for (let a5 = r3; a5 < i3; a5 += r3) {
            const r4 = t4[a5], i4 = t4[a5 + 1];
            r4 < o3 && (o3 = r4), i4 < l3 && (l3 = i4), r4 > e4 && (e4 = r4), i4 > n4 && (n4 = i4);
          }
          u4 = Math.max(e4 - o3, n4 - l3), u4 = 0 !== u4 ? 32767 / u4 : 0;
        }
        return pc(a4, s3, r3, o3, l3, u4, 0), s3;
      }
      function cc(t4, e3, r3, n3, i3) {
        let a4;
        if (i3 === function(t5, e4, r4, n4) {
          let i4 = 0;
          for (let a5 = e4, s3 = r4 - n4; a5 < r4; a5 += n4) i4 += (t5[s3] - t5[a5]) * (t5[a5 + 1] + t5[s3 + 1]), s3 = a5;
          return i4;
        }(t4, e3, r3, n3) > 0) for (let i4 = e3; i4 < r3; i4 += n3) a4 = Ec(i4 / n3 | 0, t4[i4], t4[i4 + 1], a4);
        else for (let i4 = r3 - n3; i4 >= e3; i4 -= n3) a4 = Ec(i4 / n3 | 0, t4[i4], t4[i4 + 1], a4);
        return a4 && Sc(a4, a4.next) && (Bc(a4), a4 = a4.next), a4;
      }
      function hc(t4, e3) {
        if (!t4) return t4;
        e3 || (e3 = t4);
        let r3, n3 = t4;
        do {
          if (r3 = false, n3.steiner || !Sc(n3, n3.next) && 0 !== Ac(n3.prev, n3, n3.next)) n3 = n3.next;
          else {
            if (Bc(n3), n3 = e3 = n3.prev, n3 === n3.next) break;
            r3 = true;
          }
        } while (r3 || n3 !== e3);
        return e3;
      }
      function pc(t4, e3, r3, n3, i3, a4, s3) {
        if (!t4) return;
        !s3 && a4 && function(t5, e4, r4, n4) {
          let i4 = t5;
          do {
            0 === i4.z && (i4.z = bc(i4.x, i4.y, e4, r4, n4)), i4.prevZ = i4.prev, i4.nextZ = i4.next, i4 = i4.next;
          } while (i4 !== t5);
          i4.prevZ.nextZ = null, i4.prevZ = null, function(t6) {
            let e5, r5 = 1;
            do {
              let n5, i5 = t6;
              t6 = null;
              let a5 = null;
              for (e5 = 0; i5; ) {
                e5++;
                let s4 = i5, o4 = 0;
                for (let t7 = 0; t7 < r5 && (o4++, s4 = s4.nextZ, s4); t7++) ;
                let l3 = r5;
                for (; o4 > 0 || l3 > 0 && s4; ) 0 !== o4 && (0 === l3 || !s4 || i5.z <= s4.z) ? (n5 = i5, i5 = i5.nextZ, o4--) : (n5 = s4, s4 = s4.nextZ, l3--), a5 ? a5.nextZ = n5 : t6 = n5, n5.prevZ = a5, a5 = n5;
                i5 = s4;
              }
              a5.nextZ = null, r5 *= 2;
            } while (e5 > 1);
          }(i4);
        }(t4, n3, i3, a4);
        let o3 = t4;
        for (; t4.prev !== t4.next; ) {
          const l3 = t4.prev, u4 = t4.next;
          if (a4 ? dc(t4, n3, i3, a4) : fc(t4)) e3.push(l3.i, t4.i, u4.i), Bc(t4), t4 = u4.next, o3 = u4.next;
          else if ((t4 = u4) === o3) {
            s3 ? 1 === s3 ? pc(t4 = mc2(hc(t4), e3), e3, r3, n3, i3, a4, 2) : 2 === s3 && yc(t4, e3, r3, n3, i3, a4) : pc(hc(t4), e3, r3, n3, i3, a4, 1);
            break;
          }
        }
      }
      function fc(t4) {
        const e3 = t4.prev, r3 = t4, n3 = t4.next;
        if (Ac(e3, r3, n3) >= 0) return false;
        const i3 = e3.x, a4 = r3.x, s3 = n3.x, o3 = e3.y, l3 = r3.y, u4 = n3.y, c3 = i3 < a4 ? i3 < s3 ? i3 : s3 : a4 < s3 ? a4 : s3, h3 = o3 < l3 ? o3 < u4 ? o3 : u4 : l3 < u4 ? l3 : u4, p3 = i3 > a4 ? i3 > s3 ? i3 : s3 : a4 > s3 ? a4 : s3, f3 = o3 > l3 ? o3 > u4 ? o3 : u4 : l3 > u4 ? l3 : u4;
        let d3 = n3.next;
        for (; d3 !== e3; ) {
          if (d3.x >= c3 && d3.x <= p3 && d3.y >= h3 && d3.y <= f3 && _c(i3, o3, a4, l3, s3, u4, d3.x, d3.y) && Ac(d3.prev, d3, d3.next) >= 0) return false;
          d3 = d3.next;
        }
        return true;
      }
      function dc(t4, e3, r3, n3) {
        const i3 = t4.prev, a4 = t4, s3 = t4.next;
        if (Ac(i3, a4, s3) >= 0) return false;
        const o3 = i3.x, l3 = a4.x, u4 = s3.x, c3 = i3.y, h3 = a4.y, p3 = s3.y, f3 = o3 < l3 ? o3 < u4 ? o3 : u4 : l3 < u4 ? l3 : u4, d3 = c3 < h3 ? c3 < p3 ? c3 : p3 : h3 < p3 ? h3 : p3, m2 = o3 > l3 ? o3 > u4 ? o3 : u4 : l3 > u4 ? l3 : u4, y2 = c3 > h3 ? c3 > p3 ? c3 : p3 : h3 > p3 ? h3 : p3, g4 = bc(f3, d3, e3, r3, n3), x2 = bc(m2, y2, e3, r3, n3);
        let v2 = t4.prevZ, b2 = t4.nextZ;
        for (; v2 && v2.z >= g4 && b2 && b2.z <= x2; ) {
          if (v2.x >= f3 && v2.x <= m2 && v2.y >= d3 && v2.y <= y2 && v2 !== i3 && v2 !== s3 && _c(o3, c3, l3, h3, u4, p3, v2.x, v2.y) && Ac(v2.prev, v2, v2.next) >= 0) return false;
          if (v2 = v2.prevZ, b2.x >= f3 && b2.x <= m2 && b2.y >= d3 && b2.y <= y2 && b2 !== i3 && b2 !== s3 && _c(o3, c3, l3, h3, u4, p3, b2.x, b2.y) && Ac(b2.prev, b2, b2.next) >= 0) return false;
          b2 = b2.nextZ;
        }
        for (; v2 && v2.z >= g4; ) {
          if (v2.x >= f3 && v2.x <= m2 && v2.y >= d3 && v2.y <= y2 && v2 !== i3 && v2 !== s3 && _c(o3, c3, l3, h3, u4, p3, v2.x, v2.y) && Ac(v2.prev, v2, v2.next) >= 0) return false;
          v2 = v2.prevZ;
        }
        for (; b2 && b2.z <= x2; ) {
          if (b2.x >= f3 && b2.x <= m2 && b2.y >= d3 && b2.y <= y2 && b2 !== i3 && b2 !== s3 && _c(o3, c3, l3, h3, u4, p3, b2.x, b2.y) && Ac(b2.prev, b2, b2.next) >= 0) return false;
          b2 = b2.nextZ;
        }
        return true;
      }
      function mc2(t4, e3) {
        let r3 = t4;
        do {
          const n3 = r3.prev, i3 = r3.next.next;
          !Sc(n3, i3) && Ic(n3, r3, r3.next, i3) && kc(n3, i3) && kc(i3, n3) && (e3.push(n3.i, r3.i, i3.i), Bc(r3), Bc(r3.next), r3 = t4 = i3), r3 = r3.next;
        } while (r3 !== t4);
        return hc(r3);
      }
      function yc(t4, e3, r3, n3, i3, a4) {
        let s3 = t4;
        do {
          let t5 = s3.next.next;
          for (; t5 !== s3.prev; ) {
            if (s3.i !== t5.i && Mc(s3, t5)) {
              let o3 = Tc(s3, t5);
              return s3 = hc(s3, s3.next), o3 = hc(o3, o3.next), pc(s3, e3, r3, n3, i3, a4, 0), void pc(o3, e3, r3, n3, i3, a4, 0);
            }
            t5 = t5.next;
          }
          s3 = s3.next;
        } while (s3 !== t4);
      }
      function gc(t4, e3) {
        return t4.x - e3.x;
      }
      function xc(t4, e3) {
        const r3 = function(t5, e4) {
          let r4 = e4;
          const n4 = t5.x, i3 = t5.y;
          let a4, s3 = -1 / 0;
          do {
            if (i3 <= r4.y && i3 >= r4.next.y && r4.next.y !== r4.y) {
              const t6 = r4.x + (i3 - r4.y) * (r4.next.x - r4.x) / (r4.next.y - r4.y);
              if (t6 <= n4 && t6 > s3 && (s3 = t6, a4 = r4.x < r4.next.x ? r4 : r4.next, t6 === n4)) return a4;
            }
            r4 = r4.next;
          } while (r4 !== e4);
          if (!a4) return null;
          const o3 = a4, l3 = a4.x, u4 = a4.y;
          let c3 = 1 / 0;
          r4 = a4;
          do {
            if (n4 >= r4.x && r4.x >= l3 && n4 !== r4.x && _c(i3 < u4 ? n4 : s3, i3, l3, u4, i3 < u4 ? s3 : n4, i3, r4.x, r4.y)) {
              const e5 = Math.abs(i3 - r4.y) / (n4 - r4.x);
              kc(r4, t5) && (e5 < c3 || e5 === c3 && (r4.x > a4.x || r4.x === a4.x && vc(a4, r4))) && (a4 = r4, c3 = e5);
            }
            r4 = r4.next;
          } while (r4 !== o3);
          return a4;
        }(t4, e3);
        if (!r3) return e3;
        const n3 = Tc(r3, t4);
        return hc(n3, n3.next), hc(r3, r3.next);
      }
      function vc(t4, e3) {
        return Ac(t4.prev, t4, e3.prev) < 0 && Ac(e3.next, t4, t4.next) < 0;
      }
      function bc(t4, e3, r3, n3, i3) {
        return (t4 = 1431655765 & ((t4 = 858993459 & ((t4 = 252645135 & ((t4 = 16711935 & ((t4 = (t4 - r3) * i3 | 0) | t4 << 8)) | t4 << 4)) | t4 << 2)) | t4 << 1)) | (e3 = 1431655765 & ((e3 = 858993459 & ((e3 = 252645135 & ((e3 = 16711935 & ((e3 = (e3 - n3) * i3 | 0) | e3 << 8)) | e3 << 4)) | e3 << 2)) | e3 << 1)) << 1;
      }
      function wc(t4) {
        let e3 = t4, r3 = t4;
        do {
          (e3.x < r3.x || e3.x === r3.x && e3.y < r3.y) && (r3 = e3), e3 = e3.next;
        } while (e3 !== t4);
        return r3;
      }
      function _c(t4, e3, r3, n3, i3, a4, s3, o3) {
        return (i3 - s3) * (e3 - o3) >= (t4 - s3) * (a4 - o3) && (t4 - s3) * (n3 - o3) >= (r3 - s3) * (e3 - o3) && (r3 - s3) * (a4 - o3) >= (i3 - s3) * (n3 - o3);
      }
      function Mc(t4, e3) {
        return t4.next.i !== e3.i && t4.prev.i !== e3.i && !function(t5, e4) {
          let r3 = t5;
          do {
            if (r3.i !== t5.i && r3.next.i !== t5.i && r3.i !== e4.i && r3.next.i !== e4.i && Ic(r3, r3.next, t5, e4)) return true;
            r3 = r3.next;
          } while (r3 !== t5);
          return false;
        }(t4, e3) && (kc(t4, e3) && kc(e3, t4) && function(t5, e4) {
          let r3 = t5, n3 = false;
          const i3 = (t5.x + e4.x) / 2, a4 = (t5.y + e4.y) / 2;
          do {
            r3.y > a4 != r3.next.y > a4 && r3.next.y !== r3.y && i3 < (r3.next.x - r3.x) * (a4 - r3.y) / (r3.next.y - r3.y) + r3.x && (n3 = !n3), r3 = r3.next;
          } while (r3 !== t5);
          return n3;
        }(t4, e3) && (Ac(t4.prev, t4, e3.prev) || Ac(t4, e3.prev, e3)) || Sc(t4, e3) && Ac(t4.prev, t4, t4.next) > 0 && Ac(e3.prev, e3, e3.next) > 0);
      }
      function Ac(t4, e3, r3) {
        return (e3.y - t4.y) * (r3.x - e3.x) - (e3.x - t4.x) * (r3.y - e3.y);
      }
      function Sc(t4, e3) {
        return t4.x === e3.x && t4.y === e3.y;
      }
      function Ic(t4, e3, r3, n3) {
        const i3 = Pc(Ac(t4, e3, r3)), a4 = Pc(Ac(t4, e3, n3)), s3 = Pc(Ac(r3, n3, t4)), o3 = Pc(Ac(r3, n3, e3));
        return i3 !== a4 && s3 !== o3 || !(0 !== i3 || !zc(t4, r3, e3)) || !(0 !== a4 || !zc(t4, n3, e3)) || !(0 !== s3 || !zc(r3, t4, n3)) || !(0 !== o3 || !zc(r3, e3, n3));
      }
      function zc(t4, e3, r3) {
        return e3.x <= Math.max(t4.x, r3.x) && e3.x >= Math.min(t4.x, r3.x) && e3.y <= Math.max(t4.y, r3.y) && e3.y >= Math.min(t4.y, r3.y);
      }
      function Pc(t4) {
        return t4 > 0 ? 1 : t4 < 0 ? -1 : 0;
      }
      function kc(t4, e3) {
        return Ac(t4.prev, t4, t4.next) < 0 ? Ac(t4, e3, t4.next) >= 0 && Ac(t4, t4.prev, e3) >= 0 : Ac(t4, e3, t4.prev) < 0 || Ac(t4, t4.next, e3) < 0;
      }
      function Tc(t4, e3) {
        const r3 = Vc(t4.i, t4.x, t4.y), n3 = Vc(e3.i, e3.x, e3.y), i3 = t4.next, a4 = e3.prev;
        return t4.next = e3, e3.prev = t4, r3.next = i3, i3.prev = r3, n3.next = r3, r3.prev = n3, a4.next = n3, n3.prev = a4, n3;
      }
      function Ec(t4, e3, r3, n3) {
        const i3 = Vc(t4, e3, r3);
        return n3 ? (i3.next = n3.next, i3.prev = n3, n3.next.prev = i3, n3.next = i3) : (i3.prev = i3, i3.next = i3), i3;
      }
      function Bc(t4) {
        t4.next.prev = t4.prev, t4.prev.next = t4.next, t4.prevZ && (t4.prevZ.nextZ = t4.nextZ), t4.nextZ && (t4.nextZ.prevZ = t4.prevZ);
      }
      function Vc(t4, e3, r3) {
        return { i: t4, x: e3, y: r3, prev: null, next: null, z: 0, prevZ: null, nextZ: null, steiner: false };
      }
      function Cc(t4, e3) {
        const r3 = t4.length;
        if (r3 <= 1) return [t4];
        const n3 = [];
        let i3, a4;
        for (let e4 = 0; e4 < r3; e4++) {
          const r4 = mt(t4[e4]);
          0 !== r4 && (t4[e4].area = Math.abs(r4), void 0 === a4 && (a4 = r4 < 0), a4 === r4 < 0 ? (i3 && n3.push(i3), i3 = [t4[e4]]) : i3.push(t4[e4]));
        }
        if (i3 && n3.push(i3), e3 > 1) for (let t5 = 0; t5 < n3.length; t5++) n3[t5].length <= e3 || (xr(n3[t5], e3, 1, n3[t5].length - 1, Rc), n3[t5] = n3[t5].slice(0, e3));
        return n3;
      }
      function Rc(t4, e3) {
        return e3.area - t4.area;
      }
      function Dc(t4, e3, r3) {
        const n3 = r3.patternDependencies;
        let i3 = false;
        for (const r4 of e3) {
          const e4 = r4.paint.get(`${t4}-pattern`);
          e4.isConstant() || (i3 = true);
          const a4 = e4.constantOr(null);
          a4 && (i3 = true, n3[a4] = true);
        }
        return i3;
      }
      function Lc(t4, e3, r3, n3, i3) {
        const a4 = i3.patternDependencies;
        for (const s3 of e3) {
          const e4 = s3.paint.get(`${t4}-pattern`).value;
          if ("constant" !== e4.kind) {
            let t5 = e4.evaluate({ zoom: n3 }, r3, {}, i3.availableImages);
            t5 = t5 && t5.name ? t5.name : t5, a4[t5] = true, r3.patterns[s3.id] = t5;
          }
        }
        return r3;
      }
      class Fc {
        constructor(t4) {
          this.zoom = t4.zoom, this.overscaling = t4.overscaling, this.layers = t4.layers, this.layerIds = this.layers.map((t5) => t5.fqid), this.index = t4.index, this.hasPattern = false, this.patternFeatures = [], this.layoutVertexArray = new ys(), this.indexArray = new Cs(), this.indexArray2 = new ks(), this.programConfigurations = new Fo(t4.layers, { zoom: t4.zoom, lut: t4.lut }), this.segments = new co(), this.segments2 = new co(), this.stateDependentLayerIds = this.layers.filter((t5) => t5.isStateDependent()).map((t5) => t5.id), this.projection = t4.projection;
        }
        updateFootprints(t4, e3) {
        }
        populate(t4, e3, r3, n3) {
          this.hasPattern = Dc("fill", this.layers, e3);
          const i3 = this.layers[0].layout.get("fill-sort-key"), a4 = [];
          for (const { feature: s3, id: o3, index: l3, sourceLayerIndex: u4 } of t4) {
            const t5 = this.layers[0]._featureFilter.needGeometry, c3 = zl(s3, t5);
            if (!this.layers[0]._featureFilter.filter(new Ea(this.zoom), c3, r3)) continue;
            const h3 = i3 ? i3.evaluate(c3, {}, r3, e3.availableImages) : void 0, p3 = { id: o3, properties: s3.properties, type: s3.type, sourceLayerIndex: u4, index: l3, geometry: t5 ? c3.geometry : Il(s3, r3, n3), patterns: {}, sortKey: h3 };
            a4.push(p3);
          }
          i3 && a4.sort((t5, e4) => t5.sortKey - e4.sortKey);
          for (const n4 of a4) {
            const { geometry: i4, index: a5, sourceLayerIndex: s3 } = n4;
            if (this.hasPattern) {
              const t5 = Lc("fill", this.layers, n4, this.zoom, e3);
              this.patternFeatures.push(t5);
            } else this.addFeature(n4, i4, a5, r3, {}, e3.availableImages, e3.brightness);
            e3.featureIndex.insert(t4[a5].feature, i4, a5, s3, this.index);
          }
        }
        update(t4, e3, r3, n3, i3) {
          const a4 = 0 !== Object.keys(t4).length;
          a4 && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(t4, e3, a4 ? this.stateDependentLayers : this.layers, r3, n3, i3);
        }
        addFeatures(t4, e3, r3, n3, i3, a4) {
          for (const t5 of this.patternFeatures) this.addFeature(t5, t5.geometry, t5.index, e3, r3, n3, a4);
        }
        isEmpty() {
          return 0 === this.layoutVertexArray.length;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(t4) {
          this.uploaded || (this.layoutVertexBuffer = t4.createVertexBuffer(this.layoutVertexArray, lc), this.indexBuffer = t4.createIndexBuffer(this.indexArray), this.indexBuffer2 = t4.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t4), this.uploaded = true;
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
        }
        addFeature(t4, e3, r3, n3, i3, a4 = [], s3) {
          for (const t5 of Cc(e3, 500)) {
            let e4 = 0;
            for (const r5 of t5) e4 += r5.length;
            const r4 = this.segments.prepareSegment(e4, this.layoutVertexArray, this.indexArray), n4 = r4.vertexLength, i4 = [], a5 = [];
            for (const e5 of t5) {
              if (0 === e5.length) continue;
              e5 !== t5[0] && a5.push(i4.length / 2);
              const r5 = this.segments2.prepareSegment(e5.length, this.layoutVertexArray, this.indexArray2), n5 = r5.vertexLength;
              this.layoutVertexArray.emplaceBack(e5[0].x, e5[0].y), this.indexArray2.emplaceBack(n5 + e5.length - 1, n5), i4.push(e5[0].x), i4.push(e5[0].y);
              for (let t6 = 1; t6 < e5.length; t6++) this.layoutVertexArray.emplaceBack(e5[t6].x, e5[t6].y), this.indexArray2.emplaceBack(n5 + t6 - 1, n5 + t6), i4.push(e5[t6].x), i4.push(e5[t6].y);
              r5.vertexLength += e5.length, r5.primitiveLength += e5.length;
            }
            const s4 = uc(i4, a5);
            for (let t6 = 0; t6 < s4.length; t6 += 3) this.indexArray.emplaceBack(n4 + s4[t6], n4 + s4[t6 + 1], n4 + s4[t6 + 2]);
            r4.vertexLength += e4, r4.primitiveLength += s4.length / 3;
          }
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t4, r3, i3, a4, n3, s3);
        }
      }
      let Oc, Uc, jc, Nc;
      aa(Fc, "FillBucket", { omit: ["layers", "patternFeatures"] });
      class qc {
        constructor(t4, e3, r3, n3) {
          if (this.triangleCount = e3.length / 3, this.min = new q(0, 0), this.max = new q(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cells = [], this.payload = [], 0 === this.triangleCount || 0 === t4.length) return;
          const [i3, a4] = [t4[0].clone(), t4[0].clone()];
          for (let e4 = 1; e4 < t4.length; ++e4) {
            const r4 = t4[e4];
            i3.x = Math.min(i3.x, r4.x), i3.y = Math.min(i3.y, r4.y), a4.x = Math.max(a4.x, r4.x), a4.y = Math.max(a4.y, r4.y);
          }
          if (n3) {
            const t5 = Math.ceil(Math.max(a4.x - i3.x, a4.y - i3.y) / n3);
            r3 = Math.max(r3, t5);
          }
          if (0 === r3) return;
          this.min = i3, this.max = a4;
          const s3 = this.max.sub(this.min);
          s3.x = Math.max(s3.x, 1), s3.y = Math.max(s3.y, 1);
          const o3 = Math.max(s3.x, s3.y) / r3;
          this.cellsX = Math.max(1, Math.ceil(s3.x / o3)), this.cellsY = Math.max(1, Math.ceil(s3.y / o3)), this.xScale = 1 / o3, this.yScale = 1 / o3;
          const l3 = [];
          for (let r4 = 0; r4 < this.triangleCount; r4++) {
            const n4 = t4[e3[3 * r4 + 0]].sub(this.min), i4 = t4[e3[3 * r4 + 1]].sub(this.min), a5 = t4[e3[3 * r4 + 2]].sub(this.min), s4 = $c(Math.floor(Math.min(n4.x, i4.x, a5.x)), this.xScale, this.cellsX), u5 = $c(Math.floor(Math.max(n4.x, i4.x, a5.x)), this.xScale, this.cellsX), c3 = $c(Math.floor(Math.min(n4.y, i4.y, a5.y)), this.yScale, this.cellsY), h3 = $c(Math.floor(Math.max(n4.y, i4.y, a5.y)), this.yScale, this.cellsY), p3 = new q(0, 0), f3 = new q(0, 0), d3 = new q(0, 0), m2 = new q(0, 0);
            for (let t5 = c3; t5 <= h3; ++t5) {
              p3.y = f3.y = t5 * o3, d3.y = m2.y = (t5 + 1) * o3;
              for (let e4 = s4; e4 <= u5; ++e4) p3.x = d3.x = e4 * o3, f3.x = m2.x = (e4 + 1) * o3, ($l(n4, i4, a5, p3, f3, m2) || $l(n4, i4, a5, p3, m2, d3)) && l3.push({ cellIdx: t5 * this.cellsX + e4, triIdx: r4 });
            }
          }
          if (0 === l3.length) return;
          l3.sort((t5, e4) => t5.cellIdx - e4.cellIdx || t5.triIdx - e4.triIdx);
          let u4 = 0;
          for (; u4 < l3.length; ) {
            const t5 = l3[u4].cellIdx, e4 = { start: this.payload.length, len: 0 };
            for (; u4 < l3.length && l3[u4].cellIdx === t5; ) ++e4.len, this.payload.push(l3[u4++].triIdx);
            this.cells[t5] = e4;
          }
        }
        _lazyInitLookup() {
          this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8))), this.lookup.fill(0);
        }
        queryPoint(t4, e3) {
          if (0 === this.triangleCount || 0 === this.cells.length) return;
          if (t4.x > this.max.x || this.min.x > t4.x || t4.y > this.max.y || this.min.y > t4.y) return;
          const r3 = $c(t4.x - this.min.x, this.xScale, this.cellsX), n3 = $c(t4.y - this.min.y, this.yScale, this.cellsY), i3 = this.cells[n3 * this.cellsX + r3];
          if (i3) {
            this._lazyInitLookup();
            for (let t5 = 0; t5 < i3.len; t5++) {
              const r4 = this.payload[i3.start + t5], n4 = Math.floor(r4 / 8), a4 = 1 << r4 % 8;
              if (!(this.lookup[n4] & a4) && (this.lookup[n4] |= a4, e3.push(r4), e3.length === this.triangleCount)) return;
            }
          }
        }
        query(t4, e3, r3) {
          if (0 === this.triangleCount || 0 === this.cells.length) return;
          if (t4.x > this.max.x || this.min.x > e3.x) return;
          if (t4.y > this.max.y || this.min.y > e3.y) return;
          this._lazyInitLookup();
          const n3 = $c(t4.x - this.min.x, this.xScale, this.cellsX), i3 = $c(e3.x - this.min.x, this.xScale, this.cellsX), a4 = $c(t4.y - this.min.y, this.yScale, this.cellsY), s3 = $c(e3.y - this.min.y, this.yScale, this.cellsY);
          for (let t5 = a4; t5 <= s3; t5++) for (let e4 = n3; e4 <= i3; e4++) {
            const n4 = this.cells[t5 * this.cellsX + e4];
            if (n4) for (let t6 = 0; t6 < n4.len; t6++) {
              const e5 = this.payload[n4.start + t6], i4 = Math.floor(e5 / 8), a5 = 1 << e5 % 8;
              if (!(this.lookup[i4] & a5) && (this.lookup[i4] |= a5, r3.push(e5), r3.length === this.triangleCount)) return;
            }
          }
        }
      }
      function $c(t4, e3, r3) {
        return Math.max(0, Math.min(r3 - 1, Math.floor(t4 * e3)));
      }
      aa(qc, "TriangleGridIndex");
      class Gc {
        constructor(t4) {
          this.zoom = t4.zoom, this.layers = t4.layers, this.layerIds = this.layers.map((t5) => t5.fqid), this.index = t4.index, this.hasPattern = false, this.stateDependentLayerIds = this.layers.filter((t5) => t5.isStateDependent()).map((t5) => t5.id), this.footprints = [];
        }
        updateFootprints(t4, e3) {
          for (const r3 of this.footprints) e3.push({ footprint: r3, id: t4 });
        }
        populate(t4, e3, r3, n3) {
          const i3 = [];
          for (const { feature: e4, id: a4, index: s3, sourceLayerIndex: o3 } of t4) {
            const t5 = this.layers[0]._featureFilter.needGeometry, l3 = zl(e4, t5);
            if (!this.layers[0]._featureFilter.filter(new Ea(this.zoom), l3, r3)) continue;
            const u4 = { id: a4, properties: e4.properties, type: e4.type, sourceLayerIndex: o3, index: s3, geometry: t5 ? l3.geometry : Il(e4, r3, n3), patterns: {} };
            i3.push(u4);
          }
          for (const n4 of i3) {
            const { geometry: i4, index: a4, sourceLayerIndex: s3 } = n4;
            this.addFeature(n4, i4, a4, r3, {}, e3.availableImages, e3.brightness), e3.featureIndex.insert(t4[a4].feature, i4, a4, s3, this.index);
          }
        }
        isEmpty() {
          return 0 === this.footprints.length;
        }
        uploadPending() {
          return false;
        }
        upload(t4) {
        }
        update(t4, e3, r3, n3, i3) {
        }
        destroy() {
        }
        addFeature(t4, e3, r3, n3, i3, a4 = [], s3) {
          for (const t5 of Cc(e3, 2)) {
            const e4 = [], r4 = [], n4 = [], i4 = new q(1 / 0, 1 / 0), a5 = new q(-1 / 0, -1 / 0);
            for (const s5 of t5) if (0 !== s5.length) {
              s5 !== t5[0] && n4.push(r4.length / 2);
              for (let t6 = 0; t6 < s5.length; t6++) r4.push(s5[t6].x), r4.push(s5[t6].y), e4.push(s5[t6]), i4.x = Math.min(i4.x, s5[t6].x), i4.y = Math.min(i4.y, s5[t6].y), a5.x = Math.max(a5.x, s5[t6].x), a5.y = Math.max(a5.y, s5[t6].y);
            }
            const s4 = uc(r4, n4), o3 = new qc(e4, s4, 8, 256);
            this.footprints.push({ vertices: e4, indices: s4, grid: o3, min: i4, max: a5 });
          }
        }
      }
      aa(Gc, "ClipBucket", { omit: ["layers"] });
      const Xc = ds([{ name: "a_pos_normal_ed", components: 4, type: "Int16" }]), Yc = ds([{ name: "a_pos_end", components: 4, type: "Int16" }, { name: "a_angular_offset_factor", components: 1, type: "Int16" }]), Zc = ds([{ name: "a_centroid_pos", components: 2, type: "Uint16" }]), Wc = ds([{ name: "a_join_normal_inside", components: 3, type: "Int16" }]), Hc = ds([{ name: "a_hidden_by_landmark", components: 1, type: "Uint8" }]), Kc = ds([{ name: "a_pos_3", components: 3, type: "Int16" }, { name: "a_pos_normal_3", components: 3, type: "Int16" }]), { members: Jc } = Xc;
      var Qc, th, eh, rh, nh, ih, ah, sh = {};
      function oh() {
        if (th) return Qc;
        th = 1;
        var t4 = N();
        function e3(t5, e4, n4, i3, a4) {
          this.properties = {}, this.extent = n4, this.type = 0, this._pbf = t5, this._geometry = -1, this._keys = i3, this._values = a4, t5.readFields(r3, this, e4);
        }
        function r3(t5, e4, r4) {
          1 == t5 ? e4.id = r4.readVarint() : 2 == t5 ? function(t6, e5) {
            for (var r5 = t6.readVarint() + t6.pos; t6.pos < r5; ) {
              var n4 = e5._keys[t6.readVarint()], i3 = e5._values[t6.readVarint()];
              e5.properties[n4] = i3;
            }
          }(r4, e4) : 3 == t5 ? e4.type = r4.readVarint() : 4 == t5 && (e4._geometry = r4.pos);
        }
        function n3(t5) {
          for (var e4, r4, n4 = 0, i3 = 0, a4 = t5.length, s3 = a4 - 1; i3 < a4; s3 = i3++) n4 += ((r4 = t5[s3]).x - (e4 = t5[i3]).x) * (e4.y + r4.y);
          return n4;
        }
        return Qc = e3, e3.types = ["Unknown", "Point", "LineString", "Polygon"], e3.prototype.loadGeometry = function() {
          var e4 = this._pbf;
          e4.pos = this._geometry;
          for (var r4, n4 = e4.readVarint() + e4.pos, i3 = 1, a4 = 0, s3 = 0, o3 = 0, l3 = []; e4.pos < n4; ) {
            if (a4 <= 0) {
              var u4 = e4.readVarint();
              i3 = 7 & u4, a4 = u4 >> 3;
            }
            if (a4--, 1 === i3 || 2 === i3) s3 += e4.readSVarint(), o3 += e4.readSVarint(), 1 === i3 && (r4 && l3.push(r4), r4 = []), r4.push(new t4(s3, o3));
            else {
              if (7 !== i3) throw new Error("unknown command " + i3);
              r4 && r4.push(r4[0].clone());
            }
          }
          return r4 && l3.push(r4), l3;
        }, e3.prototype.bbox = function() {
          var t5 = this._pbf;
          t5.pos = this._geometry;
          for (var e4 = t5.readVarint() + t5.pos, r4 = 1, n4 = 0, i3 = 0, a4 = 0, s3 = 1 / 0, o3 = -1 / 0, l3 = 1 / 0, u4 = -1 / 0; t5.pos < e4; ) {
            if (n4 <= 0) {
              var c3 = t5.readVarint();
              r4 = 7 & c3, n4 = c3 >> 3;
            }
            if (n4--, 1 === r4 || 2 === r4) (i3 += t5.readSVarint()) < s3 && (s3 = i3), i3 > o3 && (o3 = i3), (a4 += t5.readSVarint()) < l3 && (l3 = a4), a4 > u4 && (u4 = a4);
            else if (7 !== r4) throw new Error("unknown command " + r4);
          }
          return [s3, l3, o3, u4];
        }, e3.prototype.toGeoJSON = function(t5, r4, i3) {
          var a4, s3, o3 = this.extent * Math.pow(2, i3), l3 = this.extent * t5, u4 = this.extent * r4, c3 = this.loadGeometry(), h3 = e3.types[this.type];
          function p3(t6) {
            for (var e4 = 0; e4 < t6.length; e4++) {
              var r5 = t6[e4];
              t6[e4] = [360 * (r5.x + l3) / o3 - 180, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r5.y + u4) / o3) * Math.PI / 180)) - 90];
            }
          }
          switch (this.type) {
            case 1:
              var f3 = [];
              for (a4 = 0; a4 < c3.length; a4++) f3[a4] = c3[a4][0];
              p3(c3 = f3);
              break;
            case 2:
              for (a4 = 0; a4 < c3.length; a4++) p3(c3[a4]);
              break;
            case 3:
              for (c3 = function(t6) {
                var e4 = t6.length;
                if (e4 <= 1) return [t6];
                for (var r5, i4, a5 = [], s4 = 0; s4 < e4; s4++) {
                  var o4 = n3(t6[s4]);
                  0 !== o4 && (void 0 === i4 && (i4 = o4 < 0), i4 === o4 < 0 ? (r5 && a5.push(r5), r5 = [t6[s4]]) : r5.push(t6[s4]));
                }
                return r5 && a5.push(r5), a5;
              }(c3), a4 = 0; a4 < c3.length; a4++) for (s3 = 0; s3 < c3[a4].length; s3++) p3(c3[a4][s3]);
          }
          1 === c3.length ? c3 = c3[0] : h3 = "Multi" + h3;
          var d3 = { type: "Feature", geometry: { type: h3, coordinates: c3 }, properties: this.properties };
          return "id" in this && (d3.id = this.id), d3;
        }, Qc;
      }
      function lh() {
        if (rh) return eh;
        rh = 1;
        var t4 = oh();
        function e3(t5, e4) {
          this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t5, this._keys = [], this._values = [], this._features = [], t5.readFields(r3, this, e4), this.length = this._features.length;
        }
        function r3(t5, e4, r4) {
          15 === t5 ? e4.version = r4.readVarint() : 1 === t5 ? e4.name = r4.readString() : 5 === t5 ? e4.extent = r4.readVarint() : 2 === t5 ? e4._features.push(r4.pos) : 3 === t5 ? e4._keys.push(r4.readString()) : 4 === t5 && e4._values.push(function(t6) {
            for (var e5 = null, r5 = t6.readVarint() + t6.pos; t6.pos < r5; ) {
              var n3 = t6.readVarint() >> 3;
              e5 = 1 === n3 ? t6.readString() : 2 === n3 ? t6.readFloat() : 3 === n3 ? t6.readDouble() : 4 === n3 ? t6.readVarint64() : 5 === n3 ? t6.readVarint() : 6 === n3 ? t6.readSVarint() : 7 === n3 ? t6.readBoolean() : null;
            }
            return e5;
          }(r4));
        }
        return eh = e3, e3.prototype.feature = function(e4) {
          if (e4 < 0 || e4 >= this._features.length) throw new Error("feature index out of bounds");
          this._pbf.pos = this._features[e4];
          var r4 = this._pbf.readVarint() + this._pbf.pos;
          return new t4(this._pbf, r4, this.extent, this._keys, this._values);
        }, eh;
      }
      function uh() {
        return ah || (ah = 1, sh.VectorTile = function() {
          if (ih) return nh;
          ih = 1;
          var t4 = lh();
          function e3(e4, r3, n3) {
            if (3 === e4) {
              var i3 = new t4(n3, n3.readVarint() + n3.pos);
              i3.length && (r3[i3.name] = i3);
            }
          }
          return nh = function(t5, r3) {
            this.layers = t5.readFields(e3, {}, r3);
          }, nh;
        }(), sh.VectorTileFeature = oh(), sh.VectorTileLayer = lh()), sh;
      }
      var ch = uh();
      class hh extends q {
        constructor(t4, e3, r3) {
          super(t4, e3), this.z = r3;
        }
      }
      class ph extends hh {
        constructor(t4, e3, r3, n3) {
          super(t4, e3, r3), this.w = n3;
        }
      }
      function fh(t4, e3, r3, n3) {
        const i3 = [], a4 = 0 === n3 ? (t5, e4, r4, n4, i4, a5) => {
          t5.push(new q(a5, r4 + (a5 - e4) / (n4 - e4) * (i4 - r4)));
        } : (t5, e4, r4, n4, i4, a5) => {
          t5.push(new q(e4 + (a5 - r4) / (i4 - r4) * (n4 - e4), a5));
        };
        for (const s3 of t4) {
          const t5 = [];
          for (const i4 of s3) {
            if (i4.length <= 2) continue;
            const s4 = [];
            for (let t6 = 0; t6 < i4.length - 1; t6++) {
              const o4 = i4[t6].x, l4 = i4[t6].y, u4 = i4[t6 + 1].x, c3 = i4[t6 + 1].y, h3 = 0 === n3 ? o4 : l4, p3 = 0 === n3 ? u4 : c3;
              h3 < e3 ? p3 > e3 && a4(s4, o4, l4, u4, c3, e3) : h3 > r3 ? p3 < r3 && a4(s4, o4, l4, u4, c3, r3) : s4.push(i4[t6]), p3 < e3 && h3 >= e3 && a4(s4, o4, l4, u4, c3, e3), p3 > r3 && h3 <= r3 && a4(s4, o4, l4, u4, c3, r3);
            }
            let o3 = i4[i4.length - 1];
            const l3 = 0 === n3 ? o3.x : o3.y;
            l3 >= e3 && l3 <= r3 && s4.push(o3), s4.length && (o3 = s4[s4.length - 1], s4[0].x === o3.x && s4[0].y === o3.y || s4.push(s4[0]), t5.push(s4));
          }
          t5.length && i3.push(t5);
        }
        return i3;
      }
      function dh(t4, e3, r3, n3) {
        const i3 = "x" === r3 ? "y" : "x", a4 = (n3 - t4[r3]) / (e3[r3] - t4[r3]);
        t4[i3] = t4[i3] + (e3[i3] - t4[i3]) * a4, t4[r3] = n3, t4.hasOwnProperty("z") && (t4.z = Pe(t4.z, e3.z, a4)), t4.hasOwnProperty("w") && (t4.w = Pe(t4.w, e3.w, a4));
      }
      function mh(t4, e3, r3, n3) {
        const i3 = r3, a4 = n3;
        for (const r4 of ["x", "y"]) {
          let n4 = t4, s3 = e3;
          n4[r4] >= s3[r4] && (n4 = e3, s3 = t4), n4[r4] < i3 && s3[r4] > i3 && dh(n4, s3, r4, i3), n4[r4] < a4 && s3[r4] > a4 && dh(s3, n4, r4, a4);
        }
      }
      const yh = Number.MAX_SAFE_INTEGER;
      function gh(t4, e3, r3, n3) {
        return t4.order < e3 || t4.order === yh || !(t4.clipMask & r3) || function(t5, e4) {
          return 0 !== e4.length && void 0 === e4.find((e5) => e5 === t5);
        }(n3, t4.clipScope);
      }
      function xh(t4, e3) {
        return t4.x - e3.x || t4.y - e3.y;
      }
      function vh(t4, e3) {
        return 0 === xh(t4.min, e3.min) && 0 === xh(t4.max, e3.max);
      }
      function bh(t4, e3) {
        return !(t4.min.x > e3.max.x || t4.max.x < e3.min.x || t4.min.y > e3.max.y || t4.max.y < e3.min.y);
      }
      function wh(t4, e3) {
        if (t4.length !== e3.length) return false;
        for (let r3 = 0; r3 < t4.length; r3++) if (t4[r3].sourceId !== e3[r3].sourceId || !vh(t4[r3], e3[r3]) || t4[r3].order !== e3[r3].order || t4[r3].clipMask !== e3[r3].clipMask || !$2(t4[r3].clipScope, e3[r3].clipScope)) return false;
        return true;
      }
      function _h(t4, e3, r3) {
        const n3 = 1 / Wr, i3 = 1 / (1 << r3.canonical.z), a4 = (e3.x * n3 + r3.canonical.x) * i3 + r3.wrap, s3 = (e3.y * n3 + r3.canonical.y) * i3;
        return { min: new q((t4.x * n3 + r3.canonical.x) * i3 + r3.wrap, (t4.y * n3 + r3.canonical.y) * i3), max: new q(a4, s3) };
      }
      function Mh(t4, e3, r3) {
        const n3 = 1 << r3.canonical.z, i3 = ((e3.x - r3.wrap) * n3 - r3.canonical.x) * Wr, a4 = (e3.y * n3 - r3.canonical.y) * Wr;
        return { min: new q(((t4.x - r3.wrap) * n3 - r3.canonical.x) * Wr, (t4.y * n3 - r3.canonical.y) * Wr), max: new q(i3, a4) };
      }
      function Ah(t4, e3, r3, n3, i3, a4, s3) {
        const o3 = t4.indices, l3 = t4.vertices, u4 = [];
        for (let c3 = n3; c3 < n3 + i3; c3 += 3) {
          const n4 = e3[r3[c3 + 0] + a4], i4 = e3[r3[c3 + 1] + a4], h3 = e3[r3[c3 + 2] + a4], p3 = Math.min(n4.x, i4.x, h3.x), f3 = Math.max(n4.x, i4.x, h3.x), d3 = Math.min(n4.y, i4.y, h3.y), m2 = Math.max(n4.y, i4.y, h3.y);
          u4.length = 0, t4.grid.query(new q(p3, d3), new q(f3, m2), u4);
          for (let t5 = 0; t5 < u4.length; t5++) {
            const e4 = u4[t5];
            if ($l(l3[o3[3 * e4 + 0]], l3[o3[3 * e4 + 1]], l3[o3[3 * e4 + 2]], n4, i4, h3, s3)) return true;
          }
        }
        return false;
      }
      function Sh(t4, e3, r3, n3) {
        if (!t4 || !r3) return false;
        let i3 = t4.vertices;
        if (!e3.canonical.equals(n3.canonical) || e3.wrap !== n3.wrap) {
          if (r3.vertices.length < t4.vertices.length) return Sh(r3, n3, t4, e3);
          const a4 = e3.canonical, s3 = n3.canonical, o3 = Math.pow(2, s3.z - a4.z);
          i3 = t4.vertices.map((t5) => new q((t5.x + a4.x * Wr) * o3 - s3.x * Wr, (t5.y + a4.y * Wr) * o3 - s3.y * Wr));
        }
        return Ah(r3, i3, t4.indices, 0, t4.indices.length, 0, 0);
      }
      function Ih(t4, e3, r3, n3) {
        const i3 = Math.pow(2, n3.z - r3.z);
        return new q((t4 + r3.x * Wr) * i3 - n3.x * Wr, (e3 + r3.y * Wr) * i3 - n3.y * Wr);
      }
      function zh(t4, e3) {
        const r3 = [];
        e3.grid.queryPoint(t4, r3);
        const n3 = e3.indices, i3 = e3.vertices;
        for (let e4 = 0; e4 < r3.length; e4++) {
          const a4 = r3[e4];
          if (Ul([i3[n3[3 * a4 + 0]], i3[n3[3 * a4 + 1]], i3[n3[3 * a4 + 2]]], t4)) return true;
        }
        return false;
      }
      const Ph = [new q(0, 0), new q(Wr, 0), new q(Wr, Wr), new q(0, Wr)];
      function kh(t4, e3) {
        const r3 = [];
        let n3 = [];
        if (!e3 || t4.length < 2) return [t4];
        if (2 === t4.length) return Nl(t4[0], t4[1], Ph) ? [t4] : [];
        for (let e4 = 0; e4 < t4.length + 2; e4++) {
          const i3 = t4[e4 % t4.length], a4 = t4[(e4 + 1) % t4.length], s3 = Nl(0 === e4 ? t4[t4.length - 1] : t4[(e4 - 1) % t4.length], i3, Ph), o3 = Nl(i3, a4, Ph), l3 = s3 || o3;
          l3 && n3.push(i3), l3 && o3 || n3.length > 0 && (n3.length > 1 && r3.push(n3), n3 = []);
        }
        return n3.length > 1 && r3.push(n3), r3;
      }
      const Th = ch.VectorTileFeature.types, Eh = ["fill-extrusion-base", "fill-extrusion-height", "fill-extrusion-color", "fill-extrusion-pattern", "fill-extrusion-flood-light-wall-radius", "fill-extrusion-line-width", "fill-extrusion-emissive-strength"], Bh = ["fill-extrusion-flood-light-ground-radius"], Vh = Math.pow(2, 13), Ch = Math.pow(2, 15) - 1, Rh = new q(0, 1), Dh = 2147483648;
      function Lh(t4, e3, r3, n3, i3, a4, s3, o3) {
        t4.emplaceBack((e3 << 1) + s3, (r3 << 1) + a4, (Math.floor(n3 * Vh) << 1) + i3, Math.round(o3));
      }
      function Fh(t4, e3, r3) {
        t4.emplaceBack(e3.x * Wr, e3.y * Wr, r3 ? 1 : 0);
      }
      function Oh(t4, e3, r3, n3, i3, a4) {
        t4.emplaceBack(e3.x, e3.y, (r3.x << 1) + n3, (r3.y << 1) + i3, a4);
      }
      function Uh(t4, e3, r3) {
        const n3 = 16384;
        t4.emplaceBack(e3.x, e3.y, e3.z, r3[0] * n3, r3[1] * n3, r3[2] * n3);
      }
      class jh {
        constructor() {
          this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
        }
      }
      class Nh {
        constructor() {
          this.centroidXY = new q(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new q(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new q(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0;
        }
        span() {
          return new q(this.max.x - this.min.x, this.max.y - this.min.y);
        }
      }
      class qh {
        constructor() {
          this.acc = new q(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
        }
        startRing(t4, e3) {
          t4.min.x === Number.MAX_VALUE && (t4.min.x = t4.max.x = e3.x, t4.min.y = t4.max.y = e3.y);
        }
        appendEdge(t4, e3, r3) {
          this.accCount++, this.acc._add(e3);
          let n3 = !!this.borders;
          e3.x < t4.min.x ? (t4.min.x = e3.x, n3 = true) : e3.x > t4.max.x && (t4.max.x = e3.x, n3 = true), e3.y < t4.min.y ? (t4.min.y = e3.y, n3 = true) : e3.y > t4.max.y && (t4.max.y = e3.y, n3 = true), ((0 === e3.x || e3.x === Wr) && e3.x === r3.x) != ((0 === e3.y || e3.y === Wr) && e3.y === r3.y) && this.processBorderOverlap(e3, r3), n3 && this.checkBorderIntersection(e3, r3);
        }
        checkBorderIntersection(t4, e3) {
          e3.x < 0 != t4.x < 0 && this.addBorderIntersection(0, Pe(e3.y, t4.y, (0 - e3.x) / (t4.x - e3.x))), e3.x > Wr != t4.x > Wr && this.addBorderIntersection(1, Pe(e3.y, t4.y, (Wr - e3.x) / (t4.x - e3.x))), e3.y < 0 != t4.y < 0 && this.addBorderIntersection(2, Pe(e3.x, t4.x, (0 - e3.y) / (t4.y - e3.y))), e3.y > Wr != t4.y > Wr && this.addBorderIntersection(3, Pe(e3.x, t4.x, (Wr - e3.y) / (t4.y - e3.y)));
        }
        addBorderIntersection(t4, e3) {
          this.borders || (this.borders = [[Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE]]);
          const r3 = this.borders[t4];
          e3 < r3[0] && (r3[0] = e3), e3 > r3[1] && (r3[1] = e3);
        }
        processBorderOverlap(t4, e3) {
          if (t4.x === e3.x) {
            if (t4.y === e3.y) return;
            const r3 = 0 === t4.x ? 0 : 1;
            this.addBorderIntersection(r3, e3.y), this.addBorderIntersection(r3, t4.y);
          } else {
            const r3 = 0 === t4.y ? 2 : 3;
            this.addBorderIntersection(r3, e3.x), this.addBorderIntersection(r3, t4.x);
          }
        }
        centroid() {
          return 0 === this.accCount ? new q(0, 0) : new q(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
        }
        intersectsCount() {
          return this.borders ? this.borders.reduce((t4, e3) => t4 + +(e3[0] !== Number.MAX_VALUE), 0) : 0;
        }
      }
      function $h(t4, e3) {
        const r3 = t4.add(e3)._unit(), n3 = Q2(t4.x * r3.x + t4.y * r3.y, -1, 1);
        var i3, a4, s3;
        return s3 = Math.acos(n3), Math.min(4, Math.max(-4, Math.tan(s3))) / 4 * Ch * ((i3 = t4).x * (a4 = e3).y - i3.y * a4.x < 0 ? -1 : 1);
      }
      const Gh = [(t4) => t4.x < 0, (t4) => t4.x > Wr, (t4) => t4.y < 0, (t4) => t4.y > Wr];
      function Xh(t4, e3, r3, n3) {
        const i3 = [4];
        if (0 === n3) return i3;
        r3._mult(n3);
        const a4 = t4.sub(r3), s3 = e3.sub(r3), o3 = [t4, e3, a4, s3];
        for (let t5 = 0; t5 < 4; t5++) for (const e4 of o3) if (Gh[t5](e4)) {
          i3.push(t5);
          break;
        }
        return i3;
      }
      class Yh {
        constructor(t4) {
          this.vertexArray = new vs(), this.indexArray = new Cs(), this.programConfigurations = new Fo(t4.layers, { zoom: t4.zoom, lut: t4.lut }, (t5) => Bh.includes(t5)), this._segments = new co(), this.hiddenByLandmarkVertexArray = new Zs(), this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [0, 0, 0, 0, 0], this.regionSegments = {}, this.regionSegments[4] = new co();
        }
        getDefaultSegment() {
          return this.regionSegments[4];
        }
        hasData() {
          return 0 !== this.vertexArray.length;
        }
        addData(t4, e3, r3, n3 = false) {
          const i3 = t4.length;
          if (i3 > 2) {
            let a4 = Math.max(0, this._segments.get().length - 1);
            const s3 = this._segments._prepareSegment(4 * i3, this.vertexArray.length, 2 * this._segmentToGroundQuads[a4].length);
            let o3;
            a4 !== this._segments.get().length - 1 && (a4++, this._segmentToGroundQuads[a4] = [], this._segmentToRegionTriCounts[a4] = [0, 0, 0, 0, 0]);
            {
              const e4 = t4[0], r4 = t4[1];
              o3 = $h(e4.sub(t4[i3 - 1])._perp()._unit(), r4.sub(e4)._perp()._unit());
            }
            for (let l3 = 0; l3 < i3; l3++) {
              const u4 = l3 === i3 - 1 ? 0 : l3 + 1, c3 = t4[l3], h3 = t4[u4], p3 = t4[u4 === i3 - 1 ? 0 : u4 + 1], f3 = h3.sub(c3)._perp()._unit(), d3 = $h(f3, p3.sub(h3)._perp()._unit()), m2 = o3, y2 = d3;
              if (Jh(c3, h3, e3) || n3 && Qh(c3, e3) && Qh(h3, e3)) {
                o3 = d3;
                continue;
              }
              const g4 = s3.vertexLength;
              Oh(this.vertexArray, c3, h3, 1, 1, m2), Oh(this.vertexArray, c3, h3, 1, 0, m2), Oh(this.vertexArray, c3, h3, 0, 1, y2), Oh(this.vertexArray, c3, h3, 0, 0, y2), s3.vertexLength += 4;
              const x2 = Xh(c3, h3, f3, r3);
              for (const t5 of x2) this._segmentToGroundQuads[a4].push({ id: g4, region: t5 }), this._segmentToRegionTriCounts[a4][t5] += 2, s3.primitiveLength += 2;
              o3 = d3;
            }
          }
        }
        prepareBorderSegments() {
          if (!this.hasData()) return;
          const t4 = this._segments.get(), e3 = t4.length;
          for (let t5 = 0; t5 < e3; t5++) this._segmentToGroundQuads[t5].sort((t6, e4) => t6.region - e4.region);
          for (let r3 = 0; r3 < e3; r3++) {
            const e4 = this._segmentToGroundQuads[r3], n3 = t4[r3], i3 = this._segmentToRegionTriCounts[r3];
            i3.reduce((t5, e5) => t5 + e5, 0);
            let a4 = 0;
            for (let t5 = 0; t5 <= 4; t5++) {
              const e5 = i3[t5];
              if (0 !== e5) {
                let r4 = this.regionSegments[t5];
                r4 || (r4 = this.regionSegments[t5] = new co());
                const i4 = { vertexOffset: n3.vertexOffset, primitiveOffset: n3.primitiveOffset + a4, vertexLength: n3.vertexLength, primitiveLength: e5 };
                r4.get().push(i4);
              }
              a4 += e5;
            }
            for (let t5 = 0; t5 < e4.length; t5++) {
              const r4 = e4[t5].id;
              this.indexArray.emplaceBack(r4, r4 + 1, r4 + 3), this.indexArray.emplaceBack(r4, r4 + 3, r4 + 2);
            }
          }
          this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
        }
        addPaintPropertiesData(t4, e3, r3, n3, i3, a4) {
          this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, t4, e3, r3, n3, i3, a4);
        }
        upload(t4) {
          this.hasData() && (this.vertexBuffer = t4.createVertexBuffer(this.vertexArray, Yc.members), this.indexBuffer = t4.createIndexBuffer(this.indexArray));
        }
        uploadPaintProperties(t4) {
          this.hasData() && this.programConfigurations.upload(t4);
        }
        update(t4, e3, r3, n3, i3, a4) {
          this.hasData() && this.programConfigurations.updatePaintArrays(t4, e3, r3, n3, i3, a4);
        }
        updateHiddenByLandmark(t4) {
          if (!this.hasData()) return;
          const e3 = t4.groundVertexCount + t4.groundVertexArrayOffset;
          if (0 === t4.groundVertexCount) return;
          const r3 = t4.flags & Dh ? 1 : 0;
          for (let n3 = t4.groundVertexArrayOffset; n3 < e3; ++n3) this.hiddenByLandmarkVertexArray.emplace(n3, r3);
          this._needsHiddenByLandmarkUpdate = true;
        }
        uploadHiddenByLandmark(t4) {
          this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = t4.createVertexBuffer(this.hiddenByLandmarkVertexArray, Hc.members, true) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = false);
        }
        destroy() {
          if (this.vertexBuffer) {
            this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
            for (let t4 = 0; t4 <= 4; t4++) {
              const e3 = this.regionSegments[t4];
              e3 && e3.destroy();
            }
          }
        }
      }
      class Zh {
        constructor(t4) {
          this.zoom = t4.zoom, this.canonical = t4.canonical, this.overscaling = t4.overscaling, this.layers = t4.layers, this.layerIds = this.layers.map((t5) => t5.fqid), this.index = t4.index, this.hasPattern = false, this.edgeRadius = 0, this.projection = t4.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = [], this.footprintIndices = new Cs(), this.footprintVertices = new ys(), this.footprintSegments = [], this.layoutVertexArray = new xs(), this.centroidVertexArray = new ao(), this.wallVertexArray = new oo(), this.indexArray = new Cs(), this.programConfigurations = new Fo(t4.layers, { zoom: t4.zoom, lut: t4.lut }, (t5) => Eh.includes(t5)), this.segments = new co(), this.stateDependentLayerIds = this.layers.filter((t5) => t5.isStateDependent()).map((t5) => t5.id), this.groundEffect = new Yh(t4), this.maxHeight = 0, this.partLookup = {}, this.triangleSubSegments = [], this.polygonSegments = [];
        }
        updateFootprints(t4, e3) {
        }
        populate(t4, e3, r3, n3) {
          this.features = [], this.hasPattern = Dc("fill-extrusion", this.layers, e3), this.featuresOnBorder = [], this.borderFeatureIndices = [[], [], [], []], this.borderDoneWithNeighborZ = [-1, -1, -1, -1], this.tileToMeter = gl(r3), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter, this.wallMode = 0 !== this.layers[0].paint.get("fill-extrusion-line-width").constantOr(1);
          for (const { feature: i3, id: a4, index: s3, sourceLayerIndex: o3 } of t4) {
            const t5 = this.layers[0]._featureFilter.needGeometry, l3 = zl(i3, t5);
            if (!this.layers[0]._featureFilter.filter(new Ea(this.zoom), l3, r3)) continue;
            const u4 = { id: a4, sourceLayerIndex: o3, index: s3, geometry: t5 ? l3.geometry : Il(i3, r3, n3), properties: i3.properties, type: i3.type, patterns: {} }, c3 = this.layoutVertexArray.length, h3 = "Polygon" === Th[u4.type];
            if (this.hasPattern) this.features.push(Lc("fill-extrusion", this.layers, u4, this.zoom, e3));
            else if (this.wallMode) for (const t6 of u4.geometry) for (const i4 of kh(t6, h3)) this.addFeature(u4, [i4], s3, r3, {}, e3.availableImages, n3, e3.brightness);
            else this.addFeature(u4, u4.geometry, s3, r3, {}, e3.availableImages, n3, e3.brightness);
            e3.featureIndex.insert(i3, u4.geometry, s3, o3, this.index, c3);
          }
          this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
        }
        addFeatures(t4, e3, r3, n3, i3, a4) {
          for (const t5 of this.features) {
            const s3 = "Polygon" === Th[t5.type], { geometry: o3 } = t5;
            if (this.wallMode) for (const l3 of o3) for (const o4 of kh(l3, s3)) this.addFeature(t5, [o4], t5.index, e3, r3, n3, i3, a4);
            else this.addFeature(t5, o3, t5.index, e3, r3, n3, i3, a4);
          }
          this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles();
        }
        update(t4, e3, r3, n3, i3) {
          const a4 = 0 !== Object.keys(t4).length;
          if (a4 && !this.stateDependentLayers.length) return;
          const s3 = a4 ? this.stateDependentLayers : this.layers;
          this.programConfigurations.updatePaintArrays(t4, e3, s3, r3, n3, i3), this.groundEffect.update(t4, e3, s3, r3, n3, i3);
        }
        isEmpty() {
          return 0 === this.layoutVertexArray.length;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
        }
        upload(t4) {
          this.uploaded || (this.layoutVertexBuffer = t4.createVertexBuffer(this.layoutVertexArray, Jc), this.indexBuffer = t4.createIndexBuffer(this.indexArray), this.wallVertexBuffer = t4.createVertexBuffer(this.wallVertexArray, Wc.members), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = t4.createVertexBuffer(this.layoutVertexExtArray, Kc.members, true)), this.groundEffect.upload(t4)), this.groundEffect.uploadPaintProperties(t4), this.programConfigurations.upload(t4), this.uploaded = true;
        }
        uploadCentroid(t4) {
          this.groundEffect.uploadHiddenByLandmark(t4), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = t4.createVertexBuffer(this.centroidVertexArray, Zc.members, true) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = false);
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }
        addFeature(t4, e3, r3, n3, i3, a4, s3, o3) {
          const l3 = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(t4, {}) / this.tileToMeter, u4 = [new q(0, 0), new q(Wr, Wr)], c3 = s3.projection, h3 = "globe" === c3.name, p3 = this.wallMode || "Polygon" === Th[t4.type], f3 = new qh();
          f3.centroidDataIndex = this.centroidData.length;
          const d3 = new Nh(), m2 = this.layers[0].paint.get("fill-extrusion-base").evaluate(t4, {}, n3) <= 0, y2 = this.layers[0].paint.get("fill-extrusion-height").evaluate(t4, {}, n3);
          let g4;
          if (d3.height = y2, d3.vertexArrayOffset = this.layoutVertexArray.length, d3.groundVertexArrayOffset = this.groundEffect.vertexArray.length, h3 && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new Ss()), this.wallMode) {
            if (h3) return void ft("Non zero fill-extrusion-line-width is not yet supported on globe.");
            if (1 !== e3.length) return;
            g4 = function(t5) {
              const e4 = t5[0].x === t5[t5.length - 1].x && t5[0].y === t5[t5.length - 1].y, r4 = function(t6) {
                let e5 = 0;
                const r5 = t6.length;
                for (let n5 = 0; n5 < r5; n5++) e5 += (t6[(n5 + 1) % r5].x - t6[n5].x) * (t6[(n5 + 1) % r5].y + t6[n5].y);
                return e5 >= 0;
              }(t5);
              r4 || (t5 = t5.reverse());
              const n4 = { geometry: [], joinNormals: [], indices: [] }, i4 = [], a5 = [], s4 = [];
              let o4 = t5.length;
              if (o4 < (e4 ? 3 : 2)) return n4;
              for (; o4 >= 2 && t5[o4 - 1].equals(t5[o4 - 2]); ) o4--;
              let l4, u5, c4, h4, p4, f4 = 0;
              for (; f4 < o4 - 1 && t5[f4].equals(t5[f4 + 1]); ) f4++;
              e4 && (l4 = t5[o4 - 2], p4 = t5[f4].sub(l4)._unit()._perp());
              for (let r5 = f4; r5 < o4; r5++) {
                if (c4 = r5 === o4 - 1 ? e4 ? t5[f4 + 1] : void 0 : t5[r5 + 1], c4 && t5[r5].equals(c4)) continue;
                p4 && (h4 = p4), l4 && (u5 = l4), l4 = t5[r5], p4 = c4 ? c4.sub(l4)._unit()._perp() : h4, h4 = h4 || p4;
                let n5 = h4.add(p4);
                0 === n5.x && 0 === n5.y || n5._unit();
                const d5 = n5.x * p4.x + n5.y * p4.y, m3 = 0 !== d5 ? 1 / d5 : 1 / 0, y3 = h4.x * p4.y - h4.y * p4.x > 0;
                let g5 = "miter";
                const x3 = 2;
                "miter" === g5 && m3 > x3 && (g5 = "bevel"), "bevel" === g5 && (m3 > 100 && (g5 = "flipbevel"), m3 < x3 && (g5 = "miter"));
                const v3 = (t6, e5, r6, n6) => {
                  const o5 = new q(t6.x, t6.y), l5 = new q(t6.x, t6.y);
                  o5.x += e5.x * n6, o5.y += e5.y * n6, l5.x -= e5.x * Math.max(r6, 1), l5.y -= e5.y * Math.max(r6, 1), s4.push(e5), i4.push(o5), a5.push(l5);
                };
                if ("miter" === g5) n5._mult(m3), v3(l4, n5, 0, 0);
                else if ("flipbevel" === g5) n5 = p4.mult(-1), v3(l4, n5, 0, 0), v3(l4, n5.mult(-1), 0, 0);
                else {
                  const t6 = -Math.sqrt(m3 * m3 - 1), e5 = y3 ? t6 : 0, r6 = y3 ? 0 : t6;
                  u5 && v3(l4, h4, e5, r6), c4 && v3(l4, p4, e5, r6);
                }
              }
              n4.geometry = [...i4, ...a5.reverse(), i4[0]], n4.joinNormals = [...s4, ...s4.reverse(), s4[s4.length - 1]];
              const d4 = n4.geometry.length - 1;
              for (let t6 = 0; t6 < d4 / 2; t6++) if (t6 + 1 < d4 / 2) {
                let e5 = t6, r5 = t6 + 1, i5 = d4 - 1 - t6, a6 = d4 - 2 - t6;
                e5 = 0 === e5 ? d4 - 1 : e5 - 1, r5 = 0 === r5 ? d4 - 1 : r5 - 1, i5 = 0 === i5 ? d4 - 1 : i5 - 1, a6 = 0 === a6 ? d4 - 1 : a6 - 1, n4.indices.push(i5), n4.indices.push(r5), n4.indices.push(e5), n4.indices.push(i5), n4.indices.push(a6), n4.indices.push(r5);
              }
              return n4;
            }(e3[0]), e3 = [g4.geometry];
          }
          const x2 = (t5, e4) => t5 < (e4.length - 1) / 2 || t5 === e4.length - 1, v2 = this.wallMode ? [e3] : Cc(e3, 500);
          for (let t5 = v2.length - 1; t5 >= 0; t5--) {
            const e4 = v2[t5];
            (0 === e4.length || (b2 = e4[0]).every((t6) => t6.x <= 0) || b2.every((t6) => t6.x >= Wr) || b2.every((t6) => t6.y <= 0) || b2.every((t6) => t6.y >= Wr)) && v2.splice(t5, 1);
          }
          var b2;
          let w2;
          if (h3) w2 = np(v2, u4, n3);
          else {
            w2 = [];
            for (const t5 of v2) w2.push({ polygon: t5, bounds: u4 });
          }
          const _2 = p3 ? this.edgeRadius : 0, M2 = _2 > 0 && this.zoom < 17, A3 = (t5, e4) => {
            if (0 === t5.length) return false;
            const r4 = t5[t5.length - 1];
            return e4.x === r4.x && e4.y === r4.y;
          };
          for (const { polygon: t5, bounds: e4 } of w2) {
            let r4 = 0, i4 = 0;
            for (const e5 of t5) p3 && !e5[0].equals(e5[e5.length - 1]) && e5.push(e5[0]), i4 += p3 ? e5.length - 1 : e5.length;
            const a5 = this.segments.prepareSegment((p3 ? 5 : 4) * i4, this.layoutVertexArray, this.indexArray);
            d3.footprintSegIdx < 0 && (d3.footprintSegIdx = this.footprintSegments.length), d3.polygonSegIdx < 0 && (d3.polygonSegIdx = this.polygonSegments.length);
            const s4 = { triangleArrayOffset: this.indexArray.length, triangleCount: 0, triangleSegIdx: this.segments.segments.length - 1 }, o4 = new jh();
            if (o4.vertexOffset = this.footprintVertices.length, o4.indexOffset = 3 * this.footprintIndices.length, o4.ringIndices = [], p3) {
              const i5 = [], s5 = [];
              r4 = a5.vertexLength;
              for (let r5 = 0; r5 < t5.length; r5++) {
                const u6 = t5[r5];
                u6.length && 0 !== r5 && s5.push(i5.length / 2);
                const p4 = [];
                let f4, d4;
                f4 = u6[1].sub(u6[0])._perp()._unit(), o4.ringIndices.push(u6.length - 1);
                for (let t6 = 1; t6 < u6.length; t6++) {
                  const e5 = u6[t6], r6 = u6[t6 === u6.length - 1 ? 1 : t6 + 1], s6 = e5.clone();
                  if (_2) {
                    d4 = r6.sub(e5)._perp()._unit();
                    const t7 = f4.add(d4)._unit(), n4 = _2 * Math.min(4, 1 / (f4.x * t7.x + f4.y * t7.y));
                    s6.x += n4 * t7.x, s6.y += n4 * t7.y, s6.x = Math.round(s6.x), s6.y = Math.round(s6.y), f4 = d4;
                  }
                  if (!m2 || 0 !== _2 && !M2 || A3(p4, s6) || p4.push(s6), Lh(this.layoutVertexArray, s6.x, s6.y, 0, 0, 1, 1, 0), this.wallMode) {
                    const e6 = x2(t6, u6);
                    Fh(this.wallVertexArray, g4.joinNormals[t6], !e6);
                  }
                  a5.vertexLength++, this.footprintVertices.emplaceBack(e5.x, e5.y), i5.push(e5.x, e5.y), h3 && Uh(this.layoutVertexExtArray, c3.projectTilePoint(s6.x, s6.y, n3), c3.upVector(n3, s6.x, s6.y));
                }
                m2 && (0 === _2 || M2) && (0 !== p4.length && A3(p4, p4[0]) && p4.pop(), this.groundEffect.addData(p4, e4, l3));
              }
              const u5 = this.wallMode ? g4.indices : uc(i5, s5);
              for (let t6 = 0; t6 < u5.length; t6 += 3) this.footprintIndices.emplaceBack(o4.vertexOffset + u5[t6 + 0], o4.vertexOffset + u5[t6 + 1], o4.vertexOffset + u5[t6 + 2]), this.indexArray.emplaceBack(r4 + u5[t6], r4 + u5[t6 + 2], r4 + u5[t6 + 1]), a5.primitiveLength++;
              o4.indexCount += u5.length, o4.vertexCount += this.footprintVertices.length - o4.vertexOffset;
            }
            for (let i5 = 0; i5 < t5.length; i5++) {
              const s5 = t5[i5];
              f3.startRing(d3, s5[0]);
              let o5 = s5.length > 4 && tp(s5[s5.length - 2], s5[0], s5[1]), u5 = _2 ? Hh(s5[s5.length - 2], s5[0], s5[1], _2) : 0;
              const y3 = [];
              let v3, b3, w3;
              b3 = s5[1].sub(s5[0])._perp()._unit();
              let M3 = true;
              for (let t6 = 1, i6 = 0; t6 < s5.length; t6++) {
                let l4 = s5[t6 - 1], p4 = s5[t6];
                const S2 = s5[t6 === s5.length - 1 ? 1 : t6 + 1];
                if (f3.appendEdge(d3, p4, l4), Jh(p4, l4, e4)) {
                  _2 && (b3 = S2.sub(p4)._perp()._unit(), M3 = !M3);
                  continue;
                }
                const I3 = p4.sub(l4)._perp(), z3 = I3.x / (Math.abs(I3.x) + Math.abs(I3.y)), P2 = I3.y > 0 ? 1 : 0, k2 = l4.dist(p4);
                if (i6 + k2 > 32768 && (i6 = 0), _2) {
                  w3 = S2.sub(p4)._perp()._unit();
                  let t7 = Kh(l4, p4, S2, Wh(b3, w3), _2);
                  isNaN(t7) && (t7 = 0);
                  const e5 = p4.sub(l4)._unit();
                  l4 = l4.add(e5.mult(u5))._round(), p4 = p4.add(e5.mult(-t7))._round(), u5 = t7, b3 = w3, m2 && this.zoom >= 17 && (A3(y3, l4) || y3.push(l4), A3(y3, p4) || y3.push(p4));
                }
                const T3 = a5.vertexLength, E3 = s5.length > 4 && tp(l4, p4, S2);
                let B4 = ep(i6, o5, M3);
                if (Lh(this.layoutVertexArray, l4.x, l4.y, z3, P2, 0, 0, B4), Lh(this.layoutVertexArray, l4.x, l4.y, z3, P2, 0, 1, B4), this.wallMode) {
                  const e5 = x2(t6 - 1, s5), r5 = g4.joinNormals[t6 - 1];
                  Fh(this.wallVertexArray, r5, e5), Fh(this.wallVertexArray, r5, e5);
                }
                if (i6 += k2, B4 = ep(i6, E3, !M3), o5 = E3, Lh(this.layoutVertexArray, p4.x, p4.y, z3, P2, 0, 0, B4), Lh(this.layoutVertexArray, p4.x, p4.y, z3, P2, 0, 1, B4), this.wallMode) {
                  const e5 = x2(t6, s5), r5 = g4.joinNormals[t6];
                  Fh(this.wallVertexArray, r5, e5), Fh(this.wallVertexArray, r5, e5);
                }
                if (a5.vertexLength += 4, this.indexArray.emplaceBack(T3 + 0, T3 + 1, T3 + 2), this.indexArray.emplaceBack(T3 + 1, T3 + 3, T3 + 2), a5.primitiveLength += 2, _2) {
                  const n4 = r4 + (1 === t6 ? s5.length - 2 : t6 - 2), i7 = 1 === t6 ? r4 : n4 + 1;
                  if (this.indexArray.emplaceBack(T3 + 1, n4, T3 + 3), this.indexArray.emplaceBack(n4, i7, T3 + 3), a5.primitiveLength += 2, void 0 === v3 && (v3 = T3), !Jh(S2, s5[t6], e4)) {
                    const e5 = t6 === s5.length - 1 ? v3 : a5.vertexLength;
                    this.indexArray.emplaceBack(T3 + 2, T3 + 3, e5), this.indexArray.emplaceBack(T3 + 3, e5 + 1, e5), this.indexArray.emplaceBack(T3 + 3, i7, e5 + 1), a5.primitiveLength += 3;
                  }
                  M3 = !M3;
                }
                if (h3) {
                  const t7 = this.layoutVertexExtArray, e5 = c3.projectTilePoint(l4.x, l4.y, n3), r5 = c3.projectTilePoint(p4.x, p4.y, n3), i7 = c3.upVector(n3, l4.x, l4.y), a6 = c3.upVector(n3, p4.x, p4.y);
                  Uh(t7, e5, i7), Uh(t7, e5, i7), Uh(t7, r5, a6), Uh(t7, r5, a6);
                }
              }
              p3 && (r4 += s5.length - 1), m2 && _2 && this.zoom >= 17 && (0 !== y3.length && A3(y3, y3[0]) && y3.pop(), this.groundEffect.addData(y3, e4, l3, _2 > 0));
            }
            this.footprintSegments.push(o4), s4.triangleCount = this.indexArray.length - s4.triangleArrayOffset, this.polygonSegments.push(s4), ++d3.footprintSegLen, ++d3.polygonSegLen;
          }
          if (d3.vertexCount = this.layoutVertexArray.length - d3.vertexArrayOffset, d3.groundVertexCount = this.groundEffect.vertexArray.length - d3.groundVertexArrayOffset, 0 !== d3.vertexCount) {
            if (d3.centroidXY = f3.borders ? Rh : this.encodeCentroid(f3, d3), this.centroidData.push(d3), f3.borders) {
              this.featuresOnBorder.push(f3);
              const t5 = this.featuresOnBorder.length - 1;
              for (let e4 = 0; e4 < f3.borders.length; e4++) f3.borders[e4][0] !== Number.MAX_VALUE && this.borderFeatureIndices[e4].push(t5);
            }
            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t4, r3, i3, a4, n3, o3), this.groundEffect.addPaintPropertiesData(t4, r3, i3, a4, n3, o3), this.maxHeight = Math.max(this.maxHeight, y2);
          }
        }
        sortBorders() {
          for (let t4 = 0; t4 < this.borderFeatureIndices.length; t4++) this.borderFeatureIndices[t4].sort((e3, r3) => this.featuresOnBorder[e3].borders[t4][0] - this.featuresOnBorder[r3].borders[t4][0]);
        }
        splitToSubtiles() {
          const t4 = [];
          for (let e4 = 0; e4 < this.centroidData.length; e4++) {
            const r4 = this.centroidData[e4], n4 = +(r4.min.y + r4.max.y > Wr), i4 = 2 * n4 + (+(r4.min.x + r4.max.x > Wr) ^ n4);
            for (let n5 = 0; n5 < r4.polygonSegLen; n5++) {
              const a5 = r4.polygonSegIdx + n5;
              t4.push({ centroidIdx: e4, subtile: i4, polygonSegmentIdx: a5, triangleSegmentIdx: this.polygonSegments[a5].triangleSegIdx });
            }
          }
          const e3 = new Cs();
          t4.sort((t5, e4) => t5.triangleSegmentIdx === e4.triangleSegmentIdx ? t5.subtile - e4.subtile : t5.triangleSegmentIdx - e4.triangleSegmentIdx);
          let r3 = 0, n3 = 0, i3 = 0;
          for (const e4 of t4) {
            if (e4.triangleSegmentIdx !== r3) break;
            i3++;
          }
          const a4 = t4.length;
          for (; n3 !== t4.length; ) {
            r3 = t4[n3].triangleSegmentIdx;
            let s3 = 0, o3 = n3, l3 = n3;
            for (let e4 = o3; e4 < i3 && t4[e4].subtile === s3; e4++) l3++;
            for (; o3 !== i3; ) {
              const n4 = t4[o3];
              s3 = n4.subtile;
              const a5 = this.centroidData[n4.centroidIdx].min.clone(), u4 = this.centroidData[n4.centroidIdx].max.clone(), c3 = { vertexOffset: this.segments.segments[r3].vertexOffset, primitiveOffset: e3.length, vertexLength: this.segments.segments[r3].vertexLength, primitiveLength: 0, sortKey: void 0, vaos: {} };
              for (let r4 = o3; r4 < l3; r4++) {
                const n5 = t4[r4], i4 = this.polygonSegments[n5.polygonSegmentIdx], s4 = this.centroidData[n5.centroidIdx].min, o4 = this.centroidData[n5.centroidIdx].max, l4 = this.indexArray.uint16;
                for (let t5 = i4.triangleArrayOffset; t5 < i4.triangleArrayOffset + i4.triangleCount; t5++) e3.emplaceBack(l4[3 * t5], l4[3 * t5 + 1], l4[3 * t5 + 2]);
                c3.primitiveLength += i4.triangleCount, a5.x = Math.min(a5.x, s4.x), a5.y = Math.min(a5.y, s4.y), u4.x = Math.max(u4.x, o4.x), u4.y = Math.max(u4.y, o4.y);
              }
              c3.primitiveLength > 0 && this.triangleSubSegments.push({ segment: c3, min: a5, max: u4 }), o3 = l3;
              for (let e4 = o3; e4 < i3 && t4[e4].subtile === t4[o3].subtile; e4++) l3++;
            }
            n3 = i3;
            for (let e4 = n3; e4 < a4 && t4[e4].triangleSegmentIdx === t4[n3].triangleSegmentIdx; e4++) i3++;
          }
          e3._trim(), this.indexArray = e3;
        }
        getVisibleSegments(t4, e3, r3) {
          const n3 = new co();
          if (this.wallMode) {
            for (const t5 of this.triangleSubSegments) n3.segments.push(t5.segment);
            return n3;
          }
          let i3 = 0, a4 = 0;
          const s3 = 1 << t4.canonical.z;
          if (e3) {
            const r4 = e3.getMinMaxForTile(t4);
            r4 && (i3 = r4.min, a4 = r4.max);
          }
          a4 += this.maxHeight;
          const o3 = t4.toUnwrapped();
          let l3;
          const u4 = [o3.canonical.x / s3 + o3.wrap, o3.canonical.y / s3], c3 = [(o3.canonical.x + 1) / s3 + o3.wrap, (o3.canonical.y + 1) / s3], h3 = (t5, e4, r4) => [t5[0] * (1 - r4[0]) + e4[0] * r4[0], t5[1] * (1 - r4[1]) + e4[1] * r4[1]], p3 = [], f3 = [];
          for (const t5 of this.triangleSubSegments) {
            p3[0] = t5.min.x / Wr, p3[1] = t5.min.y / Wr, f3[0] = t5.max.x / Wr, f3[1] = t5.max.y / Wr;
            const e4 = h3(u4, c3, p3), s4 = h3(u4, c3, f3);
            if (0 === new yu([e4[0], e4[1], i3], [s4[0], s4[1], a4]).intersectsPrecise(r3)) {
              l3 && (n3.segments.push(l3), l3 = void 0);
              continue;
            }
            const o4 = t5.segment;
            l3 && l3.vertexOffset !== o4.vertexOffset && (n3.segments.push(l3), l3 = void 0), l3 ? (l3.vertexLength += o4.vertexLength, l3.primitiveLength += o4.primitiveLength) : l3 = { vertexOffset: o4.vertexOffset, primitiveLength: o4.primitiveLength, vertexLength: o4.vertexLength, primitiveOffset: o4.primitiveOffset, sortKey: void 0, vaos: {} };
          }
          return l3 && n3.segments.push(l3), n3;
        }
        encodeCentroid(t4, e3) {
          const r3 = t4.centroid(), n3 = e3.span(), i3 = Math.min(7, Math.round(n3.x * this.tileToMeter / 10)), a4 = Math.min(7, Math.round(n3.y * this.tileToMeter / 10));
          return new q(Q2(r3.x, 1, Wr - 1) << 3 | i3, Q2(r3.y, 1, Wr - 1) << 3 | a4);
        }
        encodeBorderCentroid(t4) {
          if (!t4.borders) return new q(0, 0);
          const e3 = t4.borders, r3 = Number.MAX_VALUE;
          if (e3[0][0] !== r3 || e3[1][0] !== r3) {
            const t5 = e3[0][0] !== r3 ? 0 : 1;
            return new q(6 | (e3[0][0] !== r3 ? 0 : 65528), (e3[t5][0] + e3[t5][1]) / 2 << 3 | 6);
          }
          {
            const t5 = e3[2][0] !== r3 ? 2 : 3;
            return new q((e3[t5][0] + e3[t5][1]) / 2 << 3 | 6, 6 | (e3[2][0] !== r3 ? 0 : 65528));
          }
        }
        showCentroid(t4) {
          const e3 = this.centroidData[t4.centroidDataIndex];
          e3.flags &= Dh, e3.centroidXY.x = 0, e3.centroidXY.y = 0, this.writeCentroidToBuffer(e3);
        }
        writeCentroidToBuffer(t4) {
          this.groundEffect.updateHiddenByLandmark(t4);
          const e3 = t4.vertexArrayOffset, r3 = t4.vertexCount + t4.vertexArrayOffset, n3 = t4.flags & Dh ? Rh : t4.centroidXY, i3 = this.centroidVertexArray.geta_centroid_pos0(e3);
          if (this.centroidVertexArray.geta_centroid_pos1(e3) !== n3.y || i3 !== n3.x) {
            for (let t5 = e3; t5 < r3; ++t5) this.centroidVertexArray.emplace(t5, n3.x, n3.y);
            this.needsCentroidUpdate = true;
          }
        }
        createCentroidsBuffer() {
          this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
          for (const t4 of this.centroidData) this.writeCentroidToBuffer(t4);
        }
        updateReplacement(t4, e3, r3) {
          if (e3.updateTime === this.replacementUpdateTime) return;
          this.replacementUpdateTime = e3.updateTime;
          const n3 = e3.getReplacementRegionsForTile(t4.toUnwrapped());
          if (wh(this.activeReplacements, n3)) return;
          if (this.activeReplacements = n3, 0 === this.centroidVertexArray.length) this.createCentroidsBuffer();
          else for (const t5 of this.centroidData) t5.flags &= 2147483647;
          const i3 = [];
          for (const e4 of this.activeReplacements) {
            if (e4.order < r3) continue;
            const n4 = Math.max(1, Math.pow(2, e4.footprintTileId.canonical.z - t4.canonical.z));
            for (const r4 of this.centroidData) if (!(r4.flags & Dh || e4.min.x > r4.max.x || r4.min.x > e4.max.x || e4.min.y > r4.max.y || r4.min.y > e4.max.y)) for (let a4 = 0; a4 < r4.footprintSegLen; a4++) {
              const s3 = this.footprintSegments[r4.footprintSegIdx + a4];
              if (i3.length = 0, ip(this.footprintVertices, s3.vertexOffset, s3.vertexCount, e4.footprintTileId.canonical, t4.canonical, i3), Ah(e4.footprint, i3, this.footprintIndices.uint16, s3.indexOffset, s3.indexCount, -s3.vertexOffset, -n4)) {
                r4.flags |= Dh;
                break;
              }
            }
          }
          for (const t5 of this.centroidData) this.writeCentroidToBuffer(t5);
          this.borderDoneWithNeighborZ = [-1, -1, -1, -1];
        }
        footprintContainsPoint(t4, e3, r3) {
          let n3 = false;
          for (let i3 = 0; i3 < r3.footprintSegLen; i3++) {
            const a4 = this.footprintSegments[r3.footprintSegIdx + i3];
            let s3 = 0;
            for (const r4 of a4.ringIndices) {
              for (let i4 = s3, o3 = r4 + s3 - 1; i4 < r4 + s3; o3 = i4++) {
                const r5 = this.footprintVertices.int16[2 * (i4 + a4.vertexOffset) + 0], s4 = this.footprintVertices.int16[2 * (i4 + a4.vertexOffset) + 1], l3 = this.footprintVertices.int16[2 * (o3 + a4.vertexOffset) + 1];
                s4 > e3 != l3 > e3 && t4 < (this.footprintVertices.int16[2 * (o3 + a4.vertexOffset) + 0] - r5) * (e3 - s4) / (l3 - s4) + r5 && (n3 = !n3);
              }
              s3 = r4;
            }
          }
          return n3;
        }
        getHeightAtTileCoord(t4, e3) {
          let r3 = Number.NEGATIVE_INFINITY, n3 = true;
          const i3 = 4 * (t4 + Wr) * Wr + (e3 + Wr);
          if (this.partLookup.hasOwnProperty(i3)) {
            const t5 = this.partLookup[i3];
            return t5 ? { height: t5.height, hidden: !!(t5.flags & Dh) } : void 0;
          }
          for (const a4 of this.centroidData) t4 > a4.max.x || a4.min.x > t4 || e3 > a4.max.y || a4.min.y > e3 || this.footprintContainsPoint(t4, e3, a4) && a4 && a4.height > r3 && (r3 = a4.height, this.partLookup[i3] = a4, n3 = !!(a4.flags & Dh));
          if (r3 !== Number.NEGATIVE_INFINITY) return { height: r3, hidden: n3 };
          this.partLookup[i3] = void 0;
        }
      }
      function Wh(t4, e3) {
        const r3 = t4.add(e3)._unit();
        return t4.x * r3.x + t4.y * r3.y;
      }
      function Hh(t4, e3, r3, n3) {
        const i3 = e3.sub(t4)._perp()._unit(), a4 = r3.sub(e3)._perp()._unit();
        return Kh(t4, e3, r3, Wh(i3, a4), n3);
      }
      function Kh(t4, e3, r3, n3, i3) {
        const a4 = Math.sqrt(1 - n3 * n3);
        return Math.min(t4.dist(e3) / 3, e3.dist(r3) / 3, i3 * a4 / n3);
      }
      function Jh(t4, e3, r3) {
        return t4.x < r3[0].x && e3.x < r3[0].x || t4.x > r3[1].x && e3.x > r3[1].x || t4.y < r3[0].y && e3.y < r3[0].y || t4.y > r3[1].y && e3.y > r3[1].y;
      }
      function Qh(t4, e3) {
        return t4.x < e3[0].x || t4.x > e3[1].x || t4.y < e3[0].y || t4.y > e3[1].y;
      }
      function tp(t4, e3, r3) {
        if (t4.x < 0 || t4.x >= Wr || e3.x < 0 || e3.x >= Wr || r3.x < 0 || r3.x >= Wr) return false;
        const n3 = r3.sub(e3), i3 = n3.perp(), a4 = t4.sub(e3);
        return (n3.x * a4.x + n3.y * a4.y) / Math.sqrt((n3.x * n3.x + n3.y * n3.y) * (a4.x * a4.x + a4.y * a4.y)) > -0.866 && i3.x * a4.x + i3.y * a4.y < 0;
      }
      function ep(t4, e3, r3) {
        const n3 = e3 ? 2 | t4 : -3 & t4;
        return r3 ? 1 | n3 : -2 & n3;
      }
      function rp() {
        const t4 = Math.PI / 32, e3 = Math.tan(t4), r3 = tl;
        return r3 * Math.sqrt(1 + 2 * e3 * e3) - r3;
      }
      function np(t4, e3, r3) {
        const n3 = 1 << r3.z, i3 = cl(r3.x / n3), a4 = cl((r3.x + 1) / n3), s3 = hl(r3.y / n3), o3 = hl((r3.y + 1) / n3);
        return function(t5, e4, r4, n4, i4 = 0, a5) {
          const s4 = [];
          if (!t5.length || !r4 || !n4) return s4;
          const o4 = (t6, e5) => {
            for (const r5 of t6) s4.push({ polygon: r5, bounds: e5 });
          }, l3 = Math.ceil(Math.log2(r4)), u4 = Math.ceil(Math.log2(n4)), c3 = l3 - u4, h3 = [];
          for (let t6 = 0; t6 < Math.abs(c3); t6++) h3.push(c3 > 0 ? 0 : 1);
          for (let t6 = 0; t6 < Math.min(l3, u4); t6++) h3.push(0), h3.push(1);
          let p3 = t5;
          if (p3 = fh(p3, e4[0].y - i4, e4[1].y + i4, 1), p3 = fh(p3, e4[0].x - i4, e4[1].x + i4, 0), !p3.length) return s4;
          const f3 = [];
          for (h3.length ? f3.push({ polygons: p3, bounds: e4, depth: 0 }) : o4(p3, e4); f3.length; ) {
            const t6 = f3.pop(), e5 = t6.depth, r5 = h3[e5], n5 = t6.bounds[0], s5 = t6.bounds[1], l4 = 0 === r5 ? n5.x : n5.y, u5 = 0 === r5 ? s5.x : s5.y, c4 = a5 ? a5(r5, l4, u5) : 0.5 * (l4 + u5), p4 = fh(t6.polygons, l4 - i4, c4 + i4, r5), d3 = fh(t6.polygons, c4 - i4, u5 + i4, r5);
            if (p4.length) {
              const t7 = [n5, new q(0 === r5 ? c4 : s5.x, 1 === r5 ? c4 : s5.y)];
              h3.length > e5 + 1 ? f3.push({ polygons: p4, bounds: t7, depth: e5 + 1 }) : o4(p4, t7);
            }
            if (d3.length) {
              const t7 = [new q(0 === r5 ? c4 : n5.x, 1 === r5 ? c4 : n5.y), s5];
              h3.length > e5 + 1 ? f3.push({ polygons: d3, bounds: t7, depth: e5 + 1 }) : o4(d3, t7);
            }
          }
          return s4;
        }(t4, e3, Math.ceil((a4 - i3) / 11.25), Math.ceil((s3 - o3) / 11.25), 1, (t5, e4, i4) => {
          if (0 === t5) return 0.5 * (e4 + i4);
          {
            const t6 = hl((r3.y + e4 / Wr) / n3);
            return (ll(0.5 * (hl((r3.y + i4 / Wr) / n3) + t6)) * n3 - r3.y) * Wr;
          }
        });
      }
      function ip(t4, e3, r3, n3, i3, a4) {
        const s3 = Math.pow(2, n3.z - i3.z);
        for (let o3 = 0; o3 < r3; o3++) {
          let r4 = t4.int16[2 * (o3 + e3) + 0], l3 = t4.int16[2 * (o3 + e3) + 1];
          r4 = (r4 + i3.x * Wr) * s3 - n3.x * Wr, l3 = (l3 + i3.y * Wr) * s3 - n3.y * Wr, a4.push(new q(r4, l3));
        }
      }
      let ap, sp;
      function op(t4, e3) {
        return t4.x * e3.x + t4.y * e3.y;
      }
      function lp(t4, e3) {
        if (1 === t4.length) {
          let r3 = 0;
          const n3 = e3[r3++];
          let i3;
          for (; !i3 || n3.equals(i3); ) if (i3 = e3[r3++], !i3) return 1 / 0;
          for (; r3 < e3.length; r3++) {
            const a4 = e3[r3], s3 = t4[0], o3 = i3.sub(n3), l3 = a4.sub(n3), u4 = s3.sub(n3), c3 = op(o3, o3), h3 = op(o3, l3), p3 = op(l3, l3), f3 = op(u4, o3), d3 = op(u4, l3), m2 = c3 * p3 - h3 * h3, y2 = (p3 * f3 - h3 * d3) / m2, g4 = (c3 * d3 - h3 * f3) / m2, x2 = n3.z * (1 - y2 - g4) + i3.z * y2 + a4.z * g4;
            if (isFinite(x2)) return x2;
          }
          return 1 / 0;
        }
        {
          let t5 = 1 / 0;
          for (const r3 of e3) t5 = Math.min(t5, r3.z);
          return t5;
        }
      }
      function up(t4, e3, r3, n3, i3, a4, s3, o3) {
        const l3 = s3 * i3.getElevationAt(t4, e3, true, true), u4 = 0 !== a4[0], c3 = u4 ? 0 === a4[1] ? s3 * (a4[0] / 7 - 450) : s3 * function(t5, e4, r4) {
          const n4 = Math.floor(e4[0] / 8), i4 = Math.floor(e4[1] / 8), a5 = 10 * (e4[0] - 8 * n4), s4 = 10 * (e4[1] - 8 * i4), o4 = t5.getElevationAt(n4, i4, true, true), l4 = t5.getMeterToDEM(r4), u5 = Math.floor(0.5 * (a5 * l4 - 1)), c4 = Math.floor(0.5 * (s4 * l4 - 1)), h3 = t5.tileCoordToPixel(n4, i4), p3 = 2 * u5 + 1, f3 = 2 * c4 + 1, d3 = function(t6, e5, r5, n5, i5) {
            return [t6.getElevationAtPixel(e5, r5, true), t6.getElevationAtPixel(e5 + i5, r5, true), t6.getElevationAtPixel(e5, r5 + i5, true), t6.getElevationAtPixel(e5 + n5, r5 + i5, true)];
          }(t5, h3.x - u5, h3.y - c4, p3, f3), m2 = Math.abs(d3[0] - d3[1]), y2 = Math.abs(d3[2] - d3[3]), g4 = Math.abs(d3[0] - d3[2]) + Math.abs(d3[1] - d3[3]), x2 = Math.min(0.25, 0.5 * l4 * (m2 + y2) / p3), v2 = Math.min(0.25, 0.5 * l4 * g4 / f3);
          return o4 + Math.max(x2 * a5, v2 * s4);
        }(i3, a4, o3) : l3;
        return { base: l3 + (0 === r3 ? -1 : r3), top: u4 ? Math.max(c3 + n3, l3 + r3 + 2) : l3 + n3 };
      }
      aa(Zh, "FillExtrusionBucket", { omit: ["layers", "features"] }), aa(Nh, "PartData"), aa(jh, "FootprintSegment"), aa(qh, "BorderCentroidData"), aa(Yh, "GroundEffect");
      const cp = ds([{ name: "a_pos_normal", components: 2, type: "Int16" }, { name: "a_data", components: 4, type: "Uint8" }, { name: "a_linesofar", components: 1, type: "Float32" }], 4), hp = ds([{ name: "a_z_offset", components: 1, type: "Float32" }], 4), { members: pp } = cp, fp = ds([{ name: "a_packed", components: 4, type: "Float32" }]), { members: dp } = fp, mp = ds([{ name: "a_pattern_data", components: 3, type: "Float32" }]), { members: yp } = mp;
      class gp {
        constructor(t4, e3) {
          this.width = t4, this.height = e3, this.nextRow = 0, this.image = new nc({ width: t4, height: e3 }), this.positions = {}, this.uploaded = false;
        }
        getDash(t4, e3) {
          const r3 = this.getKey(t4, e3);
          return this.positions[r3];
        }
        trim() {
          const t4 = this.width, e3 = this.height = st(this.nextRow);
          this.image.resize({ width: t4, height: e3 });
        }
        getKey(t4, e3) {
          return t4.join(",") + e3;
        }
        getDashRanges(t4, e3, r3) {
          const n3 = [];
          let i3 = t4.length % 2 == 1 ? -t4[t4.length - 1] * r3 : 0, a4 = t4[0] * r3, s3 = true;
          n3.push({ left: i3, right: a4, isDash: s3, zeroLength: 0 === t4[0] });
          let o3 = t4[0];
          for (let e4 = 1; e4 < t4.length; e4++) {
            s3 = !s3;
            const l3 = t4[e4];
            i3 = o3 * r3, o3 += l3, a4 = o3 * r3, n3.push({ left: i3, right: a4, isDash: s3, zeroLength: 0 === l3 });
          }
          return n3;
        }
        addRoundDash(t4, e3, r3) {
          const n3 = e3 / 2;
          for (let e4 = -r3; e4 <= r3; e4++) {
            const i3 = this.width * (this.nextRow + r3 + e4);
            let a4 = 0, s3 = t4[a4];
            for (let o3 = 0; o3 < this.width; o3++) {
              o3 / s3.right > 1 && (s3 = t4[++a4]);
              const l3 = Math.abs(o3 - s3.left), u4 = Math.abs(o3 - s3.right), c3 = Math.min(l3, u4);
              let h3;
              const p3 = e4 / r3 * (n3 + 1);
              if (s3.isDash) {
                const t5 = n3 - Math.abs(p3);
                h3 = Math.sqrt(c3 * c3 + t5 * t5);
              } else h3 = n3 - Math.sqrt(c3 * c3 + p3 * p3);
              this.image.data[i3 + o3] = Math.max(0, Math.min(255, h3 + 128));
            }
          }
        }
        addRegularDash(t4, e3) {
          for (let e4 = t4.length - 1; e4 >= 0; --e4) {
            const r4 = t4[e4], n4 = t4[e4 + 1];
            r4.zeroLength ? t4.splice(e4, 1) : n4 && n4.isDash === r4.isDash && (n4.left = r4.left, t4.splice(e4, 1));
          }
          const r3 = t4[0], n3 = t4[t4.length - 1];
          r3.isDash === n3.isDash && (r3.left = n3.left - this.width, n3.right = r3.right + this.width);
          const i3 = this.width * this.nextRow;
          let a4 = 0, s3 = t4[a4];
          for (let r4 = 0; r4 < this.width; r4++) {
            r4 / s3.right > 1 && (s3 = t4[++a4]);
            const n4 = Math.abs(r4 - s3.left), o3 = Math.abs(r4 - s3.right), l3 = Math.min(n4, o3);
            this.image.data[i3 + r4] = Math.max(0, Math.min(255, (s3.isDash ? l3 : -l3) + e3 + 128));
          }
        }
        addDash(t4, e3) {
          const r3 = this.getKey(t4, e3);
          if (this.positions[r3]) return this.positions[r3];
          const n3 = "round" === e3, i3 = n3 ? 7 : 0, a4 = 2 * i3 + 1;
          if (this.nextRow + a4 > this.height) return ft("LineAtlas out of space"), null;
          0 === t4.length && t4.push(1);
          let s3 = 0;
          for (let e4 = 0; e4 < t4.length; e4++) t4[e4] < 0 && (ft("Negative value is found in line dasharray, replacing values with 0"), t4[e4] = 0), s3 += t4[e4];
          if (0 !== s3) {
            const r4 = this.width / s3, a5 = this.getDashRanges(t4, this.width, r4);
            n3 ? this.addRoundDash(a5, r4, i3) : this.addRegularDash(a5, "square" === e3 ? 0.5 * r4 : 0);
          }
          const o3 = this.nextRow + i3;
          this.nextRow += a4;
          const l3 = { tl: [o3, i3], br: [s3, 0] };
          return this.positions[r3] = l3, l3;
        }
      }
      aa(gp, "LineAtlas");
      const xp = ch.VectorTileFeature.types, vp = Math.cos(Math.PI / 180 * 37.5), bp = Math.cos(Math.PI / 180 * 5);
      class wp {
        constructor(t4) {
          this.evaluationGlobals = { zoom: 0, lineProgress: void 0 }, this.zoom = t4.zoom, this.evaluationGlobals.zoom = this.zoom, this.overscaling = t4.overscaling, this.layers = t4.layers, this.layerIds = this.layers.map((t5) => t5.fqid), this.index = t4.index, this.projection = t4.projection, this.hasPattern = false, this.hasZOffset = false, this.hasCrossSlope = false, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t5) => {
            this.gradients[t5.id] = {};
          }), this.layoutVertexArray = new bs(), this.layoutVertexArray2 = new ws(), this.patternVertexArray = new _s(), this.indexArray = new Cs(), this.programConfigurations = new Fo(t4.layers, { zoom: t4.zoom, lut: t4.lut }), this.segments = new co(), this.maxLineLength = 0, this.zOffsetVertexArray = new Ls(), this.stateDependentLayerIds = this.layers.filter((t5) => t5.isStateDependent()).map((t5) => t5.id), this.tessellationStep = t4.tessellationStep ? t4.tessellationStep : Wr / 64;
        }
        updateFootprints(t4, e3) {
        }
        populate(t4, e3, r3, n3) {
          this.hasPattern = Dc("line", this.layers, e3);
          const i3 = this.layers[0].layout.get("line-sort-key");
          this.hasZOffset = !this.layers[0].isDraped();
          const a4 = this.layers[0].layout.get("line-elevation-reference");
          this.hasZOffset && "none" === a4 && ft(`line-elevation-reference: ground is used for the layer ${this.layerIds[0]} because non-zero line-z-offset value was found.`);
          const s3 = this.layers[0].layout.get("line-cross-slope");
          this.hasCrossSlope = this.hasZOffset && void 0 !== s3;
          const o3 = [];
          for (const { feature: e4, id: a5, index: s4, sourceLayerIndex: l4 } of t4) {
            const t5 = this.layers[0]._featureFilter.needGeometry, u5 = zl(e4, t5);
            if (!this.layers[0]._featureFilter.filter(new Ea(this.zoom), u5, r3)) continue;
            const c4 = i3 ? i3.evaluate(u5, {}, r3) : void 0, h3 = { id: a5, properties: e4.properties, type: e4.type, sourceLayerIndex: l4, index: s4, geometry: t5 ? u5.geometry : Il(e4, r3, n3), patterns: {}, sortKey: c4 };
            o3.push(h3);
          }
          i3 && o3.sort((t5, e4) => t5.sortKey - e4.sortKey);
          const { lineAtlas: l3, featureIndex: u4 } = e3, c3 = this.addConstantDashes(l3);
          for (const n4 of o3) {
            const { geometry: i4, index: a5, sourceLayerIndex: s4 } = n4;
            if (c3 && this.addFeatureDashes(n4, l3), this.hasPattern) {
              const t5 = Lc("line", this.layers, n4, this.zoom, e3);
              this.patternFeatures.push(t5);
            } else this.addFeature(n4, i4, a5, r3, l3.positions, e3.availableImages, e3.brightness);
            u4.insert(t4[a5].feature, i4, a5, s4, this.index);
          }
        }
        addConstantDashes(t4) {
          let e3 = false;
          for (const r3 of this.layers) {
            const n3 = r3.paint.get("line-dasharray").value, i3 = r3.layout.get("line-cap").value;
            if ("constant" !== n3.kind || "constant" !== i3.kind) e3 = true;
            else {
              const e4 = i3.value, r4 = n3.value;
              if (!r4) continue;
              t4.addDash(r4, e4);
            }
          }
          return e3;
        }
        addFeatureDashes(t4, e3) {
          const r3 = this.zoom;
          for (const n3 of this.layers) {
            const i3 = n3.paint.get("line-dasharray").value, a4 = n3.layout.get("line-cap").value;
            if ("constant" === i3.kind && "constant" === a4.kind) continue;
            let s3, o3;
            if ("constant" === i3.kind) {
              if (s3 = i3.value, !s3) continue;
            } else s3 = i3.evaluate({ zoom: r3 }, t4);
            o3 = "constant" === a4.kind ? a4.value : a4.evaluate({ zoom: r3 }, t4), e3.addDash(s3, o3), t4.patterns[n3.id] = e3.getKey(s3, o3);
          }
        }
        update(t4, e3, r3, n3, i3) {
          const a4 = 0 !== Object.keys(t4).length;
          a4 && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(t4, e3, a4 ? this.stateDependentLayers : this.layers, r3, n3, i3);
        }
        addFeatures(t4, e3, r3, n3, i3, a4) {
          for (const t5 of this.patternFeatures) this.addFeature(t5, t5.geometry, t5.index, e3, r3, n3, a4);
        }
        isEmpty() {
          return 0 === this.layoutVertexArray.length;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(t4) {
          this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t4.createVertexBuffer(this.layoutVertexArray2, dp)), 0 !== this.patternVertexArray.length && (this.patternVertexBuffer = t4.createVertexBuffer(this.patternVertexArray, yp)), !this.zOffsetVertexBuffer && this.zOffsetVertexArray.length > 0 && (this.zOffsetVertexBuffer = t4.createVertexBuffer(this.zOffsetVertexArray, hp.members, true)), this.layoutVertexBuffer = t4.createVertexBuffer(this.layoutVertexArray, pp), this.indexBuffer = t4.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t4), this.uploaded = true;
        }
        destroy() {
          this.layoutVertexBuffer && (this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }
        lineFeatureClips(t4) {
          if (t4.properties && t4.properties.hasOwnProperty("mapbox_clip_start") && t4.properties.hasOwnProperty("mapbox_clip_end")) return { start: +t4.properties.mapbox_clip_start, end: +t4.properties.mapbox_clip_end };
        }
        addFeature(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = this.layers[0].layout, l3 = o3.get("line-join").evaluate(t4, {}), u4 = o3.get("line-cap").evaluate(t4, {}), c3 = o3.get("line-miter-limit"), h3 = o3.get("line-round-limit");
          this.lineClips = this.lineFeatureClips(t4), this.lineFeature = t4, this.zOffsetValue = o3.get("line-z-offset").value;
          for (const r4 of e3) this.addLine(r4, t4, n3, l3, u4, c3, h3);
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t4, r3, i3, a4, n3, s3);
        }
        addLine(t4, e3, r3, n3, i3, a4, s3) {
          this.distance = 0, this.prevDistance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.totalFeatureLength = 0, this.lineSoFar = 0, this.currentVertex = void 0;
          const o3 = "none" === n3;
          if (this.patternJoinNone = this.hasPattern && o3, this.segmentStart = 0, this.segmentStartf32 = 0, this.segmentPoints = [], this.lineClips) {
            this.lineClipsArray.push(this.lineClips);
            for (let e4 = 0; e4 < t4.length - 1; e4++) this.totalDistance += t4[e4].dist(t4[e4 + 1]);
            this.totalFeatureLength = this.totalDistance / (this.lineClips.end - this.lineClips.start), this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
          }
          const l3 = "Polygon" === xp[e3.type];
          let u4 = t4.length;
          for (; u4 >= 2 && t4[u4 - 1].equals(t4[u4 - 2]); ) u4--;
          let c3 = 0;
          for (; c3 < u4 - 1 && t4[c3].equals(t4[c3 + 1]); ) c3++;
          if (u4 < (l3 ? 3 : 2)) return;
          "bevel" === n3 && (a4 = 1.05);
          const h3 = this.segments.prepareSegment(10 * u4, this.layoutVertexArray, this.indexArray);
          let p3, f3, d3, m2, y2, g4;
          this.e1 = this.e2 = -1, l3 && (p3 = t4[u4 - 2], y2 = t4[c3].sub(p3)._unit()._perp());
          for (let e4 = c3; e4 < u4; e4++) {
            if (d3 = e4 === u4 - 1 ? l3 ? t4[c3 + 1] : void 0 : t4[e4 + 1], d3 && t4[e4].equals(d3)) continue;
            y2 && (m2 = y2), p3 && (f3 = p3), p3 = t4[e4], g4 = this.hasZOffset ? this.evaluateElevationValue(f3 ? f3.dist(p3) : 0) : null, y2 = d3 ? d3.sub(p3)._unit()._perp() : m2, m2 = m2 || y2;
            const r4 = f3 && d3;
            let x2 = r4 ? n3 : l3 || o3 ? "butt" : i3;
            const v2 = m2.x * y2.x + m2.y * y2.y;
            if (o3) {
              const t5 = function(t6) {
                if (t6.patternJoinNone) {
                  const e5 = t6.segmentPoints.length / 2, r5 = t6.lineSoFar - t6.segmentStart;
                  for (let n4 = 0; n4 < e5; ++n4) {
                    const e6 = t6.segmentPoints[2 * n4 + 1], i4 = Math.round(t6.segmentPoints[2 * n4]) + 0.5 + 0.25 * e6;
                    t6.patternVertexArray.emplaceBack(i4, r5, t6.segmentStart), t6.patternVertexArray.emplaceBack(i4, r5, t6.segmentStart);
                  }
                  t6.segmentPoints.length = 0;
                }
                t6.e1 = t6.e2 = -1;
              };
              if (r4 && v2 < bp) {
                this.updateDistance(f3, p3), this.addCurrentVertex(p3, m2, 1, 1, h3, g4), t5(this), this.addCurrentVertex(p3, y2, -1, -1, h3, g4);
                continue;
              }
              if (f3) {
                if (!d3) {
                  this.updateDistance(f3, p3), this.addCurrentVertex(p3, m2, 1, 1, h3, g4), t5(this);
                  continue;
                }
                x2 = "miter";
              }
            }
            let b2 = m2.add(y2);
            0 === b2.x && 0 === b2.y || b2._unit();
            const w2 = b2.x * y2.x + b2.y * y2.y, _2 = 0 !== w2 ? 1 / w2 : 1 / 0, M2 = 2 * Math.sqrt(2 - 2 * w2), A3 = w2 < vp && f3 && d3, S2 = m2.x * y2.y - m2.y * y2.x > 0, I3 = this.overscaling <= 16 ? 15 * Wr / (512 * this.overscaling) : 0;
            if (r4 && "round" === x2) {
              if (_2 < s3) x2 = "miter";
              else if (_2 <= 2) {
                const t5 = _p(p3, -10, Wr + 10);
                x2 = this.hasZOffset && (t5 || this.hasCrossSlope) ? "miter" : "fakeround";
              }
            }
            if ("miter" === x2 && _2 > a4 && (x2 = "bevel"), "bevel" === x2 && (_2 > 2 && (x2 = "flipbevel"), _2 < a4 && (x2 = "miter")), f3 && !("miter" === x2 && A3) && this.updateDistance(f3, p3), "miter" === x2) if (A3) {
              const t5 = p3.dist(f3);
              if (t5 > 2 * I3) {
                const e6 = p3.sub(p3.sub(f3)._mult(I3 / t5)._round());
                this.updateDistance(f3, e6), this.addCurrentVertex(e6, m2, 0, 0, h3, g4), f3 = e6;
              }
              this.updateDistance(f3, p3), b2._mult(_2), this.addCurrentVertex(p3, b2, 0, 0, h3, g4);
              const e5 = p3.dist(d3);
              if (e5 > 2 * I3) {
                const t6 = p3.add(d3.sub(p3)._mult(I3 / e5)._round());
                this.updateDistance(p3, t6), this.addCurrentVertex(t6, y2, 0, 0, h3, g4), p3 = t6;
              }
            } else b2._mult(_2), this.addCurrentVertex(p3, b2, 0, 0, h3, g4);
            else if ("flipbevel" === x2) {
              if (_2 > 100) b2 = y2.mult(-1);
              else {
                const t5 = _2 * m2.add(y2).mag() / m2.sub(y2).mag();
                b2._perp()._mult(t5 * (S2 ? -1 : 1));
              }
              this.addCurrentVertex(p3, b2, 0, 0, h3, g4), this.addCurrentVertex(p3, b2.mult(-1), 0, 0, h3, g4);
            } else if ("bevel" === x2 || "fakeround" === x2) {
              null != g4 && f3 && this.addCurrentVertex(p3, m2, -1, -1, h3, g4);
              const t5 = p3.dist(f3) <= 2 * I3 && "bevel" !== x2, e5 = b2.mult(S2 ? 1 : -1);
              e5._mult(_2);
              const r5 = y2.mult(S2 ? -1 : 1), n4 = m2.mult(S2 ? -1 : 1), i4 = this.evaluateElevationValue(this.distance);
              if (null == g4 && (this.addHalfVertex(p3, e5.x, e5.y, false, !S2, 0, h3, i4), t5 || this.addHalfVertex(p3, e5.x + 2 * n4.x, e5.y + 2 * n4.y, false, S2, 0, h3, i4)), "fakeround" === x2) {
                const t6 = Math.round(180 * M2 / Math.PI / 20);
                this.addHalfVertex(p3, n4.x, n4.y, false, S2, 0, h3, i4);
                for (let e6 = 0; e6 < t6; e6++) {
                  let a5 = e6 / t6;
                  if (0.5 !== a5) {
                    const t7 = a5 - 0.5;
                    a5 += a5 * t7 * (a5 - 1) * ((1.0904 + v2 * (v2 * (3.55645 - 1.43519 * v2) - 3.2452)) * t7 * t7 + (0.848013 + v2 * (0.215638 * v2 - 1.06021)));
                  }
                  const s4 = r5.sub(n4)._mult(a5)._add(n4)._unit();
                  this.addHalfVertex(p3, s4.x, s4.y, false, S2, 0, h3, i4);
                }
                this.addHalfVertex(p3, r5.x, r5.y, false, S2, 0, h3, i4);
              }
              t5 || null != g4 || this.addHalfVertex(p3, e5.x + 2 * r5.x, e5.y + 2 * r5.y, false, S2, 0, h3, i4), null != g4 && d3 && this.addCurrentVertex(p3, y2, 1, 1, h3, g4);
            } else "butt" === x2 ? this.addCurrentVertex(p3, b2, 0, 0, h3, g4) : "square" === x2 ? (f3 || this.addCurrentVertex(p3, b2, -1, -1, h3, g4), this.addCurrentVertex(p3, b2, 0, 0, h3, g4), f3 && this.addCurrentVertex(p3, b2, 1, 1, h3, g4)) : "round" === x2 && (f3 && (this.addCurrentVertex(p3, m2, 0, 0, h3, g4), this.addCurrentVertex(p3, m2, 1, 1, h3, g4, true)), d3 && (this.addCurrentVertex(p3, y2, -1, -1, h3, g4, true), this.addCurrentVertex(p3, y2, 0, 0, h3, g4)));
          }
        }
        addVerticesTo(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4) {
          const c3 = (e3.w - t4.w) / this.tessellationStep | 0;
          let h3 = 0;
          const p3 = this.scaledDistance;
          if (c3 > 1) {
            this.lineSoFar = t4.w;
            const p4 = (e3.x - t4.x) / c3, f4 = (e3.y - t4.y) / c3, d3 = (e3.z - t4.z) / c3, m2 = (e3.w - t4.w) / c3;
            for (let e4 = 1; e4 < c3; ++e4) {
              t4.x += p4, t4.y += f4, t4.z += d3, this.lineSoFar += m2, h3 += m2;
              const e5 = this.evaluateElevationValue(this.prevDistance + h3);
              this.scaledDistance = (this.prevDistance + h3) / this.totalDistance, this.addHalfVertex(t4, r3, n3, u4, false, s3, l3, e5), this.addHalfVertex(t4, i3, a4, u4, true, -o3, l3, e5);
            }
          }
          this.lineSoFar = e3.w, this.scaledDistance = p3;
          const f3 = this.evaluateElevationValue(this.distance);
          this.addHalfVertex(e3, r3, n3, u4, false, s3, l3, f3), this.addHalfVertex(e3, i3, a4, u4, true, -o3, l3, f3);
        }
        evaluateElevationValue(t4) {
          return this.hasZOffset ? "constant" === this.zOffsetValue.kind ? this.zOffsetValue.value : (this.evaluationGlobals.lineProgress = 0, this.lineClips ? this.evaluationGlobals.lineProgress = Math.min(1, (this.totalFeatureLength * this.lineClips.start + t4) / this.totalFeatureLength) : ft(`line-z-offset evaluation for ${this.layerIds[0]} requires enabling 'lineMetrics' for the source.`), this.zOffsetValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0) : void 0;
        }
        addCurrentVertex(t4, e3, r3, n3, i3, a4, s3 = false) {
          const o3 = e3.x + e3.y * r3, l3 = e3.y - e3.x * r3, u4 = e3.y * n3 - e3.x, c3 = -e3.y - e3.x * n3;
          if (null != a4) {
            const e4 = -10, h3 = Wr + 10, p3 = a4, f3 = new ph(t4.x, t4.y, p3, this.lineSoFar), d3 = _p(t4, e4, h3), m2 = this.lineSoFar, y2 = this.distance;
            if (this.currentVertex) if (d3) {
              const a5 = this.currentVertexIsOutside, d4 = this.currentVertex, m3 = new ph(t4.x, t4.y, p3, this.lineSoFar);
              if (mh(d4, m3, e4, h3), !_p(m3, e4, h3)) {
                if (a5) {
                  this.e1 = this.e2 = -1, this.distance -= d4.dist(f3), this.lineSoFar = d4.w;
                  const t5 = this.evaluateElevationValue(d4.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                  this.addHalfVertex(d4, o3, l3, s3, false, r3, i3, t5), this.addHalfVertex(d4, u4, c3, s3, true, -n3, i3, t5), this.prevDistance = this.distance;
                }
                this.distance = this.prevDistance + d4.dist(m3), this.scaledDistance = this.distance / this.totalDistance, this.addVerticesTo(d4, m3, o3, l3, u4, c3, r3, n3, i3, s3), this.distance = y2, this.scaledDistance = this.distance / this.totalDistance;
              }
            } else {
              const t5 = this.currentVertex;
              if (this.currentVertexIsOutside) {
                mh(t5, f3, e4, h3), this.e1 = this.e2 = -1, this.distance -= t5.dist(f3), this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = t5.w;
                const a5 = this.evaluateElevationValue(t5.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                this.addHalfVertex(t5, o3, l3, s3, false, r3, i3, a5), this.addHalfVertex(t5, u4, c3, s3, true, -n3, i3, a5), this.prevDistance = this.distance, this.distance = y2, this.scaledDistance = this.distance / this.totalDistance;
              }
              this.addVerticesTo(t5, f3, o3, l3, u4, c3, r3, n3, i3, s3);
            }
            else d3 || (this.addHalfVertex(t4, o3, l3, s3, false, r3, i3, a4), this.addHalfVertex(t4, u4, c3, s3, true, -n3, i3, a4));
            this.currentVertex = f3, this.currentVertexIsOutside = d3, this.lineSoFar = m2;
          } else this.addHalfVertex(t4, o3, l3, s3, false, r3, i3, a4), this.addHalfVertex(t4, u4, c3, s3, true, -n3, i3, a4);
        }
        addHalfVertex({ x: t4, y: e3 }, r3, n3, i3, a4, s3, o3, l3) {
          this.patternJoinNone && (0 === this.segmentPoints.length && (this.segmentStart = this.lineSoFar, this.segmentStartf32 = Math.fround(this.lineSoFar)), a4 || this.segmentPoints.push(this.lineSoFar - this.segmentStart, s3)), this.layoutVertexArray.emplaceBack((t4 << 1) + (i3 ? 1 : 0), (e3 << 1) + (a4 ? 1 : 0), Math.round(63 * r3) + 128, Math.round(63 * n3) + 128, 1 + (0 === s3 ? 0 : s3 < 0 ? -1 : 1), 0, this.lineSoFar - this.segmentStartf32), this.lineClips && this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, this.lineClips.start, this.lineClips.end);
          const u4 = o3.vertexLength++;
          this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u4), o3.primitiveLength++), a4 ? this.e2 = u4 : this.e1 = u4, null != l3 && this.zOffsetVertexArray.emplaceBack(l3);
        }
        updateScaledDistance() {
          this.lineClips ? (this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = this.totalFeatureLength * this.lineClips.start + this.distance) : this.lineSoFar = this.distance;
        }
        updateDistance(t4, e3) {
          this.prevDistance = this.distance, this.distance += t4.dist(e3), this.updateScaledDistance();
        }
      }
      function _p(t4, e3, r3) {
        return t4.x < e3 || t4.x > r3 || t4.y < e3 || t4.y > r3;
      }
      let Mp, Ap;
      function Sp(t4, e3, r3) {
        return e3 * (Wr / (t4.tileSize * Math.pow(2, r3 - t4.tileID.overscaledZ)));
      }
      aa(wp, "LineBucket", { omit: ["layers", "patternFeatures", "currentVertex", "currentVertexIsOutside"] });
      const Ip = (t4, e3, r3) => (1 - r3) * t4 + r3 * e3;
      function zp(t4, e3) {
        return 1 / Sp(t4, 1, e3.tileZoom);
      }
      function Pp(t4, e3, r3, n3) {
        return t4.translatePosMatrix(n3 || e3.tileID.projMatrix, e3, r3.paint.get("line-translate"), r3.paint.get("line-translate-anchor"));
      }
      const kp = (t4) => {
        const e3 = [];
        Tp(t4) && e3.push("RENDER_LINE_DASH"), t4.paint.get("line-gradient") && e3.push("RENDER_LINE_GRADIENT");
        const r3 = t4.paint.get("line-trim-offset");
        0 === r3[0] && 0 === r3[1] || e3.push("RENDER_LINE_TRIM_OFFSET"), 0 !== t4.paint.get("line-border-width").constantOr(1) && e3.push("RENDER_LINE_BORDER");
        const n3 = "none" === t4.layout.get("line-join").constantOr("miter"), i3 = !!t4.paint.get("line-pattern").constantOr(1);
        return n3 && i3 && e3.push("LINE_JOIN_NONE"), e3;
      };
      function Tp(t4) {
        const e3 = t4.paint.get("line-dasharray").value;
        return e3.value || "constant" !== e3.kind;
      }
      let Ep;
      const Bp = () => Ep || (Ep = { layout: Mp || (Mp = new qa({ "line-cap": new ja($a.layout_line["line-cap"]), "line-join": new ja($a.layout_line["line-join"]), "line-miter-limit": new Ua($a.layout_line["line-miter-limit"]), "line-round-limit": new Ua($a.layout_line["line-round-limit"]), "line-sort-key": new ja($a.layout_line["line-sort-key"]), "line-z-offset": new ja($a.layout_line["line-z-offset"]), "line-elevation-reference": new Ua($a.layout_line["line-elevation-reference"]), "line-cross-slope": new Ua($a.layout_line["line-cross-slope"]), visibility: new Ua($a.layout_line.visibility) })), paint: Ap || (Ap = new qa({ "line-opacity": new ja($a.paint_line["line-opacity"]), "line-color": new ja($a.paint_line["line-color"]), "line-translate": new Ua($a.paint_line["line-translate"]), "line-translate-anchor": new Ua($a.paint_line["line-translate-anchor"]), "line-width": new ja($a.paint_line["line-width"]), "line-gap-width": new ja($a.paint_line["line-gap-width"]), "line-offset": new ja($a.paint_line["line-offset"]), "line-blur": new ja($a.paint_line["line-blur"]), "line-dasharray": new ja($a.paint_line["line-dasharray"]), "line-pattern": new ja($a.paint_line["line-pattern"]), "line-gradient": new Na($a.paint_line["line-gradient"]), "line-trim-offset": new Ua($a.paint_line["line-trim-offset"]), "line-trim-fade-range": new Ua($a.paint_line["line-trim-fade-range"]), "line-trim-color": new Ua($a.paint_line["line-trim-color"]), "line-emissive-strength": new Ua($a.paint_line["line-emissive-strength"]), "line-border-width": new ja($a.paint_line["line-border-width"]), "line-border-color": new ja($a.paint_line["line-border-color"]), "line-occlusion-opacity": new Ua($a.paint_line["line-occlusion-opacity"]) })) }, Ep);
      class Vp extends ja {
        possiblyEvaluate(t4, e3) {
          return e3 = new Ea(Math.floor(e3.zoom), { now: e3.now, fadeDuration: e3.fadeDuration, transition: e3.transition }), super.possiblyEvaluate(t4, e3);
        }
        evaluate(t4, e3, r3, n3) {
          return e3 = nt({}, e3, { zoom: Math.floor(e3.zoom) }), super.evaluate(t4, e3, r3, n3);
        }
      }
      let Cp;
      function Rp(t4, e3) {
        return e3 > 0 ? e3 + 2 * t4 : t4;
      }
      const Dp = ds([{ name: "a_pos_offset", components: 4, type: "Int16" }, { name: "a_tex_size", components: 4, type: "Uint16" }, { name: "a_pixeloffset", components: 4, type: "Int16" }], 4), Lp = ds([{ name: "a_globe_anchor", components: 3, type: "Int16" }, { name: "a_globe_normal", components: 3, type: "Float32" }], 4), Fp = ds([{ name: "a_projected_pos", components: 4, type: "Float32" }], 4);
      ds([{ name: "a_fade_opacity", components: 1, type: "Uint32" }], 4);
      const Op = ds([{ name: "a_auto_z_offset", components: 1, type: "Float32" }], 4), Up = ds([{ name: "a_texb", components: 2, type: "Uint16" }]), jp = ds([{ name: "a_placed", components: 2, type: "Uint8" }, { name: "a_shift", components: 2, type: "Float32" }, { name: "a_elevation_from_sea", components: 2, type: "Float32" }]), Np = ds([{ name: "a_size_scale", components: 1, type: "Float32" }, { name: "a_padding", components: 2, type: "Float32" }, { name: "a_auto_z_offset", components: 1, type: "Float32" }]);
      ds([{ type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Int16", name: "tileAnchorX" }, { type: "Int16", name: "tileAnchorY" }, { type: "Float32", name: "x1" }, { type: "Float32", name: "y1" }, { type: "Float32", name: "x2" }, { type: "Float32", name: "y2" }, { type: "Int16", name: "padding" }, { type: "Uint32", name: "featureIndex" }, { type: "Uint16", name: "sourceLayerIndex" }, { type: "Uint16", name: "bucketIndex" }]);
      const qp = ds([{ name: "a_pos", components: 3, type: "Int16" }, { name: "a_anchor_pos", components: 2, type: "Int16" }, { name: "a_extrude", components: 2, type: "Int16" }], 4), $p = ds([{ name: "a_pos_2f", components: 2, type: "Float32" }, { name: "a_radius", components: 1, type: "Float32" }, { name: "a_flags", components: 2, type: "Int16" }], 4);
      ds([{ name: "triangle", components: 3, type: "Uint16" }]), ds([{ type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Float32", name: "tileAnchorX" }, { type: "Float32", name: "tileAnchorY" }, { type: "Uint16", name: "glyphStartIndex" }, { type: "Uint16", name: "numGlyphs" }, { type: "Uint32", name: "vertexStartIndex" }, { type: "Uint32", name: "lineStartIndex" }, { type: "Uint32", name: "lineLength" }, { type: "Uint16", name: "segment" }, { type: "Uint16", name: "lowerSize" }, { type: "Uint16", name: "upperSize" }, { type: "Float32", name: "lineOffsetX" }, { type: "Float32", name: "lineOffsetY" }, { type: "Uint8", name: "writingMode" }, { type: "Uint8", name: "placedOrientation" }, { type: "Uint8", name: "hidden" }, { type: "Uint32", name: "crossTileID" }, { type: "Int16", name: "associatedIconIndex" }, { type: "Uint8", name: "flipState" }]), ds([{ type: "Float32", name: "tileAnchorX" }, { type: "Float32", name: "tileAnchorY" }, { type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Int16", name: "rightJustifiedTextSymbolIndex" }, { type: "Int16", name: "centerJustifiedTextSymbolIndex" }, { type: "Int16", name: "leftJustifiedTextSymbolIndex" }, { type: "Int16", name: "verticalPlacedTextSymbolIndex" }, { type: "Int16", name: "placedIconSymbolIndex" }, { type: "Int16", name: "verticalPlacedIconSymbolIndex" }, { type: "Uint16", name: "key" }, { type: "Uint16", name: "textBoxStartIndex" }, { type: "Uint16", name: "textBoxEndIndex" }, { type: "Uint16", name: "verticalTextBoxStartIndex" }, { type: "Uint16", name: "verticalTextBoxEndIndex" }, { type: "Uint16", name: "iconBoxStartIndex" }, { type: "Uint16", name: "iconBoxEndIndex" }, { type: "Uint16", name: "verticalIconBoxStartIndex" }, { type: "Uint16", name: "verticalIconBoxEndIndex" }, { type: "Uint16", name: "featureIndex" }, { type: "Uint16", name: "numHorizontalGlyphVertices" }, { type: "Uint16", name: "numVerticalGlyphVertices" }, { type: "Uint16", name: "numIconVertices" }, { type: "Uint16", name: "numVerticalIconVertices" }, { type: "Uint16", name: "useRuntimeCollisionCircles" }, { type: "Uint32", name: "crossTileID" }, { type: "Float32", components: 2, name: "textOffset" }, { type: "Float32", name: "collisionCircleDiameter" }, { type: "Float32", name: "zOffset" }, { type: "Uint8", name: "hasIconTextFit" }]), ds([{ type: "Float32", name: "offsetX" }]), ds([{ type: "Int16", name: "x" }, { type: "Int16", name: "y" }]);
      var Gp = 24;
      const Xp = 128;
      function Yp(t4, e3) {
        const { expression: r3 } = e3;
        if ("constant" === r3.kind) return { kind: "constant", layoutSize: r3.evaluate(new Ea(t4 + 1)) };
        if ("source" === r3.kind) return { kind: "source" };
        {
          const { zoomStops: e4, interpolationType: n3 } = r3;
          let i3 = 0;
          for (; i3 < e4.length && e4[i3] <= t4; ) i3++;
          i3 = Math.max(0, i3 - 1);
          let a4 = i3;
          for (; a4 < e4.length && e4[a4] < t4 + 1; ) a4++;
          a4 = Math.min(e4.length - 1, a4);
          const s3 = e4[i3], o3 = e4[a4];
          return "composite" === r3.kind ? { kind: "composite", minZoom: s3, maxZoom: o3, interpolationType: n3 } : { kind: "camera", minZoom: s3, maxZoom: o3, minSize: r3.evaluate(new Ea(s3)), maxSize: r3.evaluate(new Ea(o3)), interpolationType: n3 };
        }
      }
      function Zp(t4, { uSize: e3, uSizeT: r3 }, { lowerSize: n3, upperSize: i3 }) {
        return "source" === t4.kind ? n3 / Xp : "composite" === t4.kind ? Pe(n3 / Xp, i3 / Xp, r3) : e3;
      }
      function Wp(t4, e3, r3 = 1) {
        let n3 = 0, i3 = 0;
        if ("constant" === t4.kind) i3 = t4.layoutSize * r3;
        else if ("source" !== t4.kind) {
          const { interpolationType: a4, minZoom: s3, maxZoom: o3 } = t4, l3 = a4 ? Q2(ni.interpolationFactor(a4, e3, s3, o3), 0, 1) : 0;
          "camera" === t4.kind ? i3 = Pe(t4.minSize, t4.maxSize, l3) * r3 : n3 = l3 * r3;
        }
        return { uSizeT: n3, uSize: i3 };
      }
      var Hp = Object.freeze({ __proto__: null, SIZE_PACK_FACTOR: Xp, evaluateSizeForFeature: Zp, evaluateSizeForZoom: Wp, getSizeData: Yp });
      function Kp(t4, e3, r3) {
        return t4.sections.forEach((t5) => {
          t5.text = function(t6, e4, r4) {
            const n3 = e4.layout.get("text-transform").evaluate(r4, {});
            return "uppercase" === n3 ? t6 = t6.toLocaleUpperCase() : "lowercase" === n3 && (t6 = t6.toLocaleLowerCase()), Ta.applyArabicShaping && (t6 = Ta.applyArabicShaping(t6)), t6;
          }(t5.text, e3, r3);
        }), t4;
      }
      const Jp = { "!": "︕", "#": "＃", $: "＄", "%": "％", "&": "＆", "(": "︵", ")": "︶", "*": "＊", "+": "＋", ",": "︐", "-": "︲", ".": "・", "/": "／", ":": "︓", ";": "︔", "<": "︿", "=": "＝", ">": "﹀", "?": "︖", "@": "＠", "[": "﹇", "\\": "＼", "]": "﹈", "^": "＾", _: "︳", "`": "｀", "{": "︷", "|": "―", "}": "︸", "~": "～", "¢": "￠", "£": "￡", "¥": "￥", "¦": "￤", "¬": "￢", "¯": "￣", "–": "︲", "—": "︱", "‘": "﹃", "’": "﹄", "“": "﹁", "”": "﹂", "…": "︙", "‧": "・", "₩": "￦", "、": "︑", "。": "︒", "〈": "︿", "〉": "﹀", "《": "︽", "》": "︾", "「": "﹁", "」": "﹂", "『": "﹃", "』": "﹄", "【": "︻", "】": "︼", "〔": "︹", "〕": "︺", "〖": "︗", "〗": "︘", "！": "︕", "（": "︵", "）": "︶", "，": "︐", "－": "︲", "．": "・", "：": "︓", "；": "︔", "＜": "︿", "＞": "﹀", "？": "︖", "［": "﹇", "］": "﹈", "＿": "︳", "｛": "︷", "｜": "―", "｝": "︸", "｟": "︵", "｠": "︶", "｡": "︒", "｢": "﹁", "｣": "﹂", "←": "↑", "→": "↓" };
      function Qp(t4) {
        return "︶" === t4 || "﹈" === t4 || "︸" === t4 || "﹄" === t4 || "﹂" === t4 || "︾" === t4 || "︼" === t4 || "︺" === t4 || "︘" === t4 || "﹀" === t4 || "︐" === t4 || "︓" === t4 || "︔" === t4 || "｀" === t4 || "￣" === t4 || "︑" === t4 || "︒" === t4;
      }
      function tf(t4) {
        return "︵" === t4 || "﹇" === t4 || "︷" === t4 || "﹃" === t4 || "﹁" === t4 || "︽" === t4 || "︻" === t4 || "︹" === t4 || "︗" === t4 || "︿" === t4;
      }
      var ef, rf, nf, af = {};
      /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
      function sf() {
        return ef || (ef = 1, af.read = function(t4, e3, r3, n3, i3) {
          var a4, s3, o3 = 8 * i3 - n3 - 1, l3 = (1 << o3) - 1, u4 = l3 >> 1, c3 = -7, h3 = r3 ? i3 - 1 : 0, p3 = r3 ? -1 : 1, f3 = t4[e3 + h3];
          for (h3 += p3, a4 = f3 & (1 << -c3) - 1, f3 >>= -c3, c3 += o3; c3 > 0; a4 = 256 * a4 + t4[e3 + h3], h3 += p3, c3 -= 8) ;
          for (s3 = a4 & (1 << -c3) - 1, a4 >>= -c3, c3 += n3; c3 > 0; s3 = 256 * s3 + t4[e3 + h3], h3 += p3, c3 -= 8) ;
          if (0 === a4) a4 = 1 - u4;
          else {
            if (a4 === l3) return s3 ? NaN : 1 / 0 * (f3 ? -1 : 1);
            s3 += Math.pow(2, n3), a4 -= u4;
          }
          return (f3 ? -1 : 1) * s3 * Math.pow(2, a4 - n3);
        }, af.write = function(t4, e3, r3, n3, i3, a4) {
          var s3, o3, l3, u4 = 8 * a4 - i3 - 1, c3 = (1 << u4) - 1, h3 = c3 >> 1, p3 = 23 === i3 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f3 = n3 ? 0 : a4 - 1, d3 = n3 ? 1 : -1, m2 = e3 < 0 || 0 === e3 && 1 / e3 < 0 ? 1 : 0;
          for (e3 = Math.abs(e3), isNaN(e3) || e3 === 1 / 0 ? (o3 = isNaN(e3) ? 1 : 0, s3 = c3) : (s3 = Math.floor(Math.log(e3) / Math.LN2), e3 * (l3 = Math.pow(2, -s3)) < 1 && (s3--, l3 *= 2), (e3 += s3 + h3 >= 1 ? p3 / l3 : p3 * Math.pow(2, 1 - h3)) * l3 >= 2 && (s3++, l3 /= 2), s3 + h3 >= c3 ? (o3 = 0, s3 = c3) : s3 + h3 >= 1 ? (o3 = (e3 * l3 - 1) * Math.pow(2, i3), s3 += h3) : (o3 = e3 * Math.pow(2, h3 - 1) * Math.pow(2, i3), s3 = 0)); i3 >= 8; t4[r3 + f3] = 255 & o3, f3 += d3, o3 /= 256, i3 -= 8) ;
          for (s3 = s3 << i3 | o3, u4 += i3; u4 > 0; t4[r3 + f3] = 255 & s3, f3 += d3, s3 /= 256, u4 -= 8) ;
          t4[r3 + f3 - d3] |= 128 * m2;
        }), af;
      }
      function of() {
        if (nf) return rf;
        nf = 1, rf = e3;
        var t4 = sf();
        function e3(t5) {
          this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t5) ? t5 : new Uint8Array(t5 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        e3.Varint = 0, e3.Fixed64 = 1, e3.Bytes = 2, e3.Fixed32 = 5;
        var r3 = 4294967296, n3 = 1 / r3, i3 = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
        function a4(t5) {
          return t5.type === e3.Bytes ? t5.readVarint() + t5.pos : t5.pos + 1;
        }
        function s3(t5, e4, r4) {
          return r4 ? 4294967296 * e4 + (t5 >>> 0) : 4294967296 * (e4 >>> 0) + (t5 >>> 0);
        }
        function o3(t5, e4, r4) {
          var n4 = e4 <= 16383 ? 1 : e4 <= 2097151 ? 2 : e4 <= 268435455 ? 3 : Math.floor(Math.log(e4) / (7 * Math.LN2));
          r4.realloc(n4);
          for (var i4 = r4.pos - 1; i4 >= t5; i4--) r4.buf[i4 + n4] = r4.buf[i4];
        }
        function l3(t5, e4) {
          for (var r4 = 0; r4 < t5.length; r4++) e4.writeVarint(t5[r4]);
        }
        function u4(t5, e4) {
          for (var r4 = 0; r4 < t5.length; r4++) e4.writeSVarint(t5[r4]);
        }
        function c3(t5, e4) {
          for (var r4 = 0; r4 < t5.length; r4++) e4.writeFloat(t5[r4]);
        }
        function h3(t5, e4) {
          for (var r4 = 0; r4 < t5.length; r4++) e4.writeDouble(t5[r4]);
        }
        function p3(t5, e4) {
          for (var r4 = 0; r4 < t5.length; r4++) e4.writeBoolean(t5[r4]);
        }
        function f3(t5, e4) {
          for (var r4 = 0; r4 < t5.length; r4++) e4.writeFixed32(t5[r4]);
        }
        function d3(t5, e4) {
          for (var r4 = 0; r4 < t5.length; r4++) e4.writeSFixed32(t5[r4]);
        }
        function m2(t5, e4) {
          for (var r4 = 0; r4 < t5.length; r4++) e4.writeFixed64(t5[r4]);
        }
        function y2(t5, e4) {
          for (var r4 = 0; r4 < t5.length; r4++) e4.writeSFixed64(t5[r4]);
        }
        function g4(t5, e4) {
          return (t5[e4] | t5[e4 + 1] << 8 | t5[e4 + 2] << 16) + 16777216 * t5[e4 + 3];
        }
        function x2(t5, e4, r4) {
          t5[r4] = e4, t5[r4 + 1] = e4 >>> 8, t5[r4 + 2] = e4 >>> 16, t5[r4 + 3] = e4 >>> 24;
        }
        function v2(t5, e4) {
          return (t5[e4] | t5[e4 + 1] << 8 | t5[e4 + 2] << 16) + (t5[e4 + 3] << 24);
        }
        return e3.prototype = { destroy: function() {
          this.buf = null;
        }, readFields: function(t5, e4, r4) {
          for (r4 = r4 || this.length; this.pos < r4; ) {
            var n4 = this.readVarint(), i4 = n4 >> 3, a5 = this.pos;
            this.type = 7 & n4, t5(i4, e4, this), this.pos === a5 && this.skip(n4);
          }
          return e4;
        }, readMessage: function(t5, e4) {
          return this.readFields(t5, e4, this.readVarint() + this.pos);
        }, readFixed32: function() {
          var t5 = g4(this.buf, this.pos);
          return this.pos += 4, t5;
        }, readSFixed32: function() {
          var t5 = v2(this.buf, this.pos);
          return this.pos += 4, t5;
        }, readFixed64: function() {
          var t5 = g4(this.buf, this.pos) + g4(this.buf, this.pos + 4) * r3;
          return this.pos += 8, t5;
        }, readSFixed64: function() {
          var t5 = g4(this.buf, this.pos) + v2(this.buf, this.pos + 4) * r3;
          return this.pos += 8, t5;
        }, readFloat: function() {
          var e4 = t4.read(this.buf, this.pos, true, 23, 4);
          return this.pos += 4, e4;
        }, readDouble: function() {
          var e4 = t4.read(this.buf, this.pos, true, 52, 8);
          return this.pos += 8, e4;
        }, readVarint: function(t5) {
          var e4, r4, n4 = this.buf;
          return e4 = 127 & (r4 = n4[this.pos++]), r4 < 128 ? e4 : (e4 |= (127 & (r4 = n4[this.pos++])) << 7, r4 < 128 ? e4 : (e4 |= (127 & (r4 = n4[this.pos++])) << 14, r4 < 128 ? e4 : (e4 |= (127 & (r4 = n4[this.pos++])) << 21, r4 < 128 ? e4 : function(t6, e5, r5) {
            var n5, i4, a5 = r5.buf;
            if (n5 = (112 & (i4 = a5[r5.pos++])) >> 4, i4 < 128) return s3(t6, n5, e5);
            if (n5 |= (127 & (i4 = a5[r5.pos++])) << 3, i4 < 128) return s3(t6, n5, e5);
            if (n5 |= (127 & (i4 = a5[r5.pos++])) << 10, i4 < 128) return s3(t6, n5, e5);
            if (n5 |= (127 & (i4 = a5[r5.pos++])) << 17, i4 < 128) return s3(t6, n5, e5);
            if (n5 |= (127 & (i4 = a5[r5.pos++])) << 24, i4 < 128) return s3(t6, n5, e5);
            if (n5 |= (1 & (i4 = a5[r5.pos++])) << 31, i4 < 128) return s3(t6, n5, e5);
            throw new Error("Expected varint not more than 10 bytes");
          }(e4 |= (15 & (r4 = n4[this.pos])) << 28, t5, this))));
        }, readVarint64: function() {
          return this.readVarint(true);
        }, readSVarint: function() {
          var t5 = this.readVarint();
          return t5 % 2 == 1 ? (t5 + 1) / -2 : t5 / 2;
        }, readBoolean: function() {
          return Boolean(this.readVarint());
        }, readString: function() {
          var t5 = this.readVarint() + this.pos, e4 = this.pos;
          return this.pos = t5, t5 - e4 >= 12 && i3 ? function(t6, e5, r4) {
            return i3.decode(t6.subarray(e5, r4));
          }(this.buf, e4, t5) : function(t6, e5, r4) {
            for (var n4 = "", i4 = e5; i4 < r4; ) {
              var a5, s4, o4, l4 = t6[i4], u5 = null, c4 = l4 > 239 ? 4 : l4 > 223 ? 3 : l4 > 191 ? 2 : 1;
              if (i4 + c4 > r4) break;
              1 === c4 ? l4 < 128 && (u5 = l4) : 2 === c4 ? 128 == (192 & (a5 = t6[i4 + 1])) && (u5 = (31 & l4) << 6 | 63 & a5) <= 127 && (u5 = null) : 3 === c4 ? (s4 = t6[i4 + 2], 128 == (192 & (a5 = t6[i4 + 1])) && 128 == (192 & s4) && ((u5 = (15 & l4) << 12 | (63 & a5) << 6 | 63 & s4) <= 2047 || u5 >= 55296 && u5 <= 57343) && (u5 = null)) : 4 === c4 && (s4 = t6[i4 + 2], o4 = t6[i4 + 3], 128 == (192 & (a5 = t6[i4 + 1])) && 128 == (192 & s4) && 128 == (192 & o4) && ((u5 = (15 & l4) << 18 | (63 & a5) << 12 | (63 & s4) << 6 | 63 & o4) <= 65535 || u5 >= 1114112) && (u5 = null)), null === u5 ? (u5 = 65533, c4 = 1) : u5 > 65535 && (u5 -= 65536, n4 += String.fromCharCode(u5 >>> 10 & 1023 | 55296), u5 = 56320 | 1023 & u5), n4 += String.fromCharCode(u5), i4 += c4;
            }
            return n4;
          }(this.buf, e4, t5);
        }, readBytes: function() {
          var t5 = this.readVarint() + this.pos, e4 = this.buf.subarray(this.pos, t5);
          return this.pos = t5, e4;
        }, readPackedVarint: function(t5, r4) {
          if (this.type !== e3.Bytes) return t5.push(this.readVarint(r4));
          var n4 = a4(this);
          for (t5 = t5 || []; this.pos < n4; ) t5.push(this.readVarint(r4));
          return t5;
        }, readPackedSVarint: function(t5) {
          if (this.type !== e3.Bytes) return t5.push(this.readSVarint());
          var r4 = a4(this);
          for (t5 = t5 || []; this.pos < r4; ) t5.push(this.readSVarint());
          return t5;
        }, readPackedBoolean: function(t5) {
          if (this.type !== e3.Bytes) return t5.push(this.readBoolean());
          var r4 = a4(this);
          for (t5 = t5 || []; this.pos < r4; ) t5.push(this.readBoolean());
          return t5;
        }, readPackedFloat: function(t5) {
          if (this.type !== e3.Bytes) return t5.push(this.readFloat());
          var r4 = a4(this);
          for (t5 = t5 || []; this.pos < r4; ) t5.push(this.readFloat());
          return t5;
        }, readPackedDouble: function(t5) {
          if (this.type !== e3.Bytes) return t5.push(this.readDouble());
          var r4 = a4(this);
          for (t5 = t5 || []; this.pos < r4; ) t5.push(this.readDouble());
          return t5;
        }, readPackedFixed32: function(t5) {
          if (this.type !== e3.Bytes) return t5.push(this.readFixed32());
          var r4 = a4(this);
          for (t5 = t5 || []; this.pos < r4; ) t5.push(this.readFixed32());
          return t5;
        }, readPackedSFixed32: function(t5) {
          if (this.type !== e3.Bytes) return t5.push(this.readSFixed32());
          var r4 = a4(this);
          for (t5 = t5 || []; this.pos < r4; ) t5.push(this.readSFixed32());
          return t5;
        }, readPackedFixed64: function(t5) {
          if (this.type !== e3.Bytes) return t5.push(this.readFixed64());
          var r4 = a4(this);
          for (t5 = t5 || []; this.pos < r4; ) t5.push(this.readFixed64());
          return t5;
        }, readPackedSFixed64: function(t5) {
          if (this.type !== e3.Bytes) return t5.push(this.readSFixed64());
          var r4 = a4(this);
          for (t5 = t5 || []; this.pos < r4; ) t5.push(this.readSFixed64());
          return t5;
        }, skip: function(t5) {
          var r4 = 7 & t5;
          if (r4 === e3.Varint) for (; this.buf[this.pos++] > 127; ) ;
          else if (r4 === e3.Bytes) this.pos = this.readVarint() + this.pos;
          else if (r4 === e3.Fixed32) this.pos += 4;
          else {
            if (r4 !== e3.Fixed64) throw new Error("Unimplemented type: " + r4);
            this.pos += 8;
          }
        }, writeTag: function(t5, e4) {
          this.writeVarint(t5 << 3 | e4);
        }, realloc: function(t5) {
          for (var e4 = this.length || 16; e4 < this.pos + t5; ) e4 *= 2;
          if (e4 !== this.length) {
            var r4 = new Uint8Array(e4);
            r4.set(this.buf), this.buf = r4, this.length = e4;
          }
        }, finish: function() {
          return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
        }, writeFixed32: function(t5) {
          this.realloc(4), x2(this.buf, t5, this.pos), this.pos += 4;
        }, writeSFixed32: function(t5) {
          this.realloc(4), x2(this.buf, t5, this.pos), this.pos += 4;
        }, writeFixed64: function(t5) {
          this.realloc(8), x2(this.buf, -1 & t5, this.pos), x2(this.buf, Math.floor(t5 * n3), this.pos + 4), this.pos += 8;
        }, writeSFixed64: function(t5) {
          this.realloc(8), x2(this.buf, -1 & t5, this.pos), x2(this.buf, Math.floor(t5 * n3), this.pos + 4), this.pos += 8;
        }, writeVarint: function(t5) {
          (t5 = +t5 || 0) > 268435455 || t5 < 0 ? function(t6, e4) {
            var r4, n4;
            if (t6 >= 0 ? (r4 = t6 % 4294967296 | 0, n4 = t6 / 4294967296 | 0) : (n4 = ~(-t6 / 4294967296), 4294967295 ^ (r4 = ~(-t6 % 4294967296)) ? r4 = r4 + 1 | 0 : (r4 = 0, n4 = n4 + 1 | 0)), t6 >= 18446744073709552e3 || t6 < -18446744073709552e3) throw new Error("Given varint doesn't fit into 10 bytes");
            e4.realloc(10), function(t7, e5, r5) {
              r5.buf[r5.pos++] = 127 & t7 | 128, t7 >>>= 7, r5.buf[r5.pos++] = 127 & t7 | 128, t7 >>>= 7, r5.buf[r5.pos++] = 127 & t7 | 128, t7 >>>= 7, r5.buf[r5.pos++] = 127 & t7 | 128, r5.buf[r5.pos] = 127 & (t7 >>>= 7);
            }(r4, 0, e4), function(t7, e5) {
              var r5 = (7 & t7) << 4;
              e5.buf[e5.pos++] |= r5 | ((t7 >>>= 3) ? 128 : 0), t7 && (e5.buf[e5.pos++] = 127 & t7 | ((t7 >>>= 7) ? 128 : 0), t7 && (e5.buf[e5.pos++] = 127 & t7 | ((t7 >>>= 7) ? 128 : 0), t7 && (e5.buf[e5.pos++] = 127 & t7 | ((t7 >>>= 7) ? 128 : 0), t7 && (e5.buf[e5.pos++] = 127 & t7 | ((t7 >>>= 7) ? 128 : 0), t7 && (e5.buf[e5.pos++] = 127 & t7)))));
            }(n4, e4);
          }(t5, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t5 | (t5 > 127 ? 128 : 0), t5 <= 127 || (this.buf[this.pos++] = 127 & (t5 >>>= 7) | (t5 > 127 ? 128 : 0), t5 <= 127 || (this.buf[this.pos++] = 127 & (t5 >>>= 7) | (t5 > 127 ? 128 : 0), t5 <= 127 || (this.buf[this.pos++] = t5 >>> 7 & 127))));
        }, writeSVarint: function(t5) {
          this.writeVarint(t5 < 0 ? 2 * -t5 - 1 : 2 * t5);
        }, writeBoolean: function(t5) {
          this.writeVarint(Boolean(t5));
        }, writeString: function(t5) {
          t5 = String(t5), this.realloc(4 * t5.length), this.pos++;
          var e4 = this.pos;
          this.pos = function(t6, e5, r5) {
            for (var n4, i4, a5 = 0; a5 < e5.length; a5++) {
              if ((n4 = e5.charCodeAt(a5)) > 55295 && n4 < 57344) {
                if (!i4) {
                  n4 > 56319 || a5 + 1 === e5.length ? (t6[r5++] = 239, t6[r5++] = 191, t6[r5++] = 189) : i4 = n4;
                  continue;
                }
                if (n4 < 56320) {
                  t6[r5++] = 239, t6[r5++] = 191, t6[r5++] = 189, i4 = n4;
                  continue;
                }
                n4 = i4 - 55296 << 10 | n4 - 56320 | 65536, i4 = null;
              } else i4 && (t6[r5++] = 239, t6[r5++] = 191, t6[r5++] = 189, i4 = null);
              n4 < 128 ? t6[r5++] = n4 : (n4 < 2048 ? t6[r5++] = n4 >> 6 | 192 : (n4 < 65536 ? t6[r5++] = n4 >> 12 | 224 : (t6[r5++] = n4 >> 18 | 240, t6[r5++] = n4 >> 12 & 63 | 128), t6[r5++] = n4 >> 6 & 63 | 128), t6[r5++] = 63 & n4 | 128);
            }
            return r5;
          }(this.buf, t5, this.pos);
          var r4 = this.pos - e4;
          r4 >= 128 && o3(e4, r4, this), this.pos = e4 - 1, this.writeVarint(r4), this.pos += r4;
        }, writeFloat: function(e4) {
          this.realloc(4), t4.write(this.buf, e4, this.pos, true, 23, 4), this.pos += 4;
        }, writeDouble: function(e4) {
          this.realloc(8), t4.write(this.buf, e4, this.pos, true, 52, 8), this.pos += 8;
        }, writeBytes: function(t5) {
          var e4 = t5.length;
          this.writeVarint(e4), this.realloc(e4);
          for (var r4 = 0; r4 < e4; r4++) this.buf[this.pos++] = t5[r4];
        }, writeRawMessage: function(t5, e4) {
          this.pos++;
          var r4 = this.pos;
          t5(e4, this);
          var n4 = this.pos - r4;
          n4 >= 128 && o3(r4, n4, this), this.pos = r4 - 1, this.writeVarint(n4), this.pos += n4;
        }, writeMessage: function(t5, r4, n4) {
          this.writeTag(t5, e3.Bytes), this.writeRawMessage(r4, n4);
        }, writePackedVarint: function(t5, e4) {
          e4.length && this.writeMessage(t5, l3, e4);
        }, writePackedSVarint: function(t5, e4) {
          e4.length && this.writeMessage(t5, u4, e4);
        }, writePackedBoolean: function(t5, e4) {
          e4.length && this.writeMessage(t5, p3, e4);
        }, writePackedFloat: function(t5, e4) {
          e4.length && this.writeMessage(t5, c3, e4);
        }, writePackedDouble: function(t5, e4) {
          e4.length && this.writeMessage(t5, h3, e4);
        }, writePackedFixed32: function(t5, e4) {
          e4.length && this.writeMessage(t5, f3, e4);
        }, writePackedSFixed32: function(t5, e4) {
          e4.length && this.writeMessage(t5, d3, e4);
        }, writePackedFixed64: function(t5, e4) {
          e4.length && this.writeMessage(t5, m2, e4);
        }, writePackedSFixed64: function(t5, e4) {
          e4.length && this.writeMessage(t5, y2, e4);
        }, writeBytesField: function(t5, r4) {
          this.writeTag(t5, e3.Bytes), this.writeBytes(r4);
        }, writeFixed32Field: function(t5, r4) {
          this.writeTag(t5, e3.Fixed32), this.writeFixed32(r4);
        }, writeSFixed32Field: function(t5, r4) {
          this.writeTag(t5, e3.Fixed32), this.writeSFixed32(r4);
        }, writeFixed64Field: function(t5, r4) {
          this.writeTag(t5, e3.Fixed64), this.writeFixed64(r4);
        }, writeSFixed64Field: function(t5, r4) {
          this.writeTag(t5, e3.Fixed64), this.writeSFixed64(r4);
        }, writeVarintField: function(t5, r4) {
          this.writeTag(t5, e3.Varint), this.writeVarint(r4);
        }, writeSVarintField: function(t5, r4) {
          this.writeTag(t5, e3.Varint), this.writeSVarint(r4);
        }, writeStringField: function(t5, r4) {
          this.writeTag(t5, e3.Bytes), this.writeString(r4);
        }, writeFloatField: function(t5, r4) {
          this.writeTag(t5, e3.Fixed32), this.writeFloat(r4);
        }, writeDoubleField: function(t5, r4) {
          this.writeTag(t5, e3.Fixed64), this.writeDouble(r4);
        }, writeBooleanField: function(t5, e4) {
          this.writeVarintField(t5, Boolean(e4));
        } }, rf;
      }
      var lf = e2(of());
      const uf = 3;
      function cf(t4, e3, r3) {
        e3.glyphs = [], 1 === t4 && r3.readMessage(hf, e3);
      }
      function hf(t4, e3, r3) {
        if (3 === t4) {
          const { id: t5, bitmap: n3, width: i3, height: a4, left: s3, top: o3, advance: l3 } = r3.readMessage(pf, {});
          e3.glyphs.push({ id: t5, bitmap: new nc({ width: i3 + 2 * uf, height: a4 + 2 * uf }, n3), metrics: { width: i3, height: a4, left: s3, top: o3, advance: l3 } });
        } else 4 === t4 ? e3.ascender = r3.readSVarint() : 5 === t4 && (e3.descender = r3.readSVarint());
      }
      function pf(t4, e3, r3) {
        1 === t4 ? e3.id = r3.readVarint() : 2 === t4 ? e3.bitmap = r3.readBytes() : 3 === t4 ? e3.width = r3.readVarint() : 4 === t4 ? e3.height = r3.readVarint() : 5 === t4 ? e3.left = r3.readSVarint() : 6 === t4 ? e3.top = r3.readSVarint() : 7 === t4 && (e3.advance = r3.readVarint());
      }
      const ff = uf, df = { horizontal: 1, vertical: 2, horizontalOnly: 3 };
      class mf {
        constructor() {
          this.scale = 1, this.fontStack = "", this.imageName = null;
        }
        static forText(t4, e3) {
          const r3 = new mf();
          return r3.scale = t4 || 1, r3.fontStack = e3, r3;
        }
        static forImage(t4) {
          const e3 = new mf();
          return e3.imageName = t4, e3;
        }
      }
      class yf {
        constructor() {
          this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
        }
        static fromFeature(t4, e3) {
          const r3 = new yf();
          for (let n3 = 0; n3 < t4.sections.length; n3++) {
            const i3 = t4.sections[n3];
            i3.image ? r3.addImageSection(i3) : r3.addTextSection(i3, e3);
          }
          return r3;
        }
        length() {
          return this.text.length;
        }
        getSection(t4) {
          return this.sections[this.sectionIndex[t4]];
        }
        getSections() {
          return this.sections;
        }
        getSectionIndex(t4) {
          return this.sectionIndex[t4];
        }
        getCodePoint(t4) {
          return this.text.codePointAt(t4);
        }
        verticalizePunctuation(t4) {
          this.text = function(t5, e3) {
            let r3 = "";
            for (let n3 = 0; n3 < t5.length; n3++) {
              const i3 = t5.charCodeAt(n3 + 1) || null, a4 = t5.charCodeAt(n3 - 1) || null;
              r3 += !e3 && (i3 && ma(i3) && !Jp[t5[n3 + 1]] || a4 && ma(a4) && !Jp[t5[n3 - 1]]) || !Jp[t5[n3]] ? t5[n3] : Jp[t5[n3]];
            }
            return r3;
          }(this.text, t4);
        }
        trim() {
          let t4 = 0;
          for (let e4 = 0; e4 < this.text.length && xf[this.text.charCodeAt(e4)]; e4++) t4++;
          let e3 = this.text.length;
          for (let r3 = this.text.length - 1; r3 >= 0 && r3 >= t4 && xf[this.text.charCodeAt(r3)]; r3--) e3--;
          this.text = this.text.substring(t4, e3), this.sectionIndex = this.sectionIndex.slice(t4, e3);
        }
        substring(t4, e3) {
          const r3 = new yf();
          return r3.text = this.text.substring(t4, e3), r3.sectionIndex = this.sectionIndex.slice(t4, e3), r3.sections = this.sections, r3;
        }
        toString() {
          return this.text;
        }
        getMaxScale() {
          return this.sectionIndex.reduce((t4, e3) => Math.max(t4, this.sections[e3].scale), 0);
        }
        addTextSection(t4, e3) {
          this.text += t4.text, this.sections.push(mf.forText(t4.scale, t4.fontStack || e3));
          const r3 = this.sections.length - 1;
          for (let e4 = 0; e4 < t4.text.length; ++e4) this.sectionIndex.push(r3);
        }
        addImageSection(t4) {
          const e3 = t4.image ? t4.image.namePrimary : "";
          if (0 === e3.length) return void ft("Can't add FormattedSection with an empty image.");
          const r3 = this.getNextImageSectionCharCode();
          r3 ? (this.text += String.fromCodePoint(r3), this.sections.push(mf.forImage(e3)), this.sectionIndex.push(this.sections.length - 1)) : ft("Reached maximum number of images 6401");
        }
        getNextImageSectionCharCode() {
          return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
        }
      }
      function gf(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3, d3) {
        const m2 = yf.fromFeature(t4, i3);
        h3 === df.vertical && m2.verticalizePunctuation(p3);
        let y2 = [];
        const g4 = function(t5, e4, r4, n4, i4, a5) {
          if (!t5) return [];
          const s4 = [], o4 = function(t6, e5, r5, n5, i5, a6) {
            let s5 = 0;
            for (let r6 = 0; r6 < t6.length(); r6++) {
              const o5 = t6.getSection(r6);
              s5 += bf(t6.getCodePoint(r6), o5, n5, i5, e5, a6);
            }
            return s5 / Math.max(1, Math.ceil(s5 / r5));
          }(t5, e4, r4, n4, i4, a5), l4 = t5.text.indexOf("​") >= 0;
          let u5 = 0;
          for (let r5 = 0; r5 < t5.length(); r5++) {
            const h4 = t5.getSection(r5), p4 = t5.getCodePoint(r5);
            if (xf[p4] || (u5 += bf(p4, h4, n4, i4, e4, a5)), r5 < t5.length() - 1) {
              const e5 = !((c4 = p4) < 11904 || !(ca["Bopomofo Extended"](c4) || ca.Bopomofo(c4) || ca["CJK Compatibility Forms"](c4) || ca["CJK Compatibility Ideographs"](c4) || ca["CJK Compatibility"](c4) || ca["CJK Radicals Supplement"](c4) || ca["CJK Strokes"](c4) || ca["CJK Symbols and Punctuation"](c4) || ca["CJK Unified Ideographs Extension A"](c4) || ca["CJK Unified Ideographs"](c4) || ca["Enclosed CJK Letters and Months"](c4) || ca["Halfwidth and Fullwidth Forms"](c4) || ca.Hiragana(c4) || ca["Ideographic Description Characters"](c4) || ca["Kangxi Radicals"](c4) || ca["Katakana Phonetic Extensions"](c4) || ca.Katakana(c4) || ca["Vertical Forms"](c4) || ca["Yi Radicals"](c4) || ca["Yi Syllables"](c4)));
              (vf[p4] || e5 || h4.imageName) && s4.push(Mf(r5 + 1, u5, o4, s4, _f(p4, t5.getCodePoint(r5 + 1), e5 && l4), false));
            }
          }
          var c4;
          return Af(Mf(t5.length(), u5, o4, s4, 0, true));
        }(m2, u4, a4, e3, n3, f3), { processBidirectionalText: x2, processStyledBidirectionalText: v2 } = Ta;
        if (x2 && 1 === m2.sections.length) {
          const t5 = x2(m2.toString(), g4);
          for (const e4 of t5) {
            const t6 = new yf();
            t6.text = e4, t6.sections = m2.sections;
            for (let r4 = 0; r4 < e4.length; r4++) t6.sectionIndex.push(0);
            y2.push(t6);
          }
        } else if (v2) {
          const t5 = v2(m2.text, m2.sectionIndex, g4);
          for (const e4 of t5) {
            const t6 = new yf();
            t6.text = e4[0], t6.sectionIndex = e4[1], t6.sections = m2.sections, y2.push(t6);
          }
        } else y2 = function(t5, e4) {
          const r4 = [], n4 = t5.text;
          let i4 = 0;
          for (const n5 of e4) r4.push(t5.substring(i4, n5)), i4 = n5;
          return i4 < n4.length && r4.push(t5.substring(i4, n4.length)), r4;
        }(m2, g4);
        const b2 = [], w2 = { positionedLines: b2, text: m2.toString(), top: c3[1], bottom: c3[1], left: c3[0], right: c3[0], writingMode: h3, iconsInText: false, verticalizable: false, hasBaseline: false };
        return function(t5, e4, r4, n4, i4, a5, s4, o4, l4, u5, c4, h4) {
          let p4 = 0, f4 = 0, d4 = 0;
          const m3 = "right" === o4 ? 1 : "left" === o4 ? 0 : 0.5;
          let y3 = false;
          for (const t6 of i4) {
            const r5 = t6.getSections();
            for (const t7 of r5) {
              if (t7.imageName) continue;
              const r6 = e4[t7.fontStack];
              if (r6 && (y3 = void 0 !== r6.ascender && void 0 !== r6.descender, !y3)) break;
            }
            if (!y3) break;
          }
          let g5 = 0;
          for (const s5 of i4) {
            s5.trim();
            const i5 = s5.getMaxScale(), o5 = (i5 - 1) * Gp, v4 = { positionedGlyphs: [], lineOffset: 0 };
            t5.positionedLines[g5] = v4;
            const b4 = v4.positionedGlyphs;
            let w4 = 0;
            if (!s5.length()) {
              f4 += a5, ++g5;
              continue;
            }
            let _2 = 0, M2 = 0;
            for (let a6 = 0; a6 < s5.length(); a6++) {
              const o6 = s5.getSection(a6), d5 = s5.getSectionIndex(a6), m4 = s5.getCodePoint(a6);
              let g6 = o6.scale, v5 = null, A4 = null, S2 = null, I3 = Gp, z3 = 0;
              const P2 = !(l4 === df.horizontal || !c4 && !da(m4) || c4 && (xf[m4] || (x3 = m4, ca.Arabic(x3) || ca["Arabic Supplement"](x3) || ca["Arabic Extended-A"](x3) || ca["Arabic Presentation Forms-A"](x3) || ca["Arabic Presentation Forms-B"](x3))));
              if (o6.imageName) {
                const e5 = n4[o6.imageName];
                if (!e5) continue;
                S2 = o6.imageName, t5.iconsInText = t5.iconsInText || true, A4 = e5.paddedRect;
                const r5 = e5.displaySize;
                g6 = g6 * Gp / h4, v5 = { width: r5[0], height: r5[1], left: 0, top: -ff, advance: P2 ? r5[1] : r5[0], localGlyph: false }, z3 = y3 ? -v5.height * g6 : i5 * Gp - 17 - r5[1] * g6, I3 = v5.advance;
                const a7 = (P2 ? r5[0] : r5[1]) * g6 - Gp * i5;
                a7 > 0 && a7 > w4 && (w4 = a7);
              } else {
                const t6 = r4[o6.fontStack];
                if (!t6) continue;
                t6[m4] && (A4 = t6[m4]);
                const n5 = e4[o6.fontStack];
                if (!n5) continue;
                const a7 = n5.glyphs[m4];
                if (!a7) continue;
                if (v5 = a7.metrics, I3 = 8203 !== m4 ? Gp : 0, y3) {
                  const t7 = void 0 !== n5.ascender ? Math.abs(n5.ascender) : 0, e5 = void 0 !== n5.descender ? Math.abs(n5.descender) : 0, r5 = (t7 + e5) * g6;
                  _2 < r5 && (_2 = r5, M2 = (t7 - e5) / 2 * g6), z3 = -t7 * g6;
                } else z3 = (i5 - g6) * Gp - 17;
              }
              P2 ? (t5.verticalizable = true, b4.push({ glyph: m4, imageName: S2, x: p4, y: f4 + z3, vertical: P2, scale: g6, localGlyph: v5.localGlyph, fontStack: o6.fontStack, sectionIndex: d5, metrics: v5, rect: A4 }), p4 += I3 * g6 + u5) : (b4.push({ glyph: m4, imageName: S2, x: p4, y: f4 + z3, vertical: P2, scale: g6, localGlyph: v5.localGlyph, fontStack: o6.fontStack, sectionIndex: d5, metrics: v5, rect: A4 }), p4 += v5.advance * g6 + u5);
            }
            0 !== b4.length && (d4 = Math.max(p4 - u5, d4), y3 ? If(b4, m3, w4, M2, a5 * i5 / 2) : If(b4, m3, w4, 0, a5 / 2)), p4 = 0;
            const A3 = a5 * i5 + w4;
            v4.lineOffset = Math.max(w4, o5), f4 += A3, ++g5;
          }
          var x3;
          const v3 = f4, { horizontalAlign: b3, verticalAlign: w3 } = Sf(s4);
          (function(t6, e5, r5, n5, i5, a6) {
            const s5 = (e5 - r5) * i5, o5 = -a6 * n5;
            for (const e6 of t6) for (const t7 of e6.positionedGlyphs) t7.x += s5, t7.y += o5;
          })(t5.positionedLines, m3, b3, w3, d4, v3), t5.top += -w3 * v3, t5.bottom = t5.top + v3, t5.left += -b3 * d4, t5.right = t5.left + d4, t5.hasBaseline = y3;
        }(w2, e3, r3, n3, y2, s3, o3, l3, h3, u4, p3, d3), !function(t5) {
          for (const e4 of t5) if (0 !== e4.positionedGlyphs.length) return false;
          return true;
        }(b2) && w2;
      }
      const xf = { 9: true, 10: true, 11: true, 12: true, 13: true, 32: true }, vf = { 10: true, 32: true, 38: true, 40: true, 41: true, 43: true, 45: true, 47: true, 173: true, 183: true, 8203: true, 8208: true, 8211: true, 8231: true };
      function bf(t4, e3, r3, n3, i3, a4) {
        if (e3.imageName) {
          const t5 = n3[e3.imageName];
          return t5 ? t5.displaySize[0] * e3.scale * Gp / a4 + i3 : 0;
        }
        {
          const n4 = r3[e3.fontStack], a5 = n4 && n4.glyphs[t4];
          return a5 ? a5.metrics.advance * e3.scale + i3 : 0;
        }
      }
      function wf(t4, e3, r3, n3) {
        const i3 = Math.pow(t4 - e3, 2);
        return n3 ? t4 < e3 ? i3 / 2 : 2 * i3 : i3 + Math.abs(r3) * r3;
      }
      function _f(t4, e3, r3) {
        let n3 = 0;
        return 10 === t4 && (n3 -= 1e4), r3 && (n3 += 150), 40 !== t4 && 65288 !== t4 || (n3 += 50), 41 !== e3 && 65289 !== e3 || (n3 += 50), n3;
      }
      function Mf(t4, e3, r3, n3, i3, a4) {
        let s3 = null, o3 = wf(e3, r3, i3, a4);
        for (const t5 of n3) {
          const n4 = wf(e3 - t5.x, r3, i3, a4) + t5.badness;
          n4 <= o3 && (s3 = t5, o3 = n4);
        }
        return { index: t4, x: e3, priorBreak: s3, badness: o3 };
      }
      function Af(t4) {
        return t4 ? Af(t4.priorBreak).concat(t4.index) : [];
      }
      function Sf(t4) {
        let e3 = 0.5, r3 = 0.5;
        switch (t4) {
          case "right":
          case "top-right":
          case "bottom-right":
            e3 = 1;
            break;
          case "left":
          case "top-left":
          case "bottom-left":
            e3 = 0;
        }
        switch (t4) {
          case "bottom":
          case "bottom-right":
          case "bottom-left":
            r3 = 1;
            break;
          case "top":
          case "top-right":
          case "top-left":
            r3 = 0;
        }
        return { horizontalAlign: e3, verticalAlign: r3 };
      }
      function If(t4, e3, r3, n3, i3) {
        if (!(e3 || r3 || n3 || i3)) return;
        const a4 = t4.length - 1, s3 = t4[a4], o3 = (s3.x + s3.metrics.advance * s3.scale) * e3;
        for (let e4 = 0; e4 <= a4; e4++) t4[e4].x -= o3, t4[e4].y += r3 + n3 + i3;
      }
      function zf(t4, e3, r3, n3) {
        const { horizontalAlign: i3, verticalAlign: a4 } = Sf(n3), s3 = r3[0] - t4.displaySize[0] * i3, o3 = r3[1] - t4.displaySize[1] * a4;
        return { imagePrimary: t4, imageSecondary: e3, top: o3, bottom: o3 + t4.displaySize[1], left: s3, right: s3 + t4.displaySize[0] };
      }
      function Pf(t4, e3, r3, n3, i3, a4) {
        const s3 = t4.imagePrimary;
        let o3;
        if (s3.content) {
          const t5 = s3.content, e4 = s3.pixelRatio || 1;
          o3 = [t5[0] / e4, t5[1] / e4, s3.displaySize[0] - t5[2] / e4, s3.displaySize[1] - t5[3] / e4];
        }
        const l3 = e3.left * a4, u4 = e3.right * a4;
        let c3, h3, p3, f3;
        "width" === r3 || "both" === r3 ? (f3 = i3[0] + l3 - n3[3], h3 = i3[0] + u4 + n3[1]) : (f3 = i3[0] + (l3 + u4 - s3.displaySize[0]) / 2, h3 = f3 + s3.displaySize[0]);
        const d3 = e3.top * a4, m2 = e3.bottom * a4;
        return "height" === r3 || "both" === r3 ? (c3 = i3[1] + d3 - n3[0], p3 = i3[1] + m2 + n3[2]) : (c3 = i3[1] + (d3 + m2 - s3.displaySize[1]) / 2, p3 = c3 + s3.displaySize[1]), { imagePrimary: s3, imageSecondary: void 0, top: c3, right: h3, bottom: p3, left: f3, collisionPadding: o3 };
      }
      class kf extends q {
        constructor(t4, e3, r3, n3, i3) {
          super(t4, e3), this.angle = n3, this.z = r3, void 0 !== i3 && (this.segment = i3);
        }
        clone() {
          return new kf(this.x, this.y, this.z, this.angle, this.segment);
        }
      }
      function Tf(t4, e3, r3, n3, i3) {
        if (void 0 === e3.segment) return true;
        let a4 = e3, s3 = e3.segment + 1, o3 = 0;
        for (; o3 > -r3 / 2; ) {
          if (s3--, s3 < 0) return false;
          o3 -= t4[s3].dist(a4), a4 = t4[s3];
        }
        o3 += t4[s3].dist(t4[s3 + 1]), s3++;
        const l3 = [];
        let u4 = 0;
        for (; o3 < r3 / 2; ) {
          const e4 = t4[s3], r4 = t4[s3 + 1];
          if (!r4) return false;
          let a5 = t4[s3 - 1].angleTo(e4) - e4.angleTo(r4);
          for (a5 = Math.abs((a5 + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l3.push({ distance: o3, angleDelta: a5 }), u4 += a5; o3 - l3[0].distance > n3; ) u4 -= l3.shift().angleDelta;
          if (u4 > i3) return false;
          s3++, o3 += e4.dist(r4);
        }
        return true;
      }
      function Ef(t4) {
        let e3 = 0;
        for (let r3 = 0; r3 < t4.length - 1; r3++) e3 += t4[r3].dist(t4[r3 + 1]);
        return e3;
      }
      function Bf(t4, e3, r3) {
        return t4 ? 0.6 * e3 * r3 : 0;
      }
      function Vf(t4, e3) {
        return Math.max(t4 ? t4.right - t4.left : 0, e3 ? e3.right - e3.left : 0);
      }
      function Cf(t4, e3, r3, n3, i3, a4) {
        const s3 = Bf(r3, i3, a4), o3 = Vf(r3, n3) * a4;
        let l3 = 0;
        const u4 = Ef(t4) / 2;
        for (let r4 = 0; r4 < t4.length - 1; r4++) {
          const n4 = t4[r4], i4 = t4[r4 + 1], a5 = n4.dist(i4);
          if (l3 + a5 > u4) {
            const c3 = (u4 - l3) / a5, h3 = Pe(n4.x, i4.x, c3), p3 = Pe(n4.y, i4.y, c3), f3 = new kf(h3, p3, 0, i4.angleTo(n4), r4);
            return !s3 || Tf(t4, f3, o3, s3, e3) ? f3 : void 0;
          }
          l3 += a5;
        }
      }
      function Rf(t4, e3, r3, n3, i3, a4, s3, o3, l3) {
        const u4 = Bf(n3, a4, s3), c3 = Vf(n3, i3), h3 = c3 * s3, p3 = 0 === t4[0].x || t4[0].x === l3 || 0 === t4[0].y || t4[0].y === l3;
        return e3 - h3 < e3 / 4 && (e3 = h3 + e3 / 4), Df(t4, p3 ? e3 / 2 * o3 % e3 : (c3 / 2 + 2 * a4) * s3 * o3 % e3, e3, u4, r3, h3, p3, false, l3);
      }
      function Df(t4, e3, r3, n3, i3, a4, s3, o3, l3) {
        const u4 = a4 / 2, c3 = Ef(t4);
        let h3 = 0, p3 = e3 - r3, f3 = [];
        for (let e4 = 0; e4 < t4.length - 1; e4++) {
          const s4 = t4[e4], o4 = t4[e4 + 1], d3 = s4.dist(o4), m2 = o4.angleTo(s4);
          for (; p3 + r3 < h3 + d3; ) {
            p3 += r3;
            const y2 = (p3 - h3) / d3, g4 = Pe(s4.x, o4.x, y2), x2 = Pe(s4.y, o4.y, y2);
            if (g4 >= 0 && g4 < l3 && x2 >= 0 && x2 < l3 && p3 - u4 >= 0 && p3 + u4 <= c3) {
              const r4 = new kf(g4, x2, 0, m2, e4);
              n3 && !Tf(t4, r4, a4, n3, i3) || f3.push(r4);
            }
          }
          h3 += d3;
        }
        return o3 || f3.length || s3 || (f3 = Df(t4, h3 / 2, r3, n3, i3, a4, s3, true, l3)), f3;
      }
      function Lf(t4, e3, r3, n3, i3) {
        const a4 = [];
        for (let s3 = 0; s3 < t4.length; s3++) {
          const o3 = t4[s3];
          let l3;
          for (let t5 = 0; t5 < o3.length - 1; t5++) {
            let s4 = o3[t5], u4 = o3[t5 + 1];
            s4.x < e3 && u4.x < e3 || (s4.x < e3 ? s4 = new q(e3, s4.y + (e3 - s4.x) / (u4.x - s4.x) * (u4.y - s4.y))._round() : u4.x < e3 && (u4 = new q(e3, s4.y + (e3 - s4.x) / (u4.x - s4.x) * (u4.y - s4.y))._round()), s4.y < r3 && u4.y < r3 || (s4.y < r3 ? s4 = new q(s4.x + (r3 - s4.y) / (u4.y - s4.y) * (u4.x - s4.x), r3)._round() : u4.y < r3 && (u4 = new q(s4.x + (r3 - s4.y) / (u4.y - s4.y) * (u4.x - s4.x), r3)._round()), s4.x >= n3 && u4.x >= n3 || (s4.x >= n3 ? s4 = new q(n3, s4.y + (n3 - s4.x) / (u4.x - s4.x) * (u4.y - s4.y))._round() : u4.x >= n3 && (u4 = new q(n3, s4.y + (n3 - s4.x) / (u4.x - s4.x) * (u4.y - s4.y))._round()), s4.y >= i3 && u4.y >= i3 || (s4.y >= i3 ? s4 = new q(s4.x + (i3 - s4.y) / (u4.y - s4.y) * (u4.x - s4.x), i3)._round() : u4.y >= i3 && (u4 = new q(s4.x + (i3 - s4.y) / (u4.y - s4.y) * (u4.x - s4.x), i3)._round()), l3 && s4.equals(l3[l3.length - 1]) || (l3 = [s4], a4.push(l3)), l3.push(u4)))));
          }
        }
        return a4;
      }
      function Ff(t4) {
        let e3 = 0, r3 = 0;
        for (const n4 of t4) e3 += n4.w * n4.h, r3 = Math.max(r3, n4.w);
        t4.sort((t5, e4) => e4.h - t5.h);
        const n3 = [{ x: 0, y: 0, w: Math.max(Math.ceil(Math.sqrt(e3 / 0.95)), r3), h: 1 / 0 }];
        let i3 = 0, a4 = 0;
        for (const e4 of t4) for (let t5 = n3.length - 1; t5 >= 0; t5--) {
          const r4 = n3[t5];
          if (!(e4.w > r4.w || e4.h > r4.h)) {
            if (e4.x = r4.x, e4.y = r4.y, a4 = Math.max(a4, e4.y + e4.h), i3 = Math.max(i3, e4.x + e4.w), e4.w === r4.w && e4.h === r4.h) {
              const e5 = n3.pop();
              t5 < n3.length && (n3[t5] = e5);
            } else e4.h === r4.h ? (r4.x += e4.w, r4.w -= e4.w) : e4.w === r4.w ? (r4.y += e4.h, r4.h -= e4.h) : (n3.push({ x: r4.x + e4.w, y: r4.y, w: r4.w - e4.w, h: e4.h }), r4.y += e4.h, r4.h -= e4.h);
            break;
          }
        }
        return { w: i3, h: a4, fill: e3 / (i3 * a4) || 0 };
      }
      aa(kf, "Anchor");
      const Of = 1;
      class Uf {
        constructor(t4, { pixelRatio: e3, version: r3, stretchX: n3, stretchY: i3, content: a4 }, s3) {
          this.paddedRect = t4, this.pixelRatio = e3, this.stretchX = n3, this.stretchY = i3, this.content = a4, this.version = r3, this.padding = s3;
        }
        get tl() {
          return [this.paddedRect.x + this.padding, this.paddedRect.y + this.padding];
        }
        get br() {
          return [this.paddedRect.x + this.paddedRect.w - this.padding, this.paddedRect.y + this.paddedRect.h - this.padding];
        }
        get displaySize() {
          return [(this.paddedRect.w - 2 * this.padding) / this.pixelRatio, (this.paddedRect.h - 2 * this.padding) / this.pixelRatio];
        }
      }
      class jf {
        constructor(t4, e3, r3) {
          const n3 = {}, i3 = {};
          this.haveRenderCallbacks = [];
          const a4 = [];
          this.addImages(t4, n3, Of, a4), this.addImages(e3, i3, 2, a4);
          const { w: s3, h: o3 } = Ff(a4), l3 = new ic({ width: s3 || 1, height: o3 || 1 });
          for (const e4 in t4) {
            const i4 = t4[e4], a5 = n3[e4].paddedRect;
            ic.copy(i4.data, l3, { x: 0, y: 0 }, { x: a5.x + Of, y: a5.y + Of }, i4.data, r3, i4.sdf);
          }
          for (const t5 in e3) {
            const n4 = e3[t5], a5 = i3[t5].paddedRect;
            let s4 = i3[t5].padding;
            const o4 = a5.x + s4, u4 = a5.y + s4, c3 = n4.data.width, h3 = n4.data.height;
            s4 = s4 > 1 ? s4 - 1 : s4, ic.copy(n4.data, l3, { x: 0, y: 0 }, { x: o4, y: u4 }, n4.data, r3), ic.copy(n4.data, l3, { x: 0, y: h3 - s4 }, { x: o4, y: u4 - s4 }, { width: c3, height: s4 }, r3), ic.copy(n4.data, l3, { x: 0, y: 0 }, { x: o4, y: u4 + h3 }, { width: c3, height: s4 }, r3), ic.copy(n4.data, l3, { x: c3 - s4, y: 0 }, { x: o4 - s4, y: u4 }, { width: s4, height: h3 }, r3), ic.copy(n4.data, l3, { x: 0, y: 0 }, { x: o4 + c3, y: u4 }, { width: s4, height: h3 }, r3), ic.copy(n4.data, l3, { x: c3 - s4, y: h3 - s4 }, { x: o4 - s4, y: u4 - s4 }, { width: s4, height: s4 }, r3), ic.copy(n4.data, l3, { x: 0, y: h3 - s4 }, { x: o4 + c3, y: u4 - s4 }, { width: s4, height: s4 }, r3), ic.copy(n4.data, l3, { x: 0, y: 0 }, { x: o4 + c3, y: u4 + h3 }, { width: s4, height: s4 }, r3), ic.copy(n4.data, l3, { x: c3 - s4, y: 0 }, { x: o4 - s4, y: u4 + h3 }, { width: s4, height: s4 }, r3);
          }
          this.image = l3, this.iconPositions = n3, this.patternPositions = i3;
        }
        addImages(t4, e3, r3, n3) {
          for (const i3 in t4) {
            const a4 = t4[i3], s3 = { x: 0, y: 0, w: a4.data.width + 2 * r3, h: a4.data.height + 2 * r3 };
            n3.push(s3), e3[i3] = new Uf(s3, a4, r3), a4.hasRenderCallback && this.haveRenderCallbacks.push(i3);
          }
        }
        patchUpdatedImages(t4, e3, r3) {
          this.haveRenderCallbacks = this.haveRenderCallbacks.filter((e4) => t4.hasImage(e4, r3)), t4.dispatchRenderCallbacks(this.haveRenderCallbacks, r3);
          for (const n3 in t4.getUpdatedImages(r3)) this.patchUpdatedImage(this.iconPositions[n3], t4.getImage(n3, r3), e3), this.patchUpdatedImage(this.patternPositions[n3], t4.getImage(n3, r3), e3);
        }
        patchUpdatedImage(t4, e3, r3) {
          if (!t4 || !e3) return;
          if (t4.version === e3.version) return;
          t4.version = e3.version;
          const [n3, i3] = t4.tl;
          r3.update(e3.data, { position: { x: n3, y: i3 } });
        }
      }
      aa(Uf, "ImagePosition"), aa(jf, "ImageAtlas");
      const Nf = 1e20;
      function qf(t4, e3, r3, n3, i3, a4, s3, o3, l3) {
        for (let u4 = e3; u4 < e3 + n3; u4++) $f(t4, r3 * a4 + u4, a4, i3, s3, o3, l3);
        for (let u4 = r3; u4 < r3 + i3; u4++) $f(t4, u4 * a4 + e3, 1, n3, s3, o3, l3);
      }
      function $f(t4, e3, r3, n3, i3, a4, s3) {
        a4[0] = 0, s3[0] = -Nf, s3[1] = Nf, i3[0] = t4[e3];
        for (let o3 = 1, l3 = 0, u4 = 0; o3 < n3; o3++) {
          i3[o3] = t4[e3 + o3 * r3];
          const n4 = o3 * o3;
          do {
            const t5 = a4[l3];
            u4 = (i3[o3] - i3[t5] + n4 - t5 * t5) / (o3 - t5) / 2;
          } while (u4 <= s3[l3] && --l3 > -1);
          l3++, a4[l3] = o3, s3[l3] = u4, s3[l3 + 1] = Nf;
        }
        for (let o3 = 0, l3 = 0; o3 < n3; o3++) {
          for (; s3[l3 + 1] < o3; ) l3++;
          const n4 = a4[l3], u4 = o3 - n4;
          t4[e3 + o3 * r3] = i3[n4] + u4 * u4;
        }
      }
      const Gf = 2, Xf = { none: 0, ideographs: 1, all: 2 };
      class Yf {
        constructor(t4, e3, r3) {
          this.requestManager = t4, this.localGlyphMode = e3, this.localFontFamily = r3, this.urls = {}, this.entries = {}, this.localGlyphs = { 200: {}, 400: {}, 500: {}, 900: {} };
        }
        setURL(t4, e3) {
          this.urls[e3] = t4;
        }
        getGlyphs(t4, e3, r3) {
          const n3 = [], i3 = this.urls[e3] || St.GLYPHS_URL;
          for (const e4 in t4) for (const r4 of t4[e4]) n3.push({ stack: e4, id: r4 });
          rt(n3, ({ stack: t5, id: e4 }, r4) => {
            let n4 = this.entries[t5];
            n4 || (n4 = this.entries[t5] = { glyphs: {}, requests: {}, ranges: {}, ascender: void 0, descender: void 0 });
            let a4 = n4.glyphs[e4];
            if (void 0 !== a4) return void r4(null, { stack: t5, id: e4, glyph: a4 });
            if (a4 = this._tinySDF(n4, t5, e4), a4) return n4.glyphs[e4] = a4, void r4(null, { stack: t5, id: e4, glyph: a4 });
            const s3 = Math.floor(e4 / 256);
            if (256 * s3 > 65535) return ft("glyphs > 65535 not supported"), void r4(null, { stack: t5, id: e4, glyph: a4 });
            if (n4.ranges[s3]) return void r4(null, { stack: t5, id: e4, glyph: a4 });
            let o3 = n4.requests[s3];
            o3 || (o3 = n4.requests[s3] = [], Yf.loadGlyphRange(t5, s3, i3, this.requestManager, (t6, e5) => {
              if (e5) {
                n4.ascender = e5.ascender, n4.descender = e5.descender;
                for (const t7 in e5.glyphs) this._doesCharSupportLocalGlyph(+t7) || (n4.glyphs[+t7] = e5.glyphs[+t7]);
                n4.ranges[s3] = true;
              }
              for (const r5 of o3) r5(t6, e5);
              delete n4.requests[s3];
            })), o3.push((n5, i4) => {
              n5 ? r4(n5) : i4 && r4(null, { stack: t5, id: e4, glyph: i4.glyphs[e4] || null });
            });
          }, (t5, e4) => {
            if (t5) r3(t5);
            else if (e4) {
              const t6 = {};
              for (const { stack: r4, id: n4, glyph: i4 } of e4) void 0 === t6[r4] && (t6[r4] = {}), void 0 === t6[r4].glyphs && (t6[r4].glyphs = {}), t6[r4].glyphs[n4] = i4 && { id: i4.id, bitmap: i4.bitmap.clone(), metrics: i4.metrics }, t6[r4].ascender = this.entries[r4].ascender, t6[r4].descender = this.entries[r4].descender;
              r3(null, t6);
            }
          });
        }
        _doesCharSupportLocalGlyph(t4) {
          return this.localGlyphMode !== Xf.none && (this.localGlyphMode === Xf.all ? !!this.localFontFamily : !!this.localFontFamily && (ca["CJK Unified Ideographs"](t4) || ca["Hangul Syllables"](t4) || ca.Hiragana(t4) || ca.Katakana(t4) || ca["CJK Symbols and Punctuation"](t4) || ca["CJK Unified Ideographs Extension A"](t4) || ca["CJK Unified Ideographs Extension B"](t4) || ca.Osage(t4)));
        }
        _tinySDF(t4, e3, r3) {
          const n3 = this.localFontFamily;
          if (!n3 || !this._doesCharSupportLocalGlyph(r3)) return;
          let i3 = t4.tinySDF;
          if (!i3) {
            let r4 = "400";
            /bold/i.test(e3) ? r4 = "900" : /medium/i.test(e3) ? r4 = "500" : /light/i.test(e3) && (r4 = "200"), i3 = t4.tinySDF = new Yf.TinySDF({ fontFamily: n3, fontWeight: r4, fontSize: 24 * Gf, buffer: 3 * Gf, radius: 8 * Gf }), i3.fontWeight = r4;
          }
          if (this.localGlyphs[i3.fontWeight][r3]) return this.localGlyphs[i3.fontWeight][r3];
          const a4 = String.fromCodePoint(r3), { data: s3, width: o3, height: l3, glyphWidth: u4, glyphHeight: c3, glyphLeft: h3, glyphTop: p3, glyphAdvance: f3 } = i3.draw(a4);
          return this.localGlyphs[i3.fontWeight][r3] = { id: r3, bitmap: new nc({ width: o3, height: l3 }, s3), metrics: { width: u4 / Gf, height: c3 / Gf, left: h3 / Gf, top: p3 / Gf - 27, advance: f3 / Gf, localGlyph: true } };
        }
      }
      Yf.loadGlyphRange = function(t4, e3, r3, n3, i3) {
        const a4 = 256 * e3, s3 = a4 + 255, o3 = n3.transformRequest(n3.normalizeGlyphsURL(r3).replace("{fontstack}", t4).replace("{range}", `${a4}-${s3}`), te2.Glyphs);
        ie(o3, (t5, e4) => {
          if (t5) i3(t5);
          else if (e4) {
            const t6 = {}, r4 = function(t7) {
              return new lf(t7).readFields(cf, {});
            }(e4);
            for (const e5 of r4.glyphs) t6[e5.id] = e5;
            i3(null, { glyphs: t6, ascender: r4.ascender, descender: r4.descender });
          }
        });
      }, Yf.TinySDF = class {
        constructor({ fontSize: t4 = 24, buffer: e3 = 3, radius: r3 = 8, cutoff: n3 = 0.25, fontFamily: i3 = "sans-serif", fontWeight: a4 = "normal", fontStyle: s3 = "normal" } = {}) {
          this.buffer = e3, this.cutoff = n3, this.radius = r3;
          const o3 = this.size = t4 + 4 * e3, l3 = this._createCanvas(o3), u4 = this.ctx = l3.getContext("2d", { willReadFrequently: true });
          u4.font = `${s3} ${a4} ${t4}px ${i3}`, u4.textBaseline = "alphabetic", u4.textAlign = "left", u4.fillStyle = "black", this.gridOuter = new Float64Array(o3 * o3), this.gridInner = new Float64Array(o3 * o3), this.f = new Float64Array(o3), this.z = new Float64Array(o3 + 1), this.v = new Uint16Array(o3);
        }
        _createCanvas(t4) {
          const e3 = document.createElement("canvas");
          return e3.width = e3.height = t4, e3;
        }
        draw(t4) {
          const { width: e3, actualBoundingBoxAscent: r3, actualBoundingBoxDescent: n3, actualBoundingBoxLeft: i3, actualBoundingBoxRight: a4 } = this.ctx.measureText(t4), s3 = Math.ceil(r3), o3 = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(a4 - i3))), l3 = Math.min(this.size - this.buffer, s3 + Math.ceil(n3)), u4 = o3 + 2 * this.buffer, c3 = l3 + 2 * this.buffer, h3 = Math.max(u4 * c3, 0), p3 = new Uint8ClampedArray(h3), f3 = { data: p3, width: u4, height: c3, glyphWidth: o3, glyphHeight: l3, glyphTop: s3, glyphLeft: 0, glyphAdvance: e3 };
          if (0 === o3 || 0 === l3) return f3;
          const { ctx: d3, buffer: m2, gridInner: y2, gridOuter: g4 } = this;
          d3.clearRect(m2, m2, o3, l3), d3.fillText(t4, m2, m2 + s3);
          const x2 = d3.getImageData(m2, m2, o3, l3);
          g4.fill(Nf, 0, h3), y2.fill(0, 0, h3);
          for (let t5 = 0; t5 < l3; t5++) for (let e4 = 0; e4 < o3; e4++) {
            const r4 = x2.data[4 * (t5 * o3 + e4) + 3] / 255;
            if (0 === r4) continue;
            const n4 = (t5 + m2) * u4 + e4 + m2;
            if (1 === r4) g4[n4] = 0, y2[n4] = Nf;
            else {
              const t6 = 0.5 - r4;
              g4[n4] = t6 > 0 ? t6 * t6 : 0, y2[n4] = t6 < 0 ? t6 * t6 : 0;
            }
          }
          qf(g4, 0, 0, u4, c3, u4, this.f, this.v, this.z), qf(y2, m2, m2, o3, l3, u4, this.f, this.v, this.z);
          for (let t5 = 0; t5 < h3; t5++) {
            const e4 = Math.sqrt(g4[t5]) - Math.sqrt(y2[t5]);
            p3[t5] = Math.round(255 - 255 * (e4 / this.radius + this.cutoff));
          }
          return f3;
        }
      };
      const Zf = Of;
      function Wf(t4, e3, r3, n3, i3 = 1) {
        const a4 = [], s3 = t4.imagePrimary, o3 = s3.pixelRatio, l3 = s3.paddedRect.w - 2 * Zf, u4 = s3.paddedRect.h - 2 * Zf, c3 = (t4.right - t4.left) * i3, h3 = (t4.bottom - t4.top) * i3, p3 = s3.stretchX || [[0, l3]], f3 = s3.stretchY || [[0, u4]], d3 = (t5, e4) => t5 + e4[1] - e4[0], m2 = p3.reduce(d3, 0), y2 = f3.reduce(d3, 0), g4 = l3 - m2, x2 = u4 - y2;
        let v2 = 0, b2 = m2, w2 = 0, _2 = y2, M2 = 0, A3 = g4, S2 = 0, I3 = x2;
        if (s3.content && n3) {
          const t5 = s3.content;
          v2 = Hf(p3, 0, t5[0]), w2 = Hf(f3, 0, t5[1]), b2 = Hf(p3, t5[0], t5[2]), _2 = Hf(f3, t5[1], t5[3]), M2 = t5[0] - v2, S2 = t5[1] - w2, A3 = t5[2] - t5[0] - b2, I3 = t5[3] - t5[1] - _2;
        }
        const z3 = (n4, a5, l4, u5) => {
          const p4 = Jf(n4.stretch - v2, b2, c3, t4.left * i3), f4 = Qf(n4.fixed - M2, A3, n4.stretch, m2), d4 = Jf(a5.stretch - w2, _2, h3, t4.top * i3), g5 = Qf(a5.fixed - S2, I3, a5.stretch, y2), x3 = Jf(l4.stretch - v2, b2, c3, t4.left * i3), z4 = Qf(l4.fixed - M2, A3, l4.stretch, m2), P2 = Jf(u5.stretch - w2, _2, h3, t4.top * i3), k2 = Qf(u5.fixed - S2, I3, u5.stretch, y2), T3 = new q(p4, d4), E3 = new q(x3, d4), B4 = new q(x3, P2), V3 = new q(p4, P2), C3 = new q(f4 / o3, g5 / o3), R3 = new q(z4 / o3, k2 / o3), D2 = e3 * Math.PI / 180;
          if (D2) {
            const t5 = Math.sin(D2), e4 = Math.cos(D2), r4 = [e4, -t5, t5, e4];
            T3._matMult(r4), E3._matMult(r4), V3._matMult(r4), B4._matMult(r4);
          }
          const L3 = n4.stretch + n4.fixed, F3 = l4.stretch + l4.fixed, O2 = a5.stretch + a5.fixed, U3 = u5.stretch + u5.fixed, j2 = t4.imageSecondary;
          return { tl: T3, tr: E3, bl: V3, br: B4, texPrimary: { x: s3.paddedRect.x + Zf + L3, y: s3.paddedRect.y + Zf + O2, w: F3 - L3, h: U3 - O2 }, texSecondary: j2 ? { x: j2.paddedRect.x + Zf + L3, y: j2.paddedRect.y + Zf + O2, w: F3 - L3, h: U3 - O2 } : void 0, writingMode: void 0, glyphOffset: [0, 0], sectionIndex: 0, pixelOffsetTL: C3, pixelOffsetBR: R3, minFontScaleX: A3 / o3 / c3, minFontScaleY: I3 / o3 / h3, isSDF: r3 };
        };
        if (n3 && (s3.stretchX || s3.stretchY)) {
          const t5 = Kf(p3, g4, m2), e4 = Kf(f3, x2, y2);
          for (let r4 = 0; r4 < t5.length - 1; r4++) {
            const n4 = t5[r4], i4 = t5[r4 + 1];
            for (let t6 = 0; t6 < e4.length - 1; t6++) a4.push(z3(n4, e4[t6], i4, e4[t6 + 1]));
          }
        } else a4.push(z3({ fixed: 0, stretch: -1 }, { fixed: 0, stretch: -1 }, { fixed: 0, stretch: l3 + 1 }, { fixed: 0, stretch: u4 + 1 }));
        return a4;
      }
      function Hf(t4, e3, r3) {
        let n3 = 0;
        for (const i3 of t4) n3 += Math.max(e3, Math.min(r3, i3[1])) - Math.max(e3, Math.min(r3, i3[0]));
        return n3;
      }
      function Kf(t4, e3, r3) {
        const n3 = [{ fixed: -Zf, stretch: 0 }];
        for (const [e4, r4] of t4) {
          const t5 = n3[n3.length - 1];
          n3.push({ fixed: e4 - t5.stretch, stretch: t5.stretch }), n3.push({ fixed: e4 - t5.stretch, stretch: t5.stretch + (r4 - e4) });
        }
        return n3.push({ fixed: e3 + Zf, stretch: r3 }), n3;
      }
      function Jf(t4, e3, r3, n3) {
        return t4 / e3 * r3 + n3;
      }
      function Qf(t4, e3, r3, n3) {
        return t4 - e3 * r3 / n3;
      }
      function td2(t4, e3, r3, n3) {
        const i3 = e3 + t4.positionedLines[n3].lineOffset;
        return 0 === n3 ? r3 + i3 / 2 : r3 + (i3 + (e3 + t4.positionedLines[n3 - 1].lineOffset)) / 2;
      }
      function ed(t4, e3 = 1, r3 = false) {
        let n3 = 1 / 0, i3 = 1 / 0, a4 = -1 / 0, s3 = -1 / 0;
        const o3 = t4[0];
        for (let t5 = 0; t5 < o3.length; t5++) {
          const e4 = o3[t5];
          (!t5 || e4.x < n3) && (n3 = e4.x), (!t5 || e4.y < i3) && (i3 = e4.y), (!t5 || e4.x > a4) && (a4 = e4.x), (!t5 || e4.y > s3) && (s3 = e4.y);
        }
        const l3 = Math.min(a4 - n3, s3 - i3);
        let u4 = l3 / 2;
        const c3 = new Zr([], rd);
        if (0 === l3) return new q(n3, i3);
        for (let e4 = n3; e4 < a4; e4 += l3) for (let r4 = i3; r4 < s3; r4 += l3) c3.push(new nd(e4 + u4, r4 + u4, u4, t4));
        let h3 = function(t5) {
          let e4 = 0, r4 = 0, n4 = 0;
          const i4 = t5[0];
          for (let t6 = 0, a5 = i4.length, s4 = a5 - 1; t6 < a5; s4 = t6++) {
            const a6 = i4[t6], o4 = i4[s4], l4 = a6.x * o4.y - o4.x * a6.y;
            r4 += (a6.x + o4.x) * l4, n4 += (a6.y + o4.y) * l4, e4 += 3 * l4;
          }
          return new nd(r4 / e4, n4 / e4, 0, t5);
        }(t4), p3 = c3.length;
        for (; c3.length; ) {
          const n4 = c3.pop();
          (n4.d > h3.d || !h3.d) && (h3 = n4, r3 && console.log("found best %d after %d probes", Math.round(1e4 * n4.d) / 1e4, p3)), n4.max - h3.d <= e3 || (u4 = n4.h / 2, c3.push(new nd(n4.p.x - u4, n4.p.y - u4, u4, t4)), c3.push(new nd(n4.p.x + u4, n4.p.y - u4, u4, t4)), c3.push(new nd(n4.p.x - u4, n4.p.y + u4, u4, t4)), c3.push(new nd(n4.p.x + u4, n4.p.y + u4, u4, t4)), p3 += 4);
        }
        return r3 && (console.log(`num probes: ${p3}`), console.log(`best distance: ${h3.d}`)), h3.p;
      }
      function rd(t4, e3) {
        return e3.max - t4.max;
      }
      class nd {
        constructor(t4, e3, r3, n3) {
          this.p = new q(t4, e3), this.h = r3, this.d = function(t5, e4) {
            let r4 = false, n4 = 1 / 0;
            for (let i3 = 0; i3 < e4.length; i3++) {
              const a4 = e4[i3];
              for (let e5 = 0, i4 = a4.length, s3 = i4 - 1; e5 < i4; s3 = e5++) {
                const i5 = a4[e5], o3 = a4[s3];
                i5.y > t5.y != o3.y > t5.y && t5.x < (o3.x - i5.x) * (t5.y - i5.y) / (o3.y - i5.y) + i5.x && (r4 = !r4), n4 = Math.min(n4, Fl(t5, i5, o3));
              }
            }
            return (r4 ? 1 : -1) * Math.sqrt(n4);
          }(this.p, n3), this.max = this.d + this.h * Math.SQRT2;
        }
      }
      const id = Number.POSITIVE_INFINITY, ad = Math.sqrt(2);
      function sd(t4, [e3, r3]) {
        let n3 = 0, i3 = 0;
        if (r3 === id) {
          e3 < 0 && (e3 = 0);
          const r4 = e3 / ad;
          switch (t4) {
            case "top-right":
            case "top-left":
              i3 = r4 - 7;
              break;
            case "bottom-right":
            case "bottom-left":
              i3 = 7 - r4;
              break;
            case "bottom":
              i3 = 7 - e3;
              break;
            case "top":
              i3 = e3 - 7;
          }
          switch (t4) {
            case "top-right":
            case "bottom-right":
              n3 = -r4;
              break;
            case "top-left":
            case "bottom-left":
              n3 = r4;
              break;
            case "left":
              n3 = e3;
              break;
            case "right":
              n3 = -e3;
          }
        } else {
          switch (e3 = Math.abs(e3), r3 = Math.abs(r3), t4) {
            case "top-right":
            case "top-left":
            case "top":
              i3 = r3 - 7;
              break;
            case "bottom-right":
            case "bottom-left":
            case "bottom":
              i3 = 7 - r3;
          }
          switch (t4) {
            case "top-right":
            case "bottom-right":
            case "right":
              n3 = -e3;
              break;
            case "top-left":
            case "bottom-left":
            case "left":
              n3 = e3;
          }
        }
        return [n3, i3];
      }
      function od(t4) {
        switch (t4) {
          case "right":
          case "top-right":
          case "bottom-right":
            return "right";
          case "left":
          case "top-left":
          case "bottom-left":
            return "left";
        }
        return "center";
      }
      function ld(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3, d3) {
        let m2 = a4.textMaxSize.evaluate(e3, {}, h3);
        void 0 === m2 ? m2 = s3 * a4.textScaleFactor : m2 *= a4.textScaleFactor;
        const y2 = t4.layers[0].layout, g4 = y2.get("icon-offset").evaluate(e3, {}, h3), x2 = pd(r3.horizontal) || r3.vertical, v2 = "globe" === p3.name, b2 = Gp, w2 = s3 * a4.textScaleFactor / b2, _2 = t4.tilePixelRatio * m2 / b2, M2 = (E3 = t4.overscaling, t4.zoom > 18 && E3 > 2 && (E3 >>= 1), Math.max(Wr / (512 * E3), 1) * y2.get("symbol-spacing")), A3 = y2.get("text-padding") * t4.tilePixelRatio, S2 = y2.get("icon-padding") * t4.tilePixelRatio, I3 = Y(y2.get("text-max-angle")), z3 = "map" === y2.get("text-rotation-alignment") && "point" !== y2.get("symbol-placement"), P2 = "map" === y2.get("icon-rotation-alignment") && "point" !== y2.get("symbol-placement"), k2 = y2.get("symbol-placement"), T3 = M2 / 2;
        var E3;
        const B4 = y2.get("icon-text-fit").evaluate(e3, {}, h3), V3 = y2.get("icon-text-fit-padding").evaluate(e3, {}, h3), C3 = "none" !== B4;
        let R3;
        false === t4.hasAnyIconTextFit && C3 && (t4.hasAnyIconTextFit = true), n3 && C3 && (t4.allowVerticalPlacement && r3.vertical && (R3 = Pf(n3, r3.vertical, B4, V3, g4, w2)), x2 && (n3 = Pf(n3, x2, B4, V3, g4, w2)));
        const D2 = (s4, o4, m3) => {
          if (o4.x < 0 || o4.x >= Wr || o4.y < 0 || o4.y >= Wr) return;
          let y3 = null;
          if (v2) {
            const { x: t5, y: e4, z: r4 } = p3.projectTilePoint(o4.x, o4.y, m3);
            y3 = { anchor: new kf(t5, e4, r4, 0, void 0), up: p3.upVector(m3, o4.x, o4.y) };
          }
          !function(t5, e4, r4, n4, i4, a5, s5, o5, l4, u5, c4, h4, p4, f4, d4, m4, y4, g5, x3, v3, b3, w3, _3, M3, A4, S3, I4) {
            const z4 = t5.addToLineVertexArray(e4, n4);
            let P3, k3, T4, E4, B5, V4, C4, R4 = 0, D3 = 0, L3 = 0, F3 = 0, O2 = -1, U3 = -1;
            const j2 = {};
            let N2 = ge2("");
            const q2 = r4 ? r4.anchor : e4, $3 = "none" !== l4.layout.get("icon-text-fit").evaluate(b3, {}, A4);
            let G2 = 0, X2 = 0;
            if (void 0 === l4._unevaluatedLayout.getValue("text-radial-offset") ? [G2, X2] = l4.layout.get("text-offset").evaluate(b3, {}, A4).map((t6) => t6 * Gp) : (G2 = l4.layout.get("text-radial-offset").evaluate(b3, {}, A4) * Gp, X2 = id), t5.allowVerticalPlacement && i4.vertical) {
              const t6 = i4.vertical;
              if (d4) V4 = dd(t6), o5 && (C4 = dd(o5));
              else {
                const r5 = l4.layout.get("text-rotate").evaluate(b3, {}, A4) + 90;
                T4 = fd2(u5, q2, e4, c4, h4, p4, t6, f4, r5, m4), o5 && (E4 = fd2(u5, q2, e4, c4, h4, p4, o5, g5, r5));
              }
            }
            if (a5) {
              const n5 = l4.layout.get("icon-rotate").evaluate(b3, {}, A4), i5 = Wf(a5, n5, _3, $3, w3.iconScaleFactor), s6 = o5 ? Wf(o5, n5, _3, $3, w3.iconScaleFactor) : void 0;
              k3 = fd2(u5, q2, e4, c4, h4, p4, a5, g5, n5), R4 = 4 * i5.length;
              const f5 = t5.iconSizeData;
              let d5 = null;
              "source" === f5.kind ? (d5 = [Xp * l4.layout.get("icon-size").evaluate(b3, {}, A4) * w3.iconScaleFactor], d5[0] > cd && ft(`${t5.layerIds[0]}: Value for "icon-size" is >= ${ud}. Reduce your "icon-size".`)) : "composite" === f5.kind && (d5 = [Xp * w3.compositeIconSizes[0].evaluate(b3, {}, A4) * w3.iconScaleFactor, Xp * w3.compositeIconSizes[1].evaluate(b3, {}, A4) * w3.iconScaleFactor], (d5[0] > cd || d5[1] > cd) && ft(`${t5.layerIds[0]}: Value for "icon-size" is >= ${ud}. Reduce your "icon-size".`)), t5.addSymbols(t5.icon, i5, d5, v3, x3, b3, false, r4, e4, z4.lineStartIndex, z4.lineLength, -1, M3, A4, S3, I4), O2 = t5.icon.placedSymbolArray.length - 1, s6 && (D3 = 4 * s6.length, t5.addSymbols(t5.icon, s6, d5, v3, x3, b3, df.vertical, r4, e4, z4.lineStartIndex, z4.lineLength, -1, M3, A4, S3, I4), U3 = t5.icon.placedSymbolArray.length - 1);
            }
            for (const n5 in i4.horizontal) {
              const a6 = i4.horizontal[n5];
              P3 || (N2 = ge2(a6.text), d4 ? B5 = dd(a6) : P3 = fd2(u5, q2, e4, c4, h4, p4, a6, f4, l4.layout.get("text-rotate").evaluate(b3, {}, A4), m4));
              const o6 = 1 === a6.positionedLines.length;
              if (L3 += hd(t5, r4, e4, a6, s5, l4, d4, b3, m4, z4, i4.vertical ? df.horizontal : df.horizontalOnly, o6 ? Object.keys(i4.horizontal) : [n5], j2, O2, w3, M3, A4, S3), o6) break;
            }
            i4.vertical && (F3 += hd(t5, r4, e4, i4.vertical, s5, l4, d4, b3, m4, z4, df.vertical, ["vertical"], j2, U3, w3, M3, A4, S3));
            let Y2 = -1;
            const Z3 = (t6, e5) => t6 ? Math.max(t6, e5) : e5;
            Y2 = Z3(B5, Y2), Y2 = Z3(V4, Y2), Y2 = Z3(C4, Y2);
            const W2 = Y2 > -1 ? 1 : 0;
            t5.glyphOffsetArray.length >= 65535 && ft("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== b3.sortKey && t5.addToSortKeyRanges(t5.symbolInstances.length, b3.sortKey), t5.symbolInstances.emplaceBack(e4.x, e4.y, q2.x, q2.y, q2.z, j2.right >= 0 ? j2.right : -1, j2.center >= 0 ? j2.center : -1, j2.left >= 0 ? j2.left : -1, j2.vertical >= 0 ? j2.vertical : -1, O2, U3, N2, void 0 !== P3 ? P3 : t5.collisionBoxArray.length, void 0 !== P3 ? P3 + 1 : t5.collisionBoxArray.length, void 0 !== T4 ? T4 : t5.collisionBoxArray.length, void 0 !== T4 ? T4 + 1 : t5.collisionBoxArray.length, void 0 !== k3 ? k3 : t5.collisionBoxArray.length, void 0 !== k3 ? k3 + 1 : t5.collisionBoxArray.length, E4 || t5.collisionBoxArray.length, E4 ? E4 + 1 : t5.collisionBoxArray.length, c4, L3, F3, R4, D3, W2, 0, G2, X2, Y2, 0, $3 ? 1 : 0);
          }(t4, o4, y3, s4, r3, n3, i3, R3, t4.layers[0], t4.collisionBoxArray, e3.index, e3.sourceLayerIndex, t4.index, A3, z3, l3, 0, S2, P2, g4, e3, a4, u4, c3, h3, f3, d3);
        };
        if ("line" === k2) for (const i4 of Lf(e3.geometry, 0, 0, Wr, Wr)) {
          const e4 = Rf(i4, M2, I3, r3.vertical || x2, n3, b2, _2, t4.overscaling, Wr);
          for (const r4 of e4) x2 && md(t4, x2.text, T3, r4) || D2(i4, r4, h3);
        }
        else if ("line-center" === k2) {
          for (const t5 of e3.geometry) if (t5.length > 1) {
            const e4 = Cf(t5, I3, r3.vertical || x2, n3, b2, _2);
            e4 && D2(t5, e4, h3);
          }
        } else if ("Polygon" === e3.type) for (const t5 of Cc(e3.geometry, 0)) {
          const e4 = ed(t5, 16);
          D2(t5[0], new kf(e4.x, e4.y, 0, 0, void 0), h3);
        }
        else if ("LineString" === e3.type) for (const t5 of e3.geometry) D2(t5, new kf(t5[0].x, t5[0].y, 0, 0, void 0), h3);
        else if ("Point" === e3.type) for (const t5 of e3.geometry) for (const e4 of t5) D2([e4], new kf(e4.x, e4.y, 0, 0, void 0), h3);
      }
      const ud = 255, cd = ud * Xp;
      function hd(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3, d3, m2, y2, g4) {
        const x2 = function(t5, e4, r4, n4, i4, a5, s4, o4) {
          const l4 = [];
          if (0 === e4.positionedLines.length) return l4;
          const u5 = n4.layout.get("text-rotate").evaluate(a5, {}) * Math.PI / 180, c4 = function(t6) {
            const e5 = t6[0], r5 = t6[1], n5 = e5 * r5;
            return n5 > 0 ? [e5, -r5] : n5 < 0 ? [-e5, r5] : 0 === e5 ? [r5, e5] : [r5, -e5];
          }(r4);
          let h4 = Math.abs(e4.top - e4.bottom);
          for (const t6 of e4.positionedLines) h4 -= t6.lineOffset;
          const p4 = e4.positionedLines.length, f4 = h4 / p4;
          let d4 = e4.top - r4[1];
          for (let t6 = 0; t6 < p4; ++t6) {
            const n5 = e4.positionedLines[t6];
            d4 = td2(e4, f4, d4, t6);
            for (const t7 of n5.positionedGlyphs) {
              if (!t7.rect) continue;
              const n6 = t7.rect || {};
              let a6 = ff + 1, h5 = true, p5 = 1, f5 = 0;
              if (t7.imageName) {
                const e5 = s4[t7.imageName];
                if (!e5) continue;
                if (e5.sdf) {
                  ft("SDF images are not supported in formatted text and will be ignored.");
                  continue;
                }
                h5 = false, p5 = e5.pixelRatio, a6 = Of / p5;
              }
              const m3 = (i4 || o4) && t7.vertical, y3 = t7.metrics.advance * t7.scale / 2, g5 = t7.metrics, x3 = t7.rect;
              if (null === x3) continue;
              o4 && e4.verticalizable && (f5 = t7.imageName ? y3 - t7.metrics.width * t7.scale / 2 : 0);
              const v3 = i4 ? [t7.x + y3, t7.y] : [0, 0];
              let b3 = [0, 0], w2 = [0, 0], _2 = false;
              i4 || (m3 ? (w2 = [t7.x + y3 + c4[0], t7.y + c4[1] - f5], _2 = true) : b3 = [t7.x + y3 + r4[0], t7.y + r4[1] - f5]);
              const M2 = x3.w * t7.scale / (p5 * (t7.localGlyph ? Gf : 1)), A3 = x3.h * t7.scale / (p5 * (t7.localGlyph ? Gf : 1));
              let S2, I3, z3, P2;
              if (m3) {
                const e5 = t7.y - d4, r5 = new q(-y3, y3 - e5), n7 = -Math.PI / 2, i5 = new q(...w2);
                S2 = new q(-y3 + b3[0], b3[1]), S2._rotateAround(n7, r5)._add(i5), S2.x += -e5 + y3, S2.y -= (g5.left - a6) * t7.scale;
                const s5 = t7.imageName ? g5.advance * t7.scale : Gp * t7.scale, o5 = String.fromCodePoint(t7.glyph);
                Qp(o5) ? S2.x += (1 - a6) * t7.scale : tf(o5) ? S2.x += s5 - g5.height * t7.scale + (-a6 - 1) * t7.scale : S2.x += t7.imageName || g5.width + 2 * a6 === x3.w && g5.height + 2 * a6 === x3.h ? (s5 - A3) / 2 : (s5 - (g5.height + 2 * a6) * t7.scale) / 2, I3 = new q(S2.x, S2.y - M2), z3 = new q(S2.x + A3, S2.y), P2 = new q(S2.x + A3, S2.y - M2);
              } else {
                const e5 = (g5.left - a6) * t7.scale - y3 + b3[0], r5 = (-g5.top - a6) * t7.scale + b3[1], n7 = e5 + M2, i5 = r5 + A3;
                S2 = new q(e5, r5), I3 = new q(n7, r5), z3 = new q(e5, i5), P2 = new q(n7, i5);
              }
              if (u5) {
                let t8;
                t8 = i4 ? new q(0, 0) : _2 ? new q(c4[0], c4[1]) : new q(r4[0], r4[1]), S2._rotateAround(u5, t8), I3._rotateAround(u5, t8), z3._rotateAround(u5, t8), P2._rotateAround(u5, t8);
              }
              const k2 = new q(0, 0), T3 = new q(0, 0);
              l4.push({ tl: S2, tr: I3, bl: z3, br: P2, texPrimary: n6, texSecondary: void 0, writingMode: e4.writingMode, glyphOffset: v3, sectionIndex: t7.sectionIndex, isSDF: h5, pixelOffsetTL: k2, pixelOffsetBR: T3, minFontScaleX: 0, minFontScaleY: 0 });
            }
          }
          return l4;
        }(0, n3, l3, a4, s3, o3, i3, t4.allowVerticalPlacement), v2 = t4.textSizeData;
        let b2 = null;
        "source" === v2.kind ? (b2 = [Xp * a4.layout.get("text-size").evaluate(o3, {}, y2) * d3.textScaleFactor], b2[0] > cd && ft(`${t4.layerIds[0]}: Value for "text-size" is >= ${ud}. Reduce your "text-size".`)) : "composite" === v2.kind && (b2 = [Xp * d3.compositeTextSizes[0].evaluate(o3, {}, y2) * d3.textScaleFactor, Xp * d3.compositeTextSizes[1].evaluate(o3, {}, y2) * d3.textScaleFactor], (b2[0] > cd || b2[1] > cd) && ft(`${t4.layerIds[0]}: Value for "text-size" is >= ${ud}. Reduce your "text-size".`)), t4.addSymbols(t4.text, x2, b2, l3, s3, o3, c3, e3, r3, u4.lineStartIndex, u4.lineLength, f3, m2, y2, g4, false);
        for (const e4 of h3) p3[e4] = t4.text.placedSymbolArray.length - 1;
        return 4 * x2.length;
      }
      function pd(t4) {
        for (const e3 in t4) return t4[e3];
        return null;
      }
      function fd2(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4) {
        let c3 = s3.top, h3 = s3.bottom, p3 = s3.left, f3 = s3.right;
        const d3 = s3.collisionPadding;
        if (d3 && (p3 -= d3[0], c3 -= d3[1], f3 += d3[2], h3 += d3[3]), l3) {
          const t5 = new q(p3, c3), e4 = new q(f3, c3), r4 = new q(p3, h3), n4 = new q(f3, h3), i4 = Y(l3);
          let a5 = new q(0, 0);
          u4 && (a5 = new q(u4[0], u4[1])), t5._rotateAround(i4, a5), e4._rotateAround(i4, a5), r4._rotateAround(i4, a5), n4._rotateAround(i4, a5), p3 = Math.min(t5.x, e4.x, r4.x, n4.x), f3 = Math.max(t5.x, e4.x, r4.x, n4.x), c3 = Math.min(t5.y, e4.y, r4.y, n4.y), h3 = Math.max(t5.y, e4.y, r4.y, n4.y);
        }
        return t4.emplaceBack(e3.x, e3.y, e3.z, r3.x, r3.y, p3, c3, f3, h3, o3, n3, i3, a4), t4.length - 1;
      }
      function dd(t4) {
        t4.collisionPadding && (t4.top -= t4.collisionPadding[1], t4.bottom += t4.collisionPadding[3]);
        const e3 = t4.bottom - t4.top;
        return e3 > 0 ? Math.max(10, e3) : null;
      }
      function md(t4, e3, r3, n3) {
        const i3 = t4.compareText;
        if (e3 in i3) {
          const t5 = i3[e3];
          for (let e4 = t5.length - 1; e4 >= 0; e4--) if (n3.dist(t5[e4]) < r3) return true;
        } else i3[e3] = [];
        return i3[e3].push(n3), false;
      }
      function yd(t4, e3) {
        const r3 = t4.fovAboveCenter, n3 = t4.elevation ? t4.elevation.getMinElevationBelowMSL() * e3 : 0, i3 = (t4._camera.position[2] * t4.worldSize - n3) / Math.cos(t4._pitch), a4 = Math.sin(r3) * i3 / Math.sin(Math.max(Math.PI / 2 - t4._pitch - r3, 0.01));
        let s3 = Math.sin(t4._pitch) * a4 + i3;
        const o3 = i3 * (1 / t4._horizonShift);
        return t4.elevation && 0 !== t4.elevation.exaggeration() || (s3 *= 1 + Math.max(t4.zoom - 17, 0)), Math.min(1.01 * s3, o3);
      }
      function gd(t4, e3) {
        if (!e3.isReprojectedInTileSpace) return { scale: 1 << t4.z, x: t4.x, y: t4.y, x2: t4.x + 1, y2: t4.y + 1, projection: e3 };
        const r3 = Math.pow(2, -t4.z), n3 = t4.x * r3, i3 = (t4.x + 1) * r3, a4 = t4.y * r3, s3 = (t4.y + 1) * r3, o3 = cl(n3), l3 = cl(i3), u4 = hl(a4), c3 = hl(s3), h3 = e3.project(o3, u4), p3 = e3.project(l3, u4), f3 = e3.project(l3, c3), d3 = e3.project(o3, c3);
        let m2 = Math.min(h3.x, p3.x, f3.x, d3.x), y2 = Math.min(h3.y, p3.y, f3.y, d3.y), g4 = Math.max(h3.x, p3.x, f3.x, d3.x), x2 = Math.max(h3.y, p3.y, f3.y, d3.y);
        const v2 = r3 / 16;
        function b2(t5, r4, n4, i4, a5, s4) {
          const o4 = (n4 + a5) / 2, l4 = (i4 + s4) / 2, u5 = e3.project(cl(o4), hl(l4)), c4 = Math.max(0, m2 - u5.x, y2 - u5.y, u5.x - g4, u5.y - x2);
          m2 = Math.min(m2, u5.x), g4 = Math.max(g4, u5.x), y2 = Math.min(y2, u5.y), x2 = Math.max(x2, u5.y), c4 > v2 && (b2(t5, u5, n4, i4, o4, l4), b2(u5, r4, o4, l4, a5, s4));
        }
        b2(h3, p3, n3, a4, i3, a4), b2(p3, f3, i3, a4, i3, s3), b2(f3, d3, i3, s3, n3, s3), b2(d3, h3, n3, s3, n3, a4), m2 -= v2, y2 -= v2, g4 += v2, x2 += v2;
        const w2 = 1 / Math.max(g4 - m2, x2 - y2);
        return { scale: w2, x: m2 * w2, y: y2 * w2, x2: g4 * w2, y2: x2 * w2, projection: e3 };
      }
      function xd(t4, { x: e3, y: r3 }, n3 = 0) {
        return new q(((e3 - n3) * t4.scale - t4.x) * Wr, (r3 * t4.scale - t4.y) * Wr);
      }
      const vd = O.mat4.identity(new Float32Array(16));
      class bd {
        constructor(t4) {
          this.spec = t4, this.name = t4.name, this.wrap = false, this.requiresDraping = false, this.supportsWorldCopies = false, this.supportsTerrain = false, this.supportsFog = false, this.supportsFreeCamera = false, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = true, this.unsupportedLayers = ["custom"], this.center = [0, 0], this.range = [3.5, 7];
        }
        project(t4, e3) {
          return { x: 0, y: 0, z: 0 };
        }
        unproject(t4, e3) {
          return new rl(0, 0);
        }
        projectTilePoint(t4, e3, r3) {
          return { x: t4, y: e3, z: 0 };
        }
        locationPoint(t4, e3, r3 = true) {
          return t4._coordinatePoint(t4.locationCoordinate(e3), r3);
        }
        pixelsPerMeter(t4, e3) {
          return ul(1, t4) * e3;
        }
        pixelSpaceConversion(t4, e3, r3) {
          return 1;
        }
        farthestPixelDistance(t4) {
          return yd(t4, t4.pixelsPerMeter);
        }
        pointCoordinate(t4, e3, r3, n3) {
          const i3 = t4.horizonLineFromTop(false);
          let a4 = new q(e3, Math.max(i3, r3));
          return t4.isUnderground && (a4 = new q(e3, Math.min(i3, r3))), t4.rayIntersectionCoordinate(t4.pointRayIntersection(a4, n3));
        }
        pointCoordinate3D(t4, e3, r3) {
          const n3 = new q(e3, r3);
          if (t4.elevation) return t4.elevation.pointCoordinate(n3);
          {
            const e4 = this.pointCoordinate(t4, n3.x, n3.y, 0);
            return [e4.x, e4.y, e4.z];
          }
        }
        isPointAboveHorizon(t4, e3) {
          if (t4.elevation && t4.elevation.visibleDemTiles.length) return !this.pointCoordinate3D(t4, e3.x, e3.y);
          const r3 = t4.horizonLineFromTop();
          return e3.y < r3;
        }
        createInversionMatrix(t4, e3) {
          return vd;
        }
        createTileMatrix(t4, e3, r3) {
          let n3, i3, a4;
          const s3 = r3.canonical, o3 = O.mat4.identity(new Float64Array(16));
          if (this.isReprojectedInTileSpace) {
            const l3 = gd(s3, this);
            n3 = 1, i3 = l3.x + r3.wrap * l3.scale, a4 = l3.y, O.mat4.scale(o3, o3, [n3 / l3.scale, n3 / l3.scale, t4.pixelsPerMeter / e3]);
          } else n3 = e3 / t4.zoomScale(s3.z), i3 = (s3.x + Math.pow(2, s3.z) * r3.wrap) * n3, a4 = s3.y * n3;
          return O.mat4.translate(o3, o3, [i3, a4, 0]), O.mat4.scale(o3, o3, [n3 / Wr, n3 / Wr, 1]), o3;
        }
        upVector(t4, e3, r3) {
          return [0, 0, 1];
        }
        upVectorScale(t4, e3, r3) {
          return { metersToTile: 1 };
        }
      }
      class wd extends bd {
        constructor(t4) {
          super(t4), this.range = [4, 7], this.center = t4.center || [-96, 37.5];
          const [e3, r3] = this.parallels = t4.parallels || [29.5, 45.5], n3 = Math.sin(Y(e3));
          this.n = (n3 + Math.sin(Y(r3))) / 2, this.c = 1 + n3 * (2 * this.n - n3), this.r0 = Math.sqrt(this.c) / this.n;
        }
        project(t4, e3) {
          const { n: r3, c: n3, r0: i3 } = this, a4 = Y(t4 - this.center[0]), s3 = Y(e3), o3 = Math.sqrt(n3 - 2 * r3 * Math.sin(s3)) / r3;
          return { x: o3 * Math.sin(a4 * r3), y: o3 * Math.cos(a4 * r3) - i3, z: 0 };
        }
        unproject(t4, e3) {
          const { n: r3, c: n3, r0: i3 } = this, a4 = i3 + e3;
          let s3 = Math.atan2(t4, Math.abs(a4)) * Math.sign(a4);
          a4 * r3 < 0 && (s3 -= Math.PI * Math.sign(t4) * Math.sign(a4));
          const o3 = Y(this.center[0]) * r3;
          s3 = et2(s3, -Math.PI - o3, Math.PI - o3);
          const l3 = Q2(Z2(s3 / r3) + this.center[0], -180, 180), u4 = Math.asin(Q2((n3 - (t4 * t4 + a4 * a4) * r3 * r3) / (2 * r3), -1, 1)), c3 = Q2(Z2(u4), -fl2, fl2);
          return new rl(l3, c3);
        }
      }
      const _d = 1.340264, Md = -0.081106, Ad = 893e-6, Sd = 3796e-6, Id = Math.sqrt(3) / 2;
      class zd extends bd {
        project(t4, e3) {
          e3 = e3 / 180 * Math.PI, t4 = t4 / 180 * Math.PI;
          const r3 = Math.asin(Id * Math.sin(e3)), n3 = r3 * r3, i3 = n3 * n3 * n3;
          return { x: 0.5 * (t4 * Math.cos(r3) / (Id * (_d + 3 * Md * n3 + i3 * (7 * Ad + 9 * Sd * n3))) / Math.PI + 0.5), y: 1 - 0.5 * (r3 * (_d + Md * n3 + i3 * (Ad + Sd * n3)) / Math.PI + 1), z: 0 };
        }
        unproject(t4, e3) {
          t4 = (2 * t4 - 0.5) * Math.PI;
          let r3 = e3 = (2 * (1 - e3) - 1) * Math.PI, n3 = r3 * r3, i3 = n3 * n3 * n3;
          for (let t5, a5, s4, o4 = 0; o4 < 12 && (a5 = r3 * (_d + Md * n3 + i3 * (Ad + Sd * n3)) - e3, s4 = _d + 3 * Md * n3 + i3 * (7 * Ad + 9 * Sd * n3), t5 = a5 / s4, r3 = Q2(r3 - t5, -Math.PI / 3, Math.PI / 3), n3 = r3 * r3, i3 = n3 * n3 * n3, !(Math.abs(t5) < 1e-12)); ++o4) ;
          const a4 = Id * t4 * (_d + 3 * Md * n3 + i3 * (7 * Ad + 9 * Sd * n3)) / Math.cos(r3), s3 = Math.asin(Math.sin(r3) / Id), o3 = Q2(180 * a4 / Math.PI, -180, 180), l3 = Q2(180 * s3 / Math.PI, -fl2, fl2);
          return new rl(o3, l3);
        }
      }
      class Pd extends bd {
        constructor(t4) {
          super(t4), this.wrap = true, this.supportsWorldCopies = true;
        }
        project(t4, e3) {
          return { x: 0.5 + t4 / 360, y: 0.5 - e3 / 360, z: 0 };
        }
        unproject(t4, e3) {
          const r3 = 360 * (t4 - 0.5), n3 = Q2(360 * (0.5 - e3), -fl2, fl2);
          return new rl(r3, n3);
        }
      }
      const kd = Math.PI / 2;
      function Td(t4) {
        return Math.tan((kd + t4) / 2);
      }
      class Ed extends bd {
        constructor(t4) {
          super(t4), this.center = t4.center || [0, 30];
          const [e3, r3] = this.parallels = t4.parallels || [30, 30];
          let n3 = Y(e3), i3 = Y(r3);
          this.southernCenter = n3 + i3 < 0, this.southernCenter && (n3 = -n3, i3 = -i3);
          const a4 = Math.cos(n3), s3 = Td(n3);
          this.n = n3 === i3 ? Math.sin(n3) : Math.log(a4 / Math.cos(i3)) / Math.log(Td(i3) / s3), this.f = a4 * Math.pow(Td(n3), this.n) / this.n;
        }
        project(t4, e3) {
          e3 = Y(e3), this.southernCenter && (e3 = -e3), t4 = Y(t4 - this.center[0]);
          const r3 = 1e-6, { n: n3, f: i3 } = this;
          i3 > 0 ? e3 < -kd + r3 && (e3 = -kd + r3) : e3 > kd - r3 && (e3 = kd - r3);
          const a4 = i3 / Math.pow(Td(e3), n3);
          let s3 = a4 * Math.sin(n3 * t4), o3 = i3 - a4 * Math.cos(n3 * t4);
          return s3 = 0.5 * (s3 / Math.PI + 0.5), o3 = 0.5 * (o3 / Math.PI + 0.5), { x: s3, y: this.southernCenter ? o3 : 1 - o3, z: 0 };
        }
        unproject(t4, e3) {
          t4 = (2 * t4 - 0.5) * Math.PI, this.southernCenter && (e3 = 1 - e3), e3 = (2 * (1 - e3) - 0.5) * Math.PI;
          const { n: r3, f: n3 } = this, i3 = n3 - e3, a4 = Math.sign(i3), s3 = Math.sign(r3) * Math.sqrt(t4 * t4 + i3 * i3);
          let o3 = Math.atan2(t4, Math.abs(i3)) * a4;
          i3 * r3 < 0 && (o3 -= Math.PI * Math.sign(t4) * a4);
          const l3 = Q2(Z2(o3 / r3) + this.center[0], -180, 180), u4 = Q2(Z2(2 * Math.atan(Math.pow(n3 / s3, 1 / r3)) - kd), -fl2, fl2);
          return new rl(l3, this.southernCenter ? -u4 : u4);
        }
      }
      class Bd extends bd {
        constructor(t4) {
          super(t4), this.wrap = true, this.supportsWorldCopies = true, this.supportsTerrain = true, this.supportsFog = true, this.supportsFreeCamera = true, this.isReprojectedInTileSpace = false, this.unsupportedLayers = [], this.range = null;
        }
        project(t4, e3) {
          return { x: ol(t4), y: ll(e3), z: 0 };
        }
        unproject(t4, e3) {
          const r3 = cl(t4), n3 = hl(e3);
          return new rl(r3, n3);
        }
      }
      const Vd = Y(fl2);
      class Cd extends bd {
        project(t4, e3) {
          const r3 = (e3 = Y(e3)) * e3, n3 = r3 * r3;
          return { x: 0.5 * ((t4 = Y(t4)) * (0.8707 - 0.131979 * r3 + n3 * (n3 * (3971e-6 * r3 - 1529e-6 * n3) - 0.013791)) / Math.PI + 0.5), y: 1 - 0.5 * (e3 * (1.007226 + r3 * (0.015085 + n3 * (0.028874 * r3 - 0.044475 - 5916e-6 * n3))) / Math.PI + 1), z: 0 };
        }
        unproject(t4, e3) {
          t4 = (2 * t4 - 0.5) * Math.PI;
          let r3 = e3 = (2 * (1 - e3) - 1) * Math.PI, n3 = 25, i3 = 0, a4 = r3 * r3;
          do {
            a4 = r3 * r3;
            const t5 = a4 * a4;
            i3 = (r3 * (1.007226 + a4 * (0.015085 + t5 * (0.028874 * a4 - 0.044475 - 5916e-6 * t5))) - e3) / (1.007226 + a4 * (0.045255 + t5 * (0.259866 * a4 - 0.311325 - 5916e-6 * 11 * t5))), r3 = Q2(r3 - i3, -Vd, Vd);
          } while (Math.abs(i3) > 1e-6 && --n3 > 0);
          a4 = r3 * r3;
          const s3 = Q2(Z2(t4 / (0.8707 + a4 * (a4 * (a4 * a4 * a4 * (3971e-6 - 1529e-6 * a4) - 0.013791) - 0.131979))), -180, 180), o3 = Z2(r3);
          return new rl(s3, o3);
        }
      }
      const Rd = Y(fl2);
      class Dd extends bd {
        project(t4, e3) {
          e3 = Y(e3), t4 = Y(t4);
          const r3 = Math.cos(e3), n3 = 2 / Math.PI, i3 = Math.acos(r3 * Math.cos(t4 / 2)), a4 = Math.sin(i3) / i3, s3 = 0.5 * (t4 * n3 + 2 * r3 * Math.sin(t4 / 2) / a4) || 0, o3 = 0.5 * (e3 + Math.sin(e3) / a4) || 0;
          return { x: 0.5 * (s3 / Math.PI + 0.5), y: 1 - 0.5 * (o3 / Math.PI + 1), z: 0 };
        }
        unproject(t4, e3) {
          let r3 = t4 = (2 * t4 - 0.5) * Math.PI, n3 = e3 = (2 * (1 - e3) - 1) * Math.PI, i3 = 25;
          const a4 = 1e-6;
          let s3 = 0, o3 = 0;
          do {
            const i4 = Math.cos(n3), a5 = Math.sin(n3), l3 = 2 * a5 * i4, u4 = a5 * a5, c3 = i4 * i4, h3 = Math.cos(r3 / 2), p3 = Math.sin(r3 / 2), f3 = 2 * h3 * p3, d3 = p3 * p3, m2 = 1 - c3 * h3 * h3, y2 = m2 ? 1 / m2 : 0, g4 = m2 ? Math.acos(i4 * h3) * Math.sqrt(1 / m2) : 0, x2 = 0.5 * (2 * g4 * i4 * p3 + 2 * r3 / Math.PI) - t4, v2 = 0.5 * (g4 * a5 + n3) - e3, b2 = 0.5 * y2 * (c3 * d3 + g4 * i4 * h3 * u4) + 1 / Math.PI, w2 = y2 * (f3 * l3 / 4 - g4 * a5 * p3), _2 = 0.125 * y2 * (l3 * p3 - g4 * a5 * c3 * f3), M2 = 0.5 * y2 * (u4 * h3 + g4 * d3 * i4) + 0.5, A3 = w2 * _2 - M2 * b2;
            s3 = (v2 * w2 - x2 * M2) / A3, o3 = (x2 * _2 - v2 * b2) / A3, r3 = Q2(r3 - s3, -Math.PI, Math.PI), n3 = Q2(n3 - o3, -Rd, Rd);
          } while ((Math.abs(s3) > a4 || Math.abs(o3) > a4) && --i3 > 0);
          return new rl(Z2(r3), Z2(n3));
        }
      }
      class Ld extends bd {
        constructor(t4) {
          super(t4), this.center = t4.center || [0, 0], this.parallels = t4.parallels || [0, 0], this.cosPhi = Math.max(0.01, Math.cos(Y(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = true, this.supportsWorldCopies = true;
        }
        project(t4, e3) {
          const { scale: r3, cosPhi: n3 } = this;
          return { x: Y(t4) * n3 * r3 + 0.5, y: -Math.sin(Y(e3)) / n3 * r3 + 0.5, z: 0 };
        }
        unproject(t4, e3) {
          const { scale: r3, cosPhi: n3 } = this, i3 = -(e3 - 0.5) / r3, a4 = Q2(Z2((t4 - 0.5) / r3) / n3, -180, 180), s3 = Math.asin(Q2(i3 * n3, -1, 1)), o3 = Q2(Z2(s3), -fl2, fl2);
          return new rl(a4, o3);
        }
      }
      class Fd extends Bd {
        constructor(t4) {
          super(t4), this.requiresDraping = true, this.supportsWorldCopies = false, this.supportsFog = true, this.zAxisUnit = "pixels", this.unsupportedLayers = ["debug"], this.range = [3, 5];
        }
        projectTilePoint(t4, e3, r3) {
          const n3 = Pu(t4, e3, r3), i3 = Eu(_u(r3));
          return O.vec3.transformMat4(n3, n3, i3), { x: n3[0], y: n3[1], z: n3[2] };
        }
        locationPoint(t4, e3) {
          const r3 = Qo(e3.lat, e3.lng), n3 = O.vec3.normalize([], r3), i3 = t4.elevation ? t4.elevation.getAtPointOrZero(t4.locationCoordinate(e3), t4._centerAltitude) : t4._centerAltitude, a4 = ul(1, 0) * Wr * i3;
          O.vec3.scaleAndAdd(r3, r3, n3, a4);
          const s3 = O.mat4.identity(new Float64Array(16));
          return O.mat4.multiply(s3, t4.pixelMatrix, t4.globeMatrix), O.vec3.transformMat4(r3, r3, s3), new q(r3[0], r3[1]);
        }
        pixelsPerMeter(t4, e3) {
          return ul(1, 0) * e3;
        }
        pixelSpaceConversion(t4, e3, r3) {
          const n3 = ul(1, t4) * e3, i3 = Pe(ul(1, 45) * e3, n3, r3);
          return this.pixelsPerMeter(t4, e3) / i3;
        }
        createTileMatrix(t4, e3, r3) {
          const n3 = Bu(_u(r3.canonical));
          return O.mat4.multiply(new Float64Array(16), t4.globeMatrix, n3);
        }
        createInversionMatrix(t4, e3) {
          const { center: r3 } = t4, n3 = Eu(_u(e3));
          return O.mat4.rotateY(n3, n3, Y(r3.lng)), O.mat4.rotateX(n3, n3, Y(r3.lat)), O.mat4.scale(n3, n3, [t4._pixelsPerMercatorPixel, t4._pixelsPerMercatorPixel, 1]), Float32Array.from(n3);
        }
        pointCoordinate(t4, e3, r3, n3) {
          return vu(t4, e3, r3, true) || new xl(0, 0);
        }
        pointCoordinate3D(t4, e3, r3) {
          const n3 = this.pointCoordinate(t4, e3, r3, 0);
          return [n3.x, n3.y, n3.z];
        }
        isPointAboveHorizon(t4, e3) {
          return !vu(t4, e3.x, e3.y, false);
        }
        farthestPixelDistance(t4) {
          const e3 = function(t5, e4) {
            const r4 = t5.cameraToCenterDistance, n3 = t5._centerAltitude * e4, i3 = t5._camera, a4 = t5._camera.forward(), s3 = O.vec3.add([], O.vec3.scale([], a4, -r4), [0, 0, n3]), o3 = t5.worldSize / (2 * Math.PI), l3 = [0, 0, -o3], u4 = t5.width / t5.height, c3 = Math.tan(t5.fovAboveCenter), h3 = O.vec3.scale([], i3.up(), c3), p3 = O.vec3.scale([], i3.right(), c3 * u4), f3 = O.vec3.normalize([], O.vec3.add([], O.vec3.add([], a4, h3), p3)), d3 = [];
            let m2;
            if (new uu(s3, f3).closestPointOnSphere(l3, o3, d3)) {
              const e5 = O.vec3.add([], d3, l3), r5 = O.vec3.sub([], e5, s3);
              m2 = Math.cos(t5.fovAboveCenter) * O.vec3.length(r5);
            } else {
              const t6 = O.vec3.sub([], s3, l3), e5 = O.vec3.sub([], l3, s3);
              O.vec3.normalize(e5, e5);
              const r5 = O.vec3.length(t6) - o3;
              m2 = Math.sqrt(r5 * (r5 + 2 * o3));
              const n4 = Math.acos(m2 / (o3 + r5)) - Math.acos(O.vec3.dot(a4, e5));
              m2 *= Math.cos(n4);
            }
            return 1.01 * m2;
          }(t4, this.pixelsPerMeter(t4.center.lat, t4.worldSize)), r3 = Du(t4.zoom);
          if (r3 > 0) {
            const n3 = yd(t4, ul(1, t4.center.lat) * t4.worldSize), i3 = t4.worldSize / (2 * Math.PI), a4 = Math.max(t4.width, t4.height) / t4.worldSize * Math.PI;
            return Pe(e3, n3 + i3 * (1 - Math.cos(a4)), Math.pow(r3, 10));
          }
          return e3;
        }
        upVector(t4, e3, r3) {
          return Pu(e3, r3, t4, 1);
        }
        upVectorScale(t4) {
          return { metersToTile: gu(ku(_u(t4))) };
        }
      }
      function Od(t4) {
        const e3 = t4.parallels, r3 = !!e3 && Math.abs(e3[0] + e3[1]) < 0.01;
        switch (t4.name) {
          case "mercator":
            return new Bd(t4);
          case "equirectangular":
            return new Pd(t4);
          case "naturalEarth":
            return new Cd(t4);
          case "equalEarth":
            return new zd(t4);
          case "winkelTripel":
            return new Dd(t4);
          case "albers":
            return r3 ? new Ld(t4) : new wd(t4);
          case "lambertConformalConic":
            return r3 ? new Ld(t4) : new Ed(t4);
          case "globe":
            return new Fd(t4);
        }
        throw new Error(`Invalid projection name: ${t4.name}`);
      }
      const Ud = ch.VectorTileFeature.types, jd = [{ name: "a_fade_opacity", components: 1, type: "Uint8", offset: 0 }];
      function Nd(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3) {
        const f3 = o3 ? Math.min(cd, Math.round(o3[0])) : 0, d3 = o3 ? Math.min(cd, Math.round(o3[1])) : 0;
        t4.emplaceBack(e3, r3, Math.round(32 * n3), Math.round(32 * i3), a4, s3, (f3 << 1) + (l3 ? 1 : 0), d3, 16 * u4, 16 * c3, 256 * h3, 256 * p3);
      }
      function qd(t4, e3, r3) {
        t4.emplaceBack(e3, r3);
      }
      function $d(t4, e3, r3, n3, i3, a4, s3) {
        t4.emplaceBack(e3, r3, n3, i3, a4, s3);
      }
      function Gd(t4, e3, r3, n3, i3) {
        t4.emplaceBack(e3, r3, n3, i3), t4.emplaceBack(e3, r3, n3, i3), t4.emplaceBack(e3, r3, n3, i3), t4.emplaceBack(e3, r3, n3, i3);
      }
      function Xd(t4) {
        for (const e3 of t4.sections) if (xa(e3.text)) return true;
        return false;
      }
      class Yd {
        constructor(t4) {
          this.layoutVertexArray = new Is(), this.indexArray = new Cs(), this.programConfigurations = t4, this.segments = new co(), this.dynamicLayoutVertexArray = new ws(), this.opacityVertexArray = new Ps(), this.placedSymbolArray = new Js(), this.iconTransitioningVertexArray = new ks(), this.globeExtVertexArray = new zs(), this.zOffsetVertexArray = new Ls();
        }
        isEmpty() {
          return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length && 0 === this.iconTransitioningVertexArray.length;
        }
        upload(t4, e3, r3, n3, i3) {
          this.isEmpty() || (r3 && (this.layoutVertexBuffer = t4.createVertexBuffer(this.layoutVertexArray, Dp.members), this.indexBuffer = t4.createIndexBuffer(this.indexArray, e3), this.dynamicLayoutVertexBuffer = t4.createVertexBuffer(this.dynamicLayoutVertexArray, Fp.members, true), this.opacityVertexBuffer = t4.createVertexBuffer(this.opacityVertexArray, jd, true), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = t4.createVertexBuffer(this.iconTransitioningVertexArray, Up.members, true)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = t4.createVertexBuffer(this.globeExtVertexArray, Lp.members, true)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || i3) && (this.zOffsetVertexBuffer = t4.createVertexBuffer(this.zOffsetVertexArray, Op.members, true)), this.opacityVertexBuffer.itemSize = 1), (r3 || n3) && this.programConfigurations.upload(t4));
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy());
        }
      }
      aa(Yd, "SymbolBuffers");
      class Zd {
        constructor(t4, e3, r3) {
          this.layoutVertexArray = new t4(), this.layoutAttributes = e3, this.indexArray = new r3(), this.segments = new co(), this.collisionVertexArray = new Vs(), this.collisionVertexArrayExt = new ws();
        }
        upload(t4) {
          this.layoutVertexBuffer = t4.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t4.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t4.createVertexBuffer(this.collisionVertexArray, jp.members, true), this.collisionVertexBufferExt = t4.createVertexBuffer(this.collisionVertexArrayExt, Np.members, true);
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
        }
      }
      aa(Zd, "CollisionBuffers");
      class Wd {
        constructor(t4) {
          this.collisionBoxArray = t4.collisionBoxArray, this.zoom = t4.zoom, this.lut = t4.lut, this.overscaling = t4.overscaling, this.layers = t4.layers, this.layerIds = this.layers.map((t5) => t5.fqid), this.index = t4.index, this.pixelRatio = t4.pixelRatio, this.sourceLayerIndex = t4.sourceLayerIndex, this.hasPattern = false, this.hasRTLText = false, this.fullyClipped = false, this.hasAnyIconTextFit = false, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = O.mat4.identity([]), this.placementViewportMatrix = O.mat4.identity([]);
          const e3 = this.layers[0]._unevaluatedLayout._values;
          this.textSizeData = Yp(this.zoom, e3["text-size"]), this.iconSizeData = Yp(this.zoom, e3["icon-size"]);
          const r3 = this.layers[0].layout, n3 = r3.get("symbol-sort-key"), i3 = r3.get("symbol-z-order");
          this.canOverlap = r3.get("text-allow-overlap") || r3.get("icon-allow-overlap") || r3.get("text-ignore-placement") || r3.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== i3 && void 0 !== n3.constantOr(1), this.sortFeaturesByY = ("viewport-y" === i3 || "auto" === i3 && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = r3.get("text-writing-mode").map((t5) => df[t5]), this.stateDependentLayerIds = this.layers.filter((t5) => t5.isStateDependent()).map((t5) => t5.id), this.sourceID = t4.sourceID, this.projection = t4.projection, this.hasAnyZOffset = false, this.zOffsetSortDirty = false, this.zOffsetBuffersNeedUpload = r3.get("symbol-z-elevate"), this.activeReplacements = [], this.replacementUpdateTime = 0;
        }
        createArrays() {
          this.text = new Yd(new Fo(this.layers, { zoom: this.zoom, lut: this.lut }, (t4) => t4.startsWith("text") || t4.startsWith("symbol"))), this.icon = new Yd(new Fo(this.layers, { zoom: this.zoom, lut: this.lut }, (t4) => t4.startsWith("icon") || t4.startsWith("symbol"))), this.glyphOffsetArray = new eo(), this.lineVertexArray = new ro(), this.symbolInstances = new to();
        }
        calculateGlyphDependencies(t4, e3, r3, n3, i3) {
          for (const r4 of t4) {
            const t5 = r4.codePointAt(0);
            if (void 0 === t5) break;
            if (e3[t5] = true, n3 && i3 && t5 <= 65535) {
              const t6 = Jp[r4];
              t6 && (e3[t6.charCodeAt(0)] = true);
            }
          }
        }
        updateFootprints(t4, e3) {
        }
        updateReplacement(t4, e3) {
          if (e3.updateTime === this.replacementUpdateTime) return false;
          this.replacementUpdateTime = e3.updateTime;
          const r3 = e3.getReplacementRegionsForTile(t4.toUnwrapped(), true);
          return !wh(this.activeReplacements, r3) && (this.activeReplacements = r3, true);
        }
        populate(t4, e3, r3, n3) {
          const i3 = this.layers[0], a4 = i3.layout, s3 = "globe" === this.projection.name, o3 = a4.get("text-font"), l3 = a4.get("text-field"), u4 = a4.get("icon-image"), c3 = ("constant" !== l3.value.kind || l3.value.value instanceof Je && !l3.value.value.isEmpty() || l3.value.value.toString().length > 0) && ("constant" !== o3.value.kind || o3.value.value.length > 0), h3 = "constant" !== u4.value.kind || !!u4.value.value || Object.keys(u4.parameters).length > 0, p3 = a4.get("symbol-sort-key");
          if (this.features = [], !c3 && !h3) return;
          const f3 = e3.iconDependencies, d3 = e3.glyphDependencies, m2 = e3.availableImages, y2 = new Ea(this.zoom);
          for (const { feature: e4, id: l4, index: u5, sourceLayerIndex: g4 } of t4) {
            const t5 = i3._featureFilter.needGeometry, x2 = zl(e4, t5);
            if (!i3._featureFilter.filter(y2, x2, r3)) continue;
            if (t5 || (x2.geometry = Il(e4, r3, n3)), s3 && 1 !== e4.type && r3.z <= 5) {
              const t6 = x2.geometry, e5 = 0.98078528056, n4 = (t7, n5) => {
                const i4 = Pu(t7.x, t7.y, r3, 1), a5 = Pu(n5.x, n5.y, r3, 1);
                return O.vec3.dot(i4, a5) < e5;
              };
              for (let e6 = 0; e6 < t6.length; e6++) t6[e6] = _l(t6[e6], n4);
            }
            let v2, b2;
            if (c3) {
              const t6 = i3.getValueAndResolveTokens("text-field", x2, r3, m2), e5 = Je.factory(t6);
              Xd(e5) && (this.hasRTLText = true), (!this.hasRTLText || "unavailable" === Pa() || this.hasRTLText && Ta.isParsed()) && (v2 = Kp(e5, i3, x2));
            }
            if (h3) {
              const t6 = i3.getValueAndResolveTokens("icon-image", x2, r3, m2);
              b2 = t6 instanceof Qe ? t6 : Qe.fromString(t6);
            }
            if (!v2 && !b2) continue;
            const w2 = this.sortFeaturesByKey ? p3.evaluate(x2, {}, r3) : void 0;
            if (this.features.push({ id: l4, text: v2, icon: b2, index: u5, sourceLayerIndex: g4, geometry: x2.geometry, properties: e4.properties, type: Ud[e4.type], sortKey: w2 }), b2 && (f3[b2.namePrimary] = true, b2.nameSecondary && (f3[b2.nameSecondary] = true)), v2) {
              const t6 = o3.evaluate(x2, {}, r3).join(","), e5 = "map" === a4.get("text-rotation-alignment") && "point" !== a4.get("symbol-placement");
              this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(df.vertical) >= 0;
              for (const r4 of v2.sections) if (r4.image) f3[r4.image.namePrimary] = true;
              else {
                const n4 = ha(v2.toString()), i4 = r4.fontStack || t6, a5 = d3[i4] = d3[i4] || {};
                this.calculateGlyphDependencies(r4.text, a5, e5, this.allowVerticalPlacement, n4);
              }
            }
          }
          "line" === a4.get("symbol-placement") && (this.features = function(t5) {
            const e4 = {}, r4 = {}, n4 = [];
            let i4 = 0;
            function a5(e5) {
              n4.push(t5[e5]), i4++;
            }
            function s4(t6, e5, i5) {
              const a6 = r4[t6];
              return delete r4[t6], r4[e5] = a6, n4[a6].geometry[0].pop(), n4[a6].geometry[0] = n4[a6].geometry[0].concat(i5[0]), a6;
            }
            function o4(t6, r5, i5) {
              const a6 = e4[r5];
              return delete e4[r5], e4[t6] = a6, n4[a6].geometry[0].shift(), n4[a6].geometry[0] = i5[0].concat(n4[a6].geometry[0]), a6;
            }
            function l4(t6, e5, r5) {
              const n5 = r5 ? e5[0][e5[0].length - 1] : e5[0][0];
              return `${t6}:${n5.x}:${n5.y}`;
            }
            for (let u5 = 0; u5 < t5.length; u5++) {
              const c4 = t5[u5], h4 = c4.geometry, p4 = c4.text ? c4.text.toString() : null;
              if (!p4) {
                a5(u5);
                continue;
              }
              const f4 = l4(p4, h4), d4 = l4(p4, h4, true);
              if (f4 in r4 && d4 in e4 && r4[f4] !== e4[d4]) {
                const t6 = o4(f4, d4, h4), i5 = s4(f4, d4, n4[t6].geometry);
                delete e4[f4], delete r4[d4], r4[l4(p4, n4[i5].geometry, true)] = i5, n4[t6].geometry = null;
              } else f4 in r4 ? s4(f4, d4, h4) : d4 in e4 ? o4(f4, d4, h4) : (a5(u5), e4[f4] = i4 - 1, r4[d4] = i4 - 1);
            }
            return n4.filter((t6) => t6.geometry);
          }(this.features)), this.sortFeaturesByKey && this.features.sort((t5, e4) => t5.sortKey - e4.sortKey);
        }
        update(t4, e3, r3, n3, i3) {
          const a4 = 0 !== Object.keys(t4).length;
          if (a4 && !this.stateDependentLayers.length) return;
          const s3 = a4 ? this.stateDependentLayers : this.layers;
          this.text.programConfigurations.updatePaintArrays(t4, e3, s3, r3, n3, i3), this.icon.programConfigurations.updatePaintArrays(t4, e3, s3, r3, n3, i3);
        }
        updateZOffset() {
          const t4 = (t5, e4, n4) => {
            r3 += e4, r3 > t5.length && t5.resize(r3);
            for (let i3 = -e4; i3 < 0; i3++) t5.emplace(i3 + r3, n4);
          }, e3 = (t5, e4, r4) => {
            n3 += e4, n3 > t5.length && t5.resize(n3);
            for (let i3 = -e4; i3 < 0; i3++) t5.emplace(i3 + n3, r4);
          };
          if (!this.zOffsetBuffersNeedUpload) return;
          this.zOffsetBuffersNeedUpload = false;
          let r3 = 0, n3 = 0;
          for (let r4 = 0; r4 < this.symbolInstances.length; r4++) {
            const n4 = this.symbolInstances.get(r4), { numHorizontalGlyphVertices: i3, numVerticalGlyphVertices: a4, numIconVertices: s3 } = n4, o3 = n4.zOffset, l3 = s3 > 0;
            if ((i3 > 0 || a4 > 0) && (t4(this.text.zOffsetVertexArray, i3, o3), t4(this.text.zOffsetVertexArray, a4, o3)), l3) {
              const { placedIconSymbolIndex: t5, verticalPlacedIconSymbolIndex: r5 } = n4;
              t5 >= 0 && e3(this.icon.zOffsetVertexArray, s3, o3), r5 >= 0 && e3(this.icon.zOffsetVertexArray, n4.numVerticalIconVertices, o3);
            }
          }
          this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(this.text.zOffsetVertexArray), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(this.icon.zOffsetVertexArray);
        }
        isEmpty() {
          return 0 === this.symbolInstances.length && !this.hasRTLText;
        }
        uploadPending() {
          return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
        }
        upload(t4) {
          !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t4), this.iconCollisionBox.upload(t4)), this.text.upload(t4, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.icon.upload(t4, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.uploaded = true;
        }
        destroyDebugData() {
          this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
        }
        getProjection() {
          return this.projectionInstance || (this.projectionInstance = Od(this.projection)), this.projectionInstance;
        }
        destroy() {
          this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
        }
        addToLineVertexArray(t4, e3) {
          const r3 = this.lineVertexArray.length;
          if (void 0 !== t4.segment) for (const { x: t5, y: r4 } of e3) this.lineVertexArray.emplaceBack(t5, r4);
          return { lineStartIndex: r3, lineLength: this.lineVertexArray.length - r3 };
        }
        addSymbols(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3, h3, p3, f3, d3, m2) {
          const y2 = t4.indexArray, g4 = t4.layoutVertexArray, x2 = t4.globeExtVertexArray, v2 = t4.segments.prepareSegment(4 * e3.length, g4, y2, this.canOverlap ? a4.sortKey : void 0), b2 = this.glyphOffsetArray.length, w2 = v2.vertexLength, _2 = this.allowVerticalPlacement && s3 === df.vertical ? Math.PI / 2 : 0, M2 = a4.text && a4.text.sections;
          for (let n4 = 0; n4 < e3.length; n4++) {
            const { tl: i4, tr: s4, bl: u5, br: c4, texPrimary: h4, texSecondary: b3, pixelOffsetTL: w3, pixelOffsetBR: A4, minFontScaleX: S2, minFontScaleY: I3, glyphOffset: z3, isSDF: P2, sectionIndex: k2 } = e3[n4], T3 = v2.vertexLength, E3 = z3[1];
            if (Nd(g4, l3.x, l3.y, i4.x, E3 + i4.y, h4.x, h4.y, r3, P2, w3.x, w3.y, S2, I3), Nd(g4, l3.x, l3.y, s4.x, E3 + s4.y, h4.x + h4.w, h4.y, r3, P2, A4.x, w3.y, S2, I3), Nd(g4, l3.x, l3.y, u5.x, E3 + u5.y, h4.x, h4.y + h4.h, r3, P2, w3.x, A4.y, S2, I3), Nd(g4, l3.x, l3.y, c4.x, E3 + c4.y, h4.x + h4.w, h4.y + h4.h, r3, P2, A4.x, A4.y, S2, I3), o3) {
              const { x: e4, y: r4, z: n5 } = o3.anchor, [i5, a5, s5] = o3.up;
              $d(x2, e4, r4, n5, i5, a5, s5), $d(x2, e4, r4, n5, i5, a5, s5), $d(x2, e4, r4, n5, i5, a5, s5), $d(x2, e4, r4, n5, i5, a5, s5), Gd(t4.dynamicLayoutVertexArray, e4, r4, n5, _2);
            } else Gd(t4.dynamicLayoutVertexArray, l3.x, l3.y, l3.z, _2);
            if (m2) {
              const e4 = b3 || h4;
              qd(t4.iconTransitioningVertexArray, e4.x, e4.y), qd(t4.iconTransitioningVertexArray, e4.x + e4.w, e4.y), qd(t4.iconTransitioningVertexArray, e4.x, e4.y + e4.h), qd(t4.iconTransitioningVertexArray, e4.x + e4.w, e4.y + e4.h);
            }
            y2.emplaceBack(T3, T3 + 1, T3 + 2), y2.emplaceBack(T3 + 1, T3 + 2, T3 + 3), v2.vertexLength += 4, v2.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(z3[0]), n4 !== e3.length - 1 && k2 === e3[n4 + 1].sectionIndex || t4.programConfigurations.populatePaintArrays(g4.length, a4, a4.index, {}, p3, f3, d3, M2 && M2[k2]);
          }
          const A3 = o3 ? o3.anchor : l3;
          t4.placedSymbolArray.emplaceBack(A3.x, A3.y, A3.z, l3.x, l3.y, b2, this.glyphOffsetArray.length - b2, w2, u4, c3, l3.segment, r3 ? r3[0] : 0, r3 ? r3[1] : 0, n3[0], n3[1], s3, 0, false, 0, h3, 0);
        }
        _commitLayoutVertex(t4, e3, r3, n3, i3, a4, s3) {
          t4.emplaceBack(e3, r3, n3, i3, a4, Math.round(s3.x), Math.round(s3.y));
        }
        _addCollisionDebugVertices(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = r3.segments.prepareSegment(4, r3.layoutVertexArray, r3.indexArray), l3 = o3.vertexLength, u4 = s3.tileAnchorX, c3 = s3.tileAnchorY;
          for (let t5 = 0; t5 < 4; t5++) r3.collisionVertexArray.emplaceBack(0, 0, 0, 0, 0, 0);
          this._commitDebugCollisionVertexUpdate(r3.collisionVertexArrayExt, e3, t4.padding, s3.zOffset), this._commitLayoutVertex(r3.layoutVertexArray, n3, i3, a4, u4, c3, new q(t4.x1, t4.y1)), this._commitLayoutVertex(r3.layoutVertexArray, n3, i3, a4, u4, c3, new q(t4.x2, t4.y1)), this._commitLayoutVertex(r3.layoutVertexArray, n3, i3, a4, u4, c3, new q(t4.x2, t4.y2)), this._commitLayoutVertex(r3.layoutVertexArray, n3, i3, a4, u4, c3, new q(t4.x1, t4.y2)), o3.vertexLength += 4;
          const h3 = r3.indexArray;
          h3.emplaceBack(l3, l3 + 1), h3.emplaceBack(l3 + 1, l3 + 2), h3.emplaceBack(l3 + 2, l3 + 3), h3.emplaceBack(l3 + 3, l3), o3.primitiveLength += 4;
        }
        _addTextDebugCollisionBoxes(t4, e3, r3, n3, i3, a4) {
          for (let s3 = n3; s3 < i3; s3++) {
            const n4 = r3.get(s3), i4 = this.getSymbolInstanceTextSize(t4, a4, e3, s3);
            this._addCollisionDebugVertices(n4, i4, this.textCollisionBox, n4.projectedAnchorX, n4.projectedAnchorY, n4.projectedAnchorZ, a4);
          }
        }
        _addIconDebugCollisionBoxes(t4, e3, r3, n3, i3, a4) {
          for (let s3 = n3; s3 < i3; s3++) {
            const n4 = r3.get(s3), i4 = this.getSymbolInstanceIconSize(t4, e3, a4.placedIconSymbolIndex);
            this._addCollisionDebugVertices(n4, i4, this.iconCollisionBox, n4.projectedAnchorX, n4.projectedAnchorY, n4.projectedAnchorZ, a4);
          }
        }
        generateCollisionDebugBuffers(t4, e3, r3) {
          this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new Zd(Es, qp.members, ks), this.iconCollisionBox = new Zd(Es, qp.members, ks);
          const n3 = Wp(this.iconSizeData, t4), i3 = Wp(this.textSizeData, t4, r3);
          for (let r4 = 0; r4 < this.symbolInstances.length; r4++) {
            const a4 = this.symbolInstances.get(r4);
            this._addTextDebugCollisionBoxes(i3, t4, e3, a4.textBoxStartIndex, a4.textBoxEndIndex, a4), this._addTextDebugCollisionBoxes(i3, t4, e3, a4.verticalTextBoxStartIndex, a4.verticalTextBoxEndIndex, a4), this._addIconDebugCollisionBoxes(n3, t4, e3, a4.iconBoxStartIndex, a4.iconBoxEndIndex, a4), this._addIconDebugCollisionBoxes(n3, t4, e3, a4.verticalIconBoxStartIndex, a4.verticalIconBoxEndIndex, a4);
          }
        }
        getSymbolInstanceTextSize(t4, e3, r3, n3) {
          const i3 = this.text.placedSymbolArray.get(e3.rightJustifiedTextSymbolIndex >= 0 ? e3.rightJustifiedTextSymbolIndex : e3.centerJustifiedTextSymbolIndex >= 0 ? e3.centerJustifiedTextSymbolIndex : e3.leftJustifiedTextSymbolIndex >= 0 ? e3.leftJustifiedTextSymbolIndex : e3.verticalPlacedTextSymbolIndex >= 0 ? e3.verticalPlacedTextSymbolIndex : n3), a4 = Zp(this.textSizeData, t4, i3) / Gp;
          return this.tilePixelRatio * a4;
        }
        getSymbolInstanceIconSize(t4, e3, r3) {
          const n3 = this.icon.placedSymbolArray.get(r3), i3 = Zp(this.iconSizeData, t4, n3);
          return this.tilePixelRatio * i3;
        }
        _commitDebugCollisionVertexUpdate(t4, e3, r3, n3) {
          t4.emplaceBack(e3, -r3, -r3, n3), t4.emplaceBack(e3, r3, -r3, n3), t4.emplaceBack(e3, r3, r3, n3), t4.emplaceBack(e3, -r3, r3, n3);
        }
        _updateTextDebugCollisionBoxes(t4, e3, r3, n3, i3, a4, s3) {
          for (let s4 = n3; s4 < i3; s4++) {
            const n4 = r3.get(s4), i4 = this.getSymbolInstanceTextSize(t4, a4, e3, s4);
            this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, i4, n4.padding, a4.zOffset);
          }
        }
        _updateIconDebugCollisionBoxes(t4, e3, r3, n3, i3, a4, s3) {
          for (let s4 = n3; s4 < i3; s4++) {
            const n4 = r3.get(s4), i4 = this.getSymbolInstanceIconSize(t4, e3, a4.placedIconSymbolIndex);
            this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, i4, n4.padding, a4.zOffset);
          }
        }
        updateCollisionDebugBuffers(t4, e3, r3, n3) {
          if (!this.hasDebugData()) return;
          this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
          const i3 = Wp(this.iconSizeData, t4, n3), a4 = Wp(this.textSizeData, t4, r3);
          for (let s3 = 0; s3 < this.symbolInstances.length; s3++) {
            const o3 = this.symbolInstances.get(s3);
            this._updateTextDebugCollisionBoxes(a4, t4, e3, o3.textBoxStartIndex, o3.textBoxEndIndex, o3, r3), this._updateTextDebugCollisionBoxes(a4, t4, e3, o3.verticalTextBoxStartIndex, o3.verticalTextBoxEndIndex, o3, r3), this._updateIconDebugCollisionBoxes(i3, t4, e3, o3.iconBoxStartIndex, o3.iconBoxEndIndex, o3, n3), this._updateIconDebugCollisionBoxes(i3, t4, e3, o3.verticalIconBoxStartIndex, o3.verticalIconBoxEndIndex, o3, n3);
          }
          this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
        }
        _deserializeCollisionBoxesForSymbol(t4, e3, r3, n3, i3, a4, s3, o3, l3) {
          const u4 = {};
          if (e3 < r3) {
            const { x1: r4, y1: n4, x2: i4, y2: a5, padding: s4, projectedAnchorX: o4, projectedAnchorY: l4, projectedAnchorZ: c3, tileAnchorX: h3, tileAnchorY: p3, featureIndex: f3 } = t4.get(e3);
            u4.textBox = { x1: r4, y1: n4, x2: i4, y2: a5, padding: s4, projectedAnchorX: o4, projectedAnchorY: l4, projectedAnchorZ: c3, tileAnchorX: h3, tileAnchorY: p3 }, u4.textFeatureIndex = f3;
          }
          if (n3 < i3) {
            const { x1: e4, y1: r4, x2: i4, y2: a5, padding: s4, projectedAnchorX: o4, projectedAnchorY: l4, projectedAnchorZ: c3, tileAnchorX: h3, tileAnchorY: p3, featureIndex: f3 } = t4.get(n3);
            u4.verticalTextBox = { x1: e4, y1: r4, x2: i4, y2: a5, padding: s4, projectedAnchorX: o4, projectedAnchorY: l4, projectedAnchorZ: c3, tileAnchorX: h3, tileAnchorY: p3 }, u4.verticalTextFeatureIndex = f3;
          }
          if (a4 < s3) {
            const { x1: e4, y1: r4, x2: n4, y2: i4, padding: s4, projectedAnchorX: o4, projectedAnchorY: l4, projectedAnchorZ: c3, tileAnchorX: h3, tileAnchorY: p3, featureIndex: f3 } = t4.get(a4);
            u4.iconBox = { x1: e4, y1: r4, x2: n4, y2: i4, padding: s4, projectedAnchorX: o4, projectedAnchorY: l4, projectedAnchorZ: c3, tileAnchorX: h3, tileAnchorY: p3 }, u4.iconFeatureIndex = f3;
          }
          if (o3 < l3) {
            const { x1: e4, y1: r4, x2: n4, y2: i4, padding: a5, projectedAnchorX: s4, projectedAnchorY: l4, projectedAnchorZ: c3, tileAnchorX: h3, tileAnchorY: p3, featureIndex: f3 } = t4.get(o3);
            u4.verticalIconBox = { x1: e4, y1: r4, x2: n4, y2: i4, padding: a5, projectedAnchorX: s4, projectedAnchorY: l4, projectedAnchorZ: c3, tileAnchorX: h3, tileAnchorY: p3 }, u4.verticalIconFeatureIndex = f3;
          }
          return u4;
        }
        deserializeCollisionBoxes(t4) {
          this.collisionArrays = [];
          for (let e3 = 0; e3 < this.symbolInstances.length; e3++) {
            const r3 = this.symbolInstances.get(e3);
            this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t4, r3.textBoxStartIndex, r3.textBoxEndIndex, r3.verticalTextBoxStartIndex, r3.verticalTextBoxEndIndex, r3.iconBoxStartIndex, r3.iconBoxEndIndex, r3.verticalIconBoxStartIndex, r3.verticalIconBoxEndIndex));
          }
        }
        hasTextData() {
          return this.text.segments.get().length > 0;
        }
        hasIconData() {
          return this.icon.segments.get().length > 0;
        }
        hasDebugData() {
          return this.textCollisionBox && this.iconCollisionBox;
        }
        hasTextCollisionBoxData() {
          return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
        }
        hasIconCollisionBoxData() {
          return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
        }
        hasIconTextFit() {
          return this.hasAnyIconTextFit;
        }
        addIndicesForPlacedSymbol(t4, e3) {
          const r3 = t4.placedSymbolArray.get(e3), n3 = r3.vertexStartIndex + 4 * r3.numGlyphs;
          for (let e4 = r3.vertexStartIndex; e4 < n3; e4 += 4) t4.indexArray.emplaceBack(e4, e4 + 1, e4 + 2), t4.indexArray.emplaceBack(e4 + 1, e4 + 2, e4 + 3);
        }
        getSortedSymbolIndexes(t4) {
          if (this.sortedAngle === t4 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
          const e3 = Math.sin(t4), r3 = Math.cos(t4), n3 = [], i3 = [], a4 = [];
          for (let t5 = 0; t5 < this.symbolInstances.length; ++t5) {
            a4.push(t5);
            const s3 = this.symbolInstances.get(t5);
            n3.push(0 | Math.round(e3 * s3.tileAnchorX + r3 * s3.tileAnchorY)), i3.push(s3.featureIndex);
          }
          return a4.sort((t5, e4) => n3[t5] - n3[e4] || i3[e4] - i3[t5]), a4;
        }
        getSortedIndexesByZOffset() {
          if (!this.zOffsetSortDirty) return this.symbolInstanceIndexesSortedZOffset;
          if (!this.symbolInstanceIndexesSortedZOffset) {
            this.symbolInstanceIndexesSortedZOffset = [];
            for (let t4 = 0; t4 < this.symbolInstances.length; ++t4) this.symbolInstanceIndexesSortedZOffset.push(t4);
          }
          return this.zOffsetSortDirty = false, this.symbolInstanceIndexesSortedZOffset.sort((t4, e3) => this.symbolInstances.get(e3).zOffset - this.symbolInstances.get(t4).zOffset);
        }
        addToSortKeyRanges(t4, e3) {
          const r3 = this.sortKeyRanges[this.sortKeyRanges.length - 1];
          r3 && r3.sortKey === e3 ? r3.symbolInstanceEnd = t4 + 1 : this.sortKeyRanges.push({ sortKey: e3, symbolInstanceStart: t4, symbolInstanceEnd: t4 + 1 });
        }
        sortFeatures(t4) {
          if (this.sortFeaturesByY && this.sortedAngle !== t4 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
            this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t4), this.sortedAngle = t4, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
            for (const t5 of this.symbolInstanceIndexes) {
              const e3 = this.symbolInstances.get(t5);
              this.featureSortOrder.push(e3.featureIndex);
              const { rightJustifiedTextSymbolIndex: r3, centerJustifiedTextSymbolIndex: n3, leftJustifiedTextSymbolIndex: i3, verticalPlacedTextSymbolIndex: a4, placedIconSymbolIndex: s3, verticalPlacedIconSymbolIndex: o3 } = e3;
              r3 >= 0 && this.addIndicesForPlacedSymbol(this.text, r3), n3 >= 0 && n3 !== r3 && this.addIndicesForPlacedSymbol(this.text, n3), i3 >= 0 && i3 !== n3 && i3 !== r3 && this.addIndicesForPlacedSymbol(this.text, i3), a4 >= 0 && this.addIndicesForPlacedSymbol(this.text, a4), s3 >= 0 && this.addIndicesForPlacedSymbol(this.icon, s3), o3 >= 0 && this.addIndicesForPlacedSymbol(this.icon, o3);
            }
            this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
          }
        }
      }
      let Hd, Kd, Jd;
      aa(Wd, "SymbolBucket", { omit: ["layers", "collisionBoxArray", "features", "compareText"] }), Wd.addDynamicAttributes = Gd;
      class Qd {
        constructor(t4) {
          this.type = t4.property.overrides ? t4.property.overrides.runtimeType : Ce, this.defaultValue = t4;
        }
        evaluate(t4) {
          if (t4.formattedSection) {
            const e3 = this.defaultValue.property.overrides;
            if (e3 && e3.hasOverride(t4.formattedSection)) return e3.getOverride(t4.formattedSection);
          }
          return t4.feature && t4.featureState ? this.defaultValue.evaluate(t4.feature, t4.featureState) : this.defaultValue.property.specification.default;
        }
        eachChild(t4) {
          this.defaultValue.isConstant() || t4(this.defaultValue.value._styleExpression.expression);
        }
        outputDefined() {
          return false;
        }
        serialize() {
          return null;
        }
      }
      aa(Qd, "FormatSectionOverride", { omit: ["defaultValue"] });
      const tm = () => Jd || (Jd = { layout: Hd || (Hd = new qa({ "symbol-placement": new Ua($a.layout_symbol["symbol-placement"]), "symbol-spacing": new Ua($a.layout_symbol["symbol-spacing"]), "symbol-avoid-edges": new Ua($a.layout_symbol["symbol-avoid-edges"]), "symbol-sort-key": new ja($a.layout_symbol["symbol-sort-key"]), "symbol-z-order": new Ua($a.layout_symbol["symbol-z-order"]), "symbol-z-elevate": new Ua($a.layout_symbol["symbol-z-elevate"]), "symbol-elevation-reference": new Ua($a.layout_symbol["symbol-elevation-reference"]), "icon-allow-overlap": new Ua($a.layout_symbol["icon-allow-overlap"]), "icon-ignore-placement": new Ua($a.layout_symbol["icon-ignore-placement"]), "icon-optional": new Ua($a.layout_symbol["icon-optional"]), "icon-rotation-alignment": new Ua($a.layout_symbol["icon-rotation-alignment"]), "icon-size": new ja($a.layout_symbol["icon-size"]), "icon-size-scale-range": new Ua($a.layout_symbol["icon-size-scale-range"]), "icon-text-fit": new ja($a.layout_symbol["icon-text-fit"]), "icon-text-fit-padding": new ja($a.layout_symbol["icon-text-fit-padding"]), "icon-image": new ja($a.layout_symbol["icon-image"]), "icon-rotate": new ja($a.layout_symbol["icon-rotate"]), "icon-padding": new Ua($a.layout_symbol["icon-padding"]), "icon-keep-upright": new Ua($a.layout_symbol["icon-keep-upright"]), "icon-offset": new ja($a.layout_symbol["icon-offset"]), "icon-anchor": new ja($a.layout_symbol["icon-anchor"]), "icon-pitch-alignment": new Ua($a.layout_symbol["icon-pitch-alignment"]), "text-pitch-alignment": new Ua($a.layout_symbol["text-pitch-alignment"]), "text-rotation-alignment": new Ua($a.layout_symbol["text-rotation-alignment"]), "text-field": new ja($a.layout_symbol["text-field"]), "text-font": new ja($a.layout_symbol["text-font"]), "text-size": new ja($a.layout_symbol["text-size"]), "text-size-scale-range": new Ua($a.layout_symbol["text-size-scale-range"]), "text-max-width": new ja($a.layout_symbol["text-max-width"]), "text-line-height": new ja($a.layout_symbol["text-line-height"]), "text-letter-spacing": new ja($a.layout_symbol["text-letter-spacing"]), "text-justify": new ja($a.layout_symbol["text-justify"]), "text-radial-offset": new ja($a.layout_symbol["text-radial-offset"]), "text-variable-anchor": new Ua($a.layout_symbol["text-variable-anchor"]), "text-anchor": new ja($a.layout_symbol["text-anchor"]), "text-max-angle": new Ua($a.layout_symbol["text-max-angle"]), "text-writing-mode": new Ua($a.layout_symbol["text-writing-mode"]), "text-rotate": new ja($a.layout_symbol["text-rotate"]), "text-padding": new Ua($a.layout_symbol["text-padding"]), "text-keep-upright": new Ua($a.layout_symbol["text-keep-upright"]), "text-transform": new ja($a.layout_symbol["text-transform"]), "text-offset": new ja($a.layout_symbol["text-offset"]), "text-allow-overlap": new Ua($a.layout_symbol["text-allow-overlap"]), "text-ignore-placement": new Ua($a.layout_symbol["text-ignore-placement"]), "text-optional": new Ua($a.layout_symbol["text-optional"]), visibility: new Ua($a.layout_symbol.visibility) })), paint: Kd || (Kd = new qa({ "icon-opacity": new ja($a.paint_symbol["icon-opacity"]), "icon-occlusion-opacity": new ja($a.paint_symbol["icon-occlusion-opacity"]), "icon-emissive-strength": new ja($a.paint_symbol["icon-emissive-strength"]), "text-emissive-strength": new ja($a.paint_symbol["text-emissive-strength"]), "icon-color": new ja($a.paint_symbol["icon-color"]), "icon-halo-color": new ja($a.paint_symbol["icon-halo-color"]), "icon-halo-width": new ja($a.paint_symbol["icon-halo-width"]), "icon-halo-blur": new ja($a.paint_symbol["icon-halo-blur"]), "icon-translate": new Ua($a.paint_symbol["icon-translate"]), "icon-translate-anchor": new Ua($a.paint_symbol["icon-translate-anchor"]), "icon-image-cross-fade": new ja($a.paint_symbol["icon-image-cross-fade"]), "text-opacity": new ja($a.paint_symbol["text-opacity"]), "text-occlusion-opacity": new ja($a.paint_symbol["text-occlusion-opacity"]), "text-color": new ja($a.paint_symbol["text-color"], { runtimeType: Fe, getOverride: (t4) => t4.textColor, hasOverride: (t4) => !!t4.textColor }), "text-halo-color": new ja($a.paint_symbol["text-halo-color"]), "text-halo-width": new ja($a.paint_symbol["text-halo-width"]), "text-halo-blur": new ja($a.paint_symbol["text-halo-blur"]), "text-translate": new Ua($a.paint_symbol["text-translate"]), "text-translate-anchor": new Ua($a.paint_symbol["text-translate-anchor"]), "icon-color-saturation": new Ua($a.paint_symbol["icon-color-saturation"]), "icon-color-contrast": new Ua($a.paint_symbol["icon-color-contrast"]), "icon-color-brightness-min": new Ua($a.paint_symbol["icon-color-brightness-min"]), "icon-color-brightness-max": new Ua($a.paint_symbol["icon-color-brightness-max"]), "symbol-z-offset": new ja($a.paint_symbol["symbol-z-offset"]) })) }, Jd);
      class em extends cs {
        constructor(t4, e3, r3, n3) {
          super(t4, tm(), e3, r3, n3), this._colorAdjustmentMatrix = O.mat4.identity([]), this.hasInitialOcclusionOpacityProperties = void 0 !== t4.paint && ("icon-occlusion-opacity" in t4.paint || "text-occlusion-opacity" in t4.paint);
        }
        recalculate(t4, e3) {
          super.recalculate(t4, e3), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
          const r3 = this.layout.get("text-writing-mode");
          if (r3) {
            const t5 = [];
            for (const e4 of r3) t5.indexOf(e4) < 0 && t5.push(e4);
            this.layout._values["text-writing-mode"] = t5;
          } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? ["horizontal"] : ["horizontal", "vertical"];
          this._setPaintOverrides();
        }
        getColorAdjustmentMatrix(t4, e3, r3, n3) {
          return this._saturation === t4 && this._contrast === e3 && this._brightnessMin === r3 && this._brightnessMax === n3 || (this._colorAdjustmentMatrix = function(t5, e4, r4, n4) {
            t5 = At(t5), e4 = Mt(e4);
            const i3 = O.mat4.create(), a4 = t5 / 3, s3 = 1 - 2 * a4, o3 = [s3, a4, a4, 0, a4, s3, a4, 0, a4, a4, s3, 0, 0, 0, 0, 1], l3 = 0.5 - 0.5 * e4, u4 = n4 - r4;
            return O.mat4.multiply(i3, [u4, 0, 0, 0, 0, u4, 0, 0, 0, 0, u4, 0, r4, r4, r4, 1], [e4, 0, 0, 0, 0, e4, 0, 0, 0, 0, e4, 0, l3, l3, l3, 1]), O.mat4.multiply(i3, i3, o3), i3;
          }(t4, e3, r3, n3), this._saturation = t4, this._contrast = e3, this._brightnessMin = r3, this._brightnessMax = n3), this._colorAdjustmentMatrix;
        }
        getValueAndResolveTokens(t4, e3, r3, n3) {
          const i3 = this.layout.get(t4).evaluate(e3, {}, r3, n3), a4 = this._unevaluatedLayout._values[t4];
          return a4.isDataDriven() || Yi(a4.value) || !i3 ? i3 : function(t5, e4) {
            return e4.replace(/{([^{}]+)}/g, (e5, r4) => r4 in t5 ? String(t5[r4]) : "");
          }(e3.properties, i3);
        }
        createBucket(t4) {
          return new Wd(t4);
        }
        queryRadius() {
          return 0;
        }
        queryIntersectsFeature() {
          return false;
        }
        _setPaintOverrides() {
          for (const t4 of tm().paint.overridableProperties) {
            if (!em.hasPaintOverride(this.layout, t4)) continue;
            const e3 = this.paint.get(t4), r3 = new Qd(e3), n3 = new Xi(r3, e3.property.specification, this.scope, this.options);
            let i3 = null;
            i3 = "constant" === e3.value.kind || "source" === e3.value.kind ? new Wi("source", n3) : new Hi("composite", n3, e3.value.zoomStops, e3.value._interpolationType), this.paint._values[t4] = new Fa(e3.property, i3, e3.parameters);
          }
        }
        _handleOverridablePaintPropertyUpdate(t4, e3, r3) {
          return !(!this.layout || e3.isDataDriven() || r3.isDataDriven()) && em.hasPaintOverride(this.layout, t4);
        }
        static hasPaintOverride(t4, e3) {
          const r3 = t4.get("text-field"), n3 = tm().paint.properties[e3];
          let i3 = false;
          const a4 = (t5) => {
            for (const e4 of t5) if (n3.overrides && n3.overrides.hasOverride(e4)) return void (i3 = true);
          };
          if ("constant" === r3.value.kind && r3.value.value instanceof Je) a4(r3.value.value.sections);
          else if ("source" === r3.value.kind) {
            const t5 = (e5) => {
              i3 || (e5 instanceof ir && rr(e5.value) === Ne ? a4(e5.value.sections) : e5 instanceof lr ? a4(e5.sections) : e5.eachChild(t5));
            }, e4 = r3.value;
            e4._styleExpression && t5(e4._styleExpression.expression);
          }
          return i3;
        }
        getProgramIds() {
          return ["symbol"];
        }
        getDefaultProgramParams(t4, e3, r3) {
          return { config: new Lo(this, { zoom: e3, lut: r3 }), overrideFog: false };
        }
      }
      let rm, nm, im, am;
      var sm = ds([{ name: "a_pos", type: "Int16", components: 2 }, { name: "a_texture_pos", type: "Int16", components: 2 }]);
      function om(t4) {
        switch (t4) {
          case WebGL2RenderingContext.RGBA8:
            return WebGL2RenderingContext.RGBA;
          case WebGL2RenderingContext.DEPTH_COMPONENT16:
            return WebGL2RenderingContext.DEPTH_COMPONENT;
          case WebGL2RenderingContext.DEPTH24_STENCIL8:
            return WebGL2RenderingContext.DEPTH_STENCIL;
          case WebGL2RenderingContext.R8:
          case WebGL2RenderingContext.R32F:
            return WebGL2RenderingContext.RED;
        }
      }
      function lm(t4) {
        switch (t4) {
          case WebGL2RenderingContext.RGBA8:
            return WebGL2RenderingContext.UNSIGNED_BYTE;
          case WebGL2RenderingContext.DEPTH_COMPONENT16:
            return WebGL2RenderingContext.UNSIGNED_SHORT;
          case WebGL2RenderingContext.DEPTH24_STENCIL8:
            return WebGL2RenderingContext.UNSIGNED_INT_24_8;
          case WebGL2RenderingContext.R8:
            return WebGL2RenderingContext.UNSIGNED_BYTE;
          case WebGL2RenderingContext.R32F:
            return WebGL2RenderingContext.FLOAT;
        }
      }
      class um {
        constructor(t4, e3, r3, n3) {
          this.context = t4, this.format = r3, this.useMipmap = n3 && n3.useMipmap, this.texture = t4.gl.createTexture(), this.update(e3, { premultiply: n3 && n3.premultiply });
        }
        update(t4, e3) {
          const r3 = t4 && t4 instanceof HTMLVideoElement && 0 === t4.width ? t4.videoWidth : t4.width, n3 = t4 && t4 instanceof HTMLVideoElement && 0 === t4.height ? t4.videoHeight : t4.height, { context: i3 } = this, { gl: a4 } = i3, { x: s3, y: o3 } = e3 && e3.position ? e3.position : { x: 0, y: 0 }, l3 = Math.max(s3 + r3, this.size ? this.size[0] : 0), u4 = Math.max(o3 + n3, this.size ? this.size[1] : 0);
          !this.size || this.size[0] === l3 && this.size[1] === u4 || (a4.bindTexture(a4.TEXTURE_2D, null), a4.deleteTexture(this.texture), this.texture = a4.createTexture(), this.size = null), a4.bindTexture(a4.TEXTURE_2D, this.texture), i3.pixelStoreUnpackFlipY.set(false), i3.pixelStoreUnpack.set(1), i3.pixelStoreUnpackPremultiplyAlpha.set(this.format === a4.RGBA8 && (!e3 || false !== e3.premultiply));
          const c3 = t4 instanceof HTMLImageElement || t4 instanceof HTMLCanvasElement || t4 instanceof HTMLVideoElement || t4 instanceof ImageData || ImageBitmap && t4 instanceof ImageBitmap;
          if (!this.size && l3 > 0 && u4 > 0) {
            const t5 = this.useMipmap ? Math.floor(Math.log2(Math.max(l3, u4))) + 1 : 1;
            a4.texStorage2D(a4.TEXTURE_2D, t5, this.format, l3, u4), this.size = [l3, u4];
          }
          if (this.size) if (c3) a4.texSubImage2D(a4.TEXTURE_2D, 0, s3, o3, om(this.format), lm(this.format), t4);
          else {
            const e4 = t4.data;
            e4 && a4.texSubImage2D(a4.TEXTURE_2D, 0, s3, o3, r3, n3, om(this.format), lm(this.format), e4);
          }
          this.useMipmap && a4.generateMipmap(a4.TEXTURE_2D);
        }
        bind(t4, e3, r3 = false) {
          const { context: n3 } = this, { gl: i3 } = n3;
          i3.bindTexture(i3.TEXTURE_2D, this.texture), t4 !== this.minFilter && (i3.texParameteri(i3.TEXTURE_2D, i3.TEXTURE_MAG_FILTER, t4), i3.texParameteri(i3.TEXTURE_2D, i3.TEXTURE_MIN_FILTER, this.useMipmap && !r3 ? t4 === i3.NEAREST ? i3.NEAREST_MIPMAP_NEAREST : i3.LINEAR_MIPMAP_LINEAR : t4), this.minFilter = t4), e3 !== this.wrapS && (i3.texParameteri(i3.TEXTURE_2D, i3.TEXTURE_WRAP_S, e3), i3.texParameteri(i3.TEXTURE_2D, i3.TEXTURE_WRAP_T, e3), this.wrapS = e3);
        }
        bindExtraParam(t4, e3, r3, n3) {
          const { context: i3 } = this, { gl: a4 } = i3;
          a4.bindTexture(a4.TEXTURE_2D, this.texture), e3 !== this.magFilter && (a4.texParameteri(a4.TEXTURE_2D, a4.TEXTURE_MAG_FILTER, e3), this.magFilter = e3), t4 !== this.minFilter && (a4.texParameteri(a4.TEXTURE_2D, a4.TEXTURE_MIN_FILTER, this.useMipmap ? t4 === a4.NEAREST ? a4.NEAREST_MIPMAP_NEAREST : a4.LINEAR_MIPMAP_LINEAR : t4), this.minFilter = t4), r3 !== this.wrapS && (a4.texParameteri(a4.TEXTURE_2D, a4.TEXTURE_WRAP_S, r3), this.wrapS = r3), n3 !== this.wrapT && (a4.texParameteri(a4.TEXTURE_2D, a4.TEXTURE_WRAP_T, n3), this.wrapT = n3);
        }
        destroy() {
          const { gl: t4 } = this.context;
          t4.deleteTexture(this.texture), this.texture = null;
        }
      }
      class cm {
        constructor(t4, e3) {
          this.context = t4, this.texture = e3;
        }
        bind(t4, e3) {
          const { context: r3 } = this, { gl: n3 } = r3;
          n3.bindTexture(n3.TEXTURE_2D, this.texture), t4 !== this.minFilter && (n3.texParameteri(n3.TEXTURE_2D, n3.TEXTURE_MAG_FILTER, t4), n3.texParameteri(n3.TEXTURE_2D, n3.TEXTURE_MIN_FILTER, t4), this.minFilter = t4), e3 !== this.wrapS && (n3.texParameteri(n3.TEXTURE_2D, n3.TEXTURE_WRAP_S, e3), n3.texParameteri(n3.TEXTURE_2D, n3.TEXTURE_WRAP_T, e3), this.wrapS = e3);
        }
      }
      function hm(t4, e3, r3, n3, i3, a4, s3, o3) {
        const l3 = [t4, e3, 1, r3, n3, 1, i3, a4, 1], u4 = [s3, o3, 1], c3 = O.mat3.adjoint([], l3), [h3, p3, f3] = O.vec3.transformMat3(u4, u4, c3);
        return O.mat3.multiply(l3, l3, [h3, 0, 0, 0, p3, 0, 0, 0, f3]);
      }
      function pm(t4, e3, r3, n3, i3, a4, s3, o3) {
        const l3 = function(t5, e4, r4, n4, i4, a5, s4, o4) {
          const l4 = hm(0, 0, 1, 0, 1, 1, 0, 1), u4 = hm(t5, e4, r4, n4, i4, a5, s4, o4), c3 = O.mat3.adjoint([], l4);
          return O.mat3.multiply(u4, u4, c3);
        }(t4, e3, r3, n3, i3, a4, s3, o3);
        return [l3[2] / l3[8] / Wr, l3[5] / l3[8] / Wr];
      }
      function fm(t4) {
        return [t4[0], Math.min(Math.max(t4[1], -fl2), fl2)];
      }
      class dm extends _e {
        constructor(t4, e3, r3, n3) {
          super(), this.id = t4, this.dispatcher = r3, this.coordinates = e3.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = false, this.onNorthPole = false, this.onSouthPole = false, this.setEventedParent(n3), this.options = e3, this._dirty = false;
        }
        load(t4, e3) {
          if (this._loaded = e3 || false, this.fire(new xe("dataloading", { dataType: "source" })), this.url = this.options.url, !this.url) return t4 && (this.coordinates = t4), this._loaded = true, void this._finishLoading();
          this._imageRequest = ue2(this.map._requestManager.transformRequest(this.url, te2.Image), (e4, r3) => {
            this._imageRequest = null, this._loaded = true, e4 ? this.fire(new ve(e4)) : r3 && (this.image = r3 instanceof HTMLImageElement ? Rt.getImageData(r3) : r3, this._dirty = true, this.width = this.image.width, this.height = this.image.height, t4 && (this.coordinates = t4), this._finishLoading());
          });
        }
        loaded() {
          return this._loaded;
        }
        updateImage(t4) {
          return t4.url ? (this._imageRequest && t4.url !== this.options.url && (this._imageRequest.cancel(), this._imageRequest = null), this.options.url = t4.url, this.load(t4.coordinates, this._loaded), this) : this;
        }
        setTexture(t4) {
          if (!(t4.handle instanceof WebGLTexture)) throw new Error("The provided handle is not a WebGLTexture instance");
          return this.texture = new cm(this.map.painter.context, t4.handle), this.width = t4.dimensions[0], this.height = t4.dimensions[1], this._dirty = false, this._loaded = true, this._finishLoading(), this;
        }
        _finishLoading() {
          this.map && (this.setCoordinates(this.coordinates), this.fire(new xe("data", { dataType: "source", sourceDataType: "metadata" })));
        }
        onAdd(t4) {
          this.map = t4, this.load();
        }
        onRemove(t4) {
          this._imageRequest && (this._imageRequest.cancel(), this._imageRequest = null), !this.texture || this.texture instanceof cm || this.texture.destroy(), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy());
        }
        setCoordinates(t4) {
          if (this.coordinates = t4, this._boundsArray = void 0, this._unsupportedCoords = false, !t4.length) return this;
          this.onNorthPole = false, this.onSouthPole = false;
          let e3 = t4[0][1], r3 = t4[0][1];
          for (const n4 of t4) n4[1] > r3 && (r3 = n4[1]), n4[1] < e3 && (e3 = n4[1]);
          const n3 = (r3 + e3) / 2;
          if (n3 > fl2 ? this.onNorthPole = true : n3 < -fl2 && (this.onSouthPole = true), !this.onNorthPole && !this.onSouthPole) {
            const e4 = t4.map(xl.fromLngLat);
            this.tileID = function(t5) {
              let e5 = 1 / 0, r4 = 1 / 0, n4 = -1 / 0, i3 = -1 / 0;
              for (const a5 of t5) e5 = Math.min(e5, a5.x), r4 = Math.min(r4, a5.y), n4 = Math.max(n4, a5.x), i3 = Math.max(i3, a5.y);
              const a4 = Math.max(n4 - e5, i3 - r4), s3 = Math.max(0, Math.floor(-Math.log(a4) / Math.LN2)), o3 = Math.pow(2, s3);
              let l3 = Math.floor((e5 + n4) / 2 * o3);
              return l3 > 1 && (l3 -= 1), new tu(s3, l3, Math.floor((r4 + i3) / 2 * o3));
            }(e4), this.minzoom = this.maxzoom = this.tileID.z;
          }
          return this.fire(new xe("data", { dataType: "source", sourceDataType: "content" })), this;
        }
        _clear() {
          this._boundsArray = void 0, this._unsupportedCoords = false;
        }
        _prepareData(t4) {
          for (const t5 in this.tiles) {
            const e4 = this.tiles[t5];
            "loaded" !== e4.state && (e4.state = "loaded", e4.texture = this.texture);
          }
          if (this._boundsArray || this.onNorthPole || this.onSouthPole || this._unsupportedCoords) return;
          const e3 = gd(new tu(0, 0, 0), this.map.transform.projection), r3 = [e3.projection.project(this.coordinates[0][0], this.coordinates[0][1]), e3.projection.project(this.coordinates[1][0], this.coordinates[1][1]), e3.projection.project(this.coordinates[2][0], this.coordinates[2][1]), e3.projection.project(this.coordinates[3][0], this.coordinates[3][1])];
          if (!function(t5) {
            const e4 = t5[1].x - t5[0].x, r4 = t5[1].y - t5[0].y, n4 = t5[2].x - t5[1].x, i4 = t5[2].y - t5[1].y, a5 = t5[3].x - t5[2].x, s4 = t5[3].y - t5[2].y, o4 = t5[0].x - t5[3].x, l4 = t5[0].y - t5[3].y, u5 = e4 * i4 - n4 * r4, c4 = n4 * s4 - a5 * i4, h4 = a5 * l4 - o4 * s4, p4 = o4 * r4 - e4 * l4;
            return u5 > 0 && c4 > 0 && h4 > 0 && p4 > 0 || u5 < 0 && c4 < 0 && h4 < 0 && p4 < 0;
          }(r3)) return console.warn("Image source coordinates are defining non-convex area in the Mercator projection"), void (this._unsupportedCoords = true);
          const n3 = gd(this.tileID, this.map.transform.projection), [i3, a4, s3, o3] = this.coordinates.map((t5) => {
            const e4 = n3.projection.project(t5[0], t5[1]);
            return xd(n3, e4)._round();
          });
          this.perspectiveTransform = pm(i3.x, i3.y, a4.x, a4.y, s3.x, s3.y, o3.x, o3.y);
          const l3 = this._boundsArray = new xs();
          l3.emplaceBack(i3.x, i3.y, 0, 0), l3.emplaceBack(a4.x, a4.y, Wr, 0), l3.emplaceBack(o3.x, o3.y, 0, Wr), l3.emplaceBack(s3.x, s3.y, Wr, Wr), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy()), this.boundsBuffer = t4.createVertexBuffer(l3, sm.members), this.boundsSegments = co.simpleSegment(0, 0, 4, 2);
          const u4 = [], c3 = [fm((h3 = this.coordinates)[0]), fm(h3[1]), fm(h3[2]), fm(h3[3])];
          var h3;
          const [p3, f3, d3, m2] = function(t5) {
            let e4 = t5[0][0], r4 = e4, n4 = t5[0][1], i4 = n4;
            for (let a5 = 1; a5 < t5.length; a5++) t5[a5][0] < e4 ? e4 = t5[a5][0] : t5[a5][0] > r4 && (r4 = t5[a5][0]), t5[a5][1] < n4 ? n4 = t5[a5][1] : t5[a5][1] > i4 && (i4 = t5[a5][1]);
            return [e4, n4, r4 - e4, i4 - n4];
          }(c3);
          {
            const n4 = new xs(), [i4, a5, s4, o4] = function(t5) {
              let e4 = t5[0].x, r4 = e4, n5 = t5[0].y, i5 = n5;
              for (let a6 = 1; a6 < t5.length; a6++) t5[a6].x < e4 ? e4 = t5[a6].x : t5[a6].x > r4 && (r4 = t5[a6].x), t5[a6].y < n5 ? n5 = t5[a6].y : t5[a6].y > i5 && (i5 = t5[a6].y);
              return [e4, n5, r4 - e4, i5 - n5];
            }(r3), l4 = (t5) => [(t5.x - i4) / s4, (t5.y - a5) / o4], [c4, h4, y2, g4] = r3.map(l4), x2 = function(t5, e4, r4, n5, i5, a6, s5, o5) {
              const l5 = hm(0, 0, 1, 0, 1, 1, 0, 1), u5 = hm(t5, e4, r4, n5, i5, a6, s5, o5), c5 = O.mat3.adjoint([], u5);
              return O.mat3.multiply(l5, l5, c5);
            }(c4[0], c4[1], h4[0], h4[1], y2[0], y2[1], g4[0], g4[1]);
            this.elevatedGlobePerspectiveTransform = pm(c4[0], c4[1], h4[0], h4[1], y2[0], y2[1], g4[0], g4[1]);
            const v2 = (t5, e4) => {
              u4.push(t5.lng);
              const r4 = Math.round((t5.lng - p3) / d3 * Wr), i5 = Math.round((t5.lat - f3) / m2 * Wr), a6 = l4(e4), s5 = O.vec3.transformMat3([], [a6[0], a6[1], 1], x2), o5 = Math.round(s5[0] / s5[2] * Wr), c5 = Math.round(s5[1] / s5[2] * Wr);
              n4.emplaceBack(r4, i5, o5, c5);
            }, b2 = r3[3].x - r3[0].x, w2 = r3[3].y - r3[0].y, _2 = r3[2].x - r3[1].x, M2 = r3[2].y - r3[1].y;
            for (let t5 = 0; t5 < 65; t5++) {
              const n5 = t5 / 64, i5 = [r3[0].x + n5 * b2, r3[0].y + n5 * w2], a6 = [r3[1].x + n5 * _2, r3[1].y + n5 * M2], s5 = a6[0] - i5[0], o5 = a6[1] - i5[1];
              for (let t6 = 0; t6 < 65; t6++) {
                const r4 = t6 / 64, n6 = { x: i5[0] + s5 * r4, y: i5[1] + o5 * r4 };
                v2(e3.projection.unproject(n6.x, n6.y), n6);
              }
            }
            this.elevatedGlobeVertexBuffer = t4.createVertexBuffer(n4, sm.members);
          }
          {
            this.maxLongitudeTriangleSize = 0;
            let e4 = [], r4 = new Cs();
            const n4 = (t5, n5, i4) => {
              r4.emplaceBack(t5, n5, i4);
              const a5 = u4[t5], s4 = u4[n5], o4 = u4[i4], l4 = Math.min(Math.min(a5, s4), o4), c4 = Math.max(Math.max(a5, s4), o4) - l4;
              c4 > this.maxLongitudeTriangleSize && (this.maxLongitudeTriangleSize = c4), e4.push(l4 + c4 / 2);
            };
            for (let t5 = 0; t5 < 64; t5++) for (let e5 = 0; e5 < 64; e5++) {
              const r5 = 65 * t5 + e5, i4 = r5 + 1, a5 = r5 + 65, s4 = a5 + 1;
              n4(r5, a5, i4), n4(i4, a5, s4);
            }
            [e4, r4] = function(t5, e5) {
              const r5 = Array.from({ length: t5.length }, (t6, e6) => e6);
              r5.sort((e6, r6) => t5[e6] - t5[r6]);
              const n5 = [], i4 = new Cs();
              for (let a5 = 0; a5 < r5.length; a5++) {
                const s4 = r5[a5];
                n5.push(t5[s4]);
                const o4 = 3 * s4, l4 = o4 + 1;
                i4.emplaceBack(e5.uint16[o4], e5.uint16[l4], e5.uint16[l4 + 1]);
              }
              return [n5, i4];
            }(e4, r4), this.elevatedGlobeTrianglesCenterLongitudes = e4, this.elevatedGlobeIndexBuffer = t4.createIndexBuffer(r4);
          }
          this.elevatedGlobeSegments = co.simpleSegment(0, 0, 4225, 8192), this.elevatedGlobeGridMatrix = new Float32Array([0, d3 / Wr, 0, m2 / Wr, 0, 0, f3, p3, 0]);
        }
        prepare() {
          const t4 = 0 !== Object.keys(this.tiles).length;
          if (this.tileID && !t4) return;
          const e3 = this.map.painter.context, r3 = e3.gl;
          !this._dirty || this.texture instanceof cm || (this.texture ? this.texture.update(this.image) : (this.texture = new um(e3, this.image, r3.RGBA8), this.texture.bind(r3.LINEAR, r3.CLAMP_TO_EDGE)), this._dirty = false), t4 && this._prepareData(e3);
        }
        loadTile(t4, e3) {
          this.tileID && this.tileID.equals(t4.tileID.canonical) ? (this.tiles[String(t4.tileID.wrap)] = t4, t4.buckets = {}, e3(null)) : (t4.state = "errored", e3(null));
        }
        serialize() {
          return { type: "image", url: this.options.url, coordinates: this.coordinates };
        }
        hasTransition() {
          return false;
        }
        getSegmentsForLongitude(t4) {
          const e3 = this.elevatedGlobeSegments;
          if (!this.elevatedGlobeTrianglesCenterLongitudes || !e3) return null;
          const r3 = this.elevatedGlobeTrianglesCenterLongitudes;
          let n3 = (i3 = t4 + 180) + 360 * Math.round((r3[0] - i3) / 360);
          var i3;
          const a4 = new co(), s3 = (t5, r4) => {
            a4.segments.push({ vertexOffset: 0, primitiveOffset: t5, vertexLength: e3.segments[0].vertexLength, primitiveLength: r4, sortKey: void 0, vaos: {} });
          }, o3 = 0.51 * this.maxLongitudeTriangleSize;
          if (Math.abs(r3[0] - n3) <= o3) {
            const t5 = _t(r3, 0, r3.length, n3 + o3);
            return t5 === r3.length || s3(t5, wt2(r3, t5 + 1, r3.length, n3 + 360 - o3) - t5), a4;
          }
          n3 < r3[0] && (n3 += 360);
          const l3 = wt2(r3, 0, r3.length, n3 - o3);
          if (l3 === r3.length) return s3(0, r3.length), a4;
          s3(0, l3 - 0);
          const u4 = _t(r3, l3 + 1, r3.length, n3 + o3);
          return u4 !== r3.length && s3(u4, r3.length - u4), a4;
        }
      }
      const mm = (Math.pow(256, 2) - 1) / 16907520;
      class ym extends cs {
        constructor(t4, e3, r3, n3) {
          super(t4, { layout: im || (im = new qa({ visibility: new Ua($a.layout_raster.visibility) })), paint: am || (am = new qa({ "raster-opacity": new Ua($a.paint_raster["raster-opacity"]), "raster-color": new Na($a.paint_raster["raster-color"]), "raster-color-mix": new Ua($a.paint_raster["raster-color-mix"]), "raster-color-range": new Ua($a.paint_raster["raster-color-range"]), "raster-hue-rotate": new Ua($a.paint_raster["raster-hue-rotate"]), "raster-brightness-min": new Ua($a.paint_raster["raster-brightness-min"]), "raster-brightness-max": new Ua($a.paint_raster["raster-brightness-max"]), "raster-saturation": new Ua($a.paint_raster["raster-saturation"]), "raster-contrast": new Ua($a.paint_raster["raster-contrast"]), "raster-resampling": new Ua($a.paint_raster["raster-resampling"]), "raster-fade-duration": new Ua($a.paint_raster["raster-fade-duration"]), "raster-emissive-strength": new Ua($a.paint_raster["raster-emissive-strength"]), "raster-array-band": new Ua($a.paint_raster["raster-array-band"]), "raster-elevation": new Ua($a.paint_raster["raster-elevation"]) })) }, e3, r3, n3), this.updateColorRamp(), this._curRampRange = [NaN, NaN];
        }
        getProgramIds() {
          return ["raster"];
        }
        hasColorMap() {
          return !!this._transitionablePaint._values["raster-color"].value.value;
        }
        tileCoverLift() {
          return this.paint.get("raster-elevation");
        }
        isDraped(t4) {
          return !(t4 && t4._source instanceof dm && (t4._source.onNorthPole || t4._source.onSouthPole)) && 0 === this.paint.get("raster-elevation");
        }
        _handleSpecialPaintPropertyUpdate(t4) {
          "raster-color" !== t4 && "raster-color-range" !== t4 || (this._curRampRange = [NaN, NaN], this.updateColorRamp());
        }
        updateColorRamp(t4) {
          if (!this.hasColorMap()) return;
          if (!this._curRampRange) return;
          const e3 = this._transitionablePaint._values["raster-color"].value.expression, [r3, n3] = t4 || this._transitionablePaint._values["raster-color-range"].value.expression.evaluate({ zoom: 0 }) || [NaN, NaN];
          isNaN(r3) && isNaN(n3) || r3 === this._curRampRange[0] && n3 === this._curRampRange[1] || (this.colorRamp = sc({ expression: e3, evaluationKey: "rasterValue", image: this.colorRamp, clips: [{ start: r3, end: n3 }], resolution: 256 }), this.colorRampTexture = null, this._curRampRange = [r3, n3]);
        }
      }
      let gm, xm, vm, bm, wm;
      class _m extends cs {
        constructor(t4, e3, r3, n3) {
          super(t4, { layout: gm || (gm = new qa({ visibility: new Ua($a["layout_raster-particle"].visibility) })), paint: xm || (xm = new qa({ "raster-particle-array-band": new Ua($a["paint_raster-particle"]["raster-particle-array-band"]), "raster-particle-count": new Ua($a["paint_raster-particle"]["raster-particle-count"]), "raster-particle-color": new Na($a["paint_raster-particle"]["raster-particle-color"]), "raster-particle-max-speed": new Ua($a["paint_raster-particle"]["raster-particle-max-speed"]), "raster-particle-speed-factor": new Ua($a["paint_raster-particle"]["raster-particle-speed-factor"]), "raster-particle-fade-opacity-factor": new Ua($a["paint_raster-particle"]["raster-particle-fade-opacity-factor"]), "raster-particle-reset-rate-factor": new Ua($a["paint_raster-particle"]["raster-particle-reset-rate-factor"]), "raster-particle-elevation": new Ua($a["paint_raster-particle"]["raster-particle-elevation"]) })) }, e3, r3, n3), this._updateColorRamp(), this.lastInvalidatedAt = Rt.now();
        }
        onRemove(t4) {
          this.colorRampTexture && this.colorRampTexture.destroy(), this.tileFramebuffer && this.tileFramebuffer.destroy(), this.particleFramebuffer && this.particleFramebuffer.destroy();
        }
        hasColorMap() {
          return !!this._transitionablePaint._values["raster-particle-color"].value.value;
        }
        getProgramIds() {
          return ["rasterParticle"];
        }
        hasOffscreenPass() {
          return "none" !== this.visibility;
        }
        isDraped(t4) {
          return false;
        }
        _handleSpecialPaintPropertyUpdate(t4) {
          "raster-particle-color" !== t4 && "raster-particle-max-speed" !== t4 || (this._updateColorRamp(), this._invalidateAnimationState()), "raster-particle-count" === t4 && this._invalidateAnimationState();
        }
        _updateColorRamp() {
          if (!this.hasColorMap()) return;
          const t4 = this._transitionablePaint._values["raster-particle-color"].value.expression, e3 = this._transitionablePaint._values["raster-particle-max-speed"].value.expression.evaluate({ zoom: 0 });
          this.colorRamp = sc({ expression: t4, evaluationKey: "rasterParticleSpeed", image: this.colorRamp, clips: [{ start: 0, end: e3 }], resolution: 256 }), this.colorRampTexture = null;
        }
        _invalidateAnimationState() {
          this.lastInvalidatedAt = Rt.now();
        }
        tileCoverLift() {
          return this.paint.get("raster-particle-elevation");
        }
      }
      class Mm extends cs {
        constructor(t4, e3) {
          super(t4, {}, e3, null), this.implementation = t4, t4.slot && (this.slot = t4.slot);
        }
        is3D() {
          return "3d" === this.implementation.renderingMode;
        }
        hasOffscreenPass() {
          return void 0 !== this.implementation.prerender;
        }
        isDraped(t4) {
          return void 0 !== this.implementation.renderToTile;
        }
        shouldRedrape() {
          return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
        }
        recalculate() {
        }
        updateTransitions() {
        }
        hasTransition() {
          return false;
        }
        serialize() {
        }
        onAdd(t4) {
          this.implementation.onAdd && this.implementation.onAdd(t4, t4.painter.context.gl);
        }
        onRemove(t4) {
          this.implementation.onRemove && this.implementation.onRemove(t4, t4.painter.context.gl);
        }
      }
      function Am(t4, e3, r3) {
        const n3 = [0, 0, 1], i3 = O.quat.identity([]);
        return O.quat.rotateY(i3, i3, r3 ? -Y(t4) + Math.PI : Y(t4)), O.quat.rotateX(i3, i3, -Y(e3)), O.vec3.transformQuat(n3, n3, i3), O.vec3.normalize(n3, n3);
      }
      function Sm(t4, e3) {
        const r3 = zm(t4.projection, t4.zoom, t4.width, t4.height), n3 = function(t5, e4, r4, n4, i4) {
          const a4 = new rl(r4.lng - 180 * Pm, r4.lat), s3 = new rl(r4.lng + 180 * Pm, r4.lat), o3 = t5.project(a4.lng, a4.lat), l3 = t5.project(s3.lng, s3.lat), u4 = -Math.atan2(l3.y - o3.y, l3.x - o3.x), c3 = xl.fromLngLat(r4);
          c3.y = Q2(c3.y, -1 + Pm, 1 - Pm);
          const h3 = c3.toLngLat(), p3 = t5.project(h3.lng, h3.lat), f3 = xl.fromLngLat(h3);
          f3.x += Pm;
          const d3 = f3.toLngLat(), m2 = t5.project(d3.lng, d3.lat), y2 = Tm(m2.x - p3.x, m2.y - p3.y, u4), g4 = xl.fromLngLat(h3);
          g4.y += Pm;
          const x2 = g4.toLngLat(), v2 = t5.project(x2.lng, x2.lat), b2 = Tm(v2.x - p3.x, v2.y - p3.y, u4), w2 = Math.abs(y2.x) / Math.abs(b2.y), _2 = O.mat4.identity([]);
          O.mat4.rotateZ(_2, _2, -u4 * (1 - (i4 ? 0 : n4)));
          const M2 = O.mat4.identity([]);
          return O.mat4.scale(M2, M2, [1, 1 - (1 - w2) * n4, 1]), M2[4] = -b2.x / b2.y * n4, O.mat4.rotateZ(M2, M2, u4), O.mat4.multiply(M2, _2, M2), M2;
        }(t4.projection, 0, t4.center, r3, e3), i3 = Im(t4);
        return O.mat4.scale(n3, n3, [i3, i3, 1]), n3;
      }
      function Im(t4) {
        const e3 = t4.projection, r3 = zm(t4.projection, t4.zoom, t4.width, t4.height), n3 = km(e3, t4.center), i3 = km(e3, rl.convert(e3.center));
        return Math.pow(2, n3 * r3 + (1 - r3) * i3);
      }
      function zm(t4, e3, r3, n3, i3 = 1 / 0) {
        const a4 = t4.range;
        if (!a4) return 0;
        const s3 = Math.min(i3, Math.max(r3, n3)), o3 = Math.log(s3 / 1024) / Math.LN2;
        return tt(a4[0] + o3, a4[1] + o3, e3);
      }
      const Pm = 1 / 4e4;
      function km(t4, e3) {
        const r3 = Q2(e3.lat, -fl2, fl2), n3 = new rl(e3.lng - 180 * Pm, r3), i3 = new rl(e3.lng + 180 * Pm, r3), a4 = t4.project(n3.lng, r3), s3 = t4.project(i3.lng, r3), o3 = xl.fromLngLat(n3), l3 = xl.fromLngLat(i3), u4 = s3.x - a4.x, c3 = s3.y - a4.y, h3 = l3.x - o3.x, p3 = l3.y - o3.y, f3 = Math.sqrt((h3 * h3 + p3 * p3) / (u4 * u4 + c3 * c3));
        return Math.log(f3) / Math.LN2;
      }
      function Tm(t4, e3, r3) {
        const n3 = Math.cos(r3), i3 = Math.sin(r3);
        return { x: t4 * n3 - e3 * i3, y: t4 * i3 + e3 * n3 };
      }
      function Em(t4, e3, r3) {
        O.mat4.identity(t4), O.mat4.rotateZ(t4, t4, Y(e3[2])), O.mat4.rotateX(t4, t4, Y(e3[0])), O.mat4.rotateY(t4, t4, Y(e3[1])), O.mat4.scale(t4, t4, r3), O.mat4.multiply(t4, t4, [1, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
      }
      function Bm(t4, e3, r3, n3, i3, a4, s3, o3) {
        const l3 = [r3[0] - e3[0], r3[1] - e3[1], 0], u4 = [n3[0] - e3[0], n3[1] - e3[1], 0];
        if (O.vec3.length(l3) < 1e-12 || O.vec3.length(u4) < 1e-12) return O.quat.identity(t4);
        const c3 = O.vec3.cross([], l3, u4);
        O.vec3.normalize(c3, c3), O.vec3.subtract(u4, n3, e3), l3[2] = (a4 - i3) * o3, u4[2] = (s3 - i3) * o3;
        const h3 = l3;
        return O.vec3.cross(h3, l3, u4), O.vec3.normalize(h3, h3), O.quat.rotationTo(t4, c3, h3);
      }
      function Vm(t4, e3, r3 = false) {
        const n3 = Du(e3.zoom), i3 = function(t5, e4, r4) {
          const n4 = e4.worldSize, i4 = [t5[12], t5[13], t5[14]], a4 = hl(i4[1] / n4), s3 = cl(i4[0] / n4), o3 = O.mat4.identity([]), l3 = ul(1, a4) * n4, u4 = ul(1, 0) * n4 * ml(a4, e4.zoom), c3 = 1 / Vu(n4);
          let h3 = u4 * c3;
          if (r4) {
            const t6 = zm(e4.projection, e4.zoom, e4.width, e4.height, 1024);
            h3 = c3 * e4.projection.pixelSpaceConversion(e4.center.lat, n4, t6);
          }
          const p3 = Qo(a4, s3);
          O.vec3.add(p3, p3, O.vec3.scale([], O.vec3.normalize([], p3), l3 * h3 * i4[2]));
          const f3 = function(t6) {
            const e5 = [t6[0], t6[1], t6[2]];
            let r5 = [0, 1, 0];
            const n5 = O.vec3.cross([], r5, e5);
            return O.vec3.cross(r5, e5, n5), 0 === O.vec3.squaredLength(r5) && (r5 = [0, 1, 0], O.vec3.cross(n5, e5, r5)), O.vec3.normalize(n5, n5), O.vec3.normalize(r5, r5), O.vec3.normalize(e5, e5), [n5[0], n5[1], n5[2], 0, r5[0], r5[1], r5[2], 0, e5[0], e5[1], e5[2], 0, t6[0], t6[1], t6[2], 1];
          }(p3);
          O.mat4.scale(o3, o3, [h3, h3, h3 * l3]), O.mat4.translate(o3, o3, [-i4[0], -i4[1], -i4[2]]);
          const d3 = O.mat4.multiply([], e4.globeMatrix, f3);
          return O.mat4.multiply(d3, d3, o3), O.mat4.multiply(d3, d3, t5), d3;
        }(t4, e3, r3);
        if (n3 > 0) {
          const r4 = function(t5, e4) {
            const r5 = e4.worldSize, n4 = ul(1, 0) * r5 * ml(e4.center.lat, e4.zoom) / Vu(r5), i4 = ul(1, e4.center.lat) * r5, a4 = O.mat4.identity([]);
            return O.mat4.rotateY(a4, a4, Y(e4.center.lng)), O.mat4.rotateX(a4, a4, Y(e4.center.lat)), O.mat4.translate(a4, a4, [0, 0, $o]), O.mat4.scale(a4, a4, [n4, n4, n4 * i4]), O.mat4.translate(a4, a4, [e4.point.x - 0.5 * r5, e4.point.y - 0.5 * r5, 0]), O.mat4.multiply(a4, a4, t5), O.mat4.multiply(a4, e4.globeMatrix, a4);
          }(t4, e3);
          return function(t5, e4, r5) {
            const n4 = (t6, e5, r6) => {
              const n5 = O.vec3.length(t6), i5 = O.vec3.length(e5), a5 = Mu(t6, e5, r6);
              return O.vec3.scale(a5, a5, 1 / O.vec3.length(a5) * Pe(n5, i5, r6));
            }, i4 = n4([t5[0], t5[1], t5[2]], [e4[0], e4[1], e4[2]], r5), a4 = n4([t5[4], t5[5], t5[6]], [e4[4], e4[5], e4[6]], r5), s3 = n4([t5[8], t5[9], t5[10]], [e4[8], e4[9], e4[10]], r5), o3 = Mu([t5[12], t5[13], t5[14]], [e4[12], e4[13], e4[14]], r5);
            return [i4[0], i4[1], i4[2], 0, a4[0], a4[1], a4[2], 0, s3[0], s3[1], s3[2], 0, o3[0], o3[1], o3[2], 1];
          }(i3, r4, n3);
        }
        return i3;
      }
      function Cm(t4, e3, r3, n3) {
        const i3 = yu.projectAabbCorners(n3, r3);
        let a4 = Number.MAX_VALUE, s3 = -1;
        for (let t5 = 0; t5 < i3.length; ++t5) {
          const r4 = i3[t5];
          r4[0] = (0.5 * r4[0] + 0.5) * e3.width, r4[1] = (0.5 - 0.5 * r4[1]) * e3.height, r4[2] < a4 && (s3 = t5, a4 = r4[2]);
        }
        const o3 = (t5) => new q(i3[t5][0], i3[t5][1]);
        let l3;
        switch (s3) {
          case 0:
          case 6:
            l3 = [o3(1), o3(5), o3(4), o3(7), o3(3), o3(2), o3(1)];
            break;
          case 1:
          case 7:
            l3 = [o3(0), o3(4), o3(5), o3(6), o3(2), o3(3), o3(0)];
            break;
          case 3:
          case 5:
            l3 = [o3(1), o3(0), o3(4), o3(7), o3(6), o3(2), o3(1)];
            break;
          default:
            l3 = [o3(1), o3(5), o3(6), o3(7), o3(3), o3(0), o3(1)];
        }
        if (El(t4, l3)) return a4;
      }
      const Rm = ds([{ name: "a_pos_3f", components: 3, type: "Float32" }]), Dm = ds([{ name: "a_color_3f", components: 3, type: "Float32" }]), Lm = ds([{ name: "a_color_4f", components: 4, type: "Float32" }]), Fm = ds([{ name: "a_uv_2f", components: 2, type: "Float32" }]), Om = ds([{ name: "a_normal_3f", components: 3, type: "Float32" }]), Um = ds([{ name: "a_normal_matrix0", components: 4, type: "Float32" }, { name: "a_normal_matrix1", components: 4, type: "Float32" }, { name: "a_normal_matrix2", components: 4, type: "Float32" }, { name: "a_normal_matrix3", components: 4, type: "Float32" }]), jm = ds([{ name: "a_pbr", components: 4, type: "Uint16" }, { name: "a_heightBasedEmissiveStrength", components: 3, type: "Float32" }]), Nm = { None: 0, Model: 1, Symbol: 2, FillExtrusion: 4, All: 7 };
      class qm {
        constructor(t4, e3, r3, n3) {
          this.message = (t4 ? `${t4}: ` : "") + r3, n3 && (this.identifier = n3), null != e3 && e3.__line__ && (this.line = e3.__line__);
        }
      }
      function $m(t4, e3) {
        const r3 = -1 === t4.indexOf("://");
        try {
          return new URL(t4, r3 && e3 ? "http://example.com" : void 0), true;
        } catch (t5) {
          return false;
        }
      }
      class Gm {
        constructor(t4, e3) {
          this.feature = t4, this.instancedDataOffset = e3, this.instancedDataCount = 0, this.rotation = [0, 0, 0], this.scale = [1, 1, 1], this.translation = [0, 0, 0];
        }
      }
      class Xm {
        constructor() {
          this.instancedDataArray = new Gs(), this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
        }
      }
      class Ym {
        constructor(t4) {
          this.zoom = t4.zoom, this.canonical = t4.canonical, this.layers = t4.layers, this.layerIds = this.layers.map((t5) => t5.fqid), this.projection = t4.projection, this.index = t4.index, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter((t5) => t5.isStateDependent()).map((t5) => t5.id), this.hasPattern = false, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = { id: null, timestamp: 0 }, this.modelUris = [], this.modelsRequested = false, this.activeReplacements = [], this.replacementUpdateTime = 0;
        }
        updateFootprints(t4, e3) {
        }
        populate(t4, e3, r3, n3) {
          this.tileToMeter = gl(r3);
          const i3 = this.layers[0]._featureFilter.needGeometry;
          this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
          for (const { feature: a4, id: s3, index: o3, sourceLayerIndex: l3 } of t4) {
            const t5 = null != s3 ? s3 : a4.properties && a4.properties.hasOwnProperty("id") ? a4.properties.id : void 0, u4 = zl(a4, i3);
            if (!this.layers[0]._featureFilter.filter(new Ea(this.zoom), u4, r3)) continue;
            const c3 = { id: t5, sourceLayerIndex: l3, index: o3, geometry: i3 ? u4.geometry : Il(a4, r3, n3), properties: a4.properties, type: a4.type, patterns: {} }, h3 = this.addFeature(c3, c3.geometry, u4);
            h3 && e3.featureIndex.insert(a4, c3.geometry, o3, l3, this.index, this.instancesPerModel[h3].instancedDataArray.length, Wr / 32);
          }
          this.lookup = null;
        }
        update(t4, e3, r3, n3) {
          for (const e4 in this.instancesPerModel) {
            const r4 = this.instancesPerModel[e4];
            for (const e5 in t4) r4.idToFeaturesIndex.hasOwnProperty(e5) && (this.evaluate(r4.features[r4.idToFeaturesIndex[e5]], t4[e5], r4, true), this.uploaded = false);
          }
          this.maxHeight = 0;
        }
        updateZoomBasedPaintProperties() {
          if (!this.hasZoomDependentProperties) return false;
          let t4 = false;
          for (const e3 in this.instancesPerModel) {
            const r3 = this.instancesPerModel[e3];
            for (const e4 of r3.features) {
              const n3 = this.layers[0], i3 = e4.feature, a4 = this.canonical, s3 = n3.paint.get("model-rotation").evaluate(i3, {}, a4), o3 = n3.paint.get("model-scale").evaluate(i3, {}, a4), l3 = n3.paint.get("model-translation").evaluate(i3, {}, a4);
              O.vec3.exactEquals(e4.rotation, s3) && O.vec3.exactEquals(e4.scale, o3) && O.vec3.exactEquals(e4.translation, l3) || (this.evaluate(e4, e4.featureStates, r3, true), t4 = true);
            }
          }
          return t4;
        }
        updateReplacement(t4, e3, r3, n3) {
          if (e3.updateTime === this.replacementUpdateTime) return false;
          this.replacementUpdateTime = e3.updateTime;
          const i3 = e3.getReplacementRegionsForTile(t4.toUnwrapped(), true);
          if (wh(this.activeReplacements, i3)) return false;
          this.activeReplacements = i3;
          let a4 = false;
          for (const e4 in this.instancesPerModel) {
            const i4 = this.instancesPerModel[e4], s3 = i4.instancedDataArray;
            for (const e5 of i4.features) {
              const i5 = e5.instancedDataOffset, o3 = e5.instancedDataCount;
              for (let e6 = 0; e6 < o3; e6++) {
                const o4 = 16 * (e6 + i5);
                let l3 = s3.float32[o4 + 0];
                const u4 = l3 > Wr;
                l3 = u4 ? l3 - Wr : l3;
                const c3 = Math.floor(l3), h3 = s3.float32[o4 + 1];
                let p3 = false;
                for (const e7 of this.activeReplacements) if (!gh(e7, r3, Nm.Model, n3) && !(e7.min.x > c3 || c3 > e7.max.x || e7.min.y > h3 || h3 > e7.max.y) && (p3 = zh(Ih(c3, h3, t4.canonical, e7.footprintTileId.canonical), e7.footprint), p3)) break;
                s3.float32[o4] = p3 ? l3 + Wr : l3, a4 = a4 || p3 !== u4;
              }
            }
          }
          return a4;
        }
        isEmpty() {
          for (const t4 in this.instancesPerModel) if (0 !== this.instancesPerModel[t4].instancedDataArray.length) return false;
          return true;
        }
        uploadPending() {
          return !this.uploaded;
        }
        upload(t4) {
          if (!this.uploaded) for (const e3 in this.instancesPerModel) {
            const r3 = this.instancesPerModel[e3];
            r3.instancedDataArray.length < 0 || 0 === r3.instancedDataArray.length || (r3.instancedDataBuffer ? r3.instancedDataBuffer.updateData(r3.instancedDataArray) : r3.instancedDataBuffer = t4.createVertexBuffer(r3.instancedDataArray, Um.members, true, void 0, this.instanceCount));
          }
          this.uploaded = true;
        }
        destroy() {
          for (const t5 in this.instancesPerModel) {
            const e3 = this.instancesPerModel[t5];
            0 !== e3.instancedDataArray.length && e3.instancedDataBuffer && e3.instancedDataBuffer.destroy();
          }
          const t4 = this.layers[0].modelManager;
          if (t4 && this.modelUris) for (const e3 of this.modelUris) t4.removeModel(e3, "");
        }
        addFeature(t4, e3, r3) {
          const n3 = this.layers[0], i3 = n3.layout.get("model-id").evaluate(r3, {}, this.canonical);
          if (!i3) return ft(`modelId is not evaluated for layer ${n3.id} and it is not going to get rendered.`), i3;
          $m(i3, false) && (this.modelUris.includes(i3) || this.modelUris.push(i3)), this.instancesPerModel[i3] || (this.instancesPerModel[i3] = new Xm());
          const a4 = this.instancesPerModel[i3], s3 = a4.instancedDataArray, o3 = new Gm(r3, s3.length);
          for (const t5 of e3) for (const e4 of t5) {
            if (e4.x < 0 || e4.x >= Wr || e4.y < 0 || e4.y >= Wr) continue;
            const t6 = (this.lookupDim - 1) / Wr, r4 = this.lookupDim * (e4.y * t6 | 0) + e4.x * t6 | 0;
            if (this.lookup) {
              if (0 !== this.lookup[r4]) continue;
              this.lookup[r4] = 1;
            }
            this.instanceCount++;
            const n4 = s3.length;
            s3.resize(n4 + 1), a4.instancesEvaluatedElevation.push(0), s3.float32[16 * n4] = e4.x, s3.float32[16 * n4 + 1] = e4.y;
          }
          return o3.instancedDataCount = a4.instancedDataArray.length - o3.instancedDataOffset, o3.instancedDataCount > 0 && (t4.id && (a4.idToFeaturesIndex[t4.id] = a4.features.length), a4.features.push(o3), this.evaluate(o3, {}, a4, false)), i3;
        }
        getModelUris() {
          return this.modelUris;
        }
        evaluate(t4, e3, r3, n3) {
          const i3 = this.layers[0], a4 = t4.feature, s3 = this.canonical, o3 = t4.rotation = i3.paint.get("model-rotation").evaluate(a4, e3, s3), l3 = t4.scale = i3.paint.get("model-scale").evaluate(a4, e3, s3), u4 = t4.translation = i3.paint.get("model-translation").evaluate(a4, e3, s3), c3 = i3.paint.get("model-color").evaluate(a4, e3, s3);
          c3.a = i3.paint.get("model-color-mix-intensity").evaluate(a4, e3, s3);
          const h3 = [];
          this.maxVerticalOffset < u4[2] && (this.maxVerticalOffset = u4[2]), this.maxScale = Math.max(Math.max(this.maxScale, l3[0]), Math.max(l3[1], l3[2])), Em(h3, o3, l3);
          const p3 = Math.round(100 * c3.a) + c3.b / 1.05;
          for (let e4 = 0; e4 < t4.instancedDataCount; ++e4) {
            const i4 = t4.instancedDataOffset + e4, a5 = 16 * i4, o4 = r3.instancedDataArray.float32;
            let l4 = 0;
            n3 && (l4 = o4[a5 + 6] - r3.instancesEvaluatedElevation[i4]);
            const f3 = 0 | o4[a5 + 1];
            o4[a5] = (0 | o4[a5]) + c3.r / 1.05, o4[a5 + 1] = f3 + c3.g / 1.05, o4[a5 + 2] = p3, o4[a5 + 3] = 1 / (s3.z > 10 ? this.tileToMeter : gl(s3, f3)), o4[a5 + 4] = u4[0], o4[a5 + 5] = u4[1], o4[a5 + 6] = u4[2] + l4, o4[a5 + 7] = h3[0], o4[a5 + 8] = h3[1], o4[a5 + 9] = h3[2], o4[a5 + 10] = h3[4], o4[a5 + 11] = h3[5], o4[a5 + 12] = h3[6], o4[a5 + 13] = h3[8], o4[a5 + 14] = h3[9], o4[a5 + 15] = h3[10], r3.instancesEvaluatedElevation[i4] = u4[2];
          }
        }
      }
      let Zm, Wm;
      aa(Ym, "ModelBucket", { omit: ["layers"] }), aa(Xm, "PerModelAttributes"), aa(Gm, "ModelFeature");
      const Hm = 64, Km = { CoordinateSpaceTile: 1, CoordinateSpaceYUp: 2, HasMapboxMeshFeatures: 4, HasMeshoptCompression: 8 };
      function Jm(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4 = false) {
        const c3 = r3.zoom, h3 = r3.project(n3), p3 = ml(n3.lat, c3), f3 = 1 / p3;
        O.mat4.identity(t4), O.mat4.translate(t4, t4, [h3.x + s3[0] * f3, h3.y + s3[1] * f3, s3[2]]);
        let d3 = 1, m2 = 1;
        const y2 = r3.worldSize;
        if (u4) {
          if ("mercator" === r3.projection.name) {
            let t5 = 0;
            r3.elevation && (t5 = r3.elevation.getAtPointOrZero(new xl(h3.x / y2, h3.y / y2), 0));
            const e4 = O.vec4.transformMat4([], [h3.x, h3.y, t5, 1], r3.projMatrix)[3] / r3.cameraToCenterDistance;
            d3 = e4, m2 = e4 * ml(r3.center.lat, c3);
          } else if ("globe" === r3.projection.name) {
            const e4 = Vm(t4, r3), i4 = O.mat4.multiply([], r3.projMatrix, e4), a5 = [0, 0, 0, 1];
            O.vec4.transformMat4(a5, a5, i4);
            const s4 = a5[3] / r3.cameraToCenterDistance, o4 = Du(c3), l4 = r3.projection.pixelsPerMeter(n3.lat, y2) * ml(n3.lat, c3), u5 = r3.projection.pixelsPerMeter(r3.center.lat, y2) * ml(r3.center.lat, c3);
            d3 = s4 / Pe(l4, dl(r3.center.lat), o4), m2 = s4 * p3 / l4, d3 *= u5, m2 *= u5;
          }
        } else d3 = f3;
        O.mat4.scale(t4, t4, [d3, d3, m2]);
        const g4 = [...t4], x2 = e3.orientation, v2 = [];
        if (Em(v2, [x2[0] + i3[0], x2[1] + i3[1], x2[2] + i3[2]], a4), O.mat4.multiply(t4, g4, v2), o3 && r3.elevation) {
          let i4 = 0;
          const a5 = [];
          if (l3 && r3.elevation) {
            i4 = function(t5, e4, r4, n4, i5) {
              const a6 = e4.elevation;
              if (!a6) return 0;
              const s5 = yu.projectAabbCorners(r4, n4), o5 = ul(1, i5.lat) * e4.worldSize, l4 = function(t6, e5) {
                const r5 = [0, 0, 1], n5 = [{ corners: [0, 1, 3, 2], dotProductWithUp: 0 }, { corners: [1, 5, 2, 6], dotProductWithUp: 0 }, { corners: [0, 4, 1, 5], dotProductWithUp: 0 }, { corners: [2, 6, 3, 7], dotProductWithUp: 0 }, { corners: [4, 7, 5, 6], dotProductWithUp: 0 }, { corners: [0, 3, 4, 7], dotProductWithUp: 0 }];
                for (const i6 of n5) {
                  const n6 = t6[i6.corners[0]], a7 = t6[i6.corners[1]], s6 = t6[i6.corners[2]], o6 = [a7[0] - n6[0], a7[1] - n6[1], e5 * (a7[2] - n6[2])], l5 = O.vec3.cross(o6, o6, [s6[0] - n6[0], s6[1] - n6[1], e5 * (s6[2] - n6[2])]);
                  O.vec3.normalize(l5, l5), i6.dotProductWithUp = O.vec3.dot(l5, r5);
                }
                return n5.sort((t7, e6) => t7.dotProductWithUp - e6.dotProductWithUp), n5[0].corners;
              }(s5, o5), u5 = s5[l4[0]], c4 = s5[l4[1]], h4 = s5[l4[2]], p4 = s5[l4[3]], f4 = a6.getAtPointOrZero(new xl(u5[0] / e4.worldSize, u5[1] / e4.worldSize), 0), d4 = a6.getAtPointOrZero(new xl(c4[0] / e4.worldSize, c4[1] / e4.worldSize), 0), m3 = a6.getAtPointOrZero(new xl(h4[0] / e4.worldSize, h4[1] / e4.worldSize), 0), y3 = a6.getAtPointOrZero(new xl(p4[0] / e4.worldSize, p4[1] / e4.worldSize), 0), g5 = (f4 + y3) / 2, x3 = (d4 + m3) / 2;
              return g5 > x3 ? d4 < m3 ? Bm(t5, c4, p4, u5, d4, y3, f4, o5) : Bm(t5, h4, u5, p4, m3, f4, y3, o5) : f4 < y3 ? Bm(t5, u5, c4, h4, f4, d4, m3, o5) : Bm(t5, p4, h4, c4, y3, m3, d4, o5), Math.max(g5, x3);
            }(a5, r3, e3.aabb, t4, n3);
            const s4 = O.mat4.fromQuat([], a5), o4 = O.mat4.multiply([], s4, v2);
            O.mat4.multiply(t4, g4, o4);
          } else i4 = r3.elevation.getAtPointOrZero(new xl(h3.x / y2, h3.y / y2), 0);
          0 !== i4 && (t4[14] += i4);
        }
      }
      function Qm(t4, e3, r3 = false) {
        t4.uploaded || (t4.gfxTexture = new um(e3, t4.image, r3 ? e3.gl.R8 : e3.gl.RGBA8, { useMipmap: t4.sampler.minFilter >= e3.gl.NEAREST_MIPMAP_NEAREST }), t4.uploaded = true, t4.image = null);
      }
      function ty(t4, e3, r3) {
        t4.indexBuffer = e3.createIndexBuffer(t4.indexArray, false, true), t4.vertexBuffer = e3.createVertexBuffer(t4.vertexArray, Rm.members, false, true), t4.normalArray && (t4.normalBuffer = e3.createVertexBuffer(t4.normalArray, Om.members, false, true)), t4.texcoordArray && (t4.texcoordBuffer = e3.createVertexBuffer(t4.texcoordArray, Fm.members, false, true)), t4.colorArray && (t4.colorBuffer = e3.createVertexBuffer(t4.colorArray, (12 === t4.colorArray.bytesPerElement ? Dm : Lm).members, false, true)), t4.featureArray && (t4.pbrBuffer = e3.createVertexBuffer(t4.featureArray, jm.members, true)), t4.segments = co.simpleSegment(0, 0, t4.vertexArray.length, t4.indexArray.length);
        const n3 = t4.material;
        n3.pbrMetallicRoughness.baseColorTexture && Qm(n3.pbrMetallicRoughness.baseColorTexture, e3), n3.pbrMetallicRoughness.metallicRoughnessTexture && Qm(n3.pbrMetallicRoughness.metallicRoughnessTexture, e3), n3.normalTexture && Qm(n3.normalTexture, e3), n3.occlusionTexture && Qm(n3.occlusionTexture, e3, r3), n3.emissionTexture && Qm(n3.emissionTexture, e3);
      }
      function ey(t4, e3, r3) {
        if (t4.meshes) for (const n3 of t4.meshes) ty(n3, e3, r3);
        if (t4.children) for (const n3 of t4.children) ey(n3, e3, r3);
      }
      function ry(t4) {
        if (t4.meshes) for (const e3 of t4.meshes) e3.indexArray.destroy(), e3.vertexArray.destroy(), e3.colorArray && e3.colorArray.destroy(), e3.normalArray && e3.normalArray.destroy(), e3.texcoordArray && e3.texcoordArray.destroy(), e3.featureArray && e3.featureArray.destroy();
        if (t4.children) for (const e3 of t4.children) ry(e3);
      }
      function ny(t4) {
        if (t4.meshes) for (const r3 of t4.meshes) r3.vertexBuffer && (r3.vertexBuffer.destroy(), r3.indexBuffer.destroy(), r3.normalBuffer && r3.normalBuffer.destroy(), r3.texcoordBuffer && r3.texcoordBuffer.destroy(), r3.colorBuffer && r3.colorBuffer.destroy(), r3.pbrBuffer && r3.pbrBuffer.destroy(), r3.segments.destroy(), r3.material && ((e3 = r3.material).pbrMetallicRoughness.baseColorTexture && e3.pbrMetallicRoughness.baseColorTexture.gfxTexture && e3.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), e3.pbrMetallicRoughness.metallicRoughnessTexture && e3.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && e3.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), e3.normalTexture && e3.normalTexture.gfxTexture && e3.normalTexture.gfxTexture.destroy(), e3.emissionTexture && e3.emissionTexture.gfxTexture && e3.emissionTexture.gfxTexture.destroy(), e3.occlusionTexture && e3.occlusionTexture.gfxTexture && e3.occlusionTexture.gfxTexture.destroy()));
        var e3;
        if (t4.children) for (const e4 of t4.children) ny(e4);
      }
      class iy {
        constructor(t4, e3, r3) {
          this._demTile = t4, this._dem = this._demTile.dem, this._scale = e3, this._offset = r3;
        }
        static create(t4, e3, r3) {
          const n3 = r3 || t4.findDEMTileFor(e3);
          if (!n3 || !n3.dem) return;
          const i3 = n3.dem, a4 = n3.tileID, s3 = 1 << e3.canonical.z - a4.canonical.z;
          return new iy(n3, i3.dim / Wr / s3, [(e3.canonical.x / s3 - a4.canonical.x) * i3.dim, (e3.canonical.y / s3 - a4.canonical.y) * i3.dim]);
        }
        tileCoordToPixel(t4, e3) {
          const r3 = e3 * this._scale + this._offset[1], n3 = Math.floor(t4 * this._scale + this._offset[0]), i3 = Math.floor(r3);
          return new q(n3, i3);
        }
        getElevationAt(t4, e3, r3, n3) {
          const i3 = t4 * this._scale + this._offset[0], a4 = e3 * this._scale + this._offset[1], s3 = Math.floor(i3), o3 = Math.floor(a4), l3 = this._dem;
          return n3 = !!n3, r3 ? Pe(Pe(l3.get(s3, o3, n3), l3.get(s3, o3 + 1, n3), a4 - o3), Pe(l3.get(s3 + 1, o3, n3), l3.get(s3 + 1, o3 + 1, n3), a4 - o3), i3 - s3) : l3.get(s3, o3, n3);
        }
        getElevationAtPixel(t4, e3, r3) {
          return this._dem.get(t4, e3, !!r3);
        }
        getMeterToDEM(t4) {
          return (1 << this._demTile.tileID.canonical.z) * ul(1, t4) * this._dem.stride;
        }
      }
      const ay = new Float32Array(262144), sy = new Uint8Array(262144);
      function oy(t4) {
        let e3 = 0;
        if (t4.meshes) for (const r3 of t4.meshes) e3 = Math.max(e3, r3.aabb.max[2]);
        if (t4.children) for (const r3 of t4.children) e3 = Math.max(e3, oy(r3));
        return e3;
      }
      function ly(t4, e3, r3) {
        if (t4.meshes) for (const n3 of t4.meshes) {
          if (n3.aabb.min[0] === 1 / 0) continue;
          const i3 = yu.applyTransform(n3.aabb, t4.matrix);
          r3.insert(e3, i3.min[0], i3.min[1], i3.max[0], i3.max[1]);
        }
        if (t4.children) for (const n3 of t4.children) ly(n3, e3, r3);
      }
      const uy = ["", "wall", "door", "roof", "window", "lamp", "logo"];
      class cy {
        constructor(t4) {
          this.node = t4, this.evaluatedRMEA = [[1, 0, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1], [0.4, 1, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1]], this.hiddenByReplacement = false, this.evaluatedScale = [1, 1, 1], this.evaluatedColor = [], this.emissionHeightBasedParams = [], this.cameraCollisionOpacity = 1, this.feature = { type: "Point", id: t4.id, geometry: [], properties: { height: oy(t4) } }, this.aabb = this._getLocalBounds();
        }
        _getLocalBounds() {
          if (!this.node.meshes) return new yu([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]);
          if (!this.aabb) {
            let t4 = 0;
            const e3 = new yu([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]);
            for (const r3 of this.node.meshes) this.node.lightMeshIndex !== t4 && (r3.transformedAabb = yu.applyTransformFast(r3.aabb, this.node.matrix), e3.encapsulate(r3.transformedAabb)), t4++;
            this.aabb = e3;
          }
          return this.aabb;
        }
      }
      class hy {
        constructor(t4, e3, r3, n3, i3, a4, s3) {
          this.id = r3, this.layers = t4, this.layerIds = this.layers.map((t5) => t5.fqid), this.stateDependentLayerIds = this.layers.filter((t5) => t5.isStateDependent()).map((t5) => t5.id), this.modelTraits |= Km.CoordinateSpaceTile, this.uploaded = false, this.hasPattern = false, n3 && (this.modelTraits |= Km.HasMapboxMeshFeatures), i3 && (this.modelTraits |= Km.HasMeshoptCompression), this.zoom = -1, this.terrainExaggeration = 1, this.projection = { name: "mercator" }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = a4, this.dirty = true, this.needsUpload = false, this.nodesInfo = [];
          for (const t5 of e3) this.nodesInfo.push(new cy(t5)), ly(t5, s3.featureIndexArray.length, s3.grid), s3.featureIndexArray.emplaceBack(this.nodesInfo.length - 1, 0, s3.bucketLayerIDs.length - 1, 0);
        }
        updateFootprints(t4, e3) {
          for (const r3 of this.getNodesInfo()) {
            const n3 = r3.node;
            n3.footprint && e3.push({ footprint: n3.footprint, id: t4 });
          }
        }
        update(t4) {
          const e3 = 0 !== Object.keys(t4).length;
          if (e3 && !this.stateDependentLayers.length) return;
          const r3 = e3 ? this.stateDependentLayers : this.layers;
          for (const e4 of r3) this.evaluate(e4, t4);
        }
        populate() {
          console.log("populate 3D model bucket");
        }
        uploadPending() {
          return !this.uploaded || this.needsUpload;
        }
        upload(t4) {
          if (!this.needsUpload) return;
          const e3 = this.getNodesInfo();
          for (const r3 of e3) {
            const e4 = r3.node;
            this.uploaded ? this.updatePbrBuffer(e4) : ey(e4, t4, true);
          }
          for (const t5 of e3) ry(t5.node);
          this.uploaded = true, this.needsUpload = false;
        }
        updatePbrBuffer(t4) {
          let e3 = false;
          if (!t4.meshes) return e3;
          for (const r3 of t4.meshes) r3.pbrBuffer && (r3.pbrBuffer.updateData(r3.featureArray), e3 = true);
          return e3;
        }
        needsReEvaluation(t4, e3, r3) {
          const n3 = t4.transform.projectionOptions, i3 = t4.style.getBrightness(), a4 = this.brightness !== i3;
          return !!(!this.uploaded || this.dirty || n3.name !== this.projection.name || py2(r3.paint.get("model-color").value, a4) || py2(r3.paint.get("model-color-mix-intensity").value, a4) || py2(r3.paint.get("model-roughness").value, a4) || py2(r3.paint.get("model-emissive-strength").value, a4) || py2(r3.paint.get("model-height-based-emissive-strength-multiplier").value, a4)) && (this.projection = n3, this.brightness = i3, true);
        }
        evaluateScale(t4, e3) {
          if (t4.transform.zoom === this.zoom) return;
          this.zoom = t4.transform.zoom;
          const r3 = this.getNodesInfo(), n3 = this.id.canonical;
          for (const t5 of r3) {
            const r4 = t5.feature;
            t5.evaluatedScale = e3.paint.get("model-scale").evaluate(r4, {}, n3);
          }
        }
        evaluate(t4, e3) {
          const r3 = this.getNodesInfo();
          for (const n3 of r3) {
            if (!n3.node.meshes) continue;
            const r4 = n3.feature, i3 = e3 && e3[r4.id], a4 = n3.node.meshes && n3.node.meshes[0].featureData, s3 = n3.evaluatedColor[2], o3 = n3.evaluatedRMEA[2], l3 = this.id.canonical;
            if (n3.hasTranslucentParts = false, a4) {
              for (let e4 = 0; e4 < uy.length; e4++) {
                const a5 = uy[e4];
                a5.length && (r4.properties.part = a5);
                const s4 = t4.paint.get("model-color").evaluate(r4, i3, l3).toRenderColor(null), o4 = t4.paint.get("model-color-mix-intensity").evaluate(r4, i3, l3);
                n3.evaluatedColor[e4] = [s4.r, s4.g, s4.b, o4], n3.evaluatedRMEA[e4][0] = t4.paint.get("model-roughness").evaluate(r4, i3, l3), n3.evaluatedRMEA[e4][2] = t4.paint.get("model-emissive-strength").evaluate(r4, i3, l3), n3.evaluatedRMEA[e4][3] = s4.a, n3.emissionHeightBasedParams[e4] = t4.paint.get("model-height-based-emissive-strength-multiplier").evaluate(r4, i3, l3), !n3.hasTranslucentParts && s4.a < 1 && (n3.hasTranslucentParts = true);
              }
              delete r4.properties.part, dy(n3, s3 !== n3.evaluatedColor[2] || o3 !== n3.evaluatedRMEA[2], this.modelTraits);
            } else n3.evaluatedRMEA[0][2] = t4.paint.get("model-emissive-strength").evaluate(r4, i3, l3);
            n3.evaluatedScale = t4.paint.get("model-scale").evaluate(r4, i3, l3), this.updatePbrBuffer(n3.node) || (this.needsUpload = true);
          }
          this.dirty = false;
        }
        elevationUpdate(t4, e3, r3, n3) {
          const i3 = t4.findDEMTileFor(r3);
          if (i3 && (i3.tileID.canonical !== this.terrainTile || e3 !== this.terrainExaggeration)) {
            if (i3.dem && i3.tileID.overscaledZ !== this.elevationReadFromZ) {
              this.elevationReadFromZ = i3.tileID.overscaledZ;
              const e4 = iy.create(t4, r3, i3);
              if (!e4) return;
              this.modelTraits & Km.HasMapboxMeshFeatures && this.updateDEM(t4, e4, r3, n3);
              for (const t5 of this.getNodesInfo()) {
                const r4 = t5.node;
                if (!r4.footprint || !r4.footprint.vertices || !r4.footprint.vertices.length) continue;
                const n4 = r4.footprint.vertices;
                let i4 = e4.getElevationAt(n4[0].x, n4[0].y, true, true);
                for (let t6 = 1; t6 < n4.length; t6++) i4 = Math.min(i4, e4.getElevationAt(n4[t6].x, n4[t6].y, true, true));
                r4.elevation = i4;
              }
            }
            this.terrainTile = i3.tileID.canonical, this.terrainExaggeration = e3;
          }
        }
        updateDEM(t4, e3, r3, n3) {
          let i3 = e3._dem._modifiedForSources[n3];
          if (void 0 === i3 && (e3._dem._modifiedForSources[n3] = [], i3 = e3._dem._modifiedForSources[n3]), i3.includes(r3.canonical)) return;
          const a4 = e3._dem.dim;
          i3.push(r3.canonical);
          let s3 = false;
          for (const t5 of this.getNodesInfo()) {
            const r4 = t5.node;
            if (!r4.footprint || !r4.footprint.grid) continue;
            const n4 = r4.footprint.grid, i4 = e3.tileCoordToPixel(n4.min.x, n4.min.y), o3 = e3.tileCoordToPixel(n4.max.x, n4.max.y), l3 = Math.min(Math.min(a4 - o3.y, i4.x), Math.min(i4.y, a4 - o3.x));
            if (l3 < 0) continue;
            const u4 = Q2(l3, 2, 5);
            let c3 = Math.max(0, i4.x - u4), h3 = Math.max(0, i4.y - u4), p3 = Math.min(o3.x + u4, a4 - 1), f3 = Math.min(o3.y + u4, a4 - 1);
            for (let t6 = h3; t6 <= f3; ++t6) for (let e4 = c3; e4 <= p3; ++e4) sy[t6 * a4 + e4] = 255;
            let d3 = 0, m2 = 0;
            for (let t6 = 0; t6 < n4.cellsY; ++t6) for (let r5 = 0; r5 < n4.cellsX; ++r5) {
              if (!n4.cells[t6 * n4.cellsX + r5]) continue;
              const i5 = e3.tileCoordToPixel(n4.min.x + r5 / n4.xScale, n4.min.y + t6 / n4.yScale), s4 = e3.tileCoordToPixel(n4.min.x + (r5 + 1) / n4.xScale, n4.min.y + (t6 + 1) / n4.yScale);
              for (let t7 = i5.y; t7 <= Math.min(s4.y + 1, a4 - 1); ++t7) for (let r6 = i5.x; r6 <= Math.min(s4.x + 1, a4 - 1); ++r6) 255 === sy[t7 * a4 + r6] && (sy[t7 * a4 + r6] = 0, d3 += e3.getElevationAtPixel(r6, t7), m2++);
            }
            const y2 = d3 / m2;
            c3 = Math.max(1, i4.x - u4), h3 = Math.max(1, i4.y - u4), p3 = Math.min(o3.x + u4, a4 - 2), f3 = Math.min(o3.y + u4, a4 - 2), s3 = true;
            for (let t6 = h3; t6 <= f3; ++t6) for (let r5 = c3; r5 <= p3; ++r5) 0 === sy[t6 * a4 + r5] && (ay[t6 * a4 + r5] = e3._dem.set(r5, t6, y2));
            for (let t6 = 1; t6 < u4; ++t6) {
              c3 = Math.max(1, i4.x - t6), h3 = Math.max(1, i4.y - t6), p3 = Math.min(o3.x + t6, a4 - 2), f3 = Math.min(o3.y + t6, a4 - 2);
              for (let r5 = h3; r5 <= f3; ++r5) for (let n5 = c3; n5 <= p3; ++n5) {
                const i5 = r5 * a4 + n5;
                if (255 === sy[i5]) {
                  let s4 = 0, o4 = 0, l4 = -1, c4 = -1;
                  for (let e4 = -1; e4 <= 1; ++e4) for (let i6 = -1; i6 <= 1; ++i6) {
                    const u5 = (r5 + e4) * a4 + n5 + i6;
                    if (sy[u5] >= t6) continue;
                    const h4 = ay[u5], p4 = Math.abs(h4);
                    p4 > o4 && (s4 = h4, o4 = p4, l4 = i6, c4 = e4);
                  }
                  if (o4 > 0.1) {
                    const a5 = 1 - (t6 + 0.5 * Math.abs(l4 * c4)) / u4;
                    let o5 = e3._dem.get(n5, r5) + s4 * a5;
                    const h4 = e3._dem.get(n5 + l4, r5 + c4), p4 = e3._dem.get(n5 - l4, r5 - c4, true);
                    (o5 - h4) * (o5 - p4) > 0 && (o5 = (h4 + p4) / 2), ay[i5] = e3._dem.set(n5, r5, o5), sy[i5] = t6;
                  }
                }
              }
            }
          }
          s3 && (e3._demTile.needsDEMTextureUpload = true, e3._dem._timestamp = Rt.now());
        }
        getNodesInfo() {
          return this.nodesInfo;
        }
        destroy() {
          const t4 = this.getNodesInfo();
          for (const e3 of t4) ry(e3.node), ny(e3.node);
        }
        isEmpty() {
          return !this.nodesInfo.length;
        }
        updateReplacement(t4, e3) {
          if (e3.updateTime === this.replacementUpdateTime) return;
          this.replacementUpdateTime = e3.updateTime;
          const r3 = e3.getReplacementRegionsForTile(t4.toUnwrapped()), n3 = this.getNodesInfo();
          for (let t5 = 0; t5 < this.nodesInfo.length; t5++) {
            const e4 = n3[t5].node;
            n3[t5].hiddenByReplacement = !!e4.footprint && !r3.find((t6) => t6.footprint === e4.footprint);
          }
        }
        getHeightAtTileCoord(t4, e3) {
          const r3 = this.getNodesInfo(), n3 = [], i3 = [0, 0, 0], a4 = O.mat4.identity([]);
          for (let s3 = 0; s3 < this.nodesInfo.length; s3++) {
            const o3 = r3[s3], l3 = o3.node.meshes[0], u4 = l3.transformedAabb;
            if (t4 < u4.min[0] || e3 < u4.min[1] || t4 > u4.max[0] || e3 > u4.max[1]) continue;
            if (true === o3.node.hidden) return { height: 1 / 0, maxHeight: o3.feature.properties.height, hidden: false, verticalScale: o3.evaluatedScale[2] };
            O.mat4.invert(a4, o3.node.matrix), i3[0] = t4, i3[1] = e3, O.vec3.transformMat4(i3, i3, a4);
            const c3 = (i3[0] - l3.aabb.min[0]) / (l3.aabb.max[0] - l3.aabb.min[0]) * Hm | 0, h3 = Math.min(63, (i3[1] - l3.aabb.min[1]) / (l3.aabb.max[1] - l3.aabb.min[1]) * Hm | 0) * Hm + Math.min(63, c3), p3 = l3.heightmap[h3];
            if (!(p3 < 0 && o3.node.footprint)) {
              if (o3.hiddenByReplacement) return;
              return { height: p3, maxHeight: o3.feature.properties.height, hidden: false, verticalScale: o3.evaluatedScale[2] };
            }
            if (o3.node.footprint.grid.query(new q(t4, e3), new q(t4, e3), n3), n3.length > 0) return { height: void 0, maxHeight: o3.feature.properties.height, hidden: o3.hiddenByReplacement, verticalScale: o3.evaluatedScale[2] };
          }
        }
      }
      function py2(t4, e3) {
        return !t4.isLightConstant && e3;
      }
      function fy(t4, e3, r3, n3, i3, a4, s3, o3) {
        let l3 = (61440 & e3 | (61440 & e3) >> 4) >> 8, u4 = (3840 & e3 | (3840 & e3) >> 4) >> 4, c3 = 240 & e3 | (240 & e3) >> 4;
        r3[3] > 0 && (l3 = Pe(l3, 255 * r3[0], r3[3]), u4 = Pe(u4, 255 * r3[1], r3[3]), c3 = Pe(c3, 255 * r3[2], r3[3]));
        const h3 = l3 << 8 | u4, p3 = c3 << 8 | Math.floor(255 * n3[3]), f3 = function(t5) {
          const e4 = Q2(t5, 0, 2);
          return Math.min(Math.round(0.5 * e4 * 255), 255);
        }(n3[2]) << 8 | 15 * n3[0] << 4 | 15 * n3[1], d3 = Q2(i3[0], 0, 1), m2 = Q2(i3[1], 0, 1), y2 = Q2(i3[2], 0, 1), g4 = Q2(i3[3], 0, 1);
        let x2, v2, b2, w2;
        if (d3 !== m2 && s3 !== a4 && m2 !== d3) {
          const t5 = s3 - a4;
          v2 = 1 / (t5 * (m2 - d3)), b2 = -(a4 + t5 * d3) / (t5 * (m2 - d3));
          const e4 = Q2(i3[4], -1, 1);
          w2 = Math.pow(10, e4), x2 = 255 * y2 << 8 | 255 * g4;
        } else x2 = 65535, v2 = 0, b2 = 1, w2 = 1;
        if (t4.emplaceBack(h3, p3, f3, x2, v2, b2, w2), o3) {
          const t5 = o3.length;
          o3.clear();
          for (let e4 = 0; e4 < t5; e4++) o3.emplaceBack(h3, p3, f3, x2, v2, b2, w2);
        }
      }
      function dy(t4, e3, r3) {
        const n3 = t4.node;
        let i3 = 0;
        const a4 = r3 & Km.HasMeshoptCompression;
        for (const r4 of n3.meshes) {
          if (n3.lights && n3.lightMeshIndex === i3) continue;
          if (!r4.featureData) continue;
          r4.featureArray = new Xs(), r4.featureArray.reserve(r4.featureData.length);
          let s3 = e3;
          for (const e4 of r4.featureData) {
            const i4 = a4 ? 65535 & e4 : e4 >> 16 & 65535, o3 = a4 ? e4 >> 16 & 65535 : 65535 & e4, l3 = (15 & o3) < 8 ? 15 & o3 : 0, u4 = t4.evaluatedRMEA[l3], c3 = t4.evaluatedColor[l3], h3 = t4.emissionHeightBasedParams[l3];
            let p3;
            if (s3 && 2 === l3 && n3.lights && (p3 = new Xs(), p3.resize(10 * n3.lights.length)), fy(r4.featureArray, i4, c3, u4, h3, r4.aabb.min[2], r4.aabb.max[2], p3), p3 && s3) {
              s3 = false;
              const t5 = n3.meshes[n3.lightMeshIndex];
              t5.featureArray = p3, t5.featureArray._trim();
            }
          }
          r4.featureArray._trim(), i3++;
        }
      }
      aa(hy, "Tiled3dModelBucket", { omit: ["layers"] }), aa(cy, "Tiled3dModelFeature");
      const my = ["id", "tile", "layer", "source", "sourceLayer", "state"];
      class yy {
        constructor(t4, e3, r3, n3, i3) {
          this.type = "Feature", this._vectorTileFeature = t4, this._z = e3, this._x = r3, this._y = n3, this.properties = t4.properties, this.id = i3;
        }
        clone() {
          const t4 = new yy(this._vectorTileFeature, this._z, this._x, this._y, this.id);
          return this.state && (t4.state = { ...this.state }), this.layer && (t4.layer = { ...this.layer }), this.namespace && (t4.namespace = this.namespace), t4;
        }
        get geometry() {
          return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
        }
        set geometry(t4) {
          this._geometry = t4;
        }
        toJSON() {
          const t4 = { type: "Feature", state: void 0, geometry: this.geometry, properties: this.properties };
          for (const e3 of my) void 0 !== this[e3] && (t4[e3] = this[e3]);
          return t4;
        }
      }
      function gy(t4, e3, r3, n3) {
        const i3 = 1 << t4.z;
        e3.lat = hl((n3 / Wr + t4.y) / i3), e3.lng = cl((r3 / Wr + t4.x) / i3);
      }
      const xy = { circle: class extends cs {
        constructor(t4, e3, r3, n3) {
          super(t4, { layout: Wl || (Wl = new qa({ "circle-sort-key": new ja($a.layout_circle["circle-sort-key"]), visibility: new Ua($a.layout_circle.visibility) })), paint: Hl || (Hl = new qa({ "circle-radius": new ja($a.paint_circle["circle-radius"]), "circle-color": new ja($a.paint_circle["circle-color"]), "circle-blur": new ja($a.paint_circle["circle-blur"]), "circle-opacity": new ja($a.paint_circle["circle-opacity"]), "circle-translate": new Ua($a.paint_circle["circle-translate"]), "circle-translate-anchor": new Ua($a.paint_circle["circle-translate-anchor"]), "circle-pitch-scale": new Ua($a.paint_circle["circle-pitch-scale"]), "circle-pitch-alignment": new Ua($a.paint_circle["circle-pitch-alignment"]), "circle-stroke-width": new ja($a.paint_circle["circle-stroke-width"]), "circle-stroke-color": new ja($a.paint_circle["circle-stroke-color"]), "circle-stroke-opacity": new ja($a.paint_circle["circle-stroke-opacity"]), "circle-emissive-strength": new Ua($a.paint_circle["circle-emissive-strength"]) })) }, e3, r3, n3);
        }
        createBucket(t4) {
          return new Tl(t4);
        }
        queryRadius(t4) {
          const e3 = t4;
          return Gl("circle-radius", this, e3) + Gl("circle-stroke-width", this, e3) + Xl(this.paint.get("circle-translate"));
        }
        queryIntersectsFeature(t4, e3, r3, n3, i3, a4, s3, o3) {
          const l3 = Zl(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), a4.angle, t4.pixelToTileUnitsFactor), u4 = this.paint.get("circle-radius").evaluate(e3, r3) + this.paint.get("circle-stroke-width").evaluate(e3, r3);
          return $u(t4, n3, a4, s3, o3, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l3, u4);
        }
        getProgramIds() {
          return ["circle"];
        }
        getDefaultProgramParams(t4, e3, r3) {
          const n3 = qu(this);
          return { config: new Lo(this, { zoom: e3, lut: r3 }), defines: n3, overrideFog: false };
        }
      }, heatmap: class extends cs {
        createBucket(t4) {
          return new Wu(t4);
        }
        constructor(t4, e3, r3, n3) {
          super(t4, { layout: Hu || (Hu = new qa({ visibility: new Ua($a.layout_heatmap.visibility) })), paint: Ku || (Ku = new qa({ "heatmap-radius": new ja($a.paint_heatmap["heatmap-radius"]), "heatmap-weight": new ja($a.paint_heatmap["heatmap-weight"]), "heatmap-intensity": new Ua($a.paint_heatmap["heatmap-intensity"]), "heatmap-color": new Na($a.paint_heatmap["heatmap-color"]), "heatmap-opacity": new Ua($a.paint_heatmap["heatmap-opacity"]) })) }, e3, r3, n3), this._updateColorRamp();
        }
        _handleSpecialPaintPropertyUpdate(t4) {
          "heatmap-color" === t4 && this._updateColorRamp();
        }
        _updateColorRamp() {
          this.colorRamp = sc({ expression: this._transitionablePaint._values["heatmap-color"].value.expression, evaluationKey: "heatmapDensity", image: this.colorRamp }), this.colorRampTexture = null;
        }
        resize() {
          this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
        }
        queryRadius(t4) {
          return Gl("heatmap-radius", this, t4);
        }
        queryIntersectsFeature(t4, e3, r3, n3, i3, a4, s3, o3) {
          const l3 = this.paint.get("heatmap-radius").evaluate(e3, r3);
          return $u(t4, n3, a4, s3, o3, true, true, new q(0, 0), l3);
        }
        hasOffscreenPass() {
          return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
        }
        getProgramIds() {
          return ["heatmap", "heatmapTexture"];
        }
        getDefaultProgramParams(t4, e3, r3) {
          return "heatmap" === t4 ? { config: new Lo(this, { zoom: e3, lut: r3 }), overrideFog: false } : {};
        }
      }, hillshade: class extends cs {
        constructor(t4, e3, r3, n3) {
          super(t4, { layout: Ju || (Ju = new qa({ visibility: new Ua($a.layout_hillshade.visibility) })), paint: Qu || (Qu = new qa({ "hillshade-illumination-direction": new Ua($a.paint_hillshade["hillshade-illumination-direction"]), "hillshade-illumination-anchor": new Ua($a.paint_hillshade["hillshade-illumination-anchor"]), "hillshade-exaggeration": new Ua($a.paint_hillshade["hillshade-exaggeration"]), "hillshade-shadow-color": new Ua($a.paint_hillshade["hillshade-shadow-color"]), "hillshade-highlight-color": new Ua($a.paint_hillshade["hillshade-highlight-color"]), "hillshade-accent-color": new Ua($a.paint_hillshade["hillshade-accent-color"]), "hillshade-emissive-strength": new Ua($a.paint_hillshade["hillshade-emissive-strength"]) })) }, e3, r3, n3);
        }
        shouldRedrape() {
          return this.hasOffscreenPass() && "viewport" === this.paint.get("hillshade-illumination-anchor");
        }
        hasOffscreenPass() {
          return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
        }
        getProgramIds() {
          return ["hillshade", "hillshadePrepare"];
        }
        getDefaultProgramParams(t4, e3, r3) {
          return { overrideFog: false };
        }
      }, fill: class extends cs {
        constructor(t4, e3, r3, n3) {
          super(t4, { layout: Oc || (Oc = new qa({ "fill-sort-key": new ja($a.layout_fill["fill-sort-key"]), visibility: new Ua($a.layout_fill.visibility), "fill-elevation-reference": new Ua($a.layout_fill["fill-elevation-reference"]) })), paint: Uc || (Uc = new qa({ "fill-antialias": new Ua($a.paint_fill["fill-antialias"]), "fill-opacity": new ja($a.paint_fill["fill-opacity"]), "fill-color": new ja($a.paint_fill["fill-color"]), "fill-outline-color": new ja($a.paint_fill["fill-outline-color"]), "fill-translate": new Ua($a.paint_fill["fill-translate"]), "fill-translate-anchor": new Ua($a.paint_fill["fill-translate-anchor"]), "fill-pattern": new ja($a.paint_fill["fill-pattern"]), "fill-emissive-strength": new Ua($a.paint_fill["fill-emissive-strength"]), "fill-z-offset": new ja($a.paint_fill["fill-z-offset"]) })) }, e3, r3, n3);
        }
        getProgramIds() {
          const t4 = this.paint.get("fill-pattern"), e3 = t4 && t4.constantOr(1), r3 = [e3 ? "fillPattern" : "fill"];
          return this.paint.get("fill-antialias") && r3.push(e3 && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), r3;
        }
        getDefaultProgramParams(t4, e3, r3) {
          return { config: new Lo(this, { zoom: e3, lut: r3 }), overrideFog: false };
        }
        recalculate(t4, e3) {
          super.recalculate(t4, e3);
          const r3 = this.paint._values["fill-outline-color"];
          "constant" === r3.value.kind && void 0 === r3.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
        }
        createBucket(t4) {
          return new Fc(t4);
        }
        queryRadius() {
          return Xl(this.paint.get("fill-translate"));
        }
        queryIntersectsFeature(t4, e3, r3, n3, i3, a4) {
          return !t4.queryGeometry.isAboveHorizon && Vl(Yl(t4.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), a4.angle, t4.pixelToTileUnitsFactor), n3);
        }
        isTileClipped() {
          return true;
        }
        is3D() {
          return 0 !== this.paint.get("fill-z-offset").constantOr(1);
        }
      }, "fill-extrusion": class extends cs {
        constructor(t4, e3, r3, n3) {
          super(t4, { layout: ap || (ap = new qa({ visibility: new Ua($a["layout_fill-extrusion"].visibility), "fill-extrusion-edge-radius": new Ua($a["layout_fill-extrusion"]["fill-extrusion-edge-radius"]) })), paint: sp || (sp = new qa({ "fill-extrusion-opacity": new Ua($a["paint_fill-extrusion"]["fill-extrusion-opacity"]), "fill-extrusion-color": new ja($a["paint_fill-extrusion"]["fill-extrusion-color"]), "fill-extrusion-translate": new Ua($a["paint_fill-extrusion"]["fill-extrusion-translate"]), "fill-extrusion-translate-anchor": new Ua($a["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]), "fill-extrusion-pattern": new ja($a["paint_fill-extrusion"]["fill-extrusion-pattern"]), "fill-extrusion-height": new ja($a["paint_fill-extrusion"]["fill-extrusion-height"]), "fill-extrusion-base": new ja($a["paint_fill-extrusion"]["fill-extrusion-base"]), "fill-extrusion-height-alignment": new Ua($a["paint_fill-extrusion"]["fill-extrusion-height-alignment"]), "fill-extrusion-base-alignment": new Ua($a["paint_fill-extrusion"]["fill-extrusion-base-alignment"]), "fill-extrusion-vertical-gradient": new Ua($a["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]), "fill-extrusion-ambient-occlusion-intensity": new Ua($a["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]), "fill-extrusion-ambient-occlusion-radius": new Ua($a["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]), "fill-extrusion-ambient-occlusion-wall-radius": new Ua($a["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]), "fill-extrusion-ambient-occlusion-ground-radius": new Ua($a["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]), "fill-extrusion-ambient-occlusion-ground-attenuation": new Ua($a["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]), "fill-extrusion-flood-light-color": new Ua($a["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]), "fill-extrusion-flood-light-intensity": new Ua($a["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]), "fill-extrusion-flood-light-wall-radius": new ja($a["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]), "fill-extrusion-flood-light-ground-radius": new ja($a["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]), "fill-extrusion-flood-light-ground-attenuation": new Ua($a["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]), "fill-extrusion-vertical-scale": new Ua($a["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]), "fill-extrusion-rounded-roof": new Ua($a["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]), "fill-extrusion-cutoff-fade-range": new Ua($a["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]), "fill-extrusion-emissive-strength": new ja($a["paint_fill-extrusion"]["fill-extrusion-emissive-strength"]), "fill-extrusion-line-width": new ja($a["paint_fill-extrusion"]["fill-extrusion-line-width"]), "fill-extrusion-cast-shadows": new Ua($a["paint_fill-extrusion"]["fill-extrusion-cast-shadows"]) })) }, e3, r3, n3), this._stats = { numRenderedVerticesInShadowPass: 0, numRenderedVerticesInTransparentPass: 0 };
        }
        createBucket(t4) {
          return new Zh(t4);
        }
        queryRadius() {
          return Xl(this.paint.get("fill-extrusion-translate"));
        }
        is3D() {
          return true;
        }
        hasShadowPass() {
          return this.paint.get("fill-extrusion-cast-shadows");
        }
        cutoffRange() {
          return this.paint.get("fill-extrusion-cutoff-fade-range");
        }
        canCastShadows() {
          return true;
        }
        getProgramIds() {
          return [this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"];
        }
        queryIntersectsFeature(t4, e3, r3, n3, i3, a4, s3, o3, l3) {
          const u4 = Zl(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), a4.angle, t4.pixelToTileUnitsFactor), c3 = this.paint.get("fill-extrusion-height").evaluate(e3, r3), h3 = this.paint.get("fill-extrusion-base").evaluate(e3, r3), p3 = [0, 0], f3 = o3 && a4.elevation, d3 = a4.elevation ? a4.elevation.exaggeration() : 1, m2 = t4.tile.getBucket(this);
          if (f3 && m2 instanceof Zh) {
            const t5 = m2.centroidVertexArray, e4 = l3 + 1;
            e4 < t5.length && (p3[0] = t5.geta_centroid_pos0(e4), p3[1] = t5.geta_centroid_pos1(e4));
          }
          if (0 === p3[0] && 1 === p3[1]) return false;
          "globe" === a4.projection.name && (n3 = np([n3], [new q(0, 0), new q(Wr, Wr)], t4.tileID.canonical).map((t5) => t5.polygon).flat());
          const y2 = f3 ? o3 : null, [g4, x2] = function(t5, e4, r4, n4, i4, a5, s4, o4, l4, u5, c4) {
            return "globe" === t5.projection.name ? function(t6, e5, r5, n5, i5, a6, s5, o5, l5, u6, c5) {
              const h4 = [], p4 = [], f4 = t6.projection.upVectorScale(c5, t6.center.lat, t6.worldSize).metersToTile, d4 = [0, 0, 0, 1], m3 = [0, 0, 0, 1], y3 = (t7, e6, r6, n6) => {
                t7[0] = e6, t7[1] = r6, t7[2] = n6, t7[3] = 1;
              }, g5 = rp();
              r5 > 0 && (r5 += g5), n5 += g5;
              for (const g6 of e5) {
                const e6 = [], x3 = [];
                for (const h5 of g6) {
                  const p5 = h5.x + i5.x, g7 = h5.y + i5.y, v3 = t6.projection.projectTilePoint(p5, g7, c5), b2 = t6.projection.upVector(c5, h5.x, h5.y);
                  let w2 = r5, _2 = n5;
                  if (s5) {
                    const t7 = up(p5, g7, r5, n5, s5, o5, l5, u6);
                    w2 += t7.base, _2 += t7.top;
                  }
                  0 !== r5 ? y3(d4, v3.x + b2[0] * f4 * w2, v3.y + b2[1] * f4 * w2, v3.z + b2[2] * f4 * w2) : y3(d4, v3.x, v3.y, v3.z), y3(m3, v3.x + b2[0] * f4 * _2, v3.y + b2[1] * f4 * _2, v3.z + b2[2] * f4 * _2), O.vec3.transformMat4(d4, d4, a6), O.vec3.transformMat4(m3, m3, a6), e6.push(new hh(d4[0], d4[1], d4[2])), x3.push(new hh(m3[0], m3[1], m3[2]));
                }
                h4.push(e6), p4.push(x3);
              }
              return [h4, p4];
            }(t5, e4, r4, n4, i4, a5, s4, o4, l4, u5, c4) : s4 ? function(t6, e5, r5, n5, i5, a6, s5, o5, l5) {
              const u6 = [], c5 = [], h4 = [0, 0, 0, 1];
              for (const p4 of t6) {
                const t7 = [], f4 = [];
                for (const u7 of p4) {
                  const c6 = u7.x + n5.x, p5 = u7.y + n5.y, d4 = up(c6, p5, e5, r5, a6, s5, o5, l5);
                  h4[0] = c6, h4[1] = p5, h4[2] = d4.base, h4[3] = 1, O.vec4.transformMat4(h4, h4, i5), h4[3] = Math.max(h4[3], 1e-5);
                  const m3 = new hh(h4[0] / h4[3], h4[1] / h4[3], h4[2] / h4[3]);
                  h4[0] = c6, h4[1] = p5, h4[2] = d4.top, h4[3] = 1, O.vec4.transformMat4(h4, h4, i5), h4[3] = Math.max(h4[3], 1e-5);
                  const y3 = new hh(h4[0] / h4[3], h4[1] / h4[3], h4[2] / h4[3]);
                  t7.push(m3), f4.push(y3);
                }
                u6.push(t7), c5.push(f4);
              }
              return [u6, c5];
            }(e4, r4, n4, i4, a5, s4, o4, l4, u5) : function(t6, e5, r5, n5, i5) {
              const a6 = [], s5 = [], o5 = i5[8] * e5, l5 = i5[9] * e5, u6 = i5[10] * e5, c5 = i5[11] * e5, h4 = i5[8] * r5, p4 = i5[9] * r5, f4 = i5[10] * r5, d4 = i5[11] * r5;
              for (const e6 of t6) {
                const t7 = [], r6 = [];
                for (const a7 of e6) {
                  const e7 = a7.x + n5.x, s6 = a7.y + n5.y, m3 = i5[0] * e7 + i5[4] * s6 + i5[12], y3 = i5[1] * e7 + i5[5] * s6 + i5[13], g5 = i5[2] * e7 + i5[6] * s6 + i5[14], x3 = i5[3] * e7 + i5[7] * s6 + i5[15], v3 = m3 + o5, b2 = y3 + l5, w2 = g5 + u6, _2 = Math.max(x3 + c5, 1e-5), M2 = m3 + h4, A3 = y3 + p4, S2 = g5 + f4, I3 = Math.max(x3 + d4, 1e-5);
                  t7.push(new hh(v3 / _2, b2 / _2, w2 / _2)), r6.push(new hh(M2 / I3, A3 / I3, S2 / I3));
                }
                a6.push(t7), s5.push(r6);
              }
              return [a6, s5];
            }(e4, r4, n4, i4, a5);
          }(a4, n3, h3, c3, u4, s3, y2, p3, d3, a4.center.lat, t4.tileID.canonical), v2 = t4.queryGeometry;
          return function(t5, e4, r4) {
            let n4 = 1 / 0;
            Vl(r4, e4) && (n4 = lp(r4, e4[0]));
            for (let i4 = 0; i4 < e4.length; i4++) {
              const a5 = e4[i4], s4 = t5[i4];
              for (let t6 = 0; t6 < a5.length - 1; t6++) {
                const e5 = a5[t6], i5 = [e5, a5[t6 + 1], s4[t6 + 1], s4[t6], e5];
                El(r4, i5) && (n4 = Math.min(n4, lp(r4, i5)));
              }
            }
            return n4 !== 1 / 0 && n4;
          }(g4, x2, v2.isPointQuery() ? v2.screenBounds : v2.screenGeometry);
        }
      }, line: class extends cs {
        constructor(t4, e3, r3, n3) {
          const i3 = Bp();
          super(t4, i3, e3, r3, n3), i3.layout && (this.layout = new Oa(i3.layout)), this.gradientVersion = 0;
        }
        _handleSpecialPaintPropertyUpdate(t4) {
          if ("line-gradient" === t4) {
            const t5 = this._transitionablePaint._values["line-gradient"].value.expression;
            this.stepInterpolant = t5._styleExpression && t5._styleExpression.expression instanceof Fn, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
          }
        }
        gradientExpression() {
          return this._transitionablePaint._values["line-gradient"].value.expression;
        }
        widthExpression() {
          return this._transitionablePaint._values["line-width"].value.expression;
        }
        recalculate(t4, e3) {
          super.recalculate(t4, e3), this.paint._values["line-floorwidth"] = (() => {
            if (Cp) return Cp;
            const t5 = Bp();
            return Cp = new Vp(t5.paint.properties["line-width"].specification), Cp.useIntegerZoom = true, Cp;
          })().possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t4);
        }
        createBucket(t4) {
          return new wp(t4);
        }
        getProgramIds() {
          return [this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"];
        }
        getDefaultProgramParams(t4, e3, r3) {
          const n3 = kp(this);
          return { config: new Lo(this, { zoom: e3, lut: r3 }), defines: n3, overrideFog: false };
        }
        queryRadius(t4) {
          const e3 = t4, r3 = Rp(Gl("line-width", this, e3), Gl("line-gap-width", this, e3)), n3 = Gl("line-offset", this, e3);
          return r3 / 2 + Math.abs(n3) + Xl(this.paint.get("line-translate"));
        }
        queryIntersectsFeature(t4, e3, r3, n3, i3, a4) {
          if (t4.queryGeometry.isAboveHorizon) return false;
          const s3 = Yl(t4.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), a4.angle, t4.pixelToTileUnitsFactor), o3 = t4.pixelToTileUnitsFactor / 2 * Rp(this.paint.get("line-width").evaluate(e3, r3), this.paint.get("line-gap-width").evaluate(e3, r3)), l3 = this.paint.get("line-offset").evaluate(e3, r3);
          return l3 && (n3 = function(t5, e4) {
            const r4 = [], n4 = new q(0, 0);
            for (let i4 = 0; i4 < t5.length; i4++) {
              const a5 = t5[i4], s4 = [];
              for (let t6 = 0; t6 < a5.length; t6++) {
                const r5 = a5[t6], i5 = a5[t6 + 1], o4 = 0 === t6 ? n4 : r5.sub(a5[t6 - 1])._unit()._perp(), l4 = t6 === a5.length - 1 ? n4 : i5.sub(r5)._unit()._perp(), u4 = o4._add(l4)._unit();
                u4._mult(1 / (u4.x * l4.x + u4.y * l4.y)), s4.push(u4._mult(e4)._add(r5));
              }
              r4.push(s4);
            }
            return r4;
          }(n3, l3 * t4.pixelToTileUnitsFactor)), function(t5, e4, r4) {
            for (let n4 = 0; n4 < e4.length; n4++) {
              const i4 = e4[n4];
              if (t5.length >= 3) {
                for (let e5 = 0; e5 < i4.length; e5++) if (Ul(t5, i4[e5])) return true;
              }
              if (Cl(t5, i4, r4)) return true;
            }
            return false;
          }(s3, n3, o3);
        }
        isTileClipped() {
          return true;
        }
        isDraped(t4) {
          const e3 = this.layout.get("line-z-offset"), r3 = e3.isConstant() && !e3.constantOr(0), n3 = this.layout.get("line-elevation-reference");
          return !("sea" === n3 || "ground" === n3) && (r3 || "none" !== n3);
        }
      }, symbol: em, background: class extends cs {
        constructor(t4, e3, r3, n3) {
          super(t4, { layout: rm || (rm = new qa({ visibility: new Ua($a.layout_background.visibility) })), paint: nm || (nm = new qa({ "background-pitch-alignment": new Ua($a.paint_background["background-pitch-alignment"]), "background-color": new Ua($a.paint_background["background-color"]), "background-pattern": new Ua($a.paint_background["background-pattern"]), "background-opacity": new Ua($a.paint_background["background-opacity"]), "background-emissive-strength": new Ua($a.paint_background["background-emissive-strength"]) })) }, e3, r3, n3);
        }
        getProgramIds() {
          return [this.paint.get("background-pattern") ? "backgroundPattern" : "background"];
        }
        getDefaultProgramParams(t4, e3, r3) {
          return { overrideFog: false };
        }
        is3D() {
          return "viewport" === this.paint.get("background-pitch-alignment");
        }
      }, raster: ym, "raster-particle": _m, sky: class extends cs {
        constructor(t4, e3, r3, n3) {
          super(t4, { layout: vm || (vm = new qa({ visibility: new Ua($a.layout_sky.visibility) })), paint: bm || (bm = new qa({ "sky-type": new Ua($a.paint_sky["sky-type"]), "sky-atmosphere-sun": new Ua($a.paint_sky["sky-atmosphere-sun"]), "sky-atmosphere-sun-intensity": new Ua($a.paint_sky["sky-atmosphere-sun-intensity"]), "sky-gradient-center": new Ua($a.paint_sky["sky-gradient-center"]), "sky-gradient-radius": new Ua($a.paint_sky["sky-gradient-radius"]), "sky-gradient": new Na($a.paint_sky["sky-gradient"]), "sky-atmosphere-halo-color": new Ua($a.paint_sky["sky-atmosphere-halo-color"]), "sky-atmosphere-color": new Ua($a.paint_sky["sky-atmosphere-color"]), "sky-opacity": new Ua($a.paint_sky["sky-opacity"]) })) }, e3, r3, n3), this._updateColorRamp();
        }
        _handleSpecialPaintPropertyUpdate(t4) {
          "sky-gradient" === t4 ? this._updateColorRamp() : "sky-atmosphere-sun" !== t4 && "sky-atmosphere-halo-color" !== t4 && "sky-atmosphere-color" !== t4 && "sky-atmosphere-sun-intensity" !== t4 || (this._skyboxInvalidated = true);
        }
        _updateColorRamp() {
          this.colorRamp = sc({ expression: this._transitionablePaint._values["sky-gradient"].value.expression, evaluationKey: "skyRadialProgress" }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
        }
        needsSkyboxCapture(t4) {
          if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return true;
          if (!this.paint.get("sky-atmosphere-sun")) {
            const e3 = t4.style.light.properties.get("position");
            return this._lightPosition.azimuthal !== e3.azimuthal || this._lightPosition.polar !== e3.polar;
          }
          return false;
        }
        getCenter(t4, e3) {
          if ("atmosphere" === this.paint.get("sky-type")) {
            const r4 = this.paint.get("sky-atmosphere-sun"), n3 = !r4, i3 = t4.style.light, a4 = i3.properties.get("position");
            return n3 && "viewport" === i3.properties.get("anchor") && ft("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), n3 ? Am(a4.azimuthal, 90 - a4.polar, e3) : Am(r4[0], 90 - r4[1], e3);
          }
          const r3 = this.paint.get("sky-gradient-center");
          return Am(r3[0], 90 - r3[1], e3);
        }
        isSky() {
          return true;
        }
        markSkyboxValid(t4) {
          this._skyboxInvalidated = false, this._lightPosition = t4.style.light.properties.get("position");
        }
        hasOffscreenPass() {
          return true;
        }
        getProgramIds() {
          const t4 = this.paint.get("sky-type");
          return "atmosphere" === t4 ? ["skyboxCapture", "skybox"] : "gradient" === t4 ? ["skyboxGradient"] : null;
        }
      }, slot: class extends cs {
        constructor(t4, e3, r3, n3) {
          super(t4, { paint: wm || (wm = new qa({})) }, e3, null);
        }
      }, model: class extends cs {
        constructor(t4, e3, r3, n3) {
          super(t4, { layout: Zm || (Zm = new qa({ visibility: new Ua($a.layout_model.visibility), "model-id": new ja($a.layout_model["model-id"]) })), paint: Wm || (Wm = new qa({ "model-opacity": new Ua($a.paint_model["model-opacity"]), "model-rotation": new ja($a.paint_model["model-rotation"]), "model-scale": new ja($a.paint_model["model-scale"]), "model-translation": new ja($a.paint_model["model-translation"]), "model-color": new ja($a.paint_model["model-color"]), "model-color-mix-intensity": new ja($a.paint_model["model-color-mix-intensity"]), "model-type": new Ua($a.paint_model["model-type"]), "model-cast-shadows": new Ua($a.paint_model["model-cast-shadows"]), "model-receive-shadows": new Ua($a.paint_model["model-receive-shadows"]), "model-ambient-occlusion-intensity": new Ua($a.paint_model["model-ambient-occlusion-intensity"]), "model-emissive-strength": new ja($a.paint_model["model-emissive-strength"]), "model-roughness": new ja($a.paint_model["model-roughness"]), "model-height-based-emissive-strength-multiplier": new ja($a.paint_model["model-height-based-emissive-strength-multiplier"]), "model-cutoff-fade-range": new Ua($a.paint_model["model-cutoff-fade-range"]), "model-front-cutoff": new Ua($a.paint_model["model-front-cutoff"]) })) }, e3, r3, n3), this._stats = { numRenderedVerticesInShadowPass: 0, numRenderedVerticesInTransparentPass: 0 };
        }
        createBucket(t4) {
          return new Ym(t4);
        }
        getProgramIds() {
          return ["model"];
        }
        is3D() {
          return true;
        }
        hasShadowPass() {
          return true;
        }
        canCastShadows() {
          return true;
        }
        hasLightBeamPass() {
          return true;
        }
        cutoffRange() {
          return this.paint.get("model-cutoff-fade-range");
        }
        queryRadius(t4) {
          return t4 instanceof hy ? Wr - 1 : 0;
        }
        queryIntersectsFeature(t4, e3, r3, n3, i3, a4) {
          if (!this.modelManager) return false;
          const s3 = this.modelManager, o3 = t4.tile.getBucket(this);
          if (!(o3 && o3 instanceof Ym)) return false;
          const l3 = o3;
          for (const r4 in l3.instancesPerModel) {
            const n4 = l3.instancesPerModel[r4], i4 = void 0 !== e3.id ? e3.id : e3.properties && e3.properties.hasOwnProperty("id") ? e3.properties.id : void 0;
            if (n4.idToFeaturesIndex.hasOwnProperty(i4)) {
              const e4 = n4.features[n4.idToFeaturesIndex[i4]], o4 = s3.getModel(r4, this.scope);
              if (!o4) return false;
              let u4 = O.mat4.create();
              const c3 = new rl(0, 0), h3 = l3.canonical;
              let p3 = Number.MAX_VALUE;
              for (let r5 = 0; r5 < e4.instancedDataCount; ++r5) {
                const i5 = 16 * (e4.instancedDataOffset + r5), s4 = n4.instancedDataArray.float32, l4 = [s4[i5 + 4], s4[i5 + 5], s4[i5 + 6]];
                gy(h3, c3, s4[i5], 0 | s4[i5 + 1]), Jm(u4, o4, a4, c3, e4.rotation, e4.scale, l4, false, false, false), "globe" === a4.projection.name && (u4 = Vm(u4, a4));
                const f3 = O.mat4.multiply([], a4.projMatrix, u4), d3 = t4.queryGeometry, m2 = Cm(d3.isPointQuery() ? d3.screenBounds : d3.screenGeometry, a4, f3, o4.aabb);
                null != m2 && (p3 = Math.min(m2, p3));
              }
              return p3 !== Number.MAX_VALUE && p3;
            }
          }
          return false;
        }
        _handleOverridablePaintPropertyUpdate(t4, e3, r3) {
          return !(!this.layout || e3.isDataDriven() || r3.isDataDriven() || "model-color" !== t4 && "model-color-mix-intensity" !== t4 && "model-rotation" !== t4 && "model-scale" !== t4 && "model-translation" !== t4 && "model-emissive-strength" !== t4);
        }
        _isPropertyZoomDependent(t4) {
          const e3 = this._transitionablePaint._values[t4];
          return null != e3 && null != e3.value && null != e3.value.expression && e3.value.expression instanceof Hi;
        }
        isZoomDependent() {
          return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
        }
        queryIntersectsMatchingFeature(t4, e3, r3, n3) {
          const i3 = t4.tile, a4 = i3.getBucket(this);
          let s3 = null, o3 = Number.MAX_VALUE;
          if (!(a4 && a4 instanceof hy)) return { queryFeature: s3, intersectionZ: o3 };
          const l3 = a4.getNodesInfo()[e3];
          if (l3.hiddenByReplacement || !l3.node.meshes || !r3.filter(new Ea(i3.tileID.overscaledZ), l3.feature, i3.tileID.canonical)) return { queryFeature: s3, intersectionZ: o3 };
          const u4 = l3.node, c3 = n3.calculatePosMatrix(i3.tileID.toUnwrapped(), n3.worldSize), h3 = l3.evaluatedScale;
          let p3 = 0;
          n3.elevation && u4.elevation && (p3 = u4.elevation * n3.elevation.exaggeration()), O.mat4.translate(c3, c3, [(u4.anchor ? u4.anchor[0] : 0) * (h3[0] - 1), (u4.anchor ? u4.anchor[1] : 0) * (h3[1] - 1), p3]), O.mat4.scale(c3, c3, h3);
          const f3 = t4.queryGeometry, d3 = f3.isPointQuery() ? f3.screenBounds : f3.screenGeometry, m2 = function(t5) {
            const e4 = O.mat4.multiply([], c3, t5.matrix);
            O.mat4.multiply(e4, n3.expandedFarZProjMatrix, e4);
            for (let r4 = 0; r4 < t5.meshes.length; ++r4) {
              const i4 = t5.meshes[r4];
              if (r4 === t5.lightMeshIndex) continue;
              const a5 = Cm(d3, n3, e4, i4.aabb);
              null != a5 && (o3 = Math.min(a5, o3));
            }
            if (t5.children) for (const e5 of t5.children) m2(e5);
          };
          if (m2(u4), o3 === Number.MAX_VALUE) return { queryFeature: s3, intersectionZ: o3 };
          const y2 = new rl(0, 0);
          gy(i3.tileID.canonical, y2, l3.node.anchor[0], l3.node.anchor[1]);
          const { z: g4, x: x2, y: v2 } = i3.tileID.canonical;
          return s3 = new yy({}, g4, x2, v2, l3.feature.id), s3.properties = l3.feature.properties, s3.geometry = { type: "Point", coordinates: [y2.lng, y2.lat] }, s3.layer = { ...this.serialize(), id: this.fqid }, s3.state = {}, s3.tile = i3.tileID.canonical, { queryFeature: s3, intersectionZ: o3 };
        }
      }, clip: class extends cs {
        constructor(t4, e3, r3, n3) {
          super(t4, { layout: jc || (jc = new qa({ "clip-layer-types": new Ua($a.layout_clip["clip-layer-types"]), "clip-layer-scope": new Ua($a.layout_clip["clip-layer-scope"]) })), paint: Nc || (Nc = new qa({})) }, e3, r3, n3);
        }
        recalculate(t4, e3) {
          super.recalculate(t4, e3);
        }
        createBucket(t4) {
          return new Gc(t4);
        }
        isTileClipped() {
          return true;
        }
        is3D() {
          return true;
        }
      } };
      class vy {
        constructor(t4) {
          this._callback = t4, this._triggered = false, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel(), this._channel.port2.onmessage = () => {
            this._triggered = false, this._callback();
          });
        }
        trigger() {
          this._triggered || (this._triggered = true, this._channel ? this._channel.port1.postMessage(true) : setTimeout(() => {
            this._triggered = false, this._callback();
          }, 0));
        }
        remove() {
          this._channel = void 0, this._callback = () => {
          };
        }
      }
      class by {
        constructor() {
          this.tasks = {}, this.taskQueue = [], ot(["process"], this), this.invoker = new vy(this.process), this.nextId = 0;
        }
        add(t4, e3) {
          const r3 = this.nextId++, n3 = function({ type: t5, isSymbolTile: e4, zoom: r4 }) {
            return r4 = r4 || 0, "message" === t5 ? 0 : "maybePrepare" !== t5 || e4 ? "parseTile" !== t5 || e4 ? "parseTile" === t5 && e4 ? 300 - r4 : "maybePrepare" === t5 && e4 ? 400 - r4 : 500 : 200 - r4 : 100 - r4;
          }(e3);
          if (0 === n3) {
            try {
              t4();
            } finally {
            }
            return null;
          }
          return this.tasks[r3] = { fn: t4, metadata: e3, priority: n3, id: r3 }, this.taskQueue.push(r3), this.invoker.trigger(), { cancel: () => {
            delete this.tasks[r3];
          } };
        }
        process() {
          try {
            if (this.taskQueue = this.taskQueue.filter((t5) => !!this.tasks[t5]), !this.taskQueue.length) return;
            const t4 = this.pick();
            if (null === t4) return;
            const e3 = this.tasks[t4];
            if (delete this.tasks[t4], this.taskQueue.length && this.invoker.trigger(), !e3) return;
            e3.fn();
          } finally {
          }
        }
        pick() {
          let t4 = null, e3 = 1 / 0;
          for (let r4 = 0; r4 < this.taskQueue.length; r4++) {
            const n3 = this.tasks[this.taskQueue[r4]];
            n3.priority < e3 && (e3 = n3.priority, t4 = r4);
          }
          if (null === t4) return null;
          const r3 = this.taskQueue[t4];
          return this.taskQueue.splice(t4, 1), r3;
        }
        remove() {
          this.invoker.remove();
        }
      }
      class wy {
        constructor(t4, e3, r3) {
          this.target = t4, this.parent = e3, this.mapId = r3, this.callbacks = {}, this.cancelCallbacks = {}, ot(["receive"], this), this.target.addEventListener("message", this.receive, false), this.scheduler = new by();
        }
        send(t4, e3, r3, n3, i3 = false, a4) {
          const s3 = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
          r3 && (r3.metadata = a4, this.callbacks[s3] = r3);
          const o3 = /* @__PURE__ */ new Set();
          return this.target.postMessage({ id: s3, type: t4, hasCallback: !!r3, targetMapId: n3, mustQueue: i3, sourceMapId: this.mapId, data: la(e3, o3) }, o3), { cancel: () => {
            r3 && delete this.callbacks[s3], this.target.postMessage({ id: s3, type: "<cancel>", targetMapId: n3, sourceMapId: this.mapId });
          } };
        }
        receive(t4) {
          const e3 = t4.data, r3 = e3.id;
          if (r3 && (!e3.targetMapId || this.mapId === e3.targetMapId)) if ("<cancel>" === e3.type) {
            const t5 = this.cancelCallbacks[r3];
            delete this.cancelCallbacks[r3], t5 && t5.cancel();
          } else if (e3.mustQueue || gt()) {
            const t5 = this.callbacks[r3], n3 = this.scheduler.add(() => this.processTask(r3, e3), t5 && t5.metadata || { type: "message" });
            n3 && (this.cancelCallbacks[r3] = n3);
          } else this.processTask(r3, e3);
        }
        processTask(t4, e3) {
          if (delete this.cancelCallbacks[t4], "<response>" === e3.type) {
            const r3 = this.callbacks[t4];
            delete this.callbacks[t4], r3 && (e3.error ? r3(ua(e3.error)) : r3(null, ua(e3.data)));
          } else {
            const r3 = /* @__PURE__ */ new Set(), n3 = e3.hasCallback ? (e4, n4) => {
              this.target.postMessage({ id: t4, type: "<response>", sourceMapId: this.mapId, error: e4 ? la(e4) : null, data: la(n4, r3) }, r3);
            } : () => {
            }, i3 = ua(e3.data);
            if (this.parent[e3.type]) this.parent[e3.type](e3.sourceMapId, i3, n3);
            else if (this.parent.getWorkerSource) {
              const t5 = e3.type.split(".");
              this.parent.getWorkerSource(e3.sourceMapId, t5[0], i3.source, i3.scope)[t5[1]](i3, n3);
            } else n3(new Error(`Could not find function ${e3.type}`));
          }
        }
        remove() {
          this.scheduler.remove(), this.target.removeEventListener("message", this.receive, false);
        }
      }
      class _y2 {
        constructor(t4, e3) {
          this.workerPool = t4, this.actors = [], this.currentActor = 0, this.id = at();
          const r3 = this.workerPool.acquire(this.id);
          for (let t5 = 0; t5 < r3.length; t5++) {
            const n3 = new _y2.Actor(r3[t5], e3, this.id);
            n3.name = `Worker ${t5}`, this.actors.push(n3);
          }
          this.ready = false, this.broadcast("checkIfReady", null, () => {
            this.ready = true;
          });
        }
        broadcast(t4, e3, r3) {
          rt(this.actors, (r4, n3) => {
            r4.send(t4, e3, n3);
          }, r3 = r3 || function() {
          });
        }
        getActor() {
          return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
        }
        remove() {
          this.actors.forEach((t4) => {
            t4.remove();
          }), this.actors = [], this.workerPool.release(this.id);
        }
      }
      _y2.Actor = wy;
      class My {
        constructor(t4) {
          this.size = t4, this.minimums = [], this.maximums = [], this.leaves = [];
        }
        getElevation(t4, e3) {
          const r3 = this.toIdx(t4, e3);
          return { min: this.minimums[r3], max: this.maximums[r3] };
        }
        isLeaf(t4, e3) {
          return this.leaves[this.toIdx(t4, e3)];
        }
        toIdx(t4, e3) {
          return e3 * this.size + t4;
        }
      }
      function Ay(t4, e3, r3, n3) {
        let i3 = 0, a4 = Number.MAX_VALUE;
        for (let s3 = 0; s3 < 3; s3++) if (Math.abs(n3[s3]) < 1e-15) {
          if (r3[s3] < t4[s3] || r3[s3] > e3[s3]) return null;
        } else {
          const o3 = 1 / n3[s3];
          let l3 = (t4[s3] - r3[s3]) * o3, u4 = (e3[s3] - r3[s3]) * o3;
          if (l3 > u4) {
            const t5 = l3;
            l3 = u4, u4 = t5;
          }
          if (l3 > i3 && (i3 = l3), u4 < a4 && (a4 = u4), i3 > a4) return null;
        }
        return i3;
      }
      function Sy(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3) {
        const h3 = n3 - t4, p3 = i3 - e3, f3 = a4 - r3, d3 = s3 - t4, m2 = o3 - e3, y2 = l3 - r3, g4 = c3[1] * y2 - c3[2] * m2, x2 = c3[2] * d3 - c3[0] * y2, v2 = c3[0] * m2 - c3[1] * d3, b2 = h3 * g4 + p3 * x2 + f3 * v2;
        if (Math.abs(b2) < 1e-15) return null;
        const w2 = 1 / b2, _2 = u4[0] - t4, M2 = u4[1] - e3, A3 = u4[2] - r3, S2 = (_2 * g4 + M2 * x2 + A3 * v2) * w2;
        if (S2 < 0 || S2 > 1) return null;
        const I3 = M2 * f3 - A3 * p3, z3 = A3 * h3 - _2 * f3, P2 = _2 * p3 - M2 * h3, k2 = (c3[0] * I3 + c3[1] * z3 + c3[2] * P2) * w2;
        return k2 < 0 || S2 + k2 > 1 ? null : (d3 * I3 + m2 * z3 + y2 * P2) * w2;
      }
      function Iy(t4, e3, r3) {
        return (t4 - e3) / (r3 - e3);
      }
      function zy(t4, e3, r3, n3, i3, a4, s3, o3, l3) {
        const u4 = 1 << r3, c3 = a4 - n3, h3 = s3 - i3, p3 = (t4 + 1) / u4 * c3 + n3, f3 = (e3 + 0) / u4 * h3 + i3, d3 = (e3 + 1) / u4 * h3 + i3;
        o3[0] = (t4 + 0) / u4 * c3 + n3, o3[1] = f3, l3[0] = p3, l3[1] = d3;
      }
      class Py {
        constructor(t4) {
          if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = t4, this._siblingOffset = [[0, 0], [1, 0], [0, 1], [1, 1]], !this.dem) return;
          const e3 = function(t5) {
            const e4 = Math.ceil(Math.log2(t5.dim / 8)), r4 = [];
            let n4 = Math.ceil(Math.pow(2, e4));
            const i3 = 1 / n4, a4 = (t6, e5, r5, n5, i4) => {
              const a5 = n5 ? 1 : 0, s4 = (t6 + 1) * r5 - a5, o4 = e5 * r5, l3 = (e5 + 1) * r5 - a5;
              i4[0] = t6 * r5, i4[1] = o4, i4[2] = s4, i4[3] = l3;
            };
            let s3 = new My(n4);
            const o3 = [];
            for (let e5 = 0; e5 < n4 * n4; e5++) {
              a4(e5 % n4, Math.floor(e5 / n4), i3, false, o3);
              const r5 = Ty(o3[0], o3[1], t5), l3 = Ty(o3[2], o3[1], t5), u4 = Ty(o3[2], o3[3], t5), c3 = Ty(o3[0], o3[3], t5);
              s3.minimums.push(Math.min(r5, l3, u4, c3)), s3.maximums.push(Math.max(r5, l3, u4, c3)), s3.leaves.push(1);
            }
            for (r4.push(s3), n4 /= 2; n4 >= 1; n4 /= 2) {
              const t6 = r4[r4.length - 1];
              s3 = new My(n4);
              for (let e5 = 0; e5 < n4 * n4; e5++) {
                a4(e5 % n4, Math.floor(e5 / n4), 2, true, o3);
                const r5 = t6.getElevation(o3[0], o3[1]), i4 = t6.getElevation(o3[2], o3[1]), l3 = t6.getElevation(o3[2], o3[3]), u4 = t6.getElevation(o3[0], o3[3]), c3 = t6.isLeaf(o3[0], o3[1]), h3 = t6.isLeaf(o3[2], o3[1]), p3 = t6.isLeaf(o3[2], o3[3]), f3 = t6.isLeaf(o3[0], o3[3]), d3 = Math.min(r5.min, i4.min, l3.min, u4.min), m2 = Math.max(r5.max, i4.max, l3.max, u4.max), y2 = c3 && h3 && p3 && f3;
                s3.maximums.push(m2), s3.minimums.push(d3), s3.leaves.push(m2 - d3 <= 5 && y2 ? 1 : 0);
              }
              r4.push(s3);
            }
            return r4;
          }(this.dem), r3 = e3.length - 1, n3 = e3[r3];
          this._addNode(n3.minimums[0], n3.maximums[0], n3.leaves[0]), this._construct(e3, 0, 0, r3, 0);
        }
        raycastRoot(t4, e3, r3, n3, i3, a4, s3 = 1) {
          return Ay([t4, e3, -100], [r3, n3, this.maximums[0] * s3], i3, a4);
        }
        raycast(t4, e3, r3, n3, i3, a4, s3 = 1) {
          if (!this.nodeCount) return null;
          const o3 = this.raycastRoot(t4, e3, r3, n3, i3, a4, s3);
          if (null == o3) return null;
          const l3 = [], u4 = [], c3 = [], h3 = [], p3 = [{ idx: 0, t: o3, nodex: 0, nodey: 0, depth: 0 }];
          for (; p3.length > 0; ) {
            const { idx: o4, t: f3, nodex: d3, nodey: m2, depth: y2 } = p3.pop();
            if (this.leaves[o4]) {
              zy(d3, m2, y2, t4, e3, r3, n3, c3, h3);
              const o5 = 1 << y2, l4 = (d3 + 0) / o5, u5 = (d3 + 1) / o5, p4 = (m2 + 0) / o5, g5 = (m2 + 1) / o5, x2 = Ty(l4, p4, this.dem) * s3, v2 = Ty(u5, p4, this.dem) * s3, b2 = Ty(u5, g5, this.dem) * s3, w2 = Ty(l4, g5, this.dem) * s3, _2 = Sy(c3[0], c3[1], x2, h3[0], c3[1], v2, h3[0], h3[1], b2, i3, a4), M2 = Sy(h3[0], h3[1], b2, c3[0], h3[1], w2, c3[0], c3[1], x2, i3, a4), A3 = Math.min(null !== _2 ? _2 : Number.MAX_VALUE, null !== M2 ? M2 : Number.MAX_VALUE);
              if (A3 !== Number.MAX_VALUE) return A3;
              {
                const t5 = O.vec3.scaleAndAdd([], i3, a4, f3);
                if (ky(x2, v2, w2, b2, Iy(t5[0], c3[0], h3[0]), Iy(t5[1], c3[1], h3[1])) >= t5[2]) return f3;
              }
              continue;
            }
            let g4 = 0;
            for (let p4 = 0; p4 < this._siblingOffset.length; p4++) {
              zy((d3 << 1) + this._siblingOffset[p4][0], (m2 << 1) + this._siblingOffset[p4][1], y2 + 1, t4, e3, r3, n3, c3, h3), c3[2] = -100, h3[2] = this.maximums[this.childOffsets[o4] + p4] * s3;
              const f4 = Ay(c3, h3, i3, a4);
              if (null != f4) {
                const t5 = f4;
                l3[p4] = t5;
                let e4 = false;
                for (let r4 = 0; r4 < g4 && !e4; r4++) t5 >= l3[u4[r4]] && (u4.splice(r4, 0, p4), e4 = true);
                e4 || (u4[g4] = p4), g4++;
              }
            }
            for (let t5 = 0; t5 < g4; t5++) {
              const e4 = u4[t5];
              p3.push({ idx: this.childOffsets[o4] + e4, t: l3[e4], nodex: (d3 << 1) + this._siblingOffset[e4][0], nodey: (m2 << 1) + this._siblingOffset[e4][1], depth: y2 + 1 });
            }
          }
          return null;
        }
        _addNode(t4, e3, r3) {
          return this.minimums.push(t4), this.maximums.push(e3), this.leaves.push(r3), this.childOffsets.push(0), this.nodeCount++;
        }
        _construct(t4, e3, r3, n3, i3) {
          if (1 === t4[n3].isLeaf(e3, r3)) return;
          this.childOffsets[i3] || (this.childOffsets[i3] = this.nodeCount);
          const a4 = n3 - 1, s3 = t4[a4];
          let o3 = 0, l3 = 0;
          for (let t5 = 0; t5 < this._siblingOffset.length; t5++) {
            const n4 = 2 * e3 + this._siblingOffset[t5][0], i4 = 2 * r3 + this._siblingOffset[t5][1], a5 = s3.getElevation(n4, i4), u4 = s3.isLeaf(n4, i4), c3 = this._addNode(a5.min, a5.max, u4);
            u4 && (o3 |= 1 << t5), l3 || (l3 = c3);
          }
          for (let n4 = 0; n4 < this._siblingOffset.length; n4++) o3 & 1 << n4 || this._construct(t4, 2 * e3 + this._siblingOffset[n4][0], 2 * r3 + this._siblingOffset[n4][1], a4, l3 + n4);
        }
      }
      function ky(t4, e3, r3, n3, i3, a4) {
        return Pe(Pe(t4, r3, a4), Pe(e3, n3, a4), i3);
      }
      function Ty(t4, e3, r3) {
        const n3 = r3.dim, i3 = Q2(t4 * n3 - 0.5, 0, n3 - 1), a4 = Q2(e3 * n3 - 0.5, 0, n3 - 1), s3 = Math.floor(i3), o3 = Math.floor(a4), l3 = Math.min(s3 + 1, n3 - 1), u4 = Math.min(o3 + 1, n3 - 1);
        return ky(r3.get(s3, o3), r3.get(l3, o3), r3.get(s3, u4), r3.get(l3, u4), i3 - s3, a4 - o3);
      }
      const Ey = { mapbox: [6553.6, 25.6, 0.1, 1e4], terrarium: [256, 1, 1 / 256, 32768] };
      function By(t4, e3, r3) {
        return (256 * t4 * 256 + 256 * e3 + r3) / 10 - 1e4;
      }
      function Vy(t4, e3, r3) {
        return 256 * t4 + e3 + r3 / 256 - 32768;
      }
      class Cy {
        get tree() {
          return this._tree || this._buildQuadTree(), this._tree;
        }
        constructor(t4, e3, r3, n3 = false) {
          if (this.uid = t4, e3.height !== e3.width) throw new RangeError("DEM tiles must be square");
          if (r3 && "mapbox" !== r3 && "terrarium" !== r3) return void ft(`"${r3}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
          this.stride = e3.height;
          const i3 = this.dim = e3.height - 2, a4 = new Uint32Array(e3.data.buffer);
          if (this.pixels = new Uint8Array(e3.data.buffer), this.floatView = new Float32Array(e3.data.buffer), this.borderReady = n3, this._modifiedForSources = {}, !n3) {
            for (let t5 = 0; t5 < i3; t5++) a4[this._idx(-1, t5)] = a4[this._idx(0, t5)], a4[this._idx(i3, t5)] = a4[this._idx(i3 - 1, t5)], a4[this._idx(t5, -1)] = a4[this._idx(t5, 0)], a4[this._idx(t5, i3)] = a4[this._idx(t5, i3 - 1)];
            a4[this._idx(-1, -1)] = a4[this._idx(0, 0)], a4[this._idx(i3, -1)] = a4[this._idx(i3 - 1, 0)], a4[this._idx(-1, i3)] = a4[this._idx(0, i3 - 1)], a4[this._idx(i3, i3)] = a4[this._idx(i3 - 1, i3 - 1)];
          }
          const s3 = "terrarium" === r3 ? Vy : By;
          for (let t5 = 0; t5 < a4.length; ++t5) {
            const e4 = 4 * t5;
            this.floatView[t5] = s3(this.pixels[e4], this.pixels[e4 + 1], this.pixels[e4 + 2]);
          }
          this._timestamp = Rt.now();
        }
        _buildQuadTree() {
          this._tree = new Py(this);
        }
        get(t4, e3, r3 = false) {
          r3 && (t4 = Q2(t4, -1, this.dim), e3 = Q2(e3, -1, this.dim));
          const n3 = this._idx(t4, e3);
          return this.floatView[n3];
        }
        set(t4, e3, r3) {
          const n3 = this._idx(t4, e3), i3 = this.floatView[n3];
          return this.floatView[n3] = r3, r3 - i3;
        }
        static getUnpackVector(t4) {
          return Ey[t4];
        }
        _idx(t4, e3) {
          if (t4 < -1 || t4 >= this.dim + 1 || e3 < -1 || e3 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
          return (e3 + 1) * this.stride + (t4 + 1);
        }
        static pack(t4, e3) {
          const r3 = [0, 0, 0, 0], n3 = Cy.getUnpackVector(e3);
          let i3 = Math.floor((t4 + n3[3]) / n3[2]);
          return r3[2] = i3 % 256, i3 = Math.floor(i3 / 256), r3[1] = i3 % 256, i3 = Math.floor(i3 / 256), r3[0] = i3, r3;
        }
        getPixels() {
          return new ac({ width: this.stride, height: this.stride }, this.pixels);
        }
        backfillBorder(t4, e3, r3) {
          if (this.dim !== t4.dim) throw new Error("dem dimension mismatch");
          let n3 = e3 * this.dim, i3 = e3 * this.dim + this.dim, a4 = r3 * this.dim, s3 = r3 * this.dim + this.dim;
          switch (e3) {
            case -1:
              n3 = i3 - 1;
              break;
            case 1:
              i3 = n3 + 1;
          }
          switch (r3) {
            case -1:
              a4 = s3 - 1;
              break;
            case 1:
              s3 = a4 + 1;
          }
          const o3 = -e3 * this.dim, l3 = -r3 * this.dim;
          for (let e4 = a4; e4 < s3; e4++) for (let r4 = n3; r4 < i3; r4++) {
            const n4 = 4 * this._idx(r4, e4), i4 = 4 * this._idx(r4 + o3, e4 + l3);
            this.pixels[n4 + 0] = t4.pixels[i4 + 0], this.pixels[n4 + 1] = t4.pixels[i4 + 1], this.pixels[n4 + 2] = t4.pixels[i4 + 2], this.pixels[n4 + 3] = t4.pixels[i4 + 3];
          }
        }
        onDeserialize() {
          this._tree && (this._tree.dem = this);
        }
      }
      function Ry(t4, e3, r3) {
        1 === t4 ? e3.headerLength = r3.readFixed32() : 2 === t4 ? e3.x = r3.readVarint() : 3 === t4 ? e3.y = r3.readVarint() : 4 === t4 ? e3.z = r3.readVarint() : 5 === t4 && e3.layers.push(function(t5, e4) {
          return t5.readFields(Uy, { version: 0, name: "", units: "", tileSize: 0, buffer: 0, pixelFormat: 0, dataIndex: [] }, e4);
        }(r3, r3.readVarint() + r3.pos));
      }
      function Dy(t4, e3, r3) {
        1 === t4 ? (e3.delta_filter = function(t5, e4) {
          return t5.readFields(Ly, { blockSize: 0 }, e4);
        }(r3, r3.readVarint() + r3.pos), e3.filter = "delta_filter") : 2 === t4 ? (r3.readVarint(), e3.filter = "zigzag_filter") : 3 === t4 ? (r3.readVarint(), e3.filter = "bitshuffle_filter") : 4 === t4 && (r3.readVarint(), e3.filter = "byteshuffle_filter");
      }
      function Ly(t4, e3, r3) {
        1 === t4 && (e3.blockSize = r3.readVarint());
      }
      function Fy(t4, e3, r3) {
        1 === t4 ? (r3.readVarint(), e3.codec = "gzip_data") : 2 === t4 ? (r3.readVarint(), e3.codec = "jpeg_image") : 3 === t4 ? (r3.readVarint(), e3.codec = "webp_image") : 4 === t4 && (r3.readVarint(), e3.codec = "png_image");
      }
      function Oy(t4, e3, r3) {
        let n3 = 0, i3 = 0;
        1 === t4 ? e3.firstByte = r3.readFixed64() : 2 === t4 ? e3.lastByte = r3.readFixed64() : 3 === t4 ? e3.filters.push(function(t5, e4) {
          return t5.readFields(Dy, {}, e4);
        }(r3, r3.readVarint() + r3.pos)) : 4 === t4 ? e3.codec = function(t5, e4) {
          return t5.readFields(Fy, {}, e4);
        }(r3, r3.readVarint() + r3.pos) : 5 === t4 ? i3 = r3.readFloat() : 6 === t4 ? n3 = r3.readFloat() : 7 === t4 ? e3.bands.push(r3.readString()) : 8 === t4 ? e3.offset = r3.readDouble() : 9 === t4 && (e3.scale = r3.readDouble()), 0 === e3.offset && (e3.offset = i3), 0 === e3.scale && (e3.scale = n3);
      }
      function Uy(t4, e3, r3) {
        1 === t4 ? e3.version = r3.readVarint() : 2 === t4 ? e3.name = r3.readString() : 3 === t4 ? e3.units = r3.readString() : 4 === t4 ? e3.tileSize = r3.readVarint() : 5 === t4 ? e3.buffer = r3.readVarint() : 6 === t4 ? e3.pixelFormat = r3.readVarint() : 7 === t4 && e3.dataIndex.push(function(t5, e4) {
          return t5.readFields(Oy, { firstByte: 0, lastByte: 0, filters: [], codec: null, offset: 0, scale: 0, bands: [] }, e4);
        }(r3, r3.readVarint() + r3.pos));
      }
      function jy(t4, e3, r3) {
        if (2 === t4) !function(t5, e4, r4) {
          t5.readFields(Ny, r4, e4);
        }(r3, r3.readVarint() + r3.pos, e3);
        else if (3 === t4) throw new Error("Not implemented");
      }
      function Ny(t4, e3, r3) {
        if (1 === t4) {
          let t5 = 0;
          const n3 = r3.readVarint() + r3.pos;
          for (; r3.pos < n3; ) e3[t5++] = r3.readVarint();
        }
      }
      aa(Cy, "DEMData"), aa(Py, "DemMinMaxQuadTree", { omit: ["dem"] });
      class qy {
        constructor(t4) {
          this.capacity = t4, this.cache = /* @__PURE__ */ new Map();
        }
        get(t4) {
          if (!this.cache.has(t4)) return;
          const e3 = this.cache.get(t4);
          return this.cache.delete(t4), this.cache.set(t4, e3), e3;
        }
        put(t4, e3) {
          this.cache.has(t4) ? this.cache.delete(t4) : this.cache.size === this.capacity && this.cache.delete(this.cache.keys().next().value), this.cache.set(t4, e3);
        }
      }
      function $y(t4, e3) {
        if (4 !== e3.length) throw new Error(`Expected data of dimension 4 but got ${e3.length}.`);
        let r3 = e3[3];
        for (let n3 = 2; n3 >= 1; n3--) {
          const i3 = 1 === n3 ? 1 : 0, a4 = 2 === n3 ? 1 : 0;
          for (let n4 = 0; n4 < e3[0]; n4++) {
            const s3 = e3[1] * n4;
            for (let n5 = i3; n5 < e3[1]; n5++) {
              const i4 = e3[2] * (n5 + s3);
              for (let n6 = a4; n6 < e3[2]; n6++) {
                const a5 = e3[3] * (n6 + i4);
                for (let n7 = 0; n7 < e3[3]; n7++) {
                  const e4 = a5 + n7;
                  t4[e4] += t4[e4 - r3];
                }
              }
            }
          }
          r3 *= e3[n3];
        }
        return t4;
      }
      function Gy(t4) {
        for (let e3 = 0, r3 = t4.length; e3 < r3; e3++) t4[e3] = t4[e3] >>> 1 ^ -(1 & t4[e3]);
        return t4;
      }
      function Xy(t4, e3) {
        switch (e3) {
          case "uint32":
            return t4;
          case "uint16":
            for (let e4 = 0; e4 < t4.length; e4 += 2) {
              const r3 = t4[e4], n3 = t4[e4 + 1];
              t4[e4] = (240 & r3) >> 4 | (61440 & r3) >> 8 | (240 & n3) << 4 | 61440 & n3, t4[e4 + 1] = 15 & r3 | (3840 & r3) >> 4 | (15 & n3) << 8 | (3840 & n3) << 4;
            }
            return t4;
          case "uint8":
            for (let e4 = 0; e4 < t4.length; e4 += 4) {
              const r3 = t4[e4], n3 = t4[e4 + 1], i3 = t4[e4 + 2], a4 = t4[e4 + 3];
              t4[e4 + 0] = (192 & r3) >> 6 | (192 & n3) >> 4 | (192 & i3) >> 2 | 192 & a4, t4[e4 + 1] = (48 & r3) >> 4 | (48 & n3) >> 2 | 48 & i3 | (48 & a4) << 2, t4[e4 + 2] = (12 & r3) >> 2 | 12 & n3 | (12 & i3) << 2 | (12 & a4) << 4, t4[e4 + 3] = 3 & r3 | (3 & n3) << 2 | (3 & i3) << 4 | (3 & a4) << 6;
            }
            return t4;
          default:
            throw new Error(`Invalid pixel format, "${e3}"`);
        }
      }
      var Yy = Uint8Array, Zy = Uint16Array, Wy = Int32Array, Hy = new Yy([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), Ky = new Yy([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), Jy = new Yy([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), Qy = function(t4, e3) {
        for (var r3 = new Zy(31), n3 = 0; n3 < 31; ++n3) r3[n3] = e3 += 1 << t4[n3 - 1];
        var i3 = new Wy(r3[30]);
        for (n3 = 1; n3 < 30; ++n3) for (var a4 = r3[n3]; a4 < r3[n3 + 1]; ++a4) i3[a4] = a4 - r3[n3] << 5 | n3;
        return { b: r3, r: i3 };
      }, tg = Qy(Hy, 2), eg = tg.b, rg = tg.r;
      eg[28] = 258, rg[258] = 28;
      for (var ng = Qy(Ky, 0).b, ig = new Zy(32768), ag = 0; ag < 32768; ++ag) {
        var sg = (43690 & ag) >> 1 | (21845 & ag) << 1;
        ig[ag] = ((65280 & (sg = (61680 & (sg = (52428 & sg) >> 2 | (13107 & sg) << 2)) >> 4 | (3855 & sg) << 4)) >> 8 | (255 & sg) << 8) >> 1;
      }
      var og = function(t4, e3, r3) {
        for (var n3 = t4.length, i3 = 0, a4 = new Zy(e3); i3 < n3; ++i3) t4[i3] && ++a4[t4[i3] - 1];
        var s3, o3 = new Zy(e3);
        for (i3 = 1; i3 < e3; ++i3) o3[i3] = o3[i3 - 1] + a4[i3 - 1] << 1;
        s3 = new Zy(1 << e3);
        var l3 = 15 - e3;
        for (i3 = 0; i3 < n3; ++i3) if (t4[i3]) for (var u4 = i3 << 4 | t4[i3], c3 = e3 - t4[i3], h3 = o3[t4[i3] - 1]++ << c3, p3 = h3 | (1 << c3) - 1; h3 <= p3; ++h3) s3[ig[h3] >> l3] = u4;
        return s3;
      }, lg = new Yy(288);
      for (ag = 0; ag < 144; ++ag) lg[ag] = 8;
      for (ag = 144; ag < 256; ++ag) lg[ag] = 9;
      for (ag = 256; ag < 280; ++ag) lg[ag] = 7;
      for (ag = 280; ag < 288; ++ag) lg[ag] = 8;
      var ug = new Yy(32);
      for (ag = 0; ag < 32; ++ag) ug[ag] = 5;
      var cg = og(lg, 9), hg = og(ug, 5), pg = function(t4) {
        for (var e3 = t4[0], r3 = 1; r3 < t4.length; ++r3) t4[r3] > e3 && (e3 = t4[r3]);
        return e3;
      }, fg = function(t4, e3, r3) {
        var n3 = e3 / 8 | 0;
        return (t4[n3] | t4[n3 + 1] << 8) >> (7 & e3) & r3;
      }, dg = function(t4, e3) {
        var r3 = e3 / 8 | 0;
        return (t4[r3] | t4[r3 + 1] << 8 | t4[r3 + 2] << 16) >> (7 & e3);
      }, mg = ["unexpected EOF", "invalid block type", "invalid length/literal", "invalid distance", "stream finished", "no stream handler", , "no callback", "invalid UTF-8 data", "extra field too long", "date not in range 1980-2099", "filename too long", "stream finishing", "invalid zip data"], yg = function(t4, e3, r3) {
        var n3 = new Error(e3 || mg[t4]);
        if (n3.code = t4, Error.captureStackTrace && Error.captureStackTrace(n3, yg), !r3) throw n3;
        return n3;
      }, gg = new Yy(0), xg = "undefined" != typeof TextDecoder && new TextDecoder();
      try {
        xg.decode(gg, { stream: true });
      } catch (t4) {
      }
      const vg = { gzip_data: "gzip" };
      class bg extends Error {
        constructor(t4) {
          super(t4), this.name = "MRTError";
        }
      }
      const wg = { 0: "uint32", 1: "uint32", 2: "uint16", 3: "uint8" }, _g = { uint32: 1, uint16: 2, uint8: 4 }, Mg = { uint32: Uint32Array, uint16: Uint16Array, uint8: Uint8Array };
      let Ag;
      class Sg {
        constructor(t4 = 5) {
          this.x = NaN, this.y = NaN, this.z = NaN, this.layers = {}, this._cacheSize = t4;
        }
        getLayer(t4) {
          const e3 = this.layers[t4];
          if (!e3) throw new bg(`Layer '${t4}' not found`);
          return e3;
        }
        getHeaderLength(t4) {
          const e3 = new Uint8Array(t4), r3 = new DataView(t4);
          if (13 !== e3[0]) throw new bg("File is not a valid MRT.");
          return r3.getUint32(1, true);
        }
        parseHeader(t4) {
          const e3 = new Uint8Array(t4), r3 = this.getHeaderLength(t4);
          if (e3.length < r3) throw new bg(`Expected header with length >= ${r3} but got buffer of length ${e3.length}`);
          const n3 = function(t5, e4) {
            return t5.readFields(Ry, { headerLength: 0, x: 0, y: 0, z: 0, layers: [] }, void 0);
          }(new Ag(e3.subarray(0, r3)));
          if (!isNaN(this.x) && (this.x !== n3.x || this.y !== n3.y || this.z !== n3.z)) throw new bg(`Invalid attempt to parse header ${n3.z}/${n3.x}/${n3.y} for tile ${this.z}/${this.x}/${this.y}`);
          this.x = n3.x, this.y = n3.y, this.z = n3.z;
          for (const t5 of n3.layers) this.layers[t5.name] = new Ig(t5, { cacheSize: this._cacheSize });
          return this;
        }
        createDecodingTask(t4) {
          const e3 = [], r3 = this.getLayer(t4.layerName);
          for (let n3 of t4.blockIndices) {
            const i3 = r3.dataIndex[n3], a4 = i3.firstByte - t4.firstByte, s3 = i3.lastByte - t4.firstByte;
            if (r3._blocksInProgress.has(n3)) continue;
            const o3 = { layerName: r3.name, firstByte: a4, lastByte: s3, pixelFormat: r3.pixelFormat, blockIndex: n3, blockShape: [i3.bands.length].concat(r3.bandShape), buffer: r3.buffer, codec: i3.codec.codec, filters: i3.filters.map((t5) => t5.filter) };
            r3._blocksInProgress.add(n3), e3.push(o3);
          }
          return new zg(e3, () => {
            e3.forEach((t5) => r3._blocksInProgress.delete(t5.blockIndex));
          }, (t5, n3) => {
            if (e3.forEach((t6) => r3._blocksInProgress.delete(t6.blockIndex)), t5) throw t5;
            n3.forEach((t6) => {
              this.getLayer(t6.layerName).processDecodedData(t6);
            });
          });
        }
      }
      class Ig {
        constructor({ version: t4, name: e3, units: r3, tileSize: n3, pixelFormat: i3, buffer: a4, dataIndex: s3 }, o3) {
          if (this.version = t4, 1 !== this.version) throw new bg(`Cannot parse raster layer encoded with MRT version ${t4}`);
          this.name = e3, this.units = r3, this.tileSize = n3, this.buffer = a4, this.pixelFormat = wg[i3], this.dataIndex = s3, this.bandShape = [n3 + 2 * a4, n3 + 2 * a4, _g[this.pixelFormat]], this._decodedBlocks = new qy(o3 ? o3.cacheSize : 5), this._blocksInProgress = /* @__PURE__ */ new Set();
        }
        get dimension() {
          return _g[this.pixelFormat];
        }
        get cacheSize() {
          return this._decodedBlocks.capacity;
        }
        getBandList() {
          return this.dataIndex.map(({ bands: t4 }) => t4).flat();
        }
        processDecodedData(t4) {
          const e3 = t4.blockIndex.toString();
          this._decodedBlocks.get(e3) || this._decodedBlocks.put(e3, t4.data);
        }
        getBlockForBand(t4) {
          let e3 = 0;
          switch (typeof t4) {
            case "string":
              for (const [r3, n3] of this.dataIndex.entries()) {
                for (const [i3, a4] of n3.bands.entries()) if (a4 === t4) return { bandIndex: e3 + i3, blockIndex: r3, blockBandIndex: i3 };
                e3 += n3.bands.length;
              }
              break;
            case "number":
              for (const [r3, n3] of this.dataIndex.entries()) {
                if (t4 >= e3 && t4 < e3 + n3.bands.length) return { bandIndex: t4, blockIndex: r3, blockBandIndex: t4 - e3 };
                e3 += n3.bands.length;
              }
              break;
            default:
              throw new bg(`Invalid band \`${JSON.stringify(t4)}\`. Expected string or integer.`);
          }
          throw new bg(`Band not found: ${JSON.stringify(t4)}`);
        }
        getDataRange(t4) {
          let e3 = 1 / 0, r3 = -1 / 0;
          const n3 = [], i3 = /* @__PURE__ */ new Set();
          for (const a4 of t4) {
            const { blockIndex: t5 } = this.getBlockForBand(a4);
            if (t5 < 0) throw new bg(`Invalid band: ${JSON.stringify(a4)}`);
            const s3 = this.dataIndex[t5];
            n3.includes(t5) || n3.push(t5), i3.add(t5), e3 = Math.min(e3, s3.firstByte), r3 = Math.max(r3, s3.lastByte);
          }
          if (i3.size > this.cacheSize) throw new bg(`Number of blocks to decode (${i3.size}) exceeds cache size (${this.cacheSize}).`);
          return { layerName: this.name, firstByte: e3, lastByte: r3, blockIndices: n3 };
        }
        hasBand(t4) {
          const { blockIndex: e3 } = this.getBlockForBand(t4);
          return e3 >= 0;
        }
        hasDataForBand(t4) {
          const { blockIndex: e3 } = this.getBlockForBand(t4);
          return e3 >= 0 && !!this._decodedBlocks.get(e3.toString());
        }
        getBandView(t4) {
          const { blockIndex: e3, blockBandIndex: r3 } = this.getBlockForBand(t4), n3 = this._decodedBlocks.get(e3.toString());
          if (!n3) throw new bg(`Data for band ${JSON.stringify(t4)} of layer "${this.name}" not decoded.`);
          const i3 = this.dataIndex[e3], a4 = this.bandShape.reduce((t5, e4) => t5 * e4, 1), s3 = r3 * a4, o3 = n3.subarray(s3, s3 + a4);
          return { data: o3, bytes: new Uint8Array(o3.buffer).subarray(o3.byteOffset, o3.byteOffset + o3.byteLength), tileSize: this.tileSize, buffer: this.buffer, pixelFormat: this.pixelFormat, dimension: this.dimension, offset: i3.offset, scale: i3.scale };
        }
      }
      Sg.setPbf = function(t4) {
        Ag = t4;
      };
      class zg {
        constructor(t4, e3, r3) {
          this.tasks = t4, this._onCancel = e3, this._onComplete = r3, this._finalized = false;
        }
        cancel() {
          this._finalized || (this._onCancel(), this._finalized = true);
        }
        complete(t4, e3) {
          this._finalized || (this._onComplete(t4, e3), this._finalized = true);
        }
      }
      Sg.performDecoding = function(t4, e3) {
        const r3 = new Uint8Array(t4);
        return Promise.all(e3.tasks.map((t5) => {
          const { layerName: e4, firstByte: n3, lastByte: i3, pixelFormat: a4, blockShape: s3, blockIndex: o3, filters: l3, codec: u4 } = t5, c3 = r3.subarray(n3, i3 + 1), h3 = new Uint32Array(s3[0] * s3[1] * s3[2]);
          let p3;
          if ("gzip_data" !== u4) throw new bg(`Unhandled codec: ${u4}`);
          return p3 = function(t6, e5) {
            if (!globalThis.DecompressionStream && "gzip_data" === e5) return Promise.resolve(((a5 = function(t7) {
              31 == t7[0] && 139 == t7[1] && 8 == t7[2] || yg(6, "invalid gzip data");
              var e6 = t7[3], r5 = 10;
              4 & e6 && (r5 += 2 + (t7[10] | t7[11] << 8));
              for (var n5 = (e6 >> 3 & 1) + (e6 >> 4 & 1); n5 > 0; n5 -= !t7[r5++]) ;
              return r5 + (2 & e6);
            }(i4 = t6)) + 8 > i4.length && yg(6, "invalid gzip data"), function(t7, e6, r5, n5) {
              var i5 = t7.length;
              if (!i5 || e6.f && !e6.l) return r5 || new Yy(0);
              var a6 = !r5, s5 = a6 || 2 != e6.i, o5 = e6.i;
              a6 && (r5 = new Yy(3 * i5));
              var l4, u5, c4 = function(t8) {
                var e7 = r5.length;
                if (t8 > e7) {
                  var n6 = new Yy(Math.max(2 * e7, t8));
                  n6.set(r5), r5 = n6;
                }
              }, h4 = e6.f || 0, p4 = e6.p || 0, f3 = e6.b || 0, d3 = e6.l, m2 = e6.d, y2 = e6.m, g4 = e6.n, x2 = 8 * i5;
              do {
                if (!d3) {
                  h4 = fg(t7, p4, 1);
                  var v2 = fg(t7, p4 + 1, 3);
                  if (p4 += 3, !v2) {
                    var b2 = t7[(E3 = 4 + ((p4 + 7) / 8 | 0)) - 4] | t7[E3 - 3] << 8, w2 = E3 + b2;
                    if (w2 > i5) {
                      o5 && yg(0);
                      break;
                    }
                    s5 && c4(f3 + b2), r5.set(t7.subarray(E3, w2), f3), e6.b = f3 += b2, e6.p = p4 = 8 * w2, e6.f = h4;
                    continue;
                  }
                  if (1 == v2) d3 = cg, m2 = hg, y2 = 9, g4 = 5;
                  else if (2 == v2) {
                    var _2 = fg(t7, p4, 31) + 257, M2 = fg(t7, p4 + 10, 15) + 4, A3 = _2 + fg(t7, p4 + 5, 31) + 1;
                    p4 += 14;
                    for (var S2 = new Yy(A3), I3 = new Yy(19), z3 = 0; z3 < M2; ++z3) I3[Jy[z3]] = fg(t7, p4 + 3 * z3, 7);
                    p4 += 3 * M2;
                    var P2 = pg(I3), k2 = (1 << P2) - 1, T3 = og(I3, P2);
                    for (z3 = 0; z3 < A3; ) {
                      var E3, B4 = T3[fg(t7, p4, k2)];
                      if (p4 += 15 & B4, (E3 = B4 >> 4) < 16) S2[z3++] = E3;
                      else {
                        var V3 = 0, C3 = 0;
                        for (16 == E3 ? (C3 = 3 + fg(t7, p4, 3), p4 += 2, V3 = S2[z3 - 1]) : 17 == E3 ? (C3 = 3 + fg(t7, p4, 7), p4 += 3) : 18 == E3 && (C3 = 11 + fg(t7, p4, 127), p4 += 7); C3--; ) S2[z3++] = V3;
                      }
                    }
                    var R3 = S2.subarray(0, _2), D2 = S2.subarray(_2);
                    y2 = pg(R3), g4 = pg(D2), d3 = og(R3, y2), m2 = og(D2, g4);
                  } else yg(1);
                  if (p4 > x2) {
                    o5 && yg(0);
                    break;
                  }
                }
                s5 && c4(f3 + 131072);
                for (var L3 = (1 << y2) - 1, F3 = (1 << g4) - 1, O2 = p4; ; O2 = p4) {
                  var U3 = (V3 = d3[dg(t7, p4) & L3]) >> 4;
                  if ((p4 += 15 & V3) > x2) {
                    o5 && yg(0);
                    break;
                  }
                  if (V3 || yg(2), U3 < 256) r5[f3++] = U3;
                  else {
                    if (256 == U3) {
                      O2 = p4, d3 = null;
                      break;
                    }
                    var j2 = U3 - 254;
                    U3 > 264 && (j2 = fg(t7, p4, (1 << ($3 = Hy[z3 = U3 - 257])) - 1) + eg[z3], p4 += $3);
                    var N2 = m2[dg(t7, p4) & F3], q2 = N2 >> 4;
                    if (N2 || yg(3), p4 += 15 & N2, D2 = ng[q2], q2 > 3) {
                      var $3 = Ky[q2];
                      D2 += dg(t7, p4) & (1 << $3) - 1, p4 += $3;
                    }
                    if (p4 > x2) {
                      o5 && yg(0);
                      break;
                    }
                    s5 && c4(f3 + 131072);
                    var G2 = f3 + j2;
                    if (f3 < D2) {
                      var X2 = 0 - D2, Y2 = Math.min(D2, G2);
                      for (X2 + f3 < 0 && yg(3); f3 < Y2; ++f3) r5[f3] = (void 0)[X2 + f3];
                    }
                    for (; f3 < G2; ++f3) r5[f3] = r5[f3 - D2];
                  }
                }
                e6.l = d3, e6.p = O2, e6.b = f3, e6.f = h4, d3 && (h4 = 1, e6.m = y2, e6.d = m2, e6.n = g4);
              } while (!h4);
              return f3 != r5.length && a6 ? (l4 = r5, (null == (u5 = f3) || u5 > l4.length) && (u5 = l4.length), new Yy(l4.subarray(0, u5))) : r5.subarray(0, f3);
            }(i4.subarray(a5, -8), { i: 2 }, new Yy(((r4 = i4)[(n4 = r4.length) - 4] | r4[n4 - 3] << 8 | r4[n4 - 2] << 16 | r4[n4 - 1] << 24) >>> 0))));
            var r4, n4, i4, a5;
            const s4 = vg[e5];
            if (!s4) throw new Error(`Unhandled codec: ${e5}`);
            const o4 = new globalThis.DecompressionStream(s4);
            return new Response(new Blob([t6]).stream().pipeThrough(o4)).arrayBuffer().then((t7) => new Uint8Array(t7));
          }(c3, u4).then((t6) => (function(t7, e5) {
            t7.readFields(jy, e5);
          }(new Ag(t6), h3), new Mg[a4](h3.buffer))), p3.then((t6) => {
            for (let e5 = l3.length - 1; e5 >= 0; e5--) switch (l3[e5]) {
              case "delta_filter":
                $y(t6, s3);
                break;
              case "zigzag_filter":
                Gy(t6);
                break;
              case "bitshuffle_filter":
                Xy(t6, a4);
                break;
              default:
                throw new bg(`Unhandled filter "${l3[e5]}"`);
            }
            return { layerName: e4, blockIndex: o3, data: t6 };
          }).catch((t6) => {
            throw t6;
          });
        }));
      }, aa(zg, "MRTDecodingBatch", { omit: ["_onCancel", "_onComplete"] });
      var Pg = { workerUrl: "", workerClass: null, workerParams: void 0 };
      const kg = "mapboxgl_preloaded_worker_pool";
      class Tg {
        constructor() {
          this.active = {};
        }
        acquire(t4) {
          if (!this.workers) for (this.workers = []; this.workers.length < Tg.workerCount; ) this.workers.push(null != Pg.workerClass ? new Pg.workerClass() : new self.Worker(Pg.workerUrl, Pg.workerParams));
          return this.active[t4] = true, this.workers.slice();
        }
        release(t4) {
          delete this.active[t4], this.workers && 0 === this.numActive() && (this.workers.forEach((t5) => {
            t5.terminate();
          }), this.workers = null);
        }
        isPreloaded() {
          return !!this.active[kg];
        }
        numActive() {
          return Object.keys(this.active).length;
        }
      }
      let Eg;
      function Bg() {
        return Eg || (Eg = new Tg()), Eg;
      }
      Tg.workerCount = 2;
      let Vg, Cg, Rg, Dg, Lg, Fg = null;
      function Og() {
        return gt() && self.worker && self.worker.dracoUrl ? self.worker.dracoUrl : Cg || St.DRACO_URL;
      }
      function Ug() {
        if (gt() && self.worker && self.worker.meshoptUrl) return self.worker.meshoptUrl;
        if (Dg) return Dg;
        const t4 = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 3, 2, 0, 0, 5, 3, 1, 0, 1, 12, 1, 0, 10, 22, 2, 12, 0, 65, 0, 65, 0, 65, 0, 252, 10, 0, 0, 11, 7, 0, 65, 0, 253, 15, 26, 11]);
        if ("object" != typeof WebAssembly) throw new Error("WebAssembly not supported, cannot instantiate meshoptimizer");
        return Dg = WebAssembly.validate(t4) ? St.MESHOPT_SIMD_URL : St.MESHOPT_URL, Dg;
      }
      const jg = { 5120: Int8Array, 5121: Uint8Array, 5122: Int16Array, 5123: Uint16Array, 5125: Uint32Array, 5126: Float32Array }, Ng = { 5120: "DT_INT8", 5121: "DT_UINT8", 5122: "DT_INT16", 5123: "DT_UINT16", 5125: "DT_UINT32", 5126: "DT_FLOAT32" }, qg = { SCALAR: 1, VEC2: 2, VEC3: 3, VEC4: 4, MAT2: 4, MAT3: 9, MAT4: 16 };
      function $g(t4, e3, r3) {
        const n3 = r3.json.bufferViews.length, i3 = r3.buffers.length;
        e3.bufferView = n3, r3.json.bufferViews[n3] = { buffer: i3, byteLength: t4.byteLength }, r3.buffers[i3] = t4;
      }
      const Gg = "KHR_draco_mesh_compression";
      function Xg(t4, e3) {
        const r3 = t4.extensions && t4.extensions[Gg];
        if (!r3) return;
        const n3 = new Rg.Decoder(), i3 = Qg(e3, r3.bufferView), a4 = new Rg.Mesh();
        if (!n3.DecodeArrayToMesh(i3, i3.byteLength, a4)) throw new Error("Failed to decode Draco mesh");
        const s3 = e3.json.accessors[t4.indices], o3 = jg[s3.componentType], l3 = s3.count * o3.BYTES_PER_ELEMENT, u4 = Rg._malloc(l3);
        o3 === Uint16Array ? n3.GetTrianglesUInt16Array(a4, l3, u4) : n3.GetTrianglesUInt32Array(a4, l3, u4), $g(Rg.memory.buffer.slice(u4, u4 + l3), s3, e3), Rg._free(u4);
        for (const i4 of Object.keys(r3.attributes)) {
          const s4 = n3.GetAttributeByUniqueId(a4, r3.attributes[i4]), o4 = e3.json.accessors[t4.attributes[i4]], l4 = Ng[o4.componentType], u5 = o4.count * qg[o4.type] * jg[o4.componentType].BYTES_PER_ELEMENT, c3 = Rg._malloc(u5);
          n3.GetAttributeDataArrayForAllPoints(a4, s4, Rg[l4], u5, c3), $g(Rg.memory.buffer.slice(c3, c3 + u5), o4, e3), Rg._free(c3);
        }
        n3.destroy(), a4.destroy(), delete t4.extensions[Gg];
      }
      const Yg = "EXT_meshopt_compression";
      function Zg(t4, e3) {
        if (!t4.extensions || !t4.extensions[Yg]) return;
        const r3 = t4.extensions[Yg], n3 = new Uint8Array(e3.buffers[r3.buffer], r3.byteOffset || 0, r3.byteLength || 0), i3 = new Uint8Array(r3.count * r3.byteStride);
        Lg.decodeGltfBuffer(i3, r3.count, r3.byteStride, n3, r3.mode, r3.filter), t4.buffer = e3.buffers.length, t4.byteOffset = 0, e3.buffers[t4.buffer] = i3.buffer, delete t4.extensions[Yg];
      }
      const Wg = 1179937895, Hg = new TextDecoder("utf8");
      function Kg(t4, e3) {
        return new URL(t4, e3).href;
      }
      function Jg(t4, e3, r3, n3) {
        return fetch(Kg(t4.uri, n3)).then((t5) => t5.arrayBuffer()).then((t5) => {
          e3.buffers[r3] = t5;
        });
      }
      function Qg(t4, e3) {
        const r3 = t4.json.bufferViews[e3];
        return new Uint8Array(t4.buffers[r3.buffer], r3.byteOffset || 0, r3.byteLength);
      }
      function tx(t4, e3, r3, n3) {
        if (t4.uri) {
          const i3 = Kg(t4.uri, n3);
          return fetch(i3).then((t5) => t5.blob()).then((t5) => createImageBitmap(t5)).then((t5) => {
            e3.images[r3] = t5;
          });
        }
        if (void 0 !== t4.bufferView) {
          const n4 = Qg(e3, t4.bufferView), i3 = new Blob([n4], { type: t4.mimeType });
          return createImageBitmap(i3).then((t5) => {
            e3.images[r3] = t5;
          });
        }
      }
      function ex(t4, e3 = 0, r3) {
        const n3 = { json: null, images: [], buffers: [] };
        if (new Uint32Array(t4, e3, 1)[0] === Wg) {
          const r4 = new Uint32Array(t4, e3);
          let i4 = 2;
          const a5 = (r4[i4++] >> 2) - 3, s4 = r4[i4++] >> 2;
          if (i4++, n3.json = JSON.parse(Hg.decode(r4.subarray(i4, i4 + s4))), i4 += s4, i4 < a5) {
            const a6 = r4[i4++];
            i4++;
            const s5 = e3 + (i4 << 2);
            n3.buffers[0] = t4.slice(s5, s5 + a6);
          }
        } else n3.json = JSON.parse(Hg.decode(new Uint8Array(t4, e3)));
        const { buffers: i3, images: a4, meshes: s3, extensionsUsed: o3, bufferViews: l3 } = n3.json;
        let u4 = Promise.resolve();
        if (i3) {
          const t5 = [];
          for (let e4 = 0; e4 < i3.length; e4++) {
            const a5 = i3[e4];
            a5.uri ? t5.push(Jg(a5, n3, e4, r3)) : n3.buffers[e4] || (n3.buffers[e4] = null);
          }
          u4 = Promise.all(t5);
        }
        return u4.then(() => {
          const t5 = [], e4 = o3 && o3.includes(Gg), i4 = o3 && o3.includes(Yg);
          if (e4 && t5.push(function() {
            if (!Rg) return null != Vg ? Vg : (Vg = function(t6) {
              let e5, r4 = null;
              function n4() {
                e5 = new Uint8Array(r4.buffer);
              }
              function i5() {
                throw new Error("Unexpected Draco error.");
              }
              const a5 = { a: { a: i5, d: function(t7, r5, n5) {
                return e5.copyWithin(t7, r5, r5 + n5);
              }, c: function(t7) {
                const i6 = e5.length, a6 = Math.max(t7 >>> 0, Math.ceil(1.2 * i6)), s4 = Math.ceil((a6 - i6) / 65536);
                try {
                  return r4.grow(s4), n4(), true;
                } catch (t8) {
                  return false;
                }
              }, b: i5 } };
              return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(t6, a5) : t6.then((t7) => t7.arrayBuffer()).then((t7) => WebAssembly.instantiate(t7, a5))).then((t7) => {
                const { Rb: i6, Qb: a6, P: s4, T: o4, X: l4, Ja: u5, La: c3, Qa: h3, Va: p3, Wa: f3, eb: d3, jb: m2, f: y2, e: g4, yb: x2, zb: v2, Ab: b2, Bb: w2, Db: _2, Gb: M2 } = t7.instance.exports;
                r4 = g4;
                const A3 = /* @__PURE__ */ (() => {
                  let t8 = 0, r5 = 0, n5 = 0, s5 = 0;
                  return (o5) => {
                    n5 && (i6(s5), i6(t8), r5 += n5, n5 = t8 = 0), t8 || (r5 += 128, t8 = a6(r5));
                    const l5 = o5.length + 7 & -8;
                    let u6 = t8;
                    l5 >= r5 && (n5 = l5, u6 = s5 = a6(l5));
                    for (let t9 = 0; t9 < o5.length; t9++) e5[u6 + t9] = o5[t9];
                    return u6;
                  };
                })();
                return n4(), y2(), { memory: g4, _free: i6, _malloc: a6, Mesh: class {
                  constructor() {
                    this.ptr = s4();
                  }
                  destroy() {
                    o4(this.ptr);
                  }
                }, Decoder: class {
                  constructor() {
                    this.ptr = u5();
                  }
                  destroy() {
                    m2(this.ptr);
                  }
                  DecodeArrayToMesh(t8, e6, r5) {
                    const n5 = A3(t8), i7 = c3(this.ptr, n5, e6, r5.ptr);
                    return !!l4(i7);
                  }
                  GetAttributeByUniqueId(t8, e6) {
                    return { ptr: h3(this.ptr, t8.ptr, e6) };
                  }
                  GetTrianglesUInt16Array(t8, e6, r5) {
                    p3(this.ptr, t8.ptr, e6, r5);
                  }
                  GetTrianglesUInt32Array(t8, e6, r5) {
                    f3(this.ptr, t8.ptr, e6, r5);
                  }
                  GetAttributeDataArrayForAllPoints(t8, e6, r5, n5, i7) {
                    d3(this.ptr, t8.ptr, e6.ptr, r5, n5, i7);
                  }
                }, DT_INT8: x2(), DT_UINT8: v2(), DT_INT16: b2(), DT_UINT16: w2(), DT_UINT32: _2(), DT_FLOAT32: M2() };
              });
            }(fetch(Og())), Vg.then((t6) => {
              Rg = t6, Vg = void 0;
            }));
          }()), i4 && t5.push(function() {
            if (Lg) return;
            const t6 = function(t7) {
              let e5;
              const r4 = WebAssembly.instantiateStreaming(t7, {}).then((t8) => {
                e5 = t8.instance, e5.exports.__wasm_call_ctors();
              }), n4 = { NONE: "", OCTAHEDRAL: "meshopt_decodeFilterOct", QUATERNION: "meshopt_decodeFilterQuat", EXPONENTIAL: "meshopt_decodeFilterExp" }, i5 = { ATTRIBUTES: "meshopt_decodeVertexBuffer", TRIANGLES: "meshopt_decodeIndexBuffer", INDICES: "meshopt_decodeIndexSequence" };
              return { ready: r4, supported: true, decodeGltfBuffer(t8, r5, a5, s4, o4, l4) {
                !function(t9, e6, r6, n5, i6, a6, s5) {
                  const o5 = t9.exports.sbrk, l5 = n5 + 3 & -4, u5 = o5(l5 * i6), c3 = o5(a6.length), h3 = new Uint8Array(t9.exports.memory.buffer);
                  h3.set(a6, c3);
                  const p3 = e6(u5, n5, i6, c3, a6.length);
                  if (0 === p3 && s5 && s5(u5, l5, i6), r6.set(h3.subarray(u5, u5 + n5 * i6)), o5(u5 - o5(0)), 0 !== p3) throw new Error(`Malformed buffer data: ${p3}`);
                }(e5, e5.exports[i5[o4]], t8, r5, a5, s4, e5.exports[n4[l4]]);
              } };
            }(fetch(Ug()));
            return t6.ready.then(() => {
              Lg = t6;
            });
          }()), a4) for (let e5 = 0; e5 < a4.length; e5++) t5.push(tx(a4[e5], n3, e5, r3));
          return (t5.length ? Promise.all(t5) : Promise.resolve()).then(() => {
            if (e4 && s3) for (const { primitives: t6 } of s3) for (const e5 of t6) Xg(e5, n3);
            if (i4 && s3 && l3) for (const t6 of l3) Zg(t6, n3);
            return n3;
          });
        });
      }
      function rx(t4, e3) {
        const r3 = t4.json.bufferViews[e3.bufferView], n3 = jg[e3.componentType];
        return new n3(t4.buffers[r3.buffer], (e3.byteOffset || 0) + (r3.byteOffset || 0), e3.count * (r3.byteStride && r3.byteStride !== qg[e3.type] * n3.BYTES_PER_ELEMENT ? r3.byteStride / n3.BYTES_PER_ELEMENT : qg[e3.type]));
      }
      function nx(t4, e3, r3, n3) {
        const i3 = jg[e3.componentType], a4 = function(t5) {
          switch (t5) {
            case Int8Array:
              return 1 / 127;
            case Uint8Array:
              return 1 / 255;
            case Int16Array:
              return 1 / 32767;
            case Uint16Array:
              return 1 / 65535;
            default:
              return 1;
          }
        }(i3), s3 = t4.json.bufferViews[e3.bufferView], o3 = s3.byteStride ? s3.byteStride / i3.BYTES_PER_ELEMENT : qg[e3.type], l3 = r3.float32, u4 = l3.length / r3.capacity;
        for (let t5 = 0, r4 = 0; t5 < e3.count * o3; t5 += o3, r4 += u4) for (let e4 = 0; e4 < u4; e4++) l3[r4 + e4] = n3[t5 + e4] * a4;
        r3._trim();
      }
      function ix(t4, e3, r3) {
        const n3 = t4.indices, i3 = t4.attributes, a4 = {};
        a4.indexArray = new Cs();
        const s3 = e3.json.accessors[n3], o3 = s3.count / 3;
        a4.indexArray.reserve(o3);
        const l3 = rx(e3, s3);
        for (let t5 = 0; t5 < o3; t5++) a4.indexArray.emplaceBack(l3[3 * t5], l3[3 * t5 + 1], l3[3 * t5 + 2]);
        a4.indexArray._trim(), a4.vertexArray = new _s();
        const u4 = e3.json.accessors[i3.POSITION];
        a4.vertexArray.reserve(u4.count);
        const c3 = rx(e3, u4);
        for (let t5 = 0; t5 < u4.count; t5++) a4.vertexArray.emplaceBack(c3[3 * t5], c3[3 * t5 + 1], c3[3 * t5 + 2]);
        if (a4.vertexArray._trim(), a4.aabb = new yu(u4.min, u4.max), a4.centroid = function(t5, e4) {
          const r4 = [0, 0, 0], n4 = t5.length;
          if (n4 > 0) {
            for (let i4 = 0; i4 < n4; i4++) {
              const n5 = 3 * t5[i4];
              r4[0] += e4[n5], r4[1] += e4[n5 + 1], r4[2] += e4[n5 + 2];
            }
            r4[0] /= n4, r4[1] /= n4, r4[2] /= n4;
          }
          return r4;
        }(l3, c3), void 0 !== i3.COLOR_0) {
          const t5 = e3.json.accessors[i3.COLOR_0], r4 = qg[t5.type], n4 = rx(e3, t5);
          a4.colorArray = 3 === r4 ? new _s() : new ws(), a4.colorArray.resize(t5.count), nx(e3, t5, a4.colorArray, n4);
        }
        if (void 0 !== i3.NORMAL) {
          a4.normalArray = new _s();
          const t5 = e3.json.accessors[i3.NORMAL];
          a4.normalArray.resize(t5.count);
          const r4 = rx(e3, t5);
          nx(e3, t5, a4.normalArray, r4);
        }
        if (void 0 !== i3.TEXCOORD_0 && r3.length > 0) {
          a4.texcoordArray = new $s();
          const t5 = e3.json.accessors[i3.TEXCOORD_0];
          a4.texcoordArray.resize(t5.count);
          const r4 = rx(e3, t5);
          nx(e3, t5, a4.texcoordArray, r4);
        }
        if (void 0 !== i3._FEATURE_ID_RGBA4444) {
          const t5 = e3.json.accessors[i3._FEATURE_ID_RGBA4444];
          e3.json.extensionsUsed && e3.json.extensionsUsed.includes("EXT_meshopt_compression") && (a4.featureData = rx(e3, t5));
        }
        void 0 !== i3._FEATURE_RGBA4444 && (a4.featureData = new Uint32Array(rx(e3, e3.json.accessors[i3._FEATURE_RGBA4444]).buffer));
        const h3 = t4.material;
        return a4.material = function(t5, e4) {
          const { emissiveFactor: r4 = [0, 0, 0], alphaMode: n4 = "OPAQUE", alphaCutoff: i4 = 0.5, normalTexture: a5, occlusionTexture: s4, emissiveTexture: o4, doubleSided: l4 } = t5, { baseColorFactor: u5 = [1, 1, 1, 1], metallicFactor: c4 = 1, roughnessFactor: h4 = 1, baseColorTexture: p3, metallicRoughnessTexture: f3 } = t5.pbrMetallicRoughness || {}, d3 = s4 ? e4[s4.index] : void 0;
          if (s4 && s4.extensions && s4.extensions.KHR_texture_transform && d3) {
            const t6 = s4.extensions.KHR_texture_transform;
            d3.offsetScale = [t6.offset[0], t6.offset[1], t6.scale[0], t6.scale[1]];
          }
          return { pbrMetallicRoughness: { baseColorFactor: new Ie(...u5), metallicFactor: c4, roughnessFactor: h4, baseColorTexture: p3 ? e4[p3.index] : void 0, metallicRoughnessTexture: f3 ? e4[f3.index] : void 0 }, doubleSided: l4, emissiveFactor: r4, alphaMode: n4, alphaCutoff: i4, normalTexture: a5 ? e4[a5.index] : void 0, occlusionTexture: d3, emissionTexture: o4 ? e4[o4.index] : void 0, defined: void 0 === t5.defined };
        }(void 0 !== h3 ? e3.json.materials[h3] : { defined: false }, r3), a4;
      }
      function ax(t4, e3, r3) {
        const { matrix: n3, rotation: i3, translation: a4, scale: s3, mesh: o3, extras: l3, children: u4 } = t4, c3 = {};
        if (c3.matrix = n3 || O.mat4.fromRotationTranslationScale([], i3 || [0, 0, 0, 1], a4 || [0, 0, 0], s3 || [1, 1, 1]), void 0 !== o3) {
          c3.meshes = r3[o3];
          const t5 = c3.anchor = [0, 0];
          for (const e4 of c3.meshes) {
            const { min: r4, max: n4 } = e4.aabb;
            t5[0] += r4[0] + n4[0], t5[1] += r4[1] + n4[1];
          }
          t5[0] = Math.floor(t5[0] / c3.meshes.length / 2), t5[1] = Math.floor(t5[1] / c3.meshes.length / 2);
        }
        if (l3 && (l3.id && (c3.id = l3.id), l3.lights && (c3.lights = function(t5) {
          if (!t5.length) return [];
          const e4 = function(t6) {
            const e5 = atob(t6), r5 = new Uint8Array(e5.length);
            for (let t7 = 0; t7 < e5.length; t7++) r5[t7] = e5.codePointAt(t7);
            return r5;
          }(t5), r4 = [], n4 = e4.length / 24, i4 = new Uint16Array(e4.buffer), a5 = new Float32Array(e4.buffer);
          for (let t6 = 0; t6 < n4; t6++) {
            const e5 = i4[2 * t6 * 6] / 30, n5 = i4[2 * t6 * 6 + 1] / 30, s4 = i4[2 * t6 * 6 + 10] / 100, o4 = a5[6 * t6 + 1], l4 = a5[6 * t6 + 2], u5 = a5[6 * t6 + 3], c4 = a5[6 * t6 + 4], h3 = u5 - o4, p3 = c4 - l4, f3 = Math.hypot(h3, p3);
            r4.push({ pos: [o4 + 0.5 * h3, l4 + 0.5 * p3, n5], normal: [p3 / f3, -h3 / f3, 0], width: f3, height: e5, depth: s4, points: [o4, l4, u5, c4] });
          }
          return r4;
        }(l3.lights))), u4) {
          const t5 = [];
          for (const n4 of u4) t5.push(ax(e3.json.nodes[n4], e3, r3));
          c3.children = t5;
        }
        return c3;
      }
      function sx(t4) {
        if (0 === t4.vertices.length || 0 === t4.indices.length) return null;
        const e3 = new qc(t4.vertices, t4.indices, 8, 256), [r3, n3] = [e3.min.clone(), e3.max.clone()];
        return { vertices: t4.vertices, indices: t4.indices, grid: e3, min: r3, max: n3 };
      }
      function ox(t4) {
        if (!t4.extras || !t4.extras.ground) return null;
        const e3 = t4.extras.ground;
        if (!e3 || !Array.isArray(e3) || 0 === e3.length) return null;
        const r3 = e3[0];
        if (!r3 || !Array.isArray(r3) || 0 === r3.length) return null;
        const n3 = [];
        for (const t5 of r3) {
          if (!Array.isArray(t5) || 2 !== t5.length) continue;
          const e4 = t5[0], r4 = t5[1];
          "number" == typeof e4 && "number" == typeof r4 && n3.push(new q(e4, r4));
        }
        if (n3.length < 3) return null;
        n3.length > 1 && n3[n3.length - 1].equals(n3[0]) && n3.pop();
        let i3 = 0;
        for (let t5 = 0; t5 < n3.length; t5++) {
          const e4 = n3[t5], r4 = n3[(t5 + 1) % n3.length], a5 = n3[(t5 + 2) % n3.length];
          i3 += (e4.x - r4.x) * (a5.y - r4.y) - (a5.x - r4.x) * (e4.y - r4.y);
        }
        i3 > 0 && n3.reverse();
        const a4 = uc(n3.flatMap((t5) => [t5.x, t5.y]), []);
        return 0 === a4.length ? null : { vertices: n3, indices: a4 };
      }
      function lx(t4, e3) {
        const r3 = [], n3 = [];
        let i3 = 0;
        const a4 = [];
        for (const s3 of t4) {
          i3 = r3.length;
          const t5 = s3.vertexArray.float32, o3 = s3.indexArray.uint16;
          for (let n4 = 0; n4 < s3.vertexArray.length; n4++) a4[0] = t5[3 * n4 + 0], a4[1] = t5[3 * n4 + 1], a4[2] = t5[3 * n4 + 2], O.vec3.transformMat4(a4, a4, e3), r3.push(new q(a4[0], a4[1]));
          for (let t6 = 0; t6 < 3 * s3.indexArray.length; t6++) n3.push(o3[t6] + i3);
        }
        if (n3.length % 3 != 0) return null;
        for (let t5 = 0; t5 < n3.length; t5 += 3) {
          const e4 = r3[n3[t5 + 0]], i4 = r3[n3[t5 + 1]], a5 = r3[n3[t5 + 2]];
          (e4.x - i4.x) * (a5.y - i4.y) - (a5.x - i4.x) * (e4.y - i4.y) > 0 && ([n3[t5 + 1], n3[t5 + 2]] = [n3[t5 + 2], n3[t5 + 1]]);
        }
        return { vertices: r3, indices: n3 };
      }
      function ux(t4) {
        const e3 = function(t5, e4) {
          const r4 = [], n4 = WebGL2RenderingContext;
          if (t5.json.textures) for (const i4 of t5.json.textures) {
            const a5 = { magFilter: n4.LINEAR, minFilter: n4.NEAREST, wrapS: n4.REPEAT, wrapT: n4.REPEAT };
            void 0 !== i4.sampler && Object.assign(a5, t5.json.samplers[i4.sampler]), r4.push({ image: e4[i4.source], sampler: a5, uploaded: false });
          }
          return r4;
        }(t4, t4.images), r3 = function(t5, e4) {
          const r4 = [];
          for (const n4 of t5.json.meshes) {
            const i4 = [];
            for (const r5 of n4.primitives) i4.push(ix(r5, t5, e4));
            r4.push(i4);
          }
          return r4;
        }(t4, e3), { scenes: n3, scene: i3, nodes: a4 } = t4.json, s3 = n3 ? n3[i3 || 0].nodes : a4, o3 = [];
        for (const e4 of s3) o3.push(ax(a4[e4], t4, r3));
        return function(t5, e4, r4) {
          const n4 = {}, i4 = /* @__PURE__ */ new Set();
          for (let a5 = 0; a5 < t5.length; a5++) {
            const t6 = r4[e4[a5]];
            if (!t6.extras) continue;
            const s4 = t6.extras["mapbox:footprint:version"], o4 = t6.extras["mapbox:footprint:id"];
            (s4 || o4) && i4.add(a5), "1.0.0" === s4 && o4 && (n4[o4] = a5);
          }
          for (let a5 = 0; a5 < t5.length; a5++) {
            if (i4.has(a5)) continue;
            const s4 = t5[a5], o4 = r4[e4[a5]];
            if (!o4.extras) continue;
            let l3 = null;
            s4.id in n4 && (l3 = lx(t5[n4[s4.id]].meshes, s4.matrix)), l3 || (l3 = ox(o4)), l3 && (s4.footprint = sx(l3));
          }
          if (i4.size > 0) {
            const e5 = Array.from(i4.values()).sort((t6, e6) => t6 - e6);
            for (let r5 = e5.length - 1; r5 >= 0; r5--) t5.splice(e5[r5], 1);
          }
        }(o3, s3, t4.json.nodes), o3;
      }
      function cx(t4) {
        t4.heightmap = new Float32Array(4096), t4.heightmap.fill(-1);
        const e3 = t4.vertexArray.float32, r3 = t4.aabb.min[0] - 1, n3 = t4.aabb.min[1] - 1, i3 = Hm / (t4.aabb.max[0] - r3 + 2), a4 = Hm / (t4.aabb.max[1] - n3 + 2);
        for (let s3 = 0; s3 < e3.length; s3 += 3) {
          const o3 = e3[s3 + 2], l3 = (e3[s3 + 0] - r3) * i3 | 0, u4 = (e3[s3 + 1] - n3) * a4 | 0;
          o3 > t4.heightmap[u4 * Hm + l3] && (t4.heightmap[u4 * Hm + l3] = o3);
        }
      }
      function hx(t4, e3) {
        const r3 = {};
        r3.indexArray = new Cs(), r3.indexArray.reserve(4 * t4.length), r3.vertexArray = new _s(), r3.vertexArray.reserve(10 * t4.length), r3.colorArray = new ws(), r3.vertexArray.reserve(10 * t4.length);
        let n3 = 0;
        for (const i4 of t4) {
          const t5 = Math.min(10, Math.max(4, 1.3 * i4.height)) * e3, a5 = [-i4.normal[1], i4.normal[0], 0], s3 = Math.min(0.29, 0.1 * i4.width / i4.depth), o3 = i4.width - 2 * i4.depth * e3 * (s3 + 0.01), l3 = O.vec3.scaleAndAdd([], i4.pos, a5, o3 / 2), u4 = O.vec3.scaleAndAdd([], i4.pos, a5, -o3 / 2), c3 = [l3[0], l3[1], l3[2] + i4.height], h3 = [u4[0], u4[1], u4[2] + i4.height], p3 = O.vec3.scaleAndAdd([], i4.normal, a5, s3);
          O.vec3.scale(p3, p3, t5);
          const f3 = O.vec3.scaleAndAdd([], i4.normal, a5, -s3);
          O.vec3.scale(f3, f3, t5), O.vec3.add(p3, l3, p3), O.vec3.add(f3, u4, f3), l3[2] += 0.1, u4[2] += 0.1, r3.vertexArray.emplaceBack(p3[0], p3[1], p3[2]), r3.vertexArray.emplaceBack(f3[0], f3[1], f3[2]), r3.vertexArray.emplaceBack(l3[0], l3[1], l3[2]), r3.vertexArray.emplaceBack(u4[0], u4[1], u4[2]), r3.vertexArray.emplaceBack(c3[0], c3[1], c3[2]), r3.vertexArray.emplaceBack(h3[0], h3[1], h3[2]), r3.vertexArray.emplaceBack(l3[0], l3[1], l3[2]), r3.vertexArray.emplaceBack(u4[0], u4[1], u4[2]), r3.vertexArray.emplaceBack(p3[0], p3[1], p3[2]), r3.vertexArray.emplaceBack(f3[0], f3[1], f3[2]);
          const d3 = o3 / t5 / 2;
          r3.colorArray.emplaceBack(-d3 - s3, -1, d3, 0.8), r3.colorArray.emplaceBack(d3 + s3, -1, d3, 0.8), r3.colorArray.emplaceBack(-d3, 0, d3, 1.3), r3.colorArray.emplaceBack(d3, 0, d3, 1.3), r3.colorArray.emplaceBack(d3 + s3, -0.8, d3, 0.7), r3.colorArray.emplaceBack(d3 + s3, -0.8, d3, 0.7), r3.colorArray.emplaceBack(0, 0, d3, 1.3), r3.colorArray.emplaceBack(0, 0, d3, 1.3), r3.colorArray.emplaceBack(d3 + s3, -1.2, d3, 0.8), r3.colorArray.emplaceBack(d3 + s3, -1.2, d3, 0.8), r3.indexArray.emplaceBack(6 + n3, 4 + n3, 8 + n3), r3.indexArray.emplaceBack(7 + n3, 9 + n3, 5 + n3), r3.indexArray.emplaceBack(0 + n3, 1 + n3, 2 + n3), r3.indexArray.emplaceBack(1 + n3, 3 + n3, 2 + n3), n3 += 10;
        }
        const i3 = { defined: true, emissiveFactor: [0, 0, 0] }, a4 = {};
        return a4.baseColorFactor = Ie.white, i3.pbrMetallicRoughness = a4, r3.material = i3, r3.aabb = new yu([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), r3;
      }
      class px2 {
        constructor(t4) {
          this._stringToNumber = {}, this._numberToString = [];
          for (let e3 = 0; e3 < t4.length; e3++) {
            const r3 = t4[e3];
            this._stringToNumber[r3] = e3, this._numberToString[e3] = r3;
          }
        }
        encode(t4) {
          return this._stringToNumber[t4];
        }
        decode(t4) {
          return this._numberToString[t4];
        }
      }
      class fx {
        constructor(t4, e3) {
          this.tileID = t4, this.x = t4.canonical.x, this.y = t4.canonical.y, this.z = t4.canonical.z, this.grid = new na(Wr, 16, 0), this.featureIndexArray = new io(), this.promoteId = e3, this.is3DTile = false, this.serializedLayersCache = /* @__PURE__ */ new Map();
        }
        insert(t4, e3, r3, n3, i3, a4 = 0, s3 = 0) {
          const o3 = this.featureIndexArray.length;
          this.featureIndexArray.emplaceBack(r3, n3, i3, a4);
          const l3 = this.grid;
          for (let t5 = 0; t5 < e3.length; t5++) {
            const r4 = e3[t5], n4 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
            for (let t6 = 0; t6 < r4.length; t6++) {
              const e4 = r4[t6];
              n4[0] = Math.min(n4[0], e4.x), n4[1] = Math.min(n4[1], e4.y), n4[2] = Math.max(n4[2], e4.x), n4[3] = Math.max(n4[3], e4.y);
            }
            0 !== s3 && (n4[0] -= s3, n4[1] -= s3, n4[2] += s3, n4[3] += s3), n4[0] < Wr && n4[1] < Wr && n4[2] >= 0 && n4[3] >= 0 && l3.insert(o3, n4[0], n4[1], n4[2], n4[3]);
          }
        }
        loadVTLayers() {
          if (!this.vtLayers) {
            this.vtLayers = new ch.VectorTile(new lf(this.rawTileData)).layers, this.sourceLayerCoder = new px2(this.vtLayers ? Object.keys(this.vtLayers).sort() : ["_geojsonTileLayer"]), this.vtFeatures = {};
            for (const t4 in this.vtLayers) this.vtFeatures[t4] = [];
          }
          return this.vtLayers;
        }
        query(t4, e3, r3) {
          this.loadVTLayers(), this.serializedLayersCache.clear();
          const n3 = Za(t4.filter), i3 = t4.tileResult, a4 = t4.transform, s3 = i3.bufferedTilespaceBounds, o3 = this.grid.query(s3.min.x, s3.min.y, s3.max.x, s3.max.y, (t5, e4, r4, n4) => jl(i3.bufferedTilespaceGeometry, t5, e4, r4, n4));
          o3.sort(mx);
          let l3 = null;
          a4.elevation && o3.length > 0 && (l3 = iy.create(a4.elevation, this.tileID));
          const u4 = {};
          let c3;
          for (let s4 = 0; s4 < o3.length; s4++) {
            const h3 = o3[s4];
            if (h3 === c3) continue;
            c3 = h3;
            const p3 = this.featureIndexArray.get(h3);
            let f3 = null;
            if (this.is3DTile) {
              const t5 = this.bucketLayerIDs[0][0], r4 = e3[t5];
              if ("model" !== r4.type) continue;
              const { queryFeature: s5, intersectionZ: o4 } = r4.queryIntersectsMatchingFeature(i3, p3.featureIndex, n3, a4);
              s5 && this.appendToResult(u4, t5, p3.featureIndex, s5, o4);
            } else this.loadMatchingFeature(u4, p3, n3, t4.layers, t4.availableImages, e3, r3, (e4, r4, n4, a5 = 0) => (f3 || (f3 = Il(e4, this.tileID.canonical, t4.tileTransform)), r4.queryIntersectsFeature(i3, e4, n4, f3, this.z, t4.transform, t4.pixelPosMatrix, l3, a5)));
          }
          return u4;
        }
        loadMatchingFeature(t4, e3, r3, n3, i3, a4, s3, o3) {
          const { featureIndex: l3, bucketIndex: u4, sourceLayerIndex: c3, layoutVertexArrayOffset: h3 } = e3, p3 = this.bucketLayerIDs[u4];
          if (n3.length && !function(t5, e4) {
            for (let r4 = 0; r4 < t5.length; r4++) if (e4.indexOf(t5[r4]) >= 0) return true;
            return false;
          }(n3, p3)) return;
          const f3 = this.sourceLayerCoder.decode(c3), d3 = this.vtLayers[f3].feature(l3);
          if (r3.needGeometry) {
            const t5 = zl(d3, true);
            if (!r3.filter(new Ea(this.tileID.overscaledZ), t5, this.tileID.canonical)) return;
          } else if (!r3.filter(new Ea(this.tileID.overscaledZ), d3)) return;
          const m2 = this.getId(d3, f3);
          for (let e4 = 0; e4 < p3.length; e4++) {
            const r4 = p3[e4];
            if (n3.length && n3.indexOf(r4) < 0) continue;
            const u5 = a4[r4];
            if (!u5) continue;
            let c4 = {};
            void 0 !== m2 && s3 && (c4 = s3.getState(u5.sourceLayer || "_geojsonTileLayer", m2));
            const f4 = !o3 || o3(d3, u5, c4, h3);
            if (!f4) continue;
            const y2 = new yy(d3, this.z, this.x, this.y, m2);
            let g4 = this.serializedLayersCache.get(r4);
            g4 || (g4 = u5.serialize(), g4.id = r4, this.serializedLayersCache.set(r4, g4)), y2.layer = nt({}, g4), y2.tile = this.tileID.canonical, y2.layer.paint = dx(g4.paint, u5.paint, d3, c4, i3), y2.layer.layout = dx(g4.layout, u5.layout, d3, c4, i3), this.appendToResult(t4, r4, l3, y2, f4);
          }
        }
        appendToResult(t4, e3, r3, n3, i3) {
          let a4 = t4[e3];
          void 0 === a4 && (a4 = t4[e3] = []), a4.push({ featureIndex: r3, feature: n3, intersectionZ: i3 });
        }
        lookupSymbolFeatures(t4, e3, r3, n3, i3, a4, s3) {
          const o3 = {};
          this.loadVTLayers();
          const l3 = Za(n3);
          for (const n4 of t4) this.loadMatchingFeature(o3, { bucketIndex: e3, sourceLayerIndex: r3, featureIndex: n4, layoutVertexArrayOffset: 0 }, l3, i3, a4, s3);
          return o3;
        }
        loadFeature(t4) {
          const { featureIndex: e3, sourceLayerIndex: r3 } = t4;
          this.loadVTLayers();
          const n3 = this.sourceLayerCoder.decode(r3), i3 = this.vtFeatures[n3];
          if (i3[e3]) return i3[e3];
          const a4 = this.vtLayers[n3].feature(e3);
          return i3[e3] = a4, a4;
        }
        hasLayer(t4) {
          for (const e3 of this.bucketLayerIDs) for (const r3 of e3) if (t4 === r3) return true;
          return false;
        }
        getId(t4, e3) {
          let r3 = t4.id;
          if (this.promoteId) {
            const n3 = "string" == typeof this.promoteId ? this.promoteId : this.promoteId[e3];
            null != n3 && (r3 = t4.properties[n3]), "boolean" == typeof r3 && (r3 = Number(r3));
          }
          return r3;
        }
      }
      function dx(t4, e3, r3, n3, i3) {
        return ut(t4, (t5, a4) => {
          const s3 = e3 instanceof Oa ? e3.get(a4) : null;
          return s3 && s3.evaluate ? s3.evaluate(r3, n3, i3) : s3;
        });
      }
      function mx(t4, e3) {
        return e3 - t4;
      }
      aa(fx, "FeatureIndex", { omit: ["rawTileData", "sourceLayerCoder"] });
      const yx = [Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
      class gx {
        static from(t4) {
          if (!(t4 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
          const [e3, r3] = new Uint8Array(t4, 0, 2);
          if (219 !== e3) throw new Error("Data does not appear to be in a KDBush format.");
          const n3 = r3 >> 4;
          if (1 !== n3) throw new Error(`Got v${n3} data when expected v1.`);
          const i3 = yx[15 & r3];
          if (!i3) throw new Error("Unrecognized array type.");
          const [a4] = new Uint16Array(t4, 2, 1), [s3] = new Uint32Array(t4, 4, 1);
          return new gx(s3, a4, i3, t4);
        }
        constructor(t4, e3 = 64, r3 = Float64Array, n3) {
          if (isNaN(t4) || t4 < 0) throw new Error(`Unpexpected numItems value: ${t4}.`);
          this.numItems = +t4, this.nodeSize = Math.min(Math.max(+e3, 2), 65535), this.ArrayType = r3, this.IndexArrayType = t4 < 65536 ? Uint16Array : Uint32Array;
          const i3 = yx.indexOf(this.ArrayType), a4 = 2 * t4 * this.ArrayType.BYTES_PER_ELEMENT, s3 = t4 * this.IndexArrayType.BYTES_PER_ELEMENT, o3 = (8 - s3 % 8) % 8;
          if (i3 < 0) throw new Error(`Unexpected typed array class: ${r3}.`);
          n3 && n3 instanceof ArrayBuffer ? (this.data = n3, this.ids = new this.IndexArrayType(this.data, 8, t4), this.coords = new this.ArrayType(this.data, 8 + s3 + o3, 2 * t4), this._pos = 2 * t4, this._finished = true) : (this.data = new ArrayBuffer(8 + a4 + s3 + o3), this.ids = new this.IndexArrayType(this.data, 8, t4), this.coords = new this.ArrayType(this.data, 8 + s3 + o3, 2 * t4), this._pos = 0, this._finished = false, new Uint8Array(this.data, 0, 2).set([219, 16 + i3]), new Uint16Array(this.data, 2, 1)[0] = e3, new Uint32Array(this.data, 4, 1)[0] = t4);
        }
        add(t4, e3) {
          const r3 = this._pos >> 1;
          return this.ids[r3] = r3, this.coords[this._pos++] = t4, this.coords[this._pos++] = e3, r3;
        }
        finish() {
          const t4 = this._pos >> 1;
          if (t4 !== this.numItems) throw new Error(`Added ${t4} items when expected ${this.numItems}.`);
          return xx(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = true, this;
        }
        range(t4, e3, r3, n3) {
          if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
          const { ids: i3, coords: a4, nodeSize: s3 } = this, o3 = [0, i3.length - 1, 0], l3 = [];
          for (; o3.length; ) {
            const u4 = o3.pop() || 0, c3 = o3.pop() || 0, h3 = o3.pop() || 0;
            if (c3 - h3 <= s3) {
              for (let s4 = h3; s4 <= c3; s4++) {
                const o4 = a4[2 * s4], u5 = a4[2 * s4 + 1];
                o4 >= t4 && o4 <= r3 && u5 >= e3 && u5 <= n3 && l3.push(i3[s4]);
              }
              continue;
            }
            const p3 = h3 + c3 >> 1, f3 = a4[2 * p3], d3 = a4[2 * p3 + 1];
            f3 >= t4 && f3 <= r3 && d3 >= e3 && d3 <= n3 && l3.push(i3[p3]), (0 === u4 ? t4 <= f3 : e3 <= d3) && (o3.push(h3), o3.push(p3 - 1), o3.push(1 - u4)), (0 === u4 ? r3 >= f3 : n3 >= d3) && (o3.push(p3 + 1), o3.push(c3), o3.push(1 - u4));
          }
          return l3;
        }
        within(t4, e3, r3) {
          if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
          const { ids: n3, coords: i3, nodeSize: a4 } = this, s3 = [0, n3.length - 1, 0], o3 = [], l3 = r3 * r3;
          for (; s3.length; ) {
            const u4 = s3.pop() || 0, c3 = s3.pop() || 0, h3 = s3.pop() || 0;
            if (c3 - h3 <= a4) {
              for (let r4 = h3; r4 <= c3; r4++) _x2(i3[2 * r4], i3[2 * r4 + 1], t4, e3) <= l3 && o3.push(n3[r4]);
              continue;
            }
            const p3 = h3 + c3 >> 1, f3 = i3[2 * p3], d3 = i3[2 * p3 + 1];
            _x2(f3, d3, t4, e3) <= l3 && o3.push(n3[p3]), (0 === u4 ? t4 - r3 <= f3 : e3 - r3 <= d3) && (s3.push(h3), s3.push(p3 - 1), s3.push(1 - u4)), (0 === u4 ? t4 + r3 >= f3 : e3 + r3 >= d3) && (s3.push(p3 + 1), s3.push(c3), s3.push(1 - u4));
          }
          return o3;
        }
      }
      function xx(t4, e3, r3, n3, i3, a4) {
        if (i3 - n3 <= r3) return;
        const s3 = n3 + i3 >> 1;
        vx(t4, e3, s3, n3, i3, a4), xx(t4, e3, r3, n3, s3 - 1, 1 - a4), xx(t4, e3, r3, s3 + 1, i3, 1 - a4);
      }
      function vx(t4, e3, r3, n3, i3, a4) {
        for (; i3 > n3; ) {
          if (i3 - n3 > 600) {
            const s4 = i3 - n3 + 1, o4 = r3 - n3 + 1, l4 = Math.log(s4), u4 = 0.5 * Math.exp(2 * l4 / 3), c3 = 0.5 * Math.sqrt(l4 * u4 * (s4 - u4) / s4) * (o4 - s4 / 2 < 0 ? -1 : 1);
            vx(t4, e3, r3, Math.max(n3, Math.floor(r3 - o4 * u4 / s4 + c3)), Math.min(i3, Math.floor(r3 + (s4 - o4) * u4 / s4 + c3)), a4);
          }
          const s3 = e3[2 * r3 + a4];
          let o3 = n3, l3 = i3;
          for (bx(t4, e3, n3, r3), e3[2 * i3 + a4] > s3 && bx(t4, e3, n3, i3); o3 < l3; ) {
            for (bx(t4, e3, o3, l3), o3++, l3--; e3[2 * o3 + a4] < s3; ) o3++;
            for (; e3[2 * l3 + a4] > s3; ) l3--;
          }
          e3[2 * n3 + a4] === s3 ? bx(t4, e3, n3, l3) : (l3++, bx(t4, e3, l3, i3)), l3 <= r3 && (n3 = l3 + 1), r3 <= l3 && (i3 = l3 - 1);
        }
      }
      function bx(t4, e3, r3, n3) {
        wx(t4, r3, n3), wx(e3, 2 * r3, 2 * n3), wx(e3, 2 * r3 + 1, 2 * n3 + 1);
      }
      function wx(t4, e3, r3) {
        const n3 = t4[e3];
        t4[e3] = t4[r3], t4[r3] = n3;
      }
      function _x2(t4, e3, r3, n3) {
        const i3 = t4 - r3, a4 = e3 - n3;
        return i3 * i3 + a4 * a4;
      }
      t3.$ = Ca, t3.A = class extends qm {
      }, t3.B = cr, t3.C = Ee, t3.D = Ga, t3.E = _e, t3.F = Li, t3.G = Ci, t3.H = Di, t3.I = Uf, t3.J = Yi, t3.K = Xa, t3.L = Ki, t3.M = Zi2, t3.N = En, t3.O = Vn, t3.P = q, t3.Q = Tn, t3.R = te2, t3.S = mr, t3.T = um, t3.U = Se, t3.V = qm, t3.W = Ya, t3.X = Fi, t3.Y = Ri, t3.Z = function(t4) {
        const e3 = t4.value;
        let r3 = [];
        if (!e3) return r3;
        const n3 = cr(e3);
        return "string" !== n3 ? (r3 = r3.concat([new qm(t4.key, e3, `string expected, "${n3}" found`)]), r3) : ($m(e3, true) || (r3 = r3.concat([new qm(t4.key, e3, `invalid url "${e3}"`)])), r3);
      }, t3._ = $a, t3.a = function(t4) {
        return St.API_CDN_URL_REGEX.test(t4);
      }, t3.a$ = ys, t3.a0 = qa, t3.a1 = Ua, t3.a2 = class {
        constructor(t4) {
          this.specification = t4;
        }
        possiblyEvaluate(t4, e3) {
          return yt2(t4.expression.evaluate(e3));
        }
        interpolate(t4, e3, r3) {
          return { x: Pe(t4.x, e3.x, r3), y: Pe(t4.y, e3.y, r3), z: Pe(t4.z, e3.z, r3), azimuthal: Pe(t4.azimuthal, e3.azimuthal, r3), polar: Pe(t4.polar, e3.polar, r3) };
        }
      }, t3.a3 = Ea, t3.a4 = Hi, t3.a5 = xl, t3.a6 = O, t3.a7 = tt, t3.a8 = Oa, t3.a9 = Du, t3.aA = ru, t3.aB = ym, t3.aC = _m, t3.aD = dm, t3.aE = function(t4, e3) {
        const r3 = document.createElement("video");
        r3.muted = true, r3.onloadstart = function() {
          e3(null, r3);
        };
        for (let e4 = 0; e4 < t4.length; e4++) {
          const n3 = document.createElement("source");
          ae2(t4[e4]) || (r3.crossOrigin = "Anonymous"), n3.src = t4[e4], r3.appendChild(n3);
        }
        return { cancel: () => {
        } };
      }, t3.aF = cm, t3.aG = function(t4) {
        return fetch(t4).then((t5) => t5.arrayBuffer()).then((e3) => ex(e3, 0, t4));
      }, t3.aH = ux, t3.aI = class {
        constructor(t4, e3, r3, n3) {
          this.id = t4, this.position = null != e3 ? new rl(e3[0], e3[1]) : new rl(0, 0), this.orientation = null != r3 ? r3 : [0, 0, 0], this.nodes = n3, this.uploaded = false, this.aabb = new yu([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), this.matrix = [];
        }
        _applyTransformations(t4, e3) {
          if (O.mat4.multiply(t4.matrix, e3, t4.matrix), t4.meshes) for (const e4 of t4.meshes) {
            const r3 = yu.applyTransformFast(e4.aabb, t4.matrix);
            this.aabb.encapsulate(r3);
          }
          if (t4.children) for (const e4 of t4.children) this._applyTransformations(e4, t4.matrix);
        }
        computeBoundsAndApplyParent() {
          const t4 = O.mat4.identity([]);
          for (const e3 of this.nodes) this._applyTransformations(e3, t4);
        }
        computeModelMatrix(t4, e3, r3, n3, i3, a4, s3 = false) {
          Jm(this.matrix, this, t4.transform, this.position, e3, r3, n3, i3, a4, s3);
        }
        upload(t4) {
          if (!this.uploaded) {
            for (const e3 of this.nodes) ey(e3, t4);
            for (const t5 of this.nodes) ry(t5);
            this.uploaded = true;
          }
        }
        destroy() {
          for (const t4 of this.nodes) ny(t4);
        }
      }, t3.aJ = ot, t3.aK = function(t4) {
        return t4.indexOf(ss) >= 0;
      }, t3.aL = gd, t3.aM = cl, t3.aN = hl, t3.aO = xs, t3.aP = Cs, t3.aQ = at, t3.aR = Hs, t3.aS = Wd, t3.aT = function() {
        Ta.isLoading() || Ta.isLoaded() || "deferred" !== Pa() || ka();
      }, t3.aU = Za, t3.aV = zl, t3.aW = yy, t3.aX = xt2, t3.aY = wp, t3.aZ = Fc, t3.a_ = Il, t3.aa = Pe, t3.ab = Wr, t3.ac = ke, t3.ad = class {
        constructor(t4) {
          this.specification = t4;
        }
        possiblyEvaluate(t4, e3) {
          return function([t5, e4]) {
            const r3 = yt2([1, t5, e4]);
            return { x: r3.x, y: r3.y, z: r3.z };
          }(t4.expression.evaluate(e3));
        }
        interpolate(t4, e3, r3) {
          return { x: Pe(t4.x, e3.x, r3), y: Pe(t4.y, e3.y, r3), z: Pe(t4.z, e3.z, r3) };
        }
      }, t3.ae = function(t4, e3, r3 = 0, n3 = true) {
        const i3 = new q(r3, r3), a4 = t4.sub(i3), s3 = e3.add(i3), o3 = [a4, new q(s3.x, a4.y), s3, new q(a4.x, s3.y)];
        return n3 && o3.push(a4.clone()), o3;
      }, t3.af = function(t4, e3) {
        const r3 = [];
        for (let n3 = 0; n3 < t4.length; n3++) {
          const i3 = et2(n3 - 1, -1, t4.length - 1), a4 = et2(n3 + 1, -1, t4.length - 1), s3 = t4[n3], o3 = t4[a4], l3 = t4[i3].sub(s3).unit(), u4 = o3.sub(s3).unit(), c3 = u4.angleWithSep(l3.x, l3.y), h3 = l3.add(u4).unit().mult(-1 * e3 / Math.sin(c3 / 2));
          r3.push(s3.add(h3));
        }
        return r3;
      }, t3.ag = xd, t3.ah = jl, t3.ai = function(t4, e3, r3 = 0) {
        return O.vec3.fromValues(((e3.x - r3) * t4.scale - t4.x) * Wr, (e3.y * t4.scale - t4.y) * Wr, pl(e3.z, e3.y));
      }, t3.aj = uu, t3.ak = Sp, t3.al = function(t4) {
        let e3 = 1 / 0, r3 = 1 / 0, n3 = -1 / 0, i3 = -1 / 0;
        for (const a4 of t4) e3 = Math.min(e3, a4.x), r3 = Math.min(r3, a4.y), n3 = Math.max(n3, a4.x), i3 = Math.max(i3, a4.y);
        return { min: new q(e3, r3), max: new q(n3, i3) };
      }, t3.am = ol, t3.an = Ul, t3.ao = bl, t3.ap = Q2, t3.aq = $o, t3.ar = function(t4, e3) {
        const r3 = {};
        for (let n3 = 0; n3 < e3.length; n3++) {
          const i3 = e3[n3];
          i3 in t4 && (r3[i3] = t4[i3]);
        }
        return r3;
      }, t3.as = nl, t3.at = ll, t3.au = class {
        constructor(t4) {
          this.entries = {}, this.scheduler = t4;
        }
        request(t4, e3, r3, n3) {
          const i3 = this.entries[t4] = this.entries[t4] || { callbacks: [] };
          if (i3.result) {
            const [t5, r4] = i3.result;
            return this.scheduler ? this.scheduler.add(() => {
              n3(t5, r4);
            }, e3) : n3(t5, r4), () => {
            };
          }
          return i3.callbacks.push(n3), i3.cancel || (i3.cancel = r3((r4, n4) => {
            i3.result = [r4, n4];
            for (const t5 of i3.callbacks) this.scheduler ? this.scheduler.add(() => {
              t5(r4, n4);
            }, e3) : t5(r4, n4);
            setTimeout(() => delete this.entries[t4], 3e3);
          })), () => {
            i3.result || (i3.callbacks = i3.callbacks.filter((t5) => t5 !== n3), i3.callbacks.length || (i3.cancel(), delete this.entries[t4]));
          };
        }
      }, t3.av = os, t3.aw = function(t4, e3, r3) {
        const n3 = JSON.stringify(t4.request);
        return t4.data && (this.deduped.entries[n3] = { result: [null, t4.data] }), this.deduped.request(n3, { type: "parseTile", isSymbolTile: t4.isSymbolTile, zoom: t4.tileZoom }, (e4) => {
          const n4 = ie(t4.request, (t5, n5, i3, a4) => {
            t5 ? e4(t5) : n5 && e4(null, { vectorTile: r3 ? void 0 : new ch.VectorTile(new lf(n5)), rawData: n5, cacheControl: i3, expires: a4 });
          });
          return () => {
            n4.cancel(), e4();
          };
        }, e3);
      }, t3.ax = function(t4) {
        Xt++, Xt > Ut && (t4.getActor().send("enforceCacheSizeLimit", Ot), Xt = 0);
      }, t3.ay = Ct2, t3.az = function(t4) {
        return t4 <= 1 ? 1 : Math.pow(2, Math.floor(Math.log(t4) / Math.LN2));
      }, t3.b = function(t4) {
        return St.API_FONTS_REGEX.test(t4);
      }, t3.b$ = cu, t3.b0 = qs, t3.b1 = lu, t3.b2 = co, t3.b3 = uc, t3.b4 = sm, t3.b5 = function(t4, e3) {
        const r3 = Du(e3.zoom);
        if (0 === r3) return _u(t4);
        const n3 = Iu(t4), i3 = zu(n3), a4 = ol(n3.getWest()) * e3.worldSize, s3 = ol(n3.getEast()) * e3.worldSize, o3 = ll(n3.getNorth()) * e3.worldSize, l3 = ll(n3.getSouth()) * e3.worldSize, u4 = [a4, o3, 0], c3 = [s3, o3, 0], h3 = [a4, l3, 0], p3 = [s3, l3, 0], f3 = O.mat4.invert([], e3.globeMatrix);
        return O.vec3.transformMat4(u4, u4, f3), O.vec3.transformMat4(c3, c3, f3), O.vec3.transformMat4(h3, h3, f3), O.vec3.transformMat4(p3, p3, f3), i3[0] = Mu(i3[0], h3, r3), i3[1] = Mu(i3[1], p3, r3), i3[2] = Mu(i3[2], c3, r3), i3[3] = Mu(i3[3], u4, r3), yu.fromPoints(i3);
      }, t3.b6 = Eu, t3.b7 = Pu, t3.b8 = Mu, t3.b9 = gs, t3.bA = Ie, t3.bB = et2, t3.bC = Y, t3.bD = bt, t3.bE = ul, t3.bF = function(t4, e3, r3) {
        t4[4 * e3 + 0] = r3[0], t4[4 * e3 + 1] = r3[1], t4[4 * e3 + 2] = r3[2], t4[4 * e3 + 3] = r3[3];
      }, t3.bG = zo, t3.bH = _o, t3.bI = Mo, t3.bJ = wo, t3.bK = bo, t3.bL = rl, t3.bM = Od, t3.bN = eu, t3.bO = mu, t3.bP = Im, t3.bQ = tu, t3.bR = Su, t3.bS = function(t4, e3, r3, n3, i3, a4, s3, o3, l3) {
        if ("globe" === l3.name) return Su(t4, e3, new tu(r3, n3, i3), false);
        const u4 = gd({ z: r3, x: n3, y: i3 }, l3);
        return new yu([(a4 + u4.x / u4.scale) * e3, e3 * (u4.y / u4.scale), s3], [(a4 + u4.x2 / u4.scale) * e3, e3 * (u4.y2 / u4.scale), o3]);
      }, t3.bT = function(t4, e3, r3) {
        let n3 = 0;
        for (let r4 = 0; r4 < 2; ++r4) {
          const i3 = 0;
          t4[r4] > i3 && (n3 += (t4[r4] - i3) * (t4[r4] - i3)), e3[r4] < i3 && (n3 += (i3 - e3[r4]) * (i3 - e3[r4]));
        }
        return n3;
      }, t3.bU = fl2, t3.bV = Xo, t3.bW = function(t4) {
        const e3 = O.mat4.identity(new Float64Array(16));
        O.mat4.multiply(e3, t4.pixelMatrix, t4.globeMatrix);
        const r3 = [0, Ho, 0], n3 = [0, Ko, 0];
        return O.vec3.transformMat4(r3, r3, e3), O.vec3.transformMat4(n3, n3, e3), [r3[0] > 0 && r3[0] <= t4.width && r3[1] > 0 && r3[1] <= t4.height && !Fu(t4, new rl(t4.center.lat, 90)), n3[0] > 0 && n3[0] <= t4.width && n3[1] > 0 && n3[1] <= t4.height && !Fu(t4, new rl(t4.center.lat, -90))];
      }, t3.bX = function(t4, e3) {
        const { scale: r3 } = t4.tileTransform, n3 = r3 * Wr / (t4.tileSize * Math.pow(2, e3.zoom - t4.tileID.overscaledZ + t4.tileID.canonical.z));
        return O.mat2.scale(new Float32Array(4), e3.inverseAdjustmentMatrix, [n3, n3]);
      }, t3.bY = zm, t3.bZ = Sm, t3.b_ = function(t4) {
        const e3 = Sm(t4, true);
        return O.mat2.invert([], [e3[0], e3[1], e3[4], e3[5]]);
      }, t3.ba = ou, t3.bb = Sg, t3.bc = lf, t3.bd = ie, t3.be = function(t4) {
        const e3 = [];
        for (const r3 in t4) e3.push(t4[r3]);
        return e3;
      }, t3.bf = function(t4, e3) {
        const r3 = [];
        for (const n3 in t4) n3 in e3 || r3.push(n3);
        return r3;
      }, t3.bg = rt, t3.bh = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"], t3.bi = $2, t3.bj = function(t4, e3) {
        const { x: r3, y: n3 } = t4.point, i3 = Ru(r3, n3, t4.worldSize / t4._pixelsPerMercatorPixel, 0, 0);
        return O.mat4.multiply(i3, i3, Bu(_u(e3)));
      }, t3.bk = Wp, t3.bl = df, t3.bm = Zp, t3.bn = function(t4, e3, r3, n3, i3) {
        const a4 = 5 * e3 + 2;
        t4.float32[a4 + 0] = r3, t4.float32[a4 + 1] = n3, t4.float32[a4 + 2] = i3;
      }, t3.bo = Gd, t3.bp = Lf, t3.bq = El, t3.br = Gp, t3.bs = gh, t3.bt = Nm, t3.bu = Ih, t3.bv = zh, t3.bw = od, t3.bx = sd, t3.by = Sf, t3.bz = gx, t3.c = zt, t3.c$ = iu, t3.c0 = function(t4) {
        const { x: e3, y: r3 } = t4.point, { lng: n3, lat: i3 } = t4._center;
        return Ru(e3, r3, t4.worldSize, n3, i3);
      }, t3.c1 = Z2, t3.c2 = nu, t3.c3 = Go, t3.c4 = function(t4) {
        const e3 = Math.round((t4 + 45 + 360) % 360 / 90) % 4;
        return W[e3];
      }, t3.c5 = 45, t3.c6 = sl, t3.c7 = Ao, t3.c8 = function(t4, e3, r3) {
        const n3 = Math.sqrt(t4 * t4 + e3 * e3 + r3 * r3), i3 = n3 > 0 ? Math.acos(r3 / n3) * X : 0;
        let a4 = 0 !== t4 || 0 !== e3 ? Math.atan2(-e3, -t4) * X + 90 : 0;
        return a4 < 0 && (a4 += 360), [n3, a4, i3];
      }, t3.c9 = gl, t3.cA = function(t4) {
        const e3 = fl2 - 5;
        t4 = Q2(t4, -e3, e3) / e3 * 90;
        const r3 = Math.pow(Math.abs(Math.sin(Y(t4))), 3);
        return Math.round(r3 * (Wo.length - 1));
      }, t3.cB = function(t4, e3, r3, n3) {
        const i3 = e3.getNorth(), a4 = e3.getSouth(), s3 = e3.getWest(), o3 = e3.getEast(), l3 = 1 << t4.z, u4 = o3 - s3, c3 = i3 - a4, h3 = u4 / Zo, p3 = -c3 / Wo[r3], f3 = [0, h3, 0, p3, 0, 0, i3, s3, 0];
        if (t4.z > 0) {
          const t5 = 180 / n3;
          O.mat3.multiply(f3, f3, [t5 / u4 + 1, 0, 0, 0, t5 / c3 + 1, 0, -0.5 * t5 / h3, 0.5 * t5 / p3, 1]);
        }
        return f3[2] = l3, f3[5] = t4.x, f3[8] = t4.y, f3;
      }, t3.cC = _u, t3.cD = function(t4, e3, r3) {
        const n3 = O.mat4.identity(new Float64Array(16)), i3 = (e3 / (1 << t4) - 0.5) * Math.PI * 2;
        return O.mat4.rotateY(n3, r3.globeMatrix, i3), Float32Array.from(n3);
      }, t3.cE = class {
        isDataAvailableAtPoint(t4) {
          const e3 = this._source();
          if (this.isUsingMockSource() || !e3 || t4.y < 0 || t4.y > 1) return false;
          const r3 = e3.getSource().maxzoom, n3 = 1 << r3, i3 = Math.floor(t4.x), a4 = Math.floor((t4.x - i3) * n3), s3 = Math.floor(t4.y * n3), o3 = this.findDEMTileFor(new ru(r3, i3, r3, a4, s3));
          return !(!o3 || !o3.dem);
        }
        getAtPointOrZero(t4, e3 = 0) {
          return this.getAtPoint(t4, e3) || 0;
        }
        getAtPoint(t4, e3, r3 = true) {
          if (this.isUsingMockSource()) return null;
          null == e3 && (e3 = null);
          const n3 = this._source();
          if (!n3) return e3;
          if (t4.y < 0 || t4.y > 1) return e3;
          const i3 = n3.getSource().maxzoom, a4 = 1 << i3, s3 = Math.floor(t4.x), o3 = t4.x - s3, l3 = new ru(i3, s3, i3, Math.floor(o3 * a4), Math.floor(t4.y * a4)), u4 = this.findDEMTileFor(l3);
          if (!u4 || !u4.dem) return e3;
          const c3 = u4.dem, h3 = 1 << u4.tileID.canonical.z, p3 = (o3 * h3 - u4.tileID.canonical.x) * c3.dim, f3 = (t4.y * h3 - u4.tileID.canonical.y) * c3.dim, d3 = Math.floor(p3), m2 = Math.floor(f3);
          return (r3 ? this.exaggeration() : 1) * Pe(Pe(c3.get(d3, m2), c3.get(d3, m2 + 1), f3 - m2), Pe(c3.get(d3 + 1, m2), c3.get(d3 + 1, m2 + 1), f3 - m2), p3 - d3);
        }
        getAtTileOffset(t4, e3, r3) {
          const n3 = 1 << t4.canonical.z;
          return this.getAtPointOrZero(new xl(t4.wrap + (t4.canonical.x + e3 / Wr) / n3, (t4.canonical.y + r3 / Wr) / n3));
        }
        getAtTileOffsetFunc(t4, e3, r3, n3) {
          return (i3) => {
            const a4 = this.getAtTileOffset(t4, i3.x, i3.y), s3 = n3.upVector(t4.canonical, i3.x, i3.y), o3 = n3.upVectorScale(t4.canonical, e3, r3).metersToTile;
            return O.vec3.scale(s3, s3, a4 * o3), s3;
          };
        }
        getForTilePoints(t4, e3, r3, n3) {
          if (this.isUsingMockSource()) return false;
          const i3 = iy.create(this, t4, n3);
          return !!i3 && (e3.forEach((t5) => {
            t5[2] = this.exaggeration() * i3.getElevationAt(t5[0], t5[1], r3);
          }), true);
        }
        getMinMaxForTile(t4) {
          if (this.isUsingMockSource()) return null;
          const e3 = this.findDEMTileFor(t4);
          if (!e3 || !e3.dem) return null;
          const r3 = e3.dem.tree, n3 = e3.tileID, i3 = 1 << t4.canonical.z - n3.canonical.z;
          let a4 = t4.canonical.x / i3 - n3.canonical.x, s3 = t4.canonical.y / i3 - n3.canonical.y, o3 = 0;
          for (let e4 = 0; e4 < t4.canonical.z - n3.canonical.z && !r3.leaves[o3]; e4++) {
            a4 *= 2, s3 *= 2;
            const t5 = 2 * Math.floor(s3) + Math.floor(a4);
            o3 = r3.childOffsets[o3] + t5, a4 %= 1, s3 %= 1;
          }
          return { min: this.exaggeration() * r3.minimums[o3], max: this.exaggeration() * r3.maximums[o3] };
        }
        getMinElevationBelowMSL() {
          throw new Error("Pure virtual method called.");
        }
        raycast(t4, e3, r3) {
          throw new Error("Pure virtual method called.");
        }
        pointCoordinate(t4) {
          throw new Error("Pure virtual method called.");
        }
        _source() {
          throw new Error("Pure virtual method called.");
        }
        isUsingMockSource() {
          throw new Error("Pure virtual method called.");
        }
        exaggeration() {
          throw new Error("Pure virtual method called.");
        }
        findDEMTileFor(t4) {
          throw new Error("Pure virtual method called.");
        }
        get visibleDemTiles() {
          throw new Error("Getter must be implemented in subclass.");
        }
        getMinMaxForVisibleTiles() {
          const t4 = this.visibleDemTiles;
          if (0 === t4.length) return null;
          let e3 = false, r3 = Number.MAX_VALUE, n3 = Number.MIN_VALUE;
          for (const i3 of t4) {
            const t5 = this.getMinMaxForTile(i3.tileID);
            t5 && (r3 = Math.min(r3, t5.min), n3 = Math.max(n3, t5.max), e3 = true);
          }
          return e3 ? { min: r3, max: n3 } : null;
        }
      }, t3.cF = ac, t3.cG = gu, t3.cH = function(t4, e3) {
        return [Math.pow(t4[0], 2.2) * e3, Math.pow(t4[1], 2.2) * e3, Math.pow(t4[2], 2.2) * e3];
      }, t3.cI = Cu, t3.cJ = At, t3.cK = Mt, t3.cL = 256, t3.cM = function(t4, e3) {
        const r3 = [0, 0, 0], n3 = Eu(_u(e3.canonical));
        return O.vec3.transformMat4(r3, r3, n3), O.vec3.transformMat4(r3, r3, t4), r3;
      }, t3.cN = (t4) => ({ u_camera_to_center_distance: new wo(t4), u_extrude_scale: new To(t4), u_device_pixel_ratio: new wo(t4), u_matrix: new zo(t4), u_inv_rot_matrix: new zo(t4), u_merc_center: new _o(t4), u_tile_id: new Mo(t4), u_zoom_transition: new wo(t4), u_up_dir: new Mo(t4), u_emissive_strength: new wo(t4) }), t3.cO = (t4) => ({ u_matrix: new zo(t4), u_pixels_to_tile_units: new To(t4), u_device_pixel_ratio: new wo(t4), u_units_to_pixels: new _o(t4), u_dash_image: new bo(t4), u_gradient_image: new bo(t4), u_image_height: new wo(t4), u_texsize: new _o(t4), u_tile_units_to_pixels: new wo(t4), u_alpha_discard_threshold: new wo(t4), u_trim_offset: new _o(t4), u_trim_fade_range: new _o(t4), u_trim_color: new Ao(t4), u_emissive_strength: new wo(t4), u_zbias_factor: new wo(t4), u_tile_to_meter: new wo(t4) }), t3.cP = (t4) => ({ u_matrix: new zo(t4), u_texsize: new _o(t4), u_pixels_to_tile_units: new To(t4), u_device_pixel_ratio: new wo(t4), u_image: new bo(t4), u_units_to_pixels: new _o(t4), u_tile_units_to_pixels: new wo(t4), u_alpha_discard_threshold: new wo(t4), u_trim_offset: new _o(t4), u_emissive_strength: new wo(t4), u_zbias_factor: new wo(t4), u_tile_to_meter: new wo(t4) }), t3.cQ = Bs, t3.cR = $p, t3.cS = Hp, t3.cT = qu, t3.cU = (t4, e3, r3, n3, i3, a4) => {
        const s3 = t4.transform, o3 = "globe" === s3.projection.name;
        let l3;
        if ("map" === a4.paint.get("circle-pitch-alignment")) if (o3) {
          const t5 = Cu(s3.zoom, e3.canonical) * s3._pixelsPerMercatorPixel;
          l3 = Float32Array.from([t5, 0, 0, t5]);
        } else l3 = s3.calculatePixelsToTileUnitsMatrix(r3);
        else l3 = new Float32Array([s3.pixelsToGLUnits[0], 0, 0, s3.pixelsToGLUnits[1]]);
        const u4 = { u_camera_to_center_distance: t4.transform.getCameraToCenterDistance(s3.projection), u_matrix: t4.translatePosMatrix(e3.projMatrix, r3, a4.paint.get("circle-translate"), a4.paint.get("circle-translate-anchor")), u_device_pixel_ratio: Rt.devicePixelRatio, u_extrude_scale: l3, u_inv_rot_matrix: Nu, u_merc_center: [0, 0], u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_up_dir: [0, 0, 0], u_emissive_strength: a4.paint.get("circle-emissive-strength") };
        if (o3) {
          u4.u_inv_rot_matrix = n3, u4.u_merc_center = i3, u4.u_tile_id = [e3.canonical.x, e3.canonical.y, 1 << e3.canonical.z], u4.u_zoom_transition = Du(s3.zoom);
          const t5 = i3[0] * Wr, r4 = i3[1] * Wr;
          u4.u_up_dir = s3.projection.upVector(new tu(0, 0, 0), t5, r4);
        }
        return u4;
      }, t3.cV = kp, t3.cW = (t4, e3, r3, n3, i3, a4) => {
        const s3 = t4.transform, o3 = s3.pitch < 15 ? Ip(0.07, 0.7, Q2((14 - s3.zoom) / 5, 0, 1)) : 0.07;
        return { u_matrix: Pp(t4, e3, r3, n3), u_texsize: e3.imageAtlasTexture ? e3.imageAtlasTexture.size : [0, 0], u_pixels_to_tile_units: s3.calculatePixelsToTileUnitsMatrix(e3), u_device_pixel_ratio: i3, u_image: 0, u_tile_units_to_pixels: zp(e3, s3), u_units_to_pixels: [1 / s3.pixelsToGLUnits[0], 1 / s3.pixelsToGLUnits[1]], u_alpha_discard_threshold: 0, u_trim_offset: a4, u_emissive_strength: r3.paint.get("line-emissive-strength"), u_zbias_factor: o3, u_tile_to_meter: gl(e3.tileID.canonical, 0) };
      }, t3.cX = (t4, e3, r3, n3, i3, a4, s3) => {
        const o3 = t4.transform, l3 = o3.calculatePixelsToTileUnitsMatrix(e3), u4 = o3.pitch < 15 ? Ip(0.07, 0.7, Q2((14 - o3.zoom) / 5, 0, 1)) : 0.07;
        return { u_matrix: Pp(t4, e3, r3, n3), u_pixels_to_tile_units: l3, u_device_pixel_ratio: a4, u_units_to_pixels: [1 / o3.pixelsToGLUnits[0], 1 / o3.pixelsToGLUnits[1]], u_dash_image: 0, u_gradient_image: 1, u_image_height: i3, u_texsize: Tp(r3) && e3.lineAtlasTexture ? e3.lineAtlasTexture.size : [0, 0], u_tile_units_to_pixels: zp(e3, t4.transform), u_alpha_discard_threshold: 0, u_trim_offset: s3, u_trim_fade_range: r3.paint.get("line-trim-fade-range"), u_trim_color: r3.paint.get("line-trim-color").toRenderColor(r3.lut).toArray01(), u_emissive_strength: r3.paint.get("line-emissive-strength"), u_zbias_factor: u4, u_tile_to_meter: gl(e3.tileID.canonical, 0) };
      }, t3.cY = st, t3.cZ = sc, t3.c_ = rp, t3.ca = yu, t3.cb = yt2, t3.cc = function(t4) {
        return [Math.pow(t4[0], 1 / 2.2), Math.pow(t4[1], 1 / 2.2), Math.pow(t4[2], 1 / 2.2)];
      }, t3.cd = function(t4) {
        return t4({ pluginStatus: Ma, pluginURL: Aa }), za.on("pluginStateChange", t4), t4;
      }, t3.ce = _y2, t3.cf = Bg, t3.cg = Yf, t3.ch = Xf, t3.ci = re, t3.cj = Sa, t3.ck = Lt, t3.cl = ge2, t3.cm = ht, t3.cn = function(t4) {
        const e3 = t4.indexOf(ss);
        return e3 >= 0 ? t4.slice(0, e3) : t4;
      }, t3.co = function(t4) {
        const e3 = t4.indexOf(ss);
        return e3 >= 0 ? t4.slice(e3 + 1) : "";
      }, t3.cp = function(t4) {
        const e3 = [], r3 = t4.id;
        return void 0 === r3 && e3.push({ message: `layers.${r3}: missing required property "id"` }), void 0 === t4.render && e3.push({ message: `layers.${r3}: missing required method "render"` }), t4.renderingMode && "2d" !== t4.renderingMode && "3d" !== t4.renderingMode && e3.push({ message: `layers.${r3}: property "renderingMode" must be either "2d" or "3d"` }), e3;
      }, t3.cq = function(t4, e3, r3, n3) {
        return "custom" === t4.type ? new Mm(t4, e3) : new xy[t4.type](t4, e3, r3, n3);
      }, t3.cr = ct2, t3.cs = za, t3.ct = ne, t3.cu = So, t3.cv = class extends vo {
        constructor(t4) {
          super(t4), this.current = Po;
        }
        set(t4, e3, r3) {
          if (this.fetchUniformLocation(t4, e3)) {
            for (let t5 = 0; t5 < 9; t5++) if (r3[t5] !== this.current[t5]) {
              this.current = r3, this.gl.uniformMatrix3fv(this.location, false, r3);
              break;
            }
          }
        }
      }, t3.cw = H, t3.cx = function(t4, e3, r3) {
        const n3 = Du(r3.zoom), i3 = t4.style.map._antialias, a4 = e3.options.extStandardDerivativesForceOff || t4.terrain && t4.terrain.exaggeration() > 0;
        return 0 === n3 && !i3 && !a4;
      }, t3.cy = function(t4) {
        const e3 = t4.pixelsPerMeter, r3 = e3 / ul(1, t4.center.lat), n3 = O.mat4.identity(new Float64Array(16));
        return O.mat4.translate(n3, n3, [t4.point.x, t4.point.y, 0]), O.mat4.scale(n3, n3, [r3, r3, e3]), Float32Array.from(n3);
      }, t3.cz = Iu, t3.d = function(t4) {
        return St.API_TILEJSON_REGEX.test(t4);
      }, t3.d$ = e2, t3.d0 = Zh, t3.d1 = Dh, t3.d2 = 450, t3.d3 = 7, t3.d4 = mm, t3.d5 = ds, t3.d6 = Ys, t3.d7 = 256, t3.d8 = Bu, t3.d9 = _s, t3.dA = Lu, t3.dB = function(t4) {
        const e3 = [0, 0, 0], r3 = O.mat4.identity(new Float64Array(16));
        return O.mat4.multiply(r3, t4.pixelMatrix, t4.globeMatrix), O.vec3.transformMat4(e3, e3, r3), new q(e3[0], e3[1]);
      }, t3.dC = function(t4, e3, r3 = false) {
        if (Ma === va || Ma === ba || Ma === wa) throw new Error("setRTLTextPlugin cannot be called multiple times.");
        Aa = Rt.resolveURL(t4), Ma = va, _a2 = e3, Ia(), r3 || ka();
      }, t3.dD = Pa, t3.dE = function() {
        Bg().acquire(kg);
      }, t3.dF = function() {
        const t4 = Eg;
        t4 && (t4.isPreloaded() && 1 === t4.numActive() ? (t4.release(kg), Eg = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
      }, t3.dG = Tg, t3.dH = function(t4) {
        const e3 = $t();
        if (!e3) return;
        const r3 = e3.delete(Ft2);
        t4 && r3.catch(t4).then(() => t4());
      }, t3.dI = Pg, t3.dJ = Og, t3.dK = function(t4) {
        Cg = Rt.resolveURL(t4), Fg || (Fg = new _y2(Bg(), new _e())), Fg.broadcast("setDracoUrl", Cg);
      }, t3.dL = Ug, t3.dM = function(t4) {
        Dg = Rt.resolveURL(t4), Fg || (Fg = new _y2(Bg(), new _e())), Fg.broadcast("setMeshoptUrl", Dg);
      }, t3.dN = aa, t3.dO = nc, t3.dP = Gf, t3.dQ = px2, t3.dR = fx, t3.dS = gp, t3.dT = ut, t3.dU = jf, t3.dV = function(t4, e3, r3, n3, i3, a4, s3, o3, l3, u4, c3 = 1, h3) {
        t4.createArrays(), t4.tilePixelRatio = Wr / (512 * t4.overscaling), t4.compareText = {}, t4.iconsNeedLinear = false;
        const p3 = t4.layers[0].layout, f3 = t4.layers[0]._unevaluatedLayout._values, d3 = {};
        if (d3.scaleFactor = c3, d3.textSizeScaleRange = p3.get("text-size-scale-range"), d3.iconSizeScaleRange = p3.get("icon-size-scale-range"), d3.textScaleFactor = Q2(d3.scaleFactor, d3.textSizeScaleRange[0], d3.textSizeScaleRange[1]), d3.iconScaleFactor = Q2(d3.scaleFactor, d3.iconSizeScaleRange[0], d3.iconSizeScaleRange[1]), "composite" === t4.textSizeData.kind) {
          const { minZoom: e4, maxZoom: r4 } = t4.textSizeData;
          d3.compositeTextSizes = [f3["text-size"].possiblyEvaluate(new Ea(e4), o3), f3["text-size"].possiblyEvaluate(new Ea(r4), o3)];
        }
        if ("composite" === t4.iconSizeData.kind) {
          const { minZoom: e4, maxZoom: r4 } = t4.iconSizeData;
          d3.compositeIconSizes = [f3["icon-size"].possiblyEvaluate(new Ea(e4), o3), f3["icon-size"].possiblyEvaluate(new Ea(r4), o3)];
        }
        d3.layoutTextSize = f3["text-size"].possiblyEvaluate(new Ea(l3 + 1), o3), d3.layoutIconSize = f3["icon-size"].possiblyEvaluate(new Ea(l3 + 1), o3), d3.textMaxSize = f3["text-size"].possiblyEvaluate(new Ea(18), o3);
        const m2 = "map" === p3.get("text-rotation-alignment") && "point" !== p3.get("symbol-placement"), y2 = p3.get("text-size");
        let g4 = false;
        for (const e4 of t4.features) if (e4.icon && e4.icon.nameSecondary) {
          g4 = true;
          break;
        }
        for (const a5 of t4.features) {
          const l4 = p3.get("text-font").evaluate(a5, {}, o3).join(","), c4 = y2.evaluate(a5, {}, o3) * d3.textScaleFactor, f4 = d3.layoutTextSize.evaluate(a5, {}, o3) * d3.textScaleFactor, x2 = (d3.layoutIconSize.evaluate(a5, {}, o3), { horizontal: {}, vertical: void 0 }), v2 = a5.text;
          let b2, w2 = [0, 0];
          if (v2) {
            const n4 = v2.toString(), s4 = p3.get("text-letter-spacing").evaluate(a5, {}, o3) * Gp, u5 = p3.get("text-line-height").evaluate(a5, {}, o3) * Gp, h4 = pa(n4) ? s4 : 0, d4 = p3.get("text-anchor").evaluate(a5, {}, o3), y3 = p3.get("text-variable-anchor");
            if (!y3) {
              const t5 = p3.get("text-radial-offset").evaluate(a5, {}, o3);
              w2 = t5 ? sd(d4, [t5 * Gp, id]) : p3.get("text-offset").evaluate(a5, {}, o3).map((t6) => t6 * Gp);
            }
            let g5 = m2 ? "center" : p3.get("text-justify").evaluate(a5, {}, o3);
            const b3 = "point" === p3.get("symbol-placement"), _3 = b3 ? p3.get("text-max-width").evaluate(a5, {}, o3) * Gp : 1 / 0, M3 = (a6) => {
              t4.allowVerticalPlacement && ha(n4) && (x2.vertical = gf(v2, e3, r3, i3, l4, _3, u5, d4, a6, h4, w2, df.vertical, true, f4, c4));
            };
            if (!m2 && y3) {
              const t5 = "auto" === g5 ? y3.map((t6) => od(t6)) : [g5];
              let n5 = false;
              for (let a6 = 0; a6 < t5.length; a6++) {
                const s5 = t5[a6];
                if (!x2.horizontal[s5]) if (n5) x2.horizontal[s5] = x2.horizontal[0];
                else {
                  const t6 = gf(v2, e3, r3, i3, l4, _3, u5, "center", s5, h4, w2, df.horizontal, false, f4, c4);
                  t6 && (x2.horizontal[s5] = t6, n5 = 1 === t6.positionedLines.length);
                }
              }
              M3("left");
            } else {
              if ("auto" === g5 && (g5 = od(d4)), b3 || p3.get("text-writing-mode").indexOf("horizontal") >= 0 || !ha(n4)) {
                const t5 = gf(v2, e3, r3, i3, l4, _3, u5, d4, g5, h4, w2, df.horizontal, false, f4, c4);
                t5 && (x2.horizontal[g5] = t5);
              }
              M3(b3 ? "left" : g5);
            }
          }
          let _2 = false;
          if (a5.icon && a5.icon.namePrimary) {
            const e4 = n3[a5.icon.namePrimary];
            e4 && (b2 = zf(i3[a5.icon.namePrimary], a5.icon.nameSecondary ? i3[a5.icon.nameSecondary] : void 0, p3.get("icon-offset").evaluate(a5, {}, o3), p3.get("icon-anchor").evaluate(a5, {}, o3)), _2 = e4.sdf, void 0 === t4.sdfIcons ? t4.sdfIcons = e4.sdf : t4.sdfIcons !== e4.sdf && ft("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (e4.pixelRatio !== t4.pixelRatio || 0 !== p3.get("icon-rotate").constantOr(1)) && (t4.iconsNeedLinear = true));
          }
          const M2 = pd(x2.horizontal) || x2.vertical;
          t4.iconsInText || (t4.iconsInText = !!M2 && M2.iconsInText), (M2 || b2) && ld(t4, a5, x2, b2, n3, d3, f4, 0, w2, _2, s3, o3, u4, h3, g4);
        }
        a4 && t4.generateCollisionDebugBuffers(l3, t4.collisionBoxArray, d3.textScaleFactor);
      }, t3.dW = ch, t3.dX = Cy, t3.dY = N, t3.dZ = uh, t3.d_ = of, t3.da = Fs, t3.db = Os, t3.dc = function(t4, e3, r3, n3, i3) {
        return Q2((t4 - e3) / (r3 - e3) * (i3 - n3) + n3, n3, i3);
      }, t3.dd = Ai, t3.de = ml, t3.df = class {
        constructor(t4, e3, r3, n3) {
          this.context = t4, this.format = n3, this.size = r3, this.texture = t4.gl.createTexture();
          const [i3, a4, s3] = this.size, { gl: o3 } = t4;
          o3.bindTexture(o3.TEXTURE_3D, this.texture), t4.pixelStoreUnpackFlipY.set(false), t4.pixelStoreUnpack.set(1), t4.pixelStoreUnpackPremultiplyAlpha.set(false), o3.texImage3D(o3.TEXTURE_3D, 0, this.format, i3, a4, s3, 0, om(this.format), lm(this.format), e3.data);
        }
        bind(t4, e3) {
          const { context: r3 } = this, { gl: n3 } = r3;
          n3.bindTexture(n3.TEXTURE_3D, this.texture), t4 !== this.minFilter && (n3.texParameteri(n3.TEXTURE_3D, n3.TEXTURE_MAG_FILTER, t4), n3.texParameteri(n3.TEXTURE_3D, n3.TEXTURE_MIN_FILTER, t4), this.minFilter = t4), e3 !== this.wrapS && (n3.texParameteri(n3.TEXTURE_3D, n3.TEXTURE_WRAP_S, e3), n3.texParameteri(n3.TEXTURE_3D, n3.TEXTURE_WRAP_T, e3), this.wrapS = e3);
        }
        destroy() {
          const { gl: t4 } = this.context;
          t4.deleteTexture(this.texture), this.texture = null;
        }
      }, t3.dg = Vm, t3.dh = [1, 1, 1], t3.di = iy, t3.dj = Km, t3.dk = ks, t3.dl = class {
        constructor() {
          this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [], this._globalClipBounds = { min: new q(1 / 0, 1 / 0), max: new q(-1 / 0, -1 / 0) };
        }
        clear() {
          this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
        }
        get updateTime() {
          return this._updateTime;
        }
        getReplacementRegionsForTile(t4, e3 = false) {
          const r3 = _h(new q(0, 0), new q(Wr, Wr), t4), n3 = [];
          if (e3 && !bh(r3, this._globalClipBounds)) return n3;
          for (const e4 of this._activeRegions) {
            if (e4.hiddenByOverlap) continue;
            if (!bh(r3, e4)) continue;
            const i3 = Mh(e4.min, e4.max, t4);
            n3.push({ min: i3.min, max: i3.max, sourceId: this._sourceIds[e4.priority], footprint: e4.footprint, footprintTileId: e4.tileId, order: e4.order, clipMask: e4.clipMask, clipScope: e4.clipScope });
          }
          return n3;
        }
        setSources(t4) {
          this._setSources(t4.map((t5) => ({ getSourceId: () => t5.cache.id, getFootprints: () => {
            const e3 = [];
            for (const r3 of t5.cache.getVisibleCoordinates()) {
              const n3 = t5.cache.getTile(r3).buckets[t5.layer];
              n3 && n3.updateFootprints(r3.toUnwrapped(), e3);
            }
            return e3;
          }, getOrder: () => t5.order, getClipMask: () => t5.clipMask, getClipScope: () => t5.clipScope })));
        }
        _addSource(t4) {
          const e3 = t4.getFootprints();
          if (0 === e3.length) return;
          const r3 = t4.getOrder(), n3 = t4.getClipMask(), i3 = t4.getClipScope();
          for (const t5 of e3) {
            if (!t5.footprint) continue;
            const e4 = _h(t5.footprint.min, t5.footprint.max, t5.id);
            this._activeRegions.push({ min: e4.min, max: e4.max, hiddenByOverlap: false, priority: this._sourceIds.length, tileId: t5.id, footprint: t5.footprint, order: r3, clipMask: n3, clipScope: i3 });
          }
          this._sourceIds.push(t4.getSourceId());
        }
        _computeReplacement() {
          this._activeRegions.sort((t5, e3) => t5.priority - e3.priority || xh(t5.min, e3.min) || xh(t5.max, e3.max) || t5.order - e3.order || t5.clipMask - e3.clipMask || function(t6, e4) {
            const r3 = (t7, e5) => t7 + e5;
            return t6.length - e4.length || t6.reduce(r3, "").localeCompare(e4.reduce(r3, ""));
          }(t5.clipScope, e3.clipScope));
          let t4 = this._activeRegions.length !== this._prevRegions.length;
          if (!t4) {
            let e3 = 0;
            for (; !t4 && e3 !== this._activeRegions.length; ) {
              const r3 = this._activeRegions[e3], n3 = this._prevRegions[e3];
              t4 = r3.priority !== n3.priority || !vh(r3, n3) || r3.order !== n3.order || r3.clipMask !== n3.clipMask || !$2(r3.clipScope, n3.clipScope), ++e3;
            }
          }
          if (t4) {
            ++this._updateTime;
            for (const t6 of this._activeRegions) t6.order !== yh && (this._globalClipBounds.min.x = Math.min(this._globalClipBounds.min.x, t6.min.x), this._globalClipBounds.min.y = Math.min(this._globalClipBounds.min.y, t6.min.y), this._globalClipBounds.max.x = Math.max(this._globalClipBounds.max.x, t6.max.x), this._globalClipBounds.max.y = Math.max(this._globalClipBounds.max.y, t6.max.y));
            const t5 = (t6) => {
              const e3 = this._activeRegions;
              if (t6 >= e3.length) return t6;
              const r3 = e3[t6].priority;
              for (; t6 < e3.length && e3[t6].priority === r3; ) ++t6;
              return t6;
            };
            if (this._sourceIds.length > 1) {
              let e3 = 0, r3 = t5(e3);
              for (; e3 !== r3; ) {
                let n3 = e3;
                const i3 = e3;
                for (; n3 !== r3; ) {
                  const t6 = this._activeRegions[n3];
                  t6.hiddenByOverlap = false;
                  for (let e4 = 0; e4 < i3; e4++) {
                    const r4 = this._activeRegions[e4];
                    if (!r4.hiddenByOverlap && t6.order === yh && bh(t6, r4) && (t6.hiddenByOverlap = Sh(t6.footprint, t6.tileId, r4.footprint, r4.tileId), t6.hiddenByOverlap)) break;
                  }
                  ++n3;
                }
                e3 = r3, r3 = t5(e3);
              }
            }
          }
        }
        _setSources(t4) {
          [this._prevRegions, this._activeRegions] = [this._activeRegions, []], this._sourceIds = [];
          for (let e3 = t4.length - 1; e3 >= 0; e3--) this._addSource(t4[e3]);
          this._computeReplacement();
        }
      }, t3.dm = class {
        constructor(t4) {
          this._createGrid(t4), this._createPoles(t4);
        }
        destroy() {
          this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
          for (const t4 of this._poleSegments) t4.destroy();
          for (const t4 of this._gridSegments) t4.withSkirts.destroy(), t4.withoutSkirts.destroy();
        }
        _fillGridMeshWithLods(t4, e3) {
          const r3 = new ys(), n3 = new Cs(), i3 = [], a4 = t4 + 1 + 2, s3 = e3[0] + 1, o3 = e3[0] + 1 + (1 + e3.length), l3 = (t5, e4, r4) => {
            let n4 = t5 === a4 - 1 ? t5 - 2 : 0 === t5 ? t5 : t5 - 1;
            return n4 += r4 ? 24575 : 0, [n4, e4];
          };
          for (let t5 = 0; t5 < a4; ++t5) r3.emplaceBack(...l3(t5, 0, true));
          for (let t5 = 0; t5 < s3; ++t5) for (let e4 = 0; e4 < a4; ++e4) r3.emplaceBack(...l3(e4, t5, (0 === e4 || e4 === a4 - 1) && true));
          for (let t5 = 0; t5 < e3.length; ++t5) {
            const n4 = e3[t5];
            for (let t6 = 0; t6 < a4; ++t6) r3.emplaceBack(...l3(t6, n4, true));
          }
          for (let t5 = 0; t5 < e3.length; ++t5) {
            const s4 = n3.length, l4 = e3[t5] + 1 + 2, u4 = new Cs();
            for (let r4 = 0; r4 < l4 - 1; r4++) {
              const i4 = r4 === l4 - 2, s5 = i4 ? a4 * (o3 - e3.length + t5 - r4) : a4;
              for (let t6 = 0; t6 < a4 - 1; t6++) {
                const e4 = r4 * a4 + t6;
                0 === r4 || i4 || 0 === t6 || t6 === a4 - 2 ? (u4.emplaceBack(e4 + 1, e4, e4 + s5), u4.emplaceBack(e4 + s5, e4 + s5 + 1, e4 + 1)) : (n3.emplaceBack(e4 + 1, e4, e4 + s5), n3.emplaceBack(e4 + s5, e4 + s5 + 1, e4 + 1));
              }
            }
            const c3 = co.simpleSegment(0, s4, r3.length, n3.length - s4);
            for (let t6 = 0; t6 < u4.uint16.length; t6 += 3) n3.emplaceBack(u4.uint16[t6], u4.uint16[t6 + 1], u4.uint16[t6 + 2]);
            const h3 = co.simpleSegment(0, s4, r3.length, n3.length - s4);
            i3.push({ withoutSkirts: c3, withSkirts: h3 });
          }
          return { vertices: r3, indices: n3, segments: i3 };
        }
        _createGrid(t4) {
          const e3 = this._fillGridMeshWithLods(Zo, Wo);
          this._gridSegments = e3.segments, this._gridBuffer = t4.createVertexBuffer(e3.vertices, lu.members), this._gridIndexBuffer = t4.createIndexBuffer(e3.indices, true);
        }
        _createPoles(t4) {
          const e3 = new Cs();
          for (let t5 = 0; t5 <= Zo; t5++) e3.emplaceBack(0, t5 + 1, t5 + 2);
          this._poleIndexBuffer = t4.createIndexBuffer(e3, true);
          const r3 = new Fs(), n3 = new Fs(), i3 = new Fs(), a4 = new Fs();
          this._poleSegments = [];
          for (let t5 = 0, e4 = 0; t5 < Go; t5++) {
            const s3 = 360 / (1 << t5);
            r3.emplaceBack(0, -$o, 0, 0.5, 0), n3.emplaceBack(0, -$o, 0, 0.5, 1), i3.emplaceBack(0, -$o, 0, 0.5, 0.5), a4.emplaceBack(0, -$o, 0, 0.5, 0.5);
            for (let t6 = 0; t6 <= Zo; t6++) {
              let e5 = t6 / Zo, o3 = 0;
              const l3 = Pe(0, s3, e5), [u4, c3, h3] = Jo(Uu, ju, l3, $o);
              r3.emplaceBack(u4, c3, h3, e5, o3), n3.emplaceBack(u4, c3, h3, e5, 1 - o3);
              const p3 = Y(l3);
              e5 = 0.5 + 0.5 * Math.sin(p3), o3 = 0.5 + 0.5 * Math.cos(p3), i3.emplaceBack(u4, c3, h3, e5, o3), a4.emplaceBack(u4, c3, h3, e5, 1 - o3);
            }
            this._poleSegments.push(co.simpleSegment(e4, 0, 66, 64)), e4 += 66;
          }
          this._poleNorthVertexBuffer = t4.createVertexBuffer(r3, su, false), this._poleSouthVertexBuffer = t4.createVertexBuffer(n3, su, false), this._texturedPoleNorthVertexBuffer = t4.createVertexBuffer(i3, su, false), this._texturedPoleSouthVertexBuffer = t4.createVertexBuffer(a4, su, false);
        }
        getGridBuffers(t4, e3) {
          return [this._gridBuffer, this._gridIndexBuffer, e3 ? this._gridSegments[t4].withSkirts : this._gridSegments[t4].withoutSkirts];
        }
        getPoleBuffers(t4, e3) {
          return [e3 ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer, e3 ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer, this._poleIndexBuffer, this._poleSegments[t4]];
        }
      }, t3.dn = yh, t3.dp = K, t3.dq = function() {
        return !!document.fullscreenElement || !!document.webkitFullscreenElement;
      }, t3.dr = J, t3.ds = yl, t3.dt = Qo, t3.du = function([t4, e3, r3]) {
        const n3 = Math.hypot(t4, e3, r3), i3 = Math.atan2(t4, r3), a4 = 0.5 * Math.PI - Math.acos(-e3 / n3);
        return new rl(Z2(i3), Z2(a4));
      }, t3.dv = km, t3.dw = tl, t3.dx = function(t4) {
        const e3 = t4.navigator ? t4.navigator.userAgent : null;
        return !!function(t5) {
          if (null == vt) {
            const e4 = t5.navigator ? t5.navigator.userAgent : null;
            vt = !!t5.safari || !(!e4 || !(/\b(iPad|iPhone|iPod)\b/.test(e4) || e4.match("Safari") && !e4.match("Chrome")));
          }
          return vt;
        }(t4) && e3 && (e3.match("Version/15.4") || e3.match("Version/15.5") || e3.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/));
      }, t3.dy = function(t4, e3) {
        Ot = t4, Ut = e3;
      }, t3.dz = Fu, t3.e = Rt, t3.e0 = function(t4) {
        let e3 = 0;
        if (new Uint32Array(t4, 0, 1)[0] !== Wg) {
          const r3 = new Uint32Array(t4, 0, 7), [, , n3, i3, a4, s3] = r3;
          e3 = r3.byteLength + i3 + a4 + s3 + a4, (n3 !== t4.byteLength || e3 >= t4.byteLength) && ft("Invalid b3dm header information.");
        }
        return ex(t4, e3);
      }, t3.e1 = function(t4, e3) {
        const r3 = ux(t4);
        for (const t5 of r3) {
          for (const e4 of t5.meshes) cx(e4);
          t5.lights && (t5.lightMeshIndex = t5.meshes.length, t5.meshes.push(hx(t5.lights, e3)));
        }
        return r3;
      }, t3.e2 = hy, t3.e3 = wy, t3.e4 = Ta, t3.e5 = function(t4) {
        Gt(), null != Nt && Nt.then((e3) => {
          e3.keys().then((r3) => {
            for (let n3 = 0; n3 < r3.length - t4; n3++) e3.delete(r3[n3]);
          });
        });
      }, t3.f = St, t3.g = function(t4, e3) {
        return ne(nt(t4, { method: "GET" }), e3);
      }, t3.h = function(t4) {
        return 0 === t4.indexOf("mapbox:");
      }, t3.i = function(t4) {
        return St.API_STYLE_REGEX.test(t4) && !zt(t4);
      }, t3.j = It, t3.k = function(t4) {
        return decodeURIComponent(atob(t4).split("").map((t5) => "%" + ("00" + t5.charCodeAt(0).toString(16)).slice(-2)).join(""));
      }, t3.l = function(t4) {
        return btoa(encodeURIComponent(t4).replace(/%([0-9A-F]{2})/g, (t5, e3) => String.fromCharCode(Number("0x" + e3))));
      }, t3.m = nt, t3.n = Yt, t3.o = function(t4, e3) {
        return ne(nt(t4, { type: "json" }), e3);
      }, t3.p = function(t4, e3) {
        return ne(nt(t4, { method: "POST" }), e3);
      }, t3.q = ue2, t3.r = ic, t3.s = function(t4) {
        try {
          const e3 = self[t4];
          return e3.setItem("_mapbox_test_", 1), e3.removeItem("_mapbox_test_"), true;
        } catch (t5) {
          return false;
        }
      }, t3.t = ve, t3.u = function() {
        return function t4(e3) {
          return e3 ? (e3 ^ Math.random() * (16 >> e3 / 4)).toString(16) : ([1e7] + -[1e3] + -4e3 + -8e3 + -1e11).replace(/[018]/g, t4);
        }();
      }, t3.v = function(t4) {
        return !!t4 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t4);
      }, t3.w = ft, t3.x = xe, t3.y = 2, t3.z = Ff;
    });
    define(["./shared"], function(e2) {
      function t3(e3) {
        const t4 = e3 ? e3.url.toString() : void 0;
        return t4 ? performance.getEntriesByName(t4) : [];
      }
      function s2(e3) {
        if ("number" == typeof e3 || "boolean" == typeof e3 || "string" == typeof e3 || null == e3) return JSON.stringify(e3);
        if (Array.isArray(e3)) {
          let t5 = "[";
          for (const o3 of e3) t5 += `${s2(o3)},`;
          return `${t5}]`;
        }
        let t4 = "{";
        for (const o3 of Object.keys(e3).sort()) t4 += `${o3}:${s2(e3[o3])},`;
        return `${t4}}`;
      }
      function o2(t4) {
        let o3 = "";
        for (const i3 of e2.bh) o3 += `/${s2(t4[i3])}`;
        return o3;
      }
      class i2 {
        constructor(e3) {
          this.keyCache = {}, this._layers = {}, this._layerConfigs = {}, e3 && this.replace(e3);
        }
        replace(e3, t4) {
          this._layerConfigs = {}, this._layers = {}, this.update(e3, [], t4);
        }
        update(t4, s3, i3) {
          this._options = i3;
          for (const s4 of t4) this._layerConfigs[s4.id] = s4, (this._layers[s4.id] = e2.cq(s4, this.scope, null, this._options)).compileFilter(i3), this.keyCache[s4.id] && delete this.keyCache[s4.id];
          for (const e3 of s3) delete this.keyCache[e3], delete this._layerConfigs[e3], delete this._layers[e3];
          this.familiesBySource = {};
          const n3 = function(e3, t5) {
            const s4 = {};
            for (let i5 = 0; i5 < e3.length; i5++) {
              const n4 = t5 && t5[e3[i5].id] || o2(e3[i5]);
              t5 && (t5[e3[i5].id] = n4);
              let r3 = s4[n4];
              r3 || (r3 = s4[n4] = []), r3.push(e3[i5]);
            }
            const i4 = [];
            for (const e4 in s4) i4.push(s4[e4]);
            return i4;
          }(e2.be(this._layerConfigs), this.keyCache);
          for (const e3 of n3) {
            const t5 = e3.map((e4) => this._layers[e4.id]), s4 = t5[0];
            if ("none" === s4.visibility) continue;
            const o3 = s4.source || "";
            let i4 = this.familiesBySource[o3];
            i4 || (i4 = this.familiesBySource[o3] = {});
            const n4 = s4.sourceLayer || "_geojsonTileLayer";
            let r3 = i4[n4];
            r3 || (r3 = i4[n4] = []), r3.push(t5);
          }
        }
      }
      const n2 = 1 * e2.dP;
      class r2 {
        constructor(t4) {
          const s3 = {}, o3 = [];
          for (const e3 in t4) {
            const i4 = t4[e3], r4 = s3[e3] = {};
            for (const e4 in i4.glyphs) {
              const t5 = i4.glyphs[+e4];
              if (!t5 || 0 === t5.bitmap.width || 0 === t5.bitmap.height) continue;
              const s4 = t5.metrics.localGlyph ? n2 : 1, a5 = { x: 0, y: 0, w: t5.bitmap.width + 2 * s4, h: t5.bitmap.height + 2 * s4 };
              o3.push(a5), r4[e4] = a5;
            }
          }
          const { w: i3, h: r3 } = e2.z(o3), a4 = new e2.dO({ width: i3 || 1, height: r3 || 1 });
          for (const o4 in t4) {
            const i4 = t4[o4];
            for (const t5 in i4.glyphs) {
              const r4 = i4.glyphs[+t5];
              if (!r4 || 0 === r4.bitmap.width || 0 === r4.bitmap.height) continue;
              const l3 = s3[o4][t5], c3 = r4.metrics.localGlyph ? n2 : 1;
              e2.dO.copy(r4.bitmap, a4, { x: 0, y: 0 }, { x: l3.x + c3, y: l3.y + c3 }, r4.bitmap);
            }
          }
          this.image = a4, this.positions = s3;
        }
      }
      e2.dN(r2, "GlyphAtlas");
      class a3 {
        constructor(t4) {
          this.tileID = new e2.aA(t4.tileID.overscaledZ, t4.tileID.wrap, t4.tileID.canonical.z, t4.tileID.canonical.x, t4.tileID.canonical.y), this.tileZoom = t4.tileZoom, this.uid = t4.uid, this.zoom = t4.zoom, this.lut = t4.lut, this.canonical = t4.tileID.canonical, this.pixelRatio = t4.pixelRatio, this.tileSize = t4.tileSize, this.source = t4.source, this.scope = t4.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t4.showCollisionBoxes, this.collectResourceTiming = !!t4.request && t4.request.collectResourceTiming, this.promoteId = t4.promoteId, this.isSymbolTile = t4.isSymbolTile, this.tileTransform = e2.aL(t4.tileID.canonical, t4.projection), this.projection = t4.projection, this.worldview = t4.worldview, this.localizableLayerIds = t4.localizableLayerIds, this.brightness = t4.brightness, this.extraShadowCaster = !!t4.extraShadowCaster, this.tessellationStep = t4.tessellationStep, this.scaleFactor = t4.scaleFactor;
        }
        parse(t4, s3, o3, i3, n3) {
          this.status = "parsing", this.data = t4, this.collisionBoxArray = new e2.aR();
          const a4 = new e2.dQ(Object.keys(t4.layers).sort()), c3 = new e2.dR(this.tileID, this.promoteId);
          c3.bucketLayerIDs = [];
          const h3 = {}, u4 = new e2.dS(256, 256), d3 = { featureIndex: c3, iconDependencies: {}, patternDependencies: {}, glyphDependencies: {}, lineAtlas: u4, availableImages: o3, brightness: this.brightness }, f3 = s3.familiesBySource[this.source];
          for (const s4 in f3) {
            const i4 = t4.layers[s4];
            if (!i4) continue;
            let n4 = false, r3 = false, u5 = false;
            for (const e3 of f3[s4]) "symbol" === e3[0].type ? n4 = true : r3 = true, e3[0].is3D() && "model" !== e3[0].type && (u5 = true);
            if (this.extraShadowCaster && !u5) continue;
            if (true === this.isSymbolTile && !n4) continue;
            if (false === this.isSymbolTile && !r3) continue;
            1 === i4.version && e2.w(`Vector tile source "${this.source}" layer "${s4}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
            const p4 = a4.encode(s4), g5 = [];
            for (let e3 = 0, t5 = 0; e3 < i4.length; e3++) {
              const o4 = i4.feature(e3), n5 = c3.getId(o4, s4);
              if (this.localizableLayerIds && this.localizableLayerIds.has(s4)) {
                const e4 = o4.properties ? o4.properties.worldview : null;
                if (this.worldview && "string" == typeof e4) if ("all" === e4) o4.properties.$localized = true;
                else {
                  if (!e4.split(",").includes(this.worldview)) continue;
                  o4.properties.$localized = true, o4.properties.worldview = this.worldview;
                }
              }
              g5.push({ feature: o4, id: n5, index: t5, sourceLayerIndex: p4 }), t5++;
            }
            for (const t5 of f3[s4]) {
              const s5 = t5[0];
              (!this.extraShadowCaster || s5.is3D() && "model" !== s5.type) && (void 0 !== this.isSymbolTile && "symbol" === s5.type !== this.isSymbolTile || s5.minzoom && this.zoom < Math.floor(s5.minzoom) || s5.maxzoom && this.zoom >= s5.maxzoom || "none" !== s5.visibility && (l2(t5, this.zoom, d3.brightness, o3), (h3[s5.id] = s5.createBucket({ index: c3.bucketLayerIDs.length, layers: t5, zoom: this.zoom, lut: this.lut, canonical: this.canonical, pixelRatio: this.pixelRatio, overscaling: this.overscaling, collisionBoxArray: this.collisionBoxArray, sourceLayerIndex: p4, sourceID: this.source, projection: this.projection.spec, tessellationStep: this.tessellationStep })).populate(g5, d3, this.tileID.canonical, this.tileTransform), c3.bucketLayerIDs.push(t5.map((t6) => e2.av(t6.id, t6.scope)))));
            }
          }
          let p3, g4, m2, y2;
          u4.trim();
          const x2 = { type: "maybePrepare", isSymbolTile: this.isSymbolTile, zoom: this.zoom }, w2 = () => {
            if (p3) return this.status = "done", n3(p3);
            if (this.extraShadowCaster) this.status = "done", n3(null, { buckets: e2.be(h3).filter((e3) => !e3.isEmpty()), featureIndex: c3, collisionBoxArray: null, glyphAtlasImage: null, lineAtlas: null, imageAtlas: null, brightness: d3.brightness, glyphMap: null, iconMap: null, glyphPositions: null });
            else if (g4 && m2 && y2) {
              const t5 = new r2(g4), s4 = new e2.dU(m2, y2, this.lut);
              for (const i4 in h3) {
                const n4 = h3[i4];
                n4 instanceof e2.aS ? (l2(n4.layers, this.zoom, d3.brightness, o3), e2.dV(n4, g4, t5.positions, m2, s4.iconPositions, this.showCollisionBoxes, o3, this.tileID.canonical, this.tileZoom, this.projection, this.scaleFactor, this.brightness)) : n4.hasPattern && (n4 instanceof e2.aY || n4 instanceof e2.aZ || n4 instanceof e2.d0) && (l2(n4.layers, this.zoom, d3.brightness, o3), n4.addFeatures(d3, this.tileID.canonical, s4.patternPositions, o3, this.tileTransform, this.brightness));
              }
              this.status = "done", n3(null, { buckets: e2.be(h3).filter((e3) => !e3.isEmpty()), featureIndex: c3, collisionBoxArray: this.collisionBoxArray, glyphAtlasImage: t5.image, lineAtlas: u4, imageAtlas: s4, brightness: d3.brightness });
            }
          };
          if (!this.extraShadowCaster) {
            const t5 = e2.dT(d3.glyphDependencies, (e3) => Object.keys(e3).map(Number));
            Object.keys(t5).length ? i3.send("getGlyphs", { uid: this.uid, stacks: t5, scope: this.scope }, (e3, t6) => {
              p3 || (p3 = e3, g4 = t6, w2());
            }, void 0, false, x2) : g4 = {};
            const s4 = Object.keys(d3.iconDependencies);
            s4.length ? i3.send("getImages", { icons: s4, source: this.source, scope: this.scope, tileID: this.tileID, type: "icons" }, (e3, t6) => {
              p3 || (p3 = e3, m2 = t6, w2());
            }, void 0, false, x2) : m2 = {};
            const o4 = Object.keys(d3.patternDependencies);
            o4.length ? i3.send("getImages", { icons: o4, source: this.source, scope: this.scope, tileID: this.tileID, type: "patterns" }, (e3, t6) => {
              p3 || (p3 = e3, y2 = t6, w2());
            }, void 0, false, x2) : y2 = {};
          }
          w2();
        }
      }
      function l2(t4, s3, o3, i3) {
        const n3 = new e2.a3(s3, { brightness: o3 });
        for (const e3 of t4) e3.recalculate(n3, i3);
      }
      class c2 extends e2.E {
        constructor(t4, s3, o3, i3, n3, r3) {
          super(), this.actor = t4, this.layerIndex = s3, this.availableImages = o3, this.loadVectorData = n3 || e2.aw, this.loading = {}, this.loaded = {}, this.deduped = new e2.au(t4.scheduler), this.isSpriteLoaded = i3, this.scheduler = t4.scheduler, this.brightness = r3;
        }
        loadTile(s3, o3) {
          const i3 = s3.uid, n3 = s3 && s3.request, r3 = n3 && n3.collectResourceTiming, l3 = this.loading[i3] = new a3(s3);
          l3.abort = this.loadVectorData(s3, (a4, c3) => {
            const h3 = !this.loading[i3];
            if (delete this.loading[i3], h3 || a4 || !c3) return l3.status = "done", h3 || (this.loaded[i3] = l3), o3(a4);
            const u4 = c3.rawData, d3 = {};
            c3.expires && (d3.expires = c3.expires), c3.cacheControl && (d3.cacheControl = c3.cacheControl), l3.vectorTile = c3.vectorTile || new e2.dW.VectorTile(new e2.bc(u4));
            const f3 = () => {
              l3.parse(l3.vectorTile, this.layerIndex, this.availableImages, this.actor, (s4, i4) => {
                if (s4 || !i4) return o3(s4);
                const a5 = {};
                if (r3) {
                  const e3 = t3(n3);
                  e3.length > 0 && (a5.resourceTiming = JSON.parse(JSON.stringify(e3)));
                }
                o3(null, e2.m({ rawTileData: u4.slice(0) }, i4, d3, a5));
              });
            };
            this.isSpriteLoaded ? f3() : this.once("isSpriteLoaded", () => {
              this.scheduler ? this.scheduler.add(f3, { type: "parseTile", isSymbolTile: s3.isSymbolTile, zoom: s3.tileZoom }) : f3();
            }), this.loaded = this.loaded || {}, this.loaded[i3] = l3;
          });
        }
        reloadTile(t4, s3) {
          const o3 = this.loaded, i3 = t4.uid;
          if (o3 && o3[i3]) {
            const n3 = o3[i3];
            n3.scaleFactor = t4.scaleFactor, n3.showCollisionBoxes = t4.showCollisionBoxes, n3.projection = t4.projection, n3.brightness = t4.brightness, n3.tileTransform = e2.aL(t4.tileID.canonical, t4.projection), n3.extraShadowCaster = t4.extraShadowCaster, n3.lut = t4.lut;
            const r3 = (e3, t5) => {
              const o4 = n3.reloadCallback;
              o4 && (delete n3.reloadCallback, n3.parse(n3.vectorTile, this.layerIndex, this.availableImages, this.actor, o4)), s3(e3, t5);
            };
            "parsing" === n3.status ? n3.reloadCallback = r3 : "done" === n3.status && (n3.vectorTile ? n3.parse(n3.vectorTile, this.layerIndex, this.availableImages, this.actor, r3) : r3());
          } else s3(null, void 0);
        }
        abortTile(e3, t4) {
          const s3 = e3.uid, o3 = this.loading[s3];
          o3 && (o3.abort && o3.abort(), delete this.loading[s3]), t4();
        }
        removeTile(e3, t4) {
          const s3 = this.loaded, o3 = e3.uid;
          s3 && s3[o3] && delete s3[o3], t4();
        }
      }
      class h2 {
        loadTile(t4, s3) {
          const { uid: o3, encoding: i3, rawImageData: n3, padding: r3 } = t4, a4 = ImageBitmap && n3 instanceof ImageBitmap ? this.getImageData(n3, r3) : n3;
          s3(null, new e2.dX(o3, a4, i3, r3 < 1));
        }
        getImageData(e3, t4) {
          this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e3.width, e3.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", { willReadFrequently: true })), this.offscreenCanvas.width = e3.width, this.offscreenCanvas.height = e3.height, this.offscreenCanvasContext.drawImage(e3, 0, 0, e3.width, e3.height);
          const s3 = this.offscreenCanvasContext.getImageData(-t4, -t4, e3.width + 2 * t4, e3.height + 2 * t4);
          return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), s3;
        }
      }
      e2.bb.setPbf(e2.bc);
      class u3 {
        decodeRasterArray({ task: t4, buffer: s3 }, o3) {
          e2.bb.performDecoding(s3, t4).then((e3) => {
            o3(null, e3);
          }, (e3) => {
            o3(e3);
          });
        }
      }
      const d2 = e2.dW.VectorTileFeature.prototype.toGeoJSON;
      class f2 {
        constructor(t4) {
          this._feature = t4, this.extent = e2.ab, this.type = t4.type, this.properties = t4.tags, "id" in t4 && !isNaN(t4.id) && (this.id = parseInt(t4.id, 10));
        }
        loadGeometry() {
          if (1 === this._feature.type) {
            const t4 = [];
            for (const s3 of this._feature.geometry) t4.push([new e2.P(s3[0], s3[1])]);
            return t4;
          }
          {
            const t4 = [];
            for (const s3 of this._feature.geometry) {
              const o3 = [];
              for (const t5 of s3) o3.push(new e2.P(t5[0], t5[1]));
              t4.push(o3);
            }
            return t4;
          }
        }
        toGeoJSON(e3, t4, s3) {
          return d2.call(this, e3, t4, s3);
        }
      }
      class p2 {
        constructor(t4) {
          this.layers = { _geojsonTileLayer: this }, this.name = "_geojsonTileLayer", this.extent = e2.ab, this.length = t4.length, this._features = t4;
        }
        feature(e3) {
          return new f2(this._features[e3]);
        }
      }
      const g3 = 64 / 4096, m = 128;
      class y {
        constructor() {
          this.features = /* @__PURE__ */ new Map();
        }
        clear() {
          this.features.clear();
        }
        load(e3 = [], t4) {
          for (const s3 of e3) {
            const e4 = s3.id;
            if (null == e4) continue;
            let o3 = this.features.get(e4);
            o3 && this.updateCache(o3, t4), s3.geometry ? (o3 = w(s3), this.updateCache(o3, t4), this.features.set(e4, o3)) : this.features.delete(e4), this.updateCache(o3, t4);
          }
        }
        updateCache(e3, t4) {
          for (const { canonical: s3, uid: o3 } of Object.values(t4)) {
            const { z: i3, x: n3, y: r3 } = s3;
            x(e3, Math.pow(2, i3), n3, r3) && delete t4[o3];
          }
        }
        getTile(e3, t4, s3) {
          const o3 = Math.pow(2, e3), i3 = [];
          for (const e4 of this.features.values()) x(e4, o3, t4, s3) && i3.push(I2(e4, o3, t4, s3));
          return { features: i3 };
        }
        getFeatures() {
          return [...this.features.values()];
        }
      }
      function x({ minX: e3, minY: t4, maxX: s3, maxY: o3 }, i3, n3, r3) {
        return e3 < (n3 + 1 + g3) / i3 && t4 < (r3 + 1 + g3) / i3 && s3 > (n3 - g3) / i3 && o3 > (r3 - g3) / i3;
      }
      function w(e3) {
        const { id: t4, geometry: s3, properties: o3 } = e3;
        if (!s3) return;
        if ("GeometryCollection" === s3.type) throw new Error("GeometryCollection not supported in dynamic mode.");
        const { type: i3, coordinates: n3 } = s3, r3 = { id: t4, type: 1, geometry: [], tags: o3, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 }, a4 = r3.geometry;
        if ("Point" === i3) b(n3, a4, r3);
        else if ("MultiPoint" === i3) for (const e4 of n3) b(e4, a4, r3);
        else if ("LineString" === i3) r3.type = 2, S(n3, a4, r3);
        else if ("MultiLineString" === i3) r3.type = 2, v(n3, a4, r3);
        else if ("Polygon" === i3) r3.type = 3, v(n3, a4, r3, true);
        else {
          if ("MultiPolygon" !== i3) throw new Error("Input data is not a valid GeoJSON object.");
          r3.type = 3;
          for (const e4 of n3) v(e4, a4, r3, true);
        }
        return r3;
      }
      function b([t4, s3], o3, i3) {
        const n3 = e2.am(t4);
        let r3 = e2.at(s3);
        r3 = r3 < 0 ? 0 : r3 > 1 ? 1 : r3, o3.push(n3, r3), i3.minX = Math.min(i3.minX, n3), i3.minY = Math.min(i3.minY, r3), i3.maxX = Math.max(i3.maxX, n3), i3.maxY = Math.max(i3.maxY, r3);
      }
      function S(e3, t4, s3, o3 = false, i3 = false) {
        const n3 = [];
        for (const t5 of e3) b(t5, n3, s3);
        t4.push(n3), o3 && function(e4, t5) {
          let s4 = 0;
          for (let t6 = 0, o4 = e4.length, i4 = o4 - 2; t6 < o4; i4 = t6, t6 += 2) s4 += (e4[t6] - e4[i4]) * (e4[t6 + 1] + e4[i4 + 1]);
          if (s4 > 0 === t5) for (let t6 = 0, s5 = e4.length; t6 < s5 / 2; t6 += 2) {
            const o4 = e4[t6], i4 = e4[t6 + 1];
            e4[t6] = e4[s5 - 2 - t6], e4[t6 + 1] = e4[s5 - 1 - t6], e4[s5 - 2 - t6] = o4, e4[s5 - 1 - t6] = i4;
          }
        }(n3, i3);
      }
      function v(e3, t4, s3, o3 = false) {
        for (let i3 = 0; i3 < e3.length; i3++) S(e3[i3], t4, s3, o3, 0 === i3);
      }
      function I2(t4, s3, o3, i3) {
        const { id: n3, type: r3, geometry: a4, tags: l3 } = t4, c3 = [];
        if (1 === r3) !function(t5, s4, o4, i4, n4) {
          for (let r4 = 0; r4 < t5.length; r4 += 2) {
            const a5 = Math.round(e2.ab * (t5[r4 + 0] * s4 - o4)), l4 = Math.round(e2.ab * (t5[r4 + 1] * s4 - i4));
            n4.push([a5, l4]);
          }
        }(a4, s3, o3, i3, c3);
        else for (const e3 of a4) M(e3, s3, o3, i3, c3);
        return { id: n3, type: r3, geometry: c3, tags: l3 };
      }
      function M(t4, s3, o3, i3, n3) {
        const r3 = -m, a4 = e2.ab + m;
        let l3;
        for (let c3 = 0; c3 < t4.length - 2; c3 += 2) {
          let h3 = Math.round(e2.ab * (t4[c3 + 0] * s3 - o3)), u4 = Math.round(e2.ab * (t4[c3 + 1] * s3 - i3)), d3 = Math.round(e2.ab * (t4[c3 + 2] * s3 - o3)), f3 = Math.round(e2.ab * (t4[c3 + 3] * s3 - i3));
          const p3 = d3 - h3, g4 = f3 - u4;
          h3 < r3 && d3 < r3 || (h3 < r3 ? (u4 += Math.round(g4 * ((r3 - h3) / p3)), h3 = r3) : d3 < r3 && (f3 = u4 + Math.round(g4 * ((r3 - h3) / p3)), d3 = r3), u4 < r3 && f3 < r3 || (u4 < r3 ? (h3 += Math.round(p3 * ((r3 - u4) / g4)), u4 = r3) : f3 < r3 && (d3 = h3 + Math.round(p3 * ((r3 - u4) / g4)), f3 = r3), h3 >= a4 && d3 >= a4 || (h3 >= a4 ? (u4 += Math.round(g4 * ((a4 - h3) / p3)), h3 = a4) : d3 >= a4 && (f3 = u4 + Math.round(g4 * ((a4 - h3) / p3)), d3 = a4), u4 >= a4 && f3 >= a4 || (u4 >= a4 ? (h3 += Math.round(p3 * ((a4 - u4) / g4)), u4 = a4) : f3 >= a4 && (d3 = h3 + Math.round(p3 * ((a4 - u4) / g4)), f3 = a4), l3 && h3 === l3[l3.length - 1][0] && u4 === l3[l3.length - 1][1] || (l3 = [[h3, u4]], n3.push(l3)), l3.push([d3, f3])))));
        }
      }
      var k, T2, P, C2 = { exports: {} }, L2 = function() {
        if (P) return C2.exports;
        P = 1;
        var t4 = e2.d_(), s3 = function() {
          if (T2) return k;
          T2 = 1;
          var t5 = e2.dY(), s4 = e2.dZ().VectorTileFeature;
          function o4(e3, t6) {
            this.options = t6 || {}, this.features = e3, this.length = e3.length;
          }
          function i4(e3, t6) {
            this.id = "number" == typeof e3.id ? e3.id : void 0, this.type = e3.type, this.rawGeometry = 1 === e3.type ? [e3.geometry] : e3.geometry, this.properties = e3.tags, this.extent = t6 || 4096;
          }
          return k = o4, o4.prototype.feature = function(e3) {
            return new i4(this.features[e3], this.options.extent);
          }, i4.prototype.loadGeometry = function() {
            var e3 = this.rawGeometry;
            this.geometry = [];
            for (var s5 = 0; s5 < e3.length; s5++) {
              for (var o5 = e3[s5], i5 = [], n4 = 0; n4 < o5.length; n4++) i5.push(new t5(o5[n4][0], o5[n4][1]));
              this.geometry.push(i5);
            }
            return this.geometry;
          }, i4.prototype.bbox = function() {
            this.geometry || this.loadGeometry();
            for (var e3 = this.geometry, t6 = 1 / 0, s5 = -1 / 0, o5 = 1 / 0, i5 = -1 / 0, n4 = 0; n4 < e3.length; n4++) for (var r4 = e3[n4], a5 = 0; a5 < r4.length; a5++) {
              var l4 = r4[a5];
              t6 = Math.min(t6, l4.x), s5 = Math.max(s5, l4.x), o5 = Math.min(o5, l4.y), i5 = Math.max(i5, l4.y);
            }
            return [t6, o5, s5, i5];
          }, i4.prototype.toGeoJSON = s4.prototype.toGeoJSON, k;
        }();
        function o3(e3) {
          var s4 = new t4();
          return function(e4, t5) {
            for (var s5 in e4.layers) t5.writeMessage(3, i3, e4.layers[s5]);
          }(e3, s4), s4.finish();
        }
        function i3(e3, t5) {
          var s4;
          t5.writeVarintField(15, e3.version || 1), t5.writeStringField(1, e3.name || ""), t5.writeVarintField(5, e3.extent || 4096);
          var o4 = { keys: [], values: [], keycache: {}, valuecache: {} };
          for (s4 = 0; s4 < e3.length; s4++) o4.feature = e3.feature(s4), t5.writeMessage(2, n3, o4);
          var i4 = o4.keys;
          for (s4 = 0; s4 < i4.length; s4++) t5.writeStringField(3, i4[s4]);
          var r4 = o4.values;
          for (s4 = 0; s4 < r4.length; s4++) t5.writeMessage(4, h3, r4[s4]);
        }
        function n3(e3, t5) {
          var s4 = e3.feature;
          void 0 !== s4.id && t5.writeVarintField(1, s4.id), t5.writeMessage(2, r3, e3), t5.writeVarintField(3, s4.type), t5.writeMessage(4, c3, s4);
        }
        function r3(e3, t5) {
          var s4 = e3.feature, o4 = e3.keys, i4 = e3.values, n4 = e3.keycache, r4 = e3.valuecache;
          for (var a5 in s4.properties) {
            var l4 = s4.properties[a5], c4 = n4[a5];
            if (null !== l4) {
              void 0 === c4 && (o4.push(a5), n4[a5] = c4 = o4.length - 1), t5.writeVarint(c4);
              var h4 = typeof l4;
              "string" !== h4 && "boolean" !== h4 && "number" !== h4 && (l4 = JSON.stringify(l4));
              var u4 = h4 + ":" + l4, d3 = r4[u4];
              void 0 === d3 && (i4.push(l4), r4[u4] = d3 = i4.length - 1), t5.writeVarint(d3);
            }
          }
        }
        function a4(e3, t5) {
          return (t5 << 3) + (7 & e3);
        }
        function l3(e3) {
          return e3 << 1 ^ e3 >> 31;
        }
        function c3(e3, t5) {
          for (var s4 = e3.loadGeometry(), o4 = e3.type, i4 = 0, n4 = 0, r4 = s4.length, c4 = 0; c4 < r4; c4++) {
            var h4 = s4[c4], u4 = 1;
            1 === o4 && (u4 = h4.length), t5.writeVarint(a4(1, u4));
            for (var d3 = 3 === o4 ? h4.length - 1 : h4.length, f3 = 0; f3 < d3; f3++) {
              1 === f3 && 1 !== o4 && t5.writeVarint(a4(2, d3 - 1));
              var p3 = h4[f3].x - i4, g4 = h4[f3].y - n4;
              t5.writeVarint(l3(p3)), t5.writeVarint(l3(g4)), i4 += p3, n4 += g4;
            }
            3 === o4 && t5.writeVarint(a4(7, 1));
          }
        }
        function h3(e3, t5) {
          var s4 = typeof e3;
          "string" === s4 ? t5.writeStringField(1, e3) : "boolean" === s4 ? t5.writeBooleanField(7, e3) : "number" === s4 && (e3 % 1 != 0 ? t5.writeDoubleField(3, e3) : e3 < 0 ? t5.writeSVarintField(6, e3) : t5.writeVarintField(5, e3));
        }
        return C2.exports = o3, C2.exports.fromVectorTileJs = o3, C2.exports.fromGeojsonVt = function(e3, t5) {
          t5 = t5 || {};
          var i4 = {};
          for (var n4 in e3) i4[n4] = new s3(e3[n4].features, t5), i4[n4].name = n4, i4[n4].version = t5.version, i4[n4].extent = t5.extent;
          return o3({ layers: i4 });
        }, C2.exports.GeoJSONWrapper = s3, C2.exports;
      }(), _ = e2.d$(L2);
      const D = { minZoom: 0, maxZoom: 16, minPoints: 2, radius: 40, extent: 512, nodeSize: 64, log: false, generateId: false, reduce: null, map: (e3) => e3 }, z2 = Math.fround || (j = new Float32Array(1), (e3) => (j[0] = +e3, j[0]));
      var j;
      const O = 3, A2 = 5, F2 = 6;
      class Z2 {
        constructor(e3) {
          this.options = Object.assign(Object.create(D), e3), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
        }
        load(e3) {
          const { log: t4, minZoom: s3, maxZoom: o3 } = this.options;
          t4 && console.time("total time");
          const i3 = `prepare ${e3.length} points`;
          t4 && console.time(i3), this.points = e3;
          const n3 = [];
          for (let t5 = 0; t5 < e3.length; t5++) {
            const s4 = e3[t5];
            if (!s4.geometry) continue;
            const [o4, i4] = s4.geometry.coordinates, r4 = z2(N(o4)), a4 = z2(X(i4));
            n3.push(r4, a4, 1 / 0, t5, -1, 1), this.options.reduce && n3.push(0);
          }
          let r3 = this.trees[o3 + 1] = this._createTree(n3);
          t4 && console.timeEnd(i3);
          for (let e4 = o3; e4 >= s3; e4--) {
            const s4 = +Date.now();
            r3 = this.trees[e4] = this._createTree(this._cluster(r3, e4)), t4 && console.log("z%d: %d clusters in %dms", e4, r3.numItems, +Date.now() - s4);
          }
          return t4 && console.timeEnd("total time"), this;
        }
        getClusters(e3, t4) {
          let s3 = ((e3[0] + 180) % 360 + 360) % 360 - 180;
          const o3 = Math.max(-90, Math.min(90, e3[1]));
          let i3 = 180 === e3[2] ? 180 : ((e3[2] + 180) % 360 + 360) % 360 - 180;
          const n3 = Math.max(-90, Math.min(90, e3[3]));
          if (e3[2] - e3[0] >= 360) s3 = -180, i3 = 180;
          else if (s3 > i3) {
            const e4 = this.getClusters([s3, o3, 180, n3], t4), r4 = this.getClusters([-180, o3, i3, n3], t4);
            return e4.concat(r4);
          }
          const r3 = this.trees[this._limitZoom(t4)], a4 = r3.range(N(s3), X(n3), N(i3), X(o3)), l3 = r3.data, c3 = [];
          for (const e4 of a4) {
            const t5 = this.stride * e4;
            c3.push(l3[t5 + A2] > 1 ? E2(l3, t5, this.clusterProps) : this.points[l3[t5 + O]]);
          }
          return c3;
        }
        getChildren(e3) {
          const t4 = this._getOriginId(e3), s3 = this._getOriginZoom(e3), o3 = "No cluster with the specified id.", i3 = this.trees[s3];
          if (!i3) throw new Error(o3);
          const n3 = i3.data;
          if (t4 * this.stride >= n3.length) throw new Error(o3);
          const r3 = this.options.radius / (this.options.extent * Math.pow(2, s3 - 1)), a4 = i3.within(n3[t4 * this.stride], n3[t4 * this.stride + 1], r3), l3 = [];
          for (const t5 of a4) {
            const s4 = t5 * this.stride;
            n3[s4 + 4] === e3 && l3.push(n3[s4 + A2] > 1 ? E2(n3, s4, this.clusterProps) : this.points[n3[s4 + O]]);
          }
          if (0 === l3.length) throw new Error(o3);
          return l3;
        }
        getLeaves(e3, t4, s3) {
          const o3 = [];
          return this._appendLeaves(o3, e3, t4 = t4 || 10, s3 = s3 || 0, 0), o3;
        }
        getTile(e3, t4, s3) {
          const o3 = this.trees[this._limitZoom(e3)], i3 = Math.pow(2, e3), { extent: n3, radius: r3 } = this.options, a4 = r3 / n3, l3 = (s3 - a4) / i3, c3 = (s3 + 1 + a4) / i3, h3 = { features: [] };
          return this._addTileFeatures(o3.range((t4 - a4) / i3, l3, (t4 + 1 + a4) / i3, c3), o3.data, t4, s3, i3, h3), 0 === t4 && this._addTileFeatures(o3.range(1 - a4 / i3, l3, 1, c3), o3.data, i3, s3, i3, h3), t4 === i3 - 1 && this._addTileFeatures(o3.range(0, l3, a4 / i3, c3), o3.data, -1, s3, i3, h3), h3.features.length ? h3 : null;
        }
        getClusterExpansionZoom(e3) {
          let t4 = this._getOriginZoom(e3) - 1;
          for (; t4 <= this.options.maxZoom; ) {
            const s3 = this.getChildren(e3);
            if (t4++, 1 !== s3.length) break;
            e3 = s3[0].properties.cluster_id;
          }
          return t4;
        }
        _appendLeaves(e3, t4, s3, o3, i3) {
          const n3 = this.getChildren(t4);
          for (const t5 of n3) {
            const n4 = t5.properties;
            if (n4 && n4.cluster ? i3 + n4.point_count <= o3 ? i3 += n4.point_count : i3 = this._appendLeaves(e3, n4.cluster_id, s3, o3, i3) : i3 < o3 ? i3++ : e3.push(t5), e3.length === s3) break;
          }
          return i3;
        }
        _createTree(t4) {
          const s3 = new e2.bz(t4.length / this.stride | 0, this.options.nodeSize, Float32Array);
          for (let e3 = 0; e3 < t4.length; e3 += this.stride) s3.add(t4[e3], t4[e3 + 1]);
          return s3.finish(), s3.data = t4, s3;
        }
        _addTileFeatures(e3, t4, s3, o3, i3, n3) {
          for (const r3 of e3) {
            const e4 = r3 * this.stride, a4 = t4[e4 + A2] > 1;
            let l3, c3, h3;
            if (a4) l3 = Y(t4, e4, this.clusterProps), c3 = t4[e4], h3 = t4[e4 + 1];
            else {
              const s4 = this.points[t4[e4 + O]];
              l3 = s4.properties;
              const [o4, i4] = s4.geometry.coordinates;
              c3 = N(o4), h3 = X(i4);
            }
            const u4 = { type: 1, geometry: [[Math.round(this.options.extent * (c3 * i3 - s3)), Math.round(this.options.extent * (h3 * i3 - o3))]], tags: l3 };
            let d3;
            d3 = a4 || this.options.generateId ? t4[e4 + O] : this.points[t4[e4 + O]].id, void 0 !== d3 && (u4.id = d3), n3.features.push(u4);
          }
        }
        _limitZoom(e3) {
          return Math.max(this.options.minZoom, Math.min(Math.floor(+e3), this.options.maxZoom + 1));
        }
        _cluster(e3, t4) {
          const { radius: s3, extent: o3, reduce: i3, minPoints: n3 } = this.options, r3 = s3 / (o3 * Math.pow(2, t4)), a4 = e3.data, l3 = [], c3 = this.stride;
          for (let s4 = 0; s4 < a4.length; s4 += c3) {
            if (a4[s4 + 2] <= t4) continue;
            a4[s4 + 2] = t4;
            const o4 = a4[s4], h3 = a4[s4 + 1], u4 = e3.within(a4[s4], a4[s4 + 1], r3), d3 = a4[s4 + A2];
            let f3 = d3;
            for (const e4 of u4) {
              const s5 = e4 * c3;
              a4[s5 + 2] > t4 && (f3 += a4[s5 + A2]);
            }
            if (f3 > d3 && f3 >= n3) {
              let e4, n4 = o4 * d3, r4 = h3 * d3, p3 = -1;
              const g4 = (s4 / c3 << 5) + (t4 + 1) + this.points.length;
              for (const o5 of u4) {
                const l4 = o5 * c3;
                if (a4[l4 + 2] <= t4) continue;
                a4[l4 + 2] = t4;
                const h4 = a4[l4 + A2];
                n4 += a4[l4] * h4, r4 += a4[l4 + 1] * h4, a4[l4 + 4] = g4, i3 && (e4 || (e4 = this._map(a4, s4, true), p3 = this.clusterProps.length, this.clusterProps.push(e4)), i3(e4, this._map(a4, l4)));
              }
              a4[s4 + 4] = g4, l3.push(n4 / f3, r4 / f3, 1 / 0, g4, -1, f3), i3 && l3.push(p3);
            } else {
              for (let e4 = 0; e4 < c3; e4++) l3.push(a4[s4 + e4]);
              if (f3 > 1) for (const e4 of u4) {
                const s5 = e4 * c3;
                if (!(a4[s5 + 2] <= t4)) {
                  a4[s5 + 2] = t4;
                  for (let e5 = 0; e5 < c3; e5++) l3.push(a4[s5 + e5]);
                }
              }
            }
          }
          return l3;
        }
        _getOriginId(e3) {
          return e3 - this.points.length >> 5;
        }
        _getOriginZoom(e3) {
          return (e3 - this.points.length) % 32;
        }
        _map(e3, t4, s3) {
          if (e3[t4 + A2] > 1) {
            const o4 = this.clusterProps[e3[t4 + F2]];
            return s3 ? Object.assign({}, o4) : o4;
          }
          const o3 = this.points[e3[t4 + O]].properties, i3 = this.options.map(o3);
          return s3 && i3 === o3 ? Object.assign({}, i3) : i3;
        }
      }
      function E2(e3, t4, s3) {
        return { type: "Feature", id: e3[t4 + O], properties: Y(e3, t4, s3), geometry: { type: "Point", coordinates: [(o3 = e3[t4], 360 * (o3 - 0.5)), W(e3[t4 + 1])] } };
        var o3;
      }
      function Y(e3, t4, s3) {
        const o3 = e3[t4 + A2], i3 = o3 >= 1e4 ? `${Math.round(o3 / 1e3)}k` : o3 >= 1e3 ? Math.round(o3 / 100) / 10 + "k" : o3, n3 = e3[t4 + F2], r3 = -1 === n3 ? {} : Object.assign({}, s3[n3]);
        return Object.assign(r3, { cluster: true, cluster_id: e3[t4 + O], point_count: o3, point_count_abbreviated: i3 });
      }
      function N(e3) {
        return e3 / 360 + 0.5;
      }
      function X(e3) {
        const t4 = Math.sin(e3 * Math.PI / 180), s3 = 0.5 - 0.25 * Math.log((1 + t4) / (1 - t4)) / Math.PI;
        return s3 < 0 ? 0 : s3 > 1 ? 1 : s3;
      }
      function W(e3) {
        const t4 = (180 - 360 * e3) * Math.PI / 180;
        return 360 * Math.atan(Math.exp(t4)) / Math.PI - 90;
      }
      function B3(e3, t4, s3, o3) {
        let i3 = o3;
        const n3 = t4 + (s3 - t4 >> 1);
        let r3, a4 = s3 - t4;
        const l3 = e3[t4], c3 = e3[t4 + 1], h3 = e3[s3], u4 = e3[s3 + 1];
        for (let o4 = t4 + 3; o4 < s3; o4 += 3) {
          const t5 = G(e3[o4], e3[o4 + 1], l3, c3, h3, u4);
          if (t5 > i3) r3 = o4, i3 = t5;
          else if (t5 === i3) {
            const e4 = Math.abs(o4 - n3);
            e4 < a4 && (r3 = o4, a4 = e4);
          }
        }
        i3 > o3 && (r3 - t4 > 3 && B3(e3, t4, r3, o3), e3[r3 + 2] = i3, s3 - r3 > 3 && B3(e3, r3, s3, o3));
      }
      function G(e3, t4, s3, o3, i3, n3) {
        let r3 = i3 - s3, a4 = n3 - o3;
        if (0 !== r3 || 0 !== a4) {
          const l3 = ((e3 - s3) * r3 + (t4 - o3) * a4) / (r3 * r3 + a4 * a4);
          l3 > 1 ? (s3 = i3, o3 = n3) : l3 > 0 && (s3 += r3 * l3, o3 += a4 * l3);
        }
        return r3 = e3 - s3, a4 = t4 - o3, r3 * r3 + a4 * a4;
      }
      function J(e3, t4, s3, o3) {
        const i3 = { id: e3 ?? null, type: t4, geometry: s3, tags: o3, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 };
        if ("Point" === t4 || "MultiPoint" === t4 || "LineString" === t4) R2(i3, s3);
        else if ("Polygon" === t4) R2(i3, s3[0]);
        else if ("MultiLineString" === t4) for (const e4 of s3) R2(i3, e4);
        else if ("MultiPolygon" === t4) for (const e4 of s3) R2(i3, e4[0]);
        return i3;
      }
      function R2(e3, t4) {
        for (let s3 = 0; s3 < t4.length; s3 += 3) e3.minX = Math.min(e3.minX, t4[s3]), e3.minY = Math.min(e3.minY, t4[s3 + 1]), e3.maxX = Math.max(e3.maxX, t4[s3]), e3.maxY = Math.max(e3.maxY, t4[s3 + 1]);
      }
      function V2(e3, t4, s3, o3) {
        if (!t4.geometry) return;
        const i3 = t4.geometry.coordinates;
        if (i3 && 0 === i3.length) return;
        const n3 = t4.geometry.type, r3 = Math.pow(s3.tolerance / ((1 << s3.maxZoom) * s3.extent), 2);
        let a4 = [], l3 = t4.id;
        if (s3.promoteId ? l3 = t4.properties[s3.promoteId] : s3.generateId && (l3 = o3 || 0), "Point" === n3) $2(i3, a4);
        else if ("MultiPoint" === n3) for (const e4 of i3) $2(e4, a4);
        else if ("LineString" === n3) q(i3, a4, r3, false);
        else if ("MultiLineString" === n3) {
          if (s3.lineMetrics) {
            for (const s4 of i3) a4 = [], q(s4, a4, r3, false), e3.push(J(l3, "LineString", a4, t4.properties));
            return;
          }
          U2(i3, a4, r3, false);
        } else if ("Polygon" === n3) U2(i3, a4, r3, true);
        else {
          if ("MultiPolygon" !== n3) {
            if ("GeometryCollection" === n3) {
              for (const i4 of t4.geometry.geometries) V2(e3, { id: l3, geometry: i4, properties: t4.properties }, s3, o3);
              return;
            }
            throw new Error("Input data is not a valid GeoJSON object.");
          }
          for (const e4 of i3) {
            const t5 = [];
            U2(e4, t5, r3, true), a4.push(t5);
          }
        }
        e3.push(J(l3, n3, a4, t4.properties));
      }
      function $2(e3, t4) {
        t4.push(Q2(e3[0]), H(e3[1]), 0);
      }
      function q(e3, t4, s3, o3) {
        let i3, n3, r3 = 0;
        for (let s4 = 0; s4 < e3.length; s4++) {
          const a5 = Q2(e3[s4][0]), l3 = H(e3[s4][1]);
          t4.push(a5, l3, 0), s4 > 0 && (r3 += o3 ? (i3 * l3 - a5 * n3) / 2 : Math.sqrt(Math.pow(a5 - i3, 2) + Math.pow(l3 - n3, 2))), i3 = a5, n3 = l3;
        }
        const a4 = t4.length - 3;
        t4[2] = 1, B3(t4, 0, a4, s3), t4[a4 + 2] = 1, t4.size = Math.abs(r3), t4.start = 0, t4.end = t4.size;
      }
      function U2(e3, t4, s3, o3) {
        for (let i3 = 0; i3 < e3.length; i3++) {
          const n3 = [];
          q(e3[i3], n3, s3, o3), t4.push(n3);
        }
      }
      function Q2(e3) {
        return e3 / 360 + 0.5;
      }
      function H(e3) {
        const t4 = Math.sin(e3 * Math.PI / 180), s3 = 0.5 - 0.25 * Math.log((1 + t4) / (1 - t4)) / Math.PI;
        return s3 < 0 ? 0 : s3 > 1 ? 1 : s3;
      }
      function K(e3, t4, s3, o3, i3, n3, r3, a4) {
        if (o3 /= t4, n3 >= (s3 /= t4) && r3 < o3) return e3;
        if (r3 < s3 || n3 >= o3) return null;
        const l3 = [];
        for (const t5 of e3) {
          const e4 = t5.geometry;
          let n4 = t5.type;
          const r4 = 0 === i3 ? t5.minX : t5.minY, c3 = 0 === i3 ? t5.maxX : t5.maxY;
          if (r4 >= s3 && c3 < o3) {
            l3.push(t5);
            continue;
          }
          if (c3 < s3 || r4 >= o3) continue;
          let h3 = [];
          if ("Point" === n4 || "MultiPoint" === n4) ee(e4, h3, s3, o3, i3);
          else if ("LineString" === n4) te2(e4, h3, s3, o3, i3, false, a4.lineMetrics);
          else if ("MultiLineString" === n4) oe(e4, h3, s3, o3, i3, false);
          else if ("Polygon" === n4) oe(e4, h3, s3, o3, i3, true);
          else if ("MultiPolygon" === n4) for (const t6 of e4) {
            const e5 = [];
            oe(t6, e5, s3, o3, i3, true), e5.length && h3.push(e5);
          }
          if (h3.length) {
            if (a4.lineMetrics && "LineString" === n4) {
              for (const e5 of h3) l3.push(J(t5.id, n4, e5, t5.tags));
              continue;
            }
            "LineString" !== n4 && "MultiLineString" !== n4 || (1 === h3.length ? (n4 = "LineString", h3 = h3[0]) : n4 = "MultiLineString"), "Point" !== n4 && "MultiPoint" !== n4 || (n4 = 3 === h3.length ? "Point" : "MultiPoint"), l3.push(J(t5.id, n4, h3, t5.tags));
          }
        }
        return l3.length ? l3 : null;
      }
      function ee(e3, t4, s3, o3, i3) {
        for (let n3 = 0; n3 < e3.length; n3 += 3) {
          const r3 = e3[n3 + i3];
          r3 >= s3 && r3 <= o3 && ie(t4, e3[n3], e3[n3 + 1], e3[n3 + 2]);
        }
      }
      function te2(e3, t4, s3, o3, i3, n3, r3) {
        let a4 = se(e3);
        const l3 = 0 === i3 ? ne : re;
        let c3, h3, u4 = e3.start;
        for (let d4 = 0; d4 < e3.length - 3; d4 += 3) {
          const f4 = e3[d4], p4 = e3[d4 + 1], g5 = e3[d4 + 2], m2 = e3[d4 + 3], y2 = e3[d4 + 4], x2 = 0 === i3 ? f4 : p4, w2 = 0 === i3 ? m2 : y2;
          let b2 = false;
          r3 && (c3 = Math.sqrt(Math.pow(f4 - m2, 2) + Math.pow(p4 - y2, 2))), x2 < s3 ? w2 > s3 && (h3 = l3(a4, f4, p4, m2, y2, s3), r3 && (a4.start = u4 + c3 * h3)) : x2 > o3 ? w2 < o3 && (h3 = l3(a4, f4, p4, m2, y2, o3), r3 && (a4.start = u4 + c3 * h3)) : ie(a4, f4, p4, g5), w2 < s3 && x2 >= s3 && (h3 = l3(a4, f4, p4, m2, y2, s3), b2 = true), w2 > o3 && x2 <= o3 && (h3 = l3(a4, f4, p4, m2, y2, o3), b2 = true), !n3 && b2 && (r3 && (a4.end = u4 + c3 * h3), t4.push(a4), a4 = se(e3)), r3 && (u4 += c3);
        }
        let d3 = e3.length - 3;
        const f3 = e3[d3], p3 = e3[d3 + 1], g4 = 0 === i3 ? f3 : p3;
        g4 >= s3 && g4 <= o3 && ie(a4, f3, p3, e3[d3 + 2]), d3 = a4.length - 3, n3 && d3 >= 3 && (a4[d3] !== a4[0] || a4[d3 + 1] !== a4[1]) && ie(a4, a4[0], a4[1], a4[2]), a4.length && t4.push(a4);
      }
      function se(e3) {
        const t4 = [];
        return t4.size = e3.size, t4.start = e3.start, t4.end = e3.end, t4;
      }
      function oe(e3, t4, s3, o3, i3, n3) {
        for (const r3 of e3) te2(r3, t4, s3, o3, i3, n3, false);
      }
      function ie(e3, t4, s3, o3) {
        e3.push(t4, s3, o3);
      }
      function ne(e3, t4, s3, o3, i3, n3) {
        const r3 = (n3 - t4) / (o3 - t4);
        return ie(e3, n3, s3 + (i3 - s3) * r3, 1), r3;
      }
      function re(e3, t4, s3, o3, i3, n3) {
        const r3 = (n3 - s3) / (i3 - s3);
        return ie(e3, t4 + (o3 - t4) * r3, n3, 1), r3;
      }
      function ae2(e3, t4) {
        const s3 = [];
        for (let o3 = 0; o3 < e3.length; o3++) {
          const i3 = e3[o3], n3 = i3.type;
          let r3;
          if ("Point" === n3 || "MultiPoint" === n3 || "LineString" === n3) r3 = le(i3.geometry, t4);
          else if ("MultiLineString" === n3 || "Polygon" === n3) {
            r3 = [];
            for (const e4 of i3.geometry) r3.push(le(e4, t4));
          } else if ("MultiPolygon" === n3) {
            r3 = [];
            for (const e4 of i3.geometry) {
              const s4 = [];
              for (const o4 of e4) s4.push(le(o4, t4));
              r3.push(s4);
            }
          }
          s3.push(J(i3.id, n3, r3, i3.tags));
        }
        return s3;
      }
      function le(e3, t4) {
        const s3 = [];
        s3.size = e3.size, void 0 !== e3.start && (s3.start = e3.start, s3.end = e3.end);
        for (let o3 = 0; o3 < e3.length; o3 += 3) s3.push(e3[o3] + t4, e3[o3 + 1], e3[o3 + 2]);
        return s3;
      }
      function ce(e3, t4) {
        if (e3.transformed) return e3;
        const s3 = 1 << e3.z, o3 = e3.x, i3 = e3.y;
        for (const n3 of e3.features) {
          const e4 = n3.geometry, r3 = n3.type;
          if (n3.geometry = [], 1 === r3) for (let r4 = 0; r4 < e4.length; r4 += 2) n3.geometry.push(he(e4[r4], e4[r4 + 1], t4, s3, o3, i3));
          else for (let r4 = 0; r4 < e4.length; r4++) {
            const a4 = [];
            for (let n4 = 0; n4 < e4[r4].length; n4 += 2) a4.push(he(e4[r4][n4], e4[r4][n4 + 1], t4, s3, o3, i3));
            n3.geometry.push(a4);
          }
        }
        return e3.transformed = true, e3;
      }
      function he(e3, t4, s3, o3, i3, n3) {
        return [Math.round(s3 * (e3 * o3 - i3)), Math.round(s3 * (t4 * o3 - n3))];
      }
      function ue2(e3, t4, s3, o3, i3) {
        const n3 = t4 === i3.maxZoom ? 0 : i3.tolerance / ((1 << t4) * i3.extent), r3 = { features: [], numPoints: 0, numSimplified: 0, numFeatures: e3.length, source: null, x: s3, y: o3, z: t4, transformed: false, minX: 2, minY: 1, maxX: -1, maxY: 0 };
        for (const t5 of e3) de(r3, t5, n3, i3);
        return r3;
      }
      function de(e3, t4, s3, o3) {
        const i3 = t4.geometry, n3 = t4.type, r3 = [];
        if (e3.minX = Math.min(e3.minX, t4.minX), e3.minY = Math.min(e3.minY, t4.minY), e3.maxX = Math.max(e3.maxX, t4.maxX), e3.maxY = Math.max(e3.maxY, t4.maxY), "Point" === n3 || "MultiPoint" === n3) for (let t5 = 0; t5 < i3.length; t5 += 3) r3.push(i3[t5], i3[t5 + 1]), e3.numPoints++, e3.numSimplified++;
        else if ("LineString" === n3) fe(r3, i3, e3, s3, false, false);
        else if ("MultiLineString" === n3 || "Polygon" === n3) for (let t5 = 0; t5 < i3.length; t5++) fe(r3, i3[t5], e3, s3, "Polygon" === n3, 0 === t5);
        else if ("MultiPolygon" === n3) for (let t5 = 0; t5 < i3.length; t5++) {
          const o4 = i3[t5];
          for (let t6 = 0; t6 < o4.length; t6++) fe(r3, o4[t6], e3, s3, true, 0 === t6);
        }
        if (r3.length) {
          let s4 = t4.tags || null;
          if ("LineString" === n3 && o3.lineMetrics) {
            s4 = {};
            for (const e4 in t4.tags) s4[e4] = t4.tags[e4];
            s4.mapbox_clip_start = i3.start / i3.size, s4.mapbox_clip_end = i3.end / i3.size;
          }
          const a4 = { geometry: r3, type: "Polygon" === n3 || "MultiPolygon" === n3 ? 3 : "LineString" === n3 || "MultiLineString" === n3 ? 2 : 1, tags: s4 };
          null !== t4.id && (a4.id = t4.id), e3.features.push(a4);
        }
      }
      function fe(e3, t4, s3, o3, i3, n3) {
        const r3 = o3 * o3;
        if (o3 > 0 && t4.size < (i3 ? r3 : o3)) return void (s3.numPoints += t4.length / 3);
        const a4 = [];
        for (let e4 = 0; e4 < t4.length; e4 += 3) (0 === o3 || t4[e4 + 2] > r3) && (s3.numSimplified++, a4.push(t4[e4], t4[e4 + 1])), s3.numPoints++;
        i3 && function(e4, t5) {
          let s4 = 0;
          for (let t6 = 0, o4 = e4.length, i4 = o4 - 2; t6 < o4; i4 = t6, t6 += 2) s4 += (e4[t6] - e4[i4]) * (e4[t6 + 1] + e4[i4 + 1]);
          if (s4 > 0 === t5) for (let t6 = 0, s5 = e4.length; t6 < s5 / 2; t6 += 2) {
            const o4 = e4[t6], i4 = e4[t6 + 1];
            e4[t6] = e4[s5 - 2 - t6], e4[t6 + 1] = e4[s5 - 1 - t6], e4[s5 - 2 - t6] = o4, e4[s5 - 1 - t6] = i4;
          }
        }(a4, n3), e3.push(a4);
      }
      const pe = { maxZoom: 14, indexMaxZoom: 5, indexMaxPoints: 1e5, tolerance: 3, extent: 4096, buffer: 64, lineMetrics: false, promoteId: null, generateId: false, debug: 0 };
      class ge2 {
        constructor(e3, t4) {
          const s3 = (t4 = this.options = function(e4, t5) {
            for (const s4 in t5) e4[s4] = t5[s4];
            return e4;
          }(Object.create(pe), t4)).debug;
          if (s3 && console.time("preprocess data"), t4.maxZoom < 0 || t4.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
          if (t4.promoteId && t4.generateId) throw new Error("promoteId and generateId cannot be used together.");
          let o3 = function(e4, t5) {
            const s4 = [];
            if ("FeatureCollection" === e4.type) for (let o4 = 0; o4 < e4.features.length; o4++) V2(s4, e4.features[o4], t5, o4);
            else V2(s4, "Feature" === e4.type ? e4 : { geometry: e4 }, t5);
            return s4;
          }(e3, t4);
          this.tiles = {}, this.tileCoords = [], s3 && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t4.indexMaxZoom, t4.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), o3 = function(e4, t5) {
            const s4 = t5.buffer / t5.extent;
            let o4 = e4;
            const i3 = K(e4, 1, -1 - s4, s4, 0, -1, 2, t5), n3 = K(e4, 1, 1 - s4, 2 + s4, 0, -1, 2, t5);
            return (i3 || n3) && (o4 = K(e4, 1, -s4, 1 + s4, 0, -1, 2, t5) || [], i3 && (o4 = ae2(i3, 1).concat(o4)), n3 && (o4 = o4.concat(ae2(n3, -1)))), o4;
          }(o3, t4), o3.length && this.splitTile(o3, 0, 0, 0), s3 && (o3.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
        }
        splitTile(e3, t4, s3, o3, i3, n3, r3) {
          const a4 = [e3, t4, s3, o3], l3 = this.options, c3 = l3.debug;
          for (; a4.length; ) {
            o3 = a4.pop(), s3 = a4.pop(), t4 = a4.pop(), e3 = a4.pop();
            const h3 = 1 << t4, u4 = me(t4, s3, o3);
            let d3 = this.tiles[u4];
            if (!d3 && (c3 > 1 && console.time("creation"), d3 = this.tiles[u4] = ue2(e3, t4, s3, o3, l3), this.tileCoords.push({ z: t4, x: s3, y: o3 }), c3)) {
              c3 > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t4, s3, o3, d3.numFeatures, d3.numPoints, d3.numSimplified), console.timeEnd("creation"));
              const e4 = `z${t4}`;
              this.stats[e4] = (this.stats[e4] || 0) + 1, this.total++;
            }
            if (d3.source = e3, null == i3) {
              if (t4 === l3.indexMaxZoom || d3.numPoints <= l3.indexMaxPoints) continue;
            } else {
              if (t4 === l3.maxZoom || t4 === i3) continue;
              if (null != i3) {
                const e4 = i3 - t4;
                if (s3 !== n3 >> e4 || o3 !== r3 >> e4) continue;
              }
            }
            if (d3.source = null, 0 === e3.length) continue;
            c3 > 1 && console.time("clipping");
            const f3 = 0.5 * l3.buffer / l3.extent, p3 = 0.5 - f3, g4 = 0.5 + f3, m2 = 1 + f3;
            let y2 = null, x2 = null, w2 = null, b2 = null, S2 = K(e3, h3, s3 - f3, s3 + g4, 0, d3.minX, d3.maxX, l3), v2 = K(e3, h3, s3 + p3, s3 + m2, 0, d3.minX, d3.maxX, l3);
            e3 = null, S2 && (y2 = K(S2, h3, o3 - f3, o3 + g4, 1, d3.minY, d3.maxY, l3), x2 = K(S2, h3, o3 + p3, o3 + m2, 1, d3.minY, d3.maxY, l3), S2 = null), v2 && (w2 = K(v2, h3, o3 - f3, o3 + g4, 1, d3.minY, d3.maxY, l3), b2 = K(v2, h3, o3 + p3, o3 + m2, 1, d3.minY, d3.maxY, l3), v2 = null), c3 > 1 && console.timeEnd("clipping"), a4.push(y2 || [], t4 + 1, 2 * s3, 2 * o3), a4.push(x2 || [], t4 + 1, 2 * s3, 2 * o3 + 1), a4.push(w2 || [], t4 + 1, 2 * s3 + 1, 2 * o3), a4.push(b2 || [], t4 + 1, 2 * s3 + 1, 2 * o3 + 1);
          }
        }
        getTile(e3, t4, s3) {
          e3 = +e3, t4 = +t4, s3 = +s3;
          const o3 = this.options, { extent: i3, debug: n3 } = o3;
          if (e3 < 0 || e3 > 24) return null;
          const r3 = 1 << e3, a4 = me(e3, t4 = t4 + r3 & r3 - 1, s3);
          if (this.tiles[a4]) return ce(this.tiles[a4], i3);
          n3 > 1 && console.log("drilling down to z%d-%d-%d", e3, t4, s3);
          let l3, c3 = e3, h3 = t4, u4 = s3;
          for (; !l3 && c3 > 0; ) c3--, h3 >>= 1, u4 >>= 1, l3 = this.tiles[me(c3, h3, u4)];
          return l3 && l3.source ? (n3 > 1 && (console.log("found parent tile z%d-%d-%d", c3, h3, u4), console.time("drilling down")), this.splitTile(l3.source, c3, h3, u4, e3, t4, s3), n3 > 1 && console.timeEnd("drilling down"), this.tiles[a4] ? ce(this.tiles[a4], i3) : null) : null;
        }
      }
      function me(e3, t4, s3) {
        return 32 * ((1 << e3) * s3 + t4) + e3;
      }
      function ye(e3, t4) {
        const s3 = e3.tileID.canonical;
        if (!this._geoJSONIndex) return void t4(null, null);
        const o3 = this._geoJSONIndex.getTile(s3.z, s3.x, s3.y);
        if (!o3) return void t4(null, null);
        const i3 = new p2(o3.features);
        let n3 = _(i3);
        0 === n3.byteOffset && n3.byteLength === n3.buffer.byteLength || (n3 = new Uint8Array(n3)), t4(null, { vectorTile: i3, rawData: n3.buffer });
      }
      class xe extends c2 {
        constructor(e3, t4, s3, o3, i3, n3) {
          super(e3, t4, s3, o3, ye, n3), i3 && (this.loadGeoJSON = i3), this._dynamicIndex = new y();
        }
        loadData(s3, o3) {
          const i3 = s3 && s3.request, n3 = i3 && i3.collectResourceTiming;
          this.loadGeoJSON(s3, (r3, a4) => {
            if (r3 || !a4) return o3(r3);
            if ("object" != typeof a4) return o3(new Error(`Input data given to '${s3.source}' is not a valid GeoJSON object.`));
            {
              try {
                if (s3.filter) {
                  const t4 = e2.M(s3.filter, { type: "boolean", "property-type": "data-driven", overridable: false, transition: false });
                  if ("error" === t4.result) throw new Error(t4.value.map((e3) => `${e3.key}: ${e3.message}`).join(", "));
                  a4.features = a4.features.filter((e3) => t4.value.evaluate({ zoom: 0 }, e3));
                }
                s3.dynamic ? ("Feature" === a4.type && (a4 = { type: "FeatureCollection", features: [a4] }), s3.append || (this._dynamicIndex.clear(), this.loaded = {}), this._dynamicIndex.load(a4.features, this.loaded), s3.cluster && (a4.features = this._dynamicIndex.getFeatures())) : this.loaded = {}, this._geoJSONIndex = s3.cluster ? new Z2(function({ superclusterOptions: t4, clusterProperties: s4 }) {
                  if (!s4 || !t4) return t4;
                  const o4 = {}, i4 = {}, n4 = { accumulated: null, zoom: 0 }, r5 = { properties: null }, a5 = Object.keys(s4);
                  for (const t5 of a5) {
                    const [n5, r6] = s4[t5], a6 = e2.M(r6), l3 = e2.M("string" == typeof n5 ? [n5, ["accumulated"], ["get", t5]] : n5);
                    o4[t5] = a6.value, i4[t5] = l3.value;
                  }
                  return t4.map = (e3) => {
                    r5.properties = e3;
                    const t5 = {};
                    for (const e4 of a5) t5[e4] = o4[e4].evaluate(n4, r5);
                    return t5;
                  }, t4.reduce = (e3, t5) => {
                    r5.properties = t5;
                    for (const t6 of a5) n4.accumulated = e3[t6], e3[t6] = i4[t6].evaluate(n4, r5);
                  }, t4;
                }(s3)).load(a4.features) : s3.dynamic ? this._dynamicIndex : function(e3, t4) {
                  return new ge2(e3, t4);
                }(a4, s3.geojsonVtOptions);
              } catch (e3) {
                return o3(e3);
              }
              const r4 = {};
              if (n3) {
                const e3 = t3(i3);
                e3 && (r4.resourceTiming = {}, r4.resourceTiming[s3.source] = JSON.parse(JSON.stringify(e3)));
              }
              o3(null, r4);
            }
          });
        }
        reloadTile(e3, t4) {
          const s3 = this.loaded;
          return s3 && s3[e3.uid] ? e3.partial ? t4(null, void 0) : super.reloadTile(e3, t4) : this.loadTile(e3, t4);
        }
        loadGeoJSON(t4, s3) {
          if (t4.request) e2.o(t4.request, s3);
          else {
            if ("string" != typeof t4.data) return s3(new Error(`Input data given to '${t4.source}' is not a valid GeoJSON object.`));
            try {
              return s3(null, JSON.parse(t4.data));
            } catch (e3) {
              return s3(new Error(`Input data given to '${t4.source}' is not a valid GeoJSON object.`));
            }
          }
        }
        getClusterExpansionZoom(e3, t4) {
          try {
            t4(null, this._geoJSONIndex.getClusterExpansionZoom(e3.clusterId));
          } catch (e4) {
            t4(e4);
          }
        }
        getClusterChildren(e3, t4) {
          try {
            t4(null, this._geoJSONIndex.getChildren(e3.clusterId));
          } catch (e4) {
            t4(e4);
          }
        }
        getClusterLeaves(e3, t4) {
          try {
            t4(null, this._geoJSONIndex.getLeaves(e3.clusterId, e3.limit, e3.offset));
          } catch (e4) {
            t4(e4);
          }
        }
      }
      class we2 {
        constructor(t4, s3) {
          this.tileID = new e2.aA(t4.tileID.overscaledZ, t4.tileID.wrap, t4.tileID.canonical.z, t4.tileID.canonical.x, t4.tileID.canonical.y), this.tileZoom = t4.tileZoom, this.uid = t4.uid, this.zoom = t4.zoom, this.canonical = t4.tileID.canonical, this.pixelRatio = t4.pixelRatio, this.tileSize = t4.tileSize, this.source = t4.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = t4.projection, this.brightness = s3;
        }
        parse(t4, s3, o3, i3) {
          this.status = "parsing";
          const n3 = new e2.aA(o3.tileID.overscaledZ, o3.tileID.wrap, o3.tileID.canonical.z, o3.tileID.canonical.x, o3.tileID.canonical.y), r3 = [], a4 = s3.familiesBySource[o3.source], l3 = new e2.dR(n3, o3.promoteId);
          return l3.bucketLayerIDs = [], l3.is3DTile = true, e2.e0(t4).then((t5) => {
            if (!t5) return i3(new Error("Could not parse tile"));
            const s4 = e2.e1(t5, 1 / e2.c9(o3.tileID.canonical)), c3 = t5.json.extensionsUsed && t5.json.extensionsUsed.includes("MAPBOX_mesh_features") || t5.json.asset.extras && t5.json.asset.extras.MAPBOX_mesh_features, h3 = t5.json.extensionsUsed && t5.json.extensionsUsed.includes("EXT_meshopt_compression"), u4 = new e2.a3(this.zoom, { brightness: this.brightness });
            for (const t6 in a4) for (const o4 of a4[t6]) {
              const t7 = o4[0];
              l3.bucketLayerIDs.push(o4.map((t8) => e2.av(t8.id, t8.scope))), t7.recalculate(u4, []);
              const i4 = new e2.e2(o4, s4, n3, c3, h3, this.brightness, l3);
              c3 || (i4.needsUpload = true), r3.push(i4), i4.evaluate(t7);
            }
            this.status = "done", i3(null, { buckets: r3, featureIndex: l3, collisionBoxArray: null, glyphAtlasImage: null, lineAtlas: null, imageAtlas: null, brightness: null });
          }).catch((e3) => i3(new Error(e3.message)));
        }
      }
      class be {
        constructor(e3, t4, s3, o3, i3, n3) {
          this.actor = e3, this.layerIndex = t4, this.availableImages = s3, this.brightness = n3, this.loading = {}, this.loaded = {};
        }
        loadTile(t4, s3) {
          const o3 = t4.uid, i3 = this.loading[o3] = new we2(t4, this.brightness);
          e2.bd(t4.request, (e3, n3) => {
            const r3 = !this.loading[o3];
            return delete this.loading[o3], r3 || e3 ? (i3.status = "done", r3 || (this.loaded[o3] = i3), s3(e3)) : n3 && 0 !== n3.byteLength ? void i3.parse(n3, this.layerIndex, t4, (e4, t5) => {
              i3.status = "done", this.loaded = this.loaded || {}, this.loaded[o3] = i3, e4 || !t5 ? s3(e4) : s3(null, t5);
            }) : (i3.status = "done", this.loaded[o3] = i3, s3());
          });
        }
        reloadTile(e3, t4) {
          const s3 = this.loaded, o3 = e3.uid;
          if (s3 && s3[o3]) {
            const i3 = s3[o3];
            i3.projection = e3.projection, i3.brightness = e3.brightness;
            const n3 = (s4, o4) => {
              i3.reloadCallback && (delete i3.reloadCallback, this.loadTile(e3, t4)), t4(s4, o4);
            };
            "parsing" === i3.status ? i3.reloadCallback = n3 : "done" === i3.status && this.loadTile(e3, t4);
          }
        }
        abortTile(e3, t4) {
          const s3 = e3.uid;
          this.loading[s3] && delete this.loading[s3], t4();
        }
        removeTile(e3, t4) {
          const s3 = this.loaded, o3 = e3.uid;
          s3 && s3[o3] && delete s3[o3], t4();
        }
      }
      class Se {
        constructor(t4) {
          this.self = t4, this.actor = new e2.e3(t4, this), this.layerIndexes = {}, this.availableImages = {}, this.isSpriteLoaded = {}, this.projections = {}, this.defaultProjection = e2.bM({ name: "mercator" }), this.workerSourceTypes = { vector: c2, geojson: xe, "batched-model": be }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (e3, t5) => {
            if (this.workerSourceTypes[e3]) throw new Error(`Worker source with name "${e3}" already registered.`);
            this.workerSourceTypes[e3] = t5;
          }, this.self.registerRTLTextPlugin = (t5) => {
            if (e2.e4.isParsed()) throw new Error("RTL text plugin already registered.");
            e2.e4.applyArabicShaping = t5.applyArabicShaping, e2.e4.processBidirectionalText = t5.processBidirectionalText, e2.e4.processStyledBidirectionalText = t5.processStyledBidirectionalText;
          };
        }
        clearCaches(e3, t4, s3) {
          delete this.layerIndexes[e3], delete this.availableImages[e3], delete this.workerSources[e3], delete this.demWorkerSources[e3], delete this.rasterArrayWorkerSource, s3();
        }
        checkIfReady(e3, t4, s3) {
          s3();
        }
        setReferrer(e3, t4) {
          this.referrer = t4;
        }
        spriteLoaded(t4, { scope: s3, isLoaded: o3 }) {
          if (this.isSpriteLoaded[t4] || (this.isSpriteLoaded[t4] = {}), this.isSpriteLoaded[t4][s3] = o3, this.workerSources[t4] && this.workerSources[t4][s3]) for (const i3 in this.workerSources[t4][s3]) {
            const n3 = this.workerSources[t4][s3][i3];
            for (const t5 in n3) {
              const s4 = n3[t5];
              s4 instanceof c2 && (s4.isSpriteLoaded = o3, s4.fire(new e2.x("isSpriteLoaded")));
            }
          }
        }
        setImages(e3, { scope: t4, images: s3 }, o3) {
          if (this.availableImages[e3] || (this.availableImages[e3] = {}), this.availableImages[e3][t4] = s3, this.workerSources[e3] && this.workerSources[e3][t4]) {
            for (const o4 in this.workerSources[e3][t4]) {
              const i3 = this.workerSources[e3][t4][o4];
              for (const e4 in i3) i3[e4].availableImages = s3;
            }
            o3();
          } else o3();
        }
        setProjection(t4, s3) {
          this.projections[t4] = e2.bM(s3);
        }
        setBrightness(e3, t4, s3) {
          this.brightness = t4, s3();
        }
        setLayers(e3, t4, s3) {
          this.getLayerIndex(e3, t4.scope).replace(t4.layers, t4.options), s3();
        }
        updateLayers(e3, t4, s3) {
          this.getLayerIndex(e3, t4.scope).update(t4.layers, t4.removedIds, t4.options), s3();
        }
        loadTile(e3, t4, s3) {
          t4.projection = this.projections[e3] || this.defaultProjection, this.getWorkerSource(e3, t4.type, t4.source, t4.scope).loadTile(t4, s3);
        }
        loadDEMTile(e3, t4, s3) {
          this.getDEMWorkerSource(e3, t4.source, t4.scope).loadTile(t4, s3);
        }
        decodeRasterArray(e3, t4, s3) {
          this.getRasterArrayWorkerSource().decodeRasterArray(t4, s3);
        }
        reloadTile(e3, t4, s3) {
          t4.projection = this.projections[e3] || this.defaultProjection, this.getWorkerSource(e3, t4.type, t4.source, t4.scope).reloadTile(t4, s3);
        }
        abortTile(e3, t4, s3) {
          this.getWorkerSource(e3, t4.type, t4.source, t4.scope).abortTile(t4, s3);
        }
        removeTile(e3, t4, s3) {
          this.getWorkerSource(e3, t4.type, t4.source, t4.scope).removeTile(t4, s3);
        }
        removeSource(e3, t4, s3) {
          if (!(this.workerSources[e3] && this.workerSources[e3][t4.scope] && this.workerSources[e3][t4.scope][t4.type] && this.workerSources[e3][t4.scope][t4.type][t4.source])) return;
          const o3 = this.workerSources[e3][t4.scope][t4.type][t4.source];
          delete this.workerSources[e3][t4.scope][t4.type][t4.source], void 0 !== o3.removeSource ? o3.removeSource(t4, s3) : s3();
        }
        loadWorkerSource(e3, t4, s3) {
          try {
            this.self.importScripts(t4.url), s3();
          } catch (e4) {
            s3(e4.toString());
          }
        }
        syncRTLPluginState(t4, s3, o3) {
          try {
            e2.e4.setState(s3);
            const t5 = e2.e4.getPluginURL();
            if (e2.e4.isLoaded() && !e2.e4.isParsed() && null != t5) {
              this.self.importScripts(t5);
              const s4 = e2.e4.isParsed();
              o3(s4 ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${t5}`), s4);
            }
          } catch (e3) {
            o3(e3.toString());
          }
        }
        setDracoUrl(e3, t4) {
          this.dracoUrl = t4;
        }
        getAvailableImages(e3, t4) {
          this.availableImages[e3] || (this.availableImages[e3] = {});
          let s3 = this.availableImages[e3][t4];
          return s3 || (s3 = []), s3;
        }
        getLayerIndex(e3, t4) {
          this.layerIndexes[e3] || (this.layerIndexes[e3] = {});
          let s3 = this.layerIndexes[e3][t4];
          return s3 || (s3 = this.layerIndexes[e3][t4] = new i2(), s3.scope = t4), s3;
        }
        getWorkerSource(e3, t4, s3, o3) {
          return this.workerSources[e3] || (this.workerSources[e3] = {}), this.workerSources[e3][o3] || (this.workerSources[e3][o3] = {}), this.workerSources[e3][o3][t4] || (this.workerSources[e3][o3][t4] = {}), this.isSpriteLoaded[e3] || (this.isSpriteLoaded[e3] = {}), this.workerSources[e3][o3][t4][s3] || (this.workerSources[e3][o3][t4][s3] = new this.workerSourceTypes[t4]({ send: (t5, s4, o4, i3, n3, r3) => {
            this.actor.send(t5, s4, o4, e3, n3, r3);
          }, scheduler: this.actor.scheduler }, this.getLayerIndex(e3, o3), this.getAvailableImages(e3, o3), this.isSpriteLoaded[e3][o3], void 0, this.brightness)), this.workerSources[e3][o3][t4][s3];
        }
        getDEMWorkerSource(e3, t4, s3) {
          return this.demWorkerSources[e3] || (this.demWorkerSources[e3] = {}), this.demWorkerSources[e3][s3] || (this.demWorkerSources[e3][s3] = {}), this.demWorkerSources[e3][s3][t4] || (this.demWorkerSources[e3][s3][t4] = new h2()), this.demWorkerSources[e3][s3][t4];
        }
        getRasterArrayWorkerSource() {
          return this.rasterArrayWorkerSource || (this.rasterArrayWorkerSource = new u3()), this.rasterArrayWorkerSource;
        }
        enforceCacheSizeLimit(t4, s3) {
          e2.e5(s3);
        }
        getWorkerPerformanceMetrics(e3, t4, s3) {
          s3(void 0, void 0);
        }
      }
      return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope && (self.worker = new Se(self)), Se;
    });
    define(["./shared"], function(e2) {
      var t3 = "0.0.1";
      const i2 = { create: "create", load: "load", fullLoad: "fullLoad" }, o2 = { mark(e3) {
        performance.mark(e3);
      }, measure(e3, t4, i3) {
        performance.measure(e3, t4, i3);
      } };
      function s2(t4) {
        const i3 = t4.name.split("?")[0];
        return e2.a(i3) && i3.includes("mapbox-gl.js") ? "javascript" : e2.a(i3) && i3.includes("mapbox-gl.css") ? "css" : e2.b(i3) ? "fontRange" : e2.c(i3) ? "sprite" : e2.i(i3) ? "style" : e2.d(i3) ? "tilejson" : "other";
      }
      var r2, a3 = {}, n2 = function() {
        if (r2) return a3;
        function e3(e4) {
          return !t4(e4);
        }
        function t4(t5) {
          return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : function() {
            if (!("Worker" in window && "Blob" in window && "URL" in window)) return false;
            var e4, t6, i4 = new Blob([""], { type: "text/javascript" }), o4 = URL.createObjectURL(i4);
            try {
              t6 = new Worker(o4), e4 = true;
            } catch (t7) {
              e4 = false;
            }
            return t6 && t6.terminate(), URL.revokeObjectURL(o4), e4;
          }() ? function() {
            var e4 = document.createElement("canvas");
            e4.width = e4.height = 1;
            var t6 = e4.getContext("2d");
            if (!t6) return false;
            var i4 = t6.getImageData(0, 0, 1, 1);
            return i4 && i4.width === e4.width;
          }() ? (void 0 === i3[o3 = t5 && t5.failIfMajorPerformanceCaveat] && (i3[o3] = function(t6) {
            var i4, o4 = function(t7) {
              var i5 = document.createElement("canvas"), o5 = Object.create(e3.webGLContextAttributes);
              return o5.failIfMajorPerformanceCaveat = t7, i5.getContext("webgl2", o5);
            }(t6);
            if (!o4) return false;
            try {
              i4 = o4.createShader(o4.VERTEX_SHADER);
            } catch (e4) {
              return false;
            }
            return !(!i4 || o4.isContextLost()) && (o4.shaderSource(i4, "void main() {}"), o4.compileShader(i4), true === o4.getShaderParameter(i4, o4.COMPILE_STATUS));
          }(o3)), i3[o3] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL2 support") : "insufficient Canvas/getImageData support" : "insufficient worker support";
          var o3;
        }
        r2 = 1, a3.supported = e3, a3.notSupportedReason = t4;
        var i3 = {};
        return e3.webGLContextAttributes = { antialias: false, alpha: true, stencil: true, depth: true }, a3;
      }();
      function l2(e3, t4, i3) {
        const o3 = document.createElement(e3);
        return null != t4 && (o3.className = t4), i3 && i3.appendChild(o3), o3;
      }
      function c2(e3, t4, i3) {
        const o3 = document.createElementNS("http://www.w3.org/2000/svg", e3);
        for (const e4 of Object.keys(t4)) o3.setAttributeNS(null, e4, String(t4[e4]));
        return i3 && i3.appendChild(o3), o3;
      }
      const h2 = "undefined" != typeof document ? document.documentElement && document.documentElement.style : null, u3 = h2 && void 0 !== h2.userSelect ? "userSelect" : "WebkitUserSelect";
      let d2;
      function _() {
        h2 && u3 && (d2 = h2[u3], h2[u3] = "none");
      }
      function p2() {
        h2 && u3 && (h2[u3] = d2);
      }
      function f2(e3) {
        e3.preventDefault(), e3.stopPropagation(), window.removeEventListener("click", f2, true);
      }
      function m() {
        window.addEventListener("click", f2, true), window.setTimeout(() => {
          window.removeEventListener("click", f2, true);
        }, 0);
      }
      function g3(e3, t4) {
        const i3 = e3.getBoundingClientRect();
        return y(e3, i3, t4);
      }
      function v(e3, t4) {
        const i3 = e3.getBoundingClientRect(), o3 = [];
        for (let s3 = 0; s3 < t4.length; s3++) o3.push(y(e3, i3, t4[s3]));
        return o3;
      }
      function x(e3) {
        return void 0 !== window.InstallTrigger && 2 === e3.button && e3.ctrlKey && window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : e3.button;
      }
      function y(t4, i3, o3) {
        const s3 = t4.offsetWidth === i3.width ? 1 : t4.offsetWidth / i3.width;
        return new e2.P((o3.clientX - i3.left) * s3, (o3.clientY - i3.top) * s3);
      }
      const b = "01", w = "NO_ACCESS_TOKEN";
      class T2 {
        constructor(e3, t4, i3) {
          this._transformRequestFn = e3, this._customAccessToken = t4, this._silenceAuthErrors = !!i3, this._createSkuToken();
        }
        _createSkuToken() {
          const e3 = function() {
            let e4 = "";
            for (let t4 = 0; t4 < 10; t4++) e4 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
            return { token: ["1", b, e4].join(""), tokenExpiresAt: Date.now() + 432e5 };
          }();
          this._skuToken = e3.token, this._skuTokenExpiresAt = e3.tokenExpiresAt;
        }
        _isSkuTokenExpired() {
          return Date.now() > this._skuTokenExpiresAt;
        }
        transformRequest(e3, t4) {
          return this._transformRequestFn && this._transformRequestFn(e3, t4) || { url: e3 };
        }
        normalizeStyleURL(i3, o3) {
          if (!e2.h(i3)) return i3;
          const s3 = S(i3);
          return s3.params.push(`sdk=js-${t3}`), s3.path = `/styles/v1${s3.path}`, this._makeAPIURL(s3, this._customAccessToken || o3);
        }
        normalizeGlyphsURL(t4, i3) {
          if (!e2.h(t4)) return t4;
          const o3 = S(t4);
          return o3.path = `/fonts/v1${o3.path}`, this._makeAPIURL(o3, this._customAccessToken || i3);
        }
        normalizeModelURL(t4, i3) {
          if (!e2.h(t4)) return t4;
          const o3 = S(t4);
          return o3.path = `/models/v1${o3.path}`, this._makeAPIURL(o3, this._customAccessToken || i3);
        }
        normalizeSourceURL(t4, i3, o3, s3) {
          if (!e2.h(t4)) return t4;
          const r3 = S(t4);
          return r3.path = `/v4/${r3.authority}.json`, r3.params.push("secure"), o3 && r3.params.push(`language=${o3}`), s3 && r3.params.push(`worldview=${s3}`), this._makeAPIURL(r3, this._customAccessToken || i3);
        }
        normalizeSpriteURL(t4, i3, o3, s3) {
          const r3 = S(t4);
          return e2.h(t4) ? (r3.path = `/styles/v1${r3.path}/sprite${i3}${o3}`, this._makeAPIURL(r3, this._customAccessToken || s3)) : (r3.path += `${i3}${o3}`, C2(r3));
        }
        normalizeTileURL(t4, i3, o3) {
          if (this._isSkuTokenExpired() && this._createSkuToken(), t4 && !e2.h(t4)) return t4;
          const s3 = S(t4);
          s3.path = s3.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${i3 || o3 && "raster" !== s3.authority && 512 === o3 ? "@2x" : ""}${e2.n.supported ? ".webp" : "$1"}`), "raster" === s3.authority ? s3.path = `/${e2.f.RASTER_URL_PREFIX}${s3.path}` : "rasterarrays" === s3.authority ? s3.path = `/${e2.f.RASTERARRAYS_URL_PREFIX}${s3.path}` : "3dtiles" === s3.authority ? s3.path = `/${e2.f.TILES3D_URL_PREFIX}${s3.path}` : (s3.path = s3.path.replace(/^.+\/v4\//, "/"), s3.path = `/${e2.f.TILE_URL_VERSION}${s3.path}`);
          const r3 = this._customAccessToken || function(e3) {
            for (const t5 of e3) {
              const e4 = t5.match(/^access_token=(.*)$/);
              if (e4) return e4[1];
            }
            return null;
          }(s3.params) || e2.f.ACCESS_TOKEN;
          return e2.f.REQUIRE_ACCESS_TOKEN && r3 && this._skuToken && s3.params.push(`sku=${this._skuToken}`), this._makeAPIURL(s3, r3);
        }
        canonicalizeTileURL(t4, i3) {
          const o3 = S(t4);
          if (!o3.path.match(/^(\/v4\/|\/(raster|rasterarrays)\/v1\/)/) || !o3.path.match(/\.[\w]+$/)) return t4;
          let s3 = "mapbox://";
          o3.path.match(/^\/raster\/v1\//) ? s3 += `raster/${o3.path.replace(`/${e2.f.RASTER_URL_PREFIX}/`, "")}` : o3.path.match(/^\/rasterarrays\/v1\//) ? s3 += `rasterarrays/${o3.path.replace(`/${e2.f.RASTERARRAYS_URL_PREFIX}/`, "")}` : s3 += `tiles/${o3.path.replace(`/${e2.f.TILE_URL_VERSION}/`, "")}`;
          let r3 = o3.params;
          return i3 && (r3 = r3.filter((e3) => !e3.match(/^access_token=/))), r3.length && (s3 += `?${r3.join("&")}`), s3;
        }
        canonicalizeTileset(t4, i3) {
          const o3 = !!i3 && e2.h(i3), s3 = [];
          for (const i4 of t4.tiles || []) e2.j(i4) ? s3.push(this.canonicalizeTileURL(i4, o3)) : s3.push(i4);
          return s3;
        }
        _makeAPIURL(t4, i3) {
          const o3 = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", s3 = S(e2.f.API_URL);
          if (t4.protocol = s3.protocol, t4.authority = s3.authority, "http" === t4.protocol) {
            const e3 = t4.params.indexOf("secure");
            e3 >= 0 && t4.params.splice(e3, 1);
          }
          if ("/" !== s3.path && (t4.path = `${s3.path}${t4.path}`), !e2.f.REQUIRE_ACCESS_TOKEN) return C2(t4);
          if (i3 = i3 || e2.f.ACCESS_TOKEN, !this._silenceAuthErrors) {
            if (!i3) throw new Error(`An API access token is required to use Mapbox GL. ${o3}`);
            if ("s" === i3[0]) throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${o3}`);
          }
          return t4.params = t4.params.filter((e3) => -1 === e3.indexOf("access_token")), t4.params.push(`access_token=${i3 || ""}`), C2(t4);
        }
      }
      const E2 = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
      function S(e3) {
        const t4 = e3.match(E2);
        if (!t4) throw new Error("Unable to parse URL object");
        return { protocol: t4[1], authority: t4[2], path: t4[3] || "/", params: t4[4] ? t4[4].split("&") : [] };
      }
      function C2(e3) {
        const t4 = e3.params.length ? `?${e3.params.join("&")}` : "";
        return `${e3.protocol}://${e3.authority}${e3.path}${t4}`;
      }
      const I2 = "mapbox.eventData";
      function D(t4) {
        if (!t4) return null;
        const i3 = t4.split(".");
        if (!i3 || 3 !== i3.length) return null;
        try {
          return JSON.parse(e2.k(i3[1]));
        } catch (e3) {
          return null;
        }
      }
      class R2 {
        constructor(e3) {
          this.type = e3, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
        }
        getStorageKey(t4) {
          const i3 = D(e2.f.ACCESS_TOKEN);
          let o3 = "";
          return o3 = i3 && i3.u ? e2.l(i3.u) : e2.f.ACCESS_TOKEN || "", t4 ? `${I2}.${t4}:${o3}` : `${I2}:${o3}`;
        }
        fetchEventData() {
          const t4 = e2.s("localStorage"), i3 = this.getStorageKey(), o3 = this.getStorageKey("uuid");
          if (t4) try {
            const e3 = localStorage.getItem(i3);
            e3 && (this.eventData = JSON.parse(e3));
            const t5 = localStorage.getItem(o3);
            t5 && (this.anonId = t5);
          } catch (t5) {
            e2.w("Unable to read from LocalStorage");
          }
        }
        saveEventData() {
          const t4 = e2.s("localStorage"), i3 = this.getStorageKey(), o3 = this.getStorageKey("uuid"), s3 = this.anonId;
          if (t4 && s3) try {
            localStorage.setItem(o3, s3), Object.keys(this.eventData).length >= 1 && localStorage.setItem(i3, JSON.stringify(this.eventData));
          } catch (t5) {
            e2.w("Unable to write to LocalStorage");
          }
        }
        processRequests(e3) {
        }
        postEvent(t4, i3, o3, s3) {
          if (!e2.f.EVENTS_URL) return;
          const r3 = S(e2.f.EVENTS_URL);
          r3.params.push(`access_token=${s3 || e2.f.ACCESS_TOKEN || ""}`);
          const a4 = { event: this.type, created: new Date(t4).toISOString() }, n3 = i3 ? e2.m(a4, i3) : a4, l3 = { url: C2(r3), headers: { "Content-Type": "text/plain" }, body: JSON.stringify([n3]) };
          this.pendingRequest = e2.p(l3, (e3) => {
            this.pendingRequest = null, o3(e3), this.saveEventData(), this.processRequests(s3);
          });
        }
        queueRequest(e3, t4) {
          this.queue.push(e3), this.processRequests(t4);
        }
      }
      const A2 = new class extends R2 {
        constructor(e3) {
          super("appUserTurnstile"), this._customAccessToken = e3;
        }
        postTurnstileEvent(t4, i3) {
          e2.f.EVENTS_URL && e2.f.ACCESS_TOKEN && Array.isArray(t4) && t4.some((t5) => e2.h(t5) || e2.j(t5)) && this.queueRequest(Date.now(), i3);
        }
        processRequests(i3) {
          if (this.pendingRequest || 0 === this.queue.length) return;
          this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
          const o3 = D(e2.f.ACCESS_TOKEN), s3 = o3 ? o3.u : e2.f.ACCESS_TOKEN;
          let r3 = s3 !== this.eventData.tokenU;
          e2.v(this.anonId) || (this.anonId = e2.u(), r3 = true);
          const a4 = this.queue.shift();
          if (this.eventData.lastSuccess) {
            const e3 = new Date(this.eventData.lastSuccess), t4 = new Date(a4), i4 = (a4 - this.eventData.lastSuccess) / 864e5;
            r3 = r3 || i4 >= 1 || i4 < -1 || e3.getDate() !== t4.getDate();
          } else r3 = true;
          r3 ? this.postEvent(a4, { sdkIdentifier: "mapbox-gl-js", sdkVersion: t3, skuId: b, "enabled.telemetry": false, userId: this.anonId }, (e3) => {
            e3 || (this.eventData.lastSuccess = a4, this.eventData.tokenU = s3);
          }, i3) : this.processRequests();
        }
      }(), L2 = A2.postTurnstileEvent.bind(A2), P = new class extends R2 {
        constructor() {
          super("map.load"), this.success = {}, this.skuToken = "";
        }
        postMapLoadEvent(t4, i3, o3, s3) {
          this.skuToken = i3, this.errorCb = s3, e2.f.EVENTS_URL && (o3 || e2.f.ACCESS_TOKEN ? this.queueRequest({ id: t4, timestamp: Date.now() }, o3) : this.errorCb(new Error(w)));
        }
        processRequests(i3) {
          if (this.pendingRequest || 0 === this.queue.length) return;
          const { id: o3, timestamp: s3 } = this.queue.shift();
          o3 && this.success[o3] || (this.anonId || this.fetchEventData(), e2.v(this.anonId) || (this.anonId = e2.u()), this.postEvent(s3, { sdkIdentifier: "mapbox-gl-js", sdkVersion: t3, skuId: b, skuToken: this.skuToken, userId: this.anonId }, (e3) => {
            e3 ? this.errorCb(e3) : o3 && (this.success[o3] = true);
          }, i3));
        }
        remove() {
          this.errorCb = null;
        }
      }(), M = P.postMapLoadEvent.bind(P), z2 = new class extends R2 {
        constructor() {
          super("style.load"), this.eventIdPerMapInstanceMap = /* @__PURE__ */ new Map(), this.mapInstanceIdMap = /* @__PURE__ */ new WeakMap();
        }
        getMapInstanceId(t4) {
          let i3 = this.mapInstanceIdMap.get(t4);
          return i3 || (i3 = e2.u(), this.mapInstanceIdMap.set(t4, i3)), i3;
        }
        getEventId(e3) {
          const t4 = this.eventIdPerMapInstanceMap.get(e3) || 0;
          return this.eventIdPerMapInstanceMap.set(e3, t4 + 1), t4;
        }
        postStyleLoadEvent(t4, i3) {
          const { map: o3, style: s3, importedStyles: r3 } = i3;
          if (!e2.f.EVENTS_URL || !t4 && !e2.f.ACCESS_TOKEN) return;
          const a4 = this.getMapInstanceId(o3), n3 = { mapInstanceId: a4, eventId: this.getEventId(a4), style: s3 };
          r3.length && (n3.importedStyles = r3), this.queueRequest({ timestamp: Date.now(), payload: n3 }, t4);
        }
        processRequests(e3) {
          if (this.pendingRequest || 0 === this.queue.length) return;
          const { timestamp: t4, payload: i3 } = this.queue.shift();
          this.postEvent(t4, i3, () => {
          }, e3);
        }
      }(), O = z2.postStyleLoadEvent.bind(z2), F2 = new class extends R2 {
        constructor() {
          super("gljs.performance");
        }
        postPerformanceEvent(t4, i3) {
          e2.f.EVENTS_URL && (t4 || e2.f.ACCESS_TOKEN) && this.queueRequest({ timestamp: Date.now(), performanceData: i3 }, t4);
        }
        processRequests(o3) {
          if (this.pendingRequest || 0 === this.queue.length) return;
          const { timestamp: r3, performanceData: a4 } = this.queue.shift(), n3 = function(o4) {
            const r4 = performance.getEntriesByType("resource"), a5 = performance.getEntriesByType("mark"), n4 = function(e3) {
              const t4 = {};
              if (e3) {
                for (const i3 in e3) if ("other" !== i3) for (const o5 of e3[i3]) {
                  const e4 = `${i3}ResolveRangeMin`, s3 = `${i3}ResolveRangeMax`, r5 = `${i3}RequestCount`, a6 = `${i3}RequestCachedCount`;
                  t4[e4] = Math.min(t4[e4] || 1 / 0, o5.startTime), t4[s3] = Math.max(t4[s3] || -1 / 0, o5.responseEnd);
                  const n5 = (e5) => {
                    void 0 === t4[e5] && (t4[e5] = 0), ++t4[e5];
                  };
                  void 0 !== o5.transferSize && 0 === o5.transferSize && n5(a6), n5(r5);
                }
              }
              return t4;
            }(function(e3, t4) {
              const i3 = {};
              if (e3) for (const o5 of e3) {
                const e4 = t4(o5);
                void 0 === i3[e4] && (i3[e4] = []), i3[e4].push(o5);
              }
              return i3;
            }(r4, s2)), l3 = e2.e.devicePixelRatio, c3 = navigator.connection || navigator.mozConnection || navigator.webkitConnection, h3 = c3 ? c3.effectiveType : void 0, u4 = { counters: [], metadata: [], attributes: [] }, d3 = (e3, t4, i3) => {
              null != i3 && e3.push({ name: t4, value: i3.toString() });
            };
            for (const e3 in n4) d3(u4.counters, e3, n4[e3]);
            if (o4.interactionRange[0] !== 1 / 0 && o4.interactionRange[1] !== -1 / 0 && (d3(u4.counters, "interactionRangeMin", o4.interactionRange[0]), d3(u4.counters, "interactionRangeMax", o4.interactionRange[1])), a5) for (const e3 of Object.keys(i2)) {
              const t4 = i2[e3], o5 = a5.find((e4) => e4.name === t4);
              o5 && d3(u4.counters, t4, o5.startTime);
            }
            return d3(u4.counters, "visibilityHidden", o4.visibilityHidden), d3(u4.attributes, "style", function(t4) {
              if (t4) for (const i3 of t4) {
                const t5 = i3.name.split("?")[0];
                if (e2.i(t5)) {
                  const e3 = t5.split("/").slice(-2);
                  if (2 === e3.length) return `mapbox://styles/${e3[0]}/${e3[1]}`;
                }
              }
            }(r4)), d3(u4.attributes, "terrainEnabled", o4.terrainEnabled ? "true" : "false"), d3(u4.attributes, "fogEnabled", o4.fogEnabled ? "true" : "false"), d3(u4.attributes, "projection", o4.projection), d3(u4.attributes, "zoom", o4.zoom), d3(u4.metadata, "devicePixelRatio", l3), d3(u4.metadata, "connectionEffectiveType", h3), d3(u4.metadata, "navigatorUserAgent", navigator.userAgent), d3(u4.metadata, "screenWidth", window.screen.width), d3(u4.metadata, "screenHeight", window.screen.height), d3(u4.metadata, "windowWidth", window.innerWidth), d3(u4.metadata, "windowHeight", window.innerHeight), d3(u4.metadata, "mapWidth", o4.width / l3), d3(u4.metadata, "mapHeight", o4.height / l3), d3(u4.metadata, "webglRenderer", o4.renderer), d3(u4.metadata, "webglVendor", o4.vendor), d3(u4.metadata, "sdkVersion", t3), d3(u4.metadata, "sdkIdentifier", "mapbox-gl-js"), u4;
          }(a4);
          for (const e3 of n3.metadata) ;
          for (const e3 of n3.counters) ;
          for (const e3 of n3.attributes) ;
          this.postEvent(r3, n3, () => {
          }, o3);
        }
      }(), B3 = F2.postPerformanceEvent.bind(F2), k = new class extends R2 {
        constructor() {
          super("map.auth"), this.success = {}, this.skuToken = "";
        }
        getSession(t4, i3, o3, s3) {
          if (!e2.f.API_URL || !e2.f.SESSION_PATH) return;
          const r3 = S(e2.f.API_URL + e2.f.SESSION_PATH);
          r3.params.push(`sku=${i3 || ""}`), r3.params.push(`access_token=${s3 || e2.f.ACCESS_TOKEN || ""}`);
          const a4 = { url: C2(r3), headers: { "Content-Type": "text/plain" } };
          this.pendingRequest = e2.g(a4, (e3) => {
            this.pendingRequest = null, o3(e3), this.saveEventData(), this.processRequests(s3);
          });
        }
        getSessionAPI(t4, i3, o3, s3) {
          this.skuToken = i3, this.errorCb = s3, e2.f.SESSION_PATH && e2.f.API_URL && (o3 || e2.f.ACCESS_TOKEN ? this.queueRequest({ id: t4, timestamp: Date.now() }, o3) : this.errorCb(new Error(w)));
        }
        processRequests(e3) {
          if (this.pendingRequest || 0 === this.queue.length) return;
          const { id: t4, timestamp: i3 } = this.queue.shift();
          t4 && this.success[t4] || this.getSession(i3, this.skuToken, (e4) => {
            e4 ? this.errorCb(e4) : t4 && (this.success[t4] = true);
          }, e3);
        }
        remove() {
          this.errorCb = null;
        }
      }(), N = k.getSessionAPI.bind(k), U2 = /* @__PURE__ */ new Set();
      function G(e3, t4) {
        t4 ? U2.add(e3) : U2.delete(e3);
      }
      class V2 {
        constructor() {
          this._changed = false, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps = /* @__PURE__ */ new Set(), this._updatedImages = /* @__PURE__ */ new Set();
        }
        isDirty() {
          return this._changed;
        }
        setDirty() {
          this._changed = true;
        }
        getUpdatedSourceCaches() {
          return this._updatedSourceCaches;
        }
        updateSourceCache(e3, t4) {
          this._updatedSourceCaches[e3] = t4, this.setDirty();
        }
        discardSourceCacheUpdate(e3) {
          delete this._updatedSourceCaches[e3];
        }
        updateLayer(e3) {
          const t4 = e3.scope;
          this._updatedLayers[t4] = this._updatedLayers[t4] || /* @__PURE__ */ new Set(), this._updatedLayers[t4].add(e3.id), this.setDirty();
        }
        removeLayer(e3) {
          const t4 = e3.scope;
          this._removedLayers[t4] = this._removedLayers[t4] || {}, this._updatedLayers[t4] = this._updatedLayers[t4] || /* @__PURE__ */ new Set(), this._removedLayers[t4][e3.id] = e3, this._updatedLayers[t4].delete(e3.id), this._updatedPaintProps.delete(e3.fqid), this.setDirty();
        }
        getRemovedLayer(e3) {
          return this._removedLayers[e3.scope] ? this._removedLayers[e3.scope][e3.id] : null;
        }
        discardLayerRemoval(e3) {
          this._removedLayers[e3.scope] && delete this._removedLayers[e3.scope][e3.id];
        }
        getLayerUpdatesByScope() {
          const e3 = {};
          for (const t4 in this._updatedLayers) e3[t4] = e3[t4] || {}, e3[t4].updatedIds = Array.from(this._updatedLayers[t4].values());
          for (const t4 in this._removedLayers) e3[t4] = e3[t4] || {}, e3[t4].removedIds = Object.keys(this._removedLayers[t4]);
          return e3;
        }
        getUpdatedPaintProperties() {
          return this._updatedPaintProps;
        }
        updatePaintProperties(e3) {
          this._updatedPaintProps.add(e3.fqid), this.setDirty();
        }
        getUpdatedImages() {
          return Array.from(this._updatedImages.values());
        }
        updateImage(e3) {
          this._updatedImages.add(e3), this.setDirty();
        }
        resetUpdatedImages() {
          this._updatedImages.clear();
        }
        reset() {
          this._changed = false, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps.clear(), this._updatedImages.clear();
        }
      }
      function j(e3) {
        const { userImage: t4 } = e3;
        return !!(t4 && t4.render && t4.render()) && (e3.data.replace(new Uint8Array(t4.data.buffer)), true);
      }
      class H extends e2.E {
        constructor() {
          super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = {}, this.requestors = [], this.patterns = {}, this.atlasImage = {}, this.atlasTexture = {}, this.dirty = true;
        }
        createScope(t4) {
          this.images[t4] = {}, this.loaded[t4] = false, this.updatedImages[t4] = {}, this.patterns[t4] = {}, this.callbackDispatchedThisFrame[t4] = {}, this.atlasImage[t4] = new e2.r({ width: 1, height: 1 });
        }
        isLoaded() {
          for (const e3 in this.loaded) if (!this.loaded[e3]) return false;
          return true;
        }
        setLoaded(e3, t4) {
          if (this.loaded[t4] !== e3 && (this.loaded[t4] = e3, e3)) {
            for (const { ids: e4, callback: i3 } of this.requestors) this._notify(e4, t4, i3);
            this.requestors = [];
          }
        }
        hasImage(e3, t4) {
          return !!this.getImage(e3, t4);
        }
        getImage(e3, t4) {
          return this.images[t4][e3];
        }
        addImage(e3, t4, i3) {
          this._validate(e3, i3) && (this.images[t4][e3] = i3);
        }
        _validate(t4, i3) {
          let o3 = true;
          return this._validateStretch(i3.stretchX, i3.data && i3.data.width) || (this.fire(new e2.t(new Error(`Image "${t4}" has invalid "stretchX" value`))), o3 = false), this._validateStretch(i3.stretchY, i3.data && i3.data.height) || (this.fire(new e2.t(new Error(`Image "${t4}" has invalid "stretchY" value`))), o3 = false), this._validateContent(i3.content, i3) || (this.fire(new e2.t(new Error(`Image "${t4}" has invalid "content" value`))), o3 = false), o3;
        }
        _validateStretch(e3, t4) {
          if (!e3) return true;
          let i3 = 0;
          for (const o3 of e3) {
            if (o3[0] < i3 || o3[1] < o3[0] || t4 < o3[1]) return false;
            i3 = o3[1];
          }
          return true;
        }
        _validateContent(e3, t4) {
          return !(e3 && (4 !== e3.length || e3[0] < 0 || t4.data.width < e3[0] || e3[1] < 0 || t4.data.height < e3[1] || e3[2] < 0 || t4.data.width < e3[2] || e3[3] < 0 || t4.data.height < e3[3] || e3[2] < e3[0] || e3[3] < e3[1]));
        }
        updateImage(e3, t4, i3) {
          i3.version = this.images[t4][e3].version + 1, this.images[t4][e3] = i3, this.updatedImages[t4][e3] = true;
        }
        removeImage(e3, t4) {
          const i3 = this.images[t4][e3];
          delete this.images[t4][e3], delete this.patterns[t4][e3], i3.userImage && i3.userImage.onRemove && i3.userImage.onRemove();
        }
        listImages(e3) {
          return Object.keys(this.images[e3]);
        }
        getImages(e3, t4, i3) {
          let o3 = true;
          const s3 = !!this.loaded[t4];
          if (!s3) for (const i4 of e3) this.images[t4][i4] || (o3 = false);
          s3 || o3 ? this._notify(e3, t4, i3) : this.requestors.push({ ids: e3, scope: t4, callback: i3 });
        }
        getUpdatedImages(e3) {
          return this.updatedImages[e3];
        }
        _notify(t4, i3, o3) {
          const s3 = {};
          for (const o4 of t4) {
            this.images[i3][o4] || this.fire(new e2.x("styleimagemissing", { id: o4 }));
            const t5 = this.images[i3][o4];
            t5 ? s3[o4] = { data: t5.data.clone(), pixelRatio: t5.pixelRatio, sdf: t5.sdf, version: t5.version, stretchX: t5.stretchX, stretchY: t5.stretchY, content: t5.content, hasRenderCallback: Boolean(t5.userImage && t5.userImage.render) } : e2.w(`Image "${o4}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
          }
          o3(null, s3);
        }
        getPixelSize(e3) {
          const { width: t4, height: i3 } = this.atlasImage[e3];
          return { width: t4, height: i3 };
        }
        getPattern(t4, i3, o3) {
          const s3 = this.patterns[i3][t4], r3 = this.getImage(t4, i3);
          if (!r3) return null;
          if (s3 && s3.position.version === r3.version) return s3.position;
          if (s3) s3.position.version = r3.version;
          else {
            const o4 = { w: r3.data.width + 2 * e2.y, h: r3.data.height + 2 * e2.y, x: 0, y: 0 }, s4 = new e2.I(o4, r3, e2.y);
            this.patterns[i3][t4] = { bin: o4, position: s4 };
          }
          return this._updatePatternAtlas(i3, o3), this.patterns[i3][t4].position;
        }
        bind(t4, i3) {
          const o3 = t4.gl;
          let s3 = this.atlasTexture[i3];
          s3 ? this.dirty && (s3.update(this.atlasImage[i3]), this.dirty = false) : (s3 = new e2.T(t4, this.atlasImage[i3], o3.RGBA8), this.atlasTexture[i3] = s3), s3.bind(o3.LINEAR, o3.CLAMP_TO_EDGE);
        }
        _updatePatternAtlas(t4, i3) {
          const o3 = [];
          for (const e3 in this.patterns[t4]) o3.push(this.patterns[t4][e3].bin);
          const { w: s3, h: r3 } = e2.z(o3), a4 = this.atlasImage[t4];
          a4.resize({ width: s3 || 1, height: r3 || 1 });
          for (const o4 in this.patterns[t4]) {
            const { bin: s4, position: r4 } = this.patterns[t4][o4];
            let n3 = r4.padding;
            const l3 = s4.x + n3, c3 = s4.y + n3, h3 = this.images[t4][o4].data, u4 = h3.width, d3 = h3.height;
            n3 = n3 > 1 ? n3 - 1 : n3, e2.r.copy(h3, a4, { x: 0, y: 0 }, { x: l3, y: c3 }, { width: u4, height: d3 }, i3), e2.r.copy(h3, a4, { x: 0, y: d3 - n3 }, { x: l3, y: c3 - n3 }, { width: u4, height: n3 }, i3), e2.r.copy(h3, a4, { x: 0, y: 0 }, { x: l3, y: c3 + d3 }, { width: u4, height: n3 }, i3), e2.r.copy(h3, a4, { x: u4 - n3, y: 0 }, { x: l3 - n3, y: c3 }, { width: n3, height: d3 }, i3), e2.r.copy(h3, a4, { x: 0, y: 0 }, { x: l3 + u4, y: c3 }, { width: n3, height: d3 }, i3), e2.r.copy(h3, a4, { x: u4 - n3, y: d3 - n3 }, { x: l3 - n3, y: c3 - n3 }, { width: n3, height: n3 }, i3), e2.r.copy(h3, a4, { x: 0, y: d3 - n3 }, { x: l3 + u4, y: c3 - n3 }, { width: n3, height: n3 }, i3), e2.r.copy(h3, a4, { x: 0, y: 0 }, { x: l3 + u4, y: c3 + d3 }, { width: n3, height: n3 }, i3), e2.r.copy(h3, a4, { x: u4 - n3, y: 0 }, { x: l3 - n3, y: c3 + d3 }, { width: n3, height: n3 }, i3);
          }
          this.dirty = true;
        }
        beginFrame() {
          for (const e3 in this.images) this.callbackDispatchedThisFrame[e3] = {};
        }
        dispatchRenderCallbacks(e3, t4) {
          for (const i3 of e3) {
            if (this.callbackDispatchedThisFrame[t4][i3]) continue;
            this.callbackDispatchedThisFrame[t4][i3] = true;
            const e4 = this.images[t4][i3];
            j(e4) && this.updateImage(i3, t4, e4);
          }
        }
      }
      function Z2(t4) {
        const i3 = t4.key, o3 = t4.value, s3 = t4.valueSpec || {}, r3 = t4.objectElementValidators || {}, a4 = t4.style, n3 = t4.styleSpec;
        let l3 = [];
        const c3 = e2.B(o3);
        if ("object" !== c3) return [new e2.V(i3, o3, `object expected, ${c3} found`)];
        for (const t5 in o3) {
          const c4 = t5.split(".")[0];
          let h3;
          r3[c4] ? h3 = r3[c4] : s3[c4] ? h3 = _e : r3["*"] ? h3 = r3["*"] : s3["*"] && (h3 = _e), h3 ? l3 = l3.concat(h3({ key: (i3 ? `${i3}.` : i3) + t5, value: o3[t5], valueSpec: s3[c4] || s3["*"], style: a4, styleSpec: n3, object: o3, objectKey: t5 }, o3)) : l3.push(new e2.A(i3, o3[t5], `unknown property "${t5}"`));
        }
        for (const t5 in s3) r3[t5] || s3[t5].required && void 0 === s3[t5].default && void 0 === o3[t5] && l3.push(new e2.V(i3, o3, `missing required property "${t5}"`));
        return l3;
      }
      function q(t4) {
        const i3 = t4.value, o3 = t4.valueSpec, s3 = t4.style, r3 = t4.styleSpec, a4 = t4.key, n3 = t4.arrayElementValidator || _e;
        if ("array" !== e2.B(i3)) return [new e2.V(a4, i3, `array expected, ${e2.B(i3)} found`)];
        if (o3.length && i3.length !== o3.length) return [new e2.V(a4, i3, `array length ${o3.length} expected, length ${i3.length} found`)];
        if (o3["min-length"] && i3.length < o3["min-length"]) return [new e2.V(a4, i3, `array length at least ${o3["min-length"]} expected, length ${i3.length} found`)];
        let l3 = { type: o3.value, values: o3.values, minimum: o3.minimum, maximum: o3.maximum, function: void 0 };
        r3.$version < 7 && (l3.function = o3.function), "object" === e2.B(o3.value) && (l3 = o3.value);
        let c3 = [];
        for (let e3 = 0; e3 < i3.length; e3++) c3 = c3.concat(n3({ array: i3, arrayIndex: e3, value: i3[e3], valueSpec: l3, style: s3, styleSpec: r3, key: `${a4}[${e3}]` }, true));
        return c3;
      }
      function W(t4) {
        const i3 = t4.key, o3 = t4.value, s3 = t4.valueSpec;
        let r3 = e2.B(o3);
        if ("number" === r3 && o3 != o3 && (r3 = "NaN"), "number" !== r3) return [new e2.V(i3, o3, `number expected, ${r3} found`)];
        if ("minimum" in s3) {
          let r4 = s3.minimum;
          if ("array" === e2.B(s3.minimum) && (r4 = s3.minimum[t4.arrayIndex]), o3 < r4) return [new e2.V(i3, o3, `${o3} is less than the minimum value ${r4}`)];
        }
        if ("maximum" in s3) {
          let r4 = s3.maximum;
          if ("array" === e2.B(s3.maximum) && (r4 = s3.maximum[t4.arrayIndex]), o3 > r4) return [new e2.V(i3, o3, `${o3} is greater than the maximum value ${r4}`)];
        }
        return [];
      }
      function $2(t4) {
        const i3 = t4.valueSpec, o3 = e2.D(t4.value.type);
        let s3, r3, a4, n3 = {};
        const l3 = "categorical" !== o3 && void 0 === t4.value.property, c3 = !l3, h3 = "array" === e2.B(t4.value.stops) && "array" === e2.B(t4.value.stops[0]) && "object" === e2.B(t4.value.stops[0][0]), u4 = Z2({ key: t4.key, value: t4.value, valueSpec: t4.styleSpec.function, style: t4.style, styleSpec: t4.styleSpec, objectElementValidators: { stops: function(t5) {
          if ("identity" === o3) return [new e2.V(t5.key, t5.value, 'identity function may not have a "stops" property')];
          let i4 = [];
          const s4 = t5.value;
          return i4 = i4.concat(q({ key: t5.key, value: s4, valueSpec: t5.valueSpec, style: t5.style, styleSpec: t5.styleSpec, arrayElementValidator: d3 })), "array" === e2.B(s4) && 0 === s4.length && i4.push(new e2.V(t5.key, s4, "array must have at least one stop")), i4;
        }, default: function(e3) {
          return _e({ key: e3.key, value: e3.value, valueSpec: i3, style: e3.style, styleSpec: e3.styleSpec });
        } } });
        return "identity" === o3 && l3 && u4.push(new e2.V(t4.key, t4.value, 'missing required property "property"')), "identity" === o3 || t4.value.stops || u4.push(new e2.V(t4.key, t4.value, 'missing required property "stops"')), "exponential" === o3 && t4.valueSpec.expression && !e2.F(t4.valueSpec) && u4.push(new e2.V(t4.key, t4.value, "exponential functions not supported")), t4.styleSpec.$version >= 8 && (c3 && !e2.G(t4.valueSpec) ? u4.push(new e2.V(t4.key, t4.value, "property functions not supported")) : l3 && !e2.H(t4.valueSpec) && u4.push(new e2.V(t4.key, t4.value, "zoom functions not supported"))), "categorical" !== o3 && !h3 || void 0 !== t4.value.property || u4.push(new e2.V(t4.key, t4.value, '"property" property is required')), u4;
        function d3(t5) {
          let o4 = [];
          const s4 = t5.value, l4 = t5.key;
          if ("array" !== e2.B(s4)) return [new e2.V(l4, s4, `array expected, ${e2.B(s4)} found`)];
          if (2 !== s4.length) return [new e2.V(l4, s4, `array length 2 expected, length ${s4.length} found`)];
          if (h3) {
            if ("object" !== e2.B(s4[0])) return [new e2.V(l4, s4, `object expected, ${e2.B(s4[0])} found`)];
            if (void 0 === s4[0].zoom) return [new e2.V(l4, s4, "object stop key must have zoom")];
            if (void 0 === s4[0].value) return [new e2.V(l4, s4, "object stop key must have value")];
            const i4 = e2.D(s4[0].zoom);
            if ("number" != typeof i4) return [new e2.V(l4, s4[0].zoom, "stop zoom values must be numbers")];
            if (a4 && a4 > i4) return [new e2.V(l4, s4[0].zoom, "stop zoom values must appear in ascending order")];
            i4 !== a4 && (a4 = i4, r3 = void 0, n3 = {}), o4 = o4.concat(Z2({ key: `${l4}[0]`, value: s4[0], valueSpec: { zoom: {} }, style: t5.style, styleSpec: t5.styleSpec, objectElementValidators: { zoom: W, value: _2 } }));
          } else o4 = o4.concat(_2({ key: `${l4}[0]`, value: s4[0], style: t5.style, styleSpec: t5.styleSpec }, s4));
          return e2.J(e2.K(s4[1])) ? o4.concat([new e2.V(`${l4}[1]`, s4[1], "expressions are not allowed in function stops.")]) : o4.concat(_e({ key: `${l4}[1]`, value: s4[1], valueSpec: i3, style: t5.style, styleSpec: t5.styleSpec }));
        }
        function _2(t5, a5) {
          const l4 = e2.B(t5.value), c4 = e2.D(t5.value), h4 = null !== t5.value ? t5.value : a5;
          if (s3) {
            if (l4 !== s3) return [new e2.V(t5.key, h4, `${l4} stop domain type must match previous stop domain type ${s3}`)];
          } else s3 = l4;
          if ("number" !== l4 && "string" !== l4 && "boolean" !== l4 && "number" != typeof c4 && "string" != typeof c4 && "boolean" != typeof c4) return [new e2.V(t5.key, h4, "stop domain value must be a number, string, or boolean")];
          if ("number" !== l4 && "categorical" !== o3) {
            let s4 = `number expected, ${l4} found`;
            return e2.G(i3) && void 0 === o3 && (s4 += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [new e2.V(t5.key, h4, s4)];
          }
          return "categorical" !== o3 || "number" !== l4 || "number" == typeof c4 && isFinite(c4) && Math.floor(c4) === c4 ? "categorical" !== o3 && "number" === l4 && "number" == typeof c4 && "number" == typeof r3 && void 0 !== r3 && c4 < r3 ? [new e2.V(t5.key, h4, "stop domain values must appear in ascending order")] : (r3 = c4, "categorical" === o3 && c4 in n3 ? [new e2.V(t5.key, h4, "stop domain values must be unique")] : (n3[c4] = true, [])) : [new e2.V(t5.key, h4, `integer expected, found ${String(c4)}`)];
        }
      }
      function X(t4) {
        const i3 = ("property" === t4.expressionContext ? e2.L : e2.M)(e2.K(t4.value), t4.valueSpec);
        if ("error" === i3.result) return i3.value.map((i4) => new e2.V(`${t4.key}${i4.key}`, t4.value, i4.message));
        const o3 = i3.value.expression || i3.value._styleExpression.expression;
        if ("property" === t4.expressionContext && "text-font" === t4.propertyKey && !o3.outputDefined()) return [new e2.V(t4.key, t4.value, `Invalid data expression for "${t4.propertyKey}". Output values must be contained as literals within the expression.`)];
        if ("property" === t4.expressionContext && "layout" === t4.propertyType && !e2.N(o3)) return [new e2.V(t4.key, t4.value, '"feature-state" data expressions are not supported with layout properties.')];
        if ("filter" === t4.expressionContext) return J(o3, t4);
        if (t4.expressionContext && 0 === t4.expressionContext.indexOf("cluster")) {
          if (!e2.O(o3, ["zoom", "feature-state"])) return [new e2.V(t4.key, t4.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')];
          if ("cluster-initial" === t4.expressionContext && !e2.Q(o3)) return [new e2.V(t4.key, t4.value, "Feature data expressions are not supported with initial expression part of cluster properties.")];
        }
        return [];
      }
      function J(t4, i3) {
        const o3 = /* @__PURE__ */ new Set(["zoom", "feature-state", "pitch", "distance-from-center"]);
        if (i3.valueSpec && i3.valueSpec.expression) for (const e3 of i3.valueSpec.expression.parameters) o3.delete(e3);
        if (0 === o3.size) return [];
        const s3 = [];
        return t4 instanceof e2.S && o3.has(t4.name) ? [new e2.V(i3.key, i3.value, `["${t4.name}"] expression is not supported in a filter for a ${i3.object.type} layer with id: ${i3.object.id}`)] : (t4.eachChild((e3) => {
          s3.push(...J(e3, i3));
        }), s3);
      }
      function K(t4) {
        const i3 = t4.key, o3 = t4.value, s3 = t4.valueSpec, r3 = [];
        return Array.isArray(s3.values) ? -1 === s3.values.indexOf(e2.D(o3)) && r3.push(new e2.V(i3, o3, `expected one of [${s3.values.join(", ")}], ${JSON.stringify(o3)} found`)) : -1 === Object.keys(s3.values).indexOf(e2.D(o3)) && r3.push(new e2.V(i3, o3, `expected one of [${Object.keys(s3.values).join(", ")}], ${JSON.stringify(o3)} found`)), r3;
      }
      function Y(t4) {
        return e2.W(e2.K(t4.value)) ? X(e2.C({}, t4, { expressionContext: "filter", valueSpec: t4.styleSpec[`filter_${t4.layerType || "fill"}`] })) : Q2(t4);
      }
      function Q2(t4) {
        const i3 = t4.value, o3 = t4.key;
        if ("array" !== e2.B(i3)) return [new e2.V(o3, i3, `array expected, ${e2.B(i3)} found`)];
        const s3 = t4.styleSpec;
        let r3, a4 = [];
        if (i3.length < 1) return [new e2.V(o3, i3, "filter array must have at least 1 element")];
        switch (a4 = a4.concat(K({ key: `${o3}[0]`, value: i3[0], valueSpec: s3.filter_operator, style: t4.style, styleSpec: t4.styleSpec })), e2.D(i3[0])) {
          case "<":
          case "<=":
          case ">":
          case ">=":
            i3.length >= 2 && "$type" === e2.D(i3[1]) && a4.push(new e2.V(o3, i3, `"$type" cannot be use with operator "${i3[0]}"`));
          case "==":
          case "!=":
            3 !== i3.length && a4.push(new e2.V(o3, i3, `filter array for operator "${i3[0]}" must have 3 elements`));
          case "in":
          case "!in":
            i3.length >= 2 && (r3 = e2.B(i3[1]), "string" !== r3 && a4.push(new e2.V(`${o3}[1]`, i3[1], `string expected, ${r3} found`)));
            for (let n3 = 2; n3 < i3.length; n3++) r3 = e2.B(i3[n3]), "$type" === e2.D(i3[1]) ? a4 = a4.concat(K({ key: `${o3}[${n3}]`, value: i3[n3], valueSpec: s3.geometry_type, style: t4.style, styleSpec: t4.styleSpec })) : "string" !== r3 && "number" !== r3 && "boolean" !== r3 && a4.push(new e2.V(`${o3}[${n3}]`, i3[n3], `string, number, or boolean expected, ${r3} found`));
            break;
          case "any":
          case "all":
          case "none":
            for (let e3 = 1; e3 < i3.length; e3++) a4 = a4.concat(Q2({ key: `${o3}[${e3}]`, value: i3[e3], style: t4.style, styleSpec: t4.styleSpec }));
            break;
          case "has":
          case "!has":
            r3 = e2.B(i3[1]), 2 !== i3.length ? a4.push(new e2.V(o3, i3, `filter array for "${i3[0]}" operator must have 2 elements`)) : "string" !== r3 && a4.push(new e2.V(`${o3}[1]`, i3[1], `string expected, ${r3} found`));
        }
        return a4;
      }
      function ee(t4, i3) {
        const o3 = t4.key, s3 = t4.style, r3 = t4.layer, a4 = t4.styleSpec, n3 = t4.value, l3 = t4.objectKey, c3 = a4[`${i3}_${t4.layerType}`];
        if (!c3) return [];
        const h3 = l3.match(/^(.*)-transition$/);
        if ("paint" === i3 && h3 && c3[h3[1]] && c3[h3[1]].transition) return _e({ key: o3, value: n3, valueSpec: a4.transition, style: s3, styleSpec: a4 });
        const u4 = t4.valueSpec || c3[l3];
        if (!u4) return [new e2.A(o3, n3, `unknown property "${l3}"`)];
        let d3;
        if ("string" === e2.B(n3) && e2.G(u4) && !u4.tokens && (d3 = /^{([^}]+)}$/.exec(n3))) {
          const t5 = `\`{ "type": "identity", "property": ${d3 ? JSON.stringify(d3[1]) : '"_"'} }\``;
          return [new e2.V(o3, n3, `"${l3}" does not support interpolation syntax
Use an identity property function instead: ${t5}.`)];
        }
        const _2 = [];
        if ("symbol" === t4.layerType) "text-field" !== l3 || !s3 || s3.glyphs || s3.imports || _2.push(new e2.V(o3, n3, 'use of "text-field" requires a style "glyphs" property')), "text-font" === l3 && e2.X(e2.K(n3)) && "identity" === e2.D(n3.type) && _2.push(new e2.V(o3, n3, '"text-font" does not support identity functions'));
        else if ("model" === t4.layerType && "paint" === i3 && r3 && r3.layout && r3.layout.hasOwnProperty("model-id") && e2.G(u4) && (e2.Y(u4) || e2.H(u4))) {
          const t5 = e2.L(e2.K(n3), u4), i4 = t5.value.expression || t5.value._styleExpression.expression;
          i4 && !e2.O(i4, ["measure-light"]) && ("model-emissive-strength" === l3 && e2.Q(i4) && e2.N(i4) || _2.push(new e2.V(o3, n3, `${l3} does not support measure-light expressions when the model layer source is vector tile or GeoJSON.`)));
        }
        return _2.concat(_e({ key: t4.key, value: n3, valueSpec: u4, style: s3, styleSpec: a4, expressionContext: "property", propertyType: i3, propertyKey: l3 }));
      }
      function te2(e3) {
        return ee(e3, "paint");
      }
      function ie(e3) {
        return ee(e3, "layout");
      }
      function oe(t4) {
        let i3 = [];
        const o3 = t4.value, s3 = t4.key, r3 = t4.style, a4 = t4.styleSpec;
        o3.type || o3.ref || i3.push(new e2.V(s3, o3, 'either "type" or "ref" is required'));
        let n3 = e2.D(o3.type);
        const l3 = e2.D(o3.ref);
        if (o3.id) {
          const a5 = e2.D(o3.id);
          for (let n4 = 0; n4 < t4.arrayIndex; n4++) {
            const t5 = r3.layers[n4];
            e2.D(t5.id) === a5 && i3.push(new e2.V(s3, o3.id, `duplicate layer id "${o3.id}", previously used at line ${t5.id.__line__}`));
          }
        }
        if ("ref" in o3) {
          let t5;
          ["type", "source", "source-layer", "filter", "layout"].forEach((t6) => {
            t6 in o3 && i3.push(new e2.V(s3, o3[t6], `"${t6}" is prohibited for ref layers`));
          }), r3.layers.forEach((i4) => {
            e2.D(i4.id) === l3 && (t5 = i4);
          }), t5 ? t5.ref ? i3.push(new e2.V(s3, o3.ref, "ref cannot reference another ref layer")) : n3 = e2.D(t5.type) : "string" == typeof l3 && i3.push(new e2.V(s3, o3.ref, `ref layer "${l3}" not found`));
        } else if ("background" !== n3 && "sky" !== n3 && "slot" !== n3) if (o3.source) {
          const t5 = r3.sources && r3.sources[o3.source], a5 = t5 && e2.D(t5.type);
          t5 ? "vector" === a5 && "raster" === n3 ? i3.push(new e2.V(s3, o3.source, `layer "${o3.id}" requires a raster source`)) : "raster" === a5 && "raster" !== n3 ? i3.push(new e2.V(s3, o3.source, `layer "${o3.id}" requires a vector source`)) : "vector" !== a5 || o3["source-layer"] ? "raster-dem" === a5 && "hillshade" !== n3 ? i3.push(new e2.V(s3, o3.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "raster-array" !== a5 || ["raster", "raster-particle"].includes(n3) ? "line" !== n3 || !o3.paint || !o3.paint["line-gradient"] && !o3.paint["line-trim-offset"] || "geojson" === a5 && t5.lineMetrics ? "raster-particle" === n3 && "raster-array" !== a5 && i3.push(new e2.V(s3, o3.source, `layer "${o3.id}" requires a 'raster-array' source.`)) : i3.push(new e2.V(s3, o3, `layer "${o3.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : i3.push(new e2.V(s3, o3.source, "raster-array source can only be used with layer type 'raster'.")) : i3.push(new e2.V(s3, o3, `layer "${o3.id}" must specify a "source-layer"`)) : i3.push(new e2.V(s3, o3.source, `source "${o3.source}" not found`));
        } else i3.push(new e2.V(s3, o3, 'missing required property "source"'));
        return i3 = i3.concat(Z2({ key: s3, value: o3, valueSpec: a4.layer, style: t4.style, styleSpec: t4.styleSpec, objectElementValidators: { "*": () => [], type: () => _e({ key: `${s3}.type`, value: o3.type, valueSpec: a4.layer.type, style: t4.style, styleSpec: t4.styleSpec, object: o3, objectKey: "type" }), filter: (t5) => Y(e2.C({ layerType: n3 }, t5)), layout: (t5) => Z2({ layer: o3, key: t5.key, value: t5.value, valueSpec: {}, style: t5.style, styleSpec: t5.styleSpec, objectElementValidators: { "*": (t6) => ie(e2.C({ layerType: n3 }, t6)) } }), paint: (t5) => Z2({ layer: o3, key: t5.key, value: t5.value, valueSpec: {}, style: t5.style, styleSpec: t5.styleSpec, objectElementValidators: { "*": (t6) => te2(e2.C({ layerType: n3, layer: o3 }, t6)) } }) } })), i3;
      }
      function se(t4) {
        const i3 = t4.value, o3 = t4.key, s3 = e2.B(i3);
        return "string" !== s3 ? [new e2.V(o3, i3, `string expected, ${s3} found`)] : [];
      }
      const re = { promoteId: function({ key: t4, value: i3 }) {
        if ("string" === e2.B(i3)) return se({ key: t4, value: i3 });
        {
          const e3 = [];
          for (const o3 in i3) e3.push(...se({ key: `${t4}.${o3}`, value: i3[o3] }));
          return e3;
        }
      } };
      function ae2(t4) {
        const i3 = t4.value, o3 = t4.key, s3 = t4.styleSpec, r3 = t4.style;
        if (!i3.type) return [new e2.V(o3, i3, '"type" is required')];
        const a4 = e2.D(i3.type);
        let n3 = [];
        switch (["vector", "raster", "raster-dem", "raster-array"].includes(a4) && (i3.url || i3.tiles || n3.push(new e2.A(o3, i3, 'Either "url" or "tiles" is required.'))), a4) {
          case "vector":
          case "raster":
          case "raster-dem":
          case "raster-array":
            return n3 = n3.concat(Z2({ key: o3, value: i3, valueSpec: s3[`source_${a4.replace("-", "_")}`], style: t4.style, styleSpec: s3, objectElementValidators: re })), n3;
          case "geojson":
            if (n3 = Z2({ key: o3, value: i3, valueSpec: s3.source_geojson, style: r3, styleSpec: s3, objectElementValidators: re }), i3.cluster) for (const e3 in i3.clusterProperties) {
              const [t5, s4] = i3.clusterProperties[e3], r4 = "string" == typeof t5 ? [t5, ["accumulated"], ["get", e3]] : t5;
              n3.push(...X({ key: `${o3}.${e3}.map`, value: s4, expressionContext: "cluster-map" })), n3.push(...X({ key: `${o3}.${e3}.reduce`, value: r4, expressionContext: "cluster-reduce" }));
            }
            return n3;
          case "video":
            return Z2({ key: o3, value: i3, valueSpec: s3.source_video, style: r3, styleSpec: s3 });
          case "image":
            return Z2({ key: o3, value: i3, valueSpec: s3.source_image, style: r3, styleSpec: s3 });
          case "canvas":
            return [new e2.V(o3, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")];
          default:
            return K({ key: `${o3}.type`, value: i3.type, valueSpec: { values: ne(s3) } });
        }
      }
      function ne(e3) {
        return e3.source.reduce((t4, i3) => {
          const o3 = e3[i3];
          return "enum" === o3.type.type && (t4 = t4.concat(Object.keys(o3.type.values))), t4;
        }, []);
      }
      function le(t4) {
        const i3 = t4.value, o3 = t4.styleSpec, s3 = o3.light, r3 = t4.style;
        let a4 = [];
        const n3 = e2.B(i3);
        if (void 0 === i3) return a4;
        if ("object" !== n3) return a4 = a4.concat([new e2.V("light", i3, `object expected, ${n3} found`)]), a4;
        for (const t5 in i3) {
          const n4 = t5.match(/^(.*)-transition$/);
          a4 = a4.concat(n4 && s3[n4[1]] && s3[n4[1]].transition ? _e({ key: t5, value: i3[t5], valueSpec: o3.transition, style: r3, styleSpec: o3 }) : s3[t5] ? _e({ key: t5, value: i3[t5], valueSpec: s3[t5], style: r3, styleSpec: o3 }) : [new e2.V(t5, i3[t5], `unknown property "${t5}"`)]);
        }
        return a4;
      }
      function ce(t4) {
        const i3 = t4.value;
        let o3 = [];
        if (!i3) return o3;
        const s3 = e2.B(i3);
        if ("object" !== s3) return o3 = o3.concat([new e2.V("light-3d", i3, `object expected, ${s3} found`)]), o3;
        const r3 = t4.styleSpec, a4 = r3["light-3d"], n3 = t4.key, l3 = t4.style, c3 = t4.style.lights;
        for (const t5 of ["type", "id"]) if (!(t5 in i3)) return o3 = o3.concat([new e2.V("light-3d", i3, `missing property ${t5} on light`)]), o3;
        if (i3.type && c3) for (let s4 = 0; s4 < t4.arrayIndex; s4++) {
          const t5 = e2.D(i3.type), r4 = c3[s4];
          e2.D(r4.type) === t5 && o3.push(new e2.V(n3, i3.id, `duplicate light type "${i3.type}", previously defined at line ${r4.id.__line__}`));
        }
        const h3 = `properties_light_${i3.type}`;
        if (!(h3 in r3)) return o3 = o3.concat([new e2.V("light-3d", i3, `Invalid light type ${i3.type}`)]), o3;
        const u4 = r3[h3];
        for (const s4 in i3) if ("properties" === s4) {
          const a5 = i3[s4], n4 = e2.B(a5);
          if ("object" !== n4) return o3 = o3.concat([new e2.V("properties", a5, `object expected, ${n4} found`)]), o3;
          for (const i4 in a5) o3 = o3.concat(u4[i4] ? _e({ key: i4, value: a5[i4], valueSpec: u4[i4], style: l3, styleSpec: r3 }) : [new e2.A(t4.key, a5[i4], `unknown property "${i4}"`)]);
        } else {
          const t5 = s4.match(/^(.*)-transition$/);
          o3 = o3.concat(t5 && a4[t5[1]] && a4[t5[1]].transition ? _e({ key: s4, value: i3[s4], valueSpec: r3.transition, style: l3, styleSpec: r3 }) : a4[s4] ? _e({ key: s4, value: i3[s4], valueSpec: a4[s4], style: l3, styleSpec: r3 }) : [new e2.A(s4, i3[s4], `unknown property "${s4}"`)]);
        }
        return o3;
      }
      function he(t4) {
        const i3 = t4.value, o3 = t4.key, s3 = t4.style, r3 = t4.styleSpec, a4 = r3.terrain;
        let n3 = [];
        const l3 = e2.B(i3);
        if (void 0 === i3) return n3;
        if ("null" === l3) return n3;
        if ("object" !== l3) return n3 = n3.concat([new e2.V("terrain", i3, `object expected, ${l3} found`)]), n3;
        for (const t5 in i3) {
          const o4 = t5.match(/^(.*)-transition$/);
          n3 = n3.concat(o4 && a4[o4[1]] && a4[o4[1]].transition ? _e({ key: t5, value: i3[t5], valueSpec: r3.transition, style: s3, styleSpec: r3 }) : a4[t5] ? _e({ key: t5, value: i3[t5], valueSpec: a4[t5], style: s3, styleSpec: r3 }) : [new e2.A(t5, i3[t5], `unknown property "${t5}"`)]);
        }
        if (i3.source) {
          const t5 = s3.sources && s3.sources[i3.source], r4 = t5 && e2.D(t5.type);
          t5 ? "raster-dem" !== r4 && n3.push(new e2.V(o3, i3.source, `terrain cannot be used with a source of type ${String(r4)}, it only be used with a "raster-dem" source type`)) : n3.push(new e2.V(o3, i3.source, `source "${i3.source}" not found`));
        } else n3.push(new e2.V(o3, i3, 'terrain is missing required property "source"'));
        return n3;
      }
      function ue2(t4) {
        const i3 = t4.value, o3 = t4.style, s3 = t4.styleSpec, r3 = s3.fog;
        let a4 = [];
        const n3 = e2.B(i3);
        if (void 0 === i3) return a4;
        if ("object" !== n3) return a4 = a4.concat([new e2.V("fog", i3, `object expected, ${n3} found`)]), a4;
        for (const t5 in i3) {
          const n4 = t5.match(/^(.*)-transition$/);
          a4 = a4.concat(n4 && r3[n4[1]] && r3[n4[1]].transition ? _e({ key: t5, value: i3[t5], valueSpec: s3.transition, style: o3, styleSpec: s3 }) : r3[t5] ? _e({ key: t5, value: i3[t5], valueSpec: r3[t5], style: o3, styleSpec: s3 }) : [new e2.A(t5, i3[t5], `unknown property "${t5}"`)]);
        }
        return a4;
      }
      const de = { "*": () => [], array: q, boolean: function(t4) {
        const i3 = t4.value, o3 = t4.key, s3 = e2.B(i3);
        return "boolean" !== s3 ? [new e2.V(o3, i3, `boolean expected, ${s3} found`)] : [];
      }, number: W, color: function(t4) {
        const i3 = t4.key, o3 = t4.value, s3 = e2.B(o3);
        return "string" !== s3 ? [new e2.V(i3, o3, `color expected, ${s3} found`)] : null === e2.U.parseCSSColor(o3) ? [new e2.V(i3, o3, `color expected, "${o3}" found`)] : [];
      }, enum: K, filter: Y, function: $2, layer: oe, object: Z2, source: ae2, model: e2.Z, light: le, "light-3d": ce, terrain: he, fog: ue2, string: se, formatted: function(e3) {
        return 0 === se(e3).length ? [] : X(e3);
      }, resolvedImage: function(e3) {
        return 0 === se(e3).length ? [] : X(e3);
      }, projection: function(t4) {
        const i3 = t4.value, o3 = t4.styleSpec, s3 = o3.projection, r3 = t4.style;
        let a4 = [];
        const n3 = e2.B(i3);
        if ("object" === n3) for (const e3 in i3) a4 = a4.concat(_e({ key: e3, value: i3[e3], valueSpec: s3[e3], style: r3, styleSpec: o3 }));
        else "string" !== n3 && (a4 = a4.concat([new e2.V("projection", i3, `object or string expected, ${n3} found`)]));
        return a4;
      }, import: function(t4) {
        const { value: i3, styleSpec: o3 } = t4, { data: s3, ...r3 } = i3;
        Object.defineProperty(r3, "__line__", { value: i3.__line__, enumerable: false });
        let a4 = Z2(e2.C({}, t4, { value: r3, valueSpec: o3.import }));
        return "" === e2.D(r3.id) && a4.push(new e2.V(`${t4.key}.id`, r3, "import id can't be an empty string")), s3 && (a4 = a4.concat(fe(s3, o3, { key: `${t4.key}.data` }))), a4;
      } };
      function _e(t4, i3 = false) {
        const o3 = t4.value, s3 = t4.valueSpec, r3 = t4.styleSpec;
        if (s3.expression && e2.X(e2.D(o3))) return $2(t4);
        if (s3.expression && e2.J(e2.K(o3))) return X(t4);
        if (s3.type && de[s3.type]) {
          const o4 = de[s3.type](t4);
          return true === i3 && o4.length > 0 && "array" === e2.B(t4.value) ? X(t4) : o4;
        }
        return Z2(e2.C({}, t4, { valueSpec: s3.type ? r3[s3.type] : s3 }));
      }
      function pe(t4) {
        const i3 = t4.value, o3 = t4.key, s3 = se(t4);
        return s3.length || (-1 === i3.indexOf("{fontstack}") && s3.push(new e2.V(o3, i3, '"glyphs" url must include a "{fontstack}" token')), -1 === i3.indexOf("{range}") && s3.push(new e2.V(o3, i3, '"glyphs" url must include a "{range}" token'))), s3;
      }
      function fe(t4, i3 = e2._, o3 = {}) {
        return _e({ key: o3.key || "", value: t4, valueSpec: i3.$root, styleSpec: i3, style: t4, objectElementValidators: { glyphs: pe, "*": () => [] } });
      }
      function me(t4, i3 = e2._) {
        return Ie(fe(t4, i3));
      }
      const ge2 = (e3) => Ie(ae2(e3)), ve = (e3) => Ie(le(e3)), xe = (e3) => Ie(ce(e3)), ye = (e3) => Ie(he(e3)), be = (e3) => Ie(ue2(e3)), we2 = (e3) => Ie(oe(e3)), Te = (e3) => Ie(Y(e3)), Ee = (e3) => Ie(te2(e3)), Se = (e3) => Ie(ie(e3)), Ce = (t4) => Ie(e2.Z(t4));
      function Ie(e3) {
        return e3.slice().sort((e4, t4) => e4.line && t4.line ? e4.line - t4.line : 0);
      }
      function De(t4, i3) {
        let o3 = false;
        if (i3 && i3.length) for (const s3 of i3) s3 instanceof e2.A ? e2.w(s3.message) : (t4.fire(new e2.t(new Error(s3.message))), o3 = true);
        return o3;
      }
      let Re;
      class Ae2 extends e2.E {
        constructor(t4, i3 = "flat") {
          super(), this._transitionable = new e2.$(Re || (Re = new e2.a0({ anchor: new e2.a1(e2._.light.anchor), position: new e2.a2(e2._.light.position), color: new e2.a1(e2._.light.color), intensity: new e2.a1(e2._.light.intensity) }))), this.setLight(t4, i3), this._transitioning = this._transitionable.untransitioned();
        }
        getLight() {
          return this._transitionable.serialize();
        }
        setLight(e3, t4, i3 = {}) {
          this._validate(ve, e3, i3) || (this._transitionable.setTransitionOrValue(e3), this.id = t4);
        }
        updateTransitions(e3) {
          this._transitioning = this._transitionable.transitioned(e3, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(e3) {
          this.properties = this._transitioning.possiblyEvaluate(e3);
        }
        _validate(t4, i3, o3) {
          return (!o3 || false !== o3.validate) && De(this, t4.call(me, e2.m({ value: i3, style: { glyphs: true, sprite: true }, styleSpec: e2._ })));
        }
      }
      let Le = class extends e2.E {
        constructor(t4, i3, o3, s3) {
          super(), this.scope = o3, this._transitionable = new e2.$(new e2.a0({ source: new e2.a1(e2._.terrain.source), exaggeration: new e2.a1(e2._.terrain.exaggeration) }), o3, s3), this._transitionable.setTransitionOrValue(t4, s3), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = i3;
        }
        get() {
          return this._transitionable.serialize();
        }
        set(e3, t4) {
          this._transitionable.setTransitionOrValue(e3, t4);
        }
        updateTransitions(e3) {
          this._transitioning = this._transitionable.transitioned(e3, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(e3) {
          this.properties = this._transitioning.possiblyEvaluate(e3);
        }
        getExaggeration(t4) {
          return this._transitioning.possiblyEvaluate(new e2.a3(t4)).get("exaggeration");
        }
        getAttenuationRange() {
          if (!this.isZoomDependent()) return null;
          const t4 = this._transitionable._values.exaggeration;
          if (!t4) return null;
          const i3 = t4.value.expression;
          if (!i3) return null;
          let o3 = -1, s3 = -1, r3 = 1;
          for (const t5 of i3.zoomStops) r3 = i3.evaluate(new e2.a3(t5)), r3 > 0.01 ? (o3 = t5, s3 = -1) : s3 = t5;
          return r3 < 0.01 && o3 > 0 && s3 > o3 ? [o3, s3] : null;
        }
        isZoomDependent() {
          const t4 = this._transitionable._values.exaggeration;
          return null != t4 && null != t4.value && null != t4.value.expression && t4.value.expression instanceof e2.a4;
        }
      };
      const Pe = 45, Me = 65, ze = 0.05;
      function Oe(t4, i3, o3, s3) {
        const r3 = e2.a7(Pe, Me, o3), [a4, n3] = Fe(t4, s3);
        let l3 = 1 - Math.min(1, Math.exp((i3 - a4) / (n3 - a4) * -6));
        return l3 *= l3 * l3, l3 = Math.min(1, 1.00747 * l3), l3 * r3 * t4.alpha;
      }
      function Fe(e3, t4) {
        const i3 = 0.5 / Math.tan(0.5 * t4);
        return [e3.range[0] + i3, e3.range[1] + i3];
      }
      function Be(t4, i3, o3, s3, r3) {
        const a4 = e2.a6.vec3.transformMat4([], [i3, o3, s3], r3.mercatorFogMatrix);
        return Oe(t4, e2.a6.vec3.length(a4), r3.pitch, r3._fov);
      }
      function ke(t4, i3, o3, s3, r3, a4, n3) {
        const l3 = [[o3, s3, 0], [r3, s3, 0], [r3, a4, 0], [o3, a4, 0]];
        let c3 = Number.MAX_VALUE, h3 = -Number.MAX_VALUE;
        for (const t5 of l3) {
          const o4 = e2.a6.vec3.transformMat4([], t5, i3), s4 = e2.a6.vec3.length(o4);
          c3 = Math.min(c3, s4), h3 = Math.max(h3, s4);
        }
        return [Oe(t4, c3, n3.pitch, n3._fov), Oe(t4, h3, n3.pitch, n3._fov)];
      }
      class Ne extends e2.E {
        constructor(t4, i3, o3, s3) {
          super();
          const r3 = new e2.a0({ range: new e2.a1(e2._.fog.range), color: new e2.a1(e2._.fog.color), "high-color": new e2.a1(e2._.fog["high-color"]), "space-color": new e2.a1(e2._.fog["space-color"]), "horizon-blend": new e2.a1(e2._.fog["horizon-blend"]), "star-intensity": new e2.a1(e2._.fog["star-intensity"]), "vertical-range": new e2.a1(e2._.fog["vertical-range"]) });
          this._transitionable = new e2.$(r3, o3, new Map(s3)), this.set(t4, s3), this._transitioning = this._transitionable.untransitioned(), this._transform = i3, this.properties = new e2.a8(r3), this.scope = o3;
        }
        get state() {
          const t4 = this._transform, i3 = "globe" === t4.projection.name, o3 = e2.a9(t4.zoom), s3 = this.properties.get("range"), r3 = [0.5, 3];
          return { range: i3 ? [e2.aa(r3[0], s3[0], o3), e2.aa(r3[1], s3[1], o3)] : s3, horizonBlend: this.properties.get("horizon-blend"), alpha: this.properties.get("color").a };
        }
        get() {
          return this._transitionable.serialize();
        }
        set(t4, i3, o3 = {}) {
          if (this._validate(be, t4, o3)) return;
          const s3 = e2.m({}, t4);
          for (const t5 of Object.keys(e2._.fog)) void 0 === s3[t5] && (s3[t5] = e2._.fog[t5].default);
          this._options = s3, this._transitionable.setTransitionOrValue(this._options, i3);
        }
        getOpacity(t4) {
          if (!this._transform.projection.supportsFog) return 0;
          const i3 = this.properties && this.properties.get("color") || 1;
          return ("globe" === this._transform.projection.name ? 1 : e2.a7(Pe, Me, t4)) * i3.a;
        }
        getOpacityAtLatLng(t4, i3) {
          return this._transform.projection.supportsFog ? function(t5, i4, o3) {
            const s3 = e2.a5.fromLngLat(i4), r3 = o3.elevation ? o3.elevation.getAtPointOrZero(s3) : 0;
            return Be(t5, s3.x, s3.y, r3, o3);
          }(this.state, t4, i3) : 0;
        }
        getOpacityForTile(t4) {
          if (!this._transform.projection.supportsFog) return [1, 1];
          const i3 = this._transform.calculateFogTileMatrix(t4.toUnwrapped());
          return ke(this.state, i3, 0, 0, e2.ab, e2.ab, this._transform);
        }
        getOpacityForBounds(e3, t4, i3, o3, s3) {
          return this._transform.projection.supportsFog ? ke(this.state, e3, t4, i3, o3, s3, this._transform) : [1, 1];
        }
        getFovAdjustedRange(e3) {
          return this._transform.projection.supportsFog ? Fe(this.state, e3) : [0, 1];
        }
        isVisibleOnFrustum(t4) {
          if (!this._transform.projection.supportsFog) return false;
          const i3 = [4, 5, 6, 7];
          for (const o3 of i3) {
            const i4 = t4.points[o3];
            let s3;
            if (i4[2] >= 0) s3 = i4;
            else {
              const r3 = t4.points[o3 - 4];
              s3 = e2.ac(r3, i4, r3[2] / (r3[2] - i4[2]));
            }
            if (Be(this.state, s3[0], s3[1], 0, this._transform) >= ze) return true;
          }
          return false;
        }
        updateConfig(e3) {
          this._transitionable.setTransitionOrValue(this._options, new Map(e3));
        }
        updateTransitions(e3) {
          this._transitioning = this._transitionable.transitioned(e3, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(e3) {
          this.properties = this._transitioning.possiblyEvaluate(e3);
        }
        _validate(t4, i3, o3) {
          return (!o3 || false !== o3.validate) && De(this, t4.call(me, e2.m({ value: i3, style: { glyphs: true, sprite: true }, styleSpec: e2._ })));
        }
      }
      class Ue extends e2.E {
        constructor(t4, i3, o3, s3) {
          super(), this.scope = o3, this._options = t4, this.properties = new e2.a8(i3), this._transitionable = new e2.$(i3, o3, new Map(s3)), this._transitionable.setTransitionOrValue(t4.properties), this._transitioning = this._transitionable.untransitioned();
        }
        updateConfig(e3) {
          this._transitionable.setTransitionOrValue(this._options.properties, new Map(e3));
        }
        updateTransitions(e3) {
          this._transitioning = this._transitionable.transitioned(e3, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(e3) {
          this.properties = this._transitioning.possiblyEvaluate(e3);
        }
        get() {
          return this._options.properties = this._transitionable.serialize(), this._options;
        }
        set(e3, t4) {
          this._options = e3, this._transitionable.setTransitionOrValue(e3.properties, t4);
        }
        shadowsEnabled() {
          return !!this.properties && true === this.properties.get("cast-shadows");
        }
      }
      let Ge, Ve;
      class je {
        constructor(e3, t4, i3, o3) {
          this.screenBounds = e3, this.cameraPoint = t4, this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = i3, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, o3);
        }
        static createFromScreenPoints(t4, i3) {
          let o3, s3;
          if (t4 instanceof e2.P || "number" == typeof t4[0]) {
            const r3 = e2.P.convert(t4);
            o3 = [r3], s3 = i3.isPointAboveHorizon(r3);
          } else {
            const r3 = e2.P.convert(t4[0]), a4 = e2.P.convert(t4[1]);
            o3 = [r3, a4], s3 = e2.ae(r3, a4).every((e3) => i3.isPointAboveHorizon(e3));
          }
          return new je(o3, i3.getCameraPoint(), s3, i3);
        }
        isPointQuery() {
          return 1 === this.screenBounds.length;
        }
        bufferedScreenGeometry(t4) {
          return e2.ae(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], t4);
        }
        bufferedCameraGeometry(t4) {
          const i3 = this.screenBounds[0], o3 = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e2.P(1, 1)) : this.screenBounds[1], s3 = e2.ae(i3, o3, 0, false);
          return this.cameraPoint.y > o3.y && (this.cameraPoint.x > i3.x && this.cameraPoint.x < o3.x ? s3.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= o3.x ? s3[2] = this.cameraPoint : this.cameraPoint.x <= i3.x && (s3[3] = this.cameraPoint)), e2.af(s3, t4);
        }
        bufferedCameraGeometryGlobe(t4) {
          const i3 = this.screenBounds[0], o3 = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e2.P(1, 1)) : this.screenBounds[1], s3 = e2.ae(i3, o3, t4), r3 = this.cameraPoint.clone();
          switch (3 * ((r3.y > i3.y) + (r3.y > o3.y)) + ((r3.x > i3.x) + (r3.x > o3.x))) {
            case 0:
              s3[0] = r3, s3[4] = r3.clone();
              break;
            case 1:
              s3.splice(1, 0, r3);
              break;
            case 2:
              s3[1] = r3;
              break;
            case 3:
              s3.splice(4, 0, r3);
              break;
            case 5:
              s3.splice(2, 0, r3);
              break;
            case 6:
              s3[3] = r3;
              break;
            case 7:
              s3.splice(3, 0, r3);
              break;
            case 8:
              s3[2] = r3;
          }
          return s3;
        }
        containsTile(t4, i3, o3, s3 = 0) {
          const r3 = t4.queryPadding / i3._pixelsPerMercatorPixel + 1, a4 = o3 ? this._bufferedCameraMercator(r3, i3) : this._bufferedScreenMercator(r3, i3);
          let n3 = t4.tileID.wrap + (a4.unwrapped ? s3 : 0);
          const l3 = a4.polygon.map((i4) => e2.ag(t4.tileTransform, i4, n3));
          if (!e2.ah(l3, 0, 0, e2.ab, e2.ab)) return;
          n3 = t4.tileID.wrap + (this.screenGeometryMercator.unwrapped ? s3 : 0);
          const c3 = this.screenGeometryMercator.polygon.map((i4) => e2.ai(t4.tileTransform, i4, n3)), h3 = c3.map((t5) => new e2.P(t5[0], t5[1])), u4 = i3.getFreeCameraOptions().position || new e2.a5(0, 0, 0), d3 = e2.ai(t4.tileTransform, u4, n3), _2 = c3.map((t5) => {
            const i4 = e2.a6.vec3.sub(t5, t5, d3);
            return e2.a6.vec3.normalize(i4, i4), new e2.aj(d3, i4);
          }), p3 = e2.ak(t4, 1, i3.zoom) * i3._pixelsPerMercatorPixel;
          return { queryGeometry: this, tilespaceGeometry: h3, tilespaceRays: _2, bufferedTilespaceGeometry: l3, bufferedTilespaceBounds: (f3 = e2.al(l3), f3.min.x = e2.ap(f3.min.x, 0, e2.ab), f3.min.y = e2.ap(f3.min.y, 0, e2.ab), f3.max.x = e2.ap(f3.max.x, 0, e2.ab), f3.max.y = e2.ap(f3.max.y, 0, e2.ab), f3), tile: t4, tileID: t4.tileID, pixelToTileUnitsFactor: p3 };
          var f3;
        }
        _bufferedScreenMercator(e3, t4) {
          const i3 = qe(e3);
          if (this._screenRaycastCache[i3]) return this._screenRaycastCache[i3];
          {
            let o3;
            return o3 = "globe" === t4.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e3), t4) : { polygon: this.bufferedScreenGeometry(e3).map((e4) => t4.pointCoordinate3D(e4)), unwrapped: true }, this._screenRaycastCache[i3] = o3, o3;
          }
        }
        _bufferedCameraMercator(e3, t4) {
          const i3 = qe(e3);
          if (this._cameraRaycastCache[i3]) return this._cameraRaycastCache[i3];
          {
            let o3;
            return o3 = "globe" === t4.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e3), t4) : { polygon: this.bufferedCameraGeometry(e3).map((e4) => t4.pointCoordinate3D(e4)), unwrapped: true }, this._cameraRaycastCache[i3] = o3, o3;
          }
        }
        _projectAndResample(t4, i3) {
          const o3 = function(t5, i4) {
            const o4 = e2.a6.mat4.multiply([], i4.pixelMatrix, i4.globeMatrix), s4 = [0, -e2.aq, 0, 1], r3 = [0, e2.aq, 0, 1], a4 = [0, 0, 0, 1];
            e2.a6.vec4.transformMat4(s4, s4, o4), e2.a6.vec4.transformMat4(r3, r3, o4), e2.a6.vec4.transformMat4(a4, a4, o4);
            const n3 = new e2.P(s4[0] / s4[3], s4[1] / s4[3]), l3 = new e2.P(r3[0] / r3[3], r3[1] / r3[3]), c3 = e2.an(t5, n3) && s4[3] < a4[3], h3 = e2.an(t5, l3) && r3[3] < a4[3];
            if (!c3 && !h3) return null;
            const u4 = function(e3, t6, i5) {
              for (let o5 = 1; o5 < e3.length; o5++) {
                const s5 = Ze(t6.pointCoordinate3D(e3[o5 - 1]).x), r4 = Ze(t6.pointCoordinate3D(e3[o5]).x);
                if (i5 < 0) {
                  if (s5 < r4) return { idx: o5, t: -s5 / (r4 - 1 - s5) };
                } else if (r4 < s5) return { idx: o5, t: (1 - s5) / (r4 + 1 - s5) };
              }
              return null;
            }(t5, i4, c3 ? -1 : 1);
            if (!u4) return null;
            const { idx: d3, t: _2 } = u4;
            let p3 = d3 > 1 ? He(t5.slice(0, d3), i4) : [], f3 = d3 < t5.length ? He(t5.slice(d3), i4) : [];
            p3 = p3.map((t6) => new e2.P(Ze(t6.x), t6.y)), f3 = f3.map((t6) => new e2.P(Ze(t6.x), t6.y));
            const m2 = [...p3];
            0 === m2.length && m2.push(f3[f3.length - 1]);
            const g4 = e2.aa(m2[m2.length - 1].y, (0 === f3.length ? p3[0] : f3[0]).y, _2);
            let v2;
            return v2 = c3 ? [new e2.P(0, g4), new e2.P(0, 0), new e2.P(1, 0), new e2.P(1, g4)] : [new e2.P(1, g4), new e2.P(1, 1), new e2.P(0, 1), new e2.P(0, g4)], m2.push(...v2), 0 === f3.length ? m2.push(p3[0]) : m2.push(...f3), { polygon: m2.map((t6) => new e2.a5(t6.x, t6.y)), unwrapped: false };
          }(t4, i3);
          if (o3) return o3;
          const s3 = function(t5, i4) {
            let o4 = false, s4 = -1 / 0, r3 = 0;
            for (let e3 = 0; e3 < t5.length - 1; e3++) t5[e3].x > s4 && (s4 = t5[e3].x, r3 = e3);
            for (let e3 = 0; e3 < t5.length - 1; e3++) {
              const i5 = (r3 + e3) % (t5.length - 1), s5 = t5[i5], a5 = t5[i5 + 1];
              Math.abs(s5.x - a5.x) > 0.5 && (s5.x < a5.x ? (s5.x += 1, 0 === i5 && (t5[t5.length - 1].x += 1)) : (a5.x += 1, i5 + 1 === t5.length - 1 && (t5[0].x += 1)), o4 = true);
            }
            const a4 = e2.am(i4.center.lng);
            return o4 && a4 < Math.abs(a4 - 1) && t5.forEach((e3) => {
              e3.x -= 1;
            }), { polygon: t5, unwrapped: o4 };
          }(He(t4, i3).map((t5) => new e2.P(Ze(t5.x), t5.y)), i3);
          return { polygon: s3.polygon.map((t5) => new e2.a5(t5.x, t5.y)), unwrapped: s3.unwrapped };
        }
      }
      function He(t4, i3) {
        return e2.ao(t4, (e3) => {
          const t5 = i3.pointCoordinate3D(e3);
          e3.x = t5.x, e3.y = t5.y;
        }, 1 / 256);
      }
      function Ze(e3) {
        return e3 < 0 ? 1 + e3 % 1 : e3 % 1;
      }
      function qe(e3) {
        return 100 * e3 | 0;
      }
      function We(t4, i3, o3, s3, r3) {
        const a4 = function(o4, s4) {
          if (o4) return r3(o4);
          if (s4) {
            if (t4.url && s4.tiles && t4.tiles && delete t4.tiles, s4.variants) {
              if (!Array.isArray(s4.variants)) return r3(new Error("variants must be an array"));
              for (const t5 of s4.variants) {
                if (null == t5 || "object" != typeof t5 || t5.constructor !== Object) return r3(new Error("variant must be an object"));
                if (!Array.isArray(t5.capabilities)) return r3(new Error("capabilities must be an array"));
                if (1 === t5.capabilities.length && "meshopt" === t5.capabilities[0]) {
                  s4 = e2.m(s4, t5);
                  break;
                }
              }
            }
            const o5 = e2.ar(e2.m({}, s4, t4), ["tilejson", "tiles", "minzoom", "maxzoom", "attribution", "mapbox_logo", "bounds", "scheme", "tileSize", "encoding", "vector_layers", "raster_layers", "worldview_options", "worldview_default", "worldview"]);
            o5.tiles = i3.canonicalizeTileset(o5, t4.url), r3(null, o5);
          }
        }, n3 = function(e3, t5, i4) {
          if (!e3) return null;
          if (!t5 && !i4) return e3;
          i4 = i4 || e3.worldview_default;
          const o4 = Object.values(e3.language || {});
          if (0 === o4.length) return null;
          const s4 = Object.values(e3.worldview || {});
          if (0 === s4.length) return null;
          const r4 = o4.every((e4) => e4 === t5), a5 = s4.every((e4) => e4 === i4);
          return r4 && a5 ? e3 : t5 in (e3.language_options || {}) || i4 in (e3.worldview_options || {}) ? null : e3.language_options && e3.worldview_options ? e3 : null;
        }(t4.data, o3, s3);
        return n3 ? e2.e.frame(() => a4(null, n3)) : t4.url ? e2.o(i3.transformRequest(i3.normalizeSourceURL(t4.url, null, o3, s3), e2.R.Source), a4) : e2.e.frame(() => {
          const { data: e3, ...i4 } = t4;
          a4(null, i4);
        });
      }
      class $e {
        constructor(t4, i3, o3) {
          this.bounds = e2.as.convert(this.validateBounds(t4)), this.minzoom = i3 || 0, this.maxzoom = o3 || 24;
        }
        validateBounds(e3) {
          return Array.isArray(e3) && 4 === e3.length ? [Math.max(-180, e3[0]), Math.max(-90, e3[1]), Math.min(180, e3[2]), Math.min(90, e3[3])] : [-180, -90, 180, 90];
        }
        contains(t4) {
          const i3 = Math.pow(2, t4.z), o3 = Math.floor(e2.am(this.bounds.getWest()) * i3), s3 = Math.floor(e2.at(this.bounds.getNorth()) * i3), r3 = Math.ceil(e2.am(this.bounds.getEast()) * i3), a4 = Math.ceil(e2.at(this.bounds.getSouth()) * i3);
          return t4.x >= o3 && t4.x < r3 && t4.y >= s3 && t4.y < a4;
        }
      }
      class Xe extends e2.E {
        constructor(t4, i3, o3, s3) {
          if (super(), this.id = t4, this.dispatcher = o3, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = true, this.isTileClipped = true, this._loaded = false, e2.m(this, e2.ar(i3, ["url", "scheme", "tileSize", "promoteId"])), this._options = e2.m({ type: "vector" }, i3), this._collectResourceTiming = !!i3.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
          this.setEventedParent(s3), this._tileWorkers = {}, this._deduped = new e2.au();
        }
        load(t4) {
          this._loaded = false, this.fire(new e2.x("dataloading", { dataType: "source" }));
          const i3 = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o3 = this.map.getWorldview();
          this._tileJSONRequest = We(this._options, this.map._requestManager, i3, o3, (s3, r3) => {
            if (this._tileJSONRequest = null, this._loaded = true, s3) i3 && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i3}`), o3 && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o3}`), this.fire(new e2.t(s3));
            else if (r3) {
              if (e2.m(this, r3), this.hasWorldviews = !!r3.worldview_options, r3.worldview_default && (this.worldviewDefault = r3.worldview_default), r3.vector_layers) {
                this.vectorLayers = r3.vector_layers, this.vectorLayerIds = [], this.localizableLayerIds = /* @__PURE__ */ new Set();
                for (const e3 of r3.vector_layers) this.vectorLayerIds.push(e3.id), r3.worldview && r3.worldview[e3.source] && this.localizableLayerIds.add(e3.id);
              }
              r3.bounds && (this.tileBounds = new $e(r3.bounds, this.minzoom, this.maxzoom)), L2(r3.tiles, this.map._requestManager._customAccessToken), this.fire(new e2.x("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e2.x("data", { dataType: "source", sourceDataType: "content" }));
            }
            t4 && t4(s3);
          });
        }
        loaded() {
          return this._loaded;
        }
        hasTile(e3) {
          return !this.tileBounds || this.tileBounds.contains(e3.canonical);
        }
        onAdd(e3) {
          this.map = e3, this.load();
        }
        reload() {
          this.cancelTileJSONRequest();
          const t4 = e2.av(this.id, this.scope);
          this.load(() => this.map.style.clearSource(t4));
        }
        setTiles(e3) {
          return this._options.tiles = e3, this.reload(), this;
        }
        setUrl(e3) {
          return this.url = e3, this._options.url = e3, this.reload(), this;
        }
        onRemove(e3) {
          this.cancelTileJSONRequest();
        }
        serialize() {
          return e2.m({}, this._options);
        }
        loadTile(t4, i3) {
          const o3 = t4.tileID.canonical.url(this.tiles, this.scheme), s3 = this.map._requestManager.normalizeTileURL(o3), r3 = this.map._requestManager.transformRequest(s3, e2.R.Tile), a4 = this.map.style ? this.map.style.getLut(this.scope) : null, n3 = a4 ? { image: a4.image.clone() } : null, l3 = { request: r3, data: void 0, uid: t4.uid, tileID: t4.tileID, tileZoom: t4.tileZoom, zoom: t4.tileID.overscaledZ, maxZoom: this.maxzoom, lut: n3, tileSize: this.tileSize * t4.tileID.overscaleFactor(), type: this.type, source: this.id, scope: this.scope, pixelRatio: e2.e.devicePixelRatio, showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId, isSymbolTile: t4.isSymbolTile, brightness: this.map.style && this.map.style.getBrightness() || 0, extraShadowCaster: t4.isExtraShadowCaster, tessellationStep: this.map._tessellationStep, scaleFactor: this.map.getScaleFactor() };
          if (this.hasWorldviews && e2.h(o3) && (l3.worldview = this.map.getWorldview() || this.worldviewDefault, l3.localizableLayerIds = this.localizableLayerIds), l3.request.collectResourceTiming = this._collectResourceTiming, t4.actor && "expired" !== t4.state) "loading" === t4.state ? t4.reloadCallback = i3 : t4.request = t4.actor.send("reloadTile", l3, c3.bind(this));
          else if (t4.actor = this._tileWorkers[s3] = this._tileWorkers[s3] || this.dispatcher.getActor(), this.dispatcher.ready) t4.request = t4.actor.send("loadTile", l3, c3.bind(this), void 0, true);
          else {
            const i4 = e2.aw.call({ deduped: this._deduped }, l3, (e3, i5) => {
              e3 || !i5 ? c3.call(this, e3) : (l3.data = { cacheControl: i5.cacheControl, expires: i5.expires, rawData: i5.rawData.slice(0) }, t4.actor && t4.actor.send("loadTile", l3, c3.bind(this), void 0, true));
            }, true);
            t4.request = { cancel: i4 };
          }
          function c3(o4, s4) {
            return delete t4.request, t4.aborted ? i3(null) : o4 && 404 !== o4.status ? i3(o4) : (s4 && s4.resourceTiming && (t4.resourceTiming = s4.resourceTiming), this.map._refreshExpiredTiles && s4 && t4.setExpiryData(s4), t4.loadVectorData(s4, this.map.painter), e2.ax(this.dispatcher), i3(null), void (t4.reloadCallback && (this.loadTile(t4, t4.reloadCallback), t4.reloadCallback = null)));
          }
        }
        abortTile(e3) {
          e3.request && (e3.request.cancel(), delete e3.request), e3.actor && e3.actor.send("abortTile", { uid: e3.uid, type: this.type, source: this.id, scope: this.scope });
        }
        unloadTile(e3, t4) {
          e3.actor && e3.actor.send("removeTile", { uid: e3.uid, type: this.type, source: this.id, scope: this.scope }), e3.destroy();
        }
        hasTransition() {
          return false;
        }
        afterUpdate() {
          this._tileWorkers = {};
        }
        cancelTileJSONRequest() {
          this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
        }
      }
      class Je extends e2.E {
        constructor(t4, i3, o3, s3) {
          super(), this.id = t4, this.dispatcher = o3, this.setEventedParent(s3), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = true, this.scheme = "xyz", this.tileSize = 512, this._loaded = false, this._options = e2.m({ type: "raster" }, i3), e2.m(this, e2.ar(i3, ["url", "scheme", "tileSize"]));
        }
        load(t4) {
          this._loaded = false, this.fire(new e2.x("dataloading", { dataType: "source" })), this._tileJSONRequest = We(this._options, this.map._requestManager, null, null, (i3, o3) => {
            this._tileJSONRequest = null, this._loaded = true, i3 ? this.fire(new e2.t(i3)) : o3 && (e2.m(this, o3), o3.raster_layers && (this.rasterLayers = o3.raster_layers, this.rasterLayerIds = this.rasterLayers.map((e3) => e3.id)), o3.bounds && (this.tileBounds = new $e(o3.bounds, this.minzoom, this.maxzoom)), L2(o3.tiles), this.fire(new e2.x("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e2.x("data", { dataType: "source", sourceDataType: "content" }))), t4 && t4(i3);
          });
        }
        loaded() {
          return this._loaded;
        }
        onAdd(e3) {
          this.map = e3, this.load();
        }
        reload() {
          this.cancelTileJSONRequest();
          const t4 = e2.av(this.id, this.scope);
          this.load(() => this.map.style.clearSource(t4));
        }
        setTiles(e3) {
          return this._options.tiles = e3, this.reload(), this;
        }
        setUrl(e3) {
          return this.url = e3, this._options.url = e3, this.reload(), this;
        }
        onRemove(e3) {
          this.cancelTileJSONRequest();
        }
        serialize() {
          return e2.m({}, this._options);
        }
        hasTile(e3) {
          return !this.tileBounds || this.tileBounds.contains(e3.canonical);
        }
        loadTile(t4, i3) {
          const o3 = e2.e.devicePixelRatio >= 2, s3 = this.map._requestManager.normalizeTileURL(t4.tileID.canonical.url(this.tiles, this.scheme), o3, this.tileSize);
          t4.request = e2.q(this.map._requestManager.transformRequest(s3, e2.R.Tile), (o4, s4, r3, a4) => (delete t4.request, t4.aborted ? (t4.state = "unloaded", i3(null)) : o4 ? (t4.state = "errored", i3(o4)) : s4 ? (this.map._refreshExpiredTiles && t4.setExpiryData({ cacheControl: r3, expires: a4 }), t4.setTexture(s4, this.map.painter), t4.state = "loaded", e2.ax(this.dispatcher), void i3(null)) : i3(null)));
        }
        abortTile(e3, t4) {
          e3.request && (e3.request.cancel(), delete e3.request), t4 && t4();
        }
        unloadTile(t4, i3) {
          t4.texture && t4.texture instanceof e2.T ? (t4.destroy(true), t4.texture && t4.texture instanceof e2.T && this.map.painter.saveTileTexture(t4.texture)) : t4.destroy(), i3 && i3();
        }
        hasTransition() {
          return false;
        }
        cancelTileJSONRequest() {
          this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
        }
      }
      class Ke extends Je {
        constructor(t4, i3, o3, s3) {
          super(t4, i3, o3, s3), this.type = "raster-array", this.maxzoom = 22, this._options = e2.m({ type: "raster-array" }, i3);
        }
        triggerRepaint(e3) {
          const t4 = this.map.painter._terrain, i3 = this.map.style.getSourceCache(this.id);
          t4 && t4.enabled && i3 && t4._clearRenderCacheForTile(i3.id, e3.tileID), this.map.triggerRepaint();
        }
        loadTile(t4, i3) {
          const o3 = this.map._requestManager.normalizeTileURL(t4.tileID.canonical.url(this.tiles, this.scheme), false, this.tileSize), s3 = this.map._requestManager.transformRequest(o3, e2.R.Tile);
          t4.requestParams = s3, t4.actor || (t4.actor = this.dispatcher.getActor()), t4.request = t4.fetchHeader(void 0, (e3, o4, s4, r3) => {
            if (delete t4.request, t4.aborted) return t4.state = "unloaded", i3(null);
            if (e3) {
              if (20 === e3.code) return;
              return t4.state = "errored", i3(e3);
            }
            this.map._refreshExpiredTiles && t4.setExpiryData({ cacheControl: s4, expires: r3 }), t4.state = "empty", i3(null);
          });
        }
        unloadTile(t4, i3) {
          const o3 = t4.texture;
          o3 && o3 instanceof e2.T ? (t4.destroy(true), this.map.painter.saveTileTexture(o3)) : (t4.destroy(), t4.flushQueues(), t4._isHeaderLoaded = false, delete t4._mrt, delete t4.textureDescriptor), t4.fbo && (t4.fbo.destroy(), delete t4.fbo), delete t4.request, delete t4.requestParams, delete t4.neighboringTiles, t4.state = "unloaded";
        }
        prepareTile(t4, i3, o3) {
          t4._isHeaderLoaded && ("empty" !== t4.state && (t4.state = "reloading"), t4.fetchBand(i3, o3, (i4, o4) => {
            if (i4) return t4.state = "errored", this.fire(new e2.t(i4)), void this.triggerRepaint(t4);
            o4 && (t4.setTexture(o4, this.map.painter), t4.state = "loaded", this.triggerRepaint(t4));
          }));
        }
        getInitialBand(e3) {
          if (!this.rasterLayers) return 0;
          const t4 = this.rasterLayers.find(({ id: t5 }) => t5 === e3), i3 = t4 && t4.fields, o3 = i3 && i3.bands && i3.bands;
          return o3 ? o3[0] : 0;
        }
        getTextureDescriptor(t4, i3, o3) {
          if (!t4) return;
          const s3 = i3.sourceLayer || this.rasterLayerIds && this.rasterLayerIds[0];
          if (!s3) return;
          let r3 = null;
          i3 instanceof e2.aB ? r3 = i3.paint.get("raster-array-band") : i3 instanceof e2.aC && (r3 = i3.paint.get("raster-particle-array-band"));
          const a4 = r3 || this.getInitialBand(s3);
          if (null != a4) if (t4.textureDescriptor) {
            if (!t4.updateNeeded(s3, a4) || o3) return Object.assign({}, t4.textureDescriptor, { texture: t4.texture });
          } else this.prepareTile(t4, s3, a4);
        }
      }
      const Ye = { vector: Xe, raster: Je, "raster-dem": class extends Je {
        constructor(t4, i3, o3, s3) {
          super(t4, i3, o3, s3), this.type = "raster-dem", this.maxzoom = 22, this._options = e2.m({ type: "raster-dem" }, i3), this.encoding = i3.encoding || "mapbox";
        }
        loadTile(t4, i3) {
          const o3 = this.map._requestManager.normalizeTileURL(t4.tileID.canonical.url(this.tiles, this.scheme), false, this.tileSize);
          function s3(e3, o4) {
            e3 && (t4.state = "errored", i3(e3)), o4 && (t4.dem = o4, t4.dem.onDeserialize(), t4.needsHillshadePrepare = true, t4.needsDEMTextureUpload = true, t4.state = "loaded", i3(null));
          }
          t4.request = e2.q(this.map._requestManager.transformRequest(o3, e2.R.Tile), (function(o4, r3, a4, n3) {
            if (delete t4.request, t4.aborted) t4.state = "unloaded", i3(null);
            else if (o4) t4.state = "errored", i3(o4);
            else if (r3) {
              this.map._refreshExpiredTiles && t4.setExpiryData({ cacheControl: a4, expires: n3 });
              const i4 = ImageBitmap && r3 instanceof ImageBitmap && e2.ay(), o5 = 1 - (r3.width - e2.az(r3.width)) / 2;
              o5 < 1 || t4.neighboringTiles || (t4.neighboringTiles = this._getNeighboringTiles(t4.tileID));
              const l3 = i4 ? r3 : e2.e.getImageData(r3, o5), c3 = { uid: t4.uid, coord: t4.tileID, source: this.id, scope: this.scope, rawImageData: l3, encoding: this.encoding, padding: o5 };
              t4.actor && "expired" !== t4.state || (t4.actor = this.dispatcher.getActor(), t4.actor.send("loadDEMTile", c3, s3.bind(this), void 0, true));
            }
          }).bind(this));
        }
        _getNeighboringTiles(t4) {
          const i3 = t4.canonical, o3 = Math.pow(2, i3.z), s3 = (i3.x - 1 + o3) % o3, r3 = 0 === i3.x ? t4.wrap - 1 : t4.wrap, a4 = (i3.x + 1 + o3) % o3, n3 = i3.x + 1 === o3 ? t4.wrap + 1 : t4.wrap, l3 = {};
          return l3[new e2.aA(t4.overscaledZ, r3, i3.z, s3, i3.y).key] = { backfilled: false }, l3[new e2.aA(t4.overscaledZ, n3, i3.z, a4, i3.y).key] = { backfilled: false }, i3.y > 0 && (l3[new e2.aA(t4.overscaledZ, r3, i3.z, s3, i3.y - 1).key] = { backfilled: false }, l3[new e2.aA(t4.overscaledZ, t4.wrap, i3.z, i3.x, i3.y - 1).key] = { backfilled: false }, l3[new e2.aA(t4.overscaledZ, n3, i3.z, a4, i3.y - 1).key] = { backfilled: false }), i3.y + 1 < o3 && (l3[new e2.aA(t4.overscaledZ, r3, i3.z, s3, i3.y + 1).key] = { backfilled: false }, l3[new e2.aA(t4.overscaledZ, t4.wrap, i3.z, i3.x, i3.y + 1).key] = { backfilled: false }, l3[new e2.aA(t4.overscaledZ, n3, i3.z, a4, i3.y + 1).key] = { backfilled: false }), l3;
        }
      }, "raster-array": Ke, geojson: class extends e2.E {
        constructor(t4, i3, o3, s3) {
          super(), this.id = t4, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = true, this.reparseOverscaled = true, this._loaded = false, this.actor = o3.getActor(), this.setEventedParent(s3), this._data = i3.data, this._options = e2.m({}, i3), this._collectResourceTiming = i3.collectResourceTiming, void 0 !== i3.maxzoom && (this.maxzoom = i3.maxzoom), void 0 !== i3.minzoom && (this.minzoom = i3.minzoom), i3.type && (this.type = i3.type), i3.attribution && (this.attribution = i3.attribution), this.promoteId = i3.promoteId;
          const r3 = e2.ab / this.tileSize;
          this.workerOptions = e2.m({ source: this.id, scope: this.scope, cluster: i3.cluster || false, geojsonVtOptions: { buffer: (void 0 !== i3.buffer ? i3.buffer : 128) * r3, tolerance: (void 0 !== i3.tolerance ? i3.tolerance : 0.375) * r3, extent: e2.ab, maxZoom: this.maxzoom, lineMetrics: i3.lineMetrics || false, generateId: i3.generateId || false }, superclusterOptions: { maxZoom: void 0 !== i3.clusterMaxZoom ? i3.clusterMaxZoom : this.maxzoom - 1, minPoints: Math.max(2, i3.clusterMinPoints || 2), extent: e2.ab, radius: (void 0 !== i3.clusterRadius ? i3.clusterRadius : 50) * r3, log: false, generateId: i3.generateId || false }, clusterProperties: i3.clusterProperties, filter: i3.filter, dynamic: i3.dynamic }, i3.workerOptions);
        }
        onAdd(e3) {
          this.map = e3, this.setData(this._data);
        }
        setData(e3) {
          return this._data = e3, this._updateWorkerData(), this;
        }
        updateData(t4) {
          if (!this._options.dynamic) return this.fire(new e2.t(new Error("Can't call updateData on a GeoJSON source with dynamic set to false.")));
          if ("string" != typeof t4 && ("Feature" === t4.type && (t4 = { type: "FeatureCollection", features: [t4] }), "FeatureCollection" !== t4.type)) return this.fire(new e2.t(new Error("Data to update should be a feature or a feature collection.")));
          if (this._coalesce && "string" != typeof t4 && "string" != typeof this._data && "FeatureCollection" === this._data.type) {
            const e3 = /* @__PURE__ */ new Map();
            for (const t5 of this._data.features) e3.set(t5.id, t5);
            for (const i3 of t4.features) e3.set(i3.id, i3);
            this._data.features = [...e3.values()];
          } else this._data = t4;
          return this._updateWorkerData(true), this;
        }
        getClusterExpansionZoom(e3, t4) {
          return this.actor.send("geojson.getClusterExpansionZoom", { clusterId: e3, source: this.id, scope: this.scope }, t4), this;
        }
        getClusterChildren(e3, t4) {
          return this.actor.send("geojson.getClusterChildren", { clusterId: e3, source: this.id, scope: this.scope }, t4), this;
        }
        getClusterLeaves(e3, t4, i3, o3) {
          return this.actor.send("geojson.getClusterLeaves", { source: this.id, scope: this.scope, clusterId: e3, limit: t4, offset: i3 }, o3), this;
        }
        _updateWorkerData(t4 = false) {
          if (this._pendingLoad) return void (this._coalesce = true);
          this.fire(new e2.x("dataloading", { dataType: "source" })), this._loaded = false;
          const i3 = e2.m({ append: t4 }, this.workerOptions);
          i3.scope = this.scope;
          const o3 = this._data;
          "string" == typeof o3 ? (i3.request = this.map._requestManager.transformRequest(e2.e.resolveURL(o3), e2.R.Source), i3.request.collectResourceTiming = this._collectResourceTiming) : i3.data = JSON.stringify(o3), this._pendingLoad = this.actor.send(`${this.type}.loadData`, i3, (i4, o4) => {
            if (this._loaded = true, this._pendingLoad = null, i4) this.fire(new e2.t(i4));
            else {
              const i5 = { dataType: "source", sourceDataType: this._metadataFired ? "content" : "metadata" };
              this._collectResourceTiming && o4 && o4.resourceTiming && o4.resourceTiming[this.id] && (i5.resourceTiming = o4.resourceTiming[this.id]), t4 && (this._partialReload = true), this.fire(new e2.x("data", i5)), this._partialReload = false, this._metadataFired = true;
            }
            this._coalesce && (this._updateWorkerData(t4), this._coalesce = false);
          });
        }
        loaded() {
          return this._loaded;
        }
        loadTile(t4, i3) {
          const o3 = t4.actor ? "reloadTile" : "loadTile";
          t4.actor = this.actor;
          const s3 = this.map.style ? this.map.style.getLut(this.scope) : null, r3 = s3 ? { image: s3.image.clone() } : null, a4 = this._partialReload, n3 = { type: this.type, uid: t4.uid, tileID: t4.tileID, tileZoom: t4.tileZoom, zoom: t4.tileID.overscaledZ, maxZoom: this.maxzoom, tileSize: this.tileSize, source: this.id, lut: r3, scope: this.scope, pixelRatio: e2.e.devicePixelRatio, showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId, brightness: this.map.style && this.map.style.getBrightness() || 0, scaleFactor: this.map.getScaleFactor(), partial: a4 };
          t4.request = this.actor.send(o3, n3, (e3, s4) => a4 && !s4 ? (t4.state = "loaded", i3(null)) : (delete t4.request, t4.destroy(), t4.aborted ? i3(null) : e3 ? i3(e3) : (t4.loadVectorData(s4, this.map.painter, "reloadTile" === o3), i3(null))), void 0, "loadTile" === o3);
        }
        abortTile(e3) {
          e3.request && (e3.request.cancel(), delete e3.request), e3.aborted = true;
        }
        unloadTile(e3, t4) {
          this.actor.send("removeTile", { uid: e3.uid, type: this.type, source: this.id, scope: this.scope }), e3.destroy();
        }
        onRemove(e3) {
          this._pendingLoad && this._pendingLoad.cancel();
        }
        serialize() {
          return e2.m({}, this._options, { type: this.type, data: this._data });
        }
        hasTransition() {
          return false;
        }
      }, video: class extends e2.aD {
        constructor(e3, t4, i3, o3) {
          super(e3, t4, i3, o3), this.roundZoom = true, this.type = "video", this.options = t4;
        }
        load() {
          this._loaded = false;
          const t4 = this.options;
          this.urls = [];
          for (const i3 of t4.urls) this.urls.push(this.map._requestManager.transformRequest(i3, e2.R.Source).url);
          e2.aE(this.urls, (t5, i3) => {
            this._loaded = true, t5 ? this.fire(new e2.t(t5)) : i3 && (this.video = i3, this.video.loop = true, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", () => {
              this.map.triggerRepaint();
            }), this.map && this.video.play(), this._finishLoading());
          });
        }
        pause() {
          this.video && this.video.pause();
        }
        play() {
          this.video && this.video.play();
        }
        seek(t4) {
          if (this.video) {
            const i3 = this.video.seekable;
            t4 < i3.start(0) || t4 > i3.end(0) ? this.fire(new e2.t(new e2.V(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i3.start(0)} and ${i3.end(0)}-second mark.`))) : this.video.currentTime = t4;
          }
        }
        getVideo() {
          return this.video;
        }
        onAdd(e3) {
          this.map || (this.map = e3, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
        }
        prepare() {
          if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
          const t4 = this.map.painter.context, i3 = t4.gl;
          this.texture ? this.video.paused || (this.texture.bind(i3.LINEAR, i3.CLAMP_TO_EDGE), i3.texSubImage2D(i3.TEXTURE_2D, 0, 0, 0, i3.RGBA, i3.UNSIGNED_BYTE, this.video)) : (this.texture = new e2.T(t4, this.video, i3.RGBA8), this.texture.bind(i3.LINEAR, i3.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(t4);
        }
        serialize() {
          return { type: "video", urls: this.urls, coordinates: this.coordinates };
        }
        hasTransition() {
          return this.video && !this.video.paused;
        }
      }, image: e2.aD, model: class extends e2.E {
        constructor(e3, t4, i3, o3) {
          super(), this.id = e3, this.type = "model", this.models = [], this._loaded = false, this._options = t4;
        }
        load() {
          const t4 = [];
          for (const i3 in this._options.models) {
            const o3 = this._options.models[i3], s3 = e2.aG(this.map._requestManager.transformRequest(o3.uri, e2.R.Model).url).then((t5) => {
              if (!t5) return;
              const s4 = e2.aH(t5), r3 = new e2.aI(i3, o3.position, o3.orientation, s4);
              r3.computeBoundsAndApplyParent(), this.models.push(r3);
            }).catch((t5) => {
              this.fire(new e2.t(new Error(`Could not load model ${i3} from ${o3.uri}: ${t5.message}`)));
            });
            t4.push(s3);
          }
          return Promise.allSettled(t4).then(() => {
            this._loaded = true, this.fire(new e2.x("data", { dataType: "source", sourceDataType: "metadata" }));
          }).catch((t5) => {
            this.fire(new e2.t(new Error(`Could not load models: ${t5.message}`)));
          });
        }
        onAdd(e3) {
          this.map = e3, this.load();
        }
        hasTransition() {
          return false;
        }
        loaded() {
          return this._loaded;
        }
        getModels() {
          return this.models;
        }
        loadTile(e3, t4) {
        }
        serialize() {
          return { type: "model" };
        }
      }, "batched-model": class extends e2.E {
        constructor(e3, t4, i3, o3) {
          super(), this.type = "batched-model", this.id = e3, this.tileSize = 512, this._options = t4, this.tiles = this._options.tiles, this.maxzoom = t4.maxzoom || 19, this.minzoom = t4.minzoom || 0, this.roundZoom = true, this.usedInConflation = true, this.dispatcher = i3, this.reparseOverscaled = false, this.scheme = "xyz", this._loaded = false, this.setEventedParent(o3);
        }
        onAdd(e3) {
          this.map = e3, this.load();
        }
        load(t4) {
          this._loaded = false, this.fire(new e2.x("dataloading", { dataType: "source" }));
          const i3 = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o3 = this.map.getWorldview();
          this._tileJSONRequest = We(this._options, this.map._requestManager, i3, o3, (s3, r3) => {
            this._tileJSONRequest = null, this._loaded = true, s3 ? (i3 && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i3}`), o3 && 2 !== o3.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o3}`), this.fire(new e2.t(s3))) : r3 && (e2.m(this, r3), r3.bounds && (this.tileBounds = new $e(r3.bounds, this.minzoom, this.maxzoom)), L2(r3.tiles, this.map._requestManager._customAccessToken), this.fire(new e2.x("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e2.x("data", { dataType: "source", sourceDataType: "content" }))), t4 && t4(s3);
          });
        }
        hasTransition() {
          return false;
        }
        hasTile(e3) {
          return !this.tileBounds || this.tileBounds.contains(e3.canonical);
        }
        loaded() {
          return this._loaded;
        }
        loadTile(t4, i3) {
          const o3 = this.map._requestManager.normalizeTileURL(t4.tileID.canonical.url(this.tiles, this.scheme)), s3 = { request: this.map._requestManager.transformRequest(o3, e2.R.Tile), data: void 0, uid: t4.uid, tileID: t4.tileID, tileZoom: t4.tileZoom, zoom: t4.tileID.overscaledZ, tileSize: this.tileSize * t4.tileID.overscaleFactor(), type: this.type, source: this.id, scope: this.scope, showCollisionBoxes: this.map.showCollisionBoxes, isSymbolTile: t4.isSymbolTile, brightness: this.map.style && this.map.style.getBrightness() || 0, lut: null, maxZoom: null, promoteId: null, pixelRatio: null, scaleFactor: null };
          if (t4.actor && "expired" !== t4.state) if ("loading" === t4.state) t4.reloadCallback = i3;
          else {
            if (t4.buckets) {
              const e3 = Object.values(t4.buckets);
              for (const t5 of e3) t5.dirty = true;
              return void (t4.state = "loaded");
            }
            t4.request = t4.actor.send("reloadTile", s3, r3.bind(this));
          }
          else t4.actor = this.dispatcher.getActor(), t4.request = t4.actor.send("loadTile", s3, r3.bind(this), void 0, true);
          function r3(e3, o4) {
            return t4.aborted ? i3(null) : e3 && 404 !== e3.status ? i3(e3) : (this.map._refreshExpiredTiles && o4 && t4.setExpiryData(o4), t4.loadModelData(o4, this.map.painter), t4.state = "loaded", void i3(null));
          }
        }
        serialize() {
          return e2.m({}, this._options);
        }
      }, canvas: class extends e2.aD {
        constructor(t4, i3, o3, s3) {
          super(t4, i3, o3, s3), i3.coordinates ? Array.isArray(i3.coordinates) && 4 === i3.coordinates.length && !i3.coordinates.some((e3) => !Array.isArray(e3) || 2 !== e3.length || e3.some((e4) => "number" != typeof e4)) || this.fire(new e2.t(new e2.V(`sources.${t4}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e2.t(new e2.V(`sources.${t4}`, null, 'missing required property "coordinates"'))), i3.animate && "boolean" != typeof i3.animate && this.fire(new e2.t(new e2.V(`sources.${t4}`, null, 'optional "animate" property must be a boolean value'))), i3.canvas ? "string" == typeof i3.canvas || i3.canvas instanceof HTMLCanvasElement || this.fire(new e2.t(new e2.V(`sources.${t4}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e2.t(new e2.V(`sources.${t4}`, null, 'missing required property "canvas"'))), this.options = i3, this.animate = void 0 === i3.animate || i3.animate;
        }
        load() {
          this._loaded = true, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e2.t(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
            this._playing = true, this.map.triggerRepaint();
          }, this.pause = function() {
            this._playing && (this.prepare(), this._playing = false);
          }, this._finishLoading());
        }
        getCanvas() {
          return this.canvas;
        }
        onAdd(e3) {
          this.map = e3, this.load(), this.canvas && this.animate && this.play();
        }
        onRemove(e3) {
          this.pause();
        }
        prepare() {
          let t4 = false;
          if (this.canvas.width !== this.width && (this.width = this.canvas.width, t4 = true), this.canvas.height !== this.height && (this.height = this.canvas.height, t4 = true), this._hasInvalidDimensions()) return;
          if (0 === Object.keys(this.tiles).length) return;
          const i3 = this.map.painter.context;
          this.texture ? !t4 && !this._playing || this.texture instanceof e2.aF || this.texture.update(this.canvas, { premultiply: true }) : this.texture = new e2.T(i3, this.canvas, i3.gl.RGBA8, { premultiply: true }), this._prepareData(i3);
        }
        serialize() {
          return { type: "canvas", coordinates: this.coordinates };
        }
        hasTransition() {
          return this._playing;
        }
        _hasInvalidDimensions() {
          for (const e3 of [this.canvas.width, this.canvas.height]) if (isNaN(e3) || e3 <= 0) return true;
          return false;
        }
      }, custom: class extends e2.E {
        constructor(t4, i3, o3, s3) {
          super(), this.id = t4, this.type = "custom", this._dataType = "raster", this._dispatcher = o3, this._implementation = i3, this.setEventedParent(s3), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = false, this.roundZoom = true, this._implementation || this.fire(new e2.t(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new e2.t(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new $e(this._implementation.bounds, this.minzoom, this.maxzoom)), i3.update = this._update.bind(this), i3.clearTiles = this._clearTiles.bind(this), i3.coveringTiles = this._coveringTiles.bind(this), e2.m(this, e2.ar(i3, ["dataType", "scheme", "minzoom", "maxzoom", "tileSize", "attribution", "minTileCacheSize", "maxTileCacheSize"]));
        }
        serialize() {
          return e2.ar(this, ["type", "scheme", "minzoom", "maxzoom", "tileSize", "attribution"]);
        }
        load() {
          this._loaded = true, this.fire(new e2.x("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e2.x("data", { dataType: "source", sourceDataType: "content" }));
        }
        loaded() {
          return this._loaded;
        }
        onAdd(t4) {
          this.map = t4, this._loaded = false, this.fire(new e2.x("dataloading", { dataType: "source" })), this._implementation.onAdd && this._implementation.onAdd(t4), this.load();
        }
        onRemove(e3) {
          this._implementation.onRemove && this._implementation.onRemove(e3);
        }
        hasTile(e3) {
          if (this._implementation.hasTile) {
            const { x: t4, y: i3, z: o3 } = e3.canonical;
            return this._implementation.hasTile({ x: t4, y: i3, z: o3 });
          }
          return !this.tileBounds || this.tileBounds.contains(e3.canonical);
        }
        loadTile(e3, t4) {
          const { x: i3, y: o3, z: s3 } = e3.tileID.canonical, r3 = new AbortController();
          e3.request = Promise.resolve(this._implementation.loadTile({ x: i3, y: o3, z: s3 }, { signal: r3.signal })).then((function(i4) {
            return delete e3.request, e3.aborted ? (e3.state = "unloaded", t4(null)) : void 0 === i4 ? (e3.state = "errored", t4(null)) : null === i4 ? (this.loadTileData(e3, { width: this.tileSize, height: this.tileSize, data: null }), e3.state = "loaded", t4(null)) : function(e4) {
              return e4 instanceof ImageData || e4 instanceof HTMLCanvasElement || e4 instanceof ImageBitmap || e4 instanceof HTMLImageElement;
            }(i4) ? (this.loadTileData(e3, i4), e3.state = "loaded", void t4(null)) : (e3.state = "errored", t4(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`)));
          }).bind(this)).catch((i4) => {
            20 !== i4.code && (e3.state = "errored", t4(i4));
          }), e3.request.cancel = () => r3.abort();
        }
        loadTileData(e3, t4) {
          e3.setTexture(t4, this.map.painter);
        }
        unloadTile(t4, i3) {
          if (t4.texture && t4.texture instanceof e2.T ? (t4.destroy(true), t4.texture && t4.texture instanceof e2.T && this.map.painter.saveTileTexture(t4.texture)) : t4.destroy(), this._implementation.unloadTile) {
            const { x: e3, y: i4, z: o3 } = t4.tileID.canonical;
            this._implementation.unloadTile({ x: e3, y: i4, z: o3 });
          }
          i3 && i3();
        }
        abortTile(e3, t4) {
          e3.request && e3.request.cancel && (e3.request.cancel(), delete e3.request), t4 && t4();
        }
        hasTransition() {
          return false;
        }
        _coveringTiles() {
          return this.map.transform.coveringTiles({ tileSize: this.tileSize, minzoom: this.minzoom, maxzoom: this.maxzoom, roundZoom: this.roundZoom }).map((e3) => ({ x: e3.canonical.x, y: e3.canonical.y, z: e3.canonical.z }));
        }
        _clearTiles() {
          const t4 = e2.av(this.id, this.scope);
          this.map.style.clearSource(t4);
        }
        _update() {
          this.fire(new e2.x("data", { dataType: "source", sourceDataType: "content" }));
        }
      } }, Qe = function(t4, i3, o3, s3) {
        const r3 = new Ye[i3.type](t4, i3, o3, s3);
        if (r3.id !== t4) throw new Error(`Expected Source id to be ${t4} instead of ${r3.id}`);
        return e2.aJ(["load", "abort", "unload", "serialize", "prepare"], r3), r3;
      };
      function et2(t4, i3) {
        const o3 = e2.a6.mat4.identity([]);
        return e2.a6.mat4.scale(o3, o3, [0.5 * t4.width, 0.5 * -t4.height, 1]), e2.a6.mat4.translate(o3, o3, [1, -1, 0]), e2.a6.mat4.multiply(o3, o3, t4.calculateProjMatrix(i3.toUnwrapped())), Float32Array.from(o3);
      }
      function tt(t4, i3, o3, s3, r3, a4, n3, l3, c3 = false) {
        const h3 = t4.tilesIn(o3, l3, c3);
        h3.sort(ot);
        const u4 = [];
        for (const e3 of h3) u4.push({ wrappedTileID: e3.tile.tileID.wrapped().key, queryResults: e3.tile.queryRenderedFeatures(i3, t4._state, e3, s3, r3, a4, n3, et2(t4.transform, e3.tile.tileID), c3) });
        const d3 = function(e3) {
          const t5 = {}, i4 = {};
          for (const o4 of e3) {
            const e4 = o4.queryResults, s4 = o4.wrappedTileID, r4 = i4[s4] = i4[s4] || {};
            for (const i5 in e4) {
              const o5 = e4[i5], s5 = r4[i5] = r4[i5] || {}, a5 = t5[i5] = t5[i5] || [];
              for (const e5 of o5) s5[e5.featureIndex] || (s5[e5.featureIndex] = true, a5.push(e5));
            }
          }
          return t5;
        }(u4);
        for (const i4 in d3) d3[i4].forEach((o4) => {
          const s4 = o4.feature, r4 = s4.layer;
          r4 && "background" !== r4.type && "sky" !== r4.type && "slot" !== r4.type && (e2.aK(i4) || (s4.source = r4.source, r4["source-layer"] && (s4.sourceLayer = r4["source-layer"])), s4.state = void 0 !== s4.id ? t4.getFeatureState(r4["source-layer"], s4.id) : {});
        });
        return d3;
      }
      function it2(e3, t4) {
        const i3 = e3.getRenderableIds().map((t5) => e3.getTileByID(t5)), o3 = [], s3 = {};
        for (let e4 = 0; e4 < i3.length; e4++) {
          const r3 = i3[e4], a4 = r3.tileID.canonical.key;
          s3[a4] || (s3[a4] = true, r3.querySourceFeatures(o3, t4));
        }
        return o3;
      }
      function ot(e3, t4) {
        const i3 = e3.tileID, o3 = t4.tileID;
        return i3.overscaledZ - o3.overscaledZ || i3.canonical.y - o3.canonical.y || i3.wrap - o3.wrap || i3.canonical.x - o3.canonical.x;
      }
      function st(e3, t4) {
        const i3 = {};
        if (!t4) return i3;
        for (const o3 of e3) {
          const e4 = o3.layerIds.map((e5) => t4.getLayer(e5)).filter(Boolean);
          if (0 !== e4.length) {
            o3.layers = e4, o3.stateDependentLayerIds && (o3.stateDependentLayers = o3.stateDependentLayerIds.map((t5) => e4.filter((e5) => e5.id === t5)[0]));
            for (const t5 of e4) i3[t5.fqid] = o3;
          }
        }
        return i3;
      }
      const rt = 32, at = 33, nt = new Uint16Array(8184);
      for (let e3 = 0; e3 < 2046; e3++) {
        let t4 = e3 + 2, i3 = 0, o3 = 0, s3 = 0, r3 = 0, a4 = 0, n3 = 0;
        for (1 & t4 ? s3 = r3 = a4 = rt : i3 = o3 = n3 = rt; (t4 >>= 1) > 1; ) {
          const e4 = i3 + s3 >> 1, l4 = o3 + r3 >> 1;
          1 & t4 ? (s3 = i3, r3 = o3, i3 = a4, o3 = n3) : (i3 = s3, o3 = r3, s3 = a4, r3 = n3), a4 = e4, n3 = l4;
        }
        const l3 = 4 * e3;
        nt[l3 + 0] = i3, nt[l3 + 1] = o3, nt[l3 + 2] = s3, nt[l3 + 3] = r3;
      }
      const lt2 = new Uint16Array(2178), ct2 = new Uint8Array(1089), ht = new Uint16Array(1089);
      function ut(e3) {
        return 0 === e3 ? -0.03125 : 32 === e3 ? 0.03125 : 0;
      }
      const dt = (() => ({ type: 2, extent: e2.ab, loadGeometry: () => [[new e2.P(0, 0), new e2.P(e2.ab + 1, 0), new e2.P(e2.ab + 1, e2.ab + 1), new e2.P(0, e2.ab + 1), new e2.P(0, 0)]] }))();
      class _t {
        constructor(t4, i3, o3, s3, r3) {
          this.tileID = t4, this.uid = e2.aQ(), this.uses = 0, this.tileSize = i3, this.tileZoom = o3, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = false, this.hasRTLText = false, this.dependencies = {}, this.isRaster = r3, s3 && s3.style && (this._lastUpdatedBrightness = s3.style.getBrightness()), this.expiredRequestCount = 0, this.state = "loading", s3 && s3.transform && (this.projection = s3.transform.projection);
        }
        registerFadeDuration(t4) {
          const i3 = t4 + this.timeAdded;
          i3 < e2.e.now() || this.fadeEndTime && i3 < this.fadeEndTime || (this.fadeEndTime = i3);
        }
        wasRequested() {
          return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
        }
        get tileTransform() {
          return this._tileTransform || (this._tileTransform = e2.aL(this.tileID.canonical, this.projection)), this._tileTransform;
        }
        loadVectorData(t4, i3, o3) {
          if (this.unloadVectorData(), this.state = "loaded", t4) {
            t4.featureIndex && (this.latestFeatureIndex = t4.featureIndex, t4.rawTileData ? (this.latestRawTileData = t4.rawTileData, this.latestFeatureIndex.rawTileData = t4.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t4.collisionBoxArray, this.buckets = st(t4.buckets, i3.style), this.hasSymbolBuckets = false;
            for (const t5 in this.buckets) {
              const i4 = this.buckets[t5];
              if (i4 instanceof e2.aS) {
                if (this.hasSymbolBuckets = true, !o3) break;
                i4.justReloaded = true;
              }
            }
            if (this.hasRTLText = false, this.hasSymbolBuckets) for (const t5 in this.buckets) {
              const i4 = this.buckets[t5];
              if (i4 instanceof e2.aS && i4.hasRTLText) {
                this.hasRTLText = true, e2.aT();
                break;
              }
            }
            this.queryPadding = 0;
            for (const e3 in this.buckets) {
              const t5 = this.buckets[e3], o4 = i3.style.getOwnLayer(e3);
              if (!o4) continue;
              const s3 = o4.queryRadius(t5);
              this.queryPadding = Math.max(this.queryPadding, s3);
            }
            t4.imageAtlas && (this.imageAtlas = t4.imageAtlas), t4.glyphAtlasImage && (this.glyphAtlasImage = t4.glyphAtlasImage), t4.lineAtlas && (this.lineAtlas = t4.lineAtlas), this._lastUpdatedBrightness = t4.brightness;
          } else this.collisionBoxArray = new e2.aR();
        }
        unloadVectorData() {
          if (this.hasData()) {
            for (const e3 in this.buckets) this.buckets[e3].destroy();
            this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
          }
        }
        loadModelData(e3, t4, i3) {
          e3 && (e3.resourceTiming && (this.resourceTiming = e3.resourceTiming), this.buckets = { ...this.buckets, ...st(e3.buckets, t4.style) }, e3.featureIndex && (this.latestFeatureIndex = e3.featureIndex));
        }
        getBucket(e3) {
          return this.buckets[e3.fqid];
        }
        upload(t4) {
          for (const e3 in this.buckets) {
            const i4 = this.buckets[e3];
            i4.uploadPending() && i4.upload(t4);
          }
          const i3 = t4.gl, o3 = this.imageAtlas;
          if (o3 && !o3.uploaded) {
            const s3 = !!Object.keys(o3.patternPositions).length;
            this.imageAtlasTexture = new e2.T(t4, o3.image, i3.RGBA8, { useMipmap: s3 }), this.imageAtlas.uploaded = true;
          }
          this.glyphAtlasImage && (this.glyphAtlasTexture = new e2.T(t4, this.glyphAtlasImage, i3.R8), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new e2.T(t4, this.lineAtlas.image, i3.R8), this.lineAtlas.uploaded = true);
        }
        prepare(e3, t4, i3) {
          if (this.imageAtlas && this.imageAtlasTexture && this.imageAtlas.patchUpdatedImages(e3, this.imageAtlasTexture, i3), !t4 || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) return;
          const o3 = t4.style.getBrightness();
          (this._lastUpdatedBrightness || o3) && (this._lastUpdatedBrightness && o3 && Math.abs(this._lastUpdatedBrightness - o3) < 1e-3 || (this._lastUpdatedBrightness = o3, this.updateBuckets(t4)));
        }
        queryRenderedFeatures(e3, t4, i3, o3, s3, r3, a4, n3, l3) {
          return this.latestFeatureIndex && (this.latestFeatureIndex.rawTileData || this.latestFeatureIndex.is3DTile) ? this.latestFeatureIndex.query({ tileResult: i3, pixelPosMatrix: n3, transform: a4, filter: o3, layers: s3, availableImages: r3, tileTransform: this.tileTransform }, e3, t4) : {};
        }
        querySourceFeatures(t4, i3) {
          const o3 = this.latestFeatureIndex;
          if (!o3 || !o3.rawTileData) return;
          const s3 = o3.loadVTLayers(), r3 = i3 ? i3.sourceLayer : "", a4 = s3._geojsonTileLayer || s3[r3];
          if (!a4) return;
          const n3 = e2.aU(i3 && i3.filter), { z: l3, x: c3, y: h3 } = this.tileID.canonical, u4 = { z: l3, x: c3, y: h3 };
          for (let i4 = 0; i4 < a4.length; i4++) {
            const s4 = a4.feature(i4);
            if (n3.needGeometry) {
              const t5 = e2.aV(s4, true);
              if (!n3.filter(new e2.a3(this.tileID.overscaledZ), t5, this.tileID.canonical)) continue;
            } else if (!n3.filter(new e2.a3(this.tileID.overscaledZ), s4)) continue;
            const d3 = o3.getId(s4, r3), _2 = new e2.aW(s4, l3, c3, h3, d3);
            _2.tile = u4, t4.push(_2);
          }
        }
        hasData() {
          return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
        }
        patternsLoaded() {
          return !!this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
        }
        setExpiryData(t4) {
          const i3 = this.expirationTime;
          if (t4.cacheControl) {
            const i4 = e2.aX(t4.cacheControl);
            i4["max-age"] && (this.expirationTime = Date.now() + 1e3 * i4["max-age"]);
          } else t4.expires && (this.expirationTime = new Date(t4.expires).getTime());
          if (this.expirationTime) {
            const e3 = Date.now();
            let t5 = false;
            if (this.expirationTime > e3) t5 = false;
            else if (i3) if (this.expirationTime < i3) t5 = true;
            else {
              const o3 = this.expirationTime - i3;
              o3 ? this.expirationTime = e3 + Math.max(o3, 3e4) : t5 = true;
            }
            else t5 = true;
            t5 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
          }
        }
        getExpiryTimeout() {
          if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (/* @__PURE__ */ new Date()).getTime(), Math.pow(2, 31) - 1);
        }
        refreshFeatureState(e3) {
          this.latestFeatureIndex && (this.latestFeatureIndex.rawTileData || this.latestFeatureIndex.is3DTile) && e3 && this.updateBuckets(e3);
        }
        updateBuckets(t4) {
          if (!this.latestFeatureIndex) return;
          const i3 = this.latestFeatureIndex.loadVTLayers(), o3 = t4.style.listImages(), s3 = t4.style.getBrightness();
          for (const r3 in this.buckets) {
            if (!t4.style.hasLayer(r3)) continue;
            const a4 = this.buckets[r3], n3 = a4.layers[0], l3 = n3.sourceLayer || "_geojsonTileLayer", c3 = i3[l3], h3 = t4.style.getSourceCache(n3.source, n3.scope);
            let u4 = {};
            h3 && (u4 = h3._state.getState(l3, void 0)), a4.update(u4, c3, o3, this.imageAtlas && this.imageAtlas.patternPositions || {}, s3), (a4 instanceof e2.aY || a4 instanceof e2.aZ) && t4._terrain && t4._terrain.enabled && h3 && a4.programConfigurations.needsUpload && t4._terrain._clearRenderCacheForTile(h3.id, this.tileID);
            const d3 = t4 && t4.style && t4.style.getOwnLayer(r3);
            d3 && (this.queryPadding = Math.max(this.queryPadding, d3.queryRadius(a4)));
          }
        }
        holdingForFade() {
          return void 0 !== this.symbolFadeHoldUntil;
        }
        symbolFadeFinished() {
          return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < e2.e.now();
        }
        clearFadeHold() {
          this.symbolFadeHoldUntil = void 0;
        }
        setHoldDuration(t4) {
          this.symbolFadeHoldUntil = e2.e.now() + t4;
        }
        setTexture(t4, i3) {
          const o3 = i3.context, s3 = o3.gl;
          this.texture = this.texture || i3.getTileTexture(t4.width), this.texture && this.texture instanceof e2.T ? this.texture.update(t4) : (this.texture = new e2.T(o3, t4, s3.RGBA8, { useMipmap: true }), this.texture.bind(s3.LINEAR, s3.CLAMP_TO_EDGE));
        }
        setDependencies(e3, t4) {
          const i3 = {};
          for (const e4 of t4) i3[e4] = true;
          this.dependencies[e3] = i3;
        }
        hasDependency(e3, t4) {
          for (const i3 of e3) {
            const e4 = this.dependencies[i3];
            if (e4) {
              for (const i4 of t4) if (e4[i4]) return true;
            }
          }
          return false;
        }
        clearQueryDebugViz() {
        }
        _makeDebugTileBoundsBuffers(t4, i3) {
          if (!i3 || "mercator" === i3.name || this._tileDebugBuffer) return;
          const o3 = e2.a_(dt, this.tileID.canonical, this.tileTransform)[0], s3 = new e2.a$(), r3 = new e2.b0();
          for (let e3 = 0; e3 < o3.length; e3++) {
            const { x: t5, y: i4 } = o3[e3];
            s3.emplaceBack(t5, i4), r3.emplaceBack(e3);
          }
          r3.emplaceBack(0), this._tileDebugIndexBuffer = t4.createIndexBuffer(r3), this._tileDebugBuffer = t4.createVertexBuffer(s3, e2.b1.members), this._tileDebugSegments = e2.b2.simpleSegment(0, 0, s3.length, r3.length);
        }
        _makeTileBoundsBuffers(t4, i3) {
          if (this._tileBoundsBuffer || !i3 || "mercator" === i3.name) return;
          const o3 = e2.a_(dt, this.tileID.canonical, this.tileTransform)[0];
          let s3, r3;
          if (this.isRaster) {
            const t5 = function(t6, i4) {
              const o4 = e2.aL(t6, i4), s4 = Math.pow(2, t6.z);
              for (let r5 = 0; r5 < at; r5++) for (let a5 = 0; a5 < at; a5++) {
                const n4 = e2.aM((t6.x + (a5 + ut(a5)) / rt) / s4), l4 = e2.aN((t6.y + (r5 + ut(r5)) / rt) / s4), c4 = i4.project(n4, l4), h3 = r5 * at + a5;
                lt2[2 * h3 + 0] = Math.round((c4.x * o4.scale - o4.x) * e2.ab), lt2[2 * h3 + 1] = Math.round((c4.y * o4.scale - o4.y) * e2.ab);
              }
              ct2.fill(0), ht.fill(0);
              for (let e3 = 2045; e3 >= 0; e3--) {
                const t7 = 4 * e3, i5 = nt[t7 + 0], o5 = nt[t7 + 1], s5 = nt[t7 + 2], r5 = nt[t7 + 3], a5 = i5 + s5 >> 1, n4 = o5 + r5 >> 1, l4 = a5 + n4 - o5, c4 = n4 + i5 - a5, h3 = o5 * at + i5, u4 = r5 * at + s5, d3 = n4 * at + a5, _2 = Math.hypot((lt2[2 * h3 + 0] + lt2[2 * u4 + 0]) / 2 - lt2[2 * d3 + 0], (lt2[2 * h3 + 1] + lt2[2 * u4 + 1]) / 2 - lt2[2 * d3 + 1]) >= 16;
                ct2[d3] = ct2[d3] || (_2 ? 1 : 0), e3 < 1022 && (ct2[d3] = ct2[d3] || ct2[(o5 + c4 >> 1) * at + (i5 + l4 >> 1)] || ct2[(r5 + c4 >> 1) * at + (s5 + l4 >> 1)]);
              }
              const r4 = new e2.aO(), a4 = new e2.aP();
              let n3 = 0;
              function l3(t7, i5) {
                const o5 = i5 * at + t7;
                return 0 === ht[o5] && (r4.emplaceBack(lt2[2 * o5 + 0], lt2[2 * o5 + 1], t7 * e2.ab / rt, i5 * e2.ab / rt), ht[o5] = ++n3), ht[o5] - 1;
              }
              function c3(e3, t7, i5, o5, s5, r5) {
                const n4 = e3 + i5 >> 1, h3 = t7 + o5 >> 1;
                if (Math.abs(e3 - s5) + Math.abs(t7 - r5) > 1 && ct2[h3 * at + n4]) c3(s5, r5, e3, t7, n4, h3), c3(i5, o5, s5, r5, n4, h3);
                else {
                  const n5 = l3(e3, t7), c4 = l3(i5, o5), h4 = l3(s5, r5);
                  a4.emplaceBack(n5, c4, h4);
                }
              }
              return c3(0, 0, rt, rt, rt, 0), c3(rt, rt, 0, 0, 0, rt), { vertices: r4, indices: a4 };
            }(this.tileID.canonical, i3);
            s3 = t5.vertices, r3 = t5.indices;
          } else {
            s3 = new e2.aO(), r3 = new e2.aP();
            for (const { x: e3, y: t6 } of o3) s3.emplaceBack(e3, t6, 0, 0);
            const t5 = e2.b3(s3.int16, void 0, 4);
            for (let e3 = 0; e3 < t5.length; e3 += 3) r3.emplaceBack(t5[e3], t5[e3 + 1], t5[e3 + 2]);
          }
          this._tileBoundsBuffer = t4.createVertexBuffer(s3, e2.b4.members), this._tileBoundsIndexBuffer = t4.createIndexBuffer(r3), this._tileBoundsSegments = e2.b2.simpleSegment(0, 0, s3.length, r3.length);
        }
        _makeGlobeTileDebugBuffers(t4, i3) {
          const o3 = i3.projection;
          if (!o3 || "globe" !== o3.name || i3.freezeTileCoverage) return;
          const s3 = this.tileID.canonical, r3 = e2.b5(s3, i3), a4 = e2.b6(r3), n3 = e2.a9(i3.zoom);
          let l3;
          n3 > 0 && (l3 = e2.a6.mat4.invert(new Float64Array(16), i3.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(t4, s3, i3, a4, l3, n3), this._makeGlobeTileDebugTextBuffer(t4, s3, i3, a4, l3, n3);
        }
        _globePoint(t4, i3, o3, s3, r3, a4, n3) {
          let l3 = e2.b7(t4, i3, o3);
          if (a4) {
            const r4 = 1 << o3.z, c3 = e2.am(s3.center.lng), h3 = e2.at(s3.center.lat), u4 = (o3.x + 0.5) / r4 - c3;
            let d3 = 0;
            u4 > 0.5 ? d3 = -1 : u4 < -0.5 && (d3 = 1);
            let _2 = (t4 / e2.ab + o3.x) / r4 + d3, p3 = (i3 / e2.ab + o3.y) / r4;
            _2 = (_2 - c3) * s3._pixelsPerMercatorPixel + c3, p3 = (p3 - h3) * s3._pixelsPerMercatorPixel + h3;
            const f3 = [_2 * s3.worldSize, p3 * s3.worldSize, 0];
            e2.a6.vec3.transformMat4(f3, f3, a4), l3 = e2.b8(l3, f3, n3);
          }
          return e2.a6.vec3.transformMat4(l3, l3, r3);
        }
        _makeGlobeTileDebugBorderBuffer(t4, i3, o3, s3, r3, a4) {
          const n3 = new e2.a$(), l3 = new e2.b0(), c3 = new e2.b9(), h3 = (e3, t5, h4, u5, d3) => {
            const _2 = (h4 - e3) / (d3 - 1), p3 = (u5 - t5) / (d3 - 1), f3 = n3.length;
            for (let h5 = 0; h5 < d3; h5++) {
              const u6 = e3 + h5 * _2, d4 = t5 + h5 * p3;
              n3.emplaceBack(u6, d4);
              const m2 = this._globePoint(u6, d4, i3, o3, s3, r3, a4);
              c3.emplaceBack(m2[0], m2[1], m2[2]), l3.emplaceBack(f3 + h5);
            }
          }, u4 = e2.ab;
          h3(0, 0, u4, 0, 16), h3(u4, 0, u4, u4, 16), h3(u4, u4, 0, u4, 16), h3(0, u4, 0, 0, 16), this._tileDebugIndexBuffer = t4.createIndexBuffer(l3), this._tileDebugBuffer = t4.createVertexBuffer(n3, e2.b1.members), this._globeTileDebugBorderBuffer = t4.createVertexBuffer(c3, e2.ba.members), this._tileDebugSegments = e2.b2.simpleSegment(0, 0, n3.length, l3.length);
        }
        _makeGlobeTileDebugTextBuffer(t4, i3, o3, s3, r3, a4) {
          const n3 = e2.ab / 4, l3 = new e2.a$(), c3 = new e2.aP(), h3 = new e2.b9(), u4 = 25;
          c3.reserve(32), l3.reserve(u4), h3.reserve(u4);
          const d3 = (e3, t5) => u4 * e3 + t5;
          for (let e3 = 0; e3 < u4; e3++) {
            const t5 = e3 * n3;
            for (let e4 = 0; e4 < u4; e4++) {
              const c4 = e4 * n3;
              l3.emplaceBack(c4, t5);
              const u5 = this._globePoint(c4, t5, i3, o3, s3, r3, a4);
              h3.emplaceBack(u5[0], u5[1], u5[2]);
            }
          }
          for (let e3 = 0; e3 < 4; e3++) for (let t5 = 0; t5 < 4; t5++) {
            const i4 = d3(e3, t5), o4 = d3(e3, t5 + 1), s4 = d3(e3 + 1, t5), r4 = d3(e3 + 1, t5 + 1);
            c3.emplaceBack(i4, o4, s4), c3.emplaceBack(s4, o4, r4);
          }
          this._tileDebugTextIndexBuffer = t4.createIndexBuffer(c3), this._tileDebugTextBuffer = t4.createVertexBuffer(l3, e2.b1.members), this._globeTileDebugTextBuffer = t4.createVertexBuffer(h3, e2.ba.members), this._tileDebugTextSegments = e2.b2.simpleSegment(0, 0, u4, 32);
        }
        destroy(t4 = false) {
          for (const e3 in this.buckets) this.buckets[e3].destroy();
          this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture.destroy(), delete this.imageAtlasTexture), this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), !t4 && this.texture && this.texture instanceof e2.T && (this.texture.destroy(), delete this.texture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.rasterParticleState && (this.rasterParticleState.destroy(), delete this.rasterParticleState), this.latestFeatureIndex = null, this.state = "unloaded";
        }
      }
      e2.bb.setPbf(e2.bc);
      class pt2 extends _t {
        constructor(e3, t4, i3, o3, s3) {
          super(e3, t4, i3, o3, s3), this._workQueue = [], this._fetchQueue = [], this._isHeaderLoaded = false;
        }
        setTexture(t4, i3) {
          const o3 = i3.context, s3 = o3.gl;
          this.texture = this.texture || i3.getTileTexture(t4.width), this.texture && this.texture instanceof e2.T ? this.texture.update(t4, { premultiply: false }) : this.texture = new e2.T(o3, t4, s3.RGBA8, { premultiply: false });
        }
        flushQueues() {
          for (; this._workQueue.length; ) this._workQueue.pop()();
          for (; this._fetchQueue.length; ) this._fetchQueue.pop()();
        }
        fetchHeader(t4 = 16384, i3) {
          const o3 = this._mrt = new e2.bb(30), s3 = Object.assign({}, this.requestParams, { headers: { Range: "bytes=0-" + (t4 - 1) } });
          return this.entireBuffer = null, this.request = e2.bd(s3, (e3, s4, r3, a4) => {
            if (e3) i3(e3);
            else try {
              const e4 = o3.getHeaderLength(s4);
              if (e4 > t4) return void (this.request = this.fetchHeader(e4, i3));
              o3.parseHeader(s4), this._isHeaderLoaded = true;
              let n3 = 0;
              for (const e5 of Object.values(o3.layers)) n3 = Math.max(n3, e5.dataIndex[e5.dataIndex.length - 1].last_byte);
              s4.byteLength >= n3 && (this.entireBuffer = s4), i3(null, this.entireBuffer || s4, r3, a4);
            } catch (e4) {
              i3(e4);
            }
          }), this.request;
        }
        fetchBand(t4, i3, o3) {
          const s3 = this._mrt;
          if (!this._isHeaderLoaded || !s3) return void o3(new Error("Tile header is not ready"));
          const r3 = this.actor;
          if (!r3) return void o3(new Error("Can't fetch tile band without an actor"));
          let a4;
          const n3 = (e3, s4) => {
            a4.complete(e3, s4), e3 ? o3(e3) : (this.updateTextureDescriptor(t4, i3), o3(null, this.textureDescriptor && this.textureDescriptor.img));
          }, l3 = (e3, t5) => {
            if (e3) return o3(e3);
            const i4 = r3.send("decodeRasterArray", { buffer: t5, task: a4 }, n3, void 0, true);
            this._workQueue.push(() => {
              i4 && i4.cancel(), a4.cancel();
            });
          }, c3 = s3.getLayer(t4);
          if (!c3) return void o3(new Error(`Unknown sourceLayer "${t4}"`));
          if (c3.hasDataForBand(i3)) return this.updateTextureDescriptor(t4, i3), void o3(null, this.textureDescriptor ? this.textureDescriptor.img : null);
          const h3 = c3.getDataRange([i3]);
          if (a4 = s3.createDecodingTask(h3), !a4 || a4.tasks.length) if (this.flushQueues(), this.entireBuffer) l3(null, this.entireBuffer.slice(h3.firstByte, h3.lastByte + 1));
          else {
            const t5 = Object.assign({}, this.requestParams, { headers: { Range: `bytes=${h3.firstByte}-${h3.lastByte}` } }), i4 = e2.bd(t5, l3);
            this._fetchQueue.push(() => {
              i4.cancel(), a4.cancel();
            });
          }
          else o3(null);
        }
        updateNeeded(e3, t4) {
          return (!this.textureDescriptor || this.textureDescriptor.band !== t4 || this.textureDescriptor.layer !== e3) && "errored" !== this.state;
        }
        updateTextureDescriptor(t4, i3) {
          if (!this._mrt) return;
          const o3 = this._mrt.getLayer(t4);
          if (!o3 || !o3.hasBand(i3) || !o3.hasDataForBand(i3)) return;
          const { bytes: s3, tileSize: r3, buffer: a4, offset: n3, scale: l3 } = o3.getBandView(i3), c3 = r3 + 2 * a4, h3 = { data: s3, width: c3, height: c3 }, u4 = this.texture;
          u4 && u4 instanceof e2.T && u4.update(h3, { premultiply: false }), this.textureDescriptor = { layer: t4, band: i3, img: h3, buffer: a4, offset: n3, tileSize: r3, format: o3.pixelFormat, mix: [l3, 256 * l3, 65536 * l3, 16777216 * l3] };
        }
      }
      class ft {
        constructor(e3, t4) {
          this.max = e3, this.onRemove = t4, this.reset();
        }
        reset() {
          for (const e3 in this.data) for (const t4 of this.data[e3]) t4.timeout && clearTimeout(t4.timeout), this.onRemove(t4.value);
          return this.data = {}, this.order = [], this;
        }
        add(e3, t4, i3) {
          const o3 = e3.wrapped().key;
          void 0 === this.data[o3] && (this.data[o3] = []);
          const s3 = { value: t4, timeout: void 0 };
          if (void 0 !== i3 && (s3.timeout = setTimeout(() => {
            this.remove(e3, s3);
          }, i3)), this.data[o3].push(s3), this.order.push(o3), this.order.length > this.max) {
            const e4 = this._getAndRemoveByKey(this.order[0]);
            e4 && this.onRemove(e4);
          }
          return this;
        }
        has(e3) {
          return e3.wrapped().key in this.data;
        }
        getAndRemove(e3) {
          return this.has(e3) ? this._getAndRemoveByKey(e3.wrapped().key) : null;
        }
        _getAndRemoveByKey(e3) {
          const t4 = this.data[e3].shift();
          return t4.timeout && clearTimeout(t4.timeout), 0 === this.data[e3].length && delete this.data[e3], this.order.splice(this.order.indexOf(e3), 1), t4.value;
        }
        getByKey(e3) {
          const t4 = this.data[e3];
          return t4 ? t4[0].value : null;
        }
        get(e3) {
          return this.has(e3) ? this.data[e3.wrapped().key][0].value : null;
        }
        remove(e3, t4) {
          if (!this.has(e3)) return this;
          const i3 = e3.wrapped().key, o3 = void 0 === t4 ? 0 : this.data[i3].indexOf(t4), s3 = this.data[i3][o3];
          return this.data[i3].splice(o3, 1), s3.timeout && clearTimeout(s3.timeout), 0 === this.data[i3].length && delete this.data[i3], this.onRemove(s3.value), this.order.splice(this.order.indexOf(i3), 1), this;
        }
        setMaxSize(e3) {
          for (this.max = e3; this.order.length > this.max; ) {
            const e4 = this._getAndRemoveByKey(this.order[0]);
            e4 && this.onRemove(e4);
          }
          return this;
        }
        filter(e3) {
          const t4 = [];
          for (const i3 in this.data) for (const o3 of this.data[i3]) e3(o3.value) || t4.push(o3);
          for (const e4 of t4) this.remove(e4.value.tileID, e4);
        }
      }
      class mt {
        constructor() {
          this.state = {}, this.stateChanges = {}, this.deletedStates = {};
        }
        updateState(t4, i3, o3) {
          const s3 = String(i3);
          if (this.stateChanges[t4] = this.stateChanges[t4] || {}, this.stateChanges[t4][s3] = this.stateChanges[t4][s3] || {}, e2.m(this.stateChanges[t4][s3], o3), null === this.deletedStates[t4]) {
            this.deletedStates[t4] = {};
            for (const e3 in this.state[t4]) e3 !== s3 && (this.deletedStates[t4][e3] = null);
          } else if (this.deletedStates[t4] && null === this.deletedStates[t4][s3]) {
            this.deletedStates[t4][s3] = {};
            for (const e3 in this.state[t4][s3]) o3[e3] || (this.deletedStates[t4][s3][e3] = null);
          } else for (const e3 in o3) this.deletedStates[t4] && this.deletedStates[t4][s3] && null === this.deletedStates[t4][s3][e3] && delete this.deletedStates[t4][s3][e3];
        }
        removeFeatureState(e3, t4, i3) {
          if (null === this.deletedStates[e3]) return;
          const o3 = String(t4);
          if (this.deletedStates[e3] = this.deletedStates[e3] || {}, i3 && void 0 !== t4) null !== this.deletedStates[e3][o3] && (this.deletedStates[e3][o3] = this.deletedStates[e3][o3] || {}, this.deletedStates[e3][o3][i3] = null);
          else if (void 0 !== t4) if (this.stateChanges[e3] && this.stateChanges[e3][o3]) for (i3 in this.deletedStates[e3][o3] = {}, this.stateChanges[e3][o3]) this.deletedStates[e3][o3][i3] = null;
          else this.deletedStates[e3][o3] = null;
          else this.deletedStates[e3] = null;
        }
        getState(t4, i3) {
          const o3 = this.state[t4] || {}, s3 = this.stateChanges[t4] || {}, r3 = this.deletedStates[t4];
          if (null === r3) return {};
          if (void 0 !== i3) {
            const t5 = String(i3), a5 = e2.m({}, o3[t5], s3[t5]);
            if (r3) {
              const e3 = r3[i3];
              if (null === e3) return {};
              for (const t6 in e3) delete a5[t6];
            }
            return a5;
          }
          const a4 = e2.m({}, o3, s3);
          if (r3) for (const e3 in r3) delete a4[e3];
          return a4;
        }
        initializeTileState(e3, t4) {
          e3.refreshFeatureState(t4);
        }
        coalesceChanges(t4, i3) {
          const o3 = {};
          for (const t5 in this.stateChanges) {
            this.state[t5] = this.state[t5] || {};
            const i4 = {};
            for (const o4 in this.stateChanges[t5]) this.state[t5][o4] || (this.state[t5][o4] = {}), e2.m(this.state[t5][o4], this.stateChanges[t5][o4]), i4[o4] = this.state[t5][o4];
            o3[t5] = i4;
          }
          for (const t5 in this.deletedStates) {
            this.state[t5] = this.state[t5] || {};
            const i4 = {};
            if (null === this.deletedStates[t5]) for (const e3 in this.state[t5]) i4[e3] = {}, this.state[t5][e3] = {};
            else for (const e3 in this.deletedStates[t5]) {
              if (null === this.deletedStates[t5][e3]) this.state[t5][e3] = {};
              else if (this.state[t5][e3]) for (const i5 of Object.keys(this.deletedStates[t5][e3])) delete this.state[t5][e3][i5];
              i4[e3] = this.state[t5][e3];
            }
            o3[t5] = o3[t5] || {}, e2.m(o3[t5], i4);
          }
          if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(o3).length) for (const e3 in t4) t4[e3].refreshFeatureState(i3);
        }
      }
      class gt extends e2.E {
        constructor(e3, t4, i3) {
          super(), this.id = e3, this._onlySymbols = i3, t4.on("data", (e4) => {
            "source" === e4.dataType && "metadata" === e4.sourceDataType && (this._sourceLoaded = true), this._sourceLoaded && !this._paused && "source" === e4.dataType && "content" === e4.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
          }), t4.on("error", () => {
            this._sourceErrored = true;
          }), this._source = t4, this._tiles = {}, this._cache = new ft(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = t4.minTileCacheSize, this._maxTileCacheSize = t4.maxTileCacheSize, this._loadedParentTiles = {}, this.castsShadows = false, this.tileCoverLift = 0, this._coveredTiles = {}, this._shadowCasterTiles = {}, this._state = new mt(), this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "raster-array" === this._source.type || "custom" === this._source.type && "raster" === this._source._dataType;
        }
        onAdd(e3) {
          this.map = e3, this._minTileCacheSize = void 0 === this._minTileCacheSize && e3 ? e3._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && e3 ? e3._maxTileCacheSize : this._maxTileCacheSize;
        }
        loaded() {
          if (this._sourceErrored) return true;
          if (!this._sourceLoaded) return false;
          if (!this._source.loaded()) return false;
          for (const e3 in this._tiles) {
            const t4 = this._tiles[e3];
            if ("loaded" !== t4.state && "errored" !== t4.state) return false;
          }
          return true;
        }
        getSource() {
          return this._source;
        }
        pause() {
          this._paused = true;
        }
        resume() {
          if (!this._paused) return;
          const e3 = this._shouldReloadOnResume;
          this._paused = false, this._shouldReloadOnResume = false, e3 && this.reload(), this.transform && this.update(this.transform);
        }
        _loadTile(e3, t4) {
          return e3.isSymbolTile = this._onlySymbols, e3.isExtraShadowCaster = this._shadowCasterTiles[e3.tileID.key], this._source.loadTile(e3, t4);
        }
        _unloadTile(e3) {
          if (this._source.unloadTile) return this._source.unloadTile(e3);
        }
        _abortTile(e3) {
          if (this._source.abortTile) return this._source.abortTile(e3);
        }
        serialize() {
          return this._source.serialize();
        }
        prepare(e3) {
          this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
          for (const t4 in this._tiles) {
            const i3 = this._tiles[t4];
            i3.upload(e3), i3.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
          }
        }
        getIds() {
          return e2.be(this._tiles).map((e3) => e3.tileID).sort(vt).map((e3) => e3.key);
        }
        getRenderableIds(t4, i3) {
          const o3 = [];
          for (const e3 in this._tiles) this._isIdRenderable(+e3, t4, i3) && o3.push(this._tiles[e3]);
          return t4 ? o3.sort((t5, i4) => {
            const o4 = t5.tileID, s3 = i4.tileID, r3 = new e2.P(o4.canonical.x, o4.canonical.y)._rotate(this.transform.angle), a4 = new e2.P(s3.canonical.x, s3.canonical.y)._rotate(this.transform.angle);
            return o4.overscaledZ - s3.overscaledZ || a4.y - r3.y || a4.x - r3.x;
          }).map((e3) => e3.tileID.key) : o3.map((e3) => e3.tileID).sort(vt).map((e3) => e3.key);
        }
        hasRenderableParent(e3) {
          const t4 = this.findLoadedParent(e3, 0);
          return !!t4 && this._isIdRenderable(t4.tileID.key);
        }
        _isIdRenderable(e3, t4, i3) {
          return this._tiles[e3] && this._tiles[e3].hasData() && !this._coveredTiles[e3] && (t4 || !this._tiles[e3].holdingForFade()) && (i3 || !this._shadowCasterTiles[e3]);
        }
        reload() {
          if (this._paused) this._shouldReloadOnResume = true;
          else {
            this._cache.reset();
            for (const e3 in this._tiles) "errored" !== this._tiles[e3].state && this._reloadTile(+e3, "reloading");
          }
        }
        _reloadTile(e3, t4) {
          const i3 = this._tiles[e3];
          i3 && ("loading" !== i3.state && (i3.state = t4), this._loadTile(i3, this._tileLoaded.bind(this, i3, e3, t4)));
        }
        _tileLoaded(t4, i3, o3, s3) {
          if (s3) if (t4.state = "errored", 404 !== s3.status) this._source.fire(new e2.t(s3, { tile: t4 }));
          else {
            if (this._source.fire(new e2.x("data", { dataType: "source", sourceDataType: "error", sourceId: this._source.id, tile: t4 })), !(t4.tileID.key in this._loadedParentTiles)) return;
            if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
              const e3 = this.map.painter.terrain;
              this.update(this.transform, e3.getScaledDemTileSize(), true), e3.resetTileLookupCache(this.id);
            } else this.update(this.transform);
          }
          else t4.timeAdded = e2.e.now(), "expired" === o3 && (t4.refreshedUponExpiration = true), this._setTileReloadTimer(i3, t4), "raster-dem" === this._source.type && t4.dem && this._backfillDEM(t4), this._state.initializeTileState(t4, this.map ? this.map.painter : null), this._source.fire(new e2.x("data", { dataType: "source", tile: t4, coord: t4.tileID, sourceCacheId: this.id }));
        }
        _backfillDEM(e3) {
          const t4 = this.getRenderableIds();
          for (let o3 = 0; o3 < t4.length; o3++) {
            const s3 = t4[o3];
            if (e3.neighboringTiles && e3.neighboringTiles[s3]) {
              const t5 = this.getTileByID(s3);
              i3(e3, t5), i3(t5, e3);
            }
          }
          function i3(e4, t5) {
            if (!e4.dem || e4.dem.borderReady) return;
            e4.needsHillshadePrepare = true, e4.needsDEMTextureUpload = true;
            let i4 = t5.tileID.canonical.x - e4.tileID.canonical.x;
            const o3 = t5.tileID.canonical.y - e4.tileID.canonical.y, s3 = Math.pow(2, e4.tileID.canonical.z), r3 = t5.tileID.key;
            0 === i4 && 0 === o3 || Math.abs(o3) > 1 || (Math.abs(i4) > 1 && (1 === Math.abs(i4 + s3) ? i4 += s3 : 1 === Math.abs(i4 - s3) && (i4 -= s3)), t5.dem && e4.dem && (e4.dem.backfillBorder(t5.dem, i4, o3), e4.neighboringTiles && e4.neighboringTiles[r3] && (e4.neighboringTiles[r3].backfilled = true)));
          }
        }
        getTile(e3) {
          return this.getTileByID(e3.key);
        }
        getTileByID(e3) {
          return this._tiles[e3];
        }
        _retainLoadedChildren(e3, t4, i3, o3) {
          for (const s3 in this._tiles) {
            let r3 = this._tiles[s3];
            if (o3[s3] || !r3.hasData() || r3.tileID.overscaledZ <= t4 || r3.tileID.overscaledZ > i3) continue;
            let a4 = r3.tileID;
            for (; r3 && r3.tileID.overscaledZ > t4 + 1; ) {
              const e4 = r3.tileID.scaledTo(r3.tileID.overscaledZ - 1);
              r3 = this._tiles[e4.key], r3 && r3.hasData() && (a4 = e4);
            }
            let n3 = a4;
            for (; n3.overscaledZ > t4; ) if (n3 = n3.scaledTo(n3.overscaledZ - 1), e3[n3.key]) {
              o3[a4.key] = a4;
              break;
            }
          }
        }
        findLoadedParent(e3, t4) {
          if (e3.key in this._loadedParentTiles) {
            const i3 = this._loadedParentTiles[e3.key];
            return i3 && i3.tileID.overscaledZ >= t4 ? i3 : null;
          }
          for (let i3 = e3.overscaledZ - 1; i3 >= t4; i3--) {
            const t5 = e3.scaledTo(i3), o3 = this._getLoadedTile(t5);
            if (o3) return o3;
          }
        }
        _getLoadedTile(e3) {
          const t4 = this._tiles[e3.key];
          return t4 && t4.hasData() ? t4 : this._cache.getByKey(this._source.reparseOverscaled ? e3.wrapped().key : e3.canonical.key);
        }
        updateCacheSize(e3, t4) {
          t4 = t4 || this._source.tileSize;
          const i3 = Math.ceil(e3.width / t4) + 1, o3 = Math.ceil(e3.height / t4) + 1, s3 = Math.floor(i3 * o3 * 5), r3 = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, s3) : s3, a4 = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, r3) : r3;
          this._cache.setMaxSize(a4);
        }
        handleWrapJump(e3) {
          const t4 = Math.round((e3 - (void 0 === this._prevLng ? e3 : this._prevLng)) / 360);
          if (this._prevLng = e3, t4) {
            const e4 = {};
            for (const i3 in this._tiles) {
              const o3 = this._tiles[i3];
              o3.tileID = o3.tileID.unwrapTo(o3.tileID.wrap + t4), e4[o3.tileID.key] = o3;
            }
            this._tiles = e4;
            for (const e5 in this._timers) clearTimeout(this._timers[e5]), delete this._timers[e5];
            for (const e5 in this._tiles) this._setTileReloadTimer(+e5, this._tiles[e5]);
          }
        }
        update(t4, i3, o3, s3) {
          if (this.transform = t4, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
          if (this.usedForTerrain && !o3) return;
          this.updateCacheSize(t4, i3), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = {}, this._coveredTiles = {};
          const r3 = "batched-model" === this._source.type;
          let a4, n3 = this._source.maxzoom;
          const l3 = this.map && this.map.painter ? this.map.painter._terrain : null;
          if (l3 && l3.sourceCache === this && l3.attenuationRange()) {
            const e3 = l3.attenuationRange()[0], t5 = Math.floor(e3) - Math.log2(l3.getDemUpscale());
            n3 > t5 && (n3 = t5);
          }
          if (this.used || this.usedForTerrain) {
            if (this._source.tileID) a4 = t4.getVisibleUnwrappedCoordinates(this._source.tileID).map((t5) => new e2.aA(t5.canonical.z, t5.wrap, t5.canonical.z, t5.canonical.x, t5.canonical.y));
            else if (0 !== this.tileCoverLift) {
              const s4 = t4.clone();
              s4.tileCoverLift = this.tileCoverLift, a4 = s4.coveringTiles({ tileSize: i3 || this._source.tileSize, minzoom: this._source.minzoom, maxzoom: n3, roundZoom: this._source.roundZoom && !o3, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain, calculateQuadrantVisibility: r3 }), this._source.minzoom <= 1 && "globe" === t4.projection.name && (a4.push(new e2.aA(1, 0, 1, 0, 0)), a4.push(new e2.aA(1, 0, 1, 1, 0)), a4.push(new e2.aA(1, 0, 1, 0, 1)), a4.push(new e2.aA(1, 0, 1, 1, 1)));
            } else if (a4 = t4.coveringTiles({ tileSize: i3 || this._source.tileSize, minzoom: this._source.minzoom, maxzoom: n3, roundZoom: this._source.roundZoom && !o3, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain, calculateQuadrantVisibility: r3 }), this._source.hasTile) {
              const e3 = this._source.hasTile.bind(this._source);
              a4 = a4.filter((t5) => e3(t5));
            }
          } else a4 = [];
          if (a4.length > 0 && this.castsShadows && s3 && "globe" !== this.transform.projection.name && !this.usedForTerrain && !xt2(this._source.type)) {
            const e3 = t4.coveringZoomLevel({ tileSize: i3 || this._source.tileSize, roundZoom: this._source.roundZoom && !o3 }), n4 = Math.min(e3, this._source.maxzoom);
            if (r3) {
              const e4 = t4.extendTileCover(a4, n4);
              for (const t5 of e4) a4.push(t5);
            } else {
              const e4 = t4.extendTileCover(a4, n4, s3);
              for (const t5 of e4) this._shadowCasterTiles[t5.key] = true, a4.push(t5);
            }
          }
          const c3 = this._updateRetainedTiles(a4);
          if (xt2(this._source.type) && 0 !== a4.length) {
            const t5 = {}, i4 = {}, o4 = Object.keys(c3);
            for (const s5 of o4) {
              const o5 = c3[s5], r4 = this._tiles[s5];
              if (!r4 || r4.fadeEndTime && r4.fadeEndTime <= e2.e.now()) continue;
              const a5 = this.findLoadedParent(o5, Math.max(o5.overscaledZ - gt.maxOverzooming, this._source.minzoom));
              a5 && (this._addTile(a5.tileID), t5[a5.tileID.key] = a5.tileID), i4[s5] = o5;
            }
            const s4 = a4[a4.length - 1].overscaledZ;
            for (const e3 in this._tiles) {
              const t6 = this._tiles[e3];
              if (c3[e3] || !t6.hasData()) continue;
              let o5 = t6.tileID;
              for (; o5.overscaledZ > s4; ) {
                o5 = o5.scaledTo(o5.overscaledZ - 1);
                const s5 = this._tiles[o5.key];
                if (s5 && s5.hasData() && i4[o5.key]) {
                  c3[e3] = t6.tileID;
                  break;
                }
              }
            }
            for (const e3 in t5) c3[e3] || (this._coveredTiles[e3] = true, c3[e3] = t5[e3]);
          }
          for (const e3 in c3) this._tiles[e3].clearFadeHold();
          const h3 = e2.bf(this._tiles, c3);
          for (const e3 of h3) {
            const t5 = this._tiles[e3];
            t5.hasSymbolBuckets && !t5.holdingForFade() ? t5.setHoldDuration(this.map._fadeDuration) : t5.hasSymbolBuckets && !t5.symbolFadeFinished() || this._removeTile(+e3);
          }
          this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
        }
        releaseSymbolFadeTiles() {
          for (const e3 in this._tiles) this._tiles[e3].holdingForFade() && this._removeTile(+e3);
        }
        _updateRetainedTiles(e3) {
          const t4 = {};
          if (0 === e3.length) return t4;
          const i3 = {}, o3 = e3.reduce((e4, t5) => Math.min(e4, t5.overscaledZ), 1 / 0), s3 = e3[0].overscaledZ, r3 = Math.max(s3 - gt.maxOverzooming, this._source.minzoom), a4 = Math.max(s3 + gt.maxUnderzooming, this._source.minzoom), n3 = {};
          for (const i4 of e3) {
            const e4 = this._addTile(i4);
            t4[i4.key] = i4, e4.hasData() || o3 < this._source.maxzoom && (n3[i4.key] = i4);
          }
          this._retainLoadedChildren(n3, o3, a4, t4);
          for (const o4 of e3) {
            let e4 = this._tiles[o4.key];
            if (e4.hasData()) continue;
            if (o4.canonical.z >= this._source.maxzoom) {
              const e5 = o4.children(this._source.maxzoom)[0], i4 = this.getTile(e5);
              if (i4 && i4.hasData()) {
                t4[e5.key] = e5;
                continue;
              }
            } else {
              const e5 = o4.children(this._source.maxzoom);
              if (t4[e5[0].key] && t4[e5[1].key] && t4[e5[2].key] && t4[e5[3].key]) continue;
            }
            let s4 = e4.wasRequested();
            for (let a5 = o4.overscaledZ - 1; a5 >= r3; --a5) {
              const r4 = o4.scaledTo(a5);
              if (i3[r4.key]) break;
              if (i3[r4.key] = true, e4 = this.getTile(r4), !e4 && s4 && (e4 = this._addTile(r4)), e4 && (t4[r4.key] = r4, s4 = e4.wasRequested(), e4.hasData())) break;
            }
          }
          return t4;
        }
        _updateLoadedParentTileCache() {
          this._loadedParentTiles = {};
          for (const e3 in this._tiles) {
            const t4 = [];
            let i3, o3 = this._tiles[e3].tileID;
            for (; o3.overscaledZ > 0; ) {
              if (o3.key in this._loadedParentTiles) {
                i3 = this._loadedParentTiles[o3.key];
                break;
              }
              t4.push(o3.key);
              const e4 = o3.scaledTo(o3.overscaledZ - 1);
              if (i3 = this._getLoadedTile(e4), i3) break;
              o3 = e4;
            }
            for (const e4 of t4) this._loadedParentTiles[e4] = i3;
          }
        }
        _addTile(t4) {
          let i3 = this._tiles[t4.key];
          if (i3) return true !== i3.isExtraShadowCaster || !!this._shadowCasterTiles[t4.key] || this._reloadTile(t4.key, "reloading"), i3;
          i3 = this._cache.getAndRemove(t4), i3 && (this._setTileReloadTimer(t4.key, i3), i3.tileID = t4, this._state.initializeTileState(i3, this.map ? this.map.painter : null), this._cacheTimers[t4.key] && (clearTimeout(this._cacheTimers[t4.key]), delete this._cacheTimers[t4.key], this._setTileReloadTimer(t4.key, i3)));
          const o3 = Boolean(i3);
          if (!o3) {
            const e3 = this.map ? this.map.painter : null, o4 = this._source.tileSize * t4.overscaleFactor();
            i3 = "raster-array" === this._source.type ? new pt2(t4, o4, this.transform.tileZoom, e3, this._isRaster) : new _t(t4, o4, this.transform.tileZoom, e3, this._isRaster), this._loadTile(i3, this._tileLoaded.bind(this, i3, t4.key, i3.state));
          }
          return i3 ? (i3.uses++, this._tiles[t4.key] = i3, o3 || this._source.fire(new e2.x("dataloading", { tile: i3, coord: i3.tileID, dataType: "source" })), i3) : null;
        }
        _setTileReloadTimer(e3, t4) {
          e3 in this._timers && (clearTimeout(this._timers[e3]), delete this._timers[e3]);
          const i3 = t4.getExpiryTimeout();
          i3 && (this._timers[e3] = setTimeout(() => {
            this._reloadTile(e3, "expired"), delete this._timers[e3];
          }, i3));
        }
        _removeTile(e3) {
          const t4 = this._tiles[e3];
          t4 && (t4.uses--, delete this._tiles[e3], this._timers[e3] && (clearTimeout(this._timers[e3]), delete this._timers[e3]), t4.uses > 0 || (t4.hasData() && "reloading" !== t4.state || "empty" === t4.state ? this._cache.add(t4.tileID, t4, t4.getExpiryTimeout()) : (t4.aborted = true, this._abortTile(t4), this._unloadTile(t4))));
        }
        clearTiles() {
          this._shouldReloadOnResume = false, this._paused = false;
          for (const e3 in this._tiles) this._removeTile(+e3);
          this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
        }
        tilesIn(t4, i3, o3) {
          const s3 = [], r3 = this.transform;
          if (!r3) return s3;
          const a4 = "globe" === r3.projection.name, n3 = e2.am(r3.center.lng);
          for (const l3 in this._tiles) {
            const c3 = this._tiles[l3];
            if (o3 && c3.clearQueryDebugViz(), c3.holdingForFade()) continue;
            let h3;
            if (a4) {
              const t5 = c3.tileID.canonical;
              if (0 === t5.z) {
                const i4 = [Math.abs(e2.ap(n3, ...yt2(t5, -1)) - n3), Math.abs(e2.ap(n3, ...yt2(t5, 1)) - n3)];
                h3 = [0, 2 * i4.indexOf(Math.min(...i4)) - 1];
              } else {
                const i4 = [Math.abs(e2.ap(n3, ...yt2(t5, -1)) - n3), Math.abs(e2.ap(n3, ...yt2(t5, 0)) - n3), Math.abs(e2.ap(n3, ...yt2(t5, 1)) - n3)];
                h3 = [i4.indexOf(Math.min(...i4)) - 1];
              }
            } else h3 = [0];
            for (const e3 of h3) {
              const o4 = t4.containsTile(c3, r3, i3, e3);
              o4 && s3.push(o4);
            }
          }
          return s3;
        }
        getShadowCasterCoordinates() {
          return this._getRenderableCoordinates(false, true);
        }
        getVisibleCoordinates(e3) {
          return this._getRenderableCoordinates(e3);
        }
        _getRenderableCoordinates(e3, t4) {
          const i3 = this.getRenderableIds(e3, t4).map((e4) => this._tiles[e4].tileID), o3 = "globe" === this.transform.projection.name;
          for (const e4 of i3) e4.projMatrix = this.transform.calculateProjMatrix(e4.toUnwrapped()), e4.expandedProjMatrix = o3 ? this.transform.calculateProjMatrix(e4.toUnwrapped(), false, true) : e4.projMatrix;
          return i3;
        }
        sortCoordinatesByDistance(e3) {
          const t4 = e3.slice(), i3 = this.transform._camera.position, o3 = this.transform._camera.forward(), s3 = {};
          for (const e4 of t4) {
            const t5 = 1 / (1 << e4.canonical.z);
            s3[e4.key] = ((e4.canonical.x + 0.5) * t5 + e4.wrap - i3[0]) * o3[0] + ((e4.canonical.y + 0.5) * t5 - i3[1]) * o3[1] - i3[2] * o3[2];
          }
          return t4.sort((e4, t5) => s3[e4.key] - s3[t5.key]), t4;
        }
        hasTransition() {
          if (this._source.hasTransition()) return true;
          if (xt2(this._source.type)) for (const t4 in this._tiles) {
            const i3 = this._tiles[t4];
            if (void 0 !== i3.fadeEndTime && i3.fadeEndTime >= e2.e.now()) return true;
          }
          return false;
        }
        setFeatureState(e3, t4, i3) {
          this._state.updateState(e3 = e3 || "_geojsonTileLayer", t4, i3);
        }
        removeFeatureState(e3, t4, i3) {
          this._state.removeFeatureState(e3 = e3 || "_geojsonTileLayer", t4, i3);
        }
        getFeatureState(e3, t4) {
          return this._state.getState(e3 = e3 || "_geojsonTileLayer", t4);
        }
        setDependencies(e3, t4, i3) {
          const o3 = this._tiles[e3];
          o3 && o3.setDependencies(t4, i3);
        }
        reloadTilesForDependencies(e3, t4) {
          for (const i3 in this._tiles) this._tiles[i3].hasDependency(e3, t4) && this._reloadTile(+i3, "reloading");
          this._cache.filter((i3) => !i3.hasDependency(e3, t4));
        }
        _preloadTiles(t4, i3) {
          if (!this._sourceLoaded) {
            const e3 = () => {
              this._sourceLoaded && (this._source.off("data", e3), this._preloadTiles(t4, i3));
            };
            return void this._source.on("data", e3);
          }
          const o3 = /* @__PURE__ */ new Map(), s3 = Array.isArray(t4) ? t4 : [t4], r3 = this.map.painter.terrain, a4 = this.usedForTerrain && r3 ? r3.getScaledDemTileSize() : this._source.tileSize;
          for (const e3 of s3) {
            const t5 = e3.coveringTiles({ tileSize: a4, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: this._source.roundZoom && !this.usedForTerrain, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain });
            for (const e4 of t5) o3.set(e4.key, e4);
            this.usedForTerrain && e3.updateElevation(false);
          }
          const n3 = Array.from(o3.values());
          e2.bg(n3, (e3, t5) => {
            const i4 = new _t(e3, this._source.tileSize * e3.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster);
            this._loadTile(i4, (e4) => {
              "raster-dem" === this._source.type && i4.dem && this._backfillDEM(i4), t5(e4, i4);
            });
          }, i3);
        }
      }
      function vt(e3, t4) {
        const i3 = Math.abs(2 * e3.wrap) - +(e3.wrap < 0), o3 = Math.abs(2 * t4.wrap) - +(t4.wrap < 0);
        return e3.overscaledZ - t4.overscaledZ || o3 - i3 || t4.canonical.y - e3.canonical.y || t4.canonical.x - e3.canonical.x;
      }
      function xt2(e3) {
        return "raster" === e3 || "image" === e3 || "video" === e3 || "custom" === e3;
      }
      function yt2(e3, t4) {
        const i3 = 1 << e3.z;
        return [e3.x / i3 + t4, (e3.x + 1) / i3 + t4];
      }
      gt.maxOverzooming = 10, gt.maxUnderzooming = 3;
      class bt {
        constructor(e3) {
          this.style = e3, this.layersGotHidden = false, this.layers = [];
        }
        processLayersChanged() {
          this.layers = [];
          const e3 = false, t4 = false;
          for (const i3 in this.style._mergedLayers) {
            const o3 = this.style._mergedLayers[i3];
            if ("fill-extrusion" === o3.type) this.layers.push({ layer: o3, visible: e3, visibilityChanged: t4 });
            else if ("model" === o3.type) {
              const i4 = this.style.getLayerSource(o3);
              i4 && "batched-model" === i4.type && this.layers.push({ layer: o3, visible: e3, visibilityChanged: t4 });
            }
          }
        }
        onNewFrame(e3) {
          this.layersGotHidden = false;
          for (const t4 of this.layers) {
            const i3 = t4.layer;
            let o3 = false;
            "fill-extrusion" === i3.type ? o3 = !i3.isHidden(e3) && i3.paint.get("fill-extrusion-opacity") > 0 : "model" === i3.type && (o3 = !i3.isHidden(e3) && i3.paint.get("model-opacity") > 0), this.layersGotHidden = this.layersGotHidden || !o3 && t4.visible, t4.visible = o3;
          }
        }
        updateZOffset(e3, t4) {
          this.currentBuildingBuckets = [];
          for (const e4 of this.layers) {
            const i4 = e4.layer, o3 = this.style.getLayerSourceCache(i4);
            let s3 = 1;
            "fill-extrusion" === i4.type && (s3 = e4.visible ? i4.paint.get("fill-extrusion-vertical-scale") : 0);
            let r3 = o3 ? o3.getTile(t4) : null;
            if (!r3 && o3 && t4.canonical.z > o3.getSource().minzoom) {
              let e5 = t4.scaledTo(Math.min(o3.getSource().maxzoom, t4.overscaledZ - 1));
              for (; e5.overscaledZ >= o3.getSource().minzoom && (r3 = o3.getTile(e5), !r3 && 0 !== e5.overscaledZ); ) e5 = e5.scaledTo(e5.overscaledZ - 1);
            }
            this.currentBuildingBuckets.push({ bucket: r3 ? r3.getBucket(i4) : null, tileID: r3 ? r3.tileID : t4, verticalScale: s3 });
          }
          e3.hasAnyZOffset = false;
          let i3 = false;
          for (let o3 = 0; o3 < e3.symbolInstances.length; o3++) {
            const s3 = e3.symbolInstances.get(o3), r3 = s3.zOffset, a4 = this._getHeightAtTileOffset(t4, s3.tileAnchorX, s3.tileAnchorY);
            s3.zOffset = a4 !== Number.NEGATIVE_INFINITY ? a4 : r3, i3 || r3 === s3.zOffset || (i3 = true), e3.hasAnyZOffset || 0 === s3.zOffset || (e3.hasAnyZOffset = true);
          }
          i3 && (e3.zOffsetBuffersNeedUpload = true, e3.zOffsetSortDirty = true);
        }
        _mapCoordToOverlappingTile(t4, i3, o3, s3) {
          let r3 = i3, a4 = o3;
          if (t4.canonical.z !== s3.canonical.z) {
            const n3 = s3.canonical, l3 = 1 / (1 << t4.canonical.z - n3.z);
            r3 = (i3 + t4.canonical.x * e2.ab) * l3 - n3.x * e2.ab | 0, a4 = (o3 + t4.canonical.y * e2.ab) * l3 - n3.y * e2.ab | 0;
          }
          return { tileX: r3, tileY: a4 };
        }
        _getHeightAtTileOffset(e3, t4, i3) {
          let o3, s3;
          for (let r3 = 0; r3 < this.layers.length; ++r3) {
            if ("fill-extrusion" !== this.layers[r3].layer.type) continue;
            const { bucket: a4, tileID: n3, verticalScale: l3 } = this.currentBuildingBuckets[r3];
            if (!a4) continue;
            const { tileX: c3, tileY: h3 } = this._mapCoordToOverlappingTile(e3, t4, i3, n3), u4 = a4.getHeightAtTileCoord(c3, h3);
            u4 && void 0 !== u4.height && (u4.hidden ? o3 = u4.height : s3 = Math.max(u4.height * l3, s3 || 0));
          }
          if (void 0 !== s3) return s3;
          for (let s4 = 0; s4 < this.layers.length; ++s4) {
            const r3 = this.layers[s4];
            if ("model" !== r3.layer.type || !r3.visible) continue;
            const { bucket: a4, tileID: n3 } = this.currentBuildingBuckets[s4];
            if (!a4) continue;
            const { tileX: l3, tileY: c3 } = this._mapCoordToOverlappingTile(e3, t4, i3, n3), h3 = a4.getHeightAtTileCoord(l3, c3);
            if (h3 && !h3.hidden) return void 0 === h3.height && void 0 !== o3 ? Math.min(h3.maxHeight, o3) * h3.verticalScale : h3.height ? h3.height * h3.verticalScale : Number.NEGATIVE_INFINITY;
          }
          return this.layersGotHidden ? 0 : Number.NEGATIVE_INFINITY;
        }
      }
      function wt2(t4, i3) {
        const o3 = {};
        for (const e3 in t4) "ref" !== e3 && (o3[e3] = t4[e3]);
        return e2.bh.forEach((e3) => {
          e3 in i3 && (o3[e3] = i3[e3]);
        }), o3;
      }
      function Tt(e3) {
        e3 = e3.slice();
        const t4 = /* @__PURE__ */ Object.create(null);
        for (let i3 = 0; i3 < e3.length; i3++) t4[e3[i3].id] = e3[i3];
        for (let i3 = 0; i3 < e3.length; i3++) "ref" in e3[i3] && (e3[i3] = wt2(e3[i3], t4[e3[i3].ref]));
        return e3;
      }
      const Et = { setStyle: "setStyle", addLayer: "addLayer", removeLayer: "removeLayer", setPaintProperty: "setPaintProperty", setLayoutProperty: "setLayoutProperty", setSlot: "setSlot", setFilter: "setFilter", addSource: "addSource", removeSource: "removeSource", setGeoJSONSourceData: "setGeoJSONSourceData", setLayerZoomRange: "setLayerZoomRange", setLayerProperty: "setLayerProperty", setCenter: "setCenter", setZoom: "setZoom", setBearing: "setBearing", setPitch: "setPitch", setSprite: "setSprite", setGlyphs: "setGlyphs", setTransition: "setTransition", setLight: "setLight", setTerrain: "setTerrain", setFog: "setFog", setCamera: "setCamera", setLights: "setLights", setProjection: "setProjection", addImport: "addImport", removeImport: "removeImport", updateImport: "updateImport" };
      function St(e3, t4, i3) {
        i3.push({ command: Et.addSource, args: [e3, t4[e3]] });
      }
      function Ct2(e3, t4, i3) {
        t4.push({ command: Et.removeSource, args: [e3] }), i3[e3] = true;
      }
      function It(e3, t4, i3, o3) {
        Ct2(e3, i3, o3), St(e3, t4, i3);
      }
      function Dt(t4, i3, o3) {
        let s3;
        for (s3 in t4[o3]) if (t4[o3].hasOwnProperty(s3) && "data" !== s3 && !e2.bi(t4[o3][s3], i3[o3][s3])) return false;
        for (s3 in i3[o3]) if (i3[o3].hasOwnProperty(s3) && "data" !== s3 && !e2.bi(t4[o3][s3], i3[o3][s3])) return false;
        return true;
      }
      function Rt(t4, i3, o3, s3, r3, a4) {
        let n3;
        for (n3 in i3 = i3 || {}, t4 = t4 || {}) t4.hasOwnProperty(n3) && (e2.bi(t4[n3], i3[n3]) || o3.push({ command: a4, args: [s3, n3, i3[n3], r3] }));
        for (n3 in i3) i3.hasOwnProperty(n3) && !t4.hasOwnProperty(n3) && (e2.bi(t4[n3], i3[n3]) || o3.push({ command: a4, args: [s3, n3, i3[n3], r3] }));
      }
      function At(e3) {
        return e3.id;
      }
      function Lt(e3, t4) {
        return e3[t4.id] = t4, e3;
      }
      class Pt {
        constructor(e3, t4) {
          this.reset(e3, t4);
        }
        reset(e3, t4) {
          this.points = e3 || [], this._distances = [0];
          for (let e4 = 1; e4 < this.points.length; e4++) this._distances[e4] = this._distances[e4 - 1] + this.points[e4].dist(this.points[e4 - 1]);
          this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t4 || 0, 0.5 * this.length), this.paddedLength = this.length - 2 * this.padding;
        }
        lerp(t4) {
          if (1 === this.points.length) return this.points[0];
          t4 = e2.ap(t4, 0, 1);
          let i3 = 1, o3 = this._distances[i3];
          const s3 = t4 * this.paddedLength + this.padding;
          for (; o3 < s3 && i3 < this._distances.length; ) o3 = this._distances[++i3];
          const r3 = i3 - 1, a4 = this._distances[r3], n3 = o3 - a4, l3 = n3 > 0 ? (s3 - a4) / n3 : 0;
          return this.points[r3].mult(1 - l3).add(this.points[i3].mult(l3));
        }
      }
      class Mt {
        constructor(e3, t4, i3) {
          const o3 = this.boxCells = [], s3 = this.circleCells = [];
          this.xCellCount = Math.ceil(e3 / i3), this.yCellCount = Math.ceil(t4 / i3);
          for (let e4 = 0; e4 < this.xCellCount * this.yCellCount; e4++) o3.push([]), s3.push([]);
          this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e3, this.height = t4, this.xScale = this.xCellCount / e3, this.yScale = this.yCellCount / t4, this.boxUid = 0, this.circleUid = 0;
        }
        keysLength() {
          return this.boxKeys.length + this.circleKeys.length;
        }
        insert(e3, t4, i3, o3, s3) {
          this._forEachCell(t4, i3, o3, s3, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e3), this.bboxes.push(t4), this.bboxes.push(i3), this.bboxes.push(o3), this.bboxes.push(s3);
        }
        insertCircle(e3, t4, i3, o3) {
          this._forEachCell(t4 - o3, i3 - o3, t4 + o3, i3 + o3, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e3), this.circles.push(t4), this.circles.push(i3), this.circles.push(o3);
        }
        _insertBoxCell(e3, t4, i3, o3, s3, r3) {
          this.boxCells[s3].push(r3);
        }
        _insertCircleCell(e3, t4, i3, o3, s3, r3) {
          this.circleCells[s3].push(r3);
        }
        _query(e3, t4, i3, o3, s3, r3) {
          if (i3 < 0 || e3 > this.width || o3 < 0 || t4 > this.height) return !s3 && [];
          const a4 = [];
          if (e3 <= 0 && t4 <= 0 && this.width <= i3 && this.height <= o3) {
            if (s3) return true;
            for (let e4 = 0; e4 < this.boxKeys.length; e4++) a4.push({ key: this.boxKeys[e4], x1: this.bboxes[4 * e4], y1: this.bboxes[4 * e4 + 1], x2: this.bboxes[4 * e4 + 2], y2: this.bboxes[4 * e4 + 3] });
            for (let e4 = 0; e4 < this.circleKeys.length; e4++) {
              const t5 = this.circles[3 * e4], i4 = this.circles[3 * e4 + 1], o4 = this.circles[3 * e4 + 2];
              a4.push({ key: this.circleKeys[e4], x1: t5 - o4, y1: i4 - o4, x2: t5 + o4, y2: i4 + o4 });
            }
            return r3 ? a4.filter(r3) : a4;
          }
          return this._forEachCell(e3, t4, i3, o3, this._queryCell, a4, { hitTest: s3, seenUids: { box: {}, circle: {} } }, r3), s3 ? a4.length > 0 : a4;
        }
        _queryCircle(e3, t4, i3, o3, s3) {
          const r3 = e3 - i3, a4 = e3 + i3, n3 = t4 - i3, l3 = t4 + i3;
          if (a4 < 0 || r3 > this.width || l3 < 0 || n3 > this.height) return !o3 && [];
          const c3 = [];
          return this._forEachCell(r3, n3, a4, l3, this._queryCellCircle, c3, { hitTest: o3, circle: { x: e3, y: t4, radius: i3 }, seenUids: { box: {}, circle: {} } }, s3), o3 ? c3.length > 0 : c3;
        }
        query(e3, t4, i3, o3, s3) {
          return this._query(e3, t4, i3, o3, false, s3);
        }
        hitTest(e3, t4, i3, o3, s3) {
          return this._query(e3, t4, i3, o3, true, s3);
        }
        hitTestCircle(e3, t4, i3, o3) {
          return this._queryCircle(e3, t4, i3, true, o3);
        }
        _queryCell(e3, t4, i3, o3, s3, r3, a4, n3) {
          const l3 = a4.seenUids, c3 = this.boxCells[s3];
          if (null !== c3) {
            const s4 = this.bboxes;
            for (const h4 of c3) if (!l3.box[h4]) {
              l3.box[h4] = true;
              const c4 = 4 * h4;
              if (e3 <= s4[c4 + 2] && t4 <= s4[c4 + 3] && i3 >= s4[c4 + 0] && o3 >= s4[c4 + 1] && (!n3 || n3(this.boxKeys[h4]))) {
                if (a4.hitTest) return r3.push(true), true;
                r3.push({ key: this.boxKeys[h4], x1: s4[c4], y1: s4[c4 + 1], x2: s4[c4 + 2], y2: s4[c4 + 3] });
              }
            }
          }
          const h3 = this.circleCells[s3];
          if (null !== h3) {
            const s4 = this.circles;
            for (const c4 of h3) if (!l3.circle[c4]) {
              l3.circle[c4] = true;
              const h4 = 3 * c4;
              if (this._circleAndRectCollide(s4[h4], s4[h4 + 1], s4[h4 + 2], e3, t4, i3, o3) && (!n3 || n3(this.circleKeys[c4]))) {
                if (a4.hitTest) return r3.push(true), true;
                {
                  const e4 = s4[h4], t5 = s4[h4 + 1], i4 = s4[h4 + 2];
                  r3.push({ key: this.circleKeys[c4], x1: e4 - i4, y1: t5 - i4, x2: e4 + i4, y2: t5 + i4 });
                }
              }
            }
          }
        }
        _queryCellCircle(e3, t4, i3, o3, s3, r3, a4, n3) {
          const l3 = a4.circle, c3 = a4.seenUids, h3 = this.boxCells[s3];
          if (null !== h3) {
            const e4 = this.bboxes;
            for (const t5 of h3) if (!c3.box[t5]) {
              c3.box[t5] = true;
              const i4 = 4 * t5;
              if (this._circleAndRectCollide(l3.x, l3.y, l3.radius, e4[i4 + 0], e4[i4 + 1], e4[i4 + 2], e4[i4 + 3]) && (!n3 || n3(this.boxKeys[t5]))) return r3.push(true), true;
            }
          }
          const u4 = this.circleCells[s3];
          if (null !== u4) {
            const e4 = this.circles;
            for (const t5 of u4) if (!c3.circle[t5]) {
              c3.circle[t5] = true;
              const i4 = 3 * t5;
              if (this._circlesCollide(e4[i4], e4[i4 + 1], e4[i4 + 2], l3.x, l3.y, l3.radius) && (!n3 || n3(this.circleKeys[t5]))) return r3.push(true), true;
            }
          }
        }
        _forEachCell(e3, t4, i3, o3, s3, r3, a4, n3) {
          const l3 = this._convertToXCellCoord(e3), c3 = this._convertToYCellCoord(t4), h3 = this._convertToXCellCoord(i3), u4 = this._convertToYCellCoord(o3);
          for (let d3 = l3; d3 <= h3; d3++) for (let l4 = c3; l4 <= u4; l4++) if (s3.call(this, e3, t4, i3, o3, this.xCellCount * l4 + d3, r3, a4, n3)) return;
        }
        _convertToXCellCoord(e3) {
          return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e3 * this.xScale)));
        }
        _convertToYCellCoord(e3) {
          return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e3 * this.yScale)));
        }
        _circlesCollide(e3, t4, i3, o3, s3, r3) {
          const a4 = o3 - e3, n3 = s3 - t4, l3 = i3 + r3;
          return l3 * l3 > a4 * a4 + n3 * n3;
        }
        _circleAndRectCollide(e3, t4, i3, o3, s3, r3, a4) {
          const n3 = (r3 - o3) / 2, l3 = Math.abs(e3 - (o3 + n3));
          if (l3 > n3 + i3) return false;
          const c3 = (a4 - s3) / 2, h3 = Math.abs(t4 - (s3 + c3));
          if (h3 > c3 + i3) return false;
          if (l3 <= n3 || h3 <= c3) return true;
          const u4 = l3 - n3, d3 = h3 - c3;
          return u4 * u4 + d3 * d3 <= i3 * i3;
        }
      }
      const zt = { unknown: 0, flipRequired: 1, flipNotRequired: 2 }, Ot = Math.tan(85 * Math.PI / 180);
      function Ft2(t4, i3, o3, s3, r3, a4, n3) {
        const l3 = e2.a6.mat4.create();
        if (o3) if ("globe" === a4.name) {
          const t5 = e2.bj(r3, i3);
          e2.a6.mat4.multiply(l3, l3, t5);
        } else {
          const t5 = e2.a6.mat2.invert([], n3);
          l3[0] = t5[0], l3[1] = t5[1], l3[4] = t5[2], l3[5] = t5[3], s3 || e2.a6.mat4.rotateZ(l3, l3, r3.angle);
        }
        else e2.a6.mat4.multiply(l3, r3.labelPlaneMatrix, t4);
        return l3;
      }
      function Bt(e3, t4, i3, o3, s3, r3, a4) {
        const n3 = Ft2(e3, t4, i3, o3, s3, r3, a4);
        return "globe" === r3.name && i3 || (n3[2] = n3[6] = n3[10] = n3[14] = 0), n3;
      }
      function kt(t4, i3, o3, s3, r3, a4, n3) {
        if (o3) {
          if ("globe" === a4.name) {
            const l3 = Ft2(t4, i3, o3, s3, r3, a4, n3);
            return e2.a6.mat4.invert(l3, l3), e2.a6.mat4.multiply(l3, t4, l3), l3;
          }
          {
            const i4 = e2.a6.mat4.clone(t4), o4 = e2.a6.mat4.identity([]);
            return o4[0] = n3[0], o4[1] = n3[1], o4[4] = n3[2], o4[5] = n3[3], e2.a6.mat4.multiply(i4, i4, o4), s3 || e2.a6.mat4.rotateZ(i4, i4, -r3.angle), i4;
          }
        }
        return r3.glCoordMatrix;
      }
      function Nt(t4, i3, o3, s3) {
        const r3 = [t4, i3, o3, 1];
        o3 ? e2.a6.vec4.transformMat4(r3, r3, s3) : Jt(r3, r3, s3);
        const a4 = r3[3];
        return r3[0] /= a4, r3[1] /= a4, r3[2] /= a4, r3;
      }
      function Ut(e3, t4) {
        return Math.min(0.5 + e3 / t4 * 0.5, 1.5);
      }
      function Gt(e3, t4) {
        const i3 = e3[0] / e3[3], o3 = e3[1] / e3[3];
        return i3 >= -t4[0] && i3 <= t4[0] && o3 >= -t4[1] && o3 <= t4[1];
      }
      function Vt(t4, i3, o3, s3, r3, a4, n3, l3, c3, h3) {
        const u4 = o3.transform, d3 = s3 ? t4.textSizeData : t4.iconSizeData, _2 = e2.bk(d3, o3.transform.zoom), p3 = "globe" === u4.projection.name, f3 = [256 / o3.width * 2 + 1, 256 / o3.height * 2 + 1], m2 = s3 ? t4.text.dynamicLayoutVertexArray : t4.icon.dynamicLayoutVertexArray;
        m2.clear();
        let g4 = null;
        p3 && (g4 = s3 ? t4.text.globeExtVertexArray : t4.icon.globeExtVertexArray);
        const v2 = t4.lineVertexArray, x2 = s3 ? t4.text.placedSymbolArray : t4.icon.placedSymbolArray, y2 = o3.transform.width / o3.transform.height;
        let b2, w2 = false;
        for (let s4 = 0; s4 < x2.length; s4++) {
          const p4 = x2.get(s4), { numGlyphs: T3, writingMode: E3 } = p4;
          if (E3 !== e2.bl.vertical || w2 || b2 === e2.bl.horizontal || (w2 = true), b2 = E3, (p4.hidden || E3 === e2.bl.vertical) && !w2) {
            Xt(T3, m2);
            continue;
          }
          w2 = false;
          const S2 = new e2.P(p4.tileAnchorX, p4.tileAnchorY);
          let { x: C3, y: I3, z: D2 } = u4.projection.projectTilePoint(S2.x, S2.y, h3.canonical);
          if (c3) {
            const [e3, t5, i4] = c3(S2);
            C3 += e3, I3 += t5, D2 += i4;
          }
          const R3 = [C3, I3, D2, 1];
          if (e2.a6.vec4.transformMat4(R3, R3, i3), !Gt(R3, f3)) {
            Xt(T3, m2);
            continue;
          }
          const A3 = R3[3], L3 = Ut(o3.transform.getCameraToCenterDistance(u4.projection), A3), P2 = e2.bm(d3, _2, p4), M2 = n3 ? P2 / L3 : P2 * L3, z3 = Nt(C3, I3, D2, r3);
          if (z3[3] <= 0) {
            Xt(T3, m2);
            continue;
          }
          let O2 = {};
          const F3 = n3 ? null : c3, B4 = Zt(p4, M2, false, l3, i3, r3, a4, t4.glyphOffsetArray, v2, m2, g4, z3, S2, O2, y2, F3, u4.projection, h3, n3);
          w2 = B4.useVertical, F3 && B4.needsFlipping && (O2 = {}), (B4.notEnoughRoom || w2 || B4.needsFlipping && Zt(p4, M2, true, l3, i3, r3, a4, t4.glyphOffsetArray, v2, m2, g4, z3, S2, O2, y2, F3, u4.projection, h3, n3).notEnoughRoom) && Xt(T3, m2);
        }
        s3 ? (t4.text.dynamicLayoutVertexBuffer.updateData(m2), g4 && t4.text.globeExtVertexBuffer && t4.text.globeExtVertexBuffer.updateData(g4)) : (t4.icon.dynamicLayoutVertexBuffer.updateData(m2), g4 && t4.icon.globeExtVertexBuffer && t4.icon.globeExtVertexBuffer.updateData(g4));
      }
      function jt(e3, t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4, d3, _2, p3, f3) {
        const { lineStartIndex: m2, glyphStartIndex: g4, segment: v2 } = n3, x2 = g4 + n3.numGlyphs, y2 = m2 + n3.lineLength, b2 = t4.getoffsetX(g4), w2 = t4.getoffsetX(x2 - 1), T3 = $t(e3 * b2, i3, o3, s3, r3, a4, v2, m2, y2, l3, c3, h3, u4, d3, true, _2, p3, f3);
        if (!T3) return null;
        const E3 = $t(e3 * w2, i3, o3, s3, r3, a4, v2, m2, y2, l3, c3, h3, u4, d3, true, _2, p3, f3);
        return E3 ? { first: T3, last: E3 } : null;
      }
      function Ht(t4, i3, o3, s3) {
        return t4 === e2.bl.horizontal && Math.abs(s3) > Math.abs(o3) ? { useVertical: true } : t4 === e2.bl.vertical ? s3 > 0 ? { needsFlipping: true } : null : i3 !== zt.unknown && function(e3, t5) {
          return 0 === e3 || Math.abs(t5 / e3) > Ot;
        }(o3, s3) ? i3 === zt.flipRequired ? { needsFlipping: true } : null : o3 < 0 ? { needsFlipping: true } : null;
      }
      function Zt(t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4, d3, _2, p3, f3, m2, g4, v2, x2) {
        const y2 = i3 / 24, b2 = t4.lineOffsetX * y2, w2 = t4.lineOffsetY * y2, { lineStartIndex: T3, glyphStartIndex: E3, numGlyphs: S2, segment: C3, writingMode: I3, flipState: D2 } = t4, R3 = T3 + t4.lineLength, A3 = (t5) => {
          if (u4) {
            const [i5, o5, s5] = t5.up, r4 = h3.length;
            e2.bn(u4, r4 + 0, i5, o5, s5), e2.bn(u4, r4 + 1, i5, o5, s5), e2.bn(u4, r4 + 2, i5, o5, s5), e2.bn(u4, r4 + 3, i5, o5, s5);
          }
          const [i4, o4, s4] = t5.point;
          e2.bo(h3, i4, o4, s4, t5.angle);
        };
        if (S2 > 1) {
          const e3 = jt(y2, l3, b2, w2, o3, d3, _2, t4, c3, a4, p3, m2, false, g4, v2, x2);
          if (!e3) return { notEnoughRoom: true };
          if (s3 && !o3) {
            let [i4, o4, s4] = e3.first.point, [r4, a5, l4] = e3.last.point;
            [i4, o4] = Nt(i4, o4, s4, n3), [r4, a5] = Nt(r4, a5, l4, n3);
            const c4 = Ht(I3, D2, (r4 - i4) * f3, a5 - o4);
            if (t4.flipState = c4 && c4.needsFlipping ? zt.flipRequired : zt.flipNotRequired, c4) return c4;
          }
          A3(e3.first);
          for (let e4 = E3 + 1; e4 < E3 + S2 - 1; e4++) {
            const t5 = $t(y2 * l3.getoffsetX(e4), b2, w2, o3, d3, _2, C3, T3, R3, c3, a4, p3, m2, false, false, g4, v2, x2);
            if (!t5) return h3.length -= 4 * (e4 - E3), { notEnoughRoom: true };
            A3(t5);
          }
          A3(e3.last);
        } else {
          if (s3 && !o3) {
            const i5 = Nt(_2.x, _2.y, 0, r3), o4 = T3 + C3 + 1, s4 = new e2.P(c3.getx(o4), c3.gety(o4)), a5 = Nt(s4.x, s4.y, 0, r3), n4 = a5[3] > 0 ? a5 : Wt(_2, s4, i5, 1, r3, void 0, g4, v2.canonical), l4 = Ht(I3, D2, (n4[0] - i5[0]) * f3, n4[1] - i5[1]);
            if (t4.flipState = l4 && l4.needsFlipping ? zt.flipRequired : zt.flipNotRequired, l4) return l4;
          }
          const i4 = $t(y2 * l3.getoffsetX(E3), b2, w2, o3, d3, _2, C3, T3, R3, c3, a4, p3, m2, false, false, g4, v2, x2);
          if (!i4) return { notEnoughRoom: true };
          A3(i4);
        }
        return {};
      }
      function qt(e3, t4, i3, o3, s3) {
        const { x: r3, y: a4, z: n3 } = o3.projectTilePoint(e3.x, e3.y, t4);
        if (!s3) return Nt(r3, a4, n3, i3);
        const [l3, c3, h3] = s3(e3);
        return Nt(r3 + l3, a4 + c3, n3 + h3, i3);
      }
      function Wt(t4, i3, o3, s3, r3, a4, n3, l3) {
        const c3 = qt(t4.sub(i3)._unit()._add(t4), l3, r3, n3, a4);
        return e2.a6.vec3.sub(c3, o3, c3), e2.a6.vec3.normalize(c3, c3), e2.a6.vec3.scaleAndAdd(c3, o3, c3, s3);
      }
      function $t(t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4, d3, _2, p3, f3, m2, g4, v2) {
        const x2 = s3 ? t4 - i3 : t4 + i3;
        let y2 = x2 > 0 ? 1 : -1, b2 = 0;
        s3 && (y2 *= -1, b2 = Math.PI), y2 < 0 && (b2 += Math.PI);
        let w2 = l3 + n3 + (y2 > 0 ? 0 : 1) | 0, T3 = r3, E3 = r3, S2 = 0, C3 = 0;
        const I3 = Math.abs(x2), D2 = [], R3 = [];
        let A3 = a4, L3 = A3;
        const P2 = () => Wt(L3, A3, E3, I3 - S2 + 1, u4, _2, m2, g4.canonical);
        for (; S2 + C3 <= I3; ) {
          if (w2 += y2, w2 < l3 || w2 >= c3) return null;
          if (E3 = T3, L3 = A3, D2.push(E3), p3 && R3.push(L3), A3 = new e2.P(h3.getx(w2), h3.gety(w2)), T3 = d3[w2], !T3) {
            const e3 = qt(A3, g4.canonical, u4, m2, _2);
            T3 = e3[3] > 0 ? d3[w2] = e3 : P2();
          }
          S2 += C3, C3 = e2.a6.vec3.distance(E3, T3);
        }
        f3 && _2 && (d3[w2] && (T3 = P2(), C3 = e2.a6.vec3.distance(E3, T3)), d3[w2] = T3);
        const M2 = (I3 - S2) / C3, z3 = A3.sub(L3)._mult(M2)._add(L3), O2 = e2.a6.vec3.sub([], T3, E3), F3 = e2.a6.vec3.scaleAndAdd([], E3, O2, M2);
        let B4 = [0, 0, 1], k2 = O2[0], N2 = O2[1];
        if (v2 && (B4 = m2.upVector(g4.canonical, z3.x, z3.y), 0 !== B4[0] || 0 !== B4[1] || 1 !== B4[2])) {
          const t5 = [B4[2], 0, -B4[0]], i4 = e2.a6.vec3.cross([], B4, t5);
          e2.a6.vec3.normalize(t5, t5), e2.a6.vec3.normalize(i4, i4), k2 = e2.a6.vec3.dot(O2, t5), N2 = e2.a6.vec3.dot(O2, i4);
        }
        if (o3) {
          const t5 = e2.a6.vec3.cross([], B4, O2);
          e2.a6.vec3.normalize(t5, t5), e2.a6.vec3.scaleAndAdd(F3, F3, t5, o3 * y2);
        }
        const U3 = b2 + Math.atan2(N2, k2);
        return D2.push(F3), p3 && R3.push(z3), { point: F3, angle: U3, path: D2, tilePath: R3, up: B4 };
      }
      function Xt(e3, t4) {
        const i3 = t4.length, o3 = i3 + 4 * e3;
        t4.resize(o3), t4.float32.fill(-1 / 0, 4 * i3, 4 * o3);
      }
      function Jt(e3, t4, i3) {
        const o3 = t4[0], s3 = t4[1];
        return e3[0] = i3[0] * o3 + i3[4] * s3 + i3[12], e3[1] = i3[1] * o3 + i3[5] * s3 + i3[13], e3[3] = i3[3] * o3 + i3[7] * s3 + i3[15], e3;
      }
      const Kt = 100;
      class Yt {
        constructor(e3, t4, i3 = new Mt(e3.width + 200, e3.height + 200, 25), o3 = new Mt(e3.width + 200, e3.height + 200, 25)) {
          this.transform = e3, this.grid = i3, this.ignoredGrid = o3, this.pitchfactor = Math.cos(e3._pitch) * e3.cameraToCenterDistance, this.screenRightBoundary = e3.width + Kt, this.screenBottomBoundary = e3.height + Kt, this.gridRightBoundary = e3.width + 200, this.gridBottomBoundary = e3.height + 200, this.fogState = t4;
        }
        placeCollisionBox(e3, t4, i3, o3, s3, r3, a4, n3) {
          let l3 = i3.projectedAnchorX, c3 = i3.projectedAnchorY, h3 = i3.projectedAnchorZ;
          const u4 = i3.elevation, d3 = i3.tileID, _2 = e3.getProjection();
          if (u4 && d3) {
            const [e4, t5, o4] = _2.upVector(d3.canonical, i3.tileAnchorX, i3.tileAnchorY), s4 = _2.upVectorScale(d3.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
            l3 += e4 * u4 * s4, c3 += t5 * u4 * s4, h3 += o4 * u4 * s4;
          }
          const p3 = this.projectAndGetPerspectiveRatio(a4, l3, c3, h3, i3.tileID, "globe" === _2.name || !!u4 || this.transform.pitch > 0, _2), f3 = r3 * p3.perspectiveRatio, m2 = (i3.x1 * t4 + o3.x - i3.padding) * f3 + p3.point.x, g4 = (i3.y1 * t4 + o3.y - i3.padding) * f3 + p3.point.y, v2 = (i3.x2 * t4 + o3.x + i3.padding) * f3 + p3.point.x, x2 = (i3.y2 * t4 + o3.y + i3.padding) * f3 + p3.point.y, y2 = p3.perspectiveRatio <= 0.55 || p3.occluded;
          return !this.isInsideGrid(m2, g4, v2, x2) || !s3 && this.grid.hitTest(m2, g4, v2, x2, n3) || y2 ? { box: [], offscreen: false, occluded: p3.occluded } : { box: [m2, g4, v2, x2], offscreen: this.isOffscreen(m2, g4, v2, x2), occluded: false };
        }
        placeCollisionCircles(t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4, d3, _2, p3, f3) {
          const m2 = [], g4 = this.transform.elevation, v2 = t4.getProjection(), x2 = g4 ? g4.getAtTileOffsetFunc(f3, this.transform.center.lat, this.transform.worldSize, v2) : null, y2 = new e2.P(o3.tileAnchorX, o3.tileAnchorY);
          let { x: b2, y: w2, z: T3 } = v2.projectTilePoint(y2.x, y2.y, f3.canonical);
          if (x2) {
            const [e3, t5, i4] = x2(y2);
            b2 += e3, w2 += t5, T3 += i4;
          }
          const E3 = "globe" === v2.name, S2 = this.projectAndGetPerspectiveRatio(n3, b2, w2, T3, f3, E3 || !!g4 || this.transform.pitch > 0, v2), { perspectiveRatio: C3 } = S2, I3 = (u4 ? a4 / C3 : a4 * C3) / e2.br, D2 = Nt(b2, w2, T3, l3), R3 = S2.signedDistanceFromCamera > 0 ? jt(I3, r3, o3.lineOffsetX * I3, o3.lineOffsetY * I3, false, D2, y2, o3, s3, l3, {}, g4 && !u4 ? x2 : null, u4 && !!g4, v2, f3, u4) : null;
          let A3 = false, L3 = false, P2 = true;
          if (R3 && !S2.occluded) {
            const t5 = 0.5 * _2 * C3 + p3, o4 = new e2.P(-100, -100), s4 = new e2.P(this.screenRightBoundary, this.screenBottomBoundary), r4 = new Pt(), { first: a5, last: n4 } = R3, l4 = a5.path.length;
            let u5 = [];
            for (let e3 = l4 - 1; e3 >= 1; e3--) u5.push(a5.path[e3]);
            for (let e3 = 1; e3 < n4.path.length; e3++) u5.push(n4.path[e3]);
            const f4 = 2.5 * t5;
            c3 && (u5 = u5.map(([e3, t6, i4], o5) => (x2 && !E3 && (i4 = x2(o5 < l4 - 1 ? a5.tilePath[l4 - 1 - o5] : n4.tilePath[o5 - l4 + 2])[2]), Nt(e3, t6, i4, c3))), u5.some((e3) => e3[3] <= 0) && (u5 = []));
            let g5 = [];
            if (u5.length > 0) {
              let t6 = 1 / 0, i4 = -1 / 0, r5 = 1 / 0, a6 = -1 / 0;
              for (const e3 of u5) t6 = Math.min(t6, e3[0]), r5 = Math.min(r5, e3[1]), i4 = Math.max(i4, e3[0]), a6 = Math.max(a6, e3[1]);
              i4 >= o4.x && t6 <= s4.x && a6 >= o4.y && r5 <= s4.y && (g5 = [u5.map((t7) => new e2.P(t7[0], t7[1]))], (t6 < o4.x || i4 > s4.x || r5 < o4.y || a6 > s4.y) && (g5 = e2.bp(g5, o4.x, o4.y, s4.x, s4.y)));
            }
            for (const e3 of g5) {
              r4.reset(e3, 0.25 * t5);
              let o5 = 0;
              o5 = r4.length <= 0.5 * t5 ? 1 : Math.ceil(r4.paddedLength / f4) + 1;
              for (let e4 = 0; e4 < o5; e4++) {
                const s5 = e4 / Math.max(o5 - 1, 1), a6 = r4.lerp(s5), n5 = a6.x + Kt, l5 = a6.y + Kt;
                m2.push(n5, l5, t5, 0);
                const c4 = n5 - t5, u6 = l5 - t5, _3 = n5 + t5, p4 = l5 + t5;
                if (P2 = P2 && this.isOffscreen(c4, u6, _3, p4), L3 = L3 || this.isInsideGrid(c4, u6, _3, p4), !i3 && this.grid.hitTestCircle(n5, l5, t5, d3) && (A3 = true, !h3)) return { circles: [], offscreen: false, collisionDetected: A3, occluded: false };
              }
            }
          }
          return { circles: !h3 && A3 || !L3 ? [] : m2, offscreen: P2, collisionDetected: A3, occluded: S2.occluded };
        }
        queryRenderedSymbols(t4) {
          if (0 === t4.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
          const i3 = [];
          let o3 = 1 / 0, s3 = 1 / 0, r3 = -1 / 0, a4 = -1 / 0;
          for (const n4 of t4) {
            const t5 = new e2.P(n4.x + Kt, n4.y + Kt);
            o3 = Math.min(o3, t5.x), s3 = Math.min(s3, t5.y), r3 = Math.max(r3, t5.x), a4 = Math.max(a4, t5.y), i3.push(t5);
          }
          const n3 = this.grid.query(o3, s3, r3, a4).concat(this.ignoredGrid.query(o3, s3, r3, a4)), l3 = {}, c3 = {};
          for (const t5 of n3) {
            const o4 = t5.key;
            if (void 0 === l3[o4.bucketInstanceId] && (l3[o4.bucketInstanceId] = {}), l3[o4.bucketInstanceId][o4.featureIndex]) continue;
            const s4 = [new e2.P(t5.x1, t5.y1), new e2.P(t5.x2, t5.y1), new e2.P(t5.x2, t5.y2), new e2.P(t5.x1, t5.y2)];
            e2.bq(i3, s4) && (l3[o4.bucketInstanceId][o4.featureIndex] = true, void 0 === c3[o4.bucketInstanceId] && (c3[o4.bucketInstanceId] = []), c3[o4.bucketInstanceId].push(o4.featureIndex));
          }
          return c3;
        }
        insertCollisionBox(e3, t4, i3, o3, s3) {
          (t4 ? this.ignoredGrid : this.grid).insert({ bucketInstanceId: i3, featureIndex: o3, collisionGroupID: s3 }, e3[0], e3[1], e3[2], e3[3]);
        }
        insertCollisionCircles(e3, t4, i3, o3, s3) {
          const r3 = t4 ? this.ignoredGrid : this.grid, a4 = { bucketInstanceId: i3, featureIndex: o3, collisionGroupID: s3 };
          for (let t5 = 0; t5 < e3.length; t5 += 4) r3.insertCircle(a4, e3[t5], e3[t5 + 1], e3[t5 + 2]);
        }
        projectAndGetPerspectiveRatio(t4, i3, o3, s3, r3, a4, n3) {
          const l3 = [i3, o3, s3, 1];
          let c3 = false;
          if (s3 || this.transform.pitch > 0) {
            if (e2.a6.vec4.transformMat4(l3, l3, t4), this.fogState && r3 && "globe" !== n3.name) {
              const t5 = function(t6, i4, o4, s4, r4, a5) {
                const n4 = a5.calculateFogTileMatrix(r4), l4 = [i4, o4, s4];
                return e2.a6.vec3.transformMat4(l4, l4, n4), Oe(t6, e2.a6.vec3.length(l4), a5.pitch, a5._fov);
              }(this.fogState, i3, o3, s3, r3.toUnwrapped(), this.transform);
              c3 = t5 > 0.9;
            }
          } else Jt(l3, l3, t4);
          const h3 = l3[3];
          return { point: new e2.P((l3[0] / h3 + 1) / 2 * this.transform.width + Kt, (-l3[1] / h3 + 1) / 2 * this.transform.height + Kt), perspectiveRatio: Math.min(0.5 + this.transform.getCameraToCenterDistance(n3) / h3 * 0.5, 1.5), signedDistanceFromCamera: h3, occluded: a4 && l3[2] > h3 || c3 };
        }
        isOffscreen(e3, t4, i3, o3) {
          return i3 < Kt || e3 >= this.screenRightBoundary || o3 < Kt || t4 > this.screenBottomBoundary;
        }
        isInsideGrid(e3, t4, i3, o3) {
          return i3 >= 0 && e3 < this.gridRightBoundary && o3 >= 0 && t4 < this.gridBottomBoundary;
        }
        getViewportMatrix() {
          const t4 = e2.a6.mat4.identity([]);
          return e2.a6.mat4.translate(t4, t4, [-100, -100, 0]), t4;
        }
      }
      function Qt(t4, i3, o3) {
        const s3 = i3.createTileMatrix(t4, t4.worldSize, o3.toUnwrapped());
        return e2.a6.mat4.multiply(new Float32Array(16), t4.projMatrix, s3);
      }
      function ei(e3, t4, i3) {
        if (t4.projection.name === i3.projection.name) return e3.projMatrix;
        const o3 = i3.clone();
        return o3.setProjection(t4.projection), Qt(o3, t4.getProjection(), e3);
      }
      function ti2(e3, t4, i3) {
        return t4.name === i3.projection.name ? e3.projMatrix : Qt(i3, t4, e3);
      }
      class ii {
        constructor(e3, t4, i3, o3) {
          this.opacity = e3 ? Math.max(0, Math.min(1, e3.opacity + (e3.placed ? t4 : -t4))) : o3 && i3 ? 1 : 0, this.placed = i3;
        }
        isHidden() {
          return 0 === this.opacity && !this.placed;
        }
      }
      class oi {
        constructor(e3, t4, i3, o3, s3, r3 = false) {
          this.text = new ii(e3 ? e3.text : null, t4, i3, s3), this.icon = new ii(e3 ? e3.icon : null, t4, o3, s3), this.clipped = r3;
        }
        isHidden() {
          return this.text.isHidden() && this.icon.isHidden();
        }
      }
      class si {
        constructor(e3, t4, i3, o3 = false) {
          this.text = e3, this.icon = t4, this.skipFade = i3, this.clipped = o3;
        }
      }
      class ri {
        constructor() {
          this.invProjMatrix = e2.a6.mat4.create(), this.viewportMatrix = e2.a6.mat4.create(), this.circles = [];
        }
      }
      class ai {
        constructor(e3, t4, i3, o3, s3) {
          this.bucketInstanceId = e3, this.featureIndex = t4, this.sourceLayerIndex = i3, this.bucketIndex = o3, this.tileID = s3;
        }
      }
      class ni {
        constructor(e3) {
          this.crossSourceCollisions = e3, this.maxGroupID = 0, this.collisionGroups = {};
        }
        get(e3) {
          if (this.crossSourceCollisions) return { ID: 0, predicate: null };
          if (!this.collisionGroups[e3]) {
            const t4 = ++this.maxGroupID;
            this.collisionGroups[e3] = { ID: t4, predicate: (e4) => e4.collisionGroupID === t4 };
          }
          return this.collisionGroups[e3];
        }
      }
      function li(t4, i3, o3, s3, r3) {
        const { horizontalAlign: a4, verticalAlign: n3 } = e2.by(t4), l3 = -(a4 - 0.5) * i3, c3 = -(n3 - 0.5) * o3, h3 = e2.bx(t4, s3);
        return new e2.P(l3 + h3[0] * r3, c3 + h3[1] * r3);
      }
      function ci(t4, i3, o3, s3, r3) {
        const a4 = new e2.P(t4, i3);
        return o3 && a4._rotate(s3 ? r3 : -r3), a4;
      }
      class hi {
        constructor(e3, t4, i3, o3, s3, r3) {
          this.transform = e3.clone(), this.projection = e3.projection.name, this.collisionIndex = new Yt(this.transform, s3), this.buildingIndex = r3, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = false, this.commitTime = 0, this.fadeDuration = t4, this.retainedQueryData = {}, this.collisionGroups = new ni(i3), this.collisionCircleArrays = {}, this.prevPlacement = o3, o3 && (o3.prevPlacement = void 0), this.placedOrientations = {};
        }
        getBucketParts(t4, i3, o3, s3, r3 = 1) {
          const a4 = o3.getBucket(i3), n3 = o3.latestFeatureIndex;
          if (!a4 || !n3 || i3.fqid !== a4.layerIds[0]) return;
          const l3 = a4.layers[0].layout, c3 = a4.layers[0].paint, h3 = o3.collisionBoxArray, u4 = Math.pow(2, this.transform.zoom - o3.tileID.overscaledZ), d3 = o3.tileSize / e2.ab, _2 = o3.tileID.toUnwrapped();
          this.transform.setProjection(a4.projection);
          const p3 = (f3 = o3.tileID, m2 = a4.getProjection(), g4 = this.transform, m2.name === this.projection ? g4.calculateProjMatrix(f3.toUnwrapped()) : Qt(g4, m2, f3));
          var f3, m2, g4;
          const v2 = "map" === l3.get("text-pitch-alignment"), x2 = "map" === l3.get("text-rotation-alignment");
          i3.compileFilter(i3.options);
          const y2 = i3.dynamicFilter(), b2 = i3.dynamicFilterNeedsFeature(), w2 = this.transform.calculatePixelsToTileUnitsMatrix(o3), T3 = Bt(p3, o3.tileID.canonical, v2, x2, this.transform, a4.getProjection(), w2);
          let E3 = null;
          if (v2) {
            const t5 = kt(p3, o3.tileID.canonical, v2, x2, this.transform, a4.getProjection(), w2);
            E3 = e2.a6.mat4.multiply([], this.transform.labelPlaneMatrix, t5);
          }
          let S2 = null;
          y2 && o3.latestFeatureIndex && (S2 = { unwrappedTileID: _2, dynamicFilter: y2, dynamicFilterNeedsFeature: b2 }), this.retainedQueryData[a4.bucketInstanceId] = new ai(a4.bucketInstanceId, n3, a4.sourceLayerIndex, a4.index, o3.tileID);
          const C3 = a4.layers[0].layout.get("text-size-scale-range"), I3 = e2.ap(r3, C3[0], C3[1]), D2 = a4.layers[0].layout.get("icon-size-scale-range"), R3 = e2.ap(r3, D2[0], D2[1]), A3 = { bucket: a4, layout: l3, paint: c3, posMatrix: p3, textLabelPlaneMatrix: T3, labelToScreenMatrix: E3, clippingData: S2, scale: u4, textPixelRatio: d3, holdingForFade: o3.holdingForFade(), collisionBoxArray: h3, partiallyEvaluatedTextSize: e2.bk(a4.textSizeData, this.transform.zoom, I3), partiallyEvaluatedIconSize: e2.bk(a4.iconSizeData, this.transform.zoom, R3), collisionGroup: this.collisionGroups.get(a4.sourceID), latestFeatureIndex: o3.latestFeatureIndex };
          if (s3) for (const e3 of a4.sortKeyRanges) {
            const { sortKey: i4, symbolInstanceStart: o4, symbolInstanceEnd: s4 } = e3;
            t4.push({ sortKey: i4, symbolInstanceStart: o4, symbolInstanceEnd: s4, parameters: A3 });
          }
          else t4.push({ symbolInstanceStart: 0, symbolInstanceEnd: a4.symbolInstances.length, parameters: A3 });
        }
        attemptAnchorPlacement(e3, t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4, d3, _2, p3, f3, m2, g4) {
          const { textOffset0: v2, textOffset1: x2, crossTileID: y2 } = u4, b2 = [v2, x2], w2 = li(e3, i3, o3, b2, s3), T3 = this.collisionIndex.placeCollisionBox(_2, s3, t4, ci(w2.x, w2.y, r3, a4, this.transform.angle), h3, n3, l3, c3.predicate);
          if (f3) {
            const e4 = _2.getSymbolInstanceIconSize(g4, this.transform.zoom, u4.placedIconSymbolIndex);
            if (0 === this.collisionIndex.placeCollisionBox(_2, e4, f3, ci(w2.x, w2.y, r3, a4, this.transform.angle), h3, n3, l3, c3.predicate).box.length) return;
          }
          if (T3.box.length > 0) {
            let t5;
            return this.prevPlacement && this.prevPlacement.variableOffsets[y2] && this.prevPlacement.placements[y2] && this.prevPlacement.placements[y2].text && (t5 = this.prevPlacement.variableOffsets[y2].anchor), this.variableOffsets[y2] = { textOffset: b2, width: i3, height: o3, anchor: e3, textScale: s3, prevAnchor: t5 }, this.markUsedJustification(_2, e3, u4, p3), _2.allowVerticalPlacement && (this.markUsedOrientation(_2, p3, u4), this.placedOrientations[y2] = p3), { shift: w2, placedGlyphBoxes: T3 };
          }
        }
        placeLayerBucketPart(t4, i3, o3, s3, r3 = 1) {
          const { bucket: a4, layout: n3, paint: l3, posMatrix: c3, textLabelPlaneMatrix: h3, labelToScreenMatrix: u4, clippingData: d3, textPixelRatio: _2, holdingForFade: p3, collisionBoxArray: f3, partiallyEvaluatedTextSize: m2, partiallyEvaluatedIconSize: g4, collisionGroup: v2, latestFeatureIndex: x2 } = t4.parameters, y2 = n3.get("text-optional"), b2 = n3.get("icon-optional"), w2 = n3.get("text-allow-overlap"), T3 = n3.get("icon-allow-overlap"), E3 = "map" === n3.get("text-rotation-alignment"), S2 = "map" === n3.get("text-pitch-alignment"), C3 = n3.get("symbol-z-elevate"), I3 = l3.get("symbol-z-offset"), D2 = "sea" === n3.get("symbol-elevation-reference"), R3 = n3.get("text-size-scale-range"), A3 = n3.get("icon-size-scale-range"), L3 = e2.ap(r3, R3[0], R3[1]), P2 = e2.ap(r3, A3[0], A3[1]);
          this.transform.setProjection(a4.projection);
          let M2 = w2 && (T3 || !a4.hasIconData() || b2), z3 = T3 && (w2 || !a4.hasTextData() || y2);
          const O2 = !I3.isConstant();
          !a4.collisionArrays && f3 && a4.deserializeCollisionBoxes(f3), o3 && s3 && a4.updateCollisionDebugBuffers(this.transform.zoom, f3, L3, P2);
          const F3 = (t5, s4, l4) => {
            const { crossTileID: f4, numVerticalGlyphVertices: C4 } = t5;
            let R4 = null;
            if (d3 && d3.dynamicFilterNeedsFeature || O2) {
              const e3 = this.retainedQueryData[a4.bucketInstanceId];
              R4 = x2.loadFeature({ featureIndex: t5.featureIndex, bucketIndex: e3.bucketIndex, sourceLayerIndex: e3.sourceLayerIndex, layoutVertexArrayOffset: 0 });
            }
            if (d3 && !(0, d3.dynamicFilter)({ zoom: this.transform.zoom, pitch: this.transform.pitch }, R4, this.retainedQueryData[a4.bucketInstanceId].tileID.canonical, new e2.P(t5.tileAnchorX, t5.tileAnchorY), this.transform.calculateDistanceTileData(d3.unwrappedTileID))) return this.placements[f4] = new si(false, false, false, true), void i3.add(f4);
            const A4 = I3.evaluate(R4, {});
            if (i3.has(f4)) return;
            if (p3) return void (this.placements[f4] = new si(false, false, false));
            let L4 = false, P3 = false, F4 = true, B4 = false, k2 = false, N2 = null, U3 = { box: null, offscreen: null, occluded: null }, G2 = { box: null }, V3 = null, j2 = null, H4 = null, Z3 = 0, q2 = 0, W2 = 0;
            l4.textFeatureIndex ? Z3 = l4.textFeatureIndex : t5.useRuntimeCollisionCircles && (Z3 = t5.featureIndex), l4.verticalTextFeatureIndex && (q2 = l4.verticalTextFeatureIndex);
            const $3 = (e3) => {
              e3.tileID = this.retainedQueryData[a4.bucketInstanceId].tileID;
              const i4 = this.transform.elevation;
              e3.elevation = D2 ? A4 : A4 + (i4 ? i4.getAtTileOffset(e3.tileID, e3.tileAnchorX, e3.tileAnchorY) : 0), e3.elevation += t5.zOffset;
            }, X2 = l4.textBox;
            if (X2) {
              $3(X2);
              const i4 = (i5) => {
                let o5 = e2.bl.horizontal;
                if (a4.allowVerticalPlacement && !i5 && this.prevPlacement) {
                  const e3 = this.prevPlacement.placedOrientations[f4];
                  e3 && (this.placedOrientations[f4] = e3, o5 = e3, this.markUsedOrientation(a4, o5, t5));
                }
                return o5;
              }, o4 = (t6, i5) => {
                if (a4.allowVerticalPlacement && C4 > 0 && l4.verticalTextBox) {
                  for (const o5 of a4.writingModes) if (o5 === e2.bl.vertical ? (U3 = i5(), G2 = U3) : U3 = t6(), U3 && U3.box && U3.box.length) break;
                } else U3 = t6();
              };
              if (n3.get("text-variable-anchor")) {
                let r4 = n3.get("text-variable-anchor");
                if (this.prevPlacement && this.prevPlacement.variableOffsets[f4]) {
                  const e3 = this.prevPlacement.variableOffsets[f4];
                  r4.indexOf(e3.anchor) > 0 && (r4 = r4.filter((t6) => t6 !== e3.anchor), r4.unshift(e3.anchor));
                }
                const h4 = (e3, i5, o5) => {
                  const n4 = a4.getSymbolInstanceTextSize(m2, t5, this.transform.zoom, s4), l5 = (e3.x2 - e3.x1) * n4 + 2 * e3.padding, h5 = (e3.y2 - e3.y1) * n4 + 2 * e3.padding, u6 = t5.hasIconTextFit && !T3 ? i5 : null;
                  u6 && $3(u6);
                  let d4 = { box: [], offscreen: false, occluded: false };
                  const p4 = w2 ? 2 * r4.length : r4.length;
                  for (let i6 = 0; i6 < p4; ++i6) {
                    const p5 = this.attemptAnchorPlacement(r4[i6 % r4.length], e3, l5, h5, n4, E3, S2, _2, c3, v2, i6 >= r4.length, t5, s4, a4, o5, u6, m2, g4);
                    if (p5 && (d4 = p5.placedGlyphBoxes, d4 && d4.box && d4.box.length)) {
                      L4 = true, N2 = p5.shift;
                      break;
                    }
                  }
                  return d4;
                };
                o4(() => h4(X2, l4.iconBox, e2.bl.horizontal), () => {
                  const t6 = l4.verticalTextBox;
                  return t6 && $3(t6), a4.allowVerticalPlacement && !(U3 && U3.box && U3.box.length) && C4 > 0 && t6 ? h4(t6, l4.verticalIconBox, e2.bl.vertical) : { box: null, offscreen: null, occluded: null };
                }), U3 && (L4 = U3.box, F4 = U3.offscreen, B4 = U3.occluded);
                const u5 = i4(!(!U3 || !U3.box));
                if (!L4 && this.prevPlacement) {
                  const e3 = this.prevPlacement.variableOffsets[f4];
                  e3 && (this.variableOffsets[f4] = e3, this.markUsedJustification(a4, e3.anchor, t5, u5));
                }
              } else {
                const n4 = (i5, o5) => {
                  const n5 = a4.getSymbolInstanceTextSize(m2, t5, this.transform.zoom, s4, r3), l5 = this.collisionIndex.placeCollisionBox(a4, n5, i5, new e2.P(0, 0), w2, _2, c3, v2.predicate);
                  return l5 && l5.box && l5.box.length && (this.markUsedOrientation(a4, o5, t5), this.placedOrientations[f4] = o5), l5;
                };
                o4(() => n4(X2, e2.bl.horizontal), () => {
                  const t6 = l4.verticalTextBox;
                  return a4.allowVerticalPlacement && C4 > 0 && t6 ? ($3(t6), n4(t6, e2.bl.vertical)) : { box: null, offscreen: null, occluded: null };
                }), i4(!!(U3 && U3.box && U3.box.length));
              }
            }
            if (V3 = U3, L4 = V3 && V3.box && V3.box.length > 0, F4 = V3 && V3.offscreen, B4 = V3 && V3.occluded, t5.useRuntimeCollisionCircles) {
              const i4 = a4.text.placedSymbolArray.get(t5.centerJustifiedTextSymbolIndex >= 0 ? t5.centerJustifiedTextSymbolIndex : t5.verticalPlacedTextSymbolIndex), s5 = e2.bm(a4.textSizeData, m2, i4), r4 = n3.get("text-padding");
              j2 = this.collisionIndex.placeCollisionCircles(a4, w2, i4, a4.lineVertexArray, a4.glyphOffsetArray, s5, c3, h3, u4, o3, S2, v2.predicate, t5.collisionCircleDiameter * s5 / e2.br, r4, this.retainedQueryData[a4.bucketInstanceId].tileID), L4 = w2 || j2.circles.length > 0 && !j2.collisionDetected, F4 = F4 && j2.offscreen, B4 = j2.occluded;
            }
            if (l4.iconFeatureIndex && (W2 = l4.iconFeatureIndex), l4.iconBox) {
              const i4 = (i5) => {
                $3(i5);
                const o4 = t5.hasIconTextFit && N2 ? ci(N2.x, N2.y, E3, S2, this.transform.angle) : new e2.P(0, 0), s5 = a4.getSymbolInstanceIconSize(g4, this.transform.zoom, t5.placedIconSymbolIndex);
                return this.collisionIndex.placeCollisionBox(a4, s5, i5, o4, T3, _2, c3, v2.predicate);
              };
              G2 && G2.box && G2.box.length && l4.verticalIconBox ? (H4 = i4(l4.verticalIconBox), P3 = H4.box.length > 0) : (H4 = i4(l4.iconBox), P3 = H4.box.length > 0), F4 = F4 && H4.offscreen, k2 = H4.occluded;
            }
            const J2 = y2 || 0 === t5.numHorizontalGlyphVertices && 0 === C4, K2 = b2 || 0 === t5.numIconVertices;
            if (J2 || K2 ? K2 ? J2 || (P3 = P3 && L4) : L4 = P3 && L4 : P3 = L4 = P3 && L4, L4 && V3 && V3.box && this.collisionIndex.insertCollisionBox(V3.box, n3.get("text-ignore-placement"), a4.bucketInstanceId, G2 && G2.box && q2 ? q2 : Z3, v2.ID), P3 && H4 && this.collisionIndex.insertCollisionBox(H4.box, n3.get("icon-ignore-placement"), a4.bucketInstanceId, W2, v2.ID), j2 && (L4 && this.collisionIndex.insertCollisionCircles(j2.circles, n3.get("text-ignore-placement"), a4.bucketInstanceId, Z3, v2.ID), o3)) {
              const e3 = a4.bucketInstanceId;
              let t6 = this.collisionCircleArrays[e3];
              void 0 === t6 && (t6 = this.collisionCircleArrays[e3] = new ri());
              for (let e4 = 0; e4 < j2.circles.length; e4 += 4) t6.circles.push(j2.circles[e4 + 0]), t6.circles.push(j2.circles[e4 + 1]), t6.circles.push(j2.circles[e4 + 2]), t6.circles.push(j2.collisionDetected ? 1 : 0);
            }
            const Y2 = "globe" !== a4.projection.name;
            M2 = M2 && (Y2 || !B4), z3 = z3 && (Y2 || !k2), this.placements[f4] = new si(L4 || M2, P3 || z3, F4 || a4.justReloaded), i3.add(f4);
          };
          if (C3 && this.buildingIndex && (this.buildingIndex.updateZOffset(a4, this.retainedQueryData[a4.bucketInstanceId].tileID), a4.updateZOffset()), a4.sortFeaturesByY) {
            const t5 = a4.getSortedSymbolIndexes(this.transform.angle);
            for (let e3 = t5.length - 1; e3 >= 0; --e3) {
              const i4 = t5[e3];
              F3(a4.symbolInstances.get(i4), i4, a4.collisionArrays[i4]);
            }
            a4.hasAnyZOffset && e2.w(`${a4.layerIds[0]} layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y`);
          } else if (a4.hasAnyZOffset) {
            const e3 = a4.getSortedIndexesByZOffset();
            for (let t5 = 0; t5 < e3.length; ++t5) {
              const i4 = e3[t5];
              F3(a4.symbolInstances.get(i4), i4, a4.collisionArrays[i4]);
            }
          } else for (let e3 = t4.symbolInstanceStart; e3 < t4.symbolInstanceEnd; e3++) F3(a4.symbolInstances.get(e3), e3, a4.collisionArrays[e3]);
          if (o3 && a4.bucketInstanceId in this.collisionCircleArrays) {
            const t5 = this.collisionCircleArrays[a4.bucketInstanceId];
            e2.a6.mat4.invert(t5.invProjMatrix, c3), t5.viewportMatrix = this.collisionIndex.getViewportMatrix();
          }
          a4.justReloaded = false;
        }
        markUsedJustification(t4, i3, o3, s3) {
          const { leftJustifiedTextSymbolIndex: r3, centerJustifiedTextSymbolIndex: a4, rightJustifiedTextSymbolIndex: n3, verticalPlacedTextSymbolIndex: l3, crossTileID: c3 } = o3, h3 = e2.bw(i3), u4 = s3 === e2.bl.vertical ? l3 : "left" === h3 ? r3 : "center" === h3 ? a4 : "right" === h3 ? n3 : -1;
          r3 >= 0 && (t4.text.placedSymbolArray.get(r3).crossTileID = u4 >= 0 && r3 !== u4 ? 0 : c3), a4 >= 0 && (t4.text.placedSymbolArray.get(a4).crossTileID = u4 >= 0 && a4 !== u4 ? 0 : c3), n3 >= 0 && (t4.text.placedSymbolArray.get(n3).crossTileID = u4 >= 0 && n3 !== u4 ? 0 : c3), l3 >= 0 && (t4.text.placedSymbolArray.get(l3).crossTileID = u4 >= 0 && l3 !== u4 ? 0 : c3);
        }
        markUsedOrientation(t4, i3, o3) {
          const s3 = i3 === e2.bl.horizontal || i3 === e2.bl.horizontalOnly ? i3 : 0, r3 = i3 === e2.bl.vertical ? i3 : 0, { leftJustifiedTextSymbolIndex: a4, centerJustifiedTextSymbolIndex: n3, rightJustifiedTextSymbolIndex: l3, verticalPlacedTextSymbolIndex: c3 } = o3, h3 = t4.text.placedSymbolArray;
          a4 >= 0 && (h3.get(a4).placedOrientation = s3), n3 >= 0 && (h3.get(n3).placedOrientation = s3), l3 >= 0 && (h3.get(l3).placedOrientation = s3), c3 >= 0 && (h3.get(c3).placedOrientation = r3);
        }
        commit(e3) {
          this.commitTime = e3, this.zoomAtLastRecencyCheck = this.transform.zoom;
          const t4 = this.prevPlacement;
          let i3 = false;
          this.prevZoomAdjustment = t4 ? t4.zoomAdjustment(this.transform.zoom) : 0;
          const o3 = t4 ? t4.symbolFadeChange(e3) : 1, s3 = t4 ? t4.opacities : {}, r3 = t4 ? t4.variableOffsets : {}, a4 = t4 ? t4.placedOrientations : {};
          for (const e4 in this.placements) {
            const t5 = this.placements[e4], r4 = s3[e4];
            r4 ? (this.opacities[e4] = new oi(r4, o3, t5.text, t5.icon, null, t5.clipped), i3 = i3 || t5.text !== r4.text.placed || t5.icon !== r4.icon.placed) : (this.opacities[e4] = new oi(null, o3, t5.text, t5.icon, t5.skipFade, t5.clipped), i3 = i3 || t5.text || t5.icon);
          }
          for (const e4 in s3) {
            const t5 = s3[e4];
            if (!this.opacities[e4]) {
              const s4 = new oi(t5, o3, false, false);
              s4.isHidden() || (this.opacities[e4] = s4, i3 = i3 || t5.text.placed || t5.icon.placed);
            }
          }
          for (const e4 in r3) this.variableOffsets[e4] || !this.opacities[e4] || this.opacities[e4].isHidden() || (this.variableOffsets[e4] = r3[e4]);
          for (const e4 in a4) this.placedOrientations[e4] || !this.opacities[e4] || this.opacities[e4].isHidden() || (this.placedOrientations[e4] = a4[e4]);
          i3 ? this.lastPlacementChangeTime = e3 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t4 ? t4.lastPlacementChangeTime : e3);
        }
        updateLayerOpacities(e3, t4, i3, o3) {
          const s3 = /* @__PURE__ */ new Set();
          for (const r3 of t4) {
            const t5 = r3.getBucket(e3);
            t5 && r3.latestFeatureIndex && e3.fqid === t5.layerIds[0] && (this.updateBucketOpacities(t5, s3, r3, r3.collisionBoxArray, i3, o3, r3.tileID, e3.scope), t5.layers[0].layout.get("symbol-z-elevate") && this.buildingIndex && (this.buildingIndex.updateZOffset(t5, r3.tileID), t5.updateZOffset()));
          }
        }
        updateBucketOpacities(t4, i3, o3, s3, r3, a4, n3, l3) {
          t4.hasTextData() && t4.text.opacityVertexArray.clear(), t4.hasIconData() && t4.icon.opacityVertexArray.clear(), t4.hasIconCollisionBoxData() && t4.iconCollisionBox.collisionVertexArray.clear(), t4.hasTextCollisionBoxData() && t4.textCollisionBox.collisionVertexArray.clear();
          const c3 = t4.layers[0].layout, h3 = t4.layers[0].paint, u4 = !!t4.layers[0].dynamicFilter(), d3 = new oi(null, 0, false, false, true), _2 = c3.get("text-allow-overlap"), p3 = c3.get("icon-allow-overlap"), f3 = c3.get("text-variable-anchor"), m2 = "map" === c3.get("text-rotation-alignment"), g4 = "map" === c3.get("text-pitch-alignment"), v2 = h3.get("symbol-z-offset"), x2 = "sea" === c3.get("symbol-elevation-reference"), y2 = !v2.isConstant(), b2 = new oi(null, 0, _2 && (p3 || !t4.hasIconData() || c3.get("icon-optional")), p3 && (_2 || !t4.hasTextData() || c3.get("text-optional")), true);
          !t4.collisionArrays && s3 && (t4.hasIconCollisionBoxData() || t4.hasTextCollisionBoxData()) && t4.deserializeCollisionBoxes(s3);
          const w2 = (e3, t5, i4) => {
            for (let o4 = 0; o4 < t5 / 4; o4++) e3.opacityVertexArray.emplaceBack(i4);
          };
          let T3 = 0;
          a4 && t4.updateReplacement(n3, a4);
          for (let s4 = 0; s4 < t4.symbolInstances.length; s4++) {
            const c4 = t4.symbolInstances.get(s4), { numHorizontalGlyphVertices: h4, numVerticalGlyphVertices: _3, crossTileID: p4, numIconVertices: E3, tileAnchorX: S2, tileAnchorY: C3 } = c4;
            let I3 = null;
            const D2 = this.retainedQueryData[t4.bucketInstanceId];
            y2 && c4 && D2 && (I3 = o3.latestFeatureIndex.loadFeature({ featureIndex: c4.featureIndex, bucketIndex: D2.bucketIndex, sourceLayerIndex: D2.sourceLayerIndex, layoutVertexArrayOffset: 0 }));
            const R3 = v2.evaluate(I3, {}), A3 = i3.has(p4);
            let L3 = this.opacities[p4];
            A3 ? L3 = d3 : L3 || (L3 = b2, this.opacities[p4] = L3), i3.add(p4);
            const P2 = h4 > 0 || _3 > 0, M2 = E3 > 0, z3 = this.placedOrientations[p4], O2 = z3 === e2.bl.vertical, F3 = z3 === e2.bl.horizontal || z3 === e2.bl.horizontalOnly;
            !P2 && !M2 || L3.isHidden() || T3++;
            let B4 = false;
            if ((P2 || M2) && a4) for (const i4 of t4.activeReplacements) {
              if (e2.bs(i4, r3, e2.bt.Symbol, l3)) continue;
              if (i4.min.x > S2 || S2 > i4.max.x || i4.min.y > C3 || C3 > i4.max.y) continue;
              const t5 = e2.bu(S2, C3, n3.canonical, i4.footprintTileId.canonical);
              if (B4 = e2.bv(t5, i4.footprint), B4) break;
            }
            if (P2) {
              const e3 = B4 ? yi : xi(L3.text);
              w2(t4.text, h4, O2 ? yi : e3), w2(t4.text, _3, F3 ? yi : e3);
              const i4 = L3.text.isHidden(), { leftJustifiedTextSymbolIndex: o4, centerJustifiedTextSymbolIndex: s5, rightJustifiedTextSymbolIndex: r4, verticalPlacedTextSymbolIndex: a5 } = c4, n4 = t4.text.placedSymbolArray, l4 = i4 || O2 ? 1 : 0;
              o4 >= 0 && (n4.get(o4).hidden = l4), s5 >= 0 && (n4.get(s5).hidden = l4), r4 >= 0 && (n4.get(r4).hidden = l4), a5 >= 0 && (n4.get(a5).hidden = i4 || F3 ? 1 : 0);
              const u5 = this.variableOffsets[p4];
              u5 && this.markUsedJustification(t4, u5.anchor, c4, z3);
              const d4 = this.placedOrientations[p4];
              d4 && (this.markUsedJustification(t4, "left", c4, d4), this.markUsedOrientation(t4, d4, c4));
            }
            if (M2) {
              const e3 = B4 ? yi : xi(L3.icon), { placedIconSymbolIndex: i4, verticalPlacedIconSymbolIndex: o4 } = c4, s5 = t4.icon.placedSymbolArray, r4 = L3.icon.isHidden() ? 1 : 0;
              i4 >= 0 && (w2(t4.icon, E3, O2 ? yi : e3), s5.get(i4).hidden = r4), o4 >= 0 && (w2(t4.icon, c4.numVerticalIconVertices, F3 ? yi : e3), s5.get(o4).hidden = r4);
            }
            if (t4.hasIconCollisionBoxData() || t4.hasTextCollisionBoxData()) {
              const i4 = t4.collisionArrays[s4];
              if (i4) {
                let o4 = new e2.P(0, 0), s5 = true;
                if (i4.textBox || i4.verticalTextBox) {
                  if (f3) {
                    const e3 = this.variableOffsets[p4];
                    e3 ? (o4 = li(e3.anchor, e3.width, e3.height, e3.textOffset, e3.textScale), m2 && o4._rotate(g4 ? this.transform.angle : -this.transform.angle)) : s5 = false;
                  }
                  u4 && (s5 = !L3.clipped), i4.textBox && ui(t4.textCollisionBox.collisionVertexArray, L3.text.placed, !s5 || O2, R3, x2, o4.x, o4.y), i4.verticalTextBox && ui(t4.textCollisionBox.collisionVertexArray, L3.text.placed, !s5 || F3, R3, x2, o4.x, o4.y);
                }
                const r4 = s5 && Boolean(!F3 && i4.verticalIconBox);
                i4.iconBox && ui(t4.iconCollisionBox.collisionVertexArray, L3.icon.placed, r4, R3, x2, c4.hasIconTextFit ? o4.x : 0, c4.hasIconTextFit ? o4.y : 0), i4.verticalIconBox && ui(t4.iconCollisionBox.collisionVertexArray, L3.icon.placed, !r4, R3, x2, c4.hasIconTextFit ? o4.x : 0, c4.hasIconTextFit ? o4.y : 0);
              }
            }
          }
          if (t4.fullyClipped = 0 === T3, t4.sortFeatures(this.transform.angle), this.retainedQueryData[t4.bucketInstanceId] && (this.retainedQueryData[t4.bucketInstanceId].featureSortOrder = t4.featureSortOrder), t4.hasTextData() && t4.text.opacityVertexBuffer && t4.text.opacityVertexBuffer.updateData(t4.text.opacityVertexArray), t4.hasIconData() && t4.icon.opacityVertexBuffer && t4.icon.opacityVertexBuffer.updateData(t4.icon.opacityVertexArray), t4.hasIconCollisionBoxData() && t4.iconCollisionBox.collisionVertexBuffer && t4.iconCollisionBox.collisionVertexBuffer.updateData(t4.iconCollisionBox.collisionVertexArray), t4.hasTextCollisionBoxData() && t4.textCollisionBox.collisionVertexBuffer && t4.textCollisionBox.collisionVertexBuffer.updateData(t4.textCollisionBox.collisionVertexArray), t4.bucketInstanceId in this.collisionCircleArrays) {
            const e3 = this.collisionCircleArrays[t4.bucketInstanceId];
            t4.placementInvProjMatrix = e3.invProjMatrix, t4.placementViewportMatrix = e3.viewportMatrix, t4.collisionCircleArray = e3.circles, delete this.collisionCircleArrays[t4.bucketInstanceId];
          }
        }
        symbolFadeChange(e3) {
          return 0 === this.fadeDuration ? 1 : (e3 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
        }
        zoomAdjustment(e3) {
          return Math.max(0, (this.transform.zoom - e3) / 1.5);
        }
        hasTransitions(e3) {
          return this.stale || e3 - this.lastPlacementChangeTime < this.fadeDuration;
        }
        stillRecent(e3, t4) {
          const i3 = this.zoomAtLastRecencyCheck === t4 ? 1 - this.zoomAdjustment(t4) : 1;
          return this.zoomAtLastRecencyCheck = t4, this.commitTime + this.fadeDuration * i3 > e3;
        }
        setStale() {
          this.stale = true;
        }
      }
      function ui(e3, t4, i3, o3, s3, r3, a4) {
        e3.emplaceBack(t4 ? 1 : 0, i3 ? 1 : 0, r3 || 0, a4 || 0, o3, s3 ? 1 : 0), e3.emplaceBack(t4 ? 1 : 0, i3 ? 1 : 0, r3 || 0, a4 || 0, o3, s3 ? 1 : 0), e3.emplaceBack(t4 ? 1 : 0, i3 ? 1 : 0, r3 || 0, a4 || 0, o3, s3 ? 1 : 0), e3.emplaceBack(t4 ? 1 : 0, i3 ? 1 : 0, r3 || 0, a4 || 0, o3, s3 ? 1 : 0);
      }
      const di = Math.pow(2, 25), _i = Math.pow(2, 24), pi2 = Math.pow(2, 17), fi = Math.pow(2, 16), mi = Math.pow(2, 9), gi = Math.pow(2, 8), vi = Math.pow(2, 1);
      function xi(e3) {
        if (0 === e3.opacity && !e3.placed) return 0;
        if (1 === e3.opacity && e3.placed) return 4294967295;
        const t4 = e3.placed ? 1 : 0, i3 = Math.floor(127 * e3.opacity);
        return i3 * di + t4 * _i + i3 * pi2 + t4 * fi + i3 * mi + t4 * gi + i3 * vi + t4;
      }
      const yi = 0;
      class bi {
        constructor(e3) {
          this._sortAcrossTiles = "viewport-y" !== e3.layout.get("symbol-z-order") && void 0 !== e3.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = /* @__PURE__ */ new Set(), this._bucketParts = [];
        }
        continuePlacement(e3, t4, i3, o3, s3, r3) {
          const a4 = this._bucketParts;
          for (; this._currentTileIndex < e3.length; ) if (t4.getBucketParts(a4, o3, e3[this._currentTileIndex], this._sortAcrossTiles, r3), this._currentTileIndex++, s3()) return true;
          for (this._sortAcrossTiles && (this._sortAcrossTiles = false, a4.sort((e4, t5) => e4.sortKey - t5.sortKey)); this._currentPartIndex < a4.length; ) {
            const e4 = a4[this._currentPartIndex];
            if (t4.placeLayerBucketPart(e4, this._seenCrossTileIDs, i3, 0 === e4.symbolInstanceStart, r3), this._currentPartIndex++, s3()) return true;
          }
          return false;
        }
      }
      class wi {
        constructor(e3, t4, i3, o3, s3, r3, a4, n3, l3) {
          this.placement = new hi(e3, s3, r3, a4, n3, l3), this._currentPlacementIndex = t4.length - 1, this._forceFullPlacement = i3, this._showCollisionBoxes = o3, this._done = false;
        }
        isDone() {
          return this._done;
        }
        continuePlacement(t4, i3, o3, s3, r3) {
          const a4 = e2.e.now(), n3 = () => {
            const t5 = e2.e.now() - a4;
            return !this._forceFullPlacement && t5 > 2;
          };
          for (; this._currentPlacementIndex >= 0; ) {
            const a5 = i3[t4[this._currentPlacementIndex]], l3 = this.placement.collisionIndex.transform.zoom;
            if ("symbol" === a5.type && (!a5.minzoom || a5.minzoom <= l3) && (!a5.maxzoom || a5.maxzoom > l3)) {
              const t5 = a5, i4 = t5.layout.get("symbol-z-elevate"), l4 = void 0 !== t5.layout.get("symbol-sort-key").constantOr(1), c3 = t5.layout.get("symbol-z-order"), h3 = "viewport-y" === c3 || "auto" === c3 && !("viewport-y" !== c3 && l4), u4 = t5.layout.get("text-allow-overlap") || t5.layout.get("icon-allow-overlap") || t5.layout.get("text-ignore-placement") || t5.layout.get("icon-ignore-placement"), d3 = h3 && u4, _2 = this._inProgressLayer = this._inProgressLayer || new bi(t5), p3 = e2.av(a5.source, a5.scope);
              if (_2.continuePlacement(i4 || d3 ? s3[p3] : o3[p3], this.placement, this._showCollisionBoxes, a5, n3, r3)) return;
              delete this._inProgressLayer;
            }
            this._currentPlacementIndex--;
          }
          this._done = true;
        }
        commit(e3) {
          return this.placement.commit(e3), this.placement;
        }
      }
      const Ti2 = 512 / e2.ab / 2;
      class Ei {
        constructor(t4, i3, o3) {
          this.tileID = t4, this.bucketInstanceId = o3, this.index = new e2.bz(i3.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
          const s3 = t4.canonical.x * e2.ab, r3 = t4.canonical.y * e2.ab;
          for (let e3 = 0; e3 < i3.length; e3++) {
            const { key: t5, crossTileID: o4, tileAnchorX: a4, tileAnchorY: n3 } = i3.get(e3), l3 = Math.floor((s3 + a4) * Ti2), c3 = Math.floor((r3 + n3) * Ti2);
            this.index.add(l3, c3), this.keys.push(t5), this.crossTileIDs.push(o4);
          }
          this.index.finish();
        }
        findMatches(t4, i3, o3) {
          const s3 = this.tileID.canonical.z < i3.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - i3.canonical.z), r3 = Ti2 / Math.pow(2, i3.canonical.z - this.tileID.canonical.z), a4 = i3.canonical.x * e2.ab, n3 = i3.canonical.y * e2.ab;
          for (let e3 = 0; e3 < t4.length; e3++) {
            const i4 = t4.get(e3);
            if (i4.crossTileID) continue;
            const { key: l3, tileAnchorX: c3, tileAnchorY: h3 } = i4, u4 = Math.floor((a4 + c3) * r3), d3 = Math.floor((n3 + h3) * r3), _2 = this.index.range(u4 - s3, d3 - s3, u4 + s3, d3 + s3);
            for (const e4 of _2) {
              const t5 = this.crossTileIDs[e4];
              if (this.keys[e4] === l3 && !o3.has(t5)) {
                o3.add(t5), i4.crossTileID = t5;
                break;
              }
            }
          }
        }
      }
      class Si2 {
        constructor() {
          this.maxCrossTileID = 0;
        }
        generate() {
          return ++this.maxCrossTileID;
        }
      }
      class Ci {
        constructor() {
          this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
        }
        handleWrapJump(e3) {
          const t4 = Math.round((e3 - this.lng) / 360);
          if (0 !== t4) for (const e4 in this.indexes) {
            const i3 = this.indexes[e4], o3 = {};
            for (const e5 in i3) {
              const s3 = i3[e5];
              s3.tileID = s3.tileID.unwrapTo(s3.tileID.wrap + t4), o3[s3.tileID.key] = s3;
            }
            this.indexes[e4] = o3;
          }
          this.lng = e3;
        }
        addBucket(e3, t4, i3) {
          if (this.indexes[e3.overscaledZ] && this.indexes[e3.overscaledZ][e3.key]) {
            if (this.indexes[e3.overscaledZ][e3.key].bucketInstanceId === t4.bucketInstanceId) return false;
            this.removeBucketCrossTileIDs(e3.overscaledZ, this.indexes[e3.overscaledZ][e3.key]);
          }
          for (let e4 = 0; e4 < t4.symbolInstances.length; e4++) t4.symbolInstances.get(e4).crossTileID = 0;
          this.usedCrossTileIDs[e3.overscaledZ] || (this.usedCrossTileIDs[e3.overscaledZ] = /* @__PURE__ */ new Set());
          const o3 = this.usedCrossTileIDs[e3.overscaledZ];
          for (const i4 in this.indexes) {
            const s3 = this.indexes[i4];
            if (Number(i4) > e3.overscaledZ) for (const i5 in s3) {
              const r3 = s3[i5];
              r3.tileID.isChildOf(e3) && r3.findMatches(t4.symbolInstances, e3, o3);
            }
            else {
              const r3 = s3[e3.scaledTo(Number(i4)).key];
              r3 && r3.findMatches(t4.symbolInstances, e3, o3);
            }
          }
          for (let e4 = 0; e4 < t4.symbolInstances.length; e4++) {
            const s3 = t4.symbolInstances.get(e4);
            s3.crossTileID || (s3.crossTileID = i3.generate(), o3.add(s3.crossTileID));
          }
          return void 0 === this.indexes[e3.overscaledZ] && (this.indexes[e3.overscaledZ] = {}), this.indexes[e3.overscaledZ][e3.key] = new Ei(e3, t4.symbolInstances, t4.bucketInstanceId), true;
        }
        removeBucketCrossTileIDs(e3, t4) {
          for (const i3 of t4.crossTileIDs) this.usedCrossTileIDs[e3].delete(i3);
        }
        removeStaleBuckets(e3) {
          let t4 = false;
          for (const i3 in this.indexes) {
            const o3 = this.indexes[i3];
            for (const s3 in o3) e3[o3[s3].bucketInstanceId] || (this.removeBucketCrossTileIDs(i3, o3[s3]), delete o3[s3], t4 = true);
          }
          return t4;
        }
      }
      class Ii2 {
        constructor() {
          this.layerIndexes = {}, this.crossTileIDs = new Si2(), this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
        }
        addLayer(e3, t4, i3, o3) {
          let s3 = this.layerIndexes[e3.fqid];
          void 0 === s3 && (s3 = this.layerIndexes[e3.fqid] = new Ci());
          let r3 = false;
          const a4 = {};
          "globe" !== o3.name && s3.handleWrapJump(i3);
          for (const i4 of t4) {
            const t5 = i4.getBucket(e3);
            t5 && e3.fqid === t5.layerIds[0] && (t5.bucketInstanceId || (t5.bucketInstanceId = ++this.maxBucketInstanceId), s3.addBucket(i4.tileID, t5, this.crossTileIDs) && (r3 = true), a4[t5.bucketInstanceId] = true);
          }
          return s3.removeStaleBuckets(a4) && (r3 = true), r3;
        }
        pruneUnusedLayers(e3) {
          const t4 = {};
          e3.forEach((e4) => {
            t4[e4] = true;
          });
          for (const e4 in this.layerIndexes) t4[e4] || delete this.layerIndexes[e4];
        }
      }
      const Di = 771;
      class Ri {
        constructor(e3, t4, i3, o3) {
          this.blendFunction = e3, this.blendColor = t4, this.mask = i3, this.blendEquation = o3;
        }
      }
      Ri.Replace = [1, 0, 1, 0], Ri.disabled = new Ri(Ri.Replace, e2.bA.transparent, [false, false, false, false]), Ri.unblended = new Ri(Ri.Replace, e2.bA.transparent, [true, true, true, true]), Ri.alphaBlended = new Ri([1, Di, 1, Di], e2.bA.transparent, [true, true, true, true]), Ri.alphaBlendedNonPremultiplied = new Ri([770, Di, 770, Di], e2.bA.transparent, [true, true, true, true]), Ri.multiply = new Ri([774, 0, 774, 0], e2.bA.transparent, [true, true, true, true]);
      class Ai {
        constructor(e3, t4, i3) {
          this.func = e3, this.mask = t4, this.range = i3;
        }
      }
      Ai.ReadOnly = false, Ai.ReadWrite = true, Ai.disabled = new Ai(519, Ai.ReadOnly, [0, 1]);
      const Li = 7680;
      class Pi2 {
        constructor(e3, t4, i3, o3, s3, r3) {
          this.test = e3, this.ref = t4, this.mask = i3, this.fail = o3, this.depthFail = s3, this.pass = r3;
        }
      }
      Pi2.disabled = new Pi2({ func: 519, mask: 0 }, 0, 0, Li, Li, Li);
      const Mi = 1029, zi = 2305;
      class Oi2 {
        constructor(e3, t4, i3) {
          this.enable = e3, this.mode = t4, this.frontFace = i3;
        }
      }
      function Fi(t4, i3) {
        const o3 = e2.bD(t4, 3);
        e2.a6.mat4.fromQuat(t4, i3), e2.bF(t4, 3, o3);
      }
      function Bi(t4, i3) {
        const o3 = e2.a6.quat.identity([]);
        return e2.a6.quat.rotateZ(o3, o3, -i3), e2.a6.quat.rotateX(o3, o3, -t4), o3;
      }
      function ki(t4, i3) {
        const o3 = [t4[0], t4[1], 0], s3 = [i3[0], i3[1], 0];
        if (e2.a6.vec3.length(o3) >= 1e-15) {
          const t5 = e2.a6.vec3.normalize([], o3);
          e2.a6.vec3.scale(s3, t5, e2.a6.vec3.dot(s3, t5)), i3[0] = s3[0], i3[1] = s3[1];
        }
        const r3 = e2.a6.vec3.cross([], i3, t4);
        if (e2.a6.vec3.len(r3) < 1e-15) return null;
        const a4 = Math.atan2(-r3[1], r3[0]);
        return Bi(Math.atan2(Math.sqrt(t4[0] * t4[0] + t4[1] * t4[1]), -t4[2]), a4);
      }
      Oi2.disabled = new Oi2(false, Mi, zi), Oi2.backCCW = new Oi2(true, Mi, zi), Oi2.backCW = new Oi2(true, Mi, 2304), Oi2.frontCW = new Oi2(true, 1028, 2304), Oi2.frontCCW = new Oi2(true, 1028, zi);
      class Ni {
        constructor(e3, t4) {
          this.position = e3, this.orientation = t4;
        }
        get position() {
          return this._position;
        }
        set position(t4) {
          if (t4) {
            const i3 = t4 instanceof e2.a5 ? t4 : new e2.a5(t4[0], t4[1], t4[2]);
            this._renderWorldCopies && (i3.x = e2.bB(i3.x, 0, 1)), this._position = i3;
          } else this._position = null;
        }
        lookAtPoint(t4, i3) {
          if (this.orientation = null, !this.position) return;
          const o3 = this.position, s3 = this._elevation ? this._elevation.getAtPointOrZero(e2.a5.fromLngLat(t4)) : 0, r3 = e2.a5.fromLngLat(t4, s3), a4 = [r3.x - o3.x, r3.y - o3.y, r3.z - o3.z];
          i3 || (i3 = [0, 0, 1]), i3[2] = Math.abs(i3[2]), this.orientation = ki(a4, i3);
        }
        setPitchBearing(t4, i3) {
          this.orientation = Bi(e2.bC(t4), e2.bC(-i3));
        }
      }
      class Ui {
        constructor(t4, i3) {
          this._transform = e2.a6.mat4.identity([]), this.orientation = i3, this.position = t4;
        }
        get mercatorPosition() {
          const t4 = this.position;
          return new e2.a5(t4[0], t4[1], t4[2]);
        }
        get position() {
          const t4 = e2.bD(this._transform, 3);
          return [t4[0], t4[1], t4[2]];
        }
        set position(t4) {
          var i3;
          t4 && e2.bF(this._transform, 3, [(i3 = t4)[0], i3[1], i3[2], 1]);
        }
        get orientation() {
          return this._orientation;
        }
        set orientation(t4) {
          this._orientation = t4 || e2.a6.quat.identity([]), t4 && Fi(this._transform, this._orientation);
        }
        getPitchBearing() {
          const e3 = this.forward(), t4 = this.right();
          return { bearing: Math.atan2(-t4[1], t4[0]), pitch: Math.atan2(Math.sqrt(e3[0] * e3[0] + e3[1] * e3[1]), -e3[2]) };
        }
        setPitchBearing(e3, t4) {
          this._orientation = Bi(e3, t4), Fi(this._transform, this._orientation);
        }
        forward() {
          const t4 = e2.bD(this._transform, 2);
          return [-t4[0], -t4[1], -t4[2]];
        }
        up() {
          const t4 = e2.bD(this._transform, 1);
          return [-t4[0], -t4[1], -t4[2]];
        }
        right() {
          const t4 = e2.bD(this._transform, 0);
          return [t4[0], t4[1], t4[2]];
        }
        getCameraToWorld(t4, i3) {
          const o3 = new Float64Array(16);
          return e2.a6.mat4.invert(o3, this.getWorldToCamera(t4, i3)), o3;
        }
        getCameraToWorldMercator() {
          return this._transform;
        }
        getWorldToCameraPosition(t4, i3, o3) {
          const s3 = this.position;
          e2.a6.vec3.scale(s3, s3, -t4);
          const r3 = new Float64Array(16);
          return e2.a6.mat4.fromScaling(r3, [o3, o3, o3]), e2.a6.mat4.translate(r3, r3, s3), r3[10] *= i3, r3;
        }
        getWorldToCamera(t4, i3) {
          const o3 = new Float64Array(16), s3 = new Float64Array(4), r3 = this.position;
          return e2.a6.quat.conjugate(s3, this._orientation), e2.a6.vec3.scale(r3, r3, -t4), e2.a6.mat4.fromQuat(o3, s3), e2.a6.mat4.translate(o3, o3, r3), o3[1] *= -1, o3[5] *= -1, o3[9] *= -1, o3[13] *= -1, o3[8] *= i3, o3[9] *= i3, o3[10] *= i3, o3[11] *= i3, o3;
        }
        getCameraToClipPerspective(t4, i3, o3, s3) {
          const r3 = new Float64Array(16);
          return e2.a6.mat4.perspective(r3, t4, i3, o3, s3), r3;
        }
        getCameraToClipOrthographic(t4, i3, o3, s3, r3, a4) {
          const n3 = new Float64Array(16);
          return e2.a6.mat4.ortho(n3, t4, i3, o3, s3, r3, a4), n3;
        }
        getDistanceToElevation(t4, i3 = false) {
          const o3 = 0 === t4 ? 0 : e2.bE(t4, i3 ? e2.aN(this.position[1]) : this.position[1]), s3 = this.forward();
          return (o3 - this.position[2]) / s3[2];
        }
        clone() {
          return new Ui([...this.position], [...this.orientation]);
        }
      }
      const Gi = { BaseColor: 5, MetallicRoughness: 6, Normal: 7, Occlusion: 8, Emission: 9, LUT: 10, ShadowMap0: 11 };
      class Vi {
        constructor(e3 = 0, t4 = 0, i3 = 0, o3 = 0) {
          if (isNaN(e3) || e3 < 0 || isNaN(t4) || t4 < 0 || isNaN(i3) || i3 < 0 || isNaN(o3) || o3 < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
          this.top = e3, this.bottom = t4, this.left = i3, this.right = o3;
        }
        interpolate(t4, i3, o3) {
          return null != i3.top && null != t4.top && (this.top = e2.aa(t4.top, i3.top, o3)), null != i3.bottom && null != t4.bottom && (this.bottom = e2.aa(t4.bottom, i3.bottom, o3)), null != i3.left && null != t4.left && (this.left = e2.aa(t4.left, i3.left, o3)), null != i3.right && null != t4.right && (this.right = e2.aa(t4.right, i3.right, o3)), this;
        }
        getCenter(t4, i3) {
          const o3 = e2.ap((this.left + t4 - this.right) / 2, 0, t4), s3 = e2.ap((this.top + i3 - this.bottom) / 2, 0, i3);
          return new e2.P(o3, s3);
        }
        equals(e3) {
          return this.top === e3.top && this.bottom === e3.bottom && this.left === e3.left && this.right === e3.right;
        }
        clone() {
          return new Vi(this.top, this.bottom, this.left, this.right);
        }
        toJSON() {
          return { top: this.top, bottom: this.bottom, left: this.left, right: this.right };
        }
      }
      const ji = (e3, t4, i3) => (1 - i3) * e3 + i3 * t4, Hi = (e3) => e3 * e3 * e3 * e3 * e3;
      class Zi2 {
        constructor(t4, i3, o3, s3, r3, a4, n3) {
          this.tileSize = 512, this._renderWorldCopies = void 0 === r3 || r3, this._minZoom = t4 || 0, this._maxZoom = i3 || 22, this._minPitch = o3 ?? 0, this._maxPitch = s3 ?? 60, this.setProjection(a4), this.setMaxBounds(n3), this.width = 0, this.height = 0, this._center = new e2.bL(0, 0), this.zoom = 0, this.angle = 0, this._fov = 0.6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._unmodified = true, this._edgeInsets = new Vi(), this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._expandedProjMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new Ui(), this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [0, 0, 0], this._tileCoverLift = 0, this.freezeTileCoverage = false, this._horizonShift = 0.1, this._orthographicProjectionAtLowPitch = false;
        }
        clone() {
          const e3 = new Zi2(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection());
          return e3._elevation = this._elevation, e3._centerAltitude = this._centerAltitude, e3._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e3.tileSize = this.tileSize, e3.mercatorFromTransition = this.mercatorFromTransition, e3.width = this.width, e3.height = this.height, e3.cameraElevationReference = this.cameraElevationReference, e3._center = this._center, e3._setZoom(this.zoom), e3._seaLevelZoom = this._seaLevelZoom, e3.angle = this.angle, e3._fov = this._fov, e3._pitch = this._pitch, e3._nearZ = this._nearZ, e3._farZ = this._farZ, e3._averageElevation = this._averageElevation, e3._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, e3._unmodified = this._unmodified, e3._edgeInsets = this._edgeInsets.clone(), e3._camera = this._camera.clone(), e3._calcMatrices(), e3.freezeTileCoverage = this.freezeTileCoverage, e3.frustumCorners = this.frustumCorners, e3;
        }
        get isOrthographic() {
          return "globe" !== this.projection.name && this._orthographicProjectionAtLowPitch && this.pitch < 15;
        }
        get elevation() {
          return this._elevation;
        }
        set elevation(e3) {
          this._elevation !== e3 && (this._elevation = e3, this._updateCameraOnTerrain(), this._calcMatrices());
        }
        get depthOcclusionForSymbolsAndCircles() {
          return "globe" !== this.projection.name && !this.isOrthographic;
        }
        updateElevation(e3, t4 = false) {
          const i3 = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
          (null == this._seaLevelZoom || i3) && this._updateCameraOnTerrain(), (e3 || i3) && this._constrainCamera(t4), this._calcMatrices();
        }
        getProjection() {
          return e2.ar(this.projection, ["name", "center", "parallels"]);
        }
        setProjection(t4) {
          this.projectionOptions = t4 || { name: "mercator" };
          const i3 = this.projection ? this.getProjection() : void 0;
          this.projection = e2.bM(this.projectionOptions);
          const o3 = this.getProjection(), s3 = !e2.bi(i3, o3);
          return s3 && this._calcMatrices(), this.mercatorFromTransition = false, s3;
        }
        setOrthographicProjectionAtLowPitch(e3) {
          return this._orthographicProjectionAtLowPitch !== e3 && (this._orthographicProjectionAtLowPitch = e3, this._calcMatrices(), true);
        }
        setMercatorFromTransition() {
          const t4 = this.projection.name;
          this.mercatorFromTransition = true, this.projectionOptions = { name: "mercator" }, this.projection = e2.bM({ name: "mercator" });
          const i3 = t4 !== this.projection.name;
          return i3 && this._calcMatrices(), i3;
        }
        get minZoom() {
          return this._minZoom;
        }
        set minZoom(e3) {
          this._minZoom !== e3 && (this._minZoom = e3, this.zoom = Math.max(this.zoom, e3));
        }
        get maxZoom() {
          return this._maxZoom;
        }
        set maxZoom(e3) {
          this._maxZoom !== e3 && (this._maxZoom = e3, this.zoom = Math.min(this.zoom, e3));
        }
        get minPitch() {
          return this._minPitch;
        }
        set minPitch(e3) {
          this._minPitch !== e3 && (this._minPitch = e3, this.pitch = Math.max(this.pitch, e3));
        }
        get maxPitch() {
          return this._maxPitch;
        }
        set maxPitch(e3) {
          this._maxPitch !== e3 && (this._maxPitch = e3, this.pitch = Math.min(this.pitch, e3));
        }
        get renderWorldCopies() {
          return this._renderWorldCopies && true === this.projection.supportsWorldCopies;
        }
        set renderWorldCopies(e3) {
          void 0 === e3 ? e3 = true : null === e3 && (e3 = false), this._renderWorldCopies = e3;
        }
        get worldSize() {
          return this.tileSize * this.scale;
        }
        get cameraWorldSizeForFog() {
          const e3 = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
          return this._worldSizeFromZoom(this._zoomFromMercatorZ(e3));
        }
        get cameraWorldSize() {
          const e3 = Math.max(this._camera.getDistanceToElevation(this._averageElevation, true), Number.EPSILON);
          return this._worldSizeFromZoom(this._zoomFromMercatorZ(e3));
        }
        get pixelsPerMeter() {
          return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
        }
        get cameraPixelsPerMeter() {
          return e2.bE(1, this.center.lat) * this.cameraWorldSizeForFog;
        }
        get centerOffset() {
          return this.centerPoint._sub(this.size._div(2));
        }
        get size() {
          return new e2.P(this.width, this.height);
        }
        get bearing() {
          return e2.bB(this.rotation, -180, 180);
        }
        set bearing(e3) {
          this.rotation = e3;
        }
        get rotation() {
          return -this.angle / Math.PI * 180;
        }
        set rotation(t4) {
          const i3 = -t4 * Math.PI / 180;
          this.angle !== i3 && (this._unmodified = false, this.angle = i3, this._calcMatrices(), this.rotationMatrix = e2.a6.mat2.create(), e2.a6.mat2.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
        }
        get pitch() {
          return this._pitch / Math.PI * 180;
        }
        set pitch(t4) {
          const i3 = e2.ap(t4, this.minPitch, this.maxPitch) / 180 * Math.PI;
          this._pitch !== i3 && (this._unmodified = false, this._pitch = i3, this._calcMatrices());
        }
        get aspect() {
          return this.width / this.height;
        }
        get fov() {
          return this._fov / Math.PI * 180;
        }
        get fovX() {
          return this._fov;
        }
        get fovY() {
          const e3 = 1 / Math.tan(0.5 * this.fovX);
          return 2 * Math.atan(1 / this.aspect / e3);
        }
        set fov(t4) {
          t4 = Math.max(0.01, Math.min(60, t4)), this._fov !== t4 && (this._unmodified = false, this._fov = e2.bC(t4), this._calcMatrices());
        }
        get averageElevation() {
          return this._averageElevation;
        }
        set averageElevation(e3) {
          this._averageElevation = e3, this._calcFogMatrices(), this._distanceTileDataCache = {};
        }
        get zoom() {
          return this._zoom;
        }
        set zoom(e3) {
          const t4 = Math.min(Math.max(e3, this.minZoom), this.maxZoom);
          this._zoom !== t4 && (this._unmodified = false, this._setZoom(t4), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
        }
        _setZoom(e3) {
          this._zoom = e3, this.scale = this.zoomScale(e3), this.tileZoom = Math.floor(e3), this.zoomFraction = e3 - this.tileZoom;
        }
        get tileCoverLift() {
          return this._tileCoverLift;
        }
        set tileCoverLift(e3) {
          this._tileCoverLift !== e3 && (this._tileCoverLift = e3);
        }
        _updateCameraOnTerrain() {
          const e3 = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY, t4 = this.elevation && e3 === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
          if (!this._elevation || e3 === Number.NEGATIVE_INFINITY && (!t4 || !this._centerAltitude)) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
          const i3 = this._elevation;
          t4 || this._centerAltitude && this._centerAltitudeValidForExaggeration && i3.exaggeration() && this._centerAltitudeValidForExaggeration !== i3.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * i3.exaggeration(), this._centerAltitudeValidForExaggeration = i3.exaggeration()) : (this._centerAltitude = e3 || 0, this._centerAltitudeValidForExaggeration = i3.exaggeration()), this._updateSeaLevelZoom();
        }
        _updateSeaLevelZoom() {
          void 0 !== this._centerAltitudeValidForExaggeration && (this._seaLevelZoom = this._zoomFromMercatorZ((this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize));
        }
        sampleAverageElevation() {
          if (!this._elevation) return 0;
          const t4 = this._elevation, i3 = [[0.5, 0.2], [0.3, 0.5], [0.5, 0.5], [0.7, 0.5], [0.5, 0.8]], o3 = this.horizonLineFromTop();
          let s3 = 0, r3 = 0;
          for (let a4 = 0; a4 < i3.length; a4++) {
            const n3 = new e2.P(i3[a4][0] * this.width, o3 + i3[a4][1] * (this.height - o3)), l3 = t4.pointCoordinate(n3);
            if (!l3) continue;
            const c3 = 1 / Math.hypot(l3[0] - this._camera.position[0], l3[1] - this._camera.position[1]);
            s3 += l3[3] * c3, r3 += c3;
          }
          return 0 === r3 ? NaN : s3 / r3;
        }
        get center() {
          return this._center;
        }
        set center(e3) {
          e3.lat === this._center.lat && e3.lng === this._center.lng || (this._unmodified = false, this._center = e3, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
        }
        _updateZoomFromElevation() {
          if (null == this._seaLevelZoom || !this._elevation || this.isUnderground) return;
          const e3 = this._seaLevelZoom, t4 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i3 = this.pixelsPerMeter / this.worldSize * t4, o3 = this._mercatorZfromZoom(e3), s3 = this._mercatorZfromZoom(this._maxZoom), r3 = Math.max(o3 - i3, s3);
          this._setZoom(this._zoomFromMercatorZ(r3));
        }
        get padding() {
          return this._edgeInsets.toJSON();
        }
        set padding(e3) {
          this._edgeInsets.equals(e3) || (this._unmodified = false, this._edgeInsets.interpolate(this._edgeInsets, e3, 1), this._calcMatrices());
        }
        computeZoomRelativeTo(t4) {
          const i3 = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, t4.toAltitude()));
          let o3;
          o3 = t4.z < this._camera.position[2] ? [i3.x, i3.y, i3.z] : [t4.x, t4.y, t4.z];
          const s3 = e2.a6.vec3.length(e2.a6.vec3.sub([], this._camera.position, o3));
          return e2.ap(this._zoomFromMercatorZ(s3), this._minZoom, this._maxZoom);
        }
        setFreeCameraOptions(t4) {
          if (!this.height) return;
          if (!t4.position && !t4.orientation) return;
          this._updateCameraState();
          let i3 = false;
          if (t4.orientation && !e2.a6.quat.exactEquals(t4.orientation, this._camera.orientation) && (i3 = this._setCameraOrientation(t4.orientation)), t4.position) {
            const o3 = [t4.position.x, t4.position.y, t4.position.z];
            e2.a6.vec3.exactEquals(o3, this._camera.position) || (this._setCameraPosition(o3), i3 = true);
          }
          i3 && (this._updateStateFromCamera(), this.recenterOnTerrain());
        }
        getFreeCameraOptions() {
          this._updateCameraState();
          const t4 = this._camera.position, i3 = new Ni();
          return i3.position = new e2.a5(t4[0], t4[1], t4[2]), i3.orientation = this._camera.orientation, i3._elevation = this.elevation, i3._renderWorldCopies = this.renderWorldCopies, i3;
        }
        _setCameraOrientation(t4) {
          if (!e2.a6.quat.length(t4)) return false;
          e2.a6.quat.normalize(t4, t4);
          const i3 = e2.a6.vec3.transformQuat([], [0, 0, -1], t4), o3 = e2.a6.vec3.transformQuat([], [0, -1, 0], t4);
          if (o3[2] < 0) return false;
          const s3 = ki(i3, o3);
          return !!s3 && (this._camera.orientation = s3, true);
        }
        _setCameraPosition(t4) {
          const i3 = this.zoomScale(this.minZoom) * this.tileSize, o3 = this.zoomScale(this.maxZoom) * this.tileSize, s3 = this.cameraToCenterDistance;
          t4[2] = e2.ap(t4[2], s3 / o3, s3 / i3), this._camera.position = t4;
        }
        get centerPoint() {
          return this._edgeInsets.getCenter(this.width, this.height);
        }
        get fovAboveCenter() {
          return this._fov * (0.5 + this.centerOffset.y / this.height);
        }
        get isUnderground() {
          return this.pitch > 90;
        }
        isPaddingEqual(e3) {
          return this._edgeInsets.equals(e3);
        }
        interpolatePadding(e3, t4, i3) {
          this._unmodified = false, this._edgeInsets.interpolate(e3, t4, i3), this._constrain(), this._calcMatrices();
        }
        coveringZoomLevel(e3) {
          const t4 = (e3.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e3.tileSize));
          return Math.max(0, t4);
        }
        getVisibleUnwrappedCoordinates(t4) {
          const i3 = [new e2.bN(0, t4)];
          if (this.renderWorldCopies) {
            const o3 = this.pointCoordinate(new e2.P(0, 0)), s3 = this.pointCoordinate(new e2.P(this.width, 0)), r3 = this.pointCoordinate(new e2.P(this.width, this.height)), a4 = this.pointCoordinate(new e2.P(0, this.height)), n3 = Math.floor(Math.min(o3.x, s3.x, r3.x, a4.x)), l3 = Math.floor(Math.max(o3.x, s3.x, r3.x, a4.x)), c3 = 1;
            for (let o4 = n3 - c3; o4 <= l3 + c3; o4++) 0 !== o4 && i3.push(new e2.bN(o4, t4));
          }
          return i3;
        }
        isLODDisabled(e3) {
          return (!e3 || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
        }
        extendTileCover(t4, i3, o3) {
          let s3 = [];
          const r3 = void 0 !== o3, a4 = !r3;
          if (a4 && this.zoom < i3) return s3;
          if (r3 && 0 === o3[0] && 0 === o3[1]) return s3;
          const n3 = /* @__PURE__ */ new Set(), l3 = (t5, i4, o4, r4, a5) => {
            const l4 = e2.c2(i4, t5, o4, r4, a5);
            n3.has(l4) || (s3.push(new e2.aA(t5, i4, o4, r4, a5)), n3.add(l4));
          };
          for (let e3 = 0; e3 < t4.length; e3++) {
            const s4 = t4[e3];
            if (a4 && s4.canonical.z !== i3) continue;
            const n4 = s4.canonical, c4 = s4.overscaledZ, h3 = s4.wrap, u4 = 1 << n4.z, d3 = n4.x + 1 < u4, _2 = n4.x > 0, p3 = n4.y + 1 < u4, f3 = n4.y > 0, m2 = s4.wrap - (_2 ? 0 : 1), g4 = s4.wrap + (d3 ? 0 : 1), v2 = _2 ? n4.x - 1 : u4 - 1, x2 = d3 ? n4.x + 1 : 0;
            if (r3) o3[0] < 0 ? (l3(c4, g4, n4.z, x2, n4.y), o3[1] < 0 && p3 && (l3(c4, h3, n4.z, n4.x, n4.y + 1), l3(c4, g4, n4.z, x2, n4.y + 1)), o3[1] > 0 && f3 && (l3(c4, h3, n4.z, n4.x, n4.y - 1), l3(c4, g4, n4.z, x2, n4.y - 1))) : o3[0] > 0 ? (l3(c4, m2, n4.z, v2, n4.y), o3[1] < 0 && p3 && (l3(c4, h3, n4.z, n4.x, n4.y + 1), l3(c4, m2, n4.z, v2, n4.y + 1)), o3[1] > 0 && f3 && (l3(c4, h3, n4.z, n4.x, n4.y - 1), l3(c4, m2, n4.z, v2, n4.y - 1))) : o3[1] < 0 && p3 ? l3(c4, h3, n4.z, n4.x, n4.y + 1) : f3 && l3(c4, h3, n4.z, n4.x, n4.y - 1);
            else {
              const e4 = s4.visibleQuadrants;
              1 & e4 && (l3(c4, m2, n4.z, v2, n4.y), f3 && (l3(c4, h3, n4.z, n4.x, n4.y - 1), l3(c4, m2, n4.z, v2, n4.y - 1))), 2 & e4 && (l3(c4, g4, n4.z, x2, n4.y), f3 && (l3(c4, h3, n4.z, n4.x, n4.y - 1), l3(c4, g4, n4.z, x2, n4.y - 1))), 4 & e4 && (l3(c4, m2, n4.z, v2, n4.y), p3 && (l3(c4, h3, n4.z, n4.x, n4.y + 1), l3(c4, m2, n4.z, v2, n4.y + 1))), 8 & e4 && (l3(c4, g4, n4.z, x2, n4.y), p3 && (l3(c4, h3, n4.z, n4.x, n4.y + 1), l3(c4, g4, n4.z, x2, n4.y + 1)));
            }
          }
          const c3 = [];
          for (const e3 of s3) s3.some((t5) => e3.isChildOf(t5)) || c3.push(e3);
          if (s3 = c3.filter((e3) => !t4.some((t5) => !!(e3.overscaledZ < i3 && t5.isChildOf(e3)) || e3.equals(t5) || e3.isChildOf(t5))), a4) {
            const e3 = 1 << i3, t5 = "globe" === this.projection.name ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), o4 = [e3 * t5.x, e3 * t5.y], r4 = 4, a5 = r4 * r4;
            s3 = s3.filter((e4) => {
              const t6 = e4.canonical.x + 0.5 - o4[0], i4 = e4.canonical.y + 0.5 - o4[1];
              return t6 * t6 + i4 * i4 < a5;
            });
          }
          return s3;
        }
        coveringTiles(t4) {
          let i3 = this.coveringZoomLevel(t4);
          const o3 = i3, s3 = this.elevation && this.elevation.exaggeration(), r3 = s3 && !t4.isTerrainDEM, a4 = "mercator" === this.projection.name;
          if (void 0 !== t4.minzoom && i3 < t4.minzoom) return [];
          void 0 !== t4.maxzoom && i3 > t4.maxzoom && (i3 = t4.maxzoom);
          const n3 = this.locationCoordinate(this.center), l3 = this.center.lat, c3 = 1 << i3, h3 = [c3 * n3.x, c3 * n3.y, 0], u4 = "globe" === this.projection.name, d3 = !u4, _2 = e2.bO.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i3, d3), p3 = u4 ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), f3 = c3 * e2.bE(1, this.center.lat), m2 = this._camera.position[2] / e2.bE(1, this.center.lat), g4 = [c3 * p3.x, c3 * p3.y, m2 * (d3 ? 1 : f3)], v2 = u4 || s3, x2 = this.cameraToCenterDistance / t4.tileSize * (t4.roundZoom ? 1 : 0.502), y2 = this.isLODDisabled(true) ? i3 : 0;
          let b2;
          if (this._elevation && t4.isTerrainDEM) b2 = 1e4 * this._elevation.exaggeration();
          else if (this._elevation) {
            const e3 = this._elevation.getMinMaxForVisibleTiles();
            b2 = e3 ? e3.max : this._centerAltitude;
          } else b2 = this._centerAltitude;
          const w2 = t4.isTerrainDEM ? -b2 : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, T3 = this.projection.isReprojectedInTileSpace ? e2.bP(this) : 1, E3 = (t5) => {
            const i4 = 1 / 4e4, o4 = new e2.a5(t5.x + i4, t5.y, t5.z), s4 = new e2.a5(t5.x, t5.y + i4, t5.z), r4 = t5.toLngLat(), a5 = o4.toLngLat(), n4 = s4.toLngLat(), l4 = this.locationCoordinate(r4), c4 = this.locationCoordinate(a5), h4 = this.locationCoordinate(n4), u5 = Math.hypot(c4.x - l4.x, c4.y - l4.y), d4 = Math.hypot(h4.x - l4.x, h4.y - l4.y);
            return Math.sqrt(u5 * d4) * T3 / i4;
          }, S2 = (t5) => {
            const i4 = b2, o4 = w2;
            return { aabb: e2.bS(this, c3, 0, 0, 0, t5, o4, i4, this.projection), zoom: 0, x: 0, y: 0, minZ: o4, maxZ: i4, wrap: t5, fullyVisible: false };
          }, C3 = [];
          let I3 = [];
          const D2 = i3, R3 = t4.reparseOverscaled ? o3 : i3, A3 = (m2 - this._centerAltitude) * f3, L3 = (e3) => {
            if (!this._elevation || !e3.tileID || !a4) return;
            const t5 = this._elevation.getMinMaxForTile(e3.tileID), i4 = e3.aabb;
            t5 ? (i4.min[2] = t5.min, i4.max[2] = t5.max, i4.center[2] = (i4.min[2] + i4.max[2]) / 2) : (e3.shouldSplit = M2(e3), e3.shouldSplit || (i4.min[2] = i4.max[2] = i4.center[2] = this._centerAltitude));
          }, P2 = (e3, t5) => {
            if (0.707 * t5 < e3) return 1;
            const i4 = t5 / e3;
            return i4 / (1.4144271570014144 + (Math.pow(1.1, i4 - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
          }, M2 = (t5) => {
            if (t5.zoom < y2) return true;
            if (t5.zoom === D2) return false;
            if (null != t5.shouldSplit) return t5.shouldSplit;
            const i4 = t5.aabb.distanceX(g4), s4 = t5.aabb.distanceY(g4);
            let n4 = A3, c4 = 1;
            if (u4) {
              n4 = t5.aabb.distanceZ(g4);
              const i5 = Math.pow(2, t5.zoom), o4 = e2.aN((t5.y + 1) / i5), s5 = e2.aN(t5.y / i5), r4 = Math.min(Math.max(l3, o4), s5), a5 = e2.c6(r4) / e2.c6(l3);
              if (c4 = r4 === l3 ? 1 / Math.max(1, this._mercatorScaleRatio - 0.3) : Math.min(1, a5 / this._mercatorScaleRatio), this.zoom <= e2.c3 && t5.zoom === D2 - 1 && a5 >= 0.9) return true;
            } else if (r3 && (n4 = t5.aabb.distanceZ(g4) * f3), this.projection.isReprojectedInTileSpace && o3 <= 5) {
              const i5 = Math.pow(2, t5.zoom), o4 = E3(new e2.a5((t5.x + 0.5) / i5, (t5.y + 0.5) / i5));
              c4 = o4 > 0.85 ? 1 : o4;
            }
            if (!a4) {
              const e3 = Math.sqrt(i4 * i4 + s4 * s4 + n4 * n4);
              let o4 = (1 << D2 - t5.zoom) * x2 * c4;
              return o4 *= P2(Math.max(n4, A3), e3), e3 < o4;
            }
            let d4 = Number.MAX_VALUE, _3 = 0;
            const p4 = t5.aabb.getCorners(), m3 = [];
            for (const t6 of p4) {
              e2.a6.vec3.sub(m3, t6, g4), u4 || (r3 ? m3[2] *= f3 : m3[2] = A3);
              const i5 = e2.a6.vec3.dot(m3, this._camera.forward());
              i5 < d4 && (d4 = i5, _3 = Math.abs(m3[2]));
            }
            let v3 = (1 << D2 - t5.zoom) * x2 * c4;
            if (v3 *= P2(Math.max(_3, A3), d4), d4 < v3) return true;
            const b3 = t5.aabb.closestPoint(h3);
            return b3[0] === h3[0] && b3[1] === h3[1];
          };
          if (this.renderWorldCopies) for (let e3 = 1; e3 <= 3; e3++) C3.push(S2(-e3)), C3.push(S2(e3));
          for (C3.push(S2(0)); C3.length > 0; ) {
            const o4 = C3.pop(), s4 = o4.x, n4 = o4.y;
            let l4 = o4.fullyVisible;
            const d4 = () => "globe" === this.projection.name && (0 === o4.y || o4.y === (1 << o4.zoom) - 1);
            if (!l4) {
              let t5 = v2 ? o4.aabb.intersects(_2) : o4.aabb.intersectsFlat(_2);
              if (0 === t5 && d4()) {
                const i4 = new e2.bQ(o4.zoom, s4, n4);
                t5 = e2.bR(this, c3, i4, true).intersects(_2);
              }
              if (0 === t5) continue;
              l4 = 2 === t5;
            }
            if (o4.zoom !== D2 && M2(o4)) for (let t5 = 0; t5 < 4; t5++) {
              const i4 = (s4 << 1) + t5 % 2, h4 = (n4 << 1) + (t5 >> 1), d5 = { aabb: a4 ? o4.aabb.quadrant(t5) : e2.bS(this, c3, o4.zoom + 1, i4, h4, o4.wrap, o4.minZ, o4.maxZ, this.projection), zoom: o4.zoom + 1, x: i4, y: h4, wrap: o4.wrap, fullyVisible: l4, tileID: void 0, shouldSplit: void 0, minZ: o4.minZ, maxZ: o4.maxZ };
              r3 && !u4 && (d5.tileID = new e2.aA(o4.zoom + 1 === D2 ? R3 : o4.zoom + 1, o4.wrap, o4.zoom + 1, i4, h4), L3(d5)), C3.push(d5);
            }
            else {
              const r4 = o4.zoom === D2 ? R3 : o4.zoom;
              if (t4.minzoom && t4.minzoom > r4) continue;
              let a5 = 0;
              if (!l4) {
                let i4 = v2 ? o4.aabb.intersectsPrecise(_2) : o4.aabb.intersectsPreciseFlat(_2);
                if (0 === i4 && d4()) {
                  const t5 = new e2.bQ(o4.zoom, s4, n4);
                  i4 = e2.bR(this, c3, t5, true).intersectsPrecise(_2);
                }
                if (0 === i4) continue;
                if (t4.calculateQuadrantVisibility) if (_2.containsPoint(o4.aabb.center)) a5 = 15;
                else for (let e3 = 0; e3 < 4; e3++) 0 !== o4.aabb.quadrant(e3).intersects(_2) && (a5 |= 1 << e3);
              }
              const u5 = h3[0] - (0.5 + s4 + (o4.wrap << o4.zoom)) * (1 << i3 - o4.zoom), p4 = h3[1] - 0.5 - n4, f4 = o4.tileID ? o4.tileID : new e2.aA(r4, o4.wrap, o4.zoom, s4, n4);
              t4.calculateQuadrantVisibility && (f4.visibleQuadrants = a5), I3.push({ tileID: f4, distanceSq: u5 * u5 + p4 * p4 });
            }
          }
          if (this.fogCullDistSq) {
            const i4 = this.fogCullDistSq, o4 = this.horizonLineFromTop();
            I3 = I3.filter((s4) => {
              const r4 = [0, 0, 0, 1], a5 = [e2.ab, e2.ab, 0, 1], n4 = this.calculateFogTileMatrix(s4.tileID.toUnwrapped());
              e2.a6.vec4.transformMat4(r4, r4, n4), e2.a6.vec4.transformMat4(a5, a5, n4);
              const l4 = e2.a6.vec4.min([], r4, a5), c4 = e2.a6.vec4.max([], r4, a5), h4 = e2.bT(l4, c4);
              if (0 === h4) return true;
              let u5 = false;
              const d4 = this._elevation;
              if (d4 && h4 > i4 && 0 !== o4) {
                const i5 = this.calculateProjMatrix(s4.tileID.toUnwrapped());
                let r5;
                t4.isTerrainDEM || (r5 = d4.getMinMaxForTile(s4.tileID)), r5 || (r5 = { min: w2, max: b2 });
                const a6 = e2.c4(this.rotation), n5 = [a6[0] * e2.ab, a6[1] * e2.ab, r5.max];
                e2.a6.vec3.transformMat4(n5, n5, i5), u5 = (1 - n5[1]) * this.height * 0.5 < o4;
              }
              return h4 < i4 || u5;
            });
          }
          return I3.sort((e3, t5) => e3.distanceSq - t5.distanceSq).map((e3) => e3.tileID);
        }
        resize(e3, t4) {
          this.width = e3, this.height = t4, this.pixelsToGLUnits = [2 / e3, -2 / t4], this._constrain(), this._calcMatrices();
        }
        get unmodified() {
          return this._unmodified;
        }
        zoomScale(e3) {
          return Math.pow(2, e3);
        }
        scaleZoom(e3) {
          return Math.log(e3) / Math.LN2;
        }
        project(t4) {
          const i3 = e2.ap(t4.lat, -e2.bU, e2.bU), o3 = this.projection.project(t4.lng, i3);
          return new e2.P(o3.x * this.worldSize, o3.y * this.worldSize);
        }
        unproject(e3) {
          return this.projection.unproject(e3.x / this.worldSize, e3.y / this.worldSize);
        }
        get point() {
          return this.project(this.center);
        }
        get pointMerc() {
          return this.point._div(this.worldSize);
        }
        get pixelsPerMeterRatio() {
          return this.pixelsPerMeter / e2.bE(1, this.center.lat) / this.worldSize;
        }
        setLocationAtPoint(t4, i3) {
          let o3, s3;
          const r3 = this.centerPoint;
          if ("globe" === this.projection.name) {
            const e3 = this.worldSize;
            o3 = (i3.x - r3.x) / e3, s3 = (i3.y - r3.y) / e3;
          } else {
            const e3 = this.pointCoordinate(i3), t5 = this.pointCoordinate(r3);
            o3 = e3.x - t5.x, s3 = e3.y - t5.y;
          }
          const a4 = this.locationCoordinate(t4);
          this.setLocation(new e2.a5(a4.x - o3, a4.y - s3));
        }
        setLocation(e3) {
          this.center = this.coordinateLocation(e3), this.projection.wrap && (this.center = this.center.wrap());
        }
        locationPoint(e3) {
          return this.projection.locationPoint(this, e3);
        }
        locationPoint3D(e3) {
          return this.projection.locationPoint(this, e3, true);
        }
        pointLocation(e3) {
          return this.coordinateLocation(this.pointCoordinate(e3));
        }
        pointLocation3D(e3) {
          return this.coordinateLocation(this.pointCoordinate3D(e3));
        }
        locationCoordinate(t4, i3) {
          const o3 = i3 ? e2.bE(i3, t4.lat) : void 0, s3 = this.projection.project(t4.lng, t4.lat);
          return new e2.a5(s3.x, s3.y, o3);
        }
        coordinateLocation(e3) {
          return this.projection.unproject(e3.x, e3.y);
        }
        pointRayIntersection(t4, i3) {
          const o3 = null != i3 ? i3 : this._centerAltitude, s3 = [t4.x, t4.y, 0, 1], r3 = [t4.x, t4.y, 1, 1];
          e2.a6.vec4.transformMat4(s3, s3, this.pixelMatrixInverse), e2.a6.vec4.transformMat4(r3, r3, this.pixelMatrixInverse);
          const a4 = r3[3];
          e2.a6.vec4.scale(s3, s3, 1 / s3[3]), e2.a6.vec4.scale(r3, r3, 1 / a4);
          const n3 = s3[2], l3 = r3[2];
          return { p0: s3, p1: r3, t: n3 === l3 ? 0 : (o3 - n3) / (l3 - n3) };
        }
        screenPointToMercatorRay(t4) {
          const i3 = [t4.x, t4.y, 0, 1], o3 = [t4.x, t4.y, 1, 1];
          return e2.a6.vec4.transformMat4(i3, i3, this.pixelMatrixInverse), e2.a6.vec4.transformMat4(o3, o3, this.pixelMatrixInverse), e2.a6.vec4.scale(i3, i3, 1 / i3[3]), e2.a6.vec4.scale(o3, o3, 1 / o3[3]), i3[2] = e2.bE(i3[2], this._center.lat) * this.worldSize, o3[2] = e2.bE(o3[2], this._center.lat) * this.worldSize, e2.a6.vec4.scale(i3, i3, 1 / this.worldSize), e2.a6.vec4.scale(o3, o3, 1 / this.worldSize), new e2.aj([i3[0], i3[1], i3[2]], e2.a6.vec3.normalize([], e2.a6.vec3.sub([], o3, i3)));
        }
        rayIntersectionCoordinate(t4) {
          const { p0: i3, p1: o3, t: s3 } = t4, r3 = e2.bE(i3[2], this._center.lat), a4 = e2.bE(o3[2], this._center.lat);
          return new e2.a5(e2.aa(i3[0], o3[0], s3) / this.worldSize, e2.aa(i3[1], o3[1], s3) / this.worldSize, e2.aa(r3, a4, s3));
        }
        pointCoordinate(e3, t4 = this._centerAltitude) {
          return this.projection.pointCoordinate(this, e3.x, e3.y, t4);
        }
        pointCoordinate3D(t4) {
          if (!this.elevation || this.isUnderground) return this.pointCoordinate(t4);
          let i3 = this.projection.pointCoordinate3D(this, t4.x, t4.y);
          if (i3) return new e2.a5(i3[0], i3[1], i3[2]);
          let o3 = 0, s3 = this.horizonLineFromTop();
          if (t4.y > s3) return this.pointCoordinate(t4);
          const r3 = 0.02 * s3, a4 = t4.clone();
          for (let t5 = 0; t5 < 10 && s3 - o3 > r3; t5++) {
            a4.y = e2.aa(o3, s3, 0.66);
            const t6 = this.projection.pointCoordinate3D(this, a4.x, a4.y);
            t6 ? (s3 = a4.y, i3 = t6) : o3 = a4.y;
          }
          return i3 ? new e2.a5(i3[0], i3[1], i3[2]) : this.pointCoordinate(t4);
        }
        isPointAboveHorizon(e3) {
          return this.projection.isPointAboveHorizon(this, e3);
        }
        isPointOnSurface(t4) {
          if (t4.y < 0 || t4.y > this.height || t4.x < 0 || t4.x > this.width) return false;
          if (this.elevation || this.zoom >= e2.bV) return !this.isPointAboveHorizon(t4);
          const i3 = this.pointCoordinate(t4);
          return i3.y >= 0 && i3.y <= 1;
        }
        _coordinatePoint(t4, i3) {
          const o3 = i3 && this.elevation ? this.elevation.getAtPointOrZero(t4, this._centerAltitude) : this._centerAltitude, s3 = [t4.x * this.worldSize, t4.y * this.worldSize, o3 + t4.toAltitude(), 1];
          return e2.a6.vec4.transformMat4(s3, s3, this.pixelMatrix), s3[3] > 0 ? new e2.P(s3[0] / s3[3], s3[1] / s3[3]) : new e2.P(Number.MAX_VALUE, Number.MAX_VALUE);
        }
        _getBoundsNonRectangular() {
          const { top: t4, left: i3 } = this._edgeInsets, o3 = this.height - this._edgeInsets.bottom, s3 = this.width - this._edgeInsets.right, r3 = this.pointLocation3D(new e2.P(i3, t4)), a4 = this.pointLocation3D(new e2.P(s3, t4)), n3 = this.pointLocation3D(new e2.P(s3, o3)), l3 = this.pointLocation3D(new e2.P(i3, o3));
          let c3 = Math.min(r3.lng, a4.lng, n3.lng, l3.lng), h3 = Math.max(r3.lng, a4.lng, n3.lng, l3.lng), u4 = Math.min(r3.lat, a4.lat, n3.lat, l3.lat), d3 = Math.max(r3.lat, a4.lat, n3.lat, l3.lat);
          const _2 = Math.pow(2, -this.zoom) / 16 * 270, p3 = "globe" === this.projection.name ? 1 : 4, f3 = (t5, i4, o4, s4, r4) => {
            const a5 = (t5 + o4) / 2, n4 = (i4 + s4) / 2, l4 = new e2.P(a5, n4), { lng: m2, lat: g4 } = this.pointLocation3D(l4), v2 = Math.max(0, c3 - m2, u4 - g4, m2 - h3, g4 - d3);
            c3 = Math.min(c3, m2), h3 = Math.max(h3, m2), u4 = Math.min(u4, g4), d3 = Math.max(d3, g4), (r4 < p3 || v2 > _2) && (f3(t5, i4, a5, n4, r4 + 1), f3(a5, n4, o4, s4, r4 + 1));
          };
          if (f3(i3, t4, s3, t4, 1), f3(s3, t4, s3, o3, 1), f3(s3, o3, i3, o3, 1), f3(i3, o3, i3, t4, 1), "globe" === this.projection.name) {
            const [t5, i4] = e2.bW(this);
            t5 ? (d3 = 90, h3 = 180, c3 = -180) : i4 && (u4 = -90, h3 = 180, c3 = -180);
          }
          return new e2.as(new e2.bL(c3, u4), new e2.bL(h3, d3));
        }
        _getBoundsRectangular(t4, i3) {
          const { top: o3, left: s3 } = this._edgeInsets, r3 = this.height - this._edgeInsets.bottom, a4 = this.width - this._edgeInsets.right, n3 = new e2.P(s3, o3), l3 = new e2.P(a4, o3), c3 = new e2.P(a4, r3), h3 = new e2.P(s3, r3);
          let u4 = this.pointCoordinate(n3, t4), d3 = this.pointCoordinate(l3, t4);
          const _2 = this.pointCoordinate(c3, i3), p3 = this.pointCoordinate(h3, i3), f3 = (e3, t5) => (t5.y - e3.y) / (t5.x - e3.x);
          return u4.y > 1 && d3.y >= 0 ? u4 = new e2.a5((1 - p3.y) / f3(p3, u4) + p3.x, 1) : u4.y < 0 && d3.y <= 1 && (u4 = new e2.a5(-p3.y / f3(p3, u4) + p3.x, 0)), d3.y > 1 && u4.y >= 0 ? d3 = new e2.a5((1 - _2.y) / f3(_2, d3) + _2.x, 1) : d3.y < 0 && u4.y <= 1 && (d3 = new e2.a5(-_2.y / f3(_2, d3) + _2.x, 0)), new e2.as().extend(this.coordinateLocation(u4)).extend(this.coordinateLocation(d3)).extend(this.coordinateLocation(p3)).extend(this.coordinateLocation(_2));
        }
        _getBoundsRectangularTerrain() {
          const e3 = this.elevation;
          if (!e3.visibleDemTiles.length || e3.isUsingMockSource()) return this._getBoundsRectangular(0, 0);
          const t4 = e3.visibleDemTiles.reduce((e4, t5) => {
            if (t5.dem) {
              const i3 = t5.dem.tree;
              e4.min = Math.min(e4.min, i3.minimums[0]), e4.max = Math.max(e4.max, i3.maximums[0]);
            }
            return e4;
          }, { min: Number.MAX_VALUE, max: 0 });
          return this._getBoundsRectangular(t4.min * e3.exaggeration(), t4.max * e3.exaggeration());
        }
        getBounds() {
          return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
        }
        horizonLineFromTop(e3 = true) {
          const t4 = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, 0.1)) - this.centerOffset.y, i3 = this.height / 2 - t4 * (1 - this._horizonShift);
          return e3 ? Math.max(0, i3) : i3;
        }
        getMaxBounds() {
          return this.maxBounds;
        }
        setMaxBounds(t4) {
          this.maxBounds = t4, this.minLat = -e2.bU, this.maxLat = e2.bU, this.minLng = -180, this.maxLng = 180, t4 && (this.minLat = t4.getSouth(), this.maxLat = t4.getNorth(), this.minLng = t4.getWest(), this.maxLng = t4.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = e2.am(this.minLng) * this.tileSize, this.worldMaxX = e2.am(this.maxLng) * this.tileSize, this.worldMinY = e2.at(this.maxLat) * this.tileSize, this.worldMaxY = e2.at(this.minLat) * this.tileSize, this._constrain();
        }
        calculatePosMatrix(e3, t4) {
          return this.projection.createTileMatrix(this, t4, e3);
        }
        calculateDistanceTileData(t4) {
          const i3 = t4.key, o3 = this._distanceTileDataCache;
          if (o3[i3]) return o3[i3];
          const s3 = t4.canonical, r3 = 1 / this.height, a4 = this.cameraWorldSize, n3 = a4 / this.zoomScale(s3.z), l3 = (s3.x + Math.pow(2, s3.z) * t4.wrap) * n3, c3 = s3.y * n3, h3 = this.point;
          h3.x *= a4 / this.worldSize, h3.y *= a4 / this.worldSize;
          const u4 = this.angle, d3 = Math.sin(-u4), _2 = -Math.cos(-u4);
          return o3[i3] = { bearing: [d3, _2], center: [(h3.x - l3) * r3, (h3.y - c3) * r3], scale: n3 / e2.ab * r3 }, o3[i3];
        }
        calculateFogTileMatrix(t4) {
          const i3 = t4.key, o3 = this._fogTileMatrixCache;
          if (o3[i3]) return o3[i3];
          const s3 = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, t4);
          return e2.a6.mat4.multiply(s3, this.worldToFogMatrix, s3), o3[i3] = new Float32Array(s3), o3[i3];
        }
        calculateProjMatrix(t4, i3 = false, o3 = false) {
          const s3 = t4.key;
          let r3;
          if (r3 = o3 ? this._expandedProjMatrixCache : i3 ? this._alignedProjMatrixCache : this._projMatrixCache, r3[s3]) return r3[s3];
          const a4 = this.calculatePosMatrix(t4, this.worldSize);
          let n3;
          return n3 = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : o3 ? this.expandedFarZProjMatrix : i3 ? this.alignedProjMatrix : this.projMatrix, e2.a6.mat4.multiply(a4, n3, a4), r3[s3] = new Float32Array(a4), r3[s3];
        }
        calculatePixelsToTileUnitsMatrix(t4) {
          const i3 = t4.tileID.key, o3 = this._pixelsToTileUnitsCache;
          if (o3[i3]) return o3[i3];
          const s3 = e2.bX(t4, this);
          return o3[i3] = s3, o3[i3];
        }
        customLayerMatrix() {
          return this.mercatorMatrix.slice();
        }
        globeToMercatorMatrix() {
          if ("globe" === this.projection.name) {
            const t4 = 1 / this.worldSize, i3 = e2.a6.mat4.fromScaling([], [t4, t4, t4]);
            return e2.a6.mat4.multiply(i3, i3, this.globeMatrix), i3;
          }
        }
        recenterOnTerrain() {
          if (!this._elevation || "globe" === this.projection.name || this.isUnderground) return;
          const t4 = this._elevation;
          this._updateCameraState();
          const i3 = e2.bE(1, this._center.lat) * this.worldSize, o3 = this._computeCameraPosition(i3), s3 = this._camera.forward(), r3 = e2.bE(1, this._center.lat);
          o3[2] /= r3, s3[2] /= r3, e2.a6.vec3.normalize(s3, s3);
          const a4 = t4.raycast(o3, s3, t4.exaggeration());
          if (a4) {
            const t5 = e2.a6.vec3.scaleAndAdd([], o3, s3, a4), i4 = new e2.a5(t5[0], t5[1], e2.bE(t5[2], e2.aN(t5[1]))), n3 = (i4.z + e2.a6.vec3.length([i4.x - o3[0], i4.y - o3[1], i4.z - o3[2] * r3])) * this._pixelsPerMercatorPixel;
            this._seaLevelZoom = this._zoomFromMercatorZ(n3), this._centerAltitude = i4.toAltitude(), this._center = this.coordinateLocation(i4), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
          }
        }
        _constrainCamera(t4 = false) {
          if (!this._elevation || this.isUnderground) return;
          const i3 = this._elevation, o3 = e2.bE(1, this._center.lat) * this.worldSize, s3 = this._computeCameraPosition(o3), r3 = i3.getAtPointOrZero(new e2.a5(...s3)), a4 = this.pixelsPerMeter / this.worldSize * r3, n3 = this._minimumHeightOverTerrain(), l3 = s3[2] - a4;
          if (l3 <= n3) if (l3 < 0 || t4) {
            const t5 = this.locationCoordinate(this._center, this._centerAltitude), i4 = [s3[0], s3[1], t5.z - s3[2]], o4 = e2.a6.vec3.length(i4);
            i4[2] -= (n3 - l3) / this._pixelsPerMercatorPixel;
            const r4 = e2.a6.vec3.length(i4);
            if (0 === r4) return;
            e2.a6.vec3.scale(i4, i4, o4 / r4 * this._pixelsPerMercatorPixel), this._camera.position = [s3[0], s3[1], t5.z * this._pixelsPerMercatorPixel - i4[2]], this._updateStateFromCamera();
          } else this._isCameraConstrained = true;
        }
        _constrain() {
          if (!this.center || !this.width || !this.height || this._constraining) return;
          this._constraining = true;
          const t4 = "globe" === this.projection.name || this.mercatorFromTransition;
          if (this.projection.isReprojectedInTileSpace || t4) {
            const i4 = this.center;
            return i4.lat = e2.ap(i4.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !t4) && (i4.lng = e2.ap(i4.lng, this.minLng, this.maxLng)), this.center = i4, void (this._constraining = false);
          }
          const i3 = this._unmodified, { x: o3, y: s3 } = this.point;
          let r3 = 0, a4 = o3, n3 = s3;
          const l3 = this.width / 2, c3 = this.height / 2, h3 = this.worldMinY * this.scale, u4 = this.worldMaxY * this.scale;
          if (s3 - c3 < h3 && (n3 = h3 + c3), s3 + c3 > u4 && (n3 = u4 - c3), u4 - h3 < this.height && (r3 = Math.max(r3, this.height / (u4 - h3)), n3 = (u4 + h3) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
            const e3 = this.worldMinX * this.scale, t5 = this.worldMaxX * this.scale, i4 = this.worldSize / 2 - (e3 + t5) / 2;
            a4 = (o3 + i4 + this.worldSize) % this.worldSize - i4, a4 - l3 < e3 && (a4 = e3 + l3), a4 + l3 > t5 && (a4 = t5 - l3), t5 - e3 < this.width && (r3 = Math.max(r3, this.width / (t5 - e3)), a4 = (t5 + e3) / 2);
          }
          a4 === o3 && n3 === s3 || (this.center = this.unproject(new e2.P(a4, n3))), r3 && (this.zoom += this.scaleZoom(r3)), this._constrainCamera(), this._unmodified = i3, this._constraining = false;
        }
        _minZoomForBounds() {
          let e3 = Math.max(0, this.scaleZoom(this.height / (this.worldMaxY - this.worldMinY)));
          return this.maxBounds && (e3 = Math.max(e3, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e3;
        }
        _maxCameraBoundsDistance() {
          return this._mercatorZfromZoom(this._minZoomForBounds());
        }
        _calcMatrices() {
          if (!this.height) return;
          const t4 = this.centerOffset, i3 = "globe" === this.projection.name, o3 = this.pixelsPerMeter;
          "globe" === this.projection.name && (this._mercatorScaleRatio = e2.bE(1, this.center.lat) / e2.bE(1, e2.c5));
          const s3 = e2.bY(this.projection, this.zoom, this.width, this.height, 1024);
          this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, s3), this.cameraToCenterDistance = 0.5 / Math.tan(0.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
          const r3 = "meters" === this.projection.zAxisUnit ? o3 : 1, a4 = this._camera.getWorldToCamera(this.worldSize, r3);
          let n3;
          const l3 = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
          if (l3[8] = 2 * -t4.x / this.width, l3[9] = 2 * t4.y / this.height, this.isOrthographic) {
            let e3 = 0.5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(0.5 * this._fov), i4 = e3 * this.aspect, o4 = -i4, s4 = -e3;
            i4 -= t4.x, o4 -= t4.x, e3 += t4.y, s4 += t4.y, n3 = this._camera.getCameraToClipOrthographic(o4, i4, s4, e3, this._nearZ, this._farZ), ((e4, t5, i5, o5) => {
              for (let s5 = 0; s5 < 16; s5++) e4[s5] = ji(t5[s5], i5[s5], o5);
            })(n3, n3, l3, Hi(this.pitch >= 15 ? 1 : this.pitch / 15));
          } else n3 = l3;
          const c3 = e2.a6.mat4.mul([], l3, a4);
          let h3 = e2.a6.mat4.mul([], n3, a4);
          if (this.projection.isReprojectedInTileSpace) {
            const t5 = this.locationCoordinate(this.center), i4 = e2.a6.mat4.identity([]);
            e2.a6.mat4.translate(i4, i4, [t5.x * this.worldSize, t5.y * this.worldSize, 0]), e2.a6.mat4.multiply(i4, i4, e2.bZ(this)), e2.a6.mat4.translate(i4, i4, [-t5.x * this.worldSize, -t5.y * this.worldSize, 0]), e2.a6.mat4.multiply(h3, h3, i4), e2.a6.mat4.multiply(c3, c3, i4), this.inverseAdjustmentMatrix = e2.b_(this);
          } else this.inverseAdjustmentMatrix = [1, 0, 0, 1];
          if (this.mercatorMatrix = e2.a6.mat4.scale([], h3, [this.worldSize, this.worldSize, this.worldSize / r3, 1]), this.projMatrix = h3, this.invProjMatrix = e2.a6.mat4.invert(new Float64Array(16), this.projMatrix), i3) {
            const i4 = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
            i4[8] = 2 * -t4.x / this.width, i4[9] = 2 * t4.y / this.height, this.expandedFarZProjMatrix = e2.a6.mat4.mul([], i4, a4);
          } else this.expandedFarZProjMatrix = this.projMatrix;
          const u4 = e2.a6.mat4.invert([], n3);
          this.frustumCorners = e2.b$.fromInvProjectionMatrix(u4, this.horizonLineFromTop(), this.height), this.cameraFrustum = e2.bO.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, 0, !i3);
          const d3 = new Float32Array(16);
          e2.a6.mat4.identity(d3), e2.a6.mat4.scale(d3, d3, [1, -1, 1]), e2.a6.mat4.rotateX(d3, d3, this._pitch), e2.a6.mat4.rotateZ(d3, d3, this.angle);
          const _2 = e2.a6.mat4.perspective(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ);
          this.starsProjMatrix = e2.a6.mat4.clone(_2);
          const p3 = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
          _2[8] = 2 * -t4.x / this.width, _2[9] = 2 * (t4.y + p3) / this.height, this.skyboxMatrix = e2.a6.mat4.multiply(d3, _2, d3);
          const f3 = this.point, m2 = f3.x, g4 = f3.y, v2 = this.width % 2 / 2, x2 = this.height % 2 / 2, y2 = Math.cos(this.angle), b2 = Math.sin(this.angle), w2 = m2 - Math.round(m2) + y2 * v2 + b2 * x2, T3 = g4 - Math.round(g4) + y2 * x2 + b2 * v2, E3 = new Float64Array(h3);
          if (e2.a6.mat4.translate(E3, E3, [w2 > 0.5 ? w2 - 1 : w2, T3 > 0.5 ? T3 - 1 : T3, 0]), this.alignedProjMatrix = E3, h3 = e2.a6.mat4.create(), e2.a6.mat4.scale(h3, h3, [this.width / 2, -this.height / 2, 1]), e2.a6.mat4.translate(h3, h3, [1, -1, 0]), this.labelPlaneMatrix = h3, h3 = e2.a6.mat4.create(), e2.a6.mat4.scale(h3, h3, [1, -1, 1]), e2.a6.mat4.translate(h3, h3, [-1, -1, 0]), e2.a6.mat4.scale(h3, h3, [2 / this.width, 2 / this.height, 1]), this.glCoordMatrix = h3, this.pixelMatrix = e2.a6.mat4.multiply(new Float64Array(16), this.labelPlaneMatrix, c3), this._calcFogMatrices(), this._distanceTileDataCache = {}, h3 = e2.a6.mat4.invert(new Float64Array(16), this.pixelMatrix), !h3) throw new Error("failed to invert matrix");
          if (this.pixelMatrixInverse = h3, "globe" === this.projection.name || this.mercatorFromTransition) {
            this.globeMatrix = e2.c0(this);
            const t5 = [this.globeMatrix[12], this.globeMatrix[13], this.globeMatrix[14]];
            this.globeCenterInViewSpace = e2.a6.vec3.transformMat4(t5, t5, a4), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
          } else this.globeMatrix = h3;
          this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {}, this._expandedProjMatrixCache = {};
        }
        _calcFogMatrices() {
          this._fogTileMatrixCache = {};
          const t4 = this.cameraWorldSizeForFog, i3 = this.cameraPixelsPerMeter, o3 = this._camera.position, s3 = 1 / this.height / this._pixelsPerMercatorPixel, r3 = [t4, t4, i3];
          e2.a6.vec3.scale(r3, r3, s3), e2.a6.vec3.scale(o3, o3, -1), e2.a6.vec3.multiply(o3, o3, r3);
          const a4 = e2.a6.mat4.create();
          e2.a6.mat4.translate(a4, a4, o3), e2.a6.mat4.scale(a4, a4, r3), this.mercatorFogMatrix = a4, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(t4, i3, s3);
        }
        _computeCameraPosition(e3) {
          const t4 = (e3 = e3 || this.pixelsPerMeter) / this.pixelsPerMeter, i3 = this._camera.forward(), o3 = this.point, s3 = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t4 - e3 / this.worldSize * this._centerAltitude;
          return [o3.x / this.worldSize - i3[0] * s3, o3.y / this.worldSize - i3[1] * s3, e3 / this.worldSize * this._centerAltitude - i3[2] * s3];
        }
        _updateCameraState() {
          this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
        }
        _translateCameraConstrained(t4) {
          const i3 = this._maxCameraBoundsDistance(), o3 = Math.abs(i3 * Math.cos(this._pitch)), s3 = this._camera.position[2], r3 = t4[2];
          let a4 = 1;
          this.projection.wrap && (this.center = this.center.wrap()), r3 > 0 && (a4 = Math.min((o3 - s3) / r3, 1)), this._camera.position = e2.a6.vec3.scaleAndAdd([], this._camera.position, t4, a4), this._updateStateFromCamera();
        }
        _updateStateFromCamera() {
          const t4 = this._camera.position, i3 = this._camera.forward(), { pitch: o3, bearing: s3 } = this._camera.getPitchBearing(), r3 = e2.bE(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, a4 = this._mercatorZfromZoom(this._maxZoom) * Math.cos(e2.bC(this._maxPitch)), n3 = Math.max((t4[2] - r3) / Math.cos(o3), a4), l3 = this._zoomFromMercatorZ(n3);
          e2.a6.vec3.scaleAndAdd(t4, t4, i3, n3), this._pitch = e2.ap(o3, e2.bC(this.minPitch), e2.bC(this.maxPitch)), this.angle = e2.bB(s3, -Math.PI, Math.PI), this._setZoom(e2.ap(l3, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new e2.a5(t4[0], t4[1], t4[2])), this._unmodified = false, this._constrain(), this._calcMatrices();
        }
        _worldSizeFromZoom(e3) {
          return Math.pow(2, e3) * this.tileSize;
        }
        _mercatorZfromZoom(e3) {
          return this.cameraToCenterDistance / this._worldSizeFromZoom(e3);
        }
        _minimumHeightOverTerrain() {
          const e3 = Math.min(null != this._seaLevelZoom ? this._seaLevelZoom : this._zoom, this._maxZoom) + 4;
          return this._mercatorZfromZoom(e3);
        }
        _zoomFromMercatorZ(e3) {
          return this.scaleZoom(this.cameraToCenterDistance / (e3 * this.tileSize));
        }
        zoomFromMercatorZAdjusted(t4) {
          let i3 = 0, o3 = e2.bV, s3 = 0, r3 = 1 / 0;
          for (; o3 - i3 > 1e-6 && o3 > i3; ) {
            const e3 = i3 + 0.5 * (o3 - i3), a4 = this.tileSize * Math.pow(2, e3), n3 = this.getCameraToCenterDistance(this.projection, e3, a4), l3 = this.scaleZoom(n3 / (t4 * this.tileSize)), c3 = Math.abs(e3 - l3);
            c3 < r3 && (r3 = c3, s3 = e3), e3 < l3 ? i3 = e3 : o3 = e3;
          }
          return s3;
        }
        _terrainEnabled() {
          return !(!this._elevation || !this.projection.supportsTerrain && (e2.w("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
        }
        anyCornerOffEdge(t4, i3) {
          const o3 = Math.min(t4.x, i3.x), s3 = Math.max(t4.x, i3.x), r3 = Math.min(t4.y, i3.y), a4 = Math.max(t4.y, i3.y);
          if (r3 < this.horizonLineFromTop(false)) return true;
          if ("mercator" !== this.projection.name) return false;
          const n3 = [new e2.P(o3, r3), new e2.P(s3, a4), new e2.P(o3, a4), new e2.P(s3, r3)], l3 = this.renderWorldCopies ? -3 : 0, c3 = this.renderWorldCopies ? 4 : 1;
          for (const e3 of n3) {
            const t5 = this.pointRayIntersection(e3);
            if (t5.t < 0) return true;
            const i4 = this.rayIntersectionCoordinate(t5);
            if (i4.x < l3 || i4.y < 0 || i4.x > c3 || i4.y > 1) return true;
          }
          return false;
        }
        isHorizonVisible() {
          return this.pitch + e2.c1(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new e2.P(0, 0), new e2.P(this.width, this.height));
        }
        zoomDeltaToMovement(t4, i3) {
          const o3 = e2.a6.vec3.length(e2.a6.vec3.sub([], this._camera.position, t4)), s3 = this._zoomFromMercatorZ(o3) + i3;
          return o3 - this._mercatorZfromZoom(s3);
        }
        getCameraPoint() {
          if ("globe" === this.projection.name) {
            const t4 = function([t5, i3, o3], s3) {
              const r3 = [t5, i3, o3, 1];
              e2.a6.vec4.transformMat4(r3, r3, s3);
              const a4 = r3[3] = Math.max(r3[3], 1e-6);
              return r3[0] /= a4, r3[1] /= a4, r3[2] /= a4, r3;
            }([this.globeMatrix[12], this.globeMatrix[13], this.globeMatrix[14]], this.pixelMatrix);
            return new e2.P(t4[0], t4[1]);
          }
          {
            const t4 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
            return this.centerPoint.add(new e2.P(0, t4));
          }
        }
        getCameraToCenterDistance(t4, i3 = this.zoom, o3 = this.worldSize) {
          const s3 = e2.bY(t4, i3, this.width, this.height, 1024), r3 = t4.pixelSpaceConversion(this.center.lat, o3, s3);
          let a4 = 0.5 / Math.tan(0.5 * this._fov) * this.height * r3;
          return this.isOrthographic && (a4 = ji(1, a4, Hi(this.pitch >= 15 ? 1 : this.pitch / 15))), a4;
        }
        getWorldToCameraMatrix() {
          const t4 = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? this.pixelsPerMeter : 1);
          return "globe" === this.projection.name && e2.a6.mat4.multiply(t4, t4, this.globeMatrix), t4;
        }
        getFrustum(t4) {
          return e2.bO.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, t4, "meters" === this.projection.zAxisUnit);
        }
      }
      const qi = (t4, i3) => {
        if (i3 > 0 && t4.terrain && e2.w("Cutoff is currently disabled on terrain"), i3 <= 0 || t4.terrain) return { shouldRenderCutoff: false, uniformValues: { u_cutoff_params: [0, 0, 0, 1] } };
        const o3 = t4.transform, s3 = Math.max(Math.abs(o3._zoom - (t4.minCutoffZoom - 1)), 1), r3 = o3.isLODDisabled(false) ? e2.a7(60, 45, o3.pitch) : e2.a7(30, 15, o3.pitch), a4 = o3._farZ - o3._nearZ, n3 = i3 * o3.height, l3 = ((1 - (c3 = r3)) * o3.cameraToCenterDistance + c3 * (o3._farZ + n3)) * s3;
        var c3;
        return { shouldRenderCutoff: r3 < 1, uniformValues: { u_cutoff_params: [o3._nearZ, o3._farZ, (l3 - o3._nearZ) / a4, (l3 - n3 - o3._nearZ) / a4] } };
      }, Wi = { cascadeCount: 2, normalOffset: 3, shadowMapResolution: 2048 };
      class $i {
        constructor(e3, t4) {
          this.aabb = e3, this.lastCascade = t4;
        }
      }
      class Xi {
        add(e3, t4) {
          const i3 = this.receivers[e3.key];
          void 0 !== i3 ? (i3.aabb.min[0] = Math.min(i3.aabb.min[0], t4.min[0]), i3.aabb.min[1] = Math.min(i3.aabb.min[1], t4.min[1]), i3.aabb.min[2] = Math.min(i3.aabb.min[2], t4.min[2]), i3.aabb.max[0] = Math.max(i3.aabb.max[0], t4.max[0]), i3.aabb.max[1] = Math.max(i3.aabb.max[1], t4.max[1]), i3.aabb.max[2] = Math.max(i3.aabb.max[2], t4.max[2])) : this.receivers[e3.key] = new $i(t4, null);
        }
        clear() {
          this.receivers = {};
        }
        get(e3) {
          return this.receivers[e3.key];
        }
        computeRequiredCascades(t4, i3, o3) {
          const s3 = e2.ca.fromPoints(t4.points);
          let r3 = 0;
          for (const t5 in this.receivers) {
            const a4 = this.receivers[t5];
            if (!a4) continue;
            if (!s3.intersectsAabb(a4.aabb)) continue;
            a4.aabb.min = s3.closestPoint(a4.aabb.min), a4.aabb.max = s3.closestPoint(a4.aabb.max);
            const n3 = a4.aabb.getCorners();
            for (let t6 = 0; t6 < o3.length; t6++) {
              let s4 = true;
              for (const r4 of n3) {
                const a5 = [r4[0] * i3, r4[1] * i3, r4[2]];
                if (e2.a6.vec3.transformMat4(a5, a5, o3[t6].matrix), a5[0] < -1 || a5[0] > 1 || a5[1] < -1 || a5[1] > 1) {
                  s4 = false;
                  break;
                }
              }
              if (a4.lastCascade = t6, r3 = Math.max(r3, t6), s4) break;
            }
          }
          return r3 + 1;
        }
      }
      class Ji {
        constructor(e3) {
          this.painter = e3, this._enabled = false, this._shadowLayerCount = 0, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new Xi(), this._depthMode = new Ai(e3.context.gl.LEQUAL, Ai.ReadWrite, [0, 1]), this._uniformValues = { u_light_matrix_0: new Float32Array(16), u_light_matrix_1: new Float32Array(16), u_shadow_intensity: 0, u_fade_range: [0, 0], u_shadow_normal_offset: [1, 1, 1], u_shadow_texel_size: 1, u_shadow_map_resolution: 1, u_shadow_direction: [0, 0, 1], u_shadow_bias: [36e-5, 12e-4, 0.012], u_shadowmap_0: 0, u_shadowmap_1: 0 }, this._forceDisable = false, this.useNormalOffset = false, e3.tp.registerParameter(this, ["Shadows"], "_forceDisable", { label: "forceDisable" }, () => {
            this.painter.style.map.triggerRepaint();
          }), e3.tp.registerParameter(Wi, ["Shadows"], "cascadeCount", { min: 1, max: 2, step: 1 }), e3.tp.registerParameter(Wi, ["Shadows"], "normalOffset", { min: 0, max: 10, step: 0.05 }), e3.tp.registerParameter(Wi, ["Shadows"], "shadowMapResolution", { min: 32, max: 2048, step: 32 }), e3.tp.registerBinding(this, ["Shadows"], "_numCascadesToRender", { readonly: true, label: "numCascadesToRender" });
        }
        destroy() {
          for (const e3 of this._cascades) e3.texture.destroy(), e3.framebuffer.destroy();
          this._cascades = [];
        }
        updateShadowParameters(t4, i3) {
          const o3 = this.painter;
          if (this._enabled = false, this._shadowLayerCount = 0, this._receivers.clear(), !i3 || !i3.properties) return;
          const s3 = i3.properties.get("shadow-intensity");
          if (!i3.shadowsEnabled() || s3 <= 0) return;
          if (this._shadowLayerCount = o3.style.order.reduce((e3, i4) => {
            const s4 = o3.style._mergedLayers[i4];
            return e3 + (s4.hasShadowPass() && !s4.isHidden(t4.zoom) ? 1 : 0);
          }, 0), this._enabled = this._shadowLayerCount > 0, !this.enabled) return;
          const r3 = o3.context, a4 = Wi.shadowMapResolution, n3 = Wi.shadowMapResolution;
          if (0 === this._cascades.length || Wi.shadowMapResolution !== this._cascades[0].texture.size[0]) {
            this._cascades = [];
            for (let t5 = 0; t5 < Wi.cascadeCount; ++t5) {
              const t6 = o3._shadowMapDebug, i4 = r3.gl, s4 = r3.createFramebuffer(a4, n3, t6, "texture"), l4 = new e2.T(r3, { width: a4, height: n3, data: null }, i4.DEPTH_COMPONENT16);
              if (s4.depthAttachment.set(l4.texture), t6) {
                const t7 = new e2.T(r3, { width: a4, height: n3, data: null }, i4.RGBA8);
                s4.colorAttachment.set(t7.texture);
              }
              this._cascades.push({ framebuffer: s4, texture: l4, matrix: [], far: 0, boundingSphereRadius: 0, frustum: new e2.bO(), scale: 0 });
            }
          }
          this.shadowDirection = Yi(i3);
          let l3 = 0;
          if (t4.elevation) {
            const e3 = t4.elevation, i4 = [1e4, -1e4];
            e3.visibleDemTiles.filter((e4) => e4.dem).forEach((e4) => {
              const t5 = e4.dem.tree;
              i4[0] = Math.min(i4[0], t5.minimums[0]), i4[1] = Math.max(i4[1], t5.maximums[0]);
            }), 1e4 !== i4[0] && (l3 = (i4[1] - i4[0]) * e3.exaggeration());
          }
          const c3 = 1.5 * t4.cameraToCenterDistance, h3 = 3 * c3, u4 = new Float64Array(16);
          for (let i4 = 0; i4 < this._cascades.length; ++i4) {
            const o4 = this._cascades[i4];
            let s4 = t4.height / 50, r4 = 1;
            1 === Wi.cascadeCount ? r4 = h3 : 0 === i4 ? r4 = c3 : (s4 = c3, r4 = h3);
            const [a5, n4] = eo(t4, this.shadowDirection, s4, r4, Wi.shadowMapResolution, l3);
            o4.scale = t4.scale, o4.matrix = a5, o4.boundingSphereRadius = n4, e2.a6.mat4.invert(u4, o4.matrix), o4.frustum = e2.bO.fromInvProjectionMatrix(u4, 1, 0, true), o4.far = r4;
          }
          const d3 = this._cascades.length - 1;
          this._uniformValues.u_fade_range = [0.75 * this._cascades[d3].far, this._cascades[d3].far], this._uniformValues.u_shadow_intensity = s3, this._uniformValues.u_shadow_direction = [this.shadowDirection[0], this.shadowDirection[1], this.shadowDirection[2]], this._uniformValues.u_shadow_texel_size = 1 / Wi.shadowMapResolution, this._uniformValues.u_shadow_map_resolution = Wi.shadowMapResolution, this._uniformValues.u_shadowmap_0 = Gi.ShadowMap0, this._uniformValues.u_shadowmap_1 = Gi.ShadowMap0 + 1, this._groundShadowTiles = o3.transform.coveringTiles({ tileSize: 512, renderWorldCopies: true });
          const _2 = o3.transform.elevation;
          for (const e3 of this._groundShadowTiles) {
            let t5 = { min: 0, max: 0 };
            if (_2) {
              const i4 = _2.getMinMaxForTile(e3);
              i4 && (t5 = i4);
            }
            this.addShadowReceiver(e3.toUnwrapped(), t5.min, t5.max);
          }
        }
        get enabled() {
          return this._enabled && !this._forceDisable;
        }
        set enabled(e3) {
          this._enabled = e3;
        }
        drawShadowPass(t4, i3) {
          if (!this.enabled) return;
          const o3 = this.painter, s3 = o3.context;
          this._numCascadesToRender = this._receivers.computeRequiredCascades(o3.transform.getFrustum(0), o3.transform.worldSize, this._cascades), s3.viewport.set([0, 0, Wi.shadowMapResolution, Wi.shadowMapResolution]);
          for (let r3 = 0; r3 < this._numCascadesToRender; ++r3) {
            o3.currentShadowCascade = r3, s3.bindFramebuffer.set(this._cascades[r3].framebuffer.framebuffer), s3.clear({ color: e2.bA.white, depth: 1 });
            for (const e3 of t4.order) {
              const s4 = t4._mergedLayers[e3];
              if (!s4.hasShadowPass() || s4.isHidden(o3.transform.zoom)) continue;
              const r4 = t4.getLayerSourceCache(s4), a4 = r4 ? i3[r4.id] : void 0;
              ("model" === s4.type || a4 && a4.length) && o3.renderLayer(o3, r4, s4, "ground", a4);
            }
          }
          o3.currentShadowCascade = 0;
        }
        drawGroundShadows() {
          if (!this.enabled) return;
          const e3 = this.painter, t4 = e3.style, i3 = e3.context, o3 = t4.directionalLight, s3 = t4.ambientLight;
          if (!o3 || !s3) return;
          const r3 = [], a4 = qi(e3, e3.longestCutoffRange);
          a4.shouldRenderCutoff && r3.push("RENDER_CUTOFF"), r3.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), this.useNormalOffset && r3.push("NORMAL_OFFSET");
          const n3 = Qi(t4, o3, s3), l3 = new Ai(i3.gl.LEQUAL, Ai.ReadOnly, e3.depthRangeFor3D);
          for (const t5 of this._groundShadowTiles) {
            const o4 = t5.toUnwrapped(), s4 = e3.isTileAffectedByFog(t5), c3 = e3.getOrCreateProgram("groundShadow", { defines: r3, overrideFog: s4 });
            this.setupShadows(o4, c3), e3.uploadCommonUniforms(i3, c3, o4, null, a4);
            const h3 = { u_matrix: e3.transform.calculateProjMatrix(o4), u_ground_shadow_factor: n3 };
            c3.draw(e3, i3.gl.TRIANGLES, l3, Pi2.disabled, Ri.multiply, Oi2.disabled, h3, "ground_shadow", e3.tileExtentBuffer, e3.quadTriangleIndexBuffer, e3.tileExtentSegments, {}, e3.transform.zoom, null, null);
          }
        }
        getShadowPassColorMode() {
          return this.painter._shadowMapDebug ? Ri.unblended : Ri.disabled;
        }
        getShadowPassDepthMode() {
          return this._depthMode;
        }
        getShadowCastingLayerCount() {
          return this._shadowLayerCount;
        }
        calculateShadowPassMatrixFromTile(t4) {
          const i3 = this.painter.transform, o3 = i3.calculatePosMatrix(t4, i3.worldSize);
          return e2.a6.mat4.multiply(o3, this._cascades[this.painter.currentShadowCascade].matrix, o3), Float32Array.from(o3);
        }
        calculateShadowPassMatrixFromMatrix(t4) {
          return e2.a6.mat4.multiply(t4, this._cascades[this.painter.currentShadowCascade].matrix, t4), Float32Array.from(t4);
        }
        setupShadows(t4, i3, o3, s3 = 0) {
          if (!this.enabled) return;
          const r3 = this.painter.transform, a4 = this.painter.context, n3 = a4.gl, l3 = this._uniformValues, c3 = new Float64Array(16), h3 = r3.calculatePosMatrix(t4, r3.worldSize);
          for (let t5 = 0; t5 < this._cascades.length; t5++) e2.a6.mat4.multiply(c3, this._cascades[t5].matrix, h3), l3[0 === t5 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(c3), a4.activeTexture.set(n3.TEXTURE0 + Gi.ShadowMap0 + t5), this._cascades[t5].texture.bind(n3.NEAREST, n3.CLAMP_TO_EDGE);
          if (this.useNormalOffset = !!o3, this.useNormalOffset) {
            const i4 = e2.c9(t4.canonical), a5 = 2 / r3.tileSize * e2.ab / Wi.shadowMapResolution, n4 = a5 * this._cascades[0].boundingSphereRadius, c4 = a5 * this._cascades[this._cascades.length - 1].boundingSphereRadius, h4 = ("vector-tile" === o3 ? 1 : 3) / Math.pow(2, s3 - t4.canonical.z - (1 - r3.zoom + Math.floor(r3.zoom)));
            l3.u_shadow_normal_offset = [i4, n4 * h4, c4 * h4], l3.u_shadow_bias = [6e-5, 12e-4, 0.012];
          } else l3.u_shadow_bias = [36e-5, 12e-4, 0.012];
          i3.setShadowUniformValues(a4, l3);
        }
        setupShadowsFromMatrix(t4, i3, o3 = false) {
          if (!this.enabled) return;
          const s3 = this.painter.context, r3 = s3.gl, a4 = this._uniformValues, n3 = new Float64Array(16);
          for (let i4 = 0; i4 < Wi.cascadeCount; i4++) e2.a6.mat4.multiply(n3, this._cascades[i4].matrix, t4), a4[0 === i4 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(n3), s3.activeTexture.set(r3.TEXTURE0 + Gi.ShadowMap0 + i4), this._cascades[i4].texture.bind(r3.NEAREST, r3.CLAMP_TO_EDGE);
          if (this.useNormalOffset = o3, o3) {
            const e3 = Wi.normalOffset;
            a4.u_shadow_normal_offset = [1, e3, e3], a4.u_shadow_bias = [6e-5, 12e-4, 0.012];
          } else a4.u_shadow_bias = [36e-5, 12e-4, 0.012];
          i3.setShadowUniformValues(s3, a4);
        }
        getShadowUniformValues() {
          return this._uniformValues;
        }
        getCurrentCascadeFrustum() {
          return this._cascades[this.painter.currentShadowCascade].frustum;
        }
        computeSimplifiedTileShadowVolume(t4, i3, o3, s3) {
          if (s3[2] >= 0) return {};
          const r3 = function(t5, i4, o4) {
            const s4 = o4 / (1 << t5.canonical.z);
            return new e2.ca([t5.canonical.x * s4 + t5.wrap * o4, t5.canonical.y * s4 + t5.wrap * o4, 0], [(t5.canonical.x + 1) * s4 + t5.wrap * o4, (t5.canonical.y + 1) * s4 + t5.wrap * o4, i4]);
          }(t4, i3, o3).getCorners(), a4 = i3 / -s3[2];
          s3[0] < 0 ? (e2.a6.vec3.add(r3[0], r3[0], [s3[0] * a4, 0, 0]), e2.a6.vec3.add(r3[3], r3[3], [s3[0] * a4, 0, 0])) : s3[0] > 0 && (e2.a6.vec3.add(r3[1], r3[1], [s3[0] * a4, 0, 0]), e2.a6.vec3.add(r3[2], r3[2], [s3[0] * a4, 0, 0])), s3[1] < 0 ? (e2.a6.vec3.add(r3[0], r3[0], [0, s3[1] * a4, 0]), e2.a6.vec3.add(r3[1], r3[1], [0, s3[1] * a4, 0])) : s3[1] > 0 && (e2.a6.vec3.add(r3[2], r3[2], [0, s3[1] * a4, 0]), e2.a6.vec3.add(r3[3], r3[3], [0, s3[1] * a4, 0]));
          const n3 = {};
          return n3.vertices = r3, n3.planes = [Ki(r3[1], r3[0], r3[4]), Ki(r3[2], r3[1], r3[5]), Ki(r3[3], r3[2], r3[6]), Ki(r3[0], r3[3], r3[7])], n3;
        }
        addShadowReceiver(t4, i3, o3) {
          this._receivers.add(t4, e2.ca.fromTileIdAndHeight(t4, i3, o3));
        }
        getMaxCascadeForTile(e3) {
          const t4 = this._receivers.get(e3);
          return t4 && t4.lastCascade ? t4.lastCascade : 0;
        }
      }
      function Ki(t4, i3, o3) {
        const s3 = e2.a6.vec3.sub([], o3, i3), r3 = e2.a6.vec3.sub([], t4, i3), a4 = e2.a6.vec3.cross([], s3, r3), n3 = e2.a6.vec3.length(a4);
        return 0 === n3 ? [0, 0, 1, 0] : (e2.a6.vec3.scale(a4, a4, 1 / n3), [a4[0], a4[1], a4[2], -e2.a6.vec3.dot(a4, i3)]);
      }
      function Yi(t4) {
        const i3 = t4.properties.get("direction"), o3 = e2.c8(i3.x, i3.y, i3.z);
        o3[2] = e2.ap(o3[2], 0, 75);
        const s3 = e2.cb([o3[0], o3[1], o3[2]]);
        return e2.a6.vec3.fromValues(s3.x, s3.y, s3.z);
      }
      function Qi(t4, i3, o3) {
        const s3 = i3.properties.get("color"), r3 = i3.properties.get("intensity"), a4 = i3.properties.get("direction"), n3 = [a4.x, a4.y, a4.z], l3 = o3.properties.get("color"), c3 = o3.properties.get("intensity"), h3 = Math.max(e2.a6.vec3.dot([0, 0, 1], n3), 0), u4 = [0, 0, 0];
        e2.a6.vec3.scale(u4, l3.toRenderColor(t4.getLut(i3.scope)).toArray01Linear().slice(0, 3), c3);
        const d3 = [0, 0, 0];
        return e2.a6.vec3.scale(d3, s3.toRenderColor(t4.getLut(o3.scope)).toArray01Linear().slice(0, 3), h3 * r3), e2.cc([u4[0] > 0 ? u4[0] / (u4[0] + d3[0]) : 0, u4[1] > 0 ? u4[1] / (u4[1] + d3[1]) : 0, u4[2] > 0 ? u4[2] / (u4[2] + d3[2]) : 0]);
      }
      function eo(t4, i3, o3, s3, r3, a4) {
        const n3 = t4.zoom, l3 = t4.scale, c3 = t4.worldSize, h3 = 1 / c3, u4 = t4.aspect, d3 = Math.sqrt(1 + u4 * u4) * Math.tan(0.5 * t4.fovX), _2 = d3 * d3, p3 = s3 - o3, f3 = s3 + o3;
        let m2, g4;
        _2 > p3 / f3 ? (m2 = s3, g4 = s3 * d3) : (m2 = 0.5 * f3 * (1 + _2), g4 = 0.5 * Math.sqrt(p3 * p3 + 2 * (s3 * s3 + o3 * o3) * _2 + f3 * f3 * _2 * _2));
        const v2 = t4.projection.pixelsPerMeter(t4.center.lat, c3), x2 = t4._camera.getCameraToWorldMercator(), y2 = [0, 0, -m2 * h3];
        e2.a6.vec3.transformMat4(y2, y2, x2);
        let b2 = g4 * h3;
        const w2 = t4._edgeInsets;
        if (!(0 === w2.left && 0 === w2.top && 0 === w2.right && 0 === w2.bottom || w2.left === w2.right && w2.top === w2.bottom)) {
          const i4 = t4._camera.getWorldToCamera(t4.worldSize, "meters" === t4.projection.zAxisUnit ? v2 : 1), r4 = t4._camera.getCameraToClipPerspective(t4._fov, t4.width / t4.height, o3, s3);
          r4[8] = 2 * -t4.centerOffset.x / t4.width, r4[9] = 2 * t4.centerOffset.y / t4.height;
          const a5 = new Float64Array(16);
          e2.a6.mat4.mul(a5, r4, i4);
          const h4 = new Float64Array(16);
          e2.a6.mat4.invert(h4, a5);
          const u5 = e2.bO.fromInvProjectionMatrix(h4, c3, n3, true);
          for (const i5 of u5.points) {
            const o4 = ((T3 = i5)[0] /= l3, T3[1] /= l3, T3[2] = e2.bE(T3[2], t4._center.lat), T3);
            b2 = Math.max(b2, e2.a6.vec3.len(e2.a6.vec3.subtract([], y2, o4)));
          }
        }
        var T3;
        b2 *= r3 / (r3 - 1);
        const E3 = Math.acos(i3[2]), S2 = Math.atan2(-i3[0], -i3[1]), C3 = new Ui();
        C3.position = y2, C3.setPitchBearing(E3, S2);
        const I3 = C3.getWorldToCamera(c3, v2), D2 = b2 * c3, R3 = Math.min(t4._mercatorZfromZoom(17) * c3 * -2, -2 * D2), A3 = C3.getCameraToClipOrthographic(-D2, D2, -D2, D2, R3, (D2 + a4 * v2) / i3[2]), L3 = new Float64Array(16);
        e2.a6.mat4.multiply(L3, A3, I3);
        const P2 = e2.a6.vec3.fromValues(Math.floor(1e6 * y2[0]) / 1e6 * c3, Math.floor(1e6 * y2[1]) / 1e6 * c3, 0), M2 = 0.5 * r3, z3 = [0, 0, 0];
        e2.a6.vec3.transformMat4(z3, P2, L3), e2.a6.vec3.scale(z3, z3, M2);
        const O2 = [Math.floor(z3[0]), Math.floor(z3[1]), Math.floor(z3[2])], F3 = [0, 0, 0];
        e2.a6.vec3.sub(F3, z3, O2), e2.a6.vec3.scale(F3, F3, -1 / M2);
        const B4 = new Float64Array(16);
        return e2.a6.mat4.identity(B4), e2.a6.mat4.translate(B4, B4, F3), e2.a6.mat4.multiply(L3, B4, L3), [L3, D2];
      }
      class to extends e2.E {
        constructor(e3) {
          super(), this.requestManager = e3, this.models = { "": {} }, this.numModelsLoading = {};
        }
        loadModel(t4, i3) {
          return e2.aG(this.requestManager.transformRequest(i3, e2.R.Model).url).then((i4) => {
            if (!i4) return;
            const o3 = e2.aH(i4), s3 = new e2.aI(t4, void 0, void 0, o3);
            return s3.computeBoundsAndApplyParent(), s3;
          }).catch((o3) => {
            if (o3 && 404 === o3.status) return null;
            this.fire(new e2.t(new Error(`Could not load model ${t4} from ${i3}: ${o3.message}`)));
          });
        }
        load(t4, i3) {
          this.models[i3] || (this.models[i3] = {});
          const o3 = Object.keys(t4);
          this.numModelsLoading[i3] = (this.numModelsLoading[i3] || 0) + o3.length;
          const s3 = [];
          for (const e3 of o3) s3.push(this.loadModel(e3, t4[e3]));
          Promise.allSettled(s3).then((t5) => {
            for (let e3 = 0; e3 < t5.length; e3++) {
              const { status: s4, value: r3 } = t5[e3];
              "fulfilled" === s4 && r3 && (this.models[i3][o3[e3]] = { model: r3, numReferences: 1 });
            }
            this.numModelsLoading[i3] -= o3.length, this.fire(new e2.x("data", { dataType: "style" }));
          }).catch((t5) => {
            this.fire(new e2.t(new Error(`Could not load models: ${t5.message}`)));
          });
        }
        isLoaded() {
          for (const e3 in this.numModelsLoading) if (this.numModelsLoading[e3] > 0) return false;
          return true;
        }
        hasModel(e3, t4) {
          return !!this.getModel(e3, t4);
        }
        getModel(e3, t4) {
          return this.models[t4] || (this.models[t4] = {}), this.models[t4][e3] ? this.models[t4][e3].model : void 0;
        }
        addModel(e3, t4, i3) {
          this.models[i3] || (this.models[i3] = {}), this.hasModel(e3, i3) && this.models[i3][e3].numReferences++, this.load({ [e3]: this.requestManager.normalizeModelURL(t4) }, i3);
        }
        addModels(e3, t4) {
          this.models[t4] || (this.models[t4] = {});
          const i3 = {};
          for (const o3 in e3) this.models[t4][o3] = {}, i3[o3] = this.requestManager.normalizeModelURL(e3[o3]);
          this.load(i3, t4);
        }
        addModelsFromBucket(e3, t4) {
          this.models[t4] || (this.models[t4] = {});
          const i3 = {};
          for (const o3 of e3) this.hasModel(o3, t4) ? this.models[t4][o3].numReferences++ : i3[o3] = this.requestManager.normalizeModelURL(o3);
          this.load(i3, t4);
        }
        removeModel(e3, t4) {
          if (this.models[t4] && this.models[t4][e3] && (this.models[t4][e3].numReferences--, 0 === this.models[t4][e3].numReferences)) {
            const i3 = this.models[t4][e3].model;
            delete this.models[t4][e3], i3.destroy();
          }
        }
        listModels(e3) {
          return this.models[e3] || (this.models[e3] = {}), Object.keys(this.models[e3]);
        }
        upload(e3, t4) {
          this.models[t4] || (this.models[t4] = {});
          for (const i3 in this.models[t4]) this.models[t4][i3].model && this.models[t4][i3].model.upload(e3.context);
        }
      }
      const io = new e2.a0({ data: new e2.a1(e2._.colorTheme.data) }), oo = (e3, t4) => De(e3, t4 && t4.filter((e4) => "source.canvas" !== e4.identifier)), so = e2.ar(Et, ["addLayer", "removeLayer", "setLights", "setPaintProperty", "setLayoutProperty", "setSlot", "setFilter", "addSource", "removeSource", "setLayerZoomRange", "setLight", "setTransition", "setGeoJSONSourceData", "setTerrain", "setFog", "setProjection", "setCamera", "addImport", "removeImport", "updateImport"]), ro = e2.ar(Et, ["setCenter", "setZoom", "setBearing", "setPitch"]), ao = { version: 8, layers: [], sources: {} }, no = { duration: 300, delay: 0 };
      class lo extends e2.E {
        constructor(t4, i3 = {}) {
          super(), this.map = t4, this.scope = i3.scope || "", this.globalId = null, this.fragments = [], this.importDepth = i3.importDepth || 0, this.importsCache = i3.importsCache || /* @__PURE__ */ new Map(), this.resolvedImports = i3.resolvedImports || /* @__PURE__ */ new Set(), this.transition = e2.m({}, no), this._buildingIndex = new bt(this), this.crossTileSymbolIndex = new Ii2(), this._mergedOrder = [], this._drapedFirstOrder = [], this._mergedLayers = {}, this._mergedSourceCaches = {}, this._mergedOtherSourceCaches = {}, this._mergedSymbolSourceCaches = {}, this._mergedLayerSelectors = /* @__PURE__ */ new Map(), this._clipLayerPresent = false, this._has3DLayers = false, this._hasCircleLayers = false, this._hasSymbolLayers = false, this._changes = i3.styleChanges || new V2(), this.dispatcher = i3.dispatcher ? i3.dispatcher : new e2.ce(e2.cf(), this), i3.imageManager ? this.imageManager = i3.imageManager : (this.imageManager = new H(), this.imageManager.setEventedParent(this)), this.imageManager.createScope(this.scope), this.glyphManager = i3.glyphManager ? i3.glyphManager : new e2.cg(t4._requestManager, i3.localFontFamily ? e2.ch.all : i3.localIdeographFontFamily ? e2.ch.ideographs : e2.ch.none, i3.localFontFamily || i3.localIdeographFontFamily), i3.modelManager ? this.modelManager = i3.modelManager : (this.modelManager = new to(t4._requestManager), this.modelManager.setEventedParent(this)), this._layers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this._loaded = false, this._precompileDone = false, this._shouldPrecompile = false, this._availableImages = [], this._order = [], this._markersNeedUpdate = false, this._styleColorTheme = { lut: null, lutLoading: false, lutLoadingCorrelationID: 0, colorTheme: null }, this._styleColorThemeForScope = {}, this.options = i3.configOptions ? i3.configOptions : /* @__PURE__ */ new Map(), this._configDependentLayers = i3.configDependentLayers ? i3.configDependentLayers : /* @__PURE__ */ new Set(), this._config = i3.config, this._initialConfig = i3.initialConfig, this.dispatcher.broadcast("setReferrer", e2.ci());
          const o3 = this;
          this._rtlTextPluginCallback = lo.registerForPluginStateChange((t5) => {
            o3.dispatcher.broadcast("syncRTLPluginState", { pluginStatus: t5.pluginStatus, pluginURL: t5.pluginURL }, (t6, i4) => {
              if (e2.cj(t6), i4 && i4.every((e3) => e3)) for (const e3 in o3._sourceCaches) {
                const t7 = o3._sourceCaches[e3], i5 = t7.getSource().type;
                "vector" !== i5 && "geojson" !== i5 || t7.reload();
              }
            });
          }), this.on("data", (e3) => {
            if ("source" !== e3.dataType || "metadata" !== e3.sourceDataType) return;
            const t5 = this.getOwnSource(e3.sourceId);
            if (t5 && t5.vectorLayerIds) for (const e4 in this._layers) {
              const i4 = this._layers[e4];
              i4.source === t5.id && this._validateLayer(i4);
            }
          });
        }
        load(e3) {
          return e3 ? ("string" == typeof e3 ? this.loadURL(e3) : this.loadJSON(e3), this) : this;
        }
        _getGlobalId(t4) {
          if (!t4) return null;
          if ("string" == typeof t4) {
            if (e2.h(t4)) return t4;
            const i3 = e2.ck(t4);
            if (!i3.startsWith("http")) try {
              return new URL(i3, location.href).toString();
            } catch (e3) {
              return i3;
            }
            return i3;
          }
          return `json://${e2.cl(JSON.stringify(t4))}`;
        }
        _diffStyle(t4, i3, o3) {
          this.globalId = this._getGlobalId(t4);
          const s3 = (e3, t5) => {
            try {
              t5(null, this.setState(e3, o3));
            } catch (e4) {
              t5(e4, false);
            }
          };
          if ("string" == typeof t4) {
            const o4 = this.map._requestManager.normalizeStyleURL(t4), r3 = this.map._requestManager.transformRequest(o4, e2.R.Style);
            e2.o(r3, (t5, o5) => {
              t5 ? this.fire(new e2.t(t5)) : o5 && s3(o5, i3);
            });
          } else "object" == typeof t4 && s3(t4, i3);
        }
        loadURL(t4, i3 = {}) {
          this.fire(new e2.x("dataloading", { dataType: "style" }));
          const o3 = "boolean" == typeof i3.validate ? i3.validate : !e2.h(t4);
          this.globalId = this._getGlobalId(t4), t4 = this.map._requestManager.normalizeStyleURL(t4, i3.accessToken), this.resolvedImports.add(t4);
          const s3 = this.importsCache.get(t4);
          if (s3) return this._load(s3, o3);
          const r3 = this.map._requestManager.transformRequest(t4, e2.R.Style);
          this._request = e2.o(r3, (i4, s4) => {
            if (this._request = null, i4) this.fire(new e2.t(i4));
            else if (s4) return this.importsCache.set(t4, s4), this._load(s4, o3);
          });
        }
        loadJSON(t4, i3 = {}) {
          this.fire(new e2.x("dataloading", { dataType: "style" })), this.globalId = this._getGlobalId(t4), this._request = e2.e.frame(() => {
            this._request = null, this._load(t4, false !== i3.validate);
          });
        }
        loadEmpty() {
          this.fire(new e2.x("dataloading", { dataType: "style" })), this._load(ao, false);
        }
        _loadImports(t4, i3, o3) {
          if (this.importDepth >= 4) return e2.w("Style doesn't support nesting deeper than 5"), Promise.resolve();
          const s3 = [];
          for (const e3 of t4) {
            const t5 = this._createFragmentStyle(e3), r3 = new Promise((e4) => {
              t5.once("style.import.load", e4), t5.once("error", e4);
            }).then(() => this.mergeAll());
            if (s3.push(r3), this.resolvedImports.has(e3.url)) {
              t5.loadEmpty();
              continue;
            }
            const a4 = e3.data || this.importsCache.get(e3.url);
            a4 ? (t5.loadJSON(a4, { validate: i3 }), this._isInternalStyle(a4) && (t5.globalId = null)) : e3.url ? t5.loadURL(e3.url, { validate: i3 }) : t5.loadEmpty();
            const n3 = { style: t5, id: e3.id, config: e3.config };
            if (o3) {
              const e4 = this.fragments.findIndex(({ id: e5 }) => e5 === o3);
              this.fragments = this.fragments.slice(0, e4).concat(n3).concat(this.fragments.slice(e4));
            } else this.fragments.push(n3);
          }
          return Promise.allSettled(s3);
        }
        getImportGlobalIds(e3 = this, t4 = /* @__PURE__ */ new Set()) {
          for (const i3 of e3.fragments) i3.style.globalId && t4.add(i3.style.globalId), this.getImportGlobalIds(i3.style, t4);
          return [...t4.values()];
        }
        _createFragmentStyle(t4) {
          const i3 = this.scope ? e2.av(t4.id, this.scope) : t4.id;
          let o3;
          const s3 = this._initialConfig && this._initialConfig[i3];
          (t4.config || s3) && (o3 = e2.m({}, t4.config, s3));
          const r3 = new lo(this.map, { scope: i3, styleChanges: this._changes, importDepth: this.importDepth + 1, importsCache: this.importsCache, resolvedImports: new Set(this.resolvedImports), dispatcher: this.dispatcher, imageManager: this.imageManager, glyphManager: this.glyphManager, modelManager: this.modelManager, config: o3, configOptions: this.options, configDependentLayers: this._configDependentLayers });
          return r3.setEventedParent(this.map, { style: r3 }), r3;
        }
        _reloadImports() {
          this.mergeAll(), this._updateMapProjection(), this.updateConfigDependencies(), this.map._triggerCameraUpdate(this.camera), this.dispatcher.broadcast("setLayers", { layers: this._serializeLayers(this._order), scope: this.scope, options: this.options }), this._shouldPrecompile = this.map._precompilePrograms && this.isRootStyle();
        }
        _isInternalStyle(e3) {
          return this.isRootStyle() && (e3.fragment || !!e3.schema && false !== e3.fragment);
        }
        _load(t4, i3) {
          const o3 = t4.schema;
          if (this._isInternalStyle(t4)) {
            const o4 = e2.m({}, ao, { imports: [{ id: "basemap", data: t4, url: "" }] });
            return void this._load(o4, i3);
          }
          if (this.updateConfig(this._config, o3), i3 && oo(this, me(t4))) return;
          this._loaded = true, this.stylesheet = e2.cm(t4);
          const s3 = () => {
            for (const e3 in t4.sources) this.addSource(e3, t4.sources[e3], { validate: false, isInitialLoad: true });
            t4.sprite ? this._loadSprite(t4.sprite) : (this.imageManager.setLoaded(true, this.scope), this.dispatcher.broadcast("spriteLoaded", { scope: this.scope, isLoaded: true })), this.glyphManager.setURL(t4.glyphs, this.scope);
            const o4 = Tt(this.stylesheet.layers);
            if (this._order = o4.map((e3) => e3.id), this.stylesheet.light && e2.w("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), this.stylesheet.lights) if (1 === this.stylesheet.lights.length && "flat" === this.stylesheet.lights[0].type) {
              const e3 = this.stylesheet.lights[0];
              this.light = new Ae2(e3.properties, e3.id);
            } else this.setLights(this.stylesheet.lights);
            this.light || (this.light = new Ae2(this.stylesheet.light)), this._layers = {};
            for (const t5 of o4) {
              const i4 = e2.cq(t5, this.scope, this._styleColorTheme.lut, this.options);
              0 !== i4.configDependencies.size && this._configDependentLayers.add(i4.fqid), i4.setEventedParent(this, { layer: { id: i4.id } }), this._layers[i4.id] = i4;
              const o5 = this.getOwnLayerSourceCache(i4), s5 = !!this.directionalLight && this.directionalLight.shadowsEnabled();
              o5 && i4.canCastShadows() && s5 && (o5.castsShadows = true);
            }
            this.stylesheet.models && this.modelManager.addModels(this.stylesheet.models, this.scope);
            const s4 = this.stylesheet.terrain;
            s4 && (this.checkCanvasFingerprintNoise(), this.disableElevatedTerrain || this.terrainSetForDrapingOnly() || this._createTerrain(s4, 1)), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this.stylesheet.transition && this.setTransition(this.stylesheet.transition), this.fire(new e2.x("data", { dataType: "style" }));
            const r4 = this.isRootStyle();
            t4.imports ? this._loadImports(t4.imports, i3).then(() => {
              this._reloadImports(), this.fire(new e2.x(r4 ? "style.load" : "style.import.load"));
            }) : (this._reloadImports(), this.fire(new e2.x(r4 ? "style.load" : "style.import.load")));
          }, r3 = this.stylesheet["color-theme"];
          if (this._styleColorTheme.colorTheme = r3, r3) {
            const t5 = this._evaluateColorThemeData(r3);
            this._loadColorTheme(t5).then(() => {
              s3();
            }).catch((t6) => {
              e2.w(`Couldn't load color theme from the stylesheet: ${t6}`), s3();
            });
          } else this._styleColorTheme.lut = null, s3();
        }
        isRootStyle() {
          return 0 === this.importDepth;
        }
        mergeAll() {
          let t4, i3, o3, s3, r3, a4, n3, l3;
          const c3 = {};
          this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((e3) => {
            if (e3.stylesheet) {
              if (null != e3.light && (t4 = e3.light), e3.stylesheet.lights) for (const t5 of e3.stylesheet.lights) "ambient" === t5.type && null != e3.ambientLight && (i3 = e3.ambientLight), "directional" === t5.type && null != e3.directionalLight && (o3 = e3.directionalLight);
              s3 = this._prioritizeTerrain(s3, e3.terrain, e3.stylesheet.terrain), e3.stylesheet.fog && null != e3.fog && (r3 = e3.fog), null != e3.stylesheet.camera && (l3 = e3.stylesheet.camera), null != e3.stylesheet.projection && (a4 = e3.stylesheet.projection), null != e3.stylesheet.transition && (n3 = e3.stylesheet.transition), c3[e3.scope] = e3._styleColorTheme;
            }
          }), this.light = t4, this.ambientLight = i3, this.directionalLight = o3, this.fog = r3, this._styleColorThemeForScope = c3, null === s3 ? delete this.terrain : this.terrain = s3, this.camera = l3 || { "camera-projection": "perspective" }, this.projection = a4 || { name: "mercator" }, this.transition = e2.m({}, no, n3), this.mergeSources(), this.mergeLayers();
        }
        forEachFragmentStyle(e3) {
          const t4 = (i3) => {
            for (const e4 of i3.fragments) t4(e4.style);
            e3(i3);
          };
          t4(this);
        }
        _prioritizeTerrain(e3, t4, i3) {
          const o3 = e3 && 0 === e3.drapeRenderMode;
          return null === i3 ? t4 && 0 === t4.drapeRenderMode ? t4 : o3 ? e3 : null : null != t4 && (!e3 || o3 || t4 && 1 === t4.drapeRenderMode) ? t4 : e3;
        }
        mergeTerrain() {
          let e3;
          this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((t4) => {
            e3 = this._prioritizeTerrain(e3, t4.terrain, t4.stylesheet.terrain);
          }), null === e3 ? delete this.terrain : this.terrain = e3;
        }
        mergeProjection() {
          let e3;
          this.forEachFragmentStyle((t4) => {
            null != t4.stylesheet.projection && (e3 = t4.stylesheet.projection);
          }), this.projection = e3 || { name: "mercator" };
        }
        mergeSources() {
          const t4 = {}, i3 = {}, o3 = {};
          this.forEachFragmentStyle((s3) => {
            for (const i4 in s3._sourceCaches) {
              const o4 = e2.av(i4, s3.scope);
              t4[o4] = s3._sourceCaches[i4];
            }
            for (const t5 in s3._otherSourceCaches) {
              const o4 = e2.av(t5, s3.scope);
              i3[o4] = s3._otherSourceCaches[t5];
            }
            for (const t5 in s3._symbolSourceCaches) {
              const i4 = e2.av(t5, s3.scope);
              o3[i4] = s3._symbolSourceCaches[t5];
            }
          }), this._mergedSourceCaches = t4, this._mergedOtherSourceCaches = i3, this._mergedSymbolSourceCaches = o3;
        }
        mergeLayers() {
          const t4 = {}, i3 = [], o3 = {};
          this._mergedSlots = [], this._has3DLayers = false, this._hasCircleLayers = false, this._hasSymbolLayers = false, this._mergedLayerSelectors.clear(), this.forEachFragmentStyle((o4) => {
            for (const s5 of o4._order) {
              const r3 = o4._layers[s5];
              if ("slot" === r3.type) {
                const i4 = e2.cn(s5);
                if (t4[i4]) continue;
                t4[i4] = [];
              }
              r3.slot && t4[r3.slot] ? t4[r3.slot].push(r3) : i3.push(r3);
            }
            const { featuresets: s4 } = o4.stylesheet || {};
            if (s4) for (const t5 in s4) {
              const { selectors: i4 } = s4[t5];
              for (const s5 of i4) {
                const i5 = o4._layers[s5.layer], r3 = this._mergedLayerSelectors.get(i5.fqid) || [];
                let a4;
                if (s5.properties) for (const t6 in s5.properties) {
                  const i6 = e2.M(s5.properties[t6]);
                  "success" === i6.result && (a4 = a4 || {}, a4[t6] = i6.value);
                }
                r3.push({ featuresetId: t5, featureNamespace: s5.featureNamespace, properties: a4 }), this._mergedLayerSelectors.set(i5.fqid, r3);
              }
            }
          }), this._mergedOrder = [];
          const s3 = (i4 = []) => {
            for (const r3 of i4) if ("slot" === r3.type) {
              const i5 = e2.cn(r3.id);
              t4[i5] && s3(t4[i5]), this._mergedSlots.push(i5);
            } else {
              const t5 = e2.av(r3.id, r3.scope);
              this._mergedOrder.push(t5), o3[t5] = r3, r3.is3D() && (this._has3DLayers = true), "circle" === r3.type && (this._hasCircleLayers = true), "symbol" === r3.type && (this._hasSymbolLayers = true), "clip" === r3.type && (this._clipLayerPresent = true);
            }
          };
          s3(i3), this._mergedOrder.sort((e3, t5) => {
            const i4 = o3[e3], s4 = o3[t5];
            return i4.hasInitialOcclusionOpacityProperties ? s4.is3D() ? 1 : 0 : i4.is3D() && s4.hasInitialOcclusionOpacityProperties ? -1 : 0;
          }), this._mergedLayers = o3, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged();
        }
        terrainSetForDrapingOnly() {
          return !!this.terrain && 0 === this.terrain.drapeRenderMode;
        }
        getCamera() {
          return this.stylesheet.camera;
        }
        setCamera(t4) {
          return this.stylesheet.camera = e2.m({}, this.stylesheet.camera, t4), this.camera = this.stylesheet.camera, this;
        }
        _evaluateColorThemeData(t4) {
          return t4.data ? function(t5, i3, o3) {
            const s3 = e2.m({}, i3);
            for (const t6 of Object.keys(e2._.colorTheme)) void 0 === s3[t6] && (s3[t6] = e2._.colorTheme[t6].default);
            const r3 = new e2.$(io, t5, new Map(o3));
            return r3.setTransitionOrValue(s3, o3), r3.untransitioned().possiblyEvaluate(new e2.a3(0));
          }(this.scope, t4, this.options).get("data") : null;
        }
        _loadColorTheme(t4) {
          this._styleColorTheme.lutLoading = true, this._styleColorTheme.lutLoadingCorrelationID += 1;
          const i3 = this._styleColorTheme.lutLoadingCorrelationID;
          return new Promise((o3, s3) => {
            const r3 = "data:image/png;base64,";
            if (!t4 || 0 === t4.length) return this._styleColorTheme.lut = null, this._styleColorTheme.lutLoading = false, void o3();
            let a4 = t4;
            a4.startsWith(r3) || (a4 = r3 + a4);
            const n3 = "mapbox-reserved-lut", l3 = new Image();
            l3.src = a4, l3.onerror = () => {
              this._styleColorTheme.lutLoading = false, s3(new Error("Failed to load image data"));
            }, l3.onload = () => {
              if (this._styleColorTheme.lutLoadingCorrelationID !== i3) return void o3();
              this._styleColorTheme.lutLoading = false;
              const { width: r4, height: a5, data: c3 } = e2.e.getImageData(l3);
              if (a5 > 32) return void s3(new Error("The height of the image must be less than or equal to 32 pixels."));
              if (r4 !== a5 * a5) return void s3(new Error("The width of the image must be equal to the height squared."));
              this.getImage(n3) && this.removeImage(n3), this.addImage(n3, { data: new e2.r({ width: r4, height: a5 }, c3), pixelRatio: 1, sdf: false, version: 0 });
              const h3 = this.imageManager.getImage(n3, this.scope);
              h3 ? (this._styleColorTheme.lut = { image: h3.data, data: t4 }, o3()) : s3(new Error("Missing LUT image."));
            };
          });
        }
        getLut(e3) {
          const t4 = this._styleColorThemeForScope[e3];
          return t4 ? t4.lut : null;
        }
        setProjection(e3) {
          e3 ? this.stylesheet.projection = e3 : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
        }
        applyProjectionUpdate() {
          this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? (this.getTerrain() || this.stylesheet.terrain) && !this.disableElevatedTerrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null, 0));
        }
        _updateMapProjection() {
          this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
        }
        _loadSprite(t4) {
          this._spriteRequest = function(t5, i3, o3) {
            let s3, r3, a4;
            const n3 = e2.e.devicePixelRatio > 1 ? "@2x" : "";
            let l3 = e2.o(i3.transformRequest(i3.normalizeSpriteURL(t5, n3, ".json"), e2.R.SpriteJSON), (e3, t6) => {
              l3 = null, a4 || (a4 = e3, s3 = t6, h3());
            }), c3 = e2.q(i3.transformRequest(i3.normalizeSpriteURL(t5, n3, ".png"), e2.R.SpriteImage), (e3, t6) => {
              c3 = null, a4 || (a4 = e3, r3 = t6, h3());
            });
            function h3() {
              if (a4) o3(a4);
              else if (s3 && r3) {
                const t6 = e2.e.getImageData(r3), i4 = {};
                for (const o4 in s3) {
                  const { width: r4, height: a5, x: n4, y: l4, sdf: c4, pixelRatio: h4, stretchX: u4, stretchY: d3, content: _2 } = s3[o4], p3 = new e2.r({ width: r4, height: a5 });
                  e2.r.copy(t6, p3, { x: n4, y: l4 }, { x: 0, y: 0 }, { width: r4, height: a5 }, null), i4[o4] = { data: p3, pixelRatio: h4, sdf: c4, stretchX: u4, stretchY: d3, content: _2 };
                }
                o3(null, i4);
              }
            }
            return { cancel() {
              l3 && (l3.cancel(), l3 = null), c3 && (c3.cancel(), c3 = null);
            } };
          }(t4, this.map._requestManager, (t5, i3) => {
            if (this._spriteRequest = null, t5) this.fire(new e2.t(t5));
            else if (i3) for (const e3 in i3) this.imageManager.addImage(e3, this.scope, i3[e3]);
            this.imageManager.setLoaded(true, this.scope), this._availableImages = this.imageManager.listImages(this.scope), this.dispatcher.broadcast("setImages", { scope: this.scope, images: this._availableImages }), this.dispatcher.broadcast("spriteLoaded", { scope: this.scope, isLoaded: true }), this.fire(new e2.x("data", { dataType: "style" }));
          });
        }
        _validateLayer(t4) {
          const i3 = this.getOwnSource(t4.source);
          if (!i3) return;
          const o3 = t4.sourceLayer;
          o3 && ("geojson" === i3.type || i3.vectorLayerIds && -1 === i3.vectorLayerIds.indexOf(o3)) && this.fire(new e2.t(new Error(`Source layer "${o3}" does not exist on source "${i3.id}" as specified by style layer "${t4.id}"`)));
        }
        loaded() {
          if (!this._loaded) return false;
          if (Object.keys(this._changes.getUpdatedSourceCaches()).length) return false;
          for (const e3 in this._sourceCaches) if (!this._sourceCaches[e3].loaded()) return false;
          if (!this.imageManager.isLoaded()) return false;
          if (!this.modelManager.isLoaded()) return false;
          if (this._styleColorTheme.lutLoading) return false;
          for (const { style: e3 } of this.fragments) if (!e3.loaded()) return false;
          return true;
        }
        _serializeImports() {
          if (this.stylesheet.imports) return this.stylesheet.imports.map((e3, t4) => {
            const i3 = this.fragments[t4];
            return i3 && i3.style && (e3.data = i3.style.serialize()), e3;
          });
        }
        _serializeSources() {
          const e3 = {};
          for (const t4 in this._sourceCaches) {
            const i3 = this._sourceCaches[t4].getSource();
            e3[i3.id] || (e3[i3.id] = i3.serialize());
          }
          return e3;
        }
        _serializeLayers(e3) {
          const t4 = [];
          for (const i3 of e3) {
            const e4 = this._layers[i3];
            e4 && "custom" !== e4.type && t4.push(e4.serialize());
          }
          return t4;
        }
        hasLightTransitions() {
          return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
        }
        hasFogTransition() {
          return !!this.fog && this.fog.hasTransition();
        }
        hasTransitions() {
          if (this.hasLightTransitions()) return true;
          if (this.hasFogTransition()) return true;
          for (const e3 in this._sourceCaches) if (this._sourceCaches[e3].hasTransition()) return true;
          for (const e3 in this._layers) if (this._layers[e3].hasTransition()) return true;
          return false;
        }
        get order() {
          return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
        }
        _getOrder(e3) {
          return e3 ? this.order : this._mergedOrder;
        }
        isLayerDraped(e3) {
          return !!this.terrain && e3.isDraped(this.getLayerSourceCache(e3));
        }
        _checkLoaded() {
          if (!this._loaded) throw new Error("Style is not done loading");
        }
        _checkLayer(t4) {
          const i3 = this.getOwnLayer(t4);
          if (i3) return i3;
          this.fire(new e2.t(new Error(`The layer '${t4}' does not exist in the map's style.`)));
        }
        _checkSource(t4) {
          const i3 = this.getOwnSource(t4);
          if (i3) return i3;
          this.fire(new e2.t(new Error(`The source '${t4}' does not exist in the map's style.`)));
        }
        precompilePrograms(e3, t4) {
          const i3 = this.map.painter;
          if (i3) for (let o3 = e3.minzoom || 0; o3 < (e3.maxzoom || 25.5); o3++) {
            const o4 = e3.getProgramIds();
            if (o4) for (const s3 of o4) {
              const o5 = e3.getDefaultProgramParams(s3, t4.zoom, this._styleColorTheme.lut);
              o5 && (i3.style = this, this.fog && (i3._fogVisible = true, o5.overrideFog = true, i3.getOrCreateProgram(s3, o5)), i3._fogVisible = false, o5.overrideFog = false, i3.getOrCreateProgram(s3, o5), (this.stylesheet.terrain || this.stylesheet.projection && "globe" === this.stylesheet.projection.name) && (o5.overrideRtt = true, i3.getOrCreateProgram(s3, o5)));
            }
          }
        }
        update(t4) {
          if (!this._loaded) return;
          this.ambientLight && this.ambientLight.recalculate(t4), this.directionalLight && this.directionalLight.recalculate(t4);
          const i3 = this.calculateLightsBrightness();
          t4.brightness = i3 || 0, i3 !== this._brightness && (this._brightness = i3, this.dispatcher.broadcast("setBrightness", i3));
          const o3 = this._changes.isDirty();
          let s3 = false;
          if (this._changes.isDirty()) {
            const e3 = this._changes.getLayerUpdatesByScope();
            for (const t5 in e3) {
              const { updatedIds: i4, removedIds: o4 } = e3[t5];
              (i4 || o4) && (this._updateWorkerLayers(t5, i4, o4), s3 = true);
            }
            this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(t4), this.light && this.light.updateTransitions(t4), this.ambientLight && this.ambientLight.updateTransitions(t4), this.directionalLight && this.directionalLight.updateTransitions(t4), this.fog && this.fog.updateTransitions(t4), this._changes.reset();
          }
          const r3 = {};
          for (const e3 in this._mergedSourceCaches) {
            const t5 = this._mergedSourceCaches[e3];
            r3[e3] = t5.used, t5.used = false, t5.tileCoverLift = 0;
          }
          for (const e3 of this._mergedOrder) {
            const i4 = this._mergedLayers[e3];
            if (i4.recalculate(t4, this._availableImages), !i4.isHidden(t4.zoom)) {
              const e4 = this.getLayerSourceCache(i4);
              e4 && (e4.used = true, e4.tileCoverLift = Math.max(e4.tileCoverLift, i4.tileCoverLift()));
            }
            !this._precompileDone && this._shouldPrecompile && ("requestIdleCallback" in window ? requestIdleCallback(() => {
              this.precompilePrograms(i4, t4);
            }) : this.precompilePrograms(i4, t4));
          }
          this._shouldPrecompile && (this._precompileDone = true), this.terrain && s3 && this.mergeLayers();
          for (const t5 in r3) {
            const i4 = this._mergedSourceCaches[t5];
            r3[t5] !== i4.used && i4.getSource().fire(new e2.x("data", { sourceDataType: "visibility", dataType: "source", sourceId: i4.getSource().id }));
          }
          this.light && this.light.recalculate(t4), this.terrain && this.terrain.recalculate(t4), this.fog && this.fog.recalculate(t4), this.z = t4.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = false), o3 && this.fire(new e2.x("data", { dataType: "style" }));
        }
        _updateTilesForChangedImages() {
          const e3 = this._changes.getUpdatedImages();
          if (e3.length) {
            for (const t4 in this._sourceCaches) this._sourceCaches[t4].reloadTilesForDependencies(["icons", "patterns"], e3);
            this._changes.resetUpdatedImages();
          }
        }
        _updateWorkerLayers(e3, t4, i3) {
          const o3 = this.getFragmentStyle(e3);
          o3 && this.dispatcher.broadcast("updateLayers", { layers: t4 ? o3._serializeLayers(t4) : [], scope: e3, removedIds: i3 || [], options: o3.options });
        }
        setState(t4, i3) {
          if (this._checkLoaded(), oo(this, me(t4))) return false;
          (t4 = e2.cm(t4)).layers = Tt(t4.layers);
          const o3 = function(t5, i4) {
            if (!t5) return [{ command: Et.setStyle, args: [i4] }];
            let o4 = [];
            try {
              if (!e2.bi(t5.version, i4.version)) return [{ command: Et.setStyle, args: [i4] }];
              if (e2.bi(t5.center, i4.center) || o4.push({ command: Et.setCenter, args: [i4.center] }), e2.bi(t5.zoom, i4.zoom) || o4.push({ command: Et.setZoom, args: [i4.zoom] }), e2.bi(t5.bearing, i4.bearing) || o4.push({ command: Et.setBearing, args: [i4.bearing] }), e2.bi(t5.pitch, i4.pitch) || o4.push({ command: Et.setPitch, args: [i4.pitch] }), e2.bi(t5.sprite, i4.sprite) || o4.push({ command: Et.setSprite, args: [i4.sprite] }), e2.bi(t5.glyphs, i4.glyphs) || o4.push({ command: Et.setGlyphs, args: [i4.glyphs] }), e2.bi(t5.imports, i4.imports) || function(t6 = [], i5 = [], o5) {
                i5 = i5 || [];
                const s5 = (t6 = t6 || []).map(At), r5 = i5.map(At), a5 = t6.reduce(Lt, {}), n4 = i5.reduce(Lt, {}), l3 = s5.slice();
                let c3, h3, u4, d3;
                for (c3 = 0, h3 = 0; c3 < s5.length; c3++) u4 = s5[c3], n4.hasOwnProperty(u4) ? h3++ : (o5.push({ command: Et.removeImport, args: [u4] }), l3.splice(l3.indexOf(u4, h3), 1));
                for (c3 = 0, h3 = 0; c3 < r5.length; c3++) u4 = r5[r5.length - 1 - c3], l3[l3.length - 1 - c3] !== u4 && (a5.hasOwnProperty(u4) ? (o5.push({ command: Et.removeImport, args: [u4] }), l3.splice(l3.lastIndexOf(u4, l3.length - h3), 1)) : h3++, d3 = l3[l3.length - c3], o5.push({ command: Et.addImport, args: [n4[u4], d3] }), l3.splice(l3.length - c3, 0, u4));
                for (const t7 of i5) {
                  const i6 = a5[t7.id];
                  i6 && !e2.bi(i6, t7) && o5.push({ command: Et.updateImport, args: [t7.id, t7] });
                }
              }(t5.imports, i4.imports, o4), e2.bi(t5.transition, i4.transition) || o4.push({ command: Et.setTransition, args: [i4.transition] }), e2.bi(t5.light, i4.light) || o4.push({ command: Et.setLight, args: [i4.light] }), e2.bi(t5.fog, i4.fog) || o4.push({ command: Et.setFog, args: [i4.fog] }), e2.bi(t5.projection, i4.projection) || o4.push({ command: Et.setProjection, args: [i4.projection] }), e2.bi(t5.lights, i4.lights) || o4.push({ command: Et.setLights, args: [i4.lights] }), e2.bi(t5.camera, i4.camera) || o4.push({ command: Et.setCamera, args: [i4.camera] }), !e2.bi(t5["color-theme"], i4["color-theme"])) return [{ command: Et.setStyle, args: [i4] }];
              const s4 = {}, r4 = [];
              !function(t6, i5, o5, s5) {
                let r5;
                for (r5 in i5 = i5 || {}, t6 = t6 || {}) t6.hasOwnProperty(r5) && (i5.hasOwnProperty(r5) || Ct2(r5, o5, s5));
                for (r5 in i5) {
                  if (!i5.hasOwnProperty(r5)) continue;
                  const a5 = i5[r5];
                  t6.hasOwnProperty(r5) ? e2.bi(t6[r5], a5) || ("geojson" === t6[r5].type && "geojson" === a5.type && Dt(t6, i5, r5) ? o5.push({ command: Et.setGeoJSONSourceData, args: [r5, a5.data] }) : It(r5, i5, o5, s5)) : St(r5, i5, o5);
                }
              }(t5.sources, i4.sources, r4, s4);
              const a4 = [];
              t5.layers && t5.layers.forEach((e3) => {
                e3.source && s4[e3.source] ? o4.push({ command: Et.removeLayer, args: [e3.id] }) : a4.push(e3);
              });
              let n3 = t5.terrain;
              n3 && s4[n3.source] && (o4.push({ command: Et.setTerrain, args: [void 0] }), n3 = void 0), o4 = o4.concat(r4), e2.bi(n3, i4.terrain) || o4.push({ command: Et.setTerrain, args: [i4.terrain] }), function(t6, i5, o5) {
                i5 = i5 || [];
                const s5 = (t6 = t6 || []).map(At), r5 = i5.map(At), a5 = t6.reduce(Lt, {}), n4 = i5.reduce(Lt, {}), l3 = s5.slice(), c3 = /* @__PURE__ */ Object.create(null);
                let h3, u4, d3, _2, p3, f3, m2;
                for (h3 = 0, u4 = 0; h3 < s5.length; h3++) d3 = s5[h3], n4.hasOwnProperty(d3) ? u4++ : (o5.push({ command: Et.removeLayer, args: [d3] }), l3.splice(l3.indexOf(d3, u4), 1));
                for (h3 = 0, u4 = 0; h3 < r5.length; h3++) d3 = r5[r5.length - 1 - h3], l3[l3.length - 1 - h3] !== d3 && (a5.hasOwnProperty(d3) ? (o5.push({ command: Et.removeLayer, args: [d3] }), l3.splice(l3.lastIndexOf(d3, l3.length - u4), 1)) : u4++, f3 = l3[l3.length - h3], o5.push({ command: Et.addLayer, args: [n4[d3], f3] }), l3.splice(l3.length - h3, 0, d3), c3[d3] = true);
                for (h3 = 0; h3 < r5.length; h3++) if (d3 = r5[h3], _2 = a5[d3], p3 = n4[d3], !c3[d3] && !e2.bi(_2, p3)) if (e2.bi(_2.source, p3.source) && e2.bi(_2["source-layer"], p3["source-layer"]) && e2.bi(_2.type, p3.type)) {
                  for (m2 in Rt(_2.layout, p3.layout, o5, d3, null, Et.setLayoutProperty), Rt(_2.paint, p3.paint, o5, d3, null, Et.setPaintProperty), e2.bi(_2.slot, p3.slot) || o5.push({ command: Et.setSlot, args: [d3, p3.slot] }), e2.bi(_2.filter, p3.filter) || o5.push({ command: Et.setFilter, args: [d3, p3.filter] }), e2.bi(_2.minzoom, p3.minzoom) && e2.bi(_2.maxzoom, p3.maxzoom) || o5.push({ command: Et.setLayerZoomRange, args: [d3, p3.minzoom, p3.maxzoom] }), _2) _2.hasOwnProperty(m2) && "layout" !== m2 && "paint" !== m2 && "filter" !== m2 && "metadata" !== m2 && "minzoom" !== m2 && "maxzoom" !== m2 && "slot" !== m2 && (0 === m2.indexOf("paint.") ? Rt(_2[m2], p3[m2], o5, d3, m2.slice(6), Et.setPaintProperty) : e2.bi(_2[m2], p3[m2]) || o5.push({ command: Et.setLayerProperty, args: [d3, m2, p3[m2]] }));
                  for (m2 in p3) p3.hasOwnProperty(m2) && !_2.hasOwnProperty(m2) && "layout" !== m2 && "paint" !== m2 && "filter" !== m2 && "metadata" !== m2 && "minzoom" !== m2 && "maxzoom" !== m2 && "slot" !== m2 && (0 === m2.indexOf("paint.") ? Rt(_2[m2], p3[m2], o5, d3, m2.slice(6), Et.setPaintProperty) : e2.bi(_2[m2], p3[m2]) || o5.push({ command: Et.setLayerProperty, args: [d3, m2, p3[m2]] }));
                } else o5.push({ command: Et.removeLayer, args: [d3] }), f3 = l3[l3.lastIndexOf(d3) + 1], o5.push({ command: Et.addLayer, args: [p3, f3] });
              }(a4, i4.layers, o4);
            } catch (e3) {
              console.warn("Unable to compute style diff:", e3), o4 = [{ command: Et.setStyle, args: [i4] }];
            }
            return o4;
          }(this.serialize(), t4).filter((e3) => !(e3.command in ro));
          if (0 === o3.length) return false;
          const s3 = o3.filter((e3) => !(e3.command in so));
          if (s3.length > 0) throw new Error(`Unimplemented: ${s3.map((e3) => e3.command).join(", ")}.`);
          const r3 = [];
          return o3.forEach((e3) => {
            r3.push(this[e3.command].apply(this, e3.args));
          }), i3 && Promise.all(r3).then(i3), this.stylesheet = t4, this.mergeAll(), this.dispatcher.broadcast("setLayers", { layers: this._serializeLayers(this._order), scope: this.scope, options: this.options }), true;
        }
        addImage(t4, i3) {
          return this.getImage(t4) ? this.fire(new e2.t(new Error("An image with this name already exists."))) : (this.imageManager.addImage(t4, this.scope, i3), this._afterImageUpdated(t4), this);
        }
        updateImage(e3, t4) {
          this.imageManager.updateImage(e3, this.scope, t4);
        }
        getImage(e3) {
          return this.imageManager.getImage(e3, this.scope);
        }
        removeImage(t4) {
          return this.getImage(t4) ? (this.imageManager.removeImage(t4, this.scope), this._afterImageUpdated(t4), this) : this.fire(new e2.t(new Error("No image with this name exists.")));
        }
        _afterImageUpdated(t4) {
          this._availableImages = this.imageManager.listImages(this.scope), this._changes.updateImage(t4), this.dispatcher.broadcast("setImages", { scope: this.scope, images: this._availableImages }), this.fire(new e2.x("data", { dataType: "style" }));
        }
        listImages() {
          return this._checkLoaded(), this._availableImages.slice();
        }
        addModel(e3, t4, i3 = {}) {
          return this._checkLoaded(), this._validate(Ce, `models.${e3}`, t4, null, i3) || (this.modelManager.addModel(e3, t4, this.scope), this._changes.setDirty()), this;
        }
        hasModel(e3) {
          return this.modelManager.hasModel(e3, this.scope);
        }
        removeModel(t4) {
          return this.hasModel(t4) ? (this.modelManager.removeModel(t4, this.scope), this) : this.fire(new e2.t(new Error("No model with this ID exists.")));
        }
        listModels() {
          return this._checkLoaded(), this.modelManager.listModels(this.scope);
        }
        addSource(t4, i3, o3 = {}) {
          if (this._checkLoaded(), void 0 !== this.getOwnSource(t4)) throw new Error(`There is already a source with ID "${t4}".`);
          if (!i3.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i3).join(", ")}.`);
          if (["vector", "raster", "geojson", "video", "image"].indexOf(i3.type) >= 0 && this._validate(ge2, `sources.${t4}`, i3, null, o3)) return;
          this.map && this.map._collectResourceTiming && (i3.collectResourceTiming = true);
          const s3 = Qe(t4, i3, this.dispatcher, this);
          s3.scope = this.scope, s3.setEventedParent(this, () => ({ isSourceLoaded: this._isSourceCacheLoaded(s3.id), source: s3.serialize(), sourceId: s3.id }));
          const r3 = (t5) => {
            const i4 = (t5 ? "symbol:" : "other:") + s3.id, o4 = e2.av(i4, this.scope), r4 = this._sourceCaches[i4] = new gt(o4, s3, t5);
            (t5 ? this._symbolSourceCaches : this._otherSourceCaches)[s3.id] = r4, r4.onAdd(this.map);
          };
          r3(false), "vector" !== i3.type && "geojson" !== i3.type || r3(true), s3.onAdd && s3.onAdd(this.map), o3.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
        }
        removeSource(t4) {
          this._checkLoaded();
          const i3 = this.getOwnSource(t4);
          if (!i3) throw new Error("There is no source with this ID");
          for (const i4 in this._layers) if (this._layers[i4].source === t4) return this.fire(new e2.t(new Error(`Source "${t4}" cannot be removed while layer "${i4}" is using it.`)));
          if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === t4) return this.fire(new e2.t(new Error(`Source "${t4}" cannot be removed while terrain is using it.`)));
          const o3 = this.getOwnSourceCaches(t4);
          for (const t5 of o3) {
            const i4 = e2.cn(t5.id);
            delete this._sourceCaches[i4], this._changes.discardSourceCacheUpdate(t5.id), t5.fire(new e2.x("data", { sourceDataType: "metadata", dataType: "source", sourceId: t5.getSource().id })), t5.setEventedParent(null), t5.clearTiles();
          }
          return delete this._otherSourceCaches[t4], delete this._symbolSourceCaches[t4], this.mergeSources(), i3.setEventedParent(null), i3.onRemove && i3.onRemove(this.map), this._changes.setDirty(), this;
        }
        setGeoJSONSourceData(e3, t4) {
          this._checkLoaded(), this.getOwnSource(e3).setData(t4), this._changes.setDirty();
        }
        getOwnSource(e3) {
          const t4 = this.getOwnSourceCache(e3);
          return t4 && t4.getSource();
        }
        getOwnSources() {
          const e3 = [];
          for (const t4 in this._otherSourceCaches) {
            const i3 = this.getOwnSourceCache(t4);
            i3 && e3.push(i3.getSource());
          }
          return e3;
        }
        areTilesLoaded() {
          const e3 = this._mergedSourceCaches;
          for (const t4 in e3) {
            const i3 = e3[t4]._tiles;
            for (const e4 in i3) {
              const t5 = i3[e4];
              if ("loaded" !== t5.state && "errored" !== t5.state) return false;
            }
          }
          return true;
        }
        setLights(t4) {
          if (this._checkLoaded(), !t4) return delete this.ambientLight, void delete this.directionalLight;
          const i3 = this._getTransitionParameters();
          for (const o4 of t4) {
            if (this._validate(xe, "lights", o4)) return;
            switch (o4.type) {
              case "ambient":
                if (this.ambientLight) {
                  const e3 = this.ambientLight;
                  e3.set(o4), e3.updateTransitions(i3);
                } else this.ambientLight = new Ue(o4, Ge || (Ge = new e2.a0({ color: new e2.a1(e2._.properties_light_ambient.color), intensity: new e2.a1(e2._.properties_light_ambient.intensity) })), this.scope, this.options);
                break;
              case "directional":
                if (this.directionalLight) {
                  const e3 = this.directionalLight;
                  e3.set(o4), e3.updateTransitions(i3);
                } else this.directionalLight = new Ue(o4, Ve || (Ve = new e2.a0({ direction: new e2.ad(e2._.properties_light_directional.direction), color: new e2.a1(e2._.properties_light_directional.color), intensity: new e2.a1(e2._.properties_light_directional.intensity), "cast-shadows": new e2.a1(e2._.properties_light_directional["cast-shadows"]), "shadow-intensity": new e2.a1(e2._.properties_light_directional["shadow-intensity"]) })), this.scope, this.options);
            }
          }
          const o3 = new e2.a3(this.z || 0, i3);
          this.ambientLight && this.ambientLight.recalculate(o3), this.directionalLight && this.directionalLight.recalculate(o3), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("setBrightness", this._brightness);
        }
        calculateLightsBrightness() {
          const t4 = this.directionalLight, i3 = this.ambientLight;
          if (!t4 || !i3) return;
          const o3 = (e3) => 0.2126 * (e3[0] <= 0.03928 ? e3[0] / 12.92 : Math.pow((e3[0] + 0.055) / 1.055, 2.4)) + 0.7152 * (e3[1] <= 0.03928 ? e3[1] / 12.92 : Math.pow((e3[1] + 0.055) / 1.055, 2.4)) + 0.0722 * (e3[2] <= 0.03928 ? e3[2] / 12.92 : Math.pow((e3[2] + 0.055) / 1.055, 2.4)), s3 = t4.properties.get("color").toRenderColor(null).toArray01(), r3 = t4.properties.get("intensity"), a4 = t4.properties.get("direction"), n3 = 1 - e2.c8(a4.x, a4.y, a4.z)[2] / 90, l3 = o3(s3) * r3 * n3, c3 = i3.properties.get("color").toRenderColor(null).toArray01(), h3 = i3.properties.get("intensity"), u4 = o3(c3) * h3;
          return Number(((l3 + u4) / 2).toFixed(6));
        }
        getBrightness() {
          return this._brightness;
        }
        getLights() {
          if (!this.enable3dLights()) return null;
          const e3 = [];
          return this.directionalLight && e3.push(this.directionalLight.get()), this.ambientLight && e3.push(this.ambientLight.get()), e3;
        }
        enable3dLights() {
          return !!this.ambientLight && !!this.directionalLight;
        }
        getFragmentStyle(t4) {
          if (!t4) return this;
          if (e2.aK(t4)) {
            const i3 = e2.co(t4), o3 = this.fragments.find(({ id: e3 }) => e3 === i3);
            if (!o3) throw new Error(`Style import '${t4}' not found`);
            const s3 = e2.cn(t4);
            return o3.style.getFragmentStyle(s3);
          }
          {
            const e3 = this.fragments.find(({ id: e4 }) => e4 === t4);
            if (!e3) throw new Error(`Style import '${t4}' not found`);
            return e3.style;
          }
        }
        getFeaturesetDescriptors(e3) {
          const t4 = this.getFragmentStyle(e3);
          if (!t4 || !t4.stylesheet.featuresets) return [];
          const i3 = [];
          for (const e4 in t4.stylesheet.featuresets) i3.push({ featuresetId: e4, importId: t4.scope ? t4.scope : void 0 });
          return i3;
        }
        getFeaturesetLayers(t4, i3) {
          const o3 = this.getFragmentStyle(i3), s3 = o3.stylesheet.featuresets;
          if (!s3 || !s3[t4]) return this.fire(new e2.t(new Error(`The featureset '${t4}' does not exist in the map's style and cannot be queried.`))), [];
          const r3 = [];
          for (const e3 of s3[t4].selectors) {
            const t5 = o3.getOwnLayer(e3.layer);
            t5 && r3.push(t5);
          }
          return r3;
        }
        getConfigProperty(t4, i3) {
          const o3 = this.getFragmentStyle(t4);
          if (!o3) return null;
          const s3 = e2.av(i3, o3.scope), r3 = o3.options.get(s3), a4 = r3 ? r3.value || r3.default : null;
          return a4 ? a4.serialize() : null;
        }
        setConfigProperty(t4, i3, o3) {
          const s3 = this.getFragmentStyle(t4);
          if (!s3) return;
          const r3 = s3.stylesheet.schema;
          if (!r3 || !r3[i3]) return;
          const a4 = e2.M(o3);
          if ("success" !== a4.result) return void oo(this, a4.value);
          const n3 = a4.value.expression, l3 = e2.av(i3, s3.scope), c3 = s3.options.get(l3);
          if (!c3) return;
          let h3;
          const { minValue: u4, maxValue: d3, stepValue: _2, type: p3, values: f3 } = r3[i3], m2 = e2.M(r3[i3].default);
          "success" === m2.result && (h3 = m2.value.expression), h3 ? (this.options.set(l3, { ...c3, value: n3, default: h3, minValue: u4, maxValue: d3, stepValue: _2, type: p3, values: f3 }), this.updateConfigDependencies(i3)) : this.fire(new e2.t(new Error(`No schema defined for the config option "${i3}" in the "${t4}" fragment.`)));
        }
        getConfig(t4) {
          const i3 = this.getFragmentStyle(t4);
          if (!i3) return null;
          const o3 = i3.stylesheet.schema;
          if (!o3) return null;
          const s3 = {};
          for (const t5 in o3) {
            const o4 = e2.av(t5, i3.scope), r3 = i3.options.get(o4), a4 = r3 ? r3.value || r3.default : null;
            s3[t5] = a4 ? a4.serialize() : null;
          }
          return s3;
        }
        setConfig(e3, t4) {
          const i3 = this.getFragmentStyle(e3);
          i3 && (i3.updateConfig(t4, i3.stylesheet.schema), this.updateConfigDependencies());
        }
        getSchema(e3) {
          const t4 = this.getFragmentStyle(e3);
          return t4 ? t4.stylesheet.schema : null;
        }
        setSchema(e3, t4) {
          const i3 = this.getFragmentStyle(e3);
          i3 && (i3.stylesheet.schema = t4, i3.updateConfig(i3._config, t4), this.updateConfigDependencies());
        }
        updateConfig(t4, i3) {
          if (this._config = t4, t4 || i3) if (i3) for (const o3 in i3) {
            let s3, r3;
            const a4 = e2.M(i3[o3].default);
            if ("success" === a4.result && (s3 = a4.value.expression), t4 && void 0 !== t4[o3]) {
              const i4 = e2.M(t4[o3]);
              "success" === i4.result && (r3 = i4.value.expression);
            }
            const { minValue: n3, maxValue: l3, stepValue: c3, type: h3, values: u4 } = i3[o3];
            if (s3) {
              const t5 = e2.av(o3, this.scope);
              this.options.set(t5, { default: s3, value: r3, minValue: n3, maxValue: l3, stepValue: c3, type: h3, values: u4 });
            } else this.fire(new e2.t(new Error(`No schema defined for config option "${o3}".`)));
          }
          else this.fire(new e2.t(new Error("Attempting to set config for a style without schema.")));
        }
        updateConfigDependencies(e3) {
          for (const t4 of this._configDependentLayers) {
            const i3 = this.getLayer(t4);
            if (i3) {
              if (e3 && !i3.configDependencies.has(e3)) continue;
              i3.possiblyEvaluateVisibility(), this._updateLayer(i3);
            }
          }
          this.ambientLight && this.ambientLight.updateConfig(this.options), this.directionalLight && this.directionalLight.updateConfig(this.options), this.fog && this.fog.updateConfig(this.options), this.forEachFragmentStyle((e4) => {
            if (e4._styleColorTheme.colorTheme) {
              const t4 = e4._evaluateColorThemeData(e4._styleColorTheme.colorTheme);
              (!e4._styleColorTheme.lut && "" !== t4 || e4._styleColorTheme.lut && t4 !== e4._styleColorTheme.lut.data) && e4.setColorTheme(e4._styleColorTheme.colorTheme);
            }
          }), this._changes.setDirty();
        }
        addLayer(t4, i3, o3 = {}) {
          this._checkLoaded();
          const s3 = t4.id;
          if (this._layers[s3]) return void this.fire(new e2.t(new Error(`Layer with id "${s3}" already exists on this map`)));
          let r3;
          if ("custom" === t4.type) {
            if (oo(this, e2.cp(t4))) return;
            r3 = e2.cq(t4, this.scope, this._styleColorTheme.lut, this.options);
          } else {
            if ("object" == typeof t4.source && (this.addSource(s3, t4.source), t4 = e2.cm(t4), t4 = e2.m(t4, { source: s3 })), this._validate(we2, `layers.${s3}`, t4, { arrayIndex: -1 }, o3)) return;
            r3 = e2.cq(t4, this.scope, this._styleColorTheme.lut, this.options), this._validateLayer(r3), r3.setEventedParent(this, { layer: { id: s3 } });
          }
          0 !== r3.configDependencies.size && this._configDependentLayers.add(r3.fqid);
          let a4 = this._order.length;
          if (i3) {
            const t5 = this._order.indexOf(i3);
            if (-1 === t5) return void this.fire(new e2.t(new Error(`Layer with id "${i3}" does not exist on this map.`)));
            r3.slot === this._layers[i3].slot ? a4 = t5 : e2.w(`Layer with id "${i3}" has a different slot. Layers can only be rearranged within the same slot.`);
          }
          this._order.splice(a4, 0, s3), this._layerOrderChanged = true, this._layers[s3] = r3;
          const n3 = this.getOwnLayerSourceCache(r3), l3 = !!this.directionalLight && this.directionalLight.shadowsEnabled();
          n3 && r3.canCastShadows() && l3 && (n3.castsShadows = true);
          const c3 = this._changes.getRemovedLayer(r3);
          if (c3 && r3.source && n3 && "custom" !== r3.type) {
            this._changes.discardLayerRemoval(r3);
            const t5 = e2.av(r3.source, r3.scope);
            c3.type !== r3.type ? this._changes.updateSourceCache(t5, "clear") : (this._changes.updateSourceCache(t5, "reload"), n3.pause());
          }
          this._updateLayer(r3), r3.onAdd && r3.onAdd(this.map), r3.scope = this.scope, this.mergeLayers();
        }
        moveLayer(t4, i3) {
          this._checkLoaded();
          const o3 = this._checkLayer(t4);
          if (!o3) return;
          if (t4 === i3) return;
          const s3 = this._order.indexOf(t4);
          this._order.splice(s3, 1);
          let r3 = this._order.length;
          if (i3) {
            const t5 = this._order.indexOf(i3);
            if (-1 === t5) return void this.fire(new e2.t(new Error(`Layer with id "${i3}" does not exist on this map.`)));
            o3.slot === this._layers[i3].slot ? r3 = t5 : e2.w(`Layer with id "${i3}" has a different slot. Layers can only be rearranged within the same slot.`);
          }
          this._order.splice(r3, 0, t4), this._changes.setDirty(), this._layerOrderChanged = true, this.mergeLayers();
        }
        removeLayer(e3) {
          this._checkLoaded();
          const t4 = this._checkLayer(e3);
          if (!t4) return;
          t4.setEventedParent(null);
          const i3 = this._order.indexOf(e3);
          this._order.splice(i3, 1), delete this._layers[e3], this._changes.setDirty(), this._layerOrderChanged = true, this._configDependentLayers.delete(t4.fqid), this._changes.removeLayer(t4);
          const o3 = this.getOwnLayerSourceCache(t4);
          if (o3 && o3.castsShadows) {
            let e4 = false;
            for (const i4 in this._layers) if (this._layers[i4].source === t4.source && this._layers[i4].canCastShadows()) {
              e4 = true;
              break;
            }
            o3.castsShadows = e4;
          }
          t4.onRemove && t4.onRemove(this.map), this.mergeLayers();
        }
        getOwnLayer(e3) {
          return this._layers[e3];
        }
        hasLayer(e3) {
          return e3 in this._mergedLayers;
        }
        hasLayerType(e3) {
          for (const t4 in this._layers) if (this._layers[t4].type === e3) return true;
          return false;
        }
        setLayerZoomRange(e3, t4, i3) {
          this._checkLoaded();
          const o3 = this._checkLayer(e3);
          o3 && (o3.minzoom === t4 && o3.maxzoom === i3 || (null != t4 && (o3.minzoom = t4), null != i3 && (o3.maxzoom = i3), this._updateLayer(o3)));
        }
        getSlots() {
          return this._checkLoaded(), this._mergedSlots;
        }
        setSlot(e3, t4) {
          this._checkLoaded();
          const i3 = this._checkLayer(e3);
          i3 && i3.slot !== t4 && (i3.slot = t4, this._updateLayer(i3));
        }
        setFilter(t4, i3, o3 = {}) {
          this._checkLoaded();
          const s3 = this._checkLayer(t4);
          if (s3 && !e2.bi(s3.filter, i3)) return null == i3 ? (s3.filter = void 0, void this._updateLayer(s3)) : void (this._validate(Te, `layers.${s3.id}.filter`, i3, { layerType: s3.type }, o3) || (s3.filter = e2.cm(i3), this._updateLayer(s3)));
        }
        getFilter(t4) {
          const i3 = this._checkLayer(t4);
          if (i3) return e2.cm(i3.filter);
        }
        setLayoutProperty(t4, i3, o3, s3 = {}) {
          this._checkLoaded();
          const r3 = this._checkLayer(t4);
          if (r3 && !e2.bi(r3.getLayoutProperty(i3), o3)) {
            if (null != o3 && (!s3 || false !== s3.validate) && oo(r3, Se.call(me, { key: `layers.${t4}.layout.${i3}`, layerType: r3.type, objectKey: i3, value: o3, styleSpec: e2._, style: { glyphs: true, sprite: true } }))) return;
            r3.setLayoutProperty(i3, o3), 0 !== r3.configDependencies.size && this._configDependentLayers.add(r3.fqid), this._updateLayer(r3);
          }
        }
        getLayoutProperty(e3, t4) {
          const i3 = this._checkLayer(e3);
          if (i3) return i3.getLayoutProperty(t4);
        }
        setPaintProperty(t4, i3, o3, s3 = {}) {
          this._checkLoaded();
          const r3 = this._checkLayer(t4);
          if (!r3) return;
          if (e2.bi(r3.getPaintProperty(i3), o3)) return;
          if (null != o3 && (!s3 || false !== s3.validate) && oo(r3, Ee.call(me, { key: `layers.${t4}.paint.${i3}`, layerType: r3.type, objectKey: i3, value: o3, styleSpec: e2._ }))) return;
          const a4 = r3.setPaintProperty(i3, o3);
          0 !== r3.configDependencies.size && this._configDependentLayers.add(r3.fqid), a4 && this._updateLayer(r3), this._changes.updatePaintProperties(r3);
        }
        getPaintProperty(e3, t4) {
          const i3 = this._checkLayer(e3);
          if (i3) return i3.getPaintProperty(t4);
        }
        setFeatureState(t4, i3) {
          this._checkLoaded();
          const o3 = t4.featureset;
          if (o3) {
            if ("featuresetId" in o3) {
              const e3 = this.getFragmentStyle(o3.importId), s4 = e3.getFeaturesetLayers(o3.featuresetId);
              for (const { source: o4, sourceLayer: r4 } of s4) e3.setFeatureState({ id: t4.id, source: o4, sourceLayer: r4 }, i3);
            } else if ("layerId" in o3) {
              const e3 = this.getLayer(o3.layerId);
              this.setFeatureState({ id: t4.id, source: e3.source, sourceLayer: e3.sourceLayer }, i3);
            }
            return;
          }
          const s3 = t4.source, r3 = t4.sourceLayer, a4 = this._checkSource(s3);
          if (!a4) return;
          const n3 = a4.type;
          if ("geojson" === n3 && r3) return void this.fire(new e2.t(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
          if ("vector" === n3 && !r3) return void this.fire(new e2.t(new Error("The sourceLayer parameter must be provided for vector source types.")));
          void 0 === t4.id && this.fire(new e2.t(new Error("The feature id parameter must be provided.")));
          const l3 = this.getOwnSourceCaches(s3);
          for (const e3 of l3) e3.setFeatureState(r3, t4.id, i3);
        }
        removeFeatureState(t4, i3) {
          this._checkLoaded();
          const o3 = t4.featureset;
          if (o3) {
            if ("featuresetId" in o3) {
              const e3 = this.getFragmentStyle(o3.importId), s4 = e3.getFeaturesetLayers(o3.featuresetId);
              for (const { source: o4, sourceLayer: r4 } of s4) e3.removeFeatureState({ id: t4.id, source: o4, sourceLayer: r4 }, i3);
            } else if ("layerId" in o3) {
              const e3 = this.getLayer(o3.layerId);
              this.removeFeatureState({ id: t4.id, source: e3.source, sourceLayer: e3.sourceLayer }, i3);
            }
            return;
          }
          const s3 = t4.source, r3 = this._checkSource(s3);
          if (!r3) return;
          const a4 = r3.type, n3 = "vector" === a4 ? t4.sourceLayer : void 0;
          if ("vector" === a4 && !n3) return void this.fire(new e2.t(new Error("The sourceLayer parameter must be provided for vector source types.")));
          if (i3 && "string" != typeof t4.id && "number" != typeof t4.id) return void this.fire(new e2.t(new Error("A feature id is required to remove its specific state property.")));
          const l3 = this.getOwnSourceCaches(s3);
          for (const e3 of l3) e3.removeFeatureState(n3, t4.id, i3);
        }
        getFeatureState(t4) {
          this._checkLoaded();
          const i3 = t4.featureset;
          if (i3) {
            let o4;
            if ("featuresetId" in i3) {
              const s4 = this.getFragmentStyle(i3.importId), r4 = s4.getFeaturesetLayers(i3.featuresetId);
              for (const { source: i4, sourceLayer: a4 } of r4) {
                const r5 = s4.getFeatureState({ id: t4.id, source: i4, sourceLayer: a4 });
                if (r5 && !o4) o4 = r5;
                else if (!e2.bi(o4, r5)) return void this.fire(new e2.t(new Error("The same feature id exists in multiple sources in the featureset, but their feature states are not consistent through the sources.")));
              }
            } else if ("layerId" in t4) {
              const e3 = this.getLayer(i3.layerId);
              o4 = this.getFeatureState({ id: t4.id, source: e3.source, sourceLayer: e3.sourceLayer });
            }
            return o4;
          }
          const o3 = t4.source, s3 = t4.sourceLayer, r3 = this._checkSource(o3);
          if (r3) {
            if ("vector" !== r3.type || s3) return void 0 === t4.id && this.fire(new e2.t(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(o3)[0].getFeatureState(s3, t4.id);
            this.fire(new e2.t(new Error("The sourceLayer parameter must be provided for vector source types.")));
          }
        }
        setTransition(t4) {
          return this.stylesheet.transition = e2.m({}, this.stylesheet.transition, t4), this.transition = this.stylesheet.transition, this;
        }
        getTransition() {
          return e2.m({}, this.stylesheet.transition);
        }
        serialize() {
          this._checkLoaded();
          const t4 = this.getTerrain(), i3 = t4 && this.terrain && this.terrain.scope === this.scope ? t4 : this.stylesheet.terrain;
          return e2.cr({ version: this.stylesheet.version, name: this.stylesheet.name, metadata: this.stylesheet.metadata, fragment: this.stylesheet.fragment, imports: this._serializeImports(), schema: this.stylesheet.schema, camera: this.stylesheet.camera, light: this.stylesheet.light, lights: this.stylesheet.lights, terrain: i3, fog: this.stylesheet.fog, center: this.stylesheet.center, "color-theme": this.stylesheet["color-theme"], zoom: this.stylesheet.zoom, bearing: this.stylesheet.bearing, pitch: this.stylesheet.pitch, sprite: this.stylesheet.sprite, glyphs: this.stylesheet.glyphs, transition: this.stylesheet.transition, projection: this.stylesheet.projection, sources: this._serializeSources(), layers: this._serializeLayers(this._order) }, (e3) => void 0 !== e3);
        }
        _updateFilteredLayers(e3) {
          for (const t4 of Object.values(this._mergedLayers)) e3(t4) && this._updateLayer(t4);
        }
        _updateLayer(t4) {
          this._changes.updateLayer(t4);
          const i3 = this.getLayerSourceCache(t4), o3 = e2.av(t4.source, t4.scope), s3 = this._changes.getUpdatedSourceCaches();
          t4.source && !s3[o3] && i3 && "raster" !== i3.getSource().type && (this._changes.updateSourceCache(o3, "reload"), i3.pause()), t4.invalidateCompiledFilter();
        }
        _flattenAndSortRenderedFeatures(e3) {
          const t4 = (e4) => this._mergedLayers[e4].is3D(), i3 = this.order, o3 = {}, s3 = [];
          for (let r4 = i3.length - 1; r4 >= 0; r4--) {
            const a4 = i3[r4];
            if (t4(a4)) {
              o3[a4] = r4;
              for (const t5 of e3) {
                const e4 = t5[a4];
                if (e4) for (const t6 of e4) s3.push(t6);
              }
            }
          }
          s3.sort((e4, t5) => t5.intersectionZ - e4.intersectionZ);
          const r3 = [];
          for (let a4 = i3.length - 1; a4 >= 0; a4--) {
            const n3 = i3[a4];
            if (t4(n3)) for (let e4 = s3.length - 1; e4 >= 0; e4--) {
              const t5 = s3[e4].feature;
              if (t5.layer && o3[t5.layer.id] < a4) break;
              r3.push(t5), s3.pop();
            }
            else for (const t5 of e3) {
              const e4 = t5[n3];
              if (e4) for (const t6 of e4) r3.push(t6.feature);
            }
          }
          return r3;
        }
        queryRenderedFeatures(t4, i3, o3) {
          i3 && !Array.isArray(i3) && i3.filter && this._validate(Te, "queryRenderedFeatures.filter", i3.filter, null, i3);
          let s3, r3 = false;
          const a4 = /* @__PURE__ */ new Set();
          if (i3 && i3.layers) {
            if (!Array.isArray(i3.layers)) return this.fire(new e2.t(new Error("parameters.layers must be an Array."))), [];
            s3 = [];
            for (const t5 of i3.layers) {
              const i4 = this._mergedLayers[t5];
              if (!i4) return this.fire(new e2.t(new Error(`The layer '${t5}' does not exist in the map's style and cannot be queried for features.`))), [];
              i4.is3D() && (r3 = true), a4.add(i4.source), s3.push(t5);
            }
          } else r3 = this.has3DLayers();
          const n3 = this._queryRenderedFeatures(t4, o3, { layerIds: s3, filter: i3.filter, has3DLayers: r3, includedSources: a4 }), l3 = this._flattenAndSortRenderedFeatures(n3), c3 = [];
          for (const t5 of l3) e2.co(t5.layer.id) === this.scope && c3.push(t5);
          return c3;
        }
        queryRenderedFeaturesForInteractions(t4, i3, o3) {
          let s3 = [];
          for (const { featureset: r4, filter: a5, radius: n4 } of i3) {
            let i4 = false;
            const l3 = [], c3 = /* @__PURE__ */ new Set();
            if ("featuresetId" in r4) {
              const e3 = this.getFeaturesetLayers(r4.featuresetId, r4.importId);
              if (0 === e3.length) continue;
              for (const t5 of e3) t5.is3D() && (i4 = true), c3.add(t5.source), l3.push(t5.fqid);
            } else if ("layerId" in r4) {
              const t5 = this._mergedLayers[r4.layerId];
              if (!t5) return this.fire(new e2.t(new Error(`The layer '${r4.layerId}' does not exist in the map's style and cannot be queried for features.`))), [];
              t5.is3D() && (i4 = true), c3.add(t5.source), l3.push(r4.layerId);
            }
            let h3 = t4;
            if (n4) if (t4 instanceof e2.P || "number" == typeof t4[0]) {
              const i5 = e2.P.convert(t4);
              h3 = [[i5.x - n4, i5.y - n4], [i5.x + n4, i5.y + n4]];
            } else {
              const i5 = e2.P.convert(t4[0]), o4 = e2.P.convert(t4[1]);
              h3 = [[i5.x - n4, i5.y - n4], [o4.x + n4, o4.y + n4]];
            }
            s3 = s3.concat(this._queryRenderedFeatures(h3, o3, { layerIds: l3, filter: a5, has3DLayers: i4, includedSources: c3 }));
          }
          const r3 = this._flattenAndSortRenderedFeatures(s3), a4 = (e3, t5, i4) => {
            const o4 = e3.clone();
            if (delete o4.layer, o4.featureset = t5, i4 && i4.featureNamespace && (o4.namespace = i4.featureNamespace), i4 && i4.properties) {
              const t6 = {}, s4 = this.map.transform.zoom;
              for (const o5 of Object.keys(i4.properties)) {
                const r4 = i4.properties[o5].evaluate({ zoom: s4 }, e3._vectorTileFeature, e3.state, e3.tile, this._availableImages);
                null != r4 && (t6[o5] = r4);
              }
              o4.properties = t6;
            }
            return o4;
          }, n3 = [];
          for (const t5 of r3) {
            const o4 = t5.layer.id, s4 = e2.cn(o4), r4 = e2.co(o4);
            for (const { featureset: e3 } of i3) {
              if ("layerId" in e3 && e3.layerId !== o4) continue;
              if ("layerId" in e3 && e3.layerId === o4) {
                const i5 = a4(t5, e3);
                n3.push(i5);
                continue;
              }
              if ("featuresetId" in e3) {
                if (e3.importId !== r4) continue;
                if (!this.getFeaturesetLayers(e3.featuresetId, e3.importId).map((e4) => e4.id).includes(s4)) continue;
              }
              const i4 = this._mergedLayerSelectors.get(o4) || [];
              for (const o5 of i4) {
                const i5 = a4(t5, e3, o5);
                n3.push(i5);
              }
            }
          }
          return n3;
        }
        _queryRenderedFeatures(t4, i3, o3) {
          const { layerIds: s3, filter: r3, has3DLayers: a4, includedSources: n3 } = o3, l3 = [], c3 = je.createFromScreenPoints(t4, i3);
          for (const e3 in this._mergedSourceCaches) {
            if (!this._mergedSourceCaches[e3].getSource()) continue;
            const t5 = this._mergedSourceCaches[e3].getSource().id;
            s3 && !n3.has(t5) || l3.push(tt(this._mergedSourceCaches[e3], this._mergedLayers, c3, r3, s3 || [], this._availableImages, i3, a4, !!this.map._showQueryGeometry));
          }
          return this.placement && l3.push(function(t5, i4, o4, s4, r4, a5, n4, l4) {
            const c4 = {}, h3 = n4.queryRenderedSymbols(o4), u4 = [];
            for (const e3 of Object.keys(h3).map(Number)) u4.push(l4[e3]);
            u4.sort(ot);
            for (const e3 of u4) {
              const i5 = e3.featureIndex.lookupSymbolFeatures(h3[e3.bucketInstanceId], e3.bucketIndex, e3.sourceLayerIndex, s4, r4, a5, t5);
              for (const t6 in i5) {
                const o5 = c4[t6] = c4[t6] || [], s5 = i5[t6];
                s5.sort((t7, i6) => {
                  const o6 = e3.featureSortOrder;
                  if (o6) {
                    const e4 = o6.indexOf(t7.featureIndex);
                    return o6.indexOf(i6.featureIndex) - e4;
                  }
                  return i6.featureIndex - t7.featureIndex;
                });
                for (const e4 of s5) o5.push(e4);
              }
            }
            for (const o5 in c4) c4[o5].forEach((s5) => {
              const r5 = s5.feature, a6 = t5[o5], n5 = i4(a6);
              if (!n5) return;
              const l5 = n5.getFeatureState(r5.layer["source-layer"], r5.id);
              r5.state = l5, e2.aK(a6.id) || (r5.source = r5.layer.source, r5.layer["source-layer"] && (r5.sourceLayer = r5.layer["source-layer"]));
            });
            return c4;
          }(this._mergedLayers, this.getLayerSourceCache.bind(this), c3.screenGeometry, r3, s3 || [], this._availableImages, this.placement.collisionIndex, this.placement.retainedQueryData)), l3;
        }
        querySourceFeatures(e3, t4) {
          const i3 = t4 && t4.filter;
          i3 && this._validate(Te, "querySourceFeatures.filter", i3, null, t4);
          let o3 = [];
          const s3 = this.getOwnSourceCaches(e3);
          for (const e4 of s3) o3 = o3.concat(it2(e4, t4));
          return o3;
        }
        addSourceType(e3, t4, i3) {
          return lo.getSourceType(e3) ? i3(new Error(`A source type called "${e3}" already exists.`)) : (lo.setSourceType(e3, t4), t4.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", { name: e3, url: t4.workerSourceURL }, i3) : i3(null, null));
        }
        getFlatLight() {
          return this.light.getLight();
        }
        setFlatLight(t4, i3, o3 = {}) {
          this._checkLoaded();
          const s3 = this.light.getLight();
          let r3 = false;
          for (const i4 in t4) if (!e2.bi(t4[i4], s3[i4])) {
            r3 = true;
            break;
          }
          if (!r3) return;
          const a4 = this._getTransitionParameters();
          this.light.setLight(t4, i3, o3), this.light.updateTransitions(a4);
        }
        getTerrain() {
          return this.terrain && 1 === this.terrain.drapeRenderMode ? this.terrain.get() : null;
        }
        setTerrainForDraping() {
          this.setTerrain({ source: "", exaggeration: 0 }, 0);
        }
        checkCanvasFingerprintNoise() {
          void 0 === this.disableElevatedTerrain && (this.disableElevatedTerrain = e2.e.hasCanvasFingerprintNoise(), this.disableElevatedTerrain && e2.w("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode)."));
        }
        setTerrain(t4, i3 = 1) {
          if (this._checkLoaded(), !t4) return this.terrainSetForDrapingOnly() || (delete this.terrain, this.map.transform.projection.requiresDraping && this.setTerrainForDraping()), 0 === i3 && delete this.terrain, null === t4 ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = true);
          this.checkCanvasFingerprintNoise();
          let o3 = t4;
          const s3 = null == t4.source;
          if (1 === i3) {
            if (this.disableElevatedTerrain) return;
            if ("object" == typeof o3.source) {
              const t6 = "terrain-dem-src";
              this.addSource(t6, o3.source), o3 = e2.cm(o3), o3 = e2.m(o3, { source: t6 });
            }
            const t5 = e2.m({}, o3), i4 = {};
            if (this.terrain && s3) {
              t5.source = this.terrain.get().source;
              const e3 = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
              e3 && (i4.style = e3.serialize());
            }
            if (this._validate(ye, "terrain", t5, i4)) return;
          }
          if (!this.terrain || this.terrain.scope !== this.scope && !s3 || this.terrain && i3 !== this.terrain.drapeRenderMode) {
            if (!o3) return;
            this._createTerrain(o3, i3), this.fire(new e2.x("data", { dataType: "style" }));
          } else {
            const i4 = this.terrain, s4 = i4.get();
            for (const t5 of Object.keys(e2._.terrain)) !o3.hasOwnProperty(t5) && e2._.terrain[t5].default && (o3[t5] = e2._.terrain[t5].default);
            for (const o4 in t4) if (!e2.bi(t4[o4], s4[o4])) {
              i4.set(t4, this.options), this.stylesheet.terrain = t4;
              const o5 = this._getTransitionParameters({ duration: 0 });
              i4.updateTransitions(o5), this.fire(new e2.x("data", { dataType: "style" }));
              break;
            }
          }
          this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = true;
        }
        _createFog(e3) {
          const t4 = this.fog = new Ne(e3, this.map.transform, this.scope, this.options);
          this.stylesheet.fog = t4.get();
          const i3 = this._getTransitionParameters({ duration: 0 });
          t4.updateTransitions(i3);
        }
        _updateMarkersOpacity() {
          0 !== this.map._markers.length && this.map._requestDomTask(() => {
            for (const e3 of this.map._markers) e3._evaluateOpacity();
          });
        }
        getFog() {
          return this.fog ? this.fog.get() : null;
        }
        setFog(t4) {
          if (this._checkLoaded(), !t4) return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = true);
          if (this.fog) {
            const i3 = this.fog;
            if (!e2.bi(i3.get(), t4)) {
              i3.set(t4, this.options), this.stylesheet.fog = i3.get();
              const e3 = this._getTransitionParameters({ duration: 0 });
              i3.updateTransitions(e3);
            }
          } else this._createFog(t4);
          this._markersNeedUpdate = true;
        }
        setColorTheme(t4) {
          this._checkLoaded();
          const i3 = () => {
            for (const e3 in this._layers) this._layers[e3].lut = this._styleColorTheme.lut;
            for (const e3 in this._sourceCaches) this._sourceCaches[e3].clearTiles();
          };
          if (this._styleColorTheme.colorTheme = t4, !t4) return this._styleColorTheme.lut = null, void i3();
          const o3 = this._evaluateColorThemeData(t4);
          this._loadColorTheme(o3).then(() => {
            this.fire(new e2.x("colorthemeset")), i3();
          }).catch((t5) => {
            e2.w(`Couldn't set color theme: ${t5}`);
          });
        }
        _getTransitionParameters(t4) {
          return { now: e2.e.now(), transition: e2.m(this.transition, t4) };
        }
        updateDrapeFirstLayers() {
          if (!this.terrain) return;
          const e3 = [], t4 = [];
          for (const i3 of this._mergedOrder) this.isLayerDraped(this._mergedLayers[i3]) ? e3.push(i3) : t4.push(i3);
          this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e3), this._drapedFirstOrder.push(...t4);
        }
        _createTerrain(e3, t4) {
          const i3 = this.terrain = new Le(e3, t4, this.scope, this.options);
          1 === t4 && (this.stylesheet.terrain = e3), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
          const o3 = this._getTransitionParameters({ duration: 0 });
          i3.updateTransitions(o3);
        }
        _force3DLayerUpdate() {
          for (const e3 in this._layers) {
            const t4 = this._layers[e3];
            "fill-extrusion" === t4.type && this._updateLayer(t4);
          }
        }
        _forceSymbolLayerUpdate() {
          for (const e3 in this._layers) {
            const t4 = this._layers[e3];
            "symbol" === t4.type && this._updateLayer(t4);
          }
        }
        _validate(t4, i3, o3, s3, r3 = {}) {
          if (r3 && false === r3.validate) return false;
          const a4 = e2.m({}, this.serialize());
          return oo(this, t4.call(me, e2.m({ key: i3, style: a4, value: o3, styleSpec: e2._ }, s3)));
        }
        _remove() {
          this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), e2.cs.off("pluginStateChange", this._rtlTextPluginCallback);
          for (const e3 in this._mergedLayers) this._mergedLayers[e3].setEventedParent(null);
          for (const e3 in this._mergedSourceCaches) this._mergedSourceCaches[e3].clearTiles(), this._mergedSourceCaches[e3].setEventedParent(null);
          this.setEventedParent(null), delete this.fog, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.isRootStyle() && (this.imageManager.setEventedParent(null), this.modelManager.setEventedParent(null), this.dispatcher.remove());
        }
        clearSource(e3) {
          const t4 = this.getSourceCaches(e3);
          for (const e4 of t4) e4.clearTiles();
        }
        clearSources() {
          for (const e3 in this._mergedSourceCaches) this._mergedSourceCaches[e3].clearTiles();
        }
        reloadSource(e3) {
          const t4 = this.getSourceCaches(e3);
          for (const e4 of t4) e4.resume(), e4.reload();
        }
        reloadSources() {
          for (const e3 of this.getSources()) e3.reload && e3.reload();
        }
        updateSources(e3) {
          let t4;
          this.directionalLight && (t4 = Yi(this.directionalLight));
          for (const i3 in this._mergedSourceCaches) this._mergedSourceCaches[i3].update(e3, void 0, void 0, t4);
        }
        _generateCollisionBoxes() {
          for (const e3 in this._sourceCaches) {
            const t4 = this._sourceCaches[e3];
            t4.resume(), t4.reload();
          }
        }
        _updatePlacement(t4, i3, o3, s3, r3, a4, n3 = false) {
          let l3 = false, c3 = false;
          const h3 = {}, u4 = {};
          for (const t5 of this._mergedOrder) {
            const o4 = this._mergedLayers[t5];
            if ("symbol" !== o4.type) continue;
            const s4 = e2.av(o4.source, o4.scope);
            let r4 = h3[s4];
            if (!r4) {
              const e3 = this.getLayerSourceCache(o4);
              if (!e3) continue;
              const t6 = e3.getRenderableIds(true).map((t7) => e3.getTileByID(t7));
              u4[s4] = t6.slice(), r4 = h3[s4] = t6.sort((e4, t7) => t7.tileID.overscaledZ - e4.tileID.overscaledZ || (e4.tileID.isLessThan(t7.tileID) ? -1 : 1));
            }
            const a5 = this.crossTileSymbolIndex.addLayer(o4, r4, i3.center.lng, i3.projection);
            l3 = l3 || a5;
          }
          if (this.crossTileSymbolIndex.pruneUnusedLayers(this._mergedOrder), n3 = n3 || this._layerOrderChanged || 0 === s3, this._layerOrderChanged && this.fire(new e2.x("neworder")), (n3 || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(e2.e.now(), i3.zoom)) && (this.pauseablePlacement = new wi(i3, this._mergedOrder, n3, o3, s3, r3, this.placement, this.fog && i3.projection.supportsFog ? this.fog.state : null, this._buildingIndex), this._layerOrderChanged = false), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._mergedOrder, this._mergedLayers, h3, u4, this.map.painter.scaleFactor), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e2.e.now()), c3 = true), l3 && this.pauseablePlacement.placement.setStale()), c3 || l3) {
            this._buildingIndex.onNewFrame(i3.zoom);
            for (let t5 = 0; t5 < this._mergedOrder.length; t5++) {
              const i4 = this._mergedLayers[this._mergedOrder[t5]];
              if ("symbol" !== i4.type) continue;
              const o4 = this.isLayerClipped(i4);
              this.placement.updateLayerOpacities(i4, h3[e2.av(i4.source, i4.scope)], t5, o4 ? a4 : null);
            }
          }
          return { needsRerender: !this.pauseablePlacement.isDone() || this.placement.hasTransitions(e2.e.now()) };
        }
        _releaseSymbolFadeTiles() {
          for (const e3 in this._sourceCaches) this._sourceCaches[e3].releaseSymbolFadeTiles();
        }
        addImport(t4, i3) {
          this._checkLoaded();
          const o3 = this.stylesheet.imports = this.stylesheet.imports || [];
          if (-1 !== o3.findIndex(({ id: e3 }) => e3 === t4.id)) return void this.fire(new e2.t(new Error(`Import with id '${t4.id}' already exists in the map's style.`)));
          if (!i3) return o3.push(t4), this._loadImports([t4], true);
          const s3 = o3.findIndex(({ id: e3 }) => e3 === i3);
          return -1 === s3 && this.fire(new e2.t(new Error(`Import with id "${i3}" does not exist on this map.`))), this.stylesheet.imports = o3.slice(0, s3).concat(t4).concat(o3.slice(s3)), this._loadImports([t4], true, i3);
        }
        updateImport(t4, i3) {
          this._checkLoaded();
          const o3 = this.stylesheet.imports || [], s3 = this.getImportIndex(t4);
          return -1 === s3 ? this : "string" == typeof i3 ? (this.setImportUrl(t4, i3), this) : (i3.url && i3.url !== o3[s3].url && this.setImportUrl(t4, i3.url), e2.bi(i3.config, o3[s3].config) || this.setImportConfig(t4, i3.config), e2.bi(i3.data, o3[s3].data) || this.setImportData(t4, i3.data), this);
        }
        moveImport(e3, t4) {
          this._checkLoaded();
          let i3 = this.stylesheet.imports || [];
          const o3 = this.getImportIndex(e3);
          if (-1 === o3) return this;
          const s3 = this.getImportIndex(t4);
          if (-1 === s3) return this;
          const r3 = i3[o3], a4 = this.fragments[o3];
          return i3 = i3.filter(({ id: t5 }) => t5 !== e3), this.fragments = this.fragments.filter(({ id: t5 }) => t5 !== e3), this.stylesheet.imports = i3.slice(0, s3).concat(r3).concat(i3.slice(s3)), this.fragments = this.fragments.slice(0, s3).concat(a4).concat(this.fragments.slice(s3)), this.mergeLayers(), this;
        }
        setImportUrl(e3, t4) {
          this._checkLoaded();
          const i3 = this.stylesheet.imports || [], o3 = this.getImportIndex(e3);
          if (-1 === o3) return this;
          i3[o3].url = t4;
          const s3 = this.fragments[o3];
          return s3.style = this._createFragmentStyle(i3[o3]), s3.style.on("style.import.load", () => this.mergeAll()), s3.style.loadURL(t4), this;
        }
        setImportData(e3, t4) {
          this._checkLoaded();
          const i3 = this.getImportIndex(e3), o3 = this.stylesheet.imports || [];
          return -1 === i3 ? this : t4 ? (this.fragments[i3].style.setState(t4), this._reloadImports(), this) : (delete o3[i3].data, this.setImportUrl(e3, o3[i3].url));
        }
        setImportConfig(e3, t4) {
          this._checkLoaded();
          const i3 = this.getImportIndex(e3), o3 = this.stylesheet.imports || [];
          if (-1 === i3) return this;
          t4 ? o3[i3].config = t4 : delete o3[i3].config;
          const s3 = this.fragments[i3], r3 = s3.style.stylesheet && s3.style.stylesheet.schema;
          return s3.config = t4, s3.style.updateConfig(t4, r3), this.updateConfigDependencies(), this;
        }
        removeImport(e3) {
          this._checkLoaded();
          const t4 = this.stylesheet.imports || [], i3 = this.getImportIndex(e3);
          -1 !== i3 && (t4.splice(i3, 1), this.fragments[i3].style._remove(), this.fragments.splice(i3, 1), this._reloadImports());
        }
        getImportIndex(t4) {
          const i3 = (this.stylesheet.imports || []).findIndex((e3) => e3.id === t4);
          return -1 === i3 && this.fire(new e2.t(new Error(`Import '${t4}' does not exist in the map's style and cannot be updated.`))), i3;
        }
        getLayer(e3) {
          return this._mergedLayers[e3];
        }
        getSources() {
          const e3 = [];
          for (const t4 in this._mergedOtherSourceCaches) {
            const i3 = this._mergedOtherSourceCaches[t4];
            i3 && e3.push(i3.getSource());
          }
          return e3;
        }
        getSource(e3, t4) {
          const i3 = this.getSourceCache(e3, t4);
          return i3 && i3.getSource();
        }
        getLayerSource(e3) {
          const t4 = this.getLayerSourceCache(e3);
          return t4 && t4.getSource();
        }
        getSourceCache(t4, i3) {
          const o3 = e2.av(t4, i3);
          return this._mergedOtherSourceCaches[o3];
        }
        getLayerSourceCache(t4) {
          const i3 = e2.av(t4.source, t4.scope);
          return "symbol" === t4.type ? this._mergedSymbolSourceCaches[i3] : this._mergedOtherSourceCaches[i3];
        }
        getSourceCaches(e3) {
          if (null == e3) return Object.values(this._mergedSourceCaches);
          const t4 = [];
          return this._mergedOtherSourceCaches[e3] && t4.push(this._mergedOtherSourceCaches[e3]), this._mergedSymbolSourceCaches[e3] && t4.push(this._mergedSymbolSourceCaches[e3]), t4;
        }
        updateSourceCaches() {
          const e3 = this._changes.getUpdatedSourceCaches();
          for (const t4 in e3) {
            const i3 = e3[t4];
            "reload" === i3 ? this.reloadSource(t4) : "clear" === i3 && this.clearSource(t4);
          }
        }
        updateLayers(e3) {
          const t4 = this._changes.getUpdatedPaintProperties();
          for (const i3 of t4) {
            const t5 = this.getLayer(i3);
            t5 && t5.updateTransitions(e3);
          }
        }
        getImages(e3, t4, i3) {
          this.imageManager.getImages(t4.icons, t4.scope, i3), this._updateTilesForChangedImages();
          const o3 = (e4) => {
            e4 && e4.setDependencies(t4.tileID.key, t4.type, t4.icons);
          };
          o3(this._otherSourceCaches[t4.source]), o3(this._symbolSourceCaches[t4.source]);
        }
        getGlyphs(e3, t4, i3) {
          this.glyphManager.getGlyphs(t4.stacks, t4.scope, i3);
        }
        getResource(t4, i3, o3) {
          return e2.ct(i3, o3);
        }
        getOwnSourceCache(e3) {
          return this._otherSourceCaches[e3];
        }
        getOwnLayerSourceCache(e3) {
          return "symbol" === e3.type ? this._symbolSourceCaches[e3.source] : this._otherSourceCaches[e3.source];
        }
        getOwnSourceCaches(e3) {
          const t4 = [];
          return this._otherSourceCaches[e3] && t4.push(this._otherSourceCaches[e3]), this._symbolSourceCaches[e3] && t4.push(this._symbolSourceCaches[e3]), t4;
        }
        _isSourceCacheLoaded(t4) {
          const i3 = this.getOwnSourceCaches(t4);
          return 0 === i3.length ? (this.fire(new e2.t(new Error(`There is no source with ID '${t4}'`))), false) : i3.every((e3) => e3.loaded());
        }
        has3DLayers() {
          return this._has3DLayers;
        }
        hasSymbolLayers() {
          return this._hasSymbolLayers;
        }
        hasCircleLayers() {
          return this._hasCircleLayers;
        }
        isLayerClipped(e3, t4) {
          if (!this._clipLayerPresent && "fill-extrusion" !== e3.type) return false;
          const i3 = "fill-extrusion" === e3.type && "building" === e3.sourceLayer;
          if (e3.is3D()) {
            if (i3 || t4 && "batched-model" === t4.type) return true;
            if ("model" === e3.type) return true;
          } else if ("symbol" === e3.type) return true;
          return false;
        }
        _clearWorkerCaches() {
          this.dispatcher.broadcast("clearCaches");
        }
        destroy() {
          this._clearWorkerCaches(), this.fragments.forEach((e3) => {
            e3.style._remove();
          }), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
        }
      }
      lo.getSourceType = function(e3) {
        return Ye[e3];
      }, lo.setSourceType = function(e3, t4) {
        Ye[e3] = t4;
      }, lo.registerForPluginStateChange = e2.cd;
      var co = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#ifdef RENDER_CUTOFF\nfloat cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}\n#endif", ho = "\nout vec4 glFragColor;highp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}\n#ifdef INDICATOR_CUTOUT\nuniform vec2 u_indicator_cutout_centers;uniform vec4 u_indicator_cutout_params;\n#endif\nvec4 applyCutout(vec4 color) {\n#ifdef INDICATOR_CUTOUT\nfloat holeMinOpacity=u_indicator_cutout_params.x;float holeRadius=max(u_indicator_cutout_params.y,0.0);float holeAspectRatio=u_indicator_cutout_params.z;float fadeStart=u_indicator_cutout_params.w;float distA=distance(vec2(gl_FragCoord.x,gl_FragCoord.y*holeAspectRatio),vec2(u_indicator_cutout_centers[0],u_indicator_cutout_centers[1]*holeAspectRatio));return color*min(smoothstep(fadeStart,holeRadius,distA)+holeMinOpacity,1.0);\n#else\nreturn color;\n#endif\n}\n#ifdef DEBUG_WIREFRAME\n#define HANDLE_WIREFRAME_DEBUG \\\nglFragColor=vec4(0.7,0.0,0.0,0.7); \\\ngl_FragDepth=gl_FragCoord.z-0.0001;\n#else\n#define HANDLE_WIREFRAME_DEBUG\n#endif\n#ifdef RENDER_CUTOFF\nuniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;\n#endif\nvec4 textureLodCustom(sampler2D image,highp vec2 pos,highp vec2 lod_coord) {highp vec2 size=vec2(textureSize(image,0));highp vec2 dx=dFdx(lod_coord.xy*size);highp vec2 dy=dFdy(lod_coord.xy*size);highp float delta_max_sqr=max(dot(dx,dx),dot(dy,dy));highp float lod=0.5*log2(delta_max_sqr);return textureLod(image,pos,lod);}vec4 applyLUT(highp sampler3D lut,vec4 col) {vec3 size=vec3(textureSize(lut,0));vec3 uvw=(col.rbg*float(size-1.0)+0.5)/size;return vec4(texture(lut,uvw).rgb,col.a);}vec3 applyLUT(highp sampler3D lut,vec3 col) {return applyLUT(lut,vec4(col,1.0)).rgb;}", uo = "\n#define EXTENT 8192.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const vec2 units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (units_to_pixels*pos+offset)/pattern_size;}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {return get_pattern_pos(pixel_coord_upper,pixel_coord_lower,pattern_size,vec2(tile_units_to_pixels),pos);}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}\n#ifdef RENDER_CUTOFF\nuniform vec4 u_cutoff_params;out float v_cutoff_opacity;\n#endif\nconst vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(vec2 posWithComposedSkirt)\n{float skirt=float(posWithComposedSkirt.x >=skirtOffset);vec2 pos=posWithComposedSkirt-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}", _o = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", po = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nreturn currentElevation(apos);}\n#endif\nvec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }\n#endif\n#ifdef DEPTH_OCCLUSION\nuniform highp sampler2D u_depth;uniform highp vec2 u_depth_size_inv;uniform highp vec2 u_depth_range_unpack;uniform highp float u_occluder_half_size;uniform highp float u_occlusion_depth_offset;\n#ifdef DEPTH_D24\nfloat unpack_depth(float depth) {return depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}vec4 unpack_depth4(vec4 depth) {return depth*u_depth_range_unpack.x+vec4(u_depth_range_unpack.y);}\n#else\nhighp float unpack_depth_rgba(vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;\n#ifdef DEPTH_D24\nfloat depth=unpack_depth(texture(u_depth,(coord.xy+1.0)*0.5).r);\n#else\nfloat depth=unpack_depth_rgba(texture(u_depth,(coord.xy+1.0)*0.5));\n#endif\nreturn coord.z+u_occlusion_depth_offset > depth;}highp vec4 getCornerDepths(vec2 coord) {highp vec3 df=vec3(u_occluder_half_size*u_depth_size_inv,0.0);highp vec2 uv=0.5*coord.xy+0.5;\n#ifdef DEPTH_D24\nhighp vec4 depth=vec4(\ntexture(u_depth,uv-df.xz).r,texture(u_depth,uv+df.xz).r,texture(u_depth,uv-df.zy).r,texture(u_depth,uv+df.zy).r\n);depth=unpack_depth4(depth);\n#else\nhighp vec4 depth=vec4(\nunpack_depth_rgba(texture(u_depth,uv-df.xz)),unpack_depth_rgba(texture(u_depth,uv+df.xz)),unpack_depth_rgba(texture(u_depth,uv-df.zy)),unpack_depth_rgba(texture(u_depth,uv+df.zy))\n);\n#endif\nreturn depth;}highp float occlusionFadeMultiSample(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec2 uv=0.5*coord.xy+0.5;int NX=3;int NY=4;highp vec2 df=u_occluder_half_size*u_depth_size_inv;highp vec2 oneStep=2.0*u_occluder_half_size*u_depth_size_inv/vec2(NX-1,NY-1);highp float res=0.0;for (int y=0; y < NY;++y) {for (int x=0; x < NX;++x) {\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)));\n#endif\nres+=1.0-clamp(300.0*(coord.z+u_occlusion_depth_offset-depth),0.0,1.0);}}res=clamp(2.0*res/float(NX*NY)-0.5,0.0,1.0);return res;}highp float occlusionFade(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec4 depth=getCornerDepths(coord.xy);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z+u_occlusion_depth_offset)-depth),0.0,1.0));}\n#else\nbool isOccluded(vec4 frag) { return false; }highp float occlusionFade(vec4 frag) { return 1.0; }highp float occlusionFadeMultiSample(vec4 frag) { return 1.0; }\n#endif//DEPTH_OCCLUSION", fo = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", mo = "highp vec3 hash(highp vec2 p) {highp vec3 p3=fract(p.xyx*vec3(443.8975,397.2973,491.1871));p3+=dot(p3,p3.yxz+19.19);return fract((p3.xxy+p3.yzz)*p3.zyx);}vec3 dither(vec3 color,highp vec2 seed) {vec3 rnd=hash(seed)+hash(seed+0.59374)-0.5;return color+rnd/255.0;}\n#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {\n#ifdef FOG_DITHERING\nvec2 dither_seed=gl_FragCoord.xy+u_fog_temporal_offset;return dither(color,dither_seed);\n#else\nreturn color;\n#endif\n}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif", go = "#ifdef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);ivec4 _raTexLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}vec2 _raTexLinearMix(highp vec2 fxy,highp vec4 colorMix,highp float colorOffset,highp vec4 t00,highp vec4 t10,highp vec4 t01,highp vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image0,c.yz,0),texelFetch(u_image0,c.xz,0),texelFetch(u_image0,c.yw,0),texelFetch(u_image0,c.xw,0)\n);}vec2 raTexture2D_image1_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image1,c.yz,0),texelFetch(u_image1,c.xz,0),texelFetch(u_image1,c.yw,0),texelFetch(u_image1,c.xw,0)\n);}vec2 raTexture2D_image0_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image0,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image1,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}\n#endif", vo = "#ifdef RASTER_ARRAY\nuniform sampler2D u_velocity;uniform mediump vec2 u_velocity_res;uniform mediump float u_max_speed;const vec4 NO_DATA=vec4(1);const vec2 INVALID_VELOCITY=vec2(-1);uniform highp vec2 u_uv_offset;uniform highp float u_data_offset;uniform highp vec2 u_data_scale;ivec4 rasterArrayLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}highp vec2 lookup_velocity(highp vec2 uv) {uv=u_uv_offset.x+u_uv_offset.y*uv;highp vec2 fxy;ivec4 c=rasterArrayLinearCoord(uv,u_velocity_res,fxy);highp vec4 tl=texelFetch(u_velocity,c.yz,0);highp vec4 tr=texelFetch(u_velocity,c.xz,0);highp vec4 bl=texelFetch(u_velocity,c.yw,0);highp vec4 br=texelFetch(u_velocity,c.xw,0);if (tl==NO_DATA) {return INVALID_VELOCITY;}if (tr==NO_DATA) {return INVALID_VELOCITY;}if (bl==NO_DATA) {return INVALID_VELOCITY;}if (br==NO_DATA) {return INVALID_VELOCITY;}highp vec4 t=mix(mix(bl,br,fxy.x),mix(tl,tr,fxy.x),fxy.y);highp vec2 velocity=u_data_offset+vec2(dot(t.rg,u_data_scale),dot(t.ba,u_data_scale));velocity.y=-velocity.y;velocity/=max(u_max_speed,length(velocity));return velocity;}\n#endif\nuniform highp float u_particle_pos_scale;uniform highp vec2 u_particle_pos_offset;highp vec4 pack_pos_to_rgba(highp vec2 p) {highp vec2 v=(p+u_particle_pos_offset)/u_particle_pos_scale;highp vec4 r=vec4(v.x,fract(v.x*255.0),v.y,fract(v.y*255.0));return vec4(r.x-r.y/255.0,r.y,r.z-r.w/255.0,r.w);}highp vec2 unpack_pos_from_rgba(highp vec4 v) {v=floor(v*255.0+0.5)/255.0;highp vec2 p=vec2(v.x+(v.y/255.0),v.z+(v.w/255.0));return u_particle_pos_scale*p-u_particle_pos_offset;}", xo = "#ifdef RENDER_SHADOWS\nuniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {vec3 transformed_normal=vec3(-normal.xy,normal.z);float NDotL=dot(normalize(transformed_normal),u_shadow_direction);float dotScale=min(1.0-NDotL,1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}\n#endif//RENDER_SHADOWS", yo = "#ifdef RENDER_SHADOWS\n#ifdef DEPTH_TEXTURE\nuniform highp sampler2D u_shadowmap_0;uniform highp sampler2D u_shadowmap_1;\n#else\nuniform sampler2D u_shadowmap_0;uniform sampler2D u_shadowmap_1;\n#endif\nuniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;highp float shadow_sample_1(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_1,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_1,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}highp float shadow_sample_0(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_0,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_0,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}float shadow_occlusion_1(highp vec4 pos,highp float bias) {highp vec2 uv=pos.xy;return shadow_sample_1(uv,pos.z-bias);}float shadow_occlusion_0(highp vec4 pos,highp float bias) {highp float compare0=pos.z-bias;\n#ifdef TEXTURE_GATHER\nhighp vec2 uv=pos.xy;highp vec4 samples=textureGather(u_shadowmap_0,uv,0);lowp vec4 stepSamples=step(samples,vec4(compare0));\n#else\nhighp vec2 uv00=pos.xy-vec2(0.5*u_shadow_texel_size);highp vec2 uv10=uv00+vec2(u_shadow_texel_size,0.0);highp vec2 uv01=uv00+vec2(0.0,u_shadow_texel_size);highp vec2 uv11=uv01+vec2(u_shadow_texel_size,0.0);lowp vec4 stepSamples=vec4(\nshadow_sample_0(uv01,compare0),shadow_sample_0(uv11,compare0),shadow_sample_0(uv10,compare0),shadow_sample_0(uv00,compare0)\n);\n#endif\nvec2 f=fract(pos.xy*u_shadow_map_resolution-vec2(0.5));lowp vec2 lerpx=mix(stepSamples.wx,stepSamples.zy,f.xx);return mix(lerpx.x,lerpx.y,f.y);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {\n#ifdef SHADOWS_SINGLE_CASCADE\nlight_view_pos0.xyz=light_view_pos0.xyz/light_view_pos0.w*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);\n#else\nlight_view_pos0.xyz/=light_view_pos0.w;light_view_pos1.xyz/=light_view_pos1.w;vec4 uv=vec4(light_view_pos0.xy,light_view_pos1.xy);vec4 abs_bounds=abs(uv);if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {light_view_pos0.xyz=light_view_pos0.xyz*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}light_view_pos1.xyz=light_view_pos1.xyz*0.5+0.5;float occlusion1=shadow_occlusion_1(light_view_pos1,bias);return mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth));\n#endif\n}highp float calculate_shadow_bias(float NDotL) {\n#ifdef NORMAL_OFFSET\nreturn 0.5*u_shadow_bias.x;\n#else\nreturn 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));\n#endif\n}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_opacity(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,float shadow_opacity) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias)*shadow_opacity;return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}\n#endif";
      const bo = [];
      Io(co, bo), Io(uo, bo), Io(ho, bo);
      const wo = { "_prelude_fog.vertex.glsl": fo, "_prelude_terrain.vertex.glsl": po, "_prelude_shadow.vertex.glsl": xo, "_prelude_fog.fragment.glsl": mo, "_prelude_shadow.fragment.glsl": yo, "_prelude_lighting.glsl": "\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}\n#endif//LIGHTING_3D_MODE", "_prelude_raster_array.glsl": go, "_prelude_raster_particle.glsl": vo }, To = {};
      Do("", po), Do(mo, fo), Do(yo, xo), Do(go, ""), Do(vo, "");
      const Eo = Do(ho, uo), So = co;
      var Co = { background: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec4 u_color;uniform float u_opacity;\n#ifdef LIGHTING_3D_MODE\nin vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_lighting.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec4 u_color;out vec4 v_color;uniform float u_emissive_strength;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), backgroundPattern: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in highp vec2 v_pos;void main() {highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=textureLodCustom(u_image,pos,v_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec2 u_pattern_units_to_pixels;in vec2 a_pos;out highp vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_pattern_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), circle: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float blur_positive=blur < 0.0 ? 0.0 : 1.0;lowp float antialiasblur=v_data.z;float extrude_length=length(extrude)+antialiasblur*(1.0-blur_positive);float antialiased_blur=-max(abs(blur),antialiasblur);float opacity_t=smoothstep((1.0-blur_positive)*antialiased_blur,blur_positive*antialiased_blur,extrude_length-1.0)-smoothstep(0.0,antialiasblur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\nglFragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);float height=circle_elevation(circle_center);world_center=vec4(circle_center,height,1);\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}'), clippingMask: Do("void main() {glFragColor=vec4(1.0);}", "in vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), heatmap: Do('#include "_prelude_fog.fragment.glsl"\nuniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'), heatmapTexture: Do("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"), collisionBox: Do("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", '#include "_prelude_terrain.vertex.glsl"\nin vec3 a_pos;in vec2 a_anchor_pos;in vec2 a_extrude;in vec2 a_placed;in vec2 a_shift;in vec2 a_elevation_from_sea;in float a_size_scale;in vec2 a_padding;in float a_auto_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;out float v_placed;out float v_notUsed;void main() {float feature_elevation=a_elevation_from_sea.x+a_auto_z_offset;float terrain_elevation=(a_elevation_from_sea.y==1.0 ? 0.0 : elevation(a_anchor_pos));vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*(feature_elevation+terrain_elevation),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}'), collisionCircle: Do("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", "in vec2 a_pos_2f;in float a_radius;in vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"), debug: Do("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", '#include "_prelude_terrain.vertex.glsl"\nin vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;\n#endif\nout vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}'), fill: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nuniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nuniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), fillOutline: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nin highp vec2 v_pos;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nuniform mat4 u_matrix;uniform vec2 u_world;out highp vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), fillOutlinePattern: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nin highp vec2 v_pos;in highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;out highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);v_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), fillPattern: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;in highp vec2 v_pos;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), fillExtrusion: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec4 v_color;in vec4 v_flat;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\nuniform lowp float u_opacity;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec2 v_ao;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nin vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nin highp vec3 v_normal;\n#endif\nuniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nin float v_flood_radius;in float v_has_floodlight;\n#endif\nin float v_height;\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float emissive_strength\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nvec3 normal=normalize(v_normal);\n#endif\nfloat z;vec4 color=v_color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);\n#ifdef LIGHTING_3D_MODE\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#else\ncolor=mix(v_color,v_roof_color,z);\n#endif\n#endif\nfloat h=max(0.0,v_height);float ao_shade=1.0;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\ncolor.rgb*=mix(ao_shade,1.0,v_has_floodlight);\n#else\ncolor.rgb*=ao_shade;\n#endif\n#else\ncolor.rgb*=ao_shade;\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nfloat flood_radiance=0.0;\n#ifdef FLOOD_LIGHT\nflood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef FLOOD_LIGHT\nfloat ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);\n#else\nfloat shadowed_lighting_factor;\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\ncolor.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);\n#endif\n#else\ncolor.rgb=apply_lighting(color.rgb,normal);\n#ifdef FLOOD_LIGHT\ncolor.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);\n#endif\n#endif\ncolor.rgb=mix(color.rgb,v_flat.rgb,emissive_strength);color*=u_opacity;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));\n#endif\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;uniform float u_width_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nuniform highp float u_vertical_scale;out vec4 v_color;out vec4 v_flat;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nout vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nout highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec2 v_ao;\n#endif\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nout float v_flood_radius;out float v_has_floodlight;\n#endif\nout float v_height;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define highp float flood_light_wall_radius\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize highp float flood_light_wall_radius\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp float emissive_strength\nbase*=u_vertical_scale;height*=u_vertical_scale;vec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nv_normal=normal;\n#endif\nbase=max(0.0,base);float attr_height=height;height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;float c_ele=0.0;vec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat cutoff=1.0;vec3 scaled_pos=pos;\n#ifdef RENDER_CUTOFF\nvec3 centroid_random=vec3(centroid_pos.xy,centroid_pos.x+centroid_pos.y+1.0);vec3 ground_pos=centroid_pos.x==0.0 ? pos.xyz : (centroid_random/8.0);vec4 ground=u_matrix*vec4(ground_pos.xy,ele,1.0);cutoff=cutoff_opacity(u_cutoff_params,ground.z);if (centroid_pos.y !=0.0 && centroid_pos.x !=0.0) {vec3 g=floor(ground_pos);vec3 mod_=centroid_random-g*8.0;float seed=min(1.0,0.1*(min(3.5,max(mod_.x+mod_.y,0.2*attr_height))*0.35+mod_.z));if (cutoff < 0.8-seed) {cutoff=0.0;}}float cutoff_scale=cutoff;v_cutoff_opacity=cutoff;scaled_pos.z=mix(c_ele,h,cutoff_scale);\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (cutoff==0.0 && centroid_pos.x !=0.0) || (color.a==0.0));\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);scaled_pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;scaled_pos.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\ngl_Position=mix(u_matrix*vec4(scaled_pos,1),AWAY,hidden);h=h-ele;v_height=h;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifndef LIGHTING_3D_MODE\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#endif\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\nfloat is_wall=1.0-float(t > 0.0 && top_up_ny.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;\n#endif\nv_color=vec4(color.rgb,1.0);v_flat=vec4(linearProduct(color.rgb,vec3(calculate_NdotL(normal))),1.0);\n#else\nv_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'), fillExtrusionDepth: Do("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_width_scale;uniform float u_vertical_scale;\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nin vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp vec4 color\nout highp float v_depth;void main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp vec4 color\nbase*=u_vertical_scale;height*=u_vertical_scale;vec3 pos_nx=floor(a_pos_normal_ed.xyz*0.5);mediump vec3 top_up_ny=a_pos_normal_ed.xyz-2.0*pos_nx;base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nvec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;float ele=elevation(pos_nx.xy);float c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);float h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);\n#else\npos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;pos.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);v_depth=gl_Position.z/gl_Position.w;}'), fillExtrusionPattern: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nin vec3 v_normal;\n#endif\nin highp vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_width_scale;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nout highp vec2 v_pos;out vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nout vec3 v_normal;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\n#pragma mapbox: define highp float line_width\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\n#pragma mapbox: initialize highp float line_width\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);p.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;p.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_normal=normal;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif \n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}'), groundShadow: Do('#include "_prelude_shadow.fragment.glsl"\nprecision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\nvoid main() {float light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);\n#ifdef RENDER_CUTOFF\nshadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w));\n#endif\n#ifdef FOG\nshadow=mix(shadow,vec3(1.0),v_fog_opacity);\n#endif\n#ifdef INDICATOR_CUTOUT\nshadow=mix(shadow,vec3(1.0),1.0-applyCutout(vec4(1.0)).r);\n#endif\nglFragColor=vec4(shadow,1.0);}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in vec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);v_fog_opacity=fog(v_fog_pos);\n#endif\n}'), fillExtrusionGroundEffect: Do("uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;\n#ifdef SDF_SUBPASS\nin highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}\n#ifdef FOG\nin highp float v_fog;\n#endif\n#endif\nvoid main() {\n#ifdef CLEAR_SUBPASS\nvec4 color=vec4(1.0);\n#ifdef CLEAR_FROM_TEXTURE\ncolor=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));\n#endif\nglFragColor=color;\n#else\n#ifdef SDF_SUBPASS\nhighp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;\n#ifdef FOG\nfog=v_fog;\n#endif\n#ifdef RENDER_CUTOFF\nfog*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));\n#else\nvec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);\n#ifdef OVERDRAW_INSPECTOR\ncolor=vec4(1.0);\n#endif\nglFragColor=color;\n#endif\nHANDLE_WIREFRAME_DEBUG;\n#endif\n}", '#include "_prelude_fog.vertex.glsl"\nin highp vec4 a_pos_end;in highp float a_angular_offset_factor;in highp float a_hidden_by_landmark;\n#ifdef SDF_SUBPASS\nout highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;\n#ifdef FOG\nout highp float v_fog;\n#endif\n#endif\nuniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp float u_dynamic_offset;uniform highp vec2 u_ao;\n#pragma mapbox: define highp float flood_light_ground_radius\nconst float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {\n#pragma mapbox: initialize highp float flood_light_ground_radius\nvec2 p=a_pos_end.xy;vec2 q=floor(a_pos_end.zw*0.5);vec2 start_bottom=a_pos_end.zw-q*2.0;float fl_ground_radius=flood_light_ground_radius;fl_ground_radius=abs(flood_light_ground_radius);float direction=flood_light_ground_radius < 0.0 ?-1.0 : 1.0;float flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=a_angular_offset_factor/NORM*TANGENT_CUTOFF;float angular_offset=direction*angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(u_dynamic_offset,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=direction*perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;\n#ifdef SDF_SUBPASS\nv_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);\n#ifdef FOG\nv_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);\n#endif\n#endif\nfloat hidden_by_landmark=0.0;\n#ifdef HAS_CENTROID\nhidden_by_landmark=a_hidden_by_landmark;\n#endif\nfloat isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'), hillshadePrepare: Do("precision highp float;uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"), hillshade: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\nglFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);\n#endif\n#ifdef FOG\nglFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), line: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform lowp float u_device_pixel_ratio;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;in vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nfloat luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture(u_dash_image,v_tex).r;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/dash.z;alpha*=linearstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trim_alpha=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);out_color=mix(out_color,u_trim_color,transition_factor);trim_alpha=out_color.a;}\n#endif\nif (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}\n#ifdef RENDER_LINE_BORDER\nfloat edgeBlur=(border_width+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2.t-edgeBlur),v_width2.s-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);if (border_color.a==0.0) {float Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}} else {out_color.rgb=mix(border_color.rgb*border_color.a*trim_alpha,out_color.rgb,smoothAlpha);}}\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(alpha*opacity);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define EXTRUDE_SCALE 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\nin float a_z_offset;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nin highp vec4 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nin float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\ngl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset+0.01*step(0.01,a_z_offset),1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+a_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+a_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+a_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude_xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nfloat a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec4(a_uv_x,a_split_index*texel_height-half_texel_height,a_clip_start,a_clip_end);\n#else\nv_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat scale=dash.z==0.0 ? 0.0 : u_tile_units_to_pixels/dash.z;float height=dash.y;v_tex=vec2(a_linesofar*scale/floorwidth,(-normal.y*height+dash.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'), linePattern: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform highp float u_device_pixel_ratio;uniform highp float u_alpha_discard_threshold;uniform highp vec2 u_texsize;uniform highp float u_tile_units_to_pixels;uniform highp vec2 u_trim_offset;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in highp float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec4 v_uv;\n#endif\n#ifdef LINE_JOIN_NONE\nin vec2 v_pattern_data;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nuniform float u_emissive_strength;\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;float pattern_size=display_size.x/u_tile_units_to_pixels;float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);highp float pattern_x=v_linesofar/pattern_size*aspect;highp float x=mod(pattern_x,1.0);highp float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;highp vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));highp vec2 lod_pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(pattern_x,y));vec4 color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {if (line_progress <=trim_end && line_progress >=trim_start) {color=vec4(0,0,0,0);}}\n#endif\n#ifdef LINE_JOIN_NONE\nfloat pattern_len=pattern_size/aspect;float segment_phase=pattern_len-mod(v_linesofar-v_pattern_data.x+pattern_len,pattern_len);float visible_start=segment_phase-step(pattern_len*0.5,segment_phase)*pattern_len;float visible_end=floor((v_pattern_data.y-segment_phase)/pattern_len)*pattern_len+segment_phase;visible_end+=step(pattern_len*0.5,v_pattern_data.y-visible_end)*pattern_len;if (v_pattern_data.x < visible_start || v_pattern_data.x >=visible_end) {color=vec4(0.0);}\n#endif\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting_with_emission_ground(color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=(alpha*opacity);if (u_alpha_discard_threshold !=0.0) {if (color.a < u_alpha_discard_threshold) {discard;}}\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\nin float a_z_offset;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec4 a_packed;\n#endif\nin highp float a_linesofar;\n#ifdef LINE_JOIN_NONE\nin highp vec3 a_pattern_data;out vec2 v_pattern_data;\n#endif\nuniform mat4 u_matrix;uniform float u_tile_units_to_pixels;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform float u_device_pixel_ratio;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec2 v_width2;out highp float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nout highp vec4 v_uv;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define mediump float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float floorwidth\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define mediump float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize mediump float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize mediump float pixel_ratio\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);vec2 dist=outset*a_extrude*scale;float u=0.5*a_direction;float t=1.0-abs(u);vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\ngl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset+0.01*step(0.01,a_z_offset),1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+a_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+a_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+a_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude_xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nfloat a_uv_x=a_packed[0];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];v_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;\n#ifdef LINE_JOIN_NONE\nv_width=floorwidth+ANTIALIASING;mediump float pixels_to_tile_units=1.0/u_tile_units_to_pixels;mediump float pixel_ratio_inverse=1.0/pixel_ratio;mediump float aspect=v_width/((pattern.w-pattern.y)*pixel_ratio_inverse);highp float subt_multiple=(pattern.z-pattern.x)*pixel_ratio_inverse*pixels_to_tile_units*aspect*32.0;highp float subt=floor(a_pattern_data.z/subt_multiple)*subt_multiple;float offset_sign=(fract(a_pattern_data.x)-0.5)*4.0;float line_progress_offset=offset_sign*v_width*0.5*pixels_to_tile_units;v_linesofar=(a_pattern_data.z-subt)+a_linesofar+line_progress_offset;v_pattern_data=vec2(a_pattern_data.x+line_progress_offset,a_pattern_data.y);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'), raster: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_raster_array.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;uniform highp float u_zoom_transition;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nin float v_split_fade;\n#endif\nuniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;\n#ifndef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;\n#endif\n#ifdef RASTER_COLOR\nuniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;\n#endif\nvoid main() {vec4 color0,color1,color;vec2 value;\n#ifdef RASTER_COLOR\n#ifdef RASTER_ARRAY\n#ifdef RASTER_ARRAY_LINEAR\nvalue=mix(\nraTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#else\nvalue=mix(\nraTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#endif\nif (value.y > 0.0) value.x/=value.y;\n#else\ncolor=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);\n#endif\ncolor=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;\n#else\ncolor0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);\n#endif\ncolor.a*=u_opacity;\n#ifdef GLOBE_POLES\ncolor.a*=1.0-smoothstep(0.0,0.05,u_zoom_transition);\n#endif\nvec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef PROJECTION_GLOBE_VIEW\nglFragColor*=mix(1.0,1.0-smoothstep(0.0,0.05,u_zoom_transition),smoothstep(0.8,0.9,v_split_fade));\n#endif\n#ifdef RENDER_CUTOFF\nglFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;in vec2 a_texture_pos;\n#endif\nout vec2 v_pos0;out vec2 v_pos1;out float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nout float v_split_fade;\n#endif\nvoid main() {vec2 uv;\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos   ,1.0);uv=a_uv;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);\n#endif\n#else\nfloat w=1.0+dot(a_texture_pos,u_perspective_transform);uv=a_texture_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);    \nv_split_fade=0.0;if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;float opposite_merc_center=mod(u_merc_center.x+0.5,1.0);float dist_from_poles=(abs(mercatorY-0.5)*2.0);float range=0.1;v_split_fade=abs(opposite_merc_center-mercatorX);v_split_fade=clamp(1.0-v_split_fade,0.0,1.0);v_split_fade=max(smoothstep(1.0-range,1.0,dist_from_poles),max(smoothstep(1.0-range,1.0,v_split_fade),smoothstep(1.0-range,1.0,1.0-v_split_fade)));}float tiles=u_grid_matrix[0][2];if (tiles > 0.0) {float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvY=mercatorY*tiles-idy;float uvX=mercatorX*tiles-idx;uv=vec2(uvX,uvY);}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\ngl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;\n#ifdef RENDER_CUTOFF\nv_depth=gl_Position.z;\n#endif\n}'), rasterParticle: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;uniform sampler2D u_image0;uniform sampler2D u_image1;void main() {vec4 color0,color1,color;color0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 out_color=color.rgb;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),0.0).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\nin vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {float w=1.0;vec2 uv;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);float tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvX=mercatorX*tiles-idx;float uvY=mercatorY*tiles-idy;uv=vec2(uvX,uvY);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nuv=a_texture_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}'), rasterParticleDraw: Do("uniform sampler2D u_color_ramp;in float v_particle_speed;void main() {glFragColor=texture(u_color_ramp,vec2(v_particle_speed,0.5));}", '#include "_prelude_raster_particle.glsl"\nin float a_index;uniform sampler2D u_particle_texture;uniform float u_particle_texture_side_len;uniform vec2 u_tile_offset;out float v_particle_speed;void main() {ivec2 pixel_coord=ivec2(\nmod(a_index,u_particle_texture_side_len),a_index/u_particle_texture_side_len);vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);vec2 pos=unpack_pos_from_rgba(pixel)+u_tile_offset;vec2 tex_coord=fract(pos);vec2 velocity=lookup_velocity(tex_coord);if (velocity==INVALID_VELOCITY) {gl_Position=AWAY;v_particle_speed=0.0;} else {gl_Position=vec4(2.0*pos-1.0,0,1);v_particle_speed=length(velocity);}gl_PointSize=1.0;}'), rasterParticleTexture: Do("uniform sampler2D u_texture;uniform float u_opacity;in vec2 v_tex_pos;void main() {vec4 color=texture(u_texture,v_tex_pos);glFragColor=vec4(floor(255.0*color*u_opacity)/255.0);}", "in vec2 a_pos;out vec2 v_tex_pos;void main() {vec2 uv=0.5*a_pos+vec2(0.5);v_tex_pos=uv;gl_Position=vec4(a_pos,0.0,1.0);}"), rasterParticleUpdate: Do('#include "_prelude_raster_particle.glsl"\nuniform sampler2D u_particle_texture;uniform mediump float u_particle_texture_side_len;uniform mediump float u_speed_factor;uniform highp float u_reset_rate;uniform highp float u_rand_seed;in highp vec2 v_tex_coord;vec2 linearstep(vec2 edge0,vec2 edge1,vec2 x) {return  clamp((x-edge0)/(edge1-edge0),vec2(0),vec2(1));}const highp vec3 rand_constants=vec3(12.9898,78.233,4375.85453);highp float rand(const highp vec2 co) {highp float t=dot(rand_constants.xy,co);return fract(sin(t)*(rand_constants.z+t));}void main() {ivec2 pixel_coord=ivec2(v_tex_coord*u_particle_texture_side_len);highp vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);highp vec2 pos=unpack_pos_from_rgba(pixel);highp vec2 velocity=lookup_velocity(clamp(pos,0.0,1.0));highp vec2 dp=velocity==INVALID_VELOCITY ? vec2(0) : velocity*u_speed_factor;pos=pos+dp;highp vec2 seed=(pos+v_tex_coord)*u_rand_seed;highp vec2 random_pos=vec2(rand(seed+1.3),rand(seed+2.1));highp vec2 persist_rate=pow(\nlinearstep(vec2(-u_particle_pos_offset),vec2(0),pos)*linearstep(vec2(1.0+u_particle_pos_offset),vec2(1),pos),vec2(4)\n);highp vec2 per_frame_persist=pow(persist_rate,abs(dp)/u_particle_pos_offset);highp float drop_rate=1.0-per_frame_persist.x*per_frame_persist.y;drop_rate=any(greaterThanEqual(abs(pos-0.5),vec2(0.5+u_particle_pos_offset))) ? 1.0 : drop_rate;highp float drop=step(1.0-drop_rate-u_reset_rate,rand(seed));highp vec2 next_pos=mix(pos,random_pos,drop);glFragColor=pack_pos_to_rgba(next_pos);}', "in vec2 a_pos;out vec2 v_tex_coord;void main() {v_tex_coord=0.5*(a_pos+vec2(1.0));gl_Position=vec4(a_pos,0.0,1.0);}"), symbol: Do('#include "_prelude_lighting.glsl"\n#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_halo;uniform lowp float u_scale_factor;\n#ifdef ICON_TRANSITION\nuniform float u_icon_transition;\n#endif\n#ifdef COLOR_ADJUSTMENT\nuniform mat4 u_color_adj_mat;\n#endif\nin vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nin vec2 v_tex_b;\n#endif\nin float v_draw_halo;in vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nin float is_sdf;in vec2 v_tex_a_icon;\n#endif\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nvec4 out_color;float fade_opacity=v_gamma_scale_size_fade_opacity[2];\n#ifdef RENDER_TEXT_AND_SYMBOL\nif (is_sdf==ICON) {vec2 tex_icon=v_tex_a_icon;lowp float alpha=opacity*fade_opacity;glFragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nreturn;}\n#endif\n#ifdef RENDER_SDF\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_gamma_scale_size_fade_opacity.x;float size=v_gamma_scale_size_fade_opacity.y;float fontScale=u_is_text ? size/24.0 : size;out_color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {out_color=halo_color;gamma=(halo_blur*u_scale_factor*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width*u_scale_factor/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,v_tex_a).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);out_color*=alpha;\n#else\n#ifdef ICON_TRANSITION\nvec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b);\n#else\nout_color=texture(u_texture,v_tex_a);\n#endif\n#ifdef COLOR_ADJUSTMENT\nout_color=u_color_adj_mat*out_color;\n#endif\n#endif\nout_color*=opacity*fade_opacity;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_auto_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef ICON_TRANSITION\nin vec2 a_texb;\n#endif\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_elevation_from_sea;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nout vec2 v_tex_b;\n#endif\nout float v_draw_halo;out vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nout float is_sdf;out vec2 v_tex_a_icon;\n#endif\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\n#pragma mapbox: define lowp float occlusion_opacity\n#pragma mapbox: define lowp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\n#pragma mapbox: initialize lowp float occlusion_opacity\n#pragma mapbox: initialize lowp float z_offset\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=u_elevation_from_sea ? z_offset : z_offset+elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_auto_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=a_globe_anchor+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;vec2 a;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;\n#endif\nvec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\n#ifdef Z_OFFSET\nz+=u_pitch_with_map ? a_auto_z_offset+(u_elevation_from_sea ? z_offset : z_offset) : 0.0;\n#else\nz+=u_pitch_with_map ? (u_elevation_from_sea ? z_offset : z_offset) : 0.0;\n#endif\nfloat occlusion_fade=globe_occlusion_fade;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float out_fade_opacity=interpolated_fade_opacity*projection_transition_fade;\n#ifdef DEPTH_OCCLUSION\nfloat depth_occlusion=occlusionFadeMultiSample(projected_point);float depth_occlusion_multplier=mix(occlusion_opacity,1.0,depth_occlusion);out_fade_opacity*=depth_occlusion_multplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);out_fade_opacity*=occludedFadeMultiplier;\n#endif\nfloat alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nfloat gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_gamma_scale_size_fade_opacity=vec3(gamma_scale,size,out_fade_opacity);v_tex_a=a_tex/u_texsize;\n#ifdef RENDER_TEXT_AND_SYMBOL\nis_sdf=a_size[0]-2.0*a_size_min;v_tex_a_icon=a_tex/u_texsize_icon;\n#endif\n#ifdef ICON_TRANSITION\nv_tex_b=a_texb/u_texsize;\n#endif\n}'), terrainRaster: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;in vec2 v_pos0;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#endif\nuniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;\n#ifdef LIGHTING_3D_MODE\nconst vec3 normal=vec3(0.0,0.0,1.0);\n#ifdef RENDER_SHADOWS\nfloat cutoffOpacity=1.0;\n#ifdef RENDER_CUTOFF\ncutoffOpacity=cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w);\n#endif\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nvec3 unlit_base=image_color.rgb*(1.0-image_color.a);vec3 emissive_base=image_color.rgb*image_color.a;float ndotl=u_shadow_direction.z;float occlusion=ndotl < 0.0 ? 1.0 : shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,0.0);ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;\n#else\nfloat lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));\n#endif\n#else\nfloat lighting_factor=u_lighting_directional_dir.z;color=apply_lighting(image_color,normal,lighting_factor);\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor.rgb=mix(color.rgb,image_color.rgb,image_color.a);color.a=1.0;\n#endif\n#endif\n#else\ncolor=image_color;\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_skirt_height;in vec2 a_pos;out vec2 v_pos0;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth;\n#endif\nvoid main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);\n#endif\n}'), terrainDepth: Do("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;out float v_depth;void main() {float elevation=elevation(a_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}'), skybox: Do('#include "_prelude_fog.fragment.glsl"\nin lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color.rgb=dither(sky_color.rgb,gl_FragCoord.xy+u_temporal_offset);sky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', _o), skyboxGradient: Do('#include "_prelude_fog.fragment.glsl"\nin highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;color.rgb=dither(color.rgb,gl_FragCoord.xy+u_temporal_offset);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', _o), skyboxCapture: Do("\nin highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}", "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"), globeRaster: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;uniform float u_far_z_cutoff;in vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nvec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);vec3 dir=normalize(ray_dir);vec3 closest_point=dot(u_globe_pos,dir)*dir;float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nraster=apply_lighting_with_emission_ground(raster,raster.a);color=vec4(raster.rgb*antialias,antialias);\n#else\nraster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor=apply_lighting_with_emission_ground(color,color.a);color.a=1.0;\n#else\ncolor=apply_lighting_ground(color);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=1.0-step(u_far_z_cutoff,1.0/gl_FragCoord.w);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;\n#endif\nout vec2 v_pos0;void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);globe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}'), globeAtmosphere: Do('#include "_prelude_fog.fragment.glsl"\nuniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {\n#ifdef ALPHA_PASS\nglFragColor=vec4(0,0,0,0);return;\n#else\n#ifdef NATIVE\nglFragColor=vec4(1,1,1,1);\n#else\nglFragColor=vec4(0,0,0,1);\n#endif\nreturn;\n#endif\n}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;\n#ifdef ALPHA_PASS\nfloat a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);\n#else\nvec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;\n#ifndef NATIVE\nc=dither(c,gl_FragCoord.xy+u_temporal_offset);\n#endif\nglFragColor=vec4(c*t,t);\n#endif\n}', "in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}"), model: Do('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_opacity;uniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;uniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nuniform vec4 u_occlusionTextureTransform;\n#endif\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#ifdef HAS_ATTRIBUTE_a_pbr\nin lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;\n#endif\n#ifdef HAS_TEXTURE_u_baseColorTexture\nuniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;\n#endif\n#ifdef HAS_TEXTURE_u_metallicRoughnessTexture\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\n#ifdef HAS_TEXTURE_u_occlusionTexture\nuniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;\n#endif\n#ifdef HAS_TEXTURE_u_normalTexture\nuniform sampler2D u_normalTexture;\n#endif\n#ifdef HAS_TEXTURE_u_emissionTexture\nuniform sampler2D u_emissionTexture;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nin highp float v_depth;uniform highp sampler2D u_depthTexture;uniform highp vec2 u_inv_depth_size;uniform highp vec2 u_depth_range_unpack;\n#ifdef DEPTH_D24\nhighp float unpack_depth(highp float depth) {return  depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}\n#else\nhighp float unpack_depth_rgba(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded() {highp vec2 coord=gl_FragCoord.xy*u_inv_depth_size;\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depthTexture,coord).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depthTexture,coord));\n#endif\nreturn v_depth > depth+0.0005;}\n#endif\n#define saturate(_x) clamp(_x,0.,1.)\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)\n{\n#ifdef LIGHTING_3D_MODE\nvec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));\n#endif\nreturn apply_lighting(albedo,transformed_normal,lighting_factor);\n#else\nvec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;\n#endif\n}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;\n#ifdef HAS_ATTRIBUTE_a_color_3f\nalbedo*=vec4(color_3f,1.0);\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#else\n#ifdef HAS_ATTRIBUTE_a_color_4f\nalbedo*=color_4f;\n#endif\n#endif\n#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)\nvec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}\n#ifdef UNPREMULT_TEXTURE_IN_SHADER\nif(texColor.w > 0.0) {texColor.rgb/=texColor.w;}texColor.w=1.0;\n#endif\nif(u_baseTextureIsAlpha) {if (texColor.r < 0.5) {discard;}} else {texColor.rgb=sRGBToLinear(texColor.rgb);albedo*=texColor;}\n#endif\nvec4 color=vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\nreturn color;}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {\n#ifdef HAS_TEXTURE_u_normalTexture\nhighp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=dp2perp*duv1.x+dp1perp*duv2.x;highp vec3 B=dp2perp*duv1.y+dp1perp*duv2.y;highp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;\n#else\nreturn mat3(1.0);\n#endif\n}highp vec3 getNormal(){highp vec3 n;\n#ifdef HAS_ATTRIBUTE_a_normal_3f\nn=normalize(normal_3f);\n#else\nhighp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));n=normalize(cross(fdx,fdy))*-1.0;\n#endif\n#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=normalize(-v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);\n#endif\nreturn n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;\n#ifdef HAS_ATTRIBUTE_a_pbr\nmat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;\n#endif\n#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f) \nvec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;\n#endif\nconst float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)\n{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)\n{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)\n{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)\n{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)\n{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)\n{\n#ifdef LIGHTING_3D_MODE\nreturn mat.diffuseColor;\n#else\nreturn mat.diffuseColor/PI;\n#endif\n}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)\n{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)\n{vec3 env_light=vec3(0.65,0.65,0.65);\n#ifdef LIGHTING_3D_MODE\nfloat ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;\n#endif\nvec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)\n{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=NdotL;\n#endif\nvec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;\n#if !defined(LIGHTING_3D_MODE)\nconst vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);\n#endif\ncolor*=intensityFactor;return color;}void main() {\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nif (isOccluded()) {discard;}\n#endif\nvec3 lightDir=u_lightpos;vec3 lightColor=u_lightcolor;\n#ifdef LIGHTING_3D_MODE\nlightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;\n#endif\nvec4 finalColor;\n#ifdef DIFFUSE_SHADED\nvec3 N=getNormal();vec3 baseColor=getBaseColor().rgb;vec3 diffuse=getDiffuseShadedColor(baseColor,N,lightDir,lightColor);\n#ifdef HAS_TEXTURE_u_occlusionTexture\nfloat ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;\n#endif\nfinalColor=vec4(mix(diffuse,baseColor,u_emissive_strength),1.0)*u_opacity;\n#else\nMaterial mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;\n#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nvec2 uv=uv_2f.xy*u_occlusionTextureTransform.zw+u_occlusionTextureTransform.xy;\n#else\nvec2 uv=uv_2f;\n#endif\nao=(texture(u_occlusionTexture,uv).x-1.0)*u_aoIntensity+1.0;color*=ao;\n#endif\nvec4 emissive=u_emissiveFactor;\n#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nemissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nfloat emissiveFactorLength=max(length(u_emissiveFactor.rgb),0.001);emissive.rgb=sRGBToLinear(applyLUT(u_lutTexture,linearTosRGB(emissive.rgb/emissiveFactorLength).rbg))*emissiveFactorLength;\n#endif\ncolor+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;\n#ifdef HAS_ATTRIBUTE_a_pbr\nfloat resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);vec3 color_mix=v_color_mix.rgb;\n#ifdef APPLY_LUT_ON_GPU\ncolor_mix=applyLUT(u_lutTexture,color_mix);\n#endif\ncolor=mix(color,color_mix,min(1.0,resEmission));\n#ifdef HAS_ATTRIBUTE_a_color_4f\nfloat distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);\n#endif\n#endif\nvec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);\n#endif\n#ifdef FOG\nfinalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));\n#endif\n#ifdef RENDER_CUTOFF\nfinalColor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\nfinalColor=applyCutout(finalColor);\n#endif\nglFragColor=finalColor;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute-vertex-shader-only highp vec4 pbr\n#pragma mapbox: define-attribute-vertex-shader-only highp vec3 heightBasedEmissiveStrength\nuniform mat4 u_matrix;uniform mat4 u_node_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_normal_matrix;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nout vec4 v_position_height;out lowp vec4 v_color_mix;\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nout highp float v_depth;\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\nout lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute-custom highp vec4 pbr\n#pragma mapbox: initialize-attribute-custom highp vec3 heightBasedEmissiveStrength\nhighp mat4 normal_matrix;\n#ifdef INSTANCED_ARRAYS\nnormal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\nnormal_matrix=u_normal_matrix;\n#endif\nvec3 local_pos;mat3 rs;\n#ifdef MODEL_POSITION_ON_GPU\nvec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float hidden=float(pos_a.x > EXTENT);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=mix(u_matrix*pos,AWAY,hidden);pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;\n#else\nlocal_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);\n#endif\nv_position_height.w=a_pos_3f.z;\n#ifdef HAS_ATTRIBUTE_a_pbr\nvec4 albedo_c=decode_color(pbr.xy);vec2 e_r_m=unpack_float(pbr.z);vec2 r_m= unpack_float(e_r_m.y*16.0);r_m.r=r_m.r*16.0;v_color_mix=vec4(albedo_c.rgb,1.0);v_roughness_metallic_emissive_alpha=vec4(vec3(r_m,e_r_m.x)/255.0,albedo_c.a);v_roughness_metallic_emissive_alpha.z*=2.0;float heightBasedRelativeIntepolation=a_pos_3f.z*heightBasedEmissiveStrength.x+heightBasedEmissiveStrength.y;v_height_based_emission_params.x=heightBasedRelativeIntepolation;v_height_based_emission_params.y=heightBasedEmissiveStrength.z;vec2 emissionMultiplierValues=unpack_float(pbr.w)/256.0;v_height_based_emission_params.z=emissionMultiplierValues.x;v_height_based_emission_params.w=emissionMultiplierValues.y-emissionMultiplierValues.x;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(local_pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nfloat x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_3f=rs*((u_lighting_matrix*vec4(normal_3f,0.0)).xyz/squared_scale);normal_3f=normalize(normal_3f);\n#else\nnormal_3f=vec3(normal_matrix*vec4(normal_3f,0));\n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#ifdef HAS_ATTRIBUTE_a_color_4f\nv_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shadow_pos=u_node_matrix*vec4(local_pos,1.0);\n#ifdef NORMAL_OFFSET\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nvec3 offset=shadow_normal_offset(vec3(-normal_3f.xy,normal_3f.z));shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#else\nvec3 offset=shadow_normal_offset_model(normal_3f);shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#endif\n#endif\n#endif\nv_pos_light_view_0=u_light_matrix_0*shadow_pos;v_pos_light_view_1=u_light_matrix_1*shadow_pos;v_depth_shadows=gl_Position.w;\n#endif\n}'), modelDepth: Do("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", "in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;\n#ifdef MODEL_POSITION_ON_GPU\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_instance;\n#endif\nuniform highp mat4 u_node_matrix;\n#endif\nvoid main() {\n#ifdef MODEL_POSITION_ON_GPU\nhighp mat4 instance;\n#ifdef INSTANCED_ARRAYS\ninstance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\ninstance=u_instance;\n#endif\nvec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float hidden=float(pos_a.x > EXTENT);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=mix(u_matrix*pos,AWAY,hidden);\n#else\ngl_Position=u_matrix*vec4(a_pos_3f,1);\n#endif\nv_depth=gl_Position.z/gl_Position.w;}"), stars: Do("in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)\n{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}", "\nin vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_fade_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_fade_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}"), snowParticle: Do("in highp vec2 uv;in highp float alphaMultiplier;uniform vec4 u_particleColor;uniform vec2 u_simpleShapeParameters;void main() {float t=clamp((length(uv)-u_simpleShapeParameters.x)/(1.0-u_simpleShapeParameters.x),0.0,1.0);float alpha=1.0-pow(t,pow(10.0,u_simpleShapeParameters.y));alpha*=alphaMultiplier;alpha*=u_particleColor.a;vec3 color=u_particleColor.rgb*alpha;glFragColor=vec4(color,alpha) ;HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_snowParticleData;in highp vec4 a_snowParticleDataHorizontalOscillation;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform vec2 u_screenSize;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity;uniform vec3 u_direction;uniform float u_horizontalOscillationRadius; \nuniform float u_horizontalOscillationRate; \nuniform float u_billboardSize;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;out highp vec2 uv;out highp float alphaMultiplier;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos.xyz*=halfBoxSize;pos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_snowParticleData.z;float coneAngleHeadingRad=a_snowParticleData.w*radians(360.0);vec3 localZ=normalize(u_direction);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 direction;direction.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.z=cos(coneAnglePichRad);direction=normalize(direction);vec3 simPosLocal=vec3(0,0,0);float velocityScale=(1.0+3.0*a_snowParticleData.y)*u_velocity;simPosLocal+=direction*velocityScale*u_time;float horizontalOscillationRadius=u_horizontalOscillationRadius*a_snowParticleDataHorizontalOscillation.x;float horizontalOscillationAngle=u_horizontalOscillationRate*u_time*(-1.0+2.0*a_snowParticleDataHorizontalOscillation.y);simPosLocal.xy+=horizontalOscillationRadius*vec2(cos(horizontalOscillationAngle),sin(horizontalOscillationAngle));vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);float clipZ=-u_cam_pos.z+pos.z;vec4 posView=u_modelview*vec4(pos,1.0);float size=u_billboardSize;alphaMultiplier=1.0;vec4 posScreen=u_projection*posView;posScreen/=posScreen.w;posScreen.xy=vec2(0.5)+posScreen.xy*0.5;posScreen.xy*=u_screenSize;vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=u_screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-posScreen.xy)/(0.5*u_screenSize));screenDist+=a_snowParticleData.x*u_thinningParticleOffset;float scaleFactorMode=0.0;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);if (a_snowParticleData.x < u_thinningAffectedRatio) {scaleFactorMode=1.0-thinningFadeRatio;alphaMultiplier=thinningFadeRatio;}}vec4 posScreen1=u_projection*vec4(posView.x-size,posView.yzw);posScreen1/=posScreen1.w;vec4 posScreen2=u_projection*vec4(posView.x+size,posView.yzw);posScreen2/=posScreen2.w;posScreen1.xy=vec2(0.5)+posScreen1.xy*0.5;posScreen1.xy*=u_screenSize;posScreen2.xy=vec2(0.5)+posScreen2.xy*0.5;posScreen2.xy*=u_screenSize;float screenLength=length(posScreen1.xy-posScreen2.xy);float screenEpsilon=3.0;float scaleFactor=1.0;if (screenLength < screenEpsilon) {scaleFactor=screenEpsilon/max(screenLength,0.01);scaleFactor=mix(scaleFactor,1.0,scaleFactorMode);}float screenEpsilon2=15.0;if (screenLength > screenEpsilon2) {scaleFactor=screenEpsilon2/max(screenLength,0.01);}size*=scaleFactor;vec2 right=size*vec2(1,0);vec2 up=size*vec2(0,1);posView.xy+=right*a_uv.x;posView.xy+=up*a_uv.y;uv=a_uv;gl_Position=u_projection*posView;}"), rainParticle: Do("in highp vec2 uv;in highp float particleRandomValue;uniform sampler2D u_texScreen;uniform float u_distortionStrength;uniform vec4 u_color;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;uniform float u_shapeDirectionalPower;uniform float u_mode;void main() {vec2 st=uv*0.5+vec2(0.5);vec2 uvm=uv;uvm.y=-1.0+2.0*pow(st.y,u_shapeDirectionalPower);float shape=clamp(1.0-length(uvm),0.0,1.0);float alpha=abs(shape)*u_color.a;vec2 screenSize=vec2(textureSize(u_texScreen,0));vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-gl_FragCoord.xy)/(0.5*screenSize));screenDist+=(0.5+0.5*particleRandomValue)*u_thinningParticleOffset;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;float thinningAlpha=1.0;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);thinningAlpha*=thinningFadeRatio;}vec2 offsetXY=normalize(uvm)*abs(shape);vec2 stScreen=(gl_FragCoord.xy+offsetXY*u_distortionStrength*thinningAlpha)/screenSize;vec3 colorScreen=texture(u_texScreen,stScreen).rgb;alpha*=thinningAlpha;glFragColor=mix(vec4(colorScreen,1.0),vec4(u_color.rgb*alpha,alpha),u_mode);HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_rainParticleData;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity; \nuniform vec2 u_rainDropletSize;uniform vec3 u_rainDirection;out highp vec2 uv;out highp float particleRandomValue;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos*=halfBoxSize; \npos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_rainParticleData.z;float coneAngleHeadingRad=a_rainParticleData.w*radians(360.0);vec3 localZ=normalize(u_rainDirection);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 directionLocal;directionLocal.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.z=cos(coneAnglePichRad);directionLocal=normalize(directionLocal);vec3 directionWorld=localX*directionLocal.x+localY*directionLocal.y+localZ*directionLocal.z;float velocityScale=(1.0+3.0*a_rainParticleData.y)*u_velocity;vec3 simPosLocal=vec3(0,0,0);simPosLocal+=directionLocal*velocityScale*u_time;vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);vec4 posView=u_modelview*vec4(pos,1.0);vec3 directionView=normalize((u_modelview*vec4(directionWorld,0.0)).xyz);vec3 side=cross(directionView,normalize(posView.xyz));posView.xyz+=side*a_uv.x*u_rainDropletSize.x;posView.xyz+=directionView*a_uv.y*u_rainDropletSize.y;uv=a_uv;particleRandomValue=a_rainParticleData.x;gl_Position=u_projection*posView;}"), occlusion: Do("uniform vec4 u_color;void main() {glFragColor=u_color;}", '#include "_prelude_terrain.vertex.glsl"\nin highp vec2 a_offset_xy;uniform highp vec3 u_anchorPos;uniform mat4 u_matrix;uniform vec2 u_screenSizePx;uniform vec2 u_occluderSizePx;void main() {vec3 world_pos=u_anchorPos;\n#ifdef TERRAIN\nfloat e=elevation(world_pos.xy);world_pos.z+=e;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1.0);projected_point.xy+=projected_point.w*a_offset_xy*0.5*u_occluderSizePx/u_screenSizePx;gl_Position=projected_point;}') };
      function Io(e3, t4) {
        const i3 = e3.replace(/\s*\/\/[^\n]*\n/g, "\n").split("\n");
        for (let e4 of i3) if (e4 = e4.trim(), "#" === e4[0] && e4.includes("if") && !e4.includes("endif")) {
          e4 = e4.replace("#", "").replace(/ifdef|ifndef|elif|if/g, "").replace(/!|defined|\(|\)|\|\||&&/g, "").replace(/\s+/g, " ").trim();
          const i4 = e4.split(" ");
          for (const e5 of i4) t4.includes(e5) || t4.push(e5);
        }
      }
      function Do(e3, t4) {
        const i3 = /#include\s+"([^"]+)"/g, o3 = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g;
        let s3 = t4.match(/(attribute(\S*)|(^\s*|;)in) (highp |mediump |lowp )?([\w]+) ([\w]+)/gm);
        s3 && (s3 = s3.map((e4) => {
          const t5 = e4.split(" ");
          return t5[t5.length - 1];
        }), s3 = [...new Set(s3)]);
        const r3 = {}, a4 = [], n3 = [];
        if (e3 = e3.replace(i3, (e4, t5) => (n3.push(t5), "")), (t4 = t4.replace(i3, (e4, t5) => (a4.push(t5), ""))).includes("flat out")) return void console.error('The usage of "flat" qualifier is disallowed, see: https://bugs.webkit.org/show_bug.cgi?id=268071');
        let l3 = [...bo];
        Io(e3, l3), Io(t4, l3);
        for (const e4 of [...a4, ...n3]) wo[e4] || console.error(`Undefined include: ${e4}`), To[e4] || (To[e4] = [], Io(wo[e4], To[e4])), l3 = [...l3, ...To[e4]];
        return { fragmentSource: e3 = e3.replace(o3, (e4, t5, i4, o4, s4) => (r3[s4] = true, "define" === t5 ? `
#ifndef HAS_UNIFORM_u_${s4}
in ${i4} ${o4} ${s4};
#else
uniform ${i4} ${o4} u_${s4};
#endif
` : "initialize" === t5 ? `
#ifdef HAS_UNIFORM_u_${s4}
    ${i4} ${o4} ${s4} = u_${s4};
#endif
` : "define-attribute" === t5 ? `
#ifdef HAS_ATTRIBUTE_a_${s4}
    in ${i4} ${o4} ${s4};
#endif
` : "initialize-attribute" === t5 ? "" : void 0)), vertexSource: t4 = t4.replace(o3, (e4, t5, i4, o4, s4) => {
          const a5 = "float" === o4 ? "vec2" : o4, n4 = s4.match(/color/) ? "color" : a5;
          return "define-attribute-vertex-shader-only" === t5 ? `
#ifdef HAS_ATTRIBUTE_a_${s4}
in ${i4} ${o4} a_${s4};
#endif
` : r3[s4] ? "define" === t5 ? `
#ifndef HAS_UNIFORM_u_${s4}
uniform lowp float u_${s4}_t;
in ${i4} ${a5} a_${s4};
out ${i4} ${o4} ${s4};
#else
uniform ${i4} ${o4} u_${s4};
#endif
` : "initialize" === t5 ? "vec4" === n4 ? `
#ifndef HAS_UNIFORM_u_${s4}
    ${s4} = a_${s4};
#else
    ${i4} ${o4} ${s4} = u_${s4};
#endif
` : `
#ifndef HAS_UNIFORM_u_${s4}
    ${s4} = unpack_mix_${n4}(a_${s4}, u_${s4}_t);
#else
    ${i4} ${o4} ${s4} = u_${s4};
#endif
` : "define-attribute" === t5 ? `
#ifdef HAS_ATTRIBUTE_a_${s4}
    in ${i4} ${o4} a_${s4};
    out ${i4} ${o4} ${s4};
#endif
` : "initialize-attribute" === t5 ? `
#ifdef HAS_ATTRIBUTE_a_${s4}
    ${s4} = a_${s4};
#endif
` : void 0 : "define" === t5 ? `
#ifndef HAS_UNIFORM_u_${s4}
uniform lowp float u_${s4}_t;
in ${i4} ${a5} a_${s4};
#else
uniform ${i4} ${o4} u_${s4};
#endif
` : "define-instanced" === t5 ? "mat4" === n4 ? `
#ifdef INSTANCED_ARRAYS
in vec4 a_${s4}0;
in vec4 a_${s4}1;
in vec4 a_${s4}2;
in vec4 a_${s4}3;
#else
uniform ${i4} ${o4} u_${s4};
#endif
` : `
#ifdef INSTANCED_ARRAYS
in ${i4} ${a5} a_${s4};
#else
uniform ${i4} ${o4} u_${s4};
#endif
` : "initialize-attribute-custom" === t5 ? `
#ifdef HAS_ATTRIBUTE_a_${s4}
    ${i4} ${o4} ${s4} = a_${s4};
#endif
` : "vec4" === n4 ? `
#ifndef HAS_UNIFORM_u_${s4}
    ${i4} ${o4} ${s4} = a_${s4};
#else
    ${i4} ${o4} ${s4} = u_${s4};
#endif
` : `
#ifndef HAS_UNIFORM_u_${s4}
    ${i4} ${o4} ${s4} = unpack_mix_${n4}(a_${s4}, u_${s4}_t);
#else
    ${i4} ${o4} ${s4} = u_${s4};
#endif
`;
        }), staticAttributes: s3, usedDefines: l3, vertexIncludes: a4, fragmentIncludes: n3 };
      }
      class Ro {
        constructor() {
          this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
        }
        bind(e3, t4, i3, o3, s3, r3, a4, n3) {
          this.context = e3;
          let l3 = this.boundPaintVertexBuffers.length !== o3.length;
          for (let e4 = 0; !l3 && e4 < o3.length; e4++) this.boundPaintVertexBuffers[e4] !== o3[e4] && (l3 = true);
          let c3 = this.boundDynamicVertexBuffers.length !== a4.length;
          for (let e4 = 0; !c3 && e4 < a4.length; e4++) this.boundDynamicVertexBuffers[e4] !== a4[e4] && (c3 = true);
          if (!this.vao || this.boundProgram !== t4 || this.boundLayoutVertexBuffer !== i3 || l3 || c3 || this.boundIndexBuffer !== s3 || this.boundVertexOffset !== r3) this.freshBind(t4, i3, o3, s3, r3, a4, n3);
          else {
            e3.bindVertexArrayOES.set(this.vao);
            for (const i4 of a4) i4 && (i4.bind(), n3 && i4.instanceCount && i4.setVertexAttribDivisor(e3.gl, t4, n3));
            s3 && s3.dynamicDraw && s3.bind();
          }
        }
        freshBind(e3, t4, i3, o3, s3, r3, a4) {
          const n3 = e3.numAttributes, l3 = this.context, c3 = l3.gl;
          this.vao && this.destroy(), this.vao = l3.gl.createVertexArray(), l3.bindVertexArrayOES.set(this.vao), this.boundProgram = e3, this.boundLayoutVertexBuffer = t4, this.boundPaintVertexBuffers = i3, this.boundIndexBuffer = o3, this.boundVertexOffset = s3, this.boundDynamicVertexBuffers = r3, t4.enableAttributes(c3, e3), t4.bind(), t4.setVertexAttribPointers(c3, e3, s3);
          for (const t5 of i3) t5.enableAttributes(c3, e3), t5.bind(), t5.setVertexAttribPointers(c3, e3, s3);
          for (const t5 of r3) t5 && (t5.enableAttributes(c3, e3), t5.bind(), t5.setVertexAttribPointers(c3, e3, s3), a4 && t5.instanceCount && t5.setVertexAttribDivisor(c3, e3, a4));
          o3 && o3.bind(), l3.currentNumAttributes = n3;
        }
        destroy() {
          this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
        }
      }
      function Ao(t4, i3) {
        const o3 = Math.pow(2, i3.canonical.z), s3 = i3.canonical.y;
        return [new e2.a5(0, s3 / o3).toLngLat().lat, new e2.a5(0, (s3 + 1) / o3).toLngLat().lat];
      }
      function Lo(t4, i3, o3, s3, r3, a4, n3) {
        const l3 = t4.context, c3 = l3.gl, h3 = o3.hillshadeFBO;
        if (!h3) return;
        t4.prepareDrawTile();
        const u4 = t4.isTileAffectedByFog(i3), d3 = t4.getOrCreateProgram("hillshade", { overrideFog: u4 });
        l3.activeTexture.set(c3.TEXTURE0), c3.bindTexture(c3.TEXTURE_2D, h3.colorAttachment.get());
        const _2 = ((t5, i4, o4, s4) => {
          const r4 = o4.paint.get("hillshade-shadow-color"), a5 = o4.paint.get("hillshade-highlight-color"), n4 = o4.paint.get("hillshade-accent-color"), l4 = o4.paint.get("hillshade-emissive-strength");
          let c4 = e2.bC(o4.paint.get("hillshade-illumination-direction"));
          if ("viewport" === o4.paint.get("hillshade-illumination-anchor")) c4 -= t5.transform.angle;
          else if (t5.style && t5.style.enable3dLights() && t5.style.directionalLight) {
            const i5 = t5.style.directionalLight.properties.get("direction"), o5 = e2.c8(i5.x, i5.y, i5.z);
            c4 = e2.bC(o5[1]);
          }
          const h4 = !t5.options.moving;
          return { u_matrix: s4 || t5.transform.calculateProjMatrix(i4.tileID.toUnwrapped(), h4), u_image: 0, u_latrange: Ao(0, i4.tileID), u_light: [o4.paint.get("hillshade-exaggeration"), c4], u_shadow: r4.toRenderColor(o4.lut), u_highlight: a5.toRenderColor(o4.lut), u_emissive_strength: l4, u_accent: n4.toRenderColor(o4.lut) };
        })(t4, o3, s3, t4.terrain ? i3.projMatrix : null);
        t4.uploadCommonUniforms(l3, d3, i3.toUnwrapped());
        const { tileBoundsBuffer: p3, tileBoundsIndexBuffer: f3, tileBoundsSegments: m2 } = t4.getTileBoundsBuffers(o3);
        d3.draw(t4, c3.TRIANGLES, r3, a4, n3, Oi2.disabled, _2, s3.id, p3, f3, m2);
      }
      function Po(t4, i3, o3) {
        if (!i3.needsDEMTextureUpload) return;
        const s3 = t4.context, r3 = s3.gl;
        s3.pixelStoreUnpackPremultiplyAlpha.set(false), i3.demTexture = i3.demTexture || t4.getTileTexture(o3.stride);
        const a4 = o3.getPixels();
        i3.demTexture ? i3.demTexture.update(a4, { premultiply: false }) : i3.demTexture = new e2.T(s3, a4, r3.R32F, { premultiply: false }), i3.needsDEMTextureUpload = false;
      }
      function Mo(t4, i3, o3) {
        const s3 = t4.context, r3 = s3.gl;
        if (!i3.dem) return;
        const a4 = i3.dem;
        if (s3.activeTexture.set(r3.TEXTURE1), Po(t4, i3, a4), !i3.demTexture) return;
        i3.demTexture.bind(r3.NEAREST, r3.CLAMP_TO_EDGE);
        const n3 = a4.dim;
        s3.activeTexture.set(r3.TEXTURE0);
        let l3 = i3.hillshadeFBO;
        if (!l3) {
          const t5 = new e2.T(s3, { width: n3, height: n3, data: null }, r3.RGBA8);
          t5.bind(r3.LINEAR, r3.CLAMP_TO_EDGE), l3 = i3.hillshadeFBO = s3.createFramebuffer(n3, n3, true, "renderbuffer"), l3.colorAttachment.set(t5.texture);
        }
        s3.bindFramebuffer.set(l3.framebuffer), s3.viewport.set([0, 0, n3, n3]);
        const { tileBoundsBuffer: c3, tileBoundsIndexBuffer: h3, tileBoundsSegments: u4 } = t4.getMercatorTileBoundsBuffers(), d3 = [];
        t4.linearFloatFilteringSupported() && d3.push("TERRAIN_DEM_FLOAT_FORMAT"), t4.getOrCreateProgram("hillshadePrepare", { defines: d3 }).draw(t4, r3.TRIANGLES, Ai.disabled, Pi2.disabled, Ri.unblended, Oi2.disabled, ((t5, i4) => {
          const o4 = i4.stride, s4 = e2.a6.mat4.create();
          return e2.a6.mat4.ortho(s4, 0, e2.ab, -e2.ab, 0, 0, 1), e2.a6.mat4.translate(s4, s4, [0, -e2.ab, 0]), { u_matrix: s4, u_image: 1, u_dimension: [o4, o4], u_zoom: t5.overscaledZ };
        })(i3.tileID, a4), o3.id, c3, h3, u4), i3.needsHillshadePrepare = false;
      }
      class zo {
        constructor(e3) {
          this.gl = e3.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = false;
        }
        get() {
          return this.current;
        }
        set(e3) {
        }
        getDefault() {
          return this.default;
        }
        setDefault() {
          this.set(this.default);
        }
      }
      class Oo extends zo {
        getDefault() {
          return e2.bA.transparent;
        }
        set(e3) {
          const t4 = this.current;
          (e3.r !== t4.r || e3.g !== t4.g || e3.b !== t4.b || e3.a !== t4.a || this.dirty) && (this.gl.clearColor(e3.r, e3.g, e3.b, e3.a), this.current = e3, this.dirty = false);
        }
      }
      class Fo extends zo {
        getDefault() {
          return 1;
        }
        set(e3) {
          (e3 !== this.current || this.dirty) && (this.gl.clearDepth(e3), this.current = e3, this.dirty = false);
        }
      }
      class Bo extends zo {
        getDefault() {
          return 0;
        }
        set(e3) {
          (e3 !== this.current || this.dirty) && (this.gl.clearStencil(e3), this.current = e3, this.dirty = false);
        }
      }
      class ko extends zo {
        getDefault() {
          return [true, true, true, true];
        }
        set(e3) {
          const t4 = this.current;
          (e3[0] !== t4[0] || e3[1] !== t4[1] || e3[2] !== t4[2] || e3[3] !== t4[3] || this.dirty) && (this.gl.colorMask(e3[0], e3[1], e3[2], e3[3]), this.current = e3, this.dirty = false);
        }
      }
      class No extends zo {
        getDefault() {
          return true;
        }
        set(e3) {
          (e3 !== this.current || this.dirty) && (this.gl.depthMask(e3), this.current = e3, this.dirty = false);
        }
      }
      class Uo extends zo {
        getDefault() {
          return 255;
        }
        set(e3) {
          (e3 !== this.current || this.dirty) && (this.gl.stencilMask(e3), this.current = e3, this.dirty = false);
        }
      }
      class Go extends zo {
        getDefault() {
          return { func: this.gl.ALWAYS, ref: 0, mask: 255 };
        }
        set(e3) {
          const t4 = this.current;
          (e3.func !== t4.func || e3.ref !== t4.ref || e3.mask !== t4.mask || this.dirty) && (this.gl.stencilFunc(e3.func, e3.ref, e3.mask), this.current = e3, this.dirty = false);
        }
      }
      class Vo extends zo {
        getDefault() {
          const e3 = this.gl;
          return [e3.KEEP, e3.KEEP, e3.KEEP];
        }
        set(e3) {
          const t4 = this.current;
          (e3[0] !== t4[0] || e3[1] !== t4[1] || e3[2] !== t4[2] || this.dirty) && (this.gl.stencilOp(e3[0], e3[1], e3[2]), this.current = e3, this.dirty = false);
        }
      }
      class jo extends zo {
        getDefault() {
          return false;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          const t4 = this.gl;
          e3 ? t4.enable(t4.STENCIL_TEST) : t4.disable(t4.STENCIL_TEST), this.current = e3, this.dirty = false;
        }
      }
      class Ho extends zo {
        getDefault() {
          return [0, 1];
        }
        set(e3) {
          const t4 = this.current;
          (e3[0] !== t4[0] || e3[1] !== t4[1] || this.dirty) && (this.gl.depthRange(e3[0], e3[1]), this.current = e3, this.dirty = false);
        }
      }
      class Zo extends zo {
        getDefault() {
          return false;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          const t4 = this.gl;
          e3 ? t4.enable(t4.DEPTH_TEST) : t4.disable(t4.DEPTH_TEST), this.current = e3, this.dirty = false;
        }
      }
      class qo extends zo {
        getDefault() {
          return this.gl.LESS;
        }
        set(e3) {
          (e3 !== this.current || this.dirty) && (this.gl.depthFunc(e3), this.current = e3, this.dirty = false);
        }
      }
      class Wo extends zo {
        getDefault() {
          return false;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          const t4 = this.gl;
          e3 ? t4.enable(t4.BLEND) : t4.disable(t4.BLEND), this.current = e3, this.dirty = false;
        }
      }
      class $o extends zo {
        getDefault() {
          const e3 = this.gl;
          return [e3.ONE, e3.ZERO, e3.ONE, e3.ZERO];
        }
        set(e3) {
          const t4 = this.current;
          (e3[0] !== t4[0] || e3[1] !== t4[1] || e3[2] !== t4[2] || e3[3] !== t4[3] || this.dirty) && (this.gl.blendFuncSeparate(e3[0], e3[1], e3[2], e3[3]), this.current = e3, this.dirty = false);
        }
      }
      class Xo extends zo {
        getDefault() {
          return e2.bA.transparent;
        }
        set(e3) {
          const t4 = this.current;
          (e3.r !== t4.r || e3.g !== t4.g || e3.b !== t4.b || e3.a !== t4.a || this.dirty) && (this.gl.blendColor(e3.r, e3.g, e3.b, e3.a), this.current = e3, this.dirty = false);
        }
      }
      class Jo extends zo {
        getDefault() {
          return this.gl.FUNC_ADD;
        }
        set(e3) {
          (e3 !== this.current || this.dirty) && (this.gl.blendEquationSeparate(e3, e3), this.current = e3, this.dirty = false);
        }
      }
      class Ko extends zo {
        getDefault() {
          return false;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          const t4 = this.gl;
          e3 ? t4.enable(t4.CULL_FACE) : t4.disable(t4.CULL_FACE), this.current = e3, this.dirty = false;
        }
      }
      class Yo extends zo {
        getDefault() {
          return this.gl.BACK;
        }
        set(e3) {
          (e3 !== this.current || this.dirty) && (this.gl.cullFace(e3), this.current = e3, this.dirty = false);
        }
      }
      class Qo extends zo {
        getDefault() {
          return this.gl.CCW;
        }
        set(e3) {
          (e3 !== this.current || this.dirty) && (this.gl.frontFace(e3), this.current = e3, this.dirty = false);
        }
      }
      let es = class extends zo {
        getDefault() {
          return null;
        }
        set(e3) {
          (e3 !== this.current || this.dirty) && (this.gl.useProgram(e3), this.current = e3, this.dirty = false);
        }
      };
      class ts extends zo {
        getDefault() {
          return this.gl.TEXTURE0;
        }
        set(e3) {
          (e3 !== this.current || this.dirty) && (this.gl.activeTexture(e3), this.current = e3, this.dirty = false);
        }
      }
      class is extends zo {
        getDefault() {
          const e3 = this.gl;
          return [0, 0, e3.drawingBufferWidth, e3.drawingBufferHeight];
        }
        set(e3) {
          const t4 = this.current;
          (e3[0] !== t4[0] || e3[1] !== t4[1] || e3[2] !== t4[2] || e3[3] !== t4[3] || this.dirty) && (this.gl.viewport(e3[0], e3[1], e3[2], e3[3]), this.current = e3, this.dirty = false);
        }
      }
      class os extends zo {
        getDefault() {
          return null;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          const t4 = this.gl;
          t4.bindFramebuffer(t4.FRAMEBUFFER, e3), this.current = e3, this.dirty = false;
        }
      }
      class ss extends zo {
        getDefault() {
          return null;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          const t4 = this.gl;
          t4.bindRenderbuffer(t4.RENDERBUFFER, e3), this.current = e3, this.dirty = false;
        }
      }
      class rs extends zo {
        getDefault() {
          return null;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          const t4 = this.gl;
          t4.bindTexture(t4.TEXTURE_2D, e3), this.current = e3, this.dirty = false;
        }
      }
      class as extends zo {
        getDefault() {
          return null;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          const t4 = this.gl;
          t4.bindBuffer(t4.ARRAY_BUFFER, e3), this.current = e3, this.dirty = false;
        }
      }
      class ns extends zo {
        getDefault() {
          return null;
        }
        set(e3) {
          const t4 = this.gl;
          t4.bindBuffer(t4.ELEMENT_ARRAY_BUFFER, e3), this.current = e3, this.dirty = false;
        }
      }
      class ls extends zo {
        getDefault() {
          return null;
        }
        set(e3) {
          this.gl && (e3 !== this.current || this.dirty) && (this.gl.bindVertexArray(e3), this.current = e3, this.dirty = false);
        }
      }
      class cs extends zo {
        getDefault() {
          return 4;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          const t4 = this.gl;
          t4.pixelStorei(t4.UNPACK_ALIGNMENT, e3), this.current = e3, this.dirty = false;
        }
      }
      class hs extends zo {
        getDefault() {
          return false;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          const t4 = this.gl;
          t4.pixelStorei(t4.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e3), this.current = e3, this.dirty = false;
        }
      }
      class us extends zo {
        getDefault() {
          return false;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          const t4 = this.gl;
          t4.pixelStorei(t4.UNPACK_FLIP_Y_WEBGL, e3), this.current = e3, this.dirty = false;
        }
      }
      class ds extends zo {
        constructor(e3, t4) {
          super(e3), this.context = e3, this.parent = t4;
        }
        getDefault() {
          return null;
        }
      }
      class _s extends ds {
        setDirty() {
          this.dirty = true;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          this.context.bindFramebuffer.set(this.parent);
          const t4 = this.gl;
          t4.framebufferTexture2D(t4.FRAMEBUFFER, t4.COLOR_ATTACHMENT0, t4.TEXTURE_2D, e3, 0), this.current = e3, this.dirty = false;
        }
      }
      class ps extends ds {
        attachment() {
          return this.gl.DEPTH_ATTACHMENT;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          this.context.bindFramebuffer.set(this.parent);
          const t4 = this.gl;
          t4.framebufferRenderbuffer(t4.FRAMEBUFFER, this.attachment(), t4.RENDERBUFFER, e3), this.current = e3, this.dirty = false;
        }
      }
      class fs extends ds {
        attachment() {
          return this.gl.DEPTH_ATTACHMENT;
        }
        set(e3) {
          if (e3 === this.current && !this.dirty) return;
          this.context.bindFramebuffer.set(this.parent);
          const t4 = this.gl;
          t4.framebufferTexture2D(t4.FRAMEBUFFER, this.attachment(), t4.TEXTURE_2D, e3, 0), this.current = e3, this.dirty = false;
        }
      }
      class ms extends ps {
        attachment() {
          return this.gl.DEPTH_STENCIL_ATTACHMENT;
        }
      }
      const gs = (e3, t4, i3) => ({ u_matrix: e3, u_image0: 0, u_skirt_height: t4, u_ground_shadow_factor: i3 }), vs = (e3, t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4, d3, _2, p3, f3) => ({ u_proj_matrix: Float32Array.from(e3), u_globe_matrix: t4, u_normalize_matrix: Float32Array.from(o3), u_merc_matrix: i3, u_zoom_transition: s3, u_merc_center: r3, u_image0: 0, u_frustum_tl: a4, u_frustum_tr: n3, u_frustum_br: l3, u_frustum_bl: c3, u_globe_pos: h3, u_globe_radius: u4, u_viewport: d3, u_grid_matrix: f3 ? Float32Array.from(f3) : new Float32Array(9), u_skirt_height: _2, u_far_z_cutoff: p3 });
      function xs(e3, t4) {
        return null != e3 && null != t4 && !(!e3.hasData() || !t4.hasData()) && null != e3.demTexture && null != t4.demTexture && e3.tileID.key !== t4.tileID.key;
      }
      const ys = new class {
        constructor() {
          this.operations = {};
        }
        newMorphing(e3, t4, i3, o3, s3) {
          if (e3 in this.operations) {
            const t5 = this.operations[e3];
            t5.to.tileID.key !== i3.tileID.key && (t5.queued = i3);
          } else this.operations[e3] = { startTime: o3, phase: 0, duration: s3, from: t4, to: i3, queued: null };
        }
        getMorphValuesForProxy(e3) {
          if (!(e3 in this.operations)) return null;
          const t4 = this.operations[e3];
          return { from: t4.from, to: t4.to, phase: t4.phase };
        }
        update(e3) {
          for (const t4 in this.operations) {
            const i3 = this.operations[t4];
            for (i3.phase = (e3 - i3.startTime) / i3.duration; i3.phase >= 1 || !this._validOp(i3); ) if (!this._nextOp(i3, e3)) {
              delete this.operations[t4];
              break;
            }
          }
        }
        _nextOp(e3, t4) {
          return !!e3.queued && (e3.from = e3.to, e3.to = e3.queued, e3.queued = null, e3.phase = 0, e3.startTime = t4, true);
        }
        _validOp(e3) {
          return e3.from.hasData() && e3.to.hasData();
        }
      }(), bs = { 0: null, 1: "TERRAIN_VERTEX_MORPHING" };
      function ws(e3, t4, i3) {
        if (0 === t4) return 0;
        const o3 = t4 < 1 && 514 === i3 ? 0.25 / t4 : 1;
        return 6 * Math.pow(1.5, 22 - e3) * Math.max(t4, 1) * o3;
      }
      function Ts(e3, t4) {
        const i3 = 1 << e3.z;
        return !t4 && (0 === e3.x || e3.x === i3 - 1) || 0 === e3.y || e3.y === i3 - 1;
      }
      const Es = (e3) => ({ u_matrix: e3 });
      function Ss(t4, i3, o3, s3, r3) {
        if (r3 > 0) {
          const a4 = e2.e.now(), n3 = (a4 - t4.timeAdded) / r3, l3 = i3 ? (a4 - i3.timeAdded) / r3 : -1, c3 = o3.getSource(), h3 = s3.coveringZoomLevel({ tileSize: c3.tileSize, roundZoom: c3.roundZoom }), u4 = !i3 || Math.abs(i3.tileID.overscaledZ - h3) > Math.abs(t4.tileID.overscaledZ - h3), d3 = u4 && t4.refreshedUponExpiration ? 1 : e2.ap(u4 ? n3 : 1 - l3, 0, 1);
          return t4.refreshedUponExpiration && n3 >= 1 && (t4.refreshedUponExpiration = false), i3 ? { opacity: 1, mix: 1 - d3 } : { opacity: d3, mix: 0 };
        }
        return { opacity: 1, mix: 0 };
      }
      class Cs extends gt {
        constructor(t4) {
          const i3 = { type: "raster-dem", maxzoom: t4.transform.maxZoom }, o3 = new e2.ce(e2.cf(), null), s3 = Qe("mock-dem", i3, o3, t4.style);
          super("mock-dem", s3, false), s3.setEventedParent(this), this._sourceLoaded = true;
        }
        _loadTile(e3, t4) {
          e3.state = "loaded", t4(null);
        }
      }
      class Is extends gt {
        constructor(t4) {
          const i3 = Qe("proxy", { type: "geojson", maxzoom: t4.transform.maxZoom }, new e2.ce(e2.cf(), null), t4.style);
          super("proxy", i3, false), i3.setEventedParent(this), this.map = this.getSource().map = t4, this.used = this._sourceLoaded = true, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
        }
        update(e3, t4, i3) {
          if (e3.freezeTileCoverage) return;
          this.transform = e3;
          const o3 = e3.coveringTiles({ tileSize: this._source.tileSize, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: this._source.roundZoom, reparseOverscaled: this._source.reparseOverscaled }).reduce((t5, i4) => {
            if (t5[i4.key] = "", !this._tiles[i4.key]) {
              const t6 = new _t(i4, this._source.tileSize * i4.overscaleFactor(), e3.tileZoom);
              t6.state = "loaded", this._tiles[i4.key] = t6;
            }
            return t5;
          }, {});
          for (const e4 in this._tiles) e4 in o3 || (this.freeFBO(e4), this._tiles[e4].unloadVectorData(), delete this._tiles[e4]);
        }
        freeFBO(e3) {
          const t4 = this.proxyCachedFBO[e3];
          if (void 0 !== t4) {
            const i3 = Object.values(t4);
            this.renderCachePool.push(...i3), delete this.proxyCachedFBO[e3];
          }
        }
        deallocRenderCache() {
          this.renderCache.forEach((e3) => e3.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
        }
      }
      class Ds extends e2.aA {
        constructor(e3, t4, i3) {
          super(e3.overscaledZ, e3.wrap, e3.canonical.z, e3.canonical.x, e3.canonical.y), this.proxyTileKey = t4, this.projMatrix = i3;
        }
      }
      class Rs extends e2.cE {
        constructor(t4, i3) {
          super(), this._debugParams = { sortTilesHiZFirst: true, disableRenderCache: false }, t4.tp.registerParameter(this._debugParams, ["Terrain"], "sortTilesHiZFirst", {}, () => {
            this._style.map.triggerRepaint();
          }), t4.tp.registerParameter(this._debugParams, ["Terrain"], "disableRenderCache", {}, () => {
            this._style.map.triggerRepaint();
          }), t4.tp.registerButton(["Terrain"], "Invalidate Render Cache", () => {
            this.invalidateRenderCache = true, this._style.map.triggerRepaint();
          }), this.painter = t4, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
          const [o3, s3, r3] = function(t5) {
            const i4 = new e2.a$(), o4 = new e2.aP(), s4 = 131;
            i4.reserve(17161), o4.reserve(33800);
            const r4 = e2.ab / 128, a5 = e2.ab + r4 / 2, n4 = a5 + r4;
            for (let t6 = -r4; t6 < n4; t6 += r4) for (let o5 = -r4; o5 < n4; o5 += r4) {
              const s5 = o5 < 0 || o5 > a5 || t6 < 0 || t6 > a5 ? 24575 : 0, r5 = e2.ap(Math.round(o5), 0, e2.ab), n5 = e2.ap(Math.round(t6), 0, e2.ab);
              i4.emplaceBack(r5 + s5, n5);
            }
            const l3 = (e3, t6) => {
              const i5 = t6 * s4 + e3;
              o4.emplaceBack(i5 + 1, i5, i5 + s4), o4.emplaceBack(i5 + s4, i5 + s4 + 1, i5 + 1);
            };
            for (let e3 = 1; e3 < 129; e3++) for (let t6 = 1; t6 < 129; t6++) l3(t6, e3);
            return [0, 129].forEach((e3) => {
              for (let t6 = 0; t6 < 130; t6++) l3(t6, e3), l3(e3, t6);
            }), [i4, o4, 32768];
          }(), a4 = t4.context;
          this.gridBuffer = a4.createVertexBuffer(o3, e2.b1.members), this.gridIndexBuffer = a4.createIndexBuffer(s3), this.gridSegments = e2.b2.simpleSegment(0, 0, o3.length, s3.length), this.gridNoSkirtSegments = e2.b2.simpleSegment(0, 0, o3.length, r3), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new Is(i3.map), this.orthoMatrix = e2.a6.mat4.create(), e2.a6.mat4.ortho(this.orthoMatrix, "globe" === this.painter.transform.projection.name ? 0.015 : 0, e2.ab, 0, e2.ab, 0, 1);
          const n3 = a4.gl;
          this._overlapStencilMode = new Pi2({ func: n3.GEQUAL, mask: 255 }, 0, 255, n3.KEEP, n3.KEEP, n3.REPLACE), this._previousZoom = t4.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = i3, this._useVertexMorphing = true, this._exaggeration = 1, this._mockSourceCache = new Cs(i3.map), this._pendingGroundEffectLayers = [];
        }
        set style(e3) {
          e3.on("data", this._onStyleDataEvent.bind(this)), this._style = e3, this._style.map.on("moveend", () => {
            this._clearLineLayersFromRenderCache();
          });
        }
        update(t4, i3, o3) {
          if (t4 && t4.terrain) {
            this._style !== t4 && (this.style = t4, this._evaluationZoom = void 0);
            const s3 = t4.terrain.properties, r3 = 0 === t4.terrain.drapeRenderMode, a4 = t4.terrain.isZoomDependent();
            this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = e2.e.now();
            const n3 = t4.terrain && t4.terrain.scope, l3 = s3.get("source"), c3 = r3 ? this._mockSourceCache : t4.getSourceCache(l3, n3);
            if (!c3) return void e2.w(`Couldn't find terrain source "${l3}".`);
            if (this.sourceCache = c3, this._attenuationRange = t4.terrain.getAttenuationRange(), this._exaggeration = a4 ? this.calculateExaggeration(i3) : s3.get("exaggeration"), !i3.projection.requiresDraping && a4 && 0 === this._exaggeration) return void this._disable();
            this.enabled = true;
            const h3 = () => {
              this.sourceCache.used && e2.w(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.
This leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
              const t5 = this.getScaledDemTileSize();
              this.sourceCache.update(i3, t5, true), this.resetTileLookupCache(this.sourceCache.id);
            };
            this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = true, h3(), this._initializing = true), h3(), i3.updateElevation(true, o3), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i3), this._emptyDEMTextureDirty = true, this._previousZoom = i3.zoom;
          } else this._disable();
        }
        calculateExaggeration(t4) {
          if (this._attenuationRange && t4.zoom >= Math.ceil(this._attenuationRange[1])) return this._style.terrain.getExaggeration(t4.zoom);
          const i3 = this._previousCameraAltitude, o3 = t4.getFreeCameraOptions().position.z / t4.pixelsPerMeter * t4.worldSize;
          this._previousCameraAltitude = o3;
          const s3 = null != i3 ? o3 - i3 : Number.MAX_VALUE;
          if (Math.abs(s3) < 2) return this._exaggeration;
          const r3 = t4.zoom, a4 = this._style.terrain;
          if (!this._previousUpdateTimestamp) return a4.getExaggeration(r3);
          let n3 = r3 - this._previousZoom;
          const l3 = this._previousUpdateTimestamp;
          let c3 = r3;
          null != this._evaluationZoom && (c3 = this._evaluationZoom, Math.abs(r3 - c3) > 0.5 && (n3 = 0.5 * (r3 - c3 + n3)), n3 * s3 < 0 && (c3 += n3)), this._evaluationZoom = c3;
          const h3 = a4.getExaggeration(c3), u4 = h3 === a4.getExaggeration(Math.max(0, c3 - 0.1));
          if (u4 && Math.abs(h3 - this._exaggeration) < 0.01) return h3;
          let d3 = Math.min(0.1, 375e-5 * (this._updateTimestamp - l3));
          return (u4 || h3 < 0.1 || Math.abs(n3) < 1e-4) && (d3 = Math.min(0.2, 4 * d3)), e2.aa(this._exaggeration, h3, d3);
        }
        resetTileLookupCache(e3) {
          this._findCoveringTileCache[e3] = {};
        }
        attenuationRange() {
          return this._attenuationRange;
        }
        getDemUpscale() {
          return this.proxySourceCache.getSource().tileSize / 128;
        }
        getScaledDemTileSize() {
          return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
        }
        _onStyleDataEvent(e3) {
          e3.coord && "source" === e3.dataType ? this._clearRenderCacheForTile(e3.sourceCacheId, e3.coord) : "style" === e3.dataType && (this.invalidateRenderCache = true, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
        }
        _disable() {
          if (this.enabled && (this.enabled = false, this._emptyDEMTextureDirty = true, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for (const e3 in this._style._mergedSourceCaches) this._style._mergedSourceCaches[e3].usedForTerrain = false;
        }
        destroy() {
          this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this.pool.forEach((e3) => e3.fb.destroy()), this.pool = [], this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
        }
        _source() {
          return this.enabled ? this.sourceCache : null;
        }
        isUsingMockSource() {
          return this.sourceCache === this._mockSourceCache;
        }
        exaggeration() {
          return this.enabled ? this._exaggeration : 0;
        }
        get visibleDemTiles() {
          return this._visibleDemTiles;
        }
        get drapeBufferSize() {
          const e3 = 2 * this.proxySourceCache.getSource().tileSize;
          return [e3, e3];
        }
        set useVertexMorphing(e3) {
          this._useVertexMorphing = e3;
        }
        updateTileBinding(t4) {
          if (!this.enabled) return;
          this.prevTerrainTileForTile = this.terrainTileForTile;
          const i3 = this.proxySourceCache, o3 = this.painter.transform;
          this._initializing && (this._initializing = 0 === o3._centerAltitude && -1 === this.getAtPointOrZero(e2.a5.fromLngLat(o3.center), -1), this._emptyDEMTextureDirty = !this._initializing);
          const s3 = this.proxyCoords = i3.getIds().map((e3) => {
            const t5 = i3.getTileByID(e3).tileID;
            return t5.projMatrix = o3.calculateProjMatrix(t5.toUnwrapped()), t5;
          });
          !function(t5, i4) {
            const o4 = i4.transform.pointCoordinate(i4.transform.getCameraPoint()), s4 = new e2.P(o4.x, o4.y);
            t5.sort((t6, i5) => {
              if (i5.overscaledZ - t6.overscaledZ) return i5.overscaledZ - t6.overscaledZ;
              const o5 = new e2.P(t6.canonical.x + (1 << t6.canonical.z) * t6.wrap, t6.canonical.y), r4 = new e2.P(i5.canonical.x + (1 << i5.canonical.z) * i5.wrap, i5.canonical.y), a5 = s4.mult(1 << t6.canonical.z);
              return a5.x -= 0.5, a5.y -= 0.5, a5.distSqr(o5) - a5.distSqr(r4);
            });
          }(s3, this.painter);
          const r3 = this.proxyToSource || {};
          this.proxyToSource = {}, s3.forEach((e3) => {
            this.proxyToSource[e3.key] = {};
          }), this.terrainTileForTile = {};
          const a4 = this._style._mergedSourceCaches;
          for (const e3 in a4) {
            const i4 = a4[e3];
            if (!i4.used) continue;
            if (i4 !== this.sourceCache && this.resetTileLookupCache(i4.id), this._setupProxiedCoordsForOrtho(i4, t4[e3], r3), i4.usedForTerrain) continue;
            const o4 = t4[e3];
            i4.getSource().reparseOverscaled && this._assignTerrainTiles(o4);
          }
          this.proxiedCoords[i3.id] = s3.map((e3) => new Ds(e3, e3.key, this.orthoMatrix)), this._assignTerrainTiles(s3), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(r3), this.renderingToTexture = false;
          const n3 = {};
          this._visibleDemTiles = [];
          for (const e3 of this.proxyCoords) {
            const t5 = this.terrainTileForTile[e3.key];
            if (!t5) continue;
            const i4 = t5.tileID.key;
            i4 in n3 || (this._visibleDemTiles.push(t5), n3[i4] = i4);
          }
        }
        _assignTerrainTiles(e3) {
          this._initializing || e3.forEach((e4) => {
            if (this.terrainTileForTile[e4.key]) return;
            const t4 = this._findTileCoveringTileID(e4, this.sourceCache);
            t4 && (this.terrainTileForTile[e4.key] = t4);
          });
        }
        _prepareDEMTextures() {
          const e3 = this.painter.context, t4 = e3.gl;
          for (const i3 in this.terrainTileForTile) {
            const o3 = this.terrainTileForTile[i3], s3 = o3.dem;
            !s3 || o3.demTexture && !o3.needsDEMTextureUpload || (e3.activeTexture.set(t4.TEXTURE1), Po(this.painter, o3, s3));
          }
        }
        _prepareDemTileUniforms(e3, t4, i3, o3) {
          if (!t4 || null == t4.demTexture) return false;
          const s3 = e3.tileID.canonical, r3 = Math.pow(2, t4.tileID.canonical.z - s3.z), a4 = o3 || "";
          return i3[`u_dem_tl${a4}`] = [s3.x * r3 % 1, s3.y * r3 % 1], i3[`u_dem_scale${a4}`] = r3, true;
        }
        get emptyDEMTexture() {
          return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
        }
        _getLoadedAreaMinimum() {
          if (!this.enabled) return 0;
          let e3 = 0;
          const t4 = this._visibleDemTiles.reduce((t5, i3) => {
            if (!i3.dem) return t5;
            const o3 = i3.dem.tree.minimums[0];
            return o3 > 0 && e3++, t5 + o3;
          }, 0);
          return e3 ? t4 / e3 : 0;
        }
        _updateEmptyDEMTexture() {
          const t4 = this.painter.context, i3 = t4.gl;
          t4.activeTexture.set(i3.TEXTURE2);
          const o3 = this._getLoadedAreaMinimum(), s3 = new e2.cF({ width: 1, height: 1 }, new Float32Array([o3]));
          this._emptyDEMTextureDirty = false;
          let r3 = this._emptyDEMTexture;
          return r3 ? r3.update(s3, { premultiply: false }) : r3 = this._emptyDEMTexture = new e2.T(t4, s3, i3.R32F, { premultiply: false }), r3;
        }
        setupElevationDraw(t4, i3, o3) {
          const s3 = this.painter.context, r3 = s3.gl, a4 = { u_dem: 2, u_dem_prev: 4, u_dem_tl: [0, 0], u_dem_tl_prev: [0, 0], u_dem_scale: 0, u_dem_scale_prev: 0, u_dem_size: 0, u_dem_lerp: 1, u_depth: 3, u_depth_size_inv: [0, 0], u_depth_range_unpack: [0, 1], u_occluder_half_size: 16, u_occlusion_depth_offset: -1e-4, u_exaggeration: 0 };
          a4.u_exaggeration = this.exaggeration();
          let n3 = null, l3 = null, c3 = 1;
          if (o3 && o3.morphing && this._useVertexMorphing) {
            const e3 = o3.morphing.srcDemTile, i4 = o3.morphing.dstDemTile;
            c3 = o3.morphing.phase, e3 && i4 && (this._prepareDemTileUniforms(t4, e3, a4, "_prev") && (l3 = e3), this._prepareDemTileUniforms(t4, i4, a4) && (n3 = i4));
          }
          const h3 = (e3) => e3 && e3.demTexture && this.painter.linearFloatFilteringSupported() ? r3.LINEAR : r3.NEAREST;
          let u4 = null;
          var d3;
          if (this.enabled ? l3 && n3 ? (u4 = n3.demTexture, s3.activeTexture.set(r3.TEXTURE4), l3.demTexture.bind(h3(l3), r3.CLAMP_TO_EDGE), a4.u_dem_lerp = c3) : (n3 = this.terrainTileForTile[t4.tileID.key], u4 = this._prepareDemTileUniforms(t4, n3, a4) ? n3.demTexture : this.emptyDEMTexture) : u4 = this.emptyDEMTexture, s3.activeTexture.set(r3.TEXTURE2), u4 && (a4.u_dem_size = 1 === (d3 = u4).size[0] ? 1 : d3.size[0] - 2, u4.bind(h3(n3), r3.CLAMP_TO_EDGE)), this.painter.setupDepthForOcclusion(o3 && o3.useDepthForOcclusion, i3, a4), o3 && o3.useMeterToDem && n3) {
            const t5 = (1 << n3.tileID.canonical.z) * e2.bE(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
            a4.u_meter_to_dem = t5;
          }
          if (o3 && o3.labelPlaneMatrixInv && (a4.u_label_plane_matrix_inv = o3.labelPlaneMatrixInv), i3.setTerrainUniformValues(s3, a4), "globe" === this.painter.transform.projection.name) {
            const e3 = this.globeUniformValues(this.painter.transform, t4.tileID.canonical, o3 && o3.useDenormalizedUpVectorScale);
            i3.setGlobeUniformValues(s3, e3);
          }
        }
        globeUniformValues(t4, i3, o3) {
          const s3 = t4.projection;
          return { u_tile_tl_up: s3.upVector(i3, 0, 0), u_tile_tr_up: s3.upVector(i3, e2.ab, 0), u_tile_br_up: s3.upVector(i3, e2.ab, e2.ab), u_tile_bl_up: s3.upVector(i3, 0, e2.ab), u_tile_up_scale: o3 ? e2.cG(1) : s3.upVectorScale(i3, t4.center.lat, t4.worldSize).metersToTile };
        }
        renderToBackBuffer(t4) {
          const i3 = this.painter, o3 = this.painter.context;
          0 !== t4.length && (o3.bindFramebuffer.set(null), o3.viewport.set([0, 0, i3.width, i3.height]), i3.gpuTimingDeferredRenderStart(), this.renderingToTexture = false, function(t5, i4, o4, s3, r3) {
            if ("globe" === t5.transform.projection.name) !function(t6, i5, o5, s4, r4) {
              const a4 = t6.context, n3 = a4.gl;
              let l3, c3;
              const h3 = t6.transform, u4 = e2.cx(t6, a4, h3), d3 = (e3, i6) => {
                if (c3 === i6) return;
                const o6 = [bs[i6], "PROJECTION_GLOBE_VIEW"];
                u4 && o6.push("CUSTOM_ANTIALIASING");
                const s5 = t6.isTileAffectedByFog(e3);
                l3 = t6.getOrCreateProgram("globeRaster", { defines: o6, overrideFog: s5 }), c3 = i6;
              }, _2 = t6.colorModeForRenderPass(), p3 = new Ai(n3.LEQUAL, Ai.ReadWrite, t6.depthRangeFor3D);
              ys.update(r4);
              const f3 = e2.cy(h3), m2 = [e2.am(h3.center.lng), e2.at(h3.center.lat)], g4 = t6.globeSharedBuffers, v2 = [h3.width * e2.e.devicePixelRatio, h3.height * e2.e.devicePixelRatio], x2 = Float32Array.from(h3.globeMatrix), y2 = { useDenormalizedUpVectorScale: true };
              {
                const h4 = t6.transform, u5 = ws(h4.zoom, i5.exaggeration(), i5.sourceCache._source.tileSize);
                c3 = -1;
                const b2 = n3.TRIANGLES;
                for (const c4 of s4) {
                  const s5 = o5.getTile(c4), w2 = Pi2.disabled, T3 = i5.prevTerrainTileForTile[c4.key], E3 = i5.terrainTileForTile[c4.key];
                  xs(T3, E3) && ys.newMorphing(c4.key, T3, E3, r4, 250), a4.activeTexture.set(n3.TEXTURE0), s5.texture && s5.texture.bind(n3.LINEAR, n3.CLAMP_TO_EDGE);
                  const S2 = ys.getMorphValuesForProxy(c4.key), C3 = S2 ? 1 : 0;
                  S2 && e2.C(y2, { morphing: { srcDemTile: S2.from, dstDemTile: S2.to, phase: e2.cw(S2.phase) } });
                  const I3 = e2.cz(c4.canonical), D2 = e2.cA(I3.getCenter().lat), R3 = e2.cB(c4.canonical, I3, D2, h4.worldSize / h4._pixelsPerMercatorPixel), A3 = e2.b6(e2.cC(c4.canonical)), L3 = vs(h4.expandedFarZProjMatrix, x2, f3, A3, e2.a9(h4.zoom), m2, h4.frustumCorners.TL, h4.frustumCorners.TR, h4.frustumCorners.BR, h4.frustumCorners.BL, h4.globeCenterInViewSpace, h4.globeRadius, v2, u5, h4._farZ, R3);
                  if (d3(c4, C3), l3 && (i5.setupElevationDraw(s5, l3, y2), t6.uploadCommonUniforms(a4, l3, c4.toUnwrapped()), g4)) {
                    const [e3, i6, o6] = g4.getGridBuffers(D2, 0 !== u5);
                    l3.draw(t6, b2, p3, w2, _2, Oi2.backCCW, L3, "globe_raster", e3, i6, o6);
                  }
                }
              }
              if (g4 && (t6.renderDefaultNorthPole || t6.renderDefaultSouthPole)) {
                const r5 = ["GLOBE_POLES", "PROJECTION_GLOBE_VIEW"];
                u4 && r5.push("CUSTOM_ANTIALIASING"), l3 = t6.getOrCreateProgram("globeRaster", { defines: r5 });
                for (const r6 of s4) {
                  const { x: s5, y: c4, z: u5 } = r6.canonical, d4 = 0 === c4, f4 = c4 === (1 << u5) - 1, [x3, b2, w2, T3] = g4.getPoleBuffers(u5, false);
                  if (T3 && (d4 || f4)) {
                    const c5 = o5.getTile(r6);
                    a4.activeTexture.set(n3.TEXTURE0), c5.texture && c5.texture.bind(n3.LINEAR, n3.CLAMP_TO_EDGE);
                    let g5 = e2.cD(u5, s5, h3);
                    const E3 = e2.b6(e2.cC(r6.canonical)), S2 = (e3, i6) => e3.draw(t6, n3.TRIANGLES, p3, Pi2.disabled, _2, Oi2.disabled, vs(h3.expandedFarZProjMatrix, g5, g5, E3, 0, m2, h3.frustumCorners.TL, h3.frustumCorners.TR, h3.frustumCorners.BR, h3.frustumCorners.BL, h3.globeCenterInViewSpace, h3.globeRadius, v2, 0, h3._farZ), "globe_pole_raster", i6, w2, T3);
                    i5.setupElevationDraw(c5, l3, y2), t6.uploadCommonUniforms(a4, l3, r6.toUnwrapped()), d4 && t6.renderDefaultNorthPole && S2(l3, x3), f4 && t6.renderDefaultSouthPole && (g5 = e2.a6.mat4.scale(e2.a6.mat4.create(), g5, [1, -1, 1]), S2(l3, b2));
                  }
                }
              }
            }(t5, i4, o4, s3, r3);
            else {
              const a4 = t5.context, n3 = a4.gl;
              let l3, c3;
              const h3 = t5.shadowRenderer, u4 = qi(t5, t5.longestCutoffRange), d3 = (e3) => {
                if (c3 === e3) return;
                const i5 = [];
                i5.push(bs[e3]), u4.shouldRenderCutoff && i5.push("RENDER_CUTOFF"), h3 && (i5.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), h3.useNormalOffset && i5.push("NORMAL_OFFSET")), l3 = t5.getOrCreateProgram("terrainRaster", { defines: i5 }), c3 = e3;
              }, _2 = t5.colorModeForRenderPass(), p3 = new Ai(n3.LEQUAL, Ai.ReadWrite, t5.depthRangeFor3D);
              ys.update(r3);
              const f3 = t5.transform, m2 = ws(f3.zoom, i4.exaggeration(), i4.sourceCache._source.tileSize);
              let g4 = [0, 0, 0];
              if (h3) {
                const e3 = t5.style.directionalLight, i5 = t5.style.ambientLight;
                e3 && i5 && (g4 = Qi(t5.style, e3, i5));
              }
              {
                c3 = -1;
                const v2 = n3.TRIANGLES, [x2, y2] = [i4.gridIndexBuffer, i4.gridSegments];
                for (const c4 of s3) {
                  const s4 = o4.getTile(c4), b2 = Pi2.disabled, w2 = i4.prevTerrainTileForTile[c4.key], T3 = i4.terrainTileForTile[c4.key];
                  xs(w2, T3) && ys.newMorphing(c4.key, w2, T3, r3, 250), a4.activeTexture.set(n3.TEXTURE0), s4.texture && s4.texture.bind(n3.LINEAR, n3.CLAMP_TO_EDGE);
                  const E3 = ys.getMorphValuesForProxy(c4.key), S2 = E3 ? 1 : 0;
                  let C3;
                  E3 && (C3 = { morphing: { srcDemTile: E3.from, dstDemTile: E3.to, phase: e2.cw(E3.phase) } });
                  const I3 = gs(c4.projMatrix, Ts(c4.canonical, f3.renderWorldCopies) ? m2 / 10 : m2, g4);
                  if (d3(S2), !l3) continue;
                  i4.setupElevationDraw(s4, l3, C3);
                  const D2 = c4.toUnwrapped();
                  h3 && h3.setupShadows(D2, l3), t5.uploadCommonUniforms(a4, l3, D2, null, u4), l3.draw(t5, v2, p3, b2, _2, Oi2.backCCW, I3, "terrain_raster", i4.gridBuffer, x2, y2);
                }
              }
            }
          }(i3, this, this.proxySourceCache, t4, this._updateTimestamp), this.renderingToTexture = true, i3.gpuTimingDeferredRenderEnd(), t4.splice(0, t4.length));
        }
        renderBatch(t4) {
          if (0 === this._drapedRenderBatches.length) return t4 + 1;
          this.renderingToTexture = true;
          const i3 = this.painter, o3 = this.painter.context, s3 = this.proxySourceCache, r3 = this.proxiedCoords[s3.id], a4 = this._drapedRenderBatches.shift(), n3 = i3.style.order, l3 = [];
          let c3 = 0;
          for (const h3 of r3) {
            const r4 = s3.getTileByID(h3.proxyTileKey), u4 = s3.proxyCachedFBO[h3.key] ? s3.proxyCachedFBO[h3.key][t4] : void 0, d3 = void 0 !== u4 ? s3.renderCache[u4] : this.pool[c3++], _2 = void 0 !== u4;
            if (r4.texture = d3.tex, _2 && !d3.dirty) {
              l3.push(r4.tileID);
              continue;
            }
            let p3;
            o3.bindFramebuffer.set(d3.fb.framebuffer), this.renderedToTile = false, d3.dirty && (o3.clear({ color: e2.bA.transparent, stencil: 0 }), d3.dirty = false);
            for (let e3 = a4.start; e3 <= a4.end; ++e3) {
              const t5 = i3.style._mergedLayers[n3[e3]];
              if (t5.isHidden(i3.transform.zoom)) continue;
              const s4 = i3.style.getLayerSourceCache(t5), r5 = s4 ? this.proxyToSource[h3.key][s4.id] : [h3];
              if (!r5) continue;
              const a5 = r5;
              o3.viewport.set([0, 0, d3.fb.width, d3.fb.height]), p3 !== (s4 ? s4.id : null) && (this._setupStencil(d3, r5, t5, s4), p3 = s4 ? s4.id : null), i3.renderLayer(i3, s4, t5, "ground", a5);
            }
            if (0 === this._drapedRenderBatches.length) for (const e3 of this._pendingGroundEffectLayers) {
              const t5 = i3.style._mergedLayers[n3[e3]];
              if (t5.isHidden(i3.transform.zoom)) continue;
              const s4 = i3.style.getLayerSourceCache(t5), r5 = s4 ? this.proxyToSource[h3.key][s4.id] : [h3];
              if (!r5) continue;
              const a5 = r5;
              o3.viewport.set([0, 0, d3.fb.width, d3.fb.height]), p3 !== (s4 ? s4.id : null) && (this._setupStencil(d3, r5, t5, s4), p3 = s4 ? s4.id : null), i3.renderLayer(i3, s4, t5, "ground", a5);
            }
            this.renderedToTile ? (d3.dirty = true, l3.push(r4.tileID)) : _2 || --c3, 5 === c3 && (c3 = 0, this.renderToBackBuffer(l3));
          }
          return this.renderToBackBuffer(l3), this.renderingToTexture = false, o3.bindFramebuffer.set(null), o3.viewport.set([0, 0, i3.width, i3.height]), a4.end + 1;
        }
        postRender() {
        }
        isLayerOrderingCorrect(e3) {
          const t4 = e3.order.length;
          let i3 = -1, o3 = t4;
          for (let s3 = 0; s3 < t4; ++s3) this._style.isLayerDraped(e3._mergedLayers[e3.order[s3]]) ? i3 = Math.max(i3, s3) : o3 = Math.min(o3, s3);
          return o3 > i3;
        }
        getMinElevationBelowMSL() {
          let e3 = 0;
          return this._visibleDemTiles.filter((e4) => e4.dem).forEach((t4) => {
            e3 = Math.min(e3, t4.dem.tree.minimums[0]);
          }), 0 === e3 ? e3 : (e3 - 30) * this._exaggeration;
        }
        raycast(e3, t4, i3) {
          if (!this._visibleDemTiles) return null;
          const o3 = this._visibleDemTiles.filter((e4) => e4.dem).map((o4) => {
            const s3 = o4.tileID, r3 = 1 << s3.overscaledZ, { x: a4, y: n3 } = s3.canonical, l3 = a4 / r3, c3 = (a4 + 1) / r3, h3 = n3 / r3, u4 = (n3 + 1) / r3;
            return { minx: l3, miny: h3, maxx: c3, maxy: u4, t: o4.dem.tree.raycastRoot(l3, h3, c3, u4, e3, t4, i3), tile: o4 };
          });
          o3.sort((e4, t5) => (null !== e4.t ? e4.t : Number.MAX_VALUE) - (null !== t5.t ? t5.t : Number.MAX_VALUE));
          for (const s3 of o3) {
            if (null == s3.t) return null;
            const o4 = s3.tile.dem.tree.raycast(s3.minx, s3.miny, s3.maxx, s3.maxy, e3, t4, i3);
            if (null != o4) return o4;
          }
          return null;
        }
        _createFBO() {
          const t4 = this.painter.context, i3 = t4.gl, o3 = this.drapeBufferSize;
          t4.activeTexture.set(i3.TEXTURE0);
          const s3 = new e2.T(t4, { width: o3[0], height: o3[1], data: null }, i3.RGBA8);
          s3.bind(i3.LINEAR, i3.CLAMP_TO_EDGE);
          const r3 = t4.createFramebuffer(o3[0], o3[1], true, null);
          return r3.colorAttachment.set(s3.texture), r3.depthAttachment = new ms(t4, r3.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = t4.createRenderbuffer(t4.gl.DEPTH_STENCIL, o3[0], o3[1]), this._stencilRef = 0, r3.depthAttachment.set(this._sharedDepthStencil), t4.clear({ stencil: 0 })) : r3.depthAttachment.set(this._sharedDepthStencil), t4.extTextureFilterAnisotropic && i3.texParameterf(i3.TEXTURE_2D, t4.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t4.extTextureFilterAnisotropicMax), { fb: r3, tex: s3, dirty: false };
        }
        _initFBOPool() {
          for (; this.pool.length < Math.min(5, this.proxyCoords.length); ) this.pool.push(this._createFBO());
        }
        _shouldDisableRenderCache() {
          if (this._debugParams.disableRenderCache) return true;
          if (this._style.hasLightTransitions()) return true;
          for (const e3 in this._style._mergedSourceCaches) if (this._style._mergedSourceCaches[e3].hasTransition()) return true;
          return this._style.order.some((e3) => {
            const t4 = this._style._mergedLayers[e3], i3 = t4.isHidden(this.painter.transform.zoom);
            return "hillshade" === t4.type || "custom" === t4.type ? !i3 && t4.shouldRedrape() : !i3 && t4.hasTransition();
          });
        }
        _clearLineLayersFromRenderCache() {
          let t4 = false;
          for (const e3 of this._style.getSources()) if (e3 instanceof Xe) {
            t4 = true;
            break;
          }
          if (!t4) return;
          const i3 = {};
          for (let t5 = 0; t5 < this._style.order.length; ++t5) {
            const o3 = this._style._mergedLayers[this._style.order[t5]], s3 = this._style.getLayerSourceCache(o3);
            if (s3 && !i3[s3.id] && !o3.isHidden(this.painter.transform.zoom) && "line" === o3.type && o3.widthExpression() instanceof e2.a4) {
              i3[s3.id] = true;
              for (const e3 of this.proxyCoords) {
                const t6 = this.proxyToSource[e3.key][s3.id];
                if (t6) for (const e4 of t6) this._clearRenderCacheForTile(s3.id, e4);
              }
            }
          }
        }
        _clearRasterLayersFromRenderCache() {
          let e3 = false;
          for (const t5 in this._style._mergedSourceCaches) if (this._style._mergedSourceCaches[t5]._source instanceof Je) {
            e3 = true;
            break;
          }
          if (!e3) return;
          const t4 = {};
          for (let e4 = 0; e4 < this._style.order.length; ++e4) {
            const i3 = this._style._mergedLayers[this._style.order[e4]], o3 = this._style.getLayerSourceCache(i3);
            if (!o3 || t4[o3.id]) continue;
            if (i3.isHidden(this.painter.transform.zoom) || "raster" !== i3.type) continue;
            const s3 = i3.paint.get("raster-fade-duration");
            for (const e5 of this.proxyCoords) {
              const t5 = this.proxyToSource[e5.key][o3.id];
              if (t5) for (const e6 of t5) {
                const t6 = Ss(o3.getTile(e6), o3.findLoadedParent(e6, 0), o3, this.painter.transform, s3);
                (1 !== t6.opacity || 0 !== t6.mix) && this._clearRenderCacheForTile(o3.id, e6);
              }
            }
          }
        }
        _setupDrapedRenderBatches() {
          const t4 = this._style.order, i3 = t4.length;
          if (0 === i3) return;
          const o3 = [];
          this._pendingGroundEffectLayers = [];
          let s3, r3 = 0, a4 = this._style._mergedLayers[t4[r3]];
          for (; !this._style.isLayerDraped(a4) && a4.isHidden(this.painter.transform.zoom) && ++r3 < i3; ) a4 = this._style._mergedLayers[t4[r3]];
          for (; r3 < i3; ++r3) {
            const e3 = this._style._mergedLayers[t4[r3]];
            e3.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(e3) ? void 0 === s3 && (s3 = r3) : ("fill-extrusion" === e3.type && this._pendingGroundEffectLayers.push(r3), void 0 !== s3 && (o3.push({ start: s3, end: r3 - 1 }), s3 = void 0)));
          }
          if (void 0 !== s3 && o3.push({ start: s3, end: r3 - 1 }), 0 !== o3.length) {
            const t5 = o3[o3.length - 1];
            this._pendingGroundEffectLayers.every((e3) => e3 > t5.end) || e2.w("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
          }
          this._drapedRenderBatches = o3;
        }
        _setupRenderCache(e3) {
          const t4 = this.proxySourceCache;
          if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
            if (this.invalidateRenderCache = false, t4.renderCache.length > t4.renderCachePool.length) {
              const e4 = Object.values(t4.proxyCachedFBO);
              t4.proxyCachedFBO = {};
              for (let i4 = 0; i4 < e4.length; ++i4) {
                const o4 = Object.values(e4[i4]);
                t4.renderCachePool.push(...o4);
              }
            }
            return;
          }
          this._clearRasterLayersFromRenderCache();
          const i3 = this.proxyCoords, o3 = this._tilesDirty;
          for (let s4 = i3.length - 1; s4 >= 0; s4--) {
            const r3 = i3[s4];
            if (t4.getTileByID(r3.key), void 0 !== t4.proxyCachedFBO[r3.key]) {
              const i4 = e3[r3.key], s5 = this.proxyToSource[r3.key];
              let a4 = 0;
              for (const e4 in s5) {
                const t5 = s5[e4], r4 = i4[e4];
                if (!r4 || r4.length !== t5.length || t5.some((t6, i5) => t6 !== r4[i5] || o3[e4] && o3[e4].hasOwnProperty(t6.key))) {
                  a4 = -1;
                  break;
                }
                ++a4;
              }
              for (const e4 in t4.proxyCachedFBO[r3.key]) t4.renderCache[t4.proxyCachedFBO[r3.key][e4]].dirty = a4 < 0 || a4 !== Object.values(i4).length;
            }
          }
          const s3 = [...this._drapedRenderBatches];
          s3.sort((e4, t5) => t5.end - t5.start - (e4.end - e4.start));
          for (const e4 of s3) for (const o4 of i3) {
            if (t4.proxyCachedFBO[o4.key]) continue;
            let i4 = t4.renderCachePool.pop();
            void 0 === i4 && t4.renderCache.length < 50 && (i4 = t4.renderCache.length, t4.renderCache.push(this._createFBO())), void 0 !== i4 && (t4.proxyCachedFBO[o4.key] = {}, t4.proxyCachedFBO[o4.key][e4.start] = i4, t4.renderCache[i4].dirty = true);
          }
          this._tilesDirty = {};
        }
        _setupStencil(e3, t4, i3, o3) {
          if (!o3 || !this._sourceTilesOverlap[o3.id]) return void (this._overlapStencilType && (this._overlapStencilType = false));
          const s3 = this.painter.context, r3 = s3.gl;
          if (t4.length <= 1) return void (this._overlapStencilType = false);
          let a4;
          if (i3.isTileClipped()) a4 = t4.length, this._overlapStencilMode.test = { func: r3.EQUAL, mask: 255 }, this._overlapStencilType = "Clip";
          else {
            if (!(t4[0].overscaledZ > t4[t4.length - 1].overscaledZ)) return void (this._overlapStencilType = false);
            a4 = 1, this._overlapStencilMode.test = { func: r3.GREATER, mask: 255 }, this._overlapStencilType = "Mask";
          }
          this._stencilRef + a4 > 255 && (s3.clear({ stencil: 0 }), this._stencilRef = 0), this._stencilRef += a4, this._overlapStencilMode.ref = this._stencilRef, i3.isTileClipped() && this._renderTileClippingMasks(t4, this._overlapStencilMode.ref);
        }
        clipOrMaskOverlapStencilType() {
          return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
        }
        stencilModeForRTTOverlap(e3) {
          return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[e3.key]), this._overlapStencilMode) : Pi2.disabled;
        }
        _renderTileClippingMasks(e3, t4) {
          const i3 = this.painter, o3 = this.painter.context, s3 = o3.gl;
          i3._tileClippingMaskIDs = {}, o3.setColorMode(Ri.disabled), o3.setDepthMode(Ai.disabled);
          const r3 = i3.getOrCreateProgram("clippingMask");
          for (const o4 of e3) {
            const e4 = i3._tileClippingMaskIDs[o4.key] = --t4;
            r3.draw(i3, s3.TRIANGLES, Ai.disabled, new Pi2({ func: s3.ALWAYS, mask: 0 }, e4, 255, s3.KEEP, s3.KEEP, s3.REPLACE), Ri.disabled, Oi2.disabled, Es(o4.projMatrix), "$clipping", i3.tileExtentBuffer, i3.quadTriangleIndexBuffer, i3.tileExtentSegments);
          }
        }
        pointCoordinate(t4) {
          const i3 = this.painter.transform;
          if (t4.x < 0 || t4.x > i3.width || t4.y < 0 || t4.y > i3.height) return null;
          const o3 = [t4.x, t4.y, 1, 1];
          e2.a6.vec4.transformMat4(o3, o3, i3.pixelMatrixInverse), e2.a6.vec4.scale(o3, o3, 1 / o3[3]), o3[0] /= i3.worldSize, o3[1] /= i3.worldSize;
          const s3 = i3._camera.position, r3 = e2.bE(1, i3.center.lat), a4 = [s3[0], s3[1], s3[2] / r3, 0], n3 = e2.a6.vec3.subtract([], o3.slice(0, 3), a4);
          e2.a6.vec3.normalize(n3, n3);
          const l3 = this.raycast(a4, n3, this._exaggeration);
          return null !== l3 && l3 ? (e2.a6.vec3.scaleAndAdd(a4, a4, n3, l3), a4[3] = a4[2], a4[2] *= r3, a4) : null;
        }
        _setupProxiedCoordsForOrtho(t4, i3, o3) {
          if (t4.getSource() instanceof e2.aD) return this._setupProxiedCoordsForImageSource(t4, i3, o3);
          this._findCoveringTileCache[t4.id] = this._findCoveringTileCache[t4.id] || {};
          const s3 = this.proxiedCoords[t4.id] = [], r3 = this.proxyCoords;
          for (let e3 = 0; e3 < r3.length; e3++) {
            const i4 = r3[e3], a5 = this._findTileCoveringTileID(i4, t4);
            if (a5) {
              const e4 = this._createProxiedId(i4, a5, o3[i4.key] && o3[i4.key][t4.id]);
              s3.push(e4), this.proxyToSource[i4.key][t4.id] = [e4];
            }
          }
          let a4 = false;
          const n3 = /* @__PURE__ */ new Set();
          for (let e3 = 0; e3 < i3.length; e3++) {
            const r4 = t4.getTile(i3[e3]);
            if (!r4 || !r4.hasData()) continue;
            const l3 = this._findTileCoveringTileID(r4.tileID, this.proxySourceCache);
            if (l3 && l3.tileID.canonical.z !== r4.tileID.canonical.z) {
              const e4 = this.proxyToSource[l3.tileID.key][t4.id], i4 = this._createProxiedId(l3.tileID, r4, o3[l3.tileID.key] && o3[l3.tileID.key][t4.id]);
              e4 ? e4.splice(e4.length - 1, 0, i4) : this.proxyToSource[l3.tileID.key][t4.id] = [i4];
              const c3 = this.proxyToSource[l3.tileID.key][t4.id];
              n3.has(c3) || n3.add(c3), s3.push(i4), a4 = true;
            }
          }
          if (this._sourceTilesOverlap[t4.id] = a4, a4 && this._debugParams.sortTilesHiZFirst) for (const e3 of n3) e3.sort((e4, t5) => t5.overscaledZ - e4.overscaledZ);
        }
        _setupProxiedCoordsForImageSource(t4, i3, o3) {
          if (!t4.getSource().loaded()) return;
          const s3 = this.proxiedCoords[t4.id] = [], r3 = this.proxyCoords, a4 = t4.getSource(), n3 = a4.tileID;
          if (!n3) return;
          const l3 = new e2.P(n3.x, n3.y)._div(1 << n3.z), c3 = a4.coordinates.map(e2.a5.fromLngLat).reduce((e3, t5) => (e3.min.x = Math.min(e3.min.x, t5.x - l3.x), e3.min.y = Math.min(e3.min.y, t5.y - l3.y), e3.max.x = Math.max(e3.max.x, t5.x - l3.x), e3.max.y = Math.max(e3.max.y, t5.y - l3.y), e3), { min: new e2.P(Number.MAX_VALUE, Number.MAX_VALUE), max: new e2.P(-Number.MAX_VALUE, -Number.MAX_VALUE) }), h3 = (t5, i4) => {
            const o4 = t5.wrap + t5.canonical.x / (1 << t5.canonical.z), s4 = t5.canonical.y / (1 << t5.canonical.z), r4 = e2.ab / (1 << t5.canonical.z), a5 = i4.wrap + i4.canonical.x / (1 << i4.canonical.z), n4 = i4.canonical.y / (1 << i4.canonical.z);
            return o4 + r4 < a5 + c3.min.x || o4 > a5 + c3.max.x || s4 + r4 < n4 + c3.min.y || s4 > n4 + c3.max.y;
          };
          for (let e3 = 0; e3 < r3.length; e3++) {
            const a5 = r3[e3];
            for (let e4 = 0; e4 < i3.length; e4++) {
              const r4 = t4.getTile(i3[e4]);
              if (!r4 || !r4.hasData()) continue;
              if (h3(a5, r4.tileID)) continue;
              const n4 = this._createProxiedId(a5, r4, o3[a5.key] && o3[a5.key][t4.id]), l4 = this.proxyToSource[a5.key][t4.id];
              l4 ? l4.push(n4) : this.proxyToSource[a5.key][t4.id] = [n4], s3.push(n4);
            }
          }
        }
        _createProxiedId(t4, i3, o3) {
          let s3 = this.orthoMatrix;
          if (o3) {
            const e3 = o3.find((e4) => e4.key === i3.tileID.key);
            if (e3) return e3;
          }
          if (i3.tileID.key !== t4.key) {
            const o4 = t4.canonical.z - i3.tileID.canonical.z;
            let r3, a4, n3;
            s3 = e2.a6.mat4.create();
            const l3 = i3.tileID.wrap - t4.wrap << t4.overscaledZ;
            o4 > 0 ? (r3 = e2.ab >> o4, a4 = r3 * ((i3.tileID.canonical.x << o4) - t4.canonical.x + l3), n3 = r3 * ((i3.tileID.canonical.y << o4) - t4.canonical.y)) : (r3 = e2.ab << -o4, a4 = e2.ab * (i3.tileID.canonical.x - (t4.canonical.x + l3 << -o4)), n3 = e2.ab * (i3.tileID.canonical.y - (t4.canonical.y << -o4))), e2.a6.mat4.ortho(s3, 0, r3, 0, r3, 0, 1), e2.a6.mat4.translate(s3, s3, [a4, n3, 0]);
          }
          return new Ds(i3.tileID, t4.key, s3);
        }
        _findTileCoveringTileID(t4, i3) {
          let o3 = i3.getTile(t4);
          if (o3 && o3.hasData()) return o3;
          const s3 = this._findCoveringTileCache[i3.id], r3 = s3[t4.key];
          if (o3 = r3 ? i3.getTileByID(r3) : null, o3 && o3.hasData() || null === r3) return o3;
          let a4 = o3 ? o3.tileID : t4, n3 = a4.overscaledZ;
          const l3 = i3.getSource().minzoom, c3 = [];
          if (!r3) {
            const s4 = i3.getSource().maxzoom;
            if (t4.canonical.z >= s4) {
              const o4 = t4.canonical.z - s4;
              i3.getSource().reparseOverscaled ? (n3 = Math.max(t4.canonical.z + 2, i3.transform.tileZoom), a4 = new e2.aA(n3, t4.wrap, s4, t4.canonical.x >> o4, t4.canonical.y >> o4)) : 0 !== o4 && (n3 = s4, a4 = new e2.aA(n3, t4.wrap, s4, t4.canonical.x >> o4, t4.canonical.y >> o4));
            }
            a4.key !== t4.key && (c3.push(a4.key), o3 = i3.getTile(a4));
          }
          const h3 = (e3) => {
            c3.forEach((t5) => {
              s3[t5] = e3;
            }), c3.length = 0;
          };
          for (n3 -= 1; n3 >= l3 && (!o3 || !o3.hasData()); n3--) {
            o3 && h3(o3.tileID.key);
            const e3 = a4.calculateScaledKey(n3);
            if (o3 = i3.getTileByID(e3), o3 && o3.hasData()) break;
            const t5 = s3[e3];
            if (null === t5) break;
            void 0 === t5 ? c3.push(e3) : o3 = i3.getTileByID(t5);
          }
          return h3(o3 ? o3.tileID.key : null), o3 && o3.hasData() ? o3 : null;
        }
        findDEMTileFor(e3) {
          return this.enabled ? this._findTileCoveringTileID(e3, this.sourceCache) : null;
        }
        prepareDrawTile() {
          this.renderedToTile = true;
        }
        _clearRenderCacheForTile(e3, t4) {
          let i3 = this._tilesDirty[e3];
          i3 || (i3 = this._tilesDirty[e3] = {}), i3[t4.key] = true;
        }
      }
      function As(t4, i3, o3) {
        const s3 = function(t5, i4, o4) {
          const s4 = e2.a6.vec3.dot(i4, t5), r4 = e2.a6.vec3.dot(o4, [0.2126, 0.7152, 0.0722]), a5 = (e3, t6, i5) => (1 - i5) * e3 + i5 * t6, n4 = a5(1 - 0.3 * Math.min(r4, 1), 1, Math.min(s4 + 1, 1));
          return a5(0.92, 1, Math.asin(e2.ap(i4[2], -1, 1)) / Math.PI + 0.5) * n4;
        }(t4, [0, 0, 1], i3), r3 = [0, 0, 0];
        e2.a6.vec3.scale(r3, o3.slice(0, 3), s3);
        const a4 = [0, 0, 0];
        e2.a6.vec3.scale(a4, i3.slice(0, 3), t4[2]);
        const n3 = [0, 0, 0];
        return e2.a6.vec3.add(n3, r3, a4), e2.cc(n3);
      }
      const Ls = ["fill", "fillOutline", "fillPattern", "line", "linePattern", "background", "backgroundPattern", "hillshade", "raster"], Ps = ["stars", "rain_particle", "snow_particle", "fillExtrusion", "fillExtrusionGroundEffect", "model", "symbol"];
      class Ms {
        static cacheKey(e3, t4, i3, o3) {
          let s3 = `${t4}${o3 ? o3.cacheKey : ""}`;
          for (const t5 of i3) e3.usedDefines.includes(t5) && (s3 += `/${t5}`);
          return s3;
        }
        constructor(t4, i3, o3, s3, r3, a4) {
          const n3 = t4.gl;
          this.program = n3.createProgram(), this.configuration = s3, this.name = i3, this.fixedDefines = [...a4];
          const l3 = s3 ? s3.getBinderAttributes() : [], c3 = (o3.staticAttributes || []).concat(l3);
          let h3 = s3 ? s3.defines() : [];
          h3 = h3.concat(a4.map((e3) => `#define ${e3}`));
          const u4 = "#version 300 es\n";
          let d3 = u4 + h3.concat("precision mediump float;", So, Eo.fragmentSource).join("\n");
          for (const e3 of o3.fragmentIncludes) d3 += `
${wo[e3]}`;
          d3 += `
${o3.fragmentSource}`;
          let _2 = u4 + h3.concat("precision highp float;", So, Eo.vertexSource).join("\n");
          for (const e3 of o3.vertexIncludes) _2 += `
${wo[e3]}`;
          _2 += `
${o3.vertexSource}`;
          const p3 = n3.createShader(n3.FRAGMENT_SHADER);
          if (n3.isContextLost()) return void (this.failedToCreate = true);
          n3.shaderSource(p3, d3), n3.compileShader(p3), n3.attachShader(this.program, p3);
          const f3 = n3.createShader(n3.VERTEX_SHADER);
          if (n3.isContextLost()) this.failedToCreate = true;
          else {
            n3.shaderSource(f3, _2), n3.compileShader(f3), n3.attachShader(this.program, f3), this.attributes = {}, this.numAttributes = c3.length;
            for (let e3 = 0; e3 < this.numAttributes; e3++) if (c3[e3]) {
              const t5 = c3[e3].startsWith("a_") ? c3[e3] : `a_${c3[e3]}`;
              n3.bindAttribLocation(this.program, e3, t5), this.attributes[t5] = e3;
            }
            n3.linkProgram(this.program), n3.deleteShader(f3), n3.deleteShader(p3), this.fixedUniforms = r3(t4), this.binderUniforms = s3 ? s3.getUniforms(t4) : [], (a4.includes("TERRAIN") || -1 !== i3.indexOf("symbol") || -1 !== i3.indexOf("circle")) && (this.terrainUniforms = ((t5) => ({ u_dem: new e2.bK(t5), u_dem_prev: new e2.bK(t5), u_dem_tl: new e2.bH(t5), u_dem_scale: new e2.bJ(t5), u_dem_tl_prev: new e2.bH(t5), u_dem_scale_prev: new e2.bJ(t5), u_dem_size: new e2.bJ(t5), u_dem_lerp: new e2.bJ(t5), u_exaggeration: new e2.bJ(t5), u_depth: new e2.bK(t5), u_depth_size_inv: new e2.bH(t5), u_depth_range_unpack: new e2.bH(t5), u_occluder_half_size: new e2.bJ(t5), u_occlusion_depth_offset: new e2.bJ(t5), u_meter_to_dem: new e2.bJ(t5), u_label_plane_matrix_inv: new e2.bG(t5) }))(t4)), a4.includes("GLOBE") && (this.globeUniforms = ((t5) => ({ u_tile_tl_up: new e2.bI(t5), u_tile_tr_up: new e2.bI(t5), u_tile_br_up: new e2.bI(t5), u_tile_bl_up: new e2.bI(t5), u_tile_up_scale: new e2.bJ(t5) }))(t4)), a4.includes("FOG") && (this.fogUniforms = ((t5) => ({ u_fog_matrix: new e2.bG(t5), u_fog_range: new e2.bH(t5), u_fog_color: new e2.c7(t5), u_fog_horizon_blend: new e2.bJ(t5), u_fog_vertical_limit: new e2.bH(t5), u_fog_temporal_offset: new e2.bJ(t5), u_frustum_tl: new e2.bI(t5), u_frustum_tr: new e2.bI(t5), u_frustum_br: new e2.bI(t5), u_frustum_bl: new e2.bI(t5), u_globe_pos: new e2.bI(t5), u_globe_radius: new e2.bJ(t5), u_globe_transition: new e2.bJ(t5), u_is_globe: new e2.bK(t5), u_viewport: new e2.bH(t5) }))(t4)), a4.includes("RENDER_CUTOFF") && (this.cutoffUniforms = ((t5) => ({ u_cutoff_params: new e2.c7(t5) }))(t4)), a4.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = ((t5) => ({ u_lighting_ambient_color: new e2.bI(t5), u_lighting_directional_dir: new e2.bI(t5), u_lighting_directional_color: new e2.bI(t5), u_ground_radiance: new e2.bI(t5) }))(t4)), a4.includes("RENDER_SHADOWS") && (this.shadowUniforms = ((t5) => ({ u_light_matrix_0: new e2.bG(t5), u_light_matrix_1: new e2.bG(t5), u_fade_range: new e2.bH(t5), u_shadow_normal_offset: new e2.bI(t5), u_shadow_intensity: new e2.bJ(t5), u_shadow_texel_size: new e2.bJ(t5), u_shadow_map_resolution: new e2.bJ(t5), u_shadow_direction: new e2.bI(t5), u_shadow_bias: new e2.bI(t5), u_shadowmap_0: new e2.bK(t5), u_shadowmap_1: new e2.bK(t5) }))(t4));
          }
        }
        setTerrainUniformValues(e3, t4) {
          if (!this.terrainUniforms) return;
          const i3 = this.terrainUniforms;
          if (!this.failedToCreate) {
            e3.program.set(this.program);
            for (const e4 in t4) i3[e4] && i3[e4].set(this.program, e4, t4[e4]);
          }
        }
        setGlobeUniformValues(e3, t4) {
          if (!this.globeUniforms) return;
          const i3 = this.globeUniforms;
          if (!this.failedToCreate) {
            e3.program.set(this.program);
            for (const e4 in t4) i3[e4] && i3[e4].set(this.program, e4, t4[e4]);
          }
        }
        setFogUniformValues(e3, t4) {
          if (!this.fogUniforms) return;
          const i3 = this.fogUniforms;
          if (!this.failedToCreate) {
            e3.program.set(this.program);
            for (const e4 in t4) i3[e4].set(this.program, e4, t4[e4]);
          }
        }
        setCutoffUniformValues(e3, t4) {
          if (!this.cutoffUniforms) return;
          const i3 = this.cutoffUniforms;
          if (!this.failedToCreate) {
            e3.program.set(this.program);
            for (const e4 in t4) i3[e4].set(this.program, e4, t4[e4]);
          }
        }
        setLightsUniformValues(e3, t4) {
          if (!this.lightsUniforms) return;
          const i3 = this.lightsUniforms;
          if (!this.failedToCreate) {
            e3.program.set(this.program);
            for (const e4 in t4) i3[e4].set(this.program, e4, t4[e4]);
          }
        }
        setShadowUniformValues(e3, t4) {
          if (this.failedToCreate || !this.shadowUniforms) return;
          const i3 = this.shadowUniforms;
          e3.program.set(this.program);
          for (const e4 in t4) i3[e4].set(this.program, e4, t4[e4]);
        }
        _drawDebugWireframe(t4, i3, o3, s3, r3, a4, n3, l3, c3, h3) {
          const u4 = t4.options.wireframe;
          if (false === u4.terrain && false === u4.layers2D && false === u4.layers3D) return;
          const d3 = t4.context;
          if (!(() => !(!u4.terrain || "terrainRaster" !== this.name && "globeRaster" !== this.name) || !(!u4.layers2D || t4._terrain && t4._terrain.renderingToTexture || !Ls.includes(this.name)) || !(!u4.layers3D || !Ps.includes(this.name)))()) return;
          const _2 = d3.gl, p3 = t4.wireframeDebugCache.getLinesFromTrianglesBuffer(t4.frameCounter, r3, d3);
          if (!p3) return;
          const f3 = [...this.fixedDefines];
          f3.push("DEBUG_WIREFRAME");
          const m2 = t4.getOrCreateProgram(this.name, { config: this.configuration, defines: f3 });
          d3.program.set(m2.program);
          const g4 = (e3, t5, i4) => {
            if (t5[e3] && i4[e3]) for (const o4 in t5[e3]) i4[e3][o4] && i4[e3][o4].set(i4.program, o4, t5[e3][o4].current);
          };
          c3 && c3.setUniforms(m2.program, d3, m2.binderUniforms, n3, { zoom: l3 }), g4("fixedUniforms", this, m2), g4("terrainUniforms", this, m2), g4("globeUniforms", this, m2), g4("fogUniforms", this, m2), g4("lightsUniforms", this, m2), g4("shadowUniforms", this, m2), p3.bind(), d3.setColorMode(new Ri([_2.ONE, _2.ONE_MINUS_SRC_ALPHA, _2.ZERO, _2.ONE], e2.bA.transparent, [true, true, true, false])), d3.setDepthMode(new Ai(i3.func === _2.LESS ? _2.LEQUAL : i3.func, Ai.ReadOnly, i3.range)), d3.setStencilMode(Pi2.disabled);
          const v2 = 3 * a4.primitiveLength * 2, x2 = 3 * a4.primitiveOffset * 2 * 2;
          h3 && h3 > 1 ? _2.drawElementsInstanced(_2.LINES, v2, _2.UNSIGNED_SHORT, x2, h3) : _2.drawElements(_2.LINES, v2, _2.UNSIGNED_SHORT, x2), r3.bind(), d3.program.set(this.program), d3.setDepthMode(i3), d3.setStencilMode(o3), d3.setColorMode(s3);
        }
        checkUniforms(e3, t4, i3) {
          if (this.fixedDefines.includes(t4)) {
            for (const o3 of Object.keys(i3)) if (!i3[o3].initialized) throw new Error(`Program '${this.name}', from draw '${e3}': uniform ${o3} not set but required by ${t4} being defined`);
          }
        }
        draw(e3, t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4, d3, _2, p3, f3) {
          const m2 = e3.context, g4 = m2.gl;
          if (this.failedToCreate) return;
          m2.program.set(this.program), m2.setDepthMode(i3), m2.setStencilMode(o3), m2.setColorMode(s3), m2.setCullFace(r3);
          for (const e4 of Object.keys(this.fixedUniforms)) this.fixedUniforms[e4].set(this.program, e4, a4[e4]);
          _2 && _2.setUniforms(this.program, m2, this.binderUniforms, u4, { zoom: d3 });
          const v2 = { [g4.POINTS]: 1, [g4.LINES]: 2, [g4.TRIANGLES]: 3, [g4.LINE_STRIP]: 1 }[t4];
          this.checkUniforms(n3, "RENDER_SHADOWS", this.shadowUniforms);
          const x2 = f3 && f3 > 0 ? 1 : void 0;
          for (const r4 of h3.get()) {
            const a5 = r4.vaos || (r4.vaos = {});
            (a5[n3] || (a5[n3] = new Ro())).bind(m2, this, l3, _2 ? _2.getPaintVertexBuffers() : [], c3, r4.vertexOffset, p3 || [], x2), f3 && f3 > 1 ? g4.drawElementsInstanced(t4, r4.primitiveLength * v2, g4.UNSIGNED_SHORT, r4.primitiveOffset * v2 * 2, f3) : c3 ? g4.drawElements(t4, r4.primitiveLength * v2, g4.UNSIGNED_SHORT, r4.primitiveOffset * v2 * 2) : g4.drawArrays(t4, r4.vertexOffset, r4.vertexLength), t4 === g4.TRIANGLES && c3 && this._drawDebugWireframe(e3, i3, o3, s3, c3, r4, u4, d3, _2, f3);
          }
        }
      }
      function zs(t4, i3) {
        const o3 = Math.pow(2, i3.tileID.overscaledZ), s3 = i3.tileSize * Math.pow(2, t4.transform.tileZoom) / o3, r3 = s3 * (i3.tileID.canonical.x + i3.tileID.wrap * o3), a4 = s3 * i3.tileID.canonical.y;
        return { u_image: 0, u_texsize: i3.imageAtlasTexture ? i3.imageAtlasTexture.size : [0, 0], u_tile_units_to_pixels: 1 / e2.ak(i3, 1, t4.transform.tileZoom), u_pixel_coord_upper: [r3 >> 16, a4 >> 16], u_pixel_coord_lower: [65535 & r3, 65535 & a4] };
      }
      const Os = { terrain: 0, flat: 1 }, Fs = e2.a6.mat4.create(), Bs = (t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4, d3, _2, p3, f3, m2, g4, v2) => {
        const x2 = i3.style.light, y2 = x2.properties.get("position"), b2 = [y2.x, y2.y, y2.z], w2 = e2.a6.mat3.create();
        "viewport" === x2.properties.get("anchor") && (e2.a6.mat3.fromRotation(w2, -i3.transform.angle), e2.a6.vec3.transformMat3(b2, b2, w2));
        const T3 = x2.properties.get("color"), E3 = i3.transform, S2 = { u_matrix: t4, u_lightpos: b2, u_lightintensity: x2.properties.get("intensity"), u_lightcolor: [T3.r, T3.g, T3.b], u_vertical_gradient: +o3, u_opacity: s3, u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_inv_rot_matrix: Fs, u_merc_center: [0, 0], u_up_dir: [0, 0, 0], u_height_lift: 0, u_height_type: Os[h3], u_base_type: Os[u4], u_ao: r3, u_edge_radius: a4, u_width_scale: n3, u_flood_light_color: f3, u_vertical_scale: m2, u_flood_light_intensity: g4, u_ground_shadow_factor: v2 };
        return "globe" === E3.projection.name && (S2.u_tile_id = [l3.canonical.x, l3.canonical.y, 1 << l3.canonical.z], S2.u_zoom_transition = d3, S2.u_inv_rot_matrix = p3, S2.u_merc_center = _2, S2.u_up_dir = E3.projection.upVector(new e2.bQ(0, 0, 0), _2[0] * e2.ab, _2[1] * e2.ab), S2.u_height_lift = c3), S2;
      }, ks = (e3, t4, i3, o3, s3, r3) => ({ u_matrix: e3, u_edge_radius: t4, u_width_scale: i3, u_vertical_scale: o3, u_height_type: Os[s3], u_base_type: Os[r3] }), Ns = (t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4, d3, _2, p3, f3, m2, g4) => {
        const v2 = Bs(t4, i3, o3, s3, r3, a4, n3, l3, h3, u4, d3, _2, p3, f3, m2, g4, 1, [0, 0, 0]), x2 = { u_height_factor: -Math.pow(2, l3.overscaledZ) / c3.tileSize / 8 };
        return e2.m(v2, zs(i3, c3), x2);
      }, Us = (e3, t4) => ({ u_matrix: e3, u_emissive_strength: t4 }), Gs = (t4, i3, o3, s3) => e2.m(Us(t4, i3), zs(o3, s3)), Vs = (e3, t4, i3) => ({ u_matrix: e3, u_world: i3, u_emissive_strength: t4 }), js = (t4, i3, o3, s3, r3) => e2.m(Gs(t4, i3, o3, s3), { u_world: r3 }), Hs = (t4, i3, o3, s3) => {
        const r3 = e2.ab / o3.tileSize;
        return { u_matrix: t4, u_camera_to_center_distance: i3.getCameraToCenterDistance(s3), u_extrude_scale: [i3.pixelsToGLUnits[0] / r3, i3.pixelsToGLUnits[1] / r3] };
      }, Zs = (e3, t4, i3 = 1) => ({ u_matrix: e3, u_color: t4.toRenderColor(null), u_overlay: 0, u_overlay_scale: i3 }), qs = e2.a6.mat4.create(), Ws = (t4, i3, o3, s3, r3, a4, n3) => {
        const l3 = t4.transform, c3 = "globe" === l3.projection.name, h3 = c3 ? e2.cI(l3.zoom, i3.canonical) * l3._pixelsPerMercatorPixel : e2.ak(o3, 1, a4), u4 = { u_matrix: i3.projMatrix, u_extrude_scale: h3, u_intensity: n3, u_inv_rot_matrix: qs, u_merc_center: [0, 0], u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_up_dir: [0, 0, 0] };
        if (c3) {
          u4.u_inv_rot_matrix = s3, u4.u_merc_center = r3, u4.u_tile_id = [i3.canonical.x, i3.canonical.y, 1 << i3.canonical.z], u4.u_zoom_transition = e2.a9(l3.zoom);
          const t5 = r3[0] * e2.ab, o4 = r3[1] * e2.ab;
          u4.u_up_dir = l3.projection.upVector(new e2.bQ(0, 0, 0), t5, o4);
        }
        return u4;
      };
      function $s(e3, [t4, i3, o3, s3], [r3, a4]) {
        if (r3 === a4) return [0, 0, 0, 0];
        const n3 = 255 * (e3 - 1) / (e3 * (a4 - r3));
        return [t4 * n3, i3 * n3, o3 * n3, s3 * n3];
      }
      function Xs(e3, t4, [i3, o3]) {
        return i3 === o3 ? 0 : 0.5 / e3 + (t4 - i3) * (e3 - 1) / (e3 * (o3 - i3));
      }
      const Js = (t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4, d3, _2, p3, f3, m2, g4, v2, x2, y2, b2) => ({ u_matrix: t4, u_normalize_matrix: i3, u_globe_matrix: o3, u_merc_matrix: s3, u_grid_matrix: r3, u_tl_parent: a4, u_scale_parent: h3, u_fade_t: u4.mix, u_opacity: u4.opacity * d3.paint.get("raster-opacity"), u_image0: 0, u_image1: 1, u_brightness_low: d3.paint.get("raster-brightness-min"), u_brightness_high: d3.paint.get("raster-brightness-max"), u_saturation_factor: e2.cJ(d3.paint.get("raster-saturation")), u_contrast_factor: e2.cK(d3.paint.get("raster-contrast")), u_spin_weights: Ks(d3.paint.get("raster-hue-rotate")), u_perspective_transform: _2, u_raster_elevation: p3, u_zoom_transition: n3, u_merc_center: l3, u_cutoff_params: c3, u_colorization_mix: $s(e2.cL, m2, v2), u_colorization_offset: Xs(e2.cL, g4, v2), u_color_ramp: f3, u_texture_offset: [y2 / (x2 + 2 * y2), x2 / (x2 + 2 * y2)], u_texture_res: [x2 + 2 * y2, x2 + 2 * y2], u_emissive_strength: b2 });
      function Ks(e3) {
        e3 *= Math.PI / 180;
        const t4 = Math.sin(e3), i3 = Math.cos(e3);
        return [(2 * i3 + 1) / 3, (-Math.sqrt(3) * t4 - i3 + 1) / 3, (Math.sqrt(3) * t4 - i3 + 1) / 3];
      }
      const Ys = 0.05, Qs = (e3, t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4) => ({ u_matrix: e3, u_normalize_matrix: t4, u_globe_matrix: i3, u_merc_matrix: o3, u_grid_matrix: s3, u_tl_parent: r3, u_scale_parent: c3, u_fade_t: h3.mix, u_opacity: h3.opacity, u_image0: 0, u_image1: 1, u_raster_elevation: u4, u_zoom_transition: a4, u_merc_center: n3, u_cutoff_params: l3 }), er = (e3, t4, i3, o3, s3, r3, a4, n3, l3, c3) => ({ u_particle_texture: e3, u_particle_texture_side_len: t4, u_tile_offset: i3, u_velocity: o3, u_color_ramp: r3, u_velocity_res: s3, u_max_speed: a4, u_uv_offset: n3, u_data_scale: [255 * l3[0], 255 * l3[1]], u_data_offset: c3, u_particle_pos_scale: 1.1, u_particle_pos_offset: [Ys, Ys] }), tr = (e3, t4, i3, o3, s3, r3, a4, n3, l3, c3) => ({ u_particle_texture: e3, u_particle_texture_side_len: t4, u_velocity: i3, u_velocity_res: o3, u_max_speed: s3, u_speed_factor: r3, u_reset_rate: a4, u_rand_seed: Math.random(), u_uv_offset: n3, u_data_scale: [255 * l3[0], 255 * l3[1]], u_data_offset: c3, u_particle_pos_scale: 1.1, u_particle_pos_offset: [Ys, Ys] }), ir = e2.a6.mat4.create(), or = (t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4, d3, _2, p3, f3, m2, g4, v2, x2, y2, b2, w2) => {
        const T3 = r3.transform, E3 = { u_is_size_zoom_constant: +("constant" === t4 || "source" === t4), u_is_size_feature_constant: +("constant" === t4 || "camera" === t4), u_size_t: i3 ? i3.uSizeT : 0, u_size: i3 ? i3.uSize : 0, u_camera_to_center_distance: T3.getCameraToCenterDistance(x2), u_rotate_symbol: +o3, u_aspect_ratio: T3.width / T3.height, u_fade_change: r3.options.fadeDuration ? r3.symbolFadeChange : 1, u_matrix: a4, u_label_plane_matrix: n3, u_coord_matrix: l3, u_is_text: +h3, u_elevation_from_sea: c3 ? 1 : 0, u_pitch_with_map: +s3, u_texsize: u4, u_texsize_icon: d3, u_texture: 0, u_texture_icon: 1, u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_inv_rot_matrix: ir, u_merc_center: [0, 0], u_camera_forward: [0, 0, 0], u_ecef_origin: [0, 0, 0], u_tile_matrix: ir, u_up_vector: [0, -1, 0], u_color_adj_mat: y2, u_icon_transition: b2 || 0, u_gamma_scale: s3 ? r3.transform.getCameraToCenterDistance(x2) * Math.cos(r3.terrain ? 0 : r3.transform._pitch) : 1, u_device_pixel_ratio: e2.e.devicePixelRatio, u_is_halo: 1, u_scale_factor: w2 || 1 };
        return "globe" === x2.name && (E3.u_tile_id = [p3.canonical.x, p3.canonical.y, 1 << p3.canonical.z], E3.u_zoom_transition = f3, E3.u_inv_rot_matrix = g4, E3.u_merc_center = m2, E3.u_camera_forward = T3._camera.forward(), E3.u_ecef_origin = e2.cM(T3.globeMatrix, p3.toUnwrapped()), E3.u_tile_matrix = Float32Array.from(T3.globeMatrix), E3.u_up_vector = v2), E3;
      }, sr = (e3, t4, i3, o3) => ({ u_matrix: e3, u_emissive_strength: t4, u_opacity: i3, u_color: o3 }), rr = (t4, i3, o3, s3, r3, a4, n3, l3, c3) => e2.m(function(t5, i4, o4, s4, r4, a5) {
        const { width: n4, height: l4 } = s4.imageManager.getPixelSize(i4), c4 = Math.pow(2, a5.tileID.overscaledZ), h3 = a5.tileSize * Math.pow(2, s4.transform.tileZoom) / c4, u4 = h3 * (a5.tileID.canonical.x + a5.tileID.wrap * c4), d3 = h3 * a5.tileID.canonical.y;
        return { u_image: 0, u_pattern_tl: o4.tl, u_pattern_br: o4.br, u_texsize: [n4, l4], u_pattern_size: o4.displaySize, u_pattern_units_to_pixels: r4 ? [s4.transform.width, -1 * s4.transform.height] : [1 / e2.ak(a5, 1, s4.transform.tileZoom), 1 / e2.ak(a5, 1, s4.transform.tileZoom)], u_pixel_coord_upper: [u4 >> 16, d3 >> 16], u_pixel_coord_lower: [65535 & u4, 65535 & d3] };
      }(0, a4, n3, s3, l3, c3), { u_matrix: t4, u_emissive_strength: i3, u_opacity: o3 }), ar = new Float32Array(e2.a6.mat4.identity([])), nr = (t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4, d3, _2, p3 = [0, 0, 0], f3) => {
        const m2 = r3.style.light, g4 = m2.properties.get("position"), v2 = [-g4.x, -g4.y, g4.z], x2 = e2.a6.mat3.create();
        "viewport" === m2.properties.get("anchor") && (e2.a6.mat3.fromRotation(x2, -r3.transform.angle), e2.a6.vec3.transformMat3(v2, v2, x2));
        const y2 = "MASK" === u4.alphaMode, b2 = m2.properties.get("color").toRenderColor(null), w2 = _2.paint.get("model-ambient-occlusion-intensity"), T3 = _2.paint.get("model-color").constantOr(e2.bA.white).toRenderColor(null), E3 = _2.paint.get("model-color-mix-intensity").constantOr(0);
        return { u_matrix: t4, u_lighting_matrix: i3, u_normal_matrix: o3, u_node_matrix: s3 || ar, u_lightpos: v2, u_lightintensity: m2.properties.get("intensity"), u_lightcolor: [b2.r, b2.g, b2.b], u_camera_pos: p3, u_opacity: a4, u_baseTextureIsAlpha: 0, u_alphaMask: +y2, u_alphaCutoff: u4.alphaCutoff, u_baseColorFactor: [n3.r, n3.g, n3.b, n3.a], u_emissiveFactor: [l3[0], l3[1], l3[2], 1], u_metallicFactor: c3, u_roughnessFactor: h3, u_baseColorTexture: Gi.BaseColor, u_metallicRoughnessTexture: Gi.MetallicRoughness, u_normalTexture: Gi.Normal, u_occlusionTexture: Gi.Occlusion, u_emissionTexture: Gi.Emission, u_lutTexture: Gi.LUT, u_color_mix: [T3.r, T3.g, T3.b, E3], u_aoIntensity: w2, u_emissive_strength: d3, u_occlusionTextureTransform: f3 || [0, 0, 0, 0] };
      }, lr = (e3, t4 = ar, i3 = ar) => ({ u_matrix: e3, u_instance: t4, u_node_matrix: i3 }), cr = { fillExtrusion: (t4) => ({ u_matrix: new e2.bG(t4), u_lightpos: new e2.bI(t4), u_lightintensity: new e2.bJ(t4), u_lightcolor: new e2.bI(t4), u_vertical_gradient: new e2.bJ(t4), u_opacity: new e2.bJ(t4), u_edge_radius: new e2.bJ(t4), u_width_scale: new e2.bJ(t4), u_ao: new e2.bH(t4), u_height_type: new e2.bK(t4), u_base_type: new e2.bK(t4), u_tile_id: new e2.bI(t4), u_zoom_transition: new e2.bJ(t4), u_inv_rot_matrix: new e2.bG(t4), u_merc_center: new e2.bH(t4), u_up_dir: new e2.bI(t4), u_height_lift: new e2.bJ(t4), u_flood_light_color: new e2.bI(t4), u_vertical_scale: new e2.bJ(t4), u_flood_light_intensity: new e2.bJ(t4), u_ground_shadow_factor: new e2.bI(t4) }), fillExtrusionDepth: (t4) => ({ u_matrix: new e2.bG(t4), u_edge_radius: new e2.bJ(t4), u_width_scale: new e2.bJ(t4), u_vertical_scale: new e2.bJ(t4), u_height_type: new e2.bK(t4), u_base_type: new e2.bK(t4) }), fillExtrusionPattern: (t4) => ({ u_matrix: new e2.bG(t4), u_lightpos: new e2.bI(t4), u_lightintensity: new e2.bJ(t4), u_lightcolor: new e2.bI(t4), u_vertical_gradient: new e2.bJ(t4), u_height_factor: new e2.bJ(t4), u_edge_radius: new e2.bJ(t4), u_width_scale: new e2.bJ(t4), u_ao: new e2.bH(t4), u_height_type: new e2.bK(t4), u_base_type: new e2.bK(t4), u_tile_id: new e2.bI(t4), u_zoom_transition: new e2.bJ(t4), u_inv_rot_matrix: new e2.bG(t4), u_merc_center: new e2.bH(t4), u_up_dir: new e2.bI(t4), u_height_lift: new e2.bJ(t4), u_image: new e2.bK(t4), u_texsize: new e2.bH(t4), u_pixel_coord_upper: new e2.bH(t4), u_pixel_coord_lower: new e2.bH(t4), u_tile_units_to_pixels: new e2.bJ(t4), u_opacity: new e2.bJ(t4) }), fillExtrusionGroundEffect: (t4) => ({ u_matrix: new e2.bG(t4), u_opacity: new e2.bJ(t4), u_ao_pass: new e2.bJ(t4), u_meter_to_tile: new e2.bJ(t4), u_ao: new e2.bH(t4), u_flood_light_intensity: new e2.bJ(t4), u_flood_light_color: new e2.bI(t4), u_attenuation: new e2.bJ(t4), u_edge_radius: new e2.bJ(t4), u_fb: new e2.bK(t4), u_fb_size: new e2.bJ(t4), u_dynamic_offset: new e2.bJ(t4) }), fill: (t4) => ({ u_matrix: new e2.bG(t4), u_emissive_strength: new e2.bJ(t4) }), fillPattern: (t4) => ({ u_matrix: new e2.bG(t4), u_emissive_strength: new e2.bJ(t4), u_image: new e2.bK(t4), u_texsize: new e2.bH(t4), u_pixel_coord_upper: new e2.bH(t4), u_pixel_coord_lower: new e2.bH(t4), u_tile_units_to_pixels: new e2.bJ(t4) }), fillOutline: (t4) => ({ u_matrix: new e2.bG(t4), u_emissive_strength: new e2.bJ(t4), u_world: new e2.bH(t4) }), fillOutlinePattern: (t4) => ({ u_matrix: new e2.bG(t4), u_emissive_strength: new e2.bJ(t4), u_world: new e2.bH(t4), u_image: new e2.bK(t4), u_texsize: new e2.bH(t4), u_pixel_coord_upper: new e2.bH(t4), u_pixel_coord_lower: new e2.bH(t4), u_tile_units_to_pixels: new e2.bJ(t4) }), circle: e2.cN, collisionBox: (t4) => ({ u_matrix: new e2.bG(t4), u_camera_to_center_distance: new e2.bJ(t4), u_extrude_scale: new e2.bH(t4) }), collisionCircle: (t4) => ({ u_matrix: new e2.bG(t4), u_inv_matrix: new e2.bG(t4), u_camera_to_center_distance: new e2.bJ(t4), u_viewport_size: new e2.bH(t4) }), debug: (t4) => ({ u_color: new e2.cu(t4), u_matrix: new e2.bG(t4), u_overlay: new e2.bK(t4), u_overlay_scale: new e2.bJ(t4) }), clippingMask: (t4) => ({ u_matrix: new e2.bG(t4) }), heatmap: (t4) => ({ u_extrude_scale: new e2.bJ(t4), u_intensity: new e2.bJ(t4), u_matrix: new e2.bG(t4), u_inv_rot_matrix: new e2.bG(t4), u_merc_center: new e2.bH(t4), u_tile_id: new e2.bI(t4), u_zoom_transition: new e2.bJ(t4), u_up_dir: new e2.bI(t4) }), heatmapTexture: (t4) => ({ u_image: new e2.bK(t4), u_color_ramp: new e2.bK(t4), u_opacity: new e2.bJ(t4) }), hillshade: (t4) => ({ u_matrix: new e2.bG(t4), u_image: new e2.bK(t4), u_latrange: new e2.bH(t4), u_light: new e2.bH(t4), u_shadow: new e2.cu(t4), u_highlight: new e2.cu(t4), u_emissive_strength: new e2.bJ(t4), u_accent: new e2.cu(t4) }), hillshadePrepare: (t4) => ({ u_matrix: new e2.bG(t4), u_image: new e2.bK(t4), u_dimension: new e2.bH(t4), u_zoom: new e2.bJ(t4) }), line: e2.cO, linePattern: e2.cP, raster: (t4) => ({ u_matrix: new e2.bG(t4), u_normalize_matrix: new e2.bG(t4), u_globe_matrix: new e2.bG(t4), u_merc_matrix: new e2.bG(t4), u_grid_matrix: new e2.cv(t4), u_tl_parent: new e2.bH(t4), u_scale_parent: new e2.bJ(t4), u_fade_t: new e2.bJ(t4), u_opacity: new e2.bJ(t4), u_image0: new e2.bK(t4), u_image1: new e2.bK(t4), u_brightness_low: new e2.bJ(t4), u_brightness_high: new e2.bJ(t4), u_saturation_factor: new e2.bJ(t4), u_contrast_factor: new e2.bJ(t4), u_spin_weights: new e2.bI(t4), u_perspective_transform: new e2.bH(t4), u_raster_elevation: new e2.bJ(t4), u_zoom_transition: new e2.bJ(t4), u_merc_center: new e2.bH(t4), u_cutoff_params: new e2.c7(t4), u_colorization_mix: new e2.c7(t4), u_colorization_offset: new e2.bJ(t4), u_color_ramp: new e2.bK(t4), u_texture_offset: new e2.bH(t4), u_texture_res: new e2.bH(t4), u_emissive_strength: new e2.bJ(t4) }), rasterParticle: (t4) => ({ u_matrix: new e2.bG(t4), u_normalize_matrix: new e2.bG(t4), u_globe_matrix: new e2.bG(t4), u_merc_matrix: new e2.bG(t4), u_grid_matrix: new e2.cv(t4), u_tl_parent: new e2.bH(t4), u_scale_parent: new e2.bJ(t4), u_fade_t: new e2.bJ(t4), u_opacity: new e2.bJ(t4), u_image0: new e2.bK(t4), u_image1: new e2.bK(t4), u_raster_elevation: new e2.bJ(t4), u_zoom_transition: new e2.bJ(t4), u_merc_center: new e2.bH(t4), u_cutoff_params: new e2.c7(t4) }), rasterParticleTexture: (t4) => ({ u_texture: new e2.bK(t4), u_opacity: new e2.bJ(t4) }), rasterParticleDraw: (t4) => ({ u_particle_texture: new e2.bK(t4), u_particle_texture_side_len: new e2.bJ(t4), u_tile_offset: new e2.bH(t4), u_velocity: new e2.bK(t4), u_color_ramp: new e2.bK(t4), u_velocity_res: new e2.bH(t4), u_max_speed: new e2.bJ(t4), u_uv_offset: new e2.bH(t4), u_data_scale: new e2.bH(t4), u_data_offset: new e2.bJ(t4), u_particle_pos_scale: new e2.bJ(t4), u_particle_pos_offset: new e2.bH(t4) }), rasterParticleUpdate: (t4) => ({ u_particle_texture: new e2.bK(t4), u_particle_texture_side_len: new e2.bJ(t4), u_velocity: new e2.bK(t4), u_velocity_res: new e2.bH(t4), u_max_speed: new e2.bJ(t4), u_speed_factor: new e2.bJ(t4), u_reset_rate: new e2.bJ(t4), u_rand_seed: new e2.bJ(t4), u_uv_offset: new e2.bH(t4), u_data_scale: new e2.bH(t4), u_data_offset: new e2.bJ(t4), u_particle_pos_scale: new e2.bJ(t4), u_particle_pos_offset: new e2.bH(t4) }), symbol: (t4) => ({ u_is_size_zoom_constant: new e2.bK(t4), u_is_size_feature_constant: new e2.bK(t4), u_size_t: new e2.bJ(t4), u_size: new e2.bJ(t4), u_camera_to_center_distance: new e2.bJ(t4), u_rotate_symbol: new e2.bK(t4), u_aspect_ratio: new e2.bJ(t4), u_fade_change: new e2.bJ(t4), u_matrix: new e2.bG(t4), u_label_plane_matrix: new e2.bG(t4), u_coord_matrix: new e2.bG(t4), u_is_text: new e2.bK(t4), u_elevation_from_sea: new e2.bK(t4), u_pitch_with_map: new e2.bK(t4), u_texsize: new e2.bH(t4), u_texsize_icon: new e2.bH(t4), u_texture: new e2.bK(t4), u_texture_icon: new e2.bK(t4), u_gamma_scale: new e2.bJ(t4), u_device_pixel_ratio: new e2.bJ(t4), u_tile_id: new e2.bI(t4), u_zoom_transition: new e2.bJ(t4), u_inv_rot_matrix: new e2.bG(t4), u_merc_center: new e2.bH(t4), u_camera_forward: new e2.bI(t4), u_tile_matrix: new e2.bG(t4), u_up_vector: new e2.bI(t4), u_ecef_origin: new e2.bI(t4), u_is_halo: new e2.bK(t4), u_icon_transition: new e2.bJ(t4), u_color_adj_mat: new e2.bG(t4), u_scale_factor: new e2.bJ(t4) }), background: (t4) => ({ u_matrix: new e2.bG(t4), u_emissive_strength: new e2.bJ(t4), u_opacity: new e2.bJ(t4), u_color: new e2.cu(t4) }), backgroundPattern: (t4) => ({ u_matrix: new e2.bG(t4), u_emissive_strength: new e2.bJ(t4), u_opacity: new e2.bJ(t4), u_image: new e2.bK(t4), u_pattern_tl: new e2.bH(t4), u_pattern_br: new e2.bH(t4), u_texsize: new e2.bH(t4), u_pattern_size: new e2.bH(t4), u_pixel_coord_upper: new e2.bH(t4), u_pixel_coord_lower: new e2.bH(t4), u_pattern_units_to_pixels: new e2.bH(t4) }), terrainRaster: (t4) => ({ u_matrix: new e2.bG(t4), u_image0: new e2.bK(t4), u_skirt_height: new e2.bJ(t4), u_ground_shadow_factor: new e2.bI(t4) }), skybox: (t4) => ({ u_matrix: new e2.bG(t4), u_sun_direction: new e2.bI(t4), u_cubemap: new e2.bK(t4), u_opacity: new e2.bJ(t4), u_temporal_offset: new e2.bJ(t4) }), skyboxGradient: (t4) => ({ u_matrix: new e2.bG(t4), u_color_ramp: new e2.bK(t4), u_center_direction: new e2.bI(t4), u_radius: new e2.bJ(t4), u_opacity: new e2.bJ(t4), u_temporal_offset: new e2.bJ(t4) }), skyboxCapture: (t4) => ({ u_matrix_3f: new e2.cv(t4), u_sun_direction: new e2.bI(t4), u_sun_intensity: new e2.bJ(t4), u_color_tint_r: new e2.c7(t4), u_color_tint_m: new e2.c7(t4), u_luminance: new e2.bJ(t4) }), globeRaster: (t4) => ({ u_proj_matrix: new e2.bG(t4), u_globe_matrix: new e2.bG(t4), u_normalize_matrix: new e2.bG(t4), u_merc_matrix: new e2.bG(t4), u_zoom_transition: new e2.bJ(t4), u_merc_center: new e2.bH(t4), u_image0: new e2.bK(t4), u_grid_matrix: new e2.cv(t4), u_skirt_height: new e2.bJ(t4), u_far_z_cutoff: new e2.bJ(t4), u_frustum_tl: new e2.bI(t4), u_frustum_tr: new e2.bI(t4), u_frustum_br: new e2.bI(t4), u_frustum_bl: new e2.bI(t4), u_globe_pos: new e2.bI(t4), u_globe_radius: new e2.bJ(t4), u_viewport: new e2.bH(t4) }), globeAtmosphere: (t4) => ({ u_frustum_tl: new e2.bI(t4), u_frustum_tr: new e2.bI(t4), u_frustum_br: new e2.bI(t4), u_frustum_bl: new e2.bI(t4), u_horizon: new e2.bJ(t4), u_transition: new e2.bJ(t4), u_fadeout_range: new e2.bJ(t4), u_color: new e2.c7(t4), u_high_color: new e2.c7(t4), u_space_color: new e2.c7(t4), u_temporal_offset: new e2.bJ(t4), u_horizon_angle: new e2.bJ(t4) }), model: (t4) => ({ u_matrix: new e2.bG(t4), u_lighting_matrix: new e2.bG(t4), u_normal_matrix: new e2.bG(t4), u_node_matrix: new e2.bG(t4), u_lightpos: new e2.bI(t4), u_lightintensity: new e2.bJ(t4), u_lightcolor: new e2.bI(t4), u_camera_pos: new e2.bI(t4), u_opacity: new e2.bJ(t4), u_baseColorFactor: new e2.c7(t4), u_emissiveFactor: new e2.c7(t4), u_metallicFactor: new e2.bJ(t4), u_roughnessFactor: new e2.bJ(t4), u_baseTextureIsAlpha: new e2.bK(t4), u_alphaMask: new e2.bK(t4), u_alphaCutoff: new e2.bJ(t4), u_baseColorTexture: new e2.bK(t4), u_metallicRoughnessTexture: new e2.bK(t4), u_normalTexture: new e2.bK(t4), u_occlusionTexture: new e2.bK(t4), u_emissionTexture: new e2.bK(t4), u_lutTexture: new e2.bK(t4), u_color_mix: new e2.c7(t4), u_aoIntensity: new e2.bJ(t4), u_emissive_strength: new e2.bJ(t4), u_occlusionTextureTransform: new e2.c7(t4) }), modelDepth: (t4) => ({ u_matrix: new e2.bG(t4), u_instance: new e2.bG(t4), u_node_matrix: new e2.bG(t4) }), groundShadow: (t4) => ({ u_matrix: new e2.bG(t4), u_ground_shadow_factor: new e2.bI(t4) }), stars: (t4) => ({ u_matrix: new e2.bG(t4), u_up: new e2.bI(t4), u_right: new e2.bI(t4), u_intensity_multiplier: new e2.bJ(t4) }), snowParticle: (t4) => ({ u_modelview: new e2.bG(t4), u_projection: new e2.bG(t4), u_time: new e2.bJ(t4), u_cam_pos: new e2.bI(t4), u_velocityConeAperture: new e2.bJ(t4), u_velocity: new e2.bJ(t4), u_horizontalOscillationRadius: new e2.bJ(t4), u_horizontalOscillationRate: new e2.bJ(t4), u_boxSize: new e2.bJ(t4), u_billboardSize: new e2.bJ(t4), u_simpleShapeParameters: new e2.bH(t4), u_screenSize: new e2.bH(t4), u_thinningCenterPos: new e2.bH(t4), u_thinningShape: new e2.bI(t4), u_thinningAffectedRatio: new e2.bJ(t4), u_thinningParticleOffset: new e2.bJ(t4), u_particleColor: new e2.c7(t4), u_direction: new e2.bI(t4) }), rainParticle: (t4) => ({ u_modelview: new e2.bG(t4), u_projection: new e2.bG(t4), u_time: new e2.bJ(t4), u_cam_pos: new e2.bI(t4), u_texScreen: new e2.bK(t4), u_velocityConeAperture: new e2.bJ(t4), u_velocity: new e2.bJ(t4), u_boxSize: new e2.bJ(t4), u_rainDropletSize: new e2.bH(t4), u_distortionStrength: new e2.bJ(t4), u_rainDirection: new e2.bI(t4), u_color: new e2.c7(t4), u_screenSize: new e2.bH(t4), u_thinningCenterPos: new e2.bH(t4), u_thinningShape: new e2.bI(t4), u_thinningAffectedRatio: new e2.bJ(t4), u_thinningParticleOffset: new e2.bJ(t4), u_shapeDirectionalPower: new e2.bJ(t4), u_mode: new e2.bJ(t4) }), occlusion: (t4) => ({ u_matrix: new e2.bG(t4), u_anchorPos: new e2.bI(t4), u_screenSizePx: new e2.bH(t4), u_occluderSizePx: new e2.bH(t4), u_color: new e2.c7(t4) }) };
      class hr {
        constructor(e3, t4, i3, o3) {
          this.id = hr.uniqueIdxCounter, hr.uniqueIdxCounter++, this.context = e3;
          const s3 = e3.gl;
          this.buffer = s3.createBuffer(), this.dynamicDraw = Boolean(i3), this.context.unbindVAO(), e3.bindElementBuffer.set(this.buffer), s3.bufferData(s3.ELEMENT_ARRAY_BUFFER, t4.arrayBuffer, this.dynamicDraw ? s3.DYNAMIC_DRAW : s3.STATIC_DRAW), this.dynamicDraw || o3 || t4.destroy();
        }
        bind() {
          this.context.bindElementBuffer.set(this.buffer);
        }
        updateData(e3) {
          this.id = hr.uniqueIdxCounter, hr.uniqueIdxCounter++;
          const t4 = this.context.gl;
          this.context.unbindVAO(), this.bind(), t4.bufferSubData(t4.ELEMENT_ARRAY_BUFFER, 0, e3.arrayBuffer);
        }
        destroy() {
          this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        }
      }
      hr.uniqueIdxCounter = 0;
      const ur = { Int8: "BYTE", Uint8: "UNSIGNED_BYTE", Int16: "SHORT", Uint16: "UNSIGNED_SHORT", Int32: "INT", Uint32: "UNSIGNED_INT", Float32: "FLOAT" };
      class dr {
        constructor(e3, t4, i3, o3, s3, r3) {
          this.length = t4.length, this.attributes = i3, this.itemSize = t4.bytesPerElement, this.dynamicDraw = o3, this.instanceCount = r3, this.context = e3;
          const a4 = e3.gl;
          this.buffer = a4.createBuffer(), e3.bindVertexBuffer.set(this.buffer), a4.bufferData(a4.ARRAY_BUFFER, t4.arrayBuffer, this.dynamicDraw ? a4.DYNAMIC_DRAW : a4.STATIC_DRAW), this.dynamicDraw || s3 || t4.destroy();
        }
        bind() {
          this.context.bindVertexBuffer.set(this.buffer);
        }
        updateData(e3) {
          const t4 = this.context.gl;
          this.bind(), t4.bufferSubData(t4.ARRAY_BUFFER, 0, e3.arrayBuffer);
        }
        enableAttributes(e3, t4) {
          for (let i3 = 0; i3 < this.attributes.length; i3++) {
            const o3 = t4.attributes[this.attributes[i3].name];
            void 0 !== o3 && e3.enableVertexAttribArray(o3);
          }
        }
        setVertexAttribPointers(e3, t4, i3) {
          for (let o3 = 0; o3 < this.attributes.length; o3++) {
            const s3 = this.attributes[o3], r3 = t4.attributes[s3.name];
            void 0 !== r3 && e3.vertexAttribPointer(r3, s3.components, e3[ur[s3.type]], false, this.itemSize, s3.offset + this.itemSize * (i3 || 0));
          }
        }
        setVertexAttribDivisor(e3, t4, i3) {
          for (let o3 = 0; o3 < this.attributes.length; o3++) {
            const s3 = t4.attributes[this.attributes[o3].name];
            void 0 !== s3 && this.instanceCount && this.instanceCount > 0 && e3.vertexAttribDivisor(s3, i3);
          }
        }
        destroy() {
          this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        }
      }
      class _r {
        constructor(e3, t4, i3, o3, s3) {
          this.context = e3, this.width = t4, this.height = i3;
          const r3 = this.framebuffer = e3.gl.createFramebuffer();
          o3 && (this.colorAttachment = new _s(e3, r3)), s3 && (this.depthAttachmentType = s3, this.depthAttachment = "renderbuffer" === s3 ? new ps(e3, r3) : new fs(e3, r3));
        }
        destroy() {
          const e3 = this.context.gl;
          if (this.colorAttachment) {
            const t4 = this.colorAttachment.get();
            t4 && e3.deleteTexture(t4);
          }
          if (this.depthAttachment && this.depthAttachmentType) if ("renderbuffer" === this.depthAttachmentType) {
            const t4 = this.depthAttachment.get();
            t4 && e3.deleteRenderbuffer(t4);
          } else {
            const t4 = this.depthAttachment.get();
            t4 && e3.deleteTexture(t4);
          }
          e3.deleteFramebuffer(this.framebuffer);
        }
      }
      class pr {
        constructor(e3, t4) {
          this.gl = e3, this.clearColor = new Oo(this), this.clearDepth = new Fo(this), this.clearStencil = new Bo(this), this.colorMask = new ko(this), this.depthMask = new No(this), this.stencilMask = new Uo(this), this.stencilFunc = new Go(this), this.stencilOp = new Vo(this), this.stencilTest = new jo(this), this.depthRange = new Ho(this), this.depthTest = new Zo(this), this.depthFunc = new qo(this), this.blend = new Wo(this), this.blendFunc = new $o(this), this.blendColor = new Xo(this), this.blendEquation = new Jo(this), this.cullFace = new Ko(this), this.cullFaceSide = new Yo(this), this.frontFace = new Qo(this), this.program = new es(this), this.activeTexture = new ts(this), this.viewport = new is(this), this.bindFramebuffer = new os(this), this.bindRenderbuffer = new ss(this), this.bindTexture = new rs(this), this.bindVertexBuffer = new as(this), this.bindElementBuffer = new ns(this), this.bindVertexArrayOES = new ls(this), this.pixelStoreUnpack = new cs(this), this.pixelStoreUnpackPremultiplyAlpha = new hs(this), this.pixelStoreUnpackFlipY = new us(this), this.options = t4 ? { ...t4 } : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = e3.getExtension("EXT_texture_filter_anisotropic") || e3.getExtension("MOZ_EXT_texture_filter_anisotropic") || e3.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e3.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = e3.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e3.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e3.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = e3.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = e3.getExtension("EXT_color_buffer_half_float"), this.extTimerQuery = e3.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = e3.getParameter(e3.MAX_TEXTURE_SIZE), this.maxPointSize = e3.getParameter(e3.ALIASED_POINT_SIZE_RANGE)[1];
        }
        setDefault() {
          this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
        }
        setDirty() {
          this.clearColor.dirty = true, this.clearDepth.dirty = true, this.clearStencil.dirty = true, this.colorMask.dirty = true, this.depthMask.dirty = true, this.stencilMask.dirty = true, this.stencilFunc.dirty = true, this.stencilOp.dirty = true, this.stencilTest.dirty = true, this.depthRange.dirty = true, this.depthTest.dirty = true, this.depthFunc.dirty = true, this.blend.dirty = true, this.blendFunc.dirty = true, this.blendColor.dirty = true, this.blendEquation.dirty = true, this.cullFace.dirty = true, this.cullFaceSide.dirty = true, this.frontFace.dirty = true, this.program.dirty = true, this.activeTexture.dirty = true, this.viewport.dirty = true, this.bindFramebuffer.dirty = true, this.bindRenderbuffer.dirty = true, this.bindTexture.dirty = true, this.bindVertexBuffer.dirty = true, this.bindElementBuffer.dirty = true, this.bindVertexArrayOES.dirty = true, this.pixelStoreUnpack.dirty = true, this.pixelStoreUnpackPremultiplyAlpha.dirty = true, this.pixelStoreUnpackFlipY.dirty = true;
        }
        createIndexBuffer(e3, t4, i3) {
          return new hr(this, e3, t4, i3);
        }
        createVertexBuffer(e3, t4, i3, o3, s3) {
          return new dr(this, e3, t4, i3, o3, s3);
        }
        createRenderbuffer(e3, t4, i3) {
          const o3 = this.gl, s3 = o3.createRenderbuffer();
          return this.bindRenderbuffer.set(s3), o3.renderbufferStorage(o3.RENDERBUFFER, e3, t4, i3), this.bindRenderbuffer.set(null), s3;
        }
        createFramebuffer(e3, t4, i3, o3) {
          return new _r(this, e3, t4, i3, o3);
        }
        clear({ color: e3, depth: t4, stencil: i3, colorMask: o3 }) {
          const s3 = this.gl;
          let r3 = 0;
          e3 && (r3 |= s3.COLOR_BUFFER_BIT, this.clearColor.set(e3), this.colorMask.set(o3 || [true, true, true, true])), void 0 !== t4 && (r3 |= s3.DEPTH_BUFFER_BIT, this.depthRange.set([0, 1]), this.clearDepth.set(t4), this.depthMask.set(true)), void 0 !== i3 && (r3 |= s3.STENCIL_BUFFER_BIT, this.clearStencil.set(i3), this.stencilMask.set(255)), s3.clear(r3);
        }
        setCullFace(e3) {
          false === e3.enable ? this.cullFace.set(false) : (this.cullFace.set(true), this.cullFaceSide.set(e3.mode), this.frontFace.set(e3.frontFace));
        }
        setDepthMode(e3) {
          e3.func !== this.gl.ALWAYS || e3.mask ? (this.depthTest.set(true), this.depthFunc.set(e3.func), this.depthMask.set(e3.mask), this.depthRange.set(e3.range)) : this.depthTest.set(false);
        }
        setStencilMode(e3) {
          e3.test.func !== this.gl.ALWAYS || e3.mask ? (this.stencilTest.set(true), this.stencilMask.set(e3.mask), this.stencilOp.set([e3.fail, e3.depthFail, e3.pass]), this.stencilFunc.set({ func: e3.test.func, ref: e3.ref, mask: e3.test.mask })) : this.stencilTest.set(false);
        }
        setColorMode(t4) {
          e2.bi(t4.blendFunction, Ri.Replace) ? this.blend.set(false) : (this.blend.set(true), this.blendFunc.set(t4.blendFunction), this.blendColor.set(t4.blendColor), t4.blendEquation ? this.blendEquation.set(t4.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(t4.mask);
        }
        unbindVAO() {
          this.bindVertexArrayOES.set(null);
        }
      }
      let fr;
      function mr(t4, i3, o3, s3, r3, a4, n3) {
        const l3 = t4.context, c3 = l3.gl, h3 = t4.transform, u4 = t4.getOrCreateProgram("collisionBox"), d3 = [];
        let _2 = 0, p3 = 0;
        for (let l4 = 0; l4 < s3.length; l4++) {
          const f4 = s3[l4], m3 = i3.getTile(f4), g5 = m3.getBucket(o3);
          if (!g5) continue;
          const v3 = ei(f4, g5, h3);
          let x3 = v3;
          0 === r3[0] && 0 === r3[1] || (x3 = t4.translatePosMatrix(v3, m3, r3, a4));
          const y3 = n3 ? g5.textCollisionBox : g5.iconCollisionBox, b2 = g5.collisionCircleArray;
          if (b2.length > 0) {
            const t5 = e2.a6.mat4.create(), i4 = x3;
            e2.a6.mat4.mul(t5, g5.placementInvProjMatrix, h3.glCoordMatrix), e2.a6.mat4.mul(t5, t5, g5.placementViewportMatrix), d3.push({ circleArray: b2, circleOffset: p3, transform: i4, invTransform: t5, projection: g5.getProjection() }), _2 += b2.length / 4, p3 = _2;
          }
          y3 && (t4.terrain && t4.terrain.setupElevationDraw(m3, u4), u4.draw(t4, c3.LINES, Ai.disabled, Pi2.disabled, t4.colorModeForRenderPass(), Oi2.disabled, Hs(x3, h3, m3, g5.getProjection()), o3.id, y3.layoutVertexBuffer, y3.indexBuffer, y3.segments, null, h3.zoom, null, [y3.collisionVertexBuffer, y3.collisionVertexBufferExt]));
        }
        if (!n3 || !d3.length) return;
        const f3 = t4.getOrCreateProgram("collisionCircle"), m2 = new e2.cQ();
        m2.resize(4 * _2), m2._trim();
        let g4 = 0;
        for (const e3 of d3) for (let t5 = 0; t5 < e3.circleArray.length / 4; t5++) {
          const i4 = 4 * t5, o4 = e3.circleArray[i4 + 0], s4 = e3.circleArray[i4 + 1], r4 = e3.circleArray[i4 + 2], a5 = e3.circleArray[i4 + 3];
          m2.emplace(g4++, o4, s4, r4, a5, 0), m2.emplace(g4++, o4, s4, r4, a5, 1), m2.emplace(g4++, o4, s4, r4, a5, 2), m2.emplace(g4++, o4, s4, r4, a5, 3);
        }
        (!fr || fr.length < 2 * _2) && (fr = function(t5) {
          const i4 = 2 * t5, o4 = new e2.aP();
          o4.resize(i4), o4._trim();
          for (let e3 = 0; e3 < i4; e3++) {
            const t6 = 6 * e3;
            o4.uint16[t6 + 0] = 4 * e3 + 0, o4.uint16[t6 + 1] = 4 * e3 + 1, o4.uint16[t6 + 2] = 4 * e3 + 2, o4.uint16[t6 + 3] = 4 * e3 + 2, o4.uint16[t6 + 4] = 4 * e3 + 3, o4.uint16[t6 + 5] = 4 * e3 + 0;
          }
          return o4;
        }(_2));
        const v2 = l3.createIndexBuffer(fr, true), x2 = l3.createVertexBuffer(m2, e2.cR.members, true);
        for (const i4 of d3) {
          const s4 = { u_matrix: i4.transform, u_inv_matrix: i4.invTransform, u_camera_to_center_distance: (y2 = h3).getCameraToCenterDistance(i4.projection), u_viewport_size: [y2.width, y2.height] };
          f3.draw(t4, c3.TRIANGLES, Ai.disabled, Pi2.disabled, t4.colorModeForRenderPass(), Oi2.disabled, s4, o3.id, x2, v2, e2.b2.simpleSegment(0, 2 * i4.circleOffset, i4.circleArray.length, i4.circleArray.length / 2), null, h3.zoom);
        }
        var y2;
        x2.destroy(), v2.destroy();
      }
      const gr = e2.a6.mat4.create();
      function vr(t4) {
        const i3 = t4._camera.getWorldToCamera(t4.worldSize, 1), o3 = e2.a6.mat4.multiply([], i3, t4.globeMatrix);
        e2.a6.mat4.invert(o3, o3);
        const s3 = [0, 0, 0], r3 = [0, 1, 0, 0];
        return e2.a6.vec4.transformMat4(r3, r3, o3), s3[0] = r3[0], s3[1] = r3[1], s3[2] = r3[2], e2.a6.vec3.normalize(s3, s3), s3;
      }
      function xr({ width: t4, height: i3, anchor: o3, textOffset: s3, textScale: r3 }, a4) {
        const { horizontalAlign: n3, verticalAlign: l3 } = e2.by(o3), c3 = -(n3 - 0.5) * t4, h3 = -(l3 - 0.5) * i3, u4 = e2.bx(o3, s3);
        return new e2.P((c3 / r3 + u4[0]) * a4, (h3 / r3 + u4[1]) * a4);
      }
      function yr(t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4) {
        const d3 = t4.text.placedSymbolArray, _2 = t4.text.dynamicLayoutVertexArray, p3 = t4.icon.dynamicLayoutVertexArray, f3 = {}, m2 = t4.getProjection(), g4 = ti2(l3, m2, a4), v2 = a4.elevation, x2 = m2.upVectorScale(l3.canonical, a4.center.lat, a4.worldSize).metersToTile;
        _2.clear();
        for (let p4 = 0; p4 < d3.length; p4++) {
          const y2 = d3.get(p4), { tileAnchorX: b2, tileAnchorY: w2, numGlyphs: T3 } = y2, E3 = y2.hidden || !y2.crossTileID || t4.allowVerticalPlacement && !y2.placedOrientation ? null : s3[y2.crossTileID];
          if (E3) {
            let s4 = 0, d4 = 0, p5 = 0;
            if (v2) {
              const e3 = v2 ? v2.getAtTileOffset(l3, b2, w2) : 0, [t5, i4, o4] = m2.upVector(l3.canonical, b2, w2);
              s4 = e3 * t5 * x2, d4 = e3 * i4 * x2, p5 = e3 * o4 * x2;
            }
            let [S2, C3, I3, D2] = Nt(y2.projectedAnchorX + s4, y2.projectedAnchorY + d4, y2.projectedAnchorZ + p5, o3 ? g4 : n3);
            const R3 = Ut(a4.getCameraToCenterDistance(m2), D2);
            let A3 = r3.evaluateSizeForFeature(t4.textSizeData, h3, y2) * R3 / e2.br;
            o3 && (A3 *= t4.tilePixelRatio / c3);
            const L3 = xr(E3, A3);
            o3 ? ({ x: S2, y: C3, z: I3 } = m2.projectTilePoint(b2 + L3.x, w2 + L3.y, l3.canonical), [S2, C3, I3] = Nt(S2 + s4, C3 + d4, I3 + p5, n3)) : (i3 && L3._rotate(-a4.angle), S2 += L3.x, C3 += L3.y, I3 = 0);
            const P2 = t4.allowVerticalPlacement && y2.placedOrientation === e2.bl.vertical ? Math.PI / 2 : 0;
            for (let t5 = 0; t5 < T3; t5++) e2.bo(_2, S2, C3, I3, P2);
            u4 && y2.associatedIconIndex >= 0 && (f3[y2.associatedIconIndex] = { x: S2, y: C3, z: I3, angle: P2 });
          } else Xt(T3, _2);
        }
        if (u4) {
          p3.clear();
          const i4 = t4.icon.placedSymbolArray;
          for (let t5 = 0; t5 < i4.length; t5++) {
            const o4 = i4.get(t5), { numGlyphs: s4 } = o4, r4 = f3[t5];
            if (o4.hidden || !r4) Xt(s4, p3);
            else {
              const { x: t6, y: i5, z: o5, angle: a5 } = r4;
              for (let r5 = 0; r5 < s4; r5++) e2.bo(p3, t6, i5, o5, a5);
            }
          }
          t4.icon.dynamicLayoutVertexBuffer.updateData(p3);
        }
        t4.text.dynamicLayoutVertexBuffer.updateData(_2);
      }
      function br(t4, i3, o3, s3, r3, a4, n3 = {}) {
        const l3 = o3.paint.get("icon-translate"), c3 = o3.paint.get("text-translate"), h3 = o3.paint.get("icon-translate-anchor"), u4 = o3.paint.get("text-translate-anchor"), d3 = o3.layout.get("icon-rotation-alignment"), _2 = o3.layout.get("text-rotation-alignment"), p3 = o3.layout.get("icon-pitch-alignment"), f3 = o3.layout.get("text-pitch-alignment"), m2 = o3.layout.get("icon-keep-upright"), g4 = o3.layout.get("text-keep-upright"), v2 = o3.paint.get("icon-color-saturation"), x2 = o3.paint.get("icon-color-contrast"), y2 = o3.paint.get("icon-color-brightness-min"), b2 = o3.paint.get("icon-color-brightness-max"), w2 = "sea" === o3.layout.get("symbol-elevation-reference"), T3 = t4.context, E3 = T3.gl, S2 = t4.transform, C3 = "map" === d3, I3 = "map" === _2, D2 = "map" === p3, R3 = "map" === f3, A3 = void 0 !== o3.layout.get("symbol-sort-key").constantOr(1);
        let L3 = false;
        const P2 = t4.depthModeForSublayer(0, Ai.ReadOnly), M2 = [e2.am(S2.center.lng), e2.at(S2.center.lat)], z3 = o3.layout.get("text-variable-anchor"), O2 = "globe" === S2.projection.name, F3 = [], B4 = [0, -1, 0];
        for (const r4 of s3) {
          const s4 = i3.getTile(r4), a5 = s4.getBucket(o3);
          if (!a5) continue;
          if ("mercator" === a5.projection.name && O2) continue;
          if (a5.fullyClipped) continue;
          const d4 = "globe" === a5.projection.name, _3 = d4 ? e2.a9(S2.zoom) : 0, p4 = ti2(r4, a5.getProjection(), S2), f4 = S2.calculatePixelsToTileUnitsMatrix(s4), T4 = z3 && a5.hasTextData(), P3 = a5.hasIconTextFit() && T4 && a5.hasIconData(), k2 = a5.getProjection().createInversionMatrix(S2, r4.canonical), N2 = (e3) => {
            S2.depthOcclusionForSymbolsAndCircles && (o3.hasInitialOcclusionOpacityProperties || t4.terrain) && (e3.push("DEPTH_D24"), e3.push("DEPTH_OCCLUSION"));
          }, U3 = () => {
            const i4 = C3 && "point" !== o3.layout.get("symbol-placement"), n4 = [];
            N2(n4);
            const c4 = i4 || P3, u5 = o3.paint.get("icon-image-cross-fade").constantOr(0);
            t4.terrainRenderModeElevated() && D2 && n4.push("PITCH_WITH_MAP_TERRAIN"), d4 && (n4.push("PROJECTION_GLOBE_VIEW"), c4 && n4.push("PROJECTED_POS_ON_VIEWPORT")), u5 > 0 && n4.push("ICON_TRANSITION"), a5.icon.zOffsetVertexBuffer && n4.push("Z_OFFSET"), 0 === v2 && 0 === x2 && 0 === y2 && 1 === b2 || n4.push("COLOR_ADJUSTMENT"), a5.sdfIcons && n4.push("RENDER_SDF");
            const g5 = a5.icon.programConfigurations.get(o3.id), T5 = t4.getOrCreateProgram("symbol", { config: g5, defines: n4 }), I4 = s4.imageAtlasTexture ? s4.imageAtlasTexture.size : [0, 0], R4 = a5.iconSizeData, A4 = e2.bk(R4, S2.zoom), L4 = D2 || 0 !== S2.pitch, z4 = Ft2(p4, s4.tileID.canonical, D2, C3, S2, a5.getProjection(), f4), F4 = kt(p4, s4.tileID.canonical, D2, C3, S2, a5.getProjection(), f4), U4 = t4.translatePosMatrix(F4, s4, l3, h3, true), G3 = t4.translatePosMatrix(p4, s4, l3, h3), V4 = c4 ? gr : z4, j3 = C3 && !D2 && !i4;
            let H5 = B4;
            !O2 && !S2.mercatorFromTransition || C3 || (H5 = vr(S2));
            const Z4 = d4 ? H5 : B4, q3 = o3.getColorAdjustmentMatrix(v2, x2, y2, b2), W3 = or(R4.kind, A4, j3, D2, t4, G3, V4, U4, w2, false, I4, [0, 0], true, r4, _3, M2, k2, Z4, a5.getProjection(), q3, u5), $3 = s4.imageAtlasTexture ? s4.imageAtlasTexture : null, X2 = 1 !== o3.layout.get("icon-size").constantOr(0) || a5.iconsNeedLinear, J2 = a5.sdfIcons || t4.options.rotating || t4.options.zooming || X2 || L4 ? E3.LINEAR : E3.NEAREST, K2 = a5.sdfIcons && 0 !== o3.paint.get("icon-halo-width").constantOr(1), Y2 = t4.terrain && D2 && i4 ? e2.a6.mat4.invert(e2.a6.mat4.create(), z4) : gr;
            if (i4 && a5.icon) {
              const e3 = S2.elevation, i5 = e3 ? e3.getAtTileOffsetFunc(r4, S2.center.lat, S2.worldSize, a5.getProjection()) : null, o4 = Bt(p4, s4.tileID.canonical, D2, C3, S2, a5.getProjection(), f4);
              Vt(a5, p4, t4, false, o4, F4, D2, m2, i5, r4);
            }
            return { program: T5, buffers: a5.icon, uniformValues: W3, atlasTexture: $3, atlasTextureIcon: null, atlasInterpolation: J2, atlasInterpolationIcon: null, isSDF: a5.sdfIcons, hasHalo: K2, tile: s4, labelPlaneMatrixInv: Y2 };
          }, G2 = () => {
            const i4 = I3 && "point" !== o3.layout.get("symbol-placement"), n4 = [], l4 = i4 || z3 || P3;
            t4.terrainRenderModeElevated() && R3 && n4.push("PITCH_WITH_MAP_TERRAIN"), d4 && (n4.push("PROJECTION_GLOBE_VIEW"), l4 && n4.push("PROJECTED_POS_ON_VIEWPORT")), a5.text.zOffsetVertexBuffer && n4.push("Z_OFFSET"), a5.iconsInText && n4.push("RENDER_TEXT_AND_SYMBOL"), n4.push("RENDER_SDF"), N2(n4);
            const h4 = a5.text.programConfigurations.get(o3.id), m3 = t4.getOrCreateProgram("symbol", { config: h4, defines: n4 });
            let v3, x3 = [0, 0], y3 = null;
            const b3 = a5.textSizeData;
            a5.iconsInText && (x3 = s4.imageAtlasTexture ? s4.imageAtlasTexture.size : [0, 0], y3 = s4.imageAtlasTexture ? s4.imageAtlasTexture : null, v3 = R3 || 0 !== S2.pitch || t4.options.rotating || t4.options.zooming || "composite" === b3.kind || "camera" === b3.kind ? E3.LINEAR : E3.NEAREST);
            const T5 = s4.glyphAtlasTexture ? s4.glyphAtlasTexture.size : [0, 0], C4 = o3.layout.get("text-size-scale-range"), D3 = e2.ap(t4.scaleFactor, C4[0], C4[1]), A4 = e2.bk(b3, S2.zoom, D3), L4 = Ft2(p4, s4.tileID.canonical, R3, I3, S2, a5.getProjection(), f4), F4 = kt(p4, s4.tileID.canonical, R3, I3, S2, a5.getProjection(), f4), U4 = t4.translatePosMatrix(F4, s4, c3, u4, true), G3 = t4.translatePosMatrix(p4, s4, c3, u4), V4 = l4 ? gr : L4, j3 = I3 && !R3 && !i4;
            let H5 = B4;
            !O2 && !S2.mercatorFromTransition || I3 || (H5 = vr(S2));
            const Z4 = or(b3.kind, A4, j3, R3, t4, G3, V4, U4, w2, true, T5, x3, true, r4, _3, M2, k2, d4 ? H5 : B4, a5.getProjection(), null, null, D3), q3 = s4.glyphAtlasTexture ? s4.glyphAtlasTexture : null, W3 = E3.LINEAR, $3 = 0 !== o3.paint.get("text-halo-width").constantOr(1), X2 = t4.terrain && R3 && i4 ? e2.a6.mat4.invert(e2.a6.mat4.create(), L4) : gr;
            if (i4 && a5.text) {
              const e3 = S2.elevation, i5 = e3 ? e3.getAtTileOffsetFunc(r4, S2.center.lat, S2.worldSize, a5.getProjection()) : null, o4 = Bt(p4, s4.tileID.canonical, R3, I3, S2, a5.getProjection(), f4);
              Vt(a5, p4, t4, true, o4, F4, R3, g4, i5, r4);
            }
            return { program: m3, buffers: a5.text, uniformValues: Z4, atlasTexture: q3, atlasTextureIcon: y3, atlasInterpolation: W3, atlasInterpolationIcon: v3, isSDF: true, hasHalo: $3, tile: s4, labelPlaneMatrixInv: X2 };
          }, V3 = a5.icon.segments.get().length, j2 = a5.text.segments.get().length, H4 = V3 && !n3.onlyText ? U3() : null, Z3 = j2 && !n3.onlyIcons ? G2() : null, q2 = o3.paint.get("icon-opacity").constantOr(1), W2 = o3.paint.get("text-opacity").constantOr(1);
          if (A3 && a5.canOverlap) {
            L3 = true;
            const t5 = q2 && !n3.onlyText ? a5.icon.segments.get() : [], i4 = W2 && !n3.onlyIcons ? a5.text.segments.get() : [];
            for (const i5 of t5) F3.push({ segments: new e2.b2([i5]), sortKey: i5.sortKey, state: H4 });
            for (const t6 of i4) F3.push({ segments: new e2.b2([t6]), sortKey: t6.sortKey, state: Z3 });
          } else n3.onlyText || F3.push({ segments: q2 ? a5.icon.segments : new e2.b2([]), sortKey: 0, state: H4 }), n3.onlyIcons || F3.push({ segments: W2 ? a5.text.segments : new e2.b2([]), sortKey: 0, state: Z3 });
        }
        L3 && F3.sort((e3, t5) => e3.sortKey - t5.sortKey);
        for (const e3 of F3) {
          const i4 = e3.state;
          if (i4) if (t4.terrain ? t4.terrain.setupElevationDraw(i4.tile, i4.program, { useDepthForOcclusion: S2.depthOcclusionForSymbolsAndCircles, labelPlaneMatrixInv: i4.labelPlaneMatrixInv }) : t4.setupDepthForOcclusion(S2.depthOcclusionForSymbolsAndCircles, i4.program), T3.activeTexture.set(E3.TEXTURE0), i4.atlasTexture && i4.atlasTexture.bind(i4.atlasInterpolation, E3.CLAMP_TO_EDGE, true), i4.atlasTextureIcon && (T3.activeTexture.set(E3.TEXTURE1), i4.atlasTextureIcon && i4.atlasTextureIcon.bind(i4.atlasInterpolationIcon, E3.CLAMP_TO_EDGE, true)), t4.uploadCommonLightUniforms(t4.context, i4.program), i4.hasHalo) {
            const s4 = i4.uniformValues;
            s4.u_is_halo = 1, wr(i4.buffers, e3.segments, o3, t4, i4.program, P2, r3, a4, s4, 2), s4.u_is_halo = 0;
          } else {
            if (i4.isSDF) {
              const s4 = i4.uniformValues;
              i4.hasHalo && (s4.u_is_halo = 1, wr(i4.buffers, e3.segments, o3, t4, i4.program, P2, r3, a4, s4, 1)), s4.u_is_halo = 0;
            }
            wr(i4.buffers, e3.segments, o3, t4, i4.program, P2, r3, a4, i4.uniformValues, 1);
          }
        }
      }
      function wr(e3, t4, i3, o3, s3, r3, a4, n3, l3, c3) {
        const h3 = [e3.dynamicLayoutVertexBuffer, e3.opacityVertexBuffer, e3.iconTransitioningVertexBuffer, e3.globeExtVertexBuffer, e3.zOffsetVertexBuffer];
        s3.draw(o3, o3.context.gl.TRIANGLES, r3, a4, n3, Oi2.disabled, l3, i3.id, e3.layoutVertexBuffer, e3.indexBuffer, t4, i3.paint, o3.transform.zoom, e3.programConfigurations.get(i3.id), h3, c3);
      }
      function Tr(e3, t4, i3, o3, s3, r3, a4) {
        const n3 = e3.context.gl, l3 = i3.paint.get("fill-pattern"), c3 = i3.is3D(), h3 = c3 ? e3.stencilModeFor3D() : Pi2.disabled, u4 = l3 && l3.constantOr(1);
        let d3, _2, p3, f3, m2;
        a4 ? (_2 = u4 && !i3.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", d3 = n3.LINES) : (_2 = u4 ? "fillPattern" : "fill", d3 = n3.TRIANGLES);
        for (const g4 of o3) {
          const o4 = t4.getTile(g4);
          if (u4 && !o4.patternsLoaded()) continue;
          const v2 = o4.getBucket(i3);
          if (!v2) continue;
          e3.prepareDrawTile();
          const x2 = v2.programConfigurations.get(i3.id), y2 = e3.isTileAffectedByFog(g4), b2 = e3.getOrCreateProgram(_2, { config: x2, overrideFog: y2 });
          u4 && (e3.context.activeTexture.set(n3.TEXTURE0), o4.imageAtlasTexture && o4.imageAtlasTexture.bind(n3.LINEAR, n3.CLAMP_TO_EDGE), x2.updatePaintBuffers());
          const w2 = l3.constantOr(null);
          if (w2 && o4.imageAtlas) {
            const e4 = o4.imageAtlas.patternPositions[w2.toString()];
            e4 && x2.setConstantPatternPositions(e4);
          }
          const T3 = e3.translatePosMatrix(g4.projMatrix, o4, i3.paint.get("fill-translate"), i3.paint.get("fill-translate-anchor")), E3 = i3.paint.get("fill-emissive-strength");
          if (a4) {
            f3 = v2.indexBuffer2, m2 = v2.segments2;
            const t5 = e3.terrain && e3.terrain.renderingToTexture ? e3.terrain.drapeBufferSize : [n3.drawingBufferWidth, n3.drawingBufferHeight];
            p3 = "fillOutlinePattern" === _2 && u4 ? js(T3, E3, e3, o4, t5) : Vs(T3, E3, t5);
          } else f3 = v2.indexBuffer, m2 = v2.segments, p3 = u4 ? Gs(T3, E3, e3, o4) : Us(T3, E3);
          e3.uploadCommonUniforms(e3.context, b2, g4.toUnwrapped()), b2.draw(e3, d3, s3, c3 ? h3 : e3.stencilModeForClipping(g4), r3, Oi2.disabled, p3, i3.id, v2.layoutVertexBuffer, f3, m2, i3.paint, e3.transform.zoom, x2, void 0);
        }
      }
      function Er(t4, i3, o3, s3, r3, a4, n3, l3) {
        o3.resetLayerRenderingStats(t4);
        const c3 = t4.context, h3 = c3.gl, u4 = t4.transform, d3 = o3.paint.get("fill-extrusion-pattern"), _2 = d3.constantOr(1), p3 = o3.paint.get("fill-extrusion-opacity"), f3 = t4.style.enable3dLights(), m2 = o3.paint.get(f3 && !_2 ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"), g4 = [o3.paint.get("fill-extrusion-ambient-occlusion-intensity"), m2], v2 = o3.layout.get("fill-extrusion-edge-radius"), x2 = v2 > 0 && !o3.paint.get("fill-extrusion-rounded-roof"), y2 = x2 ? 0 : v2, b2 = "globe" === u4.projection.name ? e2.c_() : 0, w2 = "globe" === u4.projection.name, T3 = w2 ? e2.a9(u4.zoom) : 0, E3 = [e2.am(u4.center.lng), e2.at(u4.center.lat)], S2 = o3.paint.get("fill-extrusion-flood-light-color").toRenderColor(o3.lut).toArray01().slice(0, 3), C3 = o3.paint.get("fill-extrusion-flood-light-intensity"), I3 = o3.paint.get("fill-extrusion-vertical-scale"), D2 = 0 !== o3.paint.get("fill-extrusion-line-width").constantOr(1), R3 = o3.paint.get("fill-extrusion-height-alignment"), A3 = o3.paint.get("fill-extrusion-base-alignment"), L3 = qi(t4, o3.paint.get("fill-extrusion-cutoff-fade-range")), P2 = [];
        let M2;
        w2 && P2.push("PROJECTION_GLOBE_VIEW"), g4[0] > 0 && P2.push("FAUX_AO"), x2 && P2.push("ZERO_ROOF_RADIUS"), l3 && P2.push("HAS_CENTROID"), C3 > 0 && P2.push("FLOOD_LIGHT"), L3.shouldRenderCutoff && P2.push("RENDER_CUTOFF"), D2 && P2.push("RENDER_WALL_MODE");
        const z3 = "shadow" === t4.renderPass, O2 = t4.shadowRenderer, F3 = z3 && !!O2;
        t4.shadowRenderer && (t4.shadowRenderer.useNormalOffset = true);
        let B4 = [0, 0, 0];
        if (O2) {
          const e3 = t4.style.directionalLight, i4 = t4.style.ambientLight;
          e3 && i4 && (B4 = Qi(t4.style, e3, i4)), z3 || (P2.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), O2.useNormalOffset && P2.push("NORMAL_OFFSET")), M2 = P2.concat(["SHADOWS_SINGLE_CASCADE"]);
        }
        const k2 = F3 ? "fillExtrusionDepth" : _2 ? "fillExtrusionPattern" : "fillExtrusion", N2 = o3.getLayerRenderingStats();
        for (const e3 of s3) {
          const s4 = i3.getTile(e3), f4 = s4.getBucket(o3);
          if (!f4 || f4.projection.name !== u4.projection.name) continue;
          let m3 = false;
          O2 && (m3 = 0 === O2.getMaxCascadeForTile(e3.toUnwrapped()));
          const v3 = t4.isTileAffectedByFog(e3), x3 = f4.programConfigurations.get(o3.id), F4 = t4.getOrCreateProgram(k2, { config: x3, defines: m3 ? M2 : P2, overrideFog: v3 });
          if (t4.terrain && t4.terrain.setupElevationDraw(s4, F4, { useMeterToDem: true }), !f4.centroidVertexBuffer) {
            const e4 = F4.attributes.a_centroid_pos;
            void 0 !== e4 && h3.vertexAttrib2f(e4, 0, 0);
          }
          !z3 && O2 && O2.setupShadows(s4.tileID.toUnwrapped(), F4, "vector-tile", s4.tileID.overscaledZ), _2 && (t4.context.activeTexture.set(h3.TEXTURE0), s4.imageAtlasTexture && s4.imageAtlasTexture.bind(h3.LINEAR, h3.CLAMP_TO_EDGE), x3.updatePaintBuffers());
          const U3 = d3.constantOr(null);
          if (U3 && s4.imageAtlas) {
            const e4 = s4.imageAtlas.patternPositions[U3.toString()];
            e4 && x3.setConstantPatternPositions(e4);
          }
          const G2 = o3.paint.get("fill-extrusion-vertical-gradient"), V3 = 1 / f4.tileToMeter;
          let j2;
          if (z3 && O2) {
            if (Ar2(s4.tileID, f4, t4)) continue;
            const e4 = O2.calculateShadowPassMatrixFromTile(s4.tileID.toUnwrapped());
            j2 = ks(e4, y2, V3, I3, R3, A3);
          } else {
            const i4 = t4.translatePosMatrix(e3.expandedProjMatrix, s4, o3.paint.get("fill-extrusion-translate"), o3.paint.get("fill-extrusion-translate-anchor")), r4 = u4.projection.createInversionMatrix(u4, e3.canonical);
            j2 = _2 ? Ns(i4, t4, G2, p3, g4, y2, V3, e3, s4, b2, R3, A3, T3, E3, r4, S2, I3) : Bs(i4, t4, G2, p3, g4, y2, V3, e3, b2, R3, A3, T3, E3, r4, S2, I3, C3, B4);
          }
          t4.uploadCommonUniforms(c3, F4, e3.toUnwrapped(), null, L3);
          let H4 = f4.segments;
          if ("mercator" === u4.projection.name && !z3 && (H4 = f4.getVisibleSegments(s4.tileID, t4.terrain, t4.transform.getFrustum(0)), !H4.get().length)) continue;
          if (N2) if (z3) for (const e4 of H4.get()) N2.numRenderedVerticesInShadowPass += e4.primitiveLength;
          else for (const e4 of H4.get()) N2.numRenderedVerticesInTransparentPass += e4.primitiveLength;
          const Z3 = [];
          (t4.terrain || l3) && Z3.push(f4.centroidVertexBuffer), w2 && Z3.push(f4.layoutVertexExtBuffer), D2 && Z3.push(f4.wallVertexBuffer), F4.draw(t4, c3.gl.TRIANGLES, r3, a4, n3, Oi2.backCCW, j2, o3.id, f4.layoutVertexBuffer, f4.indexBuffer, H4, o3.paint, t4.transform.zoom, x3, Z3);
        }
        t4.shadowRenderer && (t4.shadowRenderer.useNormalOffset = false);
      }
      function Sr(t4, i3, o3, s3, r3, a4, n3, l3, c3, h3, u4, d3, _2, p3, f3, m2, g4, v2, x2) {
        const y2 = t4.context, b2 = y2.gl, w2 = t4.transform, T3 = t4.transform.zoom, E3 = [], S2 = qi(t4, o3.paint.get("fill-extrusion-cutoff-fade-range"));
        "clear" === h3 ? (E3.push("CLEAR_SUBPASS"), x2 && (E3.push("CLEAR_FROM_TEXTURE"), y2.activeTexture.set(b2.TEXTURE0), x2.bind(b2.LINEAR, b2.CLAMP_TO_EDGE))) : "sdf" === h3 && E3.push("SDF_SUBPASS"), g4 && E3.push("HAS_CENTROID"), S2.shouldRenderCutoff && E3.push("RENDER_CUTOFF");
        const C3 = o3.layout.get("fill-extrusion-edge-radius"), I3 = (e3, i4, s4, h4, v3) => {
          const b3 = i4.programConfigurations.get(o3.id), w3 = t4.isTileAffectedByFog(e3), I4 = t4.getOrCreateProgram("fillExtrusionGroundEffect", { config: b3, defines: E3, overrideFog: w3 }), D2 = /* @__PURE__ */ ((e4, t5, i5, o4, s5, r4, a5, n4, l4, c4, h5) => ({ u_matrix: t5, u_opacity: i5, u_ao_pass: o4 ? 1 : 0, u_meter_to_tile: s5, u_ao: r4, u_flood_light_intensity: a5, u_flood_light_color: n4, u_attenuation: l4, u_edge_radius: c4, u_fb: 0, u_fb_size: h5, u_dynamic_offset: 1 }))(0, h4, u4, c3, v3, [d3, _2 * v3], p3, f3, m2, T3 >= 17 ? 0 : C3 * v3, x2 ? x2.size[0] : 0), R3 = [];
          g4 && R3.push(i4.hiddenByLandmarkVertexBuffer), t4.uploadCommonUniforms(y2, I4, e3.toUnwrapped(), null, S2), I4.draw(t4, y2.gl.TRIANGLES, r3, a4, n3, l3, D2, o3.id, i4.vertexBuffer, i4.indexBuffer, s4, o3.paint, T3, b3, R3);
        };
        for (const r4 of s3) {
          const s4 = i3.getTile(r4), a5 = s4.getBucket(o3);
          if (!a5 || a5.projection.name !== w2.projection.name || !a5.groundEffect || a5.groundEffect && !a5.groundEffect.hasData()) continue;
          const n4 = a5.groundEffect, l4 = 1 / a5.tileToMeter;
          {
            const e3 = t4.translatePosMatrix(r4.projMatrix, s4, o3.paint.get("fill-extrusion-translate"), o3.paint.get("fill-extrusion-translate-anchor")), i4 = n4.getDefaultSegment();
            I3(r4, n4, i4, e3, l4);
          }
          if (v2) for (let a6 = 0; a6 < 4; a6++) {
            const n5 = e2.c$[a6](r4), c4 = i3.getTile(n5);
            if (!c4) continue;
            const h4 = c4.getBucket(o3);
            if (!h4 || h4.projection.name !== w2.projection.name || !h4.groundEffect || h4.groundEffect && !h4.groundEffect.hasData()) continue;
            const u5 = h4.groundEffect;
            let d4, _3;
            0 === a6 ? (d4 = [-e2.ab, 0, 0], _3 = 1) : 1 === a6 ? (d4 = [e2.ab, 0, 0], _3 = 0) : 2 === a6 ? (d4 = [0, -e2.ab, 0], _3 = 3) : (d4 = [0, e2.ab, 0], _3 = 2);
            const p4 = u5.regionSegments[_3];
            if (!p4) continue;
            const f4 = new Float32Array(16);
            e2.a6.mat4.translate(f4, r4.projMatrix, d4), I3(r4, u5, p4, t4.translatePosMatrix(f4, s4, o3.paint.get("fill-extrusion-translate"), o3.paint.get("fill-extrusion-translate-anchor")), l4);
          }
        }
      }
      function Cr(t4, i3, o3, s3, r3, a4, n3) {
        0 === s3.centroidVertexArray.length && s3.createCentroidsBuffer();
        const l3 = a4 ? a4.findDEMTileFor(o3) : null;
        if (!(l3 && l3.dem || n3)) return;
        const c3 = (t5) => new e2.P(Math.ceil((t5 + e2.d2) * e2.d3), 0), h3 = (e3) => {
          const t5 = i3.getSource().minzoom, o4 = (e4) => {
            const t6 = i3.getTileByID(e4);
            if (t6 && t6.hasData()) return t6.getBucket(r3);
          }, s4 = [0, -1, 1];
          for (const i4 of s4) {
            if (e3.overscaledZ + i4 < t5) continue;
            const s5 = o4(e3.calculateScaledKey(e3.overscaledZ + i4));
            if (s5) return s5;
          }
        }, u4 = [0, 0, 0], d3 = (t5, i4) => (u4[0] = Math.min(t5.min.y, i4.min.y), u4[1] = Math.max(t5.max.y, i4.max.y), u4[2] = e2.ab - i4.min.x > t5.max.x ? i4.min.x - e2.ab : t5.max.x, u4), _2 = (t5, i4) => (u4[0] = Math.min(t5.min.x, i4.min.x), u4[1] = Math.max(t5.max.x, i4.max.x), u4[2] = e2.ab - i4.min.y > t5.max.y ? i4.min.y - e2.ab : t5.max.y, u4), p3 = [(e3, t5) => d3(e3, t5), (e3, t5) => d3(t5, e3), (e3, t5) => _2(e3, t5), (e3, t5) => _2(t5, e3)], f3 = (t5, i4, s4, r4, n4, c4, h4) => {
          if (!a4) return 0;
          const u5 = [[c4 ? s4 : t5, c4 ? t5 : s4, 0], [c4 ? s4 : i4, c4 ? i4 : s4, 0]], d4 = h4 < 0 ? e2.ab + h4 : h4, _3 = [c4 ? d4 : (t5 + i4) / 2, c4 ? (t5 + i4) / 2 : d4, 0];
          return 0 === s4 && h4 < 0 || 0 !== s4 && h4 > 0 ? a4.getForTilePoints(n4, [_3], true, r4) : u5.push(_3), a4.getForTilePoints(o3, u5, true, l3), Math.max(u5[0][2], u5[1][2], _3[2]) / a4.exaggeration();
        };
        for (let t5 = 0; t5 < 4; t5++) {
          const i4 = s3.borderFeatureIndices[t5];
          if (0 === i4.length) continue;
          const r4 = e2.c$[t5](o3), l4 = h3(r4);
          if (!(l4 && l4 instanceof e2.d0)) continue;
          if (s3.borderDoneWithNeighborZ[t5] === l4.canonical.z) continue;
          0 === l4.centroidVertexArray.length && l4.createCentroidsBuffer();
          const u5 = a4 ? a4.findDEMTileFor(r4) : null;
          if (!(u5 && u5.dem || n3)) continue;
          const d4 = (t5 < 2 ? 1 : 5) - t5, _3 = l4.borderDoneWithNeighborZ[d4] !== s3.canonical.z, v2 = l4.borderFeatureIndices[d4];
          let x2 = 0;
          if (s3.canonical.z !== l4.canonical.z) {
            for (const e3 of i4) s3.showCentroid(s3.featuresOnBorder[e3]);
            if (_3) for (const e3 of v2) l4.showCentroid(l4.featuresOnBorder[e3]);
            s3.borderDoneWithNeighborZ[t5] = l4.canonical.z, l4.borderDoneWithNeighborZ[d4] = s3.canonical.z;
          }
          for (const o4 of i4) {
            const i5 = s3.featuresOnBorder[o4], a5 = s3.centroidData[i5.centroidDataIndex], h4 = i5.borders[t5];
            let _4;
            for (; x2 < v2.length; ) {
              _4 = l4.featuresOnBorder[v2[x2]];
              const e3 = _4.borders[d4];
              if (e3[1] > h4[0] + 3 || e3[0] > h4[0] - 3) break;
              l4.showCentroid(_4), x2++;
            }
            if (_4 && x2 < v2.length) {
              const o5 = x2;
              let y2 = 0;
              for (; !(_4.borders[d4][0] > h4[1] - 3) && (y2++, ++x2 !== v2.length); ) _4 = l4.featuresOnBorder[v2[x2]];
              _4 = l4.featuresOnBorder[v2[o5]];
              let b2 = false;
              if (y2 >= 1) {
                const e3 = _4.borders[d4];
                Math.abs(h4[0] - e3[0]) < 3 && Math.abs(h4[1] - e3[1]) < 3 && (y2 = 1, b2 = true, x2 = o5 + 1);
              } else if (0 === y2) {
                s3.showCentroid(i5);
                continue;
              }
              const w2 = l4.centroidData[_4.centroidDataIndex];
              n3 && b2 && (((m2 = a5).flags | (g4 = w2).flags) & e2.d1 ? (m2.flags |= e2.d1, g4.flags |= e2.d1) : (m2.flags &= ~e2.d1, g4.flags &= ~e2.d1));
              const T3 = i5.intersectsCount() > 1 || _4.intersectsCount() > 1;
              if (y2 > 1) x2 = o5, a5.centroidXY = w2.centroidXY = new e2.P(0, 0);
              else if (u5 && u5.dem && !T3) {
                const i6 = p3[t5](a5, w2), o6 = t5 % 2 ? e2.ab - 1 : 0, s4 = f3(i6[0], Math.min(e2.ab - 1, i6[1]), o6, u5, r4, t5 < 2, i6[2]);
                a5.centroidXY = w2.centroidXY = c3(s4);
              } else T3 ? a5.centroidXY = w2.centroidXY = new e2.P(0, 0) : (a5.centroidXY = s3.encodeBorderCentroid(i5), w2.centroidXY = l4.encodeBorderCentroid(_4));
              s3.writeCentroidToBuffer(a5), l4.writeCentroidToBuffer(w2);
            } else s3.showCentroid(i5);
          }
          s3.borderDoneWithNeighborZ[t5] = l4.canonical.z, l4.borderDoneWithNeighborZ[d4] = s3.canonical.z;
        }
        var m2, g4;
        (s3.needsCentroidUpdate || !s3.centroidVertexBuffer && 0 !== s3.centroidVertexArray.length) && s3.uploadCentroid(t4);
      }
      const Ir = [1, 0, 0], Dr = [0, 1, 0], Rr = [0, 0, 1];
      function Ar2(t4, i3, o3) {
        const s3 = o3.transform, r3 = o3.shadowRenderer;
        if (!r3) return true;
        const a4 = t4.toUnwrapped(), n3 = s3.tileSize * r3._cascades[o3.currentShadowCascade].scale;
        let l3 = i3.maxHeight;
        if (s3.elevation) {
          const e3 = s3.elevation.getMinMaxForTile(t4);
          e3 && (l3 += e3.max);
        }
        const c3 = [...r3.shadowDirection];
        c3[2] = -c3[2];
        const h3 = r3.computeSimplifiedTileShadowVolume(a4, l3, n3, c3);
        if (!h3) return false;
        const u4 = [Ir, Dr, Rr, c3, [c3[0], 0, c3[2]], [0, c3[1], c3[2]]], d3 = "globe" === s3.projection.name, _2 = s3.scaleZoom(n3), p3 = e2.bO.fromInvProjectionMatrix(s3.invProjMatrix, s3.worldSize, _2, !d3), f3 = r3.getCurrentCascadeFrustum();
        return 0 === p3.intersectsPrecise(h3.vertices, h3.planes, u4) || 0 === f3.intersectsPrecise(h3.vertices, h3.planes, u4);
      }
      function Lr(t4) {
        return [t4[0] * e2.d4, t4[1] * e2.d4, t4[2] * e2.d4, 0];
      }
      function Pr(t4, i3, o3, s3, r3, a4, n3, l3, c3) {
        const h3 = s3.getSource(), u4 = o3.globeSharedBuffers;
        if (!u4) return;
        let d3, _2, p3;
        if (i3 && (d3 = s3.getTile(i3)), h3 instanceof e2.aD ? (_2 = h3.texture, p3 = e2.cD(0, 0, o3.transform)) : d3 && i3 && (_2 = d3.texture, p3 = e2.cD(i3.canonical.z, i3.canonical.x, o3.transform)), !_2 || !p3) return;
        t4 || (p3 = e2.a6.mat4.scale(e2.a6.mat4.create(), p3, [1, -1, 1]));
        const f3 = o3.context, m2 = f3.gl, g4 = "nearest" === r3.paint.get("raster-resampling") ? m2.NEAREST : m2.LINEAR, v2 = o3.colorModeForDrapableLayerRenderPass(a4), x2 = n3.defines;
        x2.push("GLOBE_POLES");
        const y2 = new Ai(m2.LEQUAL, Ai.ReadWrite, o3.depthRangeFor3D), b2 = Float32Array.from(o3.transform.expandedFarZProjMatrix), w2 = Float32Array.from(e2.b6(e2.cC(new e2.bQ(0, 0, 0))));
        o3.terrain && o3.terrain.prepareDrawTile(), f3.activeTexture.set(m2.TEXTURE0), _2.bind(g4, m2.CLAMP_TO_EDGE), f3.activeTexture.set(m2.TEXTURE1), _2.bind(g4, m2.CLAMP_TO_EDGE), _2.useMipmap && f3.extTextureFilterAnisotropic && o3.transform.pitch > 20 && m2.texParameterf(m2.TEXTURE_2D, f3.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, f3.extTextureFilterAnisotropicMax);
        const [T3, E3, S2, C3] = i3 ? u4.getPoleBuffers(i3.canonical.z, false) : u4.getPoleBuffers(0, true), I3 = r3.paint.get("raster-elevation");
        let D2;
        t4 ? (D2 = T3, o3.renderDefaultNorthPole = 0 !== I3) : (D2 = E3, o3.renderDefaultSouthPole = 0 !== I3);
        const R3 = Lr(n3.mix), A3 = ((e3, t5, i4, o4, s4, r4, a5, n4, l4, c4, h4, u5, d4) => Js(e3, t5, i4, new Float32Array(16), new Float32Array(9), [0, 0], o4, [0, 0], [0, 0, 0, 0], 1, { opacity: 1, mix: 0 }, r4, [0, 0], n4, 2, c4, h4, u5, 1, 0, d4))(b2, w2, p3, e2.a9(o3.transform.zoom), 0, r3, 0, I3, 0, R3, n3.offset, n3.range, a4), L3 = o3.getOrCreateProgram("raster", { defines: x2 });
        o3.uploadCommonUniforms(f3, L3, null), L3.draw(o3, m2.TRIANGLES, y2, c3, v2, l3, A3, r3.id, D2, S2, C3);
      }
      function Mr2(e3) {
        const t4 = e3._nearZ, i3 = e3.projection.farthestPixelDistance(e3), o3 = i3 - t4, s3 = 0.2 * e3.height, r3 = t4 + s3;
        return [t4, i3, (r3 - s3 - t4) / o3, (r3 - t4) / o3];
      }
      function zr(e3, t4, i3, o3) {
        if (e3) return t4 instanceof Ke && e3 instanceof pt2 ? t4.getTextureDescriptor(e3, i3, true) : { texture: e3.texture, mix: Lr(o3.mix), offset: o3.offset, buffer: 0, tileSize: 1 };
      }
      var Or = e2.d5([{ name: "a_index", type: "Int16", components: 1 }]);
      class Fr {
        constructor(t4, i3, o3, s3) {
          const r3 = { width: o3[0], height: o3[1], data: null }, a4 = t4.gl;
          this.targetColorTexture = new e2.T(t4, r3, a4.RGBA8, { useMipmap: false }), this.backgroundColorTexture = new e2.T(t4, r3, a4.RGBA8, { useMipmap: false }), this.context = t4, this.updateParticleTexture(i3, s3), this.lastInvalidatedAt = 0;
        }
        updateParticleTexture(t4, i3) {
          if (this.particleTextureDimension === i3.width) return;
          (this.particleTexture0 || this.particleTexture1 || this.particleIndexBuffer || this.particleSegment) && (this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleIndexBuffer.destroy(), this.particleSegment.destroy());
          const o3 = this.context.gl, s3 = i3.width * i3.height;
          this.particleTexture0 = new e2.T(this.context, i3, o3.RGBA8, { premultiply: false, useMipmap: false }), this.particleTexture1 = new e2.T(this.context, i3, o3.RGBA8, { premultiply: false, useMipmap: false });
          const r3 = new e2.d6();
          r3.reserve(s3);
          for (let e3 = 0; e3 < s3; e3++) r3.emplaceBack(e3);
          this.particleIndexBuffer = this.context.createVertexBuffer(r3, Or.members, true), this.particleSegment = e2.b2.simpleSegment(0, 0, this.particleIndexBuffer.length, 0), this.particleTextureDimension = i3.width;
        }
        update(t4) {
          return !(this.lastInvalidatedAt < t4 && (this.lastInvalidatedAt = e2.e.now(), 1));
        }
        destroy() {
          this.targetColorTexture.destroy(), this.backgroundColorTexture.destroy(), this.particleIndexBuffer.destroy(), this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleSegment.destroy();
        }
      }
      function Br(t4, i3, o3) {
        if (!t4) return null;
        const s3 = i3.getTextureDescriptor(t4, o3, true);
        if (!s3) return null;
        let { texture: r3, mix: a4, offset: n3, tileSize: l3, buffer: c3, format: h3 } = s3;
        if (!r3 || !h3) return null;
        let u4 = false;
        return "uint32" === h3 && (u4 = true, a4[3] = 0, a4 = $s(e2.d7, a4, [0, o3.paint.get("raster-particle-max-speed")]), n3 = Xs(e2.d7, n3, [0, o3.paint.get("raster-particle-max-speed")])), { texture: r3, textureOffset: [c3 / (l3 + 2 * c3), l3 / (l3 + 2 * c3)], tileSize: l3, scalarData: u4, scale: a4, offset: n3, defines: ["RASTER_ARRAY", { uint8: "DATA_FORMAT_UINT8", uint16: "DATA_FORMAT_UINT16", uint32: "DATA_FORMAT_UINT32" }[h3]] };
      }
      function kr(e3) {
        const t4 = e3._nearZ, i3 = e3.projection.farthestPixelDistance(e3), o3 = i3 - t4, s3 = 0.2 * e3.height, r3 = t4 + s3;
        return [t4, i3, (r3 - s3 - t4) / o3, (r3 - t4) / o3];
      }
      const Nr = new e2.bA(1, 0, 0, 1), Ur = new e2.bA(0, 1, 0, 1), Gr = new e2.bA(0, 0, 1, 1), Vr = new e2.bA(1, 0, 1, 1), jr = new e2.bA(0, 1, 1, 1);
      function Hr(t4, i3, o3, s3, r3, a4, n3) {
        const l3 = t4.context, c3 = t4.transform, h3 = l3.gl, u4 = "globe" === c3.projection.name, d3 = u4 ? ["PROJECTION_GLOBE_VIEW"] : [];
        let _2 = e2.a6.mat4.clone(o3.projMatrix);
        if (u4 && e2.a9(c3.zoom) > 0) {
          const t5 = e2.b5(o3.canonical, c3), i4 = e2.d8(t5);
          _2 = e2.a6.mat4.multiply(new Float32Array(16), c3.globeMatrix, i4), e2.a6.mat4.multiply(_2, c3.projMatrix, _2);
        }
        const p3 = e2.a6.mat4.create();
        p3[12] += 2 * r3 / (e2.e.devicePixelRatio * c3.width), p3[13] += 2 * a4 / (e2.e.devicePixelRatio * c3.height), e2.a6.mat4.multiply(_2, p3, _2);
        const f3 = t4.getOrCreateProgram("debug", { defines: d3 }), m2 = i3.getTileByID(o3.key);
        t4.terrain && t4.terrain.setupElevationDraw(m2, f3);
        const g4 = Ai.disabled, v2 = Pi2.disabled, x2 = t4.colorModeForRenderPass(), y2 = "$debug";
        l3.activeTexture.set(h3.TEXTURE0), t4.emptyTexture.bind(h3.LINEAR, h3.CLAMP_TO_EDGE), u4 ? m2._makeGlobeTileDebugBuffers(t4.context, c3) : m2._makeDebugTileBoundsBuffers(t4.context, c3.projection);
        const b2 = m2._tileDebugBuffer || t4.debugBuffer, w2 = m2._tileDebugIndexBuffer || t4.debugIndexBuffer, T3 = m2._tileDebugSegments || t4.debugSegments;
        if (f3.draw(t4, h3.LINE_STRIP, g4, v2, x2, Oi2.disabled, Zs(_2, s3), y2, b2, w2, T3, null, null, null, [m2._globeTileDebugBorderBuffer]), n3) {
          const e3 = m2.latestRawTileData, i4 = Math.floor((e3 && e3.byteLength || 0) / 1024);
          let s4 = o3.canonical.toString();
          o3.overscaledZ !== o3.canonical.z && (s4 += ` => ${o3.overscaledZ}`), s4 += ` ${m2.state}`, s4 += ` ${i4}kb`, function(e4, t5) {
            e4.initDebugOverlayCanvas();
            const i5 = e4.debugOverlayCanvas, o4 = e4.context.gl, s5 = e4.debugOverlayCanvas.getContext("2d");
            s5.clearRect(0, 0, i5.width, i5.height), s5.shadowColor = "white", s5.shadowBlur = 2, s5.lineWidth = 1.5, s5.strokeStyle = "white", s5.textBaseline = "top", s5.font = "bold 36px Open Sans, sans-serif", s5.fillText(t5, 5, 5), s5.strokeText(t5, 5, 5), e4.debugOverlayTexture.update(i5), e4.debugOverlayTexture.bind(o4.LINEAR, o4.CLAMP_TO_EDGE);
          }(t4, s4);
        }
        const E3 = i3.getTile(o3).tileSize, S2 = 512 / Math.min(E3, 512) * (o3.overscaledZ / c3.zoom) * 0.5, C3 = m2._tileDebugTextBuffer || t4.debugBuffer, I3 = m2._tileDebugTextIndexBuffer || t4.quadTriangleIndexBuffer, D2 = m2._tileDebugTextSegments || t4.debugSegments;
        f3.draw(t4, h3.TRIANGLES, g4, v2, Ri.alphaBlended, Oi2.disabled, Zs(_2, e2.bA.transparent, S2), y2, C3, I3, D2, null, null, null, [m2._globeTileDebugTextBuffer]);
      }
      function Zr(e3, t4, i3, o3) {
        Wr(e3, 0, t4 + i3 / 2, e3.transform.width, i3, o3);
      }
      function qr(e3, t4, i3, o3) {
        Wr(e3, t4 - i3 / 2, 0, i3, e3.transform.height, o3);
      }
      function Wr(t4, i3, o3, s3, r3, a4) {
        const n3 = t4.context, l3 = n3.gl;
        l3.enable(l3.SCISSOR_TEST), l3.scissor(i3 * e2.e.devicePixelRatio, o3 * e2.e.devicePixelRatio, s3 * e2.e.devicePixelRatio, r3 * e2.e.devicePixelRatio), n3.clear({ color: a4 }), l3.disable(l3.SCISSOR_TEST);
      }
      const $r = e2.d5([{ name: "a_pos_3f", components: 3, type: "Float32" }]), { members: Xr } = $r;
      function Jr(e3, t4, i3, o3) {
        e3.emplaceBack(t4, i3, o3);
      }
      class Kr {
        constructor(t4) {
          this.vertexArray = new e2.d9(), this.indices = new e2.aP(), Jr(this.vertexArray, -1, -1, 1), Jr(this.vertexArray, 1, -1, 1), Jr(this.vertexArray, -1, 1, 1), Jr(this.vertexArray, 1, 1, 1), Jr(this.vertexArray, -1, -1, -1), Jr(this.vertexArray, 1, -1, -1), Jr(this.vertexArray, -1, 1, -1), Jr(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t4.createVertexBuffer(this.vertexArray, Xr), this.indexBuffer = t4.createIndexBuffer(this.indices), this.segment = e2.b2.simpleSegment(0, 0, 36, 12);
        }
      }
      function Yr(t4, i3, o3, s3, r3, a4) {
        const n3 = t4.context.gl, l3 = i3.paint.get("sky-atmosphere-color"), c3 = i3.paint.get("sky-atmosphere-halo-color"), h3 = i3.paint.get("sky-atmosphere-sun-intensity"), u4 = ((e3, t5, i4, o4, s4) => ({ u_matrix_3f: e3, u_sun_direction: t5, u_sun_intensity: i4, u_color_tint_r: [o4.r, o4.g, o4.b, o4.a], u_color_tint_m: [s4.r, s4.g, s4.b, s4.a], u_luminance: 5e-5 }))(e2.a6.mat3.fromMat4(e2.a6.mat3.create(), s3), r3, h3, l3, c3);
        n3.framebufferTexture2D(n3.FRAMEBUFFER, n3.COLOR_ATTACHMENT0, n3.TEXTURE_CUBE_MAP_POSITIVE_X + a4, i3.skyboxTexture, 0), o3.draw(t4, n3.TRIANGLES, Ai.disabled, Pi2.disabled, Ri.unblended, Oi2.frontCW, u4, "skyboxCapture", i3.skyboxGeometry.vertexBuffer, i3.skyboxGeometry.indexBuffer, i3.skyboxGeometry.segment);
      }
      const Qr = e2.d5([{ type: "Float32", name: "a_pos", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }]);
      class ea {
        constructor(t4) {
          const i3 = new e2.da();
          i3.emplaceBack(-1, 1, 1, 0, 0), i3.emplaceBack(1, 1, 1, 1, 0), i3.emplaceBack(1, -1, 1, 1, 1), i3.emplaceBack(-1, -1, 1, 0, 1);
          const o3 = new e2.aP();
          o3.emplaceBack(0, 1, 2), o3.emplaceBack(2, 3, 0), this.vertexBuffer = t4.createVertexBuffer(i3, Qr.members), this.indexBuffer = t4.createIndexBuffer(o3), this.segments = e2.b2.simpleSegment(0, 0, 4, 2);
        }
        destroy() {
          this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
        }
      }
      const ta = e2.d5([{ type: "Float32", name: "a_pos_3f", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }, { type: "Float32", name: "a_size_scale", components: 1 }, { type: "Float32", name: "a_fade_opacity", components: 1 }]);
      class ia {
        constructor() {
          this.starsCount = 16e3, this.sizeMultiplier = 0.15, this.sizeRange = 100, this.intensityRange = 200;
        }
      }
      class oa {
        constructor(t4) {
          this.colorModeAlphaBlendedWriteRGB = new Ri([1, Di, 1, Di], e2.bA.transparent, [true, true, true, false]), this.colorModeWriteAlpha = new Ri([1, 0, 1, 0], e2.bA.transparent, [false, false, false, true]), this.params = new ia(), this.updateNeeded = true, t4.tp.registerParameter(this.params, ["Stars"], "starsCount", { min: 100, max: 16e3, step: 1 }, () => {
            this.updateNeeded = true;
          }), t4.tp.registerParameter(this.params, ["Stars"], "sizeMultiplier", { min: 0.01, max: 2, step: 0.01 }), t4.tp.registerParameter(this.params, ["Stars"], "sizeRange", { min: 0, max: 200, step: 1 }, () => {
            this.updateNeeded = true;
          }), t4.tp.registerParameter(this.params, ["Stars"], "intensityRange", { min: 0, max: 200, step: 1 }, () => {
            this.updateNeeded = true;
          });
        }
        update(t4) {
          const i3 = t4.context;
          if (!this.atmosphereBuffer || this.updateNeeded) {
            this.updateNeeded = false, this.atmosphereBuffer = new ea(i3);
            const t5 = this.params.sizeRange, o3 = this.params.intensityRange, s3 = function(t6) {
              const i4 = e2.dd(30), o4 = [];
              for (let s4 = 0; s4 < t6; ++s4) {
                const t7 = 2 * Math.PI * i4(), s5 = Math.acos(1 - 2 * i4()) - 0.5 * Math.PI;
                o4.push(e2.a6.vec3.fromValues(Math.cos(s5) * Math.cos(t7), Math.cos(s5) * Math.sin(t7), Math.sin(s5)));
              }
              return o4;
            }(this.params.starsCount), r3 = e2.dd(300), a4 = new e2.db(), n3 = new e2.aP();
            let l3 = 0;
            for (let i4 = 0; i4 < s3.length; ++i4) {
              const c3 = e2.a6.vec3.scale([], s3[i4], 200), h3 = Math.max(0, 1 + 0.01 * t5 * (1 * r3() - 0.5)), u4 = Math.max(0, 1 + 0.01 * o3 * (1 * r3() - 0.5));
              a4.emplaceBack(c3[0], c3[1], c3[2], -1, -1, h3, u4), a4.emplaceBack(c3[0], c3[1], c3[2], 1, -1, h3, u4), a4.emplaceBack(c3[0], c3[1], c3[2], 1, 1, h3, u4), a4.emplaceBack(c3[0], c3[1], c3[2], -1, 1, h3, u4), n3.emplaceBack(l3 + 0, l3 + 1, l3 + 2), n3.emplaceBack(l3 + 0, l3 + 2, l3 + 3), l3 += 4;
            }
            this.starsVx = i3.createVertexBuffer(a4, ta.members), this.starsIdx = i3.createIndexBuffer(n3), this.starsSegments = e2.b2.simpleSegment(0, 0, a4.length, n3.length);
          }
        }
        destroy() {
          this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy();
        }
        drawAtmosphereGlow(t4, i3) {
          const o3 = t4.context, s3 = o3.gl, r3 = t4.transform, a4 = new Ai(s3.LEQUAL, Ai.ReadOnly, [0, 1]), n3 = e2.a9(r3.zoom), l3 = t4.style.getLut(i3.scope), c3 = i3.properties.get("color").toRenderColor(l3).toArray01(), h3 = i3.properties.get("high-color").toRenderColor(l3).toArray01(), u4 = i3.properties.get("space-color").toRenderColor(l3).toArray01PremultipliedAlpha(), d3 = 5e-4, _2 = e2.dc(i3.properties.get("horizon-blend"), 0, 1, d3, 0.25), p3 = e2.cx(t4, o3, r3) && _2 === d3 ? r3.worldSize / (2 * Math.PI * 1.025) - 1 : r3.globeRadius, f3 = t4.frameCounter / 1e3 % 1, m2 = e2.a6.vec3.length(r3.globeCenterInViewSpace), g4 = Math.sqrt(Math.pow(m2, 2) - Math.pow(p3, 2)), v2 = Math.acos(g4 / m2), x2 = (e3) => {
            const i4 = "globe" === r3.projection.name ? ["PROJECTION_GLOBE_VIEW", "FOG"] : ["FOG"];
            e3 && i4.push("ALPHA_PASS");
            const l4 = t4.getOrCreateProgram("globeAtmosphere", { defines: i4 }), d4 = /* @__PURE__ */ ((e4, t5, i5, o4, s4, r4, a5, n4, l5, c4, h4, u5) => ({ u_frustum_tl: e4, u_frustum_tr: t5, u_frustum_br: i5, u_frustum_bl: o4, u_horizon: s4, u_transition: r4, u_fadeout_range: a5, u_color: n4, u_high_color: l5, u_space_color: c4, u_temporal_offset: h4, u_horizon_angle: u5 }))(r3.frustumCorners.TL, r3.frustumCorners.TR, r3.frustumCorners.BR, r3.frustumCorners.BL, r3.frustumCorners.horizon, n3, _2, c3, h3, u4, f3, v2);
            t4.uploadCommonUniforms(o3, l4);
            const p4 = this.atmosphereBuffer;
            p4 && l4.draw(t4, s3.TRIANGLES, a4, Pi2.disabled, e3 ? this.colorModeWriteAlpha : this.colorModeAlphaBlendedWriteRGB, Oi2.backCW, d4, e3 ? "atmosphere_glow_alpha" : "atmosphere_glow", p4.vertexBuffer, p4.indexBuffer, p4.segments);
          };
          x2(false), x2(true);
        }
        drawStars(t4, i3) {
          const o3 = e2.ap(i3.properties.get("star-intensity"), 0, 1);
          if (0 === o3) return;
          const s3 = t4.context, r3 = s3.gl, a4 = t4.transform, n3 = t4.getOrCreateProgram("stars"), l3 = e2.a6.quat.identity([]);
          e2.a6.quat.rotateX(l3, l3, -a4._pitch), e2.a6.quat.rotateZ(l3, l3, -a4.angle), e2.a6.quat.rotateX(l3, l3, e2.bC(a4._center.lat)), e2.a6.quat.rotateY(l3, l3, -e2.bC(a4._center.lng));
          const c3 = e2.a6.mat4.fromQuat(new Float32Array(16), l3), h3 = e2.a6.mat4.multiply([], a4.starsProjMatrix, c3), u4 = e2.a6.mat3.fromMat4([], c3), d3 = e2.a6.mat3.invert([], u4), _2 = [0, 1, 0];
          e2.a6.vec3.transformMat3(_2, _2, d3), e2.a6.vec3.scale(_2, _2, this.params.sizeMultiplier);
          const p3 = [1, 0, 0];
          e2.a6.vec3.transformMat3(p3, p3, d3), e2.a6.vec3.scale(p3, p3, this.params.sizeMultiplier);
          const f3 = (m2 = _2, g4 = p3, v2 = o3, { u_matrix: Float32Array.from(h3), u_up: m2, u_right: g4, u_intensity_multiplier: v2 });
          var m2, g4, v2;
          t4.uploadCommonUniforms(s3, n3), this.starsVx && this.starsIdx && n3.draw(t4, r3.TRIANGLES, Ai.disabled, Pi2.disabled, this.colorModeAlphaBlendedWriteRGB, Oi2.disabled, f3, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
        }
      }
      function sa(t4, i3) {
        const o3 = [...t4], s3 = i3.cameraWorldSizeForFog / i3.worldSize, r3 = e2.a6.mat4.identity([]);
        return e2.a6.mat4.scale(r3, r3, [s3, s3, 1]), e2.a6.mat4.multiply(o3, r3, o3), e2.a6.mat4.multiply(o3, i3.worldToFogMatrix, o3), o3;
      }
      function ra(t4, i3, o3, s3, r3) {
        const a4 = o3.material, n3 = s3.context, { baseColorTexture: l3, metallicRoughnessTexture: c3 } = a4.pbrMetallicRoughness, { normalTexture: h3, occlusionTexture: u4, emissionTexture: d3 } = a4;
        function _2(e3, i4, o4) {
          if (e3 && (t4.push(i4), n3.activeTexture.set(n3.gl.TEXTURE0 + o4), e3.gfxTexture)) {
            const { minFilter: t5, magFilter: i5, wrapS: o5, wrapT: s4 } = e3.sampler;
            e3.gfxTexture.bindExtraParam(t5, i5, o5, s4);
          }
        }
        _2(l3, "HAS_TEXTURE_u_baseColorTexture", Gi.BaseColor), _2(c3, "HAS_TEXTURE_u_metallicRoughnessTexture", Gi.MetallicRoughness), _2(h3, "HAS_TEXTURE_u_normalTexture", Gi.Normal), _2(u4, "HAS_TEXTURE_u_occlusionTexture", Gi.Occlusion), _2(d3, "HAS_TEXTURE_u_emissionTexture", Gi.Emission), r3 && (r3.texture || (r3.texture = new e2.df(s3.context, r3.image, [r3.image.height, r3.image.height, r3.image.height], n3.gl.RGBA8)), n3.activeTexture.set(n3.gl.TEXTURE0 + Gi.LUT), r3.texture && r3.texture.bind(n3.gl.LINEAR, n3.gl.CLAMP_TO_EDGE), t4.push("APPLY_LUT_ON_GPU")), o3.texcoordBuffer && (t4.push("HAS_ATTRIBUTE_a_uv_2f"), i3.push(o3.texcoordBuffer)), o3.colorBuffer && (t4.push(12 === o3.colorBuffer.itemSize ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), i3.push(o3.colorBuffer)), o3.normalBuffer && (t4.push("HAS_ATTRIBUTE_a_normal_3f"), i3.push(o3.normalBuffer)), o3.pbrBuffer && (t4.push("HAS_ATTRIBUTE_a_pbr"), t4.push("HAS_ATTRIBUTE_a_heightBasedEmissiveStrength"), i3.push(o3.pbrBuffer)), "OPAQUE" !== a4.alphaMode && "MASK" !== a4.alphaMode || t4.push("UNPREMULT_TEXTURE_IN_SHADER"), a4.defined || t4.push("DIFFUSE_SHADED"), t4.push("USE_STANDARD_DERIVATIVES");
        const p3 = s3.shadowRenderer;
        p3 && (t4.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), p3.useNormalOffset && t4.push("NORMAL_OFFSET"));
      }
      function aa(t4, i3, o3, s3, r3, a4) {
        const n3 = o3.paint.get("model-opacity"), l3 = i3.context, c3 = new Ai(i3.context.gl.LEQUAL, Ai.ReadWrite, i3.depthRangeFor3D), h3 = i3.transform, u4 = t4.mesh, d3 = u4.material, _2 = d3.pbrMetallicRoughness, p3 = i3.style.fog;
        let f3;
        f3 = "pixels" === i3.transform.projection.zAxisUnit ? [...t4.nodeModelMatrix] : e2.a6.mat4.multiply([], s3.zScaleMatrix, t4.nodeModelMatrix), e2.a6.mat4.multiply(f3, s3.negCameraPosMatrix, f3);
        const m2 = e2.a6.mat4.invert([], f3);
        e2.a6.mat4.transpose(m2, m2);
        const g4 = o3.paint.get("model-emissive-strength").constantOr(0), v2 = nr(new Float32Array(t4.worldViewProjection), new Float32Array(f3), new Float32Array(m2), null, i3, n3, _2.baseColorFactor.toRenderColor(null), d3.emissiveFactor, _2.metallicFactor, _2.roughnessFactor, d3, g4, o3), x2 = { defines: [] }, y2 = [], b2 = i3.shadowRenderer;
        b2 && (b2.useNormalOffset = false), ra(x2.defines, y2, u4, i3, o3.lut);
        let w2 = null;
        if (p3) {
          const e3 = sa(t4.nodeModelMatrix, i3.transform);
          if (w2 = new Float32Array(e3), "globe" !== h3.projection.name) {
            const t5 = u4.aabb.min, i4 = u4.aabb.max, [o4, s4] = p3.getOpacityForBounds(e3, t5[0], t5[1], i4[0], i4[1]);
            x2.overrideFog = o4 >= ze || s4 >= ze;
          }
        }
        const T3 = qi(i3, o3.paint.get("model-cutoff-fade-range"));
        T3.shouldRenderCutoff && x2.defines.push("RENDER_CUTOFF");
        const E3 = i3.getOrCreateProgram("model", x2);
        i3.uploadCommonUniforms(l3, E3, null, w2, T3), "shadow" !== i3.renderPass && b2 && b2.setupShadowsFromMatrix(t4.nodeModelMatrix, E3), E3.draw(i3, l3.gl.TRIANGLES, c3, r3, a4, u4.material.doubleSided ? Oi2.disabled : Oi2.backCCW, v2, o3.id, u4.vertexBuffer, u4.indexBuffer, u4.segments, o3.paint, i3.transform.zoom, void 0, y2);
      }
      function na(t4, i3, o3, s3, r3, a4, n3) {
        let l3;
        l3 = "globe" === t4.projection.name ? e2.dg(o3, t4) : [...o3], e2.a6.mat4.multiply(l3, l3, i3.matrix);
        const c3 = e2.a6.mat4.multiply([], s3, l3);
        if (i3.meshes) for (const t5 of i3.meshes) {
          if ("BLEND" !== t5.material.alphaMode) {
            n3.push({ mesh: t5, depth: 0, modelIndex: r3, worldViewProjection: c3, nodeModelMatrix: l3 });
            continue;
          }
          const i4 = e2.a6.vec3.transformMat4([], t5.centroid, c3);
          i4[2] > 0 && a4.push({ mesh: t5, depth: i4[2], modelIndex: r3, worldViewProjection: c3, nodeModelMatrix: l3 });
        }
        if (i3.children) for (const e3 of i3.children) na(t4, e3, o3, s3, r3, a4, n3);
      }
      function la(e3, t4, i3, o3) {
        const s3 = i3.shadowRenderer;
        if (!s3) return;
        const r3 = s3.getShadowPassDepthMode(), a4 = s3.getShadowPassColorMode(), n3 = s3.calculateShadowPassMatrixFromMatrix(t4), l3 = lr(n3);
        i3.getOrCreateProgram("modelDepth", { defines: i3._shadowMapDebug ? [] : ["DEPTH_TEXTURE"] }).draw(i3, i3.context.gl.TRIANGLES, r3, Pi2.disabled, a4, Oi2.backCCW, l3, o3.id, e3.vertexBuffer, e3.indexBuffer, e3.segments, o3.paint, i3.transform.zoom, void 0, void 0);
      }
      function ca(t4, i3, o3) {
        const s3 = i3.updateZoomBasedPaintProperties(), r3 = function(t5, i4, o4) {
          let s4, r4, a4, n3 = t5.terrain ? t5.terrain.exaggeration() : 0;
          if (t5.terrain && n3 > 0) {
            const i5 = t5.terrain, r5 = i5.findDEMTileFor(o4);
            r5 && r5.dem ? s4 = e2.di.create(i5, o4, r5) : n3 = 0;
          }
          if (0 === n3 && (i4.terrainElevationMin = 0, i4.terrainElevationMax = 0), n3 === i4.validForExaggeration && (0 === n3 || s4 && s4._demTile && s4._demTile.tileID === i4.validForDEMTile.id && s4._dem._timestamp === i4.validForDEMTile.timestamp)) return false;
          for (const e3 in i4.instancesPerModel) {
            const t6 = i4.instancesPerModel[e3];
            for (let e4 = 0; e4 < t6.instancedDataArray.length; ++e4) {
              const o5 = (s4 ? n3 * s4.getElevationAt(0 | t6.instancedDataArray.float32[16 * e4], 0 | t6.instancedDataArray.float32[16 * e4 + 1], true, true) : 0) + t6.instancesEvaluatedElevation[e4];
              t6.instancedDataArray.float32[16 * e4 + 6] = o5, r4 = r4 ? Math.min(i4.terrainElevationMin, o5) : o5, a4 = a4 ? Math.max(i4.terrainElevationMax, o5) : o5;
            }
          }
          return i4.terrainElevationMin = r4 || 0, i4.terrainElevationMax = a4 || 0, i4.validForExaggeration = n3, i4.validForDEMTile = s4 && s4._demTile ? { id: s4._demTile.tileID, timestamp: s4._dem._timestamp } : { id: void 0, timestamp: 0 }, true;
        }(t4, i3, o3);
        (s3 || r3) && (i3.uploaded = false, i3.upload(t4.context));
      }
      const ha = { shadowUniformsInitialized: false, useSingleShadowCascade: false, tileMatrix: new Float64Array(16), shadowTileMatrix: new Float32Array(16), aabb: new e2.ca([0, 0, 0], [e2.ab, e2.ab, 0]) };
      function ua(t4, i3) {
        const o3 = 1 << t4.canonical.z, s3 = i3.getFreeCameraOptions().position, r3 = i3.elevation, a4 = t4.canonical.x / o3, n3 = (t4.canonical.x + 1) / o3, l3 = t4.canonical.y / o3, c3 = (t4.canonical.y + 1) / o3;
        let h3 = i3._centerAltitude;
        if (r3) {
          const e3 = r3.getMinMaxForTile(t4);
          e3 && e3.max > h3 && (h3 = e3.max);
        }
        const u4 = e2.ap(s3.x, a4, n3) - s3.x, d3 = e2.ap(s3.y, l3, c3) - s3.y, _2 = e2.bE(h3, i3.center.lat) - s3.z;
        return i3._zoomFromMercatorZ(Math.sqrt(u4 * u4 + d3 * d3 + _2 * _2));
      }
      function da(e3, t4, i3, o3, s3, r3, a4) {
        const n3 = e3.context, l3 = "shadow" === e3.renderPass, c3 = e3.shadowRenderer, h3 = l3 && c3 ? c3.getShadowPassDepthMode() : new Ai(n3.gl.LEQUAL, Ai.ReadWrite, e3.depthRangeFor3D), u4 = e3.isTileAffectedByFog(r3);
        if (i3.meshes) for (const d3 of i3.meshes) {
          const _2 = ["MODEL_POSITION_ON_GPU"], p3 = [];
          let f3, m2, g4;
          o3.instancedDataArray.length > 20 && _2.push("INSTANCED_ARRAYS");
          const v2 = qi(e3, t4.paint.get("model-cutoff-fade-range"));
          if (v2.shouldRenderCutoff && _2.push("RENDER_CUTOFF"), l3 && c3) f3 = e3.getOrCreateProgram("modelDepth", { defines: _2 }), m2 = lr(a4.shadowTileMatrix, a4.shadowTileMatrix, Float32Array.from(i3.matrix)), g4 = c3.getShadowPassColorMode();
          else {
            ra(_2, p3, d3, e3, t4.lut), f3 = e3.getOrCreateProgram("model", { defines: _2, overrideFog: u4 });
            const o4 = d3.material, l4 = o4.pbrMetallicRoughness, h4 = t4.paint.get("model-opacity"), x3 = t4.paint.get("model-emissive-strength").constantOr(0);
            m2 = nr(r3.expandedProjMatrix, Float32Array.from(i3.matrix), new Float32Array(16), null, e3, h4, l4.baseColorFactor.toRenderColor(null), o4.emissiveFactor, l4.metallicFactor, l4.roughnessFactor, o4, x3, t4, s3), c3 && (a4.shadowUniformsInitialized ? f3.setShadowUniformValues(n3, c3.getShadowUniformValues()) : (c3.setupShadows(r3.toUnwrapped(), f3, "model-tile", r3.overscaledZ), a4.shadowUniformsInitialized = true)), g4 = v2.shouldRenderCutoff || h4 < 1 || "OPAQUE" !== o4.alphaMode ? Ri.alphaBlended : Ri.unblended;
          }
          e3.uploadCommonUniforms(n3, f3, r3.toUnwrapped(), null, v2);
          const x2 = d3.material.doubleSided ? Oi2.disabled : Oi2.backCCW;
          if (o3.instancedDataArray.length > 20) p3.push(o3.instancedDataBuffer), f3.draw(e3, n3.gl.TRIANGLES, h3, Pi2.disabled, g4, x2, m2, t4.id, d3.vertexBuffer, d3.indexBuffer, d3.segments, t4.paint, e3.transform.zoom, void 0, p3, o3.instancedDataArray.length);
          else {
            const i4 = l3 ? "u_instance" : "u_normal_matrix";
            for (let s4 = 0; s4 < o3.instancedDataArray.length; ++s4) m2[i4] = new Float32Array(o3.instancedDataArray.arrayBuffer, 64 * s4, 16), f3.draw(e3, n3.gl.TRIANGLES, h3, Pi2.disabled, g4, x2, m2, t4.id, d3.vertexBuffer, d3.indexBuffer, d3.segments, t4.paint, e3.transform.zoom, void 0, p3);
          }
        }
        if (i3.children) for (const n4 of i3.children) da(e3, t4, n4, o3, s3, r3, a4);
      }
      const _a2 = [1, -1, 1];
      function pa(t4, i3, o3, s3) {
        if (!o3.modelManager) return true;
        const r3 = o3.modelManager;
        if (!o3.shadowRenderer) return true;
        const a4 = o3.shadowRenderer, n3 = i3.aabb;
        let l3 = true, c3 = t4.maxHeight;
        if (0 === c3) {
          let e3 = 0;
          for (const i4 in t4.instancesPerModel) {
            const t5 = r3.getModel(i4, s3);
            t5 ? e3 = Math.max(e3, Math.max(Math.max(t5.aabb.max[0], t5.aabb.max[1]), t5.aabb.max[2])) : l3 = false;
          }
          c3 = t4.maxScale * e3 * 1.41 + t4.maxVerticalOffset, l3 && (t4.maxHeight = c3);
        }
        n3.max[2] = c3, n3.min[2] += t4.terrainElevationMin, n3.max[2] += t4.terrainElevationMax, e2.a6.vec3.transformMat4(n3.min, n3.min, i3.tileMatrix), e2.a6.vec3.transformMat4(n3.max, n3.max, i3.tileMatrix);
        const h3 = n3.intersects(a4.getCurrentCascadeFrustum());
        return 0 === o3.currentShadowCascade && (t4.isInsideFirstShadowMapFrustum = 2 === h3), 0 === h3;
      }
      function fa(t4, i3) {
        const o3 = t4.uniformValues.u_cutoff_params[0], s3 = t4.uniformValues.u_cutoff_params[1], r3 = t4.uniformValues.u_cutoff_params[2], a4 = t4.uniformValues.u_cutoff_params[3];
        return s3 === o3 || a4 === r3 ? 1 : e2.ap(((i3 - o3) / (s3 - o3) - r3) / (a4 - r3), 0, 1);
      }
      function ma(t4, i3, o3, s3) {
        if (i3.pitch < 20) return 1;
        const r3 = i3.getWorldToCameraMatrix();
        e2.a6.mat4.multiply(r3, r3, t4);
        const a4 = e2.a6.vec4.fromValues(o3.min[0], o3.min[1], o3.min[2], 1);
        let n3 = e2.a6.vec4.transformMat4(e2.a6.vec4.create(), a4, r3), l3 = n3, c3 = n3;
        a4[1] = o3.max[1], n3 = e2.a6.vec4.transformMat4(e2.a6.vec4.create(), a4, r3), l3 = n3[1] < l3[1] ? n3 : l3, c3 = n3[1] > c3[1] ? n3 : c3, a4[0] = o3.max[0], n3 = e2.a6.vec4.transformMat4(e2.a6.vec4.create(), a4, r3), l3 = n3[1] < l3[1] ? n3 : l3, c3 = n3[1] > c3[1] ? n3 : c3, a4[1] = o3.min[1], n3 = e2.a6.vec4.transformMat4(e2.a6.vec4.create(), a4, r3), l3 = n3[1] < l3[1] ? n3 : l3, c3 = n3[1] > c3[1] ? n3 : c3;
        const h3 = e2.ap(s3[0], 0, 1), u4 = 100 * i3.pixelsPerMeter * e2.ap(s3[1], 0, 1), d3 = e2.ap(s3[2], 0, 1), _2 = e2.a6.vec4.lerp(e2.a6.vec4.create(), l3, c3, h3), p3 = Math.tan(0.5 * i3.fovX), f3 = -_2[2] * p3;
        if (0 === u4) return _2[1] < -Math.abs(f3) ? d3 : 1;
        const m2 = (-Math.abs(f3) - _2[1]) / u4, g4 = (e3, t5, i4) => (1 - i4) * e3 + i4 * t5, v2 = e2.ap(g4(1, d3, m2), d3, 1);
        return g4(1, v2, e2.ap((i3.pitch - 20) / 20, 0, 1));
      }
      class ga {
      }
      class va {
        constructor() {
          this._storage = /* @__PURE__ */ new Map();
        }
        getLinesFromTrianglesBuffer(t4, i3, o3) {
          {
            const e3 = this._storage.get(i3.id);
            if (e3) return e3.lastUsedFrameIdx = t4, e3.buf;
          }
          const s3 = o3.gl, r3 = s3.getBufferParameter(s3.ELEMENT_ARRAY_BUFFER, s3.BUFFER_SIZE), a4 = new ArrayBuffer(r3), n3 = new Int16Array(a4);
          s3.getBufferSubData(s3.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(a4));
          const l3 = new e2.dk();
          for (let e3 = 0; e3 < r3 / 2; e3 += 3) {
            const t5 = n3[e3], i4 = n3[e3 + 1], o4 = n3[e3 + 2];
            l3.emplaceBack(t5, i4), l3.emplaceBack(i4, o4), l3.emplaceBack(o4, t5);
          }
          const c3 = o3.bindVertexArrayOES.current, h3 = new ga();
          return h3.buf = new hr(o3, l3), h3.lastUsedFrameIdx = t4, this._storage.set(i3.id, h3), o3.bindVertexArrayOES.set(c3), h3.buf;
        }
        update(e3) {
          for (const [t4, i3] of this._storage) e3 - i3.lastUsedFrameIdx > 30 && (i3.buf.destroy(), this._storage.delete(t4));
        }
        destroy() {
          for (const [e3, t4] of this._storage) t4.buf.destroy(), this._storage.delete(e3);
        }
      }
      class xa {
        constructor(e3) {
          this.occluderSize = 30, this.depthOffset = -1e-4, e3.registerParameter(this, ["Occlusion"], "occluderSize", { min: 1, max: 100, step: 1 }), e3.registerParameter(this, ["Occlusion"], "depthOffset", { min: -0.05, max: 0, step: 1e-5 });
        }
      }
      class ya {
        registerParameter() {
        }
        registerButton() {
        }
        registerBinding() {
        }
        refreshUI() {
        }
      }
      const ba = { symbol: function(t4, i3, o3, s3, r3, a4) {
        if ("translucent" !== t4.renderPass) return;
        const n3 = Pi2.disabled, l3 = t4.colorModeForRenderPass(), c3 = o3.layout.get("text-variable-anchor"), h3 = o3.layout.get("text-size-scale-range"), u4 = e2.ap(t4.scaleFactor, h3[0], h3[1]);
        c3 && function(t5, i4, o4, s4, r4, a5, n4, l4) {
          const c4 = i4.transform, h4 = "map" === r4, u5 = "map" === a5;
          for (const i5 of t5) {
            const t6 = s4.getTile(i5), r5 = t6.getBucket(o4);
            if (!r5 || !r5.text || !r5.text.segments.get().length) continue;
            const a6 = e2.bk(r5.textSizeData, c4.zoom, l4), d4 = ti2(i5, r5.getProjection(), c4), _3 = c4.calculatePixelsToTileUnitsMatrix(t6), p3 = Ft2(d4, t6.tileID.canonical, u5, h4, c4, r5.getProjection(), _3), f3 = r5.hasIconTextFit() && r5.hasIconData();
            if (a6) {
              const o5 = Math.pow(2, c4.zoom - t6.tileID.overscaledZ);
              yr(r5, h4, u5, n4, e2.cS, c4, p3, i5, o5, a6, f3);
            }
          }
        }(r3, t4, o3, i3, o3.layout.get("text-rotation-alignment"), o3.layout.get("text-pitch-alignment"), a4, u4);
        const d3 = 0 !== o3.paint.get("icon-opacity").constantOr(1), _2 = 0 !== o3.paint.get("text-opacity").constantOr(1);
        void 0 !== o3.layout.get("symbol-sort-key").constantOr(1) && (d3 || _2) ? br(t4, i3, o3, r3, n3, l3) : (d3 && br(t4, i3, o3, r3, n3, l3, { onlyIcons: true }), _2 && br(t4, i3, o3, r3, n3, l3, { onlyText: true })), i3.map.showCollisionBoxes && (mr(t4, i3, o3, r3, o3.paint.get("text-translate"), o3.paint.get("text-translate-anchor"), true), mr(t4, i3, o3, r3, o3.paint.get("icon-translate"), o3.paint.get("icon-translate-anchor"), false));
      }, circle: function(t4, i3, o3, s3, r3) {
        if ("translucent" !== t4.renderPass) return;
        const a4 = o3.paint.get("circle-opacity"), n3 = o3.paint.get("circle-stroke-width"), l3 = o3.paint.get("circle-stroke-opacity"), c3 = void 0 !== o3.layout.get("circle-sort-key").constantOr(1), h3 = o3.paint.get("circle-emissive-strength");
        if (0 === a4.constantOr(1) && (0 === n3.constantOr(1) || 0 === l3.constantOr(1))) return;
        const u4 = t4.context, d3 = u4.gl, _2 = t4.transform, p3 = t4.depthModeForSublayer(0, Ai.ReadOnly), f3 = Pi2.disabled, m2 = t4.colorModeForDrapableLayerRenderPass(h3), g4 = "globe" === _2.projection.name, v2 = [e2.am(_2.center.lng), e2.at(_2.center.lat)], x2 = [];
        for (let s4 = 0; s4 < r3.length; s4++) {
          const a5 = r3[s4], n4 = i3.getTile(a5), l4 = n4.getBucket(o3);
          if (!l4 || l4.projection.name !== _2.projection.name) continue;
          const h4 = l4.programConfigurations.get(o3.id), u5 = e2.cT(o3), d4 = t4.isTileAffectedByFog(a5);
          g4 && u5.push("PROJECTION_GLOBE_VIEW"), u5.push("DEPTH_D24"), t4.terrain && _2.depthOcclusionForSymbolsAndCircles && u5.push("DEPTH_OCCLUSION");
          const p4 = t4.getOrCreateProgram("circle", { config: h4, defines: u5, overrideFog: d4 }), f4 = l4.layoutVertexBuffer, m3 = l4.globeExtVertexBuffer, y3 = l4.indexBuffer, b2 = _2.projection.createInversionMatrix(_2, a5.canonical), w2 = { programConfiguration: h4, program: p4, layoutVertexBuffer: f4, globeExtVertexBuffer: m3, indexBuffer: y3, uniformValues: e2.cU(t4, a5, n4, b2, v2, o3), tile: n4 };
          if (c3) {
            const t5 = l4.segments.get();
            for (const i4 of t5) x2.push({ segments: new e2.b2([i4]), sortKey: i4.sortKey, state: w2 });
          } else x2.push({ segments: l4.segments, sortKey: 0, state: w2 });
        }
        c3 && x2.sort((e3, t5) => e3.sortKey - t5.sortKey);
        const y2 = { useDepthForOcclusion: _2.depthOcclusionForSymbolsAndCircles };
        for (const e3 of x2) {
          const { programConfiguration: i4, program: s4, layoutVertexBuffer: r4, globeExtVertexBuffer: a5, indexBuffer: n4, uniformValues: l4, tile: c4 } = e3.state, h4 = e3.segments;
          t4.terrain && t4.terrain.setupElevationDraw(c4, s4, y2), t4.uploadCommonUniforms(u4, s4, c4.tileID.toUnwrapped()), s4.draw(t4, d3.TRIANGLES, p3, f3, m2, Oi2.disabled, l4, o3.id, r4, n4, h4, o3.paint, _2.zoom, i4, [a5]);
        }
      }, heatmap: function(t4, i3, o3, s3, r3) {
        if (0 !== o3.paint.get("heatmap-opacity")) if ("offscreen" === t4.renderPass) {
          const s4 = t4.context, a4 = s4.gl, n3 = Pi2.disabled, l3 = new Ri([a4.ONE, a4.ONE, a4.ONE, a4.ONE], e2.bA.transparent, [true, true, true, true]);
          !function(e3, t5, i4, o4) {
            const s5 = e3.gl, r4 = t5.width * o4, a5 = t5.height * o4;
            e3.activeTexture.set(s5.TEXTURE1), e3.viewport.set([0, 0, r4, a5]);
            let n4 = i4.heatmapFbo;
            if (!n4 || n4 && (n4.width !== r4 || n4.height !== a5)) {
              n4 && n4.destroy();
              const t6 = s5.createTexture();
              s5.bindTexture(s5.TEXTURE_2D, t6), s5.texParameteri(s5.TEXTURE_2D, s5.TEXTURE_WRAP_S, s5.CLAMP_TO_EDGE), s5.texParameteri(s5.TEXTURE_2D, s5.TEXTURE_WRAP_T, s5.CLAMP_TO_EDGE), s5.texParameteri(s5.TEXTURE_2D, s5.TEXTURE_MIN_FILTER, s5.LINEAR), s5.texParameteri(s5.TEXTURE_2D, s5.TEXTURE_MAG_FILTER, s5.LINEAR), n4 = i4.heatmapFbo = e3.createFramebuffer(r4, a5, true, null), function(e4, t7, i5, o5, s6, r5) {
                const a6 = e4.gl;
                a6.texImage2D(a6.TEXTURE_2D, 0, e4.extRenderToTextureHalfFloat ? a6.RGBA16F : a6.RGBA, s6, r5, 0, a6.RGBA, e4.extRenderToTextureHalfFloat ? a6.HALF_FLOAT : a6.UNSIGNED_BYTE, null), o5.colorAttachment.set(i5);
              }(e3, 0, t6, n4, r4, a5);
            } else s5.bindTexture(s5.TEXTURE_2D, n4.colorAttachment.get()), e3.bindFramebuffer.set(n4.framebuffer);
          }(s4, t4, o3, "globe" === t4.transform.projection.name ? 0.5 : 0.25), s4.clear({ color: e2.bA.transparent });
          const c3 = t4.transform, h3 = "globe" === c3.projection.name, u4 = h3 ? ["PROJECTION_GLOBE_VIEW"] : [], d3 = h3 ? Oi2.frontCCW : Oi2.disabled, _2 = [e2.am(c3.center.lng), e2.at(c3.center.lat)];
          for (let e3 = 0; e3 < r3.length; e3++) {
            const p3 = r3[e3];
            if (i3.hasRenderableParent(p3)) continue;
            const f3 = i3.getTile(p3), m2 = f3.getBucket(o3);
            if (!m2 || m2.projection.name !== c3.projection.name) continue;
            const g4 = t4.isTileAffectedByFog(p3), v2 = m2.programConfigurations.get(o3.id), x2 = t4.getOrCreateProgram("heatmap", { config: v2, defines: u4, overrideFog: g4 }), { zoom: y2 } = t4.transform;
            t4.terrain && t4.terrain.setupElevationDraw(f3, x2), t4.uploadCommonUniforms(s4, x2, p3.toUnwrapped());
            const b2 = c3.projection.createInversionMatrix(c3, p3.canonical);
            x2.draw(t4, a4.TRIANGLES, Ai.disabled, n3, l3, d3, Ws(t4, p3, f3, b2, _2, y2, o3.paint.get("heatmap-intensity")), o3.id, m2.layoutVertexBuffer, m2.indexBuffer, m2.segments, o3.paint, t4.transform.zoom, v2, h3 ? [m2.globeExtVertexBuffer] : null);
          }
          s4.viewport.set([0, 0, t4.width, t4.height]);
        } else "translucent" === t4.renderPass && (t4.context.setColorMode(t4.colorModeForRenderPass()), function(t5, i4) {
          const o4 = t5.context, s4 = o4.gl, r4 = i4.heatmapFbo;
          if (!r4) return;
          o4.activeTexture.set(s4.TEXTURE0), s4.bindTexture(s4.TEXTURE_2D, r4.colorAttachment.get()), o4.activeTexture.set(s4.TEXTURE1);
          let a4 = i4.colorRampTexture;
          a4 || (a4 = i4.colorRampTexture = new e2.T(o4, i4.colorRamp, s4.RGBA8)), a4.bind(s4.LINEAR, s4.CLAMP_TO_EDGE), t5.getOrCreateProgram("heatmapTexture").draw(t5, s4.TRIANGLES, Ai.disabled, Pi2.disabled, t5.colorModeForRenderPass(), Oi2.disabled, ((e3, t6, i5, o5) => ({ u_image: 0, u_color_ramp: 1, u_opacity: t6.paint.get("heatmap-opacity") }))(0, i4), i4.id, t5.viewportBuffer, t5.quadTriangleIndexBuffer, t5.viewportSegments, i4.paint, t5.transform.zoom);
        }(t4, o3));
      }, line: function(t4, i3, o3, s3, r3) {
        if ("translucent" !== t4.renderPass) return;
        const a4 = o3.paint.get("line-opacity"), n3 = o3.paint.get("line-width");
        if (0 === a4.constantOr(1) || 0 === n3.constantOr(1)) return;
        const l3 = o3.paint.get("line-emissive-strength"), c3 = o3.paint.get("line-occlusion-opacity"), h3 = "sea" === o3.layout.get("line-elevation-reference"), u4 = t4.context, d3 = u4.gl, _2 = !o3.isDraped();
        if (_2 && "globe" === t4.transform.projection.name) return;
        const p3 = o3.layout.get("line-cross-slope"), f3 = void 0 !== p3, m2 = p3 < 1, g4 = _2 ? new Ai(t4.depthOcclusion ? d3.GREATER : d3.LEQUAL, Ai.ReadOnly, t4.depthRangeFor3D) : t4.depthModeForSublayer(0, Ai.ReadOnly), v2 = t4.colorModeForDrapableLayerRenderPass(l3), x2 = t4.terrain && t4.terrain.renderingToTexture, y2 = x2 ? 1 : e2.e.devicePixelRatio, b2 = o3.paint.get("line-dasharray"), w2 = b2.constantOr(1), T3 = o3.layout.get("line-cap"), E3 = b2.constantOr(null), S2 = T3.constantOr(null), C3 = o3.paint.get("line-pattern"), I3 = C3.constantOr(1), D2 = C3.constantOr(null), R3 = o3.paint.get("line-opacity").constantOr(1);
        let A3 = !I3 && 1 !== R3 || t4.depthOcclusion && c3 > 0 && c3 < 1;
        const L3 = o3.paint.get("line-gradient"), P2 = I3 ? "linePattern" : "line", M2 = e2.cV(o3);
        let z3;
        if (x2 && t4.terrain && t4.terrain.clipOrMaskOverlapStencilType() && (A3 = false), 0 !== c3 && t4.depthOcclusion) {
          const t5 = o3.paint._values["line-opacity"];
          t5 && t5.value && "constant" === t5.value.kind ? z3 = t5.value : e2.w(`Occlusion opacity for layer ${o3.id} is supported only when line-opacity isn't data-driven.`);
        }
        if (_2 && (t4.forceTerrainMode = true), !_2 && 0 !== c3 && t4.terrain && !x2) return void e2.w(`Occlusion opacity for layer ${o3.id} is supported on terrain only if the layer has line-z-offset enabled.`);
        const O2 = A3 && _2 ? t4.stencilModeFor3D() : Pi2.disabled;
        _2 && (M2.push("ELEVATED"), f3 && M2.push(m2 ? "CROSS_SLOPE_HORIZONTAL" : "CROSS_SLOPE_VERTICAL"), h3 && M2.push("ELEVATION_REFERENCE_SEA"));
        for (const s4 of r3) {
          const r4 = i3.getTile(s4);
          if (I3 && !r4.patternsLoaded()) continue;
          const a5 = r4.getBucket(o3);
          if (!a5) continue;
          t4.prepareDrawTile();
          const n4 = a5.programConfigurations.get(o3.id), l4 = t4.isTileAffectedByFog(s4), p4 = t4.getOrCreateProgram(P2, { config: n4, defines: M2, overrideFog: l4, overrideRtt: !_2 && void 0 });
          if (D2 && r4.imageAtlas) {
            const e3 = r4.imageAtlas.patternPositions[D2.toString()];
            e3 && n4.setConstantPatternPositions(e3);
          }
          if (!I3 && E3 && S2 && r4.lineAtlas) {
            const e3 = r4.lineAtlas.getDash(E3, S2);
            e3 && n4.setConstantPatternPositions(e3);
          }
          let [f4, m3] = o3.paint.get("line-trim-offset");
          if ("round" === S2 || "square" === S2) {
            const e3 = 1;
            f4 !== m3 && (0 === f4 && (f4 -= e3), 1 === m3 && (m3 += e3));
          }
          const b3 = x2 ? s4.projMatrix : null, T4 = I3 ? e2.cW(t4, r4, o3, b3, y2, [f4, m3]) : e2.cX(t4, r4, o3, b3, a5.lineClipsArray.length, y2, [f4, m3]);
          if (L3) {
            const r5 = a5.gradients[o3.id];
            let n5 = r5.texture;
            if (o3.gradientVersion !== r5.version) {
              let l5 = 256;
              if (o3.stepInterpolant) {
                const o4 = i3.getSource().maxzoom, r6 = s4.canonical.z === o4 ? Math.ceil(1 << t4.transform.maxZoom - s4.canonical.z) : 1;
                l5 = e2.ap(e2.cY(a5.maxLineLength / e2.ab * 1024 * r6), 256, u4.maxTextureSize);
              }
              r5.gradient = e2.cZ({ expression: o3.gradientExpression(), evaluationKey: "lineProgress", resolution: l5, image: r5.gradient || void 0, clips: a5.lineClipsArray }), r5.texture ? r5.texture.update(r5.gradient) : r5.texture = new e2.T(u4, r5.gradient, d3.RGBA8), r5.version = o3.gradientVersion, n5 = r5.texture;
            }
            u4.activeTexture.set(d3.TEXTURE1), n5.bind(o3.stepInterpolant ? d3.NEAREST : d3.LINEAR, d3.CLAMP_TO_EDGE);
          }
          w2 && (u4.activeTexture.set(d3.TEXTURE0), r4.lineAtlasTexture && r4.lineAtlasTexture.bind(d3.LINEAR, d3.REPEAT), n4.updatePaintBuffers()), I3 && (u4.activeTexture.set(d3.TEXTURE0), r4.imageAtlasTexture && r4.imageAtlasTexture.bind(d3.LINEAR, d3.CLAMP_TO_EDGE), n4.updatePaintBuffers()), _2 && !h3 && t4.terrain.setupElevationDraw(r4, p4), t4.uploadCommonUniforms(u4, p4, s4.toUnwrapped());
          const C4 = (e3) => {
            null != z3 && (z3.value = R3 * c3), p4.draw(t4, d3.TRIANGLES, g4, e3, v2, Oi2.disabled, T4, o3.id, a5.layoutVertexBuffer, a5.indexBuffer, a5.segments, o3.paint, t4.transform.zoom, n4, [a5.layoutVertexBuffer2, a5.patternVertexBuffer, a5.zOffsetVertexBuffer]), null != z3 && (z3.value = R3);
          };
          if (A3 && !_2) {
            const e3 = t4.stencilModeForClipping(s4).ref;
            0 === e3 && x2 && u4.clear({ stencil: 0 });
            const i4 = { func: d3.EQUAL, mask: 255 };
            T4.u_alpha_discard_threshold = 0.8, C4(new Pi2(i4, e3, 255, d3.KEEP, d3.KEEP, d3.INVERT)), T4.u_alpha_discard_threshold = 0, C4(new Pi2(i4, e3, 255, d3.KEEP, d3.KEEP, d3.KEEP));
          } else A3 && _2 && (T4.u_alpha_discard_threshold = 1e-3), C4(_2 ? O2 : t4.stencilModeForClipping(s4));
        }
        _2 && (t4.forceTerrainMode = false), A3 && (t4.resetStencilClippingMasks(), x2 && u4.clear({ stencil: 0 })), 0 === c3 || t4.depthOcclusion || x2 || t4.layersWithOcclusionOpacity.push(t4.currentLayer);
      }, fill: function(t4, i3, o3, s3, r3) {
        const a4 = o3.paint.get("fill-color"), n3 = o3.paint.get("fill-opacity"), l3 = o3.is3D(), c3 = new Ai(t4.context.gl.LEQUAL, Ai.ReadWrite, t4.depthRangeFor3D);
        if (0 === n3.constantOr(1)) return;
        const h3 = o3.paint.get("fill-emissive-strength"), u4 = t4.colorModeForDrapableLayerRenderPass(h3), d3 = o3.paint.get("fill-pattern"), _2 = t4.opaquePassEnabledForLayer() && !d3.constantOr(1) && 1 === a4.constantOr(e2.bA.transparent).a && 1 === n3.constantOr(0) ? "opaque" : "translucent";
        if (t4.renderPass === _2) {
          const e3 = l3 ? c3 : t4.depthModeForSublayer(1, "opaque" === t4.renderPass ? Ai.ReadWrite : Ai.ReadOnly);
          Tr(t4, i3, o3, r3, e3, u4, false);
        }
        if (!l3 && "translucent" === t4.renderPass && o3.paint.get("fill-antialias")) {
          const e3 = l3 ? c3 : t4.depthModeForSublayer(o3.getPaintProperty("fill-outline-color") ? 2 : 0, Ai.ReadOnly);
          Tr(t4, i3, o3, r3, e3, u4, true);
        }
      }, "fill-extrusion": function(t4, i3, o3, s3, r3) {
        const a4 = o3.paint.get("fill-extrusion-opacity"), n3 = t4.context, l3 = n3.gl, c3 = t4.terrain, h3 = c3 && c3.renderingToTexture;
        if (0 === a4) return;
        const u4 = t4.conflationActive && t4.style.isLayerClipped(o3, i3.getSource()), d3 = t4.style.order.indexOf(o3.fqid);
        if (u4 && function(e3, t5, i4, o4, s4) {
          for (const r4 of o4) {
            const o5 = t5.getTile(r4).getBucket(i4);
            o5 && (o5.updateReplacement(r4, e3.replacementSource, s4), o5.uploadCentroid(e3.context));
          }
        }(t4, i3, o3, r3, d3), c3 || u4) for (const e3 of r3) {
          const s4 = i3.getTile(e3).getBucket(o3);
          s4 && Cr(t4.context, i3, e3, s4, o3, c3, u4);
        }
        if ("shadow" === t4.renderPass && t4.shadowRenderer) {
          const s4 = t4.shadowRenderer;
          if (c3 && a4 < 0.65 && o3._transitionablePaint._values["fill-extrusion-opacity"].value.expression instanceof e2.a4) return;
          const n4 = s4.getShadowPassDepthMode(), l4 = s4.getShadowPassColorMode();
          Er(t4, i3, o3, r3, n4, Pi2.disabled, l4, u4);
        } else if ("translucent" === t4.renderPass) {
          const s4 = !o3.paint.get("fill-extrusion-pattern").constantOr(1), d4 = o3.paint.get("fill-extrusion-color").constantOr(e2.bA.white);
          if (!h3 && 0 !== d4.a) {
            const e3 = new Ai(t4.context.gl.LEQUAL, Ai.ReadWrite, t4.depthRangeFor3D);
            1 === a4 && s4 ? Er(t4, i3, o3, r3, e3, Pi2.disabled, Ri.unblended, u4) : (Er(t4, i3, o3, r3, e3, Pi2.disabled, Ri.disabled, u4), Er(t4, i3, o3, r3, e3, t4.stencilModeFor3D(), t4.colorModeForRenderPass(), u4), t4.resetStencilClippingMasks());
          }
          if (t4.style.enable3dLights() && s4 && (!c3 && "globe" !== t4.transform.projection.name || h3)) {
            const s5 = o3.paint.get("fill-extrusion-opacity"), a5 = o3.paint.get("fill-extrusion-ambient-occlusion-intensity"), d5 = o3.paint.get("fill-extrusion-ambient-occlusion-ground-radius"), _2 = o3.paint.get("fill-extrusion-flood-light-intensity"), p3 = o3.paint.get("fill-extrusion-flood-light-color").toRenderColor(o3.lut).toArray01().slice(0, 3), f3 = a5 > 0 && d5 > 0, m2 = _2 > 0, g4 = (e3, t5, i4) => (1 - i4) * e3 + i4 * t5, v2 = (n4) => {
              const c4 = t4.depthModeForSublayer(1, Ai.ReadOnly, l3.LEQUAL, true), h4 = o3.paint.get(n4 ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), f4 = g4(0.1, 3, h4), m3 = t4._showOverdrawInspector;
              if (!m3) {
                const h5 = new Pi2({ func: l3.ALWAYS, mask: 255 }, 255, 255, l3.KEEP, l3.KEEP, l3.REPLACE), m4 = new Ri([l3.ONE, l3.ONE, l3.ONE, l3.ONE], e2.bA.transparent, [false, false, false, true], l3.MIN);
                Sr(t4, i3, o3, r3, c4, h5, m4, Oi2.disabled, n4, "sdf", s5, a5, d5, _2, p3, f4, u4, false);
              }
              {
                const h5 = m3 ? Pi2.disabled : new Pi2({ func: l3.EQUAL, mask: 255 }, 255, 255, l3.KEEP, l3.DECR, l3.DECR), g5 = m3 ? t4.colorModeForRenderPass() : new Ri([l3.ONE_MINUS_DST_ALPHA, l3.DST_ALPHA, l3.ONE, l3.ONE], e2.bA.transparent, [true, true, true, true]);
                Sr(t4, i3, o3, r3, c4, h5, g5, Oi2.disabled, n4, "color", s5, a5, d5, _2, p3, f4, u4, false);
              }
            };
            if (h3) {
              const h4 = (n4, c4, h5) => {
                const f4 = t4.depthModeForSublayer(1, Ai.ReadOnly, l3.LEQUAL, false), m3 = o3.paint.get(n4 ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), v3 = g4(0.1, 3, m3);
                {
                  const h6 = new Ri([l3.ONE, l3.ONE, l3.ONE, l3.ONE], e2.bA.transparent, [false, false, false, true]);
                  Sr(t4, i3, o3, r3, f4, Pi2.disabled, h6, Oi2.disabled, n4, "clear", s5, a5, d5, _2, p3, v3, u4, c4);
                }
                {
                  const h6 = new Pi2({ func: l3.ALWAYS, mask: 255 }, 255, 255, l3.KEEP, l3.KEEP, l3.REPLACE), m4 = new Ri([l3.ONE, l3.ONE, l3.ONE, l3.ONE], e2.bA.transparent, [false, false, false, true], l3.MIN);
                  Sr(t4, i3, o3, r3, f4, h6, m4, Oi2.disabled, n4, "sdf", s5, a5, d5, _2, p3, v3, u4, c4);
                }
                {
                  const h6 = n4 ? l3.ZERO : l3.ONE_MINUS_DST_ALPHA, m4 = new Pi2({ func: l3.EQUAL, mask: 255 }, 255, 255, l3.KEEP, l3.DECR, l3.DECR), g5 = new Ri([h6, l3.DST_ALPHA, l3.ONE_MINUS_DST_ALPHA, l3.ZERO], e2.bA.transparent, [true, true, true, true]);
                  Sr(t4, i3, o3, r3, f4, m4, g5, Oi2.disabled, n4, "color", s5, a5, d5, _2, p3, v3, u4, c4);
                }
                {
                  const m4 = new Ri([l3.ONE, l3.ONE, l3.ONE, n4 ? l3.ZERO : l3.ONE], e2.bA.transparent, [false, false, false, true], n4 ? l3.FUNC_ADD : l3.MAX);
                  Sr(t4, i3, o3, r3, f4, Pi2.disabled, m4, Oi2.disabled, n4, "clear", s5, a5, d5, _2, p3, v3, u4, c4, h5);
                }
              };
              if (f3 || m2) {
                let i4;
                if (t4.prepareDrawTile(), c3) {
                  const t5 = c3.drapeBufferSize[0], o4 = c3.drapeBufferSize[1];
                  i4 = c3.framebufferCopyTexture, i4 && (!i4 || i4.size[0] === t5 && i4.size[1] === o4) || (i4 && i4.destroy(), i4 = c3.framebufferCopyTexture = new e2.T(n3, new e2.r({ width: t5, height: o4 }), l3.RGBA8)), i4.bind(l3.LINEAR, l3.CLAMP_TO_EDGE), l3.copyTexSubImage2D(l3.TEXTURE_2D, 0, 0, 0, 0, 0, t5, o4);
                }
                f3 && h4(true, false, i4), m2 && h4(false, true, i4);
              }
            } else f3 && v2(true), m2 && v2(false), (f3 || m2) && t4.resetStencilClippingMasks();
          }
        }
      }, hillshade: function(e3, t4, i3, o3, s3) {
        if ("offscreen" !== e3.renderPass && "translucent" !== e3.renderPass) return;
        if (e3.style.disableElevatedTerrain) return;
        const r3 = e3.context, a4 = e3.terrain && e3.terrain.renderingToTexture, [n3, l3] = "translucent" !== e3.renderPass || a4 ? [{}, s3] : e3.stencilConfigForOverlap(s3);
        for (const o4 of l3) {
          const s4 = t4.getTile(o4);
          if (s4.needsHillshadePrepare && "offscreen" === e3.renderPass) Mo(e3, s4, i3);
          else if ("translucent" === e3.renderPass) {
            const t5 = e3.depthModeForSublayer(0, Ai.ReadOnly), r4 = i3.paint.get("hillshade-emissive-strength"), l4 = e3.colorModeForDrapableLayerRenderPass(r4), c3 = a4 && e3.terrain ? e3.terrain.stencilModeForRTTOverlap(o4) : n3[o4.overscaledZ];
            Lo(e3, o4, s4, i3, t5, c3, l4);
          }
        }
        r3.viewport.set([0, 0, e3.width, e3.height]), e3.resetStencilClippingMasks();
      }, raster: function(t4, i3, o3, s3, r3, a4, n3) {
        if ("translucent" !== t4.renderPass) return;
        if (0 === o3.paint.get("raster-opacity")) return;
        const l3 = "globe" === t4.transform.projection.name, c3 = 0 !== o3.paint.get("raster-elevation"), h3 = c3 && l3;
        if (t4.renderElevatedRasterBackface && !h3) return;
        const u4 = t4.context, d3 = u4.gl, _2 = i3.getSource(), p3 = function(t5, i4, o4, s4) {
          const r4 = i4.paint.get("raster-color"), a5 = "raster-array" === t5.type, n4 = [], l4 = i4.paint.get("raster-resampling"), c4 = i4.paint.get("raster-color-mix");
          let h4 = i4.paint.get("raster-color-range");
          const u5 = [c4[0], c4[1], c4[2], 0], d4 = c4[3];
          let _3 = "nearest" === l4 ? s4.NEAREST : s4.LINEAR;
          if (a5 && (n4.push("RASTER_ARRAY"), r4 || n4.push("RASTER_COLOR"), "linear" === l4 && n4.push("RASTER_ARRAY_LINEAR"), _3 = s4.NEAREST, !h4 && t5.rasterLayers)) {
            const e3 = t5.rasterLayers.find(({ id: e4 }) => e4 === i4.sourceLayer);
            e3 && e3.fields && e3.fields.range && (h4 = e3.fields.range);
          }
          if (h4 = h4 || [0, 1], r4) {
            n4.push("RASTER_COLOR"), o4.activeTexture.set(s4.TEXTURE2), i4.updateColorRamp(h4);
            let t6 = i4.colorRampTexture;
            t6 || (t6 = i4.colorRampTexture = new e2.T(o4, i4.colorRamp, s4.RGBA8)), t6.bind(s4.LINEAR, s4.CLAMP_TO_EDGE);
          }
          return { mix: u5, range: h4, offset: d4, defines: n4, resampling: _3 };
        }(_2, o3, u4, d3);
        if (_2 instanceof e2.aD && !r3.length && !l3) return;
        const f3 = o3.paint.get("raster-emissive-strength"), m2 = t4.colorModeForDrapableLayerRenderPass(f3), g4 = t4.terrain && t4.terrain.renderingToTexture, v2 = !t4.options.moving, x2 = "nearest" === o3.paint.get("raster-resampling") ? d3.NEAREST : d3.LINEAR;
        if (_2 instanceof e2.aD && !r3.length && (_2.onNorthPole || _2.onSouthPole)) {
          const e3 = c3 ? t4.stencilModeFor3D() : Pi2.disabled;
          return void Pr(!!_2.onNorthPole, null, t4, i3, o3, f3, p3, Oi2.disabled, e3);
        }
        if (!r3.length) return;
        const [y2, b2] = _2 instanceof e2.aD || g4 ? [{}, r3] : t4.stencilConfigForOverlap(r3), w2 = b2[b2.length - 1].overscaledZ;
        h3 && p3.defines.push("PROJECTION_GLOBE_VIEW"), c3 && p3.defines.push("RENDER_CUTOFF");
        const T3 = (s4, r4, a5) => {
          for (const b3 of s4) {
            const s5 = b3.toUnwrapped(), T4 = i3.getTile(b3);
            if (g4 && (!T4 || !T4.hasData())) continue;
            u4.activeTexture.set(d3.TEXTURE0);
            const E3 = zr(T4, _2, o3, p3);
            if (!E3 || !E3.texture) continue;
            const { texture: S2, mix: C3, offset: I3, tileSize: D2, buffer: R3 } = E3;
            let A3, L3;
            g4 ? (A3 = Ai.disabled, L3 = b3.projMatrix) : c3 ? (A3 = new Ai(d3.LEQUAL, Ai.ReadWrite, t4.depthRangeFor3D), L3 = l3 ? Float32Array.from(t4.transform.expandedFarZProjMatrix) : t4.transform.calculateProjMatrix(s5, v2)) : (A3 = t4.depthModeForSublayer(b3.overscaledZ - w2, 1 === o3.paint.get("raster-opacity") ? Ai.ReadWrite : Ai.ReadOnly, d3.LESS), L3 = t4.transform.calculateProjMatrix(s5, v2));
            const P2 = t4.terrain && g4 ? t4.terrain.stencilModeForRTTOverlap(b3) : y2[b3.overscaledZ], M2 = n3 ? 0 : o3.paint.get("raster-fade-duration");
            T4.registerFadeDuration(M2);
            const z3 = i3.findLoadedParent(b3, 0), O2 = Ss(T4, z3, i3, t4.transform, M2);
            let F3, B4;
            t4.terrain && t4.terrain.prepareDrawTile(), u4.activeTexture.set(d3.TEXTURE0), S2.bind(x2, d3.CLAMP_TO_EDGE), u4.activeTexture.set(d3.TEXTURE1), z3 ? (z3.texture && z3.texture.bind(x2, d3.CLAMP_TO_EDGE), F3 = Math.pow(2, z3.tileID.overscaledZ - T4.tileID.overscaledZ), B4 = [T4.tileID.canonical.x * F3 % 1, T4.tileID.canonical.y * F3 % 1]) : S2.bind(x2, d3.CLAMP_TO_EDGE), S2.useMipmap && u4.extTextureFilterAnisotropic && t4.transform.pitch > 20 && d3.texParameterf(d3.TEXTURE_2D, u4.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, u4.extTextureFilterAnisotropicMax);
            const k2 = t4.transform;
            let N2;
            const U3 = c3 ? Mr2(k2) : [0, 0, 0, 0];
            let G2, V3, j2, H4, Z3, q2 = 0;
            if (h3 && _2 instanceof e2.aD && _2.coordinates.length > 3) G2 = Float32Array.from(e2.b6(e2.cC(new e2.bQ(0, 0, 0)))), V3 = Float32Array.from(k2.globeMatrix), j2 = Float32Array.from(e2.cy(k2)), H4 = [e2.am(k2.center.lng), e2.at(k2.center.lat)], N2 = _2.elevatedGlobePerspectiveTransform, Z3 = _2.elevatedGlobeGridMatrix || new Float32Array(9);
            else if (h3) {
              const t5 = e2.cz(b3.canonical);
              q2 = e2.cA(t5.getCenter().lat), G2 = Float32Array.from(e2.b6(e2.cC(b3.canonical))), V3 = Float32Array.from(k2.globeMatrix), j2 = Float32Array.from(e2.cy(k2)), H4 = [e2.am(k2.center.lng), e2.at(k2.center.lat)], N2 = [0, 0], Z3 = Float32Array.from(e2.cB(b3.canonical, t5, q2, k2.worldSize / k2._pixelsPerMercatorPixel));
            } else N2 = _2 instanceof e2.aD ? _2.perspectiveTransform : [0, 0], G2 = new Float32Array(16), V3 = new Float32Array(9), j2 = new Float32Array(16), H4 = [0, 0], Z3 = new Float32Array(9);
            const W2 = Js(L3, G2, V3, j2, Z3, B4 || [0, 0], e2.a9(t4.transform.zoom), H4, U3, F3 || 1, O2, o3, N2, c3 ? o3.paint.get("raster-elevation") : 0, 2, C3, I3, p3.range, D2, R3, f3), $3 = t4.isTileAffectedByFog(b3), X2 = t4.getOrCreateProgram("raster", { defines: p3.defines, overrideFog: $3 });
            if (t4.uploadCommonUniforms(u4, X2, s5), _2 instanceof e2.aD) {
              const i4 = _2.elevatedGlobeVertexBuffer, s6 = _2.elevatedGlobeIndexBuffer;
              if (g4 || !l3) _2.boundsBuffer && _2.boundsSegments && X2.draw(t4, d3.TRIANGLES, A3, Pi2.disabled, m2, Oi2.disabled, W2, o3.id, _2.boundsBuffer, t4.quadTriangleIndexBuffer, _2.boundsSegments);
              else if (i4 && s6) {
                const a6 = k2.zoom <= e2.c3 ? _2.elevatedGlobeSegments : _2.getSegmentsForLongitude(k2.center.lng);
                a6 && X2.draw(t4, d3.TRIANGLES, A3, Pi2.disabled, m2, r4, W2, o3.id, i4, s6, a6);
              }
            } else if (h3) {
              A3 = new Ai(d3.LEQUAL, Ai.ReadOnly, t4.depthRangeFor3D);
              const e3 = t4.globeSharedBuffers;
              if (e3) {
                const [i4, s6, n4] = e3.getGridBuffers(q2, false);
                X2.draw(t4, d3.TRIANGLES, A3, a5 || P2, t4.colorModeForRenderPass(), r4, W2, o3.id, i4, s6, n4);
              }
            } else {
              const { tileBoundsBuffer: e3, tileBoundsIndexBuffer: i4, tileBoundsSegments: s6 } = t4.getTileBoundsBuffers(T4);
              X2.draw(t4, d3.TRIANGLES, A3, P2, m2, Oi2.disabled, W2, o3.id, e3, i4, s6);
            }
          }
          if (!(_2 instanceof e2.aD) && h3) for (const e3 of s4) {
            const s5 = e3.canonical.y === (1 << e3.canonical.z) - 1;
            0 === e3.canonical.y && Pr(true, e3, t4, i3, o3, f3, p3, r4, a5 || Pi2.disabled), s5 && Pr(false, e3, t4, i3, o3, f3, p3, r4 === Oi2.frontCW ? Oi2.backCW : Oi2.frontCW, a5 || Pi2.disabled);
          }
        };
        h3 ? T3(b2, t4.renderElevatedRasterBackface ? Oi2.backCW : Oi2.frontCW, t4.stencilModeFor3D()) : T3(b2, Oi2.disabled, void 0), t4.resetStencilClippingMasks();
      }, "raster-particle": function(t4, i3, o3, s3, r3, a4, n3) {
        "offscreen" === t4.renderPass && function(t5, i4, o4, s4) {
          if (!s4.length) return;
          const r4 = t5.context, a5 = r4.gl, n4 = i4.getSource();
          if (!(n4 instanceof Ke)) return;
          const l3 = Math.ceil(Math.sqrt(o4.paint.get("raster-particle-count")));
          let c3 = o4.particlePositionRGBAImage;
          if (!c3 || c3.width !== l3) {
            const t6 = function(e3) {
              const t7 = e3 * e3, i5 = new Uint8Array(4 * t7), o5 = function(e4) {
                return e4 |= 0, e4 = Math.imul(2747636419 ^ e4, 2654435769), e4 = Math.imul(e4 ^ e4 >>> 16, 2654435769), ((e4 = Math.imul(e4 ^ e4 >>> 16, 2654435769)) >>> 0) / 4294967296;
              }, s5 = 1 / 1.1;
              for (let e4 = 0; e4 < t7; e4++) {
                const t8 = s5 * (o5(2 * e4 + 0) + Ys), r5 = s5 * (o5(2 * e4 + 1) + Ys), a6 = 255 * t8 % 1, n5 = 255 * r5 % 1, l4 = a6, c4 = r5 - n5 / 255, h4 = n5;
                i5[4 * e4 + 0] = 255 * (t8 - a6 / 255), i5[4 * e4 + 1] = 255 * l4, i5[4 * e4 + 2] = 255 * c4, i5[4 * e4 + 3] = 255 * h4;
              }
              return i5;
            }(l3);
            c3 = o4.particlePositionRGBAImage = new e2.r({ width: l3, height: l3 }, t6);
          }
          let h3 = o4.particleFramebuffer;
          h3 ? h3.width !== l3 && (h3.destroy(), h3 = o4.particleFramebuffer = r4.createFramebuffer(l3, l3, true, null)) : h3 = o4.particleFramebuffer = r4.createFramebuffer(l3, l3, true, null);
          const u4 = [];
          for (const e3 of s4) {
            const t6 = i4.getTile(e3);
            if (!(t6 instanceof pt2)) continue;
            const s5 = Br(t6, n4, o4);
            if (!s5) continue;
            const a6 = [t6.tileSize, t6.tileSize];
            let h4 = o4.tileFramebuffer;
            h4 || (h4 = o4.tileFramebuffer = r4.createFramebuffer(a6[0], a6[1], true, null));
            let d4 = t6.rasterParticleState;
            d4 || (d4 = t6.rasterParticleState = new Fr(r4, e3, a6, c3));
            const _3 = d4.update(o4.lastInvalidatedAt);
            d4.particleTextureDimension !== l3 && d4.updateParticleTexture(e3, c3);
            const p3 = d4.targetColorTexture;
            d4.targetColorTexture = d4.backgroundColorTexture, d4.backgroundColorTexture = p3;
            const f3 = d4.particleTexture0;
            d4.particleTexture0 = d4.particleTexture1, d4.particleTexture1 = f3, u4.push([e3, s5, d4, _3]);
          }
          if (0 === u4.length) return;
          const d3 = e2.e.now(), _2 = o4.previousDrawTimestamp ? 1e-3 * (d3 - o4.previousDrawTimestamp) : 0.0167;
          if (o4.previousDrawTimestamp = d3, o4.hasColorMap()) {
            r4.activeTexture.set(a5.TEXTURE0 + 2);
            let t6 = o4.colorRampTexture;
            t6 || (t6 = o4.colorRampTexture = new e2.T(r4, o4.colorRamp, a5.RGBA8)), t6.bind(a5.LINEAR, a5.CLAMP_TO_EDGE);
          }
          r4.bindFramebuffer.set(o4.tileFramebuffer.framebuffer), function(t6, i5, o5) {
            const s5 = t6.context, r5 = s5.gl, a6 = i5.tileFramebuffer;
            s5.activeTexture.set(r5.TEXTURE0);
            const n5 = { u_texture: 0, u_opacity: 1.05 * (c4 = i5.paint.get("raster-particle-fade-opacity-factor")) / (c4 + 0.05) }, l4 = t6.getOrCreateProgram("rasterParticleTexture", { defines: [], overrideFog: false });
            var c4;
            for (const c5 of o5) {
              const [, , o6, h4] = c5;
              a6.colorAttachment.set(o6.targetColorTexture.texture), s5.viewport.set([0, 0, a6.width, a6.height]), s5.clear({ color: e2.bA.transparent }), h4 && (o6.backgroundColorTexture.bind(r5.NEAREST, r5.CLAMP_TO_EDGE), l4.draw(t6, r5.TRIANGLES, Ai.disabled, Pi2.disabled, Ri.alphaBlended, Oi2.disabled, n5, i5.id, t6.viewportBuffer, t6.quadTriangleIndexBuffer, t6.viewportSegments));
            }
          }(t5, o4, u4), function(t6, i5, o5, s5) {
            const r5 = t6.context, a6 = r5.gl, n5 = o5.tileFramebuffer, l4 = "globe" === t6.transform.projection.name, c4 = o5.paint.get("raster-particle-max-speed");
            for (const h4 of s5) {
              const [s6, u5, d4] = h4;
              r5.activeTexture.set(a6.TEXTURE0 + 0), u5.texture.bind(a6.LINEAR, a6.CLAMP_TO_EDGE), n5.colorAttachment.set(d4.targetColorTexture.texture);
              const _3 = t6.getOrCreateProgram("rasterParticleDraw", { defines: u5.defines, overrideFog: false });
              r5.activeTexture.set(a6.TEXTURE0 + 1);
              const p3 = u5.scalarData ? [] : [0, 1, 2, 3].map((t7) => e2.c$[t7](s6));
              p3.push(s6);
              const f3 = s6.canonical.x, m2 = s6.canonical.y;
              for (const e3 of p3) {
                const r6 = i5.getTile(l4 ? e3.wrapped() : e3);
                if (!r6) continue;
                const n6 = r6.rasterParticleState;
                if (!n6) continue;
                const h5 = e3.canonical.x + (1 << e3.canonical.z) * (e3.wrap - s6.wrap), d5 = e3.canonical.y;
                n6.particleTexture0.bind(a6.NEAREST, a6.CLAMP_TO_EDGE);
                const p4 = er(1, n6.particleTexture0.size[0], [h5 - f3, d5 - m2], 0, u5.texture.size, 2, c4, u5.textureOffset, u5.scale, u5.offset);
                _3.draw(t6, a6.POINTS, Ai.disabled, Pi2.disabled, Ri.alphaBlended, Oi2.disabled, p4, o5.id, n6.particleIndexBuffer, void 0, n6.particleSegment);
              }
            }
          }(t5, i4, o4, u4), r4.bindFramebuffer.set(o4.particleFramebuffer.framebuffer), function(t6, i5, o5, s5) {
            const r5 = t6.context, a6 = r5.gl, n5 = i5.paint.get("raster-particle-max-speed"), l4 = s5 * i5.paint.get("raster-particle-speed-factor") * 0.15, c4 = function(e3) {
              return Math.pow(e3, 6);
            }(0.01 + 1 * i5.paint.get("raster-particle-reset-rate-factor")), h4 = i5.particleFramebuffer;
            r5.viewport.set([0, 0, h4.width, h4.height]);
            for (const s6 of o5) {
              const [, o6, u5] = s6;
              r5.activeTexture.set(a6.TEXTURE0 + 0), o6.texture.bind(a6.LINEAR, a6.CLAMP_TO_EDGE), r5.activeTexture.set(a6.TEXTURE0 + 1);
              const d4 = u5.particleTexture0;
              d4.bind(a6.NEAREST, a6.CLAMP_TO_EDGE);
              const _3 = tr(1, d4.size[0], 0, o6.texture.size, n5, l4, c4, o6.textureOffset, o6.scale, o6.offset);
              h4.colorAttachment.set(u5.particleTexture1.texture), r5.clear({ color: e2.bA.transparent }), t6.getOrCreateProgram("rasterParticleUpdate", { defines: o6.defines }).draw(t6, a6.TRIANGLES, Ai.disabled, Pi2.disabled, Ri.unblended, Oi2.disabled, _3, i5.id, t6.viewportBuffer, t6.quadTriangleIndexBuffer, t6.viewportSegments);
            }
          }(t5, o4, u4, _2);
        }(t4, i3, o3, r3), "translucent" === t4.renderPass && (function(t5, i4, o4, s4, r4) {
          const a5 = t5.context, n4 = a5.gl, l3 = i4.getSource().tileSize, c3 = 5 * (1 - e2.a7(e2.bV, e2.bV + 1, t5.transform.zoom)) * l3 + o4.paint.get("raster-particle-elevation"), h3 = !t5.options.moving, u4 = "globe" === t5.transform.projection.name;
          if (!s4.length) return;
          const [d3, _2] = t5.stencilConfigForOverlap(s4), p3 = [];
          u4 && p3.push("PROJECTION_GLOBE_VIEW");
          const f3 = t5.stencilModeFor3D();
          for (const s5 of _2) {
            const r5 = s5.toUnwrapped(), l4 = i4.getTile(s5);
            if (!l4.rasterParticleState) continue;
            const _3 = l4.rasterParticleState, m2 = 100;
            l4.registerFadeDuration(m2);
            const g4 = i4.findLoadedParent(s5, 0), v2 = Ss(l4, g4, i4, t5.transform, m2);
            let x2, y2;
            t5.terrain && t5.terrain.prepareDrawTile(), a5.activeTexture.set(n4.TEXTURE0), _3.targetColorTexture.bind(n4.LINEAR, n4.CLAMP_TO_EDGE), a5.activeTexture.set(n4.TEXTURE1), g4 && g4.rasterParticleState ? (g4.rasterParticleState.targetColorTexture.bind(n4.LINEAR, n4.CLAMP_TO_EDGE), x2 = Math.pow(2, g4.tileID.overscaledZ - l4.tileID.overscaledZ), y2 = [l4.tileID.canonical.x * x2 % 1, l4.tileID.canonical.y * x2 % 1]) : _3.targetColorTexture.bind(n4.LINEAR, n4.CLAMP_TO_EDGE);
            const b2 = u4 ? Float32Array.from(t5.transform.expandedFarZProjMatrix) : t5.transform.calculateProjMatrix(r5, h3), w2 = t5.transform, T3 = kr(w2), E3 = e2.cz(s5.canonical), S2 = e2.cA(E3.getCenter().lat);
            let C3, I3, D2, R3, A3;
            u4 ? (C3 = Float32Array.from(e2.b6(e2.cC(s5.canonical))), I3 = Float32Array.from(w2.globeMatrix), D2 = Float32Array.from(e2.cy(w2)), R3 = [e2.am(w2.center.lng), e2.at(w2.center.lat)], A3 = Float32Array.from(e2.cB(s5.canonical, E3, S2, w2.worldSize / w2._pixelsPerMercatorPixel))) : (C3 = new Float32Array(16), I3 = new Float32Array(9), D2 = new Float32Array(16), R3 = [0, 0], A3 = new Float32Array(9));
            const L3 = Qs(b2, C3, I3, D2, A3, y2 || [0, 0], e2.a9(t5.transform.zoom), R3, T3, x2 || 1, v2, c3), P2 = t5.isTileAffectedByFog(s5), M2 = t5.getOrCreateProgram("rasterParticle", { defines: p3, overrideFog: P2 });
            if (t5.uploadCommonUniforms(a5, M2, r5), u4) {
              const e3 = new Ai(n4.LEQUAL, Ai.ReadOnly, t5.depthRangeFor3D), i5 = 0, s6 = t5.globeSharedBuffers;
              if (s6) {
                const [r6, a6, l5] = s6.getGridBuffers(S2, 0 !== i5);
                M2.draw(t5, n4.TRIANGLES, e3, f3, Ri.alphaBlended, t5.renderElevatedRasterBackface ? Oi2.frontCCW : Oi2.backCCW, L3, o4.id, r6, a6, l5);
              }
            } else {
              const e3 = t5.depthModeForSublayer(0, Ai.ReadOnly), i5 = d3[s5.overscaledZ], { tileBoundsBuffer: r6, tileBoundsIndexBuffer: a6, tileBoundsSegments: c4 } = t5.getTileBoundsBuffers(l4);
              M2.draw(t5, n4.TRIANGLES, e3, i5, Ri.alphaBlended, Oi2.disabled, L3, o4.id, r6, a6, c4);
            }
          }
          t5.resetStencilClippingMasks();
        }(t4, i3, o3, r3), t4.style.map.triggerRepaint());
      }, background: function(t4, i3, o3, s3, r3) {
        const a4 = o3.paint.get("background-color"), n3 = o3.paint.get("background-opacity"), l3 = o3.paint.get("background-emissive-strength"), c3 = "viewport" === o3.paint.get("background-pitch-alignment");
        if (0 === n3) return;
        const h3 = t4.context, u4 = h3.gl, d3 = t4.transform, _2 = d3.tileSize, p3 = o3.paint.get("background-pattern");
        let f3;
        if (void 0 !== p3) {
          if (null === p3) return;
          if (f3 = t4.imageManager.getPattern(p3.toString(), o3.scope, t4.style.getLut(o3.scope)), !f3) return;
        }
        const m2 = !p3 && 1 === a4.a && 1 === n3 && t4.opaquePassEnabledForLayer() ? "opaque" : "translucent";
        if (t4.renderPass !== m2) return;
        const g4 = Pi2.disabled, v2 = t4.depthModeForSublayer(0, "opaque" === m2 ? Ai.ReadWrite : Ai.ReadOnly), x2 = t4.colorModeForDrapableLayerRenderPass(l3), y2 = p3 ? "backgroundPattern" : "background";
        let b2, w2 = r3;
        if (w2 || (b2 = t4.getBackgroundTiles(), w2 = Object.values(b2).map((e3) => e3.tileID)), p3 && (h3.activeTexture.set(u4.TEXTURE0), t4.imageManager.bind(t4.context, o3.scope)), c3) {
          const i4 = t4.getOrCreateProgram(y2, { overrideFog: false, overrideRtt: true }), s4 = new Float32Array(e2.a6.mat4.identity([])), r4 = new e2.aA(0, 0, 0, 0, 0), h4 = p3 ? rr(s4, l3, n3, t4, 0, o3.scope, f3, c3, { tileID: r4, tileSize: _2 }) : sr(s4, l3, n3, a4.toRenderColor(o3.lut));
          i4.draw(t4, u4.TRIANGLES, v2, g4, x2, Oi2.disabled, h4, o3.id, t4.viewportBuffer, t4.quadTriangleIndexBuffer, t4.viewportSegments);
        } else for (const e3 of w2) {
          const s4 = t4.isTileAffectedByFog(e3), m3 = t4.getOrCreateProgram(y2, { overrideFog: s4 }), w3 = e3.toUnwrapped(), T3 = r3 ? e3.projMatrix : t4.transform.calculateProjMatrix(w3);
          t4.prepareDrawTile();
          const E3 = i3 ? i3.getTile(e3) : b2 ? b2[e3.key] : new _t(e3, _2, d3.zoom, t4), S2 = p3 ? rr(T3, l3, n3, t4, 0, o3.scope, f3, c3, { tileID: e3, tileSize: _2 }) : sr(T3, l3, n3, a4.toRenderColor(o3.lut));
          t4.uploadCommonUniforms(h3, m3, w3);
          const { tileBoundsBuffer: C3, tileBoundsIndexBuffer: I3, tileBoundsSegments: D2 } = t4.getTileBoundsBuffers(E3);
          m3.draw(t4, u4.TRIANGLES, v2, g4, x2, Oi2.disabled, S2, o3.id, C3, I3, D2);
        }
      }, sky: function(t4, i3, o3, s3) {
        const r3 = t4._atmosphere ? e2.a9(t4.transform.zoom) : 1, a4 = o3.paint.get("sky-opacity") * r3;
        if (0 === a4) return;
        const n3 = t4.context, l3 = o3.paint.get("sky-type"), c3 = new Ai(n3.gl.LEQUAL, Ai.ReadOnly, [0, 1]), h3 = t4.frameCounter / 1e3 % 1;
        "atmosphere" === l3 ? "offscreen" === t4.renderPass ? o3.needsSkyboxCapture(t4) && (function(t5, i4, o4, s4) {
          const r4 = t5.context, a5 = r4.gl;
          let n4 = i4.skyboxFbo;
          if (!n4) {
            n4 = i4.skyboxFbo = r4.createFramebuffer(32, 32, true, null), i4.skyboxGeometry = new Kr(r4), i4.skyboxTexture = r4.gl.createTexture(), a5.bindTexture(a5.TEXTURE_CUBE_MAP, i4.skyboxTexture), a5.texParameteri(a5.TEXTURE_CUBE_MAP, a5.TEXTURE_WRAP_S, a5.CLAMP_TO_EDGE), a5.texParameteri(a5.TEXTURE_CUBE_MAP, a5.TEXTURE_WRAP_T, a5.CLAMP_TO_EDGE), a5.texParameteri(a5.TEXTURE_CUBE_MAP, a5.TEXTURE_MIN_FILTER, a5.LINEAR), a5.texParameteri(a5.TEXTURE_CUBE_MAP, a5.TEXTURE_MAG_FILTER, a5.LINEAR);
            for (let e3 = 0; e3 < 6; ++e3) a5.texImage2D(a5.TEXTURE_CUBE_MAP_POSITIVE_X + e3, 0, a5.RGBA, 32, 32, 0, a5.RGBA, a5.UNSIGNED_BYTE, null);
          }
          r4.bindFramebuffer.set(n4.framebuffer), r4.viewport.set([0, 0, 32, 32]);
          const l4 = i4.getCenter(t5, true), c4 = t5.getOrCreateProgram("skyboxCapture"), h4 = new Float64Array(16);
          e2.a6.mat4.identity(h4), e2.a6.mat4.rotateY(h4, h4, 0.5 * -Math.PI), Yr(t5, i4, c4, h4, l4, 0), e2.a6.mat4.identity(h4), e2.a6.mat4.rotateY(h4, h4, 0.5 * Math.PI), Yr(t5, i4, c4, h4, l4, 1), e2.a6.mat4.identity(h4), e2.a6.mat4.rotateX(h4, h4, 0.5 * -Math.PI), Yr(t5, i4, c4, h4, l4, 2), e2.a6.mat4.identity(h4), e2.a6.mat4.rotateX(h4, h4, 0.5 * Math.PI), Yr(t5, i4, c4, h4, l4, 3), e2.a6.mat4.identity(h4), Yr(t5, i4, c4, h4, l4, 4), e2.a6.mat4.identity(h4), e2.a6.mat4.rotateY(h4, h4, Math.PI), Yr(t5, i4, c4, h4, l4, 5), r4.viewport.set([0, 0, t5.width, t5.height]);
        }(t4, o3), o3.markSkyboxValid(t4)) : "sky" === t4.renderPass && function(e3, t5, i4, o4, s4) {
          const r4 = e3.context, a5 = r4.gl, n4 = e3.transform, l4 = e3.getOrCreateProgram("skybox");
          r4.activeTexture.set(a5.TEXTURE0), a5.bindTexture(a5.TEXTURE_CUBE_MAP, t5.skyboxTexture);
          const c4 = /* @__PURE__ */ ((e4, t6, i5, o5, s5) => ({ u_matrix: e4, u_sun_direction: t6, u_cubemap: 0, u_opacity: o5, u_temporal_offset: s5 }))(n4.skyboxMatrix, t5.getCenter(e3, false), 0, o4, s4);
          e3.uploadCommonUniforms(r4, l4), l4.draw(e3, a5.TRIANGLES, i4, Pi2.disabled, e3.colorModeForRenderPass(), Oi2.backCW, c4, "skybox", t5.skyboxGeometry.vertexBuffer, t5.skyboxGeometry.indexBuffer, t5.skyboxGeometry.segment);
        }(t4, o3, c3, a4, h3) : "gradient" === l3 && "sky" === t4.renderPass && function(t5, i4, o4, s4, r4) {
          const a5 = t5.context, n4 = a5.gl, l4 = t5.transform, c4 = t5.getOrCreateProgram("skyboxGradient");
          i4.skyboxGeometry || (i4.skyboxGeometry = new Kr(a5)), a5.activeTexture.set(n4.TEXTURE0);
          let h4 = i4.colorRampTexture;
          h4 || (h4 = i4.colorRampTexture = new e2.T(a5, i4.colorRamp, n4.RGBA8)), h4.bind(n4.LINEAR, n4.CLAMP_TO_EDGE);
          const u4 = ((t6, i5, o5, s5, r5) => ({ u_matrix: t6, u_color_ramp: 0, u_center_direction: i5, u_radius: e2.bC(o5), u_opacity: s5, u_temporal_offset: r5 }))(l4.skyboxMatrix, i4.getCenter(t5, false), i4.paint.get("sky-gradient-radius"), s4, r4);
          t5.uploadCommonUniforms(a5, c4), c4.draw(t5, n4.TRIANGLES, o4, Pi2.disabled, t5.colorModeForRenderPass(), Oi2.backCW, u4, "skyboxGradient", i4.skyboxGeometry.vertexBuffer, i4.skyboxGeometry.indexBuffer, i4.skyboxGeometry.segment);
        }(t4, o3, c3, a4, h3);
      }, debug: function(t4, i3, o3, s3, r3, a4) {
        for (let n3 = 0; n3 < o3.length; n3++) if (r3) {
          const r4 = 1, l3 = 0.8, c3 = new e2.bA(s3.r * l3, s3.g * l3, s3.b * l3, 1);
          Hr(t4, i3, o3[n3], s3, -r4, -r4, a4), Hr(t4, i3, o3[n3], s3, -r4, r4, a4), Hr(t4, i3, o3[n3], s3, r4, r4, a4), Hr(t4, i3, o3[n3], s3, r4, -r4, a4), Hr(t4, i3, o3[n3], c3, 0, 0, a4);
        } else Hr(t4, i3, o3[n3], s3, 0, 0, a4);
      }, custom: function(t4, i3, o3, s3, r3, a4) {
        const n3 = t4.context, l3 = o3.implementation;
        if (!t4.transform.projection.unsupportedLayers || !t4.transform.projection.unsupportedLayers.includes("custom") || t4.terrain && (t4.terrain.renderingToTexture || "offscreen" === t4.renderPass) && o3.isDraped(i3)) {
          if ("offscreen" === t4.renderPass) {
            const i4 = l3.prerender;
            if (i4) {
              if (t4.setCustomLayerDefaults(), n3.setColorMode(t4.colorModeForRenderPass()), "globe" === t4.transform.projection.name) {
                const o4 = t4.transform.pointMerc;
                i4.call(l3, n3.gl, t4.transform.customLayerMatrix(), t4.transform.getProjection(), t4.transform.globeToMercatorMatrix(), e2.a9(t4.transform.zoom), [o4.x, o4.y], t4.transform.pixelsPerMeterRatio);
              } else i4.call(l3, n3.gl, t4.transform.customLayerMatrix());
              n3.setDirty(), t4.setBaseState();
            }
          } else if ("translucent" === t4.renderPass) {
            if (t4.terrain && t4.terrain.renderingToTexture) {
              const i5 = l3.renderToTile;
              if (i5) {
                const o4 = r3[0].canonical, s4 = new e2.a5(o4.x + r3[0].wrap * (1 << o4.z), o4.y, o4.z);
                n3.setDepthMode(Ai.disabled), n3.setStencilMode(Pi2.disabled), n3.setColorMode(t4.colorModeForRenderPass()), t4.setCustomLayerDefaults(), i5.call(l3, n3.gl, s4), n3.setDirty(), t4.setBaseState();
              }
              return;
            }
            t4.setCustomLayerDefaults(), n3.setColorMode(t4.colorModeForRenderPass()), n3.setStencilMode(Pi2.disabled);
            const i4 = "3d" === l3.renderingMode ? new Ai(t4.context.gl.LEQUAL, Ai.ReadWrite, a4) : t4.depthModeForSublayer(0, Ai.ReadOnly);
            if (n3.setDepthMode(i4), "globe" === t4.transform.projection.name) {
              const i5 = t4.transform.pointMerc;
              l3.render(n3.gl, t4.transform.customLayerMatrix(), t4.renderPass, s3, t4.transform.getProjection(), t4.transform.globeToMercatorMatrix(), e2.a9(t4.transform.zoom), [i5.x, i5.y], t4.transform.pixelsPerMeterRatio);
            } else l3.render(n3.gl, t4.transform.customLayerMatrix(), t4.renderPass, s3);
            n3.setDirty(), t4.setBaseState(), n3.bindFramebuffer.set(null);
          }
        } else e2.w("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
      }, model: function(t4, i3, o3, s3, r3) {
        if ("opaque" === t4.renderPass) return;
        const a4 = o3.paint.get("model-opacity");
        if (0 === a4) return;
        const n3 = o3.paint.get("model-cast-shadows");
        if ("shadow" === t4.renderPass) {
          if (!n3) return;
          if (t4.terrain && a4 < 0.65 && o3._transitionablePaint._values["model-opacity"].value.expression instanceof e2.a4) return;
        }
        const l3 = t4.shadowRenderer, c3 = o3.paint.get("model-receive-shadows");
        l3 && (l3.useNormalOffset = true, c3 || (l3.enabled = false));
        const h3 = () => {
          l3 && (l3.useNormalOffset = true, c3 || (l3.enabled = true));
        }, u4 = i3.getSource();
        if ("light-beam" === t4.renderPass && "batched-model" !== u4.type) return;
        if ("vector" === u4.type || "geojson" === u4.type) return function(t5, i4, o4, s4, r4) {
          const a5 = t5.transform;
          if ("mercator" !== a5.projection.name) return void e2.w(`Drawing 3D models for ${a5.projection.name} projection is not yet implemented`);
          const n4 = a5.getFreeCameraOptions().position;
          if (!t5.modelManager) return;
          const l4 = t5.modelManager;
          o4.modelManager = l4;
          const c4 = t5.shadowRenderer;
          if (!o4._unevaluatedLayout._values.hasOwnProperty("model-id")) return;
          const h4 = o4._unevaluatedLayout._values["model-id"], u5 = { ...o4.layout.get("model-id").parameters }, d4 = t5.style.order.indexOf(o4.fqid);
          for (const _3 of s4) {
            const s5 = i4.getTile(_3).getBucket(o4);
            if (!s5 || s5.projection.name !== a5.projection.name) continue;
            const p4 = s5.getModelUris();
            p4 && !s5.modelsRequested && (l4.addModelsFromBucket(p4, r4), s5.modelsRequested = true);
            const f4 = ua(_3, a5);
            u5.zoom = f4;
            const m3 = h4.possiblyEvaluate(u5);
            if (ca(t5, s5, _3), ha.shadowUniformsInitialized = false, ha.useSingleShadowCascade = !!c4 && 0 === c4.getMaxCascadeForTile(_3.toUnwrapped()), "shadow" === t5.renderPass && c4) {
              if (1 === t5.currentShadowCascade && s5.isInsideFirstShadowMapFrustum) continue;
              const i5 = a5.calculatePosMatrix(_3.toUnwrapped(), a5.worldSize);
              if (ha.tileMatrix.set(i5), ha.shadowTileMatrix = Float32Array.from(c4.calculateShadowPassMatrixFromMatrix(i5)), ha.aabb.min.fill(0), ha.aabb.max[0] = ha.aabb.max[1] = e2.ab, ha.aabb.max[2] = 0, pa(s5, ha, t5, o4.scope)) continue;
            }
            const g5 = 1 << _3.canonical.z, v3 = [((n4.x - _3.wrap) * g5 - _3.canonical.x) * e2.ab, (n4.y * g5 - _3.canonical.y) * e2.ab, n4.z * g5 * e2.ab];
            t5.conflationActive && Object.keys(s5.instancesPerModel).length > 0 && t5.style.isLayerClipped(o4, i4.getSource()) && s5.updateReplacement(_3, t5.replacementSource, d4, r4) && (s5.uploaded = false, s5.upload(t5.context));
            for (let e3 in s5.instancesPerModel) {
              const i5 = s5.instancesPerModel[e3];
              i5.features.length > 0 && (e3 = m3.evaluate(i5.features[0].feature, {}));
              const a6 = l4.getModel(e3, r4);
              if (a6 && a6.uploaded) for (const e4 of a6.nodes) da(t5, o4, e4, i5, v3, _3, ha);
            }
          }
        }(t4, i3, o3, r3, "vector" === u4.type ? o3.scope : ""), void h3();
        if (!u4.loaded()) return;
        if ("batched-model" === u4.type) return function(t5, i4, o4, s4) {
          o4.resetLayerRenderingStats(t5);
          const r4 = t5.context, a5 = t5.transform, n4 = t5.style.fog, l4 = t5.shadowRenderer;
          if ("mercator" !== a5.projection.name) return void e2.w(`Drawing 3D landmark models for ${a5.projection.name} projection is not yet implemented`);
          const c4 = t5.transform.getFreeCameraOptions().position, h4 = e2.a6.vec3.scale([], [c4.x, c4.y, c4.z], t5.transform.worldSize), u5 = e2.a6.vec3.negate([], h4), d4 = e2.a6.mat4.identity([]), _3 = e2.de(a5.center.lat, a5.zoom), p4 = e2.a6.mat4.fromScaling([], [1, 1, 1 / _3]);
          e2.a6.mat4.translate(d4, d4, u5);
          const f4 = o4.paint.get("model-opacity"), m3 = new Ai(r4.gl.LEQUAL, Ai.ReadWrite, t5.depthRangeFor3D), g5 = new Ai(r4.gl.LEQUAL, Ai.ReadOnly, t5.depthRangeFor3D), v3 = new e2.ca([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), x2 = "shadow" === t5.renderPass, y2 = x2 && l4 ? l4.getCurrentCascadeFrustum() : a5.getFrustum(a5.scaleZoom(a5.worldSize)), b2 = o4.paint.get("model-front-cutoff"), w2 = b2[2] < 1, T3 = qi(t5, o4.paint.get("model-cutoff-fade-range")), E3 = o4.getLayerRenderingStats();
          (function(e3, t6, i5, o5) {
            const s5 = e3.terrain ? e3.terrain.exaggeration() : 0, r5 = e3.transform.zoom;
            for (const a6 of o5) {
              const o6 = t6.getTile(a6).getBucket(i5);
              o6 && (e3.conflationActive && o6.updateReplacement(a6, e3.replacementSource), o6.evaluateScale(e3, i5), e3.terrain && s5 > 0 && o6.elevationUpdate(e3.terrain, s5, a6, i5.source), o6.needsReEvaluation(e3, r5, i5) && o6.evaluate(i5));
            }
          })(t5, i4, o4, s4), function() {
            let c5, u6, S2;
            w2 ? (c5 = s4.length - 1, u6 = -1, S2 = -1) : (c5 = 0, u6 = s4.length, S2 = 1);
            const C3 = new Float64Array(16), I3 = e2.a6.vec3.create(), D2 = new e2.P(0, 0);
            for (let R3 = c5; R3 !== u6; R3 += S2) {
              const c6 = s4[R3], u7 = i4.getTile(c6).getBucket(o4);
              if (!u7 || !u7.uploaded) continue;
              let S3 = false;
              l4 && (S3 = 0 === l4.getMaxCascadeForTile(c6.toUnwrapped()));
              const A3 = a5.calculatePosMatrix(c6.toUnwrapped(), a5.worldSize), L3 = u7.modelTraits;
              !x2 && w2 && (e2.a6.mat4.invert(C3, A3), e2.a6.vec3.transformMat4(I3, h4, C3), D2.x = I3[0], D2.y = I3[1]);
              const P2 = [];
              for (const i5 of u7.getNodesInfo()) {
                if (i5.hiddenByReplacement) continue;
                if (!i5.node.meshes) continue;
                const o5 = i5.node;
                let s5 = 0;
                t5.terrain && o5.elevation && (s5 = o5.elevation * t5.terrain.exaggeration());
                const r5 = (() => {
                  const t6 = i5.aabb;
                  return v3.min = [...t6.min], v3.max = [...t6.max], v3.min[2] += s5, v3.max[2] += s5, e2.a6.vec3.transformMat4(v3.min, v3.min, A3), e2.a6.vec3.transformMat4(v3.max, v3.max, A3), v3;
                })(), n5 = i5.evaluatedScale;
                if (n5[0] <= 1 && n5[1] <= 1 && n5[2] <= 1 && 0 === r5.intersects(y2)) continue;
                if (!x2 && w2) {
                  const t6 = 1 / 6;
                  i5.cameraCollisionOpacity = h4[0] > r5.min[0] && h4[0] < r5.max[0] && h4[1] > r5.min[1] && h4[1] < r5.max[1] && h4[2] * _3 < r5.max[2] && o5.footprint && e2.bv(D2, o5.footprint) ? Math.max(i5.cameraCollisionOpacity - t6, 0) : Math.min(1, i5.cameraCollisionOpacity + t6);
                }
                const l5 = [...A3], c7 = o5.anchor ? o5.anchor[0] : 0, u9 = o5.anchor ? o5.anchor[1] : 0;
                e2.a6.mat4.translate(l5, l5, [c7 * (n5[0] - 1), u9 * (n5[1] - 1), s5]), e2.a6.vec3.exactEquals(n5, e2.dh) || e2.a6.mat4.scale(l5, l5, n5);
                const d5 = e2.a6.mat4.multiply([], l5, o5.matrix), p5 = e2.a6.mat4.multiply([], a5.expandedFarZProjMatrix, d5), m4 = e2.a6.mat4.multiply([], a5.expandedFarZProjMatrix, l5), g6 = e2.a6.vec4.transformMat4([], [c7, u9, s5, 1], p5)[2];
                o5.hidden = false;
                let E4 = f4;
                x2 || (w2 && (E4 *= i5.cameraCollisionOpacity, E4 *= ma(l5, a5, i5.aabb, b2)), E4 *= fa(T3, g6)), 0 !== E4 ? P2.push({ nodeInfo: i5, depth: g6, opacity: E4, wvpForNode: p5, wvpForTile: m4, nodeModelMatrix: d5, tileModelMatrix: l5 }) : o5.hidden = true;
              }
              x2 || P2.sort((e3, t6) => !w2 || 1 === e3.opacity && 1 === t6.opacity ? e3.depth < t6.depth ? -1 : 1 : 1 === e3.opacity ? -1 : 1 === t6.opacity ? 1 : e3.depth > t6.depth ? -1 : 1);
              for (const i5 of P2) {
                const s5 = i5.nodeInfo, c7 = s5.node;
                let h5 = e2.a6.mat4.multiply([], p4, i5.tileModelMatrix);
                e2.a6.mat4.multiply(h5, d4, h5);
                const u9 = e2.a6.mat4.invert([], h5);
                e2.a6.mat4.transpose(u9, u9), e2.a6.mat4.scale(u9, u9, _a2), h5 = e2.a6.mat4.multiply(h5, h5, c7.matrix);
                const _4 = "light-beam" === t5.renderPass, f5 = L3 & e2.dj.HasMapboxMeshFeatures, v4 = f5 ? 0 : s5.evaluatedRMEA[0][2];
                for (let e3 = 0; e3 < c7.meshes.length; ++e3) {
                  const d5 = c7.meshes[e3], p5 = e3 === c7.lightMeshIndex;
                  let y3 = i5.wvpForNode;
                  if (p5) {
                    if (!_4 && !t5.terrain && t5.shadowRenderer) {
                      t5.currentLayer < t5.firstLightBeamLayer && (t5.firstLightBeamLayer = t5.currentLayer);
                      continue;
                    }
                    y3 = i5.wvpForTile;
                  } else if (_4) continue;
                  const b3 = { defines: [] }, w3 = [];
                  if (!x2 && l4 && (l4.useNormalOffset = !!d5.normalBuffer), ra(b3.defines, w3, d5, t5, o4.lut), f5 || b3.defines.push("DIFFUSE_SHADED"), S3 && b3.defines.push("SHADOWS_SINGLE_CASCADE"), E3 && (x2 ? E3.numRenderedVerticesInShadowPass += d5.vertexArray.length : E3.numRenderedVerticesInTransparentPass += d5.vertexArray.length), x2) {
                    la(d5, i5.nodeModelMatrix, t5, o4);
                    continue;
                  }
                  let T4 = null;
                  if (n4) {
                    const e4 = sa(i5.nodeModelMatrix, t5.transform);
                    if (T4 = new Float32Array(e4), "globe" !== a5.projection.name) {
                      const t6 = d5.aabb.min, i6 = d5.aabb.max, [o5, s6] = n4.getOpacityForBounds(e4, t6[0], t6[1], i6[0], i6[1]);
                      b3.overrideFog = o5 >= ze || s6 >= ze;
                    }
                  }
                  const C4 = d5.material;
                  let I4;
                  C4.occlusionTexture && C4.occlusionTexture.offsetScale && (I4 = C4.occlusionTexture.offsetScale, b3.defines.push("OCCLUSION_TEXTURE_TRANSFORM"));
                  const D3 = t5.getOrCreateProgram("model", b3);
                  !x2 && l4 && l4.setupShadowsFromMatrix(i5.tileModelMatrix, D3, l4.useNormalOffset), t5.uploadCommonUniforms(r4, D3, null, T4);
                  const R4 = C4.pbrMetallicRoughness;
                  R4.metallicFactor = 0.9, R4.roughnessFactor = 0.5;
                  const A4 = nr(new Float32Array(y3), new Float32Array(h5), new Float32Array(u9), new Float32Array(c7.matrix), t5, i5.opacity, R4.baseColorFactor.toRenderColor(null), C4.emissiveFactor, R4.metallicFactor, R4.roughnessFactor, C4, v4, o4, [0, 0, 0], I4);
                  !p5 && (s5.hasTranslucentParts || i5.opacity < 1) && D3.draw(t5, r4.gl.TRIANGLES, m3, Pi2.disabled, Ri.disabled, Oi2.backCCW, A4, o4.id, d5.vertexBuffer, d5.indexBuffer, d5.segments, o4.paint, t5.transform.zoom, void 0, w3), D3.draw(t5, r4.gl.TRIANGLES, p5 ? g5 : m3, Pi2.disabled, p5 || i5.opacity < 1 || s5.hasTranslucentParts ? Ri.alphaBlended : Ri.unblended, Oi2.backCCW, A4, o4.id, d5.vertexBuffer, d5.indexBuffer, d5.segments, o4.paint, t5.transform.zoom, void 0, w3);
                }
              }
            }
          }();
        }(t4, i3, o3, r3), void h3();
        if ("model" !== u4.type) return;
        const d3 = u4.getModels(), _2 = [], p3 = t4.transform.getFreeCameraOptions().position, f3 = e2.a6.vec3.scale([], [p3.x, p3.y, p3.z], t4.transform.worldSize);
        e2.a6.vec3.negate(f3, f3);
        const m2 = [], g4 = [];
        let v2 = 0;
        for (const i4 of d3) {
          const s4 = o3.paint.get("model-rotation").constantOr(null), r4 = o3.paint.get("model-scale").constantOr(null), a5 = o3.paint.get("model-translation").constantOr(null);
          i4.computeModelMatrix(t4, s4, r4, a5, true, true, false);
          const n4 = e2.a6.mat4.identity([]), l4 = e2.de(i4.position.lat, t4.transform.zoom), c4 = e2.a6.mat4.fromScaling([], [1, 1, 1 / l4]);
          e2.a6.mat4.translate(n4, n4, f3), _2.push({ zScaleMatrix: c4, negCameraPosMatrix: n4 });
          for (const e3 of i4.nodes) na(t4.transform, e3, i4.matrix, t4.transform.expandedFarZProjMatrix, v2, m2, g4);
          v2++;
        }
        if (m2.sort((e3, t5) => t5.depth - e3.depth), "shadow" !== t4.renderPass) {
          if (1 === a4) for (const e3 of g4) aa(e3, t4, o3, _2[e3.modelIndex], Pi2.disabled, t4.colorModeForRenderPass());
          else {
            for (const e3 of g4) aa(e3, t4, o3, _2[e3.modelIndex], Pi2.disabled, Ri.disabled);
            for (const e3 of g4) aa(e3, t4, o3, _2[e3.modelIndex], t4.stencilModeFor3D(), t4.colorModeForRenderPass());
            t4.resetStencilClippingMasks();
          }
          for (const e3 of m2) aa(e3, t4, o3, _2[e3.modelIndex], Pi2.disabled, t4.colorModeForRenderPass());
          h3();
        } else {
          for (const e3 of g4) la(e3.mesh, e3.nodeModelMatrix, t4, o3);
          for (const e3 of m2) la(e3.mesh, e3.nodeModelMatrix, t4, o3);
          h3();
        }
      } }, wa = { model: function(e3, t4, i3) {
        const o3 = t4.getSource();
        if (!o3.loaded()) return;
        if ("vector" === o3.type || "geojson" === o3.type) return void (i3.modelManager && i3.modelManager.upload(i3, "vector" === o3.type ? e3.scope : ""));
        if ("batched-model" === o3.type) return;
        if ("model" !== o3.type) return;
        const s3 = o3.getModels();
        for (const e4 of s3) e4.upload(i3.context);
      }, raster: function(e3, t4, i3) {
        const o3 = t4.getSource();
        if (!(o3 instanceof Ke && o3.loaded())) return;
        const s3 = e3.sourceLayer || o3.rasterLayerIds && o3.rasterLayerIds[0];
        if (!s3) return;
        const r3 = e3.paint.get("raster-array-band") || o3.getInitialBand(s3);
        if (null == r3) return;
        const a4 = t4.getIds().map((e4) => t4.getTileByID(e4));
        for (const e4 of a4) e4.updateNeeded(s3, r3) && o3.prepareTile(e4, s3, r3);
      }, "raster-particle": function(e3, t4, i3) {
        const o3 = t4.getSource();
        if (!(o3 instanceof Ke && o3.loaded())) return;
        const s3 = e3.sourceLayer || o3.rasterLayerIds && o3.rasterLayerIds[0];
        if (!s3) return;
        const r3 = e3.paint.get("raster-particle-array-band") || o3.getInitialBand(s3);
        if (null == r3) return;
        const a4 = t4.getIds().map((e4) => t4.getTileByID(e4));
        for (const e4 of a4) e4.updateNeeded(s3, r3) && o3.prepareTile(e4, s3, r3);
      } };
      class Ta {
        constructor(t4, i3, o3, s3, r3, a4) {
          this.context = new pr(t4, i3), this.transform = o3, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.tp = r3, this._timeStamp = e2.e.now(), this._averageFPS = 0, this._fpsHistory = [], this._dt = 0, this._debugParams = { forceEnablePrecipitation: false, showTerrainProxyTiles: false, fpsWindow: 30, continousRedraw: false, enabledLayers: {} };
          const n3 = ["fill", "line", "symbol", "circle", "heatmap", "fill-extrusion", "raster", "raster-particle", "hillshade", "model", "background", "sky"];
          for (const e3 of n3) this._debugParams.enabledLayers[e3] = true;
          r3.registerParameter(this._debugParams, ["Terrain"], "showTerrainProxyTiles", {}, () => {
            this.style.map.triggerRepaint();
          }), r3.registerParameter(this._debugParams, ["Precipitation"], "forceEnablePrecipitation"), r3.registerParameter(this._debugParams, ["FPS"], "fpsWindow", { min: 1, max: 100, step: 1 }), r3.registerBinding(this._debugParams, ["FPS"], "continousRedraw", { readonly: true, label: "continuous redraw" }), r3.registerBinding(this, ["FPS"], "_averageFPS", { readonly: true, label: "value" }), r3.registerBinding(this, ["FPS"], "_averageFPS", { readonly: true, label: "graph", view: "graph", min: 0, max: 200 });
          for (const e3 of n3) r3.registerParameter(this._debugParams.enabledLayers, ["Debug", "Layers"], e3);
          this.occlusionParams = new xa(r3), this.setup(), this.numSublayers = gt.maxUnderzooming + gt.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {}, this.conflationActive = false, this.replacementSource = new e2.dl(), this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = false, this._cachedTileFogOpacities = {}, this._shadowRenderer = new Ji(this), this._wireframeDebugCache = new va(), this.renderDefaultNorthPole = true, this.renderDefaultSouthPole = true, this.layersWithOcclusionOpacity = [];
          const l3 = new e2.r({ width: 1, height: 1 }, Uint8Array.of(0, 0, 0, 0));
          this.emptyDepthTexture = new e2.T(this.context, l3, t4.RGBA8), this._clippingActiveLastFrame = false, this.scaleFactor = s3, this.enableOIT = a4;
        }
        updateTerrain(e3, t4) {
          const i3 = !!e3 && !!e3.terrain && this.transform.projection.supportsTerrain;
          if (!(i3 || this._terrain && this._terrain.enabled)) return;
          this._terrain || (this._terrain = new Rs(this, e3));
          const o3 = this._terrain;
          this.transform.elevation = i3 ? o3 : null, o3.update(e3, this.transform, t4), this.transform.elevation && !o3.enabled && (this.transform.elevation = null);
        }
        _updateFog(e3) {
          const t4 = e3.fog;
          if (!t4 || "globe" === this.transform.projection.name || t4.getOpacity(this.transform.pitch) < 1 || t4.properties.get("horizon-blend") < 0.03) return void (this.transform.fogCullDistSq = null);
          const [i3, o3] = t4.getFovAdjustedRange(this.transform._fov);
          if (i3 > o3) return void (this.transform.fogCullDistSq = null);
          const s3 = i3 + 0.78 * (o3 - i3);
          this.transform.fogCullDistSq = s3 * s3;
        }
        get terrain() {
          return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled || this._forceTerrainMode ? this._terrain : null;
        }
        get forceTerrainMode() {
          return this._forceTerrainMode;
        }
        set forceTerrainMode(e3) {
          e3 && !this._terrain && (this._terrain = new Rs(this, this.style)), this._forceTerrainMode = e3;
        }
        get shadowRenderer() {
          return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
        }
        get wireframeDebugCache() {
          return this._wireframeDebugCache;
        }
        resize(t4, i3) {
          if (this.width = t4 * e2.e.devicePixelRatio, this.height = i3 * e2.e.devicePixelRatio, this.context.viewport.set([0, 0, this.width, this.height]), this.style) for (const e3 of this.style.order) this.style._mergedLayers[e3].resize();
        }
        setup() {
          const t4 = this.context, i3 = new e2.a$();
          i3.emplaceBack(0, 0), i3.emplaceBack(e2.ab, 0), i3.emplaceBack(0, e2.ab), i3.emplaceBack(e2.ab, e2.ab), this.tileExtentBuffer = t4.createVertexBuffer(i3, e2.b1.members), this.tileExtentSegments = e2.b2.simpleSegment(0, 0, 4, 2);
          const o3 = new e2.a$();
          o3.emplaceBack(0, 0), o3.emplaceBack(e2.ab, 0), o3.emplaceBack(0, e2.ab), o3.emplaceBack(e2.ab, e2.ab), this.debugBuffer = t4.createVertexBuffer(o3, e2.b1.members), this.debugSegments = e2.b2.simpleSegment(0, 0, 4, 5);
          const s3 = new e2.a$();
          s3.emplaceBack(-1, -1), s3.emplaceBack(1, -1), s3.emplaceBack(-1, 1), s3.emplaceBack(1, 1), this.viewportBuffer = t4.createVertexBuffer(s3, e2.b1.members), this.viewportSegments = e2.b2.simpleSegment(0, 0, 4, 2);
          const r3 = new e2.aO();
          r3.emplaceBack(0, 0, 0, 0), r3.emplaceBack(e2.ab, 0, e2.ab, 0), r3.emplaceBack(0, e2.ab, 0, e2.ab), r3.emplaceBack(e2.ab, e2.ab, e2.ab, e2.ab), this.mercatorBoundsBuffer = t4.createVertexBuffer(r3, e2.b4.members), this.mercatorBoundsSegments = e2.b2.simpleSegment(0, 0, 4, 2);
          const a4 = new e2.aP();
          a4.emplaceBack(0, 1, 2), a4.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t4.createIndexBuffer(a4);
          const n3 = new e2.b0();
          for (const e3 of [0, 1, 3, 2, 0]) n3.emplaceBack(e3);
          this.debugIndexBuffer = t4.createIndexBuffer(n3), this.emptyTexture = new e2.T(t4, new e2.r({ width: 1, height: 1 }, Uint8Array.of(0, 0, 0, 0)), t4.gl.RGBA8), this.identityMat = e2.a6.mat4.create();
          const l3 = this.context.gl;
          this.stencilClearMode = new Pi2({ func: l3.ALWAYS, mask: 0 }, 0, 255, l3.ZERO, l3.ZERO, l3.ZERO), this.loadTimeStamps.push(performance.now());
        }
        getMercatorTileBoundsBuffers() {
          return { tileBoundsBuffer: this.mercatorBoundsBuffer, tileBoundsIndexBuffer: this.quadTriangleIndexBuffer, tileBoundsSegments: this.mercatorBoundsSegments };
        }
        getTileBoundsBuffers(e3) {
          return e3._makeTileBoundsBuffers(this.context, this.transform.projection), e3._tileBoundsBuffer ? { tileBoundsBuffer: e3._tileBoundsBuffer, tileBoundsIndexBuffer: e3._tileBoundsIndexBuffer, tileBoundsSegments: e3._tileBoundsSegments } : this.getMercatorTileBoundsBuffers();
        }
        clearStencil() {
          const e3 = this.context.gl;
          this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.getOrCreateProgram("clippingMask").draw(this, e3.TRIANGLES, Ai.disabled, this.stencilClearMode, Ri.disabled, Oi2.disabled, Es(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
        }
        resetStencilClippingMasks() {
          this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
        }
        _renderTileClippingMasks(e3, t4, i3) {
          if (!t4 || this.currentStencilSource === t4.id || !e3.isTileClipped() || !i3 || 0 === i3.length) return;
          if (this._tileClippingMaskIDs && !this.terrain) {
            let e4 = false;
            for (const t5 of i3) if (void 0 === this._tileClippingMaskIDs[t5.key]) {
              e4 = true;
              break;
            }
            if (!e4) return;
          }
          this.currentStencilSource = t4.id;
          const o3 = this.context, s3 = o3.gl;
          this.nextStencilID + i3.length > 256 && this.clearStencil(), o3.setColorMode(Ri.disabled), o3.setDepthMode(Ai.disabled);
          const r3 = this.getOrCreateProgram("clippingMask");
          this._tileClippingMaskIDs = {};
          for (const e4 of i3) {
            const i4 = t4.getTile(e4), o4 = this._tileClippingMaskIDs[e4.key] = this.nextStencilID++, { tileBoundsBuffer: a4, tileBoundsIndexBuffer: n3, tileBoundsSegments: l3 } = this.getTileBoundsBuffers(i4);
            r3.draw(this, s3.TRIANGLES, Ai.disabled, new Pi2({ func: s3.ALWAYS, mask: 0 }, o4, 255, s3.KEEP, s3.KEEP, s3.REPLACE), Ri.disabled, Oi2.disabled, Es(e4.projMatrix), "$clipping", a4, n3, l3);
          }
        }
        stencilModeFor3D() {
          this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
          const e3 = this.nextStencilID++, t4 = this.context.gl;
          return new Pi2({ func: t4.NOTEQUAL, mask: 255 }, e3, 255, t4.KEEP, t4.KEEP, t4.REPLACE);
        }
        stencilModeForClipping(e3) {
          if (this.terrain) return this.terrain.stencilModeForRTTOverlap(e3);
          const t4 = this.context.gl;
          return new Pi2({ func: t4.EQUAL, mask: 255 }, this._tileClippingMaskIDs[e3.key], 0, t4.KEEP, t4.KEEP, t4.REPLACE);
        }
        stencilConfigForOverlap(e3) {
          const t4 = this.context.gl, i3 = e3.sort((e4, t5) => t5.overscaledZ - e4.overscaledZ), o3 = i3[i3.length - 1].overscaledZ, s3 = i3[0].overscaledZ - o3 + 1;
          if (s3 > 1) {
            this.currentStencilSource = void 0, this.nextStencilID + s3 > 256 && this.clearStencil();
            const e4 = {};
            for (let i4 = 0; i4 < s3; i4++) e4[i4 + o3] = new Pi2({ func: t4.GEQUAL, mask: 255 }, i4 + this.nextStencilID, 255, t4.KEEP, t4.KEEP, t4.REPLACE);
            return this.nextStencilID += s3, [e4, i3];
          }
          return [{ [o3]: Pi2.disabled }, i3];
        }
        colorModeForRenderPass() {
          const t4 = this.context.gl;
          if (this._showOverdrawInspector) {
            const i3 = 1 / 8;
            return new Ri([t4.CONSTANT_COLOR, t4.ONE, t4.CONSTANT_COLOR, t4.ONE], new e2.bA(i3, i3, i3, 0), [true, true, true, true]);
          }
          return "opaque" === this.renderPass ? Ri.unblended : Ri.alphaBlended;
        }
        colorModeForDrapableLayerRenderPass(t4) {
          const i3 = this.context.gl;
          return (() => this.style && this.style.enable3dLights() && this.terrain && this.terrain.renderingToTexture)() && "translucent" === this.renderPass ? new Ri([i3.ONE, i3.ONE_MINUS_SRC_ALPHA, i3.CONSTANT_ALPHA, i3.ONE_MINUS_SRC_ALPHA], new e2.bA(0, 0, 0, void 0 === t4 ? 0 : t4), [true, true, true, true]) : this.colorModeForRenderPass();
        }
        depthModeForSublayer(e3, t4, i3, o3 = false) {
          if (this.depthOcclusion) return new Ai(this.context.gl.GREATER, Ai.ReadOnly, this.depthRangeFor3D);
          if (!this.opaquePassEnabledForLayer() && !o3) return Ai.disabled;
          const s3 = 1 - ((1 + this.currentLayer) * this.numSublayers + e3) * this.depthEpsilon;
          return new Ai(i3 || this.context.gl.LEQUAL, t4, [s3, s3]);
        }
        opaquePassEnabledForLayer() {
          return this.currentLayer < this.opaquePassCutoff;
        }
        blitDepth() {
          const t4 = this.context.gl, i3 = Math.ceil(this.width), o3 = Math.ceil(this.height), s3 = this.context.bindFramebuffer.get(), r3 = t4.getParameter(t4.TEXTURE_BINDING_2D);
          this.depthFBO && this.depthFBO.width === i3 && this.depthFBO.height === o3 || (this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), 0 !== i3 && 0 !== o3 && (this.depthFBO = new _r(this.context, i3, o3, false, "texture"), this.depthTexture = new e2.T(this.context, { width: i3, height: o3, data: null }, t4.DEPTH24_STENCIL8), this.depthFBO.depthAttachment.set(this.depthTexture.texture))), this.context.bindFramebuffer.set(s3), t4.bindTexture(t4.TEXTURE_2D, r3), this.depthFBO && (t4.bindFramebuffer(t4.READ_FRAMEBUFFER, null), t4.bindFramebuffer(t4.DRAW_FRAMEBUFFER, this.depthFBO.framebuffer), t4.blitFramebuffer(0, 0, i3, o3, 0, 0, i3, o3, t4.DEPTH_BUFFER_BIT, t4.NEAREST), t4.bindFramebuffer(t4.FRAMEBUFFER, this.context.bindFramebuffer.current));
        }
        updateAverageFPS() {
          this._fpsHistory.push(0 === this._dt ? 0 : 1e3 / this._dt), this._fpsHistory.length > this._debugParams.fpsWindow && this._fpsHistory.splice(0, this._fpsHistory.length - this._debugParams.fpsWindow), this._averageFPS = Math.round(this._fpsHistory.reduce((e3, t4) => e3 + t4 / this._fpsHistory.length, 0));
        }
        render(t4, i3) {
          const o3 = e2.e.now();
          this._dt = o3 - this._timeStamp, this._timeStamp = o3, this._wireframeDebugCache.update(this.frameCounter), this._debugParams.continousRedraw = t4.map.repaint, this.style = t4, this.options = i3;
          const s3 = this.style._mergedLayers, r3 = this.style._getOrder(!(!this.terrain || !this.terrain.enabled)).filter((e3) => {
            const t5 = s3[e3];
            return !(t5.type in this._debugParams.enabledLayers) || this._debugParams.enabledLayers[t5.type];
          });
          let a4 = false, n3 = false;
          for (const e3 of r3) {
            const t5 = s3[e3];
            "circle" === t5.type && (a4 = true), "symbol" === t5.type && (t5.hasInitialOcclusionOpacityProperties ? n3 = true : a4 = true);
          }
          const l3 = r3.map((e3) => s3[e3]), c3 = this.style._mergedSourceCaches;
          this.imageManager = t4.imageManager, this.modelManager = t4.modelManager, this.symbolFadeChange = t4.placement.symbolFadeChange(e2.e.now()), this.imageManager.beginFrame();
          let h3 = 0, u4 = false;
          for (const e3 in c3) {
            const t5 = c3[e3];
            t5.used && (t5.prepare(this.context), t5.getSource().usedInConflation && ++h3);
          }
          let d3 = false;
          for (const e3 of l3) e3.isHidden(this.transform.zoom) || ("clip" === e3.type && (d3 = true), this.prepareLayer(e3));
          const _2 = {}, p3 = {}, f3 = {}, m2 = {}, g4 = {};
          for (const e3 in c3) {
            const t5 = c3[e3];
            _2[e3] = t5.getVisibleCoordinates(), p3[e3] = _2[e3].slice().reverse(), f3[e3] = t5.getVisibleCoordinates(true).reverse(), m2[e3] = t5.getShadowCasterCoordinates(), g4[e3] = t5.sortCoordinatesByDistance(_2[e3]);
          }
          const v2 = (e3) => {
            const t5 = this.style.getLayerSourceCache(e3);
            return t5 && t5.used ? t5.getSource() : null;
          };
          if (h3 || d3 || this._clippingActiveLastFrame) {
            const t5 = [], i4 = [];
            let o4 = 0;
            for (const e3 of l3) this.isSourceForClippingOrConflation(e3, v2(e3)) && (t5.push(e3), i4.push(o4)), o4++;
            if (t5 && (d3 || t5.length > 1) || this._clippingActiveLastFrame) {
              d3 = false;
              const o5 = [];
              for (let s4 = 0; s4 < t5.length; s4++) {
                const r4 = t5[s4], a5 = i4[s4], n4 = this.style.getLayerSourceCache(r4);
                if (!n4 || !n4.used || !n4.getSource().usedInConflation && "clip" !== r4.type) continue;
                let l4 = e2.dn, c4 = e2.bt.None;
                const h4 = [];
                let u5 = true;
                if ("clip" === r4.type) {
                  l4 = a5;
                  for (const t6 of r4.layout.get("clip-layer-types")) c4 |= "model" === t6 ? e2.bt.Model : "symbol" === t6 ? e2.bt.Symbol : e2.bt.FillExtrusion;
                  for (const e3 of r4.layout.get("clip-layer-scope")) h4.push(e3);
                  r4.isHidden(this.transform.zoom) ? u5 = false : d3 = true;
                }
                u5 && o5.push({ layer: r4.fqid, cache: n4, order: l4, clipMask: c4, clipScope: h4 });
              }
              this.replacementSource.setSources(o5), u4 = true;
            }
          }
          this._clippingActiveLastFrame = d3, u4 || this.replacementSource.clear(), this.conflationActive = u4, this.minCutoffZoom = 0, this.longestCutoffRange = 0, this.opaquePassCutoff = 1 / 0, this._lastOcclusionLayer = -1, this.layersWithOcclusionOpacity = [];
          for (let e3 = 0; e3 < l3.length; e3++) {
            const t5 = l3[e3], i4 = t5.cutoffRange();
            if (this.longestCutoffRange = Math.max(i4, this.longestCutoffRange), i4 > 0) {
              const e4 = v2(t5);
              e4 && (this.minCutoffZoom = Math.max(e4.minzoom, this.minCutoffZoom)), t5.minzoom && (this.minCutoffZoom = Math.max(t5.minzoom, this.minCutoffZoom));
            }
            t5.is3D() && (this.opaquePassCutoff === 1 / 0 && (this.opaquePassCutoff = e3), this._lastOcclusionLayer = e3);
          }
          const x2 = this.style && this.style.fog;
          x2 ? (this._fogVisible = 0 !== x2.getOpacity(this.transform.pitch), this._fogVisible && "globe" !== this.transform.projection.name && (this._fogVisible = x2.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = false, this._cachedTileFogOpacities = {}, this.terrain && (this.terrain.updateTileBinding(f3), this.opaquePassCutoff = 0);
          const y2 = this._shadowRenderer;
          if (y2) {
            y2.updateShadowParameters(this.transform, this.style.directionalLight);
            for (const e3 in c3) for (const t5 of _2[e3]) {
              let e4 = { min: 0, max: 0 };
              this.terrain && (e4 = this.terrain.getMinMaxForTile(t5) || e4), y2.addShadowReceiver(t5.toUnwrapped(), e4.min, e4.max);
            }
          }
          if ("globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new e2.dm(this.context)), this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new oa(this)), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), !U2.has(this.context.gl)) return;
          this.renderPass = "offscreen";
          for (const e3 of l3) {
            const i4 = t4.getLayerSourceCache(e3);
            if (!e3.hasOffscreenPass() || e3.isHidden(this.transform.zoom)) continue;
            const o4 = i4 ? p3[i4.id] : void 0;
            ("custom" === e3.type || "raster" === e3.type || "raster-particle" === e3.type || e3.isSky() || o4 && o4.length) && this.renderLayer(this, i4, e3, "ground", o4);
          }
          this.depthRangeFor3D = [0, 1 - (l3.length + 2) * this.numSublayers * this.depthEpsilon], this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, m2)), this.context.bindFramebuffer.set(null), this.context.viewport.set([0, 0, this.width, this.height]);
          const b2 = "globe" === this.transform.projection.name || this.transform.isHorizonVisible(), w2 = (() => {
            if (i3.showOverdrawInspector) return e2.bA.black;
            const t5 = this.style.fog;
            if (t5 && this.transform.projection.supportsFog) {
              const i4 = this.style.getLut(t5.scope);
              if (!b2) {
                const o4 = t5.properties.get("color").toRenderColor(i4).toArray01();
                return new e2.bA(...o4);
              }
              if (b2) {
                const o4 = t5.properties.get("space-color").toRenderColor(i4).toArray01();
                return new e2.bA(...o4);
              }
            }
            return e2.bA.transparent;
          })();
          function T3(e3, t5) {
            let i4;
            return t5 && (i4 = ("symbol" === e3.type ? f3 : e3.is3D() ? g4 : p3)[t5.id]), i4;
          }
          if (this.context.clear({ color: w2, depth: 1 }), this.clearStencil(), this._showOverdrawInspector = i3.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && b2 && this._atmosphere.drawStars(this, this.style.fog), !this.terrain) {
            if (this.enableOIT) {
              for (this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < r3.length; this.currentLayer++) {
                const e3 = l3[this.currentLayer], i4 = t4.getLayerSourceCache(e3);
                !e3.isSky() && e3.is3D() && this.renderLayer(this, i4, e3, this.transform.isUnderground ? "above" : "under", T3(e3, i4));
              }
              this.renderPass = "opaque";
            }
            for (this.currentLayer = r3.length - 1; this.currentLayer >= 0; this.currentLayer--) {
              const e3 = l3[this.currentLayer], i4 = t4.getLayerSourceCache(e3);
              if (e3.isSky()) continue;
              const o4 = i4 ? (e3.is3D() ? g4 : p3)[i4.id] : void 0;
              this._renderTileClippingMasks(e3, i4, o4), this.renderLayer(this, i4, e3, "ground", o4);
            }
          }
          if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && b2 && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || e2.a9(this.transform.zoom) > 0) && ("globe" === this.transform.projection.name || this.transform.isHorizonVisible())) for (this.currentLayer = 0; this.currentLayer < r3.length; this.currentLayer++) {
            const e3 = l3[this.currentLayer], i4 = t4.getLayerSourceCache(e3);
            e3.isSky() && this.renderLayer(this, i4, e3, "ground", i4 ? p3[i4.id] : void 0);
          }
          if (this.renderPass = "translucent", "globe" === this.transform.projection.name) {
            for (this.renderElevatedRasterBackface = true, this.currentLayer = 0; this.currentLayer < r3.length; ) {
              const e3 = l3[this.currentLayer];
              if ("raster" === e3.type || "raster-particle" === e3.type) {
                const i4 = t4.getLayerSourceCache(e3);
                this.renderLayer(this, i4, e3, "ground", T3(e3, i4));
              }
              ++this.currentLayer;
            }
            this.renderElevatedRasterBackface = false;
          }
          this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER;
          let E3 = 0;
          y2 && (E3 = y2.getShadowCastingLayerCount());
          let S2 = false, C3 = -1;
          for (let e3 = 0; e3 < r3.length; ++e3) {
            const t5 = l3[e3];
            t5.isHidden(this.transform.zoom) || t5.is3D() && (C3 = e3);
          }
          for (n3 && -1 === C3 && (a4 = true); this.currentLayer < r3.length; ) {
            const e3 = l3[this.currentLayer], i4 = t4.getLayerSourceCache(e3);
            if (e3.isSky()) ++this.currentLayer;
            else if (this.terrain && this.style.isLayerDraped(e3)) {
              if (e3.isHidden(this.transform.zoom)) {
                ++this.currentLayer;
                continue;
              }
              this.currentLayer = this.terrain.renderBatch(this.currentLayer), this._lastOcclusionLayer = Math.max(this.currentLayer, this._lastOcclusionLayer);
            } else {
              if (a4 && !S2 && this.terrain && !this.transform.isOrthographic && (S2 = true, this.blitDepth()), n3 && -1 !== C3 && this.currentLayer === C3 + 1 && !this.transform.isOrthographic && this.blitDepth(), e3.is3D() || this.terrain || this._renderTileClippingMasks(e3, i4, i4 ? _2[i4.id] : void 0), e3.is3D() ? this.renderLayer(this, i4, e3, this.transform.isUnderground ? "under" : "above", T3(e3, i4)) : this.renderLayer(this, i4, e3, "ground", T3(e3, i4)), !this.terrain && y2 && E3 > 0 && e3.hasShadowPass() && 0 == --E3 && (y2.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer)) {
                const e4 = this.currentLayer;
                for (this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= e4; this.currentLayer++) {
                  const e5 = l3[this.currentLayer];
                  if (!e5.hasLightBeamPass()) continue;
                  const i5 = t4.getLayerSourceCache(e5);
                  this.renderLayer(this, i5, e5, "ground", i5 ? p3[i5.id] : void 0);
                }
                this.currentLayer = e4, this.renderPass = "translucent";
              }
              if (this.currentLayer >= this._lastOcclusionLayer && this.layersWithOcclusionOpacity.length > 0) {
                const e4 = this.currentLayer;
                this.depthOcclusion = true;
                for (const e5 of this.layersWithOcclusionOpacity) {
                  this.currentLayer = e5;
                  const i5 = l3[this.currentLayer], o4 = t4.getLayerSourceCache(i5), s4 = o4 ? p3[o4.id] : void 0;
                  i5.is3D() || this.terrain || this._renderTileClippingMasks(i5, o4, o4 ? _2[o4.id] : void 0), this.renderLayer(this, o4, i5, "ground", s4);
                }
                this.depthOcclusion = false, this.currentLayer = e4, this.renderPass = "translucent", this.layersWithOcclusionOpacity = [];
              }
              ++this.currentLayer;
            }
          }
          if (this.terrain && this.terrain.postRender(), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
            let i4 = null;
            l3.forEach((e3) => {
              const o4 = t4.getLayerSourceCache(e3);
              o4 && !e3.isHidden(this.transform.zoom) && o4.getVisibleCoordinates().length && (!i4 || i4.getSource().maxzoom < o4.getSource().maxzoom) && (i4 = o4);
            }), i4 && this.options.showTileBoundaries && ba.debug(this, i4, i4.getVisibleCoordinates(), e2.bA.red, false, this.options.showParseStatus);
          }
          this.terrain && this._debugParams.showTerrainProxyTiles && ba.debug(this, this.terrain.proxySourceCache, this.terrain.proxyCoords, new e2.bA(1, 0.8, 0.1, 1), true, this.options.showParseStatus), this.options.showPadding && function(e3) {
            const t5 = e3.transform.padding;
            Zr(e3, e3.transform.height - (t5.top || 0), 3, Nr), Zr(e3, t5.bottom || 0, 3, Ur), qr(e3, t5.left || 0, 3, Gr), qr(e3, e3.transform.width - (t5.right || 0), 3, Vr);
            const i4 = e3.transform.centerPoint;
            !function(e4, t6, i5, o4) {
              Wr(e4, t6 - 1, i5 - 10, 2, 20, o4), Wr(e4, t6 - 10, i5 - 1, 20, 2, o4);
            }(e3, i4.x, e3.transform.height - i4.y, jr);
          }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(performance.now()), this.saveCanvasCopy()), u4 || (this.conflationActive = false);
        }
        prepareLayer(e3) {
          this.gpuTimingStart(e3);
          const { unsupportedLayers: t4 } = this.transform.projection, i3 = !t4 || !t4.includes(e3.type);
          if (wa[e3.type] && (i3 || this.terrain && "custom" === e3.type)) {
            const t5 = this.style.getLayerSourceCache(e3);
            wa[e3.type](e3, t5, this);
          }
          this.gpuTimingEnd();
        }
        renderLayer(e3, t4, i3, o3, s3) {
          !i3.isHidden(this.transform.zoom) && ("background" === i3.type || "sky" === i3.type || "custom" === i3.type || "model" === i3.type || "raster" === i3.type || "raster-particle" === i3.type || s3 && s3.length) && (this.id = i3.id, this.gpuTimingStart(i3), e3.transform.projection.unsupportedLayers && e3.transform.projection.unsupportedLayers.includes(i3.type) && (!e3.terrain || "custom" !== i3.type) || "clip" === i3.type || ("custom" === i3.type && i3.is3D() ? ba[i3.type](e3, t4, i3, o3, s3, e3.transform.isUnderground ? "above" === o3 ? [1 - (this.numSublayers + 1) * this.depthEpsilon, 1] : e3.depthRangeFor3D : "under" === o3 ? [1 - (this.numSublayers + 1) * this.depthEpsilon, 1] : e3.depthRangeFor3D) : ba[i3.type](e3, t4, i3, o3, s3, this.style.placement.variableOffsets, this.options.isInitialLoad)), this.gpuTimingEnd());
        }
        gpuTimingStart(e3) {
          if (!this.options.gpuTiming) return;
          const t4 = this.context.extTimerQuery, i3 = this.context.gl;
          let o3 = this.gpuTimers[e3.id];
          o3 || (o3 = this.gpuTimers[e3.id] = { calls: 0, cpuTime: 0, query: i3.createQuery() }), o3.calls++, i3.beginQuery(t4.TIME_ELAPSED_EXT, o3.query);
        }
        gpuTimingDeferredRenderStart() {
          if (this.options.gpuTimingDeferredRender) {
            const e3 = this.context.extTimerQuery, t4 = this.context.gl, i3 = t4.createQuery();
            this.deferredRenderGpuTimeQueries.push(i3), t4.beginQuery(e3.TIME_ELAPSED_EXT, i3);
          }
        }
        gpuTimingDeferredRenderEnd() {
          this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
        }
        gpuTimingEnd() {
          this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
        }
        collectGpuTimers() {
          const e3 = this.gpuTimers;
          return this.gpuTimers = {}, e3;
        }
        collectDeferredRenderGpuQueries() {
          const e3 = this.deferredRenderGpuTimeQueries;
          return this.deferredRenderGpuTimeQueries = [], e3;
        }
        queryGpuTimers(e3) {
          const t4 = {};
          for (const i3 in e3) {
            const o3 = e3[i3], s3 = this.context.extTimerQuery, r3 = s3.getQueryParameter(o3.query, this.context.gl.QUERY_RESULT) / 1e6;
            s3.deleteQueryEXT(o3.query), t4[i3] = r3;
          }
          return t4;
        }
        queryGpuTimeDeferredRender(e3) {
          if (!this.options.gpuTimingDeferredRender) return 0;
          const t4 = this.context.gl;
          let i3 = 0;
          for (const o3 of e3) i3 += t4.getQueryParameter(o3, t4.QUERY_RESULT) / 1e6, t4.deleteQuery(o3);
          return i3;
        }
        translatePosMatrix(t4, i3, o3, s3, r3) {
          if (!o3[0] && !o3[1]) return t4;
          const a4 = r3 ? "map" === s3 ? this.transform.angle : 0 : "viewport" === s3 ? -this.transform.angle : 0;
          if (a4) {
            const e3 = Math.sin(a4), t5 = Math.cos(a4);
            o3 = [o3[0] * t5 - o3[1] * e3, o3[0] * e3 + o3[1] * t5];
          }
          const n3 = [r3 ? o3[0] : e2.ak(i3, o3[0], this.transform.zoom), r3 ? o3[1] : e2.ak(i3, o3[1], this.transform.zoom), 0], l3 = new Float32Array(16);
          return e2.a6.mat4.translate(l3, t4, n3), l3;
        }
        saveTileTexture(e3) {
          const t4 = e3.size[0], i3 = this._tileTextures[t4];
          i3 ? i3.push(e3) : this._tileTextures[t4] = [e3];
        }
        getTileTexture(e3) {
          const t4 = this._tileTextures[e3];
          return t4 && t4.length > 0 ? t4.pop() : null;
        }
        terrainRenderModeElevated() {
          return this.style && !!this.style.getTerrain() && !!this.terrain && !this.terrain.renderingToTexture || this.forceTerrainMode;
        }
        linearFloatFilteringSupported() {
          return null != this.context.extTextureFloatLinear;
        }
        currentGlobalDefines(e3, t4, i3) {
          const o3 = void 0 === i3 ? this.terrain && this.terrain.renderingToTexture : i3, s3 = [];
          return this.style && this.style.enable3dLights() && ("globeRaster" === e3 || "terrainRaster" === e3 ? (s3.push("LIGHTING_3D_MODE"), s3.push("LIGHTING_3D_ALPHA_EMISSIVENESS")) : o3 || s3.push("LIGHTING_3D_MODE")), "shadow" === this.renderPass && (this._shadowMapDebug || s3.push("DEPTH_TEXTURE")), this.terrainRenderModeElevated() && (s3.push("TERRAIN"), this.linearFloatFilteringSupported() && s3.push("TERRAIN_DEM_FLOAT_FORMAT")), "globe" === this.transform.projection.name && s3.push("GLOBE"), !this._fogVisible || o3 || void 0 !== t4 && !t4 || s3.push("FOG", "FOG_DITHERING"), o3 && s3.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && s3.push("OVERDRAW_INSPECTOR"), s3;
        }
        getOrCreateProgram(e3, t4) {
          this.cache = this.cache || {};
          const i3 = t4 && t4.defines || [], o3 = t4 && t4.config, s3 = this.currentGlobalDefines(e3, t4 && t4.overrideFog, t4 && t4.overrideRtt).concat(i3), r3 = Ms.cacheKey(Co[e3], e3, s3, o3);
          return this.cache[r3] || (this.cache[r3] = new Ms(this.context, e3, Co[e3], o3, cr[e3], s3)), this.cache[r3];
        }
        setCustomLayerDefaults() {
          this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
        }
        setBaseState() {
          const e3 = this.context.gl;
          this.context.cullFace.set(false), this.context.viewport.set([0, 0, this.width, this.height]), this.context.blendEquation.set(e3.FUNC_ADD);
        }
        initDebugOverlayCanvas() {
          null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e2.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA8));
        }
        destroy() {
          this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy(), this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), this.emptyDepthTexture && this.emptyDepthTexture.destroy();
        }
        prepareDrawTile() {
          this.terrain && this.terrain.prepareDrawTile();
        }
        uploadCommonLightUniforms(t4, i3) {
          if (this.style.enable3dLights()) {
            const o3 = this.style.directionalLight, s3 = this.style.ambientLight;
            if (o3 && s3) {
              const r3 = ((t5, i4, o4) => {
                const s4 = t5.properties.get("direction"), r4 = t5.properties.get("color").toRenderColor(o4.getLut(t5.scope)).toArray01(), a4 = t5.properties.get("intensity"), n3 = i4.properties.get("color").toRenderColor(o4.getLut(i4.scope)).toArray01(), l3 = i4.properties.get("intensity"), c3 = [s4.x, s4.y, s4.z], h3 = e2.cH(n3, l3), u4 = e2.cH(r4, a4);
                return { u_lighting_ambient_color: h3, u_lighting_directional_dir: c3, u_lighting_directional_color: u4, u_ground_radiance: As(c3, u4, h3) };
              })(o3, s3, this.style);
              i3.setLightsUniformValues(t4, r3);
            }
          }
        }
        uploadCommonUniforms(t4, i3, o3, s3, r3) {
          if (this.uploadCommonLightUniforms(t4, i3), this.terrain && this.terrain.renderingToTexture) return;
          const a4 = this.style.fog;
          if (a4) {
            const r4 = a4.getOpacity(this.transform.pitch), n3 = ((t5, i4, o4, s4, r5, a5, n4, l3, c3, h3, u4, d3) => {
              const _2 = t5.transform, p3 = i4.properties.get("color").toRenderColor(t5.style.getLut(i4.scope)).toArray01();
              p3[3] = s4;
              const f3 = t5.frameCounter / 1e3 % 1, [m2, g4] = i4.properties.get("vertical-range");
              return { u_fog_matrix: o4 ? _2.calculateFogTileMatrix(o4) : d3 || t5.identityMat, u_fog_range: i4.getFovAdjustedRange(_2._fov), u_fog_color: p3, u_fog_horizon_blend: i4.properties.get("horizon-blend"), u_fog_vertical_limit: [Math.min(m2, g4), g4], u_fog_temporal_offset: f3, u_frustum_tl: r5, u_frustum_tr: a5, u_frustum_br: n4, u_frustum_bl: l3, u_globe_pos: c3, u_globe_radius: h3, u_viewport: u4, u_globe_transition: e2.a9(_2.zoom), u_is_globe: +("globe" === _2.projection.name) };
            })(this, a4, o3, r4, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [this.transform.width * e2.e.devicePixelRatio, this.transform.height * e2.e.devicePixelRatio], s3);
            i3.setFogUniformValues(t4, n3);
          }
          r3 && i3.setCutoffUniformValues(t4, r3.uniformValues);
        }
        setTileLoadedFlag(e3) {
          this.tileLoaded = e3;
        }
        saveCanvasCopy() {
          const e3 = this.canvasCopy();
          e3 && (this.frameCopies.push(e3), this.tileLoaded = false);
        }
        canvasCopy() {
          const e3 = this.context.gl, t4 = e3.createTexture();
          return e3.bindTexture(e3.TEXTURE_2D, t4), e3.copyTexImage2D(e3.TEXTURE_2D, 0, e3.RGBA, 0, 0, e3.drawingBufferWidth, e3.drawingBufferHeight, 0), t4;
        }
        getCanvasCopiesAndTimestamps() {
          return { canvasCopies: this.frameCopies, timeStamps: this.loadTimeStamps };
        }
        averageElevationNeedsEasing() {
          if (!this.transform._elevation) return false;
          const e3 = this.style && this.style.fog;
          return !!e3 && 0 !== e3.getOpacity(this.transform.pitch);
        }
        getBackgroundTiles() {
          const e3 = this._backgroundTiles, t4 = this._backgroundTiles = {}, i3 = this.transform.coveringTiles({ tileSize: 512 });
          for (const o3 of i3) t4[o3.key] = e3[o3.key] || new _t(o3, 512, this.transform.tileZoom, this);
          return t4;
        }
        clearBackgroundTiles() {
          this._backgroundTiles = {};
        }
        isSourceForClippingOrConflation(e3, t4) {
          return !(!e3.is3D() || "clip" !== e3.type && (e3.minzoom && e3.minzoom > this.transform.zoom || (this.style._clipLayerPresent || "building" !== e3.sourceLayer) && (!t4 || "batched-model" !== t4.type)));
        }
        isTileAffectedByFog(e3) {
          if (!this.style || !this.style.fog) return false;
          if ("globe" === this.transform.projection.name) return true;
          let t4 = this._cachedTileFogOpacities[e3.key];
          return t4 || (this._cachedTileFogOpacities[e3.key] = t4 = this.style.fog.getOpacityForTile(e3)), t4[0] >= ze || t4[1] >= ze;
        }
        setupDepthForOcclusion(e3, t4, i3) {
          const o3 = this.context, s3 = o3.gl, r3 = !!i3;
          var a4;
          i3 || (i3 = { u_dem: 2, u_dem_prev: 4, u_dem_tl: [0, 0], u_dem_tl_prev: [0, 0], u_dem_scale: 0, u_dem_scale_prev: 0, u_dem_size: 0, u_dem_lerp: 1, u_depth: 3, u_depth_size_inv: [0, 0], u_depth_range_unpack: [0, 1], u_occluder_half_size: 16, u_occlusion_depth_offset: -1e-4, u_exaggeration: 0 }), o3.activeTexture.set(s3.TEXTURE3), e3 && this.depthFBO && this.depthTexture ? (this.depthTexture.bind(s3.NEAREST, s3.CLAMP_TO_EDGE), i3.u_depth_size_inv = [1 / this.depthFBO.width, 1 / this.depthFBO.height], i3.u_depth_range_unpack = [2 / ((a4 = this.depthRangeFor3D)[1] - a4[0]), -1 - 2 * a4[0] / (a4[1] - a4[0])], i3.u_occluder_half_size = 0.5 * this.occlusionParams.occluderSize, i3.u_occlusion_depth_offset = this.occlusionParams.depthOffset) : this.emptyDepthTexture.bind(s3.NEAREST, s3.CLAMP_TO_EDGE), o3.activeTexture.set(s3.TEXTURE0), r3 || t4.setTerrainUniformValues(o3, i3);
        }
      }
      function Ea(e3, t4) {
        let i3 = false, o3 = null;
        const s3 = () => {
          o3 = null, i3 && (e3(), o3 = setTimeout(s3, t4), i3 = false);
        };
        return () => (i3 = true, o3 || s3(), o3);
      }
      class Sa {
        constructor(t4) {
          this._hashName = t4 && encodeURIComponent(t4), e2.aJ(["_getCurrentHash", "_onHashChange", "_updateHash"], this), this._updateHash = Ea(this._updateHashUnthrottled.bind(this), 300);
        }
        addTo(e3) {
          return this._map = e3, window.addEventListener("hashchange", this._onHashChange, false), e3.on("moveend", this._updateHash), this;
        }
        remove() {
          return this._map ? (this._map.off("moveend", this._updateHash), window.removeEventListener("hashchange", this._onHashChange, false), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
        }
        getHashString() {
          const e3 = this._map;
          if (!e3) return "";
          const t4 = Ca(e3);
          if (this._hashName) {
            const e4 = this._hashName;
            let i3 = false;
            const o3 = location.hash.slice(1).split("&").map((o4) => {
              const s3 = o4.split("=")[0];
              return s3 === e4 ? (i3 = true, `${s3}=${t4}`) : o4;
            }).filter((e5) => e5);
            return i3 || o3.push(`${e4}=${t4}`), `#${o3.join("&")}`;
          }
          return `#${t4}`;
        }
        _getCurrentHash() {
          const e3 = location.hash.replace("#", "");
          if (this._hashName) {
            let t4;
            return e3.split("&").map((e4) => e4.split("=")).forEach((e4) => {
              e4[0] === this._hashName && (t4 = e4);
            }), (t4 && t4[1] || "").split("/");
          }
          return e3.split("/");
        }
        _onHashChange() {
          const e3 = this._map;
          if (!e3) return false;
          const t4 = this._getCurrentHash();
          if (t4.length >= 3 && !t4.some((e4) => isNaN(e4))) {
            const i3 = e3.dragRotate.isEnabled() && e3.touchZoomRotate.isEnabled() ? +(t4[3] || 0) : e3.getBearing();
            return e3.jumpTo({ center: [+t4[2], +t4[1]], zoom: +t4[0], bearing: i3, pitch: +(t4[4] || 0) }), true;
          }
          return false;
        }
        _updateHashUnthrottled() {
          history.replaceState(history.state, "", location.href.replace(/(#.+)?$/, this.getHashString()));
        }
      }
      function Ca(e3, t4) {
        const i3 = e3.getCenter(), o3 = Math.round(100 * e3.getZoom()) / 100, s3 = Math.ceil((o3 * Math.LN2 + Math.log(512 / 360 / 0.5)) / Math.LN10), r3 = Math.pow(10, s3), a4 = Math.round(i3.lng * r3) / r3, n3 = Math.round(i3.lat * r3) / r3, l3 = e3.getBearing(), c3 = e3.getPitch();
        let h3 = t4 ? `/${a4}/${n3}/${o3}` : `${o3}/${n3}/${a4}`;
        return (l3 || c3) && (h3 += "/" + Math.round(10 * l3) / 10), c3 && (h3 += `/${Math.round(c3)}`), h3;
      }
      const Ia = { linearity: 0.3, easing: e2.dp(0, 0, 0.3, 1) }, Da = e2.m({ deceleration: 2500, maxSpeed: 1400 }, Ia), Ra = e2.m({ deceleration: 20, maxSpeed: 1400 }, Ia), Aa = e2.m({ deceleration: 1e3, maxSpeed: 360 }, Ia), La = e2.m({ deceleration: 1e3, maxSpeed: 90 }, Ia);
      class Pa {
        constructor(e3) {
          this._map = e3, this.clear();
        }
        clear() {
          this._inertiaBuffer = [];
        }
        record(t4) {
          this._drainInertiaBuffer(), this._inertiaBuffer.push({ time: e2.e.now(), settings: t4 });
        }
        _drainInertiaBuffer() {
          const t4 = this._inertiaBuffer, i3 = e2.e.now();
          for (; t4.length > 0 && i3 - t4[0].time > 160; ) t4.shift();
        }
        _onMoveEnd(t4) {
          if (this._map._prefersReducedMotion()) return;
          if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
          const i3 = { zoom: 0, bearing: 0, pitch: 0, pan: new e2.P(0, 0), pinchAround: void 0, around: void 0 };
          for (const { settings: e3 } of this._inertiaBuffer) i3.zoom += e3.zoomDelta || 0, i3.bearing += e3.bearingDelta || 0, i3.pitch += e3.pitchDelta || 0, e3.panDelta && i3.pan._add(e3.panDelta), e3.around && (i3.around = e3.around), e3.pinchAround && (i3.pinchAround = e3.pinchAround);
          const o3 = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, s3 = {};
          if (i3.pan.mag()) {
            const r3 = za(i3.pan.mag(), o3, e2.m({}, Da, t4 || {}));
            s3.offset = i3.pan.mult(r3.amount / i3.pan.mag()), s3.center = this._map.transform.center, Ma(s3, r3);
          }
          if (i3.zoom) {
            const e3 = za(i3.zoom, o3, Ra);
            s3.zoom = this._map.transform.zoom + e3.amount, Ma(s3, e3);
          }
          if (i3.bearing) {
            const t5 = za(i3.bearing, o3, Aa);
            s3.bearing = this._map.transform.bearing + e2.ap(t5.amount, -179, 179), Ma(s3, t5);
          }
          if (i3.pitch) {
            const e3 = za(i3.pitch, o3, La);
            s3.pitch = this._map.transform.pitch + e3.amount, Ma(s3, e3);
          }
          if (s3.zoom || s3.bearing) {
            const e3 = void 0 === i3.pinchAround ? i3.around : i3.pinchAround;
            s3.around = e3 ? this._map.unproject(e3) : this._map.getCenter();
          }
          return this.clear(), s3.noMoveStart = true, s3;
        }
      }
      function Ma(e3, t4) {
        (!e3.duration || e3.duration < t4.duration) && (e3.duration = t4.duration, e3.easing = t4.easing);
      }
      function za(t4, i3, o3) {
        const { maxSpeed: s3, linearity: r3, deceleration: a4 } = o3, n3 = e2.ap(t4 * r3 / (i3 / 1e3), -s3, s3), l3 = Math.abs(n3) / (a4 * r3);
        return { easing: o3.easing, duration: 1e3 * l3, amount: n3 * (l3 / 2) };
      }
      class Oa extends e2.x {
        preventDefault() {
          this._defaultPrevented = true;
        }
        get defaultPrevented() {
          return this._defaultPrevented;
        }
        constructor(t4, i3, o3, s3 = {}) {
          const r3 = g3(i3.getCanvasContainer(), o3), a4 = i3.unproject(r3);
          super(t4, e2.m({ point: r3, lngLat: a4, originalEvent: o3 }, s3)), this._defaultPrevented = false, this.target = i3;
        }
      }
      class Fa extends e2.x {
        preventDefault() {
          this._defaultPrevented = true;
        }
        get defaultPrevented() {
          return this._defaultPrevented;
        }
        constructor(t4, i3, o3) {
          const s3 = "touchend" === t4 ? o3.changedTouches : o3.touches, r3 = v(i3.getCanvasContainer(), s3), a4 = r3.map((e3) => i3.unproject(e3)), n3 = r3.reduce((e3, t5, i4, o4) => e3.add(t5.div(o4.length)), new e2.P(0, 0));
          super(t4, { points: r3, point: n3, lngLats: a4, lngLat: i3.unproject(n3), originalEvent: o3 }), this._defaultPrevented = false;
        }
      }
      class Ba extends e2.x {
        preventDefault() {
          this._defaultPrevented = true;
        }
        get defaultPrevented() {
          return this._defaultPrevented;
        }
        constructor(e3, t4) {
          super("wheel", { originalEvent: t4 }), this._defaultPrevented = false;
        }
      }
      class ka {
        constructor(e3, t4) {
          this._map = e3, this._clickTolerance = t4.clickTolerance;
        }
        reset() {
          this._mousedownPos = void 0;
        }
        wheel(e3) {
          return this._firePreventable(new Ba(this._map, e3));
        }
        mousedown(e3, t4) {
          return this._mousedownPos = t4, this._firePreventable(new Oa(e3.type, this._map, e3));
        }
        mouseup(e3) {
          this._map.fire(new Oa(e3.type, this._map, e3));
        }
        preclick(t4) {
          const i3 = e2.m({}, t4);
          i3.type = "preclick", this._map.fire(new Oa(i3.type, this._map, i3));
        }
        click(e3, t4) {
          this._mousedownPos && this._mousedownPos.dist(t4) >= this._clickTolerance || (this.preclick(e3), this._map.fire(new Oa(e3.type, this._map, e3)));
        }
        dblclick(e3) {
          return this._firePreventable(new Oa(e3.type, this._map, e3));
        }
        mouseover(e3) {
          this._map.fire(new Oa(e3.type, this._map, e3));
        }
        mouseout(e3) {
          this._map.fire(new Oa(e3.type, this._map, e3));
        }
        touchstart(e3) {
          return this._firePreventable(new Fa(e3.type, this._map, e3));
        }
        touchmove(e3) {
          this._map.fire(new Fa(e3.type, this._map, e3));
        }
        touchend(e3) {
          this._map.fire(new Fa(e3.type, this._map, e3));
        }
        touchcancel(e3) {
          this._map.fire(new Fa(e3.type, this._map, e3));
        }
        _firePreventable(e3) {
          if (this._map.fire(e3), e3.defaultPrevented) return {};
        }
        isEnabled() {
          return true;
        }
        isActive() {
          return false;
        }
        enable() {
        }
        disable() {
        }
      }
      class Na {
        constructor(e3) {
          this._map = e3;
        }
        reset() {
          this._delayContextMenu = false, this._contextMenuEvent = void 0;
        }
        mousemove(e3) {
          this._map.fire(new Oa(e3.type, this._map, e3));
        }
        mousedown() {
          this._delayContextMenu = true;
        }
        mouseup() {
          this._delayContextMenu = false, this._contextMenuEvent && (this._map.fire(new Oa("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
        }
        contextmenu(e3) {
          this._delayContextMenu ? this._contextMenuEvent = e3 : this._map.fire(new Oa(e3.type, this._map, e3)), this._map.listens("contextmenu") && e3.preventDefault();
        }
        isEnabled() {
          return true;
        }
        isActive() {
          return false;
        }
        enable() {
        }
        disable() {
        }
      }
      class Ua {
        constructor(e3, t4) {
          this._map = e3, this._el = e3.getCanvasContainer(), this._container = e3.getContainer(), this._clickTolerance = t4.clickTolerance || 1;
        }
        isEnabled() {
          return !!this._enabled;
        }
        isActive() {
          return !!this._active;
        }
        enable() {
          this.isEnabled() || (this._enabled = true);
        }
        disable() {
          this.isEnabled() && (this._enabled = false);
        }
        mousedown(e3, t4) {
          this.isEnabled() && e3.shiftKey && 0 === e3.button && (_(), this._startPos = this._lastPos = t4, this._active = true);
        }
        mousemoveWindow(e3, t4) {
          if (!this._active) return;
          const i3 = t4, o3 = this._startPos, s3 = this._lastPos;
          if (!o3 || !s3 || s3.equals(i3) || !this._box && i3.dist(o3) < this._clickTolerance) return;
          this._lastPos = i3, this._box || (this._box = l2("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e3));
          const r3 = Math.min(o3.x, i3.x), a4 = Math.max(o3.x, i3.x), n3 = Math.min(o3.y, i3.y), c3 = Math.max(o3.y, i3.y);
          this._map._requestDomTask(() => {
            this._box && (this._box.style.transform = `translate(${r3}px,${n3}px)`, this._box.style.width = a4 - r3 + "px", this._box.style.height = c3 - n3 + "px");
          });
        }
        mouseupWindow(t4, i3) {
          if (!this._active) return;
          const o3 = this._startPos, s3 = i3;
          if (o3 && 0 === t4.button) {
            if (this.reset(), m(), o3.x !== s3.x || o3.y !== s3.y) return this._map.fire(new e2.x("boxzoomend", { originalEvent: t4 })), { cameraAnimation: (e3) => e3.fitScreenCoordinates(o3, s3, this._map.getBearing(), { linear: false }) };
            this._fireEvent("boxzoomcancel", t4);
          }
        }
        keydown(e3) {
          this._active && 27 === e3.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e3));
        }
        blur() {
          this.reset();
        }
        reset() {
          this._active = false, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), p2(), delete this._startPos, delete this._lastPos;
        }
        _fireEvent(t4, i3) {
          return this._map.fire(new e2.x(t4, { originalEvent: i3 }));
        }
      }
      function Ga(e3, t4) {
        const i3 = {};
        for (let o3 = 0; o3 < e3.length; o3++) i3[e3[o3].identifier] = t4[o3];
        return i3;
      }
      class Va {
        constructor(e3) {
          this.reset(), this.numTouches = e3.numTouches;
        }
        reset() {
          this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = false;
        }
        touchstart(t4, i3, o3) {
          (this.centroid || o3.length > this.numTouches) && (this.aborted = true), this.aborted || (0 === this.startTime && (this.startTime = t4.timeStamp), o3.length === this.numTouches && (this.centroid = function(t5) {
            const i4 = new e2.P(0, 0);
            for (const e3 of t5) i4._add(e3);
            return i4.div(t5.length);
          }(i3), this.touches = Ga(o3, i3)));
        }
        touchmove(e3, t4, i3) {
          if (this.aborted || !this.centroid) return;
          const o3 = Ga(i3, t4);
          for (const e4 in this.touches) {
            const t5 = o3[e4];
            (!t5 || t5.dist(this.touches[e4]) > 30) && (this.aborted = true);
          }
        }
        touchend(e3, t4, i3) {
          if ((!this.centroid || e3.timeStamp - this.startTime > 500) && (this.aborted = true), 0 === i3.length) {
            const e4 = !this.aborted && this.centroid;
            if (this.reset(), e4) return e4;
          }
        }
      }
      class ja {
        constructor(e3) {
          this.singleTap = new Va(e3), this.numTaps = e3.numTaps, this.reset();
        }
        reset() {
          this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
        }
        touchstart(e3, t4, i3) {
          this.singleTap.touchstart(e3, t4, i3);
        }
        touchmove(e3, t4, i3) {
          this.singleTap.touchmove(e3, t4, i3);
        }
        touchend(e3, t4, i3) {
          const o3 = this.singleTap.touchend(e3, t4, i3);
          if (o3) {
            const t5 = e3.timeStamp - this.lastTime < 500, i4 = !this.lastTap || this.lastTap.dist(o3) < 30;
            if (t5 && i4 || this.reset(), this.count++, this.lastTime = e3.timeStamp, this.lastTap = o3, this.count === this.numTaps) return this.reset(), o3;
          }
        }
      }
      class Ha {
        constructor() {
          this._zoomIn = new ja({ numTouches: 1, numTaps: 2 }), this._zoomOut = new ja({ numTouches: 2, numTaps: 1 }), this.reset();
        }
        reset() {
          this._active = false, this._zoomIn.reset(), this._zoomOut.reset();
        }
        touchstart(e3, t4, i3) {
          this._zoomIn.touchstart(e3, t4, i3), this._zoomOut.touchstart(e3, t4, i3);
        }
        touchmove(e3, t4, i3) {
          this._zoomIn.touchmove(e3, t4, i3), this._zoomOut.touchmove(e3, t4, i3);
        }
        touchend(e3, t4, i3) {
          const o3 = this._zoomIn.touchend(e3, t4, i3), s3 = this._zoomOut.touchend(e3, t4, i3);
          return o3 ? (this._active = true, e3.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (t5) => t5.easeTo({ duration: 300, zoom: t5.getZoom() + 1, around: t5.unproject(o3) }, { originalEvent: e3 }) }) : s3 ? (this._active = true, e3.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (t5) => t5.easeTo({ duration: 300, zoom: t5.getZoom() - 1, around: t5.unproject(s3) }, { originalEvent: e3 }) }) : void 0;
        }
        touchcancel() {
          this.reset();
        }
        enable() {
          this._enabled = true;
        }
        disable() {
          this._enabled = false, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      const Za = { 0: 1, 2: 2 };
      class qa {
        constructor(e3) {
          this.reset(), this._clickTolerance = e3.clickTolerance || 1;
        }
        blur() {
          this.reset();
        }
        reset() {
          this._active = false, this._moved = false, this._lastPoint = void 0, this._eventButton = void 0;
        }
        _correctButton(e3, t4) {
          return false;
        }
        _move(e3, t4) {
          return {};
        }
        mousedown(e3, t4) {
          if (this._lastPoint) return;
          const i3 = x(e3);
          this._correctButton(e3, i3) && (this._lastPoint = t4, this._eventButton = i3);
        }
        mousemoveWindow(e3, t4) {
          const i3 = this._lastPoint;
          if (i3) {
            if (e3.preventDefault(), null != this._eventButton && function(e4, t5) {
              const i4 = Za[t5];
              return void 0 === e4.buttons || (e4.buttons & i4) !== i4;
            }(e3, this._eventButton)) this.reset();
            else if (this._moved || !(t4.dist(i3) < this._clickTolerance)) return this._moved = true, this._lastPoint = t4, this._move(i3, t4);
          }
        }
        mouseupWindow(e3) {
          this._lastPoint && x(e3) === this._eventButton && (this._moved && m(), this.reset());
        }
        enable() {
          this._enabled = true;
        }
        disable() {
          this._enabled = false, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      class Wa extends qa {
        mousedown(e3, t4) {
          super.mousedown(e3, t4), this._lastPoint && (this._active = true);
        }
        _correctButton(e3, t4) {
          return 0 === t4 && !e3.ctrlKey;
        }
        _move(e3, t4) {
          return { around: t4, panDelta: t4.sub(e3) };
        }
      }
      class $a extends qa {
        _correctButton(e3, t4) {
          return 0 === t4 && e3.ctrlKey || 2 === t4;
        }
        _move(e3, t4) {
          const i3 = 0.8 * (t4.x - e3.x);
          if (i3) return this._active = true, { bearingDelta: i3 };
        }
        contextmenu(e3) {
          e3.preventDefault();
        }
      }
      class Xa extends qa {
        _correctButton(e3, t4) {
          return 0 === t4 && e3.ctrlKey || 2 === t4;
        }
        _move(e3, t4) {
          const i3 = -0.5 * (t4.y - e3.y);
          if (i3) return this._active = true, { pitchDelta: i3 };
        }
        contextmenu(e3) {
          e3.preventDefault();
        }
      }
      class Ja {
        constructor(t4, i3) {
          this._map = t4, this._el = t4.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i3.clickTolerance || 1, this.reset(), e2.aJ(["_addTouchPanBlocker", "_showTouchPanBlockerAlert"], this);
        }
        reset() {
          this._active = false, this._touches = {}, this._sum = new e2.P(0, 0);
        }
        touchstart(e3, t4, i3) {
          return this._calculateTransform(e3, t4, i3);
        }
        touchmove(t4, i3, o3) {
          if (this._active && !(o3.length < this._minTouches)) {
            if (this._map._cooperativeGestures && !this._map.isMoving()) {
              if (1 === o3.length && !e2.dq()) return void this._showTouchPanBlockerAlert();
              "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
            }
            return t4.cancelable && t4.preventDefault(), this._calculateTransform(t4, i3, o3);
          }
        }
        touchend(e3, t4, i3) {
          this._calculateTransform(e3, t4, i3), this._active && i3.length < this._minTouches && this.reset();
        }
        touchcancel() {
          this.reset();
        }
        _calculateTransform(t4, i3, o3) {
          o3.length > 0 && (this._active = true);
          const s3 = Ga(o3, i3), r3 = new e2.P(0, 0), a4 = new e2.P(0, 0);
          let n3 = 0;
          for (const e3 in s3) {
            const t5 = s3[e3], i4 = this._touches[e3];
            i4 && (r3._add(t5), a4._add(t5.sub(i4)), n3++, s3[e3] = t5);
          }
          if (this._touches = s3, n3 < this._minTouches || !a4.mag()) return;
          const l3 = a4.div(n3);
          return this._sum._add(l3), this._sum.mag() < this._clickTolerance ? void 0 : { around: r3.div(n3), panDelta: l3 };
        }
        enable() {
          this._enabled = true, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
        }
        disable() {
          this._enabled = false, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
        }
        isEnabled() {
          return !!this._enabled;
        }
        isActive() {
          return !!this._active;
        }
        _addTouchPanBlocker() {
          this._map && !this._alertContainer && (this._alertContainer = l2("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(0.05 * this._el.clientWidth)))}px`);
        }
        _showTouchPanBlockerAlert() {
          this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(() => {
            this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.removeAttribute("role");
          }, 500);
        }
      }
      class Ka {
        constructor() {
          this.reset();
        }
        reset() {
          this._active = false, this._firstTwoTouches = void 0;
        }
        _start(e3) {
        }
        _move(e3, t4, i3) {
          return {};
        }
        touchstart(e3, t4, i3) {
          this._firstTwoTouches || i3.length < 2 || (this._firstTwoTouches = [i3[0].identifier, i3[1].identifier], this._start([t4[0], t4[1]]));
        }
        touchmove(e3, t4, i3) {
          const o3 = this._firstTwoTouches;
          if (!o3) return;
          e3.preventDefault();
          const [s3, r3] = o3, a4 = Ya(i3, t4, s3), n3 = Ya(i3, t4, r3);
          if (!a4 || !n3) return;
          const l3 = this._aroundCenter ? null : a4.add(n3).div(2);
          return this._move([a4, n3], l3, e3);
        }
        touchend(e3, t4, i3) {
          if (!this._firstTwoTouches) return;
          const [o3, s3] = this._firstTwoTouches, r3 = Ya(i3, t4, o3), a4 = Ya(i3, t4, s3);
          r3 && a4 || (this._active && m(), this.reset());
        }
        touchcancel() {
          this.reset();
        }
        enable(e3) {
          this._enabled = true, this._aroundCenter = !!e3 && "center" === e3.around;
        }
        disable() {
          this._enabled = false, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      function Ya(e3, t4, i3) {
        for (let o3 = 0; o3 < e3.length; o3++) if (e3[o3].identifier === i3) return t4[o3];
      }
      function Qa(e3, t4) {
        return Math.log(e3 / t4) / Math.LN2;
      }
      class en extends Ka {
        reset() {
          super.reset(), this._distance = 0, this._startDistance = 0;
        }
        _start(e3) {
          this._startDistance = this._distance = e3[0].dist(e3[1]);
        }
        _move(e3, t4) {
          const i3 = this._distance;
          if (this._distance = e3[0].dist(e3[1]), this._active || !(Math.abs(Qa(this._distance, this._startDistance)) < 0.1)) return this._active = true, { zoomDelta: Qa(this._distance, i3), pinchAround: t4 };
        }
      }
      function tn(e3, t4) {
        return 180 * e3.angleWith(t4) / Math.PI;
      }
      class on extends Ka {
        reset() {
          super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
        }
        _start(e3) {
          this._startVector = this._vector = e3[0].sub(e3[1]), this._minDiameter = e3[0].dist(e3[1]);
        }
        _move(e3, t4) {
          const i3 = this._vector;
          if (this._vector = e3[0].sub(e3[1]), i3 && (this._active || !this._isBelowThreshold(this._vector))) return this._active = true, { bearingDelta: tn(this._vector, i3), pinchAround: t4 };
        }
        _isBelowThreshold(e3) {
          this._minDiameter = Math.min(this._minDiameter, e3.mag());
          const t4 = 25 / (Math.PI * this._minDiameter) * 360, i3 = this._startVector;
          if (!i3) return false;
          const o3 = tn(e3, i3);
          return Math.abs(o3) < t4;
        }
      }
      function sn(e3) {
        return Math.abs(e3.y) > Math.abs(e3.x);
      }
      class rn extends Ka {
        constructor(e3) {
          super(), this._map = e3;
        }
        reset() {
          super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
        }
        _start(e3) {
          this._lastPoints = e3, sn(e3[0].sub(e3[1])) && (this._valid = false);
        }
        _move(t4, i3, o3) {
          const s3 = this._lastPoints;
          if (!s3) return;
          const r3 = t4[0].sub(s3[0]), a4 = t4[1].sub(s3[1]);
          return this._map._cooperativeGestures && !e2.dq() && o3.touches.length < 3 || (this._valid = this.gestureBeginsVertically(r3, a4, o3.timeStamp), !this._valid) ? void 0 : (this._lastPoints = t4, this._active = true, { pitchDelta: (r3.y + a4.y) / 2 * -0.5 });
        }
        gestureBeginsVertically(e3, t4, i3) {
          if (void 0 !== this._valid) return this._valid;
          const o3 = e3.mag() >= 2, s3 = t4.mag() >= 2;
          if (!o3 && !s3) return;
          if (!o3 || !s3) return null == this._firstMove && (this._firstMove = i3), i3 - this._firstMove < 100 && void 0;
          const r3 = e3.y > 0 == t4.y > 0;
          return sn(e3) && sn(t4) && r3;
        }
      }
      const an = { panStep: 100, bearingStep: 15, pitchStep: 10 };
      class nn {
        constructor() {
          const e3 = an;
          this._panStep = e3.panStep, this._bearingStep = e3.bearingStep, this._pitchStep = e3.pitchStep, this._rotationDisabled = false;
        }
        blur() {
          this.reset();
        }
        reset() {
          this._active = false;
        }
        keydown(e3) {
          if (e3.altKey || e3.ctrlKey || e3.metaKey) return;
          let t4 = 0, i3 = 0, o3 = 0, s3 = 0, r3 = 0;
          switch (e3.keyCode) {
            case 61:
            case 107:
            case 171:
            case 187:
              t4 = 1;
              break;
            case 189:
            case 109:
            case 173:
              t4 = -1;
              break;
            case 37:
              e3.shiftKey ? i3 = -1 : (e3.preventDefault(), s3 = -1);
              break;
            case 39:
              e3.shiftKey ? i3 = 1 : (e3.preventDefault(), s3 = 1);
              break;
            case 38:
              e3.shiftKey ? o3 = 1 : (e3.preventDefault(), r3 = -1);
              break;
            case 40:
              e3.shiftKey ? o3 = -1 : (e3.preventDefault(), r3 = 1);
              break;
            default:
              return;
          }
          return this._rotationDisabled && (i3 = 0, o3 = 0), { cameraAnimation: (a4) => {
            const n3 = a4.getZoom();
            a4.easeTo({ duration: 300, easeId: "keyboardHandler", easing: ln, zoom: t4 ? Math.round(n3) + t4 * (e3.shiftKey ? 2 : 1) : n3, bearing: a4.getBearing() + i3 * this._bearingStep, pitch: a4.getPitch() + o3 * this._pitchStep, offset: [-s3 * this._panStep, -r3 * this._panStep], center: a4.getCenter() }, { originalEvent: e3 });
          } };
        }
        enable() {
          this._enabled = true;
        }
        disable() {
          this._enabled = false, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
        disableRotation() {
          this._rotationDisabled = true;
        }
        enableRotation() {
          this._rotationDisabled = false;
        }
      }
      function ln(e3) {
        return e3 * (2 - e3);
      }
      const cn = 4.000244140625, hn = 1 / 450;
      class un {
        constructor(t4, i3) {
          this._map = t4, this._el = t4.getCanvasContainer(), this._handler = i3, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = 0.01, this._wheelZoomRate = hn, e2.aJ(["_onTimeout", "_addScrollZoomBlocker", "_showBlockerAlert"], this);
        }
        setZoomRate(e3) {
          this._defaultZoomRate = e3;
        }
        setWheelZoomRate(e3) {
          this._wheelZoomRate = e3;
        }
        isEnabled() {
          return !!this._enabled;
        }
        isActive() {
          return this._active || void 0 !== this._finishTimeout;
        }
        isZooming() {
          return !!this._zooming;
        }
        enable(e3) {
          this.isEnabled() || (this._enabled = true, this._aroundCenter = !!e3 && "center" === e3.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
        }
        disable() {
          this.isEnabled() && (this._enabled = false, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
        }
        wheel(t4) {
          if (!this.isEnabled()) return;
          if (this._map._cooperativeGestures) {
            if (!(t4.ctrlKey || t4.metaKey || this.isZooming() || e2.dq())) return void this._showBlockerAlert();
            "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
          }
          let i3 = t4.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * t4.deltaY : t4.deltaY;
          const o3 = e2.e.now(), s3 = o3 - (this._lastWheelEventTime || 0);
          this._lastWheelEventTime = o3, 0 !== i3 && i3 % cn == 0 ? this._type = "wheel" : 0 !== i3 && Math.abs(i3) < 4 ? this._type = "trackpad" : s3 > 400 ? (this._type = null, this._lastValue = i3, this._timeout = window.setTimeout(this._onTimeout, 40, t4)) : this._type || (this._type = Math.abs(s3 * i3) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i3 += this._lastValue)), t4.shiftKey && i3 && (i3 /= 4), this._type && (this._lastWheelEvent = t4, this._delta -= i3, this._active || this._start(t4)), t4.preventDefault();
        }
        _onTimeout(e3) {
          this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e3);
        }
        _start(e3) {
          if (!this._delta) return;
          this._frameId && (this._frameId = null), this._active = true, this.isZooming() || (this._zooming = true), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
          const t4 = g3(this._el, e3);
          this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t4, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = true, this._handler._triggerRenderFrame());
        }
        renderFrame() {
          if (!this._frameId) return;
          if (this._frameId = null, !this.isActive()) return;
          const t4 = this._map.transform;
          "wheel" === this._type && t4.projection.wrap && (t4._center.lng >= 180 || t4._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
          const i3 = () => t4._terrainEnabled() && this._aroundCoord ? t4.computeZoomRelativeTo(this._aroundCoord) : t4.zoom;
          if (0 !== this._delta) {
            const e3 = "wheel" === this._type && Math.abs(this._delta) > cn ? this._wheelZoomRate : this._defaultZoomRate;
            let o4 = 2 / (1 + Math.exp(-Math.abs(this._delta * e3)));
            this._delta < 0 && 0 !== o4 && (o4 = 1 / o4);
            const s4 = i3(), r4 = Math.pow(2, s4), a5 = "number" == typeof this._targetZoom ? t4.zoomScale(this._targetZoom) : r4;
            this._targetZoom = Math.min(t4.maxZoom, Math.max(t4.minZoom, t4.scaleZoom(a5 * o4))), "wheel" === this._type && (this._startZoom = s4, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
          }
          const o3 = "number" == typeof this._targetZoom ? this._targetZoom : i3(), s3 = this._startZoom, r3 = this._easing;
          let a4, n3 = false;
          if ("wheel" === this._type && s3 && r3) {
            const t5 = Math.min((e2.e.now() - this._lastWheelEventTime) / 200, 1), i4 = r3(t5);
            a4 = e2.aa(s3, o3, i4), t5 < 1 ? this._frameId || (this._frameId = true) : n3 = true;
          } else a4 = o3, n3 = true;
          this._active = true, n3 && (this._active = false, this._finishTimeout = window.setTimeout(() => {
            this._zooming = false, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
          }, 200));
          let l3 = a4 - i3();
          return l3 * this._lastDelta < 0 && (l3 = 0), { noInertia: true, needsRenderFrame: !n3, zoomDelta: l3, around: this._aroundPoint, aroundCoord: this._aroundCoord, originalEvent: this._lastWheelEvent };
        }
        _smoothOutEasing(t4) {
          let i3 = e2.dr;
          if (this._prevEase) {
            const t5 = this._prevEase, o3 = (e2.e.now() - t5.start) / t5.duration, s3 = t5.easing(o3 + 0.01) - t5.easing(o3), r3 = 0.27 / Math.sqrt(s3 * s3 + 1e-4) * 0.01, a4 = Math.sqrt(0.0729 - r3 * r3);
            i3 = e2.dp(r3, a4, 0.25, 1);
          }
          return this._prevEase = { start: e2.e.now(), duration: t4, easing: i3 }, i3;
        }
        blur() {
          this.reset();
        }
        reset() {
          this._active = false;
        }
        _addScrollZoomBlocker() {
          this._map && !this._alertContainer && (this._alertContainer = l2("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(0.05 * this._el.clientWidth)))}px`);
        }
        _showBlockerAlert() {
          this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(() => {
            this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.removeAttribute("role");
          }, 200);
        }
      }
      class dn {
        constructor(e3, t4) {
          this._clickZoom = e3, this._tapZoom = t4;
        }
        enable() {
          this._clickZoom.enable(), this._tapZoom.enable();
        }
        disable() {
          this._clickZoom.disable(), this._tapZoom.disable();
        }
        isEnabled() {
          return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
        }
        isActive() {
          return this._clickZoom.isActive() || this._tapZoom.isActive();
        }
      }
      class _n {
        constructor() {
          this.reset();
        }
        reset() {
          this._active = false;
        }
        blur() {
          this.reset();
        }
        dblclick(e3, t4) {
          return e3.preventDefault(), { cameraAnimation: (i3) => {
            i3.easeTo({ duration: 300, zoom: i3.getZoom() + (e3.shiftKey ? -1 : 1), around: i3.unproject(t4) }, { originalEvent: e3 });
          } };
        }
        enable() {
          this._enabled = true;
        }
        disable() {
          this._enabled = false, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      class pn {
        constructor() {
          this._tap = new ja({ numTouches: 1, numTaps: 1 }), this.reset();
        }
        reset() {
          this._active = false, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
        }
        touchstart(e3, t4, i3) {
          this._swipePoint || (this._tapTime && e3.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i3.length > 0 && (this._swipePoint = t4[0], this._swipeTouch = i3[0].identifier) : this._tap.touchstart(e3, t4, i3));
        }
        touchmove(e3, t4, i3) {
          if (this._tapTime) {
            if (this._swipePoint) {
              if (i3[0].identifier !== this._swipeTouch) return;
              const o3 = t4[0], s3 = o3.y - this._swipePoint.y;
              return this._swipePoint = o3, e3.preventDefault(), this._active = true, { zoomDelta: s3 / 128 };
            }
          } else this._tap.touchmove(e3, t4, i3);
        }
        touchend(e3, t4, i3) {
          this._tapTime ? this._swipePoint && 0 === i3.length && this.reset() : this._tap.touchend(e3, t4, i3) && (this._tapTime = e3.timeStamp);
        }
        touchcancel() {
          this.reset();
        }
        enable() {
          this._enabled = true;
        }
        disable() {
          this._enabled = false, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      class fn {
        constructor(e3, t4, i3) {
          this._el = e3, this._mousePan = t4, this._touchPan = i3;
        }
        enable(e3) {
          this._inertiaOptions = e3 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
        }
        disable() {
          this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
        }
        isEnabled() {
          return this._mousePan.isEnabled() && this._touchPan.isEnabled();
        }
        isActive() {
          return this._mousePan.isActive() || this._touchPan.isActive();
        }
      }
      class mn {
        constructor(e3, t4, i3) {
          this._pitchWithRotate = e3.pitchWithRotate, this._mouseRotate = t4, this._mousePitch = i3;
        }
        enable() {
          this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
        }
        disable() {
          this._mouseRotate.disable(), this._mousePitch.disable();
        }
        isEnabled() {
          return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
        }
        isActive() {
          return this._mouseRotate.isActive() || this._mousePitch.isActive();
        }
      }
      class gn {
        constructor(e3, t4, i3, o3) {
          this._el = e3, this._touchZoom = t4, this._touchRotate = i3, this._tapDragZoom = o3, this._rotationDisabled = false, this._enabled = true;
        }
        enable(e3) {
          this._touchZoom.enable(e3), this._rotationDisabled || this._touchRotate.enable(e3), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
        }
        disable() {
          this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
        }
        isEnabled() {
          return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
        }
        isActive() {
          return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
        }
        disableRotation() {
          this._rotationDisabled = true, this._touchRotate.disable();
        }
        enableRotation() {
          this._rotationDisabled = false, this._touchZoom.isEnabled() && this._touchRotate.enable();
        }
      }
      const vn = (e3) => e3.zoom || e3.drag || e3.pitch || e3.rotate;
      class xn extends e2.x {
      }
      class yn {
        constructor() {
          this.constants = [1, 1, 0.01], this.radius = 0;
        }
        setup(t4, i3, o3) {
          const s3 = e2.a6.vec3.sub([], i3, t4);
          this.radius = e2.a6.vec3.length(o3 || s3[2] < 0 ? e2.a6.vec3.div([], s3, this.constants) : [s3[0], s3[1], 0]);
        }
        projectRay(t4, i3) {
          e2.a6.vec3.div(t4, t4, this.constants), e2.a6.vec3.normalize(t4, t4), e2.a6.vec3.mul(t4, t4, this.constants);
          const o3 = e2.a6.vec3.scale([], t4, this.radius);
          if (!i3 && o3[2] > 0) {
            const t5 = e2.a6.vec3.scale([], [0, 0, 1], e2.a6.vec3.dot(o3, [0, 0, 1])), i4 = e2.a6.vec3.scale([], e2.a6.vec3.normalize([], [o3[0], o3[1], 0]), this.radius), s3 = e2.a6.vec3.add([], o3, e2.a6.vec3.scale([], e2.a6.vec3.sub([], e2.a6.vec3.add([], i4, t5), o3), 2));
            o3[0] = s3[0], o3[1] = s3[1];
          }
          return o3;
        }
      }
      function bn(e3) {
        return e3.panDelta && e3.panDelta.mag() || e3.zoomDelta || e3.bearingDelta || e3.pitchDelta;
      }
      class wn {
        constructor(t4, i3) {
          this._map = t4, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Pa(t4), this._bearingSnap = i3.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new yn(), this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i3), e2.aJ(["handleEvent", "handleWindowEvent"], this);
          const o3 = this._el;
          this._listeners = [[o3, "touchstart", { passive: true }], [o3, "touchmove", { passive: false }], [o3, "touchend", void 0], [o3, "touchcancel", void 0], [o3, "mousedown", void 0], [o3, "mousemove", void 0], [o3, "mouseup", void 0], [document, "mousemove", { capture: true }], [document, "mouseup", void 0], [o3, "mouseover", void 0], [o3, "mouseout", void 0], [o3, "dblclick", void 0], [o3, "click", void 0], [o3, "keydown", { capture: false }], [o3, "keyup", void 0], [o3, "wheel", { passive: false }], [o3, "contextmenu", void 0], [window, "blur", void 0]];
          for (const [e3, t5, i4] of this._listeners) {
            const o4 = e3 === document ? this.handleWindowEvent : this.handleEvent;
            e3.addEventListener(t5, o4, i4);
          }
        }
        destroy() {
          for (const [e3, t4, i3] of this._listeners) {
            const o3 = e3 === document ? this.handleWindowEvent : this.handleEvent;
            e3.removeEventListener(t4, o3, i3);
          }
        }
        _addDefaultHandlers(e3) {
          const t4 = this._map, i3 = t4.getCanvasContainer();
          this._add("mapEvent", new ka(t4, e3));
          const o3 = t4.boxZoom = new Ua(t4, e3);
          this._add("boxZoom", o3);
          const s3 = new Ha(), r3 = new _n();
          t4.doubleClickZoom = new dn(r3, s3), this._add("tapZoom", s3), this._add("clickZoom", r3);
          const a4 = new pn();
          this._add("tapDragZoom", a4);
          const n3 = t4.touchPitch = new rn(t4);
          this._add("touchPitch", n3);
          const l3 = new $a(e3), c3 = new Xa(e3);
          t4.dragRotate = new mn(e3, l3, c3), this._add("mouseRotate", l3, ["mousePitch"]), this._add("mousePitch", c3, ["mouseRotate"]);
          const h3 = new Wa(e3), u4 = new Ja(t4, e3);
          t4.dragPan = new fn(i3, h3, u4), this._add("mousePan", h3), this._add("touchPan", u4, ["touchZoom", "touchRotate"]);
          const d3 = new on(), _2 = new en();
          t4.touchZoomRotate = new gn(i3, _2, d3, a4), this._add("touchRotate", d3, ["touchPan", "touchZoom"]), this._add("touchZoom", _2, ["touchPan", "touchRotate"]), this._add("blockableMapEvent", new Na(t4));
          const p3 = t4.scrollZoom = new un(t4, this);
          this._add("scrollZoom", p3, ["mousePan"]);
          const f3 = t4.keyboard = new nn();
          this._add("keyboard", f3);
          for (const i4 of ["boxZoom", "doubleClickZoom", "tapDragZoom", "touchPitch", "dragRotate", "dragPan", "touchZoomRotate", "scrollZoom", "keyboard"]) e3.interactive && e3[i4] && t4[i4].enable(e3[i4]);
        }
        _add(e3, t4, i3) {
          this._handlers.push({ handlerName: e3, handler: t4, allowed: i3 }), this._handlersById[e3] = t4;
        }
        stop(e3) {
          if (!this._updatingCamera) {
            for (const { handler: e4 } of this._handlers) e4.reset();
            this._inertia.clear(), this._fireEvents({}, {}, e3), this._changes = [], this._originalZoom = void 0;
          }
        }
        isActive() {
          for (const { handler: e3 } of this._handlers) if (e3.isActive()) return true;
          return false;
        }
        isZooming() {
          return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
        }
        isRotating() {
          return !!this._eventsInProgress.rotate;
        }
        isMoving() {
          return !!vn(this._eventsInProgress) || this.isZooming();
        }
        _isDragging() {
          return !!this._eventsInProgress.drag;
        }
        _blockedByActive(e3, t4, i3) {
          for (const o3 in e3) if (o3 !== i3 && (!t4 || t4.indexOf(o3) < 0)) return true;
          return false;
        }
        handleWindowEvent(e3) {
          this.handleEvent(e3, `${e3.type}Window`);
        }
        _getMapTouches(e3) {
          const t4 = [];
          for (const i3 of e3) this._el.contains(i3.target) && t4.push(i3);
          return t4;
        }
        handleEvent(e3, t4) {
          this._updatingCamera = true;
          const i3 = "renderFrame" === e3.type, o3 = i3 ? void 0 : e3, s3 = { needsRenderFrame: false }, r3 = {}, a4 = {}, n3 = e3.touches ? this._getMapTouches(e3.touches) : void 0, l3 = n3 ? v(this._el, n3) : i3 ? void 0 : g3(this._el, e3);
          for (const { handlerName: i4, handler: c4, allowed: h4 } of this._handlers) {
            if (!c4.isEnabled()) continue;
            let u4;
            this._blockedByActive(a4, h4, i4) ? c4.reset() : c4[t4 || e3.type] && (u4 = c4[t4 || e3.type](e3, l3, n3), this.mergeHandlerResult(s3, r3, u4, i4, o3), u4 && u4.needsRenderFrame && this._triggerRenderFrame()), (u4 || c4.isActive()) && (a4[i4] = c4);
          }
          const c3 = {};
          for (const e4 in this._previousActiveHandlers) a4[e4] || (c3[e4] = o3);
          this._previousActiveHandlers = a4, (Object.keys(c3).length || bn(s3)) && (this._changes.push([s3, r3, c3]), this._triggerRenderFrame()), (Object.keys(a4).length || bn(s3)) && this._map._stop(true), this._updatingCamera = false;
          const { cameraAnimation: h3 } = s3;
          h3 && (this._inertia.clear(), this._fireEvents({}, {}, true), this._changes = [], h3(this._map));
        }
        mergeHandlerResult(t4, i3, o3, s3, r3) {
          if (!o3) return;
          e2.m(t4, o3);
          const a4 = { handlerName: s3, originalEvent: o3.originalEvent || r3 };
          void 0 !== o3.zoomDelta && (i3.zoom = a4), void 0 !== o3.panDelta && (i3.drag = a4), void 0 !== o3.pitchDelta && (i3.pitch = a4), void 0 !== o3.bearingDelta && (i3.rotate = a4);
        }
        _applyChanges() {
          const t4 = {}, i3 = {}, o3 = {};
          for (const [s3, r3, a4] of this._changes) s3.panDelta && (t4.panDelta = (t4.panDelta || new e2.P(0, 0))._add(s3.panDelta)), s3.zoomDelta && (t4.zoomDelta = (t4.zoomDelta || 0) + s3.zoomDelta), s3.bearingDelta && (t4.bearingDelta = (t4.bearingDelta || 0) + s3.bearingDelta), s3.pitchDelta && (t4.pitchDelta = (t4.pitchDelta || 0) + s3.pitchDelta), void 0 !== s3.around && (t4.around = s3.around), void 0 !== s3.aroundCoord && (t4.aroundCoord = s3.aroundCoord), void 0 !== s3.pinchAround && (t4.pinchAround = s3.pinchAround), s3.noInertia && (t4.noInertia = s3.noInertia), e2.m(i3, r3), e2.m(o3, a4);
          this._updateMapTransform(t4, i3, o3), this._changes = [];
        }
        _updateMapTransform(t4, i3, o3) {
          const s3 = this._map, r3 = s3.transform, a4 = (e3) => [e3.x, e3.y, e3.z];
          if (((e3) => {
            const t5 = this._eventsInProgress.drag;
            return t5 && !this._handlersById[t5.handlerName].isActive();
          })() && !bn(t4)) {
            const e3 = r3.zoom;
            r3.cameraElevationReference = "sea", null != this._originalZoom && r3._orthographicProjectionAtLowPitch && "globe" !== r3.projection.name && 0 === r3.pitch ? (r3.cameraElevationReference = "ground", r3.zoom = this._originalZoom) : (r3.recenterOnTerrain(), r3.cameraElevationReference = "ground"), e3 !== r3.zoom && this._map._update(true);
          }
          if (r3._isCameraConstrained && s3._stop(true), !bn(t4)) return void this._fireEvents(i3, o3, true);
          let { panDelta: n3, zoomDelta: l3, bearingDelta: c3, pitchDelta: h3, around: u4, aroundCoord: d3, pinchAround: _2 } = t4;
          r3._isCameraConstrained && (l3 > 0 && (l3 = 0), r3._isCameraConstrained = false), void 0 !== _2 && (u4 = _2), (l3 || ((e3) => i3[e3] && !this._eventsInProgress[e3])("drag")) && u4 && (this._dragOrigin = a4(r3.pointCoordinate3D(u4)), this._originalZoom = r3.zoom, this._trackingEllipsoid.setup(r3._camera.position, this._dragOrigin, r3.isUnderground)), r3.cameraElevationReference = "sea", s3._stop(true), u4 = u4 || s3.transform.centerPoint, c3 && (r3.bearing += c3), h3 && (r3.pitch += h3), r3._updateCameraState();
          const p3 = [0, 0, 0];
          if (n3) if ("mercator" === r3.projection.name) {
            const e3 = this._trackingEllipsoid.projectRay(r3.screenPointToMercatorRay(u4).dir, r3.isUnderground), t5 = this._trackingEllipsoid.projectRay(r3.screenPointToMercatorRay(u4.sub(n3)).dir, r3.isUnderground);
            p3[0] = t5[0] - e3[0], p3[1] = t5[1] - e3[1];
          } else {
            const t5 = r3.pointCoordinate(u4);
            if ("globe" === r3.projection.name) {
              n3 = n3.rotate(-r3.angle);
              const i4 = r3._pixelsPerMercatorPixel / r3.worldSize;
              p3[0] = -n3.x * e2.ds(e2.aN(t5.y)) * i4, p3[1] = -n3.y * e2.ds(r3.center.lat) * i4;
            } else {
              const e3 = r3.pointCoordinate(u4.sub(n3));
              t5 && e3 && (p3[0] = e3.x - t5.x, p3[1] = e3.y - t5.y);
            }
          }
          const f3 = r3.zoom, m2 = [0, 0, 0];
          if (l3) {
            const t5 = a4(d3 || r3.pointCoordinate3D(u4)), i4 = { dir: e2.a6.vec3.normalize([], e2.a6.vec3.sub([], t5, r3._camera.position)) };
            if (r3.isUnderground || i4.dir[2] < 0) {
              const o4 = r3.zoomDeltaToMovement(t5, l3);
              e2.a6.vec3.scale(m2, i4.dir, o4);
            }
          }
          const g4 = e2.a6.vec3.add(p3, p3, m2);
          r3._translateCameraConstrained(g4), l3 && Math.abs(r3.zoom - f3) > 1e-4 && r3.recenterOnTerrain(), r3.cameraElevationReference = "ground", this._map._update(), t4.noInertia || this._inertia.record(t4), this._fireEvents(i3, o3, true);
        }
        _fireEvents(t4, i3, o3) {
          const s3 = vn(this._eventsInProgress), r3 = vn(t4), a4 = {};
          for (const e3 in t4) {
            const { originalEvent: i4 } = t4[e3];
            this._eventsInProgress[e3] || (a4[`${e3}start`] = i4), this._eventsInProgress[e3] = t4[e3];
          }
          !s3 && r3 && this._fireEvent("movestart", r3.originalEvent);
          for (const e3 in a4) this._fireEvent(e3, a4[e3]);
          r3 && this._fireEvent("move", r3.originalEvent);
          for (const e3 in t4) {
            const { originalEvent: i4 } = t4[e3];
            this._fireEvent(e3, i4);
          }
          const n3 = {};
          let l3;
          for (const e3 in this._eventsInProgress) {
            const { handlerName: t5, originalEvent: o4 } = this._eventsInProgress[e3];
            this._handlersById[t5].isActive() || (delete this._eventsInProgress[e3], l3 = i3[t5] || o4, n3[`${e3}end`] = l3);
          }
          for (const e3 in n3) this._fireEvent(e3, n3[e3]);
          const c3 = vn(this._eventsInProgress);
          if (o3 && (s3 || r3) && !c3) {
            this._updatingCamera = true;
            const t5 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i4 = (e3) => 0 !== e3 && -this._bearingSnap < e3 && e3 < this._bearingSnap;
            t5 ? (i4(t5.bearing || this._map.getBearing()) && (t5.bearing = 0), this._map.easeTo(t5, { originalEvent: l3 })) : (this._map.fire(new e2.x("moveend", { originalEvent: l3 })), i4(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = false;
          }
        }
        _fireEvent(t4, i3) {
          this._map.fire(new e2.x(t4, i3 ? { originalEvent: i3 } : {}));
        }
        _requestFrame() {
          return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e3) => {
            this._frameId = void 0, this.handleEvent(new xn("renderFrame", { timeStamp: e3 })), this._applyChanges();
          });
        }
        _triggerRenderFrame() {
          void 0 === this._frameId && (this._frameId = this._requestFrame());
        }
      }
      const Tn = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
      class En extends e2.E {
        constructor(t4, i3) {
          super(), this._moving = false, this._zooming = false, this.transform = t4, this._bearingSnap = i3.bearingSnap, this._respectPrefersReducedMotion = false !== i3.respectPrefersReducedMotion, e2.aJ(["_renderFrameCallback"], this);
        }
        getCenter() {
          return new e2.bL(this.transform.center.lng, this.transform.center.lat);
        }
        setCenter(e3, t4) {
          return this.jumpTo({ center: e3 }, t4);
        }
        panBy(t4, i3, o3) {
          return t4 = e2.P.convert(t4).mult(-1), this.panTo(this.transform.center, e2.m({ offset: t4 }, i3), o3);
        }
        panTo(t4, i3, o3) {
          return this.easeTo(e2.m({ center: t4 }, i3), o3);
        }
        getZoom() {
          return this.transform.zoom;
        }
        setZoom(e3, t4) {
          return this.jumpTo({ zoom: e3 }, t4), this;
        }
        zoomTo(t4, i3, o3) {
          return this.easeTo(e2.m({ zoom: t4 }, i3), o3);
        }
        zoomIn(e3, t4) {
          return this.zoomTo(this.getZoom() + 1, e3, t4), this;
        }
        zoomOut(e3, t4) {
          return this.zoomTo(this.getZoom() - 1, e3, t4), this;
        }
        getBearing() {
          return this.transform.bearing;
        }
        setBearing(e3, t4) {
          return this.jumpTo({ bearing: e3 }, t4), this;
        }
        getPadding() {
          return this.transform.padding;
        }
        setPadding(e3, t4) {
          return this.jumpTo({ padding: e3 }, t4), this;
        }
        rotateTo(t4, i3, o3) {
          return this.easeTo(e2.m({ bearing: t4 }, i3), o3);
        }
        resetNorth(t4, i3) {
          return this.rotateTo(0, e2.m({ duration: 1e3 }, t4), i3), this;
        }
        resetNorthPitch(t4, i3) {
          return this.easeTo(e2.m({ bearing: 0, pitch: 0, duration: 1e3 }, t4), i3), this;
        }
        snapToNorth(e3, t4) {
          return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e3, t4) : this;
        }
        getPitch() {
          return this.transform.pitch;
        }
        setPitch(e3, t4) {
          return this.jumpTo({ pitch: e3 }, t4), this;
        }
        cameraForBounds(t4, i3) {
          t4 = e2.as.convert(t4);
          const o3 = i3 && i3.bearing || 0, s3 = i3 && i3.pitch || 0, r3 = t4.getNorthWest(), a4 = t4.getSouthEast();
          return this._cameraForBounds(this.transform, r3, a4, o3, s3, i3);
        }
        _extendPadding(t4) {
          const i3 = { top: 0, right: 0, bottom: 0, left: 0 };
          return null == t4 ? e2.m({}, i3, this.transform.padding) : "number" == typeof t4 ? { top: t4, bottom: t4, right: t4, left: t4 } : e2.m({}, i3, t4);
        }
        _extendCameraOptions(t4) {
          return (t4 = e2.m({ offset: [0, 0], maxZoom: this.transform.maxZoom }, t4)).padding = this._extendPadding(t4.padding), t4;
        }
        _minimumAABBFrustumDistance(e3, t4) {
          const i3 = t4.max[0] - t4.min[0], o3 = t4.max[1] - t4.min[1];
          return i3 / o3 > e3.aspect ? i3 / (2 * Math.tan(0.5 * e3.fovX) * e3.aspect) : o3 / (2 * Math.tan(0.5 * e3.fovY) * e3.aspect);
        }
        _cameraForBoundsOnGlobe(t4, i3, o3, s3, r3, a4) {
          const n3 = t4.clone(), l3 = this._extendCameraOptions(a4);
          n3.bearing = s3, n3.pitch = r3;
          const c3 = e2.bL.convert(i3), h3 = e2.bL.convert(o3), u4 = 0.5 * (c3.lat + h3.lat), d3 = 0.5 * (c3.lng + h3.lng), _2 = e2.dt(u4, d3), p3 = e2.a6.vec3.normalize([], _2), f3 = e2.a6.vec3.normalize([], e2.a6.vec3.cross([], p3, [0, 1, 0])), m2 = e2.a6.vec3.cross([], f3, p3), g4 = [f3[0], f3[1], f3[2], 0, m2[0], m2[1], m2[2], 0, p3[0], p3[1], p3[2], 0, 0, 0, 0, 1], v2 = [_2, e2.dt(c3.lat, c3.lng), e2.dt(h3.lat, c3.lng), e2.dt(h3.lat, h3.lng), e2.dt(c3.lat, h3.lng), e2.dt(u4, c3.lng), e2.dt(u4, h3.lng), e2.dt(c3.lat, d3), e2.dt(h3.lat, d3)];
          let x2 = e2.ca.fromPoints(v2.map((t5) => [e2.a6.vec3.dot(f3, t5), e2.a6.vec3.dot(m2, t5), e2.a6.vec3.dot(p3, t5)]));
          const y2 = e2.a6.vec3.transformMat4([], x2.center, g4);
          0 === e2.a6.vec3.squaredLength(y2) && e2.a6.vec3.set(y2, 0, 0, 1), e2.a6.vec3.normalize(y2, y2), e2.a6.vec3.scale(y2, y2, e2.aq), n3.center = e2.du(y2);
          const b2 = n3.getWorldToCameraMatrix(), w2 = e2.a6.mat4.invert(new Float64Array(16), b2);
          x2 = e2.ca.applyTransform(x2, e2.a6.mat4.multiply([], b2, g4));
          const T3 = this._extendAABB(x2, n3, l3, s3);
          if (!T3) return void e2.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
          x2 = T3, e2.a6.vec3.transformMat4(y2, y2, b2);
          const E3 = 0.5 * (x2.max[2] - x2.min[2]), S2 = this._minimumAABBFrustumDistance(n3, x2), C3 = e2.a6.vec3.scale([], [0, 0, 1], E3), I3 = e2.a6.vec3.add(C3, y2, C3), D2 = S2 + (0 === n3.pitch ? 0 : e2.a6.vec3.distance(y2, I3)), R3 = n3.globeCenterInViewSpace, A3 = e2.a6.vec3.sub([], y2, [R3[0], R3[1], R3[2]]);
          e2.a6.vec3.normalize(A3, A3), e2.a6.vec3.scale(A3, A3, D2);
          const L3 = e2.a6.vec3.add([], y2, A3);
          e2.a6.vec3.transformMat4(L3, L3, w2);
          const P2 = e2.dw / e2.aq, M2 = e2.a6.vec3.length(L3), z3 = e2.bE(Math.max(M2 * P2 - e2.dw, Number.EPSILON), 0), O2 = Math.min(n3.zoomFromMercatorZAdjusted(z3), l3.maxZoom);
          return O2 > 0.5 * (e2.c3 + e2.bV) ? (n3.setProjection({ name: "mercator" }), n3.zoom = O2, this._cameraForBounds(n3, i3, o3, s3, r3, a4)) : { center: n3.center, zoom: O2, bearing: s3, pitch: r3 };
        }
        _extendAABB(t4, i3, o3, s3) {
          const r3 = 0.5 * ((o3.padding.left || 0) + (o3.padding.right || 0)), a4 = 0.5 * ((o3.padding.top || 0) + (o3.padding.bottom || 0)), n3 = a4, l3 = r3, c3 = r3, h3 = a4, u4 = i3.width - (l3 + c3), d3 = i3.height - (n3 + h3), _2 = e2.a6.vec3.sub([], t4.max, t4.min), p3 = Math.min(u4 / _2[0], d3 / _2[1]), f3 = Math.min(i3.scaleZoom(i3.scale * p3), o3.maxZoom);
          if (isNaN(f3)) return null;
          const m2 = i3.scale / i3.zoomScale(f3), g4 = new e2.ca([t4.min[0] - l3 * m2, t4.min[1] - h3 * m2, t4.min[2]], [t4.max[0] + c3 * m2, t4.max[1] + n3 * m2, t4.max[2]]), v2 = ("number" == typeof o3.offset.x && "number" == typeof o3.offset.y ? new e2.P(o3.offset.x, o3.offset.y) : e2.P.convert(o3.offset)).rotate(-e2.bC(s3));
          return g4.center[0] -= v2.x * m2, g4.center[1] += v2.y * m2, g4;
        }
        queryTerrainElevation(t4, i3) {
          const o3 = this.transform.elevation;
          return o3 ? (i3 = e2.m({}, { exaggerated: true }, i3), o3.getAtPoint(e2.a5.fromLngLat(t4), null, i3.exaggerated)) : null;
        }
        _cameraForBounds(t4, i3, o3, s3, r3, a4) {
          if ("globe" === t4.projection.name) return this._cameraForBoundsOnGlobe(t4, i3, o3, s3, r3, a4);
          const n3 = t4.clone(), l3 = this._extendCameraOptions(a4);
          n3.bearing = s3, n3.pitch = r3;
          const c3 = e2.bL.convert(i3), h3 = e2.bL.convert(o3), u4 = new e2.bL(c3.lng, h3.lat), d3 = new e2.bL(h3.lng, c3.lat), _2 = n3.project(c3), p3 = n3.project(h3), f3 = this.queryTerrainElevation(c3), m2 = this.queryTerrainElevation(h3), g4 = this.queryTerrainElevation(u4), v2 = this.queryTerrainElevation(d3), x2 = [[_2.x, _2.y, Math.min(f3 || 0, m2 || 0, g4 || 0, v2 || 0)], [p3.x, p3.y, Math.max(f3 || 0, m2 || 0, g4 || 0, v2 || 0)]];
          let y2 = e2.ca.fromPoints(x2);
          const b2 = n3.getWorldToCameraMatrix(), w2 = e2.a6.mat4.invert(new Float64Array(16), b2);
          y2 = e2.ca.applyTransform(y2, b2);
          const T3 = this._extendAABB(y2, n3, l3, s3);
          if (!T3) return void e2.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
          y2 = T3;
          const E3 = 0.5 * e2.a6.vec3.sub([], y2.max, y2.min)[2], S2 = this._minimumAABBFrustumDistance(n3, y2), C3 = [0, 0, 1, 0];
          e2.a6.vec4.transformMat4(C3, C3, b2), e2.a6.vec4.normalize(C3, C3);
          const I3 = e2.a6.vec3.scale([], C3, S2 + E3), D2 = e2.a6.vec3.add([], y2.center, I3);
          e2.a6.vec3.transformMat4(y2.center, y2.center, w2), e2.a6.vec3.transformMat4(D2, D2, w2);
          const R3 = n3.unproject(new e2.P(y2.center[0], y2.center[1])), A3 = e2.dv(n3.projection, R3), L3 = Math.pow(2, A3), P2 = Math.min(n3._zoomFromMercatorZ(D2[2] * n3.pixelsPerMeter * L3 / n3.worldSize), l3.maxZoom);
          return n3.mercatorFromTransition && P2 < 0.5 * (e2.c3 + e2.bV) ? (n3.setProjection({ name: "globe" }), n3.zoom = P2, this._cameraForBounds(n3, i3, o3, s3, r3, a4)) : { center: R3, zoom: P2, bearing: s3, pitch: r3 };
        }
        fitBounds(e3, t4, i3) {
          const o3 = this.cameraForBounds(e3, t4);
          return this._fitInternal(o3, t4, i3);
        }
        fitScreenCoordinates(t4, i3, o3, s3, r3) {
          const a4 = e2.P.convert(t4), n3 = e2.P.convert(i3), l3 = new e2.P(Math.min(a4.x, n3.x), Math.min(a4.y, n3.y)), c3 = new e2.P(Math.max(a4.x, n3.x), Math.max(a4.y, n3.y));
          if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(a4, n3)) return this;
          const h3 = this.transform.pointLocation3D(l3), u4 = this.transform.pointLocation3D(c3), d3 = this.transform.pointLocation3D(new e2.P(l3.x, c3.y)), _2 = this.transform.pointLocation3D(new e2.P(c3.x, l3.y)), p3 = [Math.min(h3.lng, u4.lng, d3.lng, _2.lng), Math.min(h3.lat, u4.lat, d3.lat, _2.lat)], f3 = [Math.max(h3.lng, u4.lng, d3.lng, _2.lng), Math.max(h3.lat, u4.lat, d3.lat, _2.lat)], m2 = s3 && s3.pitch ? s3.pitch : this.getPitch(), g4 = this._cameraForBounds(this.transform, p3, f3, o3, m2, s3);
          return this._fitInternal(g4, s3, r3);
        }
        _fitInternal(t4, i3, o3) {
          return t4 ? (i3 = e2.m(t4, i3)).linear ? this.easeTo(i3, o3) : this.flyTo(i3, o3) : this;
        }
        jumpTo(t4, i3) {
          this.stop();
          const o3 = t4.preloadOnly ? this.transform.clone() : this.transform;
          let s3 = false, r3 = false, a4 = false;
          "zoom" in t4 && o3.zoom !== +t4.zoom && (s3 = true, o3.zoom = +t4.zoom), void 0 !== t4.center && (o3.center = e2.bL.convert(t4.center)), "bearing" in t4 && o3.bearing !== +t4.bearing && (r3 = true, o3.bearing = +t4.bearing), "pitch" in t4 && o3.pitch !== +t4.pitch && (a4 = true, o3.pitch = +t4.pitch);
          const n3 = "number" == typeof t4.padding ? this._extendPadding(t4.padding) : t4.padding;
          if (null != t4.padding && !o3.isPaddingEqual(n3)) if (false === t4.retainPadding) {
            const e3 = o3.clone();
            e3.padding = n3, o3.setLocationAtPoint(o3.center, e3.centerPoint);
          } else o3.padding = n3;
          return t4.preloadOnly ? (this._preloadTiles(o3), this) : (this.fire(new e2.x("movestart", i3)).fire(new e2.x("move", i3)), s3 && this.fire(new e2.x("zoomstart", i3)).fire(new e2.x("zoom", i3)).fire(new e2.x("zoomend", i3)), r3 && this.fire(new e2.x("rotatestart", i3)).fire(new e2.x("rotate", i3)).fire(new e2.x("rotateend", i3)), a4 && this.fire(new e2.x("pitchstart", i3)).fire(new e2.x("pitch", i3)).fire(new e2.x("pitchend", i3)), this.fire(new e2.x("moveend", i3)));
        }
        getFreeCameraOptions() {
          return this.transform.projection.supportsFreeCamera || e2.w(Tn), this.transform.getFreeCameraOptions();
        }
        setFreeCameraOptions(t4, i3) {
          const o3 = this.transform;
          if (!o3.projection.supportsFreeCamera) return e2.w(Tn), this;
          this.stop();
          const s3 = o3.zoom, r3 = o3.pitch, a4 = o3.bearing;
          o3.setFreeCameraOptions(t4);
          const n3 = s3 !== o3.zoom, l3 = r3 !== o3.pitch, c3 = a4 !== o3.bearing;
          return this.fire(new e2.x("movestart", i3)).fire(new e2.x("move", i3)), n3 && this.fire(new e2.x("zoomstart", i3)).fire(new e2.x("zoom", i3)).fire(new e2.x("zoomend", i3)), c3 && this.fire(new e2.x("rotatestart", i3)).fire(new e2.x("rotate", i3)).fire(new e2.x("rotateend", i3)), l3 && this.fire(new e2.x("pitchstart", i3)).fire(new e2.x("pitch", i3)).fire(new e2.x("pitchend", i3)), this.fire(new e2.x("moveend", i3)), this;
        }
        easeTo(t4, i3) {
          this._stop(false, t4.easeId), (false === (t4 = e2.m({ offset: [0, 0], duration: 500, easing: e2.dr }, t4)).animate || this._prefersReducedMotion(t4)) && (t4.duration = 0);
          const o3 = this.transform, s3 = this.getZoom(), r3 = this.getBearing(), a4 = this.getPitch(), n3 = this.getPadding(), l3 = "zoom" in t4 ? +t4.zoom : s3, c3 = "bearing" in t4 ? this._normalizeBearing(t4.bearing, r3) : r3, h3 = "pitch" in t4 ? +t4.pitch : a4, u4 = this._extendPadding(t4.padding), d3 = e2.P.convert(t4.offset);
          let _2, p3, f3;
          if ("globe" === o3.projection.name) {
            const i4 = e2.a5.fromLngLat(o3.center), s4 = d3.rotate(-o3.angle);
            i4.x += s4.x / o3.worldSize, i4.y += s4.y / o3.worldSize;
            const r4 = i4.toLngLat(), a5 = e2.bL.convert(t4.center || r4);
            this._normalizeCenter(a5), _2 = o3.centerPoint.add(s4), p3 = new e2.P(i4.x, i4.y).mult(o3.worldSize), f3 = new e2.P(e2.am(a5.lng), e2.at(a5.lat)).mult(o3.worldSize).sub(p3);
          } else {
            _2 = o3.centerPoint.add(d3);
            const i4 = o3.pointLocation(_2), s4 = e2.bL.convert(t4.center || i4);
            this._normalizeCenter(s4), p3 = o3.project(i4), f3 = o3.project(s4).sub(p3);
          }
          const m2 = o3.zoomScale(l3 - s3);
          let g4, v2;
          t4.around && (g4 = e2.bL.convert(t4.around), v2 = o3.locationPoint(g4));
          const x2 = this._zooming || l3 !== s3, y2 = this._rotating || r3 !== c3, b2 = this._pitching || h3 !== a4, w2 = !o3.isPaddingEqual(u4), T3 = false === t4.retainPadding ? o3.clone() : o3, E3 = (o4) => (E4) => {
            if (x2 && (o4.zoom = e2.aa(s3, l3, E4)), y2 && (o4.bearing = e2.aa(r3, c3, E4)), b2 && (o4.pitch = e2.aa(a4, h3, E4)), w2 && (T3.interpolatePadding(n3, u4, E4), _2 = T3.centerPoint.add(d3)), g4) o4.setLocationAtPoint(g4, v2);
            else {
              const e3 = o4.zoomScale(o4.zoom - s3), t5 = l3 > s3 ? Math.min(2, m2) : Math.max(0.5, m2), i4 = Math.pow(t5, 1 - E4), r4 = o4.unproject(p3.add(f3.mult(E4 * i4)).mult(e3));
              o4.setLocationAtPoint(o4.renderWorldCopies ? r4.wrap() : r4, _2);
            }
            return t4.preloadOnly || this._fireMoveEvents(i3), o4;
          };
          if (t4.preloadOnly) {
            const e3 = this._emulate(E3, t4.duration, o3);
            return this._preloadTiles(e3), this;
          }
          const S2 = { moving: this._moving, zooming: this._zooming, rotating: this._rotating, pitching: this._pitching };
          return this._zooming = x2, this._rotating = y2, this._pitching = b2, this._padding = w2, this._easeId = t4.easeId, this._prepareEase(i3, t4.noMoveStart, S2), this._ease(E3(o3), (e3) => {
            "sea" === o3.cameraElevationReference && o3.recenterOnTerrain(), this._afterEase(i3, e3);
          }, t4), this;
        }
        _prepareEase(t4, i3, o3 = {}) {
          this._moving = true, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && 0 === this.transform.pitch && "globe" !== this.transform.projection.name && (this.transform.cameraElevationReference = "ground"), i3 || o3.moving || this.fire(new e2.x("movestart", t4)), this._zooming && !o3.zooming && this.fire(new e2.x("zoomstart", t4)), this._rotating && !o3.rotating && this.fire(new e2.x("rotatestart", t4)), this._pitching && !o3.pitching && this.fire(new e2.x("pitchstart", t4));
        }
        _fireMoveEvents(t4) {
          this.fire(new e2.x("move", t4)), this._zooming && this.fire(new e2.x("zoom", t4)), this._rotating && this.fire(new e2.x("rotate", t4)), this._pitching && this.fire(new e2.x("pitch", t4));
        }
        _afterEase(t4, i3) {
          if (this._easeId && i3 && this._easeId === i3) return;
          this._easeId = void 0, this.transform.cameraElevationReference = "ground";
          const o3 = this._zooming, s3 = this._rotating, r3 = this._pitching;
          this._moving = false, this._zooming = false, this._rotating = false, this._pitching = false, this._padding = false, o3 && this.fire(new e2.x("zoomend", t4)), s3 && this.fire(new e2.x("rotateend", t4)), r3 && this.fire(new e2.x("pitchend", t4)), this.fire(new e2.x("moveend", t4));
        }
        flyTo(t4, i3) {
          if (this._prefersReducedMotion(t4)) {
            const o4 = e2.ar(t4, ["center", "zoom", "bearing", "pitch", "around", "padding", "retainPadding"]);
            return this.jumpTo(o4, i3);
          }
          this.stop(), t4 = e2.m({ offset: [0, 0], speed: 1.2, curve: 1.42, easing: e2.dr }, t4);
          const o3 = this.transform, s3 = this.getZoom(), r3 = this.getBearing(), a4 = this.getPitch(), n3 = this.getPadding(), l3 = "zoom" in t4 ? e2.ap(+t4.zoom, o3.minZoom, o3.maxZoom) : s3, c3 = "bearing" in t4 ? this._normalizeBearing(t4.bearing, r3) : r3, h3 = "pitch" in t4 ? +t4.pitch : a4, u4 = this._extendPadding(t4.padding), d3 = o3.zoomScale(l3 - s3), _2 = e2.P.convert(t4.offset);
          let p3 = o3.centerPoint.add(_2);
          const f3 = o3.pointLocation(p3), m2 = e2.bL.convert(t4.center || f3);
          this._normalizeCenter(m2);
          const g4 = o3.project(f3), v2 = o3.project(m2).sub(g4);
          let x2 = t4.curve;
          const y2 = Math.max(o3.width, o3.height), b2 = y2 / d3, w2 = v2.mag();
          if ("minZoom" in t4) {
            const i4 = e2.ap(Math.min(t4.minZoom, s3, l3), o3.minZoom, o3.maxZoom), r4 = y2 / o3.zoomScale(i4 - s3);
            x2 = Math.sqrt(r4 / w2 * 2);
          }
          const T3 = x2 * x2;
          function E3(e3) {
            const t5 = (b2 * b2 - y2 * y2 + (e3 ? -1 : 1) * T3 * T3 * w2 * w2) / (2 * (e3 ? b2 : y2) * T3 * w2);
            return Math.log(Math.sqrt(t5 * t5 + 1) - t5);
          }
          function S2(e3) {
            return (Math.exp(e3) - Math.exp(-e3)) / 2;
          }
          function C3(e3) {
            return (Math.exp(e3) + Math.exp(-e3)) / 2;
          }
          const I3 = E3(0);
          let D2 = function(e3) {
            return C3(I3) / C3(I3 + x2 * e3);
          }, R3 = function(e3) {
            return y2 * ((C3(I3) * (S2(t5 = I3 + x2 * e3) / C3(t5)) - S2(I3)) / T3) / w2;
            var t5;
          }, A3 = (E3(1) - I3) / x2;
          if (Math.abs(w2) < 1e-6 || !isFinite(A3)) {
            if (Math.abs(y2 - b2) < 1e-6) return this.easeTo(t4, i3);
            const e3 = b2 < y2 ? -1 : 1;
            A3 = Math.abs(Math.log(b2 / y2)) / x2, R3 = function() {
              return 0;
            }, D2 = function(t5) {
              return Math.exp(e3 * x2 * t5);
            };
          }
          t4.duration = "duration" in t4 ? +t4.duration : 1e3 * A3 / ("screenSpeed" in t4 ? +t4.screenSpeed / x2 : +t4.speed), t4.maxDuration && t4.duration > t4.maxDuration && (t4.duration = 0);
          const L3 = r3 !== c3, P2 = h3 !== a4, M2 = !o3.isPaddingEqual(u4), z3 = false === t4.retainPadding ? o3.clone() : o3, O2 = (o4) => (d4) => {
            const f4 = d4 * A3, x3 = 1 / D2(f4);
            o4.zoom = 1 === d4 ? l3 : s3 + o4.scaleZoom(x3), L3 && (o4.bearing = e2.aa(r3, c3, d4)), P2 && (o4.pitch = e2.aa(a4, h3, d4)), M2 && (z3.interpolatePadding(n3, u4, d4), p3 = z3.centerPoint.add(_2));
            const y3 = 1 === d4 ? m2 : o4.unproject(g4.add(v2.mult(R3(f4))).mult(x3));
            return o4.setLocationAtPoint(o4.renderWorldCopies ? y3.wrap() : y3, p3), o4._updateCameraOnTerrain(), t4.preloadOnly || this._fireMoveEvents(i3), o4;
          };
          if (t4.preloadOnly) {
            const e3 = this._emulate(O2, t4.duration, o3);
            return this._preloadTiles(e3), this;
          }
          return this._zooming = true, this._rotating = L3, this._pitching = P2, this._padding = M2, this._prepareEase(i3, false), this._ease(O2(o3), () => this._afterEase(i3), t4), this;
        }
        isEasing() {
          return !!this._easeFrameId;
        }
        stop() {
          return this._stop();
        }
        _requestRenderFrame(e3) {
        }
        _cancelRenderFrame(e3) {
        }
        _stop(e3, t4) {
          if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
            const e4 = this._onEaseEnd;
            this._onEaseEnd = void 0, e4.call(this, t4);
          }
          if (!e3) {
            const e4 = this.handlers;
            e4 && e4.stop(false);
          }
          return this;
        }
        _ease(t4, i3, o3) {
          false === o3.animate || 0 === o3.duration ? (t4(1), i3()) : (this._easeStart = e2.e.now(), this._easeOptions = o3, this._onEaseFrame = t4, this._onEaseEnd = i3, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
        }
        _renderFrameCallback() {
          const t4 = Math.min((e2.e.now() - this._easeStart) / this._easeOptions.duration, 1), i3 = this._onEaseFrame;
          i3 && i3(this._easeOptions.easing(t4)), t4 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
        }
        _normalizeBearing(t4, i3) {
          t4 = e2.bB(t4, -180, 180);
          const o3 = Math.abs(t4 - i3);
          return Math.abs(t4 - 360 - i3) < o3 && (t4 -= 360), Math.abs(t4 + 360 - i3) < o3 && (t4 += 360), t4;
        }
        _normalizeCenter(e3) {
          const t4 = this.transform;
          if (t4.maxBounds) return;
          if ("globe" !== t4.projection.name && !t4.renderWorldCopies) return;
          const i3 = e3.lng - t4.center.lng;
          e3.lng += i3 > 180 ? -360 : i3 < -180 ? 360 : 0;
        }
        _prefersReducedMotion(t4) {
          return this._respectPrefersReducedMotion && e2.e.prefersReducedMotion && !(t4 && t4.essential);
        }
        _emulate(e3, t4, i3) {
          const o3 = Math.ceil(15 * t4 / 1e3), s3 = [], r3 = e3(i3.clone());
          for (let e4 = 0; e4 <= o3; e4++) {
            const t5 = r3(e4 / o3);
            s3.push(t5.clone());
          }
          return s3;
        }
        _preloadTiles(e3, t4) {
        }
      }
      class Sn2 {
        constructor(t4 = {}) {
          this.options = t4, e2.aJ(["_toggleAttribution", "_updateEditLink", "_updateData", "_updateCompact"], this);
        }
        getDefaultPosition() {
          return "bottom-right";
        }
        onAdd(e3) {
          const t4 = this.options && this.options.compact, i3 = e3._getUIString("AttributionControl.ToggleAttribution");
          this._map = e3, this._container = l2("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = l2("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._compactButton.setAttribute("aria-label", i3);
          const o3 = l2("span", "mapboxgl-ctrl-icon", this._compactButton);
          return o3.setAttribute("aria-hidden", "true"), o3.setAttribute("title", i3), this._innerContainer = l2("div", "mapboxgl-ctrl-attrib-inner", this._container), t4 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t4 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
        }
        onRemove() {
          this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
        }
        _toggleAttribution() {
          this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
        }
        _updateEditLink() {
          let t4 = this._editLink;
          t4 || (t4 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
          const i3 = [{ key: "owner", value: this.styleOwner }, { key: "id", value: this.styleId }, { key: "access_token", value: this._map._requestManager._customAccessToken || e2.f.ACCESS_TOKEN }];
          if (t4) {
            const o3 = i3.reduce((e3, t5, o4) => (t5.value && (e3 += `${t5.key}=${t5.value}${o4 < i3.length - 1 ? "&" : ""}`), e3), "?");
            t4.href = `${e2.f.FEEDBACK_URL}/${o3}#${Ca(this._map, true)}`, t4.rel = "noopener nofollow";
          }
        }
        _updateData(e3) {
          !e3 || "metadata" !== e3.sourceDataType && "visibility" !== e3.sourceDataType && "style" !== e3.dataType || (this._updateAttributions(), this._updateEditLink());
        }
        _updateAttributions() {
          if (!this._map.style) return;
          let e3 = [];
          if (this._map.style.stylesheet) {
            const e4 = this._map.style.stylesheet;
            this.styleOwner = e4.owner, this.styleId = e4.id;
          }
          const t4 = this._map.style._mergedSourceCaches;
          for (const i4 in t4) {
            const o3 = t4[i4];
            if (o3.used) {
              const t5 = o3.getSource();
              t5.attribution && e3.indexOf(t5.attribution) < 0 && e3.push(t5.attribution);
            }
          }
          e3.sort((e4, t5) => e4.length - t5.length), e3 = e3.filter((t5, i4) => {
            for (let o3 = i4 + 1; o3 < e3.length; o3++) if (e3[o3].indexOf(t5) >= 0) return false;
            return true;
          }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e3 = [...this.options.customAttribution, ...e3] : e3.unshift(this.options.customAttribution));
          const i3 = e3.join(" | ");
          i3 !== this._attribHTML && (this._attribHTML = i3, e3.length ? (this._innerContainer.innerHTML = i3, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
        }
        _updateCompact() {
          this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
        }
      }
      class Cn {
        constructor() {
          e2.aJ(["_updateLogo", "_updateCompact"], this);
        }
        onAdd(e3) {
          this._map = e3, this._container = l2("div", "mapboxgl-ctrl");
          const t4 = l2("a", "mapboxgl-ctrl-logo");
          return t4.target = "_blank", t4.rel = "noopener nofollow", t4.href = "https://www.mapbox.com/", t4.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t4.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t4), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
        }
        onRemove() {
          this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
        }
        getDefaultPosition() {
          return "bottom-left";
        }
        _updateLogo(e3) {
          e3 && "metadata" !== e3.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
        }
        _logoRequired() {
          if (!this._map.style) return true;
          const e3 = this._map.style._sourceCaches;
          if (0 === Object.entries(e3).length) return true;
          for (const t4 in e3) {
            const i3 = e3[t4].getSource();
            if (i3.hasOwnProperty("mapbox_logo") && !i3.mapbox_logo) return false;
          }
          return true;
        }
        _updateCompact() {
          const e3 = this._container.children;
          if (e3.length) {
            const t4 = e3[0];
            this._map.getCanvasContainer().offsetWidth < 250 ? t4.classList.add("mapboxgl-compact") : t4.classList.remove("mapboxgl-compact");
          }
        }
      }
      class In2 {
        constructor() {
          this._queue = [], this._id = 0, this._cleared = false, this._currentlyRunning = false;
        }
        add(e3) {
          const t4 = ++this._id;
          return this._queue.push({ callback: e3, id: t4, cancelled: false }), t4;
        }
        remove(e3) {
          const t4 = this._currentlyRunning, i3 = t4 ? this._queue.concat(t4) : this._queue;
          for (const t5 of i3) if (t5.id === e3) return void (t5.cancelled = true);
        }
        run(e3 = 0) {
          const t4 = this._currentlyRunning = this._queue;
          this._queue = [];
          for (const i3 of t4) if (!i3.cancelled && (i3.callback(e3), this._cleared)) break;
          this._cleared = false, this._currentlyRunning = false;
        }
        clear() {
          this._currentlyRunning && (this._cleared = true), this._queue = [];
        }
      }
      class Dn {
        constructor(e3) {
          this.jumpTo(e3);
        }
        getValue(t4) {
          if (t4 <= this._startTime) return this._start;
          if (t4 >= this._endTime) return this._end;
          const i3 = e2.cw((t4 - this._startTime) / (this._endTime - this._startTime));
          return this._start * (1 - i3) + this._end * i3;
        }
        isEasing(e3) {
          return e3 >= this._startTime && e3 <= this._endTime;
        }
        jumpTo(e3) {
          this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e3, this._end = e3;
        }
        easeTo(e3, t4, i3) {
          this._start = this.getValue(t4), this._end = e3, this._startTime = t4, this._endTime = t4 + i3;
        }
      }
      const Rn = { "AttributionControl.ToggleAttribution": "Toggle attribution", "FullscreenControl.Enter": "Enter fullscreen", "FullscreenControl.Exit": "Exit fullscreen", "GeolocateControl.FindMyLocation": "Find my location", "GeolocateControl.LocationNotAvailable": "Location not available", "LogoControl.Title": "Mapbox homepage", "Map.Title": "Map", "NavigationControl.ResetBearing": "Reset bearing to north", "NavigationControl.ZoomIn": "Zoom in", "NavigationControl.ZoomOut": "Zoom out", "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map", "ScrollZoomBlocker.CmdMessage": "Use ⌘ + scroll to zoom the map", "TouchPanBlocker.Message": "Use two fingers to move the map" }, An = ["mouseenter", "mouseover", "mouseleave", "mouseout"];
      class Ln extends e2.x {
        constructor(e3, t4, i3, o3) {
          const { point: s3, lngLat: r3, originalEvent: a4, target: n3 } = e3;
          super(e3.type, { point: s3, lngLat: r3, originalEvent: a4, target: n3 }), this.preventDefault = () => {
            e3.preventDefault();
          }, this.id = t4, this.interaction = i3, this.feature = o3;
        }
      }
      class Pn {
        constructor(e3) {
          this.map = e3, this.interactionsByType = /* @__PURE__ */ new Map(), this.typeById = /* @__PURE__ */ new Map(), this.filters = /* @__PURE__ */ new Map(), this.handleType = this.handleType.bind(this);
        }
        add(t4, i3) {
          if (this.typeById.has(t4)) throw new Error(`Interaction id "${t4}" already exists.`);
          const { type: o3, filter: s3 } = i3;
          if (s3) {
            const i4 = e2.M(s3, { type: "boolean", "property-type": "data-driven", overridable: false, transition: false });
            if ("error" === i4.result) throw new Error(i4.value.map((e3) => `${e3.key}: ${e3.message}`).join(", "));
            this.filters.set(t4, i4.value);
          }
          const r3 = this.interactionsByType.get(o3) || /* @__PURE__ */ new Map();
          0 === r3.size && (An.includes(o3) ? this.map.on(o3, i3.featureset, this.handleType) : this.map.on(o3, this.handleType), this.interactionsByType.set(o3, r3)), r3.set(t4, i3), this.typeById.set(t4, o3);
        }
        remove(e3) {
          const t4 = this.typeById.get(e3);
          if (!t4) return;
          this.typeById.delete(e3), this.filters.delete(e3);
          const i3 = this.interactionsByType.get(t4);
          i3 && (i3.delete(e3), 0 === i3.size && this.map.off(t4, this.handleType));
        }
        handleType(t4) {
          const i3 = this.interactionsByType.get(t4.type), o3 = Array.from(i3).reverse(), s3 = [];
          for (const [, e3] of o3) e3.featureset && s3.push({ featureset: e3.featureset, filter: e3.filter, radius: e3.radius });
          let r3 = this.map.style.queryRenderedFeaturesForInteractions(t4.point, s3, this.map.transform);
          !r3.length && An.includes(t4.type) && (r3 = [null]);
          let a4 = false;
          for (const i4 of r3) {
            for (const [s4, r4] of o3) {
              const { handler: o4, featureset: n3 } = r4;
              if (n3 && (null == i4 || e2.bi(i4.featureset, n3)) && false !== o4(new Ln(t4, s4, r4, i4))) {
                a4 = true;
                break;
              }
            }
            if (a4) break;
          }
          if (!a4) for (const [e3, i4] of o3) {
            const { handler: o4, featureset: s4 } = i4;
            if (!s4 && false !== o4(new Ln(t4, e3, i4, null))) break;
          }
        }
      }
      function Mn(t4, i3) {
        if (Array.isArray(t4) && Array.isArray(i3)) {
          const e3 = new Set(t4), o3 = new Set(i3);
          return e3.size === o3.size && t4.every((e4) => o3.has(e4));
        }
        return e2.bi(t4, i3);
      }
      const zn = { center: [0, 0], zoom: 0, bearing: 0, pitch: 0, minZoom: -2, maxZoom: 22, minPitch: 0, maxPitch: 85, interactive: true, scrollZoom: true, boxZoom: true, dragRotate: true, dragPan: true, keyboard: true, doubleClickZoom: true, touchZoomRotate: true, touchPitch: true, cooperativeGestures: false, performanceMetricsCollection: true, bearingSnap: 7, clickTolerance: 3, pitchWithRotate: true, hash: false, attributionControl: true, antialias: false, failIfMajorPerformanceCaveat: false, preserveDrawingBuffer: false, trackResize: true, renderWorldCopies: true, refreshExpiredTiles: true, minTileCacheSize: null, maxTileCacheSize: null, localIdeographFontFamily: "sans-serif", localFontFamily: null, transformRequest: null, accessToken: null, fadeDuration: 300, respectPrefersReducedMotion: true, crossSourceCollisions: true, collectResourceTiming: false, testMode: false, precompilePrograms: true, scaleFactor: 1, enableOIT: false }, On = { showCompass: true, showZoom: true, visualizePitch: false };
      class Fn {
        constructor(t4, i3, o3 = false) {
          this._clickTolerance = 10, this.element = i3, this.mouseRotate = new $a({ clickTolerance: t4.dragRotate._mouseRotate._clickTolerance }), this.map = t4, o3 && (this.mousePitch = new Xa({ clickTolerance: t4.dragRotate._mousePitch._clickTolerance })), e2.aJ(["mousedown", "mousemove", "mouseup", "touchstart", "touchmove", "touchend", "reset"], this), i3.addEventListener("mousedown", this.mousedown), i3.addEventListener("touchstart", this.touchstart, { passive: false }), i3.addEventListener("touchmove", this.touchmove), i3.addEventListener("touchend", this.touchend), i3.addEventListener("touchcancel", this.reset);
        }
        down(e3, t4) {
          this.mouseRotate.mousedown(e3, t4), this.mousePitch && this.mousePitch.mousedown(e3, t4), _();
        }
        move(e3, t4) {
          const i3 = this.map, o3 = this.mouseRotate.mousemoveWindow(e3, t4), s3 = o3 && o3.bearingDelta;
          if (s3 && i3.setBearing(i3.getBearing() + s3), this.mousePitch) {
            const o4 = this.mousePitch.mousemoveWindow(e3, t4), s4 = o4 && o4.pitchDelta;
            s4 && i3.setPitch(i3.getPitch() + s4);
          }
        }
        off() {
          const e3 = this.element;
          e3.removeEventListener("mousedown", this.mousedown), e3.removeEventListener("touchstart", this.touchstart, { passive: false }), e3.removeEventListener("touchmove", this.touchmove), e3.removeEventListener("touchend", this.touchend), e3.removeEventListener("touchcancel", this.reset), this.offTemp();
        }
        offTemp() {
          p2(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup);
        }
        mousedown(t4) {
          this.down(e2.m({}, t4, { ctrlKey: true, preventDefault: () => t4.preventDefault() }), g3(this.element, t4)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
        }
        mousemove(e3) {
          this.move(e3, g3(this.element, e3));
        }
        mouseup(e3) {
          this.mouseRotate.mouseupWindow(e3), this.mousePitch && this.mousePitch.mouseupWindow(e3), this.offTemp();
        }
        touchstart(e3) {
          1 !== e3.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = v(this.element, e3.targetTouches)[0], this.down({ type: "mousedown", button: 0, ctrlKey: true, preventDefault: () => e3.preventDefault() }, this._startPos));
        }
        touchmove(e3) {
          1 !== e3.targetTouches.length ? this.reset() : (this._lastPos = v(this.element, e3.targetTouches)[0], this.move({ preventDefault: () => e3.preventDefault() }, this._lastPos));
        }
        touchend(e3) {
          0 === e3.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
        }
        reset() {
          this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
        }
      }
      function Bn(t4, i3, o3) {
        if (t4 = new e2.bL(t4.lng, t4.lat), i3) {
          const s3 = new e2.bL(t4.lng - 360, t4.lat), r3 = new e2.bL(t4.lng + 360, t4.lat), a4 = 360 * Math.ceil(Math.abs(t4.lng - o3.center.lng) / 360), n3 = o3.locationPoint(t4).distSqr(i3), l3 = i3.x < 0 || i3.y < 0 || i3.x > o3.width || i3.y > o3.height;
          o3.locationPoint(s3).distSqr(i3) < n3 && (l3 || Math.abs(s3.lng - o3.center.lng) < a4) ? t4 = s3 : o3.locationPoint(r3).distSqr(i3) < n3 && (l3 || Math.abs(r3.lng - o3.center.lng) < a4) && (t4 = r3);
        }
        for (; Math.abs(t4.lng - o3.center.lng) > 180; ) {
          const e3 = o3.locationPoint(t4);
          if (e3.x >= 0 && e3.y >= 0 && e3.x <= o3.width && e3.y <= o3.height) break;
          t4.lng > o3.center.lng ? t4.lng -= 360 : t4.lng += 360;
        }
        return t4;
      }
      const kn = { center: "translate(-50%,-50%)", top: "translate(-50%,0)", "top-left": "translate(0,0)", "top-right": "translate(-100%,0)", bottom: "translate(-50%,-100%)", "bottom-left": "translate(0,-100%)", "bottom-right": "translate(-100%,-100%)", left: "translate(0,-50%)", right: "translate(-100%,-50%)" };
      class Nn extends e2.E {
        constructor(t4, i3) {
          if (super(), (t4 instanceof HTMLElement || i3) && (t4 = e2.m({ element: t4 }, i3)), e2.aJ(["_update", "_onMove", "_onUp", "_addDragHandler", "_onMapClick", "_onKeyPress", "_clearFadeTimer"], this), this._anchor = t4 && t4.anchor || "center", this._color = t4 && t4.color || "#3FB1CE", this._scale = t4 && t4.scale || 1, this._draggable = t4 && t4.draggable || false, this._clickTolerance = t4 && t4.clickTolerance || 0, this._isDragging = false, this._state = "inactive", this._rotation = t4 && t4.rotation || 0, this._rotationAlignment = t4 && t4.rotationAlignment || "auto", this._pitchAlignment = t4 && t4.pitchAlignment && t4.pitchAlignment || "auto", this._updateMoving = () => this._update(true), this._occludedOpacity = t4 && t4.occludedOpacity || 0.2, t4 && t4.element) this._element = t4.element, this._offset = e2.P.convert(t4 && t4.offset || [0, 0]);
          else {
            this._defaultMarker = true, this._element = l2("div");
            const i4 = 41, o4 = 27, s4 = c2("svg", { display: "block", height: i4 * this._scale + "px", width: o4 * this._scale + "px", viewBox: `0 0 ${o4} ${i4}` }, this._element), r3 = c2("radialGradient", { id: "shadowGradient" }, c2("defs", {}, s4));
            c2("stop", { offset: "10%", "stop-opacity": 0.4 }, r3), c2("stop", { offset: "100%", "stop-opacity": 0.05 }, r3), c2("ellipse", { cx: 13.5, cy: 34.8, rx: 10.5, ry: 5.25, fill: "url(#shadowGradient)" }, s4), c2("path", { fill: this._color, d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z" }, s4), c2("path", { opacity: 0.25, d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z" }, s4), c2("circle", { fill: "white", cx: 13.5, cy: 13.5, r: 5.5 }, s4), this._offset = e2.P.convert(t4 && t4.offset || [0, -14]);
          }
          this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.hasAttribute("role") || this._element.setAttribute("role", "img"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e3) => {
            e3.preventDefault();
          }), this._element.addEventListener("mousedown", (e3) => {
            e3.preventDefault();
          });
          const o3 = this._element.classList;
          for (const e3 in kn) o3.remove(`mapboxgl-marker-anchor-${e3}`);
          o3.add(`mapboxgl-marker-anchor-${this._anchor}`);
          const s3 = t4 && t4.className ? t4.className.trim().split(/\s+/) : [];
          o3.add(...s3), this._popup = null;
        }
        addTo(e3) {
          return e3 === this._map || (this.remove(), this._map = e3, e3.getCanvasContainer().appendChild(this._element), e3.on("move", this._updateMoving), e3.on("moveend", this._update), e3.on("remove", this._clearFadeTimer), e3._addMarker(this), this.setDraggable(this._draggable), this._update(), e3.on("click", this._onMapClick)), this;
        }
        remove() {
          const e3 = this._map;
          return e3 && (e3.off("click", this._onMapClick), e3.off("move", this._updateMoving), e3.off("moveend", this._update), e3.off("mousedown", this._addDragHandler), e3.off("touchstart", this._addDragHandler), e3.off("mouseup", this._onUp), e3.off("touchend", this._onUp), e3.off("mousemove", this._onMove), e3.off("touchmove", this._onMove), e3.off("remove", this._clearFadeTimer), e3._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
        }
        getLngLat() {
          return this._lngLat;
        }
        setLngLat(t4) {
          return this._lngLat = e2.bL.convert(t4), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(true), this;
        }
        getElement() {
          return this._element;
        }
        setPopup(e3) {
          if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e3) {
            if (!("offset" in e3.options)) {
              const t4 = 38.1, i3 = 13.5, o3 = Math.sqrt(Math.pow(i3, 2) / 2);
              e3.options.offset = this._defaultMarker ? { top: [0, 0], "top-left": [0, 0], "top-right": [0, 0], bottom: [0, -t4], "bottom-left": [o3, -1 * (t4 - i3 + o3)], "bottom-right": [-o3, -1 * (t4 - i3 + o3)], left: [i3, -1 * (t4 - i3)], right: [-i3, -1 * (t4 - i3)] } : this._offset;
            }
            this._popup = e3, e3._marker = this, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
          }
          return this;
        }
        _onKeyPress(e3) {
          const t4 = e3.code, i3 = e3.charCode || e3.keyCode;
          "Space" !== t4 && "Enter" !== t4 && 32 !== i3 && 13 !== i3 || this.togglePopup();
        }
        _onMapClick(e3) {
          const t4 = e3.originalEvent.target, i3 = this._element;
          this._popup && (t4 === i3 || i3.contains(t4)) && this.togglePopup();
        }
        getPopup() {
          return this._popup;
        }
        togglePopup() {
          const e3 = this._popup;
          return e3 ? (e3.isOpen() ? (e3.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e3.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
        }
        _behindTerrain() {
          const e3 = this._map, t4 = this._pos;
          if (!e3 || !t4) return false;
          const i3 = e3.unproject(t4), o3 = e3.getFreeCameraOptions();
          if (!o3.position) return false;
          const s3 = o3.position.toLngLat();
          return s3.distanceTo(i3) < 0.9 * s3.distanceTo(this._lngLat);
        }
        _evaluateOpacity() {
          const t4 = this._map;
          if (!t4) return;
          const i3 = this._pos;
          if (!i3 || i3.x < 0 || i3.x > t4.transform.width || i3.y < 0 || i3.y > t4.transform.height) return void this._clearFadeTimer();
          const o3 = t4.unproject(i3);
          let s3;
          t4._showingGlobe() && e2.dz(t4.transform, this._lngLat) ? s3 = 0 : (s3 = 1 - t4._queryFogOpacity(o3), t4.transform._terrainEnabled() && t4.getTerrain() && this._behindTerrain() && (s3 *= this._occludedOpacity)), this._element.style.opacity = `${s3}`, this._element.style.pointerEvents = s3 > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(s3), this._fadeTimer = null;
        }
        _clearFadeTimer() {
          this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
        }
        _updateDOM() {
          const e3 = this._pos;
          if (!e3 || !this._map) return;
          const t4 = this._offset.mult(this._scale);
          this._element.style.transform = `
            translate(${e3.x}px,${e3.y}px)
            ${kn[this._anchor]}
            ${this._calculateXYTransform()} ${this._calculateZTransform()}
            translate(${t4.x}px,${t4.y}px)
        `;
        }
        _calculateXYTransform() {
          const t4 = this._pos, i3 = this._map, o3 = this.getPitchAlignment();
          if (!i3 || !t4 || "map" !== o3) return "";
          if (!i3._showingGlobe()) {
            const e3 = i3.getPitch();
            return e3 ? `rotateX(${e3}deg)` : "";
          }
          const s3 = e2.c1(e2.dA(i3.transform, this._lngLat)), r3 = t4.sub(e2.dB(i3.transform)), a4 = Math.abs(r3.x) + Math.abs(r3.y);
          if (0 === a4) return "";
          const n3 = s3 / a4;
          return `rotateX(${-r3.y * n3}deg) rotateY(${r3.x * n3}deg)`;
        }
        _calculateZTransform() {
          const t4 = this._pos, i3 = this._map;
          if (!i3 || !t4) return "";
          let o3 = 0;
          const s3 = this.getRotationAlignment();
          if ("map" === s3) if (i3._showingGlobe()) {
            const t5 = i3.project(new e2.bL(this._lngLat.lng, this._lngLat.lat + 1e-3)), s4 = i3.project(new e2.bL(this._lngLat.lng, this._lngLat.lat - 1e-3)).sub(t5);
            o3 = e2.c1(Math.atan2(s4.y, s4.x)) - 90;
          } else o3 = -i3.getBearing();
          else if ("horizon" === s3) {
            const s4 = e2.a7(4, 6, i3.getZoom()), r3 = e2.dB(i3.transform);
            r3.y += s4 * i3.transform.height;
            const a4 = t4.sub(r3), n3 = e2.c1(Math.atan2(a4.y, a4.x));
            o3 = (n3 > 90 ? n3 - 270 : n3 + 90) * (1 - s4);
          }
          return o3 += this._rotation, o3 ? `rotateZ(${o3}deg)` : "";
        }
        _update(e3) {
          cancelAnimationFrame(this._updateFrameId);
          const t4 = this._map;
          t4 && (t4.transform.renderWorldCopies && (this._lngLat = Bn(this._lngLat, this._pos, t4.transform)), this._pos = t4.project(this._lngLat), true === e3 ? this._updateFrameId = requestAnimationFrame(() => {
            this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
          }) : this._pos = this._pos.round(), t4._requestDomTask(() => {
            this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (t4._showingGlobe() || t4.getTerrain() || t4.getFog()) && !this._fadeTimer && (this._fadeTimer = window.setTimeout(this._evaluateOpacity.bind(this), 60)));
          }));
        }
        getOffset() {
          return this._offset;
        }
        setOffset(t4) {
          return this._offset = e2.P.convert(t4), this._update(), this;
        }
        addClassName(e3) {
          return this._element.classList.add(e3), this;
        }
        removeClassName(e3) {
          return this._element.classList.remove(e3), this;
        }
        toggleClassName(e3) {
          return this._element.classList.toggle(e3);
        }
        _onMove(t4) {
          const i3 = this._map;
          if (!i3) return;
          const o3 = this._pointerdownPos, s3 = this._positionDelta;
          if (o3 && s3) {
            if (!this._isDragging) {
              const e3 = this._clickTolerance || i3._clickTolerance;
              if (t4.point.dist(o3) < e3) return;
              this._isDragging = true;
            }
            this._pos = t4.point.sub(s3), this._lngLat = i3.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e2.x("dragstart"))), this.fire(new e2.x("drag"));
          }
        }
        _onUp() {
          this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = false;
          const t4 = this._map;
          t4 && (t4.off("mousemove", this._onMove), t4.off("touchmove", this._onMove)), "active" === this._state && this.fire(new e2.x("dragend")), this._state = "inactive";
        }
        _addDragHandler(e3) {
          const t4 = this._map, i3 = this._pos;
          t4 && i3 && this._element.contains(e3.originalEvent.target) && (e3.preventDefault(), this._positionDelta = e3.point.sub(i3), this._pointerdownPos = e3.point, this._state = "pending", t4.on("mousemove", this._onMove), t4.on("touchmove", this._onMove), t4.once("mouseup", this._onUp), t4.once("touchend", this._onUp));
        }
        setDraggable(e3) {
          this._draggable = !!e3;
          const t4 = this._map;
          return t4 && (e3 ? (t4.on("mousedown", this._addDragHandler), t4.on("touchstart", this._addDragHandler)) : (t4.off("mousedown", this._addDragHandler), t4.off("touchstart", this._addDragHandler))), this;
        }
        isDraggable() {
          return this._draggable;
        }
        setRotation(e3) {
          return this._rotation = e3 || 0, this._update(), this;
        }
        getRotation() {
          return this._rotation;
        }
        setRotationAlignment(e3) {
          return this._rotationAlignment = e3 || "auto", this._update(), this;
        }
        getRotationAlignment() {
          return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
        }
        setPitchAlignment(e3) {
          return this._pitchAlignment = e3 || "auto", this._update(), this;
        }
        getPitchAlignment() {
          return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
        }
        setOccludedOpacity(e3) {
          return this._occludedOpacity = e3 || 0.2, this._update(), this;
        }
        getOccludedOpacity() {
          return this._occludedOpacity;
        }
      }
      const Un2 = { positionOptions: { enableHighAccuracy: false, maximumAge: 0, timeout: 6e3 }, fitBoundsOptions: { maxZoom: 15 }, trackUserLocation: false, showAccuracyCircle: true, showUserLocation: true, showUserHeading: false }, Gn2 = { maxWidth: 100, unit: "metric" }, Vn = { kilometer: "km", meter: "m", mile: "mi", foot: "ft", "nautical-mile": "nm" }, jn = { closeButton: true, closeOnClick: true, focusAfterOpen: true, className: "", maxWidth: "240px" }, Hn = ["a[href]", "[tabindex]:not([tabindex='-1'])", "[contenteditable]:not([contenteditable='false'])", "button:not([disabled])", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].join(", ");
      function Zn(t4 = new e2.P(0, 0), i3 = "bottom") {
        if ("number" == typeof t4) {
          const o3 = Math.round(Math.sqrt(0.5 * Math.pow(t4, 2)));
          switch (i3) {
            case "top":
              return new e2.P(0, t4);
            case "top-left":
              return new e2.P(o3, o3);
            case "top-right":
              return new e2.P(-o3, o3);
            case "bottom":
              return new e2.P(0, -t4);
            case "bottom-left":
              return new e2.P(o3, -o3);
            case "bottom-right":
              return new e2.P(-o3, -o3);
            case "left":
              return new e2.P(t4, 0);
            case "right":
              return new e2.P(-t4, 0);
          }
          return new e2.P(0, 0);
        }
        return t4 instanceof e2.P || Array.isArray(t4) ? e2.P.convert(t4) : e2.P.convert(t4[i3] || [0, 0]);
      }
      const qn2 = { browser: e2.e, version: t3, supported: n2.supported, setRTLTextPlugin: e2.dC, getRTLTextPluginStatus: e2.dD, Map: class extends En {
        constructor(t4) {
          o2.mark(i2.create);
          const s3 = t4;
          if (null != (t4 = e2.m({}, zn, t4)).minZoom && null != t4.maxZoom && t4.minZoom > t4.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
          if (null != t4.minPitch && null != t4.maxPitch && t4.minPitch > t4.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
          if (null != t4.minPitch && t4.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
          if (null != t4.maxPitch && t4.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
          if (t4.antialias && e2.dx(window) && (t4.antialias = false, e2.w("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), super(new Zi2(t4.minZoom, t4.maxZoom, t4.minPitch, t4.maxPitch, t4.renderWorldCopies), t4), this._repaint = !!t4.repaint, this._interactive = t4.interactive, this._minTileCacheSize = t4.minTileCacheSize, this._maxTileCacheSize = t4.maxTileCacheSize, this._failIfMajorPerformanceCaveat = t4.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = t4.preserveDrawingBuffer, this._antialias = t4.antialias, this._trackResize = t4.trackResize, this._bearingSnap = t4.bearingSnap, this._refreshExpiredTiles = t4.refreshExpiredTiles, this._fadeDuration = t4.fadeDuration, this._isInitialLoad = true, this._crossSourceCollisions = t4.crossSourceCollisions, this._collectResourceTiming = t4.collectResourceTiming, this._language = this._parseLanguage(t4.language), this._worldview = t4.worldview, this._renderTaskQueue = new In2(), this._domRenderTaskQueue = new In2(), this._controls = [], this._markers = [], this._popups = [], this._mapId = e2.aQ(), this._locale = e2.m({}, Rn, t4.locale), this._clickTolerance = t4.clickTolerance, this._cooperativeGestures = t4.cooperativeGestures, this._performanceMetricsCollection = t4.performanceMetricsCollection, this._tessellationStep = t4.tessellationStep, this._containerWidth = 0, this._containerHeight = 0, this._showParseStatus = true, this._precompilePrograms = t4.precompilePrograms, this._scaleFactorChanged = false, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new Dn(0), this._interactionRange = [1 / 0, -1 / 0], this._visibilityHidden = 0, this._useExplicitProjection = false, this._frameId = 0, this._scaleFactor = t4.scaleFactor, this._enableOIT = t4.enableOIT, this._requestManager = new T2(t4.transformRequest, t4.accessToken, t4.testMode), this._silenceAuthErrors = !!t4.testMode, this._contextCreateOptions = t4.contextCreateOptions ? { ...t4.contextCreateOptions } : {}, "string" == typeof t4.container) {
            const e3 = document.getElementById(t4.container);
            if (!e3) throw new Error(`Container '${t4.container.toString()}' not found.`);
            this._container = e3;
          } else {
            if (!(t4.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
            this._container = t4.container;
          }
          if (this._container.childNodes.length > 0 && e2.w("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t4.maxBounds && this.setMaxBounds(t4.maxBounds), e2.aJ(["_onWindowOnline", "_onWindowResize", "_onVisibilityChange", "_onMapScroll", "_contextLost", "_contextRestored"], this), this._setupContainer(), this._tp || (this._tp = new ya()), this._tp.registerParameter(this, ["Debug"], "showOverdrawInspector"), this._tp.registerParameter(this, ["Debug"], "showTileBoundaries"), this._tp.registerParameter(this, ["Debug"], "showParseStatus"), this._tp.registerParameter(this, ["Debug"], "repaint"), this._tp.registerParameter(this, ["Debug"], "showTileAABBs"), this._tp.registerParameter(this, ["Debug"], "showPadding"), this._tp.registerParameter(this, ["Debug"], "showCollisionBoxes", { noSave: true }), this._tp.registerParameter(this.transform, ["Debug"], "freezeTileCoverage", { noSave: true }, () => {
            this._update();
          }), this._tp.registerParameter(this, ["Debug", "Wireframe"], "showTerrainWireframe"), this._tp.registerParameter(this, ["Debug", "Wireframe"], "showLayers2DWireframe"), this._tp.registerParameter(this, ["Debug", "Wireframe"], "showLayers3DWireframe"), this._tp.registerParameter(this, ["Scaling"], "_scaleFactor", { min: 0.1, max: 10, step: 0.1 }, () => {
            this.setScaleFactor(this._scaleFactor);
          }), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
          if (this.on("move", () => this._update(false)), this.on("moveend", () => this._update(false)), this.on("zoom", () => this._update(true)), this._fullscreenchangeEvent = "onfullscreenchange" in document ? "fullscreenchange" : "webkitfullscreenchange", window.addEventListener("online", this._onWindowOnline, false), window.addEventListener("resize", this._onWindowResize, false), window.addEventListener("orientationchange", this._onWindowResize, false), window.addEventListener(this._fullscreenchangeEvent, this._onWindowResize, false), window.addEventListener("visibilitychange", this._onVisibilityChange, false), this.handlers = new wn(this, t4), this._localFontFamily = t4.localFontFamily, this._localIdeographFontFamily = t4.localIdeographFontFamily, (t4.style || !t4.testMode) && this.setStyle(t4.style || e2.f.DEFAULT_STYLE, { config: t4.config, localFontFamily: this._localFontFamily, localIdeographFontFamily: this._localIdeographFontFamily }), t4.projection && this.setProjection(t4.projection), t4.hash && (this._hash = new Sa("string" == typeof t4.hash && t4.hash || void 0).addTo(this)), !this._hash || !this._hash._onHashChange()) {
            null == s3.center && null == s3.zoom || (this.transform._unmodified = false), this.jumpTo({ center: t4.center, zoom: t4.zoom, bearing: t4.bearing, pitch: t4.pitch });
            const i3 = t4.bounds;
            i3 && (this.resize(), this.fitBounds(i3, e2.m({}, t4.fitBoundsOptions, { duration: 0 })));
          }
          this.resize(), t4.attributionControl && this.addControl(new Sn2({ customAttribution: t4.customAttribution })), this._logoControl = new Cn(), this.addControl(this._logoControl, t4.logoPosition), this.on("style.load", () => {
            this.transform.unmodified && this.jumpTo(this.style.stylesheet), this._postStyleLoadEvent();
          }), this.on("data", (t5) => {
            this._update("style" === t5.dataType), this.fire(new e2.x(`${t5.dataType}data`, t5));
          }), this.on("dataloading", (t5) => {
            this.fire(new e2.x(`${t5.dataType}dataloading`, t5));
          }), this._interactions = new Pn(this);
        }
        _getMapId() {
          return this._mapId;
        }
        addControl(t4, i3) {
          if (void 0 === i3 && (i3 = t4.getDefaultPosition ? t4.getDefaultPosition() : "top-right"), !t4 || !t4.onAdd) return this.fire(new e2.t(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
          const o3 = t4.onAdd(this);
          this._controls.push(t4);
          const s3 = this._controlPositions[i3];
          return -1 !== i3.indexOf("bottom") ? s3.insertBefore(o3, s3.firstChild) : s3.appendChild(o3), this;
        }
        removeControl(t4) {
          if (!t4 || !t4.onRemove) return this.fire(new e2.t(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
          const i3 = this._controls.indexOf(t4);
          return i3 > -1 && this._controls.splice(i3, 1), t4.onRemove(this), this;
        }
        hasControl(e3) {
          return this._controls.indexOf(e3) > -1;
        }
        getContainer() {
          return this._container;
        }
        getCanvasContainer() {
          return this._canvasContainer;
        }
        getCanvas() {
          return this._canvas;
        }
        resize(t4) {
          if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
          this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
          const i3 = !this._moving;
          return i3 && this.fire(new e2.x("movestart", t4)).fire(new e2.x("move", t4)), this.fire(new e2.x("resize", t4)), i3 && this.fire(new e2.x("moveend", t4)), this;
        }
        getBounds() {
          return this.transform.getBounds();
        }
        getMaxBounds() {
          return this.transform.getMaxBounds() || null;
        }
        setMaxBounds(t4) {
          return this.transform.setMaxBounds(e2.as.convert(t4)), this._update();
        }
        setMinZoom(t4) {
          if ((t4 = t4 ?? -2) >= -2 && t4 <= this.transform.maxZoom) return this.transform.minZoom = t4, this._update(), this.getZoom() < t4 ? this.setZoom(t4) : this.fire(new e2.x("zoomstart")).fire(new e2.x("zoom")).fire(new e2.x("zoomend")), this;
          throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
        }
        getMinZoom() {
          return this.transform.minZoom;
        }
        setMaxZoom(t4) {
          if ((t4 = t4 ?? 22) >= this.transform.minZoom) return this.transform.maxZoom = t4, this._update(), this.getZoom() > t4 ? this.setZoom(t4) : this.fire(new e2.x("zoomstart")).fire(new e2.x("zoom")).fire(new e2.x("zoomend")), this;
          throw new Error("maxZoom must be greater than the current minZoom");
        }
        getMaxZoom() {
          return this.transform.maxZoom;
        }
        setMinPitch(t4) {
          if ((t4 = t4 ?? 0) < 0) throw new Error("minPitch must be greater than or equal to 0");
          if (t4 >= 0 && t4 <= this.transform.maxPitch) return this.transform.minPitch = t4, this._update(), this.getPitch() < t4 ? this.setPitch(t4) : this.fire(new e2.x("pitchstart")).fire(new e2.x("pitch")).fire(new e2.x("pitchend")), this;
          throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
        }
        getMinPitch() {
          return this.transform.minPitch;
        }
        setMaxPitch(t4) {
          if ((t4 = t4 ?? 85) > 85) throw new Error("maxPitch must be less than or equal to 85");
          if (t4 >= this.transform.minPitch) return this.transform.maxPitch = t4, this._update(), this.getPitch() > t4 ? this.setPitch(t4) : this.fire(new e2.x("pitchstart")).fire(new e2.x("pitch")).fire(new e2.x("pitchend")), this;
          throw new Error("maxPitch must be greater than or equal to minPitch");
        }
        getMaxPitch() {
          return this.transform.maxPitch;
        }
        getScaleFactor() {
          return this._scaleFactor;
        }
        setScaleFactor(e3) {
          return this._scaleFactor = e3, this.painter.scaleFactor = e3, this._tp.refreshUI(), this._scaleFactorChanged = true, this.style._updateFilteredLayers((e4) => "symbol" === e4.type), this._update(true), this;
        }
        getEnableOIT() {
          return this._enableOIT;
        }
        setEnableOIT(e3) {
          return this._enableOIT = e3, this.triggerRepaint(), this;
        }
        getRenderWorldCopies() {
          return this.transform.renderWorldCopies;
        }
        setRenderWorldCopies(e3) {
          return this.transform.renderWorldCopies = e3, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(true), this._update();
        }
        getLanguage() {
          return this._language;
        }
        _parseLanguage(e3) {
          return "auto" === e3 ? navigator.language : Array.isArray(e3) ? 0 === e3.length ? void 0 : e3.map((e4) => "auto" === e4 ? navigator.language : e4) : e3;
        }
        setLanguage(e3) {
          const t4 = this._parseLanguage(e3);
          if (!this.style || t4 === this._language) return this;
          this._language = t4, this.style.reloadSources();
          for (const e4 of this._controls) e4._setLanguage && e4._setLanguage(this._language);
          return this;
        }
        getWorldview() {
          return this._worldview;
        }
        setWorldview(e3) {
          return this.style && e3 !== this._worldview ? (this._worldview = e3, this.style.reloadSources(), this) : this;
        }
        getProjection() {
          return this.transform.mercatorFromTransition ? { name: "globe", center: [0, 0] } : this.transform.getProjection();
        }
        _showingGlobe() {
          return "globe" === this.transform.projection.name;
        }
        setProjection(e3) {
          return this._lazyInitEmptyStyle(), e3 ? "string" == typeof e3 && (e3 = { name: e3 }) : e3 = null, this._useExplicitProjection = !!e3, this._prioritizeAndUpdateProjection(e3, this.style.projection);
        }
        _updateProjectionTransition() {
          if ("globe" !== this.getProjection().name) return;
          const t4 = this.transform, i3 = t4.projection.name;
          let o3;
          "globe" === i3 && t4.zoom >= e2.bV ? (t4.setMercatorFromTransition(), o3 = true) : "mercator" === i3 && t4.zoom < e2.bV && (t4.setProjection({ name: "globe" }), o3 = true), o3 && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate());
        }
        _prioritizeAndUpdateProjection(e3, t4) {
          return this._updateProjection(e3 || t4 || { name: "mercator" });
        }
        _updateProjection(t4) {
          let i3;
          return i3 = "globe" === t4.name && this.transform.zoom >= e2.bV ? this.transform.setMercatorFromTransition() : this.transform.setProjection(t4), this.style.applyProjectionUpdate(), i3 && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(true), this._forceMarkerAndPopupUpdate(true)), this;
        }
        project(t4) {
          return this.transform.locationPoint3D(e2.bL.convert(t4));
        }
        unproject(t4) {
          return this.transform.pointLocation3D(e2.P.convert(t4));
        }
        isMoving() {
          return this._moving || this.handlers && this.handlers.isMoving() || false;
        }
        isZooming() {
          return this._zooming || this.handlers && this.handlers.isZooming() || false;
        }
        isRotating() {
          return this._rotating || this.handlers && this.handlers.isRotating() || false;
        }
        _isDragging() {
          return this.handlers && this.handlers._isDragging() || false;
        }
        _createDelegatedListener(e3, t4, i3) {
          const o3 = (e4) => {
            let i4 = [];
            if (Array.isArray(t4)) {
              const o4 = t4.filter((e5) => this.getLayer(e5));
              i4 = o4.length ? this.queryRenderedFeatures(e4, { layers: o4 }) : [];
            } else i4 = this.queryRenderedFeatures(e4, { featureset: t4 });
            return i4;
          };
          if ("mouseenter" === e3 || "mouseover" === e3) {
            let s3 = false;
            const r3 = (t5) => {
              const r4 = o3(t5.point);
              r4.length ? s3 || (s3 = true, i3.call(this, new Oa(e3, this, t5.originalEvent, { features: r4 }))) : s3 = false;
            };
            return { listener: i3, targets: t4, delegates: { mousemove: r3, mouseout: () => {
              s3 = false;
            } } };
          }
          if ("mouseleave" === e3 || "mouseout" === e3) {
            let s3 = false;
            const r3 = (t5) => {
              o3(t5.point).length ? s3 = true : s3 && (s3 = false, i3.call(this, new Oa(e3, this, t5.originalEvent)));
            }, a4 = (t5) => {
              s3 && (s3 = false, i3.call(this, new Oa(e3, this, t5.originalEvent)));
            };
            return { listener: i3, targets: t4, delegates: { mousemove: r3, mouseout: a4 } };
          }
          {
            const s3 = (e4) => {
              const t5 = o3(e4.point);
              t5.length && (e4.features = t5, i3.call(this, e4), delete e4.features);
            };
            return { listener: i3, targets: t4, delegates: { [e3]: s3 } };
          }
        }
        on(e3, t4, i3) {
          if ("function" == typeof t4 || void 0 === i3) return super.on(e3, t4);
          if ("string" == typeof t4 && (t4 = [t4]), !this._areTargetsValid(t4)) return this;
          const o3 = this._createDelegatedListener(e3, t4, i3);
          this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e3] = this._delegatedListeners[e3] || [], this._delegatedListeners[e3].push(o3);
          for (const e4 in o3.delegates) this.on(e4, o3.delegates[e4]);
          return this;
        }
        once(e3, t4, i3) {
          if ("function" == typeof t4 || void 0 === i3) return super.once(e3, t4);
          if ("string" == typeof t4 && (t4 = [t4]), !this._areTargetsValid(t4)) return this;
          const o3 = this._createDelegatedListener(e3, t4, i3);
          for (const e4 in o3.delegates) this.once(e4, o3.delegates[e4]);
          return this;
        }
        off(e3, t4, i3) {
          if ("function" == typeof t4 || void 0 === i3) return super.off(e3, t4);
          if ("string" == typeof t4 && (t4 = [t4]), !this._areTargetsValid(t4)) return this;
          const o3 = this._delegatedListeners ? this._delegatedListeners[e3] : void 0;
          return o3 && ((e4) => {
            for (let o4 = 0; o4 < e4.length; o4++) {
              const s3 = e4[o4];
              if (s3.listener === i3 && Mn(s3.targets, t4)) {
                for (const e5 in s3.delegates) this.off(e5, s3.delegates[e5]);
                return e4.splice(o4, 1), this;
              }
            }
          })(o3), this;
        }
        queryRenderedFeatures(t4, i3) {
          if (!this.style) return [];
          if (void 0 !== i3 || void 0 === t4 || t4 instanceof e2.P || Array.isArray(t4) || (i3 = t4, t4 = void 0), t4 = t4 || [[0, 0], [this.transform.width, this.transform.height]], "featureset" in (i3 = i3 || {})) return this._isFeaturesetDescriptorValid(i3.featureset) ? this.style.queryRenderedFeaturesForInteractions(t4, [i3], this.transform) : [];
          if (i3.layers && Array.isArray(i3.layers)) {
            for (const e3 of i3.layers) if (!this._isValidId(e3)) return [];
          }
          return this.style.queryRenderedFeatures(t4, i3, this.transform);
        }
        querySourceFeatures(e3, t4) {
          return !e3 || "string" == typeof e3 && !this._isValidId(e3) ? [] : this.style.querySourceFeatures(e3, t4);
        }
        isPointOnSurface(t4) {
          const { name: i3 } = this.transform.projection;
          return "globe" !== i3 && "mercator" !== i3 && e2.w(`${i3} projection does not support isPointOnSurface, this API may behave unexpectedly.`), this.transform.isPointOnSurface(e2.P.convert(t4));
        }
        addInteraction(e3, t4) {
          return this._interactions.add(e3, t4), this;
        }
        removeInteraction(e3) {
          return this._interactions.remove(e3), this;
        }
        setStyle(t4, i3) {
          return i3 = e2.m({}, { localIdeographFontFamily: this._localIdeographFontFamily, localFontFamily: this._localFontFamily }, i3), this.style && t4 && false !== i3.diff && i3.localFontFamily === this._localFontFamily && i3.localIdeographFontFamily === this._localIdeographFontFamily && !i3.config ? (this.style._diffStyle(t4, (o3, s3) => {
            o3 ? (e2.w(`Unable to perform style diff: ${String(o3.message || o3.error || o3)}. Rebuilding the style from scratch.`), this._updateStyle(t4, i3)) : s3 && this._update(true);
          }, () => {
            this._postStyleLoadEvent();
          }), this) : (this._localIdeographFontFamily = i3.localIdeographFontFamily, this._localFontFamily = i3.localFontFamily, this._updateStyle(t4, i3));
        }
        _getUIString(e3) {
          const t4 = this._locale[e3];
          if (null == t4) throw new Error(`Missing UI string '${e3}'`);
          return t4;
        }
        _updateStyle(t4, i3) {
          if (this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), t4) {
            const o3 = e2.m({}, i3);
            i3 && i3.config && (o3.initialConfig = i3.config, delete o3.config), this.style = new lo(this, o3).load(t4), this.style.setEventedParent(this, { style: this.style });
          }
          return this._updateTerrain(), this;
        }
        _lazyInitEmptyStyle() {
          this.style || (this.style = new lo(this, {}), this.style.setEventedParent(this, { style: this.style }), this.style.loadEmpty());
        }
        getStyle() {
          if (this.style) return this.style.serialize();
        }
        isStyleLoaded() {
          return this.style ? this.style.loaded() : (e2.w("There is no style added to the map."), false);
        }
        _isValidId(t4) {
          return null == t4 ? (this.fire(new e2.t(new Error("IDs can't be empty."))), false) : !e2.aK(t4) || (this.fire(new e2.t(new Error(`IDs can't contain special symbols: "${t4}".`))), false);
        }
        _isFeaturesetDescriptorValid(e3) {
          return "featuresetId" in e3 ? this._isValidId(e3.featuresetId) : "layerId" in e3 && this._isValidId(e3.layerId);
        }
        _areTargetsValid(e3) {
          if (Array.isArray(e3)) {
            for (const t4 of e3) if (!this._isValidId(t4)) return false;
            return true;
          }
          return this._isFeaturesetDescriptorValid(e3);
        }
        addSource(e3, t4) {
          return this._isValidId(e3) ? (this._lazyInitEmptyStyle(), this.style.addSource(e3, t4), this._update(true)) : this;
        }
        isSourceLoaded(e3) {
          return !!this._isValidId(e3) && !!this.style && this.style._isSourceCacheLoaded(e3);
        }
        areTilesLoaded() {
          return this.style.areTilesLoaded();
        }
        addSourceType(e3, t4, i3) {
          this._lazyInitEmptyStyle(), this.style.addSourceType(e3, t4, i3);
        }
        removeSource(e3) {
          return this._isValidId(e3) ? (this.style.removeSource(e3), this._updateTerrain(), this._update(true)) : this;
        }
        getSource(e3) {
          return this._isValidId(e3) ? this.style.getOwnSource(e3) : null;
        }
        addImage(t4, i3, { pixelRatio: o3 = 1, sdf: s3 = false, stretchX: r3, stretchY: a4, content: n3 } = {}) {
          if (this._lazyInitEmptyStyle(), i3 instanceof HTMLImageElement || ImageBitmap && i3 instanceof ImageBitmap) {
            const { width: l3, height: c3, data: h3 } = e2.e.getImageData(i3);
            this.style.addImage(t4, { data: new e2.r({ width: l3, height: c3 }, h3), pixelRatio: o3, stretchX: r3, stretchY: a4, content: n3, sdf: s3, version: 0 });
          } else if (void 0 === i3.width || void 0 === i3.height) this.fire(new e2.t(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
          else {
            const { width: l3, height: c3 } = i3, h3 = i3;
            this.style.addImage(t4, { data: new e2.r({ width: l3, height: c3 }, new Uint8Array(h3.data)), pixelRatio: o3, stretchX: r3, stretchY: a4, content: n3, sdf: s3, version: 0, userImage: h3 }), h3.onAdd && h3.onAdd(this, t4);
          }
        }
        updateImage(t4, i3) {
          this._lazyInitEmptyStyle();
          const o3 = this.style.getImage(t4);
          if (!o3) return void this.fire(new e2.t(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
          const s3 = i3 instanceof HTMLImageElement || ImageBitmap && i3 instanceof ImageBitmap ? e2.e.getImageData(i3) : i3, { width: r3, height: a4, data: n3 } = s3;
          if (void 0 === r3 || void 0 === a4) return void this.fire(new e2.t(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
          if (r3 !== o3.data.width || a4 !== o3.data.height) return void this.fire(new e2.t(new Error(`The width and height of the updated image (${r3}, ${a4})
                must be that same as the previous version of the image
                (${o3.data.width}, ${o3.data.height})`)));
          const l3 = !(i3 instanceof HTMLImageElement || ImageBitmap && i3 instanceof ImageBitmap);
          o3.data.replace(n3, l3), this.style.updateImage(t4, o3);
        }
        hasImage(t4) {
          return t4 ? !!this.style && !!this.style.getImage(t4) : (this.fire(new e2.t(new Error("Missing required image id"))), false);
        }
        removeImage(e3) {
          this.style.removeImage(e3);
        }
        loadImage(t4, i3) {
          e2.q(this._requestManager.transformRequest(t4, e2.R.Image), (t5, o3) => {
            i3(t5, o3 instanceof HTMLImageElement ? e2.e.getImageData(o3) : o3);
          });
        }
        listImages() {
          return this.style.listImages();
        }
        addModel(e3, t4) {
          this._lazyInitEmptyStyle(), this.style.addModel(e3, t4);
        }
        hasModel(t4) {
          return t4 ? this.style.hasModel(t4) : (this.fire(new e2.t(new Error("Missing required model id"))), false);
        }
        removeModel(e3) {
          this.style.removeModel(e3);
        }
        listModels() {
          return this.style.listModels();
        }
        addLayer(e3, t4) {
          return this._isValidId(e3.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(e3, t4), this._update(true)) : this;
        }
        getSlot(e3) {
          const t4 = this.getLayer(e3);
          return t4 && t4.slot || null;
        }
        setSlot(e3, t4) {
          return this.style.setSlot(e3, t4), this.style.mergeLayers(), this._update(true);
        }
        addImport(e3, t4) {
          return this.style.addImport(e3, t4), this;
        }
        updateImport(e3, t4) {
          return "string" != typeof t4 && t4.id !== e3 ? (this.removeImport(e3), this.addImport(t4)) : (this.style.updateImport(e3, t4), this._update(true));
        }
        removeImport(e3) {
          return this.style.removeImport(e3), this;
        }
        moveImport(e3, t4) {
          return this.style.moveImport(e3, t4), this._update(true);
        }
        moveLayer(e3, t4) {
          return this._isValidId(e3) ? (this.style.moveLayer(e3, t4), this._update(true)) : this;
        }
        removeLayer(e3) {
          return this._isValidId(e3) ? (this.style.removeLayer(e3), this._update(true)) : this;
        }
        getLayer(e3) {
          if (!this._isValidId(e3)) return null;
          const t4 = this.style.getOwnLayer(e3);
          return t4 ? "custom" === t4.type ? t4.implementation : t4.serialize() : void 0;
        }
        getSlots() {
          return this.style.getSlots();
        }
        setLayerZoomRange(e3, t4, i3) {
          return this._isValidId(e3) ? (this.style.setLayerZoomRange(e3, t4, i3), this._update(true)) : this;
        }
        setFilter(e3, t4, i3 = {}) {
          return this._isValidId(e3) ? (this.style.setFilter(e3, t4, i3), this._update(true)) : this;
        }
        getFilter(e3) {
          return this._isValidId(e3) ? this.style.getFilter(e3) : null;
        }
        setPaintProperty(e3, t4, i3, o3 = {}) {
          return this._isValidId(e3) ? (this.style.setPaintProperty(e3, t4, i3, o3), this._update(true)) : this;
        }
        getPaintProperty(e3, t4) {
          return this._isValidId(e3) ? this.style.getPaintProperty(e3, t4) : null;
        }
        setLayoutProperty(e3, t4, i3, o3 = {}) {
          return this._isValidId(e3) ? (this.style.setLayoutProperty(e3, t4, i3, o3), this._update(true)) : this;
        }
        getLayoutProperty(e3, t4) {
          return this._isValidId(e3) ? this.style.getLayoutProperty(e3, t4) : null;
        }
        getSchema(e3) {
          return this.style.getSchema(e3);
        }
        setSchema(e3, t4) {
          return this.style.setSchema(e3, t4), this._update(true);
        }
        getConfig(e3) {
          return this.style.getConfig(e3);
        }
        setConfig(e3, t4) {
          return this.style.setConfig(e3, t4), this._update(true);
        }
        getConfigProperty(e3, t4) {
          return this.style.getConfigProperty(e3, t4);
        }
        setConfigProperty(e3, t4, i3) {
          return this.style.setConfigProperty(e3, t4, i3), this._update(true);
        }
        getFeaturesetDescriptors(e3) {
          return this.style.getFeaturesetDescriptors(e3);
        }
        setLights(e3) {
          if (this._lazyInitEmptyStyle(), e3 && 1 === e3.length && "flat" === e3[0].type) {
            const t4 = e3[0];
            t4.properties ? this.style.setFlatLight(t4.properties, t4.id, {}) : this.style.setFlatLight({}, "flat");
          } else this.style.setLights(e3), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = true);
          return this._update(true);
        }
        getLights() {
          const e3 = this.style.getLights() || [];
          return 0 === e3.length && e3.push({ id: this.style.light.id, type: "flat", properties: this.style.getFlatLight() }), e3;
        }
        setLight(e3, t4 = {}) {
          return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([{ id: "flat", type: "flat", properties: e3 }]);
        }
        getLight() {
          return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
        }
        setTerrain(e3) {
          return this._lazyInitEmptyStyle(), !e3 && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e3), this._averageElevationLastSampledAt = -1 / 0, this._update(true);
        }
        getTerrain() {
          return this.style ? this.style.getTerrain() : null;
        }
        setFog(e3) {
          return this._lazyInitEmptyStyle(), this.style.setFog(e3), this._update(true);
        }
        getFog() {
          return this.style ? this.style.getFog() : null;
        }
        setColorTheme(e3) {
          return this._lazyInitEmptyStyle(), this.style.setColorTheme(e3), this._update(true);
        }
        setCamera(e3) {
          return this.style.setCamera(e3), this._triggerCameraUpdate(e3);
        }
        _triggerCameraUpdate(e3) {
          return this._update(this.transform.setOrthographicProjectionAtLowPitch("orthographic" === e3["camera-projection"]));
        }
        getCamera() {
          return this.style.camera;
        }
        _queryFogOpacity(t4) {
          return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e2.bL.convert(t4), this.transform) : 0;
        }
        setFeatureState(e3, t4) {
          return e3.source && !this._isValidId(e3.source) ? this : (this.style.setFeatureState(e3, t4), this._update());
        }
        removeFeatureState(e3, t4) {
          return e3.source && !this._isValidId(e3.source) ? this : (this.style.removeFeatureState(e3, t4), this._update());
        }
        getFeatureState(e3) {
          return e3.source && !this._isValidId(e3.source) ? null : this.style.getFeatureState(e3);
        }
        _updateContainerDimensions() {
          if (!this._container) return;
          const e3 = this._container.getBoundingClientRect().width || 400, t4 = this._container.getBoundingClientRect().height || 300;
          let i3, o3, s3, r3 = this._container;
          for (; r3 && (!o3 || !s3); ) {
            const e4 = window.getComputedStyle(r3).transform;
            e4 && "none" !== e4 && (i3 = e4.match(/matrix.*\((.+)\)/)[1].split(", "), i3[0] && "0" !== i3[0] && "1" !== i3[0] && (o3 = i3[0]), i3[3] && "0" !== i3[3] && "1" !== i3[3] && (s3 = i3[3])), r3 = r3.parentElement;
          }
          this._containerWidth = o3 ? Math.abs(e3 / o3) : e3, this._containerHeight = s3 ? Math.abs(t4 / s3) : t4;
        }
        _detectMissingCSS() {
          "rgb(250, 128, 114)" !== window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e2.w("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
        }
        _setupContainer() {
          const e3 = this._container;
          e3.classList.add("mapboxgl-map"), (this._missingCSSCanary = l2("div", "mapboxgl-canary", e3)).style.visibility = "hidden", this._detectMissingCSS();
          const t4 = this._canvasContainer = l2("div", "mapboxgl-canvas-container", e3);
          this._canvas = l2("canvas", "mapboxgl-canvas", t4), this._interactive && (t4.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, false), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, false), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
          const i3 = this._controlContainer = l2("div", "mapboxgl-control-container", e3), o3 = this._controlPositions = {};
          ["top-left", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left"].forEach((e4) => {
            o3[e4] = l2("div", `mapboxgl-ctrl-${e4}`, i3);
          }), this._container.addEventListener("scroll", this._onMapScroll, false);
        }
        _resizeCanvas(t4, i3) {
          const o3 = e2.e.devicePixelRatio || 1;
          this._canvas.width = o3 * Math.ceil(t4), this._canvas.height = o3 * Math.ceil(i3), this._canvas.style.width = `${t4}px`, this._canvas.style.height = `${i3}px`;
        }
        _addMarker(e3) {
          this._markers.push(e3);
        }
        _removeMarker(e3) {
          const t4 = this._markers.indexOf(e3);
          -1 !== t4 && this._markers.splice(t4, 1);
        }
        _addPopup(e3) {
          this._popups.push(e3);
        }
        _removePopup(e3) {
          const t4 = this._popups.indexOf(e3);
          -1 !== t4 && this._popups.splice(t4, 1);
        }
        _setupPainter() {
          const t4 = e2.m({}, n2.supported.webGLContextAttributes, { failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat, preserveDrawingBuffer: this._preserveDrawingBuffer, antialias: this._antialias || false }), i3 = this._canvas.getContext("webgl2", t4);
          i3 ? (G(i3, true), this.painter = new Ta(i3, this._contextCreateOptions, this.transform, this._scaleFactor, this._tp, this._enableOIT), this.on("data", (e3) => {
            "source" === e3.dataType && this.painter.setTileLoadedFlag(true);
          }), e2.n.testSupport(i3)) : this.fire(new e2.t(new Error("Failed to initialize WebGL")));
        }
        _contextLost(t4) {
          t4.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new e2.x("webglcontextlost", { originalEvent: t4 }));
        }
        _contextRestored(t4) {
          this._setupPainter(), this.resize(), this._update(), this.fire(new e2.x("webglcontextrestored", { originalEvent: t4 }));
        }
        _onMapScroll(e3) {
          if (e3.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, false;
        }
        idle() {
          return !this.isMoving() && this.loaded();
        }
        loaded() {
          return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
        }
        frameReady() {
          return this.loaded() && !this._placementDirty;
        }
        _update(e3) {
          return this.style ? (this._styleDirty = this._styleDirty || e3, this._sourcesDirty = true, this.triggerRepaint(), this) : this;
        }
        _requestRenderFrame(e3) {
          return this._update(), this._renderTaskQueue.add(e3);
        }
        _cancelRenderFrame(e3) {
          this._renderTaskQueue.remove(e3);
        }
        _requestDomTask(e3) {
          !this.loaded() || this.loaded() && !this.isMoving() ? e3() : this._domRenderTaskQueue.add(e3);
        }
        _render(t4) {
          let s3;
          this.fire(new e2.x("renderstart")), ++this._frameId;
          const r3 = this.painter.context.extTimerQuery, a4 = e2.e.now(), n3 = this.painter.context.gl;
          if (this.listens("gpu-timing-frame") && (s3 = n3.createQuery(), n3.beginQuery(r3.TIME_ELAPSED_EXT, s3)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], performance.now())), this._renderTaskQueue.run(t4), this._domRenderTaskQueue.run(t4), this._removed) return;
          this._updateProjectionTransition();
          const l3 = this._isInitialLoad ? 0 : this._fadeDuration;
          if (this.style && this._styleDirty) {
            this._styleDirty = false;
            const t5 = this.transform.zoom, i3 = this.transform.pitch, o3 = e2.e.now(), s4 = new e2.a3(t5, { now: o3, fadeDuration: l3, pitch: i3, transition: this.style.transition });
            this.style.update(s4);
          }
          this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = true, this._sourcesDirty = true);
          let c3 = false;
          this.style && this._sourcesDirty ? (this._sourcesDirty = false, this.painter._updateFog(this.style), this._updateTerrain(), c3 = this._updateAverageElevation(a4), this.style.updateSources(this.transform), this._forceMarkerAndPopupUpdate()) : c3 = this._updateAverageElevation(a4);
          const h3 = this.style && this.style._updatePlacement(this.painter, this.painter.transform, this.showCollisionBoxes, l3, this._crossSourceCollisions, this.painter.replacementSource, this._scaleFactorChanged);
          if (this._scaleFactorChanged && (this._scaleFactorChanged = false), h3 && (this._placementDirty = h3.needsRerender), this.style && this.painter.render(this.style, { showTileBoundaries: this.showTileBoundaries, showParseStatus: this.showParseStatus, wireframe: { terrain: this.showTerrainWireframe, layers2D: this.showLayers2DWireframe, layers3D: this.showLayers3DWireframe }, showOverdrawInspector: this._showOverdrawInspector, showQueryGeometry: !!this._showQueryGeometry, showTileAABBs: this.showTileAABBs, rotating: this.isRotating(), zooming: this.isZooming(), moving: this.isMoving(), fadeDuration: l3, isInitialLoad: this._isInitialLoad, showPadding: this.showPadding, gpuTiming: !!this.listens("gpu-timing-layer"), gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"), speedIndexTiming: this.speedIndexTiming }), this.fire(new e2.x("render")), this.loaded() && !this._loaded && (this._loaded = true, o2.mark(i2.load), this.fire(new e2.x("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = true), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), s3) {
            const t5 = e2.e.now() - a4;
            n3.endQuery(r3.TIME_ELAPSED_EXT), setTimeout(() => {
              const i3 = n3.getQueryParameter(s3, n3.QUERY_RESULT) / 1e6;
              n3.deleteQuery(s3), this.fire(new e2.x("gpu-timing-frame", { cpuTime: t5, gpuTime: i3 }));
            }, 50);
          }
          if (this.listens("gpu-timing-layer")) {
            const t5 = this.painter.collectGpuTimers();
            setTimeout(() => {
              const i3 = this.painter.queryGpuTimers(t5);
              this.fire(new e2.x("gpu-timing-layer", { layerTimes: i3 }));
            }, 50);
          }
          if (this.listens("gpu-timing-deferred-render")) {
            const t5 = this.painter.collectDeferredRenderGpuQueries();
            setTimeout(() => {
              const i3 = this.painter.queryGpuTimeDeferredRender(t5);
              this.fire(new e2.x("gpu-timing-deferred-render", { gpuTime: i3 }));
            }, 50);
          }
          const u4 = this._sourcesDirty || this._styleDirty || this._placementDirty || c3;
          if (u4 || this._repaint) this.triggerRepaint();
          else {
            const t5 = this.idle();
            if (t5 && (c3 = this._updateAverageElevation(a4, true)), c3) this.triggerRepaint();
            else if (this._triggerFrame(false), t5 && (this.fire(new e2.x("idle")), this._isInitialLoad = false, this.speedIndexTiming)) {
              const t6 = this._calculateSpeedIndex();
              this.fire(new e2.x("speedindexcompleted", { speedIndex: t6 })), this.speedIndexTiming = false;
            }
          }
          !this._loaded || this._fullyLoaded || u4 || (this._fullyLoaded = true, o2.mark(i2.fullLoad), this._performanceMetricsCollection && B3(this._requestManager._customAccessToken, { width: this.painter.width, height: this.painter.height, interactionRange: this._interactionRange, visibilityHidden: this._visibilityHidden, terrainEnabled: !!this.painter.style.getTerrain(), fogEnabled: !!this.painter.style.getFog(), projection: this.getProjection().name, zoom: this.transform.zoom, renderer: this.painter.context.renderer, vendor: this.painter.context.vendor }), this._authenticate());
        }
        _forceMarkerAndPopupUpdate(e3) {
          for (const t4 of this._markers) e3 && !this.getRenderWorldCopies() && (t4._lngLat = t4._lngLat.wrap()), t4._update();
          for (const t4 of this._popups) !e3 || this.getRenderWorldCopies() || t4._trackPointer || (t4._lngLat = t4._lngLat.wrap()), t4._update();
        }
        _updateAverageElevation(e3, t4 = false) {
          const i3 = (e4) => (this.transform.averageElevation = e4, this._update(false), true);
          if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i3(0);
          const o3 = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
          if (o3 || (t4 || e3 - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e3)) {
            const t5 = this.transform.averageElevation;
            let s3 = this.transform.sampleAverageElevation();
            null != this.transform.elevation && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(s3) ? s3 = 0 : this._averageElevationLastSampledAt = e3;
            const r3 = Math.abs(t5 - s3);
            if (r3 > 1) {
              if (this._isInitialLoad || o3) return this._averageElevation.jumpTo(s3), i3(s3);
              this._averageElevation.easeTo(s3, e3, 300);
            } else if (r3 > 1e-4) return this._averageElevation.jumpTo(s3), i3(s3);
          }
          return !!this._averageElevation.isEasing(e3) && i3(this._averageElevation.getValue(e3));
        }
        _authenticate() {
          N(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (t4) => {
            if (t4 && (t4.message === w || 401 === t4.status)) {
              const t5 = this.painter.context.gl;
              G(t5, false), this._logoControl instanceof Cn && this._logoControl._updateLogo(), t5 && t5.clear(t5.DEPTH_BUFFER_BIT | t5.COLOR_BUFFER_BIT | t5.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new e2.t(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
            }
          }), M(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, () => {
          });
        }
        _postStyleLoadEvent() {
          this.style.globalId && O(this._requestManager._customAccessToken, { map: this, skuToken: this._requestManager._skuToken, style: this.style.globalId, importedStyles: this.style.getImportGlobalIds() });
        }
        _updateTerrain() {
          const e3 = this._isDragging();
          this.painter.updateTerrain(this.style, e3);
        }
        _calculateSpeedIndex() {
          const e3 = this.painter.canvasCopy(), t4 = this.painter.getCanvasCopiesAndTimestamps();
          t4.timeStamps.push(performance.now());
          const i3 = this.painter.context.gl, o3 = i3.createFramebuffer();
          function s3(e4) {
            i3.framebufferTexture2D(i3.FRAMEBUFFER, i3.COLOR_ATTACHMENT0, i3.TEXTURE_2D, e4, 0);
            const t5 = new Uint8Array(i3.drawingBufferWidth * i3.drawingBufferHeight * 4);
            return i3.readPixels(0, 0, i3.drawingBufferWidth, i3.drawingBufferHeight, i3.RGBA, i3.UNSIGNED_BYTE, t5), t5;
          }
          return i3.bindFramebuffer(i3.FRAMEBUFFER, o3), this._canvasPixelComparison(s3(e3), t4.canvasCopies.map(s3), t4.timeStamps);
        }
        _canvasPixelComparison(e3, t4, i3) {
          let o3 = i3[1] - i3[0];
          const s3 = e3.length / 4;
          for (let r3 = 0; r3 < t4.length; r3++) {
            const a4 = t4[r3];
            let n3 = 0;
            for (let t5 = 0; t5 < a4.length; t5 += 4) a4[t5] === e3[t5] && a4[t5 + 1] === e3[t5 + 1] && a4[t5 + 2] === e3[t5 + 2] && a4[t5 + 3] === e3[t5 + 3] && (n3 += 1);
            o3 += (i3[r3 + 2] - i3[r3 + 1]) * (1 - n3 / s3);
          }
          return o3;
        }
        remove() {
          this._hash && this._hash.remove();
          for (const e3 of this._controls) e3.onRemove(this);
          this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), window.removeEventListener("resize", this._onWindowResize, false), window.removeEventListener("orientationchange", this._onWindowResize, false), window.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, false), window.removeEventListener("online", this._onWindowOnline, false), window.removeEventListener("visibilitychange", this._onVisibilityChange, false);
          const t4 = this.painter.context.gl.getExtension("WEBGL_lose_context");
          t4 && t4.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, false), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, false), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, false), U2.delete(this.painter.context.gl), k.remove(), P.remove(), this._removed = true, this.fire(new e2.x("remove"));
        }
        triggerRepaint() {
          this._triggerFrame(true);
        }
        _triggerFrame(t4) {
          this._renderNextFrame = this._renderNextFrame || t4, this.style && !this._frame && (this._frame = e2.e.frame((e3) => {
            const t5 = !!this._renderNextFrame;
            this._frame = null, this._renderNextFrame = null, t5 && this._render(e3);
          }));
        }
        _preloadTiles(t4) {
          const i3 = this.style ? this.style.getSourceCaches() : [];
          return e2.bg(i3, (e3, i4) => e3._preloadTiles(t4, i4), () => {
            this.triggerRepaint();
          }), this;
        }
        _onWindowOnline() {
          this._update();
        }
        _onWindowResize(e3) {
          this._trackResize && this.resize({ originalEvent: e3 })._update();
        }
        _onVisibilityChange() {
          "hidden" === document.visibilityState && this._visibilityHidden++;
        }
        get showTileBoundaries() {
          return !!this._showTileBoundaries;
        }
        set showTileBoundaries(e3) {
          this._showTileBoundaries !== e3 && (this._showTileBoundaries = e3, this._tp.refreshUI(), this._update());
        }
        get showParseStatus() {
          return !!this._showParseStatus;
        }
        set showParseStatus(e3) {
          this._showParseStatus !== e3 && (this._showParseStatus = e3, this._tp.refreshUI(), this._update());
        }
        get showTerrainWireframe() {
          return !!this._showTerrainWireframe;
        }
        set showTerrainWireframe(e3) {
          this._showTerrainWireframe !== e3 && (this._showTerrainWireframe = e3, this._tp.refreshUI(), this._update());
        }
        get showLayers2DWireframe() {
          return !!this._showLayers2DWireframe;
        }
        set showLayers2DWireframe(e3) {
          this._showLayers2DWireframe !== e3 && (this._showLayers2DWireframe = e3, this._tp.refreshUI(), this._update());
        }
        get showLayers3DWireframe() {
          return !!this._showLayers3DWireframe;
        }
        set showLayers3DWireframe(e3) {
          this._showLayers3DWireframe !== e3 && (this._showLayers3DWireframe = e3, this._tp.refreshUI(), this._update());
        }
        get speedIndexTiming() {
          return !!this._speedIndexTiming;
        }
        set speedIndexTiming(e3) {
          this._speedIndexTiming !== e3 && (this._speedIndexTiming = e3, this._update());
        }
        get showPadding() {
          return !!this._showPadding;
        }
        set showPadding(e3) {
          this._showPadding !== e3 && (this._showPadding = e3, this._tp.refreshUI(), this._update());
        }
        get showCollisionBoxes() {
          return !!this._showCollisionBoxes;
        }
        set showCollisionBoxes(e3) {
          this._showCollisionBoxes !== e3 && (this._showCollisionBoxes = e3, this._tp.refreshUI(), e3 ? this.style._generateCollisionBoxes() : this._update());
        }
        get showOverdrawInspector() {
          return !!this._showOverdrawInspector;
        }
        set showOverdrawInspector(e3) {
          this._showOverdrawInspector !== e3 && (this._showOverdrawInspector = e3, this._tp.refreshUI(), this._update());
        }
        get repaint() {
          return !!this._repaint;
        }
        set repaint(e3) {
          this._repaint !== e3 && (this._repaint = e3, this._tp.refreshUI(), this.triggerRepaint());
        }
        get vertices() {
          return !!this._vertices;
        }
        set vertices(e3) {
          this._vertices = e3, this._update();
        }
        get showTileAABBs() {
          return !!this._showTileAABBs;
        }
        set showTileAABBs(e3) {
          this._showTileAABBs !== e3 && (this._showTileAABBs = e3, this._tp.refreshUI(), e3 && this._update());
        }
        _setCacheLimits(t4, i3) {
          e2.dy(t4, i3);
        }
        get version() {
          return t3;
        }
      }, NavigationControl: class {
        constructor(t4 = {}) {
          this.options = e2.m({}, On, t4), this._container = l2("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e3) => e3.preventDefault()), this.options.showZoom && (e2.aJ(["_setButtonTitle", "_updateZoomButtons"], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e3) => {
            this._map && this._map.zoomIn({}, { originalEvent: e3 });
          }), l2("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e3) => {
            this._map && this._map.zoomOut({}, { originalEvent: e3 });
          }), l2("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (e2.aJ(["_rotateCompassArrow"], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e3) => {
            const t5 = this._map;
            t5 && (this.options.visualizePitch ? t5.resetNorthPitch({}, { originalEvent: e3 }) : t5.resetNorth({}, { originalEvent: e3 }));
          }), this._compassIcon = l2("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
        }
        _updateZoomButtons() {
          const e3 = this._map;
          if (!e3) return;
          const t4 = e3.getZoom(), i3 = t4 === e3.getMaxZoom(), o3 = t4 === e3.getMinZoom();
          this._zoomInButton.disabled = i3, this._zoomOutButton.disabled = o3, this._zoomInButton.setAttribute("aria-disabled", i3.toString()), this._zoomOutButton.setAttribute("aria-disabled", o3.toString());
        }
        _rotateCompassArrow() {
          const e3 = this._map;
          if (!e3) return;
          const t4 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e3.transform.pitch * (Math.PI / 180)), 0.5)}) rotateX(${e3.transform.pitch}deg) rotateZ(${e3.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e3.transform.angle * (180 / Math.PI)}deg)`;
          e3._requestDomTask(() => {
            this._compassIcon && (this._compassIcon.style.transform = t4);
          });
        }
        onAdd(e3) {
          return this._map = e3, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e3.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e3.on("pitch", this._rotateCompassArrow), e3.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Fn(e3, this._compass, this.options.visualizePitch)), this._container;
        }
        onRemove() {
          const e3 = this._map;
          e3 && (this._container.remove(), this.options.showZoom && e3.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e3.off("pitch", this._rotateCompassArrow), e3.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
        }
        _createButton(e3, t4) {
          const i3 = l2("button", e3, this._container);
          return i3.type = "button", i3.addEventListener("click", t4), i3;
        }
        _setButtonTitle(e3, t4) {
          if (!this._map) return;
          const i3 = this._map._getUIString(`NavigationControl.${t4}`);
          e3.setAttribute("aria-label", i3), e3.firstElementChild && e3.firstElementChild.setAttribute("title", i3);
        }
      }, GeolocateControl: class extends e2.E {
        constructor(t4 = {}) {
          super();
          const i3 = navigator.geolocation;
          this.options = e2.m({ geolocation: i3 }, Un2, t4), e2.aJ(["_onSuccess", "_onError", "_onZoom", "_finish", "_setupUI", "_updateCamera", "_updateMarker", "_updateMarkerRotation", "_onDeviceOrientation"], this), this._updateMarkerRotationThrottled = Ea(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
        }
        onAdd(e3) {
          return this._map = e3, this._container = l2("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
        }
        onRemove() {
          void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = false;
        }
        _checkGeolocationSupport(e3) {
          const t4 = (t5 = !!this.options.geolocation) => {
            this._supportsGeolocation = t5, e3(t5);
          };
          void 0 !== this._supportsGeolocation ? e3(this._supportsGeolocation) : void 0 !== navigator.permissions ? navigator.permissions.query({ name: "geolocation" }).then((e4) => t4("denied" !== e4.state)).catch(() => t4()) : t4();
        }
        _isOutOfMapMaxBounds(e3) {
          const t4 = this._map.getMaxBounds(), i3 = e3.coords;
          return !!t4 && (i3.longitude < t4.getWest() || i3.longitude > t4.getEast() || i3.latitude < t4.getSouth() || i3.latitude > t4.getNorth());
        }
        _setErrorState() {
          switch (this._watchState) {
            case "WAITING_ACTIVE":
              this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
              break;
            case "ACTIVE_LOCK":
              this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
              break;
            case "BACKGROUND":
              this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
          }
        }
        _onSuccess(t4) {
          if (this._map) {
            if (this._isOutOfMapMaxBounds(t4)) return this._setErrorState(), this.fire(new e2.x("outofmaxbounds", t4)), this._updateMarker(), void this._finish();
            if (this.options.trackUserLocation) switch (this._lastKnownPosition = t4, this._watchState) {
              case "WAITING_ACTIVE":
              case "ACTIVE_LOCK":
              case "ACTIVE_ERROR":
                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                break;
              case "BACKGROUND":
              case "BACKGROUND_ERROR":
                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
            }
            this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t4), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(t4), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new e2.x("geolocate", t4)), this._finish();
          }
        }
        _updateCamera(t4) {
          const i3 = new e2.bL(t4.coords.longitude, t4.coords.latitude), o3 = t4.coords.accuracy, s3 = this._map.getBearing(), r3 = e2.m({ bearing: s3 }, this.options.fitBoundsOptions);
          this._map.fitBounds(i3.toBounds(o3), r3, { geolocateSource: true });
        }
        _updateMarker(t4) {
          if (t4) {
            const i3 = new e2.bL(t4.coords.longitude, t4.coords.latitude);
            this._accuracyCircleMarker.setLngLat(i3).addTo(this._map), this._userLocationDotMarker.setLngLat(i3).addTo(this._map), this._accuracy = t4.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
          } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
        }
        _updateCircleRadius() {
          const t4 = this._map.transform, i3 = e2.bE(1, t4._center.lat) * t4.worldSize, o3 = Math.ceil(2 * this._accuracy * i3);
          this._circleElement.style.width = `${o3}px`, this._circleElement.style.height = `${o3}px`;
        }
        _onZoom() {
          this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
        }
        _updateMarkerRotation() {
          this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
        }
        _onError(t4) {
          if (this._map) {
            if (this.options.trackUserLocation) if (1 === t4.code) {
              this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = true;
              const e3 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
              this._geolocateButton.setAttribute("aria-label", e3), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e3), void 0 !== this._geolocationWatchID && this._clearWatch();
            } else {
              if (3 === t4.code && this._noTimeout) return;
              this._setErrorState();
            }
            "OFF" !== this._watchState && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new e2.x("error", t4)), this._finish();
          }
        }
        _finish() {
          this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
        }
        _setupUI(t4) {
          if (void 0 !== this._map) {
            if (this._container.addEventListener("contextmenu", (e3) => e3.preventDefault()), this._geolocateButton = l2("button", "mapboxgl-ctrl-geolocate", this._container), l2("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", false === t4) {
              e2.w("Geolocation support is not available so the GeolocateControl will be disabled.");
              const t5 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
              this._geolocateButton.disabled = true, this._geolocateButton.setAttribute("aria-label", t5), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", t5);
            } else {
              const e3 = this._map._getUIString("GeolocateControl.FindMyLocation");
              this._geolocateButton.setAttribute("aria-label", e3), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e3);
            }
            this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = l2("div", "mapboxgl-user-location"), this._dotElement.appendChild(l2("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(l2("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new Nn({ element: this._dotElement, rotationAlignment: "map", pitchAlignment: "map" }), this._circleElement = l2("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Nn({ element: this._circleElement, pitchAlignment: "map" }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = true, this.options.trackUserLocation && this._map.on("movestart", (t5) => {
              t5.geolocateSource || "ACTIVE_LOCK" !== this._watchState || t5.originalEvent && "resize" === t5.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new e2.x("trackuserlocationend")));
            });
          }
        }
        _onDeviceOrientation(e3) {
          this._userLocationDotMarker && (e3.webkitCompassHeading ? this._heading = e3.webkitCompassHeading : true === e3.absolute && (this._heading = -1 * e3.alpha), this._updateMarkerRotationThrottled());
        }
        trigger() {
          if (!this._setup) return e2.w("Geolocate control triggered before added to a map"), false;
          if (this.options.trackUserLocation) {
            switch (this._watchState) {
              case "OFF":
                this._watchState = "WAITING_ACTIVE", this.fire(new e2.x("trackuserlocationstart"));
                break;
              case "WAITING_ACTIVE":
              case "ACTIVE_LOCK":
              case "ACTIVE_ERROR":
              case "BACKGROUND_ERROR":
                this._numberOfWatches--, this._noTimeout = false, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new e2.x("trackuserlocationend"));
                break;
              case "BACKGROUND":
                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e2.x("trackuserlocationstart"));
            }
            switch (this._watchState) {
              case "WAITING_ACTIVE":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                break;
              case "ACTIVE_LOCK":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                break;
              case "ACTIVE_ERROR":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                break;
              case "BACKGROUND":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                break;
              case "BACKGROUND_ERROR":
                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
            }
            if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
            else if (void 0 === this._geolocationWatchID) {
              let e3;
              this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e3 = { maximumAge: 6e5, timeout: 0 }, this._noTimeout = true) : (e3 = this.options.positionOptions, this._noTimeout = false), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e3), this.options.showUserHeading && this._addDeviceOrientationListener();
            }
          } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = window.setTimeout(this._finish, 1e4);
          return true;
        }
        _addDeviceOrientationListener() {
          const e3 = () => {
            "ondeviceorientationabsolute" in window ? window.addEventListener("deviceorientationabsolute", this._onDeviceOrientation) : window.addEventListener("deviceorientation", this._onDeviceOrientation);
          };
          "undefined" != typeof DeviceMotionEvent && "function" == typeof DeviceMotionEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then((t4) => {
            "granted" === t4 && e3();
          }).catch(console.error) : e3();
        }
        _clearWatch() {
          this.options.geolocation.clearWatch(this._geolocationWatchID), window.removeEventListener("deviceorientation", this._onDeviceOrientation), window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
        }
      }, AttributionControl: Sn2, ScaleControl: class {
        constructor(t4 = {}) {
          this.options = e2.m({}, Gn2, t4), this._isNumberFormatSupported = function() {
            try {
              return new Intl.NumberFormat("en", { style: "unit", unitDisplay: "short", unit: "meter" }), true;
            } catch (e3) {
              return false;
            }
          }(), e2.aJ(["_update", "_setScale", "setUnit"], this);
        }
        getDefaultPosition() {
          return "bottom-left";
        }
        _update() {
          const e3 = this.options.maxWidth || 100, t4 = this._map, i3 = t4._containerHeight / 2, o3 = t4._containerWidth / 2 - e3 / 2, s3 = t4.unproject([o3, i3]), r3 = t4.unproject([o3 + e3, i3]), a4 = s3.distanceTo(r3);
          if ("imperial" === this.options.unit) {
            const t5 = 3.2808 * a4;
            t5 > 5280 ? this._setScale(e3, t5 / 5280, "mile") : this._setScale(e3, t5, "foot");
          } else "nautical" === this.options.unit ? this._setScale(e3, a4 / 1852, "nautical-mile") : a4 >= 1e3 ? this._setScale(e3, a4 / 1e3, "kilometer") : this._setScale(e3, a4, "meter");
        }
        _setScale(e3, t4, i3) {
          this._map._requestDomTask(() => {
            const o3 = function(e4) {
              const t5 = Math.pow(10, `${Math.floor(e4)}`.length - 1);
              let i4 = e4 / t5;
              return i4 = i4 >= 10 ? 10 : i4 >= 5 ? 5 : i4 >= 3 ? 3 : i4 >= 2 ? 2 : i4 >= 1 ? 1 : function(e5) {
                const t6 = Math.pow(10, Math.ceil(-Math.log(e5) / Math.LN10));
                return Math.round(e5 * t6) / t6;
              }(i4), t5 * i4;
            }(t4), s3 = o3 / t4;
            this._container.innerHTML = this._isNumberFormatSupported && "nautical-mile" !== i3 ? new Intl.NumberFormat(this._language, { style: "unit", unitDisplay: "short", unit: i3 }).format(o3) : `${o3}&nbsp;${Vn[i3]}`, this._container.style.width = e3 * s3 + "px";
          });
        }
        onAdd(e3) {
          return this._map = e3, this._language = e3.getLanguage(), this._container = l2("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e3.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
        }
        onRemove() {
          this._container.remove(), this._map.off("move", this._update), this._map = void 0;
        }
        _setLanguage(e3) {
          this._language = e3, this._update();
        }
        setUnit(e3) {
          this.options.unit = e3, this._update();
        }
      }, FullscreenControl: class {
        constructor(t4 = {}) {
          this._fullscreen = false, t4 && t4.container && (t4.container instanceof HTMLElement ? this._container = t4.container : e2.w("Full screen control 'container' must be a DOM element.")), e2.aJ(["_onClickFullscreen", "_changeIcon"], this), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in document && (this._fullscreenchange = "webkitfullscreenchange");
        }
        onAdd(t4) {
          return this._map = t4, this._container || (this._container = this._map.getContainer()), this._controlContainer = l2("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e2.w("This device does not support fullscreen mode.")), this._controlContainer;
        }
        onRemove() {
          this._controlContainer.remove(), this._map = null, document.removeEventListener(this._fullscreenchange, this._changeIcon);
        }
        _checkFullscreenSupport() {
          return !(!document.fullscreenEnabled && !document.webkitFullscreenEnabled);
        }
        _setupUI() {
          const e3 = this._fullscreenButton = l2("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
          l2("span", "mapboxgl-ctrl-icon", e3).setAttribute("aria-hidden", "true"), e3.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), document.addEventListener(this._fullscreenchange, this._changeIcon);
        }
        _updateTitle() {
          const e3 = this._getTitle();
          this._fullscreenButton.setAttribute("aria-label", e3), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e3);
        }
        _getTitle() {
          return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
        }
        _isFullscreen() {
          return this._fullscreen;
        }
        _changeIcon() {
          (document.fullscreenElement || document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
        }
        _onClickFullscreen() {
          this._isFullscreen() ? document.exitFullscreen ? document.exitFullscreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
        }
      }, Popup: class extends e2.E {
        constructor(t4) {
          super(), this.options = e2.m(Object.create(jn), t4), e2.aJ(["_update", "_onClose", "remove", "_onMouseEvent"], this), this._classList = new Set(t4 && t4.className ? t4.className.trim().split(/\s+/) : []);
        }
        addTo(t4) {
          return this._map && this.remove(), this._map = t4, this.options.closeOnClick && t4.on("preclick", this._onClose), this.options.closeOnMove && t4.on("move", this._onClose), t4.on("remove", this.remove), this._update(), t4._addPopup(this), this._focusFirstElement(), this._trackPointer ? (t4.on("mousemove", this._onMouseEvent), t4.on("mouseup", this._onMouseEvent), t4._canvasContainer.classList.add("mapboxgl-track-pointer")) : t4.on("move", this._update), this.fire(new e2.x("open")), this;
        }
        isOpen() {
          return !!this._map;
        }
        remove() {
          this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
          const t4 = this._map;
          return t4 && (t4.off("move", this._update), t4.off("move", this._onClose), t4.off("preclick", this._onClose), t4.off("click", this._onClose), t4.off("remove", this.remove), t4.off("mousemove", this._onMouseEvent), t4.off("mouseup", this._onMouseEvent), t4.off("drag", this._onMouseEvent), t4._canvasContainer && t4._canvasContainer.classList.remove("mapboxgl-track-pointer"), t4._removePopup(this), this._map = void 0), this.fire(new e2.x("close")), this;
        }
        getLngLat() {
          return this._lngLat;
        }
        setLngLat(t4) {
          this._lngLat = e2.bL.convert(t4), this._pos = null, this._trackPointer = false, this._update();
          const i3 = this._map;
          return i3 && (i3.on("move", this._update), i3.off("mousemove", this._onMouseEvent), i3._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
        }
        trackPointer() {
          this._trackPointer = true, this._pos = null, this._update();
          const e3 = this._map;
          return e3 && (e3.off("move", this._update), e3.on("mousemove", this._onMouseEvent), e3.on("drag", this._onMouseEvent), e3._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
        }
        getElement() {
          return this._container;
        }
        setText(e3) {
          return this.setDOMContent(document.createTextNode(e3));
        }
        setHTML(e3) {
          const t4 = document.createDocumentFragment(), i3 = document.createElement("body");
          let o3;
          for (i3.innerHTML = e3; o3 = i3.firstChild, o3; ) t4.appendChild(o3);
          return this.setDOMContent(t4);
        }
        getMaxWidth() {
          return this._container && this._container.style.maxWidth;
        }
        setMaxWidth(e3) {
          return this.options.maxWidth = e3, this._update(), this;
        }
        setDOMContent(e3) {
          let t4 = this._content;
          if (t4) for (; t4.hasChildNodes(); ) t4.firstChild && t4.removeChild(t4.firstChild);
          else t4 = this._content = l2("div", "mapboxgl-popup-content", this._container || void 0);
          if (t4.appendChild(e3), this.options.closeButton) {
            const e4 = this._closeButton = l2("button", "mapboxgl-popup-close-button", t4);
            e4.type = "button", e4.setAttribute("aria-label", "Close popup"), e4.setAttribute("aria-hidden", "true"), e4.innerHTML = "&#215;", e4.addEventListener("click", this._onClose);
          }
          return this._update(), this._focusFirstElement(), this;
        }
        addClassName(e3) {
          return this._classList.add(e3), this._updateClassList(), this;
        }
        removeClassName(e3) {
          return this._classList.delete(e3), this._updateClassList(), this;
        }
        setOffset(e3) {
          return this.options.offset = e3, this._update(), this;
        }
        toggleClassName(e3) {
          let t4;
          return this._classList.delete(e3) ? t4 = false : (this._classList.add(e3), t4 = true), this._updateClassList(), t4;
        }
        _onMouseEvent(e3) {
          this._update(e3.point);
        }
        _getAnchor(e3) {
          if (this.options.anchor) return this.options.anchor;
          const t4 = this._map, i3 = this._container, o3 = this._pos;
          if (!t4 || !i3 || !o3) return "bottom";
          const s3 = i3.offsetWidth, r3 = i3.offsetHeight, a4 = o3.x < s3 / 2, n3 = o3.x > t4.transform.width - s3 / 2;
          if (o3.y + e3 < r3) return a4 ? "top-left" : n3 ? "top-right" : "top";
          if (o3.y > t4.transform.height - r3) {
            if (a4) return "bottom-left";
            if (n3) return "bottom-right";
          }
          return a4 ? "left" : n3 ? "right" : "bottom";
        }
        _updateClassList() {
          const e3 = this._container;
          if (!e3) return;
          const t4 = [...this._classList];
          t4.push("mapboxgl-popup"), this._anchor && t4.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t4.push("mapboxgl-popup-track-pointer"), e3.className = t4.join(" ");
        }
        _update(t4) {
          const i3 = this._map, o3 = this._content;
          if (!i3 || !this._lngLat && !this._trackPointer || !o3) return;
          let s3 = this._container;
          if (s3 || (s3 = this._container = l2("div", "mapboxgl-popup", i3.getContainer()), this._tip = l2("div", "mapboxgl-popup-tip", s3), s3.appendChild(o3)), this.options.maxWidth && s3.style.maxWidth !== this.options.maxWidth && (s3.style.maxWidth = this.options.maxWidth), i3.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = Bn(this._lngLat, this._pos, i3.transform)), !this._trackPointer || t4) {
            const o4 = this._pos = this._trackPointer && t4 instanceof e2.P ? t4 : i3.project(this._lngLat), s4 = Zn(this.options.offset), r3 = this._anchor = this._getAnchor(s4.y), a4 = Zn(this.options.offset, r3), n3 = o4.add(a4).round();
            i3._requestDomTask(() => {
              this._container && r3 && (this._container.style.transform = `${kn[r3]} translate(${n3.x}px,${n3.y}px)`);
            });
          }
          if (!this._marker && i3._showingGlobe()) {
            const t5 = e2.dz(i3.transform, this._lngLat) ? 0 : 1;
            this._setOpacity(t5);
          }
          this._updateClassList();
        }
        _focusFirstElement() {
          if (!this.options.focusAfterOpen || !this._container) return;
          const e3 = this._container.querySelector(Hn);
          e3 && e3.focus();
        }
        _onClose() {
          this.remove();
        }
        _setOpacity(e3) {
          this._container && (this._container.style.opacity = `${e3}`), this._content && (this._content.style.pointerEvents = e3 ? "auto" : "none");
        }
      }, Marker: Nn, Style: lo, LngLat: e2.bL, LngLatBounds: e2.as, Point: e2.P, MercatorCoordinate: e2.a5, FreeCameraOptions: Ni, Evented: e2.E, Event: e2.x, config: e2.f, prewarm: e2.dE, clearPrewarmedResources: e2.dF, get accessToken() {
        return e2.f.ACCESS_TOKEN;
      }, set accessToken(t4) {
        e2.f.ACCESS_TOKEN = t4;
      }, get baseApiUrl() {
        return e2.f.API_URL;
      }, set baseApiUrl(t4) {
        e2.f.API_URL = t4;
      }, get workerCount() {
        return e2.dG.workerCount;
      }, set workerCount(t4) {
        e2.dG.workerCount = t4;
      }, get maxParallelImageRequests() {
        return e2.f.MAX_PARALLEL_IMAGE_REQUESTS;
      }, set maxParallelImageRequests(t4) {
        e2.f.MAX_PARALLEL_IMAGE_REQUESTS = t4;
      }, clearStorage(t4) {
        e2.dH(t4);
      }, get workerUrl() {
        return e2.dI.workerUrl;
      }, set workerUrl(t4) {
        e2.dI.workerUrl = t4;
      }, get workerClass() {
        return e2.dI.workerClass;
      }, set workerClass(t4) {
        e2.dI.workerClass = t4;
      }, get workerParams() {
        return e2.dI.workerParams;
      }, set workerParams(t4) {
        e2.dI.workerParams = t4;
      }, get dracoUrl() {
        return e2.dJ();
      }, set dracoUrl(t4) {
        e2.dK(t4);
      }, get meshoptUrl() {
        return e2.dL();
      }, set meshoptUrl(t4) {
        e2.dM(t4);
      }, setNow: e2.e.setNow, restoreNow: e2.e.restoreNow };
      return qn2;
    });
    var mapboxgl$1 = mapboxgl2;
    return mapboxgl$1;
  });
})(mapboxGl);
var mapboxGlExports = mapboxGl.exports;
const mapboxgl = /* @__PURE__ */ getDefaultExportFromCjs(mapboxGlExports);
/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const REVISION$1 = "171";
const MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2, ROTATE: 0, DOLLY: 1, PAN: 2 };
const TOUCH = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 };
const CullFaceNone$1 = 0;
const CullFaceBack$1 = 1;
const CullFaceFront$1 = 2;
const CullFaceFrontBack = 3;
const BasicShadowMap = 0;
const PCFShadowMap$1 = 1;
const PCFSoftShadowMap$1 = 2;
const VSMShadowMap$1 = 3;
const FrontSide$1 = 0;
const BackSide$1 = 1;
const DoubleSide$1 = 2;
const NoBlending$1 = 0;
const NormalBlending$1 = 1;
const AdditiveBlending$1 = 2;
const SubtractiveBlending$1 = 3;
const MultiplyBlending$1 = 4;
const CustomBlending$1 = 5;
const AddEquation$1 = 100;
const SubtractEquation$1 = 101;
const ReverseSubtractEquation$1 = 102;
const MinEquation$1 = 103;
const MaxEquation$1 = 104;
const ZeroFactor$1 = 200;
const OneFactor$1 = 201;
const SrcColorFactor$1 = 202;
const OneMinusSrcColorFactor$1 = 203;
const SrcAlphaFactor$1 = 204;
const OneMinusSrcAlphaFactor$1 = 205;
const DstAlphaFactor$1 = 206;
const OneMinusDstAlphaFactor$1 = 207;
const DstColorFactor$1 = 208;
const OneMinusDstColorFactor$1 = 209;
const SrcAlphaSaturateFactor$1 = 210;
const ConstantColorFactor = 211;
const OneMinusConstantColorFactor = 212;
const ConstantAlphaFactor = 213;
const OneMinusConstantAlphaFactor = 214;
const NeverDepth$1 = 0;
const AlwaysDepth$1 = 1;
const LessDepth$1 = 2;
const LessEqualDepth$1 = 3;
const EqualDepth$1 = 4;
const GreaterEqualDepth$1 = 5;
const GreaterDepth$1 = 6;
const NotEqualDepth$1 = 7;
const MultiplyOperation$1 = 0;
const MixOperation$1 = 1;
const AddOperation$1 = 2;
const NoToneMapping$1 = 0;
const LinearToneMapping$1 = 1;
const ReinhardToneMapping$1 = 2;
const CineonToneMapping$1 = 3;
const ACESFilmicToneMapping$1 = 4;
const CustomToneMapping$1 = 5;
const AgXToneMapping = 6;
const NeutralToneMapping = 7;
const AttachedBindMode = "attached";
const DetachedBindMode = "detached";
const UVMapping$1 = 300;
const CubeReflectionMapping$1 = 301;
const CubeRefractionMapping$1 = 302;
const EquirectangularReflectionMapping$1 = 303;
const EquirectangularRefractionMapping$1 = 304;
const CubeUVReflectionMapping$1 = 306;
const RepeatWrapping$1 = 1e3;
const ClampToEdgeWrapping$1 = 1001;
const MirroredRepeatWrapping$1 = 1002;
const NearestFilter$1 = 1003;
const NearestMipmapNearestFilter$1 = 1004;
const NearestMipMapNearestFilter = 1004;
const NearestMipmapLinearFilter$1 = 1005;
const NearestMipMapLinearFilter = 1005;
const LinearFilter$1 = 1006;
const LinearMipmapNearestFilter$1 = 1007;
const LinearMipMapNearestFilter = 1007;
const LinearMipmapLinearFilter$1 = 1008;
const LinearMipMapLinearFilter = 1008;
const UnsignedByteType$1 = 1009;
const ByteType$1 = 1010;
const ShortType$1 = 1011;
const UnsignedShortType$1 = 1012;
const IntType$1 = 1013;
const UnsignedIntType$1 = 1014;
const FloatType$1 = 1015;
const HalfFloatType$1 = 1016;
const UnsignedShort4444Type$1 = 1017;
const UnsignedShort5551Type$1 = 1018;
const UnsignedInt248Type$1 = 1020;
const UnsignedInt5999Type = 35902;
const AlphaFormat$1 = 1021;
const RGBFormat$1 = 1022;
const RGBAFormat$1 = 1023;
const LuminanceFormat$1 = 1024;
const LuminanceAlphaFormat$1 = 1025;
const DepthFormat$1 = 1026;
const DepthStencilFormat$1 = 1027;
const RedFormat$1 = 1028;
const RedIntegerFormat$1 = 1029;
const RGFormat$1 = 1030;
const RGIntegerFormat$1 = 1031;
const RGBIntegerFormat$1 = 1032;
const RGBAIntegerFormat$1 = 1033;
const RGB_S3TC_DXT1_Format$1 = 33776;
const RGBA_S3TC_DXT1_Format$1 = 33777;
const RGBA_S3TC_DXT3_Format$1 = 33778;
const RGBA_S3TC_DXT5_Format$1 = 33779;
const RGB_PVRTC_4BPPV1_Format$1 = 35840;
const RGB_PVRTC_2BPPV1_Format$1 = 35841;
const RGBA_PVRTC_4BPPV1_Format$1 = 35842;
const RGBA_PVRTC_2BPPV1_Format$1 = 35843;
const RGB_ETC1_Format$1 = 36196;
const RGB_ETC2_Format$1 = 37492;
const RGBA_ETC2_EAC_Format$1 = 37496;
const RGBA_ASTC_4x4_Format$1 = 37808;
const RGBA_ASTC_5x4_Format$1 = 37809;
const RGBA_ASTC_5x5_Format$1 = 37810;
const RGBA_ASTC_6x5_Format$1 = 37811;
const RGBA_ASTC_6x6_Format$1 = 37812;
const RGBA_ASTC_8x5_Format$1 = 37813;
const RGBA_ASTC_8x6_Format$1 = 37814;
const RGBA_ASTC_8x8_Format$1 = 37815;
const RGBA_ASTC_10x5_Format$1 = 37816;
const RGBA_ASTC_10x6_Format$1 = 37817;
const RGBA_ASTC_10x8_Format$1 = 37818;
const RGBA_ASTC_10x10_Format$1 = 37819;
const RGBA_ASTC_12x10_Format$1 = 37820;
const RGBA_ASTC_12x12_Format$1 = 37821;
const RGBA_BPTC_Format$1 = 36492;
const RGB_BPTC_SIGNED_Format = 36494;
const RGB_BPTC_UNSIGNED_Format = 36495;
const RED_RGTC1_Format = 36283;
const SIGNED_RED_RGTC1_Format = 36284;
const RED_GREEN_RGTC2_Format = 36285;
const SIGNED_RED_GREEN_RGTC2_Format = 36286;
const LoopOnce$1 = 2200;
const LoopRepeat$1 = 2201;
const LoopPingPong$1 = 2202;
const InterpolateDiscrete$1 = 2300;
const InterpolateLinear$1 = 2301;
const InterpolateSmooth$1 = 2302;
const ZeroCurvatureEnding$1 = 2400;
const ZeroSlopeEnding$1 = 2401;
const WrapAroundEnding$1 = 2402;
const NormalAnimationBlendMode$1 = 2500;
const AdditiveAnimationBlendMode$1 = 2501;
const TrianglesDrawMode$1 = 0;
const TriangleStripDrawMode = 1;
const TriangleFanDrawMode = 2;
const BasicDepthPacking$1 = 3200;
const RGBADepthPacking$1 = 3201;
const RGBDepthPacking = 3202;
const RGDepthPacking = 3203;
const TangentSpaceNormalMap$1 = 0;
const ObjectSpaceNormalMap$1 = 1;
const NoColorSpace = "";
const SRGBColorSpace = "srgb";
const LinearSRGBColorSpace = "srgb-linear";
const LinearTransfer = "linear";
const SRGBTransfer = "srgb";
const ZeroStencilOp = 0;
const KeepStencilOp$1 = 7680;
const ReplaceStencilOp = 7681;
const IncrementStencilOp = 7682;
const DecrementStencilOp = 7683;
const IncrementWrapStencilOp = 34055;
const DecrementWrapStencilOp = 34056;
const InvertStencilOp = 5386;
const NeverStencilFunc = 512;
const LessStencilFunc = 513;
const EqualStencilFunc = 514;
const LessEqualStencilFunc = 515;
const GreaterStencilFunc = 516;
const NotEqualStencilFunc = 517;
const GreaterEqualStencilFunc = 518;
const AlwaysStencilFunc$1 = 519;
const NeverCompare = 512;
const LessCompare = 513;
const EqualCompare = 514;
const LessEqualCompare = 515;
const GreaterCompare = 516;
const NotEqualCompare = 517;
const GreaterEqualCompare = 518;
const AlwaysCompare = 519;
const StaticDrawUsage$1 = 35044;
const DynamicDrawUsage$1 = 35048;
const StreamDrawUsage = 35040;
const StaticReadUsage = 35045;
const DynamicReadUsage = 35049;
const StreamReadUsage = 35041;
const StaticCopyUsage = 35046;
const DynamicCopyUsage = 35050;
const StreamCopyUsage = 35042;
const GLSL1 = "100";
const GLSL3$1 = "300 es";
const WebGLCoordinateSystem = 2e3;
const WebGPUCoordinateSystem = 2001;
let EventDispatcher$1 = class EventDispatcher {
  addEventListener(type, listener) {
    if (this._listeners === void 0) this._listeners = {};
    const listeners = this._listeners;
    if (listeners[type] === void 0) {
      listeners[type] = [];
    }
    if (listeners[type].indexOf(listener) === -1) {
      listeners[type].push(listener);
    }
  }
  hasEventListener(type, listener) {
    if (this._listeners === void 0) return false;
    const listeners = this._listeners;
    return listeners[type] !== void 0 && listeners[type].indexOf(listener) !== -1;
  }
  removeEventListener(type, listener) {
    if (this._listeners === void 0) return;
    const listeners = this._listeners;
    const listenerArray = listeners[type];
    if (listenerArray !== void 0) {
      const index2 = listenerArray.indexOf(listener);
      if (index2 !== -1) {
        listenerArray.splice(index2, 1);
      }
    }
  }
  dispatchEvent(event) {
    if (this._listeners === void 0) return;
    const listeners = this._listeners;
    const listenerArray = listeners[event.type];
    if (listenerArray !== void 0) {
      event.target = this;
      const array = listenerArray.slice(0);
      for (let i2 = 0, l2 = array.length; i2 < l2; i2++) {
        array[i2].call(this, event);
      }
      event.target = null;
    }
  }
};
const _lut$1 = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
let _seed = 1234567;
const DEG2RAD$1 = Math.PI / 180;
const RAD2DEG$1 = 180 / Math.PI;
function generateUUID$1() {
  const d0 = Math.random() * 4294967295 | 0;
  const d1 = Math.random() * 4294967295 | 0;
  const d2 = Math.random() * 4294967295 | 0;
  const d3 = Math.random() * 4294967295 | 0;
  const uuid = _lut$1[d0 & 255] + _lut$1[d0 >> 8 & 255] + _lut$1[d0 >> 16 & 255] + _lut$1[d0 >> 24 & 255] + "-" + _lut$1[d1 & 255] + _lut$1[d1 >> 8 & 255] + "-" + _lut$1[d1 >> 16 & 15 | 64] + _lut$1[d1 >> 24 & 255] + "-" + _lut$1[d2 & 63 | 128] + _lut$1[d2 >> 8 & 255] + "-" + _lut$1[d2 >> 16 & 255] + _lut$1[d2 >> 24 & 255] + _lut$1[d3 & 255] + _lut$1[d3 >> 8 & 255] + _lut$1[d3 >> 16 & 255] + _lut$1[d3 >> 24 & 255];
  return uuid.toLowerCase();
}
function clamp$1(value, min, max2) {
  return Math.max(min, Math.min(max2, value));
}
function euclideanModulo$1(n2, m) {
  return (n2 % m + m) % m;
}
function mapLinear(x, a1, a22, b1, b2) {
  return b1 + (x - a1) * (b2 - b1) / (a22 - a1);
}
function inverseLerp(x, y, value) {
  if (x !== y) {
    return (value - x) / (y - x);
  } else {
    return 0;
  }
}
function lerp$2(x, y, t3) {
  return (1 - t3) * x + t3 * y;
}
function damp(x, y, lambda, dt) {
  return lerp$2(x, y, 1 - Math.exp(-lambda * dt));
}
function pingpong(x, length2 = 1) {
  return length2 - Math.abs(euclideanModulo$1(x, length2 * 2) - length2);
}
function smoothstep(x, min, max2) {
  if (x <= min) return 0;
  if (x >= max2) return 1;
  x = (x - min) / (max2 - min);
  return x * x * (3 - 2 * x);
}
function smootherstep(x, min, max2) {
  if (x <= min) return 0;
  if (x >= max2) return 1;
  x = (x - min) / (max2 - min);
  return x * x * x * (x * (x * 6 - 15) + 10);
}
function randInt(low, high) {
  return low + Math.floor(Math.random() * (high - low + 1));
}
function randFloat(low, high) {
  return low + Math.random() * (high - low);
}
function randFloatSpread(range) {
  return range * (0.5 - Math.random());
}
function seededRandom(s2) {
  if (s2 !== void 0) _seed = s2;
  let t3 = _seed += 1831565813;
  t3 = Math.imul(t3 ^ t3 >>> 15, t3 | 1);
  t3 ^= t3 + Math.imul(t3 ^ t3 >>> 7, t3 | 61);
  return ((t3 ^ t3 >>> 14) >>> 0) / 4294967296;
}
function degToRad(degrees) {
  return degrees * DEG2RAD$1;
}
function radToDeg(radians) {
  return radians * RAD2DEG$1;
}
function isPowerOfTwo$1(value) {
  return (value & value - 1) === 0 && value !== 0;
}
function ceilPowerOfTwo(value) {
  return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function floorPowerOfTwo$1(value) {
  return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function setQuaternionFromProperEuler(q, a3, b, c2, order) {
  const cos2 = Math.cos;
  const sin2 = Math.sin;
  const c22 = cos2(b / 2);
  const s2 = sin2(b / 2);
  const c13 = cos2((a3 + c2) / 2);
  const s13 = sin2((a3 + c2) / 2);
  const c1_3 = cos2((a3 - c2) / 2);
  const s1_3 = sin2((a3 - c2) / 2);
  const c3_1 = cos2((c2 - a3) / 2);
  const s3_1 = sin2((c2 - a3) / 2);
  switch (order) {
    case "XYX":
      q.set(c22 * s13, s2 * c1_3, s2 * s1_3, c22 * c13);
      break;
    case "YZY":
      q.set(s2 * s1_3, c22 * s13, s2 * c1_3, c22 * c13);
      break;
    case "ZXZ":
      q.set(s2 * c1_3, s2 * s1_3, c22 * s13, c22 * c13);
      break;
    case "XZX":
      q.set(c22 * s13, s2 * s3_1, s2 * c3_1, c22 * c13);
      break;
    case "YXY":
      q.set(s2 * c3_1, c22 * s13, s2 * s3_1, c22 * c13);
      break;
    case "ZYZ":
      q.set(s2 * s3_1, s2 * c3_1, c22 * s13, c22 * c13);
      break;
    default:
      console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
  }
}
function denormalize(value, array) {
  switch (array.constructor) {
    case Float32Array:
      return value;
    case Uint32Array:
      return value / 4294967295;
    case Uint16Array:
      return value / 65535;
    case Uint8Array:
      return value / 255;
    case Int32Array:
      return Math.max(value / 2147483647, -1);
    case Int16Array:
      return Math.max(value / 32767, -1);
    case Int8Array:
      return Math.max(value / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function normalize(value, array) {
  switch (array.constructor) {
    case Float32Array:
      return value;
    case Uint32Array:
      return Math.round(value * 4294967295);
    case Uint16Array:
      return Math.round(value * 65535);
    case Uint8Array:
      return Math.round(value * 255);
    case Int32Array:
      return Math.round(value * 2147483647);
    case Int16Array:
      return Math.round(value * 32767);
    case Int8Array:
      return Math.round(value * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
const MathUtils = {
  DEG2RAD: DEG2RAD$1,
  RAD2DEG: RAD2DEG$1,
  generateUUID: generateUUID$1,
  clamp: clamp$1,
  euclideanModulo: euclideanModulo$1,
  mapLinear,
  inverseLerp,
  lerp: lerp$2,
  damp,
  pingpong,
  smoothstep,
  smootherstep,
  randInt,
  randFloat,
  randFloatSpread,
  seededRandom,
  degToRad,
  radToDeg,
  isPowerOfTwo: isPowerOfTwo$1,
  ceilPowerOfTwo,
  floorPowerOfTwo: floorPowerOfTwo$1,
  setQuaternionFromProperEuler,
  normalize,
  denormalize
};
let Vector2$1 = class Vector2 {
  constructor(x = 0, y = 0) {
    Vector2.prototype.isVector2 = true;
    this.x = x;
    this.y = y;
  }
  get width() {
    return this.x;
  }
  set width(value) {
    this.x = value;
  }
  get height() {
    return this.y;
  }
  set height(value) {
    this.y = value;
  }
  set(x, y) {
    this.x = x;
    this.y = y;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    return this;
  }
  setX(x) {
    this.x = x;
    return this;
  }
  setY(y) {
    this.y = y;
    return this;
  }
  setComponent(index2, value) {
    switch (index2) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      default:
        throw new Error("index is out of range: " + index2);
    }
    return this;
  }
  getComponent(index2) {
    switch (index2) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + index2);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(v) {
    this.x = v.x;
    this.y = v.y;
    return this;
  }
  add(v) {
    this.x += v.x;
    this.y += v.y;
    return this;
  }
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    return this;
  }
  addVectors(a3, b) {
    this.x = a3.x + b.x;
    this.y = a3.y + b.y;
    return this;
  }
  addScaledVector(v, s2) {
    this.x += v.x * s2;
    this.y += v.y * s2;
    return this;
  }
  sub(v) {
    this.x -= v.x;
    this.y -= v.y;
    return this;
  }
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    return this;
  }
  subVectors(a3, b) {
    this.x = a3.x - b.x;
    this.y = a3.y - b.y;
    return this;
  }
  multiply(v) {
    this.x *= v.x;
    this.y *= v.y;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    return this;
  }
  divide(v) {
    this.x /= v.x;
    this.y /= v.y;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  applyMatrix3(m) {
    const x = this.x, y = this.y;
    const e2 = m.elements;
    this.x = e2[0] * x + e2[3] * y + e2[6];
    this.y = e2[1] * x + e2[4] * y + e2[7];
    return this;
  }
  min(v) {
    this.x = Math.min(this.x, v.x);
    this.y = Math.min(this.y, v.y);
    return this;
  }
  max(v) {
    this.x = Math.max(this.x, v.x);
    this.y = Math.max(this.y, v.y);
    return this;
  }
  clamp(min, max2) {
    this.x = clamp$1(this.x, min.x, max2.x);
    this.y = clamp$1(this.y, min.y, max2.y);
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = clamp$1(this.x, minVal, maxVal);
    this.y = clamp$1(this.y, minVal, maxVal);
    return this;
  }
  clampLength(min, max2) {
    const length2 = this.length();
    return this.divideScalar(length2 || 1).multiplyScalar(clamp$1(length2, min, max2));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  }
  roundToZero() {
    this.x = Math.trunc(this.x);
    this.y = Math.trunc(this.y);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    return this;
  }
  dot(v) {
    return this.x * v.x + this.y * v.y;
  }
  cross(v) {
    return this.x * v.y - this.y * v.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    const angle2 = Math.atan2(-this.y, -this.x) + Math.PI;
    return angle2;
  }
  angleTo(v) {
    const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
    if (denominator === 0) return Math.PI / 2;
    const theta = this.dot(v) / denominator;
    return Math.acos(clamp$1(theta, -1, 1));
  }
  distanceTo(v) {
    return Math.sqrt(this.distanceToSquared(v));
  }
  distanceToSquared(v) {
    const dx = this.x - v.x, dy = this.y - v.y;
    return dx * dx + dy * dy;
  }
  manhattanDistanceTo(v) {
    return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
  }
  setLength(length2) {
    return this.normalize().multiplyScalar(length2);
  }
  lerp(v, alpha) {
    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    return this;
  }
  lerpVectors(v1, v2, alpha) {
    this.x = v1.x + (v2.x - v1.x) * alpha;
    this.y = v1.y + (v2.y - v1.y) * alpha;
    return this;
  }
  equals(v) {
    return v.x === this.x && v.y === this.y;
  }
  fromArray(array, offset = 0) {
    this.x = array[offset];
    this.y = array[offset + 1];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.x;
    array[offset + 1] = this.y;
    return array;
  }
  fromBufferAttribute(attribute, index2) {
    this.x = attribute.getX(index2);
    this.y = attribute.getY(index2);
    return this;
  }
  rotateAround(center, angle2) {
    const c2 = Math.cos(angle2), s2 = Math.sin(angle2);
    const x = this.x - center.x;
    const y = this.y - center.y;
    this.x = x * c2 - y * s2 + center.x;
    this.y = x * s2 + y * c2 + center.y;
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
  }
};
let Matrix3$1 = class Matrix3 {
  constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
    Matrix3.prototype.isMatrix3 = true;
    this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ];
    if (n11 !== void 0) {
      this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
  }
  set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
    const te2 = this.elements;
    te2[0] = n11;
    te2[1] = n21;
    te2[2] = n31;
    te2[3] = n12;
    te2[4] = n22;
    te2[5] = n32;
    te2[6] = n13;
    te2[7] = n23;
    te2[8] = n33;
    return this;
  }
  identity() {
    this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    );
    return this;
  }
  copy(m) {
    const te2 = this.elements;
    const me = m.elements;
    te2[0] = me[0];
    te2[1] = me[1];
    te2[2] = me[2];
    te2[3] = me[3];
    te2[4] = me[4];
    te2[5] = me[5];
    te2[6] = me[6];
    te2[7] = me[7];
    te2[8] = me[8];
    return this;
  }
  extractBasis(xAxis, yAxis, zAxis) {
    xAxis.setFromMatrix3Column(this, 0);
    yAxis.setFromMatrix3Column(this, 1);
    zAxis.setFromMatrix3Column(this, 2);
    return this;
  }
  setFromMatrix4(m) {
    const me = m.elements;
    this.set(
      me[0],
      me[4],
      me[8],
      me[1],
      me[5],
      me[9],
      me[2],
      me[6],
      me[10]
    );
    return this;
  }
  multiply(m) {
    return this.multiplyMatrices(this, m);
  }
  premultiply(m) {
    return this.multiplyMatrices(m, this);
  }
  multiplyMatrices(a3, b) {
    const ae2 = a3.elements;
    const be = b.elements;
    const te2 = this.elements;
    const a11 = ae2[0], a12 = ae2[3], a13 = ae2[6];
    const a21 = ae2[1], a22 = ae2[4], a23 = ae2[7];
    const a31 = ae2[2], a32 = ae2[5], a33 = ae2[8];
    const b11 = be[0], b12 = be[3], b13 = be[6];
    const b21 = be[1], b22 = be[4], b23 = be[7];
    const b31 = be[2], b32 = be[5], b33 = be[8];
    te2[0] = a11 * b11 + a12 * b21 + a13 * b31;
    te2[3] = a11 * b12 + a12 * b22 + a13 * b32;
    te2[6] = a11 * b13 + a12 * b23 + a13 * b33;
    te2[1] = a21 * b11 + a22 * b21 + a23 * b31;
    te2[4] = a21 * b12 + a22 * b22 + a23 * b32;
    te2[7] = a21 * b13 + a22 * b23 + a23 * b33;
    te2[2] = a31 * b11 + a32 * b21 + a33 * b31;
    te2[5] = a31 * b12 + a32 * b22 + a33 * b32;
    te2[8] = a31 * b13 + a32 * b23 + a33 * b33;
    return this;
  }
  multiplyScalar(s2) {
    const te2 = this.elements;
    te2[0] *= s2;
    te2[3] *= s2;
    te2[6] *= s2;
    te2[1] *= s2;
    te2[4] *= s2;
    te2[7] *= s2;
    te2[2] *= s2;
    te2[5] *= s2;
    te2[8] *= s2;
    return this;
  }
  determinant() {
    const te2 = this.elements;
    const a3 = te2[0], b = te2[1], c2 = te2[2], d2 = te2[3], e2 = te2[4], f2 = te2[5], g3 = te2[6], h2 = te2[7], i2 = te2[8];
    return a3 * e2 * i2 - a3 * f2 * h2 - b * d2 * i2 + b * f2 * g3 + c2 * d2 * h2 - c2 * e2 * g3;
  }
  invert() {
    const te2 = this.elements, n11 = te2[0], n21 = te2[1], n31 = te2[2], n12 = te2[3], n22 = te2[4], n32 = te2[5], n13 = te2[6], n23 = te2[7], n33 = te2[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
    if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const detInv = 1 / det;
    te2[0] = t11 * detInv;
    te2[1] = (n31 * n23 - n33 * n21) * detInv;
    te2[2] = (n32 * n21 - n31 * n22) * detInv;
    te2[3] = t12 * detInv;
    te2[4] = (n33 * n11 - n31 * n13) * detInv;
    te2[5] = (n31 * n12 - n32 * n11) * detInv;
    te2[6] = t13 * detInv;
    te2[7] = (n21 * n13 - n23 * n11) * detInv;
    te2[8] = (n22 * n11 - n21 * n12) * detInv;
    return this;
  }
  transpose() {
    let tmp2;
    const m = this.elements;
    tmp2 = m[1];
    m[1] = m[3];
    m[3] = tmp2;
    tmp2 = m[2];
    m[2] = m[6];
    m[6] = tmp2;
    tmp2 = m[5];
    m[5] = m[7];
    m[7] = tmp2;
    return this;
  }
  getNormalMatrix(matrix4) {
    return this.setFromMatrix4(matrix4).invert().transpose();
  }
  transposeIntoArray(r2) {
    const m = this.elements;
    r2[0] = m[0];
    r2[1] = m[3];
    r2[2] = m[6];
    r2[3] = m[1];
    r2[4] = m[4];
    r2[5] = m[7];
    r2[6] = m[2];
    r2[7] = m[5];
    r2[8] = m[8];
    return this;
  }
  setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
    const c2 = Math.cos(rotation);
    const s2 = Math.sin(rotation);
    this.set(
      sx * c2,
      sx * s2,
      -sx * (c2 * cx + s2 * cy) + cx + tx,
      -sy * s2,
      sy * c2,
      -sy * (-s2 * cx + c2 * cy) + cy + ty,
      0,
      0,
      1
    );
    return this;
  }
  //
  scale(sx, sy) {
    this.premultiply(_m3.makeScale(sx, sy));
    return this;
  }
  rotate(theta) {
    this.premultiply(_m3.makeRotation(-theta));
    return this;
  }
  translate(tx, ty) {
    this.premultiply(_m3.makeTranslation(tx, ty));
    return this;
  }
  // for 2D Transforms
  makeTranslation(x, y) {
    if (x.isVector2) {
      this.set(
        1,
        0,
        x.x,
        0,
        1,
        x.y,
        0,
        0,
        1
      );
    } else {
      this.set(
        1,
        0,
        x,
        0,
        1,
        y,
        0,
        0,
        1
      );
    }
    return this;
  }
  makeRotation(theta) {
    const c2 = Math.cos(theta);
    const s2 = Math.sin(theta);
    this.set(
      c2,
      -s2,
      0,
      s2,
      c2,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeScale(x, y) {
    this.set(
      x,
      0,
      0,
      0,
      y,
      0,
      0,
      0,
      1
    );
    return this;
  }
  //
  equals(matrix2) {
    const te2 = this.elements;
    const me = matrix2.elements;
    for (let i2 = 0; i2 < 9; i2++) {
      if (te2[i2] !== me[i2]) return false;
    }
    return true;
  }
  fromArray(array, offset = 0) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.elements[i2] = array[i2 + offset];
    }
    return this;
  }
  toArray(array = [], offset = 0) {
    const te2 = this.elements;
    array[offset] = te2[0];
    array[offset + 1] = te2[1];
    array[offset + 2] = te2[2];
    array[offset + 3] = te2[3];
    array[offset + 4] = te2[4];
    array[offset + 5] = te2[5];
    array[offset + 6] = te2[6];
    array[offset + 7] = te2[7];
    array[offset + 8] = te2[8];
    return array;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
};
const _m3 = /* @__PURE__ */ new Matrix3$1();
function arrayNeedsUint32(array) {
  for (let i2 = array.length - 1; i2 >= 0; --i2) {
    if (array[i2] >= 65535) return true;
  }
  return false;
}
const TYPED_ARRAYS = {
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array
};
function getTypedArray(type, buffer) {
  return new TYPED_ARRAYS[type](buffer);
}
function createElementNS(name) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
function createCanvasElement$1() {
  const canvas = createElementNS("canvas");
  canvas.style.display = "block";
  return canvas;
}
const _cache = {};
function warnOnce(message) {
  if (message in _cache) return;
  _cache[message] = true;
  console.warn(message);
}
function probeAsync(gl, sync, interval) {
  return new Promise(function(resolve, reject) {
    function probe() {
      switch (gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)) {
        case gl.WAIT_FAILED:
          reject();
          break;
        case gl.TIMEOUT_EXPIRED:
          setTimeout(probe, interval);
          break;
        default:
          resolve();
      }
    }
    setTimeout(probe, interval);
  });
}
function toNormalizedProjectionMatrix(projectionMatrix) {
  const m = projectionMatrix.elements;
  m[2] = 0.5 * m[2] + 0.5 * m[3];
  m[6] = 0.5 * m[6] + 0.5 * m[7];
  m[10] = 0.5 * m[10] + 0.5 * m[11];
  m[14] = 0.5 * m[14] + 0.5 * m[15];
}
function toReversedProjectionMatrix(projectionMatrix) {
  const m = projectionMatrix.elements;
  const isPerspectiveMatrix = m[11] === -1;
  if (isPerspectiveMatrix) {
    m[10] = -m[10] - 1;
    m[14] = -m[14];
  } else {
    m[10] = -m[10];
    m[14] = -m[14] + 1;
  }
}
const LINEAR_REC709_TO_XYZ = /* @__PURE__ */ new Matrix3$1().set(
  0.4123908,
  0.3575843,
  0.1804808,
  0.212639,
  0.7151687,
  0.0721923,
  0.0193308,
  0.1191948,
  0.9505322
);
const XYZ_TO_LINEAR_REC709 = /* @__PURE__ */ new Matrix3$1().set(
  3.2409699,
  -1.5373832,
  -0.4986108,
  -0.9692436,
  1.8759675,
  0.0415551,
  0.0556301,
  -0.203977,
  1.0569715
);
function createColorManagement() {
  const ColorManagement2 = {
    enabled: true,
    workingColorSpace: LinearSRGBColorSpace,
    /**
     * Implementations of supported color spaces.
     *
     * Required:
     *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
     *	- whitePoint: reference white [ x y ]
     *	- transfer: transfer function (pre-defined)
     *	- toXYZ: Matrix3 RGB to XYZ transform
     *	- fromXYZ: Matrix3 XYZ to RGB transform
     *	- luminanceCoefficients: RGB luminance coefficients
     *
     * Optional:
     *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
     *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
     *
     * Reference:
     * - https://www.russellcottrell.com/photo/matrixCalculator.htm
     */
    spaces: {},
    convert: function(color2, sourceColorSpace, targetColorSpace) {
      if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) {
        return color2;
      }
      if (this.spaces[sourceColorSpace].transfer === SRGBTransfer) {
        color2.r = SRGBToLinear$1(color2.r);
        color2.g = SRGBToLinear$1(color2.g);
        color2.b = SRGBToLinear$1(color2.b);
      }
      if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
        color2.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
        color2.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
      }
      if (this.spaces[targetColorSpace].transfer === SRGBTransfer) {
        color2.r = LinearToSRGB$1(color2.r);
        color2.g = LinearToSRGB$1(color2.g);
        color2.b = LinearToSRGB$1(color2.b);
      }
      return color2;
    },
    fromWorkingColorSpace: function(color2, targetColorSpace) {
      return this.convert(color2, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color2, sourceColorSpace) {
      return this.convert(color2, sourceColorSpace, this.workingColorSpace);
    },
    getPrimaries: function(colorSpace) {
      return this.spaces[colorSpace].primaries;
    },
    getTransfer: function(colorSpace) {
      if (colorSpace === NoColorSpace) return LinearTransfer;
      return this.spaces[colorSpace].transfer;
    },
    getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
      return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
    },
    define: function(colorSpaces) {
      Object.assign(this.spaces, colorSpaces);
    },
    // Internal APIs
    _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
      return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
    },
    _getDrawingBufferColorSpace: function(colorSpace) {
      return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
    },
    _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
      return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
    }
  };
  const REC709_PRIMARIES = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06];
  const REC709_LUMINANCE_COEFFICIENTS = [0.2126, 0.7152, 0.0722];
  const D65 = [0.3127, 0.329];
  ColorManagement2.define({
    [LinearSRGBColorSpace]: {
      primaries: REC709_PRIMARIES,
      whitePoint: D65,
      transfer: LinearTransfer,
      toXYZ: LINEAR_REC709_TO_XYZ,
      fromXYZ: XYZ_TO_LINEAR_REC709,
      luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
      workingColorSpaceConfig: { unpackColorSpace: SRGBColorSpace },
      outputColorSpaceConfig: { drawingBufferColorSpace: SRGBColorSpace }
    },
    [SRGBColorSpace]: {
      primaries: REC709_PRIMARIES,
      whitePoint: D65,
      transfer: SRGBTransfer,
      toXYZ: LINEAR_REC709_TO_XYZ,
      fromXYZ: XYZ_TO_LINEAR_REC709,
      luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
      outputColorSpaceConfig: { drawingBufferColorSpace: SRGBColorSpace }
    }
  });
  return ColorManagement2;
}
const ColorManagement = /* @__PURE__ */ createColorManagement();
function SRGBToLinear$1(c2) {
  return c2 < 0.04045 ? c2 * 0.0773993808 : Math.pow(c2 * 0.9478672986 + 0.0521327014, 2.4);
}
function LinearToSRGB$1(c2) {
  return c2 < 31308e-7 ? c2 * 12.92 : 1.055 * Math.pow(c2, 0.41666) - 0.055;
}
let _canvas$1;
let ImageUtils$1 = class ImageUtils {
  static getDataURL(image2) {
    if (/^data:/i.test(image2.src)) {
      return image2.src;
    }
    if (typeof HTMLCanvasElement === "undefined") {
      return image2.src;
    }
    let canvas;
    if (image2 instanceof HTMLCanvasElement) {
      canvas = image2;
    } else {
      if (_canvas$1 === void 0) _canvas$1 = createElementNS("canvas");
      _canvas$1.width = image2.width;
      _canvas$1.height = image2.height;
      const context = _canvas$1.getContext("2d");
      if (image2 instanceof ImageData) {
        context.putImageData(image2, 0, 0);
      } else {
        context.drawImage(image2, 0, 0, image2.width, image2.height);
      }
      canvas = _canvas$1;
    }
    if (canvas.width > 2048 || canvas.height > 2048) {
      console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image2);
      return canvas.toDataURL("image/jpeg", 0.6);
    } else {
      return canvas.toDataURL("image/png");
    }
  }
  static sRGBToLinear(image2) {
    if (typeof HTMLImageElement !== "undefined" && image2 instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image2 instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image2 instanceof ImageBitmap) {
      const canvas = createElementNS("canvas");
      canvas.width = image2.width;
      canvas.height = image2.height;
      const context = canvas.getContext("2d");
      context.drawImage(image2, 0, 0, image2.width, image2.height);
      const imageData = context.getImageData(0, 0, image2.width, image2.height);
      const data = imageData.data;
      for (let i2 = 0; i2 < data.length; i2++) {
        data[i2] = SRGBToLinear$1(data[i2] / 255) * 255;
      }
      context.putImageData(imageData, 0, 0);
      return canvas;
    } else if (image2.data) {
      const data = image2.data.slice(0);
      for (let i2 = 0; i2 < data.length; i2++) {
        if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) {
          data[i2] = Math.floor(SRGBToLinear$1(data[i2] / 255) * 255);
        } else {
          data[i2] = SRGBToLinear$1(data[i2]);
        }
      }
      return {
        data,
        width: image2.width,
        height: image2.height
      };
    } else {
      console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
      return image2;
    }
  }
};
let _sourceId = 0;
class Source {
  constructor(data = null) {
    this.isSource = true;
    Object.defineProperty(this, "id", { value: _sourceId++ });
    this.uuid = generateUUID$1();
    this.data = data;
    this.dataReady = true;
    this.version = 0;
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    if (!isRootObject && meta.images[this.uuid] !== void 0) {
      return meta.images[this.uuid];
    }
    const output = {
      uuid: this.uuid,
      url: ""
    };
    const data = this.data;
    if (data !== null) {
      let url;
      if (Array.isArray(data)) {
        url = [];
        for (let i2 = 0, l2 = data.length; i2 < l2; i2++) {
          if (data[i2].isDataTexture) {
            url.push(serializeImage$1(data[i2].image));
          } else {
            url.push(serializeImage$1(data[i2]));
          }
        }
      } else {
        url = serializeImage$1(data);
      }
      output.url = url;
    }
    if (!isRootObject) {
      meta.images[this.uuid] = output;
    }
    return output;
  }
}
function serializeImage$1(image2) {
  if (typeof HTMLImageElement !== "undefined" && image2 instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image2 instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image2 instanceof ImageBitmap) {
    return ImageUtils$1.getDataURL(image2);
  } else {
    if (image2.data) {
      return {
        data: Array.from(image2.data),
        width: image2.width,
        height: image2.height,
        type: image2.data.constructor.name
      };
    } else {
      console.warn("THREE.Texture: Unable to serialize Texture.");
      return {};
    }
  }
}
let _textureId = 0;
let Texture$1 = class Texture extends EventDispatcher$1 {
  constructor(image2 = Texture.DEFAULT_IMAGE, mapping = Texture.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping$1, wrapT = ClampToEdgeWrapping$1, magFilter = LinearFilter$1, minFilter = LinearMipmapLinearFilter$1, format = RGBAFormat$1, type = UnsignedByteType$1, anisotropy = Texture.DEFAULT_ANISOTROPY, colorSpace = NoColorSpace) {
    super();
    this.isTexture = true;
    Object.defineProperty(this, "id", { value: _textureId++ });
    this.uuid = generateUUID$1();
    this.name = "";
    this.source = new Source(image2);
    this.mipmaps = [];
    this.mapping = mapping;
    this.channel = 0;
    this.wrapS = wrapS;
    this.wrapT = wrapT;
    this.magFilter = magFilter;
    this.minFilter = minFilter;
    this.anisotropy = anisotropy;
    this.format = format;
    this.internalFormat = null;
    this.type = type;
    this.offset = new Vector2$1(0, 0);
    this.repeat = new Vector2$1(1, 1);
    this.center = new Vector2$1(0, 0);
    this.rotation = 0;
    this.matrixAutoUpdate = true;
    this.matrix = new Matrix3$1();
    this.generateMipmaps = true;
    this.premultiplyAlpha = false;
    this.flipY = true;
    this.unpackAlignment = 4;
    this.colorSpace = colorSpace;
    this.userData = {};
    this.version = 0;
    this.onUpdate = null;
    this.isRenderTargetTexture = false;
    this.pmremVersion = 0;
  }
  get image() {
    return this.source.data;
  }
  set image(value = null) {
    this.source.data = value;
  }
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.name = source.name;
    this.source = source.source;
    this.mipmaps = source.mipmaps.slice(0);
    this.mapping = source.mapping;
    this.channel = source.channel;
    this.wrapS = source.wrapS;
    this.wrapT = source.wrapT;
    this.magFilter = source.magFilter;
    this.minFilter = source.minFilter;
    this.anisotropy = source.anisotropy;
    this.format = source.format;
    this.internalFormat = source.internalFormat;
    this.type = source.type;
    this.offset.copy(source.offset);
    this.repeat.copy(source.repeat);
    this.center.copy(source.center);
    this.rotation = source.rotation;
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    this.matrix.copy(source.matrix);
    this.generateMipmaps = source.generateMipmaps;
    this.premultiplyAlpha = source.premultiplyAlpha;
    this.flipY = source.flipY;
    this.unpackAlignment = source.unpackAlignment;
    this.colorSpace = source.colorSpace;
    this.userData = JSON.parse(JSON.stringify(source.userData));
    this.needsUpdate = true;
    return this;
  }
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    if (!isRootObject && meta.textures[this.uuid] !== void 0) {
      return meta.textures[this.uuid];
    }
    const output = {
      metadata: {
        version: 4.6,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(meta).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    if (Object.keys(this.userData).length > 0) output.userData = this.userData;
    if (!isRootObject) {
      meta.textures[this.uuid] = output;
    }
    return output;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  transformUv(uv) {
    if (this.mapping !== UVMapping$1) return uv;
    uv.applyMatrix3(this.matrix);
    if (uv.x < 0 || uv.x > 1) {
      switch (this.wrapS) {
        case RepeatWrapping$1:
          uv.x = uv.x - Math.floor(uv.x);
          break;
        case ClampToEdgeWrapping$1:
          uv.x = uv.x < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping$1:
          if (Math.abs(Math.floor(uv.x) % 2) === 1) {
            uv.x = Math.ceil(uv.x) - uv.x;
          } else {
            uv.x = uv.x - Math.floor(uv.x);
          }
          break;
      }
    }
    if (uv.y < 0 || uv.y > 1) {
      switch (this.wrapT) {
        case RepeatWrapping$1:
          uv.y = uv.y - Math.floor(uv.y);
          break;
        case ClampToEdgeWrapping$1:
          uv.y = uv.y < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping$1:
          if (Math.abs(Math.floor(uv.y) % 2) === 1) {
            uv.y = Math.ceil(uv.y) - uv.y;
          } else {
            uv.y = uv.y - Math.floor(uv.y);
          }
          break;
      }
    }
    if (this.flipY) {
      uv.y = 1 - uv.y;
    }
    return uv;
  }
  set needsUpdate(value) {
    if (value === true) {
      this.version++;
      this.source.needsUpdate = true;
    }
  }
  set needsPMREMUpdate(value) {
    if (value === true) {
      this.pmremVersion++;
    }
  }
};
Texture$1.DEFAULT_IMAGE = null;
Texture$1.DEFAULT_MAPPING = UVMapping$1;
Texture$1.DEFAULT_ANISOTROPY = 1;
let Vector4$1 = class Vector4 {
  constructor(x = 0, y = 0, z2 = 0, w = 1) {
    Vector4.prototype.isVector4 = true;
    this.x = x;
    this.y = y;
    this.z = z2;
    this.w = w;
  }
  get width() {
    return this.z;
  }
  set width(value) {
    this.z = value;
  }
  get height() {
    return this.w;
  }
  set height(value) {
    this.w = value;
  }
  set(x, y, z2, w) {
    this.x = x;
    this.y = y;
    this.z = z2;
    this.w = w;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    this.z = scalar;
    this.w = scalar;
    return this;
  }
  setX(x) {
    this.x = x;
    return this;
  }
  setY(y) {
    this.y = y;
    return this;
  }
  setZ(z2) {
    this.z = z2;
    return this;
  }
  setW(w) {
    this.w = w;
    return this;
  }
  setComponent(index2, value) {
    switch (index2) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      case 2:
        this.z = value;
        break;
      case 3:
        this.w = value;
        break;
      default:
        throw new Error("index is out of range: " + index2);
    }
    return this;
  }
  getComponent(index2) {
    switch (index2) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + index2);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(v) {
    this.x = v.x;
    this.y = v.y;
    this.z = v.z;
    this.w = v.w !== void 0 ? v.w : 1;
    return this;
  }
  add(v) {
    this.x += v.x;
    this.y += v.y;
    this.z += v.z;
    this.w += v.w;
    return this;
  }
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    this.z += s2;
    this.w += s2;
    return this;
  }
  addVectors(a3, b) {
    this.x = a3.x + b.x;
    this.y = a3.y + b.y;
    this.z = a3.z + b.z;
    this.w = a3.w + b.w;
    return this;
  }
  addScaledVector(v, s2) {
    this.x += v.x * s2;
    this.y += v.y * s2;
    this.z += v.z * s2;
    this.w += v.w * s2;
    return this;
  }
  sub(v) {
    this.x -= v.x;
    this.y -= v.y;
    this.z -= v.z;
    this.w -= v.w;
    return this;
  }
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    this.z -= s2;
    this.w -= s2;
    return this;
  }
  subVectors(a3, b) {
    this.x = a3.x - b.x;
    this.y = a3.y - b.y;
    this.z = a3.z - b.z;
    this.w = a3.w - b.w;
    return this;
  }
  multiply(v) {
    this.x *= v.x;
    this.y *= v.y;
    this.z *= v.z;
    this.w *= v.w;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;
    this.w *= scalar;
    return this;
  }
  applyMatrix4(m) {
    const x = this.x, y = this.y, z2 = this.z, w = this.w;
    const e2 = m.elements;
    this.x = e2[0] * x + e2[4] * y + e2[8] * z2 + e2[12] * w;
    this.y = e2[1] * x + e2[5] * y + e2[9] * z2 + e2[13] * w;
    this.z = e2[2] * x + e2[6] * y + e2[10] * z2 + e2[14] * w;
    this.w = e2[3] * x + e2[7] * y + e2[11] * z2 + e2[15] * w;
    return this;
  }
  divide(v) {
    this.x /= v.x;
    this.y /= v.y;
    this.z /= v.z;
    this.w /= v.w;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  setAxisAngleFromQuaternion(q) {
    this.w = 2 * Math.acos(q.w);
    const s2 = Math.sqrt(1 - q.w * q.w);
    if (s2 < 1e-4) {
      this.x = 1;
      this.y = 0;
      this.z = 0;
    } else {
      this.x = q.x / s2;
      this.y = q.y / s2;
      this.z = q.z / s2;
    }
    return this;
  }
  setAxisAngleFromRotationMatrix(m) {
    let angle2, x, y, z2;
    const epsilon = 0.01, epsilon2 = 0.1, te2 = m.elements, m11 = te2[0], m12 = te2[4], m13 = te2[8], m21 = te2[1], m22 = te2[5], m23 = te2[9], m31 = te2[2], m32 = te2[6], m33 = te2[10];
    if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
      if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
        this.set(1, 0, 0, 0);
        return this;
      }
      angle2 = Math.PI;
      const xx = (m11 + 1) / 2;
      const yy = (m22 + 1) / 2;
      const zz = (m33 + 1) / 2;
      const xy = (m12 + m21) / 4;
      const xz = (m13 + m31) / 4;
      const yz = (m23 + m32) / 4;
      if (xx > yy && xx > zz) {
        if (xx < epsilon) {
          x = 0;
          y = 0.707106781;
          z2 = 0.707106781;
        } else {
          x = Math.sqrt(xx);
          y = xy / x;
          z2 = xz / x;
        }
      } else if (yy > zz) {
        if (yy < epsilon) {
          x = 0.707106781;
          y = 0;
          z2 = 0.707106781;
        } else {
          y = Math.sqrt(yy);
          x = xy / y;
          z2 = yz / y;
        }
      } else {
        if (zz < epsilon) {
          x = 0.707106781;
          y = 0.707106781;
          z2 = 0;
        } else {
          z2 = Math.sqrt(zz);
          x = xz / z2;
          y = yz / z2;
        }
      }
      this.set(x, y, z2, angle2);
      return this;
    }
    let s2 = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12));
    if (Math.abs(s2) < 1e-3) s2 = 1;
    this.x = (m32 - m23) / s2;
    this.y = (m13 - m31) / s2;
    this.z = (m21 - m12) / s2;
    this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
    return this;
  }
  setFromMatrixPosition(m) {
    const e2 = m.elements;
    this.x = e2[12];
    this.y = e2[13];
    this.z = e2[14];
    this.w = e2[15];
    return this;
  }
  min(v) {
    this.x = Math.min(this.x, v.x);
    this.y = Math.min(this.y, v.y);
    this.z = Math.min(this.z, v.z);
    this.w = Math.min(this.w, v.w);
    return this;
  }
  max(v) {
    this.x = Math.max(this.x, v.x);
    this.y = Math.max(this.y, v.y);
    this.z = Math.max(this.z, v.z);
    this.w = Math.max(this.w, v.w);
    return this;
  }
  clamp(min, max2) {
    this.x = clamp$1(this.x, min.x, max2.x);
    this.y = clamp$1(this.y, min.y, max2.y);
    this.z = clamp$1(this.z, min.z, max2.z);
    this.w = clamp$1(this.w, min.w, max2.w);
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = clamp$1(this.x, minVal, maxVal);
    this.y = clamp$1(this.y, minVal, maxVal);
    this.z = clamp$1(this.z, minVal, maxVal);
    this.w = clamp$1(this.w, minVal, maxVal);
    return this;
  }
  clampLength(min, max2) {
    const length2 = this.length();
    return this.divideScalar(length2 || 1).multiplyScalar(clamp$1(length2, min, max2));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    this.w = Math.floor(this.w);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    this.w = Math.ceil(this.w);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    this.w = Math.round(this.w);
    return this;
  }
  roundToZero() {
    this.x = Math.trunc(this.x);
    this.y = Math.trunc(this.y);
    this.z = Math.trunc(this.z);
    this.w = Math.trunc(this.w);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    this.w = -this.w;
    return this;
  }
  dot(v) {
    return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(length2) {
    return this.normalize().multiplyScalar(length2);
  }
  lerp(v, alpha) {
    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    this.z += (v.z - this.z) * alpha;
    this.w += (v.w - this.w) * alpha;
    return this;
  }
  lerpVectors(v1, v2, alpha) {
    this.x = v1.x + (v2.x - v1.x) * alpha;
    this.y = v1.y + (v2.y - v1.y) * alpha;
    this.z = v1.z + (v2.z - v1.z) * alpha;
    this.w = v1.w + (v2.w - v1.w) * alpha;
    return this;
  }
  equals(v) {
    return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
  }
  fromArray(array, offset = 0) {
    this.x = array[offset];
    this.y = array[offset + 1];
    this.z = array[offset + 2];
    this.w = array[offset + 3];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.x;
    array[offset + 1] = this.y;
    array[offset + 2] = this.z;
    array[offset + 3] = this.w;
    return array;
  }
  fromBufferAttribute(attribute, index2) {
    this.x = attribute.getX(index2);
    this.y = attribute.getY(index2);
    this.z = attribute.getZ(index2);
    this.w = attribute.getW(index2);
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    this.z = Math.random();
    this.w = Math.random();
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
    yield this.z;
    yield this.w;
  }
};
class RenderTarget extends EventDispatcher$1 {
  constructor(width = 1, height = 1, options = {}) {
    super();
    this.isRenderTarget = true;
    this.width = width;
    this.height = height;
    this.depth = 1;
    this.scissor = new Vector4$1(0, 0, width, height);
    this.scissorTest = false;
    this.viewport = new Vector4$1(0, 0, width, height);
    const image2 = { width, height, depth: 1 };
    options = Object.assign({
      generateMipmaps: false,
      internalFormat: null,
      minFilter: LinearFilter$1,
      depthBuffer: true,
      stencilBuffer: false,
      resolveDepthBuffer: true,
      resolveStencilBuffer: true,
      depthTexture: null,
      samples: 0,
      count: 1
    }, options);
    const texture = new Texture$1(image2, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
    texture.flipY = false;
    texture.generateMipmaps = options.generateMipmaps;
    texture.internalFormat = options.internalFormat;
    this.textures = [];
    const count = options.count;
    for (let i2 = 0; i2 < count; i2++) {
      this.textures[i2] = texture.clone();
      this.textures[i2].isRenderTargetTexture = true;
    }
    this.depthBuffer = options.depthBuffer;
    this.stencilBuffer = options.stencilBuffer;
    this.resolveDepthBuffer = options.resolveDepthBuffer;
    this.resolveStencilBuffer = options.resolveStencilBuffer;
    this.depthTexture = options.depthTexture;
    this.samples = options.samples;
  }
  get texture() {
    return this.textures[0];
  }
  set texture(value) {
    this.textures[0] = value;
  }
  setSize(width, height, depth = 1) {
    if (this.width !== width || this.height !== height || this.depth !== depth) {
      this.width = width;
      this.height = height;
      this.depth = depth;
      for (let i2 = 0, il = this.textures.length; i2 < il; i2++) {
        this.textures[i2].image.width = width;
        this.textures[i2].image.height = height;
        this.textures[i2].image.depth = depth;
      }
      this.dispose();
    }
    this.viewport.set(0, 0, width, height);
    this.scissor.set(0, 0, width, height);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.width = source.width;
    this.height = source.height;
    this.depth = source.depth;
    this.scissor.copy(source.scissor);
    this.scissorTest = source.scissorTest;
    this.viewport.copy(source.viewport);
    this.textures.length = 0;
    for (let i2 = 0, il = source.textures.length; i2 < il; i2++) {
      this.textures[i2] = source.textures[i2].clone();
      this.textures[i2].isRenderTargetTexture = true;
    }
    const image2 = Object.assign({}, source.texture.image);
    this.texture.source = new Source(image2);
    this.depthBuffer = source.depthBuffer;
    this.stencilBuffer = source.stencilBuffer;
    this.resolveDepthBuffer = source.resolveDepthBuffer;
    this.resolveStencilBuffer = source.resolveStencilBuffer;
    if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
    this.samples = source.samples;
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
let WebGLRenderTarget$1 = class WebGLRenderTarget extends RenderTarget {
  constructor(width = 1, height = 1, options = {}) {
    super(width, height, options);
    this.isWebGLRenderTarget = true;
  }
};
class DataArrayTexture extends Texture$1 {
  constructor(data = null, width = 1, height = 1, depth = 1) {
    super(null);
    this.isDataArrayTexture = true;
    this.image = { data, width, height, depth };
    this.magFilter = NearestFilter$1;
    this.minFilter = NearestFilter$1;
    this.wrapR = ClampToEdgeWrapping$1;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
    this.layerUpdates = /* @__PURE__ */ new Set();
  }
  addLayerUpdate(layerIndex) {
    this.layerUpdates.add(layerIndex);
  }
  clearLayerUpdates() {
    this.layerUpdates.clear();
  }
}
class WebGLArrayRenderTarget extends WebGLRenderTarget$1 {
  constructor(width = 1, height = 1, depth = 1, options = {}) {
    super(width, height, options);
    this.isWebGLArrayRenderTarget = true;
    this.depth = depth;
    this.texture = new DataArrayTexture(null, width, height, depth);
    this.texture.isRenderTargetTexture = true;
  }
}
class Data3DTexture extends Texture$1 {
  constructor(data = null, width = 1, height = 1, depth = 1) {
    super(null);
    this.isData3DTexture = true;
    this.image = { data, width, height, depth };
    this.magFilter = NearestFilter$1;
    this.minFilter = NearestFilter$1;
    this.wrapR = ClampToEdgeWrapping$1;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
  }
}
class WebGL3DRenderTarget extends WebGLRenderTarget$1 {
  constructor(width = 1, height = 1, depth = 1, options = {}) {
    super(width, height, options);
    this.isWebGL3DRenderTarget = true;
    this.depth = depth;
    this.texture = new Data3DTexture(null, width, height, depth);
    this.texture.isRenderTargetTexture = true;
  }
}
let Quaternion$1 = class Quaternion {
  constructor(x = 0, y = 0, z2 = 0, w = 1) {
    this.isQuaternion = true;
    this._x = x;
    this._y = y;
    this._z = z2;
    this._w = w;
  }
  static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t3) {
    let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
    const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
    if (t3 === 0) {
      dst[dstOffset + 0] = x0;
      dst[dstOffset + 1] = y0;
      dst[dstOffset + 2] = z0;
      dst[dstOffset + 3] = w0;
      return;
    }
    if (t3 === 1) {
      dst[dstOffset + 0] = x1;
      dst[dstOffset + 1] = y1;
      dst[dstOffset + 2] = z1;
      dst[dstOffset + 3] = w1;
      return;
    }
    if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
      let s2 = 1 - t3;
      const cos2 = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos2 >= 0 ? 1 : -1, sqrSin = 1 - cos2 * cos2;
      if (sqrSin > Number.EPSILON) {
        const sin2 = Math.sqrt(sqrSin), len = Math.atan2(sin2, cos2 * dir);
        s2 = Math.sin(s2 * len) / sin2;
        t3 = Math.sin(t3 * len) / sin2;
      }
      const tDir = t3 * dir;
      x0 = x0 * s2 + x1 * tDir;
      y0 = y0 * s2 + y1 * tDir;
      z0 = z0 * s2 + z1 * tDir;
      w0 = w0 * s2 + w1 * tDir;
      if (s2 === 1 - t3) {
        const f2 = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
        x0 *= f2;
        y0 *= f2;
        z0 *= f2;
        w0 *= f2;
      }
    }
    dst[dstOffset] = x0;
    dst[dstOffset + 1] = y0;
    dst[dstOffset + 2] = z0;
    dst[dstOffset + 3] = w0;
  }
  static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
    const x0 = src0[srcOffset0];
    const y0 = src0[srcOffset0 + 1];
    const z0 = src0[srcOffset0 + 2];
    const w0 = src0[srcOffset0 + 3];
    const x1 = src1[srcOffset1];
    const y1 = src1[srcOffset1 + 1];
    const z1 = src1[srcOffset1 + 2];
    const w1 = src1[srcOffset1 + 3];
    dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
    dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
    dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
    dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
    return dst;
  }
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
    this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
    this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(value) {
    this._z = value;
    this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(value) {
    this._w = value;
    this._onChangeCallback();
  }
  set(x, y, z2, w) {
    this._x = x;
    this._y = y;
    this._z = z2;
    this._w = w;
    this._onChangeCallback();
    return this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(quaternion) {
    this._x = quaternion.x;
    this._y = quaternion.y;
    this._z = quaternion.z;
    this._w = quaternion.w;
    this._onChangeCallback();
    return this;
  }
  setFromEuler(euler, update = true) {
    const x = euler._x, y = euler._y, z2 = euler._z, order = euler._order;
    const cos2 = Math.cos;
    const sin2 = Math.sin;
    const c1 = cos2(x / 2);
    const c2 = cos2(y / 2);
    const c3 = cos2(z2 / 2);
    const s1 = sin2(x / 2);
    const s2 = sin2(y / 2);
    const s3 = sin2(z2 / 2);
    switch (order) {
      case "XYZ":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "YXZ":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      case "ZXY":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "ZYX":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      case "YZX":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "XZY":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
    }
    if (update === true) this._onChangeCallback();
    return this;
  }
  setFromAxisAngle(axis, angle2) {
    const halfAngle = angle2 / 2, s2 = Math.sin(halfAngle);
    this._x = axis.x * s2;
    this._y = axis.y * s2;
    this._z = axis.z * s2;
    this._w = Math.cos(halfAngle);
    this._onChangeCallback();
    return this;
  }
  setFromRotationMatrix(m) {
    const te2 = m.elements, m11 = te2[0], m12 = te2[4], m13 = te2[8], m21 = te2[1], m22 = te2[5], m23 = te2[9], m31 = te2[2], m32 = te2[6], m33 = te2[10], trace = m11 + m22 + m33;
    if (trace > 0) {
      const s2 = 0.5 / Math.sqrt(trace + 1);
      this._w = 0.25 / s2;
      this._x = (m32 - m23) * s2;
      this._y = (m13 - m31) * s2;
      this._z = (m21 - m12) * s2;
    } else if (m11 > m22 && m11 > m33) {
      const s2 = 2 * Math.sqrt(1 + m11 - m22 - m33);
      this._w = (m32 - m23) / s2;
      this._x = 0.25 * s2;
      this._y = (m12 + m21) / s2;
      this._z = (m13 + m31) / s2;
    } else if (m22 > m33) {
      const s2 = 2 * Math.sqrt(1 + m22 - m11 - m33);
      this._w = (m13 - m31) / s2;
      this._x = (m12 + m21) / s2;
      this._y = 0.25 * s2;
      this._z = (m23 + m32) / s2;
    } else {
      const s2 = 2 * Math.sqrt(1 + m33 - m11 - m22);
      this._w = (m21 - m12) / s2;
      this._x = (m13 + m31) / s2;
      this._y = (m23 + m32) / s2;
      this._z = 0.25 * s2;
    }
    this._onChangeCallback();
    return this;
  }
  setFromUnitVectors(vFrom, vTo) {
    let r2 = vFrom.dot(vTo) + 1;
    if (r2 < Number.EPSILON) {
      r2 = 0;
      if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
        this._x = -vFrom.y;
        this._y = vFrom.x;
        this._z = 0;
        this._w = r2;
      } else {
        this._x = 0;
        this._y = -vFrom.z;
        this._z = vFrom.y;
        this._w = r2;
      }
    } else {
      this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
      this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
      this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
      this._w = r2;
    }
    return this.normalize();
  }
  angleTo(q) {
    return 2 * Math.acos(Math.abs(clamp$1(this.dot(q), -1, 1)));
  }
  rotateTowards(q, step) {
    const angle2 = this.angleTo(q);
    if (angle2 === 0) return this;
    const t3 = Math.min(1, step / angle2);
    this.slerp(q, t3);
    return this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    this._x *= -1;
    this._y *= -1;
    this._z *= -1;
    this._onChangeCallback();
    return this;
  }
  dot(v) {
    return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let l2 = this.length();
    if (l2 === 0) {
      this._x = 0;
      this._y = 0;
      this._z = 0;
      this._w = 1;
    } else {
      l2 = 1 / l2;
      this._x = this._x * l2;
      this._y = this._y * l2;
      this._z = this._z * l2;
      this._w = this._w * l2;
    }
    this._onChangeCallback();
    return this;
  }
  multiply(q) {
    return this.multiplyQuaternions(this, q);
  }
  premultiply(q) {
    return this.multiplyQuaternions(q, this);
  }
  multiplyQuaternions(a3, b) {
    const qax = a3._x, qay = a3._y, qaz = a3._z, qaw = a3._w;
    const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
    this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
    this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
    this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
    this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
    this._onChangeCallback();
    return this;
  }
  slerp(qb, t3) {
    if (t3 === 0) return this;
    if (t3 === 1) return this.copy(qb);
    const x = this._x, y = this._y, z2 = this._z, w = this._w;
    let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z2 * qb._z;
    if (cosHalfTheta < 0) {
      this._w = -qb._w;
      this._x = -qb._x;
      this._y = -qb._y;
      this._z = -qb._z;
      cosHalfTheta = -cosHalfTheta;
    } else {
      this.copy(qb);
    }
    if (cosHalfTheta >= 1) {
      this._w = w;
      this._x = x;
      this._y = y;
      this._z = z2;
      return this;
    }
    const sqrSinHalfTheta = 1 - cosHalfTheta * cosHalfTheta;
    if (sqrSinHalfTheta <= Number.EPSILON) {
      const s2 = 1 - t3;
      this._w = s2 * w + t3 * this._w;
      this._x = s2 * x + t3 * this._x;
      this._y = s2 * y + t3 * this._y;
      this._z = s2 * z2 + t3 * this._z;
      this.normalize();
      return this;
    }
    const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
    const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
    const ratioA = Math.sin((1 - t3) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t3 * halfTheta) / sinHalfTheta;
    this._w = w * ratioA + this._w * ratioB;
    this._x = x * ratioA + this._x * ratioB;
    this._y = y * ratioA + this._y * ratioB;
    this._z = z2 * ratioA + this._z * ratioB;
    this._onChangeCallback();
    return this;
  }
  slerpQuaternions(qa, qb, t3) {
    return this.copy(qa).slerp(qb, t3);
  }
  random() {
    const theta1 = 2 * Math.PI * Math.random();
    const theta2 = 2 * Math.PI * Math.random();
    const x0 = Math.random();
    const r1 = Math.sqrt(1 - x0);
    const r2 = Math.sqrt(x0);
    return this.set(
      r1 * Math.sin(theta1),
      r1 * Math.cos(theta1),
      r2 * Math.sin(theta2),
      r2 * Math.cos(theta2)
    );
  }
  equals(quaternion) {
    return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
  }
  fromArray(array, offset = 0) {
    this._x = array[offset];
    this._y = array[offset + 1];
    this._z = array[offset + 2];
    this._w = array[offset + 3];
    this._onChangeCallback();
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this._x;
    array[offset + 1] = this._y;
    array[offset + 2] = this._z;
    array[offset + 3] = this._w;
    return array;
  }
  fromBufferAttribute(attribute, index2) {
    this._x = attribute.getX(index2);
    this._y = attribute.getY(index2);
    this._z = attribute.getZ(index2);
    this._w = attribute.getW(index2);
    this._onChangeCallback();
    return this;
  }
  toJSON() {
    return this.toArray();
  }
  _onChange(callback) {
    this._onChangeCallback = callback;
    return this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x;
    yield this._y;
    yield this._z;
    yield this._w;
  }
};
let Vector3$1 = class Vector3 {
  constructor(x = 0, y = 0, z2 = 0) {
    Vector3.prototype.isVector3 = true;
    this.x = x;
    this.y = y;
    this.z = z2;
  }
  set(x, y, z2) {
    if (z2 === void 0) z2 = this.z;
    this.x = x;
    this.y = y;
    this.z = z2;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    this.z = scalar;
    return this;
  }
  setX(x) {
    this.x = x;
    return this;
  }
  setY(y) {
    this.y = y;
    return this;
  }
  setZ(z2) {
    this.z = z2;
    return this;
  }
  setComponent(index2, value) {
    switch (index2) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      case 2:
        this.z = value;
        break;
      default:
        throw new Error("index is out of range: " + index2);
    }
    return this;
  }
  getComponent(index2) {
    switch (index2) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + index2);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(v) {
    this.x = v.x;
    this.y = v.y;
    this.z = v.z;
    return this;
  }
  add(v) {
    this.x += v.x;
    this.y += v.y;
    this.z += v.z;
    return this;
  }
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    this.z += s2;
    return this;
  }
  addVectors(a3, b) {
    this.x = a3.x + b.x;
    this.y = a3.y + b.y;
    this.z = a3.z + b.z;
    return this;
  }
  addScaledVector(v, s2) {
    this.x += v.x * s2;
    this.y += v.y * s2;
    this.z += v.z * s2;
    return this;
  }
  sub(v) {
    this.x -= v.x;
    this.y -= v.y;
    this.z -= v.z;
    return this;
  }
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    this.z -= s2;
    return this;
  }
  subVectors(a3, b) {
    this.x = a3.x - b.x;
    this.y = a3.y - b.y;
    this.z = a3.z - b.z;
    return this;
  }
  multiply(v) {
    this.x *= v.x;
    this.y *= v.y;
    this.z *= v.z;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;
    return this;
  }
  multiplyVectors(a3, b) {
    this.x = a3.x * b.x;
    this.y = a3.y * b.y;
    this.z = a3.z * b.z;
    return this;
  }
  applyEuler(euler) {
    return this.applyQuaternion(_quaternion$4$1.setFromEuler(euler));
  }
  applyAxisAngle(axis, angle2) {
    return this.applyQuaternion(_quaternion$4$1.setFromAxisAngle(axis, angle2));
  }
  applyMatrix3(m) {
    const x = this.x, y = this.y, z2 = this.z;
    const e2 = m.elements;
    this.x = e2[0] * x + e2[3] * y + e2[6] * z2;
    this.y = e2[1] * x + e2[4] * y + e2[7] * z2;
    this.z = e2[2] * x + e2[5] * y + e2[8] * z2;
    return this;
  }
  applyNormalMatrix(m) {
    return this.applyMatrix3(m).normalize();
  }
  applyMatrix4(m) {
    const x = this.x, y = this.y, z2 = this.z;
    const e2 = m.elements;
    const w = 1 / (e2[3] * x + e2[7] * y + e2[11] * z2 + e2[15]);
    this.x = (e2[0] * x + e2[4] * y + e2[8] * z2 + e2[12]) * w;
    this.y = (e2[1] * x + e2[5] * y + e2[9] * z2 + e2[13]) * w;
    this.z = (e2[2] * x + e2[6] * y + e2[10] * z2 + e2[14]) * w;
    return this;
  }
  applyQuaternion(q) {
    const vx = this.x, vy = this.y, vz = this.z;
    const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
    const tx = 2 * (qy * vz - qz * vy);
    const ty = 2 * (qz * vx - qx * vz);
    const tz = 2 * (qx * vy - qy * vx);
    this.x = vx + qw * tx + qy * tz - qz * ty;
    this.y = vy + qw * ty + qz * tx - qx * tz;
    this.z = vz + qw * tz + qx * ty - qy * tx;
    return this;
  }
  project(camera) {
    return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
  }
  unproject(camera) {
    return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
  }
  transformDirection(m) {
    const x = this.x, y = this.y, z2 = this.z;
    const e2 = m.elements;
    this.x = e2[0] * x + e2[4] * y + e2[8] * z2;
    this.y = e2[1] * x + e2[5] * y + e2[9] * z2;
    this.z = e2[2] * x + e2[6] * y + e2[10] * z2;
    return this.normalize();
  }
  divide(v) {
    this.x /= v.x;
    this.y /= v.y;
    this.z /= v.z;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  min(v) {
    this.x = Math.min(this.x, v.x);
    this.y = Math.min(this.y, v.y);
    this.z = Math.min(this.z, v.z);
    return this;
  }
  max(v) {
    this.x = Math.max(this.x, v.x);
    this.y = Math.max(this.y, v.y);
    this.z = Math.max(this.z, v.z);
    return this;
  }
  clamp(min, max2) {
    this.x = clamp$1(this.x, min.x, max2.x);
    this.y = clamp$1(this.y, min.y, max2.y);
    this.z = clamp$1(this.z, min.z, max2.z);
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = clamp$1(this.x, minVal, maxVal);
    this.y = clamp$1(this.y, minVal, maxVal);
    this.z = clamp$1(this.z, minVal, maxVal);
    return this;
  }
  clampLength(min, max2) {
    const length2 = this.length();
    return this.divideScalar(length2 || 1).multiplyScalar(clamp$1(length2, min, max2));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    return this;
  }
  roundToZero() {
    this.x = Math.trunc(this.x);
    this.y = Math.trunc(this.y);
    this.z = Math.trunc(this.z);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    return this;
  }
  dot(v) {
    return this.x * v.x + this.y * v.y + this.z * v.z;
  }
  // TODO lengthSquared?
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(length2) {
    return this.normalize().multiplyScalar(length2);
  }
  lerp(v, alpha) {
    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    this.z += (v.z - this.z) * alpha;
    return this;
  }
  lerpVectors(v1, v2, alpha) {
    this.x = v1.x + (v2.x - v1.x) * alpha;
    this.y = v1.y + (v2.y - v1.y) * alpha;
    this.z = v1.z + (v2.z - v1.z) * alpha;
    return this;
  }
  cross(v) {
    return this.crossVectors(this, v);
  }
  crossVectors(a3, b) {
    const ax = a3.x, ay = a3.y, az = a3.z;
    const bx = b.x, by = b.y, bz = b.z;
    this.x = ay * bz - az * by;
    this.y = az * bx - ax * bz;
    this.z = ax * by - ay * bx;
    return this;
  }
  projectOnVector(v) {
    const denominator = v.lengthSq();
    if (denominator === 0) return this.set(0, 0, 0);
    const scalar = v.dot(this) / denominator;
    return this.copy(v).multiplyScalar(scalar);
  }
  projectOnPlane(planeNormal) {
    _vector$c$1.copy(this).projectOnVector(planeNormal);
    return this.sub(_vector$c$1);
  }
  reflect(normal) {
    return this.sub(_vector$c$1.copy(normal).multiplyScalar(2 * this.dot(normal)));
  }
  angleTo(v) {
    const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
    if (denominator === 0) return Math.PI / 2;
    const theta = this.dot(v) / denominator;
    return Math.acos(clamp$1(theta, -1, 1));
  }
  distanceTo(v) {
    return Math.sqrt(this.distanceToSquared(v));
  }
  distanceToSquared(v) {
    const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
    return dx * dx + dy * dy + dz * dz;
  }
  manhattanDistanceTo(v) {
    return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
  }
  setFromSpherical(s2) {
    return this.setFromSphericalCoords(s2.radius, s2.phi, s2.theta);
  }
  setFromSphericalCoords(radius, phi, theta) {
    const sinPhiRadius = Math.sin(phi) * radius;
    this.x = sinPhiRadius * Math.sin(theta);
    this.y = Math.cos(phi) * radius;
    this.z = sinPhiRadius * Math.cos(theta);
    return this;
  }
  setFromCylindrical(c2) {
    return this.setFromCylindricalCoords(c2.radius, c2.theta, c2.y);
  }
  setFromCylindricalCoords(radius, theta, y) {
    this.x = radius * Math.sin(theta);
    this.y = y;
    this.z = radius * Math.cos(theta);
    return this;
  }
  setFromMatrixPosition(m) {
    const e2 = m.elements;
    this.x = e2[12];
    this.y = e2[13];
    this.z = e2[14];
    return this;
  }
  setFromMatrixScale(m) {
    const sx = this.setFromMatrixColumn(m, 0).length();
    const sy = this.setFromMatrixColumn(m, 1).length();
    const sz = this.setFromMatrixColumn(m, 2).length();
    this.x = sx;
    this.y = sy;
    this.z = sz;
    return this;
  }
  setFromMatrixColumn(m, index2) {
    return this.fromArray(m.elements, index2 * 4);
  }
  setFromMatrix3Column(m, index2) {
    return this.fromArray(m.elements, index2 * 3);
  }
  setFromEuler(e2) {
    this.x = e2._x;
    this.y = e2._y;
    this.z = e2._z;
    return this;
  }
  setFromColor(c2) {
    this.x = c2.r;
    this.y = c2.g;
    this.z = c2.b;
    return this;
  }
  equals(v) {
    return v.x === this.x && v.y === this.y && v.z === this.z;
  }
  fromArray(array, offset = 0) {
    this.x = array[offset];
    this.y = array[offset + 1];
    this.z = array[offset + 2];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.x;
    array[offset + 1] = this.y;
    array[offset + 2] = this.z;
    return array;
  }
  fromBufferAttribute(attribute, index2) {
    this.x = attribute.getX(index2);
    this.y = attribute.getY(index2);
    this.z = attribute.getZ(index2);
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    this.z = Math.random();
    return this;
  }
  randomDirection() {
    const theta = Math.random() * Math.PI * 2;
    const u3 = Math.random() * 2 - 1;
    const c2 = Math.sqrt(1 - u3 * u3);
    this.x = c2 * Math.cos(theta);
    this.y = u3;
    this.z = c2 * Math.sin(theta);
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
    yield this.z;
  }
};
const _vector$c$1 = /* @__PURE__ */ new Vector3$1();
const _quaternion$4$1 = /* @__PURE__ */ new Quaternion$1();
let Box3$1 = class Box3 {
  constructor(min = new Vector3$1(Infinity, Infinity, Infinity), max2 = new Vector3$1(-Infinity, -Infinity, -Infinity)) {
    this.isBox3 = true;
    this.min = min;
    this.max = max2;
  }
  set(min, max2) {
    this.min.copy(min);
    this.max.copy(max2);
    return this;
  }
  setFromArray(array) {
    this.makeEmpty();
    for (let i2 = 0, il = array.length; i2 < il; i2 += 3) {
      this.expandByPoint(_vector$b$1.fromArray(array, i2));
    }
    return this;
  }
  setFromBufferAttribute(attribute) {
    this.makeEmpty();
    for (let i2 = 0, il = attribute.count; i2 < il; i2++) {
      this.expandByPoint(_vector$b$1.fromBufferAttribute(attribute, i2));
    }
    return this;
  }
  setFromPoints(points) {
    this.makeEmpty();
    for (let i2 = 0, il = points.length; i2 < il; i2++) {
      this.expandByPoint(points[i2]);
    }
    return this;
  }
  setFromCenterAndSize(center, size) {
    const halfSize = _vector$b$1.copy(size).multiplyScalar(0.5);
    this.min.copy(center).sub(halfSize);
    this.max.copy(center).add(halfSize);
    return this;
  }
  setFromObject(object, precise = false) {
    this.makeEmpty();
    return this.expandByObject(object, precise);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(box) {
    this.min.copy(box.min);
    this.max.copy(box.max);
    return this;
  }
  makeEmpty() {
    this.min.x = this.min.y = this.min.z = Infinity;
    this.max.x = this.max.y = this.max.z = -Infinity;
    return this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(target) {
    return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(target) {
    return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
  }
  expandByPoint(point2) {
    this.min.min(point2);
    this.max.max(point2);
    return this;
  }
  expandByVector(vector) {
    this.min.sub(vector);
    this.max.add(vector);
    return this;
  }
  expandByScalar(scalar) {
    this.min.addScalar(-scalar);
    this.max.addScalar(scalar);
    return this;
  }
  expandByObject(object, precise = false) {
    object.updateWorldMatrix(false, false);
    const geometry = object.geometry;
    if (geometry !== void 0) {
      const positionAttribute = geometry.getAttribute("position");
      if (precise === true && positionAttribute !== void 0 && object.isInstancedMesh !== true) {
        for (let i2 = 0, l2 = positionAttribute.count; i2 < l2; i2++) {
          if (object.isMesh === true) {
            object.getVertexPosition(i2, _vector$b$1);
          } else {
            _vector$b$1.fromBufferAttribute(positionAttribute, i2);
          }
          _vector$b$1.applyMatrix4(object.matrixWorld);
          this.expandByPoint(_vector$b$1);
        }
      } else {
        if (object.boundingBox !== void 0) {
          if (object.boundingBox === null) {
            object.computeBoundingBox();
          }
          _box$4.copy(object.boundingBox);
        } else {
          if (geometry.boundingBox === null) {
            geometry.computeBoundingBox();
          }
          _box$4.copy(geometry.boundingBox);
        }
        _box$4.applyMatrix4(object.matrixWorld);
        this.union(_box$4);
      }
    }
    const children = object.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      this.expandByObject(children[i2], precise);
    }
    return this;
  }
  containsPoint(point2) {
    return point2.x >= this.min.x && point2.x <= this.max.x && point2.y >= this.min.y && point2.y <= this.max.y && point2.z >= this.min.z && point2.z <= this.max.z;
  }
  containsBox(box) {
    return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
  }
  getParameter(point2, target) {
    return target.set(
      (point2.x - this.min.x) / (this.max.x - this.min.x),
      (point2.y - this.min.y) / (this.max.y - this.min.y),
      (point2.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  intersectsBox(box) {
    return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
  }
  intersectsSphere(sphere) {
    this.clampPoint(sphere.center, _vector$b$1);
    return _vector$b$1.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
  }
  intersectsPlane(plane) {
    let min, max2;
    if (plane.normal.x > 0) {
      min = plane.normal.x * this.min.x;
      max2 = plane.normal.x * this.max.x;
    } else {
      min = plane.normal.x * this.max.x;
      max2 = plane.normal.x * this.min.x;
    }
    if (plane.normal.y > 0) {
      min += plane.normal.y * this.min.y;
      max2 += plane.normal.y * this.max.y;
    } else {
      min += plane.normal.y * this.max.y;
      max2 += plane.normal.y * this.min.y;
    }
    if (plane.normal.z > 0) {
      min += plane.normal.z * this.min.z;
      max2 += plane.normal.z * this.max.z;
    } else {
      min += plane.normal.z * this.max.z;
      max2 += plane.normal.z * this.min.z;
    }
    return min <= -plane.constant && max2 >= -plane.constant;
  }
  intersectsTriangle(triangle3) {
    if (this.isEmpty()) {
      return false;
    }
    this.getCenter(_center$1);
    _extents$1.subVectors(this.max, _center$1);
    _v0$2$1.subVectors(triangle3.a, _center$1);
    _v1$7$1.subVectors(triangle3.b, _center$1);
    _v2$4.subVectors(triangle3.c, _center$1);
    _f0$1.subVectors(_v1$7$1, _v0$2$1);
    _f1$1.subVectors(_v2$4, _v1$7$1);
    _f2$1.subVectors(_v0$2$1, _v2$4);
    let axes = [
      0,
      -_f0$1.z,
      _f0$1.y,
      0,
      -_f1$1.z,
      _f1$1.y,
      0,
      -_f2$1.z,
      _f2$1.y,
      _f0$1.z,
      0,
      -_f0$1.x,
      _f1$1.z,
      0,
      -_f1$1.x,
      _f2$1.z,
      0,
      -_f2$1.x,
      -_f0$1.y,
      _f0$1.x,
      0,
      -_f1$1.y,
      _f1$1.x,
      0,
      -_f2$1.y,
      _f2$1.x,
      0
    ];
    if (!satForAxes$1(axes, _v0$2$1, _v1$7$1, _v2$4, _extents$1)) {
      return false;
    }
    axes = [1, 0, 0, 0, 1, 0, 0, 0, 1];
    if (!satForAxes$1(axes, _v0$2$1, _v1$7$1, _v2$4, _extents$1)) {
      return false;
    }
    _triangleNormal$1.crossVectors(_f0$1, _f1$1);
    axes = [_triangleNormal$1.x, _triangleNormal$1.y, _triangleNormal$1.z];
    return satForAxes$1(axes, _v0$2$1, _v1$7$1, _v2$4, _extents$1);
  }
  clampPoint(point2, target) {
    return target.copy(point2).clamp(this.min, this.max);
  }
  distanceToPoint(point2) {
    return this.clampPoint(point2, _vector$b$1).distanceTo(point2);
  }
  getBoundingSphere(target) {
    if (this.isEmpty()) {
      target.makeEmpty();
    } else {
      this.getCenter(target.center);
      target.radius = this.getSize(_vector$b$1).length() * 0.5;
    }
    return target;
  }
  intersect(box) {
    this.min.max(box.min);
    this.max.min(box.max);
    if (this.isEmpty()) this.makeEmpty();
    return this;
  }
  union(box) {
    this.min.min(box.min);
    this.max.max(box.max);
    return this;
  }
  applyMatrix4(matrix2) {
    if (this.isEmpty()) return this;
    _points$1[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix2);
    _points$1[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix2);
    _points$1[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix2);
    _points$1[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix2);
    _points$1[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix2);
    _points$1[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix2);
    _points$1[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix2);
    _points$1[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix2);
    this.setFromPoints(_points$1);
    return this;
  }
  translate(offset) {
    this.min.add(offset);
    this.max.add(offset);
    return this;
  }
  equals(box) {
    return box.min.equals(this.min) && box.max.equals(this.max);
  }
};
const _points$1 = [
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1()
];
const _vector$b$1 = /* @__PURE__ */ new Vector3$1();
const _box$4 = /* @__PURE__ */ new Box3$1();
const _v0$2$1 = /* @__PURE__ */ new Vector3$1();
const _v1$7$1 = /* @__PURE__ */ new Vector3$1();
const _v2$4 = /* @__PURE__ */ new Vector3$1();
const _f0$1 = /* @__PURE__ */ new Vector3$1();
const _f1$1 = /* @__PURE__ */ new Vector3$1();
const _f2$1 = /* @__PURE__ */ new Vector3$1();
const _center$1 = /* @__PURE__ */ new Vector3$1();
const _extents$1 = /* @__PURE__ */ new Vector3$1();
const _triangleNormal$1 = /* @__PURE__ */ new Vector3$1();
const _testAxis$1 = /* @__PURE__ */ new Vector3$1();
function satForAxes$1(axes, v0, v1, v2, extents) {
  for (let i2 = 0, j = axes.length - 3; i2 <= j; i2 += 3) {
    _testAxis$1.fromArray(axes, i2);
    const r2 = extents.x * Math.abs(_testAxis$1.x) + extents.y * Math.abs(_testAxis$1.y) + extents.z * Math.abs(_testAxis$1.z);
    const p0 = v0.dot(_testAxis$1);
    const p1 = v1.dot(_testAxis$1);
    const p2 = v2.dot(_testAxis$1);
    if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r2) {
      return false;
    }
  }
  return true;
}
const _box$3$1 = /* @__PURE__ */ new Box3$1();
const _v1$6$1 = /* @__PURE__ */ new Vector3$1();
const _v2$3$1 = /* @__PURE__ */ new Vector3$1();
let Sphere$1 = class Sphere {
  constructor(center = new Vector3$1(), radius = -1) {
    this.isSphere = true;
    this.center = center;
    this.radius = radius;
  }
  set(center, radius) {
    this.center.copy(center);
    this.radius = radius;
    return this;
  }
  setFromPoints(points, optionalCenter) {
    const center = this.center;
    if (optionalCenter !== void 0) {
      center.copy(optionalCenter);
    } else {
      _box$3$1.setFromPoints(points).getCenter(center);
    }
    let maxRadiusSq = 0;
    for (let i2 = 0, il = points.length; i2 < il; i2++) {
      maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i2]));
    }
    this.radius = Math.sqrt(maxRadiusSq);
    return this;
  }
  copy(sphere) {
    this.center.copy(sphere.center);
    this.radius = sphere.radius;
    return this;
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    this.center.set(0, 0, 0);
    this.radius = -1;
    return this;
  }
  containsPoint(point2) {
    return point2.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(point2) {
    return point2.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(sphere) {
    const radiusSum = this.radius + sphere.radius;
    return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
  }
  intersectsBox(box) {
    return box.intersectsSphere(this);
  }
  intersectsPlane(plane) {
    return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(point2, target) {
    const deltaLengthSq = this.center.distanceToSquared(point2);
    target.copy(point2);
    if (deltaLengthSq > this.radius * this.radius) {
      target.sub(this.center).normalize();
      target.multiplyScalar(this.radius).add(this.center);
    }
    return target;
  }
  getBoundingBox(target) {
    if (this.isEmpty()) {
      target.makeEmpty();
      return target;
    }
    target.set(this.center, this.center);
    target.expandByScalar(this.radius);
    return target;
  }
  applyMatrix4(matrix2) {
    this.center.applyMatrix4(matrix2);
    this.radius = this.radius * matrix2.getMaxScaleOnAxis();
    return this;
  }
  translate(offset) {
    this.center.add(offset);
    return this;
  }
  expandByPoint(point2) {
    if (this.isEmpty()) {
      this.center.copy(point2);
      this.radius = 0;
      return this;
    }
    _v1$6$1.subVectors(point2, this.center);
    const lengthSq = _v1$6$1.lengthSq();
    if (lengthSq > this.radius * this.radius) {
      const length2 = Math.sqrt(lengthSq);
      const delta = (length2 - this.radius) * 0.5;
      this.center.addScaledVector(_v1$6$1, delta / length2);
      this.radius += delta;
    }
    return this;
  }
  union(sphere) {
    if (sphere.isEmpty()) {
      return this;
    }
    if (this.isEmpty()) {
      this.copy(sphere);
      return this;
    }
    if (this.center.equals(sphere.center) === true) {
      this.radius = Math.max(this.radius, sphere.radius);
    } else {
      _v2$3$1.subVectors(sphere.center, this.center).setLength(sphere.radius);
      this.expandByPoint(_v1$6$1.copy(sphere.center).add(_v2$3$1));
      this.expandByPoint(_v1$6$1.copy(sphere.center).sub(_v2$3$1));
    }
    return this;
  }
  equals(sphere) {
    return sphere.center.equals(this.center) && sphere.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
const _vector$a$1 = /* @__PURE__ */ new Vector3$1();
const _segCenter$1 = /* @__PURE__ */ new Vector3$1();
const _segDir$1 = /* @__PURE__ */ new Vector3$1();
const _diff$1 = /* @__PURE__ */ new Vector3$1();
const _edge1$1 = /* @__PURE__ */ new Vector3$1();
const _edge2$1 = /* @__PURE__ */ new Vector3$1();
const _normal$1$1 = /* @__PURE__ */ new Vector3$1();
let Ray$1 = class Ray {
  constructor(origin = new Vector3$1(), direction2 = new Vector3$1(0, 0, -1)) {
    this.origin = origin;
    this.direction = direction2;
  }
  set(origin, direction2) {
    this.origin.copy(origin);
    this.direction.copy(direction2);
    return this;
  }
  copy(ray2) {
    this.origin.copy(ray2.origin);
    this.direction.copy(ray2.direction);
    return this;
  }
  at(t3, target) {
    return target.copy(this.origin).addScaledVector(this.direction, t3);
  }
  lookAt(v) {
    this.direction.copy(v).sub(this.origin).normalize();
    return this;
  }
  recast(t3) {
    this.origin.copy(this.at(t3, _vector$a$1));
    return this;
  }
  closestPointToPoint(point2, target) {
    target.subVectors(point2, this.origin);
    const directionDistance = target.dot(this.direction);
    if (directionDistance < 0) {
      return target.copy(this.origin);
    }
    return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
  }
  distanceToPoint(point2) {
    return Math.sqrt(this.distanceSqToPoint(point2));
  }
  distanceSqToPoint(point2) {
    const directionDistance = _vector$a$1.subVectors(point2, this.origin).dot(this.direction);
    if (directionDistance < 0) {
      return this.origin.distanceToSquared(point2);
    }
    _vector$a$1.copy(this.origin).addScaledVector(this.direction, directionDistance);
    return _vector$a$1.distanceToSquared(point2);
  }
  distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
    _segCenter$1.copy(v0).add(v1).multiplyScalar(0.5);
    _segDir$1.copy(v1).sub(v0).normalize();
    _diff$1.copy(this.origin).sub(_segCenter$1);
    const segExtent = v0.distanceTo(v1) * 0.5;
    const a01 = -this.direction.dot(_segDir$1);
    const b0 = _diff$1.dot(this.direction);
    const b1 = -_diff$1.dot(_segDir$1);
    const c2 = _diff$1.lengthSq();
    const det = Math.abs(1 - a01 * a01);
    let s0, s1, sqrDist, extDet;
    if (det > 0) {
      s0 = a01 * b1 - b0;
      s1 = a01 * b0 - b1;
      extDet = segExtent * det;
      if (s0 >= 0) {
        if (s1 >= -extDet) {
          if (s1 <= extDet) {
            const invDet = 1 / det;
            s0 *= invDet;
            s1 *= invDet;
            sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c2;
          } else {
            s1 = segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
          }
        } else {
          s1 = -segExtent;
          s0 = Math.max(0, -(a01 * s1 + b0));
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
        }
      } else {
        if (s1 <= -extDet) {
          s0 = Math.max(0, -(-a01 * segExtent + b0));
          s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
        } else if (s1 <= extDet) {
          s0 = 0;
          s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = s1 * (s1 + 2 * b1) + c2;
        } else {
          s0 = Math.max(0, -(a01 * segExtent + b0));
          s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
        }
      }
    } else {
      s1 = a01 > 0 ? -segExtent : segExtent;
      s0 = Math.max(0, -(a01 * s1 + b0));
      sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
    }
    if (optionalPointOnRay) {
      optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
    }
    if (optionalPointOnSegment) {
      optionalPointOnSegment.copy(_segCenter$1).addScaledVector(_segDir$1, s1);
    }
    return sqrDist;
  }
  intersectSphere(sphere, target) {
    _vector$a$1.subVectors(sphere.center, this.origin);
    const tca = _vector$a$1.dot(this.direction);
    const d2 = _vector$a$1.dot(_vector$a$1) - tca * tca;
    const radius2 = sphere.radius * sphere.radius;
    if (d2 > radius2) return null;
    const thc = Math.sqrt(radius2 - d2);
    const t0 = tca - thc;
    const t1 = tca + thc;
    if (t1 < 0) return null;
    if (t0 < 0) return this.at(t1, target);
    return this.at(t0, target);
  }
  intersectsSphere(sphere) {
    return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
  }
  distanceToPlane(plane) {
    const denominator = plane.normal.dot(this.direction);
    if (denominator === 0) {
      if (plane.distanceToPoint(this.origin) === 0) {
        return 0;
      }
      return null;
    }
    const t3 = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
    return t3 >= 0 ? t3 : null;
  }
  intersectPlane(plane, target) {
    const t3 = this.distanceToPlane(plane);
    if (t3 === null) {
      return null;
    }
    return this.at(t3, target);
  }
  intersectsPlane(plane) {
    const distToPoint = plane.distanceToPoint(this.origin);
    if (distToPoint === 0) {
      return true;
    }
    const denominator = plane.normal.dot(this.direction);
    if (denominator * distToPoint < 0) {
      return true;
    }
    return false;
  }
  intersectBox(box, target) {
    let tmin, tmax, tymin, tymax, tzmin, tzmax;
    const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
    const origin = this.origin;
    if (invdirx >= 0) {
      tmin = (box.min.x - origin.x) * invdirx;
      tmax = (box.max.x - origin.x) * invdirx;
    } else {
      tmin = (box.max.x - origin.x) * invdirx;
      tmax = (box.min.x - origin.x) * invdirx;
    }
    if (invdiry >= 0) {
      tymin = (box.min.y - origin.y) * invdiry;
      tymax = (box.max.y - origin.y) * invdiry;
    } else {
      tymin = (box.max.y - origin.y) * invdiry;
      tymax = (box.min.y - origin.y) * invdiry;
    }
    if (tmin > tymax || tymin > tmax) return null;
    if (tymin > tmin || isNaN(tmin)) tmin = tymin;
    if (tymax < tmax || isNaN(tmax)) tmax = tymax;
    if (invdirz >= 0) {
      tzmin = (box.min.z - origin.z) * invdirz;
      tzmax = (box.max.z - origin.z) * invdirz;
    } else {
      tzmin = (box.max.z - origin.z) * invdirz;
      tzmax = (box.min.z - origin.z) * invdirz;
    }
    if (tmin > tzmax || tzmin > tmax) return null;
    if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
    if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
    if (tmax < 0) return null;
    return this.at(tmin >= 0 ? tmin : tmax, target);
  }
  intersectsBox(box) {
    return this.intersectBox(box, _vector$a$1) !== null;
  }
  intersectTriangle(a3, b, c2, backfaceCulling, target) {
    _edge1$1.subVectors(b, a3);
    _edge2$1.subVectors(c2, a3);
    _normal$1$1.crossVectors(_edge1$1, _edge2$1);
    let DdN = this.direction.dot(_normal$1$1);
    let sign2;
    if (DdN > 0) {
      if (backfaceCulling) return null;
      sign2 = 1;
    } else if (DdN < 0) {
      sign2 = -1;
      DdN = -DdN;
    } else {
      return null;
    }
    _diff$1.subVectors(this.origin, a3);
    const DdQxE2 = sign2 * this.direction.dot(_edge2$1.crossVectors(_diff$1, _edge2$1));
    if (DdQxE2 < 0) {
      return null;
    }
    const DdE1xQ = sign2 * this.direction.dot(_edge1$1.cross(_diff$1));
    if (DdE1xQ < 0) {
      return null;
    }
    if (DdQxE2 + DdE1xQ > DdN) {
      return null;
    }
    const QdN = -sign2 * _diff$1.dot(_normal$1$1);
    if (QdN < 0) {
      return null;
    }
    return this.at(QdN / DdN, target);
  }
  applyMatrix4(matrix4) {
    this.origin.applyMatrix4(matrix4);
    this.direction.transformDirection(matrix4);
    return this;
  }
  equals(ray2) {
    return ray2.origin.equals(this.origin) && ray2.direction.equals(this.direction);
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
let Matrix4$1 = class Matrix4 {
  constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
    Matrix4.prototype.isMatrix4 = true;
    this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ];
    if (n11 !== void 0) {
      this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
  }
  set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
    const te2 = this.elements;
    te2[0] = n11;
    te2[4] = n12;
    te2[8] = n13;
    te2[12] = n14;
    te2[1] = n21;
    te2[5] = n22;
    te2[9] = n23;
    te2[13] = n24;
    te2[2] = n31;
    te2[6] = n32;
    te2[10] = n33;
    te2[14] = n34;
    te2[3] = n41;
    te2[7] = n42;
    te2[11] = n43;
    te2[15] = n44;
    return this;
  }
  identity() {
    this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  clone() {
    return new Matrix4().fromArray(this.elements);
  }
  copy(m) {
    const te2 = this.elements;
    const me = m.elements;
    te2[0] = me[0];
    te2[1] = me[1];
    te2[2] = me[2];
    te2[3] = me[3];
    te2[4] = me[4];
    te2[5] = me[5];
    te2[6] = me[6];
    te2[7] = me[7];
    te2[8] = me[8];
    te2[9] = me[9];
    te2[10] = me[10];
    te2[11] = me[11];
    te2[12] = me[12];
    te2[13] = me[13];
    te2[14] = me[14];
    te2[15] = me[15];
    return this;
  }
  copyPosition(m) {
    const te2 = this.elements, me = m.elements;
    te2[12] = me[12];
    te2[13] = me[13];
    te2[14] = me[14];
    return this;
  }
  setFromMatrix3(m) {
    const me = m.elements;
    this.set(
      me[0],
      me[3],
      me[6],
      0,
      me[1],
      me[4],
      me[7],
      0,
      me[2],
      me[5],
      me[8],
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  extractBasis(xAxis, yAxis, zAxis) {
    xAxis.setFromMatrixColumn(this, 0);
    yAxis.setFromMatrixColumn(this, 1);
    zAxis.setFromMatrixColumn(this, 2);
    return this;
  }
  makeBasis(xAxis, yAxis, zAxis) {
    this.set(
      xAxis.x,
      yAxis.x,
      zAxis.x,
      0,
      xAxis.y,
      yAxis.y,
      zAxis.y,
      0,
      xAxis.z,
      yAxis.z,
      zAxis.z,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  extractRotation(m) {
    const te2 = this.elements;
    const me = m.elements;
    const scaleX = 1 / _v1$5$1.setFromMatrixColumn(m, 0).length();
    const scaleY = 1 / _v1$5$1.setFromMatrixColumn(m, 1).length();
    const scaleZ = 1 / _v1$5$1.setFromMatrixColumn(m, 2).length();
    te2[0] = me[0] * scaleX;
    te2[1] = me[1] * scaleX;
    te2[2] = me[2] * scaleX;
    te2[3] = 0;
    te2[4] = me[4] * scaleY;
    te2[5] = me[5] * scaleY;
    te2[6] = me[6] * scaleY;
    te2[7] = 0;
    te2[8] = me[8] * scaleZ;
    te2[9] = me[9] * scaleZ;
    te2[10] = me[10] * scaleZ;
    te2[11] = 0;
    te2[12] = 0;
    te2[13] = 0;
    te2[14] = 0;
    te2[15] = 1;
    return this;
  }
  makeRotationFromEuler(euler) {
    const te2 = this.elements;
    const x = euler.x, y = euler.y, z2 = euler.z;
    const a3 = Math.cos(x), b = Math.sin(x);
    const c2 = Math.cos(y), d2 = Math.sin(y);
    const e2 = Math.cos(z2), f2 = Math.sin(z2);
    if (euler.order === "XYZ") {
      const ae2 = a3 * e2, af = a3 * f2, be = b * e2, bf = b * f2;
      te2[0] = c2 * e2;
      te2[4] = -c2 * f2;
      te2[8] = d2;
      te2[1] = af + be * d2;
      te2[5] = ae2 - bf * d2;
      te2[9] = -b * c2;
      te2[2] = bf - ae2 * d2;
      te2[6] = be + af * d2;
      te2[10] = a3 * c2;
    } else if (euler.order === "YXZ") {
      const ce = c2 * e2, cf = c2 * f2, de = d2 * e2, df = d2 * f2;
      te2[0] = ce + df * b;
      te2[4] = de * b - cf;
      te2[8] = a3 * d2;
      te2[1] = a3 * f2;
      te2[5] = a3 * e2;
      te2[9] = -b;
      te2[2] = cf * b - de;
      te2[6] = df + ce * b;
      te2[10] = a3 * c2;
    } else if (euler.order === "ZXY") {
      const ce = c2 * e2, cf = c2 * f2, de = d2 * e2, df = d2 * f2;
      te2[0] = ce - df * b;
      te2[4] = -a3 * f2;
      te2[8] = de + cf * b;
      te2[1] = cf + de * b;
      te2[5] = a3 * e2;
      te2[9] = df - ce * b;
      te2[2] = -a3 * d2;
      te2[6] = b;
      te2[10] = a3 * c2;
    } else if (euler.order === "ZYX") {
      const ae2 = a3 * e2, af = a3 * f2, be = b * e2, bf = b * f2;
      te2[0] = c2 * e2;
      te2[4] = be * d2 - af;
      te2[8] = ae2 * d2 + bf;
      te2[1] = c2 * f2;
      te2[5] = bf * d2 + ae2;
      te2[9] = af * d2 - be;
      te2[2] = -d2;
      te2[6] = b * c2;
      te2[10] = a3 * c2;
    } else if (euler.order === "YZX") {
      const ac = a3 * c2, ad = a3 * d2, bc = b * c2, bd = b * d2;
      te2[0] = c2 * e2;
      te2[4] = bd - ac * f2;
      te2[8] = bc * f2 + ad;
      te2[1] = f2;
      te2[5] = a3 * e2;
      te2[9] = -b * e2;
      te2[2] = -d2 * e2;
      te2[6] = ad * f2 + bc;
      te2[10] = ac - bd * f2;
    } else if (euler.order === "XZY") {
      const ac = a3 * c2, ad = a3 * d2, bc = b * c2, bd = b * d2;
      te2[0] = c2 * e2;
      te2[4] = -f2;
      te2[8] = d2 * e2;
      te2[1] = ac * f2 + bd;
      te2[5] = a3 * e2;
      te2[9] = ad * f2 - bc;
      te2[2] = bc * f2 - ad;
      te2[6] = b * e2;
      te2[10] = bd * f2 + ac;
    }
    te2[3] = 0;
    te2[7] = 0;
    te2[11] = 0;
    te2[12] = 0;
    te2[13] = 0;
    te2[14] = 0;
    te2[15] = 1;
    return this;
  }
  makeRotationFromQuaternion(q) {
    return this.compose(_zero$1, q, _one$1);
  }
  lookAt(eye, target, up) {
    const te2 = this.elements;
    _z$1.subVectors(eye, target);
    if (_z$1.lengthSq() === 0) {
      _z$1.z = 1;
    }
    _z$1.normalize();
    _x$1.crossVectors(up, _z$1);
    if (_x$1.lengthSq() === 0) {
      if (Math.abs(up.z) === 1) {
        _z$1.x += 1e-4;
      } else {
        _z$1.z += 1e-4;
      }
      _z$1.normalize();
      _x$1.crossVectors(up, _z$1);
    }
    _x$1.normalize();
    _y$1.crossVectors(_z$1, _x$1);
    te2[0] = _x$1.x;
    te2[4] = _y$1.x;
    te2[8] = _z$1.x;
    te2[1] = _x$1.y;
    te2[5] = _y$1.y;
    te2[9] = _z$1.y;
    te2[2] = _x$1.z;
    te2[6] = _y$1.z;
    te2[10] = _z$1.z;
    return this;
  }
  multiply(m) {
    return this.multiplyMatrices(this, m);
  }
  premultiply(m) {
    return this.multiplyMatrices(m, this);
  }
  multiplyMatrices(a3, b) {
    const ae2 = a3.elements;
    const be = b.elements;
    const te2 = this.elements;
    const a11 = ae2[0], a12 = ae2[4], a13 = ae2[8], a14 = ae2[12];
    const a21 = ae2[1], a22 = ae2[5], a23 = ae2[9], a24 = ae2[13];
    const a31 = ae2[2], a32 = ae2[6], a33 = ae2[10], a34 = ae2[14];
    const a41 = ae2[3], a42 = ae2[7], a43 = ae2[11], a44 = ae2[15];
    const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
    const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
    const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
    const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
    te2[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
    te2[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
    te2[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
    te2[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
    te2[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
    te2[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
    te2[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
    te2[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
    te2[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
    te2[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
    te2[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
    te2[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
    te2[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
    te2[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
    te2[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
    te2[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
    return this;
  }
  multiplyScalar(s2) {
    const te2 = this.elements;
    te2[0] *= s2;
    te2[4] *= s2;
    te2[8] *= s2;
    te2[12] *= s2;
    te2[1] *= s2;
    te2[5] *= s2;
    te2[9] *= s2;
    te2[13] *= s2;
    te2[2] *= s2;
    te2[6] *= s2;
    te2[10] *= s2;
    te2[14] *= s2;
    te2[3] *= s2;
    te2[7] *= s2;
    te2[11] *= s2;
    te2[15] *= s2;
    return this;
  }
  determinant() {
    const te2 = this.elements;
    const n11 = te2[0], n12 = te2[4], n13 = te2[8], n14 = te2[12];
    const n21 = te2[1], n22 = te2[5], n23 = te2[9], n24 = te2[13];
    const n31 = te2[2], n32 = te2[6], n33 = te2[10], n34 = te2[14];
    const n41 = te2[3], n42 = te2[7], n43 = te2[11], n44 = te2[15];
    return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
  }
  transpose() {
    const te2 = this.elements;
    let tmp2;
    tmp2 = te2[1];
    te2[1] = te2[4];
    te2[4] = tmp2;
    tmp2 = te2[2];
    te2[2] = te2[8];
    te2[8] = tmp2;
    tmp2 = te2[6];
    te2[6] = te2[9];
    te2[9] = tmp2;
    tmp2 = te2[3];
    te2[3] = te2[12];
    te2[12] = tmp2;
    tmp2 = te2[7];
    te2[7] = te2[13];
    te2[13] = tmp2;
    tmp2 = te2[11];
    te2[11] = te2[14];
    te2[14] = tmp2;
    return this;
  }
  setPosition(x, y, z2) {
    const te2 = this.elements;
    if (x.isVector3) {
      te2[12] = x.x;
      te2[13] = x.y;
      te2[14] = x.z;
    } else {
      te2[12] = x;
      te2[13] = y;
      te2[14] = z2;
    }
    return this;
  }
  invert() {
    const te2 = this.elements, n11 = te2[0], n21 = te2[1], n31 = te2[2], n41 = te2[3], n12 = te2[4], n22 = te2[5], n32 = te2[6], n42 = te2[7], n13 = te2[8], n23 = te2[9], n33 = te2[10], n43 = te2[11], n14 = te2[12], n24 = te2[13], n34 = te2[14], n44 = te2[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
    const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
    if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const detInv = 1 / det;
    te2[0] = t11 * detInv;
    te2[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
    te2[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
    te2[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
    te2[4] = t12 * detInv;
    te2[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
    te2[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
    te2[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
    te2[8] = t13 * detInv;
    te2[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
    te2[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
    te2[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
    te2[12] = t14 * detInv;
    te2[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
    te2[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
    te2[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
    return this;
  }
  scale(v) {
    const te2 = this.elements;
    const x = v.x, y = v.y, z2 = v.z;
    te2[0] *= x;
    te2[4] *= y;
    te2[8] *= z2;
    te2[1] *= x;
    te2[5] *= y;
    te2[9] *= z2;
    te2[2] *= x;
    te2[6] *= y;
    te2[10] *= z2;
    te2[3] *= x;
    te2[7] *= y;
    te2[11] *= z2;
    return this;
  }
  getMaxScaleOnAxis() {
    const te2 = this.elements;
    const scaleXSq = te2[0] * te2[0] + te2[1] * te2[1] + te2[2] * te2[2];
    const scaleYSq = te2[4] * te2[4] + te2[5] * te2[5] + te2[6] * te2[6];
    const scaleZSq = te2[8] * te2[8] + te2[9] * te2[9] + te2[10] * te2[10];
    return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
  }
  makeTranslation(x, y, z2) {
    if (x.isVector3) {
      this.set(
        1,
        0,
        0,
        x.x,
        0,
        1,
        0,
        x.y,
        0,
        0,
        1,
        x.z,
        0,
        0,
        0,
        1
      );
    } else {
      this.set(
        1,
        0,
        0,
        x,
        0,
        1,
        0,
        y,
        0,
        0,
        1,
        z2,
        0,
        0,
        0,
        1
      );
    }
    return this;
  }
  makeRotationX(theta) {
    const c2 = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      1,
      0,
      0,
      0,
      0,
      c2,
      -s2,
      0,
      0,
      s2,
      c2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationY(theta) {
    const c2 = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      c2,
      0,
      s2,
      0,
      0,
      1,
      0,
      0,
      -s2,
      0,
      c2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationZ(theta) {
    const c2 = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      c2,
      -s2,
      0,
      0,
      s2,
      c2,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationAxis(axis, angle2) {
    const c2 = Math.cos(angle2);
    const s2 = Math.sin(angle2);
    const t3 = 1 - c2;
    const x = axis.x, y = axis.y, z2 = axis.z;
    const tx = t3 * x, ty = t3 * y;
    this.set(
      tx * x + c2,
      tx * y - s2 * z2,
      tx * z2 + s2 * y,
      0,
      tx * y + s2 * z2,
      ty * y + c2,
      ty * z2 - s2 * x,
      0,
      tx * z2 - s2 * y,
      ty * z2 + s2 * x,
      t3 * z2 * z2 + c2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeScale(x, y, z2) {
    this.set(
      x,
      0,
      0,
      0,
      0,
      y,
      0,
      0,
      0,
      0,
      z2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeShear(xy, xz, yx, yz, zx, zy) {
    this.set(
      1,
      yx,
      zx,
      0,
      xy,
      1,
      zy,
      0,
      xz,
      yz,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  compose(position2, quaternion, scale) {
    const te2 = this.elements;
    const x = quaternion._x, y = quaternion._y, z2 = quaternion._z, w = quaternion._w;
    const x2 = x + x, y2 = y + y, z22 = z2 + z2;
    const xx = x * x2, xy = x * y2, xz = x * z22;
    const yy = y * y2, yz = y * z22, zz = z2 * z22;
    const wx = w * x2, wy = w * y2, wz = w * z22;
    const sx = scale.x, sy = scale.y, sz = scale.z;
    te2[0] = (1 - (yy + zz)) * sx;
    te2[1] = (xy + wz) * sx;
    te2[2] = (xz - wy) * sx;
    te2[3] = 0;
    te2[4] = (xy - wz) * sy;
    te2[5] = (1 - (xx + zz)) * sy;
    te2[6] = (yz + wx) * sy;
    te2[7] = 0;
    te2[8] = (xz + wy) * sz;
    te2[9] = (yz - wx) * sz;
    te2[10] = (1 - (xx + yy)) * sz;
    te2[11] = 0;
    te2[12] = position2.x;
    te2[13] = position2.y;
    te2[14] = position2.z;
    te2[15] = 1;
    return this;
  }
  decompose(position2, quaternion, scale) {
    const te2 = this.elements;
    let sx = _v1$5$1.set(te2[0], te2[1], te2[2]).length();
    const sy = _v1$5$1.set(te2[4], te2[5], te2[6]).length();
    const sz = _v1$5$1.set(te2[8], te2[9], te2[10]).length();
    const det = this.determinant();
    if (det < 0) sx = -sx;
    position2.x = te2[12];
    position2.y = te2[13];
    position2.z = te2[14];
    _m1$2$1.copy(this);
    const invSX = 1 / sx;
    const invSY = 1 / sy;
    const invSZ = 1 / sz;
    _m1$2$1.elements[0] *= invSX;
    _m1$2$1.elements[1] *= invSX;
    _m1$2$1.elements[2] *= invSX;
    _m1$2$1.elements[4] *= invSY;
    _m1$2$1.elements[5] *= invSY;
    _m1$2$1.elements[6] *= invSY;
    _m1$2$1.elements[8] *= invSZ;
    _m1$2$1.elements[9] *= invSZ;
    _m1$2$1.elements[10] *= invSZ;
    quaternion.setFromRotationMatrix(_m1$2$1);
    scale.x = sx;
    scale.y = sy;
    scale.z = sz;
    return this;
  }
  makePerspective(left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem) {
    const te2 = this.elements;
    const x = 2 * near / (right - left);
    const y = 2 * near / (top - bottom);
    const a3 = (right + left) / (right - left);
    const b = (top + bottom) / (top - bottom);
    let c2, d2;
    if (coordinateSystem === WebGLCoordinateSystem) {
      c2 = -(far + near) / (far - near);
      d2 = -2 * far * near / (far - near);
    } else if (coordinateSystem === WebGPUCoordinateSystem) {
      c2 = -far / (far - near);
      d2 = -far * near / (far - near);
    } else {
      throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + coordinateSystem);
    }
    te2[0] = x;
    te2[4] = 0;
    te2[8] = a3;
    te2[12] = 0;
    te2[1] = 0;
    te2[5] = y;
    te2[9] = b;
    te2[13] = 0;
    te2[2] = 0;
    te2[6] = 0;
    te2[10] = c2;
    te2[14] = d2;
    te2[3] = 0;
    te2[7] = 0;
    te2[11] = -1;
    te2[15] = 0;
    return this;
  }
  makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem) {
    const te2 = this.elements;
    const w = 1 / (right - left);
    const h2 = 1 / (top - bottom);
    const p2 = 1 / (far - near);
    const x = (right + left) * w;
    const y = (top + bottom) * h2;
    let z2, zInv;
    if (coordinateSystem === WebGLCoordinateSystem) {
      z2 = (far + near) * p2;
      zInv = -2 * p2;
    } else if (coordinateSystem === WebGPUCoordinateSystem) {
      z2 = near * p2;
      zInv = -1 * p2;
    } else {
      throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + coordinateSystem);
    }
    te2[0] = 2 * w;
    te2[4] = 0;
    te2[8] = 0;
    te2[12] = -x;
    te2[1] = 0;
    te2[5] = 2 * h2;
    te2[9] = 0;
    te2[13] = -y;
    te2[2] = 0;
    te2[6] = 0;
    te2[10] = zInv;
    te2[14] = -z2;
    te2[3] = 0;
    te2[7] = 0;
    te2[11] = 0;
    te2[15] = 1;
    return this;
  }
  equals(matrix2) {
    const te2 = this.elements;
    const me = matrix2.elements;
    for (let i2 = 0; i2 < 16; i2++) {
      if (te2[i2] !== me[i2]) return false;
    }
    return true;
  }
  fromArray(array, offset = 0) {
    for (let i2 = 0; i2 < 16; i2++) {
      this.elements[i2] = array[i2 + offset];
    }
    return this;
  }
  toArray(array = [], offset = 0) {
    const te2 = this.elements;
    array[offset] = te2[0];
    array[offset + 1] = te2[1];
    array[offset + 2] = te2[2];
    array[offset + 3] = te2[3];
    array[offset + 4] = te2[4];
    array[offset + 5] = te2[5];
    array[offset + 6] = te2[6];
    array[offset + 7] = te2[7];
    array[offset + 8] = te2[8];
    array[offset + 9] = te2[9];
    array[offset + 10] = te2[10];
    array[offset + 11] = te2[11];
    array[offset + 12] = te2[12];
    array[offset + 13] = te2[13];
    array[offset + 14] = te2[14];
    array[offset + 15] = te2[15];
    return array;
  }
};
const _v1$5$1 = /* @__PURE__ */ new Vector3$1();
const _m1$2$1 = /* @__PURE__ */ new Matrix4$1();
const _zero$1 = /* @__PURE__ */ new Vector3$1(0, 0, 0);
const _one$1 = /* @__PURE__ */ new Vector3$1(1, 1, 1);
const _x$1 = /* @__PURE__ */ new Vector3$1();
const _y$1 = /* @__PURE__ */ new Vector3$1();
const _z$1 = /* @__PURE__ */ new Vector3$1();
const _matrix$2 = /* @__PURE__ */ new Matrix4$1();
const _quaternion$3$1 = /* @__PURE__ */ new Quaternion$1();
let Euler$1 = class Euler {
  constructor(x = 0, y = 0, z2 = 0, order = Euler.DEFAULT_ORDER) {
    this.isEuler = true;
    this._x = x;
    this._y = y;
    this._z = z2;
    this._order = order;
  }
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
    this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
    this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(value) {
    this._z = value;
    this._onChangeCallback();
  }
  get order() {
    return this._order;
  }
  set order(value) {
    this._order = value;
    this._onChangeCallback();
  }
  set(x, y, z2, order = this._order) {
    this._x = x;
    this._y = y;
    this._z = z2;
    this._order = order;
    this._onChangeCallback();
    return this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  copy(euler) {
    this._x = euler._x;
    this._y = euler._y;
    this._z = euler._z;
    this._order = euler._order;
    this._onChangeCallback();
    return this;
  }
  setFromRotationMatrix(m, order = this._order, update = true) {
    const te2 = m.elements;
    const m11 = te2[0], m12 = te2[4], m13 = te2[8];
    const m21 = te2[1], m22 = te2[5], m23 = te2[9];
    const m31 = te2[2], m32 = te2[6], m33 = te2[10];
    switch (order) {
      case "XYZ":
        this._y = Math.asin(clamp$1(m13, -1, 1));
        if (Math.abs(m13) < 0.9999999) {
          this._x = Math.atan2(-m23, m33);
          this._z = Math.atan2(-m12, m11);
        } else {
          this._x = Math.atan2(m32, m22);
          this._z = 0;
        }
        break;
      case "YXZ":
        this._x = Math.asin(-clamp$1(m23, -1, 1));
        if (Math.abs(m23) < 0.9999999) {
          this._y = Math.atan2(m13, m33);
          this._z = Math.atan2(m21, m22);
        } else {
          this._y = Math.atan2(-m31, m11);
          this._z = 0;
        }
        break;
      case "ZXY":
        this._x = Math.asin(clamp$1(m32, -1, 1));
        if (Math.abs(m32) < 0.9999999) {
          this._y = Math.atan2(-m31, m33);
          this._z = Math.atan2(-m12, m22);
        } else {
          this._y = 0;
          this._z = Math.atan2(m21, m11);
        }
        break;
      case "ZYX":
        this._y = Math.asin(-clamp$1(m31, -1, 1));
        if (Math.abs(m31) < 0.9999999) {
          this._x = Math.atan2(m32, m33);
          this._z = Math.atan2(m21, m11);
        } else {
          this._x = 0;
          this._z = Math.atan2(-m12, m22);
        }
        break;
      case "YZX":
        this._z = Math.asin(clamp$1(m21, -1, 1));
        if (Math.abs(m21) < 0.9999999) {
          this._x = Math.atan2(-m23, m22);
          this._y = Math.atan2(-m31, m11);
        } else {
          this._x = 0;
          this._y = Math.atan2(m13, m33);
        }
        break;
      case "XZY":
        this._z = Math.asin(-clamp$1(m12, -1, 1));
        if (Math.abs(m12) < 0.9999999) {
          this._x = Math.atan2(m32, m22);
          this._y = Math.atan2(m13, m11);
        } else {
          this._x = Math.atan2(-m23, m33);
          this._y = 0;
        }
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
    }
    this._order = order;
    if (update === true) this._onChangeCallback();
    return this;
  }
  setFromQuaternion(q, order, update) {
    _matrix$2.makeRotationFromQuaternion(q);
    return this.setFromRotationMatrix(_matrix$2, order, update);
  }
  setFromVector3(v, order = this._order) {
    return this.set(v.x, v.y, v.z, order);
  }
  reorder(newOrder) {
    _quaternion$3$1.setFromEuler(this);
    return this.setFromQuaternion(_quaternion$3$1, newOrder);
  }
  equals(euler) {
    return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
  }
  fromArray(array) {
    this._x = array[0];
    this._y = array[1];
    this._z = array[2];
    if (array[3] !== void 0) this._order = array[3];
    this._onChangeCallback();
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this._x;
    array[offset + 1] = this._y;
    array[offset + 2] = this._z;
    array[offset + 3] = this._order;
    return array;
  }
  _onChange(callback) {
    this._onChangeCallback = callback;
    return this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x;
    yield this._y;
    yield this._z;
    yield this._order;
  }
};
Euler$1.DEFAULT_ORDER = "XYZ";
let Layers$1 = class Layers {
  constructor() {
    this.mask = 1 | 0;
  }
  set(channel) {
    this.mask = (1 << channel | 0) >>> 0;
  }
  enable(channel) {
    this.mask |= 1 << channel | 0;
  }
  enableAll() {
    this.mask = 4294967295 | 0;
  }
  toggle(channel) {
    this.mask ^= 1 << channel | 0;
  }
  disable(channel) {
    this.mask &= ~(1 << channel | 0);
  }
  disableAll() {
    this.mask = 0;
  }
  test(layers) {
    return (this.mask & layers.mask) !== 0;
  }
  isEnabled(channel) {
    return (this.mask & (1 << channel | 0)) !== 0;
  }
};
let _object3DId$1 = 0;
const _v1$4$1 = /* @__PURE__ */ new Vector3$1();
const _q1$1 = /* @__PURE__ */ new Quaternion$1();
const _m1$1$2 = /* @__PURE__ */ new Matrix4$1();
const _target$1 = /* @__PURE__ */ new Vector3$1();
const _position$3$1 = /* @__PURE__ */ new Vector3$1();
const _scale$2$1 = /* @__PURE__ */ new Vector3$1();
const _quaternion$2$1 = /* @__PURE__ */ new Quaternion$1();
const _xAxis$1 = /* @__PURE__ */ new Vector3$1(1, 0, 0);
const _yAxis$1 = /* @__PURE__ */ new Vector3$1(0, 1, 0);
const _zAxis$1 = /* @__PURE__ */ new Vector3$1(0, 0, 1);
const _addedEvent$1 = { type: "added" };
const _removedEvent$1 = { type: "removed" };
const _childaddedEvent = { type: "childadded", child: null };
const _childremovedEvent = { type: "childremoved", child: null };
let Object3D$1 = class Object3D extends EventDispatcher$1 {
  constructor() {
    super();
    this.isObject3D = true;
    Object.defineProperty(this, "id", { value: _object3DId$1++ });
    this.uuid = generateUUID$1();
    this.name = "";
    this.type = "Object3D";
    this.parent = null;
    this.children = [];
    this.up = Object3D.DEFAULT_UP.clone();
    const position2 = new Vector3$1();
    const rotation = new Euler$1();
    const quaternion = new Quaternion$1();
    const scale = new Vector3$1(1, 1, 1);
    function onRotationChange() {
      quaternion.setFromEuler(rotation, false);
    }
    function onQuaternionChange() {
      rotation.setFromQuaternion(quaternion, void 0, false);
    }
    rotation._onChange(onRotationChange);
    quaternion._onChange(onQuaternionChange);
    Object.defineProperties(this, {
      position: {
        configurable: true,
        enumerable: true,
        value: position2
      },
      rotation: {
        configurable: true,
        enumerable: true,
        value: rotation
      },
      quaternion: {
        configurable: true,
        enumerable: true,
        value: quaternion
      },
      scale: {
        configurable: true,
        enumerable: true,
        value: scale
      },
      modelViewMatrix: {
        value: new Matrix4$1()
      },
      normalMatrix: {
        value: new Matrix3$1()
      }
    });
    this.matrix = new Matrix4$1();
    this.matrixWorld = new Matrix4$1();
    this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE;
    this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE;
    this.matrixWorldNeedsUpdate = false;
    this.layers = new Layers$1();
    this.visible = true;
    this.castShadow = false;
    this.receiveShadow = false;
    this.frustumCulled = true;
    this.renderOrder = 0;
    this.animations = [];
    this.userData = {};
  }
  onBeforeShadow() {
  }
  onAfterShadow() {
  }
  onBeforeRender() {
  }
  onAfterRender() {
  }
  applyMatrix4(matrix2) {
    if (this.matrixAutoUpdate) this.updateMatrix();
    this.matrix.premultiply(matrix2);
    this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  applyQuaternion(q) {
    this.quaternion.premultiply(q);
    return this;
  }
  setRotationFromAxisAngle(axis, angle2) {
    this.quaternion.setFromAxisAngle(axis, angle2);
  }
  setRotationFromEuler(euler) {
    this.quaternion.setFromEuler(euler, true);
  }
  setRotationFromMatrix(m) {
    this.quaternion.setFromRotationMatrix(m);
  }
  setRotationFromQuaternion(q) {
    this.quaternion.copy(q);
  }
  rotateOnAxis(axis, angle2) {
    _q1$1.setFromAxisAngle(axis, angle2);
    this.quaternion.multiply(_q1$1);
    return this;
  }
  rotateOnWorldAxis(axis, angle2) {
    _q1$1.setFromAxisAngle(axis, angle2);
    this.quaternion.premultiply(_q1$1);
    return this;
  }
  rotateX(angle2) {
    return this.rotateOnAxis(_xAxis$1, angle2);
  }
  rotateY(angle2) {
    return this.rotateOnAxis(_yAxis$1, angle2);
  }
  rotateZ(angle2) {
    return this.rotateOnAxis(_zAxis$1, angle2);
  }
  translateOnAxis(axis, distance2) {
    _v1$4$1.copy(axis).applyQuaternion(this.quaternion);
    this.position.add(_v1$4$1.multiplyScalar(distance2));
    return this;
  }
  translateX(distance2) {
    return this.translateOnAxis(_xAxis$1, distance2);
  }
  translateY(distance2) {
    return this.translateOnAxis(_yAxis$1, distance2);
  }
  translateZ(distance2) {
    return this.translateOnAxis(_zAxis$1, distance2);
  }
  localToWorld(vector) {
    this.updateWorldMatrix(true, false);
    return vector.applyMatrix4(this.matrixWorld);
  }
  worldToLocal(vector) {
    this.updateWorldMatrix(true, false);
    return vector.applyMatrix4(_m1$1$2.copy(this.matrixWorld).invert());
  }
  lookAt(x, y, z2) {
    if (x.isVector3) {
      _target$1.copy(x);
    } else {
      _target$1.set(x, y, z2);
    }
    const parent2 = this.parent;
    this.updateWorldMatrix(true, false);
    _position$3$1.setFromMatrixPosition(this.matrixWorld);
    if (this.isCamera || this.isLight) {
      _m1$1$2.lookAt(_position$3$1, _target$1, this.up);
    } else {
      _m1$1$2.lookAt(_target$1, _position$3$1, this.up);
    }
    this.quaternion.setFromRotationMatrix(_m1$1$2);
    if (parent2) {
      _m1$1$2.extractRotation(parent2.matrixWorld);
      _q1$1.setFromRotationMatrix(_m1$1$2);
      this.quaternion.premultiply(_q1$1.invert());
    }
  }
  add(object) {
    if (arguments.length > 1) {
      for (let i2 = 0; i2 < arguments.length; i2++) {
        this.add(arguments[i2]);
      }
      return this;
    }
    if (object === this) {
      console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
      return this;
    }
    if (object && object.isObject3D) {
      object.removeFromParent();
      object.parent = this;
      this.children.push(object);
      object.dispatchEvent(_addedEvent$1);
      _childaddedEvent.child = object;
      this.dispatchEvent(_childaddedEvent);
      _childaddedEvent.child = null;
    } else {
      console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
    }
    return this;
  }
  remove(object) {
    if (arguments.length > 1) {
      for (let i2 = 0; i2 < arguments.length; i2++) {
        this.remove(arguments[i2]);
      }
      return this;
    }
    const index2 = this.children.indexOf(object);
    if (index2 !== -1) {
      object.parent = null;
      this.children.splice(index2, 1);
      object.dispatchEvent(_removedEvent$1);
      _childremovedEvent.child = object;
      this.dispatchEvent(_childremovedEvent);
      _childremovedEvent.child = null;
    }
    return this;
  }
  removeFromParent() {
    const parent2 = this.parent;
    if (parent2 !== null) {
      parent2.remove(this);
    }
    return this;
  }
  clear() {
    return this.remove(...this.children);
  }
  attach(object) {
    this.updateWorldMatrix(true, false);
    _m1$1$2.copy(this.matrixWorld).invert();
    if (object.parent !== null) {
      object.parent.updateWorldMatrix(true, false);
      _m1$1$2.multiply(object.parent.matrixWorld);
    }
    object.applyMatrix4(_m1$1$2);
    object.removeFromParent();
    object.parent = this;
    this.children.push(object);
    object.updateWorldMatrix(false, true);
    object.dispatchEvent(_addedEvent$1);
    _childaddedEvent.child = object;
    this.dispatchEvent(_childaddedEvent);
    _childaddedEvent.child = null;
    return this;
  }
  getObjectById(id) {
    return this.getObjectByProperty("id", id);
  }
  getObjectByName(name) {
    return this.getObjectByProperty("name", name);
  }
  getObjectByProperty(name, value) {
    if (this[name] === value) return this;
    for (let i2 = 0, l2 = this.children.length; i2 < l2; i2++) {
      const child = this.children[i2];
      const object = child.getObjectByProperty(name, value);
      if (object !== void 0) {
        return object;
      }
    }
    return void 0;
  }
  getObjectsByProperty(name, value, result = []) {
    if (this[name] === value) result.push(this);
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      children[i2].getObjectsByProperty(name, value, result);
    }
    return result;
  }
  getWorldPosition(target) {
    this.updateWorldMatrix(true, false);
    return target.setFromMatrixPosition(this.matrixWorld);
  }
  getWorldQuaternion(target) {
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(_position$3$1, target, _scale$2$1);
    return target;
  }
  getWorldScale(target) {
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(_position$3$1, _quaternion$2$1, target);
    return target;
  }
  getWorldDirection(target) {
    this.updateWorldMatrix(true, false);
    const e2 = this.matrixWorld.elements;
    return target.set(e2[8], e2[9], e2[10]).normalize();
  }
  raycast() {
  }
  traverse(callback) {
    callback(this);
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      children[i2].traverse(callback);
    }
  }
  traverseVisible(callback) {
    if (this.visible === false) return;
    callback(this);
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      children[i2].traverseVisible(callback);
    }
  }
  traverseAncestors(callback) {
    const parent2 = this.parent;
    if (parent2 !== null) {
      callback(parent2);
      parent2.traverseAncestors(callback);
    }
  }
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale);
    this.matrixWorldNeedsUpdate = true;
  }
  updateMatrixWorld(force) {
    if (this.matrixAutoUpdate) this.updateMatrix();
    if (this.matrixWorldNeedsUpdate || force) {
      if (this.matrixWorldAutoUpdate === true) {
        if (this.parent === null) {
          this.matrixWorld.copy(this.matrix);
        } else {
          this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
      }
      this.matrixWorldNeedsUpdate = false;
      force = true;
    }
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      const child = children[i2];
      child.updateMatrixWorld(force);
    }
  }
  updateWorldMatrix(updateParents, updateChildren) {
    const parent2 = this.parent;
    if (updateParents === true && parent2 !== null) {
      parent2.updateWorldMatrix(true, false);
    }
    if (this.matrixAutoUpdate) this.updateMatrix();
    if (this.matrixWorldAutoUpdate === true) {
      if (this.parent === null) {
        this.matrixWorld.copy(this.matrix);
      } else {
        this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
      }
    }
    if (updateChildren === true) {
      const children = this.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        const child = children[i2];
        child.updateWorldMatrix(false, true);
      }
    }
  }
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    const output = {};
    if (isRootObject) {
      meta = {
        geometries: {},
        materials: {},
        textures: {},
        images: {},
        shapes: {},
        skeletons: {},
        animations: {},
        nodes: {}
      };
      output.metadata = {
        version: 4.6,
        type: "Object",
        generator: "Object3D.toJSON"
      };
    }
    const object = {};
    object.uuid = this.uuid;
    object.type = this.type;
    if (this.name !== "") object.name = this.name;
    if (this.castShadow === true) object.castShadow = true;
    if (this.receiveShadow === true) object.receiveShadow = true;
    if (this.visible === false) object.visible = false;
    if (this.frustumCulled === false) object.frustumCulled = false;
    if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
    if (Object.keys(this.userData).length > 0) object.userData = this.userData;
    object.layers = this.layers.mask;
    object.matrix = this.matrix.toArray();
    object.up = this.up.toArray();
    if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
    if (this.isInstancedMesh) {
      object.type = "InstancedMesh";
      object.count = this.count;
      object.instanceMatrix = this.instanceMatrix.toJSON();
      if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
    }
    if (this.isBatchedMesh) {
      object.type = "BatchedMesh";
      object.perObjectFrustumCulled = this.perObjectFrustumCulled;
      object.sortObjects = this.sortObjects;
      object.drawRanges = this._drawRanges;
      object.reservedRanges = this._reservedRanges;
      object.visibility = this._visibility;
      object.active = this._active;
      object.bounds = this._bounds.map((bound) => ({
        boxInitialized: bound.boxInitialized,
        boxMin: bound.box.min.toArray(),
        boxMax: bound.box.max.toArray(),
        sphereInitialized: bound.sphereInitialized,
        sphereRadius: bound.sphere.radius,
        sphereCenter: bound.sphere.center.toArray()
      }));
      object.maxInstanceCount = this._maxInstanceCount;
      object.maxVertexCount = this._maxVertexCount;
      object.maxIndexCount = this._maxIndexCount;
      object.geometryInitialized = this._geometryInitialized;
      object.geometryCount = this._geometryCount;
      object.matricesTexture = this._matricesTexture.toJSON(meta);
      if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
      if (this.boundingSphere !== null) {
        object.boundingSphere = {
          center: object.boundingSphere.center.toArray(),
          radius: object.boundingSphere.radius
        };
      }
      if (this.boundingBox !== null) {
        object.boundingBox = {
          min: object.boundingBox.min.toArray(),
          max: object.boundingBox.max.toArray()
        };
      }
    }
    function serialize(library, element) {
      if (library[element.uuid] === void 0) {
        library[element.uuid] = element.toJSON(meta);
      }
      return element.uuid;
    }
    if (this.isScene) {
      if (this.background) {
        if (this.background.isColor) {
          object.background = this.background.toJSON();
        } else if (this.background.isTexture) {
          object.background = this.background.toJSON(meta).uuid;
        }
      }
      if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) {
        object.environment = this.environment.toJSON(meta).uuid;
      }
    } else if (this.isMesh || this.isLine || this.isPoints) {
      object.geometry = serialize(meta.geometries, this.geometry);
      const parameters = this.geometry.parameters;
      if (parameters !== void 0 && parameters.shapes !== void 0) {
        const shapes = parameters.shapes;
        if (Array.isArray(shapes)) {
          for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
            const shape = shapes[i2];
            serialize(meta.shapes, shape);
          }
        } else {
          serialize(meta.shapes, shapes);
        }
      }
    }
    if (this.isSkinnedMesh) {
      object.bindMode = this.bindMode;
      object.bindMatrix = this.bindMatrix.toArray();
      if (this.skeleton !== void 0) {
        serialize(meta.skeletons, this.skeleton);
        object.skeleton = this.skeleton.uuid;
      }
    }
    if (this.material !== void 0) {
      if (Array.isArray(this.material)) {
        const uuids = [];
        for (let i2 = 0, l2 = this.material.length; i2 < l2; i2++) {
          uuids.push(serialize(meta.materials, this.material[i2]));
        }
        object.material = uuids;
      } else {
        object.material = serialize(meta.materials, this.material);
      }
    }
    if (this.children.length > 0) {
      object.children = [];
      for (let i2 = 0; i2 < this.children.length; i2++) {
        object.children.push(this.children[i2].toJSON(meta).object);
      }
    }
    if (this.animations.length > 0) {
      object.animations = [];
      for (let i2 = 0; i2 < this.animations.length; i2++) {
        const animation = this.animations[i2];
        object.animations.push(serialize(meta.animations, animation));
      }
    }
    if (isRootObject) {
      const geometries = extractFromCache(meta.geometries);
      const materials = extractFromCache(meta.materials);
      const textures = extractFromCache(meta.textures);
      const images = extractFromCache(meta.images);
      const shapes = extractFromCache(meta.shapes);
      const skeletons = extractFromCache(meta.skeletons);
      const animations = extractFromCache(meta.animations);
      const nodes = extractFromCache(meta.nodes);
      if (geometries.length > 0) output.geometries = geometries;
      if (materials.length > 0) output.materials = materials;
      if (textures.length > 0) output.textures = textures;
      if (images.length > 0) output.images = images;
      if (shapes.length > 0) output.shapes = shapes;
      if (skeletons.length > 0) output.skeletons = skeletons;
      if (animations.length > 0) output.animations = animations;
      if (nodes.length > 0) output.nodes = nodes;
    }
    output.object = object;
    return output;
    function extractFromCache(cache) {
      const values = [];
      for (const key in cache) {
        const data = cache[key];
        delete data.metadata;
        values.push(data);
      }
      return values;
    }
  }
  clone(recursive) {
    return new this.constructor().copy(this, recursive);
  }
  copy(source, recursive = true) {
    this.name = source.name;
    this.up.copy(source.up);
    this.position.copy(source.position);
    this.rotation.order = source.rotation.order;
    this.quaternion.copy(source.quaternion);
    this.scale.copy(source.scale);
    this.matrix.copy(source.matrix);
    this.matrixWorld.copy(source.matrixWorld);
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
    this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
    this.layers.mask = source.layers.mask;
    this.visible = source.visible;
    this.castShadow = source.castShadow;
    this.receiveShadow = source.receiveShadow;
    this.frustumCulled = source.frustumCulled;
    this.renderOrder = source.renderOrder;
    this.animations = source.animations.slice();
    this.userData = JSON.parse(JSON.stringify(source.userData));
    if (recursive === true) {
      for (let i2 = 0; i2 < source.children.length; i2++) {
        const child = source.children[i2];
        this.add(child.clone());
      }
    }
    return this;
  }
};
Object3D$1.DEFAULT_UP = /* @__PURE__ */ new Vector3$1(0, 1, 0);
Object3D$1.DEFAULT_MATRIX_AUTO_UPDATE = true;
Object3D$1.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const _v0$1$1 = /* @__PURE__ */ new Vector3$1();
const _v1$3$1 = /* @__PURE__ */ new Vector3$1();
const _v2$2$1 = /* @__PURE__ */ new Vector3$1();
const _v3$2 = /* @__PURE__ */ new Vector3$1();
const _vab$1 = /* @__PURE__ */ new Vector3$1();
const _vac$1 = /* @__PURE__ */ new Vector3$1();
const _vbc$1 = /* @__PURE__ */ new Vector3$1();
const _vap$1 = /* @__PURE__ */ new Vector3$1();
const _vbp$1 = /* @__PURE__ */ new Vector3$1();
const _vcp$1 = /* @__PURE__ */ new Vector3$1();
const _v40 = /* @__PURE__ */ new Vector4$1();
const _v41 = /* @__PURE__ */ new Vector4$1();
const _v42 = /* @__PURE__ */ new Vector4$1();
let Triangle$1 = class Triangle {
  constructor(a3 = new Vector3$1(), b = new Vector3$1(), c2 = new Vector3$1()) {
    this.a = a3;
    this.b = b;
    this.c = c2;
  }
  static getNormal(a3, b, c2, target) {
    target.subVectors(c2, b);
    _v0$1$1.subVectors(a3, b);
    target.cross(_v0$1$1);
    const targetLengthSq = target.lengthSq();
    if (targetLengthSq > 0) {
      return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
    }
    return target.set(0, 0, 0);
  }
  // static/instance method to calculate barycentric coordinates
  // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
  static getBarycoord(point2, a3, b, c2, target) {
    _v0$1$1.subVectors(c2, a3);
    _v1$3$1.subVectors(b, a3);
    _v2$2$1.subVectors(point2, a3);
    const dot00 = _v0$1$1.dot(_v0$1$1);
    const dot01 = _v0$1$1.dot(_v1$3$1);
    const dot02 = _v0$1$1.dot(_v2$2$1);
    const dot11 = _v1$3$1.dot(_v1$3$1);
    const dot12 = _v1$3$1.dot(_v2$2$1);
    const denom = dot00 * dot11 - dot01 * dot01;
    if (denom === 0) {
      target.set(0, 0, 0);
      return null;
    }
    const invDenom = 1 / denom;
    const u3 = (dot11 * dot02 - dot01 * dot12) * invDenom;
    const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
    return target.set(1 - u3 - v, v, u3);
  }
  static containsPoint(point2, a3, b, c2) {
    if (this.getBarycoord(point2, a3, b, c2, _v3$2) === null) {
      return false;
    }
    return _v3$2.x >= 0 && _v3$2.y >= 0 && _v3$2.x + _v3$2.y <= 1;
  }
  static getInterpolation(point2, p1, p2, p3, v1, v2, v3, target) {
    if (this.getBarycoord(point2, p1, p2, p3, _v3$2) === null) {
      target.x = 0;
      target.y = 0;
      if ("z" in target) target.z = 0;
      if ("w" in target) target.w = 0;
      return null;
    }
    target.setScalar(0);
    target.addScaledVector(v1, _v3$2.x);
    target.addScaledVector(v2, _v3$2.y);
    target.addScaledVector(v3, _v3$2.z);
    return target;
  }
  static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
    _v40.setScalar(0);
    _v41.setScalar(0);
    _v42.setScalar(0);
    _v40.fromBufferAttribute(attr, i1);
    _v41.fromBufferAttribute(attr, i2);
    _v42.fromBufferAttribute(attr, i3);
    target.setScalar(0);
    target.addScaledVector(_v40, barycoord.x);
    target.addScaledVector(_v41, barycoord.y);
    target.addScaledVector(_v42, barycoord.z);
    return target;
  }
  static isFrontFacing(a3, b, c2, direction2) {
    _v0$1$1.subVectors(c2, b);
    _v1$3$1.subVectors(a3, b);
    return _v0$1$1.cross(_v1$3$1).dot(direction2) < 0 ? true : false;
  }
  set(a3, b, c2) {
    this.a.copy(a3);
    this.b.copy(b);
    this.c.copy(c2);
    return this;
  }
  setFromPointsAndIndices(points, i0, i1, i2) {
    this.a.copy(points[i0]);
    this.b.copy(points[i1]);
    this.c.copy(points[i2]);
    return this;
  }
  setFromAttributeAndIndices(attribute, i0, i1, i2) {
    this.a.fromBufferAttribute(attribute, i0);
    this.b.fromBufferAttribute(attribute, i1);
    this.c.fromBufferAttribute(attribute, i2);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(triangle3) {
    this.a.copy(triangle3.a);
    this.b.copy(triangle3.b);
    this.c.copy(triangle3.c);
    return this;
  }
  getArea() {
    _v0$1$1.subVectors(this.c, this.b);
    _v1$3$1.subVectors(this.a, this.b);
    return _v0$1$1.cross(_v1$3$1).length() * 0.5;
  }
  getMidpoint(target) {
    return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  getNormal(target) {
    return Triangle.getNormal(this.a, this.b, this.c, target);
  }
  getPlane(target) {
    return target.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  getBarycoord(point2, target) {
    return Triangle.getBarycoord(point2, this.a, this.b, this.c, target);
  }
  getInterpolation(point2, v1, v2, v3, target) {
    return Triangle.getInterpolation(point2, this.a, this.b, this.c, v1, v2, v3, target);
  }
  containsPoint(point2) {
    return Triangle.containsPoint(point2, this.a, this.b, this.c);
  }
  isFrontFacing(direction2) {
    return Triangle.isFrontFacing(this.a, this.b, this.c, direction2);
  }
  intersectsBox(box) {
    return box.intersectsTriangle(this);
  }
  closestPointToPoint(p2, target) {
    const a3 = this.a, b = this.b, c2 = this.c;
    let v, w;
    _vab$1.subVectors(b, a3);
    _vac$1.subVectors(c2, a3);
    _vap$1.subVectors(p2, a3);
    const d1 = _vab$1.dot(_vap$1);
    const d2 = _vac$1.dot(_vap$1);
    if (d1 <= 0 && d2 <= 0) {
      return target.copy(a3);
    }
    _vbp$1.subVectors(p2, b);
    const d3 = _vab$1.dot(_vbp$1);
    const d4 = _vac$1.dot(_vbp$1);
    if (d3 >= 0 && d4 <= d3) {
      return target.copy(b);
    }
    const vc = d1 * d4 - d3 * d2;
    if (vc <= 0 && d1 >= 0 && d3 <= 0) {
      v = d1 / (d1 - d3);
      return target.copy(a3).addScaledVector(_vab$1, v);
    }
    _vcp$1.subVectors(p2, c2);
    const d5 = _vab$1.dot(_vcp$1);
    const d6 = _vac$1.dot(_vcp$1);
    if (d6 >= 0 && d5 <= d6) {
      return target.copy(c2);
    }
    const vb = d5 * d2 - d1 * d6;
    if (vb <= 0 && d2 >= 0 && d6 <= 0) {
      w = d2 / (d2 - d6);
      return target.copy(a3).addScaledVector(_vac$1, w);
    }
    const va = d3 * d6 - d5 * d4;
    if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
      _vbc$1.subVectors(c2, b);
      w = (d4 - d3) / (d4 - d3 + (d5 - d6));
      return target.copy(b).addScaledVector(_vbc$1, w);
    }
    const denom = 1 / (va + vb + vc);
    v = vb * denom;
    w = vc * denom;
    return target.copy(a3).addScaledVector(_vab$1, v).addScaledVector(_vac$1, w);
  }
  equals(triangle3) {
    return triangle3.a.equals(this.a) && triangle3.b.equals(this.b) && triangle3.c.equals(this.c);
  }
};
const _colorKeywords$1 = {
  "aliceblue": 15792383,
  "antiquewhite": 16444375,
  "aqua": 65535,
  "aquamarine": 8388564,
  "azure": 15794175,
  "beige": 16119260,
  "bisque": 16770244,
  "black": 0,
  "blanchedalmond": 16772045,
  "blue": 255,
  "blueviolet": 9055202,
  "brown": 10824234,
  "burlywood": 14596231,
  "cadetblue": 6266528,
  "chartreuse": 8388352,
  "chocolate": 13789470,
  "coral": 16744272,
  "cornflowerblue": 6591981,
  "cornsilk": 16775388,
  "crimson": 14423100,
  "cyan": 65535,
  "darkblue": 139,
  "darkcyan": 35723,
  "darkgoldenrod": 12092939,
  "darkgray": 11119017,
  "darkgreen": 25600,
  "darkgrey": 11119017,
  "darkkhaki": 12433259,
  "darkmagenta": 9109643,
  "darkolivegreen": 5597999,
  "darkorange": 16747520,
  "darkorchid": 10040012,
  "darkred": 9109504,
  "darksalmon": 15308410,
  "darkseagreen": 9419919,
  "darkslateblue": 4734347,
  "darkslategray": 3100495,
  "darkslategrey": 3100495,
  "darkturquoise": 52945,
  "darkviolet": 9699539,
  "deeppink": 16716947,
  "deepskyblue": 49151,
  "dimgray": 6908265,
  "dimgrey": 6908265,
  "dodgerblue": 2003199,
  "firebrick": 11674146,
  "floralwhite": 16775920,
  "forestgreen": 2263842,
  "fuchsia": 16711935,
  "gainsboro": 14474460,
  "ghostwhite": 16316671,
  "gold": 16766720,
  "goldenrod": 14329120,
  "gray": 8421504,
  "green": 32768,
  "greenyellow": 11403055,
  "grey": 8421504,
  "honeydew": 15794160,
  "hotpink": 16738740,
  "indianred": 13458524,
  "indigo": 4915330,
  "ivory": 16777200,
  "khaki": 15787660,
  "lavender": 15132410,
  "lavenderblush": 16773365,
  "lawngreen": 8190976,
  "lemonchiffon": 16775885,
  "lightblue": 11393254,
  "lightcoral": 15761536,
  "lightcyan": 14745599,
  "lightgoldenrodyellow": 16448210,
  "lightgray": 13882323,
  "lightgreen": 9498256,
  "lightgrey": 13882323,
  "lightpink": 16758465,
  "lightsalmon": 16752762,
  "lightseagreen": 2142890,
  "lightskyblue": 8900346,
  "lightslategray": 7833753,
  "lightslategrey": 7833753,
  "lightsteelblue": 11584734,
  "lightyellow": 16777184,
  "lime": 65280,
  "limegreen": 3329330,
  "linen": 16445670,
  "magenta": 16711935,
  "maroon": 8388608,
  "mediumaquamarine": 6737322,
  "mediumblue": 205,
  "mediumorchid": 12211667,
  "mediumpurple": 9662683,
  "mediumseagreen": 3978097,
  "mediumslateblue": 8087790,
  "mediumspringgreen": 64154,
  "mediumturquoise": 4772300,
  "mediumvioletred": 13047173,
  "midnightblue": 1644912,
  "mintcream": 16121850,
  "mistyrose": 16770273,
  "moccasin": 16770229,
  "navajowhite": 16768685,
  "navy": 128,
  "oldlace": 16643558,
  "olive": 8421376,
  "olivedrab": 7048739,
  "orange": 16753920,
  "orangered": 16729344,
  "orchid": 14315734,
  "palegoldenrod": 15657130,
  "palegreen": 10025880,
  "paleturquoise": 11529966,
  "palevioletred": 14381203,
  "papayawhip": 16773077,
  "peachpuff": 16767673,
  "peru": 13468991,
  "pink": 16761035,
  "plum": 14524637,
  "powderblue": 11591910,
  "purple": 8388736,
  "rebeccapurple": 6697881,
  "red": 16711680,
  "rosybrown": 12357519,
  "royalblue": 4286945,
  "saddlebrown": 9127187,
  "salmon": 16416882,
  "sandybrown": 16032864,
  "seagreen": 3050327,
  "seashell": 16774638,
  "sienna": 10506797,
  "silver": 12632256,
  "skyblue": 8900331,
  "slateblue": 6970061,
  "slategray": 7372944,
  "slategrey": 7372944,
  "snow": 16775930,
  "springgreen": 65407,
  "steelblue": 4620980,
  "tan": 13808780,
  "teal": 32896,
  "thistle": 14204888,
  "tomato": 16737095,
  "turquoise": 4251856,
  "violet": 15631086,
  "wheat": 16113331,
  "white": 16777215,
  "whitesmoke": 16119285,
  "yellow": 16776960,
  "yellowgreen": 10145074
};
const _hslA$1 = { h: 0, s: 0, l: 0 };
const _hslB$1 = { h: 0, s: 0, l: 0 };
function hue2rgb$2(p2, q, t3) {
  if (t3 < 0) t3 += 1;
  if (t3 > 1) t3 -= 1;
  if (t3 < 1 / 6) return p2 + (q - p2) * 6 * t3;
  if (t3 < 1 / 2) return q;
  if (t3 < 2 / 3) return p2 + (q - p2) * 6 * (2 / 3 - t3);
  return p2;
}
let Color$1 = class Color {
  constructor(r2, g3, b) {
    this.isColor = true;
    this.r = 1;
    this.g = 1;
    this.b = 1;
    return this.set(r2, g3, b);
  }
  set(r2, g3, b) {
    if (g3 === void 0 && b === void 0) {
      const value = r2;
      if (value && value.isColor) {
        this.copy(value);
      } else if (typeof value === "number") {
        this.setHex(value);
      } else if (typeof value === "string") {
        this.setStyle(value);
      }
    } else {
      this.setRGB(r2, g3, b);
    }
    return this;
  }
  setScalar(scalar) {
    this.r = scalar;
    this.g = scalar;
    this.b = scalar;
    return this;
  }
  setHex(hex, colorSpace = SRGBColorSpace) {
    hex = Math.floor(hex);
    this.r = (hex >> 16 & 255) / 255;
    this.g = (hex >> 8 & 255) / 255;
    this.b = (hex & 255) / 255;
    ColorManagement.toWorkingColorSpace(this, colorSpace);
    return this;
  }
  setRGB(r2, g3, b, colorSpace = ColorManagement.workingColorSpace) {
    this.r = r2;
    this.g = g3;
    this.b = b;
    ColorManagement.toWorkingColorSpace(this, colorSpace);
    return this;
  }
  setHSL(h2, s2, l2, colorSpace = ColorManagement.workingColorSpace) {
    h2 = euclideanModulo$1(h2, 1);
    s2 = clamp$1(s2, 0, 1);
    l2 = clamp$1(l2, 0, 1);
    if (s2 === 0) {
      this.r = this.g = this.b = l2;
    } else {
      const p2 = l2 <= 0.5 ? l2 * (1 + s2) : l2 + s2 - l2 * s2;
      const q = 2 * l2 - p2;
      this.r = hue2rgb$2(q, p2, h2 + 1 / 3);
      this.g = hue2rgb$2(q, p2, h2);
      this.b = hue2rgb$2(q, p2, h2 - 1 / 3);
    }
    ColorManagement.toWorkingColorSpace(this, colorSpace);
    return this;
  }
  setStyle(style, colorSpace = SRGBColorSpace) {
    function handleAlpha(string) {
      if (string === void 0) return;
      if (parseFloat(string) < 1) {
        console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
      }
    }
    let m;
    if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
      let color2;
      const name = m[1];
      const components = m[2];
      switch (name) {
        case "rgb":
        case "rgba":
          if (color2 = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            handleAlpha(color2[4]);
            return this.setRGB(
              Math.min(255, parseInt(color2[1], 10)) / 255,
              Math.min(255, parseInt(color2[2], 10)) / 255,
              Math.min(255, parseInt(color2[3], 10)) / 255,
              colorSpace
            );
          }
          if (color2 = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            handleAlpha(color2[4]);
            return this.setRGB(
              Math.min(100, parseInt(color2[1], 10)) / 100,
              Math.min(100, parseInt(color2[2], 10)) / 100,
              Math.min(100, parseInt(color2[3], 10)) / 100,
              colorSpace
            );
          }
          break;
        case "hsl":
        case "hsla":
          if (color2 = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            handleAlpha(color2[4]);
            return this.setHSL(
              parseFloat(color2[1]) / 360,
              parseFloat(color2[2]) / 100,
              parseFloat(color2[3]) / 100,
              colorSpace
            );
          }
          break;
        default:
          console.warn("THREE.Color: Unknown color model " + style);
      }
    } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
      const hex = m[1];
      const size = hex.length;
      if (size === 3) {
        return this.setRGB(
          parseInt(hex.charAt(0), 16) / 15,
          parseInt(hex.charAt(1), 16) / 15,
          parseInt(hex.charAt(2), 16) / 15,
          colorSpace
        );
      } else if (size === 6) {
        return this.setHex(parseInt(hex, 16), colorSpace);
      } else {
        console.warn("THREE.Color: Invalid hex color " + style);
      }
    } else if (style && style.length > 0) {
      return this.setColorName(style, colorSpace);
    }
    return this;
  }
  setColorName(style, colorSpace = SRGBColorSpace) {
    const hex = _colorKeywords$1[style.toLowerCase()];
    if (hex !== void 0) {
      this.setHex(hex, colorSpace);
    } else {
      console.warn("THREE.Color: Unknown color " + style);
    }
    return this;
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  copy(color2) {
    this.r = color2.r;
    this.g = color2.g;
    this.b = color2.b;
    return this;
  }
  copySRGBToLinear(color2) {
    this.r = SRGBToLinear$1(color2.r);
    this.g = SRGBToLinear$1(color2.g);
    this.b = SRGBToLinear$1(color2.b);
    return this;
  }
  copyLinearToSRGB(color2) {
    this.r = LinearToSRGB$1(color2.r);
    this.g = LinearToSRGB$1(color2.g);
    this.b = LinearToSRGB$1(color2.b);
    return this;
  }
  convertSRGBToLinear() {
    this.copySRGBToLinear(this);
    return this;
  }
  convertLinearToSRGB() {
    this.copyLinearToSRGB(this);
    return this;
  }
  getHex(colorSpace = SRGBColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color$1.copy(this), colorSpace);
    return Math.round(clamp$1(_color$1.r * 255, 0, 255)) * 65536 + Math.round(clamp$1(_color$1.g * 255, 0, 255)) * 256 + Math.round(clamp$1(_color$1.b * 255, 0, 255));
  }
  getHexString(colorSpace = SRGBColorSpace) {
    return ("000000" + this.getHex(colorSpace).toString(16)).slice(-6);
  }
  getHSL(target, colorSpace = ColorManagement.workingColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color$1.copy(this), colorSpace);
    const r2 = _color$1.r, g3 = _color$1.g, b = _color$1.b;
    const max2 = Math.max(r2, g3, b);
    const min = Math.min(r2, g3, b);
    let hue, saturation;
    const lightness = (min + max2) / 2;
    if (min === max2) {
      hue = 0;
      saturation = 0;
    } else {
      const delta = max2 - min;
      saturation = lightness <= 0.5 ? delta / (max2 + min) : delta / (2 - max2 - min);
      switch (max2) {
        case r2:
          hue = (g3 - b) / delta + (g3 < b ? 6 : 0);
          break;
        case g3:
          hue = (b - r2) / delta + 2;
          break;
        case b:
          hue = (r2 - g3) / delta + 4;
          break;
      }
      hue /= 6;
    }
    target.h = hue;
    target.s = saturation;
    target.l = lightness;
    return target;
  }
  getRGB(target, colorSpace = ColorManagement.workingColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color$1.copy(this), colorSpace);
    target.r = _color$1.r;
    target.g = _color$1.g;
    target.b = _color$1.b;
    return target;
  }
  getStyle(colorSpace = SRGBColorSpace) {
    ColorManagement.fromWorkingColorSpace(_color$1.copy(this), colorSpace);
    const r2 = _color$1.r, g3 = _color$1.g, b = _color$1.b;
    if (colorSpace !== SRGBColorSpace) {
      return `color(${colorSpace} ${r2.toFixed(3)} ${g3.toFixed(3)} ${b.toFixed(3)})`;
    }
    return `rgb(${Math.round(r2 * 255)},${Math.round(g3 * 255)},${Math.round(b * 255)})`;
  }
  offsetHSL(h2, s2, l2) {
    this.getHSL(_hslA$1);
    return this.setHSL(_hslA$1.h + h2, _hslA$1.s + s2, _hslA$1.l + l2);
  }
  add(color2) {
    this.r += color2.r;
    this.g += color2.g;
    this.b += color2.b;
    return this;
  }
  addColors(color1, color2) {
    this.r = color1.r + color2.r;
    this.g = color1.g + color2.g;
    this.b = color1.b + color2.b;
    return this;
  }
  addScalar(s2) {
    this.r += s2;
    this.g += s2;
    this.b += s2;
    return this;
  }
  sub(color2) {
    this.r = Math.max(0, this.r - color2.r);
    this.g = Math.max(0, this.g - color2.g);
    this.b = Math.max(0, this.b - color2.b);
    return this;
  }
  multiply(color2) {
    this.r *= color2.r;
    this.g *= color2.g;
    this.b *= color2.b;
    return this;
  }
  multiplyScalar(s2) {
    this.r *= s2;
    this.g *= s2;
    this.b *= s2;
    return this;
  }
  lerp(color2, alpha) {
    this.r += (color2.r - this.r) * alpha;
    this.g += (color2.g - this.g) * alpha;
    this.b += (color2.b - this.b) * alpha;
    return this;
  }
  lerpColors(color1, color2, alpha) {
    this.r = color1.r + (color2.r - color1.r) * alpha;
    this.g = color1.g + (color2.g - color1.g) * alpha;
    this.b = color1.b + (color2.b - color1.b) * alpha;
    return this;
  }
  lerpHSL(color2, alpha) {
    this.getHSL(_hslA$1);
    color2.getHSL(_hslB$1);
    const h2 = lerp$2(_hslA$1.h, _hslB$1.h, alpha);
    const s2 = lerp$2(_hslA$1.s, _hslB$1.s, alpha);
    const l2 = lerp$2(_hslA$1.l, _hslB$1.l, alpha);
    this.setHSL(h2, s2, l2);
    return this;
  }
  setFromVector3(v) {
    this.r = v.x;
    this.g = v.y;
    this.b = v.z;
    return this;
  }
  applyMatrix3(m) {
    const r2 = this.r, g3 = this.g, b = this.b;
    const e2 = m.elements;
    this.r = e2[0] * r2 + e2[3] * g3 + e2[6] * b;
    this.g = e2[1] * r2 + e2[4] * g3 + e2[7] * b;
    this.b = e2[2] * r2 + e2[5] * g3 + e2[8] * b;
    return this;
  }
  equals(c2) {
    return c2.r === this.r && c2.g === this.g && c2.b === this.b;
  }
  fromArray(array, offset = 0) {
    this.r = array[offset];
    this.g = array[offset + 1];
    this.b = array[offset + 2];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.r;
    array[offset + 1] = this.g;
    array[offset + 2] = this.b;
    return array;
  }
  fromBufferAttribute(attribute, index2) {
    this.r = attribute.getX(index2);
    this.g = attribute.getY(index2);
    this.b = attribute.getZ(index2);
    return this;
  }
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r;
    yield this.g;
    yield this.b;
  }
};
const _color$1 = /* @__PURE__ */ new Color$1();
Color$1.NAMES = _colorKeywords$1;
let _materialId = 0;
let Material$1 = class Material extends EventDispatcher$1 {
  constructor() {
    super();
    this.isMaterial = true;
    Object.defineProperty(this, "id", { value: _materialId++ });
    this.uuid = generateUUID$1();
    this.name = "";
    this.type = "Material";
    this.blending = NormalBlending$1;
    this.side = FrontSide$1;
    this.vertexColors = false;
    this.opacity = 1;
    this.transparent = false;
    this.alphaHash = false;
    this.blendSrc = SrcAlphaFactor$1;
    this.blendDst = OneMinusSrcAlphaFactor$1;
    this.blendEquation = AddEquation$1;
    this.blendSrcAlpha = null;
    this.blendDstAlpha = null;
    this.blendEquationAlpha = null;
    this.blendColor = new Color$1(0, 0, 0);
    this.blendAlpha = 0;
    this.depthFunc = LessEqualDepth$1;
    this.depthTest = true;
    this.depthWrite = true;
    this.stencilWriteMask = 255;
    this.stencilFunc = AlwaysStencilFunc$1;
    this.stencilRef = 0;
    this.stencilFuncMask = 255;
    this.stencilFail = KeepStencilOp$1;
    this.stencilZFail = KeepStencilOp$1;
    this.stencilZPass = KeepStencilOp$1;
    this.stencilWrite = false;
    this.clippingPlanes = null;
    this.clipIntersection = false;
    this.clipShadows = false;
    this.shadowSide = null;
    this.colorWrite = true;
    this.precision = null;
    this.polygonOffset = false;
    this.polygonOffsetFactor = 0;
    this.polygonOffsetUnits = 0;
    this.dithering = false;
    this.alphaToCoverage = false;
    this.premultipliedAlpha = false;
    this.forceSinglePass = false;
    this.visible = true;
    this.toneMapped = true;
    this.userData = {};
    this.version = 0;
    this._alphaTest = 0;
  }
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(value) {
    if (this._alphaTest > 0 !== value > 0) {
      this.version++;
    }
    this._alphaTest = value;
  }
  // onBeforeRender and onBeforeCompile only supported in WebGLRenderer
  onBeforeRender() {
  }
  onBeforeCompile() {
  }
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  setValues(values) {
    if (values === void 0) return;
    for (const key in values) {
      const newValue = values[key];
      if (newValue === void 0) {
        console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
        continue;
      }
      const currentValue = this[key];
      if (currentValue === void 0) {
        console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
        continue;
      }
      if (currentValue && currentValue.isColor) {
        currentValue.set(newValue);
      } else if (currentValue && currentValue.isVector3 && (newValue && newValue.isVector3)) {
        currentValue.copy(newValue);
      } else {
        this[key] = newValue;
      }
    }
  }
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    if (isRootObject) {
      meta = {
        textures: {},
        images: {}
      };
    }
    const data = {
      metadata: {
        version: 4.6,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    data.uuid = this.uuid;
    data.type = this.type;
    if (this.name !== "") data.name = this.name;
    if (this.color && this.color.isColor) data.color = this.color.getHex();
    if (this.roughness !== void 0) data.roughness = this.roughness;
    if (this.metalness !== void 0) data.metalness = this.metalness;
    if (this.sheen !== void 0) data.sheen = this.sheen;
    if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
    if (this.sheenRoughness !== void 0) data.sheenRoughness = this.sheenRoughness;
    if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
    if (this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
    if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
    if (this.specularIntensity !== void 0) data.specularIntensity = this.specularIntensity;
    if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
    if (this.shininess !== void 0) data.shininess = this.shininess;
    if (this.clearcoat !== void 0) data.clearcoat = this.clearcoat;
    if (this.clearcoatRoughness !== void 0) data.clearcoatRoughness = this.clearcoatRoughness;
    if (this.clearcoatMap && this.clearcoatMap.isTexture) {
      data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
    }
    if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) {
      data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
    }
    if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
      data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
      data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
    }
    if (this.dispersion !== void 0) data.dispersion = this.dispersion;
    if (this.iridescence !== void 0) data.iridescence = this.iridescence;
    if (this.iridescenceIOR !== void 0) data.iridescenceIOR = this.iridescenceIOR;
    if (this.iridescenceThicknessRange !== void 0) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
    if (this.iridescenceMap && this.iridescenceMap.isTexture) {
      data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
    }
    if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) {
      data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
    }
    if (this.anisotropy !== void 0) data.anisotropy = this.anisotropy;
    if (this.anisotropyRotation !== void 0) data.anisotropyRotation = this.anisotropyRotation;
    if (this.anisotropyMap && this.anisotropyMap.isTexture) {
      data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
    }
    if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
    if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
    if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
    if (this.lightMap && this.lightMap.isTexture) {
      data.lightMap = this.lightMap.toJSON(meta).uuid;
      data.lightMapIntensity = this.lightMapIntensity;
    }
    if (this.aoMap && this.aoMap.isTexture) {
      data.aoMap = this.aoMap.toJSON(meta).uuid;
      data.aoMapIntensity = this.aoMapIntensity;
    }
    if (this.bumpMap && this.bumpMap.isTexture) {
      data.bumpMap = this.bumpMap.toJSON(meta).uuid;
      data.bumpScale = this.bumpScale;
    }
    if (this.normalMap && this.normalMap.isTexture) {
      data.normalMap = this.normalMap.toJSON(meta).uuid;
      data.normalMapType = this.normalMapType;
      data.normalScale = this.normalScale.toArray();
    }
    if (this.displacementMap && this.displacementMap.isTexture) {
      data.displacementMap = this.displacementMap.toJSON(meta).uuid;
      data.displacementScale = this.displacementScale;
      data.displacementBias = this.displacementBias;
    }
    if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
    if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
    if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
    if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
    if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
    if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
    if (this.envMap && this.envMap.isTexture) {
      data.envMap = this.envMap.toJSON(meta).uuid;
      if (this.combine !== void 0) data.combine = this.combine;
    }
    if (this.envMapRotation !== void 0) data.envMapRotation = this.envMapRotation.toArray();
    if (this.envMapIntensity !== void 0) data.envMapIntensity = this.envMapIntensity;
    if (this.reflectivity !== void 0) data.reflectivity = this.reflectivity;
    if (this.refractionRatio !== void 0) data.refractionRatio = this.refractionRatio;
    if (this.gradientMap && this.gradientMap.isTexture) {
      data.gradientMap = this.gradientMap.toJSON(meta).uuid;
    }
    if (this.transmission !== void 0) data.transmission = this.transmission;
    if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
    if (this.thickness !== void 0) data.thickness = this.thickness;
    if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
    if (this.attenuationDistance !== void 0 && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
    if (this.attenuationColor !== void 0) data.attenuationColor = this.attenuationColor.getHex();
    if (this.size !== void 0) data.size = this.size;
    if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
    if (this.sizeAttenuation !== void 0) data.sizeAttenuation = this.sizeAttenuation;
    if (this.blending !== NormalBlending$1) data.blending = this.blending;
    if (this.side !== FrontSide$1) data.side = this.side;
    if (this.vertexColors === true) data.vertexColors = true;
    if (this.opacity < 1) data.opacity = this.opacity;
    if (this.transparent === true) data.transparent = true;
    if (this.blendSrc !== SrcAlphaFactor$1) data.blendSrc = this.blendSrc;
    if (this.blendDst !== OneMinusSrcAlphaFactor$1) data.blendDst = this.blendDst;
    if (this.blendEquation !== AddEquation$1) data.blendEquation = this.blendEquation;
    if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
    if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
    if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
    if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
    if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
    if (this.depthFunc !== LessEqualDepth$1) data.depthFunc = this.depthFunc;
    if (this.depthTest === false) data.depthTest = this.depthTest;
    if (this.depthWrite === false) data.depthWrite = this.depthWrite;
    if (this.colorWrite === false) data.colorWrite = this.colorWrite;
    if (this.stencilWriteMask !== 255) data.stencilWriteMask = this.stencilWriteMask;
    if (this.stencilFunc !== AlwaysStencilFunc$1) data.stencilFunc = this.stencilFunc;
    if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
    if (this.stencilFuncMask !== 255) data.stencilFuncMask = this.stencilFuncMask;
    if (this.stencilFail !== KeepStencilOp$1) data.stencilFail = this.stencilFail;
    if (this.stencilZFail !== KeepStencilOp$1) data.stencilZFail = this.stencilZFail;
    if (this.stencilZPass !== KeepStencilOp$1) data.stencilZPass = this.stencilZPass;
    if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
    if (this.rotation !== void 0 && this.rotation !== 0) data.rotation = this.rotation;
    if (this.polygonOffset === true) data.polygonOffset = true;
    if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
    if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
    if (this.linewidth !== void 0 && this.linewidth !== 1) data.linewidth = this.linewidth;
    if (this.dashSize !== void 0) data.dashSize = this.dashSize;
    if (this.gapSize !== void 0) data.gapSize = this.gapSize;
    if (this.scale !== void 0) data.scale = this.scale;
    if (this.dithering === true) data.dithering = true;
    if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
    if (this.alphaHash === true) data.alphaHash = true;
    if (this.alphaToCoverage === true) data.alphaToCoverage = true;
    if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
    if (this.forceSinglePass === true) data.forceSinglePass = true;
    if (this.wireframe === true) data.wireframe = true;
    if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
    if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
    if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
    if (this.flatShading === true) data.flatShading = true;
    if (this.visible === false) data.visible = false;
    if (this.toneMapped === false) data.toneMapped = false;
    if (this.fog === false) data.fog = false;
    if (Object.keys(this.userData).length > 0) data.userData = this.userData;
    function extractFromCache(cache) {
      const values = [];
      for (const key in cache) {
        const data2 = cache[key];
        delete data2.metadata;
        values.push(data2);
      }
      return values;
    }
    if (isRootObject) {
      const textures = extractFromCache(meta.textures);
      const images = extractFromCache(meta.images);
      if (textures.length > 0) data.textures = textures;
      if (images.length > 0) data.images = images;
    }
    return data;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.name = source.name;
    this.blending = source.blending;
    this.side = source.side;
    this.vertexColors = source.vertexColors;
    this.opacity = source.opacity;
    this.transparent = source.transparent;
    this.blendSrc = source.blendSrc;
    this.blendDst = source.blendDst;
    this.blendEquation = source.blendEquation;
    this.blendSrcAlpha = source.blendSrcAlpha;
    this.blendDstAlpha = source.blendDstAlpha;
    this.blendEquationAlpha = source.blendEquationAlpha;
    this.blendColor.copy(source.blendColor);
    this.blendAlpha = source.blendAlpha;
    this.depthFunc = source.depthFunc;
    this.depthTest = source.depthTest;
    this.depthWrite = source.depthWrite;
    this.stencilWriteMask = source.stencilWriteMask;
    this.stencilFunc = source.stencilFunc;
    this.stencilRef = source.stencilRef;
    this.stencilFuncMask = source.stencilFuncMask;
    this.stencilFail = source.stencilFail;
    this.stencilZFail = source.stencilZFail;
    this.stencilZPass = source.stencilZPass;
    this.stencilWrite = source.stencilWrite;
    const srcPlanes = source.clippingPlanes;
    let dstPlanes = null;
    if (srcPlanes !== null) {
      const n2 = srcPlanes.length;
      dstPlanes = new Array(n2);
      for (let i2 = 0; i2 !== n2; ++i2) {
        dstPlanes[i2] = srcPlanes[i2].clone();
      }
    }
    this.clippingPlanes = dstPlanes;
    this.clipIntersection = source.clipIntersection;
    this.clipShadows = source.clipShadows;
    this.shadowSide = source.shadowSide;
    this.colorWrite = source.colorWrite;
    this.precision = source.precision;
    this.polygonOffset = source.polygonOffset;
    this.polygonOffsetFactor = source.polygonOffsetFactor;
    this.polygonOffsetUnits = source.polygonOffsetUnits;
    this.dithering = source.dithering;
    this.alphaTest = source.alphaTest;
    this.alphaHash = source.alphaHash;
    this.alphaToCoverage = source.alphaToCoverage;
    this.premultipliedAlpha = source.premultipliedAlpha;
    this.forceSinglePass = source.forceSinglePass;
    this.visible = source.visible;
    this.toneMapped = source.toneMapped;
    this.userData = JSON.parse(JSON.stringify(source.userData));
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
  onBuild() {
    console.warn("Material: onBuild() has been removed.");
  }
};
let MeshBasicMaterial$1 = class MeshBasicMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isMeshBasicMaterial = true;
    this.type = "MeshBasicMaterial";
    this.color = new Color$1(16777215);
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapRotation = new Euler$1();
    this.combine = MultiplyOperation$1;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.envMapRotation.copy(source.envMapRotation);
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.fog = source.fog;
    return this;
  }
};
const _tables = /* @__PURE__ */ _generateTables();
function _generateTables() {
  const buffer = new ArrayBuffer(4);
  const floatView = new Float32Array(buffer);
  const uint32View = new Uint32Array(buffer);
  const baseTable = new Uint32Array(512);
  const shiftTable = new Uint32Array(512);
  for (let i2 = 0; i2 < 256; ++i2) {
    const e2 = i2 - 127;
    if (e2 < -27) {
      baseTable[i2] = 0;
      baseTable[i2 | 256] = 32768;
      shiftTable[i2] = 24;
      shiftTable[i2 | 256] = 24;
    } else if (e2 < -14) {
      baseTable[i2] = 1024 >> -e2 - 14;
      baseTable[i2 | 256] = 1024 >> -e2 - 14 | 32768;
      shiftTable[i2] = -e2 - 1;
      shiftTable[i2 | 256] = -e2 - 1;
    } else if (e2 <= 15) {
      baseTable[i2] = e2 + 15 << 10;
      baseTable[i2 | 256] = e2 + 15 << 10 | 32768;
      shiftTable[i2] = 13;
      shiftTable[i2 | 256] = 13;
    } else if (e2 < 128) {
      baseTable[i2] = 31744;
      baseTable[i2 | 256] = 64512;
      shiftTable[i2] = 24;
      shiftTable[i2 | 256] = 24;
    } else {
      baseTable[i2] = 31744;
      baseTable[i2 | 256] = 64512;
      shiftTable[i2] = 13;
      shiftTable[i2 | 256] = 13;
    }
  }
  const mantissaTable = new Uint32Array(2048);
  const exponentTable = new Uint32Array(64);
  const offsetTable = new Uint32Array(64);
  for (let i2 = 1; i2 < 1024; ++i2) {
    let m = i2 << 13;
    let e2 = 0;
    while ((m & 8388608) === 0) {
      m <<= 1;
      e2 -= 8388608;
    }
    m &= -8388609;
    e2 += 947912704;
    mantissaTable[i2] = m | e2;
  }
  for (let i2 = 1024; i2 < 2048; ++i2) {
    mantissaTable[i2] = 939524096 + (i2 - 1024 << 13);
  }
  for (let i2 = 1; i2 < 31; ++i2) {
    exponentTable[i2] = i2 << 23;
  }
  exponentTable[31] = 1199570944;
  exponentTable[32] = 2147483648;
  for (let i2 = 33; i2 < 63; ++i2) {
    exponentTable[i2] = 2147483648 + (i2 - 32 << 23);
  }
  exponentTable[63] = 3347054592;
  for (let i2 = 1; i2 < 64; ++i2) {
    if (i2 !== 32) {
      offsetTable[i2] = 1024;
    }
  }
  return {
    floatView,
    uint32View,
    baseTable,
    shiftTable,
    mantissaTable,
    exponentTable,
    offsetTable
  };
}
function toHalfFloat(val) {
  if (Math.abs(val) > 65504) console.warn("THREE.DataUtils.toHalfFloat(): Value out of range.");
  val = clamp$1(val, -65504, 65504);
  _tables.floatView[0] = val;
  const f2 = _tables.uint32View[0];
  const e2 = f2 >> 23 & 511;
  return _tables.baseTable[e2] + ((f2 & 8388607) >> _tables.shiftTable[e2]);
}
function fromHalfFloat(val) {
  const m = val >> 10;
  _tables.uint32View[0] = _tables.mantissaTable[_tables.offsetTable[m] + (val & 1023)] + _tables.exponentTable[m];
  return _tables.floatView[0];
}
const DataUtils = {
  toHalfFloat,
  fromHalfFloat
};
const _vector$9$1 = /* @__PURE__ */ new Vector3$1();
const _vector2$1$1 = /* @__PURE__ */ new Vector2$1();
let BufferAttribute$1 = class BufferAttribute {
  constructor(array, itemSize, normalized = false) {
    if (Array.isArray(array)) {
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    }
    this.isBufferAttribute = true;
    this.name = "";
    this.array = array;
    this.itemSize = itemSize;
    this.count = array !== void 0 ? array.length / itemSize : 0;
    this.normalized = normalized;
    this.usage = StaticDrawUsage$1;
    this.updateRanges = [];
    this.gpuType = FloatType$1;
    this.version = 0;
  }
  onUploadCallback() {
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
  setUsage(value) {
    this.usage = value;
    return this;
  }
  addUpdateRange(start, count) {
    this.updateRanges.push({ start, count });
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  copy(source) {
    this.name = source.name;
    this.array = new source.array.constructor(source.array);
    this.itemSize = source.itemSize;
    this.count = source.count;
    this.normalized = source.normalized;
    this.usage = source.usage;
    this.gpuType = source.gpuType;
    return this;
  }
  copyAt(index1, attribute, index2) {
    index1 *= this.itemSize;
    index2 *= attribute.itemSize;
    for (let i2 = 0, l2 = this.itemSize; i2 < l2; i2++) {
      this.array[index1 + i2] = attribute.array[index2 + i2];
    }
    return this;
  }
  copyArray(array) {
    this.array.set(array);
    return this;
  }
  applyMatrix3(m) {
    if (this.itemSize === 2) {
      for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
        _vector2$1$1.fromBufferAttribute(this, i2);
        _vector2$1$1.applyMatrix3(m);
        this.setXY(i2, _vector2$1$1.x, _vector2$1$1.y);
      }
    } else if (this.itemSize === 3) {
      for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
        _vector$9$1.fromBufferAttribute(this, i2);
        _vector$9$1.applyMatrix3(m);
        this.setXYZ(i2, _vector$9$1.x, _vector$9$1.y, _vector$9$1.z);
      }
    }
    return this;
  }
  applyMatrix4(m) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$9$1.fromBufferAttribute(this, i2);
      _vector$9$1.applyMatrix4(m);
      this.setXYZ(i2, _vector$9$1.x, _vector$9$1.y, _vector$9$1.z);
    }
    return this;
  }
  applyNormalMatrix(m) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$9$1.fromBufferAttribute(this, i2);
      _vector$9$1.applyNormalMatrix(m);
      this.setXYZ(i2, _vector$9$1.x, _vector$9$1.y, _vector$9$1.z);
    }
    return this;
  }
  transformDirection(m) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$9$1.fromBufferAttribute(this, i2);
      _vector$9$1.transformDirection(m);
      this.setXYZ(i2, _vector$9$1.x, _vector$9$1.y, _vector$9$1.z);
    }
    return this;
  }
  set(value, offset = 0) {
    this.array.set(value, offset);
    return this;
  }
  getComponent(index2, component) {
    let value = this.array[index2 * this.itemSize + component];
    if (this.normalized) value = denormalize(value, this.array);
    return value;
  }
  setComponent(index2, component, value) {
    if (this.normalized) value = normalize(value, this.array);
    this.array[index2 * this.itemSize + component] = value;
    return this;
  }
  getX(index2) {
    let x = this.array[index2 * this.itemSize];
    if (this.normalized) x = denormalize(x, this.array);
    return x;
  }
  setX(index2, x) {
    if (this.normalized) x = normalize(x, this.array);
    this.array[index2 * this.itemSize] = x;
    return this;
  }
  getY(index2) {
    let y = this.array[index2 * this.itemSize + 1];
    if (this.normalized) y = denormalize(y, this.array);
    return y;
  }
  setY(index2, y) {
    if (this.normalized) y = normalize(y, this.array);
    this.array[index2 * this.itemSize + 1] = y;
    return this;
  }
  getZ(index2) {
    let z2 = this.array[index2 * this.itemSize + 2];
    if (this.normalized) z2 = denormalize(z2, this.array);
    return z2;
  }
  setZ(index2, z2) {
    if (this.normalized) z2 = normalize(z2, this.array);
    this.array[index2 * this.itemSize + 2] = z2;
    return this;
  }
  getW(index2) {
    let w = this.array[index2 * this.itemSize + 3];
    if (this.normalized) w = denormalize(w, this.array);
    return w;
  }
  setW(index2, w) {
    if (this.normalized) w = normalize(w, this.array);
    this.array[index2 * this.itemSize + 3] = w;
    return this;
  }
  setXY(index2, x, y) {
    index2 *= this.itemSize;
    if (this.normalized) {
      x = normalize(x, this.array);
      y = normalize(y, this.array);
    }
    this.array[index2 + 0] = x;
    this.array[index2 + 1] = y;
    return this;
  }
  setXYZ(index2, x, y, z2) {
    index2 *= this.itemSize;
    if (this.normalized) {
      x = normalize(x, this.array);
      y = normalize(y, this.array);
      z2 = normalize(z2, this.array);
    }
    this.array[index2 + 0] = x;
    this.array[index2 + 1] = y;
    this.array[index2 + 2] = z2;
    return this;
  }
  setXYZW(index2, x, y, z2, w) {
    index2 *= this.itemSize;
    if (this.normalized) {
      x = normalize(x, this.array);
      y = normalize(y, this.array);
      z2 = normalize(z2, this.array);
      w = normalize(w, this.array);
    }
    this.array[index2 + 0] = x;
    this.array[index2 + 1] = y;
    this.array[index2 + 2] = z2;
    this.array[index2 + 3] = w;
    return this;
  }
  onUpload(callback) {
    this.onUploadCallback = callback;
    return this;
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  toJSON() {
    const data = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
    if (this.name !== "") data.name = this.name;
    if (this.usage !== StaticDrawUsage$1) data.usage = this.usage;
    return data;
  }
};
class Int8BufferAttribute extends BufferAttribute$1 {
  constructor(array, itemSize, normalized) {
    super(new Int8Array(array), itemSize, normalized);
  }
}
class Uint8BufferAttribute extends BufferAttribute$1 {
  constructor(array, itemSize, normalized) {
    super(new Uint8Array(array), itemSize, normalized);
  }
}
class Uint8ClampedBufferAttribute extends BufferAttribute$1 {
  constructor(array, itemSize, normalized) {
    super(new Uint8ClampedArray(array), itemSize, normalized);
  }
}
class Int16BufferAttribute extends BufferAttribute$1 {
  constructor(array, itemSize, normalized) {
    super(new Int16Array(array), itemSize, normalized);
  }
}
let Uint16BufferAttribute$1 = class Uint16BufferAttribute extends BufferAttribute$1 {
  constructor(array, itemSize, normalized) {
    super(new Uint16Array(array), itemSize, normalized);
  }
};
class Int32BufferAttribute extends BufferAttribute$1 {
  constructor(array, itemSize, normalized) {
    super(new Int32Array(array), itemSize, normalized);
  }
}
let Uint32BufferAttribute$1 = class Uint32BufferAttribute extends BufferAttribute$1 {
  constructor(array, itemSize, normalized) {
    super(new Uint32Array(array), itemSize, normalized);
  }
};
let Float16BufferAttribute$1 = class Float16BufferAttribute extends BufferAttribute$1 {
  constructor(array, itemSize, normalized) {
    super(new Uint16Array(array), itemSize, normalized);
    this.isFloat16BufferAttribute = true;
  }
  getX(index2) {
    let x = fromHalfFloat(this.array[index2 * this.itemSize]);
    if (this.normalized) x = denormalize(x, this.array);
    return x;
  }
  setX(index2, x) {
    if (this.normalized) x = normalize(x, this.array);
    this.array[index2 * this.itemSize] = toHalfFloat(x);
    return this;
  }
  getY(index2) {
    let y = fromHalfFloat(this.array[index2 * this.itemSize + 1]);
    if (this.normalized) y = denormalize(y, this.array);
    return y;
  }
  setY(index2, y) {
    if (this.normalized) y = normalize(y, this.array);
    this.array[index2 * this.itemSize + 1] = toHalfFloat(y);
    return this;
  }
  getZ(index2) {
    let z2 = fromHalfFloat(this.array[index2 * this.itemSize + 2]);
    if (this.normalized) z2 = denormalize(z2, this.array);
    return z2;
  }
  setZ(index2, z2) {
    if (this.normalized) z2 = normalize(z2, this.array);
    this.array[index2 * this.itemSize + 2] = toHalfFloat(z2);
    return this;
  }
  getW(index2) {
    let w = fromHalfFloat(this.array[index2 * this.itemSize + 3]);
    if (this.normalized) w = denormalize(w, this.array);
    return w;
  }
  setW(index2, w) {
    if (this.normalized) w = normalize(w, this.array);
    this.array[index2 * this.itemSize + 3] = toHalfFloat(w);
    return this;
  }
  setXY(index2, x, y) {
    index2 *= this.itemSize;
    if (this.normalized) {
      x = normalize(x, this.array);
      y = normalize(y, this.array);
    }
    this.array[index2 + 0] = toHalfFloat(x);
    this.array[index2 + 1] = toHalfFloat(y);
    return this;
  }
  setXYZ(index2, x, y, z2) {
    index2 *= this.itemSize;
    if (this.normalized) {
      x = normalize(x, this.array);
      y = normalize(y, this.array);
      z2 = normalize(z2, this.array);
    }
    this.array[index2 + 0] = toHalfFloat(x);
    this.array[index2 + 1] = toHalfFloat(y);
    this.array[index2 + 2] = toHalfFloat(z2);
    return this;
  }
  setXYZW(index2, x, y, z2, w) {
    index2 *= this.itemSize;
    if (this.normalized) {
      x = normalize(x, this.array);
      y = normalize(y, this.array);
      z2 = normalize(z2, this.array);
      w = normalize(w, this.array);
    }
    this.array[index2 + 0] = toHalfFloat(x);
    this.array[index2 + 1] = toHalfFloat(y);
    this.array[index2 + 2] = toHalfFloat(z2);
    this.array[index2 + 3] = toHalfFloat(w);
    return this;
  }
};
let Float32BufferAttribute$1 = class Float32BufferAttribute extends BufferAttribute$1 {
  constructor(array, itemSize, normalized) {
    super(new Float32Array(array), itemSize, normalized);
  }
};
let _id$1$1 = 0;
const _m1$4 = /* @__PURE__ */ new Matrix4$1();
const _obj$1 = /* @__PURE__ */ new Object3D$1();
const _offset$1 = /* @__PURE__ */ new Vector3$1();
const _box$2$1 = /* @__PURE__ */ new Box3$1();
const _boxMorphTargets$1 = /* @__PURE__ */ new Box3$1();
const _vector$8$1 = /* @__PURE__ */ new Vector3$1();
let BufferGeometry$1 = class BufferGeometry extends EventDispatcher$1 {
  constructor() {
    super();
    this.isBufferGeometry = true;
    Object.defineProperty(this, "id", { value: _id$1$1++ });
    this.uuid = generateUUID$1();
    this.name = "";
    this.type = "BufferGeometry";
    this.index = null;
    this.indirect = null;
    this.attributes = {};
    this.morphAttributes = {};
    this.morphTargetsRelative = false;
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    this.drawRange = { start: 0, count: Infinity };
    this.userData = {};
  }
  getIndex() {
    return this.index;
  }
  setIndex(index2) {
    if (Array.isArray(index2)) {
      this.index = new (arrayNeedsUint32(index2) ? Uint32BufferAttribute$1 : Uint16BufferAttribute$1)(index2, 1);
    } else {
      this.index = index2;
    }
    return this;
  }
  setIndirect(indirect) {
    this.indirect = indirect;
    return this;
  }
  getIndirect() {
    return this.indirect;
  }
  getAttribute(name) {
    return this.attributes[name];
  }
  setAttribute(name, attribute) {
    this.attributes[name] = attribute;
    return this;
  }
  deleteAttribute(name) {
    delete this.attributes[name];
    return this;
  }
  hasAttribute(name) {
    return this.attributes[name] !== void 0;
  }
  addGroup(start, count, materialIndex = 0) {
    this.groups.push({
      start,
      count,
      materialIndex
    });
  }
  clearGroups() {
    this.groups = [];
  }
  setDrawRange(start, count) {
    this.drawRange.start = start;
    this.drawRange.count = count;
  }
  applyMatrix4(matrix2) {
    const position2 = this.attributes.position;
    if (position2 !== void 0) {
      position2.applyMatrix4(matrix2);
      position2.needsUpdate = true;
    }
    const normal = this.attributes.normal;
    if (normal !== void 0) {
      const normalMatrix = new Matrix3$1().getNormalMatrix(matrix2);
      normal.applyNormalMatrix(normalMatrix);
      normal.needsUpdate = true;
    }
    const tangent = this.attributes.tangent;
    if (tangent !== void 0) {
      tangent.transformDirection(matrix2);
      tangent.needsUpdate = true;
    }
    if (this.boundingBox !== null) {
      this.computeBoundingBox();
    }
    if (this.boundingSphere !== null) {
      this.computeBoundingSphere();
    }
    return this;
  }
  applyQuaternion(q) {
    _m1$4.makeRotationFromQuaternion(q);
    this.applyMatrix4(_m1$4);
    return this;
  }
  rotateX(angle2) {
    _m1$4.makeRotationX(angle2);
    this.applyMatrix4(_m1$4);
    return this;
  }
  rotateY(angle2) {
    _m1$4.makeRotationY(angle2);
    this.applyMatrix4(_m1$4);
    return this;
  }
  rotateZ(angle2) {
    _m1$4.makeRotationZ(angle2);
    this.applyMatrix4(_m1$4);
    return this;
  }
  translate(x, y, z2) {
    _m1$4.makeTranslation(x, y, z2);
    this.applyMatrix4(_m1$4);
    return this;
  }
  scale(x, y, z2) {
    _m1$4.makeScale(x, y, z2);
    this.applyMatrix4(_m1$4);
    return this;
  }
  lookAt(vector) {
    _obj$1.lookAt(vector);
    _obj$1.updateMatrix();
    this.applyMatrix4(_obj$1.matrix);
    return this;
  }
  center() {
    this.computeBoundingBox();
    this.boundingBox.getCenter(_offset$1).negate();
    this.translate(_offset$1.x, _offset$1.y, _offset$1.z);
    return this;
  }
  setFromPoints(points) {
    const positionAttribute = this.getAttribute("position");
    if (positionAttribute === void 0) {
      const position2 = [];
      for (let i2 = 0, l2 = points.length; i2 < l2; i2++) {
        const point2 = points[i2];
        position2.push(point2.x, point2.y, point2.z || 0);
      }
      this.setAttribute("position", new Float32BufferAttribute$1(position2, 3));
    } else {
      const l2 = Math.min(points.length, positionAttribute.count);
      for (let i2 = 0; i2 < l2; i2++) {
        const point2 = points[i2];
        positionAttribute.setXYZ(i2, point2.x, point2.y, point2.z || 0);
      }
      if (points.length > positionAttribute.count) {
        console.warn("THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.");
      }
      positionAttribute.needsUpdate = true;
    }
    return this;
  }
  computeBoundingBox() {
    if (this.boundingBox === null) {
      this.boundingBox = new Box3$1();
    }
    const position2 = this.attributes.position;
    const morphAttributesPosition = this.morphAttributes.position;
    if (position2 && position2.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this);
      this.boundingBox.set(
        new Vector3$1(-Infinity, -Infinity, -Infinity),
        new Vector3$1(Infinity, Infinity, Infinity)
      );
      return;
    }
    if (position2 !== void 0) {
      this.boundingBox.setFromBufferAttribute(position2);
      if (morphAttributesPosition) {
        for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
          const morphAttribute = morphAttributesPosition[i2];
          _box$2$1.setFromBufferAttribute(morphAttribute);
          if (this.morphTargetsRelative) {
            _vector$8$1.addVectors(this.boundingBox.min, _box$2$1.min);
            this.boundingBox.expandByPoint(_vector$8$1);
            _vector$8$1.addVectors(this.boundingBox.max, _box$2$1.max);
            this.boundingBox.expandByPoint(_vector$8$1);
          } else {
            this.boundingBox.expandByPoint(_box$2$1.min);
            this.boundingBox.expandByPoint(_box$2$1.max);
          }
        }
      }
    } else {
      this.boundingBox.makeEmpty();
    }
    if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) {
      console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
  }
  computeBoundingSphere() {
    if (this.boundingSphere === null) {
      this.boundingSphere = new Sphere$1();
    }
    const position2 = this.attributes.position;
    const morphAttributesPosition = this.morphAttributes.position;
    if (position2 && position2.isGLBufferAttribute) {
      console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this);
      this.boundingSphere.set(new Vector3$1(), Infinity);
      return;
    }
    if (position2) {
      const center = this.boundingSphere.center;
      _box$2$1.setFromBufferAttribute(position2);
      if (morphAttributesPosition) {
        for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
          const morphAttribute = morphAttributesPosition[i2];
          _boxMorphTargets$1.setFromBufferAttribute(morphAttribute);
          if (this.morphTargetsRelative) {
            _vector$8$1.addVectors(_box$2$1.min, _boxMorphTargets$1.min);
            _box$2$1.expandByPoint(_vector$8$1);
            _vector$8$1.addVectors(_box$2$1.max, _boxMorphTargets$1.max);
            _box$2$1.expandByPoint(_vector$8$1);
          } else {
            _box$2$1.expandByPoint(_boxMorphTargets$1.min);
            _box$2$1.expandByPoint(_boxMorphTargets$1.max);
          }
        }
      }
      _box$2$1.getCenter(center);
      let maxRadiusSq = 0;
      for (let i2 = 0, il = position2.count; i2 < il; i2++) {
        _vector$8$1.fromBufferAttribute(position2, i2);
        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8$1));
      }
      if (morphAttributesPosition) {
        for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
          const morphAttribute = morphAttributesPosition[i2];
          const morphTargetsRelative = this.morphTargetsRelative;
          for (let j = 0, jl = morphAttribute.count; j < jl; j++) {
            _vector$8$1.fromBufferAttribute(morphAttribute, j);
            if (morphTargetsRelative) {
              _offset$1.fromBufferAttribute(position2, j);
              _vector$8$1.add(_offset$1);
            }
            maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8$1));
          }
        }
      }
      this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
      if (isNaN(this.boundingSphere.radius)) {
        console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
      }
    }
  }
  computeTangents() {
    const index2 = this.index;
    const attributes = this.attributes;
    if (index2 === null || attributes.position === void 0 || attributes.normal === void 0 || attributes.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const positionAttribute = attributes.position;
    const normalAttribute = attributes.normal;
    const uvAttribute = attributes.uv;
    if (this.hasAttribute("tangent") === false) {
      this.setAttribute("tangent", new BufferAttribute$1(new Float32Array(4 * positionAttribute.count), 4));
    }
    const tangentAttribute = this.getAttribute("tangent");
    const tan1 = [], tan2 = [];
    for (let i2 = 0; i2 < positionAttribute.count; i2++) {
      tan1[i2] = new Vector3$1();
      tan2[i2] = new Vector3$1();
    }
    const vA = new Vector3$1(), vB = new Vector3$1(), vC = new Vector3$1(), uvA = new Vector2$1(), uvB = new Vector2$1(), uvC = new Vector2$1(), sdir = new Vector3$1(), tdir = new Vector3$1();
    function handleTriangle(a3, b, c2) {
      vA.fromBufferAttribute(positionAttribute, a3);
      vB.fromBufferAttribute(positionAttribute, b);
      vC.fromBufferAttribute(positionAttribute, c2);
      uvA.fromBufferAttribute(uvAttribute, a3);
      uvB.fromBufferAttribute(uvAttribute, b);
      uvC.fromBufferAttribute(uvAttribute, c2);
      vB.sub(vA);
      vC.sub(vA);
      uvB.sub(uvA);
      uvC.sub(uvA);
      const r2 = 1 / (uvB.x * uvC.y - uvC.x * uvB.y);
      if (!isFinite(r2)) return;
      sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r2);
      tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r2);
      tan1[a3].add(sdir);
      tan1[b].add(sdir);
      tan1[c2].add(sdir);
      tan2[a3].add(tdir);
      tan2[b].add(tdir);
      tan2[c2].add(tdir);
    }
    let groups = this.groups;
    if (groups.length === 0) {
      groups = [{
        start: 0,
        count: index2.count
      }];
    }
    for (let i2 = 0, il = groups.length; i2 < il; ++i2) {
      const group = groups[i2];
      const start = group.start;
      const count = group.count;
      for (let j = start, jl = start + count; j < jl; j += 3) {
        handleTriangle(
          index2.getX(j + 0),
          index2.getX(j + 1),
          index2.getX(j + 2)
        );
      }
    }
    const tmp2 = new Vector3$1(), tmp22 = new Vector3$1();
    const n2 = new Vector3$1(), n22 = new Vector3$1();
    function handleVertex(v) {
      n2.fromBufferAttribute(normalAttribute, v);
      n22.copy(n2);
      const t3 = tan1[v];
      tmp2.copy(t3);
      tmp2.sub(n2.multiplyScalar(n2.dot(t3))).normalize();
      tmp22.crossVectors(n22, t3);
      const test = tmp22.dot(tan2[v]);
      const w = test < 0 ? -1 : 1;
      tangentAttribute.setXYZW(v, tmp2.x, tmp2.y, tmp2.z, w);
    }
    for (let i2 = 0, il = groups.length; i2 < il; ++i2) {
      const group = groups[i2];
      const start = group.start;
      const count = group.count;
      for (let j = start, jl = start + count; j < jl; j += 3) {
        handleVertex(index2.getX(j + 0));
        handleVertex(index2.getX(j + 1));
        handleVertex(index2.getX(j + 2));
      }
    }
  }
  computeVertexNormals() {
    const index2 = this.index;
    const positionAttribute = this.getAttribute("position");
    if (positionAttribute !== void 0) {
      let normalAttribute = this.getAttribute("normal");
      if (normalAttribute === void 0) {
        normalAttribute = new BufferAttribute$1(new Float32Array(positionAttribute.count * 3), 3);
        this.setAttribute("normal", normalAttribute);
      } else {
        for (let i2 = 0, il = normalAttribute.count; i2 < il; i2++) {
          normalAttribute.setXYZ(i2, 0, 0, 0);
        }
      }
      const pA = new Vector3$1(), pB = new Vector3$1(), pC = new Vector3$1();
      const nA = new Vector3$1(), nB = new Vector3$1(), nC = new Vector3$1();
      const cb = new Vector3$1(), ab = new Vector3$1();
      if (index2) {
        for (let i2 = 0, il = index2.count; i2 < il; i2 += 3) {
          const vA = index2.getX(i2 + 0);
          const vB = index2.getX(i2 + 1);
          const vC = index2.getX(i2 + 2);
          pA.fromBufferAttribute(positionAttribute, vA);
          pB.fromBufferAttribute(positionAttribute, vB);
          pC.fromBufferAttribute(positionAttribute, vC);
          cb.subVectors(pC, pB);
          ab.subVectors(pA, pB);
          cb.cross(ab);
          nA.fromBufferAttribute(normalAttribute, vA);
          nB.fromBufferAttribute(normalAttribute, vB);
          nC.fromBufferAttribute(normalAttribute, vC);
          nA.add(cb);
          nB.add(cb);
          nC.add(cb);
          normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
          normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
          normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
        }
      } else {
        for (let i2 = 0, il = positionAttribute.count; i2 < il; i2 += 3) {
          pA.fromBufferAttribute(positionAttribute, i2 + 0);
          pB.fromBufferAttribute(positionAttribute, i2 + 1);
          pC.fromBufferAttribute(positionAttribute, i2 + 2);
          cb.subVectors(pC, pB);
          ab.subVectors(pA, pB);
          cb.cross(ab);
          normalAttribute.setXYZ(i2 + 0, cb.x, cb.y, cb.z);
          normalAttribute.setXYZ(i2 + 1, cb.x, cb.y, cb.z);
          normalAttribute.setXYZ(i2 + 2, cb.x, cb.y, cb.z);
        }
      }
      this.normalizeNormals();
      normalAttribute.needsUpdate = true;
    }
  }
  normalizeNormals() {
    const normals = this.attributes.normal;
    for (let i2 = 0, il = normals.count; i2 < il; i2++) {
      _vector$8$1.fromBufferAttribute(normals, i2);
      _vector$8$1.normalize();
      normals.setXYZ(i2, _vector$8$1.x, _vector$8$1.y, _vector$8$1.z);
    }
  }
  toNonIndexed() {
    function convertBufferAttribute(attribute, indices2) {
      const array = attribute.array;
      const itemSize = attribute.itemSize;
      const normalized = attribute.normalized;
      const array2 = new array.constructor(indices2.length * itemSize);
      let index2 = 0, index22 = 0;
      for (let i2 = 0, l2 = indices2.length; i2 < l2; i2++) {
        if (attribute.isInterleavedBufferAttribute) {
          index2 = indices2[i2] * attribute.data.stride + attribute.offset;
        } else {
          index2 = indices2[i2] * itemSize;
        }
        for (let j = 0; j < itemSize; j++) {
          array2[index22++] = array[index2++];
        }
      }
      return new BufferAttribute$1(array2, itemSize, normalized);
    }
    if (this.index === null) {
      console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
      return this;
    }
    const geometry2 = new BufferGeometry();
    const indices = this.index.array;
    const attributes = this.attributes;
    for (const name in attributes) {
      const attribute = attributes[name];
      const newAttribute = convertBufferAttribute(attribute, indices);
      geometry2.setAttribute(name, newAttribute);
    }
    const morphAttributes = this.morphAttributes;
    for (const name in morphAttributes) {
      const morphArray = [];
      const morphAttribute = morphAttributes[name];
      for (let i2 = 0, il = morphAttribute.length; i2 < il; i2++) {
        const attribute = morphAttribute[i2];
        const newAttribute = convertBufferAttribute(attribute, indices);
        morphArray.push(newAttribute);
      }
      geometry2.morphAttributes[name] = morphArray;
    }
    geometry2.morphTargetsRelative = this.morphTargetsRelative;
    const groups = this.groups;
    for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
      const group = groups[i2];
      geometry2.addGroup(group.start, group.count, group.materialIndex);
    }
    return geometry2;
  }
  toJSON() {
    const data = {
      metadata: {
        version: 4.6,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    data.uuid = this.uuid;
    data.type = this.type;
    if (this.name !== "") data.name = this.name;
    if (Object.keys(this.userData).length > 0) data.userData = this.userData;
    if (this.parameters !== void 0) {
      const parameters = this.parameters;
      for (const key in parameters) {
        if (parameters[key] !== void 0) data[key] = parameters[key];
      }
      return data;
    }
    data.data = { attributes: {} };
    const index2 = this.index;
    if (index2 !== null) {
      data.data.index = {
        type: index2.array.constructor.name,
        array: Array.prototype.slice.call(index2.array)
      };
    }
    const attributes = this.attributes;
    for (const key in attributes) {
      const attribute = attributes[key];
      data.data.attributes[key] = attribute.toJSON(data.data);
    }
    const morphAttributes = {};
    let hasMorphAttributes = false;
    for (const key in this.morphAttributes) {
      const attributeArray = this.morphAttributes[key];
      const array = [];
      for (let i2 = 0, il = attributeArray.length; i2 < il; i2++) {
        const attribute = attributeArray[i2];
        array.push(attribute.toJSON(data.data));
      }
      if (array.length > 0) {
        morphAttributes[key] = array;
        hasMorphAttributes = true;
      }
    }
    if (hasMorphAttributes) {
      data.data.morphAttributes = morphAttributes;
      data.data.morphTargetsRelative = this.morphTargetsRelative;
    }
    const groups = this.groups;
    if (groups.length > 0) {
      data.data.groups = JSON.parse(JSON.stringify(groups));
    }
    const boundingSphere = this.boundingSphere;
    if (boundingSphere !== null) {
      data.data.boundingSphere = {
        center: boundingSphere.center.toArray(),
        radius: boundingSphere.radius
      };
    }
    return data;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.index = null;
    this.attributes = {};
    this.morphAttributes = {};
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    const data = {};
    this.name = source.name;
    const index2 = source.index;
    if (index2 !== null) {
      this.setIndex(index2.clone(data));
    }
    const attributes = source.attributes;
    for (const name in attributes) {
      const attribute = attributes[name];
      this.setAttribute(name, attribute.clone(data));
    }
    const morphAttributes = source.morphAttributes;
    for (const name in morphAttributes) {
      const array = [];
      const morphAttribute = morphAttributes[name];
      for (let i2 = 0, l2 = morphAttribute.length; i2 < l2; i2++) {
        array.push(morphAttribute[i2].clone(data));
      }
      this.morphAttributes[name] = array;
    }
    this.morphTargetsRelative = source.morphTargetsRelative;
    const groups = source.groups;
    for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
      const group = groups[i2];
      this.addGroup(group.start, group.count, group.materialIndex);
    }
    const boundingBox2 = source.boundingBox;
    if (boundingBox2 !== null) {
      this.boundingBox = boundingBox2.clone();
    }
    const boundingSphere = source.boundingSphere;
    if (boundingSphere !== null) {
      this.boundingSphere = boundingSphere.clone();
    }
    this.drawRange.start = source.drawRange.start;
    this.drawRange.count = source.drawRange.count;
    this.userData = source.userData;
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
};
const _inverseMatrix$3 = /* @__PURE__ */ new Matrix4$1();
const _ray$3$1 = /* @__PURE__ */ new Ray$1();
const _sphere$6 = /* @__PURE__ */ new Sphere$1();
const _sphereHitAt = /* @__PURE__ */ new Vector3$1();
const _vA$1$1 = /* @__PURE__ */ new Vector3$1();
const _vB$1$1 = /* @__PURE__ */ new Vector3$1();
const _vC$1$1 = /* @__PURE__ */ new Vector3$1();
const _tempA$1 = /* @__PURE__ */ new Vector3$1();
const _morphA$1 = /* @__PURE__ */ new Vector3$1();
const _intersectionPoint$2 = /* @__PURE__ */ new Vector3$1();
const _intersectionPointWorld$1 = /* @__PURE__ */ new Vector3$1();
let Mesh$1 = class Mesh extends Object3D$1 {
  constructor(geometry = new BufferGeometry$1(), material = new MeshBasicMaterial$1()) {
    super();
    this.isMesh = true;
    this.type = "Mesh";
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    if (source.morphTargetInfluences !== void 0) {
      this.morphTargetInfluences = source.morphTargetInfluences.slice();
    }
    if (source.morphTargetDictionary !== void 0) {
      this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
    }
    this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
    this.geometry = source.geometry;
    return this;
  }
  updateMorphTargets() {
    const geometry = this.geometry;
    const morphAttributes = geometry.morphAttributes;
    const keys = Object.keys(morphAttributes);
    if (keys.length > 0) {
      const morphAttribute = morphAttributes[keys[0]];
      if (morphAttribute !== void 0) {
        this.morphTargetInfluences = [];
        this.morphTargetDictionary = {};
        for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
          const name = morphAttribute[m].name || String(m);
          this.morphTargetInfluences.push(0);
          this.morphTargetDictionary[name] = m;
        }
      }
    }
  }
  getVertexPosition(index2, target) {
    const geometry = this.geometry;
    const position2 = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    target.fromBufferAttribute(position2, index2);
    const morphInfluences = this.morphTargetInfluences;
    if (morphPosition && morphInfluences) {
      _morphA$1.set(0, 0, 0);
      for (let i2 = 0, il = morphPosition.length; i2 < il; i2++) {
        const influence = morphInfluences[i2];
        const morphAttribute = morphPosition[i2];
        if (influence === 0) continue;
        _tempA$1.fromBufferAttribute(morphAttribute, index2);
        if (morphTargetsRelative) {
          _morphA$1.addScaledVector(_tempA$1, influence);
        } else {
          _morphA$1.addScaledVector(_tempA$1.sub(target), influence);
        }
      }
      target.add(_morphA$1);
    }
    return target;
  }
  raycast(raycaster, intersects2) {
    const geometry = this.geometry;
    const material = this.material;
    const matrixWorld = this.matrixWorld;
    if (material === void 0) return;
    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
    _sphere$6.copy(geometry.boundingSphere);
    _sphere$6.applyMatrix4(matrixWorld);
    _ray$3$1.copy(raycaster.ray).recast(raycaster.near);
    if (_sphere$6.containsPoint(_ray$3$1.origin) === false) {
      if (_ray$3$1.intersectSphere(_sphere$6, _sphereHitAt) === null) return;
      if (_ray$3$1.origin.distanceToSquared(_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
    }
    _inverseMatrix$3.copy(matrixWorld).invert();
    _ray$3$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$3);
    if (geometry.boundingBox !== null) {
      if (_ray$3$1.intersectsBox(geometry.boundingBox) === false) return;
    }
    this._computeIntersections(raycaster, intersects2, _ray$3$1);
  }
  _computeIntersections(raycaster, intersects2, rayLocalSpace) {
    let intersection;
    const geometry = this.geometry;
    const material = this.material;
    const index2 = geometry.index;
    const position2 = geometry.attributes.position;
    const uv = geometry.attributes.uv;
    const uv1 = geometry.attributes.uv1;
    const normal = geometry.attributes.normal;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    if (index2 !== null) {
      if (Array.isArray(material)) {
        for (let i2 = 0, il = groups.length; i2 < il; i2++) {
          const group = groups[i2];
          const groupMaterial = material[group.materialIndex];
          const start = Math.max(group.start, drawRange.start);
          const end = Math.min(index2.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
          for (let j = start, jl = end; j < jl; j += 3) {
            const a3 = index2.getX(j);
            const b = index2.getX(j + 1);
            const c2 = index2.getX(j + 2);
            intersection = checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a3, b, c2);
            if (intersection) {
              intersection.faceIndex = Math.floor(j / 3);
              intersection.face.materialIndex = group.materialIndex;
              intersects2.push(intersection);
            }
          }
        }
      } else {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(index2.count, drawRange.start + drawRange.count);
        for (let i2 = start, il = end; i2 < il; i2 += 3) {
          const a3 = index2.getX(i2);
          const b = index2.getX(i2 + 1);
          const c2 = index2.getX(i2 + 2);
          intersection = checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a3, b, c2);
          if (intersection) {
            intersection.faceIndex = Math.floor(i2 / 3);
            intersects2.push(intersection);
          }
        }
      }
    } else if (position2 !== void 0) {
      if (Array.isArray(material)) {
        for (let i2 = 0, il = groups.length; i2 < il; i2++) {
          const group = groups[i2];
          const groupMaterial = material[group.materialIndex];
          const start = Math.max(group.start, drawRange.start);
          const end = Math.min(position2.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
          for (let j = start, jl = end; j < jl; j += 3) {
            const a3 = j;
            const b = j + 1;
            const c2 = j + 2;
            intersection = checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a3, b, c2);
            if (intersection) {
              intersection.faceIndex = Math.floor(j / 3);
              intersection.face.materialIndex = group.materialIndex;
              intersects2.push(intersection);
            }
          }
        }
      } else {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(position2.count, drawRange.start + drawRange.count);
        for (let i2 = start, il = end; i2 < il; i2 += 3) {
          const a3 = i2;
          const b = i2 + 1;
          const c2 = i2 + 2;
          intersection = checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a3, b, c2);
          if (intersection) {
            intersection.faceIndex = Math.floor(i2 / 3);
            intersects2.push(intersection);
          }
        }
      }
    }
  }
};
function checkIntersection$1$1(object, material, raycaster, ray2, pA, pB, pC, point2) {
  let intersect2;
  if (material.side === BackSide$1) {
    intersect2 = ray2.intersectTriangle(pC, pB, pA, true, point2);
  } else {
    intersect2 = ray2.intersectTriangle(pA, pB, pC, material.side === FrontSide$1, point2);
  }
  if (intersect2 === null) return null;
  _intersectionPointWorld$1.copy(point2);
  _intersectionPointWorld$1.applyMatrix4(object.matrixWorld);
  const distance2 = raycaster.ray.origin.distanceTo(_intersectionPointWorld$1);
  if (distance2 < raycaster.near || distance2 > raycaster.far) return null;
  return {
    distance: distance2,
    point: _intersectionPointWorld$1.clone(),
    object
  };
}
function checkGeometryIntersection(object, material, raycaster, ray2, uv, uv1, normal, a3, b, c2) {
  object.getVertexPosition(a3, _vA$1$1);
  object.getVertexPosition(b, _vB$1$1);
  object.getVertexPosition(c2, _vC$1$1);
  const intersection = checkIntersection$1$1(object, material, raycaster, ray2, _vA$1$1, _vB$1$1, _vC$1$1, _intersectionPoint$2);
  if (intersection) {
    const barycoord = new Vector3$1();
    Triangle$1.getBarycoord(_intersectionPoint$2, _vA$1$1, _vB$1$1, _vC$1$1, barycoord);
    if (uv) {
      intersection.uv = Triangle$1.getInterpolatedAttribute(uv, a3, b, c2, barycoord, new Vector2$1());
    }
    if (uv1) {
      intersection.uv1 = Triangle$1.getInterpolatedAttribute(uv1, a3, b, c2, barycoord, new Vector2$1());
    }
    if (normal) {
      intersection.normal = Triangle$1.getInterpolatedAttribute(normal, a3, b, c2, barycoord, new Vector3$1());
      if (intersection.normal.dot(ray2.direction) > 0) {
        intersection.normal.multiplyScalar(-1);
      }
    }
    const face = {
      a: a3,
      b,
      c: c2,
      normal: new Vector3$1(),
      materialIndex: 0
    };
    Triangle$1.getNormal(_vA$1$1, _vB$1$1, _vC$1$1, face.normal);
    intersection.face = face;
    intersection.barycoord = barycoord;
  }
  return intersection;
}
let BoxGeometry$1 = class BoxGeometry extends BufferGeometry$1 {
  constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1) {
    super();
    this.type = "BoxGeometry";
    this.parameters = {
      width,
      height,
      depth,
      widthSegments,
      heightSegments,
      depthSegments
    };
    const scope = this;
    widthSegments = Math.floor(widthSegments);
    heightSegments = Math.floor(heightSegments);
    depthSegments = Math.floor(depthSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let numberOfVertices = 0;
    let groupStart = 0;
    buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0);
    buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1);
    buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2);
    buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3);
    buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4);
    buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5);
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute$1(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvs, 2));
    function buildPlane(u3, v, w, udir, vdir, width2, height2, depth2, gridX, gridY, materialIndex) {
      const segmentWidth = width2 / gridX;
      const segmentHeight = height2 / gridY;
      const widthHalf = width2 / 2;
      const heightHalf = height2 / 2;
      const depthHalf = depth2 / 2;
      const gridX1 = gridX + 1;
      const gridY1 = gridY + 1;
      let vertexCounter = 0;
      let groupCount = 0;
      const vector = new Vector3$1();
      for (let iy = 0; iy < gridY1; iy++) {
        const y = iy * segmentHeight - heightHalf;
        for (let ix = 0; ix < gridX1; ix++) {
          const x = ix * segmentWidth - widthHalf;
          vector[u3] = x * udir;
          vector[v] = y * vdir;
          vector[w] = depthHalf;
          vertices.push(vector.x, vector.y, vector.z);
          vector[u3] = 0;
          vector[v] = 0;
          vector[w] = depth2 > 0 ? 1 : -1;
          normals.push(vector.x, vector.y, vector.z);
          uvs.push(ix / gridX);
          uvs.push(1 - iy / gridY);
          vertexCounter += 1;
        }
      }
      for (let iy = 0; iy < gridY; iy++) {
        for (let ix = 0; ix < gridX; ix++) {
          const a3 = numberOfVertices + ix + gridX1 * iy;
          const b = numberOfVertices + ix + gridX1 * (iy + 1);
          const c2 = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
          const d2 = numberOfVertices + (ix + 1) + gridX1 * iy;
          indices.push(a3, b, d2);
          indices.push(b, c2, d2);
          groupCount += 6;
        }
      }
      scope.addGroup(groupStart, groupCount, materialIndex);
      groupStart += groupCount;
      numberOfVertices += vertexCounter;
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new BoxGeometry(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
  }
};
function cloneUniforms$1(src) {
  const dst = {};
  for (const u3 in src) {
    dst[u3] = {};
    for (const p2 in src[u3]) {
      const property = src[u3][p2];
      if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
        if (property.isRenderTargetTexture) {
          console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().");
          dst[u3][p2] = null;
        } else {
          dst[u3][p2] = property.clone();
        }
      } else if (Array.isArray(property)) {
        dst[u3][p2] = property.slice();
      } else {
        dst[u3][p2] = property;
      }
    }
  }
  return dst;
}
function mergeUniforms$1(uniforms) {
  const merged = {};
  for (let u3 = 0; u3 < uniforms.length; u3++) {
    const tmp2 = cloneUniforms$1(uniforms[u3]);
    for (const p2 in tmp2) {
      merged[p2] = tmp2[p2];
    }
  }
  return merged;
}
function cloneUniformsGroups(src) {
  const dst = [];
  for (let u3 = 0; u3 < src.length; u3++) {
    dst.push(src[u3].clone());
  }
  return dst;
}
function getUnlitUniformColorSpace(renderer) {
  const currentRenderTarget = renderer.getRenderTarget();
  if (currentRenderTarget === null) {
    return renderer.outputColorSpace;
  }
  if (currentRenderTarget.isXRRenderTarget === true) {
    return currentRenderTarget.texture.colorSpace;
  }
  return ColorManagement.workingColorSpace;
}
const UniformsUtils$1 = { clone: cloneUniforms$1, merge: mergeUniforms$1 };
var default_vertex$1 = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var default_fragment$1 = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
let ShaderMaterial$1 = class ShaderMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isShaderMaterial = true;
    this.type = "ShaderMaterial";
    this.defines = {};
    this.uniforms = {};
    this.uniformsGroups = [];
    this.vertexShader = default_vertex$1;
    this.fragmentShader = default_fragment$1;
    this.linewidth = 1;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.lights = false;
    this.clipping = false;
    this.forceSinglePass = true;
    this.extensions = {
      clipCullDistance: false,
      // set to use vertex shader clipping
      multiDraw: false
      // set to use vertex shader multi_draw / enable gl_DrawID
    };
    this.defaultAttributeValues = {
      "color": [1, 1, 1],
      "uv": [0, 0],
      "uv1": [0, 0]
    };
    this.index0AttributeName = void 0;
    this.uniformsNeedUpdate = false;
    this.glslVersion = null;
    if (parameters !== void 0) {
      this.setValues(parameters);
    }
  }
  copy(source) {
    super.copy(source);
    this.fragmentShader = source.fragmentShader;
    this.vertexShader = source.vertexShader;
    this.uniforms = cloneUniforms$1(source.uniforms);
    this.uniformsGroups = cloneUniformsGroups(source.uniformsGroups);
    this.defines = Object.assign({}, source.defines);
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.fog = source.fog;
    this.lights = source.lights;
    this.clipping = source.clipping;
    this.extensions = Object.assign({}, source.extensions);
    this.glslVersion = source.glslVersion;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.glslVersion = this.glslVersion;
    data.uniforms = {};
    for (const name in this.uniforms) {
      const uniform = this.uniforms[name];
      const value = uniform.value;
      if (value && value.isTexture) {
        data.uniforms[name] = {
          type: "t",
          value: value.toJSON(meta).uuid
        };
      } else if (value && value.isColor) {
        data.uniforms[name] = {
          type: "c",
          value: value.getHex()
        };
      } else if (value && value.isVector2) {
        data.uniforms[name] = {
          type: "v2",
          value: value.toArray()
        };
      } else if (value && value.isVector3) {
        data.uniforms[name] = {
          type: "v3",
          value: value.toArray()
        };
      } else if (value && value.isVector4) {
        data.uniforms[name] = {
          type: "v4",
          value: value.toArray()
        };
      } else if (value && value.isMatrix3) {
        data.uniforms[name] = {
          type: "m3",
          value: value.toArray()
        };
      } else if (value && value.isMatrix4) {
        data.uniforms[name] = {
          type: "m4",
          value: value.toArray()
        };
      } else {
        data.uniforms[name] = {
          value
        };
      }
    }
    if (Object.keys(this.defines).length > 0) data.defines = this.defines;
    data.vertexShader = this.vertexShader;
    data.fragmentShader = this.fragmentShader;
    data.lights = this.lights;
    data.clipping = this.clipping;
    const extensions = {};
    for (const key in this.extensions) {
      if (this.extensions[key] === true) extensions[key] = true;
    }
    if (Object.keys(extensions).length > 0) data.extensions = extensions;
    return data;
  }
};
let Camera$1 = class Camera extends Object3D$1 {
  constructor() {
    super();
    this.isCamera = true;
    this.type = "Camera";
    this.matrixWorldInverse = new Matrix4$1();
    this.projectionMatrix = new Matrix4$1();
    this.projectionMatrixInverse = new Matrix4$1();
    this.coordinateSystem = WebGLCoordinateSystem;
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.matrixWorldInverse.copy(source.matrixWorldInverse);
    this.projectionMatrix.copy(source.projectionMatrix);
    this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
    this.coordinateSystem = source.coordinateSystem;
    return this;
  }
  getWorldDirection(target) {
    return super.getWorldDirection(target).negate();
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(updateParents, updateChildren) {
    super.updateWorldMatrix(updateParents, updateChildren);
    this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
const _v3$1$1 = /* @__PURE__ */ new Vector3$1();
const _minTarget = /* @__PURE__ */ new Vector2$1();
const _maxTarget = /* @__PURE__ */ new Vector2$1();
let PerspectiveCamera$1 = class PerspectiveCamera extends Camera$1 {
  constructor(fov2 = 50, aspect2 = 1, near = 0.1, far = 2e3) {
    super();
    this.isPerspectiveCamera = true;
    this.type = "PerspectiveCamera";
    this.fov = fov2;
    this.zoom = 1;
    this.near = near;
    this.far = far;
    this.focus = 10;
    this.aspect = aspect2;
    this.view = null;
    this.filmGauge = 35;
    this.filmOffset = 0;
    this.updateProjectionMatrix();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.fov = source.fov;
    this.zoom = source.zoom;
    this.near = source.near;
    this.far = source.far;
    this.focus = source.focus;
    this.aspect = source.aspect;
    this.view = source.view === null ? null : Object.assign({}, source.view);
    this.filmGauge = source.filmGauge;
    this.filmOffset = source.filmOffset;
    return this;
  }
  /**
   * Sets the FOV by focal length in respect to the current .filmGauge.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(focalLength) {
    const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
    this.fov = RAD2DEG$1 * 2 * Math.atan(vExtentSlope);
    this.updateProjectionMatrix();
  }
  /**
   * Calculates the focal length from the current .fov and .filmGauge.
   */
  getFocalLength() {
    const vExtentSlope = Math.tan(DEG2RAD$1 * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / vExtentSlope;
  }
  getEffectiveFOV() {
    return RAD2DEG$1 * 2 * Math.atan(
      Math.tan(DEG2RAD$1 * 0.5 * this.fov) / this.zoom
    );
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  /**
   * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
   * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
   */
  getViewBounds(distance2, minTarget, maxTarget) {
    _v3$1$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
    minTarget.set(_v3$1$1.x, _v3$1$1.y).multiplyScalar(-distance2 / _v3$1$1.z);
    _v3$1$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
    maxTarget.set(_v3$1$1.x, _v3$1$1.y).multiplyScalar(-distance2 / _v3$1$1.z);
  }
  /**
   * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
   * Copies the result into the target Vector2, where x is width and y is height.
   */
  getViewSize(distance2, target) {
    this.getViewBounds(distance2, _minTarget, _maxTarget);
    return target.subVectors(_maxTarget, _minTarget);
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *
   * then for each monitor you would call it like this
   *
   *   const w = 1920;
   *   const h = 1080;
   *   const fullWidth = w * 3;
   *   const fullHeight = h * 2;
   *
   *   --A--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   *   --B--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   *   --C--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   *   --D--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   *   --E--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   *   --F--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   *
   *   Note there is no reason monitors have to be the same size or in a grid.
   */
  setViewOffset(fullWidth, fullHeight, x, y, width, height) {
    this.aspect = fullWidth / fullHeight;
    if (this.view === null) {
      this.view = {
        enabled: true,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      };
    }
    this.view.enabled = true;
    this.view.fullWidth = fullWidth;
    this.view.fullHeight = fullHeight;
    this.view.offsetX = x;
    this.view.offsetY = y;
    this.view.width = width;
    this.view.height = height;
    this.updateProjectionMatrix();
  }
  clearViewOffset() {
    if (this.view !== null) {
      this.view.enabled = false;
    }
    this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const near = this.near;
    let top = near * Math.tan(DEG2RAD$1 * 0.5 * this.fov) / this.zoom;
    let height = 2 * top;
    let width = this.aspect * height;
    let left = -0.5 * width;
    const view = this.view;
    if (this.view !== null && this.view.enabled) {
      const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
      left += view.offsetX * width / fullWidth;
      top -= view.offsetY * height / fullHeight;
      width *= view.width / fullWidth;
      height *= view.height / fullHeight;
    }
    const skew = this.filmOffset;
    if (skew !== 0) left += near * skew / this.getFilmWidth();
    this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
    this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.fov = this.fov;
    data.object.zoom = this.zoom;
    data.object.near = this.near;
    data.object.far = this.far;
    data.object.focus = this.focus;
    data.object.aspect = this.aspect;
    if (this.view !== null) data.object.view = Object.assign({}, this.view);
    data.object.filmGauge = this.filmGauge;
    data.object.filmOffset = this.filmOffset;
    return data;
  }
};
const fov$1 = -90;
const aspect$1 = 1;
let CubeCamera$1 = class CubeCamera extends Object3D$1 {
  constructor(near, far, renderTarget) {
    super();
    this.type = "CubeCamera";
    this.renderTarget = renderTarget;
    this.coordinateSystem = null;
    this.activeMipmapLevel = 0;
    const cameraPX = new PerspectiveCamera$1(fov$1, aspect$1, near, far);
    cameraPX.layers = this.layers;
    this.add(cameraPX);
    const cameraNX = new PerspectiveCamera$1(fov$1, aspect$1, near, far);
    cameraNX.layers = this.layers;
    this.add(cameraNX);
    const cameraPY = new PerspectiveCamera$1(fov$1, aspect$1, near, far);
    cameraPY.layers = this.layers;
    this.add(cameraPY);
    const cameraNY = new PerspectiveCamera$1(fov$1, aspect$1, near, far);
    cameraNY.layers = this.layers;
    this.add(cameraNY);
    const cameraPZ = new PerspectiveCamera$1(fov$1, aspect$1, near, far);
    cameraPZ.layers = this.layers;
    this.add(cameraPZ);
    const cameraNZ = new PerspectiveCamera$1(fov$1, aspect$1, near, far);
    cameraNZ.layers = this.layers;
    this.add(cameraNZ);
  }
  updateCoordinateSystem() {
    const coordinateSystem = this.coordinateSystem;
    const cameras = this.children.concat();
    const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
    for (const camera of cameras) this.remove(camera);
    if (coordinateSystem === WebGLCoordinateSystem) {
      cameraPX.up.set(0, 1, 0);
      cameraPX.lookAt(1, 0, 0);
      cameraNX.up.set(0, 1, 0);
      cameraNX.lookAt(-1, 0, 0);
      cameraPY.up.set(0, 0, -1);
      cameraPY.lookAt(0, 1, 0);
      cameraNY.up.set(0, 0, 1);
      cameraNY.lookAt(0, -1, 0);
      cameraPZ.up.set(0, 1, 0);
      cameraPZ.lookAt(0, 0, 1);
      cameraNZ.up.set(0, 1, 0);
      cameraNZ.lookAt(0, 0, -1);
    } else if (coordinateSystem === WebGPUCoordinateSystem) {
      cameraPX.up.set(0, -1, 0);
      cameraPX.lookAt(-1, 0, 0);
      cameraNX.up.set(0, -1, 0);
      cameraNX.lookAt(1, 0, 0);
      cameraPY.up.set(0, 0, 1);
      cameraPY.lookAt(0, 1, 0);
      cameraNY.up.set(0, 0, -1);
      cameraNY.lookAt(0, -1, 0);
      cameraPZ.up.set(0, -1, 0);
      cameraPZ.lookAt(0, 0, 1);
      cameraNZ.up.set(0, -1, 0);
      cameraNZ.lookAt(0, 0, -1);
    } else {
      throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + coordinateSystem);
    }
    for (const camera of cameras) {
      this.add(camera);
      camera.updateMatrixWorld();
    }
  }
  update(renderer, scene) {
    if (this.parent === null) this.updateMatrixWorld();
    const { renderTarget, activeMipmapLevel } = this;
    if (this.coordinateSystem !== renderer.coordinateSystem) {
      this.coordinateSystem = renderer.coordinateSystem;
      this.updateCoordinateSystem();
    }
    const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
    const currentRenderTarget = renderer.getRenderTarget();
    const currentActiveCubeFace = renderer.getActiveCubeFace();
    const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
    const currentXrEnabled = renderer.xr.enabled;
    renderer.xr.enabled = false;
    const generateMipmaps = renderTarget.texture.generateMipmaps;
    renderTarget.texture.generateMipmaps = false;
    renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
    renderer.render(scene, cameraPX);
    renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
    renderer.render(scene, cameraNX);
    renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
    renderer.render(scene, cameraPY);
    renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
    renderer.render(scene, cameraNY);
    renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
    renderer.render(scene, cameraPZ);
    renderTarget.texture.generateMipmaps = generateMipmaps;
    renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
    renderer.render(scene, cameraNZ);
    renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
    renderer.xr.enabled = currentXrEnabled;
    renderTarget.texture.needsPMREMUpdate = true;
  }
};
let CubeTexture$1 = class CubeTexture extends Texture$1 {
  constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace) {
    images = images !== void 0 ? images : [];
    mapping = mapping !== void 0 ? mapping : CubeReflectionMapping$1;
    super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
    this.isCubeTexture = true;
    this.flipY = false;
  }
  get images() {
    return this.image;
  }
  set images(value) {
    this.image = value;
  }
};
let WebGLCubeRenderTarget$1 = class WebGLCubeRenderTarget extends WebGLRenderTarget$1 {
  constructor(size = 1, options = {}) {
    super(size, size, options);
    this.isWebGLCubeRenderTarget = true;
    const image2 = { width: size, height: size, depth: 1 };
    const images = [image2, image2, image2, image2, image2, image2];
    this.texture = new CubeTexture$1(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
    this.texture.isRenderTargetTexture = true;
    this.texture.generateMipmaps = options.generateMipmaps !== void 0 ? options.generateMipmaps : false;
    this.texture.minFilter = options.minFilter !== void 0 ? options.minFilter : LinearFilter$1;
  }
  fromEquirectangularTexture(renderer, texture) {
    this.texture.type = texture.type;
    this.texture.colorSpace = texture.colorSpace;
    this.texture.generateMipmaps = texture.generateMipmaps;
    this.texture.minFilter = texture.minFilter;
    this.texture.magFilter = texture.magFilter;
    const shader = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: (
        /* glsl */
        `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
      ),
      fragmentShader: (
        /* glsl */
        `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
      )
    };
    const geometry = new BoxGeometry$1(5, 5, 5);
    const material = new ShaderMaterial$1({
      name: "CubemapFromEquirect",
      uniforms: cloneUniforms$1(shader.uniforms),
      vertexShader: shader.vertexShader,
      fragmentShader: shader.fragmentShader,
      side: BackSide$1,
      blending: NoBlending$1
    });
    material.uniforms.tEquirect.value = texture;
    const mesh = new Mesh$1(geometry, material);
    const currentMinFilter = texture.minFilter;
    if (texture.minFilter === LinearMipmapLinearFilter$1) texture.minFilter = LinearFilter$1;
    const camera = new CubeCamera$1(1, 10, this);
    camera.update(renderer, mesh);
    texture.minFilter = currentMinFilter;
    mesh.geometry.dispose();
    mesh.material.dispose();
    return this;
  }
  clear(renderer, color2, depth, stencil) {
    const currentRenderTarget = renderer.getRenderTarget();
    for (let i2 = 0; i2 < 6; i2++) {
      renderer.setRenderTarget(this, i2);
      renderer.clear(color2, depth, stencil);
    }
    renderer.setRenderTarget(currentRenderTarget);
  }
};
class FogExp2 {
  constructor(color2, density = 25e-5) {
    this.isFogExp2 = true;
    this.name = "";
    this.color = new Color$1(color2);
    this.density = density;
  }
  clone() {
    return new FogExp2(this.color, this.density);
  }
  toJSON() {
    return {
      type: "FogExp2",
      name: this.name,
      color: this.color.getHex(),
      density: this.density
    };
  }
}
class Fog {
  constructor(color2, near = 1, far = 1e3) {
    this.isFog = true;
    this.name = "";
    this.color = new Color$1(color2);
    this.near = near;
    this.far = far;
  }
  clone() {
    return new Fog(this.color, this.near, this.far);
  }
  toJSON() {
    return {
      type: "Fog",
      name: this.name,
      color: this.color.getHex(),
      near: this.near,
      far: this.far
    };
  }
}
let Scene$1 = class Scene extends Object3D$1 {
  constructor() {
    super();
    this.isScene = true;
    this.type = "Scene";
    this.background = null;
    this.environment = null;
    this.fog = null;
    this.backgroundBlurriness = 0;
    this.backgroundIntensity = 1;
    this.backgroundRotation = new Euler$1();
    this.environmentIntensity = 1;
    this.environmentRotation = new Euler$1();
    this.overrideMaterial = null;
    if (typeof __THREE_DEVTOOLS__ !== "undefined") {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
    }
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    if (source.background !== null) this.background = source.background.clone();
    if (source.environment !== null) this.environment = source.environment.clone();
    if (source.fog !== null) this.fog = source.fog.clone();
    this.backgroundBlurriness = source.backgroundBlurriness;
    this.backgroundIntensity = source.backgroundIntensity;
    this.backgroundRotation.copy(source.backgroundRotation);
    this.environmentIntensity = source.environmentIntensity;
    this.environmentRotation.copy(source.environmentRotation);
    if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    if (this.fog !== null) data.object.fog = this.fog.toJSON();
    if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
    if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
    data.object.backgroundRotation = this.backgroundRotation.toArray();
    if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
    data.object.environmentRotation = this.environmentRotation.toArray();
    return data;
  }
};
let InterleavedBuffer$1 = class InterleavedBuffer {
  constructor(array, stride) {
    this.isInterleavedBuffer = true;
    this.array = array;
    this.stride = stride;
    this.count = array !== void 0 ? array.length / stride : 0;
    this.usage = StaticDrawUsage$1;
    this.updateRanges = [];
    this.version = 0;
    this.uuid = generateUUID$1();
  }
  onUploadCallback() {
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
  setUsage(value) {
    this.usage = value;
    return this;
  }
  addUpdateRange(start, count) {
    this.updateRanges.push({ start, count });
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  copy(source) {
    this.array = new source.array.constructor(source.array);
    this.count = source.count;
    this.stride = source.stride;
    this.usage = source.usage;
    return this;
  }
  copyAt(index1, attribute, index2) {
    index1 *= this.stride;
    index2 *= attribute.stride;
    for (let i2 = 0, l2 = this.stride; i2 < l2; i2++) {
      this.array[index1 + i2] = attribute.array[index2 + i2];
    }
    return this;
  }
  set(value, offset = 0) {
    this.array.set(value, offset);
    return this;
  }
  clone(data) {
    if (data.arrayBuffers === void 0) {
      data.arrayBuffers = {};
    }
    if (this.array.buffer._uuid === void 0) {
      this.array.buffer._uuid = generateUUID$1();
    }
    if (data.arrayBuffers[this.array.buffer._uuid] === void 0) {
      data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
    }
    const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
    const ib = new this.constructor(array, this.stride);
    ib.setUsage(this.usage);
    return ib;
  }
  onUpload(callback) {
    this.onUploadCallback = callback;
    return this;
  }
  toJSON(data) {
    if (data.arrayBuffers === void 0) {
      data.arrayBuffers = {};
    }
    if (this.array.buffer._uuid === void 0) {
      this.array.buffer._uuid = generateUUID$1();
    }
    if (data.arrayBuffers[this.array.buffer._uuid] === void 0) {
      data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
    }
    return {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
  }
};
const _vector$7$1 = /* @__PURE__ */ new Vector3$1();
let InterleavedBufferAttribute$1 = class InterleavedBufferAttribute {
  constructor(interleavedBuffer, itemSize, offset, normalized = false) {
    this.isInterleavedBufferAttribute = true;
    this.name = "";
    this.data = interleavedBuffer;
    this.itemSize = itemSize;
    this.offset = offset;
    this.normalized = normalized;
  }
  get count() {
    return this.data.count;
  }
  get array() {
    return this.data.array;
  }
  set needsUpdate(value) {
    this.data.needsUpdate = value;
  }
  applyMatrix4(m) {
    for (let i2 = 0, l2 = this.data.count; i2 < l2; i2++) {
      _vector$7$1.fromBufferAttribute(this, i2);
      _vector$7$1.applyMatrix4(m);
      this.setXYZ(i2, _vector$7$1.x, _vector$7$1.y, _vector$7$1.z);
    }
    return this;
  }
  applyNormalMatrix(m) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$7$1.fromBufferAttribute(this, i2);
      _vector$7$1.applyNormalMatrix(m);
      this.setXYZ(i2, _vector$7$1.x, _vector$7$1.y, _vector$7$1.z);
    }
    return this;
  }
  transformDirection(m) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$7$1.fromBufferAttribute(this, i2);
      _vector$7$1.transformDirection(m);
      this.setXYZ(i2, _vector$7$1.x, _vector$7$1.y, _vector$7$1.z);
    }
    return this;
  }
  getComponent(index2, component) {
    let value = this.array[index2 * this.data.stride + this.offset + component];
    if (this.normalized) value = denormalize(value, this.array);
    return value;
  }
  setComponent(index2, component, value) {
    if (this.normalized) value = normalize(value, this.array);
    this.data.array[index2 * this.data.stride + this.offset + component] = value;
    return this;
  }
  setX(index2, x) {
    if (this.normalized) x = normalize(x, this.array);
    this.data.array[index2 * this.data.stride + this.offset] = x;
    return this;
  }
  setY(index2, y) {
    if (this.normalized) y = normalize(y, this.array);
    this.data.array[index2 * this.data.stride + this.offset + 1] = y;
    return this;
  }
  setZ(index2, z2) {
    if (this.normalized) z2 = normalize(z2, this.array);
    this.data.array[index2 * this.data.stride + this.offset + 2] = z2;
    return this;
  }
  setW(index2, w) {
    if (this.normalized) w = normalize(w, this.array);
    this.data.array[index2 * this.data.stride + this.offset + 3] = w;
    return this;
  }
  getX(index2) {
    let x = this.data.array[index2 * this.data.stride + this.offset];
    if (this.normalized) x = denormalize(x, this.array);
    return x;
  }
  getY(index2) {
    let y = this.data.array[index2 * this.data.stride + this.offset + 1];
    if (this.normalized) y = denormalize(y, this.array);
    return y;
  }
  getZ(index2) {
    let z2 = this.data.array[index2 * this.data.stride + this.offset + 2];
    if (this.normalized) z2 = denormalize(z2, this.array);
    return z2;
  }
  getW(index2) {
    let w = this.data.array[index2 * this.data.stride + this.offset + 3];
    if (this.normalized) w = denormalize(w, this.array);
    return w;
  }
  setXY(index2, x, y) {
    index2 = index2 * this.data.stride + this.offset;
    if (this.normalized) {
      x = normalize(x, this.array);
      y = normalize(y, this.array);
    }
    this.data.array[index2 + 0] = x;
    this.data.array[index2 + 1] = y;
    return this;
  }
  setXYZ(index2, x, y, z2) {
    index2 = index2 * this.data.stride + this.offset;
    if (this.normalized) {
      x = normalize(x, this.array);
      y = normalize(y, this.array);
      z2 = normalize(z2, this.array);
    }
    this.data.array[index2 + 0] = x;
    this.data.array[index2 + 1] = y;
    this.data.array[index2 + 2] = z2;
    return this;
  }
  setXYZW(index2, x, y, z2, w) {
    index2 = index2 * this.data.stride + this.offset;
    if (this.normalized) {
      x = normalize(x, this.array);
      y = normalize(y, this.array);
      z2 = normalize(z2, this.array);
      w = normalize(w, this.array);
    }
    this.data.array[index2 + 0] = x;
    this.data.array[index2 + 1] = y;
    this.data.array[index2 + 2] = z2;
    this.data.array[index2 + 3] = w;
    return this;
  }
  clone(data) {
    if (data === void 0) {
      console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
      const array = [];
      for (let i2 = 0; i2 < this.count; i2++) {
        const index2 = i2 * this.data.stride + this.offset;
        for (let j = 0; j < this.itemSize; j++) {
          array.push(this.data.array[index2 + j]);
        }
      }
      return new BufferAttribute$1(new this.array.constructor(array), this.itemSize, this.normalized);
    } else {
      if (data.interleavedBuffers === void 0) {
        data.interleavedBuffers = {};
      }
      if (data.interleavedBuffers[this.data.uuid] === void 0) {
        data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
      }
      return new InterleavedBufferAttribute(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
  }
  toJSON(data) {
    if (data === void 0) {
      console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
      const array = [];
      for (let i2 = 0; i2 < this.count; i2++) {
        const index2 = i2 * this.data.stride + this.offset;
        for (let j = 0; j < this.itemSize; j++) {
          array.push(this.data.array[index2 + j]);
        }
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array,
        normalized: this.normalized
      };
    } else {
      if (data.interleavedBuffers === void 0) {
        data.interleavedBuffers = {};
      }
      if (data.interleavedBuffers[this.data.uuid] === void 0) {
        data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
      }
      return {
        isInterleavedBufferAttribute: true,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
    }
  }
};
let SpriteMaterial$1 = class SpriteMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isSpriteMaterial = true;
    this.type = "SpriteMaterial";
    this.color = new Color$1(16777215);
    this.map = null;
    this.alphaMap = null;
    this.rotation = 0;
    this.sizeAttenuation = true;
    this.transparent = true;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.rotation = source.rotation;
    this.sizeAttenuation = source.sizeAttenuation;
    this.fog = source.fog;
    return this;
  }
};
let _geometry$2;
const _intersectPoint$1 = /* @__PURE__ */ new Vector3$1();
const _worldScale$2 = /* @__PURE__ */ new Vector3$1();
const _mvPosition$1 = /* @__PURE__ */ new Vector3$1();
const _alignedPosition$1 = /* @__PURE__ */ new Vector2$1();
const _rotatedPosition$1 = /* @__PURE__ */ new Vector2$1();
const _viewWorldMatrix$1 = /* @__PURE__ */ new Matrix4$1();
const _vA$4 = /* @__PURE__ */ new Vector3$1();
const _vB$4 = /* @__PURE__ */ new Vector3$1();
const _vC$4 = /* @__PURE__ */ new Vector3$1();
const _uvA$3 = /* @__PURE__ */ new Vector2$1();
const _uvB$3 = /* @__PURE__ */ new Vector2$1();
const _uvC$3 = /* @__PURE__ */ new Vector2$1();
let Sprite$1 = class Sprite extends Object3D$1 {
  constructor(material = new SpriteMaterial$1()) {
    super();
    this.isSprite = true;
    this.type = "Sprite";
    if (_geometry$2 === void 0) {
      _geometry$2 = new BufferGeometry$1();
      const float32Array2 = new Float32Array([
        -0.5,
        -0.5,
        0,
        0,
        0,
        0.5,
        -0.5,
        0,
        1,
        0,
        0.5,
        0.5,
        0,
        1,
        1,
        -0.5,
        0.5,
        0,
        0,
        1
      ]);
      const interleavedBuffer = new InterleavedBuffer$1(float32Array2, 5);
      _geometry$2.setIndex([0, 1, 2, 0, 2, 3]);
      _geometry$2.setAttribute("position", new InterleavedBufferAttribute$1(interleavedBuffer, 3, 0, false));
      _geometry$2.setAttribute("uv", new InterleavedBufferAttribute$1(interleavedBuffer, 2, 3, false));
    }
    this.geometry = _geometry$2;
    this.material = material;
    this.center = new Vector2$1(0.5, 0.5);
  }
  raycast(raycaster, intersects2) {
    if (raycaster.camera === null) {
      console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
    }
    _worldScale$2.setFromMatrixScale(this.matrixWorld);
    _viewWorldMatrix$1.copy(raycaster.camera.matrixWorld);
    this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
    _mvPosition$1.setFromMatrixPosition(this.modelViewMatrix);
    if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) {
      _worldScale$2.multiplyScalar(-_mvPosition$1.z);
    }
    const rotation = this.material.rotation;
    let sin2, cos2;
    if (rotation !== 0) {
      cos2 = Math.cos(rotation);
      sin2 = Math.sin(rotation);
    }
    const center = this.center;
    transformVertex$1(_vA$4.set(-0.5, -0.5, 0), _mvPosition$1, center, _worldScale$2, sin2, cos2);
    transformVertex$1(_vB$4.set(0.5, -0.5, 0), _mvPosition$1, center, _worldScale$2, sin2, cos2);
    transformVertex$1(_vC$4.set(0.5, 0.5, 0), _mvPosition$1, center, _worldScale$2, sin2, cos2);
    _uvA$3.set(0, 0);
    _uvB$3.set(1, 0);
    _uvC$3.set(1, 1);
    let intersect2 = raycaster.ray.intersectTriangle(_vA$4, _vB$4, _vC$4, false, _intersectPoint$1);
    if (intersect2 === null) {
      transformVertex$1(_vB$4.set(-0.5, 0.5, 0), _mvPosition$1, center, _worldScale$2, sin2, cos2);
      _uvB$3.set(0, 1);
      intersect2 = raycaster.ray.intersectTriangle(_vA$4, _vC$4, _vB$4, false, _intersectPoint$1);
      if (intersect2 === null) {
        return;
      }
    }
    const distance2 = raycaster.ray.origin.distanceTo(_intersectPoint$1);
    if (distance2 < raycaster.near || distance2 > raycaster.far) return;
    intersects2.push({
      distance: distance2,
      point: _intersectPoint$1.clone(),
      uv: Triangle$1.getInterpolation(_intersectPoint$1, _vA$4, _vB$4, _vC$4, _uvA$3, _uvB$3, _uvC$3, new Vector2$1()),
      face: null,
      object: this
    });
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    if (source.center !== void 0) this.center.copy(source.center);
    this.material = source.material;
    return this;
  }
};
function transformVertex$1(vertexPosition, mvPosition, center, scale, sin2, cos2) {
  _alignedPosition$1.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
  if (sin2 !== void 0) {
    _rotatedPosition$1.x = cos2 * _alignedPosition$1.x - sin2 * _alignedPosition$1.y;
    _rotatedPosition$1.y = sin2 * _alignedPosition$1.x + cos2 * _alignedPosition$1.y;
  } else {
    _rotatedPosition$1.copy(_alignedPosition$1);
  }
  vertexPosition.copy(mvPosition);
  vertexPosition.x += _rotatedPosition$1.x;
  vertexPosition.y += _rotatedPosition$1.y;
  vertexPosition.applyMatrix4(_viewWorldMatrix$1);
}
const _v1$2 = /* @__PURE__ */ new Vector3$1();
const _v2$1 = /* @__PURE__ */ new Vector3$1();
class LOD extends Object3D$1 {
  constructor() {
    super();
    this._currentLevel = 0;
    this.type = "LOD";
    Object.defineProperties(this, {
      levels: {
        enumerable: true,
        value: []
      },
      isLOD: {
        value: true
      }
    });
    this.autoUpdate = true;
  }
  copy(source) {
    super.copy(source, false);
    const levels = source.levels;
    for (let i2 = 0, l2 = levels.length; i2 < l2; i2++) {
      const level = levels[i2];
      this.addLevel(level.object.clone(), level.distance, level.hysteresis);
    }
    this.autoUpdate = source.autoUpdate;
    return this;
  }
  addLevel(object, distance2 = 0, hysteresis = 0) {
    distance2 = Math.abs(distance2);
    const levels = this.levels;
    let l2;
    for (l2 = 0; l2 < levels.length; l2++) {
      if (distance2 < levels[l2].distance) {
        break;
      }
    }
    levels.splice(l2, 0, { distance: distance2, hysteresis, object });
    this.add(object);
    return this;
  }
  removeLevel(distance2) {
    const levels = this.levels;
    for (let i2 = 0; i2 < levels.length; i2++) {
      if (levels[i2].distance === distance2) {
        const removedElements = levels.splice(i2, 1);
        this.remove(removedElements[0].object);
        return true;
      }
    }
    return false;
  }
  getCurrentLevel() {
    return this._currentLevel;
  }
  getObjectForDistance(distance2) {
    const levels = this.levels;
    if (levels.length > 0) {
      let i2, l2;
      for (i2 = 1, l2 = levels.length; i2 < l2; i2++) {
        let levelDistance = levels[i2].distance;
        if (levels[i2].object.visible) {
          levelDistance -= levelDistance * levels[i2].hysteresis;
        }
        if (distance2 < levelDistance) {
          break;
        }
      }
      return levels[i2 - 1].object;
    }
    return null;
  }
  raycast(raycaster, intersects2) {
    const levels = this.levels;
    if (levels.length > 0) {
      _v1$2.setFromMatrixPosition(this.matrixWorld);
      const distance2 = raycaster.ray.origin.distanceTo(_v1$2);
      this.getObjectForDistance(distance2).raycast(raycaster, intersects2);
    }
  }
  update(camera) {
    const levels = this.levels;
    if (levels.length > 1) {
      _v1$2.setFromMatrixPosition(camera.matrixWorld);
      _v2$1.setFromMatrixPosition(this.matrixWorld);
      const distance2 = _v1$2.distanceTo(_v2$1) / camera.zoom;
      levels[0].object.visible = true;
      let i2, l2;
      for (i2 = 1, l2 = levels.length; i2 < l2; i2++) {
        let levelDistance = levels[i2].distance;
        if (levels[i2].object.visible) {
          levelDistance -= levelDistance * levels[i2].hysteresis;
        }
        if (distance2 >= levelDistance) {
          levels[i2 - 1].object.visible = false;
          levels[i2].object.visible = true;
        } else {
          break;
        }
      }
      this._currentLevel = i2 - 1;
      for (; i2 < l2; i2++) {
        levels[i2].object.visible = false;
      }
    }
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    if (this.autoUpdate === false) data.object.autoUpdate = false;
    data.object.levels = [];
    const levels = this.levels;
    for (let i2 = 0, l2 = levels.length; i2 < l2; i2++) {
      const level = levels[i2];
      data.object.levels.push({
        object: level.object.uuid,
        distance: level.distance,
        hysteresis: level.hysteresis
      });
    }
    return data;
  }
}
const _basePosition$1 = /* @__PURE__ */ new Vector3$1();
const _skinIndex$1 = /* @__PURE__ */ new Vector4$1();
const _skinWeight$1 = /* @__PURE__ */ new Vector4$1();
const _vector3 = /* @__PURE__ */ new Vector3$1();
const _matrix4 = /* @__PURE__ */ new Matrix4$1();
const _vertex = /* @__PURE__ */ new Vector3$1();
const _sphere$5 = /* @__PURE__ */ new Sphere$1();
const _inverseMatrix$2$1 = /* @__PURE__ */ new Matrix4$1();
const _ray$2$1 = /* @__PURE__ */ new Ray$1();
let SkinnedMesh$1 = class SkinnedMesh extends Mesh$1 {
  constructor(geometry, material) {
    super(geometry, material);
    this.isSkinnedMesh = true;
    this.type = "SkinnedMesh";
    this.bindMode = AttachedBindMode;
    this.bindMatrix = new Matrix4$1();
    this.bindMatrixInverse = new Matrix4$1();
    this.boundingBox = null;
    this.boundingSphere = null;
  }
  computeBoundingBox() {
    const geometry = this.geometry;
    if (this.boundingBox === null) {
      this.boundingBox = new Box3$1();
    }
    this.boundingBox.makeEmpty();
    const positionAttribute = geometry.getAttribute("position");
    for (let i2 = 0; i2 < positionAttribute.count; i2++) {
      this.getVertexPosition(i2, _vertex);
      this.boundingBox.expandByPoint(_vertex);
    }
  }
  computeBoundingSphere() {
    const geometry = this.geometry;
    if (this.boundingSphere === null) {
      this.boundingSphere = new Sphere$1();
    }
    this.boundingSphere.makeEmpty();
    const positionAttribute = geometry.getAttribute("position");
    for (let i2 = 0; i2 < positionAttribute.count; i2++) {
      this.getVertexPosition(i2, _vertex);
      this.boundingSphere.expandByPoint(_vertex);
    }
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.bindMode = source.bindMode;
    this.bindMatrix.copy(source.bindMatrix);
    this.bindMatrixInverse.copy(source.bindMatrixInverse);
    this.skeleton = source.skeleton;
    if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
    if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
    return this;
  }
  raycast(raycaster, intersects2) {
    const material = this.material;
    const matrixWorld = this.matrixWorld;
    if (material === void 0) return;
    if (this.boundingSphere === null) this.computeBoundingSphere();
    _sphere$5.copy(this.boundingSphere);
    _sphere$5.applyMatrix4(matrixWorld);
    if (raycaster.ray.intersectsSphere(_sphere$5) === false) return;
    _inverseMatrix$2$1.copy(matrixWorld).invert();
    _ray$2$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$2$1);
    if (this.boundingBox !== null) {
      if (_ray$2$1.intersectsBox(this.boundingBox) === false) return;
    }
    this._computeIntersections(raycaster, intersects2, _ray$2$1);
  }
  getVertexPosition(index2, target) {
    super.getVertexPosition(index2, target);
    this.applyBoneTransform(index2, target);
    return target;
  }
  bind(skeleton, bindMatrix) {
    this.skeleton = skeleton;
    if (bindMatrix === void 0) {
      this.updateMatrixWorld(true);
      this.skeleton.calculateInverses();
      bindMatrix = this.matrixWorld;
    }
    this.bindMatrix.copy(bindMatrix);
    this.bindMatrixInverse.copy(bindMatrix).invert();
  }
  pose() {
    this.skeleton.pose();
  }
  normalizeSkinWeights() {
    const vector = new Vector4$1();
    const skinWeight = this.geometry.attributes.skinWeight;
    for (let i2 = 0, l2 = skinWeight.count; i2 < l2; i2++) {
      vector.fromBufferAttribute(skinWeight, i2);
      const scale = 1 / vector.manhattanLength();
      if (scale !== Infinity) {
        vector.multiplyScalar(scale);
      } else {
        vector.set(1, 0, 0, 0);
      }
      skinWeight.setXYZW(i2, vector.x, vector.y, vector.z, vector.w);
    }
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    if (this.bindMode === AttachedBindMode) {
      this.bindMatrixInverse.copy(this.matrixWorld).invert();
    } else if (this.bindMode === DetachedBindMode) {
      this.bindMatrixInverse.copy(this.bindMatrix).invert();
    } else {
      console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
  }
  applyBoneTransform(index2, vector) {
    const skeleton = this.skeleton;
    const geometry = this.geometry;
    _skinIndex$1.fromBufferAttribute(geometry.attributes.skinIndex, index2);
    _skinWeight$1.fromBufferAttribute(geometry.attributes.skinWeight, index2);
    _basePosition$1.copy(vector).applyMatrix4(this.bindMatrix);
    vector.set(0, 0, 0);
    for (let i2 = 0; i2 < 4; i2++) {
      const weight = _skinWeight$1.getComponent(i2);
      if (weight !== 0) {
        const boneIndex = _skinIndex$1.getComponent(i2);
        _matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
        vector.addScaledVector(_vector3.copy(_basePosition$1).applyMatrix4(_matrix4), weight);
      }
    }
    return vector.applyMatrix4(this.bindMatrixInverse);
  }
};
let Bone$1 = class Bone extends Object3D$1 {
  constructor() {
    super();
    this.isBone = true;
    this.type = "Bone";
  }
};
let DataTexture$1 = class DataTexture extends Texture$1 {
  constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = NearestFilter$1, minFilter = NearestFilter$1, anisotropy, colorSpace) {
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
    this.isDataTexture = true;
    this.image = { data, width, height };
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
  }
};
const _offsetMatrix = /* @__PURE__ */ new Matrix4$1();
const _identityMatrix$1 = /* @__PURE__ */ new Matrix4$1();
class Skeleton {
  constructor(bones = [], boneInverses = []) {
    this.uuid = generateUUID$1();
    this.bones = bones.slice(0);
    this.boneInverses = boneInverses;
    this.boneMatrices = null;
    this.boneTexture = null;
    this.init();
  }
  init() {
    const bones = this.bones;
    const boneInverses = this.boneInverses;
    this.boneMatrices = new Float32Array(bones.length * 16);
    if (boneInverses.length === 0) {
      this.calculateInverses();
    } else {
      if (bones.length !== boneInverses.length) {
        console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
        this.boneInverses = [];
        for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
          this.boneInverses.push(new Matrix4$1());
        }
      }
    }
  }
  calculateInverses() {
    this.boneInverses.length = 0;
    for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
      const inverse = new Matrix4$1();
      if (this.bones[i2]) {
        inverse.copy(this.bones[i2].matrixWorld).invert();
      }
      this.boneInverses.push(inverse);
    }
  }
  pose() {
    for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
      const bone = this.bones[i2];
      if (bone) {
        bone.matrixWorld.copy(this.boneInverses[i2]).invert();
      }
    }
    for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
      const bone = this.bones[i2];
      if (bone) {
        if (bone.parent && bone.parent.isBone) {
          bone.matrix.copy(bone.parent.matrixWorld).invert();
          bone.matrix.multiply(bone.matrixWorld);
        } else {
          bone.matrix.copy(bone.matrixWorld);
        }
        bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
      }
    }
  }
  update() {
    const bones = this.bones;
    const boneInverses = this.boneInverses;
    const boneMatrices = this.boneMatrices;
    const boneTexture = this.boneTexture;
    for (let i2 = 0, il = bones.length; i2 < il; i2++) {
      const matrix2 = bones[i2] ? bones[i2].matrixWorld : _identityMatrix$1;
      _offsetMatrix.multiplyMatrices(matrix2, boneInverses[i2]);
      _offsetMatrix.toArray(boneMatrices, i2 * 16);
    }
    if (boneTexture !== null) {
      boneTexture.needsUpdate = true;
    }
  }
  clone() {
    return new Skeleton(this.bones, this.boneInverses);
  }
  computeBoneTexture() {
    let size = Math.sqrt(this.bones.length * 4);
    size = Math.ceil(size / 4) * 4;
    size = Math.max(size, 4);
    const boneMatrices = new Float32Array(size * size * 4);
    boneMatrices.set(this.boneMatrices);
    const boneTexture = new DataTexture$1(boneMatrices, size, size, RGBAFormat$1, FloatType$1);
    boneTexture.needsUpdate = true;
    this.boneMatrices = boneMatrices;
    this.boneTexture = boneTexture;
    return this;
  }
  getBoneByName(name) {
    for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
      const bone = this.bones[i2];
      if (bone.name === name) {
        return bone;
      }
    }
    return void 0;
  }
  dispose() {
    if (this.boneTexture !== null) {
      this.boneTexture.dispose();
      this.boneTexture = null;
    }
  }
  fromJSON(json, bones) {
    this.uuid = json.uuid;
    for (let i2 = 0, l2 = json.bones.length; i2 < l2; i2++) {
      const uuid = json.bones[i2];
      let bone = bones[uuid];
      if (bone === void 0) {
        console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
        bone = new Bone$1();
      }
      this.bones.push(bone);
      this.boneInverses.push(new Matrix4$1().fromArray(json.boneInverses[i2]));
    }
    this.init();
    return this;
  }
  toJSON() {
    const data = {
      metadata: {
        version: 4.6,
        type: "Skeleton",
        generator: "Skeleton.toJSON"
      },
      bones: [],
      boneInverses: []
    };
    data.uuid = this.uuid;
    const bones = this.bones;
    const boneInverses = this.boneInverses;
    for (let i2 = 0, l2 = bones.length; i2 < l2; i2++) {
      const bone = bones[i2];
      data.bones.push(bone.uuid);
      const boneInverse = boneInverses[i2];
      data.boneInverses.push(boneInverse.toArray());
    }
    return data;
  }
}
let InstancedBufferAttribute$1 = class InstancedBufferAttribute extends BufferAttribute$1 {
  constructor(array, itemSize, normalized, meshPerAttribute = 1) {
    super(array, itemSize, normalized);
    this.isInstancedBufferAttribute = true;
    this.meshPerAttribute = meshPerAttribute;
  }
  copy(source) {
    super.copy(source);
    this.meshPerAttribute = source.meshPerAttribute;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.meshPerAttribute = this.meshPerAttribute;
    data.isInstancedBufferAttribute = true;
    return data;
  }
};
const _instanceLocalMatrix$1 = /* @__PURE__ */ new Matrix4$1();
const _instanceWorldMatrix$1 = /* @__PURE__ */ new Matrix4$1();
const _instanceIntersects$1 = [];
const _box3 = /* @__PURE__ */ new Box3$1();
const _identity = /* @__PURE__ */ new Matrix4$1();
const _mesh$1$1 = /* @__PURE__ */ new Mesh$1();
const _sphere$4$1 = /* @__PURE__ */ new Sphere$1();
let InstancedMesh$1 = class InstancedMesh extends Mesh$1 {
  constructor(geometry, material, count) {
    super(geometry, material);
    this.isInstancedMesh = true;
    this.instanceMatrix = new InstancedBufferAttribute$1(new Float32Array(count * 16), 16);
    this.instanceColor = null;
    this.morphTexture = null;
    this.count = count;
    this.boundingBox = null;
    this.boundingSphere = null;
    for (let i2 = 0; i2 < count; i2++) {
      this.setMatrixAt(i2, _identity);
    }
  }
  computeBoundingBox() {
    const geometry = this.geometry;
    const count = this.count;
    if (this.boundingBox === null) {
      this.boundingBox = new Box3$1();
    }
    if (geometry.boundingBox === null) {
      geometry.computeBoundingBox();
    }
    this.boundingBox.makeEmpty();
    for (let i2 = 0; i2 < count; i2++) {
      this.getMatrixAt(i2, _instanceLocalMatrix$1);
      _box3.copy(geometry.boundingBox).applyMatrix4(_instanceLocalMatrix$1);
      this.boundingBox.union(_box3);
    }
  }
  computeBoundingSphere() {
    const geometry = this.geometry;
    const count = this.count;
    if (this.boundingSphere === null) {
      this.boundingSphere = new Sphere$1();
    }
    if (geometry.boundingSphere === null) {
      geometry.computeBoundingSphere();
    }
    this.boundingSphere.makeEmpty();
    for (let i2 = 0; i2 < count; i2++) {
      this.getMatrixAt(i2, _instanceLocalMatrix$1);
      _sphere$4$1.copy(geometry.boundingSphere).applyMatrix4(_instanceLocalMatrix$1);
      this.boundingSphere.union(_sphere$4$1);
    }
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.instanceMatrix.copy(source.instanceMatrix);
    if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
    if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
    this.count = source.count;
    if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
    if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
    return this;
  }
  getColorAt(index2, color2) {
    color2.fromArray(this.instanceColor.array, index2 * 3);
  }
  getMatrixAt(index2, matrix2) {
    matrix2.fromArray(this.instanceMatrix.array, index2 * 16);
  }
  getMorphAt(index2, object) {
    const objectInfluences = object.morphTargetInfluences;
    const array = this.morphTexture.source.data.data;
    const len = objectInfluences.length + 1;
    const dataIndex = index2 * len + 1;
    for (let i2 = 0; i2 < objectInfluences.length; i2++) {
      objectInfluences[i2] = array[dataIndex + i2];
    }
  }
  raycast(raycaster, intersects2) {
    const matrixWorld = this.matrixWorld;
    const raycastTimes = this.count;
    _mesh$1$1.geometry = this.geometry;
    _mesh$1$1.material = this.material;
    if (_mesh$1$1.material === void 0) return;
    if (this.boundingSphere === null) this.computeBoundingSphere();
    _sphere$4$1.copy(this.boundingSphere);
    _sphere$4$1.applyMatrix4(matrixWorld);
    if (raycaster.ray.intersectsSphere(_sphere$4$1) === false) return;
    for (let instanceId = 0; instanceId < raycastTimes; instanceId++) {
      this.getMatrixAt(instanceId, _instanceLocalMatrix$1);
      _instanceWorldMatrix$1.multiplyMatrices(matrixWorld, _instanceLocalMatrix$1);
      _mesh$1$1.matrixWorld = _instanceWorldMatrix$1;
      _mesh$1$1.raycast(raycaster, _instanceIntersects$1);
      for (let i2 = 0, l2 = _instanceIntersects$1.length; i2 < l2; i2++) {
        const intersect2 = _instanceIntersects$1[i2];
        intersect2.instanceId = instanceId;
        intersect2.object = this;
        intersects2.push(intersect2);
      }
      _instanceIntersects$1.length = 0;
    }
  }
  setColorAt(index2, color2) {
    if (this.instanceColor === null) {
      this.instanceColor = new InstancedBufferAttribute$1(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
    }
    color2.toArray(this.instanceColor.array, index2 * 3);
  }
  setMatrixAt(index2, matrix2) {
    matrix2.toArray(this.instanceMatrix.array, index2 * 16);
  }
  setMorphAt(index2, object) {
    const objectInfluences = object.morphTargetInfluences;
    const len = objectInfluences.length + 1;
    if (this.morphTexture === null) {
      this.morphTexture = new DataTexture$1(new Float32Array(len * this.count), len, this.count, RedFormat$1, FloatType$1);
    }
    const array = this.morphTexture.source.data.data;
    let morphInfluencesSum = 0;
    for (let i2 = 0; i2 < objectInfluences.length; i2++) {
      morphInfluencesSum += objectInfluences[i2];
    }
    const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
    const dataIndex = len * index2;
    array[dataIndex] = morphBaseInfluence;
    array.set(objectInfluences, dataIndex + 1);
  }
  updateMorphTargets() {
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
    if (this.morphTexture !== null) {
      this.morphTexture.dispose();
      this.morphTexture = null;
    }
    return this;
  }
};
const _vector1$1 = /* @__PURE__ */ new Vector3$1();
const _vector2$2 = /* @__PURE__ */ new Vector3$1();
const _normalMatrix$1 = /* @__PURE__ */ new Matrix3$1();
let Plane$1 = class Plane {
  constructor(normal = new Vector3$1(1, 0, 0), constant = 0) {
    this.isPlane = true;
    this.normal = normal;
    this.constant = constant;
  }
  set(normal, constant) {
    this.normal.copy(normal);
    this.constant = constant;
    return this;
  }
  setComponents(x, y, z2, w) {
    this.normal.set(x, y, z2);
    this.constant = w;
    return this;
  }
  setFromNormalAndCoplanarPoint(normal, point2) {
    this.normal.copy(normal);
    this.constant = -point2.dot(this.normal);
    return this;
  }
  setFromCoplanarPoints(a3, b, c2) {
    const normal = _vector1$1.subVectors(c2, b).cross(_vector2$2.subVectors(a3, b)).normalize();
    this.setFromNormalAndCoplanarPoint(normal, a3);
    return this;
  }
  copy(plane) {
    this.normal.copy(plane.normal);
    this.constant = plane.constant;
    return this;
  }
  normalize() {
    const inverseNormalLength = 1 / this.normal.length();
    this.normal.multiplyScalar(inverseNormalLength);
    this.constant *= inverseNormalLength;
    return this;
  }
  negate() {
    this.constant *= -1;
    this.normal.negate();
    return this;
  }
  distanceToPoint(point2) {
    return this.normal.dot(point2) + this.constant;
  }
  distanceToSphere(sphere) {
    return this.distanceToPoint(sphere.center) - sphere.radius;
  }
  projectPoint(point2, target) {
    return target.copy(point2).addScaledVector(this.normal, -this.distanceToPoint(point2));
  }
  intersectLine(line, target) {
    const direction2 = line.delta(_vector1$1);
    const denominator = this.normal.dot(direction2);
    if (denominator === 0) {
      if (this.distanceToPoint(line.start) === 0) {
        return target.copy(line.start);
      }
      return null;
    }
    const t3 = -(line.start.dot(this.normal) + this.constant) / denominator;
    if (t3 < 0 || t3 > 1) {
      return null;
    }
    return target.copy(line.start).addScaledVector(direction2, t3);
  }
  intersectsLine(line) {
    const startSign = this.distanceToPoint(line.start);
    const endSign = this.distanceToPoint(line.end);
    return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
  }
  intersectsBox(box) {
    return box.intersectsPlane(this);
  }
  intersectsSphere(sphere) {
    return sphere.intersectsPlane(this);
  }
  coplanarPoint(target) {
    return target.copy(this.normal).multiplyScalar(-this.constant);
  }
  applyMatrix4(matrix2, optionalNormalMatrix) {
    const normalMatrix = optionalNormalMatrix || _normalMatrix$1.getNormalMatrix(matrix2);
    const referencePoint = this.coplanarPoint(_vector1$1).applyMatrix4(matrix2);
    const normal = this.normal.applyMatrix3(normalMatrix).normalize();
    this.constant = -referencePoint.dot(normal);
    return this;
  }
  translate(offset) {
    this.constant -= offset.dot(this.normal);
    return this;
  }
  equals(plane) {
    return plane.normal.equals(this.normal) && plane.constant === this.constant;
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
const _sphere$3$1 = /* @__PURE__ */ new Sphere$1();
const _vector$6$1 = /* @__PURE__ */ new Vector3$1();
let Frustum$1 = class Frustum {
  constructor(p0 = new Plane$1(), p1 = new Plane$1(), p2 = new Plane$1(), p3 = new Plane$1(), p4 = new Plane$1(), p5 = new Plane$1()) {
    this.planes = [p0, p1, p2, p3, p4, p5];
  }
  set(p0, p1, p2, p3, p4, p5) {
    const planes = this.planes;
    planes[0].copy(p0);
    planes[1].copy(p1);
    planes[2].copy(p2);
    planes[3].copy(p3);
    planes[4].copy(p4);
    planes[5].copy(p5);
    return this;
  }
  copy(frustum) {
    const planes = this.planes;
    for (let i2 = 0; i2 < 6; i2++) {
      planes[i2].copy(frustum.planes[i2]);
    }
    return this;
  }
  setFromProjectionMatrix(m, coordinateSystem = WebGLCoordinateSystem) {
    const planes = this.planes;
    const me = m.elements;
    const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
    const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
    const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
    const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
    planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
    planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
    planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
    planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
    planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
    if (coordinateSystem === WebGLCoordinateSystem) {
      planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
    } else if (coordinateSystem === WebGPUCoordinateSystem) {
      planes[5].setComponents(me2, me6, me10, me14).normalize();
    } else {
      throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + coordinateSystem);
    }
    return this;
  }
  intersectsObject(object) {
    if (object.boundingSphere !== void 0) {
      if (object.boundingSphere === null) object.computeBoundingSphere();
      _sphere$3$1.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
    } else {
      const geometry = object.geometry;
      if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
      _sphere$3$1.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
    }
    return this.intersectsSphere(_sphere$3$1);
  }
  intersectsSprite(sprite) {
    _sphere$3$1.center.set(0, 0, 0);
    _sphere$3$1.radius = 0.7071067811865476;
    _sphere$3$1.applyMatrix4(sprite.matrixWorld);
    return this.intersectsSphere(_sphere$3$1);
  }
  intersectsSphere(sphere) {
    const planes = this.planes;
    const center = sphere.center;
    const negRadius = -sphere.radius;
    for (let i2 = 0; i2 < 6; i2++) {
      const distance2 = planes[i2].distanceToPoint(center);
      if (distance2 < negRadius) {
        return false;
      }
    }
    return true;
  }
  intersectsBox(box) {
    const planes = this.planes;
    for (let i2 = 0; i2 < 6; i2++) {
      const plane = planes[i2];
      _vector$6$1.x = plane.normal.x > 0 ? box.max.x : box.min.x;
      _vector$6$1.y = plane.normal.y > 0 ? box.max.y : box.min.y;
      _vector$6$1.z = plane.normal.z > 0 ? box.max.z : box.min.z;
      if (plane.distanceToPoint(_vector$6$1) < 0) {
        return false;
      }
    }
    return true;
  }
  containsPoint(point2) {
    const planes = this.planes;
    for (let i2 = 0; i2 < 6; i2++) {
      if (planes[i2].distanceToPoint(point2) < 0) {
        return false;
      }
    }
    return true;
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
function ascIdSort(a3, b) {
  return a3 - b;
}
function sortOpaque(a3, b) {
  return a3.z - b.z;
}
function sortTransparent(a3, b) {
  return b.z - a3.z;
}
class MultiDrawRenderList {
  constructor() {
    this.index = 0;
    this.pool = [];
    this.list = [];
  }
  push(start, count, z2, index2) {
    const pool = this.pool;
    const list = this.list;
    if (this.index >= pool.length) {
      pool.push({
        start: -1,
        count: -1,
        z: -1,
        index: -1
      });
    }
    const item = pool[this.index];
    list.push(item);
    this.index++;
    item.start = start;
    item.count = count;
    item.z = z2;
    item.index = index2;
  }
  reset() {
    this.list.length = 0;
    this.index = 0;
  }
}
const _matrix$1$1 = /* @__PURE__ */ new Matrix4$1();
const _whiteColor = /* @__PURE__ */ new Color$1(1, 1, 1);
const _frustum = /* @__PURE__ */ new Frustum$1();
const _box$1$2 = /* @__PURE__ */ new Box3$1();
const _sphere$2$1 = /* @__PURE__ */ new Sphere$1();
const _vector$5$1 = /* @__PURE__ */ new Vector3$1();
const _forward = /* @__PURE__ */ new Vector3$1();
const _temp = /* @__PURE__ */ new Vector3$1();
const _renderList = /* @__PURE__ */ new MultiDrawRenderList();
const _mesh$2 = /* @__PURE__ */ new Mesh$1();
const _batchIntersects$1 = [];
function copyAttributeData(src, target, targetOffset = 0) {
  const itemSize = target.itemSize;
  if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
    const vertexCount = src.count;
    for (let i2 = 0; i2 < vertexCount; i2++) {
      for (let c2 = 0; c2 < itemSize; c2++) {
        target.setComponent(i2 + targetOffset, c2, src.getComponent(i2, c2));
      }
    }
  } else {
    target.array.set(src.array, targetOffset * itemSize);
  }
  target.needsUpdate = true;
}
function copyArrayContents(src, target) {
  if (src.constructor !== target.constructor) {
    const len = Math.min(src.length, target.length);
    for (let i2 = 0; i2 < len; i2++) {
      target[i2] = src[i2];
    }
  } else {
    const len = Math.min(src.length, target.length);
    target.set(new src.constructor(src.buffer, 0, len));
  }
}
class BatchedMesh extends Mesh$1 {
  get maxInstanceCount() {
    return this._maxInstanceCount;
  }
  get instanceCount() {
    return this._instanceInfo.length - this._availableInstanceIds.length;
  }
  get unusedVertexCount() {
    return this._maxVertexCount - this._nextVertexStart;
  }
  get unusedIndexCount() {
    return this._maxIndexCount - this._nextIndexStart;
  }
  constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material) {
    super(new BufferGeometry$1(), material);
    this.isBatchedMesh = true;
    this.perObjectFrustumCulled = true;
    this.sortObjects = true;
    this.boundingBox = null;
    this.boundingSphere = null;
    this.customSort = null;
    this._instanceInfo = [];
    this._geometryInfo = [];
    this._availableInstanceIds = [];
    this._availableGeometryIds = [];
    this._nextIndexStart = 0;
    this._nextVertexStart = 0;
    this._geometryCount = 0;
    this._visibilityChanged = true;
    this._geometryInitialized = false;
    this._maxInstanceCount = maxInstanceCount;
    this._maxVertexCount = maxVertexCount;
    this._maxIndexCount = maxIndexCount;
    this._multiDrawCounts = new Int32Array(maxInstanceCount);
    this._multiDrawStarts = new Int32Array(maxInstanceCount);
    this._multiDrawCount = 0;
    this._multiDrawInstances = null;
    this._matricesTexture = null;
    this._indirectTexture = null;
    this._colorsTexture = null;
    this._initMatricesTexture();
    this._initIndirectTexture();
  }
  _initMatricesTexture() {
    let size = Math.sqrt(this._maxInstanceCount * 4);
    size = Math.ceil(size / 4) * 4;
    size = Math.max(size, 4);
    const matricesArray = new Float32Array(size * size * 4);
    const matricesTexture = new DataTexture$1(matricesArray, size, size, RGBAFormat$1, FloatType$1);
    this._matricesTexture = matricesTexture;
  }
  _initIndirectTexture() {
    let size = Math.sqrt(this._maxInstanceCount);
    size = Math.ceil(size);
    const indirectArray = new Uint32Array(size * size);
    const indirectTexture = new DataTexture$1(indirectArray, size, size, RedIntegerFormat$1, UnsignedIntType$1);
    this._indirectTexture = indirectTexture;
  }
  _initColorsTexture() {
    let size = Math.sqrt(this._maxInstanceCount);
    size = Math.ceil(size);
    const colorsArray = new Float32Array(size * size * 4).fill(1);
    const colorsTexture = new DataTexture$1(colorsArray, size, size, RGBAFormat$1, FloatType$1);
    colorsTexture.colorSpace = ColorManagement.workingColorSpace;
    this._colorsTexture = colorsTexture;
  }
  _initializeGeometry(reference) {
    const geometry = this.geometry;
    const maxVertexCount = this._maxVertexCount;
    const maxIndexCount = this._maxIndexCount;
    if (this._geometryInitialized === false) {
      for (const attributeName in reference.attributes) {
        const srcAttribute = reference.getAttribute(attributeName);
        const { array, itemSize, normalized } = srcAttribute;
        const dstArray = new array.constructor(maxVertexCount * itemSize);
        const dstAttribute = new BufferAttribute$1(dstArray, itemSize, normalized);
        geometry.setAttribute(attributeName, dstAttribute);
      }
      if (reference.getIndex() !== null) {
        const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
        geometry.setIndex(new BufferAttribute$1(indexArray, 1));
      }
      this._geometryInitialized = true;
    }
  }
  // Make sure the geometry is compatible with the existing combined geometry attributes
  _validateGeometry(geometry) {
    const batchGeometry = this.geometry;
    if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) {
      throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
    }
    for (const attributeName in batchGeometry.attributes) {
      if (!geometry.hasAttribute(attributeName)) {
        throw new Error(`THREE.BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
      }
      const srcAttribute = geometry.getAttribute(attributeName);
      const dstAttribute = batchGeometry.getAttribute(attributeName);
      if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) {
        throw new Error("THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.");
      }
    }
  }
  validateInstanceId(instanceId) {
    const instanceInfo = this._instanceInfo;
    if (instanceId < 0 || instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) {
      throw new Error(`THREE.BatchedMesh: Invalid instanceId ${instanceId}. Instance is either out of range or has been deleted.`);
    }
  }
  validateGeometryId(geometryId) {
    const geometryInfoList = this._geometryInfo;
    if (geometryId < 0 || geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) {
      throw new Error(`THREE.BatchedMesh: Invalid geometryId ${geometryId}. Geometry is either out of range or has been deleted.`);
    }
  }
  setCustomSort(func) {
    this.customSort = func;
    return this;
  }
  computeBoundingBox() {
    if (this.boundingBox === null) {
      this.boundingBox = new Box3$1();
    }
    const boundingBox2 = this.boundingBox;
    const instanceInfo = this._instanceInfo;
    boundingBox2.makeEmpty();
    for (let i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++) {
      if (instanceInfo[i2].active === false) continue;
      const geometryId = instanceInfo[i2].geometryIndex;
      this.getMatrixAt(i2, _matrix$1$1);
      this.getBoundingBoxAt(geometryId, _box$1$2).applyMatrix4(_matrix$1$1);
      boundingBox2.union(_box$1$2);
    }
  }
  computeBoundingSphere() {
    if (this.boundingSphere === null) {
      this.boundingSphere = new Sphere$1();
    }
    const boundingSphere = this.boundingSphere;
    const instanceInfo = this._instanceInfo;
    boundingSphere.makeEmpty();
    for (let i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++) {
      if (instanceInfo[i2].active === false) continue;
      const geometryId = instanceInfo[i2].geometryIndex;
      this.getMatrixAt(i2, _matrix$1$1);
      this.getBoundingSphereAt(geometryId, _sphere$2$1).applyMatrix4(_matrix$1$1);
      boundingSphere.union(_sphere$2$1);
    }
  }
  addInstance(geometryId) {
    const atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
    if (atCapacity && this._availableInstanceIds.length === 0) {
      throw new Error("THREE.BatchedMesh: Maximum item count reached.");
    }
    const instanceInfo = {
      visible: true,
      active: true,
      geometryIndex: geometryId
    };
    let drawId = null;
    if (this._availableInstanceIds.length > 0) {
      this._availableInstanceIds.sort(ascIdSort);
      drawId = this._availableInstanceIds.shift();
      this._instanceInfo[drawId] = instanceInfo;
    } else {
      drawId = this._instanceInfo.length;
      this._instanceInfo.push(instanceInfo);
    }
    const matricesTexture = this._matricesTexture;
    _matrix$1$1.identity().toArray(matricesTexture.image.data, drawId * 16);
    matricesTexture.needsUpdate = true;
    const colorsTexture = this._colorsTexture;
    if (colorsTexture) {
      _whiteColor.toArray(colorsTexture.image.data, drawId * 4);
      colorsTexture.needsUpdate = true;
    }
    this._visibilityChanged = true;
    return drawId;
  }
  addGeometry(geometry, reservedVertexCount = -1, reservedIndexCount = -1) {
    this._initializeGeometry(geometry);
    this._validateGeometry(geometry);
    const geometryInfo = {
      // geometry information
      vertexStart: -1,
      vertexCount: -1,
      reservedVertexCount: -1,
      indexStart: -1,
      indexCount: -1,
      reservedIndexCount: -1,
      // draw range information
      start: -1,
      count: -1,
      // state
      boundingBox: null,
      boundingSphere: null,
      active: true
    };
    const geometryInfoList = this._geometryInfo;
    geometryInfo.vertexStart = this._nextVertexStart;
    geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute("position").count : reservedVertexCount;
    const index2 = geometry.getIndex();
    const hasIndex = index2 !== null;
    if (hasIndex) {
      geometryInfo.indexStart = this._nextIndexStart;
      geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index2.count : reservedIndexCount;
    }
    if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) {
      throw new Error("THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.");
    }
    let geometryId;
    if (this._availableGeometryIds.length > 0) {
      this._availableGeometryIds.sort(ascIdSort);
      geometryId = this._availableGeometryIds.shift();
      geometryInfoList[geometryId] = geometryInfo;
    } else {
      geometryId = this._geometryCount;
      this._geometryCount++;
      geometryInfoList.push(geometryInfo);
    }
    this.setGeometryAt(geometryId, geometry);
    this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
    this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
    return geometryId;
  }
  setGeometryAt(geometryId, geometry) {
    if (geometryId >= this._geometryCount) {
      throw new Error("THREE.BatchedMesh: Maximum geometry count reached.");
    }
    this._validateGeometry(geometry);
    const batchGeometry = this.geometry;
    const hasIndex = batchGeometry.getIndex() !== null;
    const dstIndex = batchGeometry.getIndex();
    const srcIndex = geometry.getIndex();
    const geometryInfo = this._geometryInfo[geometryId];
    if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) {
      throw new Error("THREE.BatchedMesh: Reserved space not large enough for provided geometry.");
    }
    const vertexStart = geometryInfo.vertexStart;
    const reservedVertexCount = geometryInfo.reservedVertexCount;
    geometryInfo.vertexCount = geometry.getAttribute("position").count;
    for (const attributeName in batchGeometry.attributes) {
      const srcAttribute = geometry.getAttribute(attributeName);
      const dstAttribute = batchGeometry.getAttribute(attributeName);
      copyAttributeData(srcAttribute, dstAttribute, vertexStart);
      const itemSize = srcAttribute.itemSize;
      for (let i2 = srcAttribute.count, l2 = reservedVertexCount; i2 < l2; i2++) {
        const index2 = vertexStart + i2;
        for (let c2 = 0; c2 < itemSize; c2++) {
          dstAttribute.setComponent(index2, c2, 0);
        }
      }
      dstAttribute.needsUpdate = true;
      dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
    }
    if (hasIndex) {
      const indexStart = geometryInfo.indexStart;
      const reservedIndexCount = geometryInfo.reservedIndexCount;
      geometryInfo.indexCount = geometry.getIndex().count;
      for (let i2 = 0; i2 < srcIndex.count; i2++) {
        dstIndex.setX(indexStart + i2, vertexStart + srcIndex.getX(i2));
      }
      for (let i2 = srcIndex.count, l2 = reservedIndexCount; i2 < l2; i2++) {
        dstIndex.setX(indexStart + i2, vertexStart);
      }
      dstIndex.needsUpdate = true;
      dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
    }
    geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
    geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
    geometryInfo.boundingBox = null;
    if (geometry.boundingBox !== null) {
      geometryInfo.boundingBox = geometry.boundingBox.clone();
    }
    geometryInfo.boundingSphere = null;
    if (geometry.boundingSphere !== null) {
      geometryInfo.boundingSphere = geometry.boundingSphere.clone();
    }
    this._visibilityChanged = true;
    return geometryId;
  }
  deleteGeometry(geometryId) {
    const geometryInfoList = this._geometryInfo;
    if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) {
      return this;
    }
    const instanceInfo = this._instanceInfo;
    for (let i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++) {
      if (instanceInfo[i2].geometryIndex === geometryId) {
        this.deleteInstance(i2);
      }
    }
    geometryInfoList[geometryId].active = false;
    this._availableGeometryIds.push(geometryId);
    this._visibilityChanged = true;
    return this;
  }
  deleteInstance(instanceId) {
    this.validateInstanceId(instanceId);
    this._instanceInfo[instanceId].active = false;
    this._availableInstanceIds.push(instanceId);
    this._visibilityChanged = true;
    return this;
  }
  optimize() {
    let nextVertexStart = 0;
    let nextIndexStart = 0;
    const geometryInfoList = this._geometryInfo;
    const indices = geometryInfoList.map((e2, i2) => i2).sort((a3, b) => {
      return geometryInfoList[a3].vertexStart - geometryInfoList[b].vertexStart;
    });
    const geometry = this.geometry;
    for (let i2 = 0, l2 = geometryInfoList.length; i2 < l2; i2++) {
      const index2 = indices[i2];
      const geometryInfo = geometryInfoList[index2];
      if (geometryInfo.active === false) {
        continue;
      }
      if (geometry.index !== null) {
        if (geometryInfo.indexStart !== nextIndexStart) {
          const { indexStart, vertexStart, reservedIndexCount } = geometryInfo;
          const index3 = geometry.index;
          const array = index3.array;
          const elementDelta = nextVertexStart - vertexStart;
          for (let j = indexStart; j < indexStart + reservedIndexCount; j++) {
            array[j] = array[j] + elementDelta;
          }
          index3.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
          index3.addUpdateRange(nextIndexStart, reservedIndexCount);
          geometryInfo.indexStart = nextIndexStart;
        }
        nextIndexStart += geometryInfo.reservedIndexCount;
      }
      if (geometryInfo.vertexStart !== nextVertexStart) {
        const { vertexStart, reservedVertexCount } = geometryInfo;
        const attributes = geometry.attributes;
        for (const key in attributes) {
          const attribute = attributes[key];
          const { array, itemSize } = attribute;
          array.copyWithin(nextVertexStart * itemSize, vertexStart * itemSize, (vertexStart + reservedVertexCount) * itemSize);
          attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
        }
        geometryInfo.vertexStart = nextVertexStart;
      }
      nextVertexStart += geometryInfo.reservedVertexCount;
      geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
      this._nextIndexStart = geometry.index ? geometryInfo.indexStart + geometryInfo.reservedIndexCount : 0;
      this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
    }
    return this;
  }
  // get bounding box and compute it if it doesn't exist
  getBoundingBoxAt(geometryId, target) {
    if (geometryId >= this._geometryCount) {
      return null;
    }
    const geometry = this.geometry;
    const geometryInfo = this._geometryInfo[geometryId];
    if (geometryInfo.boundingBox === null) {
      const box = new Box3$1();
      const index2 = geometry.index;
      const position2 = geometry.attributes.position;
      for (let i2 = geometryInfo.start, l2 = geometryInfo.start + geometryInfo.count; i2 < l2; i2++) {
        let iv = i2;
        if (index2) {
          iv = index2.getX(iv);
        }
        box.expandByPoint(_vector$5$1.fromBufferAttribute(position2, iv));
      }
      geometryInfo.boundingBox = box;
    }
    target.copy(geometryInfo.boundingBox);
    return target;
  }
  // get bounding sphere and compute it if it doesn't exist
  getBoundingSphereAt(geometryId, target) {
    if (geometryId >= this._geometryCount) {
      return null;
    }
    const geometry = this.geometry;
    const geometryInfo = this._geometryInfo[geometryId];
    if (geometryInfo.boundingSphere === null) {
      const sphere = new Sphere$1();
      this.getBoundingBoxAt(geometryId, _box$1$2);
      _box$1$2.getCenter(sphere.center);
      const index2 = geometry.index;
      const position2 = geometry.attributes.position;
      let maxRadiusSq = 0;
      for (let i2 = geometryInfo.start, l2 = geometryInfo.start + geometryInfo.count; i2 < l2; i2++) {
        let iv = i2;
        if (index2) {
          iv = index2.getX(iv);
        }
        _vector$5$1.fromBufferAttribute(position2, iv);
        maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared(_vector$5$1));
      }
      sphere.radius = Math.sqrt(maxRadiusSq);
      geometryInfo.boundingSphere = sphere;
    }
    target.copy(geometryInfo.boundingSphere);
    return target;
  }
  setMatrixAt(instanceId, matrix2) {
    this.validateInstanceId(instanceId);
    const matricesTexture = this._matricesTexture;
    const matricesArray = this._matricesTexture.image.data;
    matrix2.toArray(matricesArray, instanceId * 16);
    matricesTexture.needsUpdate = true;
    return this;
  }
  getMatrixAt(instanceId, matrix2) {
    this.validateInstanceId(instanceId);
    return matrix2.fromArray(this._matricesTexture.image.data, instanceId * 16);
  }
  setColorAt(instanceId, color2) {
    this.validateInstanceId(instanceId);
    if (this._colorsTexture === null) {
      this._initColorsTexture();
    }
    color2.toArray(this._colorsTexture.image.data, instanceId * 4);
    this._colorsTexture.needsUpdate = true;
    return this;
  }
  getColorAt(instanceId, color2) {
    this.validateInstanceId(instanceId);
    return color2.fromArray(this._colorsTexture.image.data, instanceId * 4);
  }
  setVisibleAt(instanceId, value) {
    this.validateInstanceId(instanceId);
    if (this._instanceInfo[instanceId].visible === value) {
      return this;
    }
    this._instanceInfo[instanceId].visible = value;
    this._visibilityChanged = true;
    return this;
  }
  getVisibleAt(instanceId) {
    this.validateInstanceId(instanceId);
    return this._instanceInfo[instanceId].visible;
  }
  setGeometryIdAt(instanceId, geometryId) {
    this.validateInstanceId(instanceId);
    this.validateGeometryId(geometryId);
    this._instanceInfo[instanceId].geometryIndex = geometryId;
    return this;
  }
  getGeometryIdAt(instanceId) {
    this.validateInstanceId(instanceId);
    return this._instanceInfo[instanceId].geometryIndex;
  }
  getGeometryRangeAt(geometryId, target = {}) {
    this.validateGeometryId(geometryId);
    const geometryInfo = this._geometryInfo[geometryId];
    target.vertexStart = geometryInfo.vertexStart;
    target.vertexCount = geometryInfo.vertexCount;
    target.reservedVertexCount = geometryInfo.reservedVertexCount;
    target.indexStart = geometryInfo.indexStart;
    target.indexCount = geometryInfo.indexCount;
    target.reservedIndexCount = geometryInfo.reservedIndexCount;
    target.start = geometryInfo.start;
    target.count = geometryInfo.count;
    return target;
  }
  setInstanceCount(maxInstanceCount) {
    const availableInstanceIds = this._availableInstanceIds;
    const instanceInfo = this._instanceInfo;
    availableInstanceIds.sort(ascIdSort);
    while (availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length) {
      instanceInfo.pop();
      availableInstanceIds.pop();
    }
    if (maxInstanceCount < instanceInfo.length) {
      throw new Error(`BatchedMesh: Instance ids outside the range ${maxInstanceCount} are being used. Cannot shrink instance count.`);
    }
    const multiDrawCounts = new Int32Array(maxInstanceCount);
    const multiDrawStarts = new Int32Array(maxInstanceCount);
    copyArrayContents(this._multiDrawCounts, multiDrawCounts);
    copyArrayContents(this._multiDrawStarts, multiDrawStarts);
    this._multiDrawCounts = multiDrawCounts;
    this._multiDrawStarts = multiDrawStarts;
    this._maxInstanceCount = maxInstanceCount;
    const indirectTexture = this._indirectTexture;
    const matricesTexture = this._matricesTexture;
    const colorsTexture = this._colorsTexture;
    indirectTexture.dispose();
    this._initIndirectTexture();
    copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
    matricesTexture.dispose();
    this._initMatricesTexture();
    copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
    if (colorsTexture) {
      colorsTexture.dispose();
      this._initColorsTexture();
      copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
    }
  }
  setGeometrySize(maxVertexCount, maxIndexCount) {
    const validRanges = [...this._geometryInfo].filter((info) => info.active);
    const requiredVertexLength = Math.max(...validRanges.map((range) => range.vertexStart + range.reservedVertexCount));
    if (requiredVertexLength > maxVertexCount) {
      throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
    }
    if (this.geometry.index) {
      const requiredIndexLength = Math.max(...validRanges.map((range) => range.indexStart + range.reservedIndexCount));
      if (requiredIndexLength > maxIndexCount) {
        throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
      }
    }
    const oldGeometry = this.geometry;
    oldGeometry.dispose();
    this._maxVertexCount = maxVertexCount;
    this._maxIndexCount = maxIndexCount;
    if (this._geometryInitialized) {
      this._geometryInitialized = false;
      this.geometry = new BufferGeometry$1();
      this._initializeGeometry(oldGeometry);
    }
    const geometry = this.geometry;
    if (oldGeometry.index) {
      copyArrayContents(oldGeometry.index.array, geometry.index.array);
    }
    for (const key in oldGeometry.attributes) {
      copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
    }
  }
  raycast(raycaster, intersects2) {
    const instanceInfo = this._instanceInfo;
    const geometryInfoList = this._geometryInfo;
    const matrixWorld = this.matrixWorld;
    const batchGeometry = this.geometry;
    _mesh$2.material = this.material;
    _mesh$2.geometry.index = batchGeometry.index;
    _mesh$2.geometry.attributes = batchGeometry.attributes;
    if (_mesh$2.geometry.boundingBox === null) {
      _mesh$2.geometry.boundingBox = new Box3$1();
    }
    if (_mesh$2.geometry.boundingSphere === null) {
      _mesh$2.geometry.boundingSphere = new Sphere$1();
    }
    for (let i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++) {
      if (!instanceInfo[i2].visible || !instanceInfo[i2].active) {
        continue;
      }
      const geometryId = instanceInfo[i2].geometryIndex;
      const geometryInfo = geometryInfoList[geometryId];
      _mesh$2.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
      this.getMatrixAt(i2, _mesh$2.matrixWorld).premultiply(matrixWorld);
      this.getBoundingBoxAt(geometryId, _mesh$2.geometry.boundingBox);
      this.getBoundingSphereAt(geometryId, _mesh$2.geometry.boundingSphere);
      _mesh$2.raycast(raycaster, _batchIntersects$1);
      for (let j = 0, l3 = _batchIntersects$1.length; j < l3; j++) {
        const intersect2 = _batchIntersects$1[j];
        intersect2.object = this;
        intersect2.batchId = i2;
        intersects2.push(intersect2);
      }
      _batchIntersects$1.length = 0;
    }
    _mesh$2.material = null;
    _mesh$2.geometry.index = null;
    _mesh$2.geometry.attributes = {};
    _mesh$2.geometry.setDrawRange(0, Infinity);
  }
  copy(source) {
    super.copy(source);
    this.geometry = source.geometry.clone();
    this.perObjectFrustumCulled = source.perObjectFrustumCulled;
    this.sortObjects = source.sortObjects;
    this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
    this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
    this._geometryInfo = source._geometryInfo.map((info) => ({
      ...info,
      boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
      boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
    }));
    this._instanceInfo = source._instanceInfo.map((info) => ({ ...info }));
    this._maxInstanceCount = source._maxInstanceCount;
    this._maxVertexCount = source._maxVertexCount;
    this._maxIndexCount = source._maxIndexCount;
    this._geometryInitialized = source._geometryInitialized;
    this._geometryCount = source._geometryCount;
    this._multiDrawCounts = source._multiDrawCounts.slice();
    this._multiDrawStarts = source._multiDrawStarts.slice();
    this._matricesTexture = source._matricesTexture.clone();
    this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
    if (this._colorsTexture !== null) {
      this._colorsTexture = source._colorsTexture.clone();
      this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
    }
    return this;
  }
  dispose() {
    this.geometry.dispose();
    this._matricesTexture.dispose();
    this._matricesTexture = null;
    this._indirectTexture.dispose();
    this._indirectTexture = null;
    if (this._colorsTexture !== null) {
      this._colorsTexture.dispose();
      this._colorsTexture = null;
    }
    return this;
  }
  onBeforeRender(renderer, scene, camera, geometry, material) {
    if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) {
      return;
    }
    const index2 = geometry.getIndex();
    const bytesPerElement = index2 === null ? 1 : index2.array.BYTES_PER_ELEMENT;
    const instanceInfo = this._instanceInfo;
    const multiDrawStarts = this._multiDrawStarts;
    const multiDrawCounts = this._multiDrawCounts;
    const geometryInfoList = this._geometryInfo;
    const perObjectFrustumCulled = this.perObjectFrustumCulled;
    const indirectTexture = this._indirectTexture;
    const indirectArray = indirectTexture.image.data;
    if (perObjectFrustumCulled) {
      _matrix$1$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
      _frustum.setFromProjectionMatrix(
        _matrix$1$1,
        renderer.coordinateSystem
      );
    }
    let multiDrawCount = 0;
    if (this.sortObjects) {
      _matrix$1$1.copy(this.matrixWorld).invert();
      _vector$5$1.setFromMatrixPosition(camera.matrixWorld).applyMatrix4(_matrix$1$1);
      _forward.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection(_matrix$1$1);
      for (let i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++) {
        if (instanceInfo[i2].visible && instanceInfo[i2].active) {
          const geometryId = instanceInfo[i2].geometryIndex;
          this.getMatrixAt(i2, _matrix$1$1);
          this.getBoundingSphereAt(geometryId, _sphere$2$1).applyMatrix4(_matrix$1$1);
          let culled = false;
          if (perObjectFrustumCulled) {
            culled = !_frustum.intersectsSphere(_sphere$2$1);
          }
          if (!culled) {
            const geometryInfo = geometryInfoList[geometryId];
            const z2 = _temp.subVectors(_sphere$2$1.center, _vector$5$1).dot(_forward);
            _renderList.push(geometryInfo.start, geometryInfo.count, z2, i2);
          }
        }
      }
      const list = _renderList.list;
      const customSort = this.customSort;
      if (customSort === null) {
        list.sort(material.transparent ? sortTransparent : sortOpaque);
      } else {
        customSort.call(this, list, camera);
      }
      for (let i2 = 0, l2 = list.length; i2 < l2; i2++) {
        const item = list[i2];
        multiDrawStarts[multiDrawCount] = item.start * bytesPerElement;
        multiDrawCounts[multiDrawCount] = item.count;
        indirectArray[multiDrawCount] = item.index;
        multiDrawCount++;
      }
      _renderList.reset();
    } else {
      for (let i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++) {
        if (instanceInfo[i2].visible && instanceInfo[i2].active) {
          const geometryId = instanceInfo[i2].geometryIndex;
          let culled = false;
          if (perObjectFrustumCulled) {
            this.getMatrixAt(i2, _matrix$1$1);
            this.getBoundingSphereAt(geometryId, _sphere$2$1).applyMatrix4(_matrix$1$1);
            culled = !_frustum.intersectsSphere(_sphere$2$1);
          }
          if (!culled) {
            const geometryInfo = geometryInfoList[geometryId];
            multiDrawStarts[multiDrawCount] = geometryInfo.start * bytesPerElement;
            multiDrawCounts[multiDrawCount] = geometryInfo.count;
            indirectArray[multiDrawCount] = i2;
            multiDrawCount++;
          }
        }
      }
    }
    indirectTexture.needsUpdate = true;
    this._multiDrawCount = multiDrawCount;
    this._visibilityChanged = false;
  }
  onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial) {
    this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
  }
}
let LineBasicMaterial$1 = class LineBasicMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isLineBasicMaterial = true;
    this.type = "LineBasicMaterial";
    this.color = new Color$1(16777215);
    this.map = null;
    this.linewidth = 1;
    this.linecap = "round";
    this.linejoin = "round";
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.linewidth = source.linewidth;
    this.linecap = source.linecap;
    this.linejoin = source.linejoin;
    this.fog = source.fog;
    return this;
  }
};
const _vStart = /* @__PURE__ */ new Vector3$1();
const _vEnd = /* @__PURE__ */ new Vector3$1();
const _inverseMatrix$1$1 = /* @__PURE__ */ new Matrix4$1();
const _ray$1$1 = /* @__PURE__ */ new Ray$1();
const _sphere$1$1 = /* @__PURE__ */ new Sphere$1();
const _intersectPointOnRay = /* @__PURE__ */ new Vector3$1();
const _intersectPointOnSegment = /* @__PURE__ */ new Vector3$1();
let Line$1 = class Line extends Object3D$1 {
  constructor(geometry = new BufferGeometry$1(), material = new LineBasicMaterial$1()) {
    super();
    this.isLine = true;
    this.type = "Line";
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
    this.geometry = source.geometry;
    return this;
  }
  computeLineDistances() {
    const geometry = this.geometry;
    if (geometry.index === null) {
      const positionAttribute = geometry.attributes.position;
      const lineDistances = [0];
      for (let i2 = 1, l2 = positionAttribute.count; i2 < l2; i2++) {
        _vStart.fromBufferAttribute(positionAttribute, i2 - 1);
        _vEnd.fromBufferAttribute(positionAttribute, i2);
        lineDistances[i2] = lineDistances[i2 - 1];
        lineDistances[i2] += _vStart.distanceTo(_vEnd);
      }
      geometry.setAttribute("lineDistance", new Float32BufferAttribute$1(lineDistances, 1));
    } else {
      console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    }
    return this;
  }
  raycast(raycaster, intersects2) {
    const geometry = this.geometry;
    const matrixWorld = this.matrixWorld;
    const threshold = raycaster.params.Line.threshold;
    const drawRange = geometry.drawRange;
    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
    _sphere$1$1.copy(geometry.boundingSphere);
    _sphere$1$1.applyMatrix4(matrixWorld);
    _sphere$1$1.radius += threshold;
    if (raycaster.ray.intersectsSphere(_sphere$1$1) === false) return;
    _inverseMatrix$1$1.copy(matrixWorld).invert();
    _ray$1$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$1$1);
    const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
    const localThresholdSq = localThreshold * localThreshold;
    const step = this.isLineSegments ? 2 : 1;
    const index2 = geometry.index;
    const attributes = geometry.attributes;
    const positionAttribute = attributes.position;
    if (index2 !== null) {
      const start = Math.max(0, drawRange.start);
      const end = Math.min(index2.count, drawRange.start + drawRange.count);
      for (let i2 = start, l2 = end - 1; i2 < l2; i2 += step) {
        const a3 = index2.getX(i2);
        const b = index2.getX(i2 + 1);
        const intersect2 = checkIntersection$2(this, raycaster, _ray$1$1, localThresholdSq, a3, b);
        if (intersect2) {
          intersects2.push(intersect2);
        }
      }
      if (this.isLineLoop) {
        const a3 = index2.getX(end - 1);
        const b = index2.getX(start);
        const intersect2 = checkIntersection$2(this, raycaster, _ray$1$1, localThresholdSq, a3, b);
        if (intersect2) {
          intersects2.push(intersect2);
        }
      }
    } else {
      const start = Math.max(0, drawRange.start);
      const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
      for (let i2 = start, l2 = end - 1; i2 < l2; i2 += step) {
        const intersect2 = checkIntersection$2(this, raycaster, _ray$1$1, localThresholdSq, i2, i2 + 1);
        if (intersect2) {
          intersects2.push(intersect2);
        }
      }
      if (this.isLineLoop) {
        const intersect2 = checkIntersection$2(this, raycaster, _ray$1$1, localThresholdSq, end - 1, start);
        if (intersect2) {
          intersects2.push(intersect2);
        }
      }
    }
  }
  updateMorphTargets() {
    const geometry = this.geometry;
    const morphAttributes = geometry.morphAttributes;
    const keys = Object.keys(morphAttributes);
    if (keys.length > 0) {
      const morphAttribute = morphAttributes[keys[0]];
      if (morphAttribute !== void 0) {
        this.morphTargetInfluences = [];
        this.morphTargetDictionary = {};
        for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
          const name = morphAttribute[m].name || String(m);
          this.morphTargetInfluences.push(0);
          this.morphTargetDictionary[name] = m;
        }
      }
    }
  }
};
function checkIntersection$2(object, raycaster, ray2, thresholdSq, a3, b) {
  const positionAttribute = object.geometry.attributes.position;
  _vStart.fromBufferAttribute(positionAttribute, a3);
  _vEnd.fromBufferAttribute(positionAttribute, b);
  const distSq = ray2.distanceSqToSegment(_vStart, _vEnd, _intersectPointOnRay, _intersectPointOnSegment);
  if (distSq > thresholdSq) return;
  _intersectPointOnRay.applyMatrix4(object.matrixWorld);
  const distance2 = raycaster.ray.origin.distanceTo(_intersectPointOnRay);
  if (distance2 < raycaster.near || distance2 > raycaster.far) return;
  return {
    distance: distance2,
    // What do we want? intersection point on the ray or on the segment??
    // point: raycaster.ray.at( distance ),
    point: _intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
    index: a3,
    face: null,
    faceIndex: null,
    barycoord: null,
    object
  };
}
const _start$3 = /* @__PURE__ */ new Vector3$1();
const _end$3 = /* @__PURE__ */ new Vector3$1();
let LineSegments$1 = class LineSegments extends Line$1 {
  constructor(geometry, material) {
    super(geometry, material);
    this.isLineSegments = true;
    this.type = "LineSegments";
  }
  computeLineDistances() {
    const geometry = this.geometry;
    if (geometry.index === null) {
      const positionAttribute = geometry.attributes.position;
      const lineDistances = [];
      for (let i2 = 0, l2 = positionAttribute.count; i2 < l2; i2 += 2) {
        _start$3.fromBufferAttribute(positionAttribute, i2);
        _end$3.fromBufferAttribute(positionAttribute, i2 + 1);
        lineDistances[i2] = i2 === 0 ? 0 : lineDistances[i2 - 1];
        lineDistances[i2 + 1] = lineDistances[i2] + _start$3.distanceTo(_end$3);
      }
      geometry.setAttribute("lineDistance", new Float32BufferAttribute$1(lineDistances, 1));
    } else {
      console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    }
    return this;
  }
};
let LineLoop$1 = class LineLoop extends Line$1 {
  constructor(geometry, material) {
    super(geometry, material);
    this.isLineLoop = true;
    this.type = "LineLoop";
  }
};
let PointsMaterial$1 = class PointsMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isPointsMaterial = true;
    this.type = "PointsMaterial";
    this.color = new Color$1(16777215);
    this.map = null;
    this.alphaMap = null;
    this.size = 1;
    this.sizeAttenuation = true;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.size = source.size;
    this.sizeAttenuation = source.sizeAttenuation;
    this.fog = source.fog;
    return this;
  }
};
const _inverseMatrix$4 = /* @__PURE__ */ new Matrix4$1();
const _ray$4 = /* @__PURE__ */ new Ray$1();
const _sphere$7 = /* @__PURE__ */ new Sphere$1();
const _position$2$1 = /* @__PURE__ */ new Vector3$1();
let Points$1 = class Points extends Object3D$1 {
  constructor(geometry = new BufferGeometry$1(), material = new PointsMaterial$1()) {
    super();
    this.isPoints = true;
    this.type = "Points";
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
    this.geometry = source.geometry;
    return this;
  }
  raycast(raycaster, intersects2) {
    const geometry = this.geometry;
    const matrixWorld = this.matrixWorld;
    const threshold = raycaster.params.Points.threshold;
    const drawRange = geometry.drawRange;
    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
    _sphere$7.copy(geometry.boundingSphere);
    _sphere$7.applyMatrix4(matrixWorld);
    _sphere$7.radius += threshold;
    if (raycaster.ray.intersectsSphere(_sphere$7) === false) return;
    _inverseMatrix$4.copy(matrixWorld).invert();
    _ray$4.copy(raycaster.ray).applyMatrix4(_inverseMatrix$4);
    const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
    const localThresholdSq = localThreshold * localThreshold;
    const index2 = geometry.index;
    const attributes = geometry.attributes;
    const positionAttribute = attributes.position;
    if (index2 !== null) {
      const start = Math.max(0, drawRange.start);
      const end = Math.min(index2.count, drawRange.start + drawRange.count);
      for (let i2 = start, il = end; i2 < il; i2++) {
        const a3 = index2.getX(i2);
        _position$2$1.fromBufferAttribute(positionAttribute, a3);
        testPoint$1(_position$2$1, a3, localThresholdSq, matrixWorld, raycaster, intersects2, this);
      }
    } else {
      const start = Math.max(0, drawRange.start);
      const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
      for (let i2 = start, l2 = end; i2 < l2; i2++) {
        _position$2$1.fromBufferAttribute(positionAttribute, i2);
        testPoint$1(_position$2$1, i2, localThresholdSq, matrixWorld, raycaster, intersects2, this);
      }
    }
  }
  updateMorphTargets() {
    const geometry = this.geometry;
    const morphAttributes = geometry.morphAttributes;
    const keys = Object.keys(morphAttributes);
    if (keys.length > 0) {
      const morphAttribute = morphAttributes[keys[0]];
      if (morphAttribute !== void 0) {
        this.morphTargetInfluences = [];
        this.morphTargetDictionary = {};
        for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
          const name = morphAttribute[m].name || String(m);
          this.morphTargetInfluences.push(0);
          this.morphTargetDictionary[name] = m;
        }
      }
    }
  }
};
function testPoint$1(point2, index2, localThresholdSq, matrixWorld, raycaster, intersects2, object) {
  const rayPointDistanceSq = _ray$4.distanceSqToPoint(point2);
  if (rayPointDistanceSq < localThresholdSq) {
    const intersectPoint = new Vector3$1();
    _ray$4.closestPointToPoint(point2, intersectPoint);
    intersectPoint.applyMatrix4(matrixWorld);
    const distance2 = raycaster.ray.origin.distanceTo(intersectPoint);
    if (distance2 < raycaster.near || distance2 > raycaster.far) return;
    intersects2.push({
      distance: distance2,
      distanceToRay: Math.sqrt(rayPointDistanceSq),
      point: intersectPoint,
      index: index2,
      face: null,
      faceIndex: null,
      barycoord: null,
      object
    });
  }
}
let Group$1 = class Group extends Object3D$1 {
  constructor() {
    super();
    this.isGroup = true;
    this.type = "Group";
  }
};
let VideoTexture$1 = class VideoTexture extends Texture$1 {
  constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.isVideoTexture = true;
    this.minFilter = minFilter !== void 0 ? minFilter : LinearFilter$1;
    this.magFilter = magFilter !== void 0 ? magFilter : LinearFilter$1;
    this.generateMipmaps = false;
    const scope = this;
    function updateVideo() {
      scope.needsUpdate = true;
      video.requestVideoFrameCallback(updateVideo);
    }
    if ("requestVideoFrameCallback" in video) {
      video.requestVideoFrameCallback(updateVideo);
    }
  }
  clone() {
    return new this.constructor(this.image).copy(this);
  }
  update() {
    const video = this.image;
    const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
    if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) {
      this.needsUpdate = true;
    }
  }
};
class FramebufferTexture extends Texture$1 {
  constructor(width, height) {
    super({ width, height });
    this.isFramebufferTexture = true;
    this.magFilter = NearestFilter$1;
    this.minFilter = NearestFilter$1;
    this.generateMipmaps = false;
    this.needsUpdate = true;
  }
}
let CompressedTexture$1 = class CompressedTexture extends Texture$1 {
  constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace) {
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
    this.isCompressedTexture = true;
    this.image = { width, height };
    this.mipmaps = mipmaps;
    this.flipY = false;
    this.generateMipmaps = false;
  }
};
class CompressedArrayTexture extends CompressedTexture$1 {
  constructor(mipmaps, width, height, depth, format, type) {
    super(mipmaps, width, height, format, type);
    this.isCompressedArrayTexture = true;
    this.image.depth = depth;
    this.wrapR = ClampToEdgeWrapping$1;
    this.layerUpdates = /* @__PURE__ */ new Set();
  }
  addLayerUpdate(layerIndex) {
    this.layerUpdates.add(layerIndex);
  }
  clearLayerUpdates() {
    this.layerUpdates.clear();
  }
}
class CompressedCubeTexture extends CompressedTexture$1 {
  constructor(images, format, type) {
    super(void 0, images[0].width, images[0].height, format, type, CubeReflectionMapping$1);
    this.isCompressedCubeTexture = true;
    this.isCubeTexture = true;
    this.image = images;
  }
}
let CanvasTexture$1 = class CanvasTexture extends Texture$1 {
  constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.isCanvasTexture = true;
    this.needsUpdate = true;
  }
};
let DepthTexture$1 = class DepthTexture extends Texture$1 {
  constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format = DepthFormat$1) {
    if (format !== DepthFormat$1 && format !== DepthStencilFormat$1) {
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    }
    if (type === void 0 && format === DepthFormat$1) type = UnsignedIntType$1;
    if (type === void 0 && format === DepthStencilFormat$1) type = UnsignedInt248Type$1;
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.isDepthTexture = true;
    this.image = { width, height };
    this.magFilter = magFilter !== void 0 ? magFilter : NearestFilter$1;
    this.minFilter = minFilter !== void 0 ? minFilter : NearestFilter$1;
    this.flipY = false;
    this.generateMipmaps = false;
    this.compareFunction = null;
  }
  copy(source) {
    super.copy(source);
    this.compareFunction = source.compareFunction;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
    return data;
  }
};
let Curve$1 = class Curve {
  constructor() {
    this.type = "Curve";
    this.arcLengthDivisions = 200;
  }
  // Virtual base class method to overwrite and implement in subclasses
  //	- t [0 .. 1]
  getPoint() {
    console.warn("THREE.Curve: .getPoint() not implemented.");
    return null;
  }
  // Get point at relative position in curve according to arc length
  // - u [0 .. 1]
  getPointAt(u3, optionalTarget) {
    const t3 = this.getUtoTmapping(u3);
    return this.getPoint(t3, optionalTarget);
  }
  // Get sequence of points using getPoint( t )
  getPoints(divisions = 5) {
    const points = [];
    for (let d2 = 0; d2 <= divisions; d2++) {
      points.push(this.getPoint(d2 / divisions));
    }
    return points;
  }
  // Get sequence of points using getPointAt( u )
  getSpacedPoints(divisions = 5) {
    const points = [];
    for (let d2 = 0; d2 <= divisions; d2++) {
      points.push(this.getPointAt(d2 / divisions));
    }
    return points;
  }
  // Get total curve arc length
  getLength() {
    const lengths = this.getLengths();
    return lengths[lengths.length - 1];
  }
  // Get list of cumulative segment lengths
  getLengths(divisions = this.arcLengthDivisions) {
    if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) {
      return this.cacheArcLengths;
    }
    this.needsUpdate = false;
    const cache = [];
    let current, last = this.getPoint(0);
    let sum = 0;
    cache.push(0);
    for (let p2 = 1; p2 <= divisions; p2++) {
      current = this.getPoint(p2 / divisions);
      sum += current.distanceTo(last);
      cache.push(sum);
      last = current;
    }
    this.cacheArcLengths = cache;
    return cache;
  }
  updateArcLengths() {
    this.needsUpdate = true;
    this.getLengths();
  }
  // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
  getUtoTmapping(u3, distance2) {
    const arcLengths = this.getLengths();
    let i2 = 0;
    const il = arcLengths.length;
    let targetArcLength;
    if (distance2) {
      targetArcLength = distance2;
    } else {
      targetArcLength = u3 * arcLengths[il - 1];
    }
    let low = 0, high = il - 1, comparison;
    while (low <= high) {
      i2 = Math.floor(low + (high - low) / 2);
      comparison = arcLengths[i2] - targetArcLength;
      if (comparison < 0) {
        low = i2 + 1;
      } else if (comparison > 0) {
        high = i2 - 1;
      } else {
        high = i2;
        break;
      }
    }
    i2 = high;
    if (arcLengths[i2] === targetArcLength) {
      return i2 / (il - 1);
    }
    const lengthBefore = arcLengths[i2];
    const lengthAfter = arcLengths[i2 + 1];
    const segmentLength = lengthAfter - lengthBefore;
    const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
    const t3 = (i2 + segmentFraction) / (il - 1);
    return t3;
  }
  // Returns a unit vector tangent at t
  // In case any sub curve does not implement its tangent derivation,
  // 2 points a small delta apart will be used to find its gradient
  // which seems to give a reasonable approximation
  getTangent(t3, optionalTarget) {
    const delta = 1e-4;
    let t1 = t3 - delta;
    let t22 = t3 + delta;
    if (t1 < 0) t1 = 0;
    if (t22 > 1) t22 = 1;
    const pt1 = this.getPoint(t1);
    const pt2 = this.getPoint(t22);
    const tangent = optionalTarget || (pt1.isVector2 ? new Vector2$1() : new Vector3$1());
    tangent.copy(pt2).sub(pt1).normalize();
    return tangent;
  }
  getTangentAt(u3, optionalTarget) {
    const t3 = this.getUtoTmapping(u3);
    return this.getTangent(t3, optionalTarget);
  }
  computeFrenetFrames(segments, closed) {
    const normal = new Vector3$1();
    const tangents = [];
    const normals = [];
    const binormals = [];
    const vec = new Vector3$1();
    const mat = new Matrix4$1();
    for (let i2 = 0; i2 <= segments; i2++) {
      const u3 = i2 / segments;
      tangents[i2] = this.getTangentAt(u3, new Vector3$1());
    }
    normals[0] = new Vector3$1();
    binormals[0] = new Vector3$1();
    let min = Number.MAX_VALUE;
    const tx = Math.abs(tangents[0].x);
    const ty = Math.abs(tangents[0].y);
    const tz = Math.abs(tangents[0].z);
    if (tx <= min) {
      min = tx;
      normal.set(1, 0, 0);
    }
    if (ty <= min) {
      min = ty;
      normal.set(0, 1, 0);
    }
    if (tz <= min) {
      normal.set(0, 0, 1);
    }
    vec.crossVectors(tangents[0], normal).normalize();
    normals[0].crossVectors(tangents[0], vec);
    binormals[0].crossVectors(tangents[0], normals[0]);
    for (let i2 = 1; i2 <= segments; i2++) {
      normals[i2] = normals[i2 - 1].clone();
      binormals[i2] = binormals[i2 - 1].clone();
      vec.crossVectors(tangents[i2 - 1], tangents[i2]);
      if (vec.length() > Number.EPSILON) {
        vec.normalize();
        const theta = Math.acos(clamp$1(tangents[i2 - 1].dot(tangents[i2]), -1, 1));
        normals[i2].applyMatrix4(mat.makeRotationAxis(vec, theta));
      }
      binormals[i2].crossVectors(tangents[i2], normals[i2]);
    }
    if (closed === true) {
      let theta = Math.acos(clamp$1(normals[0].dot(normals[segments]), -1, 1));
      theta /= segments;
      if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) {
        theta = -theta;
      }
      for (let i2 = 1; i2 <= segments; i2++) {
        normals[i2].applyMatrix4(mat.makeRotationAxis(tangents[i2], theta * i2));
        binormals[i2].crossVectors(tangents[i2], normals[i2]);
      }
    }
    return {
      tangents,
      normals,
      binormals
    };
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.arcLengthDivisions = source.arcLengthDivisions;
    return this;
  }
  toJSON() {
    const data = {
      metadata: {
        version: 4.6,
        type: "Curve",
        generator: "Curve.toJSON"
      }
    };
    data.arcLengthDivisions = this.arcLengthDivisions;
    data.type = this.type;
    return data;
  }
  fromJSON(json) {
    this.arcLengthDivisions = json.arcLengthDivisions;
    return this;
  }
};
let EllipseCurve$1 = class EllipseCurve extends Curve$1 {
  constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0) {
    super();
    this.isEllipseCurve = true;
    this.type = "EllipseCurve";
    this.aX = aX;
    this.aY = aY;
    this.xRadius = xRadius;
    this.yRadius = yRadius;
    this.aStartAngle = aStartAngle;
    this.aEndAngle = aEndAngle;
    this.aClockwise = aClockwise;
    this.aRotation = aRotation;
  }
  getPoint(t3, optionalTarget = new Vector2$1()) {
    const point2 = optionalTarget;
    const twoPi = Math.PI * 2;
    let deltaAngle = this.aEndAngle - this.aStartAngle;
    const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
    while (deltaAngle < 0) deltaAngle += twoPi;
    while (deltaAngle > twoPi) deltaAngle -= twoPi;
    if (deltaAngle < Number.EPSILON) {
      if (samePoints) {
        deltaAngle = 0;
      } else {
        deltaAngle = twoPi;
      }
    }
    if (this.aClockwise === true && !samePoints) {
      if (deltaAngle === twoPi) {
        deltaAngle = -twoPi;
      } else {
        deltaAngle = deltaAngle - twoPi;
      }
    }
    const angle2 = this.aStartAngle + t3 * deltaAngle;
    let x = this.aX + this.xRadius * Math.cos(angle2);
    let y = this.aY + this.yRadius * Math.sin(angle2);
    if (this.aRotation !== 0) {
      const cos2 = Math.cos(this.aRotation);
      const sin2 = Math.sin(this.aRotation);
      const tx = x - this.aX;
      const ty = y - this.aY;
      x = tx * cos2 - ty * sin2 + this.aX;
      y = tx * sin2 + ty * cos2 + this.aY;
    }
    return point2.set(x, y);
  }
  copy(source) {
    super.copy(source);
    this.aX = source.aX;
    this.aY = source.aY;
    this.xRadius = source.xRadius;
    this.yRadius = source.yRadius;
    this.aStartAngle = source.aStartAngle;
    this.aEndAngle = source.aEndAngle;
    this.aClockwise = source.aClockwise;
    this.aRotation = source.aRotation;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.aX = this.aX;
    data.aY = this.aY;
    data.xRadius = this.xRadius;
    data.yRadius = this.yRadius;
    data.aStartAngle = this.aStartAngle;
    data.aEndAngle = this.aEndAngle;
    data.aClockwise = this.aClockwise;
    data.aRotation = this.aRotation;
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.aX = json.aX;
    this.aY = json.aY;
    this.xRadius = json.xRadius;
    this.yRadius = json.yRadius;
    this.aStartAngle = json.aStartAngle;
    this.aEndAngle = json.aEndAngle;
    this.aClockwise = json.aClockwise;
    this.aRotation = json.aRotation;
    return this;
  }
};
let ArcCurve$1 = class ArcCurve extends EllipseCurve$1 {
  constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
    this.isArcCurve = true;
    this.type = "ArcCurve";
  }
};
function CubicPoly$1() {
  let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
  function init(x0, x1, t0, t1) {
    c0 = x0;
    c1 = t0;
    c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
    c3 = 2 * x0 - 2 * x1 + t0 + t1;
  }
  return {
    initCatmullRom: function(x0, x1, x2, x3, tension) {
      init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
    },
    initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
      let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
      let t22 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
      t1 *= dt1;
      t22 *= dt1;
      init(x1, x2, t1, t22);
    },
    calc: function(t3) {
      const t22 = t3 * t3;
      const t32 = t22 * t3;
      return c0 + c1 * t3 + c2 * t22 + c3 * t32;
    }
  };
}
const tmp$1 = /* @__PURE__ */ new Vector3$1();
const px$1 = /* @__PURE__ */ new CubicPoly$1();
const py$1 = /* @__PURE__ */ new CubicPoly$1();
const pz$1 = /* @__PURE__ */ new CubicPoly$1();
let CatmullRomCurve3$1 = class CatmullRomCurve3 extends Curve$1 {
  constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5) {
    super();
    this.isCatmullRomCurve3 = true;
    this.type = "CatmullRomCurve3";
    this.points = points;
    this.closed = closed;
    this.curveType = curveType;
    this.tension = tension;
  }
  getPoint(t3, optionalTarget = new Vector3$1()) {
    const point2 = optionalTarget;
    const points = this.points;
    const l2 = points.length;
    const p2 = (l2 - (this.closed ? 0 : 1)) * t3;
    let intPoint = Math.floor(p2);
    let weight = p2 - intPoint;
    if (this.closed) {
      intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l2) + 1) * l2;
    } else if (weight === 0 && intPoint === l2 - 1) {
      intPoint = l2 - 2;
      weight = 1;
    }
    let p0, p3;
    if (this.closed || intPoint > 0) {
      p0 = points[(intPoint - 1) % l2];
    } else {
      tmp$1.subVectors(points[0], points[1]).add(points[0]);
      p0 = tmp$1;
    }
    const p1 = points[intPoint % l2];
    const p22 = points[(intPoint + 1) % l2];
    if (this.closed || intPoint + 2 < l2) {
      p3 = points[(intPoint + 2) % l2];
    } else {
      tmp$1.subVectors(points[l2 - 1], points[l2 - 2]).add(points[l2 - 1]);
      p3 = tmp$1;
    }
    if (this.curveType === "centripetal" || this.curveType === "chordal") {
      const pow = this.curveType === "chordal" ? 0.5 : 0.25;
      let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
      let dt1 = Math.pow(p1.distanceToSquared(p22), pow);
      let dt2 = Math.pow(p22.distanceToSquared(p3), pow);
      if (dt1 < 1e-4) dt1 = 1;
      if (dt0 < 1e-4) dt0 = dt1;
      if (dt2 < 1e-4) dt2 = dt1;
      px$1.initNonuniformCatmullRom(p0.x, p1.x, p22.x, p3.x, dt0, dt1, dt2);
      py$1.initNonuniformCatmullRom(p0.y, p1.y, p22.y, p3.y, dt0, dt1, dt2);
      pz$1.initNonuniformCatmullRom(p0.z, p1.z, p22.z, p3.z, dt0, dt1, dt2);
    } else if (this.curveType === "catmullrom") {
      px$1.initCatmullRom(p0.x, p1.x, p22.x, p3.x, this.tension);
      py$1.initCatmullRom(p0.y, p1.y, p22.y, p3.y, this.tension);
      pz$1.initCatmullRom(p0.z, p1.z, p22.z, p3.z, this.tension);
    }
    point2.set(
      px$1.calc(weight),
      py$1.calc(weight),
      pz$1.calc(weight)
    );
    return point2;
  }
  copy(source) {
    super.copy(source);
    this.points = [];
    for (let i2 = 0, l2 = source.points.length; i2 < l2; i2++) {
      const point2 = source.points[i2];
      this.points.push(point2.clone());
    }
    this.closed = source.closed;
    this.curveType = source.curveType;
    this.tension = source.tension;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.points = [];
    for (let i2 = 0, l2 = this.points.length; i2 < l2; i2++) {
      const point2 = this.points[i2];
      data.points.push(point2.toArray());
    }
    data.closed = this.closed;
    data.curveType = this.curveType;
    data.tension = this.tension;
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.points = [];
    for (let i2 = 0, l2 = json.points.length; i2 < l2; i2++) {
      const point2 = json.points[i2];
      this.points.push(new Vector3$1().fromArray(point2));
    }
    this.closed = json.closed;
    this.curveType = json.curveType;
    this.tension = json.tension;
    return this;
  }
};
function CatmullRom$1(t3, p0, p1, p2, p3) {
  const v0 = (p2 - p0) * 0.5;
  const v1 = (p3 - p1) * 0.5;
  const t22 = t3 * t3;
  const t32 = t3 * t22;
  return (2 * p1 - 2 * p2 + v0 + v1) * t32 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t22 + v0 * t3 + p1;
}
function QuadraticBezierP0$1(t3, p2) {
  const k = 1 - t3;
  return k * k * p2;
}
function QuadraticBezierP1$1(t3, p2) {
  return 2 * (1 - t3) * t3 * p2;
}
function QuadraticBezierP2$1(t3, p2) {
  return t3 * t3 * p2;
}
function QuadraticBezier$1(t3, p0, p1, p2) {
  return QuadraticBezierP0$1(t3, p0) + QuadraticBezierP1$1(t3, p1) + QuadraticBezierP2$1(t3, p2);
}
function CubicBezierP0$1(t3, p2) {
  const k = 1 - t3;
  return k * k * k * p2;
}
function CubicBezierP1$1(t3, p2) {
  const k = 1 - t3;
  return 3 * k * k * t3 * p2;
}
function CubicBezierP2$1(t3, p2) {
  return 3 * (1 - t3) * t3 * t3 * p2;
}
function CubicBezierP3$1(t3, p2) {
  return t3 * t3 * t3 * p2;
}
function CubicBezier$1(t3, p0, p1, p2, p3) {
  return CubicBezierP0$1(t3, p0) + CubicBezierP1$1(t3, p1) + CubicBezierP2$1(t3, p2) + CubicBezierP3$1(t3, p3);
}
let CubicBezierCurve$1 = class CubicBezierCurve extends Curve$1 {
  constructor(v0 = new Vector2$1(), v1 = new Vector2$1(), v2 = new Vector2$1(), v3 = new Vector2$1()) {
    super();
    this.isCubicBezierCurve = true;
    this.type = "CubicBezierCurve";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
    this.v3 = v3;
  }
  getPoint(t3, optionalTarget = new Vector2$1()) {
    const point2 = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
    point2.set(
      CubicBezier$1(t3, v0.x, v1.x, v2.x, v3.x),
      CubicBezier$1(t3, v0.y, v1.y, v2.y, v3.y)
    );
    return point2;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    data.v3 = this.v3.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
  }
};
let CubicBezierCurve3$1 = class CubicBezierCurve3 extends Curve$1 {
  constructor(v0 = new Vector3$1(), v1 = new Vector3$1(), v2 = new Vector3$1(), v3 = new Vector3$1()) {
    super();
    this.isCubicBezierCurve3 = true;
    this.type = "CubicBezierCurve3";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
    this.v3 = v3;
  }
  getPoint(t3, optionalTarget = new Vector3$1()) {
    const point2 = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
    point2.set(
      CubicBezier$1(t3, v0.x, v1.x, v2.x, v3.x),
      CubicBezier$1(t3, v0.y, v1.y, v2.y, v3.y),
      CubicBezier$1(t3, v0.z, v1.z, v2.z, v3.z)
    );
    return point2;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    data.v3 = this.v3.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
  }
};
let LineCurve$1 = class LineCurve extends Curve$1 {
  constructor(v1 = new Vector2$1(), v2 = new Vector2$1()) {
    super();
    this.isLineCurve = true;
    this.type = "LineCurve";
    this.v1 = v1;
    this.v2 = v2;
  }
  getPoint(t3, optionalTarget = new Vector2$1()) {
    const point2 = optionalTarget;
    if (t3 === 1) {
      point2.copy(this.v2);
    } else {
      point2.copy(this.v2).sub(this.v1);
      point2.multiplyScalar(t3).add(this.v1);
    }
    return point2;
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(u3, optionalTarget) {
    return this.getPoint(u3, optionalTarget);
  }
  getTangent(t3, optionalTarget = new Vector2$1()) {
    return optionalTarget.subVectors(this.v2, this.v1).normalize();
  }
  getTangentAt(u3, optionalTarget) {
    return this.getTangent(u3, optionalTarget);
  }
  copy(source) {
    super.copy(source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
};
let LineCurve3$1 = class LineCurve3 extends Curve$1 {
  constructor(v1 = new Vector3$1(), v2 = new Vector3$1()) {
    super();
    this.isLineCurve3 = true;
    this.type = "LineCurve3";
    this.v1 = v1;
    this.v2 = v2;
  }
  getPoint(t3, optionalTarget = new Vector3$1()) {
    const point2 = optionalTarget;
    if (t3 === 1) {
      point2.copy(this.v2);
    } else {
      point2.copy(this.v2).sub(this.v1);
      point2.multiplyScalar(t3).add(this.v1);
    }
    return point2;
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(u3, optionalTarget) {
    return this.getPoint(u3, optionalTarget);
  }
  getTangent(t3, optionalTarget = new Vector3$1()) {
    return optionalTarget.subVectors(this.v2, this.v1).normalize();
  }
  getTangentAt(u3, optionalTarget) {
    return this.getTangent(u3, optionalTarget);
  }
  copy(source) {
    super.copy(source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
};
let QuadraticBezierCurve$1 = class QuadraticBezierCurve extends Curve$1 {
  constructor(v0 = new Vector2$1(), v1 = new Vector2$1(), v2 = new Vector2$1()) {
    super();
    this.isQuadraticBezierCurve = true;
    this.type = "QuadraticBezierCurve";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
  }
  getPoint(t3, optionalTarget = new Vector2$1()) {
    const point2 = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2;
    point2.set(
      QuadraticBezier$1(t3, v0.x, v1.x, v2.x),
      QuadraticBezier$1(t3, v0.y, v1.y, v2.y)
    );
    return point2;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
};
let QuadraticBezierCurve3$1 = class QuadraticBezierCurve3 extends Curve$1 {
  constructor(v0 = new Vector3$1(), v1 = new Vector3$1(), v2 = new Vector3$1()) {
    super();
    this.isQuadraticBezierCurve3 = true;
    this.type = "QuadraticBezierCurve3";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
  }
  getPoint(t3, optionalTarget = new Vector3$1()) {
    const point2 = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2;
    point2.set(
      QuadraticBezier$1(t3, v0.x, v1.x, v2.x),
      QuadraticBezier$1(t3, v0.y, v1.y, v2.y),
      QuadraticBezier$1(t3, v0.z, v1.z, v2.z)
    );
    return point2;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
};
let SplineCurve$1 = class SplineCurve extends Curve$1 {
  constructor(points = []) {
    super();
    this.isSplineCurve = true;
    this.type = "SplineCurve";
    this.points = points;
  }
  getPoint(t3, optionalTarget = new Vector2$1()) {
    const point2 = optionalTarget;
    const points = this.points;
    const p2 = (points.length - 1) * t3;
    const intPoint = Math.floor(p2);
    const weight = p2 - intPoint;
    const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
    const p1 = points[intPoint];
    const p22 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
    const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
    point2.set(
      CatmullRom$1(weight, p0.x, p1.x, p22.x, p3.x),
      CatmullRom$1(weight, p0.y, p1.y, p22.y, p3.y)
    );
    return point2;
  }
  copy(source) {
    super.copy(source);
    this.points = [];
    for (let i2 = 0, l2 = source.points.length; i2 < l2; i2++) {
      const point2 = source.points[i2];
      this.points.push(point2.clone());
    }
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.points = [];
    for (let i2 = 0, l2 = this.points.length; i2 < l2; i2++) {
      const point2 = this.points[i2];
      data.points.push(point2.toArray());
    }
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.points = [];
    for (let i2 = 0, l2 = json.points.length; i2 < l2; i2++) {
      const point2 = json.points[i2];
      this.points.push(new Vector2$1().fromArray(point2));
    }
    return this;
  }
};
var Curves$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcCurve: ArcCurve$1,
  CatmullRomCurve3: CatmullRomCurve3$1,
  CubicBezierCurve: CubicBezierCurve$1,
  CubicBezierCurve3: CubicBezierCurve3$1,
  EllipseCurve: EllipseCurve$1,
  LineCurve: LineCurve$1,
  LineCurve3: LineCurve3$1,
  QuadraticBezierCurve: QuadraticBezierCurve$1,
  QuadraticBezierCurve3: QuadraticBezierCurve3$1,
  SplineCurve: SplineCurve$1
});
let CurvePath$1 = class CurvePath extends Curve$1 {
  constructor() {
    super();
    this.type = "CurvePath";
    this.curves = [];
    this.autoClose = false;
  }
  add(curve) {
    this.curves.push(curve);
  }
  closePath() {
    const startPoint = this.curves[0].getPoint(0);
    const endPoint = this.curves[this.curves.length - 1].getPoint(1);
    if (!startPoint.equals(endPoint)) {
      const lineType = startPoint.isVector2 === true ? "LineCurve" : "LineCurve3";
      this.curves.push(new Curves$1[lineType](endPoint, startPoint));
    }
    return this;
  }
  // To get accurate point with reference to
  // entire path distance at time t,
  // following has to be done:
  // 1. Length of each sub path have to be known
  // 2. Locate and identify type of curve
  // 3. Get t for the curve
  // 4. Return curve.getPointAt(t')
  getPoint(t3, optionalTarget) {
    const d2 = t3 * this.getLength();
    const curveLengths = this.getCurveLengths();
    let i2 = 0;
    while (i2 < curveLengths.length) {
      if (curveLengths[i2] >= d2) {
        const diff = curveLengths[i2] - d2;
        const curve = this.curves[i2];
        const segmentLength = curve.getLength();
        const u3 = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
        return curve.getPointAt(u3, optionalTarget);
      }
      i2++;
    }
    return null;
  }
  // We cannot use the default THREE.Curve getPoint() with getLength() because in
  // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
  // getPoint() depends on getLength
  getLength() {
    const lens = this.getCurveLengths();
    return lens[lens.length - 1];
  }
  // cacheLengths must be recalculated.
  updateArcLengths() {
    this.needsUpdate = true;
    this.cacheLengths = null;
    this.getCurveLengths();
  }
  // Compute lengths and cache them
  // We cannot overwrite getLengths() because UtoT mapping uses it.
  getCurveLengths() {
    if (this.cacheLengths && this.cacheLengths.length === this.curves.length) {
      return this.cacheLengths;
    }
    const lengths = [];
    let sums = 0;
    for (let i2 = 0, l2 = this.curves.length; i2 < l2; i2++) {
      sums += this.curves[i2].getLength();
      lengths.push(sums);
    }
    this.cacheLengths = lengths;
    return lengths;
  }
  getSpacedPoints(divisions = 40) {
    const points = [];
    for (let i2 = 0; i2 <= divisions; i2++) {
      points.push(this.getPoint(i2 / divisions));
    }
    if (this.autoClose) {
      points.push(points[0]);
    }
    return points;
  }
  getPoints(divisions = 12) {
    const points = [];
    let last;
    for (let i2 = 0, curves = this.curves; i2 < curves.length; i2++) {
      const curve = curves[i2];
      const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
      const pts = curve.getPoints(resolution);
      for (let j = 0; j < pts.length; j++) {
        const point2 = pts[j];
        if (last && last.equals(point2)) continue;
        points.push(point2);
        last = point2;
      }
    }
    if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) {
      points.push(points[0]);
    }
    return points;
  }
  copy(source) {
    super.copy(source);
    this.curves = [];
    for (let i2 = 0, l2 = source.curves.length; i2 < l2; i2++) {
      const curve = source.curves[i2];
      this.curves.push(curve.clone());
    }
    this.autoClose = source.autoClose;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.autoClose = this.autoClose;
    data.curves = [];
    for (let i2 = 0, l2 = this.curves.length; i2 < l2; i2++) {
      const curve = this.curves[i2];
      data.curves.push(curve.toJSON());
    }
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.autoClose = json.autoClose;
    this.curves = [];
    for (let i2 = 0, l2 = json.curves.length; i2 < l2; i2++) {
      const curve = json.curves[i2];
      this.curves.push(new Curves$1[curve.type]().fromJSON(curve));
    }
    return this;
  }
};
let Path$1 = class Path extends CurvePath$1 {
  constructor(points) {
    super();
    this.type = "Path";
    this.currentPoint = new Vector2$1();
    if (points) {
      this.setFromPoints(points);
    }
  }
  setFromPoints(points) {
    this.moveTo(points[0].x, points[0].y);
    for (let i2 = 1, l2 = points.length; i2 < l2; i2++) {
      this.lineTo(points[i2].x, points[i2].y);
    }
    return this;
  }
  moveTo(x, y) {
    this.currentPoint.set(x, y);
    return this;
  }
  lineTo(x, y) {
    const curve = new LineCurve$1(this.currentPoint.clone(), new Vector2$1(x, y));
    this.curves.push(curve);
    this.currentPoint.set(x, y);
    return this;
  }
  quadraticCurveTo(aCPx, aCPy, aX, aY) {
    const curve = new QuadraticBezierCurve$1(
      this.currentPoint.clone(),
      new Vector2$1(aCPx, aCPy),
      new Vector2$1(aX, aY)
    );
    this.curves.push(curve);
    this.currentPoint.set(aX, aY);
    return this;
  }
  bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
    const curve = new CubicBezierCurve$1(
      this.currentPoint.clone(),
      new Vector2$1(aCP1x, aCP1y),
      new Vector2$1(aCP2x, aCP2y),
      new Vector2$1(aX, aY)
    );
    this.curves.push(curve);
    this.currentPoint.set(aX, aY);
    return this;
  }
  splineThru(pts) {
    const npts = [this.currentPoint.clone()].concat(pts);
    const curve = new SplineCurve$1(npts);
    this.curves.push(curve);
    this.currentPoint.copy(pts[pts.length - 1]);
    return this;
  }
  arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    const x0 = this.currentPoint.x;
    const y0 = this.currentPoint.y;
    this.absarc(
      aX + x0,
      aY + y0,
      aRadius,
      aStartAngle,
      aEndAngle,
      aClockwise
    );
    return this;
  }
  absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
    return this;
  }
  ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
    const x0 = this.currentPoint.x;
    const y0 = this.currentPoint.y;
    this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
    return this;
  }
  absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
    const curve = new EllipseCurve$1(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
    if (this.curves.length > 0) {
      const firstPoint = curve.getPoint(0);
      if (!firstPoint.equals(this.currentPoint)) {
        this.lineTo(firstPoint.x, firstPoint.y);
      }
    }
    this.curves.push(curve);
    const lastPoint = curve.getPoint(1);
    this.currentPoint.copy(lastPoint);
    return this;
  }
  copy(source) {
    super.copy(source);
    this.currentPoint.copy(source.currentPoint);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.currentPoint = this.currentPoint.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.currentPoint.fromArray(json.currentPoint);
    return this;
  }
};
class LatheGeometry extends BufferGeometry$1 {
  constructor(points = [new Vector2$1(0, -0.5), new Vector2$1(0.5, 0), new Vector2$1(0, 0.5)], segments = 12, phiStart = 0, phiLength = Math.PI * 2) {
    super();
    this.type = "LatheGeometry";
    this.parameters = {
      points,
      segments,
      phiStart,
      phiLength
    };
    segments = Math.floor(segments);
    phiLength = clamp$1(phiLength, 0, Math.PI * 2);
    const indices = [];
    const vertices = [];
    const uvs = [];
    const initNormals = [];
    const normals = [];
    const inverseSegments = 1 / segments;
    const vertex2 = new Vector3$1();
    const uv = new Vector2$1();
    const normal = new Vector3$1();
    const curNormal = new Vector3$1();
    const prevNormal = new Vector3$1();
    let dx = 0;
    let dy = 0;
    for (let j = 0; j <= points.length - 1; j++) {
      switch (j) {
        case 0:
          dx = points[j + 1].x - points[j].x;
          dy = points[j + 1].y - points[j].y;
          normal.x = dy * 1;
          normal.y = -dx;
          normal.z = dy * 0;
          prevNormal.copy(normal);
          normal.normalize();
          initNormals.push(normal.x, normal.y, normal.z);
          break;
        case points.length - 1:
          initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
          break;
        default:
          dx = points[j + 1].x - points[j].x;
          dy = points[j + 1].y - points[j].y;
          normal.x = dy * 1;
          normal.y = -dx;
          normal.z = dy * 0;
          curNormal.copy(normal);
          normal.x += prevNormal.x;
          normal.y += prevNormal.y;
          normal.z += prevNormal.z;
          normal.normalize();
          initNormals.push(normal.x, normal.y, normal.z);
          prevNormal.copy(curNormal);
      }
    }
    for (let i2 = 0; i2 <= segments; i2++) {
      const phi = phiStart + i2 * inverseSegments * phiLength;
      const sin2 = Math.sin(phi);
      const cos2 = Math.cos(phi);
      for (let j = 0; j <= points.length - 1; j++) {
        vertex2.x = points[j].x * sin2;
        vertex2.y = points[j].y;
        vertex2.z = points[j].x * cos2;
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        uv.x = i2 / segments;
        uv.y = j / (points.length - 1);
        uvs.push(uv.x, uv.y);
        const x = initNormals[3 * j + 0] * sin2;
        const y = initNormals[3 * j + 1];
        const z2 = initNormals[3 * j + 0] * cos2;
        normals.push(x, y, z2);
      }
    }
    for (let i2 = 0; i2 < segments; i2++) {
      for (let j = 0; j < points.length - 1; j++) {
        const base = j + i2 * points.length;
        const a3 = base;
        const b = base + points.length;
        const c2 = base + points.length + 1;
        const d2 = base + 1;
        indices.push(a3, b, d2);
        indices.push(c2, d2, b);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvs, 2));
    this.setAttribute("normal", new Float32BufferAttribute$1(normals, 3));
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new LatheGeometry(data.points, data.segments, data.phiStart, data.phiLength);
  }
}
class CapsuleGeometry extends LatheGeometry {
  constructor(radius = 1, length2 = 1, capSegments = 4, radialSegments = 8) {
    const path = new Path$1();
    path.absarc(0, -length2 / 2, radius, Math.PI * 1.5, 0);
    path.absarc(0, length2 / 2, radius, 0, Math.PI * 0.5);
    super(path.getPoints(capSegments), radialSegments);
    this.type = "CapsuleGeometry";
    this.parameters = {
      radius,
      length: length2,
      capSegments,
      radialSegments
    };
  }
  static fromJSON(data) {
    return new CapsuleGeometry(data.radius, data.length, data.capSegments, data.radialSegments);
  }
}
class CircleGeometry extends BufferGeometry$1 {
  constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2) {
    super();
    this.type = "CircleGeometry";
    this.parameters = {
      radius,
      segments,
      thetaStart,
      thetaLength
    };
    segments = Math.max(3, segments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    const vertex2 = new Vector3$1();
    const uv = new Vector2$1();
    vertices.push(0, 0, 0);
    normals.push(0, 0, 1);
    uvs.push(0.5, 0.5);
    for (let s2 = 0, i2 = 3; s2 <= segments; s2++, i2 += 3) {
      const segment = thetaStart + s2 / segments * thetaLength;
      vertex2.x = radius * Math.cos(segment);
      vertex2.y = radius * Math.sin(segment);
      vertices.push(vertex2.x, vertex2.y, vertex2.z);
      normals.push(0, 0, 1);
      uv.x = (vertices[i2] / radius + 1) / 2;
      uv.y = (vertices[i2 + 1] / radius + 1) / 2;
      uvs.push(uv.x, uv.y);
    }
    for (let i2 = 1; i2 <= segments; i2++) {
      indices.push(i2, i2 + 1, 0);
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute$1(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvs, 2));
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new CircleGeometry(data.radius, data.segments, data.thetaStart, data.thetaLength);
  }
}
class CylinderGeometry extends BufferGeometry$1 {
  constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2) {
    super();
    this.type = "CylinderGeometry";
    this.parameters = {
      radiusTop,
      radiusBottom,
      height,
      radialSegments,
      heightSegments,
      openEnded,
      thetaStart,
      thetaLength
    };
    const scope = this;
    radialSegments = Math.floor(radialSegments);
    heightSegments = Math.floor(heightSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let index2 = 0;
    const indexArray = [];
    const halfHeight = height / 2;
    let groupStart = 0;
    generateTorso();
    if (openEnded === false) {
      if (radiusTop > 0) generateCap(true);
      if (radiusBottom > 0) generateCap(false);
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute$1(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvs, 2));
    function generateTorso() {
      const normal = new Vector3$1();
      const vertex2 = new Vector3$1();
      let groupCount = 0;
      const slope = (radiusBottom - radiusTop) / height;
      for (let y = 0; y <= heightSegments; y++) {
        const indexRow = [];
        const v = y / heightSegments;
        const radius = v * (radiusBottom - radiusTop) + radiusTop;
        for (let x = 0; x <= radialSegments; x++) {
          const u3 = x / radialSegments;
          const theta = u3 * thetaLength + thetaStart;
          const sinTheta = Math.sin(theta);
          const cosTheta = Math.cos(theta);
          vertex2.x = radius * sinTheta;
          vertex2.y = -v * height + halfHeight;
          vertex2.z = radius * cosTheta;
          vertices.push(vertex2.x, vertex2.y, vertex2.z);
          normal.set(sinTheta, slope, cosTheta).normalize();
          normals.push(normal.x, normal.y, normal.z);
          uvs.push(u3, 1 - v);
          indexRow.push(index2++);
        }
        indexArray.push(indexRow);
      }
      for (let x = 0; x < radialSegments; x++) {
        for (let y = 0; y < heightSegments; y++) {
          const a3 = indexArray[y][x];
          const b = indexArray[y + 1][x];
          const c2 = indexArray[y + 1][x + 1];
          const d2 = indexArray[y][x + 1];
          if (radiusTop > 0 || y !== 0) {
            indices.push(a3, b, d2);
            groupCount += 3;
          }
          if (radiusBottom > 0 || y !== heightSegments - 1) {
            indices.push(b, c2, d2);
            groupCount += 3;
          }
        }
      }
      scope.addGroup(groupStart, groupCount, 0);
      groupStart += groupCount;
    }
    function generateCap(top) {
      const centerIndexStart = index2;
      const uv = new Vector2$1();
      const vertex2 = new Vector3$1();
      let groupCount = 0;
      const radius = top === true ? radiusTop : radiusBottom;
      const sign2 = top === true ? 1 : -1;
      for (let x = 1; x <= radialSegments; x++) {
        vertices.push(0, halfHeight * sign2, 0);
        normals.push(0, sign2, 0);
        uvs.push(0.5, 0.5);
        index2++;
      }
      const centerIndexEnd = index2;
      for (let x = 0; x <= radialSegments; x++) {
        const u3 = x / radialSegments;
        const theta = u3 * thetaLength + thetaStart;
        const cosTheta = Math.cos(theta);
        const sinTheta = Math.sin(theta);
        vertex2.x = radius * sinTheta;
        vertex2.y = halfHeight * sign2;
        vertex2.z = radius * cosTheta;
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        normals.push(0, sign2, 0);
        uv.x = cosTheta * 0.5 + 0.5;
        uv.y = sinTheta * 0.5 * sign2 + 0.5;
        uvs.push(uv.x, uv.y);
        index2++;
      }
      for (let x = 0; x < radialSegments; x++) {
        const c2 = centerIndexStart + x;
        const i2 = centerIndexEnd + x;
        if (top === true) {
          indices.push(i2, i2 + 1, c2);
        } else {
          indices.push(i2 + 1, i2, c2);
        }
        groupCount += 3;
      }
      scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
      groupStart += groupCount;
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new CylinderGeometry(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
  }
}
class ConeGeometry extends CylinderGeometry {
  constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2) {
    super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
    this.type = "ConeGeometry";
    this.parameters = {
      radius,
      height,
      radialSegments,
      heightSegments,
      openEnded,
      thetaStart,
      thetaLength
    };
  }
  static fromJSON(data) {
    return new ConeGeometry(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
  }
}
class PolyhedronGeometry extends BufferGeometry$1 {
  constructor(vertices = [], indices = [], radius = 1, detail = 0) {
    super();
    this.type = "PolyhedronGeometry";
    this.parameters = {
      vertices,
      indices,
      radius,
      detail
    };
    const vertexBuffer = [];
    const uvBuffer = [];
    subdivide(detail);
    applyRadius(radius);
    generateUVs();
    this.setAttribute("position", new Float32BufferAttribute$1(vertexBuffer, 3));
    this.setAttribute("normal", new Float32BufferAttribute$1(vertexBuffer.slice(), 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvBuffer, 2));
    if (detail === 0) {
      this.computeVertexNormals();
    } else {
      this.normalizeNormals();
    }
    function subdivide(detail2) {
      const a3 = new Vector3$1();
      const b = new Vector3$1();
      const c2 = new Vector3$1();
      for (let i2 = 0; i2 < indices.length; i2 += 3) {
        getVertexByIndex(indices[i2 + 0], a3);
        getVertexByIndex(indices[i2 + 1], b);
        getVertexByIndex(indices[i2 + 2], c2);
        subdivideFace(a3, b, c2, detail2);
      }
    }
    function subdivideFace(a3, b, c2, detail2) {
      const cols = detail2 + 1;
      const v = [];
      for (let i2 = 0; i2 <= cols; i2++) {
        v[i2] = [];
        const aj = a3.clone().lerp(c2, i2 / cols);
        const bj = b.clone().lerp(c2, i2 / cols);
        const rows = cols - i2;
        for (let j = 0; j <= rows; j++) {
          if (j === 0 && i2 === cols) {
            v[i2][j] = aj;
          } else {
            v[i2][j] = aj.clone().lerp(bj, j / rows);
          }
        }
      }
      for (let i2 = 0; i2 < cols; i2++) {
        for (let j = 0; j < 2 * (cols - i2) - 1; j++) {
          const k = Math.floor(j / 2);
          if (j % 2 === 0) {
            pushVertex(v[i2][k + 1]);
            pushVertex(v[i2 + 1][k]);
            pushVertex(v[i2][k]);
          } else {
            pushVertex(v[i2][k + 1]);
            pushVertex(v[i2 + 1][k + 1]);
            pushVertex(v[i2 + 1][k]);
          }
        }
      }
    }
    function applyRadius(radius2) {
      const vertex2 = new Vector3$1();
      for (let i2 = 0; i2 < vertexBuffer.length; i2 += 3) {
        vertex2.x = vertexBuffer[i2 + 0];
        vertex2.y = vertexBuffer[i2 + 1];
        vertex2.z = vertexBuffer[i2 + 2];
        vertex2.normalize().multiplyScalar(radius2);
        vertexBuffer[i2 + 0] = vertex2.x;
        vertexBuffer[i2 + 1] = vertex2.y;
        vertexBuffer[i2 + 2] = vertex2.z;
      }
    }
    function generateUVs() {
      const vertex2 = new Vector3$1();
      for (let i2 = 0; i2 < vertexBuffer.length; i2 += 3) {
        vertex2.x = vertexBuffer[i2 + 0];
        vertex2.y = vertexBuffer[i2 + 1];
        vertex2.z = vertexBuffer[i2 + 2];
        const u3 = azimuth2(vertex2) / 2 / Math.PI + 0.5;
        const v = inclination(vertex2) / Math.PI + 0.5;
        uvBuffer.push(u3, 1 - v);
      }
      correctUVs();
      correctSeam();
    }
    function correctSeam() {
      for (let i2 = 0; i2 < uvBuffer.length; i2 += 6) {
        const x0 = uvBuffer[i2 + 0];
        const x1 = uvBuffer[i2 + 2];
        const x2 = uvBuffer[i2 + 4];
        const max2 = Math.max(x0, x1, x2);
        const min = Math.min(x0, x1, x2);
        if (max2 > 0.9 && min < 0.1) {
          if (x0 < 0.2) uvBuffer[i2 + 0] += 1;
          if (x1 < 0.2) uvBuffer[i2 + 2] += 1;
          if (x2 < 0.2) uvBuffer[i2 + 4] += 1;
        }
      }
    }
    function pushVertex(vertex2) {
      vertexBuffer.push(vertex2.x, vertex2.y, vertex2.z);
    }
    function getVertexByIndex(index2, vertex2) {
      const stride = index2 * 3;
      vertex2.x = vertices[stride + 0];
      vertex2.y = vertices[stride + 1];
      vertex2.z = vertices[stride + 2];
    }
    function correctUVs() {
      const a3 = new Vector3$1();
      const b = new Vector3$1();
      const c2 = new Vector3$1();
      const centroid = new Vector3$1();
      const uvA = new Vector2$1();
      const uvB = new Vector2$1();
      const uvC = new Vector2$1();
      for (let i2 = 0, j = 0; i2 < vertexBuffer.length; i2 += 9, j += 6) {
        a3.set(vertexBuffer[i2 + 0], vertexBuffer[i2 + 1], vertexBuffer[i2 + 2]);
        b.set(vertexBuffer[i2 + 3], vertexBuffer[i2 + 4], vertexBuffer[i2 + 5]);
        c2.set(vertexBuffer[i2 + 6], vertexBuffer[i2 + 7], vertexBuffer[i2 + 8]);
        uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
        uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
        uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
        centroid.copy(a3).add(b).add(c2).divideScalar(3);
        const azi = azimuth2(centroid);
        correctUV(uvA, j + 0, a3, azi);
        correctUV(uvB, j + 2, b, azi);
        correctUV(uvC, j + 4, c2, azi);
      }
    }
    function correctUV(uv, stride, vector, azimuth3) {
      if (azimuth3 < 0 && uv.x === 1) {
        uvBuffer[stride] = uv.x - 1;
      }
      if (vector.x === 0 && vector.z === 0) {
        uvBuffer[stride] = azimuth3 / 2 / Math.PI + 0.5;
      }
    }
    function azimuth2(vector) {
      return Math.atan2(vector.z, -vector.x);
    }
    function inclination(vector) {
      return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new PolyhedronGeometry(data.vertices, data.indices, data.radius, data.details);
  }
}
class DodecahedronGeometry extends PolyhedronGeometry {
  constructor(radius = 1, detail = 0) {
    const t3 = (1 + Math.sqrt(5)) / 2;
    const r2 = 1 / t3;
    const vertices = [
      // (±1, ±1, ±1)
      -1,
      -1,
      -1,
      -1,
      -1,
      1,
      -1,
      1,
      -1,
      -1,
      1,
      1,
      1,
      -1,
      -1,
      1,
      -1,
      1,
      1,
      1,
      -1,
      1,
      1,
      1,
      // (0, ±1/φ, ±φ)
      0,
      -r2,
      -t3,
      0,
      -r2,
      t3,
      0,
      r2,
      -t3,
      0,
      r2,
      t3,
      // (±1/φ, ±φ, 0)
      -r2,
      -t3,
      0,
      -r2,
      t3,
      0,
      r2,
      -t3,
      0,
      r2,
      t3,
      0,
      // (±φ, 0, ±1/φ)
      -t3,
      0,
      -r2,
      t3,
      0,
      -r2,
      -t3,
      0,
      r2,
      t3,
      0,
      r2
    ];
    const indices = [
      3,
      11,
      7,
      3,
      7,
      15,
      3,
      15,
      13,
      7,
      19,
      17,
      7,
      17,
      6,
      7,
      6,
      15,
      17,
      4,
      8,
      17,
      8,
      10,
      17,
      10,
      6,
      8,
      0,
      16,
      8,
      16,
      2,
      8,
      2,
      10,
      0,
      12,
      1,
      0,
      1,
      18,
      0,
      18,
      16,
      6,
      10,
      2,
      6,
      2,
      13,
      6,
      13,
      15,
      2,
      16,
      18,
      2,
      18,
      3,
      2,
      3,
      13,
      18,
      1,
      9,
      18,
      9,
      11,
      18,
      11,
      3,
      4,
      14,
      12,
      4,
      12,
      0,
      4,
      0,
      8,
      11,
      9,
      5,
      11,
      5,
      19,
      11,
      19,
      7,
      19,
      5,
      14,
      19,
      14,
      4,
      19,
      4,
      17,
      1,
      12,
      14,
      1,
      14,
      5,
      1,
      5,
      9
    ];
    super(vertices, indices, radius, detail);
    this.type = "DodecahedronGeometry";
    this.parameters = {
      radius,
      detail
    };
  }
  static fromJSON(data) {
    return new DodecahedronGeometry(data.radius, data.detail);
  }
}
const _v0$3 = /* @__PURE__ */ new Vector3$1();
const _v1$1 = /* @__PURE__ */ new Vector3$1();
const _normal = /* @__PURE__ */ new Vector3$1();
const _triangle = /* @__PURE__ */ new Triangle$1();
class EdgesGeometry extends BufferGeometry$1 {
  constructor(geometry = null, thresholdAngle = 1) {
    super();
    this.type = "EdgesGeometry";
    this.parameters = {
      geometry,
      thresholdAngle
    };
    if (geometry !== null) {
      const precisionPoints = 4;
      const precision = Math.pow(10, precisionPoints);
      const thresholdDot = Math.cos(DEG2RAD$1 * thresholdAngle);
      const indexAttr = geometry.getIndex();
      const positionAttr = geometry.getAttribute("position");
      const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
      const indexArr = [0, 0, 0];
      const vertKeys = ["a", "b", "c"];
      const hashes = new Array(3);
      const edgeData = {};
      const vertices = [];
      for (let i2 = 0; i2 < indexCount; i2 += 3) {
        if (indexAttr) {
          indexArr[0] = indexAttr.getX(i2);
          indexArr[1] = indexAttr.getX(i2 + 1);
          indexArr[2] = indexAttr.getX(i2 + 2);
        } else {
          indexArr[0] = i2;
          indexArr[1] = i2 + 1;
          indexArr[2] = i2 + 2;
        }
        const { a: a3, b, c: c2 } = _triangle;
        a3.fromBufferAttribute(positionAttr, indexArr[0]);
        b.fromBufferAttribute(positionAttr, indexArr[1]);
        c2.fromBufferAttribute(positionAttr, indexArr[2]);
        _triangle.getNormal(_normal);
        hashes[0] = `${Math.round(a3.x * precision)},${Math.round(a3.y * precision)},${Math.round(a3.z * precision)}`;
        hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
        hashes[2] = `${Math.round(c2.x * precision)},${Math.round(c2.y * precision)},${Math.round(c2.z * precision)}`;
        if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) {
          continue;
        }
        for (let j = 0; j < 3; j++) {
          const jNext = (j + 1) % 3;
          const vecHash0 = hashes[j];
          const vecHash1 = hashes[jNext];
          const v0 = _triangle[vertKeys[j]];
          const v1 = _triangle[vertKeys[jNext]];
          const hash = `${vecHash0}_${vecHash1}`;
          const reverseHash = `${vecHash1}_${vecHash0}`;
          if (reverseHash in edgeData && edgeData[reverseHash]) {
            if (_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
              vertices.push(v0.x, v0.y, v0.z);
              vertices.push(v1.x, v1.y, v1.z);
            }
            edgeData[reverseHash] = null;
          } else if (!(hash in edgeData)) {
            edgeData[hash] = {
              index0: indexArr[j],
              index1: indexArr[jNext],
              normal: _normal.clone()
            };
          }
        }
      }
      for (const key in edgeData) {
        if (edgeData[key]) {
          const { index0, index1 } = edgeData[key];
          _v0$3.fromBufferAttribute(positionAttr, index0);
          _v1$1.fromBufferAttribute(positionAttr, index1);
          vertices.push(_v0$3.x, _v0$3.y, _v0$3.z);
          vertices.push(_v1$1.x, _v1$1.y, _v1$1.z);
        }
      }
      this.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
}
let Shape$1 = class Shape extends Path$1 {
  constructor(points) {
    super(points);
    this.uuid = generateUUID$1();
    this.type = "Shape";
    this.holes = [];
  }
  getPointsHoles(divisions) {
    const holesPts = [];
    for (let i2 = 0, l2 = this.holes.length; i2 < l2; i2++) {
      holesPts[i2] = this.holes[i2].getPoints(divisions);
    }
    return holesPts;
  }
  // get points of shape and holes (keypoints based on segments parameter)
  extractPoints(divisions) {
    return {
      shape: this.getPoints(divisions),
      holes: this.getPointsHoles(divisions)
    };
  }
  copy(source) {
    super.copy(source);
    this.holes = [];
    for (let i2 = 0, l2 = source.holes.length; i2 < l2; i2++) {
      const hole = source.holes[i2];
      this.holes.push(hole.clone());
    }
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.uuid = this.uuid;
    data.holes = [];
    for (let i2 = 0, l2 = this.holes.length; i2 < l2; i2++) {
      const hole = this.holes[i2];
      data.holes.push(hole.toJSON());
    }
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.uuid = json.uuid;
    this.holes = [];
    for (let i2 = 0, l2 = json.holes.length; i2 < l2; i2++) {
      const hole = json.holes[i2];
      this.holes.push(new Path$1().fromJSON(hole));
    }
    return this;
  }
};
const Earcut$1 = {
  triangulate: function(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = linkedList$1(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = eliminateHoles$1(data, holeIndices, outerNode, dim);
    if (data.length > 80 * dim) {
      minX = maxX = data[0];
      minY = maxY = data[1];
      for (let i2 = dim; i2 < outerLen; i2 += dim) {
        x = data[i2];
        y = data[i2 + 1];
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      }
      invSize = Math.max(maxX - minX, maxY - minY);
      invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    earcutLinked$1(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
  }
};
function linkedList$1(data, start, end, dim, clockwise) {
  let i2, last;
  if (clockwise === signedArea$1(data, start, end, dim) > 0) {
    for (i2 = start; i2 < end; i2 += dim) last = insertNode$1(i2, data[i2], data[i2 + 1], last);
  } else {
    for (i2 = end - dim; i2 >= start; i2 -= dim) last = insertNode$1(i2, data[i2], data[i2 + 1], last);
  }
  if (last && equals$1(last, last.next)) {
    removeNode$1(last);
    last = last.next;
  }
  return last;
}
function filterPoints$1(start, end) {
  if (!start) return start;
  if (!end) end = start;
  let p2 = start, again;
  do {
    again = false;
    if (!p2.steiner && (equals$1(p2, p2.next) || area$2(p2.prev, p2, p2.next) === 0)) {
      removeNode$1(p2);
      p2 = end = p2.prev;
      if (p2 === p2.next) break;
      again = true;
    } else {
      p2 = p2.next;
    }
  } while (again || p2 !== end);
  return end;
}
function earcutLinked$1(ear, triangles, dim, minX, minY, invSize, pass) {
  if (!ear) return;
  if (!pass && invSize) indexCurve$1(ear, minX, minY, invSize);
  let stop = ear, prev, next;
  while (ear.prev !== ear.next) {
    prev = ear.prev;
    next = ear.next;
    if (invSize ? isEarHashed$1(ear, minX, minY, invSize) : isEar$1(ear)) {
      triangles.push(prev.i / dim | 0);
      triangles.push(ear.i / dim | 0);
      triangles.push(next.i / dim | 0);
      removeNode$1(ear);
      ear = next.next;
      stop = next.next;
      continue;
    }
    ear = next;
    if (ear === stop) {
      if (!pass) {
        earcutLinked$1(filterPoints$1(ear), triangles, dim, minX, minY, invSize, 1);
      } else if (pass === 1) {
        ear = cureLocalIntersections$1(filterPoints$1(ear), triangles, dim);
        earcutLinked$1(ear, triangles, dim, minX, minY, invSize, 2);
      } else if (pass === 2) {
        splitEarcut$1(ear, triangles, dim, minX, minY, invSize);
      }
      break;
    }
  }
}
function isEar$1(ear) {
  const a3 = ear.prev, b = ear, c2 = ear.next;
  if (area$2(a3, b, c2) >= 0) return false;
  const ax = a3.x, bx = b.x, cx = c2.x, ay = a3.y, by = b.y, cy = c2.y;
  const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
  let p2 = c2.next;
  while (p2 !== a3) {
    if (p2.x >= x0 && p2.x <= x1 && p2.y >= y0 && p2.y <= y1 && pointInTriangle$1(ax, ay, bx, by, cx, cy, p2.x, p2.y) && area$2(p2.prev, p2, p2.next) >= 0) return false;
    p2 = p2.next;
  }
  return true;
}
function isEarHashed$1(ear, minX, minY, invSize) {
  const a3 = ear.prev, b = ear, c2 = ear.next;
  if (area$2(a3, b, c2) >= 0) return false;
  const ax = a3.x, bx = b.x, cx = c2.x, ay = a3.y, by = b.y, cy = c2.y;
  const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
  const minZ = zOrder$1(x0, y0, minX, minY, invSize), maxZ = zOrder$1(x1, y1, minX, minY, invSize);
  let p2 = ear.prevZ, n2 = ear.nextZ;
  while (p2 && p2.z >= minZ && n2 && n2.z <= maxZ) {
    if (p2.x >= x0 && p2.x <= x1 && p2.y >= y0 && p2.y <= y1 && p2 !== a3 && p2 !== c2 && pointInTriangle$1(ax, ay, bx, by, cx, cy, p2.x, p2.y) && area$2(p2.prev, p2, p2.next) >= 0) return false;
    p2 = p2.prevZ;
    if (n2.x >= x0 && n2.x <= x1 && n2.y >= y0 && n2.y <= y1 && n2 !== a3 && n2 !== c2 && pointInTriangle$1(ax, ay, bx, by, cx, cy, n2.x, n2.y) && area$2(n2.prev, n2, n2.next) >= 0) return false;
    n2 = n2.nextZ;
  }
  while (p2 && p2.z >= minZ) {
    if (p2.x >= x0 && p2.x <= x1 && p2.y >= y0 && p2.y <= y1 && p2 !== a3 && p2 !== c2 && pointInTriangle$1(ax, ay, bx, by, cx, cy, p2.x, p2.y) && area$2(p2.prev, p2, p2.next) >= 0) return false;
    p2 = p2.prevZ;
  }
  while (n2 && n2.z <= maxZ) {
    if (n2.x >= x0 && n2.x <= x1 && n2.y >= y0 && n2.y <= y1 && n2 !== a3 && n2 !== c2 && pointInTriangle$1(ax, ay, bx, by, cx, cy, n2.x, n2.y) && area$2(n2.prev, n2, n2.next) >= 0) return false;
    n2 = n2.nextZ;
  }
  return true;
}
function cureLocalIntersections$1(start, triangles, dim) {
  let p2 = start;
  do {
    const a3 = p2.prev, b = p2.next.next;
    if (!equals$1(a3, b) && intersects$1(a3, p2, p2.next, b) && locallyInside$1(a3, b) && locallyInside$1(b, a3)) {
      triangles.push(a3.i / dim | 0);
      triangles.push(p2.i / dim | 0);
      triangles.push(b.i / dim | 0);
      removeNode$1(p2);
      removeNode$1(p2.next);
      p2 = start = b;
    }
    p2 = p2.next;
  } while (p2 !== start);
  return filterPoints$1(p2);
}
function splitEarcut$1(start, triangles, dim, minX, minY, invSize) {
  let a3 = start;
  do {
    let b = a3.next.next;
    while (b !== a3.prev) {
      if (a3.i !== b.i && isValidDiagonal$1(a3, b)) {
        let c2 = splitPolygon$1(a3, b);
        a3 = filterPoints$1(a3, a3.next);
        c2 = filterPoints$1(c2, c2.next);
        earcutLinked$1(a3, triangles, dim, minX, minY, invSize, 0);
        earcutLinked$1(c2, triangles, dim, minX, minY, invSize, 0);
        return;
      }
      b = b.next;
    }
    a3 = a3.next;
  } while (a3 !== start);
}
function eliminateHoles$1(data, holeIndices, outerNode, dim) {
  const queue = [];
  let i2, len, start, end, list;
  for (i2 = 0, len = holeIndices.length; i2 < len; i2++) {
    start = holeIndices[i2] * dim;
    end = i2 < len - 1 ? holeIndices[i2 + 1] * dim : data.length;
    list = linkedList$1(data, start, end, dim, false);
    if (list === list.next) list.steiner = true;
    queue.push(getLeftmost$1(list));
  }
  queue.sort(compareX$1);
  for (i2 = 0; i2 < queue.length; i2++) {
    outerNode = eliminateHole$1(queue[i2], outerNode);
  }
  return outerNode;
}
function compareX$1(a3, b) {
  return a3.x - b.x;
}
function eliminateHole$1(hole, outerNode) {
  const bridge = findHoleBridge$1(hole, outerNode);
  if (!bridge) {
    return outerNode;
  }
  const bridgeReverse = splitPolygon$1(bridge, hole);
  filterPoints$1(bridgeReverse, bridgeReverse.next);
  return filterPoints$1(bridge, bridge.next);
}
function findHoleBridge$1(hole, outerNode) {
  let p2 = outerNode, qx = -Infinity, m;
  const hx = hole.x, hy = hole.y;
  do {
    if (hy <= p2.y && hy >= p2.next.y && p2.next.y !== p2.y) {
      const x = p2.x + (hy - p2.y) * (p2.next.x - p2.x) / (p2.next.y - p2.y);
      if (x <= hx && x > qx) {
        qx = x;
        m = p2.x < p2.next.x ? p2 : p2.next;
        if (x === hx) return m;
      }
    }
    p2 = p2.next;
  } while (p2 !== outerNode);
  if (!m) return null;
  const stop = m, mx = m.x, my = m.y;
  let tanMin = Infinity, tan2;
  p2 = m;
  do {
    if (hx >= p2.x && p2.x >= mx && hx !== p2.x && pointInTriangle$1(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p2.x, p2.y)) {
      tan2 = Math.abs(hy - p2.y) / (hx - p2.x);
      if (locallyInside$1(p2, hole) && (tan2 < tanMin || tan2 === tanMin && (p2.x > m.x || p2.x === m.x && sectorContainsSector$1(m, p2)))) {
        m = p2;
        tanMin = tan2;
      }
    }
    p2 = p2.next;
  } while (p2 !== stop);
  return m;
}
function sectorContainsSector$1(m, p2) {
  return area$2(m.prev, m, p2.prev) < 0 && area$2(p2.next, m, m.next) < 0;
}
function indexCurve$1(start, minX, minY, invSize) {
  let p2 = start;
  do {
    if (p2.z === 0) p2.z = zOrder$1(p2.x, p2.y, minX, minY, invSize);
    p2.prevZ = p2.prev;
    p2.nextZ = p2.next;
    p2 = p2.next;
  } while (p2 !== start);
  p2.prevZ.nextZ = null;
  p2.prevZ = null;
  sortLinked$1(p2);
}
function sortLinked$1(list) {
  let i2, p2, q, e2, tail, numMerges, pSize, qSize, inSize = 1;
  do {
    p2 = list;
    list = null;
    tail = null;
    numMerges = 0;
    while (p2) {
      numMerges++;
      q = p2;
      pSize = 0;
      for (i2 = 0; i2 < inSize; i2++) {
        pSize++;
        q = q.nextZ;
        if (!q) break;
      }
      qSize = inSize;
      while (pSize > 0 || qSize > 0 && q) {
        if (pSize !== 0 && (qSize === 0 || !q || p2.z <= q.z)) {
          e2 = p2;
          p2 = p2.nextZ;
          pSize--;
        } else {
          e2 = q;
          q = q.nextZ;
          qSize--;
        }
        if (tail) tail.nextZ = e2;
        else list = e2;
        e2.prevZ = tail;
        tail = e2;
      }
      p2 = q;
    }
    tail.nextZ = null;
    inSize *= 2;
  } while (numMerges > 1);
  return list;
}
function zOrder$1(x, y, minX, minY, invSize) {
  x = (x - minX) * invSize | 0;
  y = (y - minY) * invSize | 0;
  x = (x | x << 8) & 16711935;
  x = (x | x << 4) & 252645135;
  x = (x | x << 2) & 858993459;
  x = (x | x << 1) & 1431655765;
  y = (y | y << 8) & 16711935;
  y = (y | y << 4) & 252645135;
  y = (y | y << 2) & 858993459;
  y = (y | y << 1) & 1431655765;
  return x | y << 1;
}
function getLeftmost$1(start) {
  let p2 = start, leftmost = start;
  do {
    if (p2.x < leftmost.x || p2.x === leftmost.x && p2.y < leftmost.y) leftmost = p2;
    p2 = p2.next;
  } while (p2 !== start);
  return leftmost;
}
function pointInTriangle$1(ax, ay, bx, by, cx, cy, px2, py2) {
  return (cx - px2) * (ay - py2) >= (ax - px2) * (cy - py2) && (ax - px2) * (by - py2) >= (bx - px2) * (ay - py2) && (bx - px2) * (cy - py2) >= (cx - px2) * (by - py2);
}
function isValidDiagonal$1(a3, b) {
  return a3.next.i !== b.i && a3.prev.i !== b.i && !intersectsPolygon$1(a3, b) && // dones't intersect other edges
  (locallyInside$1(a3, b) && locallyInside$1(b, a3) && middleInside$1(a3, b) && // locally visible
  (area$2(a3.prev, a3, b.prev) || area$2(a3, b.prev, b)) || // does not create opposite-facing sectors
  equals$1(a3, b) && area$2(a3.prev, a3, a3.next) > 0 && area$2(b.prev, b, b.next) > 0);
}
function area$2(p2, q, r2) {
  return (q.y - p2.y) * (r2.x - q.x) - (q.x - p2.x) * (r2.y - q.y);
}
function equals$1(p1, p2) {
  return p1.x === p2.x && p1.y === p2.y;
}
function intersects$1(p1, q1, p2, q2) {
  const o1 = sign$2(area$2(p1, q1, p2));
  const o2 = sign$2(area$2(p1, q1, q2));
  const o3 = sign$2(area$2(p2, q2, p1));
  const o4 = sign$2(area$2(p2, q2, q1));
  if (o1 !== o2 && o3 !== o4) return true;
  if (o1 === 0 && onSegment$1(p1, p2, q1)) return true;
  if (o2 === 0 && onSegment$1(p1, q2, q1)) return true;
  if (o3 === 0 && onSegment$1(p2, p1, q2)) return true;
  if (o4 === 0 && onSegment$1(p2, q1, q2)) return true;
  return false;
}
function onSegment$1(p2, q, r2) {
  return q.x <= Math.max(p2.x, r2.x) && q.x >= Math.min(p2.x, r2.x) && q.y <= Math.max(p2.y, r2.y) && q.y >= Math.min(p2.y, r2.y);
}
function sign$2(num) {
  return num > 0 ? 1 : num < 0 ? -1 : 0;
}
function intersectsPolygon$1(a3, b) {
  let p2 = a3;
  do {
    if (p2.i !== a3.i && p2.next.i !== a3.i && p2.i !== b.i && p2.next.i !== b.i && intersects$1(p2, p2.next, a3, b)) return true;
    p2 = p2.next;
  } while (p2 !== a3);
  return false;
}
function locallyInside$1(a3, b) {
  return area$2(a3.prev, a3, a3.next) < 0 ? area$2(a3, b, a3.next) >= 0 && area$2(a3, a3.prev, b) >= 0 : area$2(a3, b, a3.prev) < 0 || area$2(a3, a3.next, b) < 0;
}
function middleInside$1(a3, b) {
  let p2 = a3, inside = false;
  const px2 = (a3.x + b.x) / 2, py2 = (a3.y + b.y) / 2;
  do {
    if (p2.y > py2 !== p2.next.y > py2 && p2.next.y !== p2.y && px2 < (p2.next.x - p2.x) * (py2 - p2.y) / (p2.next.y - p2.y) + p2.x)
      inside = !inside;
    p2 = p2.next;
  } while (p2 !== a3);
  return inside;
}
function splitPolygon$1(a3, b) {
  const a22 = new Node$2(a3.i, a3.x, a3.y), b2 = new Node$2(b.i, b.x, b.y), an = a3.next, bp = b.prev;
  a3.next = b;
  b.prev = a3;
  a22.next = an;
  an.prev = a22;
  b2.next = a22;
  a22.prev = b2;
  bp.next = b2;
  b2.prev = bp;
  return b2;
}
function insertNode$1(i2, x, y, last) {
  const p2 = new Node$2(i2, x, y);
  if (!last) {
    p2.prev = p2;
    p2.next = p2;
  } else {
    p2.next = last.next;
    p2.prev = last;
    last.next.prev = p2;
    last.next = p2;
  }
  return p2;
}
function removeNode$1(p2) {
  p2.next.prev = p2.prev;
  p2.prev.next = p2.next;
  if (p2.prevZ) p2.prevZ.nextZ = p2.nextZ;
  if (p2.nextZ) p2.nextZ.prevZ = p2.prevZ;
}
function Node$2(i2, x, y) {
  this.i = i2;
  this.x = x;
  this.y = y;
  this.prev = null;
  this.next = null;
  this.z = 0;
  this.prevZ = null;
  this.nextZ = null;
  this.steiner = false;
}
function signedArea$1(data, start, end, dim) {
  let sum = 0;
  for (let i2 = start, j = end - dim; i2 < end; i2 += dim) {
    sum += (data[j] - data[i2]) * (data[i2 + 1] + data[j + 1]);
    j = i2;
  }
  return sum;
}
let ShapeUtils$1 = class ShapeUtils {
  // calculate area of the contour polygon
  static area(contour) {
    const n2 = contour.length;
    let a3 = 0;
    for (let p2 = n2 - 1, q = 0; q < n2; p2 = q++) {
      a3 += contour[p2].x * contour[q].y - contour[q].x * contour[p2].y;
    }
    return a3 * 0.5;
  }
  static isClockWise(pts) {
    return ShapeUtils.area(pts) < 0;
  }
  static triangulateShape(contour, holes) {
    const vertices = [];
    const holeIndices = [];
    const faces = [];
    removeDupEndPts$1(contour);
    addContour$1(vertices, contour);
    let holeIndex = contour.length;
    holes.forEach(removeDupEndPts$1);
    for (let i2 = 0; i2 < holes.length; i2++) {
      holeIndices.push(holeIndex);
      holeIndex += holes[i2].length;
      addContour$1(vertices, holes[i2]);
    }
    const triangles = Earcut$1.triangulate(vertices, holeIndices);
    for (let i2 = 0; i2 < triangles.length; i2 += 3) {
      faces.push(triangles.slice(i2, i2 + 3));
    }
    return faces;
  }
};
function removeDupEndPts$1(points) {
  const l2 = points.length;
  if (l2 > 2 && points[l2 - 1].equals(points[0])) {
    points.pop();
  }
}
function addContour$1(vertices, contour) {
  for (let i2 = 0; i2 < contour.length; i2++) {
    vertices.push(contour[i2].x);
    vertices.push(contour[i2].y);
  }
}
let ExtrudeGeometry$1 = class ExtrudeGeometry extends BufferGeometry$1 {
  constructor(shapes = new Shape$1([new Vector2$1(0.5, 0.5), new Vector2$1(-0.5, 0.5), new Vector2$1(-0.5, -0.5), new Vector2$1(0.5, -0.5)]), options = {}) {
    super();
    this.type = "ExtrudeGeometry";
    this.parameters = {
      shapes,
      options
    };
    shapes = Array.isArray(shapes) ? shapes : [shapes];
    const scope = this;
    const verticesArray = [];
    const uvArray = [];
    for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
      const shape = shapes[i2];
      addShape(shape);
    }
    this.setAttribute("position", new Float32BufferAttribute$1(verticesArray, 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvArray, 2));
    this.computeVertexNormals();
    function addShape(shape) {
      const placeholder = [];
      const curveSegments = options.curveSegments !== void 0 ? options.curveSegments : 12;
      const steps = options.steps !== void 0 ? options.steps : 1;
      const depth = options.depth !== void 0 ? options.depth : 1;
      let bevelEnabled = options.bevelEnabled !== void 0 ? options.bevelEnabled : true;
      let bevelThickness = options.bevelThickness !== void 0 ? options.bevelThickness : 0.2;
      let bevelSize = options.bevelSize !== void 0 ? options.bevelSize : bevelThickness - 0.1;
      let bevelOffset = options.bevelOffset !== void 0 ? options.bevelOffset : 0;
      let bevelSegments = options.bevelSegments !== void 0 ? options.bevelSegments : 3;
      const extrudePath = options.extrudePath;
      const uvgen = options.UVGenerator !== void 0 ? options.UVGenerator : WorldUVGenerator$1;
      let extrudePts, extrudeByPath = false;
      let splineTube, binormal, normal, position2;
      if (extrudePath) {
        extrudePts = extrudePath.getSpacedPoints(steps);
        extrudeByPath = true;
        bevelEnabled = false;
        splineTube = extrudePath.computeFrenetFrames(steps, false);
        binormal = new Vector3$1();
        normal = new Vector3$1();
        position2 = new Vector3$1();
      }
      if (!bevelEnabled) {
        bevelSegments = 0;
        bevelThickness = 0;
        bevelSize = 0;
        bevelOffset = 0;
      }
      const shapePoints = shape.extractPoints(curveSegments);
      let vertices = shapePoints.shape;
      const holes = shapePoints.holes;
      const reverse = !ShapeUtils$1.isClockWise(vertices);
      if (reverse) {
        vertices = vertices.reverse();
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          if (ShapeUtils$1.isClockWise(ahole)) {
            holes[h2] = ahole.reverse();
          }
        }
      }
      const faces = ShapeUtils$1.triangulateShape(vertices, holes);
      const contour = vertices;
      for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
        const ahole = holes[h2];
        vertices = vertices.concat(ahole);
      }
      function scalePt2(pt2, vec, size) {
        if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
        return pt2.clone().addScaledVector(vec, size);
      }
      const vlen = vertices.length, flen = faces.length;
      function getBevelVec(inPt, inPrev, inNext) {
        let v_trans_x, v_trans_y, shrink_by;
        const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
        const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
        const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
        const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
        if (Math.abs(collinear0) > Number.EPSILON) {
          const v_prev_len = Math.sqrt(v_prev_lensq);
          const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
          const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
          const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
          const ptNextShift_x = inNext.x - v_next_y / v_next_len;
          const ptNextShift_y = inNext.y + v_next_x / v_next_len;
          const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
          v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
          v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
          const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
          if (v_trans_lensq <= 2) {
            return new Vector2$1(v_trans_x, v_trans_y);
          } else {
            shrink_by = Math.sqrt(v_trans_lensq / 2);
          }
        } else {
          let direction_eq = false;
          if (v_prev_x > Number.EPSILON) {
            if (v_next_x > Number.EPSILON) {
              direction_eq = true;
            }
          } else {
            if (v_prev_x < -Number.EPSILON) {
              if (v_next_x < -Number.EPSILON) {
                direction_eq = true;
              }
            } else {
              if (Math.sign(v_prev_y) === Math.sign(v_next_y)) {
                direction_eq = true;
              }
            }
          }
          if (direction_eq) {
            v_trans_x = -v_prev_y;
            v_trans_y = v_prev_x;
            shrink_by = Math.sqrt(v_prev_lensq);
          } else {
            v_trans_x = v_prev_x;
            v_trans_y = v_prev_y;
            shrink_by = Math.sqrt(v_prev_lensq / 2);
          }
        }
        return new Vector2$1(v_trans_x / shrink_by, v_trans_y / shrink_by);
      }
      const contourMovements = [];
      for (let i2 = 0, il = contour.length, j = il - 1, k = i2 + 1; i2 < il; i2++, j++, k++) {
        if (j === il) j = 0;
        if (k === il) k = 0;
        contourMovements[i2] = getBevelVec(contour[i2], contour[j], contour[k]);
      }
      const holesMovements = [];
      let oneHoleMovements, verticesMovements = contourMovements.concat();
      for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
        const ahole = holes[h2];
        oneHoleMovements = [];
        for (let i2 = 0, il = ahole.length, j = il - 1, k = i2 + 1; i2 < il; i2++, j++, k++) {
          if (j === il) j = 0;
          if (k === il) k = 0;
          oneHoleMovements[i2] = getBevelVec(ahole[i2], ahole[j], ahole[k]);
        }
        holesMovements.push(oneHoleMovements);
        verticesMovements = verticesMovements.concat(oneHoleMovements);
      }
      for (let b = 0; b < bevelSegments; b++) {
        const t3 = b / bevelSegments;
        const z2 = bevelThickness * Math.cos(t3 * Math.PI / 2);
        const bs2 = bevelSize * Math.sin(t3 * Math.PI / 2) + bevelOffset;
        for (let i2 = 0, il = contour.length; i2 < il; i2++) {
          const vert = scalePt2(contour[i2], contourMovements[i2], bs2);
          v(vert.x, vert.y, -z2);
        }
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          oneHoleMovements = holesMovements[h2];
          for (let i2 = 0, il = ahole.length; i2 < il; i2++) {
            const vert = scalePt2(ahole[i2], oneHoleMovements[i2], bs2);
            v(vert.x, vert.y, -z2);
          }
        }
      }
      const bs = bevelSize + bevelOffset;
      for (let i2 = 0; i2 < vlen; i2++) {
        const vert = bevelEnabled ? scalePt2(vertices[i2], verticesMovements[i2], bs) : vertices[i2];
        if (!extrudeByPath) {
          v(vert.x, vert.y, 0);
        } else {
          normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
          binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
          position2.copy(extrudePts[0]).add(normal).add(binormal);
          v(position2.x, position2.y, position2.z);
        }
      }
      for (let s2 = 1; s2 <= steps; s2++) {
        for (let i2 = 0; i2 < vlen; i2++) {
          const vert = bevelEnabled ? scalePt2(vertices[i2], verticesMovements[i2], bs) : vertices[i2];
          if (!extrudeByPath) {
            v(vert.x, vert.y, depth / steps * s2);
          } else {
            normal.copy(splineTube.normals[s2]).multiplyScalar(vert.x);
            binormal.copy(splineTube.binormals[s2]).multiplyScalar(vert.y);
            position2.copy(extrudePts[s2]).add(normal).add(binormal);
            v(position2.x, position2.y, position2.z);
          }
        }
      }
      for (let b = bevelSegments - 1; b >= 0; b--) {
        const t3 = b / bevelSegments;
        const z2 = bevelThickness * Math.cos(t3 * Math.PI / 2);
        const bs2 = bevelSize * Math.sin(t3 * Math.PI / 2) + bevelOffset;
        for (let i2 = 0, il = contour.length; i2 < il; i2++) {
          const vert = scalePt2(contour[i2], contourMovements[i2], bs2);
          v(vert.x, vert.y, depth + z2);
        }
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          oneHoleMovements = holesMovements[h2];
          for (let i2 = 0, il = ahole.length; i2 < il; i2++) {
            const vert = scalePt2(ahole[i2], oneHoleMovements[i2], bs2);
            if (!extrudeByPath) {
              v(vert.x, vert.y, depth + z2);
            } else {
              v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z2);
            }
          }
        }
      }
      buildLidFaces();
      buildSideFaces();
      function buildLidFaces() {
        const start = verticesArray.length / 3;
        if (bevelEnabled) {
          let layer = 0;
          let offset = vlen * layer;
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces[i2];
            f3(face[2] + offset, face[1] + offset, face[0] + offset);
          }
          layer = steps + bevelSegments * 2;
          offset = vlen * layer;
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces[i2];
            f3(face[0] + offset, face[1] + offset, face[2] + offset);
          }
        } else {
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces[i2];
            f3(face[2], face[1], face[0]);
          }
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces[i2];
            f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
          }
        }
        scope.addGroup(start, verticesArray.length / 3 - start, 0);
      }
      function buildSideFaces() {
        const start = verticesArray.length / 3;
        let layeroffset = 0;
        sidewalls(contour, layeroffset);
        layeroffset += contour.length;
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          sidewalls(ahole, layeroffset);
          layeroffset += ahole.length;
        }
        scope.addGroup(start, verticesArray.length / 3 - start, 1);
      }
      function sidewalls(contour2, layeroffset) {
        let i2 = contour2.length;
        while (--i2 >= 0) {
          const j = i2;
          let k = i2 - 1;
          if (k < 0) k = contour2.length - 1;
          for (let s2 = 0, sl = steps + bevelSegments * 2; s2 < sl; s2++) {
            const slen1 = vlen * s2;
            const slen2 = vlen * (s2 + 1);
            const a3 = layeroffset + j + slen1, b = layeroffset + k + slen1, c2 = layeroffset + k + slen2, d2 = layeroffset + j + slen2;
            f4(a3, b, c2, d2);
          }
        }
      }
      function v(x, y, z2) {
        placeholder.push(x);
        placeholder.push(y);
        placeholder.push(z2);
      }
      function f3(a3, b, c2) {
        addVertex(a3);
        addVertex(b);
        addVertex(c2);
        const nextIndex = verticesArray.length / 3;
        const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
        addUV(uvs[0]);
        addUV(uvs[1]);
        addUV(uvs[2]);
      }
      function f4(a3, b, c2, d2) {
        addVertex(a3);
        addVertex(b);
        addVertex(d2);
        addVertex(b);
        addVertex(c2);
        addVertex(d2);
        const nextIndex = verticesArray.length / 3;
        const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
        addUV(uvs[0]);
        addUV(uvs[1]);
        addUV(uvs[3]);
        addUV(uvs[1]);
        addUV(uvs[2]);
        addUV(uvs[3]);
      }
      function addVertex(index2) {
        verticesArray.push(placeholder[index2 * 3 + 0]);
        verticesArray.push(placeholder[index2 * 3 + 1]);
        verticesArray.push(placeholder[index2 * 3 + 2]);
      }
      function addUV(vector2) {
        uvArray.push(vector2.x);
        uvArray.push(vector2.y);
      }
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    const shapes = this.parameters.shapes;
    const options = this.parameters.options;
    return toJSON$1$1(shapes, options, data);
  }
  static fromJSON(data, shapes) {
    const geometryShapes = [];
    for (let j = 0, jl = data.shapes.length; j < jl; j++) {
      const shape = shapes[data.shapes[j]];
      geometryShapes.push(shape);
    }
    const extrudePath = data.options.extrudePath;
    if (extrudePath !== void 0) {
      data.options.extrudePath = new Curves$1[extrudePath.type]().fromJSON(extrudePath);
    }
    return new ExtrudeGeometry(geometryShapes, data.options);
  }
};
const WorldUVGenerator$1 = {
  generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
    const a_x = vertices[indexA * 3];
    const a_y = vertices[indexA * 3 + 1];
    const b_x = vertices[indexB * 3];
    const b_y = vertices[indexB * 3 + 1];
    const c_x = vertices[indexC * 3];
    const c_y = vertices[indexC * 3 + 1];
    return [
      new Vector2$1(a_x, a_y),
      new Vector2$1(b_x, b_y),
      new Vector2$1(c_x, c_y)
    ];
  },
  generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
    const a_x = vertices[indexA * 3];
    const a_y = vertices[indexA * 3 + 1];
    const a_z = vertices[indexA * 3 + 2];
    const b_x = vertices[indexB * 3];
    const b_y = vertices[indexB * 3 + 1];
    const b_z = vertices[indexB * 3 + 2];
    const c_x = vertices[indexC * 3];
    const c_y = vertices[indexC * 3 + 1];
    const c_z = vertices[indexC * 3 + 2];
    const d_x = vertices[indexD * 3];
    const d_y = vertices[indexD * 3 + 1];
    const d_z = vertices[indexD * 3 + 2];
    if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) {
      return [
        new Vector2$1(a_x, 1 - a_z),
        new Vector2$1(b_x, 1 - b_z),
        new Vector2$1(c_x, 1 - c_z),
        new Vector2$1(d_x, 1 - d_z)
      ];
    } else {
      return [
        new Vector2$1(a_y, 1 - a_z),
        new Vector2$1(b_y, 1 - b_z),
        new Vector2$1(c_y, 1 - c_z),
        new Vector2$1(d_y, 1 - d_z)
      ];
    }
  }
};
function toJSON$1$1(shapes, options, data) {
  data.shapes = [];
  if (Array.isArray(shapes)) {
    for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
      const shape = shapes[i2];
      data.shapes.push(shape.uuid);
    }
  } else {
    data.shapes.push(shapes.uuid);
  }
  data.options = Object.assign({}, options);
  if (options.extrudePath !== void 0) data.options.extrudePath = options.extrudePath.toJSON();
  return data;
}
class IcosahedronGeometry extends PolyhedronGeometry {
  constructor(radius = 1, detail = 0) {
    const t3 = (1 + Math.sqrt(5)) / 2;
    const vertices = [
      -1,
      t3,
      0,
      1,
      t3,
      0,
      -1,
      -t3,
      0,
      1,
      -t3,
      0,
      0,
      -1,
      t3,
      0,
      1,
      t3,
      0,
      -1,
      -t3,
      0,
      1,
      -t3,
      t3,
      0,
      -1,
      t3,
      0,
      1,
      -t3,
      0,
      -1,
      -t3,
      0,
      1
    ];
    const indices = [
      0,
      11,
      5,
      0,
      5,
      1,
      0,
      1,
      7,
      0,
      7,
      10,
      0,
      10,
      11,
      1,
      5,
      9,
      5,
      11,
      4,
      11,
      10,
      2,
      10,
      7,
      6,
      7,
      1,
      8,
      3,
      9,
      4,
      3,
      4,
      2,
      3,
      2,
      6,
      3,
      6,
      8,
      3,
      8,
      9,
      4,
      9,
      5,
      2,
      4,
      11,
      6,
      2,
      10,
      8,
      6,
      7,
      9,
      8,
      1
    ];
    super(vertices, indices, radius, detail);
    this.type = "IcosahedronGeometry";
    this.parameters = {
      radius,
      detail
    };
  }
  static fromJSON(data) {
    return new IcosahedronGeometry(data.radius, data.detail);
  }
}
class OctahedronGeometry extends PolyhedronGeometry {
  constructor(radius = 1, detail = 0) {
    const vertices = [
      1,
      0,
      0,
      -1,
      0,
      0,
      0,
      1,
      0,
      0,
      -1,
      0,
      0,
      0,
      1,
      0,
      0,
      -1
    ];
    const indices = [
      0,
      2,
      4,
      0,
      4,
      3,
      0,
      3,
      5,
      0,
      5,
      2,
      1,
      2,
      5,
      1,
      5,
      3,
      1,
      3,
      4,
      1,
      4,
      2
    ];
    super(vertices, indices, radius, detail);
    this.type = "OctahedronGeometry";
    this.parameters = {
      radius,
      detail
    };
  }
  static fromJSON(data) {
    return new OctahedronGeometry(data.radius, data.detail);
  }
}
let PlaneGeometry$1 = class PlaneGeometry extends BufferGeometry$1 {
  constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1) {
    super();
    this.type = "PlaneGeometry";
    this.parameters = {
      width,
      height,
      widthSegments,
      heightSegments
    };
    const width_half = width / 2;
    const height_half = height / 2;
    const gridX = Math.floor(widthSegments);
    const gridY = Math.floor(heightSegments);
    const gridX1 = gridX + 1;
    const gridY1 = gridY + 1;
    const segment_width = width / gridX;
    const segment_height = height / gridY;
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    for (let iy = 0; iy < gridY1; iy++) {
      const y = iy * segment_height - height_half;
      for (let ix = 0; ix < gridX1; ix++) {
        const x = ix * segment_width - width_half;
        vertices.push(x, -y, 0);
        normals.push(0, 0, 1);
        uvs.push(ix / gridX);
        uvs.push(1 - iy / gridY);
      }
    }
    for (let iy = 0; iy < gridY; iy++) {
      for (let ix = 0; ix < gridX; ix++) {
        const a3 = ix + gridX1 * iy;
        const b = ix + gridX1 * (iy + 1);
        const c2 = ix + 1 + gridX1 * (iy + 1);
        const d2 = ix + 1 + gridX1 * iy;
        indices.push(a3, b, d2);
        indices.push(b, c2, d2);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute$1(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvs, 2));
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new PlaneGeometry(data.width, data.height, data.widthSegments, data.heightSegments);
  }
};
class RingGeometry extends BufferGeometry$1 {
  constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2) {
    super();
    this.type = "RingGeometry";
    this.parameters = {
      innerRadius,
      outerRadius,
      thetaSegments,
      phiSegments,
      thetaStart,
      thetaLength
    };
    thetaSegments = Math.max(3, thetaSegments);
    phiSegments = Math.max(1, phiSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let radius = innerRadius;
    const radiusStep = (outerRadius - innerRadius) / phiSegments;
    const vertex2 = new Vector3$1();
    const uv = new Vector2$1();
    for (let j = 0; j <= phiSegments; j++) {
      for (let i2 = 0; i2 <= thetaSegments; i2++) {
        const segment = thetaStart + i2 / thetaSegments * thetaLength;
        vertex2.x = radius * Math.cos(segment);
        vertex2.y = radius * Math.sin(segment);
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        normals.push(0, 0, 1);
        uv.x = (vertex2.x / outerRadius + 1) / 2;
        uv.y = (vertex2.y / outerRadius + 1) / 2;
        uvs.push(uv.x, uv.y);
      }
      radius += radiusStep;
    }
    for (let j = 0; j < phiSegments; j++) {
      const thetaSegmentLevel = j * (thetaSegments + 1);
      for (let i2 = 0; i2 < thetaSegments; i2++) {
        const segment = i2 + thetaSegmentLevel;
        const a3 = segment;
        const b = segment + thetaSegments + 1;
        const c2 = segment + thetaSegments + 2;
        const d2 = segment + 1;
        indices.push(a3, b, d2);
        indices.push(b, c2, d2);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute$1(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvs, 2));
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new RingGeometry(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
  }
}
let ShapeGeometry$1 = class ShapeGeometry extends BufferGeometry$1 {
  constructor(shapes = new Shape$1([new Vector2$1(0, 0.5), new Vector2$1(-0.5, -0.5), new Vector2$1(0.5, -0.5)]), curveSegments = 12) {
    super();
    this.type = "ShapeGeometry";
    this.parameters = {
      shapes,
      curveSegments
    };
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let groupStart = 0;
    let groupCount = 0;
    if (Array.isArray(shapes) === false) {
      addShape(shapes);
    } else {
      for (let i2 = 0; i2 < shapes.length; i2++) {
        addShape(shapes[i2]);
        this.addGroup(groupStart, groupCount, i2);
        groupStart += groupCount;
        groupCount = 0;
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute$1(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvs, 2));
    function addShape(shape) {
      const indexOffset = vertices.length / 3;
      const points = shape.extractPoints(curveSegments);
      let shapeVertices = points.shape;
      const shapeHoles = points.holes;
      if (ShapeUtils$1.isClockWise(shapeVertices) === false) {
        shapeVertices = shapeVertices.reverse();
      }
      for (let i2 = 0, l2 = shapeHoles.length; i2 < l2; i2++) {
        const shapeHole = shapeHoles[i2];
        if (ShapeUtils$1.isClockWise(shapeHole) === true) {
          shapeHoles[i2] = shapeHole.reverse();
        }
      }
      const faces = ShapeUtils$1.triangulateShape(shapeVertices, shapeHoles);
      for (let i2 = 0, l2 = shapeHoles.length; i2 < l2; i2++) {
        const shapeHole = shapeHoles[i2];
        shapeVertices = shapeVertices.concat(shapeHole);
      }
      for (let i2 = 0, l2 = shapeVertices.length; i2 < l2; i2++) {
        const vertex2 = shapeVertices[i2];
        vertices.push(vertex2.x, vertex2.y, 0);
        normals.push(0, 0, 1);
        uvs.push(vertex2.x, vertex2.y);
      }
      for (let i2 = 0, l2 = faces.length; i2 < l2; i2++) {
        const face = faces[i2];
        const a3 = face[0] + indexOffset;
        const b = face[1] + indexOffset;
        const c2 = face[2] + indexOffset;
        indices.push(a3, b, c2);
        groupCount += 3;
      }
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    const shapes = this.parameters.shapes;
    return toJSON$2(shapes, data);
  }
  static fromJSON(data, shapes) {
    const geometryShapes = [];
    for (let j = 0, jl = data.shapes.length; j < jl; j++) {
      const shape = shapes[data.shapes[j]];
      geometryShapes.push(shape);
    }
    return new ShapeGeometry(geometryShapes, data.curveSegments);
  }
};
function toJSON$2(shapes, data) {
  data.shapes = [];
  if (Array.isArray(shapes)) {
    for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
      const shape = shapes[i2];
      data.shapes.push(shape.uuid);
    }
  } else {
    data.shapes.push(shapes.uuid);
  }
  return data;
}
class SphereGeometry extends BufferGeometry$1 {
  constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI) {
    super();
    this.type = "SphereGeometry";
    this.parameters = {
      radius,
      widthSegments,
      heightSegments,
      phiStart,
      phiLength,
      thetaStart,
      thetaLength
    };
    widthSegments = Math.max(3, Math.floor(widthSegments));
    heightSegments = Math.max(2, Math.floor(heightSegments));
    const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
    let index2 = 0;
    const grid = [];
    const vertex2 = new Vector3$1();
    const normal = new Vector3$1();
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    for (let iy = 0; iy <= heightSegments; iy++) {
      const verticesRow = [];
      const v = iy / heightSegments;
      let uOffset = 0;
      if (iy === 0 && thetaStart === 0) {
        uOffset = 0.5 / widthSegments;
      } else if (iy === heightSegments && thetaEnd === Math.PI) {
        uOffset = -0.5 / widthSegments;
      }
      for (let ix = 0; ix <= widthSegments; ix++) {
        const u3 = ix / widthSegments;
        vertex2.x = -radius * Math.cos(phiStart + u3 * phiLength) * Math.sin(thetaStart + v * thetaLength);
        vertex2.y = radius * Math.cos(thetaStart + v * thetaLength);
        vertex2.z = radius * Math.sin(phiStart + u3 * phiLength) * Math.sin(thetaStart + v * thetaLength);
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        normal.copy(vertex2).normalize();
        normals.push(normal.x, normal.y, normal.z);
        uvs.push(u3 + uOffset, 1 - v);
        verticesRow.push(index2++);
      }
      grid.push(verticesRow);
    }
    for (let iy = 0; iy < heightSegments; iy++) {
      for (let ix = 0; ix < widthSegments; ix++) {
        const a3 = grid[iy][ix + 1];
        const b = grid[iy][ix];
        const c2 = grid[iy + 1][ix];
        const d2 = grid[iy + 1][ix + 1];
        if (iy !== 0 || thetaStart > 0) indices.push(a3, b, d2);
        if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c2, d2);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute$1(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvs, 2));
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new SphereGeometry(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
  }
}
class TetrahedronGeometry extends PolyhedronGeometry {
  constructor(radius = 1, detail = 0) {
    const vertices = [
      1,
      1,
      1,
      -1,
      -1,
      1,
      -1,
      1,
      -1,
      1,
      -1,
      -1
    ];
    const indices = [
      2,
      1,
      0,
      0,
      3,
      2,
      1,
      3,
      0,
      2,
      3,
      1
    ];
    super(vertices, indices, radius, detail);
    this.type = "TetrahedronGeometry";
    this.parameters = {
      radius,
      detail
    };
  }
  static fromJSON(data) {
    return new TetrahedronGeometry(data.radius, data.detail);
  }
}
class TorusGeometry extends BufferGeometry$1 {
  constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2) {
    super();
    this.type = "TorusGeometry";
    this.parameters = {
      radius,
      tube,
      radialSegments,
      tubularSegments,
      arc
    };
    radialSegments = Math.floor(radialSegments);
    tubularSegments = Math.floor(tubularSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    const center = new Vector3$1();
    const vertex2 = new Vector3$1();
    const normal = new Vector3$1();
    for (let j = 0; j <= radialSegments; j++) {
      for (let i2 = 0; i2 <= tubularSegments; i2++) {
        const u3 = i2 / tubularSegments * arc;
        const v = j / radialSegments * Math.PI * 2;
        vertex2.x = (radius + tube * Math.cos(v)) * Math.cos(u3);
        vertex2.y = (radius + tube * Math.cos(v)) * Math.sin(u3);
        vertex2.z = tube * Math.sin(v);
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        center.x = radius * Math.cos(u3);
        center.y = radius * Math.sin(u3);
        normal.subVectors(vertex2, center).normalize();
        normals.push(normal.x, normal.y, normal.z);
        uvs.push(i2 / tubularSegments);
        uvs.push(j / radialSegments);
      }
    }
    for (let j = 1; j <= radialSegments; j++) {
      for (let i2 = 1; i2 <= tubularSegments; i2++) {
        const a3 = (tubularSegments + 1) * j + i2 - 1;
        const b = (tubularSegments + 1) * (j - 1) + i2 - 1;
        const c2 = (tubularSegments + 1) * (j - 1) + i2;
        const d2 = (tubularSegments + 1) * j + i2;
        indices.push(a3, b, d2);
        indices.push(b, c2, d2);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute$1(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvs, 2));
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new TorusGeometry(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
  }
}
class TorusKnotGeometry extends BufferGeometry$1 {
  constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p2 = 2, q = 3) {
    super();
    this.type = "TorusKnotGeometry";
    this.parameters = {
      radius,
      tube,
      tubularSegments,
      radialSegments,
      p: p2,
      q
    };
    tubularSegments = Math.floor(tubularSegments);
    radialSegments = Math.floor(radialSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    const vertex2 = new Vector3$1();
    const normal = new Vector3$1();
    const P1 = new Vector3$1();
    const P2 = new Vector3$1();
    const B3 = new Vector3$1();
    const T2 = new Vector3$1();
    const N = new Vector3$1();
    for (let i2 = 0; i2 <= tubularSegments; ++i2) {
      const u3 = i2 / tubularSegments * p2 * Math.PI * 2;
      calculatePositionOnCurve(u3, p2, q, radius, P1);
      calculatePositionOnCurve(u3 + 0.01, p2, q, radius, P2);
      T2.subVectors(P2, P1);
      N.addVectors(P2, P1);
      B3.crossVectors(T2, N);
      N.crossVectors(B3, T2);
      B3.normalize();
      N.normalize();
      for (let j = 0; j <= radialSegments; ++j) {
        const v = j / radialSegments * Math.PI * 2;
        const cx = -tube * Math.cos(v);
        const cy = tube * Math.sin(v);
        vertex2.x = P1.x + (cx * N.x + cy * B3.x);
        vertex2.y = P1.y + (cx * N.y + cy * B3.y);
        vertex2.z = P1.z + (cx * N.z + cy * B3.z);
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        normal.subVectors(vertex2, P1).normalize();
        normals.push(normal.x, normal.y, normal.z);
        uvs.push(i2 / tubularSegments);
        uvs.push(j / radialSegments);
      }
    }
    for (let j = 1; j <= tubularSegments; j++) {
      for (let i2 = 1; i2 <= radialSegments; i2++) {
        const a3 = (radialSegments + 1) * (j - 1) + (i2 - 1);
        const b = (radialSegments + 1) * j + (i2 - 1);
        const c2 = (radialSegments + 1) * j + i2;
        const d2 = (radialSegments + 1) * (j - 1) + i2;
        indices.push(a3, b, d2);
        indices.push(b, c2, d2);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute$1(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvs, 2));
    function calculatePositionOnCurve(u3, p3, q2, radius2, position2) {
      const cu = Math.cos(u3);
      const su = Math.sin(u3);
      const quOverP = q2 / p3 * u3;
      const cs = Math.cos(quOverP);
      position2.x = radius2 * (2 + cs) * 0.5 * cu;
      position2.y = radius2 * (2 + cs) * su * 0.5;
      position2.z = radius2 * Math.sin(quOverP) * 0.5;
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  static fromJSON(data) {
    return new TorusKnotGeometry(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
  }
}
class TubeGeometry extends BufferGeometry$1 {
  constructor(path = new QuadraticBezierCurve3$1(new Vector3$1(-1, -1, 0), new Vector3$1(-1, 1, 0), new Vector3$1(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false) {
    super();
    this.type = "TubeGeometry";
    this.parameters = {
      path,
      tubularSegments,
      radius,
      radialSegments,
      closed
    };
    const frames = path.computeFrenetFrames(tubularSegments, closed);
    this.tangents = frames.tangents;
    this.normals = frames.normals;
    this.binormals = frames.binormals;
    const vertex2 = new Vector3$1();
    const normal = new Vector3$1();
    const uv = new Vector2$1();
    let P = new Vector3$1();
    const vertices = [];
    const normals = [];
    const uvs = [];
    const indices = [];
    generateBufferData();
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute$1(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvs, 2));
    function generateBufferData() {
      for (let i2 = 0; i2 < tubularSegments; i2++) {
        generateSegment(i2);
      }
      generateSegment(closed === false ? tubularSegments : 0);
      generateUVs();
      generateIndices();
    }
    function generateSegment(i2) {
      P = path.getPointAt(i2 / tubularSegments, P);
      const N = frames.normals[i2];
      const B3 = frames.binormals[i2];
      for (let j = 0; j <= radialSegments; j++) {
        const v = j / radialSegments * Math.PI * 2;
        const sin2 = Math.sin(v);
        const cos2 = -Math.cos(v);
        normal.x = cos2 * N.x + sin2 * B3.x;
        normal.y = cos2 * N.y + sin2 * B3.y;
        normal.z = cos2 * N.z + sin2 * B3.z;
        normal.normalize();
        normals.push(normal.x, normal.y, normal.z);
        vertex2.x = P.x + radius * normal.x;
        vertex2.y = P.y + radius * normal.y;
        vertex2.z = P.z + radius * normal.z;
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
      }
    }
    function generateIndices() {
      for (let j = 1; j <= tubularSegments; j++) {
        for (let i2 = 1; i2 <= radialSegments; i2++) {
          const a3 = (radialSegments + 1) * (j - 1) + (i2 - 1);
          const b = (radialSegments + 1) * j + (i2 - 1);
          const c2 = (radialSegments + 1) * j + i2;
          const d2 = (radialSegments + 1) * (j - 1) + i2;
          indices.push(a3, b, d2);
          indices.push(b, c2, d2);
        }
      }
    }
    function generateUVs() {
      for (let i2 = 0; i2 <= tubularSegments; i2++) {
        for (let j = 0; j <= radialSegments; j++) {
          uv.x = i2 / tubularSegments;
          uv.y = j / radialSegments;
          uvs.push(uv.x, uv.y);
        }
      }
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.path = this.parameters.path.toJSON();
    return data;
  }
  static fromJSON(data) {
    return new TubeGeometry(
      new Curves$1[data.path.type]().fromJSON(data.path),
      data.tubularSegments,
      data.radius,
      data.radialSegments,
      data.closed
    );
  }
}
class WireframeGeometry extends BufferGeometry$1 {
  constructor(geometry = null) {
    super();
    this.type = "WireframeGeometry";
    this.parameters = {
      geometry
    };
    if (geometry !== null) {
      const vertices = [];
      const edges = /* @__PURE__ */ new Set();
      const start = new Vector3$1();
      const end = new Vector3$1();
      if (geometry.index !== null) {
        const position2 = geometry.attributes.position;
        const indices = geometry.index;
        let groups = geometry.groups;
        if (groups.length === 0) {
          groups = [{ start: 0, count: indices.count, materialIndex: 0 }];
        }
        for (let o2 = 0, ol = groups.length; o2 < ol; ++o2) {
          const group = groups[o2];
          const groupStart = group.start;
          const groupCount = group.count;
          for (let i2 = groupStart, l2 = groupStart + groupCount; i2 < l2; i2 += 3) {
            for (let j = 0; j < 3; j++) {
              const index1 = indices.getX(i2 + j);
              const index2 = indices.getX(i2 + (j + 1) % 3);
              start.fromBufferAttribute(position2, index1);
              end.fromBufferAttribute(position2, index2);
              if (isUniqueEdge(start, end, edges) === true) {
                vertices.push(start.x, start.y, start.z);
                vertices.push(end.x, end.y, end.z);
              }
            }
          }
        }
      } else {
        const position2 = geometry.attributes.position;
        for (let i2 = 0, l2 = position2.count / 3; i2 < l2; i2++) {
          for (let j = 0; j < 3; j++) {
            const index1 = 3 * i2 + j;
            const index2 = 3 * i2 + (j + 1) % 3;
            start.fromBufferAttribute(position2, index1);
            end.fromBufferAttribute(position2, index2);
            if (isUniqueEdge(start, end, edges) === true) {
              vertices.push(start.x, start.y, start.z);
              vertices.push(end.x, end.y, end.z);
            }
          }
        }
      }
      this.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    }
  }
  copy(source) {
    super.copy(source);
    this.parameters = Object.assign({}, source.parameters);
    return this;
  }
}
function isUniqueEdge(start, end, edges) {
  const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
  const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`;
  if (edges.has(hash1) === true || edges.has(hash2) === true) {
    return false;
  } else {
    edges.add(hash1);
    edges.add(hash2);
    return true;
  }
}
var Geometries = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BoxGeometry: BoxGeometry$1,
  CapsuleGeometry,
  CircleGeometry,
  ConeGeometry,
  CylinderGeometry,
  DodecahedronGeometry,
  EdgesGeometry,
  ExtrudeGeometry: ExtrudeGeometry$1,
  IcosahedronGeometry,
  LatheGeometry,
  OctahedronGeometry,
  PlaneGeometry: PlaneGeometry$1,
  PolyhedronGeometry,
  RingGeometry,
  ShapeGeometry: ShapeGeometry$1,
  SphereGeometry,
  TetrahedronGeometry,
  TorusGeometry,
  TorusKnotGeometry,
  TubeGeometry,
  WireframeGeometry
});
let ShadowMaterial$1 = class ShadowMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isShadowMaterial = true;
    this.type = "ShadowMaterial";
    this.color = new Color$1(0);
    this.transparent = true;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.fog = source.fog;
    return this;
  }
};
let RawShaderMaterial$1 = class RawShaderMaterial extends ShaderMaterial$1 {
  constructor(parameters) {
    super(parameters);
    this.isRawShaderMaterial = true;
    this.type = "RawShaderMaterial";
  }
};
let MeshStandardMaterial$1 = class MeshStandardMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isMeshStandardMaterial = true;
    this.type = "MeshStandardMaterial";
    this.defines = { "STANDARD": "" };
    this.color = new Color$1(16777215);
    this.roughness = 1;
    this.metalness = 0;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color$1(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap$1;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.roughnessMap = null;
    this.metalnessMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapRotation = new Euler$1();
    this.envMapIntensity = 1;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.flatShading = false;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.defines = { "STANDARD": "" };
    this.color.copy(source.color);
    this.roughness = source.roughness;
    this.metalness = source.metalness;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.roughnessMap = source.roughnessMap;
    this.metalnessMap = source.metalnessMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.envMapRotation.copy(source.envMapRotation);
    this.envMapIntensity = source.envMapIntensity;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.flatShading = source.flatShading;
    this.fog = source.fog;
    return this;
  }
};
let MeshPhysicalMaterial$1 = class MeshPhysicalMaterial extends MeshStandardMaterial$1 {
  constructor(parameters) {
    super();
    this.isMeshPhysicalMaterial = true;
    this.defines = {
      "STANDARD": "",
      "PHYSICAL": ""
    };
    this.type = "MeshPhysicalMaterial";
    this.anisotropyRotation = 0;
    this.anisotropyMap = null;
    this.clearcoatMap = null;
    this.clearcoatRoughness = 0;
    this.clearcoatRoughnessMap = null;
    this.clearcoatNormalScale = new Vector2$1(1, 1);
    this.clearcoatNormalMap = null;
    this.ior = 1.5;
    Object.defineProperty(this, "reflectivity", {
      get: function() {
        return clamp$1(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
      },
      set: function(reflectivity) {
        this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
      }
    });
    this.iridescenceMap = null;
    this.iridescenceIOR = 1.3;
    this.iridescenceThicknessRange = [100, 400];
    this.iridescenceThicknessMap = null;
    this.sheenColor = new Color$1(0);
    this.sheenColorMap = null;
    this.sheenRoughness = 1;
    this.sheenRoughnessMap = null;
    this.transmissionMap = null;
    this.thickness = 0;
    this.thicknessMap = null;
    this.attenuationDistance = Infinity;
    this.attenuationColor = new Color$1(1, 1, 1);
    this.specularIntensity = 1;
    this.specularIntensityMap = null;
    this.specularColor = new Color$1(1, 1, 1);
    this.specularColorMap = null;
    this._anisotropy = 0;
    this._clearcoat = 0;
    this._dispersion = 0;
    this._iridescence = 0;
    this._sheen = 0;
    this._transmission = 0;
    this.setValues(parameters);
  }
  get anisotropy() {
    return this._anisotropy;
  }
  set anisotropy(value) {
    if (this._anisotropy > 0 !== value > 0) {
      this.version++;
    }
    this._anisotropy = value;
  }
  get clearcoat() {
    return this._clearcoat;
  }
  set clearcoat(value) {
    if (this._clearcoat > 0 !== value > 0) {
      this.version++;
    }
    this._clearcoat = value;
  }
  get iridescence() {
    return this._iridescence;
  }
  set iridescence(value) {
    if (this._iridescence > 0 !== value > 0) {
      this.version++;
    }
    this._iridescence = value;
  }
  get dispersion() {
    return this._dispersion;
  }
  set dispersion(value) {
    if (this._dispersion > 0 !== value > 0) {
      this.version++;
    }
    this._dispersion = value;
  }
  get sheen() {
    return this._sheen;
  }
  set sheen(value) {
    if (this._sheen > 0 !== value > 0) {
      this.version++;
    }
    this._sheen = value;
  }
  get transmission() {
    return this._transmission;
  }
  set transmission(value) {
    if (this._transmission > 0 !== value > 0) {
      this.version++;
    }
    this._transmission = value;
  }
  copy(source) {
    super.copy(source);
    this.defines = {
      "STANDARD": "",
      "PHYSICAL": ""
    };
    this.anisotropy = source.anisotropy;
    this.anisotropyRotation = source.anisotropyRotation;
    this.anisotropyMap = source.anisotropyMap;
    this.clearcoat = source.clearcoat;
    this.clearcoatMap = source.clearcoatMap;
    this.clearcoatRoughness = source.clearcoatRoughness;
    this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
    this.clearcoatNormalMap = source.clearcoatNormalMap;
    this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
    this.dispersion = source.dispersion;
    this.ior = source.ior;
    this.iridescence = source.iridescence;
    this.iridescenceMap = source.iridescenceMap;
    this.iridescenceIOR = source.iridescenceIOR;
    this.iridescenceThicknessRange = [...source.iridescenceThicknessRange];
    this.iridescenceThicknessMap = source.iridescenceThicknessMap;
    this.sheen = source.sheen;
    this.sheenColor.copy(source.sheenColor);
    this.sheenColorMap = source.sheenColorMap;
    this.sheenRoughness = source.sheenRoughness;
    this.sheenRoughnessMap = source.sheenRoughnessMap;
    this.transmission = source.transmission;
    this.transmissionMap = source.transmissionMap;
    this.thickness = source.thickness;
    this.thicknessMap = source.thicknessMap;
    this.attenuationDistance = source.attenuationDistance;
    this.attenuationColor.copy(source.attenuationColor);
    this.specularIntensity = source.specularIntensity;
    this.specularIntensityMap = source.specularIntensityMap;
    this.specularColor.copy(source.specularColor);
    this.specularColorMap = source.specularColorMap;
    return this;
  }
};
let MeshPhongMaterial$1 = class MeshPhongMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isMeshPhongMaterial = true;
    this.type = "MeshPhongMaterial";
    this.color = new Color$1(16777215);
    this.specular = new Color$1(1118481);
    this.shininess = 30;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color$1(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap$1;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapRotation = new Euler$1();
    this.combine = MultiplyOperation$1;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.flatShading = false;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.specular.copy(source.specular);
    this.shininess = source.shininess;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.envMapRotation.copy(source.envMapRotation);
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.flatShading = source.flatShading;
    this.fog = source.fog;
    return this;
  }
};
let MeshToonMaterial$1 = class MeshToonMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isMeshToonMaterial = true;
    this.defines = { "TOON": "" };
    this.type = "MeshToonMaterial";
    this.color = new Color$1(16777215);
    this.map = null;
    this.gradientMap = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color$1(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap$1;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.gradientMap = source.gradientMap;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.fog = source.fog;
    return this;
  }
};
let MeshNormalMaterial$1 = class MeshNormalMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isMeshNormalMaterial = true;
    this.type = "MeshNormalMaterial";
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap$1;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.flatShading = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.flatShading = source.flatShading;
    return this;
  }
};
let MeshLambertMaterial$1 = class MeshLambertMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isMeshLambertMaterial = true;
    this.type = "MeshLambertMaterial";
    this.color = new Color$1(16777215);
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color$1(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap$1;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapRotation = new Euler$1();
    this.combine = MultiplyOperation$1;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.flatShading = false;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.envMapRotation.copy(source.envMapRotation);
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.flatShading = source.flatShading;
    this.fog = source.fog;
    return this;
  }
};
let MeshDepthMaterial$1 = class MeshDepthMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isMeshDepthMaterial = true;
    this.type = "MeshDepthMaterial";
    this.depthPacking = BasicDepthPacking$1;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.depthPacking = source.depthPacking;
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    return this;
  }
};
let MeshDistanceMaterial$1 = class MeshDistanceMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isMeshDistanceMaterial = true;
    this.type = "MeshDistanceMaterial";
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    return this;
  }
};
let MeshMatcapMaterial$1 = class MeshMatcapMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.isMeshMatcapMaterial = true;
    this.defines = { "MATCAP": "" };
    this.type = "MeshMatcapMaterial";
    this.color = new Color$1(16777215);
    this.matcap = null;
    this.map = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap$1;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.flatShading = false;
    this.fog = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.defines = { "MATCAP": "" };
    this.color.copy(source.color);
    this.matcap = source.matcap;
    this.map = source.map;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.flatShading = source.flatShading;
    this.fog = source.fog;
    return this;
  }
};
let LineDashedMaterial$1 = class LineDashedMaterial extends LineBasicMaterial$1 {
  constructor(parameters) {
    super();
    this.isLineDashedMaterial = true;
    this.type = "LineDashedMaterial";
    this.scale = 1;
    this.dashSize = 3;
    this.gapSize = 1;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.scale = source.scale;
    this.dashSize = source.dashSize;
    this.gapSize = source.gapSize;
    return this;
  }
};
function convertArray(array, type, forceClone) {
  if (!array || // let 'undefined' and 'null' pass
  !forceClone && array.constructor === type) return array;
  if (typeof type.BYTES_PER_ELEMENT === "number") {
    return new type(array);
  }
  return Array.prototype.slice.call(array);
}
function isTypedArray(object) {
  return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
function getKeyframeOrder(times2) {
  function compareTime(i2, j) {
    return times2[i2] - times2[j];
  }
  const n2 = times2.length;
  const result = new Array(n2);
  for (let i2 = 0; i2 !== n2; ++i2) result[i2] = i2;
  result.sort(compareTime);
  return result;
}
function sortedArray(values, stride, order) {
  const nValues = values.length;
  const result = new values.constructor(nValues);
  for (let i2 = 0, dstOffset = 0; dstOffset !== nValues; ++i2) {
    const srcOffset = order[i2] * stride;
    for (let j = 0; j !== stride; ++j) {
      result[dstOffset++] = values[srcOffset + j];
    }
  }
  return result;
}
function flattenJSON(jsonKeys, times2, values, valuePropertyName) {
  let i2 = 1, key = jsonKeys[0];
  while (key !== void 0 && key[valuePropertyName] === void 0) {
    key = jsonKeys[i2++];
  }
  if (key === void 0) return;
  let value = key[valuePropertyName];
  if (value === void 0) return;
  if (Array.isArray(value)) {
    do {
      value = key[valuePropertyName];
      if (value !== void 0) {
        times2.push(key.time);
        values.push.apply(values, value);
      }
      key = jsonKeys[i2++];
    } while (key !== void 0);
  } else if (value.toArray !== void 0) {
    do {
      value = key[valuePropertyName];
      if (value !== void 0) {
        times2.push(key.time);
        value.toArray(values, values.length);
      }
      key = jsonKeys[i2++];
    } while (key !== void 0);
  } else {
    do {
      value = key[valuePropertyName];
      if (value !== void 0) {
        times2.push(key.time);
        values.push(value);
      }
      key = jsonKeys[i2++];
    } while (key !== void 0);
  }
}
function subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
  const clip = sourceClip.clone();
  clip.name = name;
  const tracks = [];
  for (let i2 = 0; i2 < clip.tracks.length; ++i2) {
    const track = clip.tracks[i2];
    const valueSize = track.getValueSize();
    const times2 = [];
    const values = [];
    for (let j = 0; j < track.times.length; ++j) {
      const frame = track.times[j] * fps;
      if (frame < startFrame || frame >= endFrame) continue;
      times2.push(track.times[j]);
      for (let k = 0; k < valueSize; ++k) {
        values.push(track.values[j * valueSize + k]);
      }
    }
    if (times2.length === 0) continue;
    track.times = convertArray(times2, track.times.constructor);
    track.values = convertArray(values, track.values.constructor);
    tracks.push(track);
  }
  clip.tracks = tracks;
  let minStartTime = Infinity;
  for (let i2 = 0; i2 < clip.tracks.length; ++i2) {
    if (minStartTime > clip.tracks[i2].times[0]) {
      minStartTime = clip.tracks[i2].times[0];
    }
  }
  for (let i2 = 0; i2 < clip.tracks.length; ++i2) {
    clip.tracks[i2].shift(-1 * minStartTime);
  }
  clip.resetDuration();
  return clip;
}
function makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
  if (fps <= 0) fps = 30;
  const numTracks = referenceClip.tracks.length;
  const referenceTime = referenceFrame / fps;
  for (let i2 = 0; i2 < numTracks; ++i2) {
    const referenceTrack = referenceClip.tracks[i2];
    const referenceTrackType = referenceTrack.ValueTypeName;
    if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
    const targetTrack = targetClip.tracks.find(function(track) {
      return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
    });
    if (targetTrack === void 0) continue;
    let referenceOffset = 0;
    const referenceValueSize = referenceTrack.getValueSize();
    if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {
      referenceOffset = referenceValueSize / 3;
    }
    let targetOffset = 0;
    const targetValueSize = targetTrack.getValueSize();
    if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {
      targetOffset = targetValueSize / 3;
    }
    const lastIndex = referenceTrack.times.length - 1;
    let referenceValue;
    if (referenceTime <= referenceTrack.times[0]) {
      const startIndex = referenceOffset;
      const endIndex = referenceValueSize - referenceOffset;
      referenceValue = referenceTrack.values.slice(startIndex, endIndex);
    } else if (referenceTime >= referenceTrack.times[lastIndex]) {
      const startIndex = lastIndex * referenceValueSize + referenceOffset;
      const endIndex = startIndex + referenceValueSize - referenceOffset;
      referenceValue = referenceTrack.values.slice(startIndex, endIndex);
    } else {
      const interpolant = referenceTrack.createInterpolant();
      const startIndex = referenceOffset;
      const endIndex = referenceValueSize - referenceOffset;
      interpolant.evaluate(referenceTime);
      referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
    }
    if (referenceTrackType === "quaternion") {
      const referenceQuat = new Quaternion$1().fromArray(referenceValue).normalize().conjugate();
      referenceQuat.toArray(referenceValue);
    }
    const numTimes = targetTrack.times.length;
    for (let j = 0; j < numTimes; ++j) {
      const valueStart = j * targetValueSize + targetOffset;
      if (referenceTrackType === "quaternion") {
        Quaternion$1.multiplyQuaternionsFlat(
          targetTrack.values,
          valueStart,
          referenceValue,
          0,
          targetTrack.values,
          valueStart
        );
      } else {
        const valueEnd = targetValueSize - targetOffset * 2;
        for (let k = 0; k < valueEnd; ++k) {
          targetTrack.values[valueStart + k] -= referenceValue[k];
        }
      }
    }
  }
  targetClip.blendMode = AdditiveAnimationBlendMode$1;
  return targetClip;
}
const AnimationUtils$1 = {
  convertArray,
  isTypedArray,
  getKeyframeOrder,
  sortedArray,
  flattenJSON,
  subclip,
  makeClipAdditive
};
let Interpolant$1 = class Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    this.parameterPositions = parameterPositions;
    this._cachedIndex = 0;
    this.resultBuffer = resultBuffer !== void 0 ? resultBuffer : new sampleValues.constructor(sampleSize);
    this.sampleValues = sampleValues;
    this.valueSize = sampleSize;
    this.settings = null;
    this.DefaultSettings_ = {};
  }
  evaluate(t3) {
    const pp = this.parameterPositions;
    let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
    validate_interval: {
      seek: {
        let right;
        linear_scan: {
          forward_scan: if (!(t3 < t1)) {
            for (let giveUpAt = i1 + 2; ; ) {
              if (t1 === void 0) {
                if (t3 < t0) break forward_scan;
                i1 = pp.length;
                this._cachedIndex = i1;
                return this.copySampleValue_(i1 - 1);
              }
              if (i1 === giveUpAt) break;
              t0 = t1;
              t1 = pp[++i1];
              if (t3 < t1) {
                break seek;
              }
            }
            right = pp.length;
            break linear_scan;
          }
          if (!(t3 >= t0)) {
            const t1global = pp[1];
            if (t3 < t1global) {
              i1 = 2;
              t0 = t1global;
            }
            for (let giveUpAt = i1 - 2; ; ) {
              if (t0 === void 0) {
                this._cachedIndex = 0;
                return this.copySampleValue_(0);
              }
              if (i1 === giveUpAt) break;
              t1 = t0;
              t0 = pp[--i1 - 1];
              if (t3 >= t0) {
                break seek;
              }
            }
            right = i1;
            i1 = 0;
            break linear_scan;
          }
          break validate_interval;
        }
        while (i1 < right) {
          const mid = i1 + right >>> 1;
          if (t3 < pp[mid]) {
            right = mid;
          } else {
            i1 = mid + 1;
          }
        }
        t1 = pp[i1];
        t0 = pp[i1 - 1];
        if (t0 === void 0) {
          this._cachedIndex = 0;
          return this.copySampleValue_(0);
        }
        if (t1 === void 0) {
          i1 = pp.length;
          this._cachedIndex = i1;
          return this.copySampleValue_(i1 - 1);
        }
      }
      this._cachedIndex = i1;
      this.intervalChanged_(i1, t0, t1);
    }
    return this.interpolate_(i1, t0, t3, t1);
  }
  getSettings_() {
    return this.settings || this.DefaultSettings_;
  }
  copySampleValue_(index2) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index2 * stride;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result[i2] = values[offset + i2];
    }
    return result;
  }
  // Template methods for derived classes:
  interpolate_() {
    throw new Error("call to abstract method");
  }
  intervalChanged_() {
  }
};
let CubicInterpolant$1 = class CubicInterpolant extends Interpolant$1 {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    this._weightPrev = -0;
    this._offsetPrev = -0;
    this._weightNext = -0;
    this._offsetNext = -0;
    this.DefaultSettings_ = {
      endingStart: ZeroCurvatureEnding$1,
      endingEnd: ZeroCurvatureEnding$1
    };
  }
  intervalChanged_(i1, t0, t1) {
    const pp = this.parameterPositions;
    let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
    if (tPrev === void 0) {
      switch (this.getSettings_().endingStart) {
        case ZeroSlopeEnding$1:
          iPrev = i1;
          tPrev = 2 * t0 - t1;
          break;
        case WrapAroundEnding$1:
          iPrev = pp.length - 2;
          tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
          break;
        default:
          iPrev = i1;
          tPrev = t1;
      }
    }
    if (tNext === void 0) {
      switch (this.getSettings_().endingEnd) {
        case ZeroSlopeEnding$1:
          iNext = i1;
          tNext = 2 * t1 - t0;
          break;
        case WrapAroundEnding$1:
          iNext = 1;
          tNext = t1 + pp[1] - pp[0];
          break;
        default:
          iNext = i1 - 1;
          tNext = t0;
      }
    }
    const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
    this._weightPrev = halfDt / (t0 - tPrev);
    this._weightNext = halfDt / (tNext - t1);
    this._offsetPrev = iPrev * stride;
    this._offsetNext = iNext * stride;
  }
  interpolate_(i1, t0, t3, t1) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p2 = (t3 - t0) / (t1 - t0), pp = p2 * p2, ppp = pp * p2;
    const sP = -wP * ppp + 2 * wP * pp - wP * p2;
    const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p2 + 1;
    const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p2;
    const sN = wN * ppp - wN * pp;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result[i2] = sP * values[oP + i2] + s0 * values[o0 + i2] + s1 * values[o1 + i2] + sN * values[oN + i2];
    }
    return result;
  }
};
let LinearInterpolant$1 = class LinearInterpolant extends Interpolant$1 {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1, t0, t3, t1) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t3 - t0) / (t1 - t0), weight0 = 1 - weight1;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result[i2] = values[offset0 + i2] * weight0 + values[offset1 + i2] * weight1;
    }
    return result;
  }
};
let DiscreteInterpolant$1 = class DiscreteInterpolant extends Interpolant$1 {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1) {
    return this.copySampleValue_(i1 - 1);
  }
};
let KeyframeTrack$1 = class KeyframeTrack {
  constructor(name, times2, values, interpolation) {
    if (name === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined");
    if (times2 === void 0 || times2.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
    this.name = name;
    this.times = convertArray(times2, this.TimeBufferType);
    this.values = convertArray(values, this.ValueBufferType);
    this.setInterpolation(interpolation || this.DefaultInterpolation);
  }
  // Serialization (in static context, because of constructor invocation
  // and automatic invocation of .toJSON):
  static toJSON(track) {
    const trackType = track.constructor;
    let json;
    if (trackType.toJSON !== this.toJSON) {
      json = trackType.toJSON(track);
    } else {
      json = {
        "name": track.name,
        "times": convertArray(track.times, Array),
        "values": convertArray(track.values, Array)
      };
      const interpolation = track.getInterpolation();
      if (interpolation !== track.DefaultInterpolation) {
        json.interpolation = interpolation;
      }
    }
    json.type = track.ValueTypeName;
    return json;
  }
  InterpolantFactoryMethodDiscrete(result) {
    return new DiscreteInterpolant$1(this.times, this.values, this.getValueSize(), result);
  }
  InterpolantFactoryMethodLinear(result) {
    return new LinearInterpolant$1(this.times, this.values, this.getValueSize(), result);
  }
  InterpolantFactoryMethodSmooth(result) {
    return new CubicInterpolant$1(this.times, this.values, this.getValueSize(), result);
  }
  setInterpolation(interpolation) {
    let factoryMethod;
    switch (interpolation) {
      case InterpolateDiscrete$1:
        factoryMethod = this.InterpolantFactoryMethodDiscrete;
        break;
      case InterpolateLinear$1:
        factoryMethod = this.InterpolantFactoryMethodLinear;
        break;
      case InterpolateSmooth$1:
        factoryMethod = this.InterpolantFactoryMethodSmooth;
        break;
    }
    if (factoryMethod === void 0) {
      const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
      if (this.createInterpolant === void 0) {
        if (interpolation !== this.DefaultInterpolation) {
          this.setInterpolation(this.DefaultInterpolation);
        } else {
          throw new Error(message);
        }
      }
      console.warn("THREE.KeyframeTrack:", message);
      return this;
    }
    this.createInterpolant = factoryMethod;
    return this;
  }
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return InterpolateDiscrete$1;
      case this.InterpolantFactoryMethodLinear:
        return InterpolateLinear$1;
      case this.InterpolantFactoryMethodSmooth:
        return InterpolateSmooth$1;
    }
  }
  getValueSize() {
    return this.values.length / this.times.length;
  }
  // move all keyframes either forwards or backwards in time
  shift(timeOffset) {
    if (timeOffset !== 0) {
      const times2 = this.times;
      for (let i2 = 0, n2 = times2.length; i2 !== n2; ++i2) {
        times2[i2] += timeOffset;
      }
    }
    return this;
  }
  // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
  scale(timeScale) {
    if (timeScale !== 1) {
      const times2 = this.times;
      for (let i2 = 0, n2 = times2.length; i2 !== n2; ++i2) {
        times2[i2] *= timeScale;
      }
    }
    return this;
  }
  // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
  // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
  trim(startTime, endTime) {
    const times2 = this.times, nKeys = times2.length;
    let from = 0, to = nKeys - 1;
    while (from !== nKeys && times2[from] < startTime) {
      ++from;
    }
    while (to !== -1 && times2[to] > endTime) {
      --to;
    }
    ++to;
    if (from !== 0 || to !== nKeys) {
      if (from >= to) {
        to = Math.max(to, 1);
        from = to - 1;
      }
      const stride = this.getValueSize();
      this.times = times2.slice(from, to);
      this.values = this.values.slice(from * stride, to * stride);
    }
    return this;
  }
  // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
  validate() {
    let valid = true;
    const valueSize = this.getValueSize();
    if (valueSize - Math.floor(valueSize) !== 0) {
      console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
      valid = false;
    }
    const times2 = this.times, values = this.values, nKeys = times2.length;
    if (nKeys === 0) {
      console.error("THREE.KeyframeTrack: Track is empty.", this);
      valid = false;
    }
    let prevTime = null;
    for (let i2 = 0; i2 !== nKeys; i2++) {
      const currTime = times2[i2];
      if (typeof currTime === "number" && isNaN(currTime)) {
        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i2, currTime);
        valid = false;
        break;
      }
      if (prevTime !== null && prevTime > currTime) {
        console.error("THREE.KeyframeTrack: Out of order keys.", this, i2, currTime, prevTime);
        valid = false;
        break;
      }
      prevTime = currTime;
    }
    if (values !== void 0) {
      if (isTypedArray(values)) {
        for (let i2 = 0, n2 = values.length; i2 !== n2; ++i2) {
          const value = values[i2];
          if (isNaN(value)) {
            console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i2, value);
            valid = false;
            break;
          }
        }
      }
    }
    return valid;
  }
  // removes equivalent sequential keys as common in morph target sequences
  // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
  optimize() {
    const times2 = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === InterpolateSmooth$1, lastIndex = times2.length - 1;
    let writeIndex = 1;
    for (let i2 = 1; i2 < lastIndex; ++i2) {
      let keep = false;
      const time2 = times2[i2];
      const timeNext = times2[i2 + 1];
      if (time2 !== timeNext && (i2 !== 1 || time2 !== times2[0])) {
        if (!smoothInterpolation) {
          const offset = i2 * stride, offsetP = offset - stride, offsetN = offset + stride;
          for (let j = 0; j !== stride; ++j) {
            const value = values[offset + j];
            if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
              keep = true;
              break;
            }
          }
        } else {
          keep = true;
        }
      }
      if (keep) {
        if (i2 !== writeIndex) {
          times2[writeIndex] = times2[i2];
          const readOffset = i2 * stride, writeOffset = writeIndex * stride;
          for (let j = 0; j !== stride; ++j) {
            values[writeOffset + j] = values[readOffset + j];
          }
        }
        ++writeIndex;
      }
    }
    if (lastIndex > 0) {
      times2[writeIndex] = times2[lastIndex];
      for (let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j) {
        values[writeOffset + j] = values[readOffset + j];
      }
      ++writeIndex;
    }
    if (writeIndex !== times2.length) {
      this.times = times2.slice(0, writeIndex);
      this.values = values.slice(0, writeIndex * stride);
    } else {
      this.times = times2;
      this.values = values;
    }
    return this;
  }
  clone() {
    const times2 = this.times.slice();
    const values = this.values.slice();
    const TypedKeyframeTrack = this.constructor;
    const track = new TypedKeyframeTrack(this.name, times2, values);
    track.createInterpolant = this.createInterpolant;
    return track;
  }
};
KeyframeTrack$1.prototype.TimeBufferType = Float32Array;
KeyframeTrack$1.prototype.ValueBufferType = Float32Array;
KeyframeTrack$1.prototype.DefaultInterpolation = InterpolateLinear$1;
let BooleanKeyframeTrack$1 = class BooleanKeyframeTrack extends KeyframeTrack$1 {
  // No interpolation parameter because only InterpolateDiscrete is valid.
  constructor(name, times2, values) {
    super(name, times2, values);
  }
};
BooleanKeyframeTrack$1.prototype.ValueTypeName = "bool";
BooleanKeyframeTrack$1.prototype.ValueBufferType = Array;
BooleanKeyframeTrack$1.prototype.DefaultInterpolation = InterpolateDiscrete$1;
BooleanKeyframeTrack$1.prototype.InterpolantFactoryMethodLinear = void 0;
BooleanKeyframeTrack$1.prototype.InterpolantFactoryMethodSmooth = void 0;
let ColorKeyframeTrack$1 = class ColorKeyframeTrack extends KeyframeTrack$1 {
};
ColorKeyframeTrack$1.prototype.ValueTypeName = "color";
let NumberKeyframeTrack$1 = class NumberKeyframeTrack extends KeyframeTrack$1 {
};
NumberKeyframeTrack$1.prototype.ValueTypeName = "number";
let QuaternionLinearInterpolant$1 = class QuaternionLinearInterpolant extends Interpolant$1 {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1, t0, t3, t1) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t3 - t0) / (t1 - t0);
    let offset = i1 * stride;
    for (let end = offset + stride; offset !== end; offset += 4) {
      Quaternion$1.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
    }
    return result;
  }
};
let QuaternionKeyframeTrack$1 = class QuaternionKeyframeTrack extends KeyframeTrack$1 {
  InterpolantFactoryMethodLinear(result) {
    return new QuaternionLinearInterpolant$1(this.times, this.values, this.getValueSize(), result);
  }
};
QuaternionKeyframeTrack$1.prototype.ValueTypeName = "quaternion";
QuaternionKeyframeTrack$1.prototype.InterpolantFactoryMethodSmooth = void 0;
let StringKeyframeTrack$1 = class StringKeyframeTrack extends KeyframeTrack$1 {
  // No interpolation parameter because only InterpolateDiscrete is valid.
  constructor(name, times2, values) {
    super(name, times2, values);
  }
};
StringKeyframeTrack$1.prototype.ValueTypeName = "string";
StringKeyframeTrack$1.prototype.ValueBufferType = Array;
StringKeyframeTrack$1.prototype.DefaultInterpolation = InterpolateDiscrete$1;
StringKeyframeTrack$1.prototype.InterpolantFactoryMethodLinear = void 0;
StringKeyframeTrack$1.prototype.InterpolantFactoryMethodSmooth = void 0;
let VectorKeyframeTrack$1 = class VectorKeyframeTrack extends KeyframeTrack$1 {
};
VectorKeyframeTrack$1.prototype.ValueTypeName = "vector";
let AnimationClip$1 = class AnimationClip {
  constructor(name = "", duration2 = -1, tracks = [], blendMode = NormalAnimationBlendMode$1) {
    this.name = name;
    this.tracks = tracks;
    this.duration = duration2;
    this.blendMode = blendMode;
    this.uuid = generateUUID$1();
    if (this.duration < 0) {
      this.resetDuration();
    }
  }
  static parse(json) {
    const tracks = [], jsonTracks = json.tracks, frameTime = 1 / (json.fps || 1);
    for (let i2 = 0, n2 = jsonTracks.length; i2 !== n2; ++i2) {
      tracks.push(parseKeyframeTrack$1(jsonTracks[i2]).scale(frameTime));
    }
    const clip = new this(json.name, json.duration, tracks, json.blendMode);
    clip.uuid = json.uuid;
    return clip;
  }
  static toJSON(clip) {
    const tracks = [], clipTracks = clip.tracks;
    const json = {
      "name": clip.name,
      "duration": clip.duration,
      "tracks": tracks,
      "uuid": clip.uuid,
      "blendMode": clip.blendMode
    };
    for (let i2 = 0, n2 = clipTracks.length; i2 !== n2; ++i2) {
      tracks.push(KeyframeTrack$1.toJSON(clipTracks[i2]));
    }
    return json;
  }
  static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
    const numMorphTargets = morphTargetSequence.length;
    const tracks = [];
    for (let i2 = 0; i2 < numMorphTargets; i2++) {
      let times2 = [];
      let values = [];
      times2.push(
        (i2 + numMorphTargets - 1) % numMorphTargets,
        i2,
        (i2 + 1) % numMorphTargets
      );
      values.push(0, 1, 0);
      const order = getKeyframeOrder(times2);
      times2 = sortedArray(times2, 1, order);
      values = sortedArray(values, 1, order);
      if (!noLoop && times2[0] === 0) {
        times2.push(numMorphTargets);
        values.push(values[0]);
      }
      tracks.push(
        new NumberKeyframeTrack$1(
          ".morphTargetInfluences[" + morphTargetSequence[i2].name + "]",
          times2,
          values
        ).scale(1 / fps)
      );
    }
    return new this(name, -1, tracks);
  }
  static findByName(objectOrClipArray, name) {
    let clipArray = objectOrClipArray;
    if (!Array.isArray(objectOrClipArray)) {
      const o2 = objectOrClipArray;
      clipArray = o2.geometry && o2.geometry.animations || o2.animations;
    }
    for (let i2 = 0; i2 < clipArray.length; i2++) {
      if (clipArray[i2].name === name) {
        return clipArray[i2];
      }
    }
    return null;
  }
  static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
    const animationToMorphTargets = {};
    const pattern = /^([\w-]*?)([\d]+)$/;
    for (let i2 = 0, il = morphTargets.length; i2 < il; i2++) {
      const morphTarget = morphTargets[i2];
      const parts = morphTarget.name.match(pattern);
      if (parts && parts.length > 1) {
        const name = parts[1];
        let animationMorphTargets = animationToMorphTargets[name];
        if (!animationMorphTargets) {
          animationToMorphTargets[name] = animationMorphTargets = [];
        }
        animationMorphTargets.push(morphTarget);
      }
    }
    const clips = [];
    for (const name in animationToMorphTargets) {
      clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
    }
    return clips;
  }
  // parse the animation.hierarchy format
  static parseAnimation(animation, bones) {
    if (!animation) {
      console.error("THREE.AnimationClip: No animation in JSONLoader data.");
      return null;
    }
    const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
      if (animationKeys.length !== 0) {
        const times2 = [];
        const values = [];
        flattenJSON(animationKeys, times2, values, propertyName);
        if (times2.length !== 0) {
          destTracks.push(new trackType(trackName, times2, values));
        }
      }
    };
    const tracks = [];
    const clipName = animation.name || "default";
    const fps = animation.fps || 30;
    const blendMode = animation.blendMode;
    let duration2 = animation.length || -1;
    const hierarchyTracks = animation.hierarchy || [];
    for (let h2 = 0; h2 < hierarchyTracks.length; h2++) {
      const animationKeys = hierarchyTracks[h2].keys;
      if (!animationKeys || animationKeys.length === 0) continue;
      if (animationKeys[0].morphTargets) {
        const morphTargetNames = {};
        let k;
        for (k = 0; k < animationKeys.length; k++) {
          if (animationKeys[k].morphTargets) {
            for (let m = 0; m < animationKeys[k].morphTargets.length; m++) {
              morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
            }
          }
        }
        for (const morphTargetName in morphTargetNames) {
          const times2 = [];
          const values = [];
          for (let m = 0; m !== animationKeys[k].morphTargets.length; ++m) {
            const animationKey = animationKeys[k];
            times2.push(animationKey.time);
            values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
          }
          tracks.push(new NumberKeyframeTrack$1(".morphTargetInfluence[" + morphTargetName + "]", times2, values));
        }
        duration2 = morphTargetNames.length * fps;
      } else {
        const boneName = ".bones[" + bones[h2].name + "]";
        addNonemptyTrack(
          VectorKeyframeTrack$1,
          boneName + ".position",
          animationKeys,
          "pos",
          tracks
        );
        addNonemptyTrack(
          QuaternionKeyframeTrack$1,
          boneName + ".quaternion",
          animationKeys,
          "rot",
          tracks
        );
        addNonemptyTrack(
          VectorKeyframeTrack$1,
          boneName + ".scale",
          animationKeys,
          "scl",
          tracks
        );
      }
    }
    if (tracks.length === 0) {
      return null;
    }
    const clip = new this(clipName, duration2, tracks, blendMode);
    return clip;
  }
  resetDuration() {
    const tracks = this.tracks;
    let duration2 = 0;
    for (let i2 = 0, n2 = tracks.length; i2 !== n2; ++i2) {
      const track = this.tracks[i2];
      duration2 = Math.max(duration2, track.times[track.times.length - 1]);
    }
    this.duration = duration2;
    return this;
  }
  trim() {
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      this.tracks[i2].trim(0, this.duration);
    }
    return this;
  }
  validate() {
    let valid = true;
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      valid = valid && this.tracks[i2].validate();
    }
    return valid;
  }
  optimize() {
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      this.tracks[i2].optimize();
    }
    return this;
  }
  clone() {
    const tracks = [];
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      tracks.push(this.tracks[i2].clone());
    }
    return new this.constructor(this.name, this.duration, tracks, this.blendMode);
  }
  toJSON() {
    return this.constructor.toJSON(this);
  }
};
function getTrackTypeForValueTypeName$1(typeName) {
  switch (typeName.toLowerCase()) {
    case "scalar":
    case "double":
    case "float":
    case "number":
    case "integer":
      return NumberKeyframeTrack$1;
    case "vector":
    case "vector2":
    case "vector3":
    case "vector4":
      return VectorKeyframeTrack$1;
    case "color":
      return ColorKeyframeTrack$1;
    case "quaternion":
      return QuaternionKeyframeTrack$1;
    case "bool":
    case "boolean":
      return BooleanKeyframeTrack$1;
    case "string":
      return StringKeyframeTrack$1;
  }
  throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function parseKeyframeTrack$1(json) {
  if (json.type === void 0) {
    throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
  }
  const trackType = getTrackTypeForValueTypeName$1(json.type);
  if (json.times === void 0) {
    const times2 = [], values = [];
    flattenJSON(json.keys, times2, values, "value");
    json.times = times2;
    json.values = values;
  }
  if (trackType.parse !== void 0) {
    return trackType.parse(json);
  } else {
    return new trackType(json.name, json.times, json.values, json.interpolation);
  }
}
const Cache$2 = {
  enabled: false,
  files: {},
  add: function(key, file) {
    if (this.enabled === false) return;
    this.files[key] = file;
  },
  get: function(key) {
    if (this.enabled === false) return;
    return this.files[key];
  },
  remove: function(key) {
    delete this.files[key];
  },
  clear: function() {
    this.files = {};
  }
};
let LoadingManager$1 = class LoadingManager {
  constructor(onLoad, onProgress, onError) {
    const scope = this;
    let isLoading = false;
    let itemsLoaded = 0;
    let itemsTotal = 0;
    let urlModifier = void 0;
    const handlers = [];
    this.onStart = void 0;
    this.onLoad = onLoad;
    this.onProgress = onProgress;
    this.onError = onError;
    this.itemStart = function(url) {
      itemsTotal++;
      if (isLoading === false) {
        if (scope.onStart !== void 0) {
          scope.onStart(url, itemsLoaded, itemsTotal);
        }
      }
      isLoading = true;
    };
    this.itemEnd = function(url) {
      itemsLoaded++;
      if (scope.onProgress !== void 0) {
        scope.onProgress(url, itemsLoaded, itemsTotal);
      }
      if (itemsLoaded === itemsTotal) {
        isLoading = false;
        if (scope.onLoad !== void 0) {
          scope.onLoad();
        }
      }
    };
    this.itemError = function(url) {
      if (scope.onError !== void 0) {
        scope.onError(url);
      }
    };
    this.resolveURL = function(url) {
      if (urlModifier) {
        return urlModifier(url);
      }
      return url;
    };
    this.setURLModifier = function(transform2) {
      urlModifier = transform2;
      return this;
    };
    this.addHandler = function(regex, loader) {
      handlers.push(regex, loader);
      return this;
    };
    this.removeHandler = function(regex) {
      const index2 = handlers.indexOf(regex);
      if (index2 !== -1) {
        handlers.splice(index2, 2);
      }
      return this;
    };
    this.getHandler = function(file) {
      for (let i2 = 0, l2 = handlers.length; i2 < l2; i2 += 2) {
        const regex = handlers[i2];
        const loader = handlers[i2 + 1];
        if (regex.global) regex.lastIndex = 0;
        if (regex.test(file)) {
          return loader;
        }
      }
      return null;
    };
  }
};
const DefaultLoadingManager$1 = /* @__PURE__ */ new LoadingManager$1();
let Loader$1 = class Loader {
  constructor(manager) {
    this.manager = manager !== void 0 ? manager : DefaultLoadingManager$1;
    this.crossOrigin = "anonymous";
    this.withCredentials = false;
    this.path = "";
    this.resourcePath = "";
    this.requestHeader = {};
  }
  load() {
  }
  loadAsync(url, onProgress) {
    const scope = this;
    return new Promise(function(resolve, reject) {
      scope.load(url, resolve, onProgress, reject);
    });
  }
  parse() {
  }
  setCrossOrigin(crossOrigin) {
    this.crossOrigin = crossOrigin;
    return this;
  }
  setWithCredentials(value) {
    this.withCredentials = value;
    return this;
  }
  setPath(path) {
    this.path = path;
    return this;
  }
  setResourcePath(resourcePath) {
    this.resourcePath = resourcePath;
    return this;
  }
  setRequestHeader(requestHeader) {
    this.requestHeader = requestHeader;
    return this;
  }
};
Loader$1.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const loading$1 = {};
class HttpError extends Error {
  constructor(message, response) {
    super(message);
    this.response = response;
  }
}
let FileLoader$1 = class FileLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    if (url === void 0) url = "";
    if (this.path !== void 0) url = this.path + url;
    url = this.manager.resolveURL(url);
    const cached = Cache$2.get(url);
    if (cached !== void 0) {
      this.manager.itemStart(url);
      setTimeout(() => {
        if (onLoad) onLoad(cached);
        this.manager.itemEnd(url);
      }, 0);
      return cached;
    }
    if (loading$1[url] !== void 0) {
      loading$1[url].push({
        onLoad,
        onProgress,
        onError
      });
      return;
    }
    loading$1[url] = [];
    loading$1[url].push({
      onLoad,
      onProgress,
      onError
    });
    const req = new Request(url, {
      headers: new Headers(this.requestHeader),
      credentials: this.withCredentials ? "include" : "same-origin"
      // An abort controller could be added within a future PR
    });
    const mimeType = this.mimeType;
    const responseType = this.responseType;
    fetch(req).then((response) => {
      if (response.status === 200 || response.status === 0) {
        if (response.status === 0) {
          console.warn("THREE.FileLoader: HTTP Status 0 received.");
        }
        if (typeof ReadableStream === "undefined" || response.body === void 0 || response.body.getReader === void 0) {
          return response;
        }
        const callbacks = loading$1[url];
        const reader = response.body.getReader();
        const contentLength = response.headers.get("X-File-Size") || response.headers.get("Content-Length");
        const total = contentLength ? parseInt(contentLength) : 0;
        const lengthComputable = total !== 0;
        let loaded = 0;
        const stream = new ReadableStream({
          start(controller) {
            readData();
            function readData() {
              reader.read().then(({ done, value }) => {
                if (done) {
                  controller.close();
                } else {
                  loaded += value.byteLength;
                  const event = new ProgressEvent("progress", { lengthComputable, loaded, total });
                  for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
                    const callback = callbacks[i2];
                    if (callback.onProgress) callback.onProgress(event);
                  }
                  controller.enqueue(value);
                  readData();
                }
              }, (e2) => {
                controller.error(e2);
              });
            }
          }
        });
        return new Response(stream);
      } else {
        throw new HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
      }
    }).then((response) => {
      switch (responseType) {
        case "arraybuffer":
          return response.arrayBuffer();
        case "blob":
          return response.blob();
        case "document":
          return response.text().then((text) => {
            const parser = new DOMParser();
            return parser.parseFromString(text, mimeType);
          });
        case "json":
          return response.json();
        default:
          if (mimeType === void 0) {
            return response.text();
          } else {
            const re = /charset="?([^;"\s]*)"?/i;
            const exec = re.exec(mimeType);
            const label = exec && exec[1] ? exec[1].toLowerCase() : void 0;
            const decoder = new TextDecoder(label);
            return response.arrayBuffer().then((ab) => decoder.decode(ab));
          }
      }
    }).then((data) => {
      Cache$2.add(url, data);
      const callbacks = loading$1[url];
      delete loading$1[url];
      for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
        const callback = callbacks[i2];
        if (callback.onLoad) callback.onLoad(data);
      }
    }).catch((err2) => {
      const callbacks = loading$1[url];
      if (callbacks === void 0) {
        this.manager.itemError(url);
        throw err2;
      }
      delete loading$1[url];
      for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
        const callback = callbacks[i2];
        if (callback.onError) callback.onError(err2);
      }
      this.manager.itemError(url);
    }).finally(() => {
      this.manager.itemEnd(url);
    });
    this.manager.itemStart(url);
  }
  setResponseType(value) {
    this.responseType = value;
    return this;
  }
  setMimeType(value) {
    this.mimeType = value;
    return this;
  }
};
class AnimationLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const loader = new FileLoader$1(this.manager);
    loader.setPath(this.path);
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(url, function(text) {
      try {
        onLoad(scope.parse(JSON.parse(text)));
      } catch (e2) {
        if (onError) {
          onError(e2);
        } else {
          console.error(e2);
        }
        scope.manager.itemError(url);
      }
    }, onProgress, onError);
  }
  parse(json) {
    const animations = [];
    for (let i2 = 0; i2 < json.length; i2++) {
      const clip = AnimationClip$1.parse(json[i2]);
      animations.push(clip);
    }
    return animations;
  }
}
class CompressedTextureLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const images = [];
    const texture = new CompressedTexture$1();
    const loader = new FileLoader$1(this.manager);
    loader.setPath(this.path);
    loader.setResponseType("arraybuffer");
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(scope.withCredentials);
    let loaded = 0;
    function loadTexture(i2) {
      loader.load(url[i2], function(buffer) {
        const texDatas = scope.parse(buffer, true);
        images[i2] = {
          width: texDatas.width,
          height: texDatas.height,
          format: texDatas.format,
          mipmaps: texDatas.mipmaps
        };
        loaded += 1;
        if (loaded === 6) {
          if (texDatas.mipmapCount === 1) texture.minFilter = LinearFilter$1;
          texture.image = images;
          texture.format = texDatas.format;
          texture.needsUpdate = true;
          if (onLoad) onLoad(texture);
        }
      }, onProgress, onError);
    }
    if (Array.isArray(url)) {
      for (let i2 = 0, il = url.length; i2 < il; ++i2) {
        loadTexture(i2);
      }
    } else {
      loader.load(url, function(buffer) {
        const texDatas = scope.parse(buffer, true);
        if (texDatas.isCubemap) {
          const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
          for (let f2 = 0; f2 < faces; f2++) {
            images[f2] = { mipmaps: [] };
            for (let i2 = 0; i2 < texDatas.mipmapCount; i2++) {
              images[f2].mipmaps.push(texDatas.mipmaps[f2 * texDatas.mipmapCount + i2]);
              images[f2].format = texDatas.format;
              images[f2].width = texDatas.width;
              images[f2].height = texDatas.height;
            }
          }
          texture.image = images;
        } else {
          texture.image.width = texDatas.width;
          texture.image.height = texDatas.height;
          texture.mipmaps = texDatas.mipmaps;
        }
        if (texDatas.mipmapCount === 1) {
          texture.minFilter = LinearFilter$1;
        }
        texture.format = texDatas.format;
        texture.needsUpdate = true;
        if (onLoad) onLoad(texture);
      }, onProgress, onError);
    }
    return texture;
  }
}
let ImageLoader$1 = class ImageLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    if (this.path !== void 0) url = this.path + url;
    url = this.manager.resolveURL(url);
    const scope = this;
    const cached = Cache$2.get(url);
    if (cached !== void 0) {
      scope.manager.itemStart(url);
      setTimeout(function() {
        if (onLoad) onLoad(cached);
        scope.manager.itemEnd(url);
      }, 0);
      return cached;
    }
    const image2 = createElementNS("img");
    function onImageLoad() {
      removeEventListeners();
      Cache$2.add(url, this);
      if (onLoad) onLoad(this);
      scope.manager.itemEnd(url);
    }
    function onImageError(event) {
      removeEventListeners();
      if (onError) onError(event);
      scope.manager.itemError(url);
      scope.manager.itemEnd(url);
    }
    function removeEventListeners() {
      image2.removeEventListener("load", onImageLoad, false);
      image2.removeEventListener("error", onImageError, false);
    }
    image2.addEventListener("load", onImageLoad, false);
    image2.addEventListener("error", onImageError, false);
    if (url.slice(0, 5) !== "data:") {
      if (this.crossOrigin !== void 0) image2.crossOrigin = this.crossOrigin;
    }
    scope.manager.itemStart(url);
    image2.src = url;
    return image2;
  }
};
let CubeTextureLoader$1 = class CubeTextureLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(urls, onLoad, onProgress, onError) {
    const texture = new CubeTexture$1();
    texture.colorSpace = SRGBColorSpace;
    const loader = new ImageLoader$1(this.manager);
    loader.setCrossOrigin(this.crossOrigin);
    loader.setPath(this.path);
    let loaded = 0;
    function loadTexture(i2) {
      loader.load(urls[i2], function(image2) {
        texture.images[i2] = image2;
        loaded++;
        if (loaded === 6) {
          texture.needsUpdate = true;
          if (onLoad) onLoad(texture);
        }
      }, void 0, onError);
    }
    for (let i2 = 0; i2 < urls.length; ++i2) {
      loadTexture(i2);
    }
    return texture;
  }
};
class DataTextureLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const texture = new DataTexture$1();
    const loader = new FileLoader$1(this.manager);
    loader.setResponseType("arraybuffer");
    loader.setRequestHeader(this.requestHeader);
    loader.setPath(this.path);
    loader.setWithCredentials(scope.withCredentials);
    loader.load(url, function(buffer) {
      let texData;
      try {
        texData = scope.parse(buffer);
      } catch (error) {
        if (onError !== void 0) {
          onError(error);
        } else {
          console.error(error);
          return;
        }
      }
      if (texData.image !== void 0) {
        texture.image = texData.image;
      } else if (texData.data !== void 0) {
        texture.image.width = texData.width;
        texture.image.height = texData.height;
        texture.image.data = texData.data;
      }
      texture.wrapS = texData.wrapS !== void 0 ? texData.wrapS : ClampToEdgeWrapping$1;
      texture.wrapT = texData.wrapT !== void 0 ? texData.wrapT : ClampToEdgeWrapping$1;
      texture.magFilter = texData.magFilter !== void 0 ? texData.magFilter : LinearFilter$1;
      texture.minFilter = texData.minFilter !== void 0 ? texData.minFilter : LinearFilter$1;
      texture.anisotropy = texData.anisotropy !== void 0 ? texData.anisotropy : 1;
      if (texData.colorSpace !== void 0) {
        texture.colorSpace = texData.colorSpace;
      }
      if (texData.flipY !== void 0) {
        texture.flipY = texData.flipY;
      }
      if (texData.format !== void 0) {
        texture.format = texData.format;
      }
      if (texData.type !== void 0) {
        texture.type = texData.type;
      }
      if (texData.mipmaps !== void 0) {
        texture.mipmaps = texData.mipmaps;
        texture.minFilter = LinearMipmapLinearFilter$1;
      }
      if (texData.mipmapCount === 1) {
        texture.minFilter = LinearFilter$1;
      }
      if (texData.generateMipmaps !== void 0) {
        texture.generateMipmaps = texData.generateMipmaps;
      }
      texture.needsUpdate = true;
      if (onLoad) onLoad(texture, texData);
    }, onProgress, onError);
    return texture;
  }
}
let TextureLoader$1 = class TextureLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const texture = new Texture$1();
    const loader = new ImageLoader$1(this.manager);
    loader.setCrossOrigin(this.crossOrigin);
    loader.setPath(this.path);
    loader.load(url, function(image2) {
      texture.image = image2;
      texture.needsUpdate = true;
      if (onLoad !== void 0) {
        onLoad(texture);
      }
    }, onProgress, onError);
    return texture;
  }
};
let Light$1 = class Light extends Object3D$1 {
  constructor(color2, intensity = 1) {
    super();
    this.isLight = true;
    this.type = "Light";
    this.color = new Color$1(color2);
    this.intensity = intensity;
  }
  dispose() {
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.color.copy(source.color);
    this.intensity = source.intensity;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.color = this.color.getHex();
    data.object.intensity = this.intensity;
    if (this.groundColor !== void 0) data.object.groundColor = this.groundColor.getHex();
    if (this.distance !== void 0) data.object.distance = this.distance;
    if (this.angle !== void 0) data.object.angle = this.angle;
    if (this.decay !== void 0) data.object.decay = this.decay;
    if (this.penumbra !== void 0) data.object.penumbra = this.penumbra;
    if (this.shadow !== void 0) data.object.shadow = this.shadow.toJSON();
    if (this.target !== void 0) data.object.target = this.target.uuid;
    return data;
  }
};
let HemisphereLight$1 = class HemisphereLight extends Light$1 {
  constructor(skyColor, groundColor, intensity) {
    super(skyColor, intensity);
    this.isHemisphereLight = true;
    this.type = "HemisphereLight";
    this.position.copy(Object3D$1.DEFAULT_UP);
    this.updateMatrix();
    this.groundColor = new Color$1(groundColor);
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.groundColor.copy(source.groundColor);
    return this;
  }
};
const _projScreenMatrix$1$1 = /* @__PURE__ */ new Matrix4$1();
const _lightPositionWorld$1$1 = /* @__PURE__ */ new Vector3$1();
const _lookTarget$1$1 = /* @__PURE__ */ new Vector3$1();
let LightShadow$1 = class LightShadow {
  constructor(camera) {
    this.camera = camera;
    this.intensity = 1;
    this.bias = 0;
    this.normalBias = 0;
    this.radius = 1;
    this.blurSamples = 8;
    this.mapSize = new Vector2$1(512, 512);
    this.map = null;
    this.mapPass = null;
    this.matrix = new Matrix4$1();
    this.autoUpdate = true;
    this.needsUpdate = false;
    this._frustum = new Frustum$1();
    this._frameExtents = new Vector2$1(1, 1);
    this._viewportCount = 1;
    this._viewports = [
      new Vector4$1(0, 0, 1, 1)
    ];
  }
  getViewportCount() {
    return this._viewportCount;
  }
  getFrustum() {
    return this._frustum;
  }
  updateMatrices(light) {
    const shadowCamera = this.camera;
    const shadowMatrix = this.matrix;
    _lightPositionWorld$1$1.setFromMatrixPosition(light.matrixWorld);
    shadowCamera.position.copy(_lightPositionWorld$1$1);
    _lookTarget$1$1.setFromMatrixPosition(light.target.matrixWorld);
    shadowCamera.lookAt(_lookTarget$1$1);
    shadowCamera.updateMatrixWorld();
    _projScreenMatrix$1$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
    this._frustum.setFromProjectionMatrix(_projScreenMatrix$1$1);
    shadowMatrix.set(
      0.5,
      0,
      0,
      0.5,
      0,
      0.5,
      0,
      0.5,
      0,
      0,
      0.5,
      0.5,
      0,
      0,
      0,
      1
    );
    shadowMatrix.multiply(_projScreenMatrix$1$1);
  }
  getViewport(viewportIndex) {
    return this._viewports[viewportIndex];
  }
  getFrameExtents() {
    return this._frameExtents;
  }
  dispose() {
    if (this.map) {
      this.map.dispose();
    }
    if (this.mapPass) {
      this.mapPass.dispose();
    }
  }
  copy(source) {
    this.camera = source.camera.clone();
    this.intensity = source.intensity;
    this.bias = source.bias;
    this.radius = source.radius;
    this.mapSize.copy(source.mapSize);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    const object = {};
    if (this.intensity !== 1) object.intensity = this.intensity;
    if (this.bias !== 0) object.bias = this.bias;
    if (this.normalBias !== 0) object.normalBias = this.normalBias;
    if (this.radius !== 1) object.radius = this.radius;
    if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
    object.camera = this.camera.toJSON(false).object;
    delete object.camera.matrix;
    return object;
  }
};
let SpotLightShadow$1 = class SpotLightShadow extends LightShadow$1 {
  constructor() {
    super(new PerspectiveCamera$1(50, 1, 0.5, 500));
    this.isSpotLightShadow = true;
    this.focus = 1;
  }
  updateMatrices(light) {
    const camera = this.camera;
    const fov2 = RAD2DEG$1 * 2 * light.angle * this.focus;
    const aspect2 = this.mapSize.width / this.mapSize.height;
    const far = light.distance || camera.far;
    if (fov2 !== camera.fov || aspect2 !== camera.aspect || far !== camera.far) {
      camera.fov = fov2;
      camera.aspect = aspect2;
      camera.far = far;
      camera.updateProjectionMatrix();
    }
    super.updateMatrices(light);
  }
  copy(source) {
    super.copy(source);
    this.focus = source.focus;
    return this;
  }
};
let SpotLight$1 = class SpotLight extends Light$1 {
  constructor(color2, intensity, distance2 = 0, angle2 = Math.PI / 3, penumbra = 0, decay = 2) {
    super(color2, intensity);
    this.isSpotLight = true;
    this.type = "SpotLight";
    this.position.copy(Object3D$1.DEFAULT_UP);
    this.updateMatrix();
    this.target = new Object3D$1();
    this.distance = distance2;
    this.angle = angle2;
    this.penumbra = penumbra;
    this.decay = decay;
    this.map = null;
    this.shadow = new SpotLightShadow$1();
  }
  get power() {
    return this.intensity * Math.PI;
  }
  set power(power) {
    this.intensity = power / Math.PI;
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.distance = source.distance;
    this.angle = source.angle;
    this.penumbra = source.penumbra;
    this.decay = source.decay;
    this.target = source.target.clone();
    this.shadow = source.shadow.clone();
    return this;
  }
};
const _projScreenMatrix$2 = /* @__PURE__ */ new Matrix4$1();
const _lightPositionWorld$2 = /* @__PURE__ */ new Vector3$1();
const _lookTarget$2 = /* @__PURE__ */ new Vector3$1();
let PointLightShadow$1 = class PointLightShadow extends LightShadow$1 {
  constructor() {
    super(new PerspectiveCamera$1(90, 1, 0.5, 500));
    this.isPointLightShadow = true;
    this._frameExtents = new Vector2$1(4, 2);
    this._viewportCount = 6;
    this._viewports = [
      // These viewports map a cube-map onto a 2D texture with the
      // following orientation:
      //
      //  xzXZ
      //   y Y
      //
      // X - Positive x direction
      // x - Negative x direction
      // Y - Positive y direction
      // y - Negative y direction
      // Z - Positive z direction
      // z - Negative z direction
      // positive X
      new Vector4$1(2, 1, 1, 1),
      // negative X
      new Vector4$1(0, 1, 1, 1),
      // positive Z
      new Vector4$1(3, 1, 1, 1),
      // negative Z
      new Vector4$1(1, 1, 1, 1),
      // positive Y
      new Vector4$1(3, 0, 1, 1),
      // negative Y
      new Vector4$1(1, 0, 1, 1)
    ];
    this._cubeDirections = [
      new Vector3$1(1, 0, 0),
      new Vector3$1(-1, 0, 0),
      new Vector3$1(0, 0, 1),
      new Vector3$1(0, 0, -1),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, -1, 0)
    ];
    this._cubeUps = [
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 0, 1),
      new Vector3$1(0, 0, -1)
    ];
  }
  updateMatrices(light, viewportIndex = 0) {
    const camera = this.camera;
    const shadowMatrix = this.matrix;
    const far = light.distance || camera.far;
    if (far !== camera.far) {
      camera.far = far;
      camera.updateProjectionMatrix();
    }
    _lightPositionWorld$2.setFromMatrixPosition(light.matrixWorld);
    camera.position.copy(_lightPositionWorld$2);
    _lookTarget$2.copy(camera.position);
    _lookTarget$2.add(this._cubeDirections[viewportIndex]);
    camera.up.copy(this._cubeUps[viewportIndex]);
    camera.lookAt(_lookTarget$2);
    camera.updateMatrixWorld();
    shadowMatrix.makeTranslation(-_lightPositionWorld$2.x, -_lightPositionWorld$2.y, -_lightPositionWorld$2.z);
    _projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
    this._frustum.setFromProjectionMatrix(_projScreenMatrix$2);
  }
};
let PointLight$1 = class PointLight extends Light$1 {
  constructor(color2, intensity, distance2 = 0, decay = 2) {
    super(color2, intensity);
    this.isPointLight = true;
    this.type = "PointLight";
    this.distance = distance2;
    this.decay = decay;
    this.shadow = new PointLightShadow$1();
  }
  get power() {
    return this.intensity * 4 * Math.PI;
  }
  set power(power) {
    this.intensity = power / (4 * Math.PI);
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.distance = source.distance;
    this.decay = source.decay;
    this.shadow = source.shadow.clone();
    return this;
  }
};
let OrthographicCamera$1 = class OrthographicCamera extends Camera$1 {
  constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2e3) {
    super();
    this.isOrthographicCamera = true;
    this.type = "OrthographicCamera";
    this.zoom = 1;
    this.view = null;
    this.left = left;
    this.right = right;
    this.top = top;
    this.bottom = bottom;
    this.near = near;
    this.far = far;
    this.updateProjectionMatrix();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.left = source.left;
    this.right = source.right;
    this.top = source.top;
    this.bottom = source.bottom;
    this.near = source.near;
    this.far = source.far;
    this.zoom = source.zoom;
    this.view = source.view === null ? null : Object.assign({}, source.view);
    return this;
  }
  setViewOffset(fullWidth, fullHeight, x, y, width, height) {
    if (this.view === null) {
      this.view = {
        enabled: true,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      };
    }
    this.view.enabled = true;
    this.view.fullWidth = fullWidth;
    this.view.fullHeight = fullHeight;
    this.view.offsetX = x;
    this.view.offsetY = y;
    this.view.width = width;
    this.view.height = height;
    this.updateProjectionMatrix();
  }
  clearViewOffset() {
    if (this.view !== null) {
      this.view.enabled = false;
    }
    this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const dx = (this.right - this.left) / (2 * this.zoom);
    const dy = (this.top - this.bottom) / (2 * this.zoom);
    const cx = (this.right + this.left) / 2;
    const cy = (this.top + this.bottom) / 2;
    let left = cx - dx;
    let right = cx + dx;
    let top = cy + dy;
    let bottom = cy - dy;
    if (this.view !== null && this.view.enabled) {
      const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
      const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      left += scaleW * this.view.offsetX;
      right = left + scaleW * this.view.width;
      top -= scaleH * this.view.offsetY;
      bottom = top - scaleH * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
    this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.zoom = this.zoom;
    data.object.left = this.left;
    data.object.right = this.right;
    data.object.top = this.top;
    data.object.bottom = this.bottom;
    data.object.near = this.near;
    data.object.far = this.far;
    if (this.view !== null) data.object.view = Object.assign({}, this.view);
    return data;
  }
};
let DirectionalLightShadow$1 = class DirectionalLightShadow extends LightShadow$1 {
  constructor() {
    super(new OrthographicCamera$1(-5, 5, 5, -5, 0.5, 500));
    this.isDirectionalLightShadow = true;
  }
};
let DirectionalLight$1 = class DirectionalLight extends Light$1 {
  constructor(color2, intensity) {
    super(color2, intensity);
    this.isDirectionalLight = true;
    this.type = "DirectionalLight";
    this.position.copy(Object3D$1.DEFAULT_UP);
    this.updateMatrix();
    this.target = new Object3D$1();
    this.shadow = new DirectionalLightShadow$1();
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source) {
    super.copy(source);
    this.target = source.target.clone();
    this.shadow = source.shadow.clone();
    return this;
  }
};
let AmbientLight$1 = class AmbientLight extends Light$1 {
  constructor(color2, intensity) {
    super(color2, intensity);
    this.isAmbientLight = true;
    this.type = "AmbientLight";
  }
};
let RectAreaLight$1 = class RectAreaLight extends Light$1 {
  constructor(color2, intensity, width = 10, height = 10) {
    super(color2, intensity);
    this.isRectAreaLight = true;
    this.type = "RectAreaLight";
    this.width = width;
    this.height = height;
  }
  get power() {
    return this.intensity * this.width * this.height * Math.PI;
  }
  set power(power) {
    this.intensity = power / (this.width * this.height * Math.PI);
  }
  copy(source) {
    super.copy(source);
    this.width = source.width;
    this.height = source.height;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.width = this.width;
    data.object.height = this.height;
    return data;
  }
};
let SphericalHarmonics3$1 = class SphericalHarmonics3 {
  constructor() {
    this.isSphericalHarmonics3 = true;
    this.coefficients = [];
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients.push(new Vector3$1());
    }
  }
  set(coefficients) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].copy(coefficients[i2]);
    }
    return this;
  }
  zero() {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].set(0, 0, 0);
    }
    return this;
  }
  // get the radiance in the direction of the normal
  // target is a Vector3
  getAt(normal, target) {
    const x = normal.x, y = normal.y, z2 = normal.z;
    const coeff = this.coefficients;
    target.copy(coeff[0]).multiplyScalar(0.282095);
    target.addScaledVector(coeff[1], 0.488603 * y);
    target.addScaledVector(coeff[2], 0.488603 * z2);
    target.addScaledVector(coeff[3], 0.488603 * x);
    target.addScaledVector(coeff[4], 1.092548 * (x * y));
    target.addScaledVector(coeff[5], 1.092548 * (y * z2));
    target.addScaledVector(coeff[6], 0.315392 * (3 * z2 * z2 - 1));
    target.addScaledVector(coeff[7], 1.092548 * (x * z2));
    target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
    return target;
  }
  // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
  // target is a Vector3
  // https://graphics.stanford.edu/papers/envmap/envmap.pdf
  getIrradianceAt(normal, target) {
    const x = normal.x, y = normal.y, z2 = normal.z;
    const coeff = this.coefficients;
    target.copy(coeff[0]).multiplyScalar(0.886227);
    target.addScaledVector(coeff[1], 2 * 0.511664 * y);
    target.addScaledVector(coeff[2], 2 * 0.511664 * z2);
    target.addScaledVector(coeff[3], 2 * 0.511664 * x);
    target.addScaledVector(coeff[4], 2 * 0.429043 * x * y);
    target.addScaledVector(coeff[5], 2 * 0.429043 * y * z2);
    target.addScaledVector(coeff[6], 0.743125 * z2 * z2 - 0.247708);
    target.addScaledVector(coeff[7], 2 * 0.429043 * x * z2);
    target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y));
    return target;
  }
  add(sh) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].add(sh.coefficients[i2]);
    }
    return this;
  }
  addScaledSH(sh, s2) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].addScaledVector(sh.coefficients[i2], s2);
    }
    return this;
  }
  scale(s2) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].multiplyScalar(s2);
    }
    return this;
  }
  lerp(sh, alpha) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].lerp(sh.coefficients[i2], alpha);
    }
    return this;
  }
  equals(sh) {
    for (let i2 = 0; i2 < 9; i2++) {
      if (!this.coefficients[i2].equals(sh.coefficients[i2])) {
        return false;
      }
    }
    return true;
  }
  copy(sh) {
    return this.set(sh.coefficients);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  fromArray(array, offset = 0) {
    const coefficients = this.coefficients;
    for (let i2 = 0; i2 < 9; i2++) {
      coefficients[i2].fromArray(array, offset + i2 * 3);
    }
    return this;
  }
  toArray(array = [], offset = 0) {
    const coefficients = this.coefficients;
    for (let i2 = 0; i2 < 9; i2++) {
      coefficients[i2].toArray(array, offset + i2 * 3);
    }
    return array;
  }
  // evaluate the basis functions
  // shBasis is an Array[ 9 ]
  static getBasisAt(normal, shBasis) {
    const x = normal.x, y = normal.y, z2 = normal.z;
    shBasis[0] = 0.282095;
    shBasis[1] = 0.488603 * y;
    shBasis[2] = 0.488603 * z2;
    shBasis[3] = 0.488603 * x;
    shBasis[4] = 1.092548 * x * y;
    shBasis[5] = 1.092548 * y * z2;
    shBasis[6] = 0.315392 * (3 * z2 * z2 - 1);
    shBasis[7] = 1.092548 * x * z2;
    shBasis[8] = 0.546274 * (x * x - y * y);
  }
};
let LightProbe$1 = class LightProbe extends Light$1 {
  constructor(sh = new SphericalHarmonics3$1(), intensity = 1) {
    super(void 0, intensity);
    this.isLightProbe = true;
    this.sh = sh;
  }
  copy(source) {
    super.copy(source);
    this.sh.copy(source.sh);
    return this;
  }
  fromJSON(json) {
    this.intensity = json.intensity;
    this.sh.fromArray(json.sh);
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.sh = this.sh.toArray();
    return data;
  }
};
class MaterialLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
    this.textures = {};
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const loader = new FileLoader$1(scope.manager);
    loader.setPath(scope.path);
    loader.setRequestHeader(scope.requestHeader);
    loader.setWithCredentials(scope.withCredentials);
    loader.load(url, function(text) {
      try {
        onLoad(scope.parse(JSON.parse(text)));
      } catch (e2) {
        if (onError) {
          onError(e2);
        } else {
          console.error(e2);
        }
        scope.manager.itemError(url);
      }
    }, onProgress, onError);
  }
  parse(json) {
    const textures = this.textures;
    function getTexture(name) {
      if (textures[name] === void 0) {
        console.warn("THREE.MaterialLoader: Undefined texture", name);
      }
      return textures[name];
    }
    const material = this.createMaterialFromType(json.type);
    if (json.uuid !== void 0) material.uuid = json.uuid;
    if (json.name !== void 0) material.name = json.name;
    if (json.color !== void 0 && material.color !== void 0) material.color.setHex(json.color);
    if (json.roughness !== void 0) material.roughness = json.roughness;
    if (json.metalness !== void 0) material.metalness = json.metalness;
    if (json.sheen !== void 0) material.sheen = json.sheen;
    if (json.sheenColor !== void 0) material.sheenColor = new Color$1().setHex(json.sheenColor);
    if (json.sheenRoughness !== void 0) material.sheenRoughness = json.sheenRoughness;
    if (json.emissive !== void 0 && material.emissive !== void 0) material.emissive.setHex(json.emissive);
    if (json.specular !== void 0 && material.specular !== void 0) material.specular.setHex(json.specular);
    if (json.specularIntensity !== void 0) material.specularIntensity = json.specularIntensity;
    if (json.specularColor !== void 0 && material.specularColor !== void 0) material.specularColor.setHex(json.specularColor);
    if (json.shininess !== void 0) material.shininess = json.shininess;
    if (json.clearcoat !== void 0) material.clearcoat = json.clearcoat;
    if (json.clearcoatRoughness !== void 0) material.clearcoatRoughness = json.clearcoatRoughness;
    if (json.dispersion !== void 0) material.dispersion = json.dispersion;
    if (json.iridescence !== void 0) material.iridescence = json.iridescence;
    if (json.iridescenceIOR !== void 0) material.iridescenceIOR = json.iridescenceIOR;
    if (json.iridescenceThicknessRange !== void 0) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
    if (json.transmission !== void 0) material.transmission = json.transmission;
    if (json.thickness !== void 0) material.thickness = json.thickness;
    if (json.attenuationDistance !== void 0) material.attenuationDistance = json.attenuationDistance;
    if (json.attenuationColor !== void 0 && material.attenuationColor !== void 0) material.attenuationColor.setHex(json.attenuationColor);
    if (json.anisotropy !== void 0) material.anisotropy = json.anisotropy;
    if (json.anisotropyRotation !== void 0) material.anisotropyRotation = json.anisotropyRotation;
    if (json.fog !== void 0) material.fog = json.fog;
    if (json.flatShading !== void 0) material.flatShading = json.flatShading;
    if (json.blending !== void 0) material.blending = json.blending;
    if (json.combine !== void 0) material.combine = json.combine;
    if (json.side !== void 0) material.side = json.side;
    if (json.shadowSide !== void 0) material.shadowSide = json.shadowSide;
    if (json.opacity !== void 0) material.opacity = json.opacity;
    if (json.transparent !== void 0) material.transparent = json.transparent;
    if (json.alphaTest !== void 0) material.alphaTest = json.alphaTest;
    if (json.alphaHash !== void 0) material.alphaHash = json.alphaHash;
    if (json.depthFunc !== void 0) material.depthFunc = json.depthFunc;
    if (json.depthTest !== void 0) material.depthTest = json.depthTest;
    if (json.depthWrite !== void 0) material.depthWrite = json.depthWrite;
    if (json.colorWrite !== void 0) material.colorWrite = json.colorWrite;
    if (json.blendSrc !== void 0) material.blendSrc = json.blendSrc;
    if (json.blendDst !== void 0) material.blendDst = json.blendDst;
    if (json.blendEquation !== void 0) material.blendEquation = json.blendEquation;
    if (json.blendSrcAlpha !== void 0) material.blendSrcAlpha = json.blendSrcAlpha;
    if (json.blendDstAlpha !== void 0) material.blendDstAlpha = json.blendDstAlpha;
    if (json.blendEquationAlpha !== void 0) material.blendEquationAlpha = json.blendEquationAlpha;
    if (json.blendColor !== void 0 && material.blendColor !== void 0) material.blendColor.setHex(json.blendColor);
    if (json.blendAlpha !== void 0) material.blendAlpha = json.blendAlpha;
    if (json.stencilWriteMask !== void 0) material.stencilWriteMask = json.stencilWriteMask;
    if (json.stencilFunc !== void 0) material.stencilFunc = json.stencilFunc;
    if (json.stencilRef !== void 0) material.stencilRef = json.stencilRef;
    if (json.stencilFuncMask !== void 0) material.stencilFuncMask = json.stencilFuncMask;
    if (json.stencilFail !== void 0) material.stencilFail = json.stencilFail;
    if (json.stencilZFail !== void 0) material.stencilZFail = json.stencilZFail;
    if (json.stencilZPass !== void 0) material.stencilZPass = json.stencilZPass;
    if (json.stencilWrite !== void 0) material.stencilWrite = json.stencilWrite;
    if (json.wireframe !== void 0) material.wireframe = json.wireframe;
    if (json.wireframeLinewidth !== void 0) material.wireframeLinewidth = json.wireframeLinewidth;
    if (json.wireframeLinecap !== void 0) material.wireframeLinecap = json.wireframeLinecap;
    if (json.wireframeLinejoin !== void 0) material.wireframeLinejoin = json.wireframeLinejoin;
    if (json.rotation !== void 0) material.rotation = json.rotation;
    if (json.linewidth !== void 0) material.linewidth = json.linewidth;
    if (json.dashSize !== void 0) material.dashSize = json.dashSize;
    if (json.gapSize !== void 0) material.gapSize = json.gapSize;
    if (json.scale !== void 0) material.scale = json.scale;
    if (json.polygonOffset !== void 0) material.polygonOffset = json.polygonOffset;
    if (json.polygonOffsetFactor !== void 0) material.polygonOffsetFactor = json.polygonOffsetFactor;
    if (json.polygonOffsetUnits !== void 0) material.polygonOffsetUnits = json.polygonOffsetUnits;
    if (json.dithering !== void 0) material.dithering = json.dithering;
    if (json.alphaToCoverage !== void 0) material.alphaToCoverage = json.alphaToCoverage;
    if (json.premultipliedAlpha !== void 0) material.premultipliedAlpha = json.premultipliedAlpha;
    if (json.forceSinglePass !== void 0) material.forceSinglePass = json.forceSinglePass;
    if (json.visible !== void 0) material.visible = json.visible;
    if (json.toneMapped !== void 0) material.toneMapped = json.toneMapped;
    if (json.userData !== void 0) material.userData = json.userData;
    if (json.vertexColors !== void 0) {
      if (typeof json.vertexColors === "number") {
        material.vertexColors = json.vertexColors > 0 ? true : false;
      } else {
        material.vertexColors = json.vertexColors;
      }
    }
    if (json.uniforms !== void 0) {
      for (const name in json.uniforms) {
        const uniform = json.uniforms[name];
        material.uniforms[name] = {};
        switch (uniform.type) {
          case "t":
            material.uniforms[name].value = getTexture(uniform.value);
            break;
          case "c":
            material.uniforms[name].value = new Color$1().setHex(uniform.value);
            break;
          case "v2":
            material.uniforms[name].value = new Vector2$1().fromArray(uniform.value);
            break;
          case "v3":
            material.uniforms[name].value = new Vector3$1().fromArray(uniform.value);
            break;
          case "v4":
            material.uniforms[name].value = new Vector4$1().fromArray(uniform.value);
            break;
          case "m3":
            material.uniforms[name].value = new Matrix3$1().fromArray(uniform.value);
            break;
          case "m4":
            material.uniforms[name].value = new Matrix4$1().fromArray(uniform.value);
            break;
          default:
            material.uniforms[name].value = uniform.value;
        }
      }
    }
    if (json.defines !== void 0) material.defines = json.defines;
    if (json.vertexShader !== void 0) material.vertexShader = json.vertexShader;
    if (json.fragmentShader !== void 0) material.fragmentShader = json.fragmentShader;
    if (json.glslVersion !== void 0) material.glslVersion = json.glslVersion;
    if (json.extensions !== void 0) {
      for (const key in json.extensions) {
        material.extensions[key] = json.extensions[key];
      }
    }
    if (json.lights !== void 0) material.lights = json.lights;
    if (json.clipping !== void 0) material.clipping = json.clipping;
    if (json.size !== void 0) material.size = json.size;
    if (json.sizeAttenuation !== void 0) material.sizeAttenuation = json.sizeAttenuation;
    if (json.map !== void 0) material.map = getTexture(json.map);
    if (json.matcap !== void 0) material.matcap = getTexture(json.matcap);
    if (json.alphaMap !== void 0) material.alphaMap = getTexture(json.alphaMap);
    if (json.bumpMap !== void 0) material.bumpMap = getTexture(json.bumpMap);
    if (json.bumpScale !== void 0) material.bumpScale = json.bumpScale;
    if (json.normalMap !== void 0) material.normalMap = getTexture(json.normalMap);
    if (json.normalMapType !== void 0) material.normalMapType = json.normalMapType;
    if (json.normalScale !== void 0) {
      let normalScale = json.normalScale;
      if (Array.isArray(normalScale) === false) {
        normalScale = [normalScale, normalScale];
      }
      material.normalScale = new Vector2$1().fromArray(normalScale);
    }
    if (json.displacementMap !== void 0) material.displacementMap = getTexture(json.displacementMap);
    if (json.displacementScale !== void 0) material.displacementScale = json.displacementScale;
    if (json.displacementBias !== void 0) material.displacementBias = json.displacementBias;
    if (json.roughnessMap !== void 0) material.roughnessMap = getTexture(json.roughnessMap);
    if (json.metalnessMap !== void 0) material.metalnessMap = getTexture(json.metalnessMap);
    if (json.emissiveMap !== void 0) material.emissiveMap = getTexture(json.emissiveMap);
    if (json.emissiveIntensity !== void 0) material.emissiveIntensity = json.emissiveIntensity;
    if (json.specularMap !== void 0) material.specularMap = getTexture(json.specularMap);
    if (json.specularIntensityMap !== void 0) material.specularIntensityMap = getTexture(json.specularIntensityMap);
    if (json.specularColorMap !== void 0) material.specularColorMap = getTexture(json.specularColorMap);
    if (json.envMap !== void 0) material.envMap = getTexture(json.envMap);
    if (json.envMapRotation !== void 0) material.envMapRotation.fromArray(json.envMapRotation);
    if (json.envMapIntensity !== void 0) material.envMapIntensity = json.envMapIntensity;
    if (json.reflectivity !== void 0) material.reflectivity = json.reflectivity;
    if (json.refractionRatio !== void 0) material.refractionRatio = json.refractionRatio;
    if (json.lightMap !== void 0) material.lightMap = getTexture(json.lightMap);
    if (json.lightMapIntensity !== void 0) material.lightMapIntensity = json.lightMapIntensity;
    if (json.aoMap !== void 0) material.aoMap = getTexture(json.aoMap);
    if (json.aoMapIntensity !== void 0) material.aoMapIntensity = json.aoMapIntensity;
    if (json.gradientMap !== void 0) material.gradientMap = getTexture(json.gradientMap);
    if (json.clearcoatMap !== void 0) material.clearcoatMap = getTexture(json.clearcoatMap);
    if (json.clearcoatRoughnessMap !== void 0) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
    if (json.clearcoatNormalMap !== void 0) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
    if (json.clearcoatNormalScale !== void 0) material.clearcoatNormalScale = new Vector2$1().fromArray(json.clearcoatNormalScale);
    if (json.iridescenceMap !== void 0) material.iridescenceMap = getTexture(json.iridescenceMap);
    if (json.iridescenceThicknessMap !== void 0) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
    if (json.transmissionMap !== void 0) material.transmissionMap = getTexture(json.transmissionMap);
    if (json.thicknessMap !== void 0) material.thicknessMap = getTexture(json.thicknessMap);
    if (json.anisotropyMap !== void 0) material.anisotropyMap = getTexture(json.anisotropyMap);
    if (json.sheenColorMap !== void 0) material.sheenColorMap = getTexture(json.sheenColorMap);
    if (json.sheenRoughnessMap !== void 0) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
    return material;
  }
  setTextures(value) {
    this.textures = value;
    return this;
  }
  createMaterialFromType(type) {
    return MaterialLoader.createMaterialFromType(type);
  }
  static createMaterialFromType(type) {
    const materialLib = {
      ShadowMaterial: ShadowMaterial$1,
      SpriteMaterial: SpriteMaterial$1,
      RawShaderMaterial: RawShaderMaterial$1,
      ShaderMaterial: ShaderMaterial$1,
      PointsMaterial: PointsMaterial$1,
      MeshPhysicalMaterial: MeshPhysicalMaterial$1,
      MeshStandardMaterial: MeshStandardMaterial$1,
      MeshPhongMaterial: MeshPhongMaterial$1,
      MeshToonMaterial: MeshToonMaterial$1,
      MeshNormalMaterial: MeshNormalMaterial$1,
      MeshLambertMaterial: MeshLambertMaterial$1,
      MeshDepthMaterial: MeshDepthMaterial$1,
      MeshDistanceMaterial: MeshDistanceMaterial$1,
      MeshBasicMaterial: MeshBasicMaterial$1,
      MeshMatcapMaterial: MeshMatcapMaterial$1,
      LineDashedMaterial: LineDashedMaterial$1,
      LineBasicMaterial: LineBasicMaterial$1,
      Material: Material$1
    };
    return new materialLib[type]();
  }
}
let LoaderUtils$1 = class LoaderUtils {
  static decodeText(array) {
    console.warn("THREE.LoaderUtils: decodeText() has been deprecated with r165 and will be removed with r175. Use TextDecoder instead.");
    if (typeof TextDecoder !== "undefined") {
      return new TextDecoder().decode(array);
    }
    let s2 = "";
    for (let i2 = 0, il = array.length; i2 < il; i2++) {
      s2 += String.fromCharCode(array[i2]);
    }
    try {
      return decodeURIComponent(escape(s2));
    } catch (e2) {
      return s2;
    }
  }
  static extractUrlBase(url) {
    const index2 = url.lastIndexOf("/");
    if (index2 === -1) return "./";
    return url.slice(0, index2 + 1);
  }
  static resolveURL(url, path) {
    if (typeof url !== "string" || url === "") return "";
    if (/^https?:\/\//i.test(path) && /^\//.test(url)) {
      path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
    }
    if (/^(https?:)?\/\//i.test(url)) return url;
    if (/^data:.*,.*$/i.test(url)) return url;
    if (/^blob:.*$/i.test(url)) return url;
    return path + url;
  }
};
let InstancedBufferGeometry$1 = class InstancedBufferGeometry extends BufferGeometry$1 {
  constructor() {
    super();
    this.isInstancedBufferGeometry = true;
    this.type = "InstancedBufferGeometry";
    this.instanceCount = Infinity;
  }
  copy(source) {
    super.copy(source);
    this.instanceCount = source.instanceCount;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.instanceCount = this.instanceCount;
    data.isInstancedBufferGeometry = true;
    return data;
  }
};
class BufferGeometryLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const loader = new FileLoader$1(scope.manager);
    loader.setPath(scope.path);
    loader.setRequestHeader(scope.requestHeader);
    loader.setWithCredentials(scope.withCredentials);
    loader.load(url, function(text) {
      try {
        onLoad(scope.parse(JSON.parse(text)));
      } catch (e2) {
        if (onError) {
          onError(e2);
        } else {
          console.error(e2);
        }
        scope.manager.itemError(url);
      }
    }, onProgress, onError);
  }
  parse(json) {
    const interleavedBufferMap = {};
    const arrayBufferMap = {};
    function getInterleavedBuffer(json2, uuid) {
      if (interleavedBufferMap[uuid] !== void 0) return interleavedBufferMap[uuid];
      const interleavedBuffers = json2.interleavedBuffers;
      const interleavedBuffer = interleavedBuffers[uuid];
      const buffer = getArrayBuffer(json2, interleavedBuffer.buffer);
      const array = getTypedArray(interleavedBuffer.type, buffer);
      const ib = new InterleavedBuffer$1(array, interleavedBuffer.stride);
      ib.uuid = interleavedBuffer.uuid;
      interleavedBufferMap[uuid] = ib;
      return ib;
    }
    function getArrayBuffer(json2, uuid) {
      if (arrayBufferMap[uuid] !== void 0) return arrayBufferMap[uuid];
      const arrayBuffers = json2.arrayBuffers;
      const arrayBuffer = arrayBuffers[uuid];
      const ab = new Uint32Array(arrayBuffer).buffer;
      arrayBufferMap[uuid] = ab;
      return ab;
    }
    const geometry = json.isInstancedBufferGeometry ? new InstancedBufferGeometry$1() : new BufferGeometry$1();
    const index2 = json.data.index;
    if (index2 !== void 0) {
      const typedArray = getTypedArray(index2.type, index2.array);
      geometry.setIndex(new BufferAttribute$1(typedArray, 1));
    }
    const attributes = json.data.attributes;
    for (const key in attributes) {
      const attribute = attributes[key];
      let bufferAttribute;
      if (attribute.isInterleavedBufferAttribute) {
        const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
        bufferAttribute = new InterleavedBufferAttribute$1(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
      } else {
        const typedArray = getTypedArray(attribute.type, attribute.array);
        const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? InstancedBufferAttribute$1 : BufferAttribute$1;
        bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
      }
      if (attribute.name !== void 0) bufferAttribute.name = attribute.name;
      if (attribute.usage !== void 0) bufferAttribute.setUsage(attribute.usage);
      geometry.setAttribute(key, bufferAttribute);
    }
    const morphAttributes = json.data.morphAttributes;
    if (morphAttributes) {
      for (const key in morphAttributes) {
        const attributeArray = morphAttributes[key];
        const array = [];
        for (let i2 = 0, il = attributeArray.length; i2 < il; i2++) {
          const attribute = attributeArray[i2];
          let bufferAttribute;
          if (attribute.isInterleavedBufferAttribute) {
            const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
            bufferAttribute = new InterleavedBufferAttribute$1(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
          } else {
            const typedArray = getTypedArray(attribute.type, attribute.array);
            bufferAttribute = new BufferAttribute$1(typedArray, attribute.itemSize, attribute.normalized);
          }
          if (attribute.name !== void 0) bufferAttribute.name = attribute.name;
          array.push(bufferAttribute);
        }
        geometry.morphAttributes[key] = array;
      }
    }
    const morphTargetsRelative = json.data.morphTargetsRelative;
    if (morphTargetsRelative) {
      geometry.morphTargetsRelative = true;
    }
    const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
    if (groups !== void 0) {
      for (let i2 = 0, n2 = groups.length; i2 !== n2; ++i2) {
        const group = groups[i2];
        geometry.addGroup(group.start, group.count, group.materialIndex);
      }
    }
    const boundingSphere = json.data.boundingSphere;
    if (boundingSphere !== void 0) {
      const center = new Vector3$1();
      if (boundingSphere.center !== void 0) {
        center.fromArray(boundingSphere.center);
      }
      geometry.boundingSphere = new Sphere$1(center, boundingSphere.radius);
    }
    if (json.name) geometry.name = json.name;
    if (json.userData) geometry.userData = json.userData;
    return geometry;
  }
}
class ObjectLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const path = this.path === "" ? LoaderUtils$1.extractUrlBase(url) : this.path;
    this.resourcePath = this.resourcePath || path;
    const loader = new FileLoader$1(this.manager);
    loader.setPath(this.path);
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(url, function(text) {
      let json = null;
      try {
        json = JSON.parse(text);
      } catch (error) {
        if (onError !== void 0) onError(error);
        console.error("THREE:ObjectLoader: Can't parse " + url + ".", error.message);
        return;
      }
      const metadata = json.metadata;
      if (metadata === void 0 || metadata.type === void 0 || metadata.type.toLowerCase() === "geometry") {
        if (onError !== void 0) onError(new Error("THREE.ObjectLoader: Can't load " + url));
        console.error("THREE.ObjectLoader: Can't load " + url);
        return;
      }
      scope.parse(json, onLoad);
    }, onProgress, onError);
  }
  async loadAsync(url, onProgress) {
    const scope = this;
    const path = this.path === "" ? LoaderUtils$1.extractUrlBase(url) : this.path;
    this.resourcePath = this.resourcePath || path;
    const loader = new FileLoader$1(this.manager);
    loader.setPath(this.path);
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    const text = await loader.loadAsync(url, onProgress);
    const json = JSON.parse(text);
    const metadata = json.metadata;
    if (metadata === void 0 || metadata.type === void 0 || metadata.type.toLowerCase() === "geometry") {
      throw new Error("THREE.ObjectLoader: Can't load " + url);
    }
    return await scope.parseAsync(json);
  }
  parse(json, onLoad) {
    const animations = this.parseAnimations(json.animations);
    const shapes = this.parseShapes(json.shapes);
    const geometries = this.parseGeometries(json.geometries, shapes);
    const images = this.parseImages(json.images, function() {
      if (onLoad !== void 0) onLoad(object);
    });
    const textures = this.parseTextures(json.textures, images);
    const materials = this.parseMaterials(json.materials, textures);
    const object = this.parseObject(json.object, geometries, materials, textures, animations);
    const skeletons = this.parseSkeletons(json.skeletons, object);
    this.bindSkeletons(object, skeletons);
    this.bindLightTargets(object);
    if (onLoad !== void 0) {
      let hasImages = false;
      for (const uuid in images) {
        if (images[uuid].data instanceof HTMLImageElement) {
          hasImages = true;
          break;
        }
      }
      if (hasImages === false) onLoad(object);
    }
    return object;
  }
  async parseAsync(json) {
    const animations = this.parseAnimations(json.animations);
    const shapes = this.parseShapes(json.shapes);
    const geometries = this.parseGeometries(json.geometries, shapes);
    const images = await this.parseImagesAsync(json.images);
    const textures = this.parseTextures(json.textures, images);
    const materials = this.parseMaterials(json.materials, textures);
    const object = this.parseObject(json.object, geometries, materials, textures, animations);
    const skeletons = this.parseSkeletons(json.skeletons, object);
    this.bindSkeletons(object, skeletons);
    this.bindLightTargets(object);
    return object;
  }
  parseShapes(json) {
    const shapes = {};
    if (json !== void 0) {
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        const shape = new Shape$1().fromJSON(json[i2]);
        shapes[shape.uuid] = shape;
      }
    }
    return shapes;
  }
  parseSkeletons(json, object) {
    const skeletons = {};
    const bones = {};
    object.traverse(function(child) {
      if (child.isBone) bones[child.uuid] = child;
    });
    if (json !== void 0) {
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        const skeleton = new Skeleton().fromJSON(json[i2], bones);
        skeletons[skeleton.uuid] = skeleton;
      }
    }
    return skeletons;
  }
  parseGeometries(json, shapes) {
    const geometries = {};
    if (json !== void 0) {
      const bufferGeometryLoader = new BufferGeometryLoader();
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        let geometry;
        const data = json[i2];
        switch (data.type) {
          case "BufferGeometry":
          case "InstancedBufferGeometry":
            geometry = bufferGeometryLoader.parse(data);
            break;
          default:
            if (data.type in Geometries) {
              geometry = Geometries[data.type].fromJSON(data, shapes);
            } else {
              console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
            }
        }
        geometry.uuid = data.uuid;
        if (data.name !== void 0) geometry.name = data.name;
        if (data.userData !== void 0) geometry.userData = data.userData;
        geometries[data.uuid] = geometry;
      }
    }
    return geometries;
  }
  parseMaterials(json, textures) {
    const cache = {};
    const materials = {};
    if (json !== void 0) {
      const loader = new MaterialLoader();
      loader.setTextures(textures);
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        const data = json[i2];
        if (cache[data.uuid] === void 0) {
          cache[data.uuid] = loader.parse(data);
        }
        materials[data.uuid] = cache[data.uuid];
      }
    }
    return materials;
  }
  parseAnimations(json) {
    const animations = {};
    if (json !== void 0) {
      for (let i2 = 0; i2 < json.length; i2++) {
        const data = json[i2];
        const clip = AnimationClip$1.parse(data);
        animations[clip.uuid] = clip;
      }
    }
    return animations;
  }
  parseImages(json, onLoad) {
    const scope = this;
    const images = {};
    let loader;
    function loadImage(url) {
      scope.manager.itemStart(url);
      return loader.load(url, function() {
        scope.manager.itemEnd(url);
      }, void 0, function() {
        scope.manager.itemError(url);
        scope.manager.itemEnd(url);
      });
    }
    function deserializeImage(image2) {
      if (typeof image2 === "string") {
        const url = image2;
        const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
        return loadImage(path);
      } else {
        if (image2.data) {
          return {
            data: getTypedArray(image2.type, image2.data),
            width: image2.width,
            height: image2.height
          };
        } else {
          return null;
        }
      }
    }
    if (json !== void 0 && json.length > 0) {
      const manager = new LoadingManager$1(onLoad);
      loader = new ImageLoader$1(manager);
      loader.setCrossOrigin(this.crossOrigin);
      for (let i2 = 0, il = json.length; i2 < il; i2++) {
        const image2 = json[i2];
        const url = image2.url;
        if (Array.isArray(url)) {
          const imageArray = [];
          for (let j = 0, jl = url.length; j < jl; j++) {
            const currentUrl = url[j];
            const deserializedImage = deserializeImage(currentUrl);
            if (deserializedImage !== null) {
              if (deserializedImage instanceof HTMLImageElement) {
                imageArray.push(deserializedImage);
              } else {
                imageArray.push(new DataTexture$1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
              }
            }
          }
          images[image2.uuid] = new Source(imageArray);
        } else {
          const deserializedImage = deserializeImage(image2.url);
          images[image2.uuid] = new Source(deserializedImage);
        }
      }
    }
    return images;
  }
  async parseImagesAsync(json) {
    const scope = this;
    const images = {};
    let loader;
    async function deserializeImage(image2) {
      if (typeof image2 === "string") {
        const url = image2;
        const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
        return await loader.loadAsync(path);
      } else {
        if (image2.data) {
          return {
            data: getTypedArray(image2.type, image2.data),
            width: image2.width,
            height: image2.height
          };
        } else {
          return null;
        }
      }
    }
    if (json !== void 0 && json.length > 0) {
      loader = new ImageLoader$1(this.manager);
      loader.setCrossOrigin(this.crossOrigin);
      for (let i2 = 0, il = json.length; i2 < il; i2++) {
        const image2 = json[i2];
        const url = image2.url;
        if (Array.isArray(url)) {
          const imageArray = [];
          for (let j = 0, jl = url.length; j < jl; j++) {
            const currentUrl = url[j];
            const deserializedImage = await deserializeImage(currentUrl);
            if (deserializedImage !== null) {
              if (deserializedImage instanceof HTMLImageElement) {
                imageArray.push(deserializedImage);
              } else {
                imageArray.push(new DataTexture$1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
              }
            }
          }
          images[image2.uuid] = new Source(imageArray);
        } else {
          const deserializedImage = await deserializeImage(image2.url);
          images[image2.uuid] = new Source(deserializedImage);
        }
      }
    }
    return images;
  }
  parseTextures(json, images) {
    function parseConstant(value, type) {
      if (typeof value === "number") return value;
      console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
      return type[value];
    }
    const textures = {};
    if (json !== void 0) {
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        const data = json[i2];
        if (data.image === void 0) {
          console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
        }
        if (images[data.image] === void 0) {
          console.warn("THREE.ObjectLoader: Undefined image", data.image);
        }
        const source = images[data.image];
        const image2 = source.data;
        let texture;
        if (Array.isArray(image2)) {
          texture = new CubeTexture$1();
          if (image2.length === 6) texture.needsUpdate = true;
        } else {
          if (image2 && image2.data) {
            texture = new DataTexture$1();
          } else {
            texture = new Texture$1();
          }
          if (image2) texture.needsUpdate = true;
        }
        texture.source = source;
        texture.uuid = data.uuid;
        if (data.name !== void 0) texture.name = data.name;
        if (data.mapping !== void 0) texture.mapping = parseConstant(data.mapping, TEXTURE_MAPPING);
        if (data.channel !== void 0) texture.channel = data.channel;
        if (data.offset !== void 0) texture.offset.fromArray(data.offset);
        if (data.repeat !== void 0) texture.repeat.fromArray(data.repeat);
        if (data.center !== void 0) texture.center.fromArray(data.center);
        if (data.rotation !== void 0) texture.rotation = data.rotation;
        if (data.wrap !== void 0) {
          texture.wrapS = parseConstant(data.wrap[0], TEXTURE_WRAPPING);
          texture.wrapT = parseConstant(data.wrap[1], TEXTURE_WRAPPING);
        }
        if (data.format !== void 0) texture.format = data.format;
        if (data.internalFormat !== void 0) texture.internalFormat = data.internalFormat;
        if (data.type !== void 0) texture.type = data.type;
        if (data.colorSpace !== void 0) texture.colorSpace = data.colorSpace;
        if (data.minFilter !== void 0) texture.minFilter = parseConstant(data.minFilter, TEXTURE_FILTER);
        if (data.magFilter !== void 0) texture.magFilter = parseConstant(data.magFilter, TEXTURE_FILTER);
        if (data.anisotropy !== void 0) texture.anisotropy = data.anisotropy;
        if (data.flipY !== void 0) texture.flipY = data.flipY;
        if (data.generateMipmaps !== void 0) texture.generateMipmaps = data.generateMipmaps;
        if (data.premultiplyAlpha !== void 0) texture.premultiplyAlpha = data.premultiplyAlpha;
        if (data.unpackAlignment !== void 0) texture.unpackAlignment = data.unpackAlignment;
        if (data.compareFunction !== void 0) texture.compareFunction = data.compareFunction;
        if (data.userData !== void 0) texture.userData = data.userData;
        textures[data.uuid] = texture;
      }
    }
    return textures;
  }
  parseObject(data, geometries, materials, textures, animations) {
    let object;
    function getGeometry(name) {
      if (geometries[name] === void 0) {
        console.warn("THREE.ObjectLoader: Undefined geometry", name);
      }
      return geometries[name];
    }
    function getMaterial(name) {
      if (name === void 0) return void 0;
      if (Array.isArray(name)) {
        const array = [];
        for (let i2 = 0, l2 = name.length; i2 < l2; i2++) {
          const uuid = name[i2];
          if (materials[uuid] === void 0) {
            console.warn("THREE.ObjectLoader: Undefined material", uuid);
          }
          array.push(materials[uuid]);
        }
        return array;
      }
      if (materials[name] === void 0) {
        console.warn("THREE.ObjectLoader: Undefined material", name);
      }
      return materials[name];
    }
    function getTexture(uuid) {
      if (textures[uuid] === void 0) {
        console.warn("THREE.ObjectLoader: Undefined texture", uuid);
      }
      return textures[uuid];
    }
    let geometry, material;
    switch (data.type) {
      case "Scene":
        object = new Scene$1();
        if (data.background !== void 0) {
          if (Number.isInteger(data.background)) {
            object.background = new Color$1(data.background);
          } else {
            object.background = getTexture(data.background);
          }
        }
        if (data.environment !== void 0) {
          object.environment = getTexture(data.environment);
        }
        if (data.fog !== void 0) {
          if (data.fog.type === "Fog") {
            object.fog = new Fog(data.fog.color, data.fog.near, data.fog.far);
          } else if (data.fog.type === "FogExp2") {
            object.fog = new FogExp2(data.fog.color, data.fog.density);
          }
          if (data.fog.name !== "") {
            object.fog.name = data.fog.name;
          }
        }
        if (data.backgroundBlurriness !== void 0) object.backgroundBlurriness = data.backgroundBlurriness;
        if (data.backgroundIntensity !== void 0) object.backgroundIntensity = data.backgroundIntensity;
        if (data.backgroundRotation !== void 0) object.backgroundRotation.fromArray(data.backgroundRotation);
        if (data.environmentIntensity !== void 0) object.environmentIntensity = data.environmentIntensity;
        if (data.environmentRotation !== void 0) object.environmentRotation.fromArray(data.environmentRotation);
        break;
      case "PerspectiveCamera":
        object = new PerspectiveCamera$1(data.fov, data.aspect, data.near, data.far);
        if (data.focus !== void 0) object.focus = data.focus;
        if (data.zoom !== void 0) object.zoom = data.zoom;
        if (data.filmGauge !== void 0) object.filmGauge = data.filmGauge;
        if (data.filmOffset !== void 0) object.filmOffset = data.filmOffset;
        if (data.view !== void 0) object.view = Object.assign({}, data.view);
        break;
      case "OrthographicCamera":
        object = new OrthographicCamera$1(data.left, data.right, data.top, data.bottom, data.near, data.far);
        if (data.zoom !== void 0) object.zoom = data.zoom;
        if (data.view !== void 0) object.view = Object.assign({}, data.view);
        break;
      case "AmbientLight":
        object = new AmbientLight$1(data.color, data.intensity);
        break;
      case "DirectionalLight":
        object = new DirectionalLight$1(data.color, data.intensity);
        object.target = data.target || "";
        break;
      case "PointLight":
        object = new PointLight$1(data.color, data.intensity, data.distance, data.decay);
        break;
      case "RectAreaLight":
        object = new RectAreaLight$1(data.color, data.intensity, data.width, data.height);
        break;
      case "SpotLight":
        object = new SpotLight$1(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
        object.target = data.target || "";
        break;
      case "HemisphereLight":
        object = new HemisphereLight$1(data.color, data.groundColor, data.intensity);
        break;
      case "LightProbe":
        object = new LightProbe$1().fromJSON(data);
        break;
      case "SkinnedMesh":
        geometry = getGeometry(data.geometry);
        material = getMaterial(data.material);
        object = new SkinnedMesh$1(geometry, material);
        if (data.bindMode !== void 0) object.bindMode = data.bindMode;
        if (data.bindMatrix !== void 0) object.bindMatrix.fromArray(data.bindMatrix);
        if (data.skeleton !== void 0) object.skeleton = data.skeleton;
        break;
      case "Mesh":
        geometry = getGeometry(data.geometry);
        material = getMaterial(data.material);
        object = new Mesh$1(geometry, material);
        break;
      case "InstancedMesh":
        geometry = getGeometry(data.geometry);
        material = getMaterial(data.material);
        const count = data.count;
        const instanceMatrix = data.instanceMatrix;
        const instanceColor = data.instanceColor;
        object = new InstancedMesh$1(geometry, material, count);
        object.instanceMatrix = new InstancedBufferAttribute$1(new Float32Array(instanceMatrix.array), 16);
        if (instanceColor !== void 0) object.instanceColor = new InstancedBufferAttribute$1(new Float32Array(instanceColor.array), instanceColor.itemSize);
        break;
      case "BatchedMesh":
        geometry = getGeometry(data.geometry);
        material = getMaterial(data.material);
        object = new BatchedMesh(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
        object.geometry = geometry;
        object.perObjectFrustumCulled = data.perObjectFrustumCulled;
        object.sortObjects = data.sortObjects;
        object._drawRanges = data.drawRanges;
        object._reservedRanges = data.reservedRanges;
        object._visibility = data.visibility;
        object._active = data.active;
        object._bounds = data.bounds.map((bound) => {
          const box = new Box3$1();
          box.min.fromArray(bound.boxMin);
          box.max.fromArray(bound.boxMax);
          const sphere = new Sphere$1();
          sphere.radius = bound.sphereRadius;
          sphere.center.fromArray(bound.sphereCenter);
          return {
            boxInitialized: bound.boxInitialized,
            box,
            sphereInitialized: bound.sphereInitialized,
            sphere
          };
        });
        object._maxInstanceCount = data.maxInstanceCount;
        object._maxVertexCount = data.maxVertexCount;
        object._maxIndexCount = data.maxIndexCount;
        object._geometryInitialized = data.geometryInitialized;
        object._geometryCount = data.geometryCount;
        object._matricesTexture = getTexture(data.matricesTexture.uuid);
        if (data.colorsTexture !== void 0) object._colorsTexture = getTexture(data.colorsTexture.uuid);
        break;
      case "LOD":
        object = new LOD();
        break;
      case "Line":
        object = new Line$1(getGeometry(data.geometry), getMaterial(data.material));
        break;
      case "LineLoop":
        object = new LineLoop$1(getGeometry(data.geometry), getMaterial(data.material));
        break;
      case "LineSegments":
        object = new LineSegments$1(getGeometry(data.geometry), getMaterial(data.material));
        break;
      case "PointCloud":
      case "Points":
        object = new Points$1(getGeometry(data.geometry), getMaterial(data.material));
        break;
      case "Sprite":
        object = new Sprite$1(getMaterial(data.material));
        break;
      case "Group":
        object = new Group$1();
        break;
      case "Bone":
        object = new Bone$1();
        break;
      default:
        object = new Object3D$1();
    }
    object.uuid = data.uuid;
    if (data.name !== void 0) object.name = data.name;
    if (data.matrix !== void 0) {
      object.matrix.fromArray(data.matrix);
      if (data.matrixAutoUpdate !== void 0) object.matrixAutoUpdate = data.matrixAutoUpdate;
      if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
    } else {
      if (data.position !== void 0) object.position.fromArray(data.position);
      if (data.rotation !== void 0) object.rotation.fromArray(data.rotation);
      if (data.quaternion !== void 0) object.quaternion.fromArray(data.quaternion);
      if (data.scale !== void 0) object.scale.fromArray(data.scale);
    }
    if (data.up !== void 0) object.up.fromArray(data.up);
    if (data.castShadow !== void 0) object.castShadow = data.castShadow;
    if (data.receiveShadow !== void 0) object.receiveShadow = data.receiveShadow;
    if (data.shadow) {
      if (data.shadow.intensity !== void 0) object.shadow.intensity = data.shadow.intensity;
      if (data.shadow.bias !== void 0) object.shadow.bias = data.shadow.bias;
      if (data.shadow.normalBias !== void 0) object.shadow.normalBias = data.shadow.normalBias;
      if (data.shadow.radius !== void 0) object.shadow.radius = data.shadow.radius;
      if (data.shadow.mapSize !== void 0) object.shadow.mapSize.fromArray(data.shadow.mapSize);
      if (data.shadow.camera !== void 0) object.shadow.camera = this.parseObject(data.shadow.camera);
    }
    if (data.visible !== void 0) object.visible = data.visible;
    if (data.frustumCulled !== void 0) object.frustumCulled = data.frustumCulled;
    if (data.renderOrder !== void 0) object.renderOrder = data.renderOrder;
    if (data.userData !== void 0) object.userData = data.userData;
    if (data.layers !== void 0) object.layers.mask = data.layers;
    if (data.children !== void 0) {
      const children = data.children;
      for (let i2 = 0; i2 < children.length; i2++) {
        object.add(this.parseObject(children[i2], geometries, materials, textures, animations));
      }
    }
    if (data.animations !== void 0) {
      const objectAnimations = data.animations;
      for (let i2 = 0; i2 < objectAnimations.length; i2++) {
        const uuid = objectAnimations[i2];
        object.animations.push(animations[uuid]);
      }
    }
    if (data.type === "LOD") {
      if (data.autoUpdate !== void 0) object.autoUpdate = data.autoUpdate;
      const levels = data.levels;
      for (let l2 = 0; l2 < levels.length; l2++) {
        const level = levels[l2];
        const child = object.getObjectByProperty("uuid", level.object);
        if (child !== void 0) {
          object.addLevel(child, level.distance, level.hysteresis);
        }
      }
    }
    return object;
  }
  bindSkeletons(object, skeletons) {
    if (Object.keys(skeletons).length === 0) return;
    object.traverse(function(child) {
      if (child.isSkinnedMesh === true && child.skeleton !== void 0) {
        const skeleton = skeletons[child.skeleton];
        if (skeleton === void 0) {
          console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
        } else {
          child.bind(skeleton, child.bindMatrix);
        }
      }
    });
  }
  bindLightTargets(object) {
    object.traverse(function(child) {
      if (child.isDirectionalLight || child.isSpotLight) {
        const uuid = child.target;
        const target = object.getObjectByProperty("uuid", uuid);
        if (target !== void 0) {
          child.target = target;
        } else {
          child.target = new Object3D$1();
        }
      }
    });
  }
}
const TEXTURE_MAPPING = {
  UVMapping: UVMapping$1,
  CubeReflectionMapping: CubeReflectionMapping$1,
  CubeRefractionMapping: CubeRefractionMapping$1,
  EquirectangularReflectionMapping: EquirectangularReflectionMapping$1,
  EquirectangularRefractionMapping: EquirectangularRefractionMapping$1,
  CubeUVReflectionMapping: CubeUVReflectionMapping$1
};
const TEXTURE_WRAPPING = {
  RepeatWrapping: RepeatWrapping$1,
  ClampToEdgeWrapping: ClampToEdgeWrapping$1,
  MirroredRepeatWrapping: MirroredRepeatWrapping$1
};
const TEXTURE_FILTER = {
  NearestFilter: NearestFilter$1,
  NearestMipmapNearestFilter: NearestMipmapNearestFilter$1,
  NearestMipmapLinearFilter: NearestMipmapLinearFilter$1,
  LinearFilter: LinearFilter$1,
  LinearMipmapNearestFilter: LinearMipmapNearestFilter$1,
  LinearMipmapLinearFilter: LinearMipmapLinearFilter$1
};
let ImageBitmapLoader$1 = class ImageBitmapLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
    this.isImageBitmapLoader = true;
    if (typeof createImageBitmap === "undefined") {
      console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
    }
    if (typeof fetch === "undefined") {
      console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
    }
    this.options = { premultiplyAlpha: "none" };
  }
  setOptions(options) {
    this.options = options;
    return this;
  }
  load(url, onLoad, onProgress, onError) {
    if (url === void 0) url = "";
    if (this.path !== void 0) url = this.path + url;
    url = this.manager.resolveURL(url);
    const scope = this;
    const cached = Cache$2.get(url);
    if (cached !== void 0) {
      scope.manager.itemStart(url);
      if (cached.then) {
        cached.then((imageBitmap) => {
          if (onLoad) onLoad(imageBitmap);
          scope.manager.itemEnd(url);
        }).catch((e2) => {
          if (onError) onError(e2);
        });
        return;
      }
      setTimeout(function() {
        if (onLoad) onLoad(cached);
        scope.manager.itemEnd(url);
      }, 0);
      return cached;
    }
    const fetchOptions = {};
    fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
    fetchOptions.headers = this.requestHeader;
    const promise = fetch(url, fetchOptions).then(function(res) {
      return res.blob();
    }).then(function(blob) {
      return createImageBitmap(blob, Object.assign(scope.options, { colorSpaceConversion: "none" }));
    }).then(function(imageBitmap) {
      Cache$2.add(url, imageBitmap);
      if (onLoad) onLoad(imageBitmap);
      scope.manager.itemEnd(url);
      return imageBitmap;
    }).catch(function(e2) {
      if (onError) onError(e2);
      Cache$2.remove(url);
      scope.manager.itemError(url);
      scope.manager.itemEnd(url);
    });
    Cache$2.add(url, promise);
    scope.manager.itemStart(url);
  }
};
let _context$1;
let AudioContext$1 = class AudioContext {
  static getContext() {
    if (_context$1 === void 0) {
      _context$1 = new (window.AudioContext || window.webkitAudioContext)();
    }
    return _context$1;
  }
  static setContext(value) {
    _context$1 = value;
  }
};
let AudioLoader$1 = class AudioLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const loader = new FileLoader$1(this.manager);
    loader.setResponseType("arraybuffer");
    loader.setPath(this.path);
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(url, function(buffer) {
      try {
        const bufferCopy = buffer.slice(0);
        const context = AudioContext$1.getContext();
        context.decodeAudioData(bufferCopy, function(audioBuffer) {
          onLoad(audioBuffer);
        }).catch(handleError);
      } catch (e2) {
        handleError(e2);
      }
    }, onProgress, onError);
    function handleError(e2) {
      if (onError) {
        onError(e2);
      } else {
        console.error(e2);
      }
      scope.manager.itemError(url);
    }
  }
};
const _eyeRight = /* @__PURE__ */ new Matrix4$1();
const _eyeLeft = /* @__PURE__ */ new Matrix4$1();
const _projectionMatrix = /* @__PURE__ */ new Matrix4$1();
class StereoCamera {
  constructor() {
    this.type = "StereoCamera";
    this.aspect = 1;
    this.eyeSep = 0.064;
    this.cameraL = new PerspectiveCamera$1();
    this.cameraL.layers.enable(1);
    this.cameraL.matrixAutoUpdate = false;
    this.cameraR = new PerspectiveCamera$1();
    this.cameraR.layers.enable(2);
    this.cameraR.matrixAutoUpdate = false;
    this._cache = {
      focus: null,
      fov: null,
      aspect: null,
      near: null,
      far: null,
      zoom: null,
      eyeSep: null
    };
  }
  update(camera) {
    const cache = this._cache;
    const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
    if (needsUpdate) {
      cache.focus = camera.focus;
      cache.fov = camera.fov;
      cache.aspect = camera.aspect * this.aspect;
      cache.near = camera.near;
      cache.far = camera.far;
      cache.zoom = camera.zoom;
      cache.eyeSep = this.eyeSep;
      _projectionMatrix.copy(camera.projectionMatrix);
      const eyeSepHalf = cache.eyeSep / 2;
      const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
      const ymax = cache.near * Math.tan(DEG2RAD$1 * cache.fov * 0.5) / cache.zoom;
      let xmin, xmax;
      _eyeLeft.elements[12] = -eyeSepHalf;
      _eyeRight.elements[12] = eyeSepHalf;
      xmin = -ymax * cache.aspect + eyeSepOnProjection;
      xmax = ymax * cache.aspect + eyeSepOnProjection;
      _projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
      _projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
      this.cameraL.projectionMatrix.copy(_projectionMatrix);
      xmin = -ymax * cache.aspect - eyeSepOnProjection;
      xmax = ymax * cache.aspect - eyeSepOnProjection;
      _projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
      _projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
      this.cameraR.projectionMatrix.copy(_projectionMatrix);
    }
    this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply(_eyeLeft);
    this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply(_eyeRight);
  }
}
let ArrayCamera$1 = class ArrayCamera extends PerspectiveCamera$1 {
  constructor(array = []) {
    super();
    this.isArrayCamera = true;
    this.cameras = array;
  }
};
class Clock {
  constructor(autoStart = true) {
    this.autoStart = autoStart;
    this.startTime = 0;
    this.oldTime = 0;
    this.elapsedTime = 0;
    this.running = false;
  }
  start() {
    this.startTime = now();
    this.oldTime = this.startTime;
    this.elapsedTime = 0;
    this.running = true;
  }
  stop() {
    this.getElapsedTime();
    this.running = false;
    this.autoStart = false;
  }
  getElapsedTime() {
    this.getDelta();
    return this.elapsedTime;
  }
  getDelta() {
    let diff = 0;
    if (this.autoStart && !this.running) {
      this.start();
      return 0;
    }
    if (this.running) {
      const newTime = now();
      diff = (newTime - this.oldTime) / 1e3;
      this.oldTime = newTime;
      this.elapsedTime += diff;
    }
    return diff;
  }
}
function now() {
  return performance.now();
}
const _position$1 = /* @__PURE__ */ new Vector3$1();
const _quaternion$1 = /* @__PURE__ */ new Quaternion$1();
const _scale$1 = /* @__PURE__ */ new Vector3$1();
const _orientation$1 = /* @__PURE__ */ new Vector3$1();
class AudioListener extends Object3D$1 {
  constructor() {
    super();
    this.type = "AudioListener";
    this.context = AudioContext$1.getContext();
    this.gain = this.context.createGain();
    this.gain.connect(this.context.destination);
    this.filter = null;
    this.timeDelta = 0;
    this._clock = new Clock();
  }
  getInput() {
    return this.gain;
  }
  removeFilter() {
    if (this.filter !== null) {
      this.gain.disconnect(this.filter);
      this.filter.disconnect(this.context.destination);
      this.gain.connect(this.context.destination);
      this.filter = null;
    }
    return this;
  }
  getFilter() {
    return this.filter;
  }
  setFilter(value) {
    if (this.filter !== null) {
      this.gain.disconnect(this.filter);
      this.filter.disconnect(this.context.destination);
    } else {
      this.gain.disconnect(this.context.destination);
    }
    this.filter = value;
    this.gain.connect(this.filter);
    this.filter.connect(this.context.destination);
    return this;
  }
  getMasterVolume() {
    return this.gain.gain.value;
  }
  setMasterVolume(value) {
    this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
    return this;
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    const listener = this.context.listener;
    const up = this.up;
    this.timeDelta = this._clock.getDelta();
    this.matrixWorld.decompose(_position$1, _quaternion$1, _scale$1);
    _orientation$1.set(0, 0, -1).applyQuaternion(_quaternion$1);
    if (listener.positionX) {
      const endTime = this.context.currentTime + this.timeDelta;
      listener.positionX.linearRampToValueAtTime(_position$1.x, endTime);
      listener.positionY.linearRampToValueAtTime(_position$1.y, endTime);
      listener.positionZ.linearRampToValueAtTime(_position$1.z, endTime);
      listener.forwardX.linearRampToValueAtTime(_orientation$1.x, endTime);
      listener.forwardY.linearRampToValueAtTime(_orientation$1.y, endTime);
      listener.forwardZ.linearRampToValueAtTime(_orientation$1.z, endTime);
      listener.upX.linearRampToValueAtTime(up.x, endTime);
      listener.upY.linearRampToValueAtTime(up.y, endTime);
      listener.upZ.linearRampToValueAtTime(up.z, endTime);
    } else {
      listener.setPosition(_position$1.x, _position$1.y, _position$1.z);
      listener.setOrientation(_orientation$1.x, _orientation$1.y, _orientation$1.z, up.x, up.y, up.z);
    }
  }
}
let Audio$1 = class Audio extends Object3D$1 {
  constructor(listener) {
    super();
    this.type = "Audio";
    this.listener = listener;
    this.context = listener.context;
    this.gain = this.context.createGain();
    this.gain.connect(listener.getInput());
    this.autoplay = false;
    this.buffer = null;
    this.detune = 0;
    this.loop = false;
    this.loopStart = 0;
    this.loopEnd = 0;
    this.offset = 0;
    this.duration = void 0;
    this.playbackRate = 1;
    this.isPlaying = false;
    this.hasPlaybackControl = true;
    this.source = null;
    this.sourceType = "empty";
    this._startedAt = 0;
    this._progress = 0;
    this._connected = false;
    this.filters = [];
  }
  getOutput() {
    return this.gain;
  }
  setNodeSource(audioNode) {
    this.hasPlaybackControl = false;
    this.sourceType = "audioNode";
    this.source = audioNode;
    this.connect();
    return this;
  }
  setMediaElementSource(mediaElement) {
    this.hasPlaybackControl = false;
    this.sourceType = "mediaNode";
    this.source = this.context.createMediaElementSource(mediaElement);
    this.connect();
    return this;
  }
  setMediaStreamSource(mediaStream) {
    this.hasPlaybackControl = false;
    this.sourceType = "mediaStreamNode";
    this.source = this.context.createMediaStreamSource(mediaStream);
    this.connect();
    return this;
  }
  setBuffer(audioBuffer) {
    this.buffer = audioBuffer;
    this.sourceType = "buffer";
    if (this.autoplay) this.play();
    return this;
  }
  play(delay = 0) {
    if (this.isPlaying === true) {
      console.warn("THREE.Audio: Audio is already playing.");
      return;
    }
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this._startedAt = this.context.currentTime + delay;
    const source = this.context.createBufferSource();
    source.buffer = this.buffer;
    source.loop = this.loop;
    source.loopStart = this.loopStart;
    source.loopEnd = this.loopEnd;
    source.onended = this.onEnded.bind(this);
    source.start(this._startedAt, this._progress + this.offset, this.duration);
    this.isPlaying = true;
    this.source = source;
    this.setDetune(this.detune);
    this.setPlaybackRate(this.playbackRate);
    return this.connect();
  }
  pause() {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    if (this.isPlaying === true) {
      this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
      if (this.loop === true) {
        this._progress = this._progress % (this.duration || this.buffer.duration);
      }
      this.source.stop();
      this.source.onended = null;
      this.isPlaying = false;
    }
    return this;
  }
  stop(delay = 0) {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this._progress = 0;
    if (this.source !== null) {
      this.source.stop(this.context.currentTime + delay);
      this.source.onended = null;
    }
    this.isPlaying = false;
    return this;
  }
  connect() {
    if (this.filters.length > 0) {
      this.source.connect(this.filters[0]);
      for (let i2 = 1, l2 = this.filters.length; i2 < l2; i2++) {
        this.filters[i2 - 1].connect(this.filters[i2]);
      }
      this.filters[this.filters.length - 1].connect(this.getOutput());
    } else {
      this.source.connect(this.getOutput());
    }
    this._connected = true;
    return this;
  }
  disconnect() {
    if (this._connected === false) {
      return;
    }
    if (this.filters.length > 0) {
      this.source.disconnect(this.filters[0]);
      for (let i2 = 1, l2 = this.filters.length; i2 < l2; i2++) {
        this.filters[i2 - 1].disconnect(this.filters[i2]);
      }
      this.filters[this.filters.length - 1].disconnect(this.getOutput());
    } else {
      this.source.disconnect(this.getOutput());
    }
    this._connected = false;
    return this;
  }
  getFilters() {
    return this.filters;
  }
  setFilters(value) {
    if (!value) value = [];
    if (this._connected === true) {
      this.disconnect();
      this.filters = value.slice();
      this.connect();
    } else {
      this.filters = value.slice();
    }
    return this;
  }
  setDetune(value) {
    this.detune = value;
    if (this.isPlaying === true && this.source.detune !== void 0) {
      this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
    }
    return this;
  }
  getDetune() {
    return this.detune;
  }
  getFilter() {
    return this.getFilters()[0];
  }
  setFilter(filter) {
    return this.setFilters(filter ? [filter] : []);
  }
  setPlaybackRate(value) {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this.playbackRate = value;
    if (this.isPlaying === true) {
      this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
    }
    return this;
  }
  getPlaybackRate() {
    return this.playbackRate;
  }
  onEnded() {
    this.isPlaying = false;
    this._progress = 0;
  }
  getLoop() {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return false;
    }
    return this.loop;
  }
  setLoop(value) {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this.loop = value;
    if (this.isPlaying === true) {
      this.source.loop = this.loop;
    }
    return this;
  }
  setLoopStart(value) {
    this.loopStart = value;
    return this;
  }
  setLoopEnd(value) {
    this.loopEnd = value;
    return this;
  }
  getVolume() {
    return this.gain.gain.value;
  }
  setVolume(value) {
    this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
    return this;
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    if (source.sourceType !== "buffer") {
      console.warn("THREE.Audio: Audio source type cannot be copied.");
      return this;
    }
    this.autoplay = source.autoplay;
    this.buffer = source.buffer;
    this.detune = source.detune;
    this.loop = source.loop;
    this.loopStart = source.loopStart;
    this.loopEnd = source.loopEnd;
    this.offset = source.offset;
    this.duration = source.duration;
    this.playbackRate = source.playbackRate;
    this.hasPlaybackControl = source.hasPlaybackControl;
    this.sourceType = source.sourceType;
    this.filters = source.filters.slice();
    return this;
  }
  clone(recursive) {
    return new this.constructor(this.listener).copy(this, recursive);
  }
};
const _position = /* @__PURE__ */ new Vector3$1();
const _quaternion = /* @__PURE__ */ new Quaternion$1();
const _scale = /* @__PURE__ */ new Vector3$1();
const _orientation = /* @__PURE__ */ new Vector3$1();
class PositionalAudio extends Audio$1 {
  constructor(listener) {
    super(listener);
    this.panner = this.context.createPanner();
    this.panner.panningModel = "HRTF";
    this.panner.connect(this.gain);
  }
  connect() {
    super.connect();
    this.panner.connect(this.gain);
  }
  disconnect() {
    super.disconnect();
    this.panner.disconnect(this.gain);
  }
  getOutput() {
    return this.panner;
  }
  getRefDistance() {
    return this.panner.refDistance;
  }
  setRefDistance(value) {
    this.panner.refDistance = value;
    return this;
  }
  getRolloffFactor() {
    return this.panner.rolloffFactor;
  }
  setRolloffFactor(value) {
    this.panner.rolloffFactor = value;
    return this;
  }
  getDistanceModel() {
    return this.panner.distanceModel;
  }
  setDistanceModel(value) {
    this.panner.distanceModel = value;
    return this;
  }
  getMaxDistance() {
    return this.panner.maxDistance;
  }
  setMaxDistance(value) {
    this.panner.maxDistance = value;
    return this;
  }
  setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
    this.panner.coneInnerAngle = coneInnerAngle;
    this.panner.coneOuterAngle = coneOuterAngle;
    this.panner.coneOuterGain = coneOuterGain;
    return this;
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    if (this.hasPlaybackControl === true && this.isPlaying === false) return;
    this.matrixWorld.decompose(_position, _quaternion, _scale);
    _orientation.set(0, 0, 1).applyQuaternion(_quaternion);
    const panner = this.panner;
    if (panner.positionX) {
      const endTime = this.context.currentTime + this.listener.timeDelta;
      panner.positionX.linearRampToValueAtTime(_position.x, endTime);
      panner.positionY.linearRampToValueAtTime(_position.y, endTime);
      panner.positionZ.linearRampToValueAtTime(_position.z, endTime);
      panner.orientationX.linearRampToValueAtTime(_orientation.x, endTime);
      panner.orientationY.linearRampToValueAtTime(_orientation.y, endTime);
      panner.orientationZ.linearRampToValueAtTime(_orientation.z, endTime);
    } else {
      panner.setPosition(_position.x, _position.y, _position.z);
      panner.setOrientation(_orientation.x, _orientation.y, _orientation.z);
    }
  }
}
class AudioAnalyser {
  constructor(audio, fftSize = 2048) {
    this.analyser = audio.context.createAnalyser();
    this.analyser.fftSize = fftSize;
    this.data = new Uint8Array(this.analyser.frequencyBinCount);
    audio.getOutput().connect(this.analyser);
  }
  getFrequencyData() {
    this.analyser.getByteFrequencyData(this.data);
    return this.data;
  }
  getAverageFrequency() {
    let value = 0;
    const data = this.getFrequencyData();
    for (let i2 = 0; i2 < data.length; i2++) {
      value += data[i2];
    }
    return value / data.length;
  }
}
let PropertyMixer$1 = class PropertyMixer {
  constructor(binding, typeName, valueSize) {
    this.binding = binding;
    this.valueSize = valueSize;
    let mixFunction, mixFunctionAdditive, setIdentity;
    switch (typeName) {
      case "quaternion":
        mixFunction = this._slerp;
        mixFunctionAdditive = this._slerpAdditive;
        setIdentity = this._setAdditiveIdentityQuaternion;
        this.buffer = new Float64Array(valueSize * 6);
        this._workIndex = 5;
        break;
      case "string":
      case "bool":
        mixFunction = this._select;
        mixFunctionAdditive = this._select;
        setIdentity = this._setAdditiveIdentityOther;
        this.buffer = new Array(valueSize * 5);
        break;
      default:
        mixFunction = this._lerp;
        mixFunctionAdditive = this._lerpAdditive;
        setIdentity = this._setAdditiveIdentityNumeric;
        this.buffer = new Float64Array(valueSize * 5);
    }
    this._mixBufferRegion = mixFunction;
    this._mixBufferRegionAdditive = mixFunctionAdditive;
    this._setIdentity = setIdentity;
    this._origIndex = 3;
    this._addIndex = 4;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    this.useCount = 0;
    this.referenceCount = 0;
  }
  // accumulate data in the 'incoming' region into 'accu<i>'
  accumulate(accuIndex, weight) {
    const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
    let currentWeight = this.cumulativeWeight;
    if (currentWeight === 0) {
      for (let i2 = 0; i2 !== stride; ++i2) {
        buffer[offset + i2] = buffer[i2];
      }
      currentWeight = weight;
    } else {
      currentWeight += weight;
      const mix = weight / currentWeight;
      this._mixBufferRegion(buffer, offset, 0, mix, stride);
    }
    this.cumulativeWeight = currentWeight;
  }
  // accumulate data in the 'incoming' region into 'add'
  accumulateAdditive(weight) {
    const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
    if (this.cumulativeWeightAdditive === 0) {
      this._setIdentity();
    }
    this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
    this.cumulativeWeightAdditive += weight;
  }
  // apply the state of 'accu<i>' to the binding when accus differ
  apply(accuIndex) {
    const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    if (weight < 1) {
      const originalValueOffset = stride * this._origIndex;
      this._mixBufferRegion(
        buffer,
        offset,
        originalValueOffset,
        1 - weight,
        stride
      );
    }
    if (weightAdditive > 0) {
      this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
    }
    for (let i2 = stride, e2 = stride + stride; i2 !== e2; ++i2) {
      if (buffer[i2] !== buffer[i2 + stride]) {
        binding.setValue(buffer, offset);
        break;
      }
    }
  }
  // remember the state of the bound property and copy it to both accus
  saveOriginalState() {
    const binding = this.binding;
    const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
    binding.getValue(buffer, originalValueOffset);
    for (let i2 = stride, e2 = originalValueOffset; i2 !== e2; ++i2) {
      buffer[i2] = buffer[originalValueOffset + i2 % stride];
    }
    this._setIdentity();
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
  }
  // apply the state previously taken via 'saveOriginalState' to the binding
  restoreOriginalState() {
    const originalValueOffset = this.valueSize * 3;
    this.binding.setValue(this.buffer, originalValueOffset);
  }
  _setAdditiveIdentityNumeric() {
    const startIndex = this._addIndex * this.valueSize;
    const endIndex = startIndex + this.valueSize;
    for (let i2 = startIndex; i2 < endIndex; i2++) {
      this.buffer[i2] = 0;
    }
  }
  _setAdditiveIdentityQuaternion() {
    this._setAdditiveIdentityNumeric();
    this.buffer[this._addIndex * this.valueSize + 3] = 1;
  }
  _setAdditiveIdentityOther() {
    const startIndex = this._origIndex * this.valueSize;
    const targetIndex = this._addIndex * this.valueSize;
    for (let i2 = 0; i2 < this.valueSize; i2++) {
      this.buffer[targetIndex + i2] = this.buffer[startIndex + i2];
    }
  }
  // mix functions
  _select(buffer, dstOffset, srcOffset, t3, stride) {
    if (t3 >= 0.5) {
      for (let i2 = 0; i2 !== stride; ++i2) {
        buffer[dstOffset + i2] = buffer[srcOffset + i2];
      }
    }
  }
  _slerp(buffer, dstOffset, srcOffset, t3) {
    Quaternion$1.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t3);
  }
  _slerpAdditive(buffer, dstOffset, srcOffset, t3, stride) {
    const workOffset = this._workIndex * stride;
    Quaternion$1.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
    Quaternion$1.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t3);
  }
  _lerp(buffer, dstOffset, srcOffset, t3, stride) {
    const s2 = 1 - t3;
    for (let i2 = 0; i2 !== stride; ++i2) {
      const j = dstOffset + i2;
      buffer[j] = buffer[j] * s2 + buffer[srcOffset + i2] * t3;
    }
  }
  _lerpAdditive(buffer, dstOffset, srcOffset, t3, stride) {
    for (let i2 = 0; i2 !== stride; ++i2) {
      const j = dstOffset + i2;
      buffer[j] = buffer[j] + buffer[srcOffset + i2] * t3;
    }
  }
};
const _RESERVED_CHARS_RE$1 = "\\[\\]\\.:\\/";
const _reservedRe$1 = new RegExp("[" + _RESERVED_CHARS_RE$1 + "]", "g");
const _wordChar$1 = "[^" + _RESERVED_CHARS_RE$1 + "]";
const _wordCharOrDot$1 = "[^" + _RESERVED_CHARS_RE$1.replace("\\.", "") + "]";
const _directoryRe$1 = /* @__PURE__ */ /((?:WC+[\/:])*)/.source.replace("WC", _wordChar$1);
const _nodeRe$1 = /* @__PURE__ */ /(WCOD+)?/.source.replace("WCOD", _wordCharOrDot$1);
const _objectRe$1 = /* @__PURE__ */ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", _wordChar$1);
const _propertyRe$1 = /* @__PURE__ */ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", _wordChar$1);
const _trackRe$1 = new RegExp(
  "^" + _directoryRe$1 + _nodeRe$1 + _objectRe$1 + _propertyRe$1 + "$"
);
const _supportedObjectNames$1 = ["material", "materials", "bones", "map"];
let Composite$1 = class Composite {
  constructor(targetGroup, path, optionalParsedPath) {
    const parsedPath = optionalParsedPath || PropertyBinding$1.parseTrackName(path);
    this._targetGroup = targetGroup;
    this._bindings = targetGroup.subscribe_(path, parsedPath);
  }
  getValue(array, offset) {
    this.bind();
    const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
    if (binding !== void 0) binding.getValue(array, offset);
  }
  setValue(array, offset) {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].setValue(array, offset);
    }
  }
  bind() {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].bind();
    }
  }
  unbind() {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].unbind();
    }
  }
};
let PropertyBinding$1 = class PropertyBinding {
  constructor(rootNode, path, parsedPath) {
    this.path = path;
    this.parsedPath = parsedPath || PropertyBinding.parseTrackName(path);
    this.node = PropertyBinding.findNode(rootNode, this.parsedPath.nodeName);
    this.rootNode = rootNode;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
  static create(root, path, parsedPath) {
    if (!(root && root.isAnimationObjectGroup)) {
      return new PropertyBinding(root, path, parsedPath);
    } else {
      return new PropertyBinding.Composite(root, path, parsedPath);
    }
  }
  /**
   * Replaces spaces with underscores and removes unsupported characters from
   * node names, to ensure compatibility with parseTrackName().
   *
   * @param {string} name Node name to be sanitized.
   * @return {string}
   */
  static sanitizeNodeName(name) {
    return name.replace(/\s/g, "_").replace(_reservedRe$1, "");
  }
  static parseTrackName(trackName) {
    const matches = _trackRe$1.exec(trackName);
    if (matches === null) {
      throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
    }
    const results = {
      // directoryName: matches[ 1 ], // (tschw) currently unused
      nodeName: matches[2],
      objectName: matches[3],
      objectIndex: matches[4],
      propertyName: matches[5],
      // required
      propertyIndex: matches[6]
    };
    const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
    if (lastDot !== void 0 && lastDot !== -1) {
      const objectName = results.nodeName.substring(lastDot + 1);
      if (_supportedObjectNames$1.indexOf(objectName) !== -1) {
        results.nodeName = results.nodeName.substring(0, lastDot);
        results.objectName = objectName;
      }
    }
    if (results.propertyName === null || results.propertyName.length === 0) {
      throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
    }
    return results;
  }
  static findNode(root, nodeName) {
    if (nodeName === void 0 || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) {
      return root;
    }
    if (root.skeleton) {
      const bone = root.skeleton.getBoneByName(nodeName);
      if (bone !== void 0) {
        return bone;
      }
    }
    if (root.children) {
      const searchNodeSubtree = function(children) {
        for (let i2 = 0; i2 < children.length; i2++) {
          const childNode = children[i2];
          if (childNode.name === nodeName || childNode.uuid === nodeName) {
            return childNode;
          }
          const result = searchNodeSubtree(childNode.children);
          if (result) return result;
        }
        return null;
      };
      const subTreeNode = searchNodeSubtree(root.children);
      if (subTreeNode) {
        return subTreeNode;
      }
    }
    return null;
  }
  // these are used to "bind" a nonexistent property
  _getValue_unavailable() {
  }
  _setValue_unavailable() {
  }
  // Getters
  _getValue_direct(buffer, offset) {
    buffer[offset] = this.targetObject[this.propertyName];
  }
  _getValue_array(buffer, offset) {
    const source = this.resolvedProperty;
    for (let i2 = 0, n2 = source.length; i2 !== n2; ++i2) {
      buffer[offset++] = source[i2];
    }
  }
  _getValue_arrayElement(buffer, offset) {
    buffer[offset] = this.resolvedProperty[this.propertyIndex];
  }
  _getValue_toArray(buffer, offset) {
    this.resolvedProperty.toArray(buffer, offset);
  }
  // Direct
  _setValue_direct(buffer, offset) {
    this.targetObject[this.propertyName] = buffer[offset];
  }
  _setValue_direct_setNeedsUpdate(buffer, offset) {
    this.targetObject[this.propertyName] = buffer[offset];
    this.targetObject.needsUpdate = true;
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
    this.targetObject[this.propertyName] = buffer[offset];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // EntireArray
  _setValue_array(buffer, offset) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer[offset++];
    }
  }
  _setValue_array_setNeedsUpdate(buffer, offset) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer[offset++];
    }
    this.targetObject.needsUpdate = true;
  }
  _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer[offset++];
    }
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // ArrayElement
  _setValue_arrayElement(buffer, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset];
  }
  _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset];
    this.targetObject.needsUpdate = true;
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // HasToFromArray
  _setValue_fromArray(buffer, offset) {
    this.resolvedProperty.fromArray(buffer, offset);
  }
  _setValue_fromArray_setNeedsUpdate(buffer, offset) {
    this.resolvedProperty.fromArray(buffer, offset);
    this.targetObject.needsUpdate = true;
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
    this.resolvedProperty.fromArray(buffer, offset);
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  _getValue_unbound(targetArray, offset) {
    this.bind();
    this.getValue(targetArray, offset);
  }
  _setValue_unbound(sourceArray, offset) {
    this.bind();
    this.setValue(sourceArray, offset);
  }
  // create getter / setter pair for a property in the scene graph
  bind() {
    let targetObject = this.node;
    const parsedPath = this.parsedPath;
    const objectName = parsedPath.objectName;
    const propertyName = parsedPath.propertyName;
    let propertyIndex = parsedPath.propertyIndex;
    if (!targetObject) {
      targetObject = PropertyBinding.findNode(this.rootNode, parsedPath.nodeName);
      this.node = targetObject;
    }
    this.getValue = this._getValue_unavailable;
    this.setValue = this._setValue_unavailable;
    if (!targetObject) {
      console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
      return;
    }
    if (objectName) {
      let objectIndex = parsedPath.objectIndex;
      switch (objectName) {
        case "materials":
          if (!targetObject.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!targetObject.material.materials) {
            console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
            return;
          }
          targetObject = targetObject.material.materials;
          break;
        case "bones":
          if (!targetObject.skeleton) {
            console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
            return;
          }
          targetObject = targetObject.skeleton.bones;
          for (let i2 = 0; i2 < targetObject.length; i2++) {
            if (targetObject[i2].name === objectIndex) {
              objectIndex = i2;
              break;
            }
          }
          break;
        case "map":
          if ("map" in targetObject) {
            targetObject = targetObject.map;
            break;
          }
          if (!targetObject.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!targetObject.material.map) {
            console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
            return;
          }
          targetObject = targetObject.material.map;
          break;
        default:
          if (targetObject[objectName] === void 0) {
            console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
            return;
          }
          targetObject = targetObject[objectName];
      }
      if (objectIndex !== void 0) {
        if (targetObject[objectIndex] === void 0) {
          console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
          return;
        }
        targetObject = targetObject[objectIndex];
      }
    }
    const nodeProperty = targetObject[propertyName];
    if (nodeProperty === void 0) {
      const nodeName = parsedPath.nodeName;
      console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
      return;
    }
    let versioning = this.Versioning.None;
    this.targetObject = targetObject;
    if (targetObject.needsUpdate !== void 0) {
      versioning = this.Versioning.NeedsUpdate;
    } else if (targetObject.matrixWorldNeedsUpdate !== void 0) {
      versioning = this.Versioning.MatrixWorldNeedsUpdate;
    }
    let bindingType = this.BindingType.Direct;
    if (propertyIndex !== void 0) {
      if (propertyName === "morphTargetInfluences") {
        if (!targetObject.geometry) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
          return;
        }
        if (!targetObject.geometry.morphAttributes) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
          return;
        }
        if (targetObject.morphTargetDictionary[propertyIndex] !== void 0) {
          propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
        }
      }
      bindingType = this.BindingType.ArrayElement;
      this.resolvedProperty = nodeProperty;
      this.propertyIndex = propertyIndex;
    } else if (nodeProperty.fromArray !== void 0 && nodeProperty.toArray !== void 0) {
      bindingType = this.BindingType.HasFromToArray;
      this.resolvedProperty = nodeProperty;
    } else if (Array.isArray(nodeProperty)) {
      bindingType = this.BindingType.EntireArray;
      this.resolvedProperty = nodeProperty;
    } else {
      this.propertyName = propertyName;
    }
    this.getValue = this.GetterByBindingType[bindingType];
    this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
  }
  unbind() {
    this.node = null;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
};
PropertyBinding$1.Composite = Composite$1;
PropertyBinding$1.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
};
PropertyBinding$1.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
};
PropertyBinding$1.prototype.GetterByBindingType = [
  PropertyBinding$1.prototype._getValue_direct,
  PropertyBinding$1.prototype._getValue_array,
  PropertyBinding$1.prototype._getValue_arrayElement,
  PropertyBinding$1.prototype._getValue_toArray
];
PropertyBinding$1.prototype.SetterByBindingTypeAndVersioning = [
  [
    // Direct
    PropertyBinding$1.prototype._setValue_direct,
    PropertyBinding$1.prototype._setValue_direct_setNeedsUpdate,
    PropertyBinding$1.prototype._setValue_direct_setMatrixWorldNeedsUpdate
  ],
  [
    // EntireArray
    PropertyBinding$1.prototype._setValue_array,
    PropertyBinding$1.prototype._setValue_array_setNeedsUpdate,
    PropertyBinding$1.prototype._setValue_array_setMatrixWorldNeedsUpdate
  ],
  [
    // ArrayElement
    PropertyBinding$1.prototype._setValue_arrayElement,
    PropertyBinding$1.prototype._setValue_arrayElement_setNeedsUpdate,
    PropertyBinding$1.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
  ],
  [
    // HasToFromArray
    PropertyBinding$1.prototype._setValue_fromArray,
    PropertyBinding$1.prototype._setValue_fromArray_setNeedsUpdate,
    PropertyBinding$1.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
  ]
];
class AnimationObjectGroup {
  constructor() {
    this.isAnimationObjectGroup = true;
    this.uuid = generateUUID$1();
    this._objects = Array.prototype.slice.call(arguments);
    this.nCachedObjects_ = 0;
    const indices = {};
    this._indicesByUUID = indices;
    for (let i2 = 0, n2 = arguments.length; i2 !== n2; ++i2) {
      indices[arguments[i2].uuid] = i2;
    }
    this._paths = [];
    this._parsedPaths = [];
    this._bindings = [];
    this._bindingsIndicesByPath = {};
    const scope = this;
    this.stats = {
      objects: {
        get total() {
          return scope._objects.length;
        },
        get inUse() {
          return this.total - scope.nCachedObjects_;
        }
      },
      get bindingsPerObject() {
        return scope._bindings.length;
      }
    };
  }
  add() {
    const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
    let knownObject = void 0, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
    for (let i2 = 0, n2 = arguments.length; i2 !== n2; ++i2) {
      const object = arguments[i2], uuid = object.uuid;
      let index2 = indicesByUUID[uuid];
      if (index2 === void 0) {
        index2 = nObjects++;
        indicesByUUID[uuid] = index2;
        objects.push(object);
        for (let j = 0, m = nBindings; j !== m; ++j) {
          bindings[j].push(new PropertyBinding$1(object, paths[j], parsedPaths[j]));
        }
      } else if (index2 < nCachedObjects) {
        knownObject = objects[index2];
        const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
        indicesByUUID[lastCachedObject.uuid] = index2;
        objects[index2] = lastCachedObject;
        indicesByUUID[uuid] = firstActiveIndex;
        objects[firstActiveIndex] = object;
        for (let j = 0, m = nBindings; j !== m; ++j) {
          const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
          let binding = bindingsForPath[index2];
          bindingsForPath[index2] = lastCached;
          if (binding === void 0) {
            binding = new PropertyBinding$1(object, paths[j], parsedPaths[j]);
          }
          bindingsForPath[firstActiveIndex] = binding;
        }
      } else if (objects[index2] !== knownObject) {
        console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
      }
    }
    this.nCachedObjects_ = nCachedObjects;
  }
  remove() {
    const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
    let nCachedObjects = this.nCachedObjects_;
    for (let i2 = 0, n2 = arguments.length; i2 !== n2; ++i2) {
      const object = arguments[i2], uuid = object.uuid, index2 = indicesByUUID[uuid];
      if (index2 !== void 0 && index2 >= nCachedObjects) {
        const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
        indicesByUUID[firstActiveObject.uuid] = index2;
        objects[index2] = firstActiveObject;
        indicesByUUID[uuid] = lastCachedIndex;
        objects[lastCachedIndex] = object;
        for (let j = 0, m = nBindings; j !== m; ++j) {
          const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index2];
          bindingsForPath[index2] = firstActive;
          bindingsForPath[lastCachedIndex] = binding;
        }
      }
    }
    this.nCachedObjects_ = nCachedObjects;
  }
  // remove & forget
  uncache() {
    const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
    let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
    for (let i2 = 0, n2 = arguments.length; i2 !== n2; ++i2) {
      const object = arguments[i2], uuid = object.uuid, index2 = indicesByUUID[uuid];
      if (index2 !== void 0) {
        delete indicesByUUID[uuid];
        if (index2 < nCachedObjects) {
          const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
          indicesByUUID[lastCachedObject.uuid] = index2;
          objects[index2] = lastCachedObject;
          indicesByUUID[lastObject.uuid] = firstActiveIndex;
          objects[firstActiveIndex] = lastObject;
          objects.pop();
          for (let j = 0, m = nBindings; j !== m; ++j) {
            const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
            bindingsForPath[index2] = lastCached;
            bindingsForPath[firstActiveIndex] = last;
            bindingsForPath.pop();
          }
        } else {
          const lastIndex = --nObjects, lastObject = objects[lastIndex];
          if (lastIndex > 0) {
            indicesByUUID[lastObject.uuid] = index2;
          }
          objects[index2] = lastObject;
          objects.pop();
          for (let j = 0, m = nBindings; j !== m; ++j) {
            const bindingsForPath = bindings[j];
            bindingsForPath[index2] = bindingsForPath[lastIndex];
            bindingsForPath.pop();
          }
        }
      }
    }
    this.nCachedObjects_ = nCachedObjects;
  }
  // Internal interface used by befriended PropertyBinding.Composite:
  subscribe_(path, parsedPath) {
    const indicesByPath = this._bindingsIndicesByPath;
    let index2 = indicesByPath[path];
    const bindings = this._bindings;
    if (index2 !== void 0) return bindings[index2];
    const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
    index2 = bindings.length;
    indicesByPath[path] = index2;
    paths.push(path);
    parsedPaths.push(parsedPath);
    bindings.push(bindingsForPath);
    for (let i2 = nCachedObjects, n2 = objects.length; i2 !== n2; ++i2) {
      const object = objects[i2];
      bindingsForPath[i2] = new PropertyBinding$1(object, path, parsedPath);
    }
    return bindingsForPath;
  }
  unsubscribe_(path) {
    const indicesByPath = this._bindingsIndicesByPath, index2 = indicesByPath[path];
    if (index2 !== void 0) {
      const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
      indicesByPath[lastBindingsPath] = index2;
      bindings[index2] = lastBindings;
      bindings.pop();
      parsedPaths[index2] = parsedPaths[lastBindingsIndex];
      parsedPaths.pop();
      paths[index2] = paths[lastBindingsIndex];
      paths.pop();
    }
  }
}
let AnimationAction$1 = class AnimationAction {
  constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode) {
    this._mixer = mixer;
    this._clip = clip;
    this._localRoot = localRoot;
    this.blendMode = blendMode;
    const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
    const interpolantSettings = {
      endingStart: ZeroCurvatureEnding$1,
      endingEnd: ZeroCurvatureEnding$1
    };
    for (let i2 = 0; i2 !== nTracks; ++i2) {
      const interpolant = tracks[i2].createInterpolant(null);
      interpolants[i2] = interpolant;
      interpolant.settings = interpolantSettings;
    }
    this._interpolantSettings = interpolantSettings;
    this._interpolants = interpolants;
    this._propertyBindings = new Array(nTracks);
    this._cacheIndex = null;
    this._byClipCacheIndex = null;
    this._timeScaleInterpolant = null;
    this._weightInterpolant = null;
    this.loop = LoopRepeat$1;
    this._loopCount = -1;
    this._startTime = null;
    this.time = 0;
    this.timeScale = 1;
    this._effectiveTimeScale = 1;
    this.weight = 1;
    this._effectiveWeight = 1;
    this.repetitions = Infinity;
    this.paused = false;
    this.enabled = true;
    this.clampWhenFinished = false;
    this.zeroSlopeAtStart = true;
    this.zeroSlopeAtEnd = true;
  }
  // State & Scheduling
  play() {
    this._mixer._activateAction(this);
    return this;
  }
  stop() {
    this._mixer._deactivateAction(this);
    return this.reset();
  }
  reset() {
    this.paused = false;
    this.enabled = true;
    this.time = 0;
    this._loopCount = -1;
    this._startTime = null;
    return this.stopFading().stopWarping();
  }
  isRunning() {
    return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
  }
  // return true when play has been called
  isScheduled() {
    return this._mixer._isActiveAction(this);
  }
  startAt(time2) {
    this._startTime = time2;
    return this;
  }
  setLoop(mode, repetitions) {
    this.loop = mode;
    this.repetitions = repetitions;
    return this;
  }
  // Weight
  // set the weight stopping any scheduled fading
  // although .enabled = false yields an effective weight of zero, this
  // method does *not* change .enabled, because it would be confusing
  setEffectiveWeight(weight) {
    this.weight = weight;
    this._effectiveWeight = this.enabled ? weight : 0;
    return this.stopFading();
  }
  // return the weight considering fading and .enabled
  getEffectiveWeight() {
    return this._effectiveWeight;
  }
  fadeIn(duration2) {
    return this._scheduleFading(duration2, 0, 1);
  }
  fadeOut(duration2) {
    return this._scheduleFading(duration2, 1, 0);
  }
  crossFadeFrom(fadeOutAction, duration2, warp) {
    fadeOutAction.fadeOut(duration2);
    this.fadeIn(duration2);
    if (warp) {
      const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
      fadeOutAction.warp(1, startEndRatio, duration2);
      this.warp(endStartRatio, 1, duration2);
    }
    return this;
  }
  crossFadeTo(fadeInAction, duration2, warp) {
    return fadeInAction.crossFadeFrom(this, duration2, warp);
  }
  stopFading() {
    const weightInterpolant = this._weightInterpolant;
    if (weightInterpolant !== null) {
      this._weightInterpolant = null;
      this._mixer._takeBackControlInterpolant(weightInterpolant);
    }
    return this;
  }
  // Time Scale Control
  // set the time scale stopping any scheduled warping
  // although .paused = true yields an effective time scale of zero, this
  // method does *not* change .paused, because it would be confusing
  setEffectiveTimeScale(timeScale) {
    this.timeScale = timeScale;
    this._effectiveTimeScale = this.paused ? 0 : timeScale;
    return this.stopWarping();
  }
  // return the time scale considering warping and .paused
  getEffectiveTimeScale() {
    return this._effectiveTimeScale;
  }
  setDuration(duration2) {
    this.timeScale = this._clip.duration / duration2;
    return this.stopWarping();
  }
  syncWith(action) {
    this.time = action.time;
    this.timeScale = action.timeScale;
    return this.stopWarping();
  }
  halt(duration2) {
    return this.warp(this._effectiveTimeScale, 0, duration2);
  }
  warp(startTimeScale, endTimeScale, duration2) {
    const mixer = this._mixer, now2 = mixer.time, timeScale = this.timeScale;
    let interpolant = this._timeScaleInterpolant;
    if (interpolant === null) {
      interpolant = mixer._lendControlInterpolant();
      this._timeScaleInterpolant = interpolant;
    }
    const times2 = interpolant.parameterPositions, values = interpolant.sampleValues;
    times2[0] = now2;
    times2[1] = now2 + duration2;
    values[0] = startTimeScale / timeScale;
    values[1] = endTimeScale / timeScale;
    return this;
  }
  stopWarping() {
    const timeScaleInterpolant = this._timeScaleInterpolant;
    if (timeScaleInterpolant !== null) {
      this._timeScaleInterpolant = null;
      this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
    }
    return this;
  }
  // Object Accessors
  getMixer() {
    return this._mixer;
  }
  getClip() {
    return this._clip;
  }
  getRoot() {
    return this._localRoot || this._mixer._root;
  }
  // Interna
  _update(time2, deltaTime, timeDirection, accuIndex) {
    if (!this.enabled) {
      this._updateWeight(time2);
      return;
    }
    const startTime = this._startTime;
    if (startTime !== null) {
      const timeRunning = (time2 - startTime) * timeDirection;
      if (timeRunning < 0 || timeDirection === 0) {
        deltaTime = 0;
      } else {
        this._startTime = null;
        deltaTime = timeDirection * timeRunning;
      }
    }
    deltaTime *= this._updateTimeScale(time2);
    const clipTime = this._updateTime(deltaTime);
    const weight = this._updateWeight(time2);
    if (weight > 0) {
      const interpolants = this._interpolants;
      const propertyMixers = this._propertyBindings;
      switch (this.blendMode) {
        case AdditiveAnimationBlendMode$1:
          for (let j = 0, m = interpolants.length; j !== m; ++j) {
            interpolants[j].evaluate(clipTime);
            propertyMixers[j].accumulateAdditive(weight);
          }
          break;
        case NormalAnimationBlendMode$1:
        default:
          for (let j = 0, m = interpolants.length; j !== m; ++j) {
            interpolants[j].evaluate(clipTime);
            propertyMixers[j].accumulate(accuIndex, weight);
          }
      }
    }
  }
  _updateWeight(time2) {
    let weight = 0;
    if (this.enabled) {
      weight = this.weight;
      const interpolant = this._weightInterpolant;
      if (interpolant !== null) {
        const interpolantValue = interpolant.evaluate(time2)[0];
        weight *= interpolantValue;
        if (time2 > interpolant.parameterPositions[1]) {
          this.stopFading();
          if (interpolantValue === 0) {
            this.enabled = false;
          }
        }
      }
    }
    this._effectiveWeight = weight;
    return weight;
  }
  _updateTimeScale(time2) {
    let timeScale = 0;
    if (!this.paused) {
      timeScale = this.timeScale;
      const interpolant = this._timeScaleInterpolant;
      if (interpolant !== null) {
        const interpolantValue = interpolant.evaluate(time2)[0];
        timeScale *= interpolantValue;
        if (time2 > interpolant.parameterPositions[1]) {
          this.stopWarping();
          if (timeScale === 0) {
            this.paused = true;
          } else {
            this.timeScale = timeScale;
          }
        }
      }
    }
    this._effectiveTimeScale = timeScale;
    return timeScale;
  }
  _updateTime(deltaTime) {
    const duration2 = this._clip.duration;
    const loop = this.loop;
    let time2 = this.time + deltaTime;
    let loopCount = this._loopCount;
    const pingPong = loop === LoopPingPong$1;
    if (deltaTime === 0) {
      if (loopCount === -1) return time2;
      return pingPong && (loopCount & 1) === 1 ? duration2 - time2 : time2;
    }
    if (loop === LoopOnce$1) {
      if (loopCount === -1) {
        this._loopCount = 0;
        this._setEndings(true, true, false);
      }
      handle_stop: {
        if (time2 >= duration2) {
          time2 = duration2;
        } else if (time2 < 0) {
          time2 = 0;
        } else {
          this.time = time2;
          break handle_stop;
        }
        if (this.clampWhenFinished) this.paused = true;
        else this.enabled = false;
        this.time = time2;
        this._mixer.dispatchEvent({
          type: "finished",
          action: this,
          direction: deltaTime < 0 ? -1 : 1
        });
      }
    } else {
      if (loopCount === -1) {
        if (deltaTime >= 0) {
          loopCount = 0;
          this._setEndings(true, this.repetitions === 0, pingPong);
        } else {
          this._setEndings(this.repetitions === 0, true, pingPong);
        }
      }
      if (time2 >= duration2 || time2 < 0) {
        const loopDelta = Math.floor(time2 / duration2);
        time2 -= duration2 * loopDelta;
        loopCount += Math.abs(loopDelta);
        const pending = this.repetitions - loopCount;
        if (pending <= 0) {
          if (this.clampWhenFinished) this.paused = true;
          else this.enabled = false;
          time2 = deltaTime > 0 ? duration2 : 0;
          this.time = time2;
          this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: deltaTime > 0 ? 1 : -1
          });
        } else {
          if (pending === 1) {
            const atStart = deltaTime < 0;
            this._setEndings(atStart, !atStart, pingPong);
          } else {
            this._setEndings(false, false, pingPong);
          }
          this._loopCount = loopCount;
          this.time = time2;
          this._mixer.dispatchEvent({
            type: "loop",
            action: this,
            loopDelta
          });
        }
      } else {
        this.time = time2;
      }
      if (pingPong && (loopCount & 1) === 1) {
        return duration2 - time2;
      }
    }
    return time2;
  }
  _setEndings(atStart, atEnd, pingPong) {
    const settings = this._interpolantSettings;
    if (pingPong) {
      settings.endingStart = ZeroSlopeEnding$1;
      settings.endingEnd = ZeroSlopeEnding$1;
    } else {
      if (atStart) {
        settings.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding$1 : ZeroCurvatureEnding$1;
      } else {
        settings.endingStart = WrapAroundEnding$1;
      }
      if (atEnd) {
        settings.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding$1 : ZeroCurvatureEnding$1;
      } else {
        settings.endingEnd = WrapAroundEnding$1;
      }
    }
  }
  _scheduleFading(duration2, weightNow, weightThen) {
    const mixer = this._mixer, now2 = mixer.time;
    let interpolant = this._weightInterpolant;
    if (interpolant === null) {
      interpolant = mixer._lendControlInterpolant();
      this._weightInterpolant = interpolant;
    }
    const times2 = interpolant.parameterPositions, values = interpolant.sampleValues;
    times2[0] = now2;
    values[0] = weightNow;
    times2[1] = now2 + duration2;
    values[1] = weightThen;
    return this;
  }
};
const _controlInterpolantsResultBuffer = new Float32Array(1);
let AnimationMixer$1 = class AnimationMixer extends EventDispatcher$1 {
  constructor(root) {
    super();
    this._root = root;
    this._initMemoryManager();
    this._accuIndex = 0;
    this.time = 0;
    this.timeScale = 1;
  }
  _bindAction(action, prototypeAction) {
    const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
    let bindingsByName = bindingsByRoot[rootUuid];
    if (bindingsByName === void 0) {
      bindingsByName = {};
      bindingsByRoot[rootUuid] = bindingsByName;
    }
    for (let i2 = 0; i2 !== nTracks; ++i2) {
      const track = tracks[i2], trackName = track.name;
      let binding = bindingsByName[trackName];
      if (binding !== void 0) {
        ++binding.referenceCount;
        bindings[i2] = binding;
      } else {
        binding = bindings[i2];
        if (binding !== void 0) {
          if (binding._cacheIndex === null) {
            ++binding.referenceCount;
            this._addInactiveBinding(binding, rootUuid, trackName);
          }
          continue;
        }
        const path = prototypeAction && prototypeAction._propertyBindings[i2].binding.parsedPath;
        binding = new PropertyMixer$1(
          PropertyBinding$1.create(root, trackName, path),
          track.ValueTypeName,
          track.getValueSize()
        );
        ++binding.referenceCount;
        this._addInactiveBinding(binding, rootUuid, trackName);
        bindings[i2] = binding;
      }
      interpolants[i2].resultBuffer = binding.buffer;
    }
  }
  _activateAction(action) {
    if (!this._isActiveAction(action)) {
      if (action._cacheIndex === null) {
        const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
        this._bindAction(
          action,
          actionsForClip && actionsForClip.knownActions[0]
        );
        this._addInactiveAction(action, clipUuid, rootUuid);
      }
      const bindings = action._propertyBindings;
      for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
        const binding = bindings[i2];
        if (binding.useCount++ === 0) {
          this._lendBinding(binding);
          binding.saveOriginalState();
        }
      }
      this._lendAction(action);
    }
  }
  _deactivateAction(action) {
    if (this._isActiveAction(action)) {
      const bindings = action._propertyBindings;
      for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
        const binding = bindings[i2];
        if (--binding.useCount === 0) {
          binding.restoreOriginalState();
          this._takeBackBinding(binding);
        }
      }
      this._takeBackAction(action);
    }
  }
  // Memory manager
  _initMemoryManager() {
    this._actions = [];
    this._nActiveActions = 0;
    this._actionsByClip = {};
    this._bindings = [];
    this._nActiveBindings = 0;
    this._bindingsByRootAndName = {};
    this._controlInterpolants = [];
    this._nActiveControlInterpolants = 0;
    const scope = this;
    this.stats = {
      actions: {
        get total() {
          return scope._actions.length;
        },
        get inUse() {
          return scope._nActiveActions;
        }
      },
      bindings: {
        get total() {
          return scope._bindings.length;
        },
        get inUse() {
          return scope._nActiveBindings;
        }
      },
      controlInterpolants: {
        get total() {
          return scope._controlInterpolants.length;
        },
        get inUse() {
          return scope._nActiveControlInterpolants;
        }
      }
    };
  }
  // Memory management for AnimationAction objects
  _isActiveAction(action) {
    const index2 = action._cacheIndex;
    return index2 !== null && index2 < this._nActiveActions;
  }
  _addInactiveAction(action, clipUuid, rootUuid) {
    const actions = this._actions, actionsByClip = this._actionsByClip;
    let actionsForClip = actionsByClip[clipUuid];
    if (actionsForClip === void 0) {
      actionsForClip = {
        knownActions: [action],
        actionByRoot: {}
      };
      action._byClipCacheIndex = 0;
      actionsByClip[clipUuid] = actionsForClip;
    } else {
      const knownActions = actionsForClip.knownActions;
      action._byClipCacheIndex = knownActions.length;
      knownActions.push(action);
    }
    action._cacheIndex = actions.length;
    actions.push(action);
    actionsForClip.actionByRoot[rootUuid] = action;
  }
  _removeInactiveAction(action) {
    const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
    lastInactiveAction._cacheIndex = cacheIndex;
    actions[cacheIndex] = lastInactiveAction;
    actions.pop();
    action._cacheIndex = null;
    const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
    lastKnownAction._byClipCacheIndex = byClipCacheIndex;
    knownActionsForClip[byClipCacheIndex] = lastKnownAction;
    knownActionsForClip.pop();
    action._byClipCacheIndex = null;
    const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
    delete actionByRoot[rootUuid];
    if (knownActionsForClip.length === 0) {
      delete actionsByClip[clipUuid];
    }
    this._removeInactiveBindingsForAction(action);
  }
  _removeInactiveBindingsForAction(action) {
    const bindings = action._propertyBindings;
    for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
      const binding = bindings[i2];
      if (--binding.referenceCount === 0) {
        this._removeInactiveBinding(binding);
      }
    }
  }
  _lendAction(action) {
    const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
    action._cacheIndex = lastActiveIndex;
    actions[lastActiveIndex] = action;
    firstInactiveAction._cacheIndex = prevIndex;
    actions[prevIndex] = firstInactiveAction;
  }
  _takeBackAction(action) {
    const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
    action._cacheIndex = firstInactiveIndex;
    actions[firstInactiveIndex] = action;
    lastActiveAction._cacheIndex = prevIndex;
    actions[prevIndex] = lastActiveAction;
  }
  // Memory management for PropertyMixer objects
  _addInactiveBinding(binding, rootUuid, trackName) {
    const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
    let bindingByName = bindingsByRoot[rootUuid];
    if (bindingByName === void 0) {
      bindingByName = {};
      bindingsByRoot[rootUuid] = bindingByName;
    }
    bindingByName[trackName] = binding;
    binding._cacheIndex = bindings.length;
    bindings.push(binding);
  }
  _removeInactiveBinding(binding) {
    const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
    lastInactiveBinding._cacheIndex = cacheIndex;
    bindings[cacheIndex] = lastInactiveBinding;
    bindings.pop();
    delete bindingByName[trackName];
    if (Object.keys(bindingByName).length === 0) {
      delete bindingsByRoot[rootUuid];
    }
  }
  _lendBinding(binding) {
    const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
    binding._cacheIndex = lastActiveIndex;
    bindings[lastActiveIndex] = binding;
    firstInactiveBinding._cacheIndex = prevIndex;
    bindings[prevIndex] = firstInactiveBinding;
  }
  _takeBackBinding(binding) {
    const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
    binding._cacheIndex = firstInactiveIndex;
    bindings[firstInactiveIndex] = binding;
    lastActiveBinding._cacheIndex = prevIndex;
    bindings[prevIndex] = lastActiveBinding;
  }
  // Memory management of Interpolants for weight and time scale
  _lendControlInterpolant() {
    const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
    let interpolant = interpolants[lastActiveIndex];
    if (interpolant === void 0) {
      interpolant = new LinearInterpolant$1(
        new Float32Array(2),
        new Float32Array(2),
        1,
        _controlInterpolantsResultBuffer
      );
      interpolant.__cacheIndex = lastActiveIndex;
      interpolants[lastActiveIndex] = interpolant;
    }
    return interpolant;
  }
  _takeBackControlInterpolant(interpolant) {
    const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
    interpolant.__cacheIndex = firstInactiveIndex;
    interpolants[firstInactiveIndex] = interpolant;
    lastActiveInterpolant.__cacheIndex = prevIndex;
    interpolants[prevIndex] = lastActiveInterpolant;
  }
  // return an action for a clip optionally using a custom root target
  // object (this method allocates a lot of dynamic memory in case a
  // previously unknown clip/root combination is specified)
  clipAction(clip, optionalRoot, blendMode) {
    const root = optionalRoot || this._root, rootUuid = root.uuid;
    let clipObject = typeof clip === "string" ? AnimationClip$1.findByName(root, clip) : clip;
    const clipUuid = clipObject !== null ? clipObject.uuid : clip;
    const actionsForClip = this._actionsByClip[clipUuid];
    let prototypeAction = null;
    if (blendMode === void 0) {
      if (clipObject !== null) {
        blendMode = clipObject.blendMode;
      } else {
        blendMode = NormalAnimationBlendMode$1;
      }
    }
    if (actionsForClip !== void 0) {
      const existingAction = actionsForClip.actionByRoot[rootUuid];
      if (existingAction !== void 0 && existingAction.blendMode === blendMode) {
        return existingAction;
      }
      prototypeAction = actionsForClip.knownActions[0];
      if (clipObject === null)
        clipObject = prototypeAction._clip;
    }
    if (clipObject === null) return null;
    const newAction = new AnimationAction$1(this, clipObject, optionalRoot, blendMode);
    this._bindAction(newAction, prototypeAction);
    this._addInactiveAction(newAction, clipUuid, rootUuid);
    return newAction;
  }
  // get an existing action
  existingAction(clip, optionalRoot) {
    const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? AnimationClip$1.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
    if (actionsForClip !== void 0) {
      return actionsForClip.actionByRoot[rootUuid] || null;
    }
    return null;
  }
  // deactivates all previously scheduled actions
  stopAllAction() {
    const actions = this._actions, nActions = this._nActiveActions;
    for (let i2 = nActions - 1; i2 >= 0; --i2) {
      actions[i2].stop();
    }
    return this;
  }
  // advance the time and update apply the animation
  update(deltaTime) {
    deltaTime *= this.timeScale;
    const actions = this._actions, nActions = this._nActiveActions, time2 = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
    for (let i2 = 0; i2 !== nActions; ++i2) {
      const action = actions[i2];
      action._update(time2, deltaTime, timeDirection, accuIndex);
    }
    const bindings = this._bindings, nBindings = this._nActiveBindings;
    for (let i2 = 0; i2 !== nBindings; ++i2) {
      bindings[i2].apply(accuIndex);
    }
    return this;
  }
  // Allows you to seek to a specific time in an animation.
  setTime(timeInSeconds) {
    this.time = 0;
    for (let i2 = 0; i2 < this._actions.length; i2++) {
      this._actions[i2].time = 0;
    }
    return this.update(timeInSeconds);
  }
  // return this mixer's root target object
  getRoot() {
    return this._root;
  }
  // free all resources specific to a particular clip
  uncacheClip(clip) {
    const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
    if (actionsForClip !== void 0) {
      const actionsToRemove = actionsForClip.knownActions;
      for (let i2 = 0, n2 = actionsToRemove.length; i2 !== n2; ++i2) {
        const action = actionsToRemove[i2];
        this._deactivateAction(action);
        const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
        action._cacheIndex = null;
        action._byClipCacheIndex = null;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        this._removeInactiveBindingsForAction(action);
      }
      delete actionsByClip[clipUuid];
    }
  }
  // free all resources specific to a particular root target object
  uncacheRoot(root) {
    const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
    for (const clipUuid in actionsByClip) {
      const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
      if (action !== void 0) {
        this._deactivateAction(action);
        this._removeInactiveAction(action);
      }
    }
    const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
    if (bindingByName !== void 0) {
      for (const trackName in bindingByName) {
        const binding = bindingByName[trackName];
        binding.restoreOriginalState();
        this._removeInactiveBinding(binding);
      }
    }
  }
  // remove a targeted clip from the cache
  uncacheAction(clip, optionalRoot) {
    const action = this.existingAction(clip, optionalRoot);
    if (action !== null) {
      this._deactivateAction(action);
      this._removeInactiveAction(action);
    }
  }
};
class Uniform {
  constructor(value) {
    this.value = value;
  }
  clone() {
    return new Uniform(this.value.clone === void 0 ? this.value : this.value.clone());
  }
}
let _id$2 = 0;
class UniformsGroup extends EventDispatcher$1 {
  constructor() {
    super();
    this.isUniformsGroup = true;
    Object.defineProperty(this, "id", { value: _id$2++ });
    this.name = "";
    this.usage = StaticDrawUsage$1;
    this.uniforms = [];
  }
  add(uniform) {
    this.uniforms.push(uniform);
    return this;
  }
  remove(uniform) {
    const index2 = this.uniforms.indexOf(uniform);
    if (index2 !== -1) this.uniforms.splice(index2, 1);
    return this;
  }
  setName(name) {
    this.name = name;
    return this;
  }
  setUsage(value) {
    this.usage = value;
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
    return this;
  }
  copy(source) {
    this.name = source.name;
    this.usage = source.usage;
    const uniformsSource = source.uniforms;
    this.uniforms.length = 0;
    for (let i2 = 0, l2 = uniformsSource.length; i2 < l2; i2++) {
      const uniforms = Array.isArray(uniformsSource[i2]) ? uniformsSource[i2] : [uniformsSource[i2]];
      for (let j = 0; j < uniforms.length; j++) {
        this.uniforms.push(uniforms[j].clone());
      }
    }
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
let InstancedInterleavedBuffer$1 = class InstancedInterleavedBuffer extends InterleavedBuffer$1 {
  constructor(array, stride, meshPerAttribute = 1) {
    super(array, stride);
    this.isInstancedInterleavedBuffer = true;
    this.meshPerAttribute = meshPerAttribute;
  }
  copy(source) {
    super.copy(source);
    this.meshPerAttribute = source.meshPerAttribute;
    return this;
  }
  clone(data) {
    const ib = super.clone(data);
    ib.meshPerAttribute = this.meshPerAttribute;
    return ib;
  }
  toJSON(data) {
    const json = super.toJSON(data);
    json.isInstancedInterleavedBuffer = true;
    json.meshPerAttribute = this.meshPerAttribute;
    return json;
  }
};
class GLBufferAttribute {
  constructor(buffer, type, itemSize, elementSize, count) {
    this.isGLBufferAttribute = true;
    this.name = "";
    this.buffer = buffer;
    this.type = type;
    this.itemSize = itemSize;
    this.elementSize = elementSize;
    this.count = count;
    this.version = 0;
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
  setBuffer(buffer) {
    this.buffer = buffer;
    return this;
  }
  setType(type, elementSize) {
    this.type = type;
    this.elementSize = elementSize;
    return this;
  }
  setItemSize(itemSize) {
    this.itemSize = itemSize;
    return this;
  }
  setCount(count) {
    this.count = count;
    return this;
  }
}
const _matrix$3 = /* @__PURE__ */ new Matrix4$1();
class Raycaster {
  constructor(origin, direction2, near = 0, far = Infinity) {
    this.ray = new Ray$1(origin, direction2);
    this.near = near;
    this.far = far;
    this.camera = null;
    this.layers = new Layers$1();
    this.params = {
      Mesh: {},
      Line: { threshold: 1 },
      LOD: {},
      Points: { threshold: 1 },
      Sprite: {}
    };
  }
  set(origin, direction2) {
    this.ray.set(origin, direction2);
  }
  setFromCamera(coords, camera) {
    if (camera.isPerspectiveCamera) {
      this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
      this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
      this.camera = camera;
    } else if (camera.isOrthographicCamera) {
      this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera);
      this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
      this.camera = camera;
    } else {
      console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
  }
  setFromXRController(controller) {
    _matrix$3.identity().extractRotation(controller.matrixWorld);
    this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
    this.ray.direction.set(0, 0, -1).applyMatrix4(_matrix$3);
    return this;
  }
  intersectObject(object, recursive = true, intersects2 = []) {
    intersect(object, this, intersects2, recursive);
    intersects2.sort(ascSort);
    return intersects2;
  }
  intersectObjects(objects, recursive = true, intersects2 = []) {
    for (let i2 = 0, l2 = objects.length; i2 < l2; i2++) {
      intersect(objects[i2], this, intersects2, recursive);
    }
    intersects2.sort(ascSort);
    return intersects2;
  }
}
function ascSort(a3, b) {
  return a3.distance - b.distance;
}
function intersect(object, raycaster, intersects2, recursive) {
  let propagate = true;
  if (object.layers.test(raycaster.layers)) {
    const result = object.raycast(raycaster, intersects2);
    if (result === false) propagate = false;
  }
  if (propagate === true && recursive === true) {
    const children = object.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      intersect(children[i2], raycaster, intersects2, true);
    }
  }
}
class Spherical {
  constructor(radius = 1, phi = 0, theta = 0) {
    this.radius = radius;
    this.phi = phi;
    this.theta = theta;
    return this;
  }
  set(radius, phi, theta) {
    this.radius = radius;
    this.phi = phi;
    this.theta = theta;
    return this;
  }
  copy(other) {
    this.radius = other.radius;
    this.phi = other.phi;
    this.theta = other.theta;
    return this;
  }
  // restrict phi to be between EPS and PI-EPS
  makeSafe() {
    const EPS = 1e-6;
    this.phi = clamp$1(this.phi, EPS, Math.PI - EPS);
    return this;
  }
  setFromVector3(v) {
    return this.setFromCartesianCoords(v.x, v.y, v.z);
  }
  setFromCartesianCoords(x, y, z2) {
    this.radius = Math.sqrt(x * x + y * y + z2 * z2);
    if (this.radius === 0) {
      this.theta = 0;
      this.phi = 0;
    } else {
      this.theta = Math.atan2(x, z2);
      this.phi = Math.acos(clamp$1(y / this.radius, -1, 1));
    }
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Cylindrical {
  constructor(radius = 1, theta = 0, y = 0) {
    this.radius = radius;
    this.theta = theta;
    this.y = y;
    return this;
  }
  set(radius, theta, y) {
    this.radius = radius;
    this.theta = theta;
    this.y = y;
    return this;
  }
  copy(other) {
    this.radius = other.radius;
    this.theta = other.theta;
    this.y = other.y;
    return this;
  }
  setFromVector3(v) {
    return this.setFromCartesianCoords(v.x, v.y, v.z);
  }
  setFromCartesianCoords(x, y, z2) {
    this.radius = Math.sqrt(x * x + z2 * z2);
    this.theta = Math.atan2(x, z2);
    this.y = y;
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Matrix2 {
  constructor(n11, n12, n21, n22) {
    Matrix2.prototype.isMatrix2 = true;
    this.elements = [
      1,
      0,
      0,
      1
    ];
    if (n11 !== void 0) {
      this.set(n11, n12, n21, n22);
    }
  }
  identity() {
    this.set(
      1,
      0,
      0,
      1
    );
    return this;
  }
  fromArray(array, offset = 0) {
    for (let i2 = 0; i2 < 4; i2++) {
      this.elements[i2] = array[i2 + offset];
    }
    return this;
  }
  set(n11, n12, n21, n22) {
    const te2 = this.elements;
    te2[0] = n11;
    te2[2] = n12;
    te2[1] = n21;
    te2[3] = n22;
    return this;
  }
}
const _vector$4 = /* @__PURE__ */ new Vector2$1();
class Box2 {
  constructor(min = new Vector2$1(Infinity, Infinity), max2 = new Vector2$1(-Infinity, -Infinity)) {
    this.isBox2 = true;
    this.min = min;
    this.max = max2;
  }
  set(min, max2) {
    this.min.copy(min);
    this.max.copy(max2);
    return this;
  }
  setFromPoints(points) {
    this.makeEmpty();
    for (let i2 = 0, il = points.length; i2 < il; i2++) {
      this.expandByPoint(points[i2]);
    }
    return this;
  }
  setFromCenterAndSize(center, size) {
    const halfSize = _vector$4.copy(size).multiplyScalar(0.5);
    this.min.copy(center).sub(halfSize);
    this.max.copy(center).add(halfSize);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(box) {
    this.min.copy(box.min);
    this.max.copy(box.max);
    return this;
  }
  makeEmpty() {
    this.min.x = this.min.y = Infinity;
    this.max.x = this.max.y = -Infinity;
    return this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y;
  }
  getCenter(target) {
    return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(target) {
    return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
  }
  expandByPoint(point2) {
    this.min.min(point2);
    this.max.max(point2);
    return this;
  }
  expandByVector(vector) {
    this.min.sub(vector);
    this.max.add(vector);
    return this;
  }
  expandByScalar(scalar) {
    this.min.addScalar(-scalar);
    this.max.addScalar(scalar);
    return this;
  }
  containsPoint(point2) {
    return point2.x >= this.min.x && point2.x <= this.max.x && point2.y >= this.min.y && point2.y <= this.max.y;
  }
  containsBox(box) {
    return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
  }
  getParameter(point2, target) {
    return target.set(
      (point2.x - this.min.x) / (this.max.x - this.min.x),
      (point2.y - this.min.y) / (this.max.y - this.min.y)
    );
  }
  intersectsBox(box) {
    return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
  }
  clampPoint(point2, target) {
    return target.copy(point2).clamp(this.min, this.max);
  }
  distanceToPoint(point2) {
    return this.clampPoint(point2, _vector$4).distanceTo(point2);
  }
  intersect(box) {
    this.min.max(box.min);
    this.max.min(box.max);
    if (this.isEmpty()) this.makeEmpty();
    return this;
  }
  union(box) {
    this.min.min(box.min);
    this.max.max(box.max);
    return this;
  }
  translate(offset) {
    this.min.add(offset);
    this.max.add(offset);
    return this;
  }
  equals(box) {
    return box.min.equals(this.min) && box.max.equals(this.max);
  }
}
const _startP = /* @__PURE__ */ new Vector3$1();
const _startEnd = /* @__PURE__ */ new Vector3$1();
class Line3 {
  constructor(start = new Vector3$1(), end = new Vector3$1()) {
    this.start = start;
    this.end = end;
  }
  set(start, end) {
    this.start.copy(start);
    this.end.copy(end);
    return this;
  }
  copy(line) {
    this.start.copy(line.start);
    this.end.copy(line.end);
    return this;
  }
  getCenter(target) {
    return target.addVectors(this.start, this.end).multiplyScalar(0.5);
  }
  delta(target) {
    return target.subVectors(this.end, this.start);
  }
  distanceSq() {
    return this.start.distanceToSquared(this.end);
  }
  distance() {
    return this.start.distanceTo(this.end);
  }
  at(t3, target) {
    return this.delta(target).multiplyScalar(t3).add(this.start);
  }
  closestPointToPointParameter(point2, clampToLine) {
    _startP.subVectors(point2, this.start);
    _startEnd.subVectors(this.end, this.start);
    const startEnd2 = _startEnd.dot(_startEnd);
    const startEnd_startP = _startEnd.dot(_startP);
    let t3 = startEnd_startP / startEnd2;
    if (clampToLine) {
      t3 = clamp$1(t3, 0, 1);
    }
    return t3;
  }
  closestPointToPoint(point2, clampToLine, target) {
    const t3 = this.closestPointToPointParameter(point2, clampToLine);
    return this.delta(target).multiplyScalar(t3).add(this.start);
  }
  applyMatrix4(matrix2) {
    this.start.applyMatrix4(matrix2);
    this.end.applyMatrix4(matrix2);
    return this;
  }
  equals(line) {
    return line.start.equals(this.start) && line.end.equals(this.end);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _vector$3 = /* @__PURE__ */ new Vector3$1();
class SpotLightHelper extends Object3D$1 {
  constructor(light, color2) {
    super();
    this.light = light;
    this.matrixAutoUpdate = false;
    this.color = color2;
    this.type = "SpotLightHelper";
    const geometry = new BufferGeometry$1();
    const positions = [
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1,
      0,
      1,
      0,
      0,
      0,
      -1,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      1,
      0,
      0,
      0,
      0,
      -1,
      1
    ];
    for (let i2 = 0, j = 1, l2 = 32; i2 < l2; i2++, j++) {
      const p1 = i2 / l2 * Math.PI * 2;
      const p2 = j / l2 * Math.PI * 2;
      positions.push(
        Math.cos(p1),
        Math.sin(p1),
        1,
        Math.cos(p2),
        Math.sin(p2),
        1
      );
    }
    geometry.setAttribute("position", new Float32BufferAttribute$1(positions, 3));
    const material = new LineBasicMaterial$1({ fog: false, toneMapped: false });
    this.cone = new LineSegments$1(geometry, material);
    this.add(this.cone);
    this.update();
  }
  dispose() {
    this.cone.geometry.dispose();
    this.cone.material.dispose();
  }
  update() {
    this.light.updateWorldMatrix(true, false);
    this.light.target.updateWorldMatrix(true, false);
    if (this.parent) {
      this.parent.updateWorldMatrix(true);
      this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
    } else {
      this.matrix.copy(this.light.matrixWorld);
    }
    this.matrixWorld.copy(this.light.matrixWorld);
    const coneLength = this.light.distance ? this.light.distance : 1e3;
    const coneWidth = coneLength * Math.tan(this.light.angle);
    this.cone.scale.set(coneWidth, coneWidth, coneLength);
    _vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
    this.cone.lookAt(_vector$3);
    if (this.color !== void 0) {
      this.cone.material.color.set(this.color);
    } else {
      this.cone.material.color.copy(this.light.color);
    }
  }
}
const _vector$2$1 = /* @__PURE__ */ new Vector3$1();
const _boneMatrix$1 = /* @__PURE__ */ new Matrix4$1();
const _matrixWorldInv$1 = /* @__PURE__ */ new Matrix4$1();
let SkeletonHelper$1 = class SkeletonHelper extends LineSegments$1 {
  constructor(object) {
    const bones = getBoneList$1(object);
    const geometry = new BufferGeometry$1();
    const vertices = [];
    const colors = [];
    const color1 = new Color$1(0, 0, 1);
    const color2 = new Color$1(0, 1, 0);
    for (let i2 = 0; i2 < bones.length; i2++) {
      const bone = bones[i2];
      if (bone.parent && bone.parent.isBone) {
        vertices.push(0, 0, 0);
        vertices.push(0, 0, 0);
        colors.push(color1.r, color1.g, color1.b);
        colors.push(color2.r, color2.g, color2.b);
      }
    }
    geometry.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute$1(colors, 3));
    const material = new LineBasicMaterial$1({ vertexColors: true, depthTest: false, depthWrite: false, toneMapped: false, transparent: true });
    super(geometry, material);
    this.isSkeletonHelper = true;
    this.type = "SkeletonHelper";
    this.root = object;
    this.bones = bones;
    this.matrix = object.matrixWorld;
    this.matrixAutoUpdate = false;
  }
  updateMatrixWorld(force) {
    const bones = this.bones;
    const geometry = this.geometry;
    const position2 = geometry.getAttribute("position");
    _matrixWorldInv$1.copy(this.root.matrixWorld).invert();
    for (let i2 = 0, j = 0; i2 < bones.length; i2++) {
      const bone = bones[i2];
      if (bone.parent && bone.parent.isBone) {
        _boneMatrix$1.multiplyMatrices(_matrixWorldInv$1, bone.matrixWorld);
        _vector$2$1.setFromMatrixPosition(_boneMatrix$1);
        position2.setXYZ(j, _vector$2$1.x, _vector$2$1.y, _vector$2$1.z);
        _boneMatrix$1.multiplyMatrices(_matrixWorldInv$1, bone.parent.matrixWorld);
        _vector$2$1.setFromMatrixPosition(_boneMatrix$1);
        position2.setXYZ(j + 1, _vector$2$1.x, _vector$2$1.y, _vector$2$1.z);
        j += 2;
      }
    }
    geometry.getAttribute("position").needsUpdate = true;
    super.updateMatrixWorld(force);
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
};
function getBoneList$1(object) {
  const boneList = [];
  if (object.isBone === true) {
    boneList.push(object);
  }
  for (let i2 = 0; i2 < object.children.length; i2++) {
    boneList.push.apply(boneList, getBoneList$1(object.children[i2]));
  }
  return boneList;
}
class PointLightHelper extends Mesh$1 {
  constructor(light, sphereSize, color2) {
    const geometry = new SphereGeometry(sphereSize, 4, 2);
    const material = new MeshBasicMaterial$1({ wireframe: true, fog: false, toneMapped: false });
    super(geometry, material);
    this.light = light;
    this.color = color2;
    this.type = "PointLightHelper";
    this.matrix = this.light.matrixWorld;
    this.matrixAutoUpdate = false;
    this.update();
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
  update() {
    this.light.updateWorldMatrix(true, false);
    if (this.color !== void 0) {
      this.material.color.set(this.color);
    } else {
      this.material.color.copy(this.light.color);
    }
  }
}
const _vector$1$1 = /* @__PURE__ */ new Vector3$1();
const _color1 = /* @__PURE__ */ new Color$1();
const _color2 = /* @__PURE__ */ new Color$1();
class HemisphereLightHelper extends Object3D$1 {
  constructor(light, size, color2) {
    super();
    this.light = light;
    this.matrix = light.matrixWorld;
    this.matrixAutoUpdate = false;
    this.color = color2;
    this.type = "HemisphereLightHelper";
    const geometry = new OctahedronGeometry(size);
    geometry.rotateY(Math.PI * 0.5);
    this.material = new MeshBasicMaterial$1({ wireframe: true, fog: false, toneMapped: false });
    if (this.color === void 0) this.material.vertexColors = true;
    const position2 = geometry.getAttribute("position");
    const colors = new Float32Array(position2.count * 3);
    geometry.setAttribute("color", new BufferAttribute$1(colors, 3));
    this.add(new Mesh$1(geometry, this.material));
    this.update();
  }
  dispose() {
    this.children[0].geometry.dispose();
    this.children[0].material.dispose();
  }
  update() {
    const mesh = this.children[0];
    if (this.color !== void 0) {
      this.material.color.set(this.color);
    } else {
      const colors = mesh.geometry.getAttribute("color");
      _color1.copy(this.light.color);
      _color2.copy(this.light.groundColor);
      for (let i2 = 0, l2 = colors.count; i2 < l2; i2++) {
        const color2 = i2 < l2 / 2 ? _color1 : _color2;
        colors.setXYZ(i2, color2.r, color2.g, color2.b);
      }
      colors.needsUpdate = true;
    }
    this.light.updateWorldMatrix(true, false);
    mesh.lookAt(_vector$1$1.setFromMatrixPosition(this.light.matrixWorld).negate());
  }
}
let GridHelper$1 = class GridHelper extends LineSegments$1 {
  constructor(size = 10, divisions = 10, color1 = 4473924, color2 = 8947848) {
    color1 = new Color$1(color1);
    color2 = new Color$1(color2);
    const center = divisions / 2;
    const step = size / divisions;
    const halfSize = size / 2;
    const vertices = [], colors = [];
    for (let i2 = 0, j = 0, k = -halfSize; i2 <= divisions; i2++, k += step) {
      vertices.push(-halfSize, 0, k, halfSize, 0, k);
      vertices.push(k, 0, -halfSize, k, 0, halfSize);
      const color3 = i2 === center ? color1 : color2;
      color3.toArray(colors, j);
      j += 3;
      color3.toArray(colors, j);
      j += 3;
      color3.toArray(colors, j);
      j += 3;
      color3.toArray(colors, j);
      j += 3;
    }
    const geometry = new BufferGeometry$1();
    geometry.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute$1(colors, 3));
    const material = new LineBasicMaterial$1({ vertexColors: true, toneMapped: false });
    super(geometry, material);
    this.type = "GridHelper";
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
};
class PolarGridHelper extends LineSegments$1 {
  constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 4473924, color2 = 8947848) {
    color1 = new Color$1(color1);
    color2 = new Color$1(color2);
    const vertices = [];
    const colors = [];
    if (sectors > 1) {
      for (let i2 = 0; i2 < sectors; i2++) {
        const v = i2 / sectors * (Math.PI * 2);
        const x = Math.sin(v) * radius;
        const z2 = Math.cos(v) * radius;
        vertices.push(0, 0, 0);
        vertices.push(x, 0, z2);
        const color3 = i2 & 1 ? color1 : color2;
        colors.push(color3.r, color3.g, color3.b);
        colors.push(color3.r, color3.g, color3.b);
      }
    }
    for (let i2 = 0; i2 < rings; i2++) {
      const color3 = i2 & 1 ? color1 : color2;
      const r2 = radius - radius / rings * i2;
      for (let j = 0; j < divisions; j++) {
        let v = j / divisions * (Math.PI * 2);
        let x = Math.sin(v) * r2;
        let z2 = Math.cos(v) * r2;
        vertices.push(x, 0, z2);
        colors.push(color3.r, color3.g, color3.b);
        v = (j + 1) / divisions * (Math.PI * 2);
        x = Math.sin(v) * r2;
        z2 = Math.cos(v) * r2;
        vertices.push(x, 0, z2);
        colors.push(color3.r, color3.g, color3.b);
      }
    }
    const geometry = new BufferGeometry$1();
    geometry.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute$1(colors, 3));
    const material = new LineBasicMaterial$1({ vertexColors: true, toneMapped: false });
    super(geometry, material);
    this.type = "PolarGridHelper";
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
const _v1 = /* @__PURE__ */ new Vector3$1();
const _v2 = /* @__PURE__ */ new Vector3$1();
const _v3 = /* @__PURE__ */ new Vector3$1();
class DirectionalLightHelper extends Object3D$1 {
  constructor(light, size, color2) {
    super();
    this.light = light;
    this.matrix = light.matrixWorld;
    this.matrixAutoUpdate = false;
    this.color = color2;
    this.type = "DirectionalLightHelper";
    if (size === void 0) size = 1;
    let geometry = new BufferGeometry$1();
    geometry.setAttribute("position", new Float32BufferAttribute$1([
      -size,
      size,
      0,
      size,
      size,
      0,
      size,
      -size,
      0,
      -size,
      -size,
      0,
      -size,
      size,
      0
    ], 3));
    const material = new LineBasicMaterial$1({ fog: false, toneMapped: false });
    this.lightPlane = new Line$1(geometry, material);
    this.add(this.lightPlane);
    geometry = new BufferGeometry$1();
    geometry.setAttribute("position", new Float32BufferAttribute$1([0, 0, 0, 0, 0, 1], 3));
    this.targetLine = new Line$1(geometry, material);
    this.add(this.targetLine);
    this.update();
  }
  dispose() {
    this.lightPlane.geometry.dispose();
    this.lightPlane.material.dispose();
    this.targetLine.geometry.dispose();
    this.targetLine.material.dispose();
  }
  update() {
    this.light.updateWorldMatrix(true, false);
    this.light.target.updateWorldMatrix(true, false);
    _v1.setFromMatrixPosition(this.light.matrixWorld);
    _v2.setFromMatrixPosition(this.light.target.matrixWorld);
    _v3.subVectors(_v2, _v1);
    this.lightPlane.lookAt(_v2);
    if (this.color !== void 0) {
      this.lightPlane.material.color.set(this.color);
      this.targetLine.material.color.set(this.color);
    } else {
      this.lightPlane.material.color.copy(this.light.color);
      this.targetLine.material.color.copy(this.light.color);
    }
    this.targetLine.lookAt(_v2);
    this.targetLine.scale.z = _v3.length();
  }
}
const _vector$d = /* @__PURE__ */ new Vector3$1();
const _camera$1 = /* @__PURE__ */ new Camera$1();
class CameraHelper extends LineSegments$1 {
  constructor(camera) {
    const geometry = new BufferGeometry$1();
    const material = new LineBasicMaterial$1({ color: 16777215, vertexColors: true, toneMapped: false });
    const vertices = [];
    const colors = [];
    const pointMap = {};
    addLine("n1", "n2");
    addLine("n2", "n4");
    addLine("n4", "n3");
    addLine("n3", "n1");
    addLine("f1", "f2");
    addLine("f2", "f4");
    addLine("f4", "f3");
    addLine("f3", "f1");
    addLine("n1", "f1");
    addLine("n2", "f2");
    addLine("n3", "f3");
    addLine("n4", "f4");
    addLine("p", "n1");
    addLine("p", "n2");
    addLine("p", "n3");
    addLine("p", "n4");
    addLine("u1", "u2");
    addLine("u2", "u3");
    addLine("u3", "u1");
    addLine("c", "t");
    addLine("p", "c");
    addLine("cn1", "cn2");
    addLine("cn3", "cn4");
    addLine("cf1", "cf2");
    addLine("cf3", "cf4");
    function addLine(a3, b) {
      addPoint(a3);
      addPoint(b);
    }
    function addPoint(id) {
      vertices.push(0, 0, 0);
      colors.push(0, 0, 0);
      if (pointMap[id] === void 0) {
        pointMap[id] = [];
      }
      pointMap[id].push(vertices.length / 3 - 1);
    }
    geometry.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute$1(colors, 3));
    super(geometry, material);
    this.type = "CameraHelper";
    this.camera = camera;
    if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
    this.matrix = camera.matrixWorld;
    this.matrixAutoUpdate = false;
    this.pointMap = pointMap;
    this.update();
    const colorFrustum = new Color$1(16755200);
    const colorCone = new Color$1(16711680);
    const colorUp = new Color$1(43775);
    const colorTarget = new Color$1(16777215);
    const colorCross = new Color$1(3355443);
    this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
  }
  setColors(frustum, cone, up, target, cross) {
    const geometry = this.geometry;
    const colorAttribute = geometry.getAttribute("color");
    colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b);
    colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(25, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(27, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(29, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(31, cone.r, cone.g, cone.b);
    colorAttribute.setXYZ(32, up.r, up.g, up.b);
    colorAttribute.setXYZ(33, up.r, up.g, up.b);
    colorAttribute.setXYZ(34, up.r, up.g, up.b);
    colorAttribute.setXYZ(35, up.r, up.g, up.b);
    colorAttribute.setXYZ(36, up.r, up.g, up.b);
    colorAttribute.setXYZ(37, up.r, up.g, up.b);
    colorAttribute.setXYZ(38, target.r, target.g, target.b);
    colorAttribute.setXYZ(39, target.r, target.g, target.b);
    colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(41, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(43, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(45, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(47, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
    colorAttribute.setXYZ(49, cross.r, cross.g, cross.b);
    colorAttribute.needsUpdate = true;
  }
  update() {
    const geometry = this.geometry;
    const pointMap = this.pointMap;
    const w = 1, h2 = 1;
    _camera$1.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
    setPoint("c", pointMap, geometry, _camera$1, 0, 0, -1);
    setPoint("t", pointMap, geometry, _camera$1, 0, 0, 1);
    setPoint("n1", pointMap, geometry, _camera$1, -w, -h2, -1);
    setPoint("n2", pointMap, geometry, _camera$1, w, -h2, -1);
    setPoint("n3", pointMap, geometry, _camera$1, -w, h2, -1);
    setPoint("n4", pointMap, geometry, _camera$1, w, h2, -1);
    setPoint("f1", pointMap, geometry, _camera$1, -w, -h2, 1);
    setPoint("f2", pointMap, geometry, _camera$1, w, -h2, 1);
    setPoint("f3", pointMap, geometry, _camera$1, -w, h2, 1);
    setPoint("f4", pointMap, geometry, _camera$1, w, h2, 1);
    setPoint("u1", pointMap, geometry, _camera$1, w * 0.7, h2 * 1.1, -1);
    setPoint("u2", pointMap, geometry, _camera$1, -w * 0.7, h2 * 1.1, -1);
    setPoint("u3", pointMap, geometry, _camera$1, 0, h2 * 2, -1);
    setPoint("cf1", pointMap, geometry, _camera$1, -w, 0, 1);
    setPoint("cf2", pointMap, geometry, _camera$1, w, 0, 1);
    setPoint("cf3", pointMap, geometry, _camera$1, 0, -h2, 1);
    setPoint("cf4", pointMap, geometry, _camera$1, 0, h2, 1);
    setPoint("cn1", pointMap, geometry, _camera$1, -w, 0, -1);
    setPoint("cn2", pointMap, geometry, _camera$1, w, 0, -1);
    setPoint("cn3", pointMap, geometry, _camera$1, 0, -h2, -1);
    setPoint("cn4", pointMap, geometry, _camera$1, 0, h2, -1);
    geometry.getAttribute("position").needsUpdate = true;
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
function setPoint(point2, pointMap, geometry, camera, x, y, z2) {
  _vector$d.set(x, y, z2).unproject(camera);
  const points = pointMap[point2];
  if (points !== void 0) {
    const position2 = geometry.getAttribute("position");
    for (let i2 = 0, l2 = points.length; i2 < l2; i2++) {
      position2.setXYZ(points[i2], _vector$d.x, _vector$d.y, _vector$d.z);
    }
  }
}
const _box$5 = /* @__PURE__ */ new Box3$1();
class BoxHelper extends LineSegments$1 {
  constructor(object, color2 = 16776960) {
    const indices = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]);
    const positions = new Float32Array(8 * 3);
    const geometry = new BufferGeometry$1();
    geometry.setIndex(new BufferAttribute$1(indices, 1));
    geometry.setAttribute("position", new BufferAttribute$1(positions, 3));
    super(geometry, new LineBasicMaterial$1({ color: color2, toneMapped: false }));
    this.object = object;
    this.type = "BoxHelper";
    this.matrixAutoUpdate = false;
    this.update();
  }
  update(object) {
    if (object !== void 0) {
      console.warn("THREE.BoxHelper: .update() has no longer arguments.");
    }
    if (this.object !== void 0) {
      _box$5.setFromObject(this.object);
    }
    if (_box$5.isEmpty()) return;
    const min = _box$5.min;
    const max2 = _box$5.max;
    const position2 = this.geometry.attributes.position;
    const array = position2.array;
    array[0] = max2.x;
    array[1] = max2.y;
    array[2] = max2.z;
    array[3] = min.x;
    array[4] = max2.y;
    array[5] = max2.z;
    array[6] = min.x;
    array[7] = min.y;
    array[8] = max2.z;
    array[9] = max2.x;
    array[10] = min.y;
    array[11] = max2.z;
    array[12] = max2.x;
    array[13] = max2.y;
    array[14] = min.z;
    array[15] = min.x;
    array[16] = max2.y;
    array[17] = min.z;
    array[18] = min.x;
    array[19] = min.y;
    array[20] = min.z;
    array[21] = max2.x;
    array[22] = min.y;
    array[23] = min.z;
    position2.needsUpdate = true;
    this.geometry.computeBoundingSphere();
  }
  setFromObject(object) {
    this.object = object;
    this.update();
    return this;
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.object = source.object;
    return this;
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
class Box3Helper extends LineSegments$1 {
  constructor(box, color2 = 16776960) {
    const indices = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]);
    const positions = [1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1];
    const geometry = new BufferGeometry$1();
    geometry.setIndex(new BufferAttribute$1(indices, 1));
    geometry.setAttribute("position", new Float32BufferAttribute$1(positions, 3));
    super(geometry, new LineBasicMaterial$1({ color: color2, toneMapped: false }));
    this.box = box;
    this.type = "Box3Helper";
    this.geometry.computeBoundingSphere();
  }
  updateMatrixWorld(force) {
    const box = this.box;
    if (box.isEmpty()) return;
    box.getCenter(this.position);
    box.getSize(this.scale);
    this.scale.multiplyScalar(0.5);
    super.updateMatrixWorld(force);
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
class PlaneHelper extends Line$1 {
  constructor(plane, size = 1, hex = 16776960) {
    const color2 = hex;
    const positions = [1, -1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, 1, 0, -1, -1, 0, 1, -1, 0, 1, 1, 0];
    const geometry = new BufferGeometry$1();
    geometry.setAttribute("position", new Float32BufferAttribute$1(positions, 3));
    geometry.computeBoundingSphere();
    super(geometry, new LineBasicMaterial$1({ color: color2, toneMapped: false }));
    this.type = "PlaneHelper";
    this.plane = plane;
    this.size = size;
    const positions2 = [1, 1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, -1, 0, 1, -1, 0];
    const geometry2 = new BufferGeometry$1();
    geometry2.setAttribute("position", new Float32BufferAttribute$1(positions2, 3));
    geometry2.computeBoundingSphere();
    this.add(new Mesh$1(geometry2, new MeshBasicMaterial$1({ color: color2, opacity: 0.2, transparent: true, depthWrite: false, toneMapped: false })));
  }
  updateMatrixWorld(force) {
    this.position.set(0, 0, 0);
    this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
    this.lookAt(this.plane.normal);
    this.translateZ(-this.plane.constant);
    super.updateMatrixWorld(force);
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
    this.children[0].geometry.dispose();
    this.children[0].material.dispose();
  }
}
const _axis = /* @__PURE__ */ new Vector3$1();
let _lineGeometry, _coneGeometry;
class ArrowHelper extends Object3D$1 {
  // dir is assumed to be normalized
  constructor(dir = new Vector3$1(0, 0, 1), origin = new Vector3$1(0, 0, 0), length2 = 1, color2 = 16776960, headLength = length2 * 0.2, headWidth = headLength * 0.2) {
    super();
    this.type = "ArrowHelper";
    if (_lineGeometry === void 0) {
      _lineGeometry = new BufferGeometry$1();
      _lineGeometry.setAttribute("position", new Float32BufferAttribute$1([0, 0, 0, 0, 1, 0], 3));
      _coneGeometry = new CylinderGeometry(0, 0.5, 1, 5, 1);
      _coneGeometry.translate(0, -0.5, 0);
    }
    this.position.copy(origin);
    this.line = new Line$1(_lineGeometry, new LineBasicMaterial$1({ color: color2, toneMapped: false }));
    this.line.matrixAutoUpdate = false;
    this.add(this.line);
    this.cone = new Mesh$1(_coneGeometry, new MeshBasicMaterial$1({ color: color2, toneMapped: false }));
    this.cone.matrixAutoUpdate = false;
    this.add(this.cone);
    this.setDirection(dir);
    this.setLength(length2, headLength, headWidth);
  }
  setDirection(dir) {
    if (dir.y > 0.99999) {
      this.quaternion.set(0, 0, 0, 1);
    } else if (dir.y < -0.99999) {
      this.quaternion.set(1, 0, 0, 0);
    } else {
      _axis.set(dir.z, 0, -dir.x).normalize();
      const radians = Math.acos(dir.y);
      this.quaternion.setFromAxisAngle(_axis, radians);
    }
  }
  setLength(length2, headLength = length2 * 0.2, headWidth = headLength * 0.2) {
    this.line.scale.set(1, Math.max(1e-4, length2 - headLength), 1);
    this.line.updateMatrix();
    this.cone.scale.set(headWidth, headLength, headWidth);
    this.cone.position.y = length2;
    this.cone.updateMatrix();
  }
  setColor(color2) {
    this.line.material.color.set(color2);
    this.cone.material.color.set(color2);
  }
  copy(source) {
    super.copy(source, false);
    this.line.copy(source.line);
    this.cone.copy(source.cone);
    return this;
  }
  dispose() {
    this.line.geometry.dispose();
    this.line.material.dispose();
    this.cone.geometry.dispose();
    this.cone.material.dispose();
  }
}
class AxesHelper extends LineSegments$1 {
  constructor(size = 1) {
    const vertices = [
      0,
      0,
      0,
      size,
      0,
      0,
      0,
      0,
      0,
      0,
      size,
      0,
      0,
      0,
      0,
      0,
      0,
      size
    ];
    const colors = [
      1,
      0,
      0,
      1,
      0.6,
      0,
      0,
      1,
      0,
      0.6,
      1,
      0,
      0,
      0,
      1,
      0,
      0.6,
      1
    ];
    const geometry = new BufferGeometry$1();
    geometry.setAttribute("position", new Float32BufferAttribute$1(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute$1(colors, 3));
    const material = new LineBasicMaterial$1({ vertexColors: true, toneMapped: false });
    super(geometry, material);
    this.type = "AxesHelper";
  }
  setColors(xAxisColor, yAxisColor, zAxisColor) {
    const color2 = new Color$1();
    const array = this.geometry.attributes.color.array;
    color2.set(xAxisColor);
    color2.toArray(array, 0);
    color2.toArray(array, 3);
    color2.set(yAxisColor);
    color2.toArray(array, 6);
    color2.toArray(array, 9);
    color2.set(zAxisColor);
    color2.toArray(array, 12);
    color2.toArray(array, 15);
    this.geometry.attributes.color.needsUpdate = true;
    return this;
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
class ShapePath {
  constructor() {
    this.type = "ShapePath";
    this.color = new Color$1();
    this.subPaths = [];
    this.currentPath = null;
  }
  moveTo(x, y) {
    this.currentPath = new Path$1();
    this.subPaths.push(this.currentPath);
    this.currentPath.moveTo(x, y);
    return this;
  }
  lineTo(x, y) {
    this.currentPath.lineTo(x, y);
    return this;
  }
  quadraticCurveTo(aCPx, aCPy, aX, aY) {
    this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
    return this;
  }
  bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
    this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
    return this;
  }
  splineThru(pts) {
    this.currentPath.splineThru(pts);
    return this;
  }
  toShapes(isCCW) {
    function toShapesNoHoles(inSubpaths) {
      const shapes2 = [];
      for (let i2 = 0, l2 = inSubpaths.length; i2 < l2; i2++) {
        const tmpPath2 = inSubpaths[i2];
        const tmpShape2 = new Shape$1();
        tmpShape2.curves = tmpPath2.curves;
        shapes2.push(tmpShape2);
      }
      return shapes2;
    }
    function isPointInsidePolygon(inPt, inPolygon) {
      const polyLen = inPolygon.length;
      let inside = false;
      for (let p2 = polyLen - 1, q = 0; q < polyLen; p2 = q++) {
        let edgeLowPt = inPolygon[p2];
        let edgeHighPt = inPolygon[q];
        let edgeDx = edgeHighPt.x - edgeLowPt.x;
        let edgeDy = edgeHighPt.y - edgeLowPt.y;
        if (Math.abs(edgeDy) > Number.EPSILON) {
          if (edgeDy < 0) {
            edgeLowPt = inPolygon[q];
            edgeDx = -edgeDx;
            edgeHighPt = inPolygon[p2];
            edgeDy = -edgeDy;
          }
          if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
          if (inPt.y === edgeLowPt.y) {
            if (inPt.x === edgeLowPt.x) return true;
          } else {
            const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
            if (perpEdge === 0) return true;
            if (perpEdge < 0) continue;
            inside = !inside;
          }
        } else {
          if (inPt.y !== edgeLowPt.y) continue;
          if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true;
        }
      }
      return inside;
    }
    const isClockWise = ShapeUtils$1.isClockWise;
    const subPaths = this.subPaths;
    if (subPaths.length === 0) return [];
    let solid, tmpPath, tmpShape;
    const shapes = [];
    if (subPaths.length === 1) {
      tmpPath = subPaths[0];
      tmpShape = new Shape$1();
      tmpShape.curves = tmpPath.curves;
      shapes.push(tmpShape);
      return shapes;
    }
    let holesFirst = !isClockWise(subPaths[0].getPoints());
    holesFirst = isCCW ? !holesFirst : holesFirst;
    const betterShapeHoles = [];
    const newShapes = [];
    let newShapeHoles = [];
    let mainIdx = 0;
    let tmpPoints;
    newShapes[mainIdx] = void 0;
    newShapeHoles[mainIdx] = [];
    for (let i2 = 0, l2 = subPaths.length; i2 < l2; i2++) {
      tmpPath = subPaths[i2];
      tmpPoints = tmpPath.getPoints();
      solid = isClockWise(tmpPoints);
      solid = isCCW ? !solid : solid;
      if (solid) {
        if (!holesFirst && newShapes[mainIdx]) mainIdx++;
        newShapes[mainIdx] = { s: new Shape$1(), p: tmpPoints };
        newShapes[mainIdx].s.curves = tmpPath.curves;
        if (holesFirst) mainIdx++;
        newShapeHoles[mainIdx] = [];
      } else {
        newShapeHoles[mainIdx].push({ h: tmpPath, p: tmpPoints[0] });
      }
    }
    if (!newShapes[0]) return toShapesNoHoles(subPaths);
    if (newShapes.length > 1) {
      let ambiguous = false;
      let toChange = 0;
      for (let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++) {
        betterShapeHoles[sIdx] = [];
      }
      for (let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++) {
        const sho = newShapeHoles[sIdx];
        for (let hIdx = 0; hIdx < sho.length; hIdx++) {
          const ho = sho[hIdx];
          let hole_unassigned = true;
          for (let s2Idx = 0; s2Idx < newShapes.length; s2Idx++) {
            if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
              if (sIdx !== s2Idx) toChange++;
              if (hole_unassigned) {
                hole_unassigned = false;
                betterShapeHoles[s2Idx].push(ho);
              } else {
                ambiguous = true;
              }
            }
          }
          if (hole_unassigned) {
            betterShapeHoles[sIdx].push(ho);
          }
        }
      }
      if (toChange > 0 && ambiguous === false) {
        newShapeHoles = betterShapeHoles;
      }
    }
    let tmpHoles;
    for (let i2 = 0, il = newShapes.length; i2 < il; i2++) {
      tmpShape = newShapes[i2].s;
      shapes.push(tmpShape);
      tmpHoles = newShapeHoles[i2];
      for (let j = 0, jl = tmpHoles.length; j < jl; j++) {
        tmpShape.holes.push(tmpHoles[j].h);
      }
    }
    return shapes;
  }
}
class Controls extends EventDispatcher$1 {
  constructor(object, domElement = null) {
    super();
    this.object = object;
    this.domElement = domElement;
    this.enabled = true;
    this.state = -1;
    this.keys = {};
    this.mouseButtons = { LEFT: null, MIDDLE: null, RIGHT: null };
    this.touches = { ONE: null, TWO: null };
  }
  connect() {
  }
  disconnect() {
  }
  dispose() {
  }
  update() {
  }
}
function contain(texture, aspect2) {
  const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
  if (imageAspect > aspect2) {
    texture.repeat.x = 1;
    texture.repeat.y = imageAspect / aspect2;
    texture.offset.x = 0;
    texture.offset.y = (1 - texture.repeat.y) / 2;
  } else {
    texture.repeat.x = aspect2 / imageAspect;
    texture.repeat.y = 1;
    texture.offset.x = (1 - texture.repeat.x) / 2;
    texture.offset.y = 0;
  }
  return texture;
}
function cover(texture, aspect2) {
  const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
  if (imageAspect > aspect2) {
    texture.repeat.x = aspect2 / imageAspect;
    texture.repeat.y = 1;
    texture.offset.x = (1 - texture.repeat.x) / 2;
    texture.offset.y = 0;
  } else {
    texture.repeat.x = 1;
    texture.repeat.y = imageAspect / aspect2;
    texture.offset.x = 0;
    texture.offset.y = (1 - texture.repeat.y) / 2;
  }
  return texture;
}
function fill(texture) {
  texture.repeat.x = 1;
  texture.repeat.y = 1;
  texture.offset.x = 0;
  texture.offset.y = 0;
  return texture;
}
function getByteLength(width, height, format, type) {
  const typeByteLength = getTextureTypeByteLength(type);
  switch (format) {
    case AlphaFormat$1:
      return width * height;
    case LuminanceFormat$1:
      return width * height;
    case LuminanceAlphaFormat$1:
      return width * height * 2;
    case RedFormat$1:
      return width * height / typeByteLength.components * typeByteLength.byteLength;
    case RedIntegerFormat$1:
      return width * height / typeByteLength.components * typeByteLength.byteLength;
    case RGFormat$1:
      return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
    case RGIntegerFormat$1:
      return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
    case RGBFormat$1:
      return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
    case RGBAFormat$1:
      return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
    case RGBAIntegerFormat$1:
      return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
    case RGB_S3TC_DXT1_Format$1:
    case RGBA_S3TC_DXT1_Format$1:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
    case RGBA_S3TC_DXT3_Format$1:
    case RGBA_S3TC_DXT5_Format$1:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
    case RGB_PVRTC_2BPPV1_Format$1:
    case RGBA_PVRTC_2BPPV1_Format$1:
      return Math.max(width, 16) * Math.max(height, 8) / 4;
    case RGB_PVRTC_4BPPV1_Format$1:
    case RGBA_PVRTC_4BPPV1_Format$1:
      return Math.max(width, 8) * Math.max(height, 8) / 2;
    case RGB_ETC1_Format$1:
    case RGB_ETC2_Format$1:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
    case RGBA_ETC2_EAC_Format$1:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
    case RGBA_ASTC_4x4_Format$1:
      return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
    case RGBA_ASTC_5x4_Format$1:
      return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
    case RGBA_ASTC_5x5_Format$1:
      return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
    case RGBA_ASTC_6x5_Format$1:
      return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
    case RGBA_ASTC_6x6_Format$1:
      return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
    case RGBA_ASTC_8x5_Format$1:
      return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
    case RGBA_ASTC_8x6_Format$1:
      return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
    case RGBA_ASTC_8x8_Format$1:
      return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
    case RGBA_ASTC_10x5_Format$1:
      return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
    case RGBA_ASTC_10x6_Format$1:
      return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
    case RGBA_ASTC_10x8_Format$1:
      return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
    case RGBA_ASTC_10x10_Format$1:
      return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
    case RGBA_ASTC_12x10_Format$1:
      return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
    case RGBA_ASTC_12x12_Format$1:
      return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
    case RGBA_BPTC_Format$1:
    case RGB_BPTC_SIGNED_Format:
    case RGB_BPTC_UNSIGNED_Format:
      return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    case RED_RGTC1_Format:
    case SIGNED_RED_RGTC1_Format:
      return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
    case RED_GREEN_RGTC2_Format:
    case SIGNED_RED_GREEN_RGTC2_Format:
      return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
  }
  throw new Error(
    `Unable to determine texture byte length for ${format} format.`
  );
}
function getTextureTypeByteLength(type) {
  switch (type) {
    case UnsignedByteType$1:
    case ByteType$1:
      return { byteLength: 1, components: 1 };
    case UnsignedShortType$1:
    case ShortType$1:
    case HalfFloatType$1:
      return { byteLength: 2, components: 1 };
    case UnsignedShort4444Type$1:
    case UnsignedShort5551Type$1:
      return { byteLength: 2, components: 4 };
    case UnsignedIntType$1:
    case IntType$1:
    case FloatType$1:
      return { byteLength: 4, components: 1 };
    case UnsignedInt5999Type:
      return { byteLength: 4, components: 3 };
  }
  throw new Error(`Unknown texture type ${type}.`);
}
const TextureUtils = {
  contain,
  cover,
  fill,
  getByteLength
};
let WebGLMultipleRenderTargets$1 = class WebGLMultipleRenderTargets extends WebGLRenderTarget$1 {
  // @deprecated, r162
  constructor(width = 1, height = 1, count = 1, options = {}) {
    console.warn('THREE.WebGLMultipleRenderTargets has been deprecated and will be removed in r172. Use THREE.WebGLRenderTarget and set the "count" parameter to enable MRT.');
    super(width, height, { ...options, count });
    this.isWebGLMultipleRenderTargets = true;
  }
  get texture() {
    return this.textures;
  }
};
if (typeof __THREE_DEVTOOLS__ !== "undefined") {
  __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
    revision: REVISION$1
  } }));
}
if (typeof window !== "undefined") {
  if (window.__THREE__) {
    console.warn("WARNING: Multiple instances of Three.js being imported.");
  } else {
    window.__THREE__ = REVISION$1;
  }
}
/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
function WebGLAnimation$1() {
  let context = null;
  let isAnimating = false;
  let animationLoop = null;
  let requestId = null;
  function onAnimationFrame(time2, frame) {
    animationLoop(time2, frame);
    requestId = context.requestAnimationFrame(onAnimationFrame);
  }
  return {
    start: function() {
      if (isAnimating === true) return;
      if (animationLoop === null) return;
      requestId = context.requestAnimationFrame(onAnimationFrame);
      isAnimating = true;
    },
    stop: function() {
      context.cancelAnimationFrame(requestId);
      isAnimating = false;
    },
    setAnimationLoop: function(callback) {
      animationLoop = callback;
    },
    setContext: function(value) {
      context = value;
    }
  };
}
function WebGLAttributes$1(gl) {
  const buffers = /* @__PURE__ */ new WeakMap();
  function createBuffer(attribute, bufferType) {
    const array = attribute.array;
    const usage = attribute.usage;
    const size = array.byteLength;
    const buffer = gl.createBuffer();
    gl.bindBuffer(bufferType, buffer);
    gl.bufferData(bufferType, array, usage);
    attribute.onUploadCallback();
    let type;
    if (array instanceof Float32Array) {
      type = gl.FLOAT;
    } else if (array instanceof Uint16Array) {
      if (attribute.isFloat16BufferAttribute) {
        type = gl.HALF_FLOAT;
      } else {
        type = gl.UNSIGNED_SHORT;
      }
    } else if (array instanceof Int16Array) {
      type = gl.SHORT;
    } else if (array instanceof Uint32Array) {
      type = gl.UNSIGNED_INT;
    } else if (array instanceof Int32Array) {
      type = gl.INT;
    } else if (array instanceof Int8Array) {
      type = gl.BYTE;
    } else if (array instanceof Uint8Array) {
      type = gl.UNSIGNED_BYTE;
    } else if (array instanceof Uint8ClampedArray) {
      type = gl.UNSIGNED_BYTE;
    } else {
      throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array);
    }
    return {
      buffer,
      type,
      bytesPerElement: array.BYTES_PER_ELEMENT,
      version: attribute.version,
      size
    };
  }
  function updateBuffer(buffer, attribute, bufferType) {
    const array = attribute.array;
    const updateRanges = attribute.updateRanges;
    gl.bindBuffer(bufferType, buffer);
    if (updateRanges.length === 0) {
      gl.bufferSubData(bufferType, 0, array);
    } else {
      updateRanges.sort((a3, b) => a3.start - b.start);
      let mergeIndex = 0;
      for (let i2 = 1; i2 < updateRanges.length; i2++) {
        const previousRange = updateRanges[mergeIndex];
        const range = updateRanges[i2];
        if (range.start <= previousRange.start + previousRange.count + 1) {
          previousRange.count = Math.max(
            previousRange.count,
            range.start + range.count - previousRange.start
          );
        } else {
          ++mergeIndex;
          updateRanges[mergeIndex] = range;
        }
      }
      updateRanges.length = mergeIndex + 1;
      for (let i2 = 0, l2 = updateRanges.length; i2 < l2; i2++) {
        const range = updateRanges[i2];
        gl.bufferSubData(
          bufferType,
          range.start * array.BYTES_PER_ELEMENT,
          array,
          range.start,
          range.count
        );
      }
      attribute.clearUpdateRanges();
    }
    attribute.onUploadCallback();
  }
  function get(attribute) {
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    return buffers.get(attribute);
  }
  function remove(attribute) {
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    const data = buffers.get(attribute);
    if (data) {
      gl.deleteBuffer(data.buffer);
      buffers.delete(attribute);
    }
  }
  function update(attribute, bufferType) {
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    if (attribute.isGLBufferAttribute) {
      const cached = buffers.get(attribute);
      if (!cached || cached.version < attribute.version) {
        buffers.set(attribute, {
          buffer: attribute.buffer,
          type: attribute.type,
          bytesPerElement: attribute.elementSize,
          version: attribute.version
        });
      }
      return;
    }
    const data = buffers.get(attribute);
    if (data === void 0) {
      buffers.set(attribute, createBuffer(attribute, bufferType));
    } else if (data.version < attribute.version) {
      if (data.size !== attribute.array.byteLength) {
        throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
      }
      updateBuffer(data.buffer, attribute, bufferType);
      data.version = attribute.version;
    }
  }
  return {
    get,
    remove,
    update
  };
}
var alphahash_fragment = "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif";
var alphamap_fragment$1 = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var alphamap_pars_fragment$1 = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var alphatest_fragment$1 = "#ifdef USE_ALPHATEST\n	#ifdef ALPHA_TO_COVERAGE\n	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n	if ( diffuseColor.a == 0.0 ) discard;\n	#else\n	if ( diffuseColor.a < alphaTest ) discard;\n	#endif\n#endif";
var alphatest_pars_fragment$1 = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var aomap_fragment$1 = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_CLEARCOAT ) \n		clearcoatSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_SHEEN ) \n		sheenSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var aomap_pars_fragment$1 = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var batching_pars_vertex = "#ifdef USE_BATCHING\n	#if ! defined( GL_ANGLE_multi_draw )\n	#define gl_DrawID _gl_DrawID\n	uniform int _gl_DrawID;\n	#endif\n	uniform highp sampler2D batchingTexture;\n	uniform highp usampler2D batchingIdTexture;\n	mat4 getBatchingMatrix( const in float i ) {\n		int size = textureSize( batchingTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n	float getIndirectIndex( const in int i ) {\n		int size = textureSize( batchingIdTexture, 0 ).x;\n		int x = i % size;\n		int y = i / size;\n		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n	}\n#endif\n#ifdef USE_BATCHING_COLOR\n	uniform sampler2D batchingColorTexture;\n	vec3 getBatchingColor( const in float i ) {\n		int size = textureSize( batchingColorTexture, 0 ).x;\n		int j = int( i );\n		int x = j % size;\n		int y = j / size;\n		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n	}\n#endif";
var batching_vertex = "#ifdef USE_BATCHING\n	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var begin_vertex$1 = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif";
var beginnormal_vertex$1 = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var bsdfs$1 = "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated";
var iridescence_fragment = "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif";
var bumpmap_pars_fragment$1 = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var clipping_planes_fragment$1 = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#ifdef ALPHA_TO_COVERAGE\n		float distanceToPlane, distanceGradient;\n		float clipOpacity = 1.0;\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n			distanceGradient = fwidth( distanceToPlane ) / 2.0;\n			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			if ( clipOpacity == 0.0 ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			float unionClipOpacity = 1.0;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n				distanceGradient = fwidth( distanceToPlane ) / 2.0;\n				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			}\n			#pragma unroll_loop_end\n			clipOpacity *= 1.0 - unionClipOpacity;\n		#endif\n		diffuseColor.a *= clipOpacity;\n		if ( diffuseColor.a == 0.0 ) discard;\n	#else\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			bool clipped = true;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n			}\n			#pragma unroll_loop_end\n			if ( clipped ) discard;\n		#endif\n	#endif\n#endif";
var clipping_planes_pars_fragment$1 = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var clipping_planes_pars_vertex$1 = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var clipping_planes_vertex$1 = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var color_fragment$1 = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var color_pars_fragment$1 = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var color_pars_vertex$1 = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	varying vec3 vColor;\n#endif";
var color_vertex$1 = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n	vColor.xyz *= batchingColor.xyz;\n#endif";
var common$1 = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var cube_uv_reflection_fragment$1 = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var defaultnormal_vertex$1 = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n	vec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n	mat3 bm = mat3( batchingMatrix );\n	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n	transformedNormal = bm * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = bm * transformedTangent;\n	#endif\n#endif\n#ifdef USE_INSTANCING\n	mat3 im = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n	transformedNormal = im * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = im * transformedTangent;\n	#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var displacementmap_pars_vertex$1 = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var displacementmap_vertex$1 = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var emissivemap_fragment$1 = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n		emissiveColor = sRGBTransferEOTF( emissiveColor );\n	#endif\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var emissivemap_pars_fragment$1 = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n	return value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var envmap_fragment$1 = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var envmap_common_pars_fragment$1 = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	uniform mat3 envMapRotation;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var envmap_pars_fragment$1 = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var envmap_pars_vertex$1 = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var envmap_vertex$1 = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var fog_vertex$1 = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var fog_pars_vertex$1 = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var fog_fragment$1 = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var fog_pars_fragment$1 = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var gradientmap_pars_fragment$1 = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}";
var lightmap_pars_fragment$1 = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert";
var lights_pars_begin$1 = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n	uniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n	if ( cutoffDistance > 0.0 ) {\n		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n	}\n	return distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var envmap_physical_pars_fragment$1 = "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif";
var lights_toon_fragment$1 = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var lights_toon_pars_fragment$1 = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon";
var lights_phong_fragment$1 = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var lights_phong_pars_fragment$1 = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong";
var lights_physical_fragment$1 = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n	material.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	if( material.anisotropy == 0.0 ) {\n		anisotropyV = vec2( 1.0, 0.0 );\n	} else {\n		anisotropyV /= material.anisotropy;\n		material.anisotropy = saturate( material.anisotropy );\n	}\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var lights_physical_pars_fragment$1 = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	float dispersion;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometryNormal;\n		vec3 viewDir = geometryViewDir;\n		vec3 position = geometryPosition;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var lights_fragment_begin$1 = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n	geometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometryViewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometryPosition, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometryPosition, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	#if defined( USE_LIGHT_PROBES )\n		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n	#endif\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var lights_fragment_maps$1 = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometryNormal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var lights_fragment_end$1 = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var logdepthbuf_fragment$1 = "#if defined( USE_LOGDEPTHBUF )\n	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var logdepthbuf_pars_fragment$1 = "#if defined( USE_LOGDEPTHBUF )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var logdepthbuf_pars_vertex$1 = "#ifdef USE_LOGDEPTHBUF\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var logdepthbuf_vertex$1 = "#ifdef USE_LOGDEPTHBUF\n	vFragDepth = 1.0 + gl_Position.w;\n	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var map_fragment$1 = "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif";
var map_pars_fragment$1 = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var map_particle_fragment$1 = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var map_particle_pars_fragment$1 = "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var metalnessmap_fragment$1 = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var metalnessmap_pars_fragment$1 = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n	float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n	}\n#endif";
var morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
var morphnormal_vertex$1 = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif";
var morphtarget_pars_vertex$1 = "#ifdef USE_MORPHTARGETS\n	#ifndef USE_INSTANCING_MORPH\n		uniform float morphTargetBaseInfluence;\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	#endif\n	uniform sampler2DArray morphTargetsTexture;\n	uniform ivec2 morphTargetsTextureSize;\n	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n		int y = texelIndex / morphTargetsTextureSize.x;\n		int x = texelIndex - y * morphTargetsTextureSize.x;\n		ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n		return texelFetch( morphTargetsTexture, morphUV, 0 );\n	}\n#endif";
var morphtarget_vertex$1 = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif";
var normal_fragment_begin$1 = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var normal_fragment_maps$1 = "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var normal_pars_fragment$1 = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var normal_pars_vertex$1 = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var normal_vertex$1 = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var normalmap_pars_fragment$1 = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif";
var clearcoat_normal_fragment_begin$1 = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var clearcoat_normal_fragment_maps$1 = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var clearcoat_pars_fragment$1 = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif";
var iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif";
var opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var packing$1 = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n	if( v <= 0.0 )\n		return vec4( 0., 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec4( 1., 1., 1., 1. );\n	float vuf;\n	float af = modf( v * PackFactors.a, vuf );\n	float bf = modf( vuf * ShiftRight8, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n	if( v <= 0.0 )\n		return vec3( 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec3( 1., 1., 1. );\n	float vuf;\n	float bf = modf( v * PackFactors.b, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n	if( v <= 0.0 )\n		return vec2( 0., 0. );\n	if( v >= 1.0 )\n		return vec2( 1., 1. );\n	float vuf;\n	float gf = modf( v * 256., vuf );\n	return vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n	return dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}";
var premultiplied_alpha_fragment$1 = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var project_vertex$1 = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n	mvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var dithering_fragment$1 = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var dithering_pars_fragment$1 = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var roughnessmap_fragment$1 = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var roughnessmap_pars_fragment$1 = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var shadowmap_pars_fragment$1 = "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		float shadow = 1.0;\n		vec3 lightToPosition = shadowCoord.xyz;\n		\n		float lightToPositionLength = length( lightToPosition );\n		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;\n			vec3 bd3D = normalize( lightToPosition );\n			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n				shadow = (\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n				) * ( 1.0 / 9.0 );\n			#else\n				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n			#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n#endif";
var shadowmap_pars_vertex$1 = "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var shadowmap_vertex$1 = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif";
var shadowmask_pars_fragment$1 = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var skinbase_vertex$1 = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var skinning_pars_vertex$1 = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	mat4 getBoneMatrix( const in float i ) {\n		int size = textureSize( boneTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n#endif";
var skinning_vertex$1 = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var skinnormal_vertex$1 = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var specularmap_fragment$1 = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var specularmap_pars_fragment$1 = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var tonemapping_fragment$1 = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var tonemapping_pars_fragment$1 = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n	vec3( 1.6605, - 0.1246, - 0.0182 ),\n	vec3( - 0.5876, 1.1329, - 0.1006 ),\n	vec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n	vec3( 0.6274, 0.0691, 0.0164 ),\n	vec3( 0.3293, 0.9195, 0.0880 ),\n	vec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n	vec3 x2 = x * x;\n	vec3 x4 = x2 * x2;\n	return + 15.5 * x4 * x2\n		- 40.14 * x4 * x\n		+ 31.96 * x4\n		- 6.868 * x2 * x\n		+ 0.4298 * x2\n		+ 0.1191 * x\n		- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n	const mat3 AgXInsetMatrix = mat3(\n		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n	);\n	const mat3 AgXOutsetMatrix = mat3(\n		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n	);\n	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;\n	color *= toneMappingExposure;\n	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n	color = AgXInsetMatrix * color;\n	color = max( color, 1e-10 );	color = log2( color );\n	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n	color = clamp( color, 0.0, 1.0 );\n	color = agxDefaultContrastApprox( color );\n	color = AgXOutsetMatrix * color;\n	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n	color = clamp( color, 0.0, 1.0 );\n	return color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n	const float StartCompression = 0.8 - 0.04;\n	const float Desaturation = 0.15;\n	color *= toneMappingExposure;\n	float x = min( color.r, min( color.g, color.b ) );\n	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n	color -= offset;\n	float peak = max( color.r, max( color.g, color.b ) );\n	if ( peak < StartCompression ) return color;\n	float d = 1. - StartCompression;\n	float newPeak = 1. - d * d / ( peak + d - StartCompression );\n	color *= newPeak / peak;\n	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n	return mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var transmission_fragment$1 = "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var transmission_pars_fragment$1 = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec4 transmittedLight;\n		vec3 transmittance;\n		#ifdef USE_DISPERSION\n			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n			for ( int i = 0; i < 3; i ++ ) {\n				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n				vec3 refractedRayExit = position + transmissionRay;\n		\n				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n				vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n				refractionCoords += 1.0;\n				refractionCoords /= 2.0;\n		\n				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n				transmittedLight[ i ] = transmissionSample[ i ];\n				transmittedLight.a += transmissionSample.a;\n				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n			}\n			transmittedLight.a /= 3.0;\n		\n		#else\n		\n			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n			vec3 refractedRayExit = position + transmissionRay;\n			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n			vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n			refractionCoords += 1.0;\n			refractionCoords /= 2.0;\n			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		\n		#endif\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif";
var uv_pars_fragment$1 = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var uv_pars_vertex$1 = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var uv_vertex$1 = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var worldpos_vertex$1 = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_BATCHING\n		worldPosition = batchingMatrix * worldPosition;\n	#endif\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#elif DEPTH_PACKING == 3202\n		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n	#elif DEPTH_PACKING == 3203\n		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n	#endif\n}";
const vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
const vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n	uniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
const vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix[ 3 ];\n	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
const ShaderChunk$1 = {
  alphahash_fragment,
  alphahash_pars_fragment,
  alphamap_fragment: alphamap_fragment$1,
  alphamap_pars_fragment: alphamap_pars_fragment$1,
  alphatest_fragment: alphatest_fragment$1,
  alphatest_pars_fragment: alphatest_pars_fragment$1,
  aomap_fragment: aomap_fragment$1,
  aomap_pars_fragment: aomap_pars_fragment$1,
  batching_pars_vertex,
  batching_vertex,
  begin_vertex: begin_vertex$1,
  beginnormal_vertex: beginnormal_vertex$1,
  bsdfs: bsdfs$1,
  iridescence_fragment,
  bumpmap_pars_fragment: bumpmap_pars_fragment$1,
  clipping_planes_fragment: clipping_planes_fragment$1,
  clipping_planes_pars_fragment: clipping_planes_pars_fragment$1,
  clipping_planes_pars_vertex: clipping_planes_pars_vertex$1,
  clipping_planes_vertex: clipping_planes_vertex$1,
  color_fragment: color_fragment$1,
  color_pars_fragment: color_pars_fragment$1,
  color_pars_vertex: color_pars_vertex$1,
  color_vertex: color_vertex$1,
  common: common$1,
  cube_uv_reflection_fragment: cube_uv_reflection_fragment$1,
  defaultnormal_vertex: defaultnormal_vertex$1,
  displacementmap_pars_vertex: displacementmap_pars_vertex$1,
  displacementmap_vertex: displacementmap_vertex$1,
  emissivemap_fragment: emissivemap_fragment$1,
  emissivemap_pars_fragment: emissivemap_pars_fragment$1,
  colorspace_fragment,
  colorspace_pars_fragment,
  envmap_fragment: envmap_fragment$1,
  envmap_common_pars_fragment: envmap_common_pars_fragment$1,
  envmap_pars_fragment: envmap_pars_fragment$1,
  envmap_pars_vertex: envmap_pars_vertex$1,
  envmap_physical_pars_fragment: envmap_physical_pars_fragment$1,
  envmap_vertex: envmap_vertex$1,
  fog_vertex: fog_vertex$1,
  fog_pars_vertex: fog_pars_vertex$1,
  fog_fragment: fog_fragment$1,
  fog_pars_fragment: fog_pars_fragment$1,
  gradientmap_pars_fragment: gradientmap_pars_fragment$1,
  lightmap_pars_fragment: lightmap_pars_fragment$1,
  lights_lambert_fragment,
  lights_lambert_pars_fragment,
  lights_pars_begin: lights_pars_begin$1,
  lights_toon_fragment: lights_toon_fragment$1,
  lights_toon_pars_fragment: lights_toon_pars_fragment$1,
  lights_phong_fragment: lights_phong_fragment$1,
  lights_phong_pars_fragment: lights_phong_pars_fragment$1,
  lights_physical_fragment: lights_physical_fragment$1,
  lights_physical_pars_fragment: lights_physical_pars_fragment$1,
  lights_fragment_begin: lights_fragment_begin$1,
  lights_fragment_maps: lights_fragment_maps$1,
  lights_fragment_end: lights_fragment_end$1,
  logdepthbuf_fragment: logdepthbuf_fragment$1,
  logdepthbuf_pars_fragment: logdepthbuf_pars_fragment$1,
  logdepthbuf_pars_vertex: logdepthbuf_pars_vertex$1,
  logdepthbuf_vertex: logdepthbuf_vertex$1,
  map_fragment: map_fragment$1,
  map_pars_fragment: map_pars_fragment$1,
  map_particle_fragment: map_particle_fragment$1,
  map_particle_pars_fragment: map_particle_pars_fragment$1,
  metalnessmap_fragment: metalnessmap_fragment$1,
  metalnessmap_pars_fragment: metalnessmap_pars_fragment$1,
  morphinstance_vertex,
  morphcolor_vertex,
  morphnormal_vertex: morphnormal_vertex$1,
  morphtarget_pars_vertex: morphtarget_pars_vertex$1,
  morphtarget_vertex: morphtarget_vertex$1,
  normal_fragment_begin: normal_fragment_begin$1,
  normal_fragment_maps: normal_fragment_maps$1,
  normal_pars_fragment: normal_pars_fragment$1,
  normal_pars_vertex: normal_pars_vertex$1,
  normal_vertex: normal_vertex$1,
  normalmap_pars_fragment: normalmap_pars_fragment$1,
  clearcoat_normal_fragment_begin: clearcoat_normal_fragment_begin$1,
  clearcoat_normal_fragment_maps: clearcoat_normal_fragment_maps$1,
  clearcoat_pars_fragment: clearcoat_pars_fragment$1,
  iridescence_pars_fragment,
  opaque_fragment,
  packing: packing$1,
  premultiplied_alpha_fragment: premultiplied_alpha_fragment$1,
  project_vertex: project_vertex$1,
  dithering_fragment: dithering_fragment$1,
  dithering_pars_fragment: dithering_pars_fragment$1,
  roughnessmap_fragment: roughnessmap_fragment$1,
  roughnessmap_pars_fragment: roughnessmap_pars_fragment$1,
  shadowmap_pars_fragment: shadowmap_pars_fragment$1,
  shadowmap_pars_vertex: shadowmap_pars_vertex$1,
  shadowmap_vertex: shadowmap_vertex$1,
  shadowmask_pars_fragment: shadowmask_pars_fragment$1,
  skinbase_vertex: skinbase_vertex$1,
  skinning_pars_vertex: skinning_pars_vertex$1,
  skinning_vertex: skinning_vertex$1,
  skinnormal_vertex: skinnormal_vertex$1,
  specularmap_fragment: specularmap_fragment$1,
  specularmap_pars_fragment: specularmap_pars_fragment$1,
  tonemapping_fragment: tonemapping_fragment$1,
  tonemapping_pars_fragment: tonemapping_pars_fragment$1,
  transmission_fragment: transmission_fragment$1,
  transmission_pars_fragment: transmission_pars_fragment$1,
  uv_pars_fragment: uv_pars_fragment$1,
  uv_pars_vertex: uv_pars_vertex$1,
  uv_vertex: uv_vertex$1,
  worldpos_vertex: worldpos_vertex$1,
  background_vert: vertex$h,
  background_frag: fragment$h,
  backgroundCube_vert: vertex$g,
  backgroundCube_frag: fragment$g,
  cube_vert: vertex$f,
  cube_frag: fragment$f,
  depth_vert: vertex$e,
  depth_frag: fragment$e,
  distanceRGBA_vert: vertex$d,
  distanceRGBA_frag: fragment$d,
  equirect_vert: vertex$c,
  equirect_frag: fragment$c,
  linedashed_vert: vertex$b,
  linedashed_frag: fragment$b,
  meshbasic_vert: vertex$a,
  meshbasic_frag: fragment$a,
  meshlambert_vert: vertex$9,
  meshlambert_frag: fragment$9,
  meshmatcap_vert: vertex$8,
  meshmatcap_frag: fragment$8,
  meshnormal_vert: vertex$7,
  meshnormal_frag: fragment$7,
  meshphong_vert: vertex$6,
  meshphong_frag: fragment$6,
  meshphysical_vert: vertex$5,
  meshphysical_frag: fragment$5,
  meshtoon_vert: vertex$4,
  meshtoon_frag: fragment$4,
  points_vert: vertex$3,
  points_frag: fragment$3,
  shadow_vert: vertex$2,
  shadow_frag: fragment$2,
  sprite_vert: vertex$1,
  sprite_frag: fragment$1
};
const UniformsLib$1 = {
  common: {
    diffuse: { value: /* @__PURE__ */ new Color$1(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    alphaTest: { value: 0 }
  },
  specularmap: {
    specularMap: { value: null },
    specularMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  envmap: {
    envMap: { value: null },
    envMapRotation: { value: /* @__PURE__ */ new Matrix3$1() },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    // basic, lambert, phong
    ior: { value: 1.5 },
    // physical
    refractionRatio: { value: 0.98 }
    // basic, lambert, phong
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 },
    aoMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 },
    lightMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    normalScale: { value: /* @__PURE__ */ new Vector2$1(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  emissivemap: {
    emissiveMap: { value: null },
    emissiveMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  metalnessmap: {
    metalnessMap: { value: null },
    metalnessMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  roughnessmap: {
    roughnessMap: { value: null },
    roughnessMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: /* @__PURE__ */ new Color$1(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotLightMap: { value: [] },
    spotShadowMap: { value: [] },
    spotLightMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowIntensity: 1,
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: /* @__PURE__ */ new Color$1(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    alphaTest: { value: 0 },
    uvTransform: { value: /* @__PURE__ */ new Matrix3$1() }
  },
  sprite: {
    diffuse: { value: /* @__PURE__ */ new Color$1(16777215) },
    opacity: { value: 1 },
    center: { value: /* @__PURE__ */ new Vector2$1(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    mapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    alphaMap: { value: null },
    alphaMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
    alphaTest: { value: 0 }
  }
};
const ShaderLib$1 = {
  basic: {
    uniforms: /* @__PURE__ */ mergeUniforms$1([
      UniformsLib$1.common,
      UniformsLib$1.specularmap,
      UniformsLib$1.envmap,
      UniformsLib$1.aomap,
      UniformsLib$1.lightmap,
      UniformsLib$1.fog
    ]),
    vertexShader: ShaderChunk$1.meshbasic_vert,
    fragmentShader: ShaderChunk$1.meshbasic_frag
  },
  lambert: {
    uniforms: /* @__PURE__ */ mergeUniforms$1([
      UniformsLib$1.common,
      UniformsLib$1.specularmap,
      UniformsLib$1.envmap,
      UniformsLib$1.aomap,
      UniformsLib$1.lightmap,
      UniformsLib$1.emissivemap,
      UniformsLib$1.bumpmap,
      UniformsLib$1.normalmap,
      UniformsLib$1.displacementmap,
      UniformsLib$1.fog,
      UniformsLib$1.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color$1(0) }
      }
    ]),
    vertexShader: ShaderChunk$1.meshlambert_vert,
    fragmentShader: ShaderChunk$1.meshlambert_frag
  },
  phong: {
    uniforms: /* @__PURE__ */ mergeUniforms$1([
      UniformsLib$1.common,
      UniformsLib$1.specularmap,
      UniformsLib$1.envmap,
      UniformsLib$1.aomap,
      UniformsLib$1.lightmap,
      UniformsLib$1.emissivemap,
      UniformsLib$1.bumpmap,
      UniformsLib$1.normalmap,
      UniformsLib$1.displacementmap,
      UniformsLib$1.fog,
      UniformsLib$1.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color$1(0) },
        specular: { value: /* @__PURE__ */ new Color$1(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: ShaderChunk$1.meshphong_vert,
    fragmentShader: ShaderChunk$1.meshphong_frag
  },
  standard: {
    uniforms: /* @__PURE__ */ mergeUniforms$1([
      UniformsLib$1.common,
      UniformsLib$1.envmap,
      UniformsLib$1.aomap,
      UniformsLib$1.lightmap,
      UniformsLib$1.emissivemap,
      UniformsLib$1.bumpmap,
      UniformsLib$1.normalmap,
      UniformsLib$1.displacementmap,
      UniformsLib$1.roughnessmap,
      UniformsLib$1.metalnessmap,
      UniformsLib$1.fog,
      UniformsLib$1.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color$1(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk$1.meshphysical_vert,
    fragmentShader: ShaderChunk$1.meshphysical_frag
  },
  toon: {
    uniforms: /* @__PURE__ */ mergeUniforms$1([
      UniformsLib$1.common,
      UniformsLib$1.aomap,
      UniformsLib$1.lightmap,
      UniformsLib$1.emissivemap,
      UniformsLib$1.bumpmap,
      UniformsLib$1.normalmap,
      UniformsLib$1.displacementmap,
      UniformsLib$1.gradientmap,
      UniformsLib$1.fog,
      UniformsLib$1.lights,
      {
        emissive: { value: /* @__PURE__ */ new Color$1(0) }
      }
    ]),
    vertexShader: ShaderChunk$1.meshtoon_vert,
    fragmentShader: ShaderChunk$1.meshtoon_frag
  },
  matcap: {
    uniforms: /* @__PURE__ */ mergeUniforms$1([
      UniformsLib$1.common,
      UniformsLib$1.bumpmap,
      UniformsLib$1.normalmap,
      UniformsLib$1.displacementmap,
      UniformsLib$1.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: ShaderChunk$1.meshmatcap_vert,
    fragmentShader: ShaderChunk$1.meshmatcap_frag
  },
  points: {
    uniforms: /* @__PURE__ */ mergeUniforms$1([
      UniformsLib$1.points,
      UniformsLib$1.fog
    ]),
    vertexShader: ShaderChunk$1.points_vert,
    fragmentShader: ShaderChunk$1.points_frag
  },
  dashed: {
    uniforms: /* @__PURE__ */ mergeUniforms$1([
      UniformsLib$1.common,
      UniformsLib$1.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: ShaderChunk$1.linedashed_vert,
    fragmentShader: ShaderChunk$1.linedashed_frag
  },
  depth: {
    uniforms: /* @__PURE__ */ mergeUniforms$1([
      UniformsLib$1.common,
      UniformsLib$1.displacementmap
    ]),
    vertexShader: ShaderChunk$1.depth_vert,
    fragmentShader: ShaderChunk$1.depth_frag
  },
  normal: {
    uniforms: /* @__PURE__ */ mergeUniforms$1([
      UniformsLib$1.common,
      UniformsLib$1.bumpmap,
      UniformsLib$1.normalmap,
      UniformsLib$1.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk$1.meshnormal_vert,
    fragmentShader: ShaderChunk$1.meshnormal_frag
  },
  sprite: {
    uniforms: /* @__PURE__ */ mergeUniforms$1([
      UniformsLib$1.sprite,
      UniformsLib$1.fog
    ]),
    vertexShader: ShaderChunk$1.sprite_vert,
    fragmentShader: ShaderChunk$1.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      t2D: { value: null },
      backgroundIntensity: { value: 1 }
    },
    vertexShader: ShaderChunk$1.background_vert,
    fragmentShader: ShaderChunk$1.background_frag
  },
  backgroundCube: {
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 },
      backgroundBlurriness: { value: 0 },
      backgroundIntensity: { value: 1 },
      backgroundRotation: { value: /* @__PURE__ */ new Matrix3$1() }
    },
    vertexShader: ShaderChunk$1.backgroundCube_vert,
    fragmentShader: ShaderChunk$1.backgroundCube_frag
  },
  cube: {
    uniforms: {
      tCube: { value: null },
      tFlip: { value: -1 },
      opacity: { value: 1 }
    },
    vertexShader: ShaderChunk$1.cube_vert,
    fragmentShader: ShaderChunk$1.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: ShaderChunk$1.equirect_vert,
    fragmentShader: ShaderChunk$1.equirect_frag
  },
  distanceRGBA: {
    uniforms: /* @__PURE__ */ mergeUniforms$1([
      UniformsLib$1.common,
      UniformsLib$1.displacementmap,
      {
        referencePosition: { value: /* @__PURE__ */ new Vector3$1() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: ShaderChunk$1.distanceRGBA_vert,
    fragmentShader: ShaderChunk$1.distanceRGBA_frag
  },
  shadow: {
    uniforms: /* @__PURE__ */ mergeUniforms$1([
      UniformsLib$1.lights,
      UniformsLib$1.fog,
      {
        color: { value: /* @__PURE__ */ new Color$1(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk$1.shadow_vert,
    fragmentShader: ShaderChunk$1.shadow_frag
  }
};
ShaderLib$1.physical = {
  uniforms: /* @__PURE__ */ mergeUniforms$1([
    ShaderLib$1.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      clearcoatNormalMap: { value: null },
      clearcoatNormalMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      clearcoatNormalScale: { value: /* @__PURE__ */ new Vector2$1(1, 1) },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatRoughnessMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      dispersion: { value: 0 },
      iridescence: { value: 0 },
      iridescenceMap: { value: null },
      iridescenceMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      iridescenceIOR: { value: 1.3 },
      iridescenceThicknessMinimum: { value: 100 },
      iridescenceThicknessMaximum: { value: 400 },
      iridescenceThicknessMap: { value: null },
      iridescenceThicknessMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      sheen: { value: 0 },
      sheenColor: { value: /* @__PURE__ */ new Color$1(0) },
      sheenColorMap: { value: null },
      sheenColorMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      sheenRoughnessMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      transmissionSamplerSize: { value: /* @__PURE__ */ new Vector2$1() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      thicknessMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: /* @__PURE__ */ new Color$1(0) },
      specularColor: { value: /* @__PURE__ */ new Color$1(1, 1, 1) },
      specularColorMap: { value: null },
      specularColorMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularIntensityMapTransform: { value: /* @__PURE__ */ new Matrix3$1() },
      anisotropyVector: { value: /* @__PURE__ */ new Vector2$1() },
      anisotropyMap: { value: null },
      anisotropyMapTransform: { value: /* @__PURE__ */ new Matrix3$1() }
    }
  ]),
  vertexShader: ShaderChunk$1.meshphysical_vert,
  fragmentShader: ShaderChunk$1.meshphysical_frag
};
const _rgb = { r: 0, b: 0, g: 0 };
const _e1$1 = /* @__PURE__ */ new Euler$1();
const _m1$1$1 = /* @__PURE__ */ new Matrix4$1();
function WebGLBackground$1(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
  const clearColor = new Color$1(0);
  let clearAlpha = alpha === true ? 0 : 1;
  let planeMesh;
  let boxMesh;
  let currentBackground = null;
  let currentBackgroundVersion = 0;
  let currentTonemapping = null;
  function getBackground(scene) {
    let background = scene.isScene === true ? scene.background : null;
    if (background && background.isTexture) {
      const usePMREM = scene.backgroundBlurriness > 0;
      background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
    }
    return background;
  }
  function render(scene) {
    let forceClear = false;
    const background = getBackground(scene);
    if (background === null) {
      setClear(clearColor, clearAlpha);
    } else if (background && background.isColor) {
      setClear(background, 1);
      forceClear = true;
    }
    const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
    if (environmentBlendMode === "additive") {
      state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
    } else if (environmentBlendMode === "alpha-blend") {
      state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
    }
    if (renderer.autoClear || forceClear) {
      state.buffers.depth.setTest(true);
      state.buffers.depth.setMask(true);
      state.buffers.color.setMask(true);
      renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
    }
  }
  function addToRenderList(renderList, scene) {
    const background = getBackground(scene);
    if (background && (background.isCubeTexture || background.mapping === CubeUVReflectionMapping$1)) {
      if (boxMesh === void 0) {
        boxMesh = new Mesh$1(
          new BoxGeometry$1(1, 1, 1),
          new ShaderMaterial$1({
            name: "BackgroundCubeMaterial",
            uniforms: cloneUniforms$1(ShaderLib$1.backgroundCube.uniforms),
            vertexShader: ShaderLib$1.backgroundCube.vertexShader,
            fragmentShader: ShaderLib$1.backgroundCube.fragmentShader,
            side: BackSide$1,
            depthTest: false,
            depthWrite: false,
            fog: false
          })
        );
        boxMesh.geometry.deleteAttribute("normal");
        boxMesh.geometry.deleteAttribute("uv");
        boxMesh.onBeforeRender = function(renderer2, scene2, camera) {
          this.matrixWorld.copyPosition(camera.matrixWorld);
        };
        Object.defineProperty(boxMesh.material, "envMap", {
          get: function() {
            return this.uniforms.envMap.value;
          }
        });
        objects.update(boxMesh);
      }
      _e1$1.copy(scene.backgroundRotation);
      _e1$1.x *= -1;
      _e1$1.y *= -1;
      _e1$1.z *= -1;
      if (background.isCubeTexture && background.isRenderTargetTexture === false) {
        _e1$1.y *= -1;
        _e1$1.z *= -1;
      }
      boxMesh.material.uniforms.envMap.value = background;
      boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
      boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
      boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
      boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4(_m1$1$1.makeRotationFromEuler(_e1$1));
      boxMesh.material.toneMapped = ColorManagement.getTransfer(background.colorSpace) !== SRGBTransfer;
      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        boxMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }
      boxMesh.layers.enableAll();
      renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
    } else if (background && background.isTexture) {
      if (planeMesh === void 0) {
        planeMesh = new Mesh$1(
          new PlaneGeometry$1(2, 2),
          new ShaderMaterial$1({
            name: "BackgroundMaterial",
            uniforms: cloneUniforms$1(ShaderLib$1.background.uniforms),
            vertexShader: ShaderLib$1.background.vertexShader,
            fragmentShader: ShaderLib$1.background.fragmentShader,
            side: FrontSide$1,
            depthTest: false,
            depthWrite: false,
            fog: false
          })
        );
        planeMesh.geometry.deleteAttribute("normal");
        Object.defineProperty(planeMesh.material, "map", {
          get: function() {
            return this.uniforms.t2D.value;
          }
        });
        objects.update(planeMesh);
      }
      planeMesh.material.uniforms.t2D.value = background;
      planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
      planeMesh.material.toneMapped = ColorManagement.getTransfer(background.colorSpace) !== SRGBTransfer;
      if (background.matrixAutoUpdate === true) {
        background.updateMatrix();
      }
      planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        planeMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }
      planeMesh.layers.enableAll();
      renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
    }
  }
  function setClear(color2, alpha2) {
    color2.getRGB(_rgb, getUnlitUniformColorSpace(renderer));
    state.buffers.color.setClear(_rgb.r, _rgb.g, _rgb.b, alpha2, premultipliedAlpha);
  }
  function dispose() {
    if (boxMesh !== void 0) {
      boxMesh.geometry.dispose();
      boxMesh.material.dispose();
    }
    if (planeMesh !== void 0) {
      planeMesh.geometry.dispose();
      planeMesh.material.dispose();
    }
  }
  return {
    getClearColor: function() {
      return clearColor;
    },
    setClearColor: function(color2, alpha2 = 1) {
      clearColor.set(color2);
      clearAlpha = alpha2;
      setClear(clearColor, clearAlpha);
    },
    getClearAlpha: function() {
      return clearAlpha;
    },
    setClearAlpha: function(alpha2) {
      clearAlpha = alpha2;
      setClear(clearColor, clearAlpha);
    },
    render,
    addToRenderList,
    dispose
  };
}
function WebGLBindingStates$1(gl, attributes) {
  const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
  const bindingStates = {};
  const defaultState = createBindingState(null);
  let currentState = defaultState;
  let forceUpdate = false;
  function setup(object, material, program, geometry, index2) {
    let updateBuffers = false;
    const state = getBindingState(geometry, program, material);
    if (currentState !== state) {
      currentState = state;
      bindVertexArrayObject(currentState.object);
    }
    updateBuffers = needsUpdate(object, geometry, program, index2);
    if (updateBuffers) saveCache(object, geometry, program, index2);
    if (index2 !== null) {
      attributes.update(index2, gl.ELEMENT_ARRAY_BUFFER);
    }
    if (updateBuffers || forceUpdate) {
      forceUpdate = false;
      setupVertexAttributes(object, material, program, geometry);
      if (index2 !== null) {
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index2).buffer);
      }
    }
  }
  function createVertexArrayObject() {
    return gl.createVertexArray();
  }
  function bindVertexArrayObject(vao) {
    return gl.bindVertexArray(vao);
  }
  function deleteVertexArrayObject(vao) {
    return gl.deleteVertexArray(vao);
  }
  function getBindingState(geometry, program, material) {
    const wireframe = material.wireframe === true;
    let programMap = bindingStates[geometry.id];
    if (programMap === void 0) {
      programMap = {};
      bindingStates[geometry.id] = programMap;
    }
    let stateMap = programMap[program.id];
    if (stateMap === void 0) {
      stateMap = {};
      programMap[program.id] = stateMap;
    }
    let state = stateMap[wireframe];
    if (state === void 0) {
      state = createBindingState(createVertexArrayObject());
      stateMap[wireframe] = state;
    }
    return state;
  }
  function createBindingState(vao) {
    const newAttributes = [];
    const enabledAttributes = [];
    const attributeDivisors = [];
    for (let i2 = 0; i2 < maxVertexAttributes; i2++) {
      newAttributes[i2] = 0;
      enabledAttributes[i2] = 0;
      attributeDivisors[i2] = 0;
    }
    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: false,
      newAttributes,
      enabledAttributes,
      attributeDivisors,
      object: vao,
      attributes: {},
      index: null
    };
  }
  function needsUpdate(object, geometry, program, index2) {
    const cachedAttributes = currentState.attributes;
    const geometryAttributes = geometry.attributes;
    let attributesNum = 0;
    const programAttributes = program.getAttributes();
    for (const name in programAttributes) {
      const programAttribute = programAttributes[name];
      if (programAttribute.location >= 0) {
        const cachedAttribute = cachedAttributes[name];
        let geometryAttribute = geometryAttributes[name];
        if (geometryAttribute === void 0) {
          if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
          if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
        }
        if (cachedAttribute === void 0) return true;
        if (cachedAttribute.attribute !== geometryAttribute) return true;
        if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
        attributesNum++;
      }
    }
    if (currentState.attributesNum !== attributesNum) return true;
    if (currentState.index !== index2) return true;
    return false;
  }
  function saveCache(object, geometry, program, index2) {
    const cache = {};
    const attributes2 = geometry.attributes;
    let attributesNum = 0;
    const programAttributes = program.getAttributes();
    for (const name in programAttributes) {
      const programAttribute = programAttributes[name];
      if (programAttribute.location >= 0) {
        let attribute = attributes2[name];
        if (attribute === void 0) {
          if (name === "instanceMatrix" && object.instanceMatrix) attribute = object.instanceMatrix;
          if (name === "instanceColor" && object.instanceColor) attribute = object.instanceColor;
        }
        const data = {};
        data.attribute = attribute;
        if (attribute && attribute.data) {
          data.data = attribute.data;
        }
        cache[name] = data;
        attributesNum++;
      }
    }
    currentState.attributes = cache;
    currentState.attributesNum = attributesNum;
    currentState.index = index2;
  }
  function initAttributes() {
    const newAttributes = currentState.newAttributes;
    for (let i2 = 0, il = newAttributes.length; i2 < il; i2++) {
      newAttributes[i2] = 0;
    }
  }
  function enableAttribute(attribute) {
    enableAttributeAndDivisor(attribute, 0);
  }
  function enableAttributeAndDivisor(attribute, meshPerAttribute) {
    const newAttributes = currentState.newAttributes;
    const enabledAttributes = currentState.enabledAttributes;
    const attributeDivisors = currentState.attributeDivisors;
    newAttributes[attribute] = 1;
    if (enabledAttributes[attribute] === 0) {
      gl.enableVertexAttribArray(attribute);
      enabledAttributes[attribute] = 1;
    }
    if (attributeDivisors[attribute] !== meshPerAttribute) {
      gl.vertexAttribDivisor(attribute, meshPerAttribute);
      attributeDivisors[attribute] = meshPerAttribute;
    }
  }
  function disableUnusedAttributes() {
    const newAttributes = currentState.newAttributes;
    const enabledAttributes = currentState.enabledAttributes;
    for (let i2 = 0, il = enabledAttributes.length; i2 < il; i2++) {
      if (enabledAttributes[i2] !== newAttributes[i2]) {
        gl.disableVertexAttribArray(i2);
        enabledAttributes[i2] = 0;
      }
    }
  }
  function vertexAttribPointer(index2, size, type, normalized, stride, offset, integer) {
    if (integer === true) {
      gl.vertexAttribIPointer(index2, size, type, stride, offset);
    } else {
      gl.vertexAttribPointer(index2, size, type, normalized, stride, offset);
    }
  }
  function setupVertexAttributes(object, material, program, geometry) {
    initAttributes();
    const geometryAttributes = geometry.attributes;
    const programAttributes = program.getAttributes();
    const materialDefaultAttributeValues = material.defaultAttributeValues;
    for (const name in programAttributes) {
      const programAttribute = programAttributes[name];
      if (programAttribute.location >= 0) {
        let geometryAttribute = geometryAttributes[name];
        if (geometryAttribute === void 0) {
          if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
          if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
        }
        if (geometryAttribute !== void 0) {
          const normalized = geometryAttribute.normalized;
          const size = geometryAttribute.itemSize;
          const attribute = attributes.get(geometryAttribute);
          if (attribute === void 0) continue;
          const buffer = attribute.buffer;
          const type = attribute.type;
          const bytesPerElement = attribute.bytesPerElement;
          const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === IntType$1;
          if (geometryAttribute.isInterleavedBufferAttribute) {
            const data = geometryAttribute.data;
            const stride = data.stride;
            const offset = geometryAttribute.offset;
            if (data.isInstancedInterleavedBuffer) {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttributeAndDivisor(programAttribute.location + i2, data.meshPerAttribute);
              }
              if (object.isInstancedMesh !== true && geometry._maxInstanceCount === void 0) {
                geometry._maxInstanceCount = data.meshPerAttribute * data.count;
              }
            } else {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttribute(programAttribute.location + i2);
              }
            }
            gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
            for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
              vertexAttribPointer(
                programAttribute.location + i2,
                size / programAttribute.locationSize,
                type,
                normalized,
                stride * bytesPerElement,
                (offset + size / programAttribute.locationSize * i2) * bytesPerElement,
                integer
              );
            }
          } else {
            if (geometryAttribute.isInstancedBufferAttribute) {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttributeAndDivisor(programAttribute.location + i2, geometryAttribute.meshPerAttribute);
              }
              if (object.isInstancedMesh !== true && geometry._maxInstanceCount === void 0) {
                geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
              }
            } else {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttribute(programAttribute.location + i2);
              }
            }
            gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
            for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
              vertexAttribPointer(
                programAttribute.location + i2,
                size / programAttribute.locationSize,
                type,
                normalized,
                size * bytesPerElement,
                size / programAttribute.locationSize * i2 * bytesPerElement,
                integer
              );
            }
          }
        } else if (materialDefaultAttributeValues !== void 0) {
          const value = materialDefaultAttributeValues[name];
          if (value !== void 0) {
            switch (value.length) {
              case 2:
                gl.vertexAttrib2fv(programAttribute.location, value);
                break;
              case 3:
                gl.vertexAttrib3fv(programAttribute.location, value);
                break;
              case 4:
                gl.vertexAttrib4fv(programAttribute.location, value);
                break;
              default:
                gl.vertexAttrib1fv(programAttribute.location, value);
            }
          }
        }
      }
    }
    disableUnusedAttributes();
  }
  function dispose() {
    reset();
    for (const geometryId in bindingStates) {
      const programMap = bindingStates[geometryId];
      for (const programId in programMap) {
        const stateMap = programMap[programId];
        for (const wireframe in stateMap) {
          deleteVertexArrayObject(stateMap[wireframe].object);
          delete stateMap[wireframe];
        }
        delete programMap[programId];
      }
      delete bindingStates[geometryId];
    }
  }
  function releaseStatesOfGeometry(geometry) {
    if (bindingStates[geometry.id] === void 0) return;
    const programMap = bindingStates[geometry.id];
    for (const programId in programMap) {
      const stateMap = programMap[programId];
      for (const wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }
      delete programMap[programId];
    }
    delete bindingStates[geometry.id];
  }
  function releaseStatesOfProgram(program) {
    for (const geometryId in bindingStates) {
      const programMap = bindingStates[geometryId];
      if (programMap[program.id] === void 0) continue;
      const stateMap = programMap[program.id];
      for (const wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }
      delete programMap[program.id];
    }
  }
  function reset() {
    resetDefaultState();
    forceUpdate = true;
    if (currentState === defaultState) return;
    currentState = defaultState;
    bindVertexArrayObject(currentState.object);
  }
  function resetDefaultState() {
    defaultState.geometry = null;
    defaultState.program = null;
    defaultState.wireframe = false;
  }
  return {
    setup,
    reset,
    resetDefaultState,
    dispose,
    releaseStatesOfGeometry,
    releaseStatesOfProgram,
    initAttributes,
    enableAttribute,
    disableUnusedAttributes
  };
}
function WebGLBufferRenderer$1(gl, extensions, info) {
  let mode;
  function setMode(value) {
    mode = value;
  }
  function render(start, count) {
    gl.drawArrays(mode, start, count);
    info.update(count, mode, 1);
  }
  function renderInstances(start, count, primcount) {
    if (primcount === 0) return;
    gl.drawArraysInstanced(mode, start, count, primcount);
    info.update(count, mode, primcount);
  }
  function renderMultiDraw(starts, counts, drawCount) {
    if (drawCount === 0) return;
    const extension = extensions.get("WEBGL_multi_draw");
    extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
    let elementCount = 0;
    for (let i2 = 0; i2 < drawCount; i2++) {
      elementCount += counts[i2];
    }
    info.update(elementCount, mode, 1);
  }
  function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
    if (drawCount === 0) return;
    const extension = extensions.get("WEBGL_multi_draw");
    if (extension === null) {
      for (let i2 = 0; i2 < starts.length; i2++) {
        renderInstances(starts[i2], counts[i2], primcount[i2]);
      }
    } else {
      extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
      let elementCount = 0;
      for (let i2 = 0; i2 < drawCount; i2++) {
        elementCount += counts[i2] * primcount[i2];
      }
      info.update(elementCount, mode, 1);
    }
  }
  this.setMode = setMode;
  this.render = render;
  this.renderInstances = renderInstances;
  this.renderMultiDraw = renderMultiDraw;
  this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function WebGLCapabilities$1(gl, extensions, parameters, utils2) {
  let maxAnisotropy;
  function getMaxAnisotropy() {
    if (maxAnisotropy !== void 0) return maxAnisotropy;
    if (extensions.has("EXT_texture_filter_anisotropic") === true) {
      const extension = extensions.get("EXT_texture_filter_anisotropic");
      maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else {
      maxAnisotropy = 0;
    }
    return maxAnisotropy;
  }
  function textureFormatReadable(textureFormat) {
    if (textureFormat !== RGBAFormat$1 && utils2.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) {
      return false;
    }
    return true;
  }
  function textureTypeReadable(textureType) {
    const halfFloatSupportedByExt = textureType === HalfFloatType$1 && (extensions.has("EXT_color_buffer_half_float") || extensions.has("EXT_color_buffer_float"));
    if (textureType !== UnsignedByteType$1 && utils2.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
    textureType !== FloatType$1 && !halfFloatSupportedByExt) {
      return false;
    }
    return true;
  }
  function getMaxPrecision(precision2) {
    if (precision2 === "highp") {
      if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) {
        return "highp";
      }
      precision2 = "mediump";
    }
    if (precision2 === "mediump") {
      if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) {
        return "mediump";
      }
    }
    return "lowp";
  }
  let precision = parameters.precision !== void 0 ? parameters.precision : "highp";
  const maxPrecision = getMaxPrecision(precision);
  if (maxPrecision !== precision) {
    console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
    precision = maxPrecision;
  }
  const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
  const reverseDepthBuffer = parameters.reverseDepthBuffer === true && extensions.has("EXT_clip_control");
  const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
  const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
  const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
  const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
  const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
  const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
  const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
  const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
  const vertexTextures = maxVertexTextures > 0;
  const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
  return {
    isWebGL2: true,
    // keeping this for backwards compatibility
    getMaxAnisotropy,
    getMaxPrecision,
    textureFormatReadable,
    textureTypeReadable,
    precision,
    logarithmicDepthBuffer,
    reverseDepthBuffer,
    maxTextures,
    maxVertexTextures,
    maxTextureSize,
    maxCubemapSize,
    maxAttributes,
    maxVertexUniforms,
    maxVaryings,
    maxFragmentUniforms,
    vertexTextures,
    maxSamples
  };
}
function WebGLClipping$1(properties) {
  const scope = this;
  let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
  const plane = new Plane$1(), viewNormalMatrix = new Matrix3$1(), uniform = { value: null, needsUpdate: false };
  this.uniform = uniform;
  this.numPlanes = 0;
  this.numIntersection = 0;
  this.init = function(planes, enableLocalClipping) {
    const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
    // run another frame in order to reset the state:
    numGlobalPlanes !== 0 || localClippingEnabled;
    localClippingEnabled = enableLocalClipping;
    numGlobalPlanes = planes.length;
    return enabled;
  };
  this.beginShadows = function() {
    renderingShadows = true;
    projectPlanes(null);
  };
  this.endShadows = function() {
    renderingShadows = false;
  };
  this.setGlobalState = function(planes, camera) {
    globalState = projectPlanes(planes, camera, 0);
  };
  this.setState = function(material, camera, useCache) {
    const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
    const materialProperties = properties.get(material);
    if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
      if (renderingShadows) {
        projectPlanes(null);
      } else {
        resetGlobalState();
      }
    } else {
      const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
      let dstArray = materialProperties.clippingState || null;
      uniform.value = dstArray;
      dstArray = projectPlanes(planes, camera, lGlobal, useCache);
      for (let i2 = 0; i2 !== lGlobal; ++i2) {
        dstArray[i2] = globalState[i2];
      }
      materialProperties.clippingState = dstArray;
      this.numIntersection = clipIntersection ? this.numPlanes : 0;
      this.numPlanes += nGlobal;
    }
  };
  function resetGlobalState() {
    if (uniform.value !== globalState) {
      uniform.value = globalState;
      uniform.needsUpdate = numGlobalPlanes > 0;
    }
    scope.numPlanes = numGlobalPlanes;
    scope.numIntersection = 0;
  }
  function projectPlanes(planes, camera, dstOffset, skipTransform) {
    const nPlanes = planes !== null ? planes.length : 0;
    let dstArray = null;
    if (nPlanes !== 0) {
      dstArray = uniform.value;
      if (skipTransform !== true || dstArray === null) {
        const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
        viewNormalMatrix.getNormalMatrix(viewMatrix);
        if (dstArray === null || dstArray.length < flatSize) {
          dstArray = new Float32Array(flatSize);
        }
        for (let i2 = 0, i4 = dstOffset; i2 !== nPlanes; ++i2, i4 += 4) {
          plane.copy(planes[i2]).applyMatrix4(viewMatrix, viewNormalMatrix);
          plane.normal.toArray(dstArray, i4);
          dstArray[i4 + 3] = plane.constant;
        }
      }
      uniform.value = dstArray;
      uniform.needsUpdate = true;
    }
    scope.numPlanes = nPlanes;
    scope.numIntersection = 0;
    return dstArray;
  }
}
function WebGLCubeMaps$1(renderer) {
  let cubemaps = /* @__PURE__ */ new WeakMap();
  function mapTextureMapping(texture, mapping) {
    if (mapping === EquirectangularReflectionMapping$1) {
      texture.mapping = CubeReflectionMapping$1;
    } else if (mapping === EquirectangularRefractionMapping$1) {
      texture.mapping = CubeRefractionMapping$1;
    }
    return texture;
  }
  function get(texture) {
    if (texture && texture.isTexture) {
      const mapping = texture.mapping;
      if (mapping === EquirectangularReflectionMapping$1 || mapping === EquirectangularRefractionMapping$1) {
        if (cubemaps.has(texture)) {
          const cubemap = cubemaps.get(texture).texture;
          return mapTextureMapping(cubemap, texture.mapping);
        } else {
          const image2 = texture.image;
          if (image2 && image2.height > 0) {
            const renderTarget = new WebGLCubeRenderTarget$1(image2.height);
            renderTarget.fromEquirectangularTexture(renderer, texture);
            cubemaps.set(texture, renderTarget);
            texture.addEventListener("dispose", onTextureDispose);
            return mapTextureMapping(renderTarget.texture, texture.mapping);
          } else {
            return null;
          }
        }
      }
    }
    return texture;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    const cubemap = cubemaps.get(texture);
    if (cubemap !== void 0) {
      cubemaps.delete(texture);
      cubemap.dispose();
    }
  }
  function dispose() {
    cubemaps = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose
  };
}
const LOD_MIN$1 = 4;
const EXTRA_LOD_SIGMA$1 = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582];
const MAX_SAMPLES$1 = 20;
const _flatCamera$1 = /* @__PURE__ */ new OrthographicCamera$1();
const _clearColor$1 = /* @__PURE__ */ new Color$1();
let _oldTarget$1 = null;
let _oldActiveCubeFace = 0;
let _oldActiveMipmapLevel = 0;
let _oldXrEnabled = false;
const PHI$1 = (1 + Math.sqrt(5)) / 2;
const INV_PHI$1 = 1 / PHI$1;
const _axisDirections$1 = [
  /* @__PURE__ */ new Vector3$1(-PHI$1, INV_PHI$1, 0),
  /* @__PURE__ */ new Vector3$1(PHI$1, INV_PHI$1, 0),
  /* @__PURE__ */ new Vector3$1(-INV_PHI$1, 0, PHI$1),
  /* @__PURE__ */ new Vector3$1(INV_PHI$1, 0, PHI$1),
  /* @__PURE__ */ new Vector3$1(0, PHI$1, -INV_PHI$1),
  /* @__PURE__ */ new Vector3$1(0, PHI$1, INV_PHI$1),
  /* @__PURE__ */ new Vector3$1(-1, 1, -1),
  /* @__PURE__ */ new Vector3$1(1, 1, -1),
  /* @__PURE__ */ new Vector3$1(-1, 1, 1),
  /* @__PURE__ */ new Vector3$1(1, 1, 1)
];
let PMREMGenerator$1 = class PMREMGenerator {
  constructor(renderer) {
    this._renderer = renderer;
    this._pingPongRenderTarget = null;
    this._lodMax = 0;
    this._cubeSize = 0;
    this._lodPlanes = [];
    this._sizeLods = [];
    this._sigmas = [];
    this._blurMaterial = null;
    this._cubemapMaterial = null;
    this._equirectMaterial = null;
    this._compileMaterial(this._blurMaterial);
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety (the cubeCamera
   * is placed at the origin).
   */
  fromScene(scene, sigma = 0, near = 0.1, far = 100) {
    _oldTarget$1 = this._renderer.getRenderTarget();
    _oldActiveCubeFace = this._renderer.getActiveCubeFace();
    _oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
    _oldXrEnabled = this._renderer.xr.enabled;
    this._renderer.xr.enabled = false;
    this._setSize(256);
    const cubeUVRenderTarget = this._allocateTargets();
    cubeUVRenderTarget.depthBuffer = true;
    this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
    if (sigma > 0) {
      this._blur(cubeUVRenderTarget, 0, 0, sigma);
    }
    this._applyPMREM(cubeUVRenderTarget);
    this._cleanup(cubeUVRenderTarget);
    return cubeUVRenderTarget;
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   * The smallest supported equirectangular image size is 64 x 32.
   */
  fromEquirectangular(equirectangular, renderTarget = null) {
    return this._fromTexture(equirectangular, renderTarget);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   * The smallest supported cube size is 16 x 16.
   */
  fromCubemap(cubemap, renderTarget = null) {
    return this._fromTexture(cubemap, renderTarget);
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileCubemapShader() {
    if (this._cubemapMaterial === null) {
      this._cubemapMaterial = _getCubemapMaterial();
      this._compileMaterial(this._cubemapMaterial);
    }
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileEquirectangularShader() {
    if (this._equirectMaterial === null) {
      this._equirectMaterial = _getEquirectMaterial();
      this._compileMaterial(this._equirectMaterial);
    }
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    this._dispose();
    if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
    if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
  }
  // private interface
  _setSize(cubeSize) {
    this._lodMax = Math.floor(Math.log2(cubeSize));
    this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    if (this._blurMaterial !== null) this._blurMaterial.dispose();
    if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
    for (let i2 = 0; i2 < this._lodPlanes.length; i2++) {
      this._lodPlanes[i2].dispose();
    }
  }
  _cleanup(outputTarget) {
    this._renderer.setRenderTarget(_oldTarget$1, _oldActiveCubeFace, _oldActiveMipmapLevel);
    this._renderer.xr.enabled = _oldXrEnabled;
    outputTarget.scissorTest = false;
    _setViewport$1(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
  }
  _fromTexture(texture, renderTarget) {
    if (texture.mapping === CubeReflectionMapping$1 || texture.mapping === CubeRefractionMapping$1) {
      this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
    } else {
      this._setSize(texture.image.width / 4);
    }
    _oldTarget$1 = this._renderer.getRenderTarget();
    _oldActiveCubeFace = this._renderer.getActiveCubeFace();
    _oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
    _oldXrEnabled = this._renderer.xr.enabled;
    this._renderer.xr.enabled = false;
    const cubeUVRenderTarget = renderTarget || this._allocateTargets();
    this._textureToCubeUV(texture, cubeUVRenderTarget);
    this._applyPMREM(cubeUVRenderTarget);
    this._cleanup(cubeUVRenderTarget);
    return cubeUVRenderTarget;
  }
  _allocateTargets() {
    const width = 3 * Math.max(this._cubeSize, 16 * 7);
    const height = 4 * this._cubeSize;
    const params = {
      magFilter: LinearFilter$1,
      minFilter: LinearFilter$1,
      generateMipmaps: false,
      type: HalfFloatType$1,
      format: RGBAFormat$1,
      colorSpace: LinearSRGBColorSpace,
      depthBuffer: false
    };
    const cubeUVRenderTarget = _createRenderTarget$1(width, height, params);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
      if (this._pingPongRenderTarget !== null) {
        this._dispose();
      }
      this._pingPongRenderTarget = _createRenderTarget$1(width, height, params);
      const { _lodMax } = this;
      ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = _createPlanes$1(_lodMax));
      this._blurMaterial = _getBlurShader$1(_lodMax, width, height);
    }
    return cubeUVRenderTarget;
  }
  _compileMaterial(material) {
    const tmpMesh = new Mesh$1(this._lodPlanes[0], material);
    this._renderer.compile(tmpMesh, _flatCamera$1);
  }
  _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
    const fov2 = 90;
    const aspect2 = 1;
    const cubeCamera = new PerspectiveCamera$1(fov2, aspect2, near, far);
    const upSign = [1, -1, 1, 1, 1, 1];
    const forwardSign = [1, 1, 1, -1, -1, -1];
    const renderer = this._renderer;
    const originalAutoClear = renderer.autoClear;
    const toneMapping = renderer.toneMapping;
    renderer.getClearColor(_clearColor$1);
    renderer.toneMapping = NoToneMapping$1;
    renderer.autoClear = false;
    const backgroundMaterial = new MeshBasicMaterial$1({
      name: "PMREM.Background",
      side: BackSide$1,
      depthWrite: false,
      depthTest: false
    });
    const backgroundBox = new Mesh$1(new BoxGeometry$1(), backgroundMaterial);
    let useSolidColor = false;
    const background = scene.background;
    if (background) {
      if (background.isColor) {
        backgroundMaterial.color.copy(background);
        scene.background = null;
        useSolidColor = true;
      }
    } else {
      backgroundMaterial.color.copy(_clearColor$1);
      useSolidColor = true;
    }
    for (let i2 = 0; i2 < 6; i2++) {
      const col = i2 % 3;
      if (col === 0) {
        cubeCamera.up.set(0, upSign[i2], 0);
        cubeCamera.lookAt(forwardSign[i2], 0, 0);
      } else if (col === 1) {
        cubeCamera.up.set(0, 0, upSign[i2]);
        cubeCamera.lookAt(0, forwardSign[i2], 0);
      } else {
        cubeCamera.up.set(0, upSign[i2], 0);
        cubeCamera.lookAt(0, 0, forwardSign[i2]);
      }
      const size = this._cubeSize;
      _setViewport$1(cubeUVRenderTarget, col * size, i2 > 2 ? size : 0, size, size);
      renderer.setRenderTarget(cubeUVRenderTarget);
      if (useSolidColor) {
        renderer.render(backgroundBox, cubeCamera);
      }
      renderer.render(scene, cubeCamera);
    }
    backgroundBox.geometry.dispose();
    backgroundBox.material.dispose();
    renderer.toneMapping = toneMapping;
    renderer.autoClear = originalAutoClear;
    scene.background = background;
  }
  _textureToCubeUV(texture, cubeUVRenderTarget) {
    const renderer = this._renderer;
    const isCubeTexture = texture.mapping === CubeReflectionMapping$1 || texture.mapping === CubeRefractionMapping$1;
    if (isCubeTexture) {
      if (this._cubemapMaterial === null) {
        this._cubemapMaterial = _getCubemapMaterial();
      }
      this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
    } else {
      if (this._equirectMaterial === null) {
        this._equirectMaterial = _getEquirectMaterial();
      }
    }
    const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
    const mesh = new Mesh$1(this._lodPlanes[0], material);
    const uniforms = material.uniforms;
    uniforms["envMap"].value = texture;
    const size = this._cubeSize;
    _setViewport$1(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
    renderer.setRenderTarget(cubeUVRenderTarget);
    renderer.render(mesh, _flatCamera$1);
  }
  _applyPMREM(cubeUVRenderTarget) {
    const renderer = this._renderer;
    const autoClear = renderer.autoClear;
    renderer.autoClear = false;
    const n2 = this._lodPlanes.length;
    for (let i2 = 1; i2 < n2; i2++) {
      const sigma = Math.sqrt(this._sigmas[i2] * this._sigmas[i2] - this._sigmas[i2 - 1] * this._sigmas[i2 - 1]);
      const poleAxis = _axisDirections$1[(n2 - i2 - 1) % _axisDirections$1.length];
      this._blur(cubeUVRenderTarget, i2 - 1, i2, sigma, poleAxis);
    }
    renderer.autoClear = autoClear;
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   */
  _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
    const pingPongRenderTarget = this._pingPongRenderTarget;
    this._halfBlur(
      cubeUVRenderTarget,
      pingPongRenderTarget,
      lodIn,
      lodOut,
      sigma,
      "latitudinal",
      poleAxis
    );
    this._halfBlur(
      pingPongRenderTarget,
      cubeUVRenderTarget,
      lodOut,
      lodOut,
      sigma,
      "longitudinal",
      poleAxis
    );
  }
  _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction2, poleAxis) {
    const renderer = this._renderer;
    const blurMaterial = this._blurMaterial;
    if (direction2 !== "latitudinal" && direction2 !== "longitudinal") {
      console.error(
        "blur direction must be either latitudinal or longitudinal!"
      );
    }
    const STANDARD_DEVIATIONS = 3;
    const blurMesh = new Mesh$1(this._lodPlanes[lodOut], blurMaterial);
    const blurUniforms = blurMaterial.uniforms;
    const pixels = this._sizeLods[lodIn] - 1;
    const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * MAX_SAMPLES$1 - 1);
    const sigmaPixels = sigmaRadians / radiansPerPixel;
    const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : MAX_SAMPLES$1;
    if (samples > MAX_SAMPLES$1) {
      console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${MAX_SAMPLES$1}`);
    }
    const weights = [];
    let sum = 0;
    for (let i2 = 0; i2 < MAX_SAMPLES$1; ++i2) {
      const x2 = i2 / sigmaPixels;
      const weight = Math.exp(-x2 * x2 / 2);
      weights.push(weight);
      if (i2 === 0) {
        sum += weight;
      } else if (i2 < samples) {
        sum += 2 * weight;
      }
    }
    for (let i2 = 0; i2 < weights.length; i2++) {
      weights[i2] = weights[i2] / sum;
    }
    blurUniforms["envMap"].value = targetIn.texture;
    blurUniforms["samples"].value = samples;
    blurUniforms["weights"].value = weights;
    blurUniforms["latitudinal"].value = direction2 === "latitudinal";
    if (poleAxis) {
      blurUniforms["poleAxis"].value = poleAxis;
    }
    const { _lodMax } = this;
    blurUniforms["dTheta"].value = radiansPerPixel;
    blurUniforms["mipInt"].value = _lodMax - lodIn;
    const outputSize = this._sizeLods[lodOut];
    const x = 3 * outputSize * (lodOut > _lodMax - LOD_MIN$1 ? lodOut - _lodMax + LOD_MIN$1 : 0);
    const y = 4 * (this._cubeSize - outputSize);
    _setViewport$1(targetOut, x, y, 3 * outputSize, 2 * outputSize);
    renderer.setRenderTarget(targetOut);
    renderer.render(blurMesh, _flatCamera$1);
  }
};
function _createPlanes$1(lodMax) {
  const lodPlanes = [];
  const sizeLods = [];
  const sigmas = [];
  let lod = lodMax;
  const totalLods = lodMax - LOD_MIN$1 + 1 + EXTRA_LOD_SIGMA$1.length;
  for (let i2 = 0; i2 < totalLods; i2++) {
    const sizeLod = Math.pow(2, lod);
    sizeLods.push(sizeLod);
    let sigma = 1 / sizeLod;
    if (i2 > lodMax - LOD_MIN$1) {
      sigma = EXTRA_LOD_SIGMA$1[i2 - lodMax + LOD_MIN$1 - 1];
    } else if (i2 === 0) {
      sigma = 0;
    }
    sigmas.push(sigma);
    const texelSize = 1 / (sizeLod - 2);
    const min = -texelSize;
    const max2 = 1 + texelSize;
    const uv1 = [min, min, max2, min, max2, max2, min, min, max2, max2, min, max2];
    const cubeFaces = 6;
    const vertices = 6;
    const positionSize = 3;
    const uvSize = 2;
    const faceIndexSize = 1;
    const position2 = new Float32Array(positionSize * vertices * cubeFaces);
    const uv = new Float32Array(uvSize * vertices * cubeFaces);
    const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
    for (let face = 0; face < cubeFaces; face++) {
      const x = face % 3 * 2 / 3 - 1;
      const y = face > 2 ? 0 : -1;
      const coordinates = [
        x,
        y,
        0,
        x + 2 / 3,
        y,
        0,
        x + 2 / 3,
        y + 1,
        0,
        x,
        y,
        0,
        x + 2 / 3,
        y + 1,
        0,
        x,
        y + 1,
        0
      ];
      position2.set(coordinates, positionSize * vertices * face);
      uv.set(uv1, uvSize * vertices * face);
      const fill2 = [face, face, face, face, face, face];
      faceIndex.set(fill2, faceIndexSize * vertices * face);
    }
    const planes = new BufferGeometry$1();
    planes.setAttribute("position", new BufferAttribute$1(position2, positionSize));
    planes.setAttribute("uv", new BufferAttribute$1(uv, uvSize));
    planes.setAttribute("faceIndex", new BufferAttribute$1(faceIndex, faceIndexSize));
    lodPlanes.push(planes);
    if (lod > LOD_MIN$1) {
      lod--;
    }
  }
  return { lodPlanes, sizeLods, sigmas };
}
function _createRenderTarget$1(width, height, params) {
  const cubeUVRenderTarget = new WebGLRenderTarget$1(width, height, params);
  cubeUVRenderTarget.texture.mapping = CubeUVReflectionMapping$1;
  cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
  cubeUVRenderTarget.scissorTest = true;
  return cubeUVRenderTarget;
}
function _setViewport$1(target, x, y, width, height) {
  target.viewport.set(x, y, width, height);
  target.scissor.set(x, y, width, height);
}
function _getBlurShader$1(lodMax, width, height) {
  const weights = new Float32Array(MAX_SAMPLES$1);
  const poleAxis = new Vector3$1(0, 1, 0);
  const shaderMaterial = new ShaderMaterial$1({
    name: "SphericalGaussianBlur",
    defines: {
      "n": MAX_SAMPLES$1,
      "CUBEUV_TEXEL_WIDTH": 1 / width,
      "CUBEUV_TEXEL_HEIGHT": 1 / height,
      "CUBEUV_MAX_MIP": `${lodMax}.0`
    },
    uniforms: {
      "envMap": { value: null },
      "samples": { value: 1 },
      "weights": { value: weights },
      "latitudinal": { value: false },
      "dTheta": { value: 0 },
      "mipInt": { value: 0 },
      "poleAxis": { value: poleAxis }
    },
    vertexShader: _getCommonVertexShader$1(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`
    ),
    blending: NoBlending$1,
    depthTest: false,
    depthWrite: false
  });
  return shaderMaterial;
}
function _getEquirectMaterial() {
  return new ShaderMaterial$1({
    name: "EquirectangularToCubeUV",
    uniforms: {
      "envMap": { value: null }
    },
    vertexShader: _getCommonVertexShader$1(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`
    ),
    blending: NoBlending$1,
    depthTest: false,
    depthWrite: false
  });
}
function _getCubemapMaterial() {
  return new ShaderMaterial$1({
    name: "CubemapToCubeUV",
    uniforms: {
      "envMap": { value: null },
      "flipEnvMap": { value: -1 }
    },
    vertexShader: _getCommonVertexShader$1(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`
    ),
    blending: NoBlending$1,
    depthTest: false,
    depthWrite: false
  });
}
function _getCommonVertexShader$1() {
  return (
    /* glsl */
    `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
  );
}
function WebGLCubeUVMaps$1(renderer) {
  let cubeUVmaps = /* @__PURE__ */ new WeakMap();
  let pmremGenerator = null;
  function get(texture) {
    if (texture && texture.isTexture) {
      const mapping = texture.mapping;
      const isEquirectMap = mapping === EquirectangularReflectionMapping$1 || mapping === EquirectangularRefractionMapping$1;
      const isCubeMap = mapping === CubeReflectionMapping$1 || mapping === CubeRefractionMapping$1;
      if (isEquirectMap || isCubeMap) {
        let renderTarget = cubeUVmaps.get(texture);
        const currentPMREMVersion = renderTarget !== void 0 ? renderTarget.texture.pmremVersion : 0;
        if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
          if (pmremGenerator === null) pmremGenerator = new PMREMGenerator$1(renderer);
          renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
          renderTarget.texture.pmremVersion = texture.pmremVersion;
          cubeUVmaps.set(texture, renderTarget);
          return renderTarget.texture;
        } else {
          if (renderTarget !== void 0) {
            return renderTarget.texture;
          } else {
            const image2 = texture.image;
            if (isEquirectMap && image2 && image2.height > 0 || isCubeMap && image2 && isCubeTextureComplete(image2)) {
              if (pmremGenerator === null) pmremGenerator = new PMREMGenerator$1(renderer);
              renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
              renderTarget.texture.pmremVersion = texture.pmremVersion;
              cubeUVmaps.set(texture, renderTarget);
              texture.addEventListener("dispose", onTextureDispose);
              return renderTarget.texture;
            } else {
              return null;
            }
          }
        }
      }
    }
    return texture;
  }
  function isCubeTextureComplete(image2) {
    let count = 0;
    const length2 = 6;
    for (let i2 = 0; i2 < length2; i2++) {
      if (image2[i2] !== void 0) count++;
    }
    return count === length2;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    const cubemapUV = cubeUVmaps.get(texture);
    if (cubemapUV !== void 0) {
      cubeUVmaps.delete(texture);
      cubemapUV.dispose();
    }
  }
  function dispose() {
    cubeUVmaps = /* @__PURE__ */ new WeakMap();
    if (pmremGenerator !== null) {
      pmremGenerator.dispose();
      pmremGenerator = null;
    }
  }
  return {
    get,
    dispose
  };
}
function WebGLExtensions$1(gl) {
  const extensions = {};
  function getExtension(name) {
    if (extensions[name] !== void 0) {
      return extensions[name];
    }
    let extension;
    switch (name) {
      case "WEBGL_depth_texture":
        extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        extension = gl.getExtension(name);
    }
    extensions[name] = extension;
    return extension;
  }
  return {
    has: function(name) {
      return getExtension(name) !== null;
    },
    init: function() {
      getExtension("EXT_color_buffer_float");
      getExtension("WEBGL_clip_cull_distance");
      getExtension("OES_texture_float_linear");
      getExtension("EXT_color_buffer_half_float");
      getExtension("WEBGL_multisampled_render_to_texture");
      getExtension("WEBGL_render_shared_exponent");
    },
    get: function(name) {
      const extension = getExtension(name);
      if (extension === null) {
        warnOnce("THREE.WebGLRenderer: " + name + " extension not supported.");
      }
      return extension;
    }
  };
}
function WebGLGeometries$1(gl, attributes, info, bindingStates) {
  const geometries = {};
  const wireframeAttributes = /* @__PURE__ */ new WeakMap();
  function onGeometryDispose(event) {
    const geometry = event.target;
    if (geometry.index !== null) {
      attributes.remove(geometry.index);
    }
    for (const name in geometry.attributes) {
      attributes.remove(geometry.attributes[name]);
    }
    geometry.removeEventListener("dispose", onGeometryDispose);
    delete geometries[geometry.id];
    const attribute = wireframeAttributes.get(geometry);
    if (attribute) {
      attributes.remove(attribute);
      wireframeAttributes.delete(geometry);
    }
    bindingStates.releaseStatesOfGeometry(geometry);
    if (geometry.isInstancedBufferGeometry === true) {
      delete geometry._maxInstanceCount;
    }
    info.memory.geometries--;
  }
  function get(object, geometry) {
    if (geometries[geometry.id] === true) return geometry;
    geometry.addEventListener("dispose", onGeometryDispose);
    geometries[geometry.id] = true;
    info.memory.geometries++;
    return geometry;
  }
  function update(geometry) {
    const geometryAttributes = geometry.attributes;
    for (const name in geometryAttributes) {
      attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
  }
  function updateWireframeAttribute(geometry) {
    const indices = [];
    const geometryIndex = geometry.index;
    const geometryPosition = geometry.attributes.position;
    let version = 0;
    if (geometryIndex !== null) {
      const array = geometryIndex.array;
      version = geometryIndex.version;
      for (let i2 = 0, l2 = array.length; i2 < l2; i2 += 3) {
        const a3 = array[i2 + 0];
        const b = array[i2 + 1];
        const c2 = array[i2 + 2];
        indices.push(a3, b, b, c2, c2, a3);
      }
    } else if (geometryPosition !== void 0) {
      const array = geometryPosition.array;
      version = geometryPosition.version;
      for (let i2 = 0, l2 = array.length / 3 - 1; i2 < l2; i2 += 3) {
        const a3 = i2 + 0;
        const b = i2 + 1;
        const c2 = i2 + 2;
        indices.push(a3, b, b, c2, c2, a3);
      }
    } else {
      return;
    }
    const attribute = new (arrayNeedsUint32(indices) ? Uint32BufferAttribute$1 : Uint16BufferAttribute$1)(indices, 1);
    attribute.version = version;
    const previousAttribute = wireframeAttributes.get(geometry);
    if (previousAttribute) attributes.remove(previousAttribute);
    wireframeAttributes.set(geometry, attribute);
  }
  function getWireframeAttribute(geometry) {
    const currentAttribute = wireframeAttributes.get(geometry);
    if (currentAttribute) {
      const geometryIndex = geometry.index;
      if (geometryIndex !== null) {
        if (currentAttribute.version < geometryIndex.version) {
          updateWireframeAttribute(geometry);
        }
      }
    } else {
      updateWireframeAttribute(geometry);
    }
    return wireframeAttributes.get(geometry);
  }
  return {
    get,
    update,
    getWireframeAttribute
  };
}
function WebGLIndexedBufferRenderer$1(gl, extensions, info) {
  let mode;
  function setMode(value) {
    mode = value;
  }
  let type, bytesPerElement;
  function setIndex(value) {
    type = value.type;
    bytesPerElement = value.bytesPerElement;
  }
  function render(start, count) {
    gl.drawElements(mode, count, type, start * bytesPerElement);
    info.update(count, mode, 1);
  }
  function renderInstances(start, count, primcount) {
    if (primcount === 0) return;
    gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
    info.update(count, mode, primcount);
  }
  function renderMultiDraw(starts, counts, drawCount) {
    if (drawCount === 0) return;
    const extension = extensions.get("WEBGL_multi_draw");
    extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
    let elementCount = 0;
    for (let i2 = 0; i2 < drawCount; i2++) {
      elementCount += counts[i2];
    }
    info.update(elementCount, mode, 1);
  }
  function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
    if (drawCount === 0) return;
    const extension = extensions.get("WEBGL_multi_draw");
    if (extension === null) {
      for (let i2 = 0; i2 < starts.length; i2++) {
        renderInstances(starts[i2] / bytesPerElement, counts[i2], primcount[i2]);
      }
    } else {
      extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
      let elementCount = 0;
      for (let i2 = 0; i2 < drawCount; i2++) {
        elementCount += counts[i2] * primcount[i2];
      }
      info.update(elementCount, mode, 1);
    }
  }
  this.setMode = setMode;
  this.setIndex = setIndex;
  this.render = render;
  this.renderInstances = renderInstances;
  this.renderMultiDraw = renderMultiDraw;
  this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function WebGLInfo$1(gl) {
  const memory = {
    geometries: 0,
    textures: 0
  };
  const render = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function update(count, mode, instanceCount) {
    render.calls++;
    switch (mode) {
      case gl.TRIANGLES:
        render.triangles += instanceCount * (count / 3);
        break;
      case gl.LINES:
        render.lines += instanceCount * (count / 2);
        break;
      case gl.LINE_STRIP:
        render.lines += instanceCount * (count - 1);
        break;
      case gl.LINE_LOOP:
        render.lines += instanceCount * count;
        break;
      case gl.POINTS:
        render.points += instanceCount * count;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
        break;
    }
  }
  function reset() {
    render.calls = 0;
    render.triangles = 0;
    render.points = 0;
    render.lines = 0;
  }
  return {
    memory,
    render,
    programs: null,
    autoReset: true,
    reset,
    update
  };
}
function WebGLMorphtargets$1(gl, capabilities, textures) {
  const morphTextures = /* @__PURE__ */ new WeakMap();
  const morph = new Vector4$1();
  function update(object, geometry, program) {
    const objectInfluences = object.morphTargetInfluences;
    const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
    const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
    let entry = morphTextures.get(geometry);
    if (entry === void 0 || entry.count !== morphTargetsCount) {
      let disposeTexture = function() {
        texture.dispose();
        morphTextures.delete(geometry);
        geometry.removeEventListener("dispose", disposeTexture);
      };
      if (entry !== void 0) entry.texture.dispose();
      const hasMorphPosition = geometry.morphAttributes.position !== void 0;
      const hasMorphNormals = geometry.morphAttributes.normal !== void 0;
      const hasMorphColors = geometry.morphAttributes.color !== void 0;
      const morphTargets = geometry.morphAttributes.position || [];
      const morphNormals = geometry.morphAttributes.normal || [];
      const morphColors = geometry.morphAttributes.color || [];
      let vertexDataCount = 0;
      if (hasMorphPosition === true) vertexDataCount = 1;
      if (hasMorphNormals === true) vertexDataCount = 2;
      if (hasMorphColors === true) vertexDataCount = 3;
      let width = geometry.attributes.position.count * vertexDataCount;
      let height = 1;
      if (width > capabilities.maxTextureSize) {
        height = Math.ceil(width / capabilities.maxTextureSize);
        width = capabilities.maxTextureSize;
      }
      const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
      const texture = new DataArrayTexture(buffer, width, height, morphTargetsCount);
      texture.type = FloatType$1;
      texture.needsUpdate = true;
      const vertexDataStride = vertexDataCount * 4;
      for (let i2 = 0; i2 < morphTargetsCount; i2++) {
        const morphTarget = morphTargets[i2];
        const morphNormal = morphNormals[i2];
        const morphColor = morphColors[i2];
        const offset = width * height * 4 * i2;
        for (let j = 0; j < morphTarget.count; j++) {
          const stride = j * vertexDataStride;
          if (hasMorphPosition === true) {
            morph.fromBufferAttribute(morphTarget, j);
            buffer[offset + stride + 0] = morph.x;
            buffer[offset + stride + 1] = morph.y;
            buffer[offset + stride + 2] = morph.z;
            buffer[offset + stride + 3] = 0;
          }
          if (hasMorphNormals === true) {
            morph.fromBufferAttribute(morphNormal, j);
            buffer[offset + stride + 4] = morph.x;
            buffer[offset + stride + 5] = morph.y;
            buffer[offset + stride + 6] = morph.z;
            buffer[offset + stride + 7] = 0;
          }
          if (hasMorphColors === true) {
            morph.fromBufferAttribute(morphColor, j);
            buffer[offset + stride + 8] = morph.x;
            buffer[offset + stride + 9] = morph.y;
            buffer[offset + stride + 10] = morph.z;
            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
          }
        }
      }
      entry = {
        count: morphTargetsCount,
        texture,
        size: new Vector2$1(width, height)
      };
      morphTextures.set(geometry, entry);
      geometry.addEventListener("dispose", disposeTexture);
    }
    if (object.isInstancedMesh === true && object.morphTexture !== null) {
      program.getUniforms().setValue(gl, "morphTexture", object.morphTexture, textures);
    } else {
      let morphInfluencesSum = 0;
      for (let i2 = 0; i2 < objectInfluences.length; i2++) {
        morphInfluencesSum += objectInfluences[i2];
      }
      const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
      program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
      program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
    }
    program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
    program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
  }
  return {
    update
  };
}
function WebGLObjects$1(gl, geometries, attributes, info) {
  let updateMap = /* @__PURE__ */ new WeakMap();
  function update(object) {
    const frame = info.render.frame;
    const geometry = object.geometry;
    const buffergeometry = geometries.get(object, geometry);
    if (updateMap.get(buffergeometry) !== frame) {
      geometries.update(buffergeometry);
      updateMap.set(buffergeometry, frame);
    }
    if (object.isInstancedMesh) {
      if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) {
        object.addEventListener("dispose", onInstancedMeshDispose);
      }
      if (updateMap.get(object) !== frame) {
        attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
        if (object.instanceColor !== null) {
          attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
        }
        updateMap.set(object, frame);
      }
    }
    if (object.isSkinnedMesh) {
      const skeleton = object.skeleton;
      if (updateMap.get(skeleton) !== frame) {
        skeleton.update();
        updateMap.set(skeleton, frame);
      }
    }
    return buffergeometry;
  }
  function dispose() {
    updateMap = /* @__PURE__ */ new WeakMap();
  }
  function onInstancedMeshDispose(event) {
    const instancedMesh = event.target;
    instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
    attributes.remove(instancedMesh.instanceMatrix);
    if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
  }
  return {
    update,
    dispose
  };
}
const emptyTexture$1 = /* @__PURE__ */ new Texture$1();
const emptyShadowTexture = /* @__PURE__ */ new DepthTexture$1(1, 1);
const emptyArrayTexture = /* @__PURE__ */ new DataArrayTexture();
const empty3dTexture = /* @__PURE__ */ new Data3DTexture();
const emptyCubeTexture$1 = /* @__PURE__ */ new CubeTexture$1();
const arrayCacheF32$1 = [];
const arrayCacheI32$1 = [];
const mat4array$1 = new Float32Array(16);
const mat3array$1 = new Float32Array(9);
const mat2array$1 = new Float32Array(4);
function flatten$1(array, nBlocks, blockSize) {
  const firstElem = array[0];
  if (firstElem <= 0 || firstElem > 0) return array;
  const n2 = nBlocks * blockSize;
  let r2 = arrayCacheF32$1[n2];
  if (r2 === void 0) {
    r2 = new Float32Array(n2);
    arrayCacheF32$1[n2] = r2;
  }
  if (nBlocks !== 0) {
    firstElem.toArray(r2, 0);
    for (let i2 = 1, offset = 0; i2 !== nBlocks; ++i2) {
      offset += blockSize;
      array[i2].toArray(r2, offset);
    }
  }
  return r2;
}
function arraysEqual$1(a3, b) {
  if (a3.length !== b.length) return false;
  for (let i2 = 0, l2 = a3.length; i2 < l2; i2++) {
    if (a3[i2] !== b[i2]) return false;
  }
  return true;
}
function copyArray$1(a3, b) {
  for (let i2 = 0, l2 = b.length; i2 < l2; i2++) {
    a3[i2] = b[i2];
  }
}
function allocTexUnits$1(textures, n2) {
  let r2 = arrayCacheI32$1[n2];
  if (r2 === void 0) {
    r2 = new Int32Array(n2);
    arrayCacheI32$1[n2] = r2;
  }
  for (let i2 = 0; i2 !== n2; ++i2) {
    r2[i2] = textures.allocateTextureUnit();
  }
  return r2;
}
function setValueV1f$1(gl, v) {
  const cache = this.cache;
  if (cache[0] === v) return;
  gl.uniform1f(this.addr, v);
  cache[0] = v;
}
function setValueV2f$1(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y) {
      gl.uniform2f(this.addr, v.x, v.y);
      cache[0] = v.x;
      cache[1] = v.y;
    }
  } else {
    if (arraysEqual$1(cache, v)) return;
    gl.uniform2fv(this.addr, v);
    copyArray$1(cache, v);
  }
}
function setValueV3f$1(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
      gl.uniform3f(this.addr, v.x, v.y, v.z);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
    }
  } else if (v.r !== void 0) {
    if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
      gl.uniform3f(this.addr, v.r, v.g, v.b);
      cache[0] = v.r;
      cache[1] = v.g;
      cache[2] = v.b;
    }
  } else {
    if (arraysEqual$1(cache, v)) return;
    gl.uniform3fv(this.addr, v);
    copyArray$1(cache, v);
  }
}
function setValueV4f$1(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
      gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
      cache[3] = v.w;
    }
  } else {
    if (arraysEqual$1(cache, v)) return;
    gl.uniform4fv(this.addr, v);
    copyArray$1(cache, v);
  }
}
function setValueM2$1(gl, v) {
  const cache = this.cache;
  const elements = v.elements;
  if (elements === void 0) {
    if (arraysEqual$1(cache, v)) return;
    gl.uniformMatrix2fv(this.addr, false, v);
    copyArray$1(cache, v);
  } else {
    if (arraysEqual$1(cache, elements)) return;
    mat2array$1.set(elements);
    gl.uniformMatrix2fv(this.addr, false, mat2array$1);
    copyArray$1(cache, elements);
  }
}
function setValueM3$1(gl, v) {
  const cache = this.cache;
  const elements = v.elements;
  if (elements === void 0) {
    if (arraysEqual$1(cache, v)) return;
    gl.uniformMatrix3fv(this.addr, false, v);
    copyArray$1(cache, v);
  } else {
    if (arraysEqual$1(cache, elements)) return;
    mat3array$1.set(elements);
    gl.uniformMatrix3fv(this.addr, false, mat3array$1);
    copyArray$1(cache, elements);
  }
}
function setValueM4$1(gl, v) {
  const cache = this.cache;
  const elements = v.elements;
  if (elements === void 0) {
    if (arraysEqual$1(cache, v)) return;
    gl.uniformMatrix4fv(this.addr, false, v);
    copyArray$1(cache, v);
  } else {
    if (arraysEqual$1(cache, elements)) return;
    mat4array$1.set(elements);
    gl.uniformMatrix4fv(this.addr, false, mat4array$1);
    copyArray$1(cache, elements);
  }
}
function setValueV1i$1(gl, v) {
  const cache = this.cache;
  if (cache[0] === v) return;
  gl.uniform1i(this.addr, v);
  cache[0] = v;
}
function setValueV2i$1(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y) {
      gl.uniform2i(this.addr, v.x, v.y);
      cache[0] = v.x;
      cache[1] = v.y;
    }
  } else {
    if (arraysEqual$1(cache, v)) return;
    gl.uniform2iv(this.addr, v);
    copyArray$1(cache, v);
  }
}
function setValueV3i$1(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
      gl.uniform3i(this.addr, v.x, v.y, v.z);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
    }
  } else {
    if (arraysEqual$1(cache, v)) return;
    gl.uniform3iv(this.addr, v);
    copyArray$1(cache, v);
  }
}
function setValueV4i$1(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
      gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
      cache[3] = v.w;
    }
  } else {
    if (arraysEqual$1(cache, v)) return;
    gl.uniform4iv(this.addr, v);
    copyArray$1(cache, v);
  }
}
function setValueV1ui$1(gl, v) {
  const cache = this.cache;
  if (cache[0] === v) return;
  gl.uniform1ui(this.addr, v);
  cache[0] = v;
}
function setValueV2ui$1(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y) {
      gl.uniform2ui(this.addr, v.x, v.y);
      cache[0] = v.x;
      cache[1] = v.y;
    }
  } else {
    if (arraysEqual$1(cache, v)) return;
    gl.uniform2uiv(this.addr, v);
    copyArray$1(cache, v);
  }
}
function setValueV3ui$1(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
      gl.uniform3ui(this.addr, v.x, v.y, v.z);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
    }
  } else {
    if (arraysEqual$1(cache, v)) return;
    gl.uniform3uiv(this.addr, v);
    copyArray$1(cache, v);
  }
}
function setValueV4ui$1(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
      gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
      cache[3] = v.w;
    }
  } else {
    if (arraysEqual$1(cache, v)) return;
    gl.uniform4uiv(this.addr, v);
    copyArray$1(cache, v);
  }
}
function setValueT1$1(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  let emptyTexture2D;
  if (this.type === gl.SAMPLER_2D_SHADOW) {
    emptyShadowTexture.compareFunction = LessEqualCompare;
    emptyTexture2D = emptyShadowTexture;
  } else {
    emptyTexture2D = emptyTexture$1;
  }
  textures.setTexture2D(v || emptyTexture2D, unit);
}
function setValueT3D1$1(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.setTexture3D(v || empty3dTexture, unit);
}
function setValueT6$1(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.setTextureCube(v || emptyCubeTexture$1, unit);
}
function setValueT2DArray1$1(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.setTexture2DArray(v || emptyArrayTexture, unit);
}
function getSingularSetter$1(type) {
  switch (type) {
    case 5126:
      return setValueV1f$1;
    case 35664:
      return setValueV2f$1;
    case 35665:
      return setValueV3f$1;
    case 35666:
      return setValueV4f$1;
    case 35674:
      return setValueM2$1;
    case 35675:
      return setValueM3$1;
    case 35676:
      return setValueM4$1;
    case 5124:
    case 35670:
      return setValueV1i$1;
    case 35667:
    case 35671:
      return setValueV2i$1;
    case 35668:
    case 35672:
      return setValueV3i$1;
    case 35669:
    case 35673:
      return setValueV4i$1;
    case 5125:
      return setValueV1ui$1;
    case 36294:
      return setValueV2ui$1;
    case 36295:
      return setValueV3ui$1;
    case 36296:
      return setValueV4ui$1;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return setValueT1$1;
    case 35679:
    case 36299:
    case 36307:
      return setValueT3D1$1;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return setValueT6$1;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return setValueT2DArray1$1;
  }
}
function setValueV1fArray$1(gl, v) {
  gl.uniform1fv(this.addr, v);
}
function setValueV2fArray$1(gl, v) {
  const data = flatten$1(v, this.size, 2);
  gl.uniform2fv(this.addr, data);
}
function setValueV3fArray$1(gl, v) {
  const data = flatten$1(v, this.size, 3);
  gl.uniform3fv(this.addr, data);
}
function setValueV4fArray$1(gl, v) {
  const data = flatten$1(v, this.size, 4);
  gl.uniform4fv(this.addr, data);
}
function setValueM2Array$1(gl, v) {
  const data = flatten$1(v, this.size, 4);
  gl.uniformMatrix2fv(this.addr, false, data);
}
function setValueM3Array$1(gl, v) {
  const data = flatten$1(v, this.size, 9);
  gl.uniformMatrix3fv(this.addr, false, data);
}
function setValueM4Array$1(gl, v) {
  const data = flatten$1(v, this.size, 16);
  gl.uniformMatrix4fv(this.addr, false, data);
}
function setValueV1iArray$1(gl, v) {
  gl.uniform1iv(this.addr, v);
}
function setValueV2iArray$1(gl, v) {
  gl.uniform2iv(this.addr, v);
}
function setValueV3iArray$1(gl, v) {
  gl.uniform3iv(this.addr, v);
}
function setValueV4iArray$1(gl, v) {
  gl.uniform4iv(this.addr, v);
}
function setValueV1uiArray$1(gl, v) {
  gl.uniform1uiv(this.addr, v);
}
function setValueV2uiArray$1(gl, v) {
  gl.uniform2uiv(this.addr, v);
}
function setValueV3uiArray$1(gl, v) {
  gl.uniform3uiv(this.addr, v);
}
function setValueV4uiArray$1(gl, v) {
  gl.uniform4uiv(this.addr, v);
}
function setValueT1Array$1(gl, v, textures) {
  const cache = this.cache;
  const n2 = v.length;
  const units = allocTexUnits$1(textures, n2);
  if (!arraysEqual$1(cache, units)) {
    gl.uniform1iv(this.addr, units);
    copyArray$1(cache, units);
  }
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.setTexture2D(v[i2] || emptyTexture$1, units[i2]);
  }
}
function setValueT3DArray(gl, v, textures) {
  const cache = this.cache;
  const n2 = v.length;
  const units = allocTexUnits$1(textures, n2);
  if (!arraysEqual$1(cache, units)) {
    gl.uniform1iv(this.addr, units);
    copyArray$1(cache, units);
  }
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.setTexture3D(v[i2] || empty3dTexture, units[i2]);
  }
}
function setValueT6Array$1(gl, v, textures) {
  const cache = this.cache;
  const n2 = v.length;
  const units = allocTexUnits$1(textures, n2);
  if (!arraysEqual$1(cache, units)) {
    gl.uniform1iv(this.addr, units);
    copyArray$1(cache, units);
  }
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.setTextureCube(v[i2] || emptyCubeTexture$1, units[i2]);
  }
}
function setValueT2DArrayArray(gl, v, textures) {
  const cache = this.cache;
  const n2 = v.length;
  const units = allocTexUnits$1(textures, n2);
  if (!arraysEqual$1(cache, units)) {
    gl.uniform1iv(this.addr, units);
    copyArray$1(cache, units);
  }
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.setTexture2DArray(v[i2] || emptyArrayTexture, units[i2]);
  }
}
function getPureArraySetter$1(type) {
  switch (type) {
    case 5126:
      return setValueV1fArray$1;
    case 35664:
      return setValueV2fArray$1;
    case 35665:
      return setValueV3fArray$1;
    case 35666:
      return setValueV4fArray$1;
    case 35674:
      return setValueM2Array$1;
    case 35675:
      return setValueM3Array$1;
    case 35676:
      return setValueM4Array$1;
    case 5124:
    case 35670:
      return setValueV1iArray$1;
    case 35667:
    case 35671:
      return setValueV2iArray$1;
    case 35668:
    case 35672:
      return setValueV3iArray$1;
    case 35669:
    case 35673:
      return setValueV4iArray$1;
    case 5125:
      return setValueV1uiArray$1;
    case 36294:
      return setValueV2uiArray$1;
    case 36295:
      return setValueV3uiArray$1;
    case 36296:
      return setValueV4uiArray$1;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return setValueT1Array$1;
    case 35679:
    case 36299:
    case 36307:
      return setValueT3DArray;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return setValueT6Array$1;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return setValueT2DArrayArray;
  }
}
let SingleUniform$1 = class SingleUniform {
  constructor(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.type = activeInfo.type;
    this.setValue = getSingularSetter$1(activeInfo.type);
  }
};
let PureArrayUniform$1 = class PureArrayUniform {
  constructor(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.type = activeInfo.type;
    this.size = activeInfo.size;
    this.setValue = getPureArraySetter$1(activeInfo.type);
  }
};
let StructuredUniform$1 = class StructuredUniform {
  constructor(id) {
    this.id = id;
    this.seq = [];
    this.map = {};
  }
  setValue(gl, value, textures) {
    const seq = this.seq;
    for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
      const u3 = seq[i2];
      u3.setValue(gl, value[u3.id], textures);
    }
  }
};
const RePathPart$1 = /(\w+)(\])?(\[|\.)?/g;
function addUniform$1(container, uniformObject) {
  container.seq.push(uniformObject);
  container.map[uniformObject.id] = uniformObject;
}
function parseUniform$1(activeInfo, addr, container) {
  const path = activeInfo.name, pathLength = path.length;
  RePathPart$1.lastIndex = 0;
  while (true) {
    const match = RePathPart$1.exec(path), matchEnd = RePathPart$1.lastIndex;
    let id = match[1];
    const idIsIndex = match[2] === "]", subscript = match[3];
    if (idIsIndex) id = id | 0;
    if (subscript === void 0 || subscript === "[" && matchEnd + 2 === pathLength) {
      addUniform$1(container, subscript === void 0 ? new SingleUniform$1(id, activeInfo, addr) : new PureArrayUniform$1(id, activeInfo, addr));
      break;
    } else {
      const map = container.map;
      let next = map[id];
      if (next === void 0) {
        next = new StructuredUniform$1(id);
        addUniform$1(container, next);
      }
      container = next;
    }
  }
}
let WebGLUniforms$1 = class WebGLUniforms {
  constructor(gl, program) {
    this.seq = [];
    this.map = {};
    const n2 = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
    for (let i2 = 0; i2 < n2; ++i2) {
      const info = gl.getActiveUniform(program, i2), addr = gl.getUniformLocation(program, info.name);
      parseUniform$1(info, addr, this);
    }
  }
  setValue(gl, name, value, textures) {
    const u3 = this.map[name];
    if (u3 !== void 0) u3.setValue(gl, value, textures);
  }
  setOptional(gl, object, name) {
    const v = object[name];
    if (v !== void 0) this.setValue(gl, name, v);
  }
  static upload(gl, seq, values, textures) {
    for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
      const u3 = seq[i2], v = values[u3.id];
      if (v.needsUpdate !== false) {
        u3.setValue(gl, v.value, textures);
      }
    }
  }
  static seqWithValue(seq, values) {
    const r2 = [];
    for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
      const u3 = seq[i2];
      if (u3.id in values) r2.push(u3);
    }
    return r2;
  }
};
function WebGLShader$1(gl, type, string) {
  const shader = gl.createShader(type);
  gl.shaderSource(shader, string);
  gl.compileShader(shader);
  return shader;
}
const COMPLETION_STATUS_KHR = 37297;
let programIdCount$1 = 0;
function handleSource(string, errorLine) {
  const lines = string.split("\n");
  const lines2 = [];
  const from = Math.max(errorLine - 6, 0);
  const to = Math.min(errorLine + 6, lines.length);
  for (let i2 = from; i2 < to; i2++) {
    const line = i2 + 1;
    lines2.push(`${line === errorLine ? ">" : " "} ${line}: ${lines[i2]}`);
  }
  return lines2.join("\n");
}
const _m0 = /* @__PURE__ */ new Matrix3$1();
function getEncodingComponents$1(colorSpace) {
  ColorManagement._getMatrix(_m0, ColorManagement.workingColorSpace, colorSpace);
  const encodingMatrix = `mat3( ${_m0.elements.map((v) => v.toFixed(4))} )`;
  switch (ColorManagement.getTransfer(colorSpace)) {
    case LinearTransfer:
      return [encodingMatrix, "LinearTransferOETF"];
    case SRGBTransfer:
      return [encodingMatrix, "sRGBTransferOETF"];
    default:
      console.warn("THREE.WebGLProgram: Unsupported color space: ", colorSpace);
      return [encodingMatrix, "LinearTransferOETF"];
  }
}
function getShaderErrors$1(gl, shader, type) {
  const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
  const errors = gl.getShaderInfoLog(shader).trim();
  if (status && errors === "") return "";
  const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
  if (errorMatches) {
    const errorLine = parseInt(errorMatches[1]);
    return type.toUpperCase() + "\n\n" + errors + "\n\n" + handleSource(gl.getShaderSource(shader), errorLine);
  } else {
    return errors;
  }
}
function getTexelEncodingFunction$1(functionName, colorSpace) {
  const components = getEncodingComponents$1(colorSpace);
  return [
    `vec4 ${functionName}( vec4 value ) {`,
    `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
    "}"
  ].join("\n");
}
function getToneMappingFunction$1(functionName, toneMapping) {
  let toneMappingName;
  switch (toneMapping) {
    case LinearToneMapping$1:
      toneMappingName = "Linear";
      break;
    case ReinhardToneMapping$1:
      toneMappingName = "Reinhard";
      break;
    case CineonToneMapping$1:
      toneMappingName = "Cineon";
      break;
    case ACESFilmicToneMapping$1:
      toneMappingName = "ACESFilmic";
      break;
    case AgXToneMapping:
      toneMappingName = "AgX";
      break;
    case NeutralToneMapping:
      toneMappingName = "Neutral";
      break;
    case CustomToneMapping$1:
      toneMappingName = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
      toneMappingName = "Linear";
  }
  return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
const _v0 = /* @__PURE__ */ new Vector3$1();
function getLuminanceFunction() {
  ColorManagement.getLuminanceCoefficients(_v0);
  const r2 = _v0.x.toFixed(4);
  const g3 = _v0.y.toFixed(4);
  const b = _v0.z.toFixed(4);
  return [
    "float luminance( const in vec3 rgb ) {",
    `	const vec3 weights = vec3( ${r2}, ${g3}, ${b} );`,
    "	return dot( weights, rgb );",
    "}"
  ].join("\n");
}
function generateVertexExtensions(parameters) {
  const chunks = [
    parameters.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
    parameters.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
  ];
  return chunks.filter(filterEmptyLine$1).join("\n");
}
function generateDefines$1(defines) {
  const chunks = [];
  for (const name in defines) {
    const value = defines[name];
    if (value === false) continue;
    chunks.push("#define " + name + " " + value);
  }
  return chunks.join("\n");
}
function fetchAttributeLocations$1(gl, program) {
  const attributes = {};
  const n2 = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
  for (let i2 = 0; i2 < n2; i2++) {
    const info = gl.getActiveAttrib(program, i2);
    const name = info.name;
    let locationSize = 1;
    if (info.type === gl.FLOAT_MAT2) locationSize = 2;
    if (info.type === gl.FLOAT_MAT3) locationSize = 3;
    if (info.type === gl.FLOAT_MAT4) locationSize = 4;
    attributes[name] = {
      type: info.type,
      location: gl.getAttribLocation(program, name),
      locationSize
    };
  }
  return attributes;
}
function filterEmptyLine$1(string) {
  return string !== "";
}
function replaceLightNums$1(string, parameters) {
  const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
  return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function replaceClippingPlaneNums$1(string, parameters) {
  return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
const includePattern$1 = /^[ \t]*#include +<([\w\d./]+)>/gm;
function resolveIncludes$1(string) {
  return string.replace(includePattern$1, includeReplacer$1);
}
const shaderChunkMap = /* @__PURE__ */ new Map();
function includeReplacer$1(match, include) {
  let string = ShaderChunk$1[include];
  if (string === void 0) {
    const newInclude = shaderChunkMap.get(include);
    if (newInclude !== void 0) {
      string = ShaderChunk$1[newInclude];
      console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
    } else {
      throw new Error("Can not resolve #include <" + include + ">");
    }
  }
  return resolveIncludes$1(string);
}
const unrollLoopPattern$1 = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function unrollLoops$1(string) {
  return string.replace(unrollLoopPattern$1, loopReplacer$1);
}
function loopReplacer$1(match, start, end, snippet) {
  let string = "";
  for (let i2 = parseInt(start); i2 < parseInt(end); i2++) {
    string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i2 + " ]").replace(/UNROLLED_LOOP_INDEX/g, i2);
  }
  return string;
}
function generatePrecision$1(parameters) {
  let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
  if (parameters.precision === "highp") {
    precisionstring += "\n#define HIGH_PRECISION";
  } else if (parameters.precision === "mediump") {
    precisionstring += "\n#define MEDIUM_PRECISION";
  } else if (parameters.precision === "lowp") {
    precisionstring += "\n#define LOW_PRECISION";
  }
  return precisionstring;
}
function generateShadowMapTypeDefine$1(parameters) {
  let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
  if (parameters.shadowMapType === PCFShadowMap$1) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
  } else if (parameters.shadowMapType === PCFSoftShadowMap$1) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
  } else if (parameters.shadowMapType === VSMShadowMap$1) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
  }
  return shadowMapTypeDefine;
}
function generateEnvMapTypeDefine$1(parameters) {
  let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeReflectionMapping$1:
      case CubeRefractionMapping$1:
        envMapTypeDefine = "ENVMAP_TYPE_CUBE";
        break;
      case CubeUVReflectionMapping$1:
        envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
        break;
    }
  }
  return envMapTypeDefine;
}
function generateEnvMapModeDefine$1(parameters) {
  let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeRefractionMapping$1:
        envMapModeDefine = "ENVMAP_MODE_REFRACTION";
        break;
    }
  }
  return envMapModeDefine;
}
function generateEnvMapBlendingDefine$1(parameters) {
  let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
  if (parameters.envMap) {
    switch (parameters.combine) {
      case MultiplyOperation$1:
        envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
        break;
      case MixOperation$1:
        envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
        break;
      case AddOperation$1:
        envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
        break;
    }
  }
  return envMapBlendingDefine;
}
function generateCubeUVSize(parameters) {
  const imageHeight = parameters.envMapCubeUVHeight;
  if (imageHeight === null) return null;
  const maxMip = Math.log2(imageHeight) - 2;
  const texelHeight = 1 / imageHeight;
  const texelWidth = 1 / (3 * Math.max(Math.pow(2, maxMip), 7 * 16));
  return { texelWidth, texelHeight, maxMip };
}
function WebGLProgram$1(renderer, cacheKey, parameters, bindingStates) {
  const gl = renderer.getContext();
  const defines = parameters.defines;
  let vertexShader = parameters.vertexShader;
  let fragmentShader = parameters.fragmentShader;
  const shadowMapTypeDefine = generateShadowMapTypeDefine$1(parameters);
  const envMapTypeDefine = generateEnvMapTypeDefine$1(parameters);
  const envMapModeDefine = generateEnvMapModeDefine$1(parameters);
  const envMapBlendingDefine = generateEnvMapBlendingDefine$1(parameters);
  const envMapCubeUVSize = generateCubeUVSize(parameters);
  const customVertexExtensions = generateVertexExtensions(parameters);
  const customDefines = generateDefines$1(defines);
  const program = gl.createProgram();
  let prefixVertex, prefixFragment;
  let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
  if (parameters.isRawShaderMaterial) {
    prefixVertex = [
      "#define SHADER_TYPE " + parameters.shaderType,
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines
    ].filter(filterEmptyLine$1).join("\n");
    if (prefixVertex.length > 0) {
      prefixVertex += "\n";
    }
    prefixFragment = [
      "#define SHADER_TYPE " + parameters.shaderType,
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines
    ].filter(filterEmptyLine$1).join("\n");
    if (prefixFragment.length > 0) {
      prefixFragment += "\n";
    }
  } else {
    prefixVertex = [
      generatePrecision$1(parameters),
      "#define SHADER_TYPE " + parameters.shaderType,
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines,
      parameters.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
      parameters.batching ? "#define USE_BATCHING" : "",
      parameters.batchingColor ? "#define USE_BATCHING_COLOR" : "",
      parameters.instancing ? "#define USE_INSTANCING" : "",
      parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
      parameters.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
      parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
      parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
      parameters.map ? "#define USE_MAP" : "",
      parameters.envMap ? "#define USE_ENVMAP" : "",
      parameters.envMap ? "#define " + envMapModeDefine : "",
      parameters.lightMap ? "#define USE_LIGHTMAP" : "",
      parameters.aoMap ? "#define USE_AOMAP" : "",
      parameters.bumpMap ? "#define USE_BUMPMAP" : "",
      parameters.normalMap ? "#define USE_NORMALMAP" : "",
      parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
      parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
      parameters.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
      parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
      parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
      parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
      parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
      parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
      parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
      parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
      parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
      parameters.specularMap ? "#define USE_SPECULARMAP" : "",
      parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
      parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
      parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
      parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
      parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
      parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
      parameters.transmission ? "#define USE_TRANSMISSION" : "",
      parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
      parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
      parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
      parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
      //
      parameters.mapUv ? "#define MAP_UV " + parameters.mapUv : "",
      parameters.alphaMapUv ? "#define ALPHAMAP_UV " + parameters.alphaMapUv : "",
      parameters.lightMapUv ? "#define LIGHTMAP_UV " + parameters.lightMapUv : "",
      parameters.aoMapUv ? "#define AOMAP_UV " + parameters.aoMapUv : "",
      parameters.emissiveMapUv ? "#define EMISSIVEMAP_UV " + parameters.emissiveMapUv : "",
      parameters.bumpMapUv ? "#define BUMPMAP_UV " + parameters.bumpMapUv : "",
      parameters.normalMapUv ? "#define NORMALMAP_UV " + parameters.normalMapUv : "",
      parameters.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + parameters.displacementMapUv : "",
      parameters.metalnessMapUv ? "#define METALNESSMAP_UV " + parameters.metalnessMapUv : "",
      parameters.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + parameters.roughnessMapUv : "",
      parameters.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + parameters.anisotropyMapUv : "",
      parameters.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + parameters.clearcoatMapUv : "",
      parameters.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + parameters.clearcoatNormalMapUv : "",
      parameters.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + parameters.clearcoatRoughnessMapUv : "",
      parameters.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + parameters.iridescenceMapUv : "",
      parameters.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + parameters.iridescenceThicknessMapUv : "",
      parameters.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + parameters.sheenColorMapUv : "",
      parameters.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + parameters.sheenRoughnessMapUv : "",
      parameters.specularMapUv ? "#define SPECULARMAP_UV " + parameters.specularMapUv : "",
      parameters.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + parameters.specularColorMapUv : "",
      parameters.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + parameters.specularIntensityMapUv : "",
      parameters.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + parameters.transmissionMapUv : "",
      parameters.thicknessMapUv ? "#define THICKNESSMAP_UV " + parameters.thicknessMapUv : "",
      //
      parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
      parameters.vertexColors ? "#define USE_COLOR" : "",
      parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
      parameters.vertexUv1s ? "#define USE_UV1" : "",
      parameters.vertexUv2s ? "#define USE_UV2" : "",
      parameters.vertexUv3s ? "#define USE_UV3" : "",
      parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
      parameters.flatShading ? "#define FLAT_SHADED" : "",
      parameters.skinning ? "#define USE_SKINNING" : "",
      parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
      parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
      parameters.morphColors ? "#define USE_MORPHCOLORS" : "",
      parameters.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
      parameters.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
      parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
      parameters.flipSided ? "#define FLIP_SIDED" : "",
      parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
      parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
      parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
      parameters.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
      parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
      parameters.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
      "uniform mat4 modelMatrix;",
      "uniform mat4 modelViewMatrix;",
      "uniform mat4 projectionMatrix;",
      "uniform mat4 viewMatrix;",
      "uniform mat3 normalMatrix;",
      "uniform vec3 cameraPosition;",
      "uniform bool isOrthographic;",
      "#ifdef USE_INSTANCING",
      "	attribute mat4 instanceMatrix;",
      "#endif",
      "#ifdef USE_INSTANCING_COLOR",
      "	attribute vec3 instanceColor;",
      "#endif",
      "#ifdef USE_INSTANCING_MORPH",
      "	uniform sampler2D morphTexture;",
      "#endif",
      "attribute vec3 position;",
      "attribute vec3 normal;",
      "attribute vec2 uv;",
      "#ifdef USE_UV1",
      "	attribute vec2 uv1;",
      "#endif",
      "#ifdef USE_UV2",
      "	attribute vec2 uv2;",
      "#endif",
      "#ifdef USE_UV3",
      "	attribute vec2 uv3;",
      "#endif",
      "#ifdef USE_TANGENT",
      "	attribute vec4 tangent;",
      "#endif",
      "#if defined( USE_COLOR_ALPHA )",
      "	attribute vec4 color;",
      "#elif defined( USE_COLOR )",
      "	attribute vec3 color;",
      "#endif",
      "#ifdef USE_SKINNING",
      "	attribute vec4 skinIndex;",
      "	attribute vec4 skinWeight;",
      "#endif",
      "\n"
    ].filter(filterEmptyLine$1).join("\n");
    prefixFragment = [
      generatePrecision$1(parameters),
      "#define SHADER_TYPE " + parameters.shaderType,
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines,
      parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
      parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
      parameters.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
      parameters.map ? "#define USE_MAP" : "",
      parameters.matcap ? "#define USE_MATCAP" : "",
      parameters.envMap ? "#define USE_ENVMAP" : "",
      parameters.envMap ? "#define " + envMapTypeDefine : "",
      parameters.envMap ? "#define " + envMapModeDefine : "",
      parameters.envMap ? "#define " + envMapBlendingDefine : "",
      envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
      envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
      envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
      parameters.lightMap ? "#define USE_LIGHTMAP" : "",
      parameters.aoMap ? "#define USE_AOMAP" : "",
      parameters.bumpMap ? "#define USE_BUMPMAP" : "",
      parameters.normalMap ? "#define USE_NORMALMAP" : "",
      parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
      parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
      parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
      parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
      parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
      parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
      parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
      parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
      parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
      parameters.dispersion ? "#define USE_DISPERSION" : "",
      parameters.iridescence ? "#define USE_IRIDESCENCE" : "",
      parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
      parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
      parameters.specularMap ? "#define USE_SPECULARMAP" : "",
      parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
      parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
      parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
      parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
      parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
      parameters.alphaTest ? "#define USE_ALPHATEST" : "",
      parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
      parameters.sheen ? "#define USE_SHEEN" : "",
      parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
      parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
      parameters.transmission ? "#define USE_TRANSMISSION" : "",
      parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
      parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
      parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
      parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? "#define USE_COLOR" : "",
      parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
      parameters.vertexUv1s ? "#define USE_UV1" : "",
      parameters.vertexUv2s ? "#define USE_UV2" : "",
      parameters.vertexUv3s ? "#define USE_UV3" : "",
      parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
      parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
      parameters.flatShading ? "#define FLAT_SHADED" : "",
      parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
      parameters.flipSided ? "#define FLIP_SIDED" : "",
      parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
      parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
      parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
      parameters.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
      parameters.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
      parameters.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
      parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
      parameters.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
      "uniform mat4 viewMatrix;",
      "uniform vec3 cameraPosition;",
      "uniform bool isOrthographic;",
      parameters.toneMapping !== NoToneMapping$1 ? "#define TONE_MAPPING" : "",
      parameters.toneMapping !== NoToneMapping$1 ? ShaderChunk$1["tonemapping_pars_fragment"] : "",
      // this code is required here because it is used by the toneMapping() function defined below
      parameters.toneMapping !== NoToneMapping$1 ? getToneMappingFunction$1("toneMapping", parameters.toneMapping) : "",
      parameters.dithering ? "#define DITHERING" : "",
      parameters.opaque ? "#define OPAQUE" : "",
      ShaderChunk$1["colorspace_pars_fragment"],
      // this code is required here because it is used by the various encoding/decoding function defined below
      getTexelEncodingFunction$1("linearToOutputTexel", parameters.outputColorSpace),
      getLuminanceFunction(),
      parameters.useDepthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
      "\n"
    ].filter(filterEmptyLine$1).join("\n");
  }
  vertexShader = resolveIncludes$1(vertexShader);
  vertexShader = replaceLightNums$1(vertexShader, parameters);
  vertexShader = replaceClippingPlaneNums$1(vertexShader, parameters);
  fragmentShader = resolveIncludes$1(fragmentShader);
  fragmentShader = replaceLightNums$1(fragmentShader, parameters);
  fragmentShader = replaceClippingPlaneNums$1(fragmentShader, parameters);
  vertexShader = unrollLoops$1(vertexShader);
  fragmentShader = unrollLoops$1(fragmentShader);
  if (parameters.isRawShaderMaterial !== true) {
    versionString = "#version 300 es\n";
    prefixVertex = [
      customVertexExtensions,
      "#define attribute in",
      "#define varying out",
      "#define texture2D texture"
    ].join("\n") + "\n" + prefixVertex;
    prefixFragment = [
      "#define varying in",
      parameters.glslVersion === GLSL3$1 ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
      parameters.glslVersion === GLSL3$1 ? "" : "#define gl_FragColor pc_fragColor",
      "#define gl_FragDepthEXT gl_FragDepth",
      "#define texture2D texture",
      "#define textureCube texture",
      "#define texture2DProj textureProj",
      "#define texture2DLodEXT textureLod",
      "#define texture2DProjLodEXT textureProjLod",
      "#define textureCubeLodEXT textureLod",
      "#define texture2DGradEXT textureGrad",
      "#define texture2DProjGradEXT textureProjGrad",
      "#define textureCubeGradEXT textureGrad"
    ].join("\n") + "\n" + prefixFragment;
  }
  const vertexGlsl = versionString + prefixVertex + vertexShader;
  const fragmentGlsl = versionString + prefixFragment + fragmentShader;
  const glVertexShader = WebGLShader$1(gl, gl.VERTEX_SHADER, vertexGlsl);
  const glFragmentShader = WebGLShader$1(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
  gl.attachShader(program, glVertexShader);
  gl.attachShader(program, glFragmentShader);
  if (parameters.index0AttributeName !== void 0) {
    gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
  } else if (parameters.morphTargets === true) {
    gl.bindAttribLocation(program, 0, "position");
  }
  gl.linkProgram(program);
  function onFirstUse(self2) {
    if (renderer.debug.checkShaderErrors) {
      const programLog = gl.getProgramInfoLog(program).trim();
      const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
      const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
      let runnable = true;
      let haveDiagnostics = true;
      if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
        runnable = false;
        if (typeof renderer.debug.onShaderError === "function") {
          renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
        } else {
          const vertexErrors = getShaderErrors$1(gl, glVertexShader, "vertex");
          const fragmentErrors = getShaderErrors$1(gl, glFragmentShader, "fragment");
          console.error(
            "THREE.WebGLProgram: Shader Error " + gl.getError() + " - VALIDATE_STATUS " + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + "\n\nMaterial Name: " + self2.name + "\nMaterial Type: " + self2.type + "\n\nProgram Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors
          );
        }
      } else if (programLog !== "") {
        console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
      } else if (vertexLog === "" || fragmentLog === "") {
        haveDiagnostics = false;
      }
      if (haveDiagnostics) {
        self2.diagnostics = {
          runnable,
          programLog,
          vertexShader: {
            log: vertexLog,
            prefix: prefixVertex
          },
          fragmentShader: {
            log: fragmentLog,
            prefix: prefixFragment
          }
        };
      }
    }
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    cachedUniforms = new WebGLUniforms$1(gl, program);
    cachedAttributes = fetchAttributeLocations$1(gl, program);
  }
  let cachedUniforms;
  this.getUniforms = function() {
    if (cachedUniforms === void 0) {
      onFirstUse(this);
    }
    return cachedUniforms;
  };
  let cachedAttributes;
  this.getAttributes = function() {
    if (cachedAttributes === void 0) {
      onFirstUse(this);
    }
    return cachedAttributes;
  };
  let programReady = parameters.rendererExtensionParallelShaderCompile === false;
  this.isReady = function() {
    if (programReady === false) {
      programReady = gl.getProgramParameter(program, COMPLETION_STATUS_KHR);
    }
    return programReady;
  };
  this.destroy = function() {
    bindingStates.releaseStatesOfProgram(this);
    gl.deleteProgram(program);
    this.program = void 0;
  };
  this.type = parameters.shaderType;
  this.name = parameters.shaderName;
  this.id = programIdCount$1++;
  this.cacheKey = cacheKey;
  this.usedTimes = 1;
  this.program = program;
  this.vertexShader = glVertexShader;
  this.fragmentShader = glFragmentShader;
  return this;
}
let _id$1 = 0;
class WebGLShaderCache {
  constructor() {
    this.shaderCache = /* @__PURE__ */ new Map();
    this.materialCache = /* @__PURE__ */ new Map();
  }
  update(material) {
    const vertexShader = material.vertexShader;
    const fragmentShader = material.fragmentShader;
    const vertexShaderStage = this._getShaderStage(vertexShader);
    const fragmentShaderStage = this._getShaderStage(fragmentShader);
    const materialShaders = this._getShaderCacheForMaterial(material);
    if (materialShaders.has(vertexShaderStage) === false) {
      materialShaders.add(vertexShaderStage);
      vertexShaderStage.usedTimes++;
    }
    if (materialShaders.has(fragmentShaderStage) === false) {
      materialShaders.add(fragmentShaderStage);
      fragmentShaderStage.usedTimes++;
    }
    return this;
  }
  remove(material) {
    const materialShaders = this.materialCache.get(material);
    for (const shaderStage of materialShaders) {
      shaderStage.usedTimes--;
      if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
    }
    this.materialCache.delete(material);
    return this;
  }
  getVertexShaderID(material) {
    return this._getShaderStage(material.vertexShader).id;
  }
  getFragmentShaderID(material) {
    return this._getShaderStage(material.fragmentShader).id;
  }
  dispose() {
    this.shaderCache.clear();
    this.materialCache.clear();
  }
  _getShaderCacheForMaterial(material) {
    const cache = this.materialCache;
    let set = cache.get(material);
    if (set === void 0) {
      set = /* @__PURE__ */ new Set();
      cache.set(material, set);
    }
    return set;
  }
  _getShaderStage(code) {
    const cache = this.shaderCache;
    let stage = cache.get(code);
    if (stage === void 0) {
      stage = new WebGLShaderStage(code);
      cache.set(code, stage);
    }
    return stage;
  }
}
class WebGLShaderStage {
  constructor(code) {
    this.id = _id$1++;
    this.code = code;
    this.usedTimes = 0;
  }
}
function WebGLPrograms$1(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
  const _programLayers = new Layers$1();
  const _customShaders = new WebGLShaderCache();
  const _activeChannels = /* @__PURE__ */ new Set();
  const programs = [];
  const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
  const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
  let precision = capabilities.precision;
  const shaderIDs = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  function getChannel(value) {
    _activeChannels.add(value);
    if (value === 0) return "uv";
    return `uv${value}`;
  }
  function getParameters(material, lights, shadows, scene, object) {
    const fog = scene.fog;
    const geometry = object.geometry;
    const environment = material.isMeshStandardMaterial ? scene.environment : null;
    const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
    const envMapCubeUVHeight = !!envMap && envMap.mapping === CubeUVReflectionMapping$1 ? envMap.image.height : null;
    const shaderID = shaderIDs[material.type];
    if (material.precision !== null) {
      precision = capabilities.getMaxPrecision(material.precision);
      if (precision !== material.precision) {
        console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
      }
    }
    const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
    const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
    let morphTextureStride = 0;
    if (geometry.morphAttributes.position !== void 0) morphTextureStride = 1;
    if (geometry.morphAttributes.normal !== void 0) morphTextureStride = 2;
    if (geometry.morphAttributes.color !== void 0) morphTextureStride = 3;
    let vertexShader, fragmentShader;
    let customVertexShaderID, customFragmentShaderID;
    if (shaderID) {
      const shader = ShaderLib$1[shaderID];
      vertexShader = shader.vertexShader;
      fragmentShader = shader.fragmentShader;
    } else {
      vertexShader = material.vertexShader;
      fragmentShader = material.fragmentShader;
      _customShaders.update(material);
      customVertexShaderID = _customShaders.getVertexShaderID(material);
      customFragmentShaderID = _customShaders.getFragmentShaderID(material);
    }
    const currentRenderTarget = renderer.getRenderTarget();
    const reverseDepthBuffer = renderer.state.buffers.depth.getReversed();
    const IS_INSTANCEDMESH = object.isInstancedMesh === true;
    const IS_BATCHEDMESH = object.isBatchedMesh === true;
    const HAS_MAP = !!material.map;
    const HAS_MATCAP = !!material.matcap;
    const HAS_ENVMAP = !!envMap;
    const HAS_AOMAP = !!material.aoMap;
    const HAS_LIGHTMAP = !!material.lightMap;
    const HAS_BUMPMAP = !!material.bumpMap;
    const HAS_NORMALMAP = !!material.normalMap;
    const HAS_DISPLACEMENTMAP = !!material.displacementMap;
    const HAS_EMISSIVEMAP = !!material.emissiveMap;
    const HAS_METALNESSMAP = !!material.metalnessMap;
    const HAS_ROUGHNESSMAP = !!material.roughnessMap;
    const HAS_ANISOTROPY = material.anisotropy > 0;
    const HAS_CLEARCOAT = material.clearcoat > 0;
    const HAS_DISPERSION = material.dispersion > 0;
    const HAS_IRIDESCENCE = material.iridescence > 0;
    const HAS_SHEEN = material.sheen > 0;
    const HAS_TRANSMISSION = material.transmission > 0;
    const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
    const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
    const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
    const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
    const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
    const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
    const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
    const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
    const HAS_SPECULARMAP = !!material.specularMap;
    const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
    const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
    const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
    const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
    const HAS_GRADIENTMAP = !!material.gradientMap;
    const HAS_ALPHAMAP = !!material.alphaMap;
    const HAS_ALPHATEST = material.alphaTest > 0;
    const HAS_ALPHAHASH = !!material.alphaHash;
    const HAS_EXTENSIONS = !!material.extensions;
    let toneMapping = NoToneMapping$1;
    if (material.toneMapped) {
      if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) {
        toneMapping = renderer.toneMapping;
      }
    }
    const parameters = {
      shaderID,
      shaderType: material.type,
      shaderName: material.name,
      vertexShader,
      fragmentShader,
      defines: material.defines,
      customVertexShaderID,
      customFragmentShaderID,
      isRawShaderMaterial: material.isRawShaderMaterial === true,
      glslVersion: material.glslVersion,
      precision,
      batching: IS_BATCHEDMESH,
      batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
      instancing: IS_INSTANCEDMESH,
      instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
      instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
      supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
      outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace,
      alphaToCoverage: !!material.alphaToCoverage,
      map: HAS_MAP,
      matcap: HAS_MATCAP,
      envMap: HAS_ENVMAP,
      envMapMode: HAS_ENVMAP && envMap.mapping,
      envMapCubeUVHeight,
      aoMap: HAS_AOMAP,
      lightMap: HAS_LIGHTMAP,
      bumpMap: HAS_BUMPMAP,
      normalMap: HAS_NORMALMAP,
      displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
      emissiveMap: HAS_EMISSIVEMAP,
      normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === ObjectSpaceNormalMap$1,
      normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === TangentSpaceNormalMap$1,
      metalnessMap: HAS_METALNESSMAP,
      roughnessMap: HAS_ROUGHNESSMAP,
      anisotropy: HAS_ANISOTROPY,
      anisotropyMap: HAS_ANISOTROPYMAP,
      clearcoat: HAS_CLEARCOAT,
      clearcoatMap: HAS_CLEARCOATMAP,
      clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
      clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
      dispersion: HAS_DISPERSION,
      iridescence: HAS_IRIDESCENCE,
      iridescenceMap: HAS_IRIDESCENCEMAP,
      iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
      sheen: HAS_SHEEN,
      sheenColorMap: HAS_SHEEN_COLORMAP,
      sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
      specularMap: HAS_SPECULARMAP,
      specularColorMap: HAS_SPECULAR_COLORMAP,
      specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
      transmission: HAS_TRANSMISSION,
      transmissionMap: HAS_TRANSMISSIONMAP,
      thicknessMap: HAS_THICKNESSMAP,
      gradientMap: HAS_GRADIENTMAP,
      opaque: material.transparent === false && material.blending === NormalBlending$1 && material.alphaToCoverage === false,
      alphaMap: HAS_ALPHAMAP,
      alphaTest: HAS_ALPHATEST,
      alphaHash: HAS_ALPHAHASH,
      combine: material.combine,
      //
      mapUv: HAS_MAP && getChannel(material.map.channel),
      aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
      lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
      bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
      normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
      displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
      emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
      metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
      roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
      anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
      clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
      clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
      iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
      iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
      sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
      sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
      specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
      specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
      specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
      transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
      thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
      alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
      //
      vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
      vertexColors: material.vertexColors,
      vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
      pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
      fog: !!fog,
      useFog: material.fog === true,
      fogExp2: !!fog && fog.isFogExp2,
      flatShading: material.flatShading === true,
      sizeAttenuation: material.sizeAttenuation === true,
      logarithmicDepthBuffer,
      reverseDepthBuffer,
      skinning: object.isSkinnedMesh === true,
      morphTargets: geometry.morphAttributes.position !== void 0,
      morphNormals: geometry.morphAttributes.normal !== void 0,
      morphColors: geometry.morphAttributes.color !== void 0,
      morphTargetsCount,
      morphTextureStride,
      numDirLights: lights.directional.length,
      numPointLights: lights.point.length,
      numSpotLights: lights.spot.length,
      numSpotLightMaps: lights.spotLightMap.length,
      numRectAreaLights: lights.rectArea.length,
      numHemiLights: lights.hemi.length,
      numDirLightShadows: lights.directionalShadowMap.length,
      numPointLightShadows: lights.pointShadowMap.length,
      numSpotLightShadows: lights.spotShadowMap.length,
      numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
      numLightProbes: lights.numLightProbes,
      numClippingPlanes: clipping.numPlanes,
      numClipIntersection: clipping.numIntersection,
      dithering: material.dithering,
      shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
      shadowMapType: renderer.shadowMap.type,
      toneMapping,
      decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && ColorManagement.getTransfer(material.map.colorSpace) === SRGBTransfer,
      decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && ColorManagement.getTransfer(material.emissiveMap.colorSpace) === SRGBTransfer,
      premultipliedAlpha: material.premultipliedAlpha,
      doubleSided: material.side === DoubleSide$1,
      flipSided: material.side === BackSide$1,
      useDepthPacking: material.depthPacking >= 0,
      depthPacking: material.depthPacking || 0,
      index0AttributeName: material.index0AttributeName,
      extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has("WEBGL_clip_cull_distance"),
      extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has("WEBGL_multi_draw"),
      rendererExtensionParallelShaderCompile: extensions.has("KHR_parallel_shader_compile"),
      customProgramCacheKey: material.customProgramCacheKey()
    };
    parameters.vertexUv1s = _activeChannels.has(1);
    parameters.vertexUv2s = _activeChannels.has(2);
    parameters.vertexUv3s = _activeChannels.has(3);
    _activeChannels.clear();
    return parameters;
  }
  function getProgramCacheKey(parameters) {
    const array = [];
    if (parameters.shaderID) {
      array.push(parameters.shaderID);
    } else {
      array.push(parameters.customVertexShaderID);
      array.push(parameters.customFragmentShaderID);
    }
    if (parameters.defines !== void 0) {
      for (const name in parameters.defines) {
        array.push(name);
        array.push(parameters.defines[name]);
      }
    }
    if (parameters.isRawShaderMaterial === false) {
      getProgramCacheKeyParameters(array, parameters);
      getProgramCacheKeyBooleans(array, parameters);
      array.push(renderer.outputColorSpace);
    }
    array.push(parameters.customProgramCacheKey);
    return array.join();
  }
  function getProgramCacheKeyParameters(array, parameters) {
    array.push(parameters.precision);
    array.push(parameters.outputColorSpace);
    array.push(parameters.envMapMode);
    array.push(parameters.envMapCubeUVHeight);
    array.push(parameters.mapUv);
    array.push(parameters.alphaMapUv);
    array.push(parameters.lightMapUv);
    array.push(parameters.aoMapUv);
    array.push(parameters.bumpMapUv);
    array.push(parameters.normalMapUv);
    array.push(parameters.displacementMapUv);
    array.push(parameters.emissiveMapUv);
    array.push(parameters.metalnessMapUv);
    array.push(parameters.roughnessMapUv);
    array.push(parameters.anisotropyMapUv);
    array.push(parameters.clearcoatMapUv);
    array.push(parameters.clearcoatNormalMapUv);
    array.push(parameters.clearcoatRoughnessMapUv);
    array.push(parameters.iridescenceMapUv);
    array.push(parameters.iridescenceThicknessMapUv);
    array.push(parameters.sheenColorMapUv);
    array.push(parameters.sheenRoughnessMapUv);
    array.push(parameters.specularMapUv);
    array.push(parameters.specularColorMapUv);
    array.push(parameters.specularIntensityMapUv);
    array.push(parameters.transmissionMapUv);
    array.push(parameters.thicknessMapUv);
    array.push(parameters.combine);
    array.push(parameters.fogExp2);
    array.push(parameters.sizeAttenuation);
    array.push(parameters.morphTargetsCount);
    array.push(parameters.morphAttributeCount);
    array.push(parameters.numDirLights);
    array.push(parameters.numPointLights);
    array.push(parameters.numSpotLights);
    array.push(parameters.numSpotLightMaps);
    array.push(parameters.numHemiLights);
    array.push(parameters.numRectAreaLights);
    array.push(parameters.numDirLightShadows);
    array.push(parameters.numPointLightShadows);
    array.push(parameters.numSpotLightShadows);
    array.push(parameters.numSpotLightShadowsWithMaps);
    array.push(parameters.numLightProbes);
    array.push(parameters.shadowMapType);
    array.push(parameters.toneMapping);
    array.push(parameters.numClippingPlanes);
    array.push(parameters.numClipIntersection);
    array.push(parameters.depthPacking);
  }
  function getProgramCacheKeyBooleans(array, parameters) {
    _programLayers.disableAll();
    if (parameters.supportsVertexTextures)
      _programLayers.enable(0);
    if (parameters.instancing)
      _programLayers.enable(1);
    if (parameters.instancingColor)
      _programLayers.enable(2);
    if (parameters.instancingMorph)
      _programLayers.enable(3);
    if (parameters.matcap)
      _programLayers.enable(4);
    if (parameters.envMap)
      _programLayers.enable(5);
    if (parameters.normalMapObjectSpace)
      _programLayers.enable(6);
    if (parameters.normalMapTangentSpace)
      _programLayers.enable(7);
    if (parameters.clearcoat)
      _programLayers.enable(8);
    if (parameters.iridescence)
      _programLayers.enable(9);
    if (parameters.alphaTest)
      _programLayers.enable(10);
    if (parameters.vertexColors)
      _programLayers.enable(11);
    if (parameters.vertexAlphas)
      _programLayers.enable(12);
    if (parameters.vertexUv1s)
      _programLayers.enable(13);
    if (parameters.vertexUv2s)
      _programLayers.enable(14);
    if (parameters.vertexUv3s)
      _programLayers.enable(15);
    if (parameters.vertexTangents)
      _programLayers.enable(16);
    if (parameters.anisotropy)
      _programLayers.enable(17);
    if (parameters.alphaHash)
      _programLayers.enable(18);
    if (parameters.batching)
      _programLayers.enable(19);
    if (parameters.dispersion)
      _programLayers.enable(20);
    if (parameters.batchingColor)
      _programLayers.enable(21);
    array.push(_programLayers.mask);
    _programLayers.disableAll();
    if (parameters.fog)
      _programLayers.enable(0);
    if (parameters.useFog)
      _programLayers.enable(1);
    if (parameters.flatShading)
      _programLayers.enable(2);
    if (parameters.logarithmicDepthBuffer)
      _programLayers.enable(3);
    if (parameters.reverseDepthBuffer)
      _programLayers.enable(4);
    if (parameters.skinning)
      _programLayers.enable(5);
    if (parameters.morphTargets)
      _programLayers.enable(6);
    if (parameters.morphNormals)
      _programLayers.enable(7);
    if (parameters.morphColors)
      _programLayers.enable(8);
    if (parameters.premultipliedAlpha)
      _programLayers.enable(9);
    if (parameters.shadowMapEnabled)
      _programLayers.enable(10);
    if (parameters.doubleSided)
      _programLayers.enable(11);
    if (parameters.flipSided)
      _programLayers.enable(12);
    if (parameters.useDepthPacking)
      _programLayers.enable(13);
    if (parameters.dithering)
      _programLayers.enable(14);
    if (parameters.transmission)
      _programLayers.enable(15);
    if (parameters.sheen)
      _programLayers.enable(16);
    if (parameters.opaque)
      _programLayers.enable(17);
    if (parameters.pointsUvs)
      _programLayers.enable(18);
    if (parameters.decodeVideoTexture)
      _programLayers.enable(19);
    if (parameters.decodeVideoTextureEmissive)
      _programLayers.enable(20);
    if (parameters.alphaToCoverage)
      _programLayers.enable(21);
    array.push(_programLayers.mask);
  }
  function getUniforms(material) {
    const shaderID = shaderIDs[material.type];
    let uniforms;
    if (shaderID) {
      const shader = ShaderLib$1[shaderID];
      uniforms = UniformsUtils$1.clone(shader.uniforms);
    } else {
      uniforms = material.uniforms;
    }
    return uniforms;
  }
  function acquireProgram(parameters, cacheKey) {
    let program;
    for (let p2 = 0, pl = programs.length; p2 < pl; p2++) {
      const preexistingProgram = programs[p2];
      if (preexistingProgram.cacheKey === cacheKey) {
        program = preexistingProgram;
        ++program.usedTimes;
        break;
      }
    }
    if (program === void 0) {
      program = new WebGLProgram$1(renderer, cacheKey, parameters, bindingStates);
      programs.push(program);
    }
    return program;
  }
  function releaseProgram(program) {
    if (--program.usedTimes === 0) {
      const i2 = programs.indexOf(program);
      programs[i2] = programs[programs.length - 1];
      programs.pop();
      program.destroy();
    }
  }
  function releaseShaderCache(material) {
    _customShaders.remove(material);
  }
  function dispose() {
    _customShaders.dispose();
  }
  return {
    getParameters,
    getProgramCacheKey,
    getUniforms,
    acquireProgram,
    releaseProgram,
    releaseShaderCache,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs,
    dispose
  };
}
function WebGLProperties$1() {
  let properties = /* @__PURE__ */ new WeakMap();
  function has(object) {
    return properties.has(object);
  }
  function get(object) {
    let map = properties.get(object);
    if (map === void 0) {
      map = {};
      properties.set(object, map);
    }
    return map;
  }
  function remove(object) {
    properties.delete(object);
  }
  function update(object, key, value) {
    properties.get(object)[key] = value;
  }
  function dispose() {
    properties = /* @__PURE__ */ new WeakMap();
  }
  return {
    has,
    get,
    remove,
    update,
    dispose
  };
}
function painterSortStable$1(a3, b) {
  if (a3.groupOrder !== b.groupOrder) {
    return a3.groupOrder - b.groupOrder;
  } else if (a3.renderOrder !== b.renderOrder) {
    return a3.renderOrder - b.renderOrder;
  } else if (a3.material.id !== b.material.id) {
    return a3.material.id - b.material.id;
  } else if (a3.z !== b.z) {
    return a3.z - b.z;
  } else {
    return a3.id - b.id;
  }
}
function reversePainterSortStable$1(a3, b) {
  if (a3.groupOrder !== b.groupOrder) {
    return a3.groupOrder - b.groupOrder;
  } else if (a3.renderOrder !== b.renderOrder) {
    return a3.renderOrder - b.renderOrder;
  } else if (a3.z !== b.z) {
    return b.z - a3.z;
  } else {
    return a3.id - b.id;
  }
}
function WebGLRenderList$1() {
  const renderItems = [];
  let renderItemsIndex = 0;
  const opaque = [];
  const transmissive = [];
  const transparent = [];
  function init() {
    renderItemsIndex = 0;
    opaque.length = 0;
    transmissive.length = 0;
    transparent.length = 0;
  }
  function getNextRenderItem(object, geometry, material, groupOrder, z2, group) {
    let renderItem = renderItems[renderItemsIndex];
    if (renderItem === void 0) {
      renderItem = {
        id: object.id,
        object,
        geometry,
        material,
        groupOrder,
        renderOrder: object.renderOrder,
        z: z2,
        group
      };
      renderItems[renderItemsIndex] = renderItem;
    } else {
      renderItem.id = object.id;
      renderItem.object = object;
      renderItem.geometry = geometry;
      renderItem.material = material;
      renderItem.groupOrder = groupOrder;
      renderItem.renderOrder = object.renderOrder;
      renderItem.z = z2;
      renderItem.group = group;
    }
    renderItemsIndex++;
    return renderItem;
  }
  function push(object, geometry, material, groupOrder, z2, group) {
    const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z2, group);
    if (material.transmission > 0) {
      transmissive.push(renderItem);
    } else if (material.transparent === true) {
      transparent.push(renderItem);
    } else {
      opaque.push(renderItem);
    }
  }
  function unshift(object, geometry, material, groupOrder, z2, group) {
    const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z2, group);
    if (material.transmission > 0) {
      transmissive.unshift(renderItem);
    } else if (material.transparent === true) {
      transparent.unshift(renderItem);
    } else {
      opaque.unshift(renderItem);
    }
  }
  function sort(customOpaqueSort, customTransparentSort) {
    if (opaque.length > 1) opaque.sort(customOpaqueSort || painterSortStable$1);
    if (transmissive.length > 1) transmissive.sort(customTransparentSort || reversePainterSortStable$1);
    if (transparent.length > 1) transparent.sort(customTransparentSort || reversePainterSortStable$1);
  }
  function finish() {
    for (let i2 = renderItemsIndex, il = renderItems.length; i2 < il; i2++) {
      const renderItem = renderItems[i2];
      if (renderItem.id === null) break;
      renderItem.id = null;
      renderItem.object = null;
      renderItem.geometry = null;
      renderItem.material = null;
      renderItem.group = null;
    }
  }
  return {
    opaque,
    transmissive,
    transparent,
    init,
    push,
    unshift,
    finish,
    sort
  };
}
function WebGLRenderLists$1() {
  let lists = /* @__PURE__ */ new WeakMap();
  function get(scene, renderCallDepth) {
    const listArray = lists.get(scene);
    let list;
    if (listArray === void 0) {
      list = new WebGLRenderList$1();
      lists.set(scene, [list]);
    } else {
      if (renderCallDepth >= listArray.length) {
        list = new WebGLRenderList$1();
        listArray.push(list);
      } else {
        list = listArray[renderCallDepth];
      }
    }
    return list;
  }
  function dispose() {
    lists = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose
  };
}
function UniformsCache$1() {
  const lights = {};
  return {
    get: function(light) {
      if (lights[light.id] !== void 0) {
        return lights[light.id];
      }
      let uniforms;
      switch (light.type) {
        case "DirectionalLight":
          uniforms = {
            direction: new Vector3$1(),
            color: new Color$1()
          };
          break;
        case "SpotLight":
          uniforms = {
            position: new Vector3$1(),
            direction: new Vector3$1(),
            color: new Color$1(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          uniforms = {
            position: new Vector3$1(),
            color: new Color$1(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          uniforms = {
            direction: new Vector3$1(),
            skyColor: new Color$1(),
            groundColor: new Color$1()
          };
          break;
        case "RectAreaLight":
          uniforms = {
            color: new Color$1(),
            position: new Vector3$1(),
            halfWidth: new Vector3$1(),
            halfHeight: new Vector3$1()
          };
          break;
      }
      lights[light.id] = uniforms;
      return uniforms;
    }
  };
}
function ShadowUniformsCache$1() {
  const lights = {};
  return {
    get: function(light) {
      if (lights[light.id] !== void 0) {
        return lights[light.id];
      }
      let uniforms;
      switch (light.type) {
        case "DirectionalLight":
          uniforms = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2$1()
          };
          break;
        case "SpotLight":
          uniforms = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2$1()
          };
          break;
        case "PointLight":
          uniforms = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2$1(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      lights[light.id] = uniforms;
      return uniforms;
    }
  };
}
let nextVersion$1 = 0;
function shadowCastingAndTexturingLightsFirst(lightA, lightB) {
  return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function WebGLLights$1(extensions) {
  const cache = new UniformsCache$1();
  const shadowCache = ShadowUniformsCache$1();
  const state = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1,
      numSpotMaps: -1,
      numLightProbes: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotLightMap: [],
    spotShadow: [],
    spotShadowMap: [],
    spotLightMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: [],
    numSpotLightShadowsWithMaps: 0,
    numLightProbes: 0
  };
  for (let i2 = 0; i2 < 9; i2++) state.probe.push(new Vector3$1());
  const vector3 = new Vector3$1();
  const matrix4 = new Matrix4$1();
  const matrix42 = new Matrix4$1();
  function setup(lights) {
    let r2 = 0, g3 = 0, b = 0;
    for (let i2 = 0; i2 < 9; i2++) state.probe[i2].set(0, 0, 0);
    let directionalLength = 0;
    let pointLength = 0;
    let spotLength = 0;
    let rectAreaLength = 0;
    let hemiLength = 0;
    let numDirectionalShadows = 0;
    let numPointShadows = 0;
    let numSpotShadows = 0;
    let numSpotMaps = 0;
    let numSpotShadowsWithMaps = 0;
    let numLightProbes = 0;
    lights.sort(shadowCastingAndTexturingLightsFirst);
    for (let i2 = 0, l2 = lights.length; i2 < l2; i2++) {
      const light = lights[i2];
      const color2 = light.color;
      const intensity = light.intensity;
      const distance2 = light.distance;
      const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
      if (light.isAmbientLight) {
        r2 += color2.r * intensity;
        g3 += color2.g * intensity;
        b += color2.b * intensity;
      } else if (light.isLightProbe) {
        for (let j = 0; j < 9; j++) {
          state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
        }
        numLightProbes++;
      } else if (light.isDirectionalLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(light.color).multiplyScalar(light.intensity);
        if (light.castShadow) {
          const shadow = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowIntensity = shadow.intensity;
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          state.directionalShadow[directionalLength] = shadowUniforms;
          state.directionalShadowMap[directionalLength] = shadowMap;
          state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
          numDirectionalShadows++;
        }
        state.directional[directionalLength] = uniforms;
        directionalLength++;
      } else if (light.isSpotLight) {
        const uniforms = cache.get(light);
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.color.copy(color2).multiplyScalar(intensity);
        uniforms.distance = distance2;
        uniforms.coneCos = Math.cos(light.angle);
        uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
        uniforms.decay = light.decay;
        state.spot[spotLength] = uniforms;
        const shadow = light.shadow;
        if (light.map) {
          state.spotLightMap[numSpotMaps] = light.map;
          numSpotMaps++;
          shadow.updateMatrices(light);
          if (light.castShadow) numSpotShadowsWithMaps++;
        }
        state.spotLightMatrix[spotLength] = shadow.matrix;
        if (light.castShadow) {
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowIntensity = shadow.intensity;
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          state.spotShadow[spotLength] = shadowUniforms;
          state.spotShadowMap[spotLength] = shadowMap;
          numSpotShadows++;
        }
        spotLength++;
      } else if (light.isRectAreaLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(color2).multiplyScalar(intensity);
        uniforms.halfWidth.set(light.width * 0.5, 0, 0);
        uniforms.halfHeight.set(0, light.height * 0.5, 0);
        state.rectArea[rectAreaLength] = uniforms;
        rectAreaLength++;
      } else if (light.isPointLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(light.color).multiplyScalar(light.intensity);
        uniforms.distance = light.distance;
        uniforms.decay = light.decay;
        if (light.castShadow) {
          const shadow = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowIntensity = shadow.intensity;
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          shadowUniforms.shadowCameraNear = shadow.camera.near;
          shadowUniforms.shadowCameraFar = shadow.camera.far;
          state.pointShadow[pointLength] = shadowUniforms;
          state.pointShadowMap[pointLength] = shadowMap;
          state.pointShadowMatrix[pointLength] = light.shadow.matrix;
          numPointShadows++;
        }
        state.point[pointLength] = uniforms;
        pointLength++;
      } else if (light.isHemisphereLight) {
        const uniforms = cache.get(light);
        uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
        uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
        state.hemi[hemiLength] = uniforms;
        hemiLength++;
      }
    }
    if (rectAreaLength > 0) {
      if (extensions.has("OES_texture_float_linear") === true) {
        state.rectAreaLTC1 = UniformsLib$1.LTC_FLOAT_1;
        state.rectAreaLTC2 = UniformsLib$1.LTC_FLOAT_2;
      } else {
        state.rectAreaLTC1 = UniformsLib$1.LTC_HALF_1;
        state.rectAreaLTC2 = UniformsLib$1.LTC_HALF_2;
      }
    }
    state.ambient[0] = r2;
    state.ambient[1] = g3;
    state.ambient[2] = b;
    const hash = state.hash;
    if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
      state.directional.length = directionalLength;
      state.spot.length = spotLength;
      state.rectArea.length = rectAreaLength;
      state.point.length = pointLength;
      state.hemi.length = hemiLength;
      state.directionalShadow.length = numDirectionalShadows;
      state.directionalShadowMap.length = numDirectionalShadows;
      state.pointShadow.length = numPointShadows;
      state.pointShadowMap.length = numPointShadows;
      state.spotShadow.length = numSpotShadows;
      state.spotShadowMap.length = numSpotShadows;
      state.directionalShadowMatrix.length = numDirectionalShadows;
      state.pointShadowMatrix.length = numPointShadows;
      state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
      state.spotLightMap.length = numSpotMaps;
      state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
      state.numLightProbes = numLightProbes;
      hash.directionalLength = directionalLength;
      hash.pointLength = pointLength;
      hash.spotLength = spotLength;
      hash.rectAreaLength = rectAreaLength;
      hash.hemiLength = hemiLength;
      hash.numDirectionalShadows = numDirectionalShadows;
      hash.numPointShadows = numPointShadows;
      hash.numSpotShadows = numSpotShadows;
      hash.numSpotMaps = numSpotMaps;
      hash.numLightProbes = numLightProbes;
      state.version = nextVersion$1++;
    }
  }
  function setupView(lights, camera) {
    let directionalLength = 0;
    let pointLength = 0;
    let spotLength = 0;
    let rectAreaLength = 0;
    let hemiLength = 0;
    const viewMatrix = camera.matrixWorldInverse;
    for (let i2 = 0, l2 = lights.length; i2 < l2; i2++) {
      const light = lights[i2];
      if (light.isDirectionalLight) {
        const uniforms = state.directional[directionalLength];
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        vector3.setFromMatrixPosition(light.target.matrixWorld);
        uniforms.direction.sub(vector3);
        uniforms.direction.transformDirection(viewMatrix);
        directionalLength++;
      } else if (light.isSpotLight) {
        const uniforms = state.spot[spotLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        vector3.setFromMatrixPosition(light.target.matrixWorld);
        uniforms.direction.sub(vector3);
        uniforms.direction.transformDirection(viewMatrix);
        spotLength++;
      } else if (light.isRectAreaLight) {
        const uniforms = state.rectArea[rectAreaLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        matrix42.identity();
        matrix4.copy(light.matrixWorld);
        matrix4.premultiply(viewMatrix);
        matrix42.extractRotation(matrix4);
        uniforms.halfWidth.set(light.width * 0.5, 0, 0);
        uniforms.halfHeight.set(0, light.height * 0.5, 0);
        uniforms.halfWidth.applyMatrix4(matrix42);
        uniforms.halfHeight.applyMatrix4(matrix42);
        rectAreaLength++;
      } else if (light.isPointLight) {
        const uniforms = state.point[pointLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        pointLength++;
      } else if (light.isHemisphereLight) {
        const uniforms = state.hemi[hemiLength];
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        uniforms.direction.transformDirection(viewMatrix);
        hemiLength++;
      }
    }
  }
  return {
    setup,
    setupView,
    state
  };
}
function WebGLRenderState$1(extensions) {
  const lights = new WebGLLights$1(extensions);
  const lightsArray = [];
  const shadowsArray = [];
  function init(camera) {
    state.camera = camera;
    lightsArray.length = 0;
    shadowsArray.length = 0;
  }
  function pushLight(light) {
    lightsArray.push(light);
  }
  function pushShadow(shadowLight) {
    shadowsArray.push(shadowLight);
  }
  function setupLights() {
    lights.setup(lightsArray);
  }
  function setupLightsView(camera) {
    lights.setupView(lightsArray, camera);
  }
  const state = {
    lightsArray,
    shadowsArray,
    camera: null,
    lights,
    transmissionRenderTarget: {}
  };
  return {
    init,
    state,
    setupLights,
    setupLightsView,
    pushLight,
    pushShadow
  };
}
function WebGLRenderStates$1(extensions) {
  let renderStates = /* @__PURE__ */ new WeakMap();
  function get(scene, renderCallDepth = 0) {
    const renderStateArray = renderStates.get(scene);
    let renderState;
    if (renderStateArray === void 0) {
      renderState = new WebGLRenderState$1(extensions);
      renderStates.set(scene, [renderState]);
    } else {
      if (renderCallDepth >= renderStateArray.length) {
        renderState = new WebGLRenderState$1(extensions);
        renderStateArray.push(renderState);
      } else {
        renderState = renderStateArray[renderCallDepth];
      }
    }
    return renderState;
  }
  function dispose() {
    renderStates = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose
  };
}
const vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function WebGLShadowMap$1(renderer, objects, capabilities) {
  let _frustum2 = new Frustum$1();
  const _shadowMapSize = new Vector2$1(), _viewportSize = new Vector2$1(), _viewport2 = new Vector4$1(), _depthMaterial = new MeshDepthMaterial$1({ depthPacking: RGBADepthPacking$1 }), _distanceMaterial = new MeshDistanceMaterial$1(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
  const shadowSide = { [FrontSide$1]: BackSide$1, [BackSide$1]: FrontSide$1, [DoubleSide$1]: DoubleSide$1 };
  const shadowMaterialVertical = new ShaderMaterial$1({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new Vector2$1() },
      radius: { value: 4 }
    },
    vertexShader: vertex,
    fragmentShader: fragment
  });
  const shadowMaterialHorizontal = shadowMaterialVertical.clone();
  shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
  const fullScreenTri = new BufferGeometry$1();
  fullScreenTri.setAttribute(
    "position",
    new BufferAttribute$1(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const fullScreenMesh = new Mesh$1(fullScreenTri, shadowMaterialVertical);
  const scope = this;
  this.enabled = false;
  this.autoUpdate = true;
  this.needsUpdate = false;
  this.type = PCFShadowMap$1;
  let _previousType = this.type;
  this.render = function(lights, scene, camera) {
    if (scope.enabled === false) return;
    if (scope.autoUpdate === false && scope.needsUpdate === false) return;
    if (lights.length === 0) return;
    const currentRenderTarget = renderer.getRenderTarget();
    const activeCubeFace = renderer.getActiveCubeFace();
    const activeMipmapLevel = renderer.getActiveMipmapLevel();
    const _state = renderer.state;
    _state.setBlending(NoBlending$1);
    _state.buffers.color.setClear(1, 1, 1, 1);
    _state.buffers.depth.setTest(true);
    _state.setScissorTest(false);
    const toVSM = _previousType !== VSMShadowMap$1 && this.type === VSMShadowMap$1;
    const fromVSM = _previousType === VSMShadowMap$1 && this.type !== VSMShadowMap$1;
    for (let i2 = 0, il = lights.length; i2 < il; i2++) {
      const light = lights[i2];
      const shadow = light.shadow;
      if (shadow === void 0) {
        console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
        continue;
      }
      if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
      _shadowMapSize.copy(shadow.mapSize);
      const shadowFrameExtents = shadow.getFrameExtents();
      _shadowMapSize.multiply(shadowFrameExtents);
      _viewportSize.copy(shadow.mapSize);
      if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
        if (_shadowMapSize.x > _maxTextureSize) {
          _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
          _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
          shadow.mapSize.x = _viewportSize.x;
        }
        if (_shadowMapSize.y > _maxTextureSize) {
          _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
          _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
          shadow.mapSize.y = _viewportSize.y;
        }
      }
      if (shadow.map === null || toVSM === true || fromVSM === true) {
        const pars = this.type !== VSMShadowMap$1 ? { minFilter: NearestFilter$1, magFilter: NearestFilter$1 } : {};
        if (shadow.map !== null) {
          shadow.map.dispose();
        }
        shadow.map = new WebGLRenderTarget$1(_shadowMapSize.x, _shadowMapSize.y, pars);
        shadow.map.texture.name = light.name + ".shadowMap";
        shadow.camera.updateProjectionMatrix();
      }
      renderer.setRenderTarget(shadow.map);
      renderer.clear();
      const viewportCount = shadow.getViewportCount();
      for (let vp = 0; vp < viewportCount; vp++) {
        const viewport = shadow.getViewport(vp);
        _viewport2.set(
          _viewportSize.x * viewport.x,
          _viewportSize.y * viewport.y,
          _viewportSize.x * viewport.z,
          _viewportSize.y * viewport.w
        );
        _state.viewport(_viewport2);
        shadow.updateMatrices(light, vp);
        _frustum2 = shadow.getFrustum();
        renderObject(scene, camera, shadow.camera, light, this.type);
      }
      if (shadow.isPointLightShadow !== true && this.type === VSMShadowMap$1) {
        VSMPass(shadow, camera);
      }
      shadow.needsUpdate = false;
    }
    _previousType = this.type;
    scope.needsUpdate = false;
    renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
  };
  function VSMPass(shadow, camera) {
    const geometry = objects.update(fullScreenMesh);
    if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
      shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
      shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
      shadowMaterialVertical.needsUpdate = true;
      shadowMaterialHorizontal.needsUpdate = true;
    }
    if (shadow.mapPass === null) {
      shadow.mapPass = new WebGLRenderTarget$1(_shadowMapSize.x, _shadowMapSize.y);
    }
    shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
    shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
    shadowMaterialVertical.uniforms.radius.value = shadow.radius;
    renderer.setRenderTarget(shadow.mapPass);
    renderer.clear();
    renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
    shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
    shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
    shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
    renderer.setRenderTarget(shadow.map);
    renderer.clear();
    renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
  }
  function getDepthMaterial(object, material, light, type) {
    let result = null;
    const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
    if (customMaterial !== void 0) {
      result = customMaterial;
    } else {
      result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
      if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
        const keyA = result.uuid, keyB = material.uuid;
        let materialsForVariant = _materialCache[keyA];
        if (materialsForVariant === void 0) {
          materialsForVariant = {};
          _materialCache[keyA] = materialsForVariant;
        }
        let cachedMaterial = materialsForVariant[keyB];
        if (cachedMaterial === void 0) {
          cachedMaterial = result.clone();
          materialsForVariant[keyB] = cachedMaterial;
          material.addEventListener("dispose", onMaterialDispose);
        }
        result = cachedMaterial;
      }
    }
    result.visible = material.visible;
    result.wireframe = material.wireframe;
    if (type === VSMShadowMap$1) {
      result.side = material.shadowSide !== null ? material.shadowSide : material.side;
    } else {
      result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
    }
    result.alphaMap = material.alphaMap;
    result.alphaTest = material.alphaTest;
    result.map = material.map;
    result.clipShadows = material.clipShadows;
    result.clippingPlanes = material.clippingPlanes;
    result.clipIntersection = material.clipIntersection;
    result.displacementMap = material.displacementMap;
    result.displacementScale = material.displacementScale;
    result.displacementBias = material.displacementBias;
    result.wireframeLinewidth = material.wireframeLinewidth;
    result.linewidth = material.linewidth;
    if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
      const materialProperties = renderer.properties.get(result);
      materialProperties.light = light;
    }
    return result;
  }
  function renderObject(object, camera, shadowCamera, light, type) {
    if (object.visible === false) return;
    const visible = object.layers.test(camera.layers);
    if (visible && (object.isMesh || object.isLine || object.isPoints)) {
      if ((object.castShadow || object.receiveShadow && type === VSMShadowMap$1) && (!object.frustumCulled || _frustum2.intersectsObject(object))) {
        object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
        const geometry = objects.update(object);
        const material = object.material;
        if (Array.isArray(material)) {
          const groups = geometry.groups;
          for (let k = 0, kl = groups.length; k < kl; k++) {
            const group = groups[k];
            const groupMaterial = material[group.materialIndex];
            if (groupMaterial && groupMaterial.visible) {
              const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
              object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
              renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
              object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
            }
          }
        } else if (material.visible) {
          const depthMaterial = getDepthMaterial(object, material, light, type);
          object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
          renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
          object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
        }
      }
    }
    const children = object.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      renderObject(children[i2], camera, shadowCamera, light, type);
    }
  }
  function onMaterialDispose(event) {
    const material = event.target;
    material.removeEventListener("dispose", onMaterialDispose);
    for (const id in _materialCache) {
      const cache = _materialCache[id];
      const uuid = event.target.uuid;
      if (uuid in cache) {
        const shadowMaterial = cache[uuid];
        shadowMaterial.dispose();
        delete cache[uuid];
      }
    }
  }
}
const reversedFuncs = {
  [NeverDepth$1]: AlwaysDepth$1,
  [LessDepth$1]: GreaterDepth$1,
  [EqualDepth$1]: NotEqualDepth$1,
  [LessEqualDepth$1]: GreaterEqualDepth$1,
  [AlwaysDepth$1]: NeverDepth$1,
  [GreaterDepth$1]: LessDepth$1,
  [NotEqualDepth$1]: EqualDepth$1,
  [GreaterEqualDepth$1]: LessEqualDepth$1
};
function WebGLState$1(gl, extensions) {
  function ColorBuffer() {
    let locked = false;
    const color2 = new Vector4$1();
    let currentColorMask = null;
    const currentColorClear = new Vector4$1(0, 0, 0, 0);
    return {
      setMask: function(colorMask) {
        if (currentColorMask !== colorMask && !locked) {
          gl.colorMask(colorMask, colorMask, colorMask, colorMask);
          currentColorMask = colorMask;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(r2, g3, b, a3, premultipliedAlpha) {
        if (premultipliedAlpha === true) {
          r2 *= a3;
          g3 *= a3;
          b *= a3;
        }
        color2.set(r2, g3, b, a3);
        if (currentColorClear.equals(color2) === false) {
          gl.clearColor(r2, g3, b, a3);
          currentColorClear.copy(color2);
        }
      },
      reset: function() {
        locked = false;
        currentColorMask = null;
        currentColorClear.set(-1, 0, 0, 0);
      }
    };
  }
  function DepthBuffer() {
    let locked = false;
    let reversed = false;
    let currentDepthMask = null;
    let currentDepthFunc = null;
    let currentDepthClear = null;
    return {
      setReversed: function(value) {
        if (reversed !== value) {
          const ext = extensions.get("EXT_clip_control");
          if (reversed) {
            ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
          } else {
            ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
          }
          const oldDepth = currentDepthClear;
          currentDepthClear = null;
          this.setClear(oldDepth);
        }
        reversed = value;
      },
      getReversed: function() {
        return reversed;
      },
      setTest: function(depthTest) {
        if (depthTest) {
          enable(gl.DEPTH_TEST);
        } else {
          disable(gl.DEPTH_TEST);
        }
      },
      setMask: function(depthMask) {
        if (currentDepthMask !== depthMask && !locked) {
          gl.depthMask(depthMask);
          currentDepthMask = depthMask;
        }
      },
      setFunc: function(depthFunc) {
        if (reversed) depthFunc = reversedFuncs[depthFunc];
        if (currentDepthFunc !== depthFunc) {
          switch (depthFunc) {
            case NeverDepth$1:
              gl.depthFunc(gl.NEVER);
              break;
            case AlwaysDepth$1:
              gl.depthFunc(gl.ALWAYS);
              break;
            case LessDepth$1:
              gl.depthFunc(gl.LESS);
              break;
            case LessEqualDepth$1:
              gl.depthFunc(gl.LEQUAL);
              break;
            case EqualDepth$1:
              gl.depthFunc(gl.EQUAL);
              break;
            case GreaterEqualDepth$1:
              gl.depthFunc(gl.GEQUAL);
              break;
            case GreaterDepth$1:
              gl.depthFunc(gl.GREATER);
              break;
            case NotEqualDepth$1:
              gl.depthFunc(gl.NOTEQUAL);
              break;
            default:
              gl.depthFunc(gl.LEQUAL);
          }
          currentDepthFunc = depthFunc;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(depth) {
        if (currentDepthClear !== depth) {
          if (reversed) {
            depth = 1 - depth;
          }
          gl.clearDepth(depth);
          currentDepthClear = depth;
        }
      },
      reset: function() {
        locked = false;
        currentDepthMask = null;
        currentDepthFunc = null;
        currentDepthClear = null;
        reversed = false;
      }
    };
  }
  function StencilBuffer() {
    let locked = false;
    let currentStencilMask = null;
    let currentStencilFunc = null;
    let currentStencilRef = null;
    let currentStencilFuncMask = null;
    let currentStencilFail = null;
    let currentStencilZFail = null;
    let currentStencilZPass = null;
    let currentStencilClear = null;
    return {
      setTest: function(stencilTest) {
        if (!locked) {
          if (stencilTest) {
            enable(gl.STENCIL_TEST);
          } else {
            disable(gl.STENCIL_TEST);
          }
        }
      },
      setMask: function(stencilMask) {
        if (currentStencilMask !== stencilMask && !locked) {
          gl.stencilMask(stencilMask);
          currentStencilMask = stencilMask;
        }
      },
      setFunc: function(stencilFunc, stencilRef, stencilMask) {
        if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
          gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
          currentStencilFunc = stencilFunc;
          currentStencilRef = stencilRef;
          currentStencilFuncMask = stencilMask;
        }
      },
      setOp: function(stencilFail, stencilZFail, stencilZPass) {
        if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
          gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
          currentStencilFail = stencilFail;
          currentStencilZFail = stencilZFail;
          currentStencilZPass = stencilZPass;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(stencil) {
        if (currentStencilClear !== stencil) {
          gl.clearStencil(stencil);
          currentStencilClear = stencil;
        }
      },
      reset: function() {
        locked = false;
        currentStencilMask = null;
        currentStencilFunc = null;
        currentStencilRef = null;
        currentStencilFuncMask = null;
        currentStencilFail = null;
        currentStencilZFail = null;
        currentStencilZPass = null;
        currentStencilClear = null;
      }
    };
  }
  const colorBuffer = new ColorBuffer();
  const depthBuffer = new DepthBuffer();
  const stencilBuffer = new StencilBuffer();
  const uboBindings = /* @__PURE__ */ new WeakMap();
  const uboProgramMap = /* @__PURE__ */ new WeakMap();
  let enabledCapabilities = {};
  let currentBoundFramebuffers = {};
  let currentDrawbuffers = /* @__PURE__ */ new WeakMap();
  let defaultDrawbuffers = [];
  let currentProgram = null;
  let currentBlendingEnabled = false;
  let currentBlending = null;
  let currentBlendEquation = null;
  let currentBlendSrc = null;
  let currentBlendDst = null;
  let currentBlendEquationAlpha = null;
  let currentBlendSrcAlpha = null;
  let currentBlendDstAlpha = null;
  let currentBlendColor = new Color$1(0, 0, 0);
  let currentBlendAlpha = 0;
  let currentPremultipledAlpha = false;
  let currentFlipSided = null;
  let currentCullFace = null;
  let currentLineWidth = null;
  let currentPolygonOffsetFactor = null;
  let currentPolygonOffsetUnits = null;
  const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
  let lineWidthAvailable = false;
  let version = 0;
  const glVersion = gl.getParameter(gl.VERSION);
  if (glVersion.indexOf("WebGL") !== -1) {
    version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version >= 1;
  } else if (glVersion.indexOf("OpenGL ES") !== -1) {
    version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version >= 2;
  }
  let currentTextureSlot = null;
  let currentBoundTextures = {};
  const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
  const viewportParam = gl.getParameter(gl.VIEWPORT);
  const currentScissor = new Vector4$1().fromArray(scissorParam);
  const currentViewport = new Vector4$1().fromArray(viewportParam);
  function createTexture(type, target, count, dimensions) {
    const data = new Uint8Array(4);
    const texture = gl.createTexture();
    gl.bindTexture(type, texture);
    gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    for (let i2 = 0; i2 < count; i2++) {
      if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) {
        gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
      } else {
        gl.texImage2D(target + i2, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
      }
    }
    return texture;
  }
  const emptyTextures = {};
  emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
  emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
  emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
  emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
  colorBuffer.setClear(0, 0, 0, 1);
  depthBuffer.setClear(1);
  stencilBuffer.setClear(0);
  enable(gl.DEPTH_TEST);
  depthBuffer.setFunc(LessEqualDepth$1);
  setFlipSided(false);
  setCullFace(CullFaceBack$1);
  enable(gl.CULL_FACE);
  setBlending(NoBlending$1);
  function enable(id) {
    if (enabledCapabilities[id] !== true) {
      gl.enable(id);
      enabledCapabilities[id] = true;
    }
  }
  function disable(id) {
    if (enabledCapabilities[id] !== false) {
      gl.disable(id);
      enabledCapabilities[id] = false;
    }
  }
  function bindFramebuffer(target, framebuffer) {
    if (currentBoundFramebuffers[target] !== framebuffer) {
      gl.bindFramebuffer(target, framebuffer);
      currentBoundFramebuffers[target] = framebuffer;
      if (target === gl.DRAW_FRAMEBUFFER) {
        currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
      }
      if (target === gl.FRAMEBUFFER) {
        currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
      }
      return true;
    }
    return false;
  }
  function drawBuffers(renderTarget, framebuffer) {
    let drawBuffers2 = defaultDrawbuffers;
    let needsUpdate = false;
    if (renderTarget) {
      drawBuffers2 = currentDrawbuffers.get(framebuffer);
      if (drawBuffers2 === void 0) {
        drawBuffers2 = [];
        currentDrawbuffers.set(framebuffer, drawBuffers2);
      }
      const textures = renderTarget.textures;
      if (drawBuffers2.length !== textures.length || drawBuffers2[0] !== gl.COLOR_ATTACHMENT0) {
        for (let i2 = 0, il = textures.length; i2 < il; i2++) {
          drawBuffers2[i2] = gl.COLOR_ATTACHMENT0 + i2;
        }
        drawBuffers2.length = textures.length;
        needsUpdate = true;
      }
    } else {
      if (drawBuffers2[0] !== gl.BACK) {
        drawBuffers2[0] = gl.BACK;
        needsUpdate = true;
      }
    }
    if (needsUpdate) {
      gl.drawBuffers(drawBuffers2);
    }
  }
  function useProgram(program) {
    if (currentProgram !== program) {
      gl.useProgram(program);
      currentProgram = program;
      return true;
    }
    return false;
  }
  const equationToGL = {
    [AddEquation$1]: gl.FUNC_ADD,
    [SubtractEquation$1]: gl.FUNC_SUBTRACT,
    [ReverseSubtractEquation$1]: gl.FUNC_REVERSE_SUBTRACT
  };
  equationToGL[MinEquation$1] = gl.MIN;
  equationToGL[MaxEquation$1] = gl.MAX;
  const factorToGL = {
    [ZeroFactor$1]: gl.ZERO,
    [OneFactor$1]: gl.ONE,
    [SrcColorFactor$1]: gl.SRC_COLOR,
    [SrcAlphaFactor$1]: gl.SRC_ALPHA,
    [SrcAlphaSaturateFactor$1]: gl.SRC_ALPHA_SATURATE,
    [DstColorFactor$1]: gl.DST_COLOR,
    [DstAlphaFactor$1]: gl.DST_ALPHA,
    [OneMinusSrcColorFactor$1]: gl.ONE_MINUS_SRC_COLOR,
    [OneMinusSrcAlphaFactor$1]: gl.ONE_MINUS_SRC_ALPHA,
    [OneMinusDstColorFactor$1]: gl.ONE_MINUS_DST_COLOR,
    [OneMinusDstAlphaFactor$1]: gl.ONE_MINUS_DST_ALPHA,
    [ConstantColorFactor]: gl.CONSTANT_COLOR,
    [OneMinusConstantColorFactor]: gl.ONE_MINUS_CONSTANT_COLOR,
    [ConstantAlphaFactor]: gl.CONSTANT_ALPHA,
    [OneMinusConstantAlphaFactor]: gl.ONE_MINUS_CONSTANT_ALPHA
  };
  function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
    if (blending === NoBlending$1) {
      if (currentBlendingEnabled === true) {
        disable(gl.BLEND);
        currentBlendingEnabled = false;
      }
      return;
    }
    if (currentBlendingEnabled === false) {
      enable(gl.BLEND);
      currentBlendingEnabled = true;
    }
    if (blending !== CustomBlending$1) {
      if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
        if (currentBlendEquation !== AddEquation$1 || currentBlendEquationAlpha !== AddEquation$1) {
          gl.blendEquation(gl.FUNC_ADD);
          currentBlendEquation = AddEquation$1;
          currentBlendEquationAlpha = AddEquation$1;
        }
        if (premultipliedAlpha) {
          switch (blending) {
            case NormalBlending$1:
              gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
              break;
            case AdditiveBlending$1:
              gl.blendFunc(gl.ONE, gl.ONE);
              break;
            case SubtractiveBlending$1:
              gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
              break;
            case MultiplyBlending$1:
              gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", blending);
              break;
          }
        } else {
          switch (blending) {
            case NormalBlending$1:
              gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
              break;
            case AdditiveBlending$1:
              gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
              break;
            case SubtractiveBlending$1:
              gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
              break;
            case MultiplyBlending$1:
              gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", blending);
              break;
          }
        }
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor.set(0, 0, 0);
        currentBlendAlpha = 0;
        currentBlending = blending;
        currentPremultipledAlpha = premultipliedAlpha;
      }
      return;
    }
    blendEquationAlpha = blendEquationAlpha || blendEquation;
    blendSrcAlpha = blendSrcAlpha || blendSrc;
    blendDstAlpha = blendDstAlpha || blendDst;
    if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
      gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
      currentBlendEquation = blendEquation;
      currentBlendEquationAlpha = blendEquationAlpha;
    }
    if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
      gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
      currentBlendSrc = blendSrc;
      currentBlendDst = blendDst;
      currentBlendSrcAlpha = blendSrcAlpha;
      currentBlendDstAlpha = blendDstAlpha;
    }
    if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
      gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
      currentBlendColor.copy(blendColor);
      currentBlendAlpha = blendAlpha;
    }
    currentBlending = blending;
    currentPremultipledAlpha = false;
  }
  function setMaterial(material, frontFaceCW) {
    material.side === DoubleSide$1 ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
    let flipSided = material.side === BackSide$1;
    if (frontFaceCW) flipSided = !flipSided;
    setFlipSided(flipSided);
    material.blending === NormalBlending$1 && material.transparent === false ? setBlending(NoBlending$1) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
    depthBuffer.setFunc(material.depthFunc);
    depthBuffer.setTest(material.depthTest);
    depthBuffer.setMask(material.depthWrite);
    colorBuffer.setMask(material.colorWrite);
    const stencilWrite = material.stencilWrite;
    stencilBuffer.setTest(stencilWrite);
    if (stencilWrite) {
      stencilBuffer.setMask(material.stencilWriteMask);
      stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
      stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
    }
    setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
    material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
  }
  function setFlipSided(flipSided) {
    if (currentFlipSided !== flipSided) {
      if (flipSided) {
        gl.frontFace(gl.CW);
      } else {
        gl.frontFace(gl.CCW);
      }
      currentFlipSided = flipSided;
    }
  }
  function setCullFace(cullFace) {
    if (cullFace !== CullFaceNone$1) {
      enable(gl.CULL_FACE);
      if (cullFace !== currentCullFace) {
        if (cullFace === CullFaceBack$1) {
          gl.cullFace(gl.BACK);
        } else if (cullFace === CullFaceFront$1) {
          gl.cullFace(gl.FRONT);
        } else {
          gl.cullFace(gl.FRONT_AND_BACK);
        }
      }
    } else {
      disable(gl.CULL_FACE);
    }
    currentCullFace = cullFace;
  }
  function setLineWidth(width) {
    if (width !== currentLineWidth) {
      if (lineWidthAvailable) gl.lineWidth(width);
      currentLineWidth = width;
    }
  }
  function setPolygonOffset(polygonOffset, factor, units) {
    if (polygonOffset) {
      enable(gl.POLYGON_OFFSET_FILL);
      if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
        gl.polygonOffset(factor, units);
        currentPolygonOffsetFactor = factor;
        currentPolygonOffsetUnits = units;
      }
    } else {
      disable(gl.POLYGON_OFFSET_FILL);
    }
  }
  function setScissorTest(scissorTest) {
    if (scissorTest) {
      enable(gl.SCISSOR_TEST);
    } else {
      disable(gl.SCISSOR_TEST);
    }
  }
  function activeTexture(webglSlot) {
    if (webglSlot === void 0) webglSlot = gl.TEXTURE0 + maxTextures - 1;
    if (currentTextureSlot !== webglSlot) {
      gl.activeTexture(webglSlot);
      currentTextureSlot = webglSlot;
    }
  }
  function bindTexture(webglType, webglTexture, webglSlot) {
    if (webglSlot === void 0) {
      if (currentTextureSlot === null) {
        webglSlot = gl.TEXTURE0 + maxTextures - 1;
      } else {
        webglSlot = currentTextureSlot;
      }
    }
    let boundTexture = currentBoundTextures[webglSlot];
    if (boundTexture === void 0) {
      boundTexture = { type: void 0, texture: void 0 };
      currentBoundTextures[webglSlot] = boundTexture;
    }
    if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
      if (currentTextureSlot !== webglSlot) {
        gl.activeTexture(webglSlot);
        currentTextureSlot = webglSlot;
      }
      gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
      boundTexture.type = webglType;
      boundTexture.texture = webglTexture;
    }
  }
  function unbindTexture() {
    const boundTexture = currentBoundTextures[currentTextureSlot];
    if (boundTexture !== void 0 && boundTexture.type !== void 0) {
      gl.bindTexture(boundTexture.type, null);
      boundTexture.type = void 0;
      boundTexture.texture = void 0;
    }
  }
  function compressedTexImage2D() {
    try {
      gl.compressedTexImage2D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function compressedTexImage3D() {
    try {
      gl.compressedTexImage3D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texSubImage2D() {
    try {
      gl.texSubImage2D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texSubImage3D() {
    try {
      gl.texSubImage3D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function compressedTexSubImage2D() {
    try {
      gl.compressedTexSubImage2D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function compressedTexSubImage3D() {
    try {
      gl.compressedTexSubImage3D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texStorage2D() {
    try {
      gl.texStorage2D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texStorage3D() {
    try {
      gl.texStorage3D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texImage2D() {
    try {
      gl.texImage2D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texImage3D() {
    try {
      gl.texImage3D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function scissor(scissor2) {
    if (currentScissor.equals(scissor2) === false) {
      gl.scissor(scissor2.x, scissor2.y, scissor2.z, scissor2.w);
      currentScissor.copy(scissor2);
    }
  }
  function viewport(viewport2) {
    if (currentViewport.equals(viewport2) === false) {
      gl.viewport(viewport2.x, viewport2.y, viewport2.z, viewport2.w);
      currentViewport.copy(viewport2);
    }
  }
  function updateUBOMapping(uniformsGroup, program) {
    let mapping = uboProgramMap.get(program);
    if (mapping === void 0) {
      mapping = /* @__PURE__ */ new WeakMap();
      uboProgramMap.set(program, mapping);
    }
    let blockIndex = mapping.get(uniformsGroup);
    if (blockIndex === void 0) {
      blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
      mapping.set(uniformsGroup, blockIndex);
    }
  }
  function uniformBlockBinding(uniformsGroup, program) {
    const mapping = uboProgramMap.get(program);
    const blockIndex = mapping.get(uniformsGroup);
    if (uboBindings.get(program) !== blockIndex) {
      gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
      uboBindings.set(program, blockIndex);
    }
  }
  function reset() {
    gl.disable(gl.BLEND);
    gl.disable(gl.CULL_FACE);
    gl.disable(gl.DEPTH_TEST);
    gl.disable(gl.POLYGON_OFFSET_FILL);
    gl.disable(gl.SCISSOR_TEST);
    gl.disable(gl.STENCIL_TEST);
    gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    gl.blendEquation(gl.FUNC_ADD);
    gl.blendFunc(gl.ONE, gl.ZERO);
    gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
    gl.blendColor(0, 0, 0, 0);
    gl.colorMask(true, true, true, true);
    gl.clearColor(0, 0, 0, 0);
    gl.depthMask(true);
    gl.depthFunc(gl.LESS);
    depthBuffer.setReversed(false);
    gl.clearDepth(1);
    gl.stencilMask(4294967295);
    gl.stencilFunc(gl.ALWAYS, 0, 4294967295);
    gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
    gl.clearStencil(0);
    gl.cullFace(gl.BACK);
    gl.frontFace(gl.CCW);
    gl.polygonOffset(0, 0);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
    gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
    gl.useProgram(null);
    gl.lineWidth(1);
    gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
    gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
    enabledCapabilities = {};
    currentTextureSlot = null;
    currentBoundTextures = {};
    currentBoundFramebuffers = {};
    currentDrawbuffers = /* @__PURE__ */ new WeakMap();
    defaultDrawbuffers = [];
    currentProgram = null;
    currentBlendingEnabled = false;
    currentBlending = null;
    currentBlendEquation = null;
    currentBlendSrc = null;
    currentBlendDst = null;
    currentBlendEquationAlpha = null;
    currentBlendSrcAlpha = null;
    currentBlendDstAlpha = null;
    currentBlendColor = new Color$1(0, 0, 0);
    currentBlendAlpha = 0;
    currentPremultipledAlpha = false;
    currentFlipSided = null;
    currentCullFace = null;
    currentLineWidth = null;
    currentPolygonOffsetFactor = null;
    currentPolygonOffsetUnits = null;
    currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
    currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
    colorBuffer.reset();
    depthBuffer.reset();
    stencilBuffer.reset();
  }
  return {
    buffers: {
      color: colorBuffer,
      depth: depthBuffer,
      stencil: stencilBuffer
    },
    enable,
    disable,
    bindFramebuffer,
    drawBuffers,
    useProgram,
    setBlending,
    setMaterial,
    setFlipSided,
    setCullFace,
    setLineWidth,
    setPolygonOffset,
    setScissorTest,
    activeTexture,
    bindTexture,
    unbindTexture,
    compressedTexImage2D,
    compressedTexImage3D,
    texImage2D,
    texImage3D,
    updateUBOMapping,
    uniformBlockBinding,
    texStorage2D,
    texStorage3D,
    texSubImage2D,
    texSubImage3D,
    compressedTexSubImage2D,
    compressedTexSubImage3D,
    scissor,
    viewport,
    reset
  };
}
function WebGLTextures$1(_gl, extensions, state, properties, capabilities, utils2, info) {
  const multisampledRTTExt = extensions.has("WEBGL_multisampled_render_to_texture") ? extensions.get("WEBGL_multisampled_render_to_texture") : null;
  const supportsInvalidateFramebuffer = typeof navigator === "undefined" ? false : /OculusBrowser/g.test(navigator.userAgent);
  const _imageDimensions = new Vector2$1();
  const _videoTextures = /* @__PURE__ */ new WeakMap();
  let _canvas2;
  const _sources = /* @__PURE__ */ new WeakMap();
  let useOffscreenCanvas = false;
  try {
    useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch (err2) {
  }
  function createCanvas(width, height) {
    return useOffscreenCanvas ? (
      // eslint-disable-next-line compat/compat
      new OffscreenCanvas(width, height)
    ) : createElementNS("canvas");
  }
  function resizeImage(image2, needsNewCanvas, maxSize) {
    let scale = 1;
    const dimensions = getDimensions(image2);
    if (dimensions.width > maxSize || dimensions.height > maxSize) {
      scale = maxSize / Math.max(dimensions.width, dimensions.height);
    }
    if (scale < 1) {
      if (typeof HTMLImageElement !== "undefined" && image2 instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image2 instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image2 instanceof ImageBitmap || typeof VideoFrame !== "undefined" && image2 instanceof VideoFrame) {
        const width = Math.floor(scale * dimensions.width);
        const height = Math.floor(scale * dimensions.height);
        if (_canvas2 === void 0) _canvas2 = createCanvas(width, height);
        const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas2;
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext("2d");
        context.drawImage(image2, 0, 0, width, height);
        console.warn("THREE.WebGLRenderer: Texture has been resized from (" + dimensions.width + "x" + dimensions.height + ") to (" + width + "x" + height + ").");
        return canvas;
      } else {
        if ("data" in image2) {
          console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + dimensions.width + "x" + dimensions.height + ").");
        }
        return image2;
      }
    }
    return image2;
  }
  function textureNeedsGenerateMipmaps(texture) {
    return texture.generateMipmaps;
  }
  function generateMipmap(target) {
    _gl.generateMipmap(target);
  }
  function getTargetType(texture) {
    if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
    if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
    if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
    return _gl.TEXTURE_2D;
  }
  function getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
    if (internalFormatName !== null) {
      if (_gl[internalFormatName] !== void 0) return _gl[internalFormatName];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
    }
    let internalFormat = glFormat;
    if (glFormat === _gl.RED) {
      if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
      if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
    }
    if (glFormat === _gl.RED_INTEGER) {
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
      if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
      if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
      if (glType === _gl.BYTE) internalFormat = _gl.R8I;
      if (glType === _gl.SHORT) internalFormat = _gl.R16I;
      if (glType === _gl.INT) internalFormat = _gl.R32I;
    }
    if (glFormat === _gl.RG) {
      if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
      if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
    }
    if (glFormat === _gl.RG_INTEGER) {
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
      if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
      if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
      if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
      if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
      if (glType === _gl.INT) internalFormat = _gl.RG32I;
    }
    if (glFormat === _gl.RGB_INTEGER) {
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
      if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
      if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
      if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
      if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
      if (glType === _gl.INT) internalFormat = _gl.RGB32I;
    }
    if (glFormat === _gl.RGBA_INTEGER) {
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
      if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
      if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
      if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
      if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
      if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
    }
    if (glFormat === _gl.RGB) {
      if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
    }
    if (glFormat === _gl.RGBA) {
      const transfer = forceLinearTransfer ? LinearTransfer : ColorManagement.getTransfer(colorSpace);
      if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
      if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
      if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === SRGBTransfer ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
      if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
      if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
    }
    if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) {
      extensions.get("EXT_color_buffer_float");
    }
    return internalFormat;
  }
  function getInternalDepthFormat(useStencil, depthType) {
    let glInternalFormat;
    if (useStencil) {
      if (depthType === null || depthType === UnsignedIntType$1 || depthType === UnsignedInt248Type$1) {
        glInternalFormat = _gl.DEPTH24_STENCIL8;
      } else if (depthType === FloatType$1) {
        glInternalFormat = _gl.DEPTH32F_STENCIL8;
      } else if (depthType === UnsignedShortType$1) {
        glInternalFormat = _gl.DEPTH24_STENCIL8;
        console.warn("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.");
      }
    } else {
      if (depthType === null || depthType === UnsignedIntType$1 || depthType === UnsignedInt248Type$1) {
        glInternalFormat = _gl.DEPTH_COMPONENT24;
      } else if (depthType === FloatType$1) {
        glInternalFormat = _gl.DEPTH_COMPONENT32F;
      } else if (depthType === UnsignedShortType$1) {
        glInternalFormat = _gl.DEPTH_COMPONENT16;
      }
    }
    return glInternalFormat;
  }
  function getMipLevels(texture, image2) {
    if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== NearestFilter$1 && texture.minFilter !== LinearFilter$1) {
      return Math.log2(Math.max(image2.width, image2.height)) + 1;
    } else if (texture.mipmaps !== void 0 && texture.mipmaps.length > 0) {
      return texture.mipmaps.length;
    } else if (texture.isCompressedTexture && Array.isArray(texture.image)) {
      return image2.mipmaps.length;
    } else {
      return 1;
    }
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    deallocateTexture(texture);
    if (texture.isVideoTexture) {
      _videoTextures.delete(texture);
    }
  }
  function onRenderTargetDispose(event) {
    const renderTarget = event.target;
    renderTarget.removeEventListener("dispose", onRenderTargetDispose);
    deallocateRenderTarget(renderTarget);
  }
  function deallocateTexture(texture) {
    const textureProperties = properties.get(texture);
    if (textureProperties.__webglInit === void 0) return;
    const source = texture.source;
    const webglTextures = _sources.get(source);
    if (webglTextures) {
      const webglTexture = webglTextures[textureProperties.__cacheKey];
      webglTexture.usedTimes--;
      if (webglTexture.usedTimes === 0) {
        deleteTexture(texture);
      }
      if (Object.keys(webglTextures).length === 0) {
        _sources.delete(source);
      }
    }
    properties.remove(texture);
  }
  function deleteTexture(texture) {
    const textureProperties = properties.get(texture);
    _gl.deleteTexture(textureProperties.__webglTexture);
    const source = texture.source;
    const webglTextures = _sources.get(source);
    delete webglTextures[textureProperties.__cacheKey];
    info.memory.textures--;
  }
  function deallocateRenderTarget(renderTarget) {
    const renderTargetProperties = properties.get(renderTarget);
    if (renderTarget.depthTexture) {
      renderTarget.depthTexture.dispose();
      properties.remove(renderTarget.depthTexture);
    }
    if (renderTarget.isWebGLCubeRenderTarget) {
      for (let i2 = 0; i2 < 6; i2++) {
        if (Array.isArray(renderTargetProperties.__webglFramebuffer[i2])) {
          for (let level = 0; level < renderTargetProperties.__webglFramebuffer[i2].length; level++) _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i2][level]);
        } else {
          _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i2]);
        }
        if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i2]);
      }
    } else {
      if (Array.isArray(renderTargetProperties.__webglFramebuffer)) {
        for (let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++) _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
      } else {
        _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
      }
      if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
      if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
      if (renderTargetProperties.__webglColorRenderbuffer) {
        for (let i2 = 0; i2 < renderTargetProperties.__webglColorRenderbuffer.length; i2++) {
          if (renderTargetProperties.__webglColorRenderbuffer[i2]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i2]);
        }
      }
      if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
    }
    const textures = renderTarget.textures;
    for (let i2 = 0, il = textures.length; i2 < il; i2++) {
      const attachmentProperties = properties.get(textures[i2]);
      if (attachmentProperties.__webglTexture) {
        _gl.deleteTexture(attachmentProperties.__webglTexture);
        info.memory.textures--;
      }
      properties.remove(textures[i2]);
    }
    properties.remove(renderTarget);
  }
  let textureUnits = 0;
  function resetTextureUnits() {
    textureUnits = 0;
  }
  function allocateTextureUnit() {
    const textureUnit = textureUnits;
    if (textureUnit >= capabilities.maxTextures) {
      console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + capabilities.maxTextures);
    }
    textureUnits += 1;
    return textureUnit;
  }
  function getTextureCacheKey(texture) {
    const array = [];
    array.push(texture.wrapS);
    array.push(texture.wrapT);
    array.push(texture.wrapR || 0);
    array.push(texture.magFilter);
    array.push(texture.minFilter);
    array.push(texture.anisotropy);
    array.push(texture.internalFormat);
    array.push(texture.format);
    array.push(texture.type);
    array.push(texture.generateMipmaps);
    array.push(texture.premultiplyAlpha);
    array.push(texture.flipY);
    array.push(texture.unpackAlignment);
    array.push(texture.colorSpace);
    return array.join();
  }
  function setTexture2D(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.isVideoTexture) updateVideoTexture(texture);
    if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
      const image2 = texture.image;
      if (image2 === null) {
        console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
      } else if (image2.complete === false) {
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      } else {
        uploadTexture(textureProperties, texture, slot);
        return;
      }
    }
    state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
  }
  function setTexture2DArray(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }
    state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
  }
  function setTexture3D(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }
    state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
  }
  function setTextureCube(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadCubeTexture(textureProperties, texture, slot);
      return;
    }
    state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
  }
  const wrappingToGL = {
    [RepeatWrapping$1]: _gl.REPEAT,
    [ClampToEdgeWrapping$1]: _gl.CLAMP_TO_EDGE,
    [MirroredRepeatWrapping$1]: _gl.MIRRORED_REPEAT
  };
  const filterToGL = {
    [NearestFilter$1]: _gl.NEAREST,
    [NearestMipmapNearestFilter$1]: _gl.NEAREST_MIPMAP_NEAREST,
    [NearestMipmapLinearFilter$1]: _gl.NEAREST_MIPMAP_LINEAR,
    [LinearFilter$1]: _gl.LINEAR,
    [LinearMipmapNearestFilter$1]: _gl.LINEAR_MIPMAP_NEAREST,
    [LinearMipmapLinearFilter$1]: _gl.LINEAR_MIPMAP_LINEAR
  };
  const compareToGL = {
    [NeverCompare]: _gl.NEVER,
    [AlwaysCompare]: _gl.ALWAYS,
    [LessCompare]: _gl.LESS,
    [LessEqualCompare]: _gl.LEQUAL,
    [EqualCompare]: _gl.EQUAL,
    [GreaterEqualCompare]: _gl.GEQUAL,
    [GreaterCompare]: _gl.GREATER,
    [NotEqualCompare]: _gl.NOTEQUAL
  };
  function setTextureParameters(textureType, texture) {
    if (texture.type === FloatType$1 && extensions.has("OES_texture_float_linear") === false && (texture.magFilter === LinearFilter$1 || texture.magFilter === LinearMipmapNearestFilter$1 || texture.magFilter === NearestMipmapLinearFilter$1 || texture.magFilter === LinearMipmapLinearFilter$1 || texture.minFilter === LinearFilter$1 || texture.minFilter === LinearMipmapNearestFilter$1 || texture.minFilter === NearestMipmapLinearFilter$1 || texture.minFilter === LinearMipmapLinearFilter$1)) {
      console.warn("THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.");
    }
    _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
    _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
    if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) {
      _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
    }
    _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
    _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
    if (texture.compareFunction) {
      _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
      _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
    }
    if (extensions.has("EXT_texture_filter_anisotropic") === true) {
      if (texture.magFilter === NearestFilter$1) return;
      if (texture.minFilter !== NearestMipmapLinearFilter$1 && texture.minFilter !== LinearMipmapLinearFilter$1) return;
      if (texture.type === FloatType$1 && extensions.has("OES_texture_float_linear") === false) return;
      if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
        const extension = extensions.get("EXT_texture_filter_anisotropic");
        _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
        properties.get(texture).__currentAnisotropy = texture.anisotropy;
      }
    }
  }
  function initTexture(textureProperties, texture) {
    let forceUpload = false;
    if (textureProperties.__webglInit === void 0) {
      textureProperties.__webglInit = true;
      texture.addEventListener("dispose", onTextureDispose);
    }
    const source = texture.source;
    let webglTextures = _sources.get(source);
    if (webglTextures === void 0) {
      webglTextures = {};
      _sources.set(source, webglTextures);
    }
    const textureCacheKey = getTextureCacheKey(texture);
    if (textureCacheKey !== textureProperties.__cacheKey) {
      if (webglTextures[textureCacheKey] === void 0) {
        webglTextures[textureCacheKey] = {
          texture: _gl.createTexture(),
          usedTimes: 0
        };
        info.memory.textures++;
        forceUpload = true;
      }
      webglTextures[textureCacheKey].usedTimes++;
      const webglTexture = webglTextures[textureProperties.__cacheKey];
      if (webglTexture !== void 0) {
        webglTextures[textureProperties.__cacheKey].usedTimes--;
        if (webglTexture.usedTimes === 0) {
          deleteTexture(texture);
        }
      }
      textureProperties.__cacheKey = textureCacheKey;
      textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
    }
    return forceUpload;
  }
  function uploadTexture(textureProperties, texture, slot) {
    let textureType = _gl.TEXTURE_2D;
    if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
    if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
    const forceUpload = initTexture(textureProperties, texture);
    const source = texture.source;
    state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    const sourceProperties = properties.get(source);
    if (source.version !== sourceProperties.__version || forceUpload === true) {
      state.activeTexture(_gl.TEXTURE0 + slot);
      const workingPrimaries = ColorManagement.getPrimaries(ColorManagement.workingColorSpace);
      const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries(texture.colorSpace);
      const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
      _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
      _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
      _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
      _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
      let image2 = resizeImage(texture.image, false, capabilities.maxTextureSize);
      image2 = verifyColorSpace(texture, image2);
      const glFormat = utils2.convert(texture.format, texture.colorSpace);
      const glType = utils2.convert(texture.type);
      let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
      setTextureParameters(textureType, texture);
      let mipmap;
      const mipmaps = texture.mipmaps;
      const useTexStorage = texture.isVideoTexture !== true;
      const allocateMemory = sourceProperties.__version === void 0 || forceUpload === true;
      const dataReady = source.dataReady;
      const levels = getMipLevels(texture, image2);
      if (texture.isDepthTexture) {
        glInternalFormat = getInternalDepthFormat(texture.format === DepthStencilFormat$1, texture.type);
        if (allocateMemory) {
          if (useTexStorage) {
            state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image2.width, image2.height);
          } else {
            state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image2.width, image2.height, 0, glFormat, glType, null);
          }
        }
      } else if (texture.isDataTexture) {
        if (mipmaps.length > 0) {
          if (useTexStorage && allocateMemory) {
            state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
          }
          for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
            mipmap = mipmaps[i2];
            if (useTexStorage) {
              if (dataReady) {
                state.texSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
          }
          texture.generateMipmaps = false;
        } else {
          if (useTexStorage) {
            if (allocateMemory) {
              state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image2.width, image2.height);
            }
            if (dataReady) {
              state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image2.width, image2.height, glFormat, glType, image2.data);
            }
          } else {
            state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image2.width, image2.height, 0, glFormat, glType, image2.data);
          }
        }
      } else if (texture.isCompressedTexture) {
        if (texture.isCompressedArrayTexture) {
          if (useTexStorage && allocateMemory) {
            state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image2.depth);
          }
          for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
            mipmap = mipmaps[i2];
            if (texture.format !== RGBAFormat$1) {
              if (glFormat !== null) {
                if (useTexStorage) {
                  if (dataReady) {
                    if (texture.layerUpdates.size > 0) {
                      const layerByteLength = getByteLength(mipmap.width, mipmap.height, texture.format, texture.type);
                      for (const layerIndex of texture.layerUpdates) {
                        const layerData = mipmap.data.subarray(
                          layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT,
                          (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT
                        );
                        state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i2, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                      }
                      texture.clearLayerUpdates();
                    } else {
                      state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i2, 0, 0, 0, mipmap.width, mipmap.height, image2.depth, glFormat, mipmap.data);
                    }
                  }
                } else {
                  state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i2, glInternalFormat, mipmap.width, mipmap.height, image2.depth, 0, mipmap.data, 0, 0);
                }
              } else {
                console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
              }
            } else {
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i2, 0, 0, 0, mipmap.width, mipmap.height, image2.depth, glFormat, glType, mipmap.data);
                }
              } else {
                state.texImage3D(_gl.TEXTURE_2D_ARRAY, i2, glInternalFormat, mipmap.width, mipmap.height, image2.depth, 0, glFormat, glType, mipmap.data);
              }
            }
          }
        } else {
          if (useTexStorage && allocateMemory) {
            state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
          }
          for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
            mipmap = mipmaps[i2];
            if (texture.format !== RGBAFormat$1) {
              if (glFormat !== null) {
                if (useTexStorage) {
                  if (dataReady) {
                    state.compressedTexSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                  }
                } else {
                  state.compressedTexImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                }
              } else {
                console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
              }
            } else {
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
              }
            }
          }
        }
      } else if (texture.isDataArrayTexture) {
        if (useTexStorage) {
          if (allocateMemory) {
            state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image2.width, image2.height, image2.depth);
          }
          if (dataReady) {
            if (texture.layerUpdates.size > 0) {
              const layerByteLength = getByteLength(image2.width, image2.height, texture.format, texture.type);
              for (const layerIndex of texture.layerUpdates) {
                const layerData = image2.data.subarray(
                  layerIndex * layerByteLength / image2.data.BYTES_PER_ELEMENT,
                  (layerIndex + 1) * layerByteLength / image2.data.BYTES_PER_ELEMENT
                );
                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image2.width, image2.height, 1, glFormat, glType, layerData);
              }
              texture.clearLayerUpdates();
            } else {
              state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image2.width, image2.height, image2.depth, glFormat, glType, image2.data);
            }
          }
        } else {
          state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image2.width, image2.height, image2.depth, 0, glFormat, glType, image2.data);
        }
      } else if (texture.isData3DTexture) {
        if (useTexStorage) {
          if (allocateMemory) {
            state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image2.width, image2.height, image2.depth);
          }
          if (dataReady) {
            state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image2.width, image2.height, image2.depth, glFormat, glType, image2.data);
          }
        } else {
          state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image2.width, image2.height, image2.depth, 0, glFormat, glType, image2.data);
        }
      } else if (texture.isFramebufferTexture) {
        if (allocateMemory) {
          if (useTexStorage) {
            state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image2.width, image2.height);
          } else {
            let width = image2.width, height = image2.height;
            for (let i2 = 0; i2 < levels; i2++) {
              state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, width, height, 0, glFormat, glType, null);
              width >>= 1;
              height >>= 1;
            }
          }
        }
      } else {
        if (mipmaps.length > 0) {
          if (useTexStorage && allocateMemory) {
            const dimensions = getDimensions(mipmaps[0]);
            state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
          }
          for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
            mipmap = mipmaps[i2];
            if (useTexStorage) {
              if (dataReady) {
                state.texSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, glFormat, glType, mipmap);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, glFormat, glType, mipmap);
            }
          }
          texture.generateMipmaps = false;
        } else {
          if (useTexStorage) {
            if (allocateMemory) {
              const dimensions = getDimensions(image2);
              state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
            }
            if (dataReady) {
              state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image2);
            }
          } else {
            state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image2);
          }
        }
      }
      if (textureNeedsGenerateMipmaps(texture)) {
        generateMipmap(textureType);
      }
      sourceProperties.__version = source.version;
      if (texture.onUpdate) texture.onUpdate(texture);
    }
    textureProperties.__version = texture.version;
  }
  function uploadCubeTexture(textureProperties, texture, slot) {
    if (texture.image.length !== 6) return;
    const forceUpload = initTexture(textureProperties, texture);
    const source = texture.source;
    state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    const sourceProperties = properties.get(source);
    if (source.version !== sourceProperties.__version || forceUpload === true) {
      state.activeTexture(_gl.TEXTURE0 + slot);
      const workingPrimaries = ColorManagement.getPrimaries(ColorManagement.workingColorSpace);
      const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries(texture.colorSpace);
      const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
      _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
      _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
      _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
      _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
      const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
      const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
      const cubeImage = [];
      for (let i2 = 0; i2 < 6; i2++) {
        if (!isCompressed && !isDataTexture) {
          cubeImage[i2] = resizeImage(texture.image[i2], true, capabilities.maxCubemapSize);
        } else {
          cubeImage[i2] = isDataTexture ? texture.image[i2].image : texture.image[i2];
        }
        cubeImage[i2] = verifyColorSpace(texture, cubeImage[i2]);
      }
      const image2 = cubeImage[0], glFormat = utils2.convert(texture.format, texture.colorSpace), glType = utils2.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
      const useTexStorage = texture.isVideoTexture !== true;
      const allocateMemory = sourceProperties.__version === void 0 || forceUpload === true;
      const dataReady = source.dataReady;
      let levels = getMipLevels(texture, image2);
      setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
      let mipmaps;
      if (isCompressed) {
        if (useTexStorage && allocateMemory) {
          state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image2.width, image2.height);
        }
        for (let i2 = 0; i2 < 6; i2++) {
          mipmaps = cubeImage[i2].mipmaps;
          for (let j = 0; j < mipmaps.length; j++) {
            const mipmap = mipmaps[j];
            if (texture.format !== RGBAFormat$1) {
              if (glFormat !== null) {
                if (useTexStorage) {
                  if (dataReady) {
                    state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                  }
                } else {
                  state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                }
              } else {
                console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
              }
            } else {
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
              }
            }
          }
        }
      } else {
        mipmaps = texture.mipmaps;
        if (useTexStorage && allocateMemory) {
          if (mipmaps.length > 0) levels++;
          const dimensions = getDimensions(cubeImage[0]);
          state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
        }
        for (let i2 = 0; i2 < 6; i2++) {
          if (isDataTexture) {
            if (useTexStorage) {
              if (dataReady) {
                state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, 0, 0, cubeImage[i2].width, cubeImage[i2].height, glFormat, glType, cubeImage[i2].data);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, glInternalFormat, cubeImage[i2].width, cubeImage[i2].height, 0, glFormat, glType, cubeImage[i2].data);
            }
            for (let j = 0; j < mipmaps.length; j++) {
              const mipmap = mipmaps[j];
              const mipmapImage = mipmap.image[i2].image;
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
              }
            }
          } else {
            if (useTexStorage) {
              if (dataReady) {
                state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, 0, 0, glFormat, glType, cubeImage[i2]);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, glInternalFormat, glFormat, glType, cubeImage[i2]);
            }
            for (let j = 0; j < mipmaps.length; j++) {
              const mipmap = mipmaps[j];
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j + 1, 0, 0, glFormat, glType, mipmap.image[i2]);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i2]);
              }
            }
          }
        }
      }
      if (textureNeedsGenerateMipmaps(texture)) {
        generateMipmap(_gl.TEXTURE_CUBE_MAP);
      }
      sourceProperties.__version = source.version;
      if (texture.onUpdate) texture.onUpdate(texture);
    }
    textureProperties.__version = texture.version;
  }
  function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
    const glFormat = utils2.convert(texture.format, texture.colorSpace);
    const glType = utils2.convert(texture.type);
    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
    const renderTargetProperties = properties.get(renderTarget);
    const textureProperties = properties.get(texture);
    textureProperties.__renderTarget = renderTarget;
    if (!renderTargetProperties.__hasExternalTextures) {
      const width = Math.max(1, renderTarget.width >> level);
      const height = Math.max(1, renderTarget.height >> level);
      if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) {
        state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
      } else {
        state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
      }
    }
    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
    if (useMultisampledRTT(renderTarget)) {
      multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
    } else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) {
      _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
    }
    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
  }
  function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
    if (renderTarget.depthBuffer) {
      const depthTexture = renderTarget.depthTexture;
      const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
      const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
      const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
      const samples = getRenderTargetSamples(renderTarget);
      const isUseMultisampledRTT = useMultisampledRTT(renderTarget);
      if (isUseMultisampledRTT) {
        multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
      } else if (isMultisample) {
        _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
      } else {
        _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
      }
      _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
    } else {
      const textures = renderTarget.textures;
      for (let i2 = 0; i2 < textures.length; i2++) {
        const texture = textures[i2];
        const glFormat = utils2.convert(texture.format, texture.colorSpace);
        const glType = utils2.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const samples = getRenderTargetSamples(renderTarget);
        if (isMultisample && useMultisampledRTT(renderTarget) === false) {
          _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
        } else if (useMultisampledRTT(renderTarget)) {
          multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
        } else {
          _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
        }
      }
    }
    _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
  }
  function setupDepthTexture(framebuffer, renderTarget) {
    const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
    if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
    if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) {
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    }
    const textureProperties = properties.get(renderTarget.depthTexture);
    textureProperties.__renderTarget = renderTarget;
    if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
      renderTarget.depthTexture.image.width = renderTarget.width;
      renderTarget.depthTexture.image.height = renderTarget.height;
      renderTarget.depthTexture.needsUpdate = true;
    }
    setTexture2D(renderTarget.depthTexture, 0);
    const webglDepthTexture = textureProperties.__webglTexture;
    const samples = getRenderTargetSamples(renderTarget);
    if (renderTarget.depthTexture.format === DepthFormat$1) {
      if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
      } else {
        _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
      }
    } else if (renderTarget.depthTexture.format === DepthStencilFormat$1) {
      if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
      } else {
        _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
      }
    } else {
      throw new Error("Unknown depthTexture format");
    }
  }
  function setupDepthRenderbuffer(renderTarget) {
    const renderTargetProperties = properties.get(renderTarget);
    const isCube = renderTarget.isWebGLCubeRenderTarget === true;
    if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
      const depthTexture = renderTarget.depthTexture;
      if (renderTargetProperties.__depthDisposeCallback) {
        renderTargetProperties.__depthDisposeCallback();
      }
      if (depthTexture) {
        const disposeEvent = () => {
          delete renderTargetProperties.__boundDepthTexture;
          delete renderTargetProperties.__depthDisposeCallback;
          depthTexture.removeEventListener("dispose", disposeEvent);
        };
        depthTexture.addEventListener("dispose", disposeEvent);
        renderTargetProperties.__depthDisposeCallback = disposeEvent;
      }
      renderTargetProperties.__boundDepthTexture = depthTexture;
    }
    if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
      if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
      setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
    } else {
      if (isCube) {
        renderTargetProperties.__webglDepthbuffer = [];
        for (let i2 = 0; i2 < 6; i2++) {
          state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i2]);
          if (renderTargetProperties.__webglDepthbuffer[i2] === void 0) {
            renderTargetProperties.__webglDepthbuffer[i2] = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i2], renderTarget, false);
          } else {
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            const renderbuffer = renderTargetProperties.__webglDepthbuffer[i2];
            _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
          }
        }
      } else {
        state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
        if (renderTargetProperties.__webglDepthbuffer === void 0) {
          renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
          setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        } else {
          const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
          const renderbuffer = renderTargetProperties.__webglDepthbuffer;
          _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
          _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        }
      }
    }
    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
  }
  function rebindTextures(renderTarget, colorTexture, depthTexture) {
    const renderTargetProperties = properties.get(renderTarget);
    if (colorTexture !== void 0) {
      setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
    }
    if (depthTexture !== void 0) {
      setupDepthRenderbuffer(renderTarget);
    }
  }
  function setupRenderTarget(renderTarget) {
    const texture = renderTarget.texture;
    const renderTargetProperties = properties.get(renderTarget);
    const textureProperties = properties.get(texture);
    renderTarget.addEventListener("dispose", onRenderTargetDispose);
    const textures = renderTarget.textures;
    const isCube = renderTarget.isWebGLCubeRenderTarget === true;
    const isMultipleRenderTargets = textures.length > 1;
    if (!isMultipleRenderTargets) {
      if (textureProperties.__webglTexture === void 0) {
        textureProperties.__webglTexture = _gl.createTexture();
      }
      textureProperties.__version = texture.version;
      info.memory.textures++;
    }
    if (isCube) {
      renderTargetProperties.__webglFramebuffer = [];
      for (let i2 = 0; i2 < 6; i2++) {
        if (texture.mipmaps && texture.mipmaps.length > 0) {
          renderTargetProperties.__webglFramebuffer[i2] = [];
          for (let level = 0; level < texture.mipmaps.length; level++) {
            renderTargetProperties.__webglFramebuffer[i2][level] = _gl.createFramebuffer();
          }
        } else {
          renderTargetProperties.__webglFramebuffer[i2] = _gl.createFramebuffer();
        }
      }
    } else {
      if (texture.mipmaps && texture.mipmaps.length > 0) {
        renderTargetProperties.__webglFramebuffer = [];
        for (let level = 0; level < texture.mipmaps.length; level++) {
          renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
        }
      } else {
        renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
      }
      if (isMultipleRenderTargets) {
        for (let i2 = 0, il = textures.length; i2 < il; i2++) {
          const attachmentProperties = properties.get(textures[i2]);
          if (attachmentProperties.__webglTexture === void 0) {
            attachmentProperties.__webglTexture = _gl.createTexture();
            info.memory.textures++;
          }
        }
      }
      if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
        renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
        renderTargetProperties.__webglColorRenderbuffer = [];
        state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        for (let i2 = 0; i2 < textures.length; i2++) {
          const texture2 = textures[i2];
          renderTargetProperties.__webglColorRenderbuffer[i2] = _gl.createRenderbuffer();
          _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
          const glFormat = utils2.convert(texture2.format, texture2.colorSpace);
          const glType = utils2.convert(texture2.type);
          const glInternalFormat = getInternalFormat(texture2.internalFormat, glFormat, glType, texture2.colorSpace, renderTarget.isXRRenderTarget === true);
          const samples = getRenderTargetSamples(renderTarget);
          _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
          _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
        if (renderTarget.depthBuffer) {
          renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
          setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
      }
    }
    if (isCube) {
      state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
      setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
      for (let i2 = 0; i2 < 6; i2++) {
        if (texture.mipmaps && texture.mipmaps.length > 0) {
          for (let level = 0; level < texture.mipmaps.length; level++) {
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i2][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, level);
          }
        } else {
          setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i2], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0);
        }
      }
      if (textureNeedsGenerateMipmaps(texture)) {
        generateMipmap(_gl.TEXTURE_CUBE_MAP);
      }
      state.unbindTexture();
    } else if (isMultipleRenderTargets) {
      for (let i2 = 0, il = textures.length; i2 < il; i2++) {
        const attachment = textures[i2];
        const attachmentProperties = properties.get(attachment);
        state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
        setTextureParameters(_gl.TEXTURE_2D, attachment);
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i2, _gl.TEXTURE_2D, 0);
        if (textureNeedsGenerateMipmaps(attachment)) {
          generateMipmap(_gl.TEXTURE_2D);
        }
      }
      state.unbindTexture();
    } else {
      let glTextureType = _gl.TEXTURE_2D;
      if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
        glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
      }
      state.bindTexture(glTextureType, textureProperties.__webglTexture);
      setTextureParameters(glTextureType, texture);
      if (texture.mipmaps && texture.mipmaps.length > 0) {
        for (let level = 0; level < texture.mipmaps.length; level++) {
          setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
        }
      } else {
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
      }
      if (textureNeedsGenerateMipmaps(texture)) {
        generateMipmap(glTextureType);
      }
      state.unbindTexture();
    }
    if (renderTarget.depthBuffer) {
      setupDepthRenderbuffer(renderTarget);
    }
  }
  function updateRenderTargetMipmap(renderTarget) {
    const textures = renderTarget.textures;
    for (let i2 = 0, il = textures.length; i2 < il; i2++) {
      const texture = textures[i2];
      if (textureNeedsGenerateMipmaps(texture)) {
        const targetType = getTargetType(renderTarget);
        const webglTexture = properties.get(texture).__webglTexture;
        state.bindTexture(targetType, webglTexture);
        generateMipmap(targetType);
        state.unbindTexture();
      }
    }
  }
  const invalidationArrayRead = [];
  const invalidationArrayDraw = [];
  function updateMultisampleRenderTarget(renderTarget) {
    if (renderTarget.samples > 0) {
      if (useMultisampledRTT(renderTarget) === false) {
        const textures = renderTarget.textures;
        const width = renderTarget.width;
        const height = renderTarget.height;
        let mask = _gl.COLOR_BUFFER_BIT;
        const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
        const renderTargetProperties = properties.get(renderTarget);
        const isMultipleRenderTargets = textures.length > 1;
        if (isMultipleRenderTargets) {
          for (let i2 = 0; i2 < textures.length; i2++) {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.RENDERBUFFER, null);
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.TEXTURE_2D, null, 0);
          }
        }
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
        for (let i2 = 0; i2 < textures.length; i2++) {
          if (renderTarget.resolveDepthBuffer) {
            if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
            if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
          }
          if (isMultipleRenderTargets) {
            _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
            const webglTexture = properties.get(textures[i2]).__webglTexture;
            _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
          }
          _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
          if (supportsInvalidateFramebuffer === true) {
            invalidationArrayRead.length = 0;
            invalidationArrayDraw.length = 0;
            invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i2);
            if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
              invalidationArrayRead.push(depthStyle);
              invalidationArrayDraw.push(depthStyle);
              _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
            }
            _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
          }
        }
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
        if (isMultipleRenderTargets) {
          for (let i2 = 0; i2 < textures.length; i2++) {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
            const webglTexture = properties.get(textures[i2]).__webglTexture;
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.TEXTURE_2D, webglTexture, 0);
          }
        }
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
      } else {
        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
          const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
          _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [depthStyle]);
        }
      }
    }
  }
  function getRenderTargetSamples(renderTarget) {
    return Math.min(capabilities.maxSamples, renderTarget.samples);
  }
  function useMultisampledRTT(renderTarget) {
    const renderTargetProperties = properties.get(renderTarget);
    return renderTarget.samples > 0 && extensions.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
  }
  function updateVideoTexture(texture) {
    const frame = info.render.frame;
    if (_videoTextures.get(texture) !== frame) {
      _videoTextures.set(texture, frame);
      texture.update();
    }
  }
  function verifyColorSpace(texture, image2) {
    const colorSpace = texture.colorSpace;
    const format = texture.format;
    const type = texture.type;
    if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image2;
    if (colorSpace !== LinearSRGBColorSpace && colorSpace !== NoColorSpace) {
      if (ColorManagement.getTransfer(colorSpace) === SRGBTransfer) {
        if (format !== RGBAFormat$1 || type !== UnsignedByteType$1) {
          console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
        }
      } else {
        console.error("THREE.WebGLTextures: Unsupported texture color space:", colorSpace);
      }
    }
    return image2;
  }
  function getDimensions(image2) {
    if (typeof HTMLImageElement !== "undefined" && image2 instanceof HTMLImageElement) {
      _imageDimensions.width = image2.naturalWidth || image2.width;
      _imageDimensions.height = image2.naturalHeight || image2.height;
    } else if (typeof VideoFrame !== "undefined" && image2 instanceof VideoFrame) {
      _imageDimensions.width = image2.displayWidth;
      _imageDimensions.height = image2.displayHeight;
    } else {
      _imageDimensions.width = image2.width;
      _imageDimensions.height = image2.height;
    }
    return _imageDimensions;
  }
  this.allocateTextureUnit = allocateTextureUnit;
  this.resetTextureUnits = resetTextureUnits;
  this.setTexture2D = setTexture2D;
  this.setTexture2DArray = setTexture2DArray;
  this.setTexture3D = setTexture3D;
  this.setTextureCube = setTextureCube;
  this.rebindTextures = rebindTextures;
  this.setupRenderTarget = setupRenderTarget;
  this.updateRenderTargetMipmap = updateRenderTargetMipmap;
  this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
  this.setupDepthRenderbuffer = setupDepthRenderbuffer;
  this.setupFrameBufferTexture = setupFrameBufferTexture;
  this.useMultisampledRTT = useMultisampledRTT;
}
function WebGLUtils$1(gl, extensions) {
  function convert2(p2, colorSpace = NoColorSpace) {
    let extension;
    const transfer = ColorManagement.getTransfer(colorSpace);
    if (p2 === UnsignedByteType$1) return gl.UNSIGNED_BYTE;
    if (p2 === UnsignedShort4444Type$1) return gl.UNSIGNED_SHORT_4_4_4_4;
    if (p2 === UnsignedShort5551Type$1) return gl.UNSIGNED_SHORT_5_5_5_1;
    if (p2 === UnsignedInt5999Type) return gl.UNSIGNED_INT_5_9_9_9_REV;
    if (p2 === ByteType$1) return gl.BYTE;
    if (p2 === ShortType$1) return gl.SHORT;
    if (p2 === UnsignedShortType$1) return gl.UNSIGNED_SHORT;
    if (p2 === IntType$1) return gl.INT;
    if (p2 === UnsignedIntType$1) return gl.UNSIGNED_INT;
    if (p2 === FloatType$1) return gl.FLOAT;
    if (p2 === HalfFloatType$1) return gl.HALF_FLOAT;
    if (p2 === AlphaFormat$1) return gl.ALPHA;
    if (p2 === RGBFormat$1) return gl.RGB;
    if (p2 === RGBAFormat$1) return gl.RGBA;
    if (p2 === LuminanceFormat$1) return gl.LUMINANCE;
    if (p2 === LuminanceAlphaFormat$1) return gl.LUMINANCE_ALPHA;
    if (p2 === DepthFormat$1) return gl.DEPTH_COMPONENT;
    if (p2 === DepthStencilFormat$1) return gl.DEPTH_STENCIL;
    if (p2 === RedFormat$1) return gl.RED;
    if (p2 === RedIntegerFormat$1) return gl.RED_INTEGER;
    if (p2 === RGFormat$1) return gl.RG;
    if (p2 === RGIntegerFormat$1) return gl.RG_INTEGER;
    if (p2 === RGBAIntegerFormat$1) return gl.RGBA_INTEGER;
    if (p2 === RGB_S3TC_DXT1_Format$1 || p2 === RGBA_S3TC_DXT1_Format$1 || p2 === RGBA_S3TC_DXT3_Format$1 || p2 === RGBA_S3TC_DXT5_Format$1) {
      if (transfer === SRGBTransfer) {
        extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
        if (extension !== null) {
          if (p2 === RGB_S3TC_DXT1_Format$1) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (p2 === RGBA_S3TC_DXT1_Format$1) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (p2 === RGBA_S3TC_DXT3_Format$1) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (p2 === RGBA_S3TC_DXT5_Format$1) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else {
          return null;
        }
      } else {
        extension = extensions.get("WEBGL_compressed_texture_s3tc");
        if (extension !== null) {
          if (p2 === RGB_S3TC_DXT1_Format$1) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
          if (p2 === RGBA_S3TC_DXT1_Format$1) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
          if (p2 === RGBA_S3TC_DXT3_Format$1) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
          if (p2 === RGBA_S3TC_DXT5_Format$1) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
        } else {
          return null;
        }
      }
    }
    if (p2 === RGB_PVRTC_4BPPV1_Format$1 || p2 === RGB_PVRTC_2BPPV1_Format$1 || p2 === RGBA_PVRTC_4BPPV1_Format$1 || p2 === RGBA_PVRTC_2BPPV1_Format$1) {
      extension = extensions.get("WEBGL_compressed_texture_pvrtc");
      if (extension !== null) {
        if (p2 === RGB_PVRTC_4BPPV1_Format$1) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (p2 === RGB_PVRTC_2BPPV1_Format$1) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (p2 === RGBA_PVRTC_4BPPV1_Format$1) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (p2 === RGBA_PVRTC_2BPPV1_Format$1) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else {
        return null;
      }
    }
    if (p2 === RGB_ETC1_Format$1 || p2 === RGB_ETC2_Format$1 || p2 === RGBA_ETC2_EAC_Format$1) {
      extension = extensions.get("WEBGL_compressed_texture_etc");
      if (extension !== null) {
        if (p2 === RGB_ETC1_Format$1 || p2 === RGB_ETC2_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
        if (p2 === RGBA_ETC2_EAC_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
      } else {
        return null;
      }
    }
    if (p2 === RGBA_ASTC_4x4_Format$1 || p2 === RGBA_ASTC_5x4_Format$1 || p2 === RGBA_ASTC_5x5_Format$1 || p2 === RGBA_ASTC_6x5_Format$1 || p2 === RGBA_ASTC_6x6_Format$1 || p2 === RGBA_ASTC_8x5_Format$1 || p2 === RGBA_ASTC_8x6_Format$1 || p2 === RGBA_ASTC_8x8_Format$1 || p2 === RGBA_ASTC_10x5_Format$1 || p2 === RGBA_ASTC_10x6_Format$1 || p2 === RGBA_ASTC_10x8_Format$1 || p2 === RGBA_ASTC_10x10_Format$1 || p2 === RGBA_ASTC_12x10_Format$1 || p2 === RGBA_ASTC_12x12_Format$1) {
      extension = extensions.get("WEBGL_compressed_texture_astc");
      if (extension !== null) {
        if (p2 === RGBA_ASTC_4x4_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (p2 === RGBA_ASTC_5x4_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (p2 === RGBA_ASTC_5x5_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (p2 === RGBA_ASTC_6x5_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (p2 === RGBA_ASTC_6x6_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (p2 === RGBA_ASTC_8x5_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (p2 === RGBA_ASTC_8x6_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (p2 === RGBA_ASTC_8x8_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (p2 === RGBA_ASTC_10x5_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (p2 === RGBA_ASTC_10x6_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (p2 === RGBA_ASTC_10x8_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (p2 === RGBA_ASTC_10x10_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (p2 === RGBA_ASTC_12x10_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (p2 === RGBA_ASTC_12x12_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else {
        return null;
      }
    }
    if (p2 === RGBA_BPTC_Format$1 || p2 === RGB_BPTC_SIGNED_Format || p2 === RGB_BPTC_UNSIGNED_Format) {
      extension = extensions.get("EXT_texture_compression_bptc");
      if (extension !== null) {
        if (p2 === RGBA_BPTC_Format$1) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
        if (p2 === RGB_BPTC_SIGNED_Format) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
        if (p2 === RGB_BPTC_UNSIGNED_Format) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
      } else {
        return null;
      }
    }
    if (p2 === RED_RGTC1_Format || p2 === SIGNED_RED_RGTC1_Format || p2 === RED_GREEN_RGTC2_Format || p2 === SIGNED_RED_GREEN_RGTC2_Format) {
      extension = extensions.get("EXT_texture_compression_rgtc");
      if (extension !== null) {
        if (p2 === RGBA_BPTC_Format$1) return extension.COMPRESSED_RED_RGTC1_EXT;
        if (p2 === SIGNED_RED_RGTC1_Format) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
        if (p2 === RED_GREEN_RGTC2_Format) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
        if (p2 === SIGNED_RED_GREEN_RGTC2_Format) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
      } else {
        return null;
      }
    }
    if (p2 === UnsignedInt248Type$1) return gl.UNSIGNED_INT_24_8;
    return gl[p2] !== void 0 ? gl[p2] : null;
  }
  return { convert: convert2 };
}
const _moveEvent$1 = { type: "move" };
let WebXRController$1 = class WebXRController {
  constructor() {
    this._targetRay = null;
    this._grip = null;
    this._hand = null;
  }
  getHandSpace() {
    if (this._hand === null) {
      this._hand = new Group$1();
      this._hand.matrixAutoUpdate = false;
      this._hand.visible = false;
      this._hand.joints = {};
      this._hand.inputState = { pinching: false };
    }
    return this._hand;
  }
  getTargetRaySpace() {
    if (this._targetRay === null) {
      this._targetRay = new Group$1();
      this._targetRay.matrixAutoUpdate = false;
      this._targetRay.visible = false;
      this._targetRay.hasLinearVelocity = false;
      this._targetRay.linearVelocity = new Vector3$1();
      this._targetRay.hasAngularVelocity = false;
      this._targetRay.angularVelocity = new Vector3$1();
    }
    return this._targetRay;
  }
  getGripSpace() {
    if (this._grip === null) {
      this._grip = new Group$1();
      this._grip.matrixAutoUpdate = false;
      this._grip.visible = false;
      this._grip.hasLinearVelocity = false;
      this._grip.linearVelocity = new Vector3$1();
      this._grip.hasAngularVelocity = false;
      this._grip.angularVelocity = new Vector3$1();
    }
    return this._grip;
  }
  dispatchEvent(event) {
    if (this._targetRay !== null) {
      this._targetRay.dispatchEvent(event);
    }
    if (this._grip !== null) {
      this._grip.dispatchEvent(event);
    }
    if (this._hand !== null) {
      this._hand.dispatchEvent(event);
    }
    return this;
  }
  connect(inputSource) {
    if (inputSource && inputSource.hand) {
      const hand = this._hand;
      if (hand) {
        for (const inputjoint of inputSource.hand.values()) {
          this._getHandJoint(hand, inputjoint);
        }
      }
    }
    this.dispatchEvent({ type: "connected", data: inputSource });
    return this;
  }
  disconnect(inputSource) {
    this.dispatchEvent({ type: "disconnected", data: inputSource });
    if (this._targetRay !== null) {
      this._targetRay.visible = false;
    }
    if (this._grip !== null) {
      this._grip.visible = false;
    }
    if (this._hand !== null) {
      this._hand.visible = false;
    }
    return this;
  }
  update(inputSource, frame, referenceSpace) {
    let inputPose = null;
    let gripPose = null;
    let handPose = null;
    const targetRay = this._targetRay;
    const grip = this._grip;
    const hand = this._hand;
    if (inputSource && frame.session.visibilityState !== "visible-blurred") {
      if (hand && inputSource.hand) {
        handPose = true;
        for (const inputjoint of inputSource.hand.values()) {
          const jointPose = frame.getJointPose(inputjoint, referenceSpace);
          const joint = this._getHandJoint(hand, inputjoint);
          if (jointPose !== null) {
            joint.matrix.fromArray(jointPose.transform.matrix);
            joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
            joint.matrixWorldNeedsUpdate = true;
            joint.jointRadius = jointPose.radius;
          }
          joint.visible = jointPose !== null;
        }
        const indexTip = hand.joints["index-finger-tip"];
        const thumbTip = hand.joints["thumb-tip"];
        const distance2 = indexTip.position.distanceTo(thumbTip.position);
        const distanceToPinch = 0.02;
        const threshold = 5e-3;
        if (hand.inputState.pinching && distance2 > distanceToPinch + threshold) {
          hand.inputState.pinching = false;
          this.dispatchEvent({
            type: "pinchend",
            handedness: inputSource.handedness,
            target: this
          });
        } else if (!hand.inputState.pinching && distance2 <= distanceToPinch - threshold) {
          hand.inputState.pinching = true;
          this.dispatchEvent({
            type: "pinchstart",
            handedness: inputSource.handedness,
            target: this
          });
        }
      } else {
        if (grip !== null && inputSource.gripSpace) {
          gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
          if (gripPose !== null) {
            grip.matrix.fromArray(gripPose.transform.matrix);
            grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
            grip.matrixWorldNeedsUpdate = true;
            if (gripPose.linearVelocity) {
              grip.hasLinearVelocity = true;
              grip.linearVelocity.copy(gripPose.linearVelocity);
            } else {
              grip.hasLinearVelocity = false;
            }
            if (gripPose.angularVelocity) {
              grip.hasAngularVelocity = true;
              grip.angularVelocity.copy(gripPose.angularVelocity);
            } else {
              grip.hasAngularVelocity = false;
            }
          }
        }
      }
      if (targetRay !== null) {
        inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
        if (inputPose === null && gripPose !== null) {
          inputPose = gripPose;
        }
        if (inputPose !== null) {
          targetRay.matrix.fromArray(inputPose.transform.matrix);
          targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
          targetRay.matrixWorldNeedsUpdate = true;
          if (inputPose.linearVelocity) {
            targetRay.hasLinearVelocity = true;
            targetRay.linearVelocity.copy(inputPose.linearVelocity);
          } else {
            targetRay.hasLinearVelocity = false;
          }
          if (inputPose.angularVelocity) {
            targetRay.hasAngularVelocity = true;
            targetRay.angularVelocity.copy(inputPose.angularVelocity);
          } else {
            targetRay.hasAngularVelocity = false;
          }
          this.dispatchEvent(_moveEvent$1);
        }
      }
    }
    if (targetRay !== null) {
      targetRay.visible = inputPose !== null;
    }
    if (grip !== null) {
      grip.visible = gripPose !== null;
    }
    if (hand !== null) {
      hand.visible = handPose !== null;
    }
    return this;
  }
  // private method
  _getHandJoint(hand, inputjoint) {
    if (hand.joints[inputjoint.jointName] === void 0) {
      const joint = new Group$1();
      joint.matrixAutoUpdate = false;
      joint.visible = false;
      hand.joints[inputjoint.jointName] = joint;
      hand.add(joint);
    }
    return hand.joints[inputjoint.jointName];
  }
};
const _occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const _occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class WebXRDepthSensing {
  constructor() {
    this.texture = null;
    this.mesh = null;
    this.depthNear = 0;
    this.depthFar = 0;
  }
  init(renderer, depthData, renderState) {
    if (this.texture === null) {
      const texture = new Texture$1();
      const texProps = renderer.properties.get(texture);
      texProps.__webglTexture = depthData.texture;
      if (depthData.depthNear != renderState.depthNear || depthData.depthFar != renderState.depthFar) {
        this.depthNear = depthData.depthNear;
        this.depthFar = depthData.depthFar;
      }
      this.texture = texture;
    }
  }
  getMesh(cameraXR) {
    if (this.texture !== null) {
      if (this.mesh === null) {
        const viewport = cameraXR.cameras[0].viewport;
        const material = new ShaderMaterial$1({
          vertexShader: _occlusion_vertex,
          fragmentShader: _occlusion_fragment,
          uniforms: {
            depthColor: { value: this.texture },
            depthWidth: { value: viewport.z },
            depthHeight: { value: viewport.w }
          }
        });
        this.mesh = new Mesh$1(new PlaneGeometry$1(20, 20), material);
      }
    }
    return this.mesh;
  }
  reset() {
    this.texture = null;
    this.mesh = null;
  }
  getDepthTexture() {
    return this.texture;
  }
}
let WebXRManager$1 = class WebXRManager extends EventDispatcher$1 {
  constructor(renderer, gl) {
    super();
    const scope = this;
    let session = null;
    let framebufferScaleFactor = 1;
    let referenceSpace = null;
    let referenceSpaceType = "local-floor";
    let foveation = 1;
    let customReferenceSpace = null;
    let pose = null;
    let glBinding = null;
    let glProjLayer = null;
    let glBaseLayer = null;
    let xrFrame = null;
    const depthSensing = new WebXRDepthSensing();
    const attributes = gl.getContextAttributes();
    let initialRenderTarget = null;
    let newRenderTarget = null;
    const controllers = [];
    const controllerInputSources = [];
    const currentSize = new Vector2$1();
    let currentPixelRatio = null;
    const cameraL = new PerspectiveCamera$1();
    cameraL.viewport = new Vector4$1();
    const cameraR = new PerspectiveCamera$1();
    cameraR.viewport = new Vector4$1();
    const cameras = [cameraL, cameraR];
    const cameraXR = new ArrayCamera$1();
    let _currentDepthNear = null;
    let _currentDepthFar = null;
    this.cameraAutoUpdate = true;
    this.enabled = false;
    this.isPresenting = false;
    this.getController = function(index2) {
      let controller = controllers[index2];
      if (controller === void 0) {
        controller = new WebXRController$1();
        controllers[index2] = controller;
      }
      return controller.getTargetRaySpace();
    };
    this.getControllerGrip = function(index2) {
      let controller = controllers[index2];
      if (controller === void 0) {
        controller = new WebXRController$1();
        controllers[index2] = controller;
      }
      return controller.getGripSpace();
    };
    this.getHand = function(index2) {
      let controller = controllers[index2];
      if (controller === void 0) {
        controller = new WebXRController$1();
        controllers[index2] = controller;
      }
      return controller.getHandSpace();
    };
    function onSessionEvent(event) {
      const controllerIndex = controllerInputSources.indexOf(event.inputSource);
      if (controllerIndex === -1) {
        return;
      }
      const controller = controllers[controllerIndex];
      if (controller !== void 0) {
        controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
        controller.dispatchEvent({ type: event.type, data: event.inputSource });
      }
    }
    function onSessionEnd() {
      session.removeEventListener("select", onSessionEvent);
      session.removeEventListener("selectstart", onSessionEvent);
      session.removeEventListener("selectend", onSessionEvent);
      session.removeEventListener("squeeze", onSessionEvent);
      session.removeEventListener("squeezestart", onSessionEvent);
      session.removeEventListener("squeezeend", onSessionEvent);
      session.removeEventListener("end", onSessionEnd);
      session.removeEventListener("inputsourceschange", onInputSourcesChange);
      for (let i2 = 0; i2 < controllers.length; i2++) {
        const inputSource = controllerInputSources[i2];
        if (inputSource === null) continue;
        controllerInputSources[i2] = null;
        controllers[i2].disconnect(inputSource);
      }
      _currentDepthNear = null;
      _currentDepthFar = null;
      depthSensing.reset();
      renderer.setRenderTarget(initialRenderTarget);
      glBaseLayer = null;
      glProjLayer = null;
      glBinding = null;
      session = null;
      newRenderTarget = null;
      animation.stop();
      scope.isPresenting = false;
      renderer.setPixelRatio(currentPixelRatio);
      renderer.setSize(currentSize.width, currentSize.height, false);
      scope.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function(value) {
      framebufferScaleFactor = value;
      if (scope.isPresenting === true) {
        console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
      }
    };
    this.setReferenceSpaceType = function(value) {
      referenceSpaceType = value;
      if (scope.isPresenting === true) {
        console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
      }
    };
    this.getReferenceSpace = function() {
      return customReferenceSpace || referenceSpace;
    };
    this.setReferenceSpace = function(space) {
      customReferenceSpace = space;
    };
    this.getBaseLayer = function() {
      return glProjLayer !== null ? glProjLayer : glBaseLayer;
    };
    this.getBinding = function() {
      return glBinding;
    };
    this.getFrame = function() {
      return xrFrame;
    };
    this.getSession = function() {
      return session;
    };
    this.setSession = async function(value) {
      session = value;
      if (session !== null) {
        initialRenderTarget = renderer.getRenderTarget();
        session.addEventListener("select", onSessionEvent);
        session.addEventListener("selectstart", onSessionEvent);
        session.addEventListener("selectend", onSessionEvent);
        session.addEventListener("squeeze", onSessionEvent);
        session.addEventListener("squeezestart", onSessionEvent);
        session.addEventListener("squeezeend", onSessionEvent);
        session.addEventListener("end", onSessionEnd);
        session.addEventListener("inputsourceschange", onInputSourcesChange);
        if (attributes.xrCompatible !== true) {
          await gl.makeXRCompatible();
        }
        currentPixelRatio = renderer.getPixelRatio();
        renderer.getSize(currentSize);
        if (session.renderState.layers === void 0) {
          const layerInit = {
            antialias: attributes.antialias,
            alpha: true,
            depth: attributes.depth,
            stencil: attributes.stencil,
            framebufferScaleFactor
          };
          glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
          session.updateRenderState({ baseLayer: glBaseLayer });
          renderer.setPixelRatio(1);
          renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
          newRenderTarget = new WebGLRenderTarget$1(
            glBaseLayer.framebufferWidth,
            glBaseLayer.framebufferHeight,
            {
              format: RGBAFormat$1,
              type: UnsignedByteType$1,
              colorSpace: renderer.outputColorSpace,
              stencilBuffer: attributes.stencil
            }
          );
        } else {
          let depthFormat = null;
          let depthType = null;
          let glDepthFormat = null;
          if (attributes.depth) {
            glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
            depthFormat = attributes.stencil ? DepthStencilFormat$1 : DepthFormat$1;
            depthType = attributes.stencil ? UnsignedInt248Type$1 : UnsignedIntType$1;
          }
          const projectionlayerInit = {
            colorFormat: gl.RGBA8,
            depthFormat: glDepthFormat,
            scaleFactor: framebufferScaleFactor
          };
          glBinding = new XRWebGLBinding(session, gl);
          glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
          session.updateRenderState({ layers: [glProjLayer] });
          renderer.setPixelRatio(1);
          renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
          newRenderTarget = new WebGLRenderTarget$1(
            glProjLayer.textureWidth,
            glProjLayer.textureHeight,
            {
              format: RGBAFormat$1,
              type: UnsignedByteType$1,
              depthTexture: new DepthTexture$1(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, void 0, void 0, void 0, void 0, void 0, void 0, depthFormat),
              stencilBuffer: attributes.stencil,
              colorSpace: renderer.outputColorSpace,
              samples: attributes.antialias ? 4 : 0,
              resolveDepthBuffer: glProjLayer.ignoreDepthValues === false
            }
          );
        }
        newRenderTarget.isXRRenderTarget = true;
        this.setFoveation(foveation);
        customReferenceSpace = null;
        referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
        animation.setContext(session);
        animation.start();
        scope.isPresenting = true;
        scope.dispatchEvent({ type: "sessionstart" });
      }
    };
    this.getEnvironmentBlendMode = function() {
      if (session !== null) {
        return session.environmentBlendMode;
      }
    };
    this.getDepthTexture = function() {
      return depthSensing.getDepthTexture();
    };
    function onInputSourcesChange(event) {
      for (let i2 = 0; i2 < event.removed.length; i2++) {
        const inputSource = event.removed[i2];
        const index2 = controllerInputSources.indexOf(inputSource);
        if (index2 >= 0) {
          controllerInputSources[index2] = null;
          controllers[index2].disconnect(inputSource);
        }
      }
      for (let i2 = 0; i2 < event.added.length; i2++) {
        const inputSource = event.added[i2];
        let controllerIndex = controllerInputSources.indexOf(inputSource);
        if (controllerIndex === -1) {
          for (let i3 = 0; i3 < controllers.length; i3++) {
            if (i3 >= controllerInputSources.length) {
              controllerInputSources.push(inputSource);
              controllerIndex = i3;
              break;
            } else if (controllerInputSources[i3] === null) {
              controllerInputSources[i3] = inputSource;
              controllerIndex = i3;
              break;
            }
          }
          if (controllerIndex === -1) break;
        }
        const controller = controllers[controllerIndex];
        if (controller) {
          controller.connect(inputSource);
        }
      }
    }
    const cameraLPos = new Vector3$1();
    const cameraRPos = new Vector3$1();
    function setProjectionFromUnion(camera, cameraL2, cameraR2) {
      cameraLPos.setFromMatrixPosition(cameraL2.matrixWorld);
      cameraRPos.setFromMatrixPosition(cameraR2.matrixWorld);
      const ipd = cameraLPos.distanceTo(cameraRPos);
      const projL = cameraL2.projectionMatrix.elements;
      const projR = cameraR2.projectionMatrix.elements;
      const near = projL[14] / (projL[10] - 1);
      const far = projL[14] / (projL[10] + 1);
      const topFov = (projL[9] + 1) / projL[5];
      const bottomFov = (projL[9] - 1) / projL[5];
      const leftFov = (projL[8] - 1) / projL[0];
      const rightFov = (projR[8] + 1) / projR[0];
      const left = near * leftFov;
      const right = near * rightFov;
      const zOffset = ipd / (-leftFov + rightFov);
      const xOffset = zOffset * -leftFov;
      cameraL2.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
      camera.translateX(xOffset);
      camera.translateZ(zOffset);
      camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
      camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
      if (projL[10] === -1) {
        camera.projectionMatrix.copy(cameraL2.projectionMatrix);
        camera.projectionMatrixInverse.copy(cameraL2.projectionMatrixInverse);
      } else {
        const near2 = near + zOffset;
        const far2 = far + zOffset;
        const left2 = left - xOffset;
        const right2 = right + (ipd - xOffset);
        const top2 = topFov * far / far2 * near2;
        const bottom2 = bottomFov * far / far2 * near2;
        camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
        camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
      }
    }
    function updateCamera(camera, parent2) {
      if (parent2 === null) {
        camera.matrixWorld.copy(camera.matrix);
      } else {
        camera.matrixWorld.multiplyMatrices(parent2.matrixWorld, camera.matrix);
      }
      camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
    }
    this.updateCamera = function(camera) {
      if (session === null) return;
      let depthNear = camera.near;
      let depthFar = camera.far;
      if (depthSensing.texture !== null) {
        if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
        if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
      }
      cameraXR.near = cameraR.near = cameraL.near = depthNear;
      cameraXR.far = cameraR.far = cameraL.far = depthFar;
      if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
        session.updateRenderState({
          depthNear: cameraXR.near,
          depthFar: cameraXR.far
        });
        _currentDepthNear = cameraXR.near;
        _currentDepthFar = cameraXR.far;
      }
      cameraL.layers.mask = camera.layers.mask | 2;
      cameraR.layers.mask = camera.layers.mask | 4;
      cameraXR.layers.mask = cameraL.layers.mask | cameraR.layers.mask;
      const parent2 = camera.parent;
      const cameras2 = cameraXR.cameras;
      updateCamera(cameraXR, parent2);
      for (let i2 = 0; i2 < cameras2.length; i2++) {
        updateCamera(cameras2[i2], parent2);
      }
      if (cameras2.length === 2) {
        setProjectionFromUnion(cameraXR, cameraL, cameraR);
      } else {
        cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
      }
      updateUserCamera(camera, cameraXR, parent2);
    };
    function updateUserCamera(camera, cameraXR2, parent2) {
      if (parent2 === null) {
        camera.matrix.copy(cameraXR2.matrixWorld);
      } else {
        camera.matrix.copy(parent2.matrixWorld);
        camera.matrix.invert();
        camera.matrix.multiply(cameraXR2.matrixWorld);
      }
      camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
      camera.updateMatrixWorld(true);
      camera.projectionMatrix.copy(cameraXR2.projectionMatrix);
      camera.projectionMatrixInverse.copy(cameraXR2.projectionMatrixInverse);
      if (camera.isPerspectiveCamera) {
        camera.fov = RAD2DEG$1 * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
        camera.zoom = 1;
      }
    }
    this.getCamera = function() {
      return cameraXR;
    };
    this.getFoveation = function() {
      if (glProjLayer === null && glBaseLayer === null) {
        return void 0;
      }
      return foveation;
    };
    this.setFoveation = function(value) {
      foveation = value;
      if (glProjLayer !== null) {
        glProjLayer.fixedFoveation = value;
      }
      if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== void 0) {
        glBaseLayer.fixedFoveation = value;
      }
    };
    this.hasDepthSensing = function() {
      return depthSensing.texture !== null;
    };
    this.getDepthSensingMesh = function() {
      return depthSensing.getMesh(cameraXR);
    };
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time2, frame) {
      pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
      xrFrame = frame;
      if (pose !== null) {
        const views = pose.views;
        if (glBaseLayer !== null) {
          renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
          renderer.setRenderTarget(newRenderTarget);
        }
        let cameraXRNeedsUpdate = false;
        if (views.length !== cameraXR.cameras.length) {
          cameraXR.cameras.length = 0;
          cameraXRNeedsUpdate = true;
        }
        for (let i2 = 0; i2 < views.length; i2++) {
          const view = views[i2];
          let viewport = null;
          if (glBaseLayer !== null) {
            viewport = glBaseLayer.getViewport(view);
          } else {
            const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
            viewport = glSubImage.viewport;
            if (i2 === 0) {
              renderer.setRenderTargetTextures(
                newRenderTarget,
                glSubImage.colorTexture,
                glProjLayer.ignoreDepthValues ? void 0 : glSubImage.depthStencilTexture
              );
              renderer.setRenderTarget(newRenderTarget);
            }
          }
          let camera = cameras[i2];
          if (camera === void 0) {
            camera = new PerspectiveCamera$1();
            camera.layers.enable(i2);
            camera.viewport = new Vector4$1();
            cameras[i2] = camera;
          }
          camera.matrix.fromArray(view.transform.matrix);
          camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
          camera.projectionMatrix.fromArray(view.projectionMatrix);
          camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
          camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
          if (i2 === 0) {
            cameraXR.matrix.copy(camera.matrix);
            cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
          }
          if (cameraXRNeedsUpdate === true) {
            cameraXR.cameras.push(camera);
          }
        }
        const enabledFeatures = session.enabledFeatures;
        if (enabledFeatures && enabledFeatures.includes("depth-sensing")) {
          const depthData = glBinding.getDepthInformation(views[0]);
          if (depthData && depthData.isValid && depthData.texture) {
            depthSensing.init(renderer, depthData, session.renderState);
          }
        }
      }
      for (let i2 = 0; i2 < controllers.length; i2++) {
        const inputSource = controllerInputSources[i2];
        const controller = controllers[i2];
        if (inputSource !== null && controller !== void 0) {
          controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
        }
      }
      if (onAnimationFrameCallback) onAnimationFrameCallback(time2, frame);
      if (frame.detectedPlanes) {
        scope.dispatchEvent({ type: "planesdetected", data: frame });
      }
      xrFrame = null;
    }
    const animation = new WebGLAnimation$1();
    animation.setAnimationLoop(onAnimationFrame);
    this.setAnimationLoop = function(callback) {
      onAnimationFrameCallback = callback;
    };
    this.dispose = function() {
    };
  }
};
const _e1 = /* @__PURE__ */ new Euler$1();
const _m1$3 = /* @__PURE__ */ new Matrix4$1();
function WebGLMaterials$1(renderer, properties) {
  function refreshTransformUniform(map, uniform) {
    if (map.matrixAutoUpdate === true) {
      map.updateMatrix();
    }
    uniform.value.copy(map.matrix);
  }
  function refreshFogUniforms(uniforms, fog) {
    fog.color.getRGB(uniforms.fogColor.value, getUnlitUniformColorSpace(renderer));
    if (fog.isFog) {
      uniforms.fogNear.value = fog.near;
      uniforms.fogFar.value = fog.far;
    } else if (fog.isFogExp2) {
      uniforms.fogDensity.value = fog.density;
    }
  }
  function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
    if (material.isMeshBasicMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshLambertMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshToonMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsToon(uniforms, material);
    } else if (material.isMeshPhongMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsPhong(uniforms, material);
    } else if (material.isMeshStandardMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsStandard(uniforms, material);
      if (material.isMeshPhysicalMaterial) {
        refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
      }
    } else if (material.isMeshMatcapMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsMatcap(uniforms, material);
    } else if (material.isMeshDepthMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshDistanceMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsDistance(uniforms, material);
    } else if (material.isMeshNormalMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isLineBasicMaterial) {
      refreshUniformsLine(uniforms, material);
      if (material.isLineDashedMaterial) {
        refreshUniformsDash(uniforms, material);
      }
    } else if (material.isPointsMaterial) {
      refreshUniformsPoints(uniforms, material, pixelRatio, height);
    } else if (material.isSpriteMaterial) {
      refreshUniformsSprites(uniforms, material);
    } else if (material.isShadowMaterial) {
      uniforms.color.value.copy(material.color);
      uniforms.opacity.value = material.opacity;
    } else if (material.isShaderMaterial) {
      material.uniformsNeedUpdate = false;
    }
  }
  function refreshUniformsCommon(uniforms, material) {
    uniforms.opacity.value = material.opacity;
    if (material.color) {
      uniforms.diffuse.value.copy(material.color);
    }
    if (material.emissive) {
      uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
    }
    if (material.map) {
      uniforms.map.value = material.map;
      refreshTransformUniform(material.map, uniforms.mapTransform);
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
      refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
    }
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide$1) {
        uniforms.bumpScale.value *= -1;
      }
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide$1) {
        uniforms.normalScale.value.negate();
      }
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
    if (material.emissiveMap) {
      uniforms.emissiveMap.value = material.emissiveMap;
      refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
    }
    if (material.specularMap) {
      uniforms.specularMap.value = material.specularMap;
      refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
    const materialProperties = properties.get(material);
    const envMap = materialProperties.envMap;
    const envMapRotation = materialProperties.envMapRotation;
    if (envMap) {
      uniforms.envMap.value = envMap;
      _e1.copy(envMapRotation);
      _e1.x *= -1;
      _e1.y *= -1;
      _e1.z *= -1;
      if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
        _e1.y *= -1;
        _e1.z *= -1;
      }
      uniforms.envMapRotation.value.setFromMatrix4(_m1$3.makeRotationFromEuler(_e1));
      uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
      uniforms.reflectivity.value = material.reflectivity;
      uniforms.ior.value = material.ior;
      uniforms.refractionRatio.value = material.refractionRatio;
    }
    if (material.lightMap) {
      uniforms.lightMap.value = material.lightMap;
      uniforms.lightMapIntensity.value = material.lightMapIntensity;
      refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
    }
    if (material.aoMap) {
      uniforms.aoMap.value = material.aoMap;
      uniforms.aoMapIntensity.value = material.aoMapIntensity;
      refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
    }
  }
  function refreshUniformsLine(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    if (material.map) {
      uniforms.map.value = material.map;
      refreshTransformUniform(material.map, uniforms.mapTransform);
    }
  }
  function refreshUniformsDash(uniforms, material) {
    uniforms.dashSize.value = material.dashSize;
    uniforms.totalSize.value = material.dashSize + material.gapSize;
    uniforms.scale.value = material.scale;
  }
  function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.size.value = material.size * pixelRatio;
    uniforms.scale.value = height * 0.5;
    if (material.map) {
      uniforms.map.value = material.map;
      refreshTransformUniform(material.map, uniforms.uvTransform);
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
      refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
  }
  function refreshUniformsSprites(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.rotation.value = material.rotation;
    if (material.map) {
      uniforms.map.value = material.map;
      refreshTransformUniform(material.map, uniforms.mapTransform);
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
      refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
  }
  function refreshUniformsPhong(uniforms, material) {
    uniforms.specular.value.copy(material.specular);
    uniforms.shininess.value = Math.max(material.shininess, 1e-4);
  }
  function refreshUniformsToon(uniforms, material) {
    if (material.gradientMap) {
      uniforms.gradientMap.value = material.gradientMap;
    }
  }
  function refreshUniformsStandard(uniforms, material) {
    uniforms.metalness.value = material.metalness;
    if (material.metalnessMap) {
      uniforms.metalnessMap.value = material.metalnessMap;
      refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
    }
    uniforms.roughness.value = material.roughness;
    if (material.roughnessMap) {
      uniforms.roughnessMap.value = material.roughnessMap;
      refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
    }
    if (material.envMap) {
      uniforms.envMapIntensity.value = material.envMapIntensity;
    }
  }
  function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
    uniforms.ior.value = material.ior;
    if (material.sheen > 0) {
      uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
      uniforms.sheenRoughness.value = material.sheenRoughness;
      if (material.sheenColorMap) {
        uniforms.sheenColorMap.value = material.sheenColorMap;
        refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
      }
      if (material.sheenRoughnessMap) {
        uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
        refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
      }
    }
    if (material.clearcoat > 0) {
      uniforms.clearcoat.value = material.clearcoat;
      uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
      if (material.clearcoatMap) {
        uniforms.clearcoatMap.value = material.clearcoatMap;
        refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
      }
      if (material.clearcoatRoughnessMap) {
        uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
        refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
      }
      if (material.clearcoatNormalMap) {
        uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
        refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
        uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
        if (material.side === BackSide$1) {
          uniforms.clearcoatNormalScale.value.negate();
        }
      }
    }
    if (material.dispersion > 0) {
      uniforms.dispersion.value = material.dispersion;
    }
    if (material.iridescence > 0) {
      uniforms.iridescence.value = material.iridescence;
      uniforms.iridescenceIOR.value = material.iridescenceIOR;
      uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
      uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
      if (material.iridescenceMap) {
        uniforms.iridescenceMap.value = material.iridescenceMap;
        refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
      }
      if (material.iridescenceThicknessMap) {
        uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
        refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
      }
    }
    if (material.transmission > 0) {
      uniforms.transmission.value = material.transmission;
      uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
      uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
      if (material.transmissionMap) {
        uniforms.transmissionMap.value = material.transmissionMap;
        refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
      }
      uniforms.thickness.value = material.thickness;
      if (material.thicknessMap) {
        uniforms.thicknessMap.value = material.thicknessMap;
        refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
      }
      uniforms.attenuationDistance.value = material.attenuationDistance;
      uniforms.attenuationColor.value.copy(material.attenuationColor);
    }
    if (material.anisotropy > 0) {
      uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
      if (material.anisotropyMap) {
        uniforms.anisotropyMap.value = material.anisotropyMap;
        refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
      }
    }
    uniforms.specularIntensity.value = material.specularIntensity;
    uniforms.specularColor.value.copy(material.specularColor);
    if (material.specularColorMap) {
      uniforms.specularColorMap.value = material.specularColorMap;
      refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
    }
    if (material.specularIntensityMap) {
      uniforms.specularIntensityMap.value = material.specularIntensityMap;
      refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
    }
  }
  function refreshUniformsMatcap(uniforms, material) {
    if (material.matcap) {
      uniforms.matcap.value = material.matcap;
    }
  }
  function refreshUniformsDistance(uniforms, material) {
    const light = properties.get(material).light;
    uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
    uniforms.nearDistance.value = light.shadow.camera.near;
    uniforms.farDistance.value = light.shadow.camera.far;
  }
  return {
    refreshFogUniforms,
    refreshMaterialUniforms
  };
}
function WebGLUniformsGroups(gl, info, capabilities, state) {
  let buffers = {};
  let updateList = {};
  let allocatedBindingPoints = [];
  const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS);
  function bind(uniformsGroup, program) {
    const webglProgram = program.program;
    state.uniformBlockBinding(uniformsGroup, webglProgram);
  }
  function update(uniformsGroup, program) {
    let buffer = buffers[uniformsGroup.id];
    if (buffer === void 0) {
      prepareUniformsGroup(uniformsGroup);
      buffer = createBuffer(uniformsGroup);
      buffers[uniformsGroup.id] = buffer;
      uniformsGroup.addEventListener("dispose", onUniformsGroupsDispose);
    }
    const webglProgram = program.program;
    state.updateUBOMapping(uniformsGroup, webglProgram);
    const frame = info.render.frame;
    if (updateList[uniformsGroup.id] !== frame) {
      updateBufferData(uniformsGroup);
      updateList[uniformsGroup.id] = frame;
    }
  }
  function createBuffer(uniformsGroup) {
    const bindingPointIndex = allocateBindingPointIndex();
    uniformsGroup.__bindingPointIndex = bindingPointIndex;
    const buffer = gl.createBuffer();
    const size = uniformsGroup.__size;
    const usage = uniformsGroup.usage;
    gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
    gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
    gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
    return buffer;
  }
  function allocateBindingPointIndex() {
    for (let i2 = 0; i2 < maxBindingPoints; i2++) {
      if (allocatedBindingPoints.indexOf(i2) === -1) {
        allocatedBindingPoints.push(i2);
        return i2;
      }
    }
    console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.");
    return 0;
  }
  function updateBufferData(uniformsGroup) {
    const buffer = buffers[uniformsGroup.id];
    const uniforms = uniformsGroup.uniforms;
    const cache = uniformsGroup.__cache;
    gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
    for (let i2 = 0, il = uniforms.length; i2 < il; i2++) {
      const uniformArray = Array.isArray(uniforms[i2]) ? uniforms[i2] : [uniforms[i2]];
      for (let j = 0, jl = uniformArray.length; j < jl; j++) {
        const uniform = uniformArray[j];
        if (hasUniformChanged(uniform, i2, j, cache) === true) {
          const offset = uniform.__offset;
          const values = Array.isArray(uniform.value) ? uniform.value : [uniform.value];
          let arrayOffset = 0;
          for (let k = 0; k < values.length; k++) {
            const value = values[k];
            const info2 = getUniformSize(value);
            if (typeof value === "number" || typeof value === "boolean") {
              uniform.__data[0] = value;
              gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
            } else if (value.isMatrix3) {
              uniform.__data[0] = value.elements[0];
              uniform.__data[1] = value.elements[1];
              uniform.__data[2] = value.elements[2];
              uniform.__data[3] = 0;
              uniform.__data[4] = value.elements[3];
              uniform.__data[5] = value.elements[4];
              uniform.__data[6] = value.elements[5];
              uniform.__data[7] = 0;
              uniform.__data[8] = value.elements[6];
              uniform.__data[9] = value.elements[7];
              uniform.__data[10] = value.elements[8];
              uniform.__data[11] = 0;
            } else {
              value.toArray(uniform.__data, arrayOffset);
              arrayOffset += info2.storage / Float32Array.BYTES_PER_ELEMENT;
            }
          }
          gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
        }
      }
    }
    gl.bindBuffer(gl.UNIFORM_BUFFER, null);
  }
  function hasUniformChanged(uniform, index2, indexArray, cache) {
    const value = uniform.value;
    const indexString = index2 + "_" + indexArray;
    if (cache[indexString] === void 0) {
      if (typeof value === "number" || typeof value === "boolean") {
        cache[indexString] = value;
      } else {
        cache[indexString] = value.clone();
      }
      return true;
    } else {
      const cachedObject = cache[indexString];
      if (typeof value === "number" || typeof value === "boolean") {
        if (cachedObject !== value) {
          cache[indexString] = value;
          return true;
        }
      } else {
        if (cachedObject.equals(value) === false) {
          cachedObject.copy(value);
          return true;
        }
      }
    }
    return false;
  }
  function prepareUniformsGroup(uniformsGroup) {
    const uniforms = uniformsGroup.uniforms;
    let offset = 0;
    const chunkSize = 16;
    for (let i2 = 0, l2 = uniforms.length; i2 < l2; i2++) {
      const uniformArray = Array.isArray(uniforms[i2]) ? uniforms[i2] : [uniforms[i2]];
      for (let j = 0, jl = uniformArray.length; j < jl; j++) {
        const uniform = uniformArray[j];
        const values = Array.isArray(uniform.value) ? uniform.value : [uniform.value];
        for (let k = 0, kl = values.length; k < kl; k++) {
          const value = values[k];
          const info2 = getUniformSize(value);
          const chunkOffset2 = offset % chunkSize;
          const chunkPadding = chunkOffset2 % info2.boundary;
          const chunkStart = chunkOffset2 + chunkPadding;
          offset += chunkPadding;
          if (chunkStart !== 0 && chunkSize - chunkStart < info2.storage) {
            offset += chunkSize - chunkStart;
          }
          uniform.__data = new Float32Array(info2.storage / Float32Array.BYTES_PER_ELEMENT);
          uniform.__offset = offset;
          offset += info2.storage;
        }
      }
    }
    const chunkOffset = offset % chunkSize;
    if (chunkOffset > 0) offset += chunkSize - chunkOffset;
    uniformsGroup.__size = offset;
    uniformsGroup.__cache = {};
    return this;
  }
  function getUniformSize(value) {
    const info2 = {
      boundary: 0,
      // bytes
      storage: 0
      // bytes
    };
    if (typeof value === "number" || typeof value === "boolean") {
      info2.boundary = 4;
      info2.storage = 4;
    } else if (value.isVector2) {
      info2.boundary = 8;
      info2.storage = 8;
    } else if (value.isVector3 || value.isColor) {
      info2.boundary = 16;
      info2.storage = 12;
    } else if (value.isVector4) {
      info2.boundary = 16;
      info2.storage = 16;
    } else if (value.isMatrix3) {
      info2.boundary = 48;
      info2.storage = 48;
    } else if (value.isMatrix4) {
      info2.boundary = 64;
      info2.storage = 64;
    } else if (value.isTexture) {
      console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.");
    } else {
      console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", value);
    }
    return info2;
  }
  function onUniformsGroupsDispose(event) {
    const uniformsGroup = event.target;
    uniformsGroup.removeEventListener("dispose", onUniformsGroupsDispose);
    const index2 = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
    allocatedBindingPoints.splice(index2, 1);
    gl.deleteBuffer(buffers[uniformsGroup.id]);
    delete buffers[uniformsGroup.id];
    delete updateList[uniformsGroup.id];
  }
  function dispose() {
    for (const id in buffers) {
      gl.deleteBuffer(buffers[id]);
    }
    allocatedBindingPoints = [];
    buffers = {};
    updateList = {};
  }
  return {
    bind,
    update,
    dispose
  };
}
let WebGLRenderer$1 = class WebGLRenderer {
  constructor(parameters = {}) {
    const {
      canvas = createCanvasElement$1(),
      context = null,
      depth = true,
      stencil = false,
      alpha = false,
      antialias = false,
      premultipliedAlpha = true,
      preserveDrawingBuffer = false,
      powerPreference = "default",
      failIfMajorPerformanceCaveat = false,
      reverseDepthBuffer = false
    } = parameters;
    this.isWebGLRenderer = true;
    let _alpha;
    if (context !== null) {
      if (typeof WebGLRenderingContext !== "undefined" && context instanceof WebGLRenderingContext) {
        throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
      }
      _alpha = context.getContextAttributes().alpha;
    } else {
      _alpha = alpha;
    }
    const uintClearColor = new Uint32Array(4);
    const intClearColor = new Int32Array(4);
    let currentRenderList = null;
    let currentRenderState = null;
    const renderListStack = [];
    const renderStateStack = [];
    this.domElement = canvas;
    this.debug = {
      /**
       * Enables error checking and reporting when shader programs are being compiled
       * @type {boolean}
       */
      checkShaderErrors: true,
      /**
       * Callback for custom error reporting.
       * @type {?Function}
       */
      onShaderError: null
    };
    this.autoClear = true;
    this.autoClearColor = true;
    this.autoClearDepth = true;
    this.autoClearStencil = true;
    this.sortObjects = true;
    this.clippingPlanes = [];
    this.localClippingEnabled = false;
    this._outputColorSpace = SRGBColorSpace;
    this.toneMapping = NoToneMapping$1;
    this.toneMappingExposure = 1;
    const _this = this;
    let _isContextLost = false;
    let _currentActiveCubeFace = 0;
    let _currentActiveMipmapLevel = 0;
    let _currentRenderTarget = null;
    let _currentMaterialId = -1;
    let _currentCamera = null;
    const _currentViewport = new Vector4$1();
    const _currentScissor = new Vector4$1();
    let _currentScissorTest = null;
    const _currentClearColor = new Color$1(0);
    let _currentClearAlpha = 0;
    let _width = canvas.width;
    let _height = canvas.height;
    let _pixelRatio = 1;
    let _opaqueSort = null;
    let _transparentSort = null;
    const _viewport2 = new Vector4$1(0, 0, _width, _height);
    const _scissor = new Vector4$1(0, 0, _width, _height);
    let _scissorTest = false;
    const _frustum2 = new Frustum$1();
    let _clippingEnabled = false;
    let _localClippingEnabled = false;
    const _currentProjectionMatrix = new Matrix4$1();
    const _projScreenMatrix2 = new Matrix4$1();
    const _vector32 = new Vector3$1();
    const _vector4 = new Vector4$1();
    const _emptyScene = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: true };
    let _renderBackground = false;
    function getTargetPixelRatio() {
      return _currentRenderTarget === null ? _pixelRatio : 1;
    }
    let _gl = context;
    function getContext(contextName, contextAttributes) {
      return canvas.getContext(contextName, contextAttributes);
    }
    try {
      const contextAttributes = {
        alpha: true,
        depth,
        stencil,
        antialias,
        premultipliedAlpha,
        preserveDrawingBuffer,
        powerPreference,
        failIfMajorPerformanceCaveat
      };
      if ("setAttribute" in canvas) canvas.setAttribute("data-engine", `three.js r${REVISION$1}`);
      canvas.addEventListener("webglcontextlost", onContextLost, false);
      canvas.addEventListener("webglcontextrestored", onContextRestore, false);
      canvas.addEventListener("webglcontextcreationerror", onContextCreationError, false);
      if (_gl === null) {
        const contextName = "webgl2";
        _gl = getContext(contextName, contextAttributes);
        if (_gl === null) {
          if (getContext(contextName)) {
            throw new Error("Error creating WebGL context with your selected attributes.");
          } else {
            throw new Error("Error creating WebGL context.");
          }
        }
      }
    } catch (error) {
      console.error("THREE.WebGLRenderer: " + error.message);
      throw error;
    }
    let extensions, capabilities, state, info;
    let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
    let programCache, materials, renderLists, renderStates, clipping, shadowMap;
    let background, morphtargets, bufferRenderer, indexedBufferRenderer;
    let utils2, bindingStates, uniformsGroups;
    function initGLContext() {
      extensions = new WebGLExtensions$1(_gl);
      extensions.init();
      utils2 = new WebGLUtils$1(_gl, extensions);
      capabilities = new WebGLCapabilities$1(_gl, extensions, parameters, utils2);
      state = new WebGLState$1(_gl, extensions);
      if (capabilities.reverseDepthBuffer && reverseDepthBuffer) {
        state.buffers.depth.setReversed(true);
      }
      info = new WebGLInfo$1(_gl);
      properties = new WebGLProperties$1();
      textures = new WebGLTextures$1(_gl, extensions, state, properties, capabilities, utils2, info);
      cubemaps = new WebGLCubeMaps$1(_this);
      cubeuvmaps = new WebGLCubeUVMaps$1(_this);
      attributes = new WebGLAttributes$1(_gl);
      bindingStates = new WebGLBindingStates$1(_gl, attributes);
      geometries = new WebGLGeometries$1(_gl, attributes, info, bindingStates);
      objects = new WebGLObjects$1(_gl, geometries, attributes, info);
      morphtargets = new WebGLMorphtargets$1(_gl, capabilities, textures);
      clipping = new WebGLClipping$1(properties);
      programCache = new WebGLPrograms$1(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
      materials = new WebGLMaterials$1(_this, properties);
      renderLists = new WebGLRenderLists$1();
      renderStates = new WebGLRenderStates$1(extensions);
      background = new WebGLBackground$1(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
      shadowMap = new WebGLShadowMap$1(_this, objects, capabilities);
      uniformsGroups = new WebGLUniformsGroups(_gl, info, capabilities, state);
      bufferRenderer = new WebGLBufferRenderer$1(_gl, extensions, info);
      indexedBufferRenderer = new WebGLIndexedBufferRenderer$1(_gl, extensions, info);
      info.programs = programCache.programs;
      _this.capabilities = capabilities;
      _this.extensions = extensions;
      _this.properties = properties;
      _this.renderLists = renderLists;
      _this.shadowMap = shadowMap;
      _this.state = state;
      _this.info = info;
    }
    initGLContext();
    const xr = new WebXRManager$1(_this, _gl);
    this.xr = xr;
    this.getContext = function() {
      return _gl;
    };
    this.getContextAttributes = function() {
      return _gl.getContextAttributes();
    };
    this.forceContextLoss = function() {
      const extension = extensions.get("WEBGL_lose_context");
      if (extension) extension.loseContext();
    };
    this.forceContextRestore = function() {
      const extension = extensions.get("WEBGL_lose_context");
      if (extension) extension.restoreContext();
    };
    this.getPixelRatio = function() {
      return _pixelRatio;
    };
    this.setPixelRatio = function(value) {
      if (value === void 0) return;
      _pixelRatio = value;
      this.setSize(_width, _height, false);
    };
    this.getSize = function(target) {
      return target.set(_width, _height);
    };
    this.setSize = function(width, height, updateStyle = true) {
      if (xr.isPresenting) {
        console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
        return;
      }
      _width = width;
      _height = height;
      canvas.width = Math.floor(width * _pixelRatio);
      canvas.height = Math.floor(height * _pixelRatio);
      if (updateStyle === true) {
        canvas.style.width = width + "px";
        canvas.style.height = height + "px";
      }
      this.setViewport(0, 0, width, height);
    };
    this.getDrawingBufferSize = function(target) {
      return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
    };
    this.setDrawingBufferSize = function(width, height, pixelRatio) {
      _width = width;
      _height = height;
      _pixelRatio = pixelRatio;
      canvas.width = Math.floor(width * pixelRatio);
      canvas.height = Math.floor(height * pixelRatio);
      this.setViewport(0, 0, width, height);
    };
    this.getCurrentViewport = function(target) {
      return target.copy(_currentViewport);
    };
    this.getViewport = function(target) {
      return target.copy(_viewport2);
    };
    this.setViewport = function(x, y, width, height) {
      if (x.isVector4) {
        _viewport2.set(x.x, x.y, x.z, x.w);
      } else {
        _viewport2.set(x, y, width, height);
      }
      state.viewport(_currentViewport.copy(_viewport2).multiplyScalar(_pixelRatio).round());
    };
    this.getScissor = function(target) {
      return target.copy(_scissor);
    };
    this.setScissor = function(x, y, width, height) {
      if (x.isVector4) {
        _scissor.set(x.x, x.y, x.z, x.w);
      } else {
        _scissor.set(x, y, width, height);
      }
      state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
    };
    this.getScissorTest = function() {
      return _scissorTest;
    };
    this.setScissorTest = function(boolean) {
      state.setScissorTest(_scissorTest = boolean);
    };
    this.setOpaqueSort = function(method) {
      _opaqueSort = method;
    };
    this.setTransparentSort = function(method) {
      _transparentSort = method;
    };
    this.getClearColor = function(target) {
      return target.copy(background.getClearColor());
    };
    this.setClearColor = function() {
      background.setClearColor.apply(background, arguments);
    };
    this.getClearAlpha = function() {
      return background.getClearAlpha();
    };
    this.setClearAlpha = function() {
      background.setClearAlpha.apply(background, arguments);
    };
    this.clear = function(color2 = true, depth2 = true, stencil2 = true) {
      let bits2 = 0;
      if (color2) {
        let isIntegerFormat = false;
        if (_currentRenderTarget !== null) {
          const targetFormat = _currentRenderTarget.texture.format;
          isIntegerFormat = targetFormat === RGBAIntegerFormat$1 || targetFormat === RGIntegerFormat$1 || targetFormat === RedIntegerFormat$1;
        }
        if (isIntegerFormat) {
          const targetType = _currentRenderTarget.texture.type;
          const isUnsignedType = targetType === UnsignedByteType$1 || targetType === UnsignedIntType$1 || targetType === UnsignedShortType$1 || targetType === UnsignedInt248Type$1 || targetType === UnsignedShort4444Type$1 || targetType === UnsignedShort5551Type$1;
          const clearColor = background.getClearColor();
          const a3 = background.getClearAlpha();
          const r2 = clearColor.r;
          const g3 = clearColor.g;
          const b = clearColor.b;
          if (isUnsignedType) {
            uintClearColor[0] = r2;
            uintClearColor[1] = g3;
            uintClearColor[2] = b;
            uintClearColor[3] = a3;
            _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
          } else {
            intClearColor[0] = r2;
            intClearColor[1] = g3;
            intClearColor[2] = b;
            intClearColor[3] = a3;
            _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
          }
        } else {
          bits2 |= _gl.COLOR_BUFFER_BIT;
        }
      }
      if (depth2) {
        bits2 |= _gl.DEPTH_BUFFER_BIT;
      }
      if (stencil2) {
        bits2 |= _gl.STENCIL_BUFFER_BIT;
        this.state.buffers.stencil.setMask(4294967295);
      }
      _gl.clear(bits2);
    };
    this.clearColor = function() {
      this.clear(true, false, false);
    };
    this.clearDepth = function() {
      this.clear(false, true, false);
    };
    this.clearStencil = function() {
      this.clear(false, false, true);
    };
    this.dispose = function() {
      canvas.removeEventListener("webglcontextlost", onContextLost, false);
      canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
      canvas.removeEventListener("webglcontextcreationerror", onContextCreationError, false);
      background.dispose();
      renderLists.dispose();
      renderStates.dispose();
      properties.dispose();
      cubemaps.dispose();
      cubeuvmaps.dispose();
      objects.dispose();
      bindingStates.dispose();
      uniformsGroups.dispose();
      programCache.dispose();
      xr.dispose();
      xr.removeEventListener("sessionstart", onXRSessionStart);
      xr.removeEventListener("sessionend", onXRSessionEnd);
      animation.stop();
    };
    function onContextLost(event) {
      event.preventDefault();
      console.log("THREE.WebGLRenderer: Context Lost.");
      _isContextLost = true;
    }
    function onContextRestore() {
      console.log("THREE.WebGLRenderer: Context Restored.");
      _isContextLost = false;
      const infoAutoReset = info.autoReset;
      const shadowMapEnabled = shadowMap.enabled;
      const shadowMapAutoUpdate = shadowMap.autoUpdate;
      const shadowMapNeedsUpdate = shadowMap.needsUpdate;
      const shadowMapType = shadowMap.type;
      initGLContext();
      info.autoReset = infoAutoReset;
      shadowMap.enabled = shadowMapEnabled;
      shadowMap.autoUpdate = shadowMapAutoUpdate;
      shadowMap.needsUpdate = shadowMapNeedsUpdate;
      shadowMap.type = shadowMapType;
    }
    function onContextCreationError(event) {
      console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", event.statusMessage);
    }
    function onMaterialDispose(event) {
      const material = event.target;
      material.removeEventListener("dispose", onMaterialDispose);
      deallocateMaterial(material);
    }
    function deallocateMaterial(material) {
      releaseMaterialProgramReferences(material);
      properties.remove(material);
    }
    function releaseMaterialProgramReferences(material) {
      const programs = properties.get(material).programs;
      if (programs !== void 0) {
        programs.forEach(function(program) {
          programCache.releaseProgram(program);
        });
        if (material.isShaderMaterial) {
          programCache.releaseShaderCache(material);
        }
      }
    }
    this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
      if (scene === null) scene = _emptyScene;
      const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
      const program = setProgram(camera, scene, geometry, material, object);
      state.setMaterial(material, frontFaceCW);
      let index2 = geometry.index;
      let rangeFactor = 1;
      if (material.wireframe === true) {
        index2 = geometries.getWireframeAttribute(geometry);
        if (index2 === void 0) return;
        rangeFactor = 2;
      }
      const drawRange = geometry.drawRange;
      const position2 = geometry.attributes.position;
      let drawStart = drawRange.start * rangeFactor;
      let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
      if (group !== null) {
        drawStart = Math.max(drawStart, group.start * rangeFactor);
        drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
      }
      if (index2 !== null) {
        drawStart = Math.max(drawStart, 0);
        drawEnd = Math.min(drawEnd, index2.count);
      } else if (position2 !== void 0 && position2 !== null) {
        drawStart = Math.max(drawStart, 0);
        drawEnd = Math.min(drawEnd, position2.count);
      }
      const drawCount = drawEnd - drawStart;
      if (drawCount < 0 || drawCount === Infinity) return;
      bindingStates.setup(object, material, program, geometry, index2);
      let attribute;
      let renderer = bufferRenderer;
      if (index2 !== null) {
        attribute = attributes.get(index2);
        renderer = indexedBufferRenderer;
        renderer.setIndex(attribute);
      }
      if (object.isMesh) {
        if (material.wireframe === true) {
          state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
          renderer.setMode(_gl.LINES);
        } else {
          renderer.setMode(_gl.TRIANGLES);
        }
      } else if (object.isLine) {
        let lineWidth = material.linewidth;
        if (lineWidth === void 0) lineWidth = 1;
        state.setLineWidth(lineWidth * getTargetPixelRatio());
        if (object.isLineSegments) {
          renderer.setMode(_gl.LINES);
        } else if (object.isLineLoop) {
          renderer.setMode(_gl.LINE_LOOP);
        } else {
          renderer.setMode(_gl.LINE_STRIP);
        }
      } else if (object.isPoints) {
        renderer.setMode(_gl.POINTS);
      } else if (object.isSprite) {
        renderer.setMode(_gl.TRIANGLES);
      }
      if (object.isBatchedMesh) {
        if (object._multiDrawInstances !== null) {
          renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
        } else {
          if (!extensions.get("WEBGL_multi_draw")) {
            const starts = object._multiDrawStarts;
            const counts = object._multiDrawCounts;
            const drawCount2 = object._multiDrawCount;
            const bytesPerElement = index2 ? attributes.get(index2).bytesPerElement : 1;
            const uniforms = properties.get(material).currentProgram.getUniforms();
            for (let i2 = 0; i2 < drawCount2; i2++) {
              uniforms.setValue(_gl, "_gl_DrawID", i2);
              renderer.render(starts[i2] / bytesPerElement, counts[i2]);
            }
          } else {
            renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
          }
        }
      } else if (object.isInstancedMesh) {
        renderer.renderInstances(drawStart, drawCount, object.count);
      } else if (geometry.isInstancedBufferGeometry) {
        const maxInstanceCount = geometry._maxInstanceCount !== void 0 ? geometry._maxInstanceCount : Infinity;
        const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
        renderer.renderInstances(drawStart, drawCount, instanceCount);
      } else {
        renderer.render(drawStart, drawCount);
      }
    };
    function prepareMaterial(material, scene, object) {
      if (material.transparent === true && material.side === DoubleSide$1 && material.forceSinglePass === false) {
        material.side = BackSide$1;
        material.needsUpdate = true;
        getProgram(material, scene, object);
        material.side = FrontSide$1;
        material.needsUpdate = true;
        getProgram(material, scene, object);
        material.side = DoubleSide$1;
      } else {
        getProgram(material, scene, object);
      }
    }
    this.compile = function(scene, camera, targetScene = null) {
      if (targetScene === null) targetScene = scene;
      currentRenderState = renderStates.get(targetScene);
      currentRenderState.init(camera);
      renderStateStack.push(currentRenderState);
      targetScene.traverseVisible(function(object) {
        if (object.isLight && object.layers.test(camera.layers)) {
          currentRenderState.pushLight(object);
          if (object.castShadow) {
            currentRenderState.pushShadow(object);
          }
        }
      });
      if (scene !== targetScene) {
        scene.traverseVisible(function(object) {
          if (object.isLight && object.layers.test(camera.layers)) {
            currentRenderState.pushLight(object);
            if (object.castShadow) {
              currentRenderState.pushShadow(object);
            }
          }
        });
      }
      currentRenderState.setupLights();
      const materials2 = /* @__PURE__ */ new Set();
      scene.traverse(function(object) {
        if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) {
          return;
        }
        const material = object.material;
        if (material) {
          if (Array.isArray(material)) {
            for (let i2 = 0; i2 < material.length; i2++) {
              const material2 = material[i2];
              prepareMaterial(material2, targetScene, object);
              materials2.add(material2);
            }
          } else {
            prepareMaterial(material, targetScene, object);
            materials2.add(material);
          }
        }
      });
      renderStateStack.pop();
      currentRenderState = null;
      return materials2;
    };
    this.compileAsync = function(scene, camera, targetScene = null) {
      const materials2 = this.compile(scene, camera, targetScene);
      return new Promise((resolve) => {
        function checkMaterialsReady() {
          materials2.forEach(function(material) {
            const materialProperties = properties.get(material);
            const program = materialProperties.currentProgram;
            if (program.isReady()) {
              materials2.delete(material);
            }
          });
          if (materials2.size === 0) {
            resolve(scene);
            return;
          }
          setTimeout(checkMaterialsReady, 10);
        }
        if (extensions.get("KHR_parallel_shader_compile") !== null) {
          checkMaterialsReady();
        } else {
          setTimeout(checkMaterialsReady, 10);
        }
      });
    };
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time2) {
      if (onAnimationFrameCallback) onAnimationFrameCallback(time2);
    }
    function onXRSessionStart() {
      animation.stop();
    }
    function onXRSessionEnd() {
      animation.start();
    }
    const animation = new WebGLAnimation$1();
    animation.setAnimationLoop(onAnimationFrame);
    if (typeof self !== "undefined") animation.setContext(self);
    this.setAnimationLoop = function(callback) {
      onAnimationFrameCallback = callback;
      xr.setAnimationLoop(callback);
      callback === null ? animation.stop() : animation.start();
    };
    xr.addEventListener("sessionstart", onXRSessionStart);
    xr.addEventListener("sessionend", onXRSessionEnd);
    this.render = function(scene, camera) {
      if (camera !== void 0 && camera.isCamera !== true) {
        console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
        return;
      }
      if (_isContextLost === true) return;
      if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
      if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
      if (xr.enabled === true && xr.isPresenting === true) {
        if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
        camera = xr.getCamera();
      }
      if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
      currentRenderState = renderStates.get(scene, renderStateStack.length);
      currentRenderState.init(camera);
      renderStateStack.push(currentRenderState);
      _projScreenMatrix2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
      _frustum2.setFromProjectionMatrix(_projScreenMatrix2);
      _localClippingEnabled = this.localClippingEnabled;
      _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
      currentRenderList = renderLists.get(scene, renderListStack.length);
      currentRenderList.init();
      renderListStack.push(currentRenderList);
      if (xr.enabled === true && xr.isPresenting === true) {
        const depthSensingMesh = _this.xr.getDepthSensingMesh();
        if (depthSensingMesh !== null) {
          projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
        }
      }
      projectObject(scene, camera, 0, _this.sortObjects);
      currentRenderList.finish();
      if (_this.sortObjects === true) {
        currentRenderList.sort(_opaqueSort, _transparentSort);
      }
      _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
      if (_renderBackground) {
        background.addToRenderList(currentRenderList, scene);
      }
      this.info.render.frame++;
      if (_clippingEnabled === true) clipping.beginShadows();
      const shadowsArray = currentRenderState.state.shadowsArray;
      shadowMap.render(shadowsArray, scene, camera);
      if (_clippingEnabled === true) clipping.endShadows();
      if (this.info.autoReset === true) this.info.reset();
      const opaqueObjects = currentRenderList.opaque;
      const transmissiveObjects = currentRenderList.transmissive;
      currentRenderState.setupLights();
      if (camera.isArrayCamera) {
        const cameras = camera.cameras;
        if (transmissiveObjects.length > 0) {
          for (let i2 = 0, l2 = cameras.length; i2 < l2; i2++) {
            const camera2 = cameras[i2];
            renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
          }
        }
        if (_renderBackground) background.render(scene);
        for (let i2 = 0, l2 = cameras.length; i2 < l2; i2++) {
          const camera2 = cameras[i2];
          renderScene(currentRenderList, scene, camera2, camera2.viewport);
        }
      } else {
        if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
        if (_renderBackground) background.render(scene);
        renderScene(currentRenderList, scene, camera);
      }
      if (_currentRenderTarget !== null) {
        textures.updateMultisampleRenderTarget(_currentRenderTarget);
        textures.updateRenderTargetMipmap(_currentRenderTarget);
      }
      if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
      bindingStates.resetDefaultState();
      _currentMaterialId = -1;
      _currentCamera = null;
      renderStateStack.pop();
      if (renderStateStack.length > 0) {
        currentRenderState = renderStateStack[renderStateStack.length - 1];
        if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
      } else {
        currentRenderState = null;
      }
      renderListStack.pop();
      if (renderListStack.length > 0) {
        currentRenderList = renderListStack[renderListStack.length - 1];
      } else {
        currentRenderList = null;
      }
    };
    function projectObject(object, camera, groupOrder, sortObjects) {
      if (object.visible === false) return;
      const visible = object.layers.test(camera.layers);
      if (visible) {
        if (object.isGroup) {
          groupOrder = object.renderOrder;
        } else if (object.isLOD) {
          if (object.autoUpdate === true) object.update(camera);
        } else if (object.isLight) {
          currentRenderState.pushLight(object);
          if (object.castShadow) {
            currentRenderState.pushShadow(object);
          }
        } else if (object.isSprite) {
          if (!object.frustumCulled || _frustum2.intersectsSprite(object)) {
            if (sortObjects) {
              _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
            }
            const geometry = objects.update(object);
            const material = object.material;
            if (material.visible) {
              currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
            }
          }
        } else if (object.isMesh || object.isLine || object.isPoints) {
          if (!object.frustumCulled || _frustum2.intersectsObject(object)) {
            const geometry = objects.update(object);
            const material = object.material;
            if (sortObjects) {
              if (object.boundingSphere !== void 0) {
                if (object.boundingSphere === null) object.computeBoundingSphere();
                _vector4.copy(object.boundingSphere.center);
              } else {
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                _vector4.copy(geometry.boundingSphere.center);
              }
              _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
            }
            if (Array.isArray(material)) {
              const groups = geometry.groups;
              for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
                const group = groups[i2];
                const groupMaterial = material[group.materialIndex];
                if (groupMaterial && groupMaterial.visible) {
                  currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                }
              }
            } else if (material.visible) {
              currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
            }
          }
        }
      }
      const children = object.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        projectObject(children[i2], camera, groupOrder, sortObjects);
      }
    }
    function renderScene(currentRenderList2, scene, camera, viewport) {
      const opaqueObjects = currentRenderList2.opaque;
      const transmissiveObjects = currentRenderList2.transmissive;
      const transparentObjects = currentRenderList2.transparent;
      currentRenderState.setupLightsView(camera);
      if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
      if (viewport) state.viewport(_currentViewport.copy(viewport));
      if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
      if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
      if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
      state.buffers.depth.setTest(true);
      state.buffers.depth.setMask(true);
      state.buffers.color.setMask(true);
      state.setPolygonOffset(false);
    }
    function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
      const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
      if (overrideMaterial !== null) {
        return;
      }
      if (currentRenderState.state.transmissionRenderTarget[camera.id] === void 0) {
        currentRenderState.state.transmissionRenderTarget[camera.id] = new WebGLRenderTarget$1(1, 1, {
          generateMipmaps: true,
          type: extensions.has("EXT_color_buffer_half_float") || extensions.has("EXT_color_buffer_float") ? HalfFloatType$1 : UnsignedByteType$1,
          minFilter: LinearMipmapLinearFilter$1,
          samples: 4,
          stencilBuffer: stencil,
          resolveDepthBuffer: false,
          resolveStencilBuffer: false,
          colorSpace: ColorManagement.workingColorSpace
        });
      }
      const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
      const activeViewport = camera.viewport || _currentViewport;
      transmissionRenderTarget.setSize(activeViewport.z, activeViewport.w);
      const currentRenderTarget = _this.getRenderTarget();
      _this.setRenderTarget(transmissionRenderTarget);
      _this.getClearColor(_currentClearColor);
      _currentClearAlpha = _this.getClearAlpha();
      if (_currentClearAlpha < 1) _this.setClearColor(16777215, 0.5);
      _this.clear();
      if (_renderBackground) background.render(scene);
      const currentToneMapping = _this.toneMapping;
      _this.toneMapping = NoToneMapping$1;
      const currentCameraViewport = camera.viewport;
      if (camera.viewport !== void 0) camera.viewport = void 0;
      currentRenderState.setupLightsView(camera);
      if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
      renderObjects(opaqueObjects, scene, camera);
      textures.updateMultisampleRenderTarget(transmissionRenderTarget);
      textures.updateRenderTargetMipmap(transmissionRenderTarget);
      if (extensions.has("WEBGL_multisampled_render_to_texture") === false) {
        let renderTargetNeedsUpdate = false;
        for (let i2 = 0, l2 = transmissiveObjects.length; i2 < l2; i2++) {
          const renderItem = transmissiveObjects[i2];
          const object = renderItem.object;
          const geometry = renderItem.geometry;
          const material = renderItem.material;
          const group = renderItem.group;
          if (material.side === DoubleSide$1 && object.layers.test(camera.layers)) {
            const currentSide = material.side;
            material.side = BackSide$1;
            material.needsUpdate = true;
            renderObject(object, scene, camera, geometry, material, group);
            material.side = currentSide;
            material.needsUpdate = true;
            renderTargetNeedsUpdate = true;
          }
        }
        if (renderTargetNeedsUpdate === true) {
          textures.updateMultisampleRenderTarget(transmissionRenderTarget);
          textures.updateRenderTargetMipmap(transmissionRenderTarget);
        }
      }
      _this.setRenderTarget(currentRenderTarget);
      _this.setClearColor(_currentClearColor, _currentClearAlpha);
      if (currentCameraViewport !== void 0) camera.viewport = currentCameraViewport;
      _this.toneMapping = currentToneMapping;
    }
    function renderObjects(renderList, scene, camera) {
      const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
      for (let i2 = 0, l2 = renderList.length; i2 < l2; i2++) {
        const renderItem = renderList[i2];
        const object = renderItem.object;
        const geometry = renderItem.geometry;
        const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
        const group = renderItem.group;
        if (object.layers.test(camera.layers)) {
          renderObject(object, scene, camera, geometry, material, group);
        }
      }
    }
    function renderObject(object, scene, camera, geometry, material, group) {
      object.onBeforeRender(_this, scene, camera, geometry, material, group);
      object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
      object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
      material.onBeforeRender(_this, scene, camera, geometry, object, group);
      if (material.transparent === true && material.side === DoubleSide$1 && material.forceSinglePass === false) {
        material.side = BackSide$1;
        material.needsUpdate = true;
        _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        material.side = FrontSide$1;
        material.needsUpdate = true;
        _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        material.side = DoubleSide$1;
      } else {
        _this.renderBufferDirect(camera, scene, geometry, material, object, group);
      }
      object.onAfterRender(_this, scene, camera, geometry, material, group);
    }
    function getProgram(material, scene, object) {
      if (scene.isScene !== true) scene = _emptyScene;
      const materialProperties = properties.get(material);
      const lights = currentRenderState.state.lights;
      const shadowsArray = currentRenderState.state.shadowsArray;
      const lightsStateVersion = lights.state.version;
      const parameters2 = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
      const programCacheKey = programCache.getProgramCacheKey(parameters2);
      let programs = materialProperties.programs;
      materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
      materialProperties.fog = scene.fog;
      materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
      materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
      if (programs === void 0) {
        material.addEventListener("dispose", onMaterialDispose);
        programs = /* @__PURE__ */ new Map();
        materialProperties.programs = programs;
      }
      let program = programs.get(programCacheKey);
      if (program !== void 0) {
        if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
          updateCommonMaterialProperties(material, parameters2);
          return program;
        }
      } else {
        parameters2.uniforms = programCache.getUniforms(material);
        material.onBeforeCompile(parameters2, _this);
        program = programCache.acquireProgram(parameters2, programCacheKey);
        programs.set(programCacheKey, program);
        materialProperties.uniforms = parameters2.uniforms;
      }
      const uniforms = materialProperties.uniforms;
      if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) {
        uniforms.clippingPlanes = clipping.uniform;
      }
      updateCommonMaterialProperties(material, parameters2);
      materialProperties.needsLights = materialNeedsLights(material);
      materialProperties.lightsStateVersion = lightsStateVersion;
      if (materialProperties.needsLights) {
        uniforms.ambientLightColor.value = lights.state.ambient;
        uniforms.lightProbe.value = lights.state.probe;
        uniforms.directionalLights.value = lights.state.directional;
        uniforms.directionalLightShadows.value = lights.state.directionalShadow;
        uniforms.spotLights.value = lights.state.spot;
        uniforms.spotLightShadows.value = lights.state.spotShadow;
        uniforms.rectAreaLights.value = lights.state.rectArea;
        uniforms.ltc_1.value = lights.state.rectAreaLTC1;
        uniforms.ltc_2.value = lights.state.rectAreaLTC2;
        uniforms.pointLights.value = lights.state.point;
        uniforms.pointLightShadows.value = lights.state.pointShadow;
        uniforms.hemisphereLights.value = lights.state.hemi;
        uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
        uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
        uniforms.spotShadowMap.value = lights.state.spotShadowMap;
        uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
        uniforms.spotLightMap.value = lights.state.spotLightMap;
        uniforms.pointShadowMap.value = lights.state.pointShadowMap;
        uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
      }
      materialProperties.currentProgram = program;
      materialProperties.uniformsList = null;
      return program;
    }
    function getUniformList(materialProperties) {
      if (materialProperties.uniformsList === null) {
        const progUniforms = materialProperties.currentProgram.getUniforms();
        materialProperties.uniformsList = WebGLUniforms$1.seqWithValue(progUniforms.seq, materialProperties.uniforms);
      }
      return materialProperties.uniformsList;
    }
    function updateCommonMaterialProperties(material, parameters2) {
      const materialProperties = properties.get(material);
      materialProperties.outputColorSpace = parameters2.outputColorSpace;
      materialProperties.batching = parameters2.batching;
      materialProperties.batchingColor = parameters2.batchingColor;
      materialProperties.instancing = parameters2.instancing;
      materialProperties.instancingColor = parameters2.instancingColor;
      materialProperties.instancingMorph = parameters2.instancingMorph;
      materialProperties.skinning = parameters2.skinning;
      materialProperties.morphTargets = parameters2.morphTargets;
      materialProperties.morphNormals = parameters2.morphNormals;
      materialProperties.morphColors = parameters2.morphColors;
      materialProperties.morphTargetsCount = parameters2.morphTargetsCount;
      materialProperties.numClippingPlanes = parameters2.numClippingPlanes;
      materialProperties.numIntersection = parameters2.numClipIntersection;
      materialProperties.vertexAlphas = parameters2.vertexAlphas;
      materialProperties.vertexTangents = parameters2.vertexTangents;
      materialProperties.toneMapping = parameters2.toneMapping;
    }
    function setProgram(camera, scene, geometry, material, object) {
      if (scene.isScene !== true) scene = _emptyScene;
      textures.resetTextureUnits();
      const fog = scene.fog;
      const environment = material.isMeshStandardMaterial ? scene.environment : null;
      const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace;
      const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
      const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
      const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
      const morphTargets = !!geometry.morphAttributes.position;
      const morphNormals = !!geometry.morphAttributes.normal;
      const morphColors = !!geometry.morphAttributes.color;
      let toneMapping = NoToneMapping$1;
      if (material.toneMapped) {
        if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) {
          toneMapping = _this.toneMapping;
        }
      }
      const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
      const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
      const materialProperties = properties.get(material);
      const lights = currentRenderState.state.lights;
      if (_clippingEnabled === true) {
        if (_localClippingEnabled === true || camera !== _currentCamera) {
          const useCache = camera === _currentCamera && material.id === _currentMaterialId;
          clipping.setState(material, camera, useCache);
        }
      }
      let needsProgramChange = false;
      if (material.version === materialProperties.__version) {
        if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) {
          needsProgramChange = true;
        } else if (materialProperties.outputColorSpace !== colorSpace) {
          needsProgramChange = true;
        } else if (object.isBatchedMesh && materialProperties.batching === false) {
          needsProgramChange = true;
        } else if (!object.isBatchedMesh && materialProperties.batching === true) {
          needsProgramChange = true;
        } else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) {
          needsProgramChange = true;
        } else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) {
          needsProgramChange = true;
        } else if (object.isInstancedMesh && materialProperties.instancing === false) {
          needsProgramChange = true;
        } else if (!object.isInstancedMesh && materialProperties.instancing === true) {
          needsProgramChange = true;
        } else if (object.isSkinnedMesh && materialProperties.skinning === false) {
          needsProgramChange = true;
        } else if (!object.isSkinnedMesh && materialProperties.skinning === true) {
          needsProgramChange = true;
        } else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) {
          needsProgramChange = true;
        } else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) {
          needsProgramChange = true;
        } else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) {
          needsProgramChange = true;
        } else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) {
          needsProgramChange = true;
        } else if (materialProperties.envMap !== envMap) {
          needsProgramChange = true;
        } else if (material.fog === true && materialProperties.fog !== fog) {
          needsProgramChange = true;
        } else if (materialProperties.numClippingPlanes !== void 0 && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) {
          needsProgramChange = true;
        } else if (materialProperties.vertexAlphas !== vertexAlphas) {
          needsProgramChange = true;
        } else if (materialProperties.vertexTangents !== vertexTangents) {
          needsProgramChange = true;
        } else if (materialProperties.morphTargets !== morphTargets) {
          needsProgramChange = true;
        } else if (materialProperties.morphNormals !== morphNormals) {
          needsProgramChange = true;
        } else if (materialProperties.morphColors !== morphColors) {
          needsProgramChange = true;
        } else if (materialProperties.toneMapping !== toneMapping) {
          needsProgramChange = true;
        } else if (materialProperties.morphTargetsCount !== morphTargetsCount) {
          needsProgramChange = true;
        }
      } else {
        needsProgramChange = true;
        materialProperties.__version = material.version;
      }
      let program = materialProperties.currentProgram;
      if (needsProgramChange === true) {
        program = getProgram(material, scene, object);
      }
      let refreshProgram = false;
      let refreshMaterial = false;
      let refreshLights = false;
      const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
      if (state.useProgram(program.program)) {
        refreshProgram = true;
        refreshMaterial = true;
        refreshLights = true;
      }
      if (material.id !== _currentMaterialId) {
        _currentMaterialId = material.id;
        refreshMaterial = true;
      }
      if (refreshProgram || _currentCamera !== camera) {
        const reverseDepthBuffer2 = state.buffers.depth.getReversed();
        if (reverseDepthBuffer2) {
          _currentProjectionMatrix.copy(camera.projectionMatrix);
          toNormalizedProjectionMatrix(_currentProjectionMatrix);
          toReversedProjectionMatrix(_currentProjectionMatrix);
          p_uniforms.setValue(_gl, "projectionMatrix", _currentProjectionMatrix);
        } else {
          p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
        }
        p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
        const uCamPos = p_uniforms.map.cameraPosition;
        if (uCamPos !== void 0) {
          uCamPos.setValue(_gl, _vector32.setFromMatrixPosition(camera.matrixWorld));
        }
        if (capabilities.logarithmicDepthBuffer) {
          p_uniforms.setValue(
            _gl,
            "logDepthBufFC",
            2 / (Math.log(camera.far + 1) / Math.LN2)
          );
        }
        if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) {
          p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
        }
        if (_currentCamera !== camera) {
          _currentCamera = camera;
          refreshMaterial = true;
          refreshLights = true;
        }
      }
      if (object.isSkinnedMesh) {
        p_uniforms.setOptional(_gl, object, "bindMatrix");
        p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
        const skeleton = object.skeleton;
        if (skeleton) {
          if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
          p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
        }
      }
      if (object.isBatchedMesh) {
        p_uniforms.setOptional(_gl, object, "batchingTexture");
        p_uniforms.setValue(_gl, "batchingTexture", object._matricesTexture, textures);
        p_uniforms.setOptional(_gl, object, "batchingIdTexture");
        p_uniforms.setValue(_gl, "batchingIdTexture", object._indirectTexture, textures);
        p_uniforms.setOptional(_gl, object, "batchingColorTexture");
        if (object._colorsTexture !== null) {
          p_uniforms.setValue(_gl, "batchingColorTexture", object._colorsTexture, textures);
        }
      }
      const morphAttributes = geometry.morphAttributes;
      if (morphAttributes.position !== void 0 || morphAttributes.normal !== void 0 || morphAttributes.color !== void 0) {
        morphtargets.update(object, geometry, program);
      }
      if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
        materialProperties.receiveShadow = object.receiveShadow;
        p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
      }
      if (material.isMeshGouraudMaterial && material.envMap !== null) {
        m_uniforms.envMap.value = envMap;
        m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
      }
      if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) {
        m_uniforms.envMapIntensity.value = scene.environmentIntensity;
      }
      if (refreshMaterial) {
        p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
        if (materialProperties.needsLights) {
          markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
        }
        if (fog && material.fog === true) {
          materials.refreshFogUniforms(m_uniforms, fog);
        }
        materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
        WebGLUniforms$1.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
      }
      if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
        WebGLUniforms$1.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
        material.uniformsNeedUpdate = false;
      }
      if (material.isSpriteMaterial) {
        p_uniforms.setValue(_gl, "center", object.center);
      }
      p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
      p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
      p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
      if (material.isShaderMaterial || material.isRawShaderMaterial) {
        const groups = material.uniformsGroups;
        for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
          const group = groups[i2];
          uniformsGroups.update(group, program);
          uniformsGroups.bind(group, program);
        }
      }
      return program;
    }
    function markUniformsLightsNeedsUpdate(uniforms, value) {
      uniforms.ambientLightColor.needsUpdate = value;
      uniforms.lightProbe.needsUpdate = value;
      uniforms.directionalLights.needsUpdate = value;
      uniforms.directionalLightShadows.needsUpdate = value;
      uniforms.pointLights.needsUpdate = value;
      uniforms.pointLightShadows.needsUpdate = value;
      uniforms.spotLights.needsUpdate = value;
      uniforms.spotLightShadows.needsUpdate = value;
      uniforms.rectAreaLights.needsUpdate = value;
      uniforms.hemisphereLights.needsUpdate = value;
    }
    function materialNeedsLights(material) {
      return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
    }
    this.getActiveCubeFace = function() {
      return _currentActiveCubeFace;
    };
    this.getActiveMipmapLevel = function() {
      return _currentActiveMipmapLevel;
    };
    this.getRenderTarget = function() {
      return _currentRenderTarget;
    };
    this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
      properties.get(renderTarget.texture).__webglTexture = colorTexture;
      properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
      const renderTargetProperties = properties.get(renderTarget);
      renderTargetProperties.__hasExternalTextures = true;
      renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === void 0;
      if (!renderTargetProperties.__autoAllocateDepthBuffer) {
        if (extensions.has("WEBGL_multisampled_render_to_texture") === true) {
          console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided");
          renderTargetProperties.__useRenderToTexture = false;
        }
      }
    };
    this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
      const renderTargetProperties = properties.get(renderTarget);
      renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
      renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === void 0;
    };
    this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
      _currentRenderTarget = renderTarget;
      _currentActiveCubeFace = activeCubeFace;
      _currentActiveMipmapLevel = activeMipmapLevel;
      let useDefaultFramebuffer = true;
      let framebuffer = null;
      let isCube = false;
      let isRenderTarget3D = false;
      if (renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTargetProperties.__useDefaultFramebuffer !== void 0) {
          state.bindFramebuffer(_gl.FRAMEBUFFER, null);
          useDefaultFramebuffer = false;
        } else if (renderTargetProperties.__webglFramebuffer === void 0) {
          textures.setupRenderTarget(renderTarget);
        } else if (renderTargetProperties.__hasExternalTextures) {
          textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
        } else if (renderTarget.depthBuffer) {
          const depthTexture = renderTarget.depthTexture;
          if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
            if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) {
              throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
            }
            textures.setupDepthRenderbuffer(renderTarget);
          }
        }
        const texture = renderTarget.texture;
        if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) {
          isRenderTarget3D = true;
        }
        const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget) {
          if (Array.isArray(__webglFramebuffer[activeCubeFace])) {
            framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
          } else {
            framebuffer = __webglFramebuffer[activeCubeFace];
          }
          isCube = true;
        } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) {
          framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
        } else {
          if (Array.isArray(__webglFramebuffer)) {
            framebuffer = __webglFramebuffer[activeMipmapLevel];
          } else {
            framebuffer = __webglFramebuffer;
          }
        }
        _currentViewport.copy(renderTarget.viewport);
        _currentScissor.copy(renderTarget.scissor);
        _currentScissorTest = renderTarget.scissorTest;
      } else {
        _currentViewport.copy(_viewport2).multiplyScalar(_pixelRatio).floor();
        _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
        _currentScissorTest = _scissorTest;
      }
      const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
      if (framebufferBound && useDefaultFramebuffer) {
        state.drawBuffers(renderTarget, framebuffer);
      }
      state.viewport(_currentViewport);
      state.scissor(_currentScissor);
      state.setScissorTest(_currentScissorTest);
      if (isCube) {
        const textureProperties = properties.get(renderTarget.texture);
        _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
      } else if (isRenderTarget3D) {
        const textureProperties = properties.get(renderTarget.texture);
        const layer = activeCubeFace || 0;
        _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
      }
      _currentMaterialId = -1;
    };
    this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
      if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
        return;
      }
      let framebuffer = properties.get(renderTarget).__webglFramebuffer;
      if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== void 0) {
        framebuffer = framebuffer[activeCubeFaceIndex];
      }
      if (framebuffer) {
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        try {
          const texture = renderTarget.texture;
          const textureFormat = texture.format;
          const textureType = texture.type;
          if (!capabilities.textureFormatReadable(textureFormat)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
            return;
          }
          if (!capabilities.textureTypeReadable(textureType)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
            return;
          }
          if (x >= 0 && x <= renderTarget.width - width && (y >= 0 && y <= renderTarget.height - height)) {
            _gl.readPixels(x, y, width, height, utils2.convert(textureFormat), utils2.convert(textureType), buffer);
          }
        } finally {
          const framebuffer2 = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
          state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer2);
        }
      }
    };
    this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
      if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
        throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
      }
      let framebuffer = properties.get(renderTarget).__webglFramebuffer;
      if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== void 0) {
        framebuffer = framebuffer[activeCubeFaceIndex];
      }
      if (framebuffer) {
        const texture = renderTarget.texture;
        const textureFormat = texture.format;
        const textureType = texture.type;
        if (!capabilities.textureFormatReadable(textureFormat)) {
          throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
        }
        if (!capabilities.textureTypeReadable(textureType)) {
          throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
        }
        if (x >= 0 && x <= renderTarget.width - width && (y >= 0 && y <= renderTarget.height - height)) {
          state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
          const glBuffer = _gl.createBuffer();
          _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
          _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
          _gl.readPixels(x, y, width, height, utils2.convert(textureFormat), utils2.convert(textureType), 0);
          const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
          state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
          const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
          _gl.flush();
          await probeAsync(_gl, sync, 4);
          _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
          _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
          _gl.deleteBuffer(glBuffer);
          _gl.deleteSync(sync);
          return buffer;
        } else {
          throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
        }
      }
    };
    this.copyFramebufferToTexture = function(texture, position2 = null, level = 0) {
      if (texture.isTexture !== true) {
        warnOnce("WebGLRenderer: copyFramebufferToTexture function signature has changed.");
        position2 = arguments[0] || null;
        texture = arguments[1];
      }
      const levelScale = Math.pow(2, -level);
      const width = Math.floor(texture.image.width * levelScale);
      const height = Math.floor(texture.image.height * levelScale);
      const x = position2 !== null ? position2.x : 0;
      const y = position2 !== null ? position2.y : 0;
      textures.setTexture2D(texture, 0);
      _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
      state.unbindTexture();
    };
    const _srcFramebuffer = _gl.createFramebuffer();
    const _dstFramebuffer = _gl.createFramebuffer();
    this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = null) {
      if (srcTexture.isTexture !== true) {
        warnOnce("WebGLRenderer: copyTextureToTexture function signature has changed.");
        dstPosition = arguments[0] || null;
        srcTexture = arguments[1];
        dstTexture = arguments[2];
        dstLevel = arguments[3] || 0;
        srcRegion = null;
      }
      if (dstLevel === null) {
        if (srcLevel !== 0) {
          warnOnce("WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels.");
          dstLevel = srcLevel;
          srcLevel = 0;
        } else {
          dstLevel = 0;
        }
      }
      let width, height, depth2, minX, minY, minZ;
      let dstX, dstY, dstZ;
      const image2 = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
      if (srcRegion !== null) {
        width = srcRegion.max.x - srcRegion.min.x;
        height = srcRegion.max.y - srcRegion.min.y;
        depth2 = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
        minX = srcRegion.min.x;
        minY = srcRegion.min.y;
        minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
      } else {
        const levelScale = Math.pow(2, -srcLevel);
        width = Math.floor(image2.width * levelScale);
        height = Math.floor(image2.height * levelScale);
        if (srcTexture.isDataArrayTexture) {
          depth2 = image2.depth;
        } else if (srcTexture.isData3DTexture) {
          depth2 = Math.floor(image2.depth * levelScale);
        } else {
          depth2 = 1;
        }
        minX = 0;
        minY = 0;
        minZ = 0;
      }
      if (dstPosition !== null) {
        dstX = dstPosition.x;
        dstY = dstPosition.y;
        dstZ = dstPosition.z;
      } else {
        dstX = 0;
        dstY = 0;
        dstZ = 0;
      }
      const glFormat = utils2.convert(dstTexture.format);
      const glType = utils2.convert(dstTexture.type);
      let glTarget;
      if (dstTexture.isData3DTexture) {
        textures.setTexture3D(dstTexture, 0);
        glTarget = _gl.TEXTURE_3D;
      } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
        textures.setTexture2DArray(dstTexture, 0);
        glTarget = _gl.TEXTURE_2D_ARRAY;
      } else {
        textures.setTexture2D(dstTexture, 0);
        glTarget = _gl.TEXTURE_2D;
      }
      _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
      _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
      _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
      const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
      const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
      const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
      const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
      const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
      _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image2.width);
      _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image2.height);
      _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
      _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
      _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
      const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
      const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
      if (srcTexture.isDepthTexture) {
        const srcTextureProperties = properties.get(srcTexture);
        const dstTextureProperties = properties.get(dstTexture);
        const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
        const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
        for (let i2 = 0; i2 < depth2; i2++) {
          if (isSrc3D) {
            _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i2);
            _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i2);
          }
          _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
        }
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
      } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
        const srcTextureProperties = properties.get(srcTexture);
        const dstTextureProperties = properties.get(dstTexture);
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
        for (let i2 = 0; i2 < depth2; i2++) {
          if (isSrc3D) {
            _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties.__webglTexture, srcLevel, minZ + i2);
          } else {
            _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties.__webglTexture, srcLevel);
          }
          if (isDst3D) {
            _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties.__webglTexture, dstLevel, dstZ + i2);
          } else {
            _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties.__webglTexture, dstLevel);
          }
          if (srcLevel !== 0) {
            _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
          } else if (isDst3D) {
            _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i2, minX, minY, width, height);
          } else {
            _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
          }
        }
        state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
        state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
      } else {
        if (isDst3D) {
          if (srcTexture.isDataTexture || srcTexture.isData3DTexture) {
            _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth2, glFormat, glType, image2.data);
          } else if (dstTexture.isCompressedArrayTexture) {
            _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth2, glFormat, image2.data);
          } else {
            _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth2, glFormat, glType, image2);
          }
        } else {
          if (srcTexture.isDataTexture) {
            _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image2.data);
          } else if (srcTexture.isCompressedTexture) {
            _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image2.width, image2.height, glFormat, image2.data);
          } else {
            _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image2);
          }
        }
      }
      _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
      _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
      _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
      _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
      _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
      if (dstLevel === 0 && dstTexture.generateMipmaps) {
        _gl.generateMipmap(glTarget);
      }
      state.unbindTexture();
    };
    this.copyTextureToTexture3D = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
      if (srcTexture.isTexture !== true) {
        warnOnce("WebGLRenderer: copyTextureToTexture3D function signature has changed.");
        srcRegion = arguments[0] || null;
        dstPosition = arguments[1] || null;
        srcTexture = arguments[2];
        dstTexture = arguments[3];
        level = arguments[4] || 0;
      }
      warnOnce('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.');
      return this.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, level);
    };
    this.initRenderTarget = function(target) {
      if (properties.get(target).__webglFramebuffer === void 0) {
        textures.setupRenderTarget(target);
      }
    };
    this.initTexture = function(texture) {
      if (texture.isCubeTexture) {
        textures.setTextureCube(texture, 0);
      } else if (texture.isData3DTexture) {
        textures.setTexture3D(texture, 0);
      } else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) {
        textures.setTexture2DArray(texture, 0);
      } else {
        textures.setTexture2D(texture, 0);
      }
      state.unbindTexture();
    };
    this.resetState = function() {
      _currentActiveCubeFace = 0;
      _currentActiveMipmapLevel = 0;
      _currentRenderTarget = null;
      state.reset();
      bindingStates.reset();
    };
    if (typeof __THREE_DEVTOOLS__ !== "undefined") {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
    }
  }
  get coordinateSystem() {
    return WebGLCoordinateSystem;
  }
  get outputColorSpace() {
    return this._outputColorSpace;
  }
  set outputColorSpace(colorSpace) {
    this._outputColorSpace = colorSpace;
    const gl = this.getContext();
    gl.drawingBufferColorspace = ColorManagement._getDrawingBufferColorSpace(colorSpace);
    gl.unpackColorSpace = ColorManagement._getUnpackColorSpace();
  }
};
const THREE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACESFilmicToneMapping: ACESFilmicToneMapping$1,
  AddEquation: AddEquation$1,
  AddOperation: AddOperation$1,
  AdditiveAnimationBlendMode: AdditiveAnimationBlendMode$1,
  AdditiveBlending: AdditiveBlending$1,
  AgXToneMapping,
  AlphaFormat: AlphaFormat$1,
  AlwaysCompare,
  AlwaysDepth: AlwaysDepth$1,
  AlwaysStencilFunc: AlwaysStencilFunc$1,
  AmbientLight: AmbientLight$1,
  AnimationAction: AnimationAction$1,
  AnimationClip: AnimationClip$1,
  AnimationLoader,
  AnimationMixer: AnimationMixer$1,
  AnimationObjectGroup,
  AnimationUtils: AnimationUtils$1,
  ArcCurve: ArcCurve$1,
  ArrayCamera: ArrayCamera$1,
  ArrowHelper,
  AttachedBindMode,
  Audio: Audio$1,
  AudioAnalyser,
  AudioContext: AudioContext$1,
  AudioListener,
  AudioLoader: AudioLoader$1,
  AxesHelper,
  BackSide: BackSide$1,
  BasicDepthPacking: BasicDepthPacking$1,
  BasicShadowMap,
  BatchedMesh,
  Bone: Bone$1,
  BooleanKeyframeTrack: BooleanKeyframeTrack$1,
  Box2,
  Box3: Box3$1,
  Box3Helper,
  BoxGeometry: BoxGeometry$1,
  BoxHelper,
  BufferAttribute: BufferAttribute$1,
  BufferGeometry: BufferGeometry$1,
  BufferGeometryLoader,
  ByteType: ByteType$1,
  Cache: Cache$2,
  Camera: Camera$1,
  CameraHelper,
  CanvasTexture: CanvasTexture$1,
  CapsuleGeometry,
  CatmullRomCurve3: CatmullRomCurve3$1,
  CineonToneMapping: CineonToneMapping$1,
  CircleGeometry,
  ClampToEdgeWrapping: ClampToEdgeWrapping$1,
  Clock,
  Color: Color$1,
  ColorKeyframeTrack: ColorKeyframeTrack$1,
  ColorManagement,
  CompressedArrayTexture,
  CompressedCubeTexture,
  CompressedTexture: CompressedTexture$1,
  CompressedTextureLoader,
  ConeGeometry,
  ConstantAlphaFactor,
  ConstantColorFactor,
  Controls,
  CubeCamera: CubeCamera$1,
  CubeReflectionMapping: CubeReflectionMapping$1,
  CubeRefractionMapping: CubeRefractionMapping$1,
  CubeTexture: CubeTexture$1,
  CubeTextureLoader: CubeTextureLoader$1,
  CubeUVReflectionMapping: CubeUVReflectionMapping$1,
  CubicBezierCurve: CubicBezierCurve$1,
  CubicBezierCurve3: CubicBezierCurve3$1,
  CubicInterpolant: CubicInterpolant$1,
  CullFaceBack: CullFaceBack$1,
  CullFaceFront: CullFaceFront$1,
  CullFaceFrontBack,
  CullFaceNone: CullFaceNone$1,
  Curve: Curve$1,
  CurvePath: CurvePath$1,
  CustomBlending: CustomBlending$1,
  CustomToneMapping: CustomToneMapping$1,
  CylinderGeometry,
  Cylindrical,
  Data3DTexture,
  DataArrayTexture,
  DataTexture: DataTexture$1,
  DataTextureLoader,
  DataUtils,
  DecrementStencilOp,
  DecrementWrapStencilOp,
  DefaultLoadingManager: DefaultLoadingManager$1,
  DepthFormat: DepthFormat$1,
  DepthStencilFormat: DepthStencilFormat$1,
  DepthTexture: DepthTexture$1,
  DetachedBindMode,
  DirectionalLight: DirectionalLight$1,
  DirectionalLightHelper,
  DiscreteInterpolant: DiscreteInterpolant$1,
  DodecahedronGeometry,
  DoubleSide: DoubleSide$1,
  DstAlphaFactor: DstAlphaFactor$1,
  DstColorFactor: DstColorFactor$1,
  DynamicCopyUsage,
  DynamicDrawUsage: DynamicDrawUsage$1,
  DynamicReadUsage,
  EdgesGeometry,
  EllipseCurve: EllipseCurve$1,
  EqualCompare,
  EqualDepth: EqualDepth$1,
  EqualStencilFunc,
  EquirectangularReflectionMapping: EquirectangularReflectionMapping$1,
  EquirectangularRefractionMapping: EquirectangularRefractionMapping$1,
  Euler: Euler$1,
  EventDispatcher: EventDispatcher$1,
  ExtrudeGeometry: ExtrudeGeometry$1,
  FileLoader: FileLoader$1,
  Float16BufferAttribute: Float16BufferAttribute$1,
  Float32BufferAttribute: Float32BufferAttribute$1,
  FloatType: FloatType$1,
  Fog,
  FogExp2,
  FramebufferTexture,
  FrontSide: FrontSide$1,
  Frustum: Frustum$1,
  GLBufferAttribute,
  GLSL1,
  GLSL3: GLSL3$1,
  GreaterCompare,
  GreaterDepth: GreaterDepth$1,
  GreaterEqualCompare,
  GreaterEqualDepth: GreaterEqualDepth$1,
  GreaterEqualStencilFunc,
  GreaterStencilFunc,
  GridHelper: GridHelper$1,
  Group: Group$1,
  HalfFloatType: HalfFloatType$1,
  HemisphereLight: HemisphereLight$1,
  HemisphereLightHelper,
  IcosahedronGeometry,
  ImageBitmapLoader: ImageBitmapLoader$1,
  ImageLoader: ImageLoader$1,
  ImageUtils: ImageUtils$1,
  IncrementStencilOp,
  IncrementWrapStencilOp,
  InstancedBufferAttribute: InstancedBufferAttribute$1,
  InstancedBufferGeometry: InstancedBufferGeometry$1,
  InstancedInterleavedBuffer: InstancedInterleavedBuffer$1,
  InstancedMesh: InstancedMesh$1,
  Int16BufferAttribute,
  Int32BufferAttribute,
  Int8BufferAttribute,
  IntType: IntType$1,
  InterleavedBuffer: InterleavedBuffer$1,
  InterleavedBufferAttribute: InterleavedBufferAttribute$1,
  Interpolant: Interpolant$1,
  InterpolateDiscrete: InterpolateDiscrete$1,
  InterpolateLinear: InterpolateLinear$1,
  InterpolateSmooth: InterpolateSmooth$1,
  InvertStencilOp,
  KeepStencilOp: KeepStencilOp$1,
  KeyframeTrack: KeyframeTrack$1,
  LOD,
  LatheGeometry,
  Layers: Layers$1,
  LessCompare,
  LessDepth: LessDepth$1,
  LessEqualCompare,
  LessEqualDepth: LessEqualDepth$1,
  LessEqualStencilFunc,
  LessStencilFunc,
  Light: Light$1,
  LightProbe: LightProbe$1,
  Line: Line$1,
  Line3,
  LineBasicMaterial: LineBasicMaterial$1,
  LineCurve: LineCurve$1,
  LineCurve3: LineCurve3$1,
  LineDashedMaterial: LineDashedMaterial$1,
  LineLoop: LineLoop$1,
  LineSegments: LineSegments$1,
  LinearFilter: LinearFilter$1,
  LinearInterpolant: LinearInterpolant$1,
  LinearMipMapLinearFilter,
  LinearMipMapNearestFilter,
  LinearMipmapLinearFilter: LinearMipmapLinearFilter$1,
  LinearMipmapNearestFilter: LinearMipmapNearestFilter$1,
  LinearSRGBColorSpace,
  LinearToneMapping: LinearToneMapping$1,
  LinearTransfer,
  Loader: Loader$1,
  LoaderUtils: LoaderUtils$1,
  LoadingManager: LoadingManager$1,
  LoopOnce: LoopOnce$1,
  LoopPingPong: LoopPingPong$1,
  LoopRepeat: LoopRepeat$1,
  LuminanceAlphaFormat: LuminanceAlphaFormat$1,
  LuminanceFormat: LuminanceFormat$1,
  MOUSE,
  Material: Material$1,
  MaterialLoader,
  MathUtils,
  Matrix2,
  Matrix3: Matrix3$1,
  Matrix4: Matrix4$1,
  MaxEquation: MaxEquation$1,
  Mesh: Mesh$1,
  MeshBasicMaterial: MeshBasicMaterial$1,
  MeshDepthMaterial: MeshDepthMaterial$1,
  MeshDistanceMaterial: MeshDistanceMaterial$1,
  MeshLambertMaterial: MeshLambertMaterial$1,
  MeshMatcapMaterial: MeshMatcapMaterial$1,
  MeshNormalMaterial: MeshNormalMaterial$1,
  MeshPhongMaterial: MeshPhongMaterial$1,
  MeshPhysicalMaterial: MeshPhysicalMaterial$1,
  MeshStandardMaterial: MeshStandardMaterial$1,
  MeshToonMaterial: MeshToonMaterial$1,
  MinEquation: MinEquation$1,
  MirroredRepeatWrapping: MirroredRepeatWrapping$1,
  MixOperation: MixOperation$1,
  MultiplyBlending: MultiplyBlending$1,
  MultiplyOperation: MultiplyOperation$1,
  NearestFilter: NearestFilter$1,
  NearestMipMapLinearFilter,
  NearestMipMapNearestFilter,
  NearestMipmapLinearFilter: NearestMipmapLinearFilter$1,
  NearestMipmapNearestFilter: NearestMipmapNearestFilter$1,
  NeutralToneMapping,
  NeverCompare,
  NeverDepth: NeverDepth$1,
  NeverStencilFunc,
  NoBlending: NoBlending$1,
  NoColorSpace,
  NoToneMapping: NoToneMapping$1,
  NormalAnimationBlendMode: NormalAnimationBlendMode$1,
  NormalBlending: NormalBlending$1,
  NotEqualCompare,
  NotEqualDepth: NotEqualDepth$1,
  NotEqualStencilFunc,
  NumberKeyframeTrack: NumberKeyframeTrack$1,
  Object3D: Object3D$1,
  ObjectLoader,
  ObjectSpaceNormalMap: ObjectSpaceNormalMap$1,
  OctahedronGeometry,
  OneFactor: OneFactor$1,
  OneMinusConstantAlphaFactor,
  OneMinusConstantColorFactor,
  OneMinusDstAlphaFactor: OneMinusDstAlphaFactor$1,
  OneMinusDstColorFactor: OneMinusDstColorFactor$1,
  OneMinusSrcAlphaFactor: OneMinusSrcAlphaFactor$1,
  OneMinusSrcColorFactor: OneMinusSrcColorFactor$1,
  OrthographicCamera: OrthographicCamera$1,
  PCFShadowMap: PCFShadowMap$1,
  PCFSoftShadowMap: PCFSoftShadowMap$1,
  PMREMGenerator: PMREMGenerator$1,
  Path: Path$1,
  PerspectiveCamera: PerspectiveCamera$1,
  Plane: Plane$1,
  PlaneGeometry: PlaneGeometry$1,
  PlaneHelper,
  PointLight: PointLight$1,
  PointLightHelper,
  Points: Points$1,
  PointsMaterial: PointsMaterial$1,
  PolarGridHelper,
  PolyhedronGeometry,
  PositionalAudio,
  PropertyBinding: PropertyBinding$1,
  PropertyMixer: PropertyMixer$1,
  QuadraticBezierCurve: QuadraticBezierCurve$1,
  QuadraticBezierCurve3: QuadraticBezierCurve3$1,
  Quaternion: Quaternion$1,
  QuaternionKeyframeTrack: QuaternionKeyframeTrack$1,
  QuaternionLinearInterpolant: QuaternionLinearInterpolant$1,
  RED_GREEN_RGTC2_Format,
  RED_RGTC1_Format,
  REVISION: REVISION$1,
  RGBADepthPacking: RGBADepthPacking$1,
  RGBAFormat: RGBAFormat$1,
  RGBAIntegerFormat: RGBAIntegerFormat$1,
  RGBA_ASTC_10x10_Format: RGBA_ASTC_10x10_Format$1,
  RGBA_ASTC_10x5_Format: RGBA_ASTC_10x5_Format$1,
  RGBA_ASTC_10x6_Format: RGBA_ASTC_10x6_Format$1,
  RGBA_ASTC_10x8_Format: RGBA_ASTC_10x8_Format$1,
  RGBA_ASTC_12x10_Format: RGBA_ASTC_12x10_Format$1,
  RGBA_ASTC_12x12_Format: RGBA_ASTC_12x12_Format$1,
  RGBA_ASTC_4x4_Format: RGBA_ASTC_4x4_Format$1,
  RGBA_ASTC_5x4_Format: RGBA_ASTC_5x4_Format$1,
  RGBA_ASTC_5x5_Format: RGBA_ASTC_5x5_Format$1,
  RGBA_ASTC_6x5_Format: RGBA_ASTC_6x5_Format$1,
  RGBA_ASTC_6x6_Format: RGBA_ASTC_6x6_Format$1,
  RGBA_ASTC_8x5_Format: RGBA_ASTC_8x5_Format$1,
  RGBA_ASTC_8x6_Format: RGBA_ASTC_8x6_Format$1,
  RGBA_ASTC_8x8_Format: RGBA_ASTC_8x8_Format$1,
  RGBA_BPTC_Format: RGBA_BPTC_Format$1,
  RGBA_ETC2_EAC_Format: RGBA_ETC2_EAC_Format$1,
  RGBA_PVRTC_2BPPV1_Format: RGBA_PVRTC_2BPPV1_Format$1,
  RGBA_PVRTC_4BPPV1_Format: RGBA_PVRTC_4BPPV1_Format$1,
  RGBA_S3TC_DXT1_Format: RGBA_S3TC_DXT1_Format$1,
  RGBA_S3TC_DXT3_Format: RGBA_S3TC_DXT3_Format$1,
  RGBA_S3TC_DXT5_Format: RGBA_S3TC_DXT5_Format$1,
  RGBDepthPacking,
  RGBFormat: RGBFormat$1,
  RGBIntegerFormat: RGBIntegerFormat$1,
  RGB_BPTC_SIGNED_Format,
  RGB_BPTC_UNSIGNED_Format,
  RGB_ETC1_Format: RGB_ETC1_Format$1,
  RGB_ETC2_Format: RGB_ETC2_Format$1,
  RGB_PVRTC_2BPPV1_Format: RGB_PVRTC_2BPPV1_Format$1,
  RGB_PVRTC_4BPPV1_Format: RGB_PVRTC_4BPPV1_Format$1,
  RGB_S3TC_DXT1_Format: RGB_S3TC_DXT1_Format$1,
  RGDepthPacking,
  RGFormat: RGFormat$1,
  RGIntegerFormat: RGIntegerFormat$1,
  RawShaderMaterial: RawShaderMaterial$1,
  Ray: Ray$1,
  Raycaster,
  RectAreaLight: RectAreaLight$1,
  RedFormat: RedFormat$1,
  RedIntegerFormat: RedIntegerFormat$1,
  ReinhardToneMapping: ReinhardToneMapping$1,
  RenderTarget,
  RepeatWrapping: RepeatWrapping$1,
  ReplaceStencilOp,
  ReverseSubtractEquation: ReverseSubtractEquation$1,
  RingGeometry,
  SIGNED_RED_GREEN_RGTC2_Format,
  SIGNED_RED_RGTC1_Format,
  SRGBColorSpace,
  SRGBTransfer,
  Scene: Scene$1,
  ShaderChunk: ShaderChunk$1,
  ShaderLib: ShaderLib$1,
  ShaderMaterial: ShaderMaterial$1,
  ShadowMaterial: ShadowMaterial$1,
  Shape: Shape$1,
  ShapeGeometry: ShapeGeometry$1,
  ShapePath,
  ShapeUtils: ShapeUtils$1,
  ShortType: ShortType$1,
  Skeleton,
  SkeletonHelper: SkeletonHelper$1,
  SkinnedMesh: SkinnedMesh$1,
  Source,
  Sphere: Sphere$1,
  SphereGeometry,
  Spherical,
  SphericalHarmonics3: SphericalHarmonics3$1,
  SplineCurve: SplineCurve$1,
  SpotLight: SpotLight$1,
  SpotLightHelper,
  Sprite: Sprite$1,
  SpriteMaterial: SpriteMaterial$1,
  SrcAlphaFactor: SrcAlphaFactor$1,
  SrcAlphaSaturateFactor: SrcAlphaSaturateFactor$1,
  SrcColorFactor: SrcColorFactor$1,
  StaticCopyUsage,
  StaticDrawUsage: StaticDrawUsage$1,
  StaticReadUsage,
  StereoCamera,
  StreamCopyUsage,
  StreamDrawUsage,
  StreamReadUsage,
  StringKeyframeTrack: StringKeyframeTrack$1,
  SubtractEquation: SubtractEquation$1,
  SubtractiveBlending: SubtractiveBlending$1,
  TOUCH,
  TangentSpaceNormalMap: TangentSpaceNormalMap$1,
  TetrahedronGeometry,
  Texture: Texture$1,
  TextureLoader: TextureLoader$1,
  TextureUtils,
  TorusGeometry,
  TorusKnotGeometry,
  Triangle: Triangle$1,
  TriangleFanDrawMode,
  TriangleStripDrawMode,
  TrianglesDrawMode: TrianglesDrawMode$1,
  TubeGeometry,
  UVMapping: UVMapping$1,
  Uint16BufferAttribute: Uint16BufferAttribute$1,
  Uint32BufferAttribute: Uint32BufferAttribute$1,
  Uint8BufferAttribute,
  Uint8ClampedBufferAttribute,
  Uniform,
  UniformsGroup,
  UniformsLib: UniformsLib$1,
  UniformsUtils: UniformsUtils$1,
  UnsignedByteType: UnsignedByteType$1,
  UnsignedInt248Type: UnsignedInt248Type$1,
  UnsignedInt5999Type,
  UnsignedIntType: UnsignedIntType$1,
  UnsignedShort4444Type: UnsignedShort4444Type$1,
  UnsignedShort5551Type: UnsignedShort5551Type$1,
  UnsignedShortType: UnsignedShortType$1,
  VSMShadowMap: VSMShadowMap$1,
  Vector2: Vector2$1,
  Vector3: Vector3$1,
  Vector4: Vector4$1,
  VectorKeyframeTrack: VectorKeyframeTrack$1,
  VideoTexture: VideoTexture$1,
  WebGL3DRenderTarget,
  WebGLArrayRenderTarget,
  WebGLCoordinateSystem,
  WebGLCubeRenderTarget: WebGLCubeRenderTarget$1,
  WebGLMultipleRenderTargets: WebGLMultipleRenderTargets$1,
  WebGLRenderTarget: WebGLRenderTarget$1,
  WebGLRenderer: WebGLRenderer$1,
  WebGLUtils: WebGLUtils$1,
  WebGPUCoordinateSystem,
  WireframeGeometry,
  WrapAroundEnding: WrapAroundEnding$1,
  ZeroCurvatureEnding: ZeroCurvatureEnding$1,
  ZeroFactor: ZeroFactor$1,
  ZeroSlopeEnding: ZeroSlopeEnding$1,
  ZeroStencilOp,
  createCanvasElement: createCanvasElement$1
}, Symbol.toStringTag, { value: "Module" }));
/**
 * lil-gui
 * https://lil-gui.georgealways.com
 * @version 0.17.0
 * @author George Michael Brower
 * @license MIT
 */
let t$1 = class t {
  constructor(i2, e2, s2, n2, l2 = "div") {
    this.parent = i2, this.object = e2, this.property = s2, this._disabled = false, this._hidden = false, this.initialValue = this.getValue(), this.domElement = document.createElement("div"), this.domElement.classList.add("controller"), this.domElement.classList.add(n2), this.$name = document.createElement("div"), this.$name.classList.add("name"), t.nextNameID = t.nextNameID || 0, this.$name.id = "lil-gui-name-" + ++t.nextNameID, this.$widget = document.createElement(l2), this.$widget.classList.add("widget"), this.$disable = this.$widget, this.domElement.appendChild(this.$name), this.domElement.appendChild(this.$widget), this.parent.children.push(this), this.parent.controllers.push(this), this.parent.$children.appendChild(this.domElement), this._listenCallback = this._listenCallback.bind(this), this.name(s2);
  }
  name(t3) {
    return this._name = t3, this.$name.innerHTML = t3, this;
  }
  onChange(t3) {
    return this._onChange = t3, this;
  }
  _callOnChange() {
    this.parent._callOnChange(this), void 0 !== this._onChange && this._onChange.call(this, this.getValue()), this._changed = true;
  }
  onFinishChange(t3) {
    return this._onFinishChange = t3, this;
  }
  _callOnFinishChange() {
    this._changed && (this.parent._callOnFinishChange(this), void 0 !== this._onFinishChange && this._onFinishChange.call(this, this.getValue())), this._changed = false;
  }
  reset() {
    return this.setValue(this.initialValue), this._callOnFinishChange(), this;
  }
  enable(t3 = true) {
    return this.disable(!t3);
  }
  disable(t3 = true) {
    return t3 === this._disabled || (this._disabled = t3, this.domElement.classList.toggle("disabled", t3), this.$disable.toggleAttribute("disabled", t3)), this;
  }
  show(t3 = true) {
    return this._hidden = !t3, this.domElement.style.display = this._hidden ? "none" : "", this;
  }
  hide() {
    return this.show(false);
  }
  options(t3) {
    const i2 = this.parent.add(this.object, this.property, t3);
    return i2.name(this._name), this.destroy(), i2;
  }
  min(t3) {
    return this;
  }
  max(t3) {
    return this;
  }
  step(t3) {
    return this;
  }
  decimals(t3) {
    return this;
  }
  listen(t3 = true) {
    return this._listening = t3, void 0 !== this._listenCallbackID && (cancelAnimationFrame(this._listenCallbackID), this._listenCallbackID = void 0), this._listening && this._listenCallback(), this;
  }
  _listenCallback() {
    this._listenCallbackID = requestAnimationFrame(this._listenCallback);
    const t3 = this.save();
    t3 !== this._listenPrevValue && this.updateDisplay(), this._listenPrevValue = t3;
  }
  getValue() {
    return this.object[this.property];
  }
  setValue(t3) {
    return this.object[this.property] = t3, this._callOnChange(), this.updateDisplay(), this;
  }
  updateDisplay() {
    return this;
  }
  load(t3) {
    return this.setValue(t3), this._callOnFinishChange(), this;
  }
  save() {
    return this.getValue();
  }
  destroy() {
    this.listen(false), this.parent.children.splice(this.parent.children.indexOf(this), 1), this.parent.controllers.splice(this.parent.controllers.indexOf(this), 1), this.parent.$children.removeChild(this.domElement);
  }
};
let i$5 = class i extends t$1 {
  constructor(t3, i2, e2) {
    super(t3, i2, e2, "boolean", "label"), this.$input = document.createElement("input"), this.$input.setAttribute("type", "checkbox"), this.$input.setAttribute("aria-labelledby", this.$name.id), this.$widget.appendChild(this.$input), this.$input.addEventListener("change", () => {
      this.setValue(this.$input.checked), this._callOnFinishChange();
    }), this.$disable = this.$input, this.updateDisplay();
  }
  updateDisplay() {
    return this.$input.checked = this.getValue(), this;
  }
};
function e$2(t3) {
  let i2, e2;
  return (i2 = t3.match(/(#|0x)?([a-f0-9]{6})/i)) ? e2 = i2[2] : (i2 = t3.match(/rgb\(\s*(\d*)\s*,\s*(\d*)\s*,\s*(\d*)\s*\)/)) ? e2 = parseInt(i2[1]).toString(16).padStart(2, 0) + parseInt(i2[2]).toString(16).padStart(2, 0) + parseInt(i2[3]).toString(16).padStart(2, 0) : (i2 = t3.match(/^#?([a-f0-9])([a-f0-9])([a-f0-9])$/i)) && (e2 = i2[1] + i2[1] + i2[2] + i2[2] + i2[3] + i2[3]), !!e2 && "#" + e2;
}
const s = { isPrimitive: true, match: (t3) => "string" == typeof t3, fromHexString: e$2, toHexString: e$2 }, n$1 = { isPrimitive: true, match: (t3) => "number" == typeof t3, fromHexString: (t3) => parseInt(t3.substring(1), 16), toHexString: (t3) => "#" + t3.toString(16).padStart(6, 0) }, l = { isPrimitive: false, match: Array.isArray, fromHexString(t3, i2, e2 = 1) {
  const s2 = n$1.fromHexString(t3);
  i2[0] = (s2 >> 16 & 255) / 255 * e2, i2[1] = (s2 >> 8 & 255) / 255 * e2, i2[2] = (255 & s2) / 255 * e2;
}, toHexString: ([t3, i2, e2], s2 = 1) => n$1.toHexString(t3 * (s2 = 255 / s2) << 16 ^ i2 * s2 << 8 ^ e2 * s2 << 0) }, r = { isPrimitive: false, match: (t3) => Object(t3) === t3, fromHexString(t3, i2, e2 = 1) {
  const s2 = n$1.fromHexString(t3);
  i2.r = (s2 >> 16 & 255) / 255 * e2, i2.g = (s2 >> 8 & 255) / 255 * e2, i2.b = (255 & s2) / 255 * e2;
}, toHexString: ({ r: t3, g: i2, b: e2 }, s2 = 1) => n$1.toHexString(t3 * (s2 = 255 / s2) << 16 ^ i2 * s2 << 8 ^ e2 * s2 << 0) }, o = [s, n$1, l, r];
let a$1 = class a extends t$1 {
  constructor(t3, i2, s2, n2) {
    var l2;
    super(t3, i2, s2, "color"), this.$input = document.createElement("input"), this.$input.setAttribute("type", "color"), this.$input.setAttribute("tabindex", -1), this.$input.setAttribute("aria-labelledby", this.$name.id), this.$text = document.createElement("input"), this.$text.setAttribute("type", "text"), this.$text.setAttribute("spellcheck", "false"), this.$text.setAttribute("aria-labelledby", this.$name.id), this.$display = document.createElement("div"), this.$display.classList.add("display"), this.$display.appendChild(this.$input), this.$widget.appendChild(this.$display), this.$widget.appendChild(this.$text), this._format = (l2 = this.initialValue, o.find((t4) => t4.match(l2))), this._rgbScale = n2, this._initialValueHexString = this.save(), this._textFocused = false, this.$input.addEventListener("input", () => {
      this._setValueFromHexString(this.$input.value);
    }), this.$input.addEventListener("blur", () => {
      this._callOnFinishChange();
    }), this.$text.addEventListener("input", () => {
      const t4 = e$2(this.$text.value);
      t4 && this._setValueFromHexString(t4);
    }), this.$text.addEventListener("focus", () => {
      this._textFocused = true, this.$text.select();
    }), this.$text.addEventListener("blur", () => {
      this._textFocused = false, this.updateDisplay(), this._callOnFinishChange();
    }), this.$disable = this.$text, this.updateDisplay();
  }
  reset() {
    return this._setValueFromHexString(this._initialValueHexString), this;
  }
  _setValueFromHexString(t3) {
    if (this._format.isPrimitive) {
      const i2 = this._format.fromHexString(t3);
      this.setValue(i2);
    } else this._format.fromHexString(t3, this.getValue(), this._rgbScale), this._callOnChange(), this.updateDisplay();
  }
  save() {
    return this._format.toHexString(this.getValue(), this._rgbScale);
  }
  load(t3) {
    return this._setValueFromHexString(t3), this._callOnFinishChange(), this;
  }
  updateDisplay() {
    return this.$input.value = this._format.toHexString(this.getValue(), this._rgbScale), this._textFocused || (this.$text.value = this.$input.value.substring(1)), this.$display.style.backgroundColor = this.$input.value, this;
  }
};
class h extends t$1 {
  constructor(t3, i2, e2) {
    super(t3, i2, e2, "function"), this.$button = document.createElement("button"), this.$button.appendChild(this.$name), this.$widget.appendChild(this.$button), this.$button.addEventListener("click", (t4) => {
      t4.preventDefault(), this.getValue().call(this.object);
    }), this.$button.addEventListener("touchstart", () => {
    }, { passive: true }), this.$disable = this.$button;
  }
}
class d extends t$1 {
  constructor(t3, i2, e2, s2, n2, l2) {
    super(t3, i2, e2, "number"), this._initInput(), this.min(s2), this.max(n2);
    const r2 = void 0 !== l2;
    this.step(r2 ? l2 : this._getImplicitStep(), r2), this.updateDisplay();
  }
  decimals(t3) {
    return this._decimals = t3, this.updateDisplay(), this;
  }
  min(t3) {
    return this._min = t3, this._onUpdateMinMax(), this;
  }
  max(t3) {
    return this._max = t3, this._onUpdateMinMax(), this;
  }
  step(t3, i2 = true) {
    return this._step = t3, this._stepExplicit = i2, this;
  }
  updateDisplay() {
    const t3 = this.getValue();
    if (this._hasSlider) {
      let i2 = (t3 - this._min) / (this._max - this._min);
      i2 = Math.max(0, Math.min(i2, 1)), this.$fill.style.width = 100 * i2 + "%";
    }
    return this._inputFocused || (this.$input.value = void 0 === this._decimals ? t3 : t3.toFixed(this._decimals)), this;
  }
  _initInput() {
    this.$input = document.createElement("input"), this.$input.setAttribute("type", "number"), this.$input.setAttribute("step", "any"), this.$input.setAttribute("aria-labelledby", this.$name.id), this.$widget.appendChild(this.$input), this.$disable = this.$input;
    const t3 = (t4) => {
      const i3 = parseFloat(this.$input.value);
      isNaN(i3) || (this._snapClampSetValue(i3 + t4), this.$input.value = this.getValue());
    };
    let i2, e2, s2, n2, l2, r2 = false;
    const o2 = (t4) => {
      if (r2) {
        const s3 = t4.clientX - i2, n3 = t4.clientY - e2;
        Math.abs(n3) > 5 ? (t4.preventDefault(), this.$input.blur(), r2 = false, this._setDraggingStyle(true, "vertical")) : Math.abs(s3) > 5 && a3();
      }
      if (!r2) {
        const i3 = t4.clientY - s2;
        l2 -= i3 * this._step * this._arrowKeyMultiplier(t4), n2 + l2 > this._max ? l2 = this._max - n2 : n2 + l2 < this._min && (l2 = this._min - n2), this._snapClampSetValue(n2 + l2);
      }
      s2 = t4.clientY;
    }, a3 = () => {
      this._setDraggingStyle(false, "vertical"), this._callOnFinishChange(), window.removeEventListener("mousemove", o2), window.removeEventListener("mouseup", a3);
    };
    this.$input.addEventListener("input", () => {
      let t4 = parseFloat(this.$input.value);
      isNaN(t4) || (this._stepExplicit && (t4 = this._snap(t4)), this.setValue(this._clamp(t4)));
    }), this.$input.addEventListener("keydown", (i3) => {
      "Enter" === i3.code && this.$input.blur(), "ArrowUp" === i3.code && (i3.preventDefault(), t3(this._step * this._arrowKeyMultiplier(i3))), "ArrowDown" === i3.code && (i3.preventDefault(), t3(this._step * this._arrowKeyMultiplier(i3) * -1));
    }), this.$input.addEventListener("wheel", (i3) => {
      this._inputFocused && (i3.preventDefault(), t3(this._step * this._normalizeMouseWheel(i3)));
    }, { passive: false }), this.$input.addEventListener("mousedown", (t4) => {
      i2 = t4.clientX, e2 = s2 = t4.clientY, r2 = true, n2 = this.getValue(), l2 = 0, window.addEventListener("mousemove", o2), window.addEventListener("mouseup", a3);
    }), this.$input.addEventListener("focus", () => {
      this._inputFocused = true;
    }), this.$input.addEventListener("blur", () => {
      this._inputFocused = false, this.updateDisplay(), this._callOnFinishChange();
    });
  }
  _initSlider() {
    this._hasSlider = true, this.$slider = document.createElement("div"), this.$slider.classList.add("slider"), this.$fill = document.createElement("div"), this.$fill.classList.add("fill"), this.$slider.appendChild(this.$fill), this.$widget.insertBefore(this.$slider, this.$input), this.domElement.classList.add("hasSlider");
    const t3 = (t4) => {
      const i3 = this.$slider.getBoundingClientRect();
      let e3 = (s3 = t4, n3 = i3.left, l3 = i3.right, r3 = this._min, o3 = this._max, (s3 - n3) / (l3 - n3) * (o3 - r3) + r3);
      var s3, n3, l3, r3, o3;
      this._snapClampSetValue(e3);
    }, i2 = (i3) => {
      t3(i3.clientX);
    }, e2 = () => {
      this._callOnFinishChange(), this._setDraggingStyle(false), window.removeEventListener("mousemove", i2), window.removeEventListener("mouseup", e2);
    };
    let s2, n2, l2 = false;
    const r2 = (i3) => {
      i3.preventDefault(), this._setDraggingStyle(true), t3(i3.touches[0].clientX), l2 = false;
    }, o2 = (i3) => {
      if (l2) {
        const t4 = i3.touches[0].clientX - s2, e3 = i3.touches[0].clientY - n2;
        Math.abs(t4) > Math.abs(e3) ? r2(i3) : (window.removeEventListener("touchmove", o2), window.removeEventListener("touchend", a3));
      } else i3.preventDefault(), t3(i3.touches[0].clientX);
    }, a3 = () => {
      this._callOnFinishChange(), this._setDraggingStyle(false), window.removeEventListener("touchmove", o2), window.removeEventListener("touchend", a3);
    }, h2 = this._callOnFinishChange.bind(this);
    let d2;
    this.$slider.addEventListener("mousedown", (s3) => {
      this._setDraggingStyle(true), t3(s3.clientX), window.addEventListener("mousemove", i2), window.addEventListener("mouseup", e2);
    }), this.$slider.addEventListener("touchstart", (t4) => {
      t4.touches.length > 1 || (this._hasScrollBar ? (s2 = t4.touches[0].clientX, n2 = t4.touches[0].clientY, l2 = true) : r2(t4), window.addEventListener("touchmove", o2, { passive: false }), window.addEventListener("touchend", a3));
    }, { passive: false }), this.$slider.addEventListener("wheel", (t4) => {
      if (Math.abs(t4.deltaX) < Math.abs(t4.deltaY) && this._hasScrollBar) return;
      t4.preventDefault();
      const i3 = this._normalizeMouseWheel(t4) * this._step;
      this._snapClampSetValue(this.getValue() + i3), this.$input.value = this.getValue(), clearTimeout(d2), d2 = setTimeout(h2, 400);
    }, { passive: false });
  }
  _setDraggingStyle(t3, i2 = "horizontal") {
    this.$slider && this.$slider.classList.toggle("active", t3), document.body.classList.toggle("lil-gui-dragging", t3), document.body.classList.toggle("lil-gui-" + i2, t3);
  }
  _getImplicitStep() {
    return this._hasMin && this._hasMax ? (this._max - this._min) / 1e3 : 0.1;
  }
  _onUpdateMinMax() {
    !this._hasSlider && this._hasMin && this._hasMax && (this._stepExplicit || this.step(this._getImplicitStep(), false), this._initSlider(), this.updateDisplay());
  }
  _normalizeMouseWheel(t3) {
    let { deltaX: i2, deltaY: e2 } = t3;
    Math.floor(t3.deltaY) !== t3.deltaY && t3.wheelDelta && (i2 = 0, e2 = -t3.wheelDelta / 120, e2 *= this._stepExplicit ? 1 : 10);
    return i2 + -e2;
  }
  _arrowKeyMultiplier(t3) {
    let i2 = this._stepExplicit ? 1 : 10;
    return t3.shiftKey ? i2 *= 10 : t3.altKey && (i2 /= 10), i2;
  }
  _snap(t3) {
    const i2 = Math.round(t3 / this._step) * this._step;
    return parseFloat(i2.toPrecision(15));
  }
  _clamp(t3) {
    return t3 < this._min && (t3 = this._min), t3 > this._max && (t3 = this._max), t3;
  }
  _snapClampSetValue(t3) {
    this.setValue(this._clamp(this._snap(t3)));
  }
  get _hasScrollBar() {
    const t3 = this.parent.root.$children;
    return t3.scrollHeight > t3.clientHeight;
  }
  get _hasMin() {
    return void 0 !== this._min;
  }
  get _hasMax() {
    return void 0 !== this._max;
  }
}
class c extends t$1 {
  constructor(t3, i2, e2, s2) {
    super(t3, i2, e2, "option"), this.$select = document.createElement("select"), this.$select.setAttribute("aria-labelledby", this.$name.id), this.$display = document.createElement("div"), this.$display.classList.add("display"), this._values = Array.isArray(s2) ? s2 : Object.values(s2), this._names = Array.isArray(s2) ? s2 : Object.keys(s2), this._names.forEach((t4) => {
      const i3 = document.createElement("option");
      i3.innerHTML = t4, this.$select.appendChild(i3);
    }), this.$select.addEventListener("change", () => {
      this.setValue(this._values[this.$select.selectedIndex]), this._callOnFinishChange();
    }), this.$select.addEventListener("focus", () => {
      this.$display.classList.add("focus");
    }), this.$select.addEventListener("blur", () => {
      this.$display.classList.remove("focus");
    }), this.$widget.appendChild(this.$select), this.$widget.appendChild(this.$display), this.$disable = this.$select, this.updateDisplay();
  }
  updateDisplay() {
    const t3 = this.getValue(), i2 = this._values.indexOf(t3);
    return this.$select.selectedIndex = i2, this.$display.innerHTML = -1 === i2 ? t3 : this._names[i2], this;
  }
}
let u$2 = class u extends t$1 {
  constructor(t3, i2, e2) {
    super(t3, i2, e2, "string"), this.$input = document.createElement("input"), this.$input.setAttribute("type", "text"), this.$input.setAttribute("aria-labelledby", this.$name.id), this.$input.addEventListener("input", () => {
      this.setValue(this.$input.value);
    }), this.$input.addEventListener("keydown", (t4) => {
      "Enter" === t4.code && this.$input.blur();
    }), this.$input.addEventListener("blur", () => {
      this._callOnFinishChange();
    }), this.$widget.appendChild(this.$input), this.$disable = this.$input, this.updateDisplay();
  }
  updateDisplay() {
    return this.$input.value = this.getValue(), this;
  }
};
let p = false;
let g$2 = class g {
  constructor({ parent: t3, autoPlace: i2 = void 0 === t3, container: e2, width: s2, title: n2 = "Controls", injectStyles: l2 = true, touchStyles: r2 = true } = {}) {
    if (this.parent = t3, this.root = t3 ? t3.root : this, this.children = [], this.controllers = [], this.folders = [], this._closed = false, this._hidden = false, this.domElement = document.createElement("div"), this.domElement.classList.add("lil-gui"), this.$title = document.createElement("div"), this.$title.classList.add("title"), this.$title.setAttribute("role", "button"), this.$title.setAttribute("aria-expanded", true), this.$title.setAttribute("tabindex", 0), this.$title.addEventListener("click", () => this.openAnimated(this._closed)), this.$title.addEventListener("keydown", (t4) => {
      "Enter" !== t4.code && "Space" !== t4.code || (t4.preventDefault(), this.$title.click());
    }), this.$title.addEventListener("touchstart", () => {
    }, { passive: true }), this.$children = document.createElement("div"), this.$children.classList.add("children"), this.domElement.appendChild(this.$title), this.domElement.appendChild(this.$children), this.title(n2), r2 && this.domElement.classList.add("allow-touch-styles"), this.parent) return this.parent.children.push(this), this.parent.folders.push(this), void this.parent.$children.appendChild(this.domElement);
    this.domElement.classList.add("root"), !p && l2 && (!function(t4) {
      const i3 = document.createElement("style");
      i3.innerHTML = t4;
      const e3 = document.querySelector("head link[rel=stylesheet], head style");
      e3 ? document.head.insertBefore(i3, e3) : document.head.appendChild(i3);
    }('.lil-gui{--background-color:#1f1f1f;--text-color:#ebebeb;--title-background-color:#111;--title-text-color:#ebebeb;--widget-color:#424242;--hover-color:#4f4f4f;--focus-color:#595959;--number-color:#2cc9ff;--string-color:#a2db3c;--font-size:11px;--input-font-size:11px;--font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;--font-family-mono:Menlo,Monaco,Consolas,"Droid Sans Mono",monospace;--padding:4px;--spacing:4px;--widget-height:20px;--name-width:45%;--slider-knob-width:2px;--slider-input-width:27%;--color-input-width:27%;--slider-input-min-width:45px;--color-input-min-width:45px;--folder-indent:7px;--widget-padding:0 0 0 3px;--widget-border-radius:2px;--checkbox-size:calc(var(--widget-height)*0.75);--scrollbar-width:5px;background-color:var(--background-color);color:var(--text-color);font-family:var(--font-family);font-size:var(--font-size);font-style:normal;font-weight:400;line-height:1;text-align:left;touch-action:manipulation;user-select:none;-webkit-user-select:none}.lil-gui,.lil-gui *{box-sizing:border-box;margin:0;padding:0}.lil-gui.root{display:flex;flex-direction:column;width:var(--width,245px)}.lil-gui.root>.title{background:var(--title-background-color);color:var(--title-text-color)}.lil-gui.root>.children{overflow-x:hidden;overflow-y:auto}.lil-gui.root>.children::-webkit-scrollbar{background:var(--background-color);height:var(--scrollbar-width);width:var(--scrollbar-width)}.lil-gui.root>.children::-webkit-scrollbar-thumb{background:var(--focus-color);border-radius:var(--scrollbar-width)}.lil-gui.force-touch-styles{--widget-height:28px;--padding:6px;--spacing:6px;--font-size:13px;--input-font-size:16px;--folder-indent:10px;--scrollbar-width:7px;--slider-input-min-width:50px;--color-input-min-width:65px}.lil-gui.autoPlace{max-height:100%;position:fixed;right:15px;top:0;z-index:1001}.lil-gui .controller{align-items:center;display:flex;margin:var(--spacing) 0;padding:0 var(--padding)}.lil-gui .controller.disabled{opacity:.5}.lil-gui .controller.disabled,.lil-gui .controller.disabled *{pointer-events:none!important}.lil-gui .controller>.name{flex-shrink:0;line-height:var(--widget-height);min-width:var(--name-width);padding-right:var(--spacing);white-space:pre}.lil-gui .controller .widget{align-items:center;display:flex;min-height:var(--widget-height);position:relative;width:100%}.lil-gui .controller.string input{color:var(--string-color)}.lil-gui .controller.boolean .widget{cursor:pointer}.lil-gui .controller.color .display{border-radius:var(--widget-border-radius);height:var(--widget-height);position:relative;width:100%}.lil-gui .controller.color input[type=color]{cursor:pointer;height:100%;opacity:0;width:100%}.lil-gui .controller.color input[type=text]{flex-shrink:0;font-family:var(--font-family-mono);margin-left:var(--spacing);min-width:var(--color-input-min-width);width:var(--color-input-width)}.lil-gui .controller.option select{max-width:100%;opacity:0;position:absolute;width:100%}.lil-gui .controller.option .display{background:var(--widget-color);border-radius:var(--widget-border-radius);height:var(--widget-height);line-height:var(--widget-height);max-width:100%;overflow:hidden;padding-left:.55em;padding-right:1.75em;pointer-events:none;position:relative;word-break:break-all}.lil-gui .controller.option .display.active{background:var(--focus-color)}.lil-gui .controller.option .display:after{bottom:0;content:"↕";font-family:lil-gui;padding-right:.375em;position:absolute;right:0;top:0}.lil-gui .controller.option .widget,.lil-gui .controller.option select{cursor:pointer}.lil-gui .controller.number input{color:var(--number-color)}.lil-gui .controller.number.hasSlider input{flex-shrink:0;margin-left:var(--spacing);min-width:var(--slider-input-min-width);width:var(--slider-input-width)}.lil-gui .controller.number .slider{background-color:var(--widget-color);border-radius:var(--widget-border-radius);cursor:ew-resize;height:var(--widget-height);overflow:hidden;padding-right:var(--slider-knob-width);touch-action:pan-y;width:100%}.lil-gui .controller.number .slider.active{background-color:var(--focus-color)}.lil-gui .controller.number .slider.active .fill{opacity:.95}.lil-gui .controller.number .fill{border-right:var(--slider-knob-width) solid var(--number-color);box-sizing:content-box;height:100%}.lil-gui-dragging .lil-gui{--hover-color:var(--widget-color)}.lil-gui-dragging *{cursor:ew-resize!important}.lil-gui-dragging.lil-gui-vertical *{cursor:ns-resize!important}.lil-gui .title{--title-height:calc(var(--widget-height) + var(--spacing)*1.25);-webkit-tap-highlight-color:transparent;text-decoration-skip:objects;cursor:pointer;font-weight:600;height:var(--title-height);line-height:calc(var(--title-height) - 4px);outline:none;padding:0 var(--padding)}.lil-gui .title:before{content:"▾";display:inline-block;font-family:lil-gui;padding-right:2px}.lil-gui .title:active{background:var(--title-background-color);opacity:.75}.lil-gui.root>.title:focus{text-decoration:none!important}.lil-gui.closed>.title:before{content:"▸"}.lil-gui.closed>.children{opacity:0;transform:translateY(-7px)}.lil-gui.closed:not(.transition)>.children{display:none}.lil-gui.transition>.children{overflow:hidden;pointer-events:none;transition-duration:.3s;transition-property:height,opacity,transform;transition-timing-function:cubic-bezier(.2,.6,.35,1)}.lil-gui .children:empty:before{content:"Empty";display:block;font-style:italic;height:var(--widget-height);line-height:var(--widget-height);margin:var(--spacing) 0;opacity:.5;padding:0 var(--padding)}.lil-gui.root>.children>.lil-gui>.title{border-width:0;border-bottom:1px solid var(--widget-color);border-left:0 solid var(--widget-color);border-right:0 solid var(--widget-color);border-top:1px solid var(--widget-color);transition:border-color .3s}.lil-gui.root>.children>.lil-gui.closed>.title{border-bottom-color:transparent}.lil-gui+.controller{border-top:1px solid var(--widget-color);margin-top:0;padding-top:var(--spacing)}.lil-gui .lil-gui .lil-gui>.title{border:none}.lil-gui .lil-gui .lil-gui>.children{border:none;border-left:2px solid var(--widget-color);margin-left:var(--folder-indent)}.lil-gui .lil-gui .controller{border:none}.lil-gui input{-webkit-tap-highlight-color:transparent;background:var(--widget-color);border:0;border-radius:var(--widget-border-radius);color:var(--text-color);font-family:var(--font-family);font-size:var(--input-font-size);height:var(--widget-height);outline:none;width:100%}.lil-gui input:disabled{opacity:1}.lil-gui input[type=number],.lil-gui input[type=text]{padding:var(--widget-padding)}.lil-gui input[type=number]:focus,.lil-gui input[type=text]:focus{background:var(--focus-color)}.lil-gui input::-webkit-inner-spin-button,.lil-gui input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.lil-gui input[type=number]{-moz-appearance:textfield}.lil-gui input[type=checkbox]{appearance:none;-webkit-appearance:none;border-radius:var(--widget-border-radius);cursor:pointer;height:var(--checkbox-size);text-align:center;width:var(--checkbox-size)}.lil-gui input[type=checkbox]:checked:before{content:"✓";font-family:lil-gui;font-size:var(--checkbox-size);line-height:var(--checkbox-size)}.lil-gui button{-webkit-tap-highlight-color:transparent;background:var(--widget-color);border:1px solid var(--widget-color);border-radius:var(--widget-border-radius);color:var(--text-color);cursor:pointer;font-family:var(--font-family);font-size:var(--font-size);height:var(--widget-height);line-height:calc(var(--widget-height) - 4px);outline:none;text-align:center;text-transform:none;width:100%}.lil-gui button:active{background:var(--focus-color)}@font-face{font-family:lil-gui;src:url("data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAAUsAAsAAAAACJwAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABHU1VCAAABCAAAAH4AAADAImwmYE9TLzIAAAGIAAAAPwAAAGBKqH5SY21hcAAAAcgAAAD0AAACrukyyJBnbHlmAAACvAAAAF8AAACEIZpWH2hlYWQAAAMcAAAAJwAAADZfcj2zaGhlYQAAA0QAAAAYAAAAJAC5AHhobXR4AAADXAAAABAAAABMAZAAAGxvY2EAAANsAAAAFAAAACgCEgIybWF4cAAAA4AAAAAeAAAAIAEfABJuYW1lAAADoAAAASIAAAIK9SUU/XBvc3QAAATEAAAAZgAAAJCTcMc2eJxVjbEOgjAURU+hFRBK1dGRL+ALnAiToyMLEzFpnPz/eAshwSa97517c/MwwJmeB9kwPl+0cf5+uGPZXsqPu4nvZabcSZldZ6kfyWnomFY/eScKqZNWupKJO6kXN3K9uCVoL7iInPr1X5baXs3tjuMqCtzEuagm/AAlzQgPAAB4nGNgYRBlnMDAysDAYM/gBiT5oLQBAwuDJAMDEwMrMwNWEJDmmsJwgCFeXZghBcjlZMgFCzOiKOIFAB71Bb8AeJy1kjFuwkAQRZ+DwRAwBtNQRUGKQ8OdKCAWUhAgKLhIuAsVSpWz5Bbkj3dEgYiUIszqWdpZe+Z7/wB1oCYmIoboiwiLT2WjKl/jscrHfGg/pKdMkyklC5Zs2LEfHYpjcRoPzme9MWWmk3dWbK9ObkWkikOetJ554fWyoEsmdSlt+uR0pCJR34b6t/TVg1SY3sYvdf8vuiKrpyaDXDISiegp17p7579Gp3p++y7HPAiY9pmTibljrr85qSidtlg4+l25GLCaS8e6rRxNBmsnERunKbaOObRz7N72ju5vdAjYpBXHgJylOAVsMseDAPEP8LYoUHicY2BiAAEfhiAGJgZWBgZ7RnFRdnVJELCQlBSRlATJMoLV2DK4glSYs6ubq5vbKrJLSbGrgEmovDuDJVhe3VzcXFwNLCOILB/C4IuQ1xTn5FPilBTj5FPmBAB4WwoqAHicY2BkYGAA4sk1sR/j+W2+MnAzpDBgAyEMQUCSg4EJxAEAwUgFHgB4nGNgZGBgSGFggJMhDIwMqEAYAByHATJ4nGNgAIIUNEwmAABl3AGReJxjYAACIQYlBiMGJ3wQAEcQBEV4nGNgZGBgEGZgY2BiAAEQyQWEDAz/wXwGAAsPATIAAHicXdBNSsNAHAXwl35iA0UQXYnMShfS9GPZA7T7LgIu03SSpkwzYTIt1BN4Ak/gKTyAeCxfw39jZkjymzcvAwmAW/wgwHUEGDb36+jQQ3GXGot79L24jxCP4gHzF/EIr4jEIe7wxhOC3g2TMYy4Q7+Lu/SHuEd/ivt4wJd4wPxbPEKMX3GI5+DJFGaSn4qNzk8mcbKSR6xdXdhSzaOZJGtdapd4vVPbi6rP+cL7TGXOHtXKll4bY1Xl7EGnPtp7Xy2n00zyKLVHfkHBa4IcJ2oD3cgggWvt/V/FbDrUlEUJhTn/0azVWbNTNr0Ens8de1tceK9xZmfB1CPjOmPH4kitmvOubcNpmVTN3oFJyjzCvnmrwhJTzqzVj9jiSX911FjeAAB4nG3HMRKCMBBA0f0giiKi4DU8k0V2GWbIZDOh4PoWWvq6J5V8If9NVNQcaDhyouXMhY4rPTcG7jwYmXhKq8Wz+p762aNaeYXom2n3m2dLTVgsrCgFJ7OTmIkYbwIbC6vIB7WmFfAAAA==") format("woff")}@media (pointer:coarse){.lil-gui.allow-touch-styles{--widget-height:28px;--padding:6px;--spacing:6px;--font-size:13px;--input-font-size:16px;--folder-indent:10px;--scrollbar-width:7px;--slider-input-min-width:50px;--color-input-min-width:65px}}@media (hover:hover){.lil-gui .controller.color .display:hover:before{border:1px solid #fff9;border-radius:var(--widget-border-radius);bottom:0;content:" ";display:block;left:0;position:absolute;right:0;top:0}.lil-gui .controller.option .display.focus{background:var(--focus-color)}.lil-gui .controller.option .widget:hover .display{background:var(--hover-color)}.lil-gui .controller.number .slider:hover{background-color:var(--hover-color)}body:not(.lil-gui-dragging) .lil-gui .title:hover{background:var(--title-background-color);opacity:.85}.lil-gui .title:focus{text-decoration:underline var(--focus-color)}.lil-gui input:hover{background:var(--hover-color)}.lil-gui input:active{background:var(--focus-color)}.lil-gui input[type=checkbox]:focus{box-shadow:inset 0 0 0 1px var(--focus-color)}.lil-gui button:hover{background:var(--hover-color);border-color:var(--hover-color)}.lil-gui button:focus{border-color:var(--focus-color)}}'), p = true), e2 ? e2.appendChild(this.domElement) : i2 && (this.domElement.classList.add("autoPlace"), document.body.appendChild(this.domElement)), s2 && this.domElement.style.setProperty("--width", s2 + "px"), this.domElement.addEventListener("keydown", (t4) => t4.stopPropagation()), this.domElement.addEventListener("keyup", (t4) => t4.stopPropagation());
  }
  add(t3, e2, s2, n2, l2) {
    if (Object(s2) === s2) return new c(this, t3, e2, s2);
    const r2 = t3[e2];
    switch (typeof r2) {
      case "number":
        return new d(this, t3, e2, s2, n2, l2);
      case "boolean":
        return new i$5(this, t3, e2);
      case "string":
        return new u$2(this, t3, e2);
      case "function":
        return new h(this, t3, e2);
    }
    console.error("gui.add failed\n	property:", e2, "\n	object:", t3, "\n	value:", r2);
  }
  addColor(t3, i2, e2 = 1) {
    return new a$1(this, t3, i2, e2);
  }
  addFolder(t3) {
    return new g({ parent: this, title: t3 });
  }
  load(t3, i2 = true) {
    return t3.controllers && this.controllers.forEach((i3) => {
      i3 instanceof h || i3._name in t3.controllers && i3.load(t3.controllers[i3._name]);
    }), i2 && t3.folders && this.folders.forEach((i3) => {
      i3._title in t3.folders && i3.load(t3.folders[i3._title]);
    }), this;
  }
  save(t3 = true) {
    const i2 = { controllers: {}, folders: {} };
    return this.controllers.forEach((t4) => {
      if (!(t4 instanceof h)) {
        if (t4._name in i2.controllers) throw new Error(`Cannot save GUI with duplicate property "${t4._name}"`);
        i2.controllers[t4._name] = t4.save();
      }
    }), t3 && this.folders.forEach((t4) => {
      if (t4._title in i2.folders) throw new Error(`Cannot save GUI with duplicate folder "${t4._title}"`);
      i2.folders[t4._title] = t4.save();
    }), i2;
  }
  open(t3 = true) {
    return this._closed = !t3, this.$title.setAttribute("aria-expanded", !this._closed), this.domElement.classList.toggle("closed", this._closed), this;
  }
  close() {
    return this.open(false);
  }
  show(t3 = true) {
    return this._hidden = !t3, this.domElement.style.display = this._hidden ? "none" : "", this;
  }
  hide() {
    return this.show(false);
  }
  openAnimated(t3 = true) {
    return this._closed = !t3, this.$title.setAttribute("aria-expanded", !this._closed), requestAnimationFrame(() => {
      const i2 = this.$children.clientHeight;
      this.$children.style.height = i2 + "px", this.domElement.classList.add("transition");
      const e2 = (t4) => {
        t4.target === this.$children && (this.$children.style.height = "", this.domElement.classList.remove("transition"), this.$children.removeEventListener("transitionend", e2));
      };
      this.$children.addEventListener("transitionend", e2);
      const s2 = t3 ? this.$children.scrollHeight : 0;
      this.domElement.classList.toggle("closed", !t3), requestAnimationFrame(() => {
        this.$children.style.height = s2 + "px";
      });
    }), this;
  }
  title(t3) {
    return this._title = t3, this.$title.innerHTML = t3, this;
  }
  reset(t3 = true) {
    return (t3 ? this.controllersRecursive() : this.controllers).forEach((t4) => t4.reset()), this;
  }
  onChange(t3) {
    return this._onChange = t3, this;
  }
  _callOnChange(t3) {
    this.parent && this.parent._callOnChange(t3), void 0 !== this._onChange && this._onChange.call(this, { object: t3.object, property: t3.property, value: t3.getValue(), controller: t3 });
  }
  onFinishChange(t3) {
    return this._onFinishChange = t3, this;
  }
  _callOnFinishChange(t3) {
    this.parent && this.parent._callOnFinishChange(t3), void 0 !== this._onFinishChange && this._onFinishChange.call(this, { object: t3.object, property: t3.property, value: t3.getValue(), controller: t3 });
  }
  destroy() {
    this.parent && (this.parent.children.splice(this.parent.children.indexOf(this), 1), this.parent.folders.splice(this.parent.folders.indexOf(this), 1)), this.domElement.parentElement && this.domElement.parentElement.removeChild(this.domElement), Array.from(this.children).forEach((t3) => t3.destroy());
  }
  controllersRecursive() {
    let t3 = Array.from(this.controllers);
    return this.folders.forEach((i2) => {
      t3 = t3.concat(i2.controllersRecursive());
    }), t3;
  }
  foldersRecursive() {
    let t3 = Array.from(this.folders);
    return this.folders.forEach((i2) => {
      t3 = t3.concat(i2.foldersRecursive());
    }), t3;
  }
};
const CENTER = 0;
const AVERAGE = 1;
const SAH = 2;
const CONTAINED = 2;
const TRIANGLE_INTERSECT_COST = 1.25;
const TRAVERSAL_COST = 1;
const BYTES_PER_NODE = 6 * 4 + 4 + 4;
const IS_LEAFNODE_FLAG = 65535;
const FLOAT32_EPSILON = Math.pow(2, -24);
const SKIP_GENERATION = Symbol("SKIP_GENERATION");
function getVertexCount(geo) {
  return geo.index ? geo.index.count : geo.attributes.position.count;
}
function getTriCount(geo) {
  return getVertexCount(geo) / 3;
}
function getIndexArray(vertexCount, BufferConstructor = ArrayBuffer) {
  if (vertexCount > 65535) {
    return new Uint32Array(new BufferConstructor(4 * vertexCount));
  } else {
    return new Uint16Array(new BufferConstructor(2 * vertexCount));
  }
}
function ensureIndex(geo, options) {
  if (!geo.index) {
    const vertexCount = geo.attributes.position.count;
    const BufferConstructor = options.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
    const index2 = getIndexArray(vertexCount, BufferConstructor);
    geo.setIndex(new BufferAttribute$1(index2, 1));
    for (let i2 = 0; i2 < vertexCount; i2++) {
      index2[i2] = i2;
    }
  }
}
function getFullGeometryRange(geo, range) {
  const triCount = getTriCount(geo);
  const drawRange = range ? range : geo.drawRange;
  const start = drawRange.start / 3;
  const end = (drawRange.start + drawRange.count) / 3;
  const offset = Math.max(0, start);
  const count = Math.min(triCount, end) - offset;
  return [{
    offset: Math.floor(offset),
    count: Math.floor(count)
  }];
}
function getRootIndexRanges(geo, range) {
  if (!geo.groups || !geo.groups.length) {
    return getFullGeometryRange(geo, range);
  }
  const ranges = [];
  const rangeBoundaries = /* @__PURE__ */ new Set();
  const drawRange = range ? range : geo.drawRange;
  const drawRangeStart = drawRange.start / 3;
  const drawRangeEnd = (drawRange.start + drawRange.count) / 3;
  for (const group of geo.groups) {
    const groupStart = group.start / 3;
    const groupEnd = (group.start + group.count) / 3;
    rangeBoundaries.add(Math.max(drawRangeStart, groupStart));
    rangeBoundaries.add(Math.min(drawRangeEnd, groupEnd));
  }
  const sortedBoundaries = Array.from(rangeBoundaries.values()).sort((a3, b) => a3 - b);
  for (let i2 = 0; i2 < sortedBoundaries.length - 1; i2++) {
    const start = sortedBoundaries[i2];
    const end = sortedBoundaries[i2 + 1];
    ranges.push({
      offset: Math.floor(start),
      count: Math.floor(end - start)
    });
  }
  return ranges;
}
function hasGroupGaps(geometry, range) {
  const vertexCount = getTriCount(geometry);
  const groups = getRootIndexRanges(geometry, range).sort((a3, b) => a3.offset - b.offset);
  const finalGroup = groups[groups.length - 1];
  finalGroup.count = Math.min(vertexCount - finalGroup.offset, finalGroup.count);
  let total = 0;
  groups.forEach(({ count }) => total += count);
  return vertexCount !== total;
}
function getBounds(triangleBounds, offset, count, target, centroidTarget) {
  let minx = Infinity;
  let miny = Infinity;
  let minz = Infinity;
  let maxx = -Infinity;
  let maxy = -Infinity;
  let maxz = -Infinity;
  let cminx = Infinity;
  let cminy = Infinity;
  let cminz = Infinity;
  let cmaxx = -Infinity;
  let cmaxy = -Infinity;
  let cmaxz = -Infinity;
  for (let i2 = offset * 6, end = (offset + count) * 6; i2 < end; i2 += 6) {
    const cx = triangleBounds[i2 + 0];
    const hx = triangleBounds[i2 + 1];
    const lx = cx - hx;
    const rx = cx + hx;
    if (lx < minx) minx = lx;
    if (rx > maxx) maxx = rx;
    if (cx < cminx) cminx = cx;
    if (cx > cmaxx) cmaxx = cx;
    const cy = triangleBounds[i2 + 2];
    const hy = triangleBounds[i2 + 3];
    const ly = cy - hy;
    const ry = cy + hy;
    if (ly < miny) miny = ly;
    if (ry > maxy) maxy = ry;
    if (cy < cminy) cminy = cy;
    if (cy > cmaxy) cmaxy = cy;
    const cz = triangleBounds[i2 + 4];
    const hz = triangleBounds[i2 + 5];
    const lz = cz - hz;
    const rz = cz + hz;
    if (lz < minz) minz = lz;
    if (rz > maxz) maxz = rz;
    if (cz < cminz) cminz = cz;
    if (cz > cmaxz) cmaxz = cz;
  }
  target[0] = minx;
  target[1] = miny;
  target[2] = minz;
  target[3] = maxx;
  target[4] = maxy;
  target[5] = maxz;
  centroidTarget[0] = cminx;
  centroidTarget[1] = cminy;
  centroidTarget[2] = cminz;
  centroidTarget[3] = cmaxx;
  centroidTarget[4] = cmaxy;
  centroidTarget[5] = cmaxz;
}
function computeTriangleBounds(geo, target = null, offset = null, count = null) {
  const posAttr = geo.attributes.position;
  const index2 = geo.index ? geo.index.array : null;
  const triCount = getTriCount(geo);
  const normalized = posAttr.normalized;
  let triangleBounds;
  if (target === null) {
    triangleBounds = new Float32Array(triCount * 6);
    offset = 0;
    count = triCount;
  } else {
    triangleBounds = target;
    offset = offset || 0;
    count = count || triCount;
  }
  const posArr = posAttr.array;
  const bufferOffset = posAttr.offset || 0;
  let stride = 3;
  if (posAttr.isInterleavedBufferAttribute) {
    stride = posAttr.data.stride;
  }
  const getters = ["getX", "getY", "getZ"];
  for (let tri = offset; tri < offset + count; tri++) {
    const tri3 = tri * 3;
    const tri6 = tri * 6;
    let ai = tri3 + 0;
    let bi = tri3 + 1;
    let ci = tri3 + 2;
    if (index2) {
      ai = index2[ai];
      bi = index2[bi];
      ci = index2[ci];
    }
    if (!normalized) {
      ai = ai * stride + bufferOffset;
      bi = bi * stride + bufferOffset;
      ci = ci * stride + bufferOffset;
    }
    for (let el = 0; el < 3; el++) {
      let a3, b, c2;
      if (normalized) {
        a3 = posAttr[getters[el]](ai);
        b = posAttr[getters[el]](bi);
        c2 = posAttr[getters[el]](ci);
      } else {
        a3 = posArr[ai + el];
        b = posArr[bi + el];
        c2 = posArr[ci + el];
      }
      let min = a3;
      if (b < min) min = b;
      if (c2 < min) min = c2;
      let max2 = a3;
      if (b > max2) max2 = b;
      if (c2 > max2) max2 = c2;
      const halfExtents = (max2 - min) / 2;
      const el2 = el * 2;
      triangleBounds[tri6 + el2 + 0] = min + halfExtents;
      triangleBounds[tri6 + el2 + 1] = halfExtents + (Math.abs(min) + halfExtents) * FLOAT32_EPSILON;
    }
  }
  return triangleBounds;
}
function arrayToBox(nodeIndex32, array, target) {
  target.min.x = array[nodeIndex32];
  target.min.y = array[nodeIndex32 + 1];
  target.min.z = array[nodeIndex32 + 2];
  target.max.x = array[nodeIndex32 + 3];
  target.max.y = array[nodeIndex32 + 4];
  target.max.z = array[nodeIndex32 + 5];
  return target;
}
function getLongestEdgeIndex(bounds) {
  let splitDimIdx = -1;
  let splitDist = -Infinity;
  for (let i2 = 0; i2 < 3; i2++) {
    const dist = bounds[i2 + 3] - bounds[i2];
    if (dist > splitDist) {
      splitDist = dist;
      splitDimIdx = i2;
    }
  }
  return splitDimIdx;
}
function copyBounds(source, target) {
  target.set(source);
}
function unionBounds(a3, b, target) {
  let aVal, bVal;
  for (let d2 = 0; d2 < 3; d2++) {
    const d3 = d2 + 3;
    aVal = a3[d2];
    bVal = b[d2];
    target[d2] = aVal < bVal ? aVal : bVal;
    aVal = a3[d3];
    bVal = b[d3];
    target[d3] = aVal > bVal ? aVal : bVal;
  }
}
function expandByTriangleBounds(startIndex, triangleBounds, bounds) {
  for (let d2 = 0; d2 < 3; d2++) {
    const tCenter = triangleBounds[startIndex + 2 * d2];
    const tHalf = triangleBounds[startIndex + 2 * d2 + 1];
    const tMin = tCenter - tHalf;
    const tMax = tCenter + tHalf;
    if (tMin < bounds[d2]) {
      bounds[d2] = tMin;
    }
    if (tMax > bounds[d2 + 3]) {
      bounds[d2 + 3] = tMax;
    }
  }
}
function computeSurfaceArea(bounds) {
  const d0 = bounds[3] - bounds[0];
  const d1 = bounds[4] - bounds[1];
  const d2 = bounds[5] - bounds[2];
  return 2 * (d0 * d1 + d1 * d2 + d2 * d0);
}
const BIN_COUNT = 32;
const binsSort = (a3, b) => a3.candidate - b.candidate;
const sahBins = new Array(BIN_COUNT).fill().map(() => {
  return {
    count: 0,
    bounds: new Float32Array(6),
    rightCacheBounds: new Float32Array(6),
    leftCacheBounds: new Float32Array(6),
    candidate: 0
  };
});
const leftBounds = new Float32Array(6);
function getOptimalSplit(nodeBoundingData, centroidBoundingData, triangleBounds, offset, count, strategy) {
  let axis = -1;
  let pos = 0;
  if (strategy === CENTER) {
    axis = getLongestEdgeIndex(centroidBoundingData);
    if (axis !== -1) {
      pos = (centroidBoundingData[axis] + centroidBoundingData[axis + 3]) / 2;
    }
  } else if (strategy === AVERAGE) {
    axis = getLongestEdgeIndex(nodeBoundingData);
    if (axis !== -1) {
      pos = getAverage(triangleBounds, offset, count, axis);
    }
  } else if (strategy === SAH) {
    const rootSurfaceArea = computeSurfaceArea(nodeBoundingData);
    let bestCost = TRIANGLE_INTERSECT_COST * count;
    const cStart = offset * 6;
    const cEnd = (offset + count) * 6;
    for (let a3 = 0; a3 < 3; a3++) {
      const axisLeft = centroidBoundingData[a3];
      const axisRight = centroidBoundingData[a3 + 3];
      const axisLength = axisRight - axisLeft;
      const binWidth = axisLength / BIN_COUNT;
      if (count < BIN_COUNT / 4) {
        const truncatedBins = [...sahBins];
        truncatedBins.length = count;
        let b = 0;
        for (let c2 = cStart; c2 < cEnd; c2 += 6, b++) {
          const bin = truncatedBins[b];
          bin.candidate = triangleBounds[c2 + 2 * a3];
          bin.count = 0;
          const {
            bounds,
            leftCacheBounds,
            rightCacheBounds
          } = bin;
          for (let d2 = 0; d2 < 3; d2++) {
            rightCacheBounds[d2] = Infinity;
            rightCacheBounds[d2 + 3] = -Infinity;
            leftCacheBounds[d2] = Infinity;
            leftCacheBounds[d2 + 3] = -Infinity;
            bounds[d2] = Infinity;
            bounds[d2 + 3] = -Infinity;
          }
          expandByTriangleBounds(c2, triangleBounds, bounds);
        }
        truncatedBins.sort(binsSort);
        let splitCount = count;
        for (let bi = 0; bi < splitCount; bi++) {
          const bin = truncatedBins[bi];
          while (bi + 1 < splitCount && truncatedBins[bi + 1].candidate === bin.candidate) {
            truncatedBins.splice(bi + 1, 1);
            splitCount--;
          }
        }
        for (let c2 = cStart; c2 < cEnd; c2 += 6) {
          const center = triangleBounds[c2 + 2 * a3];
          for (let bi = 0; bi < splitCount; bi++) {
            const bin = truncatedBins[bi];
            if (center >= bin.candidate) {
              expandByTriangleBounds(c2, triangleBounds, bin.rightCacheBounds);
            } else {
              expandByTriangleBounds(c2, triangleBounds, bin.leftCacheBounds);
              bin.count++;
            }
          }
        }
        for (let bi = 0; bi < splitCount; bi++) {
          const bin = truncatedBins[bi];
          const leftCount = bin.count;
          const rightCount = count - bin.count;
          const leftBounds2 = bin.leftCacheBounds;
          const rightBounds = bin.rightCacheBounds;
          let leftProb = 0;
          if (leftCount !== 0) {
            leftProb = computeSurfaceArea(leftBounds2) / rootSurfaceArea;
          }
          let rightProb = 0;
          if (rightCount !== 0) {
            rightProb = computeSurfaceArea(rightBounds) / rootSurfaceArea;
          }
          const cost = TRAVERSAL_COST + TRIANGLE_INTERSECT_COST * (leftProb * leftCount + rightProb * rightCount);
          if (cost < bestCost) {
            axis = a3;
            bestCost = cost;
            pos = bin.candidate;
          }
        }
      } else {
        for (let i2 = 0; i2 < BIN_COUNT; i2++) {
          const bin = sahBins[i2];
          bin.count = 0;
          bin.candidate = axisLeft + binWidth + i2 * binWidth;
          const bounds = bin.bounds;
          for (let d2 = 0; d2 < 3; d2++) {
            bounds[d2] = Infinity;
            bounds[d2 + 3] = -Infinity;
          }
        }
        for (let c2 = cStart; c2 < cEnd; c2 += 6) {
          const triCenter = triangleBounds[c2 + 2 * a3];
          const relativeCenter = triCenter - axisLeft;
          let binIndex = ~~(relativeCenter / binWidth);
          if (binIndex >= BIN_COUNT) binIndex = BIN_COUNT - 1;
          const bin = sahBins[binIndex];
          bin.count++;
          expandByTriangleBounds(c2, triangleBounds, bin.bounds);
        }
        const lastBin = sahBins[BIN_COUNT - 1];
        copyBounds(lastBin.bounds, lastBin.rightCacheBounds);
        for (let i2 = BIN_COUNT - 2; i2 >= 0; i2--) {
          const bin = sahBins[i2];
          const nextBin = sahBins[i2 + 1];
          unionBounds(bin.bounds, nextBin.rightCacheBounds, bin.rightCacheBounds);
        }
        let leftCount = 0;
        for (let i2 = 0; i2 < BIN_COUNT - 1; i2++) {
          const bin = sahBins[i2];
          const binCount = bin.count;
          const bounds = bin.bounds;
          const nextBin = sahBins[i2 + 1];
          const rightBounds = nextBin.rightCacheBounds;
          if (binCount !== 0) {
            if (leftCount === 0) {
              copyBounds(bounds, leftBounds);
            } else {
              unionBounds(bounds, leftBounds, leftBounds);
            }
          }
          leftCount += binCount;
          let leftProb = 0;
          let rightProb = 0;
          if (leftCount !== 0) {
            leftProb = computeSurfaceArea(leftBounds) / rootSurfaceArea;
          }
          const rightCount = count - leftCount;
          if (rightCount !== 0) {
            rightProb = computeSurfaceArea(rightBounds) / rootSurfaceArea;
          }
          const cost = TRAVERSAL_COST + TRIANGLE_INTERSECT_COST * (leftProb * leftCount + rightProb * rightCount);
          if (cost < bestCost) {
            axis = a3;
            bestCost = cost;
            pos = bin.candidate;
          }
        }
      }
    }
  } else {
    console.warn(`MeshBVH: Invalid build strategy value ${strategy} used.`);
  }
  return { axis, pos };
}
function getAverage(triangleBounds, offset, count, axis) {
  let avg = 0;
  for (let i2 = offset, end = offset + count; i2 < end; i2++) {
    avg += triangleBounds[i2 * 6 + axis * 2];
  }
  return avg / count;
}
class MeshBVHNode {
  constructor() {
    this.boundingData = new Float32Array(6);
  }
}
function partition(indirectBuffer, index2, triangleBounds, offset, count, split) {
  let left = offset;
  let right = offset + count - 1;
  const pos = split.pos;
  const axisOffset = split.axis * 2;
  while (true) {
    while (left <= right && triangleBounds[left * 6 + axisOffset] < pos) {
      left++;
    }
    while (left <= right && triangleBounds[right * 6 + axisOffset] >= pos) {
      right--;
    }
    if (left < right) {
      for (let i2 = 0; i2 < 3; i2++) {
        let t0 = index2[left * 3 + i2];
        index2[left * 3 + i2] = index2[right * 3 + i2];
        index2[right * 3 + i2] = t0;
      }
      for (let i2 = 0; i2 < 6; i2++) {
        let tb = triangleBounds[left * 6 + i2];
        triangleBounds[left * 6 + i2] = triangleBounds[right * 6 + i2];
        triangleBounds[right * 6 + i2] = tb;
      }
      left++;
      right--;
    } else {
      return left;
    }
  }
}
function partition_indirect(indirectBuffer, index2, triangleBounds, offset, count, split) {
  let left = offset;
  let right = offset + count - 1;
  const pos = split.pos;
  const axisOffset = split.axis * 2;
  while (true) {
    while (left <= right && triangleBounds[left * 6 + axisOffset] < pos) {
      left++;
    }
    while (left <= right && triangleBounds[right * 6 + axisOffset] >= pos) {
      right--;
    }
    if (left < right) {
      let t3 = indirectBuffer[left];
      indirectBuffer[left] = indirectBuffer[right];
      indirectBuffer[right] = t3;
      for (let i2 = 0; i2 < 6; i2++) {
        let tb = triangleBounds[left * 6 + i2];
        triangleBounds[left * 6 + i2] = triangleBounds[right * 6 + i2];
        triangleBounds[right * 6 + i2] = tb;
      }
      left++;
      right--;
    } else {
      return left;
    }
  }
}
function IS_LEAF(n16, uint16Array2) {
  return uint16Array2[n16 + 15] === 65535;
}
function OFFSET(n32, uint32Array2) {
  return uint32Array2[n32 + 6];
}
function COUNT(n16, uint16Array2) {
  return uint16Array2[n16 + 14];
}
function LEFT_NODE(n32) {
  return n32 + 8;
}
function RIGHT_NODE(n32, uint32Array2) {
  return uint32Array2[n32 + 6];
}
function SPLIT_AXIS(n32, uint32Array2) {
  return uint32Array2[n32 + 7];
}
function BOUNDING_DATA_INDEX(n32) {
  return n32;
}
let float32Array, uint32Array, uint16Array, uint8Array;
const MAX_POINTER = Math.pow(2, 32);
function countNodes(node) {
  if ("count" in node) {
    return 1;
  } else {
    return 1 + countNodes(node.left) + countNodes(node.right);
  }
}
function populateBuffer(byteOffset, node, buffer) {
  float32Array = new Float32Array(buffer);
  uint32Array = new Uint32Array(buffer);
  uint16Array = new Uint16Array(buffer);
  uint8Array = new Uint8Array(buffer);
  return _populateBuffer(byteOffset, node);
}
function _populateBuffer(byteOffset, node) {
  const stride4Offset = byteOffset / 4;
  const stride2Offset = byteOffset / 2;
  const isLeaf = "count" in node;
  const boundingData = node.boundingData;
  for (let i2 = 0; i2 < 6; i2++) {
    float32Array[stride4Offset + i2] = boundingData[i2];
  }
  if (isLeaf) {
    if (node.buffer) {
      const buffer = node.buffer;
      uint8Array.set(new Uint8Array(buffer), byteOffset);
      for (let offset = byteOffset, l2 = byteOffset + buffer.byteLength; offset < l2; offset += BYTES_PER_NODE) {
        const offset2 = offset / 2;
        if (!IS_LEAF(offset2, uint16Array)) {
          uint32Array[offset / 4 + 6] += stride4Offset;
        }
      }
      return byteOffset + buffer.byteLength;
    } else {
      const offset = node.offset;
      const count = node.count;
      uint32Array[stride4Offset + 6] = offset;
      uint16Array[stride2Offset + 14] = count;
      uint16Array[stride2Offset + 15] = IS_LEAFNODE_FLAG;
      return byteOffset + BYTES_PER_NODE;
    }
  } else {
    const left = node.left;
    const right = node.right;
    const splitAxis = node.splitAxis;
    let nextUnusedPointer;
    nextUnusedPointer = _populateBuffer(byteOffset + BYTES_PER_NODE, left);
    if (nextUnusedPointer / 4 > MAX_POINTER) {
      throw new Error("MeshBVH: Cannot store child pointer greater than 32 bits.");
    }
    uint32Array[stride4Offset + 6] = nextUnusedPointer / 4;
    nextUnusedPointer = _populateBuffer(nextUnusedPointer, right);
    uint32Array[stride4Offset + 7] = splitAxis;
    return nextUnusedPointer;
  }
}
function generateIndirectBuffer(geometry, useSharedArrayBuffer) {
  const triCount = (geometry.index ? geometry.index.count : geometry.attributes.position.count) / 3;
  const useUint32 = triCount > 2 ** 16;
  const byteCount = useUint32 ? 4 : 2;
  const buffer = useSharedArrayBuffer ? new SharedArrayBuffer(triCount * byteCount) : new ArrayBuffer(triCount * byteCount);
  const indirectBuffer = useUint32 ? new Uint32Array(buffer) : new Uint16Array(buffer);
  for (let i2 = 0, l2 = indirectBuffer.length; i2 < l2; i2++) {
    indirectBuffer[i2] = i2;
  }
  return indirectBuffer;
}
function buildTree(bvh, triangleBounds, offset, count, options) {
  const {
    maxDepth,
    verbose,
    maxLeafTris,
    strategy,
    onProgress,
    indirect
  } = options;
  const indirectBuffer = bvh._indirectBuffer;
  const geometry = bvh.geometry;
  const indexArray = geometry.index ? geometry.index.array : null;
  const partionFunc = indirect ? partition_indirect : partition;
  const totalTriangles = getTriCount(geometry);
  const cacheCentroidBoundingData = new Float32Array(6);
  let reachedMaxDepth = false;
  const root = new MeshBVHNode();
  getBounds(triangleBounds, offset, count, root.boundingData, cacheCentroidBoundingData);
  splitNode(root, offset, count, cacheCentroidBoundingData);
  return root;
  function triggerProgress(trianglesProcessed) {
    if (onProgress) {
      onProgress(trianglesProcessed / totalTriangles);
    }
  }
  function splitNode(node, offset2, count2, centroidBoundingData = null, depth = 0) {
    if (!reachedMaxDepth && depth >= maxDepth) {
      reachedMaxDepth = true;
      if (verbose) {
        console.warn(`MeshBVH: Max depth of ${maxDepth} reached when generating BVH. Consider increasing maxDepth.`);
        console.warn(geometry);
      }
    }
    if (count2 <= maxLeafTris || depth >= maxDepth) {
      triggerProgress(offset2 + count2);
      node.offset = offset2;
      node.count = count2;
      return node;
    }
    const split = getOptimalSplit(node.boundingData, centroidBoundingData, triangleBounds, offset2, count2, strategy);
    if (split.axis === -1) {
      triggerProgress(offset2 + count2);
      node.offset = offset2;
      node.count = count2;
      return node;
    }
    const splitOffset = partionFunc(indirectBuffer, indexArray, triangleBounds, offset2, count2, split);
    if (splitOffset === offset2 || splitOffset === offset2 + count2) {
      triggerProgress(offset2 + count2);
      node.offset = offset2;
      node.count = count2;
    } else {
      node.splitAxis = split.axis;
      const left = new MeshBVHNode();
      const lstart = offset2;
      const lcount = splitOffset - offset2;
      node.left = left;
      getBounds(triangleBounds, lstart, lcount, left.boundingData, cacheCentroidBoundingData);
      splitNode(left, lstart, lcount, cacheCentroidBoundingData, depth + 1);
      const right = new MeshBVHNode();
      const rstart = splitOffset;
      const rcount = count2 - lcount;
      node.right = right;
      getBounds(triangleBounds, rstart, rcount, right.boundingData, cacheCentroidBoundingData);
      splitNode(right, rstart, rcount, cacheCentroidBoundingData, depth + 1);
    }
    return node;
  }
}
function buildPackedTree(bvh, options) {
  const geometry = bvh.geometry;
  if (options.indirect) {
    bvh._indirectBuffer = generateIndirectBuffer(geometry, options.useSharedArrayBuffer);
    if (hasGroupGaps(geometry, options.range) && !options.verbose) {
      console.warn(
        'MeshBVH: Provided geometry contains groups or a range that do not fully span the vertex contents while using the "indirect" option. BVH may incorrectly report intersections on unrendered portions of the geometry.'
      );
    }
  }
  if (!bvh._indirectBuffer) {
    ensureIndex(geometry, options);
  }
  const BufferConstructor = options.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
  const triangleBounds = computeTriangleBounds(geometry);
  const geometryRanges = options.indirect ? getFullGeometryRange(geometry, options.range) : getRootIndexRanges(geometry, options.range);
  bvh._roots = geometryRanges.map((range) => {
    const root = buildTree(bvh, triangleBounds, range.offset, range.count, options);
    const nodeCount = countNodes(root);
    const buffer = new BufferConstructor(BYTES_PER_NODE * nodeCount);
    populateBuffer(0, root, buffer);
    return buffer;
  });
}
class SeparatingAxisBounds {
  constructor() {
    this.min = Infinity;
    this.max = -Infinity;
  }
  setFromPointsField(points, field) {
    let min = Infinity;
    let max2 = -Infinity;
    for (let i2 = 0, l2 = points.length; i2 < l2; i2++) {
      const p2 = points[i2];
      const val = p2[field];
      min = val < min ? val : min;
      max2 = val > max2 ? val : max2;
    }
    this.min = min;
    this.max = max2;
  }
  setFromPoints(axis, points) {
    let min = Infinity;
    let max2 = -Infinity;
    for (let i2 = 0, l2 = points.length; i2 < l2; i2++) {
      const p2 = points[i2];
      const val = axis.dot(p2);
      min = val < min ? val : min;
      max2 = val > max2 ? val : max2;
    }
    this.min = min;
    this.max = max2;
  }
  isSeparated(other) {
    return this.min > other.max || other.min > this.max;
  }
}
SeparatingAxisBounds.prototype.setFromBox = function() {
  const p2 = new Vector3$1();
  return function setFromBox(axis, box) {
    const boxMin = box.min;
    const boxMax = box.max;
    let min = Infinity;
    let max2 = -Infinity;
    for (let x = 0; x <= 1; x++) {
      for (let y = 0; y <= 1; y++) {
        for (let z2 = 0; z2 <= 1; z2++) {
          p2.x = boxMin.x * x + boxMax.x * (1 - x);
          p2.y = boxMin.y * y + boxMax.y * (1 - y);
          p2.z = boxMin.z * z2 + boxMax.z * (1 - z2);
          const val = axis.dot(p2);
          min = Math.min(val, min);
          max2 = Math.max(val, max2);
        }
      }
    }
    this.min = min;
    this.max = max2;
  };
}();
const closestPointLineToLine = function() {
  const dir1 = new Vector3$1();
  const dir2 = new Vector3$1();
  const v02 = new Vector3$1();
  return function closestPointLineToLine2(l1, l2, result) {
    const v0 = l1.start;
    const v10 = dir1;
    const v2 = l2.start;
    const v32 = dir2;
    v02.subVectors(v0, v2);
    dir1.subVectors(l1.end, l1.start);
    dir2.subVectors(l2.end, l2.start);
    const d0232 = v02.dot(v32);
    const d3210 = v32.dot(v10);
    const d3232 = v32.dot(v32);
    const d0210 = v02.dot(v10);
    const d1010 = v10.dot(v10);
    const denom = d1010 * d3232 - d3210 * d3210;
    let d2, d22;
    if (denom !== 0) {
      d2 = (d0232 * d3210 - d0210 * d3232) / denom;
    } else {
      d2 = 0;
    }
    d22 = (d0232 + d2 * d3210) / d3232;
    result.x = d2;
    result.y = d22;
  };
}();
const closestPointsSegmentToSegment = function() {
  const paramResult = new Vector2$1();
  const temp12 = new Vector3$1();
  const temp22 = new Vector3$1();
  return function closestPointsSegmentToSegment2(l1, l2, target1, target2) {
    closestPointLineToLine(l1, l2, paramResult);
    let d2 = paramResult.x;
    let d22 = paramResult.y;
    if (d2 >= 0 && d2 <= 1 && d22 >= 0 && d22 <= 1) {
      l1.at(d2, target1);
      l2.at(d22, target2);
      return;
    } else if (d2 >= 0 && d2 <= 1) {
      if (d22 < 0) {
        l2.at(0, target2);
      } else {
        l2.at(1, target2);
      }
      l1.closestPointToPoint(target2, true, target1);
      return;
    } else if (d22 >= 0 && d22 <= 1) {
      if (d2 < 0) {
        l1.at(0, target1);
      } else {
        l1.at(1, target1);
      }
      l2.closestPointToPoint(target1, true, target2);
      return;
    } else {
      let p2;
      if (d2 < 0) {
        p2 = l1.start;
      } else {
        p2 = l1.end;
      }
      let p22;
      if (d22 < 0) {
        p22 = l2.start;
      } else {
        p22 = l2.end;
      }
      const closestPoint = temp12;
      const closestPoint2 = temp22;
      l1.closestPointToPoint(p22, true, temp12);
      l2.closestPointToPoint(p2, true, temp22);
      if (closestPoint.distanceToSquared(p22) <= closestPoint2.distanceToSquared(p2)) {
        target1.copy(closestPoint);
        target2.copy(p22);
        return;
      } else {
        target1.copy(p2);
        target2.copy(closestPoint2);
        return;
      }
    }
  };
}();
const sphereIntersectTriangle = function() {
  const closestPointTemp = new Vector3$1();
  const projectedPointTemp = new Vector3$1();
  const planeTemp = new Plane$1();
  const lineTemp = new Line3();
  return function sphereIntersectTriangle2(sphere, triangle3) {
    const { radius, center } = sphere;
    const { a: a3, b, c: c2 } = triangle3;
    lineTemp.start = a3;
    lineTemp.end = b;
    const closestPoint1 = lineTemp.closestPointToPoint(center, true, closestPointTemp);
    if (closestPoint1.distanceTo(center) <= radius) return true;
    lineTemp.start = a3;
    lineTemp.end = c2;
    const closestPoint2 = lineTemp.closestPointToPoint(center, true, closestPointTemp);
    if (closestPoint2.distanceTo(center) <= radius) return true;
    lineTemp.start = b;
    lineTemp.end = c2;
    const closestPoint3 = lineTemp.closestPointToPoint(center, true, closestPointTemp);
    if (closestPoint3.distanceTo(center) <= radius) return true;
    const plane = triangle3.getPlane(planeTemp);
    const dp = Math.abs(plane.distanceToPoint(center));
    if (dp <= radius) {
      const pp = plane.projectPoint(center, projectedPointTemp);
      const cp = triangle3.containsPoint(pp);
      if (cp) return true;
    }
    return false;
  };
}();
const ZERO_EPSILON = 1e-15;
function isNearZero(value) {
  return Math.abs(value) < ZERO_EPSILON;
}
class ExtendedTriangle extends Triangle$1 {
  constructor(...args) {
    super(...args);
    this.isExtendedTriangle = true;
    this.satAxes = new Array(4).fill().map(() => new Vector3$1());
    this.satBounds = new Array(4).fill().map(() => new SeparatingAxisBounds());
    this.points = [this.a, this.b, this.c];
    this.sphere = new Sphere$1();
    this.plane = new Plane$1();
    this.needsUpdate = true;
  }
  intersectsSphere(sphere) {
    return sphereIntersectTriangle(sphere, this);
  }
  update() {
    const a3 = this.a;
    const b = this.b;
    const c2 = this.c;
    const points = this.points;
    const satAxes = this.satAxes;
    const satBounds = this.satBounds;
    const axis0 = satAxes[0];
    const sab0 = satBounds[0];
    this.getNormal(axis0);
    sab0.setFromPoints(axis0, points);
    const axis1 = satAxes[1];
    const sab1 = satBounds[1];
    axis1.subVectors(a3, b);
    sab1.setFromPoints(axis1, points);
    const axis2 = satAxes[2];
    const sab2 = satBounds[2];
    axis2.subVectors(b, c2);
    sab2.setFromPoints(axis2, points);
    const axis3 = satAxes[3];
    const sab3 = satBounds[3];
    axis3.subVectors(c2, a3);
    sab3.setFromPoints(axis3, points);
    this.sphere.setFromPoints(this.points);
    this.plane.setFromNormalAndCoplanarPoint(axis0, a3);
    this.needsUpdate = false;
  }
}
ExtendedTriangle.prototype.closestPointToSegment = function() {
  const point1 = new Vector3$1();
  const point2 = new Vector3$1();
  const edge = new Line3();
  return function distanceToSegment(segment, target1 = null, target2 = null) {
    const { start, end } = segment;
    const points = this.points;
    let distSq;
    let closestDistanceSq = Infinity;
    for (let i2 = 0; i2 < 3; i2++) {
      const nexti = (i2 + 1) % 3;
      edge.start.copy(points[i2]);
      edge.end.copy(points[nexti]);
      closestPointsSegmentToSegment(edge, segment, point1, point2);
      distSq = point1.distanceToSquared(point2);
      if (distSq < closestDistanceSq) {
        closestDistanceSq = distSq;
        if (target1) target1.copy(point1);
        if (target2) target2.copy(point2);
      }
    }
    this.closestPointToPoint(start, point1);
    distSq = start.distanceToSquared(point1);
    if (distSq < closestDistanceSq) {
      closestDistanceSq = distSq;
      if (target1) target1.copy(point1);
      if (target2) target2.copy(start);
    }
    this.closestPointToPoint(end, point1);
    distSq = end.distanceToSquared(point1);
    if (distSq < closestDistanceSq) {
      closestDistanceSq = distSq;
      if (target1) target1.copy(point1);
      if (target2) target2.copy(end);
    }
    return Math.sqrt(closestDistanceSq);
  };
}();
ExtendedTriangle.prototype.intersectsTriangle = function() {
  const saTri2 = new ExtendedTriangle();
  const arr1 = new Array(3);
  const arr2 = new Array(3);
  const cachedSatBounds = new SeparatingAxisBounds();
  const cachedSatBounds2 = new SeparatingAxisBounds();
  const cachedAxis = new Vector3$1();
  const dir = new Vector3$1();
  const dir1 = new Vector3$1();
  const dir2 = new Vector3$1();
  const tempDir = new Vector3$1();
  const edge = new Line3();
  const edge1 = new Line3();
  const edge2 = new Line3();
  const tempPoint = new Vector3$1();
  function triIntersectPlane(tri, plane, targetEdge) {
    const points = tri.points;
    let count = 0;
    let startPointIntersection = -1;
    for (let i2 = 0; i2 < 3; i2++) {
      const { start, end } = edge;
      start.copy(points[i2]);
      end.copy(points[(i2 + 1) % 3]);
      edge.delta(dir);
      const startIntersects = isNearZero(plane.distanceToPoint(start));
      if (isNearZero(plane.normal.dot(dir)) && startIntersects) {
        targetEdge.copy(edge);
        count = 2;
        break;
      }
      const doesIntersect = plane.intersectLine(edge, tempPoint);
      if (!doesIntersect && startIntersects) {
        tempPoint.copy(start);
      }
      if ((doesIntersect || startIntersects) && !isNearZero(tempPoint.distanceTo(end))) {
        if (count <= 1) {
          const point2 = count === 1 ? targetEdge.start : targetEdge.end;
          point2.copy(tempPoint);
          if (startIntersects) {
            startPointIntersection = count;
          }
        } else if (count >= 2) {
          const point2 = startPointIntersection === 1 ? targetEdge.start : targetEdge.end;
          point2.copy(tempPoint);
          count = 2;
          break;
        }
        count++;
        if (count === 2 && startPointIntersection === -1) {
          break;
        }
      }
    }
    return count;
  }
  return function intersectsTriangle(other, target = null, suppressLog = false) {
    if (this.needsUpdate) {
      this.update();
    }
    if (!other.isExtendedTriangle) {
      saTri2.copy(other);
      saTri2.update();
      other = saTri2;
    } else if (other.needsUpdate) {
      other.update();
    }
    const plane1 = this.plane;
    const plane2 = other.plane;
    if (Math.abs(plane1.normal.dot(plane2.normal)) > 1 - 1e-10) {
      const satBounds1 = this.satBounds;
      const satAxes1 = this.satAxes;
      arr2[0] = other.a;
      arr2[1] = other.b;
      arr2[2] = other.c;
      for (let i2 = 0; i2 < 4; i2++) {
        const sb = satBounds1[i2];
        const sa = satAxes1[i2];
        cachedSatBounds.setFromPoints(sa, arr2);
        if (sb.isSeparated(cachedSatBounds)) return false;
      }
      const satBounds2 = other.satBounds;
      const satAxes2 = other.satAxes;
      arr1[0] = this.a;
      arr1[1] = this.b;
      arr1[2] = this.c;
      for (let i2 = 0; i2 < 4; i2++) {
        const sb = satBounds2[i2];
        const sa = satAxes2[i2];
        cachedSatBounds.setFromPoints(sa, arr1);
        if (sb.isSeparated(cachedSatBounds)) return false;
      }
      for (let i2 = 0; i2 < 4; i2++) {
        const sa1 = satAxes1[i2];
        for (let i22 = 0; i22 < 4; i22++) {
          const sa2 = satAxes2[i22];
          cachedAxis.crossVectors(sa1, sa2);
          cachedSatBounds.setFromPoints(cachedAxis, arr1);
          cachedSatBounds2.setFromPoints(cachedAxis, arr2);
          if (cachedSatBounds.isSeparated(cachedSatBounds2)) return false;
        }
      }
      if (target) {
        if (!suppressLog) {
          console.warn("ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0.");
        }
        target.start.set(0, 0, 0);
        target.end.set(0, 0, 0);
      }
      return true;
    } else {
      const count1 = triIntersectPlane(this, plane2, edge1);
      if (count1 === 1 && other.containsPoint(edge1.end)) {
        if (target) {
          target.start.copy(edge1.end);
          target.end.copy(edge1.end);
        }
        return true;
      } else if (count1 !== 2) {
        return false;
      }
      const count2 = triIntersectPlane(other, plane1, edge2);
      if (count2 === 1 && this.containsPoint(edge2.end)) {
        if (target) {
          target.start.copy(edge2.end);
          target.end.copy(edge2.end);
        }
        return true;
      } else if (count2 !== 2) {
        return false;
      }
      edge1.delta(dir1);
      edge2.delta(dir2);
      if (dir1.dot(dir2) < 0) {
        let tmp2 = edge2.start;
        edge2.start = edge2.end;
        edge2.end = tmp2;
      }
      const s1 = edge1.start.dot(dir1);
      const e1 = edge1.end.dot(dir1);
      const s2 = edge2.start.dot(dir1);
      const e2 = edge2.end.dot(dir1);
      const separated1 = e1 < s2;
      const separated2 = s1 < e2;
      if (s1 !== e2 && s2 !== e1 && separated1 === separated2) {
        return false;
      }
      if (target) {
        tempDir.subVectors(edge1.start, edge2.start);
        if (tempDir.dot(dir1) > 0) {
          target.start.copy(edge1.start);
        } else {
          target.start.copy(edge2.start);
        }
        tempDir.subVectors(edge1.end, edge2.end);
        if (tempDir.dot(dir1) < 0) {
          target.end.copy(edge1.end);
        } else {
          target.end.copy(edge2.end);
        }
      }
      return true;
    }
  };
}();
ExtendedTriangle.prototype.distanceToPoint = function() {
  const target = new Vector3$1();
  return function distanceToPoint(point2) {
    this.closestPointToPoint(point2, target);
    return point2.distanceTo(target);
  };
}();
ExtendedTriangle.prototype.distanceToTriangle = function() {
  const point2 = new Vector3$1();
  const point22 = new Vector3$1();
  const cornerFields = ["a", "b", "c"];
  const line1 = new Line3();
  const line2 = new Line3();
  return function distanceToTriangle(other, target1 = null, target2 = null) {
    const lineTarget = target1 || target2 ? line1 : null;
    if (this.intersectsTriangle(other, lineTarget)) {
      if (target1 || target2) {
        if (target1) lineTarget.getCenter(target1);
        if (target2) lineTarget.getCenter(target2);
      }
      return 0;
    }
    let closestDistanceSq = Infinity;
    for (let i2 = 0; i2 < 3; i2++) {
      let dist;
      const field = cornerFields[i2];
      const otherVec = other[field];
      this.closestPointToPoint(otherVec, point2);
      dist = otherVec.distanceToSquared(point2);
      if (dist < closestDistanceSq) {
        closestDistanceSq = dist;
        if (target1) target1.copy(point2);
        if (target2) target2.copy(otherVec);
      }
      const thisVec = this[field];
      other.closestPointToPoint(thisVec, point2);
      dist = thisVec.distanceToSquared(point2);
      if (dist < closestDistanceSq) {
        closestDistanceSq = dist;
        if (target1) target1.copy(thisVec);
        if (target2) target2.copy(point2);
      }
    }
    for (let i2 = 0; i2 < 3; i2++) {
      const f11 = cornerFields[i2];
      const f12 = cornerFields[(i2 + 1) % 3];
      line1.set(this[f11], this[f12]);
      for (let i22 = 0; i22 < 3; i22++) {
        const f21 = cornerFields[i22];
        const f22 = cornerFields[(i22 + 1) % 3];
        line2.set(other[f21], other[f22]);
        closestPointsSegmentToSegment(line1, line2, point2, point22);
        const dist = point2.distanceToSquared(point22);
        if (dist < closestDistanceSq) {
          closestDistanceSq = dist;
          if (target1) target1.copy(point2);
          if (target2) target2.copy(point22);
        }
      }
    }
    return Math.sqrt(closestDistanceSq);
  };
}();
class OrientedBox {
  constructor(min, max2, matrix2) {
    this.isOrientedBox = true;
    this.min = new Vector3$1();
    this.max = new Vector3$1();
    this.matrix = new Matrix4$1();
    this.invMatrix = new Matrix4$1();
    this.points = new Array(8).fill().map(() => new Vector3$1());
    this.satAxes = new Array(3).fill().map(() => new Vector3$1());
    this.satBounds = new Array(3).fill().map(() => new SeparatingAxisBounds());
    this.alignedSatBounds = new Array(3).fill().map(() => new SeparatingAxisBounds());
    this.needsUpdate = false;
    if (min) this.min.copy(min);
    if (max2) this.max.copy(max2);
    if (matrix2) this.matrix.copy(matrix2);
  }
  set(min, max2, matrix2) {
    this.min.copy(min);
    this.max.copy(max2);
    this.matrix.copy(matrix2);
    this.needsUpdate = true;
  }
  copy(other) {
    this.min.copy(other.min);
    this.max.copy(other.max);
    this.matrix.copy(other.matrix);
    this.needsUpdate = true;
  }
}
OrientedBox.prototype.update = /* @__PURE__ */ function() {
  return function update() {
    const matrix2 = this.matrix;
    const min = this.min;
    const max2 = this.max;
    const points = this.points;
    for (let x = 0; x <= 1; x++) {
      for (let y = 0; y <= 1; y++) {
        for (let z2 = 0; z2 <= 1; z2++) {
          const i2 = (1 << 0) * x | (1 << 1) * y | (1 << 2) * z2;
          const v = points[i2];
          v.x = x ? max2.x : min.x;
          v.y = y ? max2.y : min.y;
          v.z = z2 ? max2.z : min.z;
          v.applyMatrix4(matrix2);
        }
      }
    }
    const satBounds = this.satBounds;
    const satAxes = this.satAxes;
    const minVec = points[0];
    for (let i2 = 0; i2 < 3; i2++) {
      const axis = satAxes[i2];
      const sb = satBounds[i2];
      const index2 = 1 << i2;
      const pi2 = points[index2];
      axis.subVectors(minVec, pi2);
      sb.setFromPoints(axis, points);
    }
    const alignedSatBounds = this.alignedSatBounds;
    alignedSatBounds[0].setFromPointsField(points, "x");
    alignedSatBounds[1].setFromPointsField(points, "y");
    alignedSatBounds[2].setFromPointsField(points, "z");
    this.invMatrix.copy(this.matrix).invert();
    this.needsUpdate = false;
  };
}();
OrientedBox.prototype.intersectsBox = function() {
  const aabbBounds = new SeparatingAxisBounds();
  return function intersectsBox(box) {
    if (this.needsUpdate) {
      this.update();
    }
    const min = box.min;
    const max2 = box.max;
    const satBounds = this.satBounds;
    const satAxes = this.satAxes;
    const alignedSatBounds = this.alignedSatBounds;
    aabbBounds.min = min.x;
    aabbBounds.max = max2.x;
    if (alignedSatBounds[0].isSeparated(aabbBounds)) return false;
    aabbBounds.min = min.y;
    aabbBounds.max = max2.y;
    if (alignedSatBounds[1].isSeparated(aabbBounds)) return false;
    aabbBounds.min = min.z;
    aabbBounds.max = max2.z;
    if (alignedSatBounds[2].isSeparated(aabbBounds)) return false;
    for (let i2 = 0; i2 < 3; i2++) {
      const axis = satAxes[i2];
      const sb = satBounds[i2];
      aabbBounds.setFromBox(axis, box);
      if (sb.isSeparated(aabbBounds)) return false;
    }
    return true;
  };
}();
OrientedBox.prototype.intersectsTriangle = function() {
  const saTri = new ExtendedTriangle();
  const pointsArr = new Array(3);
  const cachedSatBounds = new SeparatingAxisBounds();
  const cachedSatBounds2 = new SeparatingAxisBounds();
  const cachedAxis = new Vector3$1();
  return function intersectsTriangle(triangle3) {
    if (this.needsUpdate) {
      this.update();
    }
    if (!triangle3.isExtendedTriangle) {
      saTri.copy(triangle3);
      saTri.update();
      triangle3 = saTri;
    } else if (triangle3.needsUpdate) {
      triangle3.update();
    }
    const satBounds = this.satBounds;
    const satAxes = this.satAxes;
    pointsArr[0] = triangle3.a;
    pointsArr[1] = triangle3.b;
    pointsArr[2] = triangle3.c;
    for (let i2 = 0; i2 < 3; i2++) {
      const sb = satBounds[i2];
      const sa = satAxes[i2];
      cachedSatBounds.setFromPoints(sa, pointsArr);
      if (sb.isSeparated(cachedSatBounds)) return false;
    }
    const triSatBounds = triangle3.satBounds;
    const triSatAxes = triangle3.satAxes;
    const points = this.points;
    for (let i2 = 0; i2 < 3; i2++) {
      const sb = triSatBounds[i2];
      const sa = triSatAxes[i2];
      cachedSatBounds.setFromPoints(sa, points);
      if (sb.isSeparated(cachedSatBounds)) return false;
    }
    for (let i2 = 0; i2 < 3; i2++) {
      const sa1 = satAxes[i2];
      for (let i22 = 0; i22 < 4; i22++) {
        const sa2 = triSatAxes[i22];
        cachedAxis.crossVectors(sa1, sa2);
        cachedSatBounds.setFromPoints(cachedAxis, pointsArr);
        cachedSatBounds2.setFromPoints(cachedAxis, points);
        if (cachedSatBounds.isSeparated(cachedSatBounds2)) return false;
      }
    }
    return true;
  };
}();
OrientedBox.prototype.closestPointToPoint = /* @__PURE__ */ function() {
  return function closestPointToPoint2(point2, target1) {
    if (this.needsUpdate) {
      this.update();
    }
    target1.copy(point2).applyMatrix4(this.invMatrix).clamp(this.min, this.max).applyMatrix4(this.matrix);
    return target1;
  };
}();
OrientedBox.prototype.distanceToPoint = function() {
  const target = new Vector3$1();
  return function distanceToPoint(point2) {
    this.closestPointToPoint(point2, target);
    return point2.distanceTo(target);
  };
}();
OrientedBox.prototype.distanceToBox = function() {
  const xyzFields = ["x", "y", "z"];
  const segments1 = new Array(12).fill().map(() => new Line3());
  const segments2 = new Array(12).fill().map(() => new Line3());
  const point1 = new Vector3$1();
  const point2 = new Vector3$1();
  return function distanceToBox(box, threshold = 0, target1 = null, target2 = null) {
    if (this.needsUpdate) {
      this.update();
    }
    if (this.intersectsBox(box)) {
      if (target1 || target2) {
        box.getCenter(point2);
        this.closestPointToPoint(point2, point1);
        box.closestPointToPoint(point1, point2);
        if (target1) target1.copy(point1);
        if (target2) target2.copy(point2);
      }
      return 0;
    }
    const threshold2 = threshold * threshold;
    const min = box.min;
    const max2 = box.max;
    const points = this.points;
    let closestDistanceSq = Infinity;
    for (let i2 = 0; i2 < 8; i2++) {
      const p2 = points[i2];
      point2.copy(p2).clamp(min, max2);
      const dist = p2.distanceToSquared(point2);
      if (dist < closestDistanceSq) {
        closestDistanceSq = dist;
        if (target1) target1.copy(p2);
        if (target2) target2.copy(point2);
        if (dist < threshold2) return Math.sqrt(dist);
      }
    }
    let count = 0;
    for (let i2 = 0; i2 < 3; i2++) {
      for (let i1 = 0; i1 <= 1; i1++) {
        for (let i22 = 0; i22 <= 1; i22++) {
          const nextIndex = (i2 + 1) % 3;
          const nextIndex2 = (i2 + 2) % 3;
          const index2 = i1 << nextIndex | i22 << nextIndex2;
          const index22 = 1 << i2 | i1 << nextIndex | i22 << nextIndex2;
          const p1 = points[index2];
          const p2 = points[index22];
          const line1 = segments1[count];
          line1.set(p1, p2);
          const f1 = xyzFields[i2];
          const f2 = xyzFields[nextIndex];
          const f3 = xyzFields[nextIndex2];
          const line2 = segments2[count];
          const start = line2.start;
          const end = line2.end;
          start[f1] = min[f1];
          start[f2] = i1 ? min[f2] : max2[f2];
          start[f3] = i22 ? min[f3] : max2[f2];
          end[f1] = max2[f1];
          end[f2] = i1 ? min[f2] : max2[f2];
          end[f3] = i22 ? min[f3] : max2[f2];
          count++;
        }
      }
    }
    for (let x = 0; x <= 1; x++) {
      for (let y = 0; y <= 1; y++) {
        for (let z2 = 0; z2 <= 1; z2++) {
          point2.x = x ? max2.x : min.x;
          point2.y = y ? max2.y : min.y;
          point2.z = z2 ? max2.z : min.z;
          this.closestPointToPoint(point2, point1);
          const dist = point2.distanceToSquared(point1);
          if (dist < closestDistanceSq) {
            closestDistanceSq = dist;
            if (target1) target1.copy(point1);
            if (target2) target2.copy(point2);
            if (dist < threshold2) return Math.sqrt(dist);
          }
        }
      }
    }
    for (let i2 = 0; i2 < 12; i2++) {
      const l1 = segments1[i2];
      for (let i22 = 0; i22 < 12; i22++) {
        const l2 = segments2[i22];
        closestPointsSegmentToSegment(l1, l2, point1, point2);
        const dist = point1.distanceToSquared(point2);
        if (dist < closestDistanceSq) {
          closestDistanceSq = dist;
          if (target1) target1.copy(point1);
          if (target2) target2.copy(point2);
          if (dist < threshold2) return Math.sqrt(dist);
        }
      }
    }
    return Math.sqrt(closestDistanceSq);
  };
}();
class PrimitivePool {
  constructor(getNewPrimitive) {
    this._getNewPrimitive = getNewPrimitive;
    this._primitives = [];
  }
  getPrimitive() {
    const primitives = this._primitives;
    if (primitives.length === 0) {
      return this._getNewPrimitive();
    } else {
      return primitives.pop();
    }
  }
  releasePrimitive(primitive) {
    this._primitives.push(primitive);
  }
}
class ExtendedTrianglePoolBase extends PrimitivePool {
  constructor() {
    super(() => new ExtendedTriangle());
  }
}
const ExtendedTrianglePool = /* @__PURE__ */ new ExtendedTrianglePoolBase();
class _BufferStack {
  constructor() {
    this.float32Array = null;
    this.uint16Array = null;
    this.uint32Array = null;
    const stack = [];
    let prevBuffer = null;
    this.setBuffer = (buffer) => {
      if (prevBuffer) {
        stack.push(prevBuffer);
      }
      prevBuffer = buffer;
      this.float32Array = new Float32Array(buffer);
      this.uint16Array = new Uint16Array(buffer);
      this.uint32Array = new Uint32Array(buffer);
    };
    this.clearBuffer = () => {
      prevBuffer = null;
      this.float32Array = null;
      this.uint16Array = null;
      this.uint32Array = null;
      if (stack.length !== 0) {
        this.setBuffer(stack.pop());
      }
    };
  }
}
const BufferStack = new _BufferStack();
let _box1, _box2;
const boxStack = [];
const boxPool = /* @__PURE__ */ new PrimitivePool(() => new Box3$1());
function shapecast(bvh, root, intersectsBounds, intersectsRange, boundsTraverseOrder, byteOffset) {
  _box1 = boxPool.getPrimitive();
  _box2 = boxPool.getPrimitive();
  boxStack.push(_box1, _box2);
  BufferStack.setBuffer(bvh._roots[root]);
  const result = shapecastTraverse(0, bvh.geometry, intersectsBounds, intersectsRange, boundsTraverseOrder, byteOffset);
  BufferStack.clearBuffer();
  boxPool.releasePrimitive(_box1);
  boxPool.releasePrimitive(_box2);
  boxStack.pop();
  boxStack.pop();
  const length2 = boxStack.length;
  if (length2 > 0) {
    _box2 = boxStack[length2 - 1];
    _box1 = boxStack[length2 - 2];
  }
  return result;
}
function shapecastTraverse(nodeIndex32, geometry, intersectsBoundsFunc, intersectsRangeFunc, nodeScoreFunc = null, nodeIndexByteOffset = 0, depth = 0) {
  const { float32Array: float32Array2, uint16Array: uint16Array2, uint32Array: uint32Array2 } = BufferStack;
  let nodeIndex16 = nodeIndex32 * 2;
  const isLeaf = IS_LEAF(nodeIndex16, uint16Array2);
  if (isLeaf) {
    const offset = OFFSET(nodeIndex32, uint32Array2);
    const count = COUNT(nodeIndex16, uint16Array2);
    arrayToBox(BOUNDING_DATA_INDEX(nodeIndex32), float32Array2, _box1);
    return intersectsRangeFunc(offset, count, false, depth, nodeIndexByteOffset + nodeIndex32, _box1);
  } else {
    let getLeftOffset = function(nodeIndex322) {
      const { uint16Array: uint16Array3, uint32Array: uint32Array3 } = BufferStack;
      let nodeIndex162 = nodeIndex322 * 2;
      while (!IS_LEAF(nodeIndex162, uint16Array3)) {
        nodeIndex322 = LEFT_NODE(nodeIndex322);
        nodeIndex162 = nodeIndex322 * 2;
      }
      return OFFSET(nodeIndex322, uint32Array3);
    }, getRightEndOffset = function(nodeIndex322) {
      const { uint16Array: uint16Array3, uint32Array: uint32Array3 } = BufferStack;
      let nodeIndex162 = nodeIndex322 * 2;
      while (!IS_LEAF(nodeIndex162, uint16Array3)) {
        nodeIndex322 = RIGHT_NODE(nodeIndex322, uint32Array3);
        nodeIndex162 = nodeIndex322 * 2;
      }
      return OFFSET(nodeIndex322, uint32Array3) + COUNT(nodeIndex162, uint16Array3);
    };
    const left = LEFT_NODE(nodeIndex32);
    const right = RIGHT_NODE(nodeIndex32, uint32Array2);
    let c1 = left;
    let c2 = right;
    let score1, score2;
    let box1, box2;
    if (nodeScoreFunc) {
      box1 = _box1;
      box2 = _box2;
      arrayToBox(BOUNDING_DATA_INDEX(c1), float32Array2, box1);
      arrayToBox(BOUNDING_DATA_INDEX(c2), float32Array2, box2);
      score1 = nodeScoreFunc(box1);
      score2 = nodeScoreFunc(box2);
      if (score2 < score1) {
        c1 = right;
        c2 = left;
        const temp5 = score1;
        score1 = score2;
        score2 = temp5;
        box1 = box2;
      }
    }
    if (!box1) {
      box1 = _box1;
      arrayToBox(BOUNDING_DATA_INDEX(c1), float32Array2, box1);
    }
    const isC1Leaf = IS_LEAF(c1 * 2, uint16Array2);
    const c1Intersection = intersectsBoundsFunc(box1, isC1Leaf, score1, depth + 1, nodeIndexByteOffset + c1);
    let c1StopTraversal;
    if (c1Intersection === CONTAINED) {
      const offset = getLeftOffset(c1);
      const end = getRightEndOffset(c1);
      const count = end - offset;
      c1StopTraversal = intersectsRangeFunc(offset, count, true, depth + 1, nodeIndexByteOffset + c1, box1);
    } else {
      c1StopTraversal = c1Intersection && shapecastTraverse(
        c1,
        geometry,
        intersectsBoundsFunc,
        intersectsRangeFunc,
        nodeScoreFunc,
        nodeIndexByteOffset,
        depth + 1
      );
    }
    if (c1StopTraversal) return true;
    box2 = _box2;
    arrayToBox(BOUNDING_DATA_INDEX(c2), float32Array2, box2);
    const isC2Leaf = IS_LEAF(c2 * 2, uint16Array2);
    const c2Intersection = intersectsBoundsFunc(box2, isC2Leaf, score2, depth + 1, nodeIndexByteOffset + c2);
    let c2StopTraversal;
    if (c2Intersection === CONTAINED) {
      const offset = getLeftOffset(c2);
      const end = getRightEndOffset(c2);
      const count = end - offset;
      c2StopTraversal = intersectsRangeFunc(offset, count, true, depth + 1, nodeIndexByteOffset + c2, box2);
    } else {
      c2StopTraversal = c2Intersection && shapecastTraverse(
        c2,
        geometry,
        intersectsBoundsFunc,
        intersectsRangeFunc,
        nodeScoreFunc,
        nodeIndexByteOffset,
        depth + 1
      );
    }
    if (c2StopTraversal) return true;
    return false;
  }
}
const temp = /* @__PURE__ */ new Vector3$1();
const temp1$2 = /* @__PURE__ */ new Vector3$1();
function closestPointToPoint(bvh, point2, target = {}, minThreshold = 0, maxThreshold = Infinity) {
  const minThresholdSq = minThreshold * minThreshold;
  const maxThresholdSq = maxThreshold * maxThreshold;
  let closestDistanceSq = Infinity;
  let closestDistanceTriIndex = null;
  bvh.shapecast(
    {
      boundsTraverseOrder: (box) => {
        temp.copy(point2).clamp(box.min, box.max);
        return temp.distanceToSquared(point2);
      },
      intersectsBounds: (box, isLeaf, score) => {
        return score < closestDistanceSq && score < maxThresholdSq;
      },
      intersectsTriangle: (tri, triIndex) => {
        tri.closestPointToPoint(point2, temp);
        const distSq = point2.distanceToSquared(temp);
        if (distSq < closestDistanceSq) {
          temp1$2.copy(temp);
          closestDistanceSq = distSq;
          closestDistanceTriIndex = triIndex;
        }
        if (distSq < minThresholdSq) {
          return true;
        } else {
          return false;
        }
      }
    }
  );
  if (closestDistanceSq === Infinity) return null;
  const closestDistance = Math.sqrt(closestDistanceSq);
  if (!target.point) target.point = temp1$2.clone();
  else target.point.copy(temp1$2);
  target.distance = closestDistance, target.faceIndex = closestDistanceTriIndex;
  return target;
}
const IS_GT_REVISION_169 = parseInt(REVISION$1) >= 169;
const _vA$3 = /* @__PURE__ */ new Vector3$1();
const _vB$3 = /* @__PURE__ */ new Vector3$1();
const _vC$3 = /* @__PURE__ */ new Vector3$1();
const _uvA$2 = /* @__PURE__ */ new Vector2$1();
const _uvB$2 = /* @__PURE__ */ new Vector2$1();
const _uvC$2 = /* @__PURE__ */ new Vector2$1();
const _normalA = /* @__PURE__ */ new Vector3$1();
const _normalB = /* @__PURE__ */ new Vector3$1();
const _normalC = /* @__PURE__ */ new Vector3$1();
const _intersectionPoint$1 = /* @__PURE__ */ new Vector3$1();
function checkIntersection$1(ray2, pA, pB, pC, point2, side, near, far) {
  let intersect2;
  if (side === BackSide$1) {
    intersect2 = ray2.intersectTriangle(pC, pB, pA, true, point2);
  } else {
    intersect2 = ray2.intersectTriangle(pA, pB, pC, side !== DoubleSide$1, point2);
  }
  if (intersect2 === null) return null;
  const distance2 = ray2.origin.distanceTo(point2);
  if (distance2 < near || distance2 > far) return null;
  return {
    distance: distance2,
    point: point2.clone()
  };
}
function checkBufferGeometryIntersection$1(ray2, position2, normal, uv, uv1, a3, b, c2, side, near, far) {
  _vA$3.fromBufferAttribute(position2, a3);
  _vB$3.fromBufferAttribute(position2, b);
  _vC$3.fromBufferAttribute(position2, c2);
  const intersection = checkIntersection$1(ray2, _vA$3, _vB$3, _vC$3, _intersectionPoint$1, side, near, far);
  if (intersection) {
    const barycoord = new Vector3$1();
    Triangle$1.getBarycoord(_intersectionPoint$1, _vA$3, _vB$3, _vC$3, barycoord);
    if (uv) {
      _uvA$2.fromBufferAttribute(uv, a3);
      _uvB$2.fromBufferAttribute(uv, b);
      _uvC$2.fromBufferAttribute(uv, c2);
      intersection.uv = Triangle$1.getInterpolation(_intersectionPoint$1, _vA$3, _vB$3, _vC$3, _uvA$2, _uvB$2, _uvC$2, new Vector2$1());
    }
    if (uv1) {
      _uvA$2.fromBufferAttribute(uv1, a3);
      _uvB$2.fromBufferAttribute(uv1, b);
      _uvC$2.fromBufferAttribute(uv1, c2);
      intersection.uv1 = Triangle$1.getInterpolation(_intersectionPoint$1, _vA$3, _vB$3, _vC$3, _uvA$2, _uvB$2, _uvC$2, new Vector2$1());
    }
    if (normal) {
      _normalA.fromBufferAttribute(normal, a3);
      _normalB.fromBufferAttribute(normal, b);
      _normalC.fromBufferAttribute(normal, c2);
      intersection.normal = Triangle$1.getInterpolation(_intersectionPoint$1, _vA$3, _vB$3, _vC$3, _normalA, _normalB, _normalC, new Vector3$1());
      if (intersection.normal.dot(ray2.direction) > 0) {
        intersection.normal.multiplyScalar(-1);
      }
    }
    const face = {
      a: a3,
      b,
      c: c2,
      normal: new Vector3$1(),
      materialIndex: 0
    };
    Triangle$1.getNormal(_vA$3, _vB$3, _vC$3, face.normal);
    intersection.face = face;
    intersection.faceIndex = a3;
    if (IS_GT_REVISION_169) {
      intersection.barycoord = barycoord;
    }
  }
  return intersection;
}
function intersectTri(geo, side, ray2, tri, intersections, near, far) {
  const triOffset = tri * 3;
  let a3 = triOffset + 0;
  let b = triOffset + 1;
  let c2 = triOffset + 2;
  const index2 = geo.index;
  if (geo.index) {
    a3 = index2.getX(a3);
    b = index2.getX(b);
    c2 = index2.getX(c2);
  }
  const { position: position2, normal, uv, uv1 } = geo.attributes;
  const intersection = checkBufferGeometryIntersection$1(ray2, position2, normal, uv, uv1, a3, b, c2, side, near, far);
  if (intersection) {
    intersection.faceIndex = tri;
    if (intersections) intersections.push(intersection);
    return intersection;
  }
  return null;
}
function setTriangle(tri, i2, index2, pos) {
  const ta = tri.a;
  const tb = tri.b;
  const tc = tri.c;
  let i0 = i2;
  let i1 = i2 + 1;
  let i22 = i2 + 2;
  if (index2) {
    i0 = index2.getX(i0);
    i1 = index2.getX(i1);
    i22 = index2.getX(i22);
  }
  ta.x = pos.getX(i0);
  ta.y = pos.getY(i0);
  ta.z = pos.getZ(i0);
  tb.x = pos.getX(i1);
  tb.y = pos.getY(i1);
  tb.z = pos.getZ(i1);
  tc.x = pos.getX(i22);
  tc.y = pos.getY(i22);
  tc.z = pos.getZ(i22);
}
function intersectTris(bvh, side, ray2, offset, count, intersections, near, far) {
  const { geometry, _indirectBuffer } = bvh;
  for (let i2 = offset, end = offset + count; i2 < end; i2++) {
    intersectTri(geometry, side, ray2, i2, intersections, near, far);
  }
}
function intersectClosestTri(bvh, side, ray2, offset, count, near, far) {
  const { geometry, _indirectBuffer } = bvh;
  let dist = Infinity;
  let res = null;
  for (let i2 = offset, end = offset + count; i2 < end; i2++) {
    let intersection;
    intersection = intersectTri(geometry, side, ray2, i2, null, near, far);
    if (intersection && intersection.distance < dist) {
      res = intersection;
      dist = intersection.distance;
    }
  }
  return res;
}
function iterateOverTriangles(offset, count, bvh, intersectsTriangleFunc, contained, depth, triangle3) {
  const { geometry } = bvh;
  const { index: index2 } = geometry;
  const pos = geometry.attributes.position;
  for (let i2 = offset, l2 = count + offset; i2 < l2; i2++) {
    let tri;
    tri = i2;
    setTriangle(triangle3, tri * 3, index2, pos);
    triangle3.needsUpdate = true;
    if (intersectsTriangleFunc(triangle3, tri, contained, depth)) {
      return true;
    }
  }
  return false;
}
function refit(bvh, nodeIndices = null) {
  if (nodeIndices && Array.isArray(nodeIndices)) {
    nodeIndices = new Set(nodeIndices);
  }
  const geometry = bvh.geometry;
  const indexArr = geometry.index ? geometry.index.array : null;
  const posAttr = geometry.attributes.position;
  let buffer, uint32Array2, uint16Array2, float32Array2;
  let byteOffset = 0;
  const roots = bvh._roots;
  for (let i2 = 0, l2 = roots.length; i2 < l2; i2++) {
    buffer = roots[i2];
    uint32Array2 = new Uint32Array(buffer);
    uint16Array2 = new Uint16Array(buffer);
    float32Array2 = new Float32Array(buffer);
    _traverse2(0, byteOffset);
    byteOffset += buffer.byteLength;
  }
  function _traverse2(node32Index, byteOffset2, force = false) {
    const node16Index = node32Index * 2;
    const isLeaf = uint16Array2[node16Index + 15] === IS_LEAFNODE_FLAG;
    if (isLeaf) {
      const offset = uint32Array2[node32Index + 6];
      const count = uint16Array2[node16Index + 14];
      let minx = Infinity;
      let miny = Infinity;
      let minz = Infinity;
      let maxx = -Infinity;
      let maxy = -Infinity;
      let maxz = -Infinity;
      for (let i2 = 3 * offset, l2 = 3 * (offset + count); i2 < l2; i2++) {
        let index2 = indexArr[i2];
        const x = posAttr.getX(index2);
        const y = posAttr.getY(index2);
        const z2 = posAttr.getZ(index2);
        if (x < minx) minx = x;
        if (x > maxx) maxx = x;
        if (y < miny) miny = y;
        if (y > maxy) maxy = y;
        if (z2 < minz) minz = z2;
        if (z2 > maxz) maxz = z2;
      }
      if (float32Array2[node32Index + 0] !== minx || float32Array2[node32Index + 1] !== miny || float32Array2[node32Index + 2] !== minz || float32Array2[node32Index + 3] !== maxx || float32Array2[node32Index + 4] !== maxy || float32Array2[node32Index + 5] !== maxz) {
        float32Array2[node32Index + 0] = minx;
        float32Array2[node32Index + 1] = miny;
        float32Array2[node32Index + 2] = minz;
        float32Array2[node32Index + 3] = maxx;
        float32Array2[node32Index + 4] = maxy;
        float32Array2[node32Index + 5] = maxz;
        return true;
      } else {
        return false;
      }
    } else {
      const left = node32Index + 8;
      const right = uint32Array2[node32Index + 6];
      const offsetLeft = left + byteOffset2;
      const offsetRight = right + byteOffset2;
      let forceChildren = force;
      let includesLeft = false;
      let includesRight = false;
      if (nodeIndices) {
        if (!forceChildren) {
          includesLeft = nodeIndices.has(offsetLeft);
          includesRight = nodeIndices.has(offsetRight);
          forceChildren = !includesLeft && !includesRight;
        }
      } else {
        includesLeft = true;
        includesRight = true;
      }
      const traverseLeft = forceChildren || includesLeft;
      const traverseRight = forceChildren || includesRight;
      let leftChange = false;
      if (traverseLeft) {
        leftChange = _traverse2(left, byteOffset2, forceChildren);
      }
      let rightChange = false;
      if (traverseRight) {
        rightChange = _traverse2(right, byteOffset2, forceChildren);
      }
      const didChange = leftChange || rightChange;
      if (didChange) {
        for (let i2 = 0; i2 < 3; i2++) {
          const lefti = left + i2;
          const righti = right + i2;
          const minLeftValue = float32Array2[lefti];
          const maxLeftValue = float32Array2[lefti + 3];
          const minRightValue = float32Array2[righti];
          const maxRightValue = float32Array2[righti + 3];
          float32Array2[node32Index + i2] = minLeftValue < minRightValue ? minLeftValue : minRightValue;
          float32Array2[node32Index + i2 + 3] = maxLeftValue > maxRightValue ? maxLeftValue : maxRightValue;
        }
      }
      return didChange;
    }
  }
}
function intersectRay(nodeIndex32, array, ray2, near, far) {
  let tmin, tmax, tymin, tymax, tzmin, tzmax;
  const invdirx = 1 / ray2.direction.x, invdiry = 1 / ray2.direction.y, invdirz = 1 / ray2.direction.z;
  const ox = ray2.origin.x;
  const oy = ray2.origin.y;
  const oz = ray2.origin.z;
  let minx = array[nodeIndex32];
  let maxx = array[nodeIndex32 + 3];
  let miny = array[nodeIndex32 + 1];
  let maxy = array[nodeIndex32 + 3 + 1];
  let minz = array[nodeIndex32 + 2];
  let maxz = array[nodeIndex32 + 3 + 2];
  if (invdirx >= 0) {
    tmin = (minx - ox) * invdirx;
    tmax = (maxx - ox) * invdirx;
  } else {
    tmin = (maxx - ox) * invdirx;
    tmax = (minx - ox) * invdirx;
  }
  if (invdiry >= 0) {
    tymin = (miny - oy) * invdiry;
    tymax = (maxy - oy) * invdiry;
  } else {
    tymin = (maxy - oy) * invdiry;
    tymax = (miny - oy) * invdiry;
  }
  if (tmin > tymax || tymin > tmax) return false;
  if (tymin > tmin || isNaN(tmin)) tmin = tymin;
  if (tymax < tmax || isNaN(tmax)) tmax = tymax;
  if (invdirz >= 0) {
    tzmin = (minz - oz) * invdirz;
    tzmax = (maxz - oz) * invdirz;
  } else {
    tzmin = (maxz - oz) * invdirz;
    tzmax = (minz - oz) * invdirz;
  }
  if (tmin > tzmax || tzmin > tmax) return false;
  if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
  if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
  return tmin <= far && tmax >= near;
}
function intersectTris_indirect(bvh, side, ray2, offset, count, intersections, near, far) {
  const { geometry, _indirectBuffer } = bvh;
  for (let i2 = offset, end = offset + count; i2 < end; i2++) {
    let vi = _indirectBuffer ? _indirectBuffer[i2] : i2;
    intersectTri(geometry, side, ray2, vi, intersections, near, far);
  }
}
function intersectClosestTri_indirect(bvh, side, ray2, offset, count, near, far) {
  const { geometry, _indirectBuffer } = bvh;
  let dist = Infinity;
  let res = null;
  for (let i2 = offset, end = offset + count; i2 < end; i2++) {
    let intersection;
    intersection = intersectTri(geometry, side, ray2, _indirectBuffer ? _indirectBuffer[i2] : i2, null, near, far);
    if (intersection && intersection.distance < dist) {
      res = intersection;
      dist = intersection.distance;
    }
  }
  return res;
}
function iterateOverTriangles_indirect(offset, count, bvh, intersectsTriangleFunc, contained, depth, triangle3) {
  const { geometry } = bvh;
  const { index: index2 } = geometry;
  const pos = geometry.attributes.position;
  for (let i2 = offset, l2 = count + offset; i2 < l2; i2++) {
    let tri;
    tri = bvh.resolveTriangleIndex(i2);
    setTriangle(triangle3, tri * 3, index2, pos);
    triangle3.needsUpdate = true;
    if (intersectsTriangleFunc(triangle3, tri, contained, depth)) {
      return true;
    }
  }
  return false;
}
function raycast(bvh, root, side, ray2, intersects2, near, far) {
  BufferStack.setBuffer(bvh._roots[root]);
  _raycast$1(0, bvh, side, ray2, intersects2, near, far);
  BufferStack.clearBuffer();
}
function _raycast$1(nodeIndex32, bvh, side, ray2, intersects2, near, far) {
  const { float32Array: float32Array2, uint16Array: uint16Array2, uint32Array: uint32Array2 } = BufferStack;
  const nodeIndex16 = nodeIndex32 * 2;
  const isLeaf = IS_LEAF(nodeIndex16, uint16Array2);
  if (isLeaf) {
    const offset = OFFSET(nodeIndex32, uint32Array2);
    const count = COUNT(nodeIndex16, uint16Array2);
    intersectTris(bvh, side, ray2, offset, count, intersects2, near, far);
  } else {
    const leftIndex = LEFT_NODE(nodeIndex32);
    if (intersectRay(leftIndex, float32Array2, ray2, near, far)) {
      _raycast$1(leftIndex, bvh, side, ray2, intersects2, near, far);
    }
    const rightIndex = RIGHT_NODE(nodeIndex32, uint32Array2);
    if (intersectRay(rightIndex, float32Array2, ray2, near, far)) {
      _raycast$1(rightIndex, bvh, side, ray2, intersects2, near, far);
    }
  }
}
const _xyzFields$1 = ["x", "y", "z"];
function raycastFirst(bvh, root, side, ray2, near, far) {
  BufferStack.setBuffer(bvh._roots[root]);
  const result = _raycastFirst$1(0, bvh, side, ray2, near, far);
  BufferStack.clearBuffer();
  return result;
}
function _raycastFirst$1(nodeIndex32, bvh, side, ray2, near, far) {
  const { float32Array: float32Array2, uint16Array: uint16Array2, uint32Array: uint32Array2 } = BufferStack;
  let nodeIndex16 = nodeIndex32 * 2;
  const isLeaf = IS_LEAF(nodeIndex16, uint16Array2);
  if (isLeaf) {
    const offset = OFFSET(nodeIndex32, uint32Array2);
    const count = COUNT(nodeIndex16, uint16Array2);
    return intersectClosestTri(bvh, side, ray2, offset, count, near, far);
  } else {
    const splitAxis = SPLIT_AXIS(nodeIndex32, uint32Array2);
    const xyzAxis = _xyzFields$1[splitAxis];
    const rayDir = ray2.direction[xyzAxis];
    const leftToRight = rayDir >= 0;
    let c1, c2;
    if (leftToRight) {
      c1 = LEFT_NODE(nodeIndex32);
      c2 = RIGHT_NODE(nodeIndex32, uint32Array2);
    } else {
      c1 = RIGHT_NODE(nodeIndex32, uint32Array2);
      c2 = LEFT_NODE(nodeIndex32);
    }
    const c1Intersection = intersectRay(c1, float32Array2, ray2, near, far);
    const c1Result = c1Intersection ? _raycastFirst$1(c1, bvh, side, ray2, near, far) : null;
    if (c1Result) {
      const point2 = c1Result.point[xyzAxis];
      const isOutside = leftToRight ? point2 <= float32Array2[c2 + splitAxis] : (
        // min bounding data
        point2 >= float32Array2[c2 + splitAxis + 3]
      );
      if (isOutside) {
        return c1Result;
      }
    }
    const c2Intersection = intersectRay(c2, float32Array2, ray2, near, far);
    const c2Result = c2Intersection ? _raycastFirst$1(c2, bvh, side, ray2, near, far) : null;
    if (c1Result && c2Result) {
      return c1Result.distance <= c2Result.distance ? c1Result : c2Result;
    } else {
      return c1Result || c2Result || null;
    }
  }
}
const boundingBox$1 = /* @__PURE__ */ new Box3$1();
const triangle$1 = /* @__PURE__ */ new ExtendedTriangle();
const triangle2$1 = /* @__PURE__ */ new ExtendedTriangle();
const invertedMat$1 = /* @__PURE__ */ new Matrix4$1();
const obb$4 = /* @__PURE__ */ new OrientedBox();
const obb2$3 = /* @__PURE__ */ new OrientedBox();
function intersectsGeometry(bvh, root, otherGeometry, geometryToBvh) {
  BufferStack.setBuffer(bvh._roots[root]);
  const result = _intersectsGeometry$1(0, bvh, otherGeometry, geometryToBvh);
  BufferStack.clearBuffer();
  return result;
}
function _intersectsGeometry$1(nodeIndex32, bvh, otherGeometry, geometryToBvh, cachedObb = null) {
  const { float32Array: float32Array2, uint16Array: uint16Array2, uint32Array: uint32Array2 } = BufferStack;
  let nodeIndex16 = nodeIndex32 * 2;
  if (cachedObb === null) {
    if (!otherGeometry.boundingBox) {
      otherGeometry.computeBoundingBox();
    }
    obb$4.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
    cachedObb = obb$4;
  }
  const isLeaf = IS_LEAF(nodeIndex16, uint16Array2);
  if (isLeaf) {
    const thisGeometry = bvh.geometry;
    const thisIndex = thisGeometry.index;
    const thisPos = thisGeometry.attributes.position;
    const index2 = otherGeometry.index;
    const pos = otherGeometry.attributes.position;
    const offset = OFFSET(nodeIndex32, uint32Array2);
    const count = COUNT(nodeIndex16, uint16Array2);
    invertedMat$1.copy(geometryToBvh).invert();
    if (otherGeometry.boundsTree) {
      arrayToBox(BOUNDING_DATA_INDEX(nodeIndex32), float32Array2, obb2$3);
      obb2$3.matrix.copy(invertedMat$1);
      obb2$3.needsUpdate = true;
      const res = otherGeometry.boundsTree.shapecast({
        intersectsBounds: (box) => obb2$3.intersectsBox(box),
        intersectsTriangle: (tri) => {
          tri.a.applyMatrix4(geometryToBvh);
          tri.b.applyMatrix4(geometryToBvh);
          tri.c.applyMatrix4(geometryToBvh);
          tri.needsUpdate = true;
          for (let i2 = offset * 3, l2 = (count + offset) * 3; i2 < l2; i2 += 3) {
            setTriangle(triangle2$1, i2, thisIndex, thisPos);
            triangle2$1.needsUpdate = true;
            if (tri.intersectsTriangle(triangle2$1)) {
              return true;
            }
          }
          return false;
        }
      });
      return res;
    } else {
      for (let i2 = offset * 3, l2 = (count + offset) * 3; i2 < l2; i2 += 3) {
        setTriangle(triangle$1, i2, thisIndex, thisPos);
        triangle$1.a.applyMatrix4(invertedMat$1);
        triangle$1.b.applyMatrix4(invertedMat$1);
        triangle$1.c.applyMatrix4(invertedMat$1);
        triangle$1.needsUpdate = true;
        for (let i22 = 0, l22 = index2.count; i22 < l22; i22 += 3) {
          setTriangle(triangle2$1, i22, index2, pos);
          triangle2$1.needsUpdate = true;
          if (triangle$1.intersectsTriangle(triangle2$1)) {
            return true;
          }
        }
      }
    }
  } else {
    const left = nodeIndex32 + 8;
    const right = uint32Array2[nodeIndex32 + 6];
    arrayToBox(BOUNDING_DATA_INDEX(left), float32Array2, boundingBox$1);
    const leftIntersection = cachedObb.intersectsBox(boundingBox$1) && _intersectsGeometry$1(left, bvh, otherGeometry, geometryToBvh, cachedObb);
    if (leftIntersection) return true;
    arrayToBox(BOUNDING_DATA_INDEX(right), float32Array2, boundingBox$1);
    const rightIntersection = cachedObb.intersectsBox(boundingBox$1) && _intersectsGeometry$1(right, bvh, otherGeometry, geometryToBvh, cachedObb);
    if (rightIntersection) return true;
    return false;
  }
}
const tempMatrix$1 = /* @__PURE__ */ new Matrix4$1();
const obb$3 = /* @__PURE__ */ new OrientedBox();
const obb2$2 = /* @__PURE__ */ new OrientedBox();
const temp1$1 = /* @__PURE__ */ new Vector3$1();
const temp2$1 = /* @__PURE__ */ new Vector3$1();
const temp3$1 = /* @__PURE__ */ new Vector3$1();
const temp4$1 = /* @__PURE__ */ new Vector3$1();
function closestPointToGeometry(bvh, otherGeometry, geometryToBvh, target1 = {}, target2 = {}, minThreshold = 0, maxThreshold = Infinity) {
  if (!otherGeometry.boundingBox) {
    otherGeometry.computeBoundingBox();
  }
  obb$3.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
  obb$3.needsUpdate = true;
  const geometry = bvh.geometry;
  const pos = geometry.attributes.position;
  const index2 = geometry.index;
  const otherPos = otherGeometry.attributes.position;
  const otherIndex = otherGeometry.index;
  const triangle3 = ExtendedTrianglePool.getPrimitive();
  const triangle22 = ExtendedTrianglePool.getPrimitive();
  let tempTarget1 = temp1$1;
  let tempTargetDest1 = temp2$1;
  let tempTarget2 = null;
  let tempTargetDest2 = null;
  if (target2) {
    tempTarget2 = temp3$1;
    tempTargetDest2 = temp4$1;
  }
  let closestDistance = Infinity;
  let closestDistanceTriIndex = null;
  let closestDistanceOtherTriIndex = null;
  tempMatrix$1.copy(geometryToBvh).invert();
  obb2$2.matrix.copy(tempMatrix$1);
  bvh.shapecast(
    {
      boundsTraverseOrder: (box) => {
        return obb$3.distanceToBox(box);
      },
      intersectsBounds: (box, isLeaf, score) => {
        if (score < closestDistance && score < maxThreshold) {
          if (isLeaf) {
            obb2$2.min.copy(box.min);
            obb2$2.max.copy(box.max);
            obb2$2.needsUpdate = true;
          }
          return true;
        }
        return false;
      },
      intersectsRange: (offset, count) => {
        if (otherGeometry.boundsTree) {
          const otherBvh = otherGeometry.boundsTree;
          return otherBvh.shapecast({
            boundsTraverseOrder: (box) => {
              return obb2$2.distanceToBox(box);
            },
            intersectsBounds: (box, isLeaf, score) => {
              return score < closestDistance && score < maxThreshold;
            },
            intersectsRange: (otherOffset, otherCount) => {
              for (let i2 = otherOffset, l2 = otherOffset + otherCount; i2 < l2; i2++) {
                setTriangle(triangle22, 3 * i2, otherIndex, otherPos);
                triangle22.a.applyMatrix4(geometryToBvh);
                triangle22.b.applyMatrix4(geometryToBvh);
                triangle22.c.applyMatrix4(geometryToBvh);
                triangle22.needsUpdate = true;
                for (let i3 = offset, l3 = offset + count; i3 < l3; i3++) {
                  setTriangle(triangle3, 3 * i3, index2, pos);
                  triangle3.needsUpdate = true;
                  const dist = triangle3.distanceToTriangle(triangle22, tempTarget1, tempTarget2);
                  if (dist < closestDistance) {
                    tempTargetDest1.copy(tempTarget1);
                    if (tempTargetDest2) {
                      tempTargetDest2.copy(tempTarget2);
                    }
                    closestDistance = dist;
                    closestDistanceTriIndex = i3;
                    closestDistanceOtherTriIndex = i2;
                  }
                  if (dist < minThreshold) {
                    return true;
                  }
                }
              }
            }
          });
        } else {
          const triCount = getTriCount(otherGeometry);
          for (let i2 = 0, l2 = triCount; i2 < l2; i2++) {
            setTriangle(triangle22, 3 * i2, otherIndex, otherPos);
            triangle22.a.applyMatrix4(geometryToBvh);
            triangle22.b.applyMatrix4(geometryToBvh);
            triangle22.c.applyMatrix4(geometryToBvh);
            triangle22.needsUpdate = true;
            for (let i3 = offset, l3 = offset + count; i3 < l3; i3++) {
              setTriangle(triangle3, 3 * i3, index2, pos);
              triangle3.needsUpdate = true;
              const dist = triangle3.distanceToTriangle(triangle22, tempTarget1, tempTarget2);
              if (dist < closestDistance) {
                tempTargetDest1.copy(tempTarget1);
                if (tempTargetDest2) {
                  tempTargetDest2.copy(tempTarget2);
                }
                closestDistance = dist;
                closestDistanceTriIndex = i3;
                closestDistanceOtherTriIndex = i2;
              }
              if (dist < minThreshold) {
                return true;
              }
            }
          }
        }
      }
    }
  );
  ExtendedTrianglePool.releasePrimitive(triangle3);
  ExtendedTrianglePool.releasePrimitive(triangle22);
  if (closestDistance === Infinity) {
    return null;
  }
  if (!target1.point) {
    target1.point = tempTargetDest1.clone();
  } else {
    target1.point.copy(tempTargetDest1);
  }
  target1.distance = closestDistance, target1.faceIndex = closestDistanceTriIndex;
  if (target2) {
    if (!target2.point) target2.point = tempTargetDest2.clone();
    else target2.point.copy(tempTargetDest2);
    target2.point.applyMatrix4(tempMatrix$1);
    tempTargetDest1.applyMatrix4(tempMatrix$1);
    target2.distance = tempTargetDest1.sub(target2.point).length();
    target2.faceIndex = closestDistanceOtherTriIndex;
  }
  return target1;
}
function refit_indirect(bvh, nodeIndices = null) {
  if (nodeIndices && Array.isArray(nodeIndices)) {
    nodeIndices = new Set(nodeIndices);
  }
  const geometry = bvh.geometry;
  const indexArr = geometry.index ? geometry.index.array : null;
  const posAttr = geometry.attributes.position;
  let buffer, uint32Array2, uint16Array2, float32Array2;
  let byteOffset = 0;
  const roots = bvh._roots;
  for (let i2 = 0, l2 = roots.length; i2 < l2; i2++) {
    buffer = roots[i2];
    uint32Array2 = new Uint32Array(buffer);
    uint16Array2 = new Uint16Array(buffer);
    float32Array2 = new Float32Array(buffer);
    _traverse2(0, byteOffset);
    byteOffset += buffer.byteLength;
  }
  function _traverse2(node32Index, byteOffset2, force = false) {
    const node16Index = node32Index * 2;
    const isLeaf = uint16Array2[node16Index + 15] === IS_LEAFNODE_FLAG;
    if (isLeaf) {
      const offset = uint32Array2[node32Index + 6];
      const count = uint16Array2[node16Index + 14];
      let minx = Infinity;
      let miny = Infinity;
      let minz = Infinity;
      let maxx = -Infinity;
      let maxy = -Infinity;
      let maxz = -Infinity;
      for (let i2 = offset, l2 = offset + count; i2 < l2; i2++) {
        const t3 = 3 * bvh.resolveTriangleIndex(i2);
        for (let j = 0; j < 3; j++) {
          let index2 = t3 + j;
          index2 = indexArr ? indexArr[index2] : index2;
          const x = posAttr.getX(index2);
          const y = posAttr.getY(index2);
          const z2 = posAttr.getZ(index2);
          if (x < minx) minx = x;
          if (x > maxx) maxx = x;
          if (y < miny) miny = y;
          if (y > maxy) maxy = y;
          if (z2 < minz) minz = z2;
          if (z2 > maxz) maxz = z2;
        }
      }
      if (float32Array2[node32Index + 0] !== minx || float32Array2[node32Index + 1] !== miny || float32Array2[node32Index + 2] !== minz || float32Array2[node32Index + 3] !== maxx || float32Array2[node32Index + 4] !== maxy || float32Array2[node32Index + 5] !== maxz) {
        float32Array2[node32Index + 0] = minx;
        float32Array2[node32Index + 1] = miny;
        float32Array2[node32Index + 2] = minz;
        float32Array2[node32Index + 3] = maxx;
        float32Array2[node32Index + 4] = maxy;
        float32Array2[node32Index + 5] = maxz;
        return true;
      } else {
        return false;
      }
    } else {
      const left = node32Index + 8;
      const right = uint32Array2[node32Index + 6];
      const offsetLeft = left + byteOffset2;
      const offsetRight = right + byteOffset2;
      let forceChildren = force;
      let includesLeft = false;
      let includesRight = false;
      if (nodeIndices) {
        if (!forceChildren) {
          includesLeft = nodeIndices.has(offsetLeft);
          includesRight = nodeIndices.has(offsetRight);
          forceChildren = !includesLeft && !includesRight;
        }
      } else {
        includesLeft = true;
        includesRight = true;
      }
      const traverseLeft = forceChildren || includesLeft;
      const traverseRight = forceChildren || includesRight;
      let leftChange = false;
      if (traverseLeft) {
        leftChange = _traverse2(left, byteOffset2, forceChildren);
      }
      let rightChange = false;
      if (traverseRight) {
        rightChange = _traverse2(right, byteOffset2, forceChildren);
      }
      const didChange = leftChange || rightChange;
      if (didChange) {
        for (let i2 = 0; i2 < 3; i2++) {
          const lefti = left + i2;
          const righti = right + i2;
          const minLeftValue = float32Array2[lefti];
          const maxLeftValue = float32Array2[lefti + 3];
          const minRightValue = float32Array2[righti];
          const maxRightValue = float32Array2[righti + 3];
          float32Array2[node32Index + i2] = minLeftValue < minRightValue ? minLeftValue : minRightValue;
          float32Array2[node32Index + i2 + 3] = maxLeftValue > maxRightValue ? maxLeftValue : maxRightValue;
        }
      }
      return didChange;
    }
  }
}
function raycast_indirect(bvh, root, side, ray2, intersects2, near, far) {
  BufferStack.setBuffer(bvh._roots[root]);
  _raycast(0, bvh, side, ray2, intersects2, near, far);
  BufferStack.clearBuffer();
}
function _raycast(nodeIndex32, bvh, side, ray2, intersects2, near, far) {
  const { float32Array: float32Array2, uint16Array: uint16Array2, uint32Array: uint32Array2 } = BufferStack;
  const nodeIndex16 = nodeIndex32 * 2;
  const isLeaf = IS_LEAF(nodeIndex16, uint16Array2);
  if (isLeaf) {
    const offset = OFFSET(nodeIndex32, uint32Array2);
    const count = COUNT(nodeIndex16, uint16Array2);
    intersectTris_indirect(bvh, side, ray2, offset, count, intersects2, near, far);
  } else {
    const leftIndex = LEFT_NODE(nodeIndex32);
    if (intersectRay(leftIndex, float32Array2, ray2, near, far)) {
      _raycast(leftIndex, bvh, side, ray2, intersects2, near, far);
    }
    const rightIndex = RIGHT_NODE(nodeIndex32, uint32Array2);
    if (intersectRay(rightIndex, float32Array2, ray2, near, far)) {
      _raycast(rightIndex, bvh, side, ray2, intersects2, near, far);
    }
  }
}
const _xyzFields = ["x", "y", "z"];
function raycastFirst_indirect(bvh, root, side, ray2, near, far) {
  BufferStack.setBuffer(bvh._roots[root]);
  const result = _raycastFirst(0, bvh, side, ray2, near, far);
  BufferStack.clearBuffer();
  return result;
}
function _raycastFirst(nodeIndex32, bvh, side, ray2, near, far) {
  const { float32Array: float32Array2, uint16Array: uint16Array2, uint32Array: uint32Array2 } = BufferStack;
  let nodeIndex16 = nodeIndex32 * 2;
  const isLeaf = IS_LEAF(nodeIndex16, uint16Array2);
  if (isLeaf) {
    const offset = OFFSET(nodeIndex32, uint32Array2);
    const count = COUNT(nodeIndex16, uint16Array2);
    return intersectClosestTri_indirect(bvh, side, ray2, offset, count, near, far);
  } else {
    const splitAxis = SPLIT_AXIS(nodeIndex32, uint32Array2);
    const xyzAxis = _xyzFields[splitAxis];
    const rayDir = ray2.direction[xyzAxis];
    const leftToRight = rayDir >= 0;
    let c1, c2;
    if (leftToRight) {
      c1 = LEFT_NODE(nodeIndex32);
      c2 = RIGHT_NODE(nodeIndex32, uint32Array2);
    } else {
      c1 = RIGHT_NODE(nodeIndex32, uint32Array2);
      c2 = LEFT_NODE(nodeIndex32);
    }
    const c1Intersection = intersectRay(c1, float32Array2, ray2, near, far);
    const c1Result = c1Intersection ? _raycastFirst(c1, bvh, side, ray2, near, far) : null;
    if (c1Result) {
      const point2 = c1Result.point[xyzAxis];
      const isOutside = leftToRight ? point2 <= float32Array2[c2 + splitAxis] : (
        // min bounding data
        point2 >= float32Array2[c2 + splitAxis + 3]
      );
      if (isOutside) {
        return c1Result;
      }
    }
    const c2Intersection = intersectRay(c2, float32Array2, ray2, near, far);
    const c2Result = c2Intersection ? _raycastFirst(c2, bvh, side, ray2, near, far) : null;
    if (c1Result && c2Result) {
      return c1Result.distance <= c2Result.distance ? c1Result : c2Result;
    } else {
      return c1Result || c2Result || null;
    }
  }
}
const boundingBox = /* @__PURE__ */ new Box3$1();
const triangle = /* @__PURE__ */ new ExtendedTriangle();
const triangle2 = /* @__PURE__ */ new ExtendedTriangle();
const invertedMat = /* @__PURE__ */ new Matrix4$1();
const obb$2 = /* @__PURE__ */ new OrientedBox();
const obb2$1 = /* @__PURE__ */ new OrientedBox();
function intersectsGeometry_indirect(bvh, root, otherGeometry, geometryToBvh) {
  BufferStack.setBuffer(bvh._roots[root]);
  const result = _intersectsGeometry(0, bvh, otherGeometry, geometryToBvh);
  BufferStack.clearBuffer();
  return result;
}
function _intersectsGeometry(nodeIndex32, bvh, otherGeometry, geometryToBvh, cachedObb = null) {
  const { float32Array: float32Array2, uint16Array: uint16Array2, uint32Array: uint32Array2 } = BufferStack;
  let nodeIndex16 = nodeIndex32 * 2;
  if (cachedObb === null) {
    if (!otherGeometry.boundingBox) {
      otherGeometry.computeBoundingBox();
    }
    obb$2.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
    cachedObb = obb$2;
  }
  const isLeaf = IS_LEAF(nodeIndex16, uint16Array2);
  if (isLeaf) {
    const thisGeometry = bvh.geometry;
    const thisIndex = thisGeometry.index;
    const thisPos = thisGeometry.attributes.position;
    const index2 = otherGeometry.index;
    const pos = otherGeometry.attributes.position;
    const offset = OFFSET(nodeIndex32, uint32Array2);
    const count = COUNT(nodeIndex16, uint16Array2);
    invertedMat.copy(geometryToBvh).invert();
    if (otherGeometry.boundsTree) {
      arrayToBox(BOUNDING_DATA_INDEX(nodeIndex32), float32Array2, obb2$1);
      obb2$1.matrix.copy(invertedMat);
      obb2$1.needsUpdate = true;
      const res = otherGeometry.boundsTree.shapecast({
        intersectsBounds: (box) => obb2$1.intersectsBox(box),
        intersectsTriangle: (tri) => {
          tri.a.applyMatrix4(geometryToBvh);
          tri.b.applyMatrix4(geometryToBvh);
          tri.c.applyMatrix4(geometryToBvh);
          tri.needsUpdate = true;
          for (let i2 = offset, l2 = count + offset; i2 < l2; i2++) {
            setTriangle(triangle2, 3 * bvh.resolveTriangleIndex(i2), thisIndex, thisPos);
            triangle2.needsUpdate = true;
            if (tri.intersectsTriangle(triangle2)) {
              return true;
            }
          }
          return false;
        }
      });
      return res;
    } else {
      for (let i2 = offset, l2 = count + offset; i2 < l2; i2++) {
        const ti2 = bvh.resolveTriangleIndex(i2);
        setTriangle(triangle, 3 * ti2, thisIndex, thisPos);
        triangle.a.applyMatrix4(invertedMat);
        triangle.b.applyMatrix4(invertedMat);
        triangle.c.applyMatrix4(invertedMat);
        triangle.needsUpdate = true;
        for (let i22 = 0, l22 = index2.count; i22 < l22; i22 += 3) {
          setTriangle(triangle2, i22, index2, pos);
          triangle2.needsUpdate = true;
          if (triangle.intersectsTriangle(triangle2)) {
            return true;
          }
        }
      }
    }
  } else {
    const left = nodeIndex32 + 8;
    const right = uint32Array2[nodeIndex32 + 6];
    arrayToBox(BOUNDING_DATA_INDEX(left), float32Array2, boundingBox);
    const leftIntersection = cachedObb.intersectsBox(boundingBox) && _intersectsGeometry(left, bvh, otherGeometry, geometryToBvh, cachedObb);
    if (leftIntersection) return true;
    arrayToBox(BOUNDING_DATA_INDEX(right), float32Array2, boundingBox);
    const rightIntersection = cachedObb.intersectsBox(boundingBox) && _intersectsGeometry(right, bvh, otherGeometry, geometryToBvh, cachedObb);
    if (rightIntersection) return true;
    return false;
  }
}
const tempMatrix = /* @__PURE__ */ new Matrix4$1();
const obb$1 = /* @__PURE__ */ new OrientedBox();
const obb2 = /* @__PURE__ */ new OrientedBox();
const temp1 = /* @__PURE__ */ new Vector3$1();
const temp2 = /* @__PURE__ */ new Vector3$1();
const temp3 = /* @__PURE__ */ new Vector3$1();
const temp4 = /* @__PURE__ */ new Vector3$1();
function closestPointToGeometry_indirect(bvh, otherGeometry, geometryToBvh, target1 = {}, target2 = {}, minThreshold = 0, maxThreshold = Infinity) {
  if (!otherGeometry.boundingBox) {
    otherGeometry.computeBoundingBox();
  }
  obb$1.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
  obb$1.needsUpdate = true;
  const geometry = bvh.geometry;
  const pos = geometry.attributes.position;
  const index2 = geometry.index;
  const otherPos = otherGeometry.attributes.position;
  const otherIndex = otherGeometry.index;
  const triangle3 = ExtendedTrianglePool.getPrimitive();
  const triangle22 = ExtendedTrianglePool.getPrimitive();
  let tempTarget1 = temp1;
  let tempTargetDest1 = temp2;
  let tempTarget2 = null;
  let tempTargetDest2 = null;
  if (target2) {
    tempTarget2 = temp3;
    tempTargetDest2 = temp4;
  }
  let closestDistance = Infinity;
  let closestDistanceTriIndex = null;
  let closestDistanceOtherTriIndex = null;
  tempMatrix.copy(geometryToBvh).invert();
  obb2.matrix.copy(tempMatrix);
  bvh.shapecast(
    {
      boundsTraverseOrder: (box) => {
        return obb$1.distanceToBox(box);
      },
      intersectsBounds: (box, isLeaf, score) => {
        if (score < closestDistance && score < maxThreshold) {
          if (isLeaf) {
            obb2.min.copy(box.min);
            obb2.max.copy(box.max);
            obb2.needsUpdate = true;
          }
          return true;
        }
        return false;
      },
      intersectsRange: (offset, count) => {
        if (otherGeometry.boundsTree) {
          const otherBvh = otherGeometry.boundsTree;
          return otherBvh.shapecast({
            boundsTraverseOrder: (box) => {
              return obb2.distanceToBox(box);
            },
            intersectsBounds: (box, isLeaf, score) => {
              return score < closestDistance && score < maxThreshold;
            },
            intersectsRange: (otherOffset, otherCount) => {
              for (let i2 = otherOffset, l2 = otherOffset + otherCount; i2 < l2; i2++) {
                const ti2 = otherBvh.resolveTriangleIndex(i2);
                setTriangle(triangle22, 3 * ti2, otherIndex, otherPos);
                triangle22.a.applyMatrix4(geometryToBvh);
                triangle22.b.applyMatrix4(geometryToBvh);
                triangle22.c.applyMatrix4(geometryToBvh);
                triangle22.needsUpdate = true;
                for (let i3 = offset, l3 = offset + count; i3 < l3; i3++) {
                  const ti3 = bvh.resolveTriangleIndex(i3);
                  setTriangle(triangle3, 3 * ti3, index2, pos);
                  triangle3.needsUpdate = true;
                  const dist = triangle3.distanceToTriangle(triangle22, tempTarget1, tempTarget2);
                  if (dist < closestDistance) {
                    tempTargetDest1.copy(tempTarget1);
                    if (tempTargetDest2) {
                      tempTargetDest2.copy(tempTarget2);
                    }
                    closestDistance = dist;
                    closestDistanceTriIndex = i3;
                    closestDistanceOtherTriIndex = i2;
                  }
                  if (dist < minThreshold) {
                    return true;
                  }
                }
              }
            }
          });
        } else {
          const triCount = getTriCount(otherGeometry);
          for (let i2 = 0, l2 = triCount; i2 < l2; i2++) {
            setTriangle(triangle22, 3 * i2, otherIndex, otherPos);
            triangle22.a.applyMatrix4(geometryToBvh);
            triangle22.b.applyMatrix4(geometryToBvh);
            triangle22.c.applyMatrix4(geometryToBvh);
            triangle22.needsUpdate = true;
            for (let i3 = offset, l3 = offset + count; i3 < l3; i3++) {
              const ti2 = bvh.resolveTriangleIndex(i3);
              setTriangle(triangle3, 3 * ti2, index2, pos);
              triangle3.needsUpdate = true;
              const dist = triangle3.distanceToTriangle(triangle22, tempTarget1, tempTarget2);
              if (dist < closestDistance) {
                tempTargetDest1.copy(tempTarget1);
                if (tempTargetDest2) {
                  tempTargetDest2.copy(tempTarget2);
                }
                closestDistance = dist;
                closestDistanceTriIndex = i3;
                closestDistanceOtherTriIndex = i2;
              }
              if (dist < minThreshold) {
                return true;
              }
            }
          }
        }
      }
    }
  );
  ExtendedTrianglePool.releasePrimitive(triangle3);
  ExtendedTrianglePool.releasePrimitive(triangle22);
  if (closestDistance === Infinity) {
    return null;
  }
  if (!target1.point) {
    target1.point = tempTargetDest1.clone();
  } else {
    target1.point.copy(tempTargetDest1);
  }
  target1.distance = closestDistance, target1.faceIndex = closestDistanceTriIndex;
  if (target2) {
    if (!target2.point) target2.point = tempTargetDest2.clone();
    else target2.point.copy(tempTargetDest2);
    target2.point.applyMatrix4(tempMatrix);
    tempTargetDest1.applyMatrix4(tempMatrix);
    target2.distance = tempTargetDest1.sub(target2.point).length();
    target2.faceIndex = closestDistanceOtherTriIndex;
  }
  return target1;
}
function isSharedArrayBufferSupported() {
  return typeof SharedArrayBuffer !== "undefined";
}
const _bufferStack1 = new BufferStack.constructor();
const _bufferStack2 = new BufferStack.constructor();
const _boxPool = new PrimitivePool(() => new Box3$1());
const _leftBox1 = new Box3$1();
const _rightBox1 = new Box3$1();
const _leftBox2 = new Box3$1();
const _rightBox2 = new Box3$1();
let _active = false;
function bvhcast(bvh, otherBvh, matrixToLocal, intersectsRanges) {
  if (_active) {
    throw new Error("MeshBVH: Recursive calls to bvhcast not supported.");
  }
  _active = true;
  const roots = bvh._roots;
  const otherRoots = otherBvh._roots;
  let result;
  let offset1 = 0;
  let offset2 = 0;
  const invMat = new Matrix4$1().copy(matrixToLocal).invert();
  for (let i2 = 0, il = roots.length; i2 < il; i2++) {
    _bufferStack1.setBuffer(roots[i2]);
    offset2 = 0;
    const localBox = _boxPool.getPrimitive();
    arrayToBox(BOUNDING_DATA_INDEX(0), _bufferStack1.float32Array, localBox);
    localBox.applyMatrix4(invMat);
    for (let j = 0, jl = otherRoots.length; j < jl; j++) {
      _bufferStack2.setBuffer(otherRoots[j]);
      result = _traverse(
        0,
        0,
        matrixToLocal,
        invMat,
        intersectsRanges,
        offset1,
        offset2,
        0,
        0,
        localBox
      );
      _bufferStack2.clearBuffer();
      offset2 += otherRoots[j].length;
      if (result) {
        break;
      }
    }
    _boxPool.releasePrimitive(localBox);
    _bufferStack1.clearBuffer();
    offset1 += roots[i2].length;
    if (result) {
      break;
    }
  }
  _active = false;
  return result;
}
function _traverse(node1Index32, node2Index32, matrix2to1, matrix1to2, intersectsRangesFunc, node1IndexByteOffset = 0, node2IndexByteOffset = 0, depth1 = 0, depth2 = 0, currBox = null, reversed = false) {
  let bufferStack1, bufferStack2;
  if (reversed) {
    bufferStack1 = _bufferStack2;
    bufferStack2 = _bufferStack1;
  } else {
    bufferStack1 = _bufferStack1;
    bufferStack2 = _bufferStack2;
  }
  const float32Array1 = bufferStack1.float32Array, uint32Array1 = bufferStack1.uint32Array, uint16Array1 = bufferStack1.uint16Array, float32Array2 = bufferStack2.float32Array, uint32Array2 = bufferStack2.uint32Array, uint16Array2 = bufferStack2.uint16Array;
  const node1Index16 = node1Index32 * 2;
  const node2Index16 = node2Index32 * 2;
  const isLeaf1 = IS_LEAF(node1Index16, uint16Array1);
  const isLeaf2 = IS_LEAF(node2Index16, uint16Array2);
  let result = false;
  if (isLeaf2 && isLeaf1) {
    if (reversed) {
      result = intersectsRangesFunc(
        OFFSET(node2Index32, uint32Array2),
        COUNT(node2Index32 * 2, uint16Array2),
        OFFSET(node1Index32, uint32Array1),
        COUNT(node1Index32 * 2, uint16Array1),
        depth2,
        node2IndexByteOffset + node2Index32,
        depth1,
        node1IndexByteOffset + node1Index32
      );
    } else {
      result = intersectsRangesFunc(
        OFFSET(node1Index32, uint32Array1),
        COUNT(node1Index32 * 2, uint16Array1),
        OFFSET(node2Index32, uint32Array2),
        COUNT(node2Index32 * 2, uint16Array2),
        depth1,
        node1IndexByteOffset + node1Index32,
        depth2,
        node2IndexByteOffset + node2Index32
      );
    }
  } else if (isLeaf2) {
    const newBox = _boxPool.getPrimitive();
    arrayToBox(BOUNDING_DATA_INDEX(node2Index32), float32Array2, newBox);
    newBox.applyMatrix4(matrix2to1);
    const cl1 = LEFT_NODE(node1Index32);
    const cr1 = RIGHT_NODE(node1Index32, uint32Array1);
    arrayToBox(BOUNDING_DATA_INDEX(cl1), float32Array1, _leftBox1);
    arrayToBox(BOUNDING_DATA_INDEX(cr1), float32Array1, _rightBox1);
    const intersectCl1 = newBox.intersectsBox(_leftBox1);
    const intersectCr1 = newBox.intersectsBox(_rightBox1);
    result = intersectCl1 && _traverse(
      node2Index32,
      cl1,
      matrix1to2,
      matrix2to1,
      intersectsRangesFunc,
      node2IndexByteOffset,
      node1IndexByteOffset,
      depth2,
      depth1 + 1,
      newBox,
      !reversed
    ) || intersectCr1 && _traverse(
      node2Index32,
      cr1,
      matrix1to2,
      matrix2to1,
      intersectsRangesFunc,
      node2IndexByteOffset,
      node1IndexByteOffset,
      depth2,
      depth1 + 1,
      newBox,
      !reversed
    );
    _boxPool.releasePrimitive(newBox);
  } else {
    const cl2 = LEFT_NODE(node2Index32);
    const cr2 = RIGHT_NODE(node2Index32, uint32Array2);
    arrayToBox(BOUNDING_DATA_INDEX(cl2), float32Array2, _leftBox2);
    arrayToBox(BOUNDING_DATA_INDEX(cr2), float32Array2, _rightBox2);
    const leftIntersects = currBox.intersectsBox(_leftBox2);
    const rightIntersects = currBox.intersectsBox(_rightBox2);
    if (leftIntersects && rightIntersects) {
      result = _traverse(
        node1Index32,
        cl2,
        matrix2to1,
        matrix1to2,
        intersectsRangesFunc,
        node1IndexByteOffset,
        node2IndexByteOffset,
        depth1,
        depth2 + 1,
        currBox,
        reversed
      ) || _traverse(
        node1Index32,
        cr2,
        matrix2to1,
        matrix1to2,
        intersectsRangesFunc,
        node1IndexByteOffset,
        node2IndexByteOffset,
        depth1,
        depth2 + 1,
        currBox,
        reversed
      );
    } else if (leftIntersects) {
      if (isLeaf1) {
        result = _traverse(
          node1Index32,
          cl2,
          matrix2to1,
          matrix1to2,
          intersectsRangesFunc,
          node1IndexByteOffset,
          node2IndexByteOffset,
          depth1,
          depth2 + 1,
          currBox,
          reversed
        );
      } else {
        const newBox = _boxPool.getPrimitive();
        newBox.copy(_leftBox2).applyMatrix4(matrix2to1);
        const cl1 = LEFT_NODE(node1Index32);
        const cr1 = RIGHT_NODE(node1Index32, uint32Array1);
        arrayToBox(BOUNDING_DATA_INDEX(cl1), float32Array1, _leftBox1);
        arrayToBox(BOUNDING_DATA_INDEX(cr1), float32Array1, _rightBox1);
        const intersectCl1 = newBox.intersectsBox(_leftBox1);
        const intersectCr1 = newBox.intersectsBox(_rightBox1);
        result = intersectCl1 && _traverse(
          cl2,
          cl1,
          matrix1to2,
          matrix2to1,
          intersectsRangesFunc,
          node2IndexByteOffset,
          node1IndexByteOffset,
          depth2,
          depth1 + 1,
          newBox,
          !reversed
        ) || intersectCr1 && _traverse(
          cl2,
          cr1,
          matrix1to2,
          matrix2to1,
          intersectsRangesFunc,
          node2IndexByteOffset,
          node1IndexByteOffset,
          depth2,
          depth1 + 1,
          newBox,
          !reversed
        );
        _boxPool.releasePrimitive(newBox);
      }
    } else if (rightIntersects) {
      if (isLeaf1) {
        result = _traverse(
          node1Index32,
          cr2,
          matrix2to1,
          matrix1to2,
          intersectsRangesFunc,
          node1IndexByteOffset,
          node2IndexByteOffset,
          depth1,
          depth2 + 1,
          currBox,
          reversed
        );
      } else {
        const newBox = _boxPool.getPrimitive();
        newBox.copy(_rightBox2).applyMatrix4(matrix2to1);
        const cl1 = LEFT_NODE(node1Index32);
        const cr1 = RIGHT_NODE(node1Index32, uint32Array1);
        arrayToBox(BOUNDING_DATA_INDEX(cl1), float32Array1, _leftBox1);
        arrayToBox(BOUNDING_DATA_INDEX(cr1), float32Array1, _rightBox1);
        const intersectCl1 = newBox.intersectsBox(_leftBox1);
        const intersectCr1 = newBox.intersectsBox(_rightBox1);
        result = intersectCl1 && _traverse(
          cr2,
          cl1,
          matrix1to2,
          matrix2to1,
          intersectsRangesFunc,
          node2IndexByteOffset,
          node1IndexByteOffset,
          depth2,
          depth1 + 1,
          newBox,
          !reversed
        ) || intersectCr1 && _traverse(
          cr2,
          cr1,
          matrix1to2,
          matrix2to1,
          intersectsRangesFunc,
          node2IndexByteOffset,
          node1IndexByteOffset,
          depth2,
          depth1 + 1,
          newBox,
          !reversed
        );
        _boxPool.releasePrimitive(newBox);
      }
    }
  }
  return result;
}
const obb = /* @__PURE__ */ new OrientedBox();
const tempBox = /* @__PURE__ */ new Box3$1();
const DEFAULT_OPTIONS = {
  strategy: CENTER,
  maxDepth: 40,
  maxLeafTris: 10,
  useSharedArrayBuffer: false,
  setBoundingBox: true,
  onProgress: null,
  indirect: false,
  verbose: true,
  range: null
};
class MeshBVH {
  static serialize(bvh, options = {}) {
    options = {
      cloneBuffers: true,
      ...options
    };
    const geometry = bvh.geometry;
    const rootData = bvh._roots;
    const indirectBuffer = bvh._indirectBuffer;
    const indexAttribute = geometry.getIndex();
    let result;
    if (options.cloneBuffers) {
      result = {
        roots: rootData.map((root) => root.slice()),
        index: indexAttribute ? indexAttribute.array.slice() : null,
        indirectBuffer: indirectBuffer ? indirectBuffer.slice() : null
      };
    } else {
      result = {
        roots: rootData,
        index: indexAttribute ? indexAttribute.array : null,
        indirectBuffer
      };
    }
    return result;
  }
  static deserialize(data, geometry, options = {}) {
    options = {
      setIndex: true,
      indirect: Boolean(data.indirectBuffer),
      ...options
    };
    const { index: index2, roots, indirectBuffer } = data;
    const bvh = new MeshBVH(geometry, { ...options, [SKIP_GENERATION]: true });
    bvh._roots = roots;
    bvh._indirectBuffer = indirectBuffer || null;
    if (options.setIndex) {
      const indexAttribute = geometry.getIndex();
      if (indexAttribute === null) {
        const newIndex = new BufferAttribute$1(data.index, 1, false);
        geometry.setIndex(newIndex);
      } else if (indexAttribute.array !== index2) {
        indexAttribute.array.set(index2);
        indexAttribute.needsUpdate = true;
      }
    }
    return bvh;
  }
  get indirect() {
    return !!this._indirectBuffer;
  }
  constructor(geometry, options = {}) {
    if (!geometry.isBufferGeometry) {
      throw new Error("MeshBVH: Only BufferGeometries are supported.");
    } else if (geometry.index && geometry.index.isInterleavedBufferAttribute) {
      throw new Error("MeshBVH: InterleavedBufferAttribute is not supported for the index attribute.");
    }
    options = Object.assign({
      ...DEFAULT_OPTIONS,
      // undocumented options
      // Whether to skip generating the tree. Used for deserialization.
      [SKIP_GENERATION]: false
    }, options);
    if (options.useSharedArrayBuffer && !isSharedArrayBufferSupported()) {
      throw new Error("MeshBVH: SharedArrayBuffer is not available.");
    }
    this.geometry = geometry;
    this._roots = null;
    this._indirectBuffer = null;
    if (!options[SKIP_GENERATION]) {
      buildPackedTree(this, options);
      if (!geometry.boundingBox && options.setBoundingBox) {
        geometry.boundingBox = this.getBoundingBox(new Box3$1());
      }
    }
    this.resolveTriangleIndex = options.indirect ? (i2) => this._indirectBuffer[i2] : (i2) => i2;
  }
  refit(nodeIndices = null) {
    const refitFunc = this.indirect ? refit_indirect : refit;
    return refitFunc(this, nodeIndices);
  }
  traverse(callback, rootIndex = 0) {
    const buffer = this._roots[rootIndex];
    const uint32Array2 = new Uint32Array(buffer);
    const uint16Array2 = new Uint16Array(buffer);
    _traverse2(0);
    function _traverse2(node32Index, depth = 0) {
      const node16Index = node32Index * 2;
      const isLeaf = uint16Array2[node16Index + 15] === IS_LEAFNODE_FLAG;
      if (isLeaf) {
        const offset = uint32Array2[node32Index + 6];
        const count = uint16Array2[node16Index + 14];
        callback(depth, isLeaf, new Float32Array(buffer, node32Index * 4, 6), offset, count);
      } else {
        const left = node32Index + BYTES_PER_NODE / 4;
        const right = uint32Array2[node32Index + 6];
        const splitAxis = uint32Array2[node32Index + 7];
        const stopTraversal = callback(depth, isLeaf, new Float32Array(buffer, node32Index * 4, 6), splitAxis);
        if (!stopTraversal) {
          _traverse2(left, depth + 1);
          _traverse2(right, depth + 1);
        }
      }
    }
  }
  /* Core Cast Functions */
  raycast(ray2, materialOrSide = FrontSide$1, near = 0, far = Infinity) {
    const roots = this._roots;
    const geometry = this.geometry;
    const intersects2 = [];
    const isMaterial = materialOrSide.isMaterial;
    const isArrayMaterial = Array.isArray(materialOrSide);
    const groups = geometry.groups;
    const side = isMaterial ? materialOrSide.side : materialOrSide;
    const raycastFunc = this.indirect ? raycast_indirect : raycast;
    for (let i2 = 0, l2 = roots.length; i2 < l2; i2++) {
      const materialSide = isArrayMaterial ? materialOrSide[groups[i2].materialIndex].side : side;
      const startCount = intersects2.length;
      raycastFunc(this, i2, materialSide, ray2, intersects2, near, far);
      if (isArrayMaterial) {
        const materialIndex = groups[i2].materialIndex;
        for (let j = startCount, jl = intersects2.length; j < jl; j++) {
          intersects2[j].face.materialIndex = materialIndex;
        }
      }
    }
    return intersects2;
  }
  raycastFirst(ray2, materialOrSide = FrontSide$1, near = 0, far = Infinity) {
    const roots = this._roots;
    const geometry = this.geometry;
    const isMaterial = materialOrSide.isMaterial;
    const isArrayMaterial = Array.isArray(materialOrSide);
    let closestResult = null;
    const groups = geometry.groups;
    const side = isMaterial ? materialOrSide.side : materialOrSide;
    const raycastFirstFunc = this.indirect ? raycastFirst_indirect : raycastFirst;
    for (let i2 = 0, l2 = roots.length; i2 < l2; i2++) {
      const materialSide = isArrayMaterial ? materialOrSide[groups[i2].materialIndex].side : side;
      const result = raycastFirstFunc(this, i2, materialSide, ray2, near, far);
      if (result != null && (closestResult == null || result.distance < closestResult.distance)) {
        closestResult = result;
        if (isArrayMaterial) {
          result.face.materialIndex = groups[i2].materialIndex;
        }
      }
    }
    return closestResult;
  }
  intersectsGeometry(otherGeometry, geomToMesh) {
    let result = false;
    const roots = this._roots;
    const intersectsGeometryFunc = this.indirect ? intersectsGeometry_indirect : intersectsGeometry;
    for (let i2 = 0, l2 = roots.length; i2 < l2; i2++) {
      result = intersectsGeometryFunc(this, i2, otherGeometry, geomToMesh);
      if (result) {
        break;
      }
    }
    return result;
  }
  shapecast(callbacks) {
    const triangle3 = ExtendedTrianglePool.getPrimitive();
    const iterateFunc = this.indirect ? iterateOverTriangles_indirect : iterateOverTriangles;
    let {
      boundsTraverseOrder,
      intersectsBounds,
      intersectsRange,
      intersectsTriangle
    } = callbacks;
    if (intersectsRange && intersectsTriangle) {
      const originalIntersectsRange = intersectsRange;
      intersectsRange = (offset, count, contained, depth, nodeIndex) => {
        if (!originalIntersectsRange(offset, count, contained, depth, nodeIndex)) {
          return iterateFunc(offset, count, this, intersectsTriangle, contained, depth, triangle3);
        }
        return true;
      };
    } else if (!intersectsRange) {
      if (intersectsTriangle) {
        intersectsRange = (offset, count, contained, depth) => {
          return iterateFunc(offset, count, this, intersectsTriangle, contained, depth, triangle3);
        };
      } else {
        intersectsRange = (offset, count, contained) => {
          return contained;
        };
      }
    }
    let result = false;
    let byteOffset = 0;
    const roots = this._roots;
    for (let i2 = 0, l2 = roots.length; i2 < l2; i2++) {
      const root = roots[i2];
      result = shapecast(this, i2, intersectsBounds, intersectsRange, boundsTraverseOrder, byteOffset);
      if (result) {
        break;
      }
      byteOffset += root.byteLength;
    }
    ExtendedTrianglePool.releasePrimitive(triangle3);
    return result;
  }
  bvhcast(otherBvh, matrixToLocal, callbacks) {
    let {
      intersectsRanges,
      intersectsTriangles
    } = callbacks;
    const triangle1 = ExtendedTrianglePool.getPrimitive();
    const indexAttr1 = this.geometry.index;
    const positionAttr1 = this.geometry.attributes.position;
    const assignTriangle1 = this.indirect ? (i1) => {
      const ti2 = this.resolveTriangleIndex(i1);
      setTriangle(triangle1, ti2 * 3, indexAttr1, positionAttr1);
    } : (i1) => {
      setTriangle(triangle1, i1 * 3, indexAttr1, positionAttr1);
    };
    const triangle22 = ExtendedTrianglePool.getPrimitive();
    const indexAttr2 = otherBvh.geometry.index;
    const positionAttr2 = otherBvh.geometry.attributes.position;
    const assignTriangle2 = otherBvh.indirect ? (i2) => {
      const ti2 = otherBvh.resolveTriangleIndex(i2);
      setTriangle(triangle22, ti2 * 3, indexAttr2, positionAttr2);
    } : (i2) => {
      setTriangle(triangle22, i2 * 3, indexAttr2, positionAttr2);
    };
    if (intersectsTriangles) {
      const iterateOverDoubleTriangles = (offset1, count1, offset2, count2, depth1, index1, depth2, index2) => {
        for (let i2 = offset2, l2 = offset2 + count2; i2 < l2; i2++) {
          assignTriangle2(i2);
          triangle22.a.applyMatrix4(matrixToLocal);
          triangle22.b.applyMatrix4(matrixToLocal);
          triangle22.c.applyMatrix4(matrixToLocal);
          triangle22.needsUpdate = true;
          for (let i1 = offset1, l1 = offset1 + count1; i1 < l1; i1++) {
            assignTriangle1(i1);
            triangle1.needsUpdate = true;
            if (intersectsTriangles(triangle1, triangle22, i1, i2, depth1, index1, depth2, index2)) {
              return true;
            }
          }
        }
        return false;
      };
      if (intersectsRanges) {
        const originalIntersectsRanges = intersectsRanges;
        intersectsRanges = function(offset1, count1, offset2, count2, depth1, index1, depth2, index2) {
          if (!originalIntersectsRanges(offset1, count1, offset2, count2, depth1, index1, depth2, index2)) {
            return iterateOverDoubleTriangles(offset1, count1, offset2, count2, depth1, index1, depth2, index2);
          }
          return true;
        };
      } else {
        intersectsRanges = iterateOverDoubleTriangles;
      }
    }
    return bvhcast(this, otherBvh, matrixToLocal, intersectsRanges);
  }
  /* Derived Cast Functions */
  intersectsBox(box, boxToMesh) {
    obb.set(box.min, box.max, boxToMesh);
    obb.needsUpdate = true;
    return this.shapecast(
      {
        intersectsBounds: (box2) => obb.intersectsBox(box2),
        intersectsTriangle: (tri) => obb.intersectsTriangle(tri)
      }
    );
  }
  intersectsSphere(sphere) {
    return this.shapecast(
      {
        intersectsBounds: (box) => sphere.intersectsBox(box),
        intersectsTriangle: (tri) => tri.intersectsSphere(sphere)
      }
    );
  }
  closestPointToGeometry(otherGeometry, geometryToBvh, target1 = {}, target2 = {}, minThreshold = 0, maxThreshold = Infinity) {
    const closestPointToGeometryFunc = this.indirect ? closestPointToGeometry_indirect : closestPointToGeometry;
    return closestPointToGeometryFunc(
      this,
      otherGeometry,
      geometryToBvh,
      target1,
      target2,
      minThreshold,
      maxThreshold
    );
  }
  closestPointToPoint(point2, target = {}, minThreshold = 0, maxThreshold = Infinity) {
    return closestPointToPoint(
      this,
      point2,
      target,
      minThreshold,
      maxThreshold
    );
  }
  getBoundingBox(target) {
    target.makeEmpty();
    const roots = this._roots;
    roots.forEach((buffer) => {
      arrayToBox(0, new Float32Array(buffer), tempBox);
      target.union(tempBox);
    });
    return target;
  }
}
function convertRaycastIntersect(hit, object, raycaster) {
  if (hit === null) {
    return null;
  }
  hit.point.applyMatrix4(object.matrixWorld);
  hit.distance = hit.point.distanceTo(raycaster.ray.origin);
  hit.object = object;
  return hit;
}
const ray = /* @__PURE__ */ new Ray$1();
const direction$1 = /* @__PURE__ */ new Vector3$1();
const tmpInverseMatrix = /* @__PURE__ */ new Matrix4$1();
const origMeshRaycastFunc = Mesh$1.prototype.raycast;
const origBatchedRaycastFunc = BatchedMesh.prototype.raycast;
const _worldScale$1 = /* @__PURE__ */ new Vector3$1();
const _mesh$1 = /* @__PURE__ */ new Mesh$1();
const _batchIntersects = [];
function acceleratedRaycast(raycaster, intersects2) {
  if (this.isBatchedMesh) {
    acceleratedBatchedMeshRaycast.call(this, raycaster, intersects2);
  } else {
    acceleratedMeshRaycast.call(this, raycaster, intersects2);
  }
}
function acceleratedBatchedMeshRaycast(raycaster, intersects2) {
  if (this.boundsTrees) {
    const boundsTrees = this.boundsTrees;
    const drawInfo = this._drawInfo || this._instanceInfo;
    const drawRanges = this._drawRanges || this._geometryInfo;
    const matrixWorld = this.matrixWorld;
    _mesh$1.material = this.material;
    _mesh$1.geometry = this.geometry;
    const oldBoundsTree = _mesh$1.geometry.boundsTree;
    const oldDrawRange = _mesh$1.geometry.drawRange;
    if (_mesh$1.geometry.boundingSphere === null) {
      _mesh$1.geometry.boundingSphere = new Sphere$1();
    }
    for (let i2 = 0, l2 = drawInfo.length; i2 < l2; i2++) {
      if (!this.getVisibleAt(i2)) {
        continue;
      }
      const geometryId = drawInfo[i2].geometryIndex;
      _mesh$1.geometry.boundsTree = boundsTrees[geometryId];
      this.getMatrixAt(i2, _mesh$1.matrixWorld).premultiply(matrixWorld);
      if (!_mesh$1.geometry.boundsTree) {
        this.getBoundingBoxAt(geometryId, _mesh$1.geometry.boundingBox);
        this.getBoundingSphereAt(geometryId, _mesh$1.geometry.boundingSphere);
        const drawRange = drawRanges[geometryId];
        _mesh$1.geometry.setDrawRange(drawRange.start, drawRange.count);
      }
      _mesh$1.raycast(raycaster, _batchIntersects);
      for (let j = 0, l3 = _batchIntersects.length; j < l3; j++) {
        const intersect2 = _batchIntersects[j];
        intersect2.object = this;
        intersect2.batchId = i2;
        intersects2.push(intersect2);
      }
      _batchIntersects.length = 0;
    }
    _mesh$1.geometry.boundsTree = oldBoundsTree;
    _mesh$1.geometry.drawRange = oldDrawRange;
    _mesh$1.material = null;
    _mesh$1.geometry = null;
  } else {
    origBatchedRaycastFunc.call(this, raycaster, intersects2);
  }
}
function acceleratedMeshRaycast(raycaster, intersects2) {
  if (this.geometry.boundsTree) {
    if (this.material === void 0) return;
    tmpInverseMatrix.copy(this.matrixWorld).invert();
    ray.copy(raycaster.ray).applyMatrix4(tmpInverseMatrix);
    _worldScale$1.setFromMatrixScale(this.matrixWorld);
    direction$1.copy(ray.direction).multiply(_worldScale$1);
    const scaleFactor = direction$1.length();
    const near = raycaster.near / scaleFactor;
    const far = raycaster.far / scaleFactor;
    const bvh = this.geometry.boundsTree;
    if (raycaster.firstHitOnly === true) {
      const hit = convertRaycastIntersect(bvh.raycastFirst(ray, this.material, near, far), this, raycaster);
      if (hit) {
        intersects2.push(hit);
      }
    } else {
      const hits = bvh.raycast(ray, this.material, near, far);
      for (let i2 = 0, l2 = hits.length; i2 < l2; i2++) {
        const hit = convertRaycastIntersect(hits[i2], this, raycaster);
        if (hit) {
          intersects2.push(hit);
        }
      }
    }
  } else {
    origMeshRaycastFunc.call(this, raycaster, intersects2);
  }
}
function computeBoundsTree(options = {}) {
  this.boundsTree = new MeshBVH(this, options);
  return this.boundsTree;
}
function disposeBoundsTree() {
  this.boundsTree = null;
}
var earthRadius = 63710088e-1;
var factors = {
  centimeters: earthRadius * 100,
  centimetres: earthRadius * 100,
  degrees: 360 / (2 * Math.PI),
  feet: earthRadius * 3.28084,
  inches: earthRadius * 39.37,
  kilometers: earthRadius / 1e3,
  kilometres: earthRadius / 1e3,
  meters: earthRadius,
  metres: earthRadius,
  miles: earthRadius / 1609.344,
  millimeters: earthRadius * 1e3,
  millimetres: earthRadius * 1e3,
  nauticalmiles: earthRadius / 1852,
  radians: 1,
  yards: earthRadius * 1.0936
};
function feature(geom, properties, options = {}) {
  const feat = { type: "Feature" };
  if (options.id === 0 || options.id) {
    feat.id = options.id;
  }
  if (options.bbox) {
    feat.bbox = options.bbox;
  }
  feat.properties = properties || {};
  feat.geometry = geom;
  return feat;
}
function point(coordinates, properties, options = {}) {
  if (!coordinates) {
    throw new Error("coordinates is required");
  }
  if (!Array.isArray(coordinates)) {
    throw new Error("coordinates must be an Array");
  }
  if (coordinates.length < 2) {
    throw new Error("coordinates must be at least 2 numbers long");
  }
  if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) {
    throw new Error("coordinates must contain numbers");
  }
  const geom = {
    type: "Point",
    coordinates
  };
  return feature(geom, properties, options);
}
function lineString(coordinates, properties, options = {}) {
  if (coordinates.length < 2) {
    throw new Error("coordinates must be an array of two or more positions");
  }
  const geom = {
    type: "LineString",
    coordinates
  };
  return feature(geom, properties, options);
}
function radiansToLength(radians, units = "kilometers") {
  const factor = factors[units];
  if (!factor) {
    throw new Error(units + " units is invalid");
  }
  return radians * factor;
}
function degreesToRadians(degrees) {
  const normalisedDegrees = degrees % 360;
  return normalisedDegrees * Math.PI / 180;
}
function isNumber(num) {
  return !isNaN(num) && num !== null && !Array.isArray(num);
}
function getCoord(coord) {
  if (!coord) {
    throw new Error("coord is required");
  }
  if (!Array.isArray(coord)) {
    if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") {
      return [...coord.geometry.coordinates];
    }
    if (coord.type === "Point") {
      return [...coord.coordinates];
    }
  }
  if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) {
    return [...coord];
  }
  throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function distance$1(from, to, options = {}) {
  var coordinates1 = getCoord(from);
  var coordinates2 = getCoord(to);
  var dLat = degreesToRadians(coordinates2[1] - coordinates1[1]);
  var dLon = degreesToRadians(coordinates2[0] - coordinates1[0]);
  var lat1 = degreesToRadians(coordinates1[1]);
  var lat2 = degreesToRadians(coordinates2[1]);
  var a3 = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
  return radiansToLength(
    2 * Math.atan2(Math.sqrt(a3), Math.sqrt(1 - a3)),
    options.units
  );
}
function coordEach(geojson, callback, excludeWrapCoord) {
  if (geojson === null) return;
  var j, k, l2, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
  for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
    geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
    isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
    stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
    for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
      var multiFeatureIndex = 0;
      var geometryIndex = 0;
      geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
      if (geometry === null) continue;
      coords = geometry.coordinates;
      var geomType = geometry.type;
      wrapShrink = 0;
      switch (geomType) {
        case null:
          break;
        case "Point":
          if (callback(
            coords,
            coordIndex,
            featureIndex,
            multiFeatureIndex,
            geometryIndex
          ) === false)
            return false;
          coordIndex++;
          multiFeatureIndex++;
          break;
        case "LineString":
        case "MultiPoint":
          for (j = 0; j < coords.length; j++) {
            if (callback(
              coords[j],
              coordIndex,
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false)
              return false;
            coordIndex++;
            if (geomType === "MultiPoint") multiFeatureIndex++;
          }
          if (geomType === "LineString") multiFeatureIndex++;
          break;
        case "Polygon":
        case "MultiLineString":
          for (j = 0; j < coords.length; j++) {
            for (k = 0; k < coords[j].length - wrapShrink; k++) {
              if (callback(
                coords[j][k],
                coordIndex,
                featureIndex,
                multiFeatureIndex,
                geometryIndex
              ) === false)
                return false;
              coordIndex++;
            }
            if (geomType === "MultiLineString") multiFeatureIndex++;
            if (geomType === "Polygon") geometryIndex++;
          }
          if (geomType === "Polygon") multiFeatureIndex++;
          break;
        case "MultiPolygon":
          for (j = 0; j < coords.length; j++) {
            geometryIndex = 0;
            for (k = 0; k < coords[j].length; k++) {
              for (l2 = 0; l2 < coords[j][k].length - wrapShrink; l2++) {
                if (callback(
                  coords[j][k][l2],
                  coordIndex,
                  featureIndex,
                  multiFeatureIndex,
                  geometryIndex
                ) === false)
                  return false;
                coordIndex++;
              }
              geometryIndex++;
            }
            multiFeatureIndex++;
          }
          break;
        case "GeometryCollection":
          for (j = 0; j < geometry.geometries.length; j++)
            if (coordEach(geometry.geometries[j], callback) === false)
              return false;
          break;
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
  }
}
function geomEach(geojson, callback) {
  var i2, j, g3, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
  for (i2 = 0; i2 < stop; i2++) {
    geometryMaybeCollection = isFeatureCollection ? geojson.features[i2].geometry : isFeature ? geojson.geometry : geojson;
    featureProperties = isFeatureCollection ? geojson.features[i2].properties : isFeature ? geojson.properties : {};
    featureBBox = isFeatureCollection ? geojson.features[i2].bbox : isFeature ? geojson.bbox : void 0;
    featureId = isFeatureCollection ? geojson.features[i2].id : isFeature ? geojson.id : void 0;
    isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
    stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
    for (g3 = 0; g3 < stopG; g3++) {
      geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g3] : geometryMaybeCollection;
      if (geometry === null) {
        if (callback(
          null,
          featureIndex,
          featureProperties,
          featureBBox,
          featureId
        ) === false)
          return false;
        continue;
      }
      switch (geometry.type) {
        case "Point":
        case "LineString":
        case "MultiPoint":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon": {
          if (callback(
            geometry,
            featureIndex,
            featureProperties,
            featureBBox,
            featureId
          ) === false)
            return false;
          break;
        }
        case "GeometryCollection": {
          for (j = 0; j < geometry.geometries.length; j++) {
            if (callback(
              geometry.geometries[j],
              featureIndex,
              featureProperties,
              featureBBox,
              featureId
            ) === false)
              return false;
          }
          break;
        }
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
    featureIndex++;
  }
}
function geomReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  geomEach(
    geojson,
    function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
      previousValue = callback(
        previousValue,
        currentGeometry,
        featureIndex,
        featureProperties,
        featureBBox,
        featureId
      );
    }
  );
  return previousValue;
}
function flattenEach(geojson, callback) {
  geomEach(geojson, function(geometry, featureIndex, properties, bbox, id) {
    var type = geometry === null ? null : geometry.type;
    switch (type) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        if (callback(
          feature(geometry, properties, { bbox, id }),
          featureIndex,
          0
        ) === false)
          return false;
        return;
    }
    var geomType;
    switch (type) {
      case "MultiPoint":
        geomType = "Point";
        break;
      case "MultiLineString":
        geomType = "LineString";
        break;
      case "MultiPolygon":
        geomType = "Polygon";
        break;
    }
    for (var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++) {
      var coordinate = geometry.coordinates[multiFeatureIndex];
      var geom = {
        type: geomType,
        coordinates: coordinate
      };
      if (callback(feature(geom, properties), featureIndex, multiFeatureIndex) === false)
        return false;
    }
  });
}
function segmentEach(geojson, callback) {
  flattenEach(geojson, function(feature2, featureIndex, multiFeatureIndex) {
    var segmentIndex = 0;
    if (!feature2.geometry) return;
    var type = feature2.geometry.type;
    if (type === "Point" || type === "MultiPoint") return;
    var previousCoords;
    var previousFeatureIndex = 0;
    var previousMultiIndex = 0;
    var prevGeomIndex = 0;
    if (coordEach(
      feature2,
      function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
        if (previousCoords === void 0 || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
          previousCoords = currentCoord;
          previousFeatureIndex = featureIndex;
          previousMultiIndex = multiPartIndexCoord;
          prevGeomIndex = geometryIndex;
          segmentIndex = 0;
          return;
        }
        var currentSegment = lineString(
          [previousCoords, currentCoord],
          feature2.properties
        );
        if (callback(
          currentSegment,
          featureIndex,
          multiFeatureIndex,
          geometryIndex,
          segmentIndex
        ) === false)
          return false;
        segmentIndex++;
        previousCoords = currentCoord;
      }
    ) === false)
      return false;
  });
}
function segmentReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  var started = false;
  segmentEach(
    geojson,
    function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
      if (started === false && initialValue === void 0)
        previousValue = currentSegment;
      else
        previousValue = callback(
          previousValue,
          currentSegment,
          featureIndex,
          multiFeatureIndex,
          geometryIndex,
          segmentIndex
        );
      started = true;
    }
  );
  return previousValue;
}
function area$1(geojson) {
  return geomReduce(
    geojson,
    (value, geom) => {
      return value + calculateArea(geom);
    },
    0
  );
}
function calculateArea(geom) {
  let total = 0;
  let i2;
  switch (geom.type) {
    case "Polygon":
      return polygonArea(geom.coordinates);
    case "MultiPolygon":
      for (i2 = 0; i2 < geom.coordinates.length; i2++) {
        total += polygonArea(geom.coordinates[i2]);
      }
      return total;
    case "Point":
    case "MultiPoint":
    case "LineString":
    case "MultiLineString":
      return 0;
  }
  return 0;
}
function polygonArea(coords) {
  let total = 0;
  if (coords && coords.length > 0) {
    total += Math.abs(ringArea(coords[0]));
    for (let i2 = 1; i2 < coords.length; i2++) {
      total -= Math.abs(ringArea(coords[i2]));
    }
  }
  return total;
}
var FACTOR = earthRadius * earthRadius / 2;
var PI_OVER_180 = Math.PI / 180;
function ringArea(coords) {
  const coordsLength = coords.length - 1;
  if (coordsLength <= 2) return 0;
  let total = 0;
  let i2 = 0;
  while (i2 < coordsLength) {
    const lower = coords[i2];
    const middle = coords[i2 + 1 === coordsLength ? 0 : i2 + 1];
    const upper = coords[i2 + 2 >= coordsLength ? (i2 + 2) % coordsLength : i2 + 2];
    const lowerX = lower[0] * PI_OVER_180;
    const middleY = middle[1] * PI_OVER_180;
    const upperX = upper[0] * PI_OVER_180;
    total += (upperX - lowerX) * Math.sin(middleY);
    i2++;
  }
  return total * FACTOR;
}
function clone(geojson) {
  if (!geojson) {
    throw new Error("geojson is required");
  }
  switch (geojson.type) {
    case "Feature":
      return cloneFeature(geojson);
    case "FeatureCollection":
      return cloneFeatureCollection(geojson);
    case "Point":
    case "LineString":
    case "Polygon":
    case "MultiPoint":
    case "MultiLineString":
    case "MultiPolygon":
    case "GeometryCollection":
      return cloneGeometry(geojson);
    default:
      throw new Error("unknown GeoJSON type");
  }
}
function cloneFeature(geojson) {
  const cloned = { type: "Feature" };
  Object.keys(geojson).forEach((key) => {
    switch (key) {
      case "type":
      case "properties":
      case "geometry":
        return;
      default:
        cloned[key] = geojson[key];
    }
  });
  cloned.properties = cloneProperties(geojson.properties);
  if (geojson.geometry == null) {
    cloned.geometry = null;
  } else {
    cloned.geometry = cloneGeometry(geojson.geometry);
  }
  return cloned;
}
function cloneProperties(properties) {
  const cloned = {};
  if (!properties) {
    return cloned;
  }
  Object.keys(properties).forEach((key) => {
    const value = properties[key];
    if (typeof value === "object") {
      if (value === null) {
        cloned[key] = null;
      } else if (Array.isArray(value)) {
        cloned[key] = value.map((item) => {
          return item;
        });
      } else {
        cloned[key] = cloneProperties(value);
      }
    } else {
      cloned[key] = value;
    }
  });
  return cloned;
}
function cloneFeatureCollection(geojson) {
  const cloned = { type: "FeatureCollection" };
  Object.keys(geojson).forEach((key) => {
    switch (key) {
      case "type":
      case "features":
        return;
      default:
        cloned[key] = geojson[key];
    }
  });
  cloned.features = geojson.features.map((feature2) => {
    return cloneFeature(feature2);
  });
  return cloned;
}
function cloneGeometry(geometry) {
  const geom = { type: geometry.type };
  if (geometry.bbox) {
    geom.bbox = geometry.bbox;
  }
  if (geometry.type === "GeometryCollection") {
    geom.geometries = geometry.geometries.map((g3) => {
      return cloneGeometry(g3);
    });
    return geom;
  }
  geom.coordinates = deepSlice(geometry.coordinates);
  return geom;
}
function deepSlice(coords) {
  const cloned = coords;
  if (typeof cloned[0] !== "object") {
    return cloned.slice();
  }
  return cloned.map((coord) => {
    return deepSlice(coord);
  });
}
function length(geojson, options = {}) {
  return segmentReduce(
    geojson,
    (previousValue, segment) => {
      const coords = segment.geometry.coordinates;
      return previousValue + distance$1(coords[0], coords[1], options);
    },
    0
  );
}
function toMercator(geojson, options = {}) {
  return convert(geojson, "mercator", options);
}
function toWgs84(geojson, options = {}) {
  return convert(geojson, "wgs84", options);
}
function convert(geojson, projection, options = {}) {
  options = options || {};
  var mutate = options.mutate;
  if (!geojson) throw new Error("geojson is required");
  if (Array.isArray(geojson) && isNumber(geojson[0]))
    geojson = projection === "mercator" ? convertToMercator(geojson) : convertToWgs84(geojson);
  else {
    if (mutate !== true) geojson = clone(geojson);
    coordEach(geojson, function(coord) {
      var newCoord = projection === "mercator" ? convertToMercator(coord) : convertToWgs84(coord);
      coord[0] = newCoord[0];
      coord[1] = newCoord[1];
    });
  }
  return geojson;
}
function convertToMercator(lonLat) {
  var D2R = Math.PI / 180, A2 = 6378137, MAXEXTENT = 20037508342789244e-9;
  var adjusted = Math.abs(lonLat[0]) <= 180 ? lonLat[0] : lonLat[0] - sign$1(lonLat[0]) * 360;
  var xy = [
    A2 * adjusted * D2R,
    A2 * Math.log(Math.tan(Math.PI * 0.25 + 0.5 * lonLat[1] * D2R))
  ];
  if (xy[0] > MAXEXTENT) xy[0] = MAXEXTENT;
  if (xy[0] < -MAXEXTENT) xy[0] = -MAXEXTENT;
  if (xy[1] > MAXEXTENT) xy[1] = MAXEXTENT;
  if (xy[1] < -MAXEXTENT) xy[1] = -MAXEXTENT;
  return xy;
}
function convertToWgs84(xy) {
  var R2D = 180 / Math.PI;
  var A2 = 6378137;
  return [
    xy[0] * R2D / A2,
    (Math.PI * 0.5 - 2 * Math.atan(Math.exp(-xy[1] / A2))) * R2D
  ];
}
function sign$1(x) {
  return x < 0 ? -1 : x > 0 ? 1 : 0;
}
var jquery = { exports: {} };
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
(function(module) {
  (function(global2, factory) {
    {
      module.exports = global2.document ? factory(global2, true) : function(w) {
        if (!w.document) {
          throw new Error("jQuery requires a window with a document");
        }
        return factory(w);
      };
    }
  })(typeof window !== "undefined" ? window : commonjsGlobal, function(window2, noGlobal) {
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice2 = arr.slice;
    var flat = arr.flat ? function(array) {
      return arr.flat.call(array);
    } : function(array) {
      return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction2(obj) {
      return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow2(obj) {
      return obj != null && obj === obj.window;
    };
    var document2 = window2.document;
    var preservedScriptAttributes = {
      type: true,
      src: true,
      nonce: true,
      noModule: true
    };
    function DOMEval(code, node, doc) {
      doc = doc || document2;
      var i2, val, script = doc.createElement("script");
      script.text = code;
      if (node) {
        for (i2 in preservedScriptAttributes) {
          val = node[i2] || node.getAttribute && node.getAttribute(i2);
          if (val) {
            script.setAttribute(i2, val);
          }
        }
      }
      doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
      if (obj == null) {
        return obj + "";
      }
      return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, jQuery = function(selector, context) {
      return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
      // The current version of jQuery being used
      jquery: version,
      constructor: jQuery,
      // The default length of a jQuery object is 0
      length: 0,
      toArray: function() {
        return slice2.call(this);
      },
      // Get the Nth element in the matched element set OR
      // Get the whole matched element set as a clean array
      get: function(num) {
        if (num == null) {
          return slice2.call(this);
        }
        return num < 0 ? this[num + this.length] : this[num];
      },
      // Take an array of elements and push it onto the stack
      // (returning the new matched element set)
      pushStack: function(elems) {
        var ret = jQuery.merge(this.constructor(), elems);
        ret.prevObject = this;
        return ret;
      },
      // Execute a callback for every element in the matched set.
      each: function(callback) {
        return jQuery.each(this, callback);
      },
      map: function(callback) {
        return this.pushStack(jQuery.map(this, function(elem, i2) {
          return callback.call(elem, i2, elem);
        }));
      },
      slice: function() {
        return this.pushStack(slice2.apply(this, arguments));
      },
      first: function() {
        return this.eq(0);
      },
      last: function() {
        return this.eq(-1);
      },
      even: function() {
        return this.pushStack(jQuery.grep(this, function(_elem, i2) {
          return (i2 + 1) % 2;
        }));
      },
      odd: function() {
        return this.pushStack(jQuery.grep(this, function(_elem, i2) {
          return i2 % 2;
        }));
      },
      eq: function(i2) {
        var len = this.length, j = +i2 + (i2 < 0 ? len : 0);
        return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
      },
      end: function() {
        return this.prevObject || this.constructor();
      },
      // For internal use only.
      // Behaves like an Array's method, not like a jQuery method.
      push,
      sort: arr.sort,
      splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
      var options, name, src, copy, copyIsArray, clone2, target = arguments[0] || {}, i2 = 1, length2 = arguments.length, deep = false;
      if (typeof target === "boolean") {
        deep = target;
        target = arguments[i2] || {};
        i2++;
      }
      if (typeof target !== "object" && !isFunction(target)) {
        target = {};
      }
      if (i2 === length2) {
        target = this;
        i2--;
      }
      for (; i2 < length2; i2++) {
        if ((options = arguments[i2]) != null) {
          for (name in options) {
            copy = options[name];
            if (name === "__proto__" || target === copy) {
              continue;
            }
            if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
              src = target[name];
              if (copyIsArray && !Array.isArray(src)) {
                clone2 = [];
              } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
                clone2 = {};
              } else {
                clone2 = src;
              }
              copyIsArray = false;
              target[name] = jQuery.extend(deep, clone2, copy);
            } else if (copy !== void 0) {
              target[name] = copy;
            }
          }
        }
      }
      return target;
    };
    jQuery.extend({
      // Unique for each copy of jQuery on the page
      expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
      // Assume jQuery is ready without the ready module
      isReady: true,
      error: function(msg) {
        throw new Error(msg);
      },
      noop: function() {
      },
      isPlainObject: function(obj) {
        var proto, Ctor;
        if (!obj || toString.call(obj) !== "[object Object]") {
          return false;
        }
        proto = getProto(obj);
        if (!proto) {
          return true;
        }
        Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
        return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
      },
      isEmptyObject: function(obj) {
        var name;
        for (name in obj) {
          return false;
        }
        return true;
      },
      // Evaluates a script in a provided context; falls back to the global one
      // if not specified.
      globalEval: function(code, options, doc) {
        DOMEval(code, { nonce: options && options.nonce }, doc);
      },
      each: function(obj, callback) {
        var length2, i2 = 0;
        if (isArrayLike(obj)) {
          length2 = obj.length;
          for (; i2 < length2; i2++) {
            if (callback.call(obj[i2], i2, obj[i2]) === false) {
              break;
            }
          }
        } else {
          for (i2 in obj) {
            if (callback.call(obj[i2], i2, obj[i2]) === false) {
              break;
            }
          }
        }
        return obj;
      },
      // Retrieve the text value of an array of DOM nodes
      text: function(elem) {
        var node, ret = "", i2 = 0, nodeType = elem.nodeType;
        if (!nodeType) {
          while (node = elem[i2++]) {
            ret += jQuery.text(node);
          }
        }
        if (nodeType === 1 || nodeType === 11) {
          return elem.textContent;
        }
        if (nodeType === 9) {
          return elem.documentElement.textContent;
        }
        if (nodeType === 3 || nodeType === 4) {
          return elem.nodeValue;
        }
        return ret;
      },
      // results is for internal usage only
      makeArray: function(arr2, results) {
        var ret = results || [];
        if (arr2 != null) {
          if (isArrayLike(Object(arr2))) {
            jQuery.merge(
              ret,
              typeof arr2 === "string" ? [arr2] : arr2
            );
          } else {
            push.call(ret, arr2);
          }
        }
        return ret;
      },
      inArray: function(elem, arr2, i2) {
        return arr2 == null ? -1 : indexOf.call(arr2, elem, i2);
      },
      isXMLDoc: function(elem) {
        var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
        return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
      },
      // Support: Android <=4.0 only, PhantomJS 1 only
      // push.apply(_, arraylike) throws on ancient WebKit
      merge: function(first, second) {
        var len = +second.length, j = 0, i2 = first.length;
        for (; j < len; j++) {
          first[i2++] = second[j];
        }
        first.length = i2;
        return first;
      },
      grep: function(elems, callback, invert) {
        var callbackInverse, matches = [], i2 = 0, length2 = elems.length, callbackExpect = !invert;
        for (; i2 < length2; i2++) {
          callbackInverse = !callback(elems[i2], i2);
          if (callbackInverse !== callbackExpect) {
            matches.push(elems[i2]);
          }
        }
        return matches;
      },
      // arg is for internal usage only
      map: function(elems, callback, arg) {
        var length2, value, i2 = 0, ret = [];
        if (isArrayLike(elems)) {
          length2 = elems.length;
          for (; i2 < length2; i2++) {
            value = callback(elems[i2], i2, arg);
            if (value != null) {
              ret.push(value);
            }
          }
        } else {
          for (i2 in elems) {
            value = callback(elems[i2], i2, arg);
            if (value != null) {
              ret.push(value);
            }
          }
        }
        return flat(ret);
      },
      // A global GUID counter for objects
      guid: 1,
      // jQuery.support is not used in Core but other projects attach their
      // properties to it so it needs to exist.
      support
    });
    if (typeof Symbol === "function") {
      jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    }
    jQuery.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
      function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
      }
    );
    function isArrayLike(obj) {
      var length2 = !!obj && "length" in obj && obj.length, type = toType(obj);
      if (isFunction(obj) || isWindow(obj)) {
        return false;
      }
      return type === "array" || length2 === 0 || typeof length2 === "number" && length2 > 0 && length2 - 1 in obj;
    }
    function nodeName(elem, name) {
      return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp(
      "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
      "g"
    );
    jQuery.contains = function(a3, b) {
      var bup = b && b.parentNode;
      return a3 === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
      // IE doesn't have `contains` on SVG.
      (a3.contains ? a3.contains(bup) : a3.compareDocumentPosition && a3.compareDocumentPosition(bup) & 16));
    };
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
      if (asCodePoint) {
        if (ch === "\0") {
          return "�";
        }
        return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
      }
      return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
      return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document2, pushNative = push;
    (function() {
      var i2, Expr, outermostContext, sortInput, hasDuplicate, push2 = pushNative, document3, documentElement2, documentIsHTML, rbuggyQSA, matches, expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a3, b) {
        if (a3 === b) {
          hasDuplicate = true;
        }
        return 0;
      }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
      "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
      `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + attributes + ")*)|.*)\\)|)", rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
        ID: new RegExp("^#(" + identifier + ")"),
        CLASS: new RegExp("^\\.(" + identifier + ")"),
        TAG: new RegExp("^(" + identifier + "|[*])"),
        ATTR: new RegExp("^" + attributes),
        PSEUDO: new RegExp("^" + pseudos),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + booleans + ")$", "i"),
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
      }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rquickExpr2 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape2, nonHex) {
        var high = "0x" + escape2.slice(1) - 65536;
        if (nonHex) {
          return nonHex;
        }
        return high < 0 ? String.fromCharCode(high + 65536) : String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320);
      }, unloadHandler = function() {
        setDocument();
      }, inDisabledFieldset = addCombinator(
        function(elem) {
          return elem.disabled === true && nodeName(elem, "fieldset");
        },
        { dir: "parentNode", next: "legend" }
      );
      function safeActiveElement() {
        try {
          return document3.activeElement;
        } catch (err2) {
        }
      }
      try {
        push2.apply(
          arr = slice2.call(preferredDoc.childNodes),
          preferredDoc.childNodes
        );
        arr[preferredDoc.childNodes.length].nodeType;
      } catch (e2) {
        push2 = {
          apply: function(target, els) {
            pushNative.apply(target, slice2.call(els));
          },
          call: function(target) {
            pushNative.apply(target, slice2.call(arguments, 1));
          }
        };
      }
      function find(selector, context, results, seed) {
        var m, i3, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, nodeType = context ? context.nodeType : 9;
        results = results || [];
        if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
          return results;
        }
        if (!seed) {
          setDocument(context);
          context = context || document3;
          if (documentIsHTML) {
            if (nodeType !== 11 && (match = rquickExpr2.exec(selector))) {
              if (m = match[1]) {
                if (nodeType === 9) {
                  if (elem = context.getElementById(m)) {
                    if (elem.id === m) {
                      push2.call(results, elem);
                      return results;
                    }
                  } else {
                    return results;
                  }
                } else {
                  if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                    push2.call(results, elem);
                    return results;
                  }
                }
              } else if (match[2]) {
                push2.apply(results, context.getElementsByTagName(selector));
                return results;
              } else if ((m = match[3]) && context.getElementsByClassName) {
                push2.apply(results, context.getElementsByClassName(m));
                return results;
              }
            }
            if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
              newSelector = selector;
              newContext = context;
              if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                if (newContext != context || !support.scope) {
                  if (nid = context.getAttribute("id")) {
                    nid = jQuery.escapeSelector(nid);
                  } else {
                    context.setAttribute("id", nid = expando);
                  }
                }
                groups = tokenize(selector);
                i3 = groups.length;
                while (i3--) {
                  groups[i3] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i3]);
                }
                newSelector = groups.join(",");
              }
              try {
                push2.apply(
                  results,
                  newContext.querySelectorAll(newSelector)
                );
                return results;
              } catch (qsaError) {
                nonnativeSelectorCache(selector, true);
              } finally {
                if (nid === expando) {
                  context.removeAttribute("id");
                }
              }
            }
          }
        }
        return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
      }
      function createCache() {
        var keys = [];
        function cache(key, value) {
          if (keys.push(key + " ") > Expr.cacheLength) {
            delete cache[keys.shift()];
          }
          return cache[key + " "] = value;
        }
        return cache;
      }
      function markFunction(fn) {
        fn[expando] = true;
        return fn;
      }
      function assert(fn) {
        var el = document3.createElement("fieldset");
        try {
          return !!fn(el);
        } catch (e2) {
          return false;
        } finally {
          if (el.parentNode) {
            el.parentNode.removeChild(el);
          }
          el = null;
        }
      }
      function createInputPseudo(type) {
        return function(elem) {
          return nodeName(elem, "input") && elem.type === type;
        };
      }
      function createButtonPseudo(type) {
        return function(elem) {
          return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
        };
      }
      function createDisabledPseudo(disabled) {
        return function(elem) {
          if ("form" in elem) {
            if (elem.parentNode && elem.disabled === false) {
              if ("label" in elem) {
                if ("label" in elem.parentNode) {
                  return elem.parentNode.disabled === disabled;
                } else {
                  return elem.disabled === disabled;
                }
              }
              return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
              elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
            }
            return elem.disabled === disabled;
          } else if ("label" in elem) {
            return elem.disabled === disabled;
          }
          return false;
        };
      }
      function createPositionalPseudo(fn) {
        return markFunction(function(argument) {
          argument = +argument;
          return markFunction(function(seed, matches2) {
            var j, matchIndexes = fn([], seed.length, argument), i3 = matchIndexes.length;
            while (i3--) {
              if (seed[j = matchIndexes[i3]]) {
                seed[j] = !(matches2[j] = seed[j]);
              }
            }
          });
        });
      }
      function testContext(context) {
        return context && typeof context.getElementsByTagName !== "undefined" && context;
      }
      function setDocument(node) {
        var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
        if (doc == document3 || doc.nodeType !== 9 || !doc.documentElement) {
          return document3;
        }
        document3 = doc;
        documentElement2 = document3.documentElement;
        documentIsHTML = !jQuery.isXMLDoc(document3);
        matches = documentElement2.matches || documentElement2.webkitMatchesSelector || documentElement2.msMatchesSelector;
        if (documentElement2.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        preferredDoc != document3 && (subWindow = document3.defaultView) && subWindow.top !== subWindow) {
          subWindow.addEventListener("unload", unloadHandler);
        }
        support.getById = assert(function(el) {
          documentElement2.appendChild(el).id = jQuery.expando;
          return !document3.getElementsByName || !document3.getElementsByName(jQuery.expando).length;
        });
        support.disconnectedMatch = assert(function(el) {
          return matches.call(el, "*");
        });
        support.scope = assert(function() {
          return document3.querySelectorAll(":scope");
        });
        support.cssHas = assert(function() {
          try {
            document3.querySelector(":has(*,:jqfake)");
            return false;
          } catch (e2) {
            return true;
          }
        });
        if (support.getById) {
          Expr.filter.ID = function(id) {
            var attrId = id.replace(runescape, funescape);
            return function(elem) {
              return elem.getAttribute("id") === attrId;
            };
          };
          Expr.find.ID = function(id, context) {
            if (typeof context.getElementById !== "undefined" && documentIsHTML) {
              var elem = context.getElementById(id);
              return elem ? [elem] : [];
            }
          };
        } else {
          Expr.filter.ID = function(id) {
            var attrId = id.replace(runescape, funescape);
            return function(elem) {
              var node2 = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
              return node2 && node2.value === attrId;
            };
          };
          Expr.find.ID = function(id, context) {
            if (typeof context.getElementById !== "undefined" && documentIsHTML) {
              var node2, i3, elems, elem = context.getElementById(id);
              if (elem) {
                node2 = elem.getAttributeNode("id");
                if (node2 && node2.value === id) {
                  return [elem];
                }
                elems = context.getElementsByName(id);
                i3 = 0;
                while (elem = elems[i3++]) {
                  node2 = elem.getAttributeNode("id");
                  if (node2 && node2.value === id) {
                    return [elem];
                  }
                }
              }
              return [];
            }
          };
        }
        Expr.find.TAG = function(tag, context) {
          if (typeof context.getElementsByTagName !== "undefined") {
            return context.getElementsByTagName(tag);
          } else {
            return context.querySelectorAll(tag);
          }
        };
        Expr.find.CLASS = function(className, context) {
          if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
            return context.getElementsByClassName(className);
          }
        };
        rbuggyQSA = [];
        assert(function(el) {
          var input;
          documentElement2.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a><select id='" + expando + "-\r\\' disabled='disabled'><option selected=''></option></select>";
          if (!el.querySelectorAll("[selected]").length) {
            rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
          }
          if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
            rbuggyQSA.push("~=");
          }
          if (!el.querySelectorAll("a#" + expando + "+*").length) {
            rbuggyQSA.push(".#.+[+~]");
          }
          if (!el.querySelectorAll(":checked").length) {
            rbuggyQSA.push(":checked");
          }
          input = document3.createElement("input");
          input.setAttribute("type", "hidden");
          el.appendChild(input).setAttribute("name", "D");
          documentElement2.appendChild(el).disabled = true;
          if (el.querySelectorAll(":disabled").length !== 2) {
            rbuggyQSA.push(":enabled", ":disabled");
          }
          input = document3.createElement("input");
          input.setAttribute("name", "");
          el.appendChild(input);
          if (!el.querySelectorAll("[name='']").length) {
            rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + `*(?:''|"")`);
          }
        });
        if (!support.cssHas) {
          rbuggyQSA.push(":has");
        }
        rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
        sortOrder = function(a3, b) {
          if (a3 === b) {
            hasDuplicate = true;
            return 0;
          }
          var compare = !a3.compareDocumentPosition - !b.compareDocumentPosition;
          if (compare) {
            return compare;
          }
          compare = (a3.ownerDocument || a3) == (b.ownerDocument || b) ? a3.compareDocumentPosition(b) : (
            // Otherwise we know they are disconnected
            1
          );
          if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a3) === compare) {
            if (a3 === document3 || a3.ownerDocument == preferredDoc && find.contains(preferredDoc, a3)) {
              return -1;
            }
            if (b === document3 || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) {
              return 1;
            }
            return sortInput ? indexOf.call(sortInput, a3) - indexOf.call(sortInput, b) : 0;
          }
          return compare & 4 ? -1 : 1;
        };
        return document3;
      }
      find.matches = function(expr, elements) {
        return find(expr, null, null, elements);
      };
      find.matchesSelector = function(elem, expr) {
        setDocument(elem);
        if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
          try {
            var ret = matches.call(elem, expr);
            if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
            // fragment in IE 9
            elem.document && elem.document.nodeType !== 11) {
              return ret;
            }
          } catch (e2) {
            nonnativeSelectorCache(expr, true);
          }
        }
        return find(expr, document3, null, [elem]).length > 0;
      };
      find.contains = function(context, elem) {
        if ((context.ownerDocument || context) != document3) {
          setDocument(context);
        }
        return jQuery.contains(context, elem);
      };
      find.attr = function(elem, name) {
        if ((elem.ownerDocument || elem) != document3) {
          setDocument(elem);
        }
        var fn = Expr.attrHandle[name.toLowerCase()], val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : void 0;
        if (val !== void 0) {
          return val;
        }
        return elem.getAttribute(name);
      };
      find.error = function(msg) {
        throw new Error("Syntax error, unrecognized expression: " + msg);
      };
      jQuery.uniqueSort = function(results) {
        var elem, duplicates = [], j = 0, i3 = 0;
        hasDuplicate = !support.sortStable;
        sortInput = !support.sortStable && slice2.call(results, 0);
        sort.call(results, sortOrder);
        if (hasDuplicate) {
          while (elem = results[i3++]) {
            if (elem === results[i3]) {
              j = duplicates.push(i3);
            }
          }
          while (j--) {
            splice.call(results, duplicates[j], 1);
          }
        }
        sortInput = null;
        return results;
      };
      jQuery.fn.uniqueSort = function() {
        return this.pushStack(jQuery.uniqueSort(slice2.apply(this)));
      };
      Expr = jQuery.expr = {
        // Can be adjusted by the user
        cacheLength: 50,
        createPseudo: markFunction,
        match: matchExpr,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: true },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: true },
          "~": { dir: "previousSibling" }
        },
        preFilter: {
          ATTR: function(match) {
            match[1] = match[1].replace(runescape, funescape);
            match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
            if (match[2] === "~=") {
              match[3] = " " + match[3] + " ";
            }
            return match.slice(0, 4);
          },
          CHILD: function(match) {
            match[1] = match[1].toLowerCase();
            if (match[1].slice(0, 3) === "nth") {
              if (!match[3]) {
                find.error(match[0]);
              }
              match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
              match[5] = +(match[7] + match[8] || match[3] === "odd");
            } else if (match[3]) {
              find.error(match[0]);
            }
            return match;
          },
          PSEUDO: function(match) {
            var excess, unquoted = !match[6] && match[2];
            if (matchExpr.CHILD.test(match[0])) {
              return null;
            }
            if (match[3]) {
              match[2] = match[4] || match[5] || "";
            } else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
            (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
            (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
              match[0] = match[0].slice(0, excess);
              match[2] = unquoted.slice(0, excess);
            }
            return match.slice(0, 3);
          }
        },
        filter: {
          TAG: function(nodeNameSelector) {
            var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
            return nodeNameSelector === "*" ? function() {
              return true;
            } : function(elem) {
              return nodeName(elem, expectedNodeName);
            };
          },
          CLASS: function(className) {
            var pattern = classCache[className + " "];
            return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function(elem) {
              return pattern.test(
                typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || ""
              );
            });
          },
          ATTR: function(name, operator, check) {
            return function(elem) {
              var result = find.attr(elem, name);
              if (result == null) {
                return operator === "!=";
              }
              if (!operator) {
                return true;
              }
              result += "";
              if (operator === "=") {
                return result === check;
              }
              if (operator === "!=") {
                return result !== check;
              }
              if (operator === "^=") {
                return check && result.indexOf(check) === 0;
              }
              if (operator === "*=") {
                return check && result.indexOf(check) > -1;
              }
              if (operator === "$=") {
                return check && result.slice(-check.length) === check;
              }
              if (operator === "~=") {
                return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
              }
              if (operator === "|=") {
                return result === check || result.slice(0, check.length + 1) === check + "-";
              }
              return false;
            };
          },
          CHILD: function(type, what, _argument, first, last) {
            var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
            return first === 1 && last === 0 ? (
              // Shortcut for :nth-*(n)
              function(elem) {
                return !!elem.parentNode;
              }
            ) : function(elem, _context2, xml) {
              var cache, outerCache, node, nodeIndex, start, dir2 = simple !== forward ? "nextSibling" : "previousSibling", parent2 = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
              if (parent2) {
                if (simple) {
                  while (dir2) {
                    node = elem;
                    while (node = node[dir2]) {
                      if (ofType ? nodeName(node, name) : node.nodeType === 1) {
                        return false;
                      }
                    }
                    start = dir2 = type === "only" && !start && "nextSibling";
                  }
                  return true;
                }
                start = [forward ? parent2.firstChild : parent2.lastChild];
                if (forward && useCache) {
                  outerCache = parent2[expando] || (parent2[expando] = {});
                  cache = outerCache[type] || [];
                  nodeIndex = cache[0] === dirruns && cache[1];
                  diff = nodeIndex && cache[2];
                  node = nodeIndex && parent2.childNodes[nodeIndex];
                  while (node = ++nodeIndex && node && node[dir2] || // Fallback to seeking `elem` from the start
                  (diff = nodeIndex = 0) || start.pop()) {
                    if (node.nodeType === 1 && ++diff && node === elem) {
                      outerCache[type] = [dirruns, nodeIndex, diff];
                      break;
                    }
                  }
                } else {
                  if (useCache) {
                    outerCache = elem[expando] || (elem[expando] = {});
                    cache = outerCache[type] || [];
                    nodeIndex = cache[0] === dirruns && cache[1];
                    diff = nodeIndex;
                  }
                  if (diff === false) {
                    while (node = ++nodeIndex && node && node[dir2] || (diff = nodeIndex = 0) || start.pop()) {
                      if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                        if (useCache) {
                          outerCache = node[expando] || (node[expando] = {});
                          outerCache[type] = [dirruns, diff];
                        }
                        if (node === elem) {
                          break;
                        }
                      }
                    }
                  }
                }
                diff -= last;
                return diff === first || diff % first === 0 && diff / first >= 0;
              }
            };
          },
          PSEUDO: function(pseudo, argument) {
            var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
            if (fn[expando]) {
              return fn(argument);
            }
            if (fn.length > 1) {
              args = [pseudo, pseudo, "", argument];
              return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches2) {
                var idx, matched = fn(seed, argument), i3 = matched.length;
                while (i3--) {
                  idx = indexOf.call(seed, matched[i3]);
                  seed[idx] = !(matches2[idx] = matched[i3]);
                }
              }) : function(elem) {
                return fn(elem, 0, args);
              };
            }
            return fn;
          }
        },
        pseudos: {
          // Potentially complex pseudos
          not: markFunction(function(selector) {
            var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
            return matcher[expando] ? markFunction(function(seed, matches2, _context2, xml) {
              var elem, unmatched = matcher(seed, null, xml, []), i3 = seed.length;
              while (i3--) {
                if (elem = unmatched[i3]) {
                  seed[i3] = !(matches2[i3] = elem);
                }
              }
            }) : function(elem, _context2, xml) {
              input[0] = elem;
              matcher(input, null, xml, results);
              input[0] = null;
              return !results.pop();
            };
          }),
          has: markFunction(function(selector) {
            return function(elem) {
              return find(selector, elem).length > 0;
            };
          }),
          contains: markFunction(function(text) {
            text = text.replace(runescape, funescape);
            return function(elem) {
              return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
            };
          }),
          // "Whether an element is represented by a :lang() selector
          // is based solely on the element's language value
          // being equal to the identifier C,
          // or beginning with the identifier C immediately followed by "-".
          // The matching of C against the element's language value is performed case-insensitively.
          // The identifier C does not have to be a valid language name."
          // https://www.w3.org/TR/selectors/#lang-pseudo
          lang: markFunction(function(lang) {
            if (!ridentifier.test(lang || "")) {
              find.error("unsupported lang: " + lang);
            }
            lang = lang.replace(runescape, funescape).toLowerCase();
            return function(elem) {
              var elemLang;
              do {
                if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                  elemLang = elemLang.toLowerCase();
                  return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                }
              } while ((elem = elem.parentNode) && elem.nodeType === 1);
              return false;
            };
          }),
          // Miscellaneous
          target: function(elem) {
            var hash = window2.location && window2.location.hash;
            return hash && hash.slice(1) === elem.id;
          },
          root: function(elem) {
            return elem === documentElement2;
          },
          focus: function(elem) {
            return elem === safeActiveElement() && document3.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
          },
          // Boolean properties
          enabled: createDisabledPseudo(false),
          disabled: createDisabledPseudo(true),
          checked: function(elem) {
            return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
          },
          selected: function(elem) {
            if (elem.parentNode) {
              elem.parentNode.selectedIndex;
            }
            return elem.selected === true;
          },
          // Contents
          empty: function(elem) {
            for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
              if (elem.nodeType < 6) {
                return false;
              }
            }
            return true;
          },
          parent: function(elem) {
            return !Expr.pseudos.empty(elem);
          },
          // Element/input types
          header: function(elem) {
            return rheader.test(elem.nodeName);
          },
          input: function(elem) {
            return rinputs.test(elem.nodeName);
          },
          button: function(elem) {
            return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
          },
          text: function(elem) {
            var attr;
            return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
            // New HTML5 attribute values (e.g., "search") appear
            // with elem.type === "text"
            ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
          },
          // Position-in-collection
          first: createPositionalPseudo(function() {
            return [0];
          }),
          last: createPositionalPseudo(function(_matchIndexes, length2) {
            return [length2 - 1];
          }),
          eq: createPositionalPseudo(function(_matchIndexes, length2, argument) {
            return [argument < 0 ? argument + length2 : argument];
          }),
          even: createPositionalPseudo(function(matchIndexes, length2) {
            var i3 = 0;
            for (; i3 < length2; i3 += 2) {
              matchIndexes.push(i3);
            }
            return matchIndexes;
          }),
          odd: createPositionalPseudo(function(matchIndexes, length2) {
            var i3 = 1;
            for (; i3 < length2; i3 += 2) {
              matchIndexes.push(i3);
            }
            return matchIndexes;
          }),
          lt: createPositionalPseudo(function(matchIndexes, length2, argument) {
            var i3;
            if (argument < 0) {
              i3 = argument + length2;
            } else if (argument > length2) {
              i3 = length2;
            } else {
              i3 = argument;
            }
            for (; --i3 >= 0; ) {
              matchIndexes.push(i3);
            }
            return matchIndexes;
          }),
          gt: createPositionalPseudo(function(matchIndexes, length2, argument) {
            var i3 = argument < 0 ? argument + length2 : argument;
            for (; ++i3 < length2; ) {
              matchIndexes.push(i3);
            }
            return matchIndexes;
          })
        }
      };
      Expr.pseudos.nth = Expr.pseudos.eq;
      for (i2 in { radio: true, checkbox: true, file: true, password: true, image: true }) {
        Expr.pseudos[i2] = createInputPseudo(i2);
      }
      for (i2 in { submit: true, reset: true }) {
        Expr.pseudos[i2] = createButtonPseudo(i2);
      }
      function setFilters() {
      }
      setFilters.prototype = Expr.filters = Expr.pseudos;
      Expr.setFilters = new setFilters();
      function tokenize(selector, parseOnly) {
        var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
        if (cached) {
          return parseOnly ? 0 : cached.slice(0);
        }
        soFar = selector;
        groups = [];
        preFilters = Expr.preFilter;
        while (soFar) {
          if (!matched || (match = rcomma.exec(soFar))) {
            if (match) {
              soFar = soFar.slice(match[0].length) || soFar;
            }
            groups.push(tokens = []);
          }
          matched = false;
          if (match = rleadingCombinator.exec(soFar)) {
            matched = match.shift();
            tokens.push({
              value: matched,
              // Cast descendant combinators to space
              type: match[0].replace(rtrimCSS, " ")
            });
            soFar = soFar.slice(matched.length);
          }
          for (type in Expr.filter) {
            if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
              matched = match.shift();
              tokens.push({
                value: matched,
                type,
                matches: match
              });
              soFar = soFar.slice(matched.length);
            }
          }
          if (!matched) {
            break;
          }
        }
        if (parseOnly) {
          return soFar.length;
        }
        return soFar ? find.error(selector) : (
          // Cache the tokens
          tokenCache(selector, groups).slice(0)
        );
      }
      function toSelector(tokens) {
        var i3 = 0, len = tokens.length, selector = "";
        for (; i3 < len; i3++) {
          selector += tokens[i3].value;
        }
        return selector;
      }
      function addCombinator(matcher, combinator, base) {
        var dir2 = combinator.dir, skip = combinator.next, key = skip || dir2, checkNonElements = base && key === "parentNode", doneName = done++;
        return combinator.first ? (
          // Check against closest ancestor/preceding element
          function(elem, context, xml) {
            while (elem = elem[dir2]) {
              if (elem.nodeType === 1 || checkNonElements) {
                return matcher(elem, context, xml);
              }
            }
            return false;
          }
        ) : (
          // Check against all ancestor/preceding elements
          function(elem, context, xml) {
            var oldCache, outerCache, newCache = [dirruns, doneName];
            if (xml) {
              while (elem = elem[dir2]) {
                if (elem.nodeType === 1 || checkNonElements) {
                  if (matcher(elem, context, xml)) {
                    return true;
                  }
                }
              }
            } else {
              while (elem = elem[dir2]) {
                if (elem.nodeType === 1 || checkNonElements) {
                  outerCache = elem[expando] || (elem[expando] = {});
                  if (skip && nodeName(elem, skip)) {
                    elem = elem[dir2] || elem;
                  } else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                    return newCache[2] = oldCache[2];
                  } else {
                    outerCache[key] = newCache;
                    if (newCache[2] = matcher(elem, context, xml)) {
                      return true;
                    }
                  }
                }
              }
            }
            return false;
          }
        );
      }
      function elementMatcher(matchers) {
        return matchers.length > 1 ? function(elem, context, xml) {
          var i3 = matchers.length;
          while (i3--) {
            if (!matchers[i3](elem, context, xml)) {
              return false;
            }
          }
          return true;
        } : matchers[0];
      }
      function multipleContexts(selector, contexts, results) {
        var i3 = 0, len = contexts.length;
        for (; i3 < len; i3++) {
          find(selector, contexts[i3], results);
        }
        return results;
      }
      function condense(unmatched, map, filter, context, xml) {
        var elem, newUnmatched = [], i3 = 0, len = unmatched.length, mapped = map != null;
        for (; i3 < len; i3++) {
          if (elem = unmatched[i3]) {
            if (!filter || filter(elem, context, xml)) {
              newUnmatched.push(elem);
              if (mapped) {
                map.push(i3);
              }
            }
          }
        }
        return newUnmatched;
      }
      function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
        if (postFilter && !postFilter[expando]) {
          postFilter = setMatcher(postFilter);
        }
        if (postFinder && !postFinder[expando]) {
          postFinder = setMatcher(postFinder, postSelector);
        }
        return markFunction(function(seed, results, context, xml) {
          var temp5, i3, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, elems = seed || multipleContexts(
            selector || "*",
            context.nodeType ? [context] : context,
            []
          ), matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
          if (matcher) {
            matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? (
              // ...intermediate processing is necessary
              []
            ) : (
              // ...otherwise use results directly
              results
            );
            matcher(matcherIn, matcherOut, context, xml);
          } else {
            matcherOut = matcherIn;
          }
          if (postFilter) {
            temp5 = condense(matcherOut, postMap);
            postFilter(temp5, [], context, xml);
            i3 = temp5.length;
            while (i3--) {
              if (elem = temp5[i3]) {
                matcherOut[postMap[i3]] = !(matcherIn[postMap[i3]] = elem);
              }
            }
          }
          if (seed) {
            if (postFinder || preFilter) {
              if (postFinder) {
                temp5 = [];
                i3 = matcherOut.length;
                while (i3--) {
                  if (elem = matcherOut[i3]) {
                    temp5.push(matcherIn[i3] = elem);
                  }
                }
                postFinder(null, matcherOut = [], temp5, xml);
              }
              i3 = matcherOut.length;
              while (i3--) {
                if ((elem = matcherOut[i3]) && (temp5 = postFinder ? indexOf.call(seed, elem) : preMap[i3]) > -1) {
                  seed[temp5] = !(results[temp5] = elem);
                }
              }
            }
          } else {
            matcherOut = condense(
              matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut
            );
            if (postFinder) {
              postFinder(null, results, matcherOut, xml);
            } else {
              push2.apply(results, matcherOut);
            }
          }
        });
      }
      function matcherFromTokens(tokens) {
        var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i3 = leadingRelative ? 1 : 0, matchContext = addCombinator(function(elem) {
          return elem === checkContext;
        }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
          return indexOf.call(checkContext, elem) > -1;
        }, implicitRelative, true), matchers = [function(elem, context, xml) {
          var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
          checkContext = null;
          return ret;
        }];
        for (; i3 < len; i3++) {
          if (matcher = Expr.relative[tokens[i3].type]) {
            matchers = [addCombinator(elementMatcher(matchers), matcher)];
          } else {
            matcher = Expr.filter[tokens[i3].type].apply(null, tokens[i3].matches);
            if (matcher[expando]) {
              j = ++i3;
              for (; j < len; j++) {
                if (Expr.relative[tokens[j].type]) {
                  break;
                }
              }
              return setMatcher(
                i3 > 1 && elementMatcher(matchers),
                i3 > 1 && toSelector(
                  // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                  tokens.slice(0, i3 - 1).concat({ value: tokens[i3 - 2].type === " " ? "*" : "" })
                ).replace(rtrimCSS, "$1"),
                matcher,
                i3 < j && matcherFromTokens(tokens.slice(i3, j)),
                j < len && matcherFromTokens(tokens = tokens.slice(j)),
                j < len && toSelector(tokens)
              );
            }
            matchers.push(matcher);
          }
        }
        return elementMatcher(matchers);
      }
      function matcherFromGroupMatchers(elementMatchers, setMatchers) {
        var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
          var elem, j, matcher, matchedCount = 0, i3 = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, elems = seed || byElement && Expr.find.TAG("*", outermost), dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
          if (outermost) {
            outermostContext = context == document3 || context || outermost;
          }
          for (; i3 !== len && (elem = elems[i3]) != null; i3++) {
            if (byElement && elem) {
              j = 0;
              if (!context && elem.ownerDocument != document3) {
                setDocument(elem);
                xml = !documentIsHTML;
              }
              while (matcher = elementMatchers[j++]) {
                if (matcher(elem, context || document3, xml)) {
                  push2.call(results, elem);
                  break;
                }
              }
              if (outermost) {
                dirruns = dirrunsUnique;
              }
            }
            if (bySet) {
              if (elem = !matcher && elem) {
                matchedCount--;
              }
              if (seed) {
                unmatched.push(elem);
              }
            }
          }
          matchedCount += i3;
          if (bySet && i3 !== matchedCount) {
            j = 0;
            while (matcher = setMatchers[j++]) {
              matcher(unmatched, setMatched, context, xml);
            }
            if (seed) {
              if (matchedCount > 0) {
                while (i3--) {
                  if (!(unmatched[i3] || setMatched[i3])) {
                    setMatched[i3] = pop.call(results);
                  }
                }
              }
              setMatched = condense(setMatched);
            }
            push2.apply(results, setMatched);
            if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
              jQuery.uniqueSort(results);
            }
          }
          if (outermost) {
            dirruns = dirrunsUnique;
            outermostContext = contextBackup;
          }
          return unmatched;
        };
        return bySet ? markFunction(superMatcher) : superMatcher;
      }
      function compile(selector, match) {
        var i3, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
        if (!cached) {
          if (!match) {
            match = tokenize(selector);
          }
          i3 = match.length;
          while (i3--) {
            cached = matcherFromTokens(match[i3]);
            if (cached[expando]) {
              setMatchers.push(cached);
            } else {
              elementMatchers.push(cached);
            }
          }
          cached = compilerCache(
            selector,
            matcherFromGroupMatchers(elementMatchers, setMatchers)
          );
          cached.selector = selector;
        }
        return cached;
      }
      function select(selector, context, results, seed) {
        var i3, tokens, token, type, find2, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
        results = results || [];
        if (match.length === 1) {
          tokens = match[0] = match[0].slice(0);
          if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
            context = (Expr.find.ID(
              token.matches[0].replace(runescape, funescape),
              context
            ) || [])[0];
            if (!context) {
              return results;
            } else if (compiled) {
              context = context.parentNode;
            }
            selector = selector.slice(tokens.shift().value.length);
          }
          i3 = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
          while (i3--) {
            token = tokens[i3];
            if (Expr.relative[type = token.type]) {
              break;
            }
            if (find2 = Expr.find[type]) {
              if (seed = find2(
                token.matches[0].replace(runescape, funescape),
                rsibling.test(tokens[0].type) && testContext(context.parentNode) || context
              )) {
                tokens.splice(i3, 1);
                selector = seed.length && toSelector(tokens);
                if (!selector) {
                  push2.apply(results, seed);
                  return results;
                }
                break;
              }
            }
          }
        }
        (compiled || compile(selector, match))(
          seed,
          context,
          !documentIsHTML,
          results,
          !context || rsibling.test(selector) && testContext(context.parentNode) || context
        );
        return results;
      }
      support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
      setDocument();
      support.sortDetached = assert(function(el) {
        return el.compareDocumentPosition(document3.createElement("fieldset")) & 1;
      });
      jQuery.find = find;
      jQuery.expr[":"] = jQuery.expr.pseudos;
      jQuery.unique = jQuery.uniqueSort;
      find.compile = compile;
      find.select = select;
      find.setDocument = setDocument;
      find.tokenize = tokenize;
      find.escape = jQuery.escapeSelector;
      find.getText = jQuery.text;
      find.isXML = jQuery.isXMLDoc;
      find.selectors = jQuery.expr;
      find.support = jQuery.support;
      find.uniqueSort = jQuery.uniqueSort;
    })();
    var dir = function(elem, dir2, until) {
      var matched = [], truncate = until !== void 0;
      while ((elem = elem[dir2]) && elem.nodeType !== 9) {
        if (elem.nodeType === 1) {
          if (truncate && jQuery(elem).is(until)) {
            break;
          }
          matched.push(elem);
        }
      }
      return matched;
    };
    var siblings = function(n2, elem) {
      var matched = [];
      for (; n2; n2 = n2.nextSibling) {
        if (n2.nodeType === 1 && n2 !== elem) {
          matched.push(n2);
        }
      }
      return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function winnow(elements, qualifier, not) {
      if (isFunction(qualifier)) {
        return jQuery.grep(elements, function(elem, i2) {
          return !!qualifier.call(elem, i2, elem) !== not;
        });
      }
      if (qualifier.nodeType) {
        return jQuery.grep(elements, function(elem) {
          return elem === qualifier !== not;
        });
      }
      if (typeof qualifier !== "string") {
        return jQuery.grep(elements, function(elem) {
          return indexOf.call(qualifier, elem) > -1 !== not;
        });
      }
      return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
      var elem = elems[0];
      if (not) {
        expr = ":not(" + expr + ")";
      }
      if (elems.length === 1 && elem.nodeType === 1) {
        return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
      }
      return jQuery.find.matches(expr, jQuery.grep(elems, function(elem2) {
        return elem2.nodeType === 1;
      }));
    };
    jQuery.fn.extend({
      find: function(selector) {
        var i2, ret, len = this.length, self2 = this;
        if (typeof selector !== "string") {
          return this.pushStack(jQuery(selector).filter(function() {
            for (i2 = 0; i2 < len; i2++) {
              if (jQuery.contains(self2[i2], this)) {
                return true;
              }
            }
          }));
        }
        ret = this.pushStack([]);
        for (i2 = 0; i2 < len; i2++) {
          jQuery.find(selector, self2[i2], ret);
        }
        return len > 1 ? jQuery.uniqueSort(ret) : ret;
      },
      filter: function(selector) {
        return this.pushStack(winnow(this, selector || [], false));
      },
      not: function(selector) {
        return this.pushStack(winnow(this, selector || [], true));
      },
      is: function(selector) {
        return !!winnow(
          this,
          // If this is a positional/relative selector, check membership in the returned set
          // so $("p:first").is("p:last") won't return true for a doc with two "p".
          typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [],
          false
        ).length;
      }
    });
    var rootjQuery, rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
      var match, elem;
      if (!selector) {
        return this;
      }
      root = root || rootjQuery;
      if (typeof selector === "string") {
        if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
          match = [null, selector, null];
        } else {
          match = rquickExpr.exec(selector);
        }
        if (match && (match[1] || !context)) {
          if (match[1]) {
            context = context instanceof jQuery ? context[0] : context;
            jQuery.merge(this, jQuery.parseHTML(
              match[1],
              context && context.nodeType ? context.ownerDocument || context : document2,
              true
            ));
            if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
              for (match in context) {
                if (isFunction(this[match])) {
                  this[match](context[match]);
                } else {
                  this.attr(match, context[match]);
                }
              }
            }
            return this;
          } else {
            elem = document2.getElementById(match[2]);
            if (elem) {
              this[0] = elem;
              this.length = 1;
            }
            return this;
          }
        } else if (!context || context.jquery) {
          return (context || root).find(selector);
        } else {
          return this.constructor(context).find(selector);
        }
      } else if (selector.nodeType) {
        this[0] = selector;
        this.length = 1;
        return this;
      } else if (isFunction(selector)) {
        return root.ready !== void 0 ? root.ready(selector) : (
          // Execute immediately if ready is not present
          selector(jQuery)
        );
      }
      return jQuery.makeArray(selector, this);
    };
    init.prototype = jQuery.fn;
    rootjQuery = jQuery(document2);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, guaranteedUnique = {
      children: true,
      contents: true,
      next: true,
      prev: true
    };
    jQuery.fn.extend({
      has: function(target) {
        var targets = jQuery(target, this), l2 = targets.length;
        return this.filter(function() {
          var i2 = 0;
          for (; i2 < l2; i2++) {
            if (jQuery.contains(this, targets[i2])) {
              return true;
            }
          }
        });
      },
      closest: function(selectors, context) {
        var cur, i2 = 0, l2 = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
        if (!rneedsContext.test(selectors)) {
          for (; i2 < l2; i2++) {
            for (cur = this[i2]; cur && cur !== context; cur = cur.parentNode) {
              if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : (
                // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors)
              ))) {
                matched.push(cur);
                break;
              }
            }
          }
        }
        return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
      },
      // Determine the position of an element within the set
      index: function(elem) {
        if (!elem) {
          return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        }
        if (typeof elem === "string") {
          return indexOf.call(jQuery(elem), this[0]);
        }
        return indexOf.call(
          this,
          // If it receives a jQuery object, the first element is used
          elem.jquery ? elem[0] : elem
        );
      },
      add: function(selector, context) {
        return this.pushStack(
          jQuery.uniqueSort(
            jQuery.merge(this.get(), jQuery(selector, context))
          )
        );
      },
      addBack: function(selector) {
        return this.add(
          selector == null ? this.prevObject : this.prevObject.filter(selector)
        );
      }
    });
    function sibling(cur, dir2) {
      while ((cur = cur[dir2]) && cur.nodeType !== 1) {
      }
      return cur;
    }
    jQuery.each({
      parent: function(elem) {
        var parent2 = elem.parentNode;
        return parent2 && parent2.nodeType !== 11 ? parent2 : null;
      },
      parents: function(elem) {
        return dir(elem, "parentNode");
      },
      parentsUntil: function(elem, _i, until) {
        return dir(elem, "parentNode", until);
      },
      next: function(elem) {
        return sibling(elem, "nextSibling");
      },
      prev: function(elem) {
        return sibling(elem, "previousSibling");
      },
      nextAll: function(elem) {
        return dir(elem, "nextSibling");
      },
      prevAll: function(elem) {
        return dir(elem, "previousSibling");
      },
      nextUntil: function(elem, _i, until) {
        return dir(elem, "nextSibling", until);
      },
      prevUntil: function(elem, _i, until) {
        return dir(elem, "previousSibling", until);
      },
      siblings: function(elem) {
        return siblings((elem.parentNode || {}).firstChild, elem);
      },
      children: function(elem) {
        return siblings(elem.firstChild);
      },
      contents: function(elem) {
        if (elem.contentDocument != null && // Support: IE 11+
        // <object> elements with no `data` attribute has an object
        // `contentDocument` with a `null` prototype.
        getProto(elem.contentDocument)) {
          return elem.contentDocument;
        }
        if (nodeName(elem, "template")) {
          elem = elem.content || elem;
        }
        return jQuery.merge([], elem.childNodes);
      }
    }, function(name, fn) {
      jQuery.fn[name] = function(until, selector) {
        var matched = jQuery.map(this, fn, until);
        if (name.slice(-5) !== "Until") {
          selector = until;
        }
        if (selector && typeof selector === "string") {
          matched = jQuery.filter(selector, matched);
        }
        if (this.length > 1) {
          if (!guaranteedUnique[name]) {
            jQuery.uniqueSort(matched);
          }
          if (rparentsprev.test(name)) {
            matched.reverse();
          }
        }
        return this.pushStack(matched);
      };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    function createOptions(options) {
      var object = {};
      jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
        object[flag] = true;
      });
      return object;
    }
    jQuery.Callbacks = function(options) {
      options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
      var firing, memory, fired, locked, list = [], queue = [], firingIndex = -1, fire = function() {
        locked = locked || options.once;
        fired = firing = true;
        for (; queue.length; firingIndex = -1) {
          memory = queue.shift();
          while (++firingIndex < list.length) {
            if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
              firingIndex = list.length;
              memory = false;
            }
          }
        }
        if (!options.memory) {
          memory = false;
        }
        firing = false;
        if (locked) {
          if (memory) {
            list = [];
          } else {
            list = "";
          }
        }
      }, self2 = {
        // Add a callback or a collection of callbacks to the list
        add: function() {
          if (list) {
            if (memory && !firing) {
              firingIndex = list.length - 1;
              queue.push(memory);
            }
            (function add(args) {
              jQuery.each(args, function(_, arg) {
                if (isFunction(arg)) {
                  if (!options.unique || !self2.has(arg)) {
                    list.push(arg);
                  }
                } else if (arg && arg.length && toType(arg) !== "string") {
                  add(arg);
                }
              });
            })(arguments);
            if (memory && !firing) {
              fire();
            }
          }
          return this;
        },
        // Remove a callback from the list
        remove: function() {
          jQuery.each(arguments, function(_, arg) {
            var index2;
            while ((index2 = jQuery.inArray(arg, list, index2)) > -1) {
              list.splice(index2, 1);
              if (index2 <= firingIndex) {
                firingIndex--;
              }
            }
          });
          return this;
        },
        // Check if a given callback is in the list.
        // If no argument is given, return whether or not list has callbacks attached.
        has: function(fn) {
          return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
        },
        // Remove all callbacks from the list
        empty: function() {
          if (list) {
            list = [];
          }
          return this;
        },
        // Disable .fire and .add
        // Abort any current/pending executions
        // Clear all callbacks and values
        disable: function() {
          locked = queue = [];
          list = memory = "";
          return this;
        },
        disabled: function() {
          return !list;
        },
        // Disable .fire
        // Also disable .add unless we have memory (since it would have no effect)
        // Abort any pending executions
        lock: function() {
          locked = queue = [];
          if (!memory && !firing) {
            list = memory = "";
          }
          return this;
        },
        locked: function() {
          return !!locked;
        },
        // Call all callbacks with the given context and arguments
        fireWith: function(context, args) {
          if (!locked) {
            args = args || [];
            args = [context, args.slice ? args.slice() : args];
            queue.push(args);
            if (!firing) {
              fire();
            }
          }
          return this;
        },
        // Call all the callbacks with the given arguments
        fire: function() {
          self2.fireWith(this, arguments);
          return this;
        },
        // To know if the callbacks have already been called at least once
        fired: function() {
          return !!fired;
        }
      };
      return self2;
    };
    function Identity(v) {
      return v;
    }
    function Thrower(ex) {
      throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
      var method;
      try {
        if (value && isFunction(method = value.promise)) {
          method.call(value).done(resolve).fail(reject);
        } else if (value && isFunction(method = value.then)) {
          method.call(value, resolve, reject);
        } else {
          resolve.apply(void 0, [value].slice(noValue));
        }
      } catch (value2) {
        reject.apply(void 0, [value2]);
      }
    }
    jQuery.extend({
      Deferred: function(func) {
        var tuples = [
          // action, add listener, callbacks,
          // ... .then handlers, argument index, [final state]
          [
            "notify",
            "progress",
            jQuery.Callbacks("memory"),
            jQuery.Callbacks("memory"),
            2
          ],
          [
            "resolve",
            "done",
            jQuery.Callbacks("once memory"),
            jQuery.Callbacks("once memory"),
            0,
            "resolved"
          ],
          [
            "reject",
            "fail",
            jQuery.Callbacks("once memory"),
            jQuery.Callbacks("once memory"),
            1,
            "rejected"
          ]
        ], state = "pending", promise = {
          state: function() {
            return state;
          },
          always: function() {
            deferred.done(arguments).fail(arguments);
            return this;
          },
          "catch": function(fn) {
            return promise.then(null, fn);
          },
          // Keep pipe for back-compat
          pipe: function() {
            var fns = arguments;
            return jQuery.Deferred(function(newDefer) {
              jQuery.each(tuples, function(_i, tuple) {
                var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                deferred[tuple[1]](function() {
                  var returned = fn && fn.apply(this, arguments);
                  if (returned && isFunction(returned.promise)) {
                    returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                  } else {
                    newDefer[tuple[0] + "With"](
                      this,
                      fn ? [returned] : arguments
                    );
                  }
                });
              });
              fns = null;
            }).promise();
          },
          then: function(onFulfilled, onRejected, onProgress) {
            var maxDepth = 0;
            function resolve(depth, deferred2, handler, special) {
              return function() {
                var that = this, args = arguments, mightThrow = function() {
                  var returned, then;
                  if (depth < maxDepth) {
                    return;
                  }
                  returned = handler.apply(that, args);
                  if (returned === deferred2.promise()) {
                    throw new TypeError("Thenable self-resolution");
                  }
                  then = returned && // Support: Promises/A+ section 2.3.4
                  // https://promisesaplus.com/#point-64
                  // Only check objects and functions for thenability
                  (typeof returned === "object" || typeof returned === "function") && returned.then;
                  if (isFunction(then)) {
                    if (special) {
                      then.call(
                        returned,
                        resolve(maxDepth, deferred2, Identity, special),
                        resolve(maxDepth, deferred2, Thrower, special)
                      );
                    } else {
                      maxDepth++;
                      then.call(
                        returned,
                        resolve(maxDepth, deferred2, Identity, special),
                        resolve(maxDepth, deferred2, Thrower, special),
                        resolve(
                          maxDepth,
                          deferred2,
                          Identity,
                          deferred2.notifyWith
                        )
                      );
                    }
                  } else {
                    if (handler !== Identity) {
                      that = void 0;
                      args = [returned];
                    }
                    (special || deferred2.resolveWith)(that, args);
                  }
                }, process = special ? mightThrow : function() {
                  try {
                    mightThrow();
                  } catch (e2) {
                    if (jQuery.Deferred.exceptionHook) {
                      jQuery.Deferred.exceptionHook(
                        e2,
                        process.error
                      );
                    }
                    if (depth + 1 >= maxDepth) {
                      if (handler !== Thrower) {
                        that = void 0;
                        args = [e2];
                      }
                      deferred2.rejectWith(that, args);
                    }
                  }
                };
                if (depth) {
                  process();
                } else {
                  if (jQuery.Deferred.getErrorHook) {
                    process.error = jQuery.Deferred.getErrorHook();
                  } else if (jQuery.Deferred.getStackHook) {
                    process.error = jQuery.Deferred.getStackHook();
                  }
                  window2.setTimeout(process);
                }
              };
            }
            return jQuery.Deferred(function(newDefer) {
              tuples[0][3].add(
                resolve(
                  0,
                  newDefer,
                  isFunction(onProgress) ? onProgress : Identity,
                  newDefer.notifyWith
                )
              );
              tuples[1][3].add(
                resolve(
                  0,
                  newDefer,
                  isFunction(onFulfilled) ? onFulfilled : Identity
                )
              );
              tuples[2][3].add(
                resolve(
                  0,
                  newDefer,
                  isFunction(onRejected) ? onRejected : Thrower
                )
              );
            }).promise();
          },
          // Get a promise for this deferred
          // If obj is provided, the promise aspect is added to the object
          promise: function(obj) {
            return obj != null ? jQuery.extend(obj, promise) : promise;
          }
        }, deferred = {};
        jQuery.each(tuples, function(i2, tuple) {
          var list = tuple[2], stateString = tuple[5];
          promise[tuple[1]] = list.add;
          if (stateString) {
            list.add(
              function() {
                state = stateString;
              },
              // rejected_callbacks.disable
              // fulfilled_callbacks.disable
              tuples[3 - i2][2].disable,
              // rejected_handlers.disable
              // fulfilled_handlers.disable
              tuples[3 - i2][3].disable,
              // progress_callbacks.lock
              tuples[0][2].lock,
              // progress_handlers.lock
              tuples[0][3].lock
            );
          }
          list.add(tuple[3].fire);
          deferred[tuple[0]] = function() {
            deferred[tuple[0] + "With"](this === deferred ? void 0 : this, arguments);
            return this;
          };
          deferred[tuple[0] + "With"] = list.fireWith;
        });
        promise.promise(deferred);
        if (func) {
          func.call(deferred, deferred);
        }
        return deferred;
      },
      // Deferred helper
      when: function(singleValue) {
        var remaining = arguments.length, i2 = remaining, resolveContexts = Array(i2), resolveValues = slice2.call(arguments), primary = jQuery.Deferred(), updateFunc = function(i3) {
          return function(value) {
            resolveContexts[i3] = this;
            resolveValues[i3] = arguments.length > 1 ? slice2.call(arguments) : value;
            if (!--remaining) {
              primary.resolveWith(resolveContexts, resolveValues);
            }
          };
        };
        if (remaining <= 1) {
          adoptValue(
            singleValue,
            primary.done(updateFunc(i2)).resolve,
            primary.reject,
            !remaining
          );
          if (primary.state() === "pending" || isFunction(resolveValues[i2] && resolveValues[i2].then)) {
            return primary.then();
          }
        }
        while (i2--) {
          adoptValue(resolveValues[i2], updateFunc(i2), primary.reject);
        }
        return primary.promise();
      }
    });
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
      if (window2.console && window2.console.warn && error && rerrorNames.test(error.name)) {
        window2.console.warn(
          "jQuery.Deferred exception: " + error.message,
          error.stack,
          asyncError
        );
      }
    };
    jQuery.readyException = function(error) {
      window2.setTimeout(function() {
        throw error;
      });
    };
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
      readyList.then(fn).catch(function(error) {
        jQuery.readyException(error);
      });
      return this;
    };
    jQuery.extend({
      // Is the DOM ready to be used? Set to true once it occurs.
      isReady: false,
      // A counter to track how many items to wait for before
      // the ready event fires. See trac-6781
      readyWait: 1,
      // Handle when the DOM is ready
      ready: function(wait) {
        if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
          return;
        }
        jQuery.isReady = true;
        if (wait !== true && --jQuery.readyWait > 0) {
          return;
        }
        readyList.resolveWith(document2, [jQuery]);
      }
    });
    jQuery.ready.then = readyList.then;
    function completed() {
      document2.removeEventListener("DOMContentLoaded", completed);
      window2.removeEventListener("load", completed);
      jQuery.ready();
    }
    if (document2.readyState === "complete" || document2.readyState !== "loading" && !document2.documentElement.doScroll) {
      window2.setTimeout(jQuery.ready);
    } else {
      document2.addEventListener("DOMContentLoaded", completed);
      window2.addEventListener("load", completed);
    }
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
      var i2 = 0, len = elems.length, bulk = key == null;
      if (toType(key) === "object") {
        chainable = true;
        for (i2 in key) {
          access(elems, fn, i2, key[i2], true, emptyGet, raw);
        }
      } else if (value !== void 0) {
        chainable = true;
        if (!isFunction(value)) {
          raw = true;
        }
        if (bulk) {
          if (raw) {
            fn.call(elems, value);
            fn = null;
          } else {
            bulk = fn;
            fn = function(elem, _key, value2) {
              return bulk.call(jQuery(elem), value2);
            };
          }
        }
        if (fn) {
          for (; i2 < len; i2++) {
            fn(
              elems[i2],
              key,
              raw ? value : value.call(elems[i2], i2, fn(elems[i2], key))
            );
          }
        }
      }
      if (chainable) {
        return elems;
      }
      if (bulk) {
        return fn.call(elems);
      }
      return len ? fn(elems[0], key) : emptyGet;
    };
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    function fcamelCase(_all, letter) {
      return letter.toUpperCase();
    }
    function camelCase(string) {
      return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
      return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
      this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
      cache: function(owner) {
        var value = owner[this.expando];
        if (!value) {
          value = {};
          if (acceptData(owner)) {
            if (owner.nodeType) {
              owner[this.expando] = value;
            } else {
              Object.defineProperty(owner, this.expando, {
                value,
                configurable: true
              });
            }
          }
        }
        return value;
      },
      set: function(owner, data, value) {
        var prop, cache = this.cache(owner);
        if (typeof data === "string") {
          cache[camelCase(data)] = value;
        } else {
          for (prop in data) {
            cache[camelCase(prop)] = data[prop];
          }
        }
        return cache;
      },
      get: function(owner, key) {
        return key === void 0 ? this.cache(owner) : (
          // Always use camelCase key (gh-2257)
          owner[this.expando] && owner[this.expando][camelCase(key)]
        );
      },
      access: function(owner, key, value) {
        if (key === void 0 || key && typeof key === "string" && value === void 0) {
          return this.get(owner, key);
        }
        this.set(owner, key, value);
        return value !== void 0 ? value : key;
      },
      remove: function(owner, key) {
        var i2, cache = owner[this.expando];
        if (cache === void 0) {
          return;
        }
        if (key !== void 0) {
          if (Array.isArray(key)) {
            key = key.map(camelCase);
          } else {
            key = camelCase(key);
            key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
          }
          i2 = key.length;
          while (i2--) {
            delete cache[key[i2]];
          }
        }
        if (key === void 0 || jQuery.isEmptyObject(cache)) {
          if (owner.nodeType) {
            owner[this.expando] = void 0;
          } else {
            delete owner[this.expando];
          }
        }
      },
      hasData: function(owner) {
        var cache = owner[this.expando];
        return cache !== void 0 && !jQuery.isEmptyObject(cache);
      }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData2(data) {
      if (data === "true") {
        return true;
      }
      if (data === "false") {
        return false;
      }
      if (data === "null") {
        return null;
      }
      if (data === +data + "") {
        return +data;
      }
      if (rbrace.test(data)) {
        return JSON.parse(data);
      }
      return data;
    }
    function dataAttr(elem, key, data) {
      var name;
      if (data === void 0 && elem.nodeType === 1) {
        name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
        data = elem.getAttribute(name);
        if (typeof data === "string") {
          try {
            data = getData2(data);
          } catch (e2) {
          }
          dataUser.set(elem, key, data);
        } else {
          data = void 0;
        }
      }
      return data;
    }
    jQuery.extend({
      hasData: function(elem) {
        return dataUser.hasData(elem) || dataPriv.hasData(elem);
      },
      data: function(elem, name, data) {
        return dataUser.access(elem, name, data);
      },
      removeData: function(elem, name) {
        dataUser.remove(elem, name);
      },
      // TODO: Now that all calls to _data and _removeData have been replaced
      // with direct calls to dataPriv methods, these can be deprecated.
      _data: function(elem, name, data) {
        return dataPriv.access(elem, name, data);
      },
      _removeData: function(elem, name) {
        dataPriv.remove(elem, name);
      }
    });
    jQuery.fn.extend({
      data: function(key, value) {
        var i2, name, data, elem = this[0], attrs = elem && elem.attributes;
        if (key === void 0) {
          if (this.length) {
            data = dataUser.get(elem);
            if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
              i2 = attrs.length;
              while (i2--) {
                if (attrs[i2]) {
                  name = attrs[i2].name;
                  if (name.indexOf("data-") === 0) {
                    name = camelCase(name.slice(5));
                    dataAttr(elem, name, data[name]);
                  }
                }
              }
              dataPriv.set(elem, "hasDataAttrs", true);
            }
          }
          return data;
        }
        if (typeof key === "object") {
          return this.each(function() {
            dataUser.set(this, key);
          });
        }
        return access(this, function(value2) {
          var data2;
          if (elem && value2 === void 0) {
            data2 = dataUser.get(elem, key);
            if (data2 !== void 0) {
              return data2;
            }
            data2 = dataAttr(elem, key);
            if (data2 !== void 0) {
              return data2;
            }
            return;
          }
          this.each(function() {
            dataUser.set(this, key, value2);
          });
        }, null, value, arguments.length > 1, null, true);
      },
      removeData: function(key) {
        return this.each(function() {
          dataUser.remove(this, key);
        });
      }
    });
    jQuery.extend({
      queue: function(elem, type, data) {
        var queue;
        if (elem) {
          type = (type || "fx") + "queue";
          queue = dataPriv.get(elem, type);
          if (data) {
            if (!queue || Array.isArray(data)) {
              queue = dataPriv.access(elem, type, jQuery.makeArray(data));
            } else {
              queue.push(data);
            }
          }
          return queue || [];
        }
      },
      dequeue: function(elem, type) {
        type = type || "fx";
        var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
          jQuery.dequeue(elem, type);
        };
        if (fn === "inprogress") {
          fn = queue.shift();
          startLength--;
        }
        if (fn) {
          if (type === "fx") {
            queue.unshift("inprogress");
          }
          delete hooks.stop;
          fn.call(elem, next, hooks);
        }
        if (!startLength && hooks) {
          hooks.empty.fire();
        }
      },
      // Not public - generate a queueHooks object, or return the current one
      _queueHooks: function(elem, type) {
        var key = type + "queueHooks";
        return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
          empty: jQuery.Callbacks("once memory").add(function() {
            dataPriv.remove(elem, [type + "queue", key]);
          })
        });
      }
    });
    jQuery.fn.extend({
      queue: function(type, data) {
        var setter = 2;
        if (typeof type !== "string") {
          data = type;
          type = "fx";
          setter--;
        }
        if (arguments.length < setter) {
          return jQuery.queue(this[0], type);
        }
        return data === void 0 ? this : this.each(function() {
          var queue = jQuery.queue(this, type, data);
          jQuery._queueHooks(this, type);
          if (type === "fx" && queue[0] !== "inprogress") {
            jQuery.dequeue(this, type);
          }
        });
      },
      dequeue: function(type) {
        return this.each(function() {
          jQuery.dequeue(this, type);
        });
      },
      clearQueue: function(type) {
        return this.queue(type || "fx", []);
      },
      // Get a promise resolved when queues of a certain type
      // are emptied (fx is the type by default)
      promise: function(type, obj) {
        var tmp2, count = 1, defer = jQuery.Deferred(), elements = this, i2 = this.length, resolve = function() {
          if (!--count) {
            defer.resolveWith(elements, [elements]);
          }
        };
        if (typeof type !== "string") {
          obj = type;
          type = void 0;
        }
        type = type || "fx";
        while (i2--) {
          tmp2 = dataPriv.get(elements[i2], type + "queueHooks");
          if (tmp2 && tmp2.empty) {
            count++;
            tmp2.empty.add(resolve);
          }
        }
        resolve();
        return defer.promise(obj);
      }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = ["Top", "Right", "Bottom", "Left"];
    var documentElement = document2.documentElement;
    var isAttached = function(elem) {
      return jQuery.contains(elem.ownerDocument, elem);
    }, composed = { composed: true };
    if (documentElement.getRootNode) {
      isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
      };
    }
    var isHiddenWithinTree = function(elem, el) {
      elem = el || elem;
      return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
      // Support: Firefox <=43 - 45
      // Disconnected elements can have computed display: none, so first confirm that elem is
      // in the document.
      isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
      var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
        return tween.cur();
      } : function() {
        return jQuery.css(elem, prop, "");
      }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
      if (initialInUnit && initialInUnit[3] !== unit) {
        initial = initial / 2;
        unit = unit || initialInUnit[3];
        initialInUnit = +initial || 1;
        while (maxIterations--) {
          jQuery.style(elem, prop, initialInUnit + unit);
          if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
            maxIterations = 0;
          }
          initialInUnit = initialInUnit / scale;
        }
        initialInUnit = initialInUnit * 2;
        jQuery.style(elem, prop, initialInUnit + unit);
        valueParts = valueParts || [];
      }
      if (valueParts) {
        initialInUnit = +initialInUnit || +initial || 0;
        adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
        if (tween) {
          tween.unit = unit;
          tween.start = initialInUnit;
          tween.end = adjusted;
        }
      }
      return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
      var temp5, doc = elem.ownerDocument, nodeName2 = elem.nodeName, display2 = defaultDisplayMap[nodeName2];
      if (display2) {
        return display2;
      }
      temp5 = doc.body.appendChild(doc.createElement(nodeName2));
      display2 = jQuery.css(temp5, "display");
      temp5.parentNode.removeChild(temp5);
      if (display2 === "none") {
        display2 = "block";
      }
      defaultDisplayMap[nodeName2] = display2;
      return display2;
    }
    function showHide(elements, show) {
      var display2, elem, values = [], index2 = 0, length2 = elements.length;
      for (; index2 < length2; index2++) {
        elem = elements[index2];
        if (!elem.style) {
          continue;
        }
        display2 = elem.style.display;
        if (show) {
          if (display2 === "none") {
            values[index2] = dataPriv.get(elem, "display") || null;
            if (!values[index2]) {
              elem.style.display = "";
            }
          }
          if (elem.style.display === "" && isHiddenWithinTree(elem)) {
            values[index2] = getDefaultDisplay(elem);
          }
        } else {
          if (display2 !== "none") {
            values[index2] = "none";
            dataPriv.set(elem, "display", display2);
          }
        }
      }
      for (index2 = 0; index2 < length2; index2++) {
        if (values[index2] != null) {
          elements[index2].style.display = values[index2];
        }
      }
      return elements;
    }
    jQuery.fn.extend({
      show: function() {
        return showHide(this, true);
      },
      hide: function() {
        return showHide(this);
      },
      toggle: function(state) {
        if (typeof state === "boolean") {
          return state ? this.show() : this.hide();
        }
        return this.each(function() {
          if (isHiddenWithinTree(this)) {
            jQuery(this).show();
          } else {
            jQuery(this).hide();
          }
        });
      }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
      var fragment2 = document2.createDocumentFragment(), div = fragment2.appendChild(document2.createElement("div")), input = document2.createElement("input");
      input.setAttribute("type", "radio");
      input.setAttribute("checked", "checked");
      input.setAttribute("name", "t");
      div.appendChild(input);
      support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
      div.innerHTML = "<textarea>x</textarea>";
      support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
      div.innerHTML = "<option></option>";
      support.option = !!div.lastChild;
    })();
    var wrapMap = {
      // XHTML parsers do not magically insert elements in the
      // same way that tag soup parsers do. So we cannot shorten
      // this by omitting <tbody> or other required elements.
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    if (!support.option) {
      wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
    }
    function getAll(context, tag) {
      var ret;
      if (typeof context.getElementsByTagName !== "undefined") {
        ret = context.getElementsByTagName(tag || "*");
      } else if (typeof context.querySelectorAll !== "undefined") {
        ret = context.querySelectorAll(tag || "*");
      } else {
        ret = [];
      }
      if (tag === void 0 || tag && nodeName(context, tag)) {
        return jQuery.merge([context], ret);
      }
      return ret;
    }
    function setGlobalEval(elems, refElements) {
      var i2 = 0, l2 = elems.length;
      for (; i2 < l2; i2++) {
        dataPriv.set(
          elems[i2],
          "globalEval",
          !refElements || dataPriv.get(refElements[i2], "globalEval")
        );
      }
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
      var elem, tmp2, tag, wrap, attached, j, fragment2 = context.createDocumentFragment(), nodes = [], i2 = 0, l2 = elems.length;
      for (; i2 < l2; i2++) {
        elem = elems[i2];
        if (elem || elem === 0) {
          if (toType(elem) === "object") {
            jQuery.merge(nodes, elem.nodeType ? [elem] : elem);
          } else if (!rhtml.test(elem)) {
            nodes.push(context.createTextNode(elem));
          } else {
            tmp2 = tmp2 || fragment2.appendChild(context.createElement("div"));
            tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
            wrap = wrapMap[tag] || wrapMap._default;
            tmp2.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
            j = wrap[0];
            while (j--) {
              tmp2 = tmp2.lastChild;
            }
            jQuery.merge(nodes, tmp2.childNodes);
            tmp2 = fragment2.firstChild;
            tmp2.textContent = "";
          }
        }
      }
      fragment2.textContent = "";
      i2 = 0;
      while (elem = nodes[i2++]) {
        if (selection && jQuery.inArray(elem, selection) > -1) {
          if (ignored) {
            ignored.push(elem);
          }
          continue;
        }
        attached = isAttached(elem);
        tmp2 = getAll(fragment2.appendChild(elem), "script");
        if (attached) {
          setGlobalEval(tmp2);
        }
        if (scripts) {
          j = 0;
          while (elem = tmp2[j++]) {
            if (rscriptType.test(elem.type || "")) {
              scripts.push(elem);
            }
          }
        }
      }
      return fragment2;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
      return true;
    }
    function returnFalse() {
      return false;
    }
    function on(elem, types, selector, data, fn, one) {
      var origFn, type;
      if (typeof types === "object") {
        if (typeof selector !== "string") {
          data = data || selector;
          selector = void 0;
        }
        for (type in types) {
          on(elem, type, selector, data, types[type], one);
        }
        return elem;
      }
      if (data == null && fn == null) {
        fn = selector;
        data = selector = void 0;
      } else if (fn == null) {
        if (typeof selector === "string") {
          fn = data;
          data = void 0;
        } else {
          fn = data;
          data = selector;
          selector = void 0;
        }
      }
      if (fn === false) {
        fn = returnFalse;
      } else if (!fn) {
        return elem;
      }
      if (one === 1) {
        origFn = fn;
        fn = function(event) {
          jQuery().off(event);
          return origFn.apply(this, arguments);
        };
        fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
      }
      return elem.each(function() {
        jQuery.event.add(this, types, fn, data, selector);
      });
    }
    jQuery.event = {
      global: {},
      add: function(elem, types, handler, data, selector) {
        var handleObjIn, eventHandle, tmp2, events, t3, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
        if (!acceptData(elem)) {
          return;
        }
        if (handler.handler) {
          handleObjIn = handler;
          handler = handleObjIn.handler;
          selector = handleObjIn.selector;
        }
        if (selector) {
          jQuery.find.matchesSelector(documentElement, selector);
        }
        if (!handler.guid) {
          handler.guid = jQuery.guid++;
        }
        if (!(events = elemData.events)) {
          events = elemData.events = /* @__PURE__ */ Object.create(null);
        }
        if (!(eventHandle = elemData.handle)) {
          eventHandle = elemData.handle = function(e2) {
            return typeof jQuery !== "undefined" && jQuery.event.triggered !== e2.type ? jQuery.event.dispatch.apply(elem, arguments) : void 0;
          };
        }
        types = (types || "").match(rnothtmlwhite) || [""];
        t3 = types.length;
        while (t3--) {
          tmp2 = rtypenamespace.exec(types[t3]) || [];
          type = origType = tmp2[1];
          namespaces = (tmp2[2] || "").split(".").sort();
          if (!type) {
            continue;
          }
          special = jQuery.event.special[type] || {};
          type = (selector ? special.delegateType : special.bindType) || type;
          special = jQuery.event.special[type] || {};
          handleObj = jQuery.extend({
            type,
            origType,
            data,
            handler,
            guid: handler.guid,
            selector,
            needsContext: selector && jQuery.expr.match.needsContext.test(selector),
            namespace: namespaces.join(".")
          }, handleObjIn);
          if (!(handlers = events[type])) {
            handlers = events[type] = [];
            handlers.delegateCount = 0;
            if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
              if (elem.addEventListener) {
                elem.addEventListener(type, eventHandle);
              }
            }
          }
          if (special.add) {
            special.add.call(elem, handleObj);
            if (!handleObj.handler.guid) {
              handleObj.handler.guid = handler.guid;
            }
          }
          if (selector) {
            handlers.splice(handlers.delegateCount++, 0, handleObj);
          } else {
            handlers.push(handleObj);
          }
          jQuery.event.global[type] = true;
        }
      },
      // Detach an event or set of events from an element
      remove: function(elem, types, handler, selector, mappedTypes) {
        var j, origCount, tmp2, events, t3, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
        if (!elemData || !(events = elemData.events)) {
          return;
        }
        types = (types || "").match(rnothtmlwhite) || [""];
        t3 = types.length;
        while (t3--) {
          tmp2 = rtypenamespace.exec(types[t3]) || [];
          type = origType = tmp2[1];
          namespaces = (tmp2[2] || "").split(".").sort();
          if (!type) {
            for (type in events) {
              jQuery.event.remove(elem, type + types[t3], handler, selector, true);
            }
            continue;
          }
          special = jQuery.event.special[type] || {};
          type = (selector ? special.delegateType : special.bindType) || type;
          handlers = events[type] || [];
          tmp2 = tmp2[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
          origCount = j = handlers.length;
          while (j--) {
            handleObj = handlers[j];
            if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp2 || tmp2.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
              handlers.splice(j, 1);
              if (handleObj.selector) {
                handlers.delegateCount--;
              }
              if (special.remove) {
                special.remove.call(elem, handleObj);
              }
            }
          }
          if (origCount && !handlers.length) {
            if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
              jQuery.removeEvent(elem, type, elemData.handle);
            }
            delete events[type];
          }
        }
        if (jQuery.isEmptyObject(events)) {
          dataPriv.remove(elem, "handle events");
        }
      },
      dispatch: function(nativeEvent) {
        var i2, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || /* @__PURE__ */ Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
        args[0] = event;
        for (i2 = 1; i2 < arguments.length; i2++) {
          args[i2] = arguments[i2];
        }
        event.delegateTarget = this;
        if (special.preDispatch && special.preDispatch.call(this, event) === false) {
          return;
        }
        handlerQueue = jQuery.event.handlers.call(this, event, handlers);
        i2 = 0;
        while ((matched = handlerQueue[i2++]) && !event.isPropagationStopped()) {
          event.currentTarget = matched.elem;
          j = 0;
          while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
            if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
              event.handleObj = handleObj;
              event.data = handleObj.data;
              ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
              if (ret !== void 0) {
                if ((event.result = ret) === false) {
                  event.preventDefault();
                  event.stopPropagation();
                }
              }
            }
          }
        }
        if (special.postDispatch) {
          special.postDispatch.call(this, event);
        }
        return event.result;
      },
      handlers: function(event, handlers) {
        var i2, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
        if (delegateCount && // Support: IE <=9
        // Black-hole SVG <use> instance trees (trac-13180)
        cur.nodeType && // Support: Firefox <=42
        // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
        // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
        // Support: IE 11 only
        // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
        !(event.type === "click" && event.button >= 1)) {
          for (; cur !== this; cur = cur.parentNode || this) {
            if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
              matchedHandlers = [];
              matchedSelectors = {};
              for (i2 = 0; i2 < delegateCount; i2++) {
                handleObj = handlers[i2];
                sel = handleObj.selector + " ";
                if (matchedSelectors[sel] === void 0) {
                  matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
                }
                if (matchedSelectors[sel]) {
                  matchedHandlers.push(handleObj);
                }
              }
              if (matchedHandlers.length) {
                handlerQueue.push({ elem: cur, handlers: matchedHandlers });
              }
            }
          }
        }
        cur = this;
        if (delegateCount < handlers.length) {
          handlerQueue.push({ elem: cur, handlers: handlers.slice(delegateCount) });
        }
        return handlerQueue;
      },
      addProp: function(name, hook) {
        Object.defineProperty(jQuery.Event.prototype, name, {
          enumerable: true,
          configurable: true,
          get: isFunction(hook) ? function() {
            if (this.originalEvent) {
              return hook(this.originalEvent);
            }
          } : function() {
            if (this.originalEvent) {
              return this.originalEvent[name];
            }
          },
          set: function(value) {
            Object.defineProperty(this, name, {
              enumerable: true,
              configurable: true,
              writable: true,
              value
            });
          }
        });
      },
      fix: function(originalEvent) {
        return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
      },
      special: {
        load: {
          // Prevent triggered image.load events from bubbling to window.load
          noBubble: true
        },
        click: {
          // Utilize native event to ensure correct state for checkable inputs
          setup: function(data) {
            var el = this || data;
            if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
              leverageNative(el, "click", true);
            }
            return false;
          },
          trigger: function(data) {
            var el = this || data;
            if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
              leverageNative(el, "click");
            }
            return true;
          },
          // For cross-browser consistency, suppress native .click() on links
          // Also prevent it if we're currently inside a leveraged native-event stack
          _default: function(event) {
            var target = event.target;
            return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
          }
        },
        beforeunload: {
          postDispatch: function(event) {
            if (event.result !== void 0 && event.originalEvent) {
              event.originalEvent.returnValue = event.result;
            }
          }
        }
      }
    };
    function leverageNative(el, type, isSetup) {
      if (!isSetup) {
        if (dataPriv.get(el, type) === void 0) {
          jQuery.event.add(el, type, returnTrue);
        }
        return;
      }
      dataPriv.set(el, type, false);
      jQuery.event.add(el, type, {
        namespace: false,
        handler: function(event) {
          var result, saved = dataPriv.get(this, type);
          if (event.isTrigger & 1 && this[type]) {
            if (!saved) {
              saved = slice2.call(arguments);
              dataPriv.set(this, type, saved);
              this[type]();
              result = dataPriv.get(this, type);
              dataPriv.set(this, type, false);
              if (saved !== result) {
                event.stopImmediatePropagation();
                event.preventDefault();
                return result;
              }
            } else if ((jQuery.event.special[type] || {}).delegateType) {
              event.stopPropagation();
            }
          } else if (saved) {
            dataPriv.set(this, type, jQuery.event.trigger(
              saved[0],
              saved.slice(1),
              this
            ));
            event.stopPropagation();
            event.isImmediatePropagationStopped = returnTrue;
          }
        }
      });
    }
    jQuery.removeEvent = function(elem, type, handle) {
      if (elem.removeEventListener) {
        elem.removeEventListener(type, handle);
      }
    };
    jQuery.Event = function(src, props) {
      if (!(this instanceof jQuery.Event)) {
        return new jQuery.Event(src, props);
      }
      if (src && src.type) {
        this.originalEvent = src;
        this.type = src.type;
        this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === void 0 && // Support: Android <=2.3 only
        src.returnValue === false ? returnTrue : returnFalse;
        this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
        this.currentTarget = src.currentTarget;
        this.relatedTarget = src.relatedTarget;
      } else {
        this.type = src;
      }
      if (props) {
        jQuery.extend(this, props);
      }
      this.timeStamp = src && src.timeStamp || Date.now();
      this[jQuery.expando] = true;
    };
    jQuery.Event.prototype = {
      constructor: jQuery.Event,
      isDefaultPrevented: returnFalse,
      isPropagationStopped: returnFalse,
      isImmediatePropagationStopped: returnFalse,
      isSimulated: false,
      preventDefault: function() {
        var e2 = this.originalEvent;
        this.isDefaultPrevented = returnTrue;
        if (e2 && !this.isSimulated) {
          e2.preventDefault();
        }
      },
      stopPropagation: function() {
        var e2 = this.originalEvent;
        this.isPropagationStopped = returnTrue;
        if (e2 && !this.isSimulated) {
          e2.stopPropagation();
        }
      },
      stopImmediatePropagation: function() {
        var e2 = this.originalEvent;
        this.isImmediatePropagationStopped = returnTrue;
        if (e2 && !this.isSimulated) {
          e2.stopImmediatePropagation();
        }
        this.stopPropagation();
      }
    };
    jQuery.each({
      altKey: true,
      bubbles: true,
      cancelable: true,
      changedTouches: true,
      ctrlKey: true,
      detail: true,
      eventPhase: true,
      metaKey: true,
      pageX: true,
      pageY: true,
      shiftKey: true,
      view: true,
      "char": true,
      code: true,
      charCode: true,
      key: true,
      keyCode: true,
      button: true,
      buttons: true,
      clientX: true,
      clientY: true,
      offsetX: true,
      offsetY: true,
      pointerId: true,
      pointerType: true,
      screenX: true,
      screenY: true,
      targetTouches: true,
      toElement: true,
      touches: true,
      which: true
    }, jQuery.event.addProp);
    jQuery.each({ focus: "focusin", blur: "focusout" }, function(type, delegateType) {
      function focusMappedHandler(nativeEvent) {
        if (document2.documentMode) {
          var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
          event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
          event.isSimulated = true;
          handle(nativeEvent);
          if (event.target === event.currentTarget) {
            handle(event);
          }
        } else {
          jQuery.event.simulate(
            delegateType,
            nativeEvent.target,
            jQuery.event.fix(nativeEvent)
          );
        }
      }
      jQuery.event.special[type] = {
        // Utilize native event if possible so blur/focus sequence is correct
        setup: function() {
          var attaches;
          leverageNative(this, type, true);
          if (document2.documentMode) {
            attaches = dataPriv.get(this, delegateType);
            if (!attaches) {
              this.addEventListener(delegateType, focusMappedHandler);
            }
            dataPriv.set(this, delegateType, (attaches || 0) + 1);
          } else {
            return false;
          }
        },
        trigger: function() {
          leverageNative(this, type);
          return true;
        },
        teardown: function() {
          var attaches;
          if (document2.documentMode) {
            attaches = dataPriv.get(this, delegateType) - 1;
            if (!attaches) {
              this.removeEventListener(delegateType, focusMappedHandler);
              dataPriv.remove(this, delegateType);
            } else {
              dataPriv.set(this, delegateType, attaches);
            }
          } else {
            return false;
          }
        },
        // Suppress native focus or blur if we're currently inside
        // a leveraged native-event stack
        _default: function(event) {
          return dataPriv.get(event.target, type);
        },
        delegateType
      };
      jQuery.event.special[delegateType] = {
        setup: function() {
          var doc = this.ownerDocument || this.document || this, dataHolder = document2.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
          if (!attaches) {
            if (document2.documentMode) {
              this.addEventListener(delegateType, focusMappedHandler);
            } else {
              doc.addEventListener(type, focusMappedHandler, true);
            }
          }
          dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
        },
        teardown: function() {
          var doc = this.ownerDocument || this.document || this, dataHolder = document2.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
          if (!attaches) {
            if (document2.documentMode) {
              this.removeEventListener(delegateType, focusMappedHandler);
            } else {
              doc.removeEventListener(type, focusMappedHandler, true);
            }
            dataPriv.remove(dataHolder, delegateType);
          } else {
            dataPriv.set(dataHolder, delegateType, attaches);
          }
        }
      };
    });
    jQuery.each({
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      pointerenter: "pointerover",
      pointerleave: "pointerout"
    }, function(orig, fix) {
      jQuery.event.special[orig] = {
        delegateType: fix,
        bindType: fix,
        handle: function(event) {
          var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
          if (!related || related !== target && !jQuery.contains(target, related)) {
            event.type = handleObj.origType;
            ret = handleObj.handler.apply(this, arguments);
            event.type = fix;
          }
          return ret;
        }
      };
    });
    jQuery.fn.extend({
      on: function(types, selector, data, fn) {
        return on(this, types, selector, data, fn);
      },
      one: function(types, selector, data, fn) {
        return on(this, types, selector, data, fn, 1);
      },
      off: function(types, selector, fn) {
        var handleObj, type;
        if (types && types.preventDefault && types.handleObj) {
          handleObj = types.handleObj;
          jQuery(types.delegateTarget).off(
            handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
            handleObj.selector,
            handleObj.handler
          );
          return this;
        }
        if (typeof types === "object") {
          for (type in types) {
            this.off(type, selector, types[type]);
          }
          return this;
        }
        if (selector === false || typeof selector === "function") {
          fn = selector;
          selector = void 0;
        }
        if (fn === false) {
          fn = returnFalse;
        }
        return this.each(function() {
          jQuery.event.remove(this, types, fn, selector);
        });
      }
    });
    var rnoInnerhtml = /<script|<style|<link/i, rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    function manipulationTarget(elem, content2) {
      if (nodeName(elem, "table") && nodeName(content2.nodeType !== 11 ? content2 : content2.firstChild, "tr")) {
        return jQuery(elem).children("tbody")[0] || elem;
      }
      return elem;
    }
    function disableScript(elem) {
      elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
      return elem;
    }
    function restoreScript(elem) {
      if ((elem.type || "").slice(0, 5) === "true/") {
        elem.type = elem.type.slice(5);
      } else {
        elem.removeAttribute("type");
      }
      return elem;
    }
    function cloneCopyEvent(src, dest) {
      var i2, l2, type, pdataOld, udataOld, udataCur, events;
      if (dest.nodeType !== 1) {
        return;
      }
      if (dataPriv.hasData(src)) {
        pdataOld = dataPriv.get(src);
        events = pdataOld.events;
        if (events) {
          dataPriv.remove(dest, "handle events");
          for (type in events) {
            for (i2 = 0, l2 = events[type].length; i2 < l2; i2++) {
              jQuery.event.add(dest, type, events[type][i2]);
            }
          }
        }
      }
      if (dataUser.hasData(src)) {
        udataOld = dataUser.access(src);
        udataCur = jQuery.extend({}, udataOld);
        dataUser.set(dest, udataCur);
      }
    }
    function fixInput(src, dest) {
      var nodeName2 = dest.nodeName.toLowerCase();
      if (nodeName2 === "input" && rcheckableType.test(src.type)) {
        dest.checked = src.checked;
      } else if (nodeName2 === "input" || nodeName2 === "textarea") {
        dest.defaultValue = src.defaultValue;
      }
    }
    function domManip(collection, args, callback, ignored) {
      args = flat(args);
      var fragment2, first, scripts, hasScripts, node, doc, i2 = 0, l2 = collection.length, iNoClone = l2 - 1, value = args[0], valueIsFunction = isFunction(value);
      if (valueIsFunction || l2 > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
        return collection.each(function(index2) {
          var self2 = collection.eq(index2);
          if (valueIsFunction) {
            args[0] = value.call(this, index2, self2.html());
          }
          domManip(self2, args, callback, ignored);
        });
      }
      if (l2) {
        fragment2 = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
        first = fragment2.firstChild;
        if (fragment2.childNodes.length === 1) {
          fragment2 = first;
        }
        if (first || ignored) {
          scripts = jQuery.map(getAll(fragment2, "script"), disableScript);
          hasScripts = scripts.length;
          for (; i2 < l2; i2++) {
            node = fragment2;
            if (i2 !== iNoClone) {
              node = jQuery.clone(node, true, true);
              if (hasScripts) {
                jQuery.merge(scripts, getAll(node, "script"));
              }
            }
            callback.call(collection[i2], node, i2);
          }
          if (hasScripts) {
            doc = scripts[scripts.length - 1].ownerDocument;
            jQuery.map(scripts, restoreScript);
            for (i2 = 0; i2 < hasScripts; i2++) {
              node = scripts[i2];
              if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                if (node.src && (node.type || "").toLowerCase() !== "module") {
                  if (jQuery._evalUrl && !node.noModule) {
                    jQuery._evalUrl(node.src, {
                      nonce: node.nonce || node.getAttribute("nonce")
                    }, doc);
                  }
                } else {
                  DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                }
              }
            }
          }
        }
      }
      return collection;
    }
    function remove(elem, selector, keepData) {
      var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i2 = 0;
      for (; (node = nodes[i2]) != null; i2++) {
        if (!keepData && node.nodeType === 1) {
          jQuery.cleanData(getAll(node));
        }
        if (node.parentNode) {
          if (keepData && isAttached(node)) {
            setGlobalEval(getAll(node, "script"));
          }
          node.parentNode.removeChild(node);
        }
      }
      return elem;
    }
    jQuery.extend({
      htmlPrefilter: function(html) {
        return html;
      },
      clone: function(elem, dataAndEvents, deepDataAndEvents) {
        var i2, l2, srcElements, destElements, clone2 = elem.cloneNode(true), inPage = isAttached(elem);
        if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
          destElements = getAll(clone2);
          srcElements = getAll(elem);
          for (i2 = 0, l2 = srcElements.length; i2 < l2; i2++) {
            fixInput(srcElements[i2], destElements[i2]);
          }
        }
        if (dataAndEvents) {
          if (deepDataAndEvents) {
            srcElements = srcElements || getAll(elem);
            destElements = destElements || getAll(clone2);
            for (i2 = 0, l2 = srcElements.length; i2 < l2; i2++) {
              cloneCopyEvent(srcElements[i2], destElements[i2]);
            }
          } else {
            cloneCopyEvent(elem, clone2);
          }
        }
        destElements = getAll(clone2, "script");
        if (destElements.length > 0) {
          setGlobalEval(destElements, !inPage && getAll(elem, "script"));
        }
        return clone2;
      },
      cleanData: function(elems) {
        var data, elem, type, special = jQuery.event.special, i2 = 0;
        for (; (elem = elems[i2]) !== void 0; i2++) {
          if (acceptData(elem)) {
            if (data = elem[dataPriv.expando]) {
              if (data.events) {
                for (type in data.events) {
                  if (special[type]) {
                    jQuery.event.remove(elem, type);
                  } else {
                    jQuery.removeEvent(elem, type, data.handle);
                  }
                }
              }
              elem[dataPriv.expando] = void 0;
            }
            if (elem[dataUser.expando]) {
              elem[dataUser.expando] = void 0;
            }
          }
        }
      }
    });
    jQuery.fn.extend({
      detach: function(selector) {
        return remove(this, selector, true);
      },
      remove: function(selector) {
        return remove(this, selector);
      },
      text: function(value) {
        return access(this, function(value2) {
          return value2 === void 0 ? jQuery.text(this) : this.empty().each(function() {
            if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
              this.textContent = value2;
            }
          });
        }, null, value, arguments.length);
      },
      append: function() {
        return domManip(this, arguments, function(elem) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var target = manipulationTarget(this, elem);
            target.appendChild(elem);
          }
        });
      },
      prepend: function() {
        return domManip(this, arguments, function(elem) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var target = manipulationTarget(this, elem);
            target.insertBefore(elem, target.firstChild);
          }
        });
      },
      before: function() {
        return domManip(this, arguments, function(elem) {
          if (this.parentNode) {
            this.parentNode.insertBefore(elem, this);
          }
        });
      },
      after: function() {
        return domManip(this, arguments, function(elem) {
          if (this.parentNode) {
            this.parentNode.insertBefore(elem, this.nextSibling);
          }
        });
      },
      empty: function() {
        var elem, i2 = 0;
        for (; (elem = this[i2]) != null; i2++) {
          if (elem.nodeType === 1) {
            jQuery.cleanData(getAll(elem, false));
            elem.textContent = "";
          }
        }
        return this;
      },
      clone: function(dataAndEvents, deepDataAndEvents) {
        dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
        deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
        return this.map(function() {
          return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
        });
      },
      html: function(value) {
        return access(this, function(value2) {
          var elem = this[0] || {}, i2 = 0, l2 = this.length;
          if (value2 === void 0 && elem.nodeType === 1) {
            return elem.innerHTML;
          }
          if (typeof value2 === "string" && !rnoInnerhtml.test(value2) && !wrapMap[(rtagName.exec(value2) || ["", ""])[1].toLowerCase()]) {
            value2 = jQuery.htmlPrefilter(value2);
            try {
              for (; i2 < l2; i2++) {
                elem = this[i2] || {};
                if (elem.nodeType === 1) {
                  jQuery.cleanData(getAll(elem, false));
                  elem.innerHTML = value2;
                }
              }
              elem = 0;
            } catch (e2) {
            }
          }
          if (elem) {
            this.empty().append(value2);
          }
        }, null, value, arguments.length);
      },
      replaceWith: function() {
        var ignored = [];
        return domManip(this, arguments, function(elem) {
          var parent2 = this.parentNode;
          if (jQuery.inArray(this, ignored) < 0) {
            jQuery.cleanData(getAll(this));
            if (parent2) {
              parent2.replaceChild(elem, this);
            }
          }
        }, ignored);
      }
    });
    jQuery.each({
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith"
    }, function(name, original) {
      jQuery.fn[name] = function(selector) {
        var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i2 = 0;
        for (; i2 <= last; i2++) {
          elems = i2 === last ? this : this.clone(true);
          jQuery(insert[i2])[original](elems);
          push.apply(ret, elems.get());
        }
        return this.pushStack(ret);
      };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
      var view = elem.ownerDocument.defaultView;
      if (!view || !view.opener) {
        view = window2;
      }
      return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
      var ret, name, old = {};
      for (name in options) {
        old[name] = elem.style[name];
        elem.style[name] = options[name];
      }
      ret = callback.call(elem);
      for (name in options) {
        elem.style[name] = old[name];
      }
      return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
      function computeStyleTests() {
        if (!div) {
          return;
        }
        container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
        div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
        documentElement.appendChild(container).appendChild(div);
        var divStyle = window2.getComputedStyle(div);
        pixelPositionVal = divStyle.top !== "1%";
        reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
        div.style.right = "60%";
        pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
        boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
        div.style.position = "absolute";
        scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
        documentElement.removeChild(container);
        div = null;
      }
      function roundPixelMeasures(measure) {
        return Math.round(parseFloat(measure));
      }
      var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document2.createElement("div"), div = document2.createElement("div");
      if (!div.style) {
        return;
      }
      div.style.backgroundClip = "content-box";
      div.cloneNode(true).style.backgroundClip = "";
      support.clearCloneStyle = div.style.backgroundClip === "content-box";
      jQuery.extend(support, {
        boxSizingReliable: function() {
          computeStyleTests();
          return boxSizingReliableVal;
        },
        pixelBoxStyles: function() {
          computeStyleTests();
          return pixelBoxStylesVal;
        },
        pixelPosition: function() {
          computeStyleTests();
          return pixelPositionVal;
        },
        reliableMarginLeft: function() {
          computeStyleTests();
          return reliableMarginLeftVal;
        },
        scrollboxSize: function() {
          computeStyleTests();
          return scrollboxSizeVal;
        },
        // Support: IE 9 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Behavior in IE 9 is more subtle than in newer versions & it passes
        // some versions of this test; make sure not to make it pass there!
        //
        // Support: Firefox 70+
        // Only Firefox includes border widths
        // in computed dimensions. (gh-4529)
        reliableTrDimensions: function() {
          var table, tr, trChild, trStyle;
          if (reliableTrDimensionsVal == null) {
            table = document2.createElement("table");
            tr = document2.createElement("tr");
            trChild = document2.createElement("div");
            table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
            tr.style.cssText = "box-sizing:content-box;border:1px solid";
            tr.style.height = "1px";
            trChild.style.height = "9px";
            trChild.style.display = "block";
            documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
            trStyle = window2.getComputedStyle(tr);
            reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
            documentElement.removeChild(table);
          }
          return reliableTrDimensionsVal;
        }
      });
    })();
    function curCSS(elem, name, computed) {
      var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), style = elem.style;
      computed = computed || getStyles(elem);
      if (computed) {
        ret = computed.getPropertyValue(name) || computed[name];
        if (isCustomProp && ret) {
          ret = ret.replace(rtrimCSS, "$1") || void 0;
        }
        if (ret === "" && !isAttached(elem)) {
          ret = jQuery.style(elem, name);
        }
        if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
          width = style.width;
          minWidth = style.minWidth;
          maxWidth = style.maxWidth;
          style.minWidth = style.maxWidth = style.width = ret;
          ret = computed.width;
          style.width = width;
          style.minWidth = minWidth;
          style.maxWidth = maxWidth;
        }
      }
      return ret !== void 0 ? (
        // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + ""
      ) : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
      return {
        get: function() {
          if (conditionFn()) {
            delete this.get;
            return;
          }
          return (this.get = hookFn).apply(this, arguments);
        }
      };
    }
    var cssPrefixes = ["Webkit", "Moz", "ms"], emptyStyle = document2.createElement("div").style, vendorProps = {};
    function vendorPropName(name) {
      var capName = name[0].toUpperCase() + name.slice(1), i2 = cssPrefixes.length;
      while (i2--) {
        name = cssPrefixes[i2] + capName;
        if (name in emptyStyle) {
          return name;
        }
      }
    }
    function finalPropName(name) {
      var final = jQuery.cssProps[name] || vendorProps[name];
      if (final) {
        return final;
      }
      if (name in emptyStyle) {
        return name;
      }
      return vendorProps[name] = vendorPropName(name) || name;
    }
    var rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = { position: "absolute", visibility: "hidden", display: "block" }, cssNormalTransform = {
      letterSpacing: "0",
      fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
      var matches = rcssNum.exec(value);
      return matches ? (
        // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px")
      ) : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
      var i2 = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
      if (box === (isBorderBox ? "border" : "content")) {
        return 0;
      }
      for (; i2 < 4; i2 += 2) {
        if (box === "margin") {
          marginDelta += jQuery.css(elem, box + cssExpand[i2], true, styles);
        }
        if (!isBorderBox) {
          delta += jQuery.css(elem, "padding" + cssExpand[i2], true, styles);
          if (box !== "padding") {
            delta += jQuery.css(elem, "border" + cssExpand[i2] + "Width", true, styles);
          } else {
            extra += jQuery.css(elem, "border" + cssExpand[i2] + "Width", true, styles);
          }
        } else {
          if (box === "content") {
            delta -= jQuery.css(elem, "padding" + cssExpand[i2], true, styles);
          }
          if (box !== "margin") {
            delta -= jQuery.css(elem, "border" + cssExpand[i2] + "Width", true, styles);
          }
        }
      }
      if (!isBorderBox && computedVal >= 0) {
        delta += Math.max(0, Math.ceil(
          elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5
          // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
          // Use an explicit zero to avoid NaN (gh-3964)
        )) || 0;
      }
      return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
      var styles = getStyles(elem), boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
      if (rnumnonpx.test(val)) {
        if (!extra) {
          return val;
        }
        val = "auto";
      }
      if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
      // IE/Edge misreport `getComputedStyle` of table rows with width/height
      // set in CSS while `offset*` properties report correct values.
      // Interestingly, in some cases IE 9 doesn't suffer from this issue.
      !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
      // This happens for inline elements with no explicit setting (gh-3571)
      val === "auto" || // Support: Android <=4.1 - 4.3 only
      // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
      !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
      elem.getClientRects().length) {
        isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
        valueIsBorderBox = offsetProp in elem;
        if (valueIsBorderBox) {
          val = elem[offsetProp];
        }
      }
      val = parseFloat(val) || 0;
      return val + boxModelAdjustment(
        elem,
        dimension,
        extra || (isBorderBox ? "border" : "content"),
        valueIsBorderBox,
        styles,
        // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val
      ) + "px";
    }
    jQuery.extend({
      // Add in style property hooks for overriding the default
      // behavior of getting and setting a style property
      cssHooks: {
        opacity: {
          get: function(elem, computed) {
            if (computed) {
              var ret = curCSS(elem, "opacity");
              return ret === "" ? "1" : ret;
            }
          }
        }
      },
      // Don't automatically add "px" to these possibly-unitless properties
      cssNumber: {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageSlice: true,
        columnCount: true,
        flexGrow: true,
        flexShrink: true,
        fontWeight: true,
        gridArea: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnStart: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowStart: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        scale: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeMiterlimit: true,
        strokeOpacity: true
      },
      // Add in properties whose names you wish to fix before
      // setting or getting the value
      cssProps: {},
      // Get and set the style property on a DOM Node
      style: function(elem, name, value, extra) {
        if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
          return;
        }
        var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
        if (!isCustomProp) {
          name = finalPropName(origName);
        }
        hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
        if (value !== void 0) {
          type = typeof value;
          if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
            value = adjustCSS(elem, name, ret);
            type = "number";
          }
          if (value == null || value !== value) {
            return;
          }
          if (type === "number" && !isCustomProp) {
            value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
          }
          if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
            style[name] = "inherit";
          }
          if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== void 0) {
            if (isCustomProp) {
              style.setProperty(name, value);
            } else {
              style[name] = value;
            }
          }
        } else {
          if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== void 0) {
            return ret;
          }
          return style[name];
        }
      },
      css: function(elem, name, extra, styles) {
        var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
        if (!isCustomProp) {
          name = finalPropName(origName);
        }
        hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
        if (hooks && "get" in hooks) {
          val = hooks.get(elem, true, extra);
        }
        if (val === void 0) {
          val = curCSS(elem, name, styles);
        }
        if (val === "normal" && name in cssNormalTransform) {
          val = cssNormalTransform[name];
        }
        if (extra === "" || extra) {
          num = parseFloat(val);
          return extra === true || isFinite(num) ? num || 0 : val;
        }
        return val;
      }
    });
    jQuery.each(["height", "width"], function(_i, dimension) {
      jQuery.cssHooks[dimension] = {
        get: function(elem, computed, extra) {
          if (computed) {
            return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
            // Table columns in Safari have non-zero offsetWidth & zero
            // getBoundingClientRect().width unless display is changed.
            // Support: IE <=11 only
            // Running getBoundingClientRect on a disconnected node
            // in IE throws an error.
            (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
              return getWidthOrHeight(elem, dimension, extra);
            }) : getWidthOrHeight(elem, dimension, extra);
          }
        },
        set: function(elem, value, extra) {
          var matches, styles = getStyles(elem), scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(
            elem,
            dimension,
            extra,
            isBorderBox,
            styles
          ) : 0;
          if (isBorderBox && scrollboxSizeBuggy) {
            subtract -= Math.ceil(
              elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5
            );
          }
          if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
            elem.style[dimension] = value;
            value = jQuery.css(elem, dimension);
          }
          return setPositiveNumber(elem, value, subtract);
        }
      };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(
      support.reliableMarginLeft,
      function(elem, computed) {
        if (computed) {
          return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, { marginLeft: 0 }, function() {
            return elem.getBoundingClientRect().left;
          })) + "px";
        }
      }
    );
    jQuery.each({
      margin: "",
      padding: "",
      border: "Width"
    }, function(prefix, suffix) {
      jQuery.cssHooks[prefix + suffix] = {
        expand: function(value) {
          var i2 = 0, expanded = {}, parts = typeof value === "string" ? value.split(" ") : [value];
          for (; i2 < 4; i2++) {
            expanded[prefix + cssExpand[i2] + suffix] = parts[i2] || parts[i2 - 2] || parts[0];
          }
          return expanded;
        }
      };
      if (prefix !== "margin") {
        jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
      }
    });
    jQuery.fn.extend({
      css: function(name, value) {
        return access(this, function(elem, name2, value2) {
          var styles, len, map = {}, i2 = 0;
          if (Array.isArray(name2)) {
            styles = getStyles(elem);
            len = name2.length;
            for (; i2 < len; i2++) {
              map[name2[i2]] = jQuery.css(elem, name2[i2], false, styles);
            }
            return map;
          }
          return value2 !== void 0 ? jQuery.style(elem, name2, value2) : jQuery.css(elem, name2);
        }, name, value, arguments.length > 1);
      }
    });
    function Tween(elem, options, prop, end, easing) {
      return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
      constructor: Tween,
      init: function(elem, options, prop, end, easing, unit) {
        this.elem = elem;
        this.prop = prop;
        this.easing = easing || jQuery.easing._default;
        this.options = options;
        this.start = this.now = this.cur();
        this.end = end;
        this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
      },
      cur: function() {
        var hooks = Tween.propHooks[this.prop];
        return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
      },
      run: function(percent) {
        var eased, hooks = Tween.propHooks[this.prop];
        if (this.options.duration) {
          this.pos = eased = jQuery.easing[this.easing](
            percent,
            this.options.duration * percent,
            0,
            1,
            this.options.duration
          );
        } else {
          this.pos = eased = percent;
        }
        this.now = (this.end - this.start) * eased + this.start;
        if (this.options.step) {
          this.options.step.call(this.elem, this.now, this);
        }
        if (hooks && hooks.set) {
          hooks.set(this);
        } else {
          Tween.propHooks._default.set(this);
        }
        return this;
      }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
      _default: {
        get: function(tween) {
          var result;
          if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
            return tween.elem[tween.prop];
          }
          result = jQuery.css(tween.elem, tween.prop, "");
          return !result || result === "auto" ? 0 : result;
        },
        set: function(tween) {
          if (jQuery.fx.step[tween.prop]) {
            jQuery.fx.step[tween.prop](tween);
          } else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
            jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
          } else {
            tween.elem[tween.prop] = tween.now;
          }
        }
      }
    };
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
      set: function(tween) {
        if (tween.elem.nodeType && tween.elem.parentNode) {
          tween.elem[tween.prop] = tween.now;
        }
      }
    };
    jQuery.easing = {
      linear: function(p2) {
        return p2;
      },
      swing: function(p2) {
        return 0.5 - Math.cos(p2 * Math.PI) / 2;
      },
      _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
      if (inProgress) {
        if (document2.hidden === false && window2.requestAnimationFrame) {
          window2.requestAnimationFrame(schedule);
        } else {
          window2.setTimeout(schedule, jQuery.fx.interval);
        }
        jQuery.fx.tick();
      }
    }
    function createFxNow() {
      window2.setTimeout(function() {
        fxNow = void 0;
      });
      return fxNow = Date.now();
    }
    function genFx(type, includeWidth) {
      var which, i2 = 0, attrs = { height: type };
      includeWidth = includeWidth ? 1 : 0;
      for (; i2 < 4; i2 += 2 - includeWidth) {
        which = cssExpand[i2];
        attrs["margin" + which] = attrs["padding" + which] = type;
      }
      if (includeWidth) {
        attrs.opacity = attrs.width = type;
      }
      return attrs;
    }
    function createTween(value, prop, animation) {
      var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index2 = 0, length2 = collection.length;
      for (; index2 < length2; index2++) {
        if (tween = collection[index2].call(animation, prop, value)) {
          return tween;
        }
      }
    }
    function defaultPrefilter(elem, props, opts) {
      var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display2, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
      if (!opts.queue) {
        hooks = jQuery._queueHooks(elem, "fx");
        if (hooks.unqueued == null) {
          hooks.unqueued = 0;
          oldfire = hooks.empty.fire;
          hooks.empty.fire = function() {
            if (!hooks.unqueued) {
              oldfire();
            }
          };
        }
        hooks.unqueued++;
        anim.always(function() {
          anim.always(function() {
            hooks.unqueued--;
            if (!jQuery.queue(elem, "fx").length) {
              hooks.empty.fire();
            }
          });
        });
      }
      for (prop in props) {
        value = props[prop];
        if (rfxtypes.test(value)) {
          delete props[prop];
          toggle = toggle || value === "toggle";
          if (value === (hidden ? "hide" : "show")) {
            if (value === "show" && dataShow && dataShow[prop] !== void 0) {
              hidden = true;
            } else {
              continue;
            }
          }
          orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
        }
      }
      propTween = !jQuery.isEmptyObject(props);
      if (!propTween && jQuery.isEmptyObject(orig)) {
        return;
      }
      if (isBox && elem.nodeType === 1) {
        opts.overflow = [style.overflow, style.overflowX, style.overflowY];
        restoreDisplay = dataShow && dataShow.display;
        if (restoreDisplay == null) {
          restoreDisplay = dataPriv.get(elem, "display");
        }
        display2 = jQuery.css(elem, "display");
        if (display2 === "none") {
          if (restoreDisplay) {
            display2 = restoreDisplay;
          } else {
            showHide([elem], true);
            restoreDisplay = elem.style.display || restoreDisplay;
            display2 = jQuery.css(elem, "display");
            showHide([elem]);
          }
        }
        if (display2 === "inline" || display2 === "inline-block" && restoreDisplay != null) {
          if (jQuery.css(elem, "float") === "none") {
            if (!propTween) {
              anim.done(function() {
                style.display = restoreDisplay;
              });
              if (restoreDisplay == null) {
                display2 = style.display;
                restoreDisplay = display2 === "none" ? "" : display2;
              }
            }
            style.display = "inline-block";
          }
        }
      }
      if (opts.overflow) {
        style.overflow = "hidden";
        anim.always(function() {
          style.overflow = opts.overflow[0];
          style.overflowX = opts.overflow[1];
          style.overflowY = opts.overflow[2];
        });
      }
      propTween = false;
      for (prop in orig) {
        if (!propTween) {
          if (dataShow) {
            if ("hidden" in dataShow) {
              hidden = dataShow.hidden;
            }
          } else {
            dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
          }
          if (toggle) {
            dataShow.hidden = !hidden;
          }
          if (hidden) {
            showHide([elem], true);
          }
          anim.done(function() {
            if (!hidden) {
              showHide([elem]);
            }
            dataPriv.remove(elem, "fxshow");
            for (prop in orig) {
              jQuery.style(elem, prop, orig[prop]);
            }
          });
        }
        propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
        if (!(prop in dataShow)) {
          dataShow[prop] = propTween.start;
          if (hidden) {
            propTween.end = propTween.start;
            propTween.start = 0;
          }
        }
      }
    }
    function propFilter(props, specialEasing) {
      var index2, name, easing, value, hooks;
      for (index2 in props) {
        name = camelCase(index2);
        easing = specialEasing[name];
        value = props[index2];
        if (Array.isArray(value)) {
          easing = value[1];
          value = props[index2] = value[0];
        }
        if (index2 !== name) {
          props[name] = value;
          delete props[index2];
        }
        hooks = jQuery.cssHooks[name];
        if (hooks && "expand" in hooks) {
          value = hooks.expand(value);
          delete props[name];
          for (index2 in value) {
            if (!(index2 in props)) {
              props[index2] = value[index2];
              specialEasing[index2] = easing;
            }
          }
        } else {
          specialEasing[name] = easing;
        }
      }
    }
    function Animation(elem, properties, options) {
      var result, stopped, index2 = 0, length2 = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
        delete tick.elem;
      }), tick = function() {
        if (stopped) {
          return false;
        }
        var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), temp5 = remaining / animation.duration || 0, percent = 1 - temp5, index3 = 0, length3 = animation.tweens.length;
        for (; index3 < length3; index3++) {
          animation.tweens[index3].run(percent);
        }
        deferred.notifyWith(elem, [animation, percent, remaining]);
        if (percent < 1 && length3) {
          return remaining;
        }
        if (!length3) {
          deferred.notifyWith(elem, [animation, 1, 0]);
        }
        deferred.resolveWith(elem, [animation]);
        return false;
      }, animation = deferred.promise({
        elem,
        props: jQuery.extend({}, properties),
        opts: jQuery.extend(true, {
          specialEasing: {},
          easing: jQuery.easing._default
        }, options),
        originalProperties: properties,
        originalOptions: options,
        startTime: fxNow || createFxNow(),
        duration: options.duration,
        tweens: [],
        createTween: function(prop, end) {
          var tween = jQuery.Tween(
            elem,
            animation.opts,
            prop,
            end,
            animation.opts.specialEasing[prop] || animation.opts.easing
          );
          animation.tweens.push(tween);
          return tween;
        },
        stop: function(gotoEnd) {
          var index3 = 0, length3 = gotoEnd ? animation.tweens.length : 0;
          if (stopped) {
            return this;
          }
          stopped = true;
          for (; index3 < length3; index3++) {
            animation.tweens[index3].run(1);
          }
          if (gotoEnd) {
            deferred.notifyWith(elem, [animation, 1, 0]);
            deferred.resolveWith(elem, [animation, gotoEnd]);
          } else {
            deferred.rejectWith(elem, [animation, gotoEnd]);
          }
          return this;
        }
      }), props = animation.props;
      propFilter(props, animation.opts.specialEasing);
      for (; index2 < length2; index2++) {
        result = Animation.prefilters[index2].call(animation, elem, props, animation.opts);
        if (result) {
          if (isFunction(result.stop)) {
            jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
          }
          return result;
        }
      }
      jQuery.map(props, createTween, animation);
      if (isFunction(animation.opts.start)) {
        animation.opts.start.call(elem, animation);
      }
      animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
      jQuery.fx.timer(
        jQuery.extend(tick, {
          elem,
          anim: animation,
          queue: animation.opts.queue
        })
      );
      return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
      tweeners: {
        "*": [function(prop, value) {
          var tween = this.createTween(prop, value);
          adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
          return tween;
        }]
      },
      tweener: function(props, callback) {
        if (isFunction(props)) {
          callback = props;
          props = ["*"];
        } else {
          props = props.match(rnothtmlwhite);
        }
        var prop, index2 = 0, length2 = props.length;
        for (; index2 < length2; index2++) {
          prop = props[index2];
          Animation.tweeners[prop] = Animation.tweeners[prop] || [];
          Animation.tweeners[prop].unshift(callback);
        }
      },
      prefilters: [defaultPrefilter],
      prefilter: function(callback, prepend) {
        if (prepend) {
          Animation.prefilters.unshift(callback);
        } else {
          Animation.prefilters.push(callback);
        }
      }
    });
    jQuery.speed = function(speed, easing, fn) {
      var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
        complete: fn || !fn && easing || isFunction(speed) && speed,
        duration: speed,
        easing: fn && easing || easing && !isFunction(easing) && easing
      };
      if (jQuery.fx.off) {
        opt.duration = 0;
      } else {
        if (typeof opt.duration !== "number") {
          if (opt.duration in jQuery.fx.speeds) {
            opt.duration = jQuery.fx.speeds[opt.duration];
          } else {
            opt.duration = jQuery.fx.speeds._default;
          }
        }
      }
      if (opt.queue == null || opt.queue === true) {
        opt.queue = "fx";
      }
      opt.old = opt.complete;
      opt.complete = function() {
        if (isFunction(opt.old)) {
          opt.old.call(this);
        }
        if (opt.queue) {
          jQuery.dequeue(this, opt.queue);
        }
      };
      return opt;
    };
    jQuery.fn.extend({
      fadeTo: function(speed, to, easing, callback) {
        return this.filter(isHiddenWithinTree).css("opacity", 0).show().end().animate({ opacity: to }, speed, easing, callback);
      },
      animate: function(prop, speed, easing, callback) {
        var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
          var anim = Animation(this, jQuery.extend({}, prop), optall);
          if (empty || dataPriv.get(this, "finish")) {
            anim.stop(true);
          }
        };
        doAnimation.finish = doAnimation;
        return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
      },
      stop: function(type, clearQueue, gotoEnd) {
        var stopQueue = function(hooks) {
          var stop = hooks.stop;
          delete hooks.stop;
          stop(gotoEnd);
        };
        if (typeof type !== "string") {
          gotoEnd = clearQueue;
          clearQueue = type;
          type = void 0;
        }
        if (clearQueue) {
          this.queue(type || "fx", []);
        }
        return this.each(function() {
          var dequeue = true, index2 = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
          if (index2) {
            if (data[index2] && data[index2].stop) {
              stopQueue(data[index2]);
            }
          } else {
            for (index2 in data) {
              if (data[index2] && data[index2].stop && rrun.test(index2)) {
                stopQueue(data[index2]);
              }
            }
          }
          for (index2 = timers.length; index2--; ) {
            if (timers[index2].elem === this && (type == null || timers[index2].queue === type)) {
              timers[index2].anim.stop(gotoEnd);
              dequeue = false;
              timers.splice(index2, 1);
            }
          }
          if (dequeue || !gotoEnd) {
            jQuery.dequeue(this, type);
          }
        });
      },
      finish: function(type) {
        if (type !== false) {
          type = type || "fx";
        }
        return this.each(function() {
          var index2, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length2 = queue ? queue.length : 0;
          data.finish = true;
          jQuery.queue(this, type, []);
          if (hooks && hooks.stop) {
            hooks.stop.call(this, true);
          }
          for (index2 = timers.length; index2--; ) {
            if (timers[index2].elem === this && timers[index2].queue === type) {
              timers[index2].anim.stop(true);
              timers.splice(index2, 1);
            }
          }
          for (index2 = 0; index2 < length2; index2++) {
            if (queue[index2] && queue[index2].finish) {
              queue[index2].finish.call(this);
            }
          }
          delete data.finish;
        });
      }
    });
    jQuery.each(["toggle", "show", "hide"], function(_i, name) {
      var cssFn = jQuery.fn[name];
      jQuery.fn[name] = function(speed, easing, callback) {
        return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
      };
    });
    jQuery.each({
      slideDown: genFx("show"),
      slideUp: genFx("hide"),
      slideToggle: genFx("toggle"),
      fadeIn: { opacity: "show" },
      fadeOut: { opacity: "hide" },
      fadeToggle: { opacity: "toggle" }
    }, function(name, props) {
      jQuery.fn[name] = function(speed, easing, callback) {
        return this.animate(props, speed, easing, callback);
      };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
      var timer, i2 = 0, timers = jQuery.timers;
      fxNow = Date.now();
      for (; i2 < timers.length; i2++) {
        timer = timers[i2];
        if (!timer() && timers[i2] === timer) {
          timers.splice(i2--, 1);
        }
      }
      if (!timers.length) {
        jQuery.fx.stop();
      }
      fxNow = void 0;
    };
    jQuery.fx.timer = function(timer) {
      jQuery.timers.push(timer);
      jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
      if (inProgress) {
        return;
      }
      inProgress = true;
      schedule();
    };
    jQuery.fx.stop = function() {
      inProgress = null;
    };
    jQuery.fx.speeds = {
      slow: 600,
      fast: 200,
      // Default speed
      _default: 400
    };
    jQuery.fn.delay = function(time2, type) {
      time2 = jQuery.fx ? jQuery.fx.speeds[time2] || time2 : time2;
      type = type || "fx";
      return this.queue(type, function(next, hooks) {
        var timeout = window2.setTimeout(next, time2);
        hooks.stop = function() {
          window2.clearTimeout(timeout);
        };
      });
    };
    (function() {
      var input = document2.createElement("input"), select = document2.createElement("select"), opt = select.appendChild(document2.createElement("option"));
      input.type = "checkbox";
      support.checkOn = input.value !== "";
      support.optSelected = opt.selected;
      input = document2.createElement("input");
      input.value = "t";
      input.type = "radio";
      support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
      attr: function(name, value) {
        return access(this, jQuery.attr, name, value, arguments.length > 1);
      },
      removeAttr: function(name) {
        return this.each(function() {
          jQuery.removeAttr(this, name);
        });
      }
    });
    jQuery.extend({
      attr: function(elem, name, value) {
        var ret, hooks, nType = elem.nodeType;
        if (nType === 3 || nType === 8 || nType === 2) {
          return;
        }
        if (typeof elem.getAttribute === "undefined") {
          return jQuery.prop(elem, name, value);
        }
        if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
          hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : void 0);
        }
        if (value !== void 0) {
          if (value === null) {
            jQuery.removeAttr(elem, name);
            return;
          }
          if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== void 0) {
            return ret;
          }
          elem.setAttribute(name, value + "");
          return value;
        }
        if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
          return ret;
        }
        ret = jQuery.find.attr(elem, name);
        return ret == null ? void 0 : ret;
      },
      attrHooks: {
        type: {
          set: function(elem, value) {
            if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
              var val = elem.value;
              elem.setAttribute("type", value);
              if (val) {
                elem.value = val;
              }
              return value;
            }
          }
        }
      },
      removeAttr: function(elem, value) {
        var name, i2 = 0, attrNames = value && value.match(rnothtmlwhite);
        if (attrNames && elem.nodeType === 1) {
          while (name = attrNames[i2++]) {
            elem.removeAttribute(name);
          }
        }
      }
    });
    boolHook = {
      set: function(elem, value, name) {
        if (value === false) {
          jQuery.removeAttr(elem, name);
        } else {
          elem.setAttribute(name, name);
        }
        return name;
      }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
      var getter = attrHandle[name] || jQuery.find.attr;
      attrHandle[name] = function(elem, name2, isXML) {
        var ret, handle, lowercaseName = name2.toLowerCase();
        if (!isXML) {
          handle = attrHandle[lowercaseName];
          attrHandle[lowercaseName] = ret;
          ret = getter(elem, name2, isXML) != null ? lowercaseName : null;
          attrHandle[lowercaseName] = handle;
        }
        return ret;
      };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
      prop: function(name, value) {
        return access(this, jQuery.prop, name, value, arguments.length > 1);
      },
      removeProp: function(name) {
        return this.each(function() {
          delete this[jQuery.propFix[name] || name];
        });
      }
    });
    jQuery.extend({
      prop: function(elem, name, value) {
        var ret, hooks, nType = elem.nodeType;
        if (nType === 3 || nType === 8 || nType === 2) {
          return;
        }
        if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
          name = jQuery.propFix[name] || name;
          hooks = jQuery.propHooks[name];
        }
        if (value !== void 0) {
          if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== void 0) {
            return ret;
          }
          return elem[name] = value;
        }
        if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
          return ret;
        }
        return elem[name];
      },
      propHooks: {
        tabIndex: {
          get: function(elem) {
            var tabindex = jQuery.find.attr(elem, "tabindex");
            if (tabindex) {
              return parseInt(tabindex, 10);
            }
            if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
              return 0;
            }
            return -1;
          }
        }
      },
      propFix: {
        "for": "htmlFor",
        "class": "className"
      }
    });
    if (!support.optSelected) {
      jQuery.propHooks.selected = {
        get: function(elem) {
          var parent2 = elem.parentNode;
          if (parent2 && parent2.parentNode) {
            parent2.parentNode.selectedIndex;
          }
          return null;
        },
        set: function(elem) {
          var parent2 = elem.parentNode;
          if (parent2) {
            parent2.selectedIndex;
            if (parent2.parentNode) {
              parent2.parentNode.selectedIndex;
            }
          }
        }
      };
    }
    jQuery.each([
      "tabIndex",
      "readOnly",
      "maxLength",
      "cellSpacing",
      "cellPadding",
      "rowSpan",
      "colSpan",
      "useMap",
      "frameBorder",
      "contentEditable"
    ], function() {
      jQuery.propFix[this.toLowerCase()] = this;
    });
    function stripAndCollapse(value) {
      var tokens = value.match(rnothtmlwhite) || [];
      return tokens.join(" ");
    }
    function getClass(elem) {
      return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
      if (Array.isArray(value)) {
        return value;
      }
      if (typeof value === "string") {
        return value.match(rnothtmlwhite) || [];
      }
      return [];
    }
    jQuery.fn.extend({
      addClass: function(value) {
        var classNames, cur, curValue, className, i2, finalValue;
        if (isFunction(value)) {
          return this.each(function(j) {
            jQuery(this).addClass(value.call(this, j, getClass(this)));
          });
        }
        classNames = classesToArray(value);
        if (classNames.length) {
          return this.each(function() {
            curValue = getClass(this);
            cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
            if (cur) {
              for (i2 = 0; i2 < classNames.length; i2++) {
                className = classNames[i2];
                if (cur.indexOf(" " + className + " ") < 0) {
                  cur += className + " ";
                }
              }
              finalValue = stripAndCollapse(cur);
              if (curValue !== finalValue) {
                this.setAttribute("class", finalValue);
              }
            }
          });
        }
        return this;
      },
      removeClass: function(value) {
        var classNames, cur, curValue, className, i2, finalValue;
        if (isFunction(value)) {
          return this.each(function(j) {
            jQuery(this).removeClass(value.call(this, j, getClass(this)));
          });
        }
        if (!arguments.length) {
          return this.attr("class", "");
        }
        classNames = classesToArray(value);
        if (classNames.length) {
          return this.each(function() {
            curValue = getClass(this);
            cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
            if (cur) {
              for (i2 = 0; i2 < classNames.length; i2++) {
                className = classNames[i2];
                while (cur.indexOf(" " + className + " ") > -1) {
                  cur = cur.replace(" " + className + " ", " ");
                }
              }
              finalValue = stripAndCollapse(cur);
              if (curValue !== finalValue) {
                this.setAttribute("class", finalValue);
              }
            }
          });
        }
        return this;
      },
      toggleClass: function(value, stateVal) {
        var classNames, className, i2, self2, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
        if (isFunction(value)) {
          return this.each(function(i3) {
            jQuery(this).toggleClass(
              value.call(this, i3, getClass(this), stateVal),
              stateVal
            );
          });
        }
        if (typeof stateVal === "boolean" && isValidValue) {
          return stateVal ? this.addClass(value) : this.removeClass(value);
        }
        classNames = classesToArray(value);
        return this.each(function() {
          if (isValidValue) {
            self2 = jQuery(this);
            for (i2 = 0; i2 < classNames.length; i2++) {
              className = classNames[i2];
              if (self2.hasClass(className)) {
                self2.removeClass(className);
              } else {
                self2.addClass(className);
              }
            }
          } else if (value === void 0 || type === "boolean") {
            className = getClass(this);
            if (className) {
              dataPriv.set(this, "__className__", className);
            }
            if (this.setAttribute) {
              this.setAttribute(
                "class",
                className || value === false ? "" : dataPriv.get(this, "__className__") || ""
              );
            }
          }
        });
      },
      hasClass: function(selector) {
        var className, elem, i2 = 0;
        className = " " + selector + " ";
        while (elem = this[i2++]) {
          if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
            return true;
          }
        }
        return false;
      }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
      val: function(value) {
        var hooks, ret, valueIsFunction, elem = this[0];
        if (!arguments.length) {
          if (elem) {
            hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
            if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== void 0) {
              return ret;
            }
            ret = elem.value;
            if (typeof ret === "string") {
              return ret.replace(rreturn, "");
            }
            return ret == null ? "" : ret;
          }
          return;
        }
        valueIsFunction = isFunction(value);
        return this.each(function(i2) {
          var val;
          if (this.nodeType !== 1) {
            return;
          }
          if (valueIsFunction) {
            val = value.call(this, i2, jQuery(this).val());
          } else {
            val = value;
          }
          if (val == null) {
            val = "";
          } else if (typeof val === "number") {
            val += "";
          } else if (Array.isArray(val)) {
            val = jQuery.map(val, function(value2) {
              return value2 == null ? "" : value2 + "";
            });
          }
          hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
          if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === void 0) {
            this.value = val;
          }
        });
      }
    });
    jQuery.extend({
      valHooks: {
        option: {
          get: function(elem) {
            var val = jQuery.find.attr(elem, "value");
            return val != null ? val : (
              // Support: IE <=10 - 11 only
              // option.text throws exceptions (trac-14686, trac-14858)
              // Strip and collapse whitespace
              // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
              stripAndCollapse(jQuery.text(elem))
            );
          }
        },
        select: {
          get: function(elem) {
            var value, option, i2, options = elem.options, index2 = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max2 = one ? index2 + 1 : options.length;
            if (index2 < 0) {
              i2 = max2;
            } else {
              i2 = one ? index2 : 0;
            }
            for (; i2 < max2; i2++) {
              option = options[i2];
              if ((option.selected || i2 === index2) && // Don't return options that are disabled or in a disabled optgroup
              !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                value = jQuery(option).val();
                if (one) {
                  return value;
                }
                values.push(value);
              }
            }
            return values;
          },
          set: function(elem, value) {
            var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i2 = options.length;
            while (i2--) {
              option = options[i2];
              if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
                optionSet = true;
              }
            }
            if (!optionSet) {
              elem.selectedIndex = -1;
            }
            return values;
          }
        }
      }
    });
    jQuery.each(["radio", "checkbox"], function() {
      jQuery.valHooks[this] = {
        set: function(elem, value) {
          if (Array.isArray(value)) {
            return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
          }
        }
      };
      if (!support.checkOn) {
        jQuery.valHooks[this].get = function(elem) {
          return elem.getAttribute("value") === null ? "on" : elem.value;
        };
      }
    });
    var location2 = window2.location;
    var nonce = { guid: Date.now() };
    var rquery = /\?/;
    jQuery.parseXML = function(data) {
      var xml, parserErrorElem;
      if (!data || typeof data !== "string") {
        return null;
      }
      try {
        xml = new window2.DOMParser().parseFromString(data, "text/xml");
      } catch (e2) {
      }
      parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
      if (!xml || parserErrorElem) {
        jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
          return el.textContent;
        }).join("\n") : data));
      }
      return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e2) {
      e2.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
      trigger: function(event, data, elem, onlyHandlers) {
        var i2, cur, tmp2, bubbleType, ontype, handle, special, lastElement, eventPath = [elem || document2], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
        cur = lastElement = tmp2 = elem = elem || document2;
        if (elem.nodeType === 3 || elem.nodeType === 8) {
          return;
        }
        if (rfocusMorph.test(type + jQuery.event.triggered)) {
          return;
        }
        if (type.indexOf(".") > -1) {
          namespaces = type.split(".");
          type = namespaces.shift();
          namespaces.sort();
        }
        ontype = type.indexOf(":") < 0 && "on" + type;
        event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
        event.isTrigger = onlyHandlers ? 2 : 3;
        event.namespace = namespaces.join(".");
        event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
        event.result = void 0;
        if (!event.target) {
          event.target = elem;
        }
        data = data == null ? [event] : jQuery.makeArray(data, [event]);
        special = jQuery.event.special[type] || {};
        if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
          return;
        }
        if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
          bubbleType = special.delegateType || type;
          if (!rfocusMorph.test(bubbleType + type)) {
            cur = cur.parentNode;
          }
          for (; cur; cur = cur.parentNode) {
            eventPath.push(cur);
            tmp2 = cur;
          }
          if (tmp2 === (elem.ownerDocument || document2)) {
            eventPath.push(tmp2.defaultView || tmp2.parentWindow || window2);
          }
        }
        i2 = 0;
        while ((cur = eventPath[i2++]) && !event.isPropagationStopped()) {
          lastElement = cur;
          event.type = i2 > 1 ? bubbleType : special.bindType || type;
          handle = (dataPriv.get(cur, "events") || /* @__PURE__ */ Object.create(null))[event.type] && dataPriv.get(cur, "handle");
          if (handle) {
            handle.apply(cur, data);
          }
          handle = ontype && cur[ontype];
          if (handle && handle.apply && acceptData(cur)) {
            event.result = handle.apply(cur, data);
            if (event.result === false) {
              event.preventDefault();
            }
          }
        }
        event.type = type;
        if (!onlyHandlers && !event.isDefaultPrevented()) {
          if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
            if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
              tmp2 = elem[ontype];
              if (tmp2) {
                elem[ontype] = null;
              }
              jQuery.event.triggered = type;
              if (event.isPropagationStopped()) {
                lastElement.addEventListener(type, stopPropagationCallback);
              }
              elem[type]();
              if (event.isPropagationStopped()) {
                lastElement.removeEventListener(type, stopPropagationCallback);
              }
              jQuery.event.triggered = void 0;
              if (tmp2) {
                elem[ontype] = tmp2;
              }
            }
          }
        }
        return event.result;
      },
      // Piggyback on a donor event to simulate a different one
      // Used only for `focus(in | out)` events
      simulate: function(type, elem, event) {
        var e2 = jQuery.extend(
          new jQuery.Event(),
          event,
          {
            type,
            isSimulated: true
          }
        );
        jQuery.event.trigger(e2, null, elem);
      }
    });
    jQuery.fn.extend({
      trigger: function(type, data) {
        return this.each(function() {
          jQuery.event.trigger(type, data, this);
        });
      },
      triggerHandler: function(type, data) {
        var elem = this[0];
        if (elem) {
          return jQuery.event.trigger(type, data, elem, true);
        }
      }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
      var name;
      if (Array.isArray(obj)) {
        jQuery.each(obj, function(i2, v) {
          if (traditional || rbracket.test(prefix)) {
            add(prefix, v);
          } else {
            buildParams(
              prefix + "[" + (typeof v === "object" && v != null ? i2 : "") + "]",
              v,
              traditional,
              add
            );
          }
        });
      } else if (!traditional && toType(obj) === "object") {
        for (name in obj) {
          buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        }
      } else {
        add(prefix, obj);
      }
    }
    jQuery.param = function(a3, traditional) {
      var prefix, s2 = [], add = function(key, valueOrFunction) {
        var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
        s2[s2.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
      };
      if (a3 == null) {
        return "";
      }
      if (Array.isArray(a3) || a3.jquery && !jQuery.isPlainObject(a3)) {
        jQuery.each(a3, function() {
          add(this.name, this.value);
        });
      } else {
        for (prefix in a3) {
          buildParams(prefix, a3[prefix], traditional, add);
        }
      }
      return s2.join("&");
    };
    jQuery.fn.extend({
      serialize: function() {
        return jQuery.param(this.serializeArray());
      },
      serializeArray: function() {
        return this.map(function() {
          var elements = jQuery.prop(this, "elements");
          return elements ? jQuery.makeArray(elements) : this;
        }).filter(function() {
          var type = this.type;
          return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
        }).map(function(_i, elem) {
          var val = jQuery(this).val();
          if (val == null) {
            return null;
          }
          if (Array.isArray(val)) {
            return jQuery.map(val, function(val2) {
              return { name: elem.name, value: val2.replace(rCRLF, "\r\n") };
            });
          }
          return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
        }).get();
      }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, prefilters = {}, transports = {}, allTypes = "*/".concat("*"), originAnchor = document2.createElement("a");
    originAnchor.href = location2.href;
    function addToPrefiltersOrTransports(structure) {
      return function(dataTypeExpression, func) {
        if (typeof dataTypeExpression !== "string") {
          func = dataTypeExpression;
          dataTypeExpression = "*";
        }
        var dataType, i2 = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
        if (isFunction(func)) {
          while (dataType = dataTypes[i2++]) {
            if (dataType[0] === "+") {
              dataType = dataType.slice(1) || "*";
              (structure[dataType] = structure[dataType] || []).unshift(func);
            } else {
              (structure[dataType] = structure[dataType] || []).push(func);
            }
          }
        }
      };
    }
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
      var inspected = {}, seekingTransport = structure === transports;
      function inspect(dataType) {
        var selected;
        inspected[dataType] = true;
        jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
          var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
          if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
            options.dataTypes.unshift(dataTypeOrTransport);
            inspect(dataTypeOrTransport);
            return false;
          } else if (seekingTransport) {
            return !(selected = dataTypeOrTransport);
          }
        });
        return selected;
      }
      return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    function ajaxExtend(target, src) {
      var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
      for (key in src) {
        if (src[key] !== void 0) {
          (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        }
      }
      if (deep) {
        jQuery.extend(true, target, deep);
      }
      return target;
    }
    function ajaxHandleResponses(s2, jqXHR, responses) {
      var ct2, type, finalDataType, firstDataType, contents = s2.contents, dataTypes = s2.dataTypes;
      while (dataTypes[0] === "*") {
        dataTypes.shift();
        if (ct2 === void 0) {
          ct2 = s2.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
      }
      if (ct2) {
        for (type in contents) {
          if (contents[type] && contents[type].test(ct2)) {
            dataTypes.unshift(type);
            break;
          }
        }
      }
      if (dataTypes[0] in responses) {
        finalDataType = dataTypes[0];
      } else {
        for (type in responses) {
          if (!dataTypes[0] || s2.converters[type + " " + dataTypes[0]]) {
            finalDataType = type;
            break;
          }
          if (!firstDataType) {
            firstDataType = type;
          }
        }
        finalDataType = finalDataType || firstDataType;
      }
      if (finalDataType) {
        if (finalDataType !== dataTypes[0]) {
          dataTypes.unshift(finalDataType);
        }
        return responses[finalDataType];
      }
    }
    function ajaxConvert(s2, response, jqXHR, isSuccess) {
      var conv2, current, conv, tmp2, prev, converters = {}, dataTypes = s2.dataTypes.slice();
      if (dataTypes[1]) {
        for (conv in s2.converters) {
          converters[conv.toLowerCase()] = s2.converters[conv];
        }
      }
      current = dataTypes.shift();
      while (current) {
        if (s2.responseFields[current]) {
          jqXHR[s2.responseFields[current]] = response;
        }
        if (!prev && isSuccess && s2.dataFilter) {
          response = s2.dataFilter(response, s2.dataType);
        }
        prev = current;
        current = dataTypes.shift();
        if (current) {
          if (current === "*") {
            current = prev;
          } else if (prev !== "*" && prev !== current) {
            conv = converters[prev + " " + current] || converters["* " + current];
            if (!conv) {
              for (conv2 in converters) {
                tmp2 = conv2.split(" ");
                if (tmp2[1] === current) {
                  conv = converters[prev + " " + tmp2[0]] || converters["* " + tmp2[0]];
                  if (conv) {
                    if (conv === true) {
                      conv = converters[conv2];
                    } else if (converters[conv2] !== true) {
                      current = tmp2[0];
                      dataTypes.unshift(tmp2[1]);
                    }
                    break;
                  }
                }
              }
            }
            if (conv !== true) {
              if (conv && s2.throws) {
                response = conv(response);
              } else {
                try {
                  response = conv(response);
                } catch (e2) {
                  return {
                    state: "parsererror",
                    error: conv ? e2 : "No conversion from " + prev + " to " + current
                  };
                }
              }
            }
          }
        }
      }
      return { state: "success", data: response };
    }
    jQuery.extend({
      // Counter for holding the number of active queries
      active: 0,
      // Last-Modified header cache for next request
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: location2.href,
        type: "GET",
        isLocal: rlocalProtocol.test(location2.protocol),
        global: true,
        processData: true,
        async: true,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        /*
        timeout: 0,
        data: null,
        dataType: null,
        username: null,
        password: null,
        cache: null,
        throws: false,
        traditional: false,
        headers: {},
        */
        accepts: {
          "*": allTypes,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript"
        },
        contents: {
          xml: /\bxml\b/,
          html: /\bhtml/,
          json: /\bjson\b/
        },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON"
        },
        // Data converters
        // Keys separate source (or catchall "*") and destination types with a single space
        converters: {
          // Convert anything to text
          "* text": String,
          // Text to html (true = no transformation)
          "text html": true,
          // Evaluate text as a json expression
          "text json": JSON.parse,
          // Parse text as xml
          "text xml": jQuery.parseXML
        },
        // For options that shouldn't be deep extended:
        // you can add your own custom options here if
        // and when you create one that shouldn't be
        // deep extended (see ajaxExtend)
        flatOptions: {
          url: true,
          context: true
        }
      },
      // Creates a full fledged settings object into target
      // with both ajaxSettings and settings fields.
      // If target is omitted, writes into ajaxSettings.
      ajaxSetup: function(target, settings) {
        return settings ? (
          // Building a settings object
          ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings)
        ) : (
          // Extending ajaxSettings
          ajaxExtend(jQuery.ajaxSettings, target)
        );
      },
      ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
      ajaxTransport: addToPrefiltersOrTransports(transports),
      // Main method
      ajax: function(url, options) {
        if (typeof url === "object") {
          options = url;
          url = void 0;
        }
        options = options || {};
        var transport, cacheURL, responseHeadersString, responseHeaders, timeoutTimer, urlAnchor, completed2, fireGlobals, i2, uncached, s2 = jQuery.ajaxSetup({}, options), callbackContext = s2.context || s2, globalEventContext = s2.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), statusCode = s2.statusCode || {}, requestHeaders = {}, requestHeadersNames = {}, strAbort = "canceled", jqXHR = {
          readyState: 0,
          // Builds headers hashtable if needed
          getResponseHeader: function(key) {
            var match;
            if (completed2) {
              if (!responseHeaders) {
                responseHeaders = {};
                while (match = rheaders.exec(responseHeadersString)) {
                  responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                }
              }
              match = responseHeaders[key.toLowerCase() + " "];
            }
            return match == null ? null : match.join(", ");
          },
          // Raw string
          getAllResponseHeaders: function() {
            return completed2 ? responseHeadersString : null;
          },
          // Caches the header
          setRequestHeader: function(name, value) {
            if (completed2 == null) {
              name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
              requestHeaders[name] = value;
            }
            return this;
          },
          // Overrides response content-type header
          overrideMimeType: function(type) {
            if (completed2 == null) {
              s2.mimeType = type;
            }
            return this;
          },
          // Status-dependent callbacks
          statusCode: function(map) {
            var code;
            if (map) {
              if (completed2) {
                jqXHR.always(map[jqXHR.status]);
              } else {
                for (code in map) {
                  statusCode[code] = [statusCode[code], map[code]];
                }
              }
            }
            return this;
          },
          // Cancel the request
          abort: function(statusText) {
            var finalText = statusText || strAbort;
            if (transport) {
              transport.abort(finalText);
            }
            done(0, finalText);
            return this;
          }
        };
        deferred.promise(jqXHR);
        s2.url = ((url || s2.url || location2.href) + "").replace(rprotocol, location2.protocol + "//");
        s2.type = options.method || options.type || s2.method || s2.type;
        s2.dataTypes = (s2.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];
        if (s2.crossDomain == null) {
          urlAnchor = document2.createElement("a");
          try {
            urlAnchor.href = s2.url;
            urlAnchor.href = urlAnchor.href;
            s2.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
          } catch (e2) {
            s2.crossDomain = true;
          }
        }
        if (s2.data && s2.processData && typeof s2.data !== "string") {
          s2.data = jQuery.param(s2.data, s2.traditional);
        }
        inspectPrefiltersOrTransports(prefilters, s2, options, jqXHR);
        if (completed2) {
          return jqXHR;
        }
        fireGlobals = jQuery.event && s2.global;
        if (fireGlobals && jQuery.active++ === 0) {
          jQuery.event.trigger("ajaxStart");
        }
        s2.type = s2.type.toUpperCase();
        s2.hasContent = !rnoContent.test(s2.type);
        cacheURL = s2.url.replace(rhash, "");
        if (!s2.hasContent) {
          uncached = s2.url.slice(cacheURL.length);
          if (s2.data && (s2.processData || typeof s2.data === "string")) {
            cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s2.data;
            delete s2.data;
          }
          if (s2.cache === false) {
            cacheURL = cacheURL.replace(rantiCache, "$1");
            uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
          }
          s2.url = cacheURL + uncached;
        } else if (s2.data && s2.processData && (s2.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
          s2.data = s2.data.replace(r20, "+");
        }
        if (s2.ifModified) {
          if (jQuery.lastModified[cacheURL]) {
            jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
          }
          if (jQuery.etag[cacheURL]) {
            jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
          }
        }
        if (s2.data && s2.hasContent && s2.contentType !== false || options.contentType) {
          jqXHR.setRequestHeader("Content-Type", s2.contentType);
        }
        jqXHR.setRequestHeader(
          "Accept",
          s2.dataTypes[0] && s2.accepts[s2.dataTypes[0]] ? s2.accepts[s2.dataTypes[0]] + (s2.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s2.accepts["*"]
        );
        for (i2 in s2.headers) {
          jqXHR.setRequestHeader(i2, s2.headers[i2]);
        }
        if (s2.beforeSend && (s2.beforeSend.call(callbackContext, jqXHR, s2) === false || completed2)) {
          return jqXHR.abort();
        }
        strAbort = "abort";
        completeDeferred.add(s2.complete);
        jqXHR.done(s2.success);
        jqXHR.fail(s2.error);
        transport = inspectPrefiltersOrTransports(transports, s2, options, jqXHR);
        if (!transport) {
          done(-1, "No Transport");
        } else {
          jqXHR.readyState = 1;
          if (fireGlobals) {
            globalEventContext.trigger("ajaxSend", [jqXHR, s2]);
          }
          if (completed2) {
            return jqXHR;
          }
          if (s2.async && s2.timeout > 0) {
            timeoutTimer = window2.setTimeout(function() {
              jqXHR.abort("timeout");
            }, s2.timeout);
          }
          try {
            completed2 = false;
            transport.send(requestHeaders, done);
          } catch (e2) {
            if (completed2) {
              throw e2;
            }
            done(-1, e2);
          }
        }
        function done(status, nativeStatusText, responses, headers) {
          var isSuccess, success, error, response, modified, statusText = nativeStatusText;
          if (completed2) {
            return;
          }
          completed2 = true;
          if (timeoutTimer) {
            window2.clearTimeout(timeoutTimer);
          }
          transport = void 0;
          responseHeadersString = headers || "";
          jqXHR.readyState = status > 0 ? 4 : 0;
          isSuccess = status >= 200 && status < 300 || status === 304;
          if (responses) {
            response = ajaxHandleResponses(s2, jqXHR, responses);
          }
          if (!isSuccess && jQuery.inArray("script", s2.dataTypes) > -1 && jQuery.inArray("json", s2.dataTypes) < 0) {
            s2.converters["text script"] = function() {
            };
          }
          response = ajaxConvert(s2, response, jqXHR, isSuccess);
          if (isSuccess) {
            if (s2.ifModified) {
              modified = jqXHR.getResponseHeader("Last-Modified");
              if (modified) {
                jQuery.lastModified[cacheURL] = modified;
              }
              modified = jqXHR.getResponseHeader("etag");
              if (modified) {
                jQuery.etag[cacheURL] = modified;
              }
            }
            if (status === 204 || s2.type === "HEAD") {
              statusText = "nocontent";
            } else if (status === 304) {
              statusText = "notmodified";
            } else {
              statusText = response.state;
              success = response.data;
              error = response.error;
              isSuccess = !error;
            }
          } else {
            error = statusText;
            if (status || !statusText) {
              statusText = "error";
              if (status < 0) {
                status = 0;
              }
            }
          }
          jqXHR.status = status;
          jqXHR.statusText = (nativeStatusText || statusText) + "";
          if (isSuccess) {
            deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
          } else {
            deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
          }
          jqXHR.statusCode(statusCode);
          statusCode = void 0;
          if (fireGlobals) {
            globalEventContext.trigger(
              isSuccess ? "ajaxSuccess" : "ajaxError",
              [jqXHR, s2, isSuccess ? success : error]
            );
          }
          completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
          if (fireGlobals) {
            globalEventContext.trigger("ajaxComplete", [jqXHR, s2]);
            if (!--jQuery.active) {
              jQuery.event.trigger("ajaxStop");
            }
          }
        }
        return jqXHR;
      },
      getJSON: function(url, data, callback) {
        return jQuery.get(url, data, callback, "json");
      },
      getScript: function(url, callback) {
        return jQuery.get(url, void 0, callback, "script");
      }
    });
    jQuery.each(["get", "post"], function(_i, method) {
      jQuery[method] = function(url, data, callback, type) {
        if (isFunction(data)) {
          type = type || callback;
          callback = data;
          data = void 0;
        }
        return jQuery.ajax(jQuery.extend({
          url,
          type: method,
          dataType: type,
          data,
          success: callback
        }, jQuery.isPlainObject(url) && url));
      };
    });
    jQuery.ajaxPrefilter(function(s2) {
      var i2;
      for (i2 in s2.headers) {
        if (i2.toLowerCase() === "content-type") {
          s2.contentType = s2.headers[i2] || "";
        }
      }
    });
    jQuery._evalUrl = function(url, options, doc) {
      return jQuery.ajax({
        url,
        // Make this explicit, since user can override this through ajaxSetup (trac-11264)
        type: "GET",
        dataType: "script",
        cache: true,
        async: false,
        global: false,
        // Only evaluate the response if it is successful (gh-4126)
        // dataFilter is not invoked for failure responses, so using it instead
        // of the default converter is kludgy but it works.
        converters: {
          "text script": function() {
          }
        },
        dataFilter: function(response) {
          jQuery.globalEval(response, options, doc);
        }
      });
    };
    jQuery.fn.extend({
      wrapAll: function(html) {
        var wrap;
        if (this[0]) {
          if (isFunction(html)) {
            html = html.call(this[0]);
          }
          wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
          if (this[0].parentNode) {
            wrap.insertBefore(this[0]);
          }
          wrap.map(function() {
            var elem = this;
            while (elem.firstElementChild) {
              elem = elem.firstElementChild;
            }
            return elem;
          }).append(this);
        }
        return this;
      },
      wrapInner: function(html) {
        if (isFunction(html)) {
          return this.each(function(i2) {
            jQuery(this).wrapInner(html.call(this, i2));
          });
        }
        return this.each(function() {
          var self2 = jQuery(this), contents = self2.contents();
          if (contents.length) {
            contents.wrapAll(html);
          } else {
            self2.append(html);
          }
        });
      },
      wrap: function(html) {
        var htmlIsFunction = isFunction(html);
        return this.each(function(i2) {
          jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i2) : html);
        });
      },
      unwrap: function(selector) {
        this.parent(selector).not("body").each(function() {
          jQuery(this).replaceWith(this.childNodes);
        });
        return this;
      }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
      return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
      return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
      try {
        return new window2.XMLHttpRequest();
      } catch (e2) {
      }
    };
    var xhrSuccessStatus = {
      // File protocol always yields status code 0, assume 200
      0: 200,
      // Support: IE <=9 only
      // trac-1450: sometimes IE returns 1223 when it should be 204
      1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
      var callback, errorCallback;
      if (support.cors || xhrSupported && !options.crossDomain) {
        return {
          send: function(headers, complete) {
            var i2, xhr = options.xhr();
            xhr.open(
              options.type,
              options.url,
              options.async,
              options.username,
              options.password
            );
            if (options.xhrFields) {
              for (i2 in options.xhrFields) {
                xhr[i2] = options.xhrFields[i2];
              }
            }
            if (options.mimeType && xhr.overrideMimeType) {
              xhr.overrideMimeType(options.mimeType);
            }
            if (!options.crossDomain && !headers["X-Requested-With"]) {
              headers["X-Requested-With"] = "XMLHttpRequest";
            }
            for (i2 in headers) {
              xhr.setRequestHeader(i2, headers[i2]);
            }
            callback = function(type) {
              return function() {
                if (callback) {
                  callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                  if (type === "abort") {
                    xhr.abort();
                  } else if (type === "error") {
                    if (typeof xhr.status !== "number") {
                      complete(0, "error");
                    } else {
                      complete(
                        // File: protocol always yields status 0; see trac-8605, trac-14207
                        xhr.status,
                        xhr.statusText
                      );
                    }
                  } else {
                    complete(
                      xhrSuccessStatus[xhr.status] || xhr.status,
                      xhr.statusText,
                      // Support: IE <=9 only
                      // IE9 has no XHR2 but throws on binary (trac-11426)
                      // For XHR2 non-text, let the caller handle it (gh-2498)
                      (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? { binary: xhr.response } : { text: xhr.responseText },
                      xhr.getAllResponseHeaders()
                    );
                  }
                }
              };
            };
            xhr.onload = callback();
            errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
            if (xhr.onabort !== void 0) {
              xhr.onabort = errorCallback;
            } else {
              xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                  window2.setTimeout(function() {
                    if (callback) {
                      errorCallback();
                    }
                  });
                }
              };
            }
            callback = callback("abort");
            try {
              xhr.send(options.hasContent && options.data || null);
            } catch (e2) {
              if (callback) {
                throw e2;
              }
            }
          },
          abort: function() {
            if (callback) {
              callback();
            }
          }
        };
      }
    });
    jQuery.ajaxPrefilter(function(s2) {
      if (s2.crossDomain) {
        s2.contents.script = false;
      }
    });
    jQuery.ajaxSetup({
      accepts: {
        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      },
      contents: {
        script: /\b(?:java|ecma)script\b/
      },
      converters: {
        "text script": function(text) {
          jQuery.globalEval(text);
          return text;
        }
      }
    });
    jQuery.ajaxPrefilter("script", function(s2) {
      if (s2.cache === void 0) {
        s2.cache = false;
      }
      if (s2.crossDomain) {
        s2.type = "GET";
      }
    });
    jQuery.ajaxTransport("script", function(s2) {
      if (s2.crossDomain || s2.scriptAttrs) {
        var script, callback;
        return {
          send: function(_, complete) {
            script = jQuery("<script>").attr(s2.scriptAttrs || {}).prop({ charset: s2.scriptCharset, src: s2.url }).on("load error", callback = function(evt) {
              script.remove();
              callback = null;
              if (evt) {
                complete(evt.type === "error" ? 404 : 200, evt.type);
              }
            });
            document2.head.appendChild(script[0]);
          },
          abort: function() {
            if (callback) {
              callback();
            }
          }
        };
      }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    jQuery.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function() {
        var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
        this[callback] = true;
        return callback;
      }
    });
    jQuery.ajaxPrefilter("json jsonp", function(s2, originalSettings, jqXHR) {
      var callbackName, overwritten, responseContainer, jsonProp = s2.jsonp !== false && (rjsonp.test(s2.url) ? "url" : typeof s2.data === "string" && (s2.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s2.data) && "data");
      if (jsonProp || s2.dataTypes[0] === "jsonp") {
        callbackName = s2.jsonpCallback = isFunction(s2.jsonpCallback) ? s2.jsonpCallback() : s2.jsonpCallback;
        if (jsonProp) {
          s2[jsonProp] = s2[jsonProp].replace(rjsonp, "$1" + callbackName);
        } else if (s2.jsonp !== false) {
          s2.url += (rquery.test(s2.url) ? "&" : "?") + s2.jsonp + "=" + callbackName;
        }
        s2.converters["script json"] = function() {
          if (!responseContainer) {
            jQuery.error(callbackName + " was not called");
          }
          return responseContainer[0];
        };
        s2.dataTypes[0] = "json";
        overwritten = window2[callbackName];
        window2[callbackName] = function() {
          responseContainer = arguments;
        };
        jqXHR.always(function() {
          if (overwritten === void 0) {
            jQuery(window2).removeProp(callbackName);
          } else {
            window2[callbackName] = overwritten;
          }
          if (s2[callbackName]) {
            s2.jsonpCallback = originalSettings.jsonpCallback;
            oldCallbacks.push(callbackName);
          }
          if (responseContainer && isFunction(overwritten)) {
            overwritten(responseContainer[0]);
          }
          responseContainer = overwritten = void 0;
        });
        return "script";
      }
    });
    support.createHTMLDocument = function() {
      var body = document2.implementation.createHTMLDocument("").body;
      body.innerHTML = "<form></form><form></form>";
      return body.childNodes.length === 2;
    }();
    jQuery.parseHTML = function(data, context, keepScripts) {
      if (typeof data !== "string") {
        return [];
      }
      if (typeof context === "boolean") {
        keepScripts = context;
        context = false;
      }
      var base, parsed, scripts;
      if (!context) {
        if (support.createHTMLDocument) {
          context = document2.implementation.createHTMLDocument("");
          base = context.createElement("base");
          base.href = document2.location.href;
          context.head.appendChild(base);
        } else {
          context = document2;
        }
      }
      parsed = rsingleTag.exec(data);
      scripts = !keepScripts && [];
      if (parsed) {
        return [context.createElement(parsed[1])];
      }
      parsed = buildFragment([data], context, scripts);
      if (scripts && scripts.length) {
        jQuery(scripts).remove();
      }
      return jQuery.merge([], parsed.childNodes);
    };
    jQuery.fn.load = function(url, params, callback) {
      var selector, type, response, self2 = this, off = url.indexOf(" ");
      if (off > -1) {
        selector = stripAndCollapse(url.slice(off));
        url = url.slice(0, off);
      }
      if (isFunction(params)) {
        callback = params;
        params = void 0;
      } else if (params && typeof params === "object") {
        type = "POST";
      }
      if (self2.length > 0) {
        jQuery.ajax({
          url,
          // If "type" variable is undefined, then "GET" method will be used.
          // Make value of this field explicit since
          // user can override it through ajaxSetup method
          type: type || "GET",
          dataType: "html",
          data: params
        }).done(function(responseText) {
          response = arguments;
          self2.html(selector ? (
            // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector)
          ) : (
            // Otherwise use the full result
            responseText
          ));
        }).always(callback && function(jqXHR, status) {
          self2.each(function() {
            callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
          });
        });
      }
      return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
      return jQuery.grep(jQuery.timers, function(fn) {
        return elem === fn.elem;
      }).length;
    };
    jQuery.offset = {
      setOffset: function(elem, options, i2) {
        var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position2 = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
        if (position2 === "static") {
          elem.style.position = "relative";
        }
        curOffset = curElem.offset();
        curCSSTop = jQuery.css(elem, "top");
        curCSSLeft = jQuery.css(elem, "left");
        calculatePosition = (position2 === "absolute" || position2 === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
        if (calculatePosition) {
          curPosition = curElem.position();
          curTop = curPosition.top;
          curLeft = curPosition.left;
        } else {
          curTop = parseFloat(curCSSTop) || 0;
          curLeft = parseFloat(curCSSLeft) || 0;
        }
        if (isFunction(options)) {
          options = options.call(elem, i2, jQuery.extend({}, curOffset));
        }
        if (options.top != null) {
          props.top = options.top - curOffset.top + curTop;
        }
        if (options.left != null) {
          props.left = options.left - curOffset.left + curLeft;
        }
        if ("using" in options) {
          options.using.call(elem, props);
        } else {
          curElem.css(props);
        }
      }
    };
    jQuery.fn.extend({
      // offset() relates an element's border box to the document origin
      offset: function(options) {
        if (arguments.length) {
          return options === void 0 ? this : this.each(function(i2) {
            jQuery.offset.setOffset(this, options, i2);
          });
        }
        var rect, win, elem = this[0];
        if (!elem) {
          return;
        }
        if (!elem.getClientRects().length) {
          return { top: 0, left: 0 };
        }
        rect = elem.getBoundingClientRect();
        win = elem.ownerDocument.defaultView;
        return {
          top: rect.top + win.pageYOffset,
          left: rect.left + win.pageXOffset
        };
      },
      // position() relates an element's margin box to its offset parent's padding box
      // This corresponds to the behavior of CSS absolute positioning
      position: function() {
        if (!this[0]) {
          return;
        }
        var offsetParent, offset, doc, elem = this[0], parentOffset = { top: 0, left: 0 };
        if (jQuery.css(elem, "position") === "fixed") {
          offset = elem.getBoundingClientRect();
        } else {
          offset = this.offset();
          doc = elem.ownerDocument;
          offsetParent = elem.offsetParent || doc.documentElement;
          while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {
            offsetParent = offsetParent.parentNode;
          }
          if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
            parentOffset = jQuery(offsetParent).offset();
            parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
            parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
          }
        }
        return {
          top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
          left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
        };
      },
      // This method will return documentElement in the following cases:
      // 1) For the element inside the iframe without offsetParent, this method will return
      //    documentElement of the parent window
      // 2) For the hidden or detached element
      // 3) For body or html element, i.e. in case of the html node - it will return itself
      //
      // but those exceptions were never presented as a real life use-cases
      // and might be considered as more preferable results.
      //
      // This logic, however, is not guaranteed and can change at any point in the future
      offsetParent: function() {
        return this.map(function() {
          var offsetParent = this.offsetParent;
          while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
            offsetParent = offsetParent.offsetParent;
          }
          return offsetParent || documentElement;
        });
      }
    });
    jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(method, prop) {
      var top = "pageYOffset" === prop;
      jQuery.fn[method] = function(val) {
        return access(this, function(elem, method2, val2) {
          var win;
          if (isWindow(elem)) {
            win = elem;
          } else if (elem.nodeType === 9) {
            win = elem.defaultView;
          }
          if (val2 === void 0) {
            return win ? win[prop] : elem[method2];
          }
          if (win) {
            win.scrollTo(
              !top ? val2 : win.pageXOffset,
              top ? val2 : win.pageYOffset
            );
          } else {
            elem[method2] = val2;
          }
        }, method, val, arguments.length);
      };
    });
    jQuery.each(["top", "left"], function(_i, prop) {
      jQuery.cssHooks[prop] = addGetHookIf(
        support.pixelPosition,
        function(elem, computed) {
          if (computed) {
            computed = curCSS(elem, prop);
            return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
          }
        }
      );
    });
    jQuery.each({ Height: "height", Width: "width" }, function(name, type) {
      jQuery.each({
        padding: "inner" + name,
        content: type,
        "": "outer" + name
      }, function(defaultExtra, funcName) {
        jQuery.fn[funcName] = function(margin, value) {
          var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
          return access(this, function(elem, type2, value2) {
            var doc;
            if (isWindow(elem)) {
              return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
            }
            if (elem.nodeType === 9) {
              doc = elem.documentElement;
              return Math.max(
                elem.body["scroll" + name],
                doc["scroll" + name],
                elem.body["offset" + name],
                doc["offset" + name],
                doc["client" + name]
              );
            }
            return value2 === void 0 ? (
              // Get width or height on the element, requesting but not forcing parseFloat
              jQuery.css(elem, type2, extra)
            ) : (
              // Set width or height on the element
              jQuery.style(elem, type2, value2, extra)
            );
          }, type, chainable ? margin : void 0, chainable);
        };
      });
    });
    jQuery.each([
      "ajaxStart",
      "ajaxStop",
      "ajaxComplete",
      "ajaxError",
      "ajaxSuccess",
      "ajaxSend"
    ], function(_i, type) {
      jQuery.fn[type] = function(fn) {
        return this.on(type, fn);
      };
    });
    jQuery.fn.extend({
      bind: function(types, data, fn) {
        return this.on(types, null, data, fn);
      },
      unbind: function(types, fn) {
        return this.off(types, null, fn);
      },
      delegate: function(selector, types, data, fn) {
        return this.on(types, selector, data, fn);
      },
      undelegate: function(selector, types, fn) {
        return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
      },
      hover: function(fnOver, fnOut) {
        return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
      }
    });
    jQuery.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),
      function(_i, name) {
        jQuery.fn[name] = function(data, fn) {
          return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
      }
    );
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    jQuery.proxy = function(fn, context) {
      var tmp2, args, proxy;
      if (typeof context === "string") {
        tmp2 = fn[context];
        context = fn;
        fn = tmp2;
      }
      if (!isFunction(fn)) {
        return void 0;
      }
      args = slice2.call(arguments, 2);
      proxy = function() {
        return fn.apply(context || this, args.concat(slice2.call(arguments)));
      };
      proxy.guid = fn.guid = fn.guid || jQuery.guid++;
      return proxy;
    };
    jQuery.holdReady = function(hold) {
      if (hold) {
        jQuery.readyWait++;
      } else {
        jQuery.ready(true);
      }
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
      var type = jQuery.type(obj);
      return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
      // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
      // subtraction forces infinities to NaN
      !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
      return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    var _jQuery = window2.jQuery, _$ = window2.$;
    jQuery.noConflict = function(deep) {
      if (window2.$ === jQuery) {
        window2.$ = _$;
      }
      if (deep && window2.jQuery === jQuery) {
        window2.jQuery = _jQuery;
      }
      return jQuery;
    };
    if (typeof noGlobal === "undefined") {
      window2.jQuery = window2.$ = jQuery;
    }
    return jQuery;
  });
})(jquery);
var jqueryExports = jquery.exports;
const $ = /* @__PURE__ */ getDefaultExportFromCjs(jqueryExports);
const WORLD_SIZE = 1024e3;
const FOV = Math.atan(3 / 4);
const EARTH_RADIUS = 63710088e-1;
const ThreeboxConstants = {
  WORLD_SIZE,
  PROJECTION_WORLD_SIZE: WORLD_SIZE / (EARTH_RADIUS * Math.PI * 2),
  MERCATOR_A: EARTH_RADIUS,
  DEG2RAD: Math.PI / 180,
  EARTH_CIRCUMFERENCE: 2 * Math.PI * EARTH_RADIUS,
  //40075000, // In meters
  FOV_DEGREES: FOV * 180 / Math.PI,
  // Math.atan(3/4) in degrees
  TILE_SIZE: 512
};
class Validate {
  Coords(input) {
    if (input.constructor !== Array) {
      console.error("Coords must be an array");
      return;
    }
    if (input.length < 2) {
      console.error("Coords length must be at least 2");
      return;
    }
    for (const member of input) {
      if (member.constructor !== Number) {
        console.error("Coords values must be numbers");
        return;
      }
    }
    if (Math.abs(input[1]) > 90) {
      console.error("Latitude must be between -90 and 90");
      return;
    }
    return input;
  }
  Line(input) {
    var scope = this;
    if (input.constructor !== Array) {
      console.error("Line must be an array");
      return;
    }
    for (const coord of input) {
      if (!scope.Coords(coord)) {
        console.error("Each coordinate in a line must be a valid Coords type");
        return;
      }
    }
    return input;
  }
  Rotation(input) {
    if (input.constructor === Number) {
      input = { z: input };
    } else if (input.constructor === Object) {
      for (const key of Object.keys(input)) {
        if (!["x", "y", "z"].includes(key)) {
          console.error("Rotation parameters must be x, y, or z");
          return;
        }
        if (input[key].constructor !== Number) {
          console.error("Individual rotation values must be numbers");
          return;
        }
      }
    } else if (!(input instanceof Vector3$1)) {
      console.error("Rotation must be an object or a number");
      return;
    }
    return input;
  }
  Scale(input) {
    if (input.constructor === Number) {
      input = { x: input, y: input, z: input };
    } else if (input.constructor === Object) {
      for (const key of Object.keys(input)) {
        if (!["x", "y", "z"].includes(key)) {
          console.error("Scale parameters must be x, y, or z");
          return;
        }
        if (input[key].constructor !== Number) {
          console.error("Individual scale values must be numbers");
          return;
        }
      }
    } else if (!(input instanceof Vector3$1)) {
      console.error("Scale must be an object or a number");
      return;
    }
    return input;
  }
}
const utils = {
  prettyPrintMatrix: function(uglymatrix) {
    for (let s2 = 0; s2 < 4; s2++) {
      let quartet = [uglymatrix[s2], uglymatrix[s2 + 4], uglymatrix[s2 + 8], uglymatrix[s2 + 12]];
      console.log(
        quartet.map(function(num) {
          return num.toFixed(4);
        })
      );
    }
  },
  // 创建DOM
  createDOM(tagName, className, container) {
    const el = document.createElement(tagName);
    if (className !== void 0 && className !== null) el.className = className;
    if (container) container.appendChild(el);
    return el;
  },
  // 生成透视矩阵
  makePerspectiveMatrix: function(fovy, aspect2, near, far) {
    let out = new Matrix4$1();
    let f2 = 1 / Math.tan(fovy / 2);
    let nf = 1 / (near - far);
    var newMatrix = [
      f2 / aspect2,
      0,
      0,
      0,
      0,
      f2,
      0,
      0,
      0,
      0,
      (far + near) * nf,
      -1,
      0,
      0,
      2 * far * near * nf,
      0
    ];
    out.elements = newMatrix;
    return out;
  },
  // new orthographic matrix calculations https://en.wikipedia.org/wiki/Orthographic_projection and validated with https://bit.ly/3rPvB9Y
  // 生成正交矩阵
  makeOrthographicMatrix: function(left, right, top, bottom, near, far) {
    let out = new Matrix4$1();
    const w = 1 / (right - left);
    const h2 = 1 / (top - bottom);
    const p2 = 1 / (far - near);
    const x = (right + left) * w;
    const y = (top + bottom) * h2;
    const z2 = near * p2;
    let newMatrix = [2 * w, 0, 0, 0, 0, 2 * h2, 0, 0, 0, 0, -1 * p2, 0, -x, -y, -z2, 1];
    out.elements = newMatrix;
    return out;
  },
  // 角度转弧度
  radify: function(deg2) {
    function convert2(degrees) {
      degrees = degrees || 0;
      return Math.PI * 2 * degrees / 360;
    }
    if (typeof deg2 === "object") {
      if (deg2.length > 0) {
        return deg2.map(function(degree) {
          return convert2(degree);
        });
      } else {
        return [convert2(deg2.x), convert2(deg2.y), convert2(deg2.z)];
      }
    } else return convert2(deg2);
  },
  // 弧度转角度
  degreeify: function(rad2) {
    function convert2(radians) {
      radians = radians || 0;
      return radians * 360 / (Math.PI * 2);
    }
    if (typeof rad2 === "object") {
      return [convert2(rad2.x), convert2(rad2.y), convert2(rad2.z)];
    } else return convert2(rad2);
  },
  // 经纬度转threejs世界坐标
  projectToWorld: function(coords) {
    let projected = [
      -63710088e-1 * ThreeboxConstants.DEG2RAD * coords[0] * ThreeboxConstants.PROJECTION_WORLD_SIZE,
      -63710088e-1 * Math.log(Math.tan(Math.PI * 0.25 + 0.5 * ThreeboxConstants.DEG2RAD * coords[1])) * ThreeboxConstants.PROJECTION_WORLD_SIZE
    ];
    if (!coords[2]) projected.push(0);
    else {
      let pixelsPerMeter = this.projectedUnitsPerMeter(coords[1]);
      projected.push(coords[2] * pixelsPerMeter);
    }
    return new Vector3$1(projected[0], projected[1], projected[2]);
  },
  // 根据纬度计算每米世界坐标
  projectedUnitsPerMeter: function(latitude) {
    return Math.abs(
      ThreeboxConstants.WORLD_SIZE / Math.cos(ThreeboxConstants.DEG2RAD * latitude) / ThreeboxConstants.EARTH_CIRCUMFERENCE
    );
  },
  // 墨卡托每米世界坐标
  projectedUnitsPerMercator: function() {
    return Math.abs(ThreeboxConstants.WORLD_SIZE / ThreeboxConstants.EARTH_CIRCUMFERENCE);
  },
  // 纬度周长
  circumferenceAtLatitude: function(latitude) {
    return ThreeboxConstants.EARTH_CIRCUMFERENCE * Math.cos(latitude * Math.PI / 180);
  },
  // 根据高度计算墨卡托Z值
  mercatorZfromAltitude: function(altitude2, lat) {
    return altitude2 / this.circumferenceAtLatitude(lat);
  },
  // 根据纬度和长度单位计算缩放比例
  projectedScaleByUnits: function(latitude, units) {
    let scale = utils.projectedUnitsPerMeter(latitude);
    switch (units) {
      case "decimeters":
        scale /= 10;
        break;
      case "centimeters":
        scale /= 100;
        break;
      case "millimeters":
        scale /= 1e3;
        break;
      case "decimillimeters":
        scale /= 1e4;
        break;
      case "kilometers":
        scale *= 1e3;
        break;
      case "meters":
        break;
      default:
        scale = 1;
        break;
    }
    return scale;
  },
  _scaleVerticesToMeters: function(centerLatLng, vertices) {
    let pixelsPerMeter = this.projectedUnitsPerMeter(centerLatLng[1]);
    for (var i2 = 0; i2 < vertices.length; i2++) {
      vertices[i2].multiplyScalar(pixelsPerMeter);
    }
    return vertices;
  },
  /*
    projectToScreen: function (coords) {
      console.log('WARNING: Projecting to screen coordinates is not yet implemented')
    },
  
    unprojectFromScreen: function (pixel) {
      console.log('WARNING: unproject is not yet implemented')
    },
  */
  // threejs世界坐标转经纬度
  unprojectFromWorld: function(worldUnits) {
    let unprojected = [
      -worldUnits.x / (ThreeboxConstants.MERCATOR_A * ThreeboxConstants.DEG2RAD * ThreeboxConstants.PROJECTION_WORLD_SIZE),
      2 * (Math.atan(
        Math.exp(worldUnits.y / (ThreeboxConstants.PROJECTION_WORLD_SIZE * -63710088e-1))
      ) - Math.PI / 4) / ThreeboxConstants.DEG2RAD
    ];
    let pixelsPerMeter = this.projectedUnitsPerMeter(unprojected[1]);
    var height = worldUnits.z || 0;
    unprojected.push(height / pixelsPerMeter);
    return unprojected;
  },
  toScreenPosition: function(obj, camera, renderer) {
    var vector = new Vector3$1();
    var widthHalf = 0.5 * renderer.context.canvas.width;
    var heightHalf = 0.5 * renderer.context.canvas.height;
    obj.updateMatrixWorld();
    vector.setFromMatrixPosition(obj.matrixWorld);
    vector.project(camera);
    vector.x = vector.x * widthHalf + widthHalf;
    vector.y = -(vector.y * heightHalf) + heightHalf;
    return {
      x: vector.x,
      y: vector.y
    };
  },
  // 计算要素中心点
  getFeatureCenter: function(feature2, model, level) {
    let center = [];
    let latitude = 0;
    let longitude = 0;
    let height = 0;
    let coordinates = [...feature2.geometry.coordinates[0]];
    if (feature2.geometry.type === "Point") {
      center = [...coordinates[0]];
    } else {
      if (feature2.geometry.type === "MultiPolygon") coordinates = coordinates[0];
      coordinates.splice(-1, 1);
      coordinates.forEach(function(c2) {
        latitude += c2[0];
        longitude += c2[1];
      });
      center = [latitude / coordinates.length, longitude / coordinates.length];
    }
    height = this.getObjectHeightOnFloor(feature2, model, level);
    center.length < 3 ? center.push(height) : center[2] = height;
    return center;
  },
  getObjectHeightOnFloor: function(feature2, obj, level = feature2.properties.level || 0) {
    let floorHeightMin = level * (feature2.properties.levelHeight || 0);
    let base = feature2.properties.base_height || feature2.properties.min_height || 0;
    let height = obj && obj.model ? 0 : feature2.properties.height - base;
    let objectHeight = height + base;
    let modelHeightFloor = floorHeightMin + objectHeight;
    return modelHeightFloor;
  },
  //_flipMaterialSides: function (obj) {},
  // to improve precision, normalize a series of vector3's to their collective center, and move the resultant mesh to that center
  normalizeVertices(vertices) {
    let geometry = new BufferGeometry$1();
    let positions = [];
    for (var j = 0; j < vertices.length; j++) {
      let p2 = vertices[j];
      positions.push(p2.x, p2.y, p2.z);
      positions.push(p2.x, p2.y, p2.z);
    }
    geometry.setAttribute("position", new BufferAttribute$1(new Float32Array(positions), 3));
    geometry.computeBoundingSphere();
    let center = geometry.boundingSphere.center;
    let scaled = vertices.map(function(v3) {
      return v3.sub(center);
    });
    return { vertices: scaled, position: center };
  },
  //flatten an array of Vector3's into a shallow array of values in x-y-z order, for bufferGeometry
  flattenVectors(vectors) {
    let flattenedArray = [];
    for (let vertex2 of vectors) {
      flattenedArray.push(vertex2.x, vertex2.y, vertex2.z);
    }
    return flattenedArray;
  },
  // 多个经纬度坐标转threejs世界坐标
  lnglatsToWorld: function(coords) {
    let vector3 = coords.map(function(pt2) {
      let p2 = utils.projectToWorld(pt2);
      return new Vector3$1(p2.x, p2.y, p2.z);
    });
    return vector3;
  },
  extend: function(original, addition) {
    for (let key in addition) original[key] = addition[key];
  },
  clone: function(original) {
    let clone2 = {};
    for (let key in original) clone2[key] = original[key];
    return clone2;
  },
  clamp: function(n2, min, max2) {
    return Math.min(max2, Math.max(min, n2));
  },
  // retrieve object parameters from an options object
  types: {
    rotation: function(r2, currentRotation) {
      if (!r2) {
        r2 = 0;
      }
      if (typeof r2 === "number") r2 = { z: r2 };
      let degrees = this.applyDefault([r2.x, r2.y, r2.z], currentRotation);
      let radians = utils.radify(degrees);
      return radians;
    },
    scale: function(s2, currentScale) {
      if (!s2) {
        s2 = 1;
      }
      if (typeof s2 === "number") return [s2, s2, s2];
      else return this.applyDefault([s2.x, s2.y, s2.z], currentScale);
    },
    applyDefault: function(array, current) {
      let output = array.map(function(item, index2) {
        item = item || current[index2];
        return item;
      });
      return output;
    }
  },
  toDecimal: function(n2, d2) {
    return Number(n2.toFixed(d2));
  },
  equal: function(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    if (keys1.length == 0 && keys2.length == 0 && keys1 !== keys2) {
      return false;
    }
    for (const key of keys1) {
      const val1 = obj1[key];
      const val2 = obj2[key];
      const areObjects = utils.isObject(val1) && utils.isObject(val2);
      if (areObjects && !utils.equal(val1, val2) || !areObjects && val1 !== val2) {
        return false;
      }
    }
    return true;
  },
  isObject: function(object) {
    return object != null && typeof object === "object";
  },
  curveToLine: (curve, params) => {
    let { width, color: color2 } = params;
    let geometry = new BufferGeometry$1().setFromPoints(curve.getPoints(100));
    let material = new LineBasicMaterial$1({
      color: color2,
      linewidth: width
    });
    let line = new Line$1(geometry, material);
    return line;
  },
  curvesToLines: (curves) => {
    const colors = [16711680, 2031360, 2490623];
    let lines = curves.map((curve, i2) => {
      let params = {
        width: 3,
        color: colors[i2] || "purple"
      };
      let curveline = utils.curveToLine(curve, params);
      return curveline;
    });
    return lines;
  },
  _validate: function(userInputs, defaults2) {
    userInputs = userInputs || {};
    let validatedOutput = {};
    utils.extend(validatedOutput, userInputs);
    for (let key of Object.keys(defaults2)) {
      if (userInputs[key] === void 0) {
        if (defaults2[key] === null) {
          console.error(key + " is required");
          return;
        } else validatedOutput[key] = defaults2[key];
      } else validatedOutput[key] = userInputs[key];
    }
    return validatedOutput;
  },
  // @function template(str: String, data: Object): String
  // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
  // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
  // `('Hello foo, bar')`. You can also specify functions instead of strings for
  // data values — they will be evaluated passing `data` as an argument.
  template(str, data) {
    return str.replace(/\{ *([\w_-]+) *\}/g, function(str2, key) {
      var value = data[key];
      if (value === void 0) {
        throw new Error("No value provided for variable " + str2);
      } else if (typeof value === "function") {
        value = value(data);
      }
      return value;
    });
  },
  Validator: new Validate(),
  exposedMethods: ["projectToWorld", "projectedUnitsPerMeter", "extend", "unprojectFromWorld"]
};
class CameraSync {
  constructor(map, camera, world) {
    let _this = this;
    this.map = map;
    this.camera = camera;
    this.camera.matrixAutoUpdate = false;
    this.world = world || new Group$1();
    this.world.position.x = this.world.position.y = ThreeboxConstants.WORLD_SIZE / 2;
    this.world.matrixAutoUpdate = false;
    this.state = {
      fov: 0.6435011087932844,
      translateCenter: new Matrix4$1().makeTranslation(
        ThreeboxConstants.WORLD_SIZE / 2,
        -1024e3 / 2,
        0
      ),
      worldSizeRatio: ThreeboxConstants.TILE_SIZE / ThreeboxConstants.WORLD_SIZE
    };
    this.map.on("move", function() {
      _this.updateCamera();
    }).on("resize", function() {
      _this.setupCamera();
    });
    this.setupCamera();
  }
  // 设置相机
  setupCamera() {
    this.state.cameraToCenterDistance = 0.5 / Math.tan(this.state.fov / 2) * this.map.transform.height;
    this.updateCamera();
  }
  // 更新相机
  updateCamera() {
    if (!this.camera) {
      console.log("nocamera");
      return;
    }
    const t3 = this.map.transform;
    this.camera.aspect = t3.width / t3.height;
    const groundAngle = Math.PI / 2 + t3._pitch;
    const offset = t3.centerOffset || new Vector3$1();
    const fovAboveCenter = this.state.fov * (0.5 + offset.y / t3.height);
    const minElevationInPixels = t3.elevation ? t3.elevation.getMinElevationBelowMSL() * t3.pixelsPerMeter : 0;
    const cameraToSeaLevelDistance = (t3._camera.position[2] * t3.worldSize - minElevationInPixels) / Math.cos(t3._pitch);
    const topHalfSurfaceDistance = Math.sin(fovAboveCenter) * cameraToSeaLevelDistance / Math.sin(utils.clamp(Math.PI - groundAngle - fovAboveCenter, 0.01, Math.PI - 0.01));
    const furthestDistance = Math.cos(Math.PI / 2 - t3._pitch) * topHalfSurfaceDistance + cameraToSeaLevelDistance;
    this._horizonShift = 0.1;
    const farZ1 = 2.8 * furthestDistance;
    const farZ2 = cameraToSeaLevelDistance * (1 / this._horizonShift);
    const farZ = Math.min(farZ1, farZ2);
    const nz = t3.height / 50;
    const nearZ = Math.max(nz * Math.cos(Math.PI / 2 - t3._pitch), nz);
    const h2 = t3.height;
    const w = t3.width;
    let projectionMatrix;
    if (this.camera instanceof OrthographicCamera$1) {
      projectionMatrix = utils.makeOrthographicMatrix(w / -2, w / 2, h2 / 2, h2 / -2, nearZ, farZ);
    } else {
      projectionMatrix = utils.makePerspectiveMatrix(this.state.fov, w / h2, nearZ, farZ);
    }
    projectionMatrix.elements[8] = -offset.x * 2 / t3.width;
    projectionMatrix.elements[9] = offset.y * 2 / t3.height;
    this.camera.projectionMatrix = projectionMatrix;
    this.camera.near = nearZ;
    this.camera.far = farZ;
    let cameraWorldMatrix = new Matrix4$1().premultiply(new Matrix4$1().makeTranslation(0, 0, this.state.cameraToCenterDistance)).premultiply(new Matrix4$1().makeRotationX(t3._pitch)).premultiply(new Matrix4$1().makeRotationZ(t3.angle));
    if (t3.elevation) cameraWorldMatrix.elements[14] = t3._camera.position[2] * t3.worldSize;
    this.camera.matrixWorld.copy(cameraWorldMatrix);
    let zoomPow = t3.scale * this.state.worldSizeRatio;
    let scale = new Matrix4$1();
    let translateMap = new Matrix4$1();
    let rotateMap = new Matrix4$1();
    scale.makeScale(zoomPow, zoomPow, zoomPow);
    translateMap.makeTranslation(-(t3.x || t3.point.x), t3.y || t3.point.y, 0);
    rotateMap.makeRotationZ(Math.PI);
    this.world.matrix = new Matrix4$1().premultiply(rotateMap).premultiply(this.state.translateCenter).premultiply(scale).premultiply(translateMap);
    this.camera.projectionMatrixInverse.copy(this.camera.projectionMatrix).invert();
    this.map.fire("CameraSynced", {
      detail: {
        nearZ,
        farZ,
        pitch: t3._pitch,
        angle: t3.angle,
        furthestDistance,
        cameraToCenterDistance: this.state.cameraToCenterDistance,
        t: this.map.transform,
        tbProjMatrix: this.camera.projectionMatrix.elements,
        tbWorldMatrix: this.world.matrix.elements
      }
    });
  }
}
var PI = Math.PI, sin = Math.sin, cos = Math.cos, tan = Math.tan, asin = Math.asin, atan = Math.atan2, acos = Math.acos, rad = PI / 180;
var dayMs = 1e3 * 60 * 60 * 24, J1970 = 2440588, J2000 = 2451545;
function toJulian(date) {
  return date.valueOf() / dayMs - 0.5 + J1970;
}
function fromJulian(j) {
  return new Date((j + 0.5 - J1970) * dayMs);
}
function toDays(date) {
  return toJulian(date) - J2000;
}
var e$1 = rad * 23.4397;
function rightAscension(l2, b) {
  return atan(sin(l2) * cos(e$1) - tan(b) * sin(e$1), cos(l2));
}
function declination(l2, b) {
  return asin(sin(b) * cos(e$1) + cos(b) * sin(e$1) * sin(l2));
}
function azimuth(H, phi, dec) {
  return atan(sin(H), cos(H) * sin(phi) - tan(dec) * cos(phi));
}
function altitude(H, phi, dec) {
  return asin(sin(phi) * sin(dec) + cos(phi) * cos(dec) * cos(H));
}
function siderealTime(d2, lw) {
  return rad * (280.16 + 360.9856235 * d2) - lw;
}
function astroRefraction(h2) {
  if (h2 < 0)
    h2 = 0;
  return 2967e-7 / Math.tan(h2 + 312536e-8 / (h2 + 0.08901179));
}
function solarMeanAnomaly(d2) {
  return rad * (357.5291 + 0.98560028 * d2);
}
function eclipticLongitude(M) {
  var C2 = rad * (1.9148 * sin(M) + 0.02 * sin(2 * M) + 3e-4 * sin(3 * M)), P = rad * 102.9372;
  return M + C2 + P + PI;
}
function sunCoords(d2) {
  var M = solarMeanAnomaly(d2), L2 = eclipticLongitude(M);
  return {
    dec: declination(L2, 0),
    ra: rightAscension(L2, 0)
  };
}
var SunCalc = {};
SunCalc.getPosition = function(date, lat, lng) {
  var lw = rad * -lng, phi = rad * lat, d2 = toDays(date), c2 = sunCoords(d2), H = siderealTime(d2, lw) - c2.ra;
  return {
    azimuth: azimuth(H, phi, c2.dec),
    altitude: altitude(H, phi, c2.dec)
  };
};
SunCalc.toJulian = function(date) {
  return toJulian(date);
};
var times = SunCalc.times = [
  [-0.833, "sunrise", "sunset"],
  [-0.3, "sunriseEnd", "sunsetStart"],
  [-6, "dawn", "dusk"],
  [-12, "nauticalDawn", "nauticalDusk"],
  [-18, "nightEnd", "night"],
  [6, "goldenHourEnd", "goldenHour"]
];
SunCalc.addTime = function(angle2, riseName, setName) {
  times.push([angle2, riseName, setName]);
};
var J0 = 9e-4;
function julianCycle(d2, lw) {
  return Math.round(d2 - J0 - lw / (2 * PI));
}
function approxTransit(Ht, lw, n2) {
  return J0 + (Ht + lw) / (2 * PI) + n2;
}
function solarTransitJ(ds, M, L2) {
  return J2000 + ds + 53e-4 * sin(M) - 69e-4 * sin(2 * L2);
}
function hourAngle(h2, phi, d2) {
  return acos((sin(h2) - sin(phi) * sin(d2)) / (cos(phi) * cos(d2)));
}
function observerAngle(height) {
  return -2.076 * Math.sqrt(height) / 60;
}
function getSetJ(h2, lw, phi, dec, n2, M, L2) {
  var w = hourAngle(h2, phi, dec), a3 = approxTransit(w, lw, n2);
  return solarTransitJ(a3, M, L2);
}
SunCalc.getTimes = function(date, lat, lng, height) {
  height = height || 0;
  var lw = rad * -lng, phi = rad * lat, dh = observerAngle(height), d2 = toDays(date), n2 = julianCycle(d2, lw), ds = approxTransit(0, lw, n2), M = solarMeanAnomaly(ds), L2 = eclipticLongitude(M), dec = declination(L2, 0), Jnoon = solarTransitJ(ds, M, L2), i2, len, time2, h0, Jset, Jrise;
  var result = {
    solarNoon: fromJulian(Jnoon),
    nadir: fromJulian(Jnoon - 0.5)
  };
  for (i2 = 0, len = times.length; i2 < len; i2 += 1) {
    time2 = times[i2];
    h0 = (time2[0] + dh) * rad;
    Jset = getSetJ(h0, lw, phi, dec, n2, M, L2);
    Jrise = Jnoon - (Jset - Jnoon);
    result[time2[1]] = fromJulian(Jrise);
    result[time2[2]] = fromJulian(Jset);
  }
  return result;
};
function moonCoords(d2) {
  var L2 = rad * (218.316 + 13.176396 * d2), M = rad * (134.963 + 13.064993 * d2), F2 = rad * (93.272 + 13.22935 * d2), l2 = L2 + rad * 6.289 * sin(M), b = rad * 5.128 * sin(F2), dt = 385001 - 20905 * cos(M);
  return {
    ra: rightAscension(l2, b),
    dec: declination(l2, b),
    dist: dt
  };
}
SunCalc.getMoonPosition = function(date, lat, lng) {
  var lw = rad * -lng, phi = rad * lat, d2 = toDays(date), c2 = moonCoords(d2), H = siderealTime(d2, lw) - c2.ra, h2 = altitude(H, phi, c2.dec), pa = atan(sin(H), tan(phi) * cos(c2.dec) - sin(c2.dec) * cos(H));
  h2 = h2 + astroRefraction(h2);
  return {
    azimuth: azimuth(H, phi, c2.dec),
    altitude: h2,
    distance: c2.dist,
    parallacticAngle: pa
  };
};
SunCalc.getMoonIllumination = function(date) {
  var d2 = toDays(date || /* @__PURE__ */ new Date()), s2 = sunCoords(d2), m = moonCoords(d2), sdist = 149598e3, phi = acos(sin(s2.dec) * sin(m.dec) + cos(s2.dec) * cos(m.dec) * cos(s2.ra - m.ra)), inc = atan(sdist * sin(phi), m.dist - sdist * cos(phi)), angle2 = atan(
    cos(s2.dec) * sin(s2.ra - m.ra),
    sin(s2.dec) * cos(m.dec) - cos(s2.dec) * sin(m.dec) * cos(s2.ra - m.ra)
  );
  return {
    fraction: (1 + cos(inc)) / 2,
    phase: 0.5 + 0.5 * inc * (angle2 < 0 ? -1 : 1) / Math.PI,
    angle: angle2
  };
};
function hoursLater(date, h2) {
  return new Date(date.valueOf() + h2 * dayMs / 24);
}
SunCalc.getMoonTimes = function(date, lat, lng, inUTC) {
  var t3 = new Date(date);
  if (inUTC) t3.setUTCHours(0, 0, 0, 0);
  else t3.setHours(0, 0, 0, 0);
  var hc = 0.133 * rad, h0 = SunCalc.getMoonPosition(t3, lat, lng).altitude - hc, h1, h2, rise, set, a3, b, xe, ye, d2, roots, x1, x2, dx;
  for (var i2 = 1; i2 <= 24; i2 += 2) {
    h1 = SunCalc.getMoonPosition(hoursLater(t3, i2), lat, lng).altitude - hc;
    h2 = SunCalc.getMoonPosition(hoursLater(t3, i2 + 1), lat, lng).altitude - hc;
    a3 = (h0 + h2) / 2 - h1;
    b = (h2 - h0) / 2;
    xe = -b / (2 * a3);
    ye = (a3 * xe + b) * xe + h1;
    d2 = b * b - 4 * a3 * h1;
    roots = 0;
    if (d2 >= 0) {
      dx = Math.sqrt(d2) / (Math.abs(a3) * 2);
      x1 = xe - dx;
      x2 = xe + dx;
      if (Math.abs(x1) <= 1) roots++;
      if (Math.abs(x2) <= 1) roots++;
      if (x1 < -1) x1 = x2;
    }
    if (roots === 1) {
      if (h0 < 0) rise = i2 + x1;
      else set = i2 + x1;
    } else if (roots === 2) {
      rise = i2 + (ye < 0 ? x2 : x1);
      set = i2 + (ye < 0 ? x1 : x2);
    }
    if (rise && set) break;
    h0 = h2;
  }
  var result = {};
  if (rise) result.rise = hoursLater(t3, rise);
  if (set) result.set = hoursLater(t3, set);
  if (!rise && !set) result[ye > 0 ? "alwaysUp" : "alwaysDown"] = true;
  return result;
};
const defaults = {
  followPath: {
    path: null,
    duration: 1e3,
    trackHeading: true
  }
};
class AnimationManager {
  constructor(map) {
    this.map = map;
    this.enrolledObjects = [];
    this.previousFrameTime = null;
  }
  // 取消登记
  unenroll(obj) {
    let index2 = this.enrolledObjects.indexOf(obj);
    if (index2 > -1) {
      obj.traverse((childObj) => {
        if (childObj instanceof Mesh$1) {
          childObj.geometry.disposeBoundsTree();
        }
      });
      this.enrolledObjects.splice(index2, 1);
    }
  }
  // 登记
  enroll(obj) {
    const _this = this;
    this.enrolledObjects.push(obj);
    obj.animationQueue = [];
    obj.set = function(options) {
      if (options.duration > 0) {
        let newParams = {
          start: Date.now(),
          expiration: Date.now() + options.duration,
          endState: {}
        };
        utils.extend(options, newParams);
        let translating = options.coords;
        let rotating = options.rotation;
        let scaling = options.scale || options.scaleX || options.scaleY || options.scaleZ;
        if (rotating) {
          let r2 = obj.rotation;
          options.startRotation = [r2.x, r2.y, r2.z];
          options.endState.rotation = utils.types.rotation(options.rotation, options.startRotation);
          options.rotationPerMs = options.endState.rotation.map(function(angle2, index2) {
            return (angle2 - options.startRotation[index2]) / options.duration;
          });
        }
        if (scaling) {
          let s2 = obj.scale;
          options.startScale = [s2.x, s2.y, s2.z];
          options.endState.scale = utils.types.scale(options.scale, options.startScale);
          options.scalePerMs = options.endState.scale.map(function(scale, index2) {
            return (scale - options.startScale[index2]) / options.duration;
          });
        }
        if (translating)
          options.pathCurve = new CatmullRomCurve3$1(
            utils.lnglatsToWorld([obj.coordinates, options.coords])
          );
        let entry = {
          type: "set",
          parameters: options
        };
        this.animationQueue.push(entry);
        _this.map.repaint = true;
      } else {
        this.stop();
        this._setObject(options);
      }
      return this;
    };
    obj.stop = function() {
      this.animationQueue = [];
      return this;
    };
    obj.followPath = function(options, cb) {
      let entry = {
        type: "followPath",
        parameters: utils._validate(options, defaults.followPath)
      };
      utils.extend(entry.parameters, {
        pathCurve: new CatmullRomCurve3$1(utils.lnglatsToWorld(options.path)),
        start: Date.now(),
        expiration: Date.now() + entry.parameters.duration,
        cb
      });
      this.animationQueue.push(entry);
      _this.map.repaint = true;
      return this;
    };
    obj._setObject = function(options) {
      let lnglat = options.position;
      let radians = options.rotation;
      let scale = options.scale;
      let worldUnits = options.worldUnits;
      let quaternion = options.quaternion;
      if (lnglat) {
        this.coordinates = lnglat;
        worldUnits = utils.projectToWorld(lnglat);
        this.position.copy(worldUnits);
        const normalScale = utils.projectedScaleByUnits(this.coordinates[1], this.userData.units);
        if (scale) {
          this.customScale = [scale[0], scale[1], scale[2]];
          this.scale.set(scale[0] * normalScale, scale[1] * normalScale, scale[2] * normalScale);
          options.scale = this.customScale;
        } else {
          if (!this.customScale) this.customScale = [1, 1, 1];
          this.scale.set(
            this.customScale[0] * normalScale,
            this.customScale[1] * normalScale,
            this.customScale[2] * normalScale
          );
        }
      } else if (worldUnits) {
        this.position.copy(worldUnits);
        lnglat = utils.unprojectFromWorld(worldUnits);
        this.coordinates = options.position = lnglat;
        const normalScale = utils.projectedScaleByUnits(this.coordinates[1], this.userData.units);
        if (scale) {
          this.customScale = [scale[0], scale[1], scale[2]];
          this.scale.set(scale[0] * normalScale, scale[1] * normalScale, scale[2] * normalScale);
          options.scale = this.customScale;
        } else {
          if (!this.customScale) this.customScale = [1, 1, 1];
          this.scale.set(
            this.customScale[0] * normalScale,
            this.customScale[1] * normalScale,
            this.customScale[2] * normalScale
          );
        }
      } else if (scale) {
        const normalScale = utils.projectedScaleByUnits(this.coordinates[1], this.userData.units);
        this.customScale = [scale[0], scale[1], scale[2]];
        this.scale.set(scale[0] * normalScale, scale[1] * normalScale, scale[2] * normalScale);
        options.scale = this.customScale;
      }
      if (radians) {
        radians = utils.radify(radians);
        this.rotation.set(radians[0], radians[1], radians[2]);
        options.rotation = radians;
      } else if (quaternion) {
        this.quaternion.setFromAxisAngle(quaternion[0], quaternion[1]);
        options.rotation = quaternion[0].multiplyScalar(quaternion[1]);
      }
      this.updateMatrixWorld();
      _this.map.repaint = true;
      this.dispatchEvent({
        type: "ObjectChanged",
        detail: {
          object: this,
          action: { position: options.position, rotation: options.rotation, scale: options.scale }
        }
      });
    };
    obj.traverse((childObj) => {
      if (childObj instanceof Mesh$1) {
        childObj.geometry.computeBoundsTree();
      }
    });
  }
  update(now2) {
    if (this.previousFrameTime === void 0) this.previousFrameTime = now2;
    if (!this.enrolledObjects) return false;
    for (let a3 = this.enrolledObjects.length - 1; a3 >= 0; a3--) {
      let object = this.enrolledObjects[a3];
      if (!object.animationQueue || object.animationQueue.length === 0) continue;
      for (let i2 = object.animationQueue.length - 1; i2 >= 0; i2--) {
        let item = object.animationQueue[i2];
        if (!item) continue;
        let options = item.parameters;
        if (!options.expiration) {
          object.animationQueue.splice(i2, 1);
          if (object.animationQueue[i2]) object.animationQueue[i2].parameters.start = now2;
          return;
        }
        let expiring = now2 >= options.expiration;
        if (expiring) {
          options.expiration = false;
          if (options.endState) object._setObject(options.endState);
          if (typeof options.cb != "undefined") options.cb();
        } else {
          let timeProgress = (now2 - options.start) / options.duration;
          if (item.type === "set") {
            let objectState = {};
            if (options.pathCurve) objectState.worldUnits = options.pathCurve.getPoint(timeProgress);
            if (options.rotationPerMs) {
              objectState.rotation = options.startRotation.map(function(rad2, index2) {
                return rad2 + options.rotationPerMs[index2] * timeProgress * options.duration;
              });
            }
            if (options.scalePerMs) {
              objectState.scale = options.startScale.map(function(scale, index2) {
                return scale + options.scalePerMs[index2] * timeProgress * options.duration;
              });
            }
            object._setObject(objectState);
          }
          if (item.type === "followPath") {
            let position2 = options.pathCurve.getPointAt(timeProgress);
            let objectState = { worldUnits: position2 };
            if (options.trackHeading) {
              let tangent = options.pathCurve.getTangentAt(timeProgress).normalize();
              let axis = new Vector3$1(0, 0, 0);
              let up = new Vector3$1(0, 1, 0);
              axis.crossVectors(up, tangent).normalize();
              let radians = Math.acos(up.dot(tangent));
              objectState.quaternion = [axis, radians];
            }
            object._setObject(objectState);
          }
        }
      }
    }
    this.previousFrameTime = now2;
  }
}
class RGBELoader extends DataTextureLoader {
  constructor(manager) {
    super(manager);
    this.type = HalfFloatType$1;
  }
  // adapted from http://www.graphics.cornell.edu/~bjw/rgbe.html
  parse(buffer) {
    const rgbe_read_error = 1, rgbe_write_error = 2, rgbe_format_error = 3, rgbe_memory_error = 4, rgbe_error = function(rgbe_error_code, msg) {
      switch (rgbe_error_code) {
        case rgbe_read_error:
          throw new Error("THREE.RGBELoader: Read Error: " + (msg || ""));
        case rgbe_write_error:
          throw new Error("THREE.RGBELoader: Write Error: " + (msg || ""));
        case rgbe_format_error:
          throw new Error("THREE.RGBELoader: Bad File Format: " + (msg || ""));
        default:
        case rgbe_memory_error:
          throw new Error("THREE.RGBELoader: Memory Error: " + (msg || ""));
      }
    }, RGBE_VALID_PROGRAMTYPE = 1, RGBE_VALID_FORMAT = 2, RGBE_VALID_DIMENSIONS = 4, NEWLINE = "\n", fgets = function(buffer2, lineLimit, consume) {
      const chunkSize = 128;
      lineLimit = !lineLimit ? 1024 : lineLimit;
      let p2 = buffer2.pos, i2 = -1, len = 0, s2 = "", chunk = String.fromCharCode.apply(null, new Uint16Array(buffer2.subarray(p2, p2 + chunkSize)));
      while (0 > (i2 = chunk.indexOf(NEWLINE)) && len < lineLimit && p2 < buffer2.byteLength) {
        s2 += chunk;
        len += chunk.length;
        p2 += chunkSize;
        chunk += String.fromCharCode.apply(null, new Uint16Array(buffer2.subarray(p2, p2 + chunkSize)));
      }
      if (-1 < i2) {
        buffer2.pos += len + i2 + 1;
        return s2 + chunk.slice(0, i2);
      }
      return false;
    }, RGBE_ReadHeader = function(buffer2) {
      const magic_token_re = /^#\?(\S+)/, gamma_re = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/, exposure_re = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/, format_re = /^\s*FORMAT=(\S+)\s*$/, dimensions_re = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/, header = {
        valid: 0,
        /* indicate which fields are valid */
        string: "",
        /* the actual header string */
        comments: "",
        /* comments found in header */
        programtype: "RGBE",
        /* listed at beginning of file to identify it after "#?". defaults to "RGBE" */
        format: "",
        /* RGBE format, default 32-bit_rle_rgbe */
        gamma: 1,
        /* image has already been gamma corrected with given gamma. defaults to 1.0 (no correction) */
        exposure: 1,
        /* a value of 1.0 in an image corresponds to <exposure> watts/steradian/m^2. defaults to 1.0 */
        width: 0,
        height: 0
        /* image dimensions, width/height */
      };
      let line, match;
      if (buffer2.pos >= buffer2.byteLength || !(line = fgets(buffer2))) {
        rgbe_error(rgbe_read_error, "no header found");
      }
      if (!(match = line.match(magic_token_re))) {
        rgbe_error(rgbe_format_error, "bad initial token");
      }
      header.valid |= RGBE_VALID_PROGRAMTYPE;
      header.programtype = match[1];
      header.string += line + "\n";
      while (true) {
        line = fgets(buffer2);
        if (false === line) break;
        header.string += line + "\n";
        if ("#" === line.charAt(0)) {
          header.comments += line + "\n";
          continue;
        }
        if (match = line.match(gamma_re)) {
          header.gamma = parseFloat(match[1]);
        }
        if (match = line.match(exposure_re)) {
          header.exposure = parseFloat(match[1]);
        }
        if (match = line.match(format_re)) {
          header.valid |= RGBE_VALID_FORMAT;
          header.format = match[1];
        }
        if (match = line.match(dimensions_re)) {
          header.valid |= RGBE_VALID_DIMENSIONS;
          header.height = parseInt(match[1], 10);
          header.width = parseInt(match[2], 10);
        }
        if (header.valid & RGBE_VALID_FORMAT && header.valid & RGBE_VALID_DIMENSIONS) break;
      }
      if (!(header.valid & RGBE_VALID_FORMAT)) {
        rgbe_error(rgbe_format_error, "missing format specifier");
      }
      if (!(header.valid & RGBE_VALID_DIMENSIONS)) {
        rgbe_error(rgbe_format_error, "missing image size specifier");
      }
      return header;
    }, RGBE_ReadPixels_RLE = function(buffer2, w2, h3) {
      const scanline_width = w2;
      if (
        // run length encoding is not allowed so read flat
        scanline_width < 8 || scanline_width > 32767 || // this file is not run length encoded
        (2 !== buffer2[0] || 2 !== buffer2[1] || buffer2[2] & 128)
      ) {
        return new Uint8Array(buffer2);
      }
      if (scanline_width !== (buffer2[2] << 8 | buffer2[3])) {
        rgbe_error(rgbe_format_error, "wrong scanline width");
      }
      const data_rgba = new Uint8Array(4 * w2 * h3);
      if (!data_rgba.length) {
        rgbe_error(rgbe_memory_error, "unable to allocate buffer space");
      }
      let offset = 0, pos = 0;
      const ptr_end = 4 * scanline_width;
      const rgbeStart = new Uint8Array(4);
      const scanline_buffer = new Uint8Array(ptr_end);
      let num_scanlines = h3;
      while (num_scanlines > 0 && pos < buffer2.byteLength) {
        if (pos + 4 > buffer2.byteLength) {
          rgbe_error(rgbe_read_error);
        }
        rgbeStart[0] = buffer2[pos++];
        rgbeStart[1] = buffer2[pos++];
        rgbeStart[2] = buffer2[pos++];
        rgbeStart[3] = buffer2[pos++];
        if (2 != rgbeStart[0] || 2 != rgbeStart[1] || (rgbeStart[2] << 8 | rgbeStart[3]) != scanline_width) {
          rgbe_error(rgbe_format_error, "bad rgbe scanline format");
        }
        let ptr = 0, count;
        while (ptr < ptr_end && pos < buffer2.byteLength) {
          count = buffer2[pos++];
          const isEncodedRun = count > 128;
          if (isEncodedRun) count -= 128;
          if (0 === count || ptr + count > ptr_end) {
            rgbe_error(rgbe_format_error, "bad scanline data");
          }
          if (isEncodedRun) {
            const byteValue = buffer2[pos++];
            for (let i2 = 0; i2 < count; i2++) {
              scanline_buffer[ptr++] = byteValue;
            }
          } else {
            scanline_buffer.set(buffer2.subarray(pos, pos + count), ptr);
            ptr += count;
            pos += count;
          }
        }
        const l2 = scanline_width;
        for (let i2 = 0; i2 < l2; i2++) {
          let off = 0;
          data_rgba[offset] = scanline_buffer[i2 + off];
          off += scanline_width;
          data_rgba[offset + 1] = scanline_buffer[i2 + off];
          off += scanline_width;
          data_rgba[offset + 2] = scanline_buffer[i2 + off];
          off += scanline_width;
          data_rgba[offset + 3] = scanline_buffer[i2 + off];
          offset += 4;
        }
        num_scanlines--;
      }
      return data_rgba;
    };
    const RGBEByteToRGBFloat = function(sourceArray, sourceOffset, destArray, destOffset) {
      const e2 = sourceArray[sourceOffset + 3];
      const scale = Math.pow(2, e2 - 128) / 255;
      destArray[destOffset + 0] = sourceArray[sourceOffset + 0] * scale;
      destArray[destOffset + 1] = sourceArray[sourceOffset + 1] * scale;
      destArray[destOffset + 2] = sourceArray[sourceOffset + 2] * scale;
      destArray[destOffset + 3] = 1;
    };
    const RGBEByteToRGBHalf = function(sourceArray, sourceOffset, destArray, destOffset) {
      const e2 = sourceArray[sourceOffset + 3];
      const scale = Math.pow(2, e2 - 128) / 255;
      destArray[destOffset + 0] = DataUtils.toHalfFloat(Math.min(sourceArray[sourceOffset + 0] * scale, 65504));
      destArray[destOffset + 1] = DataUtils.toHalfFloat(Math.min(sourceArray[sourceOffset + 1] * scale, 65504));
      destArray[destOffset + 2] = DataUtils.toHalfFloat(Math.min(sourceArray[sourceOffset + 2] * scale, 65504));
      destArray[destOffset + 3] = DataUtils.toHalfFloat(1);
    };
    const byteArray = new Uint8Array(buffer);
    byteArray.pos = 0;
    const rgbe_header_info = RGBE_ReadHeader(byteArray);
    const w = rgbe_header_info.width, h2 = rgbe_header_info.height, image_rgba_data = RGBE_ReadPixels_RLE(byteArray.subarray(byteArray.pos), w, h2);
    let data, type;
    let numElements;
    switch (this.type) {
      case FloatType$1:
        numElements = image_rgba_data.length / 4;
        const floatArray = new Float32Array(numElements * 4);
        for (let j = 0; j < numElements; j++) {
          RGBEByteToRGBFloat(image_rgba_data, j * 4, floatArray, j * 4);
        }
        data = floatArray;
        type = FloatType$1;
        break;
      case HalfFloatType$1:
        numElements = image_rgba_data.length / 4;
        const halfArray = new Uint16Array(numElements * 4);
        for (let j = 0; j < numElements; j++) {
          RGBEByteToRGBHalf(image_rgba_data, j * 4, halfArray, j * 4);
        }
        data = halfArray;
        type = HalfFloatType$1;
        break;
      default:
        throw new Error("THREE.RGBELoader: Unsupported type: " + this.type);
    }
    return {
      width: w,
      height: h2,
      data,
      header: rgbe_header_info.string,
      gamma: rgbe_header_info.gamma,
      exposure: rgbe_header_info.exposure,
      type
    };
  }
  setDataType(value) {
    this.type = value;
    return this;
  }
  load(url, onLoad, onProgress, onError) {
    function onLoadCallback(texture, texData) {
      switch (texture.type) {
        case FloatType$1:
        case HalfFloatType$1:
          texture.colorSpace = LinearSRGBColorSpace;
          texture.minFilter = LinearFilter$1;
          texture.magFilter = LinearFilter$1;
          texture.generateMipmaps = false;
          texture.flipY = true;
          break;
      }
      if (onLoad) onLoad(texture, texData);
    }
    return super.load(url, onLoadCallback, onProgress, onError);
  }
}
const CopyShader = {
  name: "CopyShader",
  uniforms: {
    "tDiffuse": { value: null },
    "opacity": { value: 1 }
  },
  vertexShader: (
    /* glsl */
    `

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`
  ),
  fragmentShader: (
    /* glsl */
    `

		uniform float opacity;

		uniform sampler2D tDiffuse;

		varying vec2 vUv;

		void main() {

			vec4 texel = texture2D( tDiffuse, vUv );
			gl_FragColor = opacity * texel;


		}`
  )
};
class Pass {
  constructor() {
    this.isPass = true;
    this.enabled = true;
    this.needsSwap = true;
    this.clear = false;
    this.renderToScreen = false;
  }
  setSize() {
  }
  render() {
    console.error("THREE.Pass: .render() must be implemented in derived pass.");
  }
  dispose() {
  }
}
const _camera = new OrthographicCamera$1(-1, 1, 1, -1, 0, 1);
class FullscreenTriangleGeometry extends BufferGeometry$1 {
  constructor() {
    super();
    this.setAttribute("position", new Float32BufferAttribute$1([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3));
    this.setAttribute("uv", new Float32BufferAttribute$1([0, 2, 0, 0, 2, 0], 2));
  }
}
const _geometry$1 = new FullscreenTriangleGeometry();
class FullScreenQuad {
  constructor(material) {
    this._mesh = new Mesh$1(_geometry$1, material);
  }
  dispose() {
    this._mesh.geometry.dispose();
  }
  render(renderer) {
    renderer.render(this._mesh, _camera);
  }
  get material() {
    return this._mesh.material;
  }
  set material(value) {
    this._mesh.material = value;
  }
}
class ShaderPass extends Pass {
  constructor(shader, textureID) {
    super();
    this.textureID = textureID !== void 0 ? textureID : "tDiffuse";
    if (shader instanceof ShaderMaterial$1) {
      this.uniforms = shader.uniforms;
      this.material = shader;
    } else if (shader) {
      this.uniforms = UniformsUtils$1.clone(shader.uniforms);
      this.material = new ShaderMaterial$1({
        name: shader.name !== void 0 ? shader.name : "unspecified",
        defines: Object.assign({}, shader.defines),
        uniforms: this.uniforms,
        vertexShader: shader.vertexShader,
        fragmentShader: shader.fragmentShader
      });
    }
    this.fsQuad = new FullScreenQuad(this.material);
  }
  render(renderer, writeBuffer, readBuffer) {
    if (this.uniforms[this.textureID]) {
      this.uniforms[this.textureID].value = readBuffer.texture;
    }
    this.fsQuad.material = this.material;
    if (this.renderToScreen) {
      renderer.setRenderTarget(null);
      this.fsQuad.render(renderer);
    } else {
      renderer.setRenderTarget(writeBuffer);
      if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
      this.fsQuad.render(renderer);
    }
  }
  dispose() {
    this.material.dispose();
    this.fsQuad.dispose();
  }
}
class MaskPass extends Pass {
  constructor(scene, camera) {
    super();
    this.scene = scene;
    this.camera = camera;
    this.clear = true;
    this.needsSwap = false;
    this.inverse = false;
  }
  render(renderer, writeBuffer, readBuffer) {
    const context = renderer.getContext();
    const state = renderer.state;
    state.buffers.color.setMask(false);
    state.buffers.depth.setMask(false);
    state.buffers.color.setLocked(true);
    state.buffers.depth.setLocked(true);
    let writeValue, clearValue;
    if (this.inverse) {
      writeValue = 0;
      clearValue = 1;
    } else {
      writeValue = 1;
      clearValue = 0;
    }
    state.buffers.stencil.setTest(true);
    state.buffers.stencil.setOp(context.REPLACE, context.REPLACE, context.REPLACE);
    state.buffers.stencil.setFunc(context.ALWAYS, writeValue, 4294967295);
    state.buffers.stencil.setClear(clearValue);
    state.buffers.stencil.setLocked(true);
    renderer.setRenderTarget(readBuffer);
    if (this.clear) renderer.clear();
    renderer.render(this.scene, this.camera);
    renderer.setRenderTarget(writeBuffer);
    if (this.clear) renderer.clear();
    renderer.render(this.scene, this.camera);
    state.buffers.color.setLocked(false);
    state.buffers.depth.setLocked(false);
    state.buffers.color.setMask(true);
    state.buffers.depth.setMask(true);
    state.buffers.stencil.setLocked(false);
    state.buffers.stencil.setFunc(context.EQUAL, 1, 4294967295);
    state.buffers.stencil.setOp(context.KEEP, context.KEEP, context.KEEP);
    state.buffers.stencil.setLocked(true);
  }
}
class ClearMaskPass extends Pass {
  constructor() {
    super();
    this.needsSwap = false;
  }
  render(renderer) {
    renderer.state.buffers.stencil.setLocked(false);
    renderer.state.buffers.stencil.setTest(false);
  }
}
class EffectComposer {
  constructor(renderer, renderTarget) {
    this.renderer = renderer;
    this._pixelRatio = renderer.getPixelRatio();
    if (renderTarget === void 0) {
      const size = renderer.getSize(new Vector2$1());
      this._width = size.width;
      this._height = size.height;
      renderTarget = new WebGLRenderTarget$1(this._width * this._pixelRatio, this._height * this._pixelRatio, { type: HalfFloatType$1 });
      renderTarget.texture.name = "EffectComposer.rt1";
    } else {
      this._width = renderTarget.width;
      this._height = renderTarget.height;
    }
    this.renderTarget1 = renderTarget;
    this.renderTarget2 = renderTarget.clone();
    this.renderTarget2.texture.name = "EffectComposer.rt2";
    this.writeBuffer = this.renderTarget1;
    this.readBuffer = this.renderTarget2;
    this.renderToScreen = true;
    this.passes = [];
    this.copyPass = new ShaderPass(CopyShader);
    this.copyPass.material.blending = NoBlending$1;
    this.clock = new Clock();
  }
  swapBuffers() {
    const tmp2 = this.readBuffer;
    this.readBuffer = this.writeBuffer;
    this.writeBuffer = tmp2;
  }
  addPass(pass) {
    this.passes.push(pass);
    pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
  }
  insertPass(pass, index2) {
    this.passes.splice(index2, 0, pass);
    pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
  }
  removePass(pass) {
    const index2 = this.passes.indexOf(pass);
    if (index2 !== -1) {
      this.passes.splice(index2, 1);
    }
  }
  isLastEnabledPass(passIndex) {
    for (let i2 = passIndex + 1; i2 < this.passes.length; i2++) {
      if (this.passes[i2].enabled) {
        return false;
      }
    }
    return true;
  }
  render(deltaTime) {
    if (deltaTime === void 0) {
      deltaTime = this.clock.getDelta();
    }
    const currentRenderTarget = this.renderer.getRenderTarget();
    let maskActive = false;
    for (let i2 = 0, il = this.passes.length; i2 < il; i2++) {
      const pass = this.passes[i2];
      if (pass.enabled === false) continue;
      pass.renderToScreen = this.renderToScreen && this.isLastEnabledPass(i2);
      pass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime, maskActive);
      if (pass.needsSwap) {
        if (maskActive) {
          const context = this.renderer.getContext();
          const stencil = this.renderer.state.buffers.stencil;
          stencil.setFunc(context.NOTEQUAL, 1, 4294967295);
          this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime);
          stencil.setFunc(context.EQUAL, 1, 4294967295);
        }
        this.swapBuffers();
      }
      if (MaskPass !== void 0) {
        if (pass instanceof MaskPass) {
          maskActive = true;
        } else if (pass instanceof ClearMaskPass) {
          maskActive = false;
        }
      }
    }
    this.renderer.setRenderTarget(currentRenderTarget);
  }
  reset(renderTarget) {
    if (renderTarget === void 0) {
      const size = this.renderer.getSize(new Vector2$1());
      this._pixelRatio = this.renderer.getPixelRatio();
      this._width = size.width;
      this._height = size.height;
      renderTarget = this.renderTarget1.clone();
      renderTarget.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
    this.renderTarget1.dispose();
    this.renderTarget2.dispose();
    this.renderTarget1 = renderTarget;
    this.renderTarget2 = renderTarget.clone();
    this.writeBuffer = this.renderTarget1;
    this.readBuffer = this.renderTarget2;
  }
  setSize(width, height) {
    this._width = width;
    this._height = height;
    const effectiveWidth = this._width * this._pixelRatio;
    const effectiveHeight = this._height * this._pixelRatio;
    this.renderTarget1.setSize(effectiveWidth, effectiveHeight);
    this.renderTarget2.setSize(effectiveWidth, effectiveHeight);
    for (let i2 = 0; i2 < this.passes.length; i2++) {
      this.passes[i2].setSize(effectiveWidth, effectiveHeight);
    }
  }
  setPixelRatio(pixelRatio) {
    this._pixelRatio = pixelRatio;
    this.setSize(this._width, this._height);
  }
  dispose() {
    this.renderTarget1.dispose();
    this.renderTarget2.dispose();
    this.copyPass.dispose();
  }
}
class RenderPass extends Pass {
  constructor(scene, camera, overrideMaterial = null, clearColor = null, clearAlpha = null) {
    super();
    this.scene = scene;
    this.camera = camera;
    this.overrideMaterial = overrideMaterial;
    this.clearColor = clearColor;
    this.clearAlpha = clearAlpha;
    this.clear = true;
    this.clearDepth = false;
    this.needsSwap = false;
    this._oldClearColor = new Color$1();
  }
  render(renderer, writeBuffer, readBuffer) {
    const oldAutoClear = renderer.autoClear;
    renderer.autoClear = false;
    let oldClearAlpha, oldOverrideMaterial;
    if (this.overrideMaterial !== null) {
      oldOverrideMaterial = this.scene.overrideMaterial;
      this.scene.overrideMaterial = this.overrideMaterial;
    }
    if (this.clearColor !== null) {
      renderer.getClearColor(this._oldClearColor);
      renderer.setClearColor(this.clearColor, renderer.getClearAlpha());
    }
    if (this.clearAlpha !== null) {
      oldClearAlpha = renderer.getClearAlpha();
      renderer.setClearAlpha(this.clearAlpha);
    }
    if (this.clearDepth == true) {
      renderer.clearDepth();
    }
    renderer.setRenderTarget(this.renderToScreen ? null : readBuffer);
    if (this.clear === true) {
      renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
    }
    renderer.render(this.scene, this.camera);
    if (this.clearColor !== null) {
      renderer.setClearColor(this._oldClearColor);
    }
    if (this.clearAlpha !== null) {
      renderer.setClearAlpha(oldClearAlpha);
    }
    if (this.overrideMaterial !== null) {
      this.scene.overrideMaterial = oldOverrideMaterial;
    }
    renderer.autoClear = oldAutoClear;
  }
}
const LuminosityHighPassShader = {
  uniforms: {
    "tDiffuse": { value: null },
    "luminosityThreshold": { value: 1 },
    "smoothWidth": { value: 1 },
    "defaultColor": { value: new Color$1(0) },
    "defaultOpacity": { value: 0 }
  },
  vertexShader: (
    /* glsl */
    `

		varying vec2 vUv;

		void main() {

			vUv = uv;

			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`
  ),
  fragmentShader: (
    /* glsl */
    `

		uniform sampler2D tDiffuse;
		uniform vec3 defaultColor;
		uniform float defaultOpacity;
		uniform float luminosityThreshold;
		uniform float smoothWidth;

		varying vec2 vUv;

		void main() {

			vec4 texel = texture2D( tDiffuse, vUv );

			float v = luminance( texel.xyz );

			vec4 outputColor = vec4( defaultColor.rgb, defaultOpacity );

			float alpha = smoothstep( luminosityThreshold, luminosityThreshold + smoothWidth, v );

			gl_FragColor = mix( outputColor, texel, alpha );

		}`
  )
};
class UnrealBloomPass extends Pass {
  constructor(resolution, strength, radius, threshold) {
    super();
    this.strength = strength !== void 0 ? strength : 1;
    this.radius = radius;
    this.threshold = threshold;
    this.resolution = resolution !== void 0 ? new Vector2$1(resolution.x, resolution.y) : new Vector2$1(256, 256);
    this.clearColor = new Color$1(0, 0, 0);
    this.renderTargetsHorizontal = [];
    this.renderTargetsVertical = [];
    this.nMips = 5;
    let resx = Math.round(this.resolution.x / 2);
    let resy = Math.round(this.resolution.y / 2);
    this.renderTargetBright = new WebGLRenderTarget$1(resx, resy, { type: HalfFloatType$1 });
    this.renderTargetBright.texture.name = "UnrealBloomPass.bright";
    this.renderTargetBright.texture.generateMipmaps = false;
    for (let i2 = 0; i2 < this.nMips; i2++) {
      const renderTargetHorizontal = new WebGLRenderTarget$1(resx, resy, { type: HalfFloatType$1 });
      renderTargetHorizontal.texture.name = "UnrealBloomPass.h" + i2;
      renderTargetHorizontal.texture.generateMipmaps = false;
      this.renderTargetsHorizontal.push(renderTargetHorizontal);
      const renderTargetVertical = new WebGLRenderTarget$1(resx, resy, { type: HalfFloatType$1 });
      renderTargetVertical.texture.name = "UnrealBloomPass.v" + i2;
      renderTargetVertical.texture.generateMipmaps = false;
      this.renderTargetsVertical.push(renderTargetVertical);
      resx = Math.round(resx / 2);
      resy = Math.round(resy / 2);
    }
    const highPassShader = LuminosityHighPassShader;
    this.highPassUniforms = UniformsUtils$1.clone(highPassShader.uniforms);
    this.highPassUniforms["luminosityThreshold"].value = threshold;
    this.highPassUniforms["smoothWidth"].value = 0.01;
    this.materialHighPassFilter = new ShaderMaterial$1({
      uniforms: this.highPassUniforms,
      vertexShader: highPassShader.vertexShader,
      fragmentShader: highPassShader.fragmentShader
    });
    this.separableBlurMaterials = [];
    const kernelSizeArray = [3, 5, 7, 9, 11];
    resx = Math.round(this.resolution.x / 2);
    resy = Math.round(this.resolution.y / 2);
    for (let i2 = 0; i2 < this.nMips; i2++) {
      this.separableBlurMaterials.push(this.getSeperableBlurMaterial(kernelSizeArray[i2]));
      this.separableBlurMaterials[i2].uniforms["invSize"].value = new Vector2$1(1 / resx, 1 / resy);
      resx = Math.round(resx / 2);
      resy = Math.round(resy / 2);
    }
    this.compositeMaterial = this.getCompositeMaterial(this.nMips);
    this.compositeMaterial.uniforms["blurTexture1"].value = this.renderTargetsVertical[0].texture;
    this.compositeMaterial.uniforms["blurTexture2"].value = this.renderTargetsVertical[1].texture;
    this.compositeMaterial.uniforms["blurTexture3"].value = this.renderTargetsVertical[2].texture;
    this.compositeMaterial.uniforms["blurTexture4"].value = this.renderTargetsVertical[3].texture;
    this.compositeMaterial.uniforms["blurTexture5"].value = this.renderTargetsVertical[4].texture;
    this.compositeMaterial.uniforms["bloomStrength"].value = strength;
    this.compositeMaterial.uniforms["bloomRadius"].value = 0.1;
    const bloomFactors = [1, 0.8, 0.6, 0.4, 0.2];
    this.compositeMaterial.uniforms["bloomFactors"].value = bloomFactors;
    this.bloomTintColors = [new Vector3$1(1, 1, 1), new Vector3$1(1, 1, 1), new Vector3$1(1, 1, 1), new Vector3$1(1, 1, 1), new Vector3$1(1, 1, 1)];
    this.compositeMaterial.uniforms["bloomTintColors"].value = this.bloomTintColors;
    const copyShader = CopyShader;
    this.copyUniforms = UniformsUtils$1.clone(copyShader.uniforms);
    this.blendMaterial = new ShaderMaterial$1({
      uniforms: this.copyUniforms,
      vertexShader: copyShader.vertexShader,
      fragmentShader: copyShader.fragmentShader,
      blending: AdditiveBlending$1,
      depthTest: false,
      depthWrite: false,
      transparent: true
    });
    this.enabled = true;
    this.needsSwap = false;
    this._oldClearColor = new Color$1();
    this.oldClearAlpha = 1;
    this.basic = new MeshBasicMaterial$1();
    this.fsQuad = new FullScreenQuad(null);
  }
  dispose() {
    for (let i2 = 0; i2 < this.renderTargetsHorizontal.length; i2++) {
      this.renderTargetsHorizontal[i2].dispose();
    }
    for (let i2 = 0; i2 < this.renderTargetsVertical.length; i2++) {
      this.renderTargetsVertical[i2].dispose();
    }
    this.renderTargetBright.dispose();
    for (let i2 = 0; i2 < this.separableBlurMaterials.length; i2++) {
      this.separableBlurMaterials[i2].dispose();
    }
    this.compositeMaterial.dispose();
    this.blendMaterial.dispose();
    this.basic.dispose();
    this.fsQuad.dispose();
  }
  setSize(width, height) {
    let resx = Math.round(width / 2);
    let resy = Math.round(height / 2);
    this.renderTargetBright.setSize(resx, resy);
    for (let i2 = 0; i2 < this.nMips; i2++) {
      this.renderTargetsHorizontal[i2].setSize(resx, resy);
      this.renderTargetsVertical[i2].setSize(resx, resy);
      this.separableBlurMaterials[i2].uniforms["invSize"].value = new Vector2$1(1 / resx, 1 / resy);
      resx = Math.round(resx / 2);
      resy = Math.round(resy / 2);
    }
  }
  render(renderer, writeBuffer, readBuffer, deltaTime, maskActive) {
    renderer.getClearColor(this._oldClearColor);
    this.oldClearAlpha = renderer.getClearAlpha();
    const oldAutoClear = renderer.autoClear;
    renderer.autoClear = false;
    renderer.setClearColor(this.clearColor, 0);
    if (maskActive) renderer.state.buffers.stencil.setTest(false);
    if (this.renderToScreen) {
      this.fsQuad.material = this.basic;
      this.basic.map = readBuffer.texture;
      renderer.setRenderTarget(null);
      renderer.clear();
      this.fsQuad.render(renderer);
    }
    this.highPassUniforms["tDiffuse"].value = readBuffer.texture;
    this.highPassUniforms["luminosityThreshold"].value = this.threshold;
    this.fsQuad.material = this.materialHighPassFilter;
    renderer.setRenderTarget(this.renderTargetBright);
    renderer.clear();
    this.fsQuad.render(renderer);
    let inputRenderTarget = this.renderTargetBright;
    for (let i2 = 0; i2 < this.nMips; i2++) {
      this.fsQuad.material = this.separableBlurMaterials[i2];
      this.separableBlurMaterials[i2].uniforms["colorTexture"].value = inputRenderTarget.texture;
      this.separableBlurMaterials[i2].uniforms["direction"].value = UnrealBloomPass.BlurDirectionX;
      renderer.setRenderTarget(this.renderTargetsHorizontal[i2]);
      renderer.clear();
      this.fsQuad.render(renderer);
      this.separableBlurMaterials[i2].uniforms["colorTexture"].value = this.renderTargetsHorizontal[i2].texture;
      this.separableBlurMaterials[i2].uniforms["direction"].value = UnrealBloomPass.BlurDirectionY;
      renderer.setRenderTarget(this.renderTargetsVertical[i2]);
      renderer.clear();
      this.fsQuad.render(renderer);
      inputRenderTarget = this.renderTargetsVertical[i2];
    }
    this.fsQuad.material = this.compositeMaterial;
    this.compositeMaterial.uniforms["bloomStrength"].value = this.strength;
    this.compositeMaterial.uniforms["bloomRadius"].value = this.radius;
    this.compositeMaterial.uniforms["bloomTintColors"].value = this.bloomTintColors;
    renderer.setRenderTarget(this.renderTargetsHorizontal[0]);
    renderer.clear();
    this.fsQuad.render(renderer);
    this.fsQuad.material = this.blendMaterial;
    this.copyUniforms["tDiffuse"].value = this.renderTargetsHorizontal[0].texture;
    if (maskActive) renderer.state.buffers.stencil.setTest(true);
    if (this.renderToScreen) {
      renderer.setRenderTarget(null);
      this.fsQuad.render(renderer);
    } else {
      renderer.setRenderTarget(readBuffer);
      this.fsQuad.render(renderer);
    }
    renderer.setClearColor(this._oldClearColor, this.oldClearAlpha);
    renderer.autoClear = oldAutoClear;
  }
  getSeperableBlurMaterial(kernelRadius) {
    const coefficients = [];
    for (let i2 = 0; i2 < kernelRadius; i2++) {
      coefficients.push(0.39894 * Math.exp(-0.5 * i2 * i2 / (kernelRadius * kernelRadius)) / kernelRadius);
    }
    return new ShaderMaterial$1({
      defines: {
        "KERNEL_RADIUS": kernelRadius
      },
      uniforms: {
        "colorTexture": { value: null },
        "invSize": { value: new Vector2$1(0.5, 0.5) },
        // inverse texture size
        "direction": { value: new Vector2$1(0.5, 0.5) },
        "gaussianCoefficients": { value: coefficients }
        // precomputed Gaussian coefficients
      },
      vertexShader: `varying vec2 vUv;
				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}`,
      fragmentShader: `#include <common>
				varying vec2 vUv;
				uniform sampler2D colorTexture;
				uniform vec2 invSize;
				uniform vec2 direction;
				uniform float gaussianCoefficients[KERNEL_RADIUS];

				void main() {
					float weightSum = gaussianCoefficients[0];
					vec3 diffuseSum = texture2D( colorTexture, vUv ).rgb * weightSum;
					for( int i = 1; i < KERNEL_RADIUS; i ++ ) {
						float x = float(i);
						float w = gaussianCoefficients[i];
						vec2 uvOffset = direction * invSize * x;
						vec3 sample1 = texture2D( colorTexture, vUv + uvOffset ).rgb;
						vec3 sample2 = texture2D( colorTexture, vUv - uvOffset ).rgb;
						diffuseSum += (sample1 + sample2) * w;
						weightSum += 2.0 * w;
					}
					gl_FragColor = vec4(diffuseSum/weightSum, 1.0);
				}`
    });
  }
  getCompositeMaterial(nMips) {
    return new ShaderMaterial$1({
      defines: {
        "NUM_MIPS": nMips
      },
      uniforms: {
        "blurTexture1": { value: null },
        "blurTexture2": { value: null },
        "blurTexture3": { value: null },
        "blurTexture4": { value: null },
        "blurTexture5": { value: null },
        "bloomStrength": { value: 1 },
        "bloomFactors": { value: null },
        "bloomTintColors": { value: null },
        "bloomRadius": { value: 0 }
      },
      vertexShader: `varying vec2 vUv;
				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}`,
      fragmentShader: `varying vec2 vUv;
				uniform sampler2D blurTexture1;
				uniform sampler2D blurTexture2;
				uniform sampler2D blurTexture3;
				uniform sampler2D blurTexture4;
				uniform sampler2D blurTexture5;
				uniform float bloomStrength;
				uniform float bloomRadius;
				uniform float bloomFactors[NUM_MIPS];
				uniform vec3 bloomTintColors[NUM_MIPS];

				float lerpBloomFactor(const in float factor) {
					float mirrorFactor = 1.2 - factor;
					return mix(factor, mirrorFactor, bloomRadius);
				}

				void main() {
					gl_FragColor = bloomStrength * ( lerpBloomFactor(bloomFactors[0]) * vec4(bloomTintColors[0], 1.0) * texture2D(blurTexture1, vUv) +
						lerpBloomFactor(bloomFactors[1]) * vec4(bloomTintColors[1], 1.0) * texture2D(blurTexture2, vUv) +
						lerpBloomFactor(bloomFactors[2]) * vec4(bloomTintColors[2], 1.0) * texture2D(blurTexture3, vUv) +
						lerpBloomFactor(bloomFactors[3]) * vec4(bloomTintColors[3], 1.0) * texture2D(blurTexture4, vUv) +
						lerpBloomFactor(bloomFactors[4]) * vec4(bloomTintColors[4], 1.0) * texture2D(blurTexture5, vUv) );
				}`
    });
  }
}
UnrealBloomPass.BlurDirectionX = new Vector2$1(1, 0);
UnrealBloomPass.BlurDirectionY = new Vector2$1(0, 1);
class OutlinePass extends Pass {
  constructor(resolution, scene, camera, selectedObjects) {
    super();
    this.renderScene = scene;
    this.renderCamera = camera;
    this.selectedObjects = selectedObjects !== void 0 ? selectedObjects : [];
    this.visibleEdgeColor = new Color$1(1, 1, 1);
    this.hiddenEdgeColor = new Color$1(0.1, 0.04, 0.02);
    this.edgeGlow = 0;
    this.usePatternTexture = false;
    this.edgeThickness = 1;
    this.edgeStrength = 3;
    this.downSampleRatio = 2;
    this.pulsePeriod = 0;
    this._visibilityCache = /* @__PURE__ */ new Map();
    this._selectionCache = /* @__PURE__ */ new Set();
    this.resolution = resolution !== void 0 ? new Vector2$1(resolution.x, resolution.y) : new Vector2$1(256, 256);
    const resx = Math.round(this.resolution.x / this.downSampleRatio);
    const resy = Math.round(this.resolution.y / this.downSampleRatio);
    this.renderTargetMaskBuffer = new WebGLRenderTarget$1(this.resolution.x, this.resolution.y);
    this.renderTargetMaskBuffer.texture.name = "OutlinePass.mask";
    this.renderTargetMaskBuffer.texture.generateMipmaps = false;
    this.depthMaterial = new MeshDepthMaterial$1();
    this.depthMaterial.side = DoubleSide$1;
    this.depthMaterial.depthPacking = RGBADepthPacking$1;
    this.depthMaterial.blending = NoBlending$1;
    this.prepareMaskMaterial = this.getPrepareMaskMaterial();
    this.prepareMaskMaterial.side = DoubleSide$1;
    this.prepareMaskMaterial.fragmentShader = replaceDepthToViewZ(this.prepareMaskMaterial.fragmentShader, this.renderCamera);
    this.renderTargetDepthBuffer = new WebGLRenderTarget$1(this.resolution.x, this.resolution.y, { type: HalfFloatType$1 });
    this.renderTargetDepthBuffer.texture.name = "OutlinePass.depth";
    this.renderTargetDepthBuffer.texture.generateMipmaps = false;
    this.renderTargetMaskDownSampleBuffer = new WebGLRenderTarget$1(resx, resy, { type: HalfFloatType$1 });
    this.renderTargetMaskDownSampleBuffer.texture.name = "OutlinePass.depthDownSample";
    this.renderTargetMaskDownSampleBuffer.texture.generateMipmaps = false;
    this.renderTargetBlurBuffer1 = new WebGLRenderTarget$1(resx, resy, { type: HalfFloatType$1 });
    this.renderTargetBlurBuffer1.texture.name = "OutlinePass.blur1";
    this.renderTargetBlurBuffer1.texture.generateMipmaps = false;
    this.renderTargetBlurBuffer2 = new WebGLRenderTarget$1(Math.round(resx / 2), Math.round(resy / 2), { type: HalfFloatType$1 });
    this.renderTargetBlurBuffer2.texture.name = "OutlinePass.blur2";
    this.renderTargetBlurBuffer2.texture.generateMipmaps = false;
    this.edgeDetectionMaterial = this.getEdgeDetectionMaterial();
    this.renderTargetEdgeBuffer1 = new WebGLRenderTarget$1(resx, resy, { type: HalfFloatType$1 });
    this.renderTargetEdgeBuffer1.texture.name = "OutlinePass.edge1";
    this.renderTargetEdgeBuffer1.texture.generateMipmaps = false;
    this.renderTargetEdgeBuffer2 = new WebGLRenderTarget$1(Math.round(resx / 2), Math.round(resy / 2), { type: HalfFloatType$1 });
    this.renderTargetEdgeBuffer2.texture.name = "OutlinePass.edge2";
    this.renderTargetEdgeBuffer2.texture.generateMipmaps = false;
    const MAX_EDGE_THICKNESS = 4;
    const MAX_EDGE_GLOW = 4;
    this.separableBlurMaterial1 = this.getSeperableBlurMaterial(MAX_EDGE_THICKNESS);
    this.separableBlurMaterial1.uniforms["texSize"].value.set(resx, resy);
    this.separableBlurMaterial1.uniforms["kernelRadius"].value = 1;
    this.separableBlurMaterial2 = this.getSeperableBlurMaterial(MAX_EDGE_GLOW);
    this.separableBlurMaterial2.uniforms["texSize"].value.set(Math.round(resx / 2), Math.round(resy / 2));
    this.separableBlurMaterial2.uniforms["kernelRadius"].value = MAX_EDGE_GLOW;
    this.overlayMaterial = this.getOverlayMaterial();
    const copyShader = CopyShader;
    this.copyUniforms = UniformsUtils$1.clone(copyShader.uniforms);
    this.materialCopy = new ShaderMaterial$1({
      uniforms: this.copyUniforms,
      vertexShader: copyShader.vertexShader,
      fragmentShader: copyShader.fragmentShader,
      blending: NoBlending$1,
      depthTest: false,
      depthWrite: false
    });
    this.enabled = true;
    this.needsSwap = false;
    this._oldClearColor = new Color$1();
    this.oldClearAlpha = 1;
    this.fsQuad = new FullScreenQuad(null);
    this.tempPulseColor1 = new Color$1();
    this.tempPulseColor2 = new Color$1();
    this.textureMatrix = new Matrix4$1();
    function replaceDepthToViewZ(string, camera2) {
      const type = camera2.isPerspectiveCamera ? "perspective" : "orthographic";
      return string.replace(/DEPTH_TO_VIEW_Z/g, type + "DepthToViewZ");
    }
  }
  dispose() {
    this.renderTargetMaskBuffer.dispose();
    this.renderTargetDepthBuffer.dispose();
    this.renderTargetMaskDownSampleBuffer.dispose();
    this.renderTargetBlurBuffer1.dispose();
    this.renderTargetBlurBuffer2.dispose();
    this.renderTargetEdgeBuffer1.dispose();
    this.renderTargetEdgeBuffer2.dispose();
    this.depthMaterial.dispose();
    this.prepareMaskMaterial.dispose();
    this.edgeDetectionMaterial.dispose();
    this.separableBlurMaterial1.dispose();
    this.separableBlurMaterial2.dispose();
    this.overlayMaterial.dispose();
    this.materialCopy.dispose();
    this.fsQuad.dispose();
  }
  setSize(width, height) {
    this.renderTargetMaskBuffer.setSize(width, height);
    this.renderTargetDepthBuffer.setSize(width, height);
    let resx = Math.round(width / this.downSampleRatio);
    let resy = Math.round(height / this.downSampleRatio);
    this.renderTargetMaskDownSampleBuffer.setSize(resx, resy);
    this.renderTargetBlurBuffer1.setSize(resx, resy);
    this.renderTargetEdgeBuffer1.setSize(resx, resy);
    this.separableBlurMaterial1.uniforms["texSize"].value.set(resx, resy);
    resx = Math.round(resx / 2);
    resy = Math.round(resy / 2);
    this.renderTargetBlurBuffer2.setSize(resx, resy);
    this.renderTargetEdgeBuffer2.setSize(resx, resy);
    this.separableBlurMaterial2.uniforms["texSize"].value.set(resx, resy);
  }
  updateSelectionCache() {
    const cache = this._selectionCache;
    function gatherSelectedMeshesCallBack(object) {
      if (object.isMesh) cache.add(object);
    }
    cache.clear();
    for (let i2 = 0; i2 < this.selectedObjects.length; i2++) {
      const selectedObject = this.selectedObjects[i2];
      selectedObject.traverse(gatherSelectedMeshesCallBack);
    }
  }
  changeVisibilityOfSelectedObjects(bVisible) {
    const cache = this._visibilityCache;
    for (const mesh of this._selectionCache) {
      if (bVisible === true) {
        mesh.visible = cache.get(mesh);
      } else {
        cache.set(mesh, mesh.visible);
        mesh.visible = bVisible;
      }
    }
  }
  changeVisibilityOfNonSelectedObjects(bVisible) {
    const visibilityCache = this._visibilityCache;
    const selectionCache = this._selectionCache;
    function VisibilityChangeCallBack(object) {
      if (object.isMesh || object.isSprite) {
        if (!selectionCache.has(object)) {
          const visibility2 = object.visible;
          if (bVisible === false || visibilityCache.get(object) === true) {
            object.visible = bVisible;
          }
          visibilityCache.set(object, visibility2);
        }
      } else if (object.isPoints || object.isLine) {
        if (bVisible === true) {
          object.visible = visibilityCache.get(object);
        } else {
          visibilityCache.set(object, object.visible);
          object.visible = bVisible;
        }
      }
    }
    this.renderScene.traverse(VisibilityChangeCallBack);
  }
  updateTextureMatrix() {
    this.textureMatrix.set(
      0.5,
      0,
      0,
      0.5,
      0,
      0.5,
      0,
      0.5,
      0,
      0,
      0.5,
      0.5,
      0,
      0,
      0,
      1
    );
    this.textureMatrix.multiply(this.renderCamera.projectionMatrix);
    this.textureMatrix.multiply(this.renderCamera.matrixWorldInverse);
  }
  render(renderer, writeBuffer, readBuffer, deltaTime, maskActive) {
    if (this.selectedObjects.length > 0) {
      renderer.getClearColor(this._oldClearColor);
      this.oldClearAlpha = renderer.getClearAlpha();
      const oldAutoClear = renderer.autoClear;
      renderer.autoClear = false;
      if (maskActive) renderer.state.buffers.stencil.setTest(false);
      renderer.setClearColor(16777215, 1);
      this.updateSelectionCache();
      this.changeVisibilityOfSelectedObjects(false);
      const currentBackground = this.renderScene.background;
      this.renderScene.background = null;
      this.renderScene.overrideMaterial = this.depthMaterial;
      renderer.setRenderTarget(this.renderTargetDepthBuffer);
      renderer.clear();
      renderer.render(this.renderScene, this.renderCamera);
      this.changeVisibilityOfSelectedObjects(true);
      this._visibilityCache.clear();
      this.updateTextureMatrix();
      this.changeVisibilityOfNonSelectedObjects(false);
      this.renderScene.overrideMaterial = this.prepareMaskMaterial;
      this.prepareMaskMaterial.uniforms["cameraNearFar"].value.set(this.renderCamera.near, this.renderCamera.far);
      this.prepareMaskMaterial.uniforms["depthTexture"].value = this.renderTargetDepthBuffer.texture;
      this.prepareMaskMaterial.uniforms["textureMatrix"].value = this.textureMatrix;
      renderer.setRenderTarget(this.renderTargetMaskBuffer);
      renderer.clear();
      renderer.render(this.renderScene, this.renderCamera);
      this.renderScene.overrideMaterial = null;
      this.changeVisibilityOfNonSelectedObjects(true);
      this._visibilityCache.clear();
      this._selectionCache.clear();
      this.renderScene.background = currentBackground;
      this.fsQuad.material = this.materialCopy;
      this.copyUniforms["tDiffuse"].value = this.renderTargetMaskBuffer.texture;
      renderer.setRenderTarget(this.renderTargetMaskDownSampleBuffer);
      renderer.clear();
      this.fsQuad.render(renderer);
      this.tempPulseColor1.copy(this.visibleEdgeColor);
      this.tempPulseColor2.copy(this.hiddenEdgeColor);
      if (this.pulsePeriod > 0) {
        const scalar = (1 + 0.25) / 2 + Math.cos(performance.now() * 0.01 / this.pulsePeriod) * (1 - 0.25) / 2;
        this.tempPulseColor1.multiplyScalar(scalar);
        this.tempPulseColor2.multiplyScalar(scalar);
      }
      this.fsQuad.material = this.edgeDetectionMaterial;
      this.edgeDetectionMaterial.uniforms["maskTexture"].value = this.renderTargetMaskDownSampleBuffer.texture;
      this.edgeDetectionMaterial.uniforms["texSize"].value.set(this.renderTargetMaskDownSampleBuffer.width, this.renderTargetMaskDownSampleBuffer.height);
      this.edgeDetectionMaterial.uniforms["visibleEdgeColor"].value = this.tempPulseColor1;
      this.edgeDetectionMaterial.uniforms["hiddenEdgeColor"].value = this.tempPulseColor2;
      renderer.setRenderTarget(this.renderTargetEdgeBuffer1);
      renderer.clear();
      this.fsQuad.render(renderer);
      this.fsQuad.material = this.separableBlurMaterial1;
      this.separableBlurMaterial1.uniforms["colorTexture"].value = this.renderTargetEdgeBuffer1.texture;
      this.separableBlurMaterial1.uniforms["direction"].value = OutlinePass.BlurDirectionX;
      this.separableBlurMaterial1.uniforms["kernelRadius"].value = this.edgeThickness;
      renderer.setRenderTarget(this.renderTargetBlurBuffer1);
      renderer.clear();
      this.fsQuad.render(renderer);
      this.separableBlurMaterial1.uniforms["colorTexture"].value = this.renderTargetBlurBuffer1.texture;
      this.separableBlurMaterial1.uniforms["direction"].value = OutlinePass.BlurDirectionY;
      renderer.setRenderTarget(this.renderTargetEdgeBuffer1);
      renderer.clear();
      this.fsQuad.render(renderer);
      this.fsQuad.material = this.separableBlurMaterial2;
      this.separableBlurMaterial2.uniforms["colorTexture"].value = this.renderTargetEdgeBuffer1.texture;
      this.separableBlurMaterial2.uniforms["direction"].value = OutlinePass.BlurDirectionX;
      renderer.setRenderTarget(this.renderTargetBlurBuffer2);
      renderer.clear();
      this.fsQuad.render(renderer);
      this.separableBlurMaterial2.uniforms["colorTexture"].value = this.renderTargetBlurBuffer2.texture;
      this.separableBlurMaterial2.uniforms["direction"].value = OutlinePass.BlurDirectionY;
      renderer.setRenderTarget(this.renderTargetEdgeBuffer2);
      renderer.clear();
      this.fsQuad.render(renderer);
      this.fsQuad.material = this.overlayMaterial;
      this.overlayMaterial.uniforms["maskTexture"].value = this.renderTargetMaskBuffer.texture;
      this.overlayMaterial.uniforms["edgeTexture1"].value = this.renderTargetEdgeBuffer1.texture;
      this.overlayMaterial.uniforms["edgeTexture2"].value = this.renderTargetEdgeBuffer2.texture;
      this.overlayMaterial.uniforms["patternTexture"].value = this.patternTexture;
      this.overlayMaterial.uniforms["edgeStrength"].value = this.edgeStrength;
      this.overlayMaterial.uniforms["edgeGlow"].value = this.edgeGlow;
      this.overlayMaterial.uniforms["usePatternTexture"].value = this.usePatternTexture;
      if (maskActive) renderer.state.buffers.stencil.setTest(true);
      renderer.setRenderTarget(readBuffer);
      this.fsQuad.render(renderer);
      renderer.setClearColor(this._oldClearColor, this.oldClearAlpha);
      renderer.autoClear = oldAutoClear;
    }
    if (this.renderToScreen) {
      this.fsQuad.material = this.materialCopy;
      this.copyUniforms["tDiffuse"].value = readBuffer.texture;
      renderer.setRenderTarget(null);
      this.fsQuad.render(renderer);
    }
  }
  getPrepareMaskMaterial() {
    return new ShaderMaterial$1({
      uniforms: {
        "depthTexture": { value: null },
        "cameraNearFar": { value: new Vector2$1(0.5, 0.5) },
        "textureMatrix": { value: null }
      },
      vertexShader: `#include <morphtarget_pars_vertex>
				#include <skinning_pars_vertex>

				varying vec4 projTexCoord;
				varying vec4 vPosition;
				uniform mat4 textureMatrix;

				void main() {

					#include <skinbase_vertex>
					#include <begin_vertex>
					#include <morphtarget_vertex>
					#include <skinning_vertex>
					#include <project_vertex>

					vPosition = mvPosition;

					vec4 worldPosition = vec4( transformed, 1.0 );

					#ifdef USE_INSTANCING

						worldPosition = instanceMatrix * worldPosition;

					#endif

					worldPosition = modelMatrix * worldPosition;

					projTexCoord = textureMatrix * worldPosition;

				}`,
      fragmentShader: `#include <packing>
				varying vec4 vPosition;
				varying vec4 projTexCoord;
				uniform sampler2D depthTexture;
				uniform vec2 cameraNearFar;

				void main() {

					float depth = unpackRGBAToDepth(texture2DProj( depthTexture, projTexCoord ));
					float viewZ = - DEPTH_TO_VIEW_Z( depth, cameraNearFar.x, cameraNearFar.y );
					float depthTest = (-vPosition.z > viewZ) ? 1.0 : 0.0;
					gl_FragColor = vec4(0.0, depthTest, 1.0, 1.0);

				}`
    });
  }
  getEdgeDetectionMaterial() {
    return new ShaderMaterial$1({
      uniforms: {
        "maskTexture": { value: null },
        "texSize": { value: new Vector2$1(0.5, 0.5) },
        "visibleEdgeColor": { value: new Vector3$1(1, 1, 1) },
        "hiddenEdgeColor": { value: new Vector3$1(1, 1, 1) }
      },
      vertexShader: `varying vec2 vUv;

				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}`,
      fragmentShader: `varying vec2 vUv;

				uniform sampler2D maskTexture;
				uniform vec2 texSize;
				uniform vec3 visibleEdgeColor;
				uniform vec3 hiddenEdgeColor;

				void main() {
					vec2 invSize = 1.0 / texSize;
					vec4 uvOffset = vec4(1.0, 0.0, 0.0, 1.0) * vec4(invSize, invSize);
					vec4 c1 = texture2D( maskTexture, vUv + uvOffset.xy);
					vec4 c2 = texture2D( maskTexture, vUv - uvOffset.xy);
					vec4 c3 = texture2D( maskTexture, vUv + uvOffset.yw);
					vec4 c4 = texture2D( maskTexture, vUv - uvOffset.yw);
					float diff1 = (c1.r - c2.r)*0.5;
					float diff2 = (c3.r - c4.r)*0.5;
					float d = length( vec2(diff1, diff2) );
					float a1 = min(c1.g, c2.g);
					float a2 = min(c3.g, c4.g);
					float visibilityFactor = min(a1, a2);
					vec3 edgeColor = 1.0 - visibilityFactor > 0.001 ? visibleEdgeColor : hiddenEdgeColor;
					gl_FragColor = vec4(edgeColor, 1.0) * vec4(d);
				}`
    });
  }
  getSeperableBlurMaterial(maxRadius) {
    return new ShaderMaterial$1({
      defines: {
        "MAX_RADIUS": maxRadius
      },
      uniforms: {
        "colorTexture": { value: null },
        "texSize": { value: new Vector2$1(0.5, 0.5) },
        "direction": { value: new Vector2$1(0.5, 0.5) },
        "kernelRadius": { value: 1 }
      },
      vertexShader: `varying vec2 vUv;

				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}`,
      fragmentShader: `#include <common>
				varying vec2 vUv;
				uniform sampler2D colorTexture;
				uniform vec2 texSize;
				uniform vec2 direction;
				uniform float kernelRadius;

				float gaussianPdf(in float x, in float sigma) {
					return 0.39894 * exp( -0.5 * x * x/( sigma * sigma))/sigma;
				}

				void main() {
					vec2 invSize = 1.0 / texSize;
					float sigma = kernelRadius/2.0;
					float weightSum = gaussianPdf(0.0, sigma);
					vec4 diffuseSum = texture2D( colorTexture, vUv) * weightSum;
					vec2 delta = direction * invSize * kernelRadius/float(MAX_RADIUS);
					vec2 uvOffset = delta;
					for( int i = 1; i <= MAX_RADIUS; i ++ ) {
						float x = kernelRadius * float(i) / float(MAX_RADIUS);
						float w = gaussianPdf(x, sigma);
						vec4 sample1 = texture2D( colorTexture, vUv + uvOffset);
						vec4 sample2 = texture2D( colorTexture, vUv - uvOffset);
						diffuseSum += ((sample1 + sample2) * w);
						weightSum += (2.0 * w);
						uvOffset += delta;
					}
					gl_FragColor = diffuseSum/weightSum;
				}`
    });
  }
  getOverlayMaterial() {
    return new ShaderMaterial$1({
      uniforms: {
        "maskTexture": { value: null },
        "edgeTexture1": { value: null },
        "edgeTexture2": { value: null },
        "patternTexture": { value: null },
        "edgeStrength": { value: 1 },
        "edgeGlow": { value: 1 },
        "usePatternTexture": { value: 0 }
      },
      vertexShader: `varying vec2 vUv;

				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}`,
      fragmentShader: `varying vec2 vUv;

				uniform sampler2D maskTexture;
				uniform sampler2D edgeTexture1;
				uniform sampler2D edgeTexture2;
				uniform sampler2D patternTexture;
				uniform float edgeStrength;
				uniform float edgeGlow;
				uniform bool usePatternTexture;

				void main() {
					vec4 edgeValue1 = texture2D(edgeTexture1, vUv);
					vec4 edgeValue2 = texture2D(edgeTexture2, vUv);
					vec4 maskColor = texture2D(maskTexture, vUv);
					vec4 patternColor = texture2D(patternTexture, 6.0 * vUv);
					float visibilityFactor = 1.0 - maskColor.g > 0.0 ? 1.0 : 0.5;
					vec4 edgeValue = edgeValue1 + edgeValue2 * edgeGlow;
					vec4 finalColor = edgeStrength * maskColor.r * edgeValue;
					if(usePatternTexture)
						finalColor += + visibilityFactor * (1.0 - maskColor.r) * (1.0 - patternColor.r);
					gl_FragColor = finalColor;
				}`,
      blending: AdditiveBlending$1,
      depthTest: false,
      depthWrite: false,
      transparent: true
    });
  }
}
OutlinePass.BlurDirectionX = new Vector2$1(1, 0);
OutlinePass.BlurDirectionY = new Vector2$1(0, 1);
const cube_sky_nx = "data:image/jpeg;base64,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";
const cube_sky_px = "data:image/jpeg;base64,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";
const cube_sky_pz = "data:image/jpeg;base64,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";
const cube_sky_nz = "data:image/jpeg;base64,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";
const cube_sky_py = "data:image/jpeg;base64,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";
const cube_sky_ny = "data:image/jpeg;base64,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";
const cube_night_nx = "data:image/jpeg;base64,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";
const cube_night_px = "data:image/jpeg;base64,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";
const cube_night_pz = "data:image/jpeg;base64,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";
const cube_night_nz = "data:image/jpeg;base64,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";
const cube_night_py = "data:image/jpeg;base64,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";
const cube_night_ny = "data:image/jpeg;base64,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";
const threeVersion$f = parseInt(REVISION$1, 10);
const defaultOptions = {
  passiveRendering: false,
  preserveDrawingBuffer: true,
  enableSelectingFeatures: false,
  enableSelectingObjects: false,
  enableDraggingObjects: false,
  enableRotatingObjects: false,
  enableTooltips: false,
  enableHelpTooltips: false,
  orthographic: false,
  fov: ThreeboxConstants.FOV_DEGREES,
  terrain: false
};
const shaderChunk = {
  depth_offset_pars_vertex: "#ifdef ENABLE_DEPTH_SET\n    varying vec4 mapboxPosition;\n#endif",
  depth_offset_vertex: "#ifdef ENABLE_DEPTH_SET\n   mapboxPosition = vec4(position,1.0);\n   #ifdef USE_INSTANCING\n      mapboxPosition = instanceMatrix * mapboxPosition;\n   #endif\n   mapboxPosition = modelMatrix * mapboxPosition;\n   \n#endif",
  depth_offset_pars_fragment: "#ifdef ENABLE_DEPTH_SET\n    #if __VERSION__ >= 300\n    \n        #define gl_FragDepthEXT gl_FragDepth\n    #endif\n    uniform highp float depthOffset;\n    uniform bool isUnderground;\n    varying vec4 mapboxPosition;\n    \n#endif",
  depth_offset_fragment: "#ifdef ENABLE_DEPTH_SET\n    gl_FragDepthEXT = gl_FragCoord.z;\n    if(isUnderground){\n        if(mapboxPosition.z > -0.0001) {\n            if(depthOffset>0.0){\n                gl_FragDepthEXT = gl_FragCoord.z + depthOffset;\n             }\n         }\n    }\n    else{\n        if(mapboxPosition.z < -0.0001) {\n            if(depthOffset>0.0){\n                gl_FragDepthEXT = gl_FragCoord.z + depthOffset;\n            }\n        }\n    }\n    \n#endif"
};
class ThreeBox {
  constructor(map, options) {
    __publicField(this, "initLights", {
      ambientLight: null,
      dirLight: null,
      dirLightBack: null,
      dirLightHelper: null,
      hemiLight: null,
      pointLight: null
    });
    let _this = this;
    this.options = Object.assign({}, defaultOptions, options);
    this.map = map;
    this.map.tb = this;
    const height = this.map.getCanvas().clientHeight;
    const width = this.map.getCanvas().clientWidth;
    this.renderer = new WebGLRenderer$1({
      alpha: true,
      antialias: true,
      logarithmicDepthBuffer: true,
      preserveDrawingBuffer: this.options.preserveDrawingBuffer,
      canvas: map.getCanvas()
    });
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = PCFShadowMap$1;
    this.renderer.autoClear = false;
    this.renderer.setPixelRatio(mapboxgl.browser.devicePixelRatio);
    this.renderer.setSize(width, height);
    if (threeVersion$f > 151) {
      this.renderer.outputColorSpace = LinearSRGBColorSpace;
    } else {
      this.renderer.outputEncoding = void 0;
    }
    this.renderer.setClearAlpha(0);
    this.renderer.setClearColor(16777215, 0);
    this.renderer.localClippingEnabled = true;
    const env3D = this.options.env3D;
    const exposure = env3D && env3D.exposure;
    if ("number" == typeof exposure) {
      this.renderer.toneMapping = LinearToneMapping$1;
      this.renderer.toneMappingExposure = exposure;
    } else {
      this.renderer.toneMapping = NoToneMapping$1;
    }
    this.scene = new Scene$1();
    this.world = new Group$1();
    this.world.name = "world";
    this.scene.add(this.world);
    this.clock = new Clock();
    if (this.options.orthographic) {
      this.map.transform.fov = 0;
      this.camera = new OrthographicCamera$1(
        width / -2,
        width / 2,
        height / 2,
        height / -2,
        0.1,
        1e21
      );
    } else {
      this.map.transform.fov = this.options.fov;
      this.camera = new PerspectiveCamera$1(this.map.transform.fov, width / height, 0.1, 1e21);
    }
    this.camera.layers.disableAll();
    this.camera.layers.enable(0);
    this.camera.layers.enable(1);
    this.camera.layers.enable(3);
    this.cameraSync = new CameraSync(this.map, this.camera, this.world);
    this.prMeshBasicMaterial = new MeshBasicMaterial$1({ color: new Color$1("#000000") });
    this.prSpriteMaterial = new SpriteMaterial$1({ color: new Color$1("#000000") });
    this.testLayers = new Layers$1();
    this.testLayers.set(1);
    this.cacheMaterials = [];
    this.offScreenComposer = new EffectComposer(this.renderer);
    this.offScreenComposer.setPixelRatio(mapboxgl.browser.devicePixelRatio);
    this.offScreenComposer.setSize(width, height);
    this.offScreenComposer.renderToScreen = false;
    const renderPass = new RenderPass(this.scene, this.camera);
    this.offScreenComposer.addPass(renderPass);
    const unrealBloomPass = new UnrealBloomPass(new Vector2$1(width, height), 0, 1, 0.16);
    this.offScreenComposer.addPass(unrealBloomPass);
    for (let i2 = 0; i2 < 4; i2++) {
      let outlinePass = new OutlinePass(new Vector2$1(width, height), this.scene, this.camera);
      switch (i2) {
        case 0:
          outlinePass.edgeStrength = 5;
          outlinePass.edgeGlow = 2;
          outlinePass.edgeThickness = 2;
          outlinePass.pulsePeriod = 3;
          outlinePass.visibleEdgeColor = new Color$1("#e9a400");
          outlinePass.hiddenEdgeColor = new Color$1("#e9a400");
          break;
        case 1:
          outlinePass.edgeStrength = 3;
          outlinePass.edgeGlow = 1;
          outlinePass.edgeThickness = 1;
          outlinePass.pulsePeriod = 2;
          outlinePass.visibleEdgeColor = new Color$1("#00ff00");
          outlinePass.hiddenEdgeColor = new Color$1("#00ff00");
          break;
        case 2:
          outlinePass.edgeStrength = 6;
          outlinePass.edgeGlow = 1;
          outlinePass.edgeThickness = 8;
          outlinePass.pulsePeriod = 2;
          outlinePass.visibleEdgeColor = new Color$1("#ffffff");
          outlinePass.hiddenEdgeColor = new Color$1("#ffffff");
          break;
        case 3:
          outlinePass.edgeStrength = 3;
          outlinePass.edgeGlow = 1;
          outlinePass.edgeThickness = 1;
          outlinePass.pulsePeriod = 2;
          outlinePass.visibleEdgeColor = new Color$1("#ff0000");
          outlinePass.hiddenEdgeColor = new Color$1("#ff0000");
          break;
      }
      outlinePass.id = i2 + 1;
      this.offScreenComposer.addPass(outlinePass);
    }
    this.onScreenComposer = new EffectComposer(this.renderer);
    this.onScreenComposer.setPixelRatio(mapboxgl.browser.devicePixelRatio);
    this.onScreenComposer.setSize(width, height);
    this.onScreenComposer.addPass(renderPass);
    this.raycaster = new Raycaster();
    this.raycaster.layers.set(0);
    this.animationManager = new AnimationManager(this.map);
    for (let key in shaderChunk) {
      ShaderChunk$1[key] = shaderChunk[key];
    }
    this.setDefaultLight(env3D && env3D.defaultLights);
    this.setEnvMap(env3D && env3D.envMap);
    this.set3dBackground(env3D && env3D.defaultBackground);
    this.defaultFog = null;
    this.enableSelectingFeatures = this.options.enableSelectingFeatures || false;
    this.enableSelectingObjects = this.options.enableSelectingObjects || false;
    this.enableDraggingObjects = this.options.enableDraggingObjects || false;
    this.enableRotatingObjects = this.options.enableRotatingObjects || false;
    this.enableTooltips = this.options.enableTooltips || false;
    this.multiLayer = this.options.multiLayer || false;
    this.enableHelpTooltips = this.options.enableHelpTooltips || false;
    this.map.on("resize", function() {
      const width2 = _this.map.getCanvas().clientWidth;
      const height2 = _this.map.getCanvas().clientHeight;
      _this.renderer.setPixelRatio(mapboxgl.browser.devicePixelRatio);
      _this.offScreenComposer.setPixelRatio(mapboxgl.browser.devicePixelRatio);
      _this.onScreenComposer.setPixelRatio(mapboxgl.browser.devicePixelRatio);
      _this.renderer.setSize(width2, height2);
      _this.offScreenComposer.setSize(width2, height2);
      _this.onScreenComposer.setSize(width2, height2);
      if (_this.map.css2d_render_label) {
        _this.map.css2d_render_label.setSize(width2, height2);
        _this.map.needCss2DRefresh = true;
      }
      _this.repaint();
    });
  }
  Object3D(options) {
    options = utils._validate(options, {
      obj: null,
      units: "scene"
    });
    const { obj, group, ...other } = options;
    let currentGroup = group ?? new Group$1();
    currentGroup.userData = other || {};
    currentGroup.isGeoGroup = true;
    if (Array.isArray(obj)) {
      for (let t3 of obj) currentGroup.add(t3);
    } else {
      currentGroup.add(obj);
    }
    if (!currentGroup.coordinates) currentGroup.coordinates = [0, 0, 0];
    this.animationManager.enroll(currentGroup);
    currentGroup.setCoords = function(lnglat) {
      this.customeCoordinates = lnglat;
      this.updateMatrix();
      this.set({ position: lnglat });
      return this;
    };
    currentGroup.setRotation = function(xyz) {
      this.updateMatrix();
      this.set({ rotation: "number" == typeof xyz ? [xyz, xyz, xyz] : xyz });
      return this;
    };
    currentGroup.setScale = function(xyz) {
      this.updateMatrix();
      let scale = {
        x: ("number" == typeof xyz ? xyz : xyz.x) || 1,
        y: ("number" == typeof xyz ? xyz : xyz.y) || 1,
        z: ("number" == typeof xyz ? xyz : xyz.z) || 1
      };
      this.set({ scale: [scale.x, scale.y, scale.z] });
      return this;
    };
    currentGroup.setTranslate = function(xyz) {
      this.updateMatrix();
      this.translateX(("number" == typeof xyz ? xyz : xyz.x) || 0);
      this.translateY(("number" == typeof xyz ? xyz : xyz.y) || 0);
      this.translateZ(("number" == typeof xyz ? xyz : xyz.z) || 0);
      this.dispatchEvent({
        type: "ObjectChanged",
        detail: {
          object: this,
          action: { position: this.position }
        }
      });
      return this;
    };
    currentGroup.tranform = function(type, xyz) {
      if (type == "translate") {
        return this.setTranslate(xyz);
      } else if (type == "scale") {
        this.updateMatrix();
        let scale = {
          x: ("number" == typeof xyz ? xyz : xyz.x) || 1,
          y: ("number" == typeof xyz ? xyz : xyz.y) || 1,
          z: ("number" == typeof xyz ? xyz : xyz.z) || 1
        };
        this.scale.set(scale.x, scale.y, scale.z);
        this.dispatchEvent({
          type: "ObjectChanged",
          detail: {
            object: this,
            action: { scale }
          }
        });
      } else if (type == "rotate") {
        this.updateMatrix();
        let rotation = {
          x: ("number" == typeof xyz ? xyz : xyz.x) || 0,
          y: ("number" == typeof xyz ? xyz : xyz.y) || 0,
          z: ("number" == typeof xyz ? xyz : xyz.z) || 0
        };
        this.rotateX(utils.radify(rotation.x));
        this.rotateY(utils.radify(rotation.y));
        this.rotateZ(utils.radify(rotation.z));
        this.dispatchEvent({
          type: "ObjectChanged",
          detail: {
            object: this,
            action: { rotation }
          }
        });
      }
      return this;
    };
    currentGroup.addFrame = function(color2, thresholdAngle) {
      const obj2 = currentGroup.getObjectByName("EdgesLineFrame");
      if (obj2 && obj2 instanceof LineSegments$1) {
        console.log("This object has a EdgesLineFrame！");
        return;
      }
      this.updateMatrix();
      this.updateMatrixWorld(true);
      this.updateWorldMatrix(true, true);
      const worldMatrix = this.matrixWorld.clone();
      this.traverse((obj3) => {
        if (obj3 instanceof Mesh$1) {
          const childMatrix = obj3.matrixWorld.clone();
          const relativeMatrix = new Matrix4$1();
          relativeMatrix.copy(childMatrix).invert().multiply(worldMatrix);
          let lineSegments = new LineSegments$1(
            new EdgesGeometry(obj3.geometry, thresholdAngle || 1),
            new LineBasicMaterial$1({
              color: new Color$1(color2),
              linewidth: 1
            })
          );
          lineSegments.renderOrder = 1;
          lineSegments.name = "EdgesLineFrame";
          this.add(lineSegments);
          lineSegments.position.setFromMatrixPosition(relativeMatrix);
          lineSegments.rotation.setFromRotationMatrix(relativeMatrix);
          lineSegments.scale.setFromMatrixScale(relativeMatrix);
          lineSegments.updateMatrix();
          lineSegments.updateMatrixWorld(true);
        }
      });
    };
    currentGroup.removeFrame = function() {
      this.traverse((obj2) => {
        if (obj2 instanceof LineSegments$1 && "EdgesLineFrame" === obj2.name)
          obj2.parent.remove(obj2);
      });
    };
    currentGroup.showFrame = function() {
      this.traverse((obj2) => {
        if (obj2 instanceof LineSegments$1 && "EdgesLineFrame" === obj2.name) obj2.visible = true;
      });
    };
    currentGroup.hideFrame = function() {
      this.traverse((obj2) => {
        if (obj2 instanceof LineSegments$1 && "EdgesLineFrame" === obj2.name) obj2.visible = false;
      });
    };
    return currentGroup;
  }
  // 刷新mapbox
  repaint() {
    this.map.repaint = true;
  }
  // gps坐标转threejs世界坐标
  projectToWorld(coords) {
    return utils.projectToWorld(coords);
  }
  // threejs世界坐标转gps坐标
  unprojectFromWorld(worldUnits) {
    return utils.unprojectFromWorld(worldUnits);
  }
  mercatorZfromAltitude(altitude2, lat) {
    return utils.mercatorZfromAltitude(altitude2, lat);
  }
  projectedUnitsPerMeter(latitude) {
    return utils.projectedUnitsPerMeter(latitude);
  }
  projectedUnitsPerMercator() {
    return utils.projectedUnitsPerMercator();
  }
  queryRenderedFeatures(point2, obj, recursive) {
    let mouse = new Vector2$1();
    mouse.x = point2.x / this.map.transform.width * 2 - 1;
    mouse.y = 1 - point2.y / this.map.transform.height * 2;
    this.raycaster.setFromCamera(mouse, this.camera);
    let intersects2;
    if (obj) {
      if (Array.isArray(obj)) {
        intersects2 = this.raycaster.intersectObjects(obj, recursive);
      } else {
        intersects2 = this.raycaster.intersectObject(obj, recursive);
      }
    } else {
      intersects2 = this.raycaster.intersectObjects(this.world.children, recursive);
    }
    return intersects2;
  }
  // 刷新threejs渲染器
  update() {
    if (this.map.repaint) this.map.repaint = false;
    this.animationManager.update(Date.now());
    this.renderer.resetState();
    if (!this.map._isShowPage) {
      if (this.scene.fog !== this.defaultFog) this.scene.fog = this.defaultFog;
      this.renderer.render(this.scene, this.camera);
    } else {
      this.onScreenComposer.render();
    }
  }
  add(obj) {
    this.world.add(obj);
  }
  remove(obj) {
    this.clear(obj);
  }
  // 设置默认光线
  setDefaultLight(isOpen) {
    let open = true;
    if (false === isOpen) open = false;
    let group = this.scene.getObjectByName("default_lights");
    if (open) {
      if (!group) {
        const worldUnitPerMeter = this.projectedUnitsPerMeter(31.344352);
        const group2 = new Group$1();
        group2.name = "default_lights";
        const ambientLight = new AmbientLight$1(
          new Color$1().setStyle("#ffffff", LinearSRGBColorSpace),
          2 * Math.PI
        );
        ambientLight.name = "ambient_light";
        group2.add(ambientLight);
        let dirLight = new DirectionalLight$1(
          new Color$1().setStyle("#ffffff", LinearSRGBColorSpace),
          1.5 * Math.PI
        );
        dirLight.name = "dir_light";
        dirLight.castShadow = true;
        const vector = new Vector3$1(
          -200 * worldUnitPerMeter,
          -100 * worldUnitPerMeter,
          150 * worldUnitPerMeter
        );
        const quaternion = new Quaternion$1().setFromAxisAngle(
          new Vector3$1(0, 0, 1),
          MathUtils.degToRad(-28.5)
        );
        vector.applyQuaternion(quaternion);
        dirLight.position.set(vector.x, vector.y, vector.z);
        dirLight.target.position.set(0, 0, 0);
        dirLight.shadow.mapSize.width = 1024 * 8;
        dirLight.shadow.mapSize.height = 1024 * 8;
        dirLight.shadow.camera.near = -2048;
        dirLight.shadow.camera.far = 2048;
        dirLight.shadow.camera.left = -2048;
        dirLight.shadow.camera.right = 2048;
        dirLight.shadow.camera.top = 2048;
        dirLight.shadow.camera.bottom = -2048;
        dirLight.shadow.radius = 12;
        group2.add(dirLight);
        group2.updateMatrixWorld();
        this.scene.add(group2);
      }
    } else {
      if (group) this.removeObject(group);
    }
  }
  // 设置3d环境贴图
  setEnvMap(envMap) {
    if (envMap) {
      const _this = this;
      new RGBELoader().load(
        envMap,
        function(texture) {
          texture.wrapS = texture.wrapT = RepeatWrapping$1;
          const pmremGenerator = new PMREMGenerator$1(_this.renderer);
          pmremGenerator.compileEquirectangularShader();
          if (_this.scene.environment) _this.scene.environment.dispose();
          _this.scene.environment = pmremGenerator.fromEquirectangular(texture).texture;
          texture.dispose();
          pmremGenerator.dispose();
        },
        null,
        function(err2) {
          console.warn(err2);
        }
      );
    } else {
      if (this.scene.environment) {
        this.scene.environment.dispose();
        this.scene.environment = null;
      }
    }
  }
  // 设置默认背景
  set3dBackground(isOpen) {
    let open = true;
    if (false === isOpen) open = false;
    if (open) {
      this.sceneSkyTexture = new CubeTextureLoader$1().load([
        cube_sky_nx,
        cube_sky_px,
        cube_sky_pz,
        cube_sky_nz,
        cube_sky_py,
        cube_sky_ny
      ]);
      this.sceneSkyTexture.colorSpace = LinearSRGBColorSpace;
      this.sceneNightTexture = new CubeTextureLoader$1().load([
        cube_night_nx,
        cube_night_px,
        cube_night_pz,
        cube_night_nz,
        cube_night_py,
        cube_night_ny
      ]);
      this.sceneNightTexture.colorSpace = LinearSRGBColorSpace;
      if (this.map._isShowPage) this.scene.background = this.sceneSkyTexture;
    } else {
      if (this.scene.background) this.scene.background = null;
      if (this.sceneSkyTexture) this.sceneSkyTexture.dispose();
      if (this.sceneNightTexture) this.sceneNightTexture.dispose();
    }
  }
  // 释放材质
  disposeMaterial(mesh) {
    if (mesh.material) {
      if (Array.isArray(mesh.material)) {
        mesh.material.forEach((material) => {
          if (material.alphaMap) {
            material.alphaMap.dispose();
          }
          if (material.aoMap) {
            material.aoMap.dispose();
          }
          if (material.aoMap) {
            material.aoMap.dispose();
          }
          if (material.bumpMap) {
            material.bumpMap.dispose();
          }
          if (material.displacementMap) {
            material.displacementMap.dispose();
          }
          if (material.emissiveMap) {
            material.emissiveMap.dispose();
          }
          if (material.envMap) {
            material.envMap.dispose();
          }
          if (material.lightMap) {
            material.lightMap.dispose();
          }
          if (material.map) {
            material.map.dispose();
          }
          if (material.metalnessMap) {
            material.metalnessMap.dispose();
          }
          if (material.normalMap) {
            material.normalMap.dispose();
          }
          if (material.roughnessMap) {
            material.roughnessMap.dispose();
          }
          if (material.specularMap) {
            material.specularMap.dispose();
          }
          material.dispose();
        });
      } else {
        if (mesh.material.alphaMap) {
          mesh.material.alphaMap.dispose();
        }
        if (mesh.material.aoMap) {
          mesh.material.aoMap.dispose();
        }
        if (mesh.material.aoMap) {
          mesh.material.aoMap.dispose();
        }
        if (mesh.material.bumpMap) {
          mesh.material.bumpMap.dispose();
        }
        if (mesh.material.displacementMap) {
          mesh.material.displacementMap.dispose();
        }
        if (mesh.material.emissiveMap) {
          mesh.material.emissiveMap.dispose();
        }
        if (mesh.material.envMap) {
          mesh.material.envMap.dispose();
        }
        if (mesh.material.lightMap) {
          mesh.material.lightMap.dispose();
        }
        if (mesh.material.map) {
          mesh.material.map.dispose();
        }
        if (mesh.material.metalnessMap) {
          mesh.material.metalnessMap.dispose();
        }
        if (mesh.material.normalMap) {
          mesh.material.normalMap.dispose();
        }
        if (mesh.material.roughnessMap) {
          mesh.material.roughnessMap.dispose();
        }
        if (mesh.material.specularMap) {
          mesh.material.specularMap.dispose();
        }
        mesh.material.dispose();
      }
      mesh.material = null;
    }
  }
  // 删除物体并清除资源
  clear(obj) {
    if (!obj) return;
    if (Array.isArray(obj.children)) {
      while (obj.children.length > 0) {
        if (obj.children[0].isGeoGroup) {
          this.animationManager.unenroll(obj.children[0]);
        }
        this.clear(obj.children[0]);
      }
    }
    if (obj.userData && obj.userData.interval) {
      clearInterval(obj.userData.interval);
      delete obj.userData.interval;
    }
    if (obj.parent) {
      obj.parent.remove(obj);
      obj.parent = null;
    }
    if (obj.isMesh) {
      this.disposeMaterial(obj);
      if (obj.geometry) obj.geometry.dispose();
    }
  }
  // 获取物体外包围盒
  getModelBoundingBox(obj) {
    obj.updateWorldMatrix(true, true);
    let boundingBox2;
    obj.traverse((child) => {
      if (child.isMesh) {
        let geometry = child.geometry;
        geometry.computeBoundingBox();
        if (!boundingBox2) {
          boundingBox2 = this.applyWorldMatrix4(child, geometry.boundingBox.clone());
        } else {
          boundingBox2 = boundingBox2.union(
            this.applyWorldMatrix4(child, geometry.boundingBox.clone())
          );
        }
      }
    });
    const maxLngLat = this.unprojectFromWorld(boundingBox2.max.clone());
    const minLngLat = this.unprojectFromWorld(boundingBox2.min.clone());
    return {
      max: [
        Math.max(maxLngLat[0], minLngLat[0]),
        Math.max(maxLngLat[1], minLngLat[1]),
        Math.max(maxLngLat[2], minLngLat[2])
      ],
      min: [
        Math.min(maxLngLat[0], minLngLat[0]),
        Math.min(maxLngLat[1], minLngLat[1]),
        Math.min(maxLngLat[2], minLngLat[2])
      ]
    };
  }
  // 获取物体的世界坐标
  getWolrdUnitFromMesh(obj) {
    if (!obj.isMesh) return [];
    obj.updateWorldMatrix(true, true);
    const positions = obj.geometry.attributes.position.array;
    const worldPosition = new Vector3$1();
    const worldUnits = [];
    for (let i2 = 0; i2 < positions.length; i2 += 3) {
      worldPosition.set(positions[i2], positions[i2 + 1], positions[i2 + 2]);
      this.applyWorldMatrix4(obj, worldPosition);
      worldUnits.push(worldPosition.clone());
    }
    return worldUnits;
  }
  // 获取物体的gps坐标序列
  getLngLatFromMesh(obj) {
    if (!obj.isMesh) return [];
    obj.updateWorldMatrix(true, true);
    const positions = obj.geometry.attributes.position.array;
    const worldPosition = new Vector3$1();
    const lngLats = [];
    for (let i2 = 0; i2 < positions.length; i2 += 3) {
      worldPosition.set(positions[i2], positions[i2 + 1], positions[i2 + 2]);
      this.applyWorldMatrix4(obj, worldPosition);
      const lngLat = utils.unprojectFromWorld(worldPosition);
      lngLats.push(lngLat);
    }
    return lngLats;
  }
  // 局部坐标转换为世界坐标
  applyWorldMatrix4(obj, vb) {
    if (obj.coordinates || obj.userData && obj.userData.is3dtiles) {
      return vb.applyMatrix4(obj.matrix);
    } else {
      return this.applyWorldMatrix4(obj.parent, vb.applyMatrix4(obj.matrix));
    }
  }
  //[jscastro] get the sun position (azimuth, altitude) from a given datetime, lng, lat
  getSunPosition(date, coords) {
    return SunCalc.getPosition(date || Date.now(), coords[1], coords[0]);
  }
  //[jscastro] get the sun times for sunrise, sunset, etc.. from a given datetime, lng, lat and alt
  getSunTimes(date, coords) {
    return SunCalc.getTimes(date, coords[1], coords[0], coords[2] ? coords[2] : 0);
  }
  setSunlight(newDate = /* @__PURE__ */ new Date(), coords) {
    if (!this.lights.dirLight || !this.options.realSunlight) {
      console.warn(
        "To use setSunlight it's required to set realSunlight : true in Threebox initial options."
      );
      return;
    }
    var date = new Date(newDate.getTime());
    if (coords) {
      if (coords.lng && coords.lat) this.mapCenter = coords;
      else this.mapCenter = { lng: coords[0], lat: coords[1] };
    } else {
      this.mapCenter = this.map.getCenter();
    }
    if (this.lightDateTime && this.lightDateTime.getTime() === date.getTime() && this.lightLng === this.mapCenter.lng && this.lightLat === this.mapCenter.lat) {
      return;
    }
    this.lightDateTime = date;
    this.lightLng = this.mapCenter.lng;
    this.lightLat = this.mapCenter.lat;
    this.sunPosition = this.getSunPosition(date, [this.mapCenter.lng, this.mapCenter.lat]);
    let altitude2 = this.sunPosition.altitude;
    let azimuth2 = Math.PI + this.sunPosition.azimuth;
    let radius = ThreeboxConstants.WORLD_SIZE / 2;
    let alt = Math.sin(altitude2);
    let altRadius = Math.cos(altitude2);
    let azCos = Math.cos(azimuth2) * altRadius;
    let azSin = Math.sin(azimuth2) * altRadius;
    this.lights.dirLight.position.set(azSin, azCos, alt);
    this.lights.dirLight.position.multiplyScalar(radius);
    this.lights.dirLight.intensity = Math.max(alt, 0);
    this.lights.hemiLight.intensity = Math.max(alt * 1, 0.1);
    this.lights.dirLight.updateMatrixWorld();
    this.updateLightHelper();
    if (this.map.loaded()) {
      this.updateSunGround(this.sunPosition);
      this.map.setLight(
        {
          anchor: "map",
          position: [
            3,
            180 + this.sunPosition.azimuth * 180 / Math.PI,
            90 - this.sunPosition.altitude * 180 / Math.PI
          ],
          intensity: Math.cos(this.sunPosition.altitude),
          //0.4,
          color: `hsl(40, ${50 * Math.cos(this.sunPosition.altitude)}%, ${Math.max(20, 20 + 96 * Math.sin(this.sunPosition.altitude))}%)`
        },
        { duration: 0 }
      );
      if (this.sky) {
        this.updateSunSky(this.getSunSky(date, this.sunPosition));
      }
    }
  }
  getSunSky(date, sunPos) {
    if (!sunPos) {
      var center = this.map.getCenter();
      sunPos = this.getSunPosition(date || Date.now(), [center.lng, center.lat]);
    }
    var sunAzimuth = 180 + sunPos.azimuth * 180 / Math.PI;
    var sunAltitude = 90 - sunPos.altitude * 180 / Math.PI;
    return [sunAzimuth, sunAltitude];
  }
  updateSunSky(sunPos) {
    if (this.sky) {
      this.map.setPaintProperty(this.skyLayerName, "sky-atmosphere-sun", sunPos);
    }
  }
  updateSunGround(sunPos) {
    if (this.terrainLayerName != "") {
      this.map.setPaintProperty(
        this.terrainLayerName,
        "raster-opacity",
        Math.max(Math.min(1, sunPos.altitude * 4), 0.25)
      );
    }
  }
  realSunlight(helper = false) {
    this.renderer.shadowMap.enabled = true;
    this.lights.dirLight = new DirectionalLight$1(16777215, 1);
    this.scene.add(this.lights.dirLight);
    if (helper) {
      this.lights.dirLightHelper = new DirectionalLightHelper(this.lights.dirLight, 5);
      this.scene.add(this.lights.dirLightHelper);
    }
    let d2 = 1e3;
    let r2 = 2;
    let mapSize2 = 8192;
    this.lights.dirLight.castShadow = true;
    this.lights.dirLight.shadow.radius = r2;
    this.lights.dirLight.shadow.mapSize.width = mapSize2;
    this.lights.dirLight.shadow.mapSize.height = mapSize2;
    this.lights.dirLight.shadow.camera.top = this.lights.dirLight.shadow.camera.right = d2;
    this.lights.dirLight.shadow.camera.bottom = this.lights.dirLight.shadow.camera.left = -d2;
    this.lights.dirLight.shadow.camera.near = 1;
    this.lights.dirLight.shadow.camera.visible = true;
    this.lights.dirLight.shadow.camera.far = 4e8;
    this.lights.hemiLight = new HemisphereLight$1(
      new Color$1("#ffffff"),
      new Color$1("#ffffff"),
      0.6
    );
    this.lights.hemiLight.color.setHSL(0.661, 0.96, 0.12);
    this.lights.hemiLight.groundColor.setHSL(0.11, 0.96, 0.14);
    this.lights.hemiLight.position.set(0, 0, 50);
    this.scene.add(this.lights.hemiLight);
    this.setSunlight();
    this.map.once("idle", () => {
      this.setSunlight();
      this.repaint();
    });
  }
  dispose() {
    this.map = {};
    this.setEnvMap(null);
    this.set3dBackground(false);
    this.clear(this.scene);
    this.world = null;
    this.scene = null;
    this.renderer.dispose();
  }
}
class CSS2DObject extends Object3D$1 {
  constructor(element = document.createElement("div")) {
    super();
    this.isCSS2DObject = true;
    this.element = element;
    this.element.style.position = "absolute";
    this.element.style.userSelect = "none";
    this.element.setAttribute("draggable", false);
    this.center = new Vector2$1(0.5, 0.5);
    this.addEventListener("removed", function() {
      this.traverse(function(object) {
        if (object.element instanceof object.element.ownerDocument.defaultView.Element && object.element.parentNode !== null) {
          object.element.remove();
        }
      });
    });
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.element = source.element.cloneNode(true);
    this.center = source.center;
    return this;
  }
}
new Vector3$1();
new Matrix4$1();
new Matrix4$1();
new Vector3$1();
new Vector3$1();
const threeVersion$e = parseInt(REVISION$1, 10);
const _vector$1 = new Vector3$1();
const _viewMatrix = new Matrix4$1();
const _viewProjectionMatrix = new Matrix4$1();
const _a$1 = new Vector3$1();
const _b$1 = new Vector3$1();
class CSS2DRenderer {
  constructor(parameters = {}) {
    const _this = this;
    let _width, _height;
    let _widthHalf, _heightHalf;
    const cache = {
      objects: /* @__PURE__ */ new WeakMap()
    };
    const domElement = parameters.element !== void 0 ? parameters.element : document.createElement("div");
    domElement.style.overflow = "hidden";
    this.domElement = domElement;
    this.getSize = function() {
      return {
        width: _width,
        height: _height
      };
    };
    this.render = function(scene, camera) {
      if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
      if (camera.parent === null && camera.matrixWorldAutoUpdate === true)
        camera.updateMatrixWorld();
      _viewMatrix.copy(camera.matrixWorldInverse);
      _viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, _viewMatrix);
      renderObject(scene, scene, camera);
      zOrder2(scene);
    };
    this.setSize = function(width, height) {
      _width = width;
      _height = height;
      _widthHalf = _width / 2;
      _heightHalf = _height / 2;
      domElement.style.width = width + "px";
      domElement.style.height = height + "px";
    };
    function hideObject(object) {
      if (object.isCSS2DObject) object.element.style.display = "none";
      for (let i2 = 0, l2 = object.children.length; i2 < l2; i2++) {
        hideObject(object.children[i2]);
      }
    }
    function renderObject(object, scene, camera) {
      if (object.visible === false) {
        hideObject(object);
        return;
      }
      if (object.isCSS2DObject) {
        _vector$1.setFromMatrixPosition(object.matrixWorld);
        _vector$1.applyMatrix4(_viewProjectionMatrix);
        const visible = _vector$1.z >= -1 && _vector$1.z <= 1 && object.layers.test(camera.layers) === true;
        const element = object.element;
        element.style.display = visible === true ? "" : "none";
        object.userData.visible = !(_vector$1.x < -1 || _vector$1.x > 1 || _vector$1.y < -1 || _vector$1.y > 1 || _vector$1.z > 1);
        if (visible === true) {
          object.onBeforeRender(_this, scene, camera);
          if (threeVersion$e > 151) {
            element.style.transform = "translate(" + -100 * object.center.x + "%," + -100 * object.center.y + "%)translate(" + (_vector$1.x * _widthHalf + _widthHalf) + "px," + (-_vector$1.y * _heightHalf + _heightHalf) + "px)";
          } else {
            element.style.transform = "translate(-50%,-50%) translate(" + (_vector$1.x * _widthHalf + _widthHalf) + "px," + (-_vector$1.y * _heightHalf + _heightHalf) + "px)";
          }
          if (element.parentNode !== domElement) {
            domElement.appendChild(element);
          }
          object.onAfterRender(_this, scene, camera);
        }
        const objectData = {
          distanceToCameraSquared: getDistanceToSquared(camera, object)
        };
        cache.objects.set(object, objectData);
      }
      for (let i2 = 0, l2 = object.children.length; i2 < l2; i2++) {
        renderObject(object.children[i2], scene, camera);
      }
    }
    function getDistanceToSquared(object1, object2) {
      _a$1.setFromMatrixPosition(object1.matrixWorld);
      _b$1.setFromMatrixPosition(object2.matrixWorld);
      return _a$1.distanceToSquared(_b$1);
    }
    function filterAndFlatten(scene) {
      const result = [];
      scene.traverseVisible(function(object) {
        if (object.isCSS2DObject) result.push(object);
      });
      return result;
    }
    function zOrder2(scene) {
      const sorted = filterAndFlatten(scene).sort(function(a3, b) {
        if (a3.renderOrder !== b.renderOrder) {
          return b.renderOrder - a3.renderOrder;
        }
        const distanceA = cache.objects.get(a3).distanceToCameraSquared;
        const distanceB = cache.objects.get(b).distanceToCameraSquared;
        return distanceA - distanceB;
      });
      const zMax = sorted.length;
      const screenElements = [];
      for (let i2 = 0, l2 = sorted.length; i2 < l2; i2++) {
        sorted[i2].element.style.zIndex = zMax - i2;
        if (sorted[i2].userData.visible && sorted[i2].userData.avoidance)
          screenElements.push(sorted[i2].element);
      }
      if (screenElements.length > 0) {
        const visibleElements = [screenElements[0]];
        for (let i2 = 1, n2 = screenElements.length; i2 < n2; i2++) {
          if ("none" !== screenElements[i2].style.display) {
            const rectA = screenElements[i2].getBoundingClientRect();
            if (visibleElements.some((element) => {
              const rectB = element.getBoundingClientRect();
              const x = Math.abs(rectA.right + rectA.left - (rectB.right + rectB.left)) / 2;
              const y = Math.abs(rectA.top + rectA.bottom - (rectB.top + rectB.bottom)) / 2;
              return x < (rectA.right - rectA.left + rectB.right - rectB.left) / 2 && y < (rectA.bottom - rectA.top + rectB.bottom - rectB.top) / 2;
            })) {
              screenElements[i2].style.display = "none";
            } else {
              visibleElements.push(screenElements[i2]);
            }
          }
        }
      }
    }
  }
}
const gUniform = {
  frameNumber: 1,
  resolution: new Vector2$1(),
  delta: 0,
  time: 0
};
class ThreeBoxLayer {
  constructor(options) {
    this.options = options;
    this.id = options.id;
    this.type = "custom";
    this.renderingMode = "3d";
    this.syncRenderPass = false;
    this.isThreeBoxLayer = true;
    this._map = null;
    this.group = new Group$1();
    this.group.name = options.id;
    this.group.isThreeBoxGroup = true;
    this.group.userData = {};
    this.group.userData.name = options.id;
  }
  get minZoom() {
    return this.options.minZoom;
  }
  set minZoom(value) {
    this._minZoom = value;
    if (this._map && typeof this._map.triggerRepaint === "function") {
      this._map.triggerRepaint();
    }
  }
  get maxZoom() {
    return this._maxZoom;
  }
  set maxZoom(value) {
    this._maxZoom = value;
    if (this._map && typeof this._map.triggerRepaint === "function") {
      this._map.triggerRepaint();
    }
  }
  // eslint-disable-next-line no-unused-vars
  _onAdd(map, gl) {
  }
  // eslint-disable-next-line no-unused-vars
  _render(gl, matrix2) {
  }
  // eslint-disable-next-line no-unused-vars
  _onRemove(map, gl) {
  }
  setLayoutProperty(name, value) {
    if (name === "visibility") this.group.visible = value === "visible";
    return this;
  }
  getLayoutProperty(name) {
    if (name === "visibility") return this.group.visible ? "visible" : "none";
    return null;
  }
  onAdd(map, gl) {
    this._map = map;
    this._map.tb.add(this.group);
    this.group.updateMatrixWorld();
    this.group.userData.renderFlag = this.flag;
    this.group.userData.enableOIT = !!this._map.enableOIT;
    this._onAdd(this._map, gl);
    this.options.funcOnAdd && this.options.funcOnAdd(this._map, gl);
  }
  render(gl, matrix2, mapboxRenderPass, level) {
    if (this.id !== "default_scene") return;
    if (!this.group.visible) return;
    if ("translucent" !== mapboxRenderPass) return;
    if (!this._map.getEnableOIT() || !this._map.painter.transform.isUnderground && level === "under" || this._map.painter.transform.isUnderground && level === "above") {
      gUniform.resolution = new Vector2$1(
        this._map.getCanvas().clientWidth,
        this._map.getCanvas().clientHeight
      );
      gUniform.frameNumber++;
      if (gUniform.frameNumber > 15e6) gUniform.frameNumber = 1;
      gUniform.delta = this._map.tb.clock.getDelta();
      gUniform.time += gUniform.delta;
      Object.keys(this._map.materialCache).forEach((id) => {
        this._map.materialCache[id].forEach((material) => {
          const arr = ["frameNumber", "resolution"];
          arr.forEach((key) => {
            if (material.uniforms[key]) material.uniforms[key] = { value: gUniform[key] };
            material.uniforms[key] = { value: gUniform[key] };
          });
          if (material.uniforms.time) material.uniforms.time.value += 1 / 60;
          if (material.realTimeUniformsFun) {
            let uniforms = material.realTimeUniformsFun();
            for (let key in uniforms) material.uniforms[key] = uniforms[key];
          }
        });
      });
      if (this._map._plane3d) {
        this._map._plane3d.children[0].rotation.z -= 2e-3;
        this._map._plane3d.children[1].rotation.z -= 5e-3;
        this._map._plane3d.children[2].rotation.z += 6e-3;
        this._map._plane3d.children[4].material.uniforms.time.value += 1 / 60;
      }
      if (this._map.css2d_render_matrix !== matrix2.toString() || this._map.needCss2DRefresh) {
        if (this._map.css2d_render_label) {
          this._map.needCss2DRefresh = false;
          this._map.css2d_render_label.render(this._map.tb.scene, this._map.tb.camera);
        }
        this._map.css2d_render_matrix = matrix2.toString();
      }
      if (this._map.tb.options.passiveRendering === false) {
        setTimeout(() => {
          if (typeof this._map.triggerRepaint === "function") this._map.triggerRepaint();
        }, 0);
      }
      for (let id in this._map.style._layers) {
        let layer = this._map.style._layers[id];
        if (layer.implementation && layer.implementation.isThreeBoxLayer) {
          layer.implementation._mapboxRenderPass = mapboxRenderPass;
          if (layer.implementation.options.funcOnRender)
            layer.implementation.options.funcOnRender(gl, matrix2);
          if (layer.implementation._render) layer.implementation._render(gl, matrix2);
        }
      }
    }
    if (level === "under") {
      if (this._map.getEnableOIT())
        this._map.tb.renderer.clippingPlanes = [new Plane$1(new Vector3$1(0, 0, -1), 0)];
    } else if (level === "above") {
      if (this._map.getEnableOIT())
        this._map.tb.renderer.clippingPlanes = [new Plane$1(new Vector3$1(0, 0, 1), 0)];
    } else {
      return;
    }
    this._map.tb.update();
  }
  onRemove(map, gl) {
    this._onRemove();
    if (this.options.funcOnRemove) this.options.funcOnRemove(map, gl);
  }
}
class MeshLine extends BufferGeometry$1 {
  constructor() {
    super();
    this.isMeshLine = true;
    this.type = "MeshLine";
    this.positions = [];
    this.previous = [];
    this.next = [];
    this.side = [];
    this.width = [];
    this.indices_array = [];
    this.uvs = [];
    this.counters = [];
    this._points = [];
    this._geom = null;
    this.widthCallback = null;
    this.matrixWorld = new Matrix4$1();
    Object.defineProperties(this, {
      // this is now a bufferGeometry
      // add getter to support previous api
      geometry: {
        enumerable: true,
        get: function() {
          return this;
        }
      },
      geom: {
        enumerable: true,
        get: function() {
          return this._geom;
        },
        set: function(value) {
          this.setGeometry(value, this.widthCallback);
        }
      },
      // for declaritive architectures
      // to return the same value that sets the points
      // eg. this.points = points
      // console.log(this.points) -> points
      points: {
        enumerable: true,
        get: function() {
          return this._points;
        },
        set: function(value) {
          this.setPoints(value, this.widthCallback);
        }
      }
    });
  }
}
MeshLine.prototype.setMatrixWorld = function(matrixWorld) {
  this.matrixWorld = matrixWorld;
};
MeshLine.prototype.setGeometry = function(g3, c2) {
  this._geometry = g3;
  this.setPoints(g3.getAttribute("position").array, c2);
};
MeshLine.prototype.setPoints = function(points, wcb) {
  if (!(points instanceof Float32Array) && !(points instanceof Array)) {
    console.error("ERROR: The BufferArray of points is not instancied correctly.");
    return;
  }
  this._points = points;
  this.widthCallback = wcb;
  this.positions = [];
  this.counters = [];
  if (points.length && points[0] instanceof Vector3$1) {
    for (var j = 0; j < points.length; j++) {
      var p2 = points[j];
      var c2 = j / points.length;
      this.positions.push(p2.x, p2.y, p2.z);
      this.positions.push(p2.x, p2.y, p2.z);
      this.counters.push(c2);
      this.counters.push(c2);
    }
  } else {
    for (var j = 0; j < points.length; j += 3) {
      var c2 = j / points.length;
      this.positions.push(points[j], points[j + 1], points[j + 2]);
      this.positions.push(points[j], points[j + 1], points[j + 2]);
      this.counters.push(c2);
      this.counters.push(c2);
    }
  }
  this.process();
};
function MeshLineRaycast(raycaster, intersects2) {
  var inverseMatrix = new Matrix4$1();
  var ray2 = new Ray$1();
  var sphere = new Sphere$1();
  var interRay = new Vector3$1();
  var geometry = this.geometry;
  if (!geometry.boundingSphere) geometry.computeBoundingSphere();
  sphere.copy(geometry.boundingSphere);
  sphere.applyMatrix4(this.matrixWorld);
  if (raycaster.ray.intersectSphere(sphere, interRay) === false) {
    return;
  }
  inverseMatrix.copy(this.matrixWorld).invert();
  ray2.copy(raycaster.ray).applyMatrix4(inverseMatrix);
  var vStart = new Vector3$1();
  var vEnd = new Vector3$1();
  var interSegment = new Vector3$1();
  var step = this instanceof LineSegments$1 ? 2 : 1;
  var index2 = geometry.index;
  var attributes = geometry.attributes;
  if (index2 !== null) {
    var indices = index2.array;
    var positions = attributes.position.array;
    var widths = attributes.width.array;
    for (var i2 = 0, l2 = indices.length - 1; i2 < l2; i2 += step) {
      var a3 = indices[i2];
      var b = indices[i2 + 1];
      vStart.fromArray(positions, a3 * 3);
      vEnd.fromArray(positions, b * 3);
      var width = widths[Math.floor(i2 / 3)] !== void 0 ? widths[Math.floor(i2 / 3)] : 1;
      var precision = raycaster.params.Line.threshold + this.material.lineWidth * width / 2;
      var precisionSq = precision * precision;
      var distSq = ray2.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
      if (distSq > precisionSq) continue;
      interRay.applyMatrix4(this.matrixWorld);
      var distance2 = raycaster.ray.origin.distanceTo(interRay);
      if (distance2 < raycaster.near || distance2 > raycaster.far) continue;
      intersects2.push({
        distance: distance2,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: interSegment.clone().applyMatrix4(this.matrixWorld),
        index: i2,
        face: null,
        faceIndex: null,
        object: this
      });
      i2 = l2;
    }
  }
}
MeshLine.prototype.raycast = MeshLineRaycast;
MeshLine.prototype.compareV3 = function(a3, b) {
  var aa = a3 * 6;
  var ab = b * 6;
  return this.positions[aa] === this.positions[ab] && this.positions[aa + 1] === this.positions[ab + 1] && this.positions[aa + 2] === this.positions[ab + 2];
};
MeshLine.prototype.copyV3 = function(a3) {
  var aa = a3 * 6;
  return [this.positions[aa], this.positions[aa + 1], this.positions[aa + 2]];
};
MeshLine.prototype.process = function() {
  var l2 = this.positions.length / 6;
  this.previous = [];
  this.next = [];
  this.side = [];
  this.width = [];
  this.indices_array = [];
  this.uvs = [];
  var w;
  var v;
  if (this.compareV3(0, l2 - 1)) {
    v = this.copyV3(l2 - 2);
  } else {
    v = this.copyV3(0);
  }
  this.previous.push(v[0], v[1], v[2]);
  this.previous.push(v[0], v[1], v[2]);
  for (var j = 0; j < l2; j++) {
    this.side.push(1);
    this.side.push(-1);
    if (this.widthCallback) w = this.widthCallback(j / (l2 - 1));
    else w = 1;
    this.width.push(w);
    this.width.push(w);
    this.uvs.push(j / (l2 - 1), 0);
    this.uvs.push(j / (l2 - 1), 1);
    if (j < l2 - 1) {
      v = this.copyV3(j);
      this.previous.push(v[0], v[1], v[2]);
      this.previous.push(v[0], v[1], v[2]);
      var n2 = j * 2;
      this.indices_array.push(n2, n2 + 1, n2 + 2);
      this.indices_array.push(n2 + 2, n2 + 1, n2 + 3);
    }
    if (j > 0) {
      v = this.copyV3(j);
      this.next.push(v[0], v[1], v[2]);
      this.next.push(v[0], v[1], v[2]);
    }
  }
  if (this.compareV3(l2 - 1, 0)) {
    v = this.copyV3(1);
  } else {
    v = this.copyV3(l2 - 1);
  }
  this.next.push(v[0], v[1], v[2]);
  this.next.push(v[0], v[1], v[2]);
  if (!this._attributes || this._attributes.position.count !== this.positions.length) {
    this._attributes = {
      position: new BufferAttribute$1(new Float32Array(this.positions), 3),
      previous: new BufferAttribute$1(new Float32Array(this.previous), 3),
      next: new BufferAttribute$1(new Float32Array(this.next), 3),
      side: new BufferAttribute$1(new Float32Array(this.side), 1),
      width: new BufferAttribute$1(new Float32Array(this.width), 1),
      uv: new BufferAttribute$1(new Float32Array(this.uvs), 2),
      index: new BufferAttribute$1(new Uint16Array(this.indices_array), 1),
      counters: new BufferAttribute$1(new Float32Array(this.counters), 1)
    };
  } else {
    this._attributes.position.copyArray(new Float32Array(this.positions));
    this._attributes.position.needsUpdate = true;
    this._attributes.previous.copyArray(new Float32Array(this.previous));
    this._attributes.previous.needsUpdate = true;
    this._attributes.next.copyArray(new Float32Array(this.next));
    this._attributes.next.needsUpdate = true;
    this._attributes.side.copyArray(new Float32Array(this.side));
    this._attributes.side.needsUpdate = true;
    this._attributes.width.copyArray(new Float32Array(this.width));
    this._attributes.width.needsUpdate = true;
    this._attributes.uv.copyArray(new Float32Array(this.uvs));
    this._attributes.uv.needsUpdate = true;
    this._attributes.index.copyArray(new Uint16Array(this.indices_array));
    this._attributes.index.needsUpdate = true;
  }
  this.setAttribute("position", this._attributes.position);
  this.setAttribute("previous", this._attributes.previous);
  this.setAttribute("next", this._attributes.next);
  this.setAttribute("side", this._attributes.side);
  this.setAttribute("width", this._attributes.width);
  this.setAttribute("uv", this._attributes.uv);
  this.setAttribute("counters", this._attributes.counters);
  this.setIndex(this._attributes.index);
  this.computeBoundingSphere();
  this.computeBoundingBox();
};
function memcpy(src, srcOffset, dst, dstOffset, length2) {
  var i2;
  src = src.subarray || src.slice ? src : src.buffer;
  dst = dst.subarray || dst.slice ? dst : dst.buffer;
  src = srcOffset ? src.subarray ? src.subarray(srcOffset, length2 && srcOffset + length2) : src.slice(srcOffset, length2 && srcOffset + length2) : src;
  if (dst.set) {
    dst.set(src, dstOffset);
  } else {
    for (i2 = 0; i2 < src.length; i2++) {
      dst[i2 + dstOffset] = src[i2];
    }
  }
  return dst;
}
MeshLine.prototype.advance = function(position2) {
  var positions = this._attributes.position.array;
  var previous = this._attributes.previous.array;
  var next = this._attributes.next.array;
  var l2 = positions.length;
  memcpy(positions, 0, previous, 0, l2);
  memcpy(positions, 6, positions, 0, l2 - 6);
  positions[l2 - 6] = position2.x;
  positions[l2 - 5] = position2.y;
  positions[l2 - 4] = position2.z;
  positions[l2 - 3] = position2.x;
  positions[l2 - 2] = position2.y;
  positions[l2 - 1] = position2.z;
  memcpy(positions, 6, next, 0, l2 - 6);
  next[l2 - 6] = position2.x;
  next[l2 - 5] = position2.y;
  next[l2 - 4] = position2.z;
  next[l2 - 3] = position2.x;
  next[l2 - 2] = position2.y;
  next[l2 - 1] = position2.z;
  this._attributes.position.needsUpdate = true;
  this._attributes.previous.needsUpdate = true;
  this._attributes.next.needsUpdate = true;
};
ShaderChunk$1["meshline_vert"] = [
  "",
  ShaderChunk$1.logdepthbuf_pars_vertex,
  ShaderChunk$1.fog_pars_vertex,
  "",
  "attribute vec3 previous;",
  "attribute vec3 next;",
  "attribute float side;",
  "attribute float width;",
  "attribute float counters;",
  "",
  "uniform vec2 resolution;",
  "uniform float lineWidth;",
  "uniform vec3 color;",
  "uniform float opacity;",
  "uniform float sizeAttenuation;",
  "",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "varying float vCounters;",
  "",
  "vec2 fix( vec4 i, float aspect ) {",
  "",
  "    vec2 res = i.xy / i.w;",
  "    res.x *= aspect;",
  "	 vCounters = counters;",
  "    return res;",
  "",
  "}",
  "",
  "void main() {",
  "",
  "    float aspect = resolution.x / resolution.y;",
  "",
  "    vColor = vec4( color, opacity );",
  "    vUV = uv;",
  "",
  "    mat4 m = projectionMatrix * modelViewMatrix;",
  "    vec4 finalPosition = m * vec4( position, 1.0 );",
  "    vec4 prevPos = m * vec4( previous, 1.0 );",
  "    vec4 nextPos = m * vec4( next, 1.0 );",
  "",
  "    vec2 currentP = fix( finalPosition, aspect );",
  "    vec2 prevP = fix( prevPos, aspect );",
  "    vec2 nextP = fix( nextPos, aspect );",
  "",
  "    float w = lineWidth * width;",
  "",
  "    vec2 dir;",
  "    if( nextP == currentP ) dir = normalize( currentP - prevP );",
  "    else if( prevP == currentP ) dir = normalize( nextP - currentP );",
  "    else {",
  "        vec2 dir1 = normalize( currentP - prevP );",
  "        vec2 dir2 = normalize( nextP - currentP );",
  "        dir = normalize( dir1 + dir2 );",
  "",
  "        vec2 perp = vec2( -dir1.y, dir1.x );",
  "        vec2 miter = vec2( -dir.y, dir.x );",
  "        //w = clamp( w / dot( miter, perp ), 0., 4. * lineWidth * width );",
  "",
  "    }",
  "",
  "    //vec2 normal = ( cross( vec3( dir, 0. ), vec3( 0., 0., 1. ) ) ).xy;",
  "    vec4 normal = vec4( -dir.y, dir.x, 0., 1. );",
  "    normal.xy *= .5 * w;",
  "    normal *= projectionMatrix;",
  "    if( sizeAttenuation == 0. ) {",
  "        normal.xy *= finalPosition.w;",
  "        normal.xy /= ( vec4( resolution, 0., 1. ) * projectionMatrix ).xy;",
  "    }",
  "",
  "    finalPosition.xy += normal.xy * side;",
  "",
  "    gl_Position = finalPosition;",
  "",
  ShaderChunk$1.logdepthbuf_vertex,
  ShaderChunk$1.fog_vertex && "    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.fog_vertex,
  "}"
].join("\n");
ShaderChunk$1["meshline_frag"] = [
  "",
  ShaderChunk$1.fog_pars_fragment,
  ShaderChunk$1.logdepthbuf_pars_fragment,
  "",
  "uniform sampler2D map;",
  "uniform sampler2D alphaMap;",
  "uniform float useMap;",
  "uniform float useAlphaMap;",
  "uniform float useDash;",
  "uniform float dashArray;",
  "uniform float dashOffset;",
  "uniform float dashRatio;",
  "uniform float visibility;",
  "uniform float alphaTest;",
  "uniform vec2 repeat;",
  "",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "varying float vCounters;",
  "",
  "void main() {",
  "",
  ShaderChunk$1.logdepthbuf_fragment,
  "",
  "    vec4 c = vColor;",
  "    if( useMap == 1. ) c *= texture2D( map, vUV * repeat );",
  "    if( useAlphaMap == 1. ) c.a *= texture2D( alphaMap, vUV * repeat ).a;",
  "    if( c.a < alphaTest ) discard;",
  "    if( useDash == 1. ){",
  "        c.a *= ceil(mod(vCounters + dashOffset, dashArray) - (dashArray * dashRatio));",
  "    }",
  "    gl_FragColor = c;",
  "    gl_FragColor.a *= step(vCounters, visibility);",
  "",
  ShaderChunk$1.fog_fragment,
  "}"
].join("\n");
let MeshLineMaterial$1 = class MeshLineMaterial extends ShaderMaterial$1 {
  constructor(parameters) {
    super({
      uniforms: Object.assign({}, UniformsLib$1.fog, {
        lineWidth: { value: 1 },
        map: { value: null },
        useMap: { value: 0 },
        alphaMap: { value: null },
        useAlphaMap: { value: 0 },
        color: { value: new Color$1(16777215) },
        opacity: { value: 1 },
        resolution: { value: new Vector2$1(1, 1) },
        sizeAttenuation: { value: 1 },
        dashArray: { value: 0 },
        dashOffset: { value: 0 },
        dashRatio: { value: 0.5 },
        useDash: { value: 0 },
        visibility: { value: 1 },
        alphaTest: { value: 0 },
        repeat: { value: new Vector2$1(1, 1) }
      }),
      vertexShader: ShaderChunk$1.meshline_vert,
      fragmentShader: ShaderChunk$1.meshline_frag
    });
    this.isMeshLineMaterial = true;
    this.type = "MeshLineMaterial";
    Object.defineProperties(this, {
      lineWidth: {
        enumerable: true,
        get: function() {
          return this.uniforms.lineWidth.value;
        },
        set: function(value) {
          this.uniforms.lineWidth.value = value;
        }
      },
      map: {
        enumerable: true,
        get: function() {
          return this.uniforms.map.value;
        },
        set: function(value) {
          this.uniforms.map.value = value;
        }
      },
      useMap: {
        enumerable: true,
        get: function() {
          return this.uniforms.useMap.value;
        },
        set: function(value) {
          this.uniforms.useMap.value = value;
        }
      },
      alphaMap: {
        enumerable: true,
        get: function() {
          return this.uniforms.alphaMap.value;
        },
        set: function(value) {
          this.uniforms.alphaMap.value = value;
        }
      },
      useAlphaMap: {
        enumerable: true,
        get: function() {
          return this.uniforms.useAlphaMap.value;
        },
        set: function(value) {
          this.uniforms.useAlphaMap.value = value;
        }
      },
      color: {
        enumerable: true,
        get: function() {
          return this.uniforms.color.value;
        },
        set: function(value) {
          this.uniforms.color.value = value;
        }
      },
      opacity: {
        enumerable: true,
        get: function() {
          return this.uniforms.opacity.value;
        },
        set: function(value) {
          this.uniforms.opacity.value = value;
        }
      },
      resolution: {
        enumerable: true,
        get: function() {
          return this.uniforms.resolution.value;
        },
        set: function(value) {
          this.uniforms.resolution.value.copy(value);
        }
      },
      sizeAttenuation: {
        enumerable: true,
        get: function() {
          return this.uniforms.sizeAttenuation.value;
        },
        set: function(value) {
          this.uniforms.sizeAttenuation.value = value;
        }
      },
      dashArray: {
        enumerable: true,
        get: function() {
          return this.uniforms.dashArray.value;
        },
        set: function(value) {
          this.uniforms.dashArray.value = value;
          this.useDash = value !== 0 ? 1 : 0;
        }
      },
      dashOffset: {
        enumerable: true,
        get: function() {
          return this.uniforms.dashOffset.value;
        },
        set: function(value) {
          this.uniforms.dashOffset.value = value;
        }
      },
      dashRatio: {
        enumerable: true,
        get: function() {
          return this.uniforms.dashRatio.value;
        },
        set: function(value) {
          this.uniforms.dashRatio.value = value;
        }
      },
      useDash: {
        enumerable: true,
        get: function() {
          return this.uniforms.useDash.value;
        },
        set: function(value) {
          this.uniforms.useDash.value = value;
        }
      },
      visibility: {
        enumerable: true,
        get: function() {
          return this.uniforms.visibility.value;
        },
        set: function(value) {
          this.uniforms.visibility.value = value;
        }
      },
      alphaTest: {
        enumerable: true,
        get: function() {
          return this.uniforms.alphaTest.value;
        },
        set: function(value) {
          this.uniforms.alphaTest.value = value;
        }
      },
      repeat: {
        enumerable: true,
        get: function() {
          return this.uniforms.repeat.value;
        },
        set: function(value) {
          this.uniforms.repeat.value.copy(value);
        }
      }
    });
    this.setValues(parameters);
  }
};
MeshLineMaterial$1.prototype.copy = function(source) {
  ShaderMaterial$1.prototype.copy.call(this, source);
  this.lineWidth = source.lineWidth;
  this.map = source.map;
  this.useMap = source.useMap;
  this.alphaMap = source.alphaMap;
  this.useAlphaMap = source.useAlphaMap;
  this.color.copy(source.color);
  this.opacity = source.opacity;
  this.resolution.copy(source.resolution);
  this.sizeAttenuation = source.sizeAttenuation;
  this.dashArray.copy(source.dashArray);
  this.dashOffset.copy(source.dashOffset);
  this.dashRatio.copy(source.dashRatio);
  this.useDash = source.useDash;
  this.visibility = source.visibility;
  this.alphaTest = source.alphaTest;
  this.repeat.copy(source.repeat);
  return this;
};
/**
 * @license
 * Copyright 2010-2021 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const REVISION = "132";
const CullFaceNone = 0;
const CullFaceBack = 1;
const CullFaceFront = 2;
const PCFShadowMap = 1;
const PCFSoftShadowMap = 2;
const VSMShadowMap = 3;
const FrontSide = 0;
const BackSide = 1;
const DoubleSide = 2;
const FlatShading = 1;
const NoBlending = 0;
const NormalBlending = 1;
const AdditiveBlending = 2;
const SubtractiveBlending = 3;
const MultiplyBlending = 4;
const CustomBlending = 5;
const AddEquation = 100;
const SubtractEquation = 101;
const ReverseSubtractEquation = 102;
const MinEquation = 103;
const MaxEquation = 104;
const ZeroFactor = 200;
const OneFactor = 201;
const SrcColorFactor = 202;
const OneMinusSrcColorFactor = 203;
const SrcAlphaFactor = 204;
const OneMinusSrcAlphaFactor = 205;
const DstAlphaFactor = 206;
const OneMinusDstAlphaFactor = 207;
const DstColorFactor = 208;
const OneMinusDstColorFactor = 209;
const SrcAlphaSaturateFactor = 210;
const NeverDepth = 0;
const AlwaysDepth = 1;
const LessDepth = 2;
const LessEqualDepth = 3;
const EqualDepth = 4;
const GreaterEqualDepth = 5;
const GreaterDepth = 6;
const NotEqualDepth = 7;
const MultiplyOperation = 0;
const MixOperation = 1;
const AddOperation = 2;
const NoToneMapping = 0;
const LinearToneMapping = 1;
const ReinhardToneMapping = 2;
const CineonToneMapping = 3;
const ACESFilmicToneMapping = 4;
const CustomToneMapping = 5;
const UVMapping = 300;
const CubeReflectionMapping = 301;
const CubeRefractionMapping = 302;
const EquirectangularReflectionMapping = 303;
const EquirectangularRefractionMapping = 304;
const CubeUVReflectionMapping = 306;
const CubeUVRefractionMapping = 307;
const RepeatWrapping = 1e3;
const ClampToEdgeWrapping = 1001;
const MirroredRepeatWrapping = 1002;
const NearestFilter = 1003;
const NearestMipmapNearestFilter = 1004;
const NearestMipmapLinearFilter = 1005;
const LinearFilter = 1006;
const LinearMipmapNearestFilter = 1007;
const LinearMipmapLinearFilter = 1008;
const UnsignedByteType = 1009;
const ByteType = 1010;
const ShortType = 1011;
const UnsignedShortType = 1012;
const IntType = 1013;
const UnsignedIntType = 1014;
const FloatType = 1015;
const HalfFloatType = 1016;
const UnsignedShort4444Type = 1017;
const UnsignedShort5551Type = 1018;
const UnsignedShort565Type = 1019;
const UnsignedInt248Type = 1020;
const AlphaFormat = 1021;
const RGBFormat = 1022;
const RGBAFormat = 1023;
const LuminanceFormat = 1024;
const LuminanceAlphaFormat = 1025;
const RGBEFormat = RGBAFormat;
const DepthFormat = 1026;
const DepthStencilFormat = 1027;
const RedFormat = 1028;
const RedIntegerFormat = 1029;
const RGFormat = 1030;
const RGIntegerFormat = 1031;
const RGBIntegerFormat = 1032;
const RGBAIntegerFormat = 1033;
const RGB_S3TC_DXT1_Format = 33776;
const RGBA_S3TC_DXT1_Format = 33777;
const RGBA_S3TC_DXT3_Format = 33778;
const RGBA_S3TC_DXT5_Format = 33779;
const RGB_PVRTC_4BPPV1_Format = 35840;
const RGB_PVRTC_2BPPV1_Format = 35841;
const RGBA_PVRTC_4BPPV1_Format = 35842;
const RGBA_PVRTC_2BPPV1_Format = 35843;
const RGB_ETC1_Format = 36196;
const RGB_ETC2_Format = 37492;
const RGBA_ETC2_EAC_Format = 37496;
const RGBA_ASTC_4x4_Format = 37808;
const RGBA_ASTC_5x4_Format = 37809;
const RGBA_ASTC_5x5_Format = 37810;
const RGBA_ASTC_6x5_Format = 37811;
const RGBA_ASTC_6x6_Format = 37812;
const RGBA_ASTC_8x5_Format = 37813;
const RGBA_ASTC_8x6_Format = 37814;
const RGBA_ASTC_8x8_Format = 37815;
const RGBA_ASTC_10x5_Format = 37816;
const RGBA_ASTC_10x6_Format = 37817;
const RGBA_ASTC_10x8_Format = 37818;
const RGBA_ASTC_10x10_Format = 37819;
const RGBA_ASTC_12x10_Format = 37820;
const RGBA_ASTC_12x12_Format = 37821;
const RGBA_BPTC_Format = 36492;
const SRGB8_ALPHA8_ASTC_4x4_Format = 37840;
const SRGB8_ALPHA8_ASTC_5x4_Format = 37841;
const SRGB8_ALPHA8_ASTC_5x5_Format = 37842;
const SRGB8_ALPHA8_ASTC_6x5_Format = 37843;
const SRGB8_ALPHA8_ASTC_6x6_Format = 37844;
const SRGB8_ALPHA8_ASTC_8x5_Format = 37845;
const SRGB8_ALPHA8_ASTC_8x6_Format = 37846;
const SRGB8_ALPHA8_ASTC_8x8_Format = 37847;
const SRGB8_ALPHA8_ASTC_10x5_Format = 37848;
const SRGB8_ALPHA8_ASTC_10x6_Format = 37849;
const SRGB8_ALPHA8_ASTC_10x8_Format = 37850;
const SRGB8_ALPHA8_ASTC_10x10_Format = 37851;
const SRGB8_ALPHA8_ASTC_12x10_Format = 37852;
const SRGB8_ALPHA8_ASTC_12x12_Format = 37853;
const LoopOnce = 2200;
const LoopRepeat = 2201;
const LoopPingPong = 2202;
const InterpolateDiscrete = 2300;
const InterpolateLinear = 2301;
const InterpolateSmooth = 2302;
const ZeroCurvatureEnding = 2400;
const ZeroSlopeEnding = 2401;
const WrapAroundEnding = 2402;
const NormalAnimationBlendMode = 2500;
const AdditiveAnimationBlendMode = 2501;
const TrianglesDrawMode = 0;
const LinearEncoding = 3e3;
const sRGBEncoding = 3001;
const GammaEncoding = 3007;
const RGBEEncoding = 3002;
const LogLuvEncoding = 3003;
const RGBM7Encoding = 3004;
const RGBM16Encoding = 3005;
const RGBDEncoding = 3006;
const BasicDepthPacking = 3200;
const RGBADepthPacking = 3201;
const TangentSpaceNormalMap = 0;
const ObjectSpaceNormalMap = 1;
const KeepStencilOp = 7680;
const AlwaysStencilFunc = 519;
const StaticDrawUsage = 35044;
const DynamicDrawUsage = 35048;
const GLSL3 = "300 es";
class EventDispatcher2 {
  addEventListener(type, listener) {
    if (this._listeners === void 0) this._listeners = {};
    const listeners = this._listeners;
    if (listeners[type] === void 0) {
      listeners[type] = [];
    }
    if (listeners[type].indexOf(listener) === -1) {
      listeners[type].push(listener);
    }
  }
  hasEventListener(type, listener) {
    if (this._listeners === void 0) return false;
    const listeners = this._listeners;
    return listeners[type] !== void 0 && listeners[type].indexOf(listener) !== -1;
  }
  removeEventListener(type, listener) {
    if (this._listeners === void 0) return;
    const listeners = this._listeners;
    const listenerArray = listeners[type];
    if (listenerArray !== void 0) {
      const index2 = listenerArray.indexOf(listener);
      if (index2 !== -1) {
        listenerArray.splice(index2, 1);
      }
    }
  }
  dispatchEvent(event) {
    if (this._listeners === void 0) return;
    const listeners = this._listeners;
    const listenerArray = listeners[event.type];
    if (listenerArray !== void 0) {
      event.target = this;
      const array = listenerArray.slice(0);
      for (let i2 = 0, l2 = array.length; i2 < l2; i2++) {
        array[i2].call(this, event);
      }
      event.target = null;
    }
  }
}
const _lut = [];
for (let i2 = 0; i2 < 256; i2++) {
  _lut[i2] = (i2 < 16 ? "0" : "") + i2.toString(16);
}
const DEG2RAD = Math.PI / 180;
const RAD2DEG = 180 / Math.PI;
function generateUUID() {
  const d0 = Math.random() * 4294967295 | 0;
  const d1 = Math.random() * 4294967295 | 0;
  const d2 = Math.random() * 4294967295 | 0;
  const d3 = Math.random() * 4294967295 | 0;
  const uuid = _lut[d0 & 255] + _lut[d0 >> 8 & 255] + _lut[d0 >> 16 & 255] + _lut[d0 >> 24 & 255] + "-" + _lut[d1 & 255] + _lut[d1 >> 8 & 255] + "-" + _lut[d1 >> 16 & 15 | 64] + _lut[d1 >> 24 & 255] + "-" + _lut[d2 & 63 | 128] + _lut[d2 >> 8 & 255] + "-" + _lut[d2 >> 16 & 255] + _lut[d2 >> 24 & 255] + _lut[d3 & 255] + _lut[d3 >> 8 & 255] + _lut[d3 >> 16 & 255] + _lut[d3 >> 24 & 255];
  return uuid.toUpperCase();
}
function clamp(value, min, max2) {
  return Math.max(min, Math.min(max2, value));
}
function euclideanModulo(n2, m) {
  return (n2 % m + m) % m;
}
function lerp$1(x, y, t3) {
  return (1 - t3) * x + t3 * y;
}
function isPowerOfTwo(value) {
  return (value & value - 1) === 0 && value !== 0;
}
function floorPowerOfTwo(value) {
  return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
class Vector22 {
  constructor(x = 0, y = 0) {
    this.x = x;
    this.y = y;
  }
  get width() {
    return this.x;
  }
  set width(value) {
    this.x = value;
  }
  get height() {
    return this.y;
  }
  set height(value) {
    this.y = value;
  }
  set(x, y) {
    this.x = x;
    this.y = y;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    return this;
  }
  setX(x) {
    this.x = x;
    return this;
  }
  setY(y) {
    this.y = y;
    return this;
  }
  setComponent(index2, value) {
    switch (index2) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      default:
        throw new Error("index is out of range: " + index2);
    }
    return this;
  }
  getComponent(index2) {
    switch (index2) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + index2);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(v) {
    this.x = v.x;
    this.y = v.y;
    return this;
  }
  add(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
      return this.addVectors(v, w);
    }
    this.x += v.x;
    this.y += v.y;
    return this;
  }
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    return this;
  }
  addVectors(a3, b) {
    this.x = a3.x + b.x;
    this.y = a3.y + b.y;
    return this;
  }
  addScaledVector(v, s2) {
    this.x += v.x * s2;
    this.y += v.y * s2;
    return this;
  }
  sub(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
      return this.subVectors(v, w);
    }
    this.x -= v.x;
    this.y -= v.y;
    return this;
  }
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    return this;
  }
  subVectors(a3, b) {
    this.x = a3.x - b.x;
    this.y = a3.y - b.y;
    return this;
  }
  multiply(v) {
    this.x *= v.x;
    this.y *= v.y;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    return this;
  }
  divide(v) {
    this.x /= v.x;
    this.y /= v.y;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  applyMatrix3(m) {
    const x = this.x, y = this.y;
    const e2 = m.elements;
    this.x = e2[0] * x + e2[3] * y + e2[6];
    this.y = e2[1] * x + e2[4] * y + e2[7];
    return this;
  }
  min(v) {
    this.x = Math.min(this.x, v.x);
    this.y = Math.min(this.y, v.y);
    return this;
  }
  max(v) {
    this.x = Math.max(this.x, v.x);
    this.y = Math.max(this.y, v.y);
    return this;
  }
  clamp(min, max2) {
    this.x = Math.max(min.x, Math.min(max2.x, this.x));
    this.y = Math.max(min.y, Math.min(max2.y, this.y));
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = Math.max(minVal, Math.min(maxVal, this.x));
    this.y = Math.max(minVal, Math.min(maxVal, this.y));
    return this;
  }
  clampLength(min, max2) {
    const length2 = this.length();
    return this.divideScalar(length2 || 1).multiplyScalar(Math.max(min, Math.min(max2, length2)));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  }
  roundToZero() {
    this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
    this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    return this;
  }
  dot(v) {
    return this.x * v.x + this.y * v.y;
  }
  cross(v) {
    return this.x * v.y - this.y * v.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    const angle2 = Math.atan2(-this.y, -this.x) + Math.PI;
    return angle2;
  }
  distanceTo(v) {
    return Math.sqrt(this.distanceToSquared(v));
  }
  distanceToSquared(v) {
    const dx = this.x - v.x, dy = this.y - v.y;
    return dx * dx + dy * dy;
  }
  manhattanDistanceTo(v) {
    return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
  }
  setLength(length2) {
    return this.normalize().multiplyScalar(length2);
  }
  lerp(v, alpha) {
    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    return this;
  }
  lerpVectors(v1, v2, alpha) {
    this.x = v1.x + (v2.x - v1.x) * alpha;
    this.y = v1.y + (v2.y - v1.y) * alpha;
    return this;
  }
  equals(v) {
    return v.x === this.x && v.y === this.y;
  }
  fromArray(array, offset = 0) {
    this.x = array[offset];
    this.y = array[offset + 1];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.x;
    array[offset + 1] = this.y;
    return array;
  }
  fromBufferAttribute(attribute, index2, offset) {
    if (offset !== void 0) {
      console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute().");
    }
    this.x = attribute.getX(index2);
    this.y = attribute.getY(index2);
    return this;
  }
  rotateAround(center, angle2) {
    const c2 = Math.cos(angle2), s2 = Math.sin(angle2);
    const x = this.x - center.x;
    const y = this.y - center.y;
    this.x = x * c2 - y * s2 + center.x;
    this.y = x * s2 + y * c2 + center.y;
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    return this;
  }
}
Vector22.prototype.isVector2 = true;
class Matrix32 {
  constructor() {
    this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ];
    if (arguments.length > 0) {
      console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
    }
  }
  set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
    const te2 = this.elements;
    te2[0] = n11;
    te2[1] = n21;
    te2[2] = n31;
    te2[3] = n12;
    te2[4] = n22;
    te2[5] = n32;
    te2[6] = n13;
    te2[7] = n23;
    te2[8] = n33;
    return this;
  }
  identity() {
    this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    );
    return this;
  }
  copy(m) {
    const te2 = this.elements;
    const me = m.elements;
    te2[0] = me[0];
    te2[1] = me[1];
    te2[2] = me[2];
    te2[3] = me[3];
    te2[4] = me[4];
    te2[5] = me[5];
    te2[6] = me[6];
    te2[7] = me[7];
    te2[8] = me[8];
    return this;
  }
  extractBasis(xAxis, yAxis, zAxis) {
    xAxis.setFromMatrix3Column(this, 0);
    yAxis.setFromMatrix3Column(this, 1);
    zAxis.setFromMatrix3Column(this, 2);
    return this;
  }
  setFromMatrix4(m) {
    const me = m.elements;
    this.set(
      me[0],
      me[4],
      me[8],
      me[1],
      me[5],
      me[9],
      me[2],
      me[6],
      me[10]
    );
    return this;
  }
  multiply(m) {
    return this.multiplyMatrices(this, m);
  }
  premultiply(m) {
    return this.multiplyMatrices(m, this);
  }
  multiplyMatrices(a3, b) {
    const ae2 = a3.elements;
    const be = b.elements;
    const te2 = this.elements;
    const a11 = ae2[0], a12 = ae2[3], a13 = ae2[6];
    const a21 = ae2[1], a22 = ae2[4], a23 = ae2[7];
    const a31 = ae2[2], a32 = ae2[5], a33 = ae2[8];
    const b11 = be[0], b12 = be[3], b13 = be[6];
    const b21 = be[1], b22 = be[4], b23 = be[7];
    const b31 = be[2], b32 = be[5], b33 = be[8];
    te2[0] = a11 * b11 + a12 * b21 + a13 * b31;
    te2[3] = a11 * b12 + a12 * b22 + a13 * b32;
    te2[6] = a11 * b13 + a12 * b23 + a13 * b33;
    te2[1] = a21 * b11 + a22 * b21 + a23 * b31;
    te2[4] = a21 * b12 + a22 * b22 + a23 * b32;
    te2[7] = a21 * b13 + a22 * b23 + a23 * b33;
    te2[2] = a31 * b11 + a32 * b21 + a33 * b31;
    te2[5] = a31 * b12 + a32 * b22 + a33 * b32;
    te2[8] = a31 * b13 + a32 * b23 + a33 * b33;
    return this;
  }
  multiplyScalar(s2) {
    const te2 = this.elements;
    te2[0] *= s2;
    te2[3] *= s2;
    te2[6] *= s2;
    te2[1] *= s2;
    te2[4] *= s2;
    te2[7] *= s2;
    te2[2] *= s2;
    te2[5] *= s2;
    te2[8] *= s2;
    return this;
  }
  determinant() {
    const te2 = this.elements;
    const a3 = te2[0], b = te2[1], c2 = te2[2], d2 = te2[3], e2 = te2[4], f2 = te2[5], g3 = te2[6], h2 = te2[7], i2 = te2[8];
    return a3 * e2 * i2 - a3 * f2 * h2 - b * d2 * i2 + b * f2 * g3 + c2 * d2 * h2 - c2 * e2 * g3;
  }
  invert() {
    const te2 = this.elements, n11 = te2[0], n21 = te2[1], n31 = te2[2], n12 = te2[3], n22 = te2[4], n32 = te2[5], n13 = te2[6], n23 = te2[7], n33 = te2[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
    if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const detInv = 1 / det;
    te2[0] = t11 * detInv;
    te2[1] = (n31 * n23 - n33 * n21) * detInv;
    te2[2] = (n32 * n21 - n31 * n22) * detInv;
    te2[3] = t12 * detInv;
    te2[4] = (n33 * n11 - n31 * n13) * detInv;
    te2[5] = (n31 * n12 - n32 * n11) * detInv;
    te2[6] = t13 * detInv;
    te2[7] = (n21 * n13 - n23 * n11) * detInv;
    te2[8] = (n22 * n11 - n21 * n12) * detInv;
    return this;
  }
  transpose() {
    let tmp2;
    const m = this.elements;
    tmp2 = m[1];
    m[1] = m[3];
    m[3] = tmp2;
    tmp2 = m[2];
    m[2] = m[6];
    m[6] = tmp2;
    tmp2 = m[5];
    m[5] = m[7];
    m[7] = tmp2;
    return this;
  }
  getNormalMatrix(matrix4) {
    return this.setFromMatrix4(matrix4).invert().transpose();
  }
  transposeIntoArray(r2) {
    const m = this.elements;
    r2[0] = m[0];
    r2[1] = m[3];
    r2[2] = m[6];
    r2[3] = m[1];
    r2[4] = m[4];
    r2[5] = m[7];
    r2[6] = m[2];
    r2[7] = m[5];
    r2[8] = m[8];
    return this;
  }
  setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
    const c2 = Math.cos(rotation);
    const s2 = Math.sin(rotation);
    this.set(
      sx * c2,
      sx * s2,
      -sx * (c2 * cx + s2 * cy) + cx + tx,
      -sy * s2,
      sy * c2,
      -sy * (-s2 * cx + c2 * cy) + cy + ty,
      0,
      0,
      1
    );
    return this;
  }
  scale(sx, sy) {
    const te2 = this.elements;
    te2[0] *= sx;
    te2[3] *= sx;
    te2[6] *= sx;
    te2[1] *= sy;
    te2[4] *= sy;
    te2[7] *= sy;
    return this;
  }
  rotate(theta) {
    const c2 = Math.cos(theta);
    const s2 = Math.sin(theta);
    const te2 = this.elements;
    const a11 = te2[0], a12 = te2[3], a13 = te2[6];
    const a21 = te2[1], a22 = te2[4], a23 = te2[7];
    te2[0] = c2 * a11 + s2 * a21;
    te2[3] = c2 * a12 + s2 * a22;
    te2[6] = c2 * a13 + s2 * a23;
    te2[1] = -s2 * a11 + c2 * a21;
    te2[4] = -s2 * a12 + c2 * a22;
    te2[7] = -s2 * a13 + c2 * a23;
    return this;
  }
  translate(tx, ty) {
    const te2 = this.elements;
    te2[0] += tx * te2[2];
    te2[3] += tx * te2[5];
    te2[6] += tx * te2[8];
    te2[1] += ty * te2[2];
    te2[4] += ty * te2[5];
    te2[7] += ty * te2[8];
    return this;
  }
  equals(matrix2) {
    const te2 = this.elements;
    const me = matrix2.elements;
    for (let i2 = 0; i2 < 9; i2++) {
      if (te2[i2] !== me[i2]) return false;
    }
    return true;
  }
  fromArray(array, offset = 0) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.elements[i2] = array[i2 + offset];
    }
    return this;
  }
  toArray(array = [], offset = 0) {
    const te2 = this.elements;
    array[offset] = te2[0];
    array[offset + 1] = te2[1];
    array[offset + 2] = te2[2];
    array[offset + 3] = te2[3];
    array[offset + 4] = te2[4];
    array[offset + 5] = te2[5];
    array[offset + 6] = te2[6];
    array[offset + 7] = te2[7];
    array[offset + 8] = te2[8];
    return array;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
Matrix32.prototype.isMatrix3 = true;
let _canvas;
class ImageUtils2 {
  static getDataURL(image2) {
    if (/^data:/i.test(image2.src)) {
      return image2.src;
    }
    if (typeof HTMLCanvasElement == "undefined") {
      return image2.src;
    }
    let canvas;
    if (image2 instanceof HTMLCanvasElement) {
      canvas = image2;
    } else {
      if (_canvas === void 0) _canvas = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
      _canvas.width = image2.width;
      _canvas.height = image2.height;
      const context = _canvas.getContext("2d");
      if (image2 instanceof ImageData) {
        context.putImageData(image2, 0, 0);
      } else {
        context.drawImage(image2, 0, 0, image2.width, image2.height);
      }
      canvas = _canvas;
    }
    if (canvas.width > 2048 || canvas.height > 2048) {
      console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image2);
      return canvas.toDataURL("image/jpeg", 0.6);
    } else {
      return canvas.toDataURL("image/png");
    }
  }
}
let textureId = 0;
class Texture2 extends EventDispatcher2 {
  constructor(image2 = Texture2.DEFAULT_IMAGE, mapping = Texture2.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping, wrapT = ClampToEdgeWrapping, magFilter = LinearFilter, minFilter = LinearMipmapLinearFilter, format = RGBAFormat, type = UnsignedByteType, anisotropy = 1, encoding = LinearEncoding) {
    super();
    Object.defineProperty(this, "id", { value: textureId++ });
    this.uuid = generateUUID();
    this.name = "";
    this.image = image2;
    this.mipmaps = [];
    this.mapping = mapping;
    this.wrapS = wrapS;
    this.wrapT = wrapT;
    this.magFilter = magFilter;
    this.minFilter = minFilter;
    this.anisotropy = anisotropy;
    this.format = format;
    this.internalFormat = null;
    this.type = type;
    this.offset = new Vector22(0, 0);
    this.repeat = new Vector22(1, 1);
    this.center = new Vector22(0, 0);
    this.rotation = 0;
    this.matrixAutoUpdate = true;
    this.matrix = new Matrix32();
    this.generateMipmaps = true;
    this.premultiplyAlpha = false;
    this.flipY = true;
    this.unpackAlignment = 4;
    this.encoding = encoding;
    this.version = 0;
    this.onUpdate = null;
    this.isRenderTargetTexture = false;
  }
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.name = source.name;
    this.image = source.image;
    this.mipmaps = source.mipmaps.slice(0);
    this.mapping = source.mapping;
    this.wrapS = source.wrapS;
    this.wrapT = source.wrapT;
    this.magFilter = source.magFilter;
    this.minFilter = source.minFilter;
    this.anisotropy = source.anisotropy;
    this.format = source.format;
    this.internalFormat = source.internalFormat;
    this.type = source.type;
    this.offset.copy(source.offset);
    this.repeat.copy(source.repeat);
    this.center.copy(source.center);
    this.rotation = source.rotation;
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    this.matrix.copy(source.matrix);
    this.generateMipmaps = source.generateMipmaps;
    this.premultiplyAlpha = source.premultiplyAlpha;
    this.flipY = source.flipY;
    this.unpackAlignment = source.unpackAlignment;
    this.encoding = source.encoding;
    return this;
  }
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    if (!isRootObject && meta.textures[this.uuid] !== void 0) {
      return meta.textures[this.uuid];
    }
    const output = {
      metadata: {
        version: 4.5,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      mapping: this.mapping,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      type: this.type,
      encoding: this.encoding,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    if (this.image !== void 0) {
      const image2 = this.image;
      if (image2.uuid === void 0) {
        image2.uuid = generateUUID();
      }
      if (!isRootObject && meta.images[image2.uuid] === void 0) {
        let url;
        if (Array.isArray(image2)) {
          url = [];
          for (let i2 = 0, l2 = image2.length; i2 < l2; i2++) {
            if (image2[i2].isDataTexture) {
              url.push(serializeImage(image2[i2].image));
            } else {
              url.push(serializeImage(image2[i2]));
            }
          }
        } else {
          url = serializeImage(image2);
        }
        meta.images[image2.uuid] = {
          uuid: image2.uuid,
          url
        };
      }
      output.image = image2.uuid;
    }
    if (!isRootObject) {
      meta.textures[this.uuid] = output;
    }
    return output;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  transformUv(uv) {
    if (this.mapping !== UVMapping) return uv;
    uv.applyMatrix3(this.matrix);
    if (uv.x < 0 || uv.x > 1) {
      switch (this.wrapS) {
        case RepeatWrapping:
          uv.x = uv.x - Math.floor(uv.x);
          break;
        case ClampToEdgeWrapping:
          uv.x = uv.x < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          if (Math.abs(Math.floor(uv.x) % 2) === 1) {
            uv.x = Math.ceil(uv.x) - uv.x;
          } else {
            uv.x = uv.x - Math.floor(uv.x);
          }
          break;
      }
    }
    if (uv.y < 0 || uv.y > 1) {
      switch (this.wrapT) {
        case RepeatWrapping:
          uv.y = uv.y - Math.floor(uv.y);
          break;
        case ClampToEdgeWrapping:
          uv.y = uv.y < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          if (Math.abs(Math.floor(uv.y) % 2) === 1) {
            uv.y = Math.ceil(uv.y) - uv.y;
          } else {
            uv.y = uv.y - Math.floor(uv.y);
          }
          break;
      }
    }
    if (this.flipY) {
      uv.y = 1 - uv.y;
    }
    return uv;
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
}
Texture2.DEFAULT_IMAGE = void 0;
Texture2.DEFAULT_MAPPING = UVMapping;
Texture2.prototype.isTexture = true;
function serializeImage(image2) {
  if (typeof HTMLImageElement !== "undefined" && image2 instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image2 instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image2 instanceof ImageBitmap) {
    return ImageUtils2.getDataURL(image2);
  } else {
    if (image2.data) {
      return {
        data: Array.prototype.slice.call(image2.data),
        width: image2.width,
        height: image2.height,
        type: image2.data.constructor.name
      };
    } else {
      console.warn("THREE.Texture: Unable to serialize Texture.");
      return {};
    }
  }
}
class Vector42 {
  constructor(x = 0, y = 0, z2 = 0, w = 1) {
    this.x = x;
    this.y = y;
    this.z = z2;
    this.w = w;
  }
  get width() {
    return this.z;
  }
  set width(value) {
    this.z = value;
  }
  get height() {
    return this.w;
  }
  set height(value) {
    this.w = value;
  }
  set(x, y, z2, w) {
    this.x = x;
    this.y = y;
    this.z = z2;
    this.w = w;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    this.z = scalar;
    this.w = scalar;
    return this;
  }
  setX(x) {
    this.x = x;
    return this;
  }
  setY(y) {
    this.y = y;
    return this;
  }
  setZ(z2) {
    this.z = z2;
    return this;
  }
  setW(w) {
    this.w = w;
    return this;
  }
  setComponent(index2, value) {
    switch (index2) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      case 2:
        this.z = value;
        break;
      case 3:
        this.w = value;
        break;
      default:
        throw new Error("index is out of range: " + index2);
    }
    return this;
  }
  getComponent(index2) {
    switch (index2) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + index2);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(v) {
    this.x = v.x;
    this.y = v.y;
    this.z = v.z;
    this.w = v.w !== void 0 ? v.w : 1;
    return this;
  }
  add(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
      return this.addVectors(v, w);
    }
    this.x += v.x;
    this.y += v.y;
    this.z += v.z;
    this.w += v.w;
    return this;
  }
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    this.z += s2;
    this.w += s2;
    return this;
  }
  addVectors(a3, b) {
    this.x = a3.x + b.x;
    this.y = a3.y + b.y;
    this.z = a3.z + b.z;
    this.w = a3.w + b.w;
    return this;
  }
  addScaledVector(v, s2) {
    this.x += v.x * s2;
    this.y += v.y * s2;
    this.z += v.z * s2;
    this.w += v.w * s2;
    return this;
  }
  sub(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
      return this.subVectors(v, w);
    }
    this.x -= v.x;
    this.y -= v.y;
    this.z -= v.z;
    this.w -= v.w;
    return this;
  }
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    this.z -= s2;
    this.w -= s2;
    return this;
  }
  subVectors(a3, b) {
    this.x = a3.x - b.x;
    this.y = a3.y - b.y;
    this.z = a3.z - b.z;
    this.w = a3.w - b.w;
    return this;
  }
  multiply(v) {
    this.x *= v.x;
    this.y *= v.y;
    this.z *= v.z;
    this.w *= v.w;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;
    this.w *= scalar;
    return this;
  }
  applyMatrix4(m) {
    const x = this.x, y = this.y, z2 = this.z, w = this.w;
    const e2 = m.elements;
    this.x = e2[0] * x + e2[4] * y + e2[8] * z2 + e2[12] * w;
    this.y = e2[1] * x + e2[5] * y + e2[9] * z2 + e2[13] * w;
    this.z = e2[2] * x + e2[6] * y + e2[10] * z2 + e2[14] * w;
    this.w = e2[3] * x + e2[7] * y + e2[11] * z2 + e2[15] * w;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  setAxisAngleFromQuaternion(q) {
    this.w = 2 * Math.acos(q.w);
    const s2 = Math.sqrt(1 - q.w * q.w);
    if (s2 < 1e-4) {
      this.x = 1;
      this.y = 0;
      this.z = 0;
    } else {
      this.x = q.x / s2;
      this.y = q.y / s2;
      this.z = q.z / s2;
    }
    return this;
  }
  setAxisAngleFromRotationMatrix(m) {
    let angle2, x, y, z2;
    const epsilon = 0.01, epsilon2 = 0.1, te2 = m.elements, m11 = te2[0], m12 = te2[4], m13 = te2[8], m21 = te2[1], m22 = te2[5], m23 = te2[9], m31 = te2[2], m32 = te2[6], m33 = te2[10];
    if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
      if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
        this.set(1, 0, 0, 0);
        return this;
      }
      angle2 = Math.PI;
      const xx = (m11 + 1) / 2;
      const yy = (m22 + 1) / 2;
      const zz = (m33 + 1) / 2;
      const xy = (m12 + m21) / 4;
      const xz = (m13 + m31) / 4;
      const yz = (m23 + m32) / 4;
      if (xx > yy && xx > zz) {
        if (xx < epsilon) {
          x = 0;
          y = 0.707106781;
          z2 = 0.707106781;
        } else {
          x = Math.sqrt(xx);
          y = xy / x;
          z2 = xz / x;
        }
      } else if (yy > zz) {
        if (yy < epsilon) {
          x = 0.707106781;
          y = 0;
          z2 = 0.707106781;
        } else {
          y = Math.sqrt(yy);
          x = xy / y;
          z2 = yz / y;
        }
      } else {
        if (zz < epsilon) {
          x = 0.707106781;
          y = 0.707106781;
          z2 = 0;
        } else {
          z2 = Math.sqrt(zz);
          x = xz / z2;
          y = yz / z2;
        }
      }
      this.set(x, y, z2, angle2);
      return this;
    }
    let s2 = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12));
    if (Math.abs(s2) < 1e-3) s2 = 1;
    this.x = (m32 - m23) / s2;
    this.y = (m13 - m31) / s2;
    this.z = (m21 - m12) / s2;
    this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
    return this;
  }
  min(v) {
    this.x = Math.min(this.x, v.x);
    this.y = Math.min(this.y, v.y);
    this.z = Math.min(this.z, v.z);
    this.w = Math.min(this.w, v.w);
    return this;
  }
  max(v) {
    this.x = Math.max(this.x, v.x);
    this.y = Math.max(this.y, v.y);
    this.z = Math.max(this.z, v.z);
    this.w = Math.max(this.w, v.w);
    return this;
  }
  clamp(min, max2) {
    this.x = Math.max(min.x, Math.min(max2.x, this.x));
    this.y = Math.max(min.y, Math.min(max2.y, this.y));
    this.z = Math.max(min.z, Math.min(max2.z, this.z));
    this.w = Math.max(min.w, Math.min(max2.w, this.w));
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = Math.max(minVal, Math.min(maxVal, this.x));
    this.y = Math.max(minVal, Math.min(maxVal, this.y));
    this.z = Math.max(minVal, Math.min(maxVal, this.z));
    this.w = Math.max(minVal, Math.min(maxVal, this.w));
    return this;
  }
  clampLength(min, max2) {
    const length2 = this.length();
    return this.divideScalar(length2 || 1).multiplyScalar(Math.max(min, Math.min(max2, length2)));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    this.w = Math.floor(this.w);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    this.w = Math.ceil(this.w);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    this.w = Math.round(this.w);
    return this;
  }
  roundToZero() {
    this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
    this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
    this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
    this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    this.w = -this.w;
    return this;
  }
  dot(v) {
    return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(length2) {
    return this.normalize().multiplyScalar(length2);
  }
  lerp(v, alpha) {
    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    this.z += (v.z - this.z) * alpha;
    this.w += (v.w - this.w) * alpha;
    return this;
  }
  lerpVectors(v1, v2, alpha) {
    this.x = v1.x + (v2.x - v1.x) * alpha;
    this.y = v1.y + (v2.y - v1.y) * alpha;
    this.z = v1.z + (v2.z - v1.z) * alpha;
    this.w = v1.w + (v2.w - v1.w) * alpha;
    return this;
  }
  equals(v) {
    return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
  }
  fromArray(array, offset = 0) {
    this.x = array[offset];
    this.y = array[offset + 1];
    this.z = array[offset + 2];
    this.w = array[offset + 3];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.x;
    array[offset + 1] = this.y;
    array[offset + 2] = this.z;
    array[offset + 3] = this.w;
    return array;
  }
  fromBufferAttribute(attribute, index2, offset) {
    if (offset !== void 0) {
      console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute().");
    }
    this.x = attribute.getX(index2);
    this.y = attribute.getY(index2);
    this.z = attribute.getZ(index2);
    this.w = attribute.getW(index2);
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    this.z = Math.random();
    this.w = Math.random();
    return this;
  }
}
Vector42.prototype.isVector4 = true;
class WebGLRenderTarget2 extends EventDispatcher2 {
  constructor(width, height, options = {}) {
    super();
    this.width = width;
    this.height = height;
    this.depth = 1;
    this.scissor = new Vector42(0, 0, width, height);
    this.scissorTest = false;
    this.viewport = new Vector42(0, 0, width, height);
    this.texture = new Texture2(void 0, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
    this.texture.isRenderTargetTexture = true;
    this.texture.image = { width, height, depth: 1 };
    this.texture.generateMipmaps = options.generateMipmaps !== void 0 ? options.generateMipmaps : false;
    this.texture.internalFormat = options.internalFormat !== void 0 ? options.internalFormat : null;
    this.texture.minFilter = options.minFilter !== void 0 ? options.minFilter : LinearFilter;
    this.depthBuffer = options.depthBuffer !== void 0 ? options.depthBuffer : true;
    this.stencilBuffer = options.stencilBuffer !== void 0 ? options.stencilBuffer : false;
    this.depthTexture = options.depthTexture !== void 0 ? options.depthTexture : null;
  }
  setTexture(texture) {
    texture.image = {
      width: this.width,
      height: this.height,
      depth: this.depth
    };
    this.texture = texture;
  }
  setSize(width, height, depth = 1) {
    if (this.width !== width || this.height !== height || this.depth !== depth) {
      this.width = width;
      this.height = height;
      this.depth = depth;
      this.texture.image.width = width;
      this.texture.image.height = height;
      this.texture.image.depth = depth;
      this.dispose();
    }
    this.viewport.set(0, 0, width, height);
    this.scissor.set(0, 0, width, height);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.width = source.width;
    this.height = source.height;
    this.depth = source.depth;
    this.viewport.copy(source.viewport);
    this.texture = source.texture.clone();
    this.texture.image = { ...this.texture.image };
    this.depthBuffer = source.depthBuffer;
    this.stencilBuffer = source.stencilBuffer;
    this.depthTexture = source.depthTexture;
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
WebGLRenderTarget2.prototype.isWebGLRenderTarget = true;
class WebGLMultipleRenderTargets2 extends WebGLRenderTarget2 {
  constructor(width, height, count) {
    super(width, height);
    const texture = this.texture;
    this.texture = [];
    for (let i2 = 0; i2 < count; i2++) {
      this.texture[i2] = texture.clone();
    }
  }
  setSize(width, height, depth = 1) {
    if (this.width !== width || this.height !== height || this.depth !== depth) {
      this.width = width;
      this.height = height;
      this.depth = depth;
      for (let i2 = 0, il = this.texture.length; i2 < il; i2++) {
        this.texture[i2].image.width = width;
        this.texture[i2].image.height = height;
        this.texture[i2].image.depth = depth;
      }
      this.dispose();
    }
    this.viewport.set(0, 0, width, height);
    this.scissor.set(0, 0, width, height);
    return this;
  }
  copy(source) {
    this.dispose();
    this.width = source.width;
    this.height = source.height;
    this.depth = source.depth;
    this.viewport.set(0, 0, this.width, this.height);
    this.scissor.set(0, 0, this.width, this.height);
    this.depthBuffer = source.depthBuffer;
    this.stencilBuffer = source.stencilBuffer;
    this.depthTexture = source.depthTexture;
    this.texture.length = 0;
    for (let i2 = 0, il = source.texture.length; i2 < il; i2++) {
      this.texture[i2] = source.texture[i2].clone();
    }
    return this;
  }
}
WebGLMultipleRenderTargets2.prototype.isWebGLMultipleRenderTargets = true;
class WebGLMultisampleRenderTarget extends WebGLRenderTarget2 {
  constructor(width, height, options) {
    super(width, height, options);
    this.samples = 4;
  }
  copy(source) {
    super.copy.call(this, source);
    this.samples = source.samples;
    return this;
  }
}
WebGLMultisampleRenderTarget.prototype.isWebGLMultisampleRenderTarget = true;
class Quaternion2 {
  constructor(x = 0, y = 0, z2 = 0, w = 1) {
    this._x = x;
    this._y = y;
    this._z = z2;
    this._w = w;
  }
  static slerp(qa, qb, qm, t3) {
    console.warn("THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead.");
    return qm.slerpQuaternions(qa, qb, t3);
  }
  static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t3) {
    let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
    const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
    if (t3 === 0) {
      dst[dstOffset + 0] = x0;
      dst[dstOffset + 1] = y0;
      dst[dstOffset + 2] = z0;
      dst[dstOffset + 3] = w0;
      return;
    }
    if (t3 === 1) {
      dst[dstOffset + 0] = x1;
      dst[dstOffset + 1] = y1;
      dst[dstOffset + 2] = z1;
      dst[dstOffset + 3] = w1;
      return;
    }
    if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
      let s2 = 1 - t3;
      const cos2 = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos2 >= 0 ? 1 : -1, sqrSin = 1 - cos2 * cos2;
      if (sqrSin > Number.EPSILON) {
        const sin2 = Math.sqrt(sqrSin), len = Math.atan2(sin2, cos2 * dir);
        s2 = Math.sin(s2 * len) / sin2;
        t3 = Math.sin(t3 * len) / sin2;
      }
      const tDir = t3 * dir;
      x0 = x0 * s2 + x1 * tDir;
      y0 = y0 * s2 + y1 * tDir;
      z0 = z0 * s2 + z1 * tDir;
      w0 = w0 * s2 + w1 * tDir;
      if (s2 === 1 - t3) {
        const f2 = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
        x0 *= f2;
        y0 *= f2;
        z0 *= f2;
        w0 *= f2;
      }
    }
    dst[dstOffset] = x0;
    dst[dstOffset + 1] = y0;
    dst[dstOffset + 2] = z0;
    dst[dstOffset + 3] = w0;
  }
  static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
    const x0 = src0[srcOffset0];
    const y0 = src0[srcOffset0 + 1];
    const z0 = src0[srcOffset0 + 2];
    const w0 = src0[srcOffset0 + 3];
    const x1 = src1[srcOffset1];
    const y1 = src1[srcOffset1 + 1];
    const z1 = src1[srcOffset1 + 2];
    const w1 = src1[srcOffset1 + 3];
    dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
    dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
    dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
    dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
    return dst;
  }
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
    this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
    this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(value) {
    this._z = value;
    this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(value) {
    this._w = value;
    this._onChangeCallback();
  }
  set(x, y, z2, w) {
    this._x = x;
    this._y = y;
    this._z = z2;
    this._w = w;
    this._onChangeCallback();
    return this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(quaternion) {
    this._x = quaternion.x;
    this._y = quaternion.y;
    this._z = quaternion.z;
    this._w = quaternion.w;
    this._onChangeCallback();
    return this;
  }
  setFromEuler(euler, update) {
    if (!(euler && euler.isEuler)) {
      throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
    }
    const x = euler._x, y = euler._y, z2 = euler._z, order = euler._order;
    const cos2 = Math.cos;
    const sin2 = Math.sin;
    const c1 = cos2(x / 2);
    const c2 = cos2(y / 2);
    const c3 = cos2(z2 / 2);
    const s1 = sin2(x / 2);
    const s2 = sin2(y / 2);
    const s3 = sin2(z2 / 2);
    switch (order) {
      case "XYZ":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "YXZ":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      case "ZXY":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "ZYX":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      case "YZX":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "XZY":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
    }
    if (update !== false) this._onChangeCallback();
    return this;
  }
  setFromAxisAngle(axis, angle2) {
    const halfAngle = angle2 / 2, s2 = Math.sin(halfAngle);
    this._x = axis.x * s2;
    this._y = axis.y * s2;
    this._z = axis.z * s2;
    this._w = Math.cos(halfAngle);
    this._onChangeCallback();
    return this;
  }
  setFromRotationMatrix(m) {
    const te2 = m.elements, m11 = te2[0], m12 = te2[4], m13 = te2[8], m21 = te2[1], m22 = te2[5], m23 = te2[9], m31 = te2[2], m32 = te2[6], m33 = te2[10], trace = m11 + m22 + m33;
    if (trace > 0) {
      const s2 = 0.5 / Math.sqrt(trace + 1);
      this._w = 0.25 / s2;
      this._x = (m32 - m23) * s2;
      this._y = (m13 - m31) * s2;
      this._z = (m21 - m12) * s2;
    } else if (m11 > m22 && m11 > m33) {
      const s2 = 2 * Math.sqrt(1 + m11 - m22 - m33);
      this._w = (m32 - m23) / s2;
      this._x = 0.25 * s2;
      this._y = (m12 + m21) / s2;
      this._z = (m13 + m31) / s2;
    } else if (m22 > m33) {
      const s2 = 2 * Math.sqrt(1 + m22 - m11 - m33);
      this._w = (m13 - m31) / s2;
      this._x = (m12 + m21) / s2;
      this._y = 0.25 * s2;
      this._z = (m23 + m32) / s2;
    } else {
      const s2 = 2 * Math.sqrt(1 + m33 - m11 - m22);
      this._w = (m21 - m12) / s2;
      this._x = (m13 + m31) / s2;
      this._y = (m23 + m32) / s2;
      this._z = 0.25 * s2;
    }
    this._onChangeCallback();
    return this;
  }
  setFromUnitVectors(vFrom, vTo) {
    let r2 = vFrom.dot(vTo) + 1;
    if (r2 < Number.EPSILON) {
      r2 = 0;
      if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
        this._x = -vFrom.y;
        this._y = vFrom.x;
        this._z = 0;
        this._w = r2;
      } else {
        this._x = 0;
        this._y = -vFrom.z;
        this._z = vFrom.y;
        this._w = r2;
      }
    } else {
      this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
      this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
      this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
      this._w = r2;
    }
    return this.normalize();
  }
  angleTo(q) {
    return 2 * Math.acos(Math.abs(clamp(this.dot(q), -1, 1)));
  }
  rotateTowards(q, step) {
    const angle2 = this.angleTo(q);
    if (angle2 === 0) return this;
    const t3 = Math.min(1, step / angle2);
    this.slerp(q, t3);
    return this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    this._x *= -1;
    this._y *= -1;
    this._z *= -1;
    this._onChangeCallback();
    return this;
  }
  dot(v) {
    return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let l2 = this.length();
    if (l2 === 0) {
      this._x = 0;
      this._y = 0;
      this._z = 0;
      this._w = 1;
    } else {
      l2 = 1 / l2;
      this._x = this._x * l2;
      this._y = this._y * l2;
      this._z = this._z * l2;
      this._w = this._w * l2;
    }
    this._onChangeCallback();
    return this;
  }
  multiply(q, p2) {
    if (p2 !== void 0) {
      console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.");
      return this.multiplyQuaternions(q, p2);
    }
    return this.multiplyQuaternions(this, q);
  }
  premultiply(q) {
    return this.multiplyQuaternions(q, this);
  }
  multiplyQuaternions(a3, b) {
    const qax = a3._x, qay = a3._y, qaz = a3._z, qaw = a3._w;
    const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
    this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
    this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
    this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
    this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
    this._onChangeCallback();
    return this;
  }
  slerp(qb, t3) {
    if (t3 === 0) return this;
    if (t3 === 1) return this.copy(qb);
    const x = this._x, y = this._y, z2 = this._z, w = this._w;
    let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z2 * qb._z;
    if (cosHalfTheta < 0) {
      this._w = -qb._w;
      this._x = -qb._x;
      this._y = -qb._y;
      this._z = -qb._z;
      cosHalfTheta = -cosHalfTheta;
    } else {
      this.copy(qb);
    }
    if (cosHalfTheta >= 1) {
      this._w = w;
      this._x = x;
      this._y = y;
      this._z = z2;
      return this;
    }
    const sqrSinHalfTheta = 1 - cosHalfTheta * cosHalfTheta;
    if (sqrSinHalfTheta <= Number.EPSILON) {
      const s2 = 1 - t3;
      this._w = s2 * w + t3 * this._w;
      this._x = s2 * x + t3 * this._x;
      this._y = s2 * y + t3 * this._y;
      this._z = s2 * z2 + t3 * this._z;
      this.normalize();
      this._onChangeCallback();
      return this;
    }
    const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
    const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
    const ratioA = Math.sin((1 - t3) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t3 * halfTheta) / sinHalfTheta;
    this._w = w * ratioA + this._w * ratioB;
    this._x = x * ratioA + this._x * ratioB;
    this._y = y * ratioA + this._y * ratioB;
    this._z = z2 * ratioA + this._z * ratioB;
    this._onChangeCallback();
    return this;
  }
  slerpQuaternions(qa, qb, t3) {
    this.copy(qa).slerp(qb, t3);
  }
  equals(quaternion) {
    return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
  }
  fromArray(array, offset = 0) {
    this._x = array[offset];
    this._y = array[offset + 1];
    this._z = array[offset + 2];
    this._w = array[offset + 3];
    this._onChangeCallback();
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this._x;
    array[offset + 1] = this._y;
    array[offset + 2] = this._z;
    array[offset + 3] = this._w;
    return array;
  }
  fromBufferAttribute(attribute, index2) {
    this._x = attribute.getX(index2);
    this._y = attribute.getY(index2);
    this._z = attribute.getZ(index2);
    this._w = attribute.getW(index2);
    return this;
  }
  _onChange(callback) {
    this._onChangeCallback = callback;
    return this;
  }
  _onChangeCallback() {
  }
}
Quaternion2.prototype.isQuaternion = true;
class Vector32 {
  constructor(x = 0, y = 0, z2 = 0) {
    this.x = x;
    this.y = y;
    this.z = z2;
  }
  set(x, y, z2) {
    if (z2 === void 0) z2 = this.z;
    this.x = x;
    this.y = y;
    this.z = z2;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    this.z = scalar;
    return this;
  }
  setX(x) {
    this.x = x;
    return this;
  }
  setY(y) {
    this.y = y;
    return this;
  }
  setZ(z2) {
    this.z = z2;
    return this;
  }
  setComponent(index2, value) {
    switch (index2) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      case 2:
        this.z = value;
        break;
      default:
        throw new Error("index is out of range: " + index2);
    }
    return this;
  }
  getComponent(index2) {
    switch (index2) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + index2);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(v) {
    this.x = v.x;
    this.y = v.y;
    this.z = v.z;
    return this;
  }
  add(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
      return this.addVectors(v, w);
    }
    this.x += v.x;
    this.y += v.y;
    this.z += v.z;
    return this;
  }
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    this.z += s2;
    return this;
  }
  addVectors(a3, b) {
    this.x = a3.x + b.x;
    this.y = a3.y + b.y;
    this.z = a3.z + b.z;
    return this;
  }
  addScaledVector(v, s2) {
    this.x += v.x * s2;
    this.y += v.y * s2;
    this.z += v.z * s2;
    return this;
  }
  sub(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
      return this.subVectors(v, w);
    }
    this.x -= v.x;
    this.y -= v.y;
    this.z -= v.z;
    return this;
  }
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    this.z -= s2;
    return this;
  }
  subVectors(a3, b) {
    this.x = a3.x - b.x;
    this.y = a3.y - b.y;
    this.z = a3.z - b.z;
    return this;
  }
  multiply(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.");
      return this.multiplyVectors(v, w);
    }
    this.x *= v.x;
    this.y *= v.y;
    this.z *= v.z;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;
    return this;
  }
  multiplyVectors(a3, b) {
    this.x = a3.x * b.x;
    this.y = a3.y * b.y;
    this.z = a3.z * b.z;
    return this;
  }
  applyEuler(euler) {
    if (!(euler && euler.isEuler)) {
      console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.");
    }
    return this.applyQuaternion(_quaternion$4.setFromEuler(euler));
  }
  applyAxisAngle(axis, angle2) {
    return this.applyQuaternion(_quaternion$4.setFromAxisAngle(axis, angle2));
  }
  applyMatrix3(m) {
    const x = this.x, y = this.y, z2 = this.z;
    const e2 = m.elements;
    this.x = e2[0] * x + e2[3] * y + e2[6] * z2;
    this.y = e2[1] * x + e2[4] * y + e2[7] * z2;
    this.z = e2[2] * x + e2[5] * y + e2[8] * z2;
    return this;
  }
  applyNormalMatrix(m) {
    return this.applyMatrix3(m).normalize();
  }
  applyMatrix4(m) {
    const x = this.x, y = this.y, z2 = this.z;
    const e2 = m.elements;
    const w = 1 / (e2[3] * x + e2[7] * y + e2[11] * z2 + e2[15]);
    this.x = (e2[0] * x + e2[4] * y + e2[8] * z2 + e2[12]) * w;
    this.y = (e2[1] * x + e2[5] * y + e2[9] * z2 + e2[13]) * w;
    this.z = (e2[2] * x + e2[6] * y + e2[10] * z2 + e2[14]) * w;
    return this;
  }
  applyQuaternion(q) {
    const x = this.x, y = this.y, z2 = this.z;
    const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
    const ix = qw * x + qy * z2 - qz * y;
    const iy = qw * y + qz * x - qx * z2;
    const iz = qw * z2 + qx * y - qy * x;
    const iw = -qx * x - qy * y - qz * z2;
    this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    return this;
  }
  project(camera) {
    return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
  }
  unproject(camera) {
    return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
  }
  transformDirection(m) {
    const x = this.x, y = this.y, z2 = this.z;
    const e2 = m.elements;
    this.x = e2[0] * x + e2[4] * y + e2[8] * z2;
    this.y = e2[1] * x + e2[5] * y + e2[9] * z2;
    this.z = e2[2] * x + e2[6] * y + e2[10] * z2;
    return this.normalize();
  }
  divide(v) {
    this.x /= v.x;
    this.y /= v.y;
    this.z /= v.z;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  min(v) {
    this.x = Math.min(this.x, v.x);
    this.y = Math.min(this.y, v.y);
    this.z = Math.min(this.z, v.z);
    return this;
  }
  max(v) {
    this.x = Math.max(this.x, v.x);
    this.y = Math.max(this.y, v.y);
    this.z = Math.max(this.z, v.z);
    return this;
  }
  clamp(min, max2) {
    this.x = Math.max(min.x, Math.min(max2.x, this.x));
    this.y = Math.max(min.y, Math.min(max2.y, this.y));
    this.z = Math.max(min.z, Math.min(max2.z, this.z));
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = Math.max(minVal, Math.min(maxVal, this.x));
    this.y = Math.max(minVal, Math.min(maxVal, this.y));
    this.z = Math.max(minVal, Math.min(maxVal, this.z));
    return this;
  }
  clampLength(min, max2) {
    const length2 = this.length();
    return this.divideScalar(length2 || 1).multiplyScalar(Math.max(min, Math.min(max2, length2)));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    return this;
  }
  roundToZero() {
    this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
    this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
    this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    return this;
  }
  dot(v) {
    return this.x * v.x + this.y * v.y + this.z * v.z;
  }
  // TODO lengthSquared?
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(length2) {
    return this.normalize().multiplyScalar(length2);
  }
  lerp(v, alpha) {
    this.x += (v.x - this.x) * alpha;
    this.y += (v.y - this.y) * alpha;
    this.z += (v.z - this.z) * alpha;
    return this;
  }
  lerpVectors(v1, v2, alpha) {
    this.x = v1.x + (v2.x - v1.x) * alpha;
    this.y = v1.y + (v2.y - v1.y) * alpha;
    this.z = v1.z + (v2.z - v1.z) * alpha;
    return this;
  }
  cross(v, w) {
    if (w !== void 0) {
      console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.");
      return this.crossVectors(v, w);
    }
    return this.crossVectors(this, v);
  }
  crossVectors(a3, b) {
    const ax = a3.x, ay = a3.y, az = a3.z;
    const bx = b.x, by = b.y, bz = b.z;
    this.x = ay * bz - az * by;
    this.y = az * bx - ax * bz;
    this.z = ax * by - ay * bx;
    return this;
  }
  projectOnVector(v) {
    const denominator = v.lengthSq();
    if (denominator === 0) return this.set(0, 0, 0);
    const scalar = v.dot(this) / denominator;
    return this.copy(v).multiplyScalar(scalar);
  }
  projectOnPlane(planeNormal) {
    _vector$c.copy(this).projectOnVector(planeNormal);
    return this.sub(_vector$c);
  }
  reflect(normal) {
    return this.sub(_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
  }
  angleTo(v) {
    const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
    if (denominator === 0) return Math.PI / 2;
    const theta = this.dot(v) / denominator;
    return Math.acos(clamp(theta, -1, 1));
  }
  distanceTo(v) {
    return Math.sqrt(this.distanceToSquared(v));
  }
  distanceToSquared(v) {
    const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
    return dx * dx + dy * dy + dz * dz;
  }
  manhattanDistanceTo(v) {
    return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
  }
  setFromSpherical(s2) {
    return this.setFromSphericalCoords(s2.radius, s2.phi, s2.theta);
  }
  setFromSphericalCoords(radius, phi, theta) {
    const sinPhiRadius = Math.sin(phi) * radius;
    this.x = sinPhiRadius * Math.sin(theta);
    this.y = Math.cos(phi) * radius;
    this.z = sinPhiRadius * Math.cos(theta);
    return this;
  }
  setFromCylindrical(c2) {
    return this.setFromCylindricalCoords(c2.radius, c2.theta, c2.y);
  }
  setFromCylindricalCoords(radius, theta, y) {
    this.x = radius * Math.sin(theta);
    this.y = y;
    this.z = radius * Math.cos(theta);
    return this;
  }
  setFromMatrixPosition(m) {
    const e2 = m.elements;
    this.x = e2[12];
    this.y = e2[13];
    this.z = e2[14];
    return this;
  }
  setFromMatrixScale(m) {
    const sx = this.setFromMatrixColumn(m, 0).length();
    const sy = this.setFromMatrixColumn(m, 1).length();
    const sz = this.setFromMatrixColumn(m, 2).length();
    this.x = sx;
    this.y = sy;
    this.z = sz;
    return this;
  }
  setFromMatrixColumn(m, index2) {
    return this.fromArray(m.elements, index2 * 4);
  }
  setFromMatrix3Column(m, index2) {
    return this.fromArray(m.elements, index2 * 3);
  }
  equals(v) {
    return v.x === this.x && v.y === this.y && v.z === this.z;
  }
  fromArray(array, offset = 0) {
    this.x = array[offset];
    this.y = array[offset + 1];
    this.z = array[offset + 2];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.x;
    array[offset + 1] = this.y;
    array[offset + 2] = this.z;
    return array;
  }
  fromBufferAttribute(attribute, index2, offset) {
    if (offset !== void 0) {
      console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute().");
    }
    this.x = attribute.getX(index2);
    this.y = attribute.getY(index2);
    this.z = attribute.getZ(index2);
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    this.z = Math.random();
    return this;
  }
}
Vector32.prototype.isVector3 = true;
const _vector$c = /* @__PURE__ */ new Vector32();
const _quaternion$4 = /* @__PURE__ */ new Quaternion2();
class Box32 {
  constructor(min = new Vector32(Infinity, Infinity, Infinity), max2 = new Vector32(-Infinity, -Infinity, -Infinity)) {
    this.min = min;
    this.max = max2;
  }
  set(min, max2) {
    this.min.copy(min);
    this.max.copy(max2);
    return this;
  }
  setFromArray(array) {
    let minX = Infinity;
    let minY = Infinity;
    let minZ = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    let maxZ = -Infinity;
    for (let i2 = 0, l2 = array.length; i2 < l2; i2 += 3) {
      const x = array[i2];
      const y = array[i2 + 1];
      const z2 = array[i2 + 2];
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (z2 < minZ) minZ = z2;
      if (x > maxX) maxX = x;
      if (y > maxY) maxY = y;
      if (z2 > maxZ) maxZ = z2;
    }
    this.min.set(minX, minY, minZ);
    this.max.set(maxX, maxY, maxZ);
    return this;
  }
  setFromBufferAttribute(attribute) {
    let minX = Infinity;
    let minY = Infinity;
    let minZ = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    let maxZ = -Infinity;
    for (let i2 = 0, l2 = attribute.count; i2 < l2; i2++) {
      const x = attribute.getX(i2);
      const y = attribute.getY(i2);
      const z2 = attribute.getZ(i2);
      if (x < minX) minX = x;
      if (y < minY) minY = y;
      if (z2 < minZ) minZ = z2;
      if (x > maxX) maxX = x;
      if (y > maxY) maxY = y;
      if (z2 > maxZ) maxZ = z2;
    }
    this.min.set(minX, minY, minZ);
    this.max.set(maxX, maxY, maxZ);
    return this;
  }
  setFromPoints(points) {
    this.makeEmpty();
    for (let i2 = 0, il = points.length; i2 < il; i2++) {
      this.expandByPoint(points[i2]);
    }
    return this;
  }
  setFromCenterAndSize(center, size) {
    const halfSize = _vector$b.copy(size).multiplyScalar(0.5);
    this.min.copy(center).sub(halfSize);
    this.max.copy(center).add(halfSize);
    return this;
  }
  setFromObject(object) {
    this.makeEmpty();
    return this.expandByObject(object);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(box) {
    this.min.copy(box.min);
    this.max.copy(box.max);
    return this;
  }
  makeEmpty() {
    this.min.x = this.min.y = this.min.z = Infinity;
    this.max.x = this.max.y = this.max.z = -Infinity;
    return this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(target) {
    return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(target) {
    return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
  }
  expandByPoint(point2) {
    this.min.min(point2);
    this.max.max(point2);
    return this;
  }
  expandByVector(vector) {
    this.min.sub(vector);
    this.max.add(vector);
    return this;
  }
  expandByScalar(scalar) {
    this.min.addScalar(-scalar);
    this.max.addScalar(scalar);
    return this;
  }
  expandByObject(object) {
    object.updateWorldMatrix(false, false);
    const geometry = object.geometry;
    if (geometry !== void 0) {
      if (geometry.boundingBox === null) {
        geometry.computeBoundingBox();
      }
      _box$3.copy(geometry.boundingBox);
      _box$3.applyMatrix4(object.matrixWorld);
      this.union(_box$3);
    }
    const children = object.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      this.expandByObject(children[i2]);
    }
    return this;
  }
  containsPoint(point2) {
    return point2.x < this.min.x || point2.x > this.max.x || point2.y < this.min.y || point2.y > this.max.y || point2.z < this.min.z || point2.z > this.max.z ? false : true;
  }
  containsBox(box) {
    return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
  }
  getParameter(point2, target) {
    return target.set(
      (point2.x - this.min.x) / (this.max.x - this.min.x),
      (point2.y - this.min.y) / (this.max.y - this.min.y),
      (point2.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  intersectsBox(box) {
    return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
  }
  intersectsSphere(sphere) {
    this.clampPoint(sphere.center, _vector$b);
    return _vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
  }
  intersectsPlane(plane) {
    let min, max2;
    if (plane.normal.x > 0) {
      min = plane.normal.x * this.min.x;
      max2 = plane.normal.x * this.max.x;
    } else {
      min = plane.normal.x * this.max.x;
      max2 = plane.normal.x * this.min.x;
    }
    if (plane.normal.y > 0) {
      min += plane.normal.y * this.min.y;
      max2 += plane.normal.y * this.max.y;
    } else {
      min += plane.normal.y * this.max.y;
      max2 += plane.normal.y * this.min.y;
    }
    if (plane.normal.z > 0) {
      min += plane.normal.z * this.min.z;
      max2 += plane.normal.z * this.max.z;
    } else {
      min += plane.normal.z * this.max.z;
      max2 += plane.normal.z * this.min.z;
    }
    return min <= -plane.constant && max2 >= -plane.constant;
  }
  intersectsTriangle(triangle3) {
    if (this.isEmpty()) {
      return false;
    }
    this.getCenter(_center);
    _extents.subVectors(this.max, _center);
    _v0$2.subVectors(triangle3.a, _center);
    _v1$7.subVectors(triangle3.b, _center);
    _v2$3.subVectors(triangle3.c, _center);
    _f0.subVectors(_v1$7, _v0$2);
    _f1.subVectors(_v2$3, _v1$7);
    _f2.subVectors(_v0$2, _v2$3);
    let axes = [
      0,
      -_f0.z,
      _f0.y,
      0,
      -_f1.z,
      _f1.y,
      0,
      -_f2.z,
      _f2.y,
      _f0.z,
      0,
      -_f0.x,
      _f1.z,
      0,
      -_f1.x,
      _f2.z,
      0,
      -_f2.x,
      -_f0.y,
      _f0.x,
      0,
      -_f1.y,
      _f1.x,
      0,
      -_f2.y,
      _f2.x,
      0
    ];
    if (!satForAxes(axes, _v0$2, _v1$7, _v2$3, _extents)) {
      return false;
    }
    axes = [1, 0, 0, 0, 1, 0, 0, 0, 1];
    if (!satForAxes(axes, _v0$2, _v1$7, _v2$3, _extents)) {
      return false;
    }
    _triangleNormal.crossVectors(_f0, _f1);
    axes = [_triangleNormal.x, _triangleNormal.y, _triangleNormal.z];
    return satForAxes(axes, _v0$2, _v1$7, _v2$3, _extents);
  }
  clampPoint(point2, target) {
    return target.copy(point2).clamp(this.min, this.max);
  }
  distanceToPoint(point2) {
    const clampedPoint = _vector$b.copy(point2).clamp(this.min, this.max);
    return clampedPoint.sub(point2).length();
  }
  getBoundingSphere(target) {
    this.getCenter(target.center);
    target.radius = this.getSize(_vector$b).length() * 0.5;
    return target;
  }
  intersect(box) {
    this.min.max(box.min);
    this.max.min(box.max);
    if (this.isEmpty()) this.makeEmpty();
    return this;
  }
  union(box) {
    this.min.min(box.min);
    this.max.max(box.max);
    return this;
  }
  applyMatrix4(matrix2) {
    if (this.isEmpty()) return this;
    _points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix2);
    _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix2);
    _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix2);
    _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix2);
    _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix2);
    _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix2);
    _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix2);
    _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix2);
    this.setFromPoints(_points);
    return this;
  }
  translate(offset) {
    this.min.add(offset);
    this.max.add(offset);
    return this;
  }
  equals(box) {
    return box.min.equals(this.min) && box.max.equals(this.max);
  }
}
Box32.prototype.isBox3 = true;
const _points = [
  /* @__PURE__ */ new Vector32(),
  /* @__PURE__ */ new Vector32(),
  /* @__PURE__ */ new Vector32(),
  /* @__PURE__ */ new Vector32(),
  /* @__PURE__ */ new Vector32(),
  /* @__PURE__ */ new Vector32(),
  /* @__PURE__ */ new Vector32(),
  /* @__PURE__ */ new Vector32()
];
const _vector$b = /* @__PURE__ */ new Vector32();
const _box$3 = /* @__PURE__ */ new Box32();
const _v0$2 = /* @__PURE__ */ new Vector32();
const _v1$7 = /* @__PURE__ */ new Vector32();
const _v2$3 = /* @__PURE__ */ new Vector32();
const _f0 = /* @__PURE__ */ new Vector32();
const _f1 = /* @__PURE__ */ new Vector32();
const _f2 = /* @__PURE__ */ new Vector32();
const _center = /* @__PURE__ */ new Vector32();
const _extents = /* @__PURE__ */ new Vector32();
const _triangleNormal = /* @__PURE__ */ new Vector32();
const _testAxis = /* @__PURE__ */ new Vector32();
function satForAxes(axes, v0, v1, v2, extents) {
  for (let i2 = 0, j = axes.length - 3; i2 <= j; i2 += 3) {
    _testAxis.fromArray(axes, i2);
    const r2 = extents.x * Math.abs(_testAxis.x) + extents.y * Math.abs(_testAxis.y) + extents.z * Math.abs(_testAxis.z);
    const p0 = v0.dot(_testAxis);
    const p1 = v1.dot(_testAxis);
    const p2 = v2.dot(_testAxis);
    if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r2) {
      return false;
    }
  }
  return true;
}
const _box$2 = /* @__PURE__ */ new Box32();
const _v1$6 = /* @__PURE__ */ new Vector32();
const _toFarthestPoint = /* @__PURE__ */ new Vector32();
const _toPoint = /* @__PURE__ */ new Vector32();
class Sphere2 {
  constructor(center = new Vector32(), radius = -1) {
    this.center = center;
    this.radius = radius;
  }
  set(center, radius) {
    this.center.copy(center);
    this.radius = radius;
    return this;
  }
  setFromPoints(points, optionalCenter) {
    const center = this.center;
    if (optionalCenter !== void 0) {
      center.copy(optionalCenter);
    } else {
      _box$2.setFromPoints(points).getCenter(center);
    }
    let maxRadiusSq = 0;
    for (let i2 = 0, il = points.length; i2 < il; i2++) {
      maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i2]));
    }
    this.radius = Math.sqrt(maxRadiusSq);
    return this;
  }
  copy(sphere) {
    this.center.copy(sphere.center);
    this.radius = sphere.radius;
    return this;
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    this.center.set(0, 0, 0);
    this.radius = -1;
    return this;
  }
  containsPoint(point2) {
    return point2.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(point2) {
    return point2.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(sphere) {
    const radiusSum = this.radius + sphere.radius;
    return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
  }
  intersectsBox(box) {
    return box.intersectsSphere(this);
  }
  intersectsPlane(plane) {
    return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(point2, target) {
    const deltaLengthSq = this.center.distanceToSquared(point2);
    target.copy(point2);
    if (deltaLengthSq > this.radius * this.radius) {
      target.sub(this.center).normalize();
      target.multiplyScalar(this.radius).add(this.center);
    }
    return target;
  }
  getBoundingBox(target) {
    if (this.isEmpty()) {
      target.makeEmpty();
      return target;
    }
    target.set(this.center, this.center);
    target.expandByScalar(this.radius);
    return target;
  }
  applyMatrix4(matrix2) {
    this.center.applyMatrix4(matrix2);
    this.radius = this.radius * matrix2.getMaxScaleOnAxis();
    return this;
  }
  translate(offset) {
    this.center.add(offset);
    return this;
  }
  expandByPoint(point2) {
    _toPoint.subVectors(point2, this.center);
    const lengthSq = _toPoint.lengthSq();
    if (lengthSq > this.radius * this.radius) {
      const length2 = Math.sqrt(lengthSq);
      const missingRadiusHalf = (length2 - this.radius) * 0.5;
      this.center.add(_toPoint.multiplyScalar(missingRadiusHalf / length2));
      this.radius += missingRadiusHalf;
    }
    return this;
  }
  union(sphere) {
    _toFarthestPoint.subVectors(sphere.center, this.center).normalize().multiplyScalar(sphere.radius);
    this.expandByPoint(_v1$6.copy(sphere.center).add(_toFarthestPoint));
    this.expandByPoint(_v1$6.copy(sphere.center).sub(_toFarthestPoint));
    return this;
  }
  equals(sphere) {
    return sphere.center.equals(this.center) && sphere.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _vector$a = /* @__PURE__ */ new Vector32();
const _segCenter = /* @__PURE__ */ new Vector32();
const _segDir = /* @__PURE__ */ new Vector32();
const _diff = /* @__PURE__ */ new Vector32();
const _edge1 = /* @__PURE__ */ new Vector32();
const _edge2 = /* @__PURE__ */ new Vector32();
const _normal$1 = /* @__PURE__ */ new Vector32();
class Ray2 {
  constructor(origin = new Vector32(), direction2 = new Vector32(0, 0, -1)) {
    this.origin = origin;
    this.direction = direction2;
  }
  set(origin, direction2) {
    this.origin.copy(origin);
    this.direction.copy(direction2);
    return this;
  }
  copy(ray2) {
    this.origin.copy(ray2.origin);
    this.direction.copy(ray2.direction);
    return this;
  }
  at(t3, target) {
    return target.copy(this.direction).multiplyScalar(t3).add(this.origin);
  }
  lookAt(v) {
    this.direction.copy(v).sub(this.origin).normalize();
    return this;
  }
  recast(t3) {
    this.origin.copy(this.at(t3, _vector$a));
    return this;
  }
  closestPointToPoint(point2, target) {
    target.subVectors(point2, this.origin);
    const directionDistance = target.dot(this.direction);
    if (directionDistance < 0) {
      return target.copy(this.origin);
    }
    return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
  }
  distanceToPoint(point2) {
    return Math.sqrt(this.distanceSqToPoint(point2));
  }
  distanceSqToPoint(point2) {
    const directionDistance = _vector$a.subVectors(point2, this.origin).dot(this.direction);
    if (directionDistance < 0) {
      return this.origin.distanceToSquared(point2);
    }
    _vector$a.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    return _vector$a.distanceToSquared(point2);
  }
  distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
    _segCenter.copy(v0).add(v1).multiplyScalar(0.5);
    _segDir.copy(v1).sub(v0).normalize();
    _diff.copy(this.origin).sub(_segCenter);
    const segExtent = v0.distanceTo(v1) * 0.5;
    const a01 = -this.direction.dot(_segDir);
    const b0 = _diff.dot(this.direction);
    const b1 = -_diff.dot(_segDir);
    const c2 = _diff.lengthSq();
    const det = Math.abs(1 - a01 * a01);
    let s0, s1, sqrDist, extDet;
    if (det > 0) {
      s0 = a01 * b1 - b0;
      s1 = a01 * b0 - b1;
      extDet = segExtent * det;
      if (s0 >= 0) {
        if (s1 >= -extDet) {
          if (s1 <= extDet) {
            const invDet = 1 / det;
            s0 *= invDet;
            s1 *= invDet;
            sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c2;
          } else {
            s1 = segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
          }
        } else {
          s1 = -segExtent;
          s0 = Math.max(0, -(a01 * s1 + b0));
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
        }
      } else {
        if (s1 <= -extDet) {
          s0 = Math.max(0, -(-a01 * segExtent + b0));
          s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
        } else if (s1 <= extDet) {
          s0 = 0;
          s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = s1 * (s1 + 2 * b1) + c2;
        } else {
          s0 = Math.max(0, -(a01 * segExtent + b0));
          s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
        }
      }
    } else {
      s1 = a01 > 0 ? -segExtent : segExtent;
      s0 = Math.max(0, -(a01 * s1 + b0));
      sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
    }
    if (optionalPointOnRay) {
      optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
    }
    if (optionalPointOnSegment) {
      optionalPointOnSegment.copy(_segDir).multiplyScalar(s1).add(_segCenter);
    }
    return sqrDist;
  }
  intersectSphere(sphere, target) {
    _vector$a.subVectors(sphere.center, this.origin);
    const tca = _vector$a.dot(this.direction);
    const d2 = _vector$a.dot(_vector$a) - tca * tca;
    const radius2 = sphere.radius * sphere.radius;
    if (d2 > radius2) return null;
    const thc = Math.sqrt(radius2 - d2);
    const t0 = tca - thc;
    const t1 = tca + thc;
    if (t0 < 0 && t1 < 0) return null;
    if (t0 < 0) return this.at(t1, target);
    return this.at(t0, target);
  }
  intersectsSphere(sphere) {
    return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
  }
  distanceToPlane(plane) {
    const denominator = plane.normal.dot(this.direction);
    if (denominator === 0) {
      if (plane.distanceToPoint(this.origin) === 0) {
        return 0;
      }
      return null;
    }
    const t3 = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
    return t3 >= 0 ? t3 : null;
  }
  intersectPlane(plane, target) {
    const t3 = this.distanceToPlane(plane);
    if (t3 === null) {
      return null;
    }
    return this.at(t3, target);
  }
  intersectsPlane(plane) {
    const distToPoint = plane.distanceToPoint(this.origin);
    if (distToPoint === 0) {
      return true;
    }
    const denominator = plane.normal.dot(this.direction);
    if (denominator * distToPoint < 0) {
      return true;
    }
    return false;
  }
  intersectBox(box, target) {
    let tmin, tmax, tymin, tymax, tzmin, tzmax;
    const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
    const origin = this.origin;
    if (invdirx >= 0) {
      tmin = (box.min.x - origin.x) * invdirx;
      tmax = (box.max.x - origin.x) * invdirx;
    } else {
      tmin = (box.max.x - origin.x) * invdirx;
      tmax = (box.min.x - origin.x) * invdirx;
    }
    if (invdiry >= 0) {
      tymin = (box.min.y - origin.y) * invdiry;
      tymax = (box.max.y - origin.y) * invdiry;
    } else {
      tymin = (box.max.y - origin.y) * invdiry;
      tymax = (box.min.y - origin.y) * invdiry;
    }
    if (tmin > tymax || tymin > tmax) return null;
    if (tymin > tmin || tmin !== tmin) tmin = tymin;
    if (tymax < tmax || tmax !== tmax) tmax = tymax;
    if (invdirz >= 0) {
      tzmin = (box.min.z - origin.z) * invdirz;
      tzmax = (box.max.z - origin.z) * invdirz;
    } else {
      tzmin = (box.max.z - origin.z) * invdirz;
      tzmax = (box.min.z - origin.z) * invdirz;
    }
    if (tmin > tzmax || tzmin > tmax) return null;
    if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
    if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
    if (tmax < 0) return null;
    return this.at(tmin >= 0 ? tmin : tmax, target);
  }
  intersectsBox(box) {
    return this.intersectBox(box, _vector$a) !== null;
  }
  intersectTriangle(a3, b, c2, backfaceCulling, target) {
    _edge1.subVectors(b, a3);
    _edge2.subVectors(c2, a3);
    _normal$1.crossVectors(_edge1, _edge2);
    let DdN = this.direction.dot(_normal$1);
    let sign2;
    if (DdN > 0) {
      if (backfaceCulling) return null;
      sign2 = 1;
    } else if (DdN < 0) {
      sign2 = -1;
      DdN = -DdN;
    } else {
      return null;
    }
    _diff.subVectors(this.origin, a3);
    const DdQxE2 = sign2 * this.direction.dot(_edge2.crossVectors(_diff, _edge2));
    if (DdQxE2 < 0) {
      return null;
    }
    const DdE1xQ = sign2 * this.direction.dot(_edge1.cross(_diff));
    if (DdE1xQ < 0) {
      return null;
    }
    if (DdQxE2 + DdE1xQ > DdN) {
      return null;
    }
    const QdN = -sign2 * _diff.dot(_normal$1);
    if (QdN < 0) {
      return null;
    }
    return this.at(QdN / DdN, target);
  }
  applyMatrix4(matrix4) {
    this.origin.applyMatrix4(matrix4);
    this.direction.transformDirection(matrix4);
    return this;
  }
  equals(ray2) {
    return ray2.origin.equals(this.origin) && ray2.direction.equals(this.direction);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Matrix42 {
  constructor() {
    this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ];
    if (arguments.length > 0) {
      console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
    }
  }
  set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
    const te2 = this.elements;
    te2[0] = n11;
    te2[4] = n12;
    te2[8] = n13;
    te2[12] = n14;
    te2[1] = n21;
    te2[5] = n22;
    te2[9] = n23;
    te2[13] = n24;
    te2[2] = n31;
    te2[6] = n32;
    te2[10] = n33;
    te2[14] = n34;
    te2[3] = n41;
    te2[7] = n42;
    te2[11] = n43;
    te2[15] = n44;
    return this;
  }
  identity() {
    this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  clone() {
    return new Matrix42().fromArray(this.elements);
  }
  copy(m) {
    const te2 = this.elements;
    const me = m.elements;
    te2[0] = me[0];
    te2[1] = me[1];
    te2[2] = me[2];
    te2[3] = me[3];
    te2[4] = me[4];
    te2[5] = me[5];
    te2[6] = me[6];
    te2[7] = me[7];
    te2[8] = me[8];
    te2[9] = me[9];
    te2[10] = me[10];
    te2[11] = me[11];
    te2[12] = me[12];
    te2[13] = me[13];
    te2[14] = me[14];
    te2[15] = me[15];
    return this;
  }
  copyPosition(m) {
    const te2 = this.elements, me = m.elements;
    te2[12] = me[12];
    te2[13] = me[13];
    te2[14] = me[14];
    return this;
  }
  setFromMatrix3(m) {
    const me = m.elements;
    this.set(
      me[0],
      me[3],
      me[6],
      0,
      me[1],
      me[4],
      me[7],
      0,
      me[2],
      me[5],
      me[8],
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  extractBasis(xAxis, yAxis, zAxis) {
    xAxis.setFromMatrixColumn(this, 0);
    yAxis.setFromMatrixColumn(this, 1);
    zAxis.setFromMatrixColumn(this, 2);
    return this;
  }
  makeBasis(xAxis, yAxis, zAxis) {
    this.set(
      xAxis.x,
      yAxis.x,
      zAxis.x,
      0,
      xAxis.y,
      yAxis.y,
      zAxis.y,
      0,
      xAxis.z,
      yAxis.z,
      zAxis.z,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  extractRotation(m) {
    const te2 = this.elements;
    const me = m.elements;
    const scaleX = 1 / _v1$5.setFromMatrixColumn(m, 0).length();
    const scaleY = 1 / _v1$5.setFromMatrixColumn(m, 1).length();
    const scaleZ = 1 / _v1$5.setFromMatrixColumn(m, 2).length();
    te2[0] = me[0] * scaleX;
    te2[1] = me[1] * scaleX;
    te2[2] = me[2] * scaleX;
    te2[3] = 0;
    te2[4] = me[4] * scaleY;
    te2[5] = me[5] * scaleY;
    te2[6] = me[6] * scaleY;
    te2[7] = 0;
    te2[8] = me[8] * scaleZ;
    te2[9] = me[9] * scaleZ;
    te2[10] = me[10] * scaleZ;
    te2[11] = 0;
    te2[12] = 0;
    te2[13] = 0;
    te2[14] = 0;
    te2[15] = 1;
    return this;
  }
  makeRotationFromEuler(euler) {
    if (!(euler && euler.isEuler)) {
      console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
    }
    const te2 = this.elements;
    const x = euler.x, y = euler.y, z2 = euler.z;
    const a3 = Math.cos(x), b = Math.sin(x);
    const c2 = Math.cos(y), d2 = Math.sin(y);
    const e2 = Math.cos(z2), f2 = Math.sin(z2);
    if (euler.order === "XYZ") {
      const ae2 = a3 * e2, af = a3 * f2, be = b * e2, bf = b * f2;
      te2[0] = c2 * e2;
      te2[4] = -c2 * f2;
      te2[8] = d2;
      te2[1] = af + be * d2;
      te2[5] = ae2 - bf * d2;
      te2[9] = -b * c2;
      te2[2] = bf - ae2 * d2;
      te2[6] = be + af * d2;
      te2[10] = a3 * c2;
    } else if (euler.order === "YXZ") {
      const ce = c2 * e2, cf = c2 * f2, de = d2 * e2, df = d2 * f2;
      te2[0] = ce + df * b;
      te2[4] = de * b - cf;
      te2[8] = a3 * d2;
      te2[1] = a3 * f2;
      te2[5] = a3 * e2;
      te2[9] = -b;
      te2[2] = cf * b - de;
      te2[6] = df + ce * b;
      te2[10] = a3 * c2;
    } else if (euler.order === "ZXY") {
      const ce = c2 * e2, cf = c2 * f2, de = d2 * e2, df = d2 * f2;
      te2[0] = ce - df * b;
      te2[4] = -a3 * f2;
      te2[8] = de + cf * b;
      te2[1] = cf + de * b;
      te2[5] = a3 * e2;
      te2[9] = df - ce * b;
      te2[2] = -a3 * d2;
      te2[6] = b;
      te2[10] = a3 * c2;
    } else if (euler.order === "ZYX") {
      const ae2 = a3 * e2, af = a3 * f2, be = b * e2, bf = b * f2;
      te2[0] = c2 * e2;
      te2[4] = be * d2 - af;
      te2[8] = ae2 * d2 + bf;
      te2[1] = c2 * f2;
      te2[5] = bf * d2 + ae2;
      te2[9] = af * d2 - be;
      te2[2] = -d2;
      te2[6] = b * c2;
      te2[10] = a3 * c2;
    } else if (euler.order === "YZX") {
      const ac = a3 * c2, ad = a3 * d2, bc = b * c2, bd = b * d2;
      te2[0] = c2 * e2;
      te2[4] = bd - ac * f2;
      te2[8] = bc * f2 + ad;
      te2[1] = f2;
      te2[5] = a3 * e2;
      te2[9] = -b * e2;
      te2[2] = -d2 * e2;
      te2[6] = ad * f2 + bc;
      te2[10] = ac - bd * f2;
    } else if (euler.order === "XZY") {
      const ac = a3 * c2, ad = a3 * d2, bc = b * c2, bd = b * d2;
      te2[0] = c2 * e2;
      te2[4] = -f2;
      te2[8] = d2 * e2;
      te2[1] = ac * f2 + bd;
      te2[5] = a3 * e2;
      te2[9] = ad * f2 - bc;
      te2[2] = bc * f2 - ad;
      te2[6] = b * e2;
      te2[10] = bd * f2 + ac;
    }
    te2[3] = 0;
    te2[7] = 0;
    te2[11] = 0;
    te2[12] = 0;
    te2[13] = 0;
    te2[14] = 0;
    te2[15] = 1;
    return this;
  }
  makeRotationFromQuaternion(q) {
    return this.compose(_zero, q, _one);
  }
  lookAt(eye, target, up) {
    const te2 = this.elements;
    _z.subVectors(eye, target);
    if (_z.lengthSq() === 0) {
      _z.z = 1;
    }
    _z.normalize();
    _x.crossVectors(up, _z);
    if (_x.lengthSq() === 0) {
      if (Math.abs(up.z) === 1) {
        _z.x += 1e-4;
      } else {
        _z.z += 1e-4;
      }
      _z.normalize();
      _x.crossVectors(up, _z);
    }
    _x.normalize();
    _y.crossVectors(_z, _x);
    te2[0] = _x.x;
    te2[4] = _y.x;
    te2[8] = _z.x;
    te2[1] = _x.y;
    te2[5] = _y.y;
    te2[9] = _z.y;
    te2[2] = _x.z;
    te2[6] = _y.z;
    te2[10] = _z.z;
    return this;
  }
  multiply(m, n2) {
    if (n2 !== void 0) {
      console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.");
      return this.multiplyMatrices(m, n2);
    }
    return this.multiplyMatrices(this, m);
  }
  premultiply(m) {
    return this.multiplyMatrices(m, this);
  }
  multiplyMatrices(a3, b) {
    const ae2 = a3.elements;
    const be = b.elements;
    const te2 = this.elements;
    const a11 = ae2[0], a12 = ae2[4], a13 = ae2[8], a14 = ae2[12];
    const a21 = ae2[1], a22 = ae2[5], a23 = ae2[9], a24 = ae2[13];
    const a31 = ae2[2], a32 = ae2[6], a33 = ae2[10], a34 = ae2[14];
    const a41 = ae2[3], a42 = ae2[7], a43 = ae2[11], a44 = ae2[15];
    const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
    const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
    const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
    const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
    te2[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
    te2[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
    te2[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
    te2[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
    te2[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
    te2[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
    te2[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
    te2[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
    te2[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
    te2[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
    te2[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
    te2[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
    te2[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
    te2[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
    te2[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
    te2[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
    return this;
  }
  multiplyScalar(s2) {
    const te2 = this.elements;
    te2[0] *= s2;
    te2[4] *= s2;
    te2[8] *= s2;
    te2[12] *= s2;
    te2[1] *= s2;
    te2[5] *= s2;
    te2[9] *= s2;
    te2[13] *= s2;
    te2[2] *= s2;
    te2[6] *= s2;
    te2[10] *= s2;
    te2[14] *= s2;
    te2[3] *= s2;
    te2[7] *= s2;
    te2[11] *= s2;
    te2[15] *= s2;
    return this;
  }
  determinant() {
    const te2 = this.elements;
    const n11 = te2[0], n12 = te2[4], n13 = te2[8], n14 = te2[12];
    const n21 = te2[1], n22 = te2[5], n23 = te2[9], n24 = te2[13];
    const n31 = te2[2], n32 = te2[6], n33 = te2[10], n34 = te2[14];
    const n41 = te2[3], n42 = te2[7], n43 = te2[11], n44 = te2[15];
    return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
  }
  transpose() {
    const te2 = this.elements;
    let tmp2;
    tmp2 = te2[1];
    te2[1] = te2[4];
    te2[4] = tmp2;
    tmp2 = te2[2];
    te2[2] = te2[8];
    te2[8] = tmp2;
    tmp2 = te2[6];
    te2[6] = te2[9];
    te2[9] = tmp2;
    tmp2 = te2[3];
    te2[3] = te2[12];
    te2[12] = tmp2;
    tmp2 = te2[7];
    te2[7] = te2[13];
    te2[13] = tmp2;
    tmp2 = te2[11];
    te2[11] = te2[14];
    te2[14] = tmp2;
    return this;
  }
  setPosition(x, y, z2) {
    const te2 = this.elements;
    if (x.isVector3) {
      te2[12] = x.x;
      te2[13] = x.y;
      te2[14] = x.z;
    } else {
      te2[12] = x;
      te2[13] = y;
      te2[14] = z2;
    }
    return this;
  }
  invert() {
    const te2 = this.elements, n11 = te2[0], n21 = te2[1], n31 = te2[2], n41 = te2[3], n12 = te2[4], n22 = te2[5], n32 = te2[6], n42 = te2[7], n13 = te2[8], n23 = te2[9], n33 = te2[10], n43 = te2[11], n14 = te2[12], n24 = te2[13], n34 = te2[14], n44 = te2[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
    const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
    if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const detInv = 1 / det;
    te2[0] = t11 * detInv;
    te2[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
    te2[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
    te2[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
    te2[4] = t12 * detInv;
    te2[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
    te2[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
    te2[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
    te2[8] = t13 * detInv;
    te2[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
    te2[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
    te2[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
    te2[12] = t14 * detInv;
    te2[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
    te2[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
    te2[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
    return this;
  }
  scale(v) {
    const te2 = this.elements;
    const x = v.x, y = v.y, z2 = v.z;
    te2[0] *= x;
    te2[4] *= y;
    te2[8] *= z2;
    te2[1] *= x;
    te2[5] *= y;
    te2[9] *= z2;
    te2[2] *= x;
    te2[6] *= y;
    te2[10] *= z2;
    te2[3] *= x;
    te2[7] *= y;
    te2[11] *= z2;
    return this;
  }
  getMaxScaleOnAxis() {
    const te2 = this.elements;
    const scaleXSq = te2[0] * te2[0] + te2[1] * te2[1] + te2[2] * te2[2];
    const scaleYSq = te2[4] * te2[4] + te2[5] * te2[5] + te2[6] * te2[6];
    const scaleZSq = te2[8] * te2[8] + te2[9] * te2[9] + te2[10] * te2[10];
    return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
  }
  makeTranslation(x, y, z2) {
    this.set(
      1,
      0,
      0,
      x,
      0,
      1,
      0,
      y,
      0,
      0,
      1,
      z2,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationX(theta) {
    const c2 = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      1,
      0,
      0,
      0,
      0,
      c2,
      -s2,
      0,
      0,
      s2,
      c2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationY(theta) {
    const c2 = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      c2,
      0,
      s2,
      0,
      0,
      1,
      0,
      0,
      -s2,
      0,
      c2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationZ(theta) {
    const c2 = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      c2,
      -s2,
      0,
      0,
      s2,
      c2,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationAxis(axis, angle2) {
    const c2 = Math.cos(angle2);
    const s2 = Math.sin(angle2);
    const t3 = 1 - c2;
    const x = axis.x, y = axis.y, z2 = axis.z;
    const tx = t3 * x, ty = t3 * y;
    this.set(
      tx * x + c2,
      tx * y - s2 * z2,
      tx * z2 + s2 * y,
      0,
      tx * y + s2 * z2,
      ty * y + c2,
      ty * z2 - s2 * x,
      0,
      tx * z2 - s2 * y,
      ty * z2 + s2 * x,
      t3 * z2 * z2 + c2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeScale(x, y, z2) {
    this.set(
      x,
      0,
      0,
      0,
      0,
      y,
      0,
      0,
      0,
      0,
      z2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeShear(xy, xz, yx, yz, zx, zy) {
    this.set(
      1,
      yx,
      zx,
      0,
      xy,
      1,
      zy,
      0,
      xz,
      yz,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  compose(position2, quaternion, scale) {
    const te2 = this.elements;
    const x = quaternion._x, y = quaternion._y, z2 = quaternion._z, w = quaternion._w;
    const x2 = x + x, y2 = y + y, z22 = z2 + z2;
    const xx = x * x2, xy = x * y2, xz = x * z22;
    const yy = y * y2, yz = y * z22, zz = z2 * z22;
    const wx = w * x2, wy = w * y2, wz = w * z22;
    const sx = scale.x, sy = scale.y, sz = scale.z;
    te2[0] = (1 - (yy + zz)) * sx;
    te2[1] = (xy + wz) * sx;
    te2[2] = (xz - wy) * sx;
    te2[3] = 0;
    te2[4] = (xy - wz) * sy;
    te2[5] = (1 - (xx + zz)) * sy;
    te2[6] = (yz + wx) * sy;
    te2[7] = 0;
    te2[8] = (xz + wy) * sz;
    te2[9] = (yz - wx) * sz;
    te2[10] = (1 - (xx + yy)) * sz;
    te2[11] = 0;
    te2[12] = position2.x;
    te2[13] = position2.y;
    te2[14] = position2.z;
    te2[15] = 1;
    return this;
  }
  decompose(position2, quaternion, scale) {
    const te2 = this.elements;
    let sx = _v1$5.set(te2[0], te2[1], te2[2]).length();
    const sy = _v1$5.set(te2[4], te2[5], te2[6]).length();
    const sz = _v1$5.set(te2[8], te2[9], te2[10]).length();
    const det = this.determinant();
    if (det < 0) sx = -sx;
    position2.x = te2[12];
    position2.y = te2[13];
    position2.z = te2[14];
    _m1$2.copy(this);
    const invSX = 1 / sx;
    const invSY = 1 / sy;
    const invSZ = 1 / sz;
    _m1$2.elements[0] *= invSX;
    _m1$2.elements[1] *= invSX;
    _m1$2.elements[2] *= invSX;
    _m1$2.elements[4] *= invSY;
    _m1$2.elements[5] *= invSY;
    _m1$2.elements[6] *= invSY;
    _m1$2.elements[8] *= invSZ;
    _m1$2.elements[9] *= invSZ;
    _m1$2.elements[10] *= invSZ;
    quaternion.setFromRotationMatrix(_m1$2);
    scale.x = sx;
    scale.y = sy;
    scale.z = sz;
    return this;
  }
  makePerspective(left, right, top, bottom, near, far) {
    if (far === void 0) {
      console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
    }
    const te2 = this.elements;
    const x = 2 * near / (right - left);
    const y = 2 * near / (top - bottom);
    const a3 = (right + left) / (right - left);
    const b = (top + bottom) / (top - bottom);
    const c2 = -(far + near) / (far - near);
    const d2 = -2 * far * near / (far - near);
    te2[0] = x;
    te2[4] = 0;
    te2[8] = a3;
    te2[12] = 0;
    te2[1] = 0;
    te2[5] = y;
    te2[9] = b;
    te2[13] = 0;
    te2[2] = 0;
    te2[6] = 0;
    te2[10] = c2;
    te2[14] = d2;
    te2[3] = 0;
    te2[7] = 0;
    te2[11] = -1;
    te2[15] = 0;
    return this;
  }
  makeOrthographic(left, right, top, bottom, near, far) {
    const te2 = this.elements;
    const w = 1 / (right - left);
    const h2 = 1 / (top - bottom);
    const p2 = 1 / (far - near);
    const x = (right + left) * w;
    const y = (top + bottom) * h2;
    const z2 = (far + near) * p2;
    te2[0] = 2 * w;
    te2[4] = 0;
    te2[8] = 0;
    te2[12] = -x;
    te2[1] = 0;
    te2[5] = 2 * h2;
    te2[9] = 0;
    te2[13] = -y;
    te2[2] = 0;
    te2[6] = 0;
    te2[10] = -2 * p2;
    te2[14] = -z2;
    te2[3] = 0;
    te2[7] = 0;
    te2[11] = 0;
    te2[15] = 1;
    return this;
  }
  equals(matrix2) {
    const te2 = this.elements;
    const me = matrix2.elements;
    for (let i2 = 0; i2 < 16; i2++) {
      if (te2[i2] !== me[i2]) return false;
    }
    return true;
  }
  fromArray(array, offset = 0) {
    for (let i2 = 0; i2 < 16; i2++) {
      this.elements[i2] = array[i2 + offset];
    }
    return this;
  }
  toArray(array = [], offset = 0) {
    const te2 = this.elements;
    array[offset] = te2[0];
    array[offset + 1] = te2[1];
    array[offset + 2] = te2[2];
    array[offset + 3] = te2[3];
    array[offset + 4] = te2[4];
    array[offset + 5] = te2[5];
    array[offset + 6] = te2[6];
    array[offset + 7] = te2[7];
    array[offset + 8] = te2[8];
    array[offset + 9] = te2[9];
    array[offset + 10] = te2[10];
    array[offset + 11] = te2[11];
    array[offset + 12] = te2[12];
    array[offset + 13] = te2[13];
    array[offset + 14] = te2[14];
    array[offset + 15] = te2[15];
    return array;
  }
}
Matrix42.prototype.isMatrix4 = true;
const _v1$5 = /* @__PURE__ */ new Vector32();
const _m1$2 = /* @__PURE__ */ new Matrix42();
const _zero = /* @__PURE__ */ new Vector32(0, 0, 0);
const _one = /* @__PURE__ */ new Vector32(1, 1, 1);
const _x = /* @__PURE__ */ new Vector32();
const _y = /* @__PURE__ */ new Vector32();
const _z = /* @__PURE__ */ new Vector32();
const _matrix$1 = /* @__PURE__ */ new Matrix42();
const _quaternion$3 = /* @__PURE__ */ new Quaternion2();
class Euler2 {
  constructor(x = 0, y = 0, z2 = 0, order = Euler2.DefaultOrder) {
    this._x = x;
    this._y = y;
    this._z = z2;
    this._order = order;
  }
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
    this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
    this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(value) {
    this._z = value;
    this._onChangeCallback();
  }
  get order() {
    return this._order;
  }
  set order(value) {
    this._order = value;
    this._onChangeCallback();
  }
  set(x, y, z2, order = this._order) {
    this._x = x;
    this._y = y;
    this._z = z2;
    this._order = order;
    this._onChangeCallback();
    return this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  copy(euler) {
    this._x = euler._x;
    this._y = euler._y;
    this._z = euler._z;
    this._order = euler._order;
    this._onChangeCallback();
    return this;
  }
  setFromRotationMatrix(m, order = this._order, update = true) {
    const te2 = m.elements;
    const m11 = te2[0], m12 = te2[4], m13 = te2[8];
    const m21 = te2[1], m22 = te2[5], m23 = te2[9];
    const m31 = te2[2], m32 = te2[6], m33 = te2[10];
    switch (order) {
      case "XYZ":
        this._y = Math.asin(clamp(m13, -1, 1));
        if (Math.abs(m13) < 0.9999999) {
          this._x = Math.atan2(-m23, m33);
          this._z = Math.atan2(-m12, m11);
        } else {
          this._x = Math.atan2(m32, m22);
          this._z = 0;
        }
        break;
      case "YXZ":
        this._x = Math.asin(-clamp(m23, -1, 1));
        if (Math.abs(m23) < 0.9999999) {
          this._y = Math.atan2(m13, m33);
          this._z = Math.atan2(m21, m22);
        } else {
          this._y = Math.atan2(-m31, m11);
          this._z = 0;
        }
        break;
      case "ZXY":
        this._x = Math.asin(clamp(m32, -1, 1));
        if (Math.abs(m32) < 0.9999999) {
          this._y = Math.atan2(-m31, m33);
          this._z = Math.atan2(-m12, m22);
        } else {
          this._y = 0;
          this._z = Math.atan2(m21, m11);
        }
        break;
      case "ZYX":
        this._y = Math.asin(-clamp(m31, -1, 1));
        if (Math.abs(m31) < 0.9999999) {
          this._x = Math.atan2(m32, m33);
          this._z = Math.atan2(m21, m11);
        } else {
          this._x = 0;
          this._z = Math.atan2(-m12, m22);
        }
        break;
      case "YZX":
        this._z = Math.asin(clamp(m21, -1, 1));
        if (Math.abs(m21) < 0.9999999) {
          this._x = Math.atan2(-m23, m22);
          this._y = Math.atan2(-m31, m11);
        } else {
          this._x = 0;
          this._y = Math.atan2(m13, m33);
        }
        break;
      case "XZY":
        this._z = Math.asin(-clamp(m12, -1, 1));
        if (Math.abs(m12) < 0.9999999) {
          this._x = Math.atan2(m32, m22);
          this._y = Math.atan2(m13, m11);
        } else {
          this._x = Math.atan2(-m23, m33);
          this._y = 0;
        }
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
    }
    this._order = order;
    if (update === true) this._onChangeCallback();
    return this;
  }
  setFromQuaternion(q, order, update) {
    _matrix$1.makeRotationFromQuaternion(q);
    return this.setFromRotationMatrix(_matrix$1, order, update);
  }
  setFromVector3(v, order = this._order) {
    return this.set(v.x, v.y, v.z, order);
  }
  reorder(newOrder) {
    _quaternion$3.setFromEuler(this);
    return this.setFromQuaternion(_quaternion$3, newOrder);
  }
  equals(euler) {
    return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
  }
  fromArray(array) {
    this._x = array[0];
    this._y = array[1];
    this._z = array[2];
    if (array[3] !== void 0) this._order = array[3];
    this._onChangeCallback();
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this._x;
    array[offset + 1] = this._y;
    array[offset + 2] = this._z;
    array[offset + 3] = this._order;
    return array;
  }
  toVector3(optionalResult) {
    if (optionalResult) {
      return optionalResult.set(this._x, this._y, this._z);
    } else {
      return new Vector32(this._x, this._y, this._z);
    }
  }
  _onChange(callback) {
    this._onChangeCallback = callback;
    return this;
  }
  _onChangeCallback() {
  }
}
Euler2.prototype.isEuler = true;
Euler2.DefaultOrder = "XYZ";
Euler2.RotationOrders = ["XYZ", "YZX", "ZXY", "XZY", "YXZ", "ZYX"];
class Layers2 {
  constructor() {
    this.mask = 1 | 0;
  }
  set(channel) {
    this.mask = 1 << channel | 0;
  }
  enable(channel) {
    this.mask |= 1 << channel | 0;
  }
  enableAll() {
    this.mask = 4294967295 | 0;
  }
  toggle(channel) {
    this.mask ^= 1 << channel | 0;
  }
  disable(channel) {
    this.mask &= ~(1 << channel | 0);
  }
  disableAll() {
    this.mask = 0;
  }
  test(layers) {
    return (this.mask & layers.mask) !== 0;
  }
}
let _object3DId = 0;
const _v1$4 = /* @__PURE__ */ new Vector32();
const _q1 = /* @__PURE__ */ new Quaternion2();
const _m1$1 = /* @__PURE__ */ new Matrix42();
const _target = /* @__PURE__ */ new Vector32();
const _position$3 = /* @__PURE__ */ new Vector32();
const _scale$2 = /* @__PURE__ */ new Vector32();
const _quaternion$2 = /* @__PURE__ */ new Quaternion2();
const _xAxis = /* @__PURE__ */ new Vector32(1, 0, 0);
const _yAxis = /* @__PURE__ */ new Vector32(0, 1, 0);
const _zAxis = /* @__PURE__ */ new Vector32(0, 0, 1);
const _addedEvent = { type: "added" };
const _removedEvent = { type: "removed" };
class Object3D2 extends EventDispatcher2 {
  constructor() {
    super();
    Object.defineProperty(this, "id", { value: _object3DId++ });
    this.uuid = generateUUID();
    this.name = "";
    this.type = "Object3D";
    this.parent = null;
    this.children = [];
    this.up = Object3D2.DefaultUp.clone();
    const position2 = new Vector32();
    const rotation = new Euler2();
    const quaternion = new Quaternion2();
    const scale = new Vector32(1, 1, 1);
    function onRotationChange() {
      quaternion.setFromEuler(rotation, false);
    }
    function onQuaternionChange() {
      rotation.setFromQuaternion(quaternion, void 0, false);
    }
    rotation._onChange(onRotationChange);
    quaternion._onChange(onQuaternionChange);
    Object.defineProperties(this, {
      position: {
        configurable: true,
        enumerable: true,
        value: position2
      },
      rotation: {
        configurable: true,
        enumerable: true,
        value: rotation
      },
      quaternion: {
        configurable: true,
        enumerable: true,
        value: quaternion
      },
      scale: {
        configurable: true,
        enumerable: true,
        value: scale
      },
      modelViewMatrix: {
        value: new Matrix42()
      },
      normalMatrix: {
        value: new Matrix32()
      }
    });
    this.matrix = new Matrix42();
    this.matrixWorld = new Matrix42();
    this.matrixAutoUpdate = Object3D2.DefaultMatrixAutoUpdate;
    this.matrixWorldNeedsUpdate = false;
    this.layers = new Layers2();
    this.visible = true;
    this.castShadow = false;
    this.receiveShadow = false;
    this.frustumCulled = true;
    this.renderOrder = 0;
    this.animations = [];
    this.userData = {};
  }
  onBeforeRender() {
  }
  onAfterRender() {
  }
  applyMatrix4(matrix2) {
    if (this.matrixAutoUpdate) this.updateMatrix();
    this.matrix.premultiply(matrix2);
    this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  applyQuaternion(q) {
    this.quaternion.premultiply(q);
    return this;
  }
  setRotationFromAxisAngle(axis, angle2) {
    this.quaternion.setFromAxisAngle(axis, angle2);
  }
  setRotationFromEuler(euler) {
    this.quaternion.setFromEuler(euler, true);
  }
  setRotationFromMatrix(m) {
    this.quaternion.setFromRotationMatrix(m);
  }
  setRotationFromQuaternion(q) {
    this.quaternion.copy(q);
  }
  rotateOnAxis(axis, angle2) {
    _q1.setFromAxisAngle(axis, angle2);
    this.quaternion.multiply(_q1);
    return this;
  }
  rotateOnWorldAxis(axis, angle2) {
    _q1.setFromAxisAngle(axis, angle2);
    this.quaternion.premultiply(_q1);
    return this;
  }
  rotateX(angle2) {
    return this.rotateOnAxis(_xAxis, angle2);
  }
  rotateY(angle2) {
    return this.rotateOnAxis(_yAxis, angle2);
  }
  rotateZ(angle2) {
    return this.rotateOnAxis(_zAxis, angle2);
  }
  translateOnAxis(axis, distance2) {
    _v1$4.copy(axis).applyQuaternion(this.quaternion);
    this.position.add(_v1$4.multiplyScalar(distance2));
    return this;
  }
  translateX(distance2) {
    return this.translateOnAxis(_xAxis, distance2);
  }
  translateY(distance2) {
    return this.translateOnAxis(_yAxis, distance2);
  }
  translateZ(distance2) {
    return this.translateOnAxis(_zAxis, distance2);
  }
  localToWorld(vector) {
    return vector.applyMatrix4(this.matrixWorld);
  }
  worldToLocal(vector) {
    return vector.applyMatrix4(_m1$1.copy(this.matrixWorld).invert());
  }
  lookAt(x, y, z2) {
    if (x.isVector3) {
      _target.copy(x);
    } else {
      _target.set(x, y, z2);
    }
    const parent2 = this.parent;
    this.updateWorldMatrix(true, false);
    _position$3.setFromMatrixPosition(this.matrixWorld);
    if (this.isCamera || this.isLight) {
      _m1$1.lookAt(_position$3, _target, this.up);
    } else {
      _m1$1.lookAt(_target, _position$3, this.up);
    }
    this.quaternion.setFromRotationMatrix(_m1$1);
    if (parent2) {
      _m1$1.extractRotation(parent2.matrixWorld);
      _q1.setFromRotationMatrix(_m1$1);
      this.quaternion.premultiply(_q1.invert());
    }
  }
  add(object) {
    if (arguments.length > 1) {
      for (let i2 = 0; i2 < arguments.length; i2++) {
        this.add(arguments[i2]);
      }
      return this;
    }
    if (object === this) {
      console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
      return this;
    }
    if (object && object.isObject3D) {
      if (object.parent !== null) {
        object.parent.remove(object);
      }
      object.parent = this;
      this.children.push(object);
      object.dispatchEvent(_addedEvent);
    } else {
      console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
    }
    return this;
  }
  remove(object) {
    if (arguments.length > 1) {
      for (let i2 = 0; i2 < arguments.length; i2++) {
        this.remove(arguments[i2]);
      }
      return this;
    }
    const index2 = this.children.indexOf(object);
    if (index2 !== -1) {
      object.parent = null;
      this.children.splice(index2, 1);
      object.dispatchEvent(_removedEvent);
    }
    return this;
  }
  removeFromParent() {
    const parent2 = this.parent;
    if (parent2 !== null) {
      parent2.remove(this);
    }
    return this;
  }
  clear() {
    for (let i2 = 0; i2 < this.children.length; i2++) {
      const object = this.children[i2];
      object.parent = null;
      object.dispatchEvent(_removedEvent);
    }
    this.children.length = 0;
    return this;
  }
  attach(object) {
    this.updateWorldMatrix(true, false);
    _m1$1.copy(this.matrixWorld).invert();
    if (object.parent !== null) {
      object.parent.updateWorldMatrix(true, false);
      _m1$1.multiply(object.parent.matrixWorld);
    }
    object.applyMatrix4(_m1$1);
    this.add(object);
    object.updateWorldMatrix(false, true);
    return this;
  }
  getObjectById(id) {
    return this.getObjectByProperty("id", id);
  }
  getObjectByName(name) {
    return this.getObjectByProperty("name", name);
  }
  getObjectByProperty(name, value) {
    if (this[name] === value) return this;
    for (let i2 = 0, l2 = this.children.length; i2 < l2; i2++) {
      const child = this.children[i2];
      const object = child.getObjectByProperty(name, value);
      if (object !== void 0) {
        return object;
      }
    }
    return void 0;
  }
  getWorldPosition(target) {
    this.updateWorldMatrix(true, false);
    return target.setFromMatrixPosition(this.matrixWorld);
  }
  getWorldQuaternion(target) {
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(_position$3, target, _scale$2);
    return target;
  }
  getWorldScale(target) {
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(_position$3, _quaternion$2, target);
    return target;
  }
  getWorldDirection(target) {
    this.updateWorldMatrix(true, false);
    const e2 = this.matrixWorld.elements;
    return target.set(e2[8], e2[9], e2[10]).normalize();
  }
  raycast() {
  }
  traverse(callback) {
    callback(this);
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      children[i2].traverse(callback);
    }
  }
  traverseVisible(callback) {
    if (this.visible === false) return;
    callback(this);
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      children[i2].traverseVisible(callback);
    }
  }
  traverseAncestors(callback) {
    const parent2 = this.parent;
    if (parent2 !== null) {
      callback(parent2);
      parent2.traverseAncestors(callback);
    }
  }
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale);
    this.matrixWorldNeedsUpdate = true;
  }
  updateMatrixWorld(force) {
    if (this.matrixAutoUpdate) this.updateMatrix();
    if (this.matrixWorldNeedsUpdate || force) {
      if (this.parent === null) {
        this.matrixWorld.copy(this.matrix);
      } else {
        this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
      }
      this.matrixWorldNeedsUpdate = false;
      force = true;
    }
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      children[i2].updateMatrixWorld(force);
    }
  }
  updateWorldMatrix(updateParents, updateChildren) {
    const parent2 = this.parent;
    if (updateParents === true && parent2 !== null) {
      parent2.updateWorldMatrix(true, false);
    }
    if (this.matrixAutoUpdate) this.updateMatrix();
    if (this.parent === null) {
      this.matrixWorld.copy(this.matrix);
    } else {
      this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
    }
    if (updateChildren === true) {
      const children = this.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        children[i2].updateWorldMatrix(false, true);
      }
    }
  }
  toJSON(meta) {
    const isRootObject = meta === void 0 || typeof meta === "string";
    const output = {};
    if (isRootObject) {
      meta = {
        geometries: {},
        materials: {},
        textures: {},
        images: {},
        shapes: {},
        skeletons: {},
        animations: {}
      };
      output.metadata = {
        version: 4.5,
        type: "Object",
        generator: "Object3D.toJSON"
      };
    }
    const object = {};
    object.uuid = this.uuid;
    object.type = this.type;
    if (this.name !== "") object.name = this.name;
    if (this.castShadow === true) object.castShadow = true;
    if (this.receiveShadow === true) object.receiveShadow = true;
    if (this.visible === false) object.visible = false;
    if (this.frustumCulled === false) object.frustumCulled = false;
    if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
    if (JSON.stringify(this.userData) !== "{}") object.userData = this.userData;
    object.layers = this.layers.mask;
    object.matrix = this.matrix.toArray();
    if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
    if (this.isInstancedMesh) {
      object.type = "InstancedMesh";
      object.count = this.count;
      object.instanceMatrix = this.instanceMatrix.toJSON();
      if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
    }
    function serialize(library, element) {
      if (library[element.uuid] === void 0) {
        library[element.uuid] = element.toJSON(meta);
      }
      return element.uuid;
    }
    if (this.isScene) {
      if (this.background) {
        if (this.background.isColor) {
          object.background = this.background.toJSON();
        } else if (this.background.isTexture) {
          object.background = this.background.toJSON(meta).uuid;
        }
      }
      if (this.environment && this.environment.isTexture) {
        object.environment = this.environment.toJSON(meta).uuid;
      }
    } else if (this.isMesh || this.isLine || this.isPoints) {
      object.geometry = serialize(meta.geometries, this.geometry);
      const parameters = this.geometry.parameters;
      if (parameters !== void 0 && parameters.shapes !== void 0) {
        const shapes = parameters.shapes;
        if (Array.isArray(shapes)) {
          for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
            const shape = shapes[i2];
            serialize(meta.shapes, shape);
          }
        } else {
          serialize(meta.shapes, shapes);
        }
      }
    }
    if (this.isSkinnedMesh) {
      object.bindMode = this.bindMode;
      object.bindMatrix = this.bindMatrix.toArray();
      if (this.skeleton !== void 0) {
        serialize(meta.skeletons, this.skeleton);
        object.skeleton = this.skeleton.uuid;
      }
    }
    if (this.material !== void 0) {
      if (Array.isArray(this.material)) {
        const uuids = [];
        for (let i2 = 0, l2 = this.material.length; i2 < l2; i2++) {
          uuids.push(serialize(meta.materials, this.material[i2]));
        }
        object.material = uuids;
      } else {
        object.material = serialize(meta.materials, this.material);
      }
    }
    if (this.children.length > 0) {
      object.children = [];
      for (let i2 = 0; i2 < this.children.length; i2++) {
        object.children.push(this.children[i2].toJSON(meta).object);
      }
    }
    if (this.animations.length > 0) {
      object.animations = [];
      for (let i2 = 0; i2 < this.animations.length; i2++) {
        const animation = this.animations[i2];
        object.animations.push(serialize(meta.animations, animation));
      }
    }
    if (isRootObject) {
      const geometries = extractFromCache(meta.geometries);
      const materials = extractFromCache(meta.materials);
      const textures = extractFromCache(meta.textures);
      const images = extractFromCache(meta.images);
      const shapes = extractFromCache(meta.shapes);
      const skeletons = extractFromCache(meta.skeletons);
      const animations = extractFromCache(meta.animations);
      if (geometries.length > 0) output.geometries = geometries;
      if (materials.length > 0) output.materials = materials;
      if (textures.length > 0) output.textures = textures;
      if (images.length > 0) output.images = images;
      if (shapes.length > 0) output.shapes = shapes;
      if (skeletons.length > 0) output.skeletons = skeletons;
      if (animations.length > 0) output.animations = animations;
    }
    output.object = object;
    return output;
    function extractFromCache(cache) {
      const values = [];
      for (const key in cache) {
        const data = cache[key];
        delete data.metadata;
        values.push(data);
      }
      return values;
    }
  }
  clone(recursive) {
    return new this.constructor().copy(this, recursive);
  }
  copy(source, recursive = true) {
    this.name = source.name;
    this.up.copy(source.up);
    this.position.copy(source.position);
    this.rotation.order = source.rotation.order;
    this.quaternion.copy(source.quaternion);
    this.scale.copy(source.scale);
    this.matrix.copy(source.matrix);
    this.matrixWorld.copy(source.matrixWorld);
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
    this.layers.mask = source.layers.mask;
    this.visible = source.visible;
    this.castShadow = source.castShadow;
    this.receiveShadow = source.receiveShadow;
    this.frustumCulled = source.frustumCulled;
    this.renderOrder = source.renderOrder;
    this.userData = JSON.parse(JSON.stringify(source.userData));
    if (recursive === true) {
      for (let i2 = 0; i2 < source.children.length; i2++) {
        const child = source.children[i2];
        this.add(child.clone());
      }
    }
    return this;
  }
}
Object3D2.DefaultUp = new Vector32(0, 1, 0);
Object3D2.DefaultMatrixAutoUpdate = true;
Object3D2.prototype.isObject3D = true;
const _v0$1 = /* @__PURE__ */ new Vector32();
const _v1$3 = /* @__PURE__ */ new Vector32();
const _v2$2 = /* @__PURE__ */ new Vector32();
const _v3$1 = /* @__PURE__ */ new Vector32();
const _vab = /* @__PURE__ */ new Vector32();
const _vac = /* @__PURE__ */ new Vector32();
const _vbc = /* @__PURE__ */ new Vector32();
const _vap = /* @__PURE__ */ new Vector32();
const _vbp = /* @__PURE__ */ new Vector32();
const _vcp = /* @__PURE__ */ new Vector32();
class Triangle2 {
  constructor(a3 = new Vector32(), b = new Vector32(), c2 = new Vector32()) {
    this.a = a3;
    this.b = b;
    this.c = c2;
  }
  static getNormal(a3, b, c2, target) {
    target.subVectors(c2, b);
    _v0$1.subVectors(a3, b);
    target.cross(_v0$1);
    const targetLengthSq = target.lengthSq();
    if (targetLengthSq > 0) {
      return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
    }
    return target.set(0, 0, 0);
  }
  // static/instance method to calculate barycentric coordinates
  // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
  static getBarycoord(point2, a3, b, c2, target) {
    _v0$1.subVectors(c2, a3);
    _v1$3.subVectors(b, a3);
    _v2$2.subVectors(point2, a3);
    const dot00 = _v0$1.dot(_v0$1);
    const dot01 = _v0$1.dot(_v1$3);
    const dot02 = _v0$1.dot(_v2$2);
    const dot11 = _v1$3.dot(_v1$3);
    const dot12 = _v1$3.dot(_v2$2);
    const denom = dot00 * dot11 - dot01 * dot01;
    if (denom === 0) {
      return target.set(-2, -1, -1);
    }
    const invDenom = 1 / denom;
    const u3 = (dot11 * dot02 - dot01 * dot12) * invDenom;
    const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
    return target.set(1 - u3 - v, v, u3);
  }
  static containsPoint(point2, a3, b, c2) {
    this.getBarycoord(point2, a3, b, c2, _v3$1);
    return _v3$1.x >= 0 && _v3$1.y >= 0 && _v3$1.x + _v3$1.y <= 1;
  }
  static getUV(point2, p1, p2, p3, uv1, uv2, uv3, target) {
    this.getBarycoord(point2, p1, p2, p3, _v3$1);
    target.set(0, 0);
    target.addScaledVector(uv1, _v3$1.x);
    target.addScaledVector(uv2, _v3$1.y);
    target.addScaledVector(uv3, _v3$1.z);
    return target;
  }
  static isFrontFacing(a3, b, c2, direction2) {
    _v0$1.subVectors(c2, b);
    _v1$3.subVectors(a3, b);
    return _v0$1.cross(_v1$3).dot(direction2) < 0 ? true : false;
  }
  set(a3, b, c2) {
    this.a.copy(a3);
    this.b.copy(b);
    this.c.copy(c2);
    return this;
  }
  setFromPointsAndIndices(points, i0, i1, i2) {
    this.a.copy(points[i0]);
    this.b.copy(points[i1]);
    this.c.copy(points[i2]);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(triangle3) {
    this.a.copy(triangle3.a);
    this.b.copy(triangle3.b);
    this.c.copy(triangle3.c);
    return this;
  }
  getArea() {
    _v0$1.subVectors(this.c, this.b);
    _v1$3.subVectors(this.a, this.b);
    return _v0$1.cross(_v1$3).length() * 0.5;
  }
  getMidpoint(target) {
    return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  getNormal(target) {
    return Triangle2.getNormal(this.a, this.b, this.c, target);
  }
  getPlane(target) {
    return target.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  getBarycoord(point2, target) {
    return Triangle2.getBarycoord(point2, this.a, this.b, this.c, target);
  }
  getUV(point2, uv1, uv2, uv3, target) {
    return Triangle2.getUV(point2, this.a, this.b, this.c, uv1, uv2, uv3, target);
  }
  containsPoint(point2) {
    return Triangle2.containsPoint(point2, this.a, this.b, this.c);
  }
  isFrontFacing(direction2) {
    return Triangle2.isFrontFacing(this.a, this.b, this.c, direction2);
  }
  intersectsBox(box) {
    return box.intersectsTriangle(this);
  }
  closestPointToPoint(p2, target) {
    const a3 = this.a, b = this.b, c2 = this.c;
    let v, w;
    _vab.subVectors(b, a3);
    _vac.subVectors(c2, a3);
    _vap.subVectors(p2, a3);
    const d1 = _vab.dot(_vap);
    const d2 = _vac.dot(_vap);
    if (d1 <= 0 && d2 <= 0) {
      return target.copy(a3);
    }
    _vbp.subVectors(p2, b);
    const d3 = _vab.dot(_vbp);
    const d4 = _vac.dot(_vbp);
    if (d3 >= 0 && d4 <= d3) {
      return target.copy(b);
    }
    const vc = d1 * d4 - d3 * d2;
    if (vc <= 0 && d1 >= 0 && d3 <= 0) {
      v = d1 / (d1 - d3);
      return target.copy(a3).addScaledVector(_vab, v);
    }
    _vcp.subVectors(p2, c2);
    const d5 = _vab.dot(_vcp);
    const d6 = _vac.dot(_vcp);
    if (d6 >= 0 && d5 <= d6) {
      return target.copy(c2);
    }
    const vb = d5 * d2 - d1 * d6;
    if (vb <= 0 && d2 >= 0 && d6 <= 0) {
      w = d2 / (d2 - d6);
      return target.copy(a3).addScaledVector(_vac, w);
    }
    const va = d3 * d6 - d5 * d4;
    if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
      _vbc.subVectors(c2, b);
      w = (d4 - d3) / (d4 - d3 + (d5 - d6));
      return target.copy(b).addScaledVector(_vbc, w);
    }
    const denom = 1 / (va + vb + vc);
    v = vb * denom;
    w = vc * denom;
    return target.copy(a3).addScaledVector(_vab, v).addScaledVector(_vac, w);
  }
  equals(triangle3) {
    return triangle3.a.equals(this.a) && triangle3.b.equals(this.b) && triangle3.c.equals(this.c);
  }
}
let materialId = 0;
class Material2 extends EventDispatcher2 {
  constructor() {
    super();
    Object.defineProperty(this, "id", { value: materialId++ });
    this.uuid = generateUUID();
    this.name = "";
    this.type = "Material";
    this.fog = true;
    this.blending = NormalBlending;
    this.side = FrontSide;
    this.vertexColors = false;
    this.opacity = 1;
    this.format = RGBAFormat;
    this.transparent = false;
    this.blendSrc = SrcAlphaFactor;
    this.blendDst = OneMinusSrcAlphaFactor;
    this.blendEquation = AddEquation;
    this.blendSrcAlpha = null;
    this.blendDstAlpha = null;
    this.blendEquationAlpha = null;
    this.depthFunc = LessEqualDepth;
    this.depthTest = true;
    this.depthWrite = true;
    this.stencilWriteMask = 255;
    this.stencilFunc = AlwaysStencilFunc;
    this.stencilRef = 0;
    this.stencilFuncMask = 255;
    this.stencilFail = KeepStencilOp;
    this.stencilZFail = KeepStencilOp;
    this.stencilZPass = KeepStencilOp;
    this.stencilWrite = false;
    this.clippingPlanes = null;
    this.clipIntersection = false;
    this.clipShadows = false;
    this.shadowSide = null;
    this.colorWrite = true;
    this.precision = null;
    this.polygonOffset = false;
    this.polygonOffsetFactor = 0;
    this.polygonOffsetUnits = 0;
    this.dithering = false;
    this.alphaToCoverage = false;
    this.premultipliedAlpha = false;
    this.visible = true;
    this.toneMapped = true;
    this.userData = {};
    this.version = 0;
    this._alphaTest = 0;
  }
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(value) {
    if (this._alphaTest > 0 !== value > 0) {
      this.version++;
    }
    this._alphaTest = value;
  }
  onBuild() {
  }
  onBeforeCompile() {
  }
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  setValues(values) {
    if (values === void 0) return;
    for (const key in values) {
      const newValue = values[key];
      if (newValue === void 0) {
        console.warn("THREE.Material: '" + key + "' parameter is undefined.");
        continue;
      }
      if (key === "shading") {
        console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
        this.flatShading = newValue === FlatShading ? true : false;
        continue;
      }
      const currentValue = this[key];
      if (currentValue === void 0) {
        console.warn("THREE." + this.type + ": '" + key + "' is not a property of this material.");
        continue;
      }
      if (currentValue && currentValue.isColor) {
        currentValue.set(newValue);
      } else if (currentValue && currentValue.isVector3 && (newValue && newValue.isVector3)) {
        currentValue.copy(newValue);
      } else {
        this[key] = newValue;
      }
    }
  }
  toJSON(meta) {
    const isRoot = meta === void 0 || typeof meta === "string";
    if (isRoot) {
      meta = {
        textures: {},
        images: {}
      };
    }
    const data = {
      metadata: {
        version: 4.5,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    data.uuid = this.uuid;
    data.type = this.type;
    if (this.name !== "") data.name = this.name;
    if (this.color && this.color.isColor) data.color = this.color.getHex();
    if (this.roughness !== void 0) data.roughness = this.roughness;
    if (this.metalness !== void 0) data.metalness = this.metalness;
    if (this.sheenTint && this.sheenTint.isColor) data.sheenTint = this.sheenTint.getHex();
    if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
    if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
    if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
    if (this.specularIntensity !== void 0) data.specularIntensity = this.specularIntensity;
    if (this.specularTint && this.specularTint.isColor) data.specularTint = this.specularTint.getHex();
    if (this.shininess !== void 0) data.shininess = this.shininess;
    if (this.clearcoat !== void 0) data.clearcoat = this.clearcoat;
    if (this.clearcoatRoughness !== void 0) data.clearcoatRoughness = this.clearcoatRoughness;
    if (this.clearcoatMap && this.clearcoatMap.isTexture) {
      data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
    }
    if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) {
      data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
    }
    if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
      data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
      data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
    }
    if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
    if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
    if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
    if (this.lightMap && this.lightMap.isTexture) {
      data.lightMap = this.lightMap.toJSON(meta).uuid;
      data.lightMapIntensity = this.lightMapIntensity;
    }
    if (this.aoMap && this.aoMap.isTexture) {
      data.aoMap = this.aoMap.toJSON(meta).uuid;
      data.aoMapIntensity = this.aoMapIntensity;
    }
    if (this.bumpMap && this.bumpMap.isTexture) {
      data.bumpMap = this.bumpMap.toJSON(meta).uuid;
      data.bumpScale = this.bumpScale;
    }
    if (this.normalMap && this.normalMap.isTexture) {
      data.normalMap = this.normalMap.toJSON(meta).uuid;
      data.normalMapType = this.normalMapType;
      data.normalScale = this.normalScale.toArray();
    }
    if (this.displacementMap && this.displacementMap.isTexture) {
      data.displacementMap = this.displacementMap.toJSON(meta).uuid;
      data.displacementScale = this.displacementScale;
      data.displacementBias = this.displacementBias;
    }
    if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
    if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
    if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
    if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
    if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
    if (this.specularTintMap && this.specularTintMap.isTexture) data.specularTintMap = this.specularTintMap.toJSON(meta).uuid;
    if (this.envMap && this.envMap.isTexture) {
      data.envMap = this.envMap.toJSON(meta).uuid;
      if (this.combine !== void 0) data.combine = this.combine;
    }
    if (this.envMapIntensity !== void 0) data.envMapIntensity = this.envMapIntensity;
    if (this.reflectivity !== void 0) data.reflectivity = this.reflectivity;
    if (this.refractionRatio !== void 0) data.refractionRatio = this.refractionRatio;
    if (this.gradientMap && this.gradientMap.isTexture) {
      data.gradientMap = this.gradientMap.toJSON(meta).uuid;
    }
    if (this.transmission !== void 0) data.transmission = this.transmission;
    if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
    if (this.thickness !== void 0) data.thickness = this.thickness;
    if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
    if (this.attenuationDistance !== void 0) data.attenuationDistance = this.attenuationDistance;
    if (this.attenuationTint !== void 0) data.attenuationTint = this.attenuationTint.getHex();
    if (this.size !== void 0) data.size = this.size;
    if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
    if (this.sizeAttenuation !== void 0) data.sizeAttenuation = this.sizeAttenuation;
    if (this.blending !== NormalBlending) data.blending = this.blending;
    if (this.side !== FrontSide) data.side = this.side;
    if (this.vertexColors) data.vertexColors = true;
    if (this.opacity < 1) data.opacity = this.opacity;
    if (this.format !== RGBAFormat) data.format = this.format;
    if (this.transparent === true) data.transparent = this.transparent;
    data.depthFunc = this.depthFunc;
    data.depthTest = this.depthTest;
    data.depthWrite = this.depthWrite;
    data.colorWrite = this.colorWrite;
    data.stencilWrite = this.stencilWrite;
    data.stencilWriteMask = this.stencilWriteMask;
    data.stencilFunc = this.stencilFunc;
    data.stencilRef = this.stencilRef;
    data.stencilFuncMask = this.stencilFuncMask;
    data.stencilFail = this.stencilFail;
    data.stencilZFail = this.stencilZFail;
    data.stencilZPass = this.stencilZPass;
    if (this.rotation && this.rotation !== 0) data.rotation = this.rotation;
    if (this.polygonOffset === true) data.polygonOffset = true;
    if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
    if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
    if (this.linewidth && this.linewidth !== 1) data.linewidth = this.linewidth;
    if (this.dashSize !== void 0) data.dashSize = this.dashSize;
    if (this.gapSize !== void 0) data.gapSize = this.gapSize;
    if (this.scale !== void 0) data.scale = this.scale;
    if (this.dithering === true) data.dithering = true;
    if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
    if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
    if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
    if (this.wireframe === true) data.wireframe = this.wireframe;
    if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
    if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
    if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
    if (this.flatShading === true) data.flatShading = this.flatShading;
    if (this.visible === false) data.visible = false;
    if (this.toneMapped === false) data.toneMapped = false;
    if (JSON.stringify(this.userData) !== "{}") data.userData = this.userData;
    function extractFromCache(cache) {
      const values = [];
      for (const key in cache) {
        const data2 = cache[key];
        delete data2.metadata;
        values.push(data2);
      }
      return values;
    }
    if (isRoot) {
      const textures = extractFromCache(meta.textures);
      const images = extractFromCache(meta.images);
      if (textures.length > 0) data.textures = textures;
      if (images.length > 0) data.images = images;
    }
    return data;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.name = source.name;
    this.fog = source.fog;
    this.blending = source.blending;
    this.side = source.side;
    this.vertexColors = source.vertexColors;
    this.opacity = source.opacity;
    this.format = source.format;
    this.transparent = source.transparent;
    this.blendSrc = source.blendSrc;
    this.blendDst = source.blendDst;
    this.blendEquation = source.blendEquation;
    this.blendSrcAlpha = source.blendSrcAlpha;
    this.blendDstAlpha = source.blendDstAlpha;
    this.blendEquationAlpha = source.blendEquationAlpha;
    this.depthFunc = source.depthFunc;
    this.depthTest = source.depthTest;
    this.depthWrite = source.depthWrite;
    this.stencilWriteMask = source.stencilWriteMask;
    this.stencilFunc = source.stencilFunc;
    this.stencilRef = source.stencilRef;
    this.stencilFuncMask = source.stencilFuncMask;
    this.stencilFail = source.stencilFail;
    this.stencilZFail = source.stencilZFail;
    this.stencilZPass = source.stencilZPass;
    this.stencilWrite = source.stencilWrite;
    const srcPlanes = source.clippingPlanes;
    let dstPlanes = null;
    if (srcPlanes !== null) {
      const n2 = srcPlanes.length;
      dstPlanes = new Array(n2);
      for (let i2 = 0; i2 !== n2; ++i2) {
        dstPlanes[i2] = srcPlanes[i2].clone();
      }
    }
    this.clippingPlanes = dstPlanes;
    this.clipIntersection = source.clipIntersection;
    this.clipShadows = source.clipShadows;
    this.shadowSide = source.shadowSide;
    this.colorWrite = source.colorWrite;
    this.precision = source.precision;
    this.polygonOffset = source.polygonOffset;
    this.polygonOffsetFactor = source.polygonOffsetFactor;
    this.polygonOffsetUnits = source.polygonOffsetUnits;
    this.dithering = source.dithering;
    this.alphaTest = source.alphaTest;
    this.alphaToCoverage = source.alphaToCoverage;
    this.premultipliedAlpha = source.premultipliedAlpha;
    this.visible = source.visible;
    this.toneMapped = source.toneMapped;
    this.userData = JSON.parse(JSON.stringify(source.userData));
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
}
Material2.prototype.isMaterial = true;
const _colorKeywords = {
  "aliceblue": 15792383,
  "antiquewhite": 16444375,
  "aqua": 65535,
  "aquamarine": 8388564,
  "azure": 15794175,
  "beige": 16119260,
  "bisque": 16770244,
  "black": 0,
  "blanchedalmond": 16772045,
  "blue": 255,
  "blueviolet": 9055202,
  "brown": 10824234,
  "burlywood": 14596231,
  "cadetblue": 6266528,
  "chartreuse": 8388352,
  "chocolate": 13789470,
  "coral": 16744272,
  "cornflowerblue": 6591981,
  "cornsilk": 16775388,
  "crimson": 14423100,
  "cyan": 65535,
  "darkblue": 139,
  "darkcyan": 35723,
  "darkgoldenrod": 12092939,
  "darkgray": 11119017,
  "darkgreen": 25600,
  "darkgrey": 11119017,
  "darkkhaki": 12433259,
  "darkmagenta": 9109643,
  "darkolivegreen": 5597999,
  "darkorange": 16747520,
  "darkorchid": 10040012,
  "darkred": 9109504,
  "darksalmon": 15308410,
  "darkseagreen": 9419919,
  "darkslateblue": 4734347,
  "darkslategray": 3100495,
  "darkslategrey": 3100495,
  "darkturquoise": 52945,
  "darkviolet": 9699539,
  "deeppink": 16716947,
  "deepskyblue": 49151,
  "dimgray": 6908265,
  "dimgrey": 6908265,
  "dodgerblue": 2003199,
  "firebrick": 11674146,
  "floralwhite": 16775920,
  "forestgreen": 2263842,
  "fuchsia": 16711935,
  "gainsboro": 14474460,
  "ghostwhite": 16316671,
  "gold": 16766720,
  "goldenrod": 14329120,
  "gray": 8421504,
  "green": 32768,
  "greenyellow": 11403055,
  "grey": 8421504,
  "honeydew": 15794160,
  "hotpink": 16738740,
  "indianred": 13458524,
  "indigo": 4915330,
  "ivory": 16777200,
  "khaki": 15787660,
  "lavender": 15132410,
  "lavenderblush": 16773365,
  "lawngreen": 8190976,
  "lemonchiffon": 16775885,
  "lightblue": 11393254,
  "lightcoral": 15761536,
  "lightcyan": 14745599,
  "lightgoldenrodyellow": 16448210,
  "lightgray": 13882323,
  "lightgreen": 9498256,
  "lightgrey": 13882323,
  "lightpink": 16758465,
  "lightsalmon": 16752762,
  "lightseagreen": 2142890,
  "lightskyblue": 8900346,
  "lightslategray": 7833753,
  "lightslategrey": 7833753,
  "lightsteelblue": 11584734,
  "lightyellow": 16777184,
  "lime": 65280,
  "limegreen": 3329330,
  "linen": 16445670,
  "magenta": 16711935,
  "maroon": 8388608,
  "mediumaquamarine": 6737322,
  "mediumblue": 205,
  "mediumorchid": 12211667,
  "mediumpurple": 9662683,
  "mediumseagreen": 3978097,
  "mediumslateblue": 8087790,
  "mediumspringgreen": 64154,
  "mediumturquoise": 4772300,
  "mediumvioletred": 13047173,
  "midnightblue": 1644912,
  "mintcream": 16121850,
  "mistyrose": 16770273,
  "moccasin": 16770229,
  "navajowhite": 16768685,
  "navy": 128,
  "oldlace": 16643558,
  "olive": 8421376,
  "olivedrab": 7048739,
  "orange": 16753920,
  "orangered": 16729344,
  "orchid": 14315734,
  "palegoldenrod": 15657130,
  "palegreen": 10025880,
  "paleturquoise": 11529966,
  "palevioletred": 14381203,
  "papayawhip": 16773077,
  "peachpuff": 16767673,
  "peru": 13468991,
  "pink": 16761035,
  "plum": 14524637,
  "powderblue": 11591910,
  "purple": 8388736,
  "rebeccapurple": 6697881,
  "red": 16711680,
  "rosybrown": 12357519,
  "royalblue": 4286945,
  "saddlebrown": 9127187,
  "salmon": 16416882,
  "sandybrown": 16032864,
  "seagreen": 3050327,
  "seashell": 16774638,
  "sienna": 10506797,
  "silver": 12632256,
  "skyblue": 8900331,
  "slateblue": 6970061,
  "slategray": 7372944,
  "slategrey": 7372944,
  "snow": 16775930,
  "springgreen": 65407,
  "steelblue": 4620980,
  "tan": 13808780,
  "teal": 32896,
  "thistle": 14204888,
  "tomato": 16737095,
  "turquoise": 4251856,
  "violet": 15631086,
  "wheat": 16113331,
  "white": 16777215,
  "whitesmoke": 16119285,
  "yellow": 16776960,
  "yellowgreen": 10145074
};
const _hslA = { h: 0, s: 0, l: 0 };
const _hslB = { h: 0, s: 0, l: 0 };
function hue2rgb$1(p2, q, t3) {
  if (t3 < 0) t3 += 1;
  if (t3 > 1) t3 -= 1;
  if (t3 < 1 / 6) return p2 + (q - p2) * 6 * t3;
  if (t3 < 1 / 2) return q;
  if (t3 < 2 / 3) return p2 + (q - p2) * 6 * (2 / 3 - t3);
  return p2;
}
function SRGBToLinear(c2) {
  return c2 < 0.04045 ? c2 * 0.0773993808 : Math.pow(c2 * 0.9478672986 + 0.0521327014, 2.4);
}
function LinearToSRGB(c2) {
  return c2 < 31308e-7 ? c2 * 12.92 : 1.055 * Math.pow(c2, 0.41666) - 0.055;
}
class Color2 {
  constructor(r2, g3, b) {
    if (g3 === void 0 && b === void 0) {
      return this.set(r2);
    }
    return this.setRGB(r2, g3, b);
  }
  set(value) {
    if (value && value.isColor) {
      this.copy(value);
    } else if (typeof value === "number") {
      this.setHex(value);
    } else if (typeof value === "string") {
      this.setStyle(value);
    }
    return this;
  }
  setScalar(scalar) {
    this.r = scalar;
    this.g = scalar;
    this.b = scalar;
    return this;
  }
  setHex(hex) {
    hex = Math.floor(hex);
    this.r = (hex >> 16 & 255) / 255;
    this.g = (hex >> 8 & 255) / 255;
    this.b = (hex & 255) / 255;
    return this;
  }
  setRGB(r2, g3, b) {
    this.r = r2;
    this.g = g3;
    this.b = b;
    return this;
  }
  setHSL(h2, s2, l2) {
    h2 = euclideanModulo(h2, 1);
    s2 = clamp(s2, 0, 1);
    l2 = clamp(l2, 0, 1);
    if (s2 === 0) {
      this.r = this.g = this.b = l2;
    } else {
      const p2 = l2 <= 0.5 ? l2 * (1 + s2) : l2 + s2 - l2 * s2;
      const q = 2 * l2 - p2;
      this.r = hue2rgb$1(q, p2, h2 + 1 / 3);
      this.g = hue2rgb$1(q, p2, h2);
      this.b = hue2rgb$1(q, p2, h2 - 1 / 3);
    }
    return this;
  }
  setStyle(style) {
    function handleAlpha(string) {
      if (string === void 0) return;
      if (parseFloat(string) < 1) {
        console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
      }
    }
    let m;
    if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style)) {
      let color2;
      const name = m[1];
      const components = m[2];
      switch (name) {
        case "rgb":
        case "rgba":
          if (color2 = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            this.r = Math.min(255, parseInt(color2[1], 10)) / 255;
            this.g = Math.min(255, parseInt(color2[2], 10)) / 255;
            this.b = Math.min(255, parseInt(color2[3], 10)) / 255;
            handleAlpha(color2[4]);
            return this;
          }
          if (color2 = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            this.r = Math.min(100, parseInt(color2[1], 10)) / 100;
            this.g = Math.min(100, parseInt(color2[2], 10)) / 100;
            this.b = Math.min(100, parseInt(color2[3], 10)) / 100;
            handleAlpha(color2[4]);
            return this;
          }
          break;
        case "hsl":
        case "hsla":
          if (color2 = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            const h2 = parseFloat(color2[1]) / 360;
            const s2 = parseInt(color2[2], 10) / 100;
            const l2 = parseInt(color2[3], 10) / 100;
            handleAlpha(color2[4]);
            return this.setHSL(h2, s2, l2);
          }
          break;
      }
    } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
      const hex = m[1];
      const size = hex.length;
      if (size === 3) {
        this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
        this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
        this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
        return this;
      } else if (size === 6) {
        this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
        this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
        this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
        return this;
      }
    }
    if (style && style.length > 0) {
      return this.setColorName(style);
    }
    return this;
  }
  setColorName(style) {
    const hex = _colorKeywords[style.toLowerCase()];
    if (hex !== void 0) {
      this.setHex(hex);
    } else {
      console.warn("THREE.Color: Unknown color " + style);
    }
    return this;
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  copy(color2) {
    this.r = color2.r;
    this.g = color2.g;
    this.b = color2.b;
    return this;
  }
  copyGammaToLinear(color2, gammaFactor = 2) {
    this.r = Math.pow(color2.r, gammaFactor);
    this.g = Math.pow(color2.g, gammaFactor);
    this.b = Math.pow(color2.b, gammaFactor);
    return this;
  }
  copyLinearToGamma(color2, gammaFactor = 2) {
    const safeInverse = gammaFactor > 0 ? 1 / gammaFactor : 1;
    this.r = Math.pow(color2.r, safeInverse);
    this.g = Math.pow(color2.g, safeInverse);
    this.b = Math.pow(color2.b, safeInverse);
    return this;
  }
  convertGammaToLinear(gammaFactor) {
    this.copyGammaToLinear(this, gammaFactor);
    return this;
  }
  convertLinearToGamma(gammaFactor) {
    this.copyLinearToGamma(this, gammaFactor);
    return this;
  }
  copySRGBToLinear(color2) {
    this.r = SRGBToLinear(color2.r);
    this.g = SRGBToLinear(color2.g);
    this.b = SRGBToLinear(color2.b);
    return this;
  }
  copyLinearToSRGB(color2) {
    this.r = LinearToSRGB(color2.r);
    this.g = LinearToSRGB(color2.g);
    this.b = LinearToSRGB(color2.b);
    return this;
  }
  convertSRGBToLinear() {
    this.copySRGBToLinear(this);
    return this;
  }
  convertLinearToSRGB() {
    this.copyLinearToSRGB(this);
    return this;
  }
  getHex() {
    return this.r * 255 << 16 ^ this.g * 255 << 8 ^ this.b * 255 << 0;
  }
  getHexString() {
    return ("000000" + this.getHex().toString(16)).slice(-6);
  }
  getHSL(target) {
    const r2 = this.r, g3 = this.g, b = this.b;
    const max2 = Math.max(r2, g3, b);
    const min = Math.min(r2, g3, b);
    let hue, saturation;
    const lightness = (min + max2) / 2;
    if (min === max2) {
      hue = 0;
      saturation = 0;
    } else {
      const delta = max2 - min;
      saturation = lightness <= 0.5 ? delta / (max2 + min) : delta / (2 - max2 - min);
      switch (max2) {
        case r2:
          hue = (g3 - b) / delta + (g3 < b ? 6 : 0);
          break;
        case g3:
          hue = (b - r2) / delta + 2;
          break;
        case b:
          hue = (r2 - g3) / delta + 4;
          break;
      }
      hue /= 6;
    }
    target.h = hue;
    target.s = saturation;
    target.l = lightness;
    return target;
  }
  getStyle() {
    return "rgb(" + (this.r * 255 | 0) + "," + (this.g * 255 | 0) + "," + (this.b * 255 | 0) + ")";
  }
  offsetHSL(h2, s2, l2) {
    this.getHSL(_hslA);
    _hslA.h += h2;
    _hslA.s += s2;
    _hslA.l += l2;
    this.setHSL(_hslA.h, _hslA.s, _hslA.l);
    return this;
  }
  add(color2) {
    this.r += color2.r;
    this.g += color2.g;
    this.b += color2.b;
    return this;
  }
  addColors(color1, color2) {
    this.r = color1.r + color2.r;
    this.g = color1.g + color2.g;
    this.b = color1.b + color2.b;
    return this;
  }
  addScalar(s2) {
    this.r += s2;
    this.g += s2;
    this.b += s2;
    return this;
  }
  sub(color2) {
    this.r = Math.max(0, this.r - color2.r);
    this.g = Math.max(0, this.g - color2.g);
    this.b = Math.max(0, this.b - color2.b);
    return this;
  }
  multiply(color2) {
    this.r *= color2.r;
    this.g *= color2.g;
    this.b *= color2.b;
    return this;
  }
  multiplyScalar(s2) {
    this.r *= s2;
    this.g *= s2;
    this.b *= s2;
    return this;
  }
  lerp(color2, alpha) {
    this.r += (color2.r - this.r) * alpha;
    this.g += (color2.g - this.g) * alpha;
    this.b += (color2.b - this.b) * alpha;
    return this;
  }
  lerpColors(color1, color2, alpha) {
    this.r = color1.r + (color2.r - color1.r) * alpha;
    this.g = color1.g + (color2.g - color1.g) * alpha;
    this.b = color1.b + (color2.b - color1.b) * alpha;
    return this;
  }
  lerpHSL(color2, alpha) {
    this.getHSL(_hslA);
    color2.getHSL(_hslB);
    const h2 = lerp$1(_hslA.h, _hslB.h, alpha);
    const s2 = lerp$1(_hslA.s, _hslB.s, alpha);
    const l2 = lerp$1(_hslA.l, _hslB.l, alpha);
    this.setHSL(h2, s2, l2);
    return this;
  }
  equals(c2) {
    return c2.r === this.r && c2.g === this.g && c2.b === this.b;
  }
  fromArray(array, offset = 0) {
    this.r = array[offset];
    this.g = array[offset + 1];
    this.b = array[offset + 2];
    return this;
  }
  toArray(array = [], offset = 0) {
    array[offset] = this.r;
    array[offset + 1] = this.g;
    array[offset + 2] = this.b;
    return array;
  }
  fromBufferAttribute(attribute, index2) {
    this.r = attribute.getX(index2);
    this.g = attribute.getY(index2);
    this.b = attribute.getZ(index2);
    if (attribute.normalized === true) {
      this.r /= 255;
      this.g /= 255;
      this.b /= 255;
    }
    return this;
  }
  toJSON() {
    return this.getHex();
  }
}
Color2.NAMES = _colorKeywords;
Color2.prototype.isColor = true;
Color2.prototype.r = 1;
Color2.prototype.g = 1;
Color2.prototype.b = 1;
class MeshBasicMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.type = "MeshBasicMaterial";
    this.color = new Color2(16777215);
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    return this;
  }
}
MeshBasicMaterial2.prototype.isMeshBasicMaterial = true;
const _vector$9 = /* @__PURE__ */ new Vector32();
const _vector2$1 = /* @__PURE__ */ new Vector22();
class BufferAttribute2 {
  constructor(array, itemSize, normalized) {
    if (Array.isArray(array)) {
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    }
    this.name = "";
    this.array = array;
    this.itemSize = itemSize;
    this.count = array !== void 0 ? array.length / itemSize : 0;
    this.normalized = normalized === true;
    this.usage = StaticDrawUsage;
    this.updateRange = { offset: 0, count: -1 };
    this.version = 0;
  }
  onUploadCallback() {
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
  setUsage(value) {
    this.usage = value;
    return this;
  }
  copy(source) {
    this.name = source.name;
    this.array = new source.array.constructor(source.array);
    this.itemSize = source.itemSize;
    this.count = source.count;
    this.normalized = source.normalized;
    this.usage = source.usage;
    return this;
  }
  copyAt(index1, attribute, index2) {
    index1 *= this.itemSize;
    index2 *= attribute.itemSize;
    for (let i2 = 0, l2 = this.itemSize; i2 < l2; i2++) {
      this.array[index1 + i2] = attribute.array[index2 + i2];
    }
    return this;
  }
  copyArray(array) {
    this.array.set(array);
    return this;
  }
  copyColorsArray(colors) {
    const array = this.array;
    let offset = 0;
    for (let i2 = 0, l2 = colors.length; i2 < l2; i2++) {
      let color2 = colors[i2];
      if (color2 === void 0) {
        console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", i2);
        color2 = new Color2();
      }
      array[offset++] = color2.r;
      array[offset++] = color2.g;
      array[offset++] = color2.b;
    }
    return this;
  }
  copyVector2sArray(vectors) {
    const array = this.array;
    let offset = 0;
    for (let i2 = 0, l2 = vectors.length; i2 < l2; i2++) {
      let vector = vectors[i2];
      if (vector === void 0) {
        console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", i2);
        vector = new Vector22();
      }
      array[offset++] = vector.x;
      array[offset++] = vector.y;
    }
    return this;
  }
  copyVector3sArray(vectors) {
    const array = this.array;
    let offset = 0;
    for (let i2 = 0, l2 = vectors.length; i2 < l2; i2++) {
      let vector = vectors[i2];
      if (vector === void 0) {
        console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", i2);
        vector = new Vector32();
      }
      array[offset++] = vector.x;
      array[offset++] = vector.y;
      array[offset++] = vector.z;
    }
    return this;
  }
  copyVector4sArray(vectors) {
    const array = this.array;
    let offset = 0;
    for (let i2 = 0, l2 = vectors.length; i2 < l2; i2++) {
      let vector = vectors[i2];
      if (vector === void 0) {
        console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", i2);
        vector = new Vector42();
      }
      array[offset++] = vector.x;
      array[offset++] = vector.y;
      array[offset++] = vector.z;
      array[offset++] = vector.w;
    }
    return this;
  }
  applyMatrix3(m) {
    if (this.itemSize === 2) {
      for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
        _vector2$1.fromBufferAttribute(this, i2);
        _vector2$1.applyMatrix3(m);
        this.setXY(i2, _vector2$1.x, _vector2$1.y);
      }
    } else if (this.itemSize === 3) {
      for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
        _vector$9.fromBufferAttribute(this, i2);
        _vector$9.applyMatrix3(m);
        this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
      }
    }
    return this;
  }
  applyMatrix4(m) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$9.x = this.getX(i2);
      _vector$9.y = this.getY(i2);
      _vector$9.z = this.getZ(i2);
      _vector$9.applyMatrix4(m);
      this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
    }
    return this;
  }
  applyNormalMatrix(m) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$9.x = this.getX(i2);
      _vector$9.y = this.getY(i2);
      _vector$9.z = this.getZ(i2);
      _vector$9.applyNormalMatrix(m);
      this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
    }
    return this;
  }
  transformDirection(m) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$9.x = this.getX(i2);
      _vector$9.y = this.getY(i2);
      _vector$9.z = this.getZ(i2);
      _vector$9.transformDirection(m);
      this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
    }
    return this;
  }
  set(value, offset = 0) {
    this.array.set(value, offset);
    return this;
  }
  getX(index2) {
    return this.array[index2 * this.itemSize];
  }
  setX(index2, x) {
    this.array[index2 * this.itemSize] = x;
    return this;
  }
  getY(index2) {
    return this.array[index2 * this.itemSize + 1];
  }
  setY(index2, y) {
    this.array[index2 * this.itemSize + 1] = y;
    return this;
  }
  getZ(index2) {
    return this.array[index2 * this.itemSize + 2];
  }
  setZ(index2, z2) {
    this.array[index2 * this.itemSize + 2] = z2;
    return this;
  }
  getW(index2) {
    return this.array[index2 * this.itemSize + 3];
  }
  setW(index2, w) {
    this.array[index2 * this.itemSize + 3] = w;
    return this;
  }
  setXY(index2, x, y) {
    index2 *= this.itemSize;
    this.array[index2 + 0] = x;
    this.array[index2 + 1] = y;
    return this;
  }
  setXYZ(index2, x, y, z2) {
    index2 *= this.itemSize;
    this.array[index2 + 0] = x;
    this.array[index2 + 1] = y;
    this.array[index2 + 2] = z2;
    return this;
  }
  setXYZW(index2, x, y, z2, w) {
    index2 *= this.itemSize;
    this.array[index2 + 0] = x;
    this.array[index2 + 1] = y;
    this.array[index2 + 2] = z2;
    this.array[index2 + 3] = w;
    return this;
  }
  onUpload(callback) {
    this.onUploadCallback = callback;
    return this;
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  toJSON() {
    const data = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.prototype.slice.call(this.array),
      normalized: this.normalized
    };
    if (this.name !== "") data.name = this.name;
    if (this.usage !== StaticDrawUsage) data.usage = this.usage;
    if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
    return data;
  }
}
BufferAttribute2.prototype.isBufferAttribute = true;
class Uint16BufferAttribute2 extends BufferAttribute2 {
  constructor(array, itemSize, normalized) {
    super(new Uint16Array(array), itemSize, normalized);
  }
}
class Uint32BufferAttribute2 extends BufferAttribute2 {
  constructor(array, itemSize, normalized) {
    super(new Uint32Array(array), itemSize, normalized);
  }
}
class Float16BufferAttribute2 extends BufferAttribute2 {
  constructor(array, itemSize, normalized) {
    super(new Uint16Array(array), itemSize, normalized);
  }
}
Float16BufferAttribute2.prototype.isFloat16BufferAttribute = true;
class Float32BufferAttribute2 extends BufferAttribute2 {
  constructor(array, itemSize, normalized) {
    super(new Float32Array(array), itemSize, normalized);
  }
}
function arrayMax(array) {
  if (array.length === 0) return -Infinity;
  let max2 = array[0];
  for (let i2 = 1, l2 = array.length; i2 < l2; ++i2) {
    if (array[i2] > max2) max2 = array[i2];
  }
  return max2;
}
let _id = 0;
const _m1 = /* @__PURE__ */ new Matrix42();
const _obj = /* @__PURE__ */ new Object3D2();
const _offset = /* @__PURE__ */ new Vector32();
const _box$1$1 = /* @__PURE__ */ new Box32();
const _boxMorphTargets = /* @__PURE__ */ new Box32();
const _vector$8 = /* @__PURE__ */ new Vector32();
class BufferGeometry2 extends EventDispatcher2 {
  constructor() {
    super();
    Object.defineProperty(this, "id", { value: _id++ });
    this.uuid = generateUUID();
    this.name = "";
    this.type = "BufferGeometry";
    this.index = null;
    this.attributes = {};
    this.morphAttributes = {};
    this.morphTargetsRelative = false;
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    this.drawRange = { start: 0, count: Infinity };
    this.userData = {};
  }
  getIndex() {
    return this.index;
  }
  setIndex(index2) {
    if (Array.isArray(index2)) {
      this.index = new (arrayMax(index2) > 65535 ? Uint32BufferAttribute2 : Uint16BufferAttribute2)(index2, 1);
    } else {
      this.index = index2;
    }
    return this;
  }
  getAttribute(name) {
    return this.attributes[name];
  }
  setAttribute(name, attribute) {
    this.attributes[name] = attribute;
    return this;
  }
  deleteAttribute(name) {
    delete this.attributes[name];
    return this;
  }
  hasAttribute(name) {
    return this.attributes[name] !== void 0;
  }
  addGroup(start, count, materialIndex = 0) {
    this.groups.push({
      start,
      count,
      materialIndex
    });
  }
  clearGroups() {
    this.groups = [];
  }
  setDrawRange(start, count) {
    this.drawRange.start = start;
    this.drawRange.count = count;
  }
  applyMatrix4(matrix2) {
    const position2 = this.attributes.position;
    if (position2 !== void 0) {
      position2.applyMatrix4(matrix2);
      position2.needsUpdate = true;
    }
    const normal = this.attributes.normal;
    if (normal !== void 0) {
      const normalMatrix = new Matrix32().getNormalMatrix(matrix2);
      normal.applyNormalMatrix(normalMatrix);
      normal.needsUpdate = true;
    }
    const tangent = this.attributes.tangent;
    if (tangent !== void 0) {
      tangent.transformDirection(matrix2);
      tangent.needsUpdate = true;
    }
    if (this.boundingBox !== null) {
      this.computeBoundingBox();
    }
    if (this.boundingSphere !== null) {
      this.computeBoundingSphere();
    }
    return this;
  }
  applyQuaternion(q) {
    _m1.makeRotationFromQuaternion(q);
    this.applyMatrix4(_m1);
    return this;
  }
  rotateX(angle2) {
    _m1.makeRotationX(angle2);
    this.applyMatrix4(_m1);
    return this;
  }
  rotateY(angle2) {
    _m1.makeRotationY(angle2);
    this.applyMatrix4(_m1);
    return this;
  }
  rotateZ(angle2) {
    _m1.makeRotationZ(angle2);
    this.applyMatrix4(_m1);
    return this;
  }
  translate(x, y, z2) {
    _m1.makeTranslation(x, y, z2);
    this.applyMatrix4(_m1);
    return this;
  }
  scale(x, y, z2) {
    _m1.makeScale(x, y, z2);
    this.applyMatrix4(_m1);
    return this;
  }
  lookAt(vector) {
    _obj.lookAt(vector);
    _obj.updateMatrix();
    this.applyMatrix4(_obj.matrix);
    return this;
  }
  center() {
    this.computeBoundingBox();
    this.boundingBox.getCenter(_offset).negate();
    this.translate(_offset.x, _offset.y, _offset.z);
    return this;
  }
  setFromPoints(points) {
    const position2 = [];
    for (let i2 = 0, l2 = points.length; i2 < l2; i2++) {
      const point2 = points[i2];
      position2.push(point2.x, point2.y, point2.z || 0);
    }
    this.setAttribute("position", new Float32BufferAttribute2(position2, 3));
    return this;
  }
  computeBoundingBox() {
    if (this.boundingBox === null) {
      this.boundingBox = new Box32();
    }
    const position2 = this.attributes.position;
    const morphAttributesPosition = this.morphAttributes.position;
    if (position2 && position2.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
      this.boundingBox.set(
        new Vector32(-Infinity, -Infinity, -Infinity),
        new Vector32(Infinity, Infinity, Infinity)
      );
      return;
    }
    if (position2 !== void 0) {
      this.boundingBox.setFromBufferAttribute(position2);
      if (morphAttributesPosition) {
        for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
          const morphAttribute = morphAttributesPosition[i2];
          _box$1$1.setFromBufferAttribute(morphAttribute);
          if (this.morphTargetsRelative) {
            _vector$8.addVectors(this.boundingBox.min, _box$1$1.min);
            this.boundingBox.expandByPoint(_vector$8);
            _vector$8.addVectors(this.boundingBox.max, _box$1$1.max);
            this.boundingBox.expandByPoint(_vector$8);
          } else {
            this.boundingBox.expandByPoint(_box$1$1.min);
            this.boundingBox.expandByPoint(_box$1$1.max);
          }
        }
      }
    } else {
      this.boundingBox.makeEmpty();
    }
    if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) {
      console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
  }
  computeBoundingSphere() {
    if (this.boundingSphere === null) {
      this.boundingSphere = new Sphere2();
    }
    const position2 = this.attributes.position;
    const morphAttributesPosition = this.morphAttributes.position;
    if (position2 && position2.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
      this.boundingSphere.set(new Vector32(), Infinity);
      return;
    }
    if (position2) {
      const center = this.boundingSphere.center;
      _box$1$1.setFromBufferAttribute(position2);
      if (morphAttributesPosition) {
        for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
          const morphAttribute = morphAttributesPosition[i2];
          _boxMorphTargets.setFromBufferAttribute(morphAttribute);
          if (this.morphTargetsRelative) {
            _vector$8.addVectors(_box$1$1.min, _boxMorphTargets.min);
            _box$1$1.expandByPoint(_vector$8);
            _vector$8.addVectors(_box$1$1.max, _boxMorphTargets.max);
            _box$1$1.expandByPoint(_vector$8);
          } else {
            _box$1$1.expandByPoint(_boxMorphTargets.min);
            _box$1$1.expandByPoint(_boxMorphTargets.max);
          }
        }
      }
      _box$1$1.getCenter(center);
      let maxRadiusSq = 0;
      for (let i2 = 0, il = position2.count; i2 < il; i2++) {
        _vector$8.fromBufferAttribute(position2, i2);
        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
      }
      if (morphAttributesPosition) {
        for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
          const morphAttribute = morphAttributesPosition[i2];
          const morphTargetsRelative = this.morphTargetsRelative;
          for (let j = 0, jl = morphAttribute.count; j < jl; j++) {
            _vector$8.fromBufferAttribute(morphAttribute, j);
            if (morphTargetsRelative) {
              _offset.fromBufferAttribute(position2, j);
              _vector$8.add(_offset);
            }
            maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
          }
        }
      }
      this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
      if (isNaN(this.boundingSphere.radius)) {
        console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
      }
    }
  }
  computeTangents() {
    const index2 = this.index;
    const attributes = this.attributes;
    if (index2 === null || attributes.position === void 0 || attributes.normal === void 0 || attributes.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const indices = index2.array;
    const positions = attributes.position.array;
    const normals = attributes.normal.array;
    const uvs = attributes.uv.array;
    const nVertices = positions.length / 3;
    if (attributes.tangent === void 0) {
      this.setAttribute("tangent", new BufferAttribute2(new Float32Array(4 * nVertices), 4));
    }
    const tangents = attributes.tangent.array;
    const tan1 = [], tan2 = [];
    for (let i2 = 0; i2 < nVertices; i2++) {
      tan1[i2] = new Vector32();
      tan2[i2] = new Vector32();
    }
    const vA = new Vector32(), vB = new Vector32(), vC = new Vector32(), uvA = new Vector22(), uvB = new Vector22(), uvC = new Vector22(), sdir = new Vector32(), tdir = new Vector32();
    function handleTriangle(a3, b, c2) {
      vA.fromArray(positions, a3 * 3);
      vB.fromArray(positions, b * 3);
      vC.fromArray(positions, c2 * 3);
      uvA.fromArray(uvs, a3 * 2);
      uvB.fromArray(uvs, b * 2);
      uvC.fromArray(uvs, c2 * 2);
      vB.sub(vA);
      vC.sub(vA);
      uvB.sub(uvA);
      uvC.sub(uvA);
      const r2 = 1 / (uvB.x * uvC.y - uvC.x * uvB.y);
      if (!isFinite(r2)) return;
      sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r2);
      tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r2);
      tan1[a3].add(sdir);
      tan1[b].add(sdir);
      tan1[c2].add(sdir);
      tan2[a3].add(tdir);
      tan2[b].add(tdir);
      tan2[c2].add(tdir);
    }
    let groups = this.groups;
    if (groups.length === 0) {
      groups = [{
        start: 0,
        count: indices.length
      }];
    }
    for (let i2 = 0, il = groups.length; i2 < il; ++i2) {
      const group = groups[i2];
      const start = group.start;
      const count = group.count;
      for (let j = start, jl = start + count; j < jl; j += 3) {
        handleTriangle(
          indices[j + 0],
          indices[j + 1],
          indices[j + 2]
        );
      }
    }
    const tmp2 = new Vector32(), tmp22 = new Vector32();
    const n2 = new Vector32(), n22 = new Vector32();
    function handleVertex(v) {
      n2.fromArray(normals, v * 3);
      n22.copy(n2);
      const t3 = tan1[v];
      tmp2.copy(t3);
      tmp2.sub(n2.multiplyScalar(n2.dot(t3))).normalize();
      tmp22.crossVectors(n22, t3);
      const test = tmp22.dot(tan2[v]);
      const w = test < 0 ? -1 : 1;
      tangents[v * 4] = tmp2.x;
      tangents[v * 4 + 1] = tmp2.y;
      tangents[v * 4 + 2] = tmp2.z;
      tangents[v * 4 + 3] = w;
    }
    for (let i2 = 0, il = groups.length; i2 < il; ++i2) {
      const group = groups[i2];
      const start = group.start;
      const count = group.count;
      for (let j = start, jl = start + count; j < jl; j += 3) {
        handleVertex(indices[j + 0]);
        handleVertex(indices[j + 1]);
        handleVertex(indices[j + 2]);
      }
    }
  }
  computeVertexNormals() {
    const index2 = this.index;
    const positionAttribute = this.getAttribute("position");
    if (positionAttribute !== void 0) {
      let normalAttribute = this.getAttribute("normal");
      if (normalAttribute === void 0) {
        normalAttribute = new BufferAttribute2(new Float32Array(positionAttribute.count * 3), 3);
        this.setAttribute("normal", normalAttribute);
      } else {
        for (let i2 = 0, il = normalAttribute.count; i2 < il; i2++) {
          normalAttribute.setXYZ(i2, 0, 0, 0);
        }
      }
      const pA = new Vector32(), pB = new Vector32(), pC = new Vector32();
      const nA = new Vector32(), nB = new Vector32(), nC = new Vector32();
      const cb = new Vector32(), ab = new Vector32();
      if (index2) {
        for (let i2 = 0, il = index2.count; i2 < il; i2 += 3) {
          const vA = index2.getX(i2 + 0);
          const vB = index2.getX(i2 + 1);
          const vC = index2.getX(i2 + 2);
          pA.fromBufferAttribute(positionAttribute, vA);
          pB.fromBufferAttribute(positionAttribute, vB);
          pC.fromBufferAttribute(positionAttribute, vC);
          cb.subVectors(pC, pB);
          ab.subVectors(pA, pB);
          cb.cross(ab);
          nA.fromBufferAttribute(normalAttribute, vA);
          nB.fromBufferAttribute(normalAttribute, vB);
          nC.fromBufferAttribute(normalAttribute, vC);
          nA.add(cb);
          nB.add(cb);
          nC.add(cb);
          normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
          normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
          normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
        }
      } else {
        for (let i2 = 0, il = positionAttribute.count; i2 < il; i2 += 3) {
          pA.fromBufferAttribute(positionAttribute, i2 + 0);
          pB.fromBufferAttribute(positionAttribute, i2 + 1);
          pC.fromBufferAttribute(positionAttribute, i2 + 2);
          cb.subVectors(pC, pB);
          ab.subVectors(pA, pB);
          cb.cross(ab);
          normalAttribute.setXYZ(i2 + 0, cb.x, cb.y, cb.z);
          normalAttribute.setXYZ(i2 + 1, cb.x, cb.y, cb.z);
          normalAttribute.setXYZ(i2 + 2, cb.x, cb.y, cb.z);
        }
      }
      this.normalizeNormals();
      normalAttribute.needsUpdate = true;
    }
  }
  merge(geometry, offset) {
    if (!(geometry && geometry.isBufferGeometry)) {
      console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", geometry);
      return;
    }
    if (offset === void 0) {
      offset = 0;
      console.warn(
        "THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge."
      );
    }
    const attributes = this.attributes;
    for (const key in attributes) {
      if (geometry.attributes[key] === void 0) continue;
      const attribute1 = attributes[key];
      const attributeArray1 = attribute1.array;
      const attribute2 = geometry.attributes[key];
      const attributeArray2 = attribute2.array;
      const attributeOffset = attribute2.itemSize * offset;
      const length2 = Math.min(attributeArray2.length, attributeArray1.length - attributeOffset);
      for (let i2 = 0, j = attributeOffset; i2 < length2; i2++, j++) {
        attributeArray1[j] = attributeArray2[i2];
      }
    }
    return this;
  }
  normalizeNormals() {
    const normals = this.attributes.normal;
    for (let i2 = 0, il = normals.count; i2 < il; i2++) {
      _vector$8.fromBufferAttribute(normals, i2);
      _vector$8.normalize();
      normals.setXYZ(i2, _vector$8.x, _vector$8.y, _vector$8.z);
    }
  }
  toNonIndexed() {
    function convertBufferAttribute(attribute, indices2) {
      const array = attribute.array;
      const itemSize = attribute.itemSize;
      const normalized = attribute.normalized;
      const array2 = new array.constructor(indices2.length * itemSize);
      let index2 = 0, index22 = 0;
      for (let i2 = 0, l2 = indices2.length; i2 < l2; i2++) {
        if (attribute.isInterleavedBufferAttribute) {
          index2 = indices2[i2] * attribute.data.stride + attribute.offset;
        } else {
          index2 = indices2[i2] * itemSize;
        }
        for (let j = 0; j < itemSize; j++) {
          array2[index22++] = array[index2++];
        }
      }
      return new BufferAttribute2(array2, itemSize, normalized);
    }
    if (this.index === null) {
      console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
      return this;
    }
    const geometry2 = new BufferGeometry2();
    const indices = this.index.array;
    const attributes = this.attributes;
    for (const name in attributes) {
      const attribute = attributes[name];
      const newAttribute = convertBufferAttribute(attribute, indices);
      geometry2.setAttribute(name, newAttribute);
    }
    const morphAttributes = this.morphAttributes;
    for (const name in morphAttributes) {
      const morphArray = [];
      const morphAttribute = morphAttributes[name];
      for (let i2 = 0, il = morphAttribute.length; i2 < il; i2++) {
        const attribute = morphAttribute[i2];
        const newAttribute = convertBufferAttribute(attribute, indices);
        morphArray.push(newAttribute);
      }
      geometry2.morphAttributes[name] = morphArray;
    }
    geometry2.morphTargetsRelative = this.morphTargetsRelative;
    const groups = this.groups;
    for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
      const group = groups[i2];
      geometry2.addGroup(group.start, group.count, group.materialIndex);
    }
    return geometry2;
  }
  toJSON() {
    const data = {
      metadata: {
        version: 4.5,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    data.uuid = this.uuid;
    data.type = this.type;
    if (this.name !== "") data.name = this.name;
    if (Object.keys(this.userData).length > 0) data.userData = this.userData;
    if (this.parameters !== void 0) {
      const parameters = this.parameters;
      for (const key in parameters) {
        if (parameters[key] !== void 0) data[key] = parameters[key];
      }
      return data;
    }
    data.data = { attributes: {} };
    const index2 = this.index;
    if (index2 !== null) {
      data.data.index = {
        type: index2.array.constructor.name,
        array: Array.prototype.slice.call(index2.array)
      };
    }
    const attributes = this.attributes;
    for (const key in attributes) {
      const attribute = attributes[key];
      data.data.attributes[key] = attribute.toJSON(data.data);
    }
    const morphAttributes = {};
    let hasMorphAttributes = false;
    for (const key in this.morphAttributes) {
      const attributeArray = this.morphAttributes[key];
      const array = [];
      for (let i2 = 0, il = attributeArray.length; i2 < il; i2++) {
        const attribute = attributeArray[i2];
        array.push(attribute.toJSON(data.data));
      }
      if (array.length > 0) {
        morphAttributes[key] = array;
        hasMorphAttributes = true;
      }
    }
    if (hasMorphAttributes) {
      data.data.morphAttributes = morphAttributes;
      data.data.morphTargetsRelative = this.morphTargetsRelative;
    }
    const groups = this.groups;
    if (groups.length > 0) {
      data.data.groups = JSON.parse(JSON.stringify(groups));
    }
    const boundingSphere = this.boundingSphere;
    if (boundingSphere !== null) {
      data.data.boundingSphere = {
        center: boundingSphere.center.toArray(),
        radius: boundingSphere.radius
      };
    }
    return data;
  }
  clone() {
    return new BufferGeometry2().copy(this);
  }
  copy(source) {
    this.index = null;
    this.attributes = {};
    this.morphAttributes = {};
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    const data = {};
    this.name = source.name;
    const index2 = source.index;
    if (index2 !== null) {
      this.setIndex(index2.clone(data));
    }
    const attributes = source.attributes;
    for (const name in attributes) {
      const attribute = attributes[name];
      this.setAttribute(name, attribute.clone(data));
    }
    const morphAttributes = source.morphAttributes;
    for (const name in morphAttributes) {
      const array = [];
      const morphAttribute = morphAttributes[name];
      for (let i2 = 0, l2 = morphAttribute.length; i2 < l2; i2++) {
        array.push(morphAttribute[i2].clone(data));
      }
      this.morphAttributes[name] = array;
    }
    this.morphTargetsRelative = source.morphTargetsRelative;
    const groups = source.groups;
    for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
      const group = groups[i2];
      this.addGroup(group.start, group.count, group.materialIndex);
    }
    const boundingBox2 = source.boundingBox;
    if (boundingBox2 !== null) {
      this.boundingBox = boundingBox2.clone();
    }
    const boundingSphere = source.boundingSphere;
    if (boundingSphere !== null) {
      this.boundingSphere = boundingSphere.clone();
    }
    this.drawRange.start = source.drawRange.start;
    this.drawRange.count = source.drawRange.count;
    this.userData = source.userData;
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
BufferGeometry2.prototype.isBufferGeometry = true;
const _inverseMatrix$2 = /* @__PURE__ */ new Matrix42();
const _ray$2 = /* @__PURE__ */ new Ray2();
const _sphere$3 = /* @__PURE__ */ new Sphere2();
const _vA$1 = /* @__PURE__ */ new Vector32();
const _vB$1 = /* @__PURE__ */ new Vector32();
const _vC$1 = /* @__PURE__ */ new Vector32();
const _tempA = /* @__PURE__ */ new Vector32();
const _tempB = /* @__PURE__ */ new Vector32();
const _tempC = /* @__PURE__ */ new Vector32();
const _morphA = /* @__PURE__ */ new Vector32();
const _morphB = /* @__PURE__ */ new Vector32();
const _morphC = /* @__PURE__ */ new Vector32();
const _uvA$1 = /* @__PURE__ */ new Vector22();
const _uvB$1 = /* @__PURE__ */ new Vector22();
const _uvC$1 = /* @__PURE__ */ new Vector22();
const _intersectionPoint = /* @__PURE__ */ new Vector32();
const _intersectionPointWorld = /* @__PURE__ */ new Vector32();
class Mesh2 extends Object3D2 {
  constructor(geometry = new BufferGeometry2(), material = new MeshBasicMaterial2()) {
    super();
    this.type = "Mesh";
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source) {
    super.copy(source);
    if (source.morphTargetInfluences !== void 0) {
      this.morphTargetInfluences = source.morphTargetInfluences.slice();
    }
    if (source.morphTargetDictionary !== void 0) {
      this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
    }
    this.material = source.material;
    this.geometry = source.geometry;
    return this;
  }
  updateMorphTargets() {
    const geometry = this.geometry;
    if (geometry.isBufferGeometry) {
      const morphAttributes = geometry.morphAttributes;
      const keys = Object.keys(morphAttributes);
      if (keys.length > 0) {
        const morphAttribute = morphAttributes[keys[0]];
        if (morphAttribute !== void 0) {
          this.morphTargetInfluences = [];
          this.morphTargetDictionary = {};
          for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
            const name = morphAttribute[m].name || String(m);
            this.morphTargetInfluences.push(0);
            this.morphTargetDictionary[name] = m;
          }
        }
      }
    } else {
      const morphTargets = geometry.morphTargets;
      if (morphTargets !== void 0 && morphTargets.length > 0) {
        console.error("THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }
  raycast(raycaster, intersects2) {
    const geometry = this.geometry;
    const material = this.material;
    const matrixWorld = this.matrixWorld;
    if (material === void 0) return;
    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
    _sphere$3.copy(geometry.boundingSphere);
    _sphere$3.applyMatrix4(matrixWorld);
    if (raycaster.ray.intersectsSphere(_sphere$3) === false) return;
    _inverseMatrix$2.copy(matrixWorld).invert();
    _ray$2.copy(raycaster.ray).applyMatrix4(_inverseMatrix$2);
    if (geometry.boundingBox !== null) {
      if (_ray$2.intersectsBox(geometry.boundingBox) === false) return;
    }
    let intersection;
    if (geometry.isBufferGeometry) {
      const index2 = geometry.index;
      const position2 = geometry.attributes.position;
      const morphPosition = geometry.morphAttributes.position;
      const morphTargetsRelative = geometry.morphTargetsRelative;
      const uv = geometry.attributes.uv;
      const uv2 = geometry.attributes.uv2;
      const groups = geometry.groups;
      const drawRange = geometry.drawRange;
      if (index2 !== null) {
        if (Array.isArray(material)) {
          for (let i2 = 0, il = groups.length; i2 < il; i2++) {
            const group = groups[i2];
            const groupMaterial = material[group.materialIndex];
            const start = Math.max(group.start, drawRange.start);
            const end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for (let j = start, jl = end; j < jl; j += 3) {
              const a3 = index2.getX(j);
              const b = index2.getX(j + 1);
              const c2 = index2.getX(j + 2);
              intersection = checkBufferGeometryIntersection(this, groupMaterial, raycaster, _ray$2, position2, morphPosition, morphTargetsRelative, uv, uv2, a3, b, c2);
              if (intersection) {
                intersection.faceIndex = Math.floor(j / 3);
                intersection.face.materialIndex = group.materialIndex;
                intersects2.push(intersection);
              }
            }
          }
        } else {
          const start = Math.max(0, drawRange.start);
          const end = Math.min(index2.count, drawRange.start + drawRange.count);
          for (let i2 = start, il = end; i2 < il; i2 += 3) {
            const a3 = index2.getX(i2);
            const b = index2.getX(i2 + 1);
            const c2 = index2.getX(i2 + 2);
            intersection = checkBufferGeometryIntersection(this, material, raycaster, _ray$2, position2, morphPosition, morphTargetsRelative, uv, uv2, a3, b, c2);
            if (intersection) {
              intersection.faceIndex = Math.floor(i2 / 3);
              intersects2.push(intersection);
            }
          }
        }
      } else if (position2 !== void 0) {
        if (Array.isArray(material)) {
          for (let i2 = 0, il = groups.length; i2 < il; i2++) {
            const group = groups[i2];
            const groupMaterial = material[group.materialIndex];
            const start = Math.max(group.start, drawRange.start);
            const end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for (let j = start, jl = end; j < jl; j += 3) {
              const a3 = j;
              const b = j + 1;
              const c2 = j + 2;
              intersection = checkBufferGeometryIntersection(this, groupMaterial, raycaster, _ray$2, position2, morphPosition, morphTargetsRelative, uv, uv2, a3, b, c2);
              if (intersection) {
                intersection.faceIndex = Math.floor(j / 3);
                intersection.face.materialIndex = group.materialIndex;
                intersects2.push(intersection);
              }
            }
          }
        } else {
          const start = Math.max(0, drawRange.start);
          const end = Math.min(position2.count, drawRange.start + drawRange.count);
          for (let i2 = start, il = end; i2 < il; i2 += 3) {
            const a3 = i2;
            const b = i2 + 1;
            const c2 = i2 + 2;
            intersection = checkBufferGeometryIntersection(this, material, raycaster, _ray$2, position2, morphPosition, morphTargetsRelative, uv, uv2, a3, b, c2);
            if (intersection) {
              intersection.faceIndex = Math.floor(i2 / 3);
              intersects2.push(intersection);
            }
          }
        }
      }
    } else if (geometry.isGeometry) {
      console.error("THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }
}
Mesh2.prototype.isMesh = true;
function checkIntersection(object, material, raycaster, ray2, pA, pB, pC, point2) {
  let intersect2;
  if (material.side === BackSide) {
    intersect2 = ray2.intersectTriangle(pC, pB, pA, true, point2);
  } else {
    intersect2 = ray2.intersectTriangle(pA, pB, pC, material.side !== DoubleSide, point2);
  }
  if (intersect2 === null) return null;
  _intersectionPointWorld.copy(point2);
  _intersectionPointWorld.applyMatrix4(object.matrixWorld);
  const distance2 = raycaster.ray.origin.distanceTo(_intersectionPointWorld);
  if (distance2 < raycaster.near || distance2 > raycaster.far) return null;
  return {
    distance: distance2,
    point: _intersectionPointWorld.clone(),
    object
  };
}
function checkBufferGeometryIntersection(object, material, raycaster, ray2, position2, morphPosition, morphTargetsRelative, uv, uv2, a3, b, c2) {
  _vA$1.fromBufferAttribute(position2, a3);
  _vB$1.fromBufferAttribute(position2, b);
  _vC$1.fromBufferAttribute(position2, c2);
  const morphInfluences = object.morphTargetInfluences;
  if (morphPosition && morphInfluences) {
    _morphA.set(0, 0, 0);
    _morphB.set(0, 0, 0);
    _morphC.set(0, 0, 0);
    for (let i2 = 0, il = morphPosition.length; i2 < il; i2++) {
      const influence = morphInfluences[i2];
      const morphAttribute = morphPosition[i2];
      if (influence === 0) continue;
      _tempA.fromBufferAttribute(morphAttribute, a3);
      _tempB.fromBufferAttribute(morphAttribute, b);
      _tempC.fromBufferAttribute(morphAttribute, c2);
      if (morphTargetsRelative) {
        _morphA.addScaledVector(_tempA, influence);
        _morphB.addScaledVector(_tempB, influence);
        _morphC.addScaledVector(_tempC, influence);
      } else {
        _morphA.addScaledVector(_tempA.sub(_vA$1), influence);
        _morphB.addScaledVector(_tempB.sub(_vB$1), influence);
        _morphC.addScaledVector(_tempC.sub(_vC$1), influence);
      }
    }
    _vA$1.add(_morphA);
    _vB$1.add(_morphB);
    _vC$1.add(_morphC);
  }
  if (object.isSkinnedMesh) {
    object.boneTransform(a3, _vA$1);
    object.boneTransform(b, _vB$1);
    object.boneTransform(c2, _vC$1);
  }
  const intersection = checkIntersection(object, material, raycaster, ray2, _vA$1, _vB$1, _vC$1, _intersectionPoint);
  if (intersection) {
    if (uv) {
      _uvA$1.fromBufferAttribute(uv, a3);
      _uvB$1.fromBufferAttribute(uv, b);
      _uvC$1.fromBufferAttribute(uv, c2);
      intersection.uv = Triangle2.getUV(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector22());
    }
    if (uv2) {
      _uvA$1.fromBufferAttribute(uv2, a3);
      _uvB$1.fromBufferAttribute(uv2, b);
      _uvC$1.fromBufferAttribute(uv2, c2);
      intersection.uv2 = Triangle2.getUV(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector22());
    }
    const face = {
      a: a3,
      b,
      c: c2,
      normal: new Vector32(),
      materialIndex: 0
    };
    Triangle2.getNormal(_vA$1, _vB$1, _vC$1, face.normal);
    intersection.face = face;
  }
  return intersection;
}
class BoxGeometry2 extends BufferGeometry2 {
  constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1) {
    super();
    this.type = "BoxGeometry";
    this.parameters = {
      width,
      height,
      depth,
      widthSegments,
      heightSegments,
      depthSegments
    };
    const scope = this;
    widthSegments = Math.floor(widthSegments);
    heightSegments = Math.floor(heightSegments);
    depthSegments = Math.floor(depthSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let numberOfVertices = 0;
    let groupStart = 0;
    buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0);
    buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1);
    buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2);
    buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3);
    buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4);
    buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5);
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute2(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute2(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute2(uvs, 2));
    function buildPlane(u3, v, w, udir, vdir, width2, height2, depth2, gridX, gridY, materialIndex) {
      const segmentWidth = width2 / gridX;
      const segmentHeight = height2 / gridY;
      const widthHalf = width2 / 2;
      const heightHalf = height2 / 2;
      const depthHalf = depth2 / 2;
      const gridX1 = gridX + 1;
      const gridY1 = gridY + 1;
      let vertexCounter = 0;
      let groupCount = 0;
      const vector = new Vector32();
      for (let iy = 0; iy < gridY1; iy++) {
        const y = iy * segmentHeight - heightHalf;
        for (let ix = 0; ix < gridX1; ix++) {
          const x = ix * segmentWidth - widthHalf;
          vector[u3] = x * udir;
          vector[v] = y * vdir;
          vector[w] = depthHalf;
          vertices.push(vector.x, vector.y, vector.z);
          vector[u3] = 0;
          vector[v] = 0;
          vector[w] = depth2 > 0 ? 1 : -1;
          normals.push(vector.x, vector.y, vector.z);
          uvs.push(ix / gridX);
          uvs.push(1 - iy / gridY);
          vertexCounter += 1;
        }
      }
      for (let iy = 0; iy < gridY; iy++) {
        for (let ix = 0; ix < gridX; ix++) {
          const a3 = numberOfVertices + ix + gridX1 * iy;
          const b = numberOfVertices + ix + gridX1 * (iy + 1);
          const c2 = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
          const d2 = numberOfVertices + (ix + 1) + gridX1 * iy;
          indices.push(a3, b, d2);
          indices.push(b, c2, d2);
          groupCount += 6;
        }
      }
      scope.addGroup(groupStart, groupCount, materialIndex);
      groupStart += groupCount;
      numberOfVertices += vertexCounter;
    }
  }
  static fromJSON(data) {
    return new BoxGeometry2(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
  }
}
function cloneUniforms(src) {
  const dst = {};
  for (const u3 in src) {
    dst[u3] = {};
    for (const p2 in src[u3]) {
      const property = src[u3][p2];
      if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
        dst[u3][p2] = property.clone();
      } else if (Array.isArray(property)) {
        dst[u3][p2] = property.slice();
      } else {
        dst[u3][p2] = property;
      }
    }
  }
  return dst;
}
function mergeUniforms(uniforms) {
  const merged = {};
  for (let u3 = 0; u3 < uniforms.length; u3++) {
    const tmp2 = cloneUniforms(uniforms[u3]);
    for (const p2 in tmp2) {
      merged[p2] = tmp2[p2];
    }
  }
  return merged;
}
const UniformsUtils = { clone: cloneUniforms, merge: mergeUniforms };
var default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class ShaderMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.type = "ShaderMaterial";
    this.defines = {};
    this.uniforms = {};
    this.vertexShader = default_vertex;
    this.fragmentShader = default_fragment;
    this.linewidth = 1;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.lights = false;
    this.clipping = false;
    this.extensions = {
      derivatives: false,
      // set to use derivatives
      fragDepth: false,
      // set to use fragment depth values
      drawBuffers: false,
      // set to use draw buffers
      shaderTextureLOD: false
      // set to use shader texture LOD
    };
    this.defaultAttributeValues = {
      "color": [1, 1, 1],
      "uv": [0, 0],
      "uv2": [0, 0]
    };
    this.index0AttributeName = void 0;
    this.uniformsNeedUpdate = false;
    this.glslVersion = null;
    if (parameters !== void 0) {
      if (parameters.attributes !== void 0) {
        console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.");
      }
      this.setValues(parameters);
    }
  }
  copy(source) {
    super.copy(source);
    this.fragmentShader = source.fragmentShader;
    this.vertexShader = source.vertexShader;
    this.uniforms = cloneUniforms(source.uniforms);
    this.defines = Object.assign({}, source.defines);
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.lights = source.lights;
    this.clipping = source.clipping;
    this.extensions = Object.assign({}, source.extensions);
    this.glslVersion = source.glslVersion;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.glslVersion = this.glslVersion;
    data.uniforms = {};
    for (const name in this.uniforms) {
      const uniform = this.uniforms[name];
      const value = uniform.value;
      if (value && value.isTexture) {
        data.uniforms[name] = {
          type: "t",
          value: value.toJSON(meta).uuid
        };
      } else if (value && value.isColor) {
        data.uniforms[name] = {
          type: "c",
          value: value.getHex()
        };
      } else if (value && value.isVector2) {
        data.uniforms[name] = {
          type: "v2",
          value: value.toArray()
        };
      } else if (value && value.isVector3) {
        data.uniforms[name] = {
          type: "v3",
          value: value.toArray()
        };
      } else if (value && value.isVector4) {
        data.uniforms[name] = {
          type: "v4",
          value: value.toArray()
        };
      } else if (value && value.isMatrix3) {
        data.uniforms[name] = {
          type: "m3",
          value: value.toArray()
        };
      } else if (value && value.isMatrix4) {
        data.uniforms[name] = {
          type: "m4",
          value: value.toArray()
        };
      } else {
        data.uniforms[name] = {
          value
        };
      }
    }
    if (Object.keys(this.defines).length > 0) data.defines = this.defines;
    data.vertexShader = this.vertexShader;
    data.fragmentShader = this.fragmentShader;
    const extensions = {};
    for (const key in this.extensions) {
      if (this.extensions[key] === true) extensions[key] = true;
    }
    if (Object.keys(extensions).length > 0) data.extensions = extensions;
    return data;
  }
}
ShaderMaterial2.prototype.isShaderMaterial = true;
class Camera2 extends Object3D2 {
  constructor() {
    super();
    this.type = "Camera";
    this.matrixWorldInverse = new Matrix42();
    this.projectionMatrix = new Matrix42();
    this.projectionMatrixInverse = new Matrix42();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.matrixWorldInverse.copy(source.matrixWorldInverse);
    this.projectionMatrix.copy(source.projectionMatrix);
    this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
    return this;
  }
  getWorldDirection(target) {
    this.updateWorldMatrix(true, false);
    const e2 = this.matrixWorld.elements;
    return target.set(-e2[8], -e2[9], -e2[10]).normalize();
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(updateParents, updateChildren) {
    super.updateWorldMatrix(updateParents, updateChildren);
    this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
Camera2.prototype.isCamera = true;
class PerspectiveCamera2 extends Camera2 {
  constructor(fov2 = 50, aspect2 = 1, near = 0.1, far = 2e3) {
    super();
    this.type = "PerspectiveCamera";
    this.fov = fov2;
    this.zoom = 1;
    this.near = near;
    this.far = far;
    this.focus = 10;
    this.aspect = aspect2;
    this.view = null;
    this.filmGauge = 35;
    this.filmOffset = 0;
    this.updateProjectionMatrix();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.fov = source.fov;
    this.zoom = source.zoom;
    this.near = source.near;
    this.far = source.far;
    this.focus = source.focus;
    this.aspect = source.aspect;
    this.view = source.view === null ? null : Object.assign({}, source.view);
    this.filmGauge = source.filmGauge;
    this.filmOffset = source.filmOffset;
    return this;
  }
  /**
   * Sets the FOV by focal length in respect to the current .filmGauge.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(focalLength) {
    const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
    this.fov = RAD2DEG * 2 * Math.atan(vExtentSlope);
    this.updateProjectionMatrix();
  }
  /**
   * Calculates the focal length from the current .fov and .filmGauge.
   */
  getFocalLength() {
    const vExtentSlope = Math.tan(DEG2RAD * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / vExtentSlope;
  }
  getEffectiveFOV() {
    return RAD2DEG * 2 * Math.atan(
      Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom
    );
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *
   * then for each monitor you would call it like this
   *
   *   const w = 1920;
   *   const h = 1080;
   *   const fullWidth = w * 3;
   *   const fullHeight = h * 2;
   *
   *   --A--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   *   --B--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   *   --C--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   *   --D--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   *   --E--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   *   --F--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   *
   *   Note there is no reason monitors have to be the same size or in a grid.
   */
  setViewOffset(fullWidth, fullHeight, x, y, width, height) {
    this.aspect = fullWidth / fullHeight;
    if (this.view === null) {
      this.view = {
        enabled: true,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      };
    }
    this.view.enabled = true;
    this.view.fullWidth = fullWidth;
    this.view.fullHeight = fullHeight;
    this.view.offsetX = x;
    this.view.offsetY = y;
    this.view.width = width;
    this.view.height = height;
    this.updateProjectionMatrix();
  }
  clearViewOffset() {
    if (this.view !== null) {
      this.view.enabled = false;
    }
    this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const near = this.near;
    let top = near * Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom;
    let height = 2 * top;
    let width = this.aspect * height;
    let left = -0.5 * width;
    const view = this.view;
    if (this.view !== null && this.view.enabled) {
      const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
      left += view.offsetX * width / fullWidth;
      top -= view.offsetY * height / fullHeight;
      width *= view.width / fullWidth;
      height *= view.height / fullHeight;
    }
    const skew = this.filmOffset;
    if (skew !== 0) left += near * skew / this.getFilmWidth();
    this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
    this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.fov = this.fov;
    data.object.zoom = this.zoom;
    data.object.near = this.near;
    data.object.far = this.far;
    data.object.focus = this.focus;
    data.object.aspect = this.aspect;
    if (this.view !== null) data.object.view = Object.assign({}, this.view);
    data.object.filmGauge = this.filmGauge;
    data.object.filmOffset = this.filmOffset;
    return data;
  }
}
PerspectiveCamera2.prototype.isPerspectiveCamera = true;
const fov = 90, aspect = 1;
class CubeCamera2 extends Object3D2 {
  constructor(near, far, renderTarget) {
    super();
    this.type = "CubeCamera";
    if (renderTarget.isWebGLCubeRenderTarget !== true) {
      console.error("THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.");
      return;
    }
    this.renderTarget = renderTarget;
    const cameraPX = new PerspectiveCamera2(fov, aspect, near, far);
    cameraPX.layers = this.layers;
    cameraPX.up.set(0, -1, 0);
    cameraPX.lookAt(new Vector32(1, 0, 0));
    this.add(cameraPX);
    const cameraNX = new PerspectiveCamera2(fov, aspect, near, far);
    cameraNX.layers = this.layers;
    cameraNX.up.set(0, -1, 0);
    cameraNX.lookAt(new Vector32(-1, 0, 0));
    this.add(cameraNX);
    const cameraPY = new PerspectiveCamera2(fov, aspect, near, far);
    cameraPY.layers = this.layers;
    cameraPY.up.set(0, 0, 1);
    cameraPY.lookAt(new Vector32(0, 1, 0));
    this.add(cameraPY);
    const cameraNY = new PerspectiveCamera2(fov, aspect, near, far);
    cameraNY.layers = this.layers;
    cameraNY.up.set(0, 0, -1);
    cameraNY.lookAt(new Vector32(0, -1, 0));
    this.add(cameraNY);
    const cameraPZ = new PerspectiveCamera2(fov, aspect, near, far);
    cameraPZ.layers = this.layers;
    cameraPZ.up.set(0, -1, 0);
    cameraPZ.lookAt(new Vector32(0, 0, 1));
    this.add(cameraPZ);
    const cameraNZ = new PerspectiveCamera2(fov, aspect, near, far);
    cameraNZ.layers = this.layers;
    cameraNZ.up.set(0, -1, 0);
    cameraNZ.lookAt(new Vector32(0, 0, -1));
    this.add(cameraNZ);
  }
  update(renderer, scene) {
    if (this.parent === null) this.updateMatrixWorld();
    const renderTarget = this.renderTarget;
    const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
    const currentXrEnabled = renderer.xr.enabled;
    const currentRenderTarget = renderer.getRenderTarget();
    renderer.xr.enabled = false;
    const generateMipmaps = renderTarget.texture.generateMipmaps;
    renderTarget.texture.generateMipmaps = false;
    renderer.setRenderTarget(renderTarget, 0);
    renderer.render(scene, cameraPX);
    renderer.setRenderTarget(renderTarget, 1);
    renderer.render(scene, cameraNX);
    renderer.setRenderTarget(renderTarget, 2);
    renderer.render(scene, cameraPY);
    renderer.setRenderTarget(renderTarget, 3);
    renderer.render(scene, cameraNY);
    renderer.setRenderTarget(renderTarget, 4);
    renderer.render(scene, cameraPZ);
    renderTarget.texture.generateMipmaps = generateMipmaps;
    renderer.setRenderTarget(renderTarget, 5);
    renderer.render(scene, cameraNZ);
    renderer.setRenderTarget(currentRenderTarget);
    renderer.xr.enabled = currentXrEnabled;
  }
}
class CubeTexture2 extends Texture2 {
  constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding) {
    images = images !== void 0 ? images : [];
    mapping = mapping !== void 0 ? mapping : CubeReflectionMapping;
    format = format !== void 0 ? format : RGBFormat;
    super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.flipY = false;
  }
  get images() {
    return this.image;
  }
  set images(value) {
    this.image = value;
  }
}
CubeTexture2.prototype.isCubeTexture = true;
class WebGLCubeRenderTarget2 extends WebGLRenderTarget2 {
  constructor(size, options, dummy) {
    if (Number.isInteger(options)) {
      console.warn("THREE.WebGLCubeRenderTarget: constructor signature is now WebGLCubeRenderTarget( size, options )");
      options = dummy;
    }
    super(size, size, options);
    options = options || {};
    this.texture = new CubeTexture2(void 0, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
    this.texture.isRenderTargetTexture = true;
    this.texture.generateMipmaps = options.generateMipmaps !== void 0 ? options.generateMipmaps : false;
    this.texture.minFilter = options.minFilter !== void 0 ? options.minFilter : LinearFilter;
    this.texture._needsFlipEnvMap = false;
  }
  fromEquirectangularTexture(renderer, texture) {
    this.texture.type = texture.type;
    this.texture.format = RGBAFormat;
    this.texture.encoding = texture.encoding;
    this.texture.generateMipmaps = texture.generateMipmaps;
    this.texture.minFilter = texture.minFilter;
    this.texture.magFilter = texture.magFilter;
    const shader = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: (
        /* glsl */
        `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
      ),
      fragmentShader: (
        /* glsl */
        `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
      )
    };
    const geometry = new BoxGeometry2(5, 5, 5);
    const material = new ShaderMaterial2({
      name: "CubemapFromEquirect",
      uniforms: cloneUniforms(shader.uniforms),
      vertexShader: shader.vertexShader,
      fragmentShader: shader.fragmentShader,
      side: BackSide,
      blending: NoBlending
    });
    material.uniforms.tEquirect.value = texture;
    const mesh = new Mesh2(geometry, material);
    const currentMinFilter = texture.minFilter;
    if (texture.minFilter === LinearMipmapLinearFilter) texture.minFilter = LinearFilter;
    const camera = new CubeCamera2(1, 10, this);
    camera.update(renderer, mesh);
    texture.minFilter = currentMinFilter;
    mesh.geometry.dispose();
    mesh.material.dispose();
    return this;
  }
  clear(renderer, color2, depth, stencil) {
    const currentRenderTarget = renderer.getRenderTarget();
    for (let i2 = 0; i2 < 6; i2++) {
      renderer.setRenderTarget(this, i2);
      renderer.clear(color2, depth, stencil);
    }
    renderer.setRenderTarget(currentRenderTarget);
  }
}
WebGLCubeRenderTarget2.prototype.isWebGLCubeRenderTarget = true;
const _vector1 = /* @__PURE__ */ new Vector32();
const _vector2 = /* @__PURE__ */ new Vector32();
const _normalMatrix = /* @__PURE__ */ new Matrix32();
class Plane2 {
  constructor(normal = new Vector32(1, 0, 0), constant = 0) {
    this.normal = normal;
    this.constant = constant;
  }
  set(normal, constant) {
    this.normal.copy(normal);
    this.constant = constant;
    return this;
  }
  setComponents(x, y, z2, w) {
    this.normal.set(x, y, z2);
    this.constant = w;
    return this;
  }
  setFromNormalAndCoplanarPoint(normal, point2) {
    this.normal.copy(normal);
    this.constant = -point2.dot(this.normal);
    return this;
  }
  setFromCoplanarPoints(a3, b, c2) {
    const normal = _vector1.subVectors(c2, b).cross(_vector2.subVectors(a3, b)).normalize();
    this.setFromNormalAndCoplanarPoint(normal, a3);
    return this;
  }
  copy(plane) {
    this.normal.copy(plane.normal);
    this.constant = plane.constant;
    return this;
  }
  normalize() {
    const inverseNormalLength = 1 / this.normal.length();
    this.normal.multiplyScalar(inverseNormalLength);
    this.constant *= inverseNormalLength;
    return this;
  }
  negate() {
    this.constant *= -1;
    this.normal.negate();
    return this;
  }
  distanceToPoint(point2) {
    return this.normal.dot(point2) + this.constant;
  }
  distanceToSphere(sphere) {
    return this.distanceToPoint(sphere.center) - sphere.radius;
  }
  projectPoint(point2, target) {
    return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point2)).add(point2);
  }
  intersectLine(line, target) {
    const direction2 = line.delta(_vector1);
    const denominator = this.normal.dot(direction2);
    if (denominator === 0) {
      if (this.distanceToPoint(line.start) === 0) {
        return target.copy(line.start);
      }
      return null;
    }
    const t3 = -(line.start.dot(this.normal) + this.constant) / denominator;
    if (t3 < 0 || t3 > 1) {
      return null;
    }
    return target.copy(direction2).multiplyScalar(t3).add(line.start);
  }
  intersectsLine(line) {
    const startSign = this.distanceToPoint(line.start);
    const endSign = this.distanceToPoint(line.end);
    return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
  }
  intersectsBox(box) {
    return box.intersectsPlane(this);
  }
  intersectsSphere(sphere) {
    return sphere.intersectsPlane(this);
  }
  coplanarPoint(target) {
    return target.copy(this.normal).multiplyScalar(-this.constant);
  }
  applyMatrix4(matrix2, optionalNormalMatrix) {
    const normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix(matrix2);
    const referencePoint = this.coplanarPoint(_vector1).applyMatrix4(matrix2);
    const normal = this.normal.applyMatrix3(normalMatrix).normalize();
    this.constant = -referencePoint.dot(normal);
    return this;
  }
  translate(offset) {
    this.constant -= offset.dot(this.normal);
    return this;
  }
  equals(plane) {
    return plane.normal.equals(this.normal) && plane.constant === this.constant;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
Plane2.prototype.isPlane = true;
const _sphere$2 = /* @__PURE__ */ new Sphere2();
const _vector$7 = /* @__PURE__ */ new Vector32();
class Frustum2 {
  constructor(p0 = new Plane2(), p1 = new Plane2(), p2 = new Plane2(), p3 = new Plane2(), p4 = new Plane2(), p5 = new Plane2()) {
    this.planes = [p0, p1, p2, p3, p4, p5];
  }
  set(p0, p1, p2, p3, p4, p5) {
    const planes = this.planes;
    planes[0].copy(p0);
    planes[1].copy(p1);
    planes[2].copy(p2);
    planes[3].copy(p3);
    planes[4].copy(p4);
    planes[5].copy(p5);
    return this;
  }
  copy(frustum) {
    const planes = this.planes;
    for (let i2 = 0; i2 < 6; i2++) {
      planes[i2].copy(frustum.planes[i2]);
    }
    return this;
  }
  setFromProjectionMatrix(m) {
    const planes = this.planes;
    const me = m.elements;
    const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
    const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
    const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
    const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
    planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
    planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
    planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
    planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
    planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
    planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
    return this;
  }
  intersectsObject(object) {
    const geometry = object.geometry;
    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
    _sphere$2.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
    return this.intersectsSphere(_sphere$2);
  }
  intersectsSprite(sprite) {
    _sphere$2.center.set(0, 0, 0);
    _sphere$2.radius = 0.7071067811865476;
    _sphere$2.applyMatrix4(sprite.matrixWorld);
    return this.intersectsSphere(_sphere$2);
  }
  intersectsSphere(sphere) {
    const planes = this.planes;
    const center = sphere.center;
    const negRadius = -sphere.radius;
    for (let i2 = 0; i2 < 6; i2++) {
      const distance2 = planes[i2].distanceToPoint(center);
      if (distance2 < negRadius) {
        return false;
      }
    }
    return true;
  }
  intersectsBox(box) {
    const planes = this.planes;
    for (let i2 = 0; i2 < 6; i2++) {
      const plane = planes[i2];
      _vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
      _vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
      _vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
      if (plane.distanceToPoint(_vector$7) < 0) {
        return false;
      }
    }
    return true;
  }
  containsPoint(point2) {
    const planes = this.planes;
    for (let i2 = 0; i2 < 6; i2++) {
      if (planes[i2].distanceToPoint(point2) < 0) {
        return false;
      }
    }
    return true;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
function WebGLAnimation() {
  let context = null;
  let isAnimating = false;
  let animationLoop = null;
  let requestId = null;
  function onAnimationFrame(time2, frame) {
    animationLoop(time2, frame);
    requestId = context.requestAnimationFrame(onAnimationFrame);
  }
  return {
    start: function() {
      if (isAnimating === true) return;
      if (animationLoop === null) return;
      requestId = context.requestAnimationFrame(onAnimationFrame);
      isAnimating = true;
    },
    stop: function() {
      context.cancelAnimationFrame(requestId);
      isAnimating = false;
    },
    setAnimationLoop: function(callback) {
      animationLoop = callback;
    },
    setContext: function(value) {
      context = value;
    }
  };
}
function WebGLAttributes(gl, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  const buffers = /* @__PURE__ */ new WeakMap();
  function createBuffer(attribute, bufferType) {
    const array = attribute.array;
    const usage = attribute.usage;
    const buffer = gl.createBuffer();
    gl.bindBuffer(bufferType, buffer);
    gl.bufferData(bufferType, array, usage);
    attribute.onUploadCallback();
    let type = 5126;
    if (array instanceof Float32Array) {
      type = 5126;
    } else if (array instanceof Float64Array) {
      console.warn("THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.");
    } else if (array instanceof Uint16Array) {
      if (attribute.isFloat16BufferAttribute) {
        if (isWebGL2) {
          type = 5131;
        } else {
          console.warn("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
        }
      } else {
        type = 5123;
      }
    } else if (array instanceof Int16Array) {
      type = 5122;
    } else if (array instanceof Uint32Array) {
      type = 5125;
    } else if (array instanceof Int32Array) {
      type = 5124;
    } else if (array instanceof Int8Array) {
      type = 5120;
    } else if (array instanceof Uint8Array) {
      type = 5121;
    } else if (array instanceof Uint8ClampedArray) {
      type = 5121;
    }
    return {
      buffer,
      type,
      bytesPerElement: array.BYTES_PER_ELEMENT,
      version: attribute.version
    };
  }
  function updateBuffer(buffer, attribute, bufferType) {
    const array = attribute.array;
    const updateRange = attribute.updateRange;
    gl.bindBuffer(bufferType, buffer);
    if (updateRange.count === -1) {
      gl.bufferSubData(bufferType, 0, array);
    } else {
      if (isWebGL2) {
        gl.bufferSubData(
          bufferType,
          updateRange.offset * array.BYTES_PER_ELEMENT,
          array,
          updateRange.offset,
          updateRange.count
        );
      } else {
        gl.bufferSubData(
          bufferType,
          updateRange.offset * array.BYTES_PER_ELEMENT,
          array.subarray(updateRange.offset, updateRange.offset + updateRange.count)
        );
      }
      updateRange.count = -1;
    }
  }
  function get(attribute) {
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    return buffers.get(attribute);
  }
  function remove(attribute) {
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    const data = buffers.get(attribute);
    if (data) {
      gl.deleteBuffer(data.buffer);
      buffers.delete(attribute);
    }
  }
  function update(attribute, bufferType) {
    if (attribute.isGLBufferAttribute) {
      const cached = buffers.get(attribute);
      if (!cached || cached.version < attribute.version) {
        buffers.set(attribute, {
          buffer: attribute.buffer,
          type: attribute.type,
          bytesPerElement: attribute.elementSize,
          version: attribute.version
        });
      }
      return;
    }
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    const data = buffers.get(attribute);
    if (data === void 0) {
      buffers.set(attribute, createBuffer(attribute, bufferType));
    } else if (data.version < attribute.version) {
      updateBuffer(data.buffer, attribute, bufferType);
      data.version = attribute.version;
    }
  }
  return {
    get,
    remove,
    update
  };
}
class PlaneGeometry2 extends BufferGeometry2 {
  constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1) {
    super();
    this.type = "PlaneGeometry";
    this.parameters = {
      width,
      height,
      widthSegments,
      heightSegments
    };
    const width_half = width / 2;
    const height_half = height / 2;
    const gridX = Math.floor(widthSegments);
    const gridY = Math.floor(heightSegments);
    const gridX1 = gridX + 1;
    const gridY1 = gridY + 1;
    const segment_width = width / gridX;
    const segment_height = height / gridY;
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    for (let iy = 0; iy < gridY1; iy++) {
      const y = iy * segment_height - height_half;
      for (let ix = 0; ix < gridX1; ix++) {
        const x = ix * segment_width - width_half;
        vertices.push(x, -y, 0);
        normals.push(0, 0, 1);
        uvs.push(ix / gridX);
        uvs.push(1 - iy / gridY);
      }
    }
    for (let iy = 0; iy < gridY; iy++) {
      for (let ix = 0; ix < gridX; ix++) {
        const a3 = ix + gridX1 * iy;
        const b = ix + gridX1 * (iy + 1);
        const c2 = ix + 1 + gridX1 * (iy + 1);
        const d2 = ix + 1 + gridX1 * iy;
        indices.push(a3, b, d2);
        indices.push(b, c2, d2);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute2(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute2(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute2(uvs, 2));
  }
  static fromJSON(data) {
    return new PlaneGeometry2(data.width, data.height, data.widthSegments, data.heightSegments);
  }
}
var alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var alphatest_fragment = "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif";
var alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var begin_vertex = "vec3 transformed = vec3( position );";
var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var bsdfs = "vec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_GGX( const in IncidentLight incidentLight, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( incidentLight.direction + viewDir );\n	float dotNL = saturate( dot( normal, incidentLight.direction ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n	float D = D_GGX( alpha, dotNH );\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\nfloat G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n	float dotNH = saturate( dot( geometry.normal, halfDir ) );\n	float dotVH = saturate( dot( geometry.viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float NoH ) {\n	float invAlpha = 1.0 / roughness;\n	float cos2h = NoH * NoH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float NoV, float NoL ) {\n	return saturate( 1.0 / ( 4.0 * ( NoL + NoV - NoL * NoV ) ) );\n}\nvec3 BRDF_Sheen( const in float roughness, const in vec3 L, const in GeometricContext geometry, vec3 specularColor ) {\n	vec3 N = geometry.normal;\n	vec3 V = geometry.viewDir;\n	vec3 H = normalize( V + L );\n	float dotNH = saturate( dot( N, H ) );\n	return specularColor * D_Charlie( roughness, dotNH ) * V_Neubelt( dot(N, V), dot(N, L) );\n}\n#endif";
var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vUv );\n		vec2 dSTdy = dFdy( vUv );\n		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n		vec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif";
var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif";
var color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif";
var common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\nstruct GeometricContext {\n	vec3 position;\n	vec3 normal;\n	vec3 viewDir;\n#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n	vec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n	return dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}";
var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_maxMipLevel 8.0\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_maxTileSize 256.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		float texelSize = 1.0 / ( 3.0 * cubeUV_maxTileSize );\n		vec2 uv = getUV( direction, face ) * ( faceSize - 1.0 );\n		vec2 f = fract( uv );\n		uv += 0.5 - f;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		if ( mipInt < cubeUV_maxMipLevel ) {\n			uv.y += 2.0 * cubeUV_maxTileSize;\n		}\n		uv.y += filterInt * 2.0 * cubeUV_minTileSize;\n		uv.x += 3.0 * max( 0.0, cubeUV_maxTileSize - 2.0 * faceSize );\n		uv *= texelSize;\n		vec3 tl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n		uv.x += texelSize;\n		vec3 tr = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n		uv.y += texelSize;\n		vec3 br = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n		uv.x -= texelSize;\n		vec3 bl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n		vec3 tm = mix( tl, tr, f.x );\n		vec3 bm = mix( bl, br, f.x );\n		return mix( tm, bm, f.y );\n	}\n	#define r0 1.0\n	#define v0 0.339\n	#define m0 - 2.0\n	#define r1 0.8\n	#define v1 0.276\n	#define m1 - 1.0\n	#define r4 0.4\n	#define v4 0.046\n	#define m4 2.0\n	#define r5 0.305\n	#define v5 0.016\n	#define m5 3.0\n	#define r6 0.21\n	#define v6 0.0038\n	#define m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= r1 ) {\n			mip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n		} else if ( roughness >= r4 ) {\n			mip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n		} else if ( roughness >= r5 ) {\n			mip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n		} else if ( roughness >= r6 ) {\n			mip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), m0, cubeUV_maxMipLevel );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vUv );\n	emissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n	return vec4( pow( value.rgb, vec3( gammaFactor ) ), value.a );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n	return vec4( pow( value.rgb, vec3( 1.0 / gammaFactor ) ), value.a );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n	return vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n	float maxComponent = max( max( value.r, value.g ), value.b );\n	float fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n	return vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n	return vec4( value.rgb * value.a * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n	float maxRGB = max( value.r, max( value.g, value.b ) );\n	float M = clamp( maxRGB / maxRange, 0.0, 1.0 );\n	M = ceil( M * 255.0 ) / 255.0;\n	return vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n	return vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n	float maxRGB = max( value.r, max( value.g, value.b ) );\n	float D = max( maxRange / maxRGB, 1.0 );\n	D = clamp( floor( D ) / 255.0, 0.0, 1.0 );\n	return vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value ) {\n	vec3 Xp_Y_XYZp = cLogLuvM * value.rgb;\n	Xp_Y_XYZp = max( Xp_Y_XYZp, vec3( 1e-6, 1e-6, 1e-6 ) );\n	vec4 vResult;\n	vResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n	float Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n	vResult.w = fract( Le );\n	vResult.z = ( Le - ( floor( vResult.w * 255.0 ) ) / 255.0 ) / 255.0;\n	return vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n	float Le = value.z * 255.0 + value.w;\n	vec3 Xp_Y_XYZp;\n	Xp_Y_XYZp.y = exp2( ( Le - 127.0 ) / 2.0 );\n	Xp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n	Xp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n	vec3 vRGB = cLogLuvInverseM * Xp_Y_XYZp.rgb;\n	return vec4( max( vRGB, 0.0 ), 1.0 );\n}";
var envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n		envColor = envMapTexelToLinear( envColor );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	uniform int maxMipLevel;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return texture2D( gradientMap, coord ).rgb;\n	#else\n		return ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n	#endif\n}";
var lightmap_fragment = "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vUv2 );\n	vec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n	#ifndef PHYSICALLY_CORRECT_LIGHTS\n		lightMapIrradiance *= PI;\n	#endif\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n	vLightBack = vec3( 0.0 );\n	vIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry );\n#ifdef DOUBLE_SIDED\n	vIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n	vIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry );\n#endif\n#if NUM_POINT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		getPointLightInfo( pointLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		getSpotLightInfo( spotLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		getDirectionalLightInfo( directionalLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n		vIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n		#ifdef DOUBLE_SIDED\n			vIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif";
var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in GeometricContext geometry ) {\n	vec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#else\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n		float dotNL = dot( geometry.normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n	#ifdef ENVMAP_MODE_REFRACTION\n		uniform float refractionRatio;\n	#endif\n	vec3 getIBLIrradiance( const in GeometricContext geometry ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 reflectVec;\n			#ifdef ENVMAP_MODE_REFLECTION\n				reflectVec = reflect( - viewDir, normal );\n				reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			#else\n				reflectVec = refract( - viewDir, normal, refractionRatio );\n			#endif\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n#endif";
var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )	(0)";
var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )	(0)";
var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	#ifdef SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularTintFactor = specularTint;\n		#ifdef USE_SPECULARINTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n		#endif\n		#ifdef USE_SPECULARTINTMAP\n			specularTintFactor *= specularTintMapTexelToLinear( texture2D( specularTintMap, vUv ) ).rgb;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularTintFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( ior - 1.0 ) / ( ior + 1.0 ) ) * specularTintFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n	material.sheenTint = sheenTint;\n#endif";
var lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenTint;\n	#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	vec3 FssEss = specularColor * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometry.normal;\n		vec3 viewDir = geometry.viewDir;\n		vec3 position = geometry.position;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecular += ccIrradiance * BRDF_GGX( directLight, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		reflectedLight.directSpecular += irradiance * BRDF_Sheen( material.roughness, directLight.direction, geometry, material.sheenTint );\n	#else\n		reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );\n	#endif\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	vec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n	geometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	irradiance += getLightProbeIrradiance( lightProbe, geometry );\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vUv2 );\n		vec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n		#ifndef PHYSICALLY_CORRECT_LIGHTS\n			lightMapIrradiance *= PI;\n		#endif\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometry );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif";
var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif";
var map_fragment = "#ifdef USE_MAP\n	vec4 texelColor = texture2D( map, vUv );\n	texelColor = mapTexelToLinear( texelColor );\n	diffuseColor *= texelColor;\n#endif";
var map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n	vec4 mapTexel = texture2D( map, uv );\n	diffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	uniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n	objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n	objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n	objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n#endif";
var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifndef USE_MORPHNORMALS\n		uniform float morphTargetInfluences[ 8 ];\n	#else\n		uniform float morphTargetInfluences[ 4 ];\n	#endif\n#endif";
var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n	transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n	transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n	transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n	#ifndef USE_MORPHNORMALS\n		transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n		transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n		transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n		transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n	#endif\n#endif";
var normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n	vec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	#ifdef USE_TANGENT\n		vec3 tangent = normalize( vTangent );\n		vec3 bitangent = normalize( vBitangent );\n		#ifdef DOUBLE_SIDED\n			tangent = tangent * faceDirection;\n			bitangent = bitangent * faceDirection;\n		#endif\n		#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n			mat3 vTBN = mat3( tangent, bitangent, normal );\n		#endif\n	#endif\n#endif\nvec3 geometryNormal = normal;";
var normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n	normal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n	vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	#ifdef USE_TANGENT\n		normal = normalize( vTBN * mapN );\n	#else\n		normal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );\n	#endif\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n	vec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n		vec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n		vec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n		vec2 st0 = dFdx( vUv.st );\n		vec2 st1 = dFdy( vUv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n		return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n	}\n#endif";
var clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = geometryNormal;\n#endif";
var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	#ifdef USE_TANGENT\n		clearcoatNormal = normalize( vTBN * clearcoatMapN );\n	#else\n		clearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n	#endif\n#endif";
var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif";
var output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n	return linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n		bool inFrustum = all( inFrustumVec );\n		bvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n		bool frustumTest = all( frustumTestVec );\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif";
var shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var shadowmap_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n		vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		vec4 shadowWorldPosition;\n	#endif\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n		vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n		vSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n		vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n#endif";
var shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	#ifdef BONE_TEXTURE\n		uniform highp sampler2D boneTexture;\n		uniform int boneTextureSize;\n		mat4 getBoneMatrix( const in float i ) {\n			float j = i * 4.0;\n			float x = mod( j, float( boneTextureSize ) );\n			float y = floor( j / float( boneTextureSize ) );\n			float dx = 1.0 / float( boneTextureSize );\n			float dy = 1.0 / float( boneTextureSize );\n			y = dy * ( y + 0.5 );\n			vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n			vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n			vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n			vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n			mat4 bone = mat4( v1, v2, v3, v4 );\n			return bone;\n		}\n	#else\n		uniform mat4 boneMatrices[ MAX_BONES ];\n		mat4 getBoneMatrix( const in float i ) {\n			mat4 bone = boneMatrices[ int(i) ];\n			return bone;\n		}\n	#endif\n#endif";
var skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var transmission_fragment = "#ifdef USE_TRANSMISSION\n	float transmissionAlpha = 1.0;\n	float transmissionFactor = transmission;\n	float thicknessFactor = thickness;\n	#ifdef USE_TRANSMISSIONMAP\n		transmissionFactor *= texture2D( transmissionMap, vUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		thicknessFactor *= texture2D( thicknessMap, vUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmission = getIBLVolumeRefraction(\n		n, v, roughnessFactor, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n		attenuationTint, attenuationDistance );\n	totalDiffuse = mix( totalDiffuse, transmission.rgb, transmissionFactor );\n	transmissionAlpha = transmission.a;\n#endif";
var transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationTint;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	vec3 getVolumeTransmissionRay( vec3 n, vec3 v, float thickness, float ior, mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( float roughness, float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( vec2 fragCoord, float roughness, float ior ) {\n		float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		#ifdef TEXTURE_LOD_EXT\n			return texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n		#else\n			return texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n		#endif\n	}\n	vec3 applyVolumeAttenuation( vec3 radiance, float transmissionDistance, vec3 attenuationColor, float attenuationDistance ) {\n		if ( attenuationDistance == 0.0 ) {\n			return radiance;\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance * radiance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( vec3 n, vec3 v, float roughness, vec3 diffuseColor, vec3 specularColor, float specularF90,\n		vec3 position, mat4 modelMatrix, mat4 viewMatrix, mat4 projMatrix, float ior, float thickness,\n		vec3 attenuationColor, float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n	}\n#endif";
var uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n	varying vec2 vUv;\n#endif";
var uv_pars_vertex = "#ifdef USE_UV\n	#ifdef UVS_VERTEX_ONLY\n		vec2 vUv;\n	#else\n		varying vec2 vUv;\n	#endif\n	uniform mat3 uvTransform;\n#endif";
var uv_vertex = "#ifdef USE_UV\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	varying vec2 vUv2;\n#endif";
var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	attribute vec2 uv2;\n	varying vec2 vUv2;\n	uniform mat3 uv2Transform;\n#endif";
var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	vUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
var background_frag = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	gl_FragColor = mapTexelToLinear( texColor );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
var background_vert = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
var cube_frag = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	vec3 vReflect = vWorldDirection;\n	#include <envmap_fragment>\n	gl_FragColor = envColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
var cube_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
var depth_frag = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}";
var depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
var distanceRGBA_frag = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
var distanceRGBA_vert = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
var equirect_frag = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	vec4 texColor = texture2D( tEquirect, sampleUV );\n	gl_FragColor = mapTexelToLinear( texColor );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
var equirect_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
var linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
var linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <color_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
var meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel= texture2D( lightMap, vUv2 );\n		reflectedLight.indirectDiffuse += lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
var meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <emissivemap_fragment>\n	#ifdef DOUBLE_SIDED\n		reflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n	#else\n		reflectedLight.indirectDiffuse += vIndirectFront;\n	#endif\n	#include <lightmap_fragment>\n	reflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );\n	#ifdef DOUBLE_SIDED\n		reflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n	#else\n		reflectedLight.directDiffuse = vLightFront;\n	#endif\n	reflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <lights_lambert_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
var meshmatcap_frag = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n		matcapColor = matcapTexelToLinear( matcapColor );\n	#else\n		vec4 matcapColor = vec4( 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var meshmatcap_vert = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
var meshnormal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}";
var meshnormal_vert = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
var meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
var meshphysical_frag = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularTint;\n	#ifdef USE_SPECULARINTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n	#ifdef USE_SPECULARTINTMAP\n		uniform sampler2D specularTintMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenTint;\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - clearcoat * Fcc ) + clearcoatSpecular * clearcoat;\n	#endif\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var meshphysical_vert = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
var meshtoon_frag = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
var meshtoon_vert = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
var points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
var points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <color_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
var shadow_frag = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
var shadow_vert = "#include <common>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <begin_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
var sprite_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
var sprite_vert = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const ShaderChunk = {
  alphamap_fragment,
  alphamap_pars_fragment,
  alphatest_fragment,
  alphatest_pars_fragment,
  aomap_fragment,
  aomap_pars_fragment,
  begin_vertex,
  beginnormal_vertex,
  bsdfs,
  bumpmap_pars_fragment,
  clipping_planes_fragment,
  clipping_planes_pars_fragment,
  clipping_planes_pars_vertex,
  clipping_planes_vertex,
  color_fragment,
  color_pars_fragment,
  color_pars_vertex,
  color_vertex,
  common,
  cube_uv_reflection_fragment,
  defaultnormal_vertex,
  displacementmap_pars_vertex,
  displacementmap_vertex,
  emissivemap_fragment,
  emissivemap_pars_fragment,
  encodings_fragment,
  encodings_pars_fragment,
  envmap_fragment,
  envmap_common_pars_fragment,
  envmap_pars_fragment,
  envmap_pars_vertex,
  envmap_physical_pars_fragment,
  envmap_vertex,
  fog_vertex,
  fog_pars_vertex,
  fog_fragment,
  fog_pars_fragment,
  gradientmap_pars_fragment,
  lightmap_fragment,
  lightmap_pars_fragment,
  lights_lambert_vertex,
  lights_pars_begin,
  lights_toon_fragment,
  lights_toon_pars_fragment,
  lights_phong_fragment,
  lights_phong_pars_fragment,
  lights_physical_fragment,
  lights_physical_pars_fragment,
  lights_fragment_begin,
  lights_fragment_maps,
  lights_fragment_end,
  logdepthbuf_fragment,
  logdepthbuf_pars_fragment,
  logdepthbuf_pars_vertex,
  logdepthbuf_vertex,
  map_fragment,
  map_pars_fragment,
  map_particle_fragment,
  map_particle_pars_fragment,
  metalnessmap_fragment,
  metalnessmap_pars_fragment,
  morphnormal_vertex,
  morphtarget_pars_vertex,
  morphtarget_vertex,
  normal_fragment_begin,
  normal_fragment_maps,
  normal_pars_fragment,
  normal_pars_vertex,
  normal_vertex,
  normalmap_pars_fragment,
  clearcoat_normal_fragment_begin,
  clearcoat_normal_fragment_maps,
  clearcoat_pars_fragment,
  output_fragment,
  packing,
  premultiplied_alpha_fragment,
  project_vertex,
  dithering_fragment,
  dithering_pars_fragment,
  roughnessmap_fragment,
  roughnessmap_pars_fragment,
  shadowmap_pars_fragment,
  shadowmap_pars_vertex,
  shadowmap_vertex,
  shadowmask_pars_fragment,
  skinbase_vertex,
  skinning_pars_vertex,
  skinning_vertex,
  skinnormal_vertex,
  specularmap_fragment,
  specularmap_pars_fragment,
  tonemapping_fragment,
  tonemapping_pars_fragment,
  transmission_fragment,
  transmission_pars_fragment,
  uv_pars_fragment,
  uv_pars_vertex,
  uv_vertex,
  uv2_pars_fragment,
  uv2_pars_vertex,
  uv2_vertex,
  worldpos_vertex,
  background_frag,
  background_vert,
  cube_frag,
  cube_vert,
  depth_frag,
  depth_vert,
  distanceRGBA_frag,
  distanceRGBA_vert,
  equirect_frag,
  equirect_vert,
  linedashed_frag,
  linedashed_vert,
  meshbasic_frag,
  meshbasic_vert,
  meshlambert_frag,
  meshlambert_vert,
  meshmatcap_frag,
  meshmatcap_vert,
  meshnormal_frag,
  meshnormal_vert,
  meshphong_frag,
  meshphong_vert,
  meshphysical_frag,
  meshphysical_vert,
  meshtoon_frag,
  meshtoon_vert,
  points_frag,
  points_vert,
  shadow_frag,
  shadow_vert,
  sprite_frag,
  sprite_vert
};
const UniformsLib = {
  common: {
    diffuse: { value: new Color2(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    uvTransform: { value: new Matrix32() },
    uv2Transform: { value: new Matrix32() },
    alphaMap: { value: null },
    alphaTest: { value: 0 }
  },
  specularmap: {
    specularMap: { value: null }
  },
  envmap: {
    envMap: { value: null },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    // basic, lambert, phong
    ior: { value: 1.5 },
    // standard, physical
    refractionRatio: { value: 0.98 },
    maxMipLevel: { value: 0 }
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 }
  },
  emissivemap: {
    emissiveMap: { value: null }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalScale: { value: new Vector22(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  roughnessmap: {
    roughnessMap: { value: null }
  },
  metalnessmap: {
    metalnessMap: { value: null }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: new Color2(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotShadowMap: { value: [] },
    spotShadowMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: new Color2(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    alphaTest: { value: 0 },
    uvTransform: { value: new Matrix32() }
  },
  sprite: {
    diffuse: { value: new Color2(16777215) },
    opacity: { value: 1 },
    center: { value: new Vector22(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    alphaMap: { value: null },
    alphaTest: { value: 0 },
    uvTransform: { value: new Matrix32() }
  }
};
const ShaderLib = {
  basic: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.meshbasic_vert,
    fragmentShader: ShaderChunk.meshbasic_frag
  },
  lambert: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: new Color2(0) }
      }
    ]),
    vertexShader: ShaderChunk.meshlambert_vert,
    fragmentShader: ShaderChunk.meshlambert_frag
  },
  phong: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: new Color2(0) },
        specular: { value: new Color2(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: ShaderChunk.meshphong_vert,
    fragmentShader: ShaderChunk.meshphong_frag
  },
  standard: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.roughnessmap,
      UniformsLib.metalnessmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: new Color2(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
        // temporary
      }
    ]),
    vertexShader: ShaderChunk.meshphysical_vert,
    fragmentShader: ShaderChunk.meshphysical_frag
  },
  toon: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.gradientmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: new Color2(0) }
      }
    ]),
    vertexShader: ShaderChunk.meshtoon_vert,
    fragmentShader: ShaderChunk.meshtoon_frag
  },
  matcap: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: ShaderChunk.meshmatcap_vert,
    fragmentShader: ShaderChunk.meshmatcap_frag
  },
  points: {
    uniforms: mergeUniforms([
      UniformsLib.points,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.points_vert,
    fragmentShader: ShaderChunk.points_frag
  },
  dashed: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: ShaderChunk.linedashed_vert,
    fragmentShader: ShaderChunk.linedashed_frag
  },
  depth: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.displacementmap
    ]),
    vertexShader: ShaderChunk.depth_vert,
    fragmentShader: ShaderChunk.depth_frag
  },
  normal: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.meshnormal_vert,
    fragmentShader: ShaderChunk.meshnormal_frag
  },
  sprite: {
    uniforms: mergeUniforms([
      UniformsLib.sprite,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.sprite_vert,
    fragmentShader: ShaderChunk.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: new Matrix32() },
      t2D: { value: null }
    },
    vertexShader: ShaderChunk.background_vert,
    fragmentShader: ShaderChunk.background_frag
  },
  /* -------------------------------------------------------------------------
  //	Cube map shader
   ------------------------------------------------------------------------- */
  cube: {
    uniforms: mergeUniforms([
      UniformsLib.envmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.cube_vert,
    fragmentShader: ShaderChunk.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: ShaderChunk.equirect_vert,
    fragmentShader: ShaderChunk.equirect_frag
  },
  distanceRGBA: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.displacementmap,
      {
        referencePosition: { value: new Vector32() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: ShaderChunk.distanceRGBA_vert,
    fragmentShader: ShaderChunk.distanceRGBA_frag
  },
  shadow: {
    uniforms: mergeUniforms([
      UniformsLib.lights,
      UniformsLib.fog,
      {
        color: { value: new Color2(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.shadow_vert,
    fragmentShader: ShaderChunk.shadow_frag
  }
};
ShaderLib.physical = {
  uniforms: mergeUniforms([
    ShaderLib.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatNormalScale: { value: new Vector22(1, 1) },
      clearcoatNormalMap: { value: null },
      sheenTint: { value: new Color2(0) },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionSamplerSize: { value: new Vector22() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      attenuationDistance: { value: 0 },
      attenuationTint: { value: new Color2(0) },
      specularIntensity: { value: 0 },
      specularIntensityMap: { value: null },
      specularTint: { value: new Color2(1, 1, 1) },
      specularTintMap: { value: null }
    }
  ]),
  vertexShader: ShaderChunk.meshphysical_vert,
  fragmentShader: ShaderChunk.meshphysical_frag
};
function WebGLBackground(renderer, cubemaps, state, objects, premultipliedAlpha) {
  const clearColor = new Color2(0);
  let clearAlpha = 0;
  let planeMesh;
  let boxMesh;
  let currentBackground = null;
  let currentBackgroundVersion = 0;
  let currentTonemapping = null;
  function render(renderList, scene) {
    let forceClear = false;
    let background = scene.isScene === true ? scene.background : null;
    if (background && background.isTexture) {
      background = cubemaps.get(background);
    }
    const xr = renderer.xr;
    const session = xr.getSession && xr.getSession();
    if (session && session.environmentBlendMode === "additive") {
      background = null;
    }
    if (background === null) {
      setClear(clearColor, clearAlpha);
    } else if (background && background.isColor) {
      setClear(background, 1);
      forceClear = true;
    }
    if (renderer.autoClear || forceClear) {
      renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
    }
    if (background && (background.isCubeTexture || background.mapping === CubeUVReflectionMapping)) {
      if (boxMesh === void 0) {
        boxMesh = new Mesh2(
          new BoxGeometry2(1, 1, 1),
          new ShaderMaterial2({
            name: "BackgroundCubeMaterial",
            uniforms: cloneUniforms(ShaderLib.cube.uniforms),
            vertexShader: ShaderLib.cube.vertexShader,
            fragmentShader: ShaderLib.cube.fragmentShader,
            side: BackSide,
            depthTest: false,
            depthWrite: false,
            fog: false
          })
        );
        boxMesh.geometry.deleteAttribute("normal");
        boxMesh.geometry.deleteAttribute("uv");
        boxMesh.onBeforeRender = function(renderer2, scene2, camera) {
          this.matrixWorld.copyPosition(camera.matrixWorld);
        };
        Object.defineProperty(boxMesh.material, "envMap", {
          get: function() {
            return this.uniforms.envMap.value;
          }
        });
        objects.update(boxMesh);
      }
      boxMesh.material.uniforms.envMap.value = background;
      boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        boxMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }
      renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
    } else if (background && background.isTexture) {
      if (planeMesh === void 0) {
        planeMesh = new Mesh2(
          new PlaneGeometry2(2, 2),
          new ShaderMaterial2({
            name: "BackgroundMaterial",
            uniforms: cloneUniforms(ShaderLib.background.uniforms),
            vertexShader: ShaderLib.background.vertexShader,
            fragmentShader: ShaderLib.background.fragmentShader,
            side: FrontSide,
            depthTest: false,
            depthWrite: false,
            fog: false
          })
        );
        planeMesh.geometry.deleteAttribute("normal");
        Object.defineProperty(planeMesh.material, "map", {
          get: function() {
            return this.uniforms.t2D.value;
          }
        });
        objects.update(planeMesh);
      }
      planeMesh.material.uniforms.t2D.value = background;
      if (background.matrixAutoUpdate === true) {
        background.updateMatrix();
      }
      planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        planeMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }
      renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
    }
  }
  function setClear(color2, alpha) {
    state.buffers.color.setClear(color2.r, color2.g, color2.b, alpha, premultipliedAlpha);
  }
  return {
    getClearColor: function() {
      return clearColor;
    },
    setClearColor: function(color2, alpha = 1) {
      clearColor.set(color2);
      clearAlpha = alpha;
      setClear(clearColor, clearAlpha);
    },
    getClearAlpha: function() {
      return clearAlpha;
    },
    setClearAlpha: function(alpha) {
      clearAlpha = alpha;
      setClear(clearColor, clearAlpha);
    },
    render
  };
}
function WebGLBindingStates(gl, extensions, attributes, capabilities) {
  const maxVertexAttributes = gl.getParameter(34921);
  const extension = capabilities.isWebGL2 ? null : extensions.get("OES_vertex_array_object");
  const vaoAvailable = capabilities.isWebGL2 || extension !== null;
  const bindingStates = {};
  const defaultState = createBindingState(null);
  let currentState = defaultState;
  function setup(object, material, program, geometry, index2) {
    let updateBuffers = false;
    if (vaoAvailable) {
      const state = getBindingState(geometry, program, material);
      if (currentState !== state) {
        currentState = state;
        bindVertexArrayObject(currentState.object);
      }
      updateBuffers = needsUpdate(geometry, index2);
      if (updateBuffers) saveCache(geometry, index2);
    } else {
      const wireframe = material.wireframe === true;
      if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
        currentState.geometry = geometry.id;
        currentState.program = program.id;
        currentState.wireframe = wireframe;
        updateBuffers = true;
      }
    }
    if (object.isInstancedMesh === true) {
      updateBuffers = true;
    }
    if (index2 !== null) {
      attributes.update(index2, 34963);
    }
    if (updateBuffers) {
      setupVertexAttributes(object, material, program, geometry);
      if (index2 !== null) {
        gl.bindBuffer(34963, attributes.get(index2).buffer);
      }
    }
  }
  function createVertexArrayObject() {
    if (capabilities.isWebGL2) return gl.createVertexArray();
    return extension.createVertexArrayOES();
  }
  function bindVertexArrayObject(vao) {
    if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
    return extension.bindVertexArrayOES(vao);
  }
  function deleteVertexArrayObject(vao) {
    if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
    return extension.deleteVertexArrayOES(vao);
  }
  function getBindingState(geometry, program, material) {
    const wireframe = material.wireframe === true;
    let programMap = bindingStates[geometry.id];
    if (programMap === void 0) {
      programMap = {};
      bindingStates[geometry.id] = programMap;
    }
    let stateMap = programMap[program.id];
    if (stateMap === void 0) {
      stateMap = {};
      programMap[program.id] = stateMap;
    }
    let state = stateMap[wireframe];
    if (state === void 0) {
      state = createBindingState(createVertexArrayObject());
      stateMap[wireframe] = state;
    }
    return state;
  }
  function createBindingState(vao) {
    const newAttributes = [];
    const enabledAttributes = [];
    const attributeDivisors = [];
    for (let i2 = 0; i2 < maxVertexAttributes; i2++) {
      newAttributes[i2] = 0;
      enabledAttributes[i2] = 0;
      attributeDivisors[i2] = 0;
    }
    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: false,
      newAttributes,
      enabledAttributes,
      attributeDivisors,
      object: vao,
      attributes: {},
      index: null
    };
  }
  function needsUpdate(geometry, index2) {
    const cachedAttributes = currentState.attributes;
    const geometryAttributes = geometry.attributes;
    let attributesNum = 0;
    for (const key in geometryAttributes) {
      const cachedAttribute = cachedAttributes[key];
      const geometryAttribute = geometryAttributes[key];
      if (cachedAttribute === void 0) return true;
      if (cachedAttribute.attribute !== geometryAttribute) return true;
      if (cachedAttribute.data !== geometryAttribute.data) return true;
      attributesNum++;
    }
    if (currentState.attributesNum !== attributesNum) return true;
    if (currentState.index !== index2) return true;
    return false;
  }
  function saveCache(geometry, index2) {
    const cache = {};
    const attributes2 = geometry.attributes;
    let attributesNum = 0;
    for (const key in attributes2) {
      const attribute = attributes2[key];
      const data = {};
      data.attribute = attribute;
      if (attribute.data) {
        data.data = attribute.data;
      }
      cache[key] = data;
      attributesNum++;
    }
    currentState.attributes = cache;
    currentState.attributesNum = attributesNum;
    currentState.index = index2;
  }
  function initAttributes() {
    const newAttributes = currentState.newAttributes;
    for (let i2 = 0, il = newAttributes.length; i2 < il; i2++) {
      newAttributes[i2] = 0;
    }
  }
  function enableAttribute(attribute) {
    enableAttributeAndDivisor(attribute, 0);
  }
  function enableAttributeAndDivisor(attribute, meshPerAttribute) {
    const newAttributes = currentState.newAttributes;
    const enabledAttributes = currentState.enabledAttributes;
    const attributeDivisors = currentState.attributeDivisors;
    newAttributes[attribute] = 1;
    if (enabledAttributes[attribute] === 0) {
      gl.enableVertexAttribArray(attribute);
      enabledAttributes[attribute] = 1;
    }
    if (attributeDivisors[attribute] !== meshPerAttribute) {
      const extension2 = capabilities.isWebGL2 ? gl : extensions.get("ANGLE_instanced_arrays");
      extension2[capabilities.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](attribute, meshPerAttribute);
      attributeDivisors[attribute] = meshPerAttribute;
    }
  }
  function disableUnusedAttributes() {
    const newAttributes = currentState.newAttributes;
    const enabledAttributes = currentState.enabledAttributes;
    for (let i2 = 0, il = enabledAttributes.length; i2 < il; i2++) {
      if (enabledAttributes[i2] !== newAttributes[i2]) {
        gl.disableVertexAttribArray(i2);
        enabledAttributes[i2] = 0;
      }
    }
  }
  function vertexAttribPointer(index2, size, type, normalized, stride, offset) {
    if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) {
      gl.vertexAttribIPointer(index2, size, type, stride, offset);
    } else {
      gl.vertexAttribPointer(index2, size, type, normalized, stride, offset);
    }
  }
  function setupVertexAttributes(object, material, program, geometry) {
    if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
      if (extensions.get("ANGLE_instanced_arrays") === null) return;
    }
    initAttributes();
    const geometryAttributes = geometry.attributes;
    const programAttributes = program.getAttributes();
    const materialDefaultAttributeValues = material.defaultAttributeValues;
    for (const name in programAttributes) {
      const programAttribute = programAttributes[name];
      if (programAttribute.location >= 0) {
        let geometryAttribute = geometryAttributes[name];
        if (geometryAttribute === void 0) {
          if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
          if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
        }
        if (geometryAttribute !== void 0) {
          const normalized = geometryAttribute.normalized;
          const size = geometryAttribute.itemSize;
          const attribute = attributes.get(geometryAttribute);
          if (attribute === void 0) continue;
          const buffer = attribute.buffer;
          const type = attribute.type;
          const bytesPerElement = attribute.bytesPerElement;
          if (geometryAttribute.isInterleavedBufferAttribute) {
            const data = geometryAttribute.data;
            const stride = data.stride;
            const offset = geometryAttribute.offset;
            if (data && data.isInstancedInterleavedBuffer) {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttributeAndDivisor(programAttribute.location + i2, data.meshPerAttribute);
              }
              if (object.isInstancedMesh !== true && geometry._maxInstanceCount === void 0) {
                geometry._maxInstanceCount = data.meshPerAttribute * data.count;
              }
            } else {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttribute(programAttribute.location + i2);
              }
            }
            gl.bindBuffer(34962, buffer);
            for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
              vertexAttribPointer(
                programAttribute.location + i2,
                size / programAttribute.locationSize,
                type,
                normalized,
                stride * bytesPerElement,
                (offset + size / programAttribute.locationSize * i2) * bytesPerElement
              );
            }
          } else {
            if (geometryAttribute.isInstancedBufferAttribute) {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttributeAndDivisor(programAttribute.location + i2, geometryAttribute.meshPerAttribute);
              }
              if (object.isInstancedMesh !== true && geometry._maxInstanceCount === void 0) {
                geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
              }
            } else {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttribute(programAttribute.location + i2);
              }
            }
            gl.bindBuffer(34962, buffer);
            for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
              vertexAttribPointer(
                programAttribute.location + i2,
                size / programAttribute.locationSize,
                type,
                normalized,
                size * bytesPerElement,
                size / programAttribute.locationSize * i2 * bytesPerElement
              );
            }
          }
        } else if (materialDefaultAttributeValues !== void 0) {
          const value = materialDefaultAttributeValues[name];
          if (value !== void 0) {
            switch (value.length) {
              case 2:
                gl.vertexAttrib2fv(programAttribute.location, value);
                break;
              case 3:
                gl.vertexAttrib3fv(programAttribute.location, value);
                break;
              case 4:
                gl.vertexAttrib4fv(programAttribute.location, value);
                break;
              default:
                gl.vertexAttrib1fv(programAttribute.location, value);
            }
          }
        }
      }
    }
    disableUnusedAttributes();
  }
  function dispose() {
    reset();
    for (const geometryId in bindingStates) {
      const programMap = bindingStates[geometryId];
      for (const programId in programMap) {
        const stateMap = programMap[programId];
        for (const wireframe in stateMap) {
          deleteVertexArrayObject(stateMap[wireframe].object);
          delete stateMap[wireframe];
        }
        delete programMap[programId];
      }
      delete bindingStates[geometryId];
    }
  }
  function releaseStatesOfGeometry(geometry) {
    if (bindingStates[geometry.id] === void 0) return;
    const programMap = bindingStates[geometry.id];
    for (const programId in programMap) {
      const stateMap = programMap[programId];
      for (const wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }
      delete programMap[programId];
    }
    delete bindingStates[geometry.id];
  }
  function releaseStatesOfProgram(program) {
    for (const geometryId in bindingStates) {
      const programMap = bindingStates[geometryId];
      if (programMap[program.id] === void 0) continue;
      const stateMap = programMap[program.id];
      for (const wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }
      delete programMap[program.id];
    }
  }
  function reset() {
    resetDefaultState();
    if (currentState === defaultState) return;
    currentState = defaultState;
    bindVertexArrayObject(currentState.object);
  }
  function resetDefaultState() {
    defaultState.geometry = null;
    defaultState.program = null;
    defaultState.wireframe = false;
  }
  return {
    setup,
    reset,
    resetDefaultState,
    dispose,
    releaseStatesOfGeometry,
    releaseStatesOfProgram,
    initAttributes,
    enableAttribute,
    disableUnusedAttributes
  };
}
function WebGLBufferRenderer(gl, extensions, info, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  let mode;
  function setMode(value) {
    mode = value;
  }
  function render(start, count) {
    gl.drawArrays(mode, start, count);
    info.update(count, mode, 1);
  }
  function renderInstances(start, count, primcount) {
    if (primcount === 0) return;
    let extension, methodName;
    if (isWebGL2) {
      extension = gl;
      methodName = "drawArraysInstanced";
    } else {
      extension = extensions.get("ANGLE_instanced_arrays");
      methodName = "drawArraysInstancedANGLE";
      if (extension === null) {
        console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
        return;
      }
    }
    extension[methodName](mode, start, count, primcount);
    info.update(count, mode, primcount);
  }
  this.setMode = setMode;
  this.render = render;
  this.renderInstances = renderInstances;
}
function WebGLCapabilities(gl, extensions, parameters) {
  let maxAnisotropy;
  function getMaxAnisotropy() {
    if (maxAnisotropy !== void 0) return maxAnisotropy;
    if (extensions.has("EXT_texture_filter_anisotropic") === true) {
      const extension = extensions.get("EXT_texture_filter_anisotropic");
      maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else {
      maxAnisotropy = 0;
    }
    return maxAnisotropy;
  }
  function getMaxPrecision(precision2) {
    if (precision2 === "highp") {
      if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) {
        return "highp";
      }
      precision2 = "mediump";
    }
    if (precision2 === "mediump") {
      if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) {
        return "mediump";
      }
    }
    return "lowp";
  }
  const isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== "undefined" && gl instanceof WebGL2ComputeRenderingContext;
  let precision = parameters.precision !== void 0 ? parameters.precision : "highp";
  const maxPrecision = getMaxPrecision(precision);
  if (maxPrecision !== precision) {
    console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
    precision = maxPrecision;
  }
  const drawBuffers = isWebGL2 || extensions.has("WEBGL_draw_buffers");
  const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
  const maxTextures = gl.getParameter(34930);
  const maxVertexTextures = gl.getParameter(35660);
  const maxTextureSize = gl.getParameter(3379);
  const maxCubemapSize = gl.getParameter(34076);
  const maxAttributes = gl.getParameter(34921);
  const maxVertexUniforms = gl.getParameter(36347);
  const maxVaryings = gl.getParameter(36348);
  const maxFragmentUniforms = gl.getParameter(36349);
  const vertexTextures = maxVertexTextures > 0;
  const floatFragmentTextures = isWebGL2 || extensions.has("OES_texture_float");
  const floatVertexTextures = vertexTextures && floatFragmentTextures;
  const maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
  return {
    isWebGL2,
    drawBuffers,
    getMaxAnisotropy,
    getMaxPrecision,
    precision,
    logarithmicDepthBuffer,
    maxTextures,
    maxVertexTextures,
    maxTextureSize,
    maxCubemapSize,
    maxAttributes,
    maxVertexUniforms,
    maxVaryings,
    maxFragmentUniforms,
    vertexTextures,
    floatFragmentTextures,
    floatVertexTextures,
    maxSamples
  };
}
function WebGLClipping(properties) {
  const scope = this;
  let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
  const plane = new Plane2(), viewNormalMatrix = new Matrix32(), uniform = { value: null, needsUpdate: false };
  this.uniform = uniform;
  this.numPlanes = 0;
  this.numIntersection = 0;
  this.init = function(planes, enableLocalClipping, camera) {
    const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
    // run another frame in order to reset the state:
    numGlobalPlanes !== 0 || localClippingEnabled;
    localClippingEnabled = enableLocalClipping;
    globalState = projectPlanes(planes, camera, 0);
    numGlobalPlanes = planes.length;
    return enabled;
  };
  this.beginShadows = function() {
    renderingShadows = true;
    projectPlanes(null);
  };
  this.endShadows = function() {
    renderingShadows = false;
    resetGlobalState();
  };
  this.setState = function(material, camera, useCache) {
    const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
    const materialProperties = properties.get(material);
    if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
      if (renderingShadows) {
        projectPlanes(null);
      } else {
        resetGlobalState();
      }
    } else {
      const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
      let dstArray = materialProperties.clippingState || null;
      uniform.value = dstArray;
      dstArray = projectPlanes(planes, camera, lGlobal, useCache);
      for (let i2 = 0; i2 !== lGlobal; ++i2) {
        dstArray[i2] = globalState[i2];
      }
      materialProperties.clippingState = dstArray;
      this.numIntersection = clipIntersection ? this.numPlanes : 0;
      this.numPlanes += nGlobal;
    }
  };
  function resetGlobalState() {
    if (uniform.value !== globalState) {
      uniform.value = globalState;
      uniform.needsUpdate = numGlobalPlanes > 0;
    }
    scope.numPlanes = numGlobalPlanes;
    scope.numIntersection = 0;
  }
  function projectPlanes(planes, camera, dstOffset, skipTransform) {
    const nPlanes = planes !== null ? planes.length : 0;
    let dstArray = null;
    if (nPlanes !== 0) {
      dstArray = uniform.value;
      if (skipTransform !== true || dstArray === null) {
        const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
        viewNormalMatrix.getNormalMatrix(viewMatrix);
        if (dstArray === null || dstArray.length < flatSize) {
          dstArray = new Float32Array(flatSize);
        }
        for (let i2 = 0, i4 = dstOffset; i2 !== nPlanes; ++i2, i4 += 4) {
          plane.copy(planes[i2]).applyMatrix4(viewMatrix, viewNormalMatrix);
          plane.normal.toArray(dstArray, i4);
          dstArray[i4 + 3] = plane.constant;
        }
      }
      uniform.value = dstArray;
      uniform.needsUpdate = true;
    }
    scope.numPlanes = nPlanes;
    scope.numIntersection = 0;
    return dstArray;
  }
}
function WebGLCubeMaps(renderer) {
  let cubemaps = /* @__PURE__ */ new WeakMap();
  function mapTextureMapping(texture, mapping) {
    if (mapping === EquirectangularReflectionMapping) {
      texture.mapping = CubeReflectionMapping;
    } else if (mapping === EquirectangularRefractionMapping) {
      texture.mapping = CubeRefractionMapping;
    }
    return texture;
  }
  function get(texture) {
    if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
      const mapping = texture.mapping;
      if (mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping) {
        if (cubemaps.has(texture)) {
          const cubemap = cubemaps.get(texture).texture;
          return mapTextureMapping(cubemap, texture.mapping);
        } else {
          const image2 = texture.image;
          if (image2 && image2.height > 0) {
            const currentRenderTarget = renderer.getRenderTarget();
            const renderTarget = new WebGLCubeRenderTarget2(image2.height / 2);
            renderTarget.fromEquirectangularTexture(renderer, texture);
            cubemaps.set(texture, renderTarget);
            renderer.setRenderTarget(currentRenderTarget);
            texture.addEventListener("dispose", onTextureDispose);
            return mapTextureMapping(renderTarget.texture, texture.mapping);
          } else {
            return null;
          }
        }
      }
    }
    return texture;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    const cubemap = cubemaps.get(texture);
    if (cubemap !== void 0) {
      cubemaps.delete(texture);
      cubemap.dispose();
    }
  }
  function dispose() {
    cubemaps = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose
  };
}
class OrthographicCamera2 extends Camera2 {
  constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2e3) {
    super();
    this.type = "OrthographicCamera";
    this.zoom = 1;
    this.view = null;
    this.left = left;
    this.right = right;
    this.top = top;
    this.bottom = bottom;
    this.near = near;
    this.far = far;
    this.updateProjectionMatrix();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.left = source.left;
    this.right = source.right;
    this.top = source.top;
    this.bottom = source.bottom;
    this.near = source.near;
    this.far = source.far;
    this.zoom = source.zoom;
    this.view = source.view === null ? null : Object.assign({}, source.view);
    return this;
  }
  setViewOffset(fullWidth, fullHeight, x, y, width, height) {
    if (this.view === null) {
      this.view = {
        enabled: true,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      };
    }
    this.view.enabled = true;
    this.view.fullWidth = fullWidth;
    this.view.fullHeight = fullHeight;
    this.view.offsetX = x;
    this.view.offsetY = y;
    this.view.width = width;
    this.view.height = height;
    this.updateProjectionMatrix();
  }
  clearViewOffset() {
    if (this.view !== null) {
      this.view.enabled = false;
    }
    this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const dx = (this.right - this.left) / (2 * this.zoom);
    const dy = (this.top - this.bottom) / (2 * this.zoom);
    const cx = (this.right + this.left) / 2;
    const cy = (this.top + this.bottom) / 2;
    let left = cx - dx;
    let right = cx + dx;
    let top = cy + dy;
    let bottom = cy - dy;
    if (this.view !== null && this.view.enabled) {
      const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
      const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      left += scaleW * this.view.offsetX;
      right = left + scaleW * this.view.width;
      top -= scaleH * this.view.offsetY;
      bottom = top - scaleH * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
    this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.zoom = this.zoom;
    data.object.left = this.left;
    data.object.right = this.right;
    data.object.top = this.top;
    data.object.bottom = this.bottom;
    data.object.near = this.near;
    data.object.far = this.far;
    if (this.view !== null) data.object.view = Object.assign({}, this.view);
    return data;
  }
}
OrthographicCamera2.prototype.isOrthographicCamera = true;
class RawShaderMaterial2 extends ShaderMaterial2 {
  constructor(parameters) {
    super(parameters);
    this.type = "RawShaderMaterial";
  }
}
RawShaderMaterial2.prototype.isRawShaderMaterial = true;
const LOD_MIN = 4;
const LOD_MAX = 8;
const SIZE_MAX = Math.pow(2, LOD_MAX);
const EXTRA_LOD_SIGMA = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582];
const TOTAL_LODS = LOD_MAX - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;
const MAX_SAMPLES = 20;
const ENCODINGS = {
  [LinearEncoding]: 0,
  [sRGBEncoding]: 1,
  [RGBEEncoding]: 2,
  [RGBM7Encoding]: 3,
  [RGBM16Encoding]: 4,
  [RGBDEncoding]: 5,
  [GammaEncoding]: 6
};
const _flatCamera = /* @__PURE__ */ new OrthographicCamera2();
const { _lodPlanes, _sizeLods, _sigmas } = /* @__PURE__ */ _createPlanes();
const _clearColor = /* @__PURE__ */ new Color2();
let _oldTarget = null;
const PHI = (1 + Math.sqrt(5)) / 2;
const INV_PHI = 1 / PHI;
const _axisDirections = [
  /* @__PURE__ */ new Vector32(1, 1, 1),
  /* @__PURE__ */ new Vector32(-1, 1, 1),
  /* @__PURE__ */ new Vector32(1, 1, -1),
  /* @__PURE__ */ new Vector32(-1, 1, -1),
  /* @__PURE__ */ new Vector32(0, PHI, INV_PHI),
  /* @__PURE__ */ new Vector32(0, PHI, -INV_PHI),
  /* @__PURE__ */ new Vector32(INV_PHI, 0, PHI),
  /* @__PURE__ */ new Vector32(-INV_PHI, 0, PHI),
  /* @__PURE__ */ new Vector32(PHI, INV_PHI, 0),
  /* @__PURE__ */ new Vector32(-PHI, INV_PHI, 0)
];
class PMREMGenerator2 {
  constructor(renderer) {
    this._renderer = renderer;
    this._pingPongRenderTarget = null;
    this._blurMaterial = _getBlurShader(MAX_SAMPLES);
    this._equirectShader = null;
    this._cubemapShader = null;
    this._compileMaterial(this._blurMaterial);
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety (the cubeCamera
   * is placed at the origin).
   */
  fromScene(scene, sigma = 0, near = 0.1, far = 100) {
    _oldTarget = this._renderer.getRenderTarget();
    const cubeUVRenderTarget = this._allocateTargets();
    this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
    if (sigma > 0) {
      this._blur(cubeUVRenderTarget, 0, 0, sigma);
    }
    this._applyPMREM(cubeUVRenderTarget);
    this._cleanup(cubeUVRenderTarget);
    return cubeUVRenderTarget;
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * (RGBFormat) or HDR (RGBEFormat). The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   */
  fromEquirectangular(equirectangular) {
    return this._fromTexture(equirectangular);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * (RGBFormat) or HDR (RGBEFormat). The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   */
  fromCubemap(cubemap) {
    return this._fromTexture(cubemap);
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileCubemapShader() {
    if (this._cubemapShader === null) {
      this._cubemapShader = _getCubemapShader();
      this._compileMaterial(this._cubemapShader);
    }
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileEquirectangularShader() {
    if (this._equirectShader === null) {
      this._equirectShader = _getEquirectShader();
      this._compileMaterial(this._equirectShader);
    }
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    this._blurMaterial.dispose();
    if (this._cubemapShader !== null) this._cubemapShader.dispose();
    if (this._equirectShader !== null) this._equirectShader.dispose();
    for (let i2 = 0; i2 < _lodPlanes.length; i2++) {
      _lodPlanes[i2].dispose();
    }
  }
  // private interface
  _cleanup(outputTarget) {
    this._pingPongRenderTarget.dispose();
    this._renderer.setRenderTarget(_oldTarget);
    outputTarget.scissorTest = false;
    _setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
  }
  _fromTexture(texture) {
    _oldTarget = this._renderer.getRenderTarget();
    const cubeUVRenderTarget = this._allocateTargets(texture);
    this._textureToCubeUV(texture, cubeUVRenderTarget);
    this._applyPMREM(cubeUVRenderTarget);
    this._cleanup(cubeUVRenderTarget);
    return cubeUVRenderTarget;
  }
  _allocateTargets(texture) {
    const params = {
      magFilter: NearestFilter,
      minFilter: NearestFilter,
      generateMipmaps: false,
      type: UnsignedByteType,
      format: RGBEFormat,
      encoding: _isLDR(texture) ? texture.encoding : RGBEEncoding,
      depthBuffer: false
    };
    const cubeUVRenderTarget = _createRenderTarget(params);
    cubeUVRenderTarget.depthBuffer = texture ? false : true;
    this._pingPongRenderTarget = _createRenderTarget(params);
    return cubeUVRenderTarget;
  }
  _compileMaterial(material) {
    const tmpMesh = new Mesh2(_lodPlanes[0], material);
    this._renderer.compile(tmpMesh, _flatCamera);
  }
  _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
    const fov2 = 90;
    const aspect2 = 1;
    const cubeCamera = new PerspectiveCamera2(fov2, aspect2, near, far);
    const upSign = [1, -1, 1, 1, 1, 1];
    const forwardSign = [1, 1, 1, -1, -1, -1];
    const renderer = this._renderer;
    const originalAutoClear = renderer.autoClear;
    const outputEncoding = renderer.outputEncoding;
    const toneMapping = renderer.toneMapping;
    renderer.getClearColor(_clearColor);
    renderer.toneMapping = NoToneMapping;
    renderer.outputEncoding = LinearEncoding;
    renderer.autoClear = false;
    const backgroundMaterial = new MeshBasicMaterial2({
      name: "PMREM.Background",
      side: BackSide,
      depthWrite: false,
      depthTest: false
    });
    const backgroundBox = new Mesh2(new BoxGeometry2(), backgroundMaterial);
    let useSolidColor = false;
    const background = scene.background;
    if (background) {
      if (background.isColor) {
        backgroundMaterial.color.copy(background);
        scene.background = null;
        useSolidColor = true;
      }
    } else {
      backgroundMaterial.color.copy(_clearColor);
      useSolidColor = true;
    }
    for (let i2 = 0; i2 < 6; i2++) {
      const col = i2 % 3;
      if (col == 0) {
        cubeCamera.up.set(0, upSign[i2], 0);
        cubeCamera.lookAt(forwardSign[i2], 0, 0);
      } else if (col == 1) {
        cubeCamera.up.set(0, 0, upSign[i2]);
        cubeCamera.lookAt(0, forwardSign[i2], 0);
      } else {
        cubeCamera.up.set(0, upSign[i2], 0);
        cubeCamera.lookAt(0, 0, forwardSign[i2]);
      }
      _setViewport(
        cubeUVRenderTarget,
        col * SIZE_MAX,
        i2 > 2 ? SIZE_MAX : 0,
        SIZE_MAX,
        SIZE_MAX
      );
      renderer.setRenderTarget(cubeUVRenderTarget);
      if (useSolidColor) {
        renderer.render(backgroundBox, cubeCamera);
      }
      renderer.render(scene, cubeCamera);
    }
    backgroundBox.geometry.dispose();
    backgroundBox.material.dispose();
    renderer.toneMapping = toneMapping;
    renderer.outputEncoding = outputEncoding;
    renderer.autoClear = originalAutoClear;
    scene.background = background;
  }
  _textureToCubeUV(texture, cubeUVRenderTarget) {
    const renderer = this._renderer;
    if (texture.isCubeTexture) {
      if (this._cubemapShader == null) {
        this._cubemapShader = _getCubemapShader();
      }
    } else {
      if (this._equirectShader == null) {
        this._equirectShader = _getEquirectShader();
      }
    }
    const material = texture.isCubeTexture ? this._cubemapShader : this._equirectShader;
    const mesh = new Mesh2(_lodPlanes[0], material);
    const uniforms = material.uniforms;
    uniforms["envMap"].value = texture;
    if (!texture.isCubeTexture) {
      uniforms["texelSize"].value.set(1 / texture.image.width, 1 / texture.image.height);
    }
    uniforms["inputEncoding"].value = ENCODINGS[texture.encoding];
    uniforms["outputEncoding"].value = ENCODINGS[cubeUVRenderTarget.texture.encoding];
    _setViewport(cubeUVRenderTarget, 0, 0, 3 * SIZE_MAX, 2 * SIZE_MAX);
    renderer.setRenderTarget(cubeUVRenderTarget);
    renderer.render(mesh, _flatCamera);
  }
  _applyPMREM(cubeUVRenderTarget) {
    const renderer = this._renderer;
    const autoClear = renderer.autoClear;
    renderer.autoClear = false;
    for (let i2 = 1; i2 < TOTAL_LODS; i2++) {
      const sigma = Math.sqrt(_sigmas[i2] * _sigmas[i2] - _sigmas[i2 - 1] * _sigmas[i2 - 1]);
      const poleAxis = _axisDirections[(i2 - 1) % _axisDirections.length];
      this._blur(cubeUVRenderTarget, i2 - 1, i2, sigma, poleAxis);
    }
    renderer.autoClear = autoClear;
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   */
  _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
    const pingPongRenderTarget = this._pingPongRenderTarget;
    this._halfBlur(
      cubeUVRenderTarget,
      pingPongRenderTarget,
      lodIn,
      lodOut,
      sigma,
      "latitudinal",
      poleAxis
    );
    this._halfBlur(
      pingPongRenderTarget,
      cubeUVRenderTarget,
      lodOut,
      lodOut,
      sigma,
      "longitudinal",
      poleAxis
    );
  }
  _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction2, poleAxis) {
    const renderer = this._renderer;
    const blurMaterial = this._blurMaterial;
    if (direction2 !== "latitudinal" && direction2 !== "longitudinal") {
      console.error(
        "blur direction must be either latitudinal or longitudinal!"
      );
    }
    const STANDARD_DEVIATIONS = 3;
    const blurMesh = new Mesh2(_lodPlanes[lodOut], blurMaterial);
    const blurUniforms = blurMaterial.uniforms;
    const pixels = _sizeLods[lodIn] - 1;
    const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * MAX_SAMPLES - 1);
    const sigmaPixels = sigmaRadians / radiansPerPixel;
    const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : MAX_SAMPLES;
    if (samples > MAX_SAMPLES) {
      console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${MAX_SAMPLES}`);
    }
    const weights = [];
    let sum = 0;
    for (let i2 = 0; i2 < MAX_SAMPLES; ++i2) {
      const x2 = i2 / sigmaPixels;
      const weight = Math.exp(-x2 * x2 / 2);
      weights.push(weight);
      if (i2 == 0) {
        sum += weight;
      } else if (i2 < samples) {
        sum += 2 * weight;
      }
    }
    for (let i2 = 0; i2 < weights.length; i2++) {
      weights[i2] = weights[i2] / sum;
    }
    blurUniforms["envMap"].value = targetIn.texture;
    blurUniforms["samples"].value = samples;
    blurUniforms["weights"].value = weights;
    blurUniforms["latitudinal"].value = direction2 === "latitudinal";
    if (poleAxis) {
      blurUniforms["poleAxis"].value = poleAxis;
    }
    blurUniforms["dTheta"].value = radiansPerPixel;
    blurUniforms["mipInt"].value = LOD_MAX - lodIn;
    blurUniforms["inputEncoding"].value = ENCODINGS[targetIn.texture.encoding];
    blurUniforms["outputEncoding"].value = ENCODINGS[targetIn.texture.encoding];
    const outputSize = _sizeLods[lodOut];
    const x = 3 * Math.max(0, SIZE_MAX - 2 * outputSize);
    const y = (lodOut === 0 ? 0 : 2 * SIZE_MAX) + 2 * outputSize * (lodOut > LOD_MAX - LOD_MIN ? lodOut - LOD_MAX + LOD_MIN : 0);
    _setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
    renderer.setRenderTarget(targetOut);
    renderer.render(blurMesh, _flatCamera);
  }
}
function _isLDR(texture) {
  if (texture === void 0 || texture.type !== UnsignedByteType) return false;
  return texture.encoding === LinearEncoding || texture.encoding === sRGBEncoding || texture.encoding === GammaEncoding;
}
function _createPlanes() {
  const _lodPlanes2 = [];
  const _sizeLods2 = [];
  const _sigmas2 = [];
  let lod = LOD_MAX;
  for (let i2 = 0; i2 < TOTAL_LODS; i2++) {
    const sizeLod = Math.pow(2, lod);
    _sizeLods2.push(sizeLod);
    let sigma = 1 / sizeLod;
    if (i2 > LOD_MAX - LOD_MIN) {
      sigma = EXTRA_LOD_SIGMA[i2 - LOD_MAX + LOD_MIN - 1];
    } else if (i2 == 0) {
      sigma = 0;
    }
    _sigmas2.push(sigma);
    const texelSize = 1 / (sizeLod - 1);
    const min = -texelSize / 2;
    const max2 = 1 + texelSize / 2;
    const uv1 = [min, min, max2, min, max2, max2, min, min, max2, max2, min, max2];
    const cubeFaces = 6;
    const vertices = 6;
    const positionSize = 3;
    const uvSize = 2;
    const faceIndexSize = 1;
    const position2 = new Float32Array(positionSize * vertices * cubeFaces);
    const uv = new Float32Array(uvSize * vertices * cubeFaces);
    const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
    for (let face = 0; face < cubeFaces; face++) {
      const x = face % 3 * 2 / 3 - 1;
      const y = face > 2 ? 0 : -1;
      const coordinates = [
        x,
        y,
        0,
        x + 2 / 3,
        y,
        0,
        x + 2 / 3,
        y + 1,
        0,
        x,
        y,
        0,
        x + 2 / 3,
        y + 1,
        0,
        x,
        y + 1,
        0
      ];
      position2.set(coordinates, positionSize * vertices * face);
      uv.set(uv1, uvSize * vertices * face);
      const fill2 = [face, face, face, face, face, face];
      faceIndex.set(fill2, faceIndexSize * vertices * face);
    }
    const planes = new BufferGeometry2();
    planes.setAttribute("position", new BufferAttribute2(position2, positionSize));
    planes.setAttribute("uv", new BufferAttribute2(uv, uvSize));
    planes.setAttribute("faceIndex", new BufferAttribute2(faceIndex, faceIndexSize));
    _lodPlanes2.push(planes);
    if (lod > LOD_MIN) {
      lod--;
    }
  }
  return { _lodPlanes: _lodPlanes2, _sizeLods: _sizeLods2, _sigmas: _sigmas2 };
}
function _createRenderTarget(params) {
  const cubeUVRenderTarget = new WebGLRenderTarget2(3 * SIZE_MAX, 3 * SIZE_MAX, params);
  cubeUVRenderTarget.texture.mapping = CubeUVReflectionMapping;
  cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
  cubeUVRenderTarget.scissorTest = true;
  return cubeUVRenderTarget;
}
function _setViewport(target, x, y, width, height) {
  target.viewport.set(x, y, width, height);
  target.scissor.set(x, y, width, height);
}
function _getBlurShader(maxSamples) {
  const weights = new Float32Array(maxSamples);
  const poleAxis = new Vector32(0, 1, 0);
  const shaderMaterial = new RawShaderMaterial2({
    name: "SphericalGaussianBlur",
    defines: { "n": maxSamples },
    uniforms: {
      "envMap": { value: null },
      "samples": { value: 1 },
      "weights": { value: weights },
      "latitudinal": { value: false },
      "dTheta": { value: 0 },
      "mipInt": { value: 0 },
      "poleAxis": { value: poleAxis },
      "inputEncoding": { value: ENCODINGS[LinearEncoding] },
      "outputEncoding": { value: ENCODINGS[LinearEncoding] }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			${_getEncodings()}

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`
    ),
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
  return shaderMaterial;
}
function _getEquirectShader() {
  const texelSize = new Vector22(1, 1);
  const shaderMaterial = new RawShaderMaterial2({
    name: "EquirectangularToCubeUV",
    uniforms: {
      "envMap": { value: null },
      "texelSize": { value: texelSize },
      "inputEncoding": { value: ENCODINGS[LinearEncoding] },
      "outputEncoding": { value: ENCODINGS[LinearEncoding] }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform vec2 texelSize;

			${_getEncodings()}

			#include <common>

			void main() {

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				vec2 f = fract( uv / texelSize - 0.5 );
				uv -= f * texelSize;
				vec3 tl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.x += texelSize.x;
				vec3 tr = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.y += texelSize.y;
				vec3 br = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.x -= texelSize.x;
				vec3 bl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;

				vec3 tm = mix( tl, tr, f.x );
				vec3 bm = mix( bl, br, f.x );
				gl_FragColor.rgb = mix( tm, bm, f.y );

				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`
    ),
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
  return shaderMaterial;
}
function _getCubemapShader() {
  const shaderMaterial = new RawShaderMaterial2({
    name: "CubemapToCubeUV",
    uniforms: {
      "envMap": { value: null },
      "inputEncoding": { value: ENCODINGS[LinearEncoding] },
      "outputEncoding": { value: ENCODINGS[LinearEncoding] }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			${_getEncodings()}

			void main() {

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb = envMapTexelToLinear( textureCube( envMap, vec3( - vOutputDirection.x, vOutputDirection.yz ) ) ).rgb;
				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`
    ),
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
  return shaderMaterial;
}
function _getCommonVertexShader() {
  return (
    /* glsl */
    `

		precision mediump float;
		precision mediump int;

		attribute vec3 position;
		attribute vec2 uv;
		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
  );
}
function _getEncodings() {
  return (
    /* glsl */
    `

		uniform int inputEncoding;
		uniform int outputEncoding;

		#include <encodings_pars_fragment>

		vec4 inputTexelToLinear( vec4 value ) {

			if ( inputEncoding == 0 ) {

				return value;

			} else if ( inputEncoding == 1 ) {

				return sRGBToLinear( value );

			} else if ( inputEncoding == 2 ) {

				return RGBEToLinear( value );

			} else if ( inputEncoding == 3 ) {

				return RGBMToLinear( value, 7.0 );

			} else if ( inputEncoding == 4 ) {

				return RGBMToLinear( value, 16.0 );

			} else if ( inputEncoding == 5 ) {

				return RGBDToLinear( value, 256.0 );

			} else {

				return GammaToLinear( value, 2.2 );

			}

		}

		vec4 linearToOutputTexel( vec4 value ) {

			if ( outputEncoding == 0 ) {

				return value;

			} else if ( outputEncoding == 1 ) {

				return LinearTosRGB( value );

			} else if ( outputEncoding == 2 ) {

				return LinearToRGBE( value );

			} else if ( outputEncoding == 3 ) {

				return LinearToRGBM( value, 7.0 );

			} else if ( outputEncoding == 4 ) {

				return LinearToRGBM( value, 16.0 );

			} else if ( outputEncoding == 5 ) {

				return LinearToRGBD( value, 256.0 );

			} else {

				return LinearToGamma( value, 2.2 );

			}

		}

		vec4 envMapTexelToLinear( vec4 color ) {

			return inputTexelToLinear( color );

		}
	`
  );
}
function WebGLCubeUVMaps(renderer) {
  let cubeUVmaps = /* @__PURE__ */ new WeakMap();
  let pmremGenerator = null;
  function get(texture) {
    if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
      const mapping = texture.mapping;
      const isEquirectMap = mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping;
      const isCubeMap = mapping === CubeReflectionMapping || mapping === CubeRefractionMapping;
      if (isEquirectMap || isCubeMap) {
        if (cubeUVmaps.has(texture)) {
          return cubeUVmaps.get(texture).texture;
        } else {
          const image2 = texture.image;
          if (isEquirectMap && image2 && image2.height > 0 || isCubeMap && image2 && isCubeTextureComplete(image2)) {
            const currentRenderTarget = renderer.getRenderTarget();
            if (pmremGenerator === null) pmremGenerator = new PMREMGenerator2(renderer);
            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
            cubeUVmaps.set(texture, renderTarget);
            renderer.setRenderTarget(currentRenderTarget);
            texture.addEventListener("dispose", onTextureDispose);
            return renderTarget.texture;
          } else {
            return null;
          }
        }
      }
    }
    return texture;
  }
  function isCubeTextureComplete(image2) {
    let count = 0;
    const length2 = 6;
    for (let i2 = 0; i2 < length2; i2++) {
      if (image2[i2] !== void 0) count++;
    }
    return count === length2;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    const cubemapUV = cubeUVmaps.get(texture);
    if (cubemapUV !== void 0) {
      cubeUVmaps.delete(texture);
      cubemapUV.dispose();
    }
  }
  function dispose() {
    cubeUVmaps = /* @__PURE__ */ new WeakMap();
    if (pmremGenerator !== null) {
      pmremGenerator.dispose();
      pmremGenerator = null;
    }
  }
  return {
    get,
    dispose
  };
}
function WebGLExtensions(gl) {
  const extensions = {};
  function getExtension(name) {
    if (extensions[name] !== void 0) {
      return extensions[name];
    }
    let extension;
    switch (name) {
      case "WEBGL_depth_texture":
        extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        extension = gl.getExtension(name);
    }
    extensions[name] = extension;
    return extension;
  }
  return {
    has: function(name) {
      return getExtension(name) !== null;
    },
    init: function(capabilities) {
      if (capabilities.isWebGL2) {
        getExtension("EXT_color_buffer_float");
      } else {
        getExtension("WEBGL_depth_texture");
        getExtension("OES_texture_float");
        getExtension("OES_texture_half_float");
        getExtension("OES_texture_half_float_linear");
        getExtension("OES_standard_derivatives");
        getExtension("OES_element_index_uint");
        getExtension("OES_vertex_array_object");
        getExtension("ANGLE_instanced_arrays");
      }
      getExtension("OES_texture_float_linear");
      getExtension("EXT_color_buffer_half_float");
    },
    get: function(name) {
      const extension = getExtension(name);
      if (extension === null) {
        console.warn("THREE.WebGLRenderer: " + name + " extension not supported.");
      }
      return extension;
    }
  };
}
function WebGLGeometries(gl, attributes, info, bindingStates) {
  const geometries = {};
  const wireframeAttributes = /* @__PURE__ */ new WeakMap();
  function onGeometryDispose(event) {
    const geometry = event.target;
    if (geometry.index !== null) {
      attributes.remove(geometry.index);
    }
    for (const name in geometry.attributes) {
      attributes.remove(geometry.attributes[name]);
    }
    geometry.removeEventListener("dispose", onGeometryDispose);
    delete geometries[geometry.id];
    const attribute = wireframeAttributes.get(geometry);
    if (attribute) {
      attributes.remove(attribute);
      wireframeAttributes.delete(geometry);
    }
    bindingStates.releaseStatesOfGeometry(geometry);
    if (geometry.isInstancedBufferGeometry === true) {
      delete geometry._maxInstanceCount;
    }
    info.memory.geometries--;
  }
  function get(object, geometry) {
    if (geometries[geometry.id] === true) return geometry;
    geometry.addEventListener("dispose", onGeometryDispose);
    geometries[geometry.id] = true;
    info.memory.geometries++;
    return geometry;
  }
  function update(geometry) {
    const geometryAttributes = geometry.attributes;
    for (const name in geometryAttributes) {
      attributes.update(geometryAttributes[name], 34962);
    }
    const morphAttributes = geometry.morphAttributes;
    for (const name in morphAttributes) {
      const array = morphAttributes[name];
      for (let i2 = 0, l2 = array.length; i2 < l2; i2++) {
        attributes.update(array[i2], 34962);
      }
    }
  }
  function updateWireframeAttribute(geometry) {
    const indices = [];
    const geometryIndex = geometry.index;
    const geometryPosition = geometry.attributes.position;
    let version = 0;
    if (geometryIndex !== null) {
      const array = geometryIndex.array;
      version = geometryIndex.version;
      for (let i2 = 0, l2 = array.length; i2 < l2; i2 += 3) {
        const a3 = array[i2 + 0];
        const b = array[i2 + 1];
        const c2 = array[i2 + 2];
        indices.push(a3, b, b, c2, c2, a3);
      }
    } else {
      const array = geometryPosition.array;
      version = geometryPosition.version;
      for (let i2 = 0, l2 = array.length / 3 - 1; i2 < l2; i2 += 3) {
        const a3 = i2 + 0;
        const b = i2 + 1;
        const c2 = i2 + 2;
        indices.push(a3, b, b, c2, c2, a3);
      }
    }
    const attribute = new (arrayMax(indices) > 65535 ? Uint32BufferAttribute2 : Uint16BufferAttribute2)(indices, 1);
    attribute.version = version;
    const previousAttribute = wireframeAttributes.get(geometry);
    if (previousAttribute) attributes.remove(previousAttribute);
    wireframeAttributes.set(geometry, attribute);
  }
  function getWireframeAttribute(geometry) {
    const currentAttribute = wireframeAttributes.get(geometry);
    if (currentAttribute) {
      const geometryIndex = geometry.index;
      if (geometryIndex !== null) {
        if (currentAttribute.version < geometryIndex.version) {
          updateWireframeAttribute(geometry);
        }
      }
    } else {
      updateWireframeAttribute(geometry);
    }
    return wireframeAttributes.get(geometry);
  }
  return {
    get,
    update,
    getWireframeAttribute
  };
}
function WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  let mode;
  function setMode(value) {
    mode = value;
  }
  let type, bytesPerElement;
  function setIndex(value) {
    type = value.type;
    bytesPerElement = value.bytesPerElement;
  }
  function render(start, count) {
    gl.drawElements(mode, count, type, start * bytesPerElement);
    info.update(count, mode, 1);
  }
  function renderInstances(start, count, primcount) {
    if (primcount === 0) return;
    let extension, methodName;
    if (isWebGL2) {
      extension = gl;
      methodName = "drawElementsInstanced";
    } else {
      extension = extensions.get("ANGLE_instanced_arrays");
      methodName = "drawElementsInstancedANGLE";
      if (extension === null) {
        console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
        return;
      }
    }
    extension[methodName](mode, count, type, start * bytesPerElement, primcount);
    info.update(count, mode, primcount);
  }
  this.setMode = setMode;
  this.setIndex = setIndex;
  this.render = render;
  this.renderInstances = renderInstances;
}
function WebGLInfo(gl) {
  const memory = {
    geometries: 0,
    textures: 0
  };
  const render = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function update(count, mode, instanceCount) {
    render.calls++;
    switch (mode) {
      case 4:
        render.triangles += instanceCount * (count / 3);
        break;
      case 1:
        render.lines += instanceCount * (count / 2);
        break;
      case 3:
        render.lines += instanceCount * (count - 1);
        break;
      case 2:
        render.lines += instanceCount * count;
        break;
      case 0:
        render.points += instanceCount * count;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
        break;
    }
  }
  function reset() {
    render.frame++;
    render.calls = 0;
    render.triangles = 0;
    render.points = 0;
    render.lines = 0;
  }
  return {
    memory,
    render,
    programs: null,
    autoReset: true,
    reset,
    update
  };
}
function numericalSort(a3, b) {
  return a3[0] - b[0];
}
function absNumericalSort(a3, b) {
  return Math.abs(b[1]) - Math.abs(a3[1]);
}
function WebGLMorphtargets(gl) {
  const influencesList = {};
  const morphInfluences = new Float32Array(8);
  const workInfluences = [];
  for (let i2 = 0; i2 < 8; i2++) {
    workInfluences[i2] = [i2, 0];
  }
  function update(object, geometry, material, program) {
    const objectInfluences = object.morphTargetInfluences;
    const length2 = objectInfluences === void 0 ? 0 : objectInfluences.length;
    let influences = influencesList[geometry.id];
    if (influences === void 0 || influences.length !== length2) {
      influences = [];
      for (let i2 = 0; i2 < length2; i2++) {
        influences[i2] = [i2, 0];
      }
      influencesList[geometry.id] = influences;
    }
    for (let i2 = 0; i2 < length2; i2++) {
      const influence = influences[i2];
      influence[0] = i2;
      influence[1] = objectInfluences[i2];
    }
    influences.sort(absNumericalSort);
    for (let i2 = 0; i2 < 8; i2++) {
      if (i2 < length2 && influences[i2][1]) {
        workInfluences[i2][0] = influences[i2][0];
        workInfluences[i2][1] = influences[i2][1];
      } else {
        workInfluences[i2][0] = Number.MAX_SAFE_INTEGER;
        workInfluences[i2][1] = 0;
      }
    }
    workInfluences.sort(numericalSort);
    const morphTargets = geometry.morphAttributes.position;
    const morphNormals = geometry.morphAttributes.normal;
    let morphInfluencesSum = 0;
    for (let i2 = 0; i2 < 8; i2++) {
      const influence = workInfluences[i2];
      const index2 = influence[0];
      const value = influence[1];
      if (index2 !== Number.MAX_SAFE_INTEGER && value) {
        if (morphTargets && geometry.getAttribute("morphTarget" + i2) !== morphTargets[index2]) {
          geometry.setAttribute("morphTarget" + i2, morphTargets[index2]);
        }
        if (morphNormals && geometry.getAttribute("morphNormal" + i2) !== morphNormals[index2]) {
          geometry.setAttribute("morphNormal" + i2, morphNormals[index2]);
        }
        morphInfluences[i2] = value;
        morphInfluencesSum += value;
      } else {
        if (morphTargets && geometry.hasAttribute("morphTarget" + i2) === true) {
          geometry.deleteAttribute("morphTarget" + i2);
        }
        if (morphNormals && geometry.hasAttribute("morphNormal" + i2) === true) {
          geometry.deleteAttribute("morphNormal" + i2);
        }
        morphInfluences[i2] = 0;
      }
    }
    const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
    program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
    program.getUniforms().setValue(gl, "morphTargetInfluences", morphInfluences);
  }
  return {
    update
  };
}
function WebGLObjects(gl, geometries, attributes, info) {
  let updateMap = /* @__PURE__ */ new WeakMap();
  function update(object) {
    const frame = info.render.frame;
    const geometry = object.geometry;
    const buffergeometry = geometries.get(object, geometry);
    if (updateMap.get(buffergeometry) !== frame) {
      geometries.update(buffergeometry);
      updateMap.set(buffergeometry, frame);
    }
    if (object.isInstancedMesh) {
      if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) {
        object.addEventListener("dispose", onInstancedMeshDispose);
      }
      attributes.update(object.instanceMatrix, 34962);
      if (object.instanceColor !== null) {
        attributes.update(object.instanceColor, 34962);
      }
    }
    return buffergeometry;
  }
  function dispose() {
    updateMap = /* @__PURE__ */ new WeakMap();
  }
  function onInstancedMeshDispose(event) {
    const instancedMesh = event.target;
    instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
    attributes.remove(instancedMesh.instanceMatrix);
    if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
  }
  return {
    update,
    dispose
  };
}
class DataTexture2DArray extends Texture2 {
  constructor(data = null, width = 1, height = 1, depth = 1) {
    super(null);
    this.image = { data, width, height, depth };
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.wrapR = ClampToEdgeWrapping;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
    this.needsUpdate = true;
  }
}
DataTexture2DArray.prototype.isDataTexture2DArray = true;
class DataTexture3D extends Texture2 {
  constructor(data = null, width = 1, height = 1, depth = 1) {
    super(null);
    this.image = { data, width, height, depth };
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.wrapR = ClampToEdgeWrapping;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
    this.needsUpdate = true;
  }
}
DataTexture3D.prototype.isDataTexture3D = true;
const emptyTexture = new Texture2();
const emptyTexture2dArray = new DataTexture2DArray();
const emptyTexture3d = new DataTexture3D();
const emptyCubeTexture = new CubeTexture2();
const arrayCacheF32 = [];
const arrayCacheI32 = [];
const mat4array = new Float32Array(16);
const mat3array = new Float32Array(9);
const mat2array = new Float32Array(4);
function flatten(array, nBlocks, blockSize) {
  const firstElem = array[0];
  if (firstElem <= 0 || firstElem > 0) return array;
  const n2 = nBlocks * blockSize;
  let r2 = arrayCacheF32[n2];
  if (r2 === void 0) {
    r2 = new Float32Array(n2);
    arrayCacheF32[n2] = r2;
  }
  if (nBlocks !== 0) {
    firstElem.toArray(r2, 0);
    for (let i2 = 1, offset = 0; i2 !== nBlocks; ++i2) {
      offset += blockSize;
      array[i2].toArray(r2, offset);
    }
  }
  return r2;
}
function arraysEqual(a3, b) {
  if (a3.length !== b.length) return false;
  for (let i2 = 0, l2 = a3.length; i2 < l2; i2++) {
    if (a3[i2] !== b[i2]) return false;
  }
  return true;
}
function copyArray(a3, b) {
  for (let i2 = 0, l2 = b.length; i2 < l2; i2++) {
    a3[i2] = b[i2];
  }
}
function allocTexUnits(textures, n2) {
  let r2 = arrayCacheI32[n2];
  if (r2 === void 0) {
    r2 = new Int32Array(n2);
    arrayCacheI32[n2] = r2;
  }
  for (let i2 = 0; i2 !== n2; ++i2) {
    r2[i2] = textures.allocateTextureUnit();
  }
  return r2;
}
function setValueV1f(gl, v) {
  const cache = this.cache;
  if (cache[0] === v) return;
  gl.uniform1f(this.addr, v);
  cache[0] = v;
}
function setValueV2f(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y) {
      gl.uniform2f(this.addr, v.x, v.y);
      cache[0] = v.x;
      cache[1] = v.y;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform2fv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueV3f(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
      gl.uniform3f(this.addr, v.x, v.y, v.z);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
    }
  } else if (v.r !== void 0) {
    if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
      gl.uniform3f(this.addr, v.r, v.g, v.b);
      cache[0] = v.r;
      cache[1] = v.g;
      cache[2] = v.b;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform3fv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueV4f(gl, v) {
  const cache = this.cache;
  if (v.x !== void 0) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
      gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
      cache[3] = v.w;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform4fv(this.addr, v);
    copyArray(cache, v);
  }
}
function setValueM2(gl, v) {
  const cache = this.cache;
  const elements = v.elements;
  if (elements === void 0) {
    if (arraysEqual(cache, v)) return;
    gl.uniformMatrix2fv(this.addr, false, v);
    copyArray(cache, v);
  } else {
    if (arraysEqual(cache, elements)) return;
    mat2array.set(elements);
    gl.uniformMatrix2fv(this.addr, false, mat2array);
    copyArray(cache, elements);
  }
}
function setValueM3(gl, v) {
  const cache = this.cache;
  const elements = v.elements;
  if (elements === void 0) {
    if (arraysEqual(cache, v)) return;
    gl.uniformMatrix3fv(this.addr, false, v);
    copyArray(cache, v);
  } else {
    if (arraysEqual(cache, elements)) return;
    mat3array.set(elements);
    gl.uniformMatrix3fv(this.addr, false, mat3array);
    copyArray(cache, elements);
  }
}
function setValueM4(gl, v) {
  const cache = this.cache;
  const elements = v.elements;
  if (elements === void 0) {
    if (arraysEqual(cache, v)) return;
    gl.uniformMatrix4fv(this.addr, false, v);
    copyArray(cache, v);
  } else {
    if (arraysEqual(cache, elements)) return;
    mat4array.set(elements);
    gl.uniformMatrix4fv(this.addr, false, mat4array);
    copyArray(cache, elements);
  }
}
function setValueV1i(gl, v) {
  const cache = this.cache;
  if (cache[0] === v) return;
  gl.uniform1i(this.addr, v);
  cache[0] = v;
}
function setValueV2i(gl, v) {
  const cache = this.cache;
  if (arraysEqual(cache, v)) return;
  gl.uniform2iv(this.addr, v);
  copyArray(cache, v);
}
function setValueV3i(gl, v) {
  const cache = this.cache;
  if (arraysEqual(cache, v)) return;
  gl.uniform3iv(this.addr, v);
  copyArray(cache, v);
}
function setValueV4i(gl, v) {
  const cache = this.cache;
  if (arraysEqual(cache, v)) return;
  gl.uniform4iv(this.addr, v);
  copyArray(cache, v);
}
function setValueV1ui(gl, v) {
  const cache = this.cache;
  if (cache[0] === v) return;
  gl.uniform1ui(this.addr, v);
  cache[0] = v;
}
function setValueV2ui(gl, v) {
  const cache = this.cache;
  if (arraysEqual(cache, v)) return;
  gl.uniform2uiv(this.addr, v);
  copyArray(cache, v);
}
function setValueV3ui(gl, v) {
  const cache = this.cache;
  if (arraysEqual(cache, v)) return;
  gl.uniform3uiv(this.addr, v);
  copyArray(cache, v);
}
function setValueV4ui(gl, v) {
  const cache = this.cache;
  if (arraysEqual(cache, v)) return;
  gl.uniform4uiv(this.addr, v);
  copyArray(cache, v);
}
function setValueT1(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.safeSetTexture2D(v || emptyTexture, unit);
}
function setValueT3D1(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.setTexture3D(v || emptyTexture3d, unit);
}
function setValueT6(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.safeSetTextureCube(v || emptyCubeTexture, unit);
}
function setValueT2DArray1(gl, v, textures) {
  const cache = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }
  textures.setTexture2DArray(v || emptyTexture2dArray, unit);
}
function getSingularSetter(type) {
  switch (type) {
    case 5126:
      return setValueV1f;
    case 35664:
      return setValueV2f;
    case 35665:
      return setValueV3f;
    case 35666:
      return setValueV4f;
    case 35674:
      return setValueM2;
    case 35675:
      return setValueM3;
    case 35676:
      return setValueM4;
    case 5124:
    case 35670:
      return setValueV1i;
    case 35667:
    case 35671:
      return setValueV2i;
    case 35668:
    case 35672:
      return setValueV3i;
    case 35669:
    case 35673:
      return setValueV4i;
    case 5125:
      return setValueV1ui;
    case 36294:
      return setValueV2ui;
    case 36295:
      return setValueV3ui;
    case 36296:
      return setValueV4ui;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return setValueT1;
    case 35679:
    case 36299:
    case 36307:
      return setValueT3D1;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return setValueT6;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return setValueT2DArray1;
  }
}
function setValueV1fArray(gl, v) {
  gl.uniform1fv(this.addr, v);
}
function setValueV2fArray(gl, v) {
  const data = flatten(v, this.size, 2);
  gl.uniform2fv(this.addr, data);
}
function setValueV3fArray(gl, v) {
  const data = flatten(v, this.size, 3);
  gl.uniform3fv(this.addr, data);
}
function setValueV4fArray(gl, v) {
  const data = flatten(v, this.size, 4);
  gl.uniform4fv(this.addr, data);
}
function setValueM2Array(gl, v) {
  const data = flatten(v, this.size, 4);
  gl.uniformMatrix2fv(this.addr, false, data);
}
function setValueM3Array(gl, v) {
  const data = flatten(v, this.size, 9);
  gl.uniformMatrix3fv(this.addr, false, data);
}
function setValueM4Array(gl, v) {
  const data = flatten(v, this.size, 16);
  gl.uniformMatrix4fv(this.addr, false, data);
}
function setValueV1iArray(gl, v) {
  gl.uniform1iv(this.addr, v);
}
function setValueV2iArray(gl, v) {
  gl.uniform2iv(this.addr, v);
}
function setValueV3iArray(gl, v) {
  gl.uniform3iv(this.addr, v);
}
function setValueV4iArray(gl, v) {
  gl.uniform4iv(this.addr, v);
}
function setValueV1uiArray(gl, v) {
  gl.uniform1uiv(this.addr, v);
}
function setValueV2uiArray(gl, v) {
  gl.uniform2uiv(this.addr, v);
}
function setValueV3uiArray(gl, v) {
  gl.uniform3uiv(this.addr, v);
}
function setValueV4uiArray(gl, v) {
  gl.uniform4uiv(this.addr, v);
}
function setValueT1Array(gl, v, textures) {
  const n2 = v.length;
  const units = allocTexUnits(textures, n2);
  gl.uniform1iv(this.addr, units);
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.safeSetTexture2D(v[i2] || emptyTexture, units[i2]);
  }
}
function setValueT6Array(gl, v, textures) {
  const n2 = v.length;
  const units = allocTexUnits(textures, n2);
  gl.uniform1iv(this.addr, units);
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.safeSetTextureCube(v[i2] || emptyCubeTexture, units[i2]);
  }
}
function getPureArraySetter(type) {
  switch (type) {
    case 5126:
      return setValueV1fArray;
    case 35664:
      return setValueV2fArray;
    case 35665:
      return setValueV3fArray;
    case 35666:
      return setValueV4fArray;
    case 35674:
      return setValueM2Array;
    case 35675:
      return setValueM3Array;
    case 35676:
      return setValueM4Array;
    case 5124:
    case 35670:
      return setValueV1iArray;
    case 35667:
    case 35671:
      return setValueV2iArray;
    case 35668:
    case 35672:
      return setValueV3iArray;
    case 35669:
    case 35673:
      return setValueV4iArray;
    case 5125:
      return setValueV1uiArray;
    case 36294:
      return setValueV2uiArray;
    case 36295:
      return setValueV3uiArray;
    case 36296:
      return setValueV4uiArray;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return setValueT1Array;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return setValueT6Array;
  }
}
function SingleUniform2(id, activeInfo, addr) {
  this.id = id;
  this.addr = addr;
  this.cache = [];
  this.setValue = getSingularSetter(activeInfo.type);
}
function PureArrayUniform2(id, activeInfo, addr) {
  this.id = id;
  this.addr = addr;
  this.cache = [];
  this.size = activeInfo.size;
  this.setValue = getPureArraySetter(activeInfo.type);
}
PureArrayUniform2.prototype.updateCache = function(data) {
  const cache = this.cache;
  if (data instanceof Float32Array && cache.length !== data.length) {
    this.cache = new Float32Array(data.length);
  }
  copyArray(cache, data);
};
function StructuredUniform2(id) {
  this.id = id;
  this.seq = [];
  this.map = {};
}
StructuredUniform2.prototype.setValue = function(gl, value, textures) {
  const seq = this.seq;
  for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
    const u3 = seq[i2];
    u3.setValue(gl, value[u3.id], textures);
  }
};
const RePathPart = /(\w+)(\])?(\[|\.)?/g;
function addUniform(container, uniformObject) {
  container.seq.push(uniformObject);
  container.map[uniformObject.id] = uniformObject;
}
function parseUniform(activeInfo, addr, container) {
  const path = activeInfo.name, pathLength = path.length;
  RePathPart.lastIndex = 0;
  while (true) {
    const match = RePathPart.exec(path), matchEnd = RePathPart.lastIndex;
    let id = match[1];
    const idIsIndex = match[2] === "]", subscript = match[3];
    if (idIsIndex) id = id | 0;
    if (subscript === void 0 || subscript === "[" && matchEnd + 2 === pathLength) {
      addUniform(container, subscript === void 0 ? new SingleUniform2(id, activeInfo, addr) : new PureArrayUniform2(id, activeInfo, addr));
      break;
    } else {
      const map = container.map;
      let next = map[id];
      if (next === void 0) {
        next = new StructuredUniform2(id);
        addUniform(container, next);
      }
      container = next;
    }
  }
}
function WebGLUniforms2(gl, program) {
  this.seq = [];
  this.map = {};
  const n2 = gl.getProgramParameter(program, 35718);
  for (let i2 = 0; i2 < n2; ++i2) {
    const info = gl.getActiveUniform(program, i2), addr = gl.getUniformLocation(program, info.name);
    parseUniform(info, addr, this);
  }
}
WebGLUniforms2.prototype.setValue = function(gl, name, value, textures) {
  const u3 = this.map[name];
  if (u3 !== void 0) u3.setValue(gl, value, textures);
};
WebGLUniforms2.prototype.setOptional = function(gl, object, name) {
  const v = object[name];
  if (v !== void 0) this.setValue(gl, name, v);
};
WebGLUniforms2.upload = function(gl, seq, values, textures) {
  for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
    const u3 = seq[i2], v = values[u3.id];
    if (v.needsUpdate !== false) {
      u3.setValue(gl, v.value, textures);
    }
  }
};
WebGLUniforms2.seqWithValue = function(seq, values) {
  const r2 = [];
  for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
    const u3 = seq[i2];
    if (u3.id in values) r2.push(u3);
  }
  return r2;
};
function WebGLShader(gl, type, string) {
  const shader = gl.createShader(type);
  gl.shaderSource(shader, string);
  gl.compileShader(shader);
  return shader;
}
let programIdCount = 0;
function addLineNumbers(string) {
  const lines = string.split("\n");
  for (let i2 = 0; i2 < lines.length; i2++) {
    lines[i2] = i2 + 1 + ": " + lines[i2];
  }
  return lines.join("\n");
}
function getEncodingComponents(encoding) {
  switch (encoding) {
    case LinearEncoding:
      return ["Linear", "( value )"];
    case sRGBEncoding:
      return ["sRGB", "( value )"];
    case RGBEEncoding:
      return ["RGBE", "( value )"];
    case RGBM7Encoding:
      return ["RGBM", "( value, 7.0 )"];
    case RGBM16Encoding:
      return ["RGBM", "( value, 16.0 )"];
    case RGBDEncoding:
      return ["RGBD", "( value, 256.0 )"];
    case GammaEncoding:
      return ["Gamma", "( value, float( GAMMA_FACTOR ) )"];
    case LogLuvEncoding:
      return ["LogLuv", "( value )"];
    default:
      console.warn("THREE.WebGLProgram: Unsupported encoding:", encoding);
      return ["Linear", "( value )"];
  }
}
function getShaderErrors(gl, shader, type) {
  const status = gl.getShaderParameter(shader, 35713);
  const errors = gl.getShaderInfoLog(shader).trim();
  if (status && errors === "") return "";
  return type.toUpperCase() + "\n\n" + errors + "\n\n" + addLineNumbers(gl.getShaderSource(shader));
}
function getTexelDecodingFunction(functionName, encoding) {
  const components = getEncodingComponents(encoding);
  return "vec4 " + functionName + "( vec4 value ) { return " + components[0] + "ToLinear" + components[1] + "; }";
}
function getTexelEncodingFunction(functionName, encoding) {
  const components = getEncodingComponents(encoding);
  return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[0] + components[1] + "; }";
}
function getToneMappingFunction(functionName, toneMapping) {
  let toneMappingName;
  switch (toneMapping) {
    case LinearToneMapping:
      toneMappingName = "Linear";
      break;
    case ReinhardToneMapping:
      toneMappingName = "Reinhard";
      break;
    case CineonToneMapping:
      toneMappingName = "OptimizedCineon";
      break;
    case ACESFilmicToneMapping:
      toneMappingName = "ACESFilmic";
      break;
    case CustomToneMapping:
      toneMappingName = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
      toneMappingName = "Linear";
  }
  return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function generateExtensions(parameters) {
  const chunks = [
    parameters.extensionDerivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
    (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
    parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
    (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
  ];
  return chunks.filter(filterEmptyLine).join("\n");
}
function generateDefines(defines) {
  const chunks = [];
  for (const name in defines) {
    const value = defines[name];
    if (value === false) continue;
    chunks.push("#define " + name + " " + value);
  }
  return chunks.join("\n");
}
function fetchAttributeLocations(gl, program) {
  const attributes = {};
  const n2 = gl.getProgramParameter(program, 35721);
  for (let i2 = 0; i2 < n2; i2++) {
    const info = gl.getActiveAttrib(program, i2);
    const name = info.name;
    let locationSize = 1;
    if (info.type === 35674) locationSize = 2;
    if (info.type === 35675) locationSize = 3;
    if (info.type === 35676) locationSize = 4;
    attributes[name] = {
      type: info.type,
      location: gl.getAttribLocation(program, name),
      locationSize
    };
  }
  return attributes;
}
function filterEmptyLine(string) {
  return string !== "";
}
function replaceLightNums(string, parameters) {
  return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function replaceClippingPlaneNums(string, parameters) {
  return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function resolveIncludes(string) {
  return string.replace(includePattern, includeReplacer);
}
function includeReplacer(match, include) {
  const string = ShaderChunk[include];
  if (string === void 0) {
    throw new Error("Can not resolve #include <" + include + ">");
  }
  return resolveIncludes(string);
}
const deprecatedUnrollLoopPattern = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
const unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function unrollLoops(string) {
  return string.replace(unrollLoopPattern, loopReplacer).replace(deprecatedUnrollLoopPattern, deprecatedLoopReplacer);
}
function deprecatedLoopReplacer(match, start, end, snippet) {
  console.warn("WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.");
  return loopReplacer(match, start, end, snippet);
}
function loopReplacer(match, start, end, snippet) {
  let string = "";
  for (let i2 = parseInt(start); i2 < parseInt(end); i2++) {
    string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i2 + " ]").replace(/UNROLLED_LOOP_INDEX/g, i2);
  }
  return string;
}
function generatePrecision(parameters) {
  let precisionstring = "precision " + parameters.precision + " float;\nprecision " + parameters.precision + " int;";
  if (parameters.precision === "highp") {
    precisionstring += "\n#define HIGH_PRECISION";
  } else if (parameters.precision === "mediump") {
    precisionstring += "\n#define MEDIUM_PRECISION";
  } else if (parameters.precision === "lowp") {
    precisionstring += "\n#define LOW_PRECISION";
  }
  return precisionstring;
}
function generateShadowMapTypeDefine(parameters) {
  let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
  if (parameters.shadowMapType === PCFShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
  } else if (parameters.shadowMapType === PCFSoftShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
  } else if (parameters.shadowMapType === VSMShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
  }
  return shadowMapTypeDefine;
}
function generateEnvMapTypeDefine(parameters) {
  let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeReflectionMapping:
      case CubeRefractionMapping:
        envMapTypeDefine = "ENVMAP_TYPE_CUBE";
        break;
      case CubeUVReflectionMapping:
      case CubeUVRefractionMapping:
        envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
        break;
    }
  }
  return envMapTypeDefine;
}
function generateEnvMapModeDefine(parameters) {
  let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeRefractionMapping:
      case CubeUVRefractionMapping:
        envMapModeDefine = "ENVMAP_MODE_REFRACTION";
        break;
    }
  }
  return envMapModeDefine;
}
function generateEnvMapBlendingDefine(parameters) {
  let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
  if (parameters.envMap) {
    switch (parameters.combine) {
      case MultiplyOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
        break;
      case MixOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
        break;
      case AddOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
        break;
    }
  }
  return envMapBlendingDefine;
}
function WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
  const gl = renderer.getContext();
  const defines = parameters.defines;
  let vertexShader = parameters.vertexShader;
  let fragmentShader = parameters.fragmentShader;
  const shadowMapTypeDefine = generateShadowMapTypeDefine(parameters);
  const envMapTypeDefine = generateEnvMapTypeDefine(parameters);
  const envMapModeDefine = generateEnvMapModeDefine(parameters);
  const envMapBlendingDefine = generateEnvMapBlendingDefine(parameters);
  const gammaFactorDefine = renderer.gammaFactor > 0 ? renderer.gammaFactor : 1;
  const customExtensions = parameters.isWebGL2 ? "" : generateExtensions(parameters);
  const customDefines = generateDefines(defines);
  const program = gl.createProgram();
  let prefixVertex, prefixFragment;
  let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
  if (parameters.isRawShaderMaterial) {
    prefixVertex = [
      customDefines
    ].filter(filterEmptyLine).join("\n");
    if (prefixVertex.length > 0) {
      prefixVertex += "\n";
    }
    prefixFragment = [
      customExtensions,
      customDefines
    ].filter(filterEmptyLine).join("\n");
    if (prefixFragment.length > 0) {
      prefixFragment += "\n";
    }
  } else {
    prefixVertex = [
      generatePrecision(parameters),
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines,
      parameters.instancing ? "#define USE_INSTANCING" : "",
      parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
      parameters.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
      "#define GAMMA_FACTOR " + gammaFactorDefine,
      "#define MAX_BONES " + parameters.maxBones,
      parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
      parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
      parameters.map ? "#define USE_MAP" : "",
      parameters.envMap ? "#define USE_ENVMAP" : "",
      parameters.envMap ? "#define " + envMapModeDefine : "",
      parameters.lightMap ? "#define USE_LIGHTMAP" : "",
      parameters.aoMap ? "#define USE_AOMAP" : "",
      parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
      parameters.bumpMap ? "#define USE_BUMPMAP" : "",
      parameters.normalMap ? "#define USE_NORMALMAP" : "",
      parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
      parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
      parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
      parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
      parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
      parameters.displacementMap && parameters.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
      parameters.specularMap ? "#define USE_SPECULARMAP" : "",
      parameters.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
      parameters.specularTintMap ? "#define USE_SPECULARTINTMAP" : "",
      parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
      parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
      parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
      parameters.transmission ? "#define USE_TRANSMISSION" : "",
      parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
      parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
      parameters.vertexTangents ? "#define USE_TANGENT" : "",
      parameters.vertexColors ? "#define USE_COLOR" : "",
      parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
      parameters.vertexUvs ? "#define USE_UV" : "",
      parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
      parameters.flatShading ? "#define FLAT_SHADED" : "",
      parameters.skinning ? "#define USE_SKINNING" : "",
      parameters.useVertexTexture ? "#define BONE_TEXTURE" : "",
      parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
      parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
      parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
      parameters.flipSided ? "#define FLIP_SIDED" : "",
      parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
      parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
      parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
      parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
      parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
      "uniform mat4 modelMatrix;",
      "uniform mat4 modelViewMatrix;",
      "uniform mat4 projectionMatrix;",
      "uniform mat4 viewMatrix;",
      "uniform mat3 normalMatrix;",
      "uniform vec3 cameraPosition;",
      "uniform bool isOrthographic;",
      "#ifdef USE_INSTANCING",
      "	attribute mat4 instanceMatrix;",
      "#endif",
      "#ifdef USE_INSTANCING_COLOR",
      "	attribute vec3 instanceColor;",
      "#endif",
      "attribute vec3 position;",
      "attribute vec3 normal;",
      "attribute vec2 uv;",
      "#ifdef USE_TANGENT",
      "	attribute vec4 tangent;",
      "#endif",
      "#if defined( USE_COLOR_ALPHA )",
      "	attribute vec4 color;",
      "#elif defined( USE_COLOR )",
      "	attribute vec3 color;",
      "#endif",
      "#ifdef USE_MORPHTARGETS",
      "	attribute vec3 morphTarget0;",
      "	attribute vec3 morphTarget1;",
      "	attribute vec3 morphTarget2;",
      "	attribute vec3 morphTarget3;",
      "	#ifdef USE_MORPHNORMALS",
      "		attribute vec3 morphNormal0;",
      "		attribute vec3 morphNormal1;",
      "		attribute vec3 morphNormal2;",
      "		attribute vec3 morphNormal3;",
      "	#else",
      "		attribute vec3 morphTarget4;",
      "		attribute vec3 morphTarget5;",
      "		attribute vec3 morphTarget6;",
      "		attribute vec3 morphTarget7;",
      "	#endif",
      "#endif",
      "#ifdef USE_SKINNING",
      "	attribute vec4 skinIndex;",
      "	attribute vec4 skinWeight;",
      "#endif",
      "\n"
    ].filter(filterEmptyLine).join("\n");
    prefixFragment = [
      customExtensions,
      generatePrecision(parameters),
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines,
      "#define GAMMA_FACTOR " + gammaFactorDefine,
      parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
      parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
      parameters.map ? "#define USE_MAP" : "",
      parameters.matcap ? "#define USE_MATCAP" : "",
      parameters.envMap ? "#define USE_ENVMAP" : "",
      parameters.envMap ? "#define " + envMapTypeDefine : "",
      parameters.envMap ? "#define " + envMapModeDefine : "",
      parameters.envMap ? "#define " + envMapBlendingDefine : "",
      parameters.lightMap ? "#define USE_LIGHTMAP" : "",
      parameters.aoMap ? "#define USE_AOMAP" : "",
      parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
      parameters.bumpMap ? "#define USE_BUMPMAP" : "",
      parameters.normalMap ? "#define USE_NORMALMAP" : "",
      parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
      parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
      parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
      parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
      parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
      parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
      parameters.specularMap ? "#define USE_SPECULARMAP" : "",
      parameters.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
      parameters.specularTintMap ? "#define USE_SPECULARTINTMAP" : "",
      parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
      parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
      parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
      parameters.alphaTest ? "#define USE_ALPHATEST" : "",
      parameters.sheenTint ? "#define USE_SHEEN" : "",
      parameters.transmission ? "#define USE_TRANSMISSION" : "",
      parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
      parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
      parameters.vertexTangents ? "#define USE_TANGENT" : "",
      parameters.vertexColors || parameters.instancingColor ? "#define USE_COLOR" : "",
      parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
      parameters.vertexUvs ? "#define USE_UV" : "",
      parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
      parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
      parameters.flatShading ? "#define FLAT_SHADED" : "",
      parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
      parameters.flipSided ? "#define FLIP_SIDED" : "",
      parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
      parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
      parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
      parameters.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
      parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
      parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
      (parameters.extensionShaderTextureLOD || parameters.envMap) && parameters.rendererExtensionShaderTextureLod ? "#define TEXTURE_LOD_EXT" : "",
      "uniform mat4 viewMatrix;",
      "uniform vec3 cameraPosition;",
      "uniform bool isOrthographic;",
      parameters.toneMapping !== NoToneMapping ? "#define TONE_MAPPING" : "",
      parameters.toneMapping !== NoToneMapping ? ShaderChunk["tonemapping_pars_fragment"] : "",
      // this code is required here because it is used by the toneMapping() function defined below
      parameters.toneMapping !== NoToneMapping ? getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
      parameters.dithering ? "#define DITHERING" : "",
      parameters.format === RGBFormat ? "#define OPAQUE" : "",
      ShaderChunk["encodings_pars_fragment"],
      // this code is required here because it is used by the various encoding/decoding function defined below
      parameters.map ? getTexelDecodingFunction("mapTexelToLinear", parameters.mapEncoding) : "",
      parameters.matcap ? getTexelDecodingFunction("matcapTexelToLinear", parameters.matcapEncoding) : "",
      parameters.envMap ? getTexelDecodingFunction("envMapTexelToLinear", parameters.envMapEncoding) : "",
      parameters.emissiveMap ? getTexelDecodingFunction("emissiveMapTexelToLinear", parameters.emissiveMapEncoding) : "",
      parameters.specularTintMap ? getTexelDecodingFunction("specularTintMapTexelToLinear", parameters.specularTintMapEncoding) : "",
      parameters.lightMap ? getTexelDecodingFunction("lightMapTexelToLinear", parameters.lightMapEncoding) : "",
      getTexelEncodingFunction("linearToOutputTexel", parameters.outputEncoding),
      parameters.depthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
      "\n"
    ].filter(filterEmptyLine).join("\n");
  }
  vertexShader = resolveIncludes(vertexShader);
  vertexShader = replaceLightNums(vertexShader, parameters);
  vertexShader = replaceClippingPlaneNums(vertexShader, parameters);
  fragmentShader = resolveIncludes(fragmentShader);
  fragmentShader = replaceLightNums(fragmentShader, parameters);
  fragmentShader = replaceClippingPlaneNums(fragmentShader, parameters);
  vertexShader = unrollLoops(vertexShader);
  fragmentShader = unrollLoops(fragmentShader);
  if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
    versionString = "#version 300 es\n";
    prefixVertex = [
      "#define attribute in",
      "#define varying out",
      "#define texture2D texture"
    ].join("\n") + "\n" + prefixVertex;
    prefixFragment = [
      "#define varying in",
      parameters.glslVersion === GLSL3 ? "" : "out highp vec4 pc_fragColor;",
      parameters.glslVersion === GLSL3 ? "" : "#define gl_FragColor pc_fragColor",
      "#define gl_FragDepthEXT gl_FragDepth",
      "#define texture2D texture",
      "#define textureCube texture",
      "#define texture2DProj textureProj",
      "#define texture2DLodEXT textureLod",
      "#define texture2DProjLodEXT textureProjLod",
      "#define textureCubeLodEXT textureLod",
      "#define texture2DGradEXT textureGrad",
      "#define texture2DProjGradEXT textureProjGrad",
      "#define textureCubeGradEXT textureGrad"
    ].join("\n") + "\n" + prefixFragment;
  }
  const vertexGlsl = versionString + prefixVertex + vertexShader;
  const fragmentGlsl = versionString + prefixFragment + fragmentShader;
  const glVertexShader = WebGLShader(gl, 35633, vertexGlsl);
  const glFragmentShader = WebGLShader(gl, 35632, fragmentGlsl);
  gl.attachShader(program, glVertexShader);
  gl.attachShader(program, glFragmentShader);
  if (parameters.index0AttributeName !== void 0) {
    gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
  } else if (parameters.morphTargets === true) {
    gl.bindAttribLocation(program, 0, "position");
  }
  gl.linkProgram(program);
  if (renderer.debug.checkShaderErrors) {
    const programLog = gl.getProgramInfoLog(program).trim();
    const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
    const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
    let runnable = true;
    let haveDiagnostics = true;
    if (gl.getProgramParameter(program, 35714) === false) {
      runnable = false;
      const vertexErrors = getShaderErrors(gl, glVertexShader, "vertex");
      const fragmentErrors = getShaderErrors(gl, glFragmentShader, "fragment");
      console.error(
        "THREE.WebGLProgram: Shader Error " + gl.getError() + " - VALIDATE_STATUS " + gl.getProgramParameter(program, 35715) + "\n\nProgram Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors
      );
    } else if (programLog !== "") {
      console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
    } else if (vertexLog === "" || fragmentLog === "") {
      haveDiagnostics = false;
    }
    if (haveDiagnostics) {
      this.diagnostics = {
        runnable,
        programLog,
        vertexShader: {
          log: vertexLog,
          prefix: prefixVertex
        },
        fragmentShader: {
          log: fragmentLog,
          prefix: prefixFragment
        }
      };
    }
  }
  gl.deleteShader(glVertexShader);
  gl.deleteShader(glFragmentShader);
  let cachedUniforms;
  this.getUniforms = function() {
    if (cachedUniforms === void 0) {
      cachedUniforms = new WebGLUniforms2(gl, program);
    }
    return cachedUniforms;
  };
  let cachedAttributes;
  this.getAttributes = function() {
    if (cachedAttributes === void 0) {
      cachedAttributes = fetchAttributeLocations(gl, program);
    }
    return cachedAttributes;
  };
  this.destroy = function() {
    bindingStates.releaseStatesOfProgram(this);
    gl.deleteProgram(program);
    this.program = void 0;
  };
  this.name = parameters.shaderName;
  this.id = programIdCount++;
  this.cacheKey = cacheKey;
  this.usedTimes = 1;
  this.program = program;
  this.vertexShader = glVertexShader;
  this.fragmentShader = glFragmentShader;
  return this;
}
function WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
  const programs = [];
  const isWebGL2 = capabilities.isWebGL2;
  const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
  const floatVertexTextures = capabilities.floatVertexTextures;
  const maxVertexUniforms = capabilities.maxVertexUniforms;
  const vertexTextures = capabilities.vertexTextures;
  let precision = capabilities.precision;
  const shaderIDs = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  const parameterNames = [
    "precision",
    "isWebGL2",
    "supportsVertexTextures",
    "outputEncoding",
    "instancing",
    "instancingColor",
    "map",
    "mapEncoding",
    "matcap",
    "matcapEncoding",
    "envMap",
    "envMapMode",
    "envMapEncoding",
    "envMapCubeUV",
    "lightMap",
    "lightMapEncoding",
    "aoMap",
    "emissiveMap",
    "emissiveMapEncoding",
    "bumpMap",
    "normalMap",
    "objectSpaceNormalMap",
    "tangentSpaceNormalMap",
    "clearcoat",
    "clearcoatMap",
    "clearcoatRoughnessMap",
    "clearcoatNormalMap",
    "displacementMap",
    "specularMap",
    "specularIntensityMap",
    "specularTintMap",
    "specularTintMapEncoding",
    "roughnessMap",
    "metalnessMap",
    "gradientMap",
    "alphaMap",
    "alphaTest",
    "combine",
    "vertexColors",
    "vertexAlphas",
    "vertexTangents",
    "vertexUvs",
    "uvsVertexOnly",
    "fog",
    "useFog",
    "fogExp2",
    "flatShading",
    "sizeAttenuation",
    "logarithmicDepthBuffer",
    "skinning",
    "maxBones",
    "useVertexTexture",
    "morphTargets",
    "morphNormals",
    "premultipliedAlpha",
    "numDirLights",
    "numPointLights",
    "numSpotLights",
    "numHemiLights",
    "numRectAreaLights",
    "numDirLightShadows",
    "numPointLightShadows",
    "numSpotLightShadows",
    "shadowMapEnabled",
    "shadowMapType",
    "toneMapping",
    "physicallyCorrectLights",
    "doubleSided",
    "flipSided",
    "numClippingPlanes",
    "numClipIntersection",
    "depthPacking",
    "dithering",
    "format",
    "sheenTint",
    "transmission",
    "transmissionMap",
    "thicknessMap"
  ];
  function getMaxBones(object) {
    const skeleton = object.skeleton;
    const bones = skeleton.bones;
    if (floatVertexTextures) {
      return 1024;
    } else {
      const nVertexUniforms = maxVertexUniforms;
      const nVertexMatrices = Math.floor((nVertexUniforms - 20) / 4);
      const maxBones = Math.min(nVertexMatrices, bones.length);
      if (maxBones < bones.length) {
        console.warn("THREE.WebGLRenderer: Skeleton has " + bones.length + " bones. This GPU supports " + maxBones + ".");
        return 0;
      }
      return maxBones;
    }
  }
  function getTextureEncodingFromMap(map) {
    let encoding;
    if (map && map.isTexture) {
      encoding = map.encoding;
    } else if (map && map.isWebGLRenderTarget) {
      console.warn("THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead.");
      encoding = map.texture.encoding;
    } else {
      encoding = LinearEncoding;
    }
    return encoding;
  }
  function getParameters(material, lights, shadows, scene, object) {
    const fog = scene.fog;
    const environment = material.isMeshStandardMaterial ? scene.environment : null;
    const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
    const shaderID = shaderIDs[material.type];
    const maxBones = object.isSkinnedMesh ? getMaxBones(object) : 0;
    if (material.precision !== null) {
      precision = capabilities.getMaxPrecision(material.precision);
      if (precision !== material.precision) {
        console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
      }
    }
    let vertexShader, fragmentShader;
    if (shaderID) {
      const shader = ShaderLib[shaderID];
      vertexShader = shader.vertexShader;
      fragmentShader = shader.fragmentShader;
    } else {
      vertexShader = material.vertexShader;
      fragmentShader = material.fragmentShader;
    }
    const currentRenderTarget = renderer.getRenderTarget();
    const useAlphaTest = material.alphaTest > 0;
    const useClearcoat = material.clearcoat > 0;
    const parameters = {
      isWebGL2,
      shaderID,
      shaderName: material.type,
      vertexShader,
      fragmentShader,
      defines: material.defines,
      isRawShaderMaterial: material.isRawShaderMaterial === true,
      glslVersion: material.glslVersion,
      precision,
      instancing: object.isInstancedMesh === true,
      instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
      supportsVertexTextures: vertexTextures,
      outputEncoding: currentRenderTarget !== null ? getTextureEncodingFromMap(currentRenderTarget.texture) : renderer.outputEncoding,
      map: !!material.map,
      mapEncoding: getTextureEncodingFromMap(material.map),
      matcap: !!material.matcap,
      matcapEncoding: getTextureEncodingFromMap(material.matcap),
      envMap: !!envMap,
      envMapMode: envMap && envMap.mapping,
      envMapEncoding: getTextureEncodingFromMap(envMap),
      envMapCubeUV: !!envMap && (envMap.mapping === CubeUVReflectionMapping || envMap.mapping === CubeUVRefractionMapping),
      lightMap: !!material.lightMap,
      lightMapEncoding: getTextureEncodingFromMap(material.lightMap),
      aoMap: !!material.aoMap,
      emissiveMap: !!material.emissiveMap,
      emissiveMapEncoding: getTextureEncodingFromMap(material.emissiveMap),
      bumpMap: !!material.bumpMap,
      normalMap: !!material.normalMap,
      objectSpaceNormalMap: material.normalMapType === ObjectSpaceNormalMap,
      tangentSpaceNormalMap: material.normalMapType === TangentSpaceNormalMap,
      clearcoat: useClearcoat,
      clearcoatMap: useClearcoat && !!material.clearcoatMap,
      clearcoatRoughnessMap: useClearcoat && !!material.clearcoatRoughnessMap,
      clearcoatNormalMap: useClearcoat && !!material.clearcoatNormalMap,
      displacementMap: !!material.displacementMap,
      roughnessMap: !!material.roughnessMap,
      metalnessMap: !!material.metalnessMap,
      specularMap: !!material.specularMap,
      specularIntensityMap: !!material.specularIntensityMap,
      specularTintMap: !!material.specularTintMap,
      specularTintMapEncoding: getTextureEncodingFromMap(material.specularTintMap),
      alphaMap: !!material.alphaMap,
      alphaTest: useAlphaTest,
      gradientMap: !!material.gradientMap,
      sheenTint: !!material.sheenTint && (material.sheenTint.r > 0 || material.sheenTint.g > 0 || material.sheenTint.b > 0),
      transmission: material.transmission > 0,
      transmissionMap: !!material.transmissionMap,
      thicknessMap: !!material.thicknessMap,
      combine: material.combine,
      vertexTangents: !!material.normalMap && !!object.geometry && !!object.geometry.attributes.tangent,
      vertexColors: material.vertexColors,
      vertexAlphas: material.vertexColors === true && !!object.geometry && !!object.geometry.attributes.color && object.geometry.attributes.color.itemSize === 4,
      vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.displacementMap || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularTintMap,
      uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || material.transmission > 0 || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularTintMap) && !!material.displacementMap,
      fog: !!fog,
      useFog: material.fog,
      fogExp2: fog && fog.isFogExp2,
      flatShading: !!material.flatShading,
      sizeAttenuation: material.sizeAttenuation,
      logarithmicDepthBuffer,
      skinning: object.isSkinnedMesh === true && maxBones > 0,
      maxBones,
      useVertexTexture: floatVertexTextures,
      morphTargets: !!object.geometry && !!object.geometry.morphAttributes.position,
      morphNormals: !!object.geometry && !!object.geometry.morphAttributes.normal,
      numDirLights: lights.directional.length,
      numPointLights: lights.point.length,
      numSpotLights: lights.spot.length,
      numRectAreaLights: lights.rectArea.length,
      numHemiLights: lights.hemi.length,
      numDirLightShadows: lights.directionalShadowMap.length,
      numPointLightShadows: lights.pointShadowMap.length,
      numSpotLightShadows: lights.spotShadowMap.length,
      numClippingPlanes: clipping.numPlanes,
      numClipIntersection: clipping.numIntersection,
      format: material.format,
      dithering: material.dithering,
      shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
      shadowMapType: renderer.shadowMap.type,
      toneMapping: material.toneMapped ? renderer.toneMapping : NoToneMapping,
      physicallyCorrectLights: renderer.physicallyCorrectLights,
      premultipliedAlpha: material.premultipliedAlpha,
      doubleSided: material.side === DoubleSide,
      flipSided: material.side === BackSide,
      depthPacking: material.depthPacking !== void 0 ? material.depthPacking : false,
      index0AttributeName: material.index0AttributeName,
      extensionDerivatives: material.extensions && material.extensions.derivatives,
      extensionFragDepth: material.extensions && material.extensions.fragDepth,
      extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
      extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
      rendererExtensionFragDepth: isWebGL2 || extensions.has("EXT_frag_depth"),
      rendererExtensionDrawBuffers: isWebGL2 || extensions.has("WEBGL_draw_buffers"),
      rendererExtensionShaderTextureLod: isWebGL2 || extensions.has("EXT_shader_texture_lod"),
      customProgramCacheKey: material.customProgramCacheKey()
    };
    return parameters;
  }
  function getProgramCacheKey(parameters) {
    const array = [];
    if (parameters.shaderID) {
      array.push(parameters.shaderID);
    } else {
      array.push(parameters.fragmentShader);
      array.push(parameters.vertexShader);
    }
    if (parameters.defines !== void 0) {
      for (const name in parameters.defines) {
        array.push(name);
        array.push(parameters.defines[name]);
      }
    }
    if (parameters.isRawShaderMaterial === false) {
      for (let i2 = 0; i2 < parameterNames.length; i2++) {
        array.push(parameters[parameterNames[i2]]);
      }
      array.push(renderer.outputEncoding);
      array.push(renderer.gammaFactor);
    }
    array.push(parameters.customProgramCacheKey);
    return array.join();
  }
  function getUniforms(material) {
    const shaderID = shaderIDs[material.type];
    let uniforms;
    if (shaderID) {
      const shader = ShaderLib[shaderID];
      uniforms = UniformsUtils.clone(shader.uniforms);
    } else {
      uniforms = material.uniforms;
    }
    return uniforms;
  }
  function acquireProgram(parameters, cacheKey) {
    let program;
    for (let p2 = 0, pl = programs.length; p2 < pl; p2++) {
      const preexistingProgram = programs[p2];
      if (preexistingProgram.cacheKey === cacheKey) {
        program = preexistingProgram;
        ++program.usedTimes;
        break;
      }
    }
    if (program === void 0) {
      program = new WebGLProgram(renderer, cacheKey, parameters, bindingStates);
      programs.push(program);
    }
    return program;
  }
  function releaseProgram(program) {
    if (--program.usedTimes === 0) {
      const i2 = programs.indexOf(program);
      programs[i2] = programs[programs.length - 1];
      programs.pop();
      program.destroy();
    }
  }
  return {
    getParameters,
    getProgramCacheKey,
    getUniforms,
    acquireProgram,
    releaseProgram,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs
  };
}
function WebGLProperties() {
  let properties = /* @__PURE__ */ new WeakMap();
  function get(object) {
    let map = properties.get(object);
    if (map === void 0) {
      map = {};
      properties.set(object, map);
    }
    return map;
  }
  function remove(object) {
    properties.delete(object);
  }
  function update(object, key, value) {
    properties.get(object)[key] = value;
  }
  function dispose() {
    properties = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    remove,
    update,
    dispose
  };
}
function painterSortStable(a3, b) {
  if (a3.groupOrder !== b.groupOrder) {
    return a3.groupOrder - b.groupOrder;
  } else if (a3.renderOrder !== b.renderOrder) {
    return a3.renderOrder - b.renderOrder;
  } else if (a3.program !== b.program) {
    return a3.program.id - b.program.id;
  } else if (a3.material.id !== b.material.id) {
    return a3.material.id - b.material.id;
  } else if (a3.z !== b.z) {
    return a3.z - b.z;
  } else {
    return a3.id - b.id;
  }
}
function reversePainterSortStable(a3, b) {
  if (a3.groupOrder !== b.groupOrder) {
    return a3.groupOrder - b.groupOrder;
  } else if (a3.renderOrder !== b.renderOrder) {
    return a3.renderOrder - b.renderOrder;
  } else if (a3.z !== b.z) {
    return b.z - a3.z;
  } else {
    return a3.id - b.id;
  }
}
function WebGLRenderList(properties) {
  const renderItems = [];
  let renderItemsIndex = 0;
  const opaque = [];
  const transmissive = [];
  const transparent = [];
  const defaultProgram = { id: -1 };
  function init() {
    renderItemsIndex = 0;
    opaque.length = 0;
    transmissive.length = 0;
    transparent.length = 0;
  }
  function getNextRenderItem(object, geometry, material, groupOrder, z2, group) {
    let renderItem = renderItems[renderItemsIndex];
    const materialProperties = properties.get(material);
    if (renderItem === void 0) {
      renderItem = {
        id: object.id,
        object,
        geometry,
        material,
        program: materialProperties.program || defaultProgram,
        groupOrder,
        renderOrder: object.renderOrder,
        z: z2,
        group
      };
      renderItems[renderItemsIndex] = renderItem;
    } else {
      renderItem.id = object.id;
      renderItem.object = object;
      renderItem.geometry = geometry;
      renderItem.material = material;
      renderItem.program = materialProperties.program || defaultProgram;
      renderItem.groupOrder = groupOrder;
      renderItem.renderOrder = object.renderOrder;
      renderItem.z = z2;
      renderItem.group = group;
    }
    renderItemsIndex++;
    return renderItem;
  }
  function push(object, geometry, material, groupOrder, z2, group) {
    const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z2, group);
    if (material.transmission > 0) {
      transmissive.push(renderItem);
    } else if (material.transparent === true) {
      transparent.push(renderItem);
    } else {
      opaque.push(renderItem);
    }
  }
  function unshift(object, geometry, material, groupOrder, z2, group) {
    const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z2, group);
    if (material.transmission > 0) {
      transmissive.unshift(renderItem);
    } else if (material.transparent === true) {
      transparent.unshift(renderItem);
    } else {
      opaque.unshift(renderItem);
    }
  }
  function sort(customOpaqueSort, customTransparentSort) {
    if (opaque.length > 1) opaque.sort(customOpaqueSort || painterSortStable);
    if (transmissive.length > 1) transmissive.sort(customTransparentSort || reversePainterSortStable);
    if (transparent.length > 1) transparent.sort(customTransparentSort || reversePainterSortStable);
  }
  function finish() {
    for (let i2 = renderItemsIndex, il = renderItems.length; i2 < il; i2++) {
      const renderItem = renderItems[i2];
      if (renderItem.id === null) break;
      renderItem.id = null;
      renderItem.object = null;
      renderItem.geometry = null;
      renderItem.material = null;
      renderItem.program = null;
      renderItem.group = null;
    }
  }
  return {
    opaque,
    transmissive,
    transparent,
    init,
    push,
    unshift,
    finish,
    sort
  };
}
function WebGLRenderLists(properties) {
  let lists = /* @__PURE__ */ new WeakMap();
  function get(scene, renderCallDepth) {
    let list;
    if (lists.has(scene) === false) {
      list = new WebGLRenderList(properties);
      lists.set(scene, [list]);
    } else {
      if (renderCallDepth >= lists.get(scene).length) {
        list = new WebGLRenderList(properties);
        lists.get(scene).push(list);
      } else {
        list = lists.get(scene)[renderCallDepth];
      }
    }
    return list;
  }
  function dispose() {
    lists = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose
  };
}
function UniformsCache() {
  const lights = {};
  return {
    get: function(light) {
      if (lights[light.id] !== void 0) {
        return lights[light.id];
      }
      let uniforms;
      switch (light.type) {
        case "DirectionalLight":
          uniforms = {
            direction: new Vector32(),
            color: new Color2()
          };
          break;
        case "SpotLight":
          uniforms = {
            position: new Vector32(),
            direction: new Vector32(),
            color: new Color2(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          uniforms = {
            position: new Vector32(),
            color: new Color2(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          uniforms = {
            direction: new Vector32(),
            skyColor: new Color2(),
            groundColor: new Color2()
          };
          break;
        case "RectAreaLight":
          uniforms = {
            color: new Color2(),
            position: new Vector32(),
            halfWidth: new Vector32(),
            halfHeight: new Vector32()
          };
          break;
      }
      lights[light.id] = uniforms;
      return uniforms;
    }
  };
}
function ShadowUniformsCache() {
  const lights = {};
  return {
    get: function(light) {
      if (lights[light.id] !== void 0) {
        return lights[light.id];
      }
      let uniforms;
      switch (light.type) {
        case "DirectionalLight":
          uniforms = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector22()
          };
          break;
        case "SpotLight":
          uniforms = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector22()
          };
          break;
        case "PointLight":
          uniforms = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector22(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      lights[light.id] = uniforms;
      return uniforms;
    }
  };
}
let nextVersion = 0;
function shadowCastingLightsFirst(lightA, lightB) {
  return (lightB.castShadow ? 1 : 0) - (lightA.castShadow ? 1 : 0);
}
function WebGLLights(extensions, capabilities) {
  const cache = new UniformsCache();
  const shadowCache = ShadowUniformsCache();
  const state = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotShadow: [],
    spotShadowMap: [],
    spotShadowMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: []
  };
  for (let i2 = 0; i2 < 9; i2++) state.probe.push(new Vector32());
  const vector3 = new Vector32();
  const matrix4 = new Matrix42();
  const matrix42 = new Matrix42();
  function setup(lights, physicallyCorrectLights) {
    let r2 = 0, g3 = 0, b = 0;
    for (let i2 = 0; i2 < 9; i2++) state.probe[i2].set(0, 0, 0);
    let directionalLength = 0;
    let pointLength = 0;
    let spotLength = 0;
    let rectAreaLength = 0;
    let hemiLength = 0;
    let numDirectionalShadows = 0;
    let numPointShadows = 0;
    let numSpotShadows = 0;
    lights.sort(shadowCastingLightsFirst);
    const scaleFactor = physicallyCorrectLights !== true ? Math.PI : 1;
    for (let i2 = 0, l2 = lights.length; i2 < l2; i2++) {
      const light = lights[i2];
      const color2 = light.color;
      const intensity = light.intensity;
      const distance2 = light.distance;
      const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
      if (light.isAmbientLight) {
        r2 += color2.r * intensity * scaleFactor;
        g3 += color2.g * intensity * scaleFactor;
        b += color2.b * intensity * scaleFactor;
      } else if (light.isLightProbe) {
        for (let j = 0; j < 9; j++) {
          state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
        }
      } else if (light.isDirectionalLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
        if (light.castShadow) {
          const shadow = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          state.directionalShadow[directionalLength] = shadowUniforms;
          state.directionalShadowMap[directionalLength] = shadowMap;
          state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
          numDirectionalShadows++;
        }
        state.directional[directionalLength] = uniforms;
        directionalLength++;
      } else if (light.isSpotLight) {
        const uniforms = cache.get(light);
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.color.copy(color2).multiplyScalar(intensity * scaleFactor);
        uniforms.distance = distance2;
        uniforms.coneCos = Math.cos(light.angle);
        uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
        uniforms.decay = light.decay;
        if (light.castShadow) {
          const shadow = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          state.spotShadow[spotLength] = shadowUniforms;
          state.spotShadowMap[spotLength] = shadowMap;
          state.spotShadowMatrix[spotLength] = light.shadow.matrix;
          numSpotShadows++;
        }
        state.spot[spotLength] = uniforms;
        spotLength++;
      } else if (light.isRectAreaLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(color2).multiplyScalar(intensity);
        uniforms.halfWidth.set(light.width * 0.5, 0, 0);
        uniforms.halfHeight.set(0, light.height * 0.5, 0);
        state.rectArea[rectAreaLength] = uniforms;
        rectAreaLength++;
      } else if (light.isPointLight) {
        const uniforms = cache.get(light);
        uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
        uniforms.distance = light.distance;
        uniforms.decay = light.decay;
        if (light.castShadow) {
          const shadow = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          shadowUniforms.shadowCameraNear = shadow.camera.near;
          shadowUniforms.shadowCameraFar = shadow.camera.far;
          state.pointShadow[pointLength] = shadowUniforms;
          state.pointShadowMap[pointLength] = shadowMap;
          state.pointShadowMatrix[pointLength] = light.shadow.matrix;
          numPointShadows++;
        }
        state.point[pointLength] = uniforms;
        pointLength++;
      } else if (light.isHemisphereLight) {
        const uniforms = cache.get(light);
        uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
        uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
        state.hemi[hemiLength] = uniforms;
        hemiLength++;
      }
    }
    if (rectAreaLength > 0) {
      if (capabilities.isWebGL2) {
        state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
        state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
      } else {
        if (extensions.has("OES_texture_float_linear") === true) {
          state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
          state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
        } else if (extensions.has("OES_texture_half_float_linear") === true) {
          state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
          state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;
        } else {
          console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.");
        }
      }
    }
    state.ambient[0] = r2;
    state.ambient[1] = g3;
    state.ambient[2] = b;
    const hash = state.hash;
    if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows) {
      state.directional.length = directionalLength;
      state.spot.length = spotLength;
      state.rectArea.length = rectAreaLength;
      state.point.length = pointLength;
      state.hemi.length = hemiLength;
      state.directionalShadow.length = numDirectionalShadows;
      state.directionalShadowMap.length = numDirectionalShadows;
      state.pointShadow.length = numPointShadows;
      state.pointShadowMap.length = numPointShadows;
      state.spotShadow.length = numSpotShadows;
      state.spotShadowMap.length = numSpotShadows;
      state.directionalShadowMatrix.length = numDirectionalShadows;
      state.pointShadowMatrix.length = numPointShadows;
      state.spotShadowMatrix.length = numSpotShadows;
      hash.directionalLength = directionalLength;
      hash.pointLength = pointLength;
      hash.spotLength = spotLength;
      hash.rectAreaLength = rectAreaLength;
      hash.hemiLength = hemiLength;
      hash.numDirectionalShadows = numDirectionalShadows;
      hash.numPointShadows = numPointShadows;
      hash.numSpotShadows = numSpotShadows;
      state.version = nextVersion++;
    }
  }
  function setupView(lights, camera) {
    let directionalLength = 0;
    let pointLength = 0;
    let spotLength = 0;
    let rectAreaLength = 0;
    let hemiLength = 0;
    const viewMatrix = camera.matrixWorldInverse;
    for (let i2 = 0, l2 = lights.length; i2 < l2; i2++) {
      const light = lights[i2];
      if (light.isDirectionalLight) {
        const uniforms = state.directional[directionalLength];
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        vector3.setFromMatrixPosition(light.target.matrixWorld);
        uniforms.direction.sub(vector3);
        uniforms.direction.transformDirection(viewMatrix);
        directionalLength++;
      } else if (light.isSpotLight) {
        const uniforms = state.spot[spotLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        vector3.setFromMatrixPosition(light.target.matrixWorld);
        uniforms.direction.sub(vector3);
        uniforms.direction.transformDirection(viewMatrix);
        spotLength++;
      } else if (light.isRectAreaLight) {
        const uniforms = state.rectArea[rectAreaLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        matrix42.identity();
        matrix4.copy(light.matrixWorld);
        matrix4.premultiply(viewMatrix);
        matrix42.extractRotation(matrix4);
        uniforms.halfWidth.set(light.width * 0.5, 0, 0);
        uniforms.halfHeight.set(0, light.height * 0.5, 0);
        uniforms.halfWidth.applyMatrix4(matrix42);
        uniforms.halfHeight.applyMatrix4(matrix42);
        rectAreaLength++;
      } else if (light.isPointLight) {
        const uniforms = state.point[pointLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        pointLength++;
      } else if (light.isHemisphereLight) {
        const uniforms = state.hemi[hemiLength];
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        uniforms.direction.transformDirection(viewMatrix);
        uniforms.direction.normalize();
        hemiLength++;
      }
    }
  }
  return {
    setup,
    setupView,
    state
  };
}
function WebGLRenderState(extensions, capabilities) {
  const lights = new WebGLLights(extensions, capabilities);
  const lightsArray = [];
  const shadowsArray = [];
  function init() {
    lightsArray.length = 0;
    shadowsArray.length = 0;
  }
  function pushLight(light) {
    lightsArray.push(light);
  }
  function pushShadow(shadowLight) {
    shadowsArray.push(shadowLight);
  }
  function setupLights(physicallyCorrectLights) {
    lights.setup(lightsArray, physicallyCorrectLights);
  }
  function setupLightsView(camera) {
    lights.setupView(lightsArray, camera);
  }
  const state = {
    lightsArray,
    shadowsArray,
    lights
  };
  return {
    init,
    state,
    setupLights,
    setupLightsView,
    pushLight,
    pushShadow
  };
}
function WebGLRenderStates(extensions, capabilities) {
  let renderStates = /* @__PURE__ */ new WeakMap();
  function get(scene, renderCallDepth = 0) {
    let renderState;
    if (renderStates.has(scene) === false) {
      renderState = new WebGLRenderState(extensions, capabilities);
      renderStates.set(scene, [renderState]);
    } else {
      if (renderCallDepth >= renderStates.get(scene).length) {
        renderState = new WebGLRenderState(extensions, capabilities);
        renderStates.get(scene).push(renderState);
      } else {
        renderState = renderStates.get(scene)[renderCallDepth];
      }
    }
    return renderState;
  }
  function dispose() {
    renderStates = /* @__PURE__ */ new WeakMap();
  }
  return {
    get,
    dispose
  };
}
class MeshDepthMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.type = "MeshDepthMaterial";
    this.depthPacking = BasicDepthPacking;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.depthPacking = source.depthPacking;
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    return this;
  }
}
MeshDepthMaterial2.prototype.isMeshDepthMaterial = true;
class MeshDistanceMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.type = "MeshDistanceMaterial";
    this.referencePosition = new Vector32();
    this.nearDistance = 1;
    this.farDistance = 1e3;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.fog = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.referencePosition.copy(source.referencePosition);
    this.nearDistance = source.nearDistance;
    this.farDistance = source.farDistance;
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    return this;
  }
}
MeshDistanceMaterial2.prototype.isMeshDistanceMaterial = true;
var vsm_frag = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\nuniform float samples;\n#include <packing>\nvoid main() {\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
var vsm_vert = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
function WebGLShadowMap(_renderer, _objects, _capabilities) {
  let _frustum2 = new Frustum2();
  const _shadowMapSize = new Vector22(), _viewportSize = new Vector22(), _viewport2 = new Vector42(), _depthMaterial = new MeshDepthMaterial2({ depthPacking: RGBADepthPacking }), _distanceMaterial = new MeshDistanceMaterial2(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
  const shadowSide = { 0: BackSide, 1: FrontSide, 2: DoubleSide };
  const shadowMaterialVertical = new ShaderMaterial2({
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new Vector22() },
      radius: { value: 4 },
      samples: { value: 8 }
    },
    vertexShader: vsm_vert,
    fragmentShader: vsm_frag
  });
  const shadowMaterialHorizontal = shadowMaterialVertical.clone();
  shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
  const fullScreenTri = new BufferGeometry2();
  fullScreenTri.setAttribute(
    "position",
    new BufferAttribute2(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const fullScreenMesh = new Mesh2(fullScreenTri, shadowMaterialVertical);
  const scope = this;
  this.enabled = false;
  this.autoUpdate = true;
  this.needsUpdate = false;
  this.type = PCFShadowMap;
  this.render = function(lights, scene, camera) {
    if (scope.enabled === false) return;
    if (scope.autoUpdate === false && scope.needsUpdate === false) return;
    if (lights.length === 0) return;
    const currentRenderTarget = _renderer.getRenderTarget();
    const activeCubeFace = _renderer.getActiveCubeFace();
    const activeMipmapLevel = _renderer.getActiveMipmapLevel();
    const _state = _renderer.state;
    _state.setBlending(NoBlending);
    _state.buffers.color.setClear(1, 1, 1, 1);
    _state.buffers.depth.setTest(true);
    _state.setScissorTest(false);
    for (let i2 = 0, il = lights.length; i2 < il; i2++) {
      const light = lights[i2];
      const shadow = light.shadow;
      if (shadow === void 0) {
        console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
        continue;
      }
      if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
      _shadowMapSize.copy(shadow.mapSize);
      const shadowFrameExtents = shadow.getFrameExtents();
      _shadowMapSize.multiply(shadowFrameExtents);
      _viewportSize.copy(shadow.mapSize);
      if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
        if (_shadowMapSize.x > _maxTextureSize) {
          _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
          _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
          shadow.mapSize.x = _viewportSize.x;
        }
        if (_shadowMapSize.y > _maxTextureSize) {
          _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
          _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
          shadow.mapSize.y = _viewportSize.y;
        }
      }
      if (shadow.map === null && !shadow.isPointLightShadow && this.type === VSMShadowMap) {
        const pars = { minFilter: LinearFilter, magFilter: LinearFilter, format: RGBAFormat };
        shadow.map = new WebGLRenderTarget2(_shadowMapSize.x, _shadowMapSize.y, pars);
        shadow.map.texture.name = light.name + ".shadowMap";
        shadow.mapPass = new WebGLRenderTarget2(_shadowMapSize.x, _shadowMapSize.y, pars);
        shadow.camera.updateProjectionMatrix();
      }
      if (shadow.map === null) {
        const pars = { minFilter: NearestFilter, magFilter: NearestFilter, format: RGBAFormat };
        shadow.map = new WebGLRenderTarget2(_shadowMapSize.x, _shadowMapSize.y, pars);
        shadow.map.texture.name = light.name + ".shadowMap";
        shadow.camera.updateProjectionMatrix();
      }
      _renderer.setRenderTarget(shadow.map);
      _renderer.clear();
      const viewportCount = shadow.getViewportCount();
      for (let vp = 0; vp < viewportCount; vp++) {
        const viewport = shadow.getViewport(vp);
        _viewport2.set(
          _viewportSize.x * viewport.x,
          _viewportSize.y * viewport.y,
          _viewportSize.x * viewport.z,
          _viewportSize.y * viewport.w
        );
        _state.viewport(_viewport2);
        shadow.updateMatrices(light, vp);
        _frustum2 = shadow.getFrustum();
        renderObject(scene, camera, shadow.camera, light, this.type);
      }
      if (!shadow.isPointLightShadow && this.type === VSMShadowMap) {
        VSMPass(shadow, camera);
      }
      shadow.needsUpdate = false;
    }
    scope.needsUpdate = false;
    _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
  };
  function VSMPass(shadow, camera) {
    const geometry = _objects.update(fullScreenMesh);
    shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
    shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
    shadowMaterialVertical.uniforms.radius.value = shadow.radius;
    shadowMaterialVertical.uniforms.samples.value = shadow.blurSamples;
    _renderer.setRenderTarget(shadow.mapPass);
    _renderer.clear();
    _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
    shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
    shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
    shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
    shadowMaterialHorizontal.uniforms.samples.value = shadow.blurSamples;
    _renderer.setRenderTarget(shadow.map);
    _renderer.clear();
    _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
  }
  function getDepthMaterial(object, geometry, material, light, shadowCameraNear, shadowCameraFar, type) {
    let result = null;
    const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
    if (customMaterial !== void 0) {
      result = customMaterial;
    } else {
      result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
    }
    if (_renderer.localClippingEnabled && material.clipShadows === true && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0) {
      const keyA = result.uuid, keyB = material.uuid;
      let materialsForVariant = _materialCache[keyA];
      if (materialsForVariant === void 0) {
        materialsForVariant = {};
        _materialCache[keyA] = materialsForVariant;
      }
      let cachedMaterial = materialsForVariant[keyB];
      if (cachedMaterial === void 0) {
        cachedMaterial = result.clone();
        materialsForVariant[keyB] = cachedMaterial;
      }
      result = cachedMaterial;
    }
    result.visible = material.visible;
    result.wireframe = material.wireframe;
    if (type === VSMShadowMap) {
      result.side = material.shadowSide !== null ? material.shadowSide : material.side;
    } else {
      result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
    }
    result.alphaMap = material.alphaMap;
    result.alphaTest = material.alphaTest;
    result.clipShadows = material.clipShadows;
    result.clippingPlanes = material.clippingPlanes;
    result.clipIntersection = material.clipIntersection;
    result.displacementMap = material.displacementMap;
    result.displacementScale = material.displacementScale;
    result.displacementBias = material.displacementBias;
    result.wireframeLinewidth = material.wireframeLinewidth;
    result.linewidth = material.linewidth;
    if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
      result.referencePosition.setFromMatrixPosition(light.matrixWorld);
      result.nearDistance = shadowCameraNear;
      result.farDistance = shadowCameraFar;
    }
    return result;
  }
  function renderObject(object, camera, shadowCamera, light, type) {
    if (object.visible === false) return;
    const visible = object.layers.test(camera.layers);
    if (visible && (object.isMesh || object.isLine || object.isPoints)) {
      if ((object.castShadow || object.receiveShadow && type === VSMShadowMap) && (!object.frustumCulled || _frustum2.intersectsObject(object))) {
        object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
        const geometry = _objects.update(object);
        const material = object.material;
        if (Array.isArray(material)) {
          const groups = geometry.groups;
          for (let k = 0, kl = groups.length; k < kl; k++) {
            const group = groups[k];
            const groupMaterial = material[group.materialIndex];
            if (groupMaterial && groupMaterial.visible) {
              const depthMaterial = getDepthMaterial(object, geometry, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
              _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
            }
          }
        } else if (material.visible) {
          const depthMaterial = getDepthMaterial(object, geometry, material, light, shadowCamera.near, shadowCamera.far, type);
          _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
        }
      }
    }
    const children = object.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      renderObject(children[i2], camera, shadowCamera, light, type);
    }
  }
}
function WebGLState(gl, extensions, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  function ColorBuffer() {
    let locked = false;
    const color2 = new Vector42();
    let currentColorMask = null;
    const currentColorClear = new Vector42(0, 0, 0, 0);
    return {
      setMask: function(colorMask) {
        if (currentColorMask !== colorMask && !locked) {
          gl.colorMask(colorMask, colorMask, colorMask, colorMask);
          currentColorMask = colorMask;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(r2, g3, b, a3, premultipliedAlpha) {
        if (premultipliedAlpha === true) {
          r2 *= a3;
          g3 *= a3;
          b *= a3;
        }
        color2.set(r2, g3, b, a3);
        if (currentColorClear.equals(color2) === false) {
          gl.clearColor(r2, g3, b, a3);
          currentColorClear.copy(color2);
        }
      },
      reset: function() {
        locked = false;
        currentColorMask = null;
        currentColorClear.set(-1, 0, 0, 0);
      }
    };
  }
  function DepthBuffer() {
    let locked = false;
    let currentDepthMask = null;
    let currentDepthFunc = null;
    let currentDepthClear = null;
    return {
      setTest: function(depthTest) {
        if (depthTest) {
          enable(2929);
        } else {
          disable(2929);
        }
      },
      setMask: function(depthMask) {
        if (currentDepthMask !== depthMask && !locked) {
          gl.depthMask(depthMask);
          currentDepthMask = depthMask;
        }
      },
      setFunc: function(depthFunc) {
        if (currentDepthFunc !== depthFunc) {
          if (depthFunc) {
            switch (depthFunc) {
              case NeverDepth:
                gl.depthFunc(512);
                break;
              case AlwaysDepth:
                gl.depthFunc(519);
                break;
              case LessDepth:
                gl.depthFunc(513);
                break;
              case LessEqualDepth:
                gl.depthFunc(515);
                break;
              case EqualDepth:
                gl.depthFunc(514);
                break;
              case GreaterEqualDepth:
                gl.depthFunc(518);
                break;
              case GreaterDepth:
                gl.depthFunc(516);
                break;
              case NotEqualDepth:
                gl.depthFunc(517);
                break;
              default:
                gl.depthFunc(515);
            }
          } else {
            gl.depthFunc(515);
          }
          currentDepthFunc = depthFunc;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(depth) {
        if (currentDepthClear !== depth) {
          gl.clearDepth(depth);
          currentDepthClear = depth;
        }
      },
      reset: function() {
        locked = false;
        currentDepthMask = null;
        currentDepthFunc = null;
        currentDepthClear = null;
      }
    };
  }
  function StencilBuffer() {
    let locked = false;
    let currentStencilMask = null;
    let currentStencilFunc = null;
    let currentStencilRef = null;
    let currentStencilFuncMask = null;
    let currentStencilFail = null;
    let currentStencilZFail = null;
    let currentStencilZPass = null;
    let currentStencilClear = null;
    return {
      setTest: function(stencilTest) {
        if (!locked) {
          if (stencilTest) {
            enable(2960);
          } else {
            disable(2960);
          }
        }
      },
      setMask: function(stencilMask) {
        if (currentStencilMask !== stencilMask && !locked) {
          gl.stencilMask(stencilMask);
          currentStencilMask = stencilMask;
        }
      },
      setFunc: function(stencilFunc, stencilRef, stencilMask) {
        if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
          gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
          currentStencilFunc = stencilFunc;
          currentStencilRef = stencilRef;
          currentStencilFuncMask = stencilMask;
        }
      },
      setOp: function(stencilFail, stencilZFail, stencilZPass) {
        if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
          gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
          currentStencilFail = stencilFail;
          currentStencilZFail = stencilZFail;
          currentStencilZPass = stencilZPass;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(stencil) {
        if (currentStencilClear !== stencil) {
          gl.clearStencil(stencil);
          currentStencilClear = stencil;
        }
      },
      reset: function() {
        locked = false;
        currentStencilMask = null;
        currentStencilFunc = null;
        currentStencilRef = null;
        currentStencilFuncMask = null;
        currentStencilFail = null;
        currentStencilZFail = null;
        currentStencilZPass = null;
        currentStencilClear = null;
      }
    };
  }
  const colorBuffer = new ColorBuffer();
  const depthBuffer = new DepthBuffer();
  const stencilBuffer = new StencilBuffer();
  let enabledCapabilities = {};
  let xrFramebuffer = null;
  let currentBoundFramebuffers = {};
  let currentProgram = null;
  let currentBlendingEnabled = false;
  let currentBlending = null;
  let currentBlendEquation = null;
  let currentBlendSrc = null;
  let currentBlendDst = null;
  let currentBlendEquationAlpha = null;
  let currentBlendSrcAlpha = null;
  let currentBlendDstAlpha = null;
  let currentPremultipledAlpha = false;
  let currentFlipSided = null;
  let currentCullFace = null;
  let currentLineWidth = null;
  let currentPolygonOffsetFactor = null;
  let currentPolygonOffsetUnits = null;
  const maxTextures = gl.getParameter(35661);
  let lineWidthAvailable = false;
  let version = 0;
  const glVersion = gl.getParameter(7938);
  if (glVersion.indexOf("WebGL") !== -1) {
    version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version >= 1;
  } else if (glVersion.indexOf("OpenGL ES") !== -1) {
    version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version >= 2;
  }
  let currentTextureSlot = null;
  let currentBoundTextures = {};
  const scissorParam = gl.getParameter(3088);
  const viewportParam = gl.getParameter(2978);
  const currentScissor = new Vector42().fromArray(scissorParam);
  const currentViewport = new Vector42().fromArray(viewportParam);
  function createTexture(type, target, count) {
    const data = new Uint8Array(4);
    const texture = gl.createTexture();
    gl.bindTexture(type, texture);
    gl.texParameteri(type, 10241, 9728);
    gl.texParameteri(type, 10240, 9728);
    for (let i2 = 0; i2 < count; i2++) {
      gl.texImage2D(target + i2, 0, 6408, 1, 1, 0, 6408, 5121, data);
    }
    return texture;
  }
  const emptyTextures = {};
  emptyTextures[3553] = createTexture(3553, 3553, 1);
  emptyTextures[34067] = createTexture(34067, 34069, 6);
  colorBuffer.setClear(0, 0, 0, 1);
  depthBuffer.setClear(1);
  stencilBuffer.setClear(0);
  enable(2929);
  depthBuffer.setFunc(LessEqualDepth);
  setFlipSided(false);
  setCullFace(CullFaceBack);
  enable(2884);
  setBlending(NoBlending);
  function enable(id) {
    if (enabledCapabilities[id] !== true) {
      gl.enable(id);
      enabledCapabilities[id] = true;
    }
  }
  function disable(id) {
    if (enabledCapabilities[id] !== false) {
      gl.disable(id);
      enabledCapabilities[id] = false;
    }
  }
  function bindXRFramebuffer(framebuffer) {
    if (framebuffer !== xrFramebuffer) {
      gl.bindFramebuffer(36160, framebuffer);
      xrFramebuffer = framebuffer;
    }
  }
  function bindFramebuffer(target, framebuffer) {
    if (framebuffer === null && xrFramebuffer !== null) framebuffer = xrFramebuffer;
    if (currentBoundFramebuffers[target] !== framebuffer) {
      gl.bindFramebuffer(target, framebuffer);
      currentBoundFramebuffers[target] = framebuffer;
      if (isWebGL2) {
        if (target === 36009) {
          currentBoundFramebuffers[36160] = framebuffer;
        }
        if (target === 36160) {
          currentBoundFramebuffers[36009] = framebuffer;
        }
      }
      return true;
    }
    return false;
  }
  function useProgram(program) {
    if (currentProgram !== program) {
      gl.useProgram(program);
      currentProgram = program;
      return true;
    }
    return false;
  }
  const equationToGL = {
    [AddEquation]: 32774,
    [SubtractEquation]: 32778,
    [ReverseSubtractEquation]: 32779
  };
  if (isWebGL2) {
    equationToGL[MinEquation] = 32775;
    equationToGL[MaxEquation] = 32776;
  } else {
    const extension = extensions.get("EXT_blend_minmax");
    if (extension !== null) {
      equationToGL[MinEquation] = extension.MIN_EXT;
      equationToGL[MaxEquation] = extension.MAX_EXT;
    }
  }
  const factorToGL = {
    [ZeroFactor]: 0,
    [OneFactor]: 1,
    [SrcColorFactor]: 768,
    [SrcAlphaFactor]: 770,
    [SrcAlphaSaturateFactor]: 776,
    [DstColorFactor]: 774,
    [DstAlphaFactor]: 772,
    [OneMinusSrcColorFactor]: 769,
    [OneMinusSrcAlphaFactor]: 771,
    [OneMinusDstColorFactor]: 775,
    [OneMinusDstAlphaFactor]: 773
  };
  function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
    if (blending === NoBlending) {
      if (currentBlendingEnabled === true) {
        disable(3042);
        currentBlendingEnabled = false;
      }
      return;
    }
    if (currentBlendingEnabled === false) {
      enable(3042);
      currentBlendingEnabled = true;
    }
    if (blending !== CustomBlending) {
      if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
        if (currentBlendEquation !== AddEquation || currentBlendEquationAlpha !== AddEquation) {
          gl.blendEquation(32774);
          currentBlendEquation = AddEquation;
          currentBlendEquationAlpha = AddEquation;
        }
        if (premultipliedAlpha) {
          switch (blending) {
            case NormalBlending:
              gl.blendFuncSeparate(1, 771, 1, 771);
              break;
            case AdditiveBlending:
              gl.blendFunc(1, 1);
              break;
            case SubtractiveBlending:
              gl.blendFuncSeparate(0, 0, 769, 771);
              break;
            case MultiplyBlending:
              gl.blendFuncSeparate(0, 768, 0, 770);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", blending);
              break;
          }
        } else {
          switch (blending) {
            case NormalBlending:
              gl.blendFuncSeparate(770, 771, 1, 771);
              break;
            case AdditiveBlending:
              gl.blendFunc(770, 1);
              break;
            case SubtractiveBlending:
              gl.blendFunc(0, 769);
              break;
            case MultiplyBlending:
              gl.blendFunc(0, 768);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", blending);
              break;
          }
        }
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlending = blending;
        currentPremultipledAlpha = premultipliedAlpha;
      }
      return;
    }
    blendEquationAlpha = blendEquationAlpha || blendEquation;
    blendSrcAlpha = blendSrcAlpha || blendSrc;
    blendDstAlpha = blendDstAlpha || blendDst;
    if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
      gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
      currentBlendEquation = blendEquation;
      currentBlendEquationAlpha = blendEquationAlpha;
    }
    if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
      gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
      currentBlendSrc = blendSrc;
      currentBlendDst = blendDst;
      currentBlendSrcAlpha = blendSrcAlpha;
      currentBlendDstAlpha = blendDstAlpha;
    }
    currentBlending = blending;
    currentPremultipledAlpha = null;
  }
  function setMaterial(material, frontFaceCW) {
    material.side === DoubleSide ? disable(2884) : enable(2884);
    let flipSided = material.side === BackSide;
    if (frontFaceCW) flipSided = !flipSided;
    setFlipSided(flipSided);
    material.blending === NormalBlending && material.transparent === false ? setBlending(NoBlending) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
    depthBuffer.setFunc(material.depthFunc);
    depthBuffer.setTest(material.depthTest);
    depthBuffer.setMask(material.depthWrite);
    colorBuffer.setMask(material.colorWrite);
    const stencilWrite = material.stencilWrite;
    stencilBuffer.setTest(stencilWrite);
    if (stencilWrite) {
      stencilBuffer.setMask(material.stencilWriteMask);
      stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
      stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
    }
    setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
    material.alphaToCoverage === true ? enable(32926) : disable(32926);
  }
  function setFlipSided(flipSided) {
    if (currentFlipSided !== flipSided) {
      if (flipSided) {
        gl.frontFace(2304);
      } else {
        gl.frontFace(2305);
      }
      currentFlipSided = flipSided;
    }
  }
  function setCullFace(cullFace) {
    if (cullFace !== CullFaceNone) {
      enable(2884);
      if (cullFace !== currentCullFace) {
        if (cullFace === CullFaceBack) {
          gl.cullFace(1029);
        } else if (cullFace === CullFaceFront) {
          gl.cullFace(1028);
        } else {
          gl.cullFace(1032);
        }
      }
    } else {
      disable(2884);
    }
    currentCullFace = cullFace;
  }
  function setLineWidth(width) {
    if (width !== currentLineWidth) {
      if (lineWidthAvailable) gl.lineWidth(width);
      currentLineWidth = width;
    }
  }
  function setPolygonOffset(polygonOffset, factor, units) {
    if (polygonOffset) {
      enable(32823);
      if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
        gl.polygonOffset(factor, units);
        currentPolygonOffsetFactor = factor;
        currentPolygonOffsetUnits = units;
      }
    } else {
      disable(32823);
    }
  }
  function setScissorTest(scissorTest) {
    if (scissorTest) {
      enable(3089);
    } else {
      disable(3089);
    }
  }
  function activeTexture(webglSlot) {
    if (webglSlot === void 0) webglSlot = 33984 + maxTextures - 1;
    if (currentTextureSlot !== webglSlot) {
      gl.activeTexture(webglSlot);
      currentTextureSlot = webglSlot;
    }
  }
  function bindTexture(webglType, webglTexture) {
    if (currentTextureSlot === null) {
      activeTexture();
    }
    let boundTexture = currentBoundTextures[currentTextureSlot];
    if (boundTexture === void 0) {
      boundTexture = { type: void 0, texture: void 0 };
      currentBoundTextures[currentTextureSlot] = boundTexture;
    }
    if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
      gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
      boundTexture.type = webglType;
      boundTexture.texture = webglTexture;
    }
  }
  function unbindTexture() {
    const boundTexture = currentBoundTextures[currentTextureSlot];
    if (boundTexture !== void 0 && boundTexture.type !== void 0) {
      gl.bindTexture(boundTexture.type, null);
      boundTexture.type = void 0;
      boundTexture.texture = void 0;
    }
  }
  function compressedTexImage2D() {
    try {
      gl.compressedTexImage2D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texImage2D() {
    try {
      gl.texImage2D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function texImage3D() {
    try {
      gl.texImage3D.apply(gl, arguments);
    } catch (error) {
      console.error("THREE.WebGLState:", error);
    }
  }
  function scissor(scissor2) {
    if (currentScissor.equals(scissor2) === false) {
      gl.scissor(scissor2.x, scissor2.y, scissor2.z, scissor2.w);
      currentScissor.copy(scissor2);
    }
  }
  function viewport(viewport2) {
    if (currentViewport.equals(viewport2) === false) {
      gl.viewport(viewport2.x, viewport2.y, viewport2.z, viewport2.w);
      currentViewport.copy(viewport2);
    }
  }
  function reset() {
    gl.disable(3042);
    gl.disable(2884);
    gl.disable(2929);
    gl.disable(32823);
    gl.disable(3089);
    gl.disable(2960);
    gl.disable(32926);
    gl.blendEquation(32774);
    gl.blendFunc(1, 0);
    gl.blendFuncSeparate(1, 0, 1, 0);
    gl.colorMask(true, true, true, true);
    gl.clearColor(0, 0, 0, 0);
    gl.depthMask(true);
    gl.depthFunc(513);
    gl.clearDepth(1);
    gl.stencilMask(4294967295);
    gl.stencilFunc(519, 0, 4294967295);
    gl.stencilOp(7680, 7680, 7680);
    gl.clearStencil(0);
    gl.cullFace(1029);
    gl.frontFace(2305);
    gl.polygonOffset(0, 0);
    gl.activeTexture(33984);
    gl.bindFramebuffer(36160, null);
    if (isWebGL2 === true) {
      gl.bindFramebuffer(36009, null);
      gl.bindFramebuffer(36008, null);
    }
    gl.useProgram(null);
    gl.lineWidth(1);
    gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
    gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
    enabledCapabilities = {};
    currentTextureSlot = null;
    currentBoundTextures = {};
    xrFramebuffer = null;
    currentBoundFramebuffers = {};
    currentProgram = null;
    currentBlendingEnabled = false;
    currentBlending = null;
    currentBlendEquation = null;
    currentBlendSrc = null;
    currentBlendDst = null;
    currentBlendEquationAlpha = null;
    currentBlendSrcAlpha = null;
    currentBlendDstAlpha = null;
    currentPremultipledAlpha = false;
    currentFlipSided = null;
    currentCullFace = null;
    currentLineWidth = null;
    currentPolygonOffsetFactor = null;
    currentPolygonOffsetUnits = null;
    currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
    currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
    colorBuffer.reset();
    depthBuffer.reset();
    stencilBuffer.reset();
  }
  return {
    buffers: {
      color: colorBuffer,
      depth: depthBuffer,
      stencil: stencilBuffer
    },
    enable,
    disable,
    bindFramebuffer,
    bindXRFramebuffer,
    useProgram,
    setBlending,
    setMaterial,
    setFlipSided,
    setCullFace,
    setLineWidth,
    setPolygonOffset,
    setScissorTest,
    activeTexture,
    bindTexture,
    unbindTexture,
    compressedTexImage2D,
    texImage2D,
    texImage3D,
    scissor,
    viewport,
    reset
  };
}
function WebGLTextures(_gl, extensions, state, properties, capabilities, utils2, info) {
  const isWebGL2 = capabilities.isWebGL2;
  const maxTextures = capabilities.maxTextures;
  const maxCubemapSize = capabilities.maxCubemapSize;
  const maxTextureSize = capabilities.maxTextureSize;
  const maxSamples = capabilities.maxSamples;
  const _videoTextures = /* @__PURE__ */ new WeakMap();
  let _canvas2;
  let useOffscreenCanvas = false;
  try {
    useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch (err2) {
  }
  function createCanvas(width, height) {
    return useOffscreenCanvas ? new OffscreenCanvas(width, height) : document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
  }
  function resizeImage(image2, needsPowerOfTwo, needsNewCanvas, maxSize) {
    let scale = 1;
    if (image2.width > maxSize || image2.height > maxSize) {
      scale = maxSize / Math.max(image2.width, image2.height);
    }
    if (scale < 1 || needsPowerOfTwo === true) {
      if (typeof HTMLImageElement !== "undefined" && image2 instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image2 instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image2 instanceof ImageBitmap) {
        const floor = needsPowerOfTwo ? floorPowerOfTwo : Math.floor;
        const width = floor(scale * image2.width);
        const height = floor(scale * image2.height);
        if (_canvas2 === void 0) _canvas2 = createCanvas(width, height);
        const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas2;
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext("2d");
        context.drawImage(image2, 0, 0, width, height);
        console.warn("THREE.WebGLRenderer: Texture has been resized from (" + image2.width + "x" + image2.height + ") to (" + width + "x" + height + ").");
        return canvas;
      } else {
        if ("data" in image2) {
          console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + image2.width + "x" + image2.height + ").");
        }
        return image2;
      }
    }
    return image2;
  }
  function isPowerOfTwo$12(image2) {
    return isPowerOfTwo(image2.width) && isPowerOfTwo(image2.height);
  }
  function textureNeedsPowerOfTwo(texture) {
    if (isWebGL2) return false;
    return texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping || texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
  }
  function textureNeedsGenerateMipmaps(texture, supportsMips) {
    return texture.generateMipmaps && supportsMips && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
  }
  function generateMipmap(target, texture, width, height, depth = 1) {
    _gl.generateMipmap(target);
    const textureProperties = properties.get(texture);
    textureProperties.__maxMipLevel = Math.log2(Math.max(width, height, depth));
  }
  function getInternalFormat(internalFormatName, glFormat, glType) {
    if (isWebGL2 === false) return glFormat;
    if (internalFormatName !== null) {
      if (_gl[internalFormatName] !== void 0) return _gl[internalFormatName];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
    }
    let internalFormat = glFormat;
    if (glFormat === 6403) {
      if (glType === 5126) internalFormat = 33326;
      if (glType === 5131) internalFormat = 33325;
      if (glType === 5121) internalFormat = 33321;
    }
    if (glFormat === 6407) {
      if (glType === 5126) internalFormat = 34837;
      if (glType === 5131) internalFormat = 34843;
      if (glType === 5121) internalFormat = 32849;
    }
    if (glFormat === 6408) {
      if (glType === 5126) internalFormat = 34836;
      if (glType === 5131) internalFormat = 34842;
      if (glType === 5121) internalFormat = 32856;
    }
    if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 34842 || internalFormat === 34836) {
      extensions.get("EXT_color_buffer_float");
    }
    return internalFormat;
  }
  function filterFallback(f2) {
    if (f2 === NearestFilter || f2 === NearestMipmapNearestFilter || f2 === NearestMipmapLinearFilter) {
      return 9728;
    }
    return 9729;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    deallocateTexture(texture);
    if (texture.isVideoTexture) {
      _videoTextures.delete(texture);
    }
    info.memory.textures--;
  }
  function onRenderTargetDispose(event) {
    const renderTarget = event.target;
    renderTarget.removeEventListener("dispose", onRenderTargetDispose);
    deallocateRenderTarget(renderTarget);
  }
  function deallocateTexture(texture) {
    const textureProperties = properties.get(texture);
    if (textureProperties.__webglInit === void 0) return;
    _gl.deleteTexture(textureProperties.__webglTexture);
    properties.remove(texture);
  }
  function deallocateRenderTarget(renderTarget) {
    const texture = renderTarget.texture;
    const renderTargetProperties = properties.get(renderTarget);
    const textureProperties = properties.get(texture);
    if (!renderTarget) return;
    if (textureProperties.__webglTexture !== void 0) {
      _gl.deleteTexture(textureProperties.__webglTexture);
      info.memory.textures--;
    }
    if (renderTarget.depthTexture) {
      renderTarget.depthTexture.dispose();
    }
    if (renderTarget.isWebGLCubeRenderTarget) {
      for (let i2 = 0; i2 < 6; i2++) {
        _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i2]);
        if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i2]);
      }
    } else {
      _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
      if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
      if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
      if (renderTargetProperties.__webglColorRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer);
      if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
    }
    if (renderTarget.isWebGLMultipleRenderTargets) {
      for (let i2 = 0, il = texture.length; i2 < il; i2++) {
        const attachmentProperties = properties.get(texture[i2]);
        if (attachmentProperties.__webglTexture) {
          _gl.deleteTexture(attachmentProperties.__webglTexture);
          info.memory.textures--;
        }
        properties.remove(texture[i2]);
      }
    }
    properties.remove(texture);
    properties.remove(renderTarget);
  }
  let textureUnits = 0;
  function resetTextureUnits() {
    textureUnits = 0;
  }
  function allocateTextureUnit() {
    const textureUnit = textureUnits;
    if (textureUnit >= maxTextures) {
      console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + maxTextures);
    }
    textureUnits += 1;
    return textureUnit;
  }
  function setTexture2D(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.isVideoTexture) updateVideoTexture(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      const image2 = texture.image;
      if (image2 === void 0) {
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is undefined");
      } else if (image2.complete === false) {
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      } else {
        uploadTexture(textureProperties, texture, slot);
        return;
      }
    }
    state.activeTexture(33984 + slot);
    state.bindTexture(3553, textureProperties.__webglTexture);
  }
  function setTexture2DArray(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }
    state.activeTexture(33984 + slot);
    state.bindTexture(35866, textureProperties.__webglTexture);
  }
  function setTexture3D(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }
    state.activeTexture(33984 + slot);
    state.bindTexture(32879, textureProperties.__webglTexture);
  }
  function setTextureCube(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadCubeTexture(textureProperties, texture, slot);
      return;
    }
    state.activeTexture(33984 + slot);
    state.bindTexture(34067, textureProperties.__webglTexture);
  }
  const wrappingToGL = {
    [RepeatWrapping]: 10497,
    [ClampToEdgeWrapping]: 33071,
    [MirroredRepeatWrapping]: 33648
  };
  const filterToGL = {
    [NearestFilter]: 9728,
    [NearestMipmapNearestFilter]: 9984,
    [NearestMipmapLinearFilter]: 9986,
    [LinearFilter]: 9729,
    [LinearMipmapNearestFilter]: 9985,
    [LinearMipmapLinearFilter]: 9987
  };
  function setTextureParameters(textureType, texture, supportsMips) {
    if (supportsMips) {
      _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
      _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
      if (textureType === 32879 || textureType === 35866) {
        _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
      }
      _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
      _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
    } else {
      _gl.texParameteri(textureType, 10242, 33071);
      _gl.texParameteri(textureType, 10243, 33071);
      if (textureType === 32879 || textureType === 35866) {
        _gl.texParameteri(textureType, 32882, 33071);
      }
      if (texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping) {
        console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.");
      }
      _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
      _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
      if (texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter) {
        console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.");
      }
    }
    if (extensions.has("EXT_texture_filter_anisotropic") === true) {
      const extension = extensions.get("EXT_texture_filter_anisotropic");
      if (texture.type === FloatType && extensions.has("OES_texture_float_linear") === false) return;
      if (isWebGL2 === false && (texture.type === HalfFloatType && extensions.has("OES_texture_half_float_linear") === false)) return;
      if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
        _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
        properties.get(texture).__currentAnisotropy = texture.anisotropy;
      }
    }
  }
  function initTexture(textureProperties, texture) {
    if (textureProperties.__webglInit === void 0) {
      textureProperties.__webglInit = true;
      texture.addEventListener("dispose", onTextureDispose);
      textureProperties.__webglTexture = _gl.createTexture();
      info.memory.textures++;
    }
  }
  function uploadTexture(textureProperties, texture, slot) {
    let textureType = 3553;
    if (texture.isDataTexture2DArray) textureType = 35866;
    if (texture.isDataTexture3D) textureType = 32879;
    initTexture(textureProperties, texture);
    state.activeTexture(33984 + slot);
    state.bindTexture(textureType, textureProperties.__webglTexture);
    _gl.pixelStorei(37440, texture.flipY);
    _gl.pixelStorei(37441, texture.premultiplyAlpha);
    _gl.pixelStorei(3317, texture.unpackAlignment);
    _gl.pixelStorei(37443, 0);
    const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$12(texture.image) === false;
    const image2 = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
    const supportsMips = isPowerOfTwo$12(image2) || isWebGL2, glFormat = utils2.convert(texture.format);
    let glType = utils2.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
    setTextureParameters(textureType, texture, supportsMips);
    let mipmap;
    const mipmaps = texture.mipmaps;
    if (texture.isDepthTexture) {
      glInternalFormat = 6402;
      if (isWebGL2) {
        if (texture.type === FloatType) {
          glInternalFormat = 36012;
        } else if (texture.type === UnsignedIntType) {
          glInternalFormat = 33190;
        } else if (texture.type === UnsignedInt248Type) {
          glInternalFormat = 35056;
        } else {
          glInternalFormat = 33189;
        }
      } else {
        if (texture.type === FloatType) {
          console.error("WebGLRenderer: Floating point depth texture requires WebGL2.");
        }
      }
      if (texture.format === DepthFormat && glInternalFormat === 6402) {
        if (texture.type !== UnsignedShortType && texture.type !== UnsignedIntType) {
          console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.");
          texture.type = UnsignedShortType;
          glType = utils2.convert(texture.type);
        }
      }
      if (texture.format === DepthStencilFormat && glInternalFormat === 6402) {
        glInternalFormat = 34041;
        if (texture.type !== UnsignedInt248Type) {
          console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.");
          texture.type = UnsignedInt248Type;
          glType = utils2.convert(texture.type);
        }
      }
      state.texImage2D(3553, 0, glInternalFormat, image2.width, image2.height, 0, glFormat, glType, null);
    } else if (texture.isDataTexture) {
      if (mipmaps.length > 0 && supportsMips) {
        for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
          mipmap = mipmaps[i2];
          state.texImage2D(3553, i2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
        }
        texture.generateMipmaps = false;
        textureProperties.__maxMipLevel = mipmaps.length - 1;
      } else {
        state.texImage2D(3553, 0, glInternalFormat, image2.width, image2.height, 0, glFormat, glType, image2.data);
        textureProperties.__maxMipLevel = 0;
      }
    } else if (texture.isCompressedTexture) {
      for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
        mipmap = mipmaps[i2];
        if (texture.format !== RGBAFormat && texture.format !== RGBFormat) {
          if (glFormat !== null) {
            state.compressedTexImage2D(3553, i2, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
          } else {
            console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
          }
        } else {
          state.texImage2D(3553, i2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
        }
      }
      textureProperties.__maxMipLevel = mipmaps.length - 1;
    } else if (texture.isDataTexture2DArray) {
      state.texImage3D(35866, 0, glInternalFormat, image2.width, image2.height, image2.depth, 0, glFormat, glType, image2.data);
      textureProperties.__maxMipLevel = 0;
    } else if (texture.isDataTexture3D) {
      state.texImage3D(32879, 0, glInternalFormat, image2.width, image2.height, image2.depth, 0, glFormat, glType, image2.data);
      textureProperties.__maxMipLevel = 0;
    } else {
      if (mipmaps.length > 0 && supportsMips) {
        for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
          mipmap = mipmaps[i2];
          state.texImage2D(3553, i2, glInternalFormat, glFormat, glType, mipmap);
        }
        texture.generateMipmaps = false;
        textureProperties.__maxMipLevel = mipmaps.length - 1;
      } else {
        state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image2);
        textureProperties.__maxMipLevel = 0;
      }
    }
    if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
      generateMipmap(textureType, texture, image2.width, image2.height);
    }
    textureProperties.__version = texture.version;
    if (texture.onUpdate) texture.onUpdate(texture);
  }
  function uploadCubeTexture(textureProperties, texture, slot) {
    if (texture.image.length !== 6) return;
    initTexture(textureProperties, texture);
    state.activeTexture(33984 + slot);
    state.bindTexture(34067, textureProperties.__webglTexture);
    _gl.pixelStorei(37440, texture.flipY);
    _gl.pixelStorei(37441, texture.premultiplyAlpha);
    _gl.pixelStorei(3317, texture.unpackAlignment);
    _gl.pixelStorei(37443, 0);
    const isCompressed = texture && (texture.isCompressedTexture || texture.image[0].isCompressedTexture);
    const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
    const cubeImage = [];
    for (let i2 = 0; i2 < 6; i2++) {
      if (!isCompressed && !isDataTexture) {
        cubeImage[i2] = resizeImage(texture.image[i2], false, true, maxCubemapSize);
      } else {
        cubeImage[i2] = isDataTexture ? texture.image[i2].image : texture.image[i2];
      }
    }
    const image2 = cubeImage[0], supportsMips = isPowerOfTwo$12(image2) || isWebGL2, glFormat = utils2.convert(texture.format), glType = utils2.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
    setTextureParameters(34067, texture, supportsMips);
    let mipmaps;
    if (isCompressed) {
      for (let i2 = 0; i2 < 6; i2++) {
        mipmaps = cubeImage[i2].mipmaps;
        for (let j = 0; j < mipmaps.length; j++) {
          const mipmap = mipmaps[j];
          if (texture.format !== RGBAFormat && texture.format !== RGBFormat) {
            if (glFormat !== null) {
              state.compressedTexImage2D(34069 + i2, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
            } else {
              console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
            }
          } else {
            state.texImage2D(34069 + i2, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
          }
        }
      }
      textureProperties.__maxMipLevel = mipmaps.length - 1;
    } else {
      mipmaps = texture.mipmaps;
      for (let i2 = 0; i2 < 6; i2++) {
        if (isDataTexture) {
          state.texImage2D(34069 + i2, 0, glInternalFormat, cubeImage[i2].width, cubeImage[i2].height, 0, glFormat, glType, cubeImage[i2].data);
          for (let j = 0; j < mipmaps.length; j++) {
            const mipmap = mipmaps[j];
            const mipmapImage = mipmap.image[i2].image;
            state.texImage2D(34069 + i2, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
          }
        } else {
          state.texImage2D(34069 + i2, 0, glInternalFormat, glFormat, glType, cubeImage[i2]);
          for (let j = 0; j < mipmaps.length; j++) {
            const mipmap = mipmaps[j];
            state.texImage2D(34069 + i2, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i2]);
          }
        }
      }
      textureProperties.__maxMipLevel = mipmaps.length;
    }
    if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
      generateMipmap(34067, texture, image2.width, image2.height);
    }
    textureProperties.__version = texture.version;
    if (texture.onUpdate) texture.onUpdate(texture);
  }
  function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
    const glFormat = utils2.convert(texture.format);
    const glType = utils2.convert(texture.type);
    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
    if (textureTarget === 32879 || textureTarget === 35866) {
      state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
    } else {
      state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
    }
    state.bindFramebuffer(36160, framebuffer);
    _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
    state.bindFramebuffer(36160, null);
  }
  function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
    _gl.bindRenderbuffer(36161, renderbuffer);
    if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
      let glInternalFormat = 33189;
      if (isMultisample) {
        const depthTexture = renderTarget.depthTexture;
        if (depthTexture && depthTexture.isDepthTexture) {
          if (depthTexture.type === FloatType) {
            glInternalFormat = 36012;
          } else if (depthTexture.type === UnsignedIntType) {
            glInternalFormat = 33190;
          }
        }
        const samples = getRenderTargetSamples(renderTarget);
        _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
      } else {
        _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
      }
      _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
    } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
      if (isMultisample) {
        const samples = getRenderTargetSamples(renderTarget);
        _gl.renderbufferStorageMultisample(36161, samples, 35056, renderTarget.width, renderTarget.height);
      } else {
        _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
      }
      _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
    } else {
      const texture = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture[0] : renderTarget.texture;
      const glFormat = utils2.convert(texture.format);
      const glType = utils2.convert(texture.type);
      const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
      if (isMultisample) {
        const samples = getRenderTargetSamples(renderTarget);
        _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
      } else {
        _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
      }
    }
    _gl.bindRenderbuffer(36161, null);
  }
  function setupDepthTexture(framebuffer, renderTarget) {
    const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
    if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
    state.bindFramebuffer(36160, framebuffer);
    if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) {
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    }
    if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
      renderTarget.depthTexture.image.width = renderTarget.width;
      renderTarget.depthTexture.image.height = renderTarget.height;
      renderTarget.depthTexture.needsUpdate = true;
    }
    setTexture2D(renderTarget.depthTexture, 0);
    const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
    if (renderTarget.depthTexture.format === DepthFormat) {
      _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
    } else if (renderTarget.depthTexture.format === DepthStencilFormat) {
      _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
    } else {
      throw new Error("Unknown depthTexture format");
    }
  }
  function setupDepthRenderbuffer(renderTarget) {
    const renderTargetProperties = properties.get(renderTarget);
    const isCube = renderTarget.isWebGLCubeRenderTarget === true;
    if (renderTarget.depthTexture) {
      if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
      setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
    } else {
      if (isCube) {
        renderTargetProperties.__webglDepthbuffer = [];
        for (let i2 = 0; i2 < 6; i2++) {
          state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i2]);
          renderTargetProperties.__webglDepthbuffer[i2] = _gl.createRenderbuffer();
          setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i2], renderTarget, false);
        }
      } else {
        state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
        renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
        setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
      }
    }
    state.bindFramebuffer(36160, null);
  }
  function setupRenderTarget(renderTarget) {
    const texture = renderTarget.texture;
    const renderTargetProperties = properties.get(renderTarget);
    const textureProperties = properties.get(texture);
    renderTarget.addEventListener("dispose", onRenderTargetDispose);
    if (renderTarget.isWebGLMultipleRenderTargets !== true) {
      textureProperties.__webglTexture = _gl.createTexture();
      textureProperties.__version = texture.version;
      info.memory.textures++;
    }
    const isCube = renderTarget.isWebGLCubeRenderTarget === true;
    const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
    const isMultisample = renderTarget.isWebGLMultisampleRenderTarget === true;
    const isRenderTarget3D = texture.isDataTexture3D || texture.isDataTexture2DArray;
    const supportsMips = isPowerOfTwo$12(renderTarget) || isWebGL2;
    if (isWebGL2 && texture.format === RGBFormat && (texture.type === FloatType || texture.type === HalfFloatType)) {
      texture.format = RGBAFormat;
      console.warn("THREE.WebGLRenderer: Rendering to textures with RGB format is not supported. Using RGBA format instead.");
    }
    if (isCube) {
      renderTargetProperties.__webglFramebuffer = [];
      for (let i2 = 0; i2 < 6; i2++) {
        renderTargetProperties.__webglFramebuffer[i2] = _gl.createFramebuffer();
      }
    } else {
      renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
      if (isMultipleRenderTargets) {
        if (capabilities.drawBuffers) {
          const textures = renderTarget.texture;
          for (let i2 = 0, il = textures.length; i2 < il; i2++) {
            const attachmentProperties = properties.get(textures[i2]);
            if (attachmentProperties.__webglTexture === void 0) {
              attachmentProperties.__webglTexture = _gl.createTexture();
              info.memory.textures++;
            }
          }
        } else {
          console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
        }
      } else if (isMultisample) {
        if (isWebGL2) {
          renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
          renderTargetProperties.__webglColorRenderbuffer = _gl.createRenderbuffer();
          _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer);
          const glFormat = utils2.convert(texture.format);
          const glType = utils2.convert(texture.type);
          const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
          const samples = getRenderTargetSamples(renderTarget);
          _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
          state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
          _gl.framebufferRenderbuffer(36160, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer);
          _gl.bindRenderbuffer(36161, null);
          if (renderTarget.depthBuffer) {
            renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
          }
          state.bindFramebuffer(36160, null);
        } else {
          console.warn("THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.");
        }
      }
    }
    if (isCube) {
      state.bindTexture(34067, textureProperties.__webglTexture);
      setTextureParameters(34067, texture, supportsMips);
      for (let i2 = 0; i2 < 6; i2++) {
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i2], renderTarget, texture, 36064, 34069 + i2);
      }
      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        generateMipmap(34067, texture, renderTarget.width, renderTarget.height);
      }
      state.unbindTexture();
    } else if (isMultipleRenderTargets) {
      const textures = renderTarget.texture;
      for (let i2 = 0, il = textures.length; i2 < il; i2++) {
        const attachment = textures[i2];
        const attachmentProperties = properties.get(attachment);
        state.bindTexture(3553, attachmentProperties.__webglTexture);
        setTextureParameters(3553, attachment, supportsMips);
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + i2, 3553);
        if (textureNeedsGenerateMipmaps(attachment, supportsMips)) {
          generateMipmap(3553, attachment, renderTarget.width, renderTarget.height);
        }
      }
      state.unbindTexture();
    } else {
      let glTextureType = 3553;
      if (isRenderTarget3D) {
        if (isWebGL2) {
          const isTexture3D = texture.isDataTexture3D;
          glTextureType = isTexture3D ? 32879 : 35866;
        } else {
          console.warn("THREE.DataTexture3D and THREE.DataTexture2DArray only supported with WebGL2.");
        }
      }
      state.bindTexture(glTextureType, textureProperties.__webglTexture);
      setTextureParameters(glTextureType, texture, supportsMips);
      setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);
      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        generateMipmap(glTextureType, texture, renderTarget.width, renderTarget.height, renderTarget.depth);
      }
      state.unbindTexture();
    }
    if (renderTarget.depthBuffer) {
      setupDepthRenderbuffer(renderTarget);
    }
  }
  function updateRenderTargetMipmap(renderTarget) {
    const supportsMips = isPowerOfTwo$12(renderTarget) || isWebGL2;
    const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [renderTarget.texture];
    for (let i2 = 0, il = textures.length; i2 < il; i2++) {
      const texture = textures[i2];
      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        const target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
        const webglTexture = properties.get(texture).__webglTexture;
        state.bindTexture(target, webglTexture);
        generateMipmap(target, texture, renderTarget.width, renderTarget.height);
        state.unbindTexture();
      }
    }
  }
  function updateMultisampleRenderTarget(renderTarget) {
    if (renderTarget.isWebGLMultisampleRenderTarget) {
      if (isWebGL2) {
        const width = renderTarget.width;
        const height = renderTarget.height;
        let mask = 16384;
        if (renderTarget.depthBuffer) mask |= 256;
        if (renderTarget.stencilBuffer) mask |= 1024;
        const renderTargetProperties = properties.get(renderTarget);
        state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
        state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
        _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
        state.bindFramebuffer(36008, null);
        state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
      } else {
        console.warn("THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.");
      }
    }
  }
  function getRenderTargetSamples(renderTarget) {
    return isWebGL2 && renderTarget.isWebGLMultisampleRenderTarget ? Math.min(maxSamples, renderTarget.samples) : 0;
  }
  function updateVideoTexture(texture) {
    const frame = info.render.frame;
    if (_videoTextures.get(texture) !== frame) {
      _videoTextures.set(texture, frame);
      texture.update();
    }
  }
  let warnedTexture2D = false;
  let warnedTextureCube = false;
  function safeSetTexture2D(texture, slot) {
    if (texture && texture.isWebGLRenderTarget) {
      if (warnedTexture2D === false) {
        console.warn("THREE.WebGLTextures.safeSetTexture2D: don't use render targets as textures. Use their .texture property instead.");
        warnedTexture2D = true;
      }
      texture = texture.texture;
    }
    setTexture2D(texture, slot);
  }
  function safeSetTextureCube(texture, slot) {
    if (texture && texture.isWebGLCubeRenderTarget) {
      if (warnedTextureCube === false) {
        console.warn("THREE.WebGLTextures.safeSetTextureCube: don't use cube render targets as textures. Use their .texture property instead.");
        warnedTextureCube = true;
      }
      texture = texture.texture;
    }
    setTextureCube(texture, slot);
  }
  this.allocateTextureUnit = allocateTextureUnit;
  this.resetTextureUnits = resetTextureUnits;
  this.setTexture2D = setTexture2D;
  this.setTexture2DArray = setTexture2DArray;
  this.setTexture3D = setTexture3D;
  this.setTextureCube = setTextureCube;
  this.setupRenderTarget = setupRenderTarget;
  this.updateRenderTargetMipmap = updateRenderTargetMipmap;
  this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
  this.safeSetTexture2D = safeSetTexture2D;
  this.safeSetTextureCube = safeSetTextureCube;
}
function WebGLUtils(gl, extensions, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  function convert2(p2) {
    let extension;
    if (p2 === UnsignedByteType) return 5121;
    if (p2 === UnsignedShort4444Type) return 32819;
    if (p2 === UnsignedShort5551Type) return 32820;
    if (p2 === UnsignedShort565Type) return 33635;
    if (p2 === ByteType) return 5120;
    if (p2 === ShortType) return 5122;
    if (p2 === UnsignedShortType) return 5123;
    if (p2 === IntType) return 5124;
    if (p2 === UnsignedIntType) return 5125;
    if (p2 === FloatType) return 5126;
    if (p2 === HalfFloatType) {
      if (isWebGL2) return 5131;
      extension = extensions.get("OES_texture_half_float");
      if (extension !== null) {
        return extension.HALF_FLOAT_OES;
      } else {
        return null;
      }
    }
    if (p2 === AlphaFormat) return 6406;
    if (p2 === RGBFormat) return 6407;
    if (p2 === RGBAFormat) return 6408;
    if (p2 === LuminanceFormat) return 6409;
    if (p2 === LuminanceAlphaFormat) return 6410;
    if (p2 === DepthFormat) return 6402;
    if (p2 === DepthStencilFormat) return 34041;
    if (p2 === RedFormat) return 6403;
    if (p2 === RedIntegerFormat) return 36244;
    if (p2 === RGFormat) return 33319;
    if (p2 === RGIntegerFormat) return 33320;
    if (p2 === RGBIntegerFormat) return 36248;
    if (p2 === RGBAIntegerFormat) return 36249;
    if (p2 === RGB_S3TC_DXT1_Format || p2 === RGBA_S3TC_DXT1_Format || p2 === RGBA_S3TC_DXT3_Format || p2 === RGBA_S3TC_DXT5_Format) {
      extension = extensions.get("WEBGL_compressed_texture_s3tc");
      if (extension !== null) {
        if (p2 === RGB_S3TC_DXT1_Format) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (p2 === RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (p2 === RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (p2 === RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      } else {
        return null;
      }
    }
    if (p2 === RGB_PVRTC_4BPPV1_Format || p2 === RGB_PVRTC_2BPPV1_Format || p2 === RGBA_PVRTC_4BPPV1_Format || p2 === RGBA_PVRTC_2BPPV1_Format) {
      extension = extensions.get("WEBGL_compressed_texture_pvrtc");
      if (extension !== null) {
        if (p2 === RGB_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (p2 === RGB_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (p2 === RGBA_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (p2 === RGBA_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else {
        return null;
      }
    }
    if (p2 === RGB_ETC1_Format) {
      extension = extensions.get("WEBGL_compressed_texture_etc1");
      if (extension !== null) {
        return extension.COMPRESSED_RGB_ETC1_WEBGL;
      } else {
        return null;
      }
    }
    if (p2 === RGB_ETC2_Format || p2 === RGBA_ETC2_EAC_Format) {
      extension = extensions.get("WEBGL_compressed_texture_etc");
      if (extension !== null) {
        if (p2 === RGB_ETC2_Format) return extension.COMPRESSED_RGB8_ETC2;
        if (p2 === RGBA_ETC2_EAC_Format) return extension.COMPRESSED_RGBA8_ETC2_EAC;
      }
    }
    if (p2 === RGBA_ASTC_4x4_Format || p2 === RGBA_ASTC_5x4_Format || p2 === RGBA_ASTC_5x5_Format || p2 === RGBA_ASTC_6x5_Format || p2 === RGBA_ASTC_6x6_Format || p2 === RGBA_ASTC_8x5_Format || p2 === RGBA_ASTC_8x6_Format || p2 === RGBA_ASTC_8x8_Format || p2 === RGBA_ASTC_10x5_Format || p2 === RGBA_ASTC_10x6_Format || p2 === RGBA_ASTC_10x8_Format || p2 === RGBA_ASTC_10x10_Format || p2 === RGBA_ASTC_12x10_Format || p2 === RGBA_ASTC_12x12_Format || p2 === SRGB8_ALPHA8_ASTC_4x4_Format || p2 === SRGB8_ALPHA8_ASTC_5x4_Format || p2 === SRGB8_ALPHA8_ASTC_5x5_Format || p2 === SRGB8_ALPHA8_ASTC_6x5_Format || p2 === SRGB8_ALPHA8_ASTC_6x6_Format || p2 === SRGB8_ALPHA8_ASTC_8x5_Format || p2 === SRGB8_ALPHA8_ASTC_8x6_Format || p2 === SRGB8_ALPHA8_ASTC_8x8_Format || p2 === SRGB8_ALPHA8_ASTC_10x5_Format || p2 === SRGB8_ALPHA8_ASTC_10x6_Format || p2 === SRGB8_ALPHA8_ASTC_10x8_Format || p2 === SRGB8_ALPHA8_ASTC_10x10_Format || p2 === SRGB8_ALPHA8_ASTC_12x10_Format || p2 === SRGB8_ALPHA8_ASTC_12x12_Format) {
      extension = extensions.get("WEBGL_compressed_texture_astc");
      if (extension !== null) {
        return p2;
      } else {
        return null;
      }
    }
    if (p2 === RGBA_BPTC_Format) {
      extension = extensions.get("EXT_texture_compression_bptc");
      if (extension !== null) {
        return p2;
      } else {
        return null;
      }
    }
    if (p2 === UnsignedInt248Type) {
      if (isWebGL2) return 34042;
      extension = extensions.get("WEBGL_depth_texture");
      if (extension !== null) {
        return extension.UNSIGNED_INT_24_8_WEBGL;
      } else {
        return null;
      }
    }
  }
  return { convert: convert2 };
}
class ArrayCamera2 extends PerspectiveCamera2 {
  constructor(array = []) {
    super();
    this.cameras = array;
  }
}
ArrayCamera2.prototype.isArrayCamera = true;
class Group2 extends Object3D2 {
  constructor() {
    super();
    this.type = "Group";
  }
}
Group2.prototype.isGroup = true;
const _moveEvent = { type: "move" };
class WebXRController2 {
  constructor() {
    this._targetRay = null;
    this._grip = null;
    this._hand = null;
  }
  getHandSpace() {
    if (this._hand === null) {
      this._hand = new Group2();
      this._hand.matrixAutoUpdate = false;
      this._hand.visible = false;
      this._hand.joints = {};
      this._hand.inputState = { pinching: false };
    }
    return this._hand;
  }
  getTargetRaySpace() {
    if (this._targetRay === null) {
      this._targetRay = new Group2();
      this._targetRay.matrixAutoUpdate = false;
      this._targetRay.visible = false;
      this._targetRay.hasLinearVelocity = false;
      this._targetRay.linearVelocity = new Vector32();
      this._targetRay.hasAngularVelocity = false;
      this._targetRay.angularVelocity = new Vector32();
    }
    return this._targetRay;
  }
  getGripSpace() {
    if (this._grip === null) {
      this._grip = new Group2();
      this._grip.matrixAutoUpdate = false;
      this._grip.visible = false;
      this._grip.hasLinearVelocity = false;
      this._grip.linearVelocity = new Vector32();
      this._grip.hasAngularVelocity = false;
      this._grip.angularVelocity = new Vector32();
    }
    return this._grip;
  }
  dispatchEvent(event) {
    if (this._targetRay !== null) {
      this._targetRay.dispatchEvent(event);
    }
    if (this._grip !== null) {
      this._grip.dispatchEvent(event);
    }
    if (this._hand !== null) {
      this._hand.dispatchEvent(event);
    }
    return this;
  }
  disconnect(inputSource) {
    this.dispatchEvent({ type: "disconnected", data: inputSource });
    if (this._targetRay !== null) {
      this._targetRay.visible = false;
    }
    if (this._grip !== null) {
      this._grip.visible = false;
    }
    if (this._hand !== null) {
      this._hand.visible = false;
    }
    return this;
  }
  update(inputSource, frame, referenceSpace) {
    let inputPose = null;
    let gripPose = null;
    let handPose = null;
    const targetRay = this._targetRay;
    const grip = this._grip;
    const hand = this._hand;
    if (inputSource && frame.session.visibilityState !== "visible-blurred") {
      if (targetRay !== null) {
        inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
        if (inputPose !== null) {
          targetRay.matrix.fromArray(inputPose.transform.matrix);
          targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
          if (inputPose.linearVelocity) {
            targetRay.hasLinearVelocity = true;
            targetRay.linearVelocity.copy(inputPose.linearVelocity);
          } else {
            targetRay.hasLinearVelocity = false;
          }
          if (inputPose.angularVelocity) {
            targetRay.hasAngularVelocity = true;
            targetRay.angularVelocity.copy(inputPose.angularVelocity);
          } else {
            targetRay.hasAngularVelocity = false;
          }
          this.dispatchEvent(_moveEvent);
        }
      }
      if (hand && inputSource.hand) {
        handPose = true;
        for (const inputjoint of inputSource.hand.values()) {
          const jointPose = frame.getJointPose(inputjoint, referenceSpace);
          if (hand.joints[inputjoint.jointName] === void 0) {
            const joint2 = new Group2();
            joint2.matrixAutoUpdate = false;
            joint2.visible = false;
            hand.joints[inputjoint.jointName] = joint2;
            hand.add(joint2);
          }
          const joint = hand.joints[inputjoint.jointName];
          if (jointPose !== null) {
            joint.matrix.fromArray(jointPose.transform.matrix);
            joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
            joint.jointRadius = jointPose.radius;
          }
          joint.visible = jointPose !== null;
        }
        const indexTip = hand.joints["index-finger-tip"];
        const thumbTip = hand.joints["thumb-tip"];
        const distance2 = indexTip.position.distanceTo(thumbTip.position);
        const distanceToPinch = 0.02;
        const threshold = 5e-3;
        if (hand.inputState.pinching && distance2 > distanceToPinch + threshold) {
          hand.inputState.pinching = false;
          this.dispatchEvent({
            type: "pinchend",
            handedness: inputSource.handedness,
            target: this
          });
        } else if (!hand.inputState.pinching && distance2 <= distanceToPinch - threshold) {
          hand.inputState.pinching = true;
          this.dispatchEvent({
            type: "pinchstart",
            handedness: inputSource.handedness,
            target: this
          });
        }
      } else {
        if (grip !== null && inputSource.gripSpace) {
          gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
          if (gripPose !== null) {
            grip.matrix.fromArray(gripPose.transform.matrix);
            grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
            if (gripPose.linearVelocity) {
              grip.hasLinearVelocity = true;
              grip.linearVelocity.copy(gripPose.linearVelocity);
            } else {
              grip.hasLinearVelocity = false;
            }
            if (gripPose.angularVelocity) {
              grip.hasAngularVelocity = true;
              grip.angularVelocity.copy(gripPose.angularVelocity);
            } else {
              grip.hasAngularVelocity = false;
            }
          }
        }
      }
    }
    if (targetRay !== null) {
      targetRay.visible = inputPose !== null;
    }
    if (grip !== null) {
      grip.visible = gripPose !== null;
    }
    if (hand !== null) {
      hand.visible = handPose !== null;
    }
    return this;
  }
}
class WebXRManager2 extends EventDispatcher2 {
  constructor(renderer, gl) {
    super();
    const scope = this;
    const state = renderer.state;
    let session = null;
    let framebufferScaleFactor = 1;
    let referenceSpace = null;
    let referenceSpaceType = "local-floor";
    let pose = null;
    let glBinding = null;
    let glFramebuffer = null;
    let glProjLayer = null;
    let glBaseLayer = null;
    let isMultisample = false;
    let glMultisampledFramebuffer = null;
    let glColorRenderbuffer = null;
    let glDepthRenderbuffer = null;
    let xrFrame = null;
    let depthStyle = null;
    let clearStyle = null;
    const controllers = [];
    const inputSourcesMap = /* @__PURE__ */ new Map();
    const cameraL = new PerspectiveCamera2();
    cameraL.layers.enable(1);
    cameraL.viewport = new Vector42();
    const cameraR = new PerspectiveCamera2();
    cameraR.layers.enable(2);
    cameraR.viewport = new Vector42();
    const cameras = [cameraL, cameraR];
    const cameraVR = new ArrayCamera2();
    cameraVR.layers.enable(1);
    cameraVR.layers.enable(2);
    let _currentDepthNear = null;
    let _currentDepthFar = null;
    this.cameraAutoUpdate = true;
    this.enabled = false;
    this.isPresenting = false;
    this.getController = function(index2) {
      let controller = controllers[index2];
      if (controller === void 0) {
        controller = new WebXRController2();
        controllers[index2] = controller;
      }
      return controller.getTargetRaySpace();
    };
    this.getControllerGrip = function(index2) {
      let controller = controllers[index2];
      if (controller === void 0) {
        controller = new WebXRController2();
        controllers[index2] = controller;
      }
      return controller.getGripSpace();
    };
    this.getHand = function(index2) {
      let controller = controllers[index2];
      if (controller === void 0) {
        controller = new WebXRController2();
        controllers[index2] = controller;
      }
      return controller.getHandSpace();
    };
    function onSessionEvent(event) {
      const controller = inputSourcesMap.get(event.inputSource);
      if (controller) {
        controller.dispatchEvent({ type: event.type, data: event.inputSource });
      }
    }
    function onSessionEnd() {
      inputSourcesMap.forEach(function(controller, inputSource) {
        controller.disconnect(inputSource);
      });
      inputSourcesMap.clear();
      _currentDepthNear = null;
      _currentDepthFar = null;
      state.bindXRFramebuffer(null);
      renderer.setRenderTarget(renderer.getRenderTarget());
      if (glFramebuffer) gl.deleteFramebuffer(glFramebuffer);
      if (glMultisampledFramebuffer) gl.deleteFramebuffer(glMultisampledFramebuffer);
      if (glColorRenderbuffer) gl.deleteRenderbuffer(glColorRenderbuffer);
      if (glDepthRenderbuffer) gl.deleteRenderbuffer(glDepthRenderbuffer);
      glFramebuffer = null;
      glMultisampledFramebuffer = null;
      glColorRenderbuffer = null;
      glDepthRenderbuffer = null;
      glBaseLayer = null;
      glProjLayer = null;
      glBinding = null;
      session = null;
      animation.stop();
      scope.isPresenting = false;
      scope.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function(value) {
      framebufferScaleFactor = value;
      if (scope.isPresenting === true) {
        console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
      }
    };
    this.setReferenceSpaceType = function(value) {
      referenceSpaceType = value;
      if (scope.isPresenting === true) {
        console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
      }
    };
    this.getReferenceSpace = function() {
      return referenceSpace;
    };
    this.getBaseLayer = function() {
      return glProjLayer !== null ? glProjLayer : glBaseLayer;
    };
    this.getBinding = function() {
      return glBinding;
    };
    this.getFrame = function() {
      return xrFrame;
    };
    this.getSession = function() {
      return session;
    };
    this.setSession = async function(value) {
      session = value;
      if (session !== null) {
        session.addEventListener("select", onSessionEvent);
        session.addEventListener("selectstart", onSessionEvent);
        session.addEventListener("selectend", onSessionEvent);
        session.addEventListener("squeeze", onSessionEvent);
        session.addEventListener("squeezestart", onSessionEvent);
        session.addEventListener("squeezeend", onSessionEvent);
        session.addEventListener("end", onSessionEnd);
        session.addEventListener("inputsourceschange", onInputSourcesChange);
        const attributes = gl.getContextAttributes();
        if (attributes.xrCompatible !== true) {
          await gl.makeXRCompatible();
        }
        if (session.renderState.layers === void 0) {
          const layerInit = {
            antialias: attributes.antialias,
            alpha: attributes.alpha,
            depth: attributes.depth,
            stencil: attributes.stencil,
            framebufferScaleFactor
          };
          glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
          session.updateRenderState({ baseLayer: glBaseLayer });
        } else if (gl instanceof WebGLRenderingContext) {
          const layerInit = {
            antialias: true,
            alpha: attributes.alpha,
            depth: attributes.depth,
            stencil: attributes.stencil,
            framebufferScaleFactor
          };
          glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
          session.updateRenderState({ layers: [glBaseLayer] });
        } else {
          isMultisample = attributes.antialias;
          let depthFormat = null;
          if (attributes.depth) {
            clearStyle = 256;
            if (attributes.stencil) clearStyle |= 1024;
            depthStyle = attributes.stencil ? 33306 : 36096;
            depthFormat = attributes.stencil ? 35056 : 33190;
          }
          const projectionlayerInit = {
            colorFormat: attributes.alpha ? 32856 : 32849,
            depthFormat,
            scaleFactor: framebufferScaleFactor
          };
          glBinding = new XRWebGLBinding(session, gl);
          glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
          glFramebuffer = gl.createFramebuffer();
          session.updateRenderState({ layers: [glProjLayer] });
          if (isMultisample) {
            glMultisampledFramebuffer = gl.createFramebuffer();
            glColorRenderbuffer = gl.createRenderbuffer();
            gl.bindRenderbuffer(36161, glColorRenderbuffer);
            gl.renderbufferStorageMultisample(
              36161,
              4,
              32856,
              glProjLayer.textureWidth,
              glProjLayer.textureHeight
            );
            state.bindFramebuffer(36160, glMultisampledFramebuffer);
            gl.framebufferRenderbuffer(36160, 36064, 36161, glColorRenderbuffer);
            gl.bindRenderbuffer(36161, null);
            if (depthFormat !== null) {
              glDepthRenderbuffer = gl.createRenderbuffer();
              gl.bindRenderbuffer(36161, glDepthRenderbuffer);
              gl.renderbufferStorageMultisample(36161, 4, depthFormat, glProjLayer.textureWidth, glProjLayer.textureHeight);
              gl.framebufferRenderbuffer(36160, depthStyle, 36161, glDepthRenderbuffer);
              gl.bindRenderbuffer(36161, null);
            }
            state.bindFramebuffer(36160, null);
          }
        }
        referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
        animation.setContext(session);
        animation.start();
        scope.isPresenting = true;
        scope.dispatchEvent({ type: "sessionstart" });
      }
    };
    function onInputSourcesChange(event) {
      const inputSources = session.inputSources;
      for (let i2 = 0; i2 < controllers.length; i2++) {
        inputSourcesMap.set(inputSources[i2], controllers[i2]);
      }
      for (let i2 = 0; i2 < event.removed.length; i2++) {
        const inputSource = event.removed[i2];
        const controller = inputSourcesMap.get(inputSource);
        if (controller) {
          controller.dispatchEvent({ type: "disconnected", data: inputSource });
          inputSourcesMap.delete(inputSource);
        }
      }
      for (let i2 = 0; i2 < event.added.length; i2++) {
        const inputSource = event.added[i2];
        const controller = inputSourcesMap.get(inputSource);
        if (controller) {
          controller.dispatchEvent({ type: "connected", data: inputSource });
        }
      }
    }
    const cameraLPos = new Vector32();
    const cameraRPos = new Vector32();
    function setProjectionFromUnion(camera, cameraL2, cameraR2) {
      cameraLPos.setFromMatrixPosition(cameraL2.matrixWorld);
      cameraRPos.setFromMatrixPosition(cameraR2.matrixWorld);
      const ipd = cameraLPos.distanceTo(cameraRPos);
      const projL = cameraL2.projectionMatrix.elements;
      const projR = cameraR2.projectionMatrix.elements;
      const near = projL[14] / (projL[10] - 1);
      const far = projL[14] / (projL[10] + 1);
      const topFov = (projL[9] + 1) / projL[5];
      const bottomFov = (projL[9] - 1) / projL[5];
      const leftFov = (projL[8] - 1) / projL[0];
      const rightFov = (projR[8] + 1) / projR[0];
      const left = near * leftFov;
      const right = near * rightFov;
      const zOffset = ipd / (-leftFov + rightFov);
      const xOffset = zOffset * -leftFov;
      cameraL2.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
      camera.translateX(xOffset);
      camera.translateZ(zOffset);
      camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
      camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
      const near2 = near + zOffset;
      const far2 = far + zOffset;
      const left2 = left - xOffset;
      const right2 = right + (ipd - xOffset);
      const top2 = topFov * far / far2 * near2;
      const bottom2 = bottomFov * far / far2 * near2;
      camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
    }
    function updateCamera(camera, parent2) {
      if (parent2 === null) {
        camera.matrixWorld.copy(camera.matrix);
      } else {
        camera.matrixWorld.multiplyMatrices(parent2.matrixWorld, camera.matrix);
      }
      camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
    }
    this.updateCamera = function(camera) {
      if (session === null) return;
      cameraVR.near = cameraR.near = cameraL.near = camera.near;
      cameraVR.far = cameraR.far = cameraL.far = camera.far;
      if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
        session.updateRenderState({
          depthNear: cameraVR.near,
          depthFar: cameraVR.far
        });
        _currentDepthNear = cameraVR.near;
        _currentDepthFar = cameraVR.far;
      }
      const parent2 = camera.parent;
      const cameras2 = cameraVR.cameras;
      updateCamera(cameraVR, parent2);
      for (let i2 = 0; i2 < cameras2.length; i2++) {
        updateCamera(cameras2[i2], parent2);
      }
      cameraVR.matrixWorld.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale);
      camera.position.copy(cameraVR.position);
      camera.quaternion.copy(cameraVR.quaternion);
      camera.scale.copy(cameraVR.scale);
      camera.matrix.copy(cameraVR.matrix);
      camera.matrixWorld.copy(cameraVR.matrixWorld);
      const children = camera.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        children[i2].updateMatrixWorld(true);
      }
      if (cameras2.length === 2) {
        setProjectionFromUnion(cameraVR, cameraL, cameraR);
      } else {
        cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
      }
    };
    this.getCamera = function() {
      return cameraVR;
    };
    this.getFoveation = function() {
      if (glProjLayer !== null) {
        return glProjLayer.fixedFoveation;
      }
      if (glBaseLayer !== null) {
        return glBaseLayer.fixedFoveation;
      }
      return void 0;
    };
    this.setFoveation = function(foveation) {
      if (glProjLayer !== null) {
        glProjLayer.fixedFoveation = foveation;
      }
      if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== void 0) {
        glBaseLayer.fixedFoveation = foveation;
      }
    };
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time2, frame) {
      pose = frame.getViewerPose(referenceSpace);
      xrFrame = frame;
      if (pose !== null) {
        const views = pose.views;
        if (glBaseLayer !== null) {
          state.bindXRFramebuffer(glBaseLayer.framebuffer);
        }
        let cameraVRNeedsUpdate = false;
        if (views.length !== cameraVR.cameras.length) {
          cameraVR.cameras.length = 0;
          cameraVRNeedsUpdate = true;
        }
        for (let i2 = 0; i2 < views.length; i2++) {
          const view = views[i2];
          let viewport = null;
          if (glBaseLayer !== null) {
            viewport = glBaseLayer.getViewport(view);
          } else {
            const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
            state.bindXRFramebuffer(glFramebuffer);
            if (glSubImage.depthStencilTexture !== void 0) {
              gl.framebufferTexture2D(36160, depthStyle, 3553, glSubImage.depthStencilTexture, 0);
            }
            gl.framebufferTexture2D(36160, 36064, 3553, glSubImage.colorTexture, 0);
            viewport = glSubImage.viewport;
          }
          const camera = cameras[i2];
          camera.matrix.fromArray(view.transform.matrix);
          camera.projectionMatrix.fromArray(view.projectionMatrix);
          camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
          if (i2 === 0) {
            cameraVR.matrix.copy(camera.matrix);
          }
          if (cameraVRNeedsUpdate === true) {
            cameraVR.cameras.push(camera);
          }
        }
        if (isMultisample) {
          state.bindXRFramebuffer(glMultisampledFramebuffer);
          if (clearStyle !== null) gl.clear(clearStyle);
        }
      }
      const inputSources = session.inputSources;
      for (let i2 = 0; i2 < controllers.length; i2++) {
        const controller = controllers[i2];
        const inputSource = inputSources[i2];
        controller.update(inputSource, frame, referenceSpace);
      }
      if (onAnimationFrameCallback) onAnimationFrameCallback(time2, frame);
      if (isMultisample) {
        const width = glProjLayer.textureWidth;
        const height = glProjLayer.textureHeight;
        state.bindFramebuffer(36008, glMultisampledFramebuffer);
        state.bindFramebuffer(36009, glFramebuffer);
        gl.invalidateFramebuffer(36008, [depthStyle]);
        gl.invalidateFramebuffer(36009, [depthStyle]);
        gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, 16384, 9728);
        gl.invalidateFramebuffer(36008, [36064]);
        state.bindFramebuffer(36008, null);
        state.bindFramebuffer(36009, null);
        state.bindFramebuffer(36160, glMultisampledFramebuffer);
      }
      xrFrame = null;
    }
    const animation = new WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    this.setAnimationLoop = function(callback) {
      onAnimationFrameCallback = callback;
    };
    this.dispose = function() {
    };
  }
}
function WebGLMaterials(properties) {
  function refreshFogUniforms(uniforms, fog) {
    uniforms.fogColor.value.copy(fog.color);
    if (fog.isFog) {
      uniforms.fogNear.value = fog.near;
      uniforms.fogFar.value = fog.far;
    } else if (fog.isFogExp2) {
      uniforms.fogDensity.value = fog.density;
    }
  }
  function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
    if (material.isMeshBasicMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshLambertMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsLambert(uniforms, material);
    } else if (material.isMeshToonMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsToon(uniforms, material);
    } else if (material.isMeshPhongMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsPhong(uniforms, material);
    } else if (material.isMeshStandardMaterial) {
      refreshUniformsCommon(uniforms, material);
      if (material.isMeshPhysicalMaterial) {
        refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
      } else {
        refreshUniformsStandard(uniforms, material);
      }
    } else if (material.isMeshMatcapMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsMatcap(uniforms, material);
    } else if (material.isMeshDepthMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsDepth(uniforms, material);
    } else if (material.isMeshDistanceMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsDistance(uniforms, material);
    } else if (material.isMeshNormalMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsNormal(uniforms, material);
    } else if (material.isLineBasicMaterial) {
      refreshUniformsLine(uniforms, material);
      if (material.isLineDashedMaterial) {
        refreshUniformsDash(uniforms, material);
      }
    } else if (material.isPointsMaterial) {
      refreshUniformsPoints(uniforms, material, pixelRatio, height);
    } else if (material.isSpriteMaterial) {
      refreshUniformsSprites(uniforms, material);
    } else if (material.isShadowMaterial) {
      uniforms.color.value.copy(material.color);
      uniforms.opacity.value = material.opacity;
    } else if (material.isShaderMaterial) {
      material.uniformsNeedUpdate = false;
    }
  }
  function refreshUniformsCommon(uniforms, material) {
    uniforms.opacity.value = material.opacity;
    if (material.color) {
      uniforms.diffuse.value.copy(material.color);
    }
    if (material.emissive) {
      uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
    }
    if (material.map) {
      uniforms.map.value = material.map;
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
    }
    if (material.specularMap) {
      uniforms.specularMap.value = material.specularMap;
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
    const envMap = properties.get(material).envMap;
    if (envMap) {
      uniforms.envMap.value = envMap;
      uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
      uniforms.reflectivity.value = material.reflectivity;
      uniforms.ior.value = material.ior;
      uniforms.refractionRatio.value = material.refractionRatio;
      const maxMipLevel = properties.get(envMap).__maxMipLevel;
      if (maxMipLevel !== void 0) {
        uniforms.maxMipLevel.value = maxMipLevel;
      }
    }
    if (material.lightMap) {
      uniforms.lightMap.value = material.lightMap;
      uniforms.lightMapIntensity.value = material.lightMapIntensity;
    }
    if (material.aoMap) {
      uniforms.aoMap.value = material.aoMap;
      uniforms.aoMapIntensity.value = material.aoMapIntensity;
    }
    let uvScaleMap;
    if (material.map) {
      uvScaleMap = material.map;
    } else if (material.specularMap) {
      uvScaleMap = material.specularMap;
    } else if (material.displacementMap) {
      uvScaleMap = material.displacementMap;
    } else if (material.normalMap) {
      uvScaleMap = material.normalMap;
    } else if (material.bumpMap) {
      uvScaleMap = material.bumpMap;
    } else if (material.roughnessMap) {
      uvScaleMap = material.roughnessMap;
    } else if (material.metalnessMap) {
      uvScaleMap = material.metalnessMap;
    } else if (material.alphaMap) {
      uvScaleMap = material.alphaMap;
    } else if (material.emissiveMap) {
      uvScaleMap = material.emissiveMap;
    } else if (material.clearcoatMap) {
      uvScaleMap = material.clearcoatMap;
    } else if (material.clearcoatNormalMap) {
      uvScaleMap = material.clearcoatNormalMap;
    } else if (material.clearcoatRoughnessMap) {
      uvScaleMap = material.clearcoatRoughnessMap;
    } else if (material.specularIntensityMap) {
      uvScaleMap = material.specularIntensityMap;
    } else if (material.specularTintMap) {
      uvScaleMap = material.specularTintMap;
    } else if (material.transmissionMap) {
      uvScaleMap = material.transmissionMap;
    } else if (material.thicknessMap) {
      uvScaleMap = material.thicknessMap;
    }
    if (uvScaleMap !== void 0) {
      if (uvScaleMap.isWebGLRenderTarget) {
        uvScaleMap = uvScaleMap.texture;
      }
      if (uvScaleMap.matrixAutoUpdate === true) {
        uvScaleMap.updateMatrix();
      }
      uniforms.uvTransform.value.copy(uvScaleMap.matrix);
    }
    let uv2ScaleMap;
    if (material.aoMap) {
      uv2ScaleMap = material.aoMap;
    } else if (material.lightMap) {
      uv2ScaleMap = material.lightMap;
    }
    if (uv2ScaleMap !== void 0) {
      if (uv2ScaleMap.isWebGLRenderTarget) {
        uv2ScaleMap = uv2ScaleMap.texture;
      }
      if (uv2ScaleMap.matrixAutoUpdate === true) {
        uv2ScaleMap.updateMatrix();
      }
      uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
    }
  }
  function refreshUniformsLine(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
  }
  function refreshUniformsDash(uniforms, material) {
    uniforms.dashSize.value = material.dashSize;
    uniforms.totalSize.value = material.dashSize + material.gapSize;
    uniforms.scale.value = material.scale;
  }
  function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.size.value = material.size * pixelRatio;
    uniforms.scale.value = height * 0.5;
    if (material.map) {
      uniforms.map.value = material.map;
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
    let uvScaleMap;
    if (material.map) {
      uvScaleMap = material.map;
    } else if (material.alphaMap) {
      uvScaleMap = material.alphaMap;
    }
    if (uvScaleMap !== void 0) {
      if (uvScaleMap.matrixAutoUpdate === true) {
        uvScaleMap.updateMatrix();
      }
      uniforms.uvTransform.value.copy(uvScaleMap.matrix);
    }
  }
  function refreshUniformsSprites(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.rotation.value = material.rotation;
    if (material.map) {
      uniforms.map.value = material.map;
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
    let uvScaleMap;
    if (material.map) {
      uvScaleMap = material.map;
    } else if (material.alphaMap) {
      uvScaleMap = material.alphaMap;
    }
    if (uvScaleMap !== void 0) {
      if (uvScaleMap.matrixAutoUpdate === true) {
        uvScaleMap.updateMatrix();
      }
      uniforms.uvTransform.value.copy(uvScaleMap.matrix);
    }
  }
  function refreshUniformsLambert(uniforms, material) {
    if (material.emissiveMap) {
      uniforms.emissiveMap.value = material.emissiveMap;
    }
  }
  function refreshUniformsPhong(uniforms, material) {
    uniforms.specular.value.copy(material.specular);
    uniforms.shininess.value = Math.max(material.shininess, 1e-4);
    if (material.emissiveMap) {
      uniforms.emissiveMap.value = material.emissiveMap;
    }
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide) uniforms.bumpScale.value *= -1;
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide) uniforms.normalScale.value.negate();
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
  }
  function refreshUniformsToon(uniforms, material) {
    if (material.gradientMap) {
      uniforms.gradientMap.value = material.gradientMap;
    }
    if (material.emissiveMap) {
      uniforms.emissiveMap.value = material.emissiveMap;
    }
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide) uniforms.bumpScale.value *= -1;
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide) uniforms.normalScale.value.negate();
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
  }
  function refreshUniformsStandard(uniforms, material) {
    uniforms.roughness.value = material.roughness;
    uniforms.metalness.value = material.metalness;
    if (material.roughnessMap) {
      uniforms.roughnessMap.value = material.roughnessMap;
    }
    if (material.metalnessMap) {
      uniforms.metalnessMap.value = material.metalnessMap;
    }
    if (material.emissiveMap) {
      uniforms.emissiveMap.value = material.emissiveMap;
    }
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide) uniforms.bumpScale.value *= -1;
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide) uniforms.normalScale.value.negate();
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
    const envMap = properties.get(material).envMap;
    if (envMap) {
      uniforms.envMapIntensity.value = material.envMapIntensity;
    }
  }
  function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
    refreshUniformsStandard(uniforms, material);
    uniforms.ior.value = material.ior;
    if (material.sheenTint) uniforms.sheenTint.value.copy(material.sheenTint);
    if (material.clearcoat > 0) {
      uniforms.clearcoat.value = material.clearcoat;
      uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
      if (material.clearcoatMap) {
        uniforms.clearcoatMap.value = material.clearcoatMap;
      }
      if (material.clearcoatRoughnessMap) {
        uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
      }
      if (material.clearcoatNormalMap) {
        uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
        uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
        if (material.side === BackSide) {
          uniforms.clearcoatNormalScale.value.negate();
        }
      }
    }
    if (material.transmission > 0) {
      uniforms.transmission.value = material.transmission;
      uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
      uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
      if (material.transmissionMap) {
        uniforms.transmissionMap.value = material.transmissionMap;
      }
      uniforms.thickness.value = material.thickness;
      if (material.thicknessMap) {
        uniforms.thicknessMap.value = material.thicknessMap;
      }
      uniforms.attenuationDistance.value = material.attenuationDistance;
      uniforms.attenuationTint.value.copy(material.attenuationTint);
    }
    uniforms.specularIntensity.value = material.specularIntensity;
    uniforms.specularTint.value.copy(material.specularTint);
    if (material.specularIntensityMap) {
      uniforms.specularIntensityMap.value = material.specularIntensityMap;
    }
    if (material.specularTintMap) {
      uniforms.specularTintMap.value = material.specularTintMap;
    }
  }
  function refreshUniformsMatcap(uniforms, material) {
    if (material.matcap) {
      uniforms.matcap.value = material.matcap;
    }
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide) uniforms.bumpScale.value *= -1;
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide) uniforms.normalScale.value.negate();
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
  }
  function refreshUniformsDepth(uniforms, material) {
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
  }
  function refreshUniformsDistance(uniforms, material) {
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
    uniforms.referencePosition.value.copy(material.referencePosition);
    uniforms.nearDistance.value = material.nearDistance;
    uniforms.farDistance.value = material.farDistance;
  }
  function refreshUniformsNormal(uniforms, material) {
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide) uniforms.bumpScale.value *= -1;
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide) uniforms.normalScale.value.negate();
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
  }
  return {
    refreshFogUniforms,
    refreshMaterialUniforms
  };
}
function createCanvasElement() {
  const canvas = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
  canvas.style.display = "block";
  return canvas;
}
function WebGLRenderer2(parameters = {}) {
  const _canvas2 = parameters.canvas !== void 0 ? parameters.canvas : createCanvasElement(), _context2 = parameters.context !== void 0 ? parameters.context : null, _alpha = parameters.alpha !== void 0 ? parameters.alpha : false, _depth = parameters.depth !== void 0 ? parameters.depth : true, _stencil = parameters.stencil !== void 0 ? parameters.stencil : true, _antialias = parameters.antialias !== void 0 ? parameters.antialias : false, _premultipliedAlpha = parameters.premultipliedAlpha !== void 0 ? parameters.premultipliedAlpha : true, _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== void 0 ? parameters.preserveDrawingBuffer : false, _powerPreference = parameters.powerPreference !== void 0 ? parameters.powerPreference : "default", _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== void 0 ? parameters.failIfMajorPerformanceCaveat : false;
  let currentRenderList = null;
  let currentRenderState = null;
  const renderListStack = [];
  const renderStateStack = [];
  this.domElement = _canvas2;
  this.debug = {
    /**
     * Enables error checking and reporting when shader programs are being compiled
     * @type {boolean}
     */
    checkShaderErrors: true
  };
  this.autoClear = true;
  this.autoClearColor = true;
  this.autoClearDepth = true;
  this.autoClearStencil = true;
  this.sortObjects = true;
  this.clippingPlanes = [];
  this.localClippingEnabled = false;
  this.gammaFactor = 2;
  this.outputEncoding = LinearEncoding;
  this.physicallyCorrectLights = false;
  this.toneMapping = NoToneMapping;
  this.toneMappingExposure = 1;
  const _this = this;
  let _isContextLost = false;
  let _currentActiveCubeFace = 0;
  let _currentActiveMipmapLevel = 0;
  let _currentRenderTarget = null;
  let _currentMaterialId = -1;
  let _currentCamera = null;
  const _currentViewport = new Vector42();
  const _currentScissor = new Vector42();
  let _currentScissorTest = null;
  let _width = _canvas2.width;
  let _height = _canvas2.height;
  let _pixelRatio = 1;
  let _opaqueSort = null;
  let _transparentSort = null;
  const _viewport2 = new Vector42(0, 0, _width, _height);
  const _scissor = new Vector42(0, 0, _width, _height);
  let _scissorTest = false;
  const _currentDrawBuffers = [];
  const _frustum2 = new Frustum2();
  let _clippingEnabled = false;
  let _localClippingEnabled = false;
  let _transmissionRenderTarget = null;
  const _projScreenMatrix2 = new Matrix42();
  const _vector32 = new Vector32();
  const _emptyScene = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: true };
  function getTargetPixelRatio() {
    return _currentRenderTarget === null ? _pixelRatio : 1;
  }
  let _gl = _context2;
  function getContext(contextNames, contextAttributes) {
    for (let i2 = 0; i2 < contextNames.length; i2++) {
      const contextName = contextNames[i2];
      const context = _canvas2.getContext(contextName, contextAttributes);
      if (context !== null) return context;
    }
    return null;
  }
  try {
    const contextAttributes = {
      alpha: _alpha,
      depth: _depth,
      stencil: _stencil,
      antialias: _antialias,
      premultipliedAlpha: _premultipliedAlpha,
      preserveDrawingBuffer: _preserveDrawingBuffer,
      powerPreference: _powerPreference,
      failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
    };
    _canvas2.addEventListener("webglcontextlost", onContextLost, false);
    _canvas2.addEventListener("webglcontextrestored", onContextRestore, false);
    if (_gl === null) {
      const contextNames = ["webgl2", "webgl", "experimental-webgl"];
      if (_this.isWebGL1Renderer === true) {
        contextNames.shift();
      }
      _gl = getContext(contextNames, contextAttributes);
      if (_gl === null) {
        if (getContext(contextNames)) {
          throw new Error("Error creating WebGL context with your selected attributes.");
        } else {
          throw new Error("Error creating WebGL context.");
        }
      }
    }
    if (_gl.getShaderPrecisionFormat === void 0) {
      _gl.getShaderPrecisionFormat = function() {
        return { "rangeMin": 1, "rangeMax": 1, "precision": 1 };
      };
    }
  } catch (error) {
    console.error("THREE.WebGLRenderer: " + error.message);
    throw error;
  }
  let extensions, capabilities, state, info;
  let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
  let programCache, materials, renderLists, renderStates, clipping, shadowMap;
  let background, morphtargets, bufferRenderer, indexedBufferRenderer;
  let utils2, bindingStates;
  function initGLContext() {
    extensions = new WebGLExtensions(_gl);
    capabilities = new WebGLCapabilities(_gl, extensions, parameters);
    extensions.init(capabilities);
    utils2 = new WebGLUtils(_gl, extensions, capabilities);
    state = new WebGLState(_gl, extensions, capabilities);
    _currentDrawBuffers[0] = 1029;
    info = new WebGLInfo();
    properties = new WebGLProperties();
    textures = new WebGLTextures(_gl, extensions, state, properties, capabilities, utils2, info);
    cubemaps = new WebGLCubeMaps(_this);
    cubeuvmaps = new WebGLCubeUVMaps(_this);
    attributes = new WebGLAttributes(_gl, capabilities);
    bindingStates = new WebGLBindingStates(_gl, extensions, attributes, capabilities);
    geometries = new WebGLGeometries(_gl, attributes, info, bindingStates);
    objects = new WebGLObjects(_gl, geometries, attributes, info);
    morphtargets = new WebGLMorphtargets(_gl);
    clipping = new WebGLClipping(properties);
    programCache = new WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
    materials = new WebGLMaterials(properties);
    renderLists = new WebGLRenderLists(properties);
    renderStates = new WebGLRenderStates(extensions, capabilities);
    background = new WebGLBackground(_this, cubemaps, state, objects, _premultipliedAlpha);
    shadowMap = new WebGLShadowMap(_this, objects, capabilities);
    bufferRenderer = new WebGLBufferRenderer(_gl, extensions, info, capabilities);
    indexedBufferRenderer = new WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
    info.programs = programCache.programs;
    _this.capabilities = capabilities;
    _this.extensions = extensions;
    _this.properties = properties;
    _this.renderLists = renderLists;
    _this.shadowMap = shadowMap;
    _this.state = state;
    _this.info = info;
  }
  initGLContext();
  const xr = new WebXRManager2(_this, _gl);
  this.xr = xr;
  this.getContext = function() {
    return _gl;
  };
  this.getContextAttributes = function() {
    return _gl.getContextAttributes();
  };
  this.forceContextLoss = function() {
    const extension = extensions.get("WEBGL_lose_context");
    if (extension) extension.loseContext();
  };
  this.forceContextRestore = function() {
    const extension = extensions.get("WEBGL_lose_context");
    if (extension) extension.restoreContext();
  };
  this.getPixelRatio = function() {
    return _pixelRatio;
  };
  this.setPixelRatio = function(value) {
    if (value === void 0) return;
    _pixelRatio = value;
    this.setSize(_width, _height, false);
  };
  this.getSize = function(target) {
    return target.set(_width, _height);
  };
  this.setSize = function(width, height, updateStyle) {
    if (xr.isPresenting) {
      console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
      return;
    }
    _width = width;
    _height = height;
    _canvas2.width = Math.floor(width * _pixelRatio);
    _canvas2.height = Math.floor(height * _pixelRatio);
    if (updateStyle !== false) {
      _canvas2.style.width = width + "px";
      _canvas2.style.height = height + "px";
    }
    this.setViewport(0, 0, width, height);
  };
  this.getDrawingBufferSize = function(target) {
    return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
  };
  this.setDrawingBufferSize = function(width, height, pixelRatio) {
    _width = width;
    _height = height;
    _pixelRatio = pixelRatio;
    _canvas2.width = Math.floor(width * pixelRatio);
    _canvas2.height = Math.floor(height * pixelRatio);
    this.setViewport(0, 0, width, height);
  };
  this.getCurrentViewport = function(target) {
    return target.copy(_currentViewport);
  };
  this.getViewport = function(target) {
    return target.copy(_viewport2);
  };
  this.setViewport = function(x, y, width, height) {
    if (x.isVector4) {
      _viewport2.set(x.x, x.y, x.z, x.w);
    } else {
      _viewport2.set(x, y, width, height);
    }
    state.viewport(_currentViewport.copy(_viewport2).multiplyScalar(_pixelRatio).floor());
  };
  this.getScissor = function(target) {
    return target.copy(_scissor);
  };
  this.setScissor = function(x, y, width, height) {
    if (x.isVector4) {
      _scissor.set(x.x, x.y, x.z, x.w);
    } else {
      _scissor.set(x, y, width, height);
    }
    state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
  };
  this.getScissorTest = function() {
    return _scissorTest;
  };
  this.setScissorTest = function(boolean) {
    state.setScissorTest(_scissorTest = boolean);
  };
  this.setOpaqueSort = function(method) {
    _opaqueSort = method;
  };
  this.setTransparentSort = function(method) {
    _transparentSort = method;
  };
  this.getClearColor = function(target) {
    return target.copy(background.getClearColor());
  };
  this.setClearColor = function() {
    background.setClearColor.apply(background, arguments);
  };
  this.getClearAlpha = function() {
    return background.getClearAlpha();
  };
  this.setClearAlpha = function() {
    background.setClearAlpha.apply(background, arguments);
  };
  this.clear = function(color2, depth, stencil) {
    let bits2 = 0;
    if (color2 === void 0 || color2) bits2 |= 16384;
    if (depth === void 0 || depth) bits2 |= 256;
    if (stencil === void 0 || stencil) bits2 |= 1024;
    _gl.clear(bits2);
  };
  this.clearColor = function() {
    this.clear(true, false, false);
  };
  this.clearDepth = function() {
    this.clear(false, true, false);
  };
  this.clearStencil = function() {
    this.clear(false, false, true);
  };
  this.dispose = function() {
    _canvas2.removeEventListener("webglcontextlost", onContextLost, false);
    _canvas2.removeEventListener("webglcontextrestored", onContextRestore, false);
    renderLists.dispose();
    renderStates.dispose();
    properties.dispose();
    cubemaps.dispose();
    cubeuvmaps.dispose();
    objects.dispose();
    bindingStates.dispose();
    xr.dispose();
    xr.removeEventListener("sessionstart", onXRSessionStart);
    xr.removeEventListener("sessionend", onXRSessionEnd);
    if (_transmissionRenderTarget) {
      _transmissionRenderTarget.dispose();
      _transmissionRenderTarget = null;
    }
    animation.stop();
  };
  function onContextLost(event) {
    event.preventDefault();
    console.log("THREE.WebGLRenderer: Context Lost.");
    _isContextLost = true;
  }
  function onContextRestore() {
    console.log("THREE.WebGLRenderer: Context Restored.");
    _isContextLost = false;
    const infoAutoReset = info.autoReset;
    const shadowMapEnabled = shadowMap.enabled;
    const shadowMapAutoUpdate = shadowMap.autoUpdate;
    const shadowMapNeedsUpdate = shadowMap.needsUpdate;
    const shadowMapType = shadowMap.type;
    initGLContext();
    info.autoReset = infoAutoReset;
    shadowMap.enabled = shadowMapEnabled;
    shadowMap.autoUpdate = shadowMapAutoUpdate;
    shadowMap.needsUpdate = shadowMapNeedsUpdate;
    shadowMap.type = shadowMapType;
  }
  function onMaterialDispose(event) {
    const material = event.target;
    material.removeEventListener("dispose", onMaterialDispose);
    deallocateMaterial(material);
  }
  function deallocateMaterial(material) {
    releaseMaterialProgramReferences(material);
    properties.remove(material);
  }
  function releaseMaterialProgramReferences(material) {
    const programs = properties.get(material).programs;
    if (programs !== void 0) {
      programs.forEach(function(program) {
        programCache.releaseProgram(program);
      });
    }
  }
  function renderObjectImmediate(object, program) {
    object.render(function(object2) {
      _this.renderBufferImmediate(object2, program);
    });
  }
  this.renderBufferImmediate = function(object, program) {
    bindingStates.initAttributes();
    const buffers = properties.get(object);
    if (object.hasPositions && !buffers.position) buffers.position = _gl.createBuffer();
    if (object.hasNormals && !buffers.normal) buffers.normal = _gl.createBuffer();
    if (object.hasUvs && !buffers.uv) buffers.uv = _gl.createBuffer();
    if (object.hasColors && !buffers.color) buffers.color = _gl.createBuffer();
    const programAttributes = program.getAttributes();
    if (object.hasPositions) {
      _gl.bindBuffer(34962, buffers.position);
      _gl.bufferData(34962, object.positionArray, 35048);
      bindingStates.enableAttribute(programAttributes.position.location);
      _gl.vertexAttribPointer(programAttributes.position.location, 3, 5126, false, 0, 0);
    }
    if (object.hasNormals) {
      _gl.bindBuffer(34962, buffers.normal);
      _gl.bufferData(34962, object.normalArray, 35048);
      bindingStates.enableAttribute(programAttributes.normal.location);
      _gl.vertexAttribPointer(programAttributes.normal.location, 3, 5126, false, 0, 0);
    }
    if (object.hasUvs) {
      _gl.bindBuffer(34962, buffers.uv);
      _gl.bufferData(34962, object.uvArray, 35048);
      bindingStates.enableAttribute(programAttributes.uv.location);
      _gl.vertexAttribPointer(programAttributes.uv.location, 2, 5126, false, 0, 0);
    }
    if (object.hasColors) {
      _gl.bindBuffer(34962, buffers.color);
      _gl.bufferData(34962, object.colorArray, 35048);
      bindingStates.enableAttribute(programAttributes.color.location);
      _gl.vertexAttribPointer(programAttributes.color.location, 3, 5126, false, 0, 0);
    }
    bindingStates.disableUnusedAttributes();
    _gl.drawArrays(4, 0, object.count);
    object.count = 0;
  };
  this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
    if (scene === null) scene = _emptyScene;
    const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
    const program = setProgram(camera, scene, material, object);
    state.setMaterial(material, frontFaceCW);
    let index2 = geometry.index;
    const position2 = geometry.attributes.position;
    if (index2 === null) {
      if (position2 === void 0 || position2.count === 0) return;
    } else if (index2.count === 0) {
      return;
    }
    let rangeFactor = 1;
    if (material.wireframe === true) {
      index2 = geometries.getWireframeAttribute(geometry);
      rangeFactor = 2;
    }
    if (geometry.morphAttributes.position !== void 0 || geometry.morphAttributes.normal !== void 0) {
      morphtargets.update(object, geometry, material, program);
    }
    bindingStates.setup(object, material, program, geometry, index2);
    let attribute;
    let renderer = bufferRenderer;
    if (index2 !== null) {
      attribute = attributes.get(index2);
      renderer = indexedBufferRenderer;
      renderer.setIndex(attribute);
    }
    const dataCount = index2 !== null ? index2.count : position2.count;
    const rangeStart = geometry.drawRange.start * rangeFactor;
    const rangeCount = geometry.drawRange.count * rangeFactor;
    const groupStart = group !== null ? group.start * rangeFactor : 0;
    const groupCount = group !== null ? group.count * rangeFactor : Infinity;
    const drawStart = Math.max(rangeStart, groupStart);
    const drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
    const drawCount = Math.max(0, drawEnd - drawStart + 1);
    if (drawCount === 0) return;
    if (object.isMesh) {
      if (material.wireframe === true) {
        state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
        renderer.setMode(1);
      } else {
        renderer.setMode(4);
      }
    } else if (object.isLine) {
      let lineWidth = material.linewidth;
      if (lineWidth === void 0) lineWidth = 1;
      state.setLineWidth(lineWidth * getTargetPixelRatio());
      if (object.isLineSegments) {
        renderer.setMode(1);
      } else if (object.isLineLoop) {
        renderer.setMode(2);
      } else {
        renderer.setMode(3);
      }
    } else if (object.isPoints) {
      renderer.setMode(0);
    } else if (object.isSprite) {
      renderer.setMode(4);
    }
    if (object.isInstancedMesh) {
      renderer.renderInstances(drawStart, drawCount, object.count);
    } else if (geometry.isInstancedBufferGeometry) {
      const instanceCount = Math.min(geometry.instanceCount, geometry._maxInstanceCount);
      renderer.renderInstances(drawStart, drawCount, instanceCount);
    } else {
      renderer.render(drawStart, drawCount);
    }
  };
  this.compile = function(scene, camera) {
    currentRenderState = renderStates.get(scene);
    currentRenderState.init();
    renderStateStack.push(currentRenderState);
    scene.traverseVisible(function(object) {
      if (object.isLight && object.layers.test(camera.layers)) {
        currentRenderState.pushLight(object);
        if (object.castShadow) {
          currentRenderState.pushShadow(object);
        }
      }
    });
    currentRenderState.setupLights(_this.physicallyCorrectLights);
    scene.traverse(function(object) {
      const material = object.material;
      if (material) {
        if (Array.isArray(material)) {
          for (let i2 = 0; i2 < material.length; i2++) {
            const material2 = material[i2];
            getProgram(material2, scene, object);
          }
        } else {
          getProgram(material, scene, object);
        }
      }
    });
    renderStateStack.pop();
    currentRenderState = null;
  };
  let onAnimationFrameCallback = null;
  function onAnimationFrame(time2) {
    if (onAnimationFrameCallback) onAnimationFrameCallback(time2);
  }
  function onXRSessionStart() {
    animation.stop();
  }
  function onXRSessionEnd() {
    animation.start();
  }
  const animation = new WebGLAnimation();
  animation.setAnimationLoop(onAnimationFrame);
  if (typeof window !== "undefined") animation.setContext(window);
  this.setAnimationLoop = function(callback) {
    onAnimationFrameCallback = callback;
    xr.setAnimationLoop(callback);
    callback === null ? animation.stop() : animation.start();
  };
  xr.addEventListener("sessionstart", onXRSessionStart);
  xr.addEventListener("sessionend", onXRSessionEnd);
  this.render = function(scene, camera) {
    if (camera !== void 0 && camera.isCamera !== true) {
      console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
      return;
    }
    if (_isContextLost === true) return;
    if (scene.autoUpdate === true) scene.updateMatrixWorld();
    if (camera.parent === null) camera.updateMatrixWorld();
    if (xr.enabled === true && xr.isPresenting === true) {
      if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
      camera = xr.getCamera();
    }
    if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
    currentRenderState = renderStates.get(scene, renderStateStack.length);
    currentRenderState.init();
    renderStateStack.push(currentRenderState);
    _projScreenMatrix2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
    _frustum2.setFromProjectionMatrix(_projScreenMatrix2);
    _localClippingEnabled = this.localClippingEnabled;
    _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
    currentRenderList = renderLists.get(scene, renderListStack.length);
    currentRenderList.init();
    renderListStack.push(currentRenderList);
    projectObject(scene, camera, 0, _this.sortObjects);
    currentRenderList.finish();
    if (_this.sortObjects === true) {
      currentRenderList.sort(_opaqueSort, _transparentSort);
    }
    if (_clippingEnabled === true) clipping.beginShadows();
    const shadowsArray = currentRenderState.state.shadowsArray;
    shadowMap.render(shadowsArray, scene, camera);
    if (_clippingEnabled === true) clipping.endShadows();
    if (this.info.autoReset === true) this.info.reset();
    background.render(currentRenderList, scene);
    currentRenderState.setupLights(_this.physicallyCorrectLights);
    if (camera.isArrayCamera) {
      const cameras = camera.cameras;
      for (let i2 = 0, l2 = cameras.length; i2 < l2; i2++) {
        const camera2 = cameras[i2];
        renderScene(currentRenderList, scene, camera2, camera2.viewport);
      }
    } else {
      renderScene(currentRenderList, scene, camera);
    }
    if (_currentRenderTarget !== null) {
      textures.updateMultisampleRenderTarget(_currentRenderTarget);
      textures.updateRenderTargetMipmap(_currentRenderTarget);
    }
    if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
    state.buffers.depth.setTest(true);
    state.buffers.depth.setMask(true);
    state.buffers.color.setMask(true);
    state.setPolygonOffset(false);
    bindingStates.resetDefaultState();
    _currentMaterialId = -1;
    _currentCamera = null;
    renderStateStack.pop();
    if (renderStateStack.length > 0) {
      currentRenderState = renderStateStack[renderStateStack.length - 1];
    } else {
      currentRenderState = null;
    }
    renderListStack.pop();
    if (renderListStack.length > 0) {
      currentRenderList = renderListStack[renderListStack.length - 1];
    } else {
      currentRenderList = null;
    }
  };
  function projectObject(object, camera, groupOrder, sortObjects) {
    if (object.visible === false) return;
    const visible = object.layers.test(camera.layers);
    if (visible) {
      if (object.isGroup) {
        groupOrder = object.renderOrder;
      } else if (object.isLOD) {
        if (object.autoUpdate === true) object.update(camera);
      } else if (object.isLight) {
        currentRenderState.pushLight(object);
        if (object.castShadow) {
          currentRenderState.pushShadow(object);
        }
      } else if (object.isSprite) {
        if (!object.frustumCulled || _frustum2.intersectsSprite(object)) {
          if (sortObjects) {
            _vector32.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
          }
          const geometry = objects.update(object);
          const material = object.material;
          if (material.visible) {
            currentRenderList.push(object, geometry, material, groupOrder, _vector32.z, null);
          }
        }
      } else if (object.isImmediateRenderObject) {
        if (sortObjects) {
          _vector32.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
        }
        currentRenderList.push(object, null, object.material, groupOrder, _vector32.z, null);
      } else if (object.isMesh || object.isLine || object.isPoints) {
        if (object.isSkinnedMesh) {
          if (object.skeleton.frame !== info.render.frame) {
            object.skeleton.update();
            object.skeleton.frame = info.render.frame;
          }
        }
        if (!object.frustumCulled || _frustum2.intersectsObject(object)) {
          if (sortObjects) {
            _vector32.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
          }
          const geometry = objects.update(object);
          const material = object.material;
          if (Array.isArray(material)) {
            const groups = geometry.groups;
            for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
              const group = groups[i2];
              const groupMaterial = material[group.materialIndex];
              if (groupMaterial && groupMaterial.visible) {
                currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector32.z, group);
              }
            }
          } else if (material.visible) {
            currentRenderList.push(object, geometry, material, groupOrder, _vector32.z, null);
          }
        }
      }
    }
    const children = object.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      projectObject(children[i2], camera, groupOrder, sortObjects);
    }
  }
  function renderScene(currentRenderList2, scene, camera, viewport) {
    const opaqueObjects = currentRenderList2.opaque;
    const transmissiveObjects = currentRenderList2.transmissive;
    const transparentObjects = currentRenderList2.transparent;
    currentRenderState.setupLightsView(camera);
    if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, scene, camera);
    if (viewport) state.viewport(_currentViewport.copy(viewport));
    if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
    if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
    if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
  }
  function renderTransmissionPass(opaqueObjects, scene, camera) {
    if (_transmissionRenderTarget === null) {
      const needsAntialias = _antialias === true && capabilities.isWebGL2 === true;
      const renderTargetType = needsAntialias ? WebGLMultisampleRenderTarget : WebGLRenderTarget2;
      _transmissionRenderTarget = new renderTargetType(1024, 1024, {
        generateMipmaps: true,
        type: utils2.convert(HalfFloatType) !== null ? HalfFloatType : UnsignedByteType,
        minFilter: LinearMipmapLinearFilter,
        magFilter: NearestFilter,
        wrapS: ClampToEdgeWrapping,
        wrapT: ClampToEdgeWrapping
      });
    }
    const currentRenderTarget = _this.getRenderTarget();
    _this.setRenderTarget(_transmissionRenderTarget);
    _this.clear();
    const currentToneMapping = _this.toneMapping;
    _this.toneMapping = NoToneMapping;
    renderObjects(opaqueObjects, scene, camera);
    _this.toneMapping = currentToneMapping;
    textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
    textures.updateRenderTargetMipmap(_transmissionRenderTarget);
    _this.setRenderTarget(currentRenderTarget);
  }
  function renderObjects(renderList, scene, camera) {
    const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
    for (let i2 = 0, l2 = renderList.length; i2 < l2; i2++) {
      const renderItem = renderList[i2];
      const object = renderItem.object;
      const geometry = renderItem.geometry;
      const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
      const group = renderItem.group;
      if (object.layers.test(camera.layers)) {
        renderObject(object, scene, camera, geometry, material, group);
      }
    }
  }
  function renderObject(object, scene, camera, geometry, material, group) {
    object.onBeforeRender(_this, scene, camera, geometry, material, group);
    object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
    object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
    if (object.isImmediateRenderObject) {
      const program = setProgram(camera, scene, material, object);
      state.setMaterial(material);
      bindingStates.reset();
      renderObjectImmediate(object, program);
    } else {
      if (material.transparent === true && material.side === DoubleSide) {
        material.side = BackSide;
        material.needsUpdate = true;
        _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        material.side = FrontSide;
        material.needsUpdate = true;
        _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        material.side = DoubleSide;
      } else {
        _this.renderBufferDirect(camera, scene, geometry, material, object, group);
      }
    }
    object.onAfterRender(_this, scene, camera, geometry, material, group);
  }
  function getProgram(material, scene, object) {
    if (scene.isScene !== true) scene = _emptyScene;
    const materialProperties = properties.get(material);
    const lights = currentRenderState.state.lights;
    const shadowsArray = currentRenderState.state.shadowsArray;
    const lightsStateVersion = lights.state.version;
    const parameters2 = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
    const programCacheKey = programCache.getProgramCacheKey(parameters2);
    let programs = materialProperties.programs;
    materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
    materialProperties.fog = scene.fog;
    materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
    if (programs === void 0) {
      material.addEventListener("dispose", onMaterialDispose);
      programs = /* @__PURE__ */ new Map();
      materialProperties.programs = programs;
    }
    let program = programs.get(programCacheKey);
    if (program !== void 0) {
      if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
        updateCommonMaterialProperties(material, parameters2);
        return program;
      }
    } else {
      parameters2.uniforms = programCache.getUniforms(material);
      material.onBuild(parameters2, _this);
      material.onBeforeCompile(parameters2, _this);
      program = programCache.acquireProgram(parameters2, programCacheKey);
      programs.set(programCacheKey, program);
      materialProperties.uniforms = parameters2.uniforms;
    }
    const uniforms = materialProperties.uniforms;
    if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) {
      uniforms.clippingPlanes = clipping.uniform;
    }
    updateCommonMaterialProperties(material, parameters2);
    materialProperties.needsLights = materialNeedsLights(material);
    materialProperties.lightsStateVersion = lightsStateVersion;
    if (materialProperties.needsLights) {
      uniforms.ambientLightColor.value = lights.state.ambient;
      uniforms.lightProbe.value = lights.state.probe;
      uniforms.directionalLights.value = lights.state.directional;
      uniforms.directionalLightShadows.value = lights.state.directionalShadow;
      uniforms.spotLights.value = lights.state.spot;
      uniforms.spotLightShadows.value = lights.state.spotShadow;
      uniforms.rectAreaLights.value = lights.state.rectArea;
      uniforms.ltc_1.value = lights.state.rectAreaLTC1;
      uniforms.ltc_2.value = lights.state.rectAreaLTC2;
      uniforms.pointLights.value = lights.state.point;
      uniforms.pointLightShadows.value = lights.state.pointShadow;
      uniforms.hemisphereLights.value = lights.state.hemi;
      uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
      uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
      uniforms.spotShadowMap.value = lights.state.spotShadowMap;
      uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
      uniforms.pointShadowMap.value = lights.state.pointShadowMap;
      uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
    }
    const progUniforms = program.getUniforms();
    const uniformsList = WebGLUniforms2.seqWithValue(progUniforms.seq, uniforms);
    materialProperties.currentProgram = program;
    materialProperties.uniformsList = uniformsList;
    return program;
  }
  function updateCommonMaterialProperties(material, parameters2) {
    const materialProperties = properties.get(material);
    materialProperties.outputEncoding = parameters2.outputEncoding;
    materialProperties.instancing = parameters2.instancing;
    materialProperties.skinning = parameters2.skinning;
    materialProperties.morphTargets = parameters2.morphTargets;
    materialProperties.morphNormals = parameters2.morphNormals;
    materialProperties.numClippingPlanes = parameters2.numClippingPlanes;
    materialProperties.numIntersection = parameters2.numClipIntersection;
    materialProperties.vertexAlphas = parameters2.vertexAlphas;
    materialProperties.vertexTangents = parameters2.vertexTangents;
  }
  function setProgram(camera, scene, material, object) {
    if (scene.isScene !== true) scene = _emptyScene;
    textures.resetTextureUnits();
    const fog = scene.fog;
    const environment = material.isMeshStandardMaterial ? scene.environment : null;
    const encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.texture.encoding;
    const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
    const vertexAlphas = material.vertexColors === true && !!object.geometry && !!object.geometry.attributes.color && object.geometry.attributes.color.itemSize === 4;
    const vertexTangents = !!object.geometry && !!object.geometry.attributes.tangent;
    const morphTargets = !!object.geometry && !!object.geometry.morphAttributes.position;
    const morphNormals = !!object.geometry && !!object.geometry.morphAttributes.normal;
    const materialProperties = properties.get(material);
    const lights = currentRenderState.state.lights;
    if (_clippingEnabled === true) {
      if (_localClippingEnabled === true || camera !== _currentCamera) {
        const useCache = camera === _currentCamera && material.id === _currentMaterialId;
        clipping.setState(material, camera, useCache);
      }
    }
    let needsProgramChange = false;
    if (material.version === materialProperties.__version) {
      if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) {
        needsProgramChange = true;
      } else if (materialProperties.outputEncoding !== encoding) {
        needsProgramChange = true;
      } else if (object.isInstancedMesh && materialProperties.instancing === false) {
        needsProgramChange = true;
      } else if (!object.isInstancedMesh && materialProperties.instancing === true) {
        needsProgramChange = true;
      } else if (object.isSkinnedMesh && materialProperties.skinning === false) {
        needsProgramChange = true;
      } else if (!object.isSkinnedMesh && materialProperties.skinning === true) {
        needsProgramChange = true;
      } else if (materialProperties.envMap !== envMap) {
        needsProgramChange = true;
      } else if (material.fog && materialProperties.fog !== fog) {
        needsProgramChange = true;
      } else if (materialProperties.numClippingPlanes !== void 0 && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) {
        needsProgramChange = true;
      } else if (materialProperties.vertexAlphas !== vertexAlphas) {
        needsProgramChange = true;
      } else if (materialProperties.vertexTangents !== vertexTangents) {
        needsProgramChange = true;
      } else if (materialProperties.morphTargets !== morphTargets) {
        needsProgramChange = true;
      } else if (materialProperties.morphNormals !== morphNormals) {
        needsProgramChange = true;
      }
    } else {
      needsProgramChange = true;
      materialProperties.__version = material.version;
    }
    let program = materialProperties.currentProgram;
    if (needsProgramChange === true) {
      program = getProgram(material, scene, object);
    }
    let refreshProgram = false;
    let refreshMaterial = false;
    let refreshLights = false;
    const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
    if (state.useProgram(program.program)) {
      refreshProgram = true;
      refreshMaterial = true;
      refreshLights = true;
    }
    if (material.id !== _currentMaterialId) {
      _currentMaterialId = material.id;
      refreshMaterial = true;
    }
    if (refreshProgram || _currentCamera !== camera) {
      p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
      if (capabilities.logarithmicDepthBuffer) {
        p_uniforms.setValue(
          _gl,
          "logDepthBufFC",
          2 / (Math.log(camera.far + 1) / Math.LN2)
        );
      }
      if (_currentCamera !== camera) {
        _currentCamera = camera;
        refreshMaterial = true;
        refreshLights = true;
      }
      if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
        const uCamPos = p_uniforms.map.cameraPosition;
        if (uCamPos !== void 0) {
          uCamPos.setValue(
            _gl,
            _vector32.setFromMatrixPosition(camera.matrixWorld)
          );
        }
      }
      if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) {
        p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
      }
      if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) {
        p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
      }
    }
    if (object.isSkinnedMesh) {
      p_uniforms.setOptional(_gl, object, "bindMatrix");
      p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
      const skeleton = object.skeleton;
      if (skeleton) {
        if (capabilities.floatVertexTextures) {
          if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
          p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
          p_uniforms.setValue(_gl, "boneTextureSize", skeleton.boneTextureSize);
        } else {
          p_uniforms.setOptional(_gl, skeleton, "boneMatrices");
        }
      }
    }
    if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
      materialProperties.receiveShadow = object.receiveShadow;
      p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
    }
    if (refreshMaterial) {
      p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
      if (materialProperties.needsLights) {
        markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
      }
      if (fog && material.fog) {
        materials.refreshFogUniforms(m_uniforms, fog);
      }
      materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
      WebGLUniforms2.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
    }
    if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
      WebGLUniforms2.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
      material.uniformsNeedUpdate = false;
    }
    if (material.isSpriteMaterial) {
      p_uniforms.setValue(_gl, "center", object.center);
    }
    p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
    p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
    p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
    return program;
  }
  function markUniformsLightsNeedsUpdate(uniforms, value) {
    uniforms.ambientLightColor.needsUpdate = value;
    uniforms.lightProbe.needsUpdate = value;
    uniforms.directionalLights.needsUpdate = value;
    uniforms.directionalLightShadows.needsUpdate = value;
    uniforms.pointLights.needsUpdate = value;
    uniforms.pointLightShadows.needsUpdate = value;
    uniforms.spotLights.needsUpdate = value;
    uniforms.spotLightShadows.needsUpdate = value;
    uniforms.rectAreaLights.needsUpdate = value;
    uniforms.hemisphereLights.needsUpdate = value;
  }
  function materialNeedsLights(material) {
    return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
  }
  this.getActiveCubeFace = function() {
    return _currentActiveCubeFace;
  };
  this.getActiveMipmapLevel = function() {
    return _currentActiveMipmapLevel;
  };
  this.getRenderTarget = function() {
    return _currentRenderTarget;
  };
  this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
    _currentRenderTarget = renderTarget;
    _currentActiveCubeFace = activeCubeFace;
    _currentActiveMipmapLevel = activeMipmapLevel;
    if (renderTarget && properties.get(renderTarget).__webglFramebuffer === void 0) {
      textures.setupRenderTarget(renderTarget);
    }
    let framebuffer = null;
    let isCube = false;
    let isRenderTarget3D = false;
    if (renderTarget) {
      const texture = renderTarget.texture;
      if (texture.isDataTexture3D || texture.isDataTexture2DArray) {
        isRenderTarget3D = true;
      }
      const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
      if (renderTarget.isWebGLCubeRenderTarget) {
        framebuffer = __webglFramebuffer[activeCubeFace];
        isCube = true;
      } else if (renderTarget.isWebGLMultisampleRenderTarget) {
        framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
      } else {
        framebuffer = __webglFramebuffer;
      }
      _currentViewport.copy(renderTarget.viewport);
      _currentScissor.copy(renderTarget.scissor);
      _currentScissorTest = renderTarget.scissorTest;
    } else {
      _currentViewport.copy(_viewport2).multiplyScalar(_pixelRatio).floor();
      _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
      _currentScissorTest = _scissorTest;
    }
    const framebufferBound = state.bindFramebuffer(36160, framebuffer);
    if (framebufferBound && capabilities.drawBuffers) {
      let needsUpdate = false;
      if (renderTarget) {
        if (renderTarget.isWebGLMultipleRenderTargets) {
          const textures2 = renderTarget.texture;
          if (_currentDrawBuffers.length !== textures2.length || _currentDrawBuffers[0] !== 36064) {
            for (let i2 = 0, il = textures2.length; i2 < il; i2++) {
              _currentDrawBuffers[i2] = 36064 + i2;
            }
            _currentDrawBuffers.length = textures2.length;
            needsUpdate = true;
          }
        } else {
          if (_currentDrawBuffers.length !== 1 || _currentDrawBuffers[0] !== 36064) {
            _currentDrawBuffers[0] = 36064;
            _currentDrawBuffers.length = 1;
            needsUpdate = true;
          }
        }
      } else {
        if (_currentDrawBuffers.length !== 1 || _currentDrawBuffers[0] !== 1029) {
          _currentDrawBuffers[0] = 1029;
          _currentDrawBuffers.length = 1;
          needsUpdate = true;
        }
      }
      if (needsUpdate) {
        if (capabilities.isWebGL2) {
          _gl.drawBuffers(_currentDrawBuffers);
        } else {
          extensions.get("WEBGL_draw_buffers").drawBuffersWEBGL(_currentDrawBuffers);
        }
      }
    }
    state.viewport(_currentViewport);
    state.scissor(_currentScissor);
    state.setScissorTest(_currentScissorTest);
    if (isCube) {
      const textureProperties = properties.get(renderTarget.texture);
      _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
    } else if (isRenderTarget3D) {
      const textureProperties = properties.get(renderTarget.texture);
      const layer = activeCubeFace || 0;
      _gl.framebufferTextureLayer(36160, 36064, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
    }
    _currentMaterialId = -1;
  };
  this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
    if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
      console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
      return;
    }
    let framebuffer = properties.get(renderTarget).__webglFramebuffer;
    if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== void 0) {
      framebuffer = framebuffer[activeCubeFaceIndex];
    }
    if (framebuffer) {
      state.bindFramebuffer(36160, framebuffer);
      try {
        const texture = renderTarget.texture;
        const textureFormat = texture.format;
        const textureType = texture.type;
        if (textureFormat !== RGBAFormat && utils2.convert(textureFormat) !== _gl.getParameter(35739)) {
          console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
          return;
        }
        const halfFloatSupportedByExt = textureType === HalfFloatType && (extensions.has("EXT_color_buffer_half_float") || capabilities.isWebGL2 && extensions.has("EXT_color_buffer_float"));
        if (textureType !== UnsignedByteType && utils2.convert(textureType) !== _gl.getParameter(35738) && // Edge and Chrome Mac < 52 (#9513)
        !(textureType === FloatType && (capabilities.isWebGL2 || extensions.has("OES_texture_float") || extensions.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
        !halfFloatSupportedByExt) {
          console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
          return;
        }
        if (_gl.checkFramebufferStatus(36160) === 36053) {
          if (x >= 0 && x <= renderTarget.width - width && (y >= 0 && y <= renderTarget.height - height)) {
            _gl.readPixels(x, y, width, height, utils2.convert(textureFormat), utils2.convert(textureType), buffer);
          }
        } else {
          console.error("THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.");
        }
      } finally {
        const framebuffer2 = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
        state.bindFramebuffer(36160, framebuffer2);
      }
    }
  };
  this.copyFramebufferToTexture = function(position2, texture, level = 0) {
    const levelScale = Math.pow(2, -level);
    const width = Math.floor(texture.image.width * levelScale);
    const height = Math.floor(texture.image.height * levelScale);
    let glFormat = utils2.convert(texture.format);
    if (capabilities.isWebGL2) {
      if (glFormat === 6407) glFormat = 32849;
      if (glFormat === 6408) glFormat = 32856;
    }
    textures.setTexture2D(texture, 0);
    _gl.copyTexImage2D(3553, level, glFormat, position2.x, position2.y, width, height, 0);
    state.unbindTexture();
  };
  this.copyTextureToTexture = function(position2, srcTexture, dstTexture, level = 0) {
    const width = srcTexture.image.width;
    const height = srcTexture.image.height;
    const glFormat = utils2.convert(dstTexture.format);
    const glType = utils2.convert(dstTexture.type);
    textures.setTexture2D(dstTexture, 0);
    _gl.pixelStorei(37440, dstTexture.flipY);
    _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
    _gl.pixelStorei(3317, dstTexture.unpackAlignment);
    if (srcTexture.isDataTexture) {
      _gl.texSubImage2D(3553, level, position2.x, position2.y, width, height, glFormat, glType, srcTexture.image.data);
    } else {
      if (srcTexture.isCompressedTexture) {
        _gl.compressedTexSubImage2D(3553, level, position2.x, position2.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
      } else {
        _gl.texSubImage2D(3553, level, position2.x, position2.y, glFormat, glType, srcTexture.image);
      }
    }
    if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
    state.unbindTexture();
  };
  this.copyTextureToTexture3D = function(sourceBox, position2, srcTexture, dstTexture, level = 0) {
    if (_this.isWebGL1Renderer) {
      console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
      return;
    }
    const width = sourceBox.max.x - sourceBox.min.x + 1;
    const height = sourceBox.max.y - sourceBox.min.y + 1;
    const depth = sourceBox.max.z - sourceBox.min.z + 1;
    const glFormat = utils2.convert(dstTexture.format);
    const glType = utils2.convert(dstTexture.type);
    let glTarget;
    if (dstTexture.isDataTexture3D) {
      textures.setTexture3D(dstTexture, 0);
      glTarget = 32879;
    } else if (dstTexture.isDataTexture2DArray) {
      textures.setTexture2DArray(dstTexture, 0);
      glTarget = 35866;
    } else {
      console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
      return;
    }
    _gl.pixelStorei(37440, dstTexture.flipY);
    _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
    _gl.pixelStorei(3317, dstTexture.unpackAlignment);
    const unpackRowLen = _gl.getParameter(3314);
    const unpackImageHeight = _gl.getParameter(32878);
    const unpackSkipPixels = _gl.getParameter(3316);
    const unpackSkipRows = _gl.getParameter(3315);
    const unpackSkipImages = _gl.getParameter(32877);
    const image2 = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
    _gl.pixelStorei(3314, image2.width);
    _gl.pixelStorei(32878, image2.height);
    _gl.pixelStorei(3316, sourceBox.min.x);
    _gl.pixelStorei(3315, sourceBox.min.y);
    _gl.pixelStorei(32877, sourceBox.min.z);
    if (srcTexture.isDataTexture || srcTexture.isDataTexture3D) {
      _gl.texSubImage3D(glTarget, level, position2.x, position2.y, position2.z, width, height, depth, glFormat, glType, image2.data);
    } else {
      if (srcTexture.isCompressedTexture) {
        console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.");
        _gl.compressedTexSubImage3D(glTarget, level, position2.x, position2.y, position2.z, width, height, depth, glFormat, image2.data);
      } else {
        _gl.texSubImage3D(glTarget, level, position2.x, position2.y, position2.z, width, height, depth, glFormat, glType, image2);
      }
    }
    _gl.pixelStorei(3314, unpackRowLen);
    _gl.pixelStorei(32878, unpackImageHeight);
    _gl.pixelStorei(3316, unpackSkipPixels);
    _gl.pixelStorei(3315, unpackSkipRows);
    _gl.pixelStorei(32877, unpackSkipImages);
    if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
    state.unbindTexture();
  };
  this.initTexture = function(texture) {
    textures.setTexture2D(texture, 0);
    state.unbindTexture();
  };
  this.resetState = function() {
    _currentActiveCubeFace = 0;
    _currentActiveMipmapLevel = 0;
    _currentRenderTarget = null;
    state.reset();
    bindingStates.reset();
  };
  if (typeof __THREE_DEVTOOLS__ !== "undefined") {
    __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
}
class WebGL1Renderer extends WebGLRenderer2 {
}
WebGL1Renderer.prototype.isWebGL1Renderer = true;
class Scene2 extends Object3D2 {
  constructor() {
    super();
    this.type = "Scene";
    this.background = null;
    this.environment = null;
    this.fog = null;
    this.overrideMaterial = null;
    this.autoUpdate = true;
    if (typeof __THREE_DEVTOOLS__ !== "undefined") {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
    }
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    if (source.background !== null) this.background = source.background.clone();
    if (source.environment !== null) this.environment = source.environment.clone();
    if (source.fog !== null) this.fog = source.fog.clone();
    if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
    this.autoUpdate = source.autoUpdate;
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    if (this.fog !== null) data.object.fog = this.fog.toJSON();
    return data;
  }
}
Scene2.prototype.isScene = true;
class InterleavedBuffer2 {
  constructor(array, stride) {
    this.array = array;
    this.stride = stride;
    this.count = array !== void 0 ? array.length / stride : 0;
    this.usage = StaticDrawUsage;
    this.updateRange = { offset: 0, count: -1 };
    this.version = 0;
    this.uuid = generateUUID();
  }
  onUploadCallback() {
  }
  set needsUpdate(value) {
    if (value === true) this.version++;
  }
  setUsage(value) {
    this.usage = value;
    return this;
  }
  copy(source) {
    this.array = new source.array.constructor(source.array);
    this.count = source.count;
    this.stride = source.stride;
    this.usage = source.usage;
    return this;
  }
  copyAt(index1, attribute, index2) {
    index1 *= this.stride;
    index2 *= attribute.stride;
    for (let i2 = 0, l2 = this.stride; i2 < l2; i2++) {
      this.array[index1 + i2] = attribute.array[index2 + i2];
    }
    return this;
  }
  set(value, offset = 0) {
    this.array.set(value, offset);
    return this;
  }
  clone(data) {
    if (data.arrayBuffers === void 0) {
      data.arrayBuffers = {};
    }
    if (this.array.buffer._uuid === void 0) {
      this.array.buffer._uuid = generateUUID();
    }
    if (data.arrayBuffers[this.array.buffer._uuid] === void 0) {
      data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
    }
    const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
    const ib = new this.constructor(array, this.stride);
    ib.setUsage(this.usage);
    return ib;
  }
  onUpload(callback) {
    this.onUploadCallback = callback;
    return this;
  }
  toJSON(data) {
    if (data.arrayBuffers === void 0) {
      data.arrayBuffers = {};
    }
    if (this.array.buffer._uuid === void 0) {
      this.array.buffer._uuid = generateUUID();
    }
    if (data.arrayBuffers[this.array.buffer._uuid] === void 0) {
      data.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer));
    }
    return {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
  }
}
InterleavedBuffer2.prototype.isInterleavedBuffer = true;
const _vector$6 = /* @__PURE__ */ new Vector32();
class InterleavedBufferAttribute2 {
  constructor(interleavedBuffer, itemSize, offset, normalized = false) {
    this.name = "";
    this.data = interleavedBuffer;
    this.itemSize = itemSize;
    this.offset = offset;
    this.normalized = normalized === true;
  }
  get count() {
    return this.data.count;
  }
  get array() {
    return this.data.array;
  }
  set needsUpdate(value) {
    this.data.needsUpdate = value;
  }
  applyMatrix4(m) {
    for (let i2 = 0, l2 = this.data.count; i2 < l2; i2++) {
      _vector$6.x = this.getX(i2);
      _vector$6.y = this.getY(i2);
      _vector$6.z = this.getZ(i2);
      _vector$6.applyMatrix4(m);
      this.setXYZ(i2, _vector$6.x, _vector$6.y, _vector$6.z);
    }
    return this;
  }
  applyNormalMatrix(m) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$6.x = this.getX(i2);
      _vector$6.y = this.getY(i2);
      _vector$6.z = this.getZ(i2);
      _vector$6.applyNormalMatrix(m);
      this.setXYZ(i2, _vector$6.x, _vector$6.y, _vector$6.z);
    }
    return this;
  }
  transformDirection(m) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$6.x = this.getX(i2);
      _vector$6.y = this.getY(i2);
      _vector$6.z = this.getZ(i2);
      _vector$6.transformDirection(m);
      this.setXYZ(i2, _vector$6.x, _vector$6.y, _vector$6.z);
    }
    return this;
  }
  setX(index2, x) {
    this.data.array[index2 * this.data.stride + this.offset] = x;
    return this;
  }
  setY(index2, y) {
    this.data.array[index2 * this.data.stride + this.offset + 1] = y;
    return this;
  }
  setZ(index2, z2) {
    this.data.array[index2 * this.data.stride + this.offset + 2] = z2;
    return this;
  }
  setW(index2, w) {
    this.data.array[index2 * this.data.stride + this.offset + 3] = w;
    return this;
  }
  getX(index2) {
    return this.data.array[index2 * this.data.stride + this.offset];
  }
  getY(index2) {
    return this.data.array[index2 * this.data.stride + this.offset + 1];
  }
  getZ(index2) {
    return this.data.array[index2 * this.data.stride + this.offset + 2];
  }
  getW(index2) {
    return this.data.array[index2 * this.data.stride + this.offset + 3];
  }
  setXY(index2, x, y) {
    index2 = index2 * this.data.stride + this.offset;
    this.data.array[index2 + 0] = x;
    this.data.array[index2 + 1] = y;
    return this;
  }
  setXYZ(index2, x, y, z2) {
    index2 = index2 * this.data.stride + this.offset;
    this.data.array[index2 + 0] = x;
    this.data.array[index2 + 1] = y;
    this.data.array[index2 + 2] = z2;
    return this;
  }
  setXYZW(index2, x, y, z2, w) {
    index2 = index2 * this.data.stride + this.offset;
    this.data.array[index2 + 0] = x;
    this.data.array[index2 + 1] = y;
    this.data.array[index2 + 2] = z2;
    this.data.array[index2 + 3] = w;
    return this;
  }
  clone(data) {
    if (data === void 0) {
      console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.");
      const array = [];
      for (let i2 = 0; i2 < this.count; i2++) {
        const index2 = i2 * this.data.stride + this.offset;
        for (let j = 0; j < this.itemSize; j++) {
          array.push(this.data.array[index2 + j]);
        }
      }
      return new BufferAttribute2(new this.array.constructor(array), this.itemSize, this.normalized);
    } else {
      if (data.interleavedBuffers === void 0) {
        data.interleavedBuffers = {};
      }
      if (data.interleavedBuffers[this.data.uuid] === void 0) {
        data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
      }
      return new InterleavedBufferAttribute2(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
  }
  toJSON(data) {
    if (data === void 0) {
      console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.");
      const array = [];
      for (let i2 = 0; i2 < this.count; i2++) {
        const index2 = i2 * this.data.stride + this.offset;
        for (let j = 0; j < this.itemSize; j++) {
          array.push(this.data.array[index2 + j]);
        }
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array,
        normalized: this.normalized
      };
    } else {
      if (data.interleavedBuffers === void 0) {
        data.interleavedBuffers = {};
      }
      if (data.interleavedBuffers[this.data.uuid] === void 0) {
        data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
      }
      return {
        isInterleavedBufferAttribute: true,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
    }
  }
}
InterleavedBufferAttribute2.prototype.isInterleavedBufferAttribute = true;
class SpriteMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.type = "SpriteMaterial";
    this.color = new Color2(16777215);
    this.map = null;
    this.alphaMap = null;
    this.rotation = 0;
    this.sizeAttenuation = true;
    this.transparent = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.rotation = source.rotation;
    this.sizeAttenuation = source.sizeAttenuation;
    return this;
  }
}
SpriteMaterial2.prototype.isSpriteMaterial = true;
let _geometry;
const _intersectPoint = /* @__PURE__ */ new Vector32();
const _worldScale = /* @__PURE__ */ new Vector32();
const _mvPosition = /* @__PURE__ */ new Vector32();
const _alignedPosition = /* @__PURE__ */ new Vector22();
const _rotatedPosition = /* @__PURE__ */ new Vector22();
const _viewWorldMatrix = /* @__PURE__ */ new Matrix42();
const _vA$2 = /* @__PURE__ */ new Vector32();
const _vB$2 = /* @__PURE__ */ new Vector32();
const _vC$2 = /* @__PURE__ */ new Vector32();
const _uvA = /* @__PURE__ */ new Vector22();
const _uvB = /* @__PURE__ */ new Vector22();
const _uvC = /* @__PURE__ */ new Vector22();
class Sprite2 extends Object3D2 {
  constructor(material) {
    super();
    this.type = "Sprite";
    if (_geometry === void 0) {
      _geometry = new BufferGeometry2();
      const float32Array2 = new Float32Array([
        -0.5,
        -0.5,
        0,
        0,
        0,
        0.5,
        -0.5,
        0,
        1,
        0,
        0.5,
        0.5,
        0,
        1,
        1,
        -0.5,
        0.5,
        0,
        0,
        1
      ]);
      const interleavedBuffer = new InterleavedBuffer2(float32Array2, 5);
      _geometry.setIndex([0, 1, 2, 0, 2, 3]);
      _geometry.setAttribute("position", new InterleavedBufferAttribute2(interleavedBuffer, 3, 0, false));
      _geometry.setAttribute("uv", new InterleavedBufferAttribute2(interleavedBuffer, 2, 3, false));
    }
    this.geometry = _geometry;
    this.material = material !== void 0 ? material : new SpriteMaterial2();
    this.center = new Vector22(0.5, 0.5);
  }
  raycast(raycaster, intersects2) {
    if (raycaster.camera === null) {
      console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
    }
    _worldScale.setFromMatrixScale(this.matrixWorld);
    _viewWorldMatrix.copy(raycaster.camera.matrixWorld);
    this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
    _mvPosition.setFromMatrixPosition(this.modelViewMatrix);
    if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) {
      _worldScale.multiplyScalar(-_mvPosition.z);
    }
    const rotation = this.material.rotation;
    let sin2, cos2;
    if (rotation !== 0) {
      cos2 = Math.cos(rotation);
      sin2 = Math.sin(rotation);
    }
    const center = this.center;
    transformVertex(_vA$2.set(-0.5, -0.5, 0), _mvPosition, center, _worldScale, sin2, cos2);
    transformVertex(_vB$2.set(0.5, -0.5, 0), _mvPosition, center, _worldScale, sin2, cos2);
    transformVertex(_vC$2.set(0.5, 0.5, 0), _mvPosition, center, _worldScale, sin2, cos2);
    _uvA.set(0, 0);
    _uvB.set(1, 0);
    _uvC.set(1, 1);
    let intersect2 = raycaster.ray.intersectTriangle(_vA$2, _vB$2, _vC$2, false, _intersectPoint);
    if (intersect2 === null) {
      transformVertex(_vB$2.set(-0.5, 0.5, 0), _mvPosition, center, _worldScale, sin2, cos2);
      _uvB.set(0, 1);
      intersect2 = raycaster.ray.intersectTriangle(_vA$2, _vC$2, _vB$2, false, _intersectPoint);
      if (intersect2 === null) {
        return;
      }
    }
    const distance2 = raycaster.ray.origin.distanceTo(_intersectPoint);
    if (distance2 < raycaster.near || distance2 > raycaster.far) return;
    intersects2.push({
      distance: distance2,
      point: _intersectPoint.clone(),
      uv: Triangle2.getUV(_intersectPoint, _vA$2, _vB$2, _vC$2, _uvA, _uvB, _uvC, new Vector22()),
      face: null,
      object: this
    });
  }
  copy(source) {
    super.copy(source);
    if (source.center !== void 0) this.center.copy(source.center);
    this.material = source.material;
    return this;
  }
}
Sprite2.prototype.isSprite = true;
function transformVertex(vertexPosition, mvPosition, center, scale, sin2, cos2) {
  _alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
  if (sin2 !== void 0) {
    _rotatedPosition.x = cos2 * _alignedPosition.x - sin2 * _alignedPosition.y;
    _rotatedPosition.y = sin2 * _alignedPosition.x + cos2 * _alignedPosition.y;
  } else {
    _rotatedPosition.copy(_alignedPosition);
  }
  vertexPosition.copy(mvPosition);
  vertexPosition.x += _rotatedPosition.x;
  vertexPosition.y += _rotatedPosition.y;
  vertexPosition.applyMatrix4(_viewWorldMatrix);
}
const _basePosition = /* @__PURE__ */ new Vector32();
const _skinIndex = /* @__PURE__ */ new Vector42();
const _skinWeight = /* @__PURE__ */ new Vector42();
const _vector$5 = /* @__PURE__ */ new Vector32();
const _matrix = /* @__PURE__ */ new Matrix42();
class SkinnedMesh2 extends Mesh2 {
  constructor(geometry, material) {
    super(geometry, material);
    this.type = "SkinnedMesh";
    this.bindMode = "attached";
    this.bindMatrix = new Matrix42();
    this.bindMatrixInverse = new Matrix42();
  }
  copy(source) {
    super.copy(source);
    this.bindMode = source.bindMode;
    this.bindMatrix.copy(source.bindMatrix);
    this.bindMatrixInverse.copy(source.bindMatrixInverse);
    this.skeleton = source.skeleton;
    return this;
  }
  bind(skeleton, bindMatrix) {
    this.skeleton = skeleton;
    if (bindMatrix === void 0) {
      this.updateMatrixWorld(true);
      this.skeleton.calculateInverses();
      bindMatrix = this.matrixWorld;
    }
    this.bindMatrix.copy(bindMatrix);
    this.bindMatrixInverse.copy(bindMatrix).invert();
  }
  pose() {
    this.skeleton.pose();
  }
  normalizeSkinWeights() {
    const vector = new Vector42();
    const skinWeight = this.geometry.attributes.skinWeight;
    for (let i2 = 0, l2 = skinWeight.count; i2 < l2; i2++) {
      vector.x = skinWeight.getX(i2);
      vector.y = skinWeight.getY(i2);
      vector.z = skinWeight.getZ(i2);
      vector.w = skinWeight.getW(i2);
      const scale = 1 / vector.manhattanLength();
      if (scale !== Infinity) {
        vector.multiplyScalar(scale);
      } else {
        vector.set(1, 0, 0, 0);
      }
      skinWeight.setXYZW(i2, vector.x, vector.y, vector.z, vector.w);
    }
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    if (this.bindMode === "attached") {
      this.bindMatrixInverse.copy(this.matrixWorld).invert();
    } else if (this.bindMode === "detached") {
      this.bindMatrixInverse.copy(this.bindMatrix).invert();
    } else {
      console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
  }
  boneTransform(index2, target) {
    const skeleton = this.skeleton;
    const geometry = this.geometry;
    _skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index2);
    _skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index2);
    _basePosition.fromBufferAttribute(geometry.attributes.position, index2).applyMatrix4(this.bindMatrix);
    target.set(0, 0, 0);
    for (let i2 = 0; i2 < 4; i2++) {
      const weight = _skinWeight.getComponent(i2);
      if (weight !== 0) {
        const boneIndex = _skinIndex.getComponent(i2);
        _matrix.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
        target.addScaledVector(_vector$5.copy(_basePosition).applyMatrix4(_matrix), weight);
      }
    }
    return target.applyMatrix4(this.bindMatrixInverse);
  }
}
SkinnedMesh2.prototype.isSkinnedMesh = true;
class Bone2 extends Object3D2 {
  constructor() {
    super();
    this.type = "Bone";
  }
}
Bone2.prototype.isBone = true;
class DataTexture2 extends Texture2 {
  constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = NearestFilter, minFilter = NearestFilter, anisotropy, encoding) {
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.image = { data, width, height };
    this.magFilter = magFilter;
    this.minFilter = minFilter;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
    this.needsUpdate = true;
  }
}
DataTexture2.prototype.isDataTexture = true;
class InstancedBufferAttribute2 extends BufferAttribute2 {
  constructor(array, itemSize, normalized, meshPerAttribute = 1) {
    if (typeof normalized === "number") {
      meshPerAttribute = normalized;
      normalized = false;
      console.error("THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.");
    }
    super(array, itemSize, normalized);
    this.meshPerAttribute = meshPerAttribute;
  }
  copy(source) {
    super.copy(source);
    this.meshPerAttribute = source.meshPerAttribute;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.meshPerAttribute = this.meshPerAttribute;
    data.isInstancedBufferAttribute = true;
    return data;
  }
}
InstancedBufferAttribute2.prototype.isInstancedBufferAttribute = true;
const _instanceLocalMatrix = /* @__PURE__ */ new Matrix42();
const _instanceWorldMatrix = /* @__PURE__ */ new Matrix42();
const _instanceIntersects = [];
const _mesh = /* @__PURE__ */ new Mesh2();
class InstancedMesh2 extends Mesh2 {
  constructor(geometry, material, count) {
    super(geometry, material);
    this.instanceMatrix = new InstancedBufferAttribute2(new Float32Array(count * 16), 16);
    this.instanceColor = null;
    this.count = count;
    this.frustumCulled = false;
  }
  copy(source) {
    super.copy(source);
    this.instanceMatrix.copy(source.instanceMatrix);
    if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
    this.count = source.count;
    return this;
  }
  getColorAt(index2, color2) {
    color2.fromArray(this.instanceColor.array, index2 * 3);
  }
  getMatrixAt(index2, matrix2) {
    matrix2.fromArray(this.instanceMatrix.array, index2 * 16);
  }
  raycast(raycaster, intersects2) {
    const matrixWorld = this.matrixWorld;
    const raycastTimes = this.count;
    _mesh.geometry = this.geometry;
    _mesh.material = this.material;
    if (_mesh.material === void 0) return;
    for (let instanceId = 0; instanceId < raycastTimes; instanceId++) {
      this.getMatrixAt(instanceId, _instanceLocalMatrix);
      _instanceWorldMatrix.multiplyMatrices(matrixWorld, _instanceLocalMatrix);
      _mesh.matrixWorld = _instanceWorldMatrix;
      _mesh.raycast(raycaster, _instanceIntersects);
      for (let i2 = 0, l2 = _instanceIntersects.length; i2 < l2; i2++) {
        const intersect2 = _instanceIntersects[i2];
        intersect2.instanceId = instanceId;
        intersect2.object = this;
        intersects2.push(intersect2);
      }
      _instanceIntersects.length = 0;
    }
  }
  setColorAt(index2, color2) {
    if (this.instanceColor === null) {
      this.instanceColor = new InstancedBufferAttribute2(new Float32Array(this.instanceMatrix.count * 3), 3);
    }
    color2.toArray(this.instanceColor.array, index2 * 3);
  }
  setMatrixAt(index2, matrix2) {
    matrix2.toArray(this.instanceMatrix.array, index2 * 16);
  }
  updateMorphTargets() {
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
InstancedMesh2.prototype.isInstancedMesh = true;
class LineBasicMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.type = "LineBasicMaterial";
    this.color = new Color2(16777215);
    this.linewidth = 1;
    this.linecap = "round";
    this.linejoin = "round";
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.linewidth = source.linewidth;
    this.linecap = source.linecap;
    this.linejoin = source.linejoin;
    return this;
  }
}
LineBasicMaterial2.prototype.isLineBasicMaterial = true;
const _start$1 = /* @__PURE__ */ new Vector32();
const _end$1 = /* @__PURE__ */ new Vector32();
const _inverseMatrix$1 = /* @__PURE__ */ new Matrix42();
const _ray$1 = /* @__PURE__ */ new Ray2();
const _sphere$1 = /* @__PURE__ */ new Sphere2();
class Line2 extends Object3D2 {
  constructor(geometry = new BufferGeometry2(), material = new LineBasicMaterial2()) {
    super();
    this.type = "Line";
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source) {
    super.copy(source);
    this.material = source.material;
    this.geometry = source.geometry;
    return this;
  }
  computeLineDistances() {
    const geometry = this.geometry;
    if (geometry.isBufferGeometry) {
      if (geometry.index === null) {
        const positionAttribute = geometry.attributes.position;
        const lineDistances = [0];
        for (let i2 = 1, l2 = positionAttribute.count; i2 < l2; i2++) {
          _start$1.fromBufferAttribute(positionAttribute, i2 - 1);
          _end$1.fromBufferAttribute(positionAttribute, i2);
          lineDistances[i2] = lineDistances[i2 - 1];
          lineDistances[i2] += _start$1.distanceTo(_end$1);
        }
        geometry.setAttribute("lineDistance", new Float32BufferAttribute2(lineDistances, 1));
      } else {
        console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      }
    } else if (geometry.isGeometry) {
      console.error("THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    return this;
  }
  raycast(raycaster, intersects2) {
    const geometry = this.geometry;
    const matrixWorld = this.matrixWorld;
    const threshold = raycaster.params.Line.threshold;
    const drawRange = geometry.drawRange;
    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
    _sphere$1.copy(geometry.boundingSphere);
    _sphere$1.applyMatrix4(matrixWorld);
    _sphere$1.radius += threshold;
    if (raycaster.ray.intersectsSphere(_sphere$1) === false) return;
    _inverseMatrix$1.copy(matrixWorld).invert();
    _ray$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$1);
    const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
    const localThresholdSq = localThreshold * localThreshold;
    const vStart = new Vector32();
    const vEnd = new Vector32();
    const interSegment = new Vector32();
    const interRay = new Vector32();
    const step = this.isLineSegments ? 2 : 1;
    if (geometry.isBufferGeometry) {
      const index2 = geometry.index;
      const attributes = geometry.attributes;
      const positionAttribute = attributes.position;
      if (index2 !== null) {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(index2.count, drawRange.start + drawRange.count);
        for (let i2 = start, l2 = end - 1; i2 < l2; i2 += step) {
          const a3 = index2.getX(i2);
          const b = index2.getX(i2 + 1);
          vStart.fromBufferAttribute(positionAttribute, a3);
          vEnd.fromBufferAttribute(positionAttribute, b);
          const distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
          if (distSq > localThresholdSq) continue;
          interRay.applyMatrix4(this.matrixWorld);
          const distance2 = raycaster.ray.origin.distanceTo(interRay);
          if (distance2 < raycaster.near || distance2 > raycaster.far) continue;
          intersects2.push({
            distance: distance2,
            // What do we want? intersection point on the ray or on the segment??
            // point: raycaster.ray.at( distance ),
            point: interSegment.clone().applyMatrix4(this.matrixWorld),
            index: i2,
            face: null,
            faceIndex: null,
            object: this
          });
        }
      } else {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
        for (let i2 = start, l2 = end - 1; i2 < l2; i2 += step) {
          vStart.fromBufferAttribute(positionAttribute, i2);
          vEnd.fromBufferAttribute(positionAttribute, i2 + 1);
          const distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
          if (distSq > localThresholdSq) continue;
          interRay.applyMatrix4(this.matrixWorld);
          const distance2 = raycaster.ray.origin.distanceTo(interRay);
          if (distance2 < raycaster.near || distance2 > raycaster.far) continue;
          intersects2.push({
            distance: distance2,
            // What do we want? intersection point on the ray or on the segment??
            // point: raycaster.ray.at( distance ),
            point: interSegment.clone().applyMatrix4(this.matrixWorld),
            index: i2,
            face: null,
            faceIndex: null,
            object: this
          });
        }
      }
    } else if (geometry.isGeometry) {
      console.error("THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }
  updateMorphTargets() {
    const geometry = this.geometry;
    if (geometry.isBufferGeometry) {
      const morphAttributes = geometry.morphAttributes;
      const keys = Object.keys(morphAttributes);
      if (keys.length > 0) {
        const morphAttribute = morphAttributes[keys[0]];
        if (morphAttribute !== void 0) {
          this.morphTargetInfluences = [];
          this.morphTargetDictionary = {};
          for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
            const name = morphAttribute[m].name || String(m);
            this.morphTargetInfluences.push(0);
            this.morphTargetDictionary[name] = m;
          }
        }
      }
    } else {
      const morphTargets = geometry.morphTargets;
      if (morphTargets !== void 0 && morphTargets.length > 0) {
        console.error("THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }
}
Line2.prototype.isLine = true;
const _start$2 = /* @__PURE__ */ new Vector32();
const _end$2 = /* @__PURE__ */ new Vector32();
class LineSegments2 extends Line2 {
  constructor(geometry, material) {
    super(geometry, material);
    this.type = "LineSegments";
  }
  computeLineDistances() {
    const geometry = this.geometry;
    if (geometry.isBufferGeometry) {
      if (geometry.index === null) {
        const positionAttribute = geometry.attributes.position;
        const lineDistances = [];
        for (let i2 = 0, l2 = positionAttribute.count; i2 < l2; i2 += 2) {
          _start$2.fromBufferAttribute(positionAttribute, i2);
          _end$2.fromBufferAttribute(positionAttribute, i2 + 1);
          lineDistances[i2] = i2 === 0 ? 0 : lineDistances[i2 - 1];
          lineDistances[i2 + 1] = lineDistances[i2] + _start$2.distanceTo(_end$2);
        }
        geometry.setAttribute("lineDistance", new Float32BufferAttribute2(lineDistances, 1));
      } else {
        console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      }
    } else if (geometry.isGeometry) {
      console.error("THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    return this;
  }
}
LineSegments2.prototype.isLineSegments = true;
class LineLoop2 extends Line2 {
  constructor(geometry, material) {
    super(geometry, material);
    this.type = "LineLoop";
  }
}
LineLoop2.prototype.isLineLoop = true;
class PointsMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.type = "PointsMaterial";
    this.color = new Color2(16777215);
    this.map = null;
    this.alphaMap = null;
    this.size = 1;
    this.sizeAttenuation = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.size = source.size;
    this.sizeAttenuation = source.sizeAttenuation;
    return this;
  }
}
PointsMaterial2.prototype.isPointsMaterial = true;
const _inverseMatrix = /* @__PURE__ */ new Matrix42();
const _ray$3 = /* @__PURE__ */ new Ray2();
const _sphere$4 = /* @__PURE__ */ new Sphere2();
const _position$2 = /* @__PURE__ */ new Vector32();
class Points2 extends Object3D2 {
  constructor(geometry = new BufferGeometry2(), material = new PointsMaterial2()) {
    super();
    this.type = "Points";
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source) {
    super.copy(source);
    this.material = source.material;
    this.geometry = source.geometry;
    return this;
  }
  raycast(raycaster, intersects2) {
    const geometry = this.geometry;
    const matrixWorld = this.matrixWorld;
    const threshold = raycaster.params.Points.threshold;
    const drawRange = geometry.drawRange;
    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
    _sphere$4.copy(geometry.boundingSphere);
    _sphere$4.applyMatrix4(matrixWorld);
    _sphere$4.radius += threshold;
    if (raycaster.ray.intersectsSphere(_sphere$4) === false) return;
    _inverseMatrix.copy(matrixWorld).invert();
    _ray$3.copy(raycaster.ray).applyMatrix4(_inverseMatrix);
    const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
    const localThresholdSq = localThreshold * localThreshold;
    if (geometry.isBufferGeometry) {
      const index2 = geometry.index;
      const attributes = geometry.attributes;
      const positionAttribute = attributes.position;
      if (index2 !== null) {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(index2.count, drawRange.start + drawRange.count);
        for (let i2 = start, il = end; i2 < il; i2++) {
          const a3 = index2.getX(i2);
          _position$2.fromBufferAttribute(positionAttribute, a3);
          testPoint(_position$2, a3, localThresholdSq, matrixWorld, raycaster, intersects2, this);
        }
      } else {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
        for (let i2 = start, l2 = end; i2 < l2; i2++) {
          _position$2.fromBufferAttribute(positionAttribute, i2);
          testPoint(_position$2, i2, localThresholdSq, matrixWorld, raycaster, intersects2, this);
        }
      }
    } else {
      console.error("THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }
  updateMorphTargets() {
    const geometry = this.geometry;
    if (geometry.isBufferGeometry) {
      const morphAttributes = geometry.morphAttributes;
      const keys = Object.keys(morphAttributes);
      if (keys.length > 0) {
        const morphAttribute = morphAttributes[keys[0]];
        if (morphAttribute !== void 0) {
          this.morphTargetInfluences = [];
          this.morphTargetDictionary = {};
          for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
            const name = morphAttribute[m].name || String(m);
            this.morphTargetInfluences.push(0);
            this.morphTargetDictionary[name] = m;
          }
        }
      }
    } else {
      const morphTargets = geometry.morphTargets;
      if (morphTargets !== void 0 && morphTargets.length > 0) {
        console.error("THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }
}
Points2.prototype.isPoints = true;
function testPoint(point2, index2, localThresholdSq, matrixWorld, raycaster, intersects2, object) {
  const rayPointDistanceSq = _ray$3.distanceSqToPoint(point2);
  if (rayPointDistanceSq < localThresholdSq) {
    const intersectPoint = new Vector32();
    _ray$3.closestPointToPoint(point2, intersectPoint);
    intersectPoint.applyMatrix4(matrixWorld);
    const distance2 = raycaster.ray.origin.distanceTo(intersectPoint);
    if (distance2 < raycaster.near || distance2 > raycaster.far) return;
    intersects2.push({
      distance: distance2,
      distanceToRay: Math.sqrt(rayPointDistanceSq),
      point: intersectPoint,
      index: index2,
      face: null,
      object
    });
  }
}
class VideoTexture2 extends Texture2 {
  constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.format = format !== void 0 ? format : RGBFormat;
    this.minFilter = minFilter !== void 0 ? minFilter : LinearFilter;
    this.magFilter = magFilter !== void 0 ? magFilter : LinearFilter;
    this.generateMipmaps = false;
    const scope = this;
    function updateVideo() {
      scope.needsUpdate = true;
      video.requestVideoFrameCallback(updateVideo);
    }
    if ("requestVideoFrameCallback" in video) {
      video.requestVideoFrameCallback(updateVideo);
    }
  }
  clone() {
    return new this.constructor(this.image).copy(this);
  }
  update() {
    const video = this.image;
    const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
    if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) {
      this.needsUpdate = true;
    }
  }
}
VideoTexture2.prototype.isVideoTexture = true;
class CompressedTexture2 extends Texture2 {
  constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding) {
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.image = { width, height };
    this.mipmaps = mipmaps;
    this.flipY = false;
    this.generateMipmaps = false;
  }
}
CompressedTexture2.prototype.isCompressedTexture = true;
class CanvasTexture2 extends Texture2 {
  constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.needsUpdate = true;
  }
}
CanvasTexture2.prototype.isCanvasTexture = true;
class DepthTexture2 extends Texture2 {
  constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format) {
    format = format !== void 0 ? format : DepthFormat;
    if (format !== DepthFormat && format !== DepthStencilFormat) {
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    }
    if (type === void 0 && format === DepthFormat) type = UnsignedShortType;
    if (type === void 0 && format === DepthStencilFormat) type = UnsignedInt248Type;
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.image = { width, height };
    this.magFilter = magFilter !== void 0 ? magFilter : NearestFilter;
    this.minFilter = minFilter !== void 0 ? minFilter : NearestFilter;
    this.flipY = false;
    this.generateMipmaps = false;
  }
}
DepthTexture2.prototype.isDepthTexture = true;
class Curve2 {
  constructor() {
    this.type = "Curve";
    this.arcLengthDivisions = 200;
  }
  // Virtual base class method to overwrite and implement in subclasses
  //	- t [0 .. 1]
  getPoint() {
    console.warn("THREE.Curve: .getPoint() not implemented.");
    return null;
  }
  // Get point at relative position in curve according to arc length
  // - u [0 .. 1]
  getPointAt(u3, optionalTarget) {
    const t3 = this.getUtoTmapping(u3);
    return this.getPoint(t3, optionalTarget);
  }
  // Get sequence of points using getPoint( t )
  getPoints(divisions = 5) {
    const points = [];
    for (let d2 = 0; d2 <= divisions; d2++) {
      points.push(this.getPoint(d2 / divisions));
    }
    return points;
  }
  // Get sequence of points using getPointAt( u )
  getSpacedPoints(divisions = 5) {
    const points = [];
    for (let d2 = 0; d2 <= divisions; d2++) {
      points.push(this.getPointAt(d2 / divisions));
    }
    return points;
  }
  // Get total curve arc length
  getLength() {
    const lengths = this.getLengths();
    return lengths[lengths.length - 1];
  }
  // Get list of cumulative segment lengths
  getLengths(divisions = this.arcLengthDivisions) {
    if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) {
      return this.cacheArcLengths;
    }
    this.needsUpdate = false;
    const cache = [];
    let current, last = this.getPoint(0);
    let sum = 0;
    cache.push(0);
    for (let p2 = 1; p2 <= divisions; p2++) {
      current = this.getPoint(p2 / divisions);
      sum += current.distanceTo(last);
      cache.push(sum);
      last = current;
    }
    this.cacheArcLengths = cache;
    return cache;
  }
  updateArcLengths() {
    this.needsUpdate = true;
    this.getLengths();
  }
  // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
  getUtoTmapping(u3, distance2) {
    const arcLengths = this.getLengths();
    let i2 = 0;
    const il = arcLengths.length;
    let targetArcLength;
    if (distance2) {
      targetArcLength = distance2;
    } else {
      targetArcLength = u3 * arcLengths[il - 1];
    }
    let low = 0, high = il - 1, comparison;
    while (low <= high) {
      i2 = Math.floor(low + (high - low) / 2);
      comparison = arcLengths[i2] - targetArcLength;
      if (comparison < 0) {
        low = i2 + 1;
      } else if (comparison > 0) {
        high = i2 - 1;
      } else {
        high = i2;
        break;
      }
    }
    i2 = high;
    if (arcLengths[i2] === targetArcLength) {
      return i2 / (il - 1);
    }
    const lengthBefore = arcLengths[i2];
    const lengthAfter = arcLengths[i2 + 1];
    const segmentLength = lengthAfter - lengthBefore;
    const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
    const t3 = (i2 + segmentFraction) / (il - 1);
    return t3;
  }
  // Returns a unit vector tangent at t
  // In case any sub curve does not implement its tangent derivation,
  // 2 points a small delta apart will be used to find its gradient
  // which seems to give a reasonable approximation
  getTangent(t3, optionalTarget) {
    const delta = 1e-4;
    let t1 = t3 - delta;
    let t22 = t3 + delta;
    if (t1 < 0) t1 = 0;
    if (t22 > 1) t22 = 1;
    const pt1 = this.getPoint(t1);
    const pt2 = this.getPoint(t22);
    const tangent = optionalTarget || (pt1.isVector2 ? new Vector22() : new Vector32());
    tangent.copy(pt2).sub(pt1).normalize();
    return tangent;
  }
  getTangentAt(u3, optionalTarget) {
    const t3 = this.getUtoTmapping(u3);
    return this.getTangent(t3, optionalTarget);
  }
  computeFrenetFrames(segments, closed) {
    const normal = new Vector32();
    const tangents = [];
    const normals = [];
    const binormals = [];
    const vec = new Vector32();
    const mat = new Matrix42();
    for (let i2 = 0; i2 <= segments; i2++) {
      const u3 = i2 / segments;
      tangents[i2] = this.getTangentAt(u3, new Vector32());
      tangents[i2].normalize();
    }
    normals[0] = new Vector32();
    binormals[0] = new Vector32();
    let min = Number.MAX_VALUE;
    const tx = Math.abs(tangents[0].x);
    const ty = Math.abs(tangents[0].y);
    const tz = Math.abs(tangents[0].z);
    if (tx <= min) {
      min = tx;
      normal.set(1, 0, 0);
    }
    if (ty <= min) {
      min = ty;
      normal.set(0, 1, 0);
    }
    if (tz <= min) {
      normal.set(0, 0, 1);
    }
    vec.crossVectors(tangents[0], normal).normalize();
    normals[0].crossVectors(tangents[0], vec);
    binormals[0].crossVectors(tangents[0], normals[0]);
    for (let i2 = 1; i2 <= segments; i2++) {
      normals[i2] = normals[i2 - 1].clone();
      binormals[i2] = binormals[i2 - 1].clone();
      vec.crossVectors(tangents[i2 - 1], tangents[i2]);
      if (vec.length() > Number.EPSILON) {
        vec.normalize();
        const theta = Math.acos(clamp(tangents[i2 - 1].dot(tangents[i2]), -1, 1));
        normals[i2].applyMatrix4(mat.makeRotationAxis(vec, theta));
      }
      binormals[i2].crossVectors(tangents[i2], normals[i2]);
    }
    if (closed === true) {
      let theta = Math.acos(clamp(normals[0].dot(normals[segments]), -1, 1));
      theta /= segments;
      if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) {
        theta = -theta;
      }
      for (let i2 = 1; i2 <= segments; i2++) {
        normals[i2].applyMatrix4(mat.makeRotationAxis(tangents[i2], theta * i2));
        binormals[i2].crossVectors(tangents[i2], normals[i2]);
      }
    }
    return {
      tangents,
      normals,
      binormals
    };
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.arcLengthDivisions = source.arcLengthDivisions;
    return this;
  }
  toJSON() {
    const data = {
      metadata: {
        version: 4.5,
        type: "Curve",
        generator: "Curve.toJSON"
      }
    };
    data.arcLengthDivisions = this.arcLengthDivisions;
    data.type = this.type;
    return data;
  }
  fromJSON(json) {
    this.arcLengthDivisions = json.arcLengthDivisions;
    return this;
  }
}
class EllipseCurve2 extends Curve2 {
  constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0) {
    super();
    this.type = "EllipseCurve";
    this.aX = aX;
    this.aY = aY;
    this.xRadius = xRadius;
    this.yRadius = yRadius;
    this.aStartAngle = aStartAngle;
    this.aEndAngle = aEndAngle;
    this.aClockwise = aClockwise;
    this.aRotation = aRotation;
  }
  getPoint(t3, optionalTarget) {
    const point2 = optionalTarget || new Vector22();
    const twoPi = Math.PI * 2;
    let deltaAngle = this.aEndAngle - this.aStartAngle;
    const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
    while (deltaAngle < 0) deltaAngle += twoPi;
    while (deltaAngle > twoPi) deltaAngle -= twoPi;
    if (deltaAngle < Number.EPSILON) {
      if (samePoints) {
        deltaAngle = 0;
      } else {
        deltaAngle = twoPi;
      }
    }
    if (this.aClockwise === true && !samePoints) {
      if (deltaAngle === twoPi) {
        deltaAngle = -twoPi;
      } else {
        deltaAngle = deltaAngle - twoPi;
      }
    }
    const angle2 = this.aStartAngle + t3 * deltaAngle;
    let x = this.aX + this.xRadius * Math.cos(angle2);
    let y = this.aY + this.yRadius * Math.sin(angle2);
    if (this.aRotation !== 0) {
      const cos2 = Math.cos(this.aRotation);
      const sin2 = Math.sin(this.aRotation);
      const tx = x - this.aX;
      const ty = y - this.aY;
      x = tx * cos2 - ty * sin2 + this.aX;
      y = tx * sin2 + ty * cos2 + this.aY;
    }
    return point2.set(x, y);
  }
  copy(source) {
    super.copy(source);
    this.aX = source.aX;
    this.aY = source.aY;
    this.xRadius = source.xRadius;
    this.yRadius = source.yRadius;
    this.aStartAngle = source.aStartAngle;
    this.aEndAngle = source.aEndAngle;
    this.aClockwise = source.aClockwise;
    this.aRotation = source.aRotation;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.aX = this.aX;
    data.aY = this.aY;
    data.xRadius = this.xRadius;
    data.yRadius = this.yRadius;
    data.aStartAngle = this.aStartAngle;
    data.aEndAngle = this.aEndAngle;
    data.aClockwise = this.aClockwise;
    data.aRotation = this.aRotation;
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.aX = json.aX;
    this.aY = json.aY;
    this.xRadius = json.xRadius;
    this.yRadius = json.yRadius;
    this.aStartAngle = json.aStartAngle;
    this.aEndAngle = json.aEndAngle;
    this.aClockwise = json.aClockwise;
    this.aRotation = json.aRotation;
    return this;
  }
}
EllipseCurve2.prototype.isEllipseCurve = true;
class ArcCurve2 extends EllipseCurve2 {
  constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
    this.type = "ArcCurve";
  }
}
ArcCurve2.prototype.isArcCurve = true;
function CubicPoly() {
  let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
  function init(x0, x1, t0, t1) {
    c0 = x0;
    c1 = t0;
    c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
    c3 = 2 * x0 - 2 * x1 + t0 + t1;
  }
  return {
    initCatmullRom: function(x0, x1, x2, x3, tension) {
      init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
    },
    initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
      let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
      let t22 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
      t1 *= dt1;
      t22 *= dt1;
      init(x1, x2, t1, t22);
    },
    calc: function(t3) {
      const t22 = t3 * t3;
      const t32 = t22 * t3;
      return c0 + c1 * t3 + c2 * t22 + c3 * t32;
    }
  };
}
const tmp = new Vector32();
const px = new CubicPoly(), py = new CubicPoly(), pz = new CubicPoly();
class CatmullRomCurve32 extends Curve2 {
  constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5) {
    super();
    this.type = "CatmullRomCurve3";
    this.points = points;
    this.closed = closed;
    this.curveType = curveType;
    this.tension = tension;
  }
  getPoint(t3, optionalTarget = new Vector32()) {
    const point2 = optionalTarget;
    const points = this.points;
    const l2 = points.length;
    const p2 = (l2 - (this.closed ? 0 : 1)) * t3;
    let intPoint = Math.floor(p2);
    let weight = p2 - intPoint;
    if (this.closed) {
      intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l2) + 1) * l2;
    } else if (weight === 0 && intPoint === l2 - 1) {
      intPoint = l2 - 2;
      weight = 1;
    }
    let p0, p3;
    if (this.closed || intPoint > 0) {
      p0 = points[(intPoint - 1) % l2];
    } else {
      tmp.subVectors(points[0], points[1]).add(points[0]);
      p0 = tmp;
    }
    const p1 = points[intPoint % l2];
    const p22 = points[(intPoint + 1) % l2];
    if (this.closed || intPoint + 2 < l2) {
      p3 = points[(intPoint + 2) % l2];
    } else {
      tmp.subVectors(points[l2 - 1], points[l2 - 2]).add(points[l2 - 1]);
      p3 = tmp;
    }
    if (this.curveType === "centripetal" || this.curveType === "chordal") {
      const pow = this.curveType === "chordal" ? 0.5 : 0.25;
      let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
      let dt1 = Math.pow(p1.distanceToSquared(p22), pow);
      let dt2 = Math.pow(p22.distanceToSquared(p3), pow);
      if (dt1 < 1e-4) dt1 = 1;
      if (dt0 < 1e-4) dt0 = dt1;
      if (dt2 < 1e-4) dt2 = dt1;
      px.initNonuniformCatmullRom(p0.x, p1.x, p22.x, p3.x, dt0, dt1, dt2);
      py.initNonuniformCatmullRom(p0.y, p1.y, p22.y, p3.y, dt0, dt1, dt2);
      pz.initNonuniformCatmullRom(p0.z, p1.z, p22.z, p3.z, dt0, dt1, dt2);
    } else if (this.curveType === "catmullrom") {
      px.initCatmullRom(p0.x, p1.x, p22.x, p3.x, this.tension);
      py.initCatmullRom(p0.y, p1.y, p22.y, p3.y, this.tension);
      pz.initCatmullRom(p0.z, p1.z, p22.z, p3.z, this.tension);
    }
    point2.set(
      px.calc(weight),
      py.calc(weight),
      pz.calc(weight)
    );
    return point2;
  }
  copy(source) {
    super.copy(source);
    this.points = [];
    for (let i2 = 0, l2 = source.points.length; i2 < l2; i2++) {
      const point2 = source.points[i2];
      this.points.push(point2.clone());
    }
    this.closed = source.closed;
    this.curveType = source.curveType;
    this.tension = source.tension;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.points = [];
    for (let i2 = 0, l2 = this.points.length; i2 < l2; i2++) {
      const point2 = this.points[i2];
      data.points.push(point2.toArray());
    }
    data.closed = this.closed;
    data.curveType = this.curveType;
    data.tension = this.tension;
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.points = [];
    for (let i2 = 0, l2 = json.points.length; i2 < l2; i2++) {
      const point2 = json.points[i2];
      this.points.push(new Vector32().fromArray(point2));
    }
    this.closed = json.closed;
    this.curveType = json.curveType;
    this.tension = json.tension;
    return this;
  }
}
CatmullRomCurve32.prototype.isCatmullRomCurve3 = true;
function CatmullRom(t3, p0, p1, p2, p3) {
  const v0 = (p2 - p0) * 0.5;
  const v1 = (p3 - p1) * 0.5;
  const t22 = t3 * t3;
  const t32 = t3 * t22;
  return (2 * p1 - 2 * p2 + v0 + v1) * t32 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t22 + v0 * t3 + p1;
}
function QuadraticBezierP0(t3, p2) {
  const k = 1 - t3;
  return k * k * p2;
}
function QuadraticBezierP1(t3, p2) {
  return 2 * (1 - t3) * t3 * p2;
}
function QuadraticBezierP2(t3, p2) {
  return t3 * t3 * p2;
}
function QuadraticBezier(t3, p0, p1, p2) {
  return QuadraticBezierP0(t3, p0) + QuadraticBezierP1(t3, p1) + QuadraticBezierP2(t3, p2);
}
function CubicBezierP0(t3, p2) {
  const k = 1 - t3;
  return k * k * k * p2;
}
function CubicBezierP1(t3, p2) {
  const k = 1 - t3;
  return 3 * k * k * t3 * p2;
}
function CubicBezierP2(t3, p2) {
  return 3 * (1 - t3) * t3 * t3 * p2;
}
function CubicBezierP3(t3, p2) {
  return t3 * t3 * t3 * p2;
}
function CubicBezier(t3, p0, p1, p2, p3) {
  return CubicBezierP0(t3, p0) + CubicBezierP1(t3, p1) + CubicBezierP2(t3, p2) + CubicBezierP3(t3, p3);
}
class CubicBezierCurve2 extends Curve2 {
  constructor(v0 = new Vector22(), v1 = new Vector22(), v2 = new Vector22(), v3 = new Vector22()) {
    super();
    this.type = "CubicBezierCurve";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
    this.v3 = v3;
  }
  getPoint(t3, optionalTarget = new Vector22()) {
    const point2 = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
    point2.set(
      CubicBezier(t3, v0.x, v1.x, v2.x, v3.x),
      CubicBezier(t3, v0.y, v1.y, v2.y, v3.y)
    );
    return point2;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    data.v3 = this.v3.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
  }
}
CubicBezierCurve2.prototype.isCubicBezierCurve = true;
class CubicBezierCurve32 extends Curve2 {
  constructor(v0 = new Vector32(), v1 = new Vector32(), v2 = new Vector32(), v3 = new Vector32()) {
    super();
    this.type = "CubicBezierCurve3";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
    this.v3 = v3;
  }
  getPoint(t3, optionalTarget = new Vector32()) {
    const point2 = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
    point2.set(
      CubicBezier(t3, v0.x, v1.x, v2.x, v3.x),
      CubicBezier(t3, v0.y, v1.y, v2.y, v3.y),
      CubicBezier(t3, v0.z, v1.z, v2.z, v3.z)
    );
    return point2;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    data.v3 = this.v3.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
  }
}
CubicBezierCurve32.prototype.isCubicBezierCurve3 = true;
class LineCurve2 extends Curve2 {
  constructor(v1 = new Vector22(), v2 = new Vector22()) {
    super();
    this.type = "LineCurve";
    this.v1 = v1;
    this.v2 = v2;
  }
  getPoint(t3, optionalTarget = new Vector22()) {
    const point2 = optionalTarget;
    if (t3 === 1) {
      point2.copy(this.v2);
    } else {
      point2.copy(this.v2).sub(this.v1);
      point2.multiplyScalar(t3).add(this.v1);
    }
    return point2;
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(u3, optionalTarget) {
    return this.getPoint(u3, optionalTarget);
  }
  getTangent(t3, optionalTarget) {
    const tangent = optionalTarget || new Vector22();
    tangent.copy(this.v2).sub(this.v1).normalize();
    return tangent;
  }
  copy(source) {
    super.copy(source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
LineCurve2.prototype.isLineCurve = true;
class LineCurve32 extends Curve2 {
  constructor(v1 = new Vector32(), v2 = new Vector32()) {
    super();
    this.type = "LineCurve3";
    this.isLineCurve3 = true;
    this.v1 = v1;
    this.v2 = v2;
  }
  getPoint(t3, optionalTarget = new Vector32()) {
    const point2 = optionalTarget;
    if (t3 === 1) {
      point2.copy(this.v2);
    } else {
      point2.copy(this.v2).sub(this.v1);
      point2.multiplyScalar(t3).add(this.v1);
    }
    return point2;
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(u3, optionalTarget) {
    return this.getPoint(u3, optionalTarget);
  }
  copy(source) {
    super.copy(source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
class QuadraticBezierCurve2 extends Curve2 {
  constructor(v0 = new Vector22(), v1 = new Vector22(), v2 = new Vector22()) {
    super();
    this.type = "QuadraticBezierCurve";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
  }
  getPoint(t3, optionalTarget = new Vector22()) {
    const point2 = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2;
    point2.set(
      QuadraticBezier(t3, v0.x, v1.x, v2.x),
      QuadraticBezier(t3, v0.y, v1.y, v2.y)
    );
    return point2;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
QuadraticBezierCurve2.prototype.isQuadraticBezierCurve = true;
class QuadraticBezierCurve32 extends Curve2 {
  constructor(v0 = new Vector32(), v1 = new Vector32(), v2 = new Vector32()) {
    super();
    this.type = "QuadraticBezierCurve3";
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
  }
  getPoint(t3, optionalTarget = new Vector32()) {
    const point2 = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2;
    point2.set(
      QuadraticBezier(t3, v0.x, v1.x, v2.x),
      QuadraticBezier(t3, v0.y, v1.y, v2.y),
      QuadraticBezier(t3, v0.z, v1.z, v2.z)
    );
    return point2;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
QuadraticBezierCurve32.prototype.isQuadraticBezierCurve3 = true;
class SplineCurve2 extends Curve2 {
  constructor(points = []) {
    super();
    this.type = "SplineCurve";
    this.points = points;
  }
  getPoint(t3, optionalTarget = new Vector22()) {
    const point2 = optionalTarget;
    const points = this.points;
    const p2 = (points.length - 1) * t3;
    const intPoint = Math.floor(p2);
    const weight = p2 - intPoint;
    const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
    const p1 = points[intPoint];
    const p22 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
    const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
    point2.set(
      CatmullRom(weight, p0.x, p1.x, p22.x, p3.x),
      CatmullRom(weight, p0.y, p1.y, p22.y, p3.y)
    );
    return point2;
  }
  copy(source) {
    super.copy(source);
    this.points = [];
    for (let i2 = 0, l2 = source.points.length; i2 < l2; i2++) {
      const point2 = source.points[i2];
      this.points.push(point2.clone());
    }
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.points = [];
    for (let i2 = 0, l2 = this.points.length; i2 < l2; i2++) {
      const point2 = this.points[i2];
      data.points.push(point2.toArray());
    }
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.points = [];
    for (let i2 = 0, l2 = json.points.length; i2 < l2; i2++) {
      const point2 = json.points[i2];
      this.points.push(new Vector22().fromArray(point2));
    }
    return this;
  }
}
SplineCurve2.prototype.isSplineCurve = true;
var Curves = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcCurve: ArcCurve2,
  CatmullRomCurve3: CatmullRomCurve32,
  CubicBezierCurve: CubicBezierCurve2,
  CubicBezierCurve3: CubicBezierCurve32,
  EllipseCurve: EllipseCurve2,
  LineCurve: LineCurve2,
  LineCurve3: LineCurve32,
  QuadraticBezierCurve: QuadraticBezierCurve2,
  QuadraticBezierCurve3: QuadraticBezierCurve32,
  SplineCurve: SplineCurve2
});
const Earcut = {
  triangulate: function(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
    if (data.length > 80 * dim) {
      minX = maxX = data[0];
      minY = maxY = data[1];
      for (let i2 = dim; i2 < outerLen; i2 += dim) {
        x = data[i2];
        y = data[i2 + 1];
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      }
      invSize = Math.max(maxX - minX, maxY - minY);
      invSize = invSize !== 0 ? 1 / invSize : 0;
    }
    earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
    return triangles;
  }
};
function linkedList(data, start, end, dim, clockwise) {
  let i2, last;
  if (clockwise === signedArea(data, start, end, dim) > 0) {
    for (i2 = start; i2 < end; i2 += dim) last = insertNode(i2, data[i2], data[i2 + 1], last);
  } else {
    for (i2 = end - dim; i2 >= start; i2 -= dim) last = insertNode(i2, data[i2], data[i2 + 1], last);
  }
  if (last && equals(last, last.next)) {
    removeNode(last);
    last = last.next;
  }
  return last;
}
function filterPoints(start, end) {
  if (!start) return start;
  if (!end) end = start;
  let p2 = start, again;
  do {
    again = false;
    if (!p2.steiner && (equals(p2, p2.next) || area(p2.prev, p2, p2.next) === 0)) {
      removeNode(p2);
      p2 = end = p2.prev;
      if (p2 === p2.next) break;
      again = true;
    } else {
      p2 = p2.next;
    }
  } while (again || p2 !== end);
  return end;
}
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
  if (!ear) return;
  if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
  let stop = ear, prev, next;
  while (ear.prev !== ear.next) {
    prev = ear.prev;
    next = ear.next;
    if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
      triangles.push(prev.i / dim);
      triangles.push(ear.i / dim);
      triangles.push(next.i / dim);
      removeNode(ear);
      ear = next.next;
      stop = next.next;
      continue;
    }
    ear = next;
    if (ear === stop) {
      if (!pass) {
        earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
      } else if (pass === 1) {
        ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
        earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
      } else if (pass === 2) {
        splitEarcut(ear, triangles, dim, minX, minY, invSize);
      }
      break;
    }
  }
}
function isEar(ear) {
  const a3 = ear.prev, b = ear, c2 = ear.next;
  if (area(a3, b, c2) >= 0) return false;
  let p2 = ear.next.next;
  while (p2 !== ear.prev) {
    if (pointInTriangle(a3.x, a3.y, b.x, b.y, c2.x, c2.y, p2.x, p2.y) && area(p2.prev, p2, p2.next) >= 0) return false;
    p2 = p2.next;
  }
  return true;
}
function isEarHashed(ear, minX, minY, invSize) {
  const a3 = ear.prev, b = ear, c2 = ear.next;
  if (area(a3, b, c2) >= 0) return false;
  const minTX = a3.x < b.x ? a3.x < c2.x ? a3.x : c2.x : b.x < c2.x ? b.x : c2.x, minTY = a3.y < b.y ? a3.y < c2.y ? a3.y : c2.y : b.y < c2.y ? b.y : c2.y, maxTX = a3.x > b.x ? a3.x > c2.x ? a3.x : c2.x : b.x > c2.x ? b.x : c2.x, maxTY = a3.y > b.y ? a3.y > c2.y ? a3.y : c2.y : b.y > c2.y ? b.y : c2.y;
  const minZ = zOrder(minTX, minTY, minX, minY, invSize), maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
  let p2 = ear.prevZ, n2 = ear.nextZ;
  while (p2 && p2.z >= minZ && n2 && n2.z <= maxZ) {
    if (p2 !== ear.prev && p2 !== ear.next && pointInTriangle(a3.x, a3.y, b.x, b.y, c2.x, c2.y, p2.x, p2.y) && area(p2.prev, p2, p2.next) >= 0) return false;
    p2 = p2.prevZ;
    if (n2 !== ear.prev && n2 !== ear.next && pointInTriangle(a3.x, a3.y, b.x, b.y, c2.x, c2.y, n2.x, n2.y) && area(n2.prev, n2, n2.next) >= 0) return false;
    n2 = n2.nextZ;
  }
  while (p2 && p2.z >= minZ) {
    if (p2 !== ear.prev && p2 !== ear.next && pointInTriangle(a3.x, a3.y, b.x, b.y, c2.x, c2.y, p2.x, p2.y) && area(p2.prev, p2, p2.next) >= 0) return false;
    p2 = p2.prevZ;
  }
  while (n2 && n2.z <= maxZ) {
    if (n2 !== ear.prev && n2 !== ear.next && pointInTriangle(a3.x, a3.y, b.x, b.y, c2.x, c2.y, n2.x, n2.y) && area(n2.prev, n2, n2.next) >= 0) return false;
    n2 = n2.nextZ;
  }
  return true;
}
function cureLocalIntersections(start, triangles, dim) {
  let p2 = start;
  do {
    const a3 = p2.prev, b = p2.next.next;
    if (!equals(a3, b) && intersects(a3, p2, p2.next, b) && locallyInside(a3, b) && locallyInside(b, a3)) {
      triangles.push(a3.i / dim);
      triangles.push(p2.i / dim);
      triangles.push(b.i / dim);
      removeNode(p2);
      removeNode(p2.next);
      p2 = start = b;
    }
    p2 = p2.next;
  } while (p2 !== start);
  return filterPoints(p2);
}
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
  let a3 = start;
  do {
    let b = a3.next.next;
    while (b !== a3.prev) {
      if (a3.i !== b.i && isValidDiagonal(a3, b)) {
        let c2 = splitPolygon(a3, b);
        a3 = filterPoints(a3, a3.next);
        c2 = filterPoints(c2, c2.next);
        earcutLinked(a3, triangles, dim, minX, minY, invSize);
        earcutLinked(c2, triangles, dim, minX, minY, invSize);
        return;
      }
      b = b.next;
    }
    a3 = a3.next;
  } while (a3 !== start);
}
function eliminateHoles(data, holeIndices, outerNode, dim) {
  const queue = [];
  let i2, len, start, end, list;
  for (i2 = 0, len = holeIndices.length; i2 < len; i2++) {
    start = holeIndices[i2] * dim;
    end = i2 < len - 1 ? holeIndices[i2 + 1] * dim : data.length;
    list = linkedList(data, start, end, dim, false);
    if (list === list.next) list.steiner = true;
    queue.push(getLeftmost(list));
  }
  queue.sort(compareX);
  for (i2 = 0; i2 < queue.length; i2++) {
    eliminateHole(queue[i2], outerNode);
    outerNode = filterPoints(outerNode, outerNode.next);
  }
  return outerNode;
}
function compareX(a3, b) {
  return a3.x - b.x;
}
function eliminateHole(hole, outerNode) {
  outerNode = findHoleBridge(hole, outerNode);
  if (outerNode) {
    const b = splitPolygon(outerNode, hole);
    filterPoints(outerNode, outerNode.next);
    filterPoints(b, b.next);
  }
}
function findHoleBridge(hole, outerNode) {
  let p2 = outerNode;
  const hx = hole.x;
  const hy = hole.y;
  let qx = -Infinity, m;
  do {
    if (hy <= p2.y && hy >= p2.next.y && p2.next.y !== p2.y) {
      const x = p2.x + (hy - p2.y) * (p2.next.x - p2.x) / (p2.next.y - p2.y);
      if (x <= hx && x > qx) {
        qx = x;
        if (x === hx) {
          if (hy === p2.y) return p2;
          if (hy === p2.next.y) return p2.next;
        }
        m = p2.x < p2.next.x ? p2 : p2.next;
      }
    }
    p2 = p2.next;
  } while (p2 !== outerNode);
  if (!m) return null;
  if (hx === qx) return m;
  const stop = m, mx = m.x, my = m.y;
  let tanMin = Infinity, tan2;
  p2 = m;
  do {
    if (hx >= p2.x && p2.x >= mx && hx !== p2.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p2.x, p2.y)) {
      tan2 = Math.abs(hy - p2.y) / (hx - p2.x);
      if (locallyInside(p2, hole) && (tan2 < tanMin || tan2 === tanMin && (p2.x > m.x || p2.x === m.x && sectorContainsSector(m, p2)))) {
        m = p2;
        tanMin = tan2;
      }
    }
    p2 = p2.next;
  } while (p2 !== stop);
  return m;
}
function sectorContainsSector(m, p2) {
  return area(m.prev, m, p2.prev) < 0 && area(p2.next, m, m.next) < 0;
}
function indexCurve(start, minX, minY, invSize) {
  let p2 = start;
  do {
    if (p2.z === null) p2.z = zOrder(p2.x, p2.y, minX, minY, invSize);
    p2.prevZ = p2.prev;
    p2.nextZ = p2.next;
    p2 = p2.next;
  } while (p2 !== start);
  p2.prevZ.nextZ = null;
  p2.prevZ = null;
  sortLinked(p2);
}
function sortLinked(list) {
  let i2, p2, q, e2, tail, numMerges, pSize, qSize, inSize = 1;
  do {
    p2 = list;
    list = null;
    tail = null;
    numMerges = 0;
    while (p2) {
      numMerges++;
      q = p2;
      pSize = 0;
      for (i2 = 0; i2 < inSize; i2++) {
        pSize++;
        q = q.nextZ;
        if (!q) break;
      }
      qSize = inSize;
      while (pSize > 0 || qSize > 0 && q) {
        if (pSize !== 0 && (qSize === 0 || !q || p2.z <= q.z)) {
          e2 = p2;
          p2 = p2.nextZ;
          pSize--;
        } else {
          e2 = q;
          q = q.nextZ;
          qSize--;
        }
        if (tail) tail.nextZ = e2;
        else list = e2;
        e2.prevZ = tail;
        tail = e2;
      }
      p2 = q;
    }
    tail.nextZ = null;
    inSize *= 2;
  } while (numMerges > 1);
  return list;
}
function zOrder(x, y, minX, minY, invSize) {
  x = 32767 * (x - minX) * invSize;
  y = 32767 * (y - minY) * invSize;
  x = (x | x << 8) & 16711935;
  x = (x | x << 4) & 252645135;
  x = (x | x << 2) & 858993459;
  x = (x | x << 1) & 1431655765;
  y = (y | y << 8) & 16711935;
  y = (y | y << 4) & 252645135;
  y = (y | y << 2) & 858993459;
  y = (y | y << 1) & 1431655765;
  return x | y << 1;
}
function getLeftmost(start) {
  let p2 = start, leftmost = start;
  do {
    if (p2.x < leftmost.x || p2.x === leftmost.x && p2.y < leftmost.y) leftmost = p2;
    p2 = p2.next;
  } while (p2 !== start);
  return leftmost;
}
function pointInTriangle(ax, ay, bx, by, cx, cy, px2, py2) {
  return (cx - px2) * (ay - py2) - (ax - px2) * (cy - py2) >= 0 && (ax - px2) * (by - py2) - (bx - px2) * (ay - py2) >= 0 && (bx - px2) * (cy - py2) - (cx - px2) * (by - py2) >= 0;
}
function isValidDiagonal(a3, b) {
  return a3.next.i !== b.i && a3.prev.i !== b.i && !intersectsPolygon(a3, b) && // dones't intersect other edges
  (locallyInside(a3, b) && locallyInside(b, a3) && middleInside(a3, b) && // locally visible
  (area(a3.prev, a3, b.prev) || area(a3, b.prev, b)) || // does not create opposite-facing sectors
  equals(a3, b) && area(a3.prev, a3, a3.next) > 0 && area(b.prev, b, b.next) > 0);
}
function area(p2, q, r2) {
  return (q.y - p2.y) * (r2.x - q.x) - (q.x - p2.x) * (r2.y - q.y);
}
function equals(p1, p2) {
  return p1.x === p2.x && p1.y === p2.y;
}
function intersects(p1, q1, p2, q2) {
  const o1 = sign(area(p1, q1, p2));
  const o2 = sign(area(p1, q1, q2));
  const o3 = sign(area(p2, q2, p1));
  const o4 = sign(area(p2, q2, q1));
  if (o1 !== o2 && o3 !== o4) return true;
  if (o1 === 0 && onSegment(p1, p2, q1)) return true;
  if (o2 === 0 && onSegment(p1, q2, q1)) return true;
  if (o3 === 0 && onSegment(p2, p1, q2)) return true;
  if (o4 === 0 && onSegment(p2, q1, q2)) return true;
  return false;
}
function onSegment(p2, q, r2) {
  return q.x <= Math.max(p2.x, r2.x) && q.x >= Math.min(p2.x, r2.x) && q.y <= Math.max(p2.y, r2.y) && q.y >= Math.min(p2.y, r2.y);
}
function sign(num) {
  return num > 0 ? 1 : num < 0 ? -1 : 0;
}
function intersectsPolygon(a3, b) {
  let p2 = a3;
  do {
    if (p2.i !== a3.i && p2.next.i !== a3.i && p2.i !== b.i && p2.next.i !== b.i && intersects(p2, p2.next, a3, b)) return true;
    p2 = p2.next;
  } while (p2 !== a3);
  return false;
}
function locallyInside(a3, b) {
  return area(a3.prev, a3, a3.next) < 0 ? area(a3, b, a3.next) >= 0 && area(a3, a3.prev, b) >= 0 : area(a3, b, a3.prev) < 0 || area(a3, a3.next, b) < 0;
}
function middleInside(a3, b) {
  let p2 = a3, inside = false;
  const px2 = (a3.x + b.x) / 2, py2 = (a3.y + b.y) / 2;
  do {
    if (p2.y > py2 !== p2.next.y > py2 && p2.next.y !== p2.y && px2 < (p2.next.x - p2.x) * (py2 - p2.y) / (p2.next.y - p2.y) + p2.x)
      inside = !inside;
    p2 = p2.next;
  } while (p2 !== a3);
  return inside;
}
function splitPolygon(a3, b) {
  const a22 = new Node$1(a3.i, a3.x, a3.y), b2 = new Node$1(b.i, b.x, b.y), an = a3.next, bp = b.prev;
  a3.next = b;
  b.prev = a3;
  a22.next = an;
  an.prev = a22;
  b2.next = a22;
  a22.prev = b2;
  bp.next = b2;
  b2.prev = bp;
  return b2;
}
function insertNode(i2, x, y, last) {
  const p2 = new Node$1(i2, x, y);
  if (!last) {
    p2.prev = p2;
    p2.next = p2;
  } else {
    p2.next = last.next;
    p2.prev = last;
    last.next.prev = p2;
    last.next = p2;
  }
  return p2;
}
function removeNode(p2) {
  p2.next.prev = p2.prev;
  p2.prev.next = p2.next;
  if (p2.prevZ) p2.prevZ.nextZ = p2.nextZ;
  if (p2.nextZ) p2.nextZ.prevZ = p2.prevZ;
}
function Node$1(i2, x, y) {
  this.i = i2;
  this.x = x;
  this.y = y;
  this.prev = null;
  this.next = null;
  this.z = null;
  this.prevZ = null;
  this.nextZ = null;
  this.steiner = false;
}
function signedArea(data, start, end, dim) {
  let sum = 0;
  for (let i2 = start, j = end - dim; i2 < end; i2 += dim) {
    sum += (data[j] - data[i2]) * (data[i2 + 1] + data[j + 1]);
    j = i2;
  }
  return sum;
}
class ShapeUtils2 {
  // calculate area of the contour polygon
  static area(contour) {
    const n2 = contour.length;
    let a3 = 0;
    for (let p2 = n2 - 1, q = 0; q < n2; p2 = q++) {
      a3 += contour[p2].x * contour[q].y - contour[q].x * contour[p2].y;
    }
    return a3 * 0.5;
  }
  static isClockWise(pts) {
    return ShapeUtils2.area(pts) < 0;
  }
  static triangulateShape(contour, holes) {
    const vertices = [];
    const holeIndices = [];
    const faces = [];
    removeDupEndPts(contour);
    addContour(vertices, contour);
    let holeIndex = contour.length;
    holes.forEach(removeDupEndPts);
    for (let i2 = 0; i2 < holes.length; i2++) {
      holeIndices.push(holeIndex);
      holeIndex += holes[i2].length;
      addContour(vertices, holes[i2]);
    }
    const triangles = Earcut.triangulate(vertices, holeIndices);
    for (let i2 = 0; i2 < triangles.length; i2 += 3) {
      faces.push(triangles.slice(i2, i2 + 3));
    }
    return faces;
  }
}
function removeDupEndPts(points) {
  const l2 = points.length;
  if (l2 > 2 && points[l2 - 1].equals(points[0])) {
    points.pop();
  }
}
function addContour(vertices, contour) {
  for (let i2 = 0; i2 < contour.length; i2++) {
    vertices.push(contour[i2].x);
    vertices.push(contour[i2].y);
  }
}
class ExtrudeGeometry2 extends BufferGeometry2 {
  constructor(shapes, options) {
    super();
    this.type = "ExtrudeGeometry";
    this.parameters = {
      shapes,
      options
    };
    shapes = Array.isArray(shapes) ? shapes : [shapes];
    const scope = this;
    const verticesArray = [];
    const uvArray = [];
    for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
      const shape = shapes[i2];
      addShape(shape);
    }
    this.setAttribute("position", new Float32BufferAttribute2(verticesArray, 3));
    this.setAttribute("uv", new Float32BufferAttribute2(uvArray, 2));
    this.computeVertexNormals();
    function addShape(shape) {
      const placeholder = [];
      const curveSegments = options.curveSegments !== void 0 ? options.curveSegments : 12;
      const steps = options.steps !== void 0 ? options.steps : 1;
      let depth = options.depth !== void 0 ? options.depth : 100;
      let bevelEnabled = options.bevelEnabled !== void 0 ? options.bevelEnabled : true;
      let bevelThickness = options.bevelThickness !== void 0 ? options.bevelThickness : 6;
      let bevelSize = options.bevelSize !== void 0 ? options.bevelSize : bevelThickness - 2;
      let bevelOffset = options.bevelOffset !== void 0 ? options.bevelOffset : 0;
      let bevelSegments = options.bevelSegments !== void 0 ? options.bevelSegments : 3;
      const extrudePath = options.extrudePath;
      const uvgen = options.UVGenerator !== void 0 ? options.UVGenerator : WorldUVGenerator;
      if (options.amount !== void 0) {
        console.warn("THREE.ExtrudeBufferGeometry: amount has been renamed to depth.");
        depth = options.amount;
      }
      let extrudePts, extrudeByPath = false;
      let splineTube, binormal, normal, position2;
      if (extrudePath) {
        extrudePts = extrudePath.getSpacedPoints(steps);
        extrudeByPath = true;
        bevelEnabled = false;
        splineTube = extrudePath.computeFrenetFrames(steps, false);
        binormal = new Vector32();
        normal = new Vector32();
        position2 = new Vector32();
      }
      if (!bevelEnabled) {
        bevelSegments = 0;
        bevelThickness = 0;
        bevelSize = 0;
        bevelOffset = 0;
      }
      const shapePoints = shape.extractPoints(curveSegments);
      let vertices = shapePoints.shape;
      const holes = shapePoints.holes;
      const reverse = !ShapeUtils2.isClockWise(vertices);
      if (reverse) {
        vertices = vertices.reverse();
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          if (ShapeUtils2.isClockWise(ahole)) {
            holes[h2] = ahole.reverse();
          }
        }
      }
      const faces = ShapeUtils2.triangulateShape(vertices, holes);
      const contour = vertices;
      for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
        const ahole = holes[h2];
        vertices = vertices.concat(ahole);
      }
      function scalePt2(pt2, vec, size) {
        if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
        return vec.clone().multiplyScalar(size).add(pt2);
      }
      const vlen = vertices.length, flen = faces.length;
      function getBevelVec(inPt, inPrev, inNext) {
        let v_trans_x, v_trans_y, shrink_by;
        const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
        const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
        const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
        const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
        if (Math.abs(collinear0) > Number.EPSILON) {
          const v_prev_len = Math.sqrt(v_prev_lensq);
          const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
          const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
          const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
          const ptNextShift_x = inNext.x - v_next_y / v_next_len;
          const ptNextShift_y = inNext.y + v_next_x / v_next_len;
          const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
          v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
          v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
          const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
          if (v_trans_lensq <= 2) {
            return new Vector22(v_trans_x, v_trans_y);
          } else {
            shrink_by = Math.sqrt(v_trans_lensq / 2);
          }
        } else {
          let direction_eq = false;
          if (v_prev_x > Number.EPSILON) {
            if (v_next_x > Number.EPSILON) {
              direction_eq = true;
            }
          } else {
            if (v_prev_x < -Number.EPSILON) {
              if (v_next_x < -Number.EPSILON) {
                direction_eq = true;
              }
            } else {
              if (Math.sign(v_prev_y) === Math.sign(v_next_y)) {
                direction_eq = true;
              }
            }
          }
          if (direction_eq) {
            v_trans_x = -v_prev_y;
            v_trans_y = v_prev_x;
            shrink_by = Math.sqrt(v_prev_lensq);
          } else {
            v_trans_x = v_prev_x;
            v_trans_y = v_prev_y;
            shrink_by = Math.sqrt(v_prev_lensq / 2);
          }
        }
        return new Vector22(v_trans_x / shrink_by, v_trans_y / shrink_by);
      }
      const contourMovements = [];
      for (let i2 = 0, il = contour.length, j = il - 1, k = i2 + 1; i2 < il; i2++, j++, k++) {
        if (j === il) j = 0;
        if (k === il) k = 0;
        contourMovements[i2] = getBevelVec(contour[i2], contour[j], contour[k]);
      }
      const holesMovements = [];
      let oneHoleMovements, verticesMovements = contourMovements.concat();
      for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
        const ahole = holes[h2];
        oneHoleMovements = [];
        for (let i2 = 0, il = ahole.length, j = il - 1, k = i2 + 1; i2 < il; i2++, j++, k++) {
          if (j === il) j = 0;
          if (k === il) k = 0;
          oneHoleMovements[i2] = getBevelVec(ahole[i2], ahole[j], ahole[k]);
        }
        holesMovements.push(oneHoleMovements);
        verticesMovements = verticesMovements.concat(oneHoleMovements);
      }
      for (let b = 0; b < bevelSegments; b++) {
        const t3 = b / bevelSegments;
        const z2 = bevelThickness * Math.cos(t3 * Math.PI / 2);
        const bs2 = bevelSize * Math.sin(t3 * Math.PI / 2) + bevelOffset;
        for (let i2 = 0, il = contour.length; i2 < il; i2++) {
          const vert = scalePt2(contour[i2], contourMovements[i2], bs2);
          v(vert.x, vert.y, -z2);
        }
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          oneHoleMovements = holesMovements[h2];
          for (let i2 = 0, il = ahole.length; i2 < il; i2++) {
            const vert = scalePt2(ahole[i2], oneHoleMovements[i2], bs2);
            v(vert.x, vert.y, -z2);
          }
        }
      }
      const bs = bevelSize + bevelOffset;
      for (let i2 = 0; i2 < vlen; i2++) {
        const vert = bevelEnabled ? scalePt2(vertices[i2], verticesMovements[i2], bs) : vertices[i2];
        if (!extrudeByPath) {
          v(vert.x, vert.y, 0);
        } else {
          normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
          binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
          position2.copy(extrudePts[0]).add(normal).add(binormal);
          v(position2.x, position2.y, position2.z);
        }
      }
      for (let s2 = 1; s2 <= steps; s2++) {
        for (let i2 = 0; i2 < vlen; i2++) {
          const vert = bevelEnabled ? scalePt2(vertices[i2], verticesMovements[i2], bs) : vertices[i2];
          if (!extrudeByPath) {
            v(vert.x, vert.y, depth / steps * s2);
          } else {
            normal.copy(splineTube.normals[s2]).multiplyScalar(vert.x);
            binormal.copy(splineTube.binormals[s2]).multiplyScalar(vert.y);
            position2.copy(extrudePts[s2]).add(normal).add(binormal);
            v(position2.x, position2.y, position2.z);
          }
        }
      }
      for (let b = bevelSegments - 1; b >= 0; b--) {
        const t3 = b / bevelSegments;
        const z2 = bevelThickness * Math.cos(t3 * Math.PI / 2);
        const bs2 = bevelSize * Math.sin(t3 * Math.PI / 2) + bevelOffset;
        for (let i2 = 0, il = contour.length; i2 < il; i2++) {
          const vert = scalePt2(contour[i2], contourMovements[i2], bs2);
          v(vert.x, vert.y, depth + z2);
        }
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          oneHoleMovements = holesMovements[h2];
          for (let i2 = 0, il = ahole.length; i2 < il; i2++) {
            const vert = scalePt2(ahole[i2], oneHoleMovements[i2], bs2);
            if (!extrudeByPath) {
              v(vert.x, vert.y, depth + z2);
            } else {
              v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z2);
            }
          }
        }
      }
      buildLidFaces();
      buildSideFaces();
      function buildLidFaces() {
        const start = verticesArray.length / 3;
        if (bevelEnabled) {
          let layer = 0;
          let offset = vlen * layer;
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces[i2];
            f3(face[2] + offset, face[1] + offset, face[0] + offset);
          }
          layer = steps + bevelSegments * 2;
          offset = vlen * layer;
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces[i2];
            f3(face[0] + offset, face[1] + offset, face[2] + offset);
          }
        } else {
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces[i2];
            f3(face[2], face[1], face[0]);
          }
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces[i2];
            f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
          }
        }
        scope.addGroup(start, verticesArray.length / 3 - start, 0);
      }
      function buildSideFaces() {
        const start = verticesArray.length / 3;
        let layeroffset = 0;
        sidewalls(contour, layeroffset);
        layeroffset += contour.length;
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          sidewalls(ahole, layeroffset);
          layeroffset += ahole.length;
        }
        scope.addGroup(start, verticesArray.length / 3 - start, 1);
      }
      function sidewalls(contour2, layeroffset) {
        let i2 = contour2.length;
        while (--i2 >= 0) {
          const j = i2;
          let k = i2 - 1;
          if (k < 0) k = contour2.length - 1;
          for (let s2 = 0, sl = steps + bevelSegments * 2; s2 < sl; s2++) {
            const slen1 = vlen * s2;
            const slen2 = vlen * (s2 + 1);
            const a3 = layeroffset + j + slen1, b = layeroffset + k + slen1, c2 = layeroffset + k + slen2, d2 = layeroffset + j + slen2;
            f4(a3, b, c2, d2);
          }
        }
      }
      function v(x, y, z2) {
        placeholder.push(x);
        placeholder.push(y);
        placeholder.push(z2);
      }
      function f3(a3, b, c2) {
        addVertex(a3);
        addVertex(b);
        addVertex(c2);
        const nextIndex = verticesArray.length / 3;
        const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
        addUV(uvs[0]);
        addUV(uvs[1]);
        addUV(uvs[2]);
      }
      function f4(a3, b, c2, d2) {
        addVertex(a3);
        addVertex(b);
        addVertex(d2);
        addVertex(b);
        addVertex(c2);
        addVertex(d2);
        const nextIndex = verticesArray.length / 3;
        const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
        addUV(uvs[0]);
        addUV(uvs[1]);
        addUV(uvs[3]);
        addUV(uvs[1]);
        addUV(uvs[2]);
        addUV(uvs[3]);
      }
      function addVertex(index2) {
        verticesArray.push(placeholder[index2 * 3 + 0]);
        verticesArray.push(placeholder[index2 * 3 + 1]);
        verticesArray.push(placeholder[index2 * 3 + 2]);
      }
      function addUV(vector2) {
        uvArray.push(vector2.x);
        uvArray.push(vector2.y);
      }
    }
  }
  toJSON() {
    const data = super.toJSON();
    const shapes = this.parameters.shapes;
    const options = this.parameters.options;
    return toJSON$1(shapes, options, data);
  }
  static fromJSON(data, shapes) {
    const geometryShapes = [];
    for (let j = 0, jl = data.shapes.length; j < jl; j++) {
      const shape = shapes[data.shapes[j]];
      geometryShapes.push(shape);
    }
    const extrudePath = data.options.extrudePath;
    if (extrudePath !== void 0) {
      data.options.extrudePath = new Curves[extrudePath.type]().fromJSON(extrudePath);
    }
    return new ExtrudeGeometry2(geometryShapes, data.options);
  }
}
const WorldUVGenerator = {
  generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
    const a_x = vertices[indexA * 3];
    const a_y = vertices[indexA * 3 + 1];
    const b_x = vertices[indexB * 3];
    const b_y = vertices[indexB * 3 + 1];
    const c_x = vertices[indexC * 3];
    const c_y = vertices[indexC * 3 + 1];
    return [
      new Vector22(a_x, a_y),
      new Vector22(b_x, b_y),
      new Vector22(c_x, c_y)
    ];
  },
  generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
    const a_x = vertices[indexA * 3];
    const a_y = vertices[indexA * 3 + 1];
    const a_z = vertices[indexA * 3 + 2];
    const b_x = vertices[indexB * 3];
    const b_y = vertices[indexB * 3 + 1];
    const b_z = vertices[indexB * 3 + 2];
    const c_x = vertices[indexC * 3];
    const c_y = vertices[indexC * 3 + 1];
    const c_z = vertices[indexC * 3 + 2];
    const d_x = vertices[indexD * 3];
    const d_y = vertices[indexD * 3 + 1];
    const d_z = vertices[indexD * 3 + 2];
    if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) {
      return [
        new Vector22(a_x, 1 - a_z),
        new Vector22(b_x, 1 - b_z),
        new Vector22(c_x, 1 - c_z),
        new Vector22(d_x, 1 - d_z)
      ];
    } else {
      return [
        new Vector22(a_y, 1 - a_z),
        new Vector22(b_y, 1 - b_z),
        new Vector22(c_y, 1 - c_z),
        new Vector22(d_y, 1 - d_z)
      ];
    }
  }
};
function toJSON$1(shapes, options, data) {
  data.shapes = [];
  if (Array.isArray(shapes)) {
    for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
      const shape = shapes[i2];
      data.shapes.push(shape.uuid);
    }
  } else {
    data.shapes.push(shapes.uuid);
  }
  if (options.extrudePath !== void 0) data.options.extrudePath = options.extrudePath.toJSON();
  return data;
}
class ShapeGeometry2 extends BufferGeometry2 {
  constructor(shapes, curveSegments = 12) {
    super();
    this.type = "ShapeGeometry";
    this.parameters = {
      shapes,
      curveSegments
    };
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let groupStart = 0;
    let groupCount = 0;
    if (Array.isArray(shapes) === false) {
      addShape(shapes);
    } else {
      for (let i2 = 0; i2 < shapes.length; i2++) {
        addShape(shapes[i2]);
        this.addGroup(groupStart, groupCount, i2);
        groupStart += groupCount;
        groupCount = 0;
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute2(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute2(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute2(uvs, 2));
    function addShape(shape) {
      const indexOffset = vertices.length / 3;
      const points = shape.extractPoints(curveSegments);
      let shapeVertices = points.shape;
      const shapeHoles = points.holes;
      if (ShapeUtils2.isClockWise(shapeVertices) === false) {
        shapeVertices = shapeVertices.reverse();
      }
      for (let i2 = 0, l2 = shapeHoles.length; i2 < l2; i2++) {
        const shapeHole = shapeHoles[i2];
        if (ShapeUtils2.isClockWise(shapeHole) === true) {
          shapeHoles[i2] = shapeHole.reverse();
        }
      }
      const faces = ShapeUtils2.triangulateShape(shapeVertices, shapeHoles);
      for (let i2 = 0, l2 = shapeHoles.length; i2 < l2; i2++) {
        const shapeHole = shapeHoles[i2];
        shapeVertices = shapeVertices.concat(shapeHole);
      }
      for (let i2 = 0, l2 = shapeVertices.length; i2 < l2; i2++) {
        const vertex2 = shapeVertices[i2];
        vertices.push(vertex2.x, vertex2.y, 0);
        normals.push(0, 0, 1);
        uvs.push(vertex2.x, vertex2.y);
      }
      for (let i2 = 0, l2 = faces.length; i2 < l2; i2++) {
        const face = faces[i2];
        const a3 = face[0] + indexOffset;
        const b = face[1] + indexOffset;
        const c2 = face[2] + indexOffset;
        indices.push(a3, b, c2);
        groupCount += 3;
      }
    }
  }
  toJSON() {
    const data = super.toJSON();
    const shapes = this.parameters.shapes;
    return toJSON(shapes, data);
  }
  static fromJSON(data, shapes) {
    const geometryShapes = [];
    for (let j = 0, jl = data.shapes.length; j < jl; j++) {
      const shape = shapes[data.shapes[j]];
      geometryShapes.push(shape);
    }
    return new ShapeGeometry2(geometryShapes, data.curveSegments);
  }
}
function toJSON(shapes, data) {
  data.shapes = [];
  if (Array.isArray(shapes)) {
    for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
      const shape = shapes[i2];
      data.shapes.push(shape.uuid);
    }
  } else {
    data.shapes.push(shapes.uuid);
  }
  return data;
}
class ShadowMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.type = "ShadowMaterial";
    this.color = new Color2(0);
    this.transparent = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    return this;
  }
}
ShadowMaterial2.prototype.isShadowMaterial = true;
class MeshStandardMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.defines = { "STANDARD": "" };
    this.type = "MeshStandardMaterial";
    this.color = new Color2(16777215);
    this.roughness = 1;
    this.metalness = 0;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color2(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector22(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.roughnessMap = null;
    this.metalnessMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapIntensity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.flatShading = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.defines = { "STANDARD": "" };
    this.color.copy(source.color);
    this.roughness = source.roughness;
    this.metalness = source.metalness;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.roughnessMap = source.roughnessMap;
    this.metalnessMap = source.metalnessMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.envMapIntensity = source.envMapIntensity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.flatShading = source.flatShading;
    return this;
  }
}
MeshStandardMaterial2.prototype.isMeshStandardMaterial = true;
class MeshPhysicalMaterial2 extends MeshStandardMaterial2 {
  constructor(parameters) {
    super();
    this.defines = {
      "STANDARD": "",
      "PHYSICAL": ""
    };
    this.type = "MeshPhysicalMaterial";
    this.clearcoatMap = null;
    this.clearcoatRoughness = 0;
    this.clearcoatRoughnessMap = null;
    this.clearcoatNormalScale = new Vector22(1, 1);
    this.clearcoatNormalMap = null;
    this.ior = 1.5;
    Object.defineProperty(this, "reflectivity", {
      get: function() {
        return clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
      },
      set: function(reflectivity) {
        this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
      }
    });
    this.sheenTint = new Color2(0);
    this.transmission = 0;
    this.transmissionMap = null;
    this.thickness = 0.01;
    this.thicknessMap = null;
    this.attenuationDistance = 0;
    this.attenuationTint = new Color2(1, 1, 1);
    this.specularIntensity = 1;
    this.specularIntensityMap = null;
    this.specularTint = new Color2(1, 1, 1);
    this.specularTintMap = null;
    this._clearcoat = 0;
    this._transmission = 0;
    this.setValues(parameters);
  }
  get clearcoat() {
    return this._clearcoat;
  }
  set clearcoat(value) {
    if (this._clearcoat > 0 !== value > 0) {
      this.version++;
    }
    this._clearcoat = value;
  }
  get transmission() {
    return this._transmission;
  }
  set transmission(value) {
    if (this._transmission > 0 !== value > 0) {
      this.version++;
    }
    this._transmission = value;
  }
  copy(source) {
    super.copy(source);
    this.defines = {
      "STANDARD": "",
      "PHYSICAL": ""
    };
    this.clearcoat = source.clearcoat;
    this.clearcoatMap = source.clearcoatMap;
    this.clearcoatRoughness = source.clearcoatRoughness;
    this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
    this.clearcoatNormalMap = source.clearcoatNormalMap;
    this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
    this.ior = source.ior;
    this.sheenTint.copy(source.sheenTint);
    this.transmission = source.transmission;
    this.transmissionMap = source.transmissionMap;
    this.thickness = source.thickness;
    this.thicknessMap = source.thicknessMap;
    this.attenuationDistance = source.attenuationDistance;
    this.attenuationTint.copy(source.attenuationTint);
    this.specularIntensity = source.specularIntensity;
    this.specularIntensityMap = source.specularIntensityMap;
    this.specularTint.copy(source.specularTint);
    this.specularTintMap = source.specularTintMap;
    return this;
  }
}
MeshPhysicalMaterial2.prototype.isMeshPhysicalMaterial = true;
class MeshPhongMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.type = "MeshPhongMaterial";
    this.color = new Color2(16777215);
    this.specular = new Color2(1118481);
    this.shininess = 30;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color2(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector22(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.flatShading = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.specular.copy(source.specular);
    this.shininess = source.shininess;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.flatShading = source.flatShading;
    return this;
  }
}
MeshPhongMaterial2.prototype.isMeshPhongMaterial = true;
class MeshToonMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.defines = { "TOON": "" };
    this.type = "MeshToonMaterial";
    this.color = new Color2(16777215);
    this.map = null;
    this.gradientMap = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color2(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector22(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.gradientMap = source.gradientMap;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    return this;
  }
}
MeshToonMaterial2.prototype.isMeshToonMaterial = true;
class MeshNormalMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.type = "MeshNormalMaterial";
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector22(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.flatShading = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.flatShading = source.flatShading;
    return this;
  }
}
MeshNormalMaterial2.prototype.isMeshNormalMaterial = true;
class MeshLambertMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.type = "MeshLambertMaterial";
    this.color = new Color2(16777215);
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color2(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    return this;
  }
}
MeshLambertMaterial2.prototype.isMeshLambertMaterial = true;
class MeshMatcapMaterial2 extends Material2 {
  constructor(parameters) {
    super();
    this.defines = { "MATCAP": "" };
    this.type = "MeshMatcapMaterial";
    this.color = new Color2(16777215);
    this.matcap = null;
    this.map = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector22(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.flatShading = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.defines = { "MATCAP": "" };
    this.color.copy(source.color);
    this.matcap = source.matcap;
    this.map = source.map;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.flatShading = source.flatShading;
    return this;
  }
}
MeshMatcapMaterial2.prototype.isMeshMatcapMaterial = true;
class LineDashedMaterial2 extends LineBasicMaterial2 {
  constructor(parameters) {
    super();
    this.type = "LineDashedMaterial";
    this.scale = 1;
    this.dashSize = 3;
    this.gapSize = 1;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.scale = source.scale;
    this.dashSize = source.dashSize;
    this.gapSize = source.gapSize;
    return this;
  }
}
LineDashedMaterial2.prototype.isLineDashedMaterial = true;
const AnimationUtils = {
  // same as Array.prototype.slice, but also works on typed arrays
  arraySlice: function(array, from, to) {
    if (AnimationUtils.isTypedArray(array)) {
      return new array.constructor(array.subarray(from, to !== void 0 ? to : array.length));
    }
    return array.slice(from, to);
  },
  // converts an array to a specific type
  convertArray: function(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === "number") {
      return new type(array);
    }
    return Array.prototype.slice.call(array);
  },
  isTypedArray: function(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
  },
  // returns an array by which times and values can be sorted
  getKeyframeOrder: function(times2) {
    function compareTime(i2, j) {
      return times2[i2] - times2[j];
    }
    const n2 = times2.length;
    const result = new Array(n2);
    for (let i2 = 0; i2 !== n2; ++i2) result[i2] = i2;
    result.sort(compareTime);
    return result;
  },
  // uses the array previously returned by 'getKeyframeOrder' to sort data
  sortedArray: function(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for (let i2 = 0, dstOffset = 0; dstOffset !== nValues; ++i2) {
      const srcOffset = order[i2] * stride;
      for (let j = 0; j !== stride; ++j) {
        result[dstOffset++] = values[srcOffset + j];
      }
    }
    return result;
  },
  // function for parsing AOS keyframe formats
  flattenJSON: function(jsonKeys, times2, values, valuePropertyName) {
    let i2 = 1, key = jsonKeys[0];
    while (key !== void 0 && key[valuePropertyName] === void 0) {
      key = jsonKeys[i2++];
    }
    if (key === void 0) return;
    let value = key[valuePropertyName];
    if (value === void 0) return;
    if (Array.isArray(value)) {
      do {
        value = key[valuePropertyName];
        if (value !== void 0) {
          times2.push(key.time);
          values.push.apply(values, value);
        }
        key = jsonKeys[i2++];
      } while (key !== void 0);
    } else if (value.toArray !== void 0) {
      do {
        value = key[valuePropertyName];
        if (value !== void 0) {
          times2.push(key.time);
          value.toArray(values, values.length);
        }
        key = jsonKeys[i2++];
      } while (key !== void 0);
    } else {
      do {
        value = key[valuePropertyName];
        if (value !== void 0) {
          times2.push(key.time);
          values.push(value);
        }
        key = jsonKeys[i2++];
      } while (key !== void 0);
    }
  },
  subclip: function(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for (let i2 = 0; i2 < clip.tracks.length; ++i2) {
      const track = clip.tracks[i2];
      const valueSize = track.getValueSize();
      const times2 = [];
      const values = [];
      for (let j = 0; j < track.times.length; ++j) {
        const frame = track.times[j] * fps;
        if (frame < startFrame || frame >= endFrame) continue;
        times2.push(track.times[j]);
        for (let k = 0; k < valueSize; ++k) {
          values.push(track.values[j * valueSize + k]);
        }
      }
      if (times2.length === 0) continue;
      track.times = AnimationUtils.convertArray(times2, track.times.constructor);
      track.values = AnimationUtils.convertArray(values, track.values.constructor);
      tracks.push(track);
    }
    clip.tracks = tracks;
    let minStartTime = Infinity;
    for (let i2 = 0; i2 < clip.tracks.length; ++i2) {
      if (minStartTime > clip.tracks[i2].times[0]) {
        minStartTime = clip.tracks[i2].times[0];
      }
    }
    for (let i2 = 0; i2 < clip.tracks.length; ++i2) {
      clip.tracks[i2].shift(-1 * minStartTime);
    }
    clip.resetDuration();
    return clip;
  },
  makeClipAdditive: function(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    for (let i2 = 0; i2 < numTracks; ++i2) {
      const referenceTrack = referenceClip.tracks[i2];
      const referenceTrackType = referenceTrack.ValueTypeName;
      if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
      const targetTrack = targetClip.tracks.find(function(track) {
        return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
      });
      if (targetTrack === void 0) continue;
      let referenceOffset = 0;
      const referenceValueSize = referenceTrack.getValueSize();
      if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {
        referenceOffset = referenceValueSize / 3;
      }
      let targetOffset = 0;
      const targetValueSize = targetTrack.getValueSize();
      if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {
        targetOffset = targetValueSize / 3;
      }
      const lastIndex = referenceTrack.times.length - 1;
      let referenceValue;
      if (referenceTime <= referenceTrack.times[0]) {
        const startIndex = referenceOffset;
        const endIndex = referenceValueSize - referenceOffset;
        referenceValue = AnimationUtils.arraySlice(referenceTrack.values, startIndex, endIndex);
      } else if (referenceTime >= referenceTrack.times[lastIndex]) {
        const startIndex = lastIndex * referenceValueSize + referenceOffset;
        const endIndex = startIndex + referenceValueSize - referenceOffset;
        referenceValue = AnimationUtils.arraySlice(referenceTrack.values, startIndex, endIndex);
      } else {
        const interpolant = referenceTrack.createInterpolant();
        const startIndex = referenceOffset;
        const endIndex = referenceValueSize - referenceOffset;
        interpolant.evaluate(referenceTime);
        referenceValue = AnimationUtils.arraySlice(interpolant.resultBuffer, startIndex, endIndex);
      }
      if (referenceTrackType === "quaternion") {
        const referenceQuat = new Quaternion2().fromArray(referenceValue).normalize().conjugate();
        referenceQuat.toArray(referenceValue);
      }
      const numTimes = targetTrack.times.length;
      for (let j = 0; j < numTimes; ++j) {
        const valueStart = j * targetValueSize + targetOffset;
        if (referenceTrackType === "quaternion") {
          Quaternion2.multiplyQuaternionsFlat(
            targetTrack.values,
            valueStart,
            referenceValue,
            0,
            targetTrack.values,
            valueStart
          );
        } else {
          const valueEnd = targetValueSize - targetOffset * 2;
          for (let k = 0; k < valueEnd; ++k) {
            targetTrack.values[valueStart + k] -= referenceValue[k];
          }
        }
      }
    }
    targetClip.blendMode = AdditiveAnimationBlendMode;
    return targetClip;
  }
};
class Interpolant2 {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    this.parameterPositions = parameterPositions;
    this._cachedIndex = 0;
    this.resultBuffer = resultBuffer !== void 0 ? resultBuffer : new sampleValues.constructor(sampleSize);
    this.sampleValues = sampleValues;
    this.valueSize = sampleSize;
    this.settings = null;
    this.DefaultSettings_ = {};
  }
  evaluate(t3) {
    const pp = this.parameterPositions;
    let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
    validate_interval: {
      seek: {
        let right;
        linear_scan: {
          forward_scan: if (!(t3 < t1)) {
            for (let giveUpAt = i1 + 2; ; ) {
              if (t1 === void 0) {
                if (t3 < t0) break forward_scan;
                i1 = pp.length;
                this._cachedIndex = i1;
                return this.afterEnd_(i1 - 1, t3, t0);
              }
              if (i1 === giveUpAt) break;
              t0 = t1;
              t1 = pp[++i1];
              if (t3 < t1) {
                break seek;
              }
            }
            right = pp.length;
            break linear_scan;
          }
          if (!(t3 >= t0)) {
            const t1global = pp[1];
            if (t3 < t1global) {
              i1 = 2;
              t0 = t1global;
            }
            for (let giveUpAt = i1 - 2; ; ) {
              if (t0 === void 0) {
                this._cachedIndex = 0;
                return this.beforeStart_(0, t3, t1);
              }
              if (i1 === giveUpAt) break;
              t1 = t0;
              t0 = pp[--i1 - 1];
              if (t3 >= t0) {
                break seek;
              }
            }
            right = i1;
            i1 = 0;
            break linear_scan;
          }
          break validate_interval;
        }
        while (i1 < right) {
          const mid = i1 + right >>> 1;
          if (t3 < pp[mid]) {
            right = mid;
          } else {
            i1 = mid + 1;
          }
        }
        t1 = pp[i1];
        t0 = pp[i1 - 1];
        if (t0 === void 0) {
          this._cachedIndex = 0;
          return this.beforeStart_(0, t3, t1);
        }
        if (t1 === void 0) {
          i1 = pp.length;
          this._cachedIndex = i1;
          return this.afterEnd_(i1 - 1, t0, t3);
        }
      }
      this._cachedIndex = i1;
      this.intervalChanged_(i1, t0, t1);
    }
    return this.interpolate_(i1, t0, t3, t1);
  }
  getSettings_() {
    return this.settings || this.DefaultSettings_;
  }
  copySampleValue_(index2) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index2 * stride;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result[i2] = values[offset + i2];
    }
    return result;
  }
  // Template methods for derived classes:
  interpolate_() {
    throw new Error("call to abstract method");
  }
  intervalChanged_() {
  }
}
Interpolant2.prototype.beforeStart_ = Interpolant2.prototype.copySampleValue_;
Interpolant2.prototype.afterEnd_ = Interpolant2.prototype.copySampleValue_;
class CubicInterpolant2 extends Interpolant2 {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    this._weightPrev = -0;
    this._offsetPrev = -0;
    this._weightNext = -0;
    this._offsetNext = -0;
    this.DefaultSettings_ = {
      endingStart: ZeroCurvatureEnding,
      endingEnd: ZeroCurvatureEnding
    };
  }
  intervalChanged_(i1, t0, t1) {
    const pp = this.parameterPositions;
    let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
    if (tPrev === void 0) {
      switch (this.getSettings_().endingStart) {
        case ZeroSlopeEnding:
          iPrev = i1;
          tPrev = 2 * t0 - t1;
          break;
        case WrapAroundEnding:
          iPrev = pp.length - 2;
          tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
          break;
        default:
          iPrev = i1;
          tPrev = t1;
      }
    }
    if (tNext === void 0) {
      switch (this.getSettings_().endingEnd) {
        case ZeroSlopeEnding:
          iNext = i1;
          tNext = 2 * t1 - t0;
          break;
        case WrapAroundEnding:
          iNext = 1;
          tNext = t1 + pp[1] - pp[0];
          break;
        default:
          iNext = i1 - 1;
          tNext = t0;
      }
    }
    const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
    this._weightPrev = halfDt / (t0 - tPrev);
    this._weightNext = halfDt / (tNext - t1);
    this._offsetPrev = iPrev * stride;
    this._offsetNext = iNext * stride;
  }
  interpolate_(i1, t0, t3, t1) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p2 = (t3 - t0) / (t1 - t0), pp = p2 * p2, ppp = pp * p2;
    const sP = -wP * ppp + 2 * wP * pp - wP * p2;
    const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p2 + 1;
    const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p2;
    const sN = wN * ppp - wN * pp;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result[i2] = sP * values[oP + i2] + s0 * values[o0 + i2] + s1 * values[o1 + i2] + sN * values[oN + i2];
    }
    return result;
  }
}
class LinearInterpolant2 extends Interpolant2 {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1, t0, t3, t1) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t3 - t0) / (t1 - t0), weight0 = 1 - weight1;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result[i2] = values[offset0 + i2] * weight0 + values[offset1 + i2] * weight1;
    }
    return result;
  }
}
class DiscreteInterpolant2 extends Interpolant2 {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1) {
    return this.copySampleValue_(i1 - 1);
  }
}
class KeyframeTrack2 {
  constructor(name, times2, values, interpolation) {
    if (name === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined");
    if (times2 === void 0 || times2.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
    this.name = name;
    this.times = AnimationUtils.convertArray(times2, this.TimeBufferType);
    this.values = AnimationUtils.convertArray(values, this.ValueBufferType);
    this.setInterpolation(interpolation || this.DefaultInterpolation);
  }
  // Serialization (in static context, because of constructor invocation
  // and automatic invocation of .toJSON):
  static toJSON(track) {
    const trackType = track.constructor;
    let json;
    if (trackType.toJSON !== this.toJSON) {
      json = trackType.toJSON(track);
    } else {
      json = {
        "name": track.name,
        "times": AnimationUtils.convertArray(track.times, Array),
        "values": AnimationUtils.convertArray(track.values, Array)
      };
      const interpolation = track.getInterpolation();
      if (interpolation !== track.DefaultInterpolation) {
        json.interpolation = interpolation;
      }
    }
    json.type = track.ValueTypeName;
    return json;
  }
  InterpolantFactoryMethodDiscrete(result) {
    return new DiscreteInterpolant2(this.times, this.values, this.getValueSize(), result);
  }
  InterpolantFactoryMethodLinear(result) {
    return new LinearInterpolant2(this.times, this.values, this.getValueSize(), result);
  }
  InterpolantFactoryMethodSmooth(result) {
    return new CubicInterpolant2(this.times, this.values, this.getValueSize(), result);
  }
  setInterpolation(interpolation) {
    let factoryMethod;
    switch (interpolation) {
      case InterpolateDiscrete:
        factoryMethod = this.InterpolantFactoryMethodDiscrete;
        break;
      case InterpolateLinear:
        factoryMethod = this.InterpolantFactoryMethodLinear;
        break;
      case InterpolateSmooth:
        factoryMethod = this.InterpolantFactoryMethodSmooth;
        break;
    }
    if (factoryMethod === void 0) {
      const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
      if (this.createInterpolant === void 0) {
        if (interpolation !== this.DefaultInterpolation) {
          this.setInterpolation(this.DefaultInterpolation);
        } else {
          throw new Error(message);
        }
      }
      console.warn("THREE.KeyframeTrack:", message);
      return this;
    }
    this.createInterpolant = factoryMethod;
    return this;
  }
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return InterpolateDiscrete;
      case this.InterpolantFactoryMethodLinear:
        return InterpolateLinear;
      case this.InterpolantFactoryMethodSmooth:
        return InterpolateSmooth;
    }
  }
  getValueSize() {
    return this.values.length / this.times.length;
  }
  // move all keyframes either forwards or backwards in time
  shift(timeOffset) {
    if (timeOffset !== 0) {
      const times2 = this.times;
      for (let i2 = 0, n2 = times2.length; i2 !== n2; ++i2) {
        times2[i2] += timeOffset;
      }
    }
    return this;
  }
  // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
  scale(timeScale) {
    if (timeScale !== 1) {
      const times2 = this.times;
      for (let i2 = 0, n2 = times2.length; i2 !== n2; ++i2) {
        times2[i2] *= timeScale;
      }
    }
    return this;
  }
  // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
  // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
  trim(startTime, endTime) {
    const times2 = this.times, nKeys = times2.length;
    let from = 0, to = nKeys - 1;
    while (from !== nKeys && times2[from] < startTime) {
      ++from;
    }
    while (to !== -1 && times2[to] > endTime) {
      --to;
    }
    ++to;
    if (from !== 0 || to !== nKeys) {
      if (from >= to) {
        to = Math.max(to, 1);
        from = to - 1;
      }
      const stride = this.getValueSize();
      this.times = AnimationUtils.arraySlice(times2, from, to);
      this.values = AnimationUtils.arraySlice(this.values, from * stride, to * stride);
    }
    return this;
  }
  // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
  validate() {
    let valid = true;
    const valueSize = this.getValueSize();
    if (valueSize - Math.floor(valueSize) !== 0) {
      console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
      valid = false;
    }
    const times2 = this.times, values = this.values, nKeys = times2.length;
    if (nKeys === 0) {
      console.error("THREE.KeyframeTrack: Track is empty.", this);
      valid = false;
    }
    let prevTime = null;
    for (let i2 = 0; i2 !== nKeys; i2++) {
      const currTime = times2[i2];
      if (typeof currTime === "number" && isNaN(currTime)) {
        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i2, currTime);
        valid = false;
        break;
      }
      if (prevTime !== null && prevTime > currTime) {
        console.error("THREE.KeyframeTrack: Out of order keys.", this, i2, currTime, prevTime);
        valid = false;
        break;
      }
      prevTime = currTime;
    }
    if (values !== void 0) {
      if (AnimationUtils.isTypedArray(values)) {
        for (let i2 = 0, n2 = values.length; i2 !== n2; ++i2) {
          const value = values[i2];
          if (isNaN(value)) {
            console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i2, value);
            valid = false;
            break;
          }
        }
      }
    }
    return valid;
  }
  // removes equivalent sequential keys as common in morph target sequences
  // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
  optimize() {
    const times2 = AnimationUtils.arraySlice(this.times), values = AnimationUtils.arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === InterpolateSmooth, lastIndex = times2.length - 1;
    let writeIndex = 1;
    for (let i2 = 1; i2 < lastIndex; ++i2) {
      let keep = false;
      const time2 = times2[i2];
      const timeNext = times2[i2 + 1];
      if (time2 !== timeNext && (i2 !== 1 || time2 !== times2[0])) {
        if (!smoothInterpolation) {
          const offset = i2 * stride, offsetP = offset - stride, offsetN = offset + stride;
          for (let j = 0; j !== stride; ++j) {
            const value = values[offset + j];
            if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
              keep = true;
              break;
            }
          }
        } else {
          keep = true;
        }
      }
      if (keep) {
        if (i2 !== writeIndex) {
          times2[writeIndex] = times2[i2];
          const readOffset = i2 * stride, writeOffset = writeIndex * stride;
          for (let j = 0; j !== stride; ++j) {
            values[writeOffset + j] = values[readOffset + j];
          }
        }
        ++writeIndex;
      }
    }
    if (lastIndex > 0) {
      times2[writeIndex] = times2[lastIndex];
      for (let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j) {
        values[writeOffset + j] = values[readOffset + j];
      }
      ++writeIndex;
    }
    if (writeIndex !== times2.length) {
      this.times = AnimationUtils.arraySlice(times2, 0, writeIndex);
      this.values = AnimationUtils.arraySlice(values, 0, writeIndex * stride);
    } else {
      this.times = times2;
      this.values = values;
    }
    return this;
  }
  clone() {
    const times2 = AnimationUtils.arraySlice(this.times, 0);
    const values = AnimationUtils.arraySlice(this.values, 0);
    const TypedKeyframeTrack = this.constructor;
    const track = new TypedKeyframeTrack(this.name, times2, values);
    track.createInterpolant = this.createInterpolant;
    return track;
  }
}
KeyframeTrack2.prototype.TimeBufferType = Float32Array;
KeyframeTrack2.prototype.ValueBufferType = Float32Array;
KeyframeTrack2.prototype.DefaultInterpolation = InterpolateLinear;
class BooleanKeyframeTrack2 extends KeyframeTrack2 {
}
BooleanKeyframeTrack2.prototype.ValueTypeName = "bool";
BooleanKeyframeTrack2.prototype.ValueBufferType = Array;
BooleanKeyframeTrack2.prototype.DefaultInterpolation = InterpolateDiscrete;
BooleanKeyframeTrack2.prototype.InterpolantFactoryMethodLinear = void 0;
BooleanKeyframeTrack2.prototype.InterpolantFactoryMethodSmooth = void 0;
class ColorKeyframeTrack2 extends KeyframeTrack2 {
}
ColorKeyframeTrack2.prototype.ValueTypeName = "color";
class NumberKeyframeTrack2 extends KeyframeTrack2 {
}
NumberKeyframeTrack2.prototype.ValueTypeName = "number";
class QuaternionLinearInterpolant2 extends Interpolant2 {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1, t0, t3, t1) {
    const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t3 - t0) / (t1 - t0);
    let offset = i1 * stride;
    for (let end = offset + stride; offset !== end; offset += 4) {
      Quaternion2.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
    }
    return result;
  }
}
class QuaternionKeyframeTrack2 extends KeyframeTrack2 {
  InterpolantFactoryMethodLinear(result) {
    return new QuaternionLinearInterpolant2(this.times, this.values, this.getValueSize(), result);
  }
}
QuaternionKeyframeTrack2.prototype.ValueTypeName = "quaternion";
QuaternionKeyframeTrack2.prototype.DefaultInterpolation = InterpolateLinear;
QuaternionKeyframeTrack2.prototype.InterpolantFactoryMethodSmooth = void 0;
class StringKeyframeTrack2 extends KeyframeTrack2 {
}
StringKeyframeTrack2.prototype.ValueTypeName = "string";
StringKeyframeTrack2.prototype.ValueBufferType = Array;
StringKeyframeTrack2.prototype.DefaultInterpolation = InterpolateDiscrete;
StringKeyframeTrack2.prototype.InterpolantFactoryMethodLinear = void 0;
StringKeyframeTrack2.prototype.InterpolantFactoryMethodSmooth = void 0;
class VectorKeyframeTrack2 extends KeyframeTrack2 {
}
VectorKeyframeTrack2.prototype.ValueTypeName = "vector";
class AnimationClip2 {
  constructor(name, duration2 = -1, tracks, blendMode = NormalAnimationBlendMode) {
    this.name = name;
    this.tracks = tracks;
    this.duration = duration2;
    this.blendMode = blendMode;
    this.uuid = generateUUID();
    if (this.duration < 0) {
      this.resetDuration();
    }
  }
  static parse(json) {
    const tracks = [], jsonTracks = json.tracks, frameTime = 1 / (json.fps || 1);
    for (let i2 = 0, n2 = jsonTracks.length; i2 !== n2; ++i2) {
      tracks.push(parseKeyframeTrack(jsonTracks[i2]).scale(frameTime));
    }
    const clip = new this(json.name, json.duration, tracks, json.blendMode);
    clip.uuid = json.uuid;
    return clip;
  }
  static toJSON(clip) {
    const tracks = [], clipTracks = clip.tracks;
    const json = {
      "name": clip.name,
      "duration": clip.duration,
      "tracks": tracks,
      "uuid": clip.uuid,
      "blendMode": clip.blendMode
    };
    for (let i2 = 0, n2 = clipTracks.length; i2 !== n2; ++i2) {
      tracks.push(KeyframeTrack2.toJSON(clipTracks[i2]));
    }
    return json;
  }
  static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
    const numMorphTargets = morphTargetSequence.length;
    const tracks = [];
    for (let i2 = 0; i2 < numMorphTargets; i2++) {
      let times2 = [];
      let values = [];
      times2.push(
        (i2 + numMorphTargets - 1) % numMorphTargets,
        i2,
        (i2 + 1) % numMorphTargets
      );
      values.push(0, 1, 0);
      const order = AnimationUtils.getKeyframeOrder(times2);
      times2 = AnimationUtils.sortedArray(times2, 1, order);
      values = AnimationUtils.sortedArray(values, 1, order);
      if (!noLoop && times2[0] === 0) {
        times2.push(numMorphTargets);
        values.push(values[0]);
      }
      tracks.push(
        new NumberKeyframeTrack2(
          ".morphTargetInfluences[" + morphTargetSequence[i2].name + "]",
          times2,
          values
        ).scale(1 / fps)
      );
    }
    return new this(name, -1, tracks);
  }
  static findByName(objectOrClipArray, name) {
    let clipArray = objectOrClipArray;
    if (!Array.isArray(objectOrClipArray)) {
      const o2 = objectOrClipArray;
      clipArray = o2.geometry && o2.geometry.animations || o2.animations;
    }
    for (let i2 = 0; i2 < clipArray.length; i2++) {
      if (clipArray[i2].name === name) {
        return clipArray[i2];
      }
    }
    return null;
  }
  static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
    const animationToMorphTargets = {};
    const pattern = /^([\w-]*?)([\d]+)$/;
    for (let i2 = 0, il = morphTargets.length; i2 < il; i2++) {
      const morphTarget = morphTargets[i2];
      const parts = morphTarget.name.match(pattern);
      if (parts && parts.length > 1) {
        const name = parts[1];
        let animationMorphTargets = animationToMorphTargets[name];
        if (!animationMorphTargets) {
          animationToMorphTargets[name] = animationMorphTargets = [];
        }
        animationMorphTargets.push(morphTarget);
      }
    }
    const clips = [];
    for (const name in animationToMorphTargets) {
      clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
    }
    return clips;
  }
  // parse the animation.hierarchy format
  static parseAnimation(animation, bones) {
    if (!animation) {
      console.error("THREE.AnimationClip: No animation in JSONLoader data.");
      return null;
    }
    const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
      if (animationKeys.length !== 0) {
        const times2 = [];
        const values = [];
        AnimationUtils.flattenJSON(animationKeys, times2, values, propertyName);
        if (times2.length !== 0) {
          destTracks.push(new trackType(trackName, times2, values));
        }
      }
    };
    const tracks = [];
    const clipName = animation.name || "default";
    const fps = animation.fps || 30;
    const blendMode = animation.blendMode;
    let duration2 = animation.length || -1;
    const hierarchyTracks = animation.hierarchy || [];
    for (let h2 = 0; h2 < hierarchyTracks.length; h2++) {
      const animationKeys = hierarchyTracks[h2].keys;
      if (!animationKeys || animationKeys.length === 0) continue;
      if (animationKeys[0].morphTargets) {
        const morphTargetNames = {};
        let k;
        for (k = 0; k < animationKeys.length; k++) {
          if (animationKeys[k].morphTargets) {
            for (let m = 0; m < animationKeys[k].morphTargets.length; m++) {
              morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
            }
          }
        }
        for (const morphTargetName in morphTargetNames) {
          const times2 = [];
          const values = [];
          for (let m = 0; m !== animationKeys[k].morphTargets.length; ++m) {
            const animationKey = animationKeys[k];
            times2.push(animationKey.time);
            values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
          }
          tracks.push(new NumberKeyframeTrack2(".morphTargetInfluence[" + morphTargetName + "]", times2, values));
        }
        duration2 = morphTargetNames.length * fps;
      } else {
        const boneName = ".bones[" + bones[h2].name + "]";
        addNonemptyTrack(
          VectorKeyframeTrack2,
          boneName + ".position",
          animationKeys,
          "pos",
          tracks
        );
        addNonemptyTrack(
          QuaternionKeyframeTrack2,
          boneName + ".quaternion",
          animationKeys,
          "rot",
          tracks
        );
        addNonemptyTrack(
          VectorKeyframeTrack2,
          boneName + ".scale",
          animationKeys,
          "scl",
          tracks
        );
      }
    }
    if (tracks.length === 0) {
      return null;
    }
    const clip = new this(clipName, duration2, tracks, blendMode);
    return clip;
  }
  resetDuration() {
    const tracks = this.tracks;
    let duration2 = 0;
    for (let i2 = 0, n2 = tracks.length; i2 !== n2; ++i2) {
      const track = this.tracks[i2];
      duration2 = Math.max(duration2, track.times[track.times.length - 1]);
    }
    this.duration = duration2;
    return this;
  }
  trim() {
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      this.tracks[i2].trim(0, this.duration);
    }
    return this;
  }
  validate() {
    let valid = true;
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      valid = valid && this.tracks[i2].validate();
    }
    return valid;
  }
  optimize() {
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      this.tracks[i2].optimize();
    }
    return this;
  }
  clone() {
    const tracks = [];
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      tracks.push(this.tracks[i2].clone());
    }
    return new this.constructor(this.name, this.duration, tracks, this.blendMode);
  }
  toJSON() {
    return this.constructor.toJSON(this);
  }
}
function getTrackTypeForValueTypeName(typeName) {
  switch (typeName.toLowerCase()) {
    case "scalar":
    case "double":
    case "float":
    case "number":
    case "integer":
      return NumberKeyframeTrack2;
    case "vector":
    case "vector2":
    case "vector3":
    case "vector4":
      return VectorKeyframeTrack2;
    case "color":
      return ColorKeyframeTrack2;
    case "quaternion":
      return QuaternionKeyframeTrack2;
    case "bool":
    case "boolean":
      return BooleanKeyframeTrack2;
    case "string":
      return StringKeyframeTrack2;
  }
  throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function parseKeyframeTrack(json) {
  if (json.type === void 0) {
    throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
  }
  const trackType = getTrackTypeForValueTypeName(json.type);
  if (json.times === void 0) {
    const times2 = [], values = [];
    AnimationUtils.flattenJSON(json.keys, times2, values, "value");
    json.times = times2;
    json.values = values;
  }
  if (trackType.parse !== void 0) {
    return trackType.parse(json);
  } else {
    return new trackType(json.name, json.times, json.values, json.interpolation);
  }
}
const Cache$1 = {
  enabled: false,
  files: {},
  add: function(key, file) {
    if (this.enabled === false) return;
    this.files[key] = file;
  },
  get: function(key) {
    if (this.enabled === false) return;
    return this.files[key];
  },
  remove: function(key) {
    delete this.files[key];
  },
  clear: function() {
    this.files = {};
  }
};
class LoadingManager2 {
  constructor(onLoad, onProgress, onError) {
    const scope = this;
    let isLoading = false;
    let itemsLoaded = 0;
    let itemsTotal = 0;
    let urlModifier = void 0;
    const handlers = [];
    this.onStart = void 0;
    this.onLoad = onLoad;
    this.onProgress = onProgress;
    this.onError = onError;
    this.itemStart = function(url) {
      itemsTotal++;
      if (isLoading === false) {
        if (scope.onStart !== void 0) {
          scope.onStart(url, itemsLoaded, itemsTotal);
        }
      }
      isLoading = true;
    };
    this.itemEnd = function(url) {
      itemsLoaded++;
      if (scope.onProgress !== void 0) {
        scope.onProgress(url, itemsLoaded, itemsTotal);
      }
      if (itemsLoaded === itemsTotal) {
        isLoading = false;
        if (scope.onLoad !== void 0) {
          scope.onLoad();
        }
      }
    };
    this.itemError = function(url) {
      if (scope.onError !== void 0) {
        scope.onError(url);
      }
    };
    this.resolveURL = function(url) {
      if (urlModifier) {
        return urlModifier(url);
      }
      return url;
    };
    this.setURLModifier = function(transform2) {
      urlModifier = transform2;
      return this;
    };
    this.addHandler = function(regex, loader) {
      handlers.push(regex, loader);
      return this;
    };
    this.removeHandler = function(regex) {
      const index2 = handlers.indexOf(regex);
      if (index2 !== -1) {
        handlers.splice(index2, 2);
      }
      return this;
    };
    this.getHandler = function(file) {
      for (let i2 = 0, l2 = handlers.length; i2 < l2; i2 += 2) {
        const regex = handlers[i2];
        const loader = handlers[i2 + 1];
        if (regex.global) regex.lastIndex = 0;
        if (regex.test(file)) {
          return loader;
        }
      }
      return null;
    };
  }
}
const DefaultLoadingManager = new LoadingManager2();
class Loader2 {
  constructor(manager) {
    this.manager = manager !== void 0 ? manager : DefaultLoadingManager;
    this.crossOrigin = "anonymous";
    this.withCredentials = false;
    this.path = "";
    this.resourcePath = "";
    this.requestHeader = {};
  }
  load() {
  }
  loadAsync(url, onProgress) {
    const scope = this;
    return new Promise(function(resolve, reject) {
      scope.load(url, resolve, onProgress, reject);
    });
  }
  parse() {
  }
  setCrossOrigin(crossOrigin) {
    this.crossOrigin = crossOrigin;
    return this;
  }
  setWithCredentials(value) {
    this.withCredentials = value;
    return this;
  }
  setPath(path) {
    this.path = path;
    return this;
  }
  setResourcePath(resourcePath) {
    this.resourcePath = resourcePath;
    return this;
  }
  setRequestHeader(requestHeader) {
    this.requestHeader = requestHeader;
    return this;
  }
}
const loading = {};
class FileLoader2 extends Loader2 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    if (url === void 0) url = "";
    if (this.path !== void 0) url = this.path + url;
    url = this.manager.resolveURL(url);
    const scope = this;
    const cached = Cache$1.get(url);
    if (cached !== void 0) {
      scope.manager.itemStart(url);
      setTimeout(function() {
        if (onLoad) onLoad(cached);
        scope.manager.itemEnd(url);
      }, 0);
      return cached;
    }
    if (loading[url] !== void 0) {
      loading[url].push({
        onLoad,
        onProgress,
        onError
      });
      return;
    }
    const dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
    const dataUriRegexResult = url.match(dataUriRegex);
    let request;
    if (dataUriRegexResult) {
      const mimeType = dataUriRegexResult[1];
      const isBase64 = !!dataUriRegexResult[2];
      let data = dataUriRegexResult[3];
      data = decodeURIComponent(data);
      if (isBase64) data = atob(data);
      try {
        let response;
        const responseType = (this.responseType || "").toLowerCase();
        switch (responseType) {
          case "arraybuffer":
          case "blob":
            const view = new Uint8Array(data.length);
            for (let i2 = 0; i2 < data.length; i2++) {
              view[i2] = data.charCodeAt(i2);
            }
            if (responseType === "blob") {
              response = new Blob([view.buffer], { type: mimeType });
            } else {
              response = view.buffer;
            }
            break;
          case "document":
            const parser = new DOMParser();
            response = parser.parseFromString(data, mimeType);
            break;
          case "json":
            response = JSON.parse(data);
            break;
          default:
            response = data;
            break;
        }
        setTimeout(function() {
          if (onLoad) onLoad(response);
          scope.manager.itemEnd(url);
        }, 0);
      } catch (error) {
        setTimeout(function() {
          if (onError) onError(error);
          scope.manager.itemError(url);
          scope.manager.itemEnd(url);
        }, 0);
      }
    } else {
      loading[url] = [];
      loading[url].push({
        onLoad,
        onProgress,
        onError
      });
      request = new XMLHttpRequest();
      request.open("GET", url, true);
      request.addEventListener("load", function(event) {
        const response = this.response;
        const callbacks = loading[url];
        delete loading[url];
        if (this.status === 200 || this.status === 0) {
          if (this.status === 0) console.warn("THREE.FileLoader: HTTP Status 0 received.");
          Cache$1.add(url, response);
          for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
            const callback = callbacks[i2];
            if (callback.onLoad) callback.onLoad(response);
          }
          scope.manager.itemEnd(url);
        } else {
          for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
            const callback = callbacks[i2];
            if (callback.onError) callback.onError(event);
          }
          scope.manager.itemError(url);
          scope.manager.itemEnd(url);
        }
      }, false);
      request.addEventListener("progress", function(event) {
        const callbacks = loading[url];
        for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
          const callback = callbacks[i2];
          if (callback.onProgress) callback.onProgress(event);
        }
      }, false);
      request.addEventListener("error", function(event) {
        const callbacks = loading[url];
        delete loading[url];
        for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
          const callback = callbacks[i2];
          if (callback.onError) callback.onError(event);
        }
        scope.manager.itemError(url);
        scope.manager.itemEnd(url);
      }, false);
      request.addEventListener("abort", function(event) {
        const callbacks = loading[url];
        delete loading[url];
        for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
          const callback = callbacks[i2];
          if (callback.onError) callback.onError(event);
        }
        scope.manager.itemError(url);
        scope.manager.itemEnd(url);
      }, false);
      if (this.responseType !== void 0) request.responseType = this.responseType;
      if (this.withCredentials !== void 0) request.withCredentials = this.withCredentials;
      if (request.overrideMimeType) request.overrideMimeType(this.mimeType !== void 0 ? this.mimeType : "text/plain");
      for (const header in this.requestHeader) {
        request.setRequestHeader(header, this.requestHeader[header]);
      }
      request.send(null);
    }
    scope.manager.itemStart(url);
    return request;
  }
  setResponseType(value) {
    this.responseType = value;
    return this;
  }
  setMimeType(value) {
    this.mimeType = value;
    return this;
  }
}
class ImageLoader2 extends Loader2 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    if (this.path !== void 0) url = this.path + url;
    url = this.manager.resolveURL(url);
    const scope = this;
    const cached = Cache$1.get(url);
    if (cached !== void 0) {
      scope.manager.itemStart(url);
      setTimeout(function() {
        if (onLoad) onLoad(cached);
        scope.manager.itemEnd(url);
      }, 0);
      return cached;
    }
    const image2 = document.createElementNS("http://www.w3.org/1999/xhtml", "img");
    function onImageLoad() {
      image2.removeEventListener("load", onImageLoad, false);
      image2.removeEventListener("error", onImageError, false);
      Cache$1.add(url, this);
      if (onLoad) onLoad(this);
      scope.manager.itemEnd(url);
    }
    function onImageError(event) {
      image2.removeEventListener("load", onImageLoad, false);
      image2.removeEventListener("error", onImageError, false);
      if (onError) onError(event);
      scope.manager.itemError(url);
      scope.manager.itemEnd(url);
    }
    image2.addEventListener("load", onImageLoad, false);
    image2.addEventListener("error", onImageError, false);
    if (url.substr(0, 5) !== "data:") {
      if (this.crossOrigin !== void 0) image2.crossOrigin = this.crossOrigin;
    }
    scope.manager.itemStart(url);
    image2.src = url;
    return image2;
  }
}
class CubeTextureLoader2 extends Loader2 {
  constructor(manager) {
    super(manager);
  }
  load(urls, onLoad, onProgress, onError) {
    const texture = new CubeTexture2();
    const loader = new ImageLoader2(this.manager);
    loader.setCrossOrigin(this.crossOrigin);
    loader.setPath(this.path);
    let loaded = 0;
    function loadTexture(i2) {
      loader.load(urls[i2], function(image2) {
        texture.images[i2] = image2;
        loaded++;
        if (loaded === 6) {
          texture.needsUpdate = true;
          if (onLoad) onLoad(texture);
        }
      }, void 0, onError);
    }
    for (let i2 = 0; i2 < urls.length; ++i2) {
      loadTexture(i2);
    }
    return texture;
  }
}
class TextureLoader2 extends Loader2 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const texture = new Texture2();
    const loader = new ImageLoader2(this.manager);
    loader.setCrossOrigin(this.crossOrigin);
    loader.setPath(this.path);
    loader.load(url, function(image2) {
      texture.image = image2;
      const isJPEG = url.search(/\.jpe?g($|\?)/i) > 0 || url.search(/^data\:image\/jpeg/) === 0;
      texture.format = isJPEG ? RGBFormat : RGBAFormat;
      texture.needsUpdate = true;
      if (onLoad !== void 0) {
        onLoad(texture);
      }
    }, onProgress, onError);
    return texture;
  }
}
class CurvePath2 extends Curve2 {
  constructor() {
    super();
    this.type = "CurvePath";
    this.curves = [];
    this.autoClose = false;
  }
  add(curve) {
    this.curves.push(curve);
  }
  closePath() {
    const startPoint = this.curves[0].getPoint(0);
    const endPoint = this.curves[this.curves.length - 1].getPoint(1);
    if (!startPoint.equals(endPoint)) {
      this.curves.push(new LineCurve2(endPoint, startPoint));
    }
  }
  // To get accurate point with reference to
  // entire path distance at time t,
  // following has to be done:
  // 1. Length of each sub path have to be known
  // 2. Locate and identify type of curve
  // 3. Get t for the curve
  // 4. Return curve.getPointAt(t')
  getPoint(t3) {
    const d2 = t3 * this.getLength();
    const curveLengths = this.getCurveLengths();
    let i2 = 0;
    while (i2 < curveLengths.length) {
      if (curveLengths[i2] >= d2) {
        const diff = curveLengths[i2] - d2;
        const curve = this.curves[i2];
        const segmentLength = curve.getLength();
        const u3 = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
        return curve.getPointAt(u3);
      }
      i2++;
    }
    return null;
  }
  // We cannot use the default THREE.Curve getPoint() with getLength() because in
  // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
  // getPoint() depends on getLength
  getLength() {
    const lens = this.getCurveLengths();
    return lens[lens.length - 1];
  }
  // cacheLengths must be recalculated.
  updateArcLengths() {
    this.needsUpdate = true;
    this.cacheLengths = null;
    this.getCurveLengths();
  }
  // Compute lengths and cache them
  // We cannot overwrite getLengths() because UtoT mapping uses it.
  getCurveLengths() {
    if (this.cacheLengths && this.cacheLengths.length === this.curves.length) {
      return this.cacheLengths;
    }
    const lengths = [];
    let sums = 0;
    for (let i2 = 0, l2 = this.curves.length; i2 < l2; i2++) {
      sums += this.curves[i2].getLength();
      lengths.push(sums);
    }
    this.cacheLengths = lengths;
    return lengths;
  }
  getSpacedPoints(divisions = 40) {
    const points = [];
    for (let i2 = 0; i2 <= divisions; i2++) {
      points.push(this.getPoint(i2 / divisions));
    }
    if (this.autoClose) {
      points.push(points[0]);
    }
    return points;
  }
  getPoints(divisions = 12) {
    const points = [];
    let last;
    for (let i2 = 0, curves = this.curves; i2 < curves.length; i2++) {
      const curve = curves[i2];
      const resolution = curve && curve.isEllipseCurve ? divisions * 2 : curve && (curve.isLineCurve || curve.isLineCurve3) ? 1 : curve && curve.isSplineCurve ? divisions * curve.points.length : divisions;
      const pts = curve.getPoints(resolution);
      for (let j = 0; j < pts.length; j++) {
        const point2 = pts[j];
        if (last && last.equals(point2)) continue;
        points.push(point2);
        last = point2;
      }
    }
    if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) {
      points.push(points[0]);
    }
    return points;
  }
  copy(source) {
    super.copy(source);
    this.curves = [];
    for (let i2 = 0, l2 = source.curves.length; i2 < l2; i2++) {
      const curve = source.curves[i2];
      this.curves.push(curve.clone());
    }
    this.autoClose = source.autoClose;
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.autoClose = this.autoClose;
    data.curves = [];
    for (let i2 = 0, l2 = this.curves.length; i2 < l2; i2++) {
      const curve = this.curves[i2];
      data.curves.push(curve.toJSON());
    }
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.autoClose = json.autoClose;
    this.curves = [];
    for (let i2 = 0, l2 = json.curves.length; i2 < l2; i2++) {
      const curve = json.curves[i2];
      this.curves.push(new Curves[curve.type]().fromJSON(curve));
    }
    return this;
  }
}
class Path2 extends CurvePath2 {
  constructor(points) {
    super();
    this.type = "Path";
    this.currentPoint = new Vector22();
    if (points) {
      this.setFromPoints(points);
    }
  }
  setFromPoints(points) {
    this.moveTo(points[0].x, points[0].y);
    for (let i2 = 1, l2 = points.length; i2 < l2; i2++) {
      this.lineTo(points[i2].x, points[i2].y);
    }
    return this;
  }
  moveTo(x, y) {
    this.currentPoint.set(x, y);
    return this;
  }
  lineTo(x, y) {
    const curve = new LineCurve2(this.currentPoint.clone(), new Vector22(x, y));
    this.curves.push(curve);
    this.currentPoint.set(x, y);
    return this;
  }
  quadraticCurveTo(aCPx, aCPy, aX, aY) {
    const curve = new QuadraticBezierCurve2(
      this.currentPoint.clone(),
      new Vector22(aCPx, aCPy),
      new Vector22(aX, aY)
    );
    this.curves.push(curve);
    this.currentPoint.set(aX, aY);
    return this;
  }
  bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
    const curve = new CubicBezierCurve2(
      this.currentPoint.clone(),
      new Vector22(aCP1x, aCP1y),
      new Vector22(aCP2x, aCP2y),
      new Vector22(aX, aY)
    );
    this.curves.push(curve);
    this.currentPoint.set(aX, aY);
    return this;
  }
  splineThru(pts) {
    const npts = [this.currentPoint.clone()].concat(pts);
    const curve = new SplineCurve2(npts);
    this.curves.push(curve);
    this.currentPoint.copy(pts[pts.length - 1]);
    return this;
  }
  arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    const x0 = this.currentPoint.x;
    const y0 = this.currentPoint.y;
    this.absarc(
      aX + x0,
      aY + y0,
      aRadius,
      aStartAngle,
      aEndAngle,
      aClockwise
    );
    return this;
  }
  absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
    return this;
  }
  ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
    const x0 = this.currentPoint.x;
    const y0 = this.currentPoint.y;
    this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
    return this;
  }
  absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
    const curve = new EllipseCurve2(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
    if (this.curves.length > 0) {
      const firstPoint = curve.getPoint(0);
      if (!firstPoint.equals(this.currentPoint)) {
        this.lineTo(firstPoint.x, firstPoint.y);
      }
    }
    this.curves.push(curve);
    const lastPoint = curve.getPoint(1);
    this.currentPoint.copy(lastPoint);
    return this;
  }
  copy(source) {
    super.copy(source);
    this.currentPoint.copy(source.currentPoint);
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.currentPoint = this.currentPoint.toArray();
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.currentPoint.fromArray(json.currentPoint);
    return this;
  }
}
class Shape2 extends Path2 {
  constructor(points) {
    super(points);
    this.uuid = generateUUID();
    this.type = "Shape";
    this.holes = [];
  }
  getPointsHoles(divisions) {
    const holesPts = [];
    for (let i2 = 0, l2 = this.holes.length; i2 < l2; i2++) {
      holesPts[i2] = this.holes[i2].getPoints(divisions);
    }
    return holesPts;
  }
  // get points of shape and holes (keypoints based on segments parameter)
  extractPoints(divisions) {
    return {
      shape: this.getPoints(divisions),
      holes: this.getPointsHoles(divisions)
    };
  }
  copy(source) {
    super.copy(source);
    this.holes = [];
    for (let i2 = 0, l2 = source.holes.length; i2 < l2; i2++) {
      const hole = source.holes[i2];
      this.holes.push(hole.clone());
    }
    return this;
  }
  toJSON() {
    const data = super.toJSON();
    data.uuid = this.uuid;
    data.holes = [];
    for (let i2 = 0, l2 = this.holes.length; i2 < l2; i2++) {
      const hole = this.holes[i2];
      data.holes.push(hole.toJSON());
    }
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.uuid = json.uuid;
    this.holes = [];
    for (let i2 = 0, l2 = json.holes.length; i2 < l2; i2++) {
      const hole = json.holes[i2];
      this.holes.push(new Path2().fromJSON(hole));
    }
    return this;
  }
}
class Light2 extends Object3D2 {
  constructor(color2, intensity = 1) {
    super();
    this.type = "Light";
    this.color = new Color2(color2);
    this.intensity = intensity;
  }
  dispose() {
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.intensity = source.intensity;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.color = this.color.getHex();
    data.object.intensity = this.intensity;
    if (this.groundColor !== void 0) data.object.groundColor = this.groundColor.getHex();
    if (this.distance !== void 0) data.object.distance = this.distance;
    if (this.angle !== void 0) data.object.angle = this.angle;
    if (this.decay !== void 0) data.object.decay = this.decay;
    if (this.penumbra !== void 0) data.object.penumbra = this.penumbra;
    if (this.shadow !== void 0) data.object.shadow = this.shadow.toJSON();
    return data;
  }
}
Light2.prototype.isLight = true;
class HemisphereLight2 extends Light2 {
  constructor(skyColor, groundColor, intensity) {
    super(skyColor, intensity);
    this.type = "HemisphereLight";
    this.position.copy(Object3D2.DefaultUp);
    this.updateMatrix();
    this.groundColor = new Color2(groundColor);
  }
  copy(source) {
    Light2.prototype.copy.call(this, source);
    this.groundColor.copy(source.groundColor);
    return this;
  }
}
HemisphereLight2.prototype.isHemisphereLight = true;
const _projScreenMatrix$1 = /* @__PURE__ */ new Matrix42();
const _lightPositionWorld$1 = /* @__PURE__ */ new Vector32();
const _lookTarget$1 = /* @__PURE__ */ new Vector32();
class LightShadow2 {
  constructor(camera) {
    this.camera = camera;
    this.bias = 0;
    this.normalBias = 0;
    this.radius = 1;
    this.blurSamples = 8;
    this.mapSize = new Vector22(512, 512);
    this.map = null;
    this.mapPass = null;
    this.matrix = new Matrix42();
    this.autoUpdate = true;
    this.needsUpdate = false;
    this._frustum = new Frustum2();
    this._frameExtents = new Vector22(1, 1);
    this._viewportCount = 1;
    this._viewports = [
      new Vector42(0, 0, 1, 1)
    ];
  }
  getViewportCount() {
    return this._viewportCount;
  }
  getFrustum() {
    return this._frustum;
  }
  updateMatrices(light) {
    const shadowCamera = this.camera;
    const shadowMatrix = this.matrix;
    _lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
    shadowCamera.position.copy(_lightPositionWorld$1);
    _lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
    shadowCamera.lookAt(_lookTarget$1);
    shadowCamera.updateMatrixWorld();
    _projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
    this._frustum.setFromProjectionMatrix(_projScreenMatrix$1);
    shadowMatrix.set(
      0.5,
      0,
      0,
      0.5,
      0,
      0.5,
      0,
      0.5,
      0,
      0,
      0.5,
      0.5,
      0,
      0,
      0,
      1
    );
    shadowMatrix.multiply(shadowCamera.projectionMatrix);
    shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
  }
  getViewport(viewportIndex) {
    return this._viewports[viewportIndex];
  }
  getFrameExtents() {
    return this._frameExtents;
  }
  dispose() {
    if (this.map) {
      this.map.dispose();
    }
    if (this.mapPass) {
      this.mapPass.dispose();
    }
  }
  copy(source) {
    this.camera = source.camera.clone();
    this.bias = source.bias;
    this.radius = source.radius;
    this.mapSize.copy(source.mapSize);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    const object = {};
    if (this.bias !== 0) object.bias = this.bias;
    if (this.normalBias !== 0) object.normalBias = this.normalBias;
    if (this.radius !== 1) object.radius = this.radius;
    if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
    object.camera = this.camera.toJSON(false).object;
    delete object.camera.matrix;
    return object;
  }
}
class SpotLightShadow2 extends LightShadow2 {
  constructor() {
    super(new PerspectiveCamera2(50, 1, 0.5, 500));
    this.focus = 1;
  }
  updateMatrices(light) {
    const camera = this.camera;
    const fov2 = RAD2DEG * 2 * light.angle * this.focus;
    const aspect2 = this.mapSize.width / this.mapSize.height;
    const far = light.distance || camera.far;
    if (fov2 !== camera.fov || aspect2 !== camera.aspect || far !== camera.far) {
      camera.fov = fov2;
      camera.aspect = aspect2;
      camera.far = far;
      camera.updateProjectionMatrix();
    }
    super.updateMatrices(light);
  }
  copy(source) {
    super.copy(source);
    this.focus = source.focus;
    return this;
  }
}
SpotLightShadow2.prototype.isSpotLightShadow = true;
class SpotLight2 extends Light2 {
  constructor(color2, intensity, distance2 = 0, angle2 = Math.PI / 3, penumbra = 0, decay = 1) {
    super(color2, intensity);
    this.type = "SpotLight";
    this.position.copy(Object3D2.DefaultUp);
    this.updateMatrix();
    this.target = new Object3D2();
    this.distance = distance2;
    this.angle = angle2;
    this.penumbra = penumbra;
    this.decay = decay;
    this.shadow = new SpotLightShadow2();
  }
  get power() {
    return this.intensity * Math.PI;
  }
  set power(power) {
    this.intensity = power / Math.PI;
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source) {
    super.copy(source);
    this.distance = source.distance;
    this.angle = source.angle;
    this.penumbra = source.penumbra;
    this.decay = source.decay;
    this.target = source.target.clone();
    this.shadow = source.shadow.clone();
    return this;
  }
}
SpotLight2.prototype.isSpotLight = true;
const _projScreenMatrix = /* @__PURE__ */ new Matrix42();
const _lightPositionWorld = /* @__PURE__ */ new Vector32();
const _lookTarget = /* @__PURE__ */ new Vector32();
class PointLightShadow2 extends LightShadow2 {
  constructor() {
    super(new PerspectiveCamera2(90, 1, 0.5, 500));
    this._frameExtents = new Vector22(4, 2);
    this._viewportCount = 6;
    this._viewports = [
      // These viewports map a cube-map onto a 2D texture with the
      // following orientation:
      //
      //  xzXZ
      //   y Y
      //
      // X - Positive x direction
      // x - Negative x direction
      // Y - Positive y direction
      // y - Negative y direction
      // Z - Positive z direction
      // z - Negative z direction
      // positive X
      new Vector42(2, 1, 1, 1),
      // negative X
      new Vector42(0, 1, 1, 1),
      // positive Z
      new Vector42(3, 1, 1, 1),
      // negative Z
      new Vector42(1, 1, 1, 1),
      // positive Y
      new Vector42(3, 0, 1, 1),
      // negative Y
      new Vector42(1, 0, 1, 1)
    ];
    this._cubeDirections = [
      new Vector32(1, 0, 0),
      new Vector32(-1, 0, 0),
      new Vector32(0, 0, 1),
      new Vector32(0, 0, -1),
      new Vector32(0, 1, 0),
      new Vector32(0, -1, 0)
    ];
    this._cubeUps = [
      new Vector32(0, 1, 0),
      new Vector32(0, 1, 0),
      new Vector32(0, 1, 0),
      new Vector32(0, 1, 0),
      new Vector32(0, 0, 1),
      new Vector32(0, 0, -1)
    ];
  }
  updateMatrices(light, viewportIndex = 0) {
    const camera = this.camera;
    const shadowMatrix = this.matrix;
    const far = light.distance || camera.far;
    if (far !== camera.far) {
      camera.far = far;
      camera.updateProjectionMatrix();
    }
    _lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
    camera.position.copy(_lightPositionWorld);
    _lookTarget.copy(camera.position);
    _lookTarget.add(this._cubeDirections[viewportIndex]);
    camera.up.copy(this._cubeUps[viewportIndex]);
    camera.lookAt(_lookTarget);
    camera.updateMatrixWorld();
    shadowMatrix.makeTranslation(-_lightPositionWorld.x, -_lightPositionWorld.y, -_lightPositionWorld.z);
    _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
    this._frustum.setFromProjectionMatrix(_projScreenMatrix);
  }
}
PointLightShadow2.prototype.isPointLightShadow = true;
class PointLight2 extends Light2 {
  constructor(color2, intensity, distance2 = 0, decay = 1) {
    super(color2, intensity);
    this.type = "PointLight";
    this.distance = distance2;
    this.decay = decay;
    this.shadow = new PointLightShadow2();
  }
  get power() {
    return this.intensity * 4 * Math.PI;
  }
  set power(power) {
    this.intensity = power / (4 * Math.PI);
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source) {
    super.copy(source);
    this.distance = source.distance;
    this.decay = source.decay;
    this.shadow = source.shadow.clone();
    return this;
  }
}
PointLight2.prototype.isPointLight = true;
class DirectionalLightShadow2 extends LightShadow2 {
  constructor() {
    super(new OrthographicCamera2(-5, 5, 5, -5, 0.5, 500));
  }
}
DirectionalLightShadow2.prototype.isDirectionalLightShadow = true;
class DirectionalLight2 extends Light2 {
  constructor(color2, intensity) {
    super(color2, intensity);
    this.type = "DirectionalLight";
    this.position.copy(Object3D2.DefaultUp);
    this.updateMatrix();
    this.target = new Object3D2();
    this.shadow = new DirectionalLightShadow2();
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source) {
    super.copy(source);
    this.target = source.target.clone();
    this.shadow = source.shadow.clone();
    return this;
  }
}
DirectionalLight2.prototype.isDirectionalLight = true;
class AmbientLight2 extends Light2 {
  constructor(color2, intensity) {
    super(color2, intensity);
    this.type = "AmbientLight";
  }
}
AmbientLight2.prototype.isAmbientLight = true;
class RectAreaLight2 extends Light2 {
  constructor(color2, intensity, width = 10, height = 10) {
    super(color2, intensity);
    this.type = "RectAreaLight";
    this.width = width;
    this.height = height;
  }
  get power() {
    return this.intensity * this.width * this.height * Math.PI;
  }
  set power(power) {
    this.intensity = power / (this.width * this.height * Math.PI);
  }
  copy(source) {
    super.copy(source);
    this.width = source.width;
    this.height = source.height;
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.width = this.width;
    data.object.height = this.height;
    return data;
  }
}
RectAreaLight2.prototype.isRectAreaLight = true;
class SphericalHarmonics32 {
  constructor() {
    this.coefficients = [];
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients.push(new Vector32());
    }
  }
  set(coefficients) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].copy(coefficients[i2]);
    }
    return this;
  }
  zero() {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].set(0, 0, 0);
    }
    return this;
  }
  // get the radiance in the direction of the normal
  // target is a Vector3
  getAt(normal, target) {
    const x = normal.x, y = normal.y, z2 = normal.z;
    const coeff = this.coefficients;
    target.copy(coeff[0]).multiplyScalar(0.282095);
    target.addScaledVector(coeff[1], 0.488603 * y);
    target.addScaledVector(coeff[2], 0.488603 * z2);
    target.addScaledVector(coeff[3], 0.488603 * x);
    target.addScaledVector(coeff[4], 1.092548 * (x * y));
    target.addScaledVector(coeff[5], 1.092548 * (y * z2));
    target.addScaledVector(coeff[6], 0.315392 * (3 * z2 * z2 - 1));
    target.addScaledVector(coeff[7], 1.092548 * (x * z2));
    target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
    return target;
  }
  // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
  // target is a Vector3
  // https://graphics.stanford.edu/papers/envmap/envmap.pdf
  getIrradianceAt(normal, target) {
    const x = normal.x, y = normal.y, z2 = normal.z;
    const coeff = this.coefficients;
    target.copy(coeff[0]).multiplyScalar(0.886227);
    target.addScaledVector(coeff[1], 2 * 0.511664 * y);
    target.addScaledVector(coeff[2], 2 * 0.511664 * z2);
    target.addScaledVector(coeff[3], 2 * 0.511664 * x);
    target.addScaledVector(coeff[4], 2 * 0.429043 * x * y);
    target.addScaledVector(coeff[5], 2 * 0.429043 * y * z2);
    target.addScaledVector(coeff[6], 0.743125 * z2 * z2 - 0.247708);
    target.addScaledVector(coeff[7], 2 * 0.429043 * x * z2);
    target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y));
    return target;
  }
  add(sh) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].add(sh.coefficients[i2]);
    }
    return this;
  }
  addScaledSH(sh, s2) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].addScaledVector(sh.coefficients[i2], s2);
    }
    return this;
  }
  scale(s2) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].multiplyScalar(s2);
    }
    return this;
  }
  lerp(sh, alpha) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].lerp(sh.coefficients[i2], alpha);
    }
    return this;
  }
  equals(sh) {
    for (let i2 = 0; i2 < 9; i2++) {
      if (!this.coefficients[i2].equals(sh.coefficients[i2])) {
        return false;
      }
    }
    return true;
  }
  copy(sh) {
    return this.set(sh.coefficients);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  fromArray(array, offset = 0) {
    const coefficients = this.coefficients;
    for (let i2 = 0; i2 < 9; i2++) {
      coefficients[i2].fromArray(array, offset + i2 * 3);
    }
    return this;
  }
  toArray(array = [], offset = 0) {
    const coefficients = this.coefficients;
    for (let i2 = 0; i2 < 9; i2++) {
      coefficients[i2].toArray(array, offset + i2 * 3);
    }
    return array;
  }
  // evaluate the basis functions
  // shBasis is an Array[ 9 ]
  static getBasisAt(normal, shBasis) {
    const x = normal.x, y = normal.y, z2 = normal.z;
    shBasis[0] = 0.282095;
    shBasis[1] = 0.488603 * y;
    shBasis[2] = 0.488603 * z2;
    shBasis[3] = 0.488603 * x;
    shBasis[4] = 1.092548 * x * y;
    shBasis[5] = 1.092548 * y * z2;
    shBasis[6] = 0.315392 * (3 * z2 * z2 - 1);
    shBasis[7] = 1.092548 * x * z2;
    shBasis[8] = 0.546274 * (x * x - y * y);
  }
}
SphericalHarmonics32.prototype.isSphericalHarmonics3 = true;
class LightProbe2 extends Light2 {
  constructor(sh = new SphericalHarmonics32(), intensity = 1) {
    super(void 0, intensity);
    this.sh = sh;
  }
  copy(source) {
    super.copy(source);
    this.sh.copy(source.sh);
    return this;
  }
  fromJSON(json) {
    this.intensity = json.intensity;
    this.sh.fromArray(json.sh);
    return this;
  }
  toJSON(meta) {
    const data = super.toJSON(meta);
    data.object.sh = this.sh.toArray();
    return data;
  }
}
LightProbe2.prototype.isLightProbe = true;
class LoaderUtils2 {
  static decodeText(array) {
    if (typeof TextDecoder !== "undefined") {
      return new TextDecoder().decode(array);
    }
    let s2 = "";
    for (let i2 = 0, il = array.length; i2 < il; i2++) {
      s2 += String.fromCharCode(array[i2]);
    }
    try {
      return decodeURIComponent(escape(s2));
    } catch (e2) {
      return s2;
    }
  }
  static extractUrlBase(url) {
    const index2 = url.lastIndexOf("/");
    if (index2 === -1) return "./";
    return url.substr(0, index2 + 1);
  }
}
class InstancedBufferGeometry2 extends BufferGeometry2 {
  constructor() {
    super();
    this.type = "InstancedBufferGeometry";
    this.instanceCount = Infinity;
  }
  copy(source) {
    super.copy(source);
    this.instanceCount = source.instanceCount;
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    const data = super.toJSON(this);
    data.instanceCount = this.instanceCount;
    data.isInstancedBufferGeometry = true;
    return data;
  }
}
InstancedBufferGeometry2.prototype.isInstancedBufferGeometry = true;
class ImageBitmapLoader2 extends Loader2 {
  constructor(manager) {
    super(manager);
    if (typeof createImageBitmap === "undefined") {
      console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
    }
    if (typeof fetch === "undefined") {
      console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
    }
    this.options = { premultiplyAlpha: "none" };
  }
  setOptions(options) {
    this.options = options;
    return this;
  }
  load(url, onLoad, onProgress, onError) {
    if (url === void 0) url = "";
    if (this.path !== void 0) url = this.path + url;
    url = this.manager.resolveURL(url);
    const scope = this;
    const cached = Cache$1.get(url);
    if (cached !== void 0) {
      scope.manager.itemStart(url);
      setTimeout(function() {
        if (onLoad) onLoad(cached);
        scope.manager.itemEnd(url);
      }, 0);
      return cached;
    }
    const fetchOptions = {};
    fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
    fetchOptions.headers = this.requestHeader;
    fetch(url, fetchOptions).then(function(res) {
      return res.blob();
    }).then(function(blob) {
      return createImageBitmap(blob, Object.assign(scope.options, { colorSpaceConversion: "none" }));
    }).then(function(imageBitmap) {
      Cache$1.add(url, imageBitmap);
      if (onLoad) onLoad(imageBitmap);
      scope.manager.itemEnd(url);
    }).catch(function(e2) {
      if (onError) onError(e2);
      scope.manager.itemError(url);
      scope.manager.itemEnd(url);
    });
    scope.manager.itemStart(url);
  }
}
ImageBitmapLoader2.prototype.isImageBitmapLoader = true;
let _context;
const AudioContext2 = {
  getContext: function() {
    if (_context === void 0) {
      _context = new (window.AudioContext || window.webkitAudioContext)();
    }
    return _context;
  },
  setContext: function(value) {
    _context = value;
  }
};
class AudioLoader2 extends Loader2 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const loader = new FileLoader2(this.manager);
    loader.setResponseType("arraybuffer");
    loader.setPath(this.path);
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(url, function(buffer) {
      try {
        const bufferCopy = buffer.slice(0);
        const context = AudioContext2.getContext();
        context.decodeAudioData(bufferCopy, function(audioBuffer) {
          onLoad(audioBuffer);
        });
      } catch (e2) {
        if (onError) {
          onError(e2);
        } else {
          console.error(e2);
        }
        scope.manager.itemError(url);
      }
    }, onProgress, onError);
  }
}
class HemisphereLightProbe extends LightProbe2 {
  constructor(skyColor, groundColor, intensity = 1) {
    super(void 0, intensity);
    const color1 = new Color2().set(skyColor);
    const color2 = new Color2().set(groundColor);
    const sky = new Vector32(color1.r, color1.g, color1.b);
    const ground = new Vector32(color2.r, color2.g, color2.b);
    const c0 = Math.sqrt(Math.PI);
    const c1 = c0 * Math.sqrt(0.75);
    this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
    this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
  }
}
HemisphereLightProbe.prototype.isHemisphereLightProbe = true;
class AmbientLightProbe extends LightProbe2 {
  constructor(color2, intensity = 1) {
    super(void 0, intensity);
    const color1 = new Color2().set(color2);
    this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
  }
}
AmbientLightProbe.prototype.isAmbientLightProbe = true;
class Audio2 extends Object3D2 {
  constructor(listener) {
    super();
    this.type = "Audio";
    this.listener = listener;
    this.context = listener.context;
    this.gain = this.context.createGain();
    this.gain.connect(listener.getInput());
    this.autoplay = false;
    this.buffer = null;
    this.detune = 0;
    this.loop = false;
    this.loopStart = 0;
    this.loopEnd = 0;
    this.offset = 0;
    this.duration = void 0;
    this.playbackRate = 1;
    this.isPlaying = false;
    this.hasPlaybackControl = true;
    this.source = null;
    this.sourceType = "empty";
    this._startedAt = 0;
    this._progress = 0;
    this._connected = false;
    this.filters = [];
  }
  getOutput() {
    return this.gain;
  }
  setNodeSource(audioNode) {
    this.hasPlaybackControl = false;
    this.sourceType = "audioNode";
    this.source = audioNode;
    this.connect();
    return this;
  }
  setMediaElementSource(mediaElement) {
    this.hasPlaybackControl = false;
    this.sourceType = "mediaNode";
    this.source = this.context.createMediaElementSource(mediaElement);
    this.connect();
    return this;
  }
  setMediaStreamSource(mediaStream) {
    this.hasPlaybackControl = false;
    this.sourceType = "mediaStreamNode";
    this.source = this.context.createMediaStreamSource(mediaStream);
    this.connect();
    return this;
  }
  setBuffer(audioBuffer) {
    this.buffer = audioBuffer;
    this.sourceType = "buffer";
    if (this.autoplay) this.play();
    return this;
  }
  play(delay = 0) {
    if (this.isPlaying === true) {
      console.warn("THREE.Audio: Audio is already playing.");
      return;
    }
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this._startedAt = this.context.currentTime + delay;
    const source = this.context.createBufferSource();
    source.buffer = this.buffer;
    source.loop = this.loop;
    source.loopStart = this.loopStart;
    source.loopEnd = this.loopEnd;
    source.onended = this.onEnded.bind(this);
    source.start(this._startedAt, this._progress + this.offset, this.duration);
    this.isPlaying = true;
    this.source = source;
    this.setDetune(this.detune);
    this.setPlaybackRate(this.playbackRate);
    return this.connect();
  }
  pause() {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    if (this.isPlaying === true) {
      this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
      if (this.loop === true) {
        this._progress = this._progress % (this.duration || this.buffer.duration);
      }
      this.source.stop();
      this.source.onended = null;
      this.isPlaying = false;
    }
    return this;
  }
  stop() {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this._progress = 0;
    this.source.stop();
    this.source.onended = null;
    this.isPlaying = false;
    return this;
  }
  connect() {
    if (this.filters.length > 0) {
      this.source.connect(this.filters[0]);
      for (let i2 = 1, l2 = this.filters.length; i2 < l2; i2++) {
        this.filters[i2 - 1].connect(this.filters[i2]);
      }
      this.filters[this.filters.length - 1].connect(this.getOutput());
    } else {
      this.source.connect(this.getOutput());
    }
    this._connected = true;
    return this;
  }
  disconnect() {
    if (this.filters.length > 0) {
      this.source.disconnect(this.filters[0]);
      for (let i2 = 1, l2 = this.filters.length; i2 < l2; i2++) {
        this.filters[i2 - 1].disconnect(this.filters[i2]);
      }
      this.filters[this.filters.length - 1].disconnect(this.getOutput());
    } else {
      this.source.disconnect(this.getOutput());
    }
    this._connected = false;
    return this;
  }
  getFilters() {
    return this.filters;
  }
  setFilters(value) {
    if (!value) value = [];
    if (this._connected === true) {
      this.disconnect();
      this.filters = value.slice();
      this.connect();
    } else {
      this.filters = value.slice();
    }
    return this;
  }
  setDetune(value) {
    this.detune = value;
    if (this.source.detune === void 0) return;
    if (this.isPlaying === true) {
      this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
    }
    return this;
  }
  getDetune() {
    return this.detune;
  }
  getFilter() {
    return this.getFilters()[0];
  }
  setFilter(filter) {
    return this.setFilters(filter ? [filter] : []);
  }
  setPlaybackRate(value) {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this.playbackRate = value;
    if (this.isPlaying === true) {
      this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
    }
    return this;
  }
  getPlaybackRate() {
    return this.playbackRate;
  }
  onEnded() {
    this.isPlaying = false;
  }
  getLoop() {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return false;
    }
    return this.loop;
  }
  setLoop(value) {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this.loop = value;
    if (this.isPlaying === true) {
      this.source.loop = this.loop;
    }
    return this;
  }
  setLoopStart(value) {
    this.loopStart = value;
    return this;
  }
  setLoopEnd(value) {
    this.loopEnd = value;
    return this;
  }
  getVolume() {
    return this.gain.gain.value;
  }
  setVolume(value) {
    this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
    return this;
  }
}
class PropertyMixer2 {
  constructor(binding, typeName, valueSize) {
    this.binding = binding;
    this.valueSize = valueSize;
    let mixFunction, mixFunctionAdditive, setIdentity;
    switch (typeName) {
      case "quaternion":
        mixFunction = this._slerp;
        mixFunctionAdditive = this._slerpAdditive;
        setIdentity = this._setAdditiveIdentityQuaternion;
        this.buffer = new Float64Array(valueSize * 6);
        this._workIndex = 5;
        break;
      case "string":
      case "bool":
        mixFunction = this._select;
        mixFunctionAdditive = this._select;
        setIdentity = this._setAdditiveIdentityOther;
        this.buffer = new Array(valueSize * 5);
        break;
      default:
        mixFunction = this._lerp;
        mixFunctionAdditive = this._lerpAdditive;
        setIdentity = this._setAdditiveIdentityNumeric;
        this.buffer = new Float64Array(valueSize * 5);
    }
    this._mixBufferRegion = mixFunction;
    this._mixBufferRegionAdditive = mixFunctionAdditive;
    this._setIdentity = setIdentity;
    this._origIndex = 3;
    this._addIndex = 4;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    this.useCount = 0;
    this.referenceCount = 0;
  }
  // accumulate data in the 'incoming' region into 'accu<i>'
  accumulate(accuIndex, weight) {
    const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
    let currentWeight = this.cumulativeWeight;
    if (currentWeight === 0) {
      for (let i2 = 0; i2 !== stride; ++i2) {
        buffer[offset + i2] = buffer[i2];
      }
      currentWeight = weight;
    } else {
      currentWeight += weight;
      const mix = weight / currentWeight;
      this._mixBufferRegion(buffer, offset, 0, mix, stride);
    }
    this.cumulativeWeight = currentWeight;
  }
  // accumulate data in the 'incoming' region into 'add'
  accumulateAdditive(weight) {
    const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
    if (this.cumulativeWeightAdditive === 0) {
      this._setIdentity();
    }
    this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
    this.cumulativeWeightAdditive += weight;
  }
  // apply the state of 'accu<i>' to the binding when accus differ
  apply(accuIndex) {
    const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    if (weight < 1) {
      const originalValueOffset = stride * this._origIndex;
      this._mixBufferRegion(
        buffer,
        offset,
        originalValueOffset,
        1 - weight,
        stride
      );
    }
    if (weightAdditive > 0) {
      this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
    }
    for (let i2 = stride, e2 = stride + stride; i2 !== e2; ++i2) {
      if (buffer[i2] !== buffer[i2 + stride]) {
        binding.setValue(buffer, offset);
        break;
      }
    }
  }
  // remember the state of the bound property and copy it to both accus
  saveOriginalState() {
    const binding = this.binding;
    const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
    binding.getValue(buffer, originalValueOffset);
    for (let i2 = stride, e2 = originalValueOffset; i2 !== e2; ++i2) {
      buffer[i2] = buffer[originalValueOffset + i2 % stride];
    }
    this._setIdentity();
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
  }
  // apply the state previously taken via 'saveOriginalState' to the binding
  restoreOriginalState() {
    const originalValueOffset = this.valueSize * 3;
    this.binding.setValue(this.buffer, originalValueOffset);
  }
  _setAdditiveIdentityNumeric() {
    const startIndex = this._addIndex * this.valueSize;
    const endIndex = startIndex + this.valueSize;
    for (let i2 = startIndex; i2 < endIndex; i2++) {
      this.buffer[i2] = 0;
    }
  }
  _setAdditiveIdentityQuaternion() {
    this._setAdditiveIdentityNumeric();
    this.buffer[this._addIndex * this.valueSize + 3] = 1;
  }
  _setAdditiveIdentityOther() {
    const startIndex = this._origIndex * this.valueSize;
    const targetIndex = this._addIndex * this.valueSize;
    for (let i2 = 0; i2 < this.valueSize; i2++) {
      this.buffer[targetIndex + i2] = this.buffer[startIndex + i2];
    }
  }
  // mix functions
  _select(buffer, dstOffset, srcOffset, t3, stride) {
    if (t3 >= 0.5) {
      for (let i2 = 0; i2 !== stride; ++i2) {
        buffer[dstOffset + i2] = buffer[srcOffset + i2];
      }
    }
  }
  _slerp(buffer, dstOffset, srcOffset, t3) {
    Quaternion2.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t3);
  }
  _slerpAdditive(buffer, dstOffset, srcOffset, t3, stride) {
    const workOffset = this._workIndex * stride;
    Quaternion2.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
    Quaternion2.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t3);
  }
  _lerp(buffer, dstOffset, srcOffset, t3, stride) {
    const s2 = 1 - t3;
    for (let i2 = 0; i2 !== stride; ++i2) {
      const j = dstOffset + i2;
      buffer[j] = buffer[j] * s2 + buffer[srcOffset + i2] * t3;
    }
  }
  _lerpAdditive(buffer, dstOffset, srcOffset, t3, stride) {
    for (let i2 = 0; i2 !== stride; ++i2) {
      const j = dstOffset + i2;
      buffer[j] = buffer[j] + buffer[srcOffset + i2] * t3;
    }
  }
}
const _RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const _reservedRe = new RegExp("[" + _RESERVED_CHARS_RE + "]", "g");
const _wordChar = "[^" + _RESERVED_CHARS_RE + "]";
const _wordCharOrDot = "[^" + _RESERVED_CHARS_RE.replace("\\.", "") + "]";
const _directoryRe = /((?:WC+[\/:])*)/.source.replace("WC", _wordChar);
const _nodeRe = /(WCOD+)?/.source.replace("WCOD", _wordCharOrDot);
const _objectRe = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", _wordChar);
const _propertyRe = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", _wordChar);
const _trackRe = new RegExp(
  "^" + _directoryRe + _nodeRe + _objectRe + _propertyRe + "$"
);
const _supportedObjectNames = ["material", "materials", "bones"];
class Composite2 {
  constructor(targetGroup, path, optionalParsedPath) {
    const parsedPath = optionalParsedPath || PropertyBinding2.parseTrackName(path);
    this._targetGroup = targetGroup;
    this._bindings = targetGroup.subscribe_(path, parsedPath);
  }
  getValue(array, offset) {
    this.bind();
    const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
    if (binding !== void 0) binding.getValue(array, offset);
  }
  setValue(array, offset) {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].setValue(array, offset);
    }
  }
  bind() {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].bind();
    }
  }
  unbind() {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].unbind();
    }
  }
}
class PropertyBinding2 {
  constructor(rootNode, path, parsedPath) {
    this.path = path;
    this.parsedPath = parsedPath || PropertyBinding2.parseTrackName(path);
    this.node = PropertyBinding2.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
    this.rootNode = rootNode;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
  static create(root, path, parsedPath) {
    if (!(root && root.isAnimationObjectGroup)) {
      return new PropertyBinding2(root, path, parsedPath);
    } else {
      return new PropertyBinding2.Composite(root, path, parsedPath);
    }
  }
  /**
   * Replaces spaces with underscores and removes unsupported characters from
   * node names, to ensure compatibility with parseTrackName().
   *
   * @param {string} name Node name to be sanitized.
   * @return {string}
   */
  static sanitizeNodeName(name) {
    return name.replace(/\s/g, "_").replace(_reservedRe, "");
  }
  static parseTrackName(trackName) {
    const matches = _trackRe.exec(trackName);
    if (!matches) {
      throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
    }
    const results = {
      // directoryName: matches[ 1 ], // (tschw) currently unused
      nodeName: matches[2],
      objectName: matches[3],
      objectIndex: matches[4],
      propertyName: matches[5],
      // required
      propertyIndex: matches[6]
    };
    const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
    if (lastDot !== void 0 && lastDot !== -1) {
      const objectName = results.nodeName.substring(lastDot + 1);
      if (_supportedObjectNames.indexOf(objectName) !== -1) {
        results.nodeName = results.nodeName.substring(0, lastDot);
        results.objectName = objectName;
      }
    }
    if (results.propertyName === null || results.propertyName.length === 0) {
      throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
    }
    return results;
  }
  static findNode(root, nodeName) {
    if (!nodeName || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) {
      return root;
    }
    if (root.skeleton) {
      const bone = root.skeleton.getBoneByName(nodeName);
      if (bone !== void 0) {
        return bone;
      }
    }
    if (root.children) {
      const searchNodeSubtree = function(children) {
        for (let i2 = 0; i2 < children.length; i2++) {
          const childNode = children[i2];
          if (childNode.name === nodeName || childNode.uuid === nodeName) {
            return childNode;
          }
          const result = searchNodeSubtree(childNode.children);
          if (result) return result;
        }
        return null;
      };
      const subTreeNode = searchNodeSubtree(root.children);
      if (subTreeNode) {
        return subTreeNode;
      }
    }
    return null;
  }
  // these are used to "bind" a nonexistent property
  _getValue_unavailable() {
  }
  _setValue_unavailable() {
  }
  // Getters
  _getValue_direct(buffer, offset) {
    buffer[offset] = this.targetObject[this.propertyName];
  }
  _getValue_array(buffer, offset) {
    const source = this.resolvedProperty;
    for (let i2 = 0, n2 = source.length; i2 !== n2; ++i2) {
      buffer[offset++] = source[i2];
    }
  }
  _getValue_arrayElement(buffer, offset) {
    buffer[offset] = this.resolvedProperty[this.propertyIndex];
  }
  _getValue_toArray(buffer, offset) {
    this.resolvedProperty.toArray(buffer, offset);
  }
  // Direct
  _setValue_direct(buffer, offset) {
    this.targetObject[this.propertyName] = buffer[offset];
  }
  _setValue_direct_setNeedsUpdate(buffer, offset) {
    this.targetObject[this.propertyName] = buffer[offset];
    this.targetObject.needsUpdate = true;
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
    this.targetObject[this.propertyName] = buffer[offset];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // EntireArray
  _setValue_array(buffer, offset) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer[offset++];
    }
  }
  _setValue_array_setNeedsUpdate(buffer, offset) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer[offset++];
    }
    this.targetObject.needsUpdate = true;
  }
  _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer[offset++];
    }
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // ArrayElement
  _setValue_arrayElement(buffer, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset];
  }
  _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset];
    this.targetObject.needsUpdate = true;
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer[offset];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // HasToFromArray
  _setValue_fromArray(buffer, offset) {
    this.resolvedProperty.fromArray(buffer, offset);
  }
  _setValue_fromArray_setNeedsUpdate(buffer, offset) {
    this.resolvedProperty.fromArray(buffer, offset);
    this.targetObject.needsUpdate = true;
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
    this.resolvedProperty.fromArray(buffer, offset);
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  _getValue_unbound(targetArray, offset) {
    this.bind();
    this.getValue(targetArray, offset);
  }
  _setValue_unbound(sourceArray, offset) {
    this.bind();
    this.setValue(sourceArray, offset);
  }
  // create getter / setter pair for a property in the scene graph
  bind() {
    let targetObject = this.node;
    const parsedPath = this.parsedPath;
    const objectName = parsedPath.objectName;
    const propertyName = parsedPath.propertyName;
    let propertyIndex = parsedPath.propertyIndex;
    if (!targetObject) {
      targetObject = PropertyBinding2.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
      this.node = targetObject;
    }
    this.getValue = this._getValue_unavailable;
    this.setValue = this._setValue_unavailable;
    if (!targetObject) {
      console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
      return;
    }
    if (objectName) {
      let objectIndex = parsedPath.objectIndex;
      switch (objectName) {
        case "materials":
          if (!targetObject.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!targetObject.material.materials) {
            console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
            return;
          }
          targetObject = targetObject.material.materials;
          break;
        case "bones":
          if (!targetObject.skeleton) {
            console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
            return;
          }
          targetObject = targetObject.skeleton.bones;
          for (let i2 = 0; i2 < targetObject.length; i2++) {
            if (targetObject[i2].name === objectIndex) {
              objectIndex = i2;
              break;
            }
          }
          break;
        default:
          if (targetObject[objectName] === void 0) {
            console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
            return;
          }
          targetObject = targetObject[objectName];
      }
      if (objectIndex !== void 0) {
        if (targetObject[objectIndex] === void 0) {
          console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
          return;
        }
        targetObject = targetObject[objectIndex];
      }
    }
    const nodeProperty = targetObject[propertyName];
    if (nodeProperty === void 0) {
      const nodeName = parsedPath.nodeName;
      console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
      return;
    }
    let versioning = this.Versioning.None;
    this.targetObject = targetObject;
    if (targetObject.needsUpdate !== void 0) {
      versioning = this.Versioning.NeedsUpdate;
    } else if (targetObject.matrixWorldNeedsUpdate !== void 0) {
      versioning = this.Versioning.MatrixWorldNeedsUpdate;
    }
    let bindingType = this.BindingType.Direct;
    if (propertyIndex !== void 0) {
      if (propertyName === "morphTargetInfluences") {
        if (!targetObject.geometry) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
          return;
        }
        if (targetObject.geometry.isBufferGeometry) {
          if (!targetObject.geometry.morphAttributes) {
            console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
            return;
          }
          if (targetObject.morphTargetDictionary[propertyIndex] !== void 0) {
            propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
          }
        } else {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.", this);
          return;
        }
      }
      bindingType = this.BindingType.ArrayElement;
      this.resolvedProperty = nodeProperty;
      this.propertyIndex = propertyIndex;
    } else if (nodeProperty.fromArray !== void 0 && nodeProperty.toArray !== void 0) {
      bindingType = this.BindingType.HasFromToArray;
      this.resolvedProperty = nodeProperty;
    } else if (Array.isArray(nodeProperty)) {
      bindingType = this.BindingType.EntireArray;
      this.resolvedProperty = nodeProperty;
    } else {
      this.propertyName = propertyName;
    }
    this.getValue = this.GetterByBindingType[bindingType];
    this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
  }
  unbind() {
    this.node = null;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
}
PropertyBinding2.Composite = Composite2;
PropertyBinding2.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
};
PropertyBinding2.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
};
PropertyBinding2.prototype.GetterByBindingType = [
  PropertyBinding2.prototype._getValue_direct,
  PropertyBinding2.prototype._getValue_array,
  PropertyBinding2.prototype._getValue_arrayElement,
  PropertyBinding2.prototype._getValue_toArray
];
PropertyBinding2.prototype.SetterByBindingTypeAndVersioning = [
  [
    // Direct
    PropertyBinding2.prototype._setValue_direct,
    PropertyBinding2.prototype._setValue_direct_setNeedsUpdate,
    PropertyBinding2.prototype._setValue_direct_setMatrixWorldNeedsUpdate
  ],
  [
    // EntireArray
    PropertyBinding2.prototype._setValue_array,
    PropertyBinding2.prototype._setValue_array_setNeedsUpdate,
    PropertyBinding2.prototype._setValue_array_setMatrixWorldNeedsUpdate
  ],
  [
    // ArrayElement
    PropertyBinding2.prototype._setValue_arrayElement,
    PropertyBinding2.prototype._setValue_arrayElement_setNeedsUpdate,
    PropertyBinding2.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
  ],
  [
    // HasToFromArray
    PropertyBinding2.prototype._setValue_fromArray,
    PropertyBinding2.prototype._setValue_fromArray_setNeedsUpdate,
    PropertyBinding2.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
  ]
];
class AnimationAction2 {
  constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode) {
    this._mixer = mixer;
    this._clip = clip;
    this._localRoot = localRoot;
    this.blendMode = blendMode;
    const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
    const interpolantSettings = {
      endingStart: ZeroCurvatureEnding,
      endingEnd: ZeroCurvatureEnding
    };
    for (let i2 = 0; i2 !== nTracks; ++i2) {
      const interpolant = tracks[i2].createInterpolant(null);
      interpolants[i2] = interpolant;
      interpolant.settings = interpolantSettings;
    }
    this._interpolantSettings = interpolantSettings;
    this._interpolants = interpolants;
    this._propertyBindings = new Array(nTracks);
    this._cacheIndex = null;
    this._byClipCacheIndex = null;
    this._timeScaleInterpolant = null;
    this._weightInterpolant = null;
    this.loop = LoopRepeat;
    this._loopCount = -1;
    this._startTime = null;
    this.time = 0;
    this.timeScale = 1;
    this._effectiveTimeScale = 1;
    this.weight = 1;
    this._effectiveWeight = 1;
    this.repetitions = Infinity;
    this.paused = false;
    this.enabled = true;
    this.clampWhenFinished = false;
    this.zeroSlopeAtStart = true;
    this.zeroSlopeAtEnd = true;
  }
  // State & Scheduling
  play() {
    this._mixer._activateAction(this);
    return this;
  }
  stop() {
    this._mixer._deactivateAction(this);
    return this.reset();
  }
  reset() {
    this.paused = false;
    this.enabled = true;
    this.time = 0;
    this._loopCount = -1;
    this._startTime = null;
    return this.stopFading().stopWarping();
  }
  isRunning() {
    return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
  }
  // return true when play has been called
  isScheduled() {
    return this._mixer._isActiveAction(this);
  }
  startAt(time2) {
    this._startTime = time2;
    return this;
  }
  setLoop(mode, repetitions) {
    this.loop = mode;
    this.repetitions = repetitions;
    return this;
  }
  // Weight
  // set the weight stopping any scheduled fading
  // although .enabled = false yields an effective weight of zero, this
  // method does *not* change .enabled, because it would be confusing
  setEffectiveWeight(weight) {
    this.weight = weight;
    this._effectiveWeight = this.enabled ? weight : 0;
    return this.stopFading();
  }
  // return the weight considering fading and .enabled
  getEffectiveWeight() {
    return this._effectiveWeight;
  }
  fadeIn(duration2) {
    return this._scheduleFading(duration2, 0, 1);
  }
  fadeOut(duration2) {
    return this._scheduleFading(duration2, 1, 0);
  }
  crossFadeFrom(fadeOutAction, duration2, warp) {
    fadeOutAction.fadeOut(duration2);
    this.fadeIn(duration2);
    if (warp) {
      const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
      fadeOutAction.warp(1, startEndRatio, duration2);
      this.warp(endStartRatio, 1, duration2);
    }
    return this;
  }
  crossFadeTo(fadeInAction, duration2, warp) {
    return fadeInAction.crossFadeFrom(this, duration2, warp);
  }
  stopFading() {
    const weightInterpolant = this._weightInterpolant;
    if (weightInterpolant !== null) {
      this._weightInterpolant = null;
      this._mixer._takeBackControlInterpolant(weightInterpolant);
    }
    return this;
  }
  // Time Scale Control
  // set the time scale stopping any scheduled warping
  // although .paused = true yields an effective time scale of zero, this
  // method does *not* change .paused, because it would be confusing
  setEffectiveTimeScale(timeScale) {
    this.timeScale = timeScale;
    this._effectiveTimeScale = this.paused ? 0 : timeScale;
    return this.stopWarping();
  }
  // return the time scale considering warping and .paused
  getEffectiveTimeScale() {
    return this._effectiveTimeScale;
  }
  setDuration(duration2) {
    this.timeScale = this._clip.duration / duration2;
    return this.stopWarping();
  }
  syncWith(action) {
    this.time = action.time;
    this.timeScale = action.timeScale;
    return this.stopWarping();
  }
  halt(duration2) {
    return this.warp(this._effectiveTimeScale, 0, duration2);
  }
  warp(startTimeScale, endTimeScale, duration2) {
    const mixer = this._mixer, now2 = mixer.time, timeScale = this.timeScale;
    let interpolant = this._timeScaleInterpolant;
    if (interpolant === null) {
      interpolant = mixer._lendControlInterpolant();
      this._timeScaleInterpolant = interpolant;
    }
    const times2 = interpolant.parameterPositions, values = interpolant.sampleValues;
    times2[0] = now2;
    times2[1] = now2 + duration2;
    values[0] = startTimeScale / timeScale;
    values[1] = endTimeScale / timeScale;
    return this;
  }
  stopWarping() {
    const timeScaleInterpolant = this._timeScaleInterpolant;
    if (timeScaleInterpolant !== null) {
      this._timeScaleInterpolant = null;
      this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
    }
    return this;
  }
  // Object Accessors
  getMixer() {
    return this._mixer;
  }
  getClip() {
    return this._clip;
  }
  getRoot() {
    return this._localRoot || this._mixer._root;
  }
  // Interna
  _update(time2, deltaTime, timeDirection, accuIndex) {
    if (!this.enabled) {
      this._updateWeight(time2);
      return;
    }
    const startTime = this._startTime;
    if (startTime !== null) {
      const timeRunning = (time2 - startTime) * timeDirection;
      if (timeRunning < 0 || timeDirection === 0) {
        return;
      }
      this._startTime = null;
      deltaTime = timeDirection * timeRunning;
    }
    deltaTime *= this._updateTimeScale(time2);
    const clipTime = this._updateTime(deltaTime);
    const weight = this._updateWeight(time2);
    if (weight > 0) {
      const interpolants = this._interpolants;
      const propertyMixers = this._propertyBindings;
      switch (this.blendMode) {
        case AdditiveAnimationBlendMode:
          for (let j = 0, m = interpolants.length; j !== m; ++j) {
            interpolants[j].evaluate(clipTime);
            propertyMixers[j].accumulateAdditive(weight);
          }
          break;
        case NormalAnimationBlendMode:
        default:
          for (let j = 0, m = interpolants.length; j !== m; ++j) {
            interpolants[j].evaluate(clipTime);
            propertyMixers[j].accumulate(accuIndex, weight);
          }
      }
    }
  }
  _updateWeight(time2) {
    let weight = 0;
    if (this.enabled) {
      weight = this.weight;
      const interpolant = this._weightInterpolant;
      if (interpolant !== null) {
        const interpolantValue = interpolant.evaluate(time2)[0];
        weight *= interpolantValue;
        if (time2 > interpolant.parameterPositions[1]) {
          this.stopFading();
          if (interpolantValue === 0) {
            this.enabled = false;
          }
        }
      }
    }
    this._effectiveWeight = weight;
    return weight;
  }
  _updateTimeScale(time2) {
    let timeScale = 0;
    if (!this.paused) {
      timeScale = this.timeScale;
      const interpolant = this._timeScaleInterpolant;
      if (interpolant !== null) {
        const interpolantValue = interpolant.evaluate(time2)[0];
        timeScale *= interpolantValue;
        if (time2 > interpolant.parameterPositions[1]) {
          this.stopWarping();
          if (timeScale === 0) {
            this.paused = true;
          } else {
            this.timeScale = timeScale;
          }
        }
      }
    }
    this._effectiveTimeScale = timeScale;
    return timeScale;
  }
  _updateTime(deltaTime) {
    const duration2 = this._clip.duration;
    const loop = this.loop;
    let time2 = this.time + deltaTime;
    let loopCount = this._loopCount;
    const pingPong = loop === LoopPingPong;
    if (deltaTime === 0) {
      if (loopCount === -1) return time2;
      return pingPong && (loopCount & 1) === 1 ? duration2 - time2 : time2;
    }
    if (loop === LoopOnce) {
      if (loopCount === -1) {
        this._loopCount = 0;
        this._setEndings(true, true, false);
      }
      handle_stop: {
        if (time2 >= duration2) {
          time2 = duration2;
        } else if (time2 < 0) {
          time2 = 0;
        } else {
          this.time = time2;
          break handle_stop;
        }
        if (this.clampWhenFinished) this.paused = true;
        else this.enabled = false;
        this.time = time2;
        this._mixer.dispatchEvent({
          type: "finished",
          action: this,
          direction: deltaTime < 0 ? -1 : 1
        });
      }
    } else {
      if (loopCount === -1) {
        if (deltaTime >= 0) {
          loopCount = 0;
          this._setEndings(true, this.repetitions === 0, pingPong);
        } else {
          this._setEndings(this.repetitions === 0, true, pingPong);
        }
      }
      if (time2 >= duration2 || time2 < 0) {
        const loopDelta = Math.floor(time2 / duration2);
        time2 -= duration2 * loopDelta;
        loopCount += Math.abs(loopDelta);
        const pending = this.repetitions - loopCount;
        if (pending <= 0) {
          if (this.clampWhenFinished) this.paused = true;
          else this.enabled = false;
          time2 = deltaTime > 0 ? duration2 : 0;
          this.time = time2;
          this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: deltaTime > 0 ? 1 : -1
          });
        } else {
          if (pending === 1) {
            const atStart = deltaTime < 0;
            this._setEndings(atStart, !atStart, pingPong);
          } else {
            this._setEndings(false, false, pingPong);
          }
          this._loopCount = loopCount;
          this.time = time2;
          this._mixer.dispatchEvent({
            type: "loop",
            action: this,
            loopDelta
          });
        }
      } else {
        this.time = time2;
      }
      if (pingPong && (loopCount & 1) === 1) {
        return duration2 - time2;
      }
    }
    return time2;
  }
  _setEndings(atStart, atEnd, pingPong) {
    const settings = this._interpolantSettings;
    if (pingPong) {
      settings.endingStart = ZeroSlopeEnding;
      settings.endingEnd = ZeroSlopeEnding;
    } else {
      if (atStart) {
        settings.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding : ZeroCurvatureEnding;
      } else {
        settings.endingStart = WrapAroundEnding;
      }
      if (atEnd) {
        settings.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding : ZeroCurvatureEnding;
      } else {
        settings.endingEnd = WrapAroundEnding;
      }
    }
  }
  _scheduleFading(duration2, weightNow, weightThen) {
    const mixer = this._mixer, now2 = mixer.time;
    let interpolant = this._weightInterpolant;
    if (interpolant === null) {
      interpolant = mixer._lendControlInterpolant();
      this._weightInterpolant = interpolant;
    }
    const times2 = interpolant.parameterPositions, values = interpolant.sampleValues;
    times2[0] = now2;
    values[0] = weightNow;
    times2[1] = now2 + duration2;
    values[1] = weightThen;
    return this;
  }
}
class AnimationMixer2 extends EventDispatcher2 {
  constructor(root) {
    super();
    this._root = root;
    this._initMemoryManager();
    this._accuIndex = 0;
    this.time = 0;
    this.timeScale = 1;
  }
  _bindAction(action, prototypeAction) {
    const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
    let bindingsByName = bindingsByRoot[rootUuid];
    if (bindingsByName === void 0) {
      bindingsByName = {};
      bindingsByRoot[rootUuid] = bindingsByName;
    }
    for (let i2 = 0; i2 !== nTracks; ++i2) {
      const track = tracks[i2], trackName = track.name;
      let binding = bindingsByName[trackName];
      if (binding !== void 0) {
        bindings[i2] = binding;
      } else {
        binding = bindings[i2];
        if (binding !== void 0) {
          if (binding._cacheIndex === null) {
            ++binding.referenceCount;
            this._addInactiveBinding(binding, rootUuid, trackName);
          }
          continue;
        }
        const path = prototypeAction && prototypeAction._propertyBindings[i2].binding.parsedPath;
        binding = new PropertyMixer2(
          PropertyBinding2.create(root, trackName, path),
          track.ValueTypeName,
          track.getValueSize()
        );
        ++binding.referenceCount;
        this._addInactiveBinding(binding, rootUuid, trackName);
        bindings[i2] = binding;
      }
      interpolants[i2].resultBuffer = binding.buffer;
    }
  }
  _activateAction(action) {
    if (!this._isActiveAction(action)) {
      if (action._cacheIndex === null) {
        const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
        this._bindAction(
          action,
          actionsForClip && actionsForClip.knownActions[0]
        );
        this._addInactiveAction(action, clipUuid, rootUuid);
      }
      const bindings = action._propertyBindings;
      for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
        const binding = bindings[i2];
        if (binding.useCount++ === 0) {
          this._lendBinding(binding);
          binding.saveOriginalState();
        }
      }
      this._lendAction(action);
    }
  }
  _deactivateAction(action) {
    if (this._isActiveAction(action)) {
      const bindings = action._propertyBindings;
      for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
        const binding = bindings[i2];
        if (--binding.useCount === 0) {
          binding.restoreOriginalState();
          this._takeBackBinding(binding);
        }
      }
      this._takeBackAction(action);
    }
  }
  // Memory manager
  _initMemoryManager() {
    this._actions = [];
    this._nActiveActions = 0;
    this._actionsByClip = {};
    this._bindings = [];
    this._nActiveBindings = 0;
    this._bindingsByRootAndName = {};
    this._controlInterpolants = [];
    this._nActiveControlInterpolants = 0;
    const scope = this;
    this.stats = {
      actions: {
        get total() {
          return scope._actions.length;
        },
        get inUse() {
          return scope._nActiveActions;
        }
      },
      bindings: {
        get total() {
          return scope._bindings.length;
        },
        get inUse() {
          return scope._nActiveBindings;
        }
      },
      controlInterpolants: {
        get total() {
          return scope._controlInterpolants.length;
        },
        get inUse() {
          return scope._nActiveControlInterpolants;
        }
      }
    };
  }
  // Memory management for AnimationAction objects
  _isActiveAction(action) {
    const index2 = action._cacheIndex;
    return index2 !== null && index2 < this._nActiveActions;
  }
  _addInactiveAction(action, clipUuid, rootUuid) {
    const actions = this._actions, actionsByClip = this._actionsByClip;
    let actionsForClip = actionsByClip[clipUuid];
    if (actionsForClip === void 0) {
      actionsForClip = {
        knownActions: [action],
        actionByRoot: {}
      };
      action._byClipCacheIndex = 0;
      actionsByClip[clipUuid] = actionsForClip;
    } else {
      const knownActions = actionsForClip.knownActions;
      action._byClipCacheIndex = knownActions.length;
      knownActions.push(action);
    }
    action._cacheIndex = actions.length;
    actions.push(action);
    actionsForClip.actionByRoot[rootUuid] = action;
  }
  _removeInactiveAction(action) {
    const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
    lastInactiveAction._cacheIndex = cacheIndex;
    actions[cacheIndex] = lastInactiveAction;
    actions.pop();
    action._cacheIndex = null;
    const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
    lastKnownAction._byClipCacheIndex = byClipCacheIndex;
    knownActionsForClip[byClipCacheIndex] = lastKnownAction;
    knownActionsForClip.pop();
    action._byClipCacheIndex = null;
    const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
    delete actionByRoot[rootUuid];
    if (knownActionsForClip.length === 0) {
      delete actionsByClip[clipUuid];
    }
    this._removeInactiveBindingsForAction(action);
  }
  _removeInactiveBindingsForAction(action) {
    const bindings = action._propertyBindings;
    for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
      const binding = bindings[i2];
      if (--binding.referenceCount === 0) {
        this._removeInactiveBinding(binding);
      }
    }
  }
  _lendAction(action) {
    const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
    action._cacheIndex = lastActiveIndex;
    actions[lastActiveIndex] = action;
    firstInactiveAction._cacheIndex = prevIndex;
    actions[prevIndex] = firstInactiveAction;
  }
  _takeBackAction(action) {
    const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
    action._cacheIndex = firstInactiveIndex;
    actions[firstInactiveIndex] = action;
    lastActiveAction._cacheIndex = prevIndex;
    actions[prevIndex] = lastActiveAction;
  }
  // Memory management for PropertyMixer objects
  _addInactiveBinding(binding, rootUuid, trackName) {
    const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
    let bindingByName = bindingsByRoot[rootUuid];
    if (bindingByName === void 0) {
      bindingByName = {};
      bindingsByRoot[rootUuid] = bindingByName;
    }
    bindingByName[trackName] = binding;
    binding._cacheIndex = bindings.length;
    bindings.push(binding);
  }
  _removeInactiveBinding(binding) {
    const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
    lastInactiveBinding._cacheIndex = cacheIndex;
    bindings[cacheIndex] = lastInactiveBinding;
    bindings.pop();
    delete bindingByName[trackName];
    if (Object.keys(bindingByName).length === 0) {
      delete bindingsByRoot[rootUuid];
    }
  }
  _lendBinding(binding) {
    const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
    binding._cacheIndex = lastActiveIndex;
    bindings[lastActiveIndex] = binding;
    firstInactiveBinding._cacheIndex = prevIndex;
    bindings[prevIndex] = firstInactiveBinding;
  }
  _takeBackBinding(binding) {
    const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
    binding._cacheIndex = firstInactiveIndex;
    bindings[firstInactiveIndex] = binding;
    lastActiveBinding._cacheIndex = prevIndex;
    bindings[prevIndex] = lastActiveBinding;
  }
  // Memory management of Interpolants for weight and time scale
  _lendControlInterpolant() {
    const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
    let interpolant = interpolants[lastActiveIndex];
    if (interpolant === void 0) {
      interpolant = new LinearInterpolant2(
        new Float32Array(2),
        new Float32Array(2),
        1,
        this._controlInterpolantsResultBuffer
      );
      interpolant.__cacheIndex = lastActiveIndex;
      interpolants[lastActiveIndex] = interpolant;
    }
    return interpolant;
  }
  _takeBackControlInterpolant(interpolant) {
    const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
    interpolant.__cacheIndex = firstInactiveIndex;
    interpolants[firstInactiveIndex] = interpolant;
    lastActiveInterpolant.__cacheIndex = prevIndex;
    interpolants[prevIndex] = lastActiveInterpolant;
  }
  // return an action for a clip optionally using a custom root target
  // object (this method allocates a lot of dynamic memory in case a
  // previously unknown clip/root combination is specified)
  clipAction(clip, optionalRoot, blendMode) {
    const root = optionalRoot || this._root, rootUuid = root.uuid;
    let clipObject = typeof clip === "string" ? AnimationClip2.findByName(root, clip) : clip;
    const clipUuid = clipObject !== null ? clipObject.uuid : clip;
    const actionsForClip = this._actionsByClip[clipUuid];
    let prototypeAction = null;
    if (blendMode === void 0) {
      if (clipObject !== null) {
        blendMode = clipObject.blendMode;
      } else {
        blendMode = NormalAnimationBlendMode;
      }
    }
    if (actionsForClip !== void 0) {
      const existingAction = actionsForClip.actionByRoot[rootUuid];
      if (existingAction !== void 0 && existingAction.blendMode === blendMode) {
        return existingAction;
      }
      prototypeAction = actionsForClip.knownActions[0];
      if (clipObject === null)
        clipObject = prototypeAction._clip;
    }
    if (clipObject === null) return null;
    const newAction = new AnimationAction2(this, clipObject, optionalRoot, blendMode);
    this._bindAction(newAction, prototypeAction);
    this._addInactiveAction(newAction, clipUuid, rootUuid);
    return newAction;
  }
  // get an existing action
  existingAction(clip, optionalRoot) {
    const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? AnimationClip2.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
    if (actionsForClip !== void 0) {
      return actionsForClip.actionByRoot[rootUuid] || null;
    }
    return null;
  }
  // deactivates all previously scheduled actions
  stopAllAction() {
    const actions = this._actions, nActions = this._nActiveActions;
    for (let i2 = nActions - 1; i2 >= 0; --i2) {
      actions[i2].stop();
    }
    return this;
  }
  // advance the time and update apply the animation
  update(deltaTime) {
    deltaTime *= this.timeScale;
    const actions = this._actions, nActions = this._nActiveActions, time2 = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
    for (let i2 = 0; i2 !== nActions; ++i2) {
      const action = actions[i2];
      action._update(time2, deltaTime, timeDirection, accuIndex);
    }
    const bindings = this._bindings, nBindings = this._nActiveBindings;
    for (let i2 = 0; i2 !== nBindings; ++i2) {
      bindings[i2].apply(accuIndex);
    }
    return this;
  }
  // Allows you to seek to a specific time in an animation.
  setTime(timeInSeconds) {
    this.time = 0;
    for (let i2 = 0; i2 < this._actions.length; i2++) {
      this._actions[i2].time = 0;
    }
    return this.update(timeInSeconds);
  }
  // return this mixer's root target object
  getRoot() {
    return this._root;
  }
  // free all resources specific to a particular clip
  uncacheClip(clip) {
    const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
    if (actionsForClip !== void 0) {
      const actionsToRemove = actionsForClip.knownActions;
      for (let i2 = 0, n2 = actionsToRemove.length; i2 !== n2; ++i2) {
        const action = actionsToRemove[i2];
        this._deactivateAction(action);
        const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
        action._cacheIndex = null;
        action._byClipCacheIndex = null;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        this._removeInactiveBindingsForAction(action);
      }
      delete actionsByClip[clipUuid];
    }
  }
  // free all resources specific to a particular root target object
  uncacheRoot(root) {
    const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
    for (const clipUuid in actionsByClip) {
      const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
      if (action !== void 0) {
        this._deactivateAction(action);
        this._removeInactiveAction(action);
      }
    }
    const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
    if (bindingByName !== void 0) {
      for (const trackName in bindingByName) {
        const binding = bindingByName[trackName];
        binding.restoreOriginalState();
        this._removeInactiveBinding(binding);
      }
    }
  }
  // remove a targeted clip from the cache
  uncacheAction(clip, optionalRoot) {
    const action = this.existingAction(clip, optionalRoot);
    if (action !== null) {
      this._deactivateAction(action);
      this._removeInactiveAction(action);
    }
  }
}
AnimationMixer2.prototype._controlInterpolantsResultBuffer = new Float32Array(1);
class InstancedInterleavedBuffer2 extends InterleavedBuffer2 {
  constructor(array, stride, meshPerAttribute = 1) {
    super(array, stride);
    this.meshPerAttribute = meshPerAttribute;
  }
  copy(source) {
    super.copy(source);
    this.meshPerAttribute = source.meshPerAttribute;
    return this;
  }
  clone(data) {
    const ib = super.clone(data);
    ib.meshPerAttribute = this.meshPerAttribute;
    return ib;
  }
  toJSON(data) {
    const json = super.toJSON(data);
    json.isInstancedInterleavedBuffer = true;
    json.meshPerAttribute = this.meshPerAttribute;
    return json;
  }
}
InstancedInterleavedBuffer2.prototype.isInstancedInterleavedBuffer = true;
class ImmediateRenderObject extends Object3D2 {
  constructor(material) {
    super();
    this.material = material;
    this.render = function() {
    };
    this.hasPositions = false;
    this.hasNormals = false;
    this.hasColors = false;
    this.hasUvs = false;
    this.positionArray = null;
    this.normalArray = null;
    this.colorArray = null;
    this.uvArray = null;
    this.count = 0;
  }
}
ImmediateRenderObject.prototype.isImmediateRenderObject = true;
const _vector$2 = /* @__PURE__ */ new Vector32();
const _boneMatrix = /* @__PURE__ */ new Matrix42();
const _matrixWorldInv = /* @__PURE__ */ new Matrix42();
class SkeletonHelper2 extends LineSegments2 {
  constructor(object) {
    const bones = getBoneList(object);
    const geometry = new BufferGeometry2();
    const vertices = [];
    const colors = [];
    const color1 = new Color2(0, 0, 1);
    const color2 = new Color2(0, 1, 0);
    for (let i2 = 0; i2 < bones.length; i2++) {
      const bone = bones[i2];
      if (bone.parent && bone.parent.isBone) {
        vertices.push(0, 0, 0);
        vertices.push(0, 0, 0);
        colors.push(color1.r, color1.g, color1.b);
        colors.push(color2.r, color2.g, color2.b);
      }
    }
    geometry.setAttribute("position", new Float32BufferAttribute2(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute2(colors, 3));
    const material = new LineBasicMaterial2({ vertexColors: true, depthTest: false, depthWrite: false, toneMapped: false, transparent: true });
    super(geometry, material);
    this.type = "SkeletonHelper";
    this.isSkeletonHelper = true;
    this.root = object;
    this.bones = bones;
    this.matrix = object.matrixWorld;
    this.matrixAutoUpdate = false;
  }
  updateMatrixWorld(force) {
    const bones = this.bones;
    const geometry = this.geometry;
    const position2 = geometry.getAttribute("position");
    _matrixWorldInv.copy(this.root.matrixWorld).invert();
    for (let i2 = 0, j = 0; i2 < bones.length; i2++) {
      const bone = bones[i2];
      if (bone.parent && bone.parent.isBone) {
        _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.matrixWorld);
        _vector$2.setFromMatrixPosition(_boneMatrix);
        position2.setXYZ(j, _vector$2.x, _vector$2.y, _vector$2.z);
        _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.parent.matrixWorld);
        _vector$2.setFromMatrixPosition(_boneMatrix);
        position2.setXYZ(j + 1, _vector$2.x, _vector$2.y, _vector$2.z);
        j += 2;
      }
    }
    geometry.getAttribute("position").needsUpdate = true;
    super.updateMatrixWorld(force);
  }
}
function getBoneList(object) {
  const boneList = [];
  if (object && object.isBone) {
    boneList.push(object);
  }
  for (let i2 = 0; i2 < object.children.length; i2++) {
    boneList.push.apply(boneList, getBoneList(object.children[i2]));
  }
  return boneList;
}
class GridHelper2 extends LineSegments2 {
  constructor(size = 10, divisions = 10, color1 = 4473924, color2 = 8947848) {
    color1 = new Color2(color1);
    color2 = new Color2(color2);
    const center = divisions / 2;
    const step = size / divisions;
    const halfSize = size / 2;
    const vertices = [], colors = [];
    for (let i2 = 0, j = 0, k = -halfSize; i2 <= divisions; i2++, k += step) {
      vertices.push(-halfSize, 0, k, halfSize, 0, k);
      vertices.push(k, 0, -halfSize, k, 0, halfSize);
      const color3 = i2 === center ? color1 : color2;
      color3.toArray(colors, j);
      j += 3;
      color3.toArray(colors, j);
      j += 3;
      color3.toArray(colors, j);
      j += 3;
      color3.toArray(colors, j);
      j += 3;
    }
    const geometry = new BufferGeometry2();
    geometry.setAttribute("position", new Float32BufferAttribute2(vertices, 3));
    geometry.setAttribute("color", new Float32BufferAttribute2(colors, 3));
    const material = new LineBasicMaterial2({ vertexColors: true, toneMapped: false });
    super(geometry, material);
    this.type = "GridHelper";
  }
}
const _floatView = new Float32Array(1);
new Int32Array(_floatView.buffer);
Curve2.create = function(construct, getPoint) {
  console.log("THREE.Curve.create() has been deprecated");
  construct.prototype = Object.create(Curve2.prototype);
  construct.prototype.constructor = construct;
  construct.prototype.getPoint = getPoint;
  return construct;
};
Path2.prototype.fromPoints = function(points) {
  console.warn("THREE.Path: .fromPoints() has been renamed to .setFromPoints().");
  return this.setFromPoints(points);
};
GridHelper2.prototype.setColors = function() {
  console.error("THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.");
};
SkeletonHelper2.prototype.update = function() {
  console.error("THREE.SkeletonHelper: update() no longer needs to be called.");
};
Loader2.prototype.extractUrlBase = function(url) {
  console.warn("THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.");
  return LoaderUtils2.extractUrlBase(url);
};
Loader2.Handlers = {
  add: function() {
    console.error("THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.");
  },
  get: function() {
    console.error("THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.");
  }
};
Box32.prototype.center = function(optionalTarget) {
  console.warn("THREE.Box3: .center() has been renamed to .getCenter().");
  return this.getCenter(optionalTarget);
};
Box32.prototype.empty = function() {
  console.warn("THREE.Box3: .empty() has been renamed to .isEmpty().");
  return this.isEmpty();
};
Box32.prototype.isIntersectionBox = function(box) {
  console.warn("THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().");
  return this.intersectsBox(box);
};
Box32.prototype.isIntersectionSphere = function(sphere) {
  console.warn("THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().");
  return this.intersectsSphere(sphere);
};
Box32.prototype.size = function(optionalTarget) {
  console.warn("THREE.Box3: .size() has been renamed to .getSize().");
  return this.getSize(optionalTarget);
};
Sphere2.prototype.empty = function() {
  console.warn("THREE.Sphere: .empty() has been renamed to .isEmpty().");
  return this.isEmpty();
};
Frustum2.prototype.setFromMatrix = function(m) {
  console.warn("THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix().");
  return this.setFromProjectionMatrix(m);
};
Matrix32.prototype.flattenToArrayOffset = function(array, offset) {
  console.warn("THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
  return this.toArray(array, offset);
};
Matrix32.prototype.multiplyVector3 = function(vector) {
  console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.");
  return vector.applyMatrix3(this);
};
Matrix32.prototype.multiplyVector3Array = function() {
  console.error("THREE.Matrix3: .multiplyVector3Array() has been removed.");
};
Matrix32.prototype.applyToBufferAttribute = function(attribute) {
  console.warn("THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead.");
  return attribute.applyMatrix3(this);
};
Matrix32.prototype.applyToVector3Array = function() {
  console.error("THREE.Matrix3: .applyToVector3Array() has been removed.");
};
Matrix32.prototype.getInverse = function(matrix2) {
  console.warn("THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.");
  return this.copy(matrix2).invert();
};
Matrix42.prototype.extractPosition = function(m) {
  console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().");
  return this.copyPosition(m);
};
Matrix42.prototype.flattenToArrayOffset = function(array, offset) {
  console.warn("THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
  return this.toArray(array, offset);
};
Matrix42.prototype.getPosition = function() {
  console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.");
  return new Vector32().setFromMatrixColumn(this, 3);
};
Matrix42.prototype.setRotationFromQuaternion = function(q) {
  console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().");
  return this.makeRotationFromQuaternion(q);
};
Matrix42.prototype.multiplyToArray = function() {
  console.warn("THREE.Matrix4: .multiplyToArray() has been removed.");
};
Matrix42.prototype.multiplyVector3 = function(vector) {
  console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.");
  return vector.applyMatrix4(this);
};
Matrix42.prototype.multiplyVector4 = function(vector) {
  console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.");
  return vector.applyMatrix4(this);
};
Matrix42.prototype.multiplyVector3Array = function() {
  console.error("THREE.Matrix4: .multiplyVector3Array() has been removed.");
};
Matrix42.prototype.rotateAxis = function(v) {
  console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.");
  v.transformDirection(this);
};
Matrix42.prototype.crossVector = function(vector) {
  console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.");
  return vector.applyMatrix4(this);
};
Matrix42.prototype.translate = function() {
  console.error("THREE.Matrix4: .translate() has been removed.");
};
Matrix42.prototype.rotateX = function() {
  console.error("THREE.Matrix4: .rotateX() has been removed.");
};
Matrix42.prototype.rotateY = function() {
  console.error("THREE.Matrix4: .rotateY() has been removed.");
};
Matrix42.prototype.rotateZ = function() {
  console.error("THREE.Matrix4: .rotateZ() has been removed.");
};
Matrix42.prototype.rotateByAxis = function() {
  console.error("THREE.Matrix4: .rotateByAxis() has been removed.");
};
Matrix42.prototype.applyToBufferAttribute = function(attribute) {
  console.warn("THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead.");
  return attribute.applyMatrix4(this);
};
Matrix42.prototype.applyToVector3Array = function() {
  console.error("THREE.Matrix4: .applyToVector3Array() has been removed.");
};
Matrix42.prototype.makeFrustum = function(left, right, bottom, top, near, far) {
  console.warn("THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.");
  return this.makePerspective(left, right, top, bottom, near, far);
};
Matrix42.prototype.getInverse = function(matrix2) {
  console.warn("THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.");
  return this.copy(matrix2).invert();
};
Plane2.prototype.isIntersectionLine = function(line) {
  console.warn("THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().");
  return this.intersectsLine(line);
};
Quaternion2.prototype.multiplyVector3 = function(vector) {
  console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.");
  return vector.applyQuaternion(this);
};
Quaternion2.prototype.inverse = function() {
  console.warn("THREE.Quaternion: .inverse() has been renamed to invert().");
  return this.invert();
};
Ray2.prototype.isIntersectionBox = function(box) {
  console.warn("THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().");
  return this.intersectsBox(box);
};
Ray2.prototype.isIntersectionPlane = function(plane) {
  console.warn("THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().");
  return this.intersectsPlane(plane);
};
Ray2.prototype.isIntersectionSphere = function(sphere) {
  console.warn("THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().");
  return this.intersectsSphere(sphere);
};
Triangle2.prototype.area = function() {
  console.warn("THREE.Triangle: .area() has been renamed to .getArea().");
  return this.getArea();
};
Triangle2.prototype.barycoordFromPoint = function(point2, target) {
  console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
  return this.getBarycoord(point2, target);
};
Triangle2.prototype.midpoint = function(target) {
  console.warn("THREE.Triangle: .midpoint() has been renamed to .getMidpoint().");
  return this.getMidpoint(target);
};
Triangle2.prototypenormal = function(target) {
  console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
  return this.getNormal(target);
};
Triangle2.prototype.plane = function(target) {
  console.warn("THREE.Triangle: .plane() has been renamed to .getPlane().");
  return this.getPlane(target);
};
Triangle2.barycoordFromPoint = function(point2, a3, b, c2, target) {
  console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
  return Triangle2.getBarycoord(point2, a3, b, c2, target);
};
Triangle2.normal = function(a3, b, c2, target) {
  console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
  return Triangle2.getNormal(a3, b, c2, target);
};
Shape2.prototype.extractAllPoints = function(divisions) {
  console.warn("THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.");
  return this.extractPoints(divisions);
};
Shape2.prototype.extrude = function(options) {
  console.warn("THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.");
  return new ExtrudeGeometry2(this, options);
};
Shape2.prototype.makeGeometry = function(options) {
  console.warn("THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.");
  return new ShapeGeometry2(this, options);
};
Vector22.prototype.fromAttribute = function(attribute, index2, offset) {
  console.warn("THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().");
  return this.fromBufferAttribute(attribute, index2, offset);
};
Vector22.prototype.distanceToManhattan = function(v) {
  console.warn("THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
  return this.manhattanDistanceTo(v);
};
Vector22.prototype.lengthManhattan = function() {
  console.warn("THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().");
  return this.manhattanLength();
};
Vector32.prototype.setEulerFromRotationMatrix = function() {
  console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.");
};
Vector32.prototype.setEulerFromQuaternion = function() {
  console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.");
};
Vector32.prototype.getPositionFromMatrix = function(m) {
  console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().");
  return this.setFromMatrixPosition(m);
};
Vector32.prototype.getScaleFromMatrix = function(m) {
  console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().");
  return this.setFromMatrixScale(m);
};
Vector32.prototype.getColumnFromMatrix = function(index2, matrix2) {
  console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().");
  return this.setFromMatrixColumn(matrix2, index2);
};
Vector32.prototype.applyProjection = function(m) {
  console.warn("THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.");
  return this.applyMatrix4(m);
};
Vector32.prototype.fromAttribute = function(attribute, index2, offset) {
  console.warn("THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().");
  return this.fromBufferAttribute(attribute, index2, offset);
};
Vector32.prototype.distanceToManhattan = function(v) {
  console.warn("THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
  return this.manhattanDistanceTo(v);
};
Vector32.prototype.lengthManhattan = function() {
  console.warn("THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().");
  return this.manhattanLength();
};
Vector42.prototype.fromAttribute = function(attribute, index2, offset) {
  console.warn("THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().");
  return this.fromBufferAttribute(attribute, index2, offset);
};
Vector42.prototype.lengthManhattan = function() {
  console.warn("THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().");
  return this.manhattanLength();
};
Object3D2.prototype.getChildByName = function(name) {
  console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().");
  return this.getObjectByName(name);
};
Object3D2.prototype.renderDepth = function() {
  console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.");
};
Object3D2.prototype.translate = function(distance2, axis) {
  console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.");
  return this.translateOnAxis(axis, distance2);
};
Object3D2.prototype.getWorldRotation = function() {
  console.error("THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.");
};
Object3D2.prototype.applyMatrix = function(matrix2) {
  console.warn("THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4().");
  return this.applyMatrix4(matrix2);
};
Object.defineProperties(Object3D2.prototype, {
  eulerOrder: {
    get: function() {
      console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
      return this.rotation.order;
    },
    set: function(value) {
      console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
      this.rotation.order = value;
    }
  },
  useQuaternion: {
    get: function() {
      console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
    },
    set: function() {
      console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
    }
  }
});
Mesh2.prototype.setDrawMode = function() {
  console.error("THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
};
Object.defineProperties(Mesh2.prototype, {
  drawMode: {
    get: function() {
      console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode.");
      return TrianglesDrawMode;
    },
    set: function() {
      console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
    }
  }
});
SkinnedMesh2.prototype.initBones = function() {
  console.error("THREE.SkinnedMesh: initBones() has been removed.");
};
PerspectiveCamera2.prototype.setLens = function(focalLength, filmGauge) {
  console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup.");
  if (filmGauge !== void 0) this.filmGauge = filmGauge;
  this.setFocalLength(focalLength);
};
Object.defineProperties(Light2.prototype, {
  onlyShadow: {
    set: function() {
      console.warn("THREE.Light: .onlyShadow has been removed.");
    }
  },
  shadowCameraFov: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraFov is now .shadow.camera.fov.");
      this.shadow.camera.fov = value;
    }
  },
  shadowCameraLeft: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraLeft is now .shadow.camera.left.");
      this.shadow.camera.left = value;
    }
  },
  shadowCameraRight: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraRight is now .shadow.camera.right.");
      this.shadow.camera.right = value;
    }
  },
  shadowCameraTop: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraTop is now .shadow.camera.top.");
      this.shadow.camera.top = value;
    }
  },
  shadowCameraBottom: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.");
      this.shadow.camera.bottom = value;
    }
  },
  shadowCameraNear: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraNear is now .shadow.camera.near.");
      this.shadow.camera.near = value;
    }
  },
  shadowCameraFar: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraFar is now .shadow.camera.far.");
      this.shadow.camera.far = value;
    }
  },
  shadowCameraVisible: {
    set: function() {
      console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.");
    }
  },
  shadowBias: {
    set: function(value) {
      console.warn("THREE.Light: .shadowBias is now .shadow.bias.");
      this.shadow.bias = value;
    }
  },
  shadowDarkness: {
    set: function() {
      console.warn("THREE.Light: .shadowDarkness has been removed.");
    }
  },
  shadowMapWidth: {
    set: function(value) {
      console.warn("THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.");
      this.shadow.mapSize.width = value;
    }
  },
  shadowMapHeight: {
    set: function(value) {
      console.warn("THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.");
      this.shadow.mapSize.height = value;
    }
  }
});
Object.defineProperties(BufferAttribute2.prototype, {
  length: {
    get: function() {
      console.warn("THREE.BufferAttribute: .length has been deprecated. Use .count instead.");
      return this.array.length;
    }
  },
  dynamic: {
    get: function() {
      console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.");
      return this.usage === DynamicDrawUsage;
    },
    set: function() {
      console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.");
      this.setUsage(DynamicDrawUsage);
    }
  }
});
BufferAttribute2.prototype.setDynamic = function(value) {
  console.warn("THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead.");
  this.setUsage(value === true ? DynamicDrawUsage : StaticDrawUsage);
  return this;
};
BufferAttribute2.prototype.copyIndicesArray = function() {
  console.error("THREE.BufferAttribute: .copyIndicesArray() has been removed.");
}, BufferAttribute2.prototype.setArray = function() {
  console.error("THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
};
BufferGeometry2.prototype.addIndex = function(index2) {
  console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().");
  this.setIndex(index2);
};
BufferGeometry2.prototype.addAttribute = function(name, attribute) {
  console.warn("THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute().");
  if (!(attribute && attribute.isBufferAttribute) && !(attribute && attribute.isInterleavedBufferAttribute)) {
    console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).");
    return this.setAttribute(name, new BufferAttribute2(arguments[1], arguments[2]));
  }
  if (name === "index") {
    console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.");
    this.setIndex(attribute);
    return this;
  }
  return this.setAttribute(name, attribute);
};
BufferGeometry2.prototype.addDrawCall = function(start, count, indexOffset) {
  if (indexOffset !== void 0) {
    console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.");
  }
  console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup().");
  this.addGroup(start, count);
};
BufferGeometry2.prototype.clearDrawCalls = function() {
  console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().");
  this.clearGroups();
};
BufferGeometry2.prototype.computeOffsets = function() {
  console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.");
};
BufferGeometry2.prototype.removeAttribute = function(name) {
  console.warn("THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute().");
  return this.deleteAttribute(name);
};
BufferGeometry2.prototype.applyMatrix = function(matrix2) {
  console.warn("THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4().");
  return this.applyMatrix4(matrix2);
};
Object.defineProperties(BufferGeometry2.prototype, {
  drawcalls: {
    get: function() {
      console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups.");
      return this.groups;
    }
  },
  offsets: {
    get: function() {
      console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups.");
      return this.groups;
    }
  }
});
InterleavedBuffer2.prototype.setDynamic = function(value) {
  console.warn("THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead.");
  this.setUsage(value === true ? DynamicDrawUsage : StaticDrawUsage);
  return this;
};
InterleavedBuffer2.prototype.setArray = function() {
  console.error("THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
};
ExtrudeGeometry2.prototype.getArrays = function() {
  console.error("THREE.ExtrudeGeometry: .getArrays() has been removed.");
};
ExtrudeGeometry2.prototype.addShapeList = function() {
  console.error("THREE.ExtrudeGeometry: .addShapeList() has been removed.");
};
ExtrudeGeometry2.prototype.addShape = function() {
  console.error("THREE.ExtrudeGeometry: .addShape() has been removed.");
};
Scene2.prototype.dispose = function() {
  console.error("THREE.Scene: .dispose() has been removed.");
};
Object.defineProperties(Material2.prototype, {
  wrapAround: {
    get: function() {
      console.warn("THREE.Material: .wrapAround has been removed.");
    },
    set: function() {
      console.warn("THREE.Material: .wrapAround has been removed.");
    }
  },
  overdraw: {
    get: function() {
      console.warn("THREE.Material: .overdraw has been removed.");
    },
    set: function() {
      console.warn("THREE.Material: .overdraw has been removed.");
    }
  },
  wrapRGB: {
    get: function() {
      console.warn("THREE.Material: .wrapRGB has been removed.");
      return new Color2();
    }
  },
  shading: {
    get: function() {
      console.error("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
    },
    set: function(value) {
      console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
      this.flatShading = value === FlatShading;
    }
  },
  stencilMask: {
    get: function() {
      console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead.");
      return this.stencilFuncMask;
    },
    set: function(value) {
      console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead.");
      this.stencilFuncMask = value;
    }
  },
  vertexTangents: {
    get: function() {
      console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
    },
    set: function() {
      console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
    }
  }
});
Object.defineProperties(ShaderMaterial2.prototype, {
  derivatives: {
    get: function() {
      console.warn("THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
      return this.extensions.derivatives;
    },
    set: function(value) {
      console.warn("THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
      this.extensions.derivatives = value;
    }
  }
});
WebGLRenderer2.prototype.clearTarget = function(renderTarget, color2, depth, stencil) {
  console.warn("THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead.");
  this.setRenderTarget(renderTarget);
  this.clear(color2, depth, stencil);
};
WebGLRenderer2.prototype.animate = function(callback) {
  console.warn("THREE.WebGLRenderer: .animate() is now .setAnimationLoop().");
  this.setAnimationLoop(callback);
};
WebGLRenderer2.prototype.getCurrentRenderTarget = function() {
  console.warn("THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().");
  return this.getRenderTarget();
};
WebGLRenderer2.prototype.getMaxAnisotropy = function() {
  console.warn("THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().");
  return this.capabilities.getMaxAnisotropy();
};
WebGLRenderer2.prototype.getPrecision = function() {
  console.warn("THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.");
  return this.capabilities.precision;
};
WebGLRenderer2.prototype.resetGLState = function() {
  console.warn("THREE.WebGLRenderer: .resetGLState() is now .state.reset().");
  return this.state.reset();
};
WebGLRenderer2.prototype.supportsFloatTextures = function() {
  console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' ).");
  return this.extensions.get("OES_texture_float");
};
WebGLRenderer2.prototype.supportsHalfFloatTextures = function() {
  console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' ).");
  return this.extensions.get("OES_texture_half_float");
};
WebGLRenderer2.prototype.supportsStandardDerivatives = function() {
  console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' ).");
  return this.extensions.get("OES_standard_derivatives");
};
WebGLRenderer2.prototype.supportsCompressedTextureS3TC = function() {
  console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' ).");
  return this.extensions.get("WEBGL_compressed_texture_s3tc");
};
WebGLRenderer2.prototype.supportsCompressedTexturePVRTC = function() {
  console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' ).");
  return this.extensions.get("WEBGL_compressed_texture_pvrtc");
};
WebGLRenderer2.prototype.supportsBlendMinMax = function() {
  console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' ).");
  return this.extensions.get("EXT_blend_minmax");
};
WebGLRenderer2.prototype.supportsVertexTextures = function() {
  console.warn("THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.");
  return this.capabilities.vertexTextures;
};
WebGLRenderer2.prototype.supportsInstancedArrays = function() {
  console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' ).");
  return this.extensions.get("ANGLE_instanced_arrays");
};
WebGLRenderer2.prototype.enableScissorTest = function(boolean) {
  console.warn("THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().");
  this.setScissorTest(boolean);
};
WebGLRenderer2.prototype.initMaterial = function() {
  console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.");
};
WebGLRenderer2.prototype.addPrePlugin = function() {
  console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.");
};
WebGLRenderer2.prototype.addPostPlugin = function() {
  console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.");
};
WebGLRenderer2.prototype.updateShadowMap = function() {
  console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.");
};
WebGLRenderer2.prototype.setFaceCulling = function() {
  console.warn("THREE.WebGLRenderer: .setFaceCulling() has been removed.");
};
WebGLRenderer2.prototype.allocTextureUnit = function() {
  console.warn("THREE.WebGLRenderer: .allocTextureUnit() has been removed.");
};
WebGLRenderer2.prototype.setTexture = function() {
  console.warn("THREE.WebGLRenderer: .setTexture() has been removed.");
};
WebGLRenderer2.prototype.setTexture2D = function() {
  console.warn("THREE.WebGLRenderer: .setTexture2D() has been removed.");
};
WebGLRenderer2.prototype.setTextureCube = function() {
  console.warn("THREE.WebGLRenderer: .setTextureCube() has been removed.");
};
WebGLRenderer2.prototype.getActiveMipMapLevel = function() {
  console.warn("THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel().");
  return this.getActiveMipmapLevel();
};
Object.defineProperties(WebGLRenderer2.prototype, {
  shadowMapEnabled: {
    get: function() {
      return this.shadowMap.enabled;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.");
      this.shadowMap.enabled = value;
    }
  },
  shadowMapType: {
    get: function() {
      return this.shadowMap.type;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.");
      this.shadowMap.type = value;
    }
  },
  shadowMapCullFace: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
      return void 0;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
    }
  },
  context: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .context has been removed. Use .getContext() instead.");
      return this.getContext();
    }
  },
  vr: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .vr has been renamed to .xr");
      return this.xr;
    }
  },
  gammaInput: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
      return false;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
    }
  },
  gammaOutput: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.");
      return false;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.");
      this.outputEncoding = value === true ? sRGBEncoding : LinearEncoding;
    }
  },
  toneMappingWhitePoint: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
      return 1;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
    }
  }
});
Object.defineProperties(WebGLShadowMap.prototype, {
  cullFace: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
      return void 0;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
    }
  },
  renderReverseSided: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
      return void 0;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
    }
  },
  renderSingleSided: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
      return void 0;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
    }
  }
});
Object.defineProperties(WebGLRenderTarget2.prototype, {
  wrapS: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
      return this.texture.wrapS;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
      this.texture.wrapS = value;
    }
  },
  wrapT: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
      return this.texture.wrapT;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
      this.texture.wrapT = value;
    }
  },
  magFilter: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
      return this.texture.magFilter;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
      this.texture.magFilter = value;
    }
  },
  minFilter: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
      return this.texture.minFilter;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
      this.texture.minFilter = value;
    }
  },
  anisotropy: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
      return this.texture.anisotropy;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
      this.texture.anisotropy = value;
    }
  },
  offset: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
      return this.texture.offset;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
      this.texture.offset = value;
    }
  },
  repeat: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
      return this.texture.repeat;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
      this.texture.repeat = value;
    }
  },
  format: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
      return this.texture.format;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
      this.texture.format = value;
    }
  },
  type: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
      return this.texture.type;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
      this.texture.type = value;
    }
  },
  generateMipmaps: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
      return this.texture.generateMipmaps;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
      this.texture.generateMipmaps = value;
    }
  }
});
Audio2.prototype.load = function(file) {
  console.warn("THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.");
  const scope = this;
  const audioLoader = new AudioLoader2();
  audioLoader.load(file, function(buffer) {
    scope.setBuffer(buffer);
  });
  return this;
};
CubeCamera2.prototype.updateCubeMap = function(renderer, scene) {
  console.warn("THREE.CubeCamera: .updateCubeMap() is now .update().");
  return this.update(renderer, scene);
};
CubeCamera2.prototype.clear = function(renderer, color2, depth, stencil) {
  console.warn("THREE.CubeCamera: .clear() is now .renderTarget.clear().");
  return this.renderTarget.clear(renderer, color2, depth, stencil);
};
ImageUtils2.crossOrigin = void 0;
ImageUtils2.loadTexture = function(url, mapping, onLoad, onError) {
  console.warn("THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.");
  const loader = new TextureLoader2();
  loader.setCrossOrigin(this.crossOrigin);
  const texture = loader.load(url, onLoad, void 0, onError);
  if (mapping) texture.mapping = mapping;
  return texture;
};
ImageUtils2.loadTextureCube = function(urls, mapping, onLoad, onError) {
  console.warn("THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.");
  const loader = new CubeTextureLoader2();
  loader.setCrossOrigin(this.crossOrigin);
  const texture = loader.load(urls, onLoad, void 0, onError);
  if (mapping) texture.mapping = mapping;
  return texture;
};
ImageUtils2.loadCompressedTexture = function() {
  console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.");
};
ImageUtils2.loadCompressedTextureCube = function() {
  console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.");
};
if (typeof __THREE_DEVTOOLS__ !== "undefined") {
  __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
    revision: REVISION
  } }));
}
if (typeof window !== "undefined") {
  if (window.__THREE__) {
    console.warn("WARNING: Multiple instances of Three.js being imported.");
  } else {
    window.__THREE__ = REVISION;
  }
}
class PathPoint {
  constructor() {
    this.pos = new Vector32();
    this.dir = new Vector32();
    this.right = new Vector32();
    this.up = new Vector32();
    this.dist = 0;
    this.widthScale = 1;
    this.sharp = false;
  }
  lerpPathPoints(p1, p2, alpha) {
    this.pos.lerpVectors(p1.pos, p2.pos, alpha);
    this.dir.lerpVectors(p1.dir, p2.dir, alpha);
    this.up.lerpVectors(p1.up, p2.up, alpha);
    this.right.lerpVectors(p1.right, p2.right, alpha);
    this.dist = (p2.dist - p1.dist) * alpha + p1.dist;
    this.widthScale = (p2.widthScale - p1.widthScale) * alpha + p1.widthScale;
  }
  copy(source) {
    this.pos.copy(source.pos);
    this.dir.copy(source.dir);
    this.up.copy(source.up);
    this.right.copy(source.right);
    this.dist = source.dist;
    this.widthScale = source.widthScale;
  }
}
const helpVec3_1 = new Vector32();
const helpVec3_2 = new Vector32();
const helpVec3_3 = new Vector32();
const helpMat4 = new Matrix42();
const helpCurve = new QuadraticBezierCurve32();
function _getCornerBezierCurve(last, current, next, cornerRadius, firstCorner, out) {
  const lastDir = helpVec3_1.subVectors(current, last);
  const nextDir = helpVec3_2.subVectors(next, current);
  const lastDirLength = lastDir.length();
  const nextDirLength = nextDir.length();
  lastDir.normalize();
  nextDir.normalize();
  const v0Dist = Math.min((firstCorner ? lastDirLength / 2 : lastDirLength) * 0.999999, cornerRadius);
  out.v0.copy(current).sub(lastDir.multiplyScalar(v0Dist));
  out.v1.copy(current);
  const v2Dist = Math.min(nextDirLength / 2 * 0.999999, cornerRadius);
  out.v2.copy(current).add(nextDir.multiplyScalar(v2Dist));
  return out;
}
class PathPointList {
  constructor() {
    this.array = [];
    this.count = 0;
  }
  /**
   * Set points
   * @param {THREE.Vector3[]} points key points array
   * @param {number} cornerRadius? the corner radius. set 0 to disable round corner. default is 0.1
   * @param {number} cornerSplit? the corner split. default is 10.
   * @param {number} up? force up. default is auto up (calculate by tangent).
   * @param {boolean} close? close path. default is false.
   */
  set(points, cornerRadius = 0.1, cornerSplit = 10, up = null, close = false) {
    points = points.slice(0);
    if (points.length < 2) {
      console.warn("PathPointList: points length less than 2.");
      this.count = 0;
      return;
    }
    if (close && !points[0].equals(points[points.length - 1])) {
      points.push(new Vector32().copy(points[0]));
    }
    for (let i2 = 0, l2 = points.length; i2 < l2; i2++) {
      if (i2 === 0) {
        this._start(points[i2], points[i2 + 1], up);
      } else if (i2 === l2 - 1) {
        if (close) {
          this._corner(points[i2], points[1], cornerRadius, cornerSplit, up);
          const dist = this.array[0].dist;
          this.array[0].copy(this.array[this.count - 1]);
          this.array[0].dist = dist;
        } else {
          this._end(points[i2]);
        }
      } else {
        this._corner(points[i2], points[i2 + 1], cornerRadius, cornerSplit, up);
      }
    }
  }
  /**
   * Get distance of this path
   * @return {number}
   */
  distance() {
    if (this.count > 0) {
      return this.array[this.count - 1].dist;
    }
    return 0;
  }
  _getByIndex(index2) {
    if (!this.array[index2]) {
      this.array[index2] = new PathPoint();
    }
    return this.array[index2];
  }
  _start(current, next, up) {
    this.count = 0;
    const point2 = this._getByIndex(this.count);
    point2.pos.copy(current);
    point2.dir.subVectors(next, current);
    if (up) {
      point2.up.copy(up);
    } else {
      let min = Number.MAX_VALUE;
      const tx = Math.abs(point2.dir.x);
      const ty = Math.abs(point2.dir.y);
      const tz = Math.abs(point2.dir.z);
      if (tx < min) {
        min = tx;
        point2.up.set(1, 0, 0);
      }
      if (ty < min) {
        min = ty;
        point2.up.set(0, 1, 0);
      }
      if (tz < min) {
        point2.up.set(0, 0, 1);
      }
    }
    point2.right.crossVectors(point2.dir, point2.up).normalize();
    point2.up.crossVectors(point2.right, point2.dir).normalize();
    point2.dist = 0;
    point2.widthScale = 1;
    point2.sharp = false;
    point2.dir.normalize();
    this.count++;
  }
  _end(current) {
    const lastPoint = this.array[this.count - 1];
    const point2 = this._getByIndex(this.count);
    point2.pos.copy(current);
    point2.dir.subVectors(current, lastPoint.pos);
    const dist = point2.dir.length();
    point2.dir.normalize();
    point2.up.copy(lastPoint.up);
    const vec = helpVec3_1.crossVectors(lastPoint.dir, point2.dir);
    if (vec.length() > Number.EPSILON) {
      vec.normalize();
      const theta = Math.acos(Math.min(Math.max(lastPoint.dir.dot(point2.dir), -1), 1));
      point2.up.applyMatrix4(helpMat4.makeRotationAxis(vec, theta));
    }
    point2.right.crossVectors(point2.dir, point2.up).normalize();
    point2.dist = lastPoint.dist + dist;
    point2.widthScale = 1;
    point2.sharp = false;
    this.count++;
  }
  _corner(current, next, cornerRadius, cornerSplit, up) {
    if (cornerRadius > 0 && cornerSplit > 0) {
      const lastPoint = this.array[this.count - 1];
      const curve = _getCornerBezierCurve(lastPoint.pos, current, next, cornerRadius, this.count - 1 === 0, helpCurve);
      const samplerPoints = curve.getPoints(cornerSplit);
      for (let f2 = 0; f2 < cornerSplit; f2++) {
        this._sharpCorner(samplerPoints[f2], samplerPoints[f2 + 1], up, f2 === 0 ? 1 : 0);
      }
      if (!samplerPoints[cornerSplit].equals(next)) {
        this._sharpCorner(samplerPoints[cornerSplit], next, up, 2);
      }
    } else {
      this._sharpCorner(current, next, up, 0, true);
    }
  }
  // dirType: 0 - use middle dir / 1 - use last dir / 2- use next dir
  _sharpCorner(current, next, up, dirType = 0, sharp = false) {
    const lastPoint = this.array[this.count - 1];
    const point2 = this._getByIndex(this.count);
    const lastDir = helpVec3_1.subVectors(current, lastPoint.pos);
    const nextDir = helpVec3_2.subVectors(next, current);
    const lastDirLength = lastDir.length();
    lastDir.normalize();
    nextDir.normalize();
    point2.pos.copy(current);
    if (dirType === 1) {
      point2.dir.copy(lastDir);
    } else if (dirType === 2) {
      point2.dir.copy(nextDir);
    } else {
      point2.dir.addVectors(lastDir, nextDir);
      point2.dir.normalize();
    }
    if (up) {
      if (point2.dir.dot(up) === 1) {
        point2.right.crossVectors(nextDir, up).normalize();
      } else {
        point2.right.crossVectors(point2.dir, up).normalize();
      }
      point2.up.crossVectors(point2.right, point2.dir).normalize();
    } else {
      point2.up.copy(lastPoint.up);
      const vec = helpVec3_3.crossVectors(lastPoint.dir, point2.dir);
      if (vec.length() > Number.EPSILON) {
        vec.normalize();
        const theta = Math.acos(Math.min(Math.max(lastPoint.dir.dot(point2.dir), -1), 1));
        point2.up.applyMatrix4(helpMat4.makeRotationAxis(vec, theta));
      }
      point2.right.crossVectors(point2.dir, point2.up).normalize();
    }
    point2.dist = lastPoint.dist + lastDirLength;
    const _cos = lastDir.dot(nextDir);
    point2.widthScale = Math.min(1 / Math.sqrt((1 + _cos) / 2), 1.415) || 1;
    point2.sharp = Math.abs(_cos - 1) > 0.05 && sharp;
    this.count++;
  }
}
class PathGeometry extends BufferGeometry2 {
  /**
   * @param {Object|Number} initData - If initData is number, geometry init by empty data and set it as the max vertex. If initData is Object, it contains pathPointList and options.
   * @param {Boolean} [generateUv2=false]
   */
  constructor(initData = 3e3, generateUv2 = false) {
    super();
    if (isNaN(initData)) {
      this._initByData(initData.pathPointList, initData.options, initData.usage, generateUv2);
    } else {
      this._initByMaxVertex(initData, generateUv2);
    }
  }
  _initByMaxVertex(maxVertex, generateUv2) {
    this.setAttribute("position", new BufferAttribute2(new Float32Array(maxVertex * 3), 3).setUsage(DynamicDrawUsage));
    this.setAttribute("normal", new BufferAttribute2(new Float32Array(maxVertex * 3), 3).setUsage(DynamicDrawUsage));
    this.setAttribute("uv", new BufferAttribute2(new Float32Array(maxVertex * 2), 2).setUsage(DynamicDrawUsage));
    if (generateUv2) {
      this.setAttribute("uv2", new BufferAttribute2(new Float32Array(maxVertex * 2), 2).setUsage(DynamicDrawUsage));
    }
    this.drawRange.start = 0;
    this.drawRange.count = 0;
    this.setIndex(
      maxVertex > 65536 ? new Uint32BufferAttribute2(maxVertex * 3, 1) : new Uint16BufferAttribute2(maxVertex * 3, 1)
    );
  }
  _initByData(pathPointList, options = {}, usage, generateUv2) {
    const vertexData = generatePathVertexData(pathPointList, options, generateUv2);
    if (vertexData && vertexData.count !== 0) {
      this.setAttribute("position", new BufferAttribute2(new Float32Array(vertexData.position), 3).setUsage(usage || StaticDrawUsage));
      this.setAttribute("normal", new BufferAttribute2(new Float32Array(vertexData.normal), 3).setUsage(usage || StaticDrawUsage));
      this.setAttribute("uv", new BufferAttribute2(new Float32Array(vertexData.uv), 2).setUsage(usage || StaticDrawUsage));
      if (generateUv2) {
        this.setAttribute("uv2", new BufferAttribute2(new Float32Array(vertexData.uv2), 2).setUsage(usage || StaticDrawUsage));
      }
      this.setIndex(
        vertexData.position.length / 3 > 65536 ? new Uint32BufferAttribute2(vertexData.indices, 1) : new Uint16BufferAttribute2(vertexData.indices, 1)
      );
    } else {
      this._initByMaxVertex(2, generateUv2);
    }
  }
  /**
   * Update geometry by PathPointList instance
   * @param {PathPointList} pathPointList
   * @param {Object} options
   * @param {Number} [options.width=0.1]
   * @param {Number} [options.progress=1]
   * @param {Boolean} [options.arrow=true]
   * @param {String} [options.side='both'] - "left"/"right"/"both"
   */
  update(pathPointList, options = {}) {
    const generateUv2 = !!this.getAttribute("uv2");
    const vertexData = generatePathVertexData(pathPointList, options, generateUv2);
    if (vertexData) {
      this._updateAttributes(vertexData.position, vertexData.normal, vertexData.uv, generateUv2 ? vertexData.uv2 : null, vertexData.indices);
      this.drawRange.count = vertexData.count;
    } else {
      this.drawRange.count = 0;
    }
  }
  _resizeAttribute(name, len) {
    let attribute = this.getAttribute(name);
    while (attribute.array.length < len) {
      const oldLength = attribute.array.length;
      const newAttribute = new BufferAttribute2(
        new Float32Array(oldLength * 2),
        attribute.itemSize,
        attribute.normalized
      );
      newAttribute.name = attribute.name;
      newAttribute.usage = attribute.usage;
      this.setAttribute(name, newAttribute);
      attribute = newAttribute;
    }
  }
  _resizeIndex(len) {
    let index2 = this.getIndex();
    while (index2.array.length < len) {
      const oldLength = index2.array.length;
      const newIndex = new BufferAttribute2(
        oldLength * 2 > 65535 ? new Uint32Array(oldLength * 2) : new Uint16Array(oldLength * 2),
        1
      );
      newIndex.name = index2.name;
      newIndex.usage = index2.usage;
      this.setIndex(newIndex);
      index2 = newIndex;
    }
  }
  _updateAttributes(position2, normal, uv, uv2, indices) {
    this._resizeAttribute("position", position2.length);
    const positionAttribute = this.getAttribute("position");
    positionAttribute.array.set(position2, 0);
    positionAttribute.updateRange.count = position2.length;
    positionAttribute.needsUpdate = true;
    this._resizeAttribute("normal", normal.length);
    const normalAttribute = this.getAttribute("normal");
    normalAttribute.array.set(normal, 0);
    normalAttribute.updateRange.count = normal.length;
    normalAttribute.needsUpdate = true;
    this._resizeAttribute("uv", uv.length);
    const uvAttribute = this.getAttribute("uv");
    uvAttribute.array.set(uv, 0);
    uvAttribute.updateRange.count = uv.length;
    uvAttribute.needsUpdate = true;
    if (uv2) {
      this._resizeAttribute("uv2", uv2.length);
      const uv2Attribute = this.getAttribute("uv2");
      uv2Attribute.array.set(uv2, 0);
      uv2Attribute.updateRange.count = uv2.length;
      uv2Attribute.needsUpdate = true;
    }
    this._resizeIndex(indices.length);
    const indexAttribute = this.getIndex();
    indexAttribute.set(indices, 0);
    indexAttribute.updateRange.count = indices.length;
    indexAttribute.needsUpdate = true;
  }
}
function generatePathVertexData(pathPointList, options, generateUv2 = false) {
  const width = options.width || 0.1;
  const progress = options.progress !== void 0 ? options.progress : 1;
  const arrow = options.arrow !== void 0 ? options.arrow : true;
  const side = options.side !== void 0 ? options.side : "both";
  const halfWidth = width / 2;
  const sideWidth = side !== "both" ? width / 2 : width;
  const totalDistance = pathPointList.distance();
  const progressDistance = progress * totalDistance;
  if (totalDistance == 0) {
    return null;
  }
  const sharpUvOffset = halfWidth / sideWidth;
  const sharpUvOffset2 = halfWidth / totalDistance;
  let count = 0;
  const position2 = [];
  const normal = [];
  const uv = [];
  const uv2 = [];
  const indices = [];
  let verticesCount = 0;
  const right = new Vector32();
  const left = new Vector32();
  const leftOffset = new Vector32();
  const rightOffset = new Vector32();
  const tempPoint1 = new Vector32();
  const tempPoint2 = new Vector32();
  function addVertices(pathPoint) {
    const first = position2.length === 0;
    const sharpCorner = pathPoint.sharp && !first;
    const uvDist = pathPoint.dist / sideWidth;
    const uvDist2 = pathPoint.dist / totalDistance;
    const dir = pathPoint.dir;
    const up = pathPoint.up;
    const _right = pathPoint.right;
    if (side !== "left") {
      right.copy(_right).multiplyScalar(halfWidth * pathPoint.widthScale);
    } else {
      right.set(0, 0, 0);
    }
    if (side !== "right") {
      left.copy(_right).multiplyScalar(-halfWidth * pathPoint.widthScale);
    } else {
      left.set(0, 0, 0);
    }
    right.add(pathPoint.pos);
    left.add(pathPoint.pos);
    if (sharpCorner) {
      leftOffset.fromArray(position2, position2.length - 6).sub(left);
      rightOffset.fromArray(position2, position2.length - 3).sub(right);
      const leftDist = leftOffset.length();
      const rightDist = rightOffset.length();
      const sideOffset = leftDist - rightDist;
      let longerOffset, longEdge;
      if (sideOffset > 0) {
        longerOffset = leftOffset;
        longEdge = left;
      } else {
        longerOffset = rightOffset;
        longEdge = right;
      }
      tempPoint1.copy(longerOffset).setLength(Math.abs(sideOffset)).add(longEdge);
      let _cos = tempPoint2.copy(longEdge).sub(tempPoint1).normalize().dot(dir);
      let _len = tempPoint2.copy(longEdge).sub(tempPoint1).length();
      let _dist = _cos * _len * 2;
      tempPoint2.copy(dir).setLength(_dist).add(tempPoint1);
      if (sideOffset > 0) {
        position2.push(
          tempPoint1.x,
          tempPoint1.y,
          tempPoint1.z,
          // 6
          right.x,
          right.y,
          right.z,
          // 5
          left.x,
          left.y,
          left.z,
          // 4
          right.x,
          right.y,
          right.z,
          // 3
          tempPoint2.x,
          tempPoint2.y,
          tempPoint2.z,
          // 2
          right.x,
          right.y,
          right.z
          // 1
        );
        verticesCount += 6;
        indices.push(
          verticesCount - 6,
          verticesCount - 8,
          verticesCount - 7,
          verticesCount - 6,
          verticesCount - 7,
          verticesCount - 5,
          verticesCount - 4,
          verticesCount - 6,
          verticesCount - 5,
          verticesCount - 2,
          verticesCount - 4,
          verticesCount - 1
        );
        count += 12;
      } else {
        position2.push(
          left.x,
          left.y,
          left.z,
          // 6
          tempPoint1.x,
          tempPoint1.y,
          tempPoint1.z,
          // 5
          left.x,
          left.y,
          left.z,
          // 4
          right.x,
          right.y,
          right.z,
          // 3
          left.x,
          left.y,
          left.z,
          // 2
          tempPoint2.x,
          tempPoint2.y,
          tempPoint2.z
          // 1
        );
        verticesCount += 6;
        indices.push(
          verticesCount - 6,
          verticesCount - 8,
          verticesCount - 7,
          verticesCount - 6,
          verticesCount - 7,
          verticesCount - 5,
          verticesCount - 6,
          verticesCount - 5,
          verticesCount - 3,
          verticesCount - 2,
          verticesCount - 3,
          verticesCount - 1
        );
        count += 12;
      }
      normal.push(
        up.x,
        up.y,
        up.z,
        up.x,
        up.y,
        up.z,
        up.x,
        up.y,
        up.z,
        up.x,
        up.y,
        up.z,
        up.x,
        up.y,
        up.z,
        up.x,
        up.y,
        up.z
      );
      uv.push(
        uvDist - sharpUvOffset,
        0,
        uvDist - sharpUvOffset,
        1,
        uvDist,
        0,
        uvDist,
        1,
        uvDist + sharpUvOffset,
        0,
        uvDist + sharpUvOffset,
        1
      );
      if (generateUv2) {
        uv2.push(
          uvDist2 - sharpUvOffset2,
          0,
          uvDist2 - sharpUvOffset2,
          1,
          uvDist2,
          0,
          uvDist2,
          1,
          uvDist2 + sharpUvOffset2,
          0,
          uvDist2 + sharpUvOffset2,
          1
        );
      }
    } else {
      position2.push(
        left.x,
        left.y,
        left.z,
        right.x,
        right.y,
        right.z
      );
      normal.push(
        up.x,
        up.y,
        up.z,
        up.x,
        up.y,
        up.z
      );
      uv.push(
        uvDist,
        0,
        uvDist,
        1
      );
      if (generateUv2) {
        uv2.push(
          uvDist2,
          0,
          uvDist2,
          1
        );
      }
      verticesCount += 2;
      if (!first) {
        indices.push(
          verticesCount - 2,
          verticesCount - 4,
          verticesCount - 3,
          verticesCount - 2,
          verticesCount - 3,
          verticesCount - 1
        );
        count += 6;
      }
    }
  }
  const sharp = new Vector32();
  function addStart(pathPoint) {
    const dir = pathPoint.dir;
    const up = pathPoint.up;
    const _right = pathPoint.right;
    const uvDist = pathPoint.dist / sideWidth;
    const uvDist2 = pathPoint.dist / totalDistance;
    if (side !== "left") {
      right.copy(_right).multiplyScalar(halfWidth * 2);
    } else {
      right.set(0, 0, 0);
    }
    if (side !== "right") {
      left.copy(_right).multiplyScalar(-halfWidth * 2);
    } else {
      left.set(0, 0, 0);
    }
    sharp.copy(dir).setLength(halfWidth * 3);
    right.add(pathPoint.pos);
    left.add(pathPoint.pos);
    sharp.add(pathPoint.pos);
    position2.push(
      left.x,
      left.y,
      left.z,
      right.x,
      right.y,
      right.z,
      sharp.x,
      sharp.y,
      sharp.z
    );
    normal.push(
      up.x,
      up.y,
      up.z,
      up.x,
      up.y,
      up.z,
      up.x,
      up.y,
      up.z
    );
    uv.push(
      uvDist,
      side !== "both" ? side !== "right" ? -2 : 0 : -0.5,
      uvDist,
      side !== "both" ? side !== "left" ? 2 : 0 : 1.5,
      uvDist + 1.5,
      side !== "both" ? 0 : 0.5
    );
    if (generateUv2) {
      uv2.push(
        uvDist2,
        side !== "both" ? side !== "right" ? -2 : 0 : -0.5,
        uvDist2,
        side !== "both" ? side !== "left" ? 2 : 0 : 1.5,
        uvDist2 + 1.5 * width / totalDistance,
        side !== "both" ? 0 : 0.5
      );
    }
    verticesCount += 3;
    indices.push(
      verticesCount - 1,
      verticesCount - 3,
      verticesCount - 2
    );
    count += 3;
  }
  let lastPoint;
  if (progressDistance > 0) {
    for (let i2 = 0; i2 < pathPointList.count; i2++) {
      const pathPoint = pathPointList.array[i2];
      if (pathPoint.dist > progressDistance) {
        const prevPoint = pathPointList.array[i2 - 1];
        lastPoint = new PathPoint();
        const alpha = (progressDistance - prevPoint.dist) / (pathPoint.dist - prevPoint.dist);
        lastPoint.lerpPathPoints(prevPoint, pathPoint, alpha);
        addVertices(lastPoint);
        break;
      } else {
        addVertices(pathPoint);
      }
    }
  } else {
    lastPoint = pathPointList.array[0];
  }
  if (arrow) {
    lastPoint = lastPoint || pathPointList.array[pathPointList.count - 1];
    addStart(lastPoint);
  }
  return {
    position: position2,
    normal,
    uv,
    uv2,
    indices,
    count
  };
}
const threeVersion$d = parseInt(REVISION$1, 10);
ShaderChunk$1["mesh_line_vert"] = [
  "",
  ShaderChunk$1.common,
  ShaderChunk$1.logdepthbuf_pars_vertex,
  ShaderChunk$1.fog_pars_vertex,
  ShaderChunk$1.clipping_planes_pars_vertex,
  "",
  "attribute vec3 previous;",
  "attribute vec3 next;",
  "attribute float side;",
  "attribute float width;",
  "attribute float counters;",
  "",
  "uniform vec2 resolution;",
  "uniform float lineWidth;",
  "uniform vec3 color;",
  "uniform float opacity;",
  "uniform bool sizeAttenuation;",
  "",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "varying float vCounters;",
  "",
  "vec2 fix( vec4 i, float aspect ) {",
  "    vec2 res = i.xy / i.w;",
  "    res.x *= aspect;",
  "    return res;",
  "}",
  "",
  "void main() {",
  "    float aspect = resolution.x / resolution.y;",
  "",
  "    vColor = vec4( color, opacity );",
  "    vUV = uv;",
  "	   vCounters = counters;",
  "",
  "    mat4 m = projectionMatrix * modelViewMatrix;",
  "    vec4 finalPosition = m * vec4( position, 1.0 );",
  "    vec4 prevPos = m * vec4( previous, 1.0 );",
  "    vec4 nextPos = m * vec4( next, 1.0 );",
  "",
  "    vec2 currentP = fix( finalPosition, aspect );",
  "    vec2 prevP = fix( prevPos, aspect );",
  "    vec2 nextP = fix( nextPos, aspect );",
  "",
  "    float w = lineWidth * width;",
  "",
  "    vec2 dir;",
  "    if( nextP == currentP ) dir = normalize( currentP - prevP );",
  "    else if( prevP == currentP ) dir = normalize( nextP - currentP );",
  "    else {",
  "        vec2 dir1 = normalize( currentP - prevP );",
  "        vec2 dir2 = normalize( nextP - currentP );",
  "        dir = normalize( dir1 + dir2 );",
  "",
  "        vec2 perp = vec2( -dir1.y, dir1.x );",
  "        vec2 miter = vec2( -dir.y, dir.x );",
  "        //w = clamp( w / dot( miter, perp ), 0., 4. * lineWidth * width );",
  "",
  "    }",
  "",
  "    //vec2 normal = ( cross( vec3( dir, 0. ), vec3( 0., 0., 1. ) ) ).xy;",
  "    vec4 normal = vec4( -dir.y, dir.x, 0., 1. );",
  "    normal.xy *= .5 * w;",
  "    normal *= projectionMatrix;",
  "    if( !sizeAttenuation ) {",
  "        normal.xy *= finalPosition.w;",
  "        normal.xy /= ( vec4( resolution, 0., 1. ) * projectionMatrix ).xy;",
  "    }",
  "",
  "    finalPosition.xy += normal.xy * side;",
  "",
  "    gl_Position = finalPosition;",
  "",
  ShaderChunk$1.logdepthbuf_vertex,
  ShaderChunk$1.fog_vertex,
  "    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.clipping_planes_vertex,
  ShaderChunk$1.fog_vertex,
  "}"
].join("\n");
ShaderChunk$1["mesh_line_frag"] = [
  "",
  ShaderChunk$1.fog_pars_fragment,
  ShaderChunk$1.logdepthbuf_pars_fragment,
  ShaderChunk$1.clipping_planes_pars_fragment,
  "",
  "uniform sampler2D map;",
  "uniform sampler2D alphaMap;",
  "uniform float useMap;",
  "uniform float useAlphaMap;",
  "uniform float useDash;",
  "uniform float dashArray;",
  "uniform float dashOffset;",
  "uniform float dashRatio;",
  "uniform float visibility;",
  "uniform float alphaTest;",
  "uniform vec2 repeat;",
  "",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "varying float vCounters;",
  "",
  "void main() {",
  ShaderChunk$1.logdepthbuf_fragment,
  "    vec4 c = vColor;",
  "    if( useMap == 1. ) c *= texture2D( map, vUV * repeat );",
  "    if( useAlphaMap == 1. ) c.a *= texture2D( alphaMap, vUV * repeat ).a;",
  "    if( c.a < alphaTest ) discard;",
  "    if( useDash == 1. ){",
  "        c.a *= ceil(mod(vCounters + dashOffset, dashArray) - (dashArray * dashRatio));",
  "    }",
  "    c.a *= step(vCounters, visibility);",
  ShaderChunk$1.clipping_planes_fragment,
  "    gl_FragColor = c;",
  ShaderChunk$1.fog_fragment,
  ShaderChunk$1.tonemapping_fragment,
  threeVersion$d > 151 ? ShaderChunk$1.colorspace_fragment : ShaderChunk$1.encodings_fragment,
  "}"
].join("\n");
class MeshLineMaterial2 extends ShaderMaterial$1 {
  constructor(parameters) {
    super({
      transparent: true,
      depthWrite: false,
      depthTest: true,
      side: DoubleSide$1,
      uniforms: Object.assign({}, UniformsLib$1.fog, {
        lineWidth: { value: 1 },
        map: { value: null },
        useMap: { value: 0 },
        alphaMap: { value: null },
        useAlphaMap: { value: 0 },
        color: { value: new Color$1(16777215) },
        opacity: { value: 1 },
        resolution: { value: new Vector2$1(1, 1) },
        sizeAttenuation: { value: true },
        dashArray: { value: 0 },
        dashOffset: { value: 0 },
        dashRatio: { value: 0.5 },
        useDash: { value: 0 },
        visibility: { value: 1 },
        alphaTest: { value: 0 },
        repeat: { value: new Vector2$1(1, 1) }
      }),
      vertexShader: ShaderChunk$1.mesh_line_vert,
      fragmentShader: ShaderChunk$1.mesh_line_frag
    });
    this.isMeshLineMaterial = true;
    this.type = "MeshLineMaterial";
    Object.defineProperties(this, {
      lineWidth: {
        enumerable: true,
        get: function() {
          return this.uniforms.lineWidth.value;
        },
        set: function(value) {
          this.uniforms.lineWidth.value = value;
        }
      },
      map: {
        enumerable: true,
        get: function() {
          return this.uniforms.map.value;
        },
        set: function(value) {
          this.uniforms.map.value = value;
        }
      },
      useMap: {
        enumerable: true,
        get: function() {
          return this.uniforms.useMap.value;
        },
        set: function(value) {
          this.uniforms.useMap.value = value;
        }
      },
      alphaMap: {
        enumerable: true,
        get: function() {
          return this.uniforms.alphaMap.value;
        },
        set: function(value) {
          this.uniforms.alphaMap.value = value;
        }
      },
      useAlphaMap: {
        enumerable: true,
        get: function() {
          return this.uniforms.useAlphaMap.value;
        },
        set: function(value) {
          this.uniforms.useAlphaMap.value = value;
        }
      },
      color: {
        enumerable: true,
        get: function() {
          return this.uniforms.color.value;
        },
        set: function(value) {
          this.uniforms.color.value = value;
        }
      },
      opacity: {
        enumerable: true,
        get: function() {
          return this.uniforms.opacity.value;
        },
        set: function(value) {
          this.uniforms.opacity.value = value;
        }
      },
      resolution: {
        enumerable: true,
        get: function() {
          return this.uniforms.resolution.value;
        },
        set: function(value) {
          this.uniforms.resolution.value.copy(value);
        }
      },
      sizeAttenuation: {
        enumerable: true,
        get: function() {
          return this.uniforms.sizeAttenuation.value;
        },
        set: function(value) {
          this.uniforms.sizeAttenuation.value = value;
        }
      },
      dashArray: {
        enumerable: true,
        get: function() {
          return this.uniforms.dashArray.value;
        },
        set: function(value) {
          this.uniforms.dashArray.value = value;
          this.useDash = value !== 0 ? 1 : 0;
        }
      },
      dashOffset: {
        enumerable: true,
        get: function() {
          return this.uniforms.dashOffset.value;
        },
        set: function(value) {
          this.uniforms.dashOffset.value = value;
        }
      },
      dashRatio: {
        enumerable: true,
        get: function() {
          return this.uniforms.dashRatio.value;
        },
        set: function(value) {
          this.uniforms.dashRatio.value = value;
        }
      },
      useDash: {
        enumerable: true,
        get: function() {
          return this.uniforms.useDash.value;
        },
        set: function(value) {
          this.uniforms.useDash.value = value;
        }
      },
      visibility: {
        enumerable: true,
        get: function() {
          return this.uniforms.visibility.value;
        },
        set: function(value) {
          this.uniforms.visibility.value = value;
        }
      },
      alphaTest: {
        enumerable: true,
        get: function() {
          return this.uniforms.alphaTest.value;
        },
        set: function(value) {
          this.uniforms.alphaTest.value = value;
        }
      },
      repeat: {
        enumerable: true,
        get: function() {
          return this.uniforms.repeat.value;
        },
        set: function(value) {
          this.uniforms.repeat.value.copy(value);
        }
      }
    });
    this.setValues(parameters);
  }
}
MeshLineMaterial2.prototype.copy = function(source) {
  ShaderMaterial$1.prototype.copy.call(this, source);
  this.lineWidth = source.lineWidth;
  this.map = source.map;
  this.useMap = source.useMap;
  this.alphaMap = source.alphaMap;
  this.useAlphaMap = source.useAlphaMap;
  this.color.copy(source.color);
  this.opacity = source.opacity;
  this.resolution.copy(source.resolution);
  this.sizeAttenuation = source.sizeAttenuation;
  this.dashArray.copy(source.dashArray);
  this.dashOffset.copy(source.dashOffset);
  this.dashRatio.copy(source.dashRatio);
  this.useDash = source.useDash;
  this.visibility = source.visibility;
  this.alphaTest = source.alphaTest;
  this.repeat.copy(source.repeat);
  return this;
};
const threeVersion$c = parseInt(REVISION$1, 10);
ShaderChunk$1["trail_mesh_line_vert"] = [
  "",
  ShaderChunk$1.common,
  ShaderChunk$1.logdepthbuf_pars_vertex,
  ShaderChunk$1.fog_pars_vertex,
  ShaderChunk$1.clipping_planes_pars_vertex,
  "",
  "attribute vec3 previous;",
  "attribute vec3 next;",
  "attribute float side;",
  "attribute float width;",
  "attribute float counters;",
  "",
  "uniform vec2 resolution;",
  "uniform float lineWidth;",
  "uniform vec3 color;",
  "uniform float opacity;",
  "uniform bool sizeAttenuation;",
  "",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "varying float vCounters;",
  "",
  "vec2 fix( vec4 i, float aspect ) {",
  "    vec2 res = i.xy / i.w;",
  "    res.x *= aspect;",
  "    return res;",
  "}",
  "",
  "void main() {",
  "    float aspect = resolution.x / resolution.y;",
  "",
  "    vColor = vec4( color, opacity );",
  "    vUV = uv;",
  "	   vCounters = counters;",
  "",
  "    mat4 m = projectionMatrix * modelViewMatrix;",
  "    vec4 finalPosition = m * vec4( position, 1.0 );",
  "    vec4 prevPos = m * vec4( previous, 1.0 );",
  "    vec4 nextPos = m * vec4( next, 1.0 );",
  "",
  "    vec2 currentP = fix( finalPosition, aspect );",
  "    vec2 prevP = fix( prevPos, aspect );",
  "    vec2 nextP = fix( nextPos, aspect );",
  "",
  "    float w = lineWidth * width;",
  "",
  "    vec2 dir;",
  "    if( nextP == currentP ) dir = normalize( currentP - prevP );",
  "    else if( prevP == currentP ) dir = normalize( nextP - currentP );",
  "    else {",
  "        vec2 dir1 = normalize( currentP - prevP );",
  "        vec2 dir2 = normalize( nextP - currentP );",
  "        dir = normalize( dir1 + dir2 );",
  "",
  "        vec2 perp = vec2( -dir1.y, dir1.x );",
  "        vec2 miter = vec2( -dir.y, dir.x );",
  "        //w = clamp( w / dot( miter, perp ), 0., 4. * lineWidth * width );",
  "",
  "    }",
  "",
  "    //vec2 normal = ( cross( vec3( dir, 0. ), vec3( 0., 0., 1. ) ) ).xy;",
  "    vec4 normal = vec4( -dir.y, dir.x, 0., 1. );",
  "    normal.xy *= .5 * w;",
  "    normal *= projectionMatrix;",
  "    if( !sizeAttenuation ) {",
  "        normal.xy *= finalPosition.w;",
  "        normal.xy /= ( vec4( resolution, 0., 1. ) * projectionMatrix ).xy;",
  "    }",
  "",
  "    finalPosition.xy += normal.xy * side;",
  "",
  "    gl_Position = finalPosition;",
  "",
  ShaderChunk$1.logdepthbuf_vertex,
  ShaderChunk$1.fog_vertex,
  "    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.clipping_planes_vertex,
  ShaderChunk$1.fog_vertex,
  "}"
].join("\n");
ShaderChunk$1["trail_mesh_line_frag"] = [
  "",
  ShaderChunk$1.fog_pars_fragment,
  ShaderChunk$1.logdepthbuf_pars_fragment,
  ShaderChunk$1.clipping_planes_pars_fragment,
  "",
  "uniform sampler2D map;",
  "uniform sampler2D alphaMap;",
  "uniform float useMap;",
  "uniform float useAlphaMap;",
  "uniform float useDash;",
  "uniform float dashArray;",
  "uniform float dashOffset;",
  "uniform float dashRatio;",
  "uniform float visibility;",
  "uniform float alphaTest;",
  "uniform vec2 repeat;",
  "uniform float speed;",
  "uniform float frameNumber;",
  "",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "varying float vCounters;",
  "",
  "void main() {",
  ShaderChunk$1.logdepthbuf_fragment,
  "    vec4 c = vColor;",
  "    if( useMap == 1. ) c *= texture2D( map, vUV * repeat );",
  "    if( useAlphaMap == 1. ) c.a *= texture2D( alphaMap, vUV * repeat ).a;",
  "    if( c.a < alphaTest ) discard;",
  "    if( useDash == 1. ){",
  "        c.a *= ceil(mod(vCounters + dashOffset, dashArray) - (dashArray * dashRatio));",
  "    }",
  "    c.a *= step(vCounters, visibility);",
  "    float t = fract(frameNumber / 1000.0 * speed);",
  "    c.a *= fract(vUV.s - t );",
  ShaderChunk$1.clipping_planes_fragment,
  "    gl_FragColor = c;",
  ShaderChunk$1.fog_fragment,
  ShaderChunk$1.tonemapping_fragment,
  threeVersion$c > 151 ? ShaderChunk$1.colorspace_fragment : ShaderChunk$1.encodings_fragment,
  "}"
].join("\n");
class TrailMeshLineMaterial extends ShaderMaterial$1 {
  constructor(parameters) {
    super({
      transparent: true,
      depthWrite: false,
      depthTest: true,
      side: DoubleSide$1,
      uniforms: Object.assign({}, UniformsLib$1.fog, {
        lineWidth: { value: 1 },
        map: { value: null },
        useMap: { value: 0 },
        alphaMap: { value: null },
        useAlphaMap: { value: 0 },
        color: { value: new Color$1(16777215) },
        opacity: { value: 1 },
        resolution: { value: new Vector2$1(1, 1) },
        sizeAttenuation: { value: true },
        dashArray: { value: 0 },
        dashOffset: { value: 0 },
        dashRatio: { value: 0.5 },
        useDash: { value: 0 },
        visibility: { value: 1 },
        alphaTest: { value: 0 },
        repeat: { value: new Vector2$1(1, 1) },
        speed: { value: 3 },
        frameNumber: { value: 1 }
      }),
      vertexShader: ShaderChunk$1.trail_mesh_line_vert,
      fragmentShader: ShaderChunk$1.trail_mesh_line_frag
    });
    this.isTrailMeshLineMaterial = true;
    this.type = "TrailMeshLineMaterial";
    Object.defineProperties(this, {
      lineWidth: {
        enumerable: true,
        get: function() {
          return this.uniforms.lineWidth.value;
        },
        set: function(value) {
          this.uniforms.lineWidth.value = value;
        }
      },
      map: {
        enumerable: true,
        get: function() {
          return this.uniforms.map.value;
        },
        set: function(value) {
          this.uniforms.map.value = value;
        }
      },
      useMap: {
        enumerable: true,
        get: function() {
          return this.uniforms.useMap.value;
        },
        set: function(value) {
          this.uniforms.useMap.value = value;
        }
      },
      alphaMap: {
        enumerable: true,
        get: function() {
          return this.uniforms.alphaMap.value;
        },
        set: function(value) {
          this.uniforms.alphaMap.value = value;
        }
      },
      useAlphaMap: {
        enumerable: true,
        get: function() {
          return this.uniforms.useAlphaMap.value;
        },
        set: function(value) {
          this.uniforms.useAlphaMap.value = value;
        }
      },
      color: {
        enumerable: true,
        get: function() {
          return this.uniforms.color.value;
        },
        set: function(value) {
          this.uniforms.color.value = value;
        }
      },
      opacity: {
        enumerable: true,
        get: function() {
          return this.uniforms.opacity.value;
        },
        set: function(value) {
          this.uniforms.opacity.value = value;
        }
      },
      resolution: {
        enumerable: true,
        get: function() {
          return this.uniforms.resolution.value;
        },
        set: function(value) {
          this.uniforms.resolution.value.copy(value);
        }
      },
      sizeAttenuation: {
        enumerable: true,
        get: function() {
          return this.uniforms.sizeAttenuation.value;
        },
        set: function(value) {
          this.uniforms.sizeAttenuation.value = value;
        }
      },
      dashArray: {
        enumerable: true,
        get: function() {
          return this.uniforms.dashArray.value;
        },
        set: function(value) {
          this.uniforms.dashArray.value = value;
          this.useDash = value !== 0 ? 1 : 0;
        }
      },
      dashOffset: {
        enumerable: true,
        get: function() {
          return this.uniforms.dashOffset.value;
        },
        set: function(value) {
          this.uniforms.dashOffset.value = value;
        }
      },
      dashRatio: {
        enumerable: true,
        get: function() {
          return this.uniforms.dashRatio.value;
        },
        set: function(value) {
          this.uniforms.dashRatio.value = value;
        }
      },
      useDash: {
        enumerable: true,
        get: function() {
          return this.uniforms.useDash.value;
        },
        set: function(value) {
          this.uniforms.useDash.value = value;
        }
      },
      visibility: {
        enumerable: true,
        get: function() {
          return this.uniforms.visibility.value;
        },
        set: function(value) {
          this.uniforms.visibility.value = value;
        }
      },
      alphaTest: {
        enumerable: true,
        get: function() {
          return this.uniforms.alphaTest.value;
        },
        set: function(value) {
          this.uniforms.alphaTest.value = value;
        }
      },
      repeat: {
        enumerable: true,
        get: function() {
          return this.uniforms.repeat.value;
        },
        set: function(value) {
          this.uniforms.repeat.value.copy(value);
        }
      },
      speed: {
        enumerable: true,
        get: function() {
          return this.uniforms.speed.value;
        },
        set: function(value) {
          this.uniforms.speed.value = value;
        }
      }
    });
    this.setValues(parameters);
  }
}
TrailMeshLineMaterial.prototype.copy = function(source) {
  ShaderMaterial$1.prototype.copy.call(this, source);
  this.lineWidth = source.lineWidth;
  this.map = source.map;
  this.useMap = source.useMap;
  this.alphaMap = source.alphaMap;
  this.useAlphaMap = source.useAlphaMap;
  this.color.copy(source.color);
  this.opacity = source.opacity;
  this.resolution.copy(source.resolution);
  this.sizeAttenuation = source.sizeAttenuation;
  this.dashArray.copy(source.dashArray);
  this.dashOffset.copy(source.dashOffset);
  this.dashRatio.copy(source.dashRatio);
  this.useDash = source.useDash;
  this.visibility = source.visibility;
  this.alphaTest = source.alphaTest;
  this.repeat.copy(source.repeat);
  this.speed = source.speed;
  return this;
};
const threeVersion$b = parseInt(REVISION$1, 10);
ShaderChunk$1["flow_mesh_line_vert"] = [
  "",
  ShaderChunk$1.common,
  ShaderChunk$1.logdepthbuf_pars_vertex,
  ShaderChunk$1.fog_pars_vertex,
  ShaderChunk$1.clipping_planes_pars_vertex,
  "",
  "attribute vec3 previous;",
  "attribute vec3 next;",
  "attribute float side;",
  "attribute float width;",
  "attribute float counters;",
  "",
  "uniform vec2 resolution;",
  "uniform float lineWidth;",
  "uniform vec3 color;",
  "uniform float opacity;",
  "uniform bool sizeAttenuation;",
  "",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "varying float vCounters;",
  "",
  "vec2 fix( vec4 i, float aspect ) {",
  "    vec2 res = i.xy / i.w;",
  "    res.x *= aspect;",
  "    return res;",
  "}",
  "",
  "void main() {",
  "    float aspect = resolution.x / resolution.y;",
  "",
  "    vColor = vec4( color, opacity );",
  "    vUV = uv;",
  "	   vCounters = counters;",
  "",
  "    mat4 m = projectionMatrix * modelViewMatrix;",
  "    vec4 finalPosition = m * vec4( position, 1.0 );",
  "    vec4 prevPos = m * vec4( previous, 1.0 );",
  "    vec4 nextPos = m * vec4( next, 1.0 );",
  "",
  "    vec2 currentP = fix( finalPosition, aspect );",
  "    vec2 prevP = fix( prevPos, aspect );",
  "    vec2 nextP = fix( nextPos, aspect );",
  "",
  "    float w = lineWidth * width;",
  "",
  "    vec2 dir;",
  "    if( nextP == currentP ) dir = normalize( currentP - prevP );",
  "    else if( prevP == currentP ) dir = normalize( nextP - currentP );",
  "    else {",
  "        vec2 dir1 = normalize( currentP - prevP );",
  "        vec2 dir2 = normalize( nextP - currentP );",
  "        dir = normalize( dir1 + dir2 );",
  "",
  "        vec2 perp = vec2( -dir1.y, dir1.x );",
  "        vec2 miter = vec2( -dir.y, dir.x );",
  "        //w = clamp( w / dot( miter, perp ), 0., 4. * lineWidth * width );",
  "",
  "    }",
  "",
  "    //vec2 normal = ( cross( vec3( dir, 0. ), vec3( 0., 0., 1. ) ) ).xy;",
  "    vec4 normal = vec4( -dir.y, dir.x, 0., 1. );",
  "    normal.xy *= .5 * w;",
  "    normal *= projectionMatrix;",
  "    if( !sizeAttenuation ) {",
  "        normal.xy *= finalPosition.w;",
  "        normal.xy /= ( vec4( resolution, 0., 1. ) * projectionMatrix ).xy;",
  "    }",
  "",
  "    finalPosition.xy += normal.xy * side;",
  "",
  "    gl_Position = finalPosition;",
  "",
  ShaderChunk$1.logdepthbuf_vertex,
  ShaderChunk$1.fog_vertex,
  "    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.clipping_planes_vertex,
  ShaderChunk$1.fog_vertex,
  "}"
].join("\n");
ShaderChunk$1["flow_mesh_line_frag"] = [
  "",
  ShaderChunk$1.fog_pars_fragment,
  ShaderChunk$1.logdepthbuf_pars_fragment,
  ShaderChunk$1.clipping_planes_pars_fragment,
  "",
  "uniform sampler2D map;",
  "uniform sampler2D alphaMap;",
  "uniform float useMap;",
  "uniform float useAlphaMap;",
  "uniform float useDash;",
  "uniform float dashArray;",
  "uniform float dashOffset;",
  "uniform float dashRatio;",
  "uniform float visibility;",
  "uniform float alphaTest;",
  "uniform vec2 repeat;",
  "uniform float speed;",
  "uniform float percent;",
  "uniform float gradient;",
  "uniform float frameNumber;",
  "",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "varying float vCounters;",
  "",
  "void main() {",
  ShaderChunk$1.logdepthbuf_fragment,
  "    vec4 c = vColor;",
  "    if( useMap == 1. ) c *= texture2D( map, vUV * repeat );",
  "    if( useAlphaMap == 1. ) c.a *= texture2D( alphaMap, vUV * repeat ).a;",
  "    if( c.a < alphaTest ) discard;",
  "    if( useDash == 1. ){",
  "        c.a *= ceil(mod(vCounters + dashOffset, dashArray) - (dashArray * dashRatio));",
  "    }",
  "    c.a *= step(vCounters, visibility);",
  "    float t = fract(frameNumber / 1000.0 * speed);",
  "    t *= (1.0 + percent);",
  "    float alpha = smoothstep(t - percent, t, vUV.s) * step(-t, -vUV.s);",
  "    c.a *= alpha;",
  ShaderChunk$1.clipping_planes_fragment,
  "    gl_FragColor = c;",
  ShaderChunk$1.fog_fragment,
  ShaderChunk$1.tonemapping_fragment,
  threeVersion$b > 151 ? ShaderChunk$1.colorspace_fragment : ShaderChunk$1.encodings_fragment,
  "}"
].join("\n");
class FlowMeshLineMaterial extends ShaderMaterial$1 {
  constructor(parameters) {
    super({
      transparent: true,
      depthWrite: false,
      depthTest: true,
      side: DoubleSide$1,
      uniforms: Object.assign({}, UniformsLib$1.fog, {
        lineWidth: { value: 1 },
        map: { value: null },
        useMap: { value: 0 },
        alphaMap: { value: null },
        useAlphaMap: { value: 0 },
        color: { value: new Color$1(16777215) },
        opacity: { value: 1 },
        resolution: { value: new Vector2$1(1, 1) },
        sizeAttenuation: { value: true },
        dashArray: { value: 0 },
        dashOffset: { value: 0 },
        dashRatio: { value: 0.5 },
        useDash: { value: 0 },
        visibility: { value: 1 },
        alphaTest: { value: 0 },
        repeat: { value: new Vector2$1(1, 1) },
        speed: { value: 3 },
        percent: { value: 0.08 },
        gradient: { value: 0.02 },
        frameNumber: { value: 1 }
      }),
      vertexShader: ShaderChunk$1.flow_mesh_line_vert,
      fragmentShader: ShaderChunk$1.flow_mesh_line_frag
    });
    this.isFlowMeshLineMaterial = true;
    this.type = "FlowMeshLineMaterial";
    Object.defineProperties(this, {
      lineWidth: {
        enumerable: true,
        get: function() {
          return this.uniforms.lineWidth.value;
        },
        set: function(value) {
          this.uniforms.lineWidth.value = value;
        }
      },
      map: {
        enumerable: true,
        get: function() {
          return this.uniforms.map.value;
        },
        set: function(value) {
          this.uniforms.map.value = value;
        }
      },
      useMap: {
        enumerable: true,
        get: function() {
          return this.uniforms.useMap.value;
        },
        set: function(value) {
          this.uniforms.useMap.value = value;
        }
      },
      alphaMap: {
        enumerable: true,
        get: function() {
          return this.uniforms.alphaMap.value;
        },
        set: function(value) {
          this.uniforms.alphaMap.value = value;
        }
      },
      useAlphaMap: {
        enumerable: true,
        get: function() {
          return this.uniforms.useAlphaMap.value;
        },
        set: function(value) {
          this.uniforms.useAlphaMap.value = value;
        }
      },
      color: {
        enumerable: true,
        get: function() {
          return this.uniforms.color.value;
        },
        set: function(value) {
          this.uniforms.color.value = value;
        }
      },
      opacity: {
        enumerable: true,
        get: function() {
          return this.uniforms.opacity.value;
        },
        set: function(value) {
          this.uniforms.opacity.value = value;
        }
      },
      resolution: {
        enumerable: true,
        get: function() {
          return this.uniforms.resolution.value;
        },
        set: function(value) {
          this.uniforms.resolution.value.copy(value);
        }
      },
      sizeAttenuation: {
        enumerable: true,
        get: function() {
          return this.uniforms.sizeAttenuation.value;
        },
        set: function(value) {
          this.uniforms.sizeAttenuation.value = value;
        }
      },
      dashArray: {
        enumerable: true,
        get: function() {
          return this.uniforms.dashArray.value;
        },
        set: function(value) {
          this.uniforms.dashArray.value = value;
          this.useDash = value !== 0 ? 1 : 0;
        }
      },
      dashOffset: {
        enumerable: true,
        get: function() {
          return this.uniforms.dashOffset.value;
        },
        set: function(value) {
          this.uniforms.dashOffset.value = value;
        }
      },
      dashRatio: {
        enumerable: true,
        get: function() {
          return this.uniforms.dashRatio.value;
        },
        set: function(value) {
          this.uniforms.dashRatio.value = value;
        }
      },
      useDash: {
        enumerable: true,
        get: function() {
          return this.uniforms.useDash.value;
        },
        set: function(value) {
          this.uniforms.useDash.value = value;
        }
      },
      visibility: {
        enumerable: true,
        get: function() {
          return this.uniforms.visibility.value;
        },
        set: function(value) {
          this.uniforms.visibility.value = value;
        }
      },
      alphaTest: {
        enumerable: true,
        get: function() {
          return this.uniforms.alphaTest.value;
        },
        set: function(value) {
          this.uniforms.alphaTest.value = value;
        }
      },
      repeat: {
        enumerable: true,
        get: function() {
          return this.uniforms.repeat.value;
        },
        set: function(value) {
          this.uniforms.repeat.value.copy(value);
        }
      },
      speed: {
        enumerable: true,
        get: function() {
          return this.uniforms.speed.value;
        },
        set: function(value) {
          this.uniforms.speed.value = value;
        }
      },
      percent: {
        enumerable: true,
        get: function() {
          return this.uniforms.percent.value;
        },
        set: function(value) {
          this.uniforms.percent.value = value;
        }
      },
      gradient: {
        enumerable: true,
        get: function() {
          return this.uniforms.gradient.value;
        },
        set: function(value) {
          this.uniforms.gradient.value = value;
        }
      }
    });
    this.setValues(parameters);
  }
}
FlowMeshLineMaterial.prototype.copy = function(source) {
  ShaderMaterial$1.prototype.copy.call(this, source);
  this.lineWidth = source.lineWidth;
  this.map = source.map;
  this.useMap = source.useMap;
  this.alphaMap = source.alphaMap;
  this.useAlphaMap = source.useAlphaMap;
  this.color.copy(source.color);
  this.opacity = source.opacity;
  this.resolution.copy(source.resolution);
  this.sizeAttenuation = source.sizeAttenuation;
  this.dashArray.copy(source.dashArray);
  this.dashOffset.copy(source.dashOffset);
  this.dashRatio.copy(source.dashRatio);
  this.useDash = source.useDash;
  this.visibility = source.visibility;
  this.alphaTest = source.alphaTest;
  this.repeat.copy(source.repeat);
  this.speed = source.speed;
  this.percent = source.percent;
  this.gradient = source.gradient;
  return this;
};
const threeVersion$a = parseInt(REVISION$1, 10);
ShaderChunk$1["water_ripple_vert"] = [
  "",
  ShaderChunk$1.common,
  ShaderChunk$1.logdepthbuf_pars_vertex,
  ShaderChunk$1.fog_pars_vertex,
  ShaderChunk$1.clipping_planes_pars_vertex,
  ShaderChunk$1.depth_offset_pars_vertex,
  "",
  "varying vec2 vUv;",
  "void main() {",
  "    vUv = uv;",
  "    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.depth_offset_vertex,
  ShaderChunk$1.logdepthbuf_vertex,
  ShaderChunk$1.fog_vertex,
  "    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.clipping_planes_vertex,
  ShaderChunk$1.fog_vertex,
  "}"
].join("\n");
ShaderChunk$1["water_ripple_frag"] = [
  "",
  ShaderChunk$1.fog_pars_fragment,
  ShaderChunk$1.logdepthbuf_pars_fragment,
  ShaderChunk$1.clipping_planes_pars_fragment,
  "",
  "varying vec2 vUv;",
  "uniform vec3 color;",
  "uniform float opacity;",
  "uniform float speed;",
  "uniform float sge;",
  "uniform float time;",
  "float PI = 3.14159265;",
  "",
  "float drawCircle(float index, float range) {",
  "    float opacity = 1.0;",
  "    if (index >= 1.0 - range) {",
  "        opacity = 1.0 - (index - (1.0 - range)) / range;",
  "    } else if (index <= range) {",
  "        opacity = index / range;",
  "    }",
  "    return opacity;",
  "}",
  "",
  "float distanceTo(vec2 src, vec2 dst) {",
  "    float dx = src.x - dst.x;",
  "    float dy = src.y - dst.y;",
  "    float dv = dx * dx + dy * dy;",
  "    return sqrt(dv);",
  "}",
  "",
  ShaderChunk$1.depth_offset_pars_fragment,
  "void main() {",
  ShaderChunk$1.logdepthbuf_fragment,
  ShaderChunk$1.depth_offset_fragment,
  "    float iTime = -time * speed / 20.0;",
  "    float opacity2 = 0.0;",
  "",
  "    float len = distanceTo(vec2(0.5, 0.5), vec2(vUv.x, vUv.y));",
  "",
  "    float size = 1.0 / sge;",
  "    vec2 range = vec2(0.6, 0.8);",
  "    float index = mod(iTime + len, size);",
  "    // 中心圆",
  "    vec2 cRadius = vec2(0.06, 0.12);",
  "    if (index < size && len <= 0.5) {",
  "        float i = sin(index / size * PI);",
  "",
  "        // 处理边缘锯齿",
  "        if (i >= range.x && i <= range.y) {",
  "            // 归一",
  "            float t = (i - range.x) / (range.y - range.x);",
  "            // 边缘锯齿范围",
  "            float r = 0.3;",
  "            opacity2 = drawCircle(t, r);",
  "        }",
  "        // 渐变",
  "        opacity2 *=  1.0 - len / 0.5;",
  "    };",
  "",
  ShaderChunk$1.clipping_planes_fragment,
  "    gl_FragColor = vec4(color, opacity * opacity2);",
  ShaderChunk$1.fog_fragment,
  ShaderChunk$1.tonemapping_fragment,
  threeVersion$a > 151 ? ShaderChunk$1.colorspace_fragment : ShaderChunk$1.encodings_fragment,
  "}"
].join("\n");
class WaterRippleMaterial extends ShaderMaterial$1 {
  constructor(parameters) {
    super({
      transparent: true,
      depthWrite: true,
      depthTest: true,
      //   blending: THREE.AdditiveBlending,
      side: DoubleSide$1,
      uniforms: Object.assign({}, UniformsLib$1.fog, {
        color: { value: new Color$1("#FFFFFF") },
        opacity: { value: 1 },
        speed: { value: 1 },
        sge: { value: 8 },
        radius: { value: 0.1 },
        time: { type: "f", value: 0 }
      }),
      vertexShader: ShaderChunk$1.water_ripple_vert,
      fragmentShader: ShaderChunk$1.water_ripple_frag
    });
    this.isWaterRippleMaterial = true;
    this.type = "WaterRippleMaterial";
    Object.defineProperties(this, {
      color: {
        enumerable: true,
        get: function() {
          return this.uniforms.color.value;
        },
        set: function(value) {
          this.uniforms.color.value = value;
        }
      },
      opacity: {
        enumerable: true,
        get: function() {
          return this.uniforms.opacity.value;
        },
        set: function(value) {
          this.uniforms.opacity.value = value;
        }
      },
      speed: {
        enumerable: true,
        get: function() {
          return this.uniforms.speed.value;
        },
        set: function(value) {
          this.uniforms.speed.value = value;
        }
      },
      sge: {
        enumerable: true,
        get: function() {
          return this.uniforms.sge.value;
        },
        set: function(value) {
          this.uniforms.sge.value = value;
        }
      },
      radius: {
        enumerable: true,
        get: function() {
          return this.uniforms.radius.value;
        },
        set: function(value) {
          this.uniforms.radius.value = value;
        }
      },
      time: {
        enumerable: true,
        get: function() {
          return this.uniforms.time.value;
        },
        set: function(value) {
          this.uniforms.time.value = value;
        }
      }
    });
    this.setValues(parameters);
  }
}
WaterRippleMaterial.prototype.copy = function(source) {
  ShaderMaterial$1.prototype.copy.call(this, source);
  this.color.copy(source.color);
  this.opacity = source.opacity;
  this.speed = source.speed;
  this.sge = source.sge;
  this.radius = source.radius;
  this.time = source.time;
  return this;
};
const threeVersion$9 = parseInt(REVISION$1, 10);
ShaderChunk$1["scan_circle_vert"] = [
  "",
  ShaderChunk$1.common,
  ShaderChunk$1.logdepthbuf_pars_vertex,
  ShaderChunk$1.fog_pars_vertex,
  ShaderChunk$1.clipping_planes_pars_vertex,
  ShaderChunk$1.depth_offset_pars_vertex,
  "",
  "varying vec2 vUv;",
  "void main() {",
  "    vUv = uv;",
  "    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.depth_offset_vertex,
  ShaderChunk$1.logdepthbuf_vertex,
  ShaderChunk$1.fog_vertex,
  "    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.clipping_planes_vertex,
  ShaderChunk$1.fog_vertex,
  "}"
].join("\n");
ShaderChunk$1["scan_circle_frag"] = [
  "",
  ShaderChunk$1.fog_pars_fragment,
  ShaderChunk$1.logdepthbuf_pars_fragment,
  ShaderChunk$1.clipping_planes_pars_fragment,
  "",
  "varying vec2 vUv;",
  "uniform float frameNumber;",
  "uniform vec3 color;",
  "uniform float opacity;",
  "uniform float speed;",
  "",
  "float circle(vec2 uv, float r, float blur) {",
  "    float d = length(uv) / 2.0;",
  "    float c = smoothstep(r + blur, r, d);",
  "    return c;",
  "}",
  "",
  ShaderChunk$1.depth_offset_pars_fragment,
  "void main(){",
  ShaderChunk$1.logdepthbuf_fragment,
  ShaderChunk$1.depth_offset_fragment,
  "    vec2 st = vUv * 2.0 - 1.0;",
  "    float t = fract(frameNumber * speed / 1000.0);",
  "    float s = 0.3;",
  "    float radius1 = smoothstep(.0, s, t) * 0.5;",
  "    float alpha1 = circle(st, radius1, 0.01) * circle(st, radius1, -0.01);",
  "    float alpha2 = circle(st, radius1, 0.01 - radius1) * circle(st, radius1, 0.01);",
  "    float radius2 = 0.5 + smoothstep(s, 1.0, t) * 0.5;",
  "    float alpha3 = circle(st, radius1, radius2 + 0.01 - radius1) * circle(st, radius1, -0.01);",
  "    float alpha = smoothstep(1.0, s, t) * (alpha1 + alpha2 * 0.1 + alpha3 * 0.1);",
  ShaderChunk$1.clipping_planes_fragment,
  "    gl_FragColor = vec4(color, alpha * opacity );",
  ShaderChunk$1.fog_fragment,
  ShaderChunk$1.tonemapping_fragment,
  threeVersion$9 > 151 ? ShaderChunk$1.colorspace_fragment : ShaderChunk$1.encodings_fragment,
  "}"
].join("\n");
class ScanCircleMaterial extends ShaderMaterial$1 {
  constructor(parameters) {
    super({
      transparent: true,
      depthWrite: true,
      depthTest: true,
      //   blending: THREE.AdditiveBlending,
      side: DoubleSide$1,
      uniforms: Object.assign({}, UniformsLib$1.fog, {
        color: { value: new Color$1("#FFFFFF") },
        opacity: { value: 1 },
        speed: { value: 3 },
        frameNumber: { value: 1 }
      }),
      vertexShader: ShaderChunk$1.scan_circle_vert,
      fragmentShader: ShaderChunk$1.scan_circle_frag
    });
    this.isScanCircleMaterial = true;
    this.type = "ScanCircleMaterial";
    Object.defineProperties(this, {
      color: {
        enumerable: true,
        get: function() {
          return this.uniforms.color.value;
        },
        set: function(value) {
          this.uniforms.color.value = value;
        }
      },
      opacity: {
        enumerable: true,
        get: function() {
          return this.uniforms.opacity.value;
        },
        set: function(value) {
          this.uniforms.opacity.value = value;
        }
      },
      speed: {
        enumerable: true,
        get: function() {
          return this.uniforms.speed.value;
        },
        set: function(value) {
          this.uniforms.speed.value = value;
        }
      },
      frameNumber: {
        enumerable: true,
        get: function() {
          return this.uniforms.frameNumber.value;
        },
        set: function(value) {
          this.uniforms.frameNumber.value = value;
        }
      }
    });
    this.setValues(parameters);
  }
}
ScanCircleMaterial.prototype.copy = function(source) {
  ShaderMaterial$1.prototype.copy.call(this, source);
  this.color.copy(source.color);
  this.opacity = source.opacity;
  this.speed = source.speed;
  this.frameNumber = source.frameNumber;
  return this;
};
const threeVersion$8 = parseInt(REVISION$1, 10);
ShaderChunk$1["diffuse_circle_vert"] = [
  "",
  ShaderChunk$1.common,
  ShaderChunk$1.logdepthbuf_pars_vertex,
  ShaderChunk$1.fog_pars_vertex,
  ShaderChunk$1.clipping_planes_pars_vertex,
  ShaderChunk$1.depth_offset_pars_vertex,
  "",
  "varying vec2 vUv;",
  "void main() {",
  "    vUv = uv;",
  "    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.depth_offset_vertex,
  ShaderChunk$1.logdepthbuf_vertex,
  ShaderChunk$1.fog_vertex,
  "    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.clipping_planes_vertex,
  "}"
].join("\n");
ShaderChunk$1["diffuse_circle_frag"] = [
  "",
  ShaderChunk$1.fog_pars_fragment,
  ShaderChunk$1.logdepthbuf_pars_fragment,
  ShaderChunk$1.clipping_planes_pars_fragment,
  "",
  "varying vec2 vUv;",
  "uniform float frameNumber;",
  "uniform vec3 color;",
  "uniform float opacity;",
  "uniform float speed;",
  "",
  "vec3 circlePing(float r, float innerTail, float frontierBorder, float timeResetSeconds, float radarPingSpeed, float fadeDistance) {",
  "    float t = fract(frameNumber / 1000.0 * speed);",
  "    float time = mod(t, timeResetSeconds) * radarPingSpeed;",
  "    float circle = 0.0;",
  "    circle += smoothstep(time - innerTail, time, r) * smoothstep(time + frontierBorder,time, r);",
  "    circle *= smoothstep(fadeDistance, 0.0, r);",
  "    return vec3(circle);",
  "}",
  "",
  ShaderChunk$1.depth_offset_pars_fragment,
  "void main(){",
  ShaderChunk$1.logdepthbuf_fragment,
  ShaderChunk$1.depth_offset_fragment,
  "    vec2 st = vUv * 2.0 - 1.0;",
  "    vec2 center = vec2(0.0);",
  "    float dis = distance(st, center);",
  "    float r = length(st - center) / 5.0;",
  "    float flagAlpha = circlePing(r, 0.25, 0.025, 4.0, 0.3, 1.0).r * opacity;",
  ShaderChunk$1.clipping_planes_fragment,
  "    gl_FragColor = vec4(color, flagAlpha);",
  ShaderChunk$1.fog_fragment,
  ShaderChunk$1.tonemapping_fragment,
  threeVersion$8 > 151 ? ShaderChunk$1.colorspace_fragment : ShaderChunk$1.encodings_fragment,
  "}"
].join("\n");
class DiffuseCircleMaterial extends ShaderMaterial$1 {
  constructor(parameters) {
    super({
      transparent: true,
      depthWrite: true,
      depthTest: true,
      //blending: THREE.AdditiveBlending,
      side: DoubleSide$1,
      uniforms: Object.assign({}, UniformsLib$1.fog, {
        color: { value: new Color$1("#FFFFFF") },
        opacity: { value: 1 },
        speed: { value: 3 },
        frameNumber: { value: 1 }
      }),
      vertexShader: ShaderChunk$1.diffuse_circle_vert,
      fragmentShader: ShaderChunk$1.diffuse_circle_frag
    });
    this.isDiffuseCircleMaterial = true;
    this.type = "DiffuseCircleMaterial";
    Object.defineProperties(this, {
      color: {
        enumerable: true,
        get: function() {
          return this.uniforms.color.value;
        },
        set: function(value) {
          this.uniforms.color.value = value;
        }
      },
      opacity: {
        enumerable: true,
        get: function() {
          return this.uniforms.opacity.value;
        },
        set: function(value) {
          this.uniforms.opacity.value = value;
        }
      },
      speed: {
        enumerable: true,
        get: function() {
          return this.uniforms.speed.value;
        },
        set: function(value) {
          this.uniforms.speed.value = value;
        }
      },
      frameNumber: {
        enumerable: true,
        get: function() {
          return this.uniforms.frameNumber.value;
        },
        set: function(value) {
          this.uniforms.frameNumber.value = value;
        }
      }
    });
    this.setValues(parameters);
  }
}
DiffuseCircleMaterial.prototype.copy = function(source) {
  ShaderMaterial$1.prototype.copy.call(this, source);
  this.color.copy(source.color);
  this.opacity = source.opacity;
  this.speed = source.speed;
  this.frameNumber = source.frameNumber;
  return this;
};
const threeVersion$7 = parseInt(REVISION$1, 10);
ShaderChunk$1["scan_radar_vert"] = [
  "",
  ShaderChunk$1.common,
  ShaderChunk$1.logdepthbuf_pars_vertex,
  ShaderChunk$1.fog_pars_vertex,
  ShaderChunk$1.clipping_planes_pars_vertex,
  ShaderChunk$1.depth_offset_pars_vertex,
  "",
  "varying vec2 vUv;",
  "void main() {",
  "    vUv = uv;",
  "    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.depth_offset_vertex,
  ShaderChunk$1.logdepthbuf_vertex,
  ShaderChunk$1.fog_vertex,
  "    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.clipping_planes_vertex,
  "}"
].join("\n");
ShaderChunk$1["scan_radar_frag"] = [
  "",
  ShaderChunk$1.fog_pars_fragment,
  ShaderChunk$1.logdepthbuf_pars_fragment,
  ShaderChunk$1.clipping_planes_pars_fragment,
  "",
  "varying vec2 vUv;",
  "uniform float frameNumber;",
  "uniform vec3 color;",
  "uniform float opacity;",
  "uniform float speed;",
  "uniform bool clockwise;",
  "",
  "const float PI = 3.14159256;",
  "",
  "float RadarSweep(float time, vec2 c, vec2 center, float radius, float speed, bool dir_cw, float tailLength) {",
  "    time *= speed;",
  "    c -= center;",
  "    if (!dir_cw) c.xy = c.yx;",
  "    float x = length(c);",
  "    float y = mod(atan(c.y, c.x) + time, PI * 2.0);",
  "    y /= tailLength;",
  "    float result = 0.0;",
  "    if (x < radius) result += 1.0 - y;",
  "    return result;",
  "}",
  "",
  ShaderChunk$1.depth_offset_pars_fragment,
  "void main(){",
  ShaderChunk$1.logdepthbuf_fragment,
  ShaderChunk$1.depth_offset_fragment,
  "   vec2 st = vUv * 2.0 - 1.0;",
  "   vec2 center = vec2(0.);",
  "   float time = frameNumber / 1000.0;",
  "   vec4 fragColor = vec4(color, RadarSweep(time, st, center, PI, pow(speed,2.0), clockwise, PI / 3.0 ) * opacity);",
  "   if (fragColor.r < 0.0001) fragColor.r = 0.0;",
  "   if (fragColor.g < 0.0001) fragColor.g = 0.0;",
  "   if (fragColor.b < 0.0001) fragColor.b = 0.0;",
  ShaderChunk$1.clipping_planes_fragment,
  "   gl_FragColor = fragColor;",
  ShaderChunk$1.fog_fragment,
  ShaderChunk$1.tonemapping_fragment,
  threeVersion$7 > 151 ? ShaderChunk$1.colorspace_fragment : ShaderChunk$1.encodings_fragment,
  "}"
].join("\n");
class ScanRadarMaterial extends ShaderMaterial$1 {
  constructor(parameters) {
    super({
      transparent: true,
      depthWrite: true,
      depthTest: true,
      //blending: THREE.AdditiveBlending,
      side: DoubleSide$1,
      uniforms: Object.assign({}, UniformsLib$1.fog, {
        color: { value: new Color$1("#FFFFFF") },
        opacity: { value: 1 },
        speed: { value: 3 },
        clockwise: { value: true },
        frameNumber: { value: 1 }
      }),
      vertexShader: ShaderChunk$1.scan_radar_vert,
      fragmentShader: ShaderChunk$1.scan_radar_frag
    });
    this.isScanRadarMaterial = true;
    this.type = "ScanRadarMaterial";
    Object.defineProperties(this, {
      color: {
        enumerable: true,
        get: function() {
          return this.uniforms.color.value;
        },
        set: function(value) {
          this.uniforms.color.value = value;
        }
      },
      opacity: {
        enumerable: true,
        get: function() {
          return this.uniforms.opacity.value;
        },
        set: function(value) {
          this.uniforms.opacity.value = value;
        }
      },
      speed: {
        enumerable: true,
        get: function() {
          return this.uniforms.speed.value;
        },
        set: function(value) {
          this.uniforms.speed.value = value;
        }
      },
      clockwise: {
        enumerable: true,
        get: function() {
          return this.uniforms.clockwise.value;
        },
        set: function(value) {
          this.uniforms.clockwise.value = value;
        }
      },
      frameNumber: {
        enumerable: true,
        get: function() {
          return this.uniforms.frameNumber.value;
        },
        set: function(value) {
          this.uniforms.frameNumber.value = value;
        }
      }
    });
    this.setValues(parameters);
  }
}
ScanRadarMaterial.prototype.copy = function(source) {
  ShaderMaterial$1.prototype.copy.call(this, source);
  this.color.copy(source.color);
  this.opacity = source.opacity;
  this.speed = source.speed;
  this.clockwise = source.clockwise;
  this.frameNumber = source.frameNumber;
  return this;
};
const threeVersion$6 = parseInt(REVISION$1, 10);
ShaderChunk$1["lightning_sphere_vert"] = [
  "",
  ShaderChunk$1.common,
  ShaderChunk$1.logdepthbuf_pars_vertex,
  ShaderChunk$1.fog_pars_vertex,
  ShaderChunk$1.clipping_planes_pars_vertex,
  ShaderChunk$1.depth_offset_pars_vertex,
  "",
  "varying vec2 vUv;",
  "void main() {",
  "    vUv = uv;",
  "    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.depth_offset_vertex,
  ShaderChunk$1.logdepthbuf_vertex,
  ShaderChunk$1.fog_vertex,
  "    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.clipping_planes_vertex,
  "}"
].join("\n");
ShaderChunk$1["lightning_sphere_frag"] = [
  "",
  ShaderChunk$1.fog_pars_fragment,
  ShaderChunk$1.logdepthbuf_pars_fragment,
  ShaderChunk$1.clipping_planes_pars_fragment,
  "",
  "precision mediump float;",
  "varying vec2 vUv;",
  "uniform float frameNumber;",
  "uniform vec3 color;",
  "uniform float opacity;",
  "uniform float speed;",
  "",
  "float rands(float p) {",
  "    return fract(sin(p) * 10000.0);",
  "}",
  "",
  "float noise(vec2 p) {",
  "    float time = frameNumber / 1000. * speed;",
  "    float t = time / 20000.0;",
  "    if (t > 1.0) t -= floor(t);",
  "    return rands(p.x * 14. + p.y * sin(t) * 0.5);",
  "}",
  "",
  "vec2 sw(vec2 p) {",
  "    return vec2(floor(p.x), floor(p.y));",
  "}",
  "vec2 se(vec2 p) {",
  "    return vec2(ceil(p.x), floor(p.y));",
  "}",
  "vec2 nw(vec2 p) {",
  "    return vec2(floor(p.x), ceil(p.y));",
  "}",
  "vec2 ne(vec2 p) {",
  "    return vec2(ceil(p.x), ceil(p.y));",
  "}",
  "",
  "float smoothNoise(vec2 p) {",
  "    vec2 inter = smoothstep(0.0, 1.0, fract(p));",
  "    float s = mix(noise(sw(p)), noise(se(p)), inter.x);",
  "    float n = mix(noise(nw(p)), noise(ne(p)), inter.x);",
  "    return mix(s, n, inter.y);",
  "}",
  "",
  "float fbm(vec2 p) {",
  "    float z = 2.0;",
  "    float rz = 0.0;",
  "    vec2 bp = p;",
  "    for (float i = 1.0; i < 6.0; i++) {",
  "        rz += abs((smoothNoise(p) - 0.5)* 2.0) / z;",
  "        z *= 2.0;",
  "        p *= 2.0;",
  "    }",
  "    return rz;",
  "}",
  "",
  ShaderChunk$1.depth_offset_pars_fragment,
  "void main(){",
  ShaderChunk$1.logdepthbuf_fragment,
  ShaderChunk$1.depth_offset_fragment,
  "    vec2 st = vUv;",
  "    float rz = fbm(st * 4.0);",
  "    rz *= pow(14., 0.9);",
  "    vec4 fragColor = mix(vec4(color, opacity) / rz, vec4(color, 0.1), 0.2);",
  "    if (st.s < 0.05) {",
  "        fragColor = mix(vec4(color, 0.1), fragColor, st.s / 0.05);",
  "    }",
  "    if (st.s > 0.95) {",
  "        fragColor = mix(fragColor, vec4(color, 0.1), (st.s - 0.95) / 0.05);",
  "    }",
  ShaderChunk$1.clipping_planes_fragment,
  "    gl_FragColor = fragColor;",
  ShaderChunk$1.fog_fragment,
  ShaderChunk$1.tonemapping_fragment,
  threeVersion$6 > 151 ? ShaderChunk$1.colorspace_fragment : ShaderChunk$1.encodings_fragment,
  "}"
].join("\n");
class LightningSphereMaterial extends ShaderMaterial$1 {
  constructor(parameters) {
    super({
      transparent: true,
      depthWrite: true,
      depthTest: true,
      // blending: THREE.AdditiveBlending,
      side: DoubleSide$1,
      uniforms: Object.assign({}, UniformsLib$1.fog, {
        color: { value: new Color$1("#FFFFFF") },
        opacity: { value: 1 },
        speed: { value: 3 },
        frameNumber: { value: 1 }
      }),
      vertexShader: ShaderChunk$1.lightning_sphere_vert,
      fragmentShader: ShaderChunk$1.lightning_sphere_frag
    });
    this.isLightningSphereMaterial = true;
    this.type = "LightningSphereMaterial";
    Object.defineProperties(this, {
      color: {
        enumerable: true,
        get: function() {
          return this.uniforms.color.value;
        },
        set: function(value) {
          this.uniforms.color.value = value;
        }
      },
      opacity: {
        enumerable: true,
        get: function() {
          return this.uniforms.opacity.value;
        },
        set: function(value) {
          this.uniforms.opacity.value = value;
        }
      },
      speed: {
        enumerable: true,
        get: function() {
          return this.uniforms.speed.value;
        },
        set: function(value) {
          this.uniforms.speed.value = value;
        }
      },
      frameNumber: {
        enumerable: true,
        get: function() {
          return this.uniforms.frameNumber.value;
        },
        set: function(value) {
          this.uniforms.frameNumber.value = value;
        }
      }
    });
    this.setValues(parameters);
  }
}
LightningSphereMaterial.prototype.copy = function(source) {
  ShaderMaterial$1.prototype.copy.call(this, source);
  this.color.copy(source.color);
  this.opacity = source.opacity;
  this.speed = source.speed;
  this.frameNumber = source.frameNumber;
  return this;
};
const threeVersion$5 = parseInt(REVISION$1, 10);
ShaderChunk$1["flow_wall_vert"] = [
  "",
  ShaderChunk$1.common,
  ShaderChunk$1.logdepthbuf_pars_vertex,
  ShaderChunk$1.fog_pars_vertex,
  ShaderChunk$1.clipping_planes_pars_vertex,
  ShaderChunk$1.depth_offset_pars_vertex,
  "",
  "varying vec2 vUv;",
  "void main() {",
  "    vUv = uv;",
  "    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.depth_offset_vertex,
  ShaderChunk$1.logdepthbuf_vertex,
  ShaderChunk$1.fog_vertex,
  "    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.clipping_planes_vertex,
  "}"
].join("\n");
ShaderChunk$1["flow_wall_frag"] = [
  "",
  ShaderChunk$1.fog_pars_fragment,
  ShaderChunk$1.logdepthbuf_pars_fragment,
  ShaderChunk$1.clipping_planes_pars_fragment,
  "",
  "varying vec2 vUv;",
  "",
  "uniform float frameNumber;",
  "uniform vec3 color;",
  "uniform float opacity;",
  "uniform float speed;",
  "",
  ShaderChunk$1.depth_offset_pars_fragment,
  "void main() {",
  ShaderChunk$1.logdepthbuf_fragment,
  ShaderChunk$1.depth_offset_fragment,
  "    vec2 st = vUv;",
  "    float time = fract(frameNumber / 1000.0 * speed);",
  "    st.t -= time;",
  "    st.t = mod(st.t, 1.0);",
  "    if (vUv.t > st.t) st.t = 1.0 - vUv.t;",
  ShaderChunk$1.clipping_planes_fragment,
  "    gl_FragColor = vec4(color.rgb, st.t * opacity);",
  ShaderChunk$1.fog_fragment,
  ShaderChunk$1.tonemapping_fragment,
  threeVersion$5 > 151 ? ShaderChunk$1.colorspace_fragment : ShaderChunk$1.encodings_fragment,
  "}"
].join("\n");
class FlowWallMaterial extends ShaderMaterial$1 {
  constructor(parameters) {
    super({
      transparent: true,
      depthWrite: false,
      depthTest: true,
      side: DoubleSide$1,
      uniforms: Object.assign({}, UniformsLib$1.fog, {
        color: { value: new Color$1("#FFFFFF") },
        opacity: { value: 1 },
        speed: { value: 3 },
        frameNumber: { value: 1 }
      }),
      vertexShader: ShaderChunk$1.flow_wall_vert,
      fragmentShader: ShaderChunk$1.flow_wall_frag
    });
    this.isFlowWallMaterial = true;
    this.type = "FlowWallMaterial";
    Object.defineProperties(this, {
      color: {
        enumerable: true,
        get: function() {
          return this.uniforms.color.value;
        },
        set: function(value) {
          this.uniforms.color.value = value;
        }
      },
      opacity: {
        enumerable: true,
        get: function() {
          return this.uniforms.opacity.value;
        },
        set: function(value) {
          this.uniforms.opacity.value = value;
        }
      },
      speed: {
        enumerable: true,
        get: function() {
          return this.uniforms.speed.value;
        },
        set: function(value) {
          this.uniforms.speed.value = value;
        }
      }
    });
    this.setValues(parameters);
  }
}
FlowWallMaterial.prototype.copy = function(source) {
  ShaderMaterial$1.prototype.copy.call(this, source);
  this.map = source.map;
  this.color.copy(source.color);
  this.opacity = source.opacity;
  this.speed = source.speed;
  return this;
};
const threeVersion$4 = parseInt(REVISION$1, 10);
ShaderChunk$1["fade_wall_vert"] = [
  "",
  ShaderChunk$1.common,
  ShaderChunk$1.logdepthbuf_pars_vertex,
  ShaderChunk$1.fog_pars_vertex,
  ShaderChunk$1.clipping_planes_pars_vertex,
  ShaderChunk$1.depth_offset_pars_vertex,
  "",
  "varying vec2 vUv;",
  "void main() {",
  "    vUv = uv;",
  "    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.depth_offset_vertex,
  ShaderChunk$1.logdepthbuf_vertex,
  ShaderChunk$1.fog_vertex,
  "    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.clipping_planes_vertex,
  "}"
].join("\n");
ShaderChunk$1["fade_wall_frag"] = [
  "",
  ShaderChunk$1.fog_pars_fragment,
  ShaderChunk$1.logdepthbuf_pars_fragment,
  ShaderChunk$1.clipping_planes_pars_fragment,
  "",
  "varying vec2 vUv;",
  "",
  "uniform float frameNumber;",
  "uniform vec3 color;",
  "uniform float opacity;",
  "uniform float speed;",
  "",
  ShaderChunk$1.depth_offset_pars_fragment,
  "void main() {",
  ShaderChunk$1.logdepthbuf_fragment,
  ShaderChunk$1.depth_offset_fragment,
  "    vec2 st = vUv;",
  "    st.t = -st.t;",
  "    float time = fract(frameNumber / 1000.0 * speed);",
  ShaderChunk$1.clipping_planes_fragment,
  "    gl_FragColor = vec4(color, (st.t + time) * opacity);",
  ShaderChunk$1.fog_fragment,
  ShaderChunk$1.tonemapping_fragment,
  threeVersion$4 > 151 ? ShaderChunk$1.colorspace_fragment : ShaderChunk$1.encodings_fragment,
  "}"
].join("\n");
class FadeWallMaterial extends ShaderMaterial$1 {
  constructor(parameters) {
    super({
      transparent: true,
      depthWrite: false,
      depthTest: true,
      side: DoubleSide$1,
      uniforms: Object.assign({}, UniformsLib$1.fog, {
        color: { value: new Color$1("#FFFFFF") },
        opacity: { value: 1 },
        speed: { value: 3 },
        frameNumber: { value: 1 }
      }),
      vertexShader: ShaderChunk$1.fade_wall_vert,
      fragmentShader: ShaderChunk$1.fade_wall_frag
    });
    this.isFadeWallMaterial = true;
    this.type = "FadeWallMaterial";
    Object.defineProperties(this, {
      color: {
        enumerable: true,
        get: function() {
          return this.uniforms.color.value;
        },
        set: function(value) {
          this.uniforms.color.value = value;
        }
      },
      opacity: {
        enumerable: true,
        get: function() {
          return this.uniforms.opacity.value;
        },
        set: function(value) {
          this.uniforms.opacity.value = value;
        }
      },
      speed: {
        enumerable: true,
        get: function() {
          return this.uniforms.speed.value;
        },
        set: function(value) {
          this.uniforms.speed.value = value;
        }
      }
    });
    this.setValues(parameters);
  }
}
FadeWallMaterial.prototype.copy = function(source) {
  ShaderMaterial$1.prototype.copy.call(this, source);
  this.color.copy(source.color);
  this.opacity = source.opacity;
  this.speed = source.speed;
  return this;
};
const threeVersion$3 = parseInt(REVISION$1, 10);
ShaderChunk$1["outline_wall_vert"] = [
  "",
  ShaderChunk$1.common,
  ShaderChunk$1.logdepthbuf_pars_vertex,
  ShaderChunk$1.fog_pars_vertex,
  ShaderChunk$1.clipping_planes_pars_vertex,
  ShaderChunk$1.depth_offset_pars_vertex,
  "",
  "precision mediump float;",
  "varying vec2 vUv;",
  "",
  "void main() {",
  "    vUv = uv;",
  "    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);",
  ShaderChunk$1.depth_offset_vertex,
  ShaderChunk$1.logdepthbuf_vertex,
  ShaderChunk$1.fog_vertex,
  "    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
  ShaderChunk$1.clipping_planes_vertex,
  "}"
].join("\n");
ShaderChunk$1["outline_wall_frag"] = [
  "",
  ShaderChunk$1.fog_pars_fragment,
  ShaderChunk$1.logdepthbuf_pars_fragment,
  ShaderChunk$1.clipping_planes_pars_fragment,
  "",
  "precision mediump float;",
  "varying vec2 vUv;",
  "varying vec2 vUy;",
  "",
  "uniform float opacity;",
  "uniform sampler2D textureMap;",
  "uniform float percent;",
  "uniform vec3 imageColor;",
  "uniform vec3 gradientColor;",
  "uniform float wrapS;",
  "uniform float gradientSpeed;",
  "uniform float textureSpeed;",
  "uniform float frameNumber;",
  "",
  ShaderChunk$1.depth_offset_pars_fragment,
  "void main() {",
  ShaderChunk$1.logdepthbuf_fragment,
  ShaderChunk$1.depth_offset_fragment,
  "    vec2 st = vUv;",
  "    float tempOpacity = 0.0;",
  "    float gradientTime = fract(frameNumber / 1000.0 * gradientSpeed);",
  "    st.x = mod(st.x + gradientTime, 1.0);",
  "    if (st.x <= 0.6) {",
  "        if (st.y >= percent) {",
  "            float topacity = opacity - st.x;",
  "            tempOpacity = topacity * (1.0 - st.y) / percent;",
  "        } else {",
  "            tempOpacity = opacity - st.x;",
  "        }",
  "    }",
  "",
  "    vec2 st2 = vUv;",
  "    float textureTime = fract(frameNumber / 1000.0 * textureSpeed);",
  "    float xPerWrap = 1.0 / float(wrapS);",
  "    st2.x = mod(st2.x, xPerWrap) / xPerWrap;",
  "    st2.x = mod(st2.x + textureTime, 1.0);",
  "    vec4 img = texture2D(textureMap, st2);",
  "    img = vec4(imageColor, img.a);",
  "",
  "    vec4 mixColor = vec4(gradientColor.rgb, tempOpacity);",
  "    if (st.x <= 0.6) {",
  "        if (img.a > 0.5) {",
  "            mixColor = vec4(mix(img.rgb, gradientColor.rgb, 0.5), img.a * opacity);",
  "        } else {",
  "            mixColor = vec4(gradientColor.rgb, tempOpacity);",
  "        }",
  "    } else {",
  "        mixColor = vec4(img.rgb, img.a * opacity);",
  "    }",
  ShaderChunk$1.clipping_planes_fragment,
  "    gl_FragColor = mixColor;",
  ShaderChunk$1.fog_fragment,
  ShaderChunk$1.tonemapping_fragment,
  threeVersion$3 > 151 ? ShaderChunk$1.colorspace_fragment : ShaderChunk$1.encodings_fragment,
  "}"
].join("\n");
class OutlineWallMaterial extends ShaderMaterial$1 {
  constructor(parameters) {
    super({
      transparent: true,
      depthWrite: false,
      depthTest: true,
      side: DoubleSide$1,
      uniforms: Object.assign({}, UniformsLib$1.fog, {
        frameNumber: { value: 1 },
        gradientSpeed: { value: 3 },
        textureSpeed: { value: 3 },
        opacity: { value: 0.7 },
        textureMap: { value: null },
        percent: { value: 0.5 },
        gradientColor: { value: new Color$1("#FFFFFF") },
        imageColor: { value: new Color$1("#FFFFFF") },
        wrapS: { value: 1 }
      }),
      vertexShader: ShaderChunk$1.outline_wall_vert,
      fragmentShader: ShaderChunk$1.outline_wall_frag
    });
    this.isOutlineWallMaterial = true;
    this.type = "OutlineWallMaterial";
    Object.defineProperties(this, {
      gradientSpeed: {
        enumerable: true,
        get: function() {
          return this.uniforms.gradientSpeed.value;
        },
        set: function(value) {
          this.uniforms.gradientSpeed.value = value;
        }
      },
      textureSpeed: {
        enumerable: true,
        get: function() {
          return this.uniforms.textureSpeed.value;
        },
        set: function(value) {
          this.uniforms.textureSpeed.value = value;
        }
      },
      opacity: {
        enumerable: true,
        get: function() {
          return this.uniforms.opacity.value;
        },
        set: function(value) {
          this.uniforms.opacity.value = value;
        }
      },
      textureMap: {
        enumerable: true,
        get: function() {
          return this.uniforms.textureMap.value;
        },
        set: function(value) {
          this.uniforms.textureMap.value = value;
        }
      },
      percent: {
        enumerable: true,
        get: function() {
          return this.uniforms.percent.value;
        },
        set: function(value) {
          this.uniforms.percent.value = value;
        }
      },
      gradientColor: {
        enumerable: true,
        get: function() {
          return this.uniforms.gradientColor.value;
        },
        set: function(value) {
          this.uniforms.gradientColor.value = value;
        }
      },
      imageColor: {
        enumerable: true,
        get: function() {
          return this.uniforms.imageColor.value;
        },
        set: function(value) {
          this.uniforms.imageColor.value = value;
        }
      },
      wrapS: {
        enumerable: true,
        get: function() {
          return this.uniforms.wrapS.value;
        },
        set: function(value) {
          this.uniforms.wrapS.value = value;
        }
      }
    });
    this.setValues(parameters);
  }
}
OutlineWallMaterial.prototype.copy = function(source) {
  ShaderMaterial$1.prototype.copy.call(this, source);
  this.gradientSpeed = source.gradientSpeed;
  this.textureSpeed = source.textureSpeed;
  this.opacity = source.opacity;
  this.textureMap = source.textureMap;
  this.percent = source.percent;
  this.gradientColor.copy(source.gradientColor);
  this.imageColor.copy(source.imageColor);
  this.wrapS = source.wrapS;
  return this;
};
const threeVersion$2 = parseInt(REVISION$1, 10);
class Water extends Mesh$1 {
  constructor(geometry, options = {}) {
    super(geometry);
    this.isWater = true;
    const scope = this;
    const textureWidth = options.textureWidth !== void 0 ? options.textureWidth : 512;
    const textureHeight = options.textureHeight !== void 0 ? options.textureHeight : 512;
    const clipBias = options.clipBias !== void 0 ? options.clipBias : 0;
    const alpha = options.alpha !== void 0 ? options.alpha : 1;
    const time2 = options.time !== void 0 ? options.time : 0;
    const size = options.size !== void 0 ? options.size : 1;
    const normalSampler = options.waterNormals !== void 0 ? options.waterNormals : null;
    const sunDirection = options.sunDirection !== void 0 ? options.sunDirection : new Vector3$1(0.70707, 0.70707, 0);
    const sunColor = options.sunColor && options.sunColor.isColor ? options.sunColor : new Color$1(
      options.sunColor !== void 0 ? options.sunColor : "#ffffff"
    ).convertSRGBToLinear();
    const waterColor = options.waterColor && options.sunColor.waterColor ? options.waterColor : new Color$1(
      options.waterColor !== void 0 ? options.waterColor : "0x001e0f"
    ).convertSRGBToLinear();
    const eye = options.eye !== void 0 ? options.eye : new Vector3$1(0, 0, 0);
    const distortionScale = options.distortionScale !== void 0 ? options.distortionScale : 20;
    const noiseScale = options.noiseScale !== void 0 ? options.noiseScale : 1;
    const side = options.side !== void 0 ? options.side : FrontSide$1;
    const fog = options.fog !== void 0 ? options.fog : false;
    const mirrorPlane = new Plane$1();
    const normal = new Vector3$1();
    const mirrorWorldPosition = new Vector3$1();
    const cameraWorldPosition = new Vector3$1();
    const rotationMatrix = new Matrix4$1();
    const lookAtPosition = new Vector3$1(0, 0, -1);
    const clipPlane = new Vector4$1();
    const view = new Vector3$1();
    const target = new Vector3$1();
    const q = new Vector4$1();
    const textureMatrix = new Matrix4$1();
    const mirrorCamera = new PerspectiveCamera$1();
    const renderTarget = new WebGLRenderTarget$1(textureWidth, textureHeight);
    const mirrorShader = {
      name: "MirrorShader",
      uniforms: UniformsUtils$1.merge([
        UniformsLib$1["fog"],
        UniformsLib$1["lights"],
        {
          normalSampler: { value: null },
          mirrorSampler: { value: null },
          alpha: { value: 1 },
          time: { value: 0 },
          size: { value: 1 },
          distortionScale: { value: 20 },
          noiseScale: { value: 1 },
          textureMatrix: { value: new Matrix4$1() },
          sunColor: { value: new Color$1("#7f7f7f") },
          sunDirection: { value: new Vector3$1(0.70707, 0.70707, 0) },
          eye: { value: new Vector3$1() },
          waterColor: { value: new Color$1("#555555") }
        }
      ]),
      vertexShader: (
        /* glsl */
        `
uniform mat4 textureMatrix;
uniform float time;

varying vec4 mirrorCoord;
varying vec4 worldPosition;
varying vec3 modelPosition;

#include <common>
#include <fog_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>

void main() {
  mirrorCoord = modelMatrix * vec4( position, 1.0 );
  worldPosition = mirrorCoord.xyzw;
  modelPosition = position;
  mirrorCoord = textureMatrix * mirrorCoord;
  vec4 mvPosition =  modelViewMatrix * vec4( position, 1.0 );
  gl_Position = projectionMatrix * mvPosition;

  #include <beginnormal_vertex>
  #include <defaultnormal_vertex>
  #include <logdepthbuf_vertex>
  #include <fog_vertex>
  #include <shadowmap_vertex>
}`
      ),
      fragmentShader: (
        /* glsl */
        `
uniform sampler2D mirrorSampler;
uniform float alpha;
uniform float time;
uniform float size;
uniform float distortionScale;
uniform float noiseScale;
uniform sampler2D normalSampler;
uniform vec3 sunColor;
uniform vec3 sunDirection;
uniform vec3 eye;
uniform vec3 waterColor;

varying vec4 mirrorCoord;
varying vec4 worldPosition;
varying vec3 modelPosition;

vec4 getNoise( vec2 uv ) {
  vec2 uv0 = uv / ( 103.0 * noiseScale ) + vec2( time / 17.0, time / 29.0 );
  vec2 uv1 = uv / ( 107.0 * noiseScale ) - vec2( time / -19.0, time / 31.0 );
  vec2 uv2 = uv / ( vec2( 8907.0, 9803.0 ) * noiseScale ) + vec2( time / 101.0, time / 97.0 );
  vec2 uv3 = uv / ( vec2( 1091.0, 1027.0 ) * noiseScale ) - vec2( time / 109.0, time / -113.0 );
  vec4 noise = texture2D( normalSampler, uv0 ) +
    texture2D( normalSampler, uv1 ) +
    texture2D( normalSampler, uv2 ) +
    texture2D( normalSampler, uv3 );
  return noise * 0.5 - 1.0;
}

void sunLight( const vec3 surfaceNormal, const vec3 eyeDirection, float shiny, float spec, float diffuse, inout vec3 diffuseColor, inout vec3 specularColor ) {
  vec3 reflection = normalize( reflect( -sunDirection, surfaceNormal ) );
  float direction = max( 0.0, dot( eyeDirection, reflection ) );
  specularColor += pow( direction, shiny ) * sunColor * spec;
  diffuseColor += max( dot( sunDirection, surfaceNormal ), 0.0 ) * sunColor * diffuse;
}

#include <common>
#include <packing>
#include <bsdfs>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <lights_pars_begin>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>

void main() {

  #include <logdepthbuf_fragment>
  vec4 noise = getNoise( modelPosition.xy * size );
  vec3 surfaceNormal = normalize( noise.xyz * vec3( 1.5, 1.0, 1.5 ) );

  vec3 diffuseLight = vec3(0.0);
  vec3 specularLight = vec3(0.0);

  vec3 worldToEye = eye-worldPosition.xyz;
  vec3 eyeDirection = normalize( worldToEye );
  sunLight( surfaceNormal, eyeDirection, 100.0, 2.0, 0.5, diffuseLight, specularLight );

  float distance = length(worldToEye);

  vec2 distortion = surfaceNormal.xy * ( 0.001 + 1.0 / distance ) * distortionScale;
  vec3 reflectionSample = vec3( texture2D( mirrorSampler, mirrorCoord.xy / mirrorCoord.w + distortion ) );

  float theta = max( dot( eyeDirection, surfaceNormal ), 0.0 );
  float rf0 = 0.3;
  float reflectance = rf0 + ( 1.0 - rf0 ) * pow( ( 1.0 - theta ), 5.0 );
  vec3 scatter = max( 0.0, dot( surfaceNormal, eyeDirection ) ) * waterColor;
  vec3 albedo = mix( ( sunColor * diffuseLight * 0.3 + scatter ) * getShadowMask(), ( vec3( 0.1 ) + reflectionSample * 0.9 + reflectionSample * specularLight ), reflectance);
  vec3 outgoingLight = albedo;
  gl_FragColor = vec4( outgoingLight, alpha );

  #include <tonemapping_fragment>
  ${threeVersion$2 > 151 ? "#include <colorspace_fragment>" : "#include <encodings_fragment>"}
  #include <fog_fragment>
}`
      )
    };
    const material = new ShaderMaterial$1({
      name: mirrorShader.name,
      uniforms: UniformsUtils$1.clone(mirrorShader.uniforms),
      vertexShader: mirrorShader.vertexShader,
      fragmentShader: mirrorShader.fragmentShader,
      lights: true,
      // transparent: true,
      side,
      fog
    });
    material.uniforms["mirrorSampler"].value = renderTarget.texture;
    material.uniforms["textureMatrix"].value = textureMatrix;
    material.uniforms["alpha"].value = alpha;
    material.uniforms["time"].value = time2;
    material.uniforms["size"].value = size;
    material.uniforms["normalSampler"].value = normalSampler;
    material.uniforms["sunColor"].value = sunColor;
    material.uniforms["waterColor"].value = waterColor;
    material.uniforms["sunDirection"].value = sunDirection;
    material.uniforms["distortionScale"].value = distortionScale;
    material.uniforms["noiseScale"].value = noiseScale;
    material.uniforms["eye"].value = eye;
    scope.material = material;
    scope.onBeforeRender = function(renderer, scene, camera) {
      mirrorWorldPosition.setFromMatrixPosition(scope.matrixWorld);
      cameraWorldPosition.setFromMatrixPosition(camera.matrixWorld);
      rotationMatrix.extractRotation(scope.matrixWorld);
      normal.set(0, 0, 1);
      normal.applyMatrix4(rotationMatrix);
      view.subVectors(mirrorWorldPosition, cameraWorldPosition);
      if (view.dot(normal) > 0) {
        const meshNormal = new Vector3$1(0, 0, 1).applyMatrix4(rotationMatrix);
        normal.reflect(meshNormal);
      }
      view.reflect(normal).negate();
      view.add(mirrorWorldPosition);
      rotationMatrix.extractRotation(camera.matrixWorld);
      lookAtPosition.set(0, 0, -1);
      lookAtPosition.applyMatrix4(rotationMatrix);
      lookAtPosition.add(cameraWorldPosition);
      target.subVectors(mirrorWorldPosition, lookAtPosition);
      target.reflect(normal).negate();
      target.add(mirrorWorldPosition);
      mirrorCamera.position.copy(view);
      mirrorCamera.up.set(0, -1, 0);
      mirrorCamera.up.applyMatrix4(rotationMatrix);
      mirrorCamera.up.reflect(normal).negate();
      mirrorCamera.lookAt(target);
      mirrorCamera.aspect = camera.aspect;
      mirrorCamera.far = camera.far;
      mirrorCamera.updateMatrixWorld();
      mirrorCamera.projectionMatrix.copy(camera.projectionMatrix);
      textureMatrix.set(
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        1
      );
      textureMatrix.multiply(mirrorCamera.projectionMatrix);
      textureMatrix.multiply(mirrorCamera.matrixWorldInverse);
      mirrorPlane.setFromNormalAndCoplanarPoint(normal, mirrorWorldPosition);
      mirrorPlane.applyMatrix4(mirrorCamera.matrixWorldInverse);
      clipPlane.set(
        mirrorPlane.normal.x,
        mirrorPlane.normal.y,
        mirrorPlane.normal.z,
        mirrorPlane.constant
      );
      const projectionMatrix = mirrorCamera.projectionMatrix;
      q.x = (Math.sign(clipPlane.x) + projectionMatrix.elements[8]) / projectionMatrix.elements[0];
      q.y = (Math.sign(clipPlane.y) + projectionMatrix.elements[9]) / projectionMatrix.elements[5];
      q.z = -1;
      q.w = (1 + projectionMatrix.elements[10]) / projectionMatrix.elements[14];
      clipPlane.multiplyScalar(2 / clipPlane.dot(q));
      projectionMatrix.elements[2] = clipPlane.x;
      projectionMatrix.elements[6] = clipPlane.y;
      projectionMatrix.elements[10] = clipPlane.z + 1 - clipBias;
      projectionMatrix.elements[14] = clipPlane.w;
      eye.setFromMatrixPosition(camera.matrixWorld);
      const currentRenderTarget = renderer.getRenderTarget();
      const currentXrEnabled = renderer.xr.enabled;
      const currentShadowAutoUpdate = renderer.shadowMap.autoUpdate;
      scope.visible = false;
      renderer.xr.enabled = false;
      renderer.shadowMap.autoUpdate = false;
      renderer.setRenderTarget(renderTarget);
      renderer.state.buffers.depth.setMask(true);
      if (renderer.autoClear === false) renderer.clear();
      renderer.render(scene, mirrorCamera);
      scope.visible = true;
      renderer.xr.enabled = currentXrEnabled;
      renderer.shadowMap.autoUpdate = currentShadowAutoUpdate;
      renderer.setRenderTarget(currentRenderTarget);
      const viewport = camera.viewport;
      if (viewport !== void 0) {
        renderer.state.viewport(viewport);
      }
    };
  }
}
UniformsLib$1.line = {
  worldUnits: { value: 1 },
  linewidth: { value: 1 },
  resolution: { value: new Vector2$1(1, 1) },
  dashOffset: { value: 0 },
  dashScale: { value: 1 },
  dashSize: { value: 1 },
  gapSize: { value: 1 }
  // todo FIX - maybe change to totalSize
};
ShaderLib$1["line"] = {
  uniforms: UniformsUtils$1.merge([
    UniformsLib$1.common,
    UniformsLib$1.fog,
    UniformsLib$1.line
  ]),
  vertexShader: (
    /* glsl */
    `
		#include <common>
		#include <color_pars_vertex>
		#include <fog_pars_vertex>
		#include <logdepthbuf_pars_vertex>
		#include <clipping_planes_pars_vertex>

		uniform float linewidth;
		uniform vec2 resolution;

		attribute vec3 instanceStart;
		attribute vec3 instanceEnd;

		attribute vec3 instanceColorStart;
		attribute vec3 instanceColorEnd;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#ifdef USE_DASH

			uniform float dashScale;
			attribute float instanceDistanceStart;
			attribute float instanceDistanceEnd;
			varying float vLineDistance;

		#endif

		void trimSegment( const in vec4 start, inout vec4 end ) {

			// trim end segment so it terminates between the camera plane and the near plane

			// conservative estimate of the near plane
			float a = projectionMatrix[ 2 ][ 2 ]; // 3nd entry in 3th column
			float b = projectionMatrix[ 3 ][ 2 ]; // 3nd entry in 4th column
			float nearEstimate = - 0.5 * b / a;

			float alpha = ( nearEstimate - start.z ) / ( end.z - start.z );

			end.xyz = mix( start.xyz, end.xyz, alpha );

		}

		void main() {

			#ifdef USE_COLOR

				vColor.xyz = ( position.y < 0.5 ) ? instanceColorStart : instanceColorEnd;

			#endif

			#ifdef USE_DASH

				vLineDistance = ( position.y < 0.5 ) ? dashScale * instanceDistanceStart : dashScale * instanceDistanceEnd;
				vUv = uv;

			#endif

			float aspect = resolution.x / resolution.y;

			// camera space
			vec4 start = modelViewMatrix * vec4( instanceStart, 1.0 );
			vec4 end = modelViewMatrix * vec4( instanceEnd, 1.0 );

			#ifdef WORLD_UNITS

				worldStart = start.xyz;
				worldEnd = end.xyz;

			#else

				vUv = uv;

			#endif

			// special case for perspective projection, and segments that terminate either in, or behind, the camera plane
			// clearly the gpu firmware has a way of addressing this issue when projecting into ndc space
			// but we need to perform ndc-space calculations in the shader, so we must address this issue directly
			// perhaps there is a more elegant solution -- WestLangley

			bool perspective = ( projectionMatrix[ 2 ][ 3 ] == - 1.0 ); // 4th entry in the 3rd column

			if ( perspective ) {

				if ( start.z < 0.0 && end.z >= 0.0 ) {

					trimSegment( start, end );

				} else if ( end.z < 0.0 && start.z >= 0.0 ) {

					trimSegment( end, start );

				}

			}

			// clip space
			vec4 clipStart = projectionMatrix * start;
			vec4 clipEnd = projectionMatrix * end;

			// ndc space
			vec3 ndcStart = clipStart.xyz / clipStart.w;
			vec3 ndcEnd = clipEnd.xyz / clipEnd.w;

			// direction
			vec2 dir = ndcEnd.xy - ndcStart.xy;

			// account for clip-space aspect ratio
			dir.x *= aspect;
			dir = normalize( dir );

			#ifdef WORLD_UNITS

				vec3 worldDir = normalize( end.xyz - start.xyz );
				vec3 tmpFwd = normalize( mix( start.xyz, end.xyz, 0.5 ) );
				vec3 worldUp = normalize( cross( worldDir, tmpFwd ) );
				vec3 worldFwd = cross( worldDir, worldUp );
				worldPos = position.y < 0.5 ? start: end;

				// height offset
				float hw = linewidth * 0.5;
				worldPos.xyz += position.x < 0.0 ? hw * worldUp : - hw * worldUp;

				// don't extend the line if we're rendering dashes because we
				// won't be rendering the endcaps
				#ifndef USE_DASH

					// cap extension
					worldPos.xyz += position.y < 0.5 ? - hw * worldDir : hw * worldDir;

					// add width to the box
					worldPos.xyz += worldFwd * hw;

					// endcaps
					if ( position.y > 1.0 || position.y < 0.0 ) {

						worldPos.xyz -= worldFwd * 2.0 * hw;

					}

				#endif

				// project the worldpos
				vec4 clip = projectionMatrix * worldPos;

				// shift the depth of the projected points so the line
				// segments overlap neatly
				vec3 clipPose = ( position.y < 0.5 ) ? ndcStart : ndcEnd;
				clip.z = clipPose.z * clip.w;

			#else

				vec2 offset = vec2( dir.y, - dir.x );
				// undo aspect ratio adjustment
				dir.x /= aspect;
				offset.x /= aspect;

				// sign flip
				if ( position.x < 0.0 ) offset *= - 1.0;

				// endcaps
				if ( position.y < 0.0 ) {

					offset += - dir;

				} else if ( position.y > 1.0 ) {

					offset += dir;

				}

				// adjust for linewidth
				offset *= linewidth;

				// adjust for clip-space to screen-space conversion // maybe resolution should be based on viewport ...
				offset /= resolution.y;

				// select end
				vec4 clip = ( position.y < 0.5 ) ? clipStart : clipEnd;

				// back to clip space
				offset *= clip.w;

				clip.xy += offset;

			#endif

			gl_Position = clip;

			vec4 mvPosition = ( position.y < 0.5 ) ? start : end; // this is an approximation

			#include <logdepthbuf_vertex>
			#include <clipping_planes_vertex>
			#include <fog_vertex>

		}
		`
  ),
  fragmentShader: (
    /* glsl */
    `
		uniform vec3 diffuse;
		uniform float opacity;
		uniform float linewidth;

		#ifdef USE_DASH

			uniform float dashOffset;
			uniform float dashSize;
			uniform float gapSize;

		#endif

		varying float vLineDistance;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#include <common>
		#include <color_pars_fragment>
		#include <fog_pars_fragment>
		#include <logdepthbuf_pars_fragment>
		#include <clipping_planes_pars_fragment>

		vec2 closestLineToLine(vec3 p1, vec3 p2, vec3 p3, vec3 p4) {

			float mua;
			float mub;

			vec3 p13 = p1 - p3;
			vec3 p43 = p4 - p3;

			vec3 p21 = p2 - p1;

			float d1343 = dot( p13, p43 );
			float d4321 = dot( p43, p21 );
			float d1321 = dot( p13, p21 );
			float d4343 = dot( p43, p43 );
			float d2121 = dot( p21, p21 );

			float denom = d2121 * d4343 - d4321 * d4321;

			float numer = d1343 * d4321 - d1321 * d4343;

			mua = numer / denom;
			mua = clamp( mua, 0.0, 1.0 );
			mub = ( d1343 + d4321 * ( mua ) ) / d4343;
			mub = clamp( mub, 0.0, 1.0 );

			return vec2( mua, mub );

		}

		void main() {

			#include <clipping_planes_fragment>

			#ifdef USE_DASH

				if ( vUv.y < - 1.0 || vUv.y > 1.0 ) discard; // discard endcaps

				if ( mod( vLineDistance + dashOffset, dashSize + gapSize ) > dashSize ) discard; // todo - FIX

			#endif

			float alpha = opacity;

			#ifdef WORLD_UNITS

				// Find the closest points on the view ray and the line segment
				vec3 rayEnd = normalize( worldPos.xyz ) * 1e5;
				vec3 lineDir = worldEnd - worldStart;
				vec2 params = closestLineToLine( worldStart, worldEnd, vec3( 0.0, 0.0, 0.0 ), rayEnd );

				vec3 p1 = worldStart + lineDir * params.x;
				vec3 p2 = rayEnd * params.y;
				vec3 delta = p1 - p2;
				float len = length( delta );
				float norm = len / linewidth;

				#ifndef USE_DASH

					#ifdef USE_ALPHA_TO_COVERAGE

						float dnorm = fwidth( norm );
						alpha = 1.0 - smoothstep( 0.5 - dnorm, 0.5 + dnorm, norm );

					#else

						if ( norm > 0.5 ) {

							discard;

						}

					#endif

				#endif

			#else

				#ifdef USE_ALPHA_TO_COVERAGE

					// artifacts appear on some hardware if a derivative is taken within a conditional
					float a = vUv.x;
					float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
					float len2 = a * a + b * b;
					float dlen = fwidth( len2 );

					if ( abs( vUv.y ) > 1.0 ) {

						alpha = 1.0 - smoothstep( 1.0 - dlen, 1.0 + dlen, len2 );

					}

				#else

					if ( abs( vUv.y ) > 1.0 ) {

						float a = vUv.x;
						float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
						float len2 = a * a + b * b;

						if ( len2 > 1.0 ) discard;

					}

				#endif

			#endif

			vec4 diffuseColor = vec4( diffuse, alpha );

			#include <logdepthbuf_fragment>
			#include <color_fragment>

			gl_FragColor = vec4( diffuseColor.rgb, alpha );

			#include <tonemapping_fragment>
			#include <colorspace_fragment>
			#include <fog_fragment>
			#include <premultiplied_alpha_fragment>

		}
		`
  )
};
class LineMaterial extends ShaderMaterial$1 {
  constructor(parameters) {
    super({
      type: "LineMaterial",
      uniforms: UniformsUtils$1.clone(ShaderLib$1["line"].uniforms),
      vertexShader: ShaderLib$1["line"].vertexShader,
      fragmentShader: ShaderLib$1["line"].fragmentShader,
      clipping: true
      // required for clipping support
    });
    this.isLineMaterial = true;
    this.setValues(parameters);
  }
  get color() {
    return this.uniforms.diffuse.value;
  }
  set color(value) {
    this.uniforms.diffuse.value = value;
  }
  get worldUnits() {
    return "WORLD_UNITS" in this.defines;
  }
  set worldUnits(value) {
    if (value === true) {
      this.defines.WORLD_UNITS = "";
    } else {
      delete this.defines.WORLD_UNITS;
    }
  }
  get linewidth() {
    return this.uniforms.linewidth.value;
  }
  set linewidth(value) {
    if (!this.uniforms.linewidth) return;
    this.uniforms.linewidth.value = value;
  }
  get dashed() {
    return "USE_DASH" in this.defines;
  }
  set dashed(value) {
    if (value === true !== this.dashed) {
      this.needsUpdate = true;
    }
    if (value === true) {
      this.defines.USE_DASH = "";
    } else {
      delete this.defines.USE_DASH;
    }
  }
  get dashScale() {
    return this.uniforms.dashScale.value;
  }
  set dashScale(value) {
    this.uniforms.dashScale.value = value;
  }
  get dashSize() {
    return this.uniforms.dashSize.value;
  }
  set dashSize(value) {
    this.uniforms.dashSize.value = value;
  }
  get dashOffset() {
    return this.uniforms.dashOffset.value;
  }
  set dashOffset(value) {
    this.uniforms.dashOffset.value = value;
  }
  get gapSize() {
    return this.uniforms.gapSize.value;
  }
  set gapSize(value) {
    this.uniforms.gapSize.value = value;
  }
  get opacity() {
    return this.uniforms.opacity.value;
  }
  set opacity(value) {
    if (!this.uniforms) return;
    this.uniforms.opacity.value = value;
  }
  get resolution() {
    return this.uniforms.resolution.value;
  }
  set resolution(value) {
    this.uniforms.resolution.value.copy(value);
  }
  get alphaToCoverage() {
    return "USE_ALPHA_TO_COVERAGE" in this.defines;
  }
  set alphaToCoverage(value) {
    if (!this.defines) return;
    if (value === true !== this.alphaToCoverage) {
      this.needsUpdate = true;
    }
    if (value === true) {
      this.defines.USE_ALPHA_TO_COVERAGE = "";
    } else {
      delete this.defines.USE_ALPHA_TO_COVERAGE;
    }
  }
}
const _box$1 = new Box3$1();
const _vector = new Vector3$1();
class LineSegmentsGeometry extends InstancedBufferGeometry$1 {
  constructor() {
    super();
    this.isLineSegmentsGeometry = true;
    this.type = "LineSegmentsGeometry";
    const positions = [-1, 2, 0, 1, 2, 0, -1, 1, 0, 1, 1, 0, -1, 0, 0, 1, 0, 0, -1, -1, 0, 1, -1, 0];
    const uvs = [-1, 2, 1, 2, -1, 1, 1, 1, -1, -1, 1, -1, -1, -2, 1, -2];
    const index2 = [0, 2, 1, 2, 3, 1, 2, 4, 3, 4, 5, 3, 4, 6, 5, 6, 7, 5];
    this.setIndex(index2);
    this.setAttribute("position", new Float32BufferAttribute$1(positions, 3));
    this.setAttribute("uv", new Float32BufferAttribute$1(uvs, 2));
  }
  applyMatrix4(matrix2) {
    const start = this.attributes.instanceStart;
    const end = this.attributes.instanceEnd;
    if (start !== void 0) {
      start.applyMatrix4(matrix2);
      end.applyMatrix4(matrix2);
      start.needsUpdate = true;
    }
    if (this.boundingBox !== null) {
      this.computeBoundingBox();
    }
    if (this.boundingSphere !== null) {
      this.computeBoundingSphere();
    }
    return this;
  }
  setPositions(array) {
    let lineSegments;
    if (array instanceof Float32Array) {
      lineSegments = array;
    } else if (Array.isArray(array)) {
      lineSegments = new Float32Array(array);
    }
    const instanceBuffer = new InstancedInterleavedBuffer$1(lineSegments, 6, 1);
    this.setAttribute("instanceStart", new InterleavedBufferAttribute$1(instanceBuffer, 3, 0));
    this.setAttribute("instanceEnd", new InterleavedBufferAttribute$1(instanceBuffer, 3, 3));
    this.instanceCount = this.attributes.instanceStart.count;
    this.computeBoundingBox();
    this.computeBoundingSphere();
    return this;
  }
  setColors(array) {
    let colors;
    if (array instanceof Float32Array) {
      colors = array;
    } else if (Array.isArray(array)) {
      colors = new Float32Array(array);
    }
    const instanceColorBuffer = new InstancedInterleavedBuffer$1(colors, 6, 1);
    this.setAttribute("instanceColorStart", new InterleavedBufferAttribute$1(instanceColorBuffer, 3, 0));
    this.setAttribute("instanceColorEnd", new InterleavedBufferAttribute$1(instanceColorBuffer, 3, 3));
    return this;
  }
  fromWireframeGeometry(geometry) {
    this.setPositions(geometry.attributes.position.array);
    return this;
  }
  fromEdgesGeometry(geometry) {
    this.setPositions(geometry.attributes.position.array);
    return this;
  }
  fromMesh(mesh) {
    this.fromWireframeGeometry(new WireframeGeometry(mesh.geometry));
    return this;
  }
  fromLineSegments(lineSegments) {
    const geometry = lineSegments.geometry;
    this.setPositions(geometry.attributes.position.array);
    return this;
  }
  computeBoundingBox() {
    if (this.boundingBox === null) {
      this.boundingBox = new Box3$1();
    }
    const start = this.attributes.instanceStart;
    const end = this.attributes.instanceEnd;
    if (start !== void 0 && end !== void 0) {
      this.boundingBox.setFromBufferAttribute(start);
      _box$1.setFromBufferAttribute(end);
      this.boundingBox.union(_box$1);
    }
  }
  computeBoundingSphere() {
    if (this.boundingSphere === null) {
      this.boundingSphere = new Sphere$1();
    }
    if (this.boundingBox === null) {
      this.computeBoundingBox();
    }
    const start = this.attributes.instanceStart;
    const end = this.attributes.instanceEnd;
    if (start !== void 0 && end !== void 0) {
      const center = this.boundingSphere.center;
      this.boundingBox.getCenter(center);
      let maxRadiusSq = 0;
      for (let i2 = 0, il = start.count; i2 < il; i2++) {
        _vector.fromBufferAttribute(start, i2);
        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector));
        _vector.fromBufferAttribute(end, i2);
        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector));
      }
      this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
      if (isNaN(this.boundingSphere.radius)) {
        console.error("THREE.LineSegmentsGeometry.computeBoundingSphere(): Computed radius is NaN. The instanced position data is likely to have NaN values.", this);
      }
    }
  }
  toJSON() {
  }
  applyMatrix(matrix2) {
    console.warn("THREE.LineSegmentsGeometry: applyMatrix() has been renamed to applyMatrix4().");
    return this.applyMatrix4(matrix2);
  }
}
class LineGeometry extends LineSegmentsGeometry {
  constructor() {
    super();
    this.isLineGeometry = true;
    this.type = "LineGeometry";
  }
  setPositions(array) {
    const length2 = array.length - 3;
    const points = new Float32Array(2 * length2);
    for (let i2 = 0; i2 < length2; i2 += 3) {
      points[2 * i2] = array[i2];
      points[2 * i2 + 1] = array[i2 + 1];
      points[2 * i2 + 2] = array[i2 + 2];
      points[2 * i2 + 3] = array[i2 + 3];
      points[2 * i2 + 4] = array[i2 + 4];
      points[2 * i2 + 5] = array[i2 + 5];
    }
    super.setPositions(points);
    return this;
  }
  setColors(array) {
    const length2 = array.length - 3;
    const colors = new Float32Array(2 * length2);
    for (let i2 = 0; i2 < length2; i2 += 3) {
      colors[2 * i2] = array[i2];
      colors[2 * i2 + 1] = array[i2 + 1];
      colors[2 * i2 + 2] = array[i2 + 2];
      colors[2 * i2 + 3] = array[i2 + 3];
      colors[2 * i2 + 4] = array[i2 + 4];
      colors[2 * i2 + 5] = array[i2 + 5];
    }
    super.setColors(colors);
    return this;
  }
  setFromPoints(points) {
    const length2 = points.length - 1;
    const positions = new Float32Array(6 * length2);
    for (let i2 = 0; i2 < length2; i2++) {
      positions[6 * i2] = points[i2].x;
      positions[6 * i2 + 1] = points[i2].y;
      positions[6 * i2 + 2] = points[i2].z || 0;
      positions[6 * i2 + 3] = points[i2 + 1].x;
      positions[6 * i2 + 4] = points[i2 + 1].y;
      positions[6 * i2 + 5] = points[i2 + 1].z || 0;
    }
    super.setPositions(positions);
    return this;
  }
  fromLine(line) {
    const geometry = line.geometry;
    this.setPositions(geometry.attributes.position.array);
    return this;
  }
}
const _viewport = new Vector4$1();
const _start = new Vector3$1();
const _end = new Vector3$1();
const _start4 = new Vector4$1();
const _end4 = new Vector4$1();
const _ssOrigin = new Vector4$1();
const _ssOrigin3 = new Vector3$1();
const _mvMatrix = new Matrix4$1();
const _line = new Line3();
const _closestPoint = new Vector3$1();
const _box = new Box3$1();
const _sphere = new Sphere$1();
const _clipToWorldVector = new Vector4$1();
let _ray, _lineWidth;
function getWorldSpaceHalfWidth(camera, distance2, resolution) {
  _clipToWorldVector.set(0, 0, -distance2, 1).applyMatrix4(camera.projectionMatrix);
  _clipToWorldVector.multiplyScalar(1 / _clipToWorldVector.w);
  _clipToWorldVector.x = _lineWidth / resolution.width;
  _clipToWorldVector.y = _lineWidth / resolution.height;
  _clipToWorldVector.applyMatrix4(camera.projectionMatrixInverse);
  _clipToWorldVector.multiplyScalar(1 / _clipToWorldVector.w);
  return Math.abs(Math.max(_clipToWorldVector.x, _clipToWorldVector.y));
}
function raycastWorldUnits(lineSegments, intersects2) {
  const matrixWorld = lineSegments.matrixWorld;
  const geometry = lineSegments.geometry;
  const instanceStart = geometry.attributes.instanceStart;
  const instanceEnd = geometry.attributes.instanceEnd;
  const segmentCount = Math.min(geometry.instanceCount, instanceStart.count);
  for (let i2 = 0, l2 = segmentCount; i2 < l2; i2++) {
    _line.start.fromBufferAttribute(instanceStart, i2);
    _line.end.fromBufferAttribute(instanceEnd, i2);
    _line.applyMatrix4(matrixWorld);
    const pointOnLine = new Vector3$1();
    const point2 = new Vector3$1();
    _ray.distanceSqToSegment(_line.start, _line.end, point2, pointOnLine);
    const isInside = point2.distanceTo(pointOnLine) < _lineWidth * 0.5;
    if (isInside) {
      intersects2.push({
        point: point2,
        pointOnLine,
        distance: _ray.origin.distanceTo(point2),
        object: lineSegments,
        face: null,
        faceIndex: i2,
        uv: null,
        uv1: null
      });
    }
  }
}
function raycastScreenSpace(lineSegments, camera, intersects2) {
  const projectionMatrix = camera.projectionMatrix;
  const material = lineSegments.material;
  const resolution = material.resolution;
  const matrixWorld = lineSegments.matrixWorld;
  const geometry = lineSegments.geometry;
  const instanceStart = geometry.attributes.instanceStart;
  const instanceEnd = geometry.attributes.instanceEnd;
  const segmentCount = Math.min(geometry.instanceCount, instanceStart.count);
  const near = -camera.near;
  _ray.at(1, _ssOrigin);
  _ssOrigin.w = 1;
  _ssOrigin.applyMatrix4(camera.matrixWorldInverse);
  _ssOrigin.applyMatrix4(projectionMatrix);
  _ssOrigin.multiplyScalar(1 / _ssOrigin.w);
  _ssOrigin.x *= resolution.x / 2;
  _ssOrigin.y *= resolution.y / 2;
  _ssOrigin.z = 0;
  _ssOrigin3.copy(_ssOrigin);
  _mvMatrix.multiplyMatrices(camera.matrixWorldInverse, matrixWorld);
  for (let i2 = 0, l2 = segmentCount; i2 < l2; i2++) {
    _start4.fromBufferAttribute(instanceStart, i2);
    _end4.fromBufferAttribute(instanceEnd, i2);
    _start4.w = 1;
    _end4.w = 1;
    _start4.applyMatrix4(_mvMatrix);
    _end4.applyMatrix4(_mvMatrix);
    const isBehindCameraNear = _start4.z > near && _end4.z > near;
    if (isBehindCameraNear) {
      continue;
    }
    if (_start4.z > near) {
      const deltaDist = _start4.z - _end4.z;
      const t3 = (_start4.z - near) / deltaDist;
      _start4.lerp(_end4, t3);
    } else if (_end4.z > near) {
      const deltaDist = _end4.z - _start4.z;
      const t3 = (_end4.z - near) / deltaDist;
      _end4.lerp(_start4, t3);
    }
    _start4.applyMatrix4(projectionMatrix);
    _end4.applyMatrix4(projectionMatrix);
    _start4.multiplyScalar(1 / _start4.w);
    _end4.multiplyScalar(1 / _end4.w);
    _start4.x *= resolution.x / 2;
    _start4.y *= resolution.y / 2;
    _end4.x *= resolution.x / 2;
    _end4.y *= resolution.y / 2;
    _line.start.copy(_start4);
    _line.start.z = 0;
    _line.end.copy(_end4);
    _line.end.z = 0;
    const param = _line.closestPointToPointParameter(_ssOrigin3, true);
    _line.at(param, _closestPoint);
    const zPos = MathUtils.lerp(_start4.z, _end4.z, param);
    const isInClipSpace = zPos >= -1 && zPos <= 1;
    const isInside = _ssOrigin3.distanceTo(_closestPoint) < _lineWidth * 0.5;
    if (isInClipSpace && isInside) {
      _line.start.fromBufferAttribute(instanceStart, i2);
      _line.end.fromBufferAttribute(instanceEnd, i2);
      _line.start.applyMatrix4(matrixWorld);
      _line.end.applyMatrix4(matrixWorld);
      const pointOnLine = new Vector3$1();
      const point2 = new Vector3$1();
      _ray.distanceSqToSegment(_line.start, _line.end, point2, pointOnLine);
      intersects2.push({
        point: point2,
        pointOnLine,
        distance: _ray.origin.distanceTo(point2),
        object: lineSegments,
        face: null,
        faceIndex: i2,
        uv: null,
        uv1: null
      });
    }
  }
}
class LineSegments22 extends Mesh$1 {
  constructor(geometry = new LineSegmentsGeometry(), material = new LineMaterial({ color: Math.random() * 16777215 })) {
    super(geometry, material);
    this.isLineSegments2 = true;
    this.type = "LineSegments2";
  }
  // for backwards-compatibility, but could be a method of LineSegmentsGeometry...
  computeLineDistances() {
    const geometry = this.geometry;
    const instanceStart = geometry.attributes.instanceStart;
    const instanceEnd = geometry.attributes.instanceEnd;
    const lineDistances = new Float32Array(2 * instanceStart.count);
    for (let i2 = 0, j = 0, l2 = instanceStart.count; i2 < l2; i2++, j += 2) {
      _start.fromBufferAttribute(instanceStart, i2);
      _end.fromBufferAttribute(instanceEnd, i2);
      lineDistances[j] = j === 0 ? 0 : lineDistances[j - 1];
      lineDistances[j + 1] = lineDistances[j] + _start.distanceTo(_end);
    }
    const instanceDistanceBuffer = new InstancedInterleavedBuffer$1(lineDistances, 2, 1);
    geometry.setAttribute("instanceDistanceStart", new InterleavedBufferAttribute$1(instanceDistanceBuffer, 1, 0));
    geometry.setAttribute("instanceDistanceEnd", new InterleavedBufferAttribute$1(instanceDistanceBuffer, 1, 1));
    return this;
  }
  raycast(raycaster, intersects2) {
    const worldUnits = this.material.worldUnits;
    const camera = raycaster.camera;
    if (camera === null && !worldUnits) {
      console.error('LineSegments2: "Raycaster.camera" needs to be set in order to raycast against LineSegments2 while worldUnits is set to false.');
    }
    const threshold = raycaster.params.Line2 !== void 0 ? raycaster.params.Line2.threshold || 0 : 0;
    _ray = raycaster.ray;
    const matrixWorld = this.matrixWorld;
    const geometry = this.geometry;
    const material = this.material;
    _lineWidth = material.linewidth + threshold;
    if (geometry.boundingSphere === null) {
      geometry.computeBoundingSphere();
    }
    _sphere.copy(geometry.boundingSphere).applyMatrix4(matrixWorld);
    let sphereMargin;
    if (worldUnits) {
      sphereMargin = _lineWidth * 0.5;
    } else {
      const distanceToSphere = Math.max(camera.near, _sphere.distanceToPoint(_ray.origin));
      sphereMargin = getWorldSpaceHalfWidth(camera, distanceToSphere, material.resolution);
    }
    _sphere.radius += sphereMargin;
    if (_ray.intersectsSphere(_sphere) === false) {
      return;
    }
    if (geometry.boundingBox === null) {
      geometry.computeBoundingBox();
    }
    _box.copy(geometry.boundingBox).applyMatrix4(matrixWorld);
    let boxMargin;
    if (worldUnits) {
      boxMargin = _lineWidth * 0.5;
    } else {
      const distanceToBox = Math.max(camera.near, _box.distanceToPoint(_ray.origin));
      boxMargin = getWorldSpaceHalfWidth(camera, distanceToBox, material.resolution);
    }
    _box.expandByScalar(boxMargin);
    if (_ray.intersectsBox(_box) === false) {
      return;
    }
    if (worldUnits) {
      raycastWorldUnits(this, intersects2);
    } else {
      raycastScreenSpace(this, camera, intersects2);
    }
  }
  onBeforeRender(renderer) {
    const uniforms = this.material.uniforms;
    if (uniforms && uniforms.resolution) {
      renderer.getViewport(_viewport);
      this.material.uniforms.resolution.value.set(_viewport.z, _viewport.w);
    }
  }
}
class Line22 extends LineSegments22 {
  constructor(geometry = new LineGeometry(), material = new LineMaterial({ color: Math.random() * 16777215 })) {
    super(geometry, material);
    this.isLine2 = true;
    this.type = "Line2";
  }
}
const threeVersion$1 = parseInt(REVISION$1, 10);
class EffectLayer extends ThreeBoxLayer {
  constructor(options) {
    super(options);
    this.isEffectLayer = true;
  }
  addLines(options) {
    let group;
    const tb = this._map.tb;
    if (!options.type || options.type === "pipe") {
      let lines = [];
      const originCoord = options.data[0].coordinate[0];
      const originWorldUnit = tb.projectToWorld(originCoord);
      const color2 = new Color$1(
        typeof options.color === "number" ? options.color : options.color || "#FFFFFF"
      );
      options.data.forEach((data) => {
        let points = [];
        for (let n2 = 0; n2 < data.coordinate.length; n2++) {
          let worldUnit = tb.projectToWorld(data.coordinate[n2]);
          points.push(worldUnit.x - originWorldUnit.x);
          points.push(worldUnit.y - originWorldUnit.y);
          points.push(worldUnit.z - originWorldUnit.z);
        }
        const geometry = new LineGeometry().setPositions(points);
        const material = new LineMaterial({
          color: color2,
          linewidth: "number" == typeof options.width ? options.width : 1,
          resolution: new Vector2$1(
            this._map.getCanvas().clientWidth,
            this._map.getCanvas().clientHeight
          )
        });
        const line = new Line22(geometry, material);
        for (let key in options) line.userData[key] = options[key];
        lines.push(line);
      });
      group = tb.Object3D({ obj: lines }).setCoords(originCoord);
      group.userData.added = true;
    } else if ("solid" === options.type) {
      let lines = [];
      const originCoord = options.data[0].coordinate[0];
      const originWorldUnit = tb.projectToWorld(originCoord);
      const color2 = new Color$1(
        typeof options.color === "number" ? options.color : options.color || "#FFFFFF"
      );
      options.data.forEach((data) => {
        let points = [];
        for (let n2 = 0; n2 < data.coordinate.length; n2++) {
          let worldUnit = tb.projectToWorld(data.coordinate[n2]);
          points.push(worldUnit.x - originWorldUnit.x);
          points.push(worldUnit.y - originWorldUnit.y);
          points.push(worldUnit.z - originWorldUnit.z);
        }
        const geometry = new MeshLine();
        geometry.setPoints(points);
        const material = new MeshLineMaterial2({
          lineWidth: "number" == typeof options.width ? options.width : 1,
          color: color2,
          opacity: "number" == typeof options.opacity ? options.opacity : 1,
          resolution: new Vector2$1(
            this._map.getCanvas().clientWidth,
            this._map.getCanvas().clientHeight
          ),
          transparent: true,
          sizeAttenuation: void 0 === options.sizeAttenuation || options.sizeAttenuation,
          side: DoubleSide$1
        });
        const mesh = new Mesh$1(geometry, material);
        for (let key in data) mesh.userData[key] = data[key];
        lines.push(mesh);
      });
      group = tb.Object3D({ obj: lines }).setCoords(originCoord);
      group.userData.added = true;
    } else if ("dash" === options.type) {
      let lines = [];
      const originCoord = options.data[0].coordinate[0];
      const originWorldUnit = tb.projectToWorld(originCoord);
      const color2 = new Color$1(
        typeof options.color === "number" ? options.color : options.color || "#FFFFFF"
      );
      options.data.forEach((data) => {
        let points = [];
        for (let n2 = 0; n2 < data.coordinate.length; n2++) {
          let worldUnit = tb.projectToWorld(data.coordinate[n2]);
          points.push(worldUnit.x - originWorldUnit.x);
          points.push(worldUnit.y - originWorldUnit.y);
          points.push(worldUnit.z - originWorldUnit.z);
        }
        const geometry = new MeshLine();
        geometry.setPoints(points);
        const material = new MeshLineMaterial2({
          lineWidth: "number" == typeof options.width ? options.width : 1,
          color: color2,
          opacity: "number" == typeof options.opacity ? options.opacity : 1,
          dashArray: "number" == typeof options.dashArray ? options.dashArray : 0.02,
          dashOffset: "number" == typeof options.dashOffset ? options.dashOffset : 0,
          dashRatio: "number" == typeof options.dashRatio ? options.dashRatio : 0.5,
          resolution: new Vector2$1(
            this._map.getCanvas().clientWidth,
            this._map.getCanvas().clientHeight
          ),
          transparent: true,
          sizeAttenuation: void 0 === options.sizeAttenuation || options.sizeAttenuation,
          side: DoubleSide$1
        });
        const mesh = new Mesh$1(geometry, material);
        for (let key in data) mesh.userData[key] = data[key];
        lines.push(mesh);
      });
      group = tb.Object3D({ obj: lines }).setCoords(originCoord);
      group.userData.added = true;
    } else if ("image" === options.type) {
      let lines = [];
      const originCoord = options.data[0].coordinate[0];
      const originWorldUnit = tb.projectToWorld(originCoord);
      const texture = void 0 !== options.image ? new TextureLoader$1().load(options.image) : null;
      if (threeVersion$1 > 151) {
        texture.colorSpace = SRGBColorSpace;
      } else {
        texture.outputEncoding = void 0;
      }
      texture.wrapS = texture.wrapT = RepeatWrapping$1;
      const repeat = options.repeat && typeof options.repeat.x === "number" && typeof options.repeat.y === "number" ? new Vector2$1(options.repeat.x, options.repeat.y) : new Vector2$1(1, 1);
      options.data.forEach((data) => {
        let points = [];
        for (let n2 = 0; n2 < data.coordinate.length; n2++) {
          let worldUnit = tb.projectToWorld(data.coordinate[n2]);
          points.push(worldUnit.x - originWorldUnit.x);
          points.push(worldUnit.y - originWorldUnit.y);
          points.push(worldUnit.z - originWorldUnit.z);
        }
        const geometry = new MeshLine();
        geometry.setPoints(points);
        const material = new MeshLineMaterial2({
          lineWidth: "number" == typeof options.width ? options.width : 1,
          color: void 0 !== options.image ? null : new Color$1("#FFFFFF"),
          useMap: void 0 !== options.image,
          map: texture,
          opacity: "number" == typeof options.opacity ? options.opacity : 1,
          resolution: new Vector2$1(
            this._map.getCanvas().clientWidth,
            this._map.getCanvas().clientHeight
          ),
          transparent: true,
          sizeAttenuation: void 0 === options.sizeAttenuation || options.sizeAttenuation,
          side: DoubleSide$1,
          repeat
        });
        const mesh = new Mesh$1(geometry, material);
        for (let key in data) mesh.userData[key] = data[key];
        lines.push(mesh);
      });
      group = tb.Object3D({ obj: lines }).setCoords(originCoord);
      group.userData.added = true;
    }
    this.group.add(group);
    return group;
  }
  addFlowLine(options) {
    const tb = this._map.tb;
    if ("Circle" === options.type) {
      let interval;
      const originCoord = options.data.coordinate[0];
      const radius = (options.radius || 1) * tb.projectedUnitsPerMeter(originCoord[1]);
      const originWorldUnit = tb.projectToWorld(originCoord);
      const points = [];
      for (let t3 = 0; t3 < options.data.coordinate.length; t3++) {
        const worldUnit = tb.projectToWorld(options.data.coordinate[t3]);
        points.push(
          new Vector3$1(
            worldUnit.x - originWorldUnit.x,
            worldUnit.y - originWorldUnit.y,
            worldUnit.z - originWorldUnit.z
          )
        );
      }
      let material;
      const geometry = new TubeGeometry(
        new CatmullRomCurve3$1(points),
        100,
        radius,
        50,
        options.closed
      );
      const color2 = options.color !== void 0 ? new Color$1(
        typeof options.color === "number" ? options.color : options.color || "#FFFFFF"
      ) : null;
      if (options.image) {
        let texture = new TextureLoader$1().load(options.image);
        if (threeVersion$1 > 151) {
          texture.colorSpace = SRGBColorSpace;
        } else {
          texture.outputEncoding = void 0;
        }
        texture.wrapS = texture.wrapT = RepeatWrapping$1;
        texture.repeat = new Vector2$1(options.repeatX || 10, options.repeatY || 1);
        material = new MeshBasicMaterial$1({
          map: texture,
          color: color2,
          side: void 0 !== options.side ? options.side : FrontSide$1,
          transparent: true,
          opacity: "number" == typeof options.opacity ? options.opacity : 1
        });
        interval = setInterval(() => {
          texture.offset.x = (texture.offset.x - 0.01 * (options.speed || 1)) % 1;
        });
      } else {
        material = new MeshBasicMaterial$1({
          color: color2,
          side: void 0 !== options.side ? options.side : FrontSide$1,
          transparent: true,
          opacity: "number" == typeof options.opacity ? options.opacity : 1
        });
      }
      const Mesh3 = new Mesh$1(geometry, material);
      for (let key in options.data) Mesh3.userData[key] = options.data[key];
      let group = tb.Object3D({ obj: [Mesh3] }).setCoords(originCoord);
      if (interval) group.userData.interval = interval;
      this.group.add(group);
      return group;
    } else if ("Rectangle" === options.type) {
      let interval;
      const originCoord = options.data.coordinate[0];
      const worldUnitPerMeter = tb.projectedUnitsPerMeter(originCoord[1]);
      const originWorldUnit = tb.projectToWorld(originCoord);
      const point3ds = [];
      for (let t3 = 0; t3 < options.data.coordinate.length; t3++) {
        const worldUnit = tb.projectToWorld(options.data.coordinate[t3]);
        point3ds.push(
          new Vector3$1(
            worldUnit.x - originWorldUnit.x,
            worldUnit.y - originWorldUnit.y,
            worldUnit.z - originWorldUnit.z
          )
        );
      }
      const point2ds = [];
      const width = options.rectangle[0] * worldUnitPerMeter;
      const height = options.rectangle[1] * worldUnitPerMeter;
      point2ds.push(new Vector2$1(-width / 2, -height / 2));
      point2ds.push(new Vector2$1(width / 2, -height / 2));
      point2ds.push(new Vector2$1(width / 2, height / 2));
      point2ds.push(new Vector2$1(-width / 2, height / 2));
      let material;
      const shape = new Shape$1(point2ds);
      const path = new CatmullRomCurve3$1(point3ds);
      const steps = options.steps || 10;
      const extrudePts = path.getSpacedPoints(steps);
      const geometry = new ExtrudeGeometry$1(shape, {
        steps,
        bevelEnabled: true,
        extrudePath: path,
        UVGenerator: {
          generateTopUV: function(geometry2, vertices, indexA, indexB, indexC) {
            const a_x = vertices[indexA * 3];
            const a_y = vertices[indexA * 3 + 1];
            const b_x = vertices[indexB * 3];
            const b_y = vertices[indexB * 3 + 1];
            const c_x = vertices[indexC * 3];
            const c_y = vertices[indexC * 3 + 1];
            return [
              new Vector2$1(a_x, a_y),
              new Vector2$1(b_x, b_y),
              new Vector2$1(c_x, c_y)
            ];
          },
          generateSideWallUV: function(geometry2, vertices, indexA, indexB, indexC, indexD) {
            const a_x = vertices[indexA * 3];
            const a_y = vertices[indexA * 3 + 1];
            const a_z = vertices[indexA * 3 + 2];
            const b_x = vertices[indexB * 3];
            const b_y = vertices[indexB * 3 + 1];
            const b_z = vertices[indexB * 3 + 2];
            const c_x = vertices[indexC * 3];
            const c_y = vertices[indexC * 3 + 1];
            const c_z = vertices[indexC * 3 + 2];
            const d_x = vertices[indexD * 3];
            const d_y = vertices[indexD * 3 + 1];
            const d_z = vertices[indexD * 3 + 2];
            const x = (a_x + b_x + c_x + d_x) / 4;
            const y = (a_y + b_y + c_y + d_y) / 4;
            const z2 = (a_z + b_z + c_z + d_z) / 4;
            const targetPoint = new Vector3$1(x, y, z2);
            let closestDistance = Infinity;
            let closesIndex = 0;
            for (let i2 = 0; i2 < extrudePts.length - 1; i2++) {
              const start = extrudePts[i2];
              const end = extrudePts[i2 + 1];
              const segment = new Line3(start, end);
              let target = new Vector3$1(0, 0, 0);
              const footPoint = segment.closestPointToPoint(targetPoint, true, target);
              const distance2 = footPoint.distanceTo(targetPoint);
              if (distance2 < closestDistance) {
                closestDistance = distance2;
                closesIndex = i2;
              }
            }
            return [
              new Vector2$1(1, 1 - closesIndex / (extrudePts.length - 1)),
              new Vector2$1(0, 1 - closesIndex / (extrudePts.length - 1)),
              new Vector2$1(0, 1 - (closesIndex + 1) / (extrudePts.length - 1)),
              new Vector2$1(1, 1 - (closesIndex + 1) / (extrudePts.length - 1))
            ];
          }
        }
      });
      for (let r2 = 0; r2 < 2; r2++) {
        const t3 = 2 * r2;
        if (r2 == 0) {
          geometry.attributes.uv.array[6 * t3] = -1;
          geometry.attributes.uv.array[6 * t3 + 1] = -1;
          geometry.attributes.uv.array[6 * t3 + 2] = 0;
          geometry.attributes.uv.array[6 * t3 + 3] = -1;
          geometry.attributes.uv.array[6 * t3 + 4] = 0;
          geometry.attributes.uv.array[6 * t3 + 5] = 0;
          geometry.attributes.uv.array[6 * (t3 + 1)] = 1;
          geometry.attributes.uv.array[6 * (t3 + 1) + 1] = 1;
          geometry.attributes.uv.array[6 * (t3 + 1) + 2] = 0;
          geometry.attributes.uv.array[6 * (t3 + 1) + 3] = 1;
          geometry.attributes.uv.array[6 * (t3 + 1) + 4] = 0;
          geometry.attributes.uv.array[6 * (t3 + 1) + 5] = 0;
        } else if (r2 == 1) {
          geometry.attributes.uv.array[6 * t3] = 0;
          geometry.attributes.uv.array[6 * t3 + 1] = 0;
          geometry.attributes.uv.array[6 * t3 + 2] = 0;
          geometry.attributes.uv.array[6 * t3 + 3] = -1;
          geometry.attributes.uv.array[6 * t3 + 4] = -1;
          geometry.attributes.uv.array[6 * t3 + 5] = -1;
          geometry.attributes.uv.array[6 * (t3 + 1)] = -1;
          geometry.attributes.uv.array[6 * (t3 + 1) + 1] = -1;
          geometry.attributes.uv.array[6 * (t3 + 1) + 2] = -1;
          geometry.attributes.uv.array[6 * (t3 + 1) + 3] = 0;
          geometry.attributes.uv.array[6 * (t3 + 1) + 4] = 0;
          geometry.attributes.uv.array[6 * (t3 + 1) + 5] = 0;
        }
      }
      geometry.attributes.uv.needsUpdate = true;
      const color2 = options.color !== void 0 ? new Color$1(
        typeof options.color === "number" ? options.color : options.color || "#FFFFFF"
      ) : null;
      if (options.image) {
        let texture = new TextureLoader$1().load(options.image);
        if (threeVersion$1 > 151) {
          texture.colorSpace = SRGBColorSpace;
        } else {
          texture.outputEncoding = void 0;
        }
        texture.wrapS = texture.wrapT = RepeatWrapping$1;
        texture.repeat = new Vector2$1(options.repeatX || 1, -options.repeatY || -1);
        texture.rotation = Math.PI / 2;
        material = new MeshBasicMaterial$1({
          map: texture,
          color: color2,
          side: void 0 !== options.side ? options.side : FrontSide$1,
          transparent: true,
          opacity: "number" == typeof options.opacity ? options.opacity : 1
        });
        interval = setInterval(() => {
          texture.offset.x = (texture.offset.x + 0.01 * (options.speed || 1)) % 1;
        });
      } else {
        material = new MeshBasicMaterial$1({
          color: color2,
          side: void 0 !== options.side ? options.side : FrontSide$1,
          transparent: true,
          opacity: "number" == typeof options.opacity ? options.opacity : 1
        });
      }
      const mesh = new Mesh$1(geometry, [
        new MeshBasicMaterial$1({
          color: 16777215,
          transparent: true,
          side: void 0 !== options.side ? options.side : FrontSide$1,
          opacity: 0.01,
          depthTest: false
        }),
        material
      ]);
      for (let key in options.data) mesh.userData[key] = options.data[key];
      let group = tb.Object3D({ obj: [mesh] }).setCoords(originCoord);
      if (interval) group.userData.interval = interval;
      this.group.add(group);
      return group;
    } else if ("trail" === options.type) {
      const originCoord = options.data.coordinate[0];
      const originWorldUnit = tb.projectToWorld(originCoord);
      const points = [];
      for (let t3 = 0; t3 < options.data.coordinate.length; t3++) {
        const worldUnit = tb.projectToWorld(options.data.coordinate[t3]);
        points.push(
          worldUnit.x - originWorldUnit.x,
          worldUnit.y - originWorldUnit.y,
          worldUnit.z - originWorldUnit.z
        );
      }
      const geometry = new MeshLine();
      geometry.setPoints(points, () => 2);
      const material = new TrailMeshLineMaterial({
        lineWidth: "number" == typeof options.width ? options.width : 10,
        color: typeof options.color === "number" ? options.color : new Color$1(options.color || "#003CFF"),
        opacity: "number" == typeof options.opacity ? options.opacity : 1,
        resolution: new Vector2$1(
          this._map.getCanvas().clientWidth,
          this._map.getCanvas().clientHeight
        ),
        transparent: true,
        sizeAttenuation: false,
        speed: "number" == typeof options.speed ? options.speed : 3
      });
      this._map.materialCache[this.id].push(material);
      const mesh = new Mesh$1(geometry, material);
      for (let key in options.data) mesh.userData[key] = options.data[key];
      let group = tb.Object3D({ obj: [mesh] }).setCoords(originCoord);
      this.group.add(group);
      return group;
    } else if ("flow" === options.type) {
      const originCoord = options.data.coordinate[0];
      const originWorldUnit = tb.projectToWorld(originCoord);
      const points = [];
      for (let t3 = 0; t3 < options.data.coordinate.length; t3++) {
        const worldUnit = tb.projectToWorld(options.data.coordinate[t3]);
        points.push(
          worldUnit.x - originWorldUnit.x,
          worldUnit.y - originWorldUnit.y,
          worldUnit.z - originWorldUnit.z
        );
      }
      const geometry = new MeshLine();
      geometry.setPoints(points, () => 2);
      const material = new FlowMeshLineMaterial({
        lineWidth: "number" == typeof options.width ? options.width : 10,
        color: typeof options.color === "number" ? options.color : new Color$1(options.color || "#FFFF00"),
        opacity: "number" == typeof options.opacity ? options.opacity : 1,
        resolution: new Vector2$1(
          this._map.getCanvas().clientWidth,
          this._map.getCanvas().clientHeight
        ),
        transparent: true,
        sizeAttenuation: false,
        speed: "number" == typeof options.speed ? options.speed : 3,
        percent: "number" == typeof options.percent ? options.percent : 0.08,
        gradient: "number" == typeof options.gradient ? options.gradient : 0.02
      });
      this._map.materialCache[this.id].push(material);
      const mesh = new Mesh$1(geometry, material);
      for (let t3 in options.data) mesh.userData[t3] = options.data[t3];
      let group = tb.Object3D({ obj: mesh }).setCoords(originCoord);
      this.group.add(group);
      return group;
    } else if ("image" === options.type) {
      const oringinCoord = options.data.coordinate[0];
      const originWorldUnit = tb.projectToWorld(oringinCoord);
      const points = [];
      for (let t3 = 0; t3 < options.data.coordinate.length; t3++) {
        const worldUnit = tb.projectToWorld(options.data.coordinate[t3]);
        points.push(
          new Vector3$1(
            worldUnit.x - originWorldUnit.x,
            worldUnit.y - originWorldUnit.y,
            worldUnit.z - originWorldUnit.z
          )
        );
      }
      const pathPointList = new PathPointList();
      const tangent = options.tangent && options.tangent.x !== void 0 && options.tangent.y !== void 0 && options.tangent.z !== void 0 ? new Vector3$1(options.tangent.x, options.tangent.y, options.tangent.z) : new Vector3$1(0, 0, 1);
      pathPointList.set(
        points,
        typeof options.cornerRadius == "number" ? options.cornerRadius : 0.5,
        typeof options.cornerSplit == "number" ? options.cornerSplit : 10,
        tangent,
        options.closed
      );
      const geometry = new PathGeometry(
        {
          pathPointList,
          options: {
            width: ("number" == typeof options.width ? options.width : 10) * tb.projectedUnitsPerMeter(oringinCoord[1]),
            // default is 0.1
            arrow: false,
            // default is true
            progress: 1,
            // default is 1
            side: "both"
            // "left"/"right"/"both", default is "both"
          },
          usage: StaticDrawUsage$1
          // geometry usage
        },
        false
      );
      const texture = new TextureLoader$1().load(options.image);
      if (threeVersion$1 > 151) {
        texture.colorSpace = SRGBColorSpace;
      } else {
        texture.outputEncoding = void 0;
      }
      texture.wrapS = texture.wrapT = RepeatWrapping$1;
      texture.anisotropy = tb.renderer.capabilities.getMaxAnisotropy;
      const material = new MeshBasicMaterial$1({
        color: typeof options.color === "number" ? options.color : new Color$1(options.color || "#FFFF00"),
        opacity: "number" == typeof options.opacity ? options.opacity : 1,
        depthWrite: true,
        transparent: true,
        side: DoubleSide$1,
        map: texture
      });
      const mesh = new Mesh$1(geometry, material);
      for (let key in options.data) mesh.userData[key] = options.data[key];
      let group = tb.Object3D({ obj: [mesh] }).setCoords(oringinCoord);
      group.userData.interval = setInterval(() => {
        texture.offset.x = (texture.offset.x - 0.01 * (options.speed || 1)) % 1;
      });
      this.group.add(group);
      return group;
    } else {
      console.error("The correct parameter for type is required!");
    }
  }
  addCircle(options) {
    let material;
    let mesh;
    const tb = this._map.tb;
    const worldUnitPerMeter = tb.projectedUnitsPerMeter(options.center[1]);
    if ("ripple" === options.type) {
      const radius = 2 * options.radius * worldUnitPerMeter;
      const geometry = new PlaneGeometry$1(radius, radius, 1, 1);
      material = new WaterRippleMaterial({
        color: typeof options.color === "number" ? options.color : new Color$1(options.color || "#FFFFFF"),
        opacity: "number" == typeof options.opacity ? options.opacity : 1,
        speed: "number" == typeof options.speed ? options.speed : 1,
        sge: "number" == typeof options.turns ? options.turns : 8,
        radius: ("number" == typeof options.radius ? options.radius : 10) * worldUnitPerMeter,
        time: 0,
        transparent: true
      });
      mesh = new Mesh$1(geometry, material);
    } else {
      if ("scan" === options.type)
        material = new ScanCircleMaterial({
          color: typeof options.color === "number" ? options.color : new Color$1(options.color || "#FFFFFF"),
          opacity: "number" == typeof options.opacity ? options.opacity : 1,
          speed: options.speed || 1
        });
      else if ("spread" === options.type)
        material = new DiffuseCircleMaterial({
          color: typeof options.color === "number" ? options.color : new Color$1(options.color || "#FFFFFF"),
          opacity: "number" == typeof options.opacity ? options.opacity : 1,
          speed: options.speed || 1
        });
      else if ("radar" === options.type) {
        material = new ScanRadarMaterial({
          color: typeof options.color === "number" ? options.color : new Color$1(options.color || "#FFFFFF"),
          opacity: "number" == typeof options.opacity ? options.opacity : 1,
          speed: options.speed || 1,
          clockwise: void 0 === options.clockwise || options.clockwise
        });
      } else {
        console.error("The correct parameter for type is required!");
        return null;
      }
      mesh = new Mesh$1(
        new CircleGeometry(
          (options.radius || 10) * worldUnitPerMeter,
          options.segment || 256
        ),
        material
      );
    }
    this._map.materialCache[this.id].push(material);
    let group = tb.Object3D({ obj: [mesh] }).setCoords(options.center);
    this.group.add(group);
    return group;
  }
  addGeoFence(options) {
    const tb = this._map.tb;
    const height = "number" == typeof options.height ? options.height : 1;
    const originCoord = options.data.coordinate[0];
    const worldUnitPerMeter = tb.projectedUnitsPerMeter(originCoord[1]);
    const originWorldUnit = tb.projectToWorld(originCoord);
    const points = [];
    for (let t3 = 0; t3 < options.data.coordinate.length; t3++) {
      const worldUnit = tb.projectToWorld(options.data.coordinate[t3]);
      points.push(
        new Vector3$1(
          worldUnit.x - originWorldUnit.x,
          worldUnit.y - originWorldUnit.y,
          worldUnit.z - originWorldUnit.z
        )
      );
    }
    let distance2 = 0;
    const uvs = [0];
    let wrapS = 1;
    for (let t3 = 0; t3 < points.length - 1; t3++) {
      distance2 += points[t3].distanceTo(points[t3 + 1]);
    }
    if (distance2 > worldUnitPerMeter * height) {
      wrapS = Math.ceil(distance2 / (worldUnitPerMeter * height));
    }
    let percent = 0;
    for (let t3 = 0; t3 < points.length - 1; t3++) {
      percent += points[t3].distanceTo(points[t3 + 1]) / distance2;
      uvs.push(percent);
    }
    const xyzArray = [];
    for (let t3 = 0; t3 < points.length; t3++) {
      xyzArray.push(points[t3].x, points[t3].y, points[t3].z);
      xyzArray.push(points[t3].x, points[t3].y, points[t3].z + worldUnitPerMeter * height);
    }
    const uvArray = [];
    for (let t3 = 0; t3 < points.length; t3++) {
      uvArray.push(uvs[t3], 0);
      uvArray.push(uvs[t3], 1);
    }
    const indexArray = [];
    for (let t3 = 0; t3 < 2 * points.length - 2; t3 += 2) {
      indexArray.push(t3, t3 + 2, t3 + 3);
      indexArray.push(t3, t3 + 3, t3 + 1);
    }
    const geometry = new BufferGeometry$1();
    geometry.setAttribute("position", new Float32BufferAttribute$1(xyzArray, 3));
    geometry.setAttribute("uv", new Float32BufferAttribute$1(uvArray, 2));
    geometry.setIndex(indexArray);
    geometry.translate(0, options.upOrDown || 0, 0);
    let material;
    if ("fade" === options.type) {
      const shape = new Shape$1(points);
      shape.holes.push(new Path$1(points));
      material = new FadeWallMaterial({
        color: typeof options.color === "number" ? options.color : new Color$1(options.color || "#FFFFFF"),
        opacity: "number" == typeof options.opacity ? options.opacity : 1,
        speed: "number" == typeof options.speed ? options.speed : 3
      });
    } else if ("diffuse" === options.type) {
      material = new FlowWallMaterial({
        color: typeof options.color === "number" ? options.color : new Color$1(options.color || "#FFFFFF"),
        opacity: "number" == typeof options.opacity ? options.opacity : 1,
        speed: "number" == typeof options.speed ? options.speed : 3
      });
    } else if ("outLine" === options.type) {
      const texture = new TextureLoader$1().load(options.imageUrl);
      if (threeVersion$1 > 151) {
        texture.colorSpace = SRGBColorSpace;
      } else {
        texture.outputEncoding = void 0;
      }
      material = new OutlineWallMaterial({
        textureMap: texture,
        gradientSpeed: "number" == typeof options.gradientSpeed ? options.gradientSpeed : 0.015,
        textureSpeed: "number" == typeof options.textureSpeed ? options.textureSpeed : 15e-4,
        gradientColor: options.gradientColor,
        imageColor: options.imageColor,
        opacity: "number" == typeof options.opacity ? options.opacity : 1,
        wrapS
      });
    } else {
      console.error("The correct parameter for type is required!");
      return null;
    }
    const mesh = new Mesh$1(geometry, material);
    mesh.frustumCulled = false;
    this._map.materialCache[this.id].push(material);
    let group = tb.Object3D({ obj: [mesh] }).setCoords(originCoord);
    this.group.add(group);
    return group;
  }
  addSphere(options) {
    const tb = this._map.tb;
    const worldUnitPerMeter = tb.projectedUnitsPerMeter(options.center[1]);
    const geometry = new SphereGeometry(
      (options.radius || 10) * worldUnitPerMeter,
      options.wSegment || 32,
      options.hSegment || 16,
      utils.radify(options.phiStart || 0),
      utils.radify(options.phiLength || 360),
      utils.radify(options.thetaStart || 0),
      utils.radify(options.thetaLength || 180)
    );
    const material = new LightningSphereMaterial({
      color: typeof options.color === "number" ? options.color : new Color$1(options.color || "#FF0000"),
      opacity: "number" == typeof options.opacity ? options.opacity : 1,
      speed: options.speed || 3
    });
    const mesh = new Mesh$1(geometry, material);
    this._map.materialCache[this.id].push(material);
    let group = tb.Object3D({ obj: [mesh] }).setCoords(options.center);
    this.group.add(group);
    return group;
  }
  addModelEffect(t3, e2) {
    return aV(t3, e2, this._map, this.id);
  }
  addDynamicWater(options) {
    const tb = this._map.tb;
    const { lngLats } = options;
    let geometry, originCoord;
    let points = [];
    if (options.geometry instanceof BufferGeometry$1) {
      geometry = options.geometry;
      originCoord = lngLats[0];
    } else if (Array.isArray(lngLats)) {
      const data = lngLats[0];
      const originWorldUnit = tb.projectToWorld(data[0][0]);
      if (1 === data.length) {
        for (let i2 = 0; i2 < data[0].length; i2++) {
          const worldUnit = tb.projectToWorld(data[0][i2]);
          points.push(
            new Vector2$1(worldUnit.x - originWorldUnit.x, worldUnit.y - originWorldUnit.y)
          );
        }
        geometry = new ShapeGeometry$1(new Shape$1(points));
      } else {
        for (let i2 = 0; i2 < data.length; i2++) {
          let points2 = [];
          for (let j = 0; j < data[i2].length; j++) {
            const worldUnit = tb.projectToWorld(data[i2][j]);
            points2.push(
              new Vector2$1(worldUnit.x - originWorldUnit.x, worldUnit.y - originWorldUnit.y)
            );
          }
          points.push(points2);
        }
        const shape = new Shape$1(points[0]);
        for (let i2 in points) {
          if (i2 > 0) {
            const path = new Path$1(points[i2]);
            shape.holes.push(path);
          }
        }
        geometry = new ShapeGeometry$1(shape);
      }
      originCoord = [data[0][0][0], data[0][0][1], data[0][0][2] || 0];
    } else {
      console.warn("no lngLats or geometry");
      return null;
    }
    const water = new Water(geometry, {
      textureWidth: options.textureSize,
      textureHeight: options.textureSize,
      waterNormals: new TextureLoader$1().load(options.waterNormals, function(texture) {
        texture.wrapS = texture.wrapT = RepeatWrapping$1;
      }),
      alpha: "number" == typeof options.opacity ? options.opacity : 1,
      sunDirection: options.sunDirection,
      sunColor: typeof options.sunColor === "number" ? options.sunColor : options.sunColor || "#ffffff",
      waterColor: typeof options.waterColor === "number" ? options.waterColor : options.waterColor || "#001e0f",
      distortionScale: options.distortionScale,
      size: options.size,
      side: DoubleSide$1,
      fog: true
    });
    this._map.materialCache[this.id].push(water.material);
    const group = tb.Object3D({ obj: [water] }).setCoords(originCoord);
    group.name = options.id;
    this.group.add(group);
    return group;
  }
  addFlame(t3) {
    let e2 = function(t4, e3, r2) {
      let i2 = e3.tb, { coordinate: n2, size: o2, imgUrl: a3 } = t4;
      var s2 = new mc().load(a3);
      let l2 = {
        defines: {
          ITERATIONS: "20",
          OCTIVES: "3"
        },
        uniforms: {
          fireTex: {
            type: "t",
            value: null
          },
          color: {
            type: "c",
            value: null
          },
          time: {
            type: "f",
            value: 0
          },
          seed: {
            type: "f",
            value: 0
          },
          invModelMatrix: {
            type: "m4",
            value: null
          },
          scale: {
            type: "v3",
            value: null
          },
          noiseScale: {
            type: "v4",
            value: new Ar(1, 2, 1, 0.3)
          },
          magnitude: {
            type: "f",
            value: 1.3
          },
          lacunarity: {
            type: "f",
            value: 2
          },
          gain: {
            type: "f",
            value: 0.5
          }
        },
        vertexShader: lF.flameShader.vertexShader,
        fragmentShader: lF.flameShader.fragmentShader
      }, h2 = new qn({
        defines: l2.defines,
        uniforms: l2.uniforms,
        vertexShader: l2.vertexShader,
        fragmentShader: l2.fragmentShader,
        transparent: true,
        depthWrite: false,
        depthTest: true
      });
      s2.magFilter = s2.minFilter = pt, s2.wrapS = s2.wrapT = lt, h2.uniforms.fireTex.value = s2, h2.uniforms.color.value = new Zi("red"), h2.uniforms.invModelMatrix.value = new ti(), h2.uniforms.scale.value = new Mr(1, 1, 1), h2.uniforms.seed.value = 19.19 * Math.random();
      let c2 = new Un(new Gn(1, 1, 1), h2);
      e3.materialCache[r2].push(h2), c2.scale.x = o2[0], c2.scale.y = o2[1], c2.scale.z = o2[2];
      let u3 = i2.Object3D({
        obj: [c2],
        units: "meters"
      }).setCoords(n2);
      return i2.add(u3), u3;
    }(t3, this._map, this.id);
    return this.group.add(e2), e2;
  }
  removeEffect(obj) {
    if (obj) {
      if (obj.userData && obj.userData.interval) {
        clearInterval(obj.userData.interval);
        delete obj.userData.interval;
      }
      let materials = obj.material;
      if (materials) {
        if (!Array.isArray(materials)) materials = [materials];
        materials.forEach((material) => {
          let index2 = this._map.materialCache[this.id].indexOf(material);
          if (index2 >= 0) this._map.materialCache[this.id].splice(index2, 1);
        });
      }
    }
  }
  _onAdd(map, gl) {
    this._map.materialCache[this.id] = [];
  }
  _onRemove(map, gl) {
    delete this._map.materialCache[this.id];
  }
}
const _object_pattern = /^[og]\s*(.+)?/;
const _material_library_pattern = /^mtllib /;
const _material_use_pattern = /^usemtl /;
const _map_use_pattern = /^usemap /;
const _face_vertex_data_separator_pattern = /\s+/;
const _vA = new Vector3$1();
const _vB = new Vector3$1();
const _vC = new Vector3$1();
const _ab = new Vector3$1();
const _cb = new Vector3$1();
const _color = new Color$1();
function ParserState() {
  const state = {
    objects: [],
    object: {},
    vertices: [],
    normals: [],
    colors: [],
    uvs: [],
    materials: {},
    materialLibraries: [],
    startObject: function(name, fromDeclaration) {
      if (this.object && this.object.fromDeclaration === false) {
        this.object.name = name;
        this.object.fromDeclaration = fromDeclaration !== false;
        return;
      }
      const previousMaterial = this.object && typeof this.object.currentMaterial === "function" ? this.object.currentMaterial() : void 0;
      if (this.object && typeof this.object._finalize === "function") {
        this.object._finalize(true);
      }
      this.object = {
        name: name || "",
        fromDeclaration: fromDeclaration !== false,
        geometry: {
          vertices: [],
          normals: [],
          colors: [],
          uvs: [],
          hasUVIndices: false
        },
        materials: [],
        smooth: true,
        startMaterial: function(name2, libraries) {
          const previous = this._finalize(false);
          if (previous && (previous.inherited || previous.groupCount <= 0)) {
            this.materials.splice(previous.index, 1);
          }
          const material = {
            index: this.materials.length,
            name: name2 || "",
            mtllib: Array.isArray(libraries) && libraries.length > 0 ? libraries[libraries.length - 1] : "",
            smooth: previous !== void 0 ? previous.smooth : this.smooth,
            groupStart: previous !== void 0 ? previous.groupEnd : 0,
            groupEnd: -1,
            groupCount: -1,
            inherited: false,
            clone: function(index2) {
              const cloned = {
                index: typeof index2 === "number" ? index2 : this.index,
                name: this.name,
                mtllib: this.mtllib,
                smooth: this.smooth,
                groupStart: 0,
                groupEnd: -1,
                groupCount: -1,
                inherited: false
              };
              cloned.clone = this.clone.bind(cloned);
              return cloned;
            }
          };
          this.materials.push(material);
          return material;
        },
        currentMaterial: function() {
          if (this.materials.length > 0) {
            return this.materials[this.materials.length - 1];
          }
          return void 0;
        },
        _finalize: function(end) {
          const lastMultiMaterial = this.currentMaterial();
          if (lastMultiMaterial && lastMultiMaterial.groupEnd === -1) {
            lastMultiMaterial.groupEnd = this.geometry.vertices.length / 3;
            lastMultiMaterial.groupCount = lastMultiMaterial.groupEnd - lastMultiMaterial.groupStart;
            lastMultiMaterial.inherited = false;
          }
          if (end && this.materials.length > 1) {
            for (let mi = this.materials.length - 1; mi >= 0; mi--) {
              if (this.materials[mi].groupCount <= 0) {
                this.materials.splice(mi, 1);
              }
            }
          }
          if (end && this.materials.length === 0) {
            this.materials.push({
              name: "",
              smooth: this.smooth
            });
          }
          return lastMultiMaterial;
        }
      };
      if (previousMaterial && previousMaterial.name && typeof previousMaterial.clone === "function") {
        const declared = previousMaterial.clone(0);
        declared.inherited = true;
        this.object.materials.push(declared);
      }
      this.objects.push(this.object);
    },
    finalize: function() {
      if (this.object && typeof this.object._finalize === "function") {
        this.object._finalize(true);
      }
    },
    parseVertexIndex: function(value, len) {
      const index2 = parseInt(value, 10);
      return (index2 >= 0 ? index2 - 1 : index2 + len / 3) * 3;
    },
    parseNormalIndex: function(value, len) {
      const index2 = parseInt(value, 10);
      return (index2 >= 0 ? index2 - 1 : index2 + len / 3) * 3;
    },
    parseUVIndex: function(value, len) {
      const index2 = parseInt(value, 10);
      return (index2 >= 0 ? index2 - 1 : index2 + len / 2) * 2;
    },
    addVertex: function(a3, b, c2) {
      const src = this.vertices;
      const dst = this.object.geometry.vertices;
      dst.push(src[a3 + 0], src[a3 + 1], src[a3 + 2]);
      dst.push(src[b + 0], src[b + 1], src[b + 2]);
      dst.push(src[c2 + 0], src[c2 + 1], src[c2 + 2]);
    },
    addVertexPoint: function(a3) {
      const src = this.vertices;
      const dst = this.object.geometry.vertices;
      dst.push(src[a3 + 0], src[a3 + 1], src[a3 + 2]);
    },
    addVertexLine: function(a3) {
      const src = this.vertices;
      const dst = this.object.geometry.vertices;
      dst.push(src[a3 + 0], src[a3 + 1], src[a3 + 2]);
    },
    addNormal: function(a3, b, c2) {
      const src = this.normals;
      const dst = this.object.geometry.normals;
      dst.push(src[a3 + 0], src[a3 + 1], src[a3 + 2]);
      dst.push(src[b + 0], src[b + 1], src[b + 2]);
      dst.push(src[c2 + 0], src[c2 + 1], src[c2 + 2]);
    },
    addFaceNormal: function(a3, b, c2) {
      const src = this.vertices;
      const dst = this.object.geometry.normals;
      _vA.fromArray(src, a3);
      _vB.fromArray(src, b);
      _vC.fromArray(src, c2);
      _cb.subVectors(_vC, _vB);
      _ab.subVectors(_vA, _vB);
      _cb.cross(_ab);
      _cb.normalize();
      dst.push(_cb.x, _cb.y, _cb.z);
      dst.push(_cb.x, _cb.y, _cb.z);
      dst.push(_cb.x, _cb.y, _cb.z);
    },
    addColor: function(a3, b, c2) {
      const src = this.colors;
      const dst = this.object.geometry.colors;
      if (src[a3] !== void 0) dst.push(src[a3 + 0], src[a3 + 1], src[a3 + 2]);
      if (src[b] !== void 0) dst.push(src[b + 0], src[b + 1], src[b + 2]);
      if (src[c2] !== void 0) dst.push(src[c2 + 0], src[c2 + 1], src[c2 + 2]);
    },
    addUV: function(a3, b, c2) {
      const src = this.uvs;
      const dst = this.object.geometry.uvs;
      dst.push(src[a3 + 0], src[a3 + 1]);
      dst.push(src[b + 0], src[b + 1]);
      dst.push(src[c2 + 0], src[c2 + 1]);
    },
    addDefaultUV: function() {
      const dst = this.object.geometry.uvs;
      dst.push(0, 0);
      dst.push(0, 0);
      dst.push(0, 0);
    },
    addUVLine: function(a3) {
      const src = this.uvs;
      const dst = this.object.geometry.uvs;
      dst.push(src[a3 + 0], src[a3 + 1]);
    },
    addFace: function(a3, b, c2, ua, ub, uc, na, nb, nc) {
      const vLen = this.vertices.length;
      let ia = this.parseVertexIndex(a3, vLen);
      let ib = this.parseVertexIndex(b, vLen);
      let ic = this.parseVertexIndex(c2, vLen);
      this.addVertex(ia, ib, ic);
      this.addColor(ia, ib, ic);
      if (na !== void 0 && na !== "") {
        const nLen = this.normals.length;
        ia = this.parseNormalIndex(na, nLen);
        ib = this.parseNormalIndex(nb, nLen);
        ic = this.parseNormalIndex(nc, nLen);
        this.addNormal(ia, ib, ic);
      } else {
        this.addFaceNormal(ia, ib, ic);
      }
      if (ua !== void 0 && ua !== "") {
        const uvLen = this.uvs.length;
        ia = this.parseUVIndex(ua, uvLen);
        ib = this.parseUVIndex(ub, uvLen);
        ic = this.parseUVIndex(uc, uvLen);
        this.addUV(ia, ib, ic);
        this.object.geometry.hasUVIndices = true;
      } else {
        this.addDefaultUV();
      }
    },
    addPointGeometry: function(vertices) {
      this.object.geometry.type = "Points";
      const vLen = this.vertices.length;
      for (let vi = 0, l2 = vertices.length; vi < l2; vi++) {
        const index2 = this.parseVertexIndex(vertices[vi], vLen);
        this.addVertexPoint(index2);
        this.addColor(index2);
      }
    },
    addLineGeometry: function(vertices, uvs) {
      this.object.geometry.type = "Line";
      const vLen = this.vertices.length;
      const uvLen = this.uvs.length;
      for (let vi = 0, l2 = vertices.length; vi < l2; vi++) {
        this.addVertexLine(this.parseVertexIndex(vertices[vi], vLen));
      }
      for (let uvi = 0, l2 = uvs.length; uvi < l2; uvi++) {
        this.addUVLine(this.parseUVIndex(uvs[uvi], uvLen));
      }
    }
  };
  state.startObject("", false);
  return state;
}
class OBJLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
    this.materials = null;
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const loader = new FileLoader$1(this.manager);
    loader.setPath(this.path);
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(url, function(text) {
      try {
        onLoad(scope.parse(text));
      } catch (e2) {
        if (onError) {
          onError(e2);
        } else {
          console.error(e2);
        }
        scope.manager.itemError(url);
      }
    }, onProgress, onError);
  }
  setMaterials(materials) {
    this.materials = materials;
    return this;
  }
  parse(text) {
    const state = new ParserState();
    if (text.indexOf("\r\n") !== -1) {
      text = text.replace(/\r\n/g, "\n");
    }
    if (text.indexOf("\\\n") !== -1) {
      text = text.replace(/\\\n/g, "");
    }
    const lines = text.split("\n");
    let result = [];
    for (let i2 = 0, l2 = lines.length; i2 < l2; i2++) {
      const line = lines[i2].trimStart();
      if (line.length === 0) continue;
      const lineFirstChar = line.charAt(0);
      if (lineFirstChar === "#") continue;
      if (lineFirstChar === "v") {
        const data = line.split(_face_vertex_data_separator_pattern);
        switch (data[0]) {
          case "v":
            state.vertices.push(
              parseFloat(data[1]),
              parseFloat(data[2]),
              parseFloat(data[3])
            );
            if (data.length >= 7) {
              _color.setRGB(
                parseFloat(data[4]),
                parseFloat(data[5]),
                parseFloat(data[6]),
                SRGBColorSpace
              );
              state.colors.push(_color.r, _color.g, _color.b);
            } else {
              state.colors.push(void 0, void 0, void 0);
            }
            break;
          case "vn":
            state.normals.push(
              parseFloat(data[1]),
              parseFloat(data[2]),
              parseFloat(data[3])
            );
            break;
          case "vt":
            state.uvs.push(
              parseFloat(data[1]),
              parseFloat(data[2])
            );
            break;
        }
      } else if (lineFirstChar === "f") {
        const lineData = line.slice(1).trim();
        const vertexData = lineData.split(_face_vertex_data_separator_pattern);
        const faceVertices = [];
        for (let j = 0, jl = vertexData.length; j < jl; j++) {
          const vertex2 = vertexData[j];
          if (vertex2.length > 0) {
            const vertexParts = vertex2.split("/");
            faceVertices.push(vertexParts);
          }
        }
        const v1 = faceVertices[0];
        for (let j = 1, jl = faceVertices.length - 1; j < jl; j++) {
          const v2 = faceVertices[j];
          const v3 = faceVertices[j + 1];
          state.addFace(
            v1[0],
            v2[0],
            v3[0],
            v1[1],
            v2[1],
            v3[1],
            v1[2],
            v2[2],
            v3[2]
          );
        }
      } else if (lineFirstChar === "l") {
        const lineParts = line.substring(1).trim().split(" ");
        let lineVertices = [];
        const lineUVs = [];
        if (line.indexOf("/") === -1) {
          lineVertices = lineParts;
        } else {
          for (let li = 0, llen = lineParts.length; li < llen; li++) {
            const parts = lineParts[li].split("/");
            if (parts[0] !== "") lineVertices.push(parts[0]);
            if (parts[1] !== "") lineUVs.push(parts[1]);
          }
        }
        state.addLineGeometry(lineVertices, lineUVs);
      } else if (lineFirstChar === "p") {
        const lineData = line.slice(1).trim();
        const pointData = lineData.split(" ");
        state.addPointGeometry(pointData);
      } else if ((result = _object_pattern.exec(line)) !== null) {
        const name = (" " + result[0].slice(1).trim()).slice(1);
        state.startObject(name);
      } else if (_material_use_pattern.test(line)) {
        state.object.startMaterial(line.substring(7).trim(), state.materialLibraries);
      } else if (_material_library_pattern.test(line)) {
        state.materialLibraries.push(line.substring(7).trim());
      } else if (_map_use_pattern.test(line)) {
        console.warn('THREE.OBJLoader: Rendering identifier "usemap" not supported. Textures must be defined in MTL files.');
      } else if (lineFirstChar === "s") {
        result = line.split(" ");
        if (result.length > 1) {
          const value = result[1].trim().toLowerCase();
          state.object.smooth = value !== "0" && value !== "off";
        } else {
          state.object.smooth = true;
        }
        const material = state.object.currentMaterial();
        if (material) material.smooth = state.object.smooth;
      } else {
        if (line === "\0") continue;
        console.warn('THREE.OBJLoader: Unexpected line: "' + line + '"');
      }
    }
    state.finalize();
    const container = new Group$1();
    container.materialLibraries = [].concat(state.materialLibraries);
    const hasPrimitives = !(state.objects.length === 1 && state.objects[0].geometry.vertices.length === 0);
    if (hasPrimitives === true) {
      for (let i2 = 0, l2 = state.objects.length; i2 < l2; i2++) {
        const object = state.objects[i2];
        const geometry = object.geometry;
        const materials = object.materials;
        const isLine = geometry.type === "Line";
        const isPoints = geometry.type === "Points";
        let hasVertexColors = false;
        if (geometry.vertices.length === 0) continue;
        const buffergeometry = new BufferGeometry$1();
        buffergeometry.setAttribute("position", new Float32BufferAttribute$1(geometry.vertices, 3));
        if (geometry.normals.length > 0) {
          buffergeometry.setAttribute("normal", new Float32BufferAttribute$1(geometry.normals, 3));
        }
        if (geometry.colors.length > 0) {
          hasVertexColors = true;
          buffergeometry.setAttribute("color", new Float32BufferAttribute$1(geometry.colors, 3));
        }
        if (geometry.hasUVIndices === true) {
          buffergeometry.setAttribute("uv", new Float32BufferAttribute$1(geometry.uvs, 2));
        }
        const createdMaterials = [];
        for (let mi = 0, miLen = materials.length; mi < miLen; mi++) {
          const sourceMaterial = materials[mi];
          const materialHash = sourceMaterial.name + "_" + sourceMaterial.smooth + "_" + hasVertexColors;
          let material = state.materials[materialHash];
          if (this.materials !== null) {
            material = this.materials.create(sourceMaterial.name);
            if (isLine && material && !(material instanceof LineBasicMaterial$1)) {
              const materialLine = new LineBasicMaterial$1();
              Material$1.prototype.copy.call(materialLine, material);
              materialLine.color.copy(material.color);
              material = materialLine;
            } else if (isPoints && material && !(material instanceof PointsMaterial$1)) {
              const materialPoints = new PointsMaterial$1({ size: 10, sizeAttenuation: false });
              Material$1.prototype.copy.call(materialPoints, material);
              materialPoints.color.copy(material.color);
              materialPoints.map = material.map;
              material = materialPoints;
            }
          }
          if (material === void 0) {
            if (isLine) {
              material = new LineBasicMaterial$1();
            } else if (isPoints) {
              material = new PointsMaterial$1({ size: 1, sizeAttenuation: false });
            } else {
              material = new MeshPhongMaterial$1();
            }
            material.name = sourceMaterial.name;
            material.flatShading = sourceMaterial.smooth ? false : true;
            material.vertexColors = hasVertexColors;
            state.materials[materialHash] = material;
          }
          createdMaterials.push(material);
        }
        let mesh;
        if (createdMaterials.length > 1) {
          for (let mi = 0, miLen = materials.length; mi < miLen; mi++) {
            const sourceMaterial = materials[mi];
            buffergeometry.addGroup(sourceMaterial.groupStart, sourceMaterial.groupCount, mi);
          }
          if (isLine) {
            mesh = new LineSegments$1(buffergeometry, createdMaterials);
          } else if (isPoints) {
            mesh = new Points$1(buffergeometry, createdMaterials);
          } else {
            mesh = new Mesh$1(buffergeometry, createdMaterials);
          }
        } else {
          if (isLine) {
            mesh = new LineSegments$1(buffergeometry, createdMaterials[0]);
          } else if (isPoints) {
            mesh = new Points$1(buffergeometry, createdMaterials[0]);
          } else {
            mesh = new Mesh$1(buffergeometry, createdMaterials[0]);
          }
        }
        mesh.name = object.name;
        container.add(mesh);
      }
    } else {
      if (state.vertices.length > 0) {
        const material = new PointsMaterial$1({ size: 1, sizeAttenuation: false });
        const buffergeometry = new BufferGeometry$1();
        buffergeometry.setAttribute("position", new Float32BufferAttribute$1(state.vertices, 3));
        if (state.colors.length > 0 && state.colors[0] !== void 0) {
          buffergeometry.setAttribute("color", new Float32BufferAttribute$1(state.colors, 3));
          material.vertexColors = true;
        }
        const points = new Points$1(buffergeometry, material);
        container.add(points);
      }
    }
    return container;
  }
}
class MTLLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  /**
   * Loads and parses a MTL asset from a URL.
   *
   * @param {String} url - URL to the MTL file.
   * @param {Function} [onLoad] - Callback invoked with the loaded object.
   * @param {Function} [onProgress] - Callback for download progress.
   * @param {Function} [onError] - Callback for download errors.
   *
   * @see setPath setResourcePath
   *
   * @note In order for relative texture references to resolve correctly
   * you must call setResourcePath() explicitly prior to load.
   */
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const path = this.path === "" ? LoaderUtils$1.extractUrlBase(url) : this.path;
    const loader = new FileLoader$1(this.manager);
    loader.setPath(this.path);
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(url, function(text) {
      try {
        onLoad(scope.parse(text, path));
      } catch (e2) {
        if (onError) {
          onError(e2);
        } else {
          console.error(e2);
        }
        scope.manager.itemError(url);
      }
    }, onProgress, onError);
  }
  setMaterialOptions(value) {
    this.materialOptions = value;
    return this;
  }
  /**
   * Parses a MTL file.
   *
   * @param {String} text - Content of MTL file
   * @return {MaterialCreator}
   *
   * @see setPath setResourcePath
   *
   * @note In order for relative texture references to resolve correctly
   * you must call setResourcePath() explicitly prior to parse.
   */
  parse(text, path) {
    const lines = text.split("\n");
    let info = {};
    const delimiter_pattern = /\s+/;
    const materialsInfo = {};
    for (let i2 = 0; i2 < lines.length; i2++) {
      let line = lines[i2];
      line = line.trim();
      if (line.length === 0 || line.charAt(0) === "#") {
        continue;
      }
      const pos = line.indexOf(" ");
      let key = pos >= 0 ? line.substring(0, pos) : line;
      key = key.toLowerCase();
      let value = pos >= 0 ? line.substring(pos + 1) : "";
      value = value.trim();
      if (key === "newmtl") {
        info = { name: value };
        materialsInfo[value] = info;
      } else {
        if (key === "ka" || key === "kd" || key === "ks" || key === "ke") {
          const ss = value.split(delimiter_pattern, 3);
          info[key] = [parseFloat(ss[0]), parseFloat(ss[1]), parseFloat(ss[2])];
        } else {
          info[key] = value;
        }
      }
    }
    const materialCreator = new MaterialCreator(this.resourcePath || path, this.materialOptions);
    materialCreator.setCrossOrigin(this.crossOrigin);
    materialCreator.setManager(this.manager);
    materialCreator.setMaterials(materialsInfo);
    return materialCreator;
  }
}
class MaterialCreator {
  constructor(baseUrl = "", options = {}) {
    this.baseUrl = baseUrl;
    this.options = options;
    this.materialsInfo = {};
    this.materials = {};
    this.materialsArray = [];
    this.nameLookup = {};
    this.crossOrigin = "anonymous";
    this.side = this.options.side !== void 0 ? this.options.side : FrontSide$1;
    this.wrap = this.options.wrap !== void 0 ? this.options.wrap : RepeatWrapping$1;
  }
  setCrossOrigin(value) {
    this.crossOrigin = value;
    return this;
  }
  setManager(value) {
    this.manager = value;
  }
  setMaterials(materialsInfo) {
    this.materialsInfo = this.convert(materialsInfo);
    this.materials = {};
    this.materialsArray = [];
    this.nameLookup = {};
  }
  convert(materialsInfo) {
    if (!this.options) return materialsInfo;
    const converted = {};
    for (const mn in materialsInfo) {
      const mat = materialsInfo[mn];
      const covmat = {};
      converted[mn] = covmat;
      for (const prop in mat) {
        let save = true;
        let value = mat[prop];
        const lprop = prop.toLowerCase();
        switch (lprop) {
          case "kd":
          case "ka":
          case "ks":
            if (this.options && this.options.normalizeRGB) {
              value = [value[0] / 255, value[1] / 255, value[2] / 255];
            }
            if (this.options && this.options.ignoreZeroRGBs) {
              if (value[0] === 0 && value[1] === 0 && value[2] === 0) {
                save = false;
              }
            }
            break;
        }
        if (save) {
          covmat[lprop] = value;
        }
      }
    }
    return converted;
  }
  preload() {
    for (const mn in this.materialsInfo) {
      this.create(mn);
    }
  }
  getIndex(materialName) {
    return this.nameLookup[materialName];
  }
  getAsArray() {
    let index2 = 0;
    for (const mn in this.materialsInfo) {
      this.materialsArray[index2] = this.create(mn);
      this.nameLookup[mn] = index2;
      index2++;
    }
    return this.materialsArray;
  }
  create(materialName) {
    if (this.materials[materialName] === void 0) {
      this.createMaterial_(materialName);
    }
    return this.materials[materialName];
  }
  createMaterial_(materialName) {
    const scope = this;
    const mat = this.materialsInfo[materialName];
    const params = {
      name: materialName,
      side: this.side
    };
    function resolveURL(baseUrl, url) {
      if (typeof url !== "string" || url === "")
        return "";
      if (/^https?:\/\//i.test(url)) return url;
      return baseUrl + url;
    }
    function setMapForType(mapType, value) {
      if (params[mapType]) return;
      const texParams = scope.getTextureParams(value, params);
      const map = scope.loadTexture(resolveURL(scope.baseUrl, texParams.url));
      map.repeat.copy(texParams.scale);
      map.offset.copy(texParams.offset);
      map.wrapS = scope.wrap;
      map.wrapT = scope.wrap;
      if (mapType === "map" || mapType === "emissiveMap") {
        map.colorSpace = SRGBColorSpace;
      }
      params[mapType] = map;
    }
    for (const prop in mat) {
      const value = mat[prop];
      let n2;
      if (value === "") continue;
      switch (prop.toLowerCase()) {
        case "kd":
          params.color = ColorManagement.toWorkingColorSpace(new Color$1().fromArray(value), SRGBColorSpace);
          break;
        case "ks":
          params.specular = ColorManagement.toWorkingColorSpace(new Color$1().fromArray(value), SRGBColorSpace);
          break;
        case "ke":
          params.emissive = ColorManagement.toWorkingColorSpace(new Color$1().fromArray(value), SRGBColorSpace);
          break;
        case "map_kd":
          setMapForType("map", value);
          break;
        case "map_ks":
          setMapForType("specularMap", value);
          break;
        case "map_ke":
          setMapForType("emissiveMap", value);
          break;
        case "norm":
          setMapForType("normalMap", value);
          break;
        case "map_bump":
        case "bump":
          setMapForType("bumpMap", value);
          break;
        case "map_d":
          setMapForType("alphaMap", value);
          params.transparent = true;
          break;
        case "ns":
          params.shininess = parseFloat(value);
          break;
        case "d":
          n2 = parseFloat(value);
          if (n2 < 1) {
            params.opacity = n2;
            params.transparent = true;
          }
          break;
        case "tr":
          n2 = parseFloat(value);
          if (this.options && this.options.invertTrProperty) n2 = 1 - n2;
          if (n2 > 0) {
            params.opacity = 1 - n2;
            params.transparent = true;
          }
          break;
      }
    }
    this.materials[materialName] = new MeshPhongMaterial$1(params);
    return this.materials[materialName];
  }
  getTextureParams(value, matParams) {
    const texParams = {
      scale: new Vector2$1(1, 1),
      offset: new Vector2$1(0, 0)
    };
    const items = value.split(/\s+/);
    let pos;
    pos = items.indexOf("-bm");
    if (pos >= 0) {
      matParams.bumpScale = parseFloat(items[pos + 1]);
      items.splice(pos, 2);
    }
    pos = items.indexOf("-s");
    if (pos >= 0) {
      texParams.scale.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
      items.splice(pos, 4);
    }
    pos = items.indexOf("-o");
    if (pos >= 0) {
      texParams.offset.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
      items.splice(pos, 4);
    }
    texParams.url = items.join(" ").trim();
    return texParams;
  }
  loadTexture(url, mapping, onLoad, onProgress, onError) {
    const manager = this.manager !== void 0 ? this.manager : DefaultLoadingManager$1;
    let loader = manager.getHandler(url);
    if (loader === null) {
      loader = new TextureLoader$1(manager);
    }
    if (loader.setCrossOrigin) loader.setCrossOrigin(this.crossOrigin);
    const texture = loader.load(url, onLoad, onProgress, onError);
    if (mapping !== void 0) texture.mapping = mapping;
    return texture;
  }
}
/*!
fflate - fast JavaScript compression/decompression
<https://101arrowz.github.io/fflate>
Licensed under MIT. https://github.com/101arrowz/fflate/blob/master/LICENSE
version 0.8.2
*/
var u8 = Uint8Array, u16 = Uint16Array, i32 = Int32Array;
var fleb = new u8([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]);
var fdeb = new u8([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]);
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
var freb = function(eb, start) {
  var b = new u16(31);
  for (var i2 = 0; i2 < 31; ++i2) {
    b[i2] = start += 1 << eb[i2 - 1];
  }
  var r2 = new i32(b[30]);
  for (var i2 = 1; i2 < 30; ++i2) {
    for (var j = b[i2]; j < b[i2 + 1]; ++j) {
      r2[j] = j - b[i2] << 5 | i2;
    }
  }
  return { b, r: r2 };
};
var _a = freb(fleb, 2), fl = _a.b, revfl = _a.r;
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b.b;
var rev = new u16(32768);
for (var i$4 = 0; i$4 < 32768; ++i$4) {
  var x = (i$4 & 43690) >> 1 | (i$4 & 21845) << 1;
  x = (x & 52428) >> 2 | (x & 13107) << 2;
  x = (x & 61680) >> 4 | (x & 3855) << 4;
  rev[i$4] = ((x & 65280) >> 8 | (x & 255) << 8) >> 1;
}
var hMap = function(cd, mb, r2) {
  var s2 = cd.length;
  var i2 = 0;
  var l2 = new u16(mb);
  for (; i2 < s2; ++i2) {
    if (cd[i2])
      ++l2[cd[i2] - 1];
  }
  var le = new u16(mb);
  for (i2 = 1; i2 < mb; ++i2) {
    le[i2] = le[i2 - 1] + l2[i2 - 1] << 1;
  }
  var co;
  if (r2) {
    co = new u16(1 << mb);
    var rvb = 15 - mb;
    for (i2 = 0; i2 < s2; ++i2) {
      if (cd[i2]) {
        var sv = i2 << 4 | cd[i2];
        var r_1 = mb - cd[i2];
        var v = le[cd[i2] - 1]++ << r_1;
        for (var m = v | (1 << r_1) - 1; v <= m; ++v) {
          co[rev[v] >> rvb] = sv;
        }
      }
    }
  } else {
    co = new u16(s2);
    for (i2 = 0; i2 < s2; ++i2) {
      if (cd[i2]) {
        co[i2] = rev[le[cd[i2] - 1]++] >> 15 - cd[i2];
      }
    }
  }
  return co;
};
var flt = new u8(288);
for (var i$4 = 0; i$4 < 144; ++i$4)
  flt[i$4] = 8;
for (var i$4 = 144; i$4 < 256; ++i$4)
  flt[i$4] = 9;
for (var i$4 = 256; i$4 < 280; ++i$4)
  flt[i$4] = 7;
for (var i$4 = 280; i$4 < 288; ++i$4)
  flt[i$4] = 8;
var fdt = new u8(32);
for (var i$4 = 0; i$4 < 32; ++i$4)
  fdt[i$4] = 5;
var flrm = /* @__PURE__ */ hMap(flt, 9, 1);
var fdrm = /* @__PURE__ */ hMap(fdt, 5, 1);
var max = function(a3) {
  var m = a3[0];
  for (var i2 = 1; i2 < a3.length; ++i2) {
    if (a3[i2] > m)
      m = a3[i2];
  }
  return m;
};
var bits = function(d2, p2, m) {
  var o2 = p2 / 8 | 0;
  return (d2[o2] | d2[o2 + 1] << 8) >> (p2 & 7) & m;
};
var bits16 = function(d2, p2) {
  var o2 = p2 / 8 | 0;
  return (d2[o2] | d2[o2 + 1] << 8 | d2[o2 + 2] << 16) >> (p2 & 7);
};
var shft = function(p2) {
  return (p2 + 7) / 8 | 0;
};
var slc = function(v, s2, e2) {
  if (e2 == null || e2 > v.length)
    e2 = v.length;
  return new u8(v.subarray(s2, e2));
};
var ec = [
  "unexpected EOF",
  "invalid block type",
  "invalid length/literal",
  "invalid distance",
  "stream finished",
  "no stream handler",
  ,
  "no callback",
  "invalid UTF-8 data",
  "extra field too long",
  "date not in range 1980-2099",
  "filename too long",
  "stream finishing",
  "invalid zip data"
  // determined by unknown compression method
];
var err = function(ind, msg, nt) {
  var e2 = new Error(msg || ec[ind]);
  e2.code = ind;
  if (Error.captureStackTrace)
    Error.captureStackTrace(e2, err);
  if (!nt)
    throw e2;
  return e2;
};
var inflt = function(dat, st, buf, dict) {
  var sl = dat.length, dl = 0;
  if (!sl || st.f && !st.l)
    return buf || new u8(0);
  var noBuf = !buf;
  var resize = noBuf || st.i != 2;
  var noSt = st.i;
  if (noBuf)
    buf = new u8(sl * 3);
  var cbuf = function(l3) {
    var bl = buf.length;
    if (l3 > bl) {
      var nbuf = new u8(Math.max(bl * 2, l3));
      nbuf.set(buf);
      buf = nbuf;
    }
  };
  var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
  var tbts = sl * 8;
  do {
    if (!lm) {
      final = bits(dat, pos, 1);
      var type = bits(dat, pos + 1, 3);
      pos += 3;
      if (!type) {
        var s2 = shft(pos) + 4, l2 = dat[s2 - 4] | dat[s2 - 3] << 8, t3 = s2 + l2;
        if (t3 > sl) {
          if (noSt)
            err(0);
          break;
        }
        if (resize)
          cbuf(bt + l2);
        buf.set(dat.subarray(s2, t3), bt);
        st.b = bt += l2, st.p = pos = t3 * 8, st.f = final;
        continue;
      } else if (type == 1)
        lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
      else if (type == 2) {
        var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
        var tl = hLit + bits(dat, pos + 5, 31) + 1;
        pos += 14;
        var ldt = new u8(tl);
        var clt = new u8(19);
        for (var i2 = 0; i2 < hcLen; ++i2) {
          clt[clim[i2]] = bits(dat, pos + i2 * 3, 7);
        }
        pos += hcLen * 3;
        var clb = max(clt), clbmsk = (1 << clb) - 1;
        var clm = hMap(clt, clb, 1);
        for (var i2 = 0; i2 < tl; ) {
          var r2 = clm[bits(dat, pos, clbmsk)];
          pos += r2 & 15;
          var s2 = r2 >> 4;
          if (s2 < 16) {
            ldt[i2++] = s2;
          } else {
            var c2 = 0, n2 = 0;
            if (s2 == 16)
              n2 = 3 + bits(dat, pos, 3), pos += 2, c2 = ldt[i2 - 1];
            else if (s2 == 17)
              n2 = 3 + bits(dat, pos, 7), pos += 3;
            else if (s2 == 18)
              n2 = 11 + bits(dat, pos, 127), pos += 7;
            while (n2--)
              ldt[i2++] = c2;
          }
        }
        var lt2 = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
        lbt = max(lt2);
        dbt = max(dt);
        lm = hMap(lt2, lbt, 1);
        dm = hMap(dt, dbt, 1);
      } else
        err(1);
      if (pos > tbts) {
        if (noSt)
          err(0);
        break;
      }
    }
    if (resize)
      cbuf(bt + 131072);
    var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
    var lpos = pos;
    for (; ; lpos = pos) {
      var c2 = lm[bits16(dat, pos) & lms], sym = c2 >> 4;
      pos += c2 & 15;
      if (pos > tbts) {
        if (noSt)
          err(0);
        break;
      }
      if (!c2)
        err(2);
      if (sym < 256)
        buf[bt++] = sym;
      else if (sym == 256) {
        lpos = pos, lm = null;
        break;
      } else {
        var add = sym - 254;
        if (sym > 264) {
          var i2 = sym - 257, b = fleb[i2];
          add = bits(dat, pos, (1 << b) - 1) + fl[i2];
          pos += b;
        }
        var d2 = dm[bits16(dat, pos) & dms], dsym = d2 >> 4;
        if (!d2)
          err(3);
        pos += d2 & 15;
        var dt = fd[dsym];
        if (dsym > 3) {
          var b = fdeb[dsym];
          dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
        }
        if (pos > tbts) {
          if (noSt)
            err(0);
          break;
        }
        if (resize)
          cbuf(bt + 131072);
        var end = bt + add;
        if (bt < dt) {
          var shift = dl - dt, dend = Math.min(dt, end);
          if (shift + bt < 0)
            err(3);
          for (; bt < dend; ++bt)
            buf[bt] = dict[shift + bt];
        }
        for (; bt < end; ++bt)
          buf[bt] = buf[bt - dt];
      }
    }
    st.l = lm, st.p = lpos, st.b = bt, st.f = final;
    if (lm)
      final = 1, st.m = lbt, st.d = dm, st.n = dbt;
  } while (!final);
  return bt != buf.length && noBuf ? slc(buf, 0, bt) : buf.subarray(0, bt);
};
var et = /* @__PURE__ */ new u8(0);
var zls = function(d2, dict) {
  if ((d2[0] & 15) != 8 || d2[0] >> 4 > 7 || (d2[0] << 8 | d2[1]) % 31)
    err(6, "invalid zlib data");
  if ((d2[1] >> 5 & 1) == 1)
    err(6, "invalid zlib data: " + (d2[1] & 32 ? "need" : "unexpected") + " dictionary");
  return (d2[1] >> 3 & 4) + 2;
};
function unzlibSync(data, opts) {
  return inflt(data.subarray(zls(data), -4), { i: 2 }, opts, opts);
}
var td = typeof TextDecoder != "undefined" && /* @__PURE__ */ new TextDecoder();
var tds = 0;
try {
  td.decode(et, { stream: true });
  tds = 1;
} catch (e2) {
}
function findSpan(p2, u3, U2) {
  const n2 = U2.length - p2 - 1;
  if (u3 >= U2[n2]) {
    return n2 - 1;
  }
  if (u3 <= U2[p2]) {
    return p2;
  }
  let low = p2;
  let high = n2;
  let mid = Math.floor((low + high) / 2);
  while (u3 < U2[mid] || u3 >= U2[mid + 1]) {
    if (u3 < U2[mid]) {
      high = mid;
    } else {
      low = mid;
    }
    mid = Math.floor((low + high) / 2);
  }
  return mid;
}
function calcBasisFunctions(span, u3, p2, U2) {
  const N = [];
  const left = [];
  const right = [];
  N[0] = 1;
  for (let j = 1; j <= p2; ++j) {
    left[j] = u3 - U2[span + 1 - j];
    right[j] = U2[span + j] - u3;
    let saved = 0;
    for (let r2 = 0; r2 < j; ++r2) {
      const rv = right[r2 + 1];
      const lv = left[j - r2];
      const temp5 = N[r2] / (rv + lv);
      N[r2] = saved + rv * temp5;
      saved = lv * temp5;
    }
    N[j] = saved;
  }
  return N;
}
function calcBSplinePoint(p2, U2, P, u3) {
  const span = findSpan(p2, u3, U2);
  const N = calcBasisFunctions(span, u3, p2, U2);
  const C2 = new Vector4$1(0, 0, 0, 0);
  for (let j = 0; j <= p2; ++j) {
    const point2 = P[span - p2 + j];
    const Nj = N[j];
    const wNj = point2.w * Nj;
    C2.x += point2.x * wNj;
    C2.y += point2.y * wNj;
    C2.z += point2.z * wNj;
    C2.w += point2.w * Nj;
  }
  return C2;
}
function calcBasisFunctionDerivatives(span, u3, p2, n2, U2) {
  const zeroArr = [];
  for (let i2 = 0; i2 <= p2; ++i2)
    zeroArr[i2] = 0;
  const ders = [];
  for (let i2 = 0; i2 <= n2; ++i2)
    ders[i2] = zeroArr.slice(0);
  const ndu = [];
  for (let i2 = 0; i2 <= p2; ++i2)
    ndu[i2] = zeroArr.slice(0);
  ndu[0][0] = 1;
  const left = zeroArr.slice(0);
  const right = zeroArr.slice(0);
  for (let j = 1; j <= p2; ++j) {
    left[j] = u3 - U2[span + 1 - j];
    right[j] = U2[span + j] - u3;
    let saved = 0;
    for (let r3 = 0; r3 < j; ++r3) {
      const rv = right[r3 + 1];
      const lv = left[j - r3];
      ndu[j][r3] = rv + lv;
      const temp5 = ndu[r3][j - 1] / ndu[j][r3];
      ndu[r3][j] = saved + rv * temp5;
      saved = lv * temp5;
    }
    ndu[j][j] = saved;
  }
  for (let j = 0; j <= p2; ++j) {
    ders[0][j] = ndu[j][p2];
  }
  for (let r3 = 0; r3 <= p2; ++r3) {
    let s1 = 0;
    let s2 = 1;
    const a3 = [];
    for (let i2 = 0; i2 <= p2; ++i2) {
      a3[i2] = zeroArr.slice(0);
    }
    a3[0][0] = 1;
    for (let k = 1; k <= n2; ++k) {
      let d2 = 0;
      const rk = r3 - k;
      const pk = p2 - k;
      if (r3 >= k) {
        a3[s2][0] = a3[s1][0] / ndu[pk + 1][rk];
        d2 = a3[s2][0] * ndu[rk][pk];
      }
      const j1 = rk >= -1 ? 1 : -rk;
      const j2 = r3 - 1 <= pk ? k - 1 : p2 - r3;
      for (let j3 = j1; j3 <= j2; ++j3) {
        a3[s2][j3] = (a3[s1][j3] - a3[s1][j3 - 1]) / ndu[pk + 1][rk + j3];
        d2 += a3[s2][j3] * ndu[rk + j3][pk];
      }
      if (r3 <= pk) {
        a3[s2][k] = -a3[s1][k - 1] / ndu[pk + 1][r3];
        d2 += a3[s2][k] * ndu[r3][pk];
      }
      ders[k][r3] = d2;
      const j = s1;
      s1 = s2;
      s2 = j;
    }
  }
  let r2 = p2;
  for (let k = 1; k <= n2; ++k) {
    for (let j = 0; j <= p2; ++j) {
      ders[k][j] *= r2;
    }
    r2 *= p2 - k;
  }
  return ders;
}
function calcBSplineDerivatives(p2, U2, P, u3, nd) {
  const du = nd < p2 ? nd : p2;
  const CK = [];
  const span = findSpan(p2, u3, U2);
  const nders = calcBasisFunctionDerivatives(span, u3, p2, du, U2);
  const Pw = [];
  for (let i2 = 0; i2 < P.length; ++i2) {
    const point2 = P[i2].clone();
    const w = point2.w;
    point2.x *= w;
    point2.y *= w;
    point2.z *= w;
    Pw[i2] = point2;
  }
  for (let k = 0; k <= du; ++k) {
    const point2 = Pw[span - p2].clone().multiplyScalar(nders[k][0]);
    for (let j = 1; j <= p2; ++j) {
      point2.add(Pw[span - p2 + j].clone().multiplyScalar(nders[k][j]));
    }
    CK[k] = point2;
  }
  for (let k = du + 1; k <= nd + 1; ++k) {
    CK[k] = new Vector4$1(0, 0, 0);
  }
  return CK;
}
function calcKoverI(k, i2) {
  let nom = 1;
  for (let j = 2; j <= k; ++j) {
    nom *= j;
  }
  let denom = 1;
  for (let j = 2; j <= i2; ++j) {
    denom *= j;
  }
  for (let j = 2; j <= k - i2; ++j) {
    denom *= j;
  }
  return nom / denom;
}
function calcRationalCurveDerivatives(Pders) {
  const nd = Pders.length;
  const Aders = [];
  const wders = [];
  for (let i2 = 0; i2 < nd; ++i2) {
    const point2 = Pders[i2];
    Aders[i2] = new Vector3$1(point2.x, point2.y, point2.z);
    wders[i2] = point2.w;
  }
  const CK = [];
  for (let k = 0; k < nd; ++k) {
    const v = Aders[k].clone();
    for (let i2 = 1; i2 <= k; ++i2) {
      v.sub(CK[k - i2].clone().multiplyScalar(calcKoverI(k, i2) * wders[i2]));
    }
    CK[k] = v.divideScalar(wders[0]);
  }
  return CK;
}
function calcNURBSDerivatives(p2, U2, P, u3, nd) {
  const Pders = calcBSplineDerivatives(p2, U2, P, u3, nd);
  return calcRationalCurveDerivatives(Pders);
}
class NURBSCurve extends Curve$1 {
  constructor(degree, knots, controlPoints, startKnot, endKnot) {
    super();
    const knotsLength = knots ? knots.length - 1 : 0;
    const pointsLength = controlPoints ? controlPoints.length : 0;
    this.degree = degree;
    this.knots = knots;
    this.controlPoints = [];
    this.startKnot = startKnot || 0;
    this.endKnot = endKnot || knotsLength;
    for (let i2 = 0; i2 < pointsLength; ++i2) {
      const point2 = controlPoints[i2];
      this.controlPoints[i2] = new Vector4$1(point2.x, point2.y, point2.z, point2.w);
    }
  }
  getPoint(t3, optionalTarget = new Vector3$1()) {
    const point2 = optionalTarget;
    const u3 = this.knots[this.startKnot] + t3 * (this.knots[this.endKnot] - this.knots[this.startKnot]);
    const hpoint = calcBSplinePoint(this.degree, this.knots, this.controlPoints, u3);
    if (hpoint.w !== 1) {
      hpoint.divideScalar(hpoint.w);
    }
    return point2.set(hpoint.x, hpoint.y, hpoint.z);
  }
  getTangent(t3, optionalTarget = new Vector3$1()) {
    const tangent = optionalTarget;
    const u3 = this.knots[0] + t3 * (this.knots[this.knots.length - 1] - this.knots[0]);
    const ders = calcNURBSDerivatives(this.degree, this.knots, this.controlPoints, u3, 1);
    tangent.copy(ders[1]).normalize();
    return tangent;
  }
  toJSON() {
    const data = super.toJSON();
    data.degree = this.degree;
    data.knots = [...this.knots];
    data.controlPoints = this.controlPoints.map((p2) => p2.toArray());
    data.startKnot = this.startKnot;
    data.endKnot = this.endKnot;
    return data;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.degree = json.degree;
    this.knots = [...json.knots];
    this.controlPoints = json.controlPoints.map((p2) => new Vector4$1(p2[0], p2[1], p2[2], p2[3]));
    this.startKnot = json.startKnot;
    this.endKnot = json.endKnot;
    return this;
  }
}
let fbxTree;
let connections;
let sceneGraph;
class FBXLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const path = scope.path === "" ? LoaderUtils$1.extractUrlBase(url) : scope.path;
    const loader = new FileLoader$1(this.manager);
    loader.setPath(scope.path);
    loader.setResponseType("arraybuffer");
    loader.setRequestHeader(scope.requestHeader);
    loader.setWithCredentials(scope.withCredentials);
    loader.load(url, function(buffer) {
      try {
        onLoad(scope.parse(buffer, path));
      } catch (e2) {
        if (onError) {
          onError(e2);
        } else {
          console.error(e2);
        }
        scope.manager.itemError(url);
      }
    }, onProgress, onError);
  }
  parse(FBXBuffer, path) {
    if (isFbxFormatBinary(FBXBuffer)) {
      fbxTree = new BinaryParser().parse(FBXBuffer);
    } else {
      const FBXText = convertArrayBufferToString(FBXBuffer);
      if (!isFbxFormatASCII(FBXText)) {
        throw new Error("THREE.FBXLoader: Unknown format.");
      }
      if (getFbxVersion(FBXText) < 7e3) {
        throw new Error("THREE.FBXLoader: FBX version not supported, FileVersion: " + getFbxVersion(FBXText));
      }
      fbxTree = new TextParser().parse(FBXText);
    }
    const textureLoader = new TextureLoader$1(this.manager).setPath(this.resourcePath || path).setCrossOrigin(this.crossOrigin);
    return new FBXTreeParser(textureLoader, this.manager).parse(fbxTree);
  }
}
class FBXTreeParser {
  constructor(textureLoader, manager) {
    this.textureLoader = textureLoader;
    this.manager = manager;
  }
  parse() {
    connections = this.parseConnections();
    const images = this.parseImages();
    const textures = this.parseTextures(images);
    const materials = this.parseMaterials(textures);
    const deformers = this.parseDeformers();
    const geometryMap = new GeometryParser().parse(deformers);
    this.parseScene(deformers, geometryMap, materials);
    return sceneGraph;
  }
  // Parses FBXTree.Connections which holds parent-child connections between objects (e.g. material -> texture, model->geometry )
  // and details the connection type
  parseConnections() {
    const connectionMap = /* @__PURE__ */ new Map();
    if ("Connections" in fbxTree) {
      const rawConnections = fbxTree.Connections.connections;
      rawConnections.forEach(function(rawConnection) {
        const fromID = rawConnection[0];
        const toID = rawConnection[1];
        const relationship = rawConnection[2];
        if (!connectionMap.has(fromID)) {
          connectionMap.set(fromID, {
            parents: [],
            children: []
          });
        }
        const parentRelationship = { ID: toID, relationship };
        connectionMap.get(fromID).parents.push(parentRelationship);
        if (!connectionMap.has(toID)) {
          connectionMap.set(toID, {
            parents: [],
            children: []
          });
        }
        const childRelationship = { ID: fromID, relationship };
        connectionMap.get(toID).children.push(childRelationship);
      });
    }
    return connectionMap;
  }
  // Parse FBXTree.Objects.Video for embedded image data
  // These images are connected to textures in FBXTree.Objects.Textures
  // via FBXTree.Connections.
  parseImages() {
    const images = {};
    const blobs = {};
    if ("Video" in fbxTree.Objects) {
      const videoNodes = fbxTree.Objects.Video;
      for (const nodeID in videoNodes) {
        const videoNode = videoNodes[nodeID];
        const id = parseInt(nodeID);
        images[id] = videoNode.RelativeFilename || videoNode.Filename;
        if ("Content" in videoNode) {
          const arrayBufferContent = videoNode.Content instanceof ArrayBuffer && videoNode.Content.byteLength > 0;
          const base64Content = typeof videoNode.Content === "string" && videoNode.Content !== "";
          if (arrayBufferContent || base64Content) {
            const image2 = this.parseImage(videoNodes[nodeID]);
            blobs[videoNode.RelativeFilename || videoNode.Filename] = image2;
          }
        }
      }
    }
    for (const id in images) {
      const filename = images[id];
      if (blobs[filename] !== void 0) images[id] = blobs[filename];
      else images[id] = images[id].split("\\").pop();
    }
    return images;
  }
  // Parse embedded image data in FBXTree.Video.Content
  parseImage(videoNode) {
    const content2 = videoNode.Content;
    const fileName = videoNode.RelativeFilename || videoNode.Filename;
    const extension = fileName.slice(fileName.lastIndexOf(".") + 1).toLowerCase();
    let type;
    switch (extension) {
      case "bmp":
        type = "image/bmp";
        break;
      case "jpg":
      case "jpeg":
        type = "image/jpeg";
        break;
      case "png":
        type = "image/png";
        break;
      case "tif":
        type = "image/tiff";
        break;
      case "tga":
        if (this.manager.getHandler(".tga") === null) {
          console.warn("FBXLoader: TGA loader not found, skipping ", fileName);
        }
        type = "image/tga";
        break;
      default:
        console.warn('FBXLoader: Image type "' + extension + '" is not supported.');
        return;
    }
    if (typeof content2 === "string") {
      return "data:" + type + ";base64," + content2;
    } else {
      const array = new Uint8Array(content2);
      return window.URL.createObjectURL(new Blob([array], { type }));
    }
  }
  // Parse nodes in FBXTree.Objects.Texture
  // These contain details such as UV scaling, cropping, rotation etc and are connected
  // to images in FBXTree.Objects.Video
  parseTextures(images) {
    const textureMap = /* @__PURE__ */ new Map();
    if ("Texture" in fbxTree.Objects) {
      const textureNodes = fbxTree.Objects.Texture;
      for (const nodeID in textureNodes) {
        const texture = this.parseTexture(textureNodes[nodeID], images);
        textureMap.set(parseInt(nodeID), texture);
      }
    }
    return textureMap;
  }
  // Parse individual node in FBXTree.Objects.Texture
  parseTexture(textureNode, images) {
    const texture = this.loadTexture(textureNode, images);
    texture.ID = textureNode.id;
    texture.name = textureNode.attrName;
    const wrapModeU = textureNode.WrapModeU;
    const wrapModeV = textureNode.WrapModeV;
    const valueU = wrapModeU !== void 0 ? wrapModeU.value : 0;
    const valueV = wrapModeV !== void 0 ? wrapModeV.value : 0;
    texture.wrapS = valueU === 0 ? RepeatWrapping$1 : ClampToEdgeWrapping$1;
    texture.wrapT = valueV === 0 ? RepeatWrapping$1 : ClampToEdgeWrapping$1;
    if ("Scaling" in textureNode) {
      const values = textureNode.Scaling.value;
      texture.repeat.x = values[0];
      texture.repeat.y = values[1];
    }
    if ("Translation" in textureNode) {
      const values = textureNode.Translation.value;
      texture.offset.x = values[0];
      texture.offset.y = values[1];
    }
    return texture;
  }
  // load a texture specified as a blob or data URI, or via an external URL using TextureLoader
  loadTexture(textureNode, images) {
    const nonNativeExtensions = /* @__PURE__ */ new Set(["tga", "tif", "tiff", "exr", "dds", "hdr", "ktx2"]);
    const extension = textureNode.FileName.split(".").pop().toLowerCase();
    const loader = nonNativeExtensions.has(extension) ? this.manager.getHandler(`.${extension}`) : this.textureLoader;
    if (!loader) {
      console.warn(
        `FBXLoader: ${extension.toUpperCase()} loader not found, creating placeholder texture for`,
        textureNode.RelativeFilename
      );
      return new Texture$1();
    }
    const loaderPath = loader.path;
    if (!loaderPath) {
      loader.setPath(this.textureLoader.path);
    }
    const children = connections.get(textureNode.id).children;
    let fileName;
    if (children !== void 0 && children.length > 0 && images[children[0].ID] !== void 0) {
      fileName = images[children[0].ID];
      if (fileName.indexOf("blob:") === 0 || fileName.indexOf("data:") === 0) {
        loader.setPath(void 0);
      }
    }
    const texture = loader.load(fileName);
    loader.setPath(loaderPath);
    return texture;
  }
  // Parse nodes in FBXTree.Objects.Material
  parseMaterials(textureMap) {
    const materialMap = /* @__PURE__ */ new Map();
    if ("Material" in fbxTree.Objects) {
      const materialNodes = fbxTree.Objects.Material;
      for (const nodeID in materialNodes) {
        const material = this.parseMaterial(materialNodes[nodeID], textureMap);
        if (material !== null) materialMap.set(parseInt(nodeID), material);
      }
    }
    return materialMap;
  }
  // Parse single node in FBXTree.Objects.Material
  // Materials are connected to texture maps in FBXTree.Objects.Textures
  // FBX format currently only supports Lambert and Phong shading models
  parseMaterial(materialNode, textureMap) {
    const ID2 = materialNode.id;
    const name = materialNode.attrName;
    let type = materialNode.ShadingModel;
    if (typeof type === "object") {
      type = type.value;
    }
    if (!connections.has(ID2)) return null;
    const parameters = this.parseParameters(materialNode, textureMap, ID2);
    let material;
    switch (type.toLowerCase()) {
      case "phong":
        material = new MeshPhongMaterial$1();
        break;
      case "lambert":
        material = new MeshLambertMaterial$1();
        break;
      default:
        console.warn('THREE.FBXLoader: unknown material type "%s". Defaulting to MeshPhongMaterial.', type);
        material = new MeshPhongMaterial$1();
        break;
    }
    material.setValues(parameters);
    material.name = name;
    return material;
  }
  // Parse FBX material and return parameters suitable for a three.js material
  // Also parse the texture map and return any textures associated with the material
  parseParameters(materialNode, textureMap, ID2) {
    const parameters = {};
    if (materialNode.BumpFactor) {
      parameters.bumpScale = materialNode.BumpFactor.value;
    }
    if (materialNode.Diffuse) {
      parameters.color = ColorManagement.toWorkingColorSpace(new Color$1().fromArray(materialNode.Diffuse.value), SRGBColorSpace);
    } else if (materialNode.DiffuseColor && (materialNode.DiffuseColor.type === "Color" || materialNode.DiffuseColor.type === "ColorRGB")) {
      parameters.color = ColorManagement.toWorkingColorSpace(new Color$1().fromArray(materialNode.DiffuseColor.value), SRGBColorSpace);
    }
    if (materialNode.DisplacementFactor) {
      parameters.displacementScale = materialNode.DisplacementFactor.value;
    }
    if (materialNode.Emissive) {
      parameters.emissive = ColorManagement.toWorkingColorSpace(new Color$1().fromArray(materialNode.Emissive.value), SRGBColorSpace);
    } else if (materialNode.EmissiveColor && (materialNode.EmissiveColor.type === "Color" || materialNode.EmissiveColor.type === "ColorRGB")) {
      parameters.emissive = ColorManagement.toWorkingColorSpace(new Color$1().fromArray(materialNode.EmissiveColor.value), SRGBColorSpace);
    }
    if (materialNode.EmissiveFactor) {
      parameters.emissiveIntensity = parseFloat(materialNode.EmissiveFactor.value);
    }
    parameters.opacity = 1 - (materialNode.TransparencyFactor ? parseFloat(materialNode.TransparencyFactor.value) : 0);
    if (parameters.opacity === 1 || parameters.opacity === 0) {
      parameters.opacity = materialNode.Opacity ? parseFloat(materialNode.Opacity.value) : null;
      if (parameters.opacity === null) {
        parameters.opacity = 1 - (materialNode.TransparentColor ? parseFloat(materialNode.TransparentColor.value[0]) : 0);
      }
    }
    if (parameters.opacity < 1) {
      parameters.transparent = true;
    }
    if (materialNode.ReflectionFactor) {
      parameters.reflectivity = materialNode.ReflectionFactor.value;
    }
    if (materialNode.Shininess) {
      parameters.shininess = materialNode.Shininess.value;
    }
    if (materialNode.Specular) {
      parameters.specular = ColorManagement.toWorkingColorSpace(new Color$1().fromArray(materialNode.Specular.value), SRGBColorSpace);
    } else if (materialNode.SpecularColor && materialNode.SpecularColor.type === "Color") {
      parameters.specular = ColorManagement.toWorkingColorSpace(new Color$1().fromArray(materialNode.SpecularColor.value), SRGBColorSpace);
    }
    const scope = this;
    connections.get(ID2).children.forEach(function(child) {
      const type = child.relationship;
      switch (type) {
        case "Bump":
          parameters.bumpMap = scope.getTexture(textureMap, child.ID);
          break;
        case "Maya|TEX_ao_map":
          parameters.aoMap = scope.getTexture(textureMap, child.ID);
          break;
        case "DiffuseColor":
        case "Maya|TEX_color_map":
          parameters.map = scope.getTexture(textureMap, child.ID);
          if (parameters.map !== void 0) {
            parameters.map.colorSpace = SRGBColorSpace;
          }
          break;
        case "DisplacementColor":
          parameters.displacementMap = scope.getTexture(textureMap, child.ID);
          break;
        case "EmissiveColor":
          parameters.emissiveMap = scope.getTexture(textureMap, child.ID);
          if (parameters.emissiveMap !== void 0) {
            parameters.emissiveMap.colorSpace = SRGBColorSpace;
          }
          break;
        case "NormalMap":
        case "Maya|TEX_normal_map":
          parameters.normalMap = scope.getTexture(textureMap, child.ID);
          break;
        case "ReflectionColor":
          parameters.envMap = scope.getTexture(textureMap, child.ID);
          if (parameters.envMap !== void 0) {
            parameters.envMap.mapping = EquirectangularReflectionMapping$1;
            parameters.envMap.colorSpace = SRGBColorSpace;
          }
          break;
        case "SpecularColor":
          parameters.specularMap = scope.getTexture(textureMap, child.ID);
          if (parameters.specularMap !== void 0) {
            parameters.specularMap.colorSpace = SRGBColorSpace;
          }
          break;
        case "TransparentColor":
        case "TransparencyFactor":
          parameters.alphaMap = scope.getTexture(textureMap, child.ID);
          parameters.transparent = true;
          break;
        case "AmbientColor":
        case "ShininessExponent":
        case "SpecularFactor":
        case "VectorDisplacementColor":
        default:
          console.warn("THREE.FBXLoader: %s map is not supported in three.js, skipping texture.", type);
          break;
      }
    });
    return parameters;
  }
  // get a texture from the textureMap for use by a material.
  getTexture(textureMap, id) {
    if ("LayeredTexture" in fbxTree.Objects && id in fbxTree.Objects.LayeredTexture) {
      console.warn("THREE.FBXLoader: layered textures are not supported in three.js. Discarding all but first layer.");
      id = connections.get(id).children[0].ID;
    }
    return textureMap.get(id);
  }
  // Parse nodes in FBXTree.Objects.Deformer
  // Deformer node can contain skinning or Vertex Cache animation data, however only skinning is supported here
  // Generates map of Skeleton-like objects for use later when generating and binding skeletons.
  parseDeformers() {
    const skeletons = {};
    const morphTargets = {};
    if ("Deformer" in fbxTree.Objects) {
      const DeformerNodes = fbxTree.Objects.Deformer;
      for (const nodeID in DeformerNodes) {
        const deformerNode = DeformerNodes[nodeID];
        const relationships = connections.get(parseInt(nodeID));
        if (deformerNode.attrType === "Skin") {
          const skeleton = this.parseSkeleton(relationships, DeformerNodes);
          skeleton.ID = nodeID;
          if (relationships.parents.length > 1) console.warn("THREE.FBXLoader: skeleton attached to more than one geometry is not supported.");
          skeleton.geometryID = relationships.parents[0].ID;
          skeletons[nodeID] = skeleton;
        } else if (deformerNode.attrType === "BlendShape") {
          const morphTarget = {
            id: nodeID
          };
          morphTarget.rawTargets = this.parseMorphTargets(relationships, DeformerNodes);
          morphTarget.id = nodeID;
          if (relationships.parents.length > 1) console.warn("THREE.FBXLoader: morph target attached to more than one geometry is not supported.");
          morphTargets[nodeID] = morphTarget;
        }
      }
    }
    return {
      skeletons,
      morphTargets
    };
  }
  // Parse single nodes in FBXTree.Objects.Deformer
  // The top level skeleton node has type 'Skin' and sub nodes have type 'Cluster'
  // Each skin node represents a skeleton and each cluster node represents a bone
  parseSkeleton(relationships, deformerNodes) {
    const rawBones = [];
    relationships.children.forEach(function(child) {
      const boneNode = deformerNodes[child.ID];
      if (boneNode.attrType !== "Cluster") return;
      const rawBone = {
        ID: child.ID,
        indices: [],
        weights: [],
        transformLink: new Matrix4$1().fromArray(boneNode.TransformLink.a)
        // transform: new Matrix4().fromArray( boneNode.Transform.a ),
        // linkMode: boneNode.Mode,
      };
      if ("Indexes" in boneNode) {
        rawBone.indices = boneNode.Indexes.a;
        rawBone.weights = boneNode.Weights.a;
      }
      rawBones.push(rawBone);
    });
    return {
      rawBones,
      bones: []
    };
  }
  // The top level morph deformer node has type "BlendShape" and sub nodes have type "BlendShapeChannel"
  parseMorphTargets(relationships, deformerNodes) {
    const rawMorphTargets = [];
    for (let i2 = 0; i2 < relationships.children.length; i2++) {
      const child = relationships.children[i2];
      const morphTargetNode = deformerNodes[child.ID];
      const rawMorphTarget = {
        name: morphTargetNode.attrName,
        initialWeight: morphTargetNode.DeformPercent,
        id: morphTargetNode.id,
        fullWeights: morphTargetNode.FullWeights.a
      };
      if (morphTargetNode.attrType !== "BlendShapeChannel") return;
      rawMorphTarget.geoID = connections.get(parseInt(child.ID)).children.filter(function(child2) {
        return child2.relationship === void 0;
      })[0].ID;
      rawMorphTargets.push(rawMorphTarget);
    }
    return rawMorphTargets;
  }
  // create the main Group() to be returned by the loader
  parseScene(deformers, geometryMap, materialMap) {
    sceneGraph = new Group$1();
    const modelMap = this.parseModels(deformers.skeletons, geometryMap, materialMap);
    const modelNodes = fbxTree.Objects.Model;
    const scope = this;
    modelMap.forEach(function(model) {
      const modelNode = modelNodes[model.ID];
      scope.setLookAtProperties(model, modelNode);
      const parentConnections = connections.get(model.ID).parents;
      parentConnections.forEach(function(connection) {
        const parent2 = modelMap.get(connection.ID);
        if (parent2 !== void 0) parent2.add(model);
      });
      if (model.parent === null) {
        sceneGraph.add(model);
      }
    });
    this.bindSkeleton(deformers.skeletons, geometryMap, modelMap);
    this.addGlobalSceneSettings();
    sceneGraph.traverse(function(node) {
      if (node.userData.transformData) {
        if (node.parent) {
          node.userData.transformData.parentMatrix = node.parent.matrix;
          node.userData.transformData.parentMatrixWorld = node.parent.matrixWorld;
        }
        const transform2 = generateTransform(node.userData.transformData);
        node.applyMatrix4(transform2);
        node.updateWorldMatrix();
      }
    });
    const animations = new AnimationParser().parse();
    if (sceneGraph.children.length === 1 && sceneGraph.children[0].isGroup) {
      sceneGraph.children[0].animations = animations;
      sceneGraph = sceneGraph.children[0];
    }
    sceneGraph.animations = animations;
  }
  // parse nodes in FBXTree.Objects.Model
  parseModels(skeletons, geometryMap, materialMap) {
    const modelMap = /* @__PURE__ */ new Map();
    const modelNodes = fbxTree.Objects.Model;
    for (const nodeID in modelNodes) {
      const id = parseInt(nodeID);
      const node = modelNodes[nodeID];
      const relationships = connections.get(id);
      let model = this.buildSkeleton(relationships, skeletons, id, node.attrName);
      if (!model) {
        switch (node.attrType) {
          case "Camera":
            model = this.createCamera(relationships);
            break;
          case "Light":
            model = this.createLight(relationships);
            break;
          case "Mesh":
            model = this.createMesh(relationships, geometryMap, materialMap);
            break;
          case "NurbsCurve":
            model = this.createCurve(relationships, geometryMap);
            break;
          case "LimbNode":
          case "Root":
            model = new Bone$1();
            break;
          case "Null":
          default:
            model = new Group$1();
            break;
        }
        model.name = node.attrName ? PropertyBinding$1.sanitizeNodeName(node.attrName) : "";
        model.userData.originalName = node.attrName;
        model.ID = id;
      }
      this.getTransformData(model, node);
      modelMap.set(id, model);
    }
    return modelMap;
  }
  buildSkeleton(relationships, skeletons, id, name) {
    let bone = null;
    relationships.parents.forEach(function(parent2) {
      for (const ID2 in skeletons) {
        const skeleton = skeletons[ID2];
        skeleton.rawBones.forEach(function(rawBone, i2) {
          if (rawBone.ID === parent2.ID) {
            const subBone = bone;
            bone = new Bone$1();
            bone.matrixWorld.copy(rawBone.transformLink);
            bone.name = name ? PropertyBinding$1.sanitizeNodeName(name) : "";
            bone.userData.originalName = name;
            bone.ID = id;
            skeleton.bones[i2] = bone;
            if (subBone !== null) {
              bone.add(subBone);
            }
          }
        });
      }
    });
    return bone;
  }
  // create a PerspectiveCamera or OrthographicCamera
  createCamera(relationships) {
    let model;
    let cameraAttribute;
    relationships.children.forEach(function(child) {
      const attr = fbxTree.Objects.NodeAttribute[child.ID];
      if (attr !== void 0) {
        cameraAttribute = attr;
      }
    });
    if (cameraAttribute === void 0) {
      model = new Object3D$1();
    } else {
      let type = 0;
      if (cameraAttribute.CameraProjectionType !== void 0 && cameraAttribute.CameraProjectionType.value === 1) {
        type = 1;
      }
      let nearClippingPlane = 1;
      if (cameraAttribute.NearPlane !== void 0) {
        nearClippingPlane = cameraAttribute.NearPlane.value / 1e3;
      }
      let farClippingPlane = 1e3;
      if (cameraAttribute.FarPlane !== void 0) {
        farClippingPlane = cameraAttribute.FarPlane.value / 1e3;
      }
      let width = window.innerWidth;
      let height = window.innerHeight;
      if (cameraAttribute.AspectWidth !== void 0 && cameraAttribute.AspectHeight !== void 0) {
        width = cameraAttribute.AspectWidth.value;
        height = cameraAttribute.AspectHeight.value;
      }
      const aspect2 = width / height;
      let fov2 = 45;
      if (cameraAttribute.FieldOfView !== void 0) {
        fov2 = cameraAttribute.FieldOfView.value;
      }
      const focalLength = cameraAttribute.FocalLength ? cameraAttribute.FocalLength.value : null;
      switch (type) {
        case 0:
          model = new PerspectiveCamera$1(fov2, aspect2, nearClippingPlane, farClippingPlane);
          if (focalLength !== null) model.setFocalLength(focalLength);
          break;
        case 1:
          console.warn("THREE.FBXLoader: Orthographic cameras not supported yet.");
          model = new Object3D$1();
          break;
        default:
          console.warn("THREE.FBXLoader: Unknown camera type " + type + ".");
          model = new Object3D$1();
          break;
      }
    }
    return model;
  }
  // Create a DirectionalLight, PointLight or SpotLight
  createLight(relationships) {
    let model;
    let lightAttribute;
    relationships.children.forEach(function(child) {
      const attr = fbxTree.Objects.NodeAttribute[child.ID];
      if (attr !== void 0) {
        lightAttribute = attr;
      }
    });
    if (lightAttribute === void 0) {
      model = new Object3D$1();
    } else {
      let type;
      if (lightAttribute.LightType === void 0) {
        type = 0;
      } else {
        type = lightAttribute.LightType.value;
      }
      let color2 = 16777215;
      if (lightAttribute.Color !== void 0) {
        color2 = ColorManagement.toWorkingColorSpace(new Color$1().fromArray(lightAttribute.Color.value), SRGBColorSpace);
      }
      let intensity = lightAttribute.Intensity === void 0 ? 1 : lightAttribute.Intensity.value / 100;
      if (lightAttribute.CastLightOnObject !== void 0 && lightAttribute.CastLightOnObject.value === 0) {
        intensity = 0;
      }
      let distance2 = 0;
      if (lightAttribute.FarAttenuationEnd !== void 0) {
        if (lightAttribute.EnableFarAttenuation !== void 0 && lightAttribute.EnableFarAttenuation.value === 0) {
          distance2 = 0;
        } else {
          distance2 = lightAttribute.FarAttenuationEnd.value;
        }
      }
      const decay = 1;
      switch (type) {
        case 0:
          model = new PointLight$1(color2, intensity, distance2, decay);
          break;
        case 1:
          model = new DirectionalLight$1(color2, intensity);
          break;
        case 2:
          let angle2 = Math.PI / 3;
          if (lightAttribute.InnerAngle !== void 0) {
            angle2 = MathUtils.degToRad(lightAttribute.InnerAngle.value);
          }
          let penumbra = 0;
          if (lightAttribute.OuterAngle !== void 0) {
            penumbra = MathUtils.degToRad(lightAttribute.OuterAngle.value);
            penumbra = Math.max(penumbra, 1);
          }
          model = new SpotLight$1(color2, intensity, distance2, angle2, penumbra, decay);
          break;
        default:
          console.warn("THREE.FBXLoader: Unknown light type " + lightAttribute.LightType.value + ", defaulting to a PointLight.");
          model = new PointLight$1(color2, intensity);
          break;
      }
      if (lightAttribute.CastShadows !== void 0 && lightAttribute.CastShadows.value === 1) {
        model.castShadow = true;
      }
    }
    return model;
  }
  createMesh(relationships, geometryMap, materialMap) {
    let model;
    let geometry = null;
    let material = null;
    const materials = [];
    relationships.children.forEach(function(child) {
      if (geometryMap.has(child.ID)) {
        geometry = geometryMap.get(child.ID);
      }
      if (materialMap.has(child.ID)) {
        materials.push(materialMap.get(child.ID));
      }
    });
    if (materials.length > 1) {
      material = materials;
    } else if (materials.length > 0) {
      material = materials[0];
    } else {
      material = new MeshPhongMaterial$1({
        name: Loader$1.DEFAULT_MATERIAL_NAME,
        color: 13421772
      });
      materials.push(material);
    }
    if ("color" in geometry.attributes) {
      materials.forEach(function(material2) {
        material2.vertexColors = true;
      });
    }
    if (geometry.FBX_Deformer) {
      model = new SkinnedMesh$1(geometry, material);
      model.normalizeSkinWeights();
    } else {
      model = new Mesh$1(geometry, material);
    }
    return model;
  }
  createCurve(relationships, geometryMap) {
    const geometry = relationships.children.reduce(function(geo, child) {
      if (geometryMap.has(child.ID)) geo = geometryMap.get(child.ID);
      return geo;
    }, null);
    const material = new LineBasicMaterial$1({
      name: Loader$1.DEFAULT_MATERIAL_NAME,
      color: 3342591,
      linewidth: 1
    });
    return new Line$1(geometry, material);
  }
  // parse the model node for transform data
  getTransformData(model, modelNode) {
    const transformData = {};
    if ("InheritType" in modelNode) transformData.inheritType = parseInt(modelNode.InheritType.value);
    if ("RotationOrder" in modelNode) transformData.eulerOrder = getEulerOrder(modelNode.RotationOrder.value);
    else transformData.eulerOrder = getEulerOrder(0);
    if ("Lcl_Translation" in modelNode) transformData.translation = modelNode.Lcl_Translation.value;
    if ("PreRotation" in modelNode) transformData.preRotation = modelNode.PreRotation.value;
    if ("Lcl_Rotation" in modelNode) transformData.rotation = modelNode.Lcl_Rotation.value;
    if ("PostRotation" in modelNode) transformData.postRotation = modelNode.PostRotation.value;
    if ("Lcl_Scaling" in modelNode) transformData.scale = modelNode.Lcl_Scaling.value;
    if ("ScalingOffset" in modelNode) transformData.scalingOffset = modelNode.ScalingOffset.value;
    if ("ScalingPivot" in modelNode) transformData.scalingPivot = modelNode.ScalingPivot.value;
    if ("RotationOffset" in modelNode) transformData.rotationOffset = modelNode.RotationOffset.value;
    if ("RotationPivot" in modelNode) transformData.rotationPivot = modelNode.RotationPivot.value;
    model.userData.transformData = transformData;
  }
  setLookAtProperties(model, modelNode) {
    if ("LookAtProperty" in modelNode) {
      const children = connections.get(model.ID).children;
      children.forEach(function(child) {
        if (child.relationship === "LookAtProperty") {
          const lookAtTarget = fbxTree.Objects.Model[child.ID];
          if ("Lcl_Translation" in lookAtTarget) {
            const pos = lookAtTarget.Lcl_Translation.value;
            if (model.target !== void 0) {
              model.target.position.fromArray(pos);
              sceneGraph.add(model.target);
            } else {
              model.lookAt(new Vector3$1().fromArray(pos));
            }
          }
        }
      });
    }
  }
  bindSkeleton(skeletons, geometryMap, modelMap) {
    const bindMatrices = this.parsePoseNodes();
    for (const ID2 in skeletons) {
      const skeleton = skeletons[ID2];
      const parents = connections.get(parseInt(skeleton.ID)).parents;
      parents.forEach(function(parent2) {
        if (geometryMap.has(parent2.ID)) {
          const geoID = parent2.ID;
          const geoRelationships = connections.get(geoID);
          geoRelationships.parents.forEach(function(geoConnParent) {
            if (modelMap.has(geoConnParent.ID)) {
              const model = modelMap.get(geoConnParent.ID);
              model.bind(new Skeleton(skeleton.bones), bindMatrices[geoConnParent.ID]);
            }
          });
        }
      });
    }
  }
  parsePoseNodes() {
    const bindMatrices = {};
    if ("Pose" in fbxTree.Objects) {
      const BindPoseNode = fbxTree.Objects.Pose;
      for (const nodeID in BindPoseNode) {
        if (BindPoseNode[nodeID].attrType === "BindPose" && BindPoseNode[nodeID].NbPoseNodes > 0) {
          const poseNodes = BindPoseNode[nodeID].PoseNode;
          if (Array.isArray(poseNodes)) {
            poseNodes.forEach(function(poseNode) {
              bindMatrices[poseNode.Node] = new Matrix4$1().fromArray(poseNode.Matrix.a);
            });
          } else {
            bindMatrices[poseNodes.Node] = new Matrix4$1().fromArray(poseNodes.Matrix.a);
          }
        }
      }
    }
    return bindMatrices;
  }
  addGlobalSceneSettings() {
    if ("GlobalSettings" in fbxTree) {
      if ("AmbientColor" in fbxTree.GlobalSettings) {
        const ambientColor = fbxTree.GlobalSettings.AmbientColor.value;
        const r2 = ambientColor[0];
        const g3 = ambientColor[1];
        const b = ambientColor[2];
        if (r2 !== 0 || g3 !== 0 || b !== 0) {
          const color2 = new Color$1().setRGB(r2, g3, b, SRGBColorSpace);
          sceneGraph.add(new AmbientLight$1(color2, 1));
        }
      }
      if ("UnitScaleFactor" in fbxTree.GlobalSettings) {
        sceneGraph.userData.unitScaleFactor = fbxTree.GlobalSettings.UnitScaleFactor.value;
      }
    }
  }
}
class GeometryParser {
  constructor() {
    this.negativeMaterialIndices = false;
  }
  // Parse nodes in FBXTree.Objects.Geometry
  parse(deformers) {
    const geometryMap = /* @__PURE__ */ new Map();
    if ("Geometry" in fbxTree.Objects) {
      const geoNodes = fbxTree.Objects.Geometry;
      for (const nodeID in geoNodes) {
        const relationships = connections.get(parseInt(nodeID));
        const geo = this.parseGeometry(relationships, geoNodes[nodeID], deformers);
        geometryMap.set(parseInt(nodeID), geo);
      }
    }
    if (this.negativeMaterialIndices === true) {
      console.warn("THREE.FBXLoader: The FBX file contains invalid (negative) material indices. The asset might not render as expected.");
    }
    return geometryMap;
  }
  // Parse single node in FBXTree.Objects.Geometry
  parseGeometry(relationships, geoNode, deformers) {
    switch (geoNode.attrType) {
      case "Mesh":
        return this.parseMeshGeometry(relationships, geoNode, deformers);
      case "NurbsCurve":
        return this.parseNurbsGeometry(geoNode);
    }
  }
  // Parse single node mesh geometry in FBXTree.Objects.Geometry
  parseMeshGeometry(relationships, geoNode, deformers) {
    const skeletons = deformers.skeletons;
    const morphTargets = [];
    const modelNodes = relationships.parents.map(function(parent2) {
      return fbxTree.Objects.Model[parent2.ID];
    });
    if (modelNodes.length === 0) return;
    const skeleton = relationships.children.reduce(function(skeleton2, child) {
      if (skeletons[child.ID] !== void 0) skeleton2 = skeletons[child.ID];
      return skeleton2;
    }, null);
    relationships.children.forEach(function(child) {
      if (deformers.morphTargets[child.ID] !== void 0) {
        morphTargets.push(deformers.morphTargets[child.ID]);
      }
    });
    const modelNode = modelNodes[0];
    const transformData = {};
    if ("RotationOrder" in modelNode) transformData.eulerOrder = getEulerOrder(modelNode.RotationOrder.value);
    if ("InheritType" in modelNode) transformData.inheritType = parseInt(modelNode.InheritType.value);
    if ("GeometricTranslation" in modelNode) transformData.translation = modelNode.GeometricTranslation.value;
    if ("GeometricRotation" in modelNode) transformData.rotation = modelNode.GeometricRotation.value;
    if ("GeometricScaling" in modelNode) transformData.scale = modelNode.GeometricScaling.value;
    const transform2 = generateTransform(transformData);
    return this.genGeometry(geoNode, skeleton, morphTargets, transform2);
  }
  // Generate a BufferGeometry from a node in FBXTree.Objects.Geometry
  genGeometry(geoNode, skeleton, morphTargets, preTransform) {
    const geo = new BufferGeometry$1();
    if (geoNode.attrName) geo.name = geoNode.attrName;
    const geoInfo = this.parseGeoNode(geoNode, skeleton);
    const buffers = this.genBuffers(geoInfo);
    const positionAttribute = new Float32BufferAttribute$1(buffers.vertex, 3);
    positionAttribute.applyMatrix4(preTransform);
    geo.setAttribute("position", positionAttribute);
    if (buffers.colors.length > 0) {
      geo.setAttribute("color", new Float32BufferAttribute$1(buffers.colors, 3));
    }
    if (skeleton) {
      geo.setAttribute("skinIndex", new Uint16BufferAttribute$1(buffers.weightsIndices, 4));
      geo.setAttribute("skinWeight", new Float32BufferAttribute$1(buffers.vertexWeights, 4));
      geo.FBX_Deformer = skeleton;
    }
    if (buffers.normal.length > 0) {
      const normalMatrix = new Matrix3$1().getNormalMatrix(preTransform);
      const normalAttribute = new Float32BufferAttribute$1(buffers.normal, 3);
      normalAttribute.applyNormalMatrix(normalMatrix);
      geo.setAttribute("normal", normalAttribute);
    }
    buffers.uvs.forEach(function(uvBuffer, i2) {
      const name = i2 === 0 ? "uv" : `uv${i2}`;
      geo.setAttribute(name, new Float32BufferAttribute$1(buffers.uvs[i2], 2));
    });
    if (geoInfo.material && geoInfo.material.mappingType !== "AllSame") {
      let prevMaterialIndex = buffers.materialIndex[0];
      let startIndex = 0;
      buffers.materialIndex.forEach(function(currentIndex, i2) {
        if (currentIndex !== prevMaterialIndex) {
          geo.addGroup(startIndex, i2 - startIndex, prevMaterialIndex);
          prevMaterialIndex = currentIndex;
          startIndex = i2;
        }
      });
      if (geo.groups.length > 0) {
        const lastGroup = geo.groups[geo.groups.length - 1];
        const lastIndex = lastGroup.start + lastGroup.count;
        if (lastIndex !== buffers.materialIndex.length) {
          geo.addGroup(lastIndex, buffers.materialIndex.length - lastIndex, prevMaterialIndex);
        }
      }
      if (geo.groups.length === 0) {
        geo.addGroup(0, buffers.materialIndex.length, buffers.materialIndex[0]);
      }
    }
    this.addMorphTargets(geo, geoNode, morphTargets, preTransform);
    return geo;
  }
  parseGeoNode(geoNode, skeleton) {
    const geoInfo = {};
    geoInfo.vertexPositions = geoNode.Vertices !== void 0 ? geoNode.Vertices.a : [];
    geoInfo.vertexIndices = geoNode.PolygonVertexIndex !== void 0 ? geoNode.PolygonVertexIndex.a : [];
    if (geoNode.LayerElementColor) {
      geoInfo.color = this.parseVertexColors(geoNode.LayerElementColor[0]);
    }
    if (geoNode.LayerElementMaterial) {
      geoInfo.material = this.parseMaterialIndices(geoNode.LayerElementMaterial[0]);
    }
    if (geoNode.LayerElementNormal) {
      geoInfo.normal = this.parseNormals(geoNode.LayerElementNormal[0]);
    }
    if (geoNode.LayerElementUV) {
      geoInfo.uv = [];
      let i2 = 0;
      while (geoNode.LayerElementUV[i2]) {
        if (geoNode.LayerElementUV[i2].UV) {
          geoInfo.uv.push(this.parseUVs(geoNode.LayerElementUV[i2]));
        }
        i2++;
      }
    }
    geoInfo.weightTable = {};
    if (skeleton !== null) {
      geoInfo.skeleton = skeleton;
      skeleton.rawBones.forEach(function(rawBone, i2) {
        rawBone.indices.forEach(function(index2, j) {
          if (geoInfo.weightTable[index2] === void 0) geoInfo.weightTable[index2] = [];
          geoInfo.weightTable[index2].push({
            id: i2,
            weight: rawBone.weights[j]
          });
        });
      });
    }
    return geoInfo;
  }
  genBuffers(geoInfo) {
    const buffers = {
      vertex: [],
      normal: [],
      colors: [],
      uvs: [],
      materialIndex: [],
      vertexWeights: [],
      weightsIndices: []
    };
    let polygonIndex = 0;
    let faceLength = 0;
    let displayedWeightsWarning = false;
    let facePositionIndexes = [];
    let faceNormals = [];
    let faceColors = [];
    let faceUVs = [];
    let faceWeights = [];
    let faceWeightIndices = [];
    const scope = this;
    geoInfo.vertexIndices.forEach(function(vertexIndex, polygonVertexIndex) {
      let materialIndex;
      let endOfFace = false;
      if (vertexIndex < 0) {
        vertexIndex = vertexIndex ^ -1;
        endOfFace = true;
      }
      let weightIndices = [];
      let weights = [];
      facePositionIndexes.push(vertexIndex * 3, vertexIndex * 3 + 1, vertexIndex * 3 + 2);
      if (geoInfo.color) {
        const data = getData(polygonVertexIndex, polygonIndex, vertexIndex, geoInfo.color);
        faceColors.push(data[0], data[1], data[2]);
      }
      if (geoInfo.skeleton) {
        if (geoInfo.weightTable[vertexIndex] !== void 0) {
          geoInfo.weightTable[vertexIndex].forEach(function(wt2) {
            weights.push(wt2.weight);
            weightIndices.push(wt2.id);
          });
        }
        if (weights.length > 4) {
          if (!displayedWeightsWarning) {
            console.warn("THREE.FBXLoader: Vertex has more than 4 skinning weights assigned to vertex. Deleting additional weights.");
            displayedWeightsWarning = true;
          }
          const wIndex = [0, 0, 0, 0];
          const Weight = [0, 0, 0, 0];
          weights.forEach(function(weight, weightIndex) {
            let currentWeight = weight;
            let currentIndex = weightIndices[weightIndex];
            Weight.forEach(function(comparedWeight, comparedWeightIndex, comparedWeightArray) {
              if (currentWeight > comparedWeight) {
                comparedWeightArray[comparedWeightIndex] = currentWeight;
                currentWeight = comparedWeight;
                const tmp2 = wIndex[comparedWeightIndex];
                wIndex[comparedWeightIndex] = currentIndex;
                currentIndex = tmp2;
              }
            });
          });
          weightIndices = wIndex;
          weights = Weight;
        }
        while (weights.length < 4) {
          weights.push(0);
          weightIndices.push(0);
        }
        for (let i2 = 0; i2 < 4; ++i2) {
          faceWeights.push(weights[i2]);
          faceWeightIndices.push(weightIndices[i2]);
        }
      }
      if (geoInfo.normal) {
        const data = getData(polygonVertexIndex, polygonIndex, vertexIndex, geoInfo.normal);
        faceNormals.push(data[0], data[1], data[2]);
      }
      if (geoInfo.material && geoInfo.material.mappingType !== "AllSame") {
        materialIndex = getData(polygonVertexIndex, polygonIndex, vertexIndex, geoInfo.material)[0];
        if (materialIndex < 0) {
          scope.negativeMaterialIndices = true;
          materialIndex = 0;
        }
      }
      if (geoInfo.uv) {
        geoInfo.uv.forEach(function(uv, i2) {
          const data = getData(polygonVertexIndex, polygonIndex, vertexIndex, uv);
          if (faceUVs[i2] === void 0) {
            faceUVs[i2] = [];
          }
          faceUVs[i2].push(data[0]);
          faceUVs[i2].push(data[1]);
        });
      }
      faceLength++;
      if (endOfFace) {
        scope.genFace(buffers, geoInfo, facePositionIndexes, materialIndex, faceNormals, faceColors, faceUVs, faceWeights, faceWeightIndices, faceLength);
        polygonIndex++;
        faceLength = 0;
        facePositionIndexes = [];
        faceNormals = [];
        faceColors = [];
        faceUVs = [];
        faceWeights = [];
        faceWeightIndices = [];
      }
    });
    return buffers;
  }
  // See https://www.khronos.org/opengl/wiki/Calculating_a_Surface_Normal
  getNormalNewell(vertices) {
    const normal = new Vector3$1(0, 0, 0);
    for (let i2 = 0; i2 < vertices.length; i2++) {
      const current = vertices[i2];
      const next = vertices[(i2 + 1) % vertices.length];
      normal.x += (current.y - next.y) * (current.z + next.z);
      normal.y += (current.z - next.z) * (current.x + next.x);
      normal.z += (current.x - next.x) * (current.y + next.y);
    }
    normal.normalize();
    return normal;
  }
  getNormalTangentAndBitangent(vertices) {
    const normalVector = this.getNormalNewell(vertices);
    const up = Math.abs(normalVector.z) > 0.5 ? new Vector3$1(0, 1, 0) : new Vector3$1(0, 0, 1);
    const tangent = up.cross(normalVector).normalize();
    const bitangent = normalVector.clone().cross(tangent).normalize();
    return {
      normal: normalVector,
      tangent,
      bitangent
    };
  }
  flattenVertex(vertex2, normalTangent, normalBitangent) {
    return new Vector2$1(
      vertex2.dot(normalTangent),
      vertex2.dot(normalBitangent)
    );
  }
  // Generate data for a single face in a geometry. If the face is a quad then split it into 2 tris
  genFace(buffers, geoInfo, facePositionIndexes, materialIndex, faceNormals, faceColors, faceUVs, faceWeights, faceWeightIndices, faceLength) {
    let triangles;
    if (faceLength > 3) {
      const vertices = [];
      const positions = geoInfo.baseVertexPositions || geoInfo.vertexPositions;
      for (let i2 = 0; i2 < facePositionIndexes.length; i2 += 3) {
        vertices.push(
          new Vector3$1(
            positions[facePositionIndexes[i2]],
            positions[facePositionIndexes[i2 + 1]],
            positions[facePositionIndexes[i2 + 2]]
          )
        );
      }
      const { tangent, bitangent } = this.getNormalTangentAndBitangent(vertices);
      const triangulationInput = [];
      for (const vertex2 of vertices) {
        triangulationInput.push(this.flattenVertex(vertex2, tangent, bitangent));
      }
      triangles = ShapeUtils$1.triangulateShape(triangulationInput, []);
    } else {
      triangles = [[0, 1, 2]];
    }
    for (const [i0, i1, i2] of triangles) {
      buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i0 * 3]]);
      buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i0 * 3 + 1]]);
      buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i0 * 3 + 2]]);
      buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i1 * 3]]);
      buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i1 * 3 + 1]]);
      buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i1 * 3 + 2]]);
      buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i2 * 3]]);
      buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i2 * 3 + 1]]);
      buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i2 * 3 + 2]]);
      if (geoInfo.skeleton) {
        buffers.vertexWeights.push(faceWeights[i0 * 4]);
        buffers.vertexWeights.push(faceWeights[i0 * 4 + 1]);
        buffers.vertexWeights.push(faceWeights[i0 * 4 + 2]);
        buffers.vertexWeights.push(faceWeights[i0 * 4 + 3]);
        buffers.vertexWeights.push(faceWeights[i1 * 4]);
        buffers.vertexWeights.push(faceWeights[i1 * 4 + 1]);
        buffers.vertexWeights.push(faceWeights[i1 * 4 + 2]);
        buffers.vertexWeights.push(faceWeights[i1 * 4 + 3]);
        buffers.vertexWeights.push(faceWeights[i2 * 4]);
        buffers.vertexWeights.push(faceWeights[i2 * 4 + 1]);
        buffers.vertexWeights.push(faceWeights[i2 * 4 + 2]);
        buffers.vertexWeights.push(faceWeights[i2 * 4 + 3]);
        buffers.weightsIndices.push(faceWeightIndices[i0 * 4]);
        buffers.weightsIndices.push(faceWeightIndices[i0 * 4 + 1]);
        buffers.weightsIndices.push(faceWeightIndices[i0 * 4 + 2]);
        buffers.weightsIndices.push(faceWeightIndices[i0 * 4 + 3]);
        buffers.weightsIndices.push(faceWeightIndices[i1 * 4]);
        buffers.weightsIndices.push(faceWeightIndices[i1 * 4 + 1]);
        buffers.weightsIndices.push(faceWeightIndices[i1 * 4 + 2]);
        buffers.weightsIndices.push(faceWeightIndices[i1 * 4 + 3]);
        buffers.weightsIndices.push(faceWeightIndices[i2 * 4]);
        buffers.weightsIndices.push(faceWeightIndices[i2 * 4 + 1]);
        buffers.weightsIndices.push(faceWeightIndices[i2 * 4 + 2]);
        buffers.weightsIndices.push(faceWeightIndices[i2 * 4 + 3]);
      }
      if (geoInfo.color) {
        buffers.colors.push(faceColors[i0 * 3]);
        buffers.colors.push(faceColors[i0 * 3 + 1]);
        buffers.colors.push(faceColors[i0 * 3 + 2]);
        buffers.colors.push(faceColors[i1 * 3]);
        buffers.colors.push(faceColors[i1 * 3 + 1]);
        buffers.colors.push(faceColors[i1 * 3 + 2]);
        buffers.colors.push(faceColors[i2 * 3]);
        buffers.colors.push(faceColors[i2 * 3 + 1]);
        buffers.colors.push(faceColors[i2 * 3 + 2]);
      }
      if (geoInfo.material && geoInfo.material.mappingType !== "AllSame") {
        buffers.materialIndex.push(materialIndex);
        buffers.materialIndex.push(materialIndex);
        buffers.materialIndex.push(materialIndex);
      }
      if (geoInfo.normal) {
        buffers.normal.push(faceNormals[i0 * 3]);
        buffers.normal.push(faceNormals[i0 * 3 + 1]);
        buffers.normal.push(faceNormals[i0 * 3 + 2]);
        buffers.normal.push(faceNormals[i1 * 3]);
        buffers.normal.push(faceNormals[i1 * 3 + 1]);
        buffers.normal.push(faceNormals[i1 * 3 + 2]);
        buffers.normal.push(faceNormals[i2 * 3]);
        buffers.normal.push(faceNormals[i2 * 3 + 1]);
        buffers.normal.push(faceNormals[i2 * 3 + 2]);
      }
      if (geoInfo.uv) {
        geoInfo.uv.forEach(function(uv, j) {
          if (buffers.uvs[j] === void 0) buffers.uvs[j] = [];
          buffers.uvs[j].push(faceUVs[j][i0 * 2]);
          buffers.uvs[j].push(faceUVs[j][i0 * 2 + 1]);
          buffers.uvs[j].push(faceUVs[j][i1 * 2]);
          buffers.uvs[j].push(faceUVs[j][i1 * 2 + 1]);
          buffers.uvs[j].push(faceUVs[j][i2 * 2]);
          buffers.uvs[j].push(faceUVs[j][i2 * 2 + 1]);
        });
      }
    }
  }
  addMorphTargets(parentGeo, parentGeoNode, morphTargets, preTransform) {
    if (morphTargets.length === 0) return;
    parentGeo.morphTargetsRelative = true;
    parentGeo.morphAttributes.position = [];
    const scope = this;
    morphTargets.forEach(function(morphTarget) {
      morphTarget.rawTargets.forEach(function(rawTarget) {
        const morphGeoNode = fbxTree.Objects.Geometry[rawTarget.geoID];
        if (morphGeoNode !== void 0) {
          scope.genMorphGeometry(parentGeo, parentGeoNode, morphGeoNode, preTransform, rawTarget.name);
        }
      });
    });
  }
  // a morph geometry node is similar to a standard  node, and the node is also contained
  // in FBXTree.Objects.Geometry, however it can only have attributes for position, normal
  // and a special attribute Index defining which vertices of the original geometry are affected
  // Normal and position attributes only have data for the vertices that are affected by the morph
  genMorphGeometry(parentGeo, parentGeoNode, morphGeoNode, preTransform, name) {
    const basePositions = parentGeoNode.Vertices !== void 0 ? parentGeoNode.Vertices.a : [];
    const baseIndices = parentGeoNode.PolygonVertexIndex !== void 0 ? parentGeoNode.PolygonVertexIndex.a : [];
    const morphPositionsSparse = morphGeoNode.Vertices !== void 0 ? morphGeoNode.Vertices.a : [];
    const morphIndices = morphGeoNode.Indexes !== void 0 ? morphGeoNode.Indexes.a : [];
    const length2 = parentGeo.attributes.position.count * 3;
    const morphPositions = new Float32Array(length2);
    for (let i2 = 0; i2 < morphIndices.length; i2++) {
      const morphIndex = morphIndices[i2] * 3;
      morphPositions[morphIndex] = morphPositionsSparse[i2 * 3];
      morphPositions[morphIndex + 1] = morphPositionsSparse[i2 * 3 + 1];
      morphPositions[morphIndex + 2] = morphPositionsSparse[i2 * 3 + 2];
    }
    const morphGeoInfo = {
      vertexIndices: baseIndices,
      vertexPositions: morphPositions,
      baseVertexPositions: basePositions
    };
    const morphBuffers = this.genBuffers(morphGeoInfo);
    const positionAttribute = new Float32BufferAttribute$1(morphBuffers.vertex, 3);
    positionAttribute.name = name || morphGeoNode.attrName;
    positionAttribute.applyMatrix4(preTransform);
    parentGeo.morphAttributes.position.push(positionAttribute);
  }
  // Parse normal from FBXTree.Objects.Geometry.LayerElementNormal if it exists
  parseNormals(NormalNode) {
    const mappingType = NormalNode.MappingInformationType;
    const referenceType = NormalNode.ReferenceInformationType;
    const buffer = NormalNode.Normals.a;
    let indexBuffer = [];
    if (referenceType === "IndexToDirect") {
      if ("NormalIndex" in NormalNode) {
        indexBuffer = NormalNode.NormalIndex.a;
      } else if ("NormalsIndex" in NormalNode) {
        indexBuffer = NormalNode.NormalsIndex.a;
      }
    }
    return {
      dataSize: 3,
      buffer,
      indices: indexBuffer,
      mappingType,
      referenceType
    };
  }
  // Parse UVs from FBXTree.Objects.Geometry.LayerElementUV if it exists
  parseUVs(UVNode) {
    const mappingType = UVNode.MappingInformationType;
    const referenceType = UVNode.ReferenceInformationType;
    const buffer = UVNode.UV.a;
    let indexBuffer = [];
    if (referenceType === "IndexToDirect") {
      indexBuffer = UVNode.UVIndex.a;
    }
    return {
      dataSize: 2,
      buffer,
      indices: indexBuffer,
      mappingType,
      referenceType
    };
  }
  // Parse Vertex Colors from FBXTree.Objects.Geometry.LayerElementColor if it exists
  parseVertexColors(ColorNode) {
    const mappingType = ColorNode.MappingInformationType;
    const referenceType = ColorNode.ReferenceInformationType;
    const buffer = ColorNode.Colors.a;
    let indexBuffer = [];
    if (referenceType === "IndexToDirect") {
      indexBuffer = ColorNode.ColorIndex.a;
    }
    for (let i2 = 0, c2 = new Color$1(); i2 < buffer.length; i2 += 4) {
      c2.fromArray(buffer, i2);
      ColorManagement.toWorkingColorSpace(c2, SRGBColorSpace);
      c2.toArray(buffer, i2);
    }
    return {
      dataSize: 4,
      buffer,
      indices: indexBuffer,
      mappingType,
      referenceType
    };
  }
  // Parse mapping and material data in FBXTree.Objects.Geometry.LayerElementMaterial if it exists
  parseMaterialIndices(MaterialNode) {
    const mappingType = MaterialNode.MappingInformationType;
    const referenceType = MaterialNode.ReferenceInformationType;
    if (mappingType === "NoMappingInformation") {
      return {
        dataSize: 1,
        buffer: [0],
        indices: [0],
        mappingType: "AllSame",
        referenceType
      };
    }
    const materialIndexBuffer = MaterialNode.Materials.a;
    const materialIndices = [];
    for (let i2 = 0; i2 < materialIndexBuffer.length; ++i2) {
      materialIndices.push(i2);
    }
    return {
      dataSize: 1,
      buffer: materialIndexBuffer,
      indices: materialIndices,
      mappingType,
      referenceType
    };
  }
  // Generate a NurbGeometry from a node in FBXTree.Objects.Geometry
  parseNurbsGeometry(geoNode) {
    const order = parseInt(geoNode.Order);
    if (isNaN(order)) {
      console.error("THREE.FBXLoader: Invalid Order %s given for geometry ID: %s", geoNode.Order, geoNode.id);
      return new BufferGeometry$1();
    }
    const degree = order - 1;
    const knots = geoNode.KnotVector.a;
    const controlPoints = [];
    const pointsValues = geoNode.Points.a;
    for (let i2 = 0, l2 = pointsValues.length; i2 < l2; i2 += 4) {
      controlPoints.push(new Vector4$1().fromArray(pointsValues, i2));
    }
    let startKnot, endKnot;
    if (geoNode.Form === "Closed") {
      controlPoints.push(controlPoints[0]);
    } else if (geoNode.Form === "Periodic") {
      startKnot = degree;
      endKnot = knots.length - 1 - startKnot;
      for (let i2 = 0; i2 < degree; ++i2) {
        controlPoints.push(controlPoints[i2]);
      }
    }
    const curve = new NURBSCurve(degree, knots, controlPoints, startKnot, endKnot);
    const points = curve.getPoints(controlPoints.length * 12);
    return new BufferGeometry$1().setFromPoints(points);
  }
}
class AnimationParser {
  // take raw animation clips and turn them into three.js animation clips
  parse() {
    const animationClips = [];
    const rawClips = this.parseClips();
    if (rawClips !== void 0) {
      for (const key in rawClips) {
        const rawClip = rawClips[key];
        const clip = this.addClip(rawClip);
        animationClips.push(clip);
      }
    }
    return animationClips;
  }
  parseClips() {
    if (fbxTree.Objects.AnimationCurve === void 0) return void 0;
    const curveNodesMap = this.parseAnimationCurveNodes();
    this.parseAnimationCurves(curveNodesMap);
    const layersMap = this.parseAnimationLayers(curveNodesMap);
    const rawClips = this.parseAnimStacks(layersMap);
    return rawClips;
  }
  // parse nodes in FBXTree.Objects.AnimationCurveNode
  // each AnimationCurveNode holds data for an animation transform for a model (e.g. left arm rotation )
  // and is referenced by an AnimationLayer
  parseAnimationCurveNodes() {
    const rawCurveNodes = fbxTree.Objects.AnimationCurveNode;
    const curveNodesMap = /* @__PURE__ */ new Map();
    for (const nodeID in rawCurveNodes) {
      const rawCurveNode = rawCurveNodes[nodeID];
      if (rawCurveNode.attrName.match(/S|R|T|DeformPercent/) !== null) {
        const curveNode = {
          id: rawCurveNode.id,
          attr: rawCurveNode.attrName,
          curves: {}
        };
        curveNodesMap.set(curveNode.id, curveNode);
      }
    }
    return curveNodesMap;
  }
  // parse nodes in FBXTree.Objects.AnimationCurve and connect them up to
  // previously parsed AnimationCurveNodes. Each AnimationCurve holds data for a single animated
  // axis ( e.g. times and values of x rotation)
  parseAnimationCurves(curveNodesMap) {
    const rawCurves = fbxTree.Objects.AnimationCurve;
    for (const nodeID in rawCurves) {
      const animationCurve = {
        id: rawCurves[nodeID].id,
        times: rawCurves[nodeID].KeyTime.a.map(convertFBXTimeToSeconds),
        values: rawCurves[nodeID].KeyValueFloat.a
      };
      const relationships = connections.get(animationCurve.id);
      if (relationships !== void 0) {
        const animationCurveID = relationships.parents[0].ID;
        const animationCurveRelationship = relationships.parents[0].relationship;
        if (animationCurveRelationship.match(/X/)) {
          curveNodesMap.get(animationCurveID).curves["x"] = animationCurve;
        } else if (animationCurveRelationship.match(/Y/)) {
          curveNodesMap.get(animationCurveID).curves["y"] = animationCurve;
        } else if (animationCurveRelationship.match(/Z/)) {
          curveNodesMap.get(animationCurveID).curves["z"] = animationCurve;
        } else if (animationCurveRelationship.match(/DeformPercent/) && curveNodesMap.has(animationCurveID)) {
          curveNodesMap.get(animationCurveID).curves["morph"] = animationCurve;
        }
      }
    }
  }
  // parse nodes in FBXTree.Objects.AnimationLayer. Each layers holds references
  // to various AnimationCurveNodes and is referenced by an AnimationStack node
  // note: theoretically a stack can have multiple layers, however in practice there always seems to be one per stack
  parseAnimationLayers(curveNodesMap) {
    const rawLayers = fbxTree.Objects.AnimationLayer;
    const layersMap = /* @__PURE__ */ new Map();
    for (const nodeID in rawLayers) {
      const layerCurveNodes = [];
      const connection = connections.get(parseInt(nodeID));
      if (connection !== void 0) {
        const children = connection.children;
        children.forEach(function(child, i2) {
          if (curveNodesMap.has(child.ID)) {
            const curveNode = curveNodesMap.get(child.ID);
            if (curveNode.curves.x !== void 0 || curveNode.curves.y !== void 0 || curveNode.curves.z !== void 0) {
              if (layerCurveNodes[i2] === void 0) {
                const modelID = connections.get(child.ID).parents.filter(function(parent2) {
                  return parent2.relationship !== void 0;
                })[0].ID;
                if (modelID !== void 0) {
                  const rawModel = fbxTree.Objects.Model[modelID.toString()];
                  if (rawModel === void 0) {
                    console.warn("THREE.FBXLoader: Encountered a unused curve.", child);
                    return;
                  }
                  const node = {
                    modelName: rawModel.attrName ? PropertyBinding$1.sanitizeNodeName(rawModel.attrName) : "",
                    ID: rawModel.id,
                    initialPosition: [0, 0, 0],
                    initialRotation: [0, 0, 0],
                    initialScale: [1, 1, 1]
                  };
                  sceneGraph.traverse(function(child2) {
                    if (child2.ID === rawModel.id) {
                      node.transform = child2.matrix;
                      if (child2.userData.transformData) node.eulerOrder = child2.userData.transformData.eulerOrder;
                    }
                  });
                  if (!node.transform) node.transform = new Matrix4$1();
                  if ("PreRotation" in rawModel) node.preRotation = rawModel.PreRotation.value;
                  if ("PostRotation" in rawModel) node.postRotation = rawModel.PostRotation.value;
                  layerCurveNodes[i2] = node;
                }
              }
              if (layerCurveNodes[i2]) layerCurveNodes[i2][curveNode.attr] = curveNode;
            } else if (curveNode.curves.morph !== void 0) {
              if (layerCurveNodes[i2] === void 0) {
                const deformerID = connections.get(child.ID).parents.filter(function(parent2) {
                  return parent2.relationship !== void 0;
                })[0].ID;
                const morpherID = connections.get(deformerID).parents[0].ID;
                const geoID = connections.get(morpherID).parents[0].ID;
                const modelID = connections.get(geoID).parents[0].ID;
                const rawModel = fbxTree.Objects.Model[modelID];
                const node = {
                  modelName: rawModel.attrName ? PropertyBinding$1.sanitizeNodeName(rawModel.attrName) : "",
                  morphName: fbxTree.Objects.Deformer[deformerID].attrName
                };
                layerCurveNodes[i2] = node;
              }
              layerCurveNodes[i2][curveNode.attr] = curveNode;
            }
          }
        });
        layersMap.set(parseInt(nodeID), layerCurveNodes);
      }
    }
    return layersMap;
  }
  // parse nodes in FBXTree.Objects.AnimationStack. These are the top level node in the animation
  // hierarchy. Each Stack node will be used to create a AnimationClip
  parseAnimStacks(layersMap) {
    const rawStacks = fbxTree.Objects.AnimationStack;
    const rawClips = {};
    for (const nodeID in rawStacks) {
      const children = connections.get(parseInt(nodeID)).children;
      if (children.length > 1) {
        console.warn("THREE.FBXLoader: Encountered an animation stack with multiple layers, this is currently not supported. Ignoring subsequent layers.");
      }
      const layer = layersMap.get(children[0].ID);
      rawClips[nodeID] = {
        name: rawStacks[nodeID].attrName,
        layer
      };
    }
    return rawClips;
  }
  addClip(rawClip) {
    let tracks = [];
    const scope = this;
    rawClip.layer.forEach(function(rawTracks) {
      tracks = tracks.concat(scope.generateTracks(rawTracks));
    });
    return new AnimationClip$1(rawClip.name, -1, tracks);
  }
  generateTracks(rawTracks) {
    const tracks = [];
    let initialPosition = new Vector3$1();
    let initialScale = new Vector3$1();
    if (rawTracks.transform) rawTracks.transform.decompose(initialPosition, new Quaternion$1(), initialScale);
    initialPosition = initialPosition.toArray();
    initialScale = initialScale.toArray();
    if (rawTracks.T !== void 0 && Object.keys(rawTracks.T.curves).length > 0) {
      const positionTrack = this.generateVectorTrack(rawTracks.modelName, rawTracks.T.curves, initialPosition, "position");
      if (positionTrack !== void 0) tracks.push(positionTrack);
    }
    if (rawTracks.R !== void 0 && Object.keys(rawTracks.R.curves).length > 0) {
      const rotationTrack = this.generateRotationTrack(rawTracks.modelName, rawTracks.R.curves, rawTracks.preRotation, rawTracks.postRotation, rawTracks.eulerOrder);
      if (rotationTrack !== void 0) tracks.push(rotationTrack);
    }
    if (rawTracks.S !== void 0 && Object.keys(rawTracks.S.curves).length > 0) {
      const scaleTrack = this.generateVectorTrack(rawTracks.modelName, rawTracks.S.curves, initialScale, "scale");
      if (scaleTrack !== void 0) tracks.push(scaleTrack);
    }
    if (rawTracks.DeformPercent !== void 0) {
      const morphTrack = this.generateMorphTrack(rawTracks);
      if (morphTrack !== void 0) tracks.push(morphTrack);
    }
    return tracks;
  }
  generateVectorTrack(modelName, curves, initialValue, type) {
    const times2 = this.getTimesForAllAxes(curves);
    const values = this.getKeyframeTrackValues(times2, curves, initialValue);
    return new VectorKeyframeTrack$1(modelName + "." + type, times2, values);
  }
  generateRotationTrack(modelName, curves, preRotation, postRotation, eulerOrder) {
    let times2;
    let values;
    if (curves.x !== void 0 && curves.y !== void 0 && curves.z !== void 0) {
      const result = this.interpolateRotations(curves.x, curves.y, curves.z, eulerOrder);
      times2 = result[0];
      values = result[1];
    }
    const defaultEulerOrder = getEulerOrder(0);
    if (preRotation !== void 0) {
      preRotation = preRotation.map(MathUtils.degToRad);
      preRotation.push(defaultEulerOrder);
      preRotation = new Euler$1().fromArray(preRotation);
      preRotation = new Quaternion$1().setFromEuler(preRotation);
    }
    if (postRotation !== void 0) {
      postRotation = postRotation.map(MathUtils.degToRad);
      postRotation.push(defaultEulerOrder);
      postRotation = new Euler$1().fromArray(postRotation);
      postRotation = new Quaternion$1().setFromEuler(postRotation).invert();
    }
    const quaternion = new Quaternion$1();
    const euler = new Euler$1();
    const quaternionValues = [];
    if (!values || !times2) return new QuaternionKeyframeTrack$1(modelName + ".quaternion", [0], [0]);
    for (let i2 = 0; i2 < values.length; i2 += 3) {
      euler.set(values[i2], values[i2 + 1], values[i2 + 2], eulerOrder);
      quaternion.setFromEuler(euler);
      if (preRotation !== void 0) quaternion.premultiply(preRotation);
      if (postRotation !== void 0) quaternion.multiply(postRotation);
      if (i2 > 2) {
        const prevQuat = new Quaternion$1().fromArray(
          quaternionValues,
          (i2 - 3) / 3 * 4
        );
        if (prevQuat.dot(quaternion) < 0) {
          quaternion.set(-quaternion.x, -quaternion.y, -quaternion.z, -quaternion.w);
        }
      }
      quaternion.toArray(quaternionValues, i2 / 3 * 4);
    }
    return new QuaternionKeyframeTrack$1(modelName + ".quaternion", times2, quaternionValues);
  }
  generateMorphTrack(rawTracks) {
    const curves = rawTracks.DeformPercent.curves.morph;
    const values = curves.values.map(function(val) {
      return val / 100;
    });
    const morphNum = sceneGraph.getObjectByName(rawTracks.modelName).morphTargetDictionary[rawTracks.morphName];
    return new NumberKeyframeTrack$1(rawTracks.modelName + ".morphTargetInfluences[" + morphNum + "]", curves.times, values);
  }
  // For all animated objects, times are defined separately for each axis
  // Here we'll combine the times into one sorted array without duplicates
  getTimesForAllAxes(curves) {
    let times2 = [];
    if (curves.x !== void 0) times2 = times2.concat(curves.x.times);
    if (curves.y !== void 0) times2 = times2.concat(curves.y.times);
    if (curves.z !== void 0) times2 = times2.concat(curves.z.times);
    times2 = times2.sort(function(a3, b) {
      return a3 - b;
    });
    if (times2.length > 1) {
      let targetIndex = 1;
      let lastValue = times2[0];
      for (let i2 = 1; i2 < times2.length; i2++) {
        const currentValue = times2[i2];
        if (currentValue !== lastValue) {
          times2[targetIndex] = currentValue;
          lastValue = currentValue;
          targetIndex++;
        }
      }
      times2 = times2.slice(0, targetIndex);
    }
    return times2;
  }
  getKeyframeTrackValues(times2, curves, initialValue) {
    const prevValue = initialValue;
    const values = [];
    let xIndex = -1;
    let yIndex = -1;
    let zIndex2 = -1;
    times2.forEach(function(time2) {
      if (curves.x) xIndex = curves.x.times.indexOf(time2);
      if (curves.y) yIndex = curves.y.times.indexOf(time2);
      if (curves.z) zIndex2 = curves.z.times.indexOf(time2);
      if (xIndex !== -1) {
        const xValue = curves.x.values[xIndex];
        values.push(xValue);
        prevValue[0] = xValue;
      } else {
        values.push(prevValue[0]);
      }
      if (yIndex !== -1) {
        const yValue = curves.y.values[yIndex];
        values.push(yValue);
        prevValue[1] = yValue;
      } else {
        values.push(prevValue[1]);
      }
      if (zIndex2 !== -1) {
        const zValue = curves.z.values[zIndex2];
        values.push(zValue);
        prevValue[2] = zValue;
      } else {
        values.push(prevValue[2]);
      }
    });
    return values;
  }
  // Rotations are defined as Euler angles which can have values  of any size
  // These will be converted to quaternions which don't support values greater than
  // PI, so we'll interpolate large rotations
  interpolateRotations(curvex, curvey, curvez, eulerOrder) {
    const times2 = [];
    const values = [];
    times2.push(curvex.times[0]);
    values.push(MathUtils.degToRad(curvex.values[0]));
    values.push(MathUtils.degToRad(curvey.values[0]));
    values.push(MathUtils.degToRad(curvez.values[0]));
    for (let i2 = 1; i2 < curvex.values.length; i2++) {
      const initialValue = [
        curvex.values[i2 - 1],
        curvey.values[i2 - 1],
        curvez.values[i2 - 1]
      ];
      if (isNaN(initialValue[0]) || isNaN(initialValue[1]) || isNaN(initialValue[2])) {
        continue;
      }
      const initialValueRad = initialValue.map(MathUtils.degToRad);
      const currentValue = [
        curvex.values[i2],
        curvey.values[i2],
        curvez.values[i2]
      ];
      if (isNaN(currentValue[0]) || isNaN(currentValue[1]) || isNaN(currentValue[2])) {
        continue;
      }
      const currentValueRad = currentValue.map(MathUtils.degToRad);
      const valuesSpan = [
        currentValue[0] - initialValue[0],
        currentValue[1] - initialValue[1],
        currentValue[2] - initialValue[2]
      ];
      const absoluteSpan = [
        Math.abs(valuesSpan[0]),
        Math.abs(valuesSpan[1]),
        Math.abs(valuesSpan[2])
      ];
      if (absoluteSpan[0] >= 180 || absoluteSpan[1] >= 180 || absoluteSpan[2] >= 180) {
        const maxAbsSpan = Math.max(...absoluteSpan);
        const numSubIntervals = maxAbsSpan / 180;
        const E1 = new Euler$1(...initialValueRad, eulerOrder);
        const E2 = new Euler$1(...currentValueRad, eulerOrder);
        const Q1 = new Quaternion$1().setFromEuler(E1);
        const Q2 = new Quaternion$1().setFromEuler(E2);
        if (Q1.dot(Q2)) {
          Q2.set(-Q2.x, -Q2.y, -Q2.z, -Q2.w);
        }
        const initialTime = curvex.times[i2 - 1];
        const timeSpan = curvex.times[i2] - initialTime;
        const Q3 = new Quaternion$1();
        const E3 = new Euler$1();
        for (let t3 = 0; t3 < 1; t3 += 1 / numSubIntervals) {
          Q3.copy(Q1.clone().slerp(Q2.clone(), t3));
          times2.push(initialTime + t3 * timeSpan);
          E3.setFromQuaternion(Q3, eulerOrder);
          values.push(E3.x);
          values.push(E3.y);
          values.push(E3.z);
        }
      } else {
        times2.push(curvex.times[i2]);
        values.push(MathUtils.degToRad(curvex.values[i2]));
        values.push(MathUtils.degToRad(curvey.values[i2]));
        values.push(MathUtils.degToRad(curvez.values[i2]));
      }
    }
    return [times2, values];
  }
}
class TextParser {
  getPrevNode() {
    return this.nodeStack[this.currentIndent - 2];
  }
  getCurrentNode() {
    return this.nodeStack[this.currentIndent - 1];
  }
  getCurrentProp() {
    return this.currentProp;
  }
  pushStack(node) {
    this.nodeStack.push(node);
    this.currentIndent += 1;
  }
  popStack() {
    this.nodeStack.pop();
    this.currentIndent -= 1;
  }
  setCurrentProp(val, name) {
    this.currentProp = val;
    this.currentPropName = name;
  }
  parse(text) {
    this.currentIndent = 0;
    this.allNodes = new FBXTree();
    this.nodeStack = [];
    this.currentProp = [];
    this.currentPropName = "";
    const scope = this;
    const split = text.split(/[\r\n]+/);
    split.forEach(function(line, i2) {
      const matchComment = line.match(/^[\s\t]*;/);
      const matchEmpty = line.match(/^[\s\t]*$/);
      if (matchComment || matchEmpty) return;
      const matchBeginning = line.match("^\\t{" + scope.currentIndent + "}(\\w+):(.*){", "");
      const matchProperty = line.match("^\\t{" + scope.currentIndent + "}(\\w+):[\\s\\t\\r\\n](.*)");
      const matchEnd = line.match("^\\t{" + (scope.currentIndent - 1) + "}}");
      if (matchBeginning) {
        scope.parseNodeBegin(line, matchBeginning);
      } else if (matchProperty) {
        scope.parseNodeProperty(line, matchProperty, split[++i2]);
      } else if (matchEnd) {
        scope.popStack();
      } else if (line.match(/^[^\s\t}]/)) {
        scope.parseNodePropertyContinued(line);
      }
    });
    return this.allNodes;
  }
  parseNodeBegin(line, property) {
    const nodeName = property[1].trim().replace(/^"/, "").replace(/"$/, "");
    const nodeAttrs = property[2].split(",").map(function(attr) {
      return attr.trim().replace(/^"/, "").replace(/"$/, "");
    });
    const node = { name: nodeName };
    const attrs = this.parseNodeAttr(nodeAttrs);
    const currentNode = this.getCurrentNode();
    if (this.currentIndent === 0) {
      this.allNodes.add(nodeName, node);
    } else {
      if (nodeName in currentNode) {
        if (nodeName === "PoseNode") {
          currentNode.PoseNode.push(node);
        } else if (currentNode[nodeName].id !== void 0) {
          currentNode[nodeName] = {};
          currentNode[nodeName][currentNode[nodeName].id] = currentNode[nodeName];
        }
        if (attrs.id !== "") currentNode[nodeName][attrs.id] = node;
      } else if (typeof attrs.id === "number") {
        currentNode[nodeName] = {};
        currentNode[nodeName][attrs.id] = node;
      } else if (nodeName !== "Properties70") {
        if (nodeName === "PoseNode") currentNode[nodeName] = [node];
        else currentNode[nodeName] = node;
      }
    }
    if (typeof attrs.id === "number") node.id = attrs.id;
    if (attrs.name !== "") node.attrName = attrs.name;
    if (attrs.type !== "") node.attrType = attrs.type;
    this.pushStack(node);
  }
  parseNodeAttr(attrs) {
    let id = attrs[0];
    if (attrs[0] !== "") {
      id = parseInt(attrs[0]);
      if (isNaN(id)) {
        id = attrs[0];
      }
    }
    let name = "", type = "";
    if (attrs.length > 1) {
      name = attrs[1].replace(/^(\w+)::/, "");
      type = attrs[2];
    }
    return { id, name, type };
  }
  parseNodeProperty(line, property, contentLine) {
    let propName = property[1].replace(/^"/, "").replace(/"$/, "").trim();
    let propValue = property[2].replace(/^"/, "").replace(/"$/, "").trim();
    if (propName === "Content" && propValue === ",") {
      propValue = contentLine.replace(/"/g, "").replace(/,$/, "").trim();
    }
    const currentNode = this.getCurrentNode();
    const parentName = currentNode.name;
    if (parentName === "Properties70") {
      this.parseNodeSpecialProperty(line, propName, propValue);
      return;
    }
    if (propName === "C") {
      const connProps = propValue.split(",").slice(1);
      const from = parseInt(connProps[0]);
      const to = parseInt(connProps[1]);
      let rest = propValue.split(",").slice(3);
      rest = rest.map(function(elem) {
        return elem.trim().replace(/^"/, "");
      });
      propName = "connections";
      propValue = [from, to];
      append(propValue, rest);
      if (currentNode[propName] === void 0) {
        currentNode[propName] = [];
      }
    }
    if (propName === "Node") currentNode.id = propValue;
    if (propName in currentNode && Array.isArray(currentNode[propName])) {
      currentNode[propName].push(propValue);
    } else {
      if (propName !== "a") currentNode[propName] = propValue;
      else currentNode.a = propValue;
    }
    this.setCurrentProp(currentNode, propName);
    if (propName === "a" && propValue.slice(-1) !== ",") {
      currentNode.a = parseNumberArray(propValue);
    }
  }
  parseNodePropertyContinued(line) {
    const currentNode = this.getCurrentNode();
    currentNode.a += line;
    if (line.slice(-1) !== ",") {
      currentNode.a = parseNumberArray(currentNode.a);
    }
  }
  // parse "Property70"
  parseNodeSpecialProperty(line, propName, propValue) {
    const props = propValue.split('",').map(function(prop) {
      return prop.trim().replace(/^\"/, "").replace(/\s/, "_");
    });
    const innerPropName = props[0];
    const innerPropType1 = props[1];
    const innerPropType2 = props[2];
    const innerPropFlag = props[3];
    let innerPropValue = props[4];
    switch (innerPropType1) {
      case "int":
      case "enum":
      case "bool":
      case "ULongLong":
      case "double":
      case "Number":
      case "FieldOfView":
        innerPropValue = parseFloat(innerPropValue);
        break;
      case "Color":
      case "ColorRGB":
      case "Vector3D":
      case "Lcl_Translation":
      case "Lcl_Rotation":
      case "Lcl_Scaling":
        innerPropValue = parseNumberArray(innerPropValue);
        break;
    }
    this.getPrevNode()[innerPropName] = {
      "type": innerPropType1,
      "type2": innerPropType2,
      "flag": innerPropFlag,
      "value": innerPropValue
    };
    this.setCurrentProp(this.getPrevNode(), innerPropName);
  }
}
class BinaryParser {
  parse(buffer) {
    const reader = new BinaryReader(buffer);
    reader.skip(23);
    const version = reader.getUint32();
    if (version < 6400) {
      throw new Error("THREE.FBXLoader: FBX version not supported, FileVersion: " + version);
    }
    const allNodes = new FBXTree();
    while (!this.endOfContent(reader)) {
      const node = this.parseNode(reader, version);
      if (node !== null) allNodes.add(node.name, node);
    }
    return allNodes;
  }
  // Check if reader has reached the end of content.
  endOfContent(reader) {
    if (reader.size() % 16 === 0) {
      return (reader.getOffset() + 160 + 16 & -16) >= reader.size();
    } else {
      return reader.getOffset() + 160 + 16 >= reader.size();
    }
  }
  // recursively parse nodes until the end of the file is reached
  parseNode(reader, version) {
    const node = {};
    const endOffset = version >= 7500 ? reader.getUint64() : reader.getUint32();
    const numProperties = version >= 7500 ? reader.getUint64() : reader.getUint32();
    version >= 7500 ? reader.getUint64() : reader.getUint32();
    const nameLen = reader.getUint8();
    const name = reader.getString(nameLen);
    if (endOffset === 0) return null;
    const propertyList = [];
    for (let i2 = 0; i2 < numProperties; i2++) {
      propertyList.push(this.parseProperty(reader));
    }
    const id = propertyList.length > 0 ? propertyList[0] : "";
    const attrName = propertyList.length > 1 ? propertyList[1] : "";
    const attrType = propertyList.length > 2 ? propertyList[2] : "";
    node.singleProperty = numProperties === 1 && reader.getOffset() === endOffset ? true : false;
    while (endOffset > reader.getOffset()) {
      const subNode = this.parseNode(reader, version);
      if (subNode !== null) this.parseSubNode(name, node, subNode);
    }
    node.propertyList = propertyList;
    if (typeof id === "number") node.id = id;
    if (attrName !== "") node.attrName = attrName;
    if (attrType !== "") node.attrType = attrType;
    if (name !== "") node.name = name;
    return node;
  }
  parseSubNode(name, node, subNode) {
    if (subNode.singleProperty === true) {
      const value = subNode.propertyList[0];
      if (Array.isArray(value)) {
        node[subNode.name] = subNode;
        subNode.a = value;
      } else {
        node[subNode.name] = value;
      }
    } else if (name === "Connections" && subNode.name === "C") {
      const array = [];
      subNode.propertyList.forEach(function(property, i2) {
        if (i2 !== 0) array.push(property);
      });
      if (node.connections === void 0) {
        node.connections = [];
      }
      node.connections.push(array);
    } else if (subNode.name === "Properties70") {
      const keys = Object.keys(subNode);
      keys.forEach(function(key) {
        node[key] = subNode[key];
      });
    } else if (name === "Properties70" && subNode.name === "P") {
      let innerPropName = subNode.propertyList[0];
      let innerPropType1 = subNode.propertyList[1];
      const innerPropType2 = subNode.propertyList[2];
      const innerPropFlag = subNode.propertyList[3];
      let innerPropValue;
      if (innerPropName.indexOf("Lcl ") === 0) innerPropName = innerPropName.replace("Lcl ", "Lcl_");
      if (innerPropType1.indexOf("Lcl ") === 0) innerPropType1 = innerPropType1.replace("Lcl ", "Lcl_");
      if (innerPropType1 === "Color" || innerPropType1 === "ColorRGB" || innerPropType1 === "Vector" || innerPropType1 === "Vector3D" || innerPropType1.indexOf("Lcl_") === 0) {
        innerPropValue = [
          subNode.propertyList[4],
          subNode.propertyList[5],
          subNode.propertyList[6]
        ];
      } else {
        innerPropValue = subNode.propertyList[4];
      }
      node[innerPropName] = {
        "type": innerPropType1,
        "type2": innerPropType2,
        "flag": innerPropFlag,
        "value": innerPropValue
      };
    } else if (node[subNode.name] === void 0) {
      if (typeof subNode.id === "number") {
        node[subNode.name] = {};
        node[subNode.name][subNode.id] = subNode;
      } else {
        node[subNode.name] = subNode;
      }
    } else {
      if (subNode.name === "PoseNode") {
        if (!Array.isArray(node[subNode.name])) {
          node[subNode.name] = [node[subNode.name]];
        }
        node[subNode.name].push(subNode);
      } else if (node[subNode.name][subNode.id] === void 0) {
        node[subNode.name][subNode.id] = subNode;
      }
    }
  }
  parseProperty(reader) {
    const type = reader.getString(1);
    let length2;
    switch (type) {
      case "C":
        return reader.getBoolean();
      case "D":
        return reader.getFloat64();
      case "F":
        return reader.getFloat32();
      case "I":
        return reader.getInt32();
      case "L":
        return reader.getInt64();
      case "R":
        length2 = reader.getUint32();
        return reader.getArrayBuffer(length2);
      case "S":
        length2 = reader.getUint32();
        return reader.getString(length2);
      case "Y":
        return reader.getInt16();
      case "b":
      case "c":
      case "d":
      case "f":
      case "i":
      case "l":
        const arrayLength = reader.getUint32();
        const encoding = reader.getUint32();
        const compressedLength = reader.getUint32();
        if (encoding === 0) {
          switch (type) {
            case "b":
            case "c":
              return reader.getBooleanArray(arrayLength);
            case "d":
              return reader.getFloat64Array(arrayLength);
            case "f":
              return reader.getFloat32Array(arrayLength);
            case "i":
              return reader.getInt32Array(arrayLength);
            case "l":
              return reader.getInt64Array(arrayLength);
          }
        }
        const data = unzlibSync(new Uint8Array(reader.getArrayBuffer(compressedLength)));
        const reader2 = new BinaryReader(data.buffer);
        switch (type) {
          case "b":
          case "c":
            return reader2.getBooleanArray(arrayLength);
          case "d":
            return reader2.getFloat64Array(arrayLength);
          case "f":
            return reader2.getFloat32Array(arrayLength);
          case "i":
            return reader2.getInt32Array(arrayLength);
          case "l":
            return reader2.getInt64Array(arrayLength);
        }
        break;
      default:
        throw new Error("THREE.FBXLoader: Unknown property type " + type);
    }
  }
}
class BinaryReader {
  constructor(buffer, littleEndian) {
    this.dv = new DataView(buffer);
    this.offset = 0;
    this.littleEndian = littleEndian !== void 0 ? littleEndian : true;
    this._textDecoder = new TextDecoder();
  }
  getOffset() {
    return this.offset;
  }
  size() {
    return this.dv.buffer.byteLength;
  }
  skip(length2) {
    this.offset += length2;
  }
  // seems like true/false representation depends on exporter.
  // true: 1 or 'Y'(=0x59), false: 0 or 'T'(=0x54)
  // then sees LSB.
  getBoolean() {
    return (this.getUint8() & 1) === 1;
  }
  getBooleanArray(size) {
    const a3 = [];
    for (let i2 = 0; i2 < size; i2++) {
      a3.push(this.getBoolean());
    }
    return a3;
  }
  getUint8() {
    const value = this.dv.getUint8(this.offset);
    this.offset += 1;
    return value;
  }
  getInt16() {
    const value = this.dv.getInt16(this.offset, this.littleEndian);
    this.offset += 2;
    return value;
  }
  getInt32() {
    const value = this.dv.getInt32(this.offset, this.littleEndian);
    this.offset += 4;
    return value;
  }
  getInt32Array(size) {
    const a3 = [];
    for (let i2 = 0; i2 < size; i2++) {
      a3.push(this.getInt32());
    }
    return a3;
  }
  getUint32() {
    const value = this.dv.getUint32(this.offset, this.littleEndian);
    this.offset += 4;
    return value;
  }
  // JavaScript doesn't support 64-bit integer so calculate this here
  // 1 << 32 will return 1 so using multiply operation instead here.
  // There's a possibility that this method returns wrong value if the value
  // is out of the range between Number.MAX_SAFE_INTEGER and Number.MIN_SAFE_INTEGER.
  // TODO: safely handle 64-bit integer
  getInt64() {
    let low, high;
    if (this.littleEndian) {
      low = this.getUint32();
      high = this.getUint32();
    } else {
      high = this.getUint32();
      low = this.getUint32();
    }
    if (high & 2147483648) {
      high = ~high & 4294967295;
      low = ~low & 4294967295;
      if (low === 4294967295) high = high + 1 & 4294967295;
      low = low + 1 & 4294967295;
      return -(high * 4294967296 + low);
    }
    return high * 4294967296 + low;
  }
  getInt64Array(size) {
    const a3 = [];
    for (let i2 = 0; i2 < size; i2++) {
      a3.push(this.getInt64());
    }
    return a3;
  }
  // Note: see getInt64() comment
  getUint64() {
    let low, high;
    if (this.littleEndian) {
      low = this.getUint32();
      high = this.getUint32();
    } else {
      high = this.getUint32();
      low = this.getUint32();
    }
    return high * 4294967296 + low;
  }
  getFloat32() {
    const value = this.dv.getFloat32(this.offset, this.littleEndian);
    this.offset += 4;
    return value;
  }
  getFloat32Array(size) {
    const a3 = [];
    for (let i2 = 0; i2 < size; i2++) {
      a3.push(this.getFloat32());
    }
    return a3;
  }
  getFloat64() {
    const value = this.dv.getFloat64(this.offset, this.littleEndian);
    this.offset += 8;
    return value;
  }
  getFloat64Array(size) {
    const a3 = [];
    for (let i2 = 0; i2 < size; i2++) {
      a3.push(this.getFloat64());
    }
    return a3;
  }
  getArrayBuffer(size) {
    const value = this.dv.buffer.slice(this.offset, this.offset + size);
    this.offset += size;
    return value;
  }
  getString(size) {
    const start = this.offset;
    let a3 = new Uint8Array(this.dv.buffer, start, size);
    this.skip(size);
    const nullByte = a3.indexOf(0);
    if (nullByte >= 0) a3 = new Uint8Array(this.dv.buffer, start, nullByte);
    return this._textDecoder.decode(a3);
  }
}
class FBXTree {
  add(key, val) {
    this[key] = val;
  }
}
function isFbxFormatBinary(buffer) {
  const CORRECT = "Kaydara FBX Binary  \0";
  return buffer.byteLength >= CORRECT.length && CORRECT === convertArrayBufferToString(buffer, 0, CORRECT.length);
}
function isFbxFormatASCII(text) {
  const CORRECT = ["K", "a", "y", "d", "a", "r", "a", "\\", "F", "B", "X", "\\", "B", "i", "n", "a", "r", "y", "\\", "\\"];
  let cursor = 0;
  function read(offset) {
    const result = text[offset - 1];
    text = text.slice(cursor + offset);
    cursor++;
    return result;
  }
  for (let i2 = 0; i2 < CORRECT.length; ++i2) {
    const num = read(1);
    if (num === CORRECT[i2]) {
      return false;
    }
  }
  return true;
}
function getFbxVersion(text) {
  const versionRegExp = /FBXVersion: (\d+)/;
  const match = text.match(versionRegExp);
  if (match) {
    const version = parseInt(match[1]);
    return version;
  }
  throw new Error("THREE.FBXLoader: Cannot find the version number for the file given.");
}
function convertFBXTimeToSeconds(time2) {
  return time2 / 46186158e3;
}
const dataArray = [];
function getData(polygonVertexIndex, polygonIndex, vertexIndex, infoObject) {
  let index2;
  switch (infoObject.mappingType) {
    case "ByPolygonVertex":
      index2 = polygonVertexIndex;
      break;
    case "ByPolygon":
      index2 = polygonIndex;
      break;
    case "ByVertice":
      index2 = vertexIndex;
      break;
    case "AllSame":
      index2 = infoObject.indices[0];
      break;
    default:
      console.warn("THREE.FBXLoader: unknown attribute mapping type " + infoObject.mappingType);
  }
  if (infoObject.referenceType === "IndexToDirect") index2 = infoObject.indices[index2];
  const from = index2 * infoObject.dataSize;
  const to = from + infoObject.dataSize;
  return slice(dataArray, infoObject.buffer, from, to);
}
const tempEuler = new Euler$1();
const tempVec = new Vector3$1();
function generateTransform(transformData) {
  const lTranslationM = new Matrix4$1();
  const lPreRotationM = new Matrix4$1();
  const lRotationM = new Matrix4$1();
  const lPostRotationM = new Matrix4$1();
  const lScalingM = new Matrix4$1();
  const lScalingPivotM = new Matrix4$1();
  const lScalingOffsetM = new Matrix4$1();
  const lRotationOffsetM = new Matrix4$1();
  const lRotationPivotM = new Matrix4$1();
  const lParentGX = new Matrix4$1();
  const lParentLX = new Matrix4$1();
  const lGlobalT = new Matrix4$1();
  const inheritType = transformData.inheritType ? transformData.inheritType : 0;
  if (transformData.translation) lTranslationM.setPosition(tempVec.fromArray(transformData.translation));
  const defaultEulerOrder = getEulerOrder(0);
  if (transformData.preRotation) {
    const array = transformData.preRotation.map(MathUtils.degToRad);
    array.push(defaultEulerOrder);
    lPreRotationM.makeRotationFromEuler(tempEuler.fromArray(array));
  }
  if (transformData.rotation) {
    const array = transformData.rotation.map(MathUtils.degToRad);
    array.push(transformData.eulerOrder || defaultEulerOrder);
    lRotationM.makeRotationFromEuler(tempEuler.fromArray(array));
  }
  if (transformData.postRotation) {
    const array = transformData.postRotation.map(MathUtils.degToRad);
    array.push(defaultEulerOrder);
    lPostRotationM.makeRotationFromEuler(tempEuler.fromArray(array));
    lPostRotationM.invert();
  }
  if (transformData.scale) lScalingM.scale(tempVec.fromArray(transformData.scale));
  if (transformData.scalingOffset) lScalingOffsetM.setPosition(tempVec.fromArray(transformData.scalingOffset));
  if (transformData.scalingPivot) lScalingPivotM.setPosition(tempVec.fromArray(transformData.scalingPivot));
  if (transformData.rotationOffset) lRotationOffsetM.setPosition(tempVec.fromArray(transformData.rotationOffset));
  if (transformData.rotationPivot) lRotationPivotM.setPosition(tempVec.fromArray(transformData.rotationPivot));
  if (transformData.parentMatrixWorld) {
    lParentLX.copy(transformData.parentMatrix);
    lParentGX.copy(transformData.parentMatrixWorld);
  }
  const lLRM = lPreRotationM.clone().multiply(lRotationM).multiply(lPostRotationM);
  const lParentGRM = new Matrix4$1();
  lParentGRM.extractRotation(lParentGX);
  const lParentTM = new Matrix4$1();
  lParentTM.copyPosition(lParentGX);
  const lParentGRSM = lParentTM.clone().invert().multiply(lParentGX);
  const lParentGSM = lParentGRM.clone().invert().multiply(lParentGRSM);
  const lLSM = lScalingM;
  const lGlobalRS = new Matrix4$1();
  if (inheritType === 0) {
    lGlobalRS.copy(lParentGRM).multiply(lLRM).multiply(lParentGSM).multiply(lLSM);
  } else if (inheritType === 1) {
    lGlobalRS.copy(lParentGRM).multiply(lParentGSM).multiply(lLRM).multiply(lLSM);
  } else {
    const lParentLSM = new Matrix4$1().scale(new Vector3$1().setFromMatrixScale(lParentLX));
    const lParentLSM_inv = lParentLSM.clone().invert();
    const lParentGSM_noLocal = lParentGSM.clone().multiply(lParentLSM_inv);
    lGlobalRS.copy(lParentGRM).multiply(lLRM).multiply(lParentGSM_noLocal).multiply(lLSM);
  }
  const lRotationPivotM_inv = lRotationPivotM.clone().invert();
  const lScalingPivotM_inv = lScalingPivotM.clone().invert();
  let lTransform = lTranslationM.clone().multiply(lRotationOffsetM).multiply(lRotationPivotM).multiply(lPreRotationM).multiply(lRotationM).multiply(lPostRotationM).multiply(lRotationPivotM_inv).multiply(lScalingOffsetM).multiply(lScalingPivotM).multiply(lScalingM).multiply(lScalingPivotM_inv);
  const lLocalTWithAllPivotAndOffsetInfo = new Matrix4$1().copyPosition(lTransform);
  const lGlobalTranslation = lParentGX.clone().multiply(lLocalTWithAllPivotAndOffsetInfo);
  lGlobalT.copyPosition(lGlobalTranslation);
  lTransform = lGlobalT.clone().multiply(lGlobalRS);
  lTransform.premultiply(lParentGX.invert());
  return lTransform;
}
function getEulerOrder(order) {
  order = order || 0;
  const enums = [
    "ZYX",
    // -> XYZ extrinsic
    "YZX",
    // -> XZY extrinsic
    "XZY",
    // -> YZX extrinsic
    "ZXY",
    // -> YXZ extrinsic
    "YXZ",
    // -> ZXY extrinsic
    "XYZ"
    // -> ZYX extrinsic
    //'SphericXYZ', // not possible to support
  ];
  if (order === 6) {
    console.warn("THREE.FBXLoader: unsupported Euler Order: Spherical XYZ. Animations and rotations may be incorrect.");
    return enums[0];
  }
  return enums[order];
}
function parseNumberArray(value) {
  const array = value.split(",").map(function(val) {
    return parseFloat(val);
  });
  return array;
}
function convertArrayBufferToString(buffer, from, to) {
  if (from === void 0) from = 0;
  if (to === void 0) to = buffer.byteLength;
  return new TextDecoder().decode(new Uint8Array(buffer, from, to));
}
function append(a3, b) {
  for (let i2 = 0, j = a3.length, l2 = b.length; i2 < l2; i2++, j++) {
    a3[j] = b[i2];
  }
}
function slice(a3, b, from, to) {
  for (let i2 = from, j = 0; i2 < to; i2++, j++) {
    a3[j] = b[i2];
  }
  return a3;
}
function toTrianglesDrawMode(geometry, drawMode) {
  if (drawMode === TrianglesDrawMode$1) {
    console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
    return geometry;
  }
  if (drawMode === TriangleFanDrawMode || drawMode === TriangleStripDrawMode) {
    let index2 = geometry.getIndex();
    if (index2 === null) {
      const indices = [];
      const position2 = geometry.getAttribute("position");
      if (position2 !== void 0) {
        for (let i2 = 0; i2 < position2.count; i2++) {
          indices.push(i2);
        }
        geometry.setIndex(indices);
        index2 = geometry.getIndex();
      } else {
        console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
        return geometry;
      }
    }
    const numberOfTriangles = index2.count - 2;
    const newIndices = [];
    if (drawMode === TriangleFanDrawMode) {
      for (let i2 = 1; i2 <= numberOfTriangles; i2++) {
        newIndices.push(index2.getX(0));
        newIndices.push(index2.getX(i2));
        newIndices.push(index2.getX(i2 + 1));
      }
    } else {
      for (let i2 = 0; i2 < numberOfTriangles; i2++) {
        if (i2 % 2 === 0) {
          newIndices.push(index2.getX(i2));
          newIndices.push(index2.getX(i2 + 1));
          newIndices.push(index2.getX(i2 + 2));
        } else {
          newIndices.push(index2.getX(i2 + 2));
          newIndices.push(index2.getX(i2 + 1));
          newIndices.push(index2.getX(i2));
        }
      }
    }
    if (newIndices.length / 3 !== numberOfTriangles) {
      console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
    }
    const newGeometry = geometry.clone();
    newGeometry.setIndex(newIndices);
    newGeometry.clearGroups();
    return newGeometry;
  } else {
    console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", drawMode);
    return geometry;
  }
}
class GLTFLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
    this.dracoLoader = null;
    this.ktx2Loader = null;
    this.meshoptDecoder = null;
    this.pluginCallbacks = [];
    this.register(function(parser) {
      return new GLTFMaterialsClearcoatExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsDispersionExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFTextureBasisUExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFTextureWebPExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFTextureAVIFExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsSheenExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsTransmissionExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsVolumeExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsIorExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsEmissiveStrengthExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsSpecularExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsIridescenceExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsAnisotropyExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsBumpExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFLightsExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMeshoptCompression(parser);
    });
    this.register(function(parser) {
      return new GLTFMeshGpuInstancing(parser);
    });
  }
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    let resourcePath;
    if (this.resourcePath !== "") {
      resourcePath = this.resourcePath;
    } else if (this.path !== "") {
      const relativeUrl = LoaderUtils$1.extractUrlBase(url);
      resourcePath = LoaderUtils$1.resolveURL(relativeUrl, this.path);
    } else {
      resourcePath = LoaderUtils$1.extractUrlBase(url);
    }
    this.manager.itemStart(url);
    const _onError = function(e2) {
      if (onError) {
        onError(e2);
      } else {
        console.error(e2);
      }
      scope.manager.itemError(url);
      scope.manager.itemEnd(url);
    };
    const loader = new FileLoader$1(this.manager);
    loader.setPath(this.path);
    loader.setResponseType("arraybuffer");
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(url, function(data) {
      try {
        scope.parse(data, resourcePath, function(gltf) {
          onLoad(gltf);
          scope.manager.itemEnd(url);
        }, _onError);
      } catch (e2) {
        _onError(e2);
      }
    }, onProgress, _onError);
  }
  setDRACOLoader(dracoLoader) {
    this.dracoLoader = dracoLoader;
    return this;
  }
  setKTX2Loader(ktx2Loader) {
    this.ktx2Loader = ktx2Loader;
    return this;
  }
  setMeshoptDecoder(meshoptDecoder) {
    this.meshoptDecoder = meshoptDecoder;
    return this;
  }
  register(callback) {
    if (this.pluginCallbacks.indexOf(callback) === -1) {
      this.pluginCallbacks.push(callback);
    }
    return this;
  }
  unregister(callback) {
    if (this.pluginCallbacks.indexOf(callback) !== -1) {
      this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
    }
    return this;
  }
  parse(data, path, onLoad, onError) {
    let json;
    const extensions = {};
    const plugins = {};
    const textDecoder = new TextDecoder();
    if (typeof data === "string") {
      json = JSON.parse(data);
    } else if (data instanceof ArrayBuffer) {
      const magic = textDecoder.decode(new Uint8Array(data, 0, 4));
      if (magic === BINARY_EXTENSION_HEADER_MAGIC) {
        try {
          extensions[EXTENSIONS.KHR_BINARY_GLTF] = new GLTFBinaryExtension(data);
        } catch (error) {
          if (onError) onError(error);
          return;
        }
        json = JSON.parse(extensions[EXTENSIONS.KHR_BINARY_GLTF].content);
      } else {
        json = JSON.parse(textDecoder.decode(data));
      }
    } else {
      json = data;
    }
    if (json.asset === void 0 || json.asset.version[0] < 2) {
      if (onError) onError(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
      return;
    }
    const parser = new GLTFParser(json, {
      path: path || this.resourcePath || "",
      crossOrigin: this.crossOrigin,
      requestHeader: this.requestHeader,
      manager: this.manager,
      ktx2Loader: this.ktx2Loader,
      meshoptDecoder: this.meshoptDecoder
    });
    parser.fileLoader.setRequestHeader(this.requestHeader);
    for (let i2 = 0; i2 < this.pluginCallbacks.length; i2++) {
      const plugin = this.pluginCallbacks[i2](parser);
      if (!plugin.name) console.error("THREE.GLTFLoader: Invalid plugin found: missing name");
      plugins[plugin.name] = plugin;
      extensions[plugin.name] = true;
    }
    if (json.extensionsUsed) {
      for (let i2 = 0; i2 < json.extensionsUsed.length; ++i2) {
        const extensionName = json.extensionsUsed[i2];
        const extensionsRequired = json.extensionsRequired || [];
        switch (extensionName) {
          case EXTENSIONS.KHR_MATERIALS_UNLIT:
            extensions[extensionName] = new GLTFMaterialsUnlitExtension();
            break;
          case EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
            extensions[extensionName] = new GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
            break;
          case EXTENSIONS.KHR_TEXTURE_TRANSFORM:
            extensions[extensionName] = new GLTFTextureTransformExtension();
            break;
          case EXTENSIONS.KHR_MESH_QUANTIZATION:
            extensions[extensionName] = new GLTFMeshQuantizationExtension();
            break;
          default:
            if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === void 0) {
              console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
      }
    }
    parser.setExtensions(extensions);
    parser.setPlugins(plugins);
    parser.parse(onLoad, onError);
  }
  parseAsync(data, path) {
    const scope = this;
    return new Promise(function(resolve, reject) {
      scope.parse(data, path, resolve, reject);
    });
  }
}
function GLTFRegistry() {
  let objects = {};
  return {
    get: function(key) {
      return objects[key];
    },
    add: function(key, object) {
      objects[key] = object;
    },
    remove: function(key) {
      delete objects[key];
    },
    removeAll: function() {
      objects = {};
    }
  };
}
const EXTENSIONS = {
  KHR_BINARY_GLTF: "KHR_binary_glTF",
  KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
  KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
  KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
  KHR_MATERIALS_DISPERSION: "KHR_materials_dispersion",
  KHR_MATERIALS_IOR: "KHR_materials_ior",
  KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
  KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
  KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
  KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
  KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
  KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
  KHR_MATERIALS_VOLUME: "KHR_materials_volume",
  KHR_TEXTURE_BASISU: "KHR_texture_basisu",
  KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
  KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
  KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
  EXT_MATERIALS_BUMP: "EXT_materials_bump",
  EXT_TEXTURE_WEBP: "EXT_texture_webp",
  EXT_TEXTURE_AVIF: "EXT_texture_avif",
  EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
  EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
class GLTFLightsExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
    this.cache = { refs: {}, uses: {} };
  }
  _markDefs() {
    const parser = this.parser;
    const nodeDefs = this.parser.json.nodes || [];
    for (let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
      const nodeDef = nodeDefs[nodeIndex];
      if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== void 0) {
        parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
      }
    }
  }
  _loadLight(lightIndex) {
    const parser = this.parser;
    const cacheKey = "light:" + lightIndex;
    let dependency = parser.cache.get(cacheKey);
    if (dependency) return dependency;
    const json = parser.json;
    const extensions = json.extensions && json.extensions[this.name] || {};
    const lightDefs = extensions.lights || [];
    const lightDef = lightDefs[lightIndex];
    let lightNode;
    const color2 = new Color$1(16777215);
    if (lightDef.color !== void 0) color2.setRGB(lightDef.color[0], lightDef.color[1], lightDef.color[2], LinearSRGBColorSpace);
    const range = lightDef.range !== void 0 ? lightDef.range : 0;
    switch (lightDef.type) {
      case "directional":
        lightNode = new DirectionalLight$1(color2);
        lightNode.target.position.set(0, 0, -1);
        lightNode.add(lightNode.target);
        break;
      case "point":
        lightNode = new PointLight$1(color2);
        lightNode.distance = range;
        break;
      case "spot":
        lightNode = new SpotLight$1(color2);
        lightNode.distance = range;
        lightDef.spot = lightDef.spot || {};
        lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== void 0 ? lightDef.spot.innerConeAngle : 0;
        lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== void 0 ? lightDef.spot.outerConeAngle : Math.PI / 4;
        lightNode.angle = lightDef.spot.outerConeAngle;
        lightNode.penumbra = 1 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
        lightNode.target.position.set(0, 0, -1);
        lightNode.add(lightNode.target);
        break;
      default:
        throw new Error("THREE.GLTFLoader: Unexpected light type: " + lightDef.type);
    }
    lightNode.position.set(0, 0, 0);
    lightNode.decay = 2;
    assignExtrasToUserData(lightNode, lightDef);
    if (lightDef.intensity !== void 0) lightNode.intensity = lightDef.intensity;
    lightNode.name = parser.createUniqueName(lightDef.name || "light_" + lightIndex);
    dependency = Promise.resolve(lightNode);
    parser.cache.add(cacheKey, dependency);
    return dependency;
  }
  getDependency(type, index2) {
    if (type !== "light") return;
    return this._loadLight(index2);
  }
  createNodeAttachment(nodeIndex) {
    const self2 = this;
    const parser = this.parser;
    const json = parser.json;
    const nodeDef = json.nodes[nodeIndex];
    const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
    const lightIndex = lightDef.light;
    if (lightIndex === void 0) return null;
    return this._loadLight(lightIndex).then(function(light) {
      return parser._getNodeRef(self2.cache, lightIndex, light);
    });
  }
}
class GLTFMaterialsUnlitExtension {
  constructor() {
    this.name = EXTENSIONS.KHR_MATERIALS_UNLIT;
  }
  getMaterialType() {
    return MeshBasicMaterial$1;
  }
  extendParams(materialParams, materialDef, parser) {
    const pending = [];
    materialParams.color = new Color$1(1, 1, 1);
    materialParams.opacity = 1;
    const metallicRoughness = materialDef.pbrMetallicRoughness;
    if (metallicRoughness) {
      if (Array.isArray(metallicRoughness.baseColorFactor)) {
        const array = metallicRoughness.baseColorFactor;
        materialParams.color.setRGB(array[0], array[1], array[2], LinearSRGBColorSpace);
        materialParams.opacity = array[3];
      }
      if (metallicRoughness.baseColorTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, SRGBColorSpace));
      }
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsEmissiveStrengthExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
    if (emissiveStrength !== void 0) {
      materialParams.emissiveIntensity = emissiveStrength;
    }
    return Promise.resolve();
  }
}
class GLTFMaterialsClearcoatExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
    return MeshPhysicalMaterial$1;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    if (extension.clearcoatFactor !== void 0) {
      materialParams.clearcoat = extension.clearcoatFactor;
    }
    if (extension.clearcoatTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "clearcoatMap", extension.clearcoatTexture));
    }
    if (extension.clearcoatRoughnessFactor !== void 0) {
      materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
    }
    if (extension.clearcoatRoughnessTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "clearcoatRoughnessMap", extension.clearcoatRoughnessTexture));
    }
    if (extension.clearcoatNormalTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "clearcoatNormalMap", extension.clearcoatNormalTexture));
      if (extension.clearcoatNormalTexture.scale !== void 0) {
        const scale = extension.clearcoatNormalTexture.scale;
        materialParams.clearcoatNormalScale = new Vector2$1(scale, scale);
      }
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsDispersionExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_DISPERSION;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
    return MeshPhysicalMaterial$1;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const extension = materialDef.extensions[this.name];
    materialParams.dispersion = extension.dispersion !== void 0 ? extension.dispersion : 0;
    return Promise.resolve();
  }
}
class GLTFMaterialsIridescenceExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
    return MeshPhysicalMaterial$1;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    if (extension.iridescenceFactor !== void 0) {
      materialParams.iridescence = extension.iridescenceFactor;
    }
    if (extension.iridescenceTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "iridescenceMap", extension.iridescenceTexture));
    }
    if (extension.iridescenceIor !== void 0) {
      materialParams.iridescenceIOR = extension.iridescenceIor;
    }
    if (materialParams.iridescenceThicknessRange === void 0) {
      materialParams.iridescenceThicknessRange = [100, 400];
    }
    if (extension.iridescenceThicknessMinimum !== void 0) {
      materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
    }
    if (extension.iridescenceThicknessMaximum !== void 0) {
      materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
    }
    if (extension.iridescenceThicknessTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "iridescenceThicknessMap", extension.iridescenceThicknessTexture));
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsSheenExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_SHEEN;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
    return MeshPhysicalMaterial$1;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    materialParams.sheenColor = new Color$1(0, 0, 0);
    materialParams.sheenRoughness = 0;
    materialParams.sheen = 1;
    const extension = materialDef.extensions[this.name];
    if (extension.sheenColorFactor !== void 0) {
      const colorFactor = extension.sheenColorFactor;
      materialParams.sheenColor.setRGB(colorFactor[0], colorFactor[1], colorFactor[2], LinearSRGBColorSpace);
    }
    if (extension.sheenRoughnessFactor !== void 0) {
      materialParams.sheenRoughness = extension.sheenRoughnessFactor;
    }
    if (extension.sheenColorTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "sheenColorMap", extension.sheenColorTexture, SRGBColorSpace));
    }
    if (extension.sheenRoughnessTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "sheenRoughnessMap", extension.sheenRoughnessTexture));
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsTransmissionExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
    return MeshPhysicalMaterial$1;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    if (extension.transmissionFactor !== void 0) {
      materialParams.transmission = extension.transmissionFactor;
    }
    if (extension.transmissionTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "transmissionMap", extension.transmissionTexture));
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsVolumeExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_VOLUME;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
    return MeshPhysicalMaterial$1;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    materialParams.thickness = extension.thicknessFactor !== void 0 ? extension.thicknessFactor : 0;
    if (extension.thicknessTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "thicknessMap", extension.thicknessTexture));
    }
    materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
    const colorArray = extension.attenuationColor || [1, 1, 1];
    materialParams.attenuationColor = new Color$1().setRGB(colorArray[0], colorArray[1], colorArray[2], LinearSRGBColorSpace);
    return Promise.all(pending);
  }
}
class GLTFMaterialsIorExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_IOR;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
    return MeshPhysicalMaterial$1;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const extension = materialDef.extensions[this.name];
    materialParams.ior = extension.ior !== void 0 ? extension.ior : 1.5;
    return Promise.resolve();
  }
}
class GLTFMaterialsSpecularExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_SPECULAR;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
    return MeshPhysicalMaterial$1;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    materialParams.specularIntensity = extension.specularFactor !== void 0 ? extension.specularFactor : 1;
    if (extension.specularTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "specularIntensityMap", extension.specularTexture));
    }
    const colorArray = extension.specularColorFactor || [1, 1, 1];
    materialParams.specularColor = new Color$1().setRGB(colorArray[0], colorArray[1], colorArray[2], LinearSRGBColorSpace);
    if (extension.specularColorTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "specularColorMap", extension.specularColorTexture, SRGBColorSpace));
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsBumpExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.EXT_MATERIALS_BUMP;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
    return MeshPhysicalMaterial$1;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    materialParams.bumpScale = extension.bumpFactor !== void 0 ? extension.bumpFactor : 1;
    if (extension.bumpTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "bumpMap", extension.bumpTexture));
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsAnisotropyExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
    return MeshPhysicalMaterial$1;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    if (extension.anisotropyStrength !== void 0) {
      materialParams.anisotropy = extension.anisotropyStrength;
    }
    if (extension.anisotropyRotation !== void 0) {
      materialParams.anisotropyRotation = extension.anisotropyRotation;
    }
    if (extension.anisotropyTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "anisotropyMap", extension.anisotropyTexture));
    }
    return Promise.all(pending);
  }
}
class GLTFTextureBasisUExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.KHR_TEXTURE_BASISU;
  }
  loadTexture(textureIndex) {
    const parser = this.parser;
    const json = parser.json;
    const textureDef = json.textures[textureIndex];
    if (!textureDef.extensions || !textureDef.extensions[this.name]) {
      return null;
    }
    const extension = textureDef.extensions[this.name];
    const loader = parser.options.ktx2Loader;
    if (!loader) {
      if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
        throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
      } else {
        return null;
      }
    }
    return parser.loadTextureImage(textureIndex, extension.source, loader);
  }
}
class GLTFTextureWebPExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.EXT_TEXTURE_WEBP;
    this.isSupported = null;
  }
  loadTexture(textureIndex) {
    const name = this.name;
    const parser = this.parser;
    const json = parser.json;
    const textureDef = json.textures[textureIndex];
    if (!textureDef.extensions || !textureDef.extensions[name]) {
      return null;
    }
    const extension = textureDef.extensions[name];
    const source = json.images[extension.source];
    let loader = parser.textureLoader;
    if (source.uri) {
      const handler = parser.options.manager.getHandler(source.uri);
      if (handler !== null) loader = handler;
    }
    return this.detectSupport().then(function(isSupported) {
      if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
      if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) {
        throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
      }
      return parser.loadTexture(textureIndex);
    });
  }
  detectSupport() {
    if (!this.isSupported) {
      this.isSupported = new Promise(function(resolve) {
        const image2 = new Image();
        image2.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
        image2.onload = image2.onerror = function() {
          resolve(image2.height === 1);
        };
      });
    }
    return this.isSupported;
  }
}
class GLTFTextureAVIFExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS.EXT_TEXTURE_AVIF;
    this.isSupported = null;
  }
  loadTexture(textureIndex) {
    const name = this.name;
    const parser = this.parser;
    const json = parser.json;
    const textureDef = json.textures[textureIndex];
    if (!textureDef.extensions || !textureDef.extensions[name]) {
      return null;
    }
    const extension = textureDef.extensions[name];
    const source = json.images[extension.source];
    let loader = parser.textureLoader;
    if (source.uri) {
      const handler = parser.options.manager.getHandler(source.uri);
      if (handler !== null) loader = handler;
    }
    return this.detectSupport().then(function(isSupported) {
      if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
      if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) {
        throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
      }
      return parser.loadTexture(textureIndex);
    });
  }
  detectSupport() {
    if (!this.isSupported) {
      this.isSupported = new Promise(function(resolve) {
        const image2 = new Image();
        image2.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=";
        image2.onload = image2.onerror = function() {
          resolve(image2.height === 1);
        };
      });
    }
    return this.isSupported;
  }
}
class GLTFMeshoptCompression {
  constructor(parser) {
    this.name = EXTENSIONS.EXT_MESHOPT_COMPRESSION;
    this.parser = parser;
  }
  loadBufferView(index2) {
    const json = this.parser.json;
    const bufferView = json.bufferViews[index2];
    if (bufferView.extensions && bufferView.extensions[this.name]) {
      const extensionDef = bufferView.extensions[this.name];
      const buffer = this.parser.getDependency("buffer", extensionDef.buffer);
      const decoder = this.parser.options.meshoptDecoder;
      if (!decoder || !decoder.supported) {
        if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
          throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
        } else {
          return null;
        }
      }
      return buffer.then(function(res) {
        const byteOffset = extensionDef.byteOffset || 0;
        const byteLength = extensionDef.byteLength || 0;
        const count = extensionDef.count;
        const stride = extensionDef.byteStride;
        const source = new Uint8Array(res, byteOffset, byteLength);
        if (decoder.decodeGltfBufferAsync) {
          return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res2) {
            return res2.buffer;
          });
        } else {
          return decoder.ready.then(function() {
            const result = new ArrayBuffer(count * stride);
            decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
            return result;
          });
        }
      });
    } else {
      return null;
    }
  }
}
class GLTFMeshGpuInstancing {
  constructor(parser) {
    this.name = EXTENSIONS.EXT_MESH_GPU_INSTANCING;
    this.parser = parser;
  }
  createNodeMesh(nodeIndex) {
    const json = this.parser.json;
    const nodeDef = json.nodes[nodeIndex];
    if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === void 0) {
      return null;
    }
    const meshDef = json.meshes[nodeDef.mesh];
    for (const primitive of meshDef.primitives) {
      if (primitive.mode !== WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== void 0) {
        return null;
      }
    }
    const extensionDef = nodeDef.extensions[this.name];
    const attributesDef = extensionDef.attributes;
    const pending = [];
    const attributes = {};
    for (const key in attributesDef) {
      pending.push(this.parser.getDependency("accessor", attributesDef[key]).then((accessor) => {
        attributes[key] = accessor;
        return attributes[key];
      }));
    }
    if (pending.length < 1) {
      return null;
    }
    pending.push(this.parser.createNodeMesh(nodeIndex));
    return Promise.all(pending).then((results) => {
      const nodeObject = results.pop();
      const meshes = nodeObject.isGroup ? nodeObject.children : [nodeObject];
      const count = results[0].count;
      const instancedMeshes = [];
      for (const mesh of meshes) {
        const m = new Matrix4$1();
        const p2 = new Vector3$1();
        const q = new Quaternion$1();
        const s2 = new Vector3$1(1, 1, 1);
        const instancedMesh = new InstancedMesh$1(mesh.geometry, mesh.material, count);
        for (let i2 = 0; i2 < count; i2++) {
          if (attributes.TRANSLATION) {
            p2.fromBufferAttribute(attributes.TRANSLATION, i2);
          }
          if (attributes.ROTATION) {
            q.fromBufferAttribute(attributes.ROTATION, i2);
          }
          if (attributes.SCALE) {
            s2.fromBufferAttribute(attributes.SCALE, i2);
          }
          instancedMesh.setMatrixAt(i2, m.compose(p2, q, s2));
        }
        for (const attributeName in attributes) {
          if (attributeName === "_COLOR_0") {
            const attr = attributes[attributeName];
            instancedMesh.instanceColor = new InstancedBufferAttribute$1(attr.array, attr.itemSize, attr.normalized);
          } else if (attributeName !== "TRANSLATION" && attributeName !== "ROTATION" && attributeName !== "SCALE") {
            mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
          }
        }
        Object3D$1.prototype.copy.call(instancedMesh, mesh);
        this.parser.assignFinalMaterial(instancedMesh);
        instancedMeshes.push(instancedMesh);
      }
      if (nodeObject.isGroup) {
        nodeObject.clear();
        nodeObject.add(...instancedMeshes);
        return nodeObject;
      }
      return instancedMeshes[0];
    });
  }
}
const BINARY_EXTENSION_HEADER_MAGIC = "glTF";
const BINARY_EXTENSION_HEADER_LENGTH = 12;
const BINARY_EXTENSION_CHUNK_TYPES = { JSON: 1313821514, BIN: 5130562 };
class GLTFBinaryExtension {
  constructor(data) {
    this.name = EXTENSIONS.KHR_BINARY_GLTF;
    this.content = null;
    this.body = null;
    const headerView = new DataView(data, 0, BINARY_EXTENSION_HEADER_LENGTH);
    const textDecoder = new TextDecoder();
    this.header = {
      magic: textDecoder.decode(new Uint8Array(data.slice(0, 4))),
      version: headerView.getUint32(4, true),
      length: headerView.getUint32(8, true)
    };
    if (this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC) {
      throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
    } else if (this.header.version < 2) {
      throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
    }
    const chunkContentsLength = this.header.length - BINARY_EXTENSION_HEADER_LENGTH;
    const chunkView = new DataView(data, BINARY_EXTENSION_HEADER_LENGTH);
    let chunkIndex = 0;
    while (chunkIndex < chunkContentsLength) {
      const chunkLength = chunkView.getUint32(chunkIndex, true);
      chunkIndex += 4;
      const chunkType = chunkView.getUint32(chunkIndex, true);
      chunkIndex += 4;
      if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.JSON) {
        const contentArray = new Uint8Array(data, BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
        this.content = textDecoder.decode(contentArray);
      } else if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.BIN) {
        const byteOffset = BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
        this.body = data.slice(byteOffset, byteOffset + chunkLength);
      }
      chunkIndex += chunkLength;
    }
    if (this.content === null) {
      throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
  }
}
class GLTFDracoMeshCompressionExtension {
  constructor(json, dracoLoader) {
    if (!dracoLoader) {
      throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
    }
    this.name = EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
    this.json = json;
    this.dracoLoader = dracoLoader;
    this.dracoLoader.preload();
  }
  decodePrimitive(primitive, parser) {
    const json = this.json;
    const dracoLoader = this.dracoLoader;
    const bufferViewIndex = primitive.extensions[this.name].bufferView;
    const gltfAttributeMap = primitive.extensions[this.name].attributes;
    const threeAttributeMap = {};
    const attributeNormalizedMap = {};
    const attributeTypeMap = {};
    for (const attributeName in gltfAttributeMap) {
      const threeAttributeName = ATTRIBUTES[attributeName] || attributeName.toLowerCase();
      threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
    }
    for (const attributeName in primitive.attributes) {
      const threeAttributeName = ATTRIBUTES[attributeName] || attributeName.toLowerCase();
      if (gltfAttributeMap[attributeName] !== void 0) {
        const accessorDef = json.accessors[primitive.attributes[attributeName]];
        const componentType = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
        attributeTypeMap[threeAttributeName] = componentType.name;
        attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
      }
    }
    return parser.getDependency("bufferView", bufferViewIndex).then(function(bufferView) {
      return new Promise(function(resolve, reject) {
        dracoLoader.decodeDracoFile(bufferView, function(geometry) {
          for (const attributeName in geometry.attributes) {
            const attribute = geometry.attributes[attributeName];
            const normalized = attributeNormalizedMap[attributeName];
            if (normalized !== void 0) attribute.normalized = normalized;
          }
          resolve(geometry);
        }, threeAttributeMap, attributeTypeMap, LinearSRGBColorSpace, reject);
      });
    });
  }
}
class GLTFTextureTransformExtension {
  constructor() {
    this.name = EXTENSIONS.KHR_TEXTURE_TRANSFORM;
  }
  extendTexture(texture, transform2) {
    if ((transform2.texCoord === void 0 || transform2.texCoord === texture.channel) && transform2.offset === void 0 && transform2.rotation === void 0 && transform2.scale === void 0) {
      return texture;
    }
    texture = texture.clone();
    if (transform2.texCoord !== void 0) {
      texture.channel = transform2.texCoord;
    }
    if (transform2.offset !== void 0) {
      texture.offset.fromArray(transform2.offset);
    }
    if (transform2.rotation !== void 0) {
      texture.rotation = transform2.rotation;
    }
    if (transform2.scale !== void 0) {
      texture.repeat.fromArray(transform2.scale);
    }
    texture.needsUpdate = true;
    return texture;
  }
}
class GLTFMeshQuantizationExtension {
  constructor() {
    this.name = EXTENSIONS.KHR_MESH_QUANTIZATION;
  }
}
class GLTFCubicSplineInterpolant extends Interpolant$1 {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  copySampleValue_(index2) {
    const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index2 * valueSize * 3 + valueSize;
    for (let i2 = 0; i2 !== valueSize; i2++) {
      result[i2] = values[offset + i2];
    }
    return result;
  }
  interpolate_(i1, t0, t3, t1) {
    const result = this.resultBuffer;
    const values = this.sampleValues;
    const stride = this.valueSize;
    const stride2 = stride * 2;
    const stride3 = stride * 3;
    const td2 = t1 - t0;
    const p2 = (t3 - t0) / td2;
    const pp = p2 * p2;
    const ppp = pp * p2;
    const offset1 = i1 * stride3;
    const offset0 = offset1 - stride3;
    const s2 = -2 * ppp + 3 * pp;
    const s3 = ppp - pp;
    const s0 = 1 - s2;
    const s1 = s3 - pp + p2;
    for (let i2 = 0; i2 !== stride; i2++) {
      const p0 = values[offset0 + i2 + stride];
      const m0 = values[offset0 + i2 + stride2] * td2;
      const p1 = values[offset1 + i2 + stride];
      const m1 = values[offset1 + i2] * td2;
      result[i2] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
    }
    return result;
  }
}
const _q = new Quaternion$1();
class GLTFCubicSplineQuaternionInterpolant extends GLTFCubicSplineInterpolant {
  interpolate_(i1, t0, t3, t1) {
    const result = super.interpolate_(i1, t0, t3, t1);
    _q.fromArray(result).normalize().toArray(result);
    return result;
  }
}
const WEBGL_CONSTANTS = {
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6
};
const WEBGL_COMPONENT_TYPES = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
};
const WEBGL_FILTERS = {
  9728: NearestFilter$1,
  9729: LinearFilter$1,
  9984: NearestMipmapNearestFilter$1,
  9985: LinearMipmapNearestFilter$1,
  9986: NearestMipmapLinearFilter$1,
  9987: LinearMipmapLinearFilter$1
};
const WEBGL_WRAPPINGS = {
  33071: ClampToEdgeWrapping$1,
  33648: MirroredRepeatWrapping$1,
  10497: RepeatWrapping$1
};
const WEBGL_TYPE_SIZES = {
  "SCALAR": 1,
  "VEC2": 2,
  "VEC3": 3,
  "VEC4": 4,
  "MAT2": 4,
  "MAT3": 9,
  "MAT4": 16
};
const ATTRIBUTES = {
  POSITION: "position",
  NORMAL: "normal",
  TANGENT: "tangent",
  TEXCOORD_0: "uv",
  TEXCOORD_1: "uv1",
  TEXCOORD_2: "uv2",
  TEXCOORD_3: "uv3",
  COLOR_0: "color",
  WEIGHTS_0: "skinWeight",
  JOINTS_0: "skinIndex"
};
const PATH_PROPERTIES = {
  scale: "scale",
  translation: "position",
  rotation: "quaternion",
  weights: "morphTargetInfluences"
};
const INTERPOLATION = {
  CUBICSPLINE: void 0,
  // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
  // keyframe track will be initialized with a default interpolation type, then modified.
  LINEAR: InterpolateLinear$1,
  STEP: InterpolateDiscrete$1
};
const ALPHA_MODES = {
  OPAQUE: "OPAQUE",
  MASK: "MASK",
  BLEND: "BLEND"
};
function createDefaultMaterial(cache) {
  if (cache["DefaultMaterial"] === void 0) {
    cache["DefaultMaterial"] = new MeshStandardMaterial$1({
      color: 16777215,
      emissive: 0,
      metalness: 1,
      roughness: 1,
      transparent: false,
      depthTest: true,
      side: FrontSide$1
    });
  }
  return cache["DefaultMaterial"];
}
function addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
  for (const name in objectDef.extensions) {
    if (knownExtensions[name] === void 0) {
      object.userData.gltfExtensions = object.userData.gltfExtensions || {};
      object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
  }
}
function assignExtrasToUserData(object, gltfDef) {
  if (gltfDef.extras !== void 0) {
    if (typeof gltfDef.extras === "object") {
      Object.assign(object.userData, gltfDef.extras);
    } else {
      console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + gltfDef.extras);
    }
  }
}
function addMorphTargets(geometry, targets, parser) {
  let hasMorphPosition = false;
  let hasMorphNormal = false;
  let hasMorphColor = false;
  for (let i2 = 0, il = targets.length; i2 < il; i2++) {
    const target = targets[i2];
    if (target.POSITION !== void 0) hasMorphPosition = true;
    if (target.NORMAL !== void 0) hasMorphNormal = true;
    if (target.COLOR_0 !== void 0) hasMorphColor = true;
    if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
  }
  if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
  const pendingPositionAccessors = [];
  const pendingNormalAccessors = [];
  const pendingColorAccessors = [];
  for (let i2 = 0, il = targets.length; i2 < il; i2++) {
    const target = targets[i2];
    if (hasMorphPosition) {
      const pendingAccessor = target.POSITION !== void 0 ? parser.getDependency("accessor", target.POSITION) : geometry.attributes.position;
      pendingPositionAccessors.push(pendingAccessor);
    }
    if (hasMorphNormal) {
      const pendingAccessor = target.NORMAL !== void 0 ? parser.getDependency("accessor", target.NORMAL) : geometry.attributes.normal;
      pendingNormalAccessors.push(pendingAccessor);
    }
    if (hasMorphColor) {
      const pendingAccessor = target.COLOR_0 !== void 0 ? parser.getDependency("accessor", target.COLOR_0) : geometry.attributes.color;
      pendingColorAccessors.push(pendingAccessor);
    }
  }
  return Promise.all([
    Promise.all(pendingPositionAccessors),
    Promise.all(pendingNormalAccessors),
    Promise.all(pendingColorAccessors)
  ]).then(function(accessors) {
    const morphPositions = accessors[0];
    const morphNormals = accessors[1];
    const morphColors = accessors[2];
    if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
    if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
    if (hasMorphColor) geometry.morphAttributes.color = morphColors;
    geometry.morphTargetsRelative = true;
    return geometry;
  });
}
function updateMorphTargets(mesh, meshDef) {
  mesh.updateMorphTargets();
  if (meshDef.weights !== void 0) {
    for (let i2 = 0, il = meshDef.weights.length; i2 < il; i2++) {
      mesh.morphTargetInfluences[i2] = meshDef.weights[i2];
    }
  }
  if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
    const targetNames = meshDef.extras.targetNames;
    if (mesh.morphTargetInfluences.length === targetNames.length) {
      mesh.morphTargetDictionary = {};
      for (let i2 = 0, il = targetNames.length; i2 < il; i2++) {
        mesh.morphTargetDictionary[targetNames[i2]] = i2;
      }
    } else {
      console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
  }
}
function createPrimitiveKey(primitiveDef) {
  let geometryKey;
  const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
  if (dracoExtension) {
    geometryKey = "draco:" + dracoExtension.bufferView + ":" + dracoExtension.indices + ":" + createAttributesKey(dracoExtension.attributes);
  } else {
    geometryKey = primitiveDef.indices + ":" + createAttributesKey(primitiveDef.attributes) + ":" + primitiveDef.mode;
  }
  if (primitiveDef.targets !== void 0) {
    for (let i2 = 0, il = primitiveDef.targets.length; i2 < il; i2++) {
      geometryKey += ":" + createAttributesKey(primitiveDef.targets[i2]);
    }
  }
  return geometryKey;
}
function createAttributesKey(attributes) {
  let attributesKey = "";
  const keys = Object.keys(attributes).sort();
  for (let i2 = 0, il = keys.length; i2 < il; i2++) {
    attributesKey += keys[i2] + ":" + attributes[keys[i2]] + ";";
  }
  return attributesKey;
}
function getNormalizedComponentScale(constructor) {
  switch (constructor) {
    case Int8Array:
      return 1 / 127;
    case Uint8Array:
      return 1 / 255;
    case Int16Array:
      return 1 / 32767;
    case Uint16Array:
      return 1 / 65535;
    default:
      throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
  }
}
function getImageURIMimeType(uri) {
  if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return "image/jpeg";
  if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return "image/webp";
  if (uri.search(/\.ktx2($|\?)/i) > 0 || uri.search(/^data\:image\/ktx2/) === 0) return "image/ktx2";
  return "image/png";
}
const _identityMatrix = new Matrix4$1();
class GLTFParser {
  constructor(json = {}, options = {}) {
    this.json = json;
    this.extensions = {};
    this.plugins = {};
    this.options = options;
    this.cache = new GLTFRegistry();
    this.associations = /* @__PURE__ */ new Map();
    this.primitiveCache = {};
    this.nodeCache = {};
    this.meshCache = { refs: {}, uses: {} };
    this.cameraCache = { refs: {}, uses: {} };
    this.lightCache = { refs: {}, uses: {} };
    this.sourceCache = {};
    this.textureCache = {};
    this.nodeNamesUsed = {};
    let isSafari = false;
    let safariVersion = -1;
    let isFirefox = false;
    let firefoxVersion = -1;
    if (typeof navigator !== "undefined") {
      const userAgent = navigator.userAgent;
      isSafari = /^((?!chrome|android).)*safari/i.test(userAgent) === true;
      const safariMatch = userAgent.match(/Version\/(\d+)/);
      safariVersion = isSafari && safariMatch ? parseInt(safariMatch[1], 10) : -1;
      isFirefox = userAgent.indexOf("Firefox") > -1;
      firefoxVersion = isFirefox ? userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
    }
    if (typeof createImageBitmap === "undefined" || isSafari && safariVersion < 17 || isFirefox && firefoxVersion < 98) {
      this.textureLoader = new TextureLoader$1(this.options.manager);
    } else {
      this.textureLoader = new ImageBitmapLoader$1(this.options.manager);
    }
    this.textureLoader.setCrossOrigin(this.options.crossOrigin);
    this.textureLoader.setRequestHeader(this.options.requestHeader);
    this.fileLoader = new FileLoader$1(this.options.manager);
    this.fileLoader.setResponseType("arraybuffer");
    if (this.options.crossOrigin === "use-credentials") {
      this.fileLoader.setWithCredentials(true);
    }
  }
  setExtensions(extensions) {
    this.extensions = extensions;
  }
  setPlugins(plugins) {
    this.plugins = plugins;
  }
  parse(onLoad, onError) {
    const parser = this;
    const json = this.json;
    const extensions = this.extensions;
    this.cache.removeAll();
    this.nodeCache = {};
    this._invokeAll(function(ext) {
      return ext._markDefs && ext._markDefs();
    });
    Promise.all(this._invokeAll(function(ext) {
      return ext.beforeRoot && ext.beforeRoot();
    })).then(function() {
      return Promise.all([
        parser.getDependencies("scene"),
        parser.getDependencies("animation"),
        parser.getDependencies("camera")
      ]);
    }).then(function(dependencies) {
      const result = {
        scene: dependencies[0][json.scene || 0],
        scenes: dependencies[0],
        animations: dependencies[1],
        cameras: dependencies[2],
        asset: json.asset,
        parser,
        userData: {}
      };
      addUnknownExtensionsToUserData(extensions, result, json);
      assignExtrasToUserData(result, json);
      return Promise.all(parser._invokeAll(function(ext) {
        return ext.afterRoot && ext.afterRoot(result);
      })).then(function() {
        for (const scene of result.scenes) {
          scene.updateMatrixWorld();
        }
        onLoad(result);
      });
    }).catch(onError);
  }
  /**
   * Marks the special nodes/meshes in json for efficient parse.
   */
  _markDefs() {
    const nodeDefs = this.json.nodes || [];
    const skinDefs = this.json.skins || [];
    const meshDefs = this.json.meshes || [];
    for (let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++) {
      const joints = skinDefs[skinIndex].joints;
      for (let i2 = 0, il = joints.length; i2 < il; i2++) {
        nodeDefs[joints[i2]].isBone = true;
      }
    }
    for (let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
      const nodeDef = nodeDefs[nodeIndex];
      if (nodeDef.mesh !== void 0) {
        this._addNodeRef(this.meshCache, nodeDef.mesh);
        if (nodeDef.skin !== void 0) {
          meshDefs[nodeDef.mesh].isSkinnedMesh = true;
        }
      }
      if (nodeDef.camera !== void 0) {
        this._addNodeRef(this.cameraCache, nodeDef.camera);
      }
    }
  }
  /**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   */
  _addNodeRef(cache, index2) {
    if (index2 === void 0) return;
    if (cache.refs[index2] === void 0) {
      cache.refs[index2] = cache.uses[index2] = 0;
    }
    cache.refs[index2]++;
  }
  /** Returns a reference to a shared resource, cloning it if necessary. */
  _getNodeRef(cache, index2, object) {
    if (cache.refs[index2] <= 1) return object;
    const ref = object.clone();
    const updateMappings = (original, clone2) => {
      const mappings = this.associations.get(original);
      if (mappings != null) {
        this.associations.set(clone2, mappings);
      }
      for (const [i2, child] of original.children.entries()) {
        updateMappings(child, clone2.children[i2]);
      }
    };
    updateMappings(object, ref);
    ref.name += "_instance_" + cache.uses[index2]++;
    return ref;
  }
  _invokeOne(func) {
    const extensions = Object.values(this.plugins);
    extensions.push(this);
    for (let i2 = 0; i2 < extensions.length; i2++) {
      const result = func(extensions[i2]);
      if (result) return result;
    }
    return null;
  }
  _invokeAll(func) {
    const extensions = Object.values(this.plugins);
    extensions.unshift(this);
    const pending = [];
    for (let i2 = 0; i2 < extensions.length; i2++) {
      const result = func(extensions[i2]);
      if (result) pending.push(result);
    }
    return pending;
  }
  /**
   * Requests the specified dependency asynchronously, with caching.
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
   */
  getDependency(type, index2) {
    const cacheKey = type + ":" + index2;
    let dependency = this.cache.get(cacheKey);
    if (!dependency) {
      switch (type) {
        case "scene":
          dependency = this.loadScene(index2);
          break;
        case "node":
          dependency = this._invokeOne(function(ext) {
            return ext.loadNode && ext.loadNode(index2);
          });
          break;
        case "mesh":
          dependency = this._invokeOne(function(ext) {
            return ext.loadMesh && ext.loadMesh(index2);
          });
          break;
        case "accessor":
          dependency = this.loadAccessor(index2);
          break;
        case "bufferView":
          dependency = this._invokeOne(function(ext) {
            return ext.loadBufferView && ext.loadBufferView(index2);
          });
          break;
        case "buffer":
          dependency = this.loadBuffer(index2);
          break;
        case "material":
          dependency = this._invokeOne(function(ext) {
            return ext.loadMaterial && ext.loadMaterial(index2);
          });
          break;
        case "texture":
          dependency = this._invokeOne(function(ext) {
            return ext.loadTexture && ext.loadTexture(index2);
          });
          break;
        case "skin":
          dependency = this.loadSkin(index2);
          break;
        case "animation":
          dependency = this._invokeOne(function(ext) {
            return ext.loadAnimation && ext.loadAnimation(index2);
          });
          break;
        case "camera":
          dependency = this.loadCamera(index2);
          break;
        default:
          dependency = this._invokeOne(function(ext) {
            return ext != this && ext.getDependency && ext.getDependency(type, index2);
          });
          if (!dependency) {
            throw new Error("Unknown type: " + type);
          }
          break;
      }
      this.cache.add(cacheKey, dependency);
    }
    return dependency;
  }
  /**
   * Requests all dependencies of the specified type asynchronously, with caching.
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */
  getDependencies(type) {
    let dependencies = this.cache.get(type);
    if (!dependencies) {
      const parser = this;
      const defs = this.json[type + (type === "mesh" ? "es" : "s")] || [];
      dependencies = Promise.all(defs.map(function(def, index2) {
        return parser.getDependency(type, index2);
      }));
      this.cache.add(type, dependencies);
    }
    return dependencies;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBuffer(bufferIndex) {
    const bufferDef = this.json.buffers[bufferIndex];
    const loader = this.fileLoader;
    if (bufferDef.type && bufferDef.type !== "arraybuffer") {
      throw new Error("THREE.GLTFLoader: " + bufferDef.type + " buffer type is not supported.");
    }
    if (bufferDef.uri === void 0 && bufferIndex === 0) {
      return Promise.resolve(this.extensions[EXTENSIONS.KHR_BINARY_GLTF].body);
    }
    const options = this.options;
    return new Promise(function(resolve, reject) {
      loader.load(LoaderUtils$1.resolveURL(bufferDef.uri, options.path), resolve, void 0, function() {
        reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
      });
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBufferView(bufferViewIndex) {
    const bufferViewDef = this.json.bufferViews[bufferViewIndex];
    return this.getDependency("buffer", bufferViewDef.buffer).then(function(buffer) {
      const byteLength = bufferViewDef.byteLength || 0;
      const byteOffset = bufferViewDef.byteOffset || 0;
      return buffer.slice(byteOffset, byteOffset + byteLength);
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */
  loadAccessor(accessorIndex) {
    const parser = this;
    const json = this.json;
    const accessorDef = this.json.accessors[accessorIndex];
    if (accessorDef.bufferView === void 0 && accessorDef.sparse === void 0) {
      const itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
      const TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
      const normalized = accessorDef.normalized === true;
      const array = new TypedArray(accessorDef.count * itemSize);
      return Promise.resolve(new BufferAttribute$1(array, itemSize, normalized));
    }
    const pendingBufferViews = [];
    if (accessorDef.bufferView !== void 0) {
      pendingBufferViews.push(this.getDependency("bufferView", accessorDef.bufferView));
    } else {
      pendingBufferViews.push(null);
    }
    if (accessorDef.sparse !== void 0) {
      pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.indices.bufferView));
      pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.values.bufferView));
    }
    return Promise.all(pendingBufferViews).then(function(bufferViews) {
      const bufferView = bufferViews[0];
      const itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
      const TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
      const elementBytes = TypedArray.BYTES_PER_ELEMENT;
      const itemBytes = elementBytes * itemSize;
      const byteOffset = accessorDef.byteOffset || 0;
      const byteStride = accessorDef.bufferView !== void 0 ? json.bufferViews[accessorDef.bufferView].byteStride : void 0;
      const normalized = accessorDef.normalized === true;
      let array, bufferAttribute;
      if (byteStride && byteStride !== itemBytes) {
        const ibSlice = Math.floor(byteOffset / byteStride);
        const ibCacheKey = "InterleavedBuffer:" + accessorDef.bufferView + ":" + accessorDef.componentType + ":" + ibSlice + ":" + accessorDef.count;
        let ib = parser.cache.get(ibCacheKey);
        if (!ib) {
          array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
          ib = new InterleavedBuffer$1(array, byteStride / elementBytes);
          parser.cache.add(ibCacheKey, ib);
        }
        bufferAttribute = new InterleavedBufferAttribute$1(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
      } else {
        if (bufferView === null) {
          array = new TypedArray(accessorDef.count * itemSize);
        } else {
          array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
        }
        bufferAttribute = new BufferAttribute$1(array, itemSize, normalized);
      }
      if (accessorDef.sparse !== void 0) {
        const itemSizeIndices = WEBGL_TYPE_SIZES.SCALAR;
        const TypedArrayIndices = WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
        const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
        const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
        const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
        const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
        if (bufferView !== null) {
          bufferAttribute = new BufferAttribute$1(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
        }
        bufferAttribute.normalized = false;
        for (let i2 = 0, il = sparseIndices.length; i2 < il; i2++) {
          const index2 = sparseIndices[i2];
          bufferAttribute.setX(index2, sparseValues[i2 * itemSize]);
          if (itemSize >= 2) bufferAttribute.setY(index2, sparseValues[i2 * itemSize + 1]);
          if (itemSize >= 3) bufferAttribute.setZ(index2, sparseValues[i2 * itemSize + 2]);
          if (itemSize >= 4) bufferAttribute.setW(index2, sparseValues[i2 * itemSize + 3]);
          if (itemSize >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
        }
        bufferAttribute.normalized = normalized;
      }
      return bufferAttribute;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   * @param {number} textureIndex
   * @return {Promise<THREE.Texture|null>}
   */
  loadTexture(textureIndex) {
    const json = this.json;
    const options = this.options;
    const textureDef = json.textures[textureIndex];
    const sourceIndex = textureDef.source;
    const sourceDef = json.images[sourceIndex];
    let loader = this.textureLoader;
    if (sourceDef.uri) {
      const handler = options.manager.getHandler(sourceDef.uri);
      if (handler !== null) loader = handler;
    }
    return this.loadTextureImage(textureIndex, sourceIndex, loader);
  }
  loadTextureImage(textureIndex, sourceIndex, loader) {
    const parser = this;
    const json = this.json;
    const textureDef = json.textures[textureIndex];
    const sourceDef = json.images[sourceIndex];
    const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ":" + textureDef.sampler;
    if (this.textureCache[cacheKey]) {
      return this.textureCache[cacheKey];
    }
    const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
      texture.flipY = false;
      texture.name = textureDef.name || sourceDef.name || "";
      if (texture.name === "" && typeof sourceDef.uri === "string" && sourceDef.uri.startsWith("data:image/") === false) {
        texture.name = sourceDef.uri;
      }
      const samplers = json.samplers || {};
      const sampler = samplers[textureDef.sampler] || {};
      texture.magFilter = WEBGL_FILTERS[sampler.magFilter] || LinearFilter$1;
      texture.minFilter = WEBGL_FILTERS[sampler.minFilter] || LinearMipmapLinearFilter$1;
      texture.wrapS = WEBGL_WRAPPINGS[sampler.wrapS] || RepeatWrapping$1;
      texture.wrapT = WEBGL_WRAPPINGS[sampler.wrapT] || RepeatWrapping$1;
      texture.generateMipmaps = !texture.isCompressedTexture && texture.minFilter !== NearestFilter$1 && texture.minFilter !== LinearFilter$1;
      parser.associations.set(texture, { textures: textureIndex });
      return texture;
    }).catch(function() {
      return null;
    });
    this.textureCache[cacheKey] = promise;
    return promise;
  }
  loadImageSource(sourceIndex, loader) {
    const parser = this;
    const json = this.json;
    const options = this.options;
    if (this.sourceCache[sourceIndex] !== void 0) {
      return this.sourceCache[sourceIndex].then((texture) => texture.clone());
    }
    const sourceDef = json.images[sourceIndex];
    const URL2 = self.URL || self.webkitURL;
    let sourceURI = sourceDef.uri || "";
    let isObjectURL = false;
    if (sourceDef.bufferView !== void 0) {
      sourceURI = parser.getDependency("bufferView", sourceDef.bufferView).then(function(bufferView) {
        isObjectURL = true;
        const blob = new Blob([bufferView], { type: sourceDef.mimeType });
        sourceURI = URL2.createObjectURL(blob);
        return sourceURI;
      });
    } else if (sourceDef.uri === void 0) {
      throw new Error("THREE.GLTFLoader: Image " + sourceIndex + " is missing URI and bufferView");
    }
    const promise = Promise.resolve(sourceURI).then(function(sourceURI2) {
      return new Promise(function(resolve, reject) {
        let onLoad = resolve;
        if (loader.isImageBitmapLoader === true) {
          onLoad = function(imageBitmap) {
            const texture = new Texture$1(imageBitmap);
            texture.needsUpdate = true;
            resolve(texture);
          };
        }
        loader.load(LoaderUtils$1.resolveURL(sourceURI2, options.path), onLoad, void 0, reject);
      });
    }).then(function(texture) {
      if (isObjectURL === true) {
        URL2.revokeObjectURL(sourceURI);
      }
      assignExtrasToUserData(texture, sourceDef);
      texture.userData.mimeType = sourceDef.mimeType || getImageURIMimeType(sourceDef.uri);
      return texture;
    }).catch(function(error) {
      console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
      throw error;
    });
    this.sourceCache[sourceIndex] = promise;
    return promise;
  }
  /**
   * Asynchronously assigns a texture to the given material parameters.
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @return {Promise<Texture>}
   */
  assignTexture(materialParams, mapName, mapDef, colorSpace) {
    const parser = this;
    return this.getDependency("texture", mapDef.index).then(function(texture) {
      if (!texture) return null;
      if (mapDef.texCoord !== void 0 && mapDef.texCoord > 0) {
        texture = texture.clone();
        texture.channel = mapDef.texCoord;
      }
      if (parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
        const transform2 = mapDef.extensions !== void 0 ? mapDef.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM] : void 0;
        if (transform2) {
          const gltfReference = parser.associations.get(texture);
          texture = parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform2);
          parser.associations.set(texture, gltfReference);
        }
      }
      if (colorSpace !== void 0) {
        texture.colorSpace = colorSpace;
      }
      materialParams[mapName] = texture;
      return texture;
    });
  }
  /**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   * @param  {Object3D} mesh Mesh, Line, or Points instance.
   */
  assignFinalMaterial(mesh) {
    const geometry = mesh.geometry;
    let material = mesh.material;
    const useDerivativeTangents = geometry.attributes.tangent === void 0;
    const useVertexColors = geometry.attributes.color !== void 0;
    const useFlatShading = geometry.attributes.normal === void 0;
    if (mesh.isPoints) {
      const cacheKey = "PointsMaterial:" + material.uuid;
      let pointsMaterial = this.cache.get(cacheKey);
      if (!pointsMaterial) {
        pointsMaterial = new PointsMaterial$1();
        Material$1.prototype.copy.call(pointsMaterial, material);
        pointsMaterial.color.copy(material.color);
        pointsMaterial.map = material.map;
        pointsMaterial.sizeAttenuation = false;
        this.cache.add(cacheKey, pointsMaterial);
      }
      material = pointsMaterial;
    } else if (mesh.isLine) {
      const cacheKey = "LineBasicMaterial:" + material.uuid;
      let lineMaterial = this.cache.get(cacheKey);
      if (!lineMaterial) {
        lineMaterial = new LineBasicMaterial$1();
        Material$1.prototype.copy.call(lineMaterial, material);
        lineMaterial.color.copy(material.color);
        lineMaterial.map = material.map;
        this.cache.add(cacheKey, lineMaterial);
      }
      material = lineMaterial;
    }
    if (useDerivativeTangents || useVertexColors || useFlatShading) {
      let cacheKey = "ClonedMaterial:" + material.uuid + ":";
      if (useDerivativeTangents) cacheKey += "derivative-tangents:";
      if (useVertexColors) cacheKey += "vertex-colors:";
      if (useFlatShading) cacheKey += "flat-shading:";
      let cachedMaterial = this.cache.get(cacheKey);
      if (!cachedMaterial) {
        cachedMaterial = material.clone();
        if (useVertexColors) cachedMaterial.vertexColors = true;
        if (useFlatShading) cachedMaterial.flatShading = true;
        if (useDerivativeTangents) {
          if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
          if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
        }
        this.cache.add(cacheKey, cachedMaterial);
        this.associations.set(cachedMaterial, this.associations.get(material));
      }
      material = cachedMaterial;
    }
    mesh.material = material;
  }
  getMaterialType() {
    return MeshStandardMaterial$1;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */
  loadMaterial(materialIndex) {
    const parser = this;
    const json = this.json;
    const extensions = this.extensions;
    const materialDef = json.materials[materialIndex];
    let materialType;
    const materialParams = {};
    const materialExtensions = materialDef.extensions || {};
    const pending = [];
    if (materialExtensions[EXTENSIONS.KHR_MATERIALS_UNLIT]) {
      const kmuExtension = extensions[EXTENSIONS.KHR_MATERIALS_UNLIT];
      materialType = kmuExtension.getMaterialType();
      pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
    } else {
      const metallicRoughness = materialDef.pbrMetallicRoughness || {};
      materialParams.color = new Color$1(1, 1, 1);
      materialParams.opacity = 1;
      if (Array.isArray(metallicRoughness.baseColorFactor)) {
        const array = metallicRoughness.baseColorFactor;
        materialParams.color.setRGB(array[0], array[1], array[2], LinearSRGBColorSpace);
        materialParams.opacity = array[3];
      }
      if (metallicRoughness.baseColorTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, SRGBColorSpace));
      }
      materialParams.metalness = metallicRoughness.metallicFactor !== void 0 ? metallicRoughness.metallicFactor : 1;
      materialParams.roughness = metallicRoughness.roughnessFactor !== void 0 ? metallicRoughness.roughnessFactor : 1;
      if (metallicRoughness.metallicRoughnessTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "metalnessMap", metallicRoughness.metallicRoughnessTexture));
        pending.push(parser.assignTexture(materialParams, "roughnessMap", metallicRoughness.metallicRoughnessTexture));
      }
      materialType = this._invokeOne(function(ext) {
        return ext.getMaterialType && ext.getMaterialType(materialIndex);
      });
      pending.push(Promise.all(this._invokeAll(function(ext) {
        return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
      })));
    }
    if (materialDef.doubleSided === true) {
      materialParams.side = DoubleSide$1;
    }
    const alphaMode = materialDef.alphaMode || ALPHA_MODES.OPAQUE;
    if (alphaMode === ALPHA_MODES.BLEND) {
      materialParams.transparent = true;
      materialParams.depthWrite = false;
    } else {
      materialParams.transparent = false;
      if (alphaMode === ALPHA_MODES.MASK) {
        materialParams.alphaTest = materialDef.alphaCutoff !== void 0 ? materialDef.alphaCutoff : 0.5;
      }
    }
    if (materialDef.normalTexture !== void 0 && materialType !== MeshBasicMaterial$1) {
      pending.push(parser.assignTexture(materialParams, "normalMap", materialDef.normalTexture));
      materialParams.normalScale = new Vector2$1(1, 1);
      if (materialDef.normalTexture.scale !== void 0) {
        const scale = materialDef.normalTexture.scale;
        materialParams.normalScale.set(scale, scale);
      }
    }
    if (materialDef.occlusionTexture !== void 0 && materialType !== MeshBasicMaterial$1) {
      pending.push(parser.assignTexture(materialParams, "aoMap", materialDef.occlusionTexture));
      if (materialDef.occlusionTexture.strength !== void 0) {
        materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
      }
    }
    if (materialDef.emissiveFactor !== void 0 && materialType !== MeshBasicMaterial$1) {
      const emissiveFactor = materialDef.emissiveFactor;
      materialParams.emissive = new Color$1().setRGB(emissiveFactor[0], emissiveFactor[1], emissiveFactor[2], LinearSRGBColorSpace);
    }
    if (materialDef.emissiveTexture !== void 0 && materialType !== MeshBasicMaterial$1) {
      pending.push(parser.assignTexture(materialParams, "emissiveMap", materialDef.emissiveTexture, SRGBColorSpace));
    }
    return Promise.all(pending).then(function() {
      const material = new materialType(materialParams);
      if (materialDef.name) material.name = materialDef.name;
      assignExtrasToUserData(material, materialDef);
      parser.associations.set(material, { materials: materialIndex });
      if (materialDef.extensions) addUnknownExtensionsToUserData(extensions, material, materialDef);
      return material;
    });
  }
  /** When Object3D instances are targeted by animation, they need unique names. */
  createUniqueName(originalName) {
    const sanitizedName = PropertyBinding$1.sanitizeNodeName(originalName || "");
    if (sanitizedName in this.nodeNamesUsed) {
      return sanitizedName + "_" + ++this.nodeNamesUsed[sanitizedName];
    } else {
      this.nodeNamesUsed[sanitizedName] = 0;
      return sanitizedName;
    }
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */
  loadGeometries(primitives) {
    const parser = this;
    const extensions = this.extensions;
    const cache = this.primitiveCache;
    function createDracoPrimitive(primitive) {
      return extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
        return addPrimitiveAttributes(geometry, primitive, parser);
      });
    }
    const pending = [];
    for (let i2 = 0, il = primitives.length; i2 < il; i2++) {
      const primitive = primitives[i2];
      const cacheKey = createPrimitiveKey(primitive);
      const cached = cache[cacheKey];
      if (cached) {
        pending.push(cached.promise);
      } else {
        let geometryPromise;
        if (primitive.extensions && primitive.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) {
          geometryPromise = createDracoPrimitive(primitive);
        } else {
          geometryPromise = addPrimitiveAttributes(new BufferGeometry$1(), primitive, parser);
        }
        cache[cacheKey] = { primitive, promise: geometryPromise };
        pending.push(geometryPromise);
      }
    }
    return Promise.all(pending);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh>}
   */
  loadMesh(meshIndex) {
    const parser = this;
    const json = this.json;
    const extensions = this.extensions;
    const meshDef = json.meshes[meshIndex];
    const primitives = meshDef.primitives;
    const pending = [];
    for (let i2 = 0, il = primitives.length; i2 < il; i2++) {
      const material = primitives[i2].material === void 0 ? createDefaultMaterial(this.cache) : this.getDependency("material", primitives[i2].material);
      pending.push(material);
    }
    pending.push(parser.loadGeometries(primitives));
    return Promise.all(pending).then(function(results) {
      const materials = results.slice(0, results.length - 1);
      const geometries = results[results.length - 1];
      const meshes = [];
      for (let i2 = 0, il = geometries.length; i2 < il; i2++) {
        const geometry = geometries[i2];
        const primitive = primitives[i2];
        let mesh;
        const material = materials[i2];
        if (primitive.mode === WEBGL_CONSTANTS.TRIANGLES || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === void 0) {
          mesh = meshDef.isSkinnedMesh === true ? new SkinnedMesh$1(geometry, material) : new Mesh$1(geometry, material);
          if (mesh.isSkinnedMesh === true) {
            mesh.normalizeSkinWeights();
          }
          if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP) {
            mesh.geometry = toTrianglesDrawMode(mesh.geometry, TriangleStripDrawMode);
          } else if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN) {
            mesh.geometry = toTrianglesDrawMode(mesh.geometry, TriangleFanDrawMode);
          }
        } else if (primitive.mode === WEBGL_CONSTANTS.LINES) {
          mesh = new LineSegments$1(geometry, material);
        } else if (primitive.mode === WEBGL_CONSTANTS.LINE_STRIP) {
          mesh = new Line$1(geometry, material);
        } else if (primitive.mode === WEBGL_CONSTANTS.LINE_LOOP) {
          mesh = new LineLoop$1(geometry, material);
        } else if (primitive.mode === WEBGL_CONSTANTS.POINTS) {
          mesh = new Points$1(geometry, material);
        } else {
          throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + primitive.mode);
        }
        if (Object.keys(mesh.geometry.morphAttributes).length > 0) {
          updateMorphTargets(mesh, meshDef);
        }
        mesh.name = parser.createUniqueName(meshDef.name || "mesh_" + meshIndex);
        assignExtrasToUserData(mesh, meshDef);
        if (primitive.extensions) addUnknownExtensionsToUserData(extensions, mesh, primitive);
        parser.assignFinalMaterial(mesh);
        meshes.push(mesh);
      }
      for (let i2 = 0, il = meshes.length; i2 < il; i2++) {
        parser.associations.set(meshes[i2], {
          meshes: meshIndex,
          primitives: i2
        });
      }
      if (meshes.length === 1) {
        if (meshDef.extensions) addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
        return meshes[0];
      }
      const group = new Group$1();
      if (meshDef.extensions) addUnknownExtensionsToUserData(extensions, group, meshDef);
      parser.associations.set(group, { meshes: meshIndex });
      for (let i2 = 0, il = meshes.length; i2 < il; i2++) {
        group.add(meshes[i2]);
      }
      return group;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   * @param {number} cameraIndex
   * @return {Promise<THREE.Camera>}
   */
  loadCamera(cameraIndex) {
    let camera;
    const cameraDef = this.json.cameras[cameraIndex];
    const params = cameraDef[cameraDef.type];
    if (!params) {
      console.warn("THREE.GLTFLoader: Missing camera parameters.");
      return;
    }
    if (cameraDef.type === "perspective") {
      camera = new PerspectiveCamera$1(MathUtils.radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
    } else if (cameraDef.type === "orthographic") {
      camera = new OrthographicCamera$1(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
    }
    if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
    assignExtrasToUserData(camera, cameraDef);
    return Promise.resolve(camera);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   * @param {number} skinIndex
   * @return {Promise<Skeleton>}
   */
  loadSkin(skinIndex) {
    const skinDef = this.json.skins[skinIndex];
    const pending = [];
    for (let i2 = 0, il = skinDef.joints.length; i2 < il; i2++) {
      pending.push(this._loadNodeShallow(skinDef.joints[i2]));
    }
    if (skinDef.inverseBindMatrices !== void 0) {
      pending.push(this.getDependency("accessor", skinDef.inverseBindMatrices));
    } else {
      pending.push(null);
    }
    return Promise.all(pending).then(function(results) {
      const inverseBindMatrices = results.pop();
      const jointNodes = results;
      const bones = [];
      const boneInverses = [];
      for (let i2 = 0, il = jointNodes.length; i2 < il; i2++) {
        const jointNode = jointNodes[i2];
        if (jointNode) {
          bones.push(jointNode);
          const mat = new Matrix4$1();
          if (inverseBindMatrices !== null) {
            mat.fromArray(inverseBindMatrices.array, i2 * 16);
          }
          boneInverses.push(mat);
        } else {
          console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i2]);
        }
      }
      return new Skeleton(bones, boneInverses);
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */
  loadAnimation(animationIndex) {
    const json = this.json;
    const parser = this;
    const animationDef = json.animations[animationIndex];
    const animationName = animationDef.name ? animationDef.name : "animation_" + animationIndex;
    const pendingNodes = [];
    const pendingInputAccessors = [];
    const pendingOutputAccessors = [];
    const pendingSamplers = [];
    const pendingTargets = [];
    for (let i2 = 0, il = animationDef.channels.length; i2 < il; i2++) {
      const channel = animationDef.channels[i2];
      const sampler = animationDef.samplers[channel.sampler];
      const target = channel.target;
      const name = target.node;
      const input = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.input] : sampler.input;
      const output = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.output] : sampler.output;
      if (target.node === void 0) continue;
      pendingNodes.push(this.getDependency("node", name));
      pendingInputAccessors.push(this.getDependency("accessor", input));
      pendingOutputAccessors.push(this.getDependency("accessor", output));
      pendingSamplers.push(sampler);
      pendingTargets.push(target);
    }
    return Promise.all([
      Promise.all(pendingNodes),
      Promise.all(pendingInputAccessors),
      Promise.all(pendingOutputAccessors),
      Promise.all(pendingSamplers),
      Promise.all(pendingTargets)
    ]).then(function(dependencies) {
      const nodes = dependencies[0];
      const inputAccessors = dependencies[1];
      const outputAccessors = dependencies[2];
      const samplers = dependencies[3];
      const targets = dependencies[4];
      const tracks = [];
      for (let i2 = 0, il = nodes.length; i2 < il; i2++) {
        const node = nodes[i2];
        const inputAccessor = inputAccessors[i2];
        const outputAccessor = outputAccessors[i2];
        const sampler = samplers[i2];
        const target = targets[i2];
        if (node === void 0) continue;
        if (node.updateMatrix) {
          node.updateMatrix();
        }
        const createdTracks = parser._createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target);
        if (createdTracks) {
          for (let k = 0; k < createdTracks.length; k++) {
            tracks.push(createdTracks[k]);
          }
        }
      }
      return new AnimationClip$1(animationName, void 0, tracks);
    });
  }
  createNodeMesh(nodeIndex) {
    const json = this.json;
    const parser = this;
    const nodeDef = json.nodes[nodeIndex];
    if (nodeDef.mesh === void 0) return null;
    return parser.getDependency("mesh", nodeDef.mesh).then(function(mesh) {
      const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
      if (nodeDef.weights !== void 0) {
        node.traverse(function(o2) {
          if (!o2.isMesh) return;
          for (let i2 = 0, il = nodeDef.weights.length; i2 < il; i2++) {
            o2.morphTargetInfluences[i2] = nodeDef.weights[i2];
          }
        });
      }
      return node;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */
  loadNode(nodeIndex) {
    const json = this.json;
    const parser = this;
    const nodeDef = json.nodes[nodeIndex];
    const nodePending = parser._loadNodeShallow(nodeIndex);
    const childPending = [];
    const childrenDef = nodeDef.children || [];
    for (let i2 = 0, il = childrenDef.length; i2 < il; i2++) {
      childPending.push(parser.getDependency("node", childrenDef[i2]));
    }
    const skeletonPending = nodeDef.skin === void 0 ? Promise.resolve(null) : parser.getDependency("skin", nodeDef.skin);
    return Promise.all([
      nodePending,
      Promise.all(childPending),
      skeletonPending
    ]).then(function(results) {
      const node = results[0];
      const children = results[1];
      const skeleton = results[2];
      if (skeleton !== null) {
        node.traverse(function(mesh) {
          if (!mesh.isSkinnedMesh) return;
          mesh.bind(skeleton, _identityMatrix);
        });
      }
      for (let i2 = 0, il = children.length; i2 < il; i2++) {
        node.add(children[i2]);
      }
      return node;
    });
  }
  // ._loadNodeShallow() parses a single node.
  // skin and child nodes are created and added in .loadNode() (no '_' prefix).
  _loadNodeShallow(nodeIndex) {
    const json = this.json;
    const extensions = this.extensions;
    const parser = this;
    if (this.nodeCache[nodeIndex] !== void 0) {
      return this.nodeCache[nodeIndex];
    }
    const nodeDef = json.nodes[nodeIndex];
    const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : "";
    const pending = [];
    const meshPromise = parser._invokeOne(function(ext) {
      return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
    });
    if (meshPromise) {
      pending.push(meshPromise);
    }
    if (nodeDef.camera !== void 0) {
      pending.push(parser.getDependency("camera", nodeDef.camera).then(function(camera) {
        return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
      }));
    }
    parser._invokeAll(function(ext) {
      return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
    }).forEach(function(promise) {
      pending.push(promise);
    });
    this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
      let node;
      if (nodeDef.isBone === true) {
        node = new Bone$1();
      } else if (objects.length > 1) {
        node = new Group$1();
      } else if (objects.length === 1) {
        node = objects[0];
      } else {
        node = new Object3D$1();
      }
      if (node !== objects[0]) {
        for (let i2 = 0, il = objects.length; i2 < il; i2++) {
          node.add(objects[i2]);
        }
      }
      if (nodeDef.name) {
        node.userData.name = nodeDef.name;
        node.name = nodeName;
      }
      assignExtrasToUserData(node, nodeDef);
      if (nodeDef.extensions) addUnknownExtensionsToUserData(extensions, node, nodeDef);
      if (nodeDef.matrix !== void 0) {
        const matrix2 = new Matrix4$1();
        matrix2.fromArray(nodeDef.matrix);
        node.applyMatrix4(matrix2);
      } else {
        if (nodeDef.translation !== void 0) {
          node.position.fromArray(nodeDef.translation);
        }
        if (nodeDef.rotation !== void 0) {
          node.quaternion.fromArray(nodeDef.rotation);
        }
        if (nodeDef.scale !== void 0) {
          node.scale.fromArray(nodeDef.scale);
        }
      }
      if (!parser.associations.has(node)) {
        parser.associations.set(node, {});
      }
      parser.associations.get(node).nodes = nodeIndex;
      return node;
    });
    return this.nodeCache[nodeIndex];
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */
  loadScene(sceneIndex) {
    const extensions = this.extensions;
    const sceneDef = this.json.scenes[sceneIndex];
    const parser = this;
    const scene = new Group$1();
    if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
    assignExtrasToUserData(scene, sceneDef);
    if (sceneDef.extensions) addUnknownExtensionsToUserData(extensions, scene, sceneDef);
    const nodeIds = sceneDef.nodes || [];
    const pending = [];
    for (let i2 = 0, il = nodeIds.length; i2 < il; i2++) {
      pending.push(parser.getDependency("node", nodeIds[i2]));
    }
    return Promise.all(pending).then(function(nodes) {
      for (let i2 = 0, il = nodes.length; i2 < il; i2++) {
        scene.add(nodes[i2]);
      }
      const reduceAssociations = (node) => {
        const reducedAssociations = /* @__PURE__ */ new Map();
        for (const [key, value] of parser.associations) {
          if (key instanceof Material$1 || key instanceof Texture$1) {
            reducedAssociations.set(key, value);
          }
        }
        node.traverse((node2) => {
          const mappings = parser.associations.get(node2);
          if (mappings != null) {
            reducedAssociations.set(node2, mappings);
          }
        });
        return reducedAssociations;
      };
      parser.associations = reduceAssociations(scene);
      return scene;
    });
  }
  _createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target) {
    const tracks = [];
    const targetName = node.name ? node.name : node.uuid;
    const targetNames = [];
    if (PATH_PROPERTIES[target.path] === PATH_PROPERTIES.weights) {
      node.traverse(function(object) {
        if (object.morphTargetInfluences) {
          targetNames.push(object.name ? object.name : object.uuid);
        }
      });
    } else {
      targetNames.push(targetName);
    }
    let TypedKeyframeTrack;
    switch (PATH_PROPERTIES[target.path]) {
      case PATH_PROPERTIES.weights:
        TypedKeyframeTrack = NumberKeyframeTrack$1;
        break;
      case PATH_PROPERTIES.rotation:
        TypedKeyframeTrack = QuaternionKeyframeTrack$1;
        break;
      case PATH_PROPERTIES.position:
      case PATH_PROPERTIES.scale:
        TypedKeyframeTrack = VectorKeyframeTrack$1;
        break;
      default:
        switch (outputAccessor.itemSize) {
          case 1:
            TypedKeyframeTrack = NumberKeyframeTrack$1;
            break;
          case 2:
          case 3:
          default:
            TypedKeyframeTrack = VectorKeyframeTrack$1;
            break;
        }
        break;
    }
    const interpolation = sampler.interpolation !== void 0 ? INTERPOLATION[sampler.interpolation] : InterpolateLinear$1;
    const outputArray = this._getArrayFromAccessor(outputAccessor);
    for (let j = 0, jl = targetNames.length; j < jl; j++) {
      const track = new TypedKeyframeTrack(
        targetNames[j] + "." + PATH_PROPERTIES[target.path],
        inputAccessor.array,
        outputArray,
        interpolation
      );
      if (sampler.interpolation === "CUBICSPLINE") {
        this._createCubicSplineTrackInterpolant(track);
      }
      tracks.push(track);
    }
    return tracks;
  }
  _getArrayFromAccessor(accessor) {
    let outputArray = accessor.array;
    if (accessor.normalized) {
      const scale = getNormalizedComponentScale(outputArray.constructor);
      const scaled = new Float32Array(outputArray.length);
      for (let j = 0, jl = outputArray.length; j < jl; j++) {
        scaled[j] = outputArray[j] * scale;
      }
      outputArray = scaled;
    }
    return outputArray;
  }
  _createCubicSplineTrackInterpolant(track) {
    track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
      const interpolantType = this instanceof QuaternionKeyframeTrack$1 ? GLTFCubicSplineQuaternionInterpolant : GLTFCubicSplineInterpolant;
      return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
    };
    track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
  }
}
function computeBounds(geometry, primitiveDef, parser) {
  const attributes = primitiveDef.attributes;
  const box = new Box3$1();
  if (attributes.POSITION !== void 0) {
    const accessor = parser.json.accessors[attributes.POSITION];
    const min = accessor.min;
    const max2 = accessor.max;
    if (min !== void 0 && max2 !== void 0) {
      box.set(
        new Vector3$1(min[0], min[1], min[2]),
        new Vector3$1(max2[0], max2[1], max2[2])
      );
      if (accessor.normalized) {
        const boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[accessor.componentType]);
        box.min.multiplyScalar(boxScale);
        box.max.multiplyScalar(boxScale);
      }
    } else {
      console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      return;
    }
  } else {
    return;
  }
  const targets = primitiveDef.targets;
  if (targets !== void 0) {
    const maxDisplacement = new Vector3$1();
    const vector = new Vector3$1();
    for (let i2 = 0, il = targets.length; i2 < il; i2++) {
      const target = targets[i2];
      if (target.POSITION !== void 0) {
        const accessor = parser.json.accessors[target.POSITION];
        const min = accessor.min;
        const max2 = accessor.max;
        if (min !== void 0 && max2 !== void 0) {
          vector.setX(Math.max(Math.abs(min[0]), Math.abs(max2[0])));
          vector.setY(Math.max(Math.abs(min[1]), Math.abs(max2[1])));
          vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max2[2])));
          if (accessor.normalized) {
            const boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[accessor.componentType]);
            vector.multiplyScalar(boxScale);
          }
          maxDisplacement.max(vector);
        } else {
          console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
        }
      }
    }
    box.expandByVector(maxDisplacement);
  }
  geometry.boundingBox = box;
  const sphere = new Sphere$1();
  box.getCenter(sphere.center);
  sphere.radius = box.min.distanceTo(box.max) / 2;
  geometry.boundingSphere = sphere;
}
function addPrimitiveAttributes(geometry, primitiveDef, parser) {
  const attributes = primitiveDef.attributes;
  const pending = [];
  function assignAttributeAccessor(accessorIndex, attributeName) {
    return parser.getDependency("accessor", accessorIndex).then(function(accessor) {
      geometry.setAttribute(attributeName, accessor);
    });
  }
  for (const gltfAttributeName in attributes) {
    const threeAttributeName = ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
    if (threeAttributeName in geometry.attributes) continue;
    pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
  }
  if (primitiveDef.indices !== void 0 && !geometry.index) {
    const accessor = parser.getDependency("accessor", primitiveDef.indices).then(function(accessor2) {
      geometry.setIndex(accessor2);
    });
    pending.push(accessor);
  }
  if (ColorManagement.workingColorSpace !== LinearSRGBColorSpace && "COLOR_0" in attributes) {
    console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${ColorManagement.workingColorSpace}" not supported.`);
  }
  assignExtrasToUserData(geometry, primitiveDef);
  computeBounds(geometry, primitiveDef, parser);
  return Promise.all(pending).then(function() {
    return primitiveDef.targets !== void 0 ? addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
  });
}
class TGALoader extends DataTextureLoader {
  constructor(manager) {
    super(manager);
  }
  parse(buffer) {
    function tgaCheckHeader(header2) {
      switch (header2.image_type) {
        case TGA_TYPE_INDEXED:
        case TGA_TYPE_RLE_INDEXED:
          if (header2.colormap_length > 256 || header2.colormap_size !== 24 || header2.colormap_type !== 1) {
            throw new Error("THREE.TGALoader: Invalid type colormap data for indexed type.");
          }
          break;
        case TGA_TYPE_RGB:
        case TGA_TYPE_GREY:
        case TGA_TYPE_RLE_RGB:
        case TGA_TYPE_RLE_GREY:
          if (header2.colormap_type) {
            throw new Error("THREE.TGALoader: Invalid type colormap data for colormap type.");
          }
          break;
        case TGA_TYPE_NO_DATA:
          throw new Error("THREE.TGALoader: No data.");
        default:
          throw new Error("THREE.TGALoader: Invalid type " + header2.image_type);
      }
      if (header2.width <= 0 || header2.height <= 0) {
        throw new Error("THREE.TGALoader: Invalid image size.");
      }
      if (header2.pixel_size !== 8 && header2.pixel_size !== 16 && header2.pixel_size !== 24 && header2.pixel_size !== 32) {
        throw new Error("THREE.TGALoader: Invalid pixel size " + header2.pixel_size);
      }
    }
    function tgaParse(use_rle2, use_pal2, header2, offset2, data) {
      let pixel_data, palettes;
      const pixel_size = header2.pixel_size >> 3;
      const pixel_total = header2.width * header2.height * pixel_size;
      if (use_pal2) {
        palettes = data.subarray(offset2, offset2 += header2.colormap_length * (header2.colormap_size >> 3));
      }
      if (use_rle2) {
        pixel_data = new Uint8Array(pixel_total);
        let c2, count, i2;
        let shift = 0;
        const pixels = new Uint8Array(pixel_size);
        while (shift < pixel_total) {
          c2 = data[offset2++];
          count = (c2 & 127) + 1;
          if (c2 & 128) {
            for (i2 = 0; i2 < pixel_size; ++i2) {
              pixels[i2] = data[offset2++];
            }
            for (i2 = 0; i2 < count; ++i2) {
              pixel_data.set(pixels, shift + i2 * pixel_size);
            }
            shift += pixel_size * count;
          } else {
            count *= pixel_size;
            for (i2 = 0; i2 < count; ++i2) {
              pixel_data[shift + i2] = data[offset2++];
            }
            shift += count;
          }
        }
      } else {
        pixel_data = data.subarray(
          offset2,
          offset2 += use_pal2 ? header2.width * header2.height : pixel_total
        );
      }
      return {
        pixel_data,
        palettes
      };
    }
    function tgaGetImageData8bits(imageData2, y_start, y_step, y_end, x_start, x_step, x_end, image2, palettes) {
      const colormap = palettes;
      let color2, i2 = 0, x, y;
      const width = header.width;
      for (y = y_start; y !== y_end; y += y_step) {
        for (x = x_start; x !== x_end; x += x_step, i2++) {
          color2 = image2[i2];
          imageData2[(x + width * y) * 4 + 3] = 255;
          imageData2[(x + width * y) * 4 + 2] = colormap[color2 * 3 + 0];
          imageData2[(x + width * y) * 4 + 1] = colormap[color2 * 3 + 1];
          imageData2[(x + width * y) * 4 + 0] = colormap[color2 * 3 + 2];
        }
      }
      return imageData2;
    }
    function tgaGetImageData16bits(imageData2, y_start, y_step, y_end, x_start, x_step, x_end, image2) {
      let color2, i2 = 0, x, y;
      const width = header.width;
      for (y = y_start; y !== y_end; y += y_step) {
        for (x = x_start; x !== x_end; x += x_step, i2 += 2) {
          color2 = image2[i2 + 0] + (image2[i2 + 1] << 8);
          imageData2[(x + width * y) * 4 + 0] = (color2 & 31744) >> 7;
          imageData2[(x + width * y) * 4 + 1] = (color2 & 992) >> 2;
          imageData2[(x + width * y) * 4 + 2] = (color2 & 31) << 3;
          imageData2[(x + width * y) * 4 + 3] = color2 & 32768 ? 0 : 255;
        }
      }
      return imageData2;
    }
    function tgaGetImageData24bits(imageData2, y_start, y_step, y_end, x_start, x_step, x_end, image2) {
      let i2 = 0, x, y;
      const width = header.width;
      for (y = y_start; y !== y_end; y += y_step) {
        for (x = x_start; x !== x_end; x += x_step, i2 += 3) {
          imageData2[(x + width * y) * 4 + 3] = 255;
          imageData2[(x + width * y) * 4 + 2] = image2[i2 + 0];
          imageData2[(x + width * y) * 4 + 1] = image2[i2 + 1];
          imageData2[(x + width * y) * 4 + 0] = image2[i2 + 2];
        }
      }
      return imageData2;
    }
    function tgaGetImageData32bits(imageData2, y_start, y_step, y_end, x_start, x_step, x_end, image2) {
      let i2 = 0, x, y;
      const width = header.width;
      for (y = y_start; y !== y_end; y += y_step) {
        for (x = x_start; x !== x_end; x += x_step, i2 += 4) {
          imageData2[(x + width * y) * 4 + 2] = image2[i2 + 0];
          imageData2[(x + width * y) * 4 + 1] = image2[i2 + 1];
          imageData2[(x + width * y) * 4 + 0] = image2[i2 + 2];
          imageData2[(x + width * y) * 4 + 3] = image2[i2 + 3];
        }
      }
      return imageData2;
    }
    function tgaGetImageDataGrey8bits(imageData2, y_start, y_step, y_end, x_start, x_step, x_end, image2) {
      let color2, i2 = 0, x, y;
      const width = header.width;
      for (y = y_start; y !== y_end; y += y_step) {
        for (x = x_start; x !== x_end; x += x_step, i2++) {
          color2 = image2[i2];
          imageData2[(x + width * y) * 4 + 0] = color2;
          imageData2[(x + width * y) * 4 + 1] = color2;
          imageData2[(x + width * y) * 4 + 2] = color2;
          imageData2[(x + width * y) * 4 + 3] = 255;
        }
      }
      return imageData2;
    }
    function tgaGetImageDataGrey16bits(imageData2, y_start, y_step, y_end, x_start, x_step, x_end, image2) {
      let i2 = 0, x, y;
      const width = header.width;
      for (y = y_start; y !== y_end; y += y_step) {
        for (x = x_start; x !== x_end; x += x_step, i2 += 2) {
          imageData2[(x + width * y) * 4 + 0] = image2[i2 + 0];
          imageData2[(x + width * y) * 4 + 1] = image2[i2 + 0];
          imageData2[(x + width * y) * 4 + 2] = image2[i2 + 0];
          imageData2[(x + width * y) * 4 + 3] = image2[i2 + 1];
        }
      }
      return imageData2;
    }
    function getTgaRGBA(data, width, height, image2, palette) {
      let x_start, y_start, x_step, y_step, x_end, y_end;
      switch ((header.flags & TGA_ORIGIN_MASK) >> TGA_ORIGIN_SHIFT) {
        default:
        case TGA_ORIGIN_UL:
          x_start = 0;
          x_step = 1;
          x_end = width;
          y_start = 0;
          y_step = 1;
          y_end = height;
          break;
        case TGA_ORIGIN_BL:
          x_start = 0;
          x_step = 1;
          x_end = width;
          y_start = height - 1;
          y_step = -1;
          y_end = -1;
          break;
        case TGA_ORIGIN_UR:
          x_start = width - 1;
          x_step = -1;
          x_end = -1;
          y_start = 0;
          y_step = 1;
          y_end = height;
          break;
        case TGA_ORIGIN_BR:
          x_start = width - 1;
          x_step = -1;
          x_end = -1;
          y_start = height - 1;
          y_step = -1;
          y_end = -1;
          break;
      }
      if (use_grey) {
        switch (header.pixel_size) {
          case 8:
            tgaGetImageDataGrey8bits(data, y_start, y_step, y_end, x_start, x_step, x_end, image2);
            break;
          case 16:
            tgaGetImageDataGrey16bits(data, y_start, y_step, y_end, x_start, x_step, x_end, image2);
            break;
          default:
            throw new Error("THREE.TGALoader: Format not supported.");
        }
      } else {
        switch (header.pixel_size) {
          case 8:
            tgaGetImageData8bits(data, y_start, y_step, y_end, x_start, x_step, x_end, image2, palette);
            break;
          case 16:
            tgaGetImageData16bits(data, y_start, y_step, y_end, x_start, x_step, x_end, image2);
            break;
          case 24:
            tgaGetImageData24bits(data, y_start, y_step, y_end, x_start, x_step, x_end, image2);
            break;
          case 32:
            tgaGetImageData32bits(data, y_start, y_step, y_end, x_start, x_step, x_end, image2);
            break;
          default:
            throw new Error("THREE.TGALoader: Format not supported.");
        }
      }
      return data;
    }
    const TGA_TYPE_NO_DATA = 0, TGA_TYPE_INDEXED = 1, TGA_TYPE_RGB = 2, TGA_TYPE_GREY = 3, TGA_TYPE_RLE_INDEXED = 9, TGA_TYPE_RLE_RGB = 10, TGA_TYPE_RLE_GREY = 11, TGA_ORIGIN_MASK = 48, TGA_ORIGIN_SHIFT = 4, TGA_ORIGIN_BL = 0, TGA_ORIGIN_BR = 1, TGA_ORIGIN_UL = 2, TGA_ORIGIN_UR = 3;
    if (buffer.length < 19) throw new Error("THREE.TGALoader: Not enough data to contain header.");
    let offset = 0;
    const content2 = new Uint8Array(buffer), header = {
      id_length: content2[offset++],
      colormap_type: content2[offset++],
      image_type: content2[offset++],
      colormap_index: content2[offset++] | content2[offset++] << 8,
      colormap_length: content2[offset++] | content2[offset++] << 8,
      colormap_size: content2[offset++],
      origin: [
        content2[offset++] | content2[offset++] << 8,
        content2[offset++] | content2[offset++] << 8
      ],
      width: content2[offset++] | content2[offset++] << 8,
      height: content2[offset++] | content2[offset++] << 8,
      pixel_size: content2[offset++],
      flags: content2[offset++]
    };
    tgaCheckHeader(header);
    if (header.id_length + offset > buffer.length) {
      throw new Error("THREE.TGALoader: No data.");
    }
    offset += header.id_length;
    let use_rle = false, use_pal = false, use_grey = false;
    switch (header.image_type) {
      case TGA_TYPE_RLE_INDEXED:
        use_rle = true;
        use_pal = true;
        break;
      case TGA_TYPE_INDEXED:
        use_pal = true;
        break;
      case TGA_TYPE_RLE_RGB:
        use_rle = true;
        break;
      case TGA_TYPE_RGB:
        break;
      case TGA_TYPE_RLE_GREY:
        use_rle = true;
        use_grey = true;
        break;
      case TGA_TYPE_GREY:
        use_grey = true;
        break;
    }
    const imageData = new Uint8Array(header.width * header.height * 4);
    const result = tgaParse(use_rle, use_pal, header, offset, content2);
    getTgaRGBA(imageData, header.width, header.height, result.pixel_data, result.palettes);
    return {
      data: imageData,
      width: header.width,
      height: header.height,
      flipY: true,
      generateMipmaps: true,
      minFilter: LinearMipmapLinearFilter$1
    };
  }
}
class ColladaLoader extends Loader$1 {
  load(url, onLoad, onProgress, onError) {
    const scope = this;
    const path = scope.path === "" ? LoaderUtils$1.extractUrlBase(url) : scope.path;
    const loader = new FileLoader$1(scope.manager);
    loader.setPath(scope.path);
    loader.setRequestHeader(scope.requestHeader);
    loader.setWithCredentials(scope.withCredentials);
    loader.load(url, function(text) {
      try {
        onLoad(scope.parse(text, path));
      } catch (e2) {
        if (onError) {
          onError(e2);
        } else {
          console.error(e2);
        }
        scope.manager.itemError(url);
      }
    }, onProgress, onError);
  }
  parse(text, path) {
    function getElementsByTagName(xml2, name) {
      const array = [];
      const childNodes = xml2.childNodes;
      for (let i2 = 0, l2 = childNodes.length; i2 < l2; i2++) {
        const child = childNodes[i2];
        if (child.nodeName === name) {
          array.push(child);
        }
      }
      return array;
    }
    function parseStrings(text2) {
      if (text2.length === 0) return [];
      const parts = text2.trim().split(/\s+/);
      const array = new Array(parts.length);
      for (let i2 = 0, l2 = parts.length; i2 < l2; i2++) {
        array[i2] = parts[i2];
      }
      return array;
    }
    function parseFloats(text2) {
      if (text2.length === 0) return [];
      const parts = text2.trim().split(/\s+/);
      const array = new Array(parts.length);
      for (let i2 = 0, l2 = parts.length; i2 < l2; i2++) {
        array[i2] = parseFloat(parts[i2]);
      }
      return array;
    }
    function parseInts(text2) {
      if (text2.length === 0) return [];
      const parts = text2.trim().split(/\s+/);
      const array = new Array(parts.length);
      for (let i2 = 0, l2 = parts.length; i2 < l2; i2++) {
        array[i2] = parseInt(parts[i2]);
      }
      return array;
    }
    function parseId(text2) {
      return text2.substring(1);
    }
    function generateId() {
      return "three_default_" + count++;
    }
    function isEmpty(object) {
      return Object.keys(object).length === 0;
    }
    function parseAsset(xml2) {
      return {
        unit: parseAssetUnit(getElementsByTagName(xml2, "unit")[0]),
        upAxis: parseAssetUpAxis(getElementsByTagName(xml2, "up_axis")[0])
      };
    }
    function parseAssetUnit(xml2) {
      if (xml2 !== void 0 && xml2.hasAttribute("meter") === true) {
        return parseFloat(xml2.getAttribute("meter"));
      } else {
        return 1;
      }
    }
    function parseAssetUpAxis(xml2) {
      return xml2 !== void 0 ? xml2.textContent : "Y_UP";
    }
    function parseLibrary(xml2, libraryName, nodeName, parser) {
      const library2 = getElementsByTagName(xml2, libraryName)[0];
      if (library2 !== void 0) {
        const elements = getElementsByTagName(library2, nodeName);
        for (let i2 = 0; i2 < elements.length; i2++) {
          parser(elements[i2]);
        }
      }
    }
    function buildLibrary(data, builder) {
      for (const name in data) {
        const object = data[name];
        object.build = builder(data[name]);
      }
    }
    function getBuild(data, builder) {
      if (data.build !== void 0) return data.build;
      data.build = builder(data);
      return data.build;
    }
    function parseAnimation(xml2) {
      const data = {
        sources: {},
        samplers: {},
        channels: {}
      };
      let hasChildren = false;
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        let id;
        switch (child.nodeName) {
          case "source":
            id = child.getAttribute("id");
            data.sources[id] = parseSource(child);
            break;
          case "sampler":
            id = child.getAttribute("id");
            data.samplers[id] = parseAnimationSampler(child);
            break;
          case "channel":
            id = child.getAttribute("target");
            data.channels[id] = parseAnimationChannel(child);
            break;
          case "animation":
            parseAnimation(child);
            hasChildren = true;
            break;
          default:
            console.log(child);
        }
      }
      if (hasChildren === false) {
        library.animations[xml2.getAttribute("id") || MathUtils.generateUUID()] = data;
      }
    }
    function parseAnimationSampler(xml2) {
      const data = {
        inputs: {}
      };
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "input":
            const id = parseId(child.getAttribute("source"));
            const semantic = child.getAttribute("semantic");
            data.inputs[semantic] = id;
            break;
        }
      }
      return data;
    }
    function parseAnimationChannel(xml2) {
      const data = {};
      const target = xml2.getAttribute("target");
      let parts = target.split("/");
      const id = parts.shift();
      let sid = parts.shift();
      const arraySyntax = sid.indexOf("(") !== -1;
      const memberSyntax = sid.indexOf(".") !== -1;
      if (memberSyntax) {
        parts = sid.split(".");
        sid = parts.shift();
        data.member = parts.shift();
      } else if (arraySyntax) {
        const indices = sid.split("(");
        sid = indices.shift();
        for (let i2 = 0; i2 < indices.length; i2++) {
          indices[i2] = parseInt(indices[i2].replace(/\)/, ""));
        }
        data.indices = indices;
      }
      data.id = id;
      data.sid = sid;
      data.arraySyntax = arraySyntax;
      data.memberSyntax = memberSyntax;
      data.sampler = parseId(xml2.getAttribute("source"));
      return data;
    }
    function buildAnimation(data) {
      const tracks = [];
      const channels = data.channels;
      const samplers = data.samplers;
      const sources = data.sources;
      for (const target in channels) {
        if (channels.hasOwnProperty(target)) {
          const channel = channels[target];
          const sampler = samplers[channel.sampler];
          const inputId = sampler.inputs.INPUT;
          const outputId = sampler.inputs.OUTPUT;
          const inputSource = sources[inputId];
          const outputSource = sources[outputId];
          const animation = buildAnimationChannel(channel, inputSource, outputSource);
          createKeyframeTracks(animation, tracks);
        }
      }
      return tracks;
    }
    function getAnimation(id) {
      return getBuild(library.animations[id], buildAnimation);
    }
    function buildAnimationChannel(channel, inputSource, outputSource) {
      const node = library.nodes[channel.id];
      const object3D = getNode(node.id);
      const transform2 = node.transforms[channel.sid];
      const defaultMatrix = node.matrix.clone().transpose();
      let time2, stride;
      let i2, il, j, jl;
      const data = {};
      switch (transform2) {
        case "matrix":
          for (i2 = 0, il = inputSource.array.length; i2 < il; i2++) {
            time2 = inputSource.array[i2];
            stride = i2 * outputSource.stride;
            if (data[time2] === void 0) data[time2] = {};
            if (channel.arraySyntax === true) {
              const value = outputSource.array[stride];
              const index2 = channel.indices[0] + 4 * channel.indices[1];
              data[time2][index2] = value;
            } else {
              for (j = 0, jl = outputSource.stride; j < jl; j++) {
                data[time2][j] = outputSource.array[stride + j];
              }
            }
          }
          break;
        case "translate":
          console.warn('THREE.ColladaLoader: Animation transform type "%s" not yet implemented.', transform2);
          break;
        case "rotate":
          console.warn('THREE.ColladaLoader: Animation transform type "%s" not yet implemented.', transform2);
          break;
        case "scale":
          console.warn('THREE.ColladaLoader: Animation transform type "%s" not yet implemented.', transform2);
          break;
      }
      const keyframes = prepareAnimationData(data, defaultMatrix);
      const animation = {
        name: object3D.uuid,
        keyframes
      };
      return animation;
    }
    function prepareAnimationData(data, defaultMatrix) {
      const keyframes = [];
      for (const time2 in data) {
        keyframes.push({ time: parseFloat(time2), value: data[time2] });
      }
      keyframes.sort(ascending);
      for (let i2 = 0; i2 < 16; i2++) {
        transformAnimationData(keyframes, i2, defaultMatrix.elements[i2]);
      }
      return keyframes;
      function ascending(a3, b) {
        return a3.time - b.time;
      }
    }
    const position2 = new Vector3$1();
    const scale = new Vector3$1();
    const quaternion = new Quaternion$1();
    function createKeyframeTracks(animation, tracks) {
      const keyframes = animation.keyframes;
      const name = animation.name;
      const times2 = [];
      const positionData = [];
      const quaternionData = [];
      const scaleData = [];
      for (let i2 = 0, l2 = keyframes.length; i2 < l2; i2++) {
        const keyframe = keyframes[i2];
        const time2 = keyframe.time;
        const value = keyframe.value;
        matrix2.fromArray(value).transpose();
        matrix2.decompose(position2, quaternion, scale);
        times2.push(time2);
        positionData.push(position2.x, position2.y, position2.z);
        quaternionData.push(quaternion.x, quaternion.y, quaternion.z, quaternion.w);
        scaleData.push(scale.x, scale.y, scale.z);
      }
      if (positionData.length > 0) tracks.push(new VectorKeyframeTrack$1(name + ".position", times2, positionData));
      if (quaternionData.length > 0) tracks.push(new QuaternionKeyframeTrack$1(name + ".quaternion", times2, quaternionData));
      if (scaleData.length > 0) tracks.push(new VectorKeyframeTrack$1(name + ".scale", times2, scaleData));
      return tracks;
    }
    function transformAnimationData(keyframes, property, defaultValue) {
      let keyframe;
      let empty = true;
      let i2, l2;
      for (i2 = 0, l2 = keyframes.length; i2 < l2; i2++) {
        keyframe = keyframes[i2];
        if (keyframe.value[property] === void 0) {
          keyframe.value[property] = null;
        } else {
          empty = false;
        }
      }
      if (empty === true) {
        for (i2 = 0, l2 = keyframes.length; i2 < l2; i2++) {
          keyframe = keyframes[i2];
          keyframe.value[property] = defaultValue;
        }
      } else {
        createMissingKeyframes(keyframes, property);
      }
    }
    function createMissingKeyframes(keyframes, property) {
      let prev, next;
      for (let i2 = 0, l2 = keyframes.length; i2 < l2; i2++) {
        const keyframe = keyframes[i2];
        if (keyframe.value[property] === null) {
          prev = getPrev(keyframes, i2, property);
          next = getNext(keyframes, i2, property);
          if (prev === null) {
            keyframe.value[property] = next.value[property];
            continue;
          }
          if (next === null) {
            keyframe.value[property] = prev.value[property];
            continue;
          }
          interpolate(keyframe, prev, next, property);
        }
      }
    }
    function getPrev(keyframes, i2, property) {
      while (i2 >= 0) {
        const keyframe = keyframes[i2];
        if (keyframe.value[property] !== null) return keyframe;
        i2--;
      }
      return null;
    }
    function getNext(keyframes, i2, property) {
      while (i2 < keyframes.length) {
        const keyframe = keyframes[i2];
        if (keyframe.value[property] !== null) return keyframe;
        i2++;
      }
      return null;
    }
    function interpolate(key, prev, next, property) {
      if (next.time - prev.time === 0) {
        key.value[property] = prev.value[property];
        return;
      }
      key.value[property] = (key.time - prev.time) * (next.value[property] - prev.value[property]) / (next.time - prev.time) + prev.value[property];
    }
    function parseAnimationClip(xml2) {
      const data = {
        name: xml2.getAttribute("id") || "default",
        start: parseFloat(xml2.getAttribute("start") || 0),
        end: parseFloat(xml2.getAttribute("end") || 0),
        animations: []
      };
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "instance_animation":
            data.animations.push(parseId(child.getAttribute("url")));
            break;
        }
      }
      library.clips[xml2.getAttribute("id")] = data;
    }
    function buildAnimationClip(data) {
      const tracks = [];
      const name = data.name;
      const duration2 = data.end - data.start || -1;
      const animations2 = data.animations;
      for (let i2 = 0, il = animations2.length; i2 < il; i2++) {
        const animationTracks = getAnimation(animations2[i2]);
        for (let j = 0, jl = animationTracks.length; j < jl; j++) {
          tracks.push(animationTracks[j]);
        }
      }
      return new AnimationClip$1(name, duration2, tracks);
    }
    function getAnimationClip(id) {
      return getBuild(library.clips[id], buildAnimationClip);
    }
    function parseController(xml2) {
      const data = {};
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "skin":
            data.id = parseId(child.getAttribute("source"));
            data.skin = parseSkin(child);
            break;
          case "morph":
            data.id = parseId(child.getAttribute("source"));
            console.warn("THREE.ColladaLoader: Morph target animation not supported yet.");
            break;
        }
      }
      library.controllers[xml2.getAttribute("id")] = data;
    }
    function parseSkin(xml2) {
      const data = {
        sources: {}
      };
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "bind_shape_matrix":
            data.bindShapeMatrix = parseFloats(child.textContent);
            break;
          case "source":
            const id = child.getAttribute("id");
            data.sources[id] = parseSource(child);
            break;
          case "joints":
            data.joints = parseJoints(child);
            break;
          case "vertex_weights":
            data.vertexWeights = parseVertexWeights(child);
            break;
        }
      }
      return data;
    }
    function parseJoints(xml2) {
      const data = {
        inputs: {}
      };
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "input":
            const semantic = child.getAttribute("semantic");
            const id = parseId(child.getAttribute("source"));
            data.inputs[semantic] = id;
            break;
        }
      }
      return data;
    }
    function parseVertexWeights(xml2) {
      const data = {
        inputs: {}
      };
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "input":
            const semantic = child.getAttribute("semantic");
            const id = parseId(child.getAttribute("source"));
            const offset = parseInt(child.getAttribute("offset"));
            data.inputs[semantic] = { id, offset };
            break;
          case "vcount":
            data.vcount = parseInts(child.textContent);
            break;
          case "v":
            data.v = parseInts(child.textContent);
            break;
        }
      }
      return data;
    }
    function buildController(data) {
      const build = {
        id: data.id
      };
      const geometry = library.geometries[build.id];
      if (data.skin !== void 0) {
        build.skin = buildSkin(data.skin);
        geometry.sources.skinIndices = build.skin.indices;
        geometry.sources.skinWeights = build.skin.weights;
      }
      return build;
    }
    function buildSkin(data) {
      const BONE_LIMIT = 4;
      const build = {
        joints: [],
        // this must be an array to preserve the joint order
        indices: {
          array: [],
          stride: BONE_LIMIT
        },
        weights: {
          array: [],
          stride: BONE_LIMIT
        }
      };
      const sources = data.sources;
      const vertexWeights = data.vertexWeights;
      const vcount = vertexWeights.vcount;
      const v = vertexWeights.v;
      const jointOffset = vertexWeights.inputs.JOINT.offset;
      const weightOffset = vertexWeights.inputs.WEIGHT.offset;
      const jointSource = data.sources[data.joints.inputs.JOINT];
      const inverseSource = data.sources[data.joints.inputs.INV_BIND_MATRIX];
      const weights = sources[vertexWeights.inputs.WEIGHT.id].array;
      let stride = 0;
      let i2, j, l2;
      for (i2 = 0, l2 = vcount.length; i2 < l2; i2++) {
        const jointCount = vcount[i2];
        const vertexSkinData = [];
        for (j = 0; j < jointCount; j++) {
          const skinIndex = v[stride + jointOffset];
          const weightId = v[stride + weightOffset];
          const skinWeight = weights[weightId];
          vertexSkinData.push({ index: skinIndex, weight: skinWeight });
          stride += 2;
        }
        vertexSkinData.sort(descending);
        for (j = 0; j < BONE_LIMIT; j++) {
          const d2 = vertexSkinData[j];
          if (d2 !== void 0) {
            build.indices.array.push(d2.index);
            build.weights.array.push(d2.weight);
          } else {
            build.indices.array.push(0);
            build.weights.array.push(0);
          }
        }
      }
      if (data.bindShapeMatrix) {
        build.bindMatrix = new Matrix4$1().fromArray(data.bindShapeMatrix).transpose();
      } else {
        build.bindMatrix = new Matrix4$1().identity();
      }
      for (i2 = 0, l2 = jointSource.array.length; i2 < l2; i2++) {
        const name = jointSource.array[i2];
        const boneInverse = new Matrix4$1().fromArray(inverseSource.array, i2 * inverseSource.stride).transpose();
        build.joints.push({ name, boneInverse });
      }
      return build;
      function descending(a3, b) {
        return b.weight - a3.weight;
      }
    }
    function getController(id) {
      return getBuild(library.controllers[id], buildController);
    }
    function parseImage(xml2) {
      const data = {
        init_from: getElementsByTagName(xml2, "init_from")[0].textContent
      };
      library.images[xml2.getAttribute("id")] = data;
    }
    function buildImage(data) {
      if (data.build !== void 0) return data.build;
      return data.init_from;
    }
    function getImage(id) {
      const data = library.images[id];
      if (data !== void 0) {
        return getBuild(data, buildImage);
      }
      console.warn("THREE.ColladaLoader: Couldn't find image with ID:", id);
      return null;
    }
    function parseEffect(xml2) {
      const data = {};
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "profile_COMMON":
            data.profile = parseEffectProfileCOMMON(child);
            break;
        }
      }
      library.effects[xml2.getAttribute("id")] = data;
    }
    function parseEffectProfileCOMMON(xml2) {
      const data = {
        surfaces: {},
        samplers: {}
      };
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "newparam":
            parseEffectNewparam(child, data);
            break;
          case "technique":
            data.technique = parseEffectTechnique(child);
            break;
          case "extra":
            data.extra = parseEffectExtra(child);
            break;
        }
      }
      return data;
    }
    function parseEffectNewparam(xml2, data) {
      const sid = xml2.getAttribute("sid");
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "surface":
            data.surfaces[sid] = parseEffectSurface(child);
            break;
          case "sampler2D":
            data.samplers[sid] = parseEffectSampler(child);
            break;
        }
      }
    }
    function parseEffectSurface(xml2) {
      const data = {};
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "init_from":
            data.init_from = child.textContent;
            break;
        }
      }
      return data;
    }
    function parseEffectSampler(xml2) {
      const data = {};
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "source":
            data.source = child.textContent;
            break;
        }
      }
      return data;
    }
    function parseEffectTechnique(xml2) {
      const data = {};
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "constant":
          case "lambert":
          case "blinn":
          case "phong":
            data.type = child.nodeName;
            data.parameters = parseEffectParameters(child);
            break;
          case "extra":
            data.extra = parseEffectExtra(child);
            break;
        }
      }
      return data;
    }
    function parseEffectParameters(xml2) {
      const data = {};
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "emission":
          case "diffuse":
          case "specular":
          case "bump":
          case "ambient":
          case "shininess":
          case "transparency":
            data[child.nodeName] = parseEffectParameter(child);
            break;
          case "transparent":
            data[child.nodeName] = {
              opaque: child.hasAttribute("opaque") ? child.getAttribute("opaque") : "A_ONE",
              data: parseEffectParameter(child)
            };
            break;
        }
      }
      return data;
    }
    function parseEffectParameter(xml2) {
      const data = {};
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "color":
            data[child.nodeName] = parseFloats(child.textContent);
            break;
          case "float":
            data[child.nodeName] = parseFloat(child.textContent);
            break;
          case "texture":
            data[child.nodeName] = { id: child.getAttribute("texture"), extra: parseEffectParameterTexture(child) };
            break;
        }
      }
      return data;
    }
    function parseEffectParameterTexture(xml2) {
      const data = {
        technique: {}
      };
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "extra":
            parseEffectParameterTextureExtra(child, data);
            break;
        }
      }
      return data;
    }
    function parseEffectParameterTextureExtra(xml2, data) {
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "technique":
            parseEffectParameterTextureExtraTechnique(child, data);
            break;
        }
      }
    }
    function parseEffectParameterTextureExtraTechnique(xml2, data) {
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "repeatU":
          case "repeatV":
          case "offsetU":
          case "offsetV":
            data.technique[child.nodeName] = parseFloat(child.textContent);
            break;
          case "wrapU":
          case "wrapV":
            if (child.textContent.toUpperCase() === "TRUE") {
              data.technique[child.nodeName] = 1;
            } else if (child.textContent.toUpperCase() === "FALSE") {
              data.technique[child.nodeName] = 0;
            } else {
              data.technique[child.nodeName] = parseInt(child.textContent);
            }
            break;
          case "bump":
            data[child.nodeName] = parseEffectExtraTechniqueBump(child);
            break;
        }
      }
    }
    function parseEffectExtra(xml2) {
      const data = {};
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "technique":
            data.technique = parseEffectExtraTechnique(child);
            break;
        }
      }
      return data;
    }
    function parseEffectExtraTechnique(xml2) {
      const data = {};
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "double_sided":
            data[child.nodeName] = parseInt(child.textContent);
            break;
          case "bump":
            data[child.nodeName] = parseEffectExtraTechniqueBump(child);
            break;
        }
      }
      return data;
    }
    function parseEffectExtraTechniqueBump(xml2) {
      const data = {};
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "texture":
            data[child.nodeName] = { id: child.getAttribute("texture"), texcoord: child.getAttribute("texcoord"), extra: parseEffectParameterTexture(child) };
            break;
        }
      }
      return data;
    }
    function buildEffect(data) {
      return data;
    }
    function getEffect(id) {
      return getBuild(library.effects[id], buildEffect);
    }
    function parseMaterial(xml2) {
      const data = {
        name: xml2.getAttribute("name")
      };
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "instance_effect":
            data.url = parseId(child.getAttribute("url"));
            break;
        }
      }
      library.materials[xml2.getAttribute("id")] = data;
    }
    function getTextureLoader(image2) {
      let loader;
      let extension = image2.slice((image2.lastIndexOf(".") - 1 >>> 0) + 2);
      extension = extension.toLowerCase();
      switch (extension) {
        case "tga":
          loader = tgaLoader;
          break;
        default:
          loader = textureLoader;
      }
      return loader;
    }
    function buildMaterial(data) {
      const effect = getEffect(data.url);
      const technique = effect.profile.technique;
      let material;
      switch (technique.type) {
        case "phong":
        case "blinn":
          material = new MeshPhongMaterial$1();
          break;
        case "lambert":
          material = new MeshLambertMaterial$1();
          break;
        default:
          material = new MeshBasicMaterial$1();
          break;
      }
      material.name = data.name || "";
      function getTexture(textureObject, colorSpace = null) {
        const sampler = effect.profile.samplers[textureObject.id];
        let image2 = null;
        if (sampler !== void 0) {
          const surface = effect.profile.surfaces[sampler.source];
          image2 = getImage(surface.init_from);
        } else {
          console.warn("THREE.ColladaLoader: Undefined sampler. Access image directly (see #12530).");
          image2 = getImage(textureObject.id);
        }
        if (image2 !== null) {
          const loader = getTextureLoader(image2);
          if (loader !== void 0) {
            const texture = loader.load(image2);
            const extra = textureObject.extra;
            if (extra !== void 0 && extra.technique !== void 0 && isEmpty(extra.technique) === false) {
              const technique2 = extra.technique;
              texture.wrapS = technique2.wrapU ? RepeatWrapping$1 : ClampToEdgeWrapping$1;
              texture.wrapT = technique2.wrapV ? RepeatWrapping$1 : ClampToEdgeWrapping$1;
              texture.offset.set(technique2.offsetU || 0, technique2.offsetV || 0);
              texture.repeat.set(technique2.repeatU || 1, technique2.repeatV || 1);
            } else {
              texture.wrapS = RepeatWrapping$1;
              texture.wrapT = RepeatWrapping$1;
            }
            if (colorSpace !== null) {
              texture.colorSpace = colorSpace;
            }
            return texture;
          } else {
            console.warn("THREE.ColladaLoader: Loader for texture %s not found.", image2);
            return null;
          }
        } else {
          console.warn("THREE.ColladaLoader: Couldn't create texture with ID:", textureObject.id);
          return null;
        }
      }
      const parameters = technique.parameters;
      for (const key in parameters) {
        const parameter = parameters[key];
        switch (key) {
          case "diffuse":
            if (parameter.color) material.color.fromArray(parameter.color);
            if (parameter.texture) material.map = getTexture(parameter.texture, SRGBColorSpace);
            break;
          case "specular":
            if (parameter.color && material.specular) material.specular.fromArray(parameter.color);
            if (parameter.texture) material.specularMap = getTexture(parameter.texture);
            break;
          case "bump":
            if (parameter.texture) material.normalMap = getTexture(parameter.texture);
            break;
          case "ambient":
            if (parameter.texture) material.lightMap = getTexture(parameter.texture, SRGBColorSpace);
            break;
          case "shininess":
            if (parameter.float && material.shininess) material.shininess = parameter.float;
            break;
          case "emission":
            if (parameter.color && material.emissive) material.emissive.fromArray(parameter.color);
            if (parameter.texture) material.emissiveMap = getTexture(parameter.texture, SRGBColorSpace);
            break;
        }
      }
      ColorManagement.toWorkingColorSpace(material.color, SRGBColorSpace);
      if (material.specular) ColorManagement.toWorkingColorSpace(material.specular, SRGBColorSpace);
      if (material.emissive) ColorManagement.toWorkingColorSpace(material.emissive, SRGBColorSpace);
      let transparent = parameters["transparent"];
      let transparency = parameters["transparency"];
      if (transparency === void 0 && transparent) {
        transparency = {
          float: 1
        };
      }
      if (transparent === void 0 && transparency) {
        transparent = {
          opaque: "A_ONE",
          data: {
            color: [1, 1, 1, 1]
          }
        };
      }
      if (transparent && transparency) {
        if (transparent.data.texture) {
          material.transparent = true;
        } else {
          const color2 = transparent.data.color;
          switch (transparent.opaque) {
            case "A_ONE":
              material.opacity = color2[3] * transparency.float;
              break;
            case "RGB_ZERO":
              material.opacity = 1 - color2[0] * transparency.float;
              break;
            case "A_ZERO":
              material.opacity = 1 - color2[3] * transparency.float;
              break;
            case "RGB_ONE":
              material.opacity = color2[0] * transparency.float;
              break;
            default:
              console.warn('THREE.ColladaLoader: Invalid opaque type "%s" of transparent tag.', transparent.opaque);
          }
          if (material.opacity < 1) material.transparent = true;
        }
      }
      if (technique.extra !== void 0 && technique.extra.technique !== void 0) {
        const techniques = technique.extra.technique;
        for (const k in techniques) {
          const v = techniques[k];
          switch (k) {
            case "double_sided":
              material.side = v === 1 ? DoubleSide$1 : FrontSide$1;
              break;
            case "bump":
              material.normalMap = getTexture(v.texture);
              material.normalScale = new Vector2$1(1, 1);
              break;
          }
        }
      }
      return material;
    }
    function getMaterial(id) {
      return getBuild(library.materials[id], buildMaterial);
    }
    function parseCamera(xml2) {
      const data = {
        name: xml2.getAttribute("name")
      };
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "optics":
            data.optics = parseCameraOptics(child);
            break;
        }
      }
      library.cameras[xml2.getAttribute("id")] = data;
    }
    function parseCameraOptics(xml2) {
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        switch (child.nodeName) {
          case "technique_common":
            return parseCameraTechnique(child);
        }
      }
      return {};
    }
    function parseCameraTechnique(xml2) {
      const data = {};
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        switch (child.nodeName) {
          case "perspective":
          case "orthographic":
            data.technique = child.nodeName;
            data.parameters = parseCameraParameters(child);
            break;
        }
      }
      return data;
    }
    function parseCameraParameters(xml2) {
      const data = {};
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        switch (child.nodeName) {
          case "xfov":
          case "yfov":
          case "xmag":
          case "ymag":
          case "znear":
          case "zfar":
          case "aspect_ratio":
            data[child.nodeName] = parseFloat(child.textContent);
            break;
        }
      }
      return data;
    }
    function buildCamera(data) {
      let camera;
      switch (data.optics.technique) {
        case "perspective":
          camera = new PerspectiveCamera$1(
            data.optics.parameters.yfov,
            data.optics.parameters.aspect_ratio,
            data.optics.parameters.znear,
            data.optics.parameters.zfar
          );
          break;
        case "orthographic":
          let ymag = data.optics.parameters.ymag;
          let xmag = data.optics.parameters.xmag;
          const aspectRatio = data.optics.parameters.aspect_ratio;
          xmag = xmag === void 0 ? ymag * aspectRatio : xmag;
          ymag = ymag === void 0 ? xmag / aspectRatio : ymag;
          xmag *= 0.5;
          ymag *= 0.5;
          camera = new OrthographicCamera$1(
            -xmag,
            xmag,
            ymag,
            -ymag,
            // left, right, top, bottom
            data.optics.parameters.znear,
            data.optics.parameters.zfar
          );
          break;
        default:
          camera = new PerspectiveCamera$1();
          break;
      }
      camera.name = data.name || "";
      return camera;
    }
    function getCamera(id) {
      const data = library.cameras[id];
      if (data !== void 0) {
        return getBuild(data, buildCamera);
      }
      console.warn("THREE.ColladaLoader: Couldn't find camera with ID:", id);
      return null;
    }
    function parseLight(xml2) {
      let data = {};
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "technique_common":
            data = parseLightTechnique(child);
            break;
        }
      }
      library.lights[xml2.getAttribute("id")] = data;
    }
    function parseLightTechnique(xml2) {
      const data = {};
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "directional":
          case "point":
          case "spot":
          case "ambient":
            data.technique = child.nodeName;
            data.parameters = parseLightParameters(child);
        }
      }
      return data;
    }
    function parseLightParameters(xml2) {
      const data = {};
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "color":
            const array = parseFloats(child.textContent);
            data.color = new Color$1().fromArray(array);
            ColorManagement.toWorkingColorSpace(data.color, SRGBColorSpace);
            break;
          case "falloff_angle":
            data.falloffAngle = parseFloat(child.textContent);
            break;
          case "quadratic_attenuation":
            const f2 = parseFloat(child.textContent);
            data.distance = f2 ? Math.sqrt(1 / f2) : 0;
            break;
        }
      }
      return data;
    }
    function buildLight(data) {
      let light;
      switch (data.technique) {
        case "directional":
          light = new DirectionalLight$1();
          break;
        case "point":
          light = new PointLight$1();
          break;
        case "spot":
          light = new SpotLight$1();
          break;
        case "ambient":
          light = new AmbientLight$1();
          break;
      }
      if (data.parameters.color) light.color.copy(data.parameters.color);
      if (data.parameters.distance) light.distance = data.parameters.distance;
      return light;
    }
    function getLight(id) {
      const data = library.lights[id];
      if (data !== void 0) {
        return getBuild(data, buildLight);
      }
      console.warn("THREE.ColladaLoader: Couldn't find light with ID:", id);
      return null;
    }
    function parseGeometry(xml2) {
      const data = {
        name: xml2.getAttribute("name"),
        sources: {},
        vertices: {},
        primitives: []
      };
      const mesh = getElementsByTagName(xml2, "mesh")[0];
      if (mesh === void 0) return;
      for (let i2 = 0; i2 < mesh.childNodes.length; i2++) {
        const child = mesh.childNodes[i2];
        if (child.nodeType !== 1) continue;
        const id = child.getAttribute("id");
        switch (child.nodeName) {
          case "source":
            data.sources[id] = parseSource(child);
            break;
          case "vertices":
            data.vertices = parseGeometryVertices(child);
            break;
          case "polygons":
            console.warn("THREE.ColladaLoader: Unsupported primitive type: ", child.nodeName);
            break;
          case "lines":
          case "linestrips":
          case "polylist":
          case "triangles":
            data.primitives.push(parseGeometryPrimitive(child));
            break;
          default:
            console.log(child);
        }
      }
      library.geometries[xml2.getAttribute("id")] = data;
    }
    function parseSource(xml2) {
      const data = {
        array: [],
        stride: 3
      };
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "float_array":
            data.array = parseFloats(child.textContent);
            break;
          case "Name_array":
            data.array = parseStrings(child.textContent);
            break;
          case "technique_common":
            const accessor = getElementsByTagName(child, "accessor")[0];
            if (accessor !== void 0) {
              data.stride = parseInt(accessor.getAttribute("stride"));
            }
            break;
        }
      }
      return data;
    }
    function parseGeometryVertices(xml2) {
      const data = {};
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        data[child.getAttribute("semantic")] = parseId(child.getAttribute("source"));
      }
      return data;
    }
    function parseGeometryPrimitive(xml2) {
      const primitive = {
        type: xml2.nodeName,
        material: xml2.getAttribute("material"),
        count: parseInt(xml2.getAttribute("count")),
        inputs: {},
        stride: 0,
        hasUV: false
      };
      for (let i2 = 0, l2 = xml2.childNodes.length; i2 < l2; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "input":
            const id = parseId(child.getAttribute("source"));
            const semantic = child.getAttribute("semantic");
            const offset = parseInt(child.getAttribute("offset"));
            const set = parseInt(child.getAttribute("set"));
            const inputname = set > 0 ? semantic + set : semantic;
            primitive.inputs[inputname] = { id, offset };
            primitive.stride = Math.max(primitive.stride, offset + 1);
            if (semantic === "TEXCOORD") primitive.hasUV = true;
            break;
          case "vcount":
            primitive.vcount = parseInts(child.textContent);
            break;
          case "p":
            primitive.p = parseInts(child.textContent);
            break;
        }
      }
      return primitive;
    }
    function groupPrimitives(primitives) {
      const build = {};
      for (let i2 = 0; i2 < primitives.length; i2++) {
        const primitive = primitives[i2];
        if (build[primitive.type] === void 0) build[primitive.type] = [];
        build[primitive.type].push(primitive);
      }
      return build;
    }
    function checkUVCoordinates(primitives) {
      let count2 = 0;
      for (let i2 = 0, l2 = primitives.length; i2 < l2; i2++) {
        const primitive = primitives[i2];
        if (primitive.hasUV === true) {
          count2++;
        }
      }
      if (count2 > 0 && count2 < primitives.length) {
        primitives.uvsNeedsFix = true;
      }
    }
    function buildGeometry(data) {
      const build = {};
      const sources = data.sources;
      const vertices = data.vertices;
      const primitives = data.primitives;
      if (primitives.length === 0) return {};
      const groupedPrimitives = groupPrimitives(primitives);
      for (const type in groupedPrimitives) {
        const primitiveType = groupedPrimitives[type];
        checkUVCoordinates(primitiveType);
        build[type] = buildGeometryType(primitiveType, sources, vertices);
      }
      return build;
    }
    function buildGeometryType(primitives, sources, vertices) {
      const build = {};
      const position3 = { array: [], stride: 0 };
      const normal = { array: [], stride: 0 };
      const uv = { array: [], stride: 0 };
      const uv1 = { array: [], stride: 0 };
      const color2 = { array: [], stride: 0 };
      const skinIndex = { array: [], stride: 4 };
      const skinWeight = { array: [], stride: 4 };
      const geometry = new BufferGeometry$1();
      const materialKeys = [];
      let start = 0;
      for (let p2 = 0; p2 < primitives.length; p2++) {
        const primitive = primitives[p2];
        const inputs = primitive.inputs;
        let count2 = 0;
        switch (primitive.type) {
          case "lines":
          case "linestrips":
            count2 = primitive.count * 2;
            break;
          case "triangles":
            count2 = primitive.count * 3;
            break;
          case "polylist":
            for (let g3 = 0; g3 < primitive.count; g3++) {
              const vc = primitive.vcount[g3];
              switch (vc) {
                case 3:
                  count2 += 3;
                  break;
                case 4:
                  count2 += 6;
                  break;
                default:
                  count2 += (vc - 2) * 3;
                  break;
              }
            }
            break;
          default:
            console.warn("THREE.ColladaLoader: Unknow primitive type:", primitive.type);
        }
        geometry.addGroup(start, count2, p2);
        start += count2;
        if (primitive.material) {
          materialKeys.push(primitive.material);
        }
        for (const name in inputs) {
          const input = inputs[name];
          switch (name) {
            case "VERTEX":
              for (const key in vertices) {
                const id = vertices[key];
                switch (key) {
                  case "POSITION":
                    const prevLength = position3.array.length;
                    buildGeometryData(primitive, sources[id], input.offset, position3.array);
                    position3.stride = sources[id].stride;
                    if (sources.skinWeights && sources.skinIndices) {
                      buildGeometryData(primitive, sources.skinIndices, input.offset, skinIndex.array);
                      buildGeometryData(primitive, sources.skinWeights, input.offset, skinWeight.array);
                    }
                    if (primitive.hasUV === false && primitives.uvsNeedsFix === true) {
                      const count3 = (position3.array.length - prevLength) / position3.stride;
                      for (let i2 = 0; i2 < count3; i2++) {
                        uv.array.push(0, 0);
                      }
                    }
                    break;
                  case "NORMAL":
                    buildGeometryData(primitive, sources[id], input.offset, normal.array);
                    normal.stride = sources[id].stride;
                    break;
                  case "COLOR":
                    buildGeometryData(primitive, sources[id], input.offset, color2.array);
                    color2.stride = sources[id].stride;
                    break;
                  case "TEXCOORD":
                    buildGeometryData(primitive, sources[id], input.offset, uv.array);
                    uv.stride = sources[id].stride;
                    break;
                  case "TEXCOORD1":
                    buildGeometryData(primitive, sources[id], input.offset, uv1.array);
                    uv.stride = sources[id].stride;
                    break;
                  default:
                    console.warn('THREE.ColladaLoader: Semantic "%s" not handled in geometry build process.', key);
                }
              }
              break;
            case "NORMAL":
              buildGeometryData(primitive, sources[input.id], input.offset, normal.array);
              normal.stride = sources[input.id].stride;
              break;
            case "COLOR":
              buildGeometryData(primitive, sources[input.id], input.offset, color2.array, true);
              color2.stride = sources[input.id].stride;
              break;
            case "TEXCOORD":
              buildGeometryData(primitive, sources[input.id], input.offset, uv.array);
              uv.stride = sources[input.id].stride;
              break;
            case "TEXCOORD1":
              buildGeometryData(primitive, sources[input.id], input.offset, uv1.array);
              uv1.stride = sources[input.id].stride;
              break;
          }
        }
      }
      if (position3.array.length > 0) geometry.setAttribute("position", new Float32BufferAttribute$1(position3.array, position3.stride));
      if (normal.array.length > 0) geometry.setAttribute("normal", new Float32BufferAttribute$1(normal.array, normal.stride));
      if (color2.array.length > 0) geometry.setAttribute("color", new Float32BufferAttribute$1(color2.array, color2.stride));
      if (uv.array.length > 0) geometry.setAttribute("uv", new Float32BufferAttribute$1(uv.array, uv.stride));
      if (uv1.array.length > 0) geometry.setAttribute("uv1", new Float32BufferAttribute$1(uv1.array, uv1.stride));
      if (skinIndex.array.length > 0) geometry.setAttribute("skinIndex", new Float32BufferAttribute$1(skinIndex.array, skinIndex.stride));
      if (skinWeight.array.length > 0) geometry.setAttribute("skinWeight", new Float32BufferAttribute$1(skinWeight.array, skinWeight.stride));
      build.data = geometry;
      build.type = primitives[0].type;
      build.materialKeys = materialKeys;
      return build;
    }
    function buildGeometryData(primitive, source, offset, array, isColor = false) {
      const indices = primitive.p;
      const stride = primitive.stride;
      const vcount = primitive.vcount;
      function pushVector(i2) {
        let index2 = indices[i2 + offset] * sourceStride;
        const length2 = index2 + sourceStride;
        for (; index2 < length2; index2++) {
          array.push(sourceArray[index2]);
        }
        if (isColor) {
          const startIndex = array.length - sourceStride - 1;
          tempColor.setRGB(
            array[startIndex + 0],
            array[startIndex + 1],
            array[startIndex + 2],
            SRGBColorSpace
          );
          array[startIndex + 0] = tempColor.r;
          array[startIndex + 1] = tempColor.g;
          array[startIndex + 2] = tempColor.b;
        }
      }
      const sourceArray = source.array;
      const sourceStride = source.stride;
      if (primitive.vcount !== void 0) {
        let index2 = 0;
        for (let i2 = 0, l2 = vcount.length; i2 < l2; i2++) {
          const count2 = vcount[i2];
          if (count2 === 4) {
            const a3 = index2 + stride * 0;
            const b = index2 + stride * 1;
            const c2 = index2 + stride * 2;
            const d2 = index2 + stride * 3;
            pushVector(a3);
            pushVector(b);
            pushVector(d2);
            pushVector(b);
            pushVector(c2);
            pushVector(d2);
          } else if (count2 === 3) {
            const a3 = index2 + stride * 0;
            const b = index2 + stride * 1;
            const c2 = index2 + stride * 2;
            pushVector(a3);
            pushVector(b);
            pushVector(c2);
          } else if (count2 > 4) {
            for (let k = 1, kl = count2 - 2; k <= kl; k++) {
              const a3 = index2 + stride * 0;
              const b = index2 + stride * k;
              const c2 = index2 + stride * (k + 1);
              pushVector(a3);
              pushVector(b);
              pushVector(c2);
            }
          }
          index2 += stride * count2;
        }
      } else {
        for (let i2 = 0, l2 = indices.length; i2 < l2; i2 += stride) {
          pushVector(i2);
        }
      }
    }
    function getGeometry(id) {
      return getBuild(library.geometries[id], buildGeometry);
    }
    function parseKinematicsModel(xml2) {
      const data = {
        name: xml2.getAttribute("name") || "",
        joints: {},
        links: []
      };
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "technique_common":
            parseKinematicsTechniqueCommon(child, data);
            break;
        }
      }
      library.kinematicsModels[xml2.getAttribute("id")] = data;
    }
    function buildKinematicsModel(data) {
      if (data.build !== void 0) return data.build;
      return data;
    }
    function getKinematicsModel(id) {
      return getBuild(library.kinematicsModels[id], buildKinematicsModel);
    }
    function parseKinematicsTechniqueCommon(xml2, data) {
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "joint":
            data.joints[child.getAttribute("sid")] = parseKinematicsJoint(child);
            break;
          case "link":
            data.links.push(parseKinematicsLink(child));
            break;
        }
      }
    }
    function parseKinematicsJoint(xml2) {
      let data;
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "prismatic":
          case "revolute":
            data = parseKinematicsJointParameter(child);
            break;
        }
      }
      return data;
    }
    function parseKinematicsJointParameter(xml2) {
      const data = {
        sid: xml2.getAttribute("sid"),
        name: xml2.getAttribute("name") || "",
        axis: new Vector3$1(),
        limits: {
          min: 0,
          max: 0
        },
        type: xml2.nodeName,
        static: false,
        zeroPosition: 0,
        middlePosition: 0
      };
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "axis":
            const array = parseFloats(child.textContent);
            data.axis.fromArray(array);
            break;
          case "limits":
            const max2 = child.getElementsByTagName("max")[0];
            const min = child.getElementsByTagName("min")[0];
            data.limits.max = parseFloat(max2.textContent);
            data.limits.min = parseFloat(min.textContent);
            break;
        }
      }
      if (data.limits.min >= data.limits.max) {
        data.static = true;
      }
      data.middlePosition = (data.limits.min + data.limits.max) / 2;
      return data;
    }
    function parseKinematicsLink(xml2) {
      const data = {
        sid: xml2.getAttribute("sid"),
        name: xml2.getAttribute("name") || "",
        attachments: [],
        transforms: []
      };
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "attachment_full":
            data.attachments.push(parseKinematicsAttachment(child));
            break;
          case "matrix":
          case "translate":
          case "rotate":
            data.transforms.push(parseKinematicsTransform(child));
            break;
        }
      }
      return data;
    }
    function parseKinematicsAttachment(xml2) {
      const data = {
        joint: xml2.getAttribute("joint").split("/").pop(),
        transforms: [],
        links: []
      };
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "link":
            data.links.push(parseKinematicsLink(child));
            break;
          case "matrix":
          case "translate":
          case "rotate":
            data.transforms.push(parseKinematicsTransform(child));
            break;
        }
      }
      return data;
    }
    function parseKinematicsTransform(xml2) {
      const data = {
        type: xml2.nodeName
      };
      const array = parseFloats(xml2.textContent);
      switch (data.type) {
        case "matrix":
          data.obj = new Matrix4$1();
          data.obj.fromArray(array).transpose();
          break;
        case "translate":
          data.obj = new Vector3$1();
          data.obj.fromArray(array);
          break;
        case "rotate":
          data.obj = new Vector3$1();
          data.obj.fromArray(array);
          data.angle = MathUtils.degToRad(array[3]);
          break;
      }
      return data;
    }
    function parsePhysicsModel(xml2) {
      const data = {
        name: xml2.getAttribute("name") || "",
        rigidBodies: {}
      };
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "rigid_body":
            data.rigidBodies[child.getAttribute("name")] = {};
            parsePhysicsRigidBody(child, data.rigidBodies[child.getAttribute("name")]);
            break;
        }
      }
      library.physicsModels[xml2.getAttribute("id")] = data;
    }
    function parsePhysicsRigidBody(xml2, data) {
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "technique_common":
            parsePhysicsTechniqueCommon(child, data);
            break;
        }
      }
    }
    function parsePhysicsTechniqueCommon(xml2, data) {
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "inertia":
            data.inertia = parseFloats(child.textContent);
            break;
          case "mass":
            data.mass = parseFloats(child.textContent)[0];
            break;
        }
      }
    }
    function parseKinematicsScene(xml2) {
      const data = {
        bindJointAxis: []
      };
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "bind_joint_axis":
            data.bindJointAxis.push(parseKinematicsBindJointAxis(child));
            break;
        }
      }
      library.kinematicsScenes[parseId(xml2.getAttribute("url"))] = data;
    }
    function parseKinematicsBindJointAxis(xml2) {
      const data = {
        target: xml2.getAttribute("target").split("/").pop()
      };
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        switch (child.nodeName) {
          case "axis":
            const param = child.getElementsByTagName("param")[0];
            data.axis = param.textContent;
            const tmpJointIndex = data.axis.split("inst_").pop().split("axis")[0];
            data.jointIndex = tmpJointIndex.substring(0, tmpJointIndex.length - 1);
            break;
        }
      }
      return data;
    }
    function buildKinematicsScene(data) {
      if (data.build !== void 0) return data.build;
      return data;
    }
    function getKinematicsScene(id) {
      return getBuild(library.kinematicsScenes[id], buildKinematicsScene);
    }
    function setupKinematics() {
      const kinematicsModelId = Object.keys(library.kinematicsModels)[0];
      const kinematicsSceneId = Object.keys(library.kinematicsScenes)[0];
      const visualSceneId = Object.keys(library.visualScenes)[0];
      if (kinematicsModelId === void 0 || kinematicsSceneId === void 0) return;
      const kinematicsModel = getKinematicsModel(kinematicsModelId);
      const kinematicsScene = getKinematicsScene(kinematicsSceneId);
      const visualScene = getVisualScene(visualSceneId);
      const bindJointAxis = kinematicsScene.bindJointAxis;
      const jointMap = {};
      for (let i2 = 0, l2 = bindJointAxis.length; i2 < l2; i2++) {
        const axis = bindJointAxis[i2];
        const targetElement = collada.querySelector('[sid="' + axis.target + '"]');
        if (targetElement) {
          const parentVisualElement = targetElement.parentElement;
          connect(axis.jointIndex, parentVisualElement);
        }
      }
      function connect(jointIndex, visualElement) {
        const visualElementName = visualElement.getAttribute("name");
        const joint = kinematicsModel.joints[jointIndex];
        visualScene.traverse(function(object) {
          if (object.name === visualElementName) {
            jointMap[jointIndex] = {
              object,
              transforms: buildTransformList(visualElement),
              joint,
              position: joint.zeroPosition
            };
          }
        });
      }
      const m0 = new Matrix4$1();
      kinematics = {
        joints: kinematicsModel && kinematicsModel.joints,
        getJointValue: function(jointIndex) {
          const jointData = jointMap[jointIndex];
          if (jointData) {
            return jointData.position;
          } else {
            console.warn("THREE.ColladaLoader: Joint " + jointIndex + " doesn't exist.");
          }
        },
        setJointValue: function(jointIndex, value) {
          const jointData = jointMap[jointIndex];
          if (jointData) {
            const joint = jointData.joint;
            if (value > joint.limits.max || value < joint.limits.min) {
              console.warn("THREE.ColladaLoader: Joint " + jointIndex + " value " + value + " outside of limits (min: " + joint.limits.min + ", max: " + joint.limits.max + ").");
            } else if (joint.static) {
              console.warn("THREE.ColladaLoader: Joint " + jointIndex + " is static.");
            } else {
              const object = jointData.object;
              const axis = joint.axis;
              const transforms = jointData.transforms;
              matrix2.identity();
              for (let i2 = 0; i2 < transforms.length; i2++) {
                const transform2 = transforms[i2];
                if (transform2.sid && transform2.sid.indexOf(jointIndex) !== -1) {
                  switch (joint.type) {
                    case "revolute":
                      matrix2.multiply(m0.makeRotationAxis(axis, MathUtils.degToRad(value)));
                      break;
                    case "prismatic":
                      matrix2.multiply(m0.makeTranslation(axis.x * value, axis.y * value, axis.z * value));
                      break;
                    default:
                      console.warn("THREE.ColladaLoader: Unknown joint type: " + joint.type);
                      break;
                  }
                } else {
                  switch (transform2.type) {
                    case "matrix":
                      matrix2.multiply(transform2.obj);
                      break;
                    case "translate":
                      matrix2.multiply(m0.makeTranslation(transform2.obj.x, transform2.obj.y, transform2.obj.z));
                      break;
                    case "scale":
                      matrix2.scale(transform2.obj);
                      break;
                    case "rotate":
                      matrix2.multiply(m0.makeRotationAxis(transform2.obj, transform2.angle));
                      break;
                  }
                }
              }
              object.matrix.copy(matrix2);
              object.matrix.decompose(object.position, object.quaternion, object.scale);
              jointMap[jointIndex].position = value;
            }
          } else {
            console.log("THREE.ColladaLoader: " + jointIndex + " does not exist.");
          }
        }
      };
    }
    function buildTransformList(node) {
      const transforms = [];
      const xml2 = collada.querySelector('[id="' + node.id + '"]');
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        let array, vector2;
        switch (child.nodeName) {
          case "matrix":
            array = parseFloats(child.textContent);
            const matrix3 = new Matrix4$1().fromArray(array).transpose();
            transforms.push({
              sid: child.getAttribute("sid"),
              type: child.nodeName,
              obj: matrix3
            });
            break;
          case "translate":
          case "scale":
            array = parseFloats(child.textContent);
            vector2 = new Vector3$1().fromArray(array);
            transforms.push({
              sid: child.getAttribute("sid"),
              type: child.nodeName,
              obj: vector2
            });
            break;
          case "rotate":
            array = parseFloats(child.textContent);
            vector2 = new Vector3$1().fromArray(array);
            const angle2 = MathUtils.degToRad(array[3]);
            transforms.push({
              sid: child.getAttribute("sid"),
              type: child.nodeName,
              obj: vector2,
              angle: angle2
            });
            break;
        }
      }
      return transforms;
    }
    function prepareNodes(xml2) {
      const elements = xml2.getElementsByTagName("node");
      for (let i2 = 0; i2 < elements.length; i2++) {
        const element = elements[i2];
        if (element.hasAttribute("id") === false) {
          element.setAttribute("id", generateId());
        }
      }
    }
    const matrix2 = new Matrix4$1();
    const vector = new Vector3$1();
    function parseNode(xml2) {
      const data = {
        name: xml2.getAttribute("name") || "",
        type: xml2.getAttribute("type"),
        id: xml2.getAttribute("id"),
        sid: xml2.getAttribute("sid"),
        matrix: new Matrix4$1(),
        nodes: [],
        instanceCameras: [],
        instanceControllers: [],
        instanceLights: [],
        instanceGeometries: [],
        instanceNodes: [],
        transforms: {}
      };
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        if (child.nodeType !== 1) continue;
        let array;
        switch (child.nodeName) {
          case "node":
            data.nodes.push(child.getAttribute("id"));
            parseNode(child);
            break;
          case "instance_camera":
            data.instanceCameras.push(parseId(child.getAttribute("url")));
            break;
          case "instance_controller":
            data.instanceControllers.push(parseNodeInstance(child));
            break;
          case "instance_light":
            data.instanceLights.push(parseId(child.getAttribute("url")));
            break;
          case "instance_geometry":
            data.instanceGeometries.push(parseNodeInstance(child));
            break;
          case "instance_node":
            data.instanceNodes.push(parseId(child.getAttribute("url")));
            break;
          case "matrix":
            array = parseFloats(child.textContent);
            data.matrix.multiply(matrix2.fromArray(array).transpose());
            data.transforms[child.getAttribute("sid")] = child.nodeName;
            break;
          case "translate":
            array = parseFloats(child.textContent);
            vector.fromArray(array);
            data.matrix.multiply(matrix2.makeTranslation(vector.x, vector.y, vector.z));
            data.transforms[child.getAttribute("sid")] = child.nodeName;
            break;
          case "rotate":
            array = parseFloats(child.textContent);
            const angle2 = MathUtils.degToRad(array[3]);
            data.matrix.multiply(matrix2.makeRotationAxis(vector.fromArray(array), angle2));
            data.transforms[child.getAttribute("sid")] = child.nodeName;
            break;
          case "scale":
            array = parseFloats(child.textContent);
            data.matrix.scale(vector.fromArray(array));
            data.transforms[child.getAttribute("sid")] = child.nodeName;
            break;
          case "extra":
            break;
          default:
            console.log(child);
        }
      }
      if (hasNode(data.id)) {
        console.warn("THREE.ColladaLoader: There is already a node with ID %s. Exclude current node from further processing.", data.id);
      } else {
        library.nodes[data.id] = data;
      }
      return data;
    }
    function parseNodeInstance(xml2) {
      const data = {
        id: parseId(xml2.getAttribute("url")),
        materials: {},
        skeletons: []
      };
      for (let i2 = 0; i2 < xml2.childNodes.length; i2++) {
        const child = xml2.childNodes[i2];
        switch (child.nodeName) {
          case "bind_material":
            const instances = child.getElementsByTagName("instance_material");
            for (let j = 0; j < instances.length; j++) {
              const instance = instances[j];
              const symbol = instance.getAttribute("symbol");
              const target = instance.getAttribute("target");
              data.materials[symbol] = parseId(target);
            }
            break;
          case "skeleton":
            data.skeletons.push(parseId(child.textContent));
            break;
        }
      }
      return data;
    }
    function buildSkeleton(skeletons, joints) {
      const boneData = [];
      const sortedBoneData = [];
      let i2, j, data;
      for (i2 = 0; i2 < skeletons.length; i2++) {
        const skeleton = skeletons[i2];
        let root;
        if (hasNode(skeleton)) {
          root = getNode(skeleton);
          buildBoneHierarchy(root, joints, boneData);
        } else if (hasVisualScene(skeleton)) {
          const visualScene = library.visualScenes[skeleton];
          const children = visualScene.children;
          for (let j2 = 0; j2 < children.length; j2++) {
            const child = children[j2];
            if (child.type === "JOINT") {
              const root2 = getNode(child.id);
              buildBoneHierarchy(root2, joints, boneData);
            }
          }
        } else {
          console.error("THREE.ColladaLoader: Unable to find root bone of skeleton with ID:", skeleton);
        }
      }
      for (i2 = 0; i2 < joints.length; i2++) {
        for (j = 0; j < boneData.length; j++) {
          data = boneData[j];
          if (data.bone.name === joints[i2].name) {
            sortedBoneData[i2] = data;
            data.processed = true;
            break;
          }
        }
      }
      for (i2 = 0; i2 < boneData.length; i2++) {
        data = boneData[i2];
        if (data.processed === false) {
          sortedBoneData.push(data);
          data.processed = true;
        }
      }
      const bones = [];
      const boneInverses = [];
      for (i2 = 0; i2 < sortedBoneData.length; i2++) {
        data = sortedBoneData[i2];
        bones.push(data.bone);
        boneInverses.push(data.boneInverse);
      }
      return new Skeleton(bones, boneInverses);
    }
    function buildBoneHierarchy(root, joints, boneData) {
      root.traverse(function(object) {
        if (object.isBone === true) {
          let boneInverse;
          for (let i2 = 0; i2 < joints.length; i2++) {
            const joint = joints[i2];
            if (joint.name === object.name) {
              boneInverse = joint.boneInverse;
              break;
            }
          }
          if (boneInverse === void 0) {
            boneInverse = new Matrix4$1();
          }
          boneData.push({ bone: object, boneInverse, processed: false });
        }
      });
    }
    function buildNode(data) {
      const objects = [];
      const matrix3 = data.matrix;
      const nodes = data.nodes;
      const type = data.type;
      const instanceCameras = data.instanceCameras;
      const instanceControllers = data.instanceControllers;
      const instanceLights = data.instanceLights;
      const instanceGeometries = data.instanceGeometries;
      const instanceNodes = data.instanceNodes;
      for (let i2 = 0, l2 = nodes.length; i2 < l2; i2++) {
        objects.push(getNode(nodes[i2]));
      }
      for (let i2 = 0, l2 = instanceCameras.length; i2 < l2; i2++) {
        const instanceCamera = getCamera(instanceCameras[i2]);
        if (instanceCamera !== null) {
          objects.push(instanceCamera.clone());
        }
      }
      for (let i2 = 0, l2 = instanceControllers.length; i2 < l2; i2++) {
        const instance = instanceControllers[i2];
        const controller = getController(instance.id);
        const geometries = getGeometry(controller.id);
        const newObjects = buildObjects(geometries, instance.materials);
        const skeletons = instance.skeletons;
        const joints = controller.skin.joints;
        const skeleton = buildSkeleton(skeletons, joints);
        for (let j = 0, jl = newObjects.length; j < jl; j++) {
          const object2 = newObjects[j];
          if (object2.isSkinnedMesh) {
            object2.bind(skeleton, controller.skin.bindMatrix);
            object2.normalizeSkinWeights();
          }
          objects.push(object2);
        }
      }
      for (let i2 = 0, l2 = instanceLights.length; i2 < l2; i2++) {
        const instanceLight = getLight(instanceLights[i2]);
        if (instanceLight !== null) {
          objects.push(instanceLight.clone());
        }
      }
      for (let i2 = 0, l2 = instanceGeometries.length; i2 < l2; i2++) {
        const instance = instanceGeometries[i2];
        const geometries = getGeometry(instance.id);
        const newObjects = buildObjects(geometries, instance.materials);
        for (let j = 0, jl = newObjects.length; j < jl; j++) {
          objects.push(newObjects[j]);
        }
      }
      for (let i2 = 0, l2 = instanceNodes.length; i2 < l2; i2++) {
        objects.push(getNode(instanceNodes[i2]).clone());
      }
      let object;
      if (nodes.length === 0 && objects.length === 1) {
        object = objects[0];
      } else {
        object = type === "JOINT" ? new Bone$1() : new Group$1();
        for (let i2 = 0; i2 < objects.length; i2++) {
          object.add(objects[i2]);
        }
      }
      object.name = type === "JOINT" ? data.sid : data.name;
      object.matrix.copy(matrix3);
      object.matrix.decompose(object.position, object.quaternion, object.scale);
      return object;
    }
    const fallbackMaterial = new MeshBasicMaterial$1({
      name: Loader$1.DEFAULT_MATERIAL_NAME,
      color: 16711935
    });
    function resolveMaterialBinding(keys, instanceMaterials) {
      const materials = [];
      for (let i2 = 0, l2 = keys.length; i2 < l2; i2++) {
        const id = instanceMaterials[keys[i2]];
        if (id === void 0) {
          console.warn("THREE.ColladaLoader: Material with key %s not found. Apply fallback material.", keys[i2]);
          materials.push(fallbackMaterial);
        } else {
          materials.push(getMaterial(id));
        }
      }
      return materials;
    }
    function buildObjects(geometries, instanceMaterials) {
      const objects = [];
      for (const type in geometries) {
        const geometry = geometries[type];
        const materials = resolveMaterialBinding(geometry.materialKeys, instanceMaterials);
        if (materials.length === 0) {
          if (type === "lines" || type === "linestrips") {
            materials.push(new LineBasicMaterial$1());
          } else {
            materials.push(new MeshPhongMaterial$1());
          }
        }
        if (type === "lines" || type === "linestrips") {
          for (let i2 = 0, l2 = materials.length; i2 < l2; i2++) {
            const material2 = materials[i2];
            if (material2.isMeshPhongMaterial === true || material2.isMeshLambertMaterial === true) {
              const lineMaterial = new LineBasicMaterial$1();
              lineMaterial.color.copy(material2.color);
              lineMaterial.opacity = material2.opacity;
              lineMaterial.transparent = material2.transparent;
              materials[i2] = lineMaterial;
            }
          }
        }
        const skinning = geometry.data.attributes.skinIndex !== void 0;
        const material = materials.length === 1 ? materials[0] : materials;
        let object;
        switch (type) {
          case "lines":
            object = new LineSegments$1(geometry.data, material);
            break;
          case "linestrips":
            object = new Line$1(geometry.data, material);
            break;
          case "triangles":
          case "polylist":
            if (skinning) {
              object = new SkinnedMesh$1(geometry.data, material);
            } else {
              object = new Mesh$1(geometry.data, material);
            }
            break;
        }
        objects.push(object);
      }
      return objects;
    }
    function hasNode(id) {
      return library.nodes[id] !== void 0;
    }
    function getNode(id) {
      return getBuild(library.nodes[id], buildNode);
    }
    function parseVisualScene(xml2) {
      const data = {
        name: xml2.getAttribute("name"),
        children: []
      };
      prepareNodes(xml2);
      const elements = getElementsByTagName(xml2, "node");
      for (let i2 = 0; i2 < elements.length; i2++) {
        data.children.push(parseNode(elements[i2]));
      }
      library.visualScenes[xml2.getAttribute("id")] = data;
    }
    function buildVisualScene(data) {
      const group = new Group$1();
      group.name = data.name;
      const children = data.children;
      for (let i2 = 0; i2 < children.length; i2++) {
        const child = children[i2];
        group.add(getNode(child.id));
      }
      return group;
    }
    function hasVisualScene(id) {
      return library.visualScenes[id] !== void 0;
    }
    function getVisualScene(id) {
      return getBuild(library.visualScenes[id], buildVisualScene);
    }
    function parseScene(xml2) {
      const instance = getElementsByTagName(xml2, "instance_visual_scene")[0];
      return getVisualScene(parseId(instance.getAttribute("url")));
    }
    function setupAnimations() {
      const clips = library.clips;
      if (isEmpty(clips) === true) {
        if (isEmpty(library.animations) === false) {
          const tracks = [];
          for (const id in library.animations) {
            const animationTracks = getAnimation(id);
            for (let i2 = 0, l2 = animationTracks.length; i2 < l2; i2++) {
              tracks.push(animationTracks[i2]);
            }
          }
          animations.push(new AnimationClip$1("default", -1, tracks));
        }
      } else {
        for (const id in clips) {
          animations.push(getAnimationClip(id));
        }
      }
    }
    function parserErrorToText(parserError2) {
      let result = "";
      const stack = [parserError2];
      while (stack.length) {
        const node = stack.shift();
        if (node.nodeType === Node.TEXT_NODE) {
          result += node.textContent;
        } else {
          result += "\n";
          stack.push.apply(stack, node.childNodes);
        }
      }
      return result.trim();
    }
    if (text.length === 0) {
      return { scene: new Scene$1() };
    }
    const xml = new DOMParser().parseFromString(text, "application/xml");
    const collada = getElementsByTagName(xml, "COLLADA")[0];
    const parserError = xml.getElementsByTagName("parsererror")[0];
    if (parserError !== void 0) {
      const errorElement = getElementsByTagName(parserError, "div")[0];
      let errorText;
      if (errorElement) {
        errorText = errorElement.textContent;
      } else {
        errorText = parserErrorToText(parserError);
      }
      console.error("THREE.ColladaLoader: Failed to parse collada file.\n", errorText);
      return null;
    }
    const version = collada.getAttribute("version");
    console.debug("THREE.ColladaLoader: File version", version);
    const asset = parseAsset(getElementsByTagName(collada, "asset")[0]);
    const textureLoader = new TextureLoader$1(this.manager);
    textureLoader.setPath(this.resourcePath || path).setCrossOrigin(this.crossOrigin);
    let tgaLoader;
    if (TGALoader) {
      tgaLoader = new TGALoader(this.manager);
      tgaLoader.setPath(this.resourcePath || path);
    }
    const tempColor = new Color$1();
    const animations = [];
    let kinematics = {};
    let count = 0;
    const library = {
      animations: {},
      clips: {},
      controllers: {},
      images: {},
      effects: {},
      materials: {},
      cameras: {},
      lights: {},
      geometries: {},
      nodes: {},
      visualScenes: {},
      kinematicsModels: {},
      physicsModels: {},
      kinematicsScenes: {}
    };
    parseLibrary(collada, "library_animations", "animation", parseAnimation);
    parseLibrary(collada, "library_animation_clips", "animation_clip", parseAnimationClip);
    parseLibrary(collada, "library_controllers", "controller", parseController);
    parseLibrary(collada, "library_images", "image", parseImage);
    parseLibrary(collada, "library_effects", "effect", parseEffect);
    parseLibrary(collada, "library_materials", "material", parseMaterial);
    parseLibrary(collada, "library_cameras", "camera", parseCamera);
    parseLibrary(collada, "library_lights", "light", parseLight);
    parseLibrary(collada, "library_geometries", "geometry", parseGeometry);
    parseLibrary(collada, "library_nodes", "node", parseNode);
    parseLibrary(collada, "library_visual_scenes", "visual_scene", parseVisualScene);
    parseLibrary(collada, "library_kinematics_models", "kinematics_model", parseKinematicsModel);
    parseLibrary(collada, "library_physics_models", "physics_model", parsePhysicsModel);
    parseLibrary(collada, "scene", "instance_kinematics_scene", parseKinematicsScene);
    buildLibrary(library.animations, buildAnimation);
    buildLibrary(library.clips, buildAnimationClip);
    buildLibrary(library.controllers, buildController);
    buildLibrary(library.images, buildImage);
    buildLibrary(library.effects, buildEffect);
    buildLibrary(library.materials, buildMaterial);
    buildLibrary(library.cameras, buildCamera);
    buildLibrary(library.lights, buildLight);
    buildLibrary(library.geometries, buildGeometry);
    buildLibrary(library.visualScenes, buildVisualScene);
    setupAnimations();
    setupKinematics();
    const scene = parseScene(getElementsByTagName(collada, "scene")[0]);
    scene.animations = animations;
    if (asset.upAxis === "Z_UP") {
      console.warn("THREE.ColladaLoader: You are loading an asset with a Z-UP coordinate system. The loader just rotates the asset to transform it into Y-UP. The vertex data are not converted, see #24289.");
      scene.rotation.set(-Math.PI / 2, 0, 0);
    }
    scene.scale.multiplyScalar(asset.unit);
    return {
      get animations() {
        console.warn("THREE.ColladaLoader: Please access animations over scene.animations now.");
        return animations;
      },
      kinematics,
      library,
      scene
    };
  }
}
const _taskCache$1 = /* @__PURE__ */ new WeakMap();
class DRACOLoader extends Loader$1 {
  constructor(manager) {
    super(manager);
    this.decoderPath = "";
    this.decoderConfig = {};
    this.decoderBinary = null;
    this.decoderPending = null;
    this.workerLimit = 4;
    this.workerPool = [];
    this.workerNextTaskID = 1;
    this.workerSourceURL = "";
    this.defaultAttributeIDs = {
      position: "POSITION",
      normal: "NORMAL",
      color: "COLOR",
      uv: "TEX_COORD"
    };
    this.defaultAttributeTypes = {
      position: "Float32Array",
      normal: "Float32Array",
      color: "Float32Array",
      uv: "Float32Array"
    };
  }
  setDecoderPath(path) {
    this.decoderPath = path;
    return this;
  }
  setDecoderConfig(config) {
    this.decoderConfig = config;
    return this;
  }
  setWorkerLimit(workerLimit) {
    this.workerLimit = workerLimit;
    return this;
  }
  load(url, onLoad, onProgress, onError) {
    const loader = new FileLoader$1(this.manager);
    loader.setPath(this.path);
    loader.setResponseType("arraybuffer");
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(url, (buffer) => {
      this.parse(buffer, onLoad, onError);
    }, onProgress, onError);
  }
  parse(buffer, onLoad, onError = () => {
  }) {
    this.decodeDracoFile(buffer, onLoad, null, null, SRGBColorSpace, onError).catch(onError);
  }
  decodeDracoFile(buffer, callback, attributeIDs, attributeTypes, vertexColorSpace = LinearSRGBColorSpace, onError = () => {
  }) {
    const taskConfig = {
      attributeIDs: attributeIDs || this.defaultAttributeIDs,
      attributeTypes: attributeTypes || this.defaultAttributeTypes,
      useUniqueIDs: !!attributeIDs,
      vertexColorSpace
    };
    return this.decodeGeometry(buffer, taskConfig).then(callback).catch(onError);
  }
  decodeGeometry(buffer, taskConfig) {
    const taskKey = JSON.stringify(taskConfig);
    if (_taskCache$1.has(buffer)) {
      const cachedTask = _taskCache$1.get(buffer);
      if (cachedTask.key === taskKey) {
        return cachedTask.promise;
      } else if (buffer.byteLength === 0) {
        throw new Error(
          "THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred."
        );
      }
    }
    let worker;
    const taskID = this.workerNextTaskID++;
    const taskCost = buffer.byteLength;
    const geometryPending = this._getWorker(taskID, taskCost).then((_worker) => {
      worker = _worker;
      return new Promise((resolve, reject) => {
        worker._callbacks[taskID] = { resolve, reject };
        worker.postMessage({ type: "decode", id: taskID, taskConfig, buffer }, [buffer]);
      });
    }).then((message) => this._createGeometry(message.geometry));
    geometryPending.catch(() => true).then(() => {
      if (worker && taskID) {
        this._releaseTask(worker, taskID);
      }
    });
    _taskCache$1.set(buffer, {
      key: taskKey,
      promise: geometryPending
    });
    return geometryPending;
  }
  _createGeometry(geometryData) {
    const geometry = new BufferGeometry$1();
    if (geometryData.index) {
      geometry.setIndex(new BufferAttribute$1(geometryData.index.array, 1));
    }
    for (let i2 = 0; i2 < geometryData.attributes.length; i2++) {
      const result = geometryData.attributes[i2];
      const name = result.name;
      const array = result.array;
      const itemSize = result.itemSize;
      const attribute = new BufferAttribute$1(array, itemSize);
      if (name === "color") {
        this._assignVertexColorSpace(attribute, result.vertexColorSpace);
        attribute.normalized = array instanceof Float32Array === false;
      }
      geometry.setAttribute(name, attribute);
    }
    return geometry;
  }
  _assignVertexColorSpace(attribute, inputColorSpace) {
    if (inputColorSpace !== SRGBColorSpace) return;
    const _color3 = new Color$1();
    for (let i2 = 0, il = attribute.count; i2 < il; i2++) {
      _color3.fromBufferAttribute(attribute, i2);
      ColorManagement.toWorkingColorSpace(_color3, SRGBColorSpace);
      attribute.setXYZ(i2, _color3.r, _color3.g, _color3.b);
    }
  }
  _loadLibrary(url, responseType) {
    const loader = new FileLoader$1(this.manager);
    loader.setPath(this.decoderPath);
    loader.setResponseType(responseType);
    loader.setWithCredentials(this.withCredentials);
    return new Promise((resolve, reject) => {
      loader.load(url, resolve, void 0, reject);
    });
  }
  preload() {
    this._initDecoder();
    return this;
  }
  _initDecoder() {
    if (this.decoderPending) return this.decoderPending;
    const useJS = typeof WebAssembly !== "object" || this.decoderConfig.type === "js";
    const librariesPending = [];
    if (useJS) {
      librariesPending.push(this._loadLibrary("draco_decoder.js", "text"));
    } else {
      librariesPending.push(this._loadLibrary("draco_wasm_wrapper.js", "text"));
      librariesPending.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"));
    }
    this.decoderPending = Promise.all(librariesPending).then((libraries) => {
      const jsContent = libraries[0];
      if (!useJS) {
        this.decoderConfig.wasmBinary = libraries[1];
      }
      const fn = DRACOWorker.toString();
      const body = [
        "/* draco decoder */",
        jsContent,
        "",
        "/* worker */",
        fn.substring(fn.indexOf("{") + 1, fn.lastIndexOf("}"))
      ].join("\n");
      this.workerSourceURL = URL.createObjectURL(new Blob([body]));
    });
    return this.decoderPending;
  }
  _getWorker(taskID, taskCost) {
    return this._initDecoder().then(() => {
      if (this.workerPool.length < this.workerLimit) {
        const worker2 = new Worker(this.workerSourceURL);
        worker2._callbacks = {};
        worker2._taskCosts = {};
        worker2._taskLoad = 0;
        worker2.postMessage({ type: "init", decoderConfig: this.decoderConfig });
        worker2.onmessage = function(e2) {
          const message = e2.data;
          switch (message.type) {
            case "decode":
              worker2._callbacks[message.id].resolve(message);
              break;
            case "error":
              worker2._callbacks[message.id].reject(message);
              break;
            default:
              console.error('THREE.DRACOLoader: Unexpected message, "' + message.type + '"');
          }
        };
        this.workerPool.push(worker2);
      } else {
        this.workerPool.sort(function(a3, b) {
          return a3._taskLoad > b._taskLoad ? -1 : 1;
        });
      }
      const worker = this.workerPool[this.workerPool.length - 1];
      worker._taskCosts[taskID] = taskCost;
      worker._taskLoad += taskCost;
      return worker;
    });
  }
  _releaseTask(worker, taskID) {
    worker._taskLoad -= worker._taskCosts[taskID];
    delete worker._callbacks[taskID];
    delete worker._taskCosts[taskID];
  }
  debug() {
    console.log("Task load: ", this.workerPool.map((worker) => worker._taskLoad));
  }
  dispose() {
    for (let i2 = 0; i2 < this.workerPool.length; ++i2) {
      this.workerPool[i2].terminate();
    }
    this.workerPool.length = 0;
    if (this.workerSourceURL !== "") {
      URL.revokeObjectURL(this.workerSourceURL);
    }
    return this;
  }
}
function DRACOWorker() {
  let decoderConfig;
  let decoderPending;
  onmessage = function(e2) {
    const message = e2.data;
    switch (message.type) {
      case "init":
        decoderConfig = message.decoderConfig;
        decoderPending = new Promise(function(resolve) {
          decoderConfig.onModuleLoaded = function(draco) {
            resolve({ draco });
          };
          DracoDecoderModule(decoderConfig);
        });
        break;
      case "decode":
        const buffer = message.buffer;
        const taskConfig = message.taskConfig;
        decoderPending.then((module) => {
          const draco = module.draco;
          const decoder = new draco.Decoder();
          try {
            const geometry = decodeGeometry(draco, decoder, new Int8Array(buffer), taskConfig);
            const buffers = geometry.attributes.map((attr) => attr.array.buffer);
            if (geometry.index) buffers.push(geometry.index.array.buffer);
            self.postMessage({ type: "decode", id: message.id, geometry }, buffers);
          } catch (error) {
            console.error(error);
            self.postMessage({ type: "error", id: message.id, error: error.message });
          } finally {
            draco.destroy(decoder);
          }
        });
        break;
    }
  };
  function decodeGeometry(draco, decoder, array, taskConfig) {
    const attributeIDs = taskConfig.attributeIDs;
    const attributeTypes = taskConfig.attributeTypes;
    let dracoGeometry;
    let decodingStatus;
    const geometryType = decoder.GetEncodedGeometryType(array);
    if (geometryType === draco.TRIANGULAR_MESH) {
      dracoGeometry = new draco.Mesh();
      decodingStatus = decoder.DecodeArrayToMesh(array, array.byteLength, dracoGeometry);
    } else if (geometryType === draco.POINT_CLOUD) {
      dracoGeometry = new draco.PointCloud();
      decodingStatus = decoder.DecodeArrayToPointCloud(array, array.byteLength, dracoGeometry);
    } else {
      throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
    }
    if (!decodingStatus.ok() || dracoGeometry.ptr === 0) {
      throw new Error("THREE.DRACOLoader: Decoding failed: " + decodingStatus.error_msg());
    }
    const geometry = { index: null, attributes: [] };
    for (const attributeName in attributeIDs) {
      const attributeType = self[attributeTypes[attributeName]];
      let attribute;
      let attributeID;
      if (taskConfig.useUniqueIDs) {
        attributeID = attributeIDs[attributeName];
        attribute = decoder.GetAttributeByUniqueId(dracoGeometry, attributeID);
      } else {
        attributeID = decoder.GetAttributeId(dracoGeometry, draco[attributeIDs[attributeName]]);
        if (attributeID === -1) continue;
        attribute = decoder.GetAttribute(dracoGeometry, attributeID);
      }
      const attributeResult = decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute);
      if (attributeName === "color") {
        attributeResult.vertexColorSpace = taskConfig.vertexColorSpace;
      }
      geometry.attributes.push(attributeResult);
    }
    if (geometryType === draco.TRIANGULAR_MESH) {
      geometry.index = decodeIndex(draco, decoder, dracoGeometry);
    }
    draco.destroy(dracoGeometry);
    return geometry;
  }
  function decodeIndex(draco, decoder, dracoGeometry) {
    const numFaces = dracoGeometry.num_faces();
    const numIndices = numFaces * 3;
    const byteLength = numIndices * 4;
    const ptr = draco._malloc(byteLength);
    decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
    const index2 = new Uint32Array(draco.HEAPF32.buffer, ptr, numIndices).slice();
    draco._free(ptr);
    return { array: index2, itemSize: 1 };
  }
  function decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute) {
    const numComponents = attribute.num_components();
    const numPoints = dracoGeometry.num_points();
    const numValues = numPoints * numComponents;
    const byteLength = numValues * attributeType.BYTES_PER_ELEMENT;
    const dataType = getDracoDataType(draco, attributeType);
    const ptr = draco._malloc(byteLength);
    decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, attribute, dataType, byteLength, ptr);
    const array = new attributeType(draco.HEAPF32.buffer, ptr, numValues).slice();
    draco._free(ptr);
    return {
      name: attributeName,
      array,
      itemSize: numComponents
    };
  }
  function getDracoDataType(draco, attributeType) {
    switch (attributeType) {
      case Float32Array:
        return draco.DT_FLOAT32;
      case Int8Array:
        return draco.DT_INT8;
      case Int16Array:
        return draco.DT_INT16;
      case Int32Array:
        return draco.DT_INT32;
      case Uint8Array:
        return draco.DT_UINT8;
      case Uint16Array:
        return draco.DT_UINT16;
      case Uint32Array:
        return draco.DT_UINT32;
    }
  }
}
class WorkerPool {
  constructor(pool = 4) {
    this.pool = pool;
    this.queue = [];
    this.workers = [];
    this.workersResolve = [];
    this.workerStatus = 0;
  }
  _initWorker(workerId) {
    if (!this.workers[workerId]) {
      const worker = this.workerCreator();
      worker.addEventListener("message", this._onMessage.bind(this, workerId));
      this.workers[workerId] = worker;
    }
  }
  _getIdleWorker() {
    for (let i2 = 0; i2 < this.pool; i2++)
      if (!(this.workerStatus & 1 << i2)) return i2;
    return -1;
  }
  _onMessage(workerId, msg) {
    const resolve = this.workersResolve[workerId];
    resolve && resolve(msg);
    if (this.queue.length) {
      const { resolve: resolve2, msg: msg2, transfer } = this.queue.shift();
      this.workersResolve[workerId] = resolve2;
      this.workers[workerId].postMessage(msg2, transfer);
    } else {
      this.workerStatus ^= 1 << workerId;
    }
  }
  setWorkerCreator(workerCreator) {
    this.workerCreator = workerCreator;
  }
  setWorkerLimit(pool) {
    this.pool = pool;
  }
  postMessage(msg, transfer) {
    return new Promise((resolve) => {
      const workerId = this._getIdleWorker();
      if (workerId !== -1) {
        this._initWorker(workerId);
        this.workerStatus |= 1 << workerId;
        this.workersResolve[workerId] = resolve;
        this.workers[workerId].postMessage(msg, transfer);
      } else {
        this.queue.push({ resolve, msg, transfer });
      }
    });
  }
  dispose() {
    this.workers.forEach((worker) => worker.terminate());
    this.workersResolve.length = 0;
    this.workers.length = 0;
    this.queue.length = 0;
    this.workerStatus = 0;
  }
}
const t2 = 0, n = 2, g$1 = 1, u$1 = 2, T$1 = 0, C$1 = 1, R = 10, it = 0, ct = 9, yt = 15, xt = 16, wt = 22, Ft = 37, Ct = 43, te = 76, ae = 83, ge = 97, ue = 100, we = 103, Ae = 109, In = 165, Sn = 166, pi = 1000066e3;
class Ii {
  constructor() {
    this.vkFormat = 0, this.typeSize = 1, this.pixelWidth = 0, this.pixelHeight = 0, this.pixelDepth = 0, this.layerCount = 0, this.faceCount = 1, this.supercompressionScheme = 0, this.levels = [], this.dataFormatDescriptor = [{ vendorId: 0, descriptorType: 0, descriptorBlockSize: 0, versionNumber: 2, colorModel: 0, colorPrimaries: 1, transferFunction: 2, flags: 0, texelBlockDimension: [0, 0, 0, 0], bytesPlane: [0, 0, 0, 0, 0, 0, 0, 0], samples: [] }], this.keyValue = {}, this.globalData = null;
  }
}
class Si {
  constructor(t3, e2, n2, i2) {
    this._dataView = void 0, this._littleEndian = void 0, this._offset = void 0, this._dataView = new DataView(t3.buffer, t3.byteOffset + e2, n2), this._littleEndian = i2, this._offset = 0;
  }
  _nextUint8() {
    const t3 = this._dataView.getUint8(this._offset);
    return this._offset += 1, t3;
  }
  _nextUint16() {
    const t3 = this._dataView.getUint16(this._offset, this._littleEndian);
    return this._offset += 2, t3;
  }
  _nextUint32() {
    const t3 = this._dataView.getUint32(this._offset, this._littleEndian);
    return this._offset += 4, t3;
  }
  _nextUint64() {
    const t3 = this._dataView.getUint32(this._offset, this._littleEndian) + 2 ** 32 * this._dataView.getUint32(this._offset + 4, this._littleEndian);
    return this._offset += 8, t3;
  }
  _nextInt32() {
    const t3 = this._dataView.getInt32(this._offset, this._littleEndian);
    return this._offset += 4, t3;
  }
  _nextUint8Array(t3) {
    const e2 = new Uint8Array(this._dataView.buffer, this._dataView.byteOffset + this._offset, t3);
    return this._offset += t3, e2;
  }
  _skip(t3) {
    return this._offset += t3, this;
  }
  _scan(t3, e2) {
    void 0 === e2 && (e2 = 0);
    const n2 = this._offset;
    let i2 = 0;
    for (; this._dataView.getUint8(this._offset) !== e2 && i2 < t3; ) i2++, this._offset++;
    return i2 < t3 && this._offset++, new Uint8Array(this._dataView.buffer, this._dataView.byteOffset + n2, i2);
  }
}
const Oi = [171, 75, 84, 88, 32, 50, 48, 187, 13, 10, 26, 10];
function Ti(t3) {
  return new TextDecoder().decode(t3);
}
function Pi(t3) {
  const e2 = new Uint8Array(t3.buffer, t3.byteOffset, Oi.length);
  if (e2[0] !== Oi[0] || e2[1] !== Oi[1] || e2[2] !== Oi[2] || e2[3] !== Oi[3] || e2[4] !== Oi[4] || e2[5] !== Oi[5] || e2[6] !== Oi[6] || e2[7] !== Oi[7] || e2[8] !== Oi[8] || e2[9] !== Oi[9] || e2[10] !== Oi[10] || e2[11] !== Oi[11]) throw new Error("Missing KTX 2.0 identifier.");
  const n2 = new Ii(), i2 = 17 * Uint32Array.BYTES_PER_ELEMENT, s2 = new Si(t3, Oi.length, i2, true);
  n2.vkFormat = s2._nextUint32(), n2.typeSize = s2._nextUint32(), n2.pixelWidth = s2._nextUint32(), n2.pixelHeight = s2._nextUint32(), n2.pixelDepth = s2._nextUint32(), n2.layerCount = s2._nextUint32(), n2.faceCount = s2._nextUint32();
  const a3 = s2._nextUint32();
  n2.supercompressionScheme = s2._nextUint32();
  const r2 = s2._nextUint32(), o2 = s2._nextUint32(), l2 = s2._nextUint32(), f2 = s2._nextUint32(), h2 = s2._nextUint64(), U2 = s2._nextUint64(), c2 = new Si(t3, Oi.length + i2, 3 * a3 * 8, true);
  for (let e3 = 0; e3 < a3; e3++) n2.levels.push({ levelData: new Uint8Array(t3.buffer, t3.byteOffset + c2._nextUint64(), c2._nextUint64()), uncompressedByteLength: c2._nextUint64() });
  const _ = new Si(t3, r2, o2, true), p2 = { vendorId: _._skip(4)._nextUint16(), descriptorType: _._nextUint16(), versionNumber: _._nextUint16(), descriptorBlockSize: _._nextUint16(), colorModel: _._nextUint8(), colorPrimaries: _._nextUint8(), transferFunction: _._nextUint8(), flags: _._nextUint8(), texelBlockDimension: [_._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8()], bytesPlane: [_._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8()], samples: [] }, g3 = (p2.descriptorBlockSize / 4 - 6) / 4;
  for (let t4 = 0; t4 < g3; t4++) {
    const e3 = { bitOffset: _._nextUint16(), bitLength: _._nextUint8(), channelType: _._nextUint8(), samplePosition: [_._nextUint8(), _._nextUint8(), _._nextUint8(), _._nextUint8()], sampleLower: -Infinity, sampleUpper: Infinity };
    64 & e3.channelType ? (e3.sampleLower = _._nextInt32(), e3.sampleUpper = _._nextInt32()) : (e3.sampleLower = _._nextUint32(), e3.sampleUpper = _._nextUint32()), p2.samples[t4] = e3;
  }
  n2.dataFormatDescriptor.length = 0, n2.dataFormatDescriptor.push(p2);
  const y = new Si(t3, l2, f2, true);
  for (; y._offset < f2; ) {
    const t4 = y._nextUint32(), e3 = y._scan(t4), i3 = Ti(e3);
    if (n2.keyValue[i3] = y._nextUint8Array(t4 - e3.byteLength - 1), i3.match(/^ktx/i)) {
      const t5 = Ti(n2.keyValue[i3]);
      n2.keyValue[i3] = t5.substring(0, t5.lastIndexOf("\0"));
    }
    y._skip(t4 % 4 ? 4 - t4 % 4 : 0);
  }
  if (U2 <= 0) return n2;
  const x = new Si(t3, h2, U2, true), u3 = x._nextUint16(), b = x._nextUint16(), d2 = x._nextUint32(), w = x._nextUint32(), m = x._nextUint32(), D = x._nextUint32(), B3 = [];
  for (let t4 = 0; t4 < a3; t4++) B3.push({ imageFlags: x._nextUint32(), rgbSliceByteOffset: x._nextUint32(), rgbSliceByteLength: x._nextUint32(), alphaSliceByteOffset: x._nextUint32(), alphaSliceByteLength: x._nextUint32() });
  const L2 = h2 + x._offset, v = L2 + d2, A2 = v + w, k = A2 + m, V2 = new Uint8Array(t3.buffer, t3.byteOffset + L2, d2), I2 = new Uint8Array(t3.buffer, t3.byteOffset + v, w), S = new Uint8Array(t3.buffer, t3.byteOffset + A2, m), F2 = new Uint8Array(t3.buffer, t3.byteOffset + k, D);
  return n2.globalData = { endpointCount: u3, selectorCount: b, imageDescs: B3, endpointsData: V2, selectorsData: I2, tablesData: S, extendedData: F2 }, n2;
}
let A$1, I, B;
const g2 = { env: { emscripten_notify_memory_growth: function(A2) {
  B = new Uint8Array(I.exports.memory.buffer);
} } };
class Q {
  init() {
    return A$1 || (A$1 = "undefined" != typeof fetch ? fetch("data:application/wasm;base64," + C).then((A2) => A2.arrayBuffer()).then((A2) => WebAssembly.instantiate(A2, g2)).then(this._init) : WebAssembly.instantiate(Buffer.from(C, "base64"), g2).then(this._init), A$1);
  }
  _init(A2) {
    I = A2.instance, g2.env.emscripten_notify_memory_growth(0);
  }
  decode(A2, g3 = 0) {
    if (!I) throw new Error("ZSTDDecoder: Await .init() before decoding.");
    const Q2 = A2.byteLength, C2 = I.exports.malloc(Q2);
    B.set(A2, C2), g3 = g3 || Number(I.exports.ZSTD_findDecompressedSize(C2, Q2));
    const E2 = I.exports.malloc(g3), i2 = I.exports.ZSTD_decompress(E2, g3, C2, Q2), D = B.slice(E2, E2 + i2);
    return I.exports.free(C2), I.exports.free(E2), D;
  }
}
const C = "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";
const DisplayP3ColorSpace = "display-p3";
const LinearDisplayP3ColorSpace = "display-p3-linear";
const _taskCache = /* @__PURE__ */ new WeakMap();
let _activeLoaders = 0;
let _zstd;
class KTX2Loader extends Loader$1 {
  constructor(manager) {
    super(manager);
    this.transcoderPath = "";
    this.transcoderBinary = null;
    this.transcoderPending = null;
    this.workerPool = new WorkerPool();
    this.workerSourceURL = "";
    this.workerConfig = null;
    if (typeof MSC_TRANSCODER !== "undefined") {
      console.warn(
        'THREE.KTX2Loader: Please update to latest "basis_transcoder". "msc_basis_transcoder" is no longer supported in three.js r125+.'
      );
    }
  }
  setTranscoderPath(path) {
    this.transcoderPath = path;
    return this;
  }
  setWorkerLimit(num) {
    this.workerPool.setWorkerLimit(num);
    return this;
  }
  async detectSupportAsync(renderer) {
    this.workerConfig = {
      astcSupported: await renderer.hasFeatureAsync("texture-compression-astc"),
      astcHDRSupported: false,
      // https://github.com/gpuweb/gpuweb/issues/3856
      etc1Supported: await renderer.hasFeatureAsync("texture-compression-etc1"),
      etc2Supported: await renderer.hasFeatureAsync("texture-compression-etc2"),
      dxtSupported: await renderer.hasFeatureAsync("texture-compression-bc"),
      bptcSupported: await renderer.hasFeatureAsync("texture-compression-bptc"),
      pvrtcSupported: await renderer.hasFeatureAsync("texture-compression-pvrtc")
    };
    return this;
  }
  detectSupport(renderer) {
    if (renderer.isWebGPURenderer === true) {
      this.workerConfig = {
        astcSupported: renderer.hasFeature("texture-compression-astc"),
        astcHDRSupported: false,
        // https://github.com/gpuweb/gpuweb/issues/3856
        etc1Supported: renderer.hasFeature("texture-compression-etc1"),
        etc2Supported: renderer.hasFeature("texture-compression-etc2"),
        dxtSupported: renderer.hasFeature("texture-compression-bc"),
        bptcSupported: renderer.hasFeature("texture-compression-bptc"),
        pvrtcSupported: renderer.hasFeature("texture-compression-pvrtc")
      };
    } else {
      this.workerConfig = {
        astcSupported: renderer.extensions.has("WEBGL_compressed_texture_astc"),
        astcHDRSupported: renderer.extensions.has("WEBGL_compressed_texture_astc") && renderer.extensions.get("WEBGL_compressed_texture_astc").getSupportedProfiles().includes("hdr"),
        etc1Supported: renderer.extensions.has("WEBGL_compressed_texture_etc1"),
        etc2Supported: renderer.extensions.has("WEBGL_compressed_texture_etc"),
        dxtSupported: renderer.extensions.has("WEBGL_compressed_texture_s3tc"),
        bptcSupported: renderer.extensions.has("EXT_texture_compression_bptc"),
        pvrtcSupported: renderer.extensions.has("WEBGL_compressed_texture_pvrtc") || renderer.extensions.has("WEBKIT_WEBGL_compressed_texture_pvrtc")
      };
    }
    return this;
  }
  init() {
    if (!this.transcoderPending) {
      const jsLoader = new FileLoader$1(this.manager);
      jsLoader.setPath(this.transcoderPath);
      jsLoader.setWithCredentials(this.withCredentials);
      const jsContent = jsLoader.loadAsync("basis_transcoder.js");
      const binaryLoader = new FileLoader$1(this.manager);
      binaryLoader.setPath(this.transcoderPath);
      binaryLoader.setResponseType("arraybuffer");
      binaryLoader.setWithCredentials(this.withCredentials);
      const binaryContent = binaryLoader.loadAsync("basis_transcoder.wasm");
      this.transcoderPending = Promise.all([jsContent, binaryContent]).then(([jsContent2, binaryContent2]) => {
        const fn = KTX2Loader.BasisWorker.toString();
        const body = [
          "/* constants */",
          "let _EngineFormat = " + JSON.stringify(KTX2Loader.EngineFormat),
          "let _EngineType = " + JSON.stringify(KTX2Loader.EngineType),
          "let _TranscoderFormat = " + JSON.stringify(KTX2Loader.TranscoderFormat),
          "let _BasisFormat = " + JSON.stringify(KTX2Loader.BasisFormat),
          "/* basis_transcoder.js */",
          jsContent2,
          "/* worker */",
          fn.substring(fn.indexOf("{") + 1, fn.lastIndexOf("}"))
        ].join("\n");
        this.workerSourceURL = URL.createObjectURL(new Blob([body]));
        this.transcoderBinary = binaryContent2;
        this.workerPool.setWorkerCreator(() => {
          const worker = new Worker(this.workerSourceURL);
          const transcoderBinary = this.transcoderBinary.slice(0);
          worker.postMessage({ type: "init", config: this.workerConfig, transcoderBinary }, [transcoderBinary]);
          return worker;
        });
      });
      if (_activeLoaders > 0) {
        console.warn(
          "THREE.KTX2Loader: Multiple active KTX2 loaders may cause performance issues. Use a single KTX2Loader instance, or call .dispose() on old instances."
        );
      }
      _activeLoaders++;
    }
    return this.transcoderPending;
  }
  load(url, onLoad, onProgress, onError) {
    if (this.workerConfig === null) {
      throw new Error("THREE.KTX2Loader: Missing initialization with `.detectSupport( renderer )`.");
    }
    const loader = new FileLoader$1(this.manager);
    loader.setResponseType("arraybuffer");
    loader.setWithCredentials(this.withCredentials);
    loader.load(url, (buffer) => {
      this.parse(buffer, onLoad, onError);
    }, onProgress, onError);
  }
  parse(buffer, onLoad, onError) {
    if (this.workerConfig === null) {
      throw new Error("THREE.KTX2Loader: Missing initialization with `.detectSupport( renderer )`.");
    }
    if (_taskCache.has(buffer)) {
      const cachedTask = _taskCache.get(buffer);
      return cachedTask.promise.then(onLoad).catch(onError);
    }
    this._createTexture(buffer).then((texture) => onLoad ? onLoad(texture) : null).catch(onError);
  }
  _createTextureFrom(transcodeResult, container) {
    const { type: messageType, error, data: { faces, width, height, format, type, dfdFlags } } = transcodeResult;
    if (messageType === "error") return Promise.reject(error);
    let texture;
    if (container.faceCount === 6) {
      texture = new CompressedCubeTexture(faces, format, type);
    } else {
      const mipmaps = faces[0].mipmaps;
      texture = container.layerCount > 1 ? new CompressedArrayTexture(mipmaps, width, height, container.layerCount, format, type) : new CompressedTexture$1(mipmaps, width, height, format, type);
    }
    texture.minFilter = faces[0].mipmaps.length === 1 ? LinearFilter$1 : LinearMipmapLinearFilter$1;
    texture.magFilter = LinearFilter$1;
    texture.generateMipmaps = false;
    texture.needsUpdate = true;
    texture.colorSpace = parseColorSpace(container);
    texture.premultiplyAlpha = !!(dfdFlags & g$1);
    return texture;
  }
  /**
   * @param {ArrayBuffer} buffer
   * @param {object?} config
   * @return {Promise<CompressedTexture|CompressedArrayTexture|DataTexture|Data3DTexture>}
   */
  async _createTexture(buffer, config = {}) {
    const container = Pi(new Uint8Array(buffer));
    const isBasisHDR = container.vkFormat === pi && container.dataFormatDescriptor[0].colorModel === 167;
    const needsTranscoder = container.vkFormat === it || isBasisHDR && !this.workerConfig.astcHDRSupported;
    if (!needsTranscoder) {
      return createRawTexture(container);
    }
    const taskConfig = config;
    const texturePending = this.init().then(() => {
      return this.workerPool.postMessage({ type: "transcode", buffer, taskConfig }, [buffer]);
    }).then((e2) => this._createTextureFrom(e2.data, container));
    _taskCache.set(buffer, { promise: texturePending });
    return texturePending;
  }
  dispose() {
    this.workerPool.dispose();
    if (this.workerSourceURL) URL.revokeObjectURL(this.workerSourceURL);
    _activeLoaders--;
    return this;
  }
}
KTX2Loader.BasisFormat = {
  ETC1S: 0,
  UASTC: 1,
  UASTC_HDR: 2
};
KTX2Loader.TranscoderFormat = {
  ETC1: 0,
  ETC2: 1,
  BC1: 2,
  BC3: 3,
  BC4: 4,
  BC5: 5,
  BC7_M6_OPAQUE_ONLY: 6,
  BC7_M5: 7,
  PVRTC1_4_RGB: 8,
  PVRTC1_4_RGBA: 9,
  ASTC_4x4: 10,
  ATC_RGB: 11,
  ATC_RGBA_INTERPOLATED_ALPHA: 12,
  RGBA32: 13,
  RGB565: 14,
  BGR565: 15,
  RGBA4444: 16,
  BC6H: 22,
  RGB_HALF: 24,
  RGBA_HALF: 25
};
KTX2Loader.EngineFormat = {
  RGBAFormat: RGBAFormat$1,
  RGBA_ASTC_4x4_Format: RGBA_ASTC_4x4_Format$1,
  RGB_BPTC_UNSIGNED_Format,
  RGBA_BPTC_Format: RGBA_BPTC_Format$1,
  RGBA_ETC2_EAC_Format: RGBA_ETC2_EAC_Format$1,
  RGBA_PVRTC_4BPPV1_Format: RGBA_PVRTC_4BPPV1_Format$1,
  RGBA_S3TC_DXT5_Format: RGBA_S3TC_DXT5_Format$1,
  RGB_ETC1_Format: RGB_ETC1_Format$1,
  RGB_ETC2_Format: RGB_ETC2_Format$1,
  RGB_PVRTC_4BPPV1_Format: RGB_PVRTC_4BPPV1_Format$1,
  RGBA_S3TC_DXT1_Format: RGBA_S3TC_DXT1_Format$1
};
KTX2Loader.EngineType = {
  UnsignedByteType: UnsignedByteType$1,
  HalfFloatType: HalfFloatType$1,
  FloatType: FloatType$1
};
KTX2Loader.BasisWorker = function() {
  let config;
  let transcoderPending;
  let BasisModule;
  const EngineFormat = _EngineFormat;
  const EngineType = _EngineType;
  const TranscoderFormat = _TranscoderFormat;
  const BasisFormat = _BasisFormat;
  self.addEventListener("message", function(e2) {
    const message = e2.data;
    switch (message.type) {
      case "init":
        config = message.config;
        init(message.transcoderBinary);
        break;
      case "transcode":
        transcoderPending.then(() => {
          try {
            const { faces, buffers, width, height, hasAlpha, format, type, dfdFlags } = transcode(message.buffer);
            self.postMessage({ type: "transcode", id: message.id, data: { faces, width, height, hasAlpha, format, type, dfdFlags } }, buffers);
          } catch (error) {
            console.error(error);
            self.postMessage({ type: "error", id: message.id, error: error.message });
          }
        });
        break;
    }
  });
  function init(wasmBinary) {
    transcoderPending = new Promise((resolve) => {
      BasisModule = { wasmBinary, onRuntimeInitialized: resolve };
      BASIS(BasisModule);
    }).then(() => {
      BasisModule.initializeBasis();
      if (BasisModule.KTX2File === void 0) {
        console.warn("THREE.KTX2Loader: Please update Basis Universal transcoder.");
      }
    });
  }
  function transcode(buffer) {
    const ktx2File = new BasisModule.KTX2File(new Uint8Array(buffer));
    function cleanup() {
      ktx2File.close();
      ktx2File.delete();
    }
    if (!ktx2File.isValid()) {
      cleanup();
      throw new Error("THREE.KTX2Loader:	Invalid or unsupported .ktx2 file");
    }
    let basisFormat;
    if (ktx2File.isUASTC()) {
      basisFormat = BasisFormat.UASTC;
    } else if (ktx2File.isETC1S()) {
      basisFormat = BasisFormat.ETC1S;
    } else if (ktx2File.isHDR()) {
      basisFormat = BasisFormat.UASTC_HDR;
    } else {
      throw new Error("THREE.KTX2Loader: Unknown Basis encoding");
    }
    const width = ktx2File.getWidth();
    const height = ktx2File.getHeight();
    const layerCount = ktx2File.getLayers() || 1;
    const levelCount = ktx2File.getLevels();
    const faceCount = ktx2File.getFaces();
    const hasAlpha = ktx2File.getHasAlpha();
    const dfdFlags = ktx2File.getDFDFlags();
    const { transcoderFormat, engineFormat, engineType } = getTranscoderFormat(basisFormat, width, height, hasAlpha);
    if (!width || !height || !levelCount) {
      cleanup();
      throw new Error("THREE.KTX2Loader:	Invalid texture");
    }
    if (!ktx2File.startTranscoding()) {
      cleanup();
      throw new Error("THREE.KTX2Loader: .startTranscoding failed");
    }
    const faces = [];
    const buffers = [];
    for (let face = 0; face < faceCount; face++) {
      const mipmaps = [];
      for (let mip = 0; mip < levelCount; mip++) {
        const layerMips = [];
        let mipWidth, mipHeight;
        for (let layer = 0; layer < layerCount; layer++) {
          const levelInfo = ktx2File.getImageLevelInfo(mip, layer, face);
          if (face === 0 && mip === 0 && layer === 0 && (levelInfo.origWidth % 4 !== 0 || levelInfo.origHeight % 4 !== 0)) {
            console.warn("THREE.KTX2Loader: ETC1S and UASTC textures should use multiple-of-four dimensions.");
          }
          if (levelCount > 1) {
            mipWidth = levelInfo.origWidth;
            mipHeight = levelInfo.origHeight;
          } else {
            mipWidth = levelInfo.width;
            mipHeight = levelInfo.height;
          }
          let dst = new Uint8Array(ktx2File.getImageTranscodedSizeInBytes(mip, layer, 0, transcoderFormat));
          const status = ktx2File.transcodeImage(dst, mip, layer, face, transcoderFormat, 0, -1, -1);
          if (engineType === EngineType.HalfFloatType) {
            dst = new Uint16Array(dst.buffer, dst.byteOffset, dst.byteLength / Uint16Array.BYTES_PER_ELEMENT);
          }
          if (!status) {
            cleanup();
            throw new Error("THREE.KTX2Loader: .transcodeImage failed.");
          }
          layerMips.push(dst);
        }
        const mipData = concat(layerMips);
        mipmaps.push({ data: mipData, width: mipWidth, height: mipHeight });
        buffers.push(mipData.buffer);
      }
      faces.push({ mipmaps, width, height, format: engineFormat, type: engineType });
    }
    cleanup();
    return { faces, buffers, width, height, hasAlpha, dfdFlags, format: engineFormat, type: engineType };
  }
  const FORMAT_OPTIONS = [
    {
      if: "astcSupported",
      basisFormat: [BasisFormat.UASTC],
      transcoderFormat: [TranscoderFormat.ASTC_4x4, TranscoderFormat.ASTC_4x4],
      engineFormat: [EngineFormat.RGBA_ASTC_4x4_Format, EngineFormat.RGBA_ASTC_4x4_Format],
      engineType: [EngineType.UnsignedByteType],
      priorityETC1S: Infinity,
      priorityUASTC: 1,
      needsPowerOfTwo: false
    },
    {
      if: "bptcSupported",
      basisFormat: [BasisFormat.ETC1S, BasisFormat.UASTC],
      transcoderFormat: [TranscoderFormat.BC7_M5, TranscoderFormat.BC7_M5],
      engineFormat: [EngineFormat.RGBA_BPTC_Format, EngineFormat.RGBA_BPTC_Format],
      engineType: [EngineType.UnsignedByteType],
      priorityETC1S: 3,
      priorityUASTC: 2,
      needsPowerOfTwo: false
    },
    {
      if: "dxtSupported",
      basisFormat: [BasisFormat.ETC1S, BasisFormat.UASTC],
      transcoderFormat: [TranscoderFormat.BC1, TranscoderFormat.BC3],
      engineFormat: [EngineFormat.RGBA_S3TC_DXT1_Format, EngineFormat.RGBA_S3TC_DXT5_Format],
      engineType: [EngineType.UnsignedByteType],
      priorityETC1S: 4,
      priorityUASTC: 5,
      needsPowerOfTwo: false
    },
    {
      if: "etc2Supported",
      basisFormat: [BasisFormat.ETC1S, BasisFormat.UASTC],
      transcoderFormat: [TranscoderFormat.ETC1, TranscoderFormat.ETC2],
      engineFormat: [EngineFormat.RGB_ETC2_Format, EngineFormat.RGBA_ETC2_EAC_Format],
      engineType: [EngineType.UnsignedByteType],
      priorityETC1S: 1,
      priorityUASTC: 3,
      needsPowerOfTwo: false
    },
    {
      if: "etc1Supported",
      basisFormat: [BasisFormat.ETC1S, BasisFormat.UASTC],
      transcoderFormat: [TranscoderFormat.ETC1],
      engineFormat: [EngineFormat.RGB_ETC1_Format],
      engineType: [EngineType.UnsignedByteType],
      priorityETC1S: 2,
      priorityUASTC: 4,
      needsPowerOfTwo: false
    },
    {
      if: "pvrtcSupported",
      basisFormat: [BasisFormat.ETC1S, BasisFormat.UASTC],
      transcoderFormat: [TranscoderFormat.PVRTC1_4_RGB, TranscoderFormat.PVRTC1_4_RGBA],
      engineFormat: [EngineFormat.RGB_PVRTC_4BPPV1_Format, EngineFormat.RGBA_PVRTC_4BPPV1_Format],
      engineType: [EngineType.UnsignedByteType],
      priorityETC1S: 5,
      priorityUASTC: 6,
      needsPowerOfTwo: true
    },
    {
      if: "bptcSupported",
      basisFormat: [BasisFormat.UASTC_HDR],
      transcoderFormat: [TranscoderFormat.BC6H],
      engineFormat: [EngineFormat.RGB_BPTC_UNSIGNED_Format],
      engineType: [EngineType.HalfFloatType],
      priorityHDR: 1,
      needsPowerOfTwo: false
    },
    // Uncompressed fallbacks.
    {
      basisFormat: [BasisFormat.ETC1S, BasisFormat.UASTC],
      transcoderFormat: [TranscoderFormat.RGBA32, TranscoderFormat.RGBA32],
      engineFormat: [EngineFormat.RGBAFormat, EngineFormat.RGBAFormat],
      engineType: [EngineType.UnsignedByteType, EngineType.UnsignedByteType],
      priorityETC1S: 100,
      priorityUASTC: 100,
      needsPowerOfTwo: false
    },
    {
      basisFormat: [BasisFormat.UASTC_HDR],
      transcoderFormat: [TranscoderFormat.RGBA_HALF],
      engineFormat: [EngineFormat.RGBAFormat],
      engineType: [EngineType.HalfFloatType],
      priorityHDR: 100,
      needsPowerOfTwo: false
    }
  ];
  const OPTIONS = {
    // TODO: For ETC1S we intentionally sort by _UASTC_ priority, preserving
    // a historical accident shown to avoid performance pitfalls for Linux with
    // Firefox & AMD GPU (RadeonSI). Further work needed.
    // See https://github.com/mrdoob/three.js/pull/29730.
    [BasisFormat.ETC1S]: FORMAT_OPTIONS.filter((opt) => opt.basisFormat.includes(BasisFormat.ETC1S)).sort((a3, b) => a3.priorityUASTC - b.priorityUASTC),
    [BasisFormat.UASTC]: FORMAT_OPTIONS.filter((opt) => opt.basisFormat.includes(BasisFormat.UASTC)).sort((a3, b) => a3.priorityUASTC - b.priorityUASTC),
    [BasisFormat.UASTC_HDR]: FORMAT_OPTIONS.filter((opt) => opt.basisFormat.includes(BasisFormat.UASTC_HDR)).sort((a3, b) => a3.priorityHDR - b.priorityHDR)
  };
  function getTranscoderFormat(basisFormat, width, height, hasAlpha) {
    const options = OPTIONS[basisFormat];
    for (let i2 = 0; i2 < options.length; i2++) {
      const opt = options[i2];
      if (opt.if && !config[opt.if]) continue;
      if (!opt.basisFormat.includes(basisFormat)) continue;
      if (hasAlpha && opt.transcoderFormat.length < 2) continue;
      if (opt.needsPowerOfTwo && !(isPowerOfTwo2(width) && isPowerOfTwo2(height))) continue;
      const transcoderFormat = opt.transcoderFormat[hasAlpha ? 1 : 0];
      const engineFormat = opt.engineFormat[hasAlpha ? 1 : 0];
      const engineType = opt.engineType[0];
      return { transcoderFormat, engineFormat, engineType };
    }
    throw new Error("THREE.KTX2Loader: Failed to identify transcoding target.");
  }
  function isPowerOfTwo2(value) {
    if (value <= 2) return true;
    return (value & value - 1) === 0 && value !== 0;
  }
  function concat(arrays) {
    if (arrays.length === 1) return arrays[0];
    let totalByteLength = 0;
    for (let i2 = 0; i2 < arrays.length; i2++) {
      const array = arrays[i2];
      totalByteLength += array.byteLength;
    }
    const result = new Uint8Array(totalByteLength);
    let byteOffset = 0;
    for (let i2 = 0; i2 < arrays.length; i2++) {
      const array = arrays[i2];
      result.set(array, byteOffset);
      byteOffset += array.byteLength;
    }
    return result;
  }
};
const UNCOMPRESSED_FORMATS = /* @__PURE__ */ new Set([RGBAFormat$1, RGFormat$1, RedFormat$1]);
const FORMAT_MAP = {
  [Ae]: RGBAFormat$1,
  [ge]: RGBAFormat$1,
  [Ft]: RGBAFormat$1,
  [Ct]: RGBAFormat$1,
  [we]: RGFormat$1,
  [ae]: RGFormat$1,
  [xt]: RGFormat$1,
  [wt]: RGFormat$1,
  [ue]: RedFormat$1,
  [te]: RedFormat$1,
  [yt]: RedFormat$1,
  [ct]: RedFormat$1,
  [pi]: RGBA_ASTC_4x4_Format$1,
  [Sn]: RGBA_ASTC_6x6_Format$1,
  [In]: RGBA_ASTC_6x6_Format$1
};
const TYPE_MAP = {
  [Ae]: FloatType$1,
  [ge]: HalfFloatType$1,
  [Ft]: UnsignedByteType$1,
  [Ct]: UnsignedByteType$1,
  [we]: FloatType$1,
  [ae]: HalfFloatType$1,
  [xt]: UnsignedByteType$1,
  [wt]: UnsignedByteType$1,
  [ue]: FloatType$1,
  [te]: HalfFloatType$1,
  [yt]: UnsignedByteType$1,
  [ct]: UnsignedByteType$1,
  [pi]: HalfFloatType$1,
  [Sn]: UnsignedByteType$1,
  [In]: UnsignedByteType$1
};
async function createRawTexture(container) {
  const { vkFormat } = container;
  if (FORMAT_MAP[vkFormat] === void 0) {
    throw new Error("THREE.KTX2Loader: Unsupported vkFormat.");
  }
  let zstd;
  if (container.supercompressionScheme === n) {
    if (!_zstd) {
      _zstd = new Promise(async (resolve) => {
        const zstd2 = new Q();
        await zstd2.init();
        resolve(zstd2);
      });
    }
    zstd = await _zstd;
  }
  const mipmaps = [];
  for (let levelIndex = 0; levelIndex < container.levels.length; levelIndex++) {
    const levelWidth = Math.max(1, container.pixelWidth >> levelIndex);
    const levelHeight = Math.max(1, container.pixelHeight >> levelIndex);
    const levelDepth = container.pixelDepth ? Math.max(1, container.pixelDepth >> levelIndex) : 0;
    const level = container.levels[levelIndex];
    let levelData;
    if (container.supercompressionScheme === t2) {
      levelData = level.levelData;
    } else if (container.supercompressionScheme === n) {
      levelData = zstd.decode(level.levelData, level.uncompressedByteLength);
    } else {
      throw new Error("THREE.KTX2Loader: Unsupported supercompressionScheme.");
    }
    let data;
    if (TYPE_MAP[vkFormat] === FloatType$1) {
      data = new Float32Array(
        levelData.buffer,
        levelData.byteOffset,
        levelData.byteLength / Float32Array.BYTES_PER_ELEMENT
      );
    } else if (TYPE_MAP[vkFormat] === HalfFloatType$1) {
      data = new Uint16Array(
        levelData.buffer,
        levelData.byteOffset,
        levelData.byteLength / Uint16Array.BYTES_PER_ELEMENT
      );
    } else {
      data = levelData;
    }
    mipmaps.push({
      data,
      width: levelWidth,
      height: levelHeight,
      depth: levelDepth
    });
  }
  let texture;
  if (UNCOMPRESSED_FORMATS.has(FORMAT_MAP[vkFormat])) {
    texture = container.pixelDepth === 0 ? new DataTexture$1(mipmaps[0].data, container.pixelWidth, container.pixelHeight) : new Data3DTexture(mipmaps[0].data, container.pixelWidth, container.pixelHeight, container.pixelDepth);
  } else {
    if (container.pixelDepth > 0) throw new Error("THREE.KTX2Loader: Unsupported pixelDepth.");
    texture = new CompressedTexture$1(mipmaps, container.pixelWidth, container.pixelHeight);
    texture.minFilter = mipmaps.length === 1 ? LinearFilter$1 : LinearMipmapLinearFilter$1;
    texture.magFilter = LinearFilter$1;
  }
  texture.mipmaps = mipmaps;
  texture.type = TYPE_MAP[vkFormat];
  texture.format = FORMAT_MAP[vkFormat];
  texture.colorSpace = parseColorSpace(container);
  texture.needsUpdate = true;
  return Promise.resolve(texture);
}
function parseColorSpace(container) {
  const dfd = container.dataFormatDescriptor[0];
  if (dfd.colorPrimaries === C$1) {
    return dfd.transferFunction === u$1 ? SRGBColorSpace : LinearSRGBColorSpace;
  } else if (dfd.colorPrimaries === R) {
    return dfd.transferFunction === u$1 ? DisplayP3ColorSpace : LinearDisplayP3ColorSpace;
  } else if (dfd.colorPrimaries === T$1) {
    return NoColorSpace;
  } else {
    console.warn(`THREE.KTX2Loader: Unsupported color primaries, "${dfd.colorPrimaries}"`);
    return NoColorSpace;
  }
}
var MeshoptDecoder = function() {
  var wasm_base = "b9H79Tebbbe8Fv9Gbb9Gvuuuuueu9Giuuub9Geueu9Giuuueuikqbeeedddillviebeoweuec:q;iekr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbeY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVbdE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbiL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtblK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbol79IV9Rbrq:P8Yqdbk;3sezu8Jjjjjbcj;eb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Radz1jjjbhwcj;abad9UhoaicefhldnadTmbaoc;WFbGgocjdaocjd6EhDcbhqinaqae9pmeaDaeaq9RaqaDfae6Egkcsfgocl4cifcd4hxdndndndnaoc9WGgmTmbcbhPcehsawcjdfhzalhHinaraH9Rax6midnaraHaxfgl9RcK6mbczhoinawcj;cbfaogifgoc9WfhOdndndndndnaHaic9WfgAco4fRbbaAci4coG4ciGPlbedibkaO9cb83ibaOcwf9cb83ibxikaOalRblalRbbgAco4gCaCciSgCE86bbaocGfalclfaCfgORbbaAcl4ciGgCaCciSgCE86bbaocVfaOaCfgORbbaAcd4ciGgCaCciSgCE86bbaoc7faOaCfgORbbaAciGgAaAciSgAE86bbaoctfaOaAfgARbbalRbegOco4gCaCciSgCE86bbaoc91faAaCfgARbbaOcl4ciGgCaCciSgCE86bbaoc4faAaCfgARbbaOcd4ciGgCaCciSgCE86bbaoc93faAaCfgARbbaOciGgOaOciSgOE86bbaoc94faAaOfgARbbalRbdgOco4gCaCciSgCE86bbaoc95faAaCfgARbbaOcl4ciGgCaCciSgCE86bbaoc96faAaCfgARbbaOcd4ciGgCaCciSgCE86bbaoc97faAaCfgARbbaOciGgOaOciSgOE86bbaoc98faAaOfgORbbalRbiglco4gAaAciSgAE86bbaoc99faOaAfgORbbalcl4ciGgAaAciSgAE86bbaoc9:faOaAfgORbbalcd4ciGgAaAciSgAE86bbaocufaOaAfgoRbbalciGglalciSglE86bbaoalfhlxdkaOalRbwalRbbgAcl4gCaCcsSgCE86bbaocGfalcwfaCfgORbbaAcsGgAaAcsSgAE86bbaocVfaOaAfgORbbalRbegAcl4gCaCcsSgCE86bbaoc7faOaCfgORbbaAcsGgAaAcsSgAE86bbaoctfaOaAfgORbbalRbdgAcl4gCaCcsSgCE86bbaoc91faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc4faOaAfgORbbalRbigAcl4gCaCcsSgCE86bbaoc93faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc94faOaAfgORbbalRblgAcl4gCaCcsSgCE86bbaoc95faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc96faOaAfgORbbalRbvgAcl4gCaCcsSgCE86bbaoc97faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc98faOaAfgORbbalRbogAcl4gCaCcsSgCE86bbaoc99faOaCfgORbbaAcsGgAaAcsSgAE86bbaoc9:faOaAfgORbbalRbrglcl4gAaAcsSgAE86bbaocufaOaAfgoRbbalcsGglalcsSglE86bbaoalfhlxekaOal8Pbb83bbaOcwfalcwf8Pbb83bbalczfhlkdnaiam9pmbaiczfhoaral9RcL0mekkaiam6mialTmidnakTmbawaPfRbbhOcbhoazhiinaiawcj;cbfaofRbbgAce4cbaAceG9R7aOfgO86bbaiadfhiaocefgoak9hmbkkazcefhzaPcefgPad6hsalhHaPad9hmexvkkcbhlasceGmdxikalaxad2fhCdnakTmbcbhHcehsawcjdfhminaral9Rax6mialTmdalaxfhlawaHfRbbhOcbhoamhiinaiawcj;cbfaofRbbgAce4cbaAceG9R7aOfgO86bbaiadfhiaocefgoak9hmbkamcefhmaHcefgHad6hsaHad9hmbkaChlxikcbhocehsinaral9Rax6mdalTmealaxfhlaocefgoad6hsadao9hmbkaChlxdkcbhlasceGTmekc9:hoxikabaqad2fawcjdfakad2z1jjjb8Aawawcjdfakcufad2fadz1jjjb8Aakaqfhqalmbkc9:hoxekcbc99aral9Radcaadca0ESEhokavcj;ebf8Kjjjjbaok;yzeHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgDce0mbavc;abfcFecjez:jjjjb8AavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhqaicefgwarfhodnaeTmbcmcsaDceSEhkcbhxcbhmcbhDcbhicbhlindnaoaq9nmbc9:hoxikdndnawRbbgrc;Ve0mbavc;abfalarcl4cu7fcsGcitfgPydlhsaPydbhzdnarcsGgPak9pmbavaiarcu7fcsGcdtfydbaxaPEhraPThPdndnadcd9hmbabaDcetfgHaz87ebaHcdfas87ebaHclfar87ebxekabaDcdtfgHazBdbaHclfasBdbaHcwfarBdbkaxaPfhxavc;abfalcitfgHarBdbaHasBdlavaicdtfarBdbavc;abfalcefcsGglcitfgHazBdbaHarBdlaiaPfhialcefhlxdkdndnaPcsSmbamaPfaPc987fcefhmxekaocefhrao8SbbgPcFeGhHdndnaPcu9mmbarhoxekaocvfhoaHcFbGhHcrhPdninar8SbbgOcFbGaPtaHVhHaOcu9kmearcefhraPcrfgPc8J9hmbxdkkarcefhokaHce4cbaHceG9R7amfhmkdndnadcd9hmbabaDcetfgraz87ebarcdfas87ebarclfam87ebxekabaDcdtfgrazBdbarclfasBdbarcwfamBdbkavc;abfalcitfgramBdbarasBdlavaicdtfamBdbavc;abfalcefcsGglcitfgrazBdbaramBdlaicefhialcefhlxekdnarcpe0mbaxcefgOavaiaqarcsGfRbbgPcl49RcsGcdtfydbaPcz6gHEhravaiaP9RcsGcdtfydbaOaHfgsaPcsGgOEhPaOThOdndnadcd9hmbabaDcetfgzax87ebazcdfar87ebazclfaP87ebxekabaDcdtfgzaxBdbazclfarBdbazcwfaPBdbkavaicdtfaxBdbavc;abfalcitfgzarBdbazaxBdlavaicefgicsGcdtfarBdbavc;abfalcefcsGcitfgzaPBdbazarBdlavaiaHfcsGgicdtfaPBdbavc;abfalcdfcsGglcitfgraxBdbaraPBdlalcefhlaiaOfhiasaOfhxxekaxcbaoRbbgzEgAarc;:eSgrfhsazcsGhCazcl4hXdndnazcs0mbascefhOxekashOavaiaX9RcsGcdtfydbhskdndnaCmbaOcefhxxekaOhxavaiaz9RcsGcdtfydbhOkdndnarTmbaocefhrxekaocdfhrao8SbegHcFeGhPdnaHcu9kmbaocofhAaPcFbGhPcrhodninar8SbbgHcFbGaotaPVhPaHcu9kmearcefhraocrfgoc8J9hmbkaAhrxekarcefhrkaPce4cbaPceG9R7amfgmhAkdndnaXcsSmbarhPxekarcefhPar8SbbgocFeGhHdnaocu9kmbarcvfhsaHcFbGhHcrhodninaP8SbbgrcFbGaotaHVhHarcu9kmeaPcefhPaocrfgoc8J9hmbkashPxekaPcefhPkaHce4cbaHceG9R7amfgmhskdndnaCcsSmbaPhoxekaPcefhoaP8SbbgrcFeGhHdnarcu9kmbaPcvfhOaHcFbGhHcrhrdninao8SbbgPcFbGartaHVhHaPcu9kmeaocefhoarcrfgrc8J9hmbkaOhoxekaocefhokaHce4cbaHceG9R7amfgmhOkdndnadcd9hmbabaDcetfgraA87ebarcdfas87ebarclfaO87ebxekabaDcdtfgraABdbarclfasBdbarcwfaOBdbkavc;abfalcitfgrasBdbaraABdlavaicdtfaABdbavc;abfalcefcsGcitfgraOBdbarasBdlavaicefgicsGcdtfasBdbavc;abfalcdfcsGcitfgraABdbaraOBdlavaiazcz6aXcsSVfgicsGcdtfaOBdbaiaCTaCcsSVfhialcifhlkawcefhwalcsGhlaicsGhiaDcifgDae6mbkkcbc99aoaqSEhokavc;aef8Kjjjjbaok:llevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:Lvoeue99dud99eud99dndnadcl9hmbaeTmeindndnabcdfgd8Sbb:Yab8Sbbgi:Ygl:l:tabcefgv8Sbbgo:Ygr:l:tgwJbb;:9cawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai86bbdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad86bbdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad86bbabclfhbaecufgembxdkkaeTmbindndnabclfgd8Ueb:Yab8Uebgi:Ygl:l:tabcdfgv8Uebgo:Ygr:l:tgwJb;:FSawawNJbbbbawawJbbbb9GgDEgq:mgkaqaicb9iEalMgwawNakaqaocb9iEarMgqaqNMM:r:vglNJbbbZJbbb:;aDEMgr:lJbbb9p9DTmbar:Ohixekcjjjj94hikadai87ebdndnaqalNJbbbZJbbb:;aqJbbbb9GEMgq:lJbbb9p9DTmbaq:Ohdxekcjjjj94hdkavad87ebdndnawalNJbbbZJbbb:;awJbbbb9GEMgw:lJbbb9p9DTmbaw:Ohdxekcjjjj94hdkabad87ebabcwfhbaecufgembkkk;siliui99iue99dnaeTmbcbhiabhlindndnJ;Zl81Zalcof8UebgvciV:Y:vgoal8Ueb:YNgrJb;:FSNJbbbZJbbb:;arJbbbb9GEMgw:lJbbb9p9DTmbaw:OhDxekcjjjj94hDkalclf8Uebhqalcdf8UebhkabavcefciGaiVcetfaD87ebdndnaoak:YNgwJb;:FSNJbbbZJbbb:;awJbbbb9GEMgx:lJbbb9p9DTmbax:Ohkxekcjjjj94hkkabavcdfciGaiVcetfak87ebdndnaoaq:YNgoJb;:FSNJbbbZJbbb:;aoJbbbb9GEMgx:lJbbb9p9DTmbax:Ohqxekcjjjj94hqkabavcufciGaiVcetfaq87ebdndnJbbjZararN:tawawN:taoaoN:tgrJbbbbarJbbbb9GE:rJb;:FSNJbbbZMgr:lJbbb9p9DTmbar:Ohqxekcjjjj94hqkabavciGaiVcetfaq87ebalcwfhlaiclfhiaecufgembkkk9mbdnadcd4ae2geTmbinababydbgdcwtcw91:Yadce91cjjj;8ifcjjj98G::NUdbabclfhbaecufgembkkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaik;LeeeudndnaeabVciGTmbabhixekdndnadcz9pmbabhixekabhiinaiaeydbBdbaiclfaeclfydbBdbaicwfaecwfydbBdbaicxfaecxfydbBdbaiczfhiaeczfheadc9Wfgdcs0mbkkadcl6mbinaiaeydbBdbaeclfheaiclfhiadc98fgdci0mbkkdnadTmbinaiaeRbb86bbaicefhiaecefheadcufgdmbkkabk;aeedudndnabciGTmbabhixekaecFeGc:b:c:ew2hldndnadcz9pmbabhixekabhiinaialBdbaicxfalBdbaicwfalBdbaiclfalBdbaiczfhiadc9Wfgdcs0mbkkadcl6mbinaialBdbaiclfhiadc98fgdci0mbkkdnadTmbinaiae86bbaicefhiadcufgdmbkkabkkkebcjwklz9Kbb";
  var wasm_simd = "b9H79TebbbeKl9Gbb9Gvuuuuueu9Giuuub9Geueuikqbbebeedddilve9Weeeviebeoweuec:q;Aekr;leDo9TW9T9VV95dbH9F9F939H79T9F9J9H229F9Jt9VV7bb8A9TW79O9V9Wt9F9KW9J9V9KW9wWVtW949c919M9MWVbdY9TW79O9V9Wt9F9KW9J9V9KW69U9KW949c919M9MWVblE9TW79O9V9Wt9F9KW9J9V9KW69U9KW949tWG91W9U9JWbvL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9p9JtboK9TW79O9V9Wt9F9KW9J9V9KWS9P2tWV9r919HtbrL9TW79O9V9Wt9F9KW9J9V9KWS9P2tWVT949Wbwl79IV9RbDq;t9tqlbzik9:evu8Jjjjjbcz9Rhbcbheincbhdcbhiinabcwfadfaicjuaead4ceGglE86bbaialfhiadcefgdcw9hmbkaec:q:yjjbfai86bbaecitc:q1jjbfab8Piw83ibaecefgecjd9hmbkk;h8JlHud97euo978Jjjjjbcj;kb9Rgv8Kjjjjbc9:hodnadcefal0mbcuhoaiRbbc:Ge9hmbavaialfgrad9Rad;8qbbcj;abad9UhoaicefhldnadTmbaoc;WFbGgocjdaocjd6EhwcbhDinaDae9pmeawaeaD9RaDawfae6Egqcsfgoc9WGgkci2hxakcethmaocl4cifcd4hPabaDad2fhscbhzdnincehHalhOcbhAdninaraO9RaP6miavcj;cbfaAak2fhCaOaPfhlcbhidnakc;ab6mbaral9Rc;Gb6mbcbhoinaCaofhidndndndndnaOaoco4fRbbgXciGPlbedibkaipxbbbbbbbbbbbbbbbbpklbxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklbalczfhlkdndndndndnaXcd4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklzxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklzalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklzalczfhlkdndndndndnaXcl4ciGPlbedibkaipxbbbbbbbbbbbbbbbbpklaxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklaalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaialpbbbpklaalczfhlkdndndndndnaXco4Plbedibkaipxbbbbbbbbbbbbbbbbpkl8WxikaialpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WalclfaYpQbfaXc:q:yjjbfRbbfhlxdkaialpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibaXc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgXcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spkl8WalcwfaYpQbfaXc:q:yjjbfRbbfhlxekaialpbbbpkl8Walczfhlkaoc;abfhiaocjefak0meaihoaral9Rc;Fb0mbkkdndnaiak9pmbaici4hoinaral9RcK6mdaCaifhXdndndndndnaOaico4fRbbaocoG4ciGPlbedibkaXpxbbbbbbbbbbbbbbbbpklbxikaXalpbblalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLgQcdp:meaQpmbzeHdOiAlCvXoQrLpxiiiiiiiiiiiiiiiip9ogLpxiiiiiiiiiiiiiiiip8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalclfaYpQbfaKc:q:yjjbfRbbfhlxdkaXalpbbwalpbbbgQclp:meaQpmbzeHdOiAlCvXoQrLpxssssssssssssssssp9ogLpxssssssssssssssssp8JgQp5b9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibaKc:q:yjjbfpbbbgYaYpmbbbbbbbbbbbbbbbbaQp5e9cjF;8;4;W;G;ab9:9cU1:NgKcitc:q1jjbfpbibp9UpmbedilvorzHOACXQLpPaLaQp9spklbalcwfaYpQbfaKc:q:yjjbfRbbfhlxekaXalpbbbpklbalczfhlkaocdfhoaiczfgiak6mbkkalTmbaAci6hHalhOaAcefgohAaoclSmdxekkcbhlaHceGmdkdnakTmbavcjdfazfhiavazfpbdbhYcbhXinaiavcj;cbfaXfgopblbgLcep9TaLpxeeeeeeeeeeeeeeeegQp9op9Hp9rgLaoakfpblbg8Acep9Ta8AaQp9op9Hp9rg8ApmbzeHdOiAlCvXoQrLgEaoamfpblbg3cep9Ta3aQp9op9Hp9rg3aoaxfpblbg5cep9Ta5aQp9op9Hp9rg5pmbzeHdOiAlCvXoQrLg8EpmbezHdiOAlvCXorQLgQaQpmbedibedibedibediaYp9UgYp9AdbbaiadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaEa8EpmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaLa8ApmwKDYq8AkEx3m5P8Es8FgLa3a5pmwKDYq8AkEx3m5P8Es8Fg8ApmbezHdiOAlvCXorQLgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfgoaYaLa8ApmwDKYqk8AExm35Ps8E8FgQaQpmbedibedibedibedip9UgYp9AdbbaoadfgoaYaQaQpmlvorlvorlvorlvorp9UgYp9AdbbaoadfgoaYaQaQpmwDqkwDqkwDqkwDqkp9UgYp9AdbbaoadfgoaYaQaQpmxmPsxmPsxmPsxmPsp9UgYp9AdbbaoadfhiaXczfgXak6mbkkazclfgzad6mbkasavcjdfaqad2;8qbbavavcjdfaqcufad2fad;8qbbaqaDfhDc9:hoalmexikkc9:hoxekcbc99aral9Radcaadca0ESEhokavcj;kbf8Kjjjjbaokwbz:bjjjbk;uzeHu8Jjjjjbc;ae9Rgv8Kjjjjbc9:hodnaeci9UgrcHfal0mbcuhoaiRbbgwc;WeGc;Ge9hmbawcsGgDce0mbavc;abfcFecje;8kbavcUf9cu83ibavc8Wf9cu83ibavcyf9cu83ibavcaf9cu83ibavcKf9cu83ibavczf9cu83ibav9cu83iwav9cu83ibaialfc9WfhqaicefgwarfhodnaeTmbcmcsaDceSEhkcbhxcbhmcbhDcbhicbhlindnaoaq9nmbc9:hoxikdndnawRbbgrc;Ve0mbavc;abfalarcl4cu7fcsGcitfgPydlhsaPydbhzdnarcsGgPak9pmbavaiarcu7fcsGcdtfydbaxaPEhraPThPdndnadcd9hmbabaDcetfgHaz87ebaHcdfas87ebaHclfar87ebxekabaDcdtfgHazBdbaHclfasBdbaHcwfarBdbkaxaPfhxavc;abfalcitfgHarBdbaHasBdlavaicdtfarBdbavc;abfalcefcsGglcitfgHazBdbaHarBdlaiaPfhialcefhlxdkdndnaPcsSmbamaPfaPc987fcefhmxekaocefhrao8SbbgPcFeGhHdndnaPcu9mmbarhoxekaocvfhoaHcFbGhHcrhPdninar8SbbgOcFbGaPtaHVhHaOcu9kmearcefhraPcrfgPc8J9hmbxdkkarcefhokaHce4cbaHceG9R7amfhmkdndnadcd9hmbabaDcetfgraz87ebarcdfas87ebarclfam87ebxekabaDcdtfgrazBdbarclfasBdbarcwfamBdbkavc;abfalcitfgramBdbarasBdlavaicdtfamBdbavc;abfalcefcsGglcitfgrazBdbaramBdlaicefhialcefhlxekdnarcpe0mbaxcefgOavaiaqarcsGfRbbgPcl49RcsGcdtfydbaPcz6gHEhravaiaP9RcsGcdtfydbaOaHfgsaPcsGgOEhPaOThOdndnadcd9hmbabaDcetfgzax87ebazcdfar87ebazclfaP87ebxekabaDcdtfgzaxBdbazclfarBdbazcwfaPBdbkavaicdtfaxBdbavc;abfalcitfgzarBdbazaxBdlavaicefgicsGcdtfarBdbavc;abfalcefcsGcitfgzaPBdbazarBdlavaiaHfcsGgicdtfaPBdbavc;abfalcdfcsGglcitfgraxBdbaraPBdlalcefhlaiaOfhiasaOfhxxekaxcbaoRbbgzEgAarc;:eSgrfhsazcsGhCazcl4hXdndnazcs0mbascefhOxekashOavaiaX9RcsGcdtfydbhskdndnaCmbaOcefhxxekaOhxavaiaz9RcsGcdtfydbhOkdndnarTmbaocefhrxekaocdfhrao8SbegHcFeGhPdnaHcu9kmbaocofhAaPcFbGhPcrhodninar8SbbgHcFbGaotaPVhPaHcu9kmearcefhraocrfgoc8J9hmbkaAhrxekarcefhrkaPce4cbaPceG9R7amfgmhAkdndnaXcsSmbarhPxekarcefhPar8SbbgocFeGhHdnaocu9kmbarcvfhsaHcFbGhHcrhodninaP8SbbgrcFbGaotaHVhHarcu9kmeaPcefhPaocrfgoc8J9hmbkashPxekaPcefhPkaHce4cbaHceG9R7amfgmhskdndnaCcsSmbaPhoxekaPcefhoaP8SbbgrcFeGhHdnarcu9kmbaPcvfhOaHcFbGhHcrhrdninao8SbbgPcFbGartaHVhHaPcu9kmeaocefhoarcrfgrc8J9hmbkaOhoxekaocefhokaHce4cbaHceG9R7amfgmhOkdndnadcd9hmbabaDcetfgraA87ebarcdfas87ebarclfaO87ebxekabaDcdtfgraABdbarclfasBdbarcwfaOBdbkavc;abfalcitfgrasBdbaraABdlavaicdtfaABdbavc;abfalcefcsGcitfgraOBdbarasBdlavaicefgicsGcdtfasBdbavc;abfalcdfcsGcitfgraABdbaraOBdlavaiazcz6aXcsSVfgicsGcdtfaOBdbaiaCTaCcsSVfhialcifhlkawcefhwalcsGhlaicsGhiaDcifgDae6mbkkcbc99aoaqSEhokavc;aef8Kjjjjbaok:llevu8Jjjjjbcz9Rhvc9:hodnaecvfal0mbcuhoaiRbbc;:eGc;qe9hmbav9cb83iwaicefhraialfc98fhwdnaeTmbdnadcdSmbcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcdtfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfglBdbaoalBdbaDcefgDae9hmbxdkkcbhDindnaraw6mbc9:skarcefhoar8SbbglcFeGhidndnalcu9mmbaohrxekarcvfhraicFbGhicrhldninao8SbbgdcFbGaltaiVhiadcu9kmeaocefhoalcrfglc8J9hmbxdkkaocefhrkabaDcetfaicd4cbaice4ceG9R7avcwfaiceGcdtVgoydbfgl87ebaoalBdbaDcefgDae9hmbkkcbc99arawSEhokaok:EPliuo97eue978Jjjjjbca9Rhidndnadcl9hmbdnaec98GglTmbcbhvabhdinadadpbbbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDpxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpkbbadczfhdavclfgval6mbkkalae9pmeaiaeciGgvcdtgdVcbczad9R;8kbaiabalcdtfglad;8qbbdnavTmbaiaipblbgocKp:RecKp:Sep;6egraocwp:RecKp:Sep;6earp;Geaoczp:RecKp:Sep;6egwp;Gep;Kep;LegDpxbbbbbbbbbbbbbbbbp:2egqarpxbbbjbbbjbbbjbbbjgkp9op9rp;Kegrpxbb;:9cbb;:9cbb;:9cbb;:9cararp;MeaDaDp;Meawaqawakp9op9rp;Kegrarp;Mep;Kep;Kep;Jep;Negwp;Mepxbbn0bbn0bbn0bbn0gqp;KepxFbbbFbbbFbbbFbbbp9oaopxbbbFbbbFbbbFbbbFp9op9qarawp;Meaqp;Kecwp:RepxbFbbbFbbbFbbbFbbp9op9qaDawp;Meaqp;Keczp:RepxbbFbbbFbbbFbbbFbp9op9qpklbkalaiad;8qbbskdnaec98GgxTmbcbhvabhdinadczfglalpbbbgopxbbbbbbFFbbbbbbFFgkp9oadpbbbgDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eaDaopmbediwDqkzHOAKY8AEgoczp:Sep;6egrp;Geaoczp:Reczp:Sep;6egwp;Gep;Kep;Legopxb;:FSb;:FSb;:FSb;:FSawaopxbbbbbbbbbbbbbbbbp:2egqawpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegwawp;Meaoaop;Mearaqaramp9op9rp;Kegoaop;Mep;Kep;Kep;Jep;Negrp;Mepxbbn0bbn0bbn0bbn0gqp;Keczp:Reawarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9op9qgwaoarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogopmwDKYqk8AExm35Ps8E8Fp9qpkbbadaDakp9oawaopmbezHdiOAlvCXorQLp9qpkbbadcafhdavclfgvax6mbkkaxae9pmbaiaeciGgvcitgdfcbcaad9R;8kbaiabaxcitfglad;8qbbdnavTmbaiaipblzgopxbbbbbbFFbbbbbbFFgkp9oaipblbgDaopmlvorxmPsCXQL358E8FpxFubbFubbFubbFubbp9op;6eaDaopmbediwDqkzHOAKY8AEgoczp:Sep;6egrp;Geaoczp:Reczp:Sep;6egwp;Gep;Kep;Legopxb;:FSb;:FSb;:FSb;:FSawaopxbbbbbbbbbbbbbbbbp:2egqawpxbbbjbbbjbbbjbbbjgmp9op9rp;Kegwawp;Meaoaop;Mearaqaramp9op9rp;Kegoaop;Mep;Kep;Kep;Jep;Negrp;Mepxbbn0bbn0bbn0bbn0gqp;Keczp:Reawarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9op9qgwaoarp;Meaqp;KepxFFbbFFbbFFbbFFbbp9ogopmwDKYqk8AExm35Ps8E8Fp9qpklzaiaDakp9oawaopmbezHdiOAlvCXorQLp9qpklbkalaiad;8qbbkk;4wllue97euv978Jjjjjbc8W9Rhidnaec98GglTmbcbhvabhoinaiaopbbbgraoczfgwpbbbgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklbaopxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaqakp;Mearp;Keczp:ReaDakp;Mearp;Keamp9op9qgkpmbezHdiOAlvCXorQLgrp5baipblbpEb:T:j83ibaocwfarp5eaipblbpEe:T:j83ibawaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblbpEd:T:j83ibaocKfakp5eaipblbpEi:T:j83ibaocafhoavclfgval6mbkkdnalae9pmbaiaeciGgvcitgofcbcaao9R;8kbaiabalcitfgwao;8qbbdnavTmbaiaipblbgraipblzgDpmlvorxmPsCXQL358E8Fgqczp:Segkclp:RepklaaipxbbjZbbjZbbjZbbjZpx;Zl81Z;Zl81Z;Zl81Z;Zl81Zakpxibbbibbbibbbibbbp9qp;6ep;NegkaraDpmbediwDqkzHOAKY8AEgrczp:Reczp:Sep;6ep;MegDaDp;Meakarczp:Sep;6ep;Megxaxp;Meakaqczp:Reczp:Sep;6ep;Megqaqp;Mep;Kep;Kep;Lepxbbbbbbbbbbbbbbbbp:4ep;Jepxb;:FSb;:FSb;:FSb;:FSgkp;Mepxbbn0bbn0bbn0bbn0grp;KepxFFbbFFbbFFbbFFbbgmp9oaxakp;Mearp;Keczp:Rep9qgxaqakp;Mearp;Keczp:ReaDakp;Mearp;Keamp9op9qgkpmbezHdiOAlvCXorQLgrp5baipblapEb:T:j83ibaiarp5eaipblapEe:T:j83iwaiaxakpmwDKYqk8AExm35Ps8E8Fgkp5baipblapEd:T:j83izaiakp5eaipblapEi:T:j83iKkawaiao;8qbbkk:Pddiue978Jjjjjbc;ab9Rhidnadcd4ae2glc98GgvTmbcbhdabheinaeaepbbbgocwp:Recwp:Sep;6eaocep:SepxbbjZbbjZbbjZbbjZp:UepxbbjFbbjFbbjFbbjFp9op;Mepkbbaeczfheadclfgdav6mbkkdnaval9pmbaialciGgdcdtgeVcbc;abae9R;8kbaiabavcdtfgvae;8qbbdnadTmbaiaipblbgocwp:Recwp:Sep;6eaocep:SepxbbjZbbjZbbjZbbjZp:UepxbbjFbbjFbbjFbbjFp9op;Mepklbkavaiae;8qbbkk9teiucbcbydj1jjbgeabcifc98GfgbBdj1jjbdndnabZbcztgd9nmbcuhiabad9RcFFifcz4nbcuSmekaehikaikkkebcjwklz9Tbb";
  var detector = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 3, 2, 0, 0, 5, 3, 1, 0, 1, 12, 1, 0, 10, 22, 2, 12, 0, 65, 0, 65, 0, 65, 0, 252, 10, 0, 0, 11, 7, 0, 65, 0, 253, 15, 26, 11]);
  var wasmpack = new Uint8Array([32, 0, 65, 2, 1, 106, 34, 33, 3, 128, 11, 4, 13, 64, 6, 253, 10, 7, 15, 116, 127, 5, 8, 12, 40, 16, 19, 54, 20, 9, 27, 255, 113, 17, 42, 67, 24, 23, 146, 148, 18, 14, 22, 45, 70, 69, 56, 114, 101, 21, 25, 63, 75, 136, 108, 28, 118, 29, 73, 115]);
  if (typeof WebAssembly !== "object") {
    return {
      supported: false
    };
  }
  var wasm = WebAssembly.validate(detector) ? wasm_simd : wasm_base;
  var instance;
  var ready = WebAssembly.instantiate(unpack(wasm), {}).then(function(result) {
    instance = result.instance;
    instance.exports.__wasm_call_ctors();
  });
  function unpack(data) {
    var result = new Uint8Array(data.length);
    for (var i2 = 0; i2 < data.length; ++i2) {
      var ch = data.charCodeAt(i2);
      result[i2] = ch > 96 ? ch - 97 : ch > 64 ? ch - 39 : ch + 4;
    }
    var write = 0;
    for (var i2 = 0; i2 < data.length; ++i2) {
      result[write++] = result[i2] < 60 ? wasmpack[result[i2]] : (result[i2] - 60) * 64 + result[++i2];
    }
    return result.buffer.slice(0, write);
  }
  function decode2(fun, target, count, size, source, filter) {
    var sbrk = instance.exports.sbrk;
    var count4 = count + 3 & -4;
    var tp = sbrk(count4 * size);
    var sp = sbrk(source.length);
    var heap = new Uint8Array(instance.exports.memory.buffer);
    heap.set(source, sp);
    var res = fun(tp, count, size, sp, source.length);
    if (res == 0 && filter) {
      filter(tp, count4, size);
    }
    target.set(heap.subarray(tp, tp + count * size));
    sbrk(tp - sbrk(0));
    if (res != 0) {
      throw new Error("Malformed buffer data: " + res);
    }
  }
  var filters = {
    NONE: "",
    OCTAHEDRAL: "meshopt_decodeFilterOct",
    QUATERNION: "meshopt_decodeFilterQuat",
    EXPONENTIAL: "meshopt_decodeFilterExp"
  };
  var decoders = {
    ATTRIBUTES: "meshopt_decodeVertexBuffer",
    TRIANGLES: "meshopt_decodeIndexBuffer",
    INDICES: "meshopt_decodeIndexSequence"
  };
  var workers = [];
  var requestId = 0;
  function createWorker(url) {
    var worker = {
      object: new Worker(url),
      pending: 0,
      requests: {}
    };
    worker.object.onmessage = function(event) {
      var data = event.data;
      worker.pending -= data.count;
      worker.requests[data.id][data.action](data.value);
      delete worker.requests[data.id];
    };
    return worker;
  }
  function initWorkers(count) {
    var source = "var instance; var ready = WebAssembly.instantiate(new Uint8Array([" + new Uint8Array(unpack(wasm)) + "]), {}).then(function(result) { instance = result.instance; instance.exports.__wasm_call_ctors(); });self.onmessage = workerProcess;" + decode2.toString() + workerProcess.toString();
    var blob = new Blob([source], { type: "text/javascript" });
    var url = URL.createObjectURL(blob);
    for (var i2 = 0; i2 < count; ++i2) {
      workers[i2] = createWorker(url);
    }
    URL.revokeObjectURL(url);
  }
  function decodeWorker(count, size, source, mode, filter) {
    var worker = workers[0];
    for (var i2 = 1; i2 < workers.length; ++i2) {
      if (workers[i2].pending < worker.pending) {
        worker = workers[i2];
      }
    }
    return new Promise(function(resolve, reject) {
      var data = new Uint8Array(source);
      var id = requestId++;
      worker.pending += count;
      worker.requests[id] = { resolve, reject };
      worker.object.postMessage({ id, count, size, source: data, mode, filter }, [data.buffer]);
    });
  }
  function workerProcess(event) {
    ready.then(function() {
      var data = event.data;
      try {
        var target = new Uint8Array(data.count * data.size);
        decode2(instance.exports[data.mode], target, data.count, data.size, data.source, instance.exports[data.filter]);
        self.postMessage({ id: data.id, count: data.count, action: "resolve", value: target }, [target.buffer]);
      } catch (error) {
        self.postMessage({ id: data.id, count: data.count, action: "reject", value: error });
      }
    });
  }
  return {
    ready,
    supported: true,
    useWorkers: function(count) {
      initWorkers(count);
    },
    decodeVertexBuffer: function(target, count, size, source, filter) {
      decode2(instance.exports.meshopt_decodeVertexBuffer, target, count, size, source, instance.exports[filters[filter]]);
    },
    decodeIndexBuffer: function(target, count, size, source) {
      decode2(instance.exports.meshopt_decodeIndexBuffer, target, count, size, source);
    },
    decodeIndexSequence: function(target, count, size, source) {
      decode2(instance.exports.meshopt_decodeIndexSequence, target, count, size, source);
    },
    decodeGltfBuffer: function(target, count, size, source, mode, filter) {
      decode2(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
    },
    decodeGltfBufferAsync: function(count, size, source, mode, filter) {
      if (workers.length > 0) {
        return decodeWorker(count, size, source, decoders[mode], filters[filter]);
      }
      return ready.then(function() {
        var target = new Uint8Array(count * size);
        decode2(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
        return target;
      });
    }
  };
}();
const materialLoader = new MTLLoader();
const objLoader = new OBJLoader();
const gltfLoader = new GLTFLoader();
const fbxLoader = new FBXLoader();
const colladaLoader = new ColladaLoader();
function normalizeSpecular(model) {
  model.traverse(function(obj) {
    if (obj.isMesh) {
      let specularColor;
      if (obj.material.type == "MeshStandardMaterial") {
        if (obj.material.metalness) {
          obj.material.metalness *= 0.1;
        }
        if (obj.material.glossiness) {
          obj.material.glossiness *= 0.25;
        }
        specularColor = new Color$1(12, 12, 12);
      } else if (obj.material.type == "MeshPhongMaterial") {
        obj.material.shininess = 0.1;
        specularColor = new Color$1(20, 20, 20);
      }
      if (obj.material.specular && obj.material.specular.isColor) {
        obj.material.specular = specularColor;
      }
    }
  });
}
const modelCache = /* @__PURE__ */ new Map();
function LoadObj(options) {
  let res;
  const { type, url, index: index2, progress, cacheable } = options;
  let withCredentials = !!options.withCredentials;
  if (type)
    switch (type) {
      case "obj":
        res = new Promise(
          options.mtl ? (resolve, reject) => {
            materialLoader.withCredentials = withCredentials;
            materialLoader.load(
              options.mtl,
              function(materials) {
                materials.preload();
                objLoader.withCredentials = withCredentials;
                objLoader.setMaterials(materials).load(
                  url,
                  (data) => {
                    data.rotateX(Math.PI / 2).rotateY(Math.PI);
                    resolve(data);
                  },
                  (xhr) => {
                    if (typeof progress === "function" && index2 !== void 0) {
                      progress(parseFloat(xhr.loaded / xhr.total * 100), index2);
                    }
                  },
                  reject
                );
              },
              null,
              reject
            );
          } : (resolve, reject) => {
            objLoader.withCredentials = withCredentials;
            objLoader.load(
              url,
              (data) => {
                data.rotateX(Math.PI / 2).rotateY(Math.PI);
                resolve(data);
              },
              (xhr) => {
                if (typeof progress === "function" && index2 !== void 0) {
                  progress(parseFloat(xhr.loaded / xhr.total * 100), index2);
                }
              },
              reject
            );
          }
        );
        break;
      case "gltf":
      case "glb":
        res = new Promise((resolve, reject) => {
          if (options.draco && !gltfLoader.dracoLoader) {
            const dracoLoader = new DRACOLoader();
            dracoLoader.setDecoderPath(options.dracoUrl);
            dracoLoader.setDecoderConfig({ type: "js" });
            dracoLoader.preload();
            gltfLoader.setDRACOLoader(dracoLoader);
          }
          if (options.ktx2Parse && !gltfLoader.ktx2Loader && options.tb) {
            const ktx2Loader = new KTX2Loader();
            ktx2Loader.setTranscoderPath(options.ktx2Url);
            ktx2Loader.detectSupport(options.tb.renderer);
            gltfLoader.setKTX2Loader(ktx2Loader);
          }
          if (options.useMeshOpt) {
            gltfLoader.setMeshoptDecoder(MeshoptDecoder);
          }
          let cacheModel;
          if (cacheable && modelCache.has(url)) {
            cacheModel = modelCache.get(url);
            resolve(cacheModel.clone());
          } else {
            gltfLoader.load(
              url,
              (data) => {
                if (options.normalize) normalizeSpecular(data);
                data.scene.rotateX(Math.PI / 2).rotateY(Math.PI);
                modelCache.set(url, data.scene.clone());
                resolve(data.scene);
              },
              (xhr) => {
                if (typeof progress === "function" && index2 !== void 0) {
                  progress(parseFloat(xhr.loaded / xhr.total * 100), index2);
                }
              },
              reject
            );
          }
        });
        break;
      case "fbx":
        fbxLoader.withCredentials = withCredentials;
        res = new Promise((resolve, reject) => {
          fbxLoader.load(
            options.url,
            (data) => {
              data.rotateX(Math.PI / 2).rotateY(Math.PI);
              resolve(data);
            },
            (xhr) => {
              if (typeof progress === "function" && index2 !== void 0) {
                progress(parseFloat(xhr.loaded / xhr.total * 100), index2);
              }
            },
            reject
          );
        });
        break;
      case "dae":
        res = new Promise((resolve, reject) => {
          colladaLoader.withCredentials = withCredentials;
          colladaLoader.load(
            url,
            (data) => {
              data.rotateX(Math.PI / 2).rotateY(Math.PI);
              resolve(data);
            },
            (xhr) => {
              if (typeof progress === "function" && index2 !== void 0) {
                progress(parseFloat(xhr.loaded / xhr.total * 100), index2);
              }
            },
            reject
          );
        });
        break;
      default:
        console.error("缺少模型类型");
    }
  else console.error("缺少模型类型");
  return res;
}
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d2, b) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b2) {
    d3.__proto__ = b2;
  } || function(d3, b2) {
    for (var p2 in b2) if (Object.prototype.hasOwnProperty.call(b2, p2)) d3[p2] = b2[p2];
  };
  return extendStatics(d2, b);
};
function __extends(d2, b) {
  if (typeof b !== "function" && b !== null)
    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d2, b);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t3) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2)) t3[p2] = s2[p2];
    }
    return t3;
  };
  return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e2) {
        reject(e2);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t3[0] & 1) throw t3[1];
    return t3[1];
  }, trys: [], ops: [] }, f2, y, t3, g3;
  return g3 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g3[Symbol.iterator] = function() {
    return this;
  }), g3;
  function verb(n2) {
    return function(v) {
      return step([n2, v]);
    };
  }
  function step(op) {
    if (f2) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f2 = 1, y && (t3 = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t3 = y["return"]) && t3.call(y), 0) : y.next) && !(t3 = t3.call(y, op[1])).done) return t3;
      if (y = 0, t3) op = [op[0] & 2, t3.value];
      switch (op[0]) {
        case 0:
        case 1:
          t3 = op;
          break;
        case 4:
          _.label++;
          return { value: op[1], done: false };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t3 = _.trys, t3 = t3.length > 0 && t3[t3.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t3 || op[1] > t3[0] && op[1] < t3[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t3[1]) {
            _.label = t3[1];
            t3 = op;
            break;
          }
          if (t3 && _.label < t3[2]) {
            _.label = t3[2];
            _.ops.push(op);
            break;
          }
          if (t3[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e2) {
      op = [6, e2];
      y = 0;
    } finally {
      f2 = t3 = 0;
    }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __spreadArray(to, from, pack2) {
  if (arguments.length === 2) for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
    if (ar || !(i2 in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i2);
      ar[i2] = from[i2];
    }
  }
  return to.concat(ar || from);
}
var Bounds = (
  /** @class */
  function() {
    function Bounds2(left, top, width, height) {
      this.left = left;
      this.top = top;
      this.width = width;
      this.height = height;
    }
    Bounds2.prototype.add = function(x, y, w, h2) {
      return new Bounds2(this.left + x, this.top + y, this.width + w, this.height + h2);
    };
    Bounds2.fromClientRect = function(context, clientRect) {
      return new Bounds2(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
    };
    Bounds2.fromDOMRectList = function(context, domRectList) {
      var domRect = Array.from(domRectList).find(function(rect) {
        return rect.width !== 0;
      });
      return domRect ? new Bounds2(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds2.EMPTY;
    };
    Bounds2.EMPTY = new Bounds2(0, 0, 0, 0);
    return Bounds2;
  }()
);
var parseBounds = function(context, node) {
  return Bounds.fromClientRect(context, node.getBoundingClientRect());
};
var parseDocumentSize = function(document2) {
  var body = document2.body;
  var documentElement = document2.documentElement;
  if (!body || !documentElement) {
    throw new Error("Unable to get document size");
  }
  var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
  var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
  return new Bounds(0, 0, width, height);
};
var toCodePoints$1 = function(str) {
  var codePoints = [];
  var i2 = 0;
  var length2 = str.length;
  while (i2 < length2) {
    var value = str.charCodeAt(i2++);
    if (value >= 55296 && value <= 56319 && i2 < length2) {
      var extra = str.charCodeAt(i2++);
      if ((extra & 64512) === 56320) {
        codePoints.push(((value & 1023) << 10) + (extra & 1023) + 65536);
      } else {
        codePoints.push(value);
        i2--;
      }
    } else {
      codePoints.push(value);
    }
  }
  return codePoints;
};
var fromCodePoint$1 = function() {
  var codePoints = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    codePoints[_i] = arguments[_i];
  }
  if (String.fromCodePoint) {
    return String.fromCodePoint.apply(String, codePoints);
  }
  var length2 = codePoints.length;
  if (!length2) {
    return "";
  }
  var codeUnits = [];
  var index2 = -1;
  var result = "";
  while (++index2 < length2) {
    var codePoint = codePoints[index2];
    if (codePoint <= 65535) {
      codeUnits.push(codePoint);
    } else {
      codePoint -= 65536;
      codeUnits.push((codePoint >> 10) + 55296, codePoint % 1024 + 56320);
    }
    if (index2 + 1 === length2 || codeUnits.length > 16384) {
      result += String.fromCharCode.apply(String, codeUnits);
      codeUnits.length = 0;
    }
  }
  return result;
};
var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
  lookup$2[chars$2.charCodeAt(i$2)] = i$2;
}
var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
  lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
}
var decode$1 = function(base642) {
  var bufferLength = base642.length * 0.75, len = base642.length, i2, p2 = 0, encoded1, encoded2, encoded3, encoded4;
  if (base642[base642.length - 1] === "=") {
    bufferLength--;
    if (base642[base642.length - 2] === "=") {
      bufferLength--;
    }
  }
  var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
  var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
  for (i2 = 0; i2 < len; i2 += 4) {
    encoded1 = lookup$1$1[base642.charCodeAt(i2)];
    encoded2 = lookup$1$1[base642.charCodeAt(i2 + 1)];
    encoded3 = lookup$1$1[base642.charCodeAt(i2 + 2)];
    encoded4 = lookup$1$1[base642.charCodeAt(i2 + 3)];
    bytes[p2++] = encoded1 << 2 | encoded2 >> 4;
    bytes[p2++] = (encoded2 & 15) << 4 | encoded3 >> 2;
    bytes[p2++] = (encoded3 & 3) << 6 | encoded4 & 63;
  }
  return buffer;
};
var polyUint16Array$1 = function(buffer) {
  var length2 = buffer.length;
  var bytes = [];
  for (var i2 = 0; i2 < length2; i2 += 2) {
    bytes.push(buffer[i2 + 1] << 8 | buffer[i2]);
  }
  return bytes;
};
var polyUint32Array$1 = function(buffer) {
  var length2 = buffer.length;
  var bytes = [];
  for (var i2 = 0; i2 < length2; i2 += 4) {
    bytes.push(buffer[i2 + 3] << 24 | buffer[i2 + 2] << 16 | buffer[i2 + 1] << 8 | buffer[i2]);
  }
  return bytes;
};
var UTRIE2_SHIFT_2$1 = 5;
var UTRIE2_SHIFT_1$1 = 6 + 5;
var UTRIE2_INDEX_SHIFT$1 = 2;
var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 65536 >> UTRIE2_SHIFT_2$1;
var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 1024 >> UTRIE2_SHIFT_2$1;
var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 2048 >> 6;
var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 65536 >> UTRIE2_SHIFT_1$1;
var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
var slice16$1 = function(view, start, end) {
  if (view.slice) {
    return view.slice(start, end);
  }
  return new Uint16Array(Array.prototype.slice.call(view, start, end));
};
var slice32$1 = function(view, start, end) {
  if (view.slice) {
    return view.slice(start, end);
  }
  return new Uint32Array(Array.prototype.slice.call(view, start, end));
};
var createTrieFromBase64$1 = function(base642, _byteLength) {
  var buffer = decode$1(base642);
  var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
  var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
  var headerLength = 24;
  var index2 = slice16$1(view16, headerLength / 2, view32[4] / 2);
  var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
  return new Trie$1(view32[0], view32[1], view32[2], view32[3], index2, data);
};
var Trie$1 = (
  /** @class */
  function() {
    function Trie2(initialValue, errorValue, highStart, highValueIndex, index2, data) {
      this.initialValue = initialValue;
      this.errorValue = errorValue;
      this.highStart = highStart;
      this.highValueIndex = highValueIndex;
      this.index = index2;
      this.data = data;
    }
    Trie2.prototype.get = function(codePoint) {
      var ix;
      if (codePoint >= 0) {
        if (codePoint < 55296 || codePoint > 56319 && codePoint <= 65535) {
          ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
          ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
          return this.data[ix];
        }
        if (codePoint <= 65535) {
          ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 55296 >> UTRIE2_SHIFT_2$1)];
          ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
          return this.data[ix];
        }
        if (codePoint < this.highStart) {
          ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
          ix = this.index[ix];
          ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
          ix = this.index[ix];
          ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
          return this.data[ix];
        }
        if (codePoint <= 1114111) {
          return this.data[this.highValueIndex];
        }
      }
      return this.errorValue;
    };
    return Trie2;
  }()
);
var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
  lookup$3[chars$3.charCodeAt(i$3)] = i$3;
}
var base64$1 = "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";
var LETTER_NUMBER_MODIFIER = 50;
var BK = 1;
var CR$1 = 2;
var LF$1 = 3;
var CM = 4;
var NL = 5;
var WJ = 7;
var ZW = 8;
var GL = 9;
var SP = 10;
var ZWJ$1 = 11;
var B2 = 12;
var BA = 13;
var BB = 14;
var HY = 15;
var CB = 16;
var CL = 17;
var CP = 18;
var EX = 19;
var IN = 20;
var NS = 21;
var OP = 22;
var QU = 23;
var IS = 24;
var NU = 25;
var PO = 26;
var PR = 27;
var SY = 28;
var AI = 29;
var AL = 30;
var CJ = 31;
var EB = 32;
var EM = 33;
var H2 = 34;
var H3 = 35;
var HL = 36;
var ID = 37;
var JL = 38;
var JV = 39;
var JT = 40;
var RI$1 = 41;
var SA = 42;
var XX = 43;
var ea_OP = [9001, 65288];
var BREAK_MANDATORY = "!";
var BREAK_NOT_ALLOWED$1 = "×";
var BREAK_ALLOWED$1 = "÷";
var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
var ALPHABETICS = [AL, HL];
var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
var SPACE$1 = [SP, ZW];
var PREFIX_POSTFIX = [PR, PO];
var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
var HYPHEN = [HY, BA];
var codePointsToCharacterClasses = function(codePoints, lineBreak2) {
  if (lineBreak2 === void 0) {
    lineBreak2 = "strict";
  }
  var types = [];
  var indices = [];
  var categories = [];
  codePoints.forEach(function(codePoint, index2) {
    var classType = UnicodeTrie$1.get(codePoint);
    if (classType > LETTER_NUMBER_MODIFIER) {
      categories.push(true);
      classType -= LETTER_NUMBER_MODIFIER;
    } else {
      categories.push(false);
    }
    if (["normal", "auto", "loose"].indexOf(lineBreak2) !== -1) {
      if ([8208, 8211, 12316, 12448].indexOf(codePoint) !== -1) {
        indices.push(index2);
        return types.push(CB);
      }
    }
    if (classType === CM || classType === ZWJ$1) {
      if (index2 === 0) {
        indices.push(index2);
        return types.push(AL);
      }
      var prev = types[index2 - 1];
      if (LINE_BREAKS.indexOf(prev) === -1) {
        indices.push(indices[index2 - 1]);
        return types.push(prev);
      }
      indices.push(index2);
      return types.push(AL);
    }
    indices.push(index2);
    if (classType === CJ) {
      return types.push(lineBreak2 === "strict" ? NS : ID);
    }
    if (classType === SA) {
      return types.push(AL);
    }
    if (classType === AI) {
      return types.push(AL);
    }
    if (classType === XX) {
      if (codePoint >= 131072 && codePoint <= 196605 || codePoint >= 196608 && codePoint <= 262141) {
        return types.push(ID);
      } else {
        return types.push(AL);
      }
    }
    types.push(classType);
  });
  return [indices, types, categories];
};
var isAdjacentWithSpaceIgnored = function(a3, b, currentIndex, classTypes) {
  var current = classTypes[currentIndex];
  if (Array.isArray(a3) ? a3.indexOf(current) !== -1 : a3 === current) {
    var i2 = currentIndex;
    while (i2 <= classTypes.length) {
      i2++;
      var next = classTypes[i2];
      if (next === b) {
        return true;
      }
      if (next !== SP) {
        break;
      }
    }
  }
  if (current === SP) {
    var i2 = currentIndex;
    while (i2 > 0) {
      i2--;
      var prev = classTypes[i2];
      if (Array.isArray(a3) ? a3.indexOf(prev) !== -1 : a3 === prev) {
        var n2 = currentIndex;
        while (n2 <= classTypes.length) {
          n2++;
          var next = classTypes[n2];
          if (next === b) {
            return true;
          }
          if (next !== SP) {
            break;
          }
        }
      }
      if (prev !== SP) {
        break;
      }
    }
  }
  return false;
};
var previousNonSpaceClassType = function(currentIndex, classTypes) {
  var i2 = currentIndex;
  while (i2 >= 0) {
    var type = classTypes[i2];
    if (type === SP) {
      i2--;
    } else {
      return type;
    }
  }
  return 0;
};
var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index2, forbiddenBreaks) {
  if (indicies[index2] === 0) {
    return BREAK_NOT_ALLOWED$1;
  }
  var currentIndex = index2 - 1;
  if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
    return BREAK_NOT_ALLOWED$1;
  }
  var beforeIndex = currentIndex - 1;
  var afterIndex = currentIndex + 1;
  var current = classTypes[currentIndex];
  var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
  var next = classTypes[afterIndex];
  if (current === CR$1 && next === LF$1) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
    return BREAK_MANDATORY;
  }
  if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (SPACE$1.indexOf(next) !== -1) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
    return BREAK_ALLOWED$1;
  }
  if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
    return BREAK_NOT_ALLOWED$1;
  }
  if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (current === WJ || next === WJ) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (current === GL) {
    return BREAK_NOT_ALLOWED$1;
  }
  if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
    return BREAK_NOT_ALLOWED$1;
  }
  if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (current === SP) {
    return BREAK_ALLOWED$1;
  }
  if (current === QU || next === QU) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (next === CB || current === CB) {
    return BREAK_ALLOWED$1;
  }
  if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (before === HL && HYPHEN.indexOf(current) !== -1) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (current === SY && next === HL) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (next === IN) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (current === PR && [ID, EB, EM].indexOf(next) !== -1 || [ID, EB, EM].indexOf(current) !== -1 && next === PO) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (
    // (PR | PO) × ( OP | HY )? NU
    [PR, PO].indexOf(current) !== -1 && (next === NU || [OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
    [OP, HY].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
    current === NU && [NU, SY, IS].indexOf(next) !== -1
  ) {
    return BREAK_NOT_ALLOWED$1;
  }
  if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
    var prevIndex = currentIndex;
    while (prevIndex >= 0) {
      var type = classTypes[prevIndex];
      if (type === NU) {
        return BREAK_NOT_ALLOWED$1;
      } else if ([SY, IS].indexOf(type) !== -1) {
        prevIndex--;
      } else {
        break;
      }
    }
  }
  if ([PR, PO].indexOf(next) !== -1) {
    var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
    while (prevIndex >= 0) {
      var type = classTypes[prevIndex];
      if (type === NU) {
        return BREAK_NOT_ALLOWED$1;
      } else if ([SY, IS].indexOf(type) !== -1) {
        prevIndex--;
      } else {
        break;
      }
    }
  }
  if (JL === current && [JL, JV, H2, H3].indexOf(next) !== -1 || [JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1 || [JT, H3].indexOf(current) !== -1 && next === JT) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) {
    return BREAK_NOT_ALLOWED$1;
  }
  if (current === RI$1 && next === RI$1) {
    var i2 = indicies[currentIndex];
    var count = 1;
    while (i2 > 0) {
      i2--;
      if (classTypes[i2] === RI$1) {
        count++;
      } else {
        break;
      }
    }
    if (count % 2 !== 0) {
      return BREAK_NOT_ALLOWED$1;
    }
  }
  if (current === EB && next === EM) {
    return BREAK_NOT_ALLOWED$1;
  }
  return BREAK_ALLOWED$1;
};
var cssFormattedClasses = function(codePoints, options) {
  if (!options) {
    options = { lineBreak: "normal", wordBreak: "normal" };
  }
  var _a2 = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a2[0], classTypes = _a2[1], isLetterNumber = _a2[2];
  if (options.wordBreak === "break-all" || options.wordBreak === "break-word") {
    classTypes = classTypes.map(function(type) {
      return [NU, AL, SA].indexOf(type) !== -1 ? ID : type;
    });
  }
  var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i2) {
    return letterNumber && codePoints[i2] >= 19968 && codePoints[i2] <= 40959;
  }) : void 0;
  return [indicies, classTypes, forbiddenBreakpoints];
};
var Break = (
  /** @class */
  function() {
    function Break2(codePoints, lineBreak2, start, end) {
      this.codePoints = codePoints;
      this.required = lineBreak2 === BREAK_MANDATORY;
      this.start = start;
      this.end = end;
    }
    Break2.prototype.slice = function() {
      return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
    };
    return Break2;
  }()
);
var LineBreaker = function(str, options) {
  var codePoints = toCodePoints$1(str);
  var _a2 = cssFormattedClasses(codePoints, options), indicies = _a2[0], classTypes = _a2[1], forbiddenBreakpoints = _a2[2];
  var length2 = codePoints.length;
  var lastEnd = 0;
  var nextIndex = 0;
  return {
    next: function() {
      if (nextIndex >= length2) {
        return { done: true, value: null };
      }
      var lineBreak2 = BREAK_NOT_ALLOWED$1;
      while (nextIndex < length2 && (lineBreak2 = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1) {
      }
      if (lineBreak2 !== BREAK_NOT_ALLOWED$1 || nextIndex === length2) {
        var value = new Break(codePoints, lineBreak2, lastEnd, nextIndex);
        lastEnd = nextIndex;
        return { value, done: false };
      }
      return { done: true, value: null };
    }
  };
};
var FLAG_UNRESTRICTED = 1 << 0;
var FLAG_ID = 1 << 1;
var FLAG_INTEGER = 1 << 2;
var FLAG_NUMBER = 1 << 3;
var LINE_FEED = 10;
var SOLIDUS = 47;
var REVERSE_SOLIDUS = 92;
var CHARACTER_TABULATION = 9;
var SPACE = 32;
var QUOTATION_MARK = 34;
var EQUALS_SIGN = 61;
var NUMBER_SIGN = 35;
var DOLLAR_SIGN = 36;
var PERCENTAGE_SIGN = 37;
var APOSTROPHE = 39;
var LEFT_PARENTHESIS = 40;
var RIGHT_PARENTHESIS = 41;
var LOW_LINE = 95;
var HYPHEN_MINUS = 45;
var EXCLAMATION_MARK = 33;
var LESS_THAN_SIGN = 60;
var GREATER_THAN_SIGN = 62;
var COMMERCIAL_AT = 64;
var LEFT_SQUARE_BRACKET = 91;
var RIGHT_SQUARE_BRACKET = 93;
var CIRCUMFLEX_ACCENT = 61;
var LEFT_CURLY_BRACKET = 123;
var QUESTION_MARK = 63;
var RIGHT_CURLY_BRACKET = 125;
var VERTICAL_LINE = 124;
var TILDE = 126;
var CONTROL = 128;
var REPLACEMENT_CHARACTER = 65533;
var ASTERISK = 42;
var PLUS_SIGN = 43;
var COMMA = 44;
var COLON = 58;
var SEMICOLON = 59;
var FULL_STOP = 46;
var NULL = 0;
var BACKSPACE = 8;
var LINE_TABULATION = 11;
var SHIFT_OUT = 14;
var INFORMATION_SEPARATOR_ONE = 31;
var DELETE = 127;
var EOF = -1;
var ZERO = 48;
var a2 = 97;
var e = 101;
var f = 102;
var u2 = 117;
var z = 122;
var A = 65;
var E = 69;
var F = 70;
var U = 85;
var Z = 90;
var isDigit = function(codePoint) {
  return codePoint >= ZERO && codePoint <= 57;
};
var isSurrogateCodePoint = function(codePoint) {
  return codePoint >= 55296 && codePoint <= 57343;
};
var isHex = function(codePoint) {
  return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a2 && codePoint <= f;
};
var isLowerCaseLetter = function(codePoint) {
  return codePoint >= a2 && codePoint <= z;
};
var isUpperCaseLetter = function(codePoint) {
  return codePoint >= A && codePoint <= Z;
};
var isLetter = function(codePoint) {
  return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
};
var isNonASCIICodePoint = function(codePoint) {
  return codePoint >= CONTROL;
};
var isWhiteSpace = function(codePoint) {
  return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
};
var isNameStartCodePoint = function(codePoint) {
  return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
};
var isNameCodePoint = function(codePoint) {
  return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
};
var isNonPrintableCodePoint = function(codePoint) {
  return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
};
var isValidEscape = function(c1, c2) {
  if (c1 !== REVERSE_SOLIDUS) {
    return false;
  }
  return c2 !== LINE_FEED;
};
var isIdentifierStart = function(c1, c2, c3) {
  if (c1 === HYPHEN_MINUS) {
    return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
  } else if (isNameStartCodePoint(c1)) {
    return true;
  } else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
    return true;
  }
  return false;
};
var isNumberStart = function(c1, c2, c3) {
  if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
    if (isDigit(c2)) {
      return true;
    }
    return c2 === FULL_STOP && isDigit(c3);
  }
  if (c1 === FULL_STOP) {
    return isDigit(c2);
  }
  return isDigit(c1);
};
var stringToNumber = function(codePoints) {
  var c2 = 0;
  var sign2 = 1;
  if (codePoints[c2] === PLUS_SIGN || codePoints[c2] === HYPHEN_MINUS) {
    if (codePoints[c2] === HYPHEN_MINUS) {
      sign2 = -1;
    }
    c2++;
  }
  var integers = [];
  while (isDigit(codePoints[c2])) {
    integers.push(codePoints[c2++]);
  }
  var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
  if (codePoints[c2] === FULL_STOP) {
    c2++;
  }
  var fraction = [];
  while (isDigit(codePoints[c2])) {
    fraction.push(codePoints[c2++]);
  }
  var fracd = fraction.length;
  var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
  if (codePoints[c2] === E || codePoints[c2] === e) {
    c2++;
  }
  var expsign = 1;
  if (codePoints[c2] === PLUS_SIGN || codePoints[c2] === HYPHEN_MINUS) {
    if (codePoints[c2] === HYPHEN_MINUS) {
      expsign = -1;
    }
    c2++;
  }
  var exponent = [];
  while (isDigit(codePoints[c2])) {
    exponent.push(codePoints[c2++]);
  }
  var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
  return sign2 * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
};
var LEFT_PARENTHESIS_TOKEN = {
  type: 2
  /* LEFT_PARENTHESIS_TOKEN */
};
var RIGHT_PARENTHESIS_TOKEN = {
  type: 3
  /* RIGHT_PARENTHESIS_TOKEN */
};
var COMMA_TOKEN = {
  type: 4
  /* COMMA_TOKEN */
};
var SUFFIX_MATCH_TOKEN = {
  type: 13
  /* SUFFIX_MATCH_TOKEN */
};
var PREFIX_MATCH_TOKEN = {
  type: 8
  /* PREFIX_MATCH_TOKEN */
};
var COLUMN_TOKEN = {
  type: 21
  /* COLUMN_TOKEN */
};
var DASH_MATCH_TOKEN = {
  type: 9
  /* DASH_MATCH_TOKEN */
};
var INCLUDE_MATCH_TOKEN = {
  type: 10
  /* INCLUDE_MATCH_TOKEN */
};
var LEFT_CURLY_BRACKET_TOKEN = {
  type: 11
  /* LEFT_CURLY_BRACKET_TOKEN */
};
var RIGHT_CURLY_BRACKET_TOKEN = {
  type: 12
  /* RIGHT_CURLY_BRACKET_TOKEN */
};
var SUBSTRING_MATCH_TOKEN = {
  type: 14
  /* SUBSTRING_MATCH_TOKEN */
};
var BAD_URL_TOKEN = {
  type: 23
  /* BAD_URL_TOKEN */
};
var BAD_STRING_TOKEN = {
  type: 1
  /* BAD_STRING_TOKEN */
};
var CDO_TOKEN = {
  type: 25
  /* CDO_TOKEN */
};
var CDC_TOKEN = {
  type: 24
  /* CDC_TOKEN */
};
var COLON_TOKEN = {
  type: 26
  /* COLON_TOKEN */
};
var SEMICOLON_TOKEN = {
  type: 27
  /* SEMICOLON_TOKEN */
};
var LEFT_SQUARE_BRACKET_TOKEN = {
  type: 28
  /* LEFT_SQUARE_BRACKET_TOKEN */
};
var RIGHT_SQUARE_BRACKET_TOKEN = {
  type: 29
  /* RIGHT_SQUARE_BRACKET_TOKEN */
};
var WHITESPACE_TOKEN = {
  type: 31
  /* WHITESPACE_TOKEN */
};
var EOF_TOKEN = {
  type: 32
  /* EOF_TOKEN */
};
var Tokenizer = (
  /** @class */
  function() {
    function Tokenizer2() {
      this._value = [];
    }
    Tokenizer2.prototype.write = function(chunk) {
      this._value = this._value.concat(toCodePoints$1(chunk));
    };
    Tokenizer2.prototype.read = function() {
      var tokens = [];
      var token = this.consumeToken();
      while (token !== EOF_TOKEN) {
        tokens.push(token);
        token = this.consumeToken();
      }
      return tokens;
    };
    Tokenizer2.prototype.consumeToken = function() {
      var codePoint = this.consumeCodePoint();
      switch (codePoint) {
        case QUOTATION_MARK:
          return this.consumeStringToken(QUOTATION_MARK);
        case NUMBER_SIGN:
          var c1 = this.peekCodePoint(0);
          var c2 = this.peekCodePoint(1);
          var c3 = this.peekCodePoint(2);
          if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
            var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
            var value = this.consumeName();
            return { type: 5, value, flags };
          }
          break;
        case DOLLAR_SIGN:
          if (this.peekCodePoint(0) === EQUALS_SIGN) {
            this.consumeCodePoint();
            return SUFFIX_MATCH_TOKEN;
          }
          break;
        case APOSTROPHE:
          return this.consumeStringToken(APOSTROPHE);
        case LEFT_PARENTHESIS:
          return LEFT_PARENTHESIS_TOKEN;
        case RIGHT_PARENTHESIS:
          return RIGHT_PARENTHESIS_TOKEN;
        case ASTERISK:
          if (this.peekCodePoint(0) === EQUALS_SIGN) {
            this.consumeCodePoint();
            return SUBSTRING_MATCH_TOKEN;
          }
          break;
        case PLUS_SIGN:
          if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
            this.reconsumeCodePoint(codePoint);
            return this.consumeNumericToken();
          }
          break;
        case COMMA:
          return COMMA_TOKEN;
        case HYPHEN_MINUS:
          var e1 = codePoint;
          var e2 = this.peekCodePoint(0);
          var e3 = this.peekCodePoint(1);
          if (isNumberStart(e1, e2, e3)) {
            this.reconsumeCodePoint(codePoint);
            return this.consumeNumericToken();
          }
          if (isIdentifierStart(e1, e2, e3)) {
            this.reconsumeCodePoint(codePoint);
            return this.consumeIdentLikeToken();
          }
          if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
            this.consumeCodePoint();
            this.consumeCodePoint();
            return CDC_TOKEN;
          }
          break;
        case FULL_STOP:
          if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
            this.reconsumeCodePoint(codePoint);
            return this.consumeNumericToken();
          }
          break;
        case SOLIDUS:
          if (this.peekCodePoint(0) === ASTERISK) {
            this.consumeCodePoint();
            while (true) {
              var c4 = this.consumeCodePoint();
              if (c4 === ASTERISK) {
                c4 = this.consumeCodePoint();
                if (c4 === SOLIDUS) {
                  return this.consumeToken();
                }
              }
              if (c4 === EOF) {
                return this.consumeToken();
              }
            }
          }
          break;
        case COLON:
          return COLON_TOKEN;
        case SEMICOLON:
          return SEMICOLON_TOKEN;
        case LESS_THAN_SIGN:
          if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
            this.consumeCodePoint();
            this.consumeCodePoint();
            return CDO_TOKEN;
          }
          break;
        case COMMERCIAL_AT:
          var a1 = this.peekCodePoint(0);
          var a22 = this.peekCodePoint(1);
          var a3 = this.peekCodePoint(2);
          if (isIdentifierStart(a1, a22, a3)) {
            var value = this.consumeName();
            return { type: 7, value };
          }
          break;
        case LEFT_SQUARE_BRACKET:
          return LEFT_SQUARE_BRACKET_TOKEN;
        case REVERSE_SOLIDUS:
          if (isValidEscape(codePoint, this.peekCodePoint(0))) {
            this.reconsumeCodePoint(codePoint);
            return this.consumeIdentLikeToken();
          }
          break;
        case RIGHT_SQUARE_BRACKET:
          return RIGHT_SQUARE_BRACKET_TOKEN;
        case CIRCUMFLEX_ACCENT:
          if (this.peekCodePoint(0) === EQUALS_SIGN) {
            this.consumeCodePoint();
            return PREFIX_MATCH_TOKEN;
          }
          break;
        case LEFT_CURLY_BRACKET:
          return LEFT_CURLY_BRACKET_TOKEN;
        case RIGHT_CURLY_BRACKET:
          return RIGHT_CURLY_BRACKET_TOKEN;
        case u2:
        case U:
          var u1 = this.peekCodePoint(0);
          var u22 = this.peekCodePoint(1);
          if (u1 === PLUS_SIGN && (isHex(u22) || u22 === QUESTION_MARK)) {
            this.consumeCodePoint();
            this.consumeUnicodeRangeToken();
          }
          this.reconsumeCodePoint(codePoint);
          return this.consumeIdentLikeToken();
        case VERTICAL_LINE:
          if (this.peekCodePoint(0) === EQUALS_SIGN) {
            this.consumeCodePoint();
            return DASH_MATCH_TOKEN;
          }
          if (this.peekCodePoint(0) === VERTICAL_LINE) {
            this.consumeCodePoint();
            return COLUMN_TOKEN;
          }
          break;
        case TILDE:
          if (this.peekCodePoint(0) === EQUALS_SIGN) {
            this.consumeCodePoint();
            return INCLUDE_MATCH_TOKEN;
          }
          break;
        case EOF:
          return EOF_TOKEN;
      }
      if (isWhiteSpace(codePoint)) {
        this.consumeWhiteSpace();
        return WHITESPACE_TOKEN;
      }
      if (isDigit(codePoint)) {
        this.reconsumeCodePoint(codePoint);
        return this.consumeNumericToken();
      }
      if (isNameStartCodePoint(codePoint)) {
        this.reconsumeCodePoint(codePoint);
        return this.consumeIdentLikeToken();
      }
      return { type: 6, value: fromCodePoint$1(codePoint) };
    };
    Tokenizer2.prototype.consumeCodePoint = function() {
      var value = this._value.shift();
      return typeof value === "undefined" ? -1 : value;
    };
    Tokenizer2.prototype.reconsumeCodePoint = function(codePoint) {
      this._value.unshift(codePoint);
    };
    Tokenizer2.prototype.peekCodePoint = function(delta) {
      if (delta >= this._value.length) {
        return -1;
      }
      return this._value[delta];
    };
    Tokenizer2.prototype.consumeUnicodeRangeToken = function() {
      var digits = [];
      var codePoint = this.consumeCodePoint();
      while (isHex(codePoint) && digits.length < 6) {
        digits.push(codePoint);
        codePoint = this.consumeCodePoint();
      }
      var questionMarks = false;
      while (codePoint === QUESTION_MARK && digits.length < 6) {
        digits.push(codePoint);
        codePoint = this.consumeCodePoint();
        questionMarks = true;
      }
      if (questionMarks) {
        var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
          return digit === QUESTION_MARK ? ZERO : digit;
        })), 16);
        var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
          return digit === QUESTION_MARK ? F : digit;
        })), 16);
        return { type: 30, start: start_1, end };
      }
      var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
      if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
        this.consumeCodePoint();
        codePoint = this.consumeCodePoint();
        var endDigits = [];
        while (isHex(codePoint) && endDigits.length < 6) {
          endDigits.push(codePoint);
          codePoint = this.consumeCodePoint();
        }
        var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
        return { type: 30, start, end };
      } else {
        return { type: 30, start, end: start };
      }
    };
    Tokenizer2.prototype.consumeIdentLikeToken = function() {
      var value = this.consumeName();
      if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
        this.consumeCodePoint();
        return this.consumeUrlToken();
      } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
        this.consumeCodePoint();
        return { type: 19, value };
      }
      return { type: 20, value };
    };
    Tokenizer2.prototype.consumeUrlToken = function() {
      var value = [];
      this.consumeWhiteSpace();
      if (this.peekCodePoint(0) === EOF) {
        return { type: 22, value: "" };
      }
      var next = this.peekCodePoint(0);
      if (next === APOSTROPHE || next === QUOTATION_MARK) {
        var stringToken = this.consumeStringToken(this.consumeCodePoint());
        if (stringToken.type === 0) {
          this.consumeWhiteSpace();
          if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
            this.consumeCodePoint();
            return { type: 22, value: stringToken.value };
          }
        }
        this.consumeBadUrlRemnants();
        return BAD_URL_TOKEN;
      }
      while (true) {
        var codePoint = this.consumeCodePoint();
        if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
          return { type: 22, value: fromCodePoint$1.apply(void 0, value) };
        } else if (isWhiteSpace(codePoint)) {
          this.consumeWhiteSpace();
          if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
            this.consumeCodePoint();
            return { type: 22, value: fromCodePoint$1.apply(void 0, value) };
          }
          this.consumeBadUrlRemnants();
          return BAD_URL_TOKEN;
        } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
          this.consumeBadUrlRemnants();
          return BAD_URL_TOKEN;
        } else if (codePoint === REVERSE_SOLIDUS) {
          if (isValidEscape(codePoint, this.peekCodePoint(0))) {
            value.push(this.consumeEscapedCodePoint());
          } else {
            this.consumeBadUrlRemnants();
            return BAD_URL_TOKEN;
          }
        } else {
          value.push(codePoint);
        }
      }
    };
    Tokenizer2.prototype.consumeWhiteSpace = function() {
      while (isWhiteSpace(this.peekCodePoint(0))) {
        this.consumeCodePoint();
      }
    };
    Tokenizer2.prototype.consumeBadUrlRemnants = function() {
      while (true) {
        var codePoint = this.consumeCodePoint();
        if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
          return;
        }
        if (isValidEscape(codePoint, this.peekCodePoint(0))) {
          this.consumeEscapedCodePoint();
        }
      }
    };
    Tokenizer2.prototype.consumeStringSlice = function(count) {
      var SLICE_STACK_SIZE = 5e4;
      var value = "";
      while (count > 0) {
        var amount = Math.min(SLICE_STACK_SIZE, count);
        value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
        count -= amount;
      }
      this._value.shift();
      return value;
    };
    Tokenizer2.prototype.consumeStringToken = function(endingCodePoint) {
      var value = "";
      var i2 = 0;
      do {
        var codePoint = this._value[i2];
        if (codePoint === EOF || codePoint === void 0 || codePoint === endingCodePoint) {
          value += this.consumeStringSlice(i2);
          return { type: 0, value };
        }
        if (codePoint === LINE_FEED) {
          this._value.splice(0, i2);
          return BAD_STRING_TOKEN;
        }
        if (codePoint === REVERSE_SOLIDUS) {
          var next = this._value[i2 + 1];
          if (next !== EOF && next !== void 0) {
            if (next === LINE_FEED) {
              value += this.consumeStringSlice(i2);
              i2 = -1;
              this._value.shift();
            } else if (isValidEscape(codePoint, next)) {
              value += this.consumeStringSlice(i2);
              value += fromCodePoint$1(this.consumeEscapedCodePoint());
              i2 = -1;
            }
          }
        }
        i2++;
      } while (true);
    };
    Tokenizer2.prototype.consumeNumber = function() {
      var repr = [];
      var type = FLAG_INTEGER;
      var c1 = this.peekCodePoint(0);
      if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
        repr.push(this.consumeCodePoint());
      }
      while (isDigit(this.peekCodePoint(0))) {
        repr.push(this.consumeCodePoint());
      }
      c1 = this.peekCodePoint(0);
      var c2 = this.peekCodePoint(1);
      if (c1 === FULL_STOP && isDigit(c2)) {
        repr.push(this.consumeCodePoint(), this.consumeCodePoint());
        type = FLAG_NUMBER;
        while (isDigit(this.peekCodePoint(0))) {
          repr.push(this.consumeCodePoint());
        }
      }
      c1 = this.peekCodePoint(0);
      c2 = this.peekCodePoint(1);
      var c3 = this.peekCodePoint(2);
      if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
        repr.push(this.consumeCodePoint(), this.consumeCodePoint());
        type = FLAG_NUMBER;
        while (isDigit(this.peekCodePoint(0))) {
          repr.push(this.consumeCodePoint());
        }
      }
      return [stringToNumber(repr), type];
    };
    Tokenizer2.prototype.consumeNumericToken = function() {
      var _a2 = this.consumeNumber(), number = _a2[0], flags = _a2[1];
      var c1 = this.peekCodePoint(0);
      var c2 = this.peekCodePoint(1);
      var c3 = this.peekCodePoint(2);
      if (isIdentifierStart(c1, c2, c3)) {
        var unit = this.consumeName();
        return { type: 15, number, flags, unit };
      }
      if (c1 === PERCENTAGE_SIGN) {
        this.consumeCodePoint();
        return { type: 16, number, flags };
      }
      return { type: 17, number, flags };
    };
    Tokenizer2.prototype.consumeEscapedCodePoint = function() {
      var codePoint = this.consumeCodePoint();
      if (isHex(codePoint)) {
        var hex = fromCodePoint$1(codePoint);
        while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
          hex += fromCodePoint$1(this.consumeCodePoint());
        }
        if (isWhiteSpace(this.peekCodePoint(0))) {
          this.consumeCodePoint();
        }
        var hexCodePoint = parseInt(hex, 16);
        if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 1114111) {
          return REPLACEMENT_CHARACTER;
        }
        return hexCodePoint;
      }
      if (codePoint === EOF) {
        return REPLACEMENT_CHARACTER;
      }
      return codePoint;
    };
    Tokenizer2.prototype.consumeName = function() {
      var result = "";
      while (true) {
        var codePoint = this.consumeCodePoint();
        if (isNameCodePoint(codePoint)) {
          result += fromCodePoint$1(codePoint);
        } else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
          result += fromCodePoint$1(this.consumeEscapedCodePoint());
        } else {
          this.reconsumeCodePoint(codePoint);
          return result;
        }
      }
    };
    return Tokenizer2;
  }()
);
var Parser = (
  /** @class */
  function() {
    function Parser2(tokens) {
      this._tokens = tokens;
    }
    Parser2.create = function(value) {
      var tokenizer = new Tokenizer();
      tokenizer.write(value);
      return new Parser2(tokenizer.read());
    };
    Parser2.parseValue = function(value) {
      return Parser2.create(value).parseComponentValue();
    };
    Parser2.parseValues = function(value) {
      return Parser2.create(value).parseComponentValues();
    };
    Parser2.prototype.parseComponentValue = function() {
      var token = this.consumeToken();
      while (token.type === 31) {
        token = this.consumeToken();
      }
      if (token.type === 32) {
        throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
      }
      this.reconsumeToken(token);
      var value = this.consumeComponentValue();
      do {
        token = this.consumeToken();
      } while (token.type === 31);
      if (token.type === 32) {
        return value;
      }
      throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
    };
    Parser2.prototype.parseComponentValues = function() {
      var values = [];
      while (true) {
        var value = this.consumeComponentValue();
        if (value.type === 32) {
          return values;
        }
        values.push(value);
        values.push();
      }
    };
    Parser2.prototype.consumeComponentValue = function() {
      var token = this.consumeToken();
      switch (token.type) {
        case 11:
        case 28:
        case 2:
          return this.consumeSimpleBlock(token.type);
        case 19:
          return this.consumeFunction(token);
      }
      return token;
    };
    Parser2.prototype.consumeSimpleBlock = function(type) {
      var block = { type, values: [] };
      var token = this.consumeToken();
      while (true) {
        if (token.type === 32 || isEndingTokenFor(token, type)) {
          return block;
        }
        this.reconsumeToken(token);
        block.values.push(this.consumeComponentValue());
        token = this.consumeToken();
      }
    };
    Parser2.prototype.consumeFunction = function(functionToken) {
      var cssFunction = {
        name: functionToken.value,
        values: [],
        type: 18
        /* FUNCTION */
      };
      while (true) {
        var token = this.consumeToken();
        if (token.type === 32 || token.type === 3) {
          return cssFunction;
        }
        this.reconsumeToken(token);
        cssFunction.values.push(this.consumeComponentValue());
      }
    };
    Parser2.prototype.consumeToken = function() {
      var token = this._tokens.shift();
      return typeof token === "undefined" ? EOF_TOKEN : token;
    };
    Parser2.prototype.reconsumeToken = function(token) {
      this._tokens.unshift(token);
    };
    return Parser2;
  }()
);
var isDimensionToken = function(token) {
  return token.type === 15;
};
var isNumberToken = function(token) {
  return token.type === 17;
};
var isIdentToken = function(token) {
  return token.type === 20;
};
var isStringToken = function(token) {
  return token.type === 0;
};
var isIdentWithValue = function(token, value) {
  return isIdentToken(token) && token.value === value;
};
var nonWhiteSpace = function(token) {
  return token.type !== 31;
};
var nonFunctionArgSeparator = function(token) {
  return token.type !== 31 && token.type !== 4;
};
var parseFunctionArgs = function(tokens) {
  var args = [];
  var arg = [];
  tokens.forEach(function(token) {
    if (token.type === 4) {
      if (arg.length === 0) {
        throw new Error("Error parsing function args, zero tokens for arg");
      }
      args.push(arg);
      arg = [];
      return;
    }
    if (token.type !== 31) {
      arg.push(token);
    }
  });
  if (arg.length) {
    args.push(arg);
  }
  return args;
};
var isEndingTokenFor = function(token, type) {
  if (type === 11 && token.type === 12) {
    return true;
  }
  if (type === 28 && token.type === 29) {
    return true;
  }
  return type === 2 && token.type === 3;
};
var isLength = function(token) {
  return token.type === 17 || token.type === 15;
};
var isLengthPercentage = function(token) {
  return token.type === 16 || isLength(token);
};
var parseLengthPercentageTuple = function(tokens) {
  return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
};
var ZERO_LENGTH = {
  type: 17,
  number: 0,
  flags: FLAG_INTEGER
};
var FIFTY_PERCENT = {
  type: 16,
  number: 50,
  flags: FLAG_INTEGER
};
var HUNDRED_PERCENT = {
  type: 16,
  number: 100,
  flags: FLAG_INTEGER
};
var getAbsoluteValueForTuple = function(tuple, width, height) {
  var x = tuple[0], y = tuple[1];
  return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== "undefined" ? y : x, height)];
};
var getAbsoluteValue = function(token, parent2) {
  if (token.type === 16) {
    return token.number / 100 * parent2;
  }
  if (isDimensionToken(token)) {
    switch (token.unit) {
      case "rem":
      case "em":
        return 16 * token.number;
      case "px":
      default:
        return token.number;
    }
  }
  return token.number;
};
var DEG = "deg";
var GRAD = "grad";
var RAD = "rad";
var TURN = "turn";
var angle = {
  name: "angle",
  parse: function(_context2, value) {
    if (value.type === 15) {
      switch (value.unit) {
        case DEG:
          return Math.PI * value.number / 180;
        case GRAD:
          return Math.PI / 200 * value.number;
        case RAD:
          return value.number;
        case TURN:
          return Math.PI * 2 * value.number;
      }
    }
    throw new Error("Unsupported angle type");
  }
};
var isAngle = function(value) {
  if (value.type === 15) {
    if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
      return true;
    }
  }
  return false;
};
var parseNamedSide = function(tokens) {
  var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
    return ident.value;
  }).join(" ");
  switch (sideOrCorner) {
    case "to bottom right":
    case "to right bottom":
    case "left top":
    case "top left":
      return [ZERO_LENGTH, ZERO_LENGTH];
    case "to top":
    case "bottom":
      return deg(0);
    case "to bottom left":
    case "to left bottom":
    case "right top":
    case "top right":
      return [ZERO_LENGTH, HUNDRED_PERCENT];
    case "to right":
    case "left":
      return deg(90);
    case "to top left":
    case "to left top":
    case "right bottom":
    case "bottom right":
      return [HUNDRED_PERCENT, HUNDRED_PERCENT];
    case "to bottom":
    case "top":
      return deg(180);
    case "to top right":
    case "to right top":
    case "left bottom":
    case "bottom left":
      return [HUNDRED_PERCENT, ZERO_LENGTH];
    case "to left":
    case "right":
      return deg(270);
  }
  return 0;
};
var deg = function(deg2) {
  return Math.PI * deg2 / 180;
};
var color$1 = {
  name: "color",
  parse: function(context, value) {
    if (value.type === 18) {
      var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
      if (typeof colorFunction === "undefined") {
        throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
      }
      return colorFunction(context, value.values);
    }
    if (value.type === 5) {
      if (value.value.length === 3) {
        var r2 = value.value.substring(0, 1);
        var g3 = value.value.substring(1, 2);
        var b = value.value.substring(2, 3);
        return pack(parseInt(r2 + r2, 16), parseInt(g3 + g3, 16), parseInt(b + b, 16), 1);
      }
      if (value.value.length === 4) {
        var r2 = value.value.substring(0, 1);
        var g3 = value.value.substring(1, 2);
        var b = value.value.substring(2, 3);
        var a3 = value.value.substring(3, 4);
        return pack(parseInt(r2 + r2, 16), parseInt(g3 + g3, 16), parseInt(b + b, 16), parseInt(a3 + a3, 16) / 255);
      }
      if (value.value.length === 6) {
        var r2 = value.value.substring(0, 2);
        var g3 = value.value.substring(2, 4);
        var b = value.value.substring(4, 6);
        return pack(parseInt(r2, 16), parseInt(g3, 16), parseInt(b, 16), 1);
      }
      if (value.value.length === 8) {
        var r2 = value.value.substring(0, 2);
        var g3 = value.value.substring(2, 4);
        var b = value.value.substring(4, 6);
        var a3 = value.value.substring(6, 8);
        return pack(parseInt(r2, 16), parseInt(g3, 16), parseInt(b, 16), parseInt(a3, 16) / 255);
      }
    }
    if (value.type === 20) {
      var namedColor = COLORS[value.value.toUpperCase()];
      if (typeof namedColor !== "undefined") {
        return namedColor;
      }
    }
    return COLORS.TRANSPARENT;
  }
};
var isTransparent = function(color2) {
  return (255 & color2) === 0;
};
var asString = function(color2) {
  var alpha = 255 & color2;
  var blue = 255 & color2 >> 8;
  var green = 255 & color2 >> 16;
  var red = 255 & color2 >> 24;
  return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
};
var pack = function(r2, g3, b, a3) {
  return (r2 << 24 | g3 << 16 | b << 8 | Math.round(a3 * 255) << 0) >>> 0;
};
var getTokenColorValue = function(token, i2) {
  if (token.type === 17) {
    return token.number;
  }
  if (token.type === 16) {
    var max2 = i2 === 3 ? 1 : 255;
    return i2 === 3 ? token.number / 100 * max2 : Math.round(token.number / 100 * max2);
  }
  return 0;
};
var rgb = function(_context2, args) {
  var tokens = args.filter(nonFunctionArgSeparator);
  if (tokens.length === 3) {
    var _a2 = tokens.map(getTokenColorValue), r2 = _a2[0], g3 = _a2[1], b = _a2[2];
    return pack(r2, g3, b, 1);
  }
  if (tokens.length === 4) {
    var _b2 = tokens.map(getTokenColorValue), r2 = _b2[0], g3 = _b2[1], b = _b2[2], a3 = _b2[3];
    return pack(r2, g3, b, a3);
  }
  return 0;
};
function hue2rgb(t1, t22, hue) {
  if (hue < 0) {
    hue += 1;
  }
  if (hue >= 1) {
    hue -= 1;
  }
  if (hue < 1 / 6) {
    return (t22 - t1) * hue * 6 + t1;
  } else if (hue < 1 / 2) {
    return t22;
  } else if (hue < 2 / 3) {
    return (t22 - t1) * 6 * (2 / 3 - hue) + t1;
  } else {
    return t1;
  }
}
var hsl = function(context, args) {
  var tokens = args.filter(nonFunctionArgSeparator);
  var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
  var h2 = (hue.type === 17 ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
  var s2 = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
  var l2 = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
  var a3 = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
  if (s2 === 0) {
    return pack(l2 * 255, l2 * 255, l2 * 255, 1);
  }
  var t22 = l2 <= 0.5 ? l2 * (s2 + 1) : l2 + s2 - l2 * s2;
  var t1 = l2 * 2 - t22;
  var r2 = hue2rgb(t1, t22, h2 + 1 / 3);
  var g3 = hue2rgb(t1, t22, h2);
  var b = hue2rgb(t1, t22, h2 - 1 / 3);
  return pack(r2 * 255, g3 * 255, b * 255, a3);
};
var SUPPORTED_COLOR_FUNCTIONS = {
  hsl,
  hsla: hsl,
  rgb,
  rgba: rgb
};
var parseColor = function(context, value) {
  return color$1.parse(context, Parser.create(value).parseComponentValue());
};
var COLORS = {
  ALICEBLUE: 4042850303,
  ANTIQUEWHITE: 4209760255,
  AQUA: 16777215,
  AQUAMARINE: 2147472639,
  AZURE: 4043309055,
  BEIGE: 4126530815,
  BISQUE: 4293182719,
  BLACK: 255,
  BLANCHEDALMOND: 4293643775,
  BLUE: 65535,
  BLUEVIOLET: 2318131967,
  BROWN: 2771004159,
  BURLYWOOD: 3736635391,
  CADETBLUE: 1604231423,
  CHARTREUSE: 2147418367,
  CHOCOLATE: 3530104575,
  CORAL: 4286533887,
  CORNFLOWERBLUE: 1687547391,
  CORNSILK: 4294499583,
  CRIMSON: 3692313855,
  CYAN: 16777215,
  DARKBLUE: 35839,
  DARKCYAN: 9145343,
  DARKGOLDENROD: 3095837695,
  DARKGRAY: 2846468607,
  DARKGREEN: 6553855,
  DARKGREY: 2846468607,
  DARKKHAKI: 3182914559,
  DARKMAGENTA: 2332068863,
  DARKOLIVEGREEN: 1433087999,
  DARKORANGE: 4287365375,
  DARKORCHID: 2570243327,
  DARKRED: 2332033279,
  DARKSALMON: 3918953215,
  DARKSEAGREEN: 2411499519,
  DARKSLATEBLUE: 1211993087,
  DARKSLATEGRAY: 793726975,
  DARKSLATEGREY: 793726975,
  DARKTURQUOISE: 13554175,
  DARKVIOLET: 2483082239,
  DEEPPINK: 4279538687,
  DEEPSKYBLUE: 12582911,
  DIMGRAY: 1768516095,
  DIMGREY: 1768516095,
  DODGERBLUE: 512819199,
  FIREBRICK: 2988581631,
  FLORALWHITE: 4294635775,
  FORESTGREEN: 579543807,
  FUCHSIA: 4278255615,
  GAINSBORO: 3705462015,
  GHOSTWHITE: 4177068031,
  GOLD: 4292280575,
  GOLDENROD: 3668254975,
  GRAY: 2155905279,
  GREEN: 8388863,
  GREENYELLOW: 2919182335,
  GREY: 2155905279,
  HONEYDEW: 4043305215,
  HOTPINK: 4285117695,
  INDIANRED: 3445382399,
  INDIGO: 1258324735,
  IVORY: 4294963455,
  KHAKI: 4041641215,
  LAVENDER: 3873897215,
  LAVENDERBLUSH: 4293981695,
  LAWNGREEN: 2096890111,
  LEMONCHIFFON: 4294626815,
  LIGHTBLUE: 2916673279,
  LIGHTCORAL: 4034953471,
  LIGHTCYAN: 3774873599,
  LIGHTGOLDENRODYELLOW: 4210742015,
  LIGHTGRAY: 3553874943,
  LIGHTGREEN: 2431553791,
  LIGHTGREY: 3553874943,
  LIGHTPINK: 4290167295,
  LIGHTSALMON: 4288707327,
  LIGHTSEAGREEN: 548580095,
  LIGHTSKYBLUE: 2278488831,
  LIGHTSLATEGRAY: 2005441023,
  LIGHTSLATEGREY: 2005441023,
  LIGHTSTEELBLUE: 2965692159,
  LIGHTYELLOW: 4294959359,
  LIME: 16711935,
  LIMEGREEN: 852308735,
  LINEN: 4210091775,
  MAGENTA: 4278255615,
  MAROON: 2147483903,
  MEDIUMAQUAMARINE: 1724754687,
  MEDIUMBLUE: 52735,
  MEDIUMORCHID: 3126187007,
  MEDIUMPURPLE: 2473647103,
  MEDIUMSEAGREEN: 1018393087,
  MEDIUMSLATEBLUE: 2070474495,
  MEDIUMSPRINGGREEN: 16423679,
  MEDIUMTURQUOISE: 1221709055,
  MEDIUMVIOLETRED: 3340076543,
  MIDNIGHTBLUE: 421097727,
  MINTCREAM: 4127193855,
  MISTYROSE: 4293190143,
  MOCCASIN: 4293178879,
  NAVAJOWHITE: 4292783615,
  NAVY: 33023,
  OLDLACE: 4260751103,
  OLIVE: 2155872511,
  OLIVEDRAB: 1804477439,
  ORANGE: 4289003775,
  ORANGERED: 4282712319,
  ORCHID: 3664828159,
  PALEGOLDENROD: 4008225535,
  PALEGREEN: 2566625535,
  PALETURQUOISE: 2951671551,
  PALEVIOLETRED: 3681588223,
  PAPAYAWHIP: 4293907967,
  PEACHPUFF: 4292524543,
  PERU: 3448061951,
  PINK: 4290825215,
  PLUM: 3718307327,
  POWDERBLUE: 2967529215,
  PURPLE: 2147516671,
  REBECCAPURPLE: 1714657791,
  RED: 4278190335,
  ROSYBROWN: 3163525119,
  ROYALBLUE: 1097458175,
  SADDLEBROWN: 2336560127,
  SALMON: 4202722047,
  SANDYBROWN: 4104413439,
  SEAGREEN: 780883967,
  SEASHELL: 4294307583,
  SIENNA: 2689740287,
  SILVER: 3233857791,
  SKYBLUE: 2278484991,
  SLATEBLUE: 1784335871,
  SLATEGRAY: 1887473919,
  SLATEGREY: 1887473919,
  SNOW: 4294638335,
  SPRINGGREEN: 16744447,
  STEELBLUE: 1182971135,
  TAN: 3535047935,
  TEAL: 8421631,
  THISTLE: 3636451583,
  TOMATO: 4284696575,
  TRANSPARENT: 0,
  TURQUOISE: 1088475391,
  VIOLET: 4001558271,
  WHEAT: 4125012991,
  WHITE: 4294967295,
  WHITESMOKE: 4126537215,
  YELLOW: 4294902015,
  YELLOWGREEN: 2597139199
};
var backgroundClip = {
  name: "background-clip",
  initialValue: "border-box",
  prefix: false,
  type: 1,
  parse: function(_context2, tokens) {
    return tokens.map(function(token) {
      if (isIdentToken(token)) {
        switch (token.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      }
      return 0;
    });
  }
};
var backgroundColor = {
  name: "background-color",
  initialValue: "transparent",
  prefix: false,
  type: 3,
  format: "color"
};
var parseColorStop = function(context, args) {
  var color2 = color$1.parse(context, args[0]);
  var stop = args[1];
  return stop && isLengthPercentage(stop) ? { color: color2, stop } : { color: color2, stop: null };
};
var processColorStops = function(stops, lineLength) {
  var first = stops[0];
  var last = stops[stops.length - 1];
  if (first.stop === null) {
    first.stop = ZERO_LENGTH;
  }
  if (last.stop === null) {
    last.stop = HUNDRED_PERCENT;
  }
  var processStops = [];
  var previous = 0;
  for (var i2 = 0; i2 < stops.length; i2++) {
    var stop_1 = stops[i2].stop;
    if (stop_1 !== null) {
      var absoluteValue = getAbsoluteValue(stop_1, lineLength);
      if (absoluteValue > previous) {
        processStops.push(absoluteValue);
      } else {
        processStops.push(previous);
      }
      previous = absoluteValue;
    } else {
      processStops.push(null);
    }
  }
  var gapBegin = null;
  for (var i2 = 0; i2 < processStops.length; i2++) {
    var stop_2 = processStops[i2];
    if (stop_2 === null) {
      if (gapBegin === null) {
        gapBegin = i2;
      }
    } else if (gapBegin !== null) {
      var gapLength = i2 - gapBegin;
      var beforeGap = processStops[gapBegin - 1];
      var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
      for (var g3 = 1; g3 <= gapLength; g3++) {
        processStops[gapBegin + g3 - 1] = gapValue * g3;
      }
      gapBegin = null;
    }
  }
  return stops.map(function(_a2, i3) {
    var color2 = _a2.color;
    return { color: color2, stop: Math.max(Math.min(1, processStops[i3] / lineLength), 0) };
  });
};
var getAngleFromCorner = function(corner, width, height) {
  var centerX = width / 2;
  var centerY = height / 2;
  var x = getAbsoluteValue(corner[0], width) - centerX;
  var y = centerY - getAbsoluteValue(corner[1], height);
  return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
};
var calculateGradientDirection = function(angle2, width, height) {
  var radian = typeof angle2 === "number" ? angle2 : getAngleFromCorner(angle2, width, height);
  var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
  var halfWidth = width / 2;
  var halfHeight = height / 2;
  var halfLineLength = lineLength / 2;
  var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
  var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
  return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
};
var distance = function(a3, b) {
  return Math.sqrt(a3 * a3 + b * b);
};
var findCorner = function(width, height, x, y, closest) {
  var corners = [
    [0, 0],
    [0, height],
    [width, 0],
    [width, height]
  ];
  return corners.reduce(function(stat, corner) {
    var cx = corner[0], cy = corner[1];
    var d2 = distance(x - cx, y - cy);
    if (closest ? d2 < stat.optimumDistance : d2 > stat.optimumDistance) {
      return {
        optimumCorner: corner,
        optimumDistance: d2
      };
    }
    return stat;
  }, {
    optimumDistance: closest ? Infinity : -Infinity,
    optimumCorner: null
  }).optimumCorner;
};
var calculateRadius = function(gradient, x, y, width, height) {
  var rx = 0;
  var ry = 0;
  switch (gradient.size) {
    case 0:
      if (gradient.shape === 0) {
        rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
      } else if (gradient.shape === 1) {
        rx = Math.min(Math.abs(x), Math.abs(x - width));
        ry = Math.min(Math.abs(y), Math.abs(y - height));
      }
      break;
    case 2:
      if (gradient.shape === 0) {
        rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
      } else if (gradient.shape === 1) {
        var c2 = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
        var _a2 = findCorner(width, height, x, y, true), cx = _a2[0], cy = _a2[1];
        rx = distance(cx - x, (cy - y) / c2);
        ry = c2 * rx;
      }
      break;
    case 1:
      if (gradient.shape === 0) {
        rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
      } else if (gradient.shape === 1) {
        rx = Math.max(Math.abs(x), Math.abs(x - width));
        ry = Math.max(Math.abs(y), Math.abs(y - height));
      }
      break;
    case 3:
      if (gradient.shape === 0) {
        rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
      } else if (gradient.shape === 1) {
        var c2 = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
        var _b2 = findCorner(width, height, x, y, false), cx = _b2[0], cy = _b2[1];
        rx = distance(cx - x, (cy - y) / c2);
        ry = c2 * rx;
      }
      break;
  }
  if (Array.isArray(gradient.size)) {
    rx = getAbsoluteValue(gradient.size[0], width);
    ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
  }
  return [rx, ry];
};
var linearGradient = function(context, tokens) {
  var angle$1 = deg(180);
  var stops = [];
  parseFunctionArgs(tokens).forEach(function(arg, i2) {
    if (i2 === 0) {
      var firstToken = arg[0];
      if (firstToken.type === 20 && firstToken.value === "to") {
        angle$1 = parseNamedSide(arg);
        return;
      } else if (isAngle(firstToken)) {
        angle$1 = angle.parse(context, firstToken);
        return;
      }
    }
    var colorStop = parseColorStop(context, arg);
    stops.push(colorStop);
  });
  return {
    angle: angle$1,
    stops,
    type: 1
    /* LINEAR_GRADIENT */
  };
};
var prefixLinearGradient = function(context, tokens) {
  var angle$1 = deg(180);
  var stops = [];
  parseFunctionArgs(tokens).forEach(function(arg, i2) {
    if (i2 === 0) {
      var firstToken = arg[0];
      if (firstToken.type === 20 && ["top", "left", "right", "bottom"].indexOf(firstToken.value) !== -1) {
        angle$1 = parseNamedSide(arg);
        return;
      } else if (isAngle(firstToken)) {
        angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
        return;
      }
    }
    var colorStop = parseColorStop(context, arg);
    stops.push(colorStop);
  });
  return {
    angle: angle$1,
    stops,
    type: 1
    /* LINEAR_GRADIENT */
  };
};
var webkitGradient = function(context, tokens) {
  var angle2 = deg(180);
  var stops = [];
  var type = 1;
  var shape = 0;
  var size = 3;
  var position2 = [];
  parseFunctionArgs(tokens).forEach(function(arg, i2) {
    var firstToken = arg[0];
    if (i2 === 0) {
      if (isIdentToken(firstToken) && firstToken.value === "linear") {
        type = 1;
        return;
      } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
        type = 2;
        return;
      }
    }
    if (firstToken.type === 18) {
      if (firstToken.name === "from") {
        var color2 = color$1.parse(context, firstToken.values[0]);
        stops.push({ stop: ZERO_LENGTH, color: color2 });
      } else if (firstToken.name === "to") {
        var color2 = color$1.parse(context, firstToken.values[0]);
        stops.push({ stop: HUNDRED_PERCENT, color: color2 });
      } else if (firstToken.name === "color-stop") {
        var values = firstToken.values.filter(nonFunctionArgSeparator);
        if (values.length === 2) {
          var color2 = color$1.parse(context, values[1]);
          var stop_1 = values[0];
          if (isNumberToken(stop_1)) {
            stops.push({
              stop: { type: 16, number: stop_1.number * 100, flags: stop_1.flags },
              color: color2
            });
          }
        }
      }
    }
  });
  return type === 1 ? {
    angle: (angle2 + deg(180)) % deg(360),
    stops,
    type
  } : { size, shape, stops, position: position2, type };
};
var CLOSEST_SIDE = "closest-side";
var FARTHEST_SIDE = "farthest-side";
var CLOSEST_CORNER = "closest-corner";
var FARTHEST_CORNER = "farthest-corner";
var CIRCLE = "circle";
var ELLIPSE = "ellipse";
var COVER = "cover";
var CONTAIN = "contain";
var radialGradient = function(context, tokens) {
  var shape = 0;
  var size = 3;
  var stops = [];
  var position2 = [];
  parseFunctionArgs(tokens).forEach(function(arg, i2) {
    var isColorStop = true;
    if (i2 === 0) {
      var isAtPosition_1 = false;
      isColorStop = arg.reduce(function(acc, token) {
        if (isAtPosition_1) {
          if (isIdentToken(token)) {
            switch (token.value) {
              case "center":
                position2.push(FIFTY_PERCENT);
                return acc;
              case "top":
              case "left":
                position2.push(ZERO_LENGTH);
                return acc;
              case "right":
              case "bottom":
                position2.push(HUNDRED_PERCENT);
                return acc;
            }
          } else if (isLengthPercentage(token) || isLength(token)) {
            position2.push(token);
          }
        } else if (isIdentToken(token)) {
          switch (token.value) {
            case CIRCLE:
              shape = 0;
              return false;
            case ELLIPSE:
              shape = 1;
              return false;
            case "at":
              isAtPosition_1 = true;
              return false;
            case CLOSEST_SIDE:
              size = 0;
              return false;
            case COVER:
            case FARTHEST_SIDE:
              size = 1;
              return false;
            case CONTAIN:
            case CLOSEST_CORNER:
              size = 2;
              return false;
            case FARTHEST_CORNER:
              size = 3;
              return false;
          }
        } else if (isLength(token) || isLengthPercentage(token)) {
          if (!Array.isArray(size)) {
            size = [];
          }
          size.push(token);
          return false;
        }
        return acc;
      }, isColorStop);
    }
    if (isColorStop) {
      var colorStop = parseColorStop(context, arg);
      stops.push(colorStop);
    }
  });
  return {
    size,
    shape,
    stops,
    position: position2,
    type: 2
    /* RADIAL_GRADIENT */
  };
};
var prefixRadialGradient = function(context, tokens) {
  var shape = 0;
  var size = 3;
  var stops = [];
  var position2 = [];
  parseFunctionArgs(tokens).forEach(function(arg, i2) {
    var isColorStop = true;
    if (i2 === 0) {
      isColorStop = arg.reduce(function(acc, token) {
        if (isIdentToken(token)) {
          switch (token.value) {
            case "center":
              position2.push(FIFTY_PERCENT);
              return false;
            case "top":
            case "left":
              position2.push(ZERO_LENGTH);
              return false;
            case "right":
            case "bottom":
              position2.push(HUNDRED_PERCENT);
              return false;
          }
        } else if (isLengthPercentage(token) || isLength(token)) {
          position2.push(token);
          return false;
        }
        return acc;
      }, isColorStop);
    } else if (i2 === 1) {
      isColorStop = arg.reduce(function(acc, token) {
        if (isIdentToken(token)) {
          switch (token.value) {
            case CIRCLE:
              shape = 0;
              return false;
            case ELLIPSE:
              shape = 1;
              return false;
            case CONTAIN:
            case CLOSEST_SIDE:
              size = 0;
              return false;
            case FARTHEST_SIDE:
              size = 1;
              return false;
            case CLOSEST_CORNER:
              size = 2;
              return false;
            case COVER:
            case FARTHEST_CORNER:
              size = 3;
              return false;
          }
        } else if (isLength(token) || isLengthPercentage(token)) {
          if (!Array.isArray(size)) {
            size = [];
          }
          size.push(token);
          return false;
        }
        return acc;
      }, isColorStop);
    }
    if (isColorStop) {
      var colorStop = parseColorStop(context, arg);
      stops.push(colorStop);
    }
  });
  return {
    size,
    shape,
    stops,
    position: position2,
    type: 2
    /* RADIAL_GRADIENT */
  };
};
var isLinearGradient = function(background) {
  return background.type === 1;
};
var isRadialGradient = function(background) {
  return background.type === 2;
};
var image = {
  name: "image",
  parse: function(context, value) {
    if (value.type === 22) {
      var image_1 = {
        url: value.value,
        type: 0
        /* URL */
      };
      context.cache.addImage(value.value);
      return image_1;
    }
    if (value.type === 18) {
      var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
      if (typeof imageFunction === "undefined") {
        throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
      }
      return imageFunction(context, value.values);
    }
    throw new Error("Unsupported image type " + value.type);
  }
};
function isSupportedImage(value) {
  return !(value.type === 20 && value.value === "none") && (value.type !== 18 || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
}
var SUPPORTED_IMAGE_FUNCTIONS = {
  "linear-gradient": linearGradient,
  "-moz-linear-gradient": prefixLinearGradient,
  "-ms-linear-gradient": prefixLinearGradient,
  "-o-linear-gradient": prefixLinearGradient,
  "-webkit-linear-gradient": prefixLinearGradient,
  "radial-gradient": radialGradient,
  "-moz-radial-gradient": prefixRadialGradient,
  "-ms-radial-gradient": prefixRadialGradient,
  "-o-radial-gradient": prefixRadialGradient,
  "-webkit-radial-gradient": prefixRadialGradient,
  "-webkit-gradient": webkitGradient
};
var backgroundImage = {
  name: "background-image",
  initialValue: "none",
  type: 1,
  prefix: false,
  parse: function(context, tokens) {
    if (tokens.length === 0) {
      return [];
    }
    var first = tokens[0];
    if (first.type === 20 && first.value === "none") {
      return [];
    }
    return tokens.filter(function(value) {
      return nonFunctionArgSeparator(value) && isSupportedImage(value);
    }).map(function(value) {
      return image.parse(context, value);
    });
  }
};
var backgroundOrigin = {
  name: "background-origin",
  initialValue: "border-box",
  prefix: false,
  type: 1,
  parse: function(_context2, tokens) {
    return tokens.map(function(token) {
      if (isIdentToken(token)) {
        switch (token.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      }
      return 0;
    });
  }
};
var backgroundPosition = {
  name: "background-position",
  initialValue: "0% 0%",
  type: 1,
  prefix: false,
  parse: function(_context2, tokens) {
    return parseFunctionArgs(tokens).map(function(values) {
      return values.filter(isLengthPercentage);
    }).map(parseLengthPercentageTuple);
  }
};
var backgroundRepeat = {
  name: "background-repeat",
  initialValue: "repeat",
  prefix: false,
  type: 1,
  parse: function(_context2, tokens) {
    return parseFunctionArgs(tokens).map(function(values) {
      return values.filter(isIdentToken).map(function(token) {
        return token.value;
      }).join(" ");
    }).map(parseBackgroundRepeat);
  }
};
var parseBackgroundRepeat = function(value) {
  switch (value) {
    case "no-repeat":
      return 1;
    case "repeat-x":
    case "repeat no-repeat":
      return 2;
    case "repeat-y":
    case "no-repeat repeat":
      return 3;
    case "repeat":
    default:
      return 0;
  }
};
var BACKGROUND_SIZE;
(function(BACKGROUND_SIZE2) {
  BACKGROUND_SIZE2["AUTO"] = "auto";
  BACKGROUND_SIZE2["CONTAIN"] = "contain";
  BACKGROUND_SIZE2["COVER"] = "cover";
})(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
var backgroundSize = {
  name: "background-size",
  initialValue: "0",
  prefix: false,
  type: 1,
  parse: function(_context2, tokens) {
    return parseFunctionArgs(tokens).map(function(values) {
      return values.filter(isBackgroundSizeInfoToken);
    });
  }
};
var isBackgroundSizeInfoToken = function(value) {
  return isIdentToken(value) || isLengthPercentage(value);
};
var borderColorForSide = function(side) {
  return {
    name: "border-" + side + "-color",
    initialValue: "transparent",
    prefix: false,
    type: 3,
    format: "color"
  };
};
var borderTopColor = borderColorForSide("top");
var borderRightColor = borderColorForSide("right");
var borderBottomColor = borderColorForSide("bottom");
var borderLeftColor = borderColorForSide("left");
var borderRadiusForSide = function(side) {
  return {
    name: "border-radius-" + side,
    initialValue: "0 0",
    prefix: false,
    type: 1,
    parse: function(_context2, tokens) {
      return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
    }
  };
};
var borderTopLeftRadius = borderRadiusForSide("top-left");
var borderTopRightRadius = borderRadiusForSide("top-right");
var borderBottomRightRadius = borderRadiusForSide("bottom-right");
var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
var borderStyleForSide = function(side) {
  return {
    name: "border-" + side + "-style",
    initialValue: "solid",
    prefix: false,
    type: 2,
    parse: function(_context2, style) {
      switch (style) {
        case "none":
          return 0;
        case "dashed":
          return 2;
        case "dotted":
          return 3;
        case "double":
          return 4;
      }
      return 1;
    }
  };
};
var borderTopStyle = borderStyleForSide("top");
var borderRightStyle = borderStyleForSide("right");
var borderBottomStyle = borderStyleForSide("bottom");
var borderLeftStyle = borderStyleForSide("left");
var borderWidthForSide = function(side) {
  return {
    name: "border-" + side + "-width",
    initialValue: "0",
    type: 0,
    prefix: false,
    parse: function(_context2, token) {
      if (isDimensionToken(token)) {
        return token.number;
      }
      return 0;
    }
  };
};
var borderTopWidth = borderWidthForSide("top");
var borderRightWidth = borderWidthForSide("right");
var borderBottomWidth = borderWidthForSide("bottom");
var borderLeftWidth = borderWidthForSide("left");
var color = {
  name: "color",
  initialValue: "transparent",
  prefix: false,
  type: 3,
  format: "color"
};
var direction = {
  name: "direction",
  initialValue: "ltr",
  prefix: false,
  type: 2,
  parse: function(_context2, direction2) {
    switch (direction2) {
      case "rtl":
        return 1;
      case "ltr":
      default:
        return 0;
    }
  }
};
var display = {
  name: "display",
  initialValue: "inline-block",
  prefix: false,
  type: 1,
  parse: function(_context2, tokens) {
    return tokens.filter(isIdentToken).reduce(
      function(bit, token) {
        return bit | parseDisplayValue(token.value);
      },
      0
      /* NONE */
    );
  }
};
var parseDisplayValue = function(display2) {
  switch (display2) {
    case "block":
    case "-webkit-box":
      return 2;
    case "inline":
      return 4;
    case "run-in":
      return 8;
    case "flow":
      return 16;
    case "flow-root":
      return 32;
    case "table":
      return 64;
    case "flex":
    case "-webkit-flex":
      return 128;
    case "grid":
    case "-ms-grid":
      return 256;
    case "ruby":
      return 512;
    case "subgrid":
      return 1024;
    case "list-item":
      return 2048;
    case "table-row-group":
      return 4096;
    case "table-header-group":
      return 8192;
    case "table-footer-group":
      return 16384;
    case "table-row":
      return 32768;
    case "table-cell":
      return 65536;
    case "table-column-group":
      return 131072;
    case "table-column":
      return 262144;
    case "table-caption":
      return 524288;
    case "ruby-base":
      return 1048576;
    case "ruby-text":
      return 2097152;
    case "ruby-base-container":
      return 4194304;
    case "ruby-text-container":
      return 8388608;
    case "contents":
      return 16777216;
    case "inline-block":
      return 33554432;
    case "inline-list-item":
      return 67108864;
    case "inline-table":
      return 134217728;
    case "inline-flex":
      return 268435456;
    case "inline-grid":
      return 536870912;
  }
  return 0;
};
var float = {
  name: "float",
  initialValue: "none",
  prefix: false,
  type: 2,
  parse: function(_context2, float2) {
    switch (float2) {
      case "left":
        return 1;
      case "right":
        return 2;
      case "inline-start":
        return 3;
      case "inline-end":
        return 4;
    }
    return 0;
  }
};
var letterSpacing = {
  name: "letter-spacing",
  initialValue: "0",
  prefix: false,
  type: 0,
  parse: function(_context2, token) {
    if (token.type === 20 && token.value === "normal") {
      return 0;
    }
    if (token.type === 17) {
      return token.number;
    }
    if (token.type === 15) {
      return token.number;
    }
    return 0;
  }
};
var LINE_BREAK;
(function(LINE_BREAK2) {
  LINE_BREAK2["NORMAL"] = "normal";
  LINE_BREAK2["STRICT"] = "strict";
})(LINE_BREAK || (LINE_BREAK = {}));
var lineBreak = {
  name: "line-break",
  initialValue: "normal",
  prefix: false,
  type: 2,
  parse: function(_context2, lineBreak2) {
    switch (lineBreak2) {
      case "strict":
        return LINE_BREAK.STRICT;
      case "normal":
      default:
        return LINE_BREAK.NORMAL;
    }
  }
};
var lineHeight = {
  name: "line-height",
  initialValue: "normal",
  prefix: false,
  type: 4
  /* TOKEN_VALUE */
};
var computeLineHeight = function(token, fontSize2) {
  if (isIdentToken(token) && token.value === "normal") {
    return 1.2 * fontSize2;
  } else if (token.type === 17) {
    return fontSize2 * token.number;
  } else if (isLengthPercentage(token)) {
    return getAbsoluteValue(token, fontSize2);
  }
  return fontSize2;
};
var listStyleImage = {
  name: "list-style-image",
  initialValue: "none",
  type: 0,
  prefix: false,
  parse: function(context, token) {
    if (token.type === 20 && token.value === "none") {
      return null;
    }
    return image.parse(context, token);
  }
};
var listStylePosition = {
  name: "list-style-position",
  initialValue: "outside",
  prefix: false,
  type: 2,
  parse: function(_context2, position2) {
    switch (position2) {
      case "inside":
        return 0;
      case "outside":
      default:
        return 1;
    }
  }
};
var listStyleType = {
  name: "list-style-type",
  initialValue: "none",
  prefix: false,
  type: 2,
  parse: function(_context2, type) {
    switch (type) {
      case "disc":
        return 0;
      case "circle":
        return 1;
      case "square":
        return 2;
      case "decimal":
        return 3;
      case "cjk-decimal":
        return 4;
      case "decimal-leading-zero":
        return 5;
      case "lower-roman":
        return 6;
      case "upper-roman":
        return 7;
      case "lower-greek":
        return 8;
      case "lower-alpha":
        return 9;
      case "upper-alpha":
        return 10;
      case "arabic-indic":
        return 11;
      case "armenian":
        return 12;
      case "bengali":
        return 13;
      case "cambodian":
        return 14;
      case "cjk-earthly-branch":
        return 15;
      case "cjk-heavenly-stem":
        return 16;
      case "cjk-ideographic":
        return 17;
      case "devanagari":
        return 18;
      case "ethiopic-numeric":
        return 19;
      case "georgian":
        return 20;
      case "gujarati":
        return 21;
      case "gurmukhi":
        return 22;
      case "hebrew":
        return 22;
      case "hiragana":
        return 23;
      case "hiragana-iroha":
        return 24;
      case "japanese-formal":
        return 25;
      case "japanese-informal":
        return 26;
      case "kannada":
        return 27;
      case "katakana":
        return 28;
      case "katakana-iroha":
        return 29;
      case "khmer":
        return 30;
      case "korean-hangul-formal":
        return 31;
      case "korean-hanja-formal":
        return 32;
      case "korean-hanja-informal":
        return 33;
      case "lao":
        return 34;
      case "lower-armenian":
        return 35;
      case "malayalam":
        return 36;
      case "mongolian":
        return 37;
      case "myanmar":
        return 38;
      case "oriya":
        return 39;
      case "persian":
        return 40;
      case "simp-chinese-formal":
        return 41;
      case "simp-chinese-informal":
        return 42;
      case "tamil":
        return 43;
      case "telugu":
        return 44;
      case "thai":
        return 45;
      case "tibetan":
        return 46;
      case "trad-chinese-formal":
        return 47;
      case "trad-chinese-informal":
        return 48;
      case "upper-armenian":
        return 49;
      case "disclosure-open":
        return 50;
      case "disclosure-closed":
        return 51;
      case "none":
      default:
        return -1;
    }
  }
};
var marginForSide = function(side) {
  return {
    name: "margin-" + side,
    initialValue: "0",
    prefix: false,
    type: 4
    /* TOKEN_VALUE */
  };
};
var marginTop = marginForSide("top");
var marginRight = marginForSide("right");
var marginBottom = marginForSide("bottom");
var marginLeft = marginForSide("left");
var overflow = {
  name: "overflow",
  initialValue: "visible",
  prefix: false,
  type: 1,
  parse: function(_context2, tokens) {
    return tokens.filter(isIdentToken).map(function(overflow2) {
      switch (overflow2.value) {
        case "hidden":
          return 1;
        case "scroll":
          return 2;
        case "clip":
          return 3;
        case "auto":
          return 4;
        case "visible":
        default:
          return 0;
      }
    });
  }
};
var overflowWrap = {
  name: "overflow-wrap",
  initialValue: "normal",
  prefix: false,
  type: 2,
  parse: function(_context2, overflow2) {
    switch (overflow2) {
      case "break-word":
        return "break-word";
      case "normal":
      default:
        return "normal";
    }
  }
};
var paddingForSide = function(side) {
  return {
    name: "padding-" + side,
    initialValue: "0",
    prefix: false,
    type: 3,
    format: "length-percentage"
  };
};
var paddingTop = paddingForSide("top");
var paddingRight = paddingForSide("right");
var paddingBottom = paddingForSide("bottom");
var paddingLeft = paddingForSide("left");
var textAlign = {
  name: "text-align",
  initialValue: "left",
  prefix: false,
  type: 2,
  parse: function(_context2, textAlign2) {
    switch (textAlign2) {
      case "right":
        return 2;
      case "center":
      case "justify":
        return 1;
      case "left":
      default:
        return 0;
    }
  }
};
var position = {
  name: "position",
  initialValue: "static",
  prefix: false,
  type: 2,
  parse: function(_context2, position2) {
    switch (position2) {
      case "relative":
        return 1;
      case "absolute":
        return 2;
      case "fixed":
        return 3;
      case "sticky":
        return 4;
    }
    return 0;
  }
};
var textShadow = {
  name: "text-shadow",
  initialValue: "none",
  type: 1,
  prefix: false,
  parse: function(context, tokens) {
    if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) {
      return [];
    }
    return parseFunctionArgs(tokens).map(function(values) {
      var shadow = {
        color: COLORS.TRANSPARENT,
        offsetX: ZERO_LENGTH,
        offsetY: ZERO_LENGTH,
        blur: ZERO_LENGTH
      };
      var c2 = 0;
      for (var i2 = 0; i2 < values.length; i2++) {
        var token = values[i2];
        if (isLength(token)) {
          if (c2 === 0) {
            shadow.offsetX = token;
          } else if (c2 === 1) {
            shadow.offsetY = token;
          } else {
            shadow.blur = token;
          }
          c2++;
        } else {
          shadow.color = color$1.parse(context, token);
        }
      }
      return shadow;
    });
  }
};
var textTransform = {
  name: "text-transform",
  initialValue: "none",
  prefix: false,
  type: 2,
  parse: function(_context2, textTransform2) {
    switch (textTransform2) {
      case "uppercase":
        return 2;
      case "lowercase":
        return 1;
      case "capitalize":
        return 3;
    }
    return 0;
  }
};
var transform$1 = {
  name: "transform",
  initialValue: "none",
  prefix: true,
  type: 0,
  parse: function(_context2, token) {
    if (token.type === 20 && token.value === "none") {
      return null;
    }
    if (token.type === 18) {
      var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
      if (typeof transformFunction === "undefined") {
        throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
      }
      return transformFunction(token.values);
    }
    return null;
  }
};
var matrix = function(args) {
  var values = args.filter(function(arg) {
    return arg.type === 17;
  }).map(function(arg) {
    return arg.number;
  });
  return values.length === 6 ? values : null;
};
var matrix3d = function(args) {
  var values = args.filter(function(arg) {
    return arg.type === 17;
  }).map(function(arg) {
    return arg.number;
  });
  var a1 = values[0], b1 = values[1];
  values[2];
  values[3];
  var a22 = values[4], b2 = values[5];
  values[6];
  values[7];
  values[8];
  values[9];
  values[10];
  values[11];
  var a4 = values[12], b4 = values[13];
  values[14];
  values[15];
  return values.length === 16 ? [a1, b1, a22, b2, a4, b4] : null;
};
var SUPPORTED_TRANSFORM_FUNCTIONS = {
  matrix,
  matrix3d
};
var DEFAULT_VALUE = {
  type: 16,
  number: 50,
  flags: FLAG_INTEGER
};
var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
var transformOrigin = {
  name: "transform-origin",
  initialValue: "50% 50%",
  prefix: true,
  type: 1,
  parse: function(_context2, tokens) {
    var origins = tokens.filter(isLengthPercentage);
    if (origins.length !== 2) {
      return DEFAULT;
    }
    return [origins[0], origins[1]];
  }
};
var visibility = {
  name: "visible",
  initialValue: "none",
  prefix: false,
  type: 2,
  parse: function(_context2, visibility2) {
    switch (visibility2) {
      case "hidden":
        return 1;
      case "collapse":
        return 2;
      case "visible":
      default:
        return 0;
    }
  }
};
var WORD_BREAK;
(function(WORD_BREAK2) {
  WORD_BREAK2["NORMAL"] = "normal";
  WORD_BREAK2["BREAK_ALL"] = "break-all";
  WORD_BREAK2["KEEP_ALL"] = "keep-all";
})(WORD_BREAK || (WORD_BREAK = {}));
var wordBreak = {
  name: "word-break",
  initialValue: "normal",
  prefix: false,
  type: 2,
  parse: function(_context2, wordBreak2) {
    switch (wordBreak2) {
      case "break-all":
        return WORD_BREAK.BREAK_ALL;
      case "keep-all":
        return WORD_BREAK.KEEP_ALL;
      case "normal":
      default:
        return WORD_BREAK.NORMAL;
    }
  }
};
var zIndex = {
  name: "z-index",
  initialValue: "auto",
  prefix: false,
  type: 0,
  parse: function(_context2, token) {
    if (token.type === 20) {
      return { auto: true, order: 0 };
    }
    if (isNumberToken(token)) {
      return { auto: false, order: token.number };
    }
    throw new Error("Invalid z-index number parsed");
  }
};
var time = {
  name: "time",
  parse: function(_context2, value) {
    if (value.type === 15) {
      switch (value.unit.toLowerCase()) {
        case "s":
          return 1e3 * value.number;
        case "ms":
          return value.number;
      }
    }
    throw new Error("Unsupported time type");
  }
};
var opacity = {
  name: "opacity",
  initialValue: "1",
  type: 0,
  prefix: false,
  parse: function(_context2, token) {
    if (isNumberToken(token)) {
      return token.number;
    }
    return 1;
  }
};
var textDecorationColor = {
  name: "text-decoration-color",
  initialValue: "transparent",
  prefix: false,
  type: 3,
  format: "color"
};
var textDecorationLine = {
  name: "text-decoration-line",
  initialValue: "none",
  prefix: false,
  type: 1,
  parse: function(_context2, tokens) {
    return tokens.filter(isIdentToken).map(function(token) {
      switch (token.value) {
        case "underline":
          return 1;
        case "overline":
          return 2;
        case "line-through":
          return 3;
        case "none":
          return 4;
      }
      return 0;
    }).filter(function(line) {
      return line !== 0;
    });
  }
};
var fontFamily = {
  name: "font-family",
  initialValue: "",
  prefix: false,
  type: 1,
  parse: function(_context2, tokens) {
    var accumulator = [];
    var results = [];
    tokens.forEach(function(token) {
      switch (token.type) {
        case 20:
        case 0:
          accumulator.push(token.value);
          break;
        case 17:
          accumulator.push(token.number.toString());
          break;
        case 4:
          results.push(accumulator.join(" "));
          accumulator.length = 0;
          break;
      }
    });
    if (accumulator.length) {
      results.push(accumulator.join(" "));
    }
    return results.map(function(result) {
      return result.indexOf(" ") === -1 ? result : "'" + result + "'";
    });
  }
};
var fontSize = {
  name: "font-size",
  initialValue: "0",
  prefix: false,
  type: 3,
  format: "length"
};
var fontWeight = {
  name: "font-weight",
  initialValue: "normal",
  type: 0,
  prefix: false,
  parse: function(_context2, token) {
    if (isNumberToken(token)) {
      return token.number;
    }
    if (isIdentToken(token)) {
      switch (token.value) {
        case "bold":
          return 700;
        case "normal":
        default:
          return 400;
      }
    }
    return 400;
  }
};
var fontVariant = {
  name: "font-variant",
  initialValue: "none",
  type: 1,
  prefix: false,
  parse: function(_context2, tokens) {
    return tokens.filter(isIdentToken).map(function(token) {
      return token.value;
    });
  }
};
var fontStyle = {
  name: "font-style",
  initialValue: "normal",
  prefix: false,
  type: 2,
  parse: function(_context2, overflow2) {
    switch (overflow2) {
      case "oblique":
        return "oblique";
      case "italic":
        return "italic";
      case "normal":
      default:
        return "normal";
    }
  }
};
var contains = function(bit, value) {
  return (bit & value) !== 0;
};
var content = {
  name: "content",
  initialValue: "none",
  type: 1,
  prefix: false,
  parse: function(_context2, tokens) {
    if (tokens.length === 0) {
      return [];
    }
    var first = tokens[0];
    if (first.type === 20 && first.value === "none") {
      return [];
    }
    return tokens;
  }
};
var counterIncrement = {
  name: "counter-increment",
  initialValue: "none",
  prefix: true,
  type: 1,
  parse: function(_context2, tokens) {
    if (tokens.length === 0) {
      return null;
    }
    var first = tokens[0];
    if (first.type === 20 && first.value === "none") {
      return null;
    }
    var increments = [];
    var filtered = tokens.filter(nonWhiteSpace);
    for (var i2 = 0; i2 < filtered.length; i2++) {
      var counter = filtered[i2];
      var next = filtered[i2 + 1];
      if (counter.type === 20) {
        var increment = next && isNumberToken(next) ? next.number : 1;
        increments.push({ counter: counter.value, increment });
      }
    }
    return increments;
  }
};
var counterReset = {
  name: "counter-reset",
  initialValue: "none",
  prefix: true,
  type: 1,
  parse: function(_context2, tokens) {
    if (tokens.length === 0) {
      return [];
    }
    var resets = [];
    var filtered = tokens.filter(nonWhiteSpace);
    for (var i2 = 0; i2 < filtered.length; i2++) {
      var counter = filtered[i2];
      var next = filtered[i2 + 1];
      if (isIdentToken(counter) && counter.value !== "none") {
        var reset = next && isNumberToken(next) ? next.number : 0;
        resets.push({ counter: counter.value, reset });
      }
    }
    return resets;
  }
};
var duration = {
  name: "duration",
  initialValue: "0s",
  prefix: false,
  type: 1,
  parse: function(context, tokens) {
    return tokens.filter(isDimensionToken).map(function(token) {
      return time.parse(context, token);
    });
  }
};
var quotes = {
  name: "quotes",
  initialValue: "none",
  prefix: true,
  type: 1,
  parse: function(_context2, tokens) {
    if (tokens.length === 0) {
      return null;
    }
    var first = tokens[0];
    if (first.type === 20 && first.value === "none") {
      return null;
    }
    var quotes2 = [];
    var filtered = tokens.filter(isStringToken);
    if (filtered.length % 2 !== 0) {
      return null;
    }
    for (var i2 = 0; i2 < filtered.length; i2 += 2) {
      var open_1 = filtered[i2].value;
      var close_1 = filtered[i2 + 1].value;
      quotes2.push({ open: open_1, close: close_1 });
    }
    return quotes2;
  }
};
var getQuote = function(quotes2, depth, open) {
  if (!quotes2) {
    return "";
  }
  var quote = quotes2[Math.min(depth, quotes2.length - 1)];
  if (!quote) {
    return "";
  }
  return open ? quote.open : quote.close;
};
var boxShadow = {
  name: "box-shadow",
  initialValue: "none",
  type: 1,
  prefix: false,
  parse: function(context, tokens) {
    if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) {
      return [];
    }
    return parseFunctionArgs(tokens).map(function(values) {
      var shadow = {
        color: 255,
        offsetX: ZERO_LENGTH,
        offsetY: ZERO_LENGTH,
        blur: ZERO_LENGTH,
        spread: ZERO_LENGTH,
        inset: false
      };
      var c2 = 0;
      for (var i2 = 0; i2 < values.length; i2++) {
        var token = values[i2];
        if (isIdentWithValue(token, "inset")) {
          shadow.inset = true;
        } else if (isLength(token)) {
          if (c2 === 0) {
            shadow.offsetX = token;
          } else if (c2 === 1) {
            shadow.offsetY = token;
          } else if (c2 === 2) {
            shadow.blur = token;
          } else {
            shadow.spread = token;
          }
          c2++;
        } else {
          shadow.color = color$1.parse(context, token);
        }
      }
      return shadow;
    });
  }
};
var paintOrder = {
  name: "paint-order",
  initialValue: "normal",
  prefix: false,
  type: 1,
  parse: function(_context2, tokens) {
    var DEFAULT_VALUE2 = [
      0,
      1,
      2
      /* MARKERS */
    ];
    var layers = [];
    tokens.filter(isIdentToken).forEach(function(token) {
      switch (token.value) {
        case "stroke":
          layers.push(
            1
            /* STROKE */
          );
          break;
        case "fill":
          layers.push(
            0
            /* FILL */
          );
          break;
        case "markers":
          layers.push(
            2
            /* MARKERS */
          );
          break;
      }
    });
    DEFAULT_VALUE2.forEach(function(value) {
      if (layers.indexOf(value) === -1) {
        layers.push(value);
      }
    });
    return layers;
  }
};
var webkitTextStrokeColor = {
  name: "-webkit-text-stroke-color",
  initialValue: "currentcolor",
  prefix: false,
  type: 3,
  format: "color"
};
var webkitTextStrokeWidth = {
  name: "-webkit-text-stroke-width",
  initialValue: "0",
  type: 0,
  prefix: false,
  parse: function(_context2, token) {
    if (isDimensionToken(token)) {
      return token.number;
    }
    return 0;
  }
};
var CSSParsedDeclaration = (
  /** @class */
  function() {
    function CSSParsedDeclaration2(context, declaration) {
      var _a2, _b2;
      this.animationDuration = parse(context, duration, declaration.animationDuration);
      this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
      this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
      this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
      this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
      this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
      this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
      this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
      this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
      this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
      this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
      this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
      this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
      this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
      this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
      this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
      this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
      this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
      this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
      this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
      this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
      this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
      this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
      this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
      this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
      this.color = parse(context, color, declaration.color);
      this.direction = parse(context, direction, declaration.direction);
      this.display = parse(context, display, declaration.display);
      this.float = parse(context, float, declaration.cssFloat);
      this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
      this.fontSize = parse(context, fontSize, declaration.fontSize);
      this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
      this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
      this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
      this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
      this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
      this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
      this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
      this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
      this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
      this.marginTop = parse(context, marginTop, declaration.marginTop);
      this.marginRight = parse(context, marginRight, declaration.marginRight);
      this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
      this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
      this.opacity = parse(context, opacity, declaration.opacity);
      var overflowTuple = parse(context, overflow, declaration.overflow);
      this.overflowX = overflowTuple[0];
      this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
      this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
      this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
      this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
      this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
      this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
      this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
      this.position = parse(context, position, declaration.position);
      this.textAlign = parse(context, textAlign, declaration.textAlign);
      this.textDecorationColor = parse(context, textDecorationColor, (_a2 = declaration.textDecorationColor) !== null && _a2 !== void 0 ? _a2 : declaration.color);
      this.textDecorationLine = parse(context, textDecorationLine, (_b2 = declaration.textDecorationLine) !== null && _b2 !== void 0 ? _b2 : declaration.textDecoration);
      this.textShadow = parse(context, textShadow, declaration.textShadow);
      this.textTransform = parse(context, textTransform, declaration.textTransform);
      this.transform = parse(context, transform$1, declaration.transform);
      this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
      this.visibility = parse(context, visibility, declaration.visibility);
      this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
      this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
      this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
      this.zIndex = parse(context, zIndex, declaration.zIndex);
    }
    CSSParsedDeclaration2.prototype.isVisible = function() {
      return this.display > 0 && this.opacity > 0 && this.visibility === 0;
    };
    CSSParsedDeclaration2.prototype.isTransparent = function() {
      return isTransparent(this.backgroundColor);
    };
    CSSParsedDeclaration2.prototype.isTransformed = function() {
      return this.transform !== null;
    };
    CSSParsedDeclaration2.prototype.isPositioned = function() {
      return this.position !== 0;
    };
    CSSParsedDeclaration2.prototype.isPositionedWithZIndex = function() {
      return this.isPositioned() && !this.zIndex.auto;
    };
    CSSParsedDeclaration2.prototype.isFloating = function() {
      return this.float !== 0;
    };
    CSSParsedDeclaration2.prototype.isInlineLevel = function() {
      return contains(
        this.display,
        4
        /* INLINE */
      ) || contains(
        this.display,
        33554432
        /* INLINE_BLOCK */
      ) || contains(
        this.display,
        268435456
        /* INLINE_FLEX */
      ) || contains(
        this.display,
        536870912
        /* INLINE_GRID */
      ) || contains(
        this.display,
        67108864
        /* INLINE_LIST_ITEM */
      ) || contains(
        this.display,
        134217728
        /* INLINE_TABLE */
      );
    };
    return CSSParsedDeclaration2;
  }()
);
var CSSParsedPseudoDeclaration = (
  /** @class */
  /* @__PURE__ */ function() {
    function CSSParsedPseudoDeclaration2(context, declaration) {
      this.content = parse(context, content, declaration.content);
      this.quotes = parse(context, quotes, declaration.quotes);
    }
    return CSSParsedPseudoDeclaration2;
  }()
);
var CSSParsedCounterDeclaration = (
  /** @class */
  /* @__PURE__ */ function() {
    function CSSParsedCounterDeclaration2(context, declaration) {
      this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
      this.counterReset = parse(context, counterReset, declaration.counterReset);
    }
    return CSSParsedCounterDeclaration2;
  }()
);
var parse = function(context, descriptor, style) {
  var tokenizer = new Tokenizer();
  var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
  tokenizer.write(value);
  var parser = new Parser(tokenizer.read());
  switch (descriptor.type) {
    case 2:
      var token = parser.parseComponentValue();
      return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
    case 0:
      return descriptor.parse(context, parser.parseComponentValue());
    case 1:
      return descriptor.parse(context, parser.parseComponentValues());
    case 4:
      return parser.parseComponentValue();
    case 3:
      switch (descriptor.format) {
        case "angle":
          return angle.parse(context, parser.parseComponentValue());
        case "color":
          return color$1.parse(context, parser.parseComponentValue());
        case "image":
          return image.parse(context, parser.parseComponentValue());
        case "length":
          var length_1 = parser.parseComponentValue();
          return isLength(length_1) ? length_1 : ZERO_LENGTH;
        case "length-percentage":
          var value_1 = parser.parseComponentValue();
          return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
        case "time":
          return time.parse(context, parser.parseComponentValue());
      }
      break;
  }
};
var elementDebuggerAttribute = "data-html2canvas-debug";
var getElementDebugType = function(element) {
  var attribute = element.getAttribute(elementDebuggerAttribute);
  switch (attribute) {
    case "all":
      return 1;
    case "clone":
      return 2;
    case "parse":
      return 3;
    case "render":
      return 4;
    default:
      return 0;
  }
};
var isDebugging = function(element, type) {
  var elementType = getElementDebugType(element);
  return elementType === 1 || type === elementType;
};
var ElementContainer = (
  /** @class */
  /* @__PURE__ */ function() {
    function ElementContainer2(context, element) {
      this.context = context;
      this.textNodes = [];
      this.elements = [];
      this.flags = 0;
      if (isDebugging(
        element,
        3
        /* PARSE */
      )) {
        debugger;
      }
      this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
      if (isHTMLElementNode(element)) {
        if (this.styles.animationDuration.some(function(duration2) {
          return duration2 > 0;
        })) {
          element.style.animationDuration = "0s";
        }
        if (this.styles.transform !== null) {
          element.style.transform = "none";
        }
      }
      this.bounds = parseBounds(this.context, element);
      if (isDebugging(
        element,
        4
        /* RENDER */
      )) {
        this.flags |= 16;
      }
    }
    return ElementContainer2;
  }()
);
var base64 = "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";
var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
  lookup$1[chars$1.charCodeAt(i$1)] = i$1;
}
var decode = function(base642) {
  var bufferLength = base642.length * 0.75, len = base642.length, i2, p2 = 0, encoded1, encoded2, encoded3, encoded4;
  if (base642[base642.length - 1] === "=") {
    bufferLength--;
    if (base642[base642.length - 2] === "=") {
      bufferLength--;
    }
  }
  var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
  var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
  for (i2 = 0; i2 < len; i2 += 4) {
    encoded1 = lookup$1[base642.charCodeAt(i2)];
    encoded2 = lookup$1[base642.charCodeAt(i2 + 1)];
    encoded3 = lookup$1[base642.charCodeAt(i2 + 2)];
    encoded4 = lookup$1[base642.charCodeAt(i2 + 3)];
    bytes[p2++] = encoded1 << 2 | encoded2 >> 4;
    bytes[p2++] = (encoded2 & 15) << 4 | encoded3 >> 2;
    bytes[p2++] = (encoded3 & 3) << 6 | encoded4 & 63;
  }
  return buffer;
};
var polyUint16Array = function(buffer) {
  var length2 = buffer.length;
  var bytes = [];
  for (var i2 = 0; i2 < length2; i2 += 2) {
    bytes.push(buffer[i2 + 1] << 8 | buffer[i2]);
  }
  return bytes;
};
var polyUint32Array = function(buffer) {
  var length2 = buffer.length;
  var bytes = [];
  for (var i2 = 0; i2 < length2; i2 += 4) {
    bytes.push(buffer[i2 + 3] << 24 | buffer[i2 + 2] << 16 | buffer[i2 + 1] << 8 | buffer[i2]);
  }
  return bytes;
};
var UTRIE2_SHIFT_2 = 5;
var UTRIE2_SHIFT_1 = 6 + 5;
var UTRIE2_INDEX_SHIFT = 2;
var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
var UTRIE2_LSCP_INDEX_2_OFFSET = 65536 >> UTRIE2_SHIFT_2;
var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
var UTRIE2_LSCP_INDEX_2_LENGTH = 1024 >> UTRIE2_SHIFT_2;
var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 2048 >> 6;
var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 65536 >> UTRIE2_SHIFT_1;
var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
var slice16 = function(view, start, end) {
  if (view.slice) {
    return view.slice(start, end);
  }
  return new Uint16Array(Array.prototype.slice.call(view, start, end));
};
var slice32 = function(view, start, end) {
  if (view.slice) {
    return view.slice(start, end);
  }
  return new Uint32Array(Array.prototype.slice.call(view, start, end));
};
var createTrieFromBase64 = function(base642, _byteLength) {
  var buffer = decode(base642);
  var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
  var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
  var headerLength = 24;
  var index2 = slice16(view16, headerLength / 2, view32[4] / 2);
  var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
  return new Trie(view32[0], view32[1], view32[2], view32[3], index2, data);
};
var Trie = (
  /** @class */
  function() {
    function Trie2(initialValue, errorValue, highStart, highValueIndex, index2, data) {
      this.initialValue = initialValue;
      this.errorValue = errorValue;
      this.highStart = highStart;
      this.highValueIndex = highValueIndex;
      this.index = index2;
      this.data = data;
    }
    Trie2.prototype.get = function(codePoint) {
      var ix;
      if (codePoint >= 0) {
        if (codePoint < 55296 || codePoint > 56319 && codePoint <= 65535) {
          ix = this.index[codePoint >> UTRIE2_SHIFT_2];
          ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
          return this.data[ix];
        }
        if (codePoint <= 65535) {
          ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 55296 >> UTRIE2_SHIFT_2)];
          ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
          return this.data[ix];
        }
        if (codePoint < this.highStart) {
          ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
          ix = this.index[ix];
          ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
          ix = this.index[ix];
          ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
          return this.data[ix];
        }
        if (codePoint <= 1114111) {
          return this.data[this.highValueIndex];
        }
      }
      return this.errorValue;
    };
    return Trie2;
  }()
);
var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for (var i2 = 0; i2 < chars.length; i2++) {
  lookup[chars.charCodeAt(i2)] = i2;
}
var Prepend = 1;
var CR = 2;
var LF = 3;
var Control = 4;
var Extend = 5;
var SpacingMark = 7;
var L = 8;
var V = 9;
var T = 10;
var LV = 11;
var LVT = 12;
var ZWJ = 13;
var Extended_Pictographic = 14;
var RI = 15;
var toCodePoints = function(str) {
  var codePoints = [];
  var i2 = 0;
  var length2 = str.length;
  while (i2 < length2) {
    var value = str.charCodeAt(i2++);
    if (value >= 55296 && value <= 56319 && i2 < length2) {
      var extra = str.charCodeAt(i2++);
      if ((extra & 64512) === 56320) {
        codePoints.push(((value & 1023) << 10) + (extra & 1023) + 65536);
      } else {
        codePoints.push(value);
        i2--;
      }
    } else {
      codePoints.push(value);
    }
  }
  return codePoints;
};
var fromCodePoint = function() {
  var codePoints = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    codePoints[_i] = arguments[_i];
  }
  if (String.fromCodePoint) {
    return String.fromCodePoint.apply(String, codePoints);
  }
  var length2 = codePoints.length;
  if (!length2) {
    return "";
  }
  var codeUnits = [];
  var index2 = -1;
  var result = "";
  while (++index2 < length2) {
    var codePoint = codePoints[index2];
    if (codePoint <= 65535) {
      codeUnits.push(codePoint);
    } else {
      codePoint -= 65536;
      codeUnits.push((codePoint >> 10) + 55296, codePoint % 1024 + 56320);
    }
    if (index2 + 1 === length2 || codeUnits.length > 16384) {
      result += String.fromCharCode.apply(String, codeUnits);
      codeUnits.length = 0;
    }
  }
  return result;
};
var UnicodeTrie = createTrieFromBase64(base64);
var BREAK_NOT_ALLOWED = "×";
var BREAK_ALLOWED = "÷";
var codePointToClass = function(codePoint) {
  return UnicodeTrie.get(codePoint);
};
var _graphemeBreakAtIndex = function(_codePoints, classTypes, index2) {
  var prevIndex = index2 - 2;
  var prev = classTypes[prevIndex];
  var current = classTypes[index2 - 1];
  var next = classTypes[index2];
  if (current === CR && next === LF) {
    return BREAK_NOT_ALLOWED;
  }
  if (current === CR || current === LF || current === Control) {
    return BREAK_ALLOWED;
  }
  if (next === CR || next === LF || next === Control) {
    return BREAK_ALLOWED;
  }
  if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
    return BREAK_NOT_ALLOWED;
  }
  if ((current === LV || current === V) && (next === V || next === T)) {
    return BREAK_NOT_ALLOWED;
  }
  if ((current === LVT || current === T) && next === T) {
    return BREAK_NOT_ALLOWED;
  }
  if (next === ZWJ || next === Extend) {
    return BREAK_NOT_ALLOWED;
  }
  if (next === SpacingMark) {
    return BREAK_NOT_ALLOWED;
  }
  if (current === Prepend) {
    return BREAK_NOT_ALLOWED;
  }
  if (current === ZWJ && next === Extended_Pictographic) {
    while (prev === Extend) {
      prev = classTypes[--prevIndex];
    }
    if (prev === Extended_Pictographic) {
      return BREAK_NOT_ALLOWED;
    }
  }
  if (current === RI && next === RI) {
    var countRI = 0;
    while (prev === RI) {
      countRI++;
      prev = classTypes[--prevIndex];
    }
    if (countRI % 2 === 0) {
      return BREAK_NOT_ALLOWED;
    }
  }
  return BREAK_ALLOWED;
};
var GraphemeBreaker = function(str) {
  var codePoints = toCodePoints(str);
  var length2 = codePoints.length;
  var index2 = 0;
  var lastEnd = 0;
  var classTypes = codePoints.map(codePointToClass);
  return {
    next: function() {
      if (index2 >= length2) {
        return { done: true, value: null };
      }
      var graphemeBreak = BREAK_NOT_ALLOWED;
      while (index2 < length2 && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index2)) === BREAK_NOT_ALLOWED) {
      }
      if (graphemeBreak !== BREAK_NOT_ALLOWED || index2 === length2) {
        var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index2));
        lastEnd = index2;
        return { value, done: false };
      }
      return { done: true, value: null };
    }
  };
};
var splitGraphemes = function(str) {
  var breaker = GraphemeBreaker(str);
  var graphemes = [];
  var bk;
  while (!(bk = breaker.next()).done) {
    if (bk.value) {
      graphemes.push(bk.value.slice());
    }
  }
  return graphemes;
};
var testRangeBounds = function(document2) {
  var TEST_HEIGHT = 123;
  if (document2.createRange) {
    var range = document2.createRange();
    if (range.getBoundingClientRect) {
      var testElement = document2.createElement("boundtest");
      testElement.style.height = TEST_HEIGHT + "px";
      testElement.style.display = "block";
      document2.body.appendChild(testElement);
      range.selectNode(testElement);
      var rangeBounds = range.getBoundingClientRect();
      var rangeHeight = Math.round(rangeBounds.height);
      document2.body.removeChild(testElement);
      if (rangeHeight === TEST_HEIGHT) {
        return true;
      }
    }
  }
  return false;
};
var testIOSLineBreak = function(document2) {
  var testElement = document2.createElement("boundtest");
  testElement.style.width = "50px";
  testElement.style.display = "block";
  testElement.style.fontSize = "12px";
  testElement.style.letterSpacing = "0px";
  testElement.style.wordSpacing = "0px";
  document2.body.appendChild(testElement);
  var range = document2.createRange();
  testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
  var node = testElement.firstChild;
  var textList = toCodePoints$1(node.data).map(function(i2) {
    return fromCodePoint$1(i2);
  });
  var offset = 0;
  var prev = {};
  var supports = textList.every(function(text, i2) {
    range.setStart(node, offset);
    range.setEnd(node, offset + text.length);
    var rect = range.getBoundingClientRect();
    offset += text.length;
    var boundAhead = rect.x > prev.x || rect.y > prev.y;
    prev = rect;
    if (i2 === 0) {
      return true;
    }
    return boundAhead;
  });
  document2.body.removeChild(testElement);
  return supports;
};
var testCORS = function() {
  return typeof new Image().crossOrigin !== "undefined";
};
var testResponseType = function() {
  return typeof new XMLHttpRequest().responseType === "string";
};
var testSVG = function(document2) {
  var img = new Image();
  var canvas = document2.createElement("canvas");
  var ctx = canvas.getContext("2d");
  if (!ctx) {
    return false;
  }
  img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
  try {
    ctx.drawImage(img, 0, 0);
    canvas.toDataURL();
  } catch (e2) {
    return false;
  }
  return true;
};
var isGreenPixel = function(data) {
  return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
};
var testForeignObject = function(document2) {
  var canvas = document2.createElement("canvas");
  var size = 100;
  canvas.width = size;
  canvas.height = size;
  var ctx = canvas.getContext("2d");
  if (!ctx) {
    return Promise.reject(false);
  }
  ctx.fillStyle = "rgb(0, 255, 0)";
  ctx.fillRect(0, 0, size, size);
  var img = new Image();
  var greenImageSrc = canvas.toDataURL();
  img.src = greenImageSrc;
  var svg = createForeignObjectSVG(size, size, 0, 0, img);
  ctx.fillStyle = "red";
  ctx.fillRect(0, 0, size, size);
  return loadSerializedSVG$1(svg).then(function(img2) {
    ctx.drawImage(img2, 0, 0);
    var data = ctx.getImageData(0, 0, size, size).data;
    ctx.fillStyle = "red";
    ctx.fillRect(0, 0, size, size);
    var node = document2.createElement("div");
    node.style.backgroundImage = "url(" + greenImageSrc + ")";
    node.style.height = size + "px";
    return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
  }).then(function(img2) {
    ctx.drawImage(img2, 0, 0);
    return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
  }).catch(function() {
    return false;
  });
};
var createForeignObjectSVG = function(width, height, x, y, node) {
  var xmlns = "http://www.w3.org/2000/svg";
  var svg = document.createElementNS(xmlns, "svg");
  var foreignObject = document.createElementNS(xmlns, "foreignObject");
  svg.setAttributeNS(null, "width", width.toString());
  svg.setAttributeNS(null, "height", height.toString());
  foreignObject.setAttributeNS(null, "width", "100%");
  foreignObject.setAttributeNS(null, "height", "100%");
  foreignObject.setAttributeNS(null, "x", x.toString());
  foreignObject.setAttributeNS(null, "y", y.toString());
  foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
  svg.appendChild(foreignObject);
  foreignObject.appendChild(node);
  return svg;
};
var loadSerializedSVG$1 = function(svg) {
  return new Promise(function(resolve, reject) {
    var img = new Image();
    img.onload = function() {
      return resolve(img);
    };
    img.onerror = reject;
    img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
  });
};
var FEATURES = {
  get SUPPORT_RANGE_BOUNDS() {
    var value = testRangeBounds(document);
    Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", { value });
    return value;
  },
  get SUPPORT_WORD_BREAKING() {
    var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
    Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", { value });
    return value;
  },
  get SUPPORT_SVG_DRAWING() {
    var value = testSVG(document);
    Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", { value });
    return value;
  },
  get SUPPORT_FOREIGNOBJECT_DRAWING() {
    var value = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
    Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", { value });
    return value;
  },
  get SUPPORT_CORS_IMAGES() {
    var value = testCORS();
    Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", { value });
    return value;
  },
  get SUPPORT_RESPONSE_TYPE() {
    var value = testResponseType();
    Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", { value });
    return value;
  },
  get SUPPORT_CORS_XHR() {
    var value = "withCredentials" in new XMLHttpRequest();
    Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", { value });
    return value;
  },
  get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
    var value = !!(typeof Intl !== "undefined" && Intl.Segmenter);
    Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value });
    return value;
  }
};
var TextBounds = (
  /** @class */
  /* @__PURE__ */ function() {
    function TextBounds2(text, bounds) {
      this.text = text;
      this.bounds = bounds;
    }
    return TextBounds2;
  }()
);
var parseTextBounds = function(context, value, styles, node) {
  var textList = breakText(value, styles);
  var textBounds = [];
  var offset = 0;
  textList.forEach(function(text) {
    if (styles.textDecorationLine.length || text.trim().length > 0) {
      if (FEATURES.SUPPORT_RANGE_BOUNDS) {
        var clientRects = createRange(node, offset, text.length).getClientRects();
        if (clientRects.length > 1) {
          var subSegments = segmentGraphemes(text);
          var subOffset_1 = 0;
          subSegments.forEach(function(subSegment) {
            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
            subOffset_1 += subSegment.length;
          });
        } else {
          textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
        }
      } else {
        var replacementNode = node.splitText(text.length);
        textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
        node = replacementNode;
      }
    } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
      node = node.splitText(text.length);
    }
    offset += text.length;
  });
  return textBounds;
};
var getWrapperBounds = function(context, node) {
  var ownerDocument = node.ownerDocument;
  if (ownerDocument) {
    var wrapper = ownerDocument.createElement("html2canvaswrapper");
    wrapper.appendChild(node.cloneNode(true));
    var parentNode = node.parentNode;
    if (parentNode) {
      parentNode.replaceChild(wrapper, node);
      var bounds = parseBounds(context, wrapper);
      if (wrapper.firstChild) {
        parentNode.replaceChild(wrapper.firstChild, wrapper);
      }
      return bounds;
    }
  }
  return Bounds.EMPTY;
};
var createRange = function(node, offset, length2) {
  var ownerDocument = node.ownerDocument;
  if (!ownerDocument) {
    throw new Error("Node has no owner document");
  }
  var range = ownerDocument.createRange();
  range.setStart(node, offset);
  range.setEnd(node, offset + length2);
  return range;
};
var segmentGraphemes = function(value) {
  if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var segmenter = new Intl.Segmenter(void 0, { granularity: "grapheme" });
    return Array.from(segmenter.segment(value)).map(function(segment) {
      return segment.segment;
    });
  }
  return splitGraphemes(value);
};
var segmentWords = function(value, styles) {
  if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var segmenter = new Intl.Segmenter(void 0, {
      granularity: "word"
    });
    return Array.from(segmenter.segment(value)).map(function(segment) {
      return segment.segment;
    });
  }
  return breakWords(value, styles);
};
var breakText = function(value, styles) {
  return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
};
var wordSeparators = [32, 160, 4961, 65792, 65793, 4153, 4241];
var breakWords = function(str, styles) {
  var breaker = LineBreaker(str, {
    lineBreak: styles.lineBreak,
    wordBreak: styles.overflowWrap === "break-word" ? "break-word" : styles.wordBreak
  });
  var words = [];
  var bk;
  var _loop_1 = function() {
    if (bk.value) {
      var value = bk.value.slice();
      var codePoints = toCodePoints$1(value);
      var word_1 = "";
      codePoints.forEach(function(codePoint) {
        if (wordSeparators.indexOf(codePoint) === -1) {
          word_1 += fromCodePoint$1(codePoint);
        } else {
          if (word_1.length) {
            words.push(word_1);
          }
          words.push(fromCodePoint$1(codePoint));
          word_1 = "";
        }
      });
      if (word_1.length) {
        words.push(word_1);
      }
    }
  };
  while (!(bk = breaker.next()).done) {
    _loop_1();
  }
  return words;
};
var TextContainer = (
  /** @class */
  /* @__PURE__ */ function() {
    function TextContainer2(context, node, styles) {
      this.text = transform(node.data, styles.textTransform);
      this.textBounds = parseTextBounds(context, this.text, styles, node);
    }
    return TextContainer2;
  }()
);
var transform = function(text, transform2) {
  switch (transform2) {
    case 1:
      return text.toLowerCase();
    case 3:
      return text.replace(CAPITALIZE, capitalize);
    case 2:
      return text.toUpperCase();
    default:
      return text;
  }
};
var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
var capitalize = function(m, p1, p2) {
  if (m.length > 0) {
    return p1 + p2.toUpperCase();
  }
  return m;
};
var ImageElementContainer = (
  /** @class */
  function(_super) {
    __extends(ImageElementContainer2, _super);
    function ImageElementContainer2(context, img) {
      var _this = _super.call(this, context, img) || this;
      _this.src = img.currentSrc || img.src;
      _this.intrinsicWidth = img.naturalWidth;
      _this.intrinsicHeight = img.naturalHeight;
      _this.context.cache.addImage(_this.src);
      return _this;
    }
    return ImageElementContainer2;
  }(ElementContainer)
);
var CanvasElementContainer = (
  /** @class */
  function(_super) {
    __extends(CanvasElementContainer2, _super);
    function CanvasElementContainer2(context, canvas) {
      var _this = _super.call(this, context, canvas) || this;
      _this.canvas = canvas;
      _this.intrinsicWidth = canvas.width;
      _this.intrinsicHeight = canvas.height;
      return _this;
    }
    return CanvasElementContainer2;
  }(ElementContainer)
);
var SVGElementContainer = (
  /** @class */
  function(_super) {
    __extends(SVGElementContainer2, _super);
    function SVGElementContainer2(context, img) {
      var _this = _super.call(this, context, img) || this;
      var s2 = new XMLSerializer();
      var bounds = parseBounds(context, img);
      img.setAttribute("width", bounds.width + "px");
      img.setAttribute("height", bounds.height + "px");
      _this.svg = "data:image/svg+xml," + encodeURIComponent(s2.serializeToString(img));
      _this.intrinsicWidth = img.width.baseVal.value;
      _this.intrinsicHeight = img.height.baseVal.value;
      _this.context.cache.addImage(_this.svg);
      return _this;
    }
    return SVGElementContainer2;
  }(ElementContainer)
);
var LIElementContainer = (
  /** @class */
  function(_super) {
    __extends(LIElementContainer2, _super);
    function LIElementContainer2(context, element) {
      var _this = _super.call(this, context, element) || this;
      _this.value = element.value;
      return _this;
    }
    return LIElementContainer2;
  }(ElementContainer)
);
var OLElementContainer = (
  /** @class */
  function(_super) {
    __extends(OLElementContainer2, _super);
    function OLElementContainer2(context, element) {
      var _this = _super.call(this, context, element) || this;
      _this.start = element.start;
      _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
      return _this;
    }
    return OLElementContainer2;
  }(ElementContainer)
);
var CHECKBOX_BORDER_RADIUS = [
  {
    type: 15,
    flags: 0,
    unit: "px",
    number: 3
  }
];
var RADIO_BORDER_RADIUS = [
  {
    type: 16,
    flags: 0,
    number: 50
  }
];
var reformatInputBounds = function(bounds) {
  if (bounds.width > bounds.height) {
    return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
  } else if (bounds.width < bounds.height) {
    return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
  }
  return bounds;
};
var getInputValue = function(node) {
  var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("•") : node.value;
  return value.length === 0 ? node.placeholder || "" : value;
};
var CHECKBOX = "checkbox";
var RADIO = "radio";
var PASSWORD = "password";
var INPUT_COLOR = 707406591;
var InputElementContainer = (
  /** @class */
  function(_super) {
    __extends(InputElementContainer2, _super);
    function InputElementContainer2(context, input) {
      var _this = _super.call(this, context, input) || this;
      _this.type = input.type.toLowerCase();
      _this.checked = input.checked;
      _this.value = getInputValue(input);
      if (_this.type === CHECKBOX || _this.type === RADIO) {
        _this.styles.backgroundColor = 3739148031;
        _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 2779096575;
        _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
        _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1;
        _this.styles.backgroundClip = [
          0
          /* BORDER_BOX */
        ];
        _this.styles.backgroundOrigin = [
          0
          /* BORDER_BOX */
        ];
        _this.bounds = reformatInputBounds(_this.bounds);
      }
      switch (_this.type) {
        case CHECKBOX:
          _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
          break;
        case RADIO:
          _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
          break;
      }
      return _this;
    }
    return InputElementContainer2;
  }(ElementContainer)
);
var SelectElementContainer = (
  /** @class */
  function(_super) {
    __extends(SelectElementContainer2, _super);
    function SelectElementContainer2(context, element) {
      var _this = _super.call(this, context, element) || this;
      var option = element.options[element.selectedIndex || 0];
      _this.value = option ? option.text || "" : "";
      return _this;
    }
    return SelectElementContainer2;
  }(ElementContainer)
);
var TextareaElementContainer = (
  /** @class */
  function(_super) {
    __extends(TextareaElementContainer2, _super);
    function TextareaElementContainer2(context, element) {
      var _this = _super.call(this, context, element) || this;
      _this.value = element.value;
      return _this;
    }
    return TextareaElementContainer2;
  }(ElementContainer)
);
var IFrameElementContainer = (
  /** @class */
  function(_super) {
    __extends(IFrameElementContainer2, _super);
    function IFrameElementContainer2(context, iframe) {
      var _this = _super.call(this, context, iframe) || this;
      _this.src = iframe.src;
      _this.width = parseInt(iframe.width, 10) || 0;
      _this.height = parseInt(iframe.height, 10) || 0;
      _this.backgroundColor = _this.styles.backgroundColor;
      try {
        if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
          _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
          var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
          var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
          _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
        }
      } catch (e2) {
      }
      return _this;
    }
    return IFrameElementContainer2;
  }(ElementContainer)
);
var LIST_OWNERS = ["OL", "UL", "MENU"];
var parseNodeTree = function(context, node, parent2, root) {
  for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
    nextNode = childNode.nextSibling;
    if (isTextNode(childNode) && childNode.data.trim().length > 0) {
      parent2.textNodes.push(new TextContainer(context, childNode, parent2.styles));
    } else if (isElementNode(childNode)) {
      if (isSlotElement(childNode) && childNode.assignedNodes) {
        childNode.assignedNodes().forEach(function(childNode2) {
          return parseNodeTree(context, childNode2, parent2, root);
        });
      } else {
        var container = createContainer(context, childNode);
        if (container.styles.isVisible()) {
          if (createsRealStackingContext(childNode, container, root)) {
            container.flags |= 4;
          } else if (createsStackingContext(container.styles)) {
            container.flags |= 2;
          }
          if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
            container.flags |= 8;
          }
          parent2.elements.push(container);
          childNode.slot;
          if (childNode.shadowRoot) {
            parseNodeTree(context, childNode.shadowRoot, container, root);
          } else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) {
            parseNodeTree(context, childNode, container, root);
          }
        }
      }
    }
  }
};
var createContainer = function(context, element) {
  if (isImageElement(element)) {
    return new ImageElementContainer(context, element);
  }
  if (isCanvasElement(element)) {
    return new CanvasElementContainer(context, element);
  }
  if (isSVGElement(element)) {
    return new SVGElementContainer(context, element);
  }
  if (isLIElement(element)) {
    return new LIElementContainer(context, element);
  }
  if (isOLElement(element)) {
    return new OLElementContainer(context, element);
  }
  if (isInputElement(element)) {
    return new InputElementContainer(context, element);
  }
  if (isSelectElement(element)) {
    return new SelectElementContainer(context, element);
  }
  if (isTextareaElement(element)) {
    return new TextareaElementContainer(context, element);
  }
  if (isIFrameElement(element)) {
    return new IFrameElementContainer(context, element);
  }
  return new ElementContainer(context, element);
};
var parseTree = function(context, element) {
  var container = createContainer(context, element);
  container.flags |= 4;
  parseNodeTree(context, element, container, container);
  return container;
};
var createsRealStackingContext = function(node, container, root) {
  return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
};
var createsStackingContext = function(styles) {
  return styles.isPositioned() || styles.isFloating();
};
var isTextNode = function(node) {
  return node.nodeType === Node.TEXT_NODE;
};
var isElementNode = function(node) {
  return node.nodeType === Node.ELEMENT_NODE;
};
var isHTMLElementNode = function(node) {
  return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
};
var isSVGElementNode = function(element) {
  return typeof element.className === "object";
};
var isLIElement = function(node) {
  return node.tagName === "LI";
};
var isOLElement = function(node) {
  return node.tagName === "OL";
};
var isInputElement = function(node) {
  return node.tagName === "INPUT";
};
var isHTMLElement = function(node) {
  return node.tagName === "HTML";
};
var isSVGElement = function(node) {
  return node.tagName === "svg";
};
var isBodyElement = function(node) {
  return node.tagName === "BODY";
};
var isCanvasElement = function(node) {
  return node.tagName === "CANVAS";
};
var isVideoElement = function(node) {
  return node.tagName === "VIDEO";
};
var isImageElement = function(node) {
  return node.tagName === "IMG";
};
var isIFrameElement = function(node) {
  return node.tagName === "IFRAME";
};
var isStyleElement = function(node) {
  return node.tagName === "STYLE";
};
var isScriptElement = function(node) {
  return node.tagName === "SCRIPT";
};
var isTextareaElement = function(node) {
  return node.tagName === "TEXTAREA";
};
var isSelectElement = function(node) {
  return node.tagName === "SELECT";
};
var isSlotElement = function(node) {
  return node.tagName === "SLOT";
};
var isCustomElement = function(node) {
  return node.tagName.indexOf("-") > 0;
};
var CounterState = (
  /** @class */
  function() {
    function CounterState2() {
      this.counters = {};
    }
    CounterState2.prototype.getCounterValue = function(name) {
      var counter = this.counters[name];
      if (counter && counter.length) {
        return counter[counter.length - 1];
      }
      return 1;
    };
    CounterState2.prototype.getCounterValues = function(name) {
      var counter = this.counters[name];
      return counter ? counter : [];
    };
    CounterState2.prototype.pop = function(counters) {
      var _this = this;
      counters.forEach(function(counter) {
        return _this.counters[counter].pop();
      });
    };
    CounterState2.prototype.parse = function(style) {
      var _this = this;
      var counterIncrement2 = style.counterIncrement;
      var counterReset2 = style.counterReset;
      var canReset = true;
      if (counterIncrement2 !== null) {
        counterIncrement2.forEach(function(entry) {
          var counter = _this.counters[entry.counter];
          if (counter && entry.increment !== 0) {
            canReset = false;
            if (!counter.length) {
              counter.push(1);
            }
            counter[Math.max(0, counter.length - 1)] += entry.increment;
          }
        });
      }
      var counterNames = [];
      if (canReset) {
        counterReset2.forEach(function(entry) {
          var counter = _this.counters[entry.counter];
          counterNames.push(entry.counter);
          if (!counter) {
            counter = _this.counters[entry.counter] = [];
          }
          counter.push(entry.reset);
        });
      }
      return counterNames;
    };
    return CounterState2;
  }()
);
var ROMAN_UPPER = {
  integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
  values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"]
};
var ARMENIAN = {
  integers: [
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "Ք",
    "Փ",
    "Ւ",
    "Ց",
    "Ր",
    "Տ",
    "Վ",
    "Ս",
    "Ռ",
    "Ջ",
    "Պ",
    "Չ",
    "Ո",
    "Շ",
    "Ն",
    "Յ",
    "Մ",
    "Ճ",
    "Ղ",
    "Ձ",
    "Հ",
    "Կ",
    "Ծ",
    "Խ",
    "Լ",
    "Ի",
    "Ժ",
    "Թ",
    "Ը",
    "Է",
    "Զ",
    "Ե",
    "Դ",
    "Գ",
    "Բ",
    "Ա"
  ]
};
var HEBREW = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    19,
    18,
    17,
    16,
    15,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "י׳",
    "ט׳",
    "ח׳",
    "ז׳",
    "ו׳",
    "ה׳",
    "ד׳",
    "ג׳",
    "ב׳",
    "א׳",
    "ת",
    "ש",
    "ר",
    "ק",
    "צ",
    "פ",
    "ע",
    "ס",
    "נ",
    "מ",
    "ל",
    "כ",
    "יט",
    "יח",
    "יז",
    "טז",
    "טו",
    "י",
    "ט",
    "ח",
    "ז",
    "ו",
    "ה",
    "ד",
    "ג",
    "ב",
    "א"
  ]
};
var GEORGIAN = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "ჵ",
    "ჰ",
    "ჯ",
    "ჴ",
    "ხ",
    "ჭ",
    "წ",
    "ძ",
    "ც",
    "ჩ",
    "შ",
    "ყ",
    "ღ",
    "ქ",
    "ფ",
    "ჳ",
    "ტ",
    "ს",
    "რ",
    "ჟ",
    "პ",
    "ო",
    "ჲ",
    "ნ",
    "მ",
    "ლ",
    "კ",
    "ი",
    "თ",
    "ჱ",
    "ზ",
    "ვ",
    "ე",
    "დ",
    "გ",
    "ბ",
    "ა"
  ]
};
var createAdditiveCounter = function(value, min, max2, symbols, fallback, suffix) {
  if (value < min || value > max2) {
    return createCounterText(value, fallback, suffix.length > 0);
  }
  return symbols.integers.reduce(function(string, integer, index2) {
    while (value >= integer) {
      value -= integer;
      string += symbols.values[index2];
    }
    return string;
  }, "") + suffix;
};
var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
  var string = "";
  do {
    if (!isNumeric) {
      value--;
    }
    string = resolver(value) + string;
    value /= codePointRangeLength;
  } while (value * codePointRangeLength >= codePointRangeLength);
  return string;
};
var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
  var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
  return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
    return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
  }) + suffix);
};
var createCounterStyleFromSymbols = function(value, symbols, suffix) {
  if (suffix === void 0) {
    suffix = ". ";
  }
  var codePointRangeLength = symbols.length;
  return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
    return symbols[Math.floor(codePoint % codePointRangeLength)];
  }) + suffix;
};
var CJK_ZEROS = 1 << 0;
var CJK_TEN_COEFFICIENTS = 1 << 1;
var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
  if (value < -9999 || value > 9999) {
    return createCounterText(value, 4, suffix.length > 0);
  }
  var tmp2 = Math.abs(value);
  var string = suffix;
  if (tmp2 === 0) {
    return numbers[0] + string;
  }
  for (var digit = 0; tmp2 > 0 && digit <= 4; digit++) {
    var coefficient = tmp2 % 10;
    if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") {
      string = numbers[coefficient] + string;
    } else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) {
      string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
    } else if (coefficient === 1 && digit > 0) {
      string = multipliers[digit - 1] + string;
    }
    tmp2 = Math.floor(tmp2 / 10);
  }
  return (value < 0 ? negativeSign : "") + string;
};
var CHINESE_INFORMAL_MULTIPLIERS = "十百千萬";
var CHINESE_FORMAL_MULTIPLIERS = "拾佰仟萬";
var JAPANESE_NEGATIVE = "マイナス";
var KOREAN_NEGATIVE = "마이너스";
var createCounterText = function(value, type, appendSuffix) {
  var defaultSuffix = appendSuffix ? ". " : "";
  var cjkSuffix = appendSuffix ? "、" : "";
  var koreanSuffix = appendSuffix ? ", " : "";
  var spaceSuffix = appendSuffix ? " " : "";
  switch (type) {
    case 0:
      return "•" + spaceSuffix;
    case 1:
      return "◦" + spaceSuffix;
    case 2:
      return "◾" + spaceSuffix;
    case 5:
      var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
      return string.length < 4 ? "0" + string : string;
    case 4:
      return createCounterStyleFromSymbols(value, "〇一二三四五六七八九", cjkSuffix);
    case 6:
      return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3, defaultSuffix).toLowerCase();
    case 7:
      return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3, defaultSuffix);
    case 8:
      return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
    case 9:
      return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
    case 10:
      return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
    case 11:
      return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
    case 12:
    case 49:
      return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3, defaultSuffix);
    case 35:
      return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3, defaultSuffix).toLowerCase();
    case 13:
      return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
    case 14:
    case 30:
      return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
    case 15:
      return createCounterStyleFromSymbols(value, "子丑寅卯辰巳午未申酉戌亥", cjkSuffix);
    case 16:
      return createCounterStyleFromSymbols(value, "甲乙丙丁戊己庚辛壬癸", cjkSuffix);
    case 17:
    case 48:
      return createCJKCounter(value, "零一二三四五六七八九", CHINESE_INFORMAL_MULTIPLIERS, "負", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
    case 47:
      return createCJKCounter(value, "零壹貳參肆伍陸柒捌玖", CHINESE_FORMAL_MULTIPLIERS, "負", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
    case 42:
      return createCJKCounter(value, "零一二三四五六七八九", CHINESE_INFORMAL_MULTIPLIERS, "负", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
    case 41:
      return createCJKCounter(value, "零壹贰叁肆伍陆柒捌玖", CHINESE_FORMAL_MULTIPLIERS, "负", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
    case 26:
      return createCJKCounter(value, "〇一二三四五六七八九", "十百千万", JAPANESE_NEGATIVE, cjkSuffix, 0);
    case 25:
      return createCJKCounter(value, "零壱弐参四伍六七八九", "拾百千万", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
    case 31:
      return createCJKCounter(value, "영일이삼사오육칠팔구", "십백천만", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
    case 33:
      return createCJKCounter(value, "零一二三四五六七八九", "十百千萬", KOREAN_NEGATIVE, koreanSuffix, 0);
    case 32:
      return createCJKCounter(value, "零壹貳參四五六七八九", "拾百千", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
    case 18:
      return createCounterStyleFromRange(value, 2406, 2415, true, defaultSuffix);
    case 20:
      return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3, defaultSuffix);
    case 21:
      return createCounterStyleFromRange(value, 2790, 2799, true, defaultSuffix);
    case 22:
      return createCounterStyleFromRange(value, 2662, 2671, true, defaultSuffix);
    case 22:
      return createAdditiveCounter(value, 1, 10999, HEBREW, 3, defaultSuffix);
    case 23:
      return createCounterStyleFromSymbols(value, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
    case 24:
      return createCounterStyleFromSymbols(value, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
    case 27:
      return createCounterStyleFromRange(value, 3302, 3311, true, defaultSuffix);
    case 28:
      return createCounterStyleFromSymbols(value, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", cjkSuffix);
    case 29:
      return createCounterStyleFromSymbols(value, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", cjkSuffix);
    case 34:
      return createCounterStyleFromRange(value, 3792, 3801, true, defaultSuffix);
    case 37:
      return createCounterStyleFromRange(value, 6160, 6169, true, defaultSuffix);
    case 38:
      return createCounterStyleFromRange(value, 4160, 4169, true, defaultSuffix);
    case 39:
      return createCounterStyleFromRange(value, 2918, 2927, true, defaultSuffix);
    case 40:
      return createCounterStyleFromRange(value, 1776, 1785, true, defaultSuffix);
    case 43:
      return createCounterStyleFromRange(value, 3046, 3055, true, defaultSuffix);
    case 44:
      return createCounterStyleFromRange(value, 3174, 3183, true, defaultSuffix);
    case 45:
      return createCounterStyleFromRange(value, 3664, 3673, true, defaultSuffix);
    case 46:
      return createCounterStyleFromRange(value, 3872, 3881, true, defaultSuffix);
    case 3:
    default:
      return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
  }
};
var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
var DocumentCloner = (
  /** @class */
  function() {
    function DocumentCloner2(context, element, options) {
      this.context = context;
      this.options = options;
      this.scrolledElements = [];
      this.referenceElement = element;
      this.counters = new CounterState();
      this.quoteDepth = 0;
      if (!element.ownerDocument) {
        throw new Error("Cloned element does not have an owner document");
      }
      this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
    }
    DocumentCloner2.prototype.toIFrame = function(ownerDocument, windowSize) {
      var _this = this;
      var iframe = createIFrameContainer(ownerDocument, windowSize);
      if (!iframe.contentWindow) {
        return Promise.reject("Unable to find iframe window");
      }
      var scrollX = ownerDocument.defaultView.pageXOffset;
      var scrollY = ownerDocument.defaultView.pageYOffset;
      var cloneWindow = iframe.contentWindow;
      var documentClone = cloneWindow.document;
      var iframeLoad = iframeLoader(iframe).then(function() {
        return __awaiter(_this, void 0, void 0, function() {
          var onclone, referenceElement;
          return __generator(this, function(_a2) {
            switch (_a2.label) {
              case 0:
                this.scrolledElements.forEach(restoreNodeScroll);
                if (cloneWindow) {
                  cloneWindow.scrollTo(windowSize.left, windowSize.top);
                  if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                    this.context.logger.warn("Unable to restore scroll position for cloned document");
                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                  }
                }
                onclone = this.options.onclone;
                referenceElement = this.clonedReferenceElement;
                if (typeof referenceElement === "undefined") {
                  return [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                }
                if (!(documentClone.fonts && documentClone.fonts.ready)) return [3, 2];
                return [4, documentClone.fonts.ready];
              case 1:
                _a2.sent();
                _a2.label = 2;
              case 2:
                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3, 4];
                return [4, imagesReady(documentClone)];
              case 3:
                _a2.sent();
                _a2.label = 4;
              case 4:
                if (typeof onclone === "function") {
                  return [2, Promise.resolve().then(function() {
                    return onclone(documentClone, referenceElement);
                  }).then(function() {
                    return iframe;
                  })];
                }
                return [2, iframe];
            }
          });
        });
      });
      documentClone.open();
      documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
      restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
      documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
      documentClone.close();
      return iframeLoad;
    };
    DocumentCloner2.prototype.createElementClone = function(node) {
      if (isDebugging(
        node,
        2
        /* CLONE */
      )) {
        debugger;
      }
      if (isCanvasElement(node)) {
        return this.createCanvasClone(node);
      }
      if (isVideoElement(node)) {
        return this.createVideoClone(node);
      }
      if (isStyleElement(node)) {
        return this.createStyleClone(node);
      }
      var clone2 = node.cloneNode(false);
      if (isImageElement(clone2)) {
        if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
          clone2.src = node.currentSrc;
          clone2.srcset = "";
        }
        if (clone2.loading === "lazy") {
          clone2.loading = "eager";
        }
      }
      if (isCustomElement(clone2)) {
        return this.createCustomElementClone(clone2);
      }
      return clone2;
    };
    DocumentCloner2.prototype.createCustomElementClone = function(node) {
      var clone2 = document.createElement("html2canvascustomelement");
      copyCSSStyles(node.style, clone2);
      return clone2;
    };
    DocumentCloner2.prototype.createStyleClone = function(node) {
      try {
        var sheet = node.sheet;
        if (sheet && sheet.cssRules) {
          var css = [].slice.call(sheet.cssRules, 0).reduce(function(css2, rule) {
            if (rule && typeof rule.cssText === "string") {
              return css2 + rule.cssText;
            }
            return css2;
          }, "");
          var style = node.cloneNode(false);
          style.textContent = css;
          return style;
        }
      } catch (e2) {
        this.context.logger.error("Unable to access cssRules property", e2);
        if (e2.name !== "SecurityError") {
          throw e2;
        }
      }
      return node.cloneNode(false);
    };
    DocumentCloner2.prototype.createCanvasClone = function(canvas) {
      var _a2;
      if (this.options.inlineImages && canvas.ownerDocument) {
        var img = canvas.ownerDocument.createElement("img");
        try {
          img.src = canvas.toDataURL();
          return img;
        } catch (e2) {
          this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
        }
      }
      var clonedCanvas = canvas.cloneNode(false);
      try {
        clonedCanvas.width = canvas.width;
        clonedCanvas.height = canvas.height;
        var ctx = canvas.getContext("2d");
        var clonedCtx = clonedCanvas.getContext("2d");
        if (clonedCtx) {
          if (!this.options.allowTaint && ctx) {
            clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
          } else {
            var gl = (_a2 = canvas.getContext("webgl2")) !== null && _a2 !== void 0 ? _a2 : canvas.getContext("webgl");
            if (gl) {
              var attribs = gl.getContextAttributes();
              if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
              }
            }
            clonedCtx.drawImage(canvas, 0, 0);
          }
        }
        return clonedCanvas;
      } catch (e2) {
        this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
      }
      return clonedCanvas;
    };
    DocumentCloner2.prototype.createVideoClone = function(video) {
      var canvas = video.ownerDocument.createElement("canvas");
      canvas.width = video.offsetWidth;
      canvas.height = video.offsetHeight;
      var ctx = canvas.getContext("2d");
      try {
        if (ctx) {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          if (!this.options.allowTaint) {
            ctx.getImageData(0, 0, canvas.width, canvas.height);
          }
        }
        return canvas;
      } catch (e2) {
        this.context.logger.info("Unable to clone video as it is tainted", video);
      }
      var blankCanvas = video.ownerDocument.createElement("canvas");
      blankCanvas.width = video.offsetWidth;
      blankCanvas.height = video.offsetHeight;
      return blankCanvas;
    };
    DocumentCloner2.prototype.appendChildNode = function(clone2, child, copyStyles) {
      if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
        if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
          clone2.appendChild(this.cloneNode(child, copyStyles));
        }
      }
    };
    DocumentCloner2.prototype.cloneChildNodes = function(node, clone2, copyStyles) {
      var _this = this;
      for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
        if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === "function") {
          var assignedNodes = child.assignedNodes();
          if (assignedNodes.length) {
            assignedNodes.forEach(function(assignedNode) {
              return _this.appendChildNode(clone2, assignedNode, copyStyles);
            });
          }
        } else {
          this.appendChildNode(clone2, child, copyStyles);
        }
      }
    };
    DocumentCloner2.prototype.cloneNode = function(node, copyStyles) {
      if (isTextNode(node)) {
        return document.createTextNode(node.data);
      }
      if (!node.ownerDocument) {
        return node.cloneNode(false);
      }
      var window2 = node.ownerDocument.defaultView;
      if (window2 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
        var clone2 = this.createElementClone(node);
        clone2.style.transitionProperty = "none";
        var style = window2.getComputedStyle(node);
        var styleBefore = window2.getComputedStyle(node, ":before");
        var styleAfter = window2.getComputedStyle(node, ":after");
        if (this.referenceElement === node && isHTMLElementNode(clone2)) {
          this.clonedReferenceElement = clone2;
        }
        if (isBodyElement(clone2)) {
          createPseudoHideStyles(clone2);
        }
        var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
        var before = this.resolvePseudoContent(node, clone2, styleBefore, PseudoElementType.BEFORE);
        if (isCustomElement(node)) {
          copyStyles = true;
        }
        if (!isVideoElement(node)) {
          this.cloneChildNodes(node, clone2, copyStyles);
        }
        if (before) {
          clone2.insertBefore(before, clone2.firstChild);
        }
        var after = this.resolvePseudoContent(node, clone2, styleAfter, PseudoElementType.AFTER);
        if (after) {
          clone2.appendChild(after);
        }
        this.counters.pop(counters);
        if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) {
          copyCSSStyles(style, clone2);
        }
        if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
          this.scrolledElements.push([clone2, node.scrollLeft, node.scrollTop]);
        }
        if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone2) || isSelectElement(clone2))) {
          clone2.value = node.value;
        }
        return clone2;
      }
      return node.cloneNode(false);
    };
    DocumentCloner2.prototype.resolvePseudoContent = function(node, clone2, style, pseudoElt) {
      var _this = this;
      if (!style) {
        return;
      }
      var value = style.content;
      var document2 = clone2.ownerDocument;
      if (!document2 || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") {
        return;
      }
      this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
      var declaration = new CSSParsedPseudoDeclaration(this.context, style);
      var anonymousReplacedElement = document2.createElement("html2canvaspseudoelement");
      copyCSSStyles(style, anonymousReplacedElement);
      declaration.content.forEach(function(token) {
        if (token.type === 0) {
          anonymousReplacedElement.appendChild(document2.createTextNode(token.value));
        } else if (token.type === 22) {
          var img = document2.createElement("img");
          img.src = token.value;
          img.style.opacity = "1";
          anonymousReplacedElement.appendChild(img);
        } else if (token.type === 18) {
          if (token.name === "attr") {
            var attr = token.values.filter(isIdentToken);
            if (attr.length) {
              anonymousReplacedElement.appendChild(document2.createTextNode(node.getAttribute(attr[0].value) || ""));
            }
          } else if (token.name === "counter") {
            var _a2 = token.values.filter(nonFunctionArgSeparator), counter = _a2[0], counterStyle = _a2[1];
            if (counter && isIdentToken(counter)) {
              var counterState = _this.counters.getCounterValue(counter.value);
              var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3;
              anonymousReplacedElement.appendChild(document2.createTextNode(createCounterText(counterState, counterType, false)));
            }
          } else if (token.name === "counters") {
            var _b2 = token.values.filter(nonFunctionArgSeparator), counter = _b2[0], delim = _b2[1], counterStyle = _b2[2];
            if (counter && isIdentToken(counter)) {
              var counterStates = _this.counters.getCounterValues(counter.value);
              var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3;
              var separator = delim && delim.type === 0 ? delim.value : "";
              var text = counterStates.map(function(value2) {
                return createCounterText(value2, counterType_1, false);
              }).join(separator);
              anonymousReplacedElement.appendChild(document2.createTextNode(text));
            }
          } else ;
        } else if (token.type === 20) {
          switch (token.value) {
            case "open-quote":
              anonymousReplacedElement.appendChild(document2.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
              break;
            case "close-quote":
              anonymousReplacedElement.appendChild(document2.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
              break;
            default:
              anonymousReplacedElement.appendChild(document2.createTextNode(token.value));
          }
        }
      });
      anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
      var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
      if (isSVGElementNode(clone2)) {
        clone2.className.baseValue += newClassName;
      } else {
        clone2.className += newClassName;
      }
      return anonymousReplacedElement;
    };
    DocumentCloner2.destroy = function(container) {
      if (container.parentNode) {
        container.parentNode.removeChild(container);
        return true;
      }
      return false;
    };
    return DocumentCloner2;
  }()
);
var PseudoElementType;
(function(PseudoElementType2) {
  PseudoElementType2[PseudoElementType2["BEFORE"] = 0] = "BEFORE";
  PseudoElementType2[PseudoElementType2["AFTER"] = 1] = "AFTER";
})(PseudoElementType || (PseudoElementType = {}));
var createIFrameContainer = function(ownerDocument, bounds) {
  var cloneIframeContainer = ownerDocument.createElement("iframe");
  cloneIframeContainer.className = "html2canvas-container";
  cloneIframeContainer.style.visibility = "hidden";
  cloneIframeContainer.style.position = "fixed";
  cloneIframeContainer.style.left = "-10000px";
  cloneIframeContainer.style.top = "0px";
  cloneIframeContainer.style.border = "0";
  cloneIframeContainer.width = bounds.width.toString();
  cloneIframeContainer.height = bounds.height.toString();
  cloneIframeContainer.scrolling = "no";
  cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
  ownerDocument.body.appendChild(cloneIframeContainer);
  return cloneIframeContainer;
};
var imageReady = function(img) {
  return new Promise(function(resolve) {
    if (img.complete) {
      resolve();
      return;
    }
    if (!img.src) {
      resolve();
      return;
    }
    img.onload = resolve;
    img.onerror = resolve;
  });
};
var imagesReady = function(document2) {
  return Promise.all([].slice.call(document2.images, 0).map(imageReady));
};
var iframeLoader = function(iframe) {
  return new Promise(function(resolve, reject) {
    var cloneWindow = iframe.contentWindow;
    if (!cloneWindow) {
      return reject("No window assigned for iframe");
    }
    var documentClone = cloneWindow.document;
    cloneWindow.onload = iframe.onload = function() {
      cloneWindow.onload = iframe.onload = null;
      var interval = setInterval(function() {
        if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
          clearInterval(interval);
          resolve(iframe);
        }
      }, 50);
    };
  });
};
var ignoredStyleProperties = [
  "all",
  "d",
  "content"
  // Safari shows pseudoelements if content is set
];
var copyCSSStyles = function(style, target) {
  for (var i2 = style.length - 1; i2 >= 0; i2--) {
    var property = style.item(i2);
    if (ignoredStyleProperties.indexOf(property) === -1) {
      target.style.setProperty(property, style.getPropertyValue(property));
    }
  }
  return target;
};
var serializeDoctype = function(doctype) {
  var str = "";
  if (doctype) {
    str += "<!DOCTYPE ";
    if (doctype.name) {
      str += doctype.name;
    }
    if (doctype.internalSubset) {
      str += doctype.internalSubset;
    }
    if (doctype.publicId) {
      str += '"' + doctype.publicId + '"';
    }
    if (doctype.systemId) {
      str += '"' + doctype.systemId + '"';
    }
    str += ">";
  }
  return str;
};
var restoreOwnerScroll = function(ownerDocument, x, y) {
  if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
    ownerDocument.defaultView.scrollTo(x, y);
  }
};
var restoreNodeScroll = function(_a2) {
  var element = _a2[0], x = _a2[1], y = _a2[2];
  element.scrollLeft = x;
  element.scrollTop = y;
};
var PSEUDO_BEFORE = ":before";
var PSEUDO_AFTER = ":after";
var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
var createPseudoHideStyles = function(body) {
  createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
};
var createStyles = function(body, styles) {
  var document2 = body.ownerDocument;
  if (document2) {
    var style = document2.createElement("style");
    style.textContent = styles;
    body.appendChild(style);
  }
};
var CacheStorage = (
  /** @class */
  function() {
    function CacheStorage2() {
    }
    CacheStorage2.getOrigin = function(url) {
      var link = CacheStorage2._link;
      if (!link) {
        return "about:blank";
      }
      link.href = url;
      link.href = link.href;
      return link.protocol + link.hostname + link.port;
    };
    CacheStorage2.isSameOrigin = function(src) {
      return CacheStorage2.getOrigin(src) === CacheStorage2._origin;
    };
    CacheStorage2.setContext = function(window2) {
      CacheStorage2._link = window2.document.createElement("a");
      CacheStorage2._origin = CacheStorage2.getOrigin(window2.location.href);
    };
    CacheStorage2._origin = "about:blank";
    return CacheStorage2;
  }()
);
var Cache = (
  /** @class */
  function() {
    function Cache2(context, _options) {
      this.context = context;
      this._options = _options;
      this._cache = {};
    }
    Cache2.prototype.addImage = function(src) {
      var result = Promise.resolve();
      if (this.has(src)) {
        return result;
      }
      if (isBlobImage(src) || isRenderable(src)) {
        (this._cache[src] = this.loadImage(src)).catch(function() {
        });
        return result;
      }
      return result;
    };
    Cache2.prototype.match = function(src) {
      return this._cache[src];
    };
    Cache2.prototype.loadImage = function(key) {
      return __awaiter(this, void 0, void 0, function() {
        var isSameOrigin, useCORS, useProxy, src;
        var _this = this;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              isSameOrigin = CacheStorage.isSameOrigin(key);
              useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
              useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
              if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) {
                return [
                  2
                  /*return*/
                ];
              }
              src = key;
              if (!useProxy) return [3, 2];
              return [4, this.proxy(src)];
            case 1:
              src = _a2.sent();
              _a2.label = 2;
            case 2:
              this.context.logger.debug("Added image " + key.substring(0, 256));
              return [4, new Promise(function(resolve, reject) {
                var img = new Image();
                img.onload = function() {
                  return resolve(img);
                };
                img.onerror = reject;
                if (isInlineBase64Image(src) || useCORS) {
                  img.crossOrigin = "anonymous";
                }
                img.src = src;
                if (img.complete === true) {
                  setTimeout(function() {
                    return resolve(img);
                  }, 500);
                }
                if (_this._options.imageTimeout > 0) {
                  setTimeout(function() {
                    return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                  }, _this._options.imageTimeout);
                }
              })];
            case 3:
              return [2, _a2.sent()];
          }
        });
      });
    };
    Cache2.prototype.has = function(key) {
      return typeof this._cache[key] !== "undefined";
    };
    Cache2.prototype.keys = function() {
      return Promise.resolve(Object.keys(this._cache));
    };
    Cache2.prototype.proxy = function(src) {
      var _this = this;
      var proxy = this._options.proxy;
      if (!proxy) {
        throw new Error("No proxy defined");
      }
      var key = src.substring(0, 256);
      return new Promise(function(resolve, reject) {
        var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
          if (xhr.status === 200) {
            if (responseType === "text") {
              resolve(xhr.response);
            } else {
              var reader_1 = new FileReader();
              reader_1.addEventListener("load", function() {
                return resolve(reader_1.result);
              }, false);
              reader_1.addEventListener("error", function(e2) {
                return reject(e2);
              }, false);
              reader_1.readAsDataURL(xhr.response);
            }
          } else {
            reject("Failed to proxy resource " + key + " with status code " + xhr.status);
          }
        };
        xhr.onerror = reject;
        var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
        xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
        if (responseType !== "text" && xhr instanceof XMLHttpRequest) {
          xhr.responseType = responseType;
        }
        if (_this._options.imageTimeout) {
          var timeout_1 = _this._options.imageTimeout;
          xhr.timeout = timeout_1;
          xhr.ontimeout = function() {
            return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
          };
        }
        xhr.send();
      });
    };
    return Cache2;
  }()
);
var INLINE_SVG = /^data:image\/svg\+xml/i;
var INLINE_BASE64 = /^data:image\/.*;base64,/i;
var INLINE_IMG = /^data:image\/.*/i;
var isRenderable = function(src) {
  return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
};
var isInlineImage = function(src) {
  return INLINE_IMG.test(src);
};
var isInlineBase64Image = function(src) {
  return INLINE_BASE64.test(src);
};
var isBlobImage = function(src) {
  return src.substr(0, 4) === "blob";
};
var isSVG = function(src) {
  return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
};
var Vector = (
  /** @class */
  function() {
    function Vector5(x, y) {
      this.type = 0;
      this.x = x;
      this.y = y;
    }
    Vector5.prototype.add = function(deltaX, deltaY) {
      return new Vector5(this.x + deltaX, this.y + deltaY);
    };
    return Vector5;
  }()
);
var lerp = function(a3, b, t3) {
  return new Vector(a3.x + (b.x - a3.x) * t3, a3.y + (b.y - a3.y) * t3);
};
var BezierCurve = (
  /** @class */
  function() {
    function BezierCurve2(start, startControl, endControl, end) {
      this.type = 1;
      this.start = start;
      this.startControl = startControl;
      this.endControl = endControl;
      this.end = end;
    }
    BezierCurve2.prototype.subdivide = function(t3, firstHalf) {
      var ab = lerp(this.start, this.startControl, t3);
      var bc = lerp(this.startControl, this.endControl, t3);
      var cd = lerp(this.endControl, this.end, t3);
      var abbc = lerp(ab, bc, t3);
      var bccd = lerp(bc, cd, t3);
      var dest = lerp(abbc, bccd, t3);
      return firstHalf ? new BezierCurve2(this.start, ab, abbc, dest) : new BezierCurve2(dest, bccd, cd, this.end);
    };
    BezierCurve2.prototype.add = function(deltaX, deltaY) {
      return new BezierCurve2(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
    };
    BezierCurve2.prototype.reverse = function() {
      return new BezierCurve2(this.end, this.endControl, this.startControl, this.start);
    };
    return BezierCurve2;
  }()
);
var isBezierCurve = function(path) {
  return path.type === 1;
};
var BoundCurves = (
  /** @class */
  /* @__PURE__ */ function() {
    function BoundCurves2(element) {
      var styles = element.styles;
      var bounds = element.bounds;
      var _a2 = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a2[0], tlv = _a2[1];
      var _b2 = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b2[0], trv = _b2[1];
      var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
      var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
      var factors2 = [];
      factors2.push((tlh + trh) / bounds.width);
      factors2.push((blh + brh) / bounds.width);
      factors2.push((tlv + blv) / bounds.height);
      factors2.push((trv + brv) / bounds.height);
      var maxFactor = Math.max.apply(Math, factors2);
      if (maxFactor > 1) {
        tlh /= maxFactor;
        tlv /= maxFactor;
        trh /= maxFactor;
        trv /= maxFactor;
        brh /= maxFactor;
        brv /= maxFactor;
        blh /= maxFactor;
        blv /= maxFactor;
      }
      var topWidth = bounds.width - trh;
      var rightHeight = bounds.height - brv;
      var bottomWidth = bounds.width - brh;
      var leftHeight = bounds.height - blv;
      var borderTopWidth2 = styles.borderTopWidth;
      var borderRightWidth2 = styles.borderRightWidth;
      var borderBottomWidth2 = styles.borderBottomWidth;
      var borderLeftWidth2 = styles.borderLeftWidth;
      var paddingTop2 = getAbsoluteValue(styles.paddingTop, element.bounds.width);
      var paddingRight2 = getAbsoluteValue(styles.paddingRight, element.bounds.width);
      var paddingBottom2 = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
      var paddingLeft2 = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
      this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 3, bounds.top + borderTopWidth2 / 3, tlh - borderLeftWidth2 / 3, tlv - borderTopWidth2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 3, bounds.top + borderTopWidth2 / 3);
      this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth2 / 3, trh - borderRightWidth2 / 3, trv - borderTopWidth2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 3, bounds.top + borderTopWidth2 / 3);
      this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth2 / 3, brv - borderBottomWidth2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 3, bounds.top + bounds.height - borderBottomWidth2 / 3);
      this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 3, bounds.top + leftHeight, blh - borderLeftWidth2 / 3, blv - borderBottomWidth2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 3, bounds.top + bounds.height - borderBottomWidth2 / 3);
      this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + borderTopWidth2 * 2 / 3, tlh - borderLeftWidth2 * 2 / 3, tlv - borderTopWidth2 * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + borderTopWidth2 * 2 / 3);
      this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth2 * 2 / 3, trh - borderRightWidth2 * 2 / 3, trv - borderTopWidth2 * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 * 2 / 3, bounds.top + borderTopWidth2 * 2 / 3);
      this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth2 * 2 / 3, brv - borderBottomWidth2 * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 * 2 / 3, bounds.top + bounds.height - borderBottomWidth2 * 2 / 3);
      this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth2 * 2 / 3, blv - borderBottomWidth2 * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 * 2 / 3, bounds.top + bounds.height - borderBottomWidth2 * 2 / 3);
      this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 2, bounds.top + borderTopWidth2 / 2, tlh - borderLeftWidth2 / 2, tlv - borderTopWidth2 / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 2, bounds.top + borderTopWidth2 / 2);
      this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth2 / 2, trh - borderRightWidth2 / 2, trv - borderTopWidth2 / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 2, bounds.top + borderTopWidth2 / 2);
      this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth2 / 2, brv - borderBottomWidth2 / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2 / 2, bounds.top + bounds.height - borderBottomWidth2 / 2);
      this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 / 2, bounds.top + leftHeight, blh - borderLeftWidth2 / 2, blv - borderBottomWidth2 / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 / 2, bounds.top + bounds.height - borderBottomWidth2 / 2);
      this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
      this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
      this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
      this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
      this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2, bounds.top + borderTopWidth2, Math.max(0, tlh - borderLeftWidth2), Math.max(0, tlv - borderTopWidth2), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2, bounds.top + borderTopWidth2);
      this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth2), bounds.top + borderTopWidth2, topWidth > bounds.width + borderRightWidth2 ? 0 : Math.max(0, trh - borderRightWidth2), Math.max(0, trv - borderTopWidth2), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2, bounds.top + borderTopWidth2);
      this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth2), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth2), Math.max(0, brh - borderRightWidth2), Math.max(0, brv - borderBottomWidth2), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth2, bounds.top + bounds.height - borderBottomWidth2);
      this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth2), Math.max(0, blh - borderLeftWidth2), Math.max(0, blv - borderBottomWidth2), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2, bounds.top + bounds.height - borderBottomWidth2);
      this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + borderTopWidth2 + paddingTop2, Math.max(0, tlh - (borderLeftWidth2 + paddingLeft2)), Math.max(0, tlv - (borderTopWidth2 + paddingTop2)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + borderTopWidth2 + paddingTop2);
      this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth2 + paddingLeft2), bounds.top + borderTopWidth2 + paddingTop2, topWidth > bounds.width + borderLeftWidth2 + paddingLeft2 ? 0 : trh - borderLeftWidth2 + paddingLeft2, trv - (borderTopWidth2 + paddingTop2), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth2 + paddingRight2), bounds.top + borderTopWidth2 + paddingTop2);
      this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth2 + paddingLeft2)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth2 + paddingTop2), Math.max(0, brh - (borderRightWidth2 + paddingRight2)), brv - (borderBottomWidth2 + paddingBottom2), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth2 + paddingRight2), bounds.top + bounds.height - (borderBottomWidth2 + paddingBottom2));
      this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth2 + paddingLeft2)), blv - (borderBottomWidth2 + paddingBottom2), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth2 + paddingLeft2, bounds.top + bounds.height - (borderBottomWidth2 + paddingBottom2));
    }
    return BoundCurves2;
  }()
);
var CORNER;
(function(CORNER2) {
  CORNER2[CORNER2["TOP_LEFT"] = 0] = "TOP_LEFT";
  CORNER2[CORNER2["TOP_RIGHT"] = 1] = "TOP_RIGHT";
  CORNER2[CORNER2["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
  CORNER2[CORNER2["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
})(CORNER || (CORNER = {}));
var getCurvePoints = function(x, y, r1, r2, position2) {
  var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
  var ox = r1 * kappa;
  var oy = r2 * kappa;
  var xm = x + r1;
  var ym = y + r2;
  switch (position2) {
    case CORNER.TOP_LEFT:
      return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
    case CORNER.TOP_RIGHT:
      return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
    case CORNER.BOTTOM_RIGHT:
      return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
    case CORNER.BOTTOM_LEFT:
    default:
      return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
  }
};
var calculateBorderBoxPath = function(curves) {
  return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
};
var calculateContentBoxPath = function(curves) {
  return [
    curves.topLeftContentBox,
    curves.topRightContentBox,
    curves.bottomRightContentBox,
    curves.bottomLeftContentBox
  ];
};
var calculatePaddingBoxPath = function(curves) {
  return [
    curves.topLeftPaddingBox,
    curves.topRightPaddingBox,
    curves.bottomRightPaddingBox,
    curves.bottomLeftPaddingBox
  ];
};
var TransformEffect = (
  /** @class */
  /* @__PURE__ */ function() {
    function TransformEffect2(offsetX, offsetY, matrix2) {
      this.offsetX = offsetX;
      this.offsetY = offsetY;
      this.matrix = matrix2;
      this.type = 0;
      this.target = 2 | 4;
    }
    return TransformEffect2;
  }()
);
var ClipEffect = (
  /** @class */
  /* @__PURE__ */ function() {
    function ClipEffect2(path, target) {
      this.path = path;
      this.target = target;
      this.type = 1;
    }
    return ClipEffect2;
  }()
);
var OpacityEffect = (
  /** @class */
  /* @__PURE__ */ function() {
    function OpacityEffect2(opacity2) {
      this.opacity = opacity2;
      this.type = 2;
      this.target = 2 | 4;
    }
    return OpacityEffect2;
  }()
);
var isTransformEffect = function(effect) {
  return effect.type === 0;
};
var isClipEffect = function(effect) {
  return effect.type === 1;
};
var isOpacityEffect = function(effect) {
  return effect.type === 2;
};
var equalPath = function(a3, b) {
  if (a3.length === b.length) {
    return a3.some(function(v, i2) {
      return v === b[i2];
    });
  }
  return false;
};
var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
  return path.map(function(point2, index2) {
    switch (index2) {
      case 0:
        return point2.add(deltaX, deltaY);
      case 1:
        return point2.add(deltaX + deltaW, deltaY);
      case 2:
        return point2.add(deltaX + deltaW, deltaY + deltaH);
      case 3:
        return point2.add(deltaX, deltaY + deltaH);
    }
    return point2;
  });
};
var StackingContext = (
  /** @class */
  /* @__PURE__ */ function() {
    function StackingContext2(container) {
      this.element = container;
      this.inlineLevel = [];
      this.nonInlineLevel = [];
      this.negativeZIndex = [];
      this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
      this.positiveZIndex = [];
      this.nonPositionedFloats = [];
      this.nonPositionedInlineLevel = [];
    }
    return StackingContext2;
  }()
);
var ElementPaint = (
  /** @class */
  function() {
    function ElementPaint2(container, parent2) {
      this.container = container;
      this.parent = parent2;
      this.effects = [];
      this.curves = new BoundCurves(this.container);
      if (this.container.styles.opacity < 1) {
        this.effects.push(new OpacityEffect(this.container.styles.opacity));
      }
      if (this.container.styles.transform !== null) {
        var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
        var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
        var matrix2 = this.container.styles.transform;
        this.effects.push(new TransformEffect(offsetX, offsetY, matrix2));
      }
      if (this.container.styles.overflowX !== 0) {
        var borderBox = calculateBorderBoxPath(this.curves);
        var paddingBox2 = calculatePaddingBoxPath(this.curves);
        if (equalPath(borderBox, paddingBox2)) {
          this.effects.push(new ClipEffect(
            borderBox,
            2 | 4
            /* CONTENT */
          ));
        } else {
          this.effects.push(new ClipEffect(
            borderBox,
            2
            /* BACKGROUND_BORDERS */
          ));
          this.effects.push(new ClipEffect(
            paddingBox2,
            4
            /* CONTENT */
          ));
        }
      }
    }
    ElementPaint2.prototype.getEffects = function(target) {
      var inFlow = [
        2,
        3
        /* FIXED */
      ].indexOf(this.container.styles.position) === -1;
      var parent2 = this.parent;
      var effects = this.effects.slice(0);
      while (parent2) {
        var croplessEffects = parent2.effects.filter(function(effect) {
          return !isClipEffect(effect);
        });
        if (inFlow || parent2.container.styles.position !== 0 || !parent2.parent) {
          effects.unshift.apply(effects, croplessEffects);
          inFlow = [
            2,
            3
            /* FIXED */
          ].indexOf(parent2.container.styles.position) === -1;
          if (parent2.container.styles.overflowX !== 0) {
            var borderBox = calculateBorderBoxPath(parent2.curves);
            var paddingBox2 = calculatePaddingBoxPath(parent2.curves);
            if (!equalPath(borderBox, paddingBox2)) {
              effects.unshift(new ClipEffect(
                paddingBox2,
                2 | 4
                /* CONTENT */
              ));
            }
          }
        } else {
          effects.unshift.apply(effects, croplessEffects);
        }
        parent2 = parent2.parent;
      }
      return effects.filter(function(effect) {
        return contains(effect.target, target);
      });
    };
    return ElementPaint2;
  }()
);
var parseStackTree = function(parent2, stackingContext, realStackingContext, listItems) {
  parent2.container.elements.forEach(function(child) {
    var treatAsRealStackingContext = contains(
      child.flags,
      4
      /* CREATES_REAL_STACKING_CONTEXT */
    );
    var createsStackingContext2 = contains(
      child.flags,
      2
      /* CREATES_STACKING_CONTEXT */
    );
    var paintContainer = new ElementPaint(child, parent2);
    if (contains(
      child.styles.display,
      2048
      /* LIST_ITEM */
    )) {
      listItems.push(paintContainer);
    }
    var listOwnerItems = contains(
      child.flags,
      8
      /* IS_LIST_OWNER */
    ) ? [] : listItems;
    if (treatAsRealStackingContext || createsStackingContext2) {
      var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
      var stack = new StackingContext(paintContainer);
      if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
        var order_1 = child.styles.zIndex.order;
        if (order_1 < 0) {
          var index_1 = 0;
          parentStack.negativeZIndex.some(function(current, i2) {
            if (order_1 > current.element.container.styles.zIndex.order) {
              index_1 = i2;
              return false;
            } else if (index_1 > 0) {
              return true;
            }
            return false;
          });
          parentStack.negativeZIndex.splice(index_1, 0, stack);
        } else if (order_1 > 0) {
          var index_2 = 0;
          parentStack.positiveZIndex.some(function(current, i2) {
            if (order_1 >= current.element.container.styles.zIndex.order) {
              index_2 = i2 + 1;
              return false;
            } else if (index_2 > 0) {
              return true;
            }
            return false;
          });
          parentStack.positiveZIndex.splice(index_2, 0, stack);
        } else {
          parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
        }
      } else {
        if (child.styles.isFloating()) {
          parentStack.nonPositionedFloats.push(stack);
        } else {
          parentStack.nonPositionedInlineLevel.push(stack);
        }
      }
      parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
    } else {
      if (child.styles.isInlineLevel()) {
        stackingContext.inlineLevel.push(paintContainer);
      } else {
        stackingContext.nonInlineLevel.push(paintContainer);
      }
      parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
    }
    if (contains(
      child.flags,
      8
      /* IS_LIST_OWNER */
    )) {
      processListItems(child, listOwnerItems);
    }
  });
};
var processListItems = function(owner, elements) {
  var numbering = owner instanceof OLElementContainer ? owner.start : 1;
  var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
  for (var i2 = 0; i2 < elements.length; i2++) {
    var item = elements[i2];
    if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) {
      numbering = item.container.value;
    }
    item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
    numbering += reversed ? -1 : 1;
  }
};
var parseStackingContexts = function(container) {
  var paintContainer = new ElementPaint(container, null);
  var root = new StackingContext(paintContainer);
  var listItems = [];
  parseStackTree(paintContainer, root, root, listItems);
  processListItems(paintContainer.container, listItems);
  return root;
};
var parsePathForBorder = function(curves, borderSide) {
  switch (borderSide) {
    case 0:
      return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
    case 1:
      return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
    case 2:
      return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
    case 3:
    default:
      return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
  }
};
var parsePathForBorderDoubleOuter = function(curves, borderSide) {
  switch (borderSide) {
    case 0:
      return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
    case 1:
      return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
    case 2:
      return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
    case 3:
    default:
      return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
  }
};
var parsePathForBorderDoubleInner = function(curves, borderSide) {
  switch (borderSide) {
    case 0:
      return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
    case 1:
      return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
    case 2:
      return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
    case 3:
    default:
      return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
  }
};
var parsePathForBorderStroke = function(curves, borderSide) {
  switch (borderSide) {
    case 0:
      return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
    case 1:
      return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
    case 2:
      return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
    case 3:
    default:
      return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
  }
};
var createStrokePathFromCurves = function(outer1, outer2) {
  var path = [];
  if (isBezierCurve(outer1)) {
    path.push(outer1.subdivide(0.5, false));
  } else {
    path.push(outer1);
  }
  if (isBezierCurve(outer2)) {
    path.push(outer2.subdivide(0.5, true));
  } else {
    path.push(outer2);
  }
  return path;
};
var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
  var path = [];
  if (isBezierCurve(outer1)) {
    path.push(outer1.subdivide(0.5, false));
  } else {
    path.push(outer1);
  }
  if (isBezierCurve(outer2)) {
    path.push(outer2.subdivide(0.5, true));
  } else {
    path.push(outer2);
  }
  if (isBezierCurve(inner2)) {
    path.push(inner2.subdivide(0.5, true).reverse());
  } else {
    path.push(inner2);
  }
  if (isBezierCurve(inner1)) {
    path.push(inner1.subdivide(0.5, false).reverse());
  } else {
    path.push(inner1);
  }
  return path;
};
var paddingBox = function(element) {
  var bounds = element.bounds;
  var styles = element.styles;
  return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
};
var contentBox = function(element) {
  var styles = element.styles;
  var bounds = element.bounds;
  var paddingLeft2 = getAbsoluteValue(styles.paddingLeft, bounds.width);
  var paddingRight2 = getAbsoluteValue(styles.paddingRight, bounds.width);
  var paddingTop2 = getAbsoluteValue(styles.paddingTop, bounds.width);
  var paddingBottom2 = getAbsoluteValue(styles.paddingBottom, bounds.width);
  return bounds.add(paddingLeft2 + styles.borderLeftWidth, paddingTop2 + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft2 + paddingRight2), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop2 + paddingBottom2));
};
var calculateBackgroundPositioningArea = function(backgroundOrigin2, element) {
  if (backgroundOrigin2 === 0) {
    return element.bounds;
  }
  if (backgroundOrigin2 === 2) {
    return contentBox(element);
  }
  return paddingBox(element);
};
var calculateBackgroundPaintingArea = function(backgroundClip2, element) {
  if (backgroundClip2 === 0) {
    return element.bounds;
  }
  if (backgroundClip2 === 2) {
    return contentBox(element);
  }
  return paddingBox(element);
};
var calculateBackgroundRendering = function(container, index2, intrinsicSize) {
  var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index2), container);
  var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index2), container);
  var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index2), intrinsicSize, backgroundPositioningArea);
  var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
  var position2 = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index2), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
  var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index2), position2, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
  var offsetX = Math.round(backgroundPositioningArea.left + position2[0]);
  var offsetY = Math.round(backgroundPositioningArea.top + position2[1]);
  return [path, offsetX, offsetY, sizeWidth, sizeHeight];
};
var isAuto = function(token) {
  return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
};
var hasIntrinsicValue = function(value) {
  return typeof value === "number";
};
var calculateBackgroundSize = function(size, _a2, bounds) {
  var intrinsicWidth = _a2[0], intrinsicHeight = _a2[1], intrinsicProportion = _a2[2];
  var first = size[0], second = size[1];
  if (!first) {
    return [0, 0];
  }
  if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
    return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
  }
  var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
  if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
    if (hasIntrinsicValue(intrinsicProportion)) {
      var targetRatio = bounds.width / bounds.height;
      return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [bounds.width, bounds.width / intrinsicProportion] : [bounds.height * intrinsicProportion, bounds.height];
    }
    return [bounds.width, bounds.height];
  }
  var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
  var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
  var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
  if (isAuto(first) && (!second || isAuto(second))) {
    if (hasIntrinsicWidth && hasIntrinsicHeight) {
      return [intrinsicWidth, intrinsicHeight];
    }
    if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
      return [bounds.width, bounds.height];
    }
    if (hasIntrinsicDimensions && hasIntrinsicProportion) {
      var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
      var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
      return [width_1, height_1];
    }
    var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
    var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
    return [width_2, height_2];
  }
  if (hasIntrinsicProportion) {
    var width_3 = 0;
    var height_3 = 0;
    if (isLengthPercentage(first)) {
      width_3 = getAbsoluteValue(first, bounds.width);
    } else if (isLengthPercentage(second)) {
      height_3 = getAbsoluteValue(second, bounds.height);
    }
    if (isAuto(first)) {
      width_3 = height_3 * intrinsicProportion;
    } else if (!second || isAuto(second)) {
      height_3 = width_3 / intrinsicProportion;
    }
    return [width_3, height_3];
  }
  var width = null;
  var height = null;
  if (isLengthPercentage(first)) {
    width = getAbsoluteValue(first, bounds.width);
  } else if (second && isLengthPercentage(second)) {
    height = getAbsoluteValue(second, bounds.height);
  }
  if (width !== null && (!second || isAuto(second))) {
    height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
  }
  if (height !== null && isAuto(first)) {
    width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
  }
  if (width !== null && height !== null) {
    return [width, height];
  }
  throw new Error("Unable to calculate background-size for element");
};
var getBackgroundValueForIndex = function(values, index2) {
  var value = values[index2];
  if (typeof value === "undefined") {
    return values[0];
  }
  return value;
};
var calculateBackgroundRepeatPath = function(repeat, _a2, _b2, backgroundPositioningArea, backgroundPaintingArea) {
  var x = _a2[0], y = _a2[1];
  var width = _b2[0], height = _b2[1];
  switch (repeat) {
    case 2:
      return [
        new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
        new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
        new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
        new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
      ];
    case 3:
      return [
        new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
        new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
        new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
        new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
      ];
    case 1:
      return [
        new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
        new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
        new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
        new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
      ];
    default:
      return [
        new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
        new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
        new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
        new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
      ];
  }
};
var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
var SAMPLE_TEXT = "Hidden Text";
var FontMetrics = (
  /** @class */
  function() {
    function FontMetrics2(document2) {
      this._data = {};
      this._document = document2;
    }
    FontMetrics2.prototype.parseMetrics = function(fontFamily2, fontSize2) {
      var container = this._document.createElement("div");
      var img = this._document.createElement("img");
      var span = this._document.createElement("span");
      var body = this._document.body;
      container.style.visibility = "hidden";
      container.style.fontFamily = fontFamily2;
      container.style.fontSize = fontSize2;
      container.style.margin = "0";
      container.style.padding = "0";
      container.style.whiteSpace = "nowrap";
      body.appendChild(container);
      img.src = SMALL_IMAGE;
      img.width = 1;
      img.height = 1;
      img.style.margin = "0";
      img.style.padding = "0";
      img.style.verticalAlign = "baseline";
      span.style.fontFamily = fontFamily2;
      span.style.fontSize = fontSize2;
      span.style.margin = "0";
      span.style.padding = "0";
      span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
      container.appendChild(span);
      container.appendChild(img);
      var baseline = img.offsetTop - span.offsetTop + 2;
      container.removeChild(span);
      container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
      container.style.lineHeight = "normal";
      img.style.verticalAlign = "super";
      var middle = img.offsetTop - container.offsetTop + 2;
      body.removeChild(container);
      return { baseline, middle };
    };
    FontMetrics2.prototype.getMetrics = function(fontFamily2, fontSize2) {
      var key = fontFamily2 + " " + fontSize2;
      if (typeof this._data[key] === "undefined") {
        this._data[key] = this.parseMetrics(fontFamily2, fontSize2);
      }
      return this._data[key];
    };
    return FontMetrics2;
  }()
);
var Renderer = (
  /** @class */
  /* @__PURE__ */ function() {
    function Renderer2(context, options) {
      this.context = context;
      this.options = options;
    }
    return Renderer2;
  }()
);
var MASK_OFFSET = 1e4;
var CanvasRenderer = (
  /** @class */
  function(_super) {
    __extends(CanvasRenderer2, _super);
    function CanvasRenderer2(context, options) {
      var _this = _super.call(this, context, options) || this;
      _this._activeEffects = [];
      _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
      _this.ctx = _this.canvas.getContext("2d");
      if (!options.canvas) {
        _this.canvas.width = Math.floor(options.width * options.scale);
        _this.canvas.height = Math.floor(options.height * options.scale);
        _this.canvas.style.width = options.width + "px";
        _this.canvas.style.height = options.height + "px";
      }
      _this.fontMetrics = new FontMetrics(document);
      _this.ctx.scale(_this.options.scale, _this.options.scale);
      _this.ctx.translate(-options.x, -options.y);
      _this.ctx.textBaseline = "bottom";
      _this._activeEffects = [];
      _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
      return _this;
    }
    CanvasRenderer2.prototype.applyEffects = function(effects) {
      var _this = this;
      while (this._activeEffects.length) {
        this.popEffect();
      }
      effects.forEach(function(effect) {
        return _this.applyEffect(effect);
      });
    };
    CanvasRenderer2.prototype.applyEffect = function(effect) {
      this.ctx.save();
      if (isOpacityEffect(effect)) {
        this.ctx.globalAlpha = effect.opacity;
      }
      if (isTransformEffect(effect)) {
        this.ctx.translate(effect.offsetX, effect.offsetY);
        this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
        this.ctx.translate(-effect.offsetX, -effect.offsetY);
      }
      if (isClipEffect(effect)) {
        this.path(effect.path);
        this.ctx.clip();
      }
      this._activeEffects.push(effect);
    };
    CanvasRenderer2.prototype.popEffect = function() {
      this._activeEffects.pop();
      this.ctx.restore();
    };
    CanvasRenderer2.prototype.renderStack = function(stack) {
      return __awaiter(this, void 0, void 0, function() {
        var styles;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              styles = stack.element.container.styles;
              if (!styles.isVisible()) return [3, 2];
              return [4, this.renderStackContent(stack)];
            case 1:
              _a2.sent();
              _a2.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    CanvasRenderer2.prototype.renderNode = function(paint) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (contains(
                paint.container.flags,
                16
                /* DEBUG_RENDER */
              )) {
                debugger;
              }
              if (!paint.container.styles.isVisible()) return [3, 3];
              return [4, this.renderNodeBackgroundAndBorders(paint)];
            case 1:
              _a2.sent();
              return [4, this.renderNodeContent(paint)];
            case 2:
              _a2.sent();
              _a2.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    CanvasRenderer2.prototype.renderTextWithLetterSpacing = function(text, letterSpacing2, baseline) {
      var _this = this;
      if (letterSpacing2 === 0) {
        this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
      } else {
        var letters = segmentGraphemes(text.text);
        letters.reduce(function(left, letter) {
          _this.ctx.fillText(letter, left, text.bounds.top + baseline);
          return left + _this.ctx.measureText(letter).width;
        }, text.bounds.left);
      }
    };
    CanvasRenderer2.prototype.createFontStyle = function(styles) {
      var fontVariant2 = styles.fontVariant.filter(function(variant) {
        return variant === "normal" || variant === "small-caps";
      }).join("");
      var fontFamily2 = fixIOSSystemFonts(styles.fontFamily).join(", ");
      var fontSize2 = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
      return [
        [styles.fontStyle, fontVariant2, styles.fontWeight, fontSize2, fontFamily2].join(" "),
        fontFamily2,
        fontSize2
      ];
    };
    CanvasRenderer2.prototype.renderTextNode = function(text, styles) {
      return __awaiter(this, void 0, void 0, function() {
        var _a2, font, fontFamily2, fontSize2, _b2, baseline, middle, paintOrder2;
        var _this = this;
        return __generator(this, function(_c) {
          _a2 = this.createFontStyle(styles), font = _a2[0], fontFamily2 = _a2[1], fontSize2 = _a2[2];
          this.ctx.font = font;
          this.ctx.direction = styles.direction === 1 ? "rtl" : "ltr";
          this.ctx.textAlign = "left";
          this.ctx.textBaseline = "alphabetic";
          _b2 = this.fontMetrics.getMetrics(fontFamily2, fontSize2), baseline = _b2.baseline, middle = _b2.middle;
          paintOrder2 = styles.paintOrder;
          text.textBounds.forEach(function(text2) {
            paintOrder2.forEach(function(paintOrderLayer) {
              switch (paintOrderLayer) {
                case 0:
                  _this.ctx.fillStyle = asString(styles.color);
                  _this.renderTextWithLetterSpacing(text2, styles.letterSpacing, baseline);
                  var textShadows = styles.textShadow;
                  if (textShadows.length && text2.text.trim().length) {
                    textShadows.slice(0).reverse().forEach(function(textShadow2) {
                      _this.ctx.shadowColor = asString(textShadow2.color);
                      _this.ctx.shadowOffsetX = textShadow2.offsetX.number * _this.options.scale;
                      _this.ctx.shadowOffsetY = textShadow2.offsetY.number * _this.options.scale;
                      _this.ctx.shadowBlur = textShadow2.blur.number;
                      _this.renderTextWithLetterSpacing(text2, styles.letterSpacing, baseline);
                    });
                    _this.ctx.shadowColor = "";
                    _this.ctx.shadowOffsetX = 0;
                    _this.ctx.shadowOffsetY = 0;
                    _this.ctx.shadowBlur = 0;
                  }
                  if (styles.textDecorationLine.length) {
                    _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                    styles.textDecorationLine.forEach(function(textDecorationLine2) {
                      switch (textDecorationLine2) {
                        case 1:
                          _this.ctx.fillRect(text2.bounds.left, Math.round(text2.bounds.top + baseline), text2.bounds.width, 1);
                          break;
                        case 2:
                          _this.ctx.fillRect(text2.bounds.left, Math.round(text2.bounds.top), text2.bounds.width, 1);
                          break;
                        case 3:
                          _this.ctx.fillRect(text2.bounds.left, Math.ceil(text2.bounds.top + middle), text2.bounds.width, 1);
                          break;
                      }
                    });
                  }
                  break;
                case 1:
                  if (styles.webkitTextStrokeWidth && text2.text.trim().length) {
                    _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                    _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                    _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                    _this.ctx.strokeText(text2.text, text2.bounds.left, text2.bounds.top + baseline);
                  }
                  _this.ctx.strokeStyle = "";
                  _this.ctx.lineWidth = 0;
                  _this.ctx.lineJoin = "miter";
                  break;
              }
            });
          });
          return [
            2
            /*return*/
          ];
        });
      });
    };
    CanvasRenderer2.prototype.renderReplacedElement = function(container, curves, image2) {
      if (image2 && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
        var box = contentBox(container);
        var path = calculatePaddingBoxPath(curves);
        this.path(path);
        this.ctx.save();
        this.ctx.clip();
        this.ctx.drawImage(image2, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
        this.ctx.restore();
      }
    };
    CanvasRenderer2.prototype.renderNodeContent = function(paint) {
      return __awaiter(this, void 0, void 0, function() {
        var container, curves, styles, _i, _a2, child, image2, image2, iframeRenderer, canvas, size, _b2, fontFamily2, fontSize2, baseline, bounds, x, textBounds, img, image2, url, fontFamily2, bounds;
        return __generator(this, function(_c) {
          switch (_c.label) {
            case 0:
              this.applyEffects(paint.getEffects(
                4
                /* CONTENT */
              ));
              container = paint.container;
              curves = paint.curves;
              styles = container.styles;
              _i = 0, _a2 = container.textNodes;
              _c.label = 1;
            case 1:
              if (!(_i < _a2.length)) return [3, 4];
              child = _a2[_i];
              return [4, this.renderTextNode(child, styles)];
            case 2:
              _c.sent();
              _c.label = 3;
            case 3:
              _i++;
              return [3, 1];
            case 4:
              if (!(container instanceof ImageElementContainer)) return [3, 8];
              _c.label = 5;
            case 5:
              _c.trys.push([5, 7, , 8]);
              return [4, this.context.cache.match(container.src)];
            case 6:
              image2 = _c.sent();
              this.renderReplacedElement(container, curves, image2);
              return [3, 8];
            case 7:
              _c.sent();
              this.context.logger.error("Error loading image " + container.src);
              return [3, 8];
            case 8:
              if (container instanceof CanvasElementContainer) {
                this.renderReplacedElement(container, curves, container.canvas);
              }
              if (!(container instanceof SVGElementContainer)) return [3, 12];
              _c.label = 9;
            case 9:
              _c.trys.push([9, 11, , 12]);
              return [4, this.context.cache.match(container.svg)];
            case 10:
              image2 = _c.sent();
              this.renderReplacedElement(container, curves, image2);
              return [3, 12];
            case 11:
              _c.sent();
              this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
              return [3, 12];
            case 12:
              if (!(container instanceof IFrameElementContainer && container.tree)) return [3, 14];
              iframeRenderer = new CanvasRenderer2(this.context, {
                scale: this.options.scale,
                backgroundColor: container.backgroundColor,
                x: 0,
                y: 0,
                width: container.width,
                height: container.height
              });
              return [4, iframeRenderer.render(container.tree)];
            case 13:
              canvas = _c.sent();
              if (container.width && container.height) {
                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
              }
              _c.label = 14;
            case 14:
              if (container instanceof InputElementContainer) {
                size = Math.min(container.bounds.width, container.bounds.height);
                if (container.type === CHECKBOX) {
                  if (container.checked) {
                    this.ctx.save();
                    this.path([
                      new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                      new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                      new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                      new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                      new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                      new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                      new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                    ]);
                    this.ctx.fillStyle = asString(INPUT_COLOR);
                    this.ctx.fill();
                    this.ctx.restore();
                  }
                } else if (container.type === RADIO) {
                  if (container.checked) {
                    this.ctx.save();
                    this.ctx.beginPath();
                    this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                    this.ctx.fillStyle = asString(INPUT_COLOR);
                    this.ctx.fill();
                    this.ctx.restore();
                  }
                }
              }
              if (isTextInputElement(container) && container.value.length) {
                _b2 = this.createFontStyle(styles), fontFamily2 = _b2[0], fontSize2 = _b2[1];
                baseline = this.fontMetrics.getMetrics(fontFamily2, fontSize2).baseline;
                this.ctx.font = fontFamily2;
                this.ctx.fillStyle = asString(styles.color);
                this.ctx.textBaseline = "alphabetic";
                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                bounds = contentBox(container);
                x = 0;
                switch (container.styles.textAlign) {
                  case 1:
                    x += bounds.width / 2;
                    break;
                  case 2:
                    x += bounds.width;
                    break;
                }
                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                this.ctx.save();
                this.path([
                  new Vector(bounds.left, bounds.top),
                  new Vector(bounds.left + bounds.width, bounds.top),
                  new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                  new Vector(bounds.left, bounds.top + bounds.height)
                ]);
                this.ctx.clip();
                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                this.ctx.restore();
                this.ctx.textBaseline = "alphabetic";
                this.ctx.textAlign = "left";
              }
              if (!contains(
                container.styles.display,
                2048
                /* LIST_ITEM */
              )) return [3, 20];
              if (!(container.styles.listStyleImage !== null)) return [3, 19];
              img = container.styles.listStyleImage;
              if (!(img.type === 0)) return [3, 18];
              image2 = void 0;
              url = img.url;
              _c.label = 15;
            case 15:
              _c.trys.push([15, 17, , 18]);
              return [4, this.context.cache.match(url)];
            case 16:
              image2 = _c.sent();
              this.ctx.drawImage(image2, container.bounds.left - (image2.width + 10), container.bounds.top);
              return [3, 18];
            case 17:
              _c.sent();
              this.context.logger.error("Error loading list-style-image " + url);
              return [3, 18];
            case 18:
              return [3, 20];
            case 19:
              if (paint.listValue && container.styles.listStyleType !== -1) {
                fontFamily2 = this.createFontStyle(styles)[0];
                this.ctx.font = fontFamily2;
                this.ctx.fillStyle = asString(styles.color);
                this.ctx.textBaseline = "middle";
                this.ctx.textAlign = "right";
                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                this.ctx.textBaseline = "bottom";
                this.ctx.textAlign = "left";
              }
              _c.label = 20;
            case 20:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    CanvasRenderer2.prototype.renderStackContent = function(stack) {
      return __awaiter(this, void 0, void 0, function() {
        var _i, _a2, child, _b2, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
        return __generator(this, function(_p) {
          switch (_p.label) {
            case 0:
              if (contains(
                stack.element.container.flags,
                16
                /* DEBUG_RENDER */
              )) {
                debugger;
              }
              return [4, this.renderNodeBackgroundAndBorders(stack.element)];
            case 1:
              _p.sent();
              _i = 0, _a2 = stack.negativeZIndex;
              _p.label = 2;
            case 2:
              if (!(_i < _a2.length)) return [3, 5];
              child = _a2[_i];
              return [4, this.renderStack(child)];
            case 3:
              _p.sent();
              _p.label = 4;
            case 4:
              _i++;
              return [3, 2];
            case 5:
              return [4, this.renderNodeContent(stack.element)];
            case 6:
              _p.sent();
              _b2 = 0, _c = stack.nonInlineLevel;
              _p.label = 7;
            case 7:
              if (!(_b2 < _c.length)) return [3, 10];
              child = _c[_b2];
              return [4, this.renderNode(child)];
            case 8:
              _p.sent();
              _p.label = 9;
            case 9:
              _b2++;
              return [3, 7];
            case 10:
              _d = 0, _e = stack.nonPositionedFloats;
              _p.label = 11;
            case 11:
              if (!(_d < _e.length)) return [3, 14];
              child = _e[_d];
              return [4, this.renderStack(child)];
            case 12:
              _p.sent();
              _p.label = 13;
            case 13:
              _d++;
              return [3, 11];
            case 14:
              _f = 0, _g = stack.nonPositionedInlineLevel;
              _p.label = 15;
            case 15:
              if (!(_f < _g.length)) return [3, 18];
              child = _g[_f];
              return [4, this.renderStack(child)];
            case 16:
              _p.sent();
              _p.label = 17;
            case 17:
              _f++;
              return [3, 15];
            case 18:
              _h = 0, _j = stack.inlineLevel;
              _p.label = 19;
            case 19:
              if (!(_h < _j.length)) return [3, 22];
              child = _j[_h];
              return [4, this.renderNode(child)];
            case 20:
              _p.sent();
              _p.label = 21;
            case 21:
              _h++;
              return [3, 19];
            case 22:
              _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
              _p.label = 23;
            case 23:
              if (!(_k < _l.length)) return [3, 26];
              child = _l[_k];
              return [4, this.renderStack(child)];
            case 24:
              _p.sent();
              _p.label = 25;
            case 25:
              _k++;
              return [3, 23];
            case 26:
              _m = 0, _o = stack.positiveZIndex;
              _p.label = 27;
            case 27:
              if (!(_m < _o.length)) return [3, 30];
              child = _o[_m];
              return [4, this.renderStack(child)];
            case 28:
              _p.sent();
              _p.label = 29;
            case 29:
              _m++;
              return [3, 27];
            case 30:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    CanvasRenderer2.prototype.mask = function(paths) {
      this.ctx.beginPath();
      this.ctx.moveTo(0, 0);
      this.ctx.lineTo(this.canvas.width, 0);
      this.ctx.lineTo(this.canvas.width, this.canvas.height);
      this.ctx.lineTo(0, this.canvas.height);
      this.ctx.lineTo(0, 0);
      this.formatPath(paths.slice(0).reverse());
      this.ctx.closePath();
    };
    CanvasRenderer2.prototype.path = function(paths) {
      this.ctx.beginPath();
      this.formatPath(paths);
      this.ctx.closePath();
    };
    CanvasRenderer2.prototype.formatPath = function(paths) {
      var _this = this;
      paths.forEach(function(point2, index2) {
        var start = isBezierCurve(point2) ? point2.start : point2;
        if (index2 === 0) {
          _this.ctx.moveTo(start.x, start.y);
        } else {
          _this.ctx.lineTo(start.x, start.y);
        }
        if (isBezierCurve(point2)) {
          _this.ctx.bezierCurveTo(point2.startControl.x, point2.startControl.y, point2.endControl.x, point2.endControl.y, point2.end.x, point2.end.y);
        }
      });
    };
    CanvasRenderer2.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
      this.path(path);
      this.ctx.fillStyle = pattern;
      this.ctx.translate(offsetX, offsetY);
      this.ctx.fill();
      this.ctx.translate(-offsetX, -offsetY);
    };
    CanvasRenderer2.prototype.resizeImage = function(image2, width, height) {
      var _a2;
      if (image2.width === width && image2.height === height) {
        return image2;
      }
      var ownerDocument = (_a2 = this.canvas.ownerDocument) !== null && _a2 !== void 0 ? _a2 : document;
      var canvas = ownerDocument.createElement("canvas");
      canvas.width = Math.max(1, width);
      canvas.height = Math.max(1, height);
      var ctx = canvas.getContext("2d");
      ctx.drawImage(image2, 0, 0, image2.width, image2.height, 0, 0, width, height);
      return canvas;
    };
    CanvasRenderer2.prototype.renderBackgroundImage = function(container) {
      return __awaiter(this, void 0, void 0, function() {
        var index2, _loop_1, this_1, _i, _a2, backgroundImage2;
        return __generator(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              index2 = container.styles.backgroundImage.length - 1;
              _loop_1 = function(backgroundImage3) {
                var image2, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position2, x, y, _g, rx, ry, radialGradient_1, midX, midY, f2, invF;
                return __generator(this, function(_h) {
                  switch (_h.label) {
                    case 0:
                      if (!(backgroundImage3.type === 0)) return [3, 5];
                      image2 = void 0;
                      url = backgroundImage3.url;
                      _h.label = 1;
                    case 1:
                      _h.trys.push([1, 3, , 4]);
                      return [4, this_1.context.cache.match(url)];
                    case 2:
                      image2 = _h.sent();
                      return [3, 4];
                    case 3:
                      _h.sent();
                      this_1.context.logger.error("Error loading background-image " + url);
                      return [3, 4];
                    case 4:
                      if (image2) {
                        _c = calculateBackgroundRendering(container, index2, [
                          image2.width,
                          image2.height,
                          image2.width / image2.height
                        ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                        pattern = this_1.ctx.createPattern(this_1.resizeImage(image2, width, height), "repeat");
                        this_1.renderRepeat(path, pattern, x, y);
                      }
                      return [3, 6];
                    case 5:
                      if (isLinearGradient(backgroundImage3)) {
                        _d = calculateBackgroundRendering(container, index2, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                        _e = calculateGradientDirection(backgroundImage3.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                        canvas = document.createElement("canvas");
                        canvas.width = width;
                        canvas.height = height;
                        ctx = canvas.getContext("2d");
                        gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                        processColorStops(backgroundImage3.stops, lineLength).forEach(function(colorStop) {
                          return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                        });
                        ctx.fillStyle = gradient_1;
                        ctx.fillRect(0, 0, width, height);
                        if (width > 0 && height > 0) {
                          pattern = this_1.ctx.createPattern(canvas, "repeat");
                          this_1.renderRepeat(path, pattern, x, y);
                        }
                      } else if (isRadialGradient(backgroundImage3)) {
                        _f = calculateBackgroundRendering(container, index2, [
                          null,
                          null,
                          null
                        ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                        position2 = backgroundImage3.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage3.position;
                        x = getAbsoluteValue(position2[0], width);
                        y = getAbsoluteValue(position2[position2.length - 1], height);
                        _g = calculateRadius(backgroundImage3, x, y, width, height), rx = _g[0], ry = _g[1];
                        if (rx > 0 && ry > 0) {
                          radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                          processColorStops(backgroundImage3.stops, rx * 2).forEach(function(colorStop) {
                            return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                          });
                          this_1.path(path);
                          this_1.ctx.fillStyle = radialGradient_1;
                          if (rx !== ry) {
                            midX = container.bounds.left + 0.5 * container.bounds.width;
                            midY = container.bounds.top + 0.5 * container.bounds.height;
                            f2 = ry / rx;
                            invF = 1 / f2;
                            this_1.ctx.save();
                            this_1.ctx.translate(midX, midY);
                            this_1.ctx.transform(1, 0, 0, f2, 0, 0);
                            this_1.ctx.translate(-midX, -midY);
                            this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                            this_1.ctx.restore();
                          } else {
                            this_1.ctx.fill();
                          }
                        }
                      }
                      _h.label = 6;
                    case 6:
                      index2--;
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              };
              this_1 = this;
              _i = 0, _a2 = container.styles.backgroundImage.slice(0).reverse();
              _b2.label = 1;
            case 1:
              if (!(_i < _a2.length)) return [3, 4];
              backgroundImage2 = _a2[_i];
              return [5, _loop_1(backgroundImage2)];
            case 2:
              _b2.sent();
              _b2.label = 3;
            case 3:
              _i++;
              return [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    CanvasRenderer2.prototype.renderSolidBorder = function(color2, side, curvePoints) {
      return __awaiter(this, void 0, void 0, function() {
        return __generator(this, function(_a2) {
          this.path(parsePathForBorder(curvePoints, side));
          this.ctx.fillStyle = asString(color2);
          this.ctx.fill();
          return [
            2
            /*return*/
          ];
        });
      });
    };
    CanvasRenderer2.prototype.renderDoubleBorder = function(color2, width, side, curvePoints) {
      return __awaiter(this, void 0, void 0, function() {
        var outerPaths, innerPaths;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (!(width < 3)) return [3, 2];
              return [4, this.renderSolidBorder(color2, side, curvePoints)];
            case 1:
              _a2.sent();
              return [
                2
                /*return*/
              ];
            case 2:
              outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
              this.path(outerPaths);
              this.ctx.fillStyle = asString(color2);
              this.ctx.fill();
              innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
              this.path(innerPaths);
              this.ctx.fill();
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    CanvasRenderer2.prototype.renderNodeBackgroundAndBorders = function(paint) {
      return __awaiter(this, void 0, void 0, function() {
        var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
        var _this = this;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              this.applyEffects(paint.getEffects(
                2
                /* BACKGROUND_BORDERS */
              ));
              styles = paint.container.styles;
              hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
              borders = [
                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
              ];
              backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
              if (!(hasBackground || styles.boxShadow.length)) return [3, 2];
              this.ctx.save();
              this.path(backgroundPaintingArea);
              this.ctx.clip();
              if (!isTransparent(styles.backgroundColor)) {
                this.ctx.fillStyle = asString(styles.backgroundColor);
                this.ctx.fill();
              }
              return [4, this.renderBackgroundImage(paint.container)];
            case 1:
              _a2.sent();
              this.ctx.restore();
              styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                _this.ctx.save();
                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                if (shadow.inset) {
                  _this.path(borderBoxArea);
                  _this.ctx.clip();
                  _this.mask(shadowPaintingArea);
                } else {
                  _this.mask(borderBoxArea);
                  _this.ctx.clip();
                  _this.path(shadowPaintingArea);
                }
                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                _this.ctx.shadowColor = asString(shadow.color);
                _this.ctx.shadowBlur = shadow.blur.number;
                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                _this.ctx.fill();
                _this.ctx.restore();
              });
              _a2.label = 2;
            case 2:
              side = 0;
              _i = 0, borders_1 = borders;
              _a2.label = 3;
            case 3:
              if (!(_i < borders_1.length)) return [3, 13];
              border = borders_1[_i];
              if (!(border.style !== 0 && !isTransparent(border.color) && border.width > 0)) return [3, 11];
              if (!(border.style === 2)) return [3, 5];
              return [4, this.renderDashedDottedBorder(
                border.color,
                border.width,
                side,
                paint.curves,
                2
                /* DASHED */
              )];
            case 4:
              _a2.sent();
              return [3, 11];
            case 5:
              if (!(border.style === 3)) return [3, 7];
              return [4, this.renderDashedDottedBorder(
                border.color,
                border.width,
                side,
                paint.curves,
                3
                /* DOTTED */
              )];
            case 6:
              _a2.sent();
              return [3, 11];
            case 7:
              if (!(border.style === 4)) return [3, 9];
              return [4, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
            case 8:
              _a2.sent();
              return [3, 11];
            case 9:
              return [4, this.renderSolidBorder(border.color, side, paint.curves)];
            case 10:
              _a2.sent();
              _a2.label = 11;
            case 11:
              side++;
              _a2.label = 12;
            case 12:
              _i++;
              return [3, 3];
            case 13:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    };
    CanvasRenderer2.prototype.renderDashedDottedBorder = function(color2, width, side, curvePoints, style) {
      return __awaiter(this, void 0, void 0, function() {
        var strokePaths, boxPaths, startX, startY, endX, endY, length2, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
        return __generator(this, function(_a2) {
          this.ctx.save();
          strokePaths = parsePathForBorderStroke(curvePoints, side);
          boxPaths = parsePathForBorder(curvePoints, side);
          if (style === 2) {
            this.path(boxPaths);
            this.ctx.clip();
          }
          if (isBezierCurve(boxPaths[0])) {
            startX = boxPaths[0].start.x;
            startY = boxPaths[0].start.y;
          } else {
            startX = boxPaths[0].x;
            startY = boxPaths[0].y;
          }
          if (isBezierCurve(boxPaths[1])) {
            endX = boxPaths[1].end.x;
            endY = boxPaths[1].end.y;
          } else {
            endX = boxPaths[1].x;
            endY = boxPaths[1].y;
          }
          if (side === 0 || side === 2) {
            length2 = Math.abs(startX - endX);
          } else {
            length2 = Math.abs(startY - endY);
          }
          this.ctx.beginPath();
          if (style === 3) {
            this.formatPath(strokePaths);
          } else {
            this.formatPath(boxPaths.slice(0, 2));
          }
          dashLength = width < 3 ? width * 3 : width * 2;
          spaceLength = width < 3 ? width * 2 : width;
          if (style === 3) {
            dashLength = width;
            spaceLength = width;
          }
          useLineDash = true;
          if (length2 <= dashLength * 2) {
            useLineDash = false;
          } else if (length2 <= dashLength * 2 + spaceLength) {
            multiplier = length2 / (2 * dashLength + spaceLength);
            dashLength *= multiplier;
            spaceLength *= multiplier;
          } else {
            numberOfDashes = Math.floor((length2 + spaceLength) / (dashLength + spaceLength));
            minSpace = (length2 - numberOfDashes * dashLength) / (numberOfDashes - 1);
            maxSpace = (length2 - (numberOfDashes + 1) * dashLength) / numberOfDashes;
            spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
          }
          if (useLineDash) {
            if (style === 3) {
              this.ctx.setLineDash([0, dashLength + spaceLength]);
            } else {
              this.ctx.setLineDash([dashLength, spaceLength]);
            }
          }
          if (style === 3) {
            this.ctx.lineCap = "round";
            this.ctx.lineWidth = width;
          } else {
            this.ctx.lineWidth = width * 2 + 1.1;
          }
          this.ctx.strokeStyle = asString(color2);
          this.ctx.stroke();
          this.ctx.setLineDash([]);
          if (style === 2) {
            if (isBezierCurve(boxPaths[0])) {
              path1 = boxPaths[3];
              path2 = boxPaths[0];
              this.ctx.beginPath();
              this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
              this.ctx.stroke();
            }
            if (isBezierCurve(boxPaths[1])) {
              path1 = boxPaths[1];
              path2 = boxPaths[2];
              this.ctx.beginPath();
              this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
              this.ctx.stroke();
            }
          }
          this.ctx.restore();
          return [
            2
            /*return*/
          ];
        });
      });
    };
    CanvasRenderer2.prototype.render = function(element) {
      return __awaiter(this, void 0, void 0, function() {
        var stack;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              if (this.options.backgroundColor) {
                this.ctx.fillStyle = asString(this.options.backgroundColor);
                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
              }
              stack = parseStackingContexts(element);
              return [4, this.renderStack(stack)];
            case 1:
              _a2.sent();
              this.applyEffects([]);
              return [2, this.canvas];
          }
        });
      });
    };
    return CanvasRenderer2;
  }(Renderer)
);
var isTextInputElement = function(container) {
  if (container instanceof TextareaElementContainer) {
    return true;
  } else if (container instanceof SelectElementContainer) {
    return true;
  } else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
    return true;
  }
  return false;
};
var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
  switch (clip) {
    case 0:
      return calculateBorderBoxPath(curves);
    case 2:
      return calculateContentBoxPath(curves);
    case 1:
    default:
      return calculatePaddingBoxPath(curves);
  }
};
var canvasTextAlign = function(textAlign2) {
  switch (textAlign2) {
    case 1:
      return "center";
    case 2:
      return "right";
    case 0:
    default:
      return "left";
  }
};
var iOSBrokenFonts = ["-apple-system", "system-ui"];
var fixIOSSystemFonts = function(fontFamilies) {
  return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily2) {
    return iOSBrokenFonts.indexOf(fontFamily2) === -1;
  }) : fontFamilies;
};
var ForeignObjectRenderer = (
  /** @class */
  function(_super) {
    __extends(ForeignObjectRenderer2, _super);
    function ForeignObjectRenderer2(context, options) {
      var _this = _super.call(this, context, options) || this;
      _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
      _this.ctx = _this.canvas.getContext("2d");
      _this.options = options;
      _this.canvas.width = Math.floor(options.width * options.scale);
      _this.canvas.height = Math.floor(options.height * options.scale);
      _this.canvas.style.width = options.width + "px";
      _this.canvas.style.height = options.height + "px";
      _this.ctx.scale(_this.options.scale, _this.options.scale);
      _this.ctx.translate(-options.x, -options.y);
      _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
      return _this;
    }
    ForeignObjectRenderer2.prototype.render = function(element) {
      return __awaiter(this, void 0, void 0, function() {
        var svg, img;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
              return [4, loadSerializedSVG(svg)];
            case 1:
              img = _a2.sent();
              if (this.options.backgroundColor) {
                this.ctx.fillStyle = asString(this.options.backgroundColor);
                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
              }
              this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
              return [2, this.canvas];
          }
        });
      });
    };
    return ForeignObjectRenderer2;
  }(Renderer)
);
var loadSerializedSVG = function(svg) {
  return new Promise(function(resolve, reject) {
    var img = new Image();
    img.onload = function() {
      resolve(img);
    };
    img.onerror = reject;
    img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
  });
};
var Logger = (
  /** @class */
  function() {
    function Logger2(_a2) {
      var id = _a2.id, enabled = _a2.enabled;
      this.id = id;
      this.enabled = enabled;
      this.start = Date.now();
    }
    Logger2.prototype.debug = function() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      if (this.enabled) {
        if (typeof window !== "undefined" && window.console && typeof console.debug === "function") {
          console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
        } else {
          this.info.apply(this, args);
        }
      }
    };
    Logger2.prototype.getTime = function() {
      return Date.now() - this.start;
    };
    Logger2.prototype.info = function() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      if (this.enabled) {
        if (typeof window !== "undefined" && window.console && typeof console.info === "function") {
          console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
        }
      }
    };
    Logger2.prototype.warn = function() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      if (this.enabled) {
        if (typeof window !== "undefined" && window.console && typeof console.warn === "function") {
          console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
        } else {
          this.info.apply(this, args);
        }
      }
    };
    Logger2.prototype.error = function() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      if (this.enabled) {
        if (typeof window !== "undefined" && window.console && typeof console.error === "function") {
          console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
        } else {
          this.info.apply(this, args);
        }
      }
    };
    Logger2.instances = {};
    return Logger2;
  }()
);
var Context = (
  /** @class */
  function() {
    function Context2(options, windowBounds) {
      var _a2;
      this.windowBounds = windowBounds;
      this.instanceName = "#" + Context2.instanceCount++;
      this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
      this.cache = (_a2 = options.cache) !== null && _a2 !== void 0 ? _a2 : new Cache(this, options);
    }
    Context2.instanceCount = 1;
    return Context2;
  }()
);
var html2canvas = function(element, options) {
  if (options === void 0) {
    options = {};
  }
  return renderElement(element, options);
};
if (typeof window !== "undefined") {
  CacheStorage.setContext(window);
}
var renderElement = function(element, opts) {
  return __awaiter(void 0, void 0, void 0, function() {
    var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a2, width, height, left, top, backgroundColor2, renderOptions, canvas, renderer, root, renderer;
    var _b2, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q2, _r, _s, _t;
    return __generator(this, function(_u) {
      switch (_u.label) {
        case 0:
          if (!element || typeof element !== "object") {
            return [2, Promise.reject("Invalid element provided as first argument")];
          }
          ownerDocument = element.ownerDocument;
          if (!ownerDocument) {
            throw new Error("Element is not attached to a Document");
          }
          defaultView = ownerDocument.defaultView;
          if (!defaultView) {
            throw new Error("Document is not attached to a Window");
          }
          resourceOptions = {
            allowTaint: (_b2 = opts.allowTaint) !== null && _b2 !== void 0 ? _b2 : false,
            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15e3,
            proxy: opts.proxy,
            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
          };
          contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
          windowOptions = {
            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
          };
          windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
          context = new Context(contextOptions, windowBounds);
          foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
          cloneOptions = {
            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
            onclone: opts.onclone,
            ignoreElements: opts.ignoreElements,
            inlineImages: foreignObjectRendering,
            copyStyles: foreignObjectRendering
          };
          context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
          documentCloner = new DocumentCloner(context, element, cloneOptions);
          clonedElement = documentCloner.clonedReferenceElement;
          if (!clonedElement) {
            return [2, Promise.reject("Unable to find element in cloned iframe")];
          }
          return [4, documentCloner.toIFrame(ownerDocument, windowBounds)];
        case 1:
          container = _u.sent();
          _a2 = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a2.width, height = _a2.height, left = _a2.left, top = _a2.top;
          backgroundColor2 = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
          renderOptions = {
            canvas: opts.canvas,
            backgroundColor: backgroundColor2,
            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
            y: ((_q2 = opts.y) !== null && _q2 !== void 0 ? _q2 : 0) + top,
            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
          };
          if (!foreignObjectRendering) return [3, 3];
          context.logger.debug("Document cloned, using foreign object rendering");
          renderer = new ForeignObjectRenderer(context, renderOptions);
          return [4, renderer.render(clonedElement)];
        case 2:
          canvas = _u.sent();
          return [3, 5];
        case 3:
          context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
          context.logger.debug("Starting DOM parsing");
          root = parseTree(context, clonedElement);
          if (backgroundColor2 === root.styles.backgroundColor) {
            root.styles.backgroundColor = COLORS.TRANSPARENT;
          }
          context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
          renderer = new CanvasRenderer(context, renderOptions);
          return [4, renderer.render(root)];
        case 4:
          canvas = _u.sent();
          _u.label = 5;
        case 5:
          if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
            if (!DocumentCloner.destroy(container)) {
              context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
            }
          }
          context.logger.debug("Finished rendering");
          return [2, canvas];
      }
    });
  });
};
var parseBackgroundColor = function(context, element, backgroundColorOverride) {
  var ownerDocument = element.ownerDocument;
  var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
  var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
  var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 4294967295;
  return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
};
const threeVersion = parseInt(REVISION$1, 10);
function cloneThreeJsObject3D(srcObj) {
  let cloneObj = "Mesh" === srcObj.type || "Sprite" === srcObj.type ? new Mesh$1(srcObj.geometry.clone(false), srcObj.material.clone(false)) : srcObj.clone(false);
  cloneObj.name = srcObj.name;
  cloneObj.position.x = srcObj.position.x;
  cloneObj.position.y = srcObj.position.y;
  cloneObj.position.z = srcObj.position.z;
  cloneObj.rotation.x = srcObj.rotation.x;
  cloneObj.rotation.y = srcObj.rotation.y;
  cloneObj.rotation.z = srcObj.rotation.z;
  cloneObj.scale.x = srcObj.scale.x;
  cloneObj.scale.y = srcObj.scale.y;
  cloneObj.scale.z = srcObj.scale.z;
  if (srcObj.children && srcObj.children.length > 0) {
    srcObj.children.forEach((child) => {
      cloneObj.add(cloneThreeJsObject3D(child));
    });
  }
  return cloneObj;
}
function getThreeBoxGroup(obj) {
  if (obj.isThreeBoxGroup) return obj;
  else if (obj.parent) return getThreeBoxGroup(obj.parent);
  else return null;
}
class ModelLayer extends ThreeBoxLayer {
  constructor(options) {
    super(options);
    this.isModelLayer = true;
    this.effectObjects = [];
  }
  // eslint-disable-next-line no-unused-vars
  _onAdd(map, gl) {
    if (!map.getLayer("3dEffect")) {
      this._map.effectLayer = new EffectLayer({ id: "3dEffect" });
      map.addLayer(this._map.effectLayer);
    }
    const { models, lnglat, units, showLoading, callback, ...other } = this.options;
    this.addModel(models, lnglat, units, showLoading, callback);
    this.options = other;
    this._map.materialCache[this.id] = [];
    this._map.customUniforms[this.id] = [];
  }
  // eslint-disable-next-line no-unused-vars
  _onRemove(map, gl) {
    delete this._map.materialCache[this.id];
    while (this.effectObjects.length > 0) this.removeModel(this.effectObjects[0]);
    if (this.css2d_render_tags) {
      let keys = Object.keys(this.css2d_render_tags);
      keys.forEach((key) => {
        const marker = this.css2d_render_tags[key];
        marker.remove();
      });
    }
    this._map.tb.remove(this.group);
    this.group = null;
  }
  addModel(models, lnglat, units, showLoading, callback) {
    const tb = this._map.tb;
    const layer = this;
    let promises = [];
    let objects = [];
    let progresses = {};
    if (models && models.length > 0) {
      models.forEach((model, index2) => {
        if (model.type) {
          if ("model" === model.type) {
            model.model.forEach((obj) => {
              model.tb = tb;
              objects.push(obj);
            });
          } else {
            model.tb = tb;
            model.index = index2;
            if (showLoading) {
              model.progress = function(percent, index3) {
                progresses[index3] = percent;
                let total = 0;
                let current = 0;
                for (let key in progresses) {
                  total += 100;
                  current += progresses[key];
                }
                layer._map.updateLoading(Math.round(current * 100 / total) + "%");
              };
              progresses[index2] = 0;
            }
            if (model.draco) {
              model.dracoUrl = this._map.getDracoPath();
            } else if (model.ktx2) {
              model.ktx2Url = this._map.getKtx2Path();
            }
            promises.push(LoadObj(model));
          }
        } else {
          console.error("models 中缺少type定义");
        }
      });
      if (showLoading) this._map.showLoading(true, "模型加载中……");
      Promise.all(promises).then((results) => {
        if (showLoading) layer._map.updateLoading("模型初始化……");
        requestAnimationFrame(() => {
          let objects2 = [];
          results.forEach((data) => {
            if (data) objects2.push(data);
          });
          objects = objects.concat(objects2);
          let group = tb.Object3D({
            obj: objects,
            units
          });
          group.userData.isModelRoot = true;
          group.setCoords(lnglat);
          layer.group.add(group);
          layer.attachInitMatrix(group);
          if (callback) callback(group, layer);
          layer._map.showLoading(false);
        });
      });
    } else {
      if (callback) callback(null, layer);
    }
  }
  attachInitMatrix(obj) {
    obj.updateMatrix();
    obj.updateMatrixWorld(true);
    obj.updateWorldMatrix(true, true);
    obj.userData.initMatrix = obj.matrix.clone();
    obj.userData.initMatrixWorld = obj.matrixWorld.clone();
  }
  // 添加坐标系辅助
  addAxesHelper(obj, length2) {
    if ("number" == typeof length2 && length2 > 0) {
      const helper = new AxesHelper(length2);
      obj.add(helper);
    } else {
      console.warn(`参数length的值为${length2}不符合要求，请重新输入！`);
    }
  }
  // 添加外包围盒辅助
  addBoxHelper(obj, color2) {
    const tb = this._map.tb;
    let box = tb.getModelBoundingBox(obj);
    let max2 = tb.projectToWorld(box.max);
    let min = tb.projectToWorld(box.min);
    let points = [
      new Vector3$1(min.x - min.x, min.y - min.y, max2.z - min.z),
      new Vector3$1(max2.x - min.x, min.y - min.y, max2.z - min.z),
      new Vector3$1(min.x - min.x, min.y - min.y, min.z - min.z),
      new Vector3$1(max2.x - min.x, min.y - min.y, min.z - min.z),
      new Vector3$1(min.x - min.x, max2.y - min.y, max2.z - min.z),
      new Vector3$1(max2.x - min.x, max2.y - min.y, max2.z - min.z),
      new Vector3$1(max2.x - min.x, max2.y - min.y, min.z - min.z),
      new Vector3$1(min.x - min.x, max2.y - min.y, min.z - min.z)
    ];
    let geometry = new BufferGeometry$1().setFromPoints(points);
    let array = new Uint16Array([
      0,
      1,
      1,
      3,
      3,
      2,
      2,
      0,
      4,
      5,
      5,
      6,
      6,
      7,
      7,
      4,
      0,
      4,
      1,
      5,
      3,
      6,
      2,
      7
    ]);
    geometry.setIndex(new BufferAttribute$1(array, 1));
    let lineSegments = new LineSegments$1(
      geometry,
      new LineBasicMaterial$1({ color: new Color$1(color2 || "#ff0000") })
    );
    let group = tb.Object3D({ obj: [lineSegments] });
    group.setCoords(box.min);
    this.group.add(group);
    return group;
  }
  // 添加点
  addPoints(options) {
    const tb = this._map.tb;
    const opacity2 = void 0 !== options.opacity ? options.opacity : 1;
    const size = tb.projectedUnitsPerMeter(options.data[0].coordinate[1]) * (options.size || 1);
    function createThreeBoxObject3D(tb2, data, originCoord, object3d, originWorldUnit, deepCopy) {
      let objs = [];
      data.forEach((data2) => {
        const obj = deepCopy ? cloneThreeJsObject3D(object3d) : object3d.clone();
        for (let key in data2) obj.userData[key] = data2[key];
        const worldUnit = tb2.projectToWorld(data2.coordinate);
        obj.position.set(
          worldUnit.x - originWorldUnit.x,
          worldUnit.y - originWorldUnit.y,
          worldUnit.z - originWorldUnit.z
        );
        const scale = utils.types.scale(data2.scale, [1, 1, 1]);
        obj.scale.set(scale[0], scale[1], scale[2]);
        const rotation = utils.types.rotation(data2.rotation, [0, 0, 0]);
        obj.rotation.set(rotation[0], rotation[1], rotation[2]);
        obj.visible = true;
        objs.push(obj);
      });
      return tb2.Object3D({ obj: objs }).setCoords(originCoord);
    }
    let mesh;
    if ("cube" === options.type) {
      mesh = new Mesh$1(
        new BoxGeometry$1(size, size, size),
        new MeshBasicMaterial$1({
          color: new Color$1(
            typeof options.color === "number" ? options.color : options.color || "#FFFFFF"
          ),
          transparent: true,
          opacity: opacity2
        })
      );
    } else if ("sphere" === options.type) {
      mesh = new Mesh$1(
        new SphereGeometry(size, 32, 32),
        new MeshBasicMaterial$1({
          color: new Color$1(
            typeof options.color === "number" ? options.color : options.color || "#FFFFFF"
          ),
          transparent: true,
          opacity: opacity2
        })
      );
    } else {
      console.error("Please set the type parameter,cube or sphere!");
      return null;
    }
    if (options.alwaysSeeing) mesh.material.depthTest = false;
    let group = createThreeBoxObject3D(
      tb,
      options.data,
      options.data[0].coordinate,
      mesh,
      tb.projectToWorld(options.data[0].coordinate),
      options.deepCopy
    );
    this.group.add(group);
    function resetUVs(object) {
      var pos = object.geometry.getAttribute("position"), nor = object.geometry.getAttribute("normal"), uvs = object.geometry.getAttribute("uv");
      for (var i2 = 0; i2 < pos.count; i2++) {
        var x = 0, y = 0;
        var nx = Math.abs(nor.getX(i2)), ny = Math.abs(nor.getY(i2)), nz = Math.abs(nor.getZ(i2));
        if (nx >= ny && nx >= nz) {
          x = pos.getZ(i2);
          y = pos.getY(i2);
        }
        if (ny >= nx && ny >= nz) {
          x = pos.getX(i2);
          y = pos.getZ(i2);
        }
        if (nz >= nx && nz >= ny) {
          x = pos.getX(i2);
          y = pos.getY(i2);
        }
        uvs.setXY(i2, x, y);
      }
    }
    resetUVs(mesh);
    return group;
  }
  // 同类模型大批量高性能加载
  addInstancedModel(options, callback) {
    if (!options.model) {
      console.error("addInstancedModel接口中必填参数model未定义，请检查参数值！");
      return null;
    }
    if (!options.data) {
      console.error("addInstancedModel接口中必填参数data未定义，请检查参数值！");
      return null;
    }
    if ("glb" !== options.model.type && "gltf" !== options.model.type) {
      console.error(`addInstancedModel接口暂不支持${options.model.type}类型模型!`);
      return null;
    }
    const tb = this._map.tb;
    let rotation = utils.radify(options.rotation || [0, 0, 0]);
    let originCoord = options.data[0].coordinate;
    let originWorldUnit = tb.projectToWorld(originCoord);
    const maxCount = options.maxCount || 99999;
    const scale = utils.Validator.Scale(options.scale || 1);
    if (options.data.length > maxCount) {
      console.error("参数`maxCount`必须大于数据实际值，请重新输入！");
    }
    options.model.tb = tb;
    if (options.model.draco) {
      options.model.dracoUrl = this._map.getDracoPath();
    } else if (options.model.ktx2) {
      options.model.ktx2Url = this._map.getKtx2Path();
    }
    LoadObj(options.model).then((data) => {
      let instancedGroup = new Group$1();
      let meshes = [];
      let geometry, newObj;
      let matrix2 = new Matrix4$1();
      function selectMesh(obj) {
        if ("Mesh" === obj.type) {
          matrix2 = obj.matrix.clone();
          geometry = obj.geometry;
          newObj = obj.clone();
        } else {
          matrix2 = obj.matrix.clone().multiply(matrix2);
        }
        if (obj.parent) {
          selectMesh(obj.parent);
        } else {
          newObj.updateMatrix();
          newObj.updateMatrixWorld(true);
          newObj.updateWorldMatrix(true, true);
          newObj.position.set(0, 0, 0);
          newObj.rotation.set(0, 0, 0);
          newObj.scale.set(1, 1, 1);
          geometry.applyMatrix4(matrix2);
          geometry.computeBoundingBox();
          geometry.computeBoundingSphere();
          geometry.computeVertexNormals();
          newObj.updateMatrix();
          newObj.updateMatrixWorld(true);
          newObj.updateWorldMatrix(true, true);
          meshes.push(newObj);
        }
      }
      cloneThreeJsObject3D(data).traverse((child) => {
        if (child instanceof Mesh$1) {
          child.updateMatrix();
          child.updateMatrixWorld(true);
          child.updateWorldMatrix(true, true);
          child.updateMatrix();
          selectMesh(child);
        }
      });
      meshes.forEach((mesh) => {
        if (options.opacity !== void 0) {
          mesh.material.transparent = true;
          mesh.material.opacity = options.opacity;
        }
        if (rotation[0]) mesh.geometry.rotateX(rotation[0]);
        if (rotation[1]) mesh.geometry.rotateY(rotation[1]);
        if (rotation[2]) mesh.geometry.rotateZ(rotation[2]);
        mesh.geometry.scale(scale.x, scale.y, scale.z);
        const instancedMesh = new InstancedMesh$1(
          mesh.geometry,
          mesh.material,
          options.data.length
        );
        instancedMesh.userData.bindIds = [];
        instancedMesh.userData.matPos = [];
        instancedMesh.userData.originColor = mesh.material.color;
        instancedMesh.userData.beforeInstanceIndex = [];
        instancedMesh.userData.scale = scale;
        instancedMesh.userData.units = options.units;
        for (let i2 = 0; i2 < options.data.length; i2++) {
          let worldUnit = tb.projectToWorld(options.data[i2].coordinate);
          let normalScale = utils.projectedScaleByUnits(
            options.data[i2].coordinate[1],
            options.units
          );
          let meshScale = utils.Validator.Scale(options.data[i2].scale || 1);
          let meshColor = new Color$1(
            options.data[i2].color ? options.data[i2].color : mesh.material.color
          );
          let offsetX = worldUnit.x - originWorldUnit.x;
          let offsetY = worldUnit.y - originWorldUnit.y;
          let offsetZ = worldUnit.z - originWorldUnit.z;
          let meshRotation = utils.radify(options.data[i2].rotation || [0, 0, 0]);
          mesh.position.set(offsetX, offsetY, offsetZ);
          mesh.rotation.set(meshRotation[0], meshRotation[1], meshRotation[2]);
          mesh.scale.set(
            meshScale.x * normalScale,
            meshScale.y * normalScale,
            meshScale.z * normalScale
          );
          mesh.updateMatrix();
          instancedMesh.setMatrixAt(i2, mesh.matrix);
          instancedMesh.setColorAt(i2, meshColor);
          instancedMesh.userData.beforeInstanceIndex.push(i2);
          instancedMesh.userData.bindIds.push(options.data[i2].id ? options.data[i2].id : "undefined");
          instancedMesh.userData.matPos.push(new Vector3$1(offsetX, offsetY, offsetZ));
        }
        instancedGroup.add(instancedMesh);
      });
      instancedGroup.userData.type = "InstancedMesh";
      instancedGroup.userData.bs_v3 = originWorldUnit;
      let group = tb.Object3D({ obj: [instancedGroup] }).setCoords(originCoord);
      this.group.add(group);
      if (callback) callback(group);
    });
  }
  // 更新同类模型
  updateInstancedModel(options) {
    const tb = this._map.tb;
    let instancedGroup = options.model.children[0];
    let originWorldUnit = instancedGroup.userData.bs_v3;
    for (let t3 = 0; t3 < instancedGroup.children.length; t3++) {
      let instancedMesh = instancedGroup.children[t3];
      if (instancedMesh.count != options.data.length) {
        console.error("updateInstancedModel接口中必填参数data的数量必须与原模型的数量一致！");
        return;
      }
      let matPos = [...instancedMesh.userData.matPos];
      instancedMesh.userData.bindIds = [];
      instancedMesh.userData.matPos = [];
      for (let i2 = 0; i2 < options.data.length; i2++) {
        let matrix4 = new Matrix4$1();
        let normalScale;
        let offsetX = 0;
        let offsetY = 0;
        let offsetZ = 0;
        if (options.data[i2].coordinate) {
          let worldUnit = tb.projectToWorld(options.data[i2].coordinate);
          offsetX = worldUnit.x - originWorldUnit.x;
          offsetY = worldUnit.y - originWorldUnit.y;
          offsetZ = worldUnit.z - originWorldUnit.z;
          normalScale = utils.projectedScaleByUnits(
            options.data[i2].coordinate[1],
            instancedMesh.userData.units
          );
        } else {
          offsetX = matPos[i2].x;
          offsetY = matPos[i2].y;
          offsetZ = matPos[i2].z;
          let coordinate = utils.unprojectFromWorld(
            new Vector3$1(
              originWorldUnit.x + offsetX,
              originWorldUnit.y + offsetY,
              originWorldUnit.z + offsetZ
            )
          );
          normalScale = utils.projectedScaleByUnits(coordinate[1], instancedMesh.userData.units);
        }
        matrix4.setPosition(new Vector3$1(offsetX, offsetY, offsetZ));
        let meshScale = utils.Validator.Scale(options.data[i2].scale || 1);
        let meshColor = new Color$1(
          options.data[i2].color ? options.data[i2].color : instancedMesh.userData.originColor
        );
        let meshRotation = utils.radify(options.data[i2].rotation || [0, 0, 0]);
        matrix4.multiply(new Matrix4$1().makeRotationX(meshRotation[0])).multiply(new Matrix4$1().makeRotationY(meshRotation[1])).multiply(new Matrix4$1().makeRotationZ(meshRotation[2])).multiply(
          new Matrix4$1().makeScale(
            meshScale.x * normalScale,
            meshScale.y * normalScale,
            meshScale.z * normalScale
          )
        );
        instancedMesh.setMatrixAt(i2, matrix4);
        instancedMesh.setColorAt(i2, meshColor);
        instancedMesh.instanceColor.needsUpdate = true;
        instancedMesh.instanceMatrix.needsUpdate = true;
        instancedMesh.userData.bindIds.push(options.data[i2].id ? options.data[i2].id : "undefined");
        instancedMesh.userData.matPos.push(new Vector3$1(offsetX, offsetY, offsetZ));
      }
    }
  }
  // 根据id更新同类模型
  updateInstancedModelById(options) {
    const tb = this._map.tb;
    let instancedGroup = options.model.children[0];
    let originWorldUnit = instancedGroup.userData.bs_v3;
    for (let t3 = 0; t3 < instancedGroup.children.length; t3++) {
      let instancedMesh = instancedGroup.children[t3];
      if (options.clearColor) {
        for (let i2 = 0; i2 < instancedMesh.count; i2++) {
          instancedMesh.setColorAt(i2, new Color$1(instancedMesh.userData.originColor));
          instancedMesh.instanceColor.needsUpdate = true;
        }
      }
      for (let i2 = 0; i2 < options.data.length; i2++) {
        let index2 = instancedMesh.userData.bindIds.indexOf(options.data[i2].id);
        if (index2 > -1) {
          let matrix4 = new Matrix4$1();
          let normalScale;
          let offsetX = 0;
          let offsetY = 0;
          let offsetZ = 0;
          if (options.data[i2].coordinate) {
            let worldUnit = tb.projectToWorld(options.data[i2].coordinate);
            offsetX = worldUnit.x - originWorldUnit.x;
            offsetY = worldUnit.y - originWorldUnit.y;
            offsetZ = worldUnit.z - originWorldUnit.z;
            normalScale = utils.projectedScaleByUnits(
              options.data[i2].coordinate[1],
              instancedMesh.userData.units
            );
          } else {
            offsetX = instancedMesh.userData.matPos[index2].x;
            offsetY = instancedMesh.userData.matPos[index2].y;
            offsetZ = instancedMesh.userData.matPos[index2].z;
            let coordinate = utils.unprojectFromWorld(
              new Vector3$1(
                originWorldUnit.x + offsetX,
                originWorldUnit.y + offsetY,
                originWorldUnit.z + offsetZ
              )
            );
            normalScale = utils.projectedScaleByUnits(coordinate[1], instancedMesh.userData.units);
          }
          matrix4.setPosition(new Vector3$1(offsetX, offsetY, offsetZ));
          let meshScale = utils.Validator.Scale(options.data[i2].scale || 1);
          let meshColor = new Color$1(
            options.data[i2].color ? options.data[i2].color : instancedMesh.userData.originColor
          );
          let meshRotation = utils.radify(options.data[i2].rotation || [0, 0, 0]);
          matrix4.multiply(new Matrix4$1().makeRotationX(meshRotation[0])).multiply(new Matrix4$1().makeRotationY(meshRotation[1])).multiply(new Matrix4$1().makeRotationZ(meshRotation[2])).multiply(
            new Matrix4$1().makeScale(
              meshScale.x * normalScale,
              meshScale.y * normalScale,
              meshScale.z * normalScale
            )
          );
          instancedMesh.setMatrixAt(index2, matrix4);
          instancedMesh.setColorAt(index2, meshColor);
          instancedMesh.instanceColor.needsUpdate = true;
          instancedMesh.instanceMatrix.needsUpdate = true;
          instancedMesh.userData.matPos[index2] = new Vector3$1(offsetX, offsetY, offsetZ);
        }
      }
    }
  }
  // 添加粒子点
  addParticle(options) {
    const tb = this._map.tb;
    const originCoord = options.data[0].coordinate;
    const originWorldUnit = tb.projectToWorld(originCoord);
    const floatArray = new Float32Array(3 * (options.maxPoints || options.data.length));
    options.data.forEach((data, index2) => {
      if (data.coordinate) {
        const worldUnit = tb.projectToWorld(data.coordinate);
        floatArray[3 * index2] = worldUnit.x - originWorldUnit.x;
        floatArray[3 * index2 + 1] = worldUnit.y - originWorldUnit.y;
        floatArray[3 * index2 + 2] = worldUnit.z - originWorldUnit.z;
      }
    });
    const geometry = new BufferGeometry$1();
    geometry.setAttribute("position", new Float32BufferAttribute$1(floatArray, 3));
    const points = new Points$1(
      geometry,
      new ShaderMaterial$1({
        uniforms: {
          color: {
            value: new Color$1(options.color || "#FFFFFF")
          },
          size: {
            value: options.size || 1
          },
          opacity: {
            value: void 0 !== options.opacity ? options.opacity : 1
          }
        },
        vertexShader: `
          uniform float size;
          #include <depth_offset_pars_vertex>
          
          void main() {
            vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
            gl_PointSize = size;
            gl_Position = projectionMatrix * mvPosition;
            #include <depth_offset_vertex>
          }
        `,
        fragmentShader: `
          uniform vec3 color;
          uniform float opacity;
          #include <depth_offset_pars_fragment>
          
          void main() {
            #include <depth_offset_fragment>
            gl_FragColor = vec4( color, opacity );
          }
        `
      })
    );
    const group = tb.Object3D({ obj: [points] });
    group.setCoords(originCoord);
    this.group.add(group);
    return group;
  }
  // 更新粒子点
  updateParticle(group, options) {
    const tb = this._map.tb;
    const points = group.children[0];
    if (options.size !== void 0) points.material.uniforms.size.value = options.size;
    if (options.opacity !== void 0) points.material.uniforms.opacity.value = options.opacity;
    if (options.color !== void 0)
      points.material.uniforms.color.value = new Color$1(options.color || "#FFFFFF");
    if (options.data !== void 0) {
      const originWorldUnit = tb.projectToWorld(group.coordinates);
      points.geometry.setDrawRange(0, options.data.length);
      options.data.forEach((data, index2) => {
        if (data.coordinate) {
          let worldUnit = tb.projectToWorld(data.coordinate);
          points.geometry.attributes.position.array[3 * index2] = worldUnit.x - originWorldUnit.x;
          points.geometry.attributes.position.array[3 * index2 + 1] = worldUnit.y - originWorldUnit.y;
          points.geometry.attributes.position.array[3 * index2 + 2] = worldUnit.z - originWorldUnit.z;
        }
      });
      points.geometry.attributes.position.needsUpdate = true;
    }
  }
  // 添加线
  addLines(options) {
    const obj = this._map.effectLayer.addLines(options);
    this.effectObjects.push(obj);
    return obj;
  }
  // 添加动态线
  addFlowLine(options) {
    const obj = this._map.effectLayer.addFlowLine(options);
    this.effectObjects.push(obj);
    return obj;
  }
  // 添加动态圆
  addCircle(options) {
    const obj = this._map.effectLayer.addCircle(options);
    this.effectObjects.push(obj);
    return obj;
  }
  // 添加特效球
  addSphere(options) {
    const obj = this._map.effectLayer.addSphere(options);
    this.effectObjects.push(obj);
    return obj;
  }
  // 添加电子围栏
  addGeoFence(options) {
    const obj = this._map.effectLayer.addGeoFence(options);
    this.effectObjects.push(obj);
    return obj;
  }
  // 添加多边形
  addPolygons(options) {
    const tb = this._map.tb;
    const polygons = [];
    const originCoord = options.data[0].coordinate[0];
    const originWorldUnit = tb.projectToWorld(originCoord);
    const material = new MeshBasicMaterial$1({
      color: new Color$1(
        typeof options.color === "number" ? options.color : options.color || "#FFFFFF"
      ),
      side: void 0 !== options.side ? options.side : FrontSide$1,
      transparent: true,
      opacity: void 0 !== options.opacity ? options.opacity : 1
    });
    options.data.forEach((data) => {
      let xyzArray = [];
      let count = data.coordinate.length;
      if (data.coordinate[0].toString() === data.coordinate[count - 1].toString()) count -= 1;
      for (let t3 = 0; t3 < count; t3++) {
        const worldUnit = tb.projectToWorld(data.coordinate[t3]);
        const offsetX = worldUnit.x - originWorldUnit.x;
        const offsetY = worldUnit.y - originWorldUnit.y;
        const offsetZ = worldUnit.z - originWorldUnit.z;
        xyzArray.push(offsetX, offsetY, offsetZ);
      }
      const geometry = new BufferGeometry$1();
      let indexArray = [];
      for (let i2 = 1; i2 < count - 1; i2++) indexArray.push(0, i2, i2 + 1);
      geometry.setIndex(new BufferAttribute$1(new Uint16Array(indexArray), 1));
      geometry.setAttribute(
        "position",
        new Float32BufferAttribute$1(new Float32Array(xyzArray), 3)
      );
      geometry.computeVertexNormals();
      const mesh = new Mesh$1(geometry, material);
      for (let key in options) mesh.userData[key] = options[key];
      polygons.push(mesh);
    });
    const group = tb.Object3D({ obj: polygons }).setCoords(originCoord);
    this.group.add(group);
    return group;
  }
  // 添加立体平面
  addPolygonByLine(options) {
    const tb = this._map.tb;
    const meshes = [];
    const originCoord = options.data[0];
    const worldUnitPerMeter = tb.projectedUnitsPerMeter(originCoord[1]);
    const originWorldUnit = tb.projectToWorld(originCoord);
    let material = new MeshPhysicalMaterial$1({
      color: new Color$1(
        typeof options.color === "number" ? options.color : options.color || "#FFFFFF"
      ),
      metalness: 1,
      opacity: void 0 !== options.opacity ? options.opacity : 1,
      side: DoubleSide$1,
      flatShading: true
    });
    for (let t3 = 0; t3 < options.data.length - 1; t3++) {
      const xyzArray = [];
      const firstWorldUnit = tb.projectToWorld(options.data[t3]);
      const firstOffsetX = firstWorldUnit.x - originWorldUnit.x;
      const firstOffsetY = firstWorldUnit.y - originWorldUnit.y;
      const firstOffsetZ = firstWorldUnit.z - originWorldUnit.z;
      const secondWorldUnit = tb.projectToWorld(options.data[t3 + 1]);
      const secondOffsetX = secondWorldUnit.x - originWorldUnit.x;
      const secondOffsetY = secondWorldUnit.y - originWorldUnit.y;
      const secondOffsetZ = secondWorldUnit.z - originWorldUnit.z;
      xyzArray.push(firstOffsetX, firstOffsetY, firstOffsetZ);
      xyzArray.push(secondOffsetX, secondOffsetY, secondOffsetZ);
      xyzArray.push(
        secondOffsetX,
        secondOffsetY,
        secondOffsetZ + worldUnitPerMeter * options.height
      );
      xyzArray.push(firstOffsetX, firstOffsetY, firstOffsetZ);
      xyzArray.push(
        secondOffsetX,
        secondOffsetY,
        secondOffsetZ + worldUnitPerMeter * options.height
      );
      xyzArray.push(firstOffsetX, firstOffsetY, firstOffsetZ + worldUnitPerMeter * options.height);
      const uvArray = [];
      uvArray.push(0, 0);
      uvArray.push(1, 0);
      uvArray.push(1, 1);
      uvArray.push(0, 0);
      uvArray.push(1, 1);
      uvArray.push(0, 1);
      let geometry = new BufferGeometry$1();
      geometry.setAttribute(
        "position",
        new Float32BufferAttribute$1(new Float32Array(xyzArray), 3)
      );
      geometry.setAttribute("uv", new Float32BufferAttribute$1(new Float32Array(uvArray), 2));
      geometry.computeVertexNormals();
      if (options.image) {
        const texture = new TextureLoader$1().load(options.image);
        if (threeVersion > 151) {
          texture.colorSpace = SRGBColorSpace;
        } else {
          texture.outputEncoding = void 0;
        }
        texture.wrapS = texture.wrapT = RepeatWrapping$1;
        let x = 1;
        if (!options.norepeat) {
          x = Math.sqrt(
            Math.pow(secondOffsetX - firstOffsetX, 2) + Math.pow(secondOffsetY - firstOffsetY, 2) + Math.pow(secondOffsetZ - firstOffsetZ, 2)
          ) / (worldUnitPerMeter * options.height);
        }
        texture.needsUpdate = true;
        texture.repeat.set(x, 1);
        material = new MeshPhysicalMaterial$1({
          transparent: true,
          opacity: void 0 !== options.opacity ? options.opacity : 1,
          map: texture,
          side: DoubleSide$1,
          metalness: 1,
          flatShading: true
        });
        material.needsUpdate = true;
      }
      let mesh = new Mesh$1(geometry, material);
      meshes.push(mesh);
    }
    const group = tb.Object3D({ obj: meshes }).setCoords(originCoord);
    this.group.add(group);
    return group;
  }
  // 添加三维椎体
  addPyramid(options) {
    const tb = this._map.tb;
    const originCoord = options.topPoint;
    const originWorldUnit = tb.projectToWorld(originCoord);
    let colors;
    if (Array.isArray(options.topColor) && options.topColor.length > 0) {
      colors = options.topColor;
    } else if (options.color !== void 0) {
      colors = [options.color];
    } else {
      colors = ["#FFFFFF"];
    }
    const topColor = new Color$1(
      typeof colors[0] === "number" ? colors[0] : colors[0] || "#FFFFFF"
    );
    const tmp2 = typeof colors[1] === "number" ? colors[1] : colors[1] || colors[0];
    const bottomColor = new Color$1(typeof tmp2 === "number" ? tmp2 : tmp2 || "#FFFFFF");
    const xyzArray = [];
    const colorArray = [];
    xyzArray.push(0, 0, 0);
    colorArray.push(topColor.r, topColor.g, topColor.b);
    options.basePoints.reverse();
    let count = options.basePoints.length;
    if (options.basePoints[0].toString() === options.basePoints[count - 1].toString()) count -= 1;
    for (let i2 = 0; i2 < count; i2++) {
      const worldUnit = tb.projectToWorld(options.basePoints[i2]);
      xyzArray.push(
        worldUnit.x - originWorldUnit.x,
        worldUnit.y - originWorldUnit.y,
        worldUnit.z - originWorldUnit.z
      );
      colorArray.push(bottomColor.r, bottomColor.g, bottomColor.b);
    }
    let materials = [
      new MeshBasicMaterial$1({
        vertexColors: true,
        side: void 0 !== options.side ? options.side : FrontSide$1,
        transparent: true,
        opacity: void 0 !== options.opacity ? options.opacity : 1
      }),
      new MeshBasicMaterial$1({
        color: new Color$1(options.baseColor),
        transparent: true,
        side: void 0 !== options.side ? options.side : FrontSide$1,
        opacity: options.baseColor && void 0 !== options.opacity ? options.opacity : 0
      })
    ];
    const indexArray = [];
    for (let i2 = 0; i2 < count; i2++) {
      indexArray.push(0, i2 + 1, i2 === count - 1 ? 1 : i2 + 2);
    }
    for (let i2 = 0; i2 < count - 2; i2++) {
      indexArray.push(1, i2 + 2, i2 + 3);
    }
    let geometry = new BufferGeometry$1();
    geometry.setIndex(new BufferAttribute$1(new Uint16Array(indexArray), 1));
    geometry.setAttribute(
      "position",
      new Float32BufferAttribute$1(new Float32Array(xyzArray), 3)
    );
    geometry.setAttribute(
      "color",
      new Float32BufferAttribute$1(new Float32Array(colorArray), 3)
    );
    geometry.computeVertexNormals();
    geometry.addGroup(0, 3 * count, 0);
    geometry.addGroup(3 * count, 3 * (count - 2), 1);
    const mesh = new Mesh$1(geometry, materials);
    const group = tb.Object3D({ obj: [mesh] }).setCoords(originCoord);
    this.group.add(group);
    return group;
  }
  // 添加三维平面标签
  addMarker(options) {
    const _this = this;
    const objs = [];
    const ids = [];
    const listeners = { click: [] };
    const id = "kkmap_markers_" + options.id;
    if (!this.css2d_render_tags) this.css2d_render_tags = {};
    if (this.css2d_render_tags[id]) {
      console.error("Current id '" + options.id + "' already exists!");
      return this.css2d_render_tags[id];
    }
    const tb = this._map.tb;
    const originCoord = options.data[0].position;
    const originWorldUnit = tb.projectToWorld(originCoord);
    if (!this._map.css2d_render_label) {
      const renderer = new CSS2DRenderer();
      const canvas = this._map.getCanvas();
      renderer.setSize(parseFloat(canvas.clientWidth), parseFloat(canvas.clientHeight));
      renderer.domElement.style.position = "absolute";
      renderer.domElement.style.top = "0px";
      canvas.parentElement.appendChild(renderer.domElement);
      this._map.css2d_render_label = renderer;
    }
    for (let t3 = 0; t3 < options.data.length; t3++) {
      const element = options.data[t3].element.cloneNode(true);
      element.id = id + "_" + t3;
      ids.push(element.id);
      const css2dObject = new CSS2DObject(element);
      const worldUnit = tb.projectToWorld(options.data[t3].position);
      css2dObject.userData.avoidance = options.avoidance;
      if (options.data[t3].name) {
        css2dObject.userData.name = options.data[t3].name;
        css2dObject.position.set(
          worldUnit.x - originWorldUnit.x,
          worldUnit.y - originWorldUnit.y,
          worldUnit.z - originWorldUnit.z
        );
        objs.push(css2dObject);
      }
      element.clickListener = (e2) => {
        e2.css2dObject = css2dObject;
        listeners.click.forEach((listener) => {
          if (typeof listener == "function") listener(e2);
        });
      };
      element.addEventListener("click", element.clickListener);
    }
    const group = tb.Object3D({ obj: objs }).setCoords(originCoord);
    this.group.add(group);
    group.updateMatrix();
    group.updateMatrixWorld(true);
    group.updateWorldMatrix(true, true);
    const marker = { elements: group };
    marker.remove = function() {
      if (_this.css2d_render_tags[id]) {
        _this.group.remove(group);
        for (let t3 = 0; t3 < ids.length; t3++) {
          const element = document.getElementById(ids[t3]);
          if (element) {
            element.removeEventListener("click", element.clickListener);
            delete element.clickListener;
            _this._map.css2d_render_label.domElement.removeChild(element);
          }
        }
        delete marker.elements;
        delete marker.remove;
        delete marker.update;
        delete marker.on;
        delete marker.off;
        delete _this.css2d_render_tags[id];
        if (_this._map.css2d_render_label.domElement.childElementCount === 0) {
          _this._map.getCanvas().parentElement.removeChild(_this._map.css2d_render_label.domElement);
          _this._map.css2d_render_label = null;
        }
      }
    };
    marker.update = function(options2) {
      for (let n2 = 0; n2 < options2.length; n2++) {
        if (options2[n2].name)
          for (let t3 = 0; t3 < marker.elements.children.length; t3++) {
            const css2dObject = marker.elements.children[t3];
            if (css2dObject.userData.name === options2[n2].name) {
              const worldUnit = tb.projectToWorld(options2[n2].position);
              css2dObject.position.set(
                worldUnit.x - originWorldUnit.x,
                worldUnit.y - originWorldUnit.y,
                worldUnit.z - originWorldUnit.z
              );
              css2dObject.updateMatrix();
              css2dObject.updateMatrixWorld(true);
              css2dObject.updateWorldMatrix(true, true);
              _this._map.needCss2DRefresh = true;
              break;
            }
          }
      }
    };
    marker.on = function(type, listener) {
      if (type == "click") {
        if (typeof listener == "function") listeners.click.push(listener);
      } else {
        console.error("This type of event is not supported!");
      }
    };
    marker.off = function(type, listener) {
      if (type == "click") {
        for (let i2 = 0; i2 < listeners.click.length; i2++) {
          if (listeners.click[i2] === listener) {
            listeners.click.splice(i2, 1);
            break;
          }
        }
      } else {
        console.error("This type of event is not supported!");
      }
    };
    this.css2d_render_tags[id] = marker;
    this._map.needCss2DRefresh = true;
    return marker;
  }
  // 添加三维立体标签
  add3dMarker(options, callback) {
    const _this = this;
    const keys = ["width", "height", "element", "data"];
    for (let i2 = 0; i2 < keys.length; i2++) {
      if (!options[keys[i2]]) {
        console.error("addMarker3D接口中必填参数" + keys[i2] + "未定义，请检查参数值！");
        return;
      }
    }
    const tb = this._map.tb;
    const originCoord = options.data[0].coordinate;
    const originWorldUnit = tb.projectToWorld(originCoord);
    const worldUnitPerMeter = tb.projectedUnitsPerMeter(originCoord[1]);
    options.element.style.position = "absolute";
    options.element.style.top = "-10000px";
    this._map.getCanvas().parentElement.appendChild(options.element);
    html2canvas(options.element, {
      allowTaint: true,
      useCORS: true,
      backgroundColor: null,
      scale: 8
    }).then((canvas) => {
      const material = new MeshBasicMaterial$1({
        map: new CanvasTexture$1(canvas),
        side: DoubleSide$1,
        transparent: true,
        opacity: 1,
        depthTest: void 0 === options.depthTest || options.depthTest
      });
      let { width, height } = options;
      width *= worldUnitPerMeter;
      height *= worldUnitPerMeter;
      const geometry = new BufferGeometry$1();
      const xyzArray = new Float32Array([
        -width / 2,
        0,
        0,
        width / 2,
        0,
        0,
        width / 2,
        0,
        height,
        -width / 2,
        0,
        height
      ]);
      const indexArray = new Uint16Array([0, 1, 3, 1, 2, 3]);
      geometry.setIndex(new BufferAttribute$1(indexArray, 1));
      geometry.setAttribute("position", new Float32BufferAttribute$1(xyzArray, 3));
      geometry.setAttribute("uv", new Float32BufferAttribute$1([0, 0, 1, 0, 1, 1, 0, 1], 2));
      const originMesh = new Mesh$1(geometry, material);
      const meshes = [];
      options.data.forEach((data) => {
        const mesh = originMesh.clone();
        const worldUnit = tb.projectToWorld(data.coordinate);
        mesh.position.set(
          worldUnit.x - originWorldUnit.x,
          worldUnit.y - originWorldUnit.y,
          worldUnit.z - originWorldUnit.z
        );
        if (typeof data.rotationOffset == "number") {
          mesh.rotation.z = utils.radify(data.rotationOffset);
        }
        for (let key in data) mesh.userData[key] = data[key];
        meshes.push(mesh);
      });
      const group = tb.Object3D({ obj: meshes }).setCoords(originCoord);
      _this.group.add(group);
      if (typeof callback == "function") callback(group);
    });
  }
  // 绘制三维立体标签使其面向相机
  render3dMarker(groups) {
    const ratate = utils.radify(this._map.getBearing() + 180);
    if (Array.isArray(groups) && groups.length > 0) {
      for (let i2 = 0; i2 < groups.length; i2++) {
        if (void 0 !== groups[i2].children) {
          for (let j = 0; j < groups[i2].children.length; j++)
            groups[i2].children[j].rotation.z = -ratate;
        }
      }
    } else if (void 0 !== groups && groups.children) {
      for (let i2 = 0; i2 < groups.children.length; i2++) {
        groups.children[i2].rotation.z = -ratate;
      }
    }
  }
  // 通过屏幕坐标获取三维立体标签
  // get3dMarker(point, groups) {
  //   if (Array.isArray(groups) && groups.length > 0) {
  //     for (let i = 0; i < groups.length; i++) {
  //       if (undefined === groups[i].children) {
  //         groups.splice(i, 1)
  //         i--
  //       }
  //     }
  //   }
  //   let result = this._map.tb.queryRenderedFeatures(point, groups, true)[0]
  //   return result ? result.object : null
  // }
  // 添加三维文字标签
  addTextMarker(options) {
    let { fontSize: fontSize2, fontFamily: fontFamily2, letterSpacing: letterSpacing2, type, color: color2, data } = options;
    if (!options.data) {
      console.error("addMarker3D接口中必填参数data未定义，请检查参数值！");
      return;
    }
    data = Array.isArray(options.data) ? options.data : [options.data];
    fontFamily2 = fontFamily2 || "sans-serif";
    color2 = color2 || "#000000";
    letterSpacing2 = typeof letterSpacing2 == "number" ? letterSpacing2 : 0;
    fontSize2 = typeof fontSize2 == "number" ? fontSize2 : 10;
    type = type || "horizontal";
    const meshes = [];
    let scale = 1;
    const tb = this._map.tb;
    const originCoord = data[0].coordinate;
    const originWorldUnit = tb.projectToWorld(originCoord);
    if (fontSize2 < 51) {
      scale = 50 / fontSize2;
      fontSize2 = 50;
    }
    letterSpacing2 *= scale;
    data.forEach((data2) => {
      let { text, angle: angle2 } = data2;
      angle2 = angle2 || [0, 0, 0];
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      ctx.font = "" + fontSize2 + "px " + fontFamily2;
      ctx.fillStyle = color2;
      if ("horizontal" == type) {
        const totalSize = ctx.measureText(text);
        let width = 0;
        let height = totalSize.actualBoundingBoxAscent + totalSize.actualBoundingBoxDescent;
        const sizes = [];
        for (let i2 = 0; i2 < text.length; i2++) {
          const word = text.slice(i2, i2 + 1).toString();
          const size = ctx.measureText(word);
          width += size.width + letterSpacing2;
          sizes.push(size);
        }
        width -= letterSpacing2;
        height += 1 / 4 * height;
        canvas.width = width;
        canvas.height = height;
        let left = 0;
        const top = height - 1 / 8 * height;
        ctx.font = "" + fontSize2 + "px " + fontFamily2;
        ctx.fillStyle = color2;
        for (let i2 = 0; i2 < text.length; i2++) {
          const word = text.slice(i2, i2 + 1).toString();
          ctx.fillText(word, left, top);
          left += sizes[i2].width + letterSpacing2;
        }
      } else if ("vertical" == type) {
        let width = 0;
        let height = 0;
        const sizes = [];
        for (let i2 = 0; i2 < text.length; i2++) {
          const word = text.slice(i2, i2 + 1).toString();
          const size = ctx.measureText(word);
          if (width < size.width) width = size.width;
          height += size.actualBoundingBoxAscent + size.actualBoundingBoxDescent + letterSpacing2;
          sizes.push(size);
        }
        height -= letterSpacing2;
        canvas.width = 1 / 4 * width + width;
        canvas.height = height;
        let top = 0;
        ctx.font = "" + fontSize2 + "px " + fontFamily2;
        ctx.fillStyle = color2;
        ctx.textBaseline = "top";
        for (let i2 = 0; i2 < data2.text.length; i2++) {
          const word = data2.text.slice(i2, i2 + 1).toString();
          ctx.fillText(word, (canvas.width - sizes[i2].width) / 2, top);
          top += sizes[i2].actualBoundingBoxAscent + sizes[i2].actualBoundingBoxDescent + letterSpacing2;
        }
      } else {
        return;
      }
      const texture = new CanvasTexture$1(canvas);
      if (threeVersion > 151) {
        texture.colorSpace = SRGBColorSpace;
      } else {
        texture.outputEncoding = void 0;
      }
      const material = new MeshBasicMaterial$1({ map: texture, side: DoubleSide$1 });
      const w = 100 * scale;
      const S = canvas.width / w;
      const T2 = canvas.height / w;
      const uvArray = [0, 0, 1, 0, 1, 1, 0, 1];
      const geometry = new BufferGeometry$1();
      const xyzArray = new Float32Array([
        -S / 2,
        -T2 / 2,
        0,
        S / 2,
        -T2 / 2,
        0,
        S / 2,
        T2 / 2,
        0,
        -S / 2,
        T2 / 2,
        0
      ]);
      const indexArray = new Uint16Array([0, 1, 3, 1, 2, 3]);
      geometry.setIndex(new BufferAttribute$1(indexArray, 1));
      geometry.setAttribute("position", new Float32BufferAttribute$1(xyzArray, 3));
      geometry.setAttribute("uv", new Float32BufferAttribute$1(uvArray, 2));
      geometry.computeVertexNormals();
      geometry.rotateZ(Math.PI);
      const mesh = new Mesh$1(geometry, material);
      mesh.rotation.set(
        angle2[0] / 180 * Math.PI,
        -angle2[1] / 180 * Math.PI,
        -angle2[2] / 180 * Math.PI
      );
      mesh.traverse(function(t3) {
        if (t3 instanceof Mesh$1) {
          t3.material.transparent = true;
          t3.material.needsUpdate = true;
        }
      });
      const worldUnit = tb.projectToWorld(data2.coordinate);
      mesh.position.set(
        worldUnit.x - originWorldUnit.x,
        worldUnit.y - originWorldUnit.y,
        worldUnit.z - originWorldUnit.z
      );
      meshes.push(mesh);
    });
    let group = tb.Object3D({ obj: meshes }).setCoords(originCoord);
    this.group.add(group);
    return group;
  }
  // 添加动态水纹
  addDynamicWater(options) {
    const obj = this._map.effectLayer.addDynamicWater(options);
    this.effectObjects.push(obj);
    return obj;
  }
  // 监听首次渲染
  onFirstRender(obj, isAll, callback) {
    if (obj) {
      let tbGroup = getThreeBoxGroup(obj);
      if (!tbGroup || tbGroup.name != this.id) {
        console.error("非法的模型对象！");
        return;
      }
    } else {
      console.error("非法的模型对象！");
      return;
    }
    if (isAll) {
      const meshes = [];
      obj.traverse((child) => {
        if (child instanceof Mesh$1 && child.visible) {
          meshes.push(child);
        }
      });
      let count = 0;
      meshes.forEach((mesh) => {
        mesh.onAfterRender = function() {
          this.onAfterRender = () => {
          };
          count++;
          if (count === meshes.length && typeof callback === "function") {
            console.log(meshes.length + " meshs rendering complete");
            callback();
          }
        };
      });
    } else {
      const camera = this._map.tb.camera;
      camera.updateMatrixWorld();
      const frustum = new Frustum$1();
      frustum.setFromProjectionMatrix(
        new Matrix4$1().multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse)
      );
      const meshes = [];
      obj.traverse((child) => {
        if (child instanceof Mesh$1 && child.visible) {
          child.geometry.computeBoundingSphere();
          if (frustum.intersectsObject(child)) meshes.push(child);
        }
      });
      let count = 0;
      meshes.forEach((mesh) => {
        mesh.onAfterRender = function() {
          this.onAfterRender = () => {
          };
          count++;
          if (count === meshes.length) {
            console.log(meshes.length + " meshs rendering complete");
            callback();
          }
        };
      });
    }
  }
  // 选择模型
  selectModel(point2, obj, recursive) {
    if (obj) {
      let tbGroup = getThreeBoxGroup(obj);
      if (!tbGroup || tbGroup.name != this.id) {
        console.error("非法的模型对象！");
        return [];
      }
    } else {
      obj = this.group;
    }
    recursive = void 0 === recursive || recursive;
    return this._map.tb.queryRenderedFeatures(point2, obj, recursive);
  }
  // 描边高亮模型
  outlineModel(objs, options = {}) {
    if (!Array.isArray(objs) || objs.length == 0) {
      console.error("非法的模型对象！");
      return;
    }
    for (let i2 = 0; i2 < objs.length; i2++) {
      let geoGroup = getThreeBoxGroup(objs[i2]);
      if (!geoGroup || geoGroup.name != this.id) {
        console.error("非法的模型对象！");
        return;
      }
    }
    let { scope } = options;
    scope = void 0 === scope ? "default" : scope;
    if (!["model", "layer", "default"].includes(scope)) {
      console.error("非法的scope参数！");
      return;
    }
    let selectedObjects = [];
    let uuids = [];
    for (let i2 = 0; i2 < objs.length; i2++) {
      let obj;
      switch (scope) {
        case "model":
          obj = objs[i2];
          while (obj) {
            if (obj.parent.isGeoGroup) {
              break;
            }
            obj = obj.parent;
          }
          if (!obj) return;
          break;
        case "layer":
          obj = this.group;
          break;
        default:
          obj = objs[i2];
      }
      if (!uuids.includes(obj.uuid)) {
        uuids.push(obj.uuid);
        selectedObjects.push(obj);
      }
    }
    this.outlinePass.selectedObjects = selectedObjects;
    this._selected = true;
  }
  // 取消描边高亮模型
  unOutlineModel() {
    this.outlinePass.selectedObjects = [];
    this._selected = false;
  }
  setOutlineOption(options) {
    const { edgeStrength, edgeGlow, edgeThickness, edgeColor, enableFillColor, fillColorOpacity } = options;
    if (void 0 !== edgeStrength) this.outlinePass.edgeStrength = edgeStrength;
    if (void 0 !== edgeGlow) this.outlinePass.edgeGlow = edgeGlow;
    if (void 0 !== edgeThickness) this.outlinePass.edgeThickness = edgeThickness;
    if (void 0 !== edgeColor) this.outlinePass.visibleEdgeColor.set(edgeColor);
    if (void 0 !== enableFillColor) this.outlinePass.usePatternColor = enableFillColor;
    if (void 0 !== fillColorOpacity) this.outlinePass.patternColorOpacity = fillColorOpacity;
    if (void 0 !== edgeGlow) {
      if (edgeGlow > 0) {
        this.outlinePass.edgeThickness = 4;
        this.outlineOpuputPass.material.blending = CustomBlending$1;
        this.outlineOpuputPass.material.blendSrc = OneFactor$1;
        this.outlineOpuputPass.material.blendSrcAlpha = SrcAlphaFactor$1;
        this.outlineOpuputPass.material.blendDst = OneMinusSrcAlphaFactor$1;
        this.outlineOpuputPass.material.blendDstAlpha = OneFactor$1;
      } else {
        this.outlinePass.edgeThickness = 1;
        this.outlineOpuputPass.material.blending = NormalBlending$1;
      }
    }
  }
  // 删除模型
  removeModel(obj) {
    if (obj && obj.type) {
      for (let i2 = 0; i2 < this.effectObjects.length; i2++) {
        if (obj.uuid == this.effectObjects[i2].uuid) {
          this.effectObjects.splice(i2, 1);
          this._map.effectLayer.removeEffect(obj);
          break;
        }
      }
      this._map.tb.clear(obj);
    }
  }
}
const rulerCursor = "data:application/octet-stream;base64,AAACAAEAICAAAAMABgCoEAAAFgAAACgAAAAgAAAAQAAAAAEAIAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAACQAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAABcAAAAlAAAAFwAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAXAAAAMwAAAEEAAAAzAAAAFwAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAFwAAADMuLi//AAAASgAAAEUAAAAzAAAAFwAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAABcAAAAzLi4v/+Pj4/8uLi//AAAASgAAAEUAAAAzAAAAFwAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAXAAAAMy4uL//j4+P//////+Pj4/8uLi//AAAASgAAAEUAAAAzAAAAFwAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAFwAAADMuLi//4+Pj/////////////////+Pj4/8uLi//AAAASgAAAEEAAAAlAAAACQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAABcAAAAzLi4v/+Pj4////////////////////////////+Pj4/8uLi//AAAAMwAAABcAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAXAAAAMy4uL//j4+P//////////////////////y4uL////////////+Pj4/8uLi//AAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAFwAAADMuLi//4+Pj/////////////////////////////////y4uL///////Li4v/wAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAABcAAAAzLi4v/+Pj4///////////////////////Li4v/////////////////y4uL/8AAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAXAAAAMy4uL//j4+P///////////8uLi//////////////////Li4v//////8uLi//AAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//8AAP//AAD//wAA//8AAAAAAAAAAAAAAAAAAAAFAAAAFwAAADMuLi//4+Pj//////////////////////8uLi//////////////////Li4v/wAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP//AAD//wAA//8AAP//AAD//wAA//8AAAAAAAAAAAAAAAkAAAAlLi4v/+Pj4/////////////////////////////////8uLi///////y4uL/8AAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//8AAP////////////8AAP//AAD//wAAAAAAAAAAAAAABS4uL//j4+P//////////////////////y4uL/////////////////8uLi//AAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD//wAA/////////////wAA//8AAP//AAAAAAAAAAAuLi//4+Pj/////////////////////////////////y4uL///////Li4v/wAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP//AAD//wAA//8AAP//AAD//wAA//8AAAAAAAAAAAAAAAAuLi//////////////////Li4v/////////////////y4uL/8AAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP//AAD//wAA//8AAP//AAAAAAAAAAAAAAAAAAAAAAAAAAAuLi//////////////////Li4v//////8uLi//AAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuLi//////////////////Li4v/wAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuLi///////y4uL/8AAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuLi//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//////////////////////////////////////////////////////////////H////g////wH///4A///8AH//+AA///AAP//gAD//wAB//4AA//8AAf/+AAP+HAAH/AwAD/wMAB/8DAA//A4Af/4fAP///4H////D////7//8=";
const plane_yuan = "data:image/png;base64,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";
const plane_yuan1 = "data:image/png;base64,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";
const plane_yuan2 = "data:image/png;base64,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";
const plane_pt = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAA7klEQVR4nO3US7HCQBgF4ZMUjnCBkIsECgUUEhDCdYGmYRGyAAH5Fjm9mppV/z2P6e85bkkuSaYsjCT3xynX7IA538Pns74Yne055Hv4len8n+PWMoJZC2gOWd787y0Yj1NewGdz5iT3LBFWxmdvF0xjLLOvb34vJ7+y+z+gAbSApgG0gKYBtICmAbSApgG0gKYBtICmAbSApgG0gKYBtICmAbSApgG0gKYBtICmAbSApgG0gKYBtICmAbSApgG0gKYBtICmAbSApgG0gKYBtICmAbSApgG0gKYBtICmAbSApgG0gKYBtICmAbSA5g1dWhV+QM9uggAAAABJRU5ErkJggg==";
const water_normals = "data:image/jpeg;base64,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";
const Park3Med_nx = "data:image/jpeg;base64,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";
const Park3Med_px = "data:image/jpeg;base64,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";
const Park3Med_pz = "data:image/jpeg;base64,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";
const Park3Med_nz = "data:image/jpeg;base64,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";
const Park3Med_py = "data:image/jpeg;base64,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";
const Park3Med_ny = "data:image/jpeg;base64,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";
const defaultMaxPitch = 135;
const defaultLngLat = [121.63523, 31.34435];
const processDataRAF = (data, processFn, onFinish) => {
  const config = {
    TARGET_FPS: 60,
    PROCESSING_BUDGET_RATIO: 0.5,
    // JS处理时间的预算比例，0.5 表示期望计算不超过每帧时间的50%。
    INITIAL_BATCH_SIZE: 30,
    // 初始批处理大小
    MIN_BATCH_SIZE: 5,
    // 最小批处理大小，防止完全停止
    MAX_BATCH_SIZE: 500,
    // 最大批处理大小，防止单帧任务过重
    SMOOTHING_FACTOR: 0.95
    // 平滑因子 (0 < a < 1)。值越小，调整越平滑、越慢。
  };
  let index2 = 0;
  const frameProcessingBudget = 1e3 / config.TARGET_FPS * config.PROCESSING_BUDGET_RATIO;
  let chunkSize = config.INITIAL_BATCH_SIZE;
  const step = () => {
    const startTime = performance.now();
    const endIndex = Math.min(index2 + chunkSize, data.length);
    const actualBatchCount = endIndex - index2;
    for (; index2 < endIndex; index2++) {
      processFn(data[index2]);
    }
    const duration2 = performance.now() - startTime;
    if (actualBatchCount > 0) {
      const timePerItem = duration2 / actualBatchCount;
      const idealBatchSize = frameProcessingBudget / (timePerItem + 1e-5);
      const smoothedBatchSize = config.SMOOTHING_FACTOR * chunkSize + (1 - config.SMOOTHING_FACTOR) * idealBatchSize;
      chunkSize = Math.round(
        Math.max(config.MIN_BATCH_SIZE, Math.min(config.MAX_BATCH_SIZE, smoothedBatchSize))
      );
    }
    if (index2 < data.length) {
      requestAnimationFrame(step);
    } else {
      onFinish == null ? void 0 : onFinish();
    }
  };
  requestAnimationFrame(step);
};
let Map$1 = class Map2 extends mapboxgl.Map {
  constructor(options) {
    const maxPitch = options.maxPitch;
    if (options && typeof maxPitch == "number" && maxPitch > 85) options.maxPitch = 85;
    options.antialias = true;
    options.locale = {
      "NavigationControl.ResetBearing": "恢复正北方向",
      "NavigationControl.ZoomIn": "放大一级",
      "NavigationControl.ZoomOut": "缩小一级"
    };
    super(options);
    this.loading = {
      visible: 0,
      // 大于0显示加载动画
      msg: null
    };
    this.showLoading(true, "地图加载中……", true);
    if (options && typeof maxPitch == "number" && maxPitch > 85) {
      options.maxPitch = maxPitch;
      this.setMaxPitch(options.maxPitch);
    }
    if (options && options.dracoPath) this.setDracoPath(options.dracoPath);
    if (options && options.ktx2Path) this.setKTX2Path(options.ktx2Path);
    if (options && options.defaultModel) this.setDefaultModel(options.defaultModel);
    this.enableOIT = !(void 0 === options.enableOIT) && options.enableOIT;
    this.deferredRendering = void 0 === options.deferredRendering || options.deferredRendering;
    this.removeControl(this._logoControl);
    this.materialCache = {};
    this.customUniforms = {};
    this._drawing = false;
    this._isShowPage = options.showPage !== void 0 ? options.showPage : false;
    this._3dStyle = "shijing";
    this.once("load", function() {
      window.tb = new ThreeBox(this, options);
      for (let id in this.style._layers) {
        const layer = this.style._layers[id];
        layer._originVisible = this.getLayoutProperty(id, "visibility");
      }
      const mapType = options && options.mapType || "2d";
      this._baseLayers = Object.keys(this.style._layers);
      this.setMapType(mapType);
      $(this.getContainer()).children(".mapboxgl-canvas-container").css("visibility", "visible");
      if (this.getMapType() !== "3d") {
        this.showLoading(false);
      }
    });
    const _this = this;
    this.resizeObserver = new ResizeObserver(() => {
      _this.resize();
    });
    this.resizeObserver.observe(this.getContainer());
    $(this.getContainer()).children(".mapboxgl-canvas-container").css("visibility", "none");
  }
  _authenticate() {
  }
  remove() {
    if (this.gui) {
      this.gui.close();
      this.gui = null;
    }
    if (this.style && this.style._order && this.style._order.length > 0) {
      for (let i2 = this.style._order.length - 1; i2 > -1; i2--) {
        let layer = this.getLayer(this.style._order[i2]);
        if (layer && layer.isThreeBoxLayer) super.removeLayer(layer.id);
      }
    }
    if (this.tb) {
      this.tb.dispose();
      this.tb = null;
    }
    this.resizeObserver.unobserve(this.getContainer());
    this.resizeObserver.disconnect();
    super.remove();
  }
  get drawing() {
    return this._drawing;
  }
  // 设置最大允许俯仰角度
  setMaxPitch(maxPitch) {
    maxPitch = maxPitch === null || maxPitch === void 0 ? defaultMaxPitch : maxPitch;
    if (maxPitch > defaultMaxPitch) {
      throw new Error(`maxPitch must be less than or equal to ${defaultMaxPitch}`);
    }
    if (maxPitch >= this.transform.minPitch) {
      this.transform.maxPitch = maxPitch;
      this._update();
      if (this.getPitch() > maxPitch) {
        this.setPitch(maxPitch);
      } else {
        this.fire(new mapboxgl.Event("pitchstart")).fire(new mapboxgl.Event("pitch")).fire(new mapboxgl.Event("pitchend"));
      }
      return this;
    } else throw new Error(`maxPitch must be greater than or equal to minPitch`);
  }
  // 设置3d环境贴图
  setEnvMap(envMap) {
    if (this.tb) this.tb.setEnvMap(envMap);
  }
  // 设置默认光线
  setDefaultLight(isOpen) {
    if (this.tb) this.tb.setDefaultLight(isOpen);
  }
  // 切换地图类型
  setMapType(mapType) {
    if (this._mapType === mapType) return;
    if (this._mapType === "2d") {
      for (let id of this._baseLayers) {
        const layer = this.style._layers[id];
        if (layer) {
          if (!(layer.implementation && layer.implementation.isThreeBoxLayer)) {
            if (!["satellite"].includes(id)) {
              layer._originVisible = this.getLayoutProperty(id, "visibility");
            }
          }
        }
      }
    }
    this._mapType = mapType;
    if (mapType === "2d") {
      for (let id of this._baseLayers) {
        const layer = this.style._layers[id];
        if (layer) {
          if (!(layer.implementation && layer.implementation.isThreeBoxLayer)) {
            if (!["satellite"].includes(id)) {
              this.setLayoutProperty(id, "visibility", layer._originVisible);
            } else {
              this.setLayoutProperty(id, "visibility", "none");
            }
          } else if (id === "default_scene") {
            this.setLayoutProperty(id, "visibility", "none");
          }
        }
      }
      this.fire(new mapboxgl.Event("maptypechange"));
    } else if (mapType === "satellite") {
      for (let id of this._baseLayers) {
        const layer = this.style._layers[id];
        if (layer) {
          if (!(layer.implementation && layer.implementation.isThreeBoxLayer)) {
            if (["satellite", "background"].includes(id)) {
              this.setLayoutProperty(
                id,
                "visibility",
                id === "satellite" ? "visible" : layer._originVisible
              );
            } else {
              this.setLayoutProperty(id, "visibility", "none");
            }
          } else if (id === "default_scene") {
            this.setLayoutProperty(id, "visibility", "none");
          }
        }
      }
      this.fire(new mapboxgl.Event("maptypechange"));
    } else if (mapType === "3d") {
      const layer = this.getLayer("default_model");
      if (!layer) {
        this._createModelLayer();
        this._baseLayers.push("default_scene");
      }
      for (let id of this._baseLayers) {
        const layer2 = this.style._layers[id];
        if (layer2) {
          if (!(layer2.implementation && layer2.implementation.isThreeBoxLayer)) {
            this.setLayoutProperty(id, "visibility", "none");
          } else if (id === "default_scene") {
            this.setLayoutProperty(id, "visibility", "visible");
          }
        }
      }
      if (layer) this.fire(new mapboxgl.Event("maptypechange"));
    }
    return this;
  }
  // 获取地图类型
  getMapType() {
    return this._mapType;
  }
  // 设置3d样式
  set3dStyle(style) {
    if (this._3dStyle !== style) {
      this._3dStyle = style;
      const layer = this.getLayer("default_model");
      if (layer) {
        const kjGroup = layer.group.getObjectByName("keji");
        const sjGroup = layer.group.getObjectByName("shijing");
        const water = this.tb.scene.getObjectByName("water");
        if (this._3dStyle === "keji") {
          if (kjGroup) {
            kjGroup.visible = true;
          } else {
            this._initKeJiStyle(true);
          }
          sjGroup.visible = false;
          if (this._plane3d) this._plane3d.visible = true;
          if (water) water.visible = false;
        } else {
          if (kjGroup) kjGroup.visible = false;
          sjGroup.visible = true;
          if (this._plane3d) this._plane3d.visible = false;
          if (water) water.visible = true;
        }
      }
    }
  }
  // 获取3d样式
  get3dStyle() {
    return this._3dStyle;
  }
  // 设置draco路径
  setDracoPath(url) {
    this._dracoUrl = url;
    return this;
  }
  // 获取draco路径
  getDracoPath() {
    return this._dracoUrl;
  }
  // 设置ktx2路径
  setKTX2Path(url) {
    this._ktx2Url = url;
    return this;
  }
  // 获取ktx2路径
  getKTX2Path() {
    return this._ktx2Url;
  }
  // 设置默认三维模型地址
  setDefaultModel(model) {
    if (!model.url || !model.type)
      throw new Error("The default model must include URL and type attributes!");
    this._defaultModel = model;
    return this;
  }
  // 创建3d场景图层，负责动画刷新，不对外暴露
  _createSceneLayer() {
    let beforeId;
    if (this.style && this.style._order && this.style._order.length > 0) {
      if (this._baseLayers && this._baseLayers.length > 0) {
        for (let i2 = this.style._order.length - 1; i2 > -1; i2--) {
          if (this.style._order[i2] === this._baseLayers[this._baseLayers.length - 1]) {
            if (i2 < this.style._order.length - 1) beforeId = this.style._order[i2 + 1];
            break;
          }
        }
      } else {
        beforeId = this.style._order[0];
      }
    }
    this.addLayer(
      {
        id: "default_scene",
        type: "model"
      },
      beforeId
    );
  }
  // 创建模型图层
  _createModelLayer() {
    const _this = this;
    const materialCache = new window.Map();
    const envMap = new CubeTextureLoader$1().load([
      Park3Med_px,
      Park3Med_nx,
      Park3Med_py,
      Park3Med_ny,
      Park3Med_pz,
      Park3Med_nz
    ]);
    function createPhongMaterialFromStandardMaterial(standardMaterial) {
      if (materialCache.has(standardMaterial.uuid)) {
        return materialCache.get(standardMaterial.uuid);
      }
      const phongMaterial = new MeshPhongMaterial$1({
        alphaMap: standardMaterial.alphaMap,
        alphaTest: standardMaterial.alphaTest,
        alphaToCoverage: standardMaterial.alphaToCoverage,
        aoMap: standardMaterial.aoMap,
        aoMapIntensity: standardMaterial.aoMapIntensity,
        blendDst: standardMaterial.blendDst,
        blendDstAlpha: standardMaterial.blendDstAlpha,
        blendEquation: standardMaterial.blendEquation,
        blendEquationAlpha: standardMaterial.blendEquationAlpha,
        blendSrc: standardMaterial.blendSrc,
        blendSrcAlpha: standardMaterial.blendSrcAlpha,
        blending: standardMaterial.blending,
        bumpMap: standardMaterial.bumpMap,
        bumpScale: standardMaterial.bumpScale,
        clipIntersection: standardMaterial.clipIntersection,
        clipShadows: standardMaterial.clipShadows,
        clippingPlanes: standardMaterial.clippingPlanes,
        color: standardMaterial.color,
        colorWrite: standardMaterial.colorWrite,
        combine: AddOperation$1,
        depthFunc: standardMaterial.depthFunc,
        depthTest: standardMaterial.depthTest,
        depthWrite: standardMaterial.depthWrite,
        displacementBias: standardMaterial.displacementBias,
        displacementMap: standardMaterial.displacementMap,
        displacementScale: standardMaterial.displacementScale,
        dithering: standardMaterial.dithering,
        emissive: standardMaterial.emissive,
        emissiveIntensity: standardMaterial.emissiveIntensity,
        emissiveMap: standardMaterial.emissiveMap,
        envMap: standardMaterial.envMap,
        flatShading: standardMaterial.flatShading,
        fog: standardMaterial.fog,
        lightMap: standardMaterial.lightMap,
        lightMapIntensity: standardMaterial.lightMapIntensity,
        map: standardMaterial.map,
        morphNormals: standardMaterial.morphNormals,
        morphTargets: standardMaterial.morphTargets,
        name: standardMaterial.name,
        normalMap: standardMaterial.normalMap,
        normalMapType: standardMaterial.normalMapType,
        normalScale: standardMaterial.normalScale,
        opacity: standardMaterial.opacity,
        polygonOffset: standardMaterial.polygonOffset,
        polygonOffsetFactor: standardMaterial.polygonOffsetFactor,
        polygonOffsetUnits: standardMaterial.polygonOffsetUnits,
        precision: standardMaterial.precision,
        premultipliedAlpha: standardMaterial.premultipliedAlpha,
        reflectivity: 1,
        refractionRatio: 0.98,
        shadowSide: standardMaterial.shadowSide,
        shininess: 100 * (1 - standardMaterial.roughness) * (1 - standardMaterial.roughness) / (1 - (1 - standardMaterial.roughness) * (1 - standardMaterial.roughness)),
        side: standardMaterial.side,
        skinning: standardMaterial.skinning,
        specular: new Color$1().setRGB(
          standardMaterial.metalness / 3,
          standardMaterial.metalness / 3,
          standardMaterial.metalness / 3
        ),
        stencilFail: standardMaterial.stencilFail,
        stencilFunc: standardMaterial.stencilFunc,
        stencilFuncMask: standardMaterial.stencilFuncMask,
        stencilRef: standardMaterial.stencilRef,
        stencilWrite: standardMaterial.stencilWrite,
        stencilWriteMask: standardMaterial.stencilWriteMask,
        stencilZFail: standardMaterial.stencilZFail,
        stencilZPass: standardMaterial.stencilZPass,
        toneMapped: standardMaterial.toneMapped,
        transparent: standardMaterial.transparent,
        userData: standardMaterial.userData,
        vertexColors: standardMaterial.vertexColors,
        visible: standardMaterial.visible,
        wireframe: standardMaterial.wireframe,
        wireframeLinecap: standardMaterial.wireframeLinecap,
        wireframeLinejoin: standardMaterial.wireframeLinejoin,
        wireframeLinewidth: standardMaterial.wireframeLinewidth
      });
      materialCache.set(standardMaterial.uuid, phongMaterial);
      return phongMaterial;
    }
    const SPECIAL_MATERIALS_SET = /* @__PURE__ */ new Set([
      "shu_08",
      "wangge",
      "wgq003",
      "wgq04",
      "tts1",
      "tt1",
      "tt6",
      "toutie",
      "tt111",
      "langan",
      "langan1",
      "langan2",
      "langan3",
      "langan3",
      "langan4",
      "toutie",
      "xj-lw_48",
      "tt8",
      "lg",
      "tt10",
      "tt9",
      "lvweilan",
      "zhalan1",
      "tt5",
      "tt2",
      "YXX0019",
      "louti",
      "wgq01",
      "xj-xp-31"
    ]);
    const REFLECTIVE_MATERIALS_SET = /* @__PURE__ */ new Set(["boli", "ty_ch", "bolimen", "chuanghu23"]);
    const transformParams = {
      rotateX: 0,
      rotateY: 0,
      rotateZ: -28.5,
      scaleX: 0.995,
      scaleY: 0.995,
      scaleZ: 0.995,
      opacity: 0.7
    };
    let initResolve;
    const initPromise = new Promise((resolve, reject) => initResolve = resolve);
    this.addLayer({
      id: "default_model",
      type: "model",
      models: [this._defaultModel],
      units: "centimeters",
      lnglat: [...defaultLngLat, -4.48],
      showLoading: true,
      callback: function(group, layer) {
        group.visible = false;
        group.setRotation({
          x: transformParams["rotateX"],
          y: transformParams["rotateY"],
          z: transformParams["rotateZ"]
        });
        group.setScale({
          x: transformParams["scaleX"],
          y: transformParams["scaleY"],
          z: transformParams["scaleZ"]
        });
        const sjGroup = group.children[0];
        sjGroup.name = "shijing";
        const materialHandlers = {
          shui: (child, layer2) => {
            child.visible = false;
            const water = _this.tb.scene.getObjectByName("water");
            if (water) {
              water.visible = _this._3dStyle === "shijing";
              return;
            }
            const worldUnits = _this.tb.getWolrdUnitFromMesh(child);
            const points = worldUnits.map((vector3) => vector3.clone().sub(worldUnits[0]));
            const geometry = child.geometry.clone();
            geometry.setFromPoints(points);
            // const waterObject = layer2.addDynamicWater({
            //   id: "water",
            //   textureWidth: 512,
            //   waterNormals: water_normals,
            //   alpha: 0.75,
            //   sunDirection: layer2._map.tb.scene.getObjectByName("dir_light").position.clone().normalize(),
            //   sunColor: 16777215,
            //   waterColor: 7695,
            //   distortionScale: 100,
            //   size: 1,
            //   geometry,
            //   lngLats: [layer2._map.tb.unprojectFromWorld(worldUnits[0])]
            // });
            // waterObject.visible = _this._3dStyle === "shijing";
          },
          car: (child) => {
            child.visible = false;
          }
        };
        const processMaterial = (material, isGLB2 = false) => {
          const key = material.uuid;
          material.vertexColors = false;
          if (materialCache.has(key)) return materialCache.get(key);
          if (REFLECTIVE_MATERIALS_SET.has(material.name)) {
            if (isGLB2) {
              const newMaterial = createPhongMaterialFromStandardMaterial(material);
              material.dispose();
              material = newMaterial;
            }
            material.envMap = envMap;
            material.combine = AddOperation$1;
            material.reflectivity = 1;
            material.shininess = 1;
          }
          if (SPECIAL_MATERIALS_SET.has(material.name)) {
            material.transparent = true;
            material.depthWrite = false;
            material.side = DoubleSide$1;
            material.opacity = 0.6 * transformParams.opacity;
          }
          if (material.name === "lanseboli") {
            material.transparent = true;
            material.depthWrite = false;
            material.opacity = 0.6;
          }
          if (material.roughness !== void 0 && material.roughness < 0) {
            material.roughness = 0.858578622341156;
          }
          materialCache.set(key, material);
          return material;
        };
        const meshQueue = [];
        group.traverse((child) => {
          if (!child.isMesh) {
            child.castShadow = true;
            return;
          }
          meshQueue.push(child);
        });
        const finalizeSetup = () => {
          if (_this._3dStyle === "keji") {
            sjGroup.visible = false;
            _this._initKeJiStyle(false);
          } else {
            sjGroup.visible = true;
            if (layer._map._plane3d) layer._map._plane3d.visible = false;
          }
          materialCache.clear();
          group.visible = true;
          initResolve();
        };
        const isGLB = _this._defaultModel.type === "glb";
        processDataRAF(
          meshQueue,
          (child) => {
            const name = child.name || "";
            if (name.includes("shui")) {
              setTimeout(() => materialHandlers.shui(child, layer), 0);
              return;
            }
            if (name.startsWith("car")) {
              materialHandlers.car(child);
              return;
            }
            const isGround = child.name.includes("cao") || child.name.includes("dimian");
            if (isGround) {
              child.castShadow = false;
              child.receiveShadow = true;
            } else {
              child.castShadow = true;
            }
            if (child.material) {
              if (Array.isArray(child.material)) {
                child.material = child.material.map((material) => {
                  if (isGround) material.shininess = 0;
                  processMaterial(material, isGLB);
                });
              } else {
                if (isGround) child.material.shininess = 0;
                child.material = processMaterial(child.material, isGLB);
              }
            }
          },
          finalizeSetup
        );
      }
    });
    return initPromise;
  }
  _initKeJiStyle(showLoading) {
    const layer = this.getLayer("default_model");
    if (!layer) return;
    if (showLoading) this.showLoading(true, "加载中……");
    const sjGroup = layer.group.getObjectByName("shijing");
    const kjGroup = new Group$1();
    kjGroup.visible = false;
    kjGroup.name = "keji";
    kjGroup.visible = true;
    sjGroup.parent.add(kjGroup);
    const materials = {
      whiteLine: new LineBasicMaterial$1({
        color: new Color$1().setHex(16777215, LinearSRGBColorSpace),
        transparent: true,
        opacity: 0.6,
        depthTest: true,
        depthWrite: false,
        linewidth: mapboxgl.browser.devicePixelRatio
      }),
      blueLine: new LineBasicMaterial$1({
        color: new Color$1().setHex(55551, LinearSRGBColorSpace),
        transparent: true,
        opacity: 0.6,
        depthTest: true,
        depthWrite: false,
        linewidth: mapboxgl.browser.devicePixelRatio
      }),
      pinkLine: new LineBasicMaterial$1({
        color: new Color$1().setHex(13796744, LinearSRGBColorSpace),
        transparent: true,
        opacity: 0.6,
        depthTest: true,
        depthWrite: false,
        linewidth: mapboxgl.browser.devicePixelRatio
      })
    };
    const targetNames = /* @__PURE__ */ new Set([
      "qt-jianzhuwu066",
      "qt-jianzhuwu065",
      "qt-jianzhuwu165",
      "jianzhuwu174",
      "qt-jianzhuwu163",
      "qt-jianzhuwu164",
      "jianzhuwu053",
      "jianzhuwu051",
      "qt-jianzhuwu167",
      "qt-jianzhuwu168",
      "jianzhuwu052",
      "jianzhuwu050",
      "qt-jianzhuwu166",
      "jianzhuwu047",
      "jianzhuwu049",
      "jianzhuwu048",
      "jianzhuwu046",
      "qt-jianzhuwu161",
      "qt-jianzhuwu063",
      "qt-jianzhuwu162",
      "qt-jianzhuwu060",
      "jianzhuwu045",
      "qt-jianzhuwu058",
      "qt-jianzhuwu059",
      "qt-jianzhuwu154",
      "qt-jianzhuwu061",
      "qt-jianzhuwu153",
      "qt-jianzhuwu155",
      "qt-jianzhuwu170",
      "qt-jianzhuwu157",
      "qt-jianzhuwu156",
      "qt-jianzhuwu160",
      "jianzhuwu044",
      "jianzhuwu177",
      "jianzhuwu039",
      "qt-jianzhuwu149",
      "qt-jianzhuwu150",
      "qt-jianzhuwu158",
      "jianzhuwu171",
      "jianzhuwu172",
      "jianzhuwu177",
      "jianzhuwu175",
      "jianzhuwu043",
      "jianzhuwu042",
      "jianzhuwu041",
      "jianzhuwu038",
      "jianzhuwu037",
      "jianzhuwu170",
      "qt-jianzhuwu152",
      "qt-jianzhuwu045",
      "qt-jianzhuwu046",
      "qt-jianzhuwu047"
    ]);
    setTimeout(() => {
      const bottomMeshs = this._create3dPlane();
      layer.addModel(
        [{ type: "model", model: bottomMeshs }],
        defaultLngLat,
        null,
        false,
        (plane3d) => {
          plane3d.setRotation({ x: 0, y: 0, z: -28.5 });
          plane3d.translateZ(-1);
          plane3d.visible = true;
          layer._map._plane3d = plane3d;
        }
      );
    }, 0);
    const geometryCache = new window.Map();
    const getEdgeGeometry = (geometry, angle2) => {
      const key = `${geometry.uuid}_${angle2}`;
      if (!geometryCache.has(key)) {
        geometryCache.set(key, new EdgesGeometry(geometry, angle2));
      }
      return geometryCache.get(key);
    };
    const meshQueue = [];
    sjGroup.parent.traverse((child) => {
      if (!child.isMesh || child.name === "shui" || child.name.startsWith("car")) return;
      meshQueue.push(child);
    });
    if (meshQueue.length === 0) {
      this.showLoading(false);
      return;
    }
    const adaptiveConfig = {
      TARGET_FPS: 60,
      PROCESSING_BUDGET_RATIO: 0.5,
      // JS处理时间的预算比例，0.5 表示期望计算不超过每帧时间的50%。
      INITIAL_BATCH_SIZE: 30,
      // 初始批处理大小
      MIN_BATCH_SIZE: 5,
      // 最小批处理大小，防止完全停止
      MAX_BATCH_SIZE: 200,
      // 最大批处理大小，防止单帧任务过重
      SMOOTHING_FACTOR: 0.95
      // 平滑因子 (0 < a < 1)。值越小，调整越平滑、越慢。
    };
    const frameProcessingBudget = 1e3 / adaptiveConfig.TARGET_FPS * adaptiveConfig.PROCESSING_BUDGET_RATIO;
    let chunkSize = adaptiveConfig.INITIAL_BATCH_SIZE;
    let index2 = 0;
    const processNextFrame = () => {
      const startTime = performance.now();
      const endIndex = Math.min(index2 + chunkSize, meshQueue.length);
      const actualBatchCount = endIndex - index2;
      for (; index2 < endIndex; index2++) {
        const child = meshQueue[index2];
        let lineSegments = null;
        const isTargetName = child.name;
        if (targetNames.has(isTargetName)) {
          lineSegments = new LineSegments$1(
            getEdgeGeometry(child.geometry, 60),
            materials.whiteLine
          );
        } else if (child.parent.name === "KeJiGan" || isTargetName.startsWith("qt_jianzhuwu1111_")) {
          lineSegments = new LineSegments$1(
            getEdgeGeometry(child.geometry, 10),
            materials.blueLine
          );
        } else if (isTargetName === "diaoji007") {
          lineSegments = new LineSegments$1(
            getEdgeGeometry(child.geometry, 24),
            materials.pinkLine
          );
        } else if (isTargetName.startsWith("diaoji")) {
          lineSegments = new LineSegments$1(
            getEdgeGeometry(child.geometry, 15),
            materials.pinkLine
          );
        } else if (isTargetName !== "shu") {
          lineSegments = new LineSegments$1(
            getEdgeGeometry(child.geometry, 60),
            materials.blueLine
          );
        }
        if (lineSegments) {
          child.add(lineSegments);
          kjGroup.attach(lineSegments);
        }
      }
      const duration2 = performance.now() - startTime;
      if (actualBatchCount > 0) {
        const timePerItem = duration2 / actualBatchCount;
        const idealBatchSize = frameProcessingBudget / (timePerItem + 1e-5);
        const smoothedBatchSize = adaptiveConfig.SMOOTHING_FACTOR * chunkSize + (1 - adaptiveConfig.SMOOTHING_FACTOR) * idealBatchSize;
        chunkSize = Math.round(
          Math.max(
            adaptiveConfig.MIN_BATCH_SIZE,
            Math.min(adaptiveConfig.MAX_BATCH_SIZE, smoothedBatchSize)
          )
        );
      }
      if (index2 < meshQueue.length) {
        requestAnimationFrame(processNextFrame);
      } else {
        if (showLoading) this.showLoading(false);
      }
    };
    requestAnimationFrame(processNextFrame);
  }
  // 创建三维地面
  _create3dPlane() {
    let meshes = [];
    const images = [plane_yuan, plane_yuan1, plane_yuan2, plane_pt];
    images.forEach((image2, index2) => {
      let opacity2, size, repeat;
      switch (index2) {
        case 0:
          opacity2 = 0.5;
          size = 700;
          repeat = 1;
          break;
        case 1:
        case 2:
          opacity2 = 0.2;
          size = 700;
          repeat = 1;
          break;
        case 3:
          opacity2 = 0.2;
          size = 500;
          repeat = 500;
          break;
      }
      let texture = new TextureLoader$1().load(image2);
      texture.wrapS = RepeatWrapping$1;
      texture.wrapT = RepeatWrapping$1;
      texture.repeat.set(repeat, repeat);
      let material = new MeshBasicMaterial$1({
        transparent: true,
        opacity: opacity2,
        map: texture,
        depthWrite: false
      });
      let mesh = new Mesh$1(new PlaneGeometry$1(size, size, 1, 1), material);
      mesh.position.set(0, index2 != 3 ? -2 : 0, 0);
      mesh.name = "floor";
      meshes.push(mesh);
    });
    meshes.push(this._createRipple());
    return meshes;
  }
  // 创建波纹
  _createRipple() {
    const vertShader = `
// Examples of variables passed from vertex to fragment shader
varying vec2 vUv;

void main(){
	// To pass variables to the fragment shader, you assign them here in the
	// main function. Traditionally you name the varying with vAttributeName
	vUv=uv;
	
	// This sets the position of the vertex in 3d space. The correct math is
	// provided below to take into account camera and object data.
	gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.);
}
`;
    const fragShader = `
#define TAU 6.28318530718
#define MAX_ITER 5

uniform vec2 resolution;
uniform vec3 backgroundColor;
uniform vec3 color;
uniform float speed;
uniform vec2 flowSpeed;
uniform float brightness;
uniform float time;
uniform float opacity;  // 添加透明度 uniform
varying vec2 vUv;

void main(){
	vec2 uv=(vUv.xy+(time*flowSpeed))*resolution;
	
	vec2 p=mod(uv*TAU,TAU)-250.;
	vec2 i=vec2(p);
	
	float c=1.;
	float inten=.005;
	
	for(int n=0;n<MAX_ITER;n++){
		float t=time*speed*(1.-(3.5/float(n+1)));
		i=p+vec2(cos(t-i.x)+sin(t+i.y),sin(t-i.y)+cos(t+i.x));
		c+=1./length(vec2(p.x/(sin(i.x+t)/inten),p.y/(cos(i.y+t)/inten)));
	}
	
	c/=float(MAX_ITER);
	c=1.17-pow(c,brightness);
	
	vec3 rgb=vec3(pow(abs(c),8.));
	
	gl_FragColor=vec4(rgb*color+backgroundColor,opacity);
}
`;
    const geometry = new PlaneGeometry$1(130, 130, 1, 1);
    const material = new ShaderMaterial$1({
      uniforms: {
        resolution: { value: new Vector2$1(1, 1) },
        backgroundColor: { value: new Color$1("#0670c1") },
        color: { value: new Color$1("#fff") },
        speed: { value: 1 },
        flowSpeed: { value: new Vector2$1(0.1, 0.1) },
        brightness: { value: 1.5 },
        time: { value: 0.1 },
        opacity: { value: 0.1 }
      },
      vertexShader: vertShader,
      fragmentShader: fragShader,
      side: DoubleSide$1,
      transparent: true,
      depthWrite: false,
      depthTest: true
    });
    material.opacity = 0.2;
    const mesh = new Mesh$1(geometry, material);
    mesh.name = "ripple";
    mesh.position.set(0, 0, 0);
    return mesh;
  }
  // 显示加载动画
  showLoading(visible, msg, background) {
    let count = this.loading.visible;
    if (visible) count++;
    else count--;
    this.loading = {
      visible: Math.max(0, count),
      msg: Math.max(0, count) > 0 ? msg || this.loading.msg : null
    };
    let lodingContainer = document.getElementById("map-loading");
    if (this.loading.visible > 0) {
      if (!lodingContainer) {
        lodingContainer = utils.createDOM("div", background ? "bg" : "", this.getContainer());
        lodingContainer.id = "map-loading";
        utils.createDOM("div", "box", lodingContainer);
      } else {
        if (background) {
          lodingContainer.classList.add("bg");
        } else if (this.loading.visible == 1) {
          lodingContainer.classList.remove("bg");
        }
      }
      let loadingMsg = lodingContainer.getElementsByTagName("span")[0];
      if (this.loading.msg && this.loading.msg.length > 0) {
        if (!loadingMsg) {
          loadingMsg = utils.createDOM("span", "", lodingContainer);
        }
        loadingMsg.innerText = msg ? msg : "";
      } else {
        if (loadingMsg) {
          loadingMsg.remove();
        }
      }
    } else {
      if (lodingContainer) {
        lodingContainer.remove();
      }
    }
  }
  // 更新加载动画提示文本
  updateLoading(msg) {
    if (this.loading.visible > 0) {
      this.loading.msg = msg;
      let lodingContainer = document.getElementById("map-loading");
      if (lodingContainer) {
        let loadingMsg = lodingContainer.getElementsByTagName("span")[0];
        if (loadingMsg) {
          loadingMsg.innerText = msg;
        }
      }
    }
  }
  // 添加图层
  addLayer(options, beforeId) {
    if (-1 === [
      "custom",
      "viewshed",
      "3dEffect",
      "video-online",
      "sky",
      "background",
      "circle",
      "line",
      "fill",
      "symbol",
      "raster",
      "fill-extrusion",
      "heatmap",
      "hillshade",
      "model",
      "buildings",
      "heatmap-3d",
      "geoVideo",
      "boxVideo",
      "3DTiles",
      "hexagon",
      "grid",
      "tree",
      "arc",
      "trips",
      "i3s",
      "migrate"
    ].indexOf(options.type)) {
      console.warn(
        `layers.${options.id}.type: expected one of ['background', 'circle', 'line', 'fill', 'symbol', 'raster', 'fill-extrusion', 'heatmap', 'hillshade', 'model', 'buildings', 'heatmap-3d', 'geoVideo', 'boxVideo', '3DTiles', 'hexagon', 'grid', 'tree', 'arc', 'trips', 'i3s','migrate']`
      );
      return null;
    }
    let newOptions = {};
    switch (options.type) {
      case "model":
        if (!this.getLayer("default_scene") && options.id !== "default_scene") {
          this._createSceneLayer();
        }
        newOptions = new ModelLayer(options);
        break;
      case "buildings":
        break;
      case "heatmap-3d":
        break;
      case "migrate":
        break;
      case "geoVideo":
        break;
      case "boxVideo":
        break;
      case "3dEffect":
        break;
      case "3DTiles":
        break;
      case "hexagon":
        break;
      case "grid":
        break;
      case "tree":
        break;
      case "video-online":
        break;
      case "arc":
        break;
      case "trips":
        break;
      case "viewshed":
        break;
      case "i3s":
        break;
      default:
        newOptions = options;
    }
    const res = super.addLayer(newOptions, beforeId);
    this.style._layers[options.id]._originVisible = this.getLayoutProperty(options.id, "visibility") || true;
    return res;
  }
  getLayoutProperty(layerId, name) {
    const layer = this.style._layers[layerId];
    if (layer && layer.implementation && layer.implementation.isThreeBoxLayer) {
      return layer.implementation.getLayoutProperty(name);
    }
    return super.getLayoutProperty(layerId, name);
  }
  setLayoutProperty(layerId, name, value, options) {
    const layer = this.style._layers[layerId];
    if (layer && layer.implementation && layer.implementation.isThreeBoxLayer) {
      return layer.implementation.setLayoutProperty(name, value, options);
    }
    return super.setLayoutProperty(layerId, name, value, options);
  }
  // 坐标转换
  proj(from, to, xy) {
    const pt2 = point(xy);
    if (from == "wgs84" && to == "mercator") {
      return toMercator(pt2).geometry.coordinates;
    } else if (from == "mercator" && to == "wgs84") {
      return toWgs84(pt2).geometry.coordinates;
    } else {
      console.log("This coordinate system conversion is currently not supported.");
      return null;
    }
  }
  // 测距
  measureDistance(callback) {
    this.clearDraw(false);
    if (!this._drawing) {
      this._initDraw();
    }
    this._drawCallback = callback;
    this._drawMode = "LineString";
  }
  // 测面积
  measureArea(callback) {
    this.clearDraw(false);
    if (!this._drawing) {
      this._initDraw();
    }
    this._drawCallback = callback;
    this._drawMode = "Polygon";
  }
  // 清除测距和测面积
  clearDraw(allClear) {
    if (this._drawing) {
      this.doubleClickZoom.enable();
      this.off("click", this._drawClick);
      this.off("mousemove", this._drawMouseMove);
      this.off("dblclick", this._drawDoubleClick);
      this._drawing = false;
      this.getCanvas().style.cursor = "grab";
      this._drawCallback = null;
      if (this.getSource("draw")) {
        this._drawFeatures = [];
        this.getSource("draw").setData({
          type: "FeatureCollection",
          features: this._drawFeatures
        });
      }
      this._helpTooltip.remove();
      this._measureTooltip.remove();
    }
    if (allClear) {
      if (this.getSource("old-draw")) {
        this._oldDrawFeatures = [];
        this.getSource("old-draw").setData({
          type: "FeatureCollection",
          features: this._oldDrawFeatures
        });
        for (let i2 = 0; i2 < this._resultTooltips.length; i2++) {
          this._resultTooltips[i2].remove();
        }
        this._resultTooltips = [];
      }
    }
  }
  // 初始化测量
  _initDraw() {
    if (!this.getSource("draw")) {
      this._drawFeatures = [];
      this._oldDrawFeatures = [];
      this.addSource("draw", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this._drawFeatures
        }
      });
      this.addLayer({
        id: "measure-points",
        type: "circle",
        source: "draw",
        paint: {
          "circle-radius": 5,
          "circle-color": "#000"
        },
        filter: ["==", ["geometry-type"], "Point"]
      });
      this.addLayer({
        id: "measure-lines",
        type: "line",
        source: "draw",
        layout: {
          "line-cap": "round",
          "line-join": "round"
        },
        paint: {
          "line-color": "#000",
          "line-width": 2.5
        },
        filter: ["!=", ["geometry-type"], "Point"]
      });
      this.addLayer({
        id: "measure-polygons",
        type: "fill",
        source: "draw",
        paint: {
          "fill-color": "#000",
          "fill-opacity": 0.2
        },
        filter: ["==", ["geometry-type"], "Polygon"]
      });
      this.addSource("old-draw", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this._oldDrawFeatures
        }
      });
      this.addLayer({
        id: "old-measure-points",
        type: "circle",
        source: "old-draw",
        paint: {
          "circle-radius": 5,
          "circle-color": "#ffcc33"
        },
        filter: ["==", ["geometry-type"], "Point"]
      });
      this.addLayer({
        id: "old-measure-lines",
        type: "line",
        source: "old-draw",
        layout: {
          "line-cap": "round",
          "line-join": "round"
        },
        paint: {
          "line-color": "#ffcc33",
          "line-width": 2.5
        },
        filter: ["!=", ["geometry-type"], "Point"]
      });
      this.addLayer({
        id: "old-measure-polygons",
        type: "fill",
        source: "old-draw",
        paint: {
          "fill-color": "#ffcc33",
          "fill-opacity": 0.2
        },
        filter: ["==", ["geometry-type"], "Polygon"]
      });
      this._helpTooltip = new mapboxgl.Popup({
        closeButton: false,
        anchor: "top-left",
        offset: 20,
        className: "drawTooltip"
      });
      this._measureTooltip = new mapboxgl.Popup({
        closeButton: false,
        anchor: "bottom",
        offset: 10,
        className: "drawTooltip"
      });
      this._resultTooltips = [];
      this._closeTooltips = [];
      this._resultIndex = 0;
      this._filterIndexes = [];
    }
    this.doubleClickZoom.disable();
    this.off("click", this._drawClick);
    this.off("mousemove", this._drawMouseMove);
    this.off("dblclick", this._drawDoubleClick);
    this.on("click", this._drawClick);
    this.on("mousemove", this._drawMouseMove);
    this._drawing = true;
    this.getCanvas().style.cursor = `url(${rulerCursor}) 2 6, crosshair`;
  }
  // 测量点击地图
  _drawClick(e2) {
    if (this._drawMode == "LineString" && this._drawFeatures.length == 0) {
      this.on("dblclick", this._drawDoubleClick);
    } else if (this._drawMode == "Polygon" && this._drawFeatures.length == 3) {
      this.on("dblclick", this._drawDoubleClick);
    }
    if (this._drawFeatures.length > 1) {
      this._drawFeatures.pop();
    }
    const point2 = {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [e2.lngLat.lng, e2.lngLat.lat]
      }
    };
    this._drawFeatures.push(point2);
    if (this._drawFeatures.length > 1) {
      let feature2;
      if (this._drawMode == "LineString" || this._drawFeatures.length < 3) {
        feature2 = {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates: []
          }
        };
        for (let i2 = 0; i2 < this._drawFeatures.length; i2++) {
          feature2.geometry.coordinates.push(this._drawFeatures[i2].geometry.coordinates);
        }
      } else if (this._drawMode == "Polygon") {
        feature2 = {
          type: "Feature",
          geometry: {
            type: "Polygon",
            coordinates: [[]]
          }
        };
        for (let i2 = 0; i2 < this._drawFeatures.length; i2++) {
          feature2.geometry.coordinates[0].push(this._drawFeatures[i2].geometry.coordinates);
        }
        feature2.geometry.coordinates[0].push(this._drawFeatures[0].geometry.coordinates);
      }
      this._drawFeatures.push(feature2);
      let value;
      if (this._drawMode == "LineString") {
        value = length(feature2).toLocaleString() + "km";
      } else {
        value = (feature2.geometry.type == "LineString" ? "0" : area$1(feature2).toLocaleString()) + "m²";
      }
      this._measureTooltip.setLngLat(e2.lngLat).setHTML(`<div class="tooltip">${value}</div>`).addTo(this);
    }
    this.getSource("draw").setData({
      type: "FeatureCollection",
      features: this._drawFeatures
    });
    this._helpTooltip.setLngLat(e2.lngLat).setHTML('<div class="tooltip">左键点击继续绘制</div>').addTo(this);
  }
  // 测量鼠标移动
  _drawMouseMove(e2) {
    if (this._drawFeatures.length == 0) {
      this._helpTooltip.setLngLat(e2.lngLat).setHTML('<div class="tooltip">左键点击开始绘制</div>').addTo(this);
    } else {
      this._helpTooltip.setLngLat(e2.lngLat).setHTML('<div class="tooltip">左键点击继续绘制</div>').addTo(this);
      if (this._drawFeatures.length > 1) {
        this._drawFeatures.pop();
        this._drawFeatures.pop();
      }
      const point2 = {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [e2.lngLat.lng, e2.lngLat.lat]
        }
      };
      this._drawFeatures.push(point2);
      if (this._drawFeatures.length > 1) {
        let feature2;
        if (this._drawMode == "LineString" || this._drawFeatures.length < 3) {
          feature2 = {
            type: "Feature",
            geometry: {
              type: "LineString",
              coordinates: []
            }
          };
          for (let i2 = 0; i2 < this._drawFeatures.length; i2++) {
            feature2.geometry.coordinates.push(this._drawFeatures[i2].geometry.coordinates);
          }
        } else {
          feature2 = {
            type: "Feature",
            geometry: {
              type: "Polygon",
              coordinates: [[]]
            }
          };
          for (let i2 = 0; i2 < this._drawFeatures.length; i2++) {
            feature2.geometry.coordinates[0].push(this._drawFeatures[i2].geometry.coordinates);
          }
          feature2.geometry.coordinates[0].push(this._drawFeatures[0].geometry.coordinates);
        }
        this._drawFeatures.push(feature2);
        let value;
        if (this._drawMode == "LineString") {
          value = length(feature2).toLocaleString() + "km";
        } else {
          value = (feature2.geometry.type == "LineString" ? "0" : area$1(feature2).toLocaleString()) + "m²";
        }
        this._measureTooltip.setLngLat(e2.lngLat).setHTML(`<div class="tooltip">${value}</div>`).addTo(this);
      }
      this.getSource("draw").setData({
        type: "FeatureCollection",
        features: this._drawFeatures
      });
    }
  }
  // 测量双击地图
  _drawDoubleClick() {
    const _this = this;
    requestAnimationFrame(function() {
      _this.doubleClickZoom.enable();
    });
    this.off("click", this._drawClick);
    this.off("mousemove", this._drawMouseMove);
    this.off("dblclick", this._drawDoubleClick);
    this._drawing = false;
    this.getCanvas().style.cursor = "grab";
    const feature2 = this._drawFeatures[this._drawFeatures.length - 1];
    let value;
    if (this._drawMode == "LineString") {
      value = length(feature2).toLocaleString() + "km";
    } else {
      value = area$1(feature2).toLocaleString() + "m²";
    }
    const lastPointCoord = this._drawFeatures[this._drawFeatures.length - 2].geometry.coordinates;
    const resultTooltip = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
      anchor: "bottom",
      offset: 10,
      className: "drawTooltip result result" + this._resultIndex,
      index: this._resultIndex
    });
    resultTooltip.setLngLat(lastPointCoord).setHTML(`<div class="tooltip">${value}<a href="javascript:void(0);">关闭</a></div>`).addTo(this);
    this._resultTooltips.push(resultTooltip);
    $(".drawTooltip.result" + this._resultIndex).bind(
      "click",
      this._clearDrawTooltip.bind(this, this._resultIndex)
    );
    for (let i2 = 0; i2 < this._drawFeatures.length; i2++) {
      this._drawFeatures[i2].properties = {
        INDEX: this._resultIndex
      };
      this._oldDrawFeatures.push(this._drawFeatures[i2]);
    }
    this.getSource("old-draw").setData({
      type: "FeatureCollection",
      features: this._oldDrawFeatures
    });
    this._drawFeatures = [];
    this.getSource("draw").setData({
      type: "FeatureCollection",
      features: this._drawFeatures
    });
    this._helpTooltip.remove();
    this._measureTooltip.remove();
    if (typeof this._drawCallback == "function") this._drawCallback(feature2.geometry, value);
    this._resultIndex++;
  }
  // 清除测量提示
  _clearDrawTooltip(index2) {
    for (let i2 = 0; i2 < this._resultTooltips.length; i2++) {
      if (this._resultTooltips[i2].options.index == index2) {
        this._resultTooltips[i2].remove();
        this._resultTooltips.splice(i2, 1);
        break;
      }
    }
    this._filterIndexes.push(index2);
    this.setFilter("old-measure-points", [
      "all",
      ["match", ["get", "INDEX"], this._filterIndexes, false, true],
      ["==", ["geometry-type"], "Point"]
    ]);
    this.setFilter("old-measure-lines", [
      "all",
      ["match", ["get", "INDEX"], this._filterIndexes, false, true],
      ["!=", ["geometry-type"], "Point"]
    ]);
    this.setFilter("old-measure-polygons", [
      "all",
      ["match", ["get", "INDEX"], this._filterIndexes, false, true],
      ["==", ["geometry-type"], "Polygon"]
    ]);
  }
};
class _Deferred {
  constructor() {
    this.promise = new Promise((resolve) => this.resolve = resolve);
  }
}
const __EventSource = class __EventSource {
  constructor(module) {
    __publicField(this, "_module");
    __publicField(this, "_eventSource", null);
    __publicField(this, "_connectionId", null);
    __publicField(this, "_reconnectAttempts", 0);
    __publicField(this, "_state", __EventSource.STATES.INITIAL);
    __publicField(this, "_callbacks", /* @__PURE__ */ new Map());
    __publicField(this, "_subscriptions", /* @__PURE__ */ new Set());
    __publicField(this, "_deferred", new _Deferred());
    if (!module) {
      throw new Error("模块名称 (module) 不能为空");
    }
    this._module = module;
    this._connect();
  }
  _connect() {
    if ([__EventSource.STATES.CONNECTING, __EventSource.STATES.CLOSED].includes(this._state)) return;
    this._state = __EventSource.STATES.CONNECTING;
    const url = `${__EventSource._BASE_URL}/event/connections`;
    this._eventSource = new EventSource(url);
    this._eventSource.onopen = () => {
      this._state = __EventSource.STATES.CONNECTED;
      this._reconnectAttempts = 0;
      console.debug(`[${this._module}] SSE 连接已建立。`);
      if (this._subscriptions.size > 0) {
        this._resubscribe();
      }
    };
    this._eventSource.onerror = (error) => {
      if (this._state === __EventSource.STATES.CLOSED) return;
      console.error(`[${this._module}] SSE 连接错误:`, error);
      this._eventSource.close();
      this._reconnectAttempts++;
      if (this._reconnectAttempts > __EventSource._MAX_RETRIES) {
        this.close();
        return;
      }
      this._state = __EventSource.STATES.RECONNECTING;
      this._reconnectAttempts++;
      const delay = Math.min(
        __EventSource._RECONNECT_DELAY_MAX,
        __EventSource._RECONNECT_DELAY_BASE * this._reconnectAttempts
      );
      console.debug(`[${this._module}] ${delay}ms 后尝试重新连接...`);
      setTimeout(() => this._connect(), delay);
    };
    this._eventSource.addEventListener("init", (event) => {
      this._connectionId = event.data;
      this._state = __EventSource.STATES.CONNECTED;
      console.debug(`[${this._module}] 会话ID: ${this._connectionId}`);
      this._deferred.resolve();
    });
  }
  async _apiCall({ url, method = "GET", params, data }) {
    const query = params ? "?" + new URLSearchParams(params).toString() : "";
    const response = await fetch(url + query, {
      method,
      headers: { "Content-Type": "application/json" },
      body: data ? JSON.stringify(data) : null
    });
    if (!response.ok) {
      throw new Error(`[${this._module}] 接口请求失败: ${response.status} ${response.statusText}`);
    }
    return response;
  }
  /**
   * 订阅一个或多个主题
   */
  async on(topics, callback) {
    await this._deferred.promise;
    if (!Array.isArray(topics)) topics = [topics];
    try {
      await this._apiCall({
        url: `${__EventSource._BASE_URL}/event/subscriptions`,
        method: "POST",
        data: {
          connectionId: this._connectionId,
          module: this._module,
          topics
        }
      });
      for (const topic of topics) {
        const wrapped = (event) => callback(event.data);
        const old = this._callbacks.get(topic);
        if (old) this._eventSource.removeEventListener(topic, old.wrapped);
        this._callbacks.set(topic, { original: callback, wrapped });
        this._subscriptions.add(topic);
        this._eventSource.addEventListener(topic, wrapped);
      }
      console.debug(`[${this._module}] 订阅主题:`, topics);
    } catch (error) {
      console.error(`[${this._module}] 订阅失败:`, error);
      throw error;
    }
  }
  /**
   * 取消订阅一个或多个主题
   */
  async off(topics) {
    await this._deferred.promise;
    topics = Array.isArray(topics) ? topics : [topics];
    try {
      await this._apiCall({
        url: `${__EventSource._BASE_URL}/event/subscriptions`,
        method: "DELETE",
        data: {
          connectionId: this._connectionId,
          module: this._module,
          topics
        }
      });
      for (const topic of topics) {
        const cb = this._callbacks.get(topic);
        if (cb) {
          this._eventSource.removeEventListener(topic, cb.wrapped);
          this._callbacks.delete(topic);
          this._subscriptions.delete(topic);
        }
      }
      console.debug(`[${this._module}] 取消订阅:`, topics);
    } catch (error) {
      console.error(`[${this._module}] 取消失败:`, error);
      throw error;
    }
  }
  /**
   * 在连接恢复后重新建立所有订阅
   */
  async _resubscribe() {
    try {
      await this._apiCall({
        url: `${__EventSource._BASE_URL}/event/subscriptions`,
        method: "POST",
        data: {
          connectionId: this._connectionId,
          module: this._module,
          topics: [...this._subscriptions]
        }
      });
      for (const topic of this._subscriptions) {
        const cb = this._callbacks.get(topic);
        if (cb) this._eventSource.addEventListener(topic, cb.wrapped);
      }
      console.debug(`[${this._module}] 订阅已恢复。`);
    } catch (error) {
      console.error(`[${this._module}] 恢复订阅失败:`, error);
    }
  }
  /**
   * 关闭连接并清理资源
   */
  async close() {
    if (this._state === __EventSource.STATES.CLOSED) return;
    this._state = __EventSource.STATES.CLOSED;
    if (this._eventSource) {
      for (const [topic, cb] of this._callbacks.entries()) {
        this._eventSource.removeEventListener(topic, cb.wrapped);
      }
      this._eventSource.close();
    }
    this._callbacks.clear();
    this._subscriptions.clear();
    if (this._connectionId) {
      await this._apiCall({
        url: `${__EventSource._BASE_URL}/event/connections/${this._connectionId}`,
        method: "DELETE"
      });
    }
    console.debug(`[${this._module}] 连接已关闭。`);
  }
};
__publicField(__EventSource, "_BASE_URL", "http://127.0.0.1:10103");
__publicField(__EventSource, "_RECONNECT_DELAY_BASE", 500);
__publicField(__EventSource, "_RECONNECT_DELAY_MAX", 5e3);
__publicField(__EventSource, "_MAX_RETRIES", 5);
__publicField(__EventSource, "STATES", {
  INITIAL: "INITIAL",
  CONNECTING: "CONNECTING",
  CONNECTED: "CONNECTED",
  RECONNECTING: "RECONNECTING",
  CLOSED: "CLOSED"
});
let _EventSource = __EventSource;
class EventHub {
  static getInstance(module) {
    let instance = this._instances.get(module);
    if (!instance) {
      instance = new _EventSource(module);
      this._instances.set(module, instance);
    }
    return instance;
  }
  static destroy(module) {
    const instance = this._instances.get(module);
    if (instance) {
      instance.close();
      this._instances.delete(module);
    }
  }
}
__publicField(EventHub, "_instances", /* @__PURE__ */ new Map());
mapboxgl.config.GLYPHS_URL = "http://192.168.1.183:8080/wgq/fonts/{fontstack}/{range}.pbf";
BufferGeometry$1.prototype.computeBoundsTree = computeBoundsTree;
BufferGeometry$1.prototype.disposeBoundsTree = disposeBoundsTree;
Mesh$1.prototype.raycast = acceleratedRaycast;
PathGeometry.prototype.computeBoundsTree = computeBoundsTree;
PathGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
const index = {
  ...mapboxgl,
  Map: Map$1,
  THREE: {
    ...THREE,
    GUI: g$2
  },
  EventHub
};
export {
  index as default
};
